/** vim: et:ts=4:sw=4:sts=4
 * @license RequireJS 2.0.6 Copyright (c) 2010-2012, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/requirejs for details
 */
//Not using strict: uneven strict support in browsers, #392, and causes
//problems with requirejs.exec()/transpiler plugins that may not be strict.
/*jslint regexp: true, nomen: true, sloppy: true */
/*global window, navigator, document, importScripts, jQuery, setTimeout, opera */

var requirejs, require, define;
(function (global) {
    var req, s, head, baseElement, dataMain, src,
        interactiveScript, currentlyAddingScript, mainScript, subPath,
        version = '2.0.6',
        commentRegExp = /(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/mg,
        cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g,
        jsSuffixRegExp = /\.js$/,
        currDirRegExp = /^\.\//,
        op = Object.prototype,
        ostring = op.toString,
        hasOwn = op.hasOwnProperty,
        ap = Array.prototype,
        aps = ap.slice,
        apsp = ap.splice,
        isBrowser = !!(typeof window !== 'undefined' && navigator && document),
        isWebWorker = !isBrowser && typeof importScripts !== 'undefined',
        //PS3 indicates loaded and complete, but need to wait for complete
        //specifically. Sequence is 'loading', 'loaded', execution,
        // then 'complete'. The UA check is unfortunate, but not sure how
        //to feature test w/o causing perf issues.
        readyRegExp = isBrowser && navigator.platform === 'PLAYSTATION 3' ?
                      /^complete$/ : /^(complete|loaded)$/,
        defContextName = '_',
        //Oh the tragedy, detecting opera. See the usage of isOpera for reason.
        isOpera = typeof opera !== 'undefined' && opera.toString() === '[object Opera]',
        contexts = {},
        cfg = {},
        globalDefQueue = [],
        useInteractive = false;

    function isFunction(it) {
        return ostring.call(it) === '[object Function]';
    }

    function isArray(it) {
        return ostring.call(it) === '[object Array]';
    }

    /**
     * Helper function for iterating over an array. If the func returns
     * a true value, it will break out of the loop.
     */
    function each(ary, func) {
        if (ary) {
            var i;
            for (i = 0; i < ary.length; i += 1) {
                if (ary[i] && func(ary[i], i, ary)) {
                    break;
                }
            }
        }
    }

    /**
     * Helper function for iterating over an array backwards. If the func
     * returns a true value, it will break out of the loop.
     */
    function eachReverse(ary, func) {
        if (ary) {
            var i;
            for (i = ary.length - 1; i > -1; i -= 1) {
                if (ary[i] && func(ary[i], i, ary)) {
                    break;
                }
            }
        }
    }

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Cycles over properties in an object and calls a function for each
     * property value. If the function returns a truthy value, then the
     * iteration is stopped.
     */
    function eachProp(obj, func) {
        var prop;
        for (prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                if (func(obj[prop], prop)) {
                    break;
                }
            }
        }
    }

    /**
     * Simple function to mix in properties from source into target,
     * but only if target does not already have a property of the same name.
     * This is not robust in IE for transferring methods that match
     * Object.prototype names, but the uses of mixin here seem unlikely to
     * trigger a problem related to that.
     */
    function mixin(target, source, force, deepStringMixin) {
        if (source) {
            eachProp(source, function (value, prop) {
                if (force || !hasProp(target, prop)) {
                    if (deepStringMixin && typeof value !== 'string') {
                        if (!target[prop]) {
                            target[prop] = {};
                        }
                        mixin(target[prop], value, force, deepStringMixin);
                    } else {
                        target[prop] = value;
                    }
                }
            });
        }
        return target;
    }

    //Similar to Function.prototype.bind, but the 'this' object is specified
    //first, since it is easier to read/figure out what 'this' will be.
    function bind(obj, fn) {
        return function () {
            return fn.apply(obj, arguments);
        };
    }

    function scripts() {
        return document.getElementsByTagName('script');
    }

    //Allow getting a global that expressed in
    //dot notation, like 'a.b.c'.
    function getGlobal(value) {
        if (!value) {
            return value;
        }
        var g = global;
        each(value.split('.'), function (part) {
            g = g[part];
        });
        return g;
    }

    function makeContextModuleFunc(func, relMap, enableBuildCallback) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            var args = aps.call(arguments, 0), lastArg;
            if (enableBuildCallback &&
                    isFunction((lastArg = args[args.length - 1]))) {
                lastArg.__requireJsBuild = true;
            }
            args.push(relMap);
            return func.apply(null, args);
        };
    }

    function addRequireMethods(req, context, relMap) {
        each([
            ['toUrl'],
            ['undef'],
            ['defined', 'requireDefined'],
            ['specified', 'requireSpecified']
        ], function (item) {
            var prop = item[1] || item[0];
            req[item[0]] = context ? makeContextModuleFunc(context[prop], relMap) :
                    //If no context, then use default context. Reference from
                    //contexts instead of early binding to default context, so
                    //that during builds, the latest instance of the default
                    //context with its config gets used.
                    function () {
                        var ctx = contexts[defContextName];
                        return ctx[prop].apply(ctx, arguments);
                    };
        });
    }

    /**
     * Constructs an error with a pointer to an URL with more information.
     * @param {String} id the error ID that maps to an ID on a web page.
     * @param {String} message human readable error.
     * @param {Error} [err] the original error, if there is one.
     *
     * @returns {Error}
     */
    function makeError(id, msg, err, requireModules) {
        var e = new Error(msg + '\nhttp://requirejs.org/docs/errors.html#' + id);
        e.requireType = id;
        e.requireModules = requireModules;
        if (err) {
            e.originalError = err;
        }
        return e;
    }

    if (typeof define !== 'undefined') {
        //If a define is already in play via another AMD loader,
        //do not overwrite.
        return;
    }

    if (typeof requirejs !== 'undefined') {
        if (isFunction(requirejs)) {
            //Do not overwrite and existing requirejs instance.
            return;
        }
        cfg = requirejs;
        requirejs = undefined;
    }

    //Allow for a require config object
    if (typeof require !== 'undefined' && !isFunction(require)) {
        //assume it is a config object.
        cfg = require;
        require = undefined;
    }

    function newContext(contextName) {
        var inCheckLoaded, Module, context, handlers,
            checkLoadedTimeoutId,
            config = {
                waitSeconds: 7,
                baseUrl: './',
                paths: {},
                pkgs: {},
                shim: {}
            },
            registry = {},
            undefEvents = {},
            defQueue = [],
            defined = {},
            urlFetched = {},
            requireCounter = 1,
            unnormalizedCounter = 1,
            //Used to track the order in which modules
            //should be executed, by the order they
            //load. Important for consistent cycle resolution
            //behavior.
            waitAry = [];

        /**
         * Trims the . and .. from an array of path segments.
         * It will keep a leading path segment if a .. will become
         * the first path segment, to help with module name lookups,
         * which act like paths, but can be remapped. But the end result,
         * all paths that use this function should look normalized.
         * NOTE: this method MODIFIES the input array.
         * @param {Array} ary the array of path segments.
         */
        function trimDots(ary) {
            var i, part;
            for (i = 0; ary[i]; i += 1) {
                part = ary[i];
                if (part === '.') {
                    ary.splice(i, 1);
                    i -= 1;
                } else if (part === '..') {
                    if (i === 1 && (ary[2] === '..' || ary[0] === '..')) {
                        //End of the line. Keep at least one non-dot
                        //path segment at the front so it can be mapped
                        //correctly to disk. Otherwise, there is likely
                        //no path mapping for a path starting with '..'.
                        //This can still fail, but catches the most reasonable
                        //uses of ..
                        break;
                    } else if (i > 0) {
                        ary.splice(i - 1, 2);
                        i -= 2;
                    }
                }
            }
        }

        /**
         * Given a relative module name, like ./something, normalize it to
         * a real name that can be mapped to a path.
         * @param {String} name the relative name
         * @param {String} baseName a real name that the name arg is relative
         * to.
         * @param {Boolean} applyMap apply the map config to the value. Should
         * only be done if this normalization is for a dependency ID.
         * @returns {String} normalized name
         */
        function normalize(name, baseName, applyMap) {
            var pkgName, pkgConfig, mapValue, nameParts, i, j, nameSegment,
                foundMap, foundI, foundStarMap, starI,
                baseParts = baseName && baseName.split('/'),
                normalizedBaseParts = baseParts,
                map = config.map,
                starMap = map && map['*'];

            //Adjust any relative paths.
            if (name && name.charAt(0) === '.') {
                //If have a base name, try to normalize against it,
                //otherwise, assume it is a top-level require that will
                //be relative to baseUrl in the end.
                if (baseName) {
                    if (config.pkgs[baseName]) {
                        //If the baseName is a package name, then just treat it as one
                        //name to concat the name with.
                        normalizedBaseParts = baseParts = [baseName];
                    } else {
                        //Convert baseName to array, and lop off the last part,
                        //so that . matches that 'directory' and not name of the baseName's
                        //module. For instance, baseName of 'one/two/three', maps to
                        //'one/two/three.js', but we want the directory, 'one/two' for
                        //this normalization.
                        normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
                    }

                    name = normalizedBaseParts.concat(name.split('/'));
                    trimDots(name);

                    //Some use of packages may use a . path to reference the
                    //'main' module name, so normalize for that.
                    pkgConfig = config.pkgs[(pkgName = name[0])];
                    name = name.join('/');
                    if (pkgConfig && name === pkgName + '/' + pkgConfig.main) {
                        name = pkgName;
                    }
                } else if (name.indexOf('./') === 0) {
                    // No baseName, so this is ID is resolved relative
                    // to baseUrl, pull off the leading dot.
                    name = name.substring(2);
                }
            }

            //Apply map config if available.
            if (applyMap && (baseParts || starMap) && map) {
                nameParts = name.split('/');

                for (i = nameParts.length; i > 0; i -= 1) {
                    nameSegment = nameParts.slice(0, i).join('/');

                    if (baseParts) {
                        //Find the longest baseName segment match in the config.
                        //So, do joins on the biggest to smallest lengths of baseParts.
                        for (j = baseParts.length; j > 0; j -= 1) {
                            mapValue = map[baseParts.slice(0, j).join('/')];

                            //baseName segment has config, find if it has one for
                            //this name.
                            if (mapValue) {
                                mapValue = mapValue[nameSegment];
                                if (mapValue) {
                                    //Match, update name to the new value.
                                    foundMap = mapValue;
                                    foundI = i;
                                    break;
                                }
                            }
                        }
                    }

                    if (foundMap) {
                        break;
                    }

                    //Check for a star map match, but just hold on to it,
                    //if there is a shorter segment match later in a matching
                    //config, then favor over this star map.
                    if (!foundStarMap && starMap && starMap[nameSegment]) {
                        foundStarMap = starMap[nameSegment];
                        starI = i;
                    }
                }

                if (!foundMap && foundStarMap) {
                    foundMap = foundStarMap;
                    foundI = starI;
                }

                if (foundMap) {
                    nameParts.splice(0, foundI, foundMap);
                    name = nameParts.join('/');
                }
            }

            return name;
        }

        function removeScript(name) {
            if (isBrowser) {
                each(scripts(), function (scriptNode) {
                    if (scriptNode.getAttribute('data-requiremodule') === name &&
                            scriptNode.getAttribute('data-requirecontext') === context.contextName) {
                        scriptNode.parentNode.removeChild(scriptNode);
                        return true;
                    }
                });
            }
        }

        function hasPathFallback(id) {
            var pathConfig = config.paths[id];
            if (pathConfig && isArray(pathConfig) && pathConfig.length > 1) {
                removeScript(id);
                //Pop off the first array value, since it failed, and
                //retry
                pathConfig.shift();
                context.undef(id);
                context.require([id]);
                return true;
            }
        }

        /**
         * Creates a module mapping that includes plugin prefix, module
         * name, and path. If parentModuleMap is provided it will
         * also normalize the name via require.normalize()
         *
         * @param {String} name the module name
         * @param {String} [parentModuleMap] parent module map
         * for the module name, used to resolve relative names.
         * @param {Boolean} isNormalized: is the ID already normalized.
         * This is true if this call is done for a define() module ID.
         * @param {Boolean} applyMap: apply the map config to the ID.
         * Should only be true if this map is for a dependency.
         *
         * @returns {Object}
         */
        function makeModuleMap(name, parentModuleMap, isNormalized, applyMap) {
            var url, pluginModule, suffix,
                index = name ? name.indexOf('!') : -1,
                prefix = null,
                parentName = parentModuleMap ? parentModuleMap.name : null,
                originalName = name,
                isDefine = true,
                normalizedName = '';

            //If no name, then it means it is a require call, generate an
            //internal name.
            if (!name) {
                isDefine = false;
                name = '_@r' + (requireCounter += 1);
            }

            if (index !== -1) {
                prefix = name.substring(0, index);
                name = name.substring(index + 1, name.length);
            }

            if (prefix) {
                prefix = normalize(prefix, parentName, applyMap);
                pluginModule = defined[prefix];
            }

            //Account for relative paths if there is a base name.
            if (name) {
                if (prefix) {
                    if (pluginModule && pluginModule.normalize) {
                        //Plugin is loaded, use its normalize method.
                        normalizedName = pluginModule.normalize(name, function (name) {
                            return normalize(name, parentName, applyMap);
                        });
                    } else {
                        normalizedName = normalize(name, parentName, applyMap);
                    }
                } else {
                    //A regular module.
                    normalizedName = normalize(name, parentName, applyMap);
                    url = context.nameToUrl(normalizedName);
                }
            }

            //If the id is a plugin id that cannot be determined if it needs
            //normalization, stamp it with a unique ID so two matching relative
            //ids that may conflict can be separate.
            suffix = prefix && !pluginModule && !isNormalized ?
                     '_unnormalized' + (unnormalizedCounter += 1) :
                     '';

            return {
                prefix: prefix,
                name: normalizedName,
                parentMap: parentModuleMap,
                unnormalized: !!suffix,
                url: url,
                originalName: originalName,
                isDefine: isDefine,
                id: (prefix ?
                        prefix + '!' + normalizedName :
                        normalizedName) + suffix
            };
        }

        function getModule(depMap) {
            var id = depMap.id,
                mod = registry[id];

            if (!mod) {
                mod = registry[id] = new context.Module(depMap);
            }

            return mod;
        }

        function on(depMap, name, fn) {
            var id = depMap.id,
                mod = registry[id];

            if (hasProp(defined, id) &&
                    (!mod || mod.defineEmitComplete)) {
                if (name === 'defined') {
                    fn(defined[id]);
                }
            } else {
                getModule(depMap).on(name, fn);
            }
        }

        function onError(err, errback) {
            var ids = err.requireModules,
                notified = false;

            if (errback) {
                errback(err);
            } else {
                each(ids, function (id) {
                    var mod = registry[id];
                    if (mod) {
                        //Set error on module, so it skips timeout checks.
                        mod.error = err;
                        if (mod.events.error) {
                            notified = true;
                            mod.emit('error', err);
                        }
                    }
                });

                if (!notified) {
                    req.onError(err);
                }
            }
        }

        /**
         * Internal method to transfer globalQueue items to this context's
         * defQueue.
         */
        function takeGlobalQueue() {
            //Push all the globalDefQueue items into the context's defQueue
            if (globalDefQueue.length) {
                //Array splice in the values since the context code has a
                //local var ref to defQueue, so cannot just reassign the one
                //on context.
                apsp.apply(defQueue,
                           [defQueue.length - 1, 0].concat(globalDefQueue));
                globalDefQueue = [];
            }
        }

        /**
         * Helper function that creates a require function object to give to
         * modules that ask for it as a dependency. It needs to be specific
         * per module because of the implication of path mappings that may
         * need to be relative to the module name.
         */
        function makeRequire(mod, enableBuildCallback, altRequire) {
            var relMap = mod && mod.map,
                modRequire = makeContextModuleFunc(altRequire || context.require,
                                                   relMap,
                                                   enableBuildCallback);

            addRequireMethods(modRequire, context, relMap);
            modRequire.isBrowser = isBrowser;

            return modRequire;
        }

        handlers = {
            'require': function (mod) {
                return makeRequire(mod);
            },
            'exports': function (mod) {
                mod.usingExports = true;
                if (mod.map.isDefine) {
                    return (mod.exports = defined[mod.map.id] = {});
                }
            },
            'module': function (mod) {
                return (mod.module = {
                    id: mod.map.id,
                    uri: mod.map.url,
                    config: function () {
                        return (config.config && config.config[mod.map.id]) || {};
                    },
                    exports: defined[mod.map.id]
                });
            }
        };

        function removeWaiting(id) {
            //Clean up machinery used for waiting modules.
            delete registry[id];

            each(waitAry, function (mod, i) {
                if (mod.map.id === id) {
                    waitAry.splice(i, 1);
                    if (!mod.defined) {
                        context.waitCount -= 1;
                    }
                    return true;
                }
            });
        }

        function findCycle(mod, traced, processed) {
            var id = mod.map.id,
                depArray = mod.depMaps,
                foundModule;

            //Do not bother with unitialized modules or not yet enabled
            //modules.
            if (!mod.inited) {
                return;
            }

            //Found the cycle.
            if (traced[id]) {
                return mod;
            }

            traced[id] = true;

            //Trace through the dependencies.
            each(depArray, function (depMap) {
                var depId = depMap.id,
                    depMod = registry[depId];

                if (!depMod || processed[depId] ||
                        !depMod.inited || !depMod.enabled) {
                    return;
                }

                return (foundModule = findCycle(depMod, traced, processed));
            });

            processed[id] = true;

            return foundModule;
        }

        function forceExec(mod, traced, uninited) {
            var id = mod.map.id,
                depArray = mod.depMaps;

            if (!mod.inited || !mod.map.isDefine) {
                return;
            }

            if (traced[id]) {
                return defined[id];
            }

            traced[id] = mod;

            each(depArray, function (depMap) {
                var depId = depMap.id,
                    depMod = registry[depId],
                    value;

                if (handlers[depId]) {
                    return;
                }

                if (depMod) {
                    if (!depMod.inited || !depMod.enabled) {
                        //Dependency is not inited,
                        //so this module cannot be
                        //given a forced value yet.
                        uninited[id] = true;
                        return;
                    }

                    //Get the value for the current dependency
                    value = forceExec(depMod, traced, uninited);

                    //Even with forcing it may not be done,
                    //in particular if the module is waiting
                    //on a plugin resource.
                    if (!uninited[depId]) {
                        mod.defineDepById(depId, value);
                    }
                }
            });

            mod.check(true);

            return defined[id];
        }

        function modCheck(mod) {
            mod.check();
        }

        function checkLoaded() {
            var map, modId, err, usingPathFallback,
                waitInterval = config.waitSeconds * 1000,
                //It is possible to disable the wait interval by using waitSeconds of 0.
                expired = waitInterval && (context.startTime + waitInterval) < new Date().getTime(),
                noLoads = [],
                stillLoading = false,
                needCycleCheck = true;

            //Do not bother if this call was a result of a cycle break.
            if (inCheckLoaded) {
                return;
            }

            inCheckLoaded = true;

            //Figure out the state of all the modules.
            eachProp(registry, function (mod) {
                map = mod.map;
                modId = map.id;

                //Skip things that are not enabled or in error state.
                if (!mod.enabled) {
                    return;
                }

                if (!mod.error) {
                    //If the module should be executed, and it has not
                    //been inited and time is up, remember it.
                    if (!mod.inited && expired) {
                        if (hasPathFallback(modId)) {
                            usingPathFallback = true;
                            stillLoading = true;
                        } else {
                            noLoads.push(modId);
                            removeScript(modId);
                        }
                    } else if (!mod.inited && mod.fetched && map.isDefine) {
                        stillLoading = true;
                        if (!map.prefix) {
                            //No reason to keep looking for unfinished
                            //loading. If the only stillLoading is a
                            //plugin resource though, keep going,
                            //because it may be that a plugin resource
                            //is waiting on a non-plugin cycle.
                            return (needCycleCheck = false);
                        }
                    }
                }
            });

            if (expired && noLoads.length) {
                //If wait time expired, throw error of unloaded modules.
                err = makeError('timeout', 'Load timeout for modules: ' + noLoads, null, noLoads);
                err.contextName = context.contextName;
                return onError(err);
            }

            //Not expired, check for a cycle.
            if (needCycleCheck) {

                each(waitAry, function (mod) {
                    if (mod.defined) {
                        return;
                    }

                    var cycleMod = findCycle(mod, {}, {}),
                        traced = {};

                    if (cycleMod) {
                        forceExec(cycleMod, traced, {});

                        //traced modules may have been
                        //removed from the registry, but
                        //their listeners still need to
                        //be called.
                        eachProp(traced, modCheck);
                    }
                });

                //Now that dependencies have
                //been satisfied, trigger the
                //completion check that then
                //notifies listeners.
                eachProp(registry, modCheck);
            }

            //If still waiting on loads, and the waiting load is something
            //other than a plugin resource, or there are still outstanding
            //scripts, then just try back later.
            if ((!expired || usingPathFallback) && stillLoading) {
                //Something is still waiting to load. Wait for it, but only
                //if a timeout is not already in effect.
                if ((isBrowser || isWebWorker) && !checkLoadedTimeoutId) {
                    checkLoadedTimeoutId = setTimeout(function () {
                        checkLoadedTimeoutId = 0;
                        checkLoaded();
                    }, 50);
                }
            }

            inCheckLoaded = false;
        }

        Module = function (map) {
            this.events = undefEvents[map.id] || {};
            this.map = map;
            this.shim = config.shim[map.id];
            this.depExports = [];
            this.depMaps = [];
            this.depMatched = [];
            this.pluginMaps = {};
            this.depCount = 0;

            /* this.exports this.factory
               this.depMaps = [],
               this.enabled, this.fetched
            */
        };

        Module.prototype = {
            init: function (depMaps, factory, errback, options) {
                options = options || {};

                //Do not do more inits if already done. Can happen if there
                //are multiple define calls for the same module. That is not
                //a normal, common case, but it is also not unexpected.
                if (this.inited) {
                    return;
                }

                this.factory = factory;

                if (errback) {
                    //Register for errors on this module.
                    this.on('error', errback);
                } else if (this.events.error) {
                    //If no errback already, but there are error listeners
                    //on this module, set up an errback to pass to the deps.
                    errback = bind(this, function (err) {
                        this.emit('error', err);
                    });
                }

                //Do a copy of the dependency array, so that
                //source inputs are not modified. For example
                //"shim" deps are passed in here directly, and
                //doing a direct modification of the depMaps array
                //would affect that config.
                this.depMaps = depMaps && depMaps.slice(0);
                this.depMaps.rjsSkipMap = depMaps.rjsSkipMap;

                this.errback = errback;

                //Indicate this module has be initialized
                this.inited = true;

                this.ignore = options.ignore;

                //Could have option to init this module in enabled mode,
                //or could have been previously marked as enabled. However,
                //the dependencies are not known until init is called. So
                //if enabled previously, now trigger dependencies as enabled.
                if (options.enabled || this.enabled) {
                    //Enable this module and dependencies.
                    //Will call this.check()
                    this.enable();
                } else {
                    this.check();
                }
            },

            defineDepById: function (id, depExports) {
                var i;

                //Find the index for this dependency.
                each(this.depMaps, function (map, index) {
                    if (map.id === id) {
                        i = index;
                        return true;
                    }
                });

                return this.defineDep(i, depExports);
            },

            defineDep: function (i, depExports) {
                //Because of cycles, defined callback for a given
                //export can be called more than once.
                if (!this.depMatched[i]) {
                    this.depMatched[i] = true;
                    this.depCount -= 1;
                    this.depExports[i] = depExports;
                }
            },

            fetch: function () {
                if (this.fetched) {
                    return;
                }
                this.fetched = true;

                context.startTime = (new Date()).getTime();

                var map = this.map;

                //If the manager is for a plugin managed resource,
                //ask the plugin to load it now.
                if (this.shim) {
                    makeRequire(this, true)(this.shim.deps || [], bind(this, function () {
                        return map.prefix ? this.callPlugin() : this.load();
                    }));
                } else {
                    //Regular dependency.
                    return map.prefix ? this.callPlugin() : this.load();
                }
            },

            load: function () {
                var url = this.map.url;

                //Regular dependency.
                if (!urlFetched[url]) {
                    urlFetched[url] = true;
                    context.load(this.map.id, url);
                }
            },

            /**
             * Checks is the module is ready to define itself, and if so,
             * define it. If the silent argument is true, then it will just
             * define, but not notify listeners, and not ask for a context-wide
             * check of all loaded modules. That is useful for cycle breaking.
             */
            check: function (silent) {
                if (!this.enabled || this.enabling) {
                    return;
                }

                var err, cjsModule,
                    id = this.map.id,
                    depExports = this.depExports,
                    exports = this.exports,
                    factory = this.factory;

                if (!this.inited) {
                    this.fetch();
                } else if (this.error) {
                    this.emit('error', this.error);
                } else if (!this.defining) {
                    //The factory could trigger another require call
                    //that would result in checking this module to
                    //define itself again. If already in the process
                    //of doing that, skip this work.
                    this.defining = true;

                    if (this.depCount < 1 && !this.defined) {
                        if (isFunction(factory)) {
                            //If there is an error listener, favor passing
                            //to that instead of throwing an error.
                            if (this.events.error) {
                                try {
                                    exports = context.execCb(id, factory, depExports, exports);
                                } catch (e) {
                                    err = e;
                                }
                            } else {
                                exports = context.execCb(id, factory, depExports, exports);
                            }

                            if (this.map.isDefine) {
                                //If setting exports via 'module' is in play,
                                //favor that over return value and exports. After that,
                                //favor a non-undefined return value over exports use.
                                cjsModule = this.module;
                                if (cjsModule &&
                                        cjsModule.exports !== undefined &&
                                        //Make sure it is not already the exports value
                                        cjsModule.exports !== this.exports) {
                                    exports = cjsModule.exports;
                                } else if (exports === undefined && this.usingExports) {
                                    //exports already set the defined value.
                                    exports = this.exports;
                                }
                            }

                            if (err) {
                                err.requireMap = this.map;
                                err.requireModules = [this.map.id];
                                err.requireType = 'define';
                                return onError((this.error = err));
                            }

                        } else {
                            //Just a literal value
                            exports = factory;
                        }

                        this.exports = exports;

                        if (this.map.isDefine && !this.ignore) {
                            defined[id] = exports;

                            if (req.onResourceLoad) {
                                req.onResourceLoad(context, this.map, this.depMaps);
                            }
                        }

                        //Clean up
                        delete registry[id];

                        this.defined = true;
                        context.waitCount -= 1;
                        if (context.waitCount === 0) {
                            //Clear the wait array used for cycles.
                            waitAry = [];
                        }
                    }

                    //Finished the define stage. Allow calling check again
                    //to allow define notifications below in the case of a
                    //cycle.
                    this.defining = false;

                    if (!silent) {
                        if (this.defined && !this.defineEmitted) {
                            this.defineEmitted = true;
                            this.emit('defined', this.exports);
                            this.defineEmitComplete = true;
                        }
                    }
                }
            },

            callPlugin: function () {
                var map = this.map,
                    id = map.id,
                    pluginMap = makeModuleMap(map.prefix, null, false, true);

                on(pluginMap, 'defined', bind(this, function (plugin) {
                    var load, normalizedMap, normalizedMod,
                        name = this.map.name,
                        parentName = this.map.parentMap ? this.map.parentMap.name : null;

                    //If current map is not normalized, wait for that
                    //normalized name to load instead of continuing.
                    if (this.map.unnormalized) {
                        //Normalize the ID if the plugin allows it.
                        if (plugin.normalize) {
                            name = plugin.normalize(name, function (name) {
                                return normalize(name, parentName, true);
                            }) || '';
                        }

                        normalizedMap = makeModuleMap(map.prefix + '!' + name,
                                                      this.map.parentMap,
                                                      false,
                                                      true);
                        on(normalizedMap,
                            'defined', bind(this, function (value) {
                                this.init([], function () { return value; }, null, {
                                    enabled: true,
                                    ignore: true
                                });
                            }));
                        normalizedMod = registry[normalizedMap.id];
                        if (normalizedMod) {
                            if (this.events.error) {
                                normalizedMod.on('error', bind(this, function (err) {
                                    this.emit('error', err);
                                }));
                            }
                            normalizedMod.enable();
                        }

                        return;
                    }

                    load = bind(this, function (value) {
                        this.init([], function () { return value; }, null, {
                            enabled: true
                        });
                    });

                    load.error = bind(this, function (err) {
                        this.inited = true;
                        this.error = err;
                        err.requireModules = [id];

                        //Remove temp unnormalized modules for this module,
                        //since they will never be resolved otherwise now.
                        eachProp(registry, function (mod) {
                            if (mod.map.id.indexOf(id + '_unnormalized') === 0) {
                                removeWaiting(mod.map.id);
                            }
                        });

                        onError(err);
                    });

                    //Allow plugins to load other code without having to know the
                    //context or how to 'complete' the load.
                    load.fromText = function (moduleName, text) {
                        /*jslint evil: true */
                        var hasInteractive = useInteractive;

                        //Turn off interactive script matching for IE for any define
                        //calls in the text, then turn it back on at the end.
                        if (hasInteractive) {
                            useInteractive = false;
                        }

                        //Prime the system by creating a module instance for
                        //it.
                        getModule(makeModuleMap(moduleName));

                        req.exec(text);

                        if (hasInteractive) {
                            useInteractive = true;
                        }

                        //Support anonymous modules.
                        context.completeLoad(moduleName);
                    };

                    //Use parentName here since the plugin's name is not reliable,
                    //could be some weird string with no path that actually wants to
                    //reference the parentName's path.
                    plugin.load(map.name, makeRequire(map.parentMap, true, function (deps, cb, er) {
                        deps.rjsSkipMap = true;
                        return context.require(deps, cb, er);
                    }), load, config);
                }));

                context.enable(pluginMap, this);
                this.pluginMaps[pluginMap.id] = pluginMap;
            },

            enable: function () {
                this.enabled = true;

                if (!this.waitPushed) {
                    waitAry.push(this);
                    context.waitCount += 1;
                    this.waitPushed = true;
                }

                //Set flag mentioning that the module is enabling,
                //so that immediate calls to the defined callbacks
                //for dependencies do not trigger inadvertent load
                //with the depCount still being zero.
                this.enabling = true;

                //Enable each dependency
                each(this.depMaps, bind(this, function (depMap, i) {
                    var id, mod, handler;

                    if (typeof depMap === 'string') {
                        //Dependency needs to be converted to a depMap
                        //and wired up to this module.
                        depMap = makeModuleMap(depMap,
                                               (this.map.isDefine ? this.map : this.map.parentMap),
                                               false,
                                               !this.depMaps.rjsSkipMap);
                        this.depMaps[i] = depMap;

                        handler = handlers[depMap.id];

                        if (handler) {
                            this.depExports[i] = handler(this);
                            return;
                        }

                        this.depCount += 1;

                        on(depMap, 'defined', bind(this, function (depExports) {
                            this.defineDep(i, depExports);
                            this.check();
                        }));

                        if (this.errback) {
                            on(depMap, 'error', this.errback);
                        }
                    }

                    id = depMap.id;
                    mod = registry[id];

                    //Skip special modules like 'require', 'exports', 'module'
                    //Also, don't call enable if it is already enabled,
                    //important in circular dependency cases.
                    if (!handlers[id] && mod && !mod.enabled) {
                        context.enable(depMap, this);
                    }
                }));

                //Enable each plugin that is used in
                //a dependency
                eachProp(this.pluginMaps, bind(this, function (pluginMap) {
                    var mod = registry[pluginMap.id];
                    if (mod && !mod.enabled) {
                        context.enable(pluginMap, this);
                    }
                }));

                this.enabling = false;

                this.check();
            },

            on: function (name, cb) {
                var cbs = this.events[name];
                if (!cbs) {
                    cbs = this.events[name] = [];
                }
                cbs.push(cb);
            },

            emit: function (name, evt) {
                each(this.events[name], function (cb) {
                    cb(evt);
                });
                if (name === 'error') {
                    //Now that the error handler was triggered, remove
                    //the listeners, since this broken Module instance
                    //can stay around for a while in the registry/waitAry.
                    delete this.events[name];
                }
            }
        };

        function callGetModule(args) {
            getModule(makeModuleMap(args[0], null, true)).init(args[1], args[2]);
        }

        function removeListener(node, func, name, ieName) {
            //Favor detachEvent because of IE9
            //issue, see attachEvent/addEventListener comment elsewhere
            //in this file.
            if (node.detachEvent && !isOpera) {
                //Probably IE. If not it will throw an error, which will be
                //useful to know.
                if (ieName) {
                    node.detachEvent(ieName, func);
                }
            } else {
                node.removeEventListener(name, func, false);
            }
        }

        /**
         * Given an event from a script node, get the requirejs info from it,
         * and then removes the event listeners on the node.
         * @param {Event} evt
         * @returns {Object}
         */
        function getScriptData(evt) {
            //Using currentTarget instead of target for Firefox 2.0's sake. Not
            //all old browsers will be supported, but this one was easy enough
            //to support and still makes sense.
            var node = evt.currentTarget || evt.srcElement;

            //Remove the listeners once here.
            removeListener(node, context.onScriptLoad, 'load', 'onreadystatechange');
            removeListener(node, context.onScriptError, 'error');

            return {
                node: node,
                id: node && node.getAttribute('data-requiremodule')
            };
        }

        return (context = {
            config: config,
            contextName: contextName,
            registry: registry,
            defined: defined,
            urlFetched: urlFetched,
            waitCount: 0,
            defQueue: defQueue,
            Module: Module,
            makeModuleMap: makeModuleMap,

            /**
             * Set a configuration for the context.
             * @param {Object} cfg config object to integrate.
             */
            configure: function (cfg) {
                //Make sure the baseUrl ends in a slash.
                if (cfg.baseUrl) {
                    if (cfg.baseUrl.charAt(cfg.baseUrl.length - 1) !== '/') {
                        cfg.baseUrl += '/';
                    }
                }

                //Save off the paths and packages since they require special processing,
                //they are additive.
                var pkgs = config.pkgs,
                    shim = config.shim,
                    paths = config.paths,
                    map = config.map;

                //Mix in the config values, favoring the new values over
                //existing ones in context.config.
                mixin(config, cfg, true);

                //Merge paths.
                config.paths = mixin(paths, cfg.paths, true);

                //Merge map
                if (cfg.map) {
                    config.map = mixin(map || {}, cfg.map, true, true);
                }

                //Merge shim
                if (cfg.shim) {
                    eachProp(cfg.shim, function (value, id) {
                        //Normalize the structure
                        if (isArray(value)) {
                            value = {
                                deps: value
                            };
                        }
                        if (value.exports && !value.exports.__buildReady) {
                            value.exports = context.makeShimExports(value.exports);
                        }
                        shim[id] = value;
                    });
                    config.shim = shim;
                }

                //Adjust packages if necessary.
                if (cfg.packages) {
                    each(cfg.packages, function (pkgObj) {
                        var location;

                        pkgObj = typeof pkgObj === 'string' ? { name: pkgObj } : pkgObj;
                        location = pkgObj.location;

                        //Create a brand new object on pkgs, since currentPackages can
                        //be passed in again, and config.pkgs is the internal transformed
                        //state for all package configs.
                        pkgs[pkgObj.name] = {
                            name: pkgObj.name,
                            location: location || pkgObj.name,
                            //Remove leading dot in main, so main paths are normalized,
                            //and remove any trailing .js, since different package
                            //envs have different conventions: some use a module name,
                            //some use a file name.
                            main: (pkgObj.main || 'main')
                                  .replace(currDirRegExp, '')
                                  .replace(jsSuffixRegExp, '')
                        };
                    });

                    //Done with modifications, assing packages back to context config
                    config.pkgs = pkgs;
                }

                //If there are any "waiting to execute" modules in the registry,
                //update the maps for them, since their info, like URLs to load,
                //may have changed.
                eachProp(registry, function (mod, id) {
                    //If module already has init called, since it is too
                    //late to modify them, and ignore unnormalized ones
                    //since they are transient.
                    if (!mod.inited && !mod.map.unnormalized) {
                        mod.map = makeModuleMap(id);
                    }
                });

                //If a deps array or a config callback is specified, then call
                //require with those args. This is useful when require is defined as a
                //config object before require.js is loaded.
                if (cfg.deps || cfg.callback) {
                    context.require(cfg.deps || [], cfg.callback);
                }
            },

            makeShimExports: function (exports) {
                var func;
                if (typeof exports === 'string') {
                    func = function () {
                        return getGlobal(exports);
                    };
                    //Save the exports for use in nodefine checking.
                    func.exports = exports;
                    return func;
                } else {
                    return function () {
                        return exports.apply(global, arguments);
                    };
                }
            },

            requireDefined: function (id, relMap) {
                return hasProp(defined, makeModuleMap(id, relMap, false, true).id);
            },

            requireSpecified: function (id, relMap) {
                id = makeModuleMap(id, relMap, false, true).id;
                return hasProp(defined, id) || hasProp(registry, id);
            },

            require: function (deps, callback, errback, relMap) {
                var moduleName, id, map, requireMod, args;
                if (typeof deps === 'string') {
                    if (isFunction(callback)) {
                        //Invalid call
                        return onError(makeError('requireargs', 'Invalid require call'), errback);
                    }

                    //Synchronous access to one module. If require.get is
                    //available (as in the Node adapter), prefer that.
                    //In this case deps is the moduleName and callback is
                    //the relMap
                    if (req.get) {
                        return req.get(context, deps, callback);
                    }

                    //Just return the module wanted. In this scenario, the
                    //second arg (if passed) is just the relMap.
                    moduleName = deps;
                    relMap = callback;

                    //Normalize module name, if it contains . or ..
                    map = makeModuleMap(moduleName, relMap, false, true);
                    id = map.id;

                    if (!hasProp(defined, id)) {
                        return onError(makeError('notloaded', 'Module name "' +
                                    id +
                                    '" has not been loaded yet for context: ' +
                                    contextName));
                    }
                    return defined[id];
                }

                //Callback require. Normalize args. if callback or errback is
                //not a function, it means it is a relMap. Test errback first.
                if (errback && !isFunction(errback)) {
                    relMap = errback;
                    errback = undefined;
                }
                if (callback && !isFunction(callback)) {
                    relMap = callback;
                    callback = undefined;
                }

                //Any defined modules in the global queue, intake them now.
                takeGlobalQueue();

                //Make sure any remaining defQueue items get properly processed.
                while (defQueue.length) {
                    args = defQueue.shift();
                    if (args[0] === null) {
                        return onError(makeError('mismatch', 'Mismatched anonymous define() module: ' + args[args.length - 1]));
                    } else {
                        //args are id, deps, factory. Should be normalized by the
                        //define() function.
                        callGetModule(args);
                    }
                }

                //Mark all the dependencies as needing to be loaded.
                requireMod = getModule(makeModuleMap(null, relMap));

                requireMod.init(deps, callback, errback, {
                    enabled: true
                });

                checkLoaded();

                return context.require;
            },

            undef: function (id) {
                //Bind any waiting define() calls to this context,
                //fix for #408
                takeGlobalQueue();

                var map = makeModuleMap(id, null, true),
                    mod = registry[id];

                delete defined[id];
                delete urlFetched[map.url];
                delete undefEvents[id];

                if (mod) {
                    //Hold on to listeners in case the
                    //module will be attempted to be reloaded
                    //using a different config.
                    if (mod.events.defined) {
                        undefEvents[id] = mod.events;
                    }

                    removeWaiting(id);
                }
            },

            /**
             * Called to enable a module if it is still in the registry
             * awaiting enablement. parent module is passed in for context,
             * used by the optimizer.
             */
            enable: function (depMap, parent) {
                var mod = registry[depMap.id];
                if (mod) {
                    getModule(depMap).enable();
                }
            },

            /**
             * Internal method used by environment adapters to complete a load event.
             * A load event could be a script load or just a load pass from a synchronous
             * load call.
             * @param {String} moduleName the name of the module to potentially complete.
             */
            completeLoad: function (moduleName) {
                var found, args, mod,
                    shim = config.shim[moduleName] || {},
                    shExports = shim.exports && shim.exports.exports;

                takeGlobalQueue();

                while (defQueue.length) {
                    args = defQueue.shift();
                    if (args[0] === null) {
                        args[0] = moduleName;
                        //If already found an anonymous module and bound it
                        //to this name, then this is some other anon module
                        //waiting for its completeLoad to fire.
                        if (found) {
                            break;
                        }
                        found = true;
                    } else if (args[0] === moduleName) {
                        //Found matching define call for this script!
                        found = true;
                    }

                    callGetModule(args);
                }

                //Do this after the cycle of callGetModule in case the result
                //of those calls/init calls changes the registry.
                mod = registry[moduleName];

                if (!found && !defined[moduleName] && mod && !mod.inited) {
                    if (config.enforceDefine && (!shExports || !getGlobal(shExports))) {
                        if (hasPathFallback(moduleName)) {
                            return;
                        } else {
                            return onError(makeError('nodefine',
                                             'No define call for ' + moduleName,
                                             null,
                                             [moduleName]));
                        }
                    } else {
                        //A script that does not call define(), so just simulate
                        //the call for it.
                        callGetModule([moduleName, (shim.deps || []), shim.exports]);
                    }
                }

                checkLoaded();
            },

            /**
             * Converts a module name + .extension into an URL path.
             * *Requires* the use of a module name. It does not support using
             * plain URLs like nameToUrl.
             */
            toUrl: function (moduleNamePlusExt, relModuleMap) {
                var index = moduleNamePlusExt.lastIndexOf('.'),
                    ext = null;

                if (index !== -1) {
                    ext = moduleNamePlusExt.substring(index, moduleNamePlusExt.length);
                    moduleNamePlusExt = moduleNamePlusExt.substring(0, index);
                }

                return context.nameToUrl(normalize(moduleNamePlusExt, relModuleMap && relModuleMap.id, true),
                                         ext);
            },

            /**
             * Converts a module name to a file path. Supports cases where
             * moduleName may actually be just an URL.
             * Note that it **does not** call normalize on the moduleName,
             * it is assumed to have already been normalized. This is an
             * internal API, not a public one. Use toUrl for the public API.
             */
            nameToUrl: function (moduleName, ext) {
                var paths, pkgs, pkg, pkgPath, syms, i, parentModule, url,
                    parentPath;

                //If a colon is in the URL, it indicates a protocol is used and it is just
                //an URL to a file, or if it starts with a slash, contains a query arg (i.e. ?)
                //or ends with .js, then assume the user meant to use an url and not a module id.
                //The slash is important for protocol-less URLs as well as full paths.
                if (req.jsExtRegExp.test(moduleName)) {
                    //Just a plain path, not module name lookup, so just return it.
                    //Add extension if it is included. This is a bit wonky, only non-.js things pass
                    //an extension, this method probably needs to be reworked.
                    url = moduleName + (ext || '');
                } else {
                    //A module that needs to be converted to a path.
                    paths = config.paths;
                    pkgs = config.pkgs;

                    syms = moduleName.split('/');
                    //For each module name segment, see if there is a path
                    //registered for it. Start with most specific name
                    //and work up from it.
                    for (i = syms.length; i > 0; i -= 1) {
                        parentModule = syms.slice(0, i).join('/');
                        pkg = pkgs[parentModule];
                        parentPath = paths[parentModule];
                        if (parentPath) {
                            //If an array, it means there are a few choices,
                            //Choose the one that is desired
                            if (isArray(parentPath)) {
                                parentPath = parentPath[0];
                            }
                            syms.splice(0, i, parentPath);
                            break;
                        } else if (pkg) {
                            //If module name is just the package name, then looking
                            //for the main module.
                            if (moduleName === pkg.name) {
                                pkgPath = pkg.location + '/' + pkg.main;
                            } else {
                                pkgPath = pkg.location;
                            }
                            syms.splice(0, i, pkgPath);
                            break;
                        }
                    }

                    //Join the path parts together, then figure out if baseUrl is needed.
                    url = syms.join('/');
                    url += (ext || (/\?/.test(url) ? '' : '.js'));
                    url = (url.charAt(0) === '/' || url.match(/^[\w\+\.\-]+:/) ? '' : config.baseUrl) + url;
                }

                return config.urlArgs ? url +
                                        ((url.indexOf('?') === -1 ? '?' : '&') +
                                         config.urlArgs) : url;
            },

            //Delegates to req.load. Broken out as a separate function to
            //allow overriding in the optimizer.
            load: function (id, url) {
                req.load(context, id, url);
            },

            /**
             * Executes a module callack function. Broken out as a separate function
             * solely to allow the build system to sequence the files in the built
             * layer in the right sequence.
             *
             * @private
             */
            execCb: function (name, callback, args, exports) {
                return callback.apply(exports, args);
            },

            /**
             * callback for script loads, used to check status of loading.
             *
             * @param {Event} evt the event from the browser for the script
             * that was loaded.
             */
            onScriptLoad: function (evt) {
                //Using currentTarget instead of target for Firefox 2.0's sake. Not
                //all old browsers will be supported, but this one was easy enough
                //to support and still makes sense.
                if (evt.type === 'load' ||
                        (readyRegExp.test((evt.currentTarget || evt.srcElement).readyState))) {
                    //Reset interactive script so a script node is not held onto for
                    //to long.
                    interactiveScript = null;

                    //Pull out the name of the module and the context.
                    var data = getScriptData(evt);
                    context.completeLoad(data.id);
                }
            },

            /**
             * Callback for script errors.
             */
            onScriptError: function (evt) {
                var data = getScriptData(evt);
                if (!hasPathFallback(data.id)) {
                    return onError(makeError('scripterror', 'Script error', evt, [data.id]));
                }
            }
        });
    }

    /**
     * Main entry point.
     *
     * If the only argument to require is a string, then the module that
     * is represented by that string is fetched for the appropriate context.
     *
     * If the first argument is an array, then it will be treated as an array
     * of dependency string names to fetch. An optional function callback can
     * be specified to execute when all of those dependencies are available.
     *
     * Make a local req variable to help Caja compliance (it assumes things
     * on a require that are not standardized), and to give a short
     * name for minification/local scope use.
     */
    req = requirejs = function (deps, callback, errback, optional) {

        //Find the right context, use default
        var context, config,
            contextName = defContextName;

        // Determine if have config object in the call.
        if (!isArray(deps) && typeof deps !== 'string') {
            // deps is a config object
            config = deps;
            if (isArray(callback)) {
                // Adjust args if there are dependencies
                deps = callback;
                callback = errback;
                errback = optional;
            } else {
                deps = [];
            }
        }

        if (config && config.context) {
            contextName = config.context;
        }

        context = contexts[contextName];
        if (!context) {
            context = contexts[contextName] = req.s.newContext(contextName);
        }

        if (config) {
            context.configure(config);
        }

        return context.require(deps, callback, errback);
    };

    /**
     * Support require.config() to make it easier to cooperate with other
     * AMD loaders on globally agreed names.
     */
    req.config = function (config) {
        return req(config);
    };

    /**
     * Export require as a global, but only if it does not already exist.
     */
    if (!require) {
        require = req;
    }

    req.version = version;

    //Used to filter out dependencies that are already paths.
    req.jsExtRegExp = /^\/|:|\?|\.js$/;
    req.isBrowser = isBrowser;
    s = req.s = {
        contexts: contexts,
        newContext: newContext
    };

    //Create default context.
    req({});

    //Exports some context-sensitive methods on global require, using
    //default context if no context specified.
    addRequireMethods(req);

    if (isBrowser) {
        head = s.head = document.getElementsByTagName('head')[0];
        //If BASE tag is in play, using appendChild is a problem for IE6.
        //When that browser dies, this can be removed. Details in this jQuery bug:
        //http://dev.jquery.com/ticket/2709
        baseElement = document.getElementsByTagName('base')[0];
        if (baseElement) {
            head = s.head = baseElement.parentNode;
        }
    }

    /**
     * Any errors that require explicitly generates will be passed to this
     * function. Intercept/override it if you want custom error handling.
     * @param {Error} err the error object.
     */
    req.onError = function (err) {
        throw err;
    };

    /**
     * Does the request to load a module for the browser case.
     * Make this a separate function to allow other environments
     * to override it.
     *
     * @param {Object} context the require context to find state.
     * @param {String} moduleName the name of the module.
     * @param {Object} url the URL to the module.
     */
    req.load = function (context, moduleName, url) {
        var config = (context && context.config) || {},
            node;
        if (isBrowser) {
            //In the browser so use a script tag
            node = config.xhtml ?
                    document.createElementNS('http://www.w3.org/1999/xhtml', 'html:script') :
                    document.createElement('script');
            node.type = config.scriptType || 'text/javascript';
            node.charset = 'utf-8';
            node.async = true;

            node.setAttribute('data-requirecontext', context.contextName);
            node.setAttribute('data-requiremodule', moduleName);

            //Set up load listener. Test attachEvent first because IE9 has
            //a subtle issue in its addEventListener and script onload firings
            //that do not match the behavior of all other browsers with
            //addEventListener support, which fire the onload event for a
            //script right after the script execution. See:
            //https://connect.microsoft.com/IE/feedback/details/648057/script-onload-event-is-not-fired-immediately-after-script-execution
            //UNFORTUNATELY Opera implements attachEvent but does not follow the script
            //script execution mode.
            if (node.attachEvent &&
                    //Check if node.attachEvent is artificially added by custom script or
                    //natively supported by browser
                    //read https://github.com/jrburke/requirejs/issues/187
                    //if we can NOT find [native code] then it must NOT natively supported.
                    //in IE8, node.attachEvent does not have toString()
                    //Note the test for "[native code" with no closing brace, see:
                    //https://github.com/jrburke/requirejs/issues/273
                    !(node.attachEvent.toString && node.attachEvent.toString().indexOf('[native code') < 0) &&
                    !isOpera) {
                //Probably IE. IE (at least 6-8) do not fire
                //script onload right after executing the script, so
                //we cannot tie the anonymous define call to a name.
                //However, IE reports the script as being in 'interactive'
                //readyState at the time of the define call.
                useInteractive = true;

                node.attachEvent('onreadystatechange', context.onScriptLoad);
                //It would be great to add an error handler here to catch
                //404s in IE9+. However, onreadystatechange will fire before
                //the error handler, so that does not help. If addEvenListener
                //is used, then IE will fire error before load, but we cannot
                //use that pathway given the connect.microsoft.com issue
                //mentioned above about not doing the 'script execute,
                //then fire the script load event listener before execute
                //next script' that other browsers do.
                //Best hope: IE10 fixes the issues,
                //and then destroys all installs of IE 6-9.
                //node.attachEvent('onerror', context.onScriptError);
            } else {
                node.addEventListener('load', context.onScriptLoad, false);
                node.addEventListener('error', context.onScriptError, false);
            }
            node.src = url;

            //For some cache cases in IE 6-8, the script executes before the end
            //of the appendChild execution, so to tie an anonymous define
            //call to the module name (which is stored on the node), hold on
            //to a reference to this node, but clear after the DOM insertion.
            currentlyAddingScript = node;
            if (baseElement) {
                head.insertBefore(node, baseElement);
            } else {
                head.appendChild(node);
            }
            currentlyAddingScript = null;

            return node;
        } else if (isWebWorker) {
            //In a web worker, use importScripts. This is not a very
            //efficient use of importScripts, importScripts will block until
            //its script is downloaded and evaluated. However, if web workers
            //are in play, the expectation that a build has been done so that
            //only one script needs to be loaded anyway. This may need to be
            //reevaluated if other use cases become common.
            importScripts(url);

            //Account for anonymous modules
            context.completeLoad(moduleName);
        }
    };

    function getInteractiveScript() {
        if (interactiveScript && interactiveScript.readyState === 'interactive') {
            return interactiveScript;
        }

        eachReverse(scripts(), function (script) {
            if (script.readyState === 'interactive') {
                return (interactiveScript = script);
            }
        });
        return interactiveScript;
    }

    //Look for a data-main script attribute, which could also adjust the baseUrl.
    if (isBrowser) {
        //Figure out baseUrl. Get it from the script tag with require.js in it.
        eachReverse(scripts(), function (script) {
            //Set the 'head' where we can append children by
            //using the script's parent.
            if (!head) {
                head = script.parentNode;
            }

            //Look for a data-main attribute to set main script for the page
            //to load. If it is there, the path to data main becomes the
            //baseUrl, if it is not already set.
            dataMain = script.getAttribute('data-main');
            if (dataMain) {
                //Set final baseUrl if there is not already an explicit one.
                if (!cfg.baseUrl) {
                    //Pull off the directory of data-main for use as the
                    //baseUrl.
                    src = dataMain.split('/');
                    mainScript = src.pop();
                    subPath = src.length ? src.join('/')  + '/' : './';

                    cfg.baseUrl = subPath;
                    dataMain = mainScript;
                }

                //Strip off any trailing .js since dataMain is now
                //like a module name.
                dataMain = dataMain.replace(jsSuffixRegExp, '');

                //Put the data-main script in the files to load.
                cfg.deps = cfg.deps ? cfg.deps.concat(dataMain) : [dataMain];

                return true;
            }
        });
    }

    /**
     * The function that handles definitions of modules. Differs from
     * require() in that a string for the module should be the first argument,
     * and the function to execute after dependencies are loaded should
     * return a value to define the module corresponding to the first argument's
     * name.
     */
    define = function (name, deps, callback) {
        var node, context;

        //Allow for anonymous functions
        if (typeof name !== 'string') {
            //Adjust args appropriately
            callback = deps;
            deps = name;
            name = null;
        }

        //This module may not have dependencies
        if (!isArray(deps)) {
            callback = deps;
            deps = [];
        }

        //If no name, and callback is a function, then figure out if it a
        //CommonJS thing with dependencies.
        if (!deps.length && isFunction(callback)) {
            //Remove comments from the callback string,
            //look for require calls, and pull them into the dependencies,
            //but only if there are function args.
            if (callback.length) {
                callback
                    .toString()
                    .replace(commentRegExp, '')
                    .replace(cjsRequireRegExp, function (match, dep) {
                        deps.push(dep);
                    });

                //May be a CommonJS thing even without require calls, but still
                //could use exports, and module. Avoid doing exports and module
                //work though if it just needs require.
                //REQUIRES the function to expect the CommonJS variables in the
                //order listed below.
                deps = (callback.length === 1 ? ['require'] : ['require', 'exports', 'module']).concat(deps);
            }
        }

        //If in IE 6-8 and hit an anonymous define() call, do the interactive
        //work.
        if (useInteractive) {
            node = currentlyAddingScript || getInteractiveScript();
            if (node) {
                if (!name) {
                    name = node.getAttribute('data-requiremodule');
                }
                context = contexts[node.getAttribute('data-requirecontext')];
            }
        }

        //Always save off evaluating the def call until the script onload handler.
        //This allows multiple modules to be in a file without prematurely
        //tracing dependencies, and allows for anonymous module support,
        //where the module name is not known until the script onload event
        //occurs. If no context, use the global queue, and get it processed
        //in the onscript load callback.
        (context ? context.defQueue : globalDefQueue).push([name, deps, callback]);
    };

    define.amd = {
        jQuery: true
    };


    /**
     * Executes the text. Normally just uses eval, but can be modified
     * to use a better, environment-specific call. Only used for transpiling
     * loader plugins, not for plain JS modules.
     * @param {String} text the text to execute/evaluate.
     */
    req.exec = function (text) {
        /*jslint evil: true */
        return eval(text);
    };

    //Set up with config info.
    req(cfg);
}(this));

define("requirejs", function(){});

// Loaded already, use what's in global scope.
// Register as a named module in requirejs:
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#anon
define('jquery', [], function () {
	return jQuery;
});
/*
	Ractive.js v0.7.3
	Sat Apr 25 2015 13:52:38 GMT-0400 (EDT) - commit da40f81c660ba2f09c45a09a9c20fdd34ee36d80

	http://ractivejs.org
	http://twitter.com/RactiveJS

	Released under the MIT License.
*/

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define('ractive',factory) :
  global.Ractive = factory()
}(this, function () { 'use strict';

  var TEMPLATE_VERSION = 3;

  var defaultOptions = {

  	// render placement:
  	el: void 0,
  	append: false,

  	// template:
  	template: { v: TEMPLATE_VERSION, t: [] },

  	// parse:     // TODO static delimiters?
  	preserveWhitespace: false,
  	sanitize: false,
  	stripComments: true,
  	delimiters: ["{{", "}}"],
  	tripleDelimiters: ["{{{", "}}}"],
  	interpolate: false,

  	// data & binding:
  	data: {},
  	computed: {},
  	magic: false,
  	modifyArrays: true,
  	adapt: [],
  	isolated: false,
  	twoway: true,
  	lazy: false,

  	// transitions:
  	noIntro: false,
  	transitionsEnabled: true,
  	complete: void 0,

  	// css:
  	css: null,
  	noCssTransform: false
  };

  var config_defaults = defaultOptions;

  // These are a subset of the easing equations found at
  // https://raw.github.com/danro/easing-js - license info
  // follows:

  // --------------------------------------------------
  // easing.js v0.5.4
  // Generic set of easing functions with AMD support
  // https://github.com/danro/easing-js
  // This code may be freely distributed under the MIT license
  // http://danro.mit-license.org/
  // --------------------------------------------------
  // All functions adapted from Thomas Fuchs & Jeremy Kahn
  // Easing Equations (c) 2003 Robert Penner, BSD license
  // https://raw.github.com/danro/easing-js/master/LICENSE
  // --------------------------------------------------

  // In that library, the functions named easeIn, easeOut, and
  // easeInOut below are named easeInCubic, easeOutCubic, and
  // (you guessed it) easeInOutCubic.
  //
  // You can add additional easing functions to this list, and they
  // will be globally available.

  var static_easing = {
  	linear: function (pos) {
  		return pos;
  	},
  	easeIn: function (pos) {
  		return Math.pow(pos, 3);
  	},
  	easeOut: function (pos) {
  		return Math.pow(pos - 1, 3) + 1;
  	},
  	easeInOut: function (pos) {
  		if ((pos /= 0.5) < 1) {
  			return 0.5 * Math.pow(pos, 3);
  		}
  		return 0.5 * (Math.pow(pos - 2, 3) + 2);
  	}
  };

  /*global console, navigator */
  var isClient, isJsdom, hasConsole, environment__magic, namespaces, svg, vendors;

  isClient = typeof document === "object";

  isJsdom = typeof navigator !== "undefined" && /jsDom/.test(navigator.appName);

  hasConsole = typeof console !== "undefined" && typeof console.warn === "function" && typeof console.warn.apply === "function";

  try {
  	Object.defineProperty({}, "test", { value: 0 });
  	environment__magic = true;
  } catch (e) {
  	environment__magic = false;
  }

  namespaces = {
  	html: "http://www.w3.org/1999/xhtml",
  	mathml: "http://www.w3.org/1998/Math/MathML",
  	svg: "http://www.w3.org/2000/svg",
  	xlink: "http://www.w3.org/1999/xlink",
  	xml: "http://www.w3.org/XML/1998/namespace",
  	xmlns: "http://www.w3.org/2000/xmlns/"
  };

  if (typeof document === "undefined") {
  	svg = false;
  } else {
  	svg = document && document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1");
  }

  vendors = ["o", "ms", "moz", "webkit"];

  var createElement, matches, dom__div, methodNames, unprefixed, prefixed, dom__i, j, makeFunction;

  // Test for SVG support
  if (!svg) {
  	createElement = function (type, ns) {
  		if (ns && ns !== namespaces.html) {
  			throw "This browser does not support namespaces other than http://www.w3.org/1999/xhtml. The most likely cause of this error is that you're trying to render SVG in an older browser. See http://docs.ractivejs.org/latest/svg-and-older-browsers for more information";
  		}

  		return document.createElement(type);
  	};
  } else {
  	createElement = function (type, ns) {
  		if (!ns || ns === namespaces.html) {
  			return document.createElement(type);
  		}

  		return document.createElementNS(ns, type);
  	};
  }

  function getElement(input) {
  	var output;

  	if (!input || typeof input === "boolean") {
  		return;
  	}

  	if (typeof window === "undefined" || !document || !input) {
  		return null;
  	}

  	// We already have a DOM node - no work to do. (Duck typing alert!)
  	if (input.nodeType) {
  		return input;
  	}

  	// Get node from string
  	if (typeof input === "string") {
  		// try ID first
  		output = document.getElementById(input);

  		// then as selector, if possible
  		if (!output && document.querySelector) {
  			output = document.querySelector(input);
  		}

  		// did it work?
  		if (output && output.nodeType) {
  			return output;
  		}
  	}

  	// If we've been given a collection (jQuery, Zepto etc), extract the first item
  	if (input[0] && input[0].nodeType) {
  		return input[0];
  	}

  	return null;
  }

  if (!isClient) {
  	matches = null;
  } else {
  	dom__div = createElement("div");
  	methodNames = ["matches", "matchesSelector"];

  	makeFunction = function (methodName) {
  		return function (node, selector) {
  			return node[methodName](selector);
  		};
  	};

  	dom__i = methodNames.length;

  	while (dom__i-- && !matches) {
  		unprefixed = methodNames[dom__i];

  		if (dom__div[unprefixed]) {
  			matches = makeFunction(unprefixed);
  		} else {
  			j = vendors.length;
  			while (j--) {
  				prefixed = vendors[dom__i] + unprefixed.substr(0, 1).toUpperCase() + unprefixed.substring(1);

  				if (dom__div[prefixed]) {
  					matches = makeFunction(prefixed);
  					break;
  				}
  			}
  		}
  	}

  	// IE8...
  	if (!matches) {
  		matches = function (node, selector) {
  			var nodes, parentNode, i;

  			parentNode = node.parentNode;

  			if (!parentNode) {
  				// empty dummy <div>
  				dom__div.innerHTML = "";

  				parentNode = dom__div;
  				node = node.cloneNode();

  				dom__div.appendChild(node);
  			}

  			nodes = parentNode.querySelectorAll(selector);

  			i = nodes.length;
  			while (i--) {
  				if (nodes[i] === node) {
  					return true;
  				}
  			}

  			return false;
  		};
  	}
  }

  function detachNode(node) {
  	if (node && typeof node.parentNode !== "unknown" && node.parentNode) {
  		node.parentNode.removeChild(node);
  	}

  	return node;
  }

  function safeToStringValue(value) {
  	return value == null || !value.toString ? "" : value;
  }

  var legacy = null;

  var create, defineProperty, defineProperties;

  try {
  	Object.defineProperty({}, "test", { value: 0 });

  	if (isClient) {
  		Object.defineProperty(document.createElement("div"), "test", { value: 0 });
  	}

  	defineProperty = Object.defineProperty;
  } catch (err) {
  	// Object.defineProperty doesn't exist, or we're in IE8 where you can
  	// only use it with DOM objects (what were you smoking, MSFT?)
  	defineProperty = function (obj, prop, desc) {
  		obj[prop] = desc.value;
  	};
  }

  try {
  	try {
  		Object.defineProperties({}, { test: { value: 0 } });
  	} catch (err) {
  		// TODO how do we account for this? noMagic = true;
  		throw err;
  	}

  	if (isClient) {
  		Object.defineProperties(createElement("div"), { test: { value: 0 } });
  	}

  	defineProperties = Object.defineProperties;
  } catch (err) {
  	defineProperties = function (obj, props) {
  		var prop;

  		for (prop in props) {
  			if (props.hasOwnProperty(prop)) {
  				defineProperty(obj, prop, props[prop]);
  			}
  		}
  	};
  }

  try {
  	Object.create(null);

  	create = Object.create;
  } catch (err) {
  	// sigh
  	create = (function () {
  		var F = function () {};

  		return function (proto, props) {
  			var obj;

  			if (proto === null) {
  				return {};
  			}

  			F.prototype = proto;
  			obj = new F();

  			if (props) {
  				Object.defineProperties(obj, props);
  			}

  			return obj;
  		};
  	})();
  }

  function utils_object__extend(target) {
  	for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
  		sources[_key - 1] = arguments[_key];
  	}

  	var prop, source;

  	while (source = sources.shift()) {
  		for (prop in source) {
  			if (hasOwn.call(source, prop)) {
  				target[prop] = source[prop];
  			}
  		}
  	}

  	return target;
  }

  function fillGaps(target) {
  	for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
  		sources[_key - 1] = arguments[_key];
  	}

  	sources.forEach(function (s) {
  		for (var key in s) {
  			if (s.hasOwnProperty(key) && !(key in target)) {
  				target[key] = s[key];
  			}
  		}
  	});

  	return target;
  }

  var hasOwn = Object.prototype.hasOwnProperty;

  // thanks, http://perfectionkills.com/instanceof-considered-harmful-or-how-to-write-a-robust-isarray/
  var is__toString = Object.prototype.toString,
      arrayLikePattern = /^\[object (?:Array|FileList)\]$/;
  function isArray(thing) {
  	return is__toString.call(thing) === "[object Array]";
  }

  function isArrayLike(obj) {
  	return arrayLikePattern.test(is__toString.call(obj));
  }

  function isEqual(a, b) {
  	if (a === null && b === null) {
  		return true;
  	}

  	if (typeof a === "object" || typeof b === "object") {
  		return false;
  	}

  	return a === b;
  }

  function is__isNumeric(thing) {
  	return !isNaN(parseFloat(thing)) && isFinite(thing);
  }

  function isObject(thing) {
  	return thing && is__toString.call(thing) === "[object Object]";
  }

  var noop = function () {};

  /* global console */
  var alreadyWarned = {},
      log,
      printWarning,
      welcome;

  if (hasConsole) {
  	(function () {
  		var welcomeIntro = ["%cRactive.js %c0.7.3 %cin debug mode, %cmore...", "color: rgb(114, 157, 52); font-weight: normal;", "color: rgb(85, 85, 85); font-weight: normal;", "color: rgb(85, 85, 85); font-weight: normal;", "color: rgb(82, 140, 224); font-weight: normal; text-decoration: underline;"];
  		var welcomeMessage = "You're running Ractive 0.7.3 in debug mode - messages will be printed to the console to help you fix problems and optimise your application.\n\nTo disable debug mode, add this line at the start of your app:\n  Ractive.DEBUG = false;\n\nTo disable debug mode when your app is minified, add this snippet:\n  Ractive.DEBUG = /unminified/.test(function(){/*unminified*/});\n\nGet help and support:\n  http://docs.ractivejs.org\n  http://stackoverflow.com/questions/tagged/ractivejs\n  http://groups.google.com/forum/#!forum/ractive-js\n  http://twitter.com/ractivejs\n\nFound a bug? Raise an issue:\n  https://github.com/ractivejs/ractive/issues\n\n";

  		welcome = function () {
  			var hasGroup = !!console.groupCollapsed;
  			console[hasGroup ? "groupCollapsed" : "log"].apply(console, welcomeIntro);
  			console.log(welcomeMessage);
  			if (hasGroup) {
  				console.groupEnd(welcomeIntro);
  			}

  			welcome = noop;
  		};

  		printWarning = function (message, args) {
  			welcome();

  			// extract information about the instance this message pertains to, if applicable
  			if (typeof args[args.length - 1] === "object") {
  				var options = args.pop();
  				var ractive = options ? options.ractive : null;

  				if (ractive) {
  					// if this is an instance of a component that we know the name of, add
  					// it to the message
  					var _name = undefined;
  					if (ractive.component && (_name = ractive.component.name)) {
  						message = "<" + _name + "> " + message;
  					}

  					var node = undefined;
  					if (node = options.node || ractive.fragment && ractive.fragment.rendered && ractive.find("*")) {
  						args.push(node);
  					}
  				}
  			}

  			console.warn.apply(console, ["%cRactive.js: %c" + message, "color: rgb(114, 157, 52);", "color: rgb(85, 85, 85);"].concat(args));
  		};

  		log = function () {
  			console.log.apply(console, arguments);
  		};
  	})();
  } else {
  	printWarning = log = welcome = noop;
  }

  function format(message, args) {
  	return message.replace(/%s/g, function () {
  		return args.shift();
  	});
  }

  function fatal(message) {
  	for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
  		args[_key - 1] = arguments[_key];
  	}

  	message = format(message, args);
  	throw new Error(message);
  }

  function logIfDebug() {
  	if (_Ractive.DEBUG) {
  		log.apply(null, arguments);
  	}
  }

  function warn(message) {
  	for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
  		args[_key - 1] = arguments[_key];
  	}

  	message = format(message, args);
  	printWarning(message, args);
  }

  function warnOnce(message) {
  	for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
  		args[_key - 1] = arguments[_key];
  	}

  	message = format(message, args);

  	if (alreadyWarned[message]) {
  		return;
  	}

  	alreadyWarned[message] = true;
  	printWarning(message, args);
  }

  function warnIfDebug() {
  	if (_Ractive.DEBUG) {
  		warn.apply(null, arguments);
  	}
  }

  function warnOnceIfDebug() {
  	if (_Ractive.DEBUG) {
  		warnOnce.apply(null, arguments);
  	}
  }

  // Error messages that are used (or could be) in multiple places
  var badArguments = "Bad arguments";
  var noRegistryFunctionReturn = "A function was specified for \"%s\" %s, but no %s was returned";
  var missingPlugin = function (name, type) {
    return "Missing \"" + name + "\" " + type + " plugin. You may need to download a plugin via http://docs.ractivejs.org/latest/plugins#" + type + "s";
  };

  function findInViewHierarchy(registryName, ractive, name) {
  	var instance = findInstance(registryName, ractive, name);
  	return instance ? instance[registryName][name] : null;
  }

  function findInstance(registryName, ractive, name) {
  	while (ractive) {
  		if (name in ractive[registryName]) {
  			return ractive;
  		}

  		if (ractive.isolated) {
  			return null;
  		}

  		ractive = ractive.parent;
  	}
  }

  var interpolate = function (from, to, ractive, type) {
  	if (from === to) {
  		return snap(to);
  	}

  	if (type) {

  		var interpol = findInViewHierarchy("interpolators", ractive, type);
  		if (interpol) {
  			return interpol(from, to) || snap(to);
  		}

  		fatal(missingPlugin(type, "interpolator"));
  	}

  	return static_interpolators.number(from, to) || static_interpolators.array(from, to) || static_interpolators.object(from, to) || snap(to);
  };

  var shared_interpolate = interpolate;

  function snap(to) {
  	return function () {
  		return to;
  	};
  }

  var interpolators = {
  	number: function (from, to) {
  		var delta;

  		if (!is__isNumeric(from) || !is__isNumeric(to)) {
  			return null;
  		}

  		from = +from;
  		to = +to;

  		delta = to - from;

  		if (!delta) {
  			return function () {
  				return from;
  			};
  		}

  		return function (t) {
  			return from + t * delta;
  		};
  	},

  	array: function (from, to) {
  		var intermediate, interpolators, len, i;

  		if (!isArray(from) || !isArray(to)) {
  			return null;
  		}

  		intermediate = [];
  		interpolators = [];

  		i = len = Math.min(from.length, to.length);
  		while (i--) {
  			interpolators[i] = shared_interpolate(from[i], to[i]);
  		}

  		// surplus values - don't interpolate, but don't exclude them either
  		for (i = len; i < from.length; i += 1) {
  			intermediate[i] = from[i];
  		}

  		for (i = len; i < to.length; i += 1) {
  			intermediate[i] = to[i];
  		}

  		return function (t) {
  			var i = len;

  			while (i--) {
  				intermediate[i] = interpolators[i](t);
  			}

  			return intermediate;
  		};
  	},

  	object: function (from, to) {
  		var properties, len, interpolators, intermediate, prop;

  		if (!isObject(from) || !isObject(to)) {
  			return null;
  		}

  		properties = [];
  		intermediate = {};
  		interpolators = {};

  		for (prop in from) {
  			if (hasOwn.call(from, prop)) {
  				if (hasOwn.call(to, prop)) {
  					properties.push(prop);
  					interpolators[prop] = shared_interpolate(from[prop], to[prop]);
  				} else {
  					intermediate[prop] = from[prop];
  				}
  			}
  		}

  		for (prop in to) {
  			if (hasOwn.call(to, prop) && !hasOwn.call(from, prop)) {
  				intermediate[prop] = to[prop];
  			}
  		}

  		len = properties.length;

  		return function (t) {
  			var i = len,
  			    prop;

  			while (i--) {
  				prop = properties[i];

  				intermediate[prop] = interpolators[prop](t);
  			}

  			return intermediate;
  		};
  	}
  };

  var static_interpolators = interpolators;

  // This function takes a keypath such as 'foo.bar.baz', and returns
  // all the variants of that keypath that include a wildcard in place
  // of a key, such as 'foo.bar.*', 'foo.*.baz', 'foo.*.*' and so on.
  // These are then checked against the dependants map (ractive.viewmodel.depsMap)
  // to see if any pattern observers are downstream of one or more of
  // these wildcard keypaths (e.g. 'foo.bar.*.status')
  var utils_getPotentialWildcardMatches = getPotentialWildcardMatches;

  var starMaps = {};
  function getPotentialWildcardMatches(keypath) {
  	var keys, starMap, mapper, i, result, wildcardKeypath;

  	keys = keypath.split(".");
  	if (!(starMap = starMaps[keys.length])) {
  		starMap = getStarMap(keys.length);
  	}

  	result = [];

  	mapper = function (star, i) {
  		return star ? "*" : keys[i];
  	};

  	i = starMap.length;
  	while (i--) {
  		wildcardKeypath = starMap[i].map(mapper).join(".");

  		if (!result.hasOwnProperty(wildcardKeypath)) {
  			result.push(wildcardKeypath);
  			result[wildcardKeypath] = true;
  		}
  	}

  	return result;
  }

  // This function returns all the possible true/false combinations for
  // a given number - e.g. for two, the possible combinations are
  // [ true, true ], [ true, false ], [ false, true ], [ false, false ].
  // It does so by getting all the binary values between 0 and e.g. 11
  function getStarMap(num) {
  	var ones = "",
  	    max,
  	    binary,
  	    starMap,
  	    mapper,
  	    i,
  	    j,
  	    l,
  	    map;

  	if (!starMaps[num]) {
  		starMap = [];

  		while (ones.length < num) {
  			ones += 1;
  		}

  		max = parseInt(ones, 2);

  		mapper = function (digit) {
  			return digit === "1";
  		};

  		for (i = 0; i <= max; i += 1) {
  			binary = i.toString(2);
  			while (binary.length < num) {
  				binary = "0" + binary;
  			}

  			map = [];
  			l = binary.length;
  			for (j = 0; j < l; j++) {
  				map.push(mapper(binary[j]));
  			}
  			starMap[i] = map;
  		}

  		starMaps[num] = starMap;
  	}

  	return starMaps[num];
  }

  var refPattern = /\[\s*(\*|[0-9]|[1-9][0-9]+)\s*\]/g;
  var patternPattern = /\*/;
  var keypathCache = {};

  var Keypath = function (str) {
  	var keys = str.split(".");

  	this.str = str;

  	if (str[0] === "@") {
  		this.isSpecial = true;
  		this.value = decodeKeypath(str);
  	}

  	this.firstKey = keys[0];
  	this.lastKey = keys.pop();

  	this.isPattern = patternPattern.test(str);

  	this.parent = str === "" ? null : getKeypath(keys.join("."));
  	this.isRoot = !str;
  };

  Keypath.prototype = {
  	equalsOrStartsWith: function (keypath) {
  		return keypath === this || this.startsWith(keypath);
  	},

  	join: function (str) {
  		return getKeypath(this.isRoot ? String(str) : this.str + "." + str);
  	},

  	replace: function (oldKeypath, newKeypath) {
  		if (this === oldKeypath) {
  			return newKeypath;
  		}

  		if (this.startsWith(oldKeypath)) {
  			return newKeypath === null ? newKeypath : getKeypath(this.str.replace(oldKeypath.str + ".", newKeypath.str + "."));
  		}
  	},

  	startsWith: function (keypath) {
  		if (!keypath) {
  			// TODO under what circumstances does this happen?
  			return false;
  		}

  		return keypath && this.str.substr(0, keypath.str.length + 1) === keypath.str + ".";
  	},

  	toString: function () {
  		throw new Error("Bad coercion");
  	},

  	valueOf: function () {
  		throw new Error("Bad coercion");
  	},

  	wildcardMatches: function () {
  		return this._wildcardMatches || (this._wildcardMatches = utils_getPotentialWildcardMatches(this.str));
  	}
  };
  function assignNewKeypath(target, property, oldKeypath, newKeypath) {
  	var existingKeypath = target[property];

  	if (existingKeypath && (existingKeypath.equalsOrStartsWith(newKeypath) || !existingKeypath.equalsOrStartsWith(oldKeypath))) {
  		return;
  	}

  	target[property] = existingKeypath ? existingKeypath.replace(oldKeypath, newKeypath) : newKeypath;
  	return true;
  }

  function decodeKeypath(keypath) {
  	var value = keypath.slice(2);

  	if (keypath[1] === "i") {
  		return is__isNumeric(value) ? +value : value;
  	} else {
  		return value;
  	}
  }

  function getKeypath(str) {
  	if (str == null) {
  		return str;
  	}

  	// TODO it *may* be worth having two versions of this function - one where
  	// keypathCache inherits from null, and one for IE8. Depends on how
  	// much of an overhead hasOwnProperty is - probably negligible
  	if (!keypathCache.hasOwnProperty(str)) {
  		keypathCache[str] = new Keypath(str);
  	}

  	return keypathCache[str];
  }

  function getMatchingKeypaths(ractive, keypath) {
  	var keys, key, matchingKeypaths;

  	keys = keypath.str.split(".");
  	matchingKeypaths = [rootKeypath];

  	while (key = keys.shift()) {
  		if (key === "*") {
  			// expand to find all valid child keypaths
  			matchingKeypaths = matchingKeypaths.reduce(expand, []);
  		} else {
  			if (matchingKeypaths[0] === rootKeypath) {
  				// first key
  				matchingKeypaths[0] = getKeypath(key);
  			} else {
  				matchingKeypaths = matchingKeypaths.map(concatenate(key));
  			}
  		}
  	}

  	return matchingKeypaths;

  	function expand(matchingKeypaths, keypath) {
  		var wrapper, value, keys;

  		if (keypath.isRoot) {
  			keys = [].concat(Object.keys(ractive.viewmodel.data), Object.keys(ractive.viewmodel.mappings), Object.keys(ractive.viewmodel.computations));
  		} else {
  			wrapper = ractive.viewmodel.wrapped[keypath.str];
  			value = wrapper ? wrapper.get() : ractive.viewmodel.get(keypath);

  			keys = value ? Object.keys(value) : null;
  		}

  		if (keys) {
  			keys.forEach(function (key) {
  				if (key !== "_ractive" || !isArray(value)) {
  					matchingKeypaths.push(keypath.join(key));
  				}
  			});
  		}

  		return matchingKeypaths;
  	}
  }

  function concatenate(key) {
  	return function (keypath) {
  		return keypath.join(key);
  	};
  }
  function normalise(ref) {
  	return ref ? ref.replace(refPattern, ".$1") : "";
  }

  var rootKeypath = getKeypath("");

  var shared_add = add;
  var shared_add__errorMessage = "Cannot add to a non-numeric value";
  function add(root, keypath, d) {
  	if (typeof keypath !== "string" || !is__isNumeric(d)) {
  		throw new Error("Bad arguments");
  	}

  	var value = undefined,
  	    changes = undefined;

  	if (/\*/.test(keypath)) {
  		changes = {};

  		getMatchingKeypaths(root, getKeypath(normalise(keypath))).forEach(function (keypath) {
  			var value = root.viewmodel.get(keypath);

  			if (!is__isNumeric(value)) {
  				throw new Error(shared_add__errorMessage);
  			}

  			changes[keypath.str] = value + d;
  		});

  		return root.set(changes);
  	}

  	value = root.get(keypath);

  	if (!is__isNumeric(value)) {
  		throw new Error(shared_add__errorMessage);
  	}

  	return root.set(keypath, +value + d);
  }

  var prototype_add = Ractive$add;
  function Ractive$add(keypath, d) {
  	return shared_add(this, keypath, d === undefined ? 1 : +d);
  }

  var requestAnimationFrame;

  // If window doesn't exist, we don't need requestAnimationFrame
  if (typeof window === "undefined") {
  	requestAnimationFrame = null;
  } else {
  	// https://gist.github.com/paulirish/1579671
  	(function (vendors, lastTime, window) {

  		var x, setTimeout;

  		if (window.requestAnimationFrame) {
  			return;
  		}

  		for (x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
  			window.requestAnimationFrame = window[vendors[x] + "RequestAnimationFrame"];
  		}

  		if (!window.requestAnimationFrame) {
  			setTimeout = window.setTimeout;

  			window.requestAnimationFrame = function (callback) {
  				var currTime, timeToCall, id;

  				currTime = Date.now();
  				timeToCall = Math.max(0, 16 - (currTime - lastTime));
  				id = setTimeout(function () {
  					callback(currTime + timeToCall);
  				}, timeToCall);

  				lastTime = currTime + timeToCall;
  				return id;
  			};
  		}
  	})(vendors, 0, window);

  	requestAnimationFrame = window.requestAnimationFrame;
  }

  var rAF = requestAnimationFrame;

  var getTime;

  if (typeof window !== "undefined" && window.performance && typeof window.performance.now === "function") {
  	getTime = function () {
  		return window.performance.now();
  	};
  } else {
  	getTime = function () {
  		return Date.now();
  	};
  }

  var utils_getTime = getTime;

  var deprecations = {
  	construct: {
  		deprecated: "beforeInit",
  		replacement: "onconstruct"
  	},
  	render: {
  		deprecated: "init",
  		message: "The \"init\" method has been deprecated " + "and will likely be removed in a future release. " + "You can either use the \"oninit\" method which will fire " + "only once prior to, and regardless of, any eventual ractive " + "instance being rendered, or if you need to access the " + "rendered DOM, use \"onrender\" instead. " + "See http://docs.ractivejs.org/latest/migrating for more information."
  	},
  	complete: {
  		deprecated: "complete",
  		replacement: "oncomplete"
  	}
  };

  function Hook(event) {
  	this.event = event;
  	this.method = "on" + event;
  	this.deprecate = deprecations[event];
  }

  Hook.prototype.fire = function (ractive, arg) {
  	function call(method) {
  		if (ractive[method]) {
  			arg ? ractive[method](arg) : ractive[method]();
  			return true;
  		}
  	}

  	call(this.method);

  	if (!ractive[this.method] && this.deprecate && call(this.deprecate.deprecated)) {
  		if (this.deprecate.message) {
  			warnIfDebug(this.deprecate.message);
  		} else {
  			warnIfDebug("The method \"%s\" has been deprecated in favor of \"%s\" and will likely be removed in a future release. See http://docs.ractivejs.org/latest/migrating for more information.", this.deprecate.deprecated, this.deprecate.replacement);
  		}
  	}

  	arg ? ractive.fire(this.event, arg) : ractive.fire(this.event);
  };

  var hooks_Hook = Hook;

  function addToArray(array, value) {
  	var index = array.indexOf(value);

  	if (index === -1) {
  		array.push(value);
  	}
  }

  function arrayContains(array, value) {
  	for (var i = 0, c = array.length; i < c; i++) {
  		if (array[i] == value) {
  			return true;
  		}
  	}

  	return false;
  }

  function arrayContentsMatch(a, b) {
  	var i;

  	if (!isArray(a) || !isArray(b)) {
  		return false;
  	}

  	if (a.length !== b.length) {
  		return false;
  	}

  	i = a.length;
  	while (i--) {
  		if (a[i] !== b[i]) {
  			return false;
  		}
  	}

  	return true;
  }

  function ensureArray(x) {
  	if (typeof x === "string") {
  		return [x];
  	}

  	if (x === undefined) {
  		return [];
  	}

  	return x;
  }

  function lastItem(array) {
  	return array[array.length - 1];
  }

  function removeFromArray(array, member) {
  	var index = array.indexOf(member);

  	if (index !== -1) {
  		array.splice(index, 1);
  	}
  }

  function toArray(arrayLike) {
  	var array = [],
  	    i = arrayLike.length;
  	while (i--) {
  		array[i] = arrayLike[i];
  	}

  	return array;
  }

  var _Promise,
      PENDING = {},
      FULFILLED = {},
      REJECTED = {};

  if (typeof Promise === "function") {
  	// use native Promise
  	_Promise = Promise;
  } else {
  	_Promise = function (callback) {
  		var fulfilledHandlers = [],
  		    rejectedHandlers = [],
  		    state = PENDING,
  		    result,
  		    dispatchHandlers,
  		    makeResolver,
  		    fulfil,
  		    reject,
  		    promise;

  		makeResolver = function (newState) {
  			return function (value) {
  				if (state !== PENDING) {
  					return;
  				}

  				result = value;
  				state = newState;

  				dispatchHandlers = makeDispatcher(state === FULFILLED ? fulfilledHandlers : rejectedHandlers, result);

  				// dispatch onFulfilled and onRejected handlers asynchronously
  				wait(dispatchHandlers);
  			};
  		};

  		fulfil = makeResolver(FULFILLED);
  		reject = makeResolver(REJECTED);

  		try {
  			callback(fulfil, reject);
  		} catch (err) {
  			reject(err);
  		}

  		promise = {
  			// `then()` returns a Promise - 2.2.7
  			then: function (onFulfilled, onRejected) {
  				var promise2 = new _Promise(function (fulfil, reject) {

  					var processResolutionHandler = function (handler, handlers, forward) {

  						// 2.2.1.1
  						if (typeof handler === "function") {
  							handlers.push(function (p1result) {
  								var x;

  								try {
  									x = handler(p1result);
  									utils_Promise__resolve(promise2, x, fulfil, reject);
  								} catch (err) {
  									reject(err);
  								}
  							});
  						} else {
  							// Forward the result of promise1 to promise2, if resolution handlers
  							// are not given
  							handlers.push(forward);
  						}
  					};

  					// 2.2
  					processResolutionHandler(onFulfilled, fulfilledHandlers, fulfil);
  					processResolutionHandler(onRejected, rejectedHandlers, reject);

  					if (state !== PENDING) {
  						// If the promise has resolved already, dispatch the appropriate handlers asynchronously
  						wait(dispatchHandlers);
  					}
  				});

  				return promise2;
  			}
  		};

  		promise["catch"] = function (onRejected) {
  			return this.then(null, onRejected);
  		};

  		return promise;
  	};

  	_Promise.all = function (promises) {
  		return new _Promise(function (fulfil, reject) {
  			var result = [],
  			    pending,
  			    i,
  			    processPromise;

  			if (!promises.length) {
  				fulfil(result);
  				return;
  			}

  			processPromise = function (promise, i) {
  				if (promise && typeof promise.then === "function") {
  					promise.then(function (value) {
  						result[i] = value;
  						--pending || fulfil(result);
  					}, reject);
  				} else {
  					result[i] = promise;
  					--pending || fulfil(result);
  				}
  			};

  			pending = i = promises.length;
  			while (i--) {
  				processPromise(promises[i], i);
  			}
  		});
  	};

  	_Promise.resolve = function (value) {
  		return new _Promise(function (fulfil) {
  			fulfil(value);
  		});
  	};

  	_Promise.reject = function (reason) {
  		return new _Promise(function (fulfil, reject) {
  			reject(reason);
  		});
  	};
  }

  var utils_Promise = _Promise;

  // TODO use MutationObservers or something to simulate setImmediate
  function wait(callback) {
  	setTimeout(callback, 0);
  }

  function makeDispatcher(handlers, result) {
  	return function () {
  		var handler;

  		while (handler = handlers.shift()) {
  			handler(result);
  		}
  	};
  }

  function utils_Promise__resolve(promise, x, fulfil, reject) {
  	// Promise Resolution Procedure
  	var then;

  	// 2.3.1
  	if (x === promise) {
  		throw new TypeError("A promise's fulfillment handler cannot return the same promise");
  	}

  	// 2.3.2
  	if (x instanceof _Promise) {
  		x.then(fulfil, reject);
  	}

  	// 2.3.3
  	else if (x && (typeof x === "object" || typeof x === "function")) {
  		try {
  			then = x.then; // 2.3.3.1
  		} catch (e) {
  			reject(e); // 2.3.3.2
  			return;
  		}

  		// 2.3.3.3
  		if (typeof then === "function") {
  			var called, resolvePromise, rejectPromise;

  			resolvePromise = function (y) {
  				if (called) {
  					return;
  				}
  				called = true;
  				utils_Promise__resolve(promise, y, fulfil, reject);
  			};

  			rejectPromise = function (r) {
  				if (called) {
  					return;
  				}
  				called = true;
  				reject(r);
  			};

  			try {
  				then.call(x, resolvePromise, rejectPromise);
  			} catch (e) {
  				if (!called) {
  					// 2.3.3.3.4.1
  					reject(e); // 2.3.3.3.4.2
  					called = true;
  					return;
  				}
  			}
  		} else {
  			fulfil(x);
  		}
  	} else {
  		fulfil(x);
  	}
  }

  var getInnerContext = function (fragment) {
  	do {
  		if (fragment.context !== undefined) {
  			return fragment.context;
  		}
  	} while (fragment = fragment.parent);

  	return rootKeypath;
  };

  var shared_resolveRef = resolveRef;

  function resolveRef(ractive, ref, fragment) {
  	var keypath;

  	ref = normalise(ref);

  	// If a reference begins '~/', it's a top-level reference
  	if (ref.substr(0, 2) === "~/") {
  		keypath = getKeypath(ref.substring(2));
  		createMappingIfNecessary(ractive, keypath.firstKey, fragment);
  	}

  	// If a reference begins with '.', it's either a restricted reference or
  	// an ancestor reference...
  	else if (ref[0] === ".") {
  		keypath = resolveAncestorRef(getInnerContext(fragment), ref);

  		if (keypath) {
  			createMappingIfNecessary(ractive, keypath.firstKey, fragment);
  		}
  	}

  	// ...otherwise we need to figure out the keypath based on context
  	else {
  		keypath = resolveAmbiguousReference(ractive, getKeypath(ref), fragment);
  	}

  	return keypath;
  }

  function resolveAncestorRef(baseContext, ref) {
  	var contextKeys;

  	// TODO...
  	if (baseContext != undefined && typeof baseContext !== "string") {
  		baseContext = baseContext.str;
  	}

  	// {{.}} means 'current context'
  	if (ref === ".") return getKeypath(baseContext);

  	contextKeys = baseContext ? baseContext.split(".") : [];

  	// ancestor references (starting "../") go up the tree
  	if (ref.substr(0, 3) === "../") {
  		while (ref.substr(0, 3) === "../") {
  			if (!contextKeys.length) {
  				throw new Error("Could not resolve reference - too many \"../\" prefixes");
  			}

  			contextKeys.pop();
  			ref = ref.substring(3);
  		}

  		contextKeys.push(ref);
  		return getKeypath(contextKeys.join("."));
  	}

  	// not an ancestor reference - must be a restricted reference (prepended with "." or "./")
  	if (!baseContext) {
  		return getKeypath(ref.replace(/^\.\/?/, ""));
  	}

  	return getKeypath(baseContext + ref.replace(/^\.\//, "."));
  }

  function resolveAmbiguousReference(ractive, ref, fragment, isParentLookup) {
  	var context, key, parentValue, hasContextChain, parentKeypath;

  	if (ref.isRoot) {
  		return ref;
  	}

  	key = ref.firstKey;

  	while (fragment) {
  		context = fragment.context;
  		fragment = fragment.parent;

  		if (!context) {
  			continue;
  		}

  		hasContextChain = true;
  		parentValue = ractive.viewmodel.get(context);

  		if (parentValue && (typeof parentValue === "object" || typeof parentValue === "function") && key in parentValue) {
  			return context.join(ref.str);
  		}
  	}

  	// Root/computed/mapped property?
  	if (isRootProperty(ractive.viewmodel, key)) {
  		return ref;
  	}

  	// If this is an inline component, and it's not isolated, we
  	// can try going up the scope chain
  	if (ractive.parent && !ractive.isolated) {
  		hasContextChain = true;
  		fragment = ractive.component.parentFragment;

  		key = getKeypath(key);

  		if (parentKeypath = resolveAmbiguousReference(ractive.parent, key, fragment, true)) {
  			// We need to create an inter-component binding
  			ractive.viewmodel.map(key, {
  				origin: ractive.parent.viewmodel,
  				keypath: parentKeypath
  			});

  			return ref;
  		}
  	}

  	// If there's no context chain, and the instance is either a) isolated or
  	// b) an orphan, then we know that the keypath is identical to the reference
  	if (!isParentLookup && !hasContextChain) {
  		// the data object needs to have a property by this name,
  		// to prevent future failed lookups
  		ractive.viewmodel.set(ref, undefined);
  		return ref;
  	}
  }

  function createMappingIfNecessary(ractive, key) {
  	var parentKeypath;

  	if (!ractive.parent || ractive.isolated || isRootProperty(ractive.viewmodel, key)) {
  		return;
  	}

  	key = getKeypath(key);

  	if (parentKeypath = resolveAmbiguousReference(ractive.parent, key, ractive.component.parentFragment, true)) {
  		ractive.viewmodel.map(key, {
  			origin: ractive.parent.viewmodel,
  			keypath: parentKeypath
  		});
  	}
  }

  function isRootProperty(viewmodel, key) {
  	// special case for reference to root
  	return key === "" || key in viewmodel.data || key in viewmodel.computations || key in viewmodel.mappings;
  }

  function teardown(x) {
    x.teardown();
  }

  function methodCallers__unbind(x) {
    x.unbind();
  }

  function methodCallers__unrender(x) {
    x.unrender();
  }

  function cancel(x) {
    x.cancel();
  }

  var TransitionManager = function (callback, parent) {
  	this.callback = callback;
  	this.parent = parent;

  	this.intros = [];
  	this.outros = [];

  	this.children = [];
  	this.totalChildren = this.outroChildren = 0;

  	this.detachQueue = [];
  	this.decoratorQueue = [];
  	this.outrosComplete = false;

  	if (parent) {
  		parent.addChild(this);
  	}
  };

  TransitionManager.prototype = {
  	addChild: function (child) {
  		this.children.push(child);

  		this.totalChildren += 1;
  		this.outroChildren += 1;
  	},

  	decrementOutros: function () {
  		this.outroChildren -= 1;
  		check(this);
  	},

  	decrementTotal: function () {
  		this.totalChildren -= 1;
  		check(this);
  	},

  	add: function (transition) {
  		var list = transition.isIntro ? this.intros : this.outros;
  		list.push(transition);
  	},

  	addDecorator: function (decorator) {
  		this.decoratorQueue.push(decorator);
  	},

  	remove: function (transition) {
  		var list = transition.isIntro ? this.intros : this.outros;
  		removeFromArray(list, transition);
  		check(this);
  	},

  	init: function () {
  		this.ready = true;
  		check(this);
  	},

  	detachNodes: function () {
  		this.decoratorQueue.forEach(teardown);
  		this.detachQueue.forEach(detach);
  		this.children.forEach(detachNodes);
  	}
  };

  function detach(element) {
  	element.detach();
  }

  function detachNodes(tm) {
  	tm.detachNodes();
  }

  function check(tm) {
  	if (!tm.ready || tm.outros.length || tm.outroChildren) return;

  	// If all outros are complete, and we haven't already done this,
  	// we notify the parent if there is one, otherwise
  	// start detaching nodes
  	if (!tm.outrosComplete) {
  		if (tm.parent) {
  			tm.parent.decrementOutros(tm);
  		} else {
  			tm.detachNodes();
  		}

  		tm.outrosComplete = true;
  	}

  	// Once everything is done, we can notify parent transition
  	// manager and call the callback
  	if (!tm.intros.length && !tm.totalChildren) {
  		if (typeof tm.callback === "function") {
  			tm.callback();
  		}

  		if (tm.parent) {
  			tm.parent.decrementTotal();
  		}
  	}
  }

  var global_TransitionManager = TransitionManager;

  var batch,
      runloop,
      unresolved = [],
      changeHook = new hooks_Hook("change");

  runloop = {
  	start: function (instance, returnPromise) {
  		var promise, fulfilPromise;

  		if (returnPromise) {
  			promise = new utils_Promise(function (f) {
  				return fulfilPromise = f;
  			});
  		}

  		batch = {
  			previousBatch: batch,
  			transitionManager: new global_TransitionManager(fulfilPromise, batch && batch.transitionManager),
  			views: [],
  			tasks: [],
  			ractives: [],
  			instance: instance
  		};

  		if (instance) {
  			batch.ractives.push(instance);
  		}

  		return promise;
  	},

  	end: function () {
  		flushChanges();

  		batch.transitionManager.init();
  		if (!batch.previousBatch && !!batch.instance) batch.instance.viewmodel.changes = [];
  		batch = batch.previousBatch;
  	},

  	addRactive: function (ractive) {
  		if (batch) {
  			addToArray(batch.ractives, ractive);
  		}
  	},

  	registerTransition: function (transition) {
  		transition._manager = batch.transitionManager;
  		batch.transitionManager.add(transition);
  	},

  	registerDecorator: function (decorator) {
  		batch.transitionManager.addDecorator(decorator);
  	},

  	addView: function (view) {
  		batch.views.push(view);
  	},

  	addUnresolved: function (thing) {
  		unresolved.push(thing);
  	},

  	removeUnresolved: function (thing) {
  		removeFromArray(unresolved, thing);
  	},

  	// synchronise node detachments with transition ends
  	detachWhenReady: function (thing) {
  		batch.transitionManager.detachQueue.push(thing);
  	},

  	scheduleTask: function (task, postRender) {
  		var _batch;

  		if (!batch) {
  			task();
  		} else {
  			_batch = batch;
  			while (postRender && _batch.previousBatch) {
  				// this can't happen until the DOM has been fully updated
  				// otherwise in some situations (with components inside elements)
  				// transitions and decorators will initialise prematurely
  				_batch = _batch.previousBatch;
  			}

  			_batch.tasks.push(task);
  		}
  	}
  };

  var global_runloop = runloop;

  function flushChanges() {
  	var i, thing, changeHash;

  	while (batch.ractives.length) {
  		thing = batch.ractives.pop();
  		changeHash = thing.viewmodel.applyChanges();

  		if (changeHash) {
  			changeHook.fire(thing, changeHash);
  		}
  	}

  	attemptKeypathResolution();

  	// Now that changes have been fully propagated, we can update the DOM
  	// and complete other tasks
  	for (i = 0; i < batch.views.length; i += 1) {
  		batch.views[i].update();
  	}
  	batch.views.length = 0;

  	for (i = 0; i < batch.tasks.length; i += 1) {
  		batch.tasks[i]();
  	}
  	batch.tasks.length = 0;

  	// If updating the view caused some model blowback - e.g. a triple
  	// containing <option> elements caused the binding on the <select>
  	// to update - then we start over
  	if (batch.ractives.length) return flushChanges();
  }

  function attemptKeypathResolution() {
  	var i, item, keypath, resolved;

  	i = unresolved.length;

  	// see if we can resolve any unresolved references
  	while (i--) {
  		item = unresolved[i];

  		if (item.keypath) {
  			// it resolved some other way. TODO how? two-way binding? Seems
  			// weird that we'd still end up here
  			unresolved.splice(i, 1);
  			continue; // avoid removing the wrong thing should the next condition be true
  		}

  		if (keypath = shared_resolveRef(item.root, item.ref, item.parentFragment)) {
  			(resolved || (resolved = [])).push({
  				item: item,
  				keypath: keypath
  			});

  			unresolved.splice(i, 1);
  		}
  	}

  	if (resolved) {
  		resolved.forEach(global_runloop__resolve);
  	}
  }

  function global_runloop__resolve(resolved) {
  	resolved.item.resolve(resolved.keypath);
  }

  var queue = [];

  var animations = {
  	tick: function () {
  		var i, animation, now;

  		now = utils_getTime();

  		global_runloop.start();

  		for (i = 0; i < queue.length; i += 1) {
  			animation = queue[i];

  			if (!animation.tick(now)) {
  				// animation is complete, remove it from the stack, and decrement i so we don't miss one
  				queue.splice(i--, 1);
  			}
  		}

  		global_runloop.end();

  		if (queue.length) {
  			rAF(animations.tick);
  		} else {
  			animations.running = false;
  		}
  	},

  	add: function (animation) {
  		queue.push(animation);

  		if (!animations.running) {
  			animations.running = true;
  			rAF(animations.tick);
  		}
  	},

  	// TODO optimise this
  	abort: function (keypath, root) {
  		var i = queue.length,
  		    animation;

  		while (i--) {
  			animation = queue[i];

  			if (animation.root === root && animation.keypath === keypath) {
  				animation.stop();
  			}
  		}
  	}
  };

  var shared_animations = animations;

  var Animation = function (options) {
  	var key;

  	this.startTime = Date.now();

  	// from and to
  	for (key in options) {
  		if (options.hasOwnProperty(key)) {
  			this[key] = options[key];
  		}
  	}

  	this.interpolator = shared_interpolate(this.from, this.to, this.root, this.interpolator);
  	this.running = true;

  	this.tick();
  };

  Animation.prototype = {
  	tick: function () {
  		var elapsed, t, value, timeNow, index, keypath;

  		keypath = this.keypath;

  		if (this.running) {
  			timeNow = Date.now();
  			elapsed = timeNow - this.startTime;

  			if (elapsed >= this.duration) {
  				if (keypath !== null) {
  					global_runloop.start(this.root);
  					this.root.viewmodel.set(keypath, this.to);
  					global_runloop.end();
  				}

  				if (this.step) {
  					this.step(1, this.to);
  				}

  				this.complete(this.to);

  				index = this.root._animations.indexOf(this);

  				// TODO investigate why this happens
  				if (index === -1) {
  					warnIfDebug("Animation was not found");
  				}

  				this.root._animations.splice(index, 1);

  				this.running = false;
  				return false; // remove from the stack
  			}

  			t = this.easing ? this.easing(elapsed / this.duration) : elapsed / this.duration;

  			if (keypath !== null) {
  				value = this.interpolator(t);
  				global_runloop.start(this.root);
  				this.root.viewmodel.set(keypath, value);
  				global_runloop.end();
  			}

  			if (this.step) {
  				this.step(t, value);
  			}

  			return true; // keep in the stack
  		}

  		return false; // remove from the stack
  	},

  	stop: function () {
  		var index;

  		this.running = false;

  		index = this.root._animations.indexOf(this);

  		// TODO investigate why this happens
  		if (index === -1) {
  			warnIfDebug("Animation was not found");
  		}

  		this.root._animations.splice(index, 1);
  	}
  };

  var animate_Animation = Animation;

  var prototype_animate = Ractive$animate;

  var noAnimation = { stop: noop };
  function Ractive$animate(keypath, to, options) {
  	var promise, fulfilPromise, k, animation, animations, easing, duration, step, complete, makeValueCollector, currentValues, collectValue, dummy, dummyOptions;

  	promise = new utils_Promise(function (fulfil) {
  		return fulfilPromise = fulfil;
  	});

  	// animate multiple keypaths
  	if (typeof keypath === "object") {
  		options = to || {};
  		easing = options.easing;
  		duration = options.duration;

  		animations = [];

  		// we don't want to pass the `step` and `complete` handlers, as they will
  		// run for each animation! So instead we'll store the handlers and create
  		// our own...
  		step = options.step;
  		complete = options.complete;

  		if (step || complete) {
  			currentValues = {};

  			options.step = null;
  			options.complete = null;

  			makeValueCollector = function (keypath) {
  				return function (t, value) {
  					currentValues[keypath] = value;
  				};
  			};
  		}

  		for (k in keypath) {
  			if (keypath.hasOwnProperty(k)) {
  				if (step || complete) {
  					collectValue = makeValueCollector(k);
  					options = { easing: easing, duration: duration };

  					if (step) {
  						options.step = collectValue;
  					}
  				}

  				options.complete = complete ? collectValue : noop;
  				animations.push(animate(this, k, keypath[k], options));
  			}
  		}

  		// Create a dummy animation, to facilitate step/complete
  		// callbacks, and Promise fulfilment
  		dummyOptions = { easing: easing, duration: duration };

  		if (step) {
  			dummyOptions.step = function (t) {
  				return step(t, currentValues);
  			};
  		}

  		if (complete) {
  			promise.then(function (t) {
  				return complete(t, currentValues);
  			});
  		}

  		dummyOptions.complete = fulfilPromise;

  		dummy = animate(this, null, null, dummyOptions);
  		animations.push(dummy);

  		promise.stop = function () {
  			var animation;

  			while (animation = animations.pop()) {
  				animation.stop();
  			}

  			if (dummy) {
  				dummy.stop();
  			}
  		};

  		return promise;
  	}

  	// animate a single keypath
  	options = options || {};

  	if (options.complete) {
  		promise.then(options.complete);
  	}

  	options.complete = fulfilPromise;
  	animation = animate(this, keypath, to, options);

  	promise.stop = function () {
  		return animation.stop();
  	};
  	return promise;
  }

  function animate(root, keypath, to, options) {
  	var easing, duration, animation, from;

  	if (keypath) {
  		keypath = getKeypath(normalise(keypath));
  	}

  	if (keypath !== null) {
  		from = root.viewmodel.get(keypath);
  	}

  	// cancel any existing animation
  	// TODO what about upstream/downstream keypaths?
  	shared_animations.abort(keypath, root);

  	// don't bother animating values that stay the same
  	if (isEqual(from, to)) {
  		if (options.complete) {
  			options.complete(options.to);
  		}

  		return noAnimation;
  	}

  	// easing function
  	if (options.easing) {
  		if (typeof options.easing === "function") {
  			easing = options.easing;
  		} else {
  			easing = root.easing[options.easing];
  		}

  		if (typeof easing !== "function") {
  			easing = null;
  		}
  	}

  	// duration
  	duration = options.duration === undefined ? 400 : options.duration;

  	// TODO store keys, use an internal set method
  	animation = new animate_Animation({
  		keypath: keypath,
  		from: from,
  		to: to,
  		root: root,
  		duration: duration,
  		easing: easing,
  		interpolator: options.interpolator,

  		// TODO wrap callbacks if necessary, to use instance as context
  		step: options.step,
  		complete: options.complete
  	});

  	shared_animations.add(animation);
  	root._animations.push(animation);

  	return animation;
  }

  var prototype_detach = Ractive$detach;
  var prototype_detach__detachHook = new hooks_Hook("detach");
  function Ractive$detach() {
  	if (this.detached) {
  		return this.detached;
  	}

  	if (this.el) {
  		removeFromArray(this.el.__ractive_instances__, this);
  	}
  	this.detached = this.fragment.detach();
  	prototype_detach__detachHook.fire(this);
  	return this.detached;
  }

  var prototype_find = Ractive$find;

  function Ractive$find(selector) {
  	if (!this.el) {
  		return null;
  	}

  	return this.fragment.find(selector);
  }

  var test = Query$test;
  function Query$test(item, noDirty) {
  	var itemMatches;

  	if (this._isComponentQuery) {
  		itemMatches = !this.selector || item.name === this.selector;
  	} else {
  		itemMatches = item.node ? matches(item.node, this.selector) : null;
  	}

  	if (itemMatches) {
  		this.push(item.node || item.instance);

  		if (!noDirty) {
  			this._makeDirty();
  		}

  		return true;
  	}
  }

  var makeQuery_cancel = function () {
  	var liveQueries, selector, index;

  	liveQueries = this._root[this._isComponentQuery ? "liveComponentQueries" : "liveQueries"];
  	selector = this.selector;

  	index = liveQueries.indexOf(selector);

  	if (index !== -1) {
  		liveQueries.splice(index, 1);
  		liveQueries[selector] = null;
  	}
  };

  var sortByItemPosition = function (a, b) {
  	var ancestryA, ancestryB, oldestA, oldestB, mutualAncestor, indexA, indexB, fragments, fragmentA, fragmentB;

  	ancestryA = getAncestry(a.component || a._ractive.proxy);
  	ancestryB = getAncestry(b.component || b._ractive.proxy);

  	oldestA = lastItem(ancestryA);
  	oldestB = lastItem(ancestryB);

  	// remove items from the end of both ancestries as long as they are identical
  	// - the final one removed is the closest mutual ancestor
  	while (oldestA && oldestA === oldestB) {
  		ancestryA.pop();
  		ancestryB.pop();

  		mutualAncestor = oldestA;

  		oldestA = lastItem(ancestryA);
  		oldestB = lastItem(ancestryB);
  	}

  	// now that we have the mutual ancestor, we can find which is earliest
  	oldestA = oldestA.component || oldestA;
  	oldestB = oldestB.component || oldestB;

  	fragmentA = oldestA.parentFragment;
  	fragmentB = oldestB.parentFragment;

  	// if both items share a parent fragment, our job is easy
  	if (fragmentA === fragmentB) {
  		indexA = fragmentA.items.indexOf(oldestA);
  		indexB = fragmentB.items.indexOf(oldestB);

  		// if it's the same index, it means one contains the other,
  		// so we see which has the longest ancestry
  		return indexA - indexB || ancestryA.length - ancestryB.length;
  	}

  	// if mutual ancestor is a section, we first test to see which section
  	// fragment comes first
  	if (fragments = mutualAncestor.fragments) {
  		indexA = fragments.indexOf(fragmentA);
  		indexB = fragments.indexOf(fragmentB);

  		return indexA - indexB || ancestryA.length - ancestryB.length;
  	}

  	throw new Error("An unexpected condition was met while comparing the position of two components. Please file an issue at https://github.com/RactiveJS/Ractive/issues - thanks!");
  };

  function getParent(item) {
  	var parentFragment;

  	if (parentFragment = item.parentFragment) {
  		return parentFragment.owner;
  	}

  	if (item.component && (parentFragment = item.component.parentFragment)) {
  		return parentFragment.owner;
  	}
  }

  function getAncestry(item) {
  	var ancestry, ancestor;

  	ancestry = [item];

  	ancestor = getParent(item);

  	while (ancestor) {
  		ancestry.push(ancestor);
  		ancestor = getParent(ancestor);
  	}

  	return ancestry;
  }

  var sortByDocumentPosition = function (node, otherNode) {
  	var bitmask;

  	if (node.compareDocumentPosition) {
  		bitmask = node.compareDocumentPosition(otherNode);
  		return bitmask & 2 ? 1 : -1;
  	}

  	// In old IE, we can piggy back on the mechanism for
  	// comparing component positions
  	return sortByItemPosition(node, otherNode);
  };

  var sort = function () {
  	this.sort(this._isComponentQuery ? sortByItemPosition : sortByDocumentPosition);
  	this._dirty = false;
  };

  var makeQuery_dirty = function () {
  	var _this = this;

  	if (!this._dirty) {
  		this._dirty = true;

  		// Once the DOM has been updated, ensure the query
  		// is correctly ordered
  		global_runloop.scheduleTask(function () {
  			_this._sort();
  		});
  	}
  };

  var remove = function (nodeOrComponent) {
  	var index = this.indexOf(this._isComponentQuery ? nodeOrComponent.instance : nodeOrComponent);

  	if (index !== -1) {
  		this.splice(index, 1);
  	}
  };

  var _makeQuery = makeQuery;
  function makeQuery(ractive, selector, live, isComponentQuery) {
  	var query = [];

  	defineProperties(query, {
  		selector: { value: selector },
  		live: { value: live },

  		_isComponentQuery: { value: isComponentQuery },
  		_test: { value: test }
  	});

  	if (!live) {
  		return query;
  	}

  	defineProperties(query, {
  		cancel: { value: makeQuery_cancel },

  		_root: { value: ractive },
  		_sort: { value: sort },
  		_makeDirty: { value: makeQuery_dirty },
  		_remove: { value: remove },

  		_dirty: { value: false, writable: true }
  	});

  	return query;
  }

  var prototype_findAll = Ractive$findAll;
  function Ractive$findAll(selector, options) {
  	var liveQueries, query;

  	if (!this.el) {
  		return [];
  	}

  	options = options || {};
  	liveQueries = this._liveQueries;

  	// Shortcut: if we're maintaining a live query with this
  	// selector, we don't need to traverse the parallel DOM
  	if (query = liveQueries[selector]) {

  		// Either return the exact same query, or (if not live) a snapshot
  		return options && options.live ? query : query.slice();
  	}

  	query = _makeQuery(this, selector, !!options.live, false);

  	// Add this to the list of live queries Ractive needs to maintain,
  	// if applicable
  	if (query.live) {
  		liveQueries.push(selector);
  		liveQueries["_" + selector] = query;
  	}

  	this.fragment.findAll(selector, query);
  	return query;
  }

  var prototype_findAllComponents = Ractive$findAllComponents;
  function Ractive$findAllComponents(selector, options) {
  	var liveQueries, query;

  	options = options || {};
  	liveQueries = this._liveComponentQueries;

  	// Shortcut: if we're maintaining a live query with this
  	// selector, we don't need to traverse the parallel DOM
  	if (query = liveQueries[selector]) {

  		// Either return the exact same query, or (if not live) a snapshot
  		return options && options.live ? query : query.slice();
  	}

  	query = _makeQuery(this, selector, !!options.live, true);

  	// Add this to the list of live queries Ractive needs to maintain,
  	// if applicable
  	if (query.live) {
  		liveQueries.push(selector);
  		liveQueries["_" + selector] = query;
  	}

  	this.fragment.findAllComponents(selector, query);
  	return query;
  }

  var prototype_findComponent = Ractive$findComponent;

  function Ractive$findComponent(selector) {
  	return this.fragment.findComponent(selector);
  }

  var findContainer = Ractive$findContainer;

  function Ractive$findContainer(selector) {
  	if (this.container) {
  		if (this.container.component && this.container.component.name === selector) {
  			return this.container;
  		} else {
  			return this.container.findContainer(selector);
  		}
  	}

  	return null;
  }

  var findParent = Ractive$findParent;

  function Ractive$findParent(selector) {

  	if (this.parent) {
  		if (this.parent.component && this.parent.component.name === selector) {
  			return this.parent;
  		} else {
  			return this.parent.findParent(selector);
  		}
  	}

  	return null;
  }

  var eventStack = {
  	enqueue: function (ractive, event) {
  		if (ractive.event) {
  			ractive._eventQueue = ractive._eventQueue || [];
  			ractive._eventQueue.push(ractive.event);
  		}
  		ractive.event = event;
  	},
  	dequeue: function (ractive) {
  		if (ractive._eventQueue && ractive._eventQueue.length) {
  			ractive.event = ractive._eventQueue.pop();
  		} else {
  			delete ractive.event;
  		}
  	}
  };

  var shared_eventStack = eventStack;

  var shared_fireEvent = fireEvent;

  function fireEvent(ractive, eventName) {
  	var options = arguments[2] === undefined ? {} : arguments[2];

  	if (!eventName) {
  		return;
  	}

  	if (!options.event) {
  		options.event = {
  			name: eventName,
  			// until event not included as argument default
  			_noArg: true
  		};
  	} else {
  		options.event.name = eventName;
  	}

  	var eventNames = getKeypath(eventName).wildcardMatches();
  	fireEventAs(ractive, eventNames, options.event, options.args, true);
  }

  function fireEventAs(ractive, eventNames, event, args) {
  	var initialFire = arguments[4] === undefined ? false : arguments[4];

  	var subscribers,
  	    i,
  	    bubble = true;

  	shared_eventStack.enqueue(ractive, event);

  	for (i = eventNames.length; i >= 0; i--) {
  		subscribers = ractive._subs[eventNames[i]];

  		if (subscribers) {
  			bubble = notifySubscribers(ractive, subscribers, event, args) && bubble;
  		}
  	}

  	shared_eventStack.dequeue(ractive);

  	if (ractive.parent && bubble) {

  		if (initialFire && ractive.component) {
  			var fullName = ractive.component.name + "." + eventNames[eventNames.length - 1];
  			eventNames = getKeypath(fullName).wildcardMatches();

  			if (event) {
  				event.component = ractive;
  			}
  		}

  		fireEventAs(ractive.parent, eventNames, event, args);
  	}
  }

  function notifySubscribers(ractive, subscribers, event, args) {
  	var originalEvent = null,
  	    stopEvent = false;

  	if (event && !event._noArg) {
  		args = [event].concat(args);
  	}

  	// subscribers can be modified inflight, e.g. "once" functionality
  	// so we need to copy to make sure everyone gets called
  	subscribers = subscribers.slice();

  	for (var i = 0, len = subscribers.length; i < len; i += 1) {
  		if (subscribers[i].apply(ractive, args) === false) {
  			stopEvent = true;
  		}
  	}

  	if (event && !event._noArg && stopEvent && (originalEvent = event.original)) {
  		originalEvent.preventDefault && originalEvent.preventDefault();
  		originalEvent.stopPropagation && originalEvent.stopPropagation();
  	}

  	return !stopEvent;
  }

  var prototype_fire = Ractive$fire;
  function Ractive$fire(eventName) {

  	var options = {
  		args: Array.prototype.slice.call(arguments, 1)
  	};

  	shared_fireEvent(this, eventName, options);
  }

  var prototype_get = Ractive$get;
  var options = {
  	capture: true, // top-level calls should be intercepted
  	noUnwrap: true, // wrapped values should NOT be unwrapped
  	fullRootGet: true // root get should return mappings
  };
  function Ractive$get(keypath) {
  	var value;

  	keypath = getKeypath(normalise(keypath));
  	value = this.viewmodel.get(keypath, options);

  	// Create inter-component binding, if necessary
  	if (value === undefined && this.parent && !this.isolated) {
  		if (shared_resolveRef(this, keypath.str, this.component.parentFragment)) {
  			// creates binding as side-effect, if appropriate
  			value = this.viewmodel.get(keypath);
  		}
  	}

  	return value;
  }

  var insert = Ractive$insert;

  var insertHook = new hooks_Hook("insert");
  function Ractive$insert(target, anchor) {
  	if (!this.fragment.rendered) {
  		// TODO create, and link to, documentation explaining this
  		throw new Error("The API has changed - you must call `ractive.render(target[, anchor])` to render your Ractive instance. Once rendered you can use `ractive.insert()`.");
  	}

  	target = getElement(target);
  	anchor = getElement(anchor) || null;

  	if (!target) {
  		throw new Error("You must specify a valid target to insert into");
  	}

  	target.insertBefore(this.detach(), anchor);
  	this.el = target;

  	(target.__ractive_instances__ || (target.__ractive_instances__ = [])).push(this);
  	this.detached = null;

  	fireInsertHook(this);
  }

  function fireInsertHook(ractive) {
  	insertHook.fire(ractive);

  	ractive.findAllComponents("*").forEach(function (child) {
  		fireInsertHook(child.instance);
  	});
  }

  var prototype_merge = Ractive$merge;
  function Ractive$merge(keypath, array, options) {
  	var currentArray, promise;

  	keypath = getKeypath(normalise(keypath));
  	currentArray = this.viewmodel.get(keypath);

  	// If either the existing value or the new value isn't an
  	// array, just do a regular set
  	if (!isArray(currentArray) || !isArray(array)) {
  		return this.set(keypath, array, options && options.complete);
  	}

  	// Manage transitions
  	promise = global_runloop.start(this, true);
  	this.viewmodel.merge(keypath, currentArray, array, options);
  	global_runloop.end();

  	return promise;
  }

  var Observer = function (ractive, keypath, callback, options) {
  	this.root = ractive;
  	this.keypath = keypath;
  	this.callback = callback;
  	this.defer = options.defer;

  	// default to root as context, but allow it to be overridden
  	this.context = options && options.context ? options.context : ractive;
  };

  Observer.prototype = {
  	init: function (immediate) {
  		this.value = this.root.get(this.keypath.str);

  		if (immediate !== false) {
  			this.update();
  		} else {
  			this.oldValue = this.value;
  		}
  	},

  	setValue: function (value) {
  		var _this = this;

  		if (!isEqual(value, this.value)) {
  			this.value = value;

  			if (this.defer && this.ready) {
  				global_runloop.scheduleTask(function () {
  					return _this.update();
  				});
  			} else {
  				this.update();
  			}
  		}
  	},

  	update: function () {
  		// Prevent infinite loops
  		if (this.updating) {
  			return;
  		}

  		this.updating = true;

  		this.callback.call(this.context, this.value, this.oldValue, this.keypath.str);
  		this.oldValue = this.value;

  		this.updating = false;
  	}
  };

  var observe_Observer = Observer;

  var observe_getPattern = getPattern;
  function getPattern(ractive, pattern) {
  	var matchingKeypaths, values;

  	matchingKeypaths = getMatchingKeypaths(ractive, pattern);

  	values = {};
  	matchingKeypaths.forEach(function (keypath) {
  		values[keypath.str] = ractive.get(keypath.str);
  	});

  	return values;
  }

  var PatternObserver,
      slice = Array.prototype.slice;

  PatternObserver = function (ractive, keypath, callback, options) {
  	this.root = ractive;

  	this.callback = callback;
  	this.defer = options.defer;

  	this.keypath = keypath;
  	this.regex = new RegExp("^" + keypath.str.replace(/\./g, "\\.").replace(/\*/g, "([^\\.]+)") + "$");
  	this.values = {};

  	if (this.defer) {
  		this.proxies = [];
  	}

  	// default to root as context, but allow it to be overridden
  	this.context = options && options.context ? options.context : ractive;
  };

  PatternObserver.prototype = {
  	init: function (immediate) {
  		var values, keypath;

  		values = observe_getPattern(this.root, this.keypath);

  		if (immediate !== false) {
  			for (keypath in values) {
  				if (values.hasOwnProperty(keypath)) {
  					this.update(getKeypath(keypath));
  				}
  			}
  		} else {
  			this.values = values;
  		}
  	},

  	update: function (keypath) {
  		var _this = this;

  		var values;

  		if (keypath.isPattern) {
  			values = observe_getPattern(this.root, keypath);

  			for (keypath in values) {
  				if (values.hasOwnProperty(keypath)) {
  					this.update(getKeypath(keypath));
  				}
  			}

  			return;
  		}

  		// special case - array mutation should not trigger `array.*`
  		// pattern observer with `array.length`
  		if (this.root.viewmodel.implicitChanges[keypath.str]) {
  			return;
  		}

  		if (this.defer && this.ready) {
  			global_runloop.scheduleTask(function () {
  				return _this.getProxy(keypath).update();
  			});
  			return;
  		}

  		this.reallyUpdate(keypath);
  	},

  	reallyUpdate: function (keypath) {
  		var keypathStr, value, keys, args;

  		keypathStr = keypath.str;
  		value = this.root.viewmodel.get(keypath);

  		// Prevent infinite loops
  		if (this.updating) {
  			this.values[keypathStr] = value;
  			return;
  		}

  		this.updating = true;

  		if (!isEqual(value, this.values[keypathStr]) || !this.ready) {
  			keys = slice.call(this.regex.exec(keypathStr), 1);
  			args = [value, this.values[keypathStr], keypathStr].concat(keys);

  			this.values[keypathStr] = value;
  			this.callback.apply(this.context, args);
  		}

  		this.updating = false;
  	},

  	getProxy: function (keypath) {
  		var _this = this;

  		if (!this.proxies[keypath.str]) {
  			this.proxies[keypath.str] = {
  				update: function () {
  					return _this.reallyUpdate(keypath);
  				}
  			};
  		}

  		return this.proxies[keypath.str];
  	}
  };

  var observe_PatternObserver = PatternObserver;

  var observe_getObserverFacade = getObserverFacade;
  var emptyObject = {};
  function getObserverFacade(ractive, keypath, callback, options) {
  	var observer, isPatternObserver, cancelled;

  	keypath = getKeypath(normalise(keypath));
  	options = options || emptyObject;

  	// pattern observers are treated differently
  	if (keypath.isPattern) {
  		observer = new observe_PatternObserver(ractive, keypath, callback, options);
  		ractive.viewmodel.patternObservers.push(observer);
  		isPatternObserver = true;
  	} else {
  		observer = new observe_Observer(ractive, keypath, callback, options);
  	}

  	observer.init(options.init);
  	ractive.viewmodel.register(keypath, observer, isPatternObserver ? "patternObservers" : "observers");

  	// This flag allows observers to initialise even with undefined values
  	observer.ready = true;

  	var facade = {
  		cancel: function () {
  			var index;

  			if (cancelled) {
  				return;
  			}

  			if (isPatternObserver) {
  				index = ractive.viewmodel.patternObservers.indexOf(observer);

  				ractive.viewmodel.patternObservers.splice(index, 1);
  				ractive.viewmodel.unregister(keypath, observer, "patternObservers");
  			} else {
  				ractive.viewmodel.unregister(keypath, observer, "observers");
  			}
  			cancelled = true;
  		}
  	};

  	ractive._observers.push(facade);
  	return facade;
  }

  var observe = Ractive$observe;
  function Ractive$observe(keypath, callback, options) {

  	var observers, map, keypaths, i;

  	// Allow a map of keypaths to handlers
  	if (isObject(keypath)) {
  		options = callback;
  		map = keypath;

  		observers = [];

  		for (keypath in map) {
  			if (map.hasOwnProperty(keypath)) {
  				callback = map[keypath];
  				observers.push(this.observe(keypath, callback, options));
  			}
  		}

  		return {
  			cancel: function () {
  				while (observers.length) {
  					observers.pop().cancel();
  				}
  			}
  		};
  	}

  	// Allow `ractive.observe( callback )` - i.e. observe entire model
  	if (typeof keypath === "function") {
  		options = callback;
  		callback = keypath;
  		keypath = "";

  		return observe_getObserverFacade(this, keypath, callback, options);
  	}

  	keypaths = keypath.split(" ");

  	// Single keypath
  	if (keypaths.length === 1) {
  		return observe_getObserverFacade(this, keypath, callback, options);
  	}

  	// Multiple space-separated keypaths
  	observers = [];

  	i = keypaths.length;
  	while (i--) {
  		keypath = keypaths[i];

  		if (keypath) {
  			observers.push(observe_getObserverFacade(this, keypath, callback, options));
  		}
  	}

  	return {
  		cancel: function () {
  			while (observers.length) {
  				observers.pop().cancel();
  			}
  		}
  	};
  }

  var observeOnce = Ractive$observeOnce;

  function Ractive$observeOnce(property, callback, options) {

  	var observer = this.observe(property, function () {
  		callback.apply(this, arguments);
  		observer.cancel();
  	}, { init: false, defer: options && options.defer });

  	return observer;
  }

  var shared_trim = function (str) {
    return str.trim();
  };

  var notEmptyString = function (str) {
    return str !== "";
  };

  var off = Ractive$off;
  function Ractive$off(eventName, callback) {
  	var _this = this;

  	var eventNames;

  	// if no arguments specified, remove all callbacks
  	if (!eventName) {
  		// TODO use this code instead, once the following issue has been resolved
  		// in PhantomJS (tests are unpassable otherwise!)
  		// https://github.com/ariya/phantomjs/issues/11856
  		// defineProperty( this, '_subs', { value: create( null ), configurable: true });
  		for (eventName in this._subs) {
  			delete this._subs[eventName];
  		}
  	} else {
  		// Handle multiple space-separated event names
  		eventNames = eventName.split(" ").map(shared_trim).filter(notEmptyString);

  		eventNames.forEach(function (eventName) {
  			var subscribers, index;

  			// If we have subscribers for this event...
  			if (subscribers = _this._subs[eventName]) {
  				// ...if a callback was specified, only remove that
  				if (callback) {
  					index = subscribers.indexOf(callback);
  					if (index !== -1) {
  						subscribers.splice(index, 1);
  					}
  				}

  				// ...otherwise remove all callbacks
  				else {
  					_this._subs[eventName] = [];
  				}
  			}
  		});
  	}

  	return this;
  }

  var on = Ractive$on;
  function Ractive$on(eventName, callback) {
  	var _this = this;

  	var listeners, n, eventNames;

  	// allow mutliple listeners to be bound in one go
  	if (typeof eventName === "object") {
  		listeners = [];

  		for (n in eventName) {
  			if (eventName.hasOwnProperty(n)) {
  				listeners.push(this.on(n, eventName[n]));
  			}
  		}

  		return {
  			cancel: function () {
  				var listener;

  				while (listener = listeners.pop()) {
  					listener.cancel();
  				}
  			}
  		};
  	}

  	// Handle multiple space-separated event names
  	eventNames = eventName.split(" ").map(shared_trim).filter(notEmptyString);

  	eventNames.forEach(function (eventName) {
  		(_this._subs[eventName] || (_this._subs[eventName] = [])).push(callback);
  	});

  	return {
  		cancel: function () {
  			return _this.off(eventName, callback);
  		}
  	};
  }

  var once = Ractive$once;

  function Ractive$once(eventName, handler) {

  	var listener = this.on(eventName, function () {
  		handler.apply(this, arguments);
  		listener.cancel();
  	});

  	// so we can still do listener.cancel() manually
  	return listener;
  }

  // This function takes an array, the name of a mutator method, and the
  // arguments to call that mutator method with, and returns an array that
  // maps the old indices to their new indices.

  // So if you had something like this...
  //
  //     array = [ 'a', 'b', 'c', 'd' ];
  //     array.push( 'e' );
  //
  // ...you'd get `[ 0, 1, 2, 3 ]` - in other words, none of the old indices
  // have changed. If you then did this...
  //
  //     array.unshift( 'z' );
  //
  // ...the indices would be `[ 1, 2, 3, 4, 5 ]` - every item has been moved
  // one higher to make room for the 'z'. If you removed an item, the new index
  // would be -1...
  //
  //     array.splice( 2, 2 );
  //
  // ...this would result in [ 0, 1, -1, -1, 2, 3 ].
  //
  // This information is used to enable fast, non-destructive shuffling of list
  // sections when you do e.g. `ractive.splice( 'items', 2, 2 );

  var shared_getNewIndices = getNewIndices;

  function getNewIndices(array, methodName, args) {
  	var spliceArguments,
  	    len,
  	    newIndices = [],
  	    removeStart,
  	    removeEnd,
  	    balance,
  	    i;

  	spliceArguments = getSpliceEquivalent(array, methodName, args);

  	if (!spliceArguments) {
  		return null; // TODO support reverse and sort?
  	}

  	len = array.length;
  	balance = spliceArguments.length - 2 - spliceArguments[1];

  	removeStart = Math.min(len, spliceArguments[0]);
  	removeEnd = removeStart + spliceArguments[1];

  	for (i = 0; i < removeStart; i += 1) {
  		newIndices.push(i);
  	}

  	for (; i < removeEnd; i += 1) {
  		newIndices.push(-1);
  	}

  	for (; i < len; i += 1) {
  		newIndices.push(i + balance);
  	}

  	// there is a net shift for the rest of the array starting with index + balance
  	if (balance !== 0) {
  		newIndices.touchedFrom = spliceArguments[0];
  	} else {
  		newIndices.touchedFrom = array.length;
  	}

  	return newIndices;
  }

  // The pop, push, shift an unshift methods can all be represented
  // as an equivalent splice
  function getSpliceEquivalent(array, methodName, args) {
  	switch (methodName) {
  		case "splice":
  			if (args[0] !== undefined && args[0] < 0) {
  				args[0] = array.length + Math.max(args[0], -array.length);
  			}

  			while (args.length < 2) {
  				args.push(0);
  			}

  			// ensure we only remove elements that exist
  			args[1] = Math.min(args[1], array.length - args[0]);

  			return args;

  		case "sort":
  		case "reverse":
  			return null;

  		case "pop":
  			if (array.length) {
  				return [array.length - 1, 1];
  			}
  			return [0, 0];

  		case "push":
  			return [array.length, 0].concat(args);

  		case "shift":
  			return [0, array.length ? 1 : 0];

  		case "unshift":
  			return [0, 0].concat(args);
  	}
  }

  var arrayProto = Array.prototype;

  var makeArrayMethod = function (methodName) {
  	return function (keypath) {
  		for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
  			args[_key - 1] = arguments[_key];
  		}

  		var array,
  		    newIndices = [],
  		    len,
  		    promise,
  		    result;

  		keypath = getKeypath(normalise(keypath));

  		array = this.viewmodel.get(keypath);
  		len = array.length;

  		if (!isArray(array)) {
  			throw new Error("Called ractive." + methodName + "('" + keypath.str + "'), but '" + keypath.str + "' does not refer to an array");
  		}

  		newIndices = shared_getNewIndices(array, methodName, args);

  		result = arrayProto[methodName].apply(array, args);
  		promise = global_runloop.start(this, true).then(function () {
  			return result;
  		});

  		if (!!newIndices) {
  			this.viewmodel.smartUpdate(keypath, array, newIndices);
  		} else {
  			this.viewmodel.mark(keypath);
  		}

  		global_runloop.end();

  		return promise;
  	};
  };

  var pop = makeArrayMethod("pop");

  var push = makeArrayMethod("push");

  var css,
      update,
      styleElement,
      head,
      styleSheet,
      inDom,
      global_css__prefix = "/* Ractive.js component styles */\n",
      styles = [],
      dirty = false;

  if (!isClient) {
  	// TODO handle encapsulated CSS in server-rendered HTML!
  	css = {
  		add: noop,
  		apply: noop
  	};
  } else {
  	styleElement = document.createElement("style");
  	styleElement.type = "text/css";

  	head = document.getElementsByTagName("head")[0];

  	inDom = false;

  	// Internet Exploder won't let you use styleSheet.innerHTML - we have to
  	// use styleSheet.cssText instead
  	styleSheet = styleElement.styleSheet;

  	update = function () {
  		var css = global_css__prefix + styles.map(function (s) {
  			return "\n/* {" + s.id + "} */\n" + s.styles;
  		}).join("\n");

  		if (styleSheet) {
  			styleSheet.cssText = css;
  		} else {
  			styleElement.innerHTML = css;
  		}

  		if (!inDom) {
  			head.appendChild(styleElement);
  			inDom = true;
  		}
  	};

  	css = {
  		add: function (s) {
  			styles.push(s);
  			dirty = true;
  		},

  		apply: function () {
  			if (dirty) {
  				update();
  				dirty = false;
  			}
  		}
  	};
  }

  var global_css = css;

  var prototype_render = Ractive$render;

  var renderHook = new hooks_Hook("render"),
      completeHook = new hooks_Hook("complete");
  function Ractive$render(target, anchor) {
  	var _this = this;

  	var promise, instances, transitionsEnabled;

  	// if `noIntro` is `true`, temporarily disable transitions
  	transitionsEnabled = this.transitionsEnabled;
  	if (this.noIntro) {
  		this.transitionsEnabled = false;
  	}

  	promise = global_runloop.start(this, true);
  	global_runloop.scheduleTask(function () {
  		return renderHook.fire(_this);
  	}, true);

  	if (this.fragment.rendered) {
  		throw new Error("You cannot call ractive.render() on an already rendered instance! Call ractive.unrender() first");
  	}

  	target = getElement(target) || this.el;
  	anchor = getElement(anchor) || this.anchor;

  	this.el = target;
  	this.anchor = anchor;

  	if (!this.append && target) {
  		// Teardown any existing instances *before* trying to set up the new one -
  		// avoids certain weird bugs
  		var others = target.__ractive_instances__;
  		if (others && others.length) {
  			removeOtherInstances(others);
  		}

  		// make sure we are the only occupants
  		target.innerHTML = ""; // TODO is this quicker than removeChild? Initial research inconclusive
  	}

  	if (this.cssId) {
  		// ensure encapsulated CSS is up-to-date
  		global_css.apply();
  	}

  	if (target) {
  		if (!(instances = target.__ractive_instances__)) {
  			target.__ractive_instances__ = [this];
  		} else {
  			instances.push(this);
  		}

  		if (anchor) {
  			target.insertBefore(this.fragment.render(), anchor);
  		} else {
  			target.appendChild(this.fragment.render());
  		}
  	}

  	global_runloop.end();

  	this.transitionsEnabled = transitionsEnabled;

  	return promise.then(function () {
  		return completeHook.fire(_this);
  	});
  }

  function removeOtherInstances(others) {
  	others.splice(0, others.length).forEach(teardown);
  }

  var adaptConfigurator = {
  	extend: function (Parent, proto, options) {
  		proto.adapt = custom_adapt__combine(proto.adapt, ensureArray(options.adapt));
  	},

  	init: function () {}
  };

  var custom_adapt = adaptConfigurator;

  function custom_adapt__combine(a, b) {
  	var c = a.slice(),
  	    i = b.length;

  	while (i--) {
  		if (! ~c.indexOf(b[i])) {
  			c.push(b[i]);
  		}
  	}

  	return c;
  }

  var transform = transformCss;

  var selectorsPattern = /(?:^|\})?\s*([^\{\}]+)\s*\{/g,
      commentsPattern = /\/\*.*?\*\//g,
      selectorUnitPattern = /((?:(?:\[[^\]+]\])|(?:[^\s\+\>\~:]))+)((?::[^\s\+\>\~\(]+(?:\([^\)]+\))?)?\s*[\s\+\>\~]?)\s*/g,
      mediaQueryPattern = /^@media/,
      dataRvcGuidPattern = /\[data-ractive-css~="\{[a-z0-9-]+\}"]/g;
  function transformCss(css, id) {
  	var transformed, dataAttr, addGuid;

  	dataAttr = "[data-ractive-css~=\"{" + id + "}\"]";

  	addGuid = function (selector) {
  		var selectorUnits,
  		    match,
  		    unit,
  		    base,
  		    prepended,
  		    appended,
  		    i,
  		    transformed = [];

  		selectorUnits = [];

  		while (match = selectorUnitPattern.exec(selector)) {
  			selectorUnits.push({
  				str: match[0],
  				base: match[1],
  				modifiers: match[2]
  			});
  		}

  		// For each simple selector within the selector, we need to create a version
  		// that a) combines with the id, and b) is inside the id
  		base = selectorUnits.map(extractString);

  		i = selectorUnits.length;
  		while (i--) {
  			appended = base.slice();

  			// Pseudo-selectors should go after the attribute selector
  			unit = selectorUnits[i];
  			appended[i] = unit.base + dataAttr + unit.modifiers || "";

  			prepended = base.slice();
  			prepended[i] = dataAttr + " " + prepended[i];

  			transformed.push(appended.join(" "), prepended.join(" "));
  		}

  		return transformed.join(", ");
  	};

  	if (dataRvcGuidPattern.test(css)) {
  		transformed = css.replace(dataRvcGuidPattern, dataAttr);
  	} else {
  		transformed = css.replace(commentsPattern, "").replace(selectorsPattern, function (match, $1) {
  			var selectors, transformed;

  			// don't transform media queries!
  			if (mediaQueryPattern.test($1)) return match;

  			selectors = $1.split(",").map(trim);
  			transformed = selectors.map(addGuid).join(", ") + " ";

  			return match.replace($1, transformed);
  		});
  	}

  	return transformed;
  }

  function trim(str) {
  	if (str.trim) {
  		return str.trim();
  	}

  	return str.replace(/^\s+/, "").replace(/\s+$/, "");
  }

  function extractString(unit) {
  	return unit.str;
  }

  var css_css__uid = 1;

  var cssConfigurator = {
  	name: "css",

  	extend: function (Parent, proto, options) {
  		if (options.css) {
  			var id = css_css__uid++;
  			var styles = options.noCssTransform ? options.css : transform(options.css, id);

  			proto.cssId = id;
  			global_css.add({ id: id, styles: styles });
  		}
  	},

  	init: function () {}
  };

  var css_css = cssConfigurator;

  function validate(data) {
  	// Warn if userOptions.data is a non-POJO
  	if (data && data.constructor !== Object) {
  		if (typeof data === "function") {} else if (typeof data !== "object") {
  			fatal("data option must be an object or a function, `" + data + "` is not valid");
  		} else {
  			warnIfDebug("If supplied, options.data should be a plain JavaScript object - using a non-POJO as the root object may work, but is discouraged");
  		}
  	}
  }

  var dataConfigurator = {
  	name: "data",

  	extend: function (Parent, proto, options) {
  		var key = undefined,
  		    value = undefined;

  		// check for non-primitives, which could cause mutation-related bugs
  		if (options.data && isObject(options.data)) {
  			for (key in options.data) {
  				value = options.data[key];

  				if (value && typeof value === "object") {
  					if (isObject(value) || isArray(value)) {
  						warnIfDebug("Passing a `data` option with object and array properties to Ractive.extend() is discouraged, as mutating them is likely to cause bugs. Consider using a data function instead:\n\n  // this...\n  data: function () {\n    return {\n      myObject: {}\n    };\n  })\n\n  // instead of this:\n  data: {\n    myObject: {}\n  }");
  					}
  				}
  			}
  		}

  		proto.data = custom_data__combine(proto.data, options.data);
  	},

  	init: function (Parent, ractive, options) {
  		var result = custom_data__combine(Parent.prototype.data, options.data);

  		if (typeof result === "function") {
  			result = result.call(ractive);
  		}

  		return result || {};
  	},

  	reset: function (ractive) {
  		var result = this.init(ractive.constructor, ractive, ractive.viewmodel);

  		ractive.viewmodel.reset(result);
  		return true;
  	}
  };

  var custom_data = dataConfigurator;

  function custom_data__combine(parentValue, childValue) {
  	validate(childValue);

  	var parentIsFn = typeof parentValue === "function";
  	var childIsFn = typeof childValue === "function";

  	// Very important, otherwise child instance can become
  	// the default data object on Ractive or a component.
  	// then ractive.set() ends up setting on the prototype!
  	if (!childValue && !parentIsFn) {
  		childValue = {};
  	}

  	// Fast path, where we just need to copy properties from
  	// parent to child
  	if (!parentIsFn && !childIsFn) {
  		return fromProperties(childValue, parentValue);
  	}

  	return function () {
  		var child = childIsFn ? callDataFunction(childValue, this) : childValue;
  		var parent = parentIsFn ? callDataFunction(parentValue, this) : parentValue;

  		return fromProperties(child, parent);
  	};
  }

  function callDataFunction(fn, context) {
  	var data = fn.call(context);

  	if (!data) return;

  	if (typeof data !== "object") {
  		fatal("Data function must return an object");
  	}

  	if (data.constructor !== Object) {
  		warnOnceIfDebug("Data function returned something other than a plain JavaScript object. This might work, but is strongly discouraged");
  	}

  	return data;
  }

  function fromProperties(primary, secondary) {
  	if (primary && secondary) {
  		for (var key in secondary) {
  			if (!(key in primary)) {
  				primary[key] = secondary[key];
  			}
  		}

  		return primary;
  	}

  	return primary || secondary;
  }

  // TODO do we need to support this in the new Ractive() case?

  var Parser,
      ParseError,
      parse_Parser__leadingWhitespace = /^\s+/;

  ParseError = function (message) {
  	this.name = "ParseError";
  	this.message = message;
  	try {
  		throw new Error(message);
  	} catch (e) {
  		this.stack = e.stack;
  	}
  };

  ParseError.prototype = Error.prototype;

  Parser = function (str, options) {
  	var items,
  	    item,
  	    lineStart = 0;

  	this.str = str;
  	this.options = options || {};
  	this.pos = 0;

  	this.lines = this.str.split("\n");
  	this.lineEnds = this.lines.map(function (line) {
  		var lineEnd = lineStart + line.length + 1; // +1 for the newline

  		lineStart = lineEnd;
  		return lineEnd;
  	}, 0);

  	// Custom init logic
  	if (this.init) this.init(str, options);

  	items = [];

  	while (this.pos < this.str.length && (item = this.read())) {
  		items.push(item);
  	}

  	this.leftover = this.remaining();
  	this.result = this.postProcess ? this.postProcess(items, options) : items;
  };

  Parser.prototype = {
  	read: function (converters) {
  		var pos, i, len, item;

  		if (!converters) converters = this.converters;

  		pos = this.pos;

  		len = converters.length;
  		for (i = 0; i < len; i += 1) {
  			this.pos = pos; // reset for each attempt

  			if (item = converters[i](this)) {
  				return item;
  			}
  		}

  		return null;
  	},

  	getLinePos: function (char) {
  		var lineNum = 0,
  		    lineStart = 0,
  		    columnNum;

  		while (char >= this.lineEnds[lineNum]) {
  			lineStart = this.lineEnds[lineNum];
  			lineNum += 1;
  		}

  		columnNum = char - lineStart;
  		return [lineNum + 1, columnNum + 1, char]; // line/col should be one-based, not zero-based!
  	},

  	error: function (message) {
  		var pos = this.getLinePos(this.pos);
  		var lineNum = pos[0];
  		var columnNum = pos[1];

  		var line = this.lines[pos[0] - 1];
  		var numTabs = 0;
  		var annotation = line.replace(/\t/g, function (match, char) {
  			if (char < pos[1]) {
  				numTabs += 1;
  			}

  			return "  ";
  		}) + "\n" + new Array(pos[1] + numTabs).join(" ") + "^----";

  		var error = new ParseError("" + message + " at line " + lineNum + " character " + columnNum + ":\n" + annotation);

  		error.line = pos[0];
  		error.character = pos[1];
  		error.shortMessage = message;

  		throw error;
  	},

  	matchString: function (string) {
  		if (this.str.substr(this.pos, string.length) === string) {
  			this.pos += string.length;
  			return string;
  		}
  	},

  	matchPattern: function (pattern) {
  		var match;

  		if (match = pattern.exec(this.remaining())) {
  			this.pos += match[0].length;
  			return match[1] || match[0];
  		}
  	},

  	allowWhitespace: function () {
  		this.matchPattern(parse_Parser__leadingWhitespace);
  	},

  	remaining: function () {
  		return this.str.substring(this.pos);
  	},

  	nextChar: function () {
  		return this.str.charAt(this.pos);
  	}
  };

  Parser.extend = function (proto) {
  	var Parent = this,
  	    Child,
  	    key;

  	Child = function (str, options) {
  		Parser.call(this, str, options);
  	};

  	Child.prototype = create(Parent.prototype);

  	for (key in proto) {
  		if (hasOwn.call(proto, key)) {
  			Child.prototype[key] = proto[key];
  		}
  	}

  	Child.extend = Parser.extend;
  	return Child;
  };

  var parse_Parser = Parser;

  var TEXT = 1;
  var INTERPOLATOR = 2;
  var TRIPLE = 3;
  var SECTION = 4;
  var INVERTED = 5;
  var CLOSING = 6;
  var ELEMENT = 7;
  var PARTIAL = 8;
  var COMMENT = 9;
  var DELIMCHANGE = 10;
  var ATTRIBUTE = 13;
  var CLOSING_TAG = 14;
  var COMPONENT = 15;
  var YIELDER = 16;
  var INLINE_PARTIAL = 17;
  var DOCTYPE = 18;

  var NUMBER_LITERAL = 20;
  var STRING_LITERAL = 21;
  var ARRAY_LITERAL = 22;
  var OBJECT_LITERAL = 23;
  var BOOLEAN_LITERAL = 24;
  var REGEXP_LITERAL = 25;

  var GLOBAL = 26;
  var KEY_VALUE_PAIR = 27;

  var REFERENCE = 30;
  var REFINEMENT = 31;
  var MEMBER = 32;
  var PREFIX_OPERATOR = 33;
  var BRACKETED = 34;
  var CONDITIONAL = 35;
  var INFIX_OPERATOR = 36;

  var INVOCATION = 40;

  var SECTION_IF = 50;
  var SECTION_UNLESS = 51;
  var SECTION_EACH = 52;
  var SECTION_WITH = 53;
  var SECTION_IF_WITH = 54;

  var ELSE = 60;
  var ELSEIF = 61;

  var mustache_readDelimiterChange = readDelimiterChange;
  var delimiterChangePattern = /^[^\s=]+/,
      whitespacePattern = /^\s+/;
  function readDelimiterChange(parser) {
  	var start, opening, closing;

  	if (!parser.matchString("=")) {
  		return null;
  	}

  	start = parser.pos;

  	// allow whitespace before new opening delimiter
  	parser.allowWhitespace();

  	opening = parser.matchPattern(delimiterChangePattern);
  	if (!opening) {
  		parser.pos = start;
  		return null;
  	}

  	// allow whitespace (in fact, it's necessary...)
  	if (!parser.matchPattern(whitespacePattern)) {
  		return null;
  	}

  	closing = parser.matchPattern(delimiterChangePattern);
  	if (!closing) {
  		parser.pos = start;
  		return null;
  	}

  	// allow whitespace before closing '='
  	parser.allowWhitespace();

  	if (!parser.matchString("=")) {
  		parser.pos = start;
  		return null;
  	}

  	return [opening, closing];
  }

  var readRegexpLiteral = readRegexpLiteral__readNumberLiteral;
  var regexpPattern = /^(\/(?:[^\n\r\u2028\u2029/\\[]|\\.|\[(?:[^\n\r\u2028\u2029\]\\]|\\.)*])+\/(?:([gimuy])(?![a-z]*\2))*(?![a-zA-Z_$0-9]))/;
  function readRegexpLiteral__readNumberLiteral(parser) {
  	var result;

  	if (result = parser.matchPattern(regexpPattern)) {
  		return {
  			t: REGEXP_LITERAL,
  			v: result
  		};
  	}

  	return null;
  }

  var converters_readMustache = readMustache;

  var delimiterChangeToken = { t: DELIMCHANGE, exclude: true };
  function readMustache(parser) {
  	var mustache, i;

  	// If we're inside a <script> or <style> tag, and we're not
  	// interpolating, bug out
  	if (parser.interpolate[parser.inside] === false) {
  		return null;
  	}

  	for (i = 0; i < parser.tags.length; i += 1) {
  		if (mustache = readMustacheOfType(parser, parser.tags[i])) {
  			return mustache;
  		}
  	}
  }

  function readMustacheOfType(parser, tag) {
  	var start, mustache, reader, i;

  	start = parser.pos;

  	if (parser.matchString("\\" + tag.open)) {
  		if (start === 0 || parser.str[start - 1] !== "\\") {
  			return tag.open;
  		}
  	} else if (!parser.matchString(tag.open)) {
  		return null;
  	}

  	// delimiter change?
  	if (mustache = mustache_readDelimiterChange(parser)) {
  		// find closing delimiter or abort...
  		if (!parser.matchString(tag.close)) {
  			return null;
  		}

  		// ...then make the switch
  		tag.open = mustache[0];
  		tag.close = mustache[1];
  		parser.sortMustacheTags();

  		return delimiterChangeToken;
  	}

  	parser.allowWhitespace();

  	// illegal section closer
  	if (parser.matchString("/")) {
  		parser.pos -= 1;
  		var rewind = parser.pos;
  		if (!readRegexpLiteral(parser)) {
  			parser.pos = rewind - tag.close.length;
  			parser.error("Attempted to close a section that wasn't open");
  		} else {
  			parser.pos = rewind;
  		}
  	}

  	for (i = 0; i < tag.readers.length; i += 1) {
  		reader = tag.readers[i];

  		if (mustache = reader(parser, tag)) {
  			if (tag.isStatic) {
  				mustache.s = true; // TODO make this `1` instead - more compact
  			}

  			if (parser.includeLinePositions) {
  				mustache.p = parser.getLinePos(start);
  			}

  			return mustache;
  		}
  	}

  	parser.pos = start;
  	return null;
  }

  var expectedExpression = "Expected a JavaScript expression";
  var expectedParen = "Expected closing paren";

  var literal_readNumberLiteral = literal_readNumberLiteral__readNumberLiteral;
  var literal_readNumberLiteral__numberPattern = /^(?:[+-]?)0*(?:(?:(?:[1-9]\d*)?\.\d+)|(?:(?:0|[1-9]\d*)\.)|(?:0|[1-9]\d*))(?:[eE][+-]?\d+)?/;
  function literal_readNumberLiteral__readNumberLiteral(parser) {
  	var result;

  	if (result = parser.matchPattern(literal_readNumberLiteral__numberPattern)) {
  		return {
  			t: NUMBER_LITERAL,
  			v: result
  		};
  	}

  	return null;
  }

  var literal_readBooleanLiteral = readBooleanLiteral;
  function readBooleanLiteral(parser) {
  	var remaining = parser.remaining();

  	if (remaining.substr(0, 4) === "true") {
  		parser.pos += 4;
  		return {
  			t: BOOLEAN_LITERAL,
  			v: "true"
  		};
  	}

  	if (remaining.substr(0, 5) === "false") {
  		parser.pos += 5;
  		return {
  			t: BOOLEAN_LITERAL,
  			v: "false"
  		};
  	}

  	return null;
  }

  var stringMiddlePattern, escapeSequencePattern, lineContinuationPattern;

  // Match one or more characters until: ", ', \, or EOL/EOF.
  // EOL/EOF is written as (?!.) (meaning there's no non-newline char next).
  stringMiddlePattern = /^(?=.)[^"'\\]+?(?:(?!.)|(?=["'\\]))/;

  // Match one escape sequence, including the backslash.
  escapeSequencePattern = /^\\(?:['"\\bfnrt]|0(?![0-9])|x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|(?=.)[^ux0-9])/;

  // Match one ES5 line continuation (backslash + line terminator).
  lineContinuationPattern = /^\\(?:\r\n|[\u000A\u000D\u2028\u2029])/;

  // Helper for defining getDoubleQuotedString and getSingleQuotedString.
  var makeQuotedStringMatcher = function (okQuote) {
  	return function (parser) {
  		var start, literal, done, next;

  		start = parser.pos;
  		literal = "\"";
  		done = false;

  		while (!done) {
  			next = parser.matchPattern(stringMiddlePattern) || parser.matchPattern(escapeSequencePattern) || parser.matchString(okQuote);
  			if (next) {
  				if (next === "\"") {
  					literal += "\\\"";
  				} else if (next === "\\'") {
  					literal += "'";
  				} else {
  					literal += next;
  				}
  			} else {
  				next = parser.matchPattern(lineContinuationPattern);
  				if (next) {
  					// convert \(newline-like) into a \u escape, which is allowed in JSON
  					literal += "\\u" + ("000" + next.charCodeAt(1).toString(16)).slice(-4);
  				} else {
  					done = true;
  				}
  			}
  		}

  		literal += "\"";

  		// use JSON.parse to interpret escapes
  		return JSON.parse(literal);
  	};
  };

  var getSingleQuotedString = makeQuotedStringMatcher("\"");
  var getDoubleQuotedString = makeQuotedStringMatcher("'");

  var readStringLiteral = function (parser) {
  	var start, string;

  	start = parser.pos;

  	if (parser.matchString("\"")) {
  		string = getDoubleQuotedString(parser);

  		if (!parser.matchString("\"")) {
  			parser.pos = start;
  			return null;
  		}

  		return {
  			t: STRING_LITERAL,
  			v: string
  		};
  	}

  	if (parser.matchString("'")) {
  		string = getSingleQuotedString(parser);

  		if (!parser.matchString("'")) {
  			parser.pos = start;
  			return null;
  		}

  		return {
  			t: STRING_LITERAL,
  			v: string
  		};
  	}

  	return null;
  };

  var patterns__name = /^[a-zA-Z_$][a-zA-Z_$0-9]*/;

  // http://mathiasbynens.be/notes/javascript-properties
  // can be any name, string literal, or number literal
  var shared_readKey = readKey;
  var identifier = /^[a-zA-Z_$][a-zA-Z_$0-9]*$/;
  function readKey(parser) {
  	var token;

  	if (token = readStringLiteral(parser)) {
  		return identifier.test(token.v) ? token.v : "\"" + token.v.replace(/"/g, "\\\"") + "\"";
  	}

  	if (token = literal_readNumberLiteral(parser)) {
  		return token.v;
  	}

  	if (token = parser.matchPattern(patterns__name)) {
  		return token;
  	}
  }

  var keyValuePair = readKeyValuePair;
  function readKeyValuePair(parser) {
  	var start, key, value;

  	start = parser.pos;

  	// allow whitespace between '{' and key
  	parser.allowWhitespace();

  	key = shared_readKey(parser);
  	if (key === null) {
  		parser.pos = start;
  		return null;
  	}

  	// allow whitespace between key and ':'
  	parser.allowWhitespace();

  	// next character must be ':'
  	if (!parser.matchString(":")) {
  		parser.pos = start;
  		return null;
  	}

  	// allow whitespace between ':' and value
  	parser.allowWhitespace();

  	// next expression must be a, well... expression
  	value = converters_readExpression(parser);
  	if (value === null) {
  		parser.pos = start;
  		return null;
  	}

  	return {
  		t: KEY_VALUE_PAIR,
  		k: key,
  		v: value
  	};
  }

  var objectLiteral_keyValuePairs = readKeyValuePairs;
  function readKeyValuePairs(parser) {
  	var start, pairs, pair, keyValuePairs;

  	start = parser.pos;

  	pair = keyValuePair(parser);
  	if (pair === null) {
  		return null;
  	}

  	pairs = [pair];

  	if (parser.matchString(",")) {
  		keyValuePairs = readKeyValuePairs(parser);

  		if (!keyValuePairs) {
  			parser.pos = start;
  			return null;
  		}

  		return pairs.concat(keyValuePairs);
  	}

  	return pairs;
  }

  var readObjectLiteral = function (parser) {
  	var start, keyValuePairs;

  	start = parser.pos;

  	// allow whitespace
  	parser.allowWhitespace();

  	if (!parser.matchString("{")) {
  		parser.pos = start;
  		return null;
  	}

  	keyValuePairs = objectLiteral_keyValuePairs(parser);

  	// allow whitespace between final value and '}'
  	parser.allowWhitespace();

  	if (!parser.matchString("}")) {
  		parser.pos = start;
  		return null;
  	}

  	return {
  		t: OBJECT_LITERAL,
  		m: keyValuePairs
  	};
  };

  var shared_readExpressionList = readExpressionList;
  function readExpressionList(parser) {
  	var start, expressions, expr, next;

  	start = parser.pos;

  	parser.allowWhitespace();

  	expr = converters_readExpression(parser);

  	if (expr === null) {
  		return null;
  	}

  	expressions = [expr];

  	// allow whitespace between expression and ','
  	parser.allowWhitespace();

  	if (parser.matchString(",")) {
  		next = readExpressionList(parser);
  		if (next === null) {
  			parser.error(expectedExpression);
  		}

  		next.forEach(append);
  	}

  	function append(expression) {
  		expressions.push(expression);
  	}

  	return expressions;
  }

  var readArrayLiteral = function (parser) {
  	var start, expressionList;

  	start = parser.pos;

  	// allow whitespace before '['
  	parser.allowWhitespace();

  	if (!parser.matchString("[")) {
  		parser.pos = start;
  		return null;
  	}

  	expressionList = shared_readExpressionList(parser);

  	if (!parser.matchString("]")) {
  		parser.pos = start;
  		return null;
  	}

  	return {
  		t: ARRAY_LITERAL,
  		m: expressionList
  	};
  };

  var primary_readLiteral = readLiteral;
  function readLiteral(parser) {
  	return literal_readNumberLiteral(parser) || literal_readBooleanLiteral(parser) || readStringLiteral(parser) || readObjectLiteral(parser) || readArrayLiteral(parser) || readRegexpLiteral(parser);
  }

  var primary_readReference = readReference;
  var prefixPattern = /^(?:~\/|(?:\.\.\/)+|\.\/(?:\.\.\/)*|\.)/,
      globals,
      keywords;

  // if a reference is a browser global, we don't deference it later, so it needs special treatment
  globals = /^(?:Array|console|Date|RegExp|decodeURIComponent|decodeURI|encodeURIComponent|encodeURI|isFinite|isNaN|parseFloat|parseInt|JSON|Math|NaN|undefined|null)\b/;

  // keywords are not valid references, with the exception of `this`
  keywords = /^(?:break|case|catch|continue|debugger|default|delete|do|else|finally|for|function|if|in|instanceof|new|return|switch|throw|try|typeof|var|void|while|with)$/;

  var legalReference = /^[a-zA-Z$_0-9]+(?:(?:\.[a-zA-Z$_0-9]+)|(?:\[[0-9]+\]))*/;
  var relaxedName = /^[a-zA-Z_$][-a-zA-Z_$0-9]*/;
  function readReference(parser) {
  	var startPos, prefix, name, global, reference, lastDotIndex;

  	startPos = parser.pos;

  	name = parser.matchPattern(/^@(?:keypath|index|key)/);

  	if (!name) {
  		prefix = parser.matchPattern(prefixPattern) || "";
  		name = !prefix && parser.relaxedNames && parser.matchPattern(relaxedName) || parser.matchPattern(legalReference);

  		if (!name && prefix === ".") {
  			prefix = "";
  			name = ".";
  		}
  	}

  	if (!name) {
  		return null;
  	}

  	// bug out if it's a keyword (exception for ancestor/restricted refs - see https://github.com/ractivejs/ractive/issues/1497)
  	if (!prefix && !parser.relaxedNames && keywords.test(name)) {
  		parser.pos = startPos;
  		return null;
  	}

  	// if this is a browser global, stop here
  	if (!prefix && globals.test(name)) {
  		global = globals.exec(name)[0];
  		parser.pos = startPos + global.length;

  		return {
  			t: GLOBAL,
  			v: global
  		};
  	}

  	reference = (prefix || "") + normalise(name);

  	if (parser.matchString("(")) {
  		// if this is a method invocation (as opposed to a function) we need
  		// to strip the method name from the reference combo, else the context
  		// will be wrong
  		lastDotIndex = reference.lastIndexOf(".");
  		if (lastDotIndex !== -1) {
  			reference = reference.substr(0, lastDotIndex);
  			parser.pos = startPos + reference.length;
  		} else {
  			parser.pos -= 1;
  		}
  	}

  	return {
  		t: REFERENCE,
  		n: reference.replace(/^this\./, "./").replace(/^this$/, ".")
  	};
  }

  var primary_readBracketedExpression = readBracketedExpression;
  function readBracketedExpression(parser) {
  	var start, expr;

  	start = parser.pos;

  	if (!parser.matchString("(")) {
  		return null;
  	}

  	parser.allowWhitespace();

  	expr = converters_readExpression(parser);
  	if (!expr) {
  		parser.error(expectedExpression);
  	}

  	parser.allowWhitespace();

  	if (!parser.matchString(")")) {
  		parser.error(expectedParen);
  	}

  	return {
  		t: BRACKETED,
  		x: expr
  	};
  }

  var readPrimary = function (parser) {
  	return primary_readLiteral(parser) || primary_readReference(parser) || primary_readBracketedExpression(parser);
  };

  var shared_readRefinement = readRefinement;
  function readRefinement(parser) {
  	var start, name, expr;

  	start = parser.pos;

  	parser.allowWhitespace();

  	// "." name
  	if (parser.matchString(".")) {
  		parser.allowWhitespace();

  		if (name = parser.matchPattern(patterns__name)) {
  			return {
  				t: REFINEMENT,
  				n: name
  			};
  		}

  		parser.error("Expected a property name");
  	}

  	// "[" expression "]"
  	if (parser.matchString("[")) {
  		parser.allowWhitespace();

  		expr = converters_readExpression(parser);
  		if (!expr) {
  			parser.error(expectedExpression);
  		}

  		parser.allowWhitespace();

  		if (!parser.matchString("]")) {
  			parser.error("Expected ']'");
  		}

  		return {
  			t: REFINEMENT,
  			x: expr
  		};
  	}

  	return null;
  }

  var readMemberOrInvocation = function (parser) {
  	var current, expression, refinement, expressionList;

  	expression = readPrimary(parser);

  	if (!expression) {
  		return null;
  	}

  	while (expression) {
  		current = parser.pos;

  		if (refinement = shared_readRefinement(parser)) {
  			expression = {
  				t: MEMBER,
  				x: expression,
  				r: refinement
  			};
  		} else if (parser.matchString("(")) {
  			parser.allowWhitespace();
  			expressionList = shared_readExpressionList(parser);

  			parser.allowWhitespace();

  			if (!parser.matchString(")")) {
  				parser.error(expectedParen);
  			}

  			expression = {
  				t: INVOCATION,
  				x: expression
  			};

  			if (expressionList) {
  				expression.o = expressionList;
  			}
  		} else {
  			break;
  		}
  	}

  	return expression;
  };

  var readTypeOf, makePrefixSequenceMatcher;

  makePrefixSequenceMatcher = function (symbol, fallthrough) {
  	return function (parser) {
  		var expression;

  		if (expression = fallthrough(parser)) {
  			return expression;
  		}

  		if (!parser.matchString(symbol)) {
  			return null;
  		}

  		parser.allowWhitespace();

  		expression = converters_readExpression(parser);
  		if (!expression) {
  			parser.error(expectedExpression);
  		}

  		return {
  			s: symbol,
  			o: expression,
  			t: PREFIX_OPERATOR
  		};
  	};
  };

  // create all prefix sequence matchers, return readTypeOf
  (function () {
  	var i, len, matcher, prefixOperators, fallthrough;

  	prefixOperators = "! ~ + - typeof".split(" ");

  	fallthrough = readMemberOrInvocation;
  	for (i = 0, len = prefixOperators.length; i < len; i += 1) {
  		matcher = makePrefixSequenceMatcher(prefixOperators[i], fallthrough);
  		fallthrough = matcher;
  	}

  	// typeof operator is higher precedence than multiplication, so provides the
  	// fallthrough for the multiplication sequence matcher we're about to create
  	// (we're skipping void and delete)
  	readTypeOf = fallthrough;
  })();

  var readTypeof = readTypeOf;

  var readLogicalOr, makeInfixSequenceMatcher;

  makeInfixSequenceMatcher = function (symbol, fallthrough) {
  	return function (parser) {
  		var start, left, right;

  		left = fallthrough(parser);
  		if (!left) {
  			return null;
  		}

  		// Loop to handle left-recursion in a case like `a * b * c` and produce
  		// left association, i.e. `(a * b) * c`.  The matcher can't call itself
  		// to parse `left` because that would be infinite regress.
  		while (true) {
  			start = parser.pos;

  			parser.allowWhitespace();

  			if (!parser.matchString(symbol)) {
  				parser.pos = start;
  				return left;
  			}

  			// special case - in operator must not be followed by [a-zA-Z_$0-9]
  			if (symbol === "in" && /[a-zA-Z_$0-9]/.test(parser.remaining().charAt(0))) {
  				parser.pos = start;
  				return left;
  			}

  			parser.allowWhitespace();

  			// right operand must also consist of only higher-precedence operators
  			right = fallthrough(parser);
  			if (!right) {
  				parser.pos = start;
  				return left;
  			}

  			left = {
  				t: INFIX_OPERATOR,
  				s: symbol,
  				o: [left, right]
  			};

  			// Loop back around.  If we don't see another occurrence of the symbol,
  			// we'll return left.
  		}
  	};
  };

  // create all infix sequence matchers, and return readLogicalOr
  (function () {
  	var i, len, matcher, infixOperators, fallthrough;

  	// All the infix operators on order of precedence (source: https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Operator_Precedence)
  	// Each sequence matcher will initially fall through to its higher precedence
  	// neighbour, and only attempt to match if one of the higher precedence operators
  	// (or, ultimately, a literal, reference, or bracketed expression) already matched
  	infixOperators = "* / % + - << >> >>> < <= > >= in instanceof == != === !== & ^ | && ||".split(" ");

  	// A typeof operator is higher precedence than multiplication
  	fallthrough = readTypeof;
  	for (i = 0, len = infixOperators.length; i < len; i += 1) {
  		matcher = makeInfixSequenceMatcher(infixOperators[i], fallthrough);
  		fallthrough = matcher;
  	}

  	// Logical OR is the fallthrough for the conditional matcher
  	readLogicalOr = fallthrough;
  })();

  var expressions_readLogicalOr = readLogicalOr;

  // The conditional operator is the lowest precedence operator, so we start here
  var readConditional = getConditional;
  function getConditional(parser) {
  	var start, expression, ifTrue, ifFalse;

  	expression = expressions_readLogicalOr(parser);
  	if (!expression) {
  		return null;
  	}

  	start = parser.pos;

  	parser.allowWhitespace();

  	if (!parser.matchString("?")) {
  		parser.pos = start;
  		return expression;
  	}

  	parser.allowWhitespace();

  	ifTrue = converters_readExpression(parser);
  	if (!ifTrue) {
  		parser.error(expectedExpression);
  	}

  	parser.allowWhitespace();

  	if (!parser.matchString(":")) {
  		parser.error("Expected \":\"");
  	}

  	parser.allowWhitespace();

  	ifFalse = converters_readExpression(parser);
  	if (!ifFalse) {
  		parser.error(expectedExpression);
  	}

  	return {
  		t: CONDITIONAL,
  		o: [expression, ifTrue, ifFalse]
  	};
  }

  var converters_readExpression = readExpression;
  function readExpression(parser) {
  	// The conditional operator is the lowest precedence operator (except yield,
  	// assignment operators, and commas, none of which are supported), so we
  	// start there. If it doesn't match, it 'falls through' to progressively
  	// higher precedence operators, until it eventually matches (or fails to
  	// match) a 'primary' - a literal or a reference. This way, the abstract syntax
  	// tree has everything in its proper place, i.e. 2 + 3 * 4 === 14, not 20.
  	return readConditional(parser);
  }

  var utils_flattenExpression = flattenExpression;

  function flattenExpression(expression) {
  	var refs;

  	extractRefs(expression, refs = []);

  	return {
  		r: refs,
  		s: stringify(expression)
  	};

  	function stringify(node) {
  		switch (node.t) {
  			case BOOLEAN_LITERAL:
  			case GLOBAL:
  			case NUMBER_LITERAL:
  			case REGEXP_LITERAL:
  				return node.v;

  			case STRING_LITERAL:
  				return JSON.stringify(String(node.v));

  			case ARRAY_LITERAL:
  				return "[" + (node.m ? node.m.map(stringify).join(",") : "") + "]";

  			case OBJECT_LITERAL:
  				return "{" + (node.m ? node.m.map(stringify).join(",") : "") + "}";

  			case KEY_VALUE_PAIR:
  				return node.k + ":" + stringify(node.v);

  			case PREFIX_OPERATOR:
  				return (node.s === "typeof" ? "typeof " : node.s) + stringify(node.o);

  			case INFIX_OPERATOR:
  				return stringify(node.o[0]) + (node.s.substr(0, 2) === "in" ? " " + node.s + " " : node.s) + stringify(node.o[1]);

  			case INVOCATION:
  				return stringify(node.x) + "(" + (node.o ? node.o.map(stringify).join(",") : "") + ")";

  			case BRACKETED:
  				return "(" + stringify(node.x) + ")";

  			case MEMBER:
  				return stringify(node.x) + stringify(node.r);

  			case REFINEMENT:
  				return node.n ? "." + node.n : "[" + stringify(node.x) + "]";

  			case CONDITIONAL:
  				return stringify(node.o[0]) + "?" + stringify(node.o[1]) + ":" + stringify(node.o[2]);

  			case REFERENCE:
  				return "_" + refs.indexOf(node.n);

  			default:
  				throw new Error("Expected legal JavaScript");
  		}
  	}
  }

  // TODO maybe refactor this?
  function extractRefs(node, refs) {
  	var i, list;

  	if (node.t === REFERENCE) {
  		if (refs.indexOf(node.n) === -1) {
  			refs.unshift(node.n);
  		}
  	}

  	list = node.o || node.m;
  	if (list) {
  		if (isObject(list)) {
  			extractRefs(list, refs);
  		} else {
  			i = list.length;
  			while (i--) {
  				extractRefs(list[i], refs);
  			}
  		}
  	}

  	if (node.x) {
  		extractRefs(node.x, refs);
  	}

  	if (node.r) {
  		extractRefs(node.r, refs);
  	}

  	if (node.v) {
  		extractRefs(node.v, refs);
  	}
  }

  var utils_refineExpression = refineExpression;

  var arrayMemberPattern = /^[0-9][1-9]*$/;
  function refineExpression(expression, mustache) {
  	var referenceExpression;

  	if (expression) {
  		while (expression.t === BRACKETED && expression.x) {
  			expression = expression.x;
  		}

  		// special case - integers should be treated as array members references,
  		// rather than as expressions in their own right
  		if (expression.t === REFERENCE) {
  			mustache.r = expression.n;
  		} else {
  			if (expression.t === NUMBER_LITERAL && arrayMemberPattern.test(expression.v)) {
  				mustache.r = expression.v;
  			} else if (referenceExpression = getReferenceExpression(expression)) {
  				mustache.rx = referenceExpression;
  			} else {
  				mustache.x = utils_flattenExpression(expression);
  			}
  		}

  		return mustache;
  	}
  }

  // TODO refactor this! it's bewildering
  function getReferenceExpression(expression) {
  	var members = [],
  	    refinement;

  	while (expression.t === MEMBER && expression.r.t === REFINEMENT) {
  		refinement = expression.r;

  		if (refinement.x) {
  			if (refinement.x.t === REFERENCE) {
  				members.unshift(refinement.x);
  			} else {
  				members.unshift(utils_flattenExpression(refinement.x));
  			}
  		} else {
  			members.unshift(refinement.n);
  		}

  		expression = expression.x;
  	}

  	if (expression.t !== REFERENCE) {
  		return null;
  	}

  	return {
  		r: expression.n,
  		m: members
  	};
  }

  var mustache_readTriple = readTriple;
  function readTriple(parser, tag) {
  	var expression = converters_readExpression(parser),
  	    triple;

  	if (!expression) {
  		return null;
  	}

  	if (!parser.matchString(tag.close)) {
  		parser.error("Expected closing delimiter '" + tag.close + "'");
  	}

  	triple = { t: TRIPLE };
  	utils_refineExpression(expression, triple); // TODO handle this differently - it's mysterious

  	return triple;
  }

  var mustache_readUnescaped = readUnescaped;
  function readUnescaped(parser, tag) {
  	var expression, triple;

  	if (!parser.matchString("&")) {
  		return null;
  	}

  	parser.allowWhitespace();

  	expression = converters_readExpression(parser);

  	if (!expression) {
  		return null;
  	}

  	if (!parser.matchString(tag.close)) {
  		parser.error("Expected closing delimiter '" + tag.close + "'");
  	}

  	triple = { t: TRIPLE };
  	utils_refineExpression(expression, triple); // TODO handle this differently - it's mysterious

  	return triple;
  }

  var mustache_readPartial = readPartial;
  function readPartial(parser, tag) {
  	var start, nameStart, expression, context, partial;

  	start = parser.pos;

  	if (!parser.matchString(">")) {
  		return null;
  	}

  	parser.allowWhitespace();
  	nameStart = parser.pos;

  	// Partial names can include hyphens, so we can't use readExpression
  	// blindly. Instead, we use the `relaxedNames` flag to indicate that
  	// `foo-bar` should be read as a single name, rather than 'subtract
  	// bar from foo'
  	parser.relaxedNames = true;
  	expression = converters_readExpression(parser);
  	parser.relaxedNames = false;

  	parser.allowWhitespace();
  	context = converters_readExpression(parser);
  	parser.allowWhitespace();

  	if (!expression) {
  		return null;
  	}

  	partial = { t: PARTIAL };
  	utils_refineExpression(expression, partial); // TODO...

  	parser.allowWhitespace();

  	// if we have another expression - e.g. `{{>foo bar}}` - then
  	// we turn it into `{{#with bar}}{{>foo}}{{/with}}`
  	if (context) {
  		partial = {
  			t: SECTION,
  			n: SECTION_WITH,
  			f: [partial]
  		};

  		utils_refineExpression(context, partial);
  	}

  	if (!parser.matchString(tag.close)) {
  		parser.error("Expected closing delimiter '" + tag.close + "'");
  	}

  	return partial;
  }

  var readMustacheComment = readComment;
  function readComment(parser, tag) {
  	var index;

  	if (!parser.matchString("!")) {
  		return null;
  	}

  	index = parser.remaining().indexOf(tag.close);

  	if (index !== -1) {
  		parser.pos += index + tag.close.length;
  		return { t: COMMENT };
  	}
  }

  var converters_readExpressionOrReference = readExpressionOrReference;
  function readExpressionOrReference(parser, expectedFollowers) {
  	var start, expression, i;

  	start = parser.pos;
  	expression = converters_readExpression(parser);

  	if (!expression) {
  		return null;
  	}

  	for (i = 0; i < expectedFollowers.length; i += 1) {
  		if (parser.remaining().substr(0, expectedFollowers[i].length) === expectedFollowers[i]) {
  			return expression;
  		}
  	}

  	parser.pos = start;
  	return primary_readReference(parser);
  }

  var mustache_readInterpolator = readInterpolator;
  function readInterpolator(parser, tag) {
  	var start, expression, interpolator, err;

  	start = parser.pos;

  	// TODO would be good for perf if we could do away with the try-catch
  	try {
  		expression = converters_readExpressionOrReference(parser, [tag.close]);
  	} catch (e) {
  		err = e;
  	}

  	if (!expression) {
  		if (parser.str.charAt(start) === "!") {
  			// special case - comment
  			parser.pos = start;
  			return null;
  		}

  		if (err) {
  			throw err;
  		}
  	}

  	if (!parser.matchString(tag.close)) {
  		parser.error("Expected closing delimiter '" + tag.close + "' after reference");

  		if (!expression) {
  			// special case - comment
  			if (parser.nextChar() === "!") {
  				return null;
  			}

  			parser.error("Expected expression or legal reference");
  		}
  	}

  	interpolator = { t: INTERPOLATOR };
  	utils_refineExpression(expression, interpolator); // TODO handle this differently - it's mysterious

  	return interpolator;
  }

  var mustache_readYielder = readYielder;
  var yieldPattern = /^yield\s*/;
  function readYielder(parser, tag) {
  	var start, name, yielder;

  	if (!parser.matchPattern(yieldPattern)) {
  		return null;
  	}

  	start = parser.pos;
  	name = parser.matchPattern(/^[a-zA-Z_$][a-zA-Z_$0-9\-]*/);

  	parser.allowWhitespace();

  	if (!parser.matchString(tag.close)) {
  		parser.error("expected legal partial name");
  	}

  	yielder = { t: YIELDER };

  	if (name) {
  		yielder.n = name;
  	}

  	return yielder;
  }

  var section_readClosing = readClosing;
  function readClosing(parser, tag) {
  	var start, remaining, index, closing;

  	start = parser.pos;

  	if (!parser.matchString(tag.open)) {
  		return null;
  	}

  	parser.allowWhitespace();

  	if (!parser.matchString("/")) {
  		parser.pos = start;
  		return null;
  	}

  	parser.allowWhitespace();

  	remaining = parser.remaining();
  	index = remaining.indexOf(tag.close);

  	if (index !== -1) {
  		closing = {
  			t: CLOSING,
  			r: remaining.substr(0, index).split(" ")[0]
  		};

  		parser.pos += index;

  		if (!parser.matchString(tag.close)) {
  			parser.error("Expected closing delimiter '" + tag.close + "'");
  		}

  		return closing;
  	}

  	parser.pos = start;
  	return null;
  }

  var section_readElse = section_readElse__readElse;
  var section_readElse__elsePattern = /^\s*else\s*/;
  function section_readElse__readElse(parser, tag) {
  	var start = parser.pos;

  	if (!parser.matchString(tag.open)) {
  		return null;
  	}

  	if (!parser.matchPattern(section_readElse__elsePattern)) {
  		parser.pos = start;
  		return null;
  	}

  	if (!parser.matchString(tag.close)) {
  		parser.error("Expected closing delimiter '" + tag.close + "'");
  	}

  	return {
  		t: ELSE
  	};
  }

  var readElseIf = readElseIf__readElse;
  var readElseIf__elsePattern = /^\s*elseif\s+/;
  function readElseIf__readElse(parser, tag) {
  	var start = parser.pos,
  	    expression;

  	if (!parser.matchString(tag.open)) {
  		return null;
  	}

  	if (!parser.matchPattern(readElseIf__elsePattern)) {
  		parser.pos = start;
  		return null;
  	}

  	expression = converters_readExpression(parser);

  	if (!parser.matchString(tag.close)) {
  		parser.error("Expected closing delimiter '" + tag.close + "'");
  	}

  	return {
  		t: ELSEIF,
  		x: expression
  	};
  }

  var handlebarsBlockCodes = {
  	each: SECTION_EACH,
  	"if": SECTION_IF,
  	"if-with": SECTION_IF_WITH,
  	"with": SECTION_WITH,
  	unless: SECTION_UNLESS
  };

  var mustache_readSection = readSection;

  var indexRefPattern = /^\s*:\s*([a-zA-Z_$][a-zA-Z_$0-9]*)/,
      keyIndexRefPattern = /^\s*,\s*([a-zA-Z_$][a-zA-Z_$0-9]*)/,
      handlebarsBlockPattern = new RegExp("^(" + Object.keys(handlebarsBlockCodes).join("|") + ")\\b");
  function readSection(parser, tag) {
  	var start, expression, section, child, children, hasElse, block, unlessBlock, conditions, closed, i, expectedClose;

  	start = parser.pos;

  	if (parser.matchString("^")) {
  		section = { t: SECTION, f: [], n: SECTION_UNLESS };
  	} else if (parser.matchString("#")) {
  		section = { t: SECTION, f: [] };

  		if (parser.matchString("partial")) {
  			parser.pos = start - parser.standardDelimiters[0].length;
  			parser.error("Partial definitions can only be at the top level of the template, or immediately inside components");
  		}

  		if (block = parser.matchPattern(handlebarsBlockPattern)) {
  			expectedClose = block;
  			section.n = handlebarsBlockCodes[block];
  		}
  	} else {
  		return null;
  	}

  	parser.allowWhitespace();

  	expression = converters_readExpression(parser);

  	if (!expression) {
  		parser.error("Expected expression");
  	}

  	// optional index and key references
  	if (i = parser.matchPattern(indexRefPattern)) {
  		var extra = undefined;

  		if (extra = parser.matchPattern(keyIndexRefPattern)) {
  			section.i = i + "," + extra;
  		} else {
  			section.i = i;
  		}
  	}

  	parser.allowWhitespace();

  	if (!parser.matchString(tag.close)) {
  		parser.error("Expected closing delimiter '" + tag.close + "'");
  	}

  	parser.sectionDepth += 1;
  	children = section.f;

  	conditions = [];

  	do {
  		if (child = section_readClosing(parser, tag)) {
  			if (expectedClose && child.r !== expectedClose) {
  				parser.error("Expected " + tag.open + "/" + expectedClose + "" + tag.close);
  			}

  			parser.sectionDepth -= 1;
  			closed = true;
  		} else if (child = readElseIf(parser, tag)) {
  			if (section.n === SECTION_UNLESS) {
  				parser.error("{{else}} not allowed in {{#unless}}");
  			}

  			if (hasElse) {
  				parser.error("illegal {{elseif...}} after {{else}}");
  			}

  			if (!unlessBlock) {
  				unlessBlock = createUnlessBlock(expression, section.n);
  			}

  			unlessBlock.f.push({
  				t: SECTION,
  				n: SECTION_IF,
  				x: utils_flattenExpression(mustache_readSection__combine(conditions.concat(child.x))),
  				f: children = []
  			});

  			conditions.push(invert(child.x));
  		} else if (child = section_readElse(parser, tag)) {
  			if (section.n === SECTION_UNLESS) {
  				parser.error("{{else}} not allowed in {{#unless}}");
  			}

  			if (hasElse) {
  				parser.error("there can only be one {{else}} block, at the end of a section");
  			}

  			hasElse = true;

  			// use an unless block if there's no elseif
  			if (!unlessBlock) {
  				unlessBlock = createUnlessBlock(expression, section.n);
  				children = unlessBlock.f;
  			} else {
  				unlessBlock.f.push({
  					t: SECTION,
  					n: SECTION_IF,
  					x: utils_flattenExpression(mustache_readSection__combine(conditions)),
  					f: children = []
  				});
  			}
  		} else {
  			child = parser.read(READERS);

  			if (!child) {
  				break;
  			}

  			children.push(child);
  		}
  	} while (!closed);

  	if (unlessBlock) {
  		// special case - `with` should become `if-with` (TODO is this right?
  		// seems to me that `with` ought to behave consistently, regardless
  		// of the presence/absence of `else`. In other words should always
  		// be `if-with`
  		if (section.n === SECTION_WITH) {
  			section.n = SECTION_IF_WITH;
  		}

  		section.l = unlessBlock;
  	}

  	utils_refineExpression(expression, section);

  	// TODO if a section is empty it should be discarded. Don't do
  	// that here though - we need to clean everything up first, as
  	// it may contain removeable whitespace. As a temporary measure,
  	// to pass the existing tests, remove empty `f` arrays
  	if (!section.f.length) {
  		delete section.f;
  	}

  	return section;
  }

  function createUnlessBlock(expression, sectionType) {
  	var unlessBlock;

  	if (sectionType === SECTION_WITH) {
  		// special case - a `{{#with foo}}` section will render if `foo` is
  		// truthy, so the `{{else}}` section needs to render if `foo` is falsy,
  		// rather than adhering to the normal `{{#unless foo}}` logic (which
  		// treats empty arrays/objects as falsy)
  		unlessBlock = {
  			t: SECTION,
  			n: SECTION_IF,
  			f: []
  		};

  		utils_refineExpression(invert(expression), unlessBlock);
  	} else {
  		unlessBlock = {
  			t: SECTION,
  			n: SECTION_UNLESS,
  			f: []
  		};

  		utils_refineExpression(expression, unlessBlock);
  	}

  	return unlessBlock;
  }

  function invert(expression) {
  	if (expression.t === PREFIX_OPERATOR && expression.s === "!") {
  		return expression.o;
  	}

  	return {
  		t: PREFIX_OPERATOR,
  		s: "!",
  		o: parensIfNecessary(expression)
  	};
  }

  function mustache_readSection__combine(expressions) {
  	if (expressions.length === 1) {
  		return expressions[0];
  	}

  	return {
  		t: INFIX_OPERATOR,
  		s: "&&",
  		o: [parensIfNecessary(expressions[0]), parensIfNecessary(mustache_readSection__combine(expressions.slice(1)))]
  	};
  }

  function parensIfNecessary(expression) {
  	// TODO only wrap if necessary
  	return {
  		t: BRACKETED,
  		x: expression
  	};
  }

  var converters_readHtmlComment = readHtmlComment;
  var OPEN_COMMENT = "<!--",
      CLOSE_COMMENT = "-->";
  function readHtmlComment(parser) {
  	var start, content, remaining, endIndex, comment;

  	start = parser.pos;

  	if (!parser.matchString(OPEN_COMMENT)) {
  		return null;
  	}

  	remaining = parser.remaining();
  	endIndex = remaining.indexOf(CLOSE_COMMENT);

  	if (endIndex === -1) {
  		parser.error("Illegal HTML - expected closing comment sequence ('-->')");
  	}

  	content = remaining.substr(0, endIndex);
  	parser.pos += endIndex + 3;

  	comment = {
  		t: COMMENT,
  		c: content
  	};

  	if (parser.includeLinePositions) {
  		comment.p = parser.getLinePos(start);
  	}

  	return comment;
  }

  var booleanAttributes, voidElementNames, htmlEntities, controlCharacters, entityPattern, lessThan, greaterThan, amp;

  // https://github.com/kangax/html-minifier/issues/63#issuecomment-37763316
  booleanAttributes = /^(allowFullscreen|async|autofocus|autoplay|checked|compact|controls|declare|default|defaultChecked|defaultMuted|defaultSelected|defer|disabled|enabled|formNoValidate|hidden|indeterminate|inert|isMap|itemScope|loop|multiple|muted|noHref|noResize|noShade|noValidate|noWrap|open|pauseOnExit|readOnly|required|reversed|scoped|seamless|selected|sortable|translate|trueSpeed|typeMustMatch|visible)$/i;
  voidElementNames = /^(?:area|base|br|col|command|doctype|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)$/i;

  htmlEntities = { quot: 34, amp: 38, apos: 39, lt: 60, gt: 62, nbsp: 160, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, sect: 167, uml: 168, copy: 169, ordf: 170, laquo: 171, not: 172, shy: 173, reg: 174, macr: 175, deg: 176, plusmn: 177, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, sup1: 185, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190, iquest: 191, Agrave: 192, Aacute: 193, Acirc: 194, Atilde: 195, Auml: 196, Aring: 197, AElig: 198, Ccedil: 199, Egrave: 200, Eacute: 201, Ecirc: 202, Euml: 203, Igrave: 204, Iacute: 205, Icirc: 206, Iuml: 207, ETH: 208, Ntilde: 209, Ograve: 210, Oacute: 211, Ocirc: 212, Otilde: 213, Ouml: 214, times: 215, Oslash: 216, Ugrave: 217, Uacute: 218, Ucirc: 219, Uuml: 220, Yacute: 221, THORN: 222, szlig: 223, agrave: 224, aacute: 225, acirc: 226, atilde: 227, auml: 228, aring: 229, aelig: 230, ccedil: 231, egrave: 232, eacute: 233, ecirc: 234, euml: 235, igrave: 236, iacute: 237, icirc: 238, iuml: 239, eth: 240, ntilde: 241, ograve: 242, oacute: 243, ocirc: 244, otilde: 245, ouml: 246, divide: 247, oslash: 248, ugrave: 249, uacute: 250, ucirc: 251, uuml: 252, yacute: 253, thorn: 254, yuml: 255, OElig: 338, oelig: 339, Scaron: 352, scaron: 353, Yuml: 376, fnof: 402, circ: 710, tilde: 732, Alpha: 913, Beta: 914, Gamma: 915, Delta: 916, Epsilon: 917, Zeta: 918, Eta: 919, Theta: 920, Iota: 921, Kappa: 922, Lambda: 923, Mu: 924, Nu: 925, Xi: 926, Omicron: 927, Pi: 928, Rho: 929, Sigma: 931, Tau: 932, Upsilon: 933, Phi: 934, Chi: 935, Psi: 936, Omega: 937, alpha: 945, beta: 946, gamma: 947, delta: 948, epsilon: 949, zeta: 950, eta: 951, theta: 952, iota: 953, kappa: 954, lambda: 955, mu: 956, nu: 957, xi: 958, omicron: 959, pi: 960, rho: 961, sigmaf: 962, sigma: 963, tau: 964, upsilon: 965, phi: 966, chi: 967, psi: 968, omega: 969, thetasym: 977, upsih: 978, piv: 982, ensp: 8194, emsp: 8195, thinsp: 8201, zwnj: 8204, zwj: 8205, lrm: 8206, rlm: 8207, ndash: 8211, mdash: 8212, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, bull: 8226, hellip: 8230, permil: 8240, prime: 8242, Prime: 8243, lsaquo: 8249, rsaquo: 8250, oline: 8254, frasl: 8260, euro: 8364, image: 8465, weierp: 8472, real: 8476, trade: 8482, alefsym: 8501, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, harr: 8596, crarr: 8629, lArr: 8656, uArr: 8657, rArr: 8658, dArr: 8659, hArr: 8660, forall: 8704, part: 8706, exist: 8707, empty: 8709, nabla: 8711, isin: 8712, notin: 8713, ni: 8715, prod: 8719, sum: 8721, minus: 8722, lowast: 8727, radic: 8730, prop: 8733, infin: 8734, ang: 8736, and: 8743, or: 8744, cap: 8745, cup: 8746, int: 8747, there4: 8756, sim: 8764, cong: 8773, asymp: 8776, ne: 8800, equiv: 8801, le: 8804, ge: 8805, sub: 8834, sup: 8835, nsub: 8836, sube: 8838, supe: 8839, oplus: 8853, otimes: 8855, perp: 8869, sdot: 8901, lceil: 8968, rceil: 8969, lfloor: 8970, rfloor: 8971, lang: 9001, rang: 9002, loz: 9674, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830 };
  controlCharacters = [8364, 129, 8218, 402, 8222, 8230, 8224, 8225, 710, 8240, 352, 8249, 338, 141, 381, 143, 144, 8216, 8217, 8220, 8221, 8226, 8211, 8212, 732, 8482, 353, 8250, 339, 157, 382, 376];
  entityPattern = new RegExp("&(#?(?:x[\\w\\d]+|\\d+|" + Object.keys(htmlEntities).join("|") + "));?", "g");

  function decodeCharacterReferences(html) {
  	return html.replace(entityPattern, function (match, entity) {
  		var code;

  		// Handle named entities
  		if (entity[0] !== "#") {
  			code = htmlEntities[entity];
  		} else if (entity[1] === "x") {
  			code = parseInt(entity.substring(2), 16);
  		} else {
  			code = parseInt(entity.substring(1), 10);
  		}

  		if (!code) {
  			return match;
  		}

  		return String.fromCharCode(validateCode(code));
  	});
  }

  // some code points are verboten. If we were inserting HTML, the browser would replace the illegal
  // code points with alternatives in some cases - since we're bypassing that mechanism, we need
  // to replace them ourselves
  //
  // Source: http://en.wikipedia.org/wiki/Character_encodings_in_HTML#Illegal_characters
  function validateCode(code) {
  	if (!code) {
  		return 65533;
  	}

  	// line feed becomes generic whitespace
  	if (code === 10) {
  		return 32;
  	}

  	// ASCII range. (Why someone would use HTML entities for ASCII characters I don't know, but...)
  	if (code < 128) {
  		return code;
  	}

  	// code points 128-159 are dealt with leniently by browsers, but they're incorrect. We need
  	// to correct the mistake or we'll end up with missing € signs and so on
  	if (code <= 159) {
  		return controlCharacters[code - 128];
  	}

  	// basic multilingual plane
  	if (code < 55296) {
  		return code;
  	}

  	// UTF-16 surrogate halves
  	if (code <= 57343) {
  		return 65533;
  	}

  	// rest of the basic multilingual plane
  	if (code <= 65535) {
  		return code;
  	}

  	return 65533;
  }

  lessThan = /</g;
  greaterThan = />/g;
  amp = /&/g;

  function escapeHtml(str) {
  	return str.replace(amp, "&amp;").replace(lessThan, "&lt;").replace(greaterThan, "&gt;");
  }

  var leadingLinebreak = /^\s*\r?\n/,
      trailingLinebreak = /\r?\n\s*$/;

  var stripStandalones = function (items) {
  	var i, current, backOne, backTwo, lastSectionItem;

  	for (i = 1; i < items.length; i += 1) {
  		current = items[i];
  		backOne = items[i - 1];
  		backTwo = items[i - 2];

  		// if we're at the end of a [text][comment][text] sequence...
  		if (isString(current) && isComment(backOne) && isString(backTwo)) {

  			// ... and the comment is a standalone (i.e. line breaks either side)...
  			if (trailingLinebreak.test(backTwo) && leadingLinebreak.test(current)) {

  				// ... then we want to remove the whitespace after the first line break
  				items[i - 2] = backTwo.replace(trailingLinebreak, "\n");

  				// and the leading line break of the second text token
  				items[i] = current.replace(leadingLinebreak, "");
  			}
  		}

  		// if the current item is a section, and it is preceded by a linebreak, and
  		// its first item is a linebreak...
  		if (isSection(current) && isString(backOne)) {
  			if (trailingLinebreak.test(backOne) && isString(current.f[0]) && leadingLinebreak.test(current.f[0])) {
  				items[i - 1] = backOne.replace(trailingLinebreak, "\n");
  				current.f[0] = current.f[0].replace(leadingLinebreak, "");
  			}
  		}

  		// if the last item was a section, and it is followed by a linebreak, and
  		// its last item is a linebreak...
  		if (isString(current) && isSection(backOne)) {
  			lastSectionItem = lastItem(backOne.f);

  			if (isString(lastSectionItem) && trailingLinebreak.test(lastSectionItem) && leadingLinebreak.test(current)) {
  				backOne.f[backOne.f.length - 1] = lastSectionItem.replace(trailingLinebreak, "\n");
  				items[i] = current.replace(leadingLinebreak, "");
  			}
  		}
  	}

  	return items;
  };

  function isString(item) {
  	return typeof item === "string";
  }

  function isComment(item) {
  	return item.t === COMMENT || item.t === DELIMCHANGE;
  }

  function isSection(item) {
  	return (item.t === SECTION || item.t === INVERTED) && item.f;
  }

  var trimWhitespace = function (items, leadingPattern, trailingPattern) {
  	var item;

  	if (leadingPattern) {
  		item = items[0];
  		if (typeof item === "string") {
  			item = item.replace(leadingPattern, "");

  			if (!item) {
  				items.shift();
  			} else {
  				items[0] = item;
  			}
  		}
  	}

  	if (trailingPattern) {
  		item = lastItem(items);
  		if (typeof item === "string") {
  			item = item.replace(trailingPattern, "");

  			if (!item) {
  				items.pop();
  			} else {
  				items[items.length - 1] = item;
  			}
  		}
  	}
  };

  var utils_cleanup = cleanup;
  var contiguousWhitespace = /[ \t\f\r\n]+/g;
  var preserveWhitespaceElements = /^(?:pre|script|style|textarea)$/i;
  var utils_cleanup__leadingWhitespace = /^[ \t\f\r\n]+/;
  var trailingWhitespace = /[ \t\f\r\n]+$/;
  var leadingNewLine = /^(?:\r\n|\r|\n)/;
  var trailingNewLine = /(?:\r\n|\r|\n)$/;
  function cleanup(items, stripComments, preserveWhitespace, removeLeadingWhitespace, removeTrailingWhitespace) {
  	var i, item, previousItem, nextItem, preserveWhitespaceInsideFragment, removeLeadingWhitespaceInsideFragment, removeTrailingWhitespaceInsideFragment, key;

  	// First pass - remove standalones and comments etc
  	stripStandalones(items);

  	i = items.length;
  	while (i--) {
  		item = items[i];

  		// Remove delimiter changes, unsafe elements etc
  		if (item.exclude) {
  			items.splice(i, 1);
  		}

  		// Remove comments, unless we want to keep them
  		else if (stripComments && item.t === COMMENT) {
  			items.splice(i, 1);
  		}
  	}

  	// If necessary, remove leading and trailing whitespace
  	trimWhitespace(items, removeLeadingWhitespace ? utils_cleanup__leadingWhitespace : null, removeTrailingWhitespace ? trailingWhitespace : null);

  	i = items.length;
  	while (i--) {
  		item = items[i];

  		// Recurse
  		if (item.f) {
  			var isPreserveWhitespaceElement = item.t === ELEMENT && preserveWhitespaceElements.test(item.e);
  			preserveWhitespaceInsideFragment = preserveWhitespace || isPreserveWhitespaceElement;

  			if (!preserveWhitespace && isPreserveWhitespaceElement) {
  				trimWhitespace(item.f, leadingNewLine, trailingNewLine);
  			}

  			if (!preserveWhitespaceInsideFragment) {
  				previousItem = items[i - 1];
  				nextItem = items[i + 1];

  				// if the previous item was a text item with trailing whitespace,
  				// remove leading whitespace inside the fragment
  				if (!previousItem || typeof previousItem === "string" && trailingWhitespace.test(previousItem)) {
  					removeLeadingWhitespaceInsideFragment = true;
  				}

  				// and vice versa
  				if (!nextItem || typeof nextItem === "string" && utils_cleanup__leadingWhitespace.test(nextItem)) {
  					removeTrailingWhitespaceInsideFragment = true;
  				}
  			}

  			cleanup(item.f, stripComments, preserveWhitespaceInsideFragment, removeLeadingWhitespaceInsideFragment, removeTrailingWhitespaceInsideFragment);
  		}

  		// Split if-else blocks into two (an if, and an unless)
  		if (item.l) {
  			cleanup(item.l.f, stripComments, preserveWhitespace, removeLeadingWhitespaceInsideFragment, removeTrailingWhitespaceInsideFragment);

  			items.splice(i + 1, 0, item.l);
  			delete item.l; // TODO would be nice if there was a way around this
  		}

  		// Clean up element attributes
  		if (item.a) {
  			for (key in item.a) {
  				if (item.a.hasOwnProperty(key) && typeof item.a[key] !== "string") {
  					cleanup(item.a[key], stripComments, preserveWhitespace, removeLeadingWhitespaceInsideFragment, removeTrailingWhitespaceInsideFragment);
  				}
  			}
  		}

  		// Clean up conditional attributes
  		if (item.m) {
  			cleanup(item.m, stripComments, preserveWhitespace, removeLeadingWhitespaceInsideFragment, removeTrailingWhitespaceInsideFragment);
  		}

  		// Clean up event handlers
  		if (item.v) {
  			for (key in item.v) {
  				if (item.v.hasOwnProperty(key)) {
  					// clean up names
  					if (isArray(item.v[key].n)) {
  						cleanup(item.v[key].n, stripComments, preserveWhitespace, removeLeadingWhitespaceInsideFragment, removeTrailingWhitespaceInsideFragment);
  					}

  					// clean up params
  					if (isArray(item.v[key].d)) {
  						cleanup(item.v[key].d, stripComments, preserveWhitespace, removeLeadingWhitespaceInsideFragment, removeTrailingWhitespaceInsideFragment);
  					}
  				}
  			}
  		}
  	}

  	// final pass - fuse text nodes together
  	i = items.length;
  	while (i--) {
  		if (typeof items[i] === "string") {
  			if (typeof items[i + 1] === "string") {
  				items[i] = items[i] + items[i + 1];
  				items.splice(i + 1, 1);
  			}

  			if (!preserveWhitespace) {
  				items[i] = items[i].replace(contiguousWhitespace, " ");
  			}

  			if (items[i] === "") {
  				items.splice(i, 1);
  			}
  		}
  	}
  }

  var element_readClosingTag = readClosingTag;
  var closingTagPattern = /^([a-zA-Z]{1,}:?[a-zA-Z0-9\-]*)\s*\>/;
  function readClosingTag(parser) {
  	var start, tag;

  	start = parser.pos;

  	// are we looking at a closing tag?
  	if (!parser.matchString("</")) {
  		return null;
  	}

  	if (tag = parser.matchPattern(closingTagPattern)) {
  		if (parser.inside && tag !== parser.inside) {
  			parser.pos = start;
  			return null;
  		}

  		return {
  			t: CLOSING_TAG,
  			e: tag
  		};
  	}

  	// We have an illegal closing tag, report it
  	parser.pos -= 2;
  	parser.error("Illegal closing tag");
  }

  var getLowestIndex = function (haystack, needles) {
  	var i, index, lowest;

  	i = needles.length;
  	while (i--) {
  		index = haystack.indexOf(needles[i]);

  		// short circuit
  		if (!index) {
  			return 0;
  		}

  		if (index === -1) {
  			continue;
  		}

  		if (!lowest || index < lowest) {
  			lowest = index;
  		}
  	}

  	return lowest || -1;
  };

  var element_readAttribute = readAttribute;

  var attributeNamePattern = /^[^\s"'>\/=]+/,
      unquotedAttributeValueTextPattern = /^[^\s"'=<>`]+/;
  function readAttribute(parser) {
  	var attr, name, value;

  	parser.allowWhitespace();

  	name = parser.matchPattern(attributeNamePattern);
  	if (!name) {
  		return null;
  	}

  	attr = { name: name };

  	value = readAttributeValue(parser);
  	if (value != null) {
  		// not null/undefined
  		attr.value = value;
  	}

  	return attr;
  }

  function readAttributeValue(parser) {
  	var start, valueStart, startDepth, value;

  	start = parser.pos;

  	// next character must be `=`, `/`, `>` or whitespace
  	if (!/[=\/>\s]/.test(parser.nextChar())) {
  		parser.error("Expected `=`, `/`, `>` or whitespace");
  	}

  	parser.allowWhitespace();

  	if (!parser.matchString("=")) {
  		parser.pos = start;
  		return null;
  	}

  	parser.allowWhitespace();

  	valueStart = parser.pos;
  	startDepth = parser.sectionDepth;

  	value = readQuotedAttributeValue(parser, "'") || readQuotedAttributeValue(parser, "\"") || readUnquotedAttributeValue(parser);

  	if (value === null) {
  		parser.error("Expected valid attribute value");
  	}

  	if (parser.sectionDepth !== startDepth) {
  		parser.pos = valueStart;
  		parser.error("An attribute value must contain as many opening section tags as closing section tags");
  	}

  	if (!value.length) {
  		return "";
  	}

  	if (value.length === 1 && typeof value[0] === "string") {
  		return decodeCharacterReferences(value[0]);
  	}

  	return value;
  }

  function readUnquotedAttributeValueToken(parser) {
  	var start, text, haystack, needles, index;

  	start = parser.pos;

  	text = parser.matchPattern(unquotedAttributeValueTextPattern);

  	if (!text) {
  		return null;
  	}

  	haystack = text;
  	needles = parser.tags.map(function (t) {
  		return t.open;
  	}); // TODO refactor... we do this in readText.js as well

  	if ((index = getLowestIndex(haystack, needles)) !== -1) {
  		text = text.substr(0, index);
  		parser.pos = start + text.length;
  	}

  	return text;
  }

  function readUnquotedAttributeValue(parser) {
  	var tokens, token;

  	parser.inAttribute = true;

  	tokens = [];

  	token = converters_readMustache(parser) || readUnquotedAttributeValueToken(parser);
  	while (token !== null) {
  		tokens.push(token);
  		token = converters_readMustache(parser) || readUnquotedAttributeValueToken(parser);
  	}

  	if (!tokens.length) {
  		return null;
  	}

  	parser.inAttribute = false;
  	return tokens;
  }

  function readQuotedAttributeValue(parser, quoteMark) {
  	var start, tokens, token;

  	start = parser.pos;

  	if (!parser.matchString(quoteMark)) {
  		return null;
  	}

  	parser.inAttribute = quoteMark;

  	tokens = [];

  	token = converters_readMustache(parser) || readQuotedStringToken(parser, quoteMark);
  	while (token !== null) {
  		tokens.push(token);
  		token = converters_readMustache(parser) || readQuotedStringToken(parser, quoteMark);
  	}

  	if (!parser.matchString(quoteMark)) {
  		parser.pos = start;
  		return null;
  	}

  	parser.inAttribute = false;

  	return tokens;
  }

  function readQuotedStringToken(parser, quoteMark) {
  	var start, index, haystack, needles;

  	start = parser.pos;
  	haystack = parser.remaining();

  	needles = parser.tags.map(function (t) {
  		return t.open;
  	}); // TODO refactor... we do this in readText.js as well
  	needles.push(quoteMark);

  	index = getLowestIndex(haystack, needles);

  	if (index === -1) {
  		parser.error("Quoted attribute value must have a closing quote");
  	}

  	if (!index) {
  		return null;
  	}

  	parser.pos += index;
  	return haystack.substr(0, index);
  }

  var JsonParser, specials, specialsPattern, parseJSON__numberPattern, placeholderPattern, placeholderAtStartPattern, onlyWhitespace;

  specials = {
  	"true": true,
  	"false": false,
  	undefined: undefined,
  	"null": null
  };

  specialsPattern = new RegExp("^(?:" + Object.keys(specials).join("|") + ")");
  parseJSON__numberPattern = /^(?:[+-]?)(?:(?:(?:0|[1-9]\d*)?\.\d+)|(?:(?:0|[1-9]\d*)\.)|(?:0|[1-9]\d*))(?:[eE][+-]?\d+)?/;
  placeholderPattern = /\$\{([^\}]+)\}/g;
  placeholderAtStartPattern = /^\$\{([^\}]+)\}/;
  onlyWhitespace = /^\s*$/;

  JsonParser = parse_Parser.extend({
  	init: function (str, options) {
  		this.values = options.values;
  		this.allowWhitespace();
  	},

  	postProcess: function (result) {
  		if (result.length !== 1 || !onlyWhitespace.test(this.leftover)) {
  			return null;
  		}

  		return { value: result[0].v };
  	},

  	converters: [function getPlaceholder(parser) {
  		var placeholder;

  		if (!parser.values) {
  			return null;
  		}

  		placeholder = parser.matchPattern(placeholderAtStartPattern);

  		if (placeholder && parser.values.hasOwnProperty(placeholder)) {
  			return { v: parser.values[placeholder] };
  		}
  	}, function getSpecial(parser) {
  		var special;

  		if (special = parser.matchPattern(specialsPattern)) {
  			return { v: specials[special] };
  		}
  	}, function getNumber(parser) {
  		var number;

  		if (number = parser.matchPattern(parseJSON__numberPattern)) {
  			return { v: +number };
  		}
  	}, function getString(parser) {
  		var stringLiteral = readStringLiteral(parser),
  		    values;

  		if (stringLiteral && (values = parser.values)) {
  			return {
  				v: stringLiteral.v.replace(placeholderPattern, function (match, $1) {
  					return $1 in values ? values[$1] : $1;
  				})
  			};
  		}

  		return stringLiteral;
  	}, function getObject(parser) {
  		var result, pair;

  		if (!parser.matchString("{")) {
  			return null;
  		}

  		result = {};

  		parser.allowWhitespace();

  		if (parser.matchString("}")) {
  			return { v: result };
  		}

  		while (pair = getKeyValuePair(parser)) {
  			result[pair.key] = pair.value;

  			parser.allowWhitespace();

  			if (parser.matchString("}")) {
  				return { v: result };
  			}

  			if (!parser.matchString(",")) {
  				return null;
  			}
  		}

  		return null;
  	}, function getArray(parser) {
  		var result, valueToken;

  		if (!parser.matchString("[")) {
  			return null;
  		}

  		result = [];

  		parser.allowWhitespace();

  		if (parser.matchString("]")) {
  			return { v: result };
  		}

  		while (valueToken = parser.read()) {
  			result.push(valueToken.v);

  			parser.allowWhitespace();

  			if (parser.matchString("]")) {
  				return { v: result };
  			}

  			if (!parser.matchString(",")) {
  				return null;
  			}

  			parser.allowWhitespace();
  		}

  		return null;
  	}]
  });

  function getKeyValuePair(parser) {
  	var key, valueToken, pair;

  	parser.allowWhitespace();

  	key = shared_readKey(parser);

  	if (!key) {
  		return null;
  	}

  	pair = { key: key };

  	parser.allowWhitespace();
  	if (!parser.matchString(":")) {
  		return null;
  	}
  	parser.allowWhitespace();

  	valueToken = parser.read();
  	if (!valueToken) {
  		return null;
  	}

  	pair.value = valueToken.v;

  	return pair;
  }

  var parseJSON = function (str, values) {
  	var parser = new JsonParser(str, {
  		values: values
  	});

  	return parser.result;
  };

  // TODO clean this up, it's shocking
  var element_processDirective = processDirective;
  var methodCallPattern = /^([a-zA-Z_$][a-zA-Z_$0-9]*)\(/,
      methodCallExcessPattern = /\)\s*$/,
      ExpressionParser;

  ExpressionParser = parse_Parser.extend({
  	converters: [converters_readExpression]
  });
  function processDirective(tokens, parentParser) {
  	var result, match, parser, args, token, colonIndex, directiveName, directiveArgs, parsed;

  	if (typeof tokens === "string") {
  		if (match = methodCallPattern.exec(tokens)) {
  			var end = tokens.lastIndexOf(")");

  			// check for invalid method calls
  			if (!methodCallExcessPattern.test(tokens)) {
  				parentParser.error("Invalid input after method call expression '" + tokens.slice(end + 1) + "'");
  			}

  			result = { m: match[1] };
  			args = "[" + tokens.slice(result.m.length + 1, end) + "]";

  			parser = new ExpressionParser(args);
  			result.a = utils_flattenExpression(parser.result[0]);

  			return result;
  		}

  		if (tokens.indexOf(":") === -1) {
  			return tokens.trim();
  		}

  		tokens = [tokens];
  	}

  	result = {};

  	directiveName = [];
  	directiveArgs = [];

  	if (tokens) {
  		while (tokens.length) {
  			token = tokens.shift();

  			if (typeof token === "string") {
  				colonIndex = token.indexOf(":");

  				if (colonIndex === -1) {
  					directiveName.push(token);
  				} else {

  					// is the colon the first character?
  					if (colonIndex) {
  						// no
  						directiveName.push(token.substr(0, colonIndex));
  					}

  					// if there is anything after the colon in this token, treat
  					// it as the first token of the directiveArgs fragment
  					if (token.length > colonIndex + 1) {
  						directiveArgs[0] = token.substring(colonIndex + 1);
  					}

  					break;
  				}
  			} else {
  				directiveName.push(token);
  			}
  		}

  		directiveArgs = directiveArgs.concat(tokens);
  	}

  	if (!directiveName.length) {
  		result = "";
  	} else if (directiveArgs.length || typeof directiveName !== "string") {
  		result = {
  			// TODO is this really necessary? just use the array
  			n: directiveName.length === 1 && typeof directiveName[0] === "string" ? directiveName[0] : directiveName
  		};

  		if (directiveArgs.length === 1 && typeof directiveArgs[0] === "string") {
  			parsed = parseJSON("[" + directiveArgs[0] + "]");
  			result.a = parsed ? parsed.value : directiveArgs[0].trim();
  		} else {
  			result.d = directiveArgs;
  		}
  	} else {
  		result = directiveName;
  	}

  	return result;
  }

  var tagNamePattern = /^[a-zA-Z]{1,}:?[a-zA-Z0-9\-]*/,
      validTagNameFollower = /^[\s\n\/>]/,
      onPattern = /^on/,
      proxyEventPattern = /^on-([a-zA-Z\\*\\.$_][a-zA-Z\\*\\.$_0-9\-]+)$/,
      reservedEventNames = /^(?:change|reset|teardown|update|construct|config|init|render|unrender|detach|insert)$/,
      directives = { "intro-outro": "t0", intro: "t1", outro: "t2", decorator: "o" },
      exclude = { exclude: true },
      disallowedContents;

  // based on http://developers.whatwg.org/syntax.html#syntax-tag-omission
  disallowedContents = {
  	li: ["li"],
  	dt: ["dt", "dd"],
  	dd: ["dt", "dd"],
  	p: "address article aside blockquote div dl fieldset footer form h1 h2 h3 h4 h5 h6 header hgroup hr main menu nav ol p pre section table ul".split(" "),
  	rt: ["rt", "rp"],
  	rp: ["rt", "rp"],
  	optgroup: ["optgroup"],
  	option: ["option", "optgroup"],
  	thead: ["tbody", "tfoot"],
  	tbody: ["tbody", "tfoot"],
  	tfoot: ["tbody"],
  	tr: ["tr", "tbody"],
  	td: ["td", "th", "tr"],
  	th: ["td", "th", "tr"]
  };

  var converters_readElement = readElement;

  function readElement(parser) {
  	var start, element, directiveName, match, addProxyEvent, attribute, directive, selfClosing, children, partials, hasPartials, child, closed, pos, remaining, closingTag;

  	start = parser.pos;

  	if (parser.inside || parser.inAttribute) {
  		return null;
  	}

  	if (!parser.matchString("<")) {
  		return null;
  	}

  	// if this is a closing tag, abort straight away
  	if (parser.nextChar() === "/") {
  		return null;
  	}

  	element = {};
  	if (parser.includeLinePositions) {
  		element.p = parser.getLinePos(start);
  	}

  	if (parser.matchString("!")) {
  		element.t = DOCTYPE;
  		if (!parser.matchPattern(/^doctype/i)) {
  			parser.error("Expected DOCTYPE declaration");
  		}

  		element.a = parser.matchPattern(/^(.+?)>/);
  		return element;
  	}

  	element.t = ELEMENT;

  	// element name
  	element.e = parser.matchPattern(tagNamePattern);
  	if (!element.e) {
  		return null;
  	}

  	// next character must be whitespace, closing solidus or '>'
  	if (!validTagNameFollower.test(parser.nextChar())) {
  		parser.error("Illegal tag name");
  	}

  	addProxyEvent = function (name, directive) {
  		var directiveName = directive.n || directive;

  		if (reservedEventNames.test(directiveName)) {
  			parser.pos -= directiveName.length;
  			parser.error("Cannot use reserved event names (change, reset, teardown, update, construct, config, init, render, unrender, detach, insert)");
  		}

  		element.v[name] = directive;
  	};

  	parser.allowWhitespace();

  	// directives and attributes
  	while (attribute = converters_readMustache(parser) || element_readAttribute(parser)) {
  		// regular attributes
  		if (attribute.name) {
  			// intro, outro, decorator
  			if (directiveName = directives[attribute.name]) {
  				element[directiveName] = element_processDirective(attribute.value, parser);
  			}

  			// on-click etc
  			else if (match = proxyEventPattern.exec(attribute.name)) {
  				if (!element.v) element.v = {};
  				directive = element_processDirective(attribute.value, parser);
  				addProxyEvent(match[1], directive);
  			} else {
  				if (!parser.sanitizeEventAttributes || !onPattern.test(attribute.name)) {
  					if (!element.a) element.a = {};
  					element.a[attribute.name] = attribute.value || (attribute.value === "" ? "" : 0);
  				}
  			}
  		}

  		// {{#if foo}}class='foo'{{/if}}
  		else {
  			if (!element.m) element.m = [];
  			element.m.push(attribute);
  		}

  		parser.allowWhitespace();
  	}

  	// allow whitespace before closing solidus
  	parser.allowWhitespace();

  	// self-closing solidus?
  	if (parser.matchString("/")) {
  		selfClosing = true;
  	}

  	// closing angle bracket
  	if (!parser.matchString(">")) {
  		return null;
  	}

  	var lowerCaseName = element.e.toLowerCase();
  	var preserveWhitespace = parser.preserveWhitespace;

  	if (!selfClosing && !voidElementNames.test(element.e)) {
  		parser.elementStack.push(lowerCaseName);

  		// Special case - if we open a script element, further tags should
  		// be ignored unless they're a closing script element
  		if (lowerCaseName === "script" || lowerCaseName === "style") {
  			parser.inside = lowerCaseName;
  		}

  		children = [];
  		partials = create(null);

  		do {
  			pos = parser.pos;
  			remaining = parser.remaining();

  			// if for example we're in an <li> element, and we see another
  			// <li> tag, close the first so they become siblings
  			if (!canContain(lowerCaseName, remaining)) {
  				closed = true;
  			}

  			// closing tag
  			else if (closingTag = element_readClosingTag(parser)) {
  				closed = true;

  				var closingTagName = closingTag.e.toLowerCase();

  				// if this *isn't* the closing tag for the current element...
  				if (closingTagName !== lowerCaseName) {
  					// rewind parser
  					parser.pos = pos;

  					// if it doesn't close a parent tag, error
  					if (! ~parser.elementStack.indexOf(closingTagName)) {
  						var errorMessage = "Unexpected closing tag";

  						// add additional help for void elements, since component names
  						// might clash with them
  						if (voidElementNames.test(closingTagName)) {
  							errorMessage += " (<" + closingTagName + "> is a void element - it cannot contain children)";
  						}

  						parser.error(errorMessage);
  					}
  				}
  			}

  			// implicit close by closing section tag. TODO clean this up
  			else if (child = section_readClosing(parser, { open: parser.standardDelimiters[0], close: parser.standardDelimiters[1] })) {
  				closed = true;
  				parser.pos = pos;
  			} else {
  				if (child = parser.read(PARTIAL_READERS)) {
  					if (partials[child.n]) {
  						parser.pos = pos;
  						parser.error("Duplicate partial definition");
  					}

  					utils_cleanup(child.f, parser.stripComments, preserveWhitespace, !preserveWhitespace, !preserveWhitespace);

  					partials[child.n] = child.f;
  					hasPartials = true;
  				} else {
  					if (child = parser.read(READERS)) {
  						children.push(child);
  					} else {
  						closed = true;
  					}
  				}
  			}
  		} while (!closed);

  		if (children.length) {
  			element.f = children;
  		}

  		if (hasPartials) {
  			element.p = partials;
  		}

  		parser.elementStack.pop();
  	}

  	parser.inside = null;

  	if (parser.sanitizeElements && parser.sanitizeElements.indexOf(lowerCaseName) !== -1) {
  		return exclude;
  	}

  	return element;
  }

  function canContain(name, remaining) {
  	var match, disallowed;

  	match = /^<([a-zA-Z][a-zA-Z0-9]*)/.exec(remaining);
  	disallowed = disallowedContents[name];

  	if (!match || !disallowed) {
  		return true;
  	}

  	return ! ~disallowed.indexOf(match[1].toLowerCase());
  }

  var converters_readText = readText;
  function readText(parser) {
  	var index, remaining, disallowed, barrier;

  	remaining = parser.remaining();

  	barrier = parser.inside ? "</" + parser.inside : "<";

  	if (parser.inside && !parser.interpolate[parser.inside]) {
  		index = remaining.indexOf(barrier);
  	} else {
  		disallowed = parser.tags.map(function (t) {
  			return t.open;
  		});
  		disallowed = disallowed.concat(parser.tags.map(function (t) {
  			return "\\" + t.open;
  		}));

  		// http://developers.whatwg.org/syntax.html#syntax-attributes
  		if (parser.inAttribute === true) {
  			// we're inside an unquoted attribute value
  			disallowed.push("\"", "'", "=", "<", ">", "`");
  		} else if (parser.inAttribute) {
  			// quoted attribute value
  			disallowed.push(parser.inAttribute);
  		} else {
  			disallowed.push(barrier);
  		}

  		index = getLowestIndex(remaining, disallowed);
  	}

  	if (!index) {
  		return null;
  	}

  	if (index === -1) {
  		index = remaining.length;
  	}

  	parser.pos += index;

  	return parser.inside ? remaining.substr(0, index) : decodeCharacterReferences(remaining.substr(0, index));
  }

  var utils_escapeRegExp = escapeRegExp;
  var utils_escapeRegExp__pattern = /[-/\\^$*+?.()|[\]{}]/g;
  function escapeRegExp(str) {
  	return str.replace(utils_escapeRegExp__pattern, "\\$&");
  }

  var converters_readPartialDefinitionComment = readPartialDefinitionComment;

  var startPattern = /^<!--\s*/,
      namePattern = /s*>\s*([a-zA-Z_$][-a-zA-Z_$0-9]*)\s*/,
      finishPattern = /\s*-->/,
      child;

  function readPartialDefinitionComment(parser) {
  	var firstPos = parser.pos,
  	    open = parser.standardDelimiters[0],
  	    close = parser.standardDelimiters[1],
  	    content = undefined,
  	    closed = undefined;

  	if (!parser.matchPattern(startPattern) || !parser.matchString(open)) {
  		parser.pos = firstPos;
  		return null;
  	}

  	var name = parser.matchPattern(namePattern);

  	warnOnceIfDebug("Inline partial comments are deprecated.\nUse this...\n  {{#partial " + name + "}} ... {{/partial}}\n\n...instead of this:\n  <!-- {{>" + name + "}} --> ... <!-- {{/" + name + "}} -->'");

  	// make sure the rest of the comment is in the correct place
  	if (!parser.matchString(close) || !parser.matchPattern(finishPattern)) {
  		parser.pos = firstPos;
  		return null;
  	}

  	content = [];

  	var endPattern = new RegExp("^<!--\\s*" + utils_escapeRegExp(open) + "\\s*\\/\\s*" + name + "\\s*" + utils_escapeRegExp(close) + "\\s*-->");

  	do {
  		if (parser.matchPattern(endPattern)) {
  			closed = true;
  		} else {
  			child = parser.read(READERS);
  			if (!child) {
  				parser.error("expected closing comment ('<!-- " + open + "/" + name + "" + close + " -->')");
  			}

  			content.push(child);
  		}
  	} while (!closed);

  	return {
  		t: INLINE_PARTIAL,
  		f: content,
  		n: name
  	};
  }

  var converters_readPartialDefinitionSection = readPartialDefinitionSection;
  var partialDefinitionSectionPattern = /^#\s*partial\s+/;
  function readPartialDefinitionSection(parser) {
  	var start, name, content, child, closed;

  	start = parser.pos;

  	var delimiters = parser.standardDelimiters;

  	if (!parser.matchString(delimiters[0])) {
  		return null;
  	}

  	if (!parser.matchPattern(partialDefinitionSectionPattern)) {
  		parser.pos = start;
  		return null;
  	}

  	name = parser.matchPattern(/^[a-zA-Z_$][a-zA-Z_$0-9\-]*/);

  	if (!name) {
  		parser.error("expected legal partial name");
  	}

  	if (!parser.matchString(delimiters[1])) {
  		parser.error("Expected closing delimiter '" + delimiters[1] + "'");
  	}

  	content = [];

  	do {
  		// TODO clean this up
  		if (child = section_readClosing(parser, { open: parser.standardDelimiters[0], close: parser.standardDelimiters[1] })) {
  			if (!child.r === "partial") {
  				parser.error("Expected " + delimiters[0] + "/partial" + delimiters[1]);
  			}

  			closed = true;
  		} else {
  			child = parser.read(READERS);

  			if (!child) {
  				parser.error("Expected " + delimiters[0] + "/partial" + delimiters[1]);
  			}

  			content.push(child);
  		}
  	} while (!closed);

  	return {
  		t: INLINE_PARTIAL,
  		n: name,
  		f: content
  	};
  }

  var converters_readTemplate = readTemplate;
  function readTemplate(parser) {
  	var fragment = [];
  	var partials = create(null);
  	var hasPartials = false;

  	var preserveWhitespace = parser.preserveWhitespace;

  	while (parser.pos < parser.str.length) {
  		var pos = parser.pos,
  		    item = undefined,
  		    partial = undefined;

  		if (partial = parser.read(PARTIAL_READERS)) {
  			if (partials[partial.n]) {
  				parser.pos = pos;
  				parser.error("Duplicated partial definition");
  			}

  			utils_cleanup(partial.f, parser.stripComments, preserveWhitespace, !preserveWhitespace, !preserveWhitespace);

  			partials[partial.n] = partial.f;
  			hasPartials = true;
  		} else if (item = parser.read(READERS)) {
  			fragment.push(item);
  		} else {
  			parser.error("Unexpected template content");
  		}
  	}

  	var result = {
  		v: TEMPLATE_VERSION,
  		t: fragment
  	};

  	if (hasPartials) {
  		result.p = partials;
  	}

  	return result;
  }

  var _parse = parse;

  var STANDARD_READERS = [mustache_readPartial, mustache_readUnescaped, mustache_readSection, mustache_readYielder, mustache_readInterpolator, readMustacheComment];
  var TRIPLE_READERS = [mustache_readTriple];
  var STATIC_READERS = [mustache_readUnescaped, mustache_readSection, mustache_readInterpolator]; // TODO does it make sense to have a static section?

  var StandardParser = undefined;
  function parse(template, options) {
  	return new StandardParser(template, options || {}).result;
  }

  var READERS = [converters_readMustache, converters_readHtmlComment, converters_readElement, converters_readText];
  var PARTIAL_READERS = [converters_readPartialDefinitionComment, converters_readPartialDefinitionSection];

  StandardParser = parse_Parser.extend({
  	init: function (str, options) {
  		var tripleDelimiters = options.tripleDelimiters || ["{{{", "}}}"],
  		    staticDelimiters = options.staticDelimiters || ["[[", "]]"],
  		    staticTripleDelimiters = options.staticTripleDelimiters || ["[[[", "]]]"];

  		this.standardDelimiters = options.delimiters || ["{{", "}}"];

  		this.tags = [{ isStatic: false, isTriple: false, open: this.standardDelimiters[0], close: this.standardDelimiters[1], readers: STANDARD_READERS }, { isStatic: false, isTriple: true, open: tripleDelimiters[0], close: tripleDelimiters[1], readers: TRIPLE_READERS }, { isStatic: true, isTriple: false, open: staticDelimiters[0], close: staticDelimiters[1], readers: STATIC_READERS }, { isStatic: true, isTriple: true, open: staticTripleDelimiters[0], close: staticTripleDelimiters[1], readers: TRIPLE_READERS }];

  		this.sortMustacheTags();

  		this.sectionDepth = 0;
  		this.elementStack = [];

  		this.interpolate = {
  			script: !options.interpolate || options.interpolate.script !== false,
  			style: !options.interpolate || options.interpolate.style !== false
  		};

  		if (options.sanitize === true) {
  			options.sanitize = {
  				// blacklist from https://code.google.com/p/google-caja/source/browse/trunk/src/com/google/caja/lang/html/html4-elements-whitelist.json
  				elements: "applet base basefont body frame frameset head html isindex link meta noframes noscript object param script style title".split(" "),
  				eventAttributes: true
  			};
  		}

  		this.stripComments = options.stripComments !== false;
  		this.preserveWhitespace = options.preserveWhitespace;
  		this.sanitizeElements = options.sanitize && options.sanitize.elements;
  		this.sanitizeEventAttributes = options.sanitize && options.sanitize.eventAttributes;
  		this.includeLinePositions = options.includeLinePositions;
  	},

  	postProcess: function (result) {
  		// special case - empty string
  		if (!result.length) {
  			return { t: [], v: TEMPLATE_VERSION };
  		}

  		if (this.sectionDepth > 0) {
  			this.error("A section was left open");
  		}

  		utils_cleanup(result[0].t, this.stripComments, this.preserveWhitespace, !this.preserveWhitespace, !this.preserveWhitespace);

  		return result[0];
  	},

  	converters: [converters_readTemplate],

  	sortMustacheTags: function () {
  		// Sort in order of descending opening delimiter length (longer first),
  		// to protect against opening delimiters being substrings of each other
  		this.tags.sort(function (a, b) {
  			return b.open.length - a.open.length;
  		});
  	}
  });

  var parseOptions = ["preserveWhitespace", "sanitize", "stripComments", "delimiters", "tripleDelimiters", "interpolate"];

  var parser = {
  	fromId: fromId, isHashedId: isHashedId, isParsed: isParsed, getParseOptions: getParseOptions, createHelper: template_parser__createHelper,
  	parse: doParse
  };

  function template_parser__createHelper(parseOptions) {
  	var helper = create(parser);
  	helper.parse = function (template, options) {
  		return doParse(template, options || parseOptions);
  	};
  	return helper;
  }

  function doParse(template, parseOptions) {
  	if (!_parse) {
  		throw new Error("Missing Ractive.parse - cannot parse template. Either preparse or use the version that includes the parser");
  	}

  	return _parse(template, parseOptions || this.options);
  }

  function fromId(id, options) {
  	var template;

  	if (!isClient) {
  		if (options && options.noThrow) {
  			return;
  		}
  		throw new Error("Cannot retrieve template #" + id + " as Ractive is not running in a browser.");
  	}

  	if (isHashedId(id)) {
  		id = id.substring(1);
  	}

  	if (!(template = document.getElementById(id))) {
  		if (options && options.noThrow) {
  			return;
  		}
  		throw new Error("Could not find template element with id #" + id);
  	}

  	if (template.tagName.toUpperCase() !== "SCRIPT") {
  		if (options && options.noThrow) {
  			return;
  		}
  		throw new Error("Template element with id #" + id + ", must be a <script> element");
  	}

  	return "textContent" in template ? template.textContent : template.innerHTML;
  }

  function isHashedId(id) {
  	return id && id[0] === "#";
  }

  function isParsed(template) {
  	return !(typeof template === "string");
  }

  function getParseOptions(ractive) {
  	// Could be Ractive or a Component
  	if (ractive.defaults) {
  		ractive = ractive.defaults;
  	}

  	return parseOptions.reduce(function (val, key) {
  		val[key] = ractive[key];
  		return val;
  	}, {});
  }

  var template_parser = parser;

  var templateConfigurator = {
  	name: "template",

  	extend: function extend(Parent, proto, options) {
  		var template;

  		// only assign if exists
  		if ("template" in options) {
  			template = options.template;

  			if (typeof template === "function") {
  				proto.template = template;
  			} else {
  				proto.template = parseIfString(template, proto);
  			}
  		}
  	},

  	init: function init(Parent, ractive, options) {
  		var template, fn;

  		// TODO because of prototypal inheritance, we might just be able to use
  		// ractive.template, and not bother passing through the Parent object.
  		// At present that breaks the test mocks' expectations
  		template = "template" in options ? options.template : Parent.prototype.template;

  		if (typeof template === "function") {
  			fn = template;
  			template = getDynamicTemplate(ractive, fn);

  			ractive._config.template = {
  				fn: fn,
  				result: template
  			};
  		}

  		template = parseIfString(template, ractive);

  		// TODO the naming of this is confusing - ractive.template refers to [...],
  		// but Component.prototype.template refers to {v:1,t:[],p:[]}...
  		// it's unnecessary, because the developer never needs to access
  		// ractive.template
  		ractive.template = template.t;

  		if (template.p) {
  			extendPartials(ractive.partials, template.p);
  		}
  	},

  	reset: function (ractive) {
  		var result = resetValue(ractive),
  		    parsed;

  		if (result) {
  			parsed = parseIfString(result, ractive);

  			ractive.template = parsed.t;
  			extendPartials(ractive.partials, parsed.p, true);

  			return true;
  		}
  	}
  };

  function resetValue(ractive) {
  	var initial = ractive._config.template,
  	    result;

  	// If this isn't a dynamic template, there's nothing to do
  	if (!initial || !initial.fn) {
  		return;
  	}

  	result = getDynamicTemplate(ractive, initial.fn);

  	// TODO deep equality check to prevent unnecessary re-rendering
  	// in the case of already-parsed templates
  	if (result !== initial.result) {
  		initial.result = result;
  		result = parseIfString(result, ractive);
  		return result;
  	}
  }

  function getDynamicTemplate(ractive, fn) {
  	var helper = template_template__createHelper(template_parser.getParseOptions(ractive));
  	return fn.call(ractive, helper);
  }

  function template_template__createHelper(parseOptions) {
  	var helper = create(template_parser);
  	helper.parse = function (template, options) {
  		return template_parser.parse(template, options || parseOptions);
  	};
  	return helper;
  }

  function parseIfString(template, ractive) {
  	if (typeof template === "string") {
  		// ID of an element containing the template?
  		if (template[0] === "#") {
  			template = template_parser.fromId(template);
  		}

  		template = _parse(template, template_parser.getParseOptions(ractive));
  	}

  	// Check that the template even exists
  	else if (template == undefined) {
  		throw new Error("The template cannot be " + template + ".");
  	}

  	// Check the parsed template has a version at all
  	else if (typeof template.v !== "number") {
  		throw new Error("The template parser was passed a non-string template, but the template doesn't have a version.  Make sure you're passing in the template you think you are.");
  	}

  	// Check we're using the correct version
  	else if (template.v !== TEMPLATE_VERSION) {
  		throw new Error("Mismatched template version (expected " + TEMPLATE_VERSION + ", got " + template.v + ") Please ensure you are using the latest version of Ractive.js in your build process as well as in your app");
  	}

  	return template;
  }

  function extendPartials(existingPartials, newPartials, overwrite) {
  	if (!newPartials) return;

  	// TODO there's an ambiguity here - we need to overwrite in the `reset()`
  	// case, but not initially...

  	for (var key in newPartials) {
  		if (overwrite || !existingPartials.hasOwnProperty(key)) {
  			existingPartials[key] = newPartials[key];
  		}
  	}
  }

  var template_template = templateConfigurator;

  var config_registries__registryNames, Registry, registries;

  config_registries__registryNames = ["adaptors", "components", "computed", "decorators", "easing", "events", "interpolators", "partials", "transitions"];

  Registry = function (name, useDefaults) {
  	this.name = name;
  	this.useDefaults = useDefaults;
  };

  Registry.prototype = {
  	constructor: Registry,

  	extend: function (Parent, proto, options) {
  		this.configure(this.useDefaults ? Parent.defaults : Parent, this.useDefaults ? proto : proto.constructor, options);
  	},

  	init: function () {},

  	configure: function (Parent, target, options) {
  		var name = this.name,
  		    option = options[name],
  		    registry;

  		registry = create(Parent[name]);

  		for (var key in option) {
  			registry[key] = option[key];
  		}

  		target[name] = registry;
  	},

  	reset: function (ractive) {
  		var registry = ractive[this.name];
  		var changed = false;
  		Object.keys(registry).forEach(function (key) {
  			var item = registry[key];
  			if (item._fn) {
  				if (item._fn.isOwner) {
  					registry[key] = item._fn;
  				} else {
  					delete registry[key];
  				}
  				changed = true;
  			}
  		});
  		return changed;
  	}
  };

  registries = config_registries__registryNames.map(function (name) {
  	return new Registry(name, name === "computed");
  });

  var config_registries = registries;

  /*this.configure(
  	this.useDefaults ? Parent.defaults : Parent,
  	ractive,
  	options );*/

  var wrapPrototype = wrap;

  function wrap(parent, name, method) {
  	if (!/_super/.test(method)) {
  		return method;
  	}

  	var wrapper = function wrapSuper() {
  		var superMethod = getSuperMethod(wrapper._parent, name),
  		    hasSuper = ("_super" in this),
  		    oldSuper = this._super,
  		    result;

  		this._super = superMethod;

  		result = method.apply(this, arguments);

  		if (hasSuper) {
  			this._super = oldSuper;
  		} else {
  			delete this._super;
  		}

  		return result;
  	};

  	wrapper._parent = parent;
  	wrapper._method = method;

  	return wrapper;
  }

  function getSuperMethod(parent, name) {
  	var value, method;

  	if (name in parent) {
  		value = parent[name];

  		if (typeof value === "function") {
  			method = value;
  		} else {
  			method = function returnValue() {
  				return value;
  			};
  		}
  	} else {
  		method = noop;
  	}

  	return method;
  }

  var config_deprecate = deprecate;
  function getMessage(deprecated, correct, isError) {
  	return "options." + deprecated + " has been deprecated in favour of options." + correct + "." + (isError ? " You cannot specify both options, please use options." + correct + "." : "");
  }

  function deprecateOption(options, deprecatedOption, correct) {
  	if (deprecatedOption in options) {
  		if (!(correct in options)) {
  			warnIfDebug(getMessage(deprecatedOption, correct));
  			options[correct] = options[deprecatedOption];
  		} else {
  			throw new Error(getMessage(deprecatedOption, correct, true));
  		}
  	}
  }
  function deprecate(options) {
  	deprecateOption(options, "beforeInit", "onconstruct");
  	deprecateOption(options, "init", "onrender");
  	deprecateOption(options, "complete", "oncomplete");
  	deprecateOption(options, "eventDefinitions", "events");

  	// Using extend with Component instead of options,
  	// like Human.extend( Spider ) means adaptors as a registry
  	// gets copied to options. So we have to check if actually an array
  	if (isArray(options.adaptors)) {
  		deprecateOption(options, "adaptors", "adapt");
  	}
  }

  var config, order, defaultKeys, custom, isBlacklisted, isStandardKey;

  custom = {
  	adapt: custom_adapt,
  	css: css_css,
  	data: custom_data,
  	template: template_template
  };

  defaultKeys = Object.keys(config_defaults);

  isStandardKey = makeObj(defaultKeys.filter(function (key) {
  	return !custom[key];
  }));

  // blacklisted keys that we don't double extend
  isBlacklisted = makeObj(defaultKeys.concat(config_registries.map(function (r) {
  	return r.name;
  })));

  order = [].concat(defaultKeys.filter(function (key) {
  	return !config_registries[key] && !custom[key];
  }), config_registries, custom.data, custom.template, custom.css);

  config = {
  	extend: function (Parent, proto, options) {
  		return configure("extend", Parent, proto, options);
  	},

  	init: function (Parent, ractive, options) {
  		return configure("init", Parent, ractive, options);
  	},

  	reset: function (ractive) {
  		return order.filter(function (c) {
  			return c.reset && c.reset(ractive);
  		}).map(function (c) {
  			return c.name;
  		});
  	},

  	// this defines the order. TODO this isn't used anywhere in the codebase,
  	// only in the test suite - should get rid of it
  	order: order };

  function configure(method, Parent, target, options) {
  	config_deprecate(options);

  	for (var key in options) {
  		if (isStandardKey.hasOwnProperty(key)) {
  			var value = options[key];

  			// warn the developer if they passed a function and ignore its value

  			// NOTE: we allow some functions on "el" because we duck type element lists
  			// and some libraries or ef'ed-up virtual browsers (phantomJS) return a
  			// function object as the result of querySelector methods
  			if (key !== "el" && typeof value === "function") {
  				warnIfDebug("" + key + " is a Ractive option that does not expect a function and will be ignored", method === "init" ? target : null);
  			} else {
  				target[key] = value;
  			}
  		}
  	}

  	config_registries.forEach(function (registry) {
  		registry[method](Parent, target, options);
  	});

  	custom_adapt[method](Parent, target, options);
  	template_template[method](Parent, target, options);
  	css_css[method](Parent, target, options);

  	extendOtherMethods(Parent.prototype, target, options);
  }

  function extendOtherMethods(parent, target, options) {
  	for (var key in options) {
  		if (!isBlacklisted[key] && options.hasOwnProperty(key)) {
  			var member = options[key];

  			// if this is a method that overwrites a method, wrap it:
  			if (typeof member === "function") {
  				member = wrapPrototype(parent, key, member);
  			}

  			target[key] = member;
  		}
  	}
  }

  function makeObj(array) {
  	var obj = {};
  	array.forEach(function (x) {
  		return obj[x] = true;
  	});
  	return obj;
  }

  var config_config = config;

  var prototype_bubble = Fragment$bubble;

  function Fragment$bubble() {
  	this.dirtyValue = this.dirtyArgs = true;

  	if (this.bound && typeof this.owner.bubble === "function") {
  		this.owner.bubble();
  	}
  }

  var Fragment_prototype_detach = Fragment$detach;

  function Fragment$detach() {
  	var docFrag;

  	if (this.items.length === 1) {
  		return this.items[0].detach();
  	}

  	docFrag = document.createDocumentFragment();

  	this.items.forEach(function (item) {
  		var node = item.detach();

  		// TODO The if {...} wasn't previously required - it is now, because we're
  		// forcibly detaching everything to reorder sections after an update. That's
  		// a non-ideal brute force approach, implemented to get all the tests to pass
  		// - as soon as it's replaced with something more elegant, this should
  		// revert to `docFrag.appendChild( item.detach() )`
  		if (node) {
  			docFrag.appendChild(node);
  		}
  	});

  	return docFrag;
  }

  var Fragment_prototype_find = Fragment$find;

  function Fragment$find(selector) {
  	var i, len, item, queryResult;

  	if (this.items) {
  		len = this.items.length;
  		for (i = 0; i < len; i += 1) {
  			item = this.items[i];

  			if (item.find && (queryResult = item.find(selector))) {
  				return queryResult;
  			}
  		}

  		return null;
  	}
  }

  var Fragment_prototype_findAll = Fragment$findAll;

  function Fragment$findAll(selector, query) {
  	var i, len, item;

  	if (this.items) {
  		len = this.items.length;
  		for (i = 0; i < len; i += 1) {
  			item = this.items[i];

  			if (item.findAll) {
  				item.findAll(selector, query);
  			}
  		}
  	}

  	return query;
  }

  var Fragment_prototype_findAllComponents = Fragment$findAllComponents;

  function Fragment$findAllComponents(selector, query) {
  	var i, len, item;

  	if (this.items) {
  		len = this.items.length;
  		for (i = 0; i < len; i += 1) {
  			item = this.items[i];

  			if (item.findAllComponents) {
  				item.findAllComponents(selector, query);
  			}
  		}
  	}

  	return query;
  }

  var Fragment_prototype_findComponent = Fragment$findComponent;

  function Fragment$findComponent(selector) {
  	var len, i, item, queryResult;

  	if (this.items) {
  		len = this.items.length;
  		for (i = 0; i < len; i += 1) {
  			item = this.items[i];

  			if (item.findComponent && (queryResult = item.findComponent(selector))) {
  				return queryResult;
  			}
  		}

  		return null;
  	}
  }

  var prototype_findNextNode = Fragment$findNextNode;

  function Fragment$findNextNode(item) {
  	var index = item.index,
  	    node;

  	if (this.items[index + 1]) {
  		node = this.items[index + 1].firstNode();
  	}

  	// if this is the root fragment, and there are no more items,
  	// it means we're at the end...
  	else if (this.owner === this.root) {
  		if (!this.owner.component) {
  			// TODO but something else could have been appended to
  			// this.root.el, no?
  			node = null;
  		}

  		// ...unless this is a component
  		else {
  			node = this.owner.component.findNextNode();
  		}
  	} else {
  		node = this.owner.findNextNode(this);
  	}

  	return node;
  }

  var prototype_firstNode = Fragment$firstNode;

  function Fragment$firstNode() {
  	if (this.items && this.items[0]) {
  		return this.items[0].firstNode();
  	}

  	return null;
  }

  var shared_processItems = processItems;

  function processItems(items, values, guid, counter) {
  	counter = counter || 0;

  	return items.map(function (item) {
  		var placeholderId, wrapped, value;

  		if (item.text) {
  			return item.text;
  		}

  		if (item.fragments) {
  			return item.fragments.map(function (fragment) {
  				return processItems(fragment.items, values, guid, counter);
  			}).join("");
  		}

  		placeholderId = guid + "-" + counter++;

  		if (item.keypath && (wrapped = item.root.viewmodel.wrapped[item.keypath.str])) {
  			value = wrapped.value;
  		} else {
  			value = item.getValue();
  		}

  		values[placeholderId] = value;

  		return "${" + placeholderId + "}";
  	}).join("");
  }

  var getArgsList = Fragment$getArgsList;
  function Fragment$getArgsList() {
  	var values, source, parsed, result;

  	if (this.dirtyArgs) {
  		source = shared_processItems(this.items, values = {}, this.root._guid);
  		parsed = parseJSON("[" + source + "]", values);

  		if (!parsed) {
  			result = [this.toString()];
  		} else {
  			result = parsed.value;
  		}

  		this.argsList = result;
  		this.dirtyArgs = false;
  	}

  	return this.argsList;
  }

  var getNode = Fragment$getNode;

  function Fragment$getNode() {
  	var fragment = this;

  	do {
  		if (fragment.pElement) {
  			return fragment.pElement.node;
  		}
  	} while (fragment = fragment.parent);

  	return this.root.detached || this.root.el;
  }

  var prototype_getValue = Fragment$getValue;
  function Fragment$getValue() {
  	var values, source, parsed, result;

  	if (this.dirtyValue) {
  		source = shared_processItems(this.items, values = {}, this.root._guid);
  		parsed = parseJSON(source, values);

  		if (!parsed) {
  			result = this.toString();
  		} else {
  			result = parsed.value;
  		}

  		this.value = result;
  		this.dirtyValue = false;
  	}

  	return this.value;
  }

  var shared_detach = function () {
  	return detachNode(this.node);
  };

  var Text = function (options) {
  	this.type = TEXT;
  	this.text = options.template;
  };

  Text.prototype = {
  	detach: shared_detach,

  	firstNode: function () {
  		return this.node;
  	},

  	render: function () {
  		if (!this.node) {
  			this.node = document.createTextNode(this.text);
  		}

  		return this.node;
  	},

  	toString: function (escape) {
  		return escape ? escapeHtml(this.text) : this.text;
  	},

  	unrender: function (shouldDestroy) {
  		if (shouldDestroy) {
  			return this.detach();
  		}
  	}
  };

  var items_Text = Text;

  var shared_unbind = shared_unbind__unbind;

  function shared_unbind__unbind() {
  	if (this.registered) {
  		// this was registered as a dependant
  		this.root.viewmodel.unregister(this.keypath, this);
  	}

  	if (this.resolver) {
  		this.resolver.unbind();
  	}
  }

  var Mustache_getValue = Mustache$getValue;

  function Mustache$getValue() {
  	return this.value;
  }

  var ReferenceResolver = function (owner, ref, callback) {
  	var keypath;

  	this.ref = ref;
  	this.resolved = false;

  	this.root = owner.root;
  	this.parentFragment = owner.parentFragment;
  	this.callback = callback;

  	keypath = shared_resolveRef(owner.root, ref, owner.parentFragment);
  	if (keypath != undefined) {
  		this.resolve(keypath);
  	} else {
  		global_runloop.addUnresolved(this);
  	}
  };

  ReferenceResolver.prototype = {
  	resolve: function (keypath) {
  		if (this.keypath && !keypath) {
  			// it was resolved, and now it's not. Can happen if e.g. `bar` in
  			// `{{foo[bar]}}` becomes undefined
  			global_runloop.addUnresolved(this);
  		}

  		this.resolved = true;

  		this.keypath = keypath;
  		this.callback(keypath);
  	},

  	forceResolution: function () {
  		this.resolve(getKeypath(this.ref));
  	},

  	rebind: function (oldKeypath, newKeypath) {
  		var keypath;

  		if (this.keypath != undefined) {
  			keypath = this.keypath.replace(oldKeypath, newKeypath);
  			// was a new keypath created?
  			if (keypath !== undefined) {
  				// resolve it
  				this.resolve(keypath);
  			}
  		}
  	},

  	unbind: function () {
  		if (!this.resolved) {
  			global_runloop.removeUnresolved(this);
  		}
  	}
  };

  var Resolvers_ReferenceResolver = ReferenceResolver;

  var SpecialResolver = function (owner, ref, callback) {
  	this.parentFragment = owner.parentFragment;
  	this.ref = ref;
  	this.callback = callback;

  	this.rebind();
  };

  var props = {
  	"@keypath": { prefix: "c", prop: ["context"] },
  	"@index": { prefix: "i", prop: ["index"] },
  	"@key": { prefix: "k", prop: ["key", "index"] }
  };

  function getProp(target, prop) {
  	var value;
  	for (var i = 0; i < prop.prop.length; i++) {
  		if ((value = target[prop.prop[i]]) !== undefined) {
  			return value;
  		}
  	}
  }

  SpecialResolver.prototype = {
  	rebind: function () {
  		var ref = this.ref,
  		    fragment = this.parentFragment,
  		    prop = props[ref],
  		    value;

  		if (!prop) {
  			throw new Error("Unknown special reference \"" + ref + "\" - valid references are @index, @key and @keypath");
  		}

  		// have we already found the nearest parent?
  		if (this.cached) {
  			return this.callback(getKeypath("@" + prop.prefix + getProp(this.cached, prop)));
  		}

  		// special case for indices, which may cross component boundaries
  		if (prop.prop.indexOf("index") !== -1 || prop.prop.indexOf("key") !== -1) {
  			while (fragment) {
  				if (fragment.owner.currentSubtype === SECTION_EACH && (value = getProp(fragment, prop)) !== undefined) {
  					this.cached = fragment;

  					fragment.registerIndexRef(this);

  					return this.callback(getKeypath("@" + prop.prefix + value));
  				}

  				// watch for component boundaries
  				if (!fragment.parent && fragment.owner && fragment.owner.component && fragment.owner.component.parentFragment && !fragment.owner.component.instance.isolated) {
  					fragment = fragment.owner.component.parentFragment;
  				} else {
  					fragment = fragment.parent;
  				}
  			}
  		} else {
  			while (fragment) {
  				if ((value = getProp(fragment, prop)) !== undefined) {
  					return this.callback(getKeypath("@" + prop.prefix + value.str));
  				}

  				fragment = fragment.parent;
  			}
  		}
  	},

  	unbind: function () {
  		if (this.cached) {
  			this.cached.unregisterIndexRef(this);
  		}
  	}
  };

  var Resolvers_SpecialResolver = SpecialResolver;

  var IndexResolver = function (owner, ref, callback) {
  	this.parentFragment = owner.parentFragment;
  	this.ref = ref;
  	this.callback = callback;

  	ref.ref.fragment.registerIndexRef(this);

  	this.rebind();
  };

  IndexResolver.prototype = {
  	rebind: function () {
  		var index,
  		    ref = this.ref.ref;

  		if (ref.ref.t === "k") {
  			index = "k" + ref.fragment.key;
  		} else {
  			index = "i" + ref.fragment.index;
  		}

  		if (index !== undefined) {
  			this.callback(getKeypath("@" + index));
  		}
  	},

  	unbind: function () {
  		this.ref.ref.fragment.unregisterIndexRef(this);
  	}
  };

  var Resolvers_IndexResolver = IndexResolver;

  var Resolvers_findIndexRefs = findIndexRefs;

  function findIndexRefs(fragment, refName) {
  	var result = {},
  	    refs,
  	    fragRefs,
  	    ref,
  	    i,
  	    owner,
  	    hit = false;

  	if (!refName) {
  		result.refs = refs = {};
  	}

  	while (fragment) {
  		if ((owner = fragment.owner) && (fragRefs = owner.indexRefs)) {

  			// we're looking for a particular ref, and it's here
  			if (refName && (ref = owner.getIndexRef(refName))) {
  				result.ref = {
  					fragment: fragment,
  					ref: ref
  				};
  				return result;
  			}

  			// we're collecting refs up-tree
  			else if (!refName) {
  				for (i in fragRefs) {
  					ref = fragRefs[i];

  					// don't overwrite existing refs - they should shadow parents
  					if (!refs[ref.n]) {
  						hit = true;
  						refs[ref.n] = {
  							fragment: fragment,
  							ref: ref
  						};
  					}
  				}
  			}
  		}

  		// watch for component boundaries
  		if (!fragment.parent && fragment.owner && fragment.owner.component && fragment.owner.component.parentFragment && !fragment.owner.component.instance.isolated) {
  			result.componentBoundary = true;
  			fragment = fragment.owner.component.parentFragment;
  		} else {
  			fragment = fragment.parent;
  		}
  	}

  	if (!hit) {
  		return undefined;
  	} else {
  		return result;
  	}
  }

  findIndexRefs.resolve = function resolve(indices) {
  	var refs = {},
  	    k,
  	    ref;

  	for (k in indices.refs) {
  		ref = indices.refs[k];
  		refs[ref.ref.n] = ref.ref.t === "k" ? ref.fragment.key : ref.fragment.index;
  	}

  	return refs;
  };

  var Resolvers_createReferenceResolver = createReferenceResolver;
  function createReferenceResolver(owner, ref, callback) {
  	var indexRef;

  	if (ref.charAt(0) === "@") {
  		return new Resolvers_SpecialResolver(owner, ref, callback);
  	}

  	if (indexRef = Resolvers_findIndexRefs(owner.parentFragment, ref)) {
  		return new Resolvers_IndexResolver(owner, indexRef, callback);
  	}

  	return new Resolvers_ReferenceResolver(owner, ref, callback);
  }

  var shared_getFunctionFromString = getFunctionFromString;
  var cache = {};
  function getFunctionFromString(str, i) {
  	var fn, args;

  	if (cache[str]) {
  		return cache[str];
  	}

  	args = [];
  	while (i--) {
  		args[i] = "_" + i;
  	}

  	fn = new Function(args.join(","), "return(" + str + ")");

  	cache[str] = fn;
  	return fn;
  }

  var ExpressionResolver,
      Resolvers_ExpressionResolver__bind = Function.prototype.bind;

  ExpressionResolver = function (owner, parentFragment, expression, callback) {
  	var _this = this;

  	var ractive;

  	ractive = owner.root;

  	this.root = ractive;
  	this.parentFragment = parentFragment;
  	this.callback = callback;
  	this.owner = owner;
  	this.str = expression.s;
  	this.keypaths = [];

  	// Create resolvers for each reference
  	this.pending = expression.r.length;
  	this.refResolvers = expression.r.map(function (ref, i) {
  		return Resolvers_createReferenceResolver(_this, ref, function (keypath) {
  			_this.resolve(i, keypath);
  		});
  	});

  	this.ready = true;
  	this.bubble();
  };

  ExpressionResolver.prototype = {
  	bubble: function () {
  		if (!this.ready) {
  			return;
  		}

  		this.uniqueString = getUniqueString(this.str, this.keypaths);
  		this.keypath = createExpressionKeypath(this.uniqueString);

  		this.createEvaluator();
  		this.callback(this.keypath);
  	},

  	unbind: function () {
  		var resolver;

  		while (resolver = this.refResolvers.pop()) {
  			resolver.unbind();
  		}
  	},

  	resolve: function (index, keypath) {
  		this.keypaths[index] = keypath;
  		this.bubble();
  	},

  	createEvaluator: function () {
  		var _this = this;

  		var computation, valueGetters, signature, keypath, fn;

  		keypath = this.keypath;
  		computation = this.root.viewmodel.computations[keypath.str];

  		// only if it doesn't exist yet!
  		if (!computation) {
  			fn = shared_getFunctionFromString(this.str, this.refResolvers.length);

  			valueGetters = this.keypaths.map(function (keypath) {
  				var value;

  				if (keypath === "undefined") {
  					return function () {
  						return undefined;
  					};
  				}

  				// 'special' keypaths encode a value
  				if (keypath.isSpecial) {
  					value = keypath.value;
  					return function () {
  						return value;
  					};
  				}

  				return function () {
  					var value = _this.root.viewmodel.get(keypath, { noUnwrap: true, fullRootGet: true });
  					if (typeof value === "function") {
  						value = wrapFunction(value, _this.root);
  					}
  					return value;
  				};
  			});

  			signature = {
  				deps: this.keypaths.filter(isValidDependency),
  				getter: function () {
  					var args = valueGetters.map(call);
  					return fn.apply(null, args);
  				}
  			};

  			computation = this.root.viewmodel.compute(keypath, signature);
  		} else {
  			this.root.viewmodel.mark(keypath);
  		}
  	},

  	rebind: function (oldKeypath, newKeypath) {
  		// TODO only bubble once, no matter how many references are affected by the rebind
  		this.refResolvers.forEach(function (r) {
  			return r.rebind(oldKeypath, newKeypath);
  		});
  	}
  };

  var Resolvers_ExpressionResolver = ExpressionResolver;

  function call(value) {
  	return value.call();
  }

  function getUniqueString(str, keypaths) {
  	// get string that is unique to this expression
  	return str.replace(/_([0-9]+)/g, function (match, $1) {
  		var keypath, value;

  		// make sure we're not replacing a non-keypath _[0-9]
  		if (+$1 >= keypaths.length) {
  			return "_" + $1;
  		}

  		keypath = keypaths[$1];

  		if (keypath === undefined) {
  			return "undefined";
  		}

  		if (keypath.isSpecial) {
  			value = keypath.value;
  			return typeof value === "number" ? value : "\"" + value + "\"";
  		}

  		return keypath.str;
  	});
  }

  function createExpressionKeypath(uniqueString) {
  	// Sanitize by removing any periods or square brackets. Otherwise
  	// we can't split the keypath into keys!
  	// Remove asterisks too, since they mess with pattern observers
  	return getKeypath("${" + uniqueString.replace(/[\.\[\]]/g, "-").replace(/\*/, "#MUL#") + "}");
  }

  function isValidDependency(keypath) {
  	return keypath !== undefined && keypath[0] !== "@";
  }

  function wrapFunction(fn, ractive) {
  	var wrapped, prop, key;

  	if (fn.__ractive_nowrap) {
  		return fn;
  	}

  	prop = "__ractive_" + ractive._guid;
  	wrapped = fn[prop];

  	if (wrapped) {
  		return wrapped;
  	} else if (/this/.test(fn.toString())) {
  		defineProperty(fn, prop, {
  			value: Resolvers_ExpressionResolver__bind.call(fn, ractive),
  			configurable: true
  		});

  		// Add properties/methods to wrapped function
  		for (key in fn) {
  			if (fn.hasOwnProperty(key)) {
  				fn[prop][key] = fn[key];
  			}
  		}

  		ractive._boundFunctions.push({
  			fn: fn,
  			prop: prop
  		});

  		return fn[prop];
  	}

  	defineProperty(fn, "__ractive_nowrap", {
  		value: fn
  	});

  	return fn.__ractive_nowrap;
  }

  var MemberResolver = function (template, resolver, parentFragment) {
  	var _this = this;

  	this.resolver = resolver;
  	this.root = resolver.root;
  	this.parentFragment = parentFragment;
  	this.viewmodel = resolver.root.viewmodel;

  	if (typeof template === "string") {
  		this.value = template;
  	}

  	// Simple reference?
  	else if (template.t === REFERENCE) {
  		this.refResolver = Resolvers_createReferenceResolver(this, template.n, function (keypath) {
  			_this.resolve(keypath);
  		});
  	}

  	// Otherwise we have an expression in its own right
  	else {
  		new Resolvers_ExpressionResolver(resolver, parentFragment, template, function (keypath) {
  			_this.resolve(keypath);
  		});
  	}
  };

  MemberResolver.prototype = {
  	resolve: function (keypath) {
  		if (this.keypath) {
  			this.viewmodel.unregister(this.keypath, this);
  		}

  		this.keypath = keypath;
  		this.value = this.viewmodel.get(keypath);

  		this.bind();

  		this.resolver.bubble();
  	},

  	bind: function () {
  		this.viewmodel.register(this.keypath, this);
  	},

  	rebind: function (oldKeypath, newKeypath) {
  		if (this.refResolver) {
  			this.refResolver.rebind(oldKeypath, newKeypath);
  		}
  	},

  	setValue: function (value) {
  		this.value = value;
  		this.resolver.bubble();
  	},

  	unbind: function () {
  		if (this.keypath) {
  			this.viewmodel.unregister(this.keypath, this);
  		}

  		if (this.refResolver) {
  			this.refResolver.unbind();
  		}
  	},

  	forceResolution: function () {
  		if (this.refResolver) {
  			this.refResolver.forceResolution();
  		}
  	}
  };

  var ReferenceExpressionResolver_MemberResolver = MemberResolver;

  var ReferenceExpressionResolver = function (mustache, template, callback) {
  	var _this = this;

  	var ractive, ref, keypath, parentFragment;

  	this.parentFragment = parentFragment = mustache.parentFragment;
  	this.root = ractive = mustache.root;
  	this.mustache = mustache;

  	this.ref = ref = template.r;
  	this.callback = callback;

  	this.unresolved = [];

  	// Find base keypath
  	if (keypath = shared_resolveRef(ractive, ref, parentFragment)) {
  		this.base = keypath;
  	} else {
  		this.baseResolver = new Resolvers_ReferenceResolver(this, ref, function (keypath) {
  			_this.base = keypath;
  			_this.baseResolver = null;
  			_this.bubble();
  		});
  	}

  	// Find values for members, or mark them as unresolved
  	this.members = template.m.map(function (template) {
  		return new ReferenceExpressionResolver_MemberResolver(template, _this, parentFragment);
  	});

  	this.ready = true;
  	this.bubble(); // trigger initial resolution if possible
  };

  ReferenceExpressionResolver.prototype = {
  	getKeypath: function () {
  		var values = this.members.map(ReferenceExpressionResolver_ReferenceExpressionResolver__getValue);

  		if (!values.every(isDefined) || this.baseResolver) {
  			return null;
  		}

  		return this.base.join(values.join("."));
  	},

  	bubble: function () {
  		if (!this.ready || this.baseResolver) {
  			return;
  		}

  		this.callback(this.getKeypath());
  	},

  	unbind: function () {
  		this.members.forEach(methodCallers__unbind);
  	},

  	rebind: function (oldKeypath, newKeypath) {
  		var changed;

  		if (this.base) {
  			var newBase = this.base.replace(oldKeypath, newKeypath);
  			if (newBase && newBase !== this.base) {
  				this.base = newBase;
  				changed = true;
  			}
  		}

  		this.members.forEach(function (members) {
  			if (members.rebind(oldKeypath, newKeypath)) {
  				changed = true;
  			}
  		});

  		if (changed) {
  			this.bubble();
  		}
  	},

  	forceResolution: function () {
  		if (this.baseResolver) {
  			this.base = getKeypath(this.ref);

  			this.baseResolver.unbind();
  			this.baseResolver = null;
  		}

  		this.members.forEach(forceResolution);
  		this.bubble();
  	}
  };

  function ReferenceExpressionResolver_ReferenceExpressionResolver__getValue(member) {
  	return member.value;
  }

  function isDefined(value) {
  	return value != undefined;
  }

  function forceResolution(member) {
  	member.forceResolution();
  }

  var ReferenceExpressionResolver_ReferenceExpressionResolver = ReferenceExpressionResolver;

  var Mustache_initialise = Mustache$init;
  function Mustache$init(mustache, options) {

  	var ref, parentFragment, template;

  	parentFragment = options.parentFragment;
  	template = options.template;

  	mustache.root = parentFragment.root;
  	mustache.parentFragment = parentFragment;
  	mustache.pElement = parentFragment.pElement;

  	mustache.template = options.template;
  	mustache.index = options.index || 0;
  	mustache.isStatic = options.template.s;

  	mustache.type = options.template.t;

  	mustache.registered = false;

  	// if this is a simple mustache, with a reference, we just need to resolve
  	// the reference to a keypath
  	if (ref = template.r) {
  		mustache.resolver = Resolvers_createReferenceResolver(mustache, ref, resolve);
  	}

  	// if it's an expression, we have a bit more work to do
  	if (options.template.x) {
  		mustache.resolver = new Resolvers_ExpressionResolver(mustache, parentFragment, options.template.x, resolveAndRebindChildren);
  	}

  	if (options.template.rx) {
  		mustache.resolver = new ReferenceExpressionResolver_ReferenceExpressionResolver(mustache, options.template.rx, resolveAndRebindChildren);
  	}

  	// Special case - inverted sections
  	if (mustache.template.n === SECTION_UNLESS && !mustache.hasOwnProperty("value")) {
  		mustache.setValue(undefined);
  	}

  	function resolve(keypath) {
  		mustache.resolve(keypath);
  	}

  	function resolveAndRebindChildren(newKeypath) {
  		var oldKeypath = mustache.keypath;

  		if (newKeypath != oldKeypath) {
  			mustache.resolve(newKeypath);

  			if (oldKeypath !== undefined) {
  				mustache.fragments && mustache.fragments.forEach(function (f) {
  					f.rebind(oldKeypath, newKeypath);
  				});
  			}
  		}
  	}
  }

  var Mustache_resolve = Mustache$resolve;

  function Mustache$resolve(keypath) {
  	var wasResolved, value, twowayBinding;

  	// 'Special' keypaths, e.g. @foo or @7, encode a value
  	if (keypath && keypath.isSpecial) {
  		this.keypath = keypath;
  		this.setValue(keypath.value);
  		return;
  	}

  	// If we resolved previously, we need to unregister
  	if (this.registered) {
  		// undefined or null
  		this.root.viewmodel.unregister(this.keypath, this);
  		this.registered = false;

  		wasResolved = true;
  	}

  	this.keypath = keypath;

  	// If the new keypath exists, we need to register
  	// with the viewmodel
  	if (keypath != undefined) {
  		// undefined or null
  		value = this.root.viewmodel.get(keypath);
  		this.root.viewmodel.register(keypath, this);

  		this.registered = true;
  	}

  	// Either way we need to queue up a render (`value`
  	// will be `undefined` if there's no keypath)
  	this.setValue(value);

  	// Two-way bindings need to point to their new target keypath
  	if (wasResolved && (twowayBinding = this.twowayBinding)) {
  		twowayBinding.rebound();
  	}
  }

  var Mustache_rebind = Mustache$rebind;

  function Mustache$rebind(oldKeypath, newKeypath) {
  	// Children first
  	if (this.fragments) {
  		this.fragments.forEach(function (f) {
  			return f.rebind(oldKeypath, newKeypath);
  		});
  	}

  	// Expression mustache?
  	if (this.resolver) {
  		this.resolver.rebind(oldKeypath, newKeypath);
  	}
  }

  var Mustache = {
  	getValue: Mustache_getValue,
  	init: Mustache_initialise,
  	resolve: Mustache_resolve,
  	rebind: Mustache_rebind
  };

  var Interpolator = function (options) {
  	this.type = INTERPOLATOR;
  	Mustache.init(this, options);
  };

  Interpolator.prototype = {
  	update: function () {
  		this.node.data = this.value == undefined ? "" : this.value;
  	},
  	resolve: Mustache.resolve,
  	rebind: Mustache.rebind,
  	detach: shared_detach,

  	unbind: shared_unbind,

  	render: function () {
  		if (!this.node) {
  			this.node = document.createTextNode(safeToStringValue(this.value));
  		}

  		return this.node;
  	},

  	unrender: function (shouldDestroy) {
  		if (shouldDestroy) {
  			detachNode(this.node);
  		}
  	},

  	getValue: Mustache.getValue,

  	// TEMP
  	setValue: function (value) {
  		var wrapper;

  		// TODO is there a better way to approach this?
  		if (this.keypath && (wrapper = this.root.viewmodel.wrapped[this.keypath.str])) {
  			value = wrapper.get();
  		}

  		if (!isEqual(value, this.value)) {
  			this.value = value;
  			this.parentFragment.bubble();

  			if (this.node) {
  				global_runloop.addView(this);
  			}
  		}
  	},

  	firstNode: function () {
  		return this.node;
  	},

  	toString: function (escape) {
  		var string = "" + safeToStringValue(this.value);
  		return escape ? escapeHtml(string) : string;
  	}
  };

  var items_Interpolator = Interpolator;

  var Section_prototype_bubble = Section$bubble;

  function Section$bubble() {
  	this.parentFragment.bubble();
  }

  var Section_prototype_detach = Section$detach;

  function Section$detach() {
  	var docFrag;

  	if (this.fragments.length === 1) {
  		return this.fragments[0].detach();
  	}

  	docFrag = document.createDocumentFragment();

  	this.fragments.forEach(function (item) {
  		docFrag.appendChild(item.detach());
  	});

  	return docFrag;
  }

  var find = Section$find;

  function Section$find(selector) {
  	var i, len, queryResult;

  	len = this.fragments.length;
  	for (i = 0; i < len; i += 1) {
  		if (queryResult = this.fragments[i].find(selector)) {
  			return queryResult;
  		}
  	}

  	return null;
  }

  var findAll = Section$findAll;

  function Section$findAll(selector, query) {
  	var i, len;

  	len = this.fragments.length;
  	for (i = 0; i < len; i += 1) {
  		this.fragments[i].findAll(selector, query);
  	}
  }

  var findAllComponents = Section$findAllComponents;

  function Section$findAllComponents(selector, query) {
  	var i, len;

  	len = this.fragments.length;
  	for (i = 0; i < len; i += 1) {
  		this.fragments[i].findAllComponents(selector, query);
  	}
  }

  var findComponent = Section$findComponent;

  function Section$findComponent(selector) {
  	var i, len, queryResult;

  	len = this.fragments.length;
  	for (i = 0; i < len; i += 1) {
  		if (queryResult = this.fragments[i].findComponent(selector)) {
  			return queryResult;
  		}
  	}

  	return null;
  }

  var findNextNode = Section$findNextNode;

  function Section$findNextNode(fragment) {
  	if (this.fragments[fragment.index + 1]) {
  		return this.fragments[fragment.index + 1].firstNode();
  	}

  	return this.parentFragment.findNextNode(this);
  }

  var firstNode = Section$firstNode;

  function Section$firstNode() {
  	var len, i, node;

  	if (len = this.fragments.length) {
  		for (i = 0; i < len; i += 1) {
  			if (node = this.fragments[i].firstNode()) {
  				return node;
  			}
  		}
  	}

  	return this.parentFragment.findNextNode(this);
  }

  var shuffle = Section$shuffle;

  function Section$shuffle(newIndices) {
  	var _this = this;

  	var parentFragment, firstChange, i, newLength, reboundFragments, fragmentOptions, fragment;

  	// short circuit any double-updates, and ensure that this isn't applied to
  	// non-list sections
  	if (this.shuffling || this.unbound || this.currentSubtype !== SECTION_EACH) {
  		return;
  	}

  	this.shuffling = true;
  	global_runloop.scheduleTask(function () {
  		return _this.shuffling = false;
  	});

  	parentFragment = this.parentFragment;

  	reboundFragments = [];

  	// TODO: need to update this
  	// first, rebind existing fragments
  	newIndices.forEach(function (newIndex, oldIndex) {
  		var fragment, by, oldKeypath, newKeypath, deps;

  		if (newIndex === oldIndex) {
  			reboundFragments[newIndex] = _this.fragments[oldIndex];
  			return;
  		}

  		fragment = _this.fragments[oldIndex];

  		if (firstChange === undefined) {
  			firstChange = oldIndex;
  		}

  		// does this fragment need to be torn down?
  		if (newIndex === -1) {
  			_this.fragmentsToUnrender.push(fragment);
  			fragment.unbind();
  			return;
  		}

  		// Otherwise, it needs to be rebound to a new index
  		by = newIndex - oldIndex;
  		oldKeypath = _this.keypath.join(oldIndex);
  		newKeypath = _this.keypath.join(newIndex);

  		fragment.index = newIndex;

  		// notify any registered index refs directly
  		if (deps = fragment.registeredIndexRefs) {
  			deps.forEach(shuffle__blindRebind);
  		}

  		fragment.rebind(oldKeypath, newKeypath);
  		reboundFragments[newIndex] = fragment;
  	});

  	newLength = this.root.viewmodel.get(this.keypath).length;

  	// If nothing changed with the existing fragments, then we start adding
  	// new fragments at the end...
  	if (firstChange === undefined) {
  		// ...unless there are no new fragments to add
  		if (this.length === newLength) {
  			return;
  		}

  		firstChange = this.length;
  	}

  	this.length = this.fragments.length = newLength;

  	if (this.rendered) {
  		global_runloop.addView(this);
  	}

  	// Prepare new fragment options
  	fragmentOptions = {
  		template: this.template.f,
  		root: this.root,
  		owner: this
  	};

  	// Add as many new fragments as we need to, or add back existing
  	// (detached) fragments
  	for (i = firstChange; i < newLength; i += 1) {
  		fragment = reboundFragments[i];

  		if (!fragment) {
  			this.fragmentsToCreate.push(i);
  		}

  		this.fragments[i] = fragment;
  	}
  }

  function shuffle__blindRebind(dep) {
  	// the keypath doesn't actually matter here as it won't have changed
  	dep.rebind("", "");
  }

  var prototype_rebind = function (oldKeypath, newKeypath) {
  	Mustache.rebind.call(this, oldKeypath, newKeypath);
  };

  var Section_prototype_render = Section$render;

  function Section$render() {
  	var _this = this;

  	this.docFrag = document.createDocumentFragment();

  	this.fragments.forEach(function (f) {
  		return _this.docFrag.appendChild(f.render());
  	});

  	this.renderedFragments = this.fragments.slice();
  	this.fragmentsToRender = [];

  	this.rendered = true;
  	return this.docFrag;
  }

  var setValue = Section$setValue;

  function Section$setValue(value) {
  	var _this = this;

  	var wrapper, fragmentOptions;

  	if (this.updating) {
  		// If a child of this section causes a re-evaluation - for example, an
  		// expression refers to a function that mutates the array that this
  		// section depends on - we'll end up with a double rendering bug (see
  		// https://github.com/ractivejs/ractive/issues/748). This prevents it.
  		return;
  	}

  	this.updating = true;

  	// with sections, we need to get the fake value if we have a wrapped object
  	if (this.keypath && (wrapper = this.root.viewmodel.wrapped[this.keypath.str])) {
  		value = wrapper.get();
  	}

  	// If any fragments are awaiting creation after a splice,
  	// this is the place to do it
  	if (this.fragmentsToCreate.length) {
  		fragmentOptions = {
  			template: this.template.f || [],
  			root: this.root,
  			pElement: this.pElement,
  			owner: this
  		};

  		this.fragmentsToCreate.forEach(function (index) {
  			var fragment;

  			fragmentOptions.context = _this.keypath.join(index);
  			fragmentOptions.index = index;

  			fragment = new virtualdom_Fragment(fragmentOptions);
  			_this.fragmentsToRender.push(_this.fragments[index] = fragment);
  		});

  		this.fragmentsToCreate.length = 0;
  	} else if (reevaluateSection(this, value)) {
  		this.bubble();

  		if (this.rendered) {
  			global_runloop.addView(this);
  		}
  	}

  	this.value = value;
  	this.updating = false;
  }

  function changeCurrentSubtype(section, value, obj) {
  	if (value === SECTION_EACH) {
  		// make sure ref type is up to date for key or value indices
  		if (section.indexRefs && section.indexRefs[0]) {
  			var ref = section.indexRefs[0];

  			// when switching flavors, make sure the section gets updated
  			if (obj && ref.t === "i" || !obj && ref.t === "k") {
  				// if switching from object to list, unbind all of the old fragments
  				if (!obj) {
  					section.length = 0;
  					section.fragmentsToUnrender = section.fragments.slice(0);
  					section.fragmentsToUnrender.forEach(function (f) {
  						return f.unbind();
  					});
  				}
  			}

  			ref.t = obj ? "k" : "i";
  		}
  	}

  	section.currentSubtype = value;
  }

  function reevaluateSection(section, value) {
  	var fragmentOptions = {
  		template: section.template.f || [],
  		root: section.root,
  		pElement: section.parentFragment.pElement,
  		owner: section
  	};

  	section.hasContext = true;

  	// If we already know the section type, great
  	// TODO can this be optimised? i.e. pick an reevaluateSection function during init
  	// and avoid doing this each time?
  	if (section.subtype) {
  		switch (section.subtype) {
  			case SECTION_IF:
  				section.hasContext = false;
  				return reevaluateConditionalSection(section, value, false, fragmentOptions);

  			case SECTION_UNLESS:
  				section.hasContext = false;
  				return reevaluateConditionalSection(section, value, true, fragmentOptions);

  			case SECTION_WITH:
  				return reevaluateContextSection(section, fragmentOptions);

  			case SECTION_IF_WITH:
  				return reevaluateConditionalContextSection(section, value, fragmentOptions);

  			case SECTION_EACH:
  				if (isObject(value)) {
  					changeCurrentSubtype(section, section.subtype, true);
  					return reevaluateListObjectSection(section, value, fragmentOptions);
  				}

  				// Fallthrough - if it's a conditional or an array we need to continue
  		}
  	}

  	// Otherwise we need to work out what sort of section we're dealing with
  	section.ordered = !!isArrayLike(value);

  	// Ordered list section
  	if (section.ordered) {
  		changeCurrentSubtype(section, SECTION_EACH, false);
  		return reevaluateListSection(section, value, fragmentOptions);
  	}

  	// Unordered list, or context
  	if (isObject(value) || typeof value === "function") {
  		// Index reference indicates section should be treated as a list
  		if (section.template.i) {
  			changeCurrentSubtype(section, SECTION_EACH, true);
  			return reevaluateListObjectSection(section, value, fragmentOptions);
  		}

  		// Otherwise, object provides context for contents
  		changeCurrentSubtype(section, SECTION_WITH, false);
  		return reevaluateContextSection(section, fragmentOptions);
  	}

  	// Conditional section
  	changeCurrentSubtype(section, SECTION_IF, false);
  	section.hasContext = false;
  	return reevaluateConditionalSection(section, value, false, fragmentOptions);
  }

  function reevaluateListSection(section, value, fragmentOptions) {
  	var i, length, fragment;

  	length = value.length;

  	if (length === section.length) {
  		// Nothing to do
  		return false;
  	}

  	// if the array is shorter than it was previously, remove items
  	if (length < section.length) {
  		section.fragmentsToUnrender = section.fragments.splice(length, section.length - length);
  		section.fragmentsToUnrender.forEach(methodCallers__unbind);
  	}

  	// otherwise...
  	else {
  		if (length > section.length) {
  			// add any new ones
  			for (i = section.length; i < length; i += 1) {
  				// append list item to context stack
  				fragmentOptions.context = section.keypath.join(i);
  				fragmentOptions.index = i;

  				fragment = new virtualdom_Fragment(fragmentOptions);
  				section.fragmentsToRender.push(section.fragments[i] = fragment);
  			}
  		}
  	}

  	section.length = length;
  	return true;
  }

  function reevaluateListObjectSection(section, value, fragmentOptions) {
  	var id, i, hasKey, fragment, changed, deps;

  	hasKey = section.hasKey || (section.hasKey = {});

  	// remove any fragments that should no longer exist
  	i = section.fragments.length;
  	while (i--) {
  		fragment = section.fragments[i];

  		if (!(fragment.key in value)) {
  			changed = true;

  			fragment.unbind();
  			section.fragmentsToUnrender.push(fragment);
  			section.fragments.splice(i, 1);

  			hasKey[fragment.key] = false;
  		}
  	}

  	// notify any dependents about changed indices
  	i = section.fragments.length;
  	while (i--) {
  		fragment = section.fragments[i];

  		if (fragment.index !== i) {
  			fragment.index = i;
  			if (deps = fragment.registeredIndexRefs) {
  				deps.forEach(setValue__blindRebind);
  			}
  		}
  	}

  	// add any that haven't been created yet
  	i = section.fragments.length;
  	for (id in value) {
  		if (!hasKey[id]) {
  			changed = true;

  			fragmentOptions.context = section.keypath.join(id);
  			fragmentOptions.key = id;
  			fragmentOptions.index = i++;

  			fragment = new virtualdom_Fragment(fragmentOptions);

  			section.fragmentsToRender.push(fragment);
  			section.fragments.push(fragment);
  			hasKey[id] = true;
  		}
  	}

  	section.length = section.fragments.length;
  	return changed;
  }

  function reevaluateConditionalContextSection(section, value, fragmentOptions) {
  	if (value) {
  		return reevaluateContextSection(section, fragmentOptions);
  	} else {
  		return removeSectionFragments(section);
  	}
  }

  function reevaluateContextSection(section, fragmentOptions) {
  	var fragment;

  	// ...then if it isn't rendered, render it, adding section.keypath to the context stack
  	// (if it is already rendered, then any children dependent on the context stack
  	// will update themselves without any prompting)
  	if (!section.length) {
  		// append this section to the context stack
  		fragmentOptions.context = section.keypath;
  		fragmentOptions.index = 0;

  		fragment = new virtualdom_Fragment(fragmentOptions);

  		section.fragmentsToRender.push(section.fragments[0] = fragment);
  		section.length = 1;

  		return true;
  	}
  }

  function reevaluateConditionalSection(section, value, inverted, fragmentOptions) {
  	var doRender, emptyArray, emptyObject, fragment, name;

  	emptyArray = isArrayLike(value) && value.length === 0;
  	emptyObject = false;
  	if (!isArrayLike(value) && isObject(value)) {
  		emptyObject = true;
  		for (name in value) {
  			emptyObject = false;
  			break;
  		}
  	}

  	if (inverted) {
  		doRender = emptyArray || emptyObject || !value;
  	} else {
  		doRender = value && !emptyArray && !emptyObject;
  	}

  	if (doRender) {
  		if (!section.length) {
  			// no change to context stack
  			fragmentOptions.index = 0;

  			fragment = new virtualdom_Fragment(fragmentOptions);
  			section.fragmentsToRender.push(section.fragments[0] = fragment);
  			section.length = 1;

  			return true;
  		}

  		if (section.length > 1) {
  			section.fragmentsToUnrender = section.fragments.splice(1);
  			section.fragmentsToUnrender.forEach(methodCallers__unbind);

  			return true;
  		}
  	} else {
  		return removeSectionFragments(section);
  	}
  }

  function removeSectionFragments(section) {
  	if (section.length) {
  		section.fragmentsToUnrender = section.fragments.splice(0, section.fragments.length).filter(isRendered);
  		section.fragmentsToUnrender.forEach(methodCallers__unbind);
  		section.length = section.fragmentsToRender.length = 0;
  		return true;
  	}
  }

  function isRendered(fragment) {
  	return fragment.rendered;
  }

  function setValue__blindRebind(dep) {
  	// the keypath doesn't actually matter here as it won't have changed
  	dep.rebind("", "");
  }

  var prototype_toString = Section$toString;

  function Section$toString(escape) {
  	var str, i, len;

  	str = "";

  	i = 0;
  	len = this.length;

  	for (i = 0; i < len; i += 1) {
  		str += this.fragments[i].toString(escape);
  	}

  	return str;
  }

  var prototype_unbind = Section$unbind;
  function Section$unbind() {
  	var _this = this;

  	this.fragments.forEach(methodCallers__unbind);
  	this.fragmentsToRender.forEach(function (f) {
  		return removeFromArray(_this.fragments, f);
  	});
  	this.fragmentsToRender = [];
  	shared_unbind.call(this);

  	this.length = 0;
  	this.unbound = true;
  }

  var prototype_unrender = Section$unrender;

  function Section$unrender(shouldDestroy) {
  	this.fragments.forEach(shouldDestroy ? unrenderAndDestroy : prototype_unrender__unrender);
  	this.renderedFragments = [];
  	this.rendered = false;
  }

  function unrenderAndDestroy(fragment) {
  	fragment.unrender(true);
  }

  function prototype_unrender__unrender(fragment) {
  	fragment.unrender(false);
  }

  var prototype_update = Section$update;

  function Section$update() {
  	var fragment, renderIndex, renderedFragments, anchor, target, i, len;

  	// `this.renderedFragments` is in the order of the previous render.
  	// If fragments have shuffled about, this allows us to quickly
  	// reinsert them in the correct place
  	renderedFragments = this.renderedFragments;

  	// Remove fragments that have been marked for destruction
  	while (fragment = this.fragmentsToUnrender.pop()) {
  		fragment.unrender(true);
  		renderedFragments.splice(renderedFragments.indexOf(fragment), 1);
  	}

  	// Render new fragments (but don't insert them yet)
  	while (fragment = this.fragmentsToRender.shift()) {
  		fragment.render();
  	}

  	if (this.rendered) {
  		target = this.parentFragment.getNode();
  	}

  	len = this.fragments.length;
  	for (i = 0; i < len; i += 1) {
  		fragment = this.fragments[i];
  		renderIndex = renderedFragments.indexOf(fragment, i); // search from current index - it's guaranteed to be the same or higher

  		if (renderIndex === i) {
  			// already in the right place. insert accumulated nodes (if any) and carry on
  			if (this.docFrag.childNodes.length) {
  				anchor = fragment.firstNode();
  				target.insertBefore(this.docFrag, anchor);
  			}

  			continue;
  		}

  		this.docFrag.appendChild(fragment.detach());

  		// update renderedFragments
  		if (renderIndex !== -1) {
  			renderedFragments.splice(renderIndex, 1);
  		}
  		renderedFragments.splice(i, 0, fragment);
  	}

  	if (this.rendered && this.docFrag.childNodes.length) {
  		anchor = this.parentFragment.findNextNode(this);
  		target.insertBefore(this.docFrag, anchor);
  	}

  	// Save the rendering order for next time
  	this.renderedFragments = this.fragments.slice();
  }

  var Section = function (options) {
  	this.type = SECTION;
  	this.subtype = this.currentSubtype = options.template.n;
  	this.inverted = this.subtype === SECTION_UNLESS;

  	this.pElement = options.pElement;

  	this.fragments = [];
  	this.fragmentsToCreate = [];
  	this.fragmentsToRender = [];
  	this.fragmentsToUnrender = [];

  	if (options.template.i) {
  		this.indexRefs = options.template.i.split(",").map(function (k, i) {
  			return { n: k, t: i === 0 ? "k" : "i" };
  		});
  	}

  	this.renderedFragments = [];

  	this.length = 0; // number of times this section is rendered

  	Mustache.init(this, options);
  };

  Section.prototype = {
  	bubble: Section_prototype_bubble,
  	detach: Section_prototype_detach,
  	find: find,
  	findAll: findAll,
  	findAllComponents: findAllComponents,
  	findComponent: findComponent,
  	findNextNode: findNextNode,
  	firstNode: firstNode,
  	getIndexRef: function (name) {
  		if (this.indexRefs) {
  			var i = this.indexRefs.length;
  			while (i--) {
  				var ref = this.indexRefs[i];
  				if (ref.n === name) {
  					return ref;
  				}
  			}
  		}
  	},
  	getValue: Mustache.getValue,
  	shuffle: shuffle,
  	rebind: prototype_rebind,
  	render: Section_prototype_render,
  	resolve: Mustache.resolve,
  	setValue: setValue,
  	toString: prototype_toString,
  	unbind: prototype_unbind,
  	unrender: prototype_unrender,
  	update: prototype_update
  };

  var _Section = Section;

  var Triple_prototype_detach = Triple$detach;

  function Triple$detach() {
  	var len, i;

  	if (this.docFrag) {
  		len = this.nodes.length;
  		for (i = 0; i < len; i += 1) {
  			this.docFrag.appendChild(this.nodes[i]);
  		}

  		return this.docFrag;
  	}
  }

  var Triple_prototype_find = Triple$find;
  function Triple$find(selector) {
  	var i, len, node, queryResult;

  	len = this.nodes.length;
  	for (i = 0; i < len; i += 1) {
  		node = this.nodes[i];

  		if (node.nodeType !== 1) {
  			continue;
  		}

  		if (matches(node, selector)) {
  			return node;
  		}

  		if (queryResult = node.querySelector(selector)) {
  			return queryResult;
  		}
  	}

  	return null;
  }

  var Triple_prototype_findAll = Triple$findAll;
  function Triple$findAll(selector, queryResult) {
  	var i, len, node, queryAllResult, numNodes, j;

  	len = this.nodes.length;
  	for (i = 0; i < len; i += 1) {
  		node = this.nodes[i];

  		if (node.nodeType !== 1) {
  			continue;
  		}

  		if (matches(node, selector)) {
  			queryResult.push(node);
  		}

  		if (queryAllResult = node.querySelectorAll(selector)) {
  			numNodes = queryAllResult.length;
  			for (j = 0; j < numNodes; j += 1) {
  				queryResult.push(queryAllResult[j]);
  			}
  		}
  	}
  }

  var Triple_prototype_firstNode = Triple$firstNode;

  function Triple$firstNode() {
  	if (this.rendered && this.nodes[0]) {
  		return this.nodes[0];
  	}

  	return this.parentFragment.findNextNode(this);
  }

  var elementCache = {},
      ieBug,
      ieBlacklist;

  try {
  	createElement("table").innerHTML = "foo";
  } catch (err) {
  	ieBug = true;

  	ieBlacklist = {
  		TABLE: ["<table class=\"x\">", "</table>"],
  		THEAD: ["<table><thead class=\"x\">", "</thead></table>"],
  		TBODY: ["<table><tbody class=\"x\">", "</tbody></table>"],
  		TR: ["<table><tr class=\"x\">", "</tr></table>"],
  		SELECT: ["<select class=\"x\">", "</select>"]
  	};
  }

  var insertHtml = function (html, node, docFrag) {
  	var container,
  	    nodes = [],
  	    wrapper,
  	    selectedOption,
  	    child,
  	    i;

  	// render 0 and false
  	if (html != null && html !== "") {
  		if (ieBug && (wrapper = ieBlacklist[node.tagName])) {
  			container = element("DIV");
  			container.innerHTML = wrapper[0] + html + wrapper[1];
  			container = container.querySelector(".x");

  			if (container.tagName === "SELECT") {
  				selectedOption = container.options[container.selectedIndex];
  			}
  		} else if (node.namespaceURI === namespaces.svg) {
  			container = element("DIV");
  			container.innerHTML = "<svg class=\"x\">" + html + "</svg>";
  			container = container.querySelector(".x");
  		} else {
  			container = element(node.tagName);
  			container.innerHTML = html;

  			if (container.tagName === "SELECT") {
  				selectedOption = container.options[container.selectedIndex];
  			}
  		}

  		while (child = container.firstChild) {
  			nodes.push(child);
  			docFrag.appendChild(child);
  		}

  		// This is really annoying. Extracting <option> nodes from the
  		// temporary container <select> causes the remaining ones to
  		// become selected. So now we have to deselect them. IE8, you
  		// amaze me. You really do
  		// ...and now Chrome too
  		if (node.tagName === "SELECT") {
  			i = nodes.length;
  			while (i--) {
  				if (nodes[i] !== selectedOption) {
  					nodes[i].selected = false;
  				}
  			}
  		}
  	}

  	return nodes;
  };

  function element(tagName) {
  	return elementCache[tagName] || (elementCache[tagName] = createElement(tagName));
  }

  var helpers_updateSelect = updateSelect;

  function updateSelect(parentElement) {
  	var selectedOptions, option, value;

  	if (!parentElement || parentElement.name !== "select" || !parentElement.binding) {
  		return;
  	}

  	selectedOptions = toArray(parentElement.node.options).filter(isSelected);

  	// If one of them had a `selected` attribute, we need to sync
  	// the model to the view
  	if (parentElement.getAttribute("multiple")) {
  		value = selectedOptions.map(function (o) {
  			return o.value;
  		});
  	} else if (option = selectedOptions[0]) {
  		value = option.value;
  	}

  	if (value !== undefined) {
  		parentElement.binding.setValue(value);
  	}

  	parentElement.bubble();
  }

  function isSelected(option) {
  	return option.selected;
  }

  var Triple_prototype_render = Triple$render;
  function Triple$render() {
  	if (this.rendered) {
  		throw new Error("Attempted to render an item that was already rendered");
  	}

  	this.docFrag = document.createDocumentFragment();
  	this.nodes = insertHtml(this.value, this.parentFragment.getNode(), this.docFrag);

  	// Special case - we're inserting the contents of a <select>
  	helpers_updateSelect(this.pElement);

  	this.rendered = true;
  	return this.docFrag;
  }

  var prototype_setValue = Triple$setValue;
  function Triple$setValue(value) {
  	var wrapper;

  	// TODO is there a better way to approach this?
  	if (wrapper = this.root.viewmodel.wrapped[this.keypath.str]) {
  		value = wrapper.get();
  	}

  	if (value !== this.value) {
  		this.value = value;
  		this.parentFragment.bubble();

  		if (this.rendered) {
  			global_runloop.addView(this);
  		}
  	}
  }

  var Triple_prototype_toString = Triple$toString;
  function Triple$toString() {
  	return this.value != undefined ? decodeCharacterReferences("" + this.value) : "";
  }

  var Triple_prototype_unrender = Triple$unrender;
  function Triple$unrender(shouldDestroy) {
  	if (this.rendered && shouldDestroy) {
  		this.nodes.forEach(detachNode);
  		this.rendered = false;
  	}

  	// TODO update live queries
  }

  var Triple_prototype_update = Triple$update;
  function Triple$update() {
  	var node, parentNode;

  	if (!this.rendered) {
  		return;
  	}

  	// Remove existing nodes
  	while (this.nodes && this.nodes.length) {
  		node = this.nodes.pop();
  		node.parentNode.removeChild(node);
  	}

  	// Insert new nodes
  	parentNode = this.parentFragment.getNode();

  	this.nodes = insertHtml(this.value, parentNode, this.docFrag);
  	parentNode.insertBefore(this.docFrag, this.parentFragment.findNextNode(this));

  	// Special case - we're inserting the contents of a <select>
  	helpers_updateSelect(this.pElement);
  }

  var Triple = function (options) {
  	this.type = TRIPLE;
  	Mustache.init(this, options);
  };

  Triple.prototype = {
  	detach: Triple_prototype_detach,
  	find: Triple_prototype_find,
  	findAll: Triple_prototype_findAll,
  	firstNode: Triple_prototype_firstNode,
  	getValue: Mustache.getValue,
  	rebind: Mustache.rebind,
  	render: Triple_prototype_render,
  	resolve: Mustache.resolve,
  	setValue: prototype_setValue,
  	toString: Triple_prototype_toString,
  	unbind: shared_unbind,
  	unrender: Triple_prototype_unrender,
  	update: Triple_prototype_update
  };

  var _Triple = Triple;

  var Element_prototype_bubble = function () {
  	this.parentFragment.bubble();
  };

  var Element_prototype_detach = Element$detach;

  function Element$detach() {
  	var node = this.node,
  	    parentNode;

  	if (node) {
  		// need to check for parent node - DOM may have been altered
  		// by something other than Ractive! e.g. jQuery UI...
  		if (parentNode = node.parentNode) {
  			parentNode.removeChild(node);
  		}

  		return node;
  	}
  }

  var Element_prototype_find = function (selector) {
  	if (!this.node) {
  		// this element hasn't been rendered yet
  		return null;
  	}

  	if (matches(this.node, selector)) {
  		return this.node;
  	}

  	if (this.fragment && this.fragment.find) {
  		return this.fragment.find(selector);
  	}
  };

  var Element_prototype_findAll = function (selector, query) {
  	// Add this node to the query, if applicable, and register the
  	// query on this element
  	if (query._test(this, true) && query.live) {
  		(this.liveQueries || (this.liveQueries = [])).push(query);
  	}

  	if (this.fragment) {
  		this.fragment.findAll(selector, query);
  	}
  };

  var Element_prototype_findAllComponents = function (selector, query) {
  	if (this.fragment) {
  		this.fragment.findAllComponents(selector, query);
  	}
  };

  var Element_prototype_findComponent = function (selector) {
  	if (this.fragment) {
  		return this.fragment.findComponent(selector);
  	}
  };

  var Element_prototype_findNextNode = Element$findNextNode;

  function Element$findNextNode() {
  	return null;
  }

  var Element_prototype_firstNode = Element$firstNode;

  function Element$firstNode() {
  	return this.node;
  }

  var getAttribute = Element$getAttribute;

  function Element$getAttribute(name) {
  	if (!this.attributes || !this.attributes[name]) {
  		return;
  	}

  	return this.attributes[name].value;
  }

  var truthy = /^true|on|yes|1$/i;
  var processBindingAttributes__isNumeric = /^[0-9]+$/;

  var processBindingAttributes = function (element, template) {
  	var val, attrs, attributes;

  	attributes = template.a || {};
  	attrs = {};

  	// attributes that are present but don't have a value (=)
  	// will be set to the number 0, which we condider to be true
  	// the string '0', however is false

  	val = attributes.twoway;
  	if (val !== undefined) {
  		attrs.twoway = val === 0 || truthy.test(val);
  	}

  	val = attributes.lazy;
  	if (val !== undefined) {
  		// check for timeout value
  		if (val !== 0 && processBindingAttributes__isNumeric.test(val)) {
  			attrs.lazy = parseInt(val);
  		} else {
  			attrs.lazy = val === 0 || truthy.test(val);
  		}
  	}

  	return attrs;
  };

  var Attribute_prototype_bubble = Attribute$bubble;
  function Attribute$bubble() {
  	var value = this.useProperty || !this.rendered ? this.fragment.getValue() : this.fragment.toString();

  	// TODO this can register the attribute multiple times (see render test
  	// 'Attribute with nested mustaches')
  	if (!isEqual(value, this.value)) {

  		// Need to clear old id from ractive.nodes
  		if (this.name === "id" && this.value) {
  			delete this.root.nodes[this.value];
  		}

  		this.value = value;

  		if (this.name === "value" && this.node) {
  			// We need to store the value on the DOM like this so we
  			// can retrieve it later without it being coerced to a string
  			this.node._ractive.value = value;
  		}

  		if (this.rendered) {
  			global_runloop.addView(this);
  		}
  	}
  }

  var svgCamelCaseElements, svgCamelCaseAttributes, createMap, map;
  svgCamelCaseElements = "altGlyph altGlyphDef altGlyphItem animateColor animateMotion animateTransform clipPath feBlend feColorMatrix feComponentTransfer feComposite feConvolveMatrix feDiffuseLighting feDisplacementMap feDistantLight feFlood feFuncA feFuncB feFuncG feFuncR feGaussianBlur feImage feMerge feMergeNode feMorphology feOffset fePointLight feSpecularLighting feSpotLight feTile feTurbulence foreignObject glyphRef linearGradient radialGradient textPath vkern".split(" ");
  svgCamelCaseAttributes = "attributeName attributeType baseFrequency baseProfile calcMode clipPathUnits contentScriptType contentStyleType diffuseConstant edgeMode externalResourcesRequired filterRes filterUnits glyphRef gradientTransform gradientUnits kernelMatrix kernelUnitLength keyPoints keySplines keyTimes lengthAdjust limitingConeAngle markerHeight markerUnits markerWidth maskContentUnits maskUnits numOctaves pathLength patternContentUnits patternTransform patternUnits pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits refX refY repeatCount repeatDur requiredExtensions requiredFeatures specularConstant specularExponent spreadMethod startOffset stdDeviation stitchTiles surfaceScale systemLanguage tableValues targetX targetY textLength viewBox viewTarget xChannelSelector yChannelSelector zoomAndPan".split(" ");

  createMap = function (items) {
  	var map = {},
  	    i = items.length;
  	while (i--) {
  		map[items[i].toLowerCase()] = items[i];
  	}
  	return map;
  };

  map = createMap(svgCamelCaseElements.concat(svgCamelCaseAttributes));

  var enforceCase = function (elementName) {
  	var lowerCaseElementName = elementName.toLowerCase();
  	return map[lowerCaseElementName] || lowerCaseElementName;
  };

  var determineNameAndNamespace = function (attribute, name) {
  	var colonIndex, namespacePrefix;

  	// are we dealing with a namespaced attribute, e.g. xlink:href?
  	colonIndex = name.indexOf(":");
  	if (colonIndex !== -1) {

  		// looks like we are, yes...
  		namespacePrefix = name.substr(0, colonIndex);

  		// ...unless it's a namespace *declaration*, which we ignore (on the assumption
  		// that only valid namespaces will be used)
  		if (namespacePrefix !== "xmlns") {
  			name = name.substring(colonIndex + 1);

  			attribute.name = enforceCase(name);
  			attribute.namespace = namespaces[namespacePrefix.toLowerCase()];
  			attribute.namespacePrefix = namespacePrefix;

  			if (!attribute.namespace) {
  				throw "Unknown namespace (\"" + namespacePrefix + "\")";
  			}

  			return;
  		}
  	}

  	// SVG attribute names are case sensitive
  	attribute.name = attribute.element.namespace !== namespaces.html ? enforceCase(name) : name;
  };

  var helpers_getInterpolator = getInterpolator;
  function getInterpolator(attribute) {
  	var items = attribute.fragment.items;

  	if (items.length !== 1) {
  		return;
  	}

  	if (items[0].type === INTERPOLATOR) {
  		return items[0];
  	}
  }

  var prototype_init = Attribute$init;
  function Attribute$init(options) {
  	this.type = ATTRIBUTE;
  	this.element = options.element;
  	this.root = options.root;

  	determineNameAndNamespace(this, options.name);
  	this.isBoolean = booleanAttributes.test(this.name);

  	// if it's an empty attribute, or just a straight key-value pair, with no
  	// mustache shenanigans, set the attribute accordingly and go home
  	if (!options.value || typeof options.value === "string") {
  		this.value = this.isBoolean ? true : options.value || "";
  		return;
  	}

  	// otherwise we need to do some work

  	// share parentFragment with parent element
  	this.parentFragment = this.element.parentFragment;

  	this.fragment = new virtualdom_Fragment({
  		template: options.value,
  		root: this.root,
  		owner: this
  	});

  	// TODO can we use this.fragment.toString() in some cases? It's quicker
  	this.value = this.fragment.getValue();

  	// Store a reference to this attribute's interpolator, if its fragment
  	// takes the form `{{foo}}`. This is necessary for two-way binding and
  	// for correctly rendering HTML later
  	this.interpolator = helpers_getInterpolator(this);
  	this.isBindable = !!this.interpolator && !this.interpolator.isStatic;

  	// mark as ready
  	this.ready = true;
  }

  var Attribute_prototype_rebind = Attribute$rebind;

  function Attribute$rebind(oldKeypath, newKeypath) {
  	if (this.fragment) {
  		this.fragment.rebind(oldKeypath, newKeypath);
  	}
  }

  var Attribute_prototype_render = Attribute$render;
  var propertyNames = {
  	"accept-charset": "acceptCharset",
  	accesskey: "accessKey",
  	bgcolor: "bgColor",
  	"class": "className",
  	codebase: "codeBase",
  	colspan: "colSpan",
  	contenteditable: "contentEditable",
  	datetime: "dateTime",
  	dirname: "dirName",
  	"for": "htmlFor",
  	"http-equiv": "httpEquiv",
  	ismap: "isMap",
  	maxlength: "maxLength",
  	novalidate: "noValidate",
  	pubdate: "pubDate",
  	readonly: "readOnly",
  	rowspan: "rowSpan",
  	tabindex: "tabIndex",
  	usemap: "useMap"
  };
  function Attribute$render(node) {
  	var propertyName;

  	this.node = node;

  	// should we use direct property access, or setAttribute?
  	if (!node.namespaceURI || node.namespaceURI === namespaces.html) {
  		propertyName = propertyNames[this.name] || this.name;

  		if (node[propertyName] !== undefined) {
  			this.propertyName = propertyName;
  		}

  		// is attribute a boolean attribute or 'value'? If so we're better off doing e.g.
  		// node.selected = true rather than node.setAttribute( 'selected', '' )
  		if (this.isBoolean || this.isTwoway) {
  			this.useProperty = true;
  		}

  		if (propertyName === "value") {
  			node._ractive.value = this.value;
  		}
  	}

  	this.rendered = true;
  	this.update();
  }

  var Attribute_prototype_toString = Attribute$toString;

  function Attribute$toString() {
  	var _ref = this;

  	var name = _ref.name;
  	var namespacePrefix = _ref.namespacePrefix;
  	var value = _ref.value;
  	var interpolator = _ref.interpolator;
  	var fragment = _ref.fragment;

  	// Special case - select and textarea values (should not be stringified)
  	if (name === "value" && (this.element.name === "select" || this.element.name === "textarea")) {
  		return;
  	}

  	// Special case - content editable
  	if (name === "value" && this.element.getAttribute("contenteditable") !== undefined) {
  		return;
  	}

  	// Special case - radio names
  	if (name === "name" && this.element.name === "input" && interpolator) {
  		return "name={{" + (interpolator.keypath.str || interpolator.ref) + "}}";
  	}

  	// Boolean attributes
  	if (this.isBoolean) {
  		return value ? name : "";
  	}

  	if (fragment) {
  		// special case - this catches undefined/null values (#1211)
  		if (fragment.items.length === 1 && fragment.items[0].value == null) {
  			return "";
  		}

  		value = fragment.toString();
  	}

  	if (namespacePrefix) {
  		name = namespacePrefix + ":" + name;
  	}

  	return value ? name + "=\"" + Attribute_prototype_toString__escape(value) + "\"" : name;
  }

  function Attribute_prototype_toString__escape(value) {
  	return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  var Attribute_prototype_unbind = Attribute$unbind;

  function Attribute$unbind() {
  	// ignore non-dynamic attributes
  	if (this.fragment) {
  		this.fragment.unbind();
  	}

  	if (this.name === "id") {
  		delete this.root.nodes[this.value];
  	}
  }

  var updateSelectValue = Attribute$updateSelect;

  function Attribute$updateSelect() {
  	var value = this.value,
  	    options,
  	    option,
  	    optionValue,
  	    i;

  	if (!this.locked) {
  		this.node._ractive.value = value;

  		options = this.node.options;
  		i = options.length;

  		while (i--) {
  			option = options[i];
  			optionValue = option._ractive ? option._ractive.value : option.value; // options inserted via a triple don't have _ractive

  			if (optionValue == value) {
  				// double equals as we may be comparing numbers with strings
  				option.selected = true;
  				break;
  			}
  		}
  	}

  	// if we're still here, it means the new value didn't match any of the options...
  	// TODO figure out what to do in this situation
  }

  var updateMultipleSelectValue = Attribute$updateMultipleSelect;
  function Attribute$updateMultipleSelect() {
  	var value = this.value,
  	    options,
  	    i,
  	    option,
  	    optionValue;

  	if (!isArray(value)) {
  		value = [value];
  	}

  	options = this.node.options;
  	i = options.length;

  	while (i--) {
  		option = options[i];
  		optionValue = option._ractive ? option._ractive.value : option.value; // options inserted via a triple don't have _ractive
  		option.selected = arrayContains(value, optionValue);
  	}
  }

  var updateRadioName = Attribute$updateRadioName;

  function Attribute$updateRadioName() {
  	var _ref = this;

  	var node = _ref.node;
  	var value = _ref.value;

  	node.checked = value == node._ractive.value;
  }

  var updateRadioValue = Attribute$updateRadioValue;
  function Attribute$updateRadioValue() {
  	var wasChecked,
  	    node = this.node,
  	    binding,
  	    bindings,
  	    i;

  	wasChecked = node.checked;

  	node.value = this.element.getAttribute("value");
  	node.checked = this.element.getAttribute("value") === this.element.getAttribute("name");

  	// This is a special case - if the input was checked, and the value
  	// changed so that it's no longer checked, the twoway binding is
  	// most likely out of date. To fix it we have to jump through some
  	// hoops... this is a little kludgy but it works
  	if (wasChecked && !node.checked && this.element.binding) {
  		bindings = this.element.binding.siblings;

  		if (i = bindings.length) {
  			while (i--) {
  				binding = bindings[i];

  				if (!binding.element.node) {
  					// this is the initial render, siblings are still rendering!
  					// we'll come back later...
  					return;
  				}

  				if (binding.element.node.checked) {
  					global_runloop.addRactive(binding.root);
  					return binding.handleChange();
  				}
  			}

  			this.root.viewmodel.set(binding.keypath, undefined);
  		}
  	}
  }

  var updateCheckboxName = Attribute$updateCheckboxName;
  function Attribute$updateCheckboxName() {
  	var _ref = this;

  	var element = _ref.element;
  	var node = _ref.node;
  	var value = _ref.value;var binding = element.binding;var valueAttribute;var i;

  	valueAttribute = element.getAttribute("value");

  	if (!isArray(value)) {
  		binding.isChecked = node.checked = value == valueAttribute;
  	} else {
  		i = value.length;
  		while (i--) {
  			if (valueAttribute == value[i]) {
  				binding.isChecked = node.checked = true;
  				return;
  			}
  		}
  		binding.isChecked = node.checked = false;
  	}
  }

  var updateClassName = Attribute$updateClassName;
  function Attribute$updateClassName() {
  	this.node.className = safeToStringValue(this.value);
  }

  var updateIdAttribute = Attribute$updateIdAttribute;

  function Attribute$updateIdAttribute() {
  	var _ref = this;

  	var node = _ref.node;
  	var value = _ref.value;

  	this.root.nodes[value] = node;
  	node.id = value;
  }

  var updateIEStyleAttribute = Attribute$updateIEStyleAttribute;

  function Attribute$updateIEStyleAttribute() {
  	var node, value;

  	node = this.node;
  	value = this.value;

  	if (value === undefined) {
  		value = "";
  	}

  	node.style.setAttribute("cssText", value);
  }

  var updateContentEditableValue = Attribute$updateContentEditableValue;

  function Attribute$updateContentEditableValue() {
  	var value = this.value;

  	if (value === undefined) {
  		value = "";
  	}

  	if (!this.locked) {
  		this.node.innerHTML = value;
  	}
  }

  var updateValue = Attribute$updateValue;

  function Attribute$updateValue() {
  	var _ref = this;

  	var node = _ref.node;
  	var value = _ref.value;

  	// store actual value, so it doesn't get coerced to a string
  	node._ractive.value = value;

  	// with two-way binding, only update if the change wasn't initiated by the user
  	// otherwise the cursor will often be sent to the wrong place
  	if (!this.locked) {
  		node.value = value == undefined ? "" : value;
  	}
  }

  var updateBoolean = Attribute$updateBooleanAttribute;

  function Attribute$updateBooleanAttribute() {
  	// with two-way binding, only update if the change wasn't initiated by the user
  	// otherwise the cursor will often be sent to the wrong place
  	if (!this.locked) {
  		this.node[this.propertyName] = this.value;
  	}
  }

  var updateEverythingElse = Attribute$updateEverythingElse;

  function Attribute$updateEverythingElse() {
  	var _ref = this;

  	var node = _ref.node;
  	var namespace = _ref.namespace;
  	var name = _ref.name;
  	var value = _ref.value;
  	var fragment = _ref.fragment;

  	if (namespace) {
  		node.setAttributeNS(namespace, name, (fragment || value).toString());
  	} else if (!this.isBoolean) {
  		if (value == null) {
  			node.removeAttribute(name);
  		} else {
  			node.setAttribute(name, (fragment || value).toString());
  		}
  	}

  	// Boolean attributes - truthy becomes '', falsy means 'remove attribute'
  	else {
  		if (value) {
  			node.setAttribute(name, "");
  		} else {
  			node.removeAttribute(name);
  		}
  	}
  }

  // There are a few special cases when it comes to updating attributes. For this reason,
  // the prototype .update() method points to this method, which waits until the
  // attribute has finished initialising, then replaces the prototype method with a more
  // suitable one. That way, we save ourselves doing a bunch of tests on each call
  var Attribute_prototype_update = Attribute$update;
  function Attribute$update() {
  	var _ref = this;

  	var name = _ref.name;
  	var element = _ref.element;
  	var node = _ref.node;var type;var updateMethod;

  	if (name === "id") {
  		updateMethod = updateIdAttribute;
  	} else if (name === "value") {
  		// special case - selects
  		if (element.name === "select" && name === "value") {
  			updateMethod = element.getAttribute("multiple") ? updateMultipleSelectValue : updateSelectValue;
  		} else if (element.name === "textarea") {
  			updateMethod = updateValue;
  		}

  		// special case - contenteditable
  		else if (element.getAttribute("contenteditable") != null) {
  			updateMethod = updateContentEditableValue;
  		}

  		// special case - <input>
  		else if (element.name === "input") {
  			type = element.getAttribute("type");

  			// type='file' value='{{fileList}}'>
  			if (type === "file") {
  				updateMethod = noop; // read-only
  			}

  			// type='radio' name='{{twoway}}'
  			else if (type === "radio" && element.binding && element.binding.name === "name") {
  				updateMethod = updateRadioValue;
  			} else {
  				updateMethod = updateValue;
  			}
  		}
  	}

  	// special case - <input type='radio' name='{{twoway}}' value='foo'>
  	else if (this.isTwoway && name === "name") {
  		if (node.type === "radio") {
  			updateMethod = updateRadioName;
  		} else if (node.type === "checkbox") {
  			updateMethod = updateCheckboxName;
  		}
  	}

  	// special case - style attributes in Internet Exploder
  	else if (name === "style" && node.style.setAttribute) {
  		updateMethod = updateIEStyleAttribute;
  	}

  	// special case - class names. IE fucks things up, again
  	else if (name === "class" && (!node.namespaceURI || node.namespaceURI === namespaces.html)) {
  		updateMethod = updateClassName;
  	} else if (this.useProperty) {
  		updateMethod = updateBoolean;
  	}

  	if (!updateMethod) {
  		updateMethod = updateEverythingElse;
  	}

  	this.update = updateMethod;
  	this.update();
  }

  var Attribute = function (options) {
  	this.init(options);
  };

  Attribute.prototype = {
  	bubble: Attribute_prototype_bubble,
  	init: prototype_init,
  	rebind: Attribute_prototype_rebind,
  	render: Attribute_prototype_render,
  	toString: Attribute_prototype_toString,
  	unbind: Attribute_prototype_unbind,
  	update: Attribute_prototype_update
  };

  var _Attribute = Attribute;

  var createAttributes = function (element, attributes) {
  	var name,
  	    attribute,
  	    result = [];

  	for (name in attributes) {
  		// skip binding attributes
  		if (name === "twoway" || name === "lazy") {
  			continue;
  		}

  		if (attributes.hasOwnProperty(name)) {
  			attribute = new _Attribute({
  				element: element,
  				name: name,
  				value: attributes[name],
  				root: element.root
  			});

  			result[name] = attribute;

  			if (name !== "value") {
  				result.push(attribute);
  			}
  		}
  	}

  	// value attribute goes last. This is because it
  	// may get clamped on render otherwise, e.g. in
  	// `<input type='range' value='999' min='0' max='1000'>`
  	// since default max is 100
  	if (attribute = result.value) {
  		result.push(attribute);
  	}

  	return result;
  };

  var _ConditionalAttribute__div;

  if (typeof document !== "undefined") {
  	_ConditionalAttribute__div = createElement("div");
  }

  var ConditionalAttribute = function (element, template) {
  	this.element = element;
  	this.root = element.root;
  	this.parentFragment = element.parentFragment;

  	this.attributes = [];

  	this.fragment = new virtualdom_Fragment({
  		root: element.root,
  		owner: this,
  		template: [template]
  	});
  };

  ConditionalAttribute.prototype = {
  	bubble: function () {
  		if (this.node) {
  			this.update();
  		}

  		this.element.bubble();
  	},

  	rebind: function (oldKeypath, newKeypath) {
  		this.fragment.rebind(oldKeypath, newKeypath);
  	},

  	render: function (node) {
  		this.node = node;
  		this.isSvg = node.namespaceURI === namespaces.svg;

  		this.update();
  	},

  	unbind: function () {
  		this.fragment.unbind();
  	},

  	update: function () {
  		var _this = this;

  		var str, attrs;

  		str = this.fragment.toString();
  		attrs = parseAttributes(str, this.isSvg);

  		// any attributes that previously existed but no longer do
  		// must be removed
  		this.attributes.filter(function (a) {
  			return notIn(attrs, a);
  		}).forEach(function (a) {
  			_this.node.removeAttribute(a.name);
  		});

  		attrs.forEach(function (a) {
  			_this.node.setAttribute(a.name, a.value);
  		});

  		this.attributes = attrs;
  	},

  	toString: function () {
  		return this.fragment.toString();
  	}
  };

  var _ConditionalAttribute = ConditionalAttribute;

  function parseAttributes(str, isSvg) {
  	var tag = isSvg ? "svg" : "div";
  	_ConditionalAttribute__div.innerHTML = "<" + tag + " " + str + "></" + tag + ">";

  	return toArray(_ConditionalAttribute__div.childNodes[0].attributes);
  }

  function notIn(haystack, needle) {
  	var i = haystack.length;

  	while (i--) {
  		if (haystack[i].name === needle.name) {
  			return false;
  		}
  	}

  	return true;
  }

  var createConditionalAttributes = function (element, attributes) {
  	if (!attributes) {
  		return [];
  	}

  	return attributes.map(function (a) {
  		return new _ConditionalAttribute(element, a);
  	});
  };

  var Binding = function (element) {
  	var interpolator, keypath, value, parentForm;

  	this.element = element;
  	this.root = element.root;
  	this.attribute = element.attributes[this.name || "value"];

  	interpolator = this.attribute.interpolator;
  	interpolator.twowayBinding = this;

  	if (keypath = interpolator.keypath) {
  		if (keypath.str.slice(-1) === "}") {
  			warnOnceIfDebug("Two-way binding does not work with expressions (`%s` on <%s>)", interpolator.resolver.uniqueString, element.name, { ractive: this.root });
  			return false;
  		}

  		if (keypath.isSpecial) {
  			warnOnceIfDebug("Two-way binding does not work with %s", interpolator.resolver.ref, { ractive: this.root });
  			return false;
  		}
  	} else {
  		// A mustache may be *ambiguous*. Let's say we were given
  		// `value="{{bar}}"`. If the context was `foo`, and `foo.bar`
  		// *wasn't* `undefined`, the keypath would be `foo.bar`.
  		// Then, any user input would result in `foo.bar` being updated.
  		//
  		// If, however, `foo.bar` *was* undefined, and so was `bar`, we would be
  		// left with an unresolved partial keypath - so we are forced to make an
  		// assumption. That assumption is that the input in question should
  		// be forced to resolve to `bar`, and any user input would affect `bar`
  		// and not `foo.bar`.
  		//
  		// Did that make any sense? No? Oh. Sorry. Well the moral of the story is
  		// be explicit when using two-way data-binding about what keypath you're
  		// updating. Using it in lists is probably a recipe for confusion...
  		var ref = interpolator.template.r ? "'" + interpolator.template.r + "' reference" : "expression";
  		warnIfDebug("The %s being used for two-way binding is ambiguous, and may cause unexpected results. Consider initialising your data to eliminate the ambiguity", ref, { ractive: this.root });
  		interpolator.resolver.forceResolution();
  		keypath = interpolator.keypath;
  	}

  	this.attribute.isTwoway = true;
  	this.keypath = keypath;

  	// initialise value, if it's undefined
  	value = this.root.viewmodel.get(keypath);

  	if (value === undefined && this.getInitialValue) {
  		value = this.getInitialValue();

  		if (value !== undefined) {
  			this.root.viewmodel.set(keypath, value);
  		}
  	}

  	if (parentForm = findParentForm(element)) {
  		this.resetValue = value;
  		parentForm.formBindings.push(this);
  	}
  };

  Binding.prototype = {
  	handleChange: function () {
  		var _this = this;

  		global_runloop.start(this.root);
  		this.attribute.locked = true;
  		this.root.viewmodel.set(this.keypath, this.getValue());
  		global_runloop.scheduleTask(function () {
  			return _this.attribute.locked = false;
  		});
  		global_runloop.end();
  	},

  	rebound: function () {
  		var bindings, oldKeypath, newKeypath;

  		oldKeypath = this.keypath;
  		newKeypath = this.attribute.interpolator.keypath;

  		// The attribute this binding is linked to has already done the work
  		if (oldKeypath === newKeypath) {
  			return;
  		}

  		removeFromArray(this.root._twowayBindings[oldKeypath.str], this);

  		this.keypath = newKeypath;

  		bindings = this.root._twowayBindings[newKeypath.str] || (this.root._twowayBindings[newKeypath.str] = []);
  		bindings.push(this);
  	},

  	unbind: function () {}
  };

  Binding.extend = function (properties) {
  	var Parent = this,
  	    SpecialisedBinding;

  	SpecialisedBinding = function (element) {
  		Binding.call(this, element);

  		if (this.init) {
  			this.init();
  		}
  	};

  	SpecialisedBinding.prototype = create(Parent.prototype);
  	utils_object__extend(SpecialisedBinding.prototype, properties);

  	SpecialisedBinding.extend = Binding.extend;

  	return SpecialisedBinding;
  };

  var Binding_Binding = Binding;

  function findParentForm(element) {
  	while (element = element.parent) {
  		if (element.name === "form") {
  			return element;
  		}
  	}
  }

  // this is called when the element is unbound.
  // Specialised bindings can override it

  // This is the handler for DOM events that would lead to a change in the model
  // (i.e. change, sometimes, input, and occasionally click and keyup)
  var handleDomEvent = handleChange;

  function handleChange() {
  	this._ractive.binding.handleChange();
  }

  var GenericBinding;

  GenericBinding = Binding_Binding.extend({
  	getInitialValue: function () {
  		return "";
  	},

  	getValue: function () {
  		return this.element.node.value;
  	},

  	render: function () {
  		var node = this.element.node,
  		    lazy,
  		    timeout = false;
  		this.rendered = true;

  		// any lazy setting for this element overrides the root
  		// if the value is a number, it's a timeout
  		lazy = this.root.lazy;
  		if (this.element.lazy === true) {
  			lazy = true;
  		} else if (this.element.lazy === false) {
  			lazy = false;
  		} else if (is__isNumeric(this.element.lazy)) {
  			lazy = false;
  			timeout = +this.element.lazy;
  		} else if (is__isNumeric(lazy || "")) {
  			timeout = +lazy;
  			lazy = false;

  			// make sure the timeout is available to the handler
  			this.element.lazy = timeout;
  		}

  		this.handler = timeout ? handleDelay : handleDomEvent;

  		node.addEventListener("change", handleDomEvent, false);

  		if (!lazy) {
  			node.addEventListener("input", this.handler, false);

  			if (node.attachEvent) {
  				node.addEventListener("keyup", this.handler, false);
  			}
  		}

  		node.addEventListener("blur", handleBlur, false);
  	},

  	unrender: function () {
  		var node = this.element.node;
  		this.rendered = false;

  		node.removeEventListener("change", handleDomEvent, false);
  		node.removeEventListener("input", this.handler, false);
  		node.removeEventListener("keyup", this.handler, false);
  		node.removeEventListener("blur", handleBlur, false);
  	}
  });

  var Binding_GenericBinding = GenericBinding;

  function handleBlur() {
  	var value;

  	handleDomEvent.call(this);

  	value = this._ractive.root.viewmodel.get(this._ractive.binding.keypath);
  	this.value = value == undefined ? "" : value;
  }

  function handleDelay() {
  	var binding = this._ractive.binding,
  	    el = this;

  	if (!!binding._timeout) clearTimeout(binding._timeout);

  	binding._timeout = setTimeout(function () {
  		if (binding.rendered) handleDomEvent.call(el);
  		binding._timeout = undefined;
  	}, binding.element.lazy);
  }

  var ContentEditableBinding = Binding_GenericBinding.extend({
  	getInitialValue: function () {
  		return this.element.fragment ? this.element.fragment.toString() : "";
  	},

  	getValue: function () {
  		return this.element.node.innerHTML;
  	}
  });

  var Binding_ContentEditableBinding = ContentEditableBinding;

  var shared_getSiblings = getSiblings;
  var sets = {};
  function getSiblings(id, group, keypath) {
  	var hash = id + group + keypath;
  	return sets[hash] || (sets[hash] = []);
  }

  var RadioBinding = Binding_Binding.extend({
  	name: "checked",

  	init: function () {
  		this.siblings = shared_getSiblings(this.root._guid, "radio", this.element.getAttribute("name"));
  		this.siblings.push(this);
  	},

  	render: function () {
  		var node = this.element.node;

  		node.addEventListener("change", handleDomEvent, false);

  		if (node.attachEvent) {
  			node.addEventListener("click", handleDomEvent, false);
  		}
  	},

  	unrender: function () {
  		var node = this.element.node;

  		node.removeEventListener("change", handleDomEvent, false);
  		node.removeEventListener("click", handleDomEvent, false);
  	},

  	handleChange: function () {
  		global_runloop.start(this.root);

  		this.siblings.forEach(function (binding) {
  			binding.root.viewmodel.set(binding.keypath, binding.getValue());
  		});

  		global_runloop.end();
  	},

  	getValue: function () {
  		return this.element.node.checked;
  	},

  	unbind: function () {
  		removeFromArray(this.siblings, this);
  	}
  });

  var Binding_RadioBinding = RadioBinding;

  var RadioNameBinding = Binding_Binding.extend({
  	name: "name",

  	init: function () {
  		this.siblings = shared_getSiblings(this.root._guid, "radioname", this.keypath.str);
  		this.siblings.push(this);

  		this.radioName = true; // so that ractive.updateModel() knows what to do with this
  	},

  	getInitialValue: function () {
  		if (this.element.getAttribute("checked")) {
  			return this.element.getAttribute("value");
  		}
  	},

  	render: function () {
  		var node = this.element.node;

  		node.name = "{{" + this.keypath.str + "}}";
  		node.checked = this.root.viewmodel.get(this.keypath) == this.element.getAttribute("value");

  		node.addEventListener("change", handleDomEvent, false);

  		if (node.attachEvent) {
  			node.addEventListener("click", handleDomEvent, false);
  		}
  	},

  	unrender: function () {
  		var node = this.element.node;

  		node.removeEventListener("change", handleDomEvent, false);
  		node.removeEventListener("click", handleDomEvent, false);
  	},

  	getValue: function () {
  		var node = this.element.node;
  		return node._ractive ? node._ractive.value : node.value;
  	},

  	handleChange: function () {
  		// If this <input> is the one that's checked, then the value of its
  		// `name` keypath gets set to its value
  		if (this.element.node.checked) {
  			Binding_Binding.prototype.handleChange.call(this);
  		}
  	},

  	rebound: function (oldKeypath, newKeypath) {
  		var node;

  		Binding_Binding.prototype.rebound.call(this, oldKeypath, newKeypath);

  		if (node = this.element.node) {
  			node.name = "{{" + this.keypath.str + "}}";
  		}
  	},

  	unbind: function () {
  		removeFromArray(this.siblings, this);
  	}
  });

  var Binding_RadioNameBinding = RadioNameBinding;

  var CheckboxNameBinding = Binding_Binding.extend({
  	name: "name",

  	getInitialValue: function () {
  		// This only gets called once per group (of inputs that
  		// share a name), because it only gets called if there
  		// isn't an initial value. By the same token, we can make
  		// a note of that fact that there was no initial value,
  		// and populate it using any `checked` attributes that
  		// exist (which users should avoid, but which we should
  		// support anyway to avoid breaking expectations)
  		this.noInitialValue = true;
  		return [];
  	},

  	init: function () {
  		var existingValue, bindingValue;

  		this.checkboxName = true; // so that ractive.updateModel() knows what to do with this

  		// Each input has a reference to an array containing it and its
  		// siblings, as two-way binding depends on being able to ascertain
  		// the status of all inputs within the group
  		this.siblings = shared_getSiblings(this.root._guid, "checkboxes", this.keypath.str);
  		this.siblings.push(this);

  		if (this.noInitialValue) {
  			this.siblings.noInitialValue = true;
  		}

  		// If no initial value was set, and this input is checked, we
  		// update the model
  		if (this.siblings.noInitialValue && this.element.getAttribute("checked")) {
  			existingValue = this.root.viewmodel.get(this.keypath);
  			bindingValue = this.element.getAttribute("value");

  			existingValue.push(bindingValue);
  		}
  	},

  	unbind: function () {
  		removeFromArray(this.siblings, this);
  	},

  	render: function () {
  		var node = this.element.node,
  		    existingValue,
  		    bindingValue;

  		existingValue = this.root.viewmodel.get(this.keypath);
  		bindingValue = this.element.getAttribute("value");

  		if (isArray(existingValue)) {
  			this.isChecked = arrayContains(existingValue, bindingValue);
  		} else {
  			this.isChecked = existingValue == bindingValue;
  		}

  		node.name = "{{" + this.keypath.str + "}}";
  		node.checked = this.isChecked;

  		node.addEventListener("change", handleDomEvent, false);

  		// in case of IE emergency, bind to click event as well
  		if (node.attachEvent) {
  			node.addEventListener("click", handleDomEvent, false);
  		}
  	},

  	unrender: function () {
  		var node = this.element.node;

  		node.removeEventListener("change", handleDomEvent, false);
  		node.removeEventListener("click", handleDomEvent, false);
  	},

  	changed: function () {
  		var wasChecked = !!this.isChecked;
  		this.isChecked = this.element.node.checked;
  		return this.isChecked === wasChecked;
  	},

  	handleChange: function () {
  		this.isChecked = this.element.node.checked;
  		Binding_Binding.prototype.handleChange.call(this);
  	},

  	getValue: function () {
  		return this.siblings.filter(isChecked).map(Binding_CheckboxNameBinding__getValue);
  	}
  });

  function isChecked(binding) {
  	return binding.isChecked;
  }

  function Binding_CheckboxNameBinding__getValue(binding) {
  	return binding.element.getAttribute("value");
  }

  var Binding_CheckboxNameBinding = CheckboxNameBinding;

  var CheckboxBinding = Binding_Binding.extend({
  	name: "checked",

  	render: function () {
  		var node = this.element.node;

  		node.addEventListener("change", handleDomEvent, false);

  		if (node.attachEvent) {
  			node.addEventListener("click", handleDomEvent, false);
  		}
  	},

  	unrender: function () {
  		var node = this.element.node;

  		node.removeEventListener("change", handleDomEvent, false);
  		node.removeEventListener("click", handleDomEvent, false);
  	},

  	getValue: function () {
  		return this.element.node.checked;
  	}
  });

  var Binding_CheckboxBinding = CheckboxBinding;

  var SelectBinding = Binding_Binding.extend({
  	getInitialValue: function () {
  		var options = this.element.options,
  		    len,
  		    i,
  		    value,
  		    optionWasSelected;

  		if (this.element.getAttribute("value") !== undefined) {
  			return;
  		}

  		i = len = options.length;

  		if (!len) {
  			return;
  		}

  		// take the final selected option...
  		while (i--) {
  			if (options[i].getAttribute("selected")) {
  				value = options[i].getAttribute("value");
  				optionWasSelected = true;
  				break;
  			}
  		}

  		// or the first non-disabled option, if none are selected
  		if (!optionWasSelected) {
  			while (++i < len) {
  				if (!options[i].getAttribute("disabled")) {
  					value = options[i].getAttribute("value");
  					break;
  				}
  			}
  		}

  		// This is an optimisation (aka hack) that allows us to forgo some
  		// other more expensive work
  		if (value !== undefined) {
  			this.element.attributes.value.value = value;
  		}

  		return value;
  	},

  	render: function () {
  		this.element.node.addEventListener("change", handleDomEvent, false);
  	},

  	unrender: function () {
  		this.element.node.removeEventListener("change", handleDomEvent, false);
  	},

  	// TODO this method is an anomaly... is it necessary?
  	setValue: function (value) {
  		this.root.viewmodel.set(this.keypath, value);
  	},

  	getValue: function () {
  		var options, i, len, option, optionValue;

  		options = this.element.node.options;
  		len = options.length;

  		for (i = 0; i < len; i += 1) {
  			option = options[i];

  			if (options[i].selected) {
  				optionValue = option._ractive ? option._ractive.value : option.value;
  				return optionValue;
  			}
  		}
  	},

  	forceUpdate: function () {
  		var _this = this;

  		var value = this.getValue();

  		if (value !== undefined) {
  			this.attribute.locked = true;
  			global_runloop.scheduleTask(function () {
  				return _this.attribute.locked = false;
  			});
  			this.root.viewmodel.set(this.keypath, value);
  		}
  	}
  });

  var Binding_SelectBinding = SelectBinding;

  var MultipleSelectBinding = Binding_SelectBinding.extend({
  	getInitialValue: function () {
  		return this.element.options.filter(function (option) {
  			return option.getAttribute("selected");
  		}).map(function (option) {
  			return option.getAttribute("value");
  		});
  	},

  	render: function () {
  		var valueFromModel;

  		this.element.node.addEventListener("change", handleDomEvent, false);

  		valueFromModel = this.root.viewmodel.get(this.keypath);

  		if (valueFromModel === undefined) {
  			// get value from DOM, if possible
  			this.handleChange();
  		}
  	},

  	unrender: function () {
  		this.element.node.removeEventListener("change", handleDomEvent, false);
  	},

  	setValue: function () {
  		throw new Error("TODO not implemented yet");
  	},

  	getValue: function () {
  		var selectedValues, options, i, len, option, optionValue;

  		selectedValues = [];
  		options = this.element.node.options;
  		len = options.length;

  		for (i = 0; i < len; i += 1) {
  			option = options[i];

  			if (option.selected) {
  				optionValue = option._ractive ? option._ractive.value : option.value;
  				selectedValues.push(optionValue);
  			}
  		}

  		return selectedValues;
  	},

  	handleChange: function () {
  		var attribute, previousValue, value;

  		attribute = this.attribute;
  		previousValue = attribute.value;

  		value = this.getValue();

  		if (previousValue === undefined || !arrayContentsMatch(value, previousValue)) {
  			Binding_SelectBinding.prototype.handleChange.call(this);
  		}

  		return this;
  	},

  	forceUpdate: function () {
  		var _this = this;

  		var value = this.getValue();

  		if (value !== undefined) {
  			this.attribute.locked = true;
  			global_runloop.scheduleTask(function () {
  				return _this.attribute.locked = false;
  			});
  			this.root.viewmodel.set(this.keypath, value);
  		}
  	},

  	updateModel: function () {
  		if (this.attribute.value === undefined || !this.attribute.value.length) {
  			this.root.viewmodel.set(this.keypath, this.initialValue);
  		}
  	}
  });

  var Binding_MultipleSelectBinding = MultipleSelectBinding;

  var FileListBinding = Binding_Binding.extend({
  	render: function () {
  		this.element.node.addEventListener("change", handleDomEvent, false);
  	},

  	unrender: function () {
  		this.element.node.removeEventListener("change", handleDomEvent, false);
  	},

  	getValue: function () {
  		return this.element.node.files;
  	}
  });

  var Binding_FileListBinding = FileListBinding;

  var NumericBinding = Binding_GenericBinding.extend({
  	getInitialValue: function () {
  		return undefined;
  	},

  	getValue: function () {
  		var value = parseFloat(this.element.node.value);
  		return isNaN(value) ? undefined : value;
  	}
  });

  var init_createTwowayBinding = createTwowayBinding;

  function createTwowayBinding(element) {
  	var attributes = element.attributes,
  	    type,
  	    Binding,
  	    bindName,
  	    bindChecked,
  	    binding;

  	// if this is a late binding, and there's already one, it
  	// needs to be torn down
  	if (element.binding) {
  		element.binding.teardown();
  		element.binding = null;
  	}

  	// contenteditable
  	if (
  	// if the contenteditable attribute is true or is bindable and may thus become true
  	(element.getAttribute("contenteditable") || !!attributes.contenteditable && isBindable(attributes.contenteditable)) && isBindable(attributes.value)) {
  		Binding = Binding_ContentEditableBinding;
  	}

  	// <input>
  	else if (element.name === "input") {
  		type = element.getAttribute("type");

  		if (type === "radio" || type === "checkbox") {
  			bindName = isBindable(attributes.name);
  			bindChecked = isBindable(attributes.checked);

  			// we can either bind the name attribute, or the checked attribute - not both
  			if (bindName && bindChecked) {
  				warnIfDebug("A radio input can have two-way binding on its name attribute, or its checked attribute - not both", { ractive: element.root });
  			}

  			if (bindName) {
  				Binding = type === "radio" ? Binding_RadioNameBinding : Binding_CheckboxNameBinding;
  			} else if (bindChecked) {
  				Binding = type === "radio" ? Binding_RadioBinding : Binding_CheckboxBinding;
  			}
  		} else if (type === "file" && isBindable(attributes.value)) {
  			Binding = Binding_FileListBinding;
  		} else if (isBindable(attributes.value)) {
  			Binding = type === "number" || type === "range" ? NumericBinding : Binding_GenericBinding;
  		}
  	}

  	// <select>
  	else if (element.name === "select" && isBindable(attributes.value)) {
  		Binding = element.getAttribute("multiple") ? Binding_MultipleSelectBinding : Binding_SelectBinding;
  	}

  	// <textarea>
  	else if (element.name === "textarea" && isBindable(attributes.value)) {
  		Binding = Binding_GenericBinding;
  	}

  	if (Binding && (binding = new Binding(element)) && binding.keypath) {
  		return binding;
  	}
  }

  function isBindable(attribute) {
  	return attribute && attribute.isBindable;
  }

  // and this element also has a value attribute to bind

  var EventHandler_prototype_bubble = EventHandler$bubble;

  function EventHandler$bubble() {
  	var hasAction = this.getAction();

  	if (hasAction && !this.hasListener) {
  		this.listen();
  	} else if (!hasAction && this.hasListener) {
  		this.unrender();
  	}
  }

  // This function may be overwritten, if the event directive
  // includes parameters
  var EventHandler_prototype_fire = EventHandler$fire;
  function EventHandler$fire(event) {
  	shared_fireEvent(this.root, this.getAction(), { event: event });
  }

  var getAction = EventHandler$getAction;

  function EventHandler$getAction() {
  	return this.action.toString().trim();
  }

  var EventHandler_prototype_init = EventHandler$init;

  var eventPattern = /^event(?:\.(.+))?/;
  function EventHandler$init(element, name, template) {
  	var _this = this;

  	var action, refs, ractive;

  	this.element = element;
  	this.root = element.root;
  	this.parentFragment = element.parentFragment;
  	this.name = name;

  	if (name.indexOf("*") !== -1) {
  		fatal("Only component proxy-events may contain \"*\" wildcards, <%s on-%s=\"...\"/> is not valid", element.name, name);
  		this.invalid = true;
  	}

  	if (template.m) {
  		refs = template.a.r;

  		// This is a method call
  		this.method = template.m;
  		this.keypaths = [];
  		this.fn = shared_getFunctionFromString(template.a.s, refs.length);

  		this.parentFragment = element.parentFragment;
  		ractive = this.root;

  		// Create resolvers for each reference
  		this.refResolvers = [];
  		refs.forEach(function (ref, i) {
  			var match = undefined;

  			// special case - the `event` object
  			if (match = eventPattern.exec(ref)) {
  				_this.keypaths[i] = {
  					eventObject: true,
  					refinements: match[1] ? match[1].split(".") : []
  				};
  			} else {
  				_this.refResolvers.push(Resolvers_createReferenceResolver(_this, ref, function (keypath) {
  					return _this.resolve(i, keypath);
  				}));
  			}
  		});

  		this.fire = fireMethodCall;
  	} else {
  		// Get action ('foo' in 'on-click='foo')
  		action = template.n || template;
  		if (typeof action !== "string") {
  			action = new virtualdom_Fragment({
  				template: action,
  				root: this.root,
  				owner: this
  			});
  		}

  		this.action = action;

  		// Get parameters
  		if (template.d) {
  			this.dynamicParams = new virtualdom_Fragment({
  				template: template.d,
  				root: this.root,
  				owner: this.element
  			});

  			this.fire = fireEventWithDynamicParams;
  		} else if (template.a) {
  			this.params = template.a;
  			this.fire = fireEventWithParams;
  		}
  	}
  }

  function fireMethodCall(event) {
  	var ractive, values, args;

  	ractive = this.root;

  	if (typeof ractive[this.method] !== "function") {
  		throw new Error("Attempted to call a non-existent method (\"" + this.method + "\")");
  	}

  	values = this.keypaths.map(function (keypath) {
  		var value, len, i;

  		if (keypath === undefined) {
  			// not yet resolved
  			return undefined;
  		}

  		// TODO the refinements stuff would be better handled at parse time
  		if (keypath.eventObject) {
  			value = event;

  			if (len = keypath.refinements.length) {
  				for (i = 0; i < len; i += 1) {
  					value = value[keypath.refinements[i]];
  				}
  			}
  		} else {
  			value = ractive.viewmodel.get(keypath);
  		}

  		return value;
  	});

  	shared_eventStack.enqueue(ractive, event);

  	args = this.fn.apply(null, values);
  	ractive[this.method].apply(ractive, args);

  	shared_eventStack.dequeue(ractive);
  }

  function fireEventWithParams(event) {
  	shared_fireEvent(this.root, this.getAction(), { event: event, args: this.params });
  }

  function fireEventWithDynamicParams(event) {
  	var args = this.dynamicParams.getArgsList();

  	// need to strip [] from ends if a string!
  	if (typeof args === "string") {
  		args = args.substr(1, args.length - 2);
  	}

  	shared_fireEvent(this.root, this.getAction(), { event: event, args: args });
  }

  var shared_genericHandler = genericHandler;
  function genericHandler(event) {
  	var storage,
  	    handler,
  	    indices,
  	    index = {};

  	storage = this._ractive;
  	handler = storage.events[event.type];

  	if (indices = Resolvers_findIndexRefs(handler.element.parentFragment)) {
  		index = Resolvers_findIndexRefs.resolve(indices);
  	}

  	handler.fire({
  		node: this,
  		original: event,
  		index: index,
  		keypath: storage.keypath.str,
  		context: storage.root.viewmodel.get(storage.keypath)
  	});
  }

  var listen = EventHandler$listen;

  var customHandlers = {},
      touchEvents = {
  	touchstart: true,
  	touchmove: true,
  	touchend: true,
  	touchcancel: true,
  	//not w3c, but supported in some browsers
  	touchleave: true
  };
  function EventHandler$listen() {
  	var definition,
  	    name = this.name;

  	if (this.invalid) {
  		return;
  	}

  	if (definition = findInViewHierarchy("events", this.root, name)) {
  		this.custom = definition(this.node, getCustomHandler(name));
  	} else {
  		// Looks like we're dealing with a standard DOM event... but let's check
  		if (!("on" + name in this.node) && !(window && "on" + name in window) && !isJsdom) {

  			// okay to use touch events if this browser doesn't support them
  			if (!touchEvents[name]) {
  				warnOnceIfDebug(missingPlugin(name, "event"), { node: this.node });
  			}

  			return;
  		}

  		this.node.addEventListener(name, shared_genericHandler, false);
  	}

  	this.hasListener = true;
  }

  function getCustomHandler(name) {
  	if (!customHandlers[name]) {
  		customHandlers[name] = function (event) {
  			var storage = event.node._ractive;

  			event.index = storage.index;
  			event.keypath = storage.keypath.str;
  			event.context = storage.root.viewmodel.get(storage.keypath);

  			storage.events[name].fire(event);
  		};
  	}

  	return customHandlers[name];
  }

  var EventHandler_prototype_rebind = EventHandler$rebind;

  function EventHandler$rebind(oldKeypath, newKeypath) {
  	var fragment;
  	if (this.method) {
  		fragment = this.element.parentFragment;
  		this.refResolvers.forEach(rebind);

  		return;
  	}

  	if (typeof this.action !== "string") {
  		rebind(this.action);
  	}

  	if (this.dynamicParams) {
  		rebind(this.dynamicParams);
  	}

  	function rebind(thing) {
  		thing && thing.rebind(oldKeypath, newKeypath);
  	}
  }

  var EventHandler_prototype_render = EventHandler$render;

  function EventHandler$render() {
  	this.node = this.element.node;
  	// store this on the node itself, so it can be retrieved by a
  	// universal handler
  	this.node._ractive.events[this.name] = this;

  	if (this.method || this.getAction()) {
  		this.listen();
  	}
  }

  var prototype_resolve = EventHandler$resolve;

  function EventHandler$resolve(index, keypath) {
  	this.keypaths[index] = keypath;
  }

  var EventHandler_prototype_unbind = EventHandler$unbind;
  function EventHandler$unbind() {
  	if (this.method) {
  		this.refResolvers.forEach(methodCallers__unbind);
  		return;
  	}

  	// Tear down dynamic name
  	if (typeof this.action !== "string") {
  		this.action.unbind();
  	}

  	// Tear down dynamic parameters
  	if (this.dynamicParams) {
  		this.dynamicParams.unbind();
  	}
  }

  var EventHandler_prototype_unrender = EventHandler$unrender;
  function EventHandler$unrender() {

  	if (this.custom) {
  		this.custom.teardown();
  	} else {
  		this.node.removeEventListener(this.name, shared_genericHandler, false);
  	}

  	this.hasListener = false;
  }

  var EventHandler = function (element, name, template) {
  	this.init(element, name, template);
  };

  EventHandler.prototype = {
  	bubble: EventHandler_prototype_bubble,
  	fire: EventHandler_prototype_fire,
  	getAction: getAction,
  	init: EventHandler_prototype_init,
  	listen: listen,
  	rebind: EventHandler_prototype_rebind,
  	render: EventHandler_prototype_render,
  	resolve: prototype_resolve,
  	unbind: EventHandler_prototype_unbind,
  	unrender: EventHandler_prototype_unrender
  };

  var _EventHandler = EventHandler;

  var createEventHandlers = function (element, template) {
  	var i,
  	    name,
  	    names,
  	    handler,
  	    result = [];

  	for (name in template) {
  		if (template.hasOwnProperty(name)) {
  			names = name.split("-");
  			i = names.length;

  			while (i--) {
  				handler = new _EventHandler(element, names[i], template[name]);
  				result.push(handler);
  			}
  		}
  	}

  	return result;
  };

  var Decorator = function (element, template) {
  	var self = this,
  	    ractive,
  	    name,
  	    fragment;

  	this.element = element;
  	this.root = ractive = element.root;

  	name = template.n || template;

  	if (typeof name !== "string") {
  		fragment = new virtualdom_Fragment({
  			template: name,
  			root: ractive,
  			owner: element
  		});

  		name = fragment.toString();
  		fragment.unbind();

  		if (name === "") {
  			// empty string okay, just no decorator
  			return;
  		}
  	}

  	if (template.a) {
  		this.params = template.a;
  	} else if (template.d) {
  		this.fragment = new virtualdom_Fragment({
  			template: template.d,
  			root: ractive,
  			owner: element
  		});

  		this.params = this.fragment.getArgsList();

  		this.fragment.bubble = function () {
  			this.dirtyArgs = this.dirtyValue = true;
  			self.params = this.getArgsList();

  			if (self.ready) {
  				self.update();
  			}
  		};
  	}

  	this.fn = findInViewHierarchy("decorators", ractive, name);

  	if (!this.fn) {
  		fatal(missingPlugin(name, "decorator"));
  	}
  };

  Decorator.prototype = {
  	init: function () {
  		var node, result, args;

  		node = this.element.node;

  		if (this.params) {
  			args = [node].concat(this.params);
  			result = this.fn.apply(this.root, args);
  		} else {
  			result = this.fn.call(this.root, node);
  		}

  		if (!result || !result.teardown) {
  			throw new Error("Decorator definition must return an object with a teardown method");
  		}

  		// TODO does this make sense?
  		this.actual = result;
  		this.ready = true;
  	},

  	update: function () {
  		if (this.actual.update) {
  			this.actual.update.apply(this.root, this.params);
  		} else {
  			this.actual.teardown(true);
  			this.init();
  		}
  	},

  	rebind: function (oldKeypath, newKeypath) {
  		if (this.fragment) {
  			this.fragment.rebind(oldKeypath, newKeypath);
  		}
  	},

  	teardown: function (updating) {
  		this.torndown = true;
  		if (this.ready) {
  			this.actual.teardown();
  		}

  		if (!updating && this.fragment) {
  			this.fragment.unbind();
  		}
  	}
  };

  var _Decorator = Decorator;

  function select__bubble() {
  	var _this = this;

  	if (!this.dirty) {
  		this.dirty = true;

  		global_runloop.scheduleTask(function () {
  			sync(_this);
  			_this.dirty = false;
  		});
  	}

  	this.parentFragment.bubble(); // default behaviour
  }

  function sync(selectElement) {
  	var selectNode, selectValue, isMultiple, options, optionWasSelected;

  	selectNode = selectElement.node;

  	if (!selectNode) {
  		return;
  	}

  	options = toArray(selectNode.options);

  	selectValue = selectElement.getAttribute("value");
  	isMultiple = selectElement.getAttribute("multiple");

  	// If the <select> has a specified value, that should override
  	// these options
  	if (selectValue !== undefined) {
  		options.forEach(function (o) {
  			var optionValue, shouldSelect;

  			optionValue = o._ractive ? o._ractive.value : o.value;
  			shouldSelect = isMultiple ? valueContains(selectValue, optionValue) : selectValue == optionValue;

  			if (shouldSelect) {
  				optionWasSelected = true;
  			}

  			o.selected = shouldSelect;
  		});

  		if (!optionWasSelected) {
  			if (options[0]) {
  				options[0].selected = true;
  			}

  			if (selectElement.binding) {
  				selectElement.binding.forceUpdate();
  			}
  		}
  	}

  	// Otherwise the value should be initialised according to which
  	// <option> element is selected, if twoway binding is in effect
  	else if (selectElement.binding) {
  		selectElement.binding.forceUpdate();
  	}
  }

  function valueContains(selectValue, optionValue) {
  	var i = selectValue.length;
  	while (i--) {
  		if (selectValue[i] == optionValue) {
  			return true;
  		}
  	}
  }

  function special_option__init(option, template) {
  	option.select = findParentSelect(option.parent);

  	// we might be inside a <datalist> element
  	if (!option.select) {
  		return;
  	}

  	option.select.options.push(option);

  	// If the value attribute is missing, use the element's content
  	if (!template.a) {
  		template.a = {};
  	}

  	// ...as long as it isn't disabled
  	if (template.a.value === undefined && !template.a.hasOwnProperty("disabled")) {
  		template.a.value = template.f;
  	}

  	// If there is a `selected` attribute, but the <select>
  	// already has a value, delete it
  	if ("selected" in template.a && option.select.getAttribute("value") !== undefined) {
  		delete template.a.selected;
  	}
  }

  function special_option__unbind(option) {
  	if (option.select) {
  		removeFromArray(option.select.options, option);
  	}
  }

  function findParentSelect(element) {
  	if (!element) {
  		return;
  	}

  	do {
  		if (element.name === "select") {
  			return element;
  		}
  	} while (element = element.parent);
  }

  var Element_prototype_init = Element$init;
  function Element$init(options) {
  	var parentFragment, template, ractive, binding, bindings, twoway, bindingAttrs;

  	this.type = ELEMENT;

  	// stuff we'll need later
  	parentFragment = this.parentFragment = options.parentFragment;
  	template = this.template = options.template;

  	this.parent = options.pElement || parentFragment.pElement;

  	this.root = ractive = parentFragment.root;
  	this.index = options.index;
  	this.key = options.key;

  	this.name = enforceCase(template.e);

  	// Special case - <option> elements
  	if (this.name === "option") {
  		special_option__init(this, template);
  	}

  	// Special case - <select> elements
  	if (this.name === "select") {
  		this.options = [];
  		this.bubble = select__bubble; // TODO this is a kludge
  	}

  	// Special case - <form> elements
  	if (this.name === "form") {
  		this.formBindings = [];
  	}

  	// handle binding attributes first (twoway, lazy)
  	bindingAttrs = processBindingAttributes(this, template);

  	// create attributes
  	this.attributes = createAttributes(this, template.a);
  	this.conditionalAttributes = createConditionalAttributes(this, template.m);

  	// append children, if there are any
  	if (template.f) {
  		this.fragment = new virtualdom_Fragment({
  			template: template.f,
  			root: ractive,
  			owner: this,
  			pElement: this,
  			cssIds: null
  		});
  	}

  	// the element setting should override the ractive setting
  	twoway = ractive.twoway;
  	if (bindingAttrs.twoway === false) twoway = false;else if (bindingAttrs.twoway === true) twoway = true;

  	this.twoway = twoway;
  	this.lazy = bindingAttrs.lazy;

  	// create twoway binding
  	if (twoway && (binding = init_createTwowayBinding(this, template.a))) {
  		this.binding = binding;

  		// register this with the root, so that we can do ractive.updateModel()
  		bindings = this.root._twowayBindings[binding.keypath.str] || (this.root._twowayBindings[binding.keypath.str] = []);
  		bindings.push(binding);
  	}

  	// create event proxies
  	if (template.v) {
  		this.eventHandlers = createEventHandlers(this, template.v);
  	}

  	// create decorator
  	if (template.o) {
  		this.decorator = new _Decorator(this, template.o);
  	}

  	// create transitions
  	this.intro = template.t0 || template.t1;
  	this.outro = template.t0 || template.t2;
  }

  var Element_prototype_rebind = Element$rebind;
  function Element$rebind(oldKeypath, newKeypath) {
  	var i, storage, liveQueries, ractive;

  	if (this.attributes) {
  		this.attributes.forEach(rebind);
  	}

  	if (this.conditionalAttributes) {
  		this.conditionalAttributes.forEach(rebind);
  	}

  	if (this.eventHandlers) {
  		this.eventHandlers.forEach(rebind);
  	}

  	if (this.decorator) {
  		rebind(this.decorator);
  	}

  	// rebind children
  	if (this.fragment) {
  		rebind(this.fragment);
  	}

  	// Update live queries, if necessary
  	if (liveQueries = this.liveQueries) {
  		ractive = this.root;

  		i = liveQueries.length;
  		while (i--) {
  			liveQueries[i]._makeDirty();
  		}
  	}

  	if (this.node && (storage = this.node._ractive)) {

  		// adjust keypath if needed
  		assignNewKeypath(storage, "keypath", oldKeypath, newKeypath);
  	}

  	function rebind(thing) {
  		thing.rebind(oldKeypath, newKeypath);
  	}
  }

  function special_img__render(img) {
  	var loadHandler;

  	// if this is an <img>, and we're in a crap browser, we may need to prevent it
  	// from overriding width and height when it loads the src
  	if (img.attributes.width || img.attributes.height) {
  		img.node.addEventListener("load", loadHandler = function () {
  			var width = img.getAttribute("width"),
  			    height = img.getAttribute("height");

  			if (width !== undefined) {
  				img.node.setAttribute("width", width);
  			}

  			if (height !== undefined) {
  				img.node.setAttribute("height", height);
  			}

  			img.node.removeEventListener("load", loadHandler, false);
  		}, false);
  	}
  }

  function form__render(element) {
  	element.node.addEventListener("reset", handleReset, false);
  }

  function form__unrender(element) {
  	element.node.removeEventListener("reset", handleReset, false);
  }

  function handleReset() {
  	var element = this._ractive.proxy;

  	global_runloop.start();
  	element.formBindings.forEach(updateModel);
  	global_runloop.end();
  }

  function updateModel(binding) {
  	binding.root.viewmodel.set(binding.keypath, binding.resetValue);
  }

  var Transition_prototype_init = Transition$init;
  function Transition$init(element, template, isIntro) {
  	var ractive, name, fragment;

  	this.element = element;
  	this.root = ractive = element.root;
  	this.isIntro = isIntro;

  	name = template.n || template;

  	if (typeof name !== "string") {
  		fragment = new virtualdom_Fragment({
  			template: name,
  			root: ractive,
  			owner: element
  		});

  		name = fragment.toString();
  		fragment.unbind();

  		if (name === "") {
  			// empty string okay, just no transition
  			return;
  		}
  	}

  	this.name = name;

  	if (template.a) {
  		this.params = template.a;
  	} else if (template.d) {
  		// TODO is there a way to interpret dynamic arguments without all the
  		// 'dependency thrashing'?
  		fragment = new virtualdom_Fragment({
  			template: template.d,
  			root: ractive,
  			owner: element
  		});

  		this.params = fragment.getArgsList();
  		fragment.unbind();
  	}

  	this._fn = findInViewHierarchy("transitions", ractive, name);

  	if (!this._fn) {
  		warnOnceIfDebug(missingPlugin(name, "transition"), { ractive: this.root });
  	}
  }

  var camelCase = function (hyphenatedStr) {
  	return hyphenatedStr.replace(/-([a-zA-Z])/g, function (match, $1) {
  		return $1.toUpperCase();
  	});
  };

  var helpers_prefix__prefix, prefixCache, helpers_prefix__testStyle;

  if (!isClient) {
  	helpers_prefix__prefix = null;
  } else {
  	prefixCache = {};
  	helpers_prefix__testStyle = createElement("div").style;

  	helpers_prefix__prefix = function (prop) {
  		var i, vendor, capped;

  		prop = camelCase(prop);

  		if (!prefixCache[prop]) {
  			if (helpers_prefix__testStyle[prop] !== undefined) {
  				prefixCache[prop] = prop;
  			} else {
  				// test vendors...
  				capped = prop.charAt(0).toUpperCase() + prop.substring(1);

  				i = vendors.length;
  				while (i--) {
  					vendor = vendors[i];
  					if (helpers_prefix__testStyle[vendor + capped] !== undefined) {
  						prefixCache[prop] = vendor + capped;
  						break;
  					}
  				}
  			}
  		}

  		return prefixCache[prop];
  	};
  }

  var helpers_prefix = helpers_prefix__prefix;

  var getStyle, prototype_getStyle__getComputedStyle;

  if (!isClient) {
  	getStyle = null;
  } else {
  	prototype_getStyle__getComputedStyle = window.getComputedStyle || legacy.getComputedStyle;

  	getStyle = function (props) {
  		var computedStyle, styles, i, prop, value;

  		computedStyle = prototype_getStyle__getComputedStyle(this.node);

  		if (typeof props === "string") {
  			value = computedStyle[helpers_prefix(props)];
  			if (value === "0px") {
  				value = 0;
  			}
  			return value;
  		}

  		if (!isArray(props)) {
  			throw new Error("Transition$getStyle must be passed a string, or an array of strings representing CSS properties");
  		}

  		styles = {};

  		i = props.length;
  		while (i--) {
  			prop = props[i];
  			value = computedStyle[helpers_prefix(prop)];
  			if (value === "0px") {
  				value = 0;
  			}
  			styles[prop] = value;
  		}

  		return styles;
  	};
  }

  var prototype_getStyle = getStyle;

  var setStyle = function (style, value) {
  	var prop;

  	if (typeof style === "string") {
  		this.node.style[helpers_prefix(style)] = value;
  	} else {
  		for (prop in style) {
  			if (style.hasOwnProperty(prop)) {
  				this.node.style[helpers_prefix(prop)] = style[prop];
  			}
  		}
  	}

  	return this;
  };

  var Ticker = function (options) {
  	var easing;

  	this.duration = options.duration;
  	this.step = options.step;
  	this.complete = options.complete;

  	// easing
  	if (typeof options.easing === "string") {
  		easing = options.root.easing[options.easing];

  		if (!easing) {
  			warnOnceIfDebug(missingPlugin(options.easing, "easing"));
  			easing = linear;
  		}
  	} else if (typeof options.easing === "function") {
  		easing = options.easing;
  	} else {
  		easing = linear;
  	}

  	this.easing = easing;

  	this.start = utils_getTime();
  	this.end = this.start + this.duration;

  	this.running = true;
  	shared_animations.add(this);
  };

  Ticker.prototype = {
  	tick: function (now) {
  		var elapsed, eased;

  		if (!this.running) {
  			return false;
  		}

  		if (now > this.end) {
  			if (this.step) {
  				this.step(1);
  			}

  			if (this.complete) {
  				this.complete(1);
  			}

  			return false;
  		}

  		elapsed = now - this.start;
  		eased = this.easing(elapsed / this.duration);

  		if (this.step) {
  			this.step(eased);
  		}

  		return true;
  	},

  	stop: function () {
  		if (this.abort) {
  			this.abort();
  		}

  		this.running = false;
  	}
  };

  var shared_Ticker = Ticker;
  function linear(t) {
  	return t;
  }

  var unprefixPattern = new RegExp("^-(?:" + vendors.join("|") + ")-");

  var unprefix = function (prop) {
  	return prop.replace(unprefixPattern, "");
  };

  var vendorPattern = new RegExp("^(?:" + vendors.join("|") + ")([A-Z])");

  var hyphenate = function (str) {
  	var hyphenated;

  	if (!str) {
  		return ""; // edge case
  	}

  	if (vendorPattern.test(str)) {
  		str = "-" + str;
  	}

  	hyphenated = str.replace(/[A-Z]/g, function (match) {
  		return "-" + match.toLowerCase();
  	});

  	return hyphenated;
  };

  var createTransitions,
      animateStyle_createTransitions__testStyle,
      TRANSITION,
      TRANSITIONEND,
      CSS_TRANSITIONS_ENABLED,
      TRANSITION_DURATION,
      TRANSITION_PROPERTY,
      TRANSITION_TIMING_FUNCTION,
      canUseCssTransitions = {},
      cannotUseCssTransitions = {};

  if (!isClient) {
  	createTransitions = null;
  } else {
  	animateStyle_createTransitions__testStyle = createElement("div").style;

  	// determine some facts about our environment
  	(function () {
  		if (animateStyle_createTransitions__testStyle.transition !== undefined) {
  			TRANSITION = "transition";
  			TRANSITIONEND = "transitionend";
  			CSS_TRANSITIONS_ENABLED = true;
  		} else if (animateStyle_createTransitions__testStyle.webkitTransition !== undefined) {
  			TRANSITION = "webkitTransition";
  			TRANSITIONEND = "webkitTransitionEnd";
  			CSS_TRANSITIONS_ENABLED = true;
  		} else {
  			CSS_TRANSITIONS_ENABLED = false;
  		}
  	})();

  	if (TRANSITION) {
  		TRANSITION_DURATION = TRANSITION + "Duration";
  		TRANSITION_PROPERTY = TRANSITION + "Property";
  		TRANSITION_TIMING_FUNCTION = TRANSITION + "TimingFunction";
  	}

  	createTransitions = function (t, to, options, changedProperties, resolve) {

  		// Wait a beat (otherwise the target styles will be applied immediately)
  		// TODO use a fastdom-style mechanism?
  		setTimeout(function () {

  			var hashPrefix, jsTransitionsComplete, cssTransitionsComplete, checkComplete, transitionEndHandler;

  			checkComplete = function () {
  				if (jsTransitionsComplete && cssTransitionsComplete) {
  					// will changes to events and fire have an unexpected consequence here?
  					t.root.fire(t.name + ":end", t.node, t.isIntro);
  					resolve();
  				}
  			};

  			// this is used to keep track of which elements can use CSS to animate
  			// which properties
  			hashPrefix = (t.node.namespaceURI || "") + t.node.tagName;

  			t.node.style[TRANSITION_PROPERTY] = changedProperties.map(helpers_prefix).map(hyphenate).join(",");
  			t.node.style[TRANSITION_TIMING_FUNCTION] = hyphenate(options.easing || "linear");
  			t.node.style[TRANSITION_DURATION] = options.duration / 1000 + "s";

  			transitionEndHandler = function (event) {
  				var index;

  				index = changedProperties.indexOf(camelCase(unprefix(event.propertyName)));
  				if (index !== -1) {
  					changedProperties.splice(index, 1);
  				}

  				if (changedProperties.length) {
  					// still transitioning...
  					return;
  				}

  				t.node.removeEventListener(TRANSITIONEND, transitionEndHandler, false);

  				cssTransitionsComplete = true;
  				checkComplete();
  			};

  			t.node.addEventListener(TRANSITIONEND, transitionEndHandler, false);

  			setTimeout(function () {
  				var i = changedProperties.length,
  				    hash,
  				    originalValue,
  				    index,
  				    propertiesToTransitionInJs = [],
  				    prop,
  				    suffix;

  				while (i--) {
  					prop = changedProperties[i];
  					hash = hashPrefix + prop;

  					if (CSS_TRANSITIONS_ENABLED && !cannotUseCssTransitions[hash]) {
  						t.node.style[helpers_prefix(prop)] = to[prop];

  						// If we're not sure if CSS transitions are supported for
  						// this tag/property combo, find out now
  						if (!canUseCssTransitions[hash]) {
  							originalValue = t.getStyle(prop);

  							// if this property is transitionable in this browser,
  							// the current style will be different from the target style
  							canUseCssTransitions[hash] = t.getStyle(prop) != to[prop];
  							cannotUseCssTransitions[hash] = !canUseCssTransitions[hash];

  							// Reset, if we're going to use timers after all
  							if (cannotUseCssTransitions[hash]) {
  								t.node.style[helpers_prefix(prop)] = originalValue;
  							}
  						}
  					}

  					if (!CSS_TRANSITIONS_ENABLED || cannotUseCssTransitions[hash]) {
  						// we need to fall back to timer-based stuff
  						if (originalValue === undefined) {
  							originalValue = t.getStyle(prop);
  						}

  						// need to remove this from changedProperties, otherwise transitionEndHandler
  						// will get confused
  						index = changedProperties.indexOf(prop);
  						if (index === -1) {
  							warnIfDebug("Something very strange happened with transitions. Please raise an issue at https://github.com/ractivejs/ractive/issues - thanks!", { node: t.node });
  						} else {
  							changedProperties.splice(index, 1);
  						}

  						// TODO Determine whether this property is animatable at all

  						suffix = /[^\d]*$/.exec(to[prop])[0];

  						// ...then kick off a timer-based transition
  						propertiesToTransitionInJs.push({
  							name: helpers_prefix(prop),
  							interpolator: shared_interpolate(parseFloat(originalValue), parseFloat(to[prop])),
  							suffix: suffix
  						});
  					}
  				}

  				// javascript transitions
  				if (propertiesToTransitionInJs.length) {
  					new shared_Ticker({
  						root: t.root,
  						duration: options.duration,
  						easing: camelCase(options.easing || ""),
  						step: function (pos) {
  							var prop, i;

  							i = propertiesToTransitionInJs.length;
  							while (i--) {
  								prop = propertiesToTransitionInJs[i];
  								t.node.style[prop.name] = prop.interpolator(pos) + prop.suffix;
  							}
  						},
  						complete: function () {
  							jsTransitionsComplete = true;
  							checkComplete();
  						}
  					});
  				} else {
  					jsTransitionsComplete = true;
  				}

  				if (!changedProperties.length) {
  					// We need to cancel the transitionEndHandler, and deal with
  					// the fact that it will never fire
  					t.node.removeEventListener(TRANSITIONEND, transitionEndHandler, false);
  					cssTransitionsComplete = true;
  					checkComplete();
  				}
  			}, 0);
  		}, options.delay || 0);
  	};
  }

  var animateStyle_createTransitions = createTransitions;

  var hidden, vendor, animateStyle_visibility__prefix, animateStyle_visibility__i, visibility;

  if (typeof document !== "undefined") {
  	hidden = "hidden";

  	visibility = {};

  	if (hidden in document) {
  		animateStyle_visibility__prefix = "";
  	} else {
  		animateStyle_visibility__i = vendors.length;
  		while (animateStyle_visibility__i--) {
  			vendor = vendors[animateStyle_visibility__i];
  			hidden = vendor + "Hidden";

  			if (hidden in document) {
  				animateStyle_visibility__prefix = vendor;
  			}
  		}
  	}

  	if (animateStyle_visibility__prefix !== undefined) {
  		document.addEventListener(animateStyle_visibility__prefix + "visibilitychange", onChange);

  		// initialise
  		onChange();
  	} else {
  		// gah, we're in an old browser
  		if ("onfocusout" in document) {
  			document.addEventListener("focusout", onHide);
  			document.addEventListener("focusin", onShow);
  		} else {
  			window.addEventListener("pagehide", onHide);
  			window.addEventListener("blur", onHide);

  			window.addEventListener("pageshow", onShow);
  			window.addEventListener("focus", onShow);
  		}

  		visibility.hidden = false; // until proven otherwise. Not ideal but hey
  	}
  }

  function onChange() {
  	visibility.hidden = document[hidden];
  }

  function onHide() {
  	visibility.hidden = true;
  }

  function onShow() {
  	visibility.hidden = false;
  }

  var animateStyle_visibility = visibility;

  var animateStyle, _animateStyle__getComputedStyle, resolved;

  if (!isClient) {
  	animateStyle = null;
  } else {
  	_animateStyle__getComputedStyle = window.getComputedStyle || legacy.getComputedStyle;

  	animateStyle = function (style, value, options) {
  		var _this = this;

  		var to;

  		if (arguments.length === 4) {
  			throw new Error("t.animateStyle() returns a promise - use .then() instead of passing a callback");
  		}

  		// Special case - page isn't visible. Don't animate anything, because
  		// that way you'll never get CSS transitionend events
  		if (animateStyle_visibility.hidden) {
  			this.setStyle(style, value);
  			return resolved || (resolved = utils_Promise.resolve());
  		}

  		if (typeof style === "string") {
  			to = {};
  			to[style] = value;
  		} else {
  			to = style;

  			// shuffle arguments
  			options = value;
  		}

  		// As of 0.3.9, transition authors should supply an `option` object with
  		// `duration` and `easing` properties (and optional `delay`), plus a
  		// callback function that gets called after the animation completes

  		// TODO remove this check in a future version
  		if (!options) {
  			warnOnceIfDebug("The \"%s\" transition does not supply an options object to `t.animateStyle()`. This will break in a future version of Ractive. For more info see https://github.com/RactiveJS/Ractive/issues/340", this.name);
  			options = this;
  		}

  		var promise = new utils_Promise(function (resolve) {
  			var propertyNames, changedProperties, computedStyle, current, from, i, prop;

  			// Edge case - if duration is zero, set style synchronously and complete
  			if (!options.duration) {
  				_this.setStyle(to);
  				resolve();
  				return;
  			}

  			// Get a list of the properties we're animating
  			propertyNames = Object.keys(to);
  			changedProperties = [];

  			// Store the current styles
  			computedStyle = _animateStyle__getComputedStyle(_this.node);

  			from = {};
  			i = propertyNames.length;
  			while (i--) {
  				prop = propertyNames[i];
  				current = computedStyle[helpers_prefix(prop)];

  				if (current === "0px") {
  					current = 0;
  				}

  				// we need to know if we're actually changing anything
  				if (current != to[prop]) {
  					// use != instead of !==, so we can compare strings with numbers
  					changedProperties.push(prop);

  					// make the computed style explicit, so we can animate where
  					// e.g. height='auto'
  					_this.node.style[helpers_prefix(prop)] = current;
  				}
  			}

  			// If we're not actually changing anything, the transitionend event
  			// will never fire! So we complete early
  			if (!changedProperties.length) {
  				resolve();
  				return;
  			}

  			animateStyle_createTransitions(_this, to, options, changedProperties, resolve);
  		});

  		return promise;
  	};
  }

  var _animateStyle = animateStyle;

  var processParams = function (params, defaults) {
  	if (typeof params === "number") {
  		params = { duration: params };
  	} else if (typeof params === "string") {
  		if (params === "slow") {
  			params = { duration: 600 };
  		} else if (params === "fast") {
  			params = { duration: 200 };
  		} else {
  			params = { duration: 400 };
  		}
  	} else if (!params) {
  		params = {};
  	}

  	return fillGaps({}, params, defaults);
  };

  var prototype_start = Transition$start;

  function Transition$start() {
  	var _this = this;

  	var node, originalStyle, completed;

  	node = this.node = this.element.node;
  	originalStyle = node.getAttribute("style");

  	// create t.complete() - we don't want this on the prototype,
  	// because we don't want `this` silliness when passing it as
  	// an argument
  	this.complete = function (noReset) {
  		if (completed) {
  			return;
  		}

  		if (!noReset && _this.isIntro) {
  			resetStyle(node, originalStyle);
  		}

  		node._ractive.transition = null;
  		_this._manager.remove(_this);

  		completed = true;
  	};

  	// If the transition function doesn't exist, abort
  	if (!this._fn) {
  		this.complete();
  		return;
  	}

  	this._fn.apply(this.root, [this].concat(this.params));
  }

  function resetStyle(node, style) {
  	if (style) {
  		node.setAttribute("style", style);
  	} else {

  		// Next line is necessary, to remove empty style attribute!
  		// See http://stackoverflow.com/a/7167553
  		node.getAttribute("style");
  		node.removeAttribute("style");
  	}
  }

  var Transition = function (owner, template, isIntro) {
  	this.init(owner, template, isIntro);
  };

  Transition.prototype = {
  	init: Transition_prototype_init,
  	start: prototype_start,
  	getStyle: prototype_getStyle,
  	setStyle: setStyle,
  	animateStyle: _animateStyle,
  	processParams: processParams
  };

  var _Transition = Transition;

  var Element_prototype_render = Element$render;

  var updateCss, updateScript;

  updateCss = function () {
  	var node = this.node,
  	    content = this.fragment.toString(false);

  	// IE8 has no styleSheet unless there's a type text/css
  	if (window && window.appearsToBeIELessEqual8) {
  		node.type = "text/css";
  	}

  	if (node.styleSheet) {
  		node.styleSheet.cssText = content;
  	} else {

  		while (node.hasChildNodes()) {
  			node.removeChild(node.firstChild);
  		}

  		node.appendChild(document.createTextNode(content));
  	}
  };

  updateScript = function () {
  	if (!this.node.type || this.node.type === "text/javascript") {
  		warnIfDebug("Script tag was updated. This does not cause the code to be re-evaluated!", { ractive: this.root });
  		// As it happens, we ARE in a position to re-evaluate the code if we wanted
  		// to - we could eval() it, or insert it into a fresh (temporary) script tag.
  		// But this would be a terrible idea with unpredictable results, so let's not.
  	}

  	this.node.text = this.fragment.toString(false);
  };
  function Element$render() {
  	var _this = this;

  	var root = this.root,
  	    namespace,
  	    node,
  	    transition;

  	namespace = getNamespace(this);
  	node = this.node = createElement(this.name, namespace);

  	// Is this a top-level node of a component? If so, we may need to add
  	// a data-ractive-css attribute, for CSS encapsulation
  	if (this.parentFragment.cssIds) {
  		this.node.setAttribute("data-ractive-css", this.parentFragment.cssIds.map(function (x) {
  			return "{" + x + "}";
  		}).join(" "));
  	}

  	// Add _ractive property to the node - we use this object to store stuff
  	// related to proxy events, two-way bindings etc
  	defineProperty(this.node, "_ractive", {
  		value: {
  			proxy: this,
  			keypath: getInnerContext(this.parentFragment),
  			events: create(null),
  			root: root
  		}
  	});

  	// Render attributes
  	this.attributes.forEach(function (a) {
  		return a.render(node);
  	});
  	this.conditionalAttributes.forEach(function (a) {
  		return a.render(node);
  	});

  	// Render children
  	if (this.fragment) {
  		// Special case - <script> element
  		if (this.name === "script") {
  			this.bubble = updateScript;
  			this.node.text = this.fragment.toString(false); // bypass warning initially
  			this.fragment.unrender = noop; // TODO this is a kludge
  		}

  		// Special case - <style> element
  		else if (this.name === "style") {
  			this.bubble = updateCss;
  			this.bubble();
  			this.fragment.unrender = noop;
  		}

  		// Special case - contenteditable
  		else if (this.binding && this.getAttribute("contenteditable")) {
  			this.fragment.unrender = noop;
  		} else {
  			this.node.appendChild(this.fragment.render());
  		}
  	}

  	// deal with two-way bindings
  	if (this.binding) {
  		this.binding.render();
  		this.node._ractive.binding = this.binding;
  	}

  	// Add proxy event handlers
  	if (this.eventHandlers) {
  		this.eventHandlers.forEach(function (h) {
  			return h.render();
  		});
  	}

  	if (this.name === "option") {
  		processOption(this);
  	}

  	// Special cases
  	if (this.name === "img") {
  		// if this is an <img>, and we're in a crap browser, we may
  		// need to prevent it from overriding width and height when
  		// it loads the src
  		special_img__render(this);
  	} else if (this.name === "form") {
  		// forms need to keep track of their bindings, in case of reset
  		form__render(this);
  	} else if (this.name === "input" || this.name === "textarea") {
  		// inputs and textareas should store their initial value as
  		// `defaultValue` in case of reset
  		this.node.defaultValue = this.node.value;
  	} else if (this.name === "option") {
  		// similarly for option nodes
  		this.node.defaultSelected = this.node.selected;
  	}

  	// apply decorator(s)
  	if (this.decorator && this.decorator.fn) {
  		global_runloop.scheduleTask(function () {
  			if (!_this.decorator.torndown) {
  				_this.decorator.init();
  			}
  		}, true);
  	}

  	// trigger intro transition
  	if (root.transitionsEnabled && this.intro) {
  		transition = new _Transition(this, this.intro, true);
  		global_runloop.registerTransition(transition);
  		global_runloop.scheduleTask(function () {
  			return transition.start();
  		}, true);

  		this.transition = transition;
  	}

  	if (this.node.autofocus) {
  		// Special case. Some browsers (*cough* Firefix *cough*) have a problem
  		// with dynamically-generated elements having autofocus, and they won't
  		// allow you to programmatically focus the element until it's in the DOM
  		global_runloop.scheduleTask(function () {
  			return _this.node.focus();
  		}, true);
  	}

  	updateLiveQueries(this);
  	return this.node;
  }

  function getNamespace(element) {
  	var namespace, xmlns, parent;

  	// Use specified namespace...
  	if (xmlns = element.getAttribute("xmlns")) {
  		namespace = xmlns;
  	}

  	// ...or SVG namespace, if this is an <svg> element
  	else if (element.name === "svg") {
  		namespace = namespaces.svg;
  	} else if (parent = element.parent) {
  		// ...or HTML, if the parent is a <foreignObject>
  		if (parent.name === "foreignObject") {
  			namespace = namespaces.html;
  		}

  		// ...or inherit from the parent node
  		else {
  			namespace = parent.node.namespaceURI;
  		}
  	} else {
  		namespace = element.root.el.namespaceURI;
  	}

  	return namespace;
  }

  function processOption(option) {
  	var optionValue, selectValue, i;

  	if (!option.select) {
  		return;
  	}

  	selectValue = option.select.getAttribute("value");
  	if (selectValue === undefined) {
  		return;
  	}

  	optionValue = option.getAttribute("value");

  	if (option.select.node.multiple && isArray(selectValue)) {
  		i = selectValue.length;
  		while (i--) {
  			if (optionValue == selectValue[i]) {
  				option.node.selected = true;
  				break;
  			}
  		}
  	} else {
  		option.node.selected = optionValue == selectValue;
  	}
  }

  function updateLiveQueries(element) {
  	var instance, liveQueries, i, selector, query;

  	// Does this need to be added to any live queries?
  	instance = element.root;

  	do {
  		liveQueries = instance._liveQueries;

  		i = liveQueries.length;
  		while (i--) {
  			selector = liveQueries[i];
  			query = liveQueries["_" + selector];

  			if (query._test(element)) {
  				// keep register of applicable selectors, for when we teardown
  				(element.liveQueries || (element.liveQueries = [])).push(query);
  			}
  		}
  	} while (instance = instance.parent);
  }

  var Element_prototype_toString = function () {
  	var str, escape;

  	if (this.template.y) {
  		// DOCTYPE declaration
  		return "<!DOCTYPE" + this.template.dd + ">";
  	}

  	str = "<" + this.template.e;

  	str += this.attributes.map(stringifyAttribute).join("") + this.conditionalAttributes.map(stringifyAttribute).join("");

  	// Special case - selected options
  	if (this.name === "option" && optionIsSelected(this)) {
  		str += " selected";
  	}

  	// Special case - two-way radio name bindings
  	if (this.name === "input" && inputIsCheckedRadio(this)) {
  		str += " checked";
  	}

  	str += ">";

  	// Special case - textarea
  	if (this.name === "textarea" && this.getAttribute("value") !== undefined) {
  		str += escapeHtml(this.getAttribute("value"));
  	}

  	// Special case - contenteditable
  	else if (this.getAttribute("contenteditable") !== undefined) {
  		str += this.getAttribute("value") || "";
  	}

  	if (this.fragment) {
  		escape = this.name !== "script" && this.name !== "style";
  		str += this.fragment.toString(escape);
  	}

  	// add a closing tag if this isn't a void element
  	if (!voidElementNames.test(this.template.e)) {
  		str += "</" + this.template.e + ">";
  	}

  	return str;
  };

  function optionIsSelected(element) {
  	var optionValue, selectValue, i;

  	optionValue = element.getAttribute("value");

  	if (optionValue === undefined || !element.select) {
  		return false;
  	}

  	selectValue = element.select.getAttribute("value");

  	if (selectValue == optionValue) {
  		return true;
  	}

  	if (element.select.getAttribute("multiple") && isArray(selectValue)) {
  		i = selectValue.length;
  		while (i--) {
  			if (selectValue[i] == optionValue) {
  				return true;
  			}
  		}
  	}
  }

  function inputIsCheckedRadio(element) {
  	var attributes, typeAttribute, valueAttribute, nameAttribute;

  	attributes = element.attributes;

  	typeAttribute = attributes.type;
  	valueAttribute = attributes.value;
  	nameAttribute = attributes.name;

  	if (!typeAttribute || typeAttribute.value !== "radio" || !valueAttribute || !nameAttribute.interpolator) {
  		return;
  	}

  	if (valueAttribute.value === nameAttribute.interpolator.value) {
  		return true;
  	}
  }

  function stringifyAttribute(attribute) {
  	var str = attribute.toString();
  	return str ? " " + str : "";
  }

  var Element_prototype_unbind = Element$unbind;
  function Element$unbind() {
  	if (this.fragment) {
  		this.fragment.unbind();
  	}

  	if (this.binding) {
  		this.binding.unbind();
  	}

  	if (this.eventHandlers) {
  		this.eventHandlers.forEach(methodCallers__unbind);
  	}

  	// Special case - <option>
  	if (this.name === "option") {
  		special_option__unbind(this);
  	}

  	this.attributes.forEach(methodCallers__unbind);
  	this.conditionalAttributes.forEach(methodCallers__unbind);
  }

  var Element_prototype_unrender = Element$unrender;

  function Element$unrender(shouldDestroy) {
  	var binding, bindings, transition;

  	if (transition = this.transition) {
  		transition.complete();
  	}

  	// Detach as soon as we can
  	if (this.name === "option") {
  		// <option> elements detach immediately, so that
  		// their parent <select> element syncs correctly, and
  		// since option elements can't have transitions anyway
  		this.detach();
  	} else if (shouldDestroy) {
  		global_runloop.detachWhenReady(this);
  	}

  	// Children first. that way, any transitions on child elements will be
  	// handled by the current transitionManager
  	if (this.fragment) {
  		this.fragment.unrender(false);
  	}

  	if (binding = this.binding) {
  		this.binding.unrender();

  		this.node._ractive.binding = null;
  		bindings = this.root._twowayBindings[binding.keypath.str];
  		bindings.splice(bindings.indexOf(binding), 1);
  	}

  	// Remove event handlers
  	if (this.eventHandlers) {
  		this.eventHandlers.forEach(methodCallers__unrender);
  	}

  	if (this.decorator) {
  		global_runloop.registerDecorator(this.decorator);
  	}

  	// trigger outro transition if necessary
  	if (this.root.transitionsEnabled && this.outro) {
  		transition = new _Transition(this, this.outro, false);
  		global_runloop.registerTransition(transition);
  		global_runloop.scheduleTask(function () {
  			return transition.start();
  		});
  	}

  	// Remove this node from any live queries
  	if (this.liveQueries) {
  		removeFromLiveQueries(this);
  	}

  	if (this.name === "form") {
  		form__unrender(this);
  	}
  }

  function removeFromLiveQueries(element) {
  	var query, selector, i;

  	i = element.liveQueries.length;
  	while (i--) {
  		query = element.liveQueries[i];
  		selector = query.selector;

  		query._remove(element.node);
  	}
  }

  var Element = function (options) {
  	this.init(options);
  };

  Element.prototype = {
  	bubble: Element_prototype_bubble,
  	detach: Element_prototype_detach,
  	find: Element_prototype_find,
  	findAll: Element_prototype_findAll,
  	findAllComponents: Element_prototype_findAllComponents,
  	findComponent: Element_prototype_findComponent,
  	findNextNode: Element_prototype_findNextNode,
  	firstNode: Element_prototype_firstNode,
  	getAttribute: getAttribute,
  	init: Element_prototype_init,
  	rebind: Element_prototype_rebind,
  	render: Element_prototype_render,
  	toString: Element_prototype_toString,
  	unbind: Element_prototype_unbind,
  	unrender: Element_prototype_unrender
  };

  var _Element = Element;

  var deIndent__empty = /^\s*$/,
      deIndent__leadingWhitespace = /^\s*/;

  var deIndent = function (str) {
  	var lines, firstLine, lastLine, minIndent;

  	lines = str.split("\n");

  	// remove first and last line, if they only contain whitespace
  	firstLine = lines[0];
  	if (firstLine !== undefined && deIndent__empty.test(firstLine)) {
  		lines.shift();
  	}

  	lastLine = lastItem(lines);
  	if (lastLine !== undefined && deIndent__empty.test(lastLine)) {
  		lines.pop();
  	}

  	minIndent = lines.reduce(reducer, null);

  	if (minIndent) {
  		str = lines.map(function (line) {
  			return line.replace(minIndent, "");
  		}).join("\n");
  	}

  	return str;
  };

  function reducer(previous, line) {
  	var lineIndent = deIndent__leadingWhitespace.exec(line)[0];

  	if (previous === null || lineIndent.length < previous.length) {
  		return lineIndent;
  	}

  	return previous;
  }

  var Partial_getPartialTemplate = getPartialTemplate;

  function getPartialTemplate(ractive, name, parentFragment) {
  	var partial;

  	// If the partial in instance or view heirarchy instances, great
  	if (partial = getPartialFromRegistry(ractive, name, parentFragment || {})) {
  		return partial;
  	}

  	// Does it exist on the page as a script tag?
  	partial = template_parser.fromId(name, { noThrow: true });

  	if (partial) {
  		// is this necessary?
  		partial = deIndent(partial);

  		// parse and register to this ractive instance
  		var parsed = template_parser.parse(partial, template_parser.getParseOptions(ractive));

  		// register (and return main partial if there are others in the template)
  		return ractive.partials[name] = parsed.t;
  	}
  }

  function getPartialFromRegistry(ractive, name, parentFragment) {
  	var fn = undefined,
  	    partial = findParentPartial(name, parentFragment.owner);

  	// if there was an instance up-hierarchy, cool
  	if (partial) return partial;

  	// find first instance in the ractive or view hierarchy that has this partial
  	var instance = findInstance("partials", ractive, name);

  	if (!instance) {
  		return;
  	}

  	partial = instance.partials[name];

  	// partial is a function?
  	if (typeof partial === "function") {
  		fn = partial.bind(instance);
  		fn.isOwner = instance.partials.hasOwnProperty(name);
  		partial = fn.call(ractive, template_parser);
  	}

  	if (!partial && partial !== "") {
  		warnIfDebug(noRegistryFunctionReturn, name, "partial", "partial", { ractive: ractive });
  		return;
  	}

  	// If this was added manually to the registry,
  	// but hasn't been parsed, parse it now
  	if (!template_parser.isParsed(partial)) {

  		// use the parseOptions of the ractive instance on which it was found
  		var parsed = template_parser.parse(partial, template_parser.getParseOptions(instance));

  		// Partials cannot contain nested partials!
  		// TODO add a test for this
  		if (parsed.p) {
  			warnIfDebug("Partials ({{>%s}}) cannot contain nested inline partials", name, { ractive: ractive });
  		}

  		// if fn, use instance to store result, otherwise needs to go
  		// in the correct point in prototype chain on instance or constructor
  		var target = fn ? instance : findOwner(instance, name);

  		// may be a template with partials, which need to be registered and main template extracted
  		target.partials[name] = partial = parsed.t;
  	}

  	// store for reset
  	if (fn) {
  		partial._fn = fn;
  	}

  	return partial.v ? partial.t : partial;
  }

  function findOwner(ractive, key) {
  	return ractive.partials.hasOwnProperty(key) ? ractive : findConstructor(ractive.constructor, key);
  }

  function findConstructor(constructor, key) {
  	if (!constructor) {
  		return;
  	}
  	return constructor.partials.hasOwnProperty(key) ? constructor : findConstructor(constructor._Parent, key);
  }

  function findParentPartial(name, parent) {
  	if (parent) {
  		if (parent.template && parent.template.p && parent.template.p[name]) {
  			return parent.template.p[name];
  		} else if (parent.parentFragment && parent.parentFragment.owner) {
  			return findParentPartial(name, parent.parentFragment.owner);
  		}
  	}
  }

  var applyIndent = function (string, indent) {
  	var indented;

  	if (!indent) {
  		return string;
  	}

  	indented = string.split("\n").map(function (line, notFirstLine) {
  		return notFirstLine ? indent + line : line;
  	}).join("\n");

  	return indented;
  };

  var missingPartialMessage = "Could not find template for partial \"%s\"";

  var Partial = function (options) {
  	var parentFragment, template;

  	parentFragment = this.parentFragment = options.parentFragment;

  	this.root = parentFragment.root;
  	this.type = PARTIAL;
  	this.index = options.index;
  	this.name = options.template.r;
  	this.rendered = false;

  	this.fragment = this.fragmentToRender = this.fragmentToUnrender = null;

  	Mustache.init(this, options);

  	// If this didn't resolve, it most likely means we have a named partial
  	// (i.e. `{{>foo}}` means 'use the foo partial', not 'use the partial
  	// whose name is the value of `foo`')
  	if (!this.keypath) {
  		if (template = Partial_getPartialTemplate(this.root, this.name, parentFragment)) {
  			shared_unbind.call(this); // prevent any further changes
  			this.isNamed = true;
  			this.setTemplate(template);
  		} else {
  			warnOnceIfDebug(missingPartialMessage, this.name);
  		}
  	}
  };

  Partial.prototype = {
  	bubble: function () {
  		this.parentFragment.bubble();
  	},

  	detach: function () {
  		return this.fragment.detach();
  	},

  	find: function (selector) {
  		return this.fragment.find(selector);
  	},

  	findAll: function (selector, query) {
  		return this.fragment.findAll(selector, query);
  	},

  	findComponent: function (selector) {
  		return this.fragment.findComponent(selector);
  	},

  	findAllComponents: function (selector, query) {
  		return this.fragment.findAllComponents(selector, query);
  	},

  	firstNode: function () {
  		return this.fragment.firstNode();
  	},

  	findNextNode: function () {
  		return this.parentFragment.findNextNode(this);
  	},

  	getPartialName: function () {
  		if (this.isNamed && this.name) return this.name;else if (this.value === undefined) return this.name;else return this.value;
  	},

  	getValue: function () {
  		return this.fragment.getValue();
  	},

  	rebind: function (oldKeypath, newKeypath) {
  		// named partials aren't bound, so don't rebind
  		if (!this.isNamed) {
  			Mustache_rebind.call(this, oldKeypath, newKeypath);
  		}

  		if (this.fragment) {
  			this.fragment.rebind(oldKeypath, newKeypath);
  		}
  	},

  	render: function () {
  		this.docFrag = document.createDocumentFragment();
  		this.update();

  		this.rendered = true;
  		return this.docFrag;
  	},

  	resolve: Mustache.resolve,

  	setValue: function (value) {
  		var template;

  		if (value !== undefined && value === this.value) {
  			// nothing has changed, so no work to be done
  			return;
  		}

  		if (value !== undefined) {
  			template = Partial_getPartialTemplate(this.root, "" + value, this.parentFragment);
  		}

  		// we may be here if we have a partial like `{{>foo}}` and `foo` is the
  		// name of both a data property (whose value ISN'T the name of a partial)
  		// and a partial. In those cases, this becomes a named partial
  		if (!template && this.name && (template = Partial_getPartialTemplate(this.root, this.name, this.parentFragment))) {
  			shared_unbind.call(this);
  			this.isNamed = true;
  		}

  		if (!template) {
  			warnOnceIfDebug(missingPartialMessage, this.name, { ractive: this.root });
  		}

  		this.value = value;

  		this.setTemplate(template || []);

  		this.bubble();

  		if (this.rendered) {
  			global_runloop.addView(this);
  		}
  	},

  	setTemplate: function (template) {
  		if (this.fragment) {
  			this.fragment.unbind();
  			if (this.rendered) {
  				this.fragmentToUnrender = this.fragment;
  			}
  		}

  		this.fragment = new virtualdom_Fragment({
  			template: template,
  			root: this.root,
  			owner: this,
  			pElement: this.parentFragment.pElement
  		});

  		this.fragmentToRender = this.fragment;
  	},

  	toString: function (toString) {
  		var string, previousItem, lastLine, match;

  		string = this.fragment.toString(toString);

  		previousItem = this.parentFragment.items[this.index - 1];

  		if (!previousItem || previousItem.type !== TEXT) {
  			return string;
  		}

  		lastLine = previousItem.text.split("\n").pop();

  		if (match = /^\s+$/.exec(lastLine)) {
  			return applyIndent(string, match[0]);
  		}

  		return string;
  	},

  	unbind: function () {
  		if (!this.isNamed) {
  			// dynamic partial - need to unbind self
  			shared_unbind.call(this);
  		}

  		if (this.fragment) {
  			this.fragment.unbind();
  		}
  	},

  	unrender: function (shouldDestroy) {
  		if (this.rendered) {
  			if (this.fragment) {
  				this.fragment.unrender(shouldDestroy);
  			}
  			this.rendered = false;
  		}
  	},

  	update: function () {
  		var target, anchor;

  		if (this.fragmentToUnrender) {
  			this.fragmentToUnrender.unrender(true);
  			this.fragmentToUnrender = null;
  		}

  		if (this.fragmentToRender) {
  			this.docFrag.appendChild(this.fragmentToRender.render());
  			this.fragmentToRender = null;
  		}

  		if (this.rendered) {
  			target = this.parentFragment.getNode();
  			anchor = this.parentFragment.findNextNode(this);
  			target.insertBefore(this.docFrag, anchor);
  		}
  	}
  };

  var _Partial = Partial;

  // finds the component constructor in the registry or view hierarchy registries

  var Component_getComponent = getComponent;
  function getComponent(ractive, name) {

  	var Component,
  	    instance = findInstance("components", ractive, name);

  	if (instance) {
  		Component = instance.components[name];

  		// best test we have for not Ractive.extend
  		if (!Component._Parent) {
  			// function option, execute and store for reset
  			var fn = Component.bind(instance);
  			fn.isOwner = instance.components.hasOwnProperty(name);
  			Component = fn();

  			if (!Component) {
  				warnIfDebug(noRegistryFunctionReturn, name, "component", "component", { ractive: ractive });

  				return;
  			}

  			if (typeof Component === "string") {
  				// allow string lookup
  				Component = getComponent(ractive, Component);
  			}

  			Component._fn = fn;
  			instance.components[name] = Component;
  		}
  	}

  	return Component;
  }

  var Component_prototype_detach = Component$detach;
  var Component_prototype_detach__detachHook = new hooks_Hook("detach");
  function Component$detach() {
  	var detached = this.instance.fragment.detach();
  	Component_prototype_detach__detachHook.fire(this.instance);
  	return detached;
  }

  var Component_prototype_find = Component$find;

  function Component$find(selector) {
  	return this.instance.fragment.find(selector);
  }

  var Component_prototype_findAll = Component$findAll;

  function Component$findAll(selector, query) {
  	return this.instance.fragment.findAll(selector, query);
  }

  var Component_prototype_findAllComponents = Component$findAllComponents;

  function Component$findAllComponents(selector, query) {
  	query._test(this, true);

  	if (this.instance.fragment) {
  		this.instance.fragment.findAllComponents(selector, query);
  	}
  }

  var Component_prototype_findComponent = Component$findComponent;

  function Component$findComponent(selector) {
  	if (!selector || selector === this.name) {
  		return this.instance;
  	}

  	if (this.instance.fragment) {
  		return this.instance.fragment.findComponent(selector);
  	}

  	return null;
  }

  var Component_prototype_findNextNode = Component$findNextNode;

  function Component$findNextNode() {
  	return this.parentFragment.findNextNode(this);
  }

  var Component_prototype_firstNode = Component$firstNode;

  function Component$firstNode() {
  	if (this.rendered) {
  		return this.instance.fragment.firstNode();
  	}

  	return null;
  }

  var processWrapper = function (wrapper, array, methodName, newIndices) {
  	var root = wrapper.root;
  	var keypath = wrapper.keypath;

  	if (!!newIndices) {
  		root.viewmodel.smartUpdate(keypath, array, newIndices);
  	} else {
  		// If this is a sort or reverse, we just do root.set()...
  		// TODO use merge logic?
  		root.viewmodel.mark(keypath);
  	}
  };

  var patchedArrayProto = [],
      mutatorMethods = ["pop", "push", "reverse", "shift", "sort", "splice", "unshift"],
      testObj,
      patchArrayMethods,
      unpatchArrayMethods;

  mutatorMethods.forEach(function (methodName) {
  	var method = function () {
  		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
  			args[_key] = arguments[_key];
  		}

  		var newIndices, result, wrapper, i;

  		newIndices = shared_getNewIndices(this, methodName, args);

  		// apply the underlying method
  		result = Array.prototype[methodName].apply(this, arguments);

  		// trigger changes
  		global_runloop.start();

  		this._ractive.setting = true;
  		i = this._ractive.wrappers.length;
  		while (i--) {
  			wrapper = this._ractive.wrappers[i];

  			global_runloop.addRactive(wrapper.root);
  			processWrapper(wrapper, this, methodName, newIndices);
  		}

  		global_runloop.end();

  		this._ractive.setting = false;
  		return result;
  	};

  	defineProperty(patchedArrayProto, methodName, {
  		value: method
  	});
  });

  // can we use prototype chain injection?
  // http://perfectionkills.com/how-ecmascript-5-still-does-not-allow-to-subclass-an-array/#wrappers_prototype_chain_injection
  testObj = {};

  if (testObj.__proto__) {
  	// yes, we can
  	patchArrayMethods = function (array) {
  		array.__proto__ = patchedArrayProto;
  	};

  	unpatchArrayMethods = function (array) {
  		array.__proto__ = Array.prototype;
  	};
  } else {
  	// no, we can't
  	patchArrayMethods = function (array) {
  		var i, methodName;

  		i = mutatorMethods.length;
  		while (i--) {
  			methodName = mutatorMethods[i];
  			defineProperty(array, methodName, {
  				value: patchedArrayProto[methodName],
  				configurable: true
  			});
  		}
  	};

  	unpatchArrayMethods = function (array) {
  		var i;

  		i = mutatorMethods.length;
  		while (i--) {
  			delete array[mutatorMethods[i]];
  		}
  	};
  }

  patchArrayMethods.unpatch = unpatchArrayMethods;
  var patch = patchArrayMethods;

  var arrayAdaptor,

  // helpers
  ArrayWrapper, array_index__errorMessage;

  arrayAdaptor = {
  	filter: function (object) {
  		// wrap the array if a) b) it's an array, and b) either it hasn't been wrapped already,
  		// or the array didn't trigger the get() itself
  		return isArray(object) && (!object._ractive || !object._ractive.setting);
  	},
  	wrap: function (ractive, array, keypath) {
  		return new ArrayWrapper(ractive, array, keypath);
  	}
  };

  ArrayWrapper = function (ractive, array, keypath) {
  	this.root = ractive;
  	this.value = array;
  	this.keypath = getKeypath(keypath);

  	// if this array hasn't already been ractified, ractify it
  	if (!array._ractive) {

  		// define a non-enumerable _ractive property to store the wrappers
  		defineProperty(array, "_ractive", {
  			value: {
  				wrappers: [],
  				instances: [],
  				setting: false
  			},
  			configurable: true
  		});

  		patch(array);
  	}

  	// store the ractive instance, so we can handle transitions later
  	if (!array._ractive.instances[ractive._guid]) {
  		array._ractive.instances[ractive._guid] = 0;
  		array._ractive.instances.push(ractive);
  	}

  	array._ractive.instances[ractive._guid] += 1;
  	array._ractive.wrappers.push(this);
  };

  ArrayWrapper.prototype = {
  	get: function () {
  		return this.value;
  	},
  	teardown: function () {
  		var array, storage, wrappers, instances, index;

  		array = this.value;
  		storage = array._ractive;
  		wrappers = storage.wrappers;
  		instances = storage.instances;

  		// if teardown() was invoked because we're clearing the cache as a result of
  		// a change that the array itself triggered, we can save ourselves the teardown
  		// and immediate setup
  		if (storage.setting) {
  			return false; // so that we don't remove it from this.root.viewmodel.wrapped
  		}

  		index = wrappers.indexOf(this);
  		if (index === -1) {
  			throw new Error(array_index__errorMessage);
  		}

  		wrappers.splice(index, 1);

  		// if nothing else depends on this array, we can revert it to its
  		// natural state
  		if (!wrappers.length) {
  			delete array._ractive;
  			patch.unpatch(this.value);
  		} else {
  			// remove ractive instance if possible
  			instances[this.root._guid] -= 1;
  			if (!instances[this.root._guid]) {
  				index = instances.indexOf(this.root);

  				if (index === -1) {
  					throw new Error(array_index__errorMessage);
  				}

  				instances.splice(index, 1);
  			}
  		}
  	}
  };

  array_index__errorMessage = "Something went wrong in a rather interesting way";
  var array_index = arrayAdaptor;

  var numeric = /^\s*[0-9]+\s*$/;

  var createBranch = function (key) {
  	return numeric.test(key) ? [] : {};
  };

  var magicAdaptor, MagicWrapper;

  try {
  	Object.defineProperty({}, "test", { value: 0 });

  	magicAdaptor = {
  		filter: function (object, keypath, ractive) {
  			var parentWrapper, parentValue;

  			if (!keypath) {
  				return false;
  			}

  			keypath = getKeypath(keypath);

  			// If the parent value is a wrapper, other than a magic wrapper,
  			// we shouldn't wrap this property
  			if ((parentWrapper = ractive.viewmodel.wrapped[keypath.parent.str]) && !parentWrapper.magic) {
  				return false;
  			}

  			parentValue = ractive.viewmodel.get(keypath.parent);

  			// if parentValue is an array that doesn't include this member,
  			// we should return false otherwise lengths will get messed up
  			if (isArray(parentValue) && /^[0-9]+$/.test(keypath.lastKey)) {
  				return false;
  			}

  			return parentValue && (typeof parentValue === "object" || typeof parentValue === "function");
  		},
  		wrap: function (ractive, property, keypath) {
  			return new MagicWrapper(ractive, property, keypath);
  		}
  	};

  	MagicWrapper = function (ractive, value, keypath) {
  		var objKeypath, template, siblings;

  		keypath = getKeypath(keypath);

  		this.magic = true;

  		this.ractive = ractive;
  		this.keypath = keypath;
  		this.value = value;

  		this.prop = keypath.lastKey;

  		objKeypath = keypath.parent;
  		this.obj = objKeypath.isRoot ? ractive.viewmodel.data : ractive.viewmodel.get(objKeypath);

  		template = this.originalDescriptor = Object.getOwnPropertyDescriptor(this.obj, this.prop);

  		// Has this property already been wrapped?
  		if (template && template.set && (siblings = template.set._ractiveWrappers)) {

  			// Yes. Register this wrapper to this property, if it hasn't been already
  			if (siblings.indexOf(this) === -1) {
  				siblings.push(this);
  			}

  			return; // already wrapped
  		}

  		// No, it hasn't been wrapped
  		createAccessors(this, value, template);
  	};

  	MagicWrapper.prototype = {
  		get: function () {
  			return this.value;
  		},
  		reset: function (value) {
  			if (this.updating) {
  				return;
  			}

  			this.updating = true;
  			this.obj[this.prop] = value; // trigger set() accessor
  			global_runloop.addRactive(this.ractive);
  			this.ractive.viewmodel.mark(this.keypath, { keepExistingWrapper: true });
  			this.updating = false;
  			return true;
  		},
  		set: function (key, value) {
  			if (this.updating) {
  				return;
  			}

  			if (!this.obj[this.prop]) {
  				this.updating = true;
  				this.obj[this.prop] = createBranch(key);
  				this.updating = false;
  			}

  			this.obj[this.prop][key] = value;
  		},
  		teardown: function () {
  			var template, set, value, wrappers, index;

  			// If this method was called because the cache was being cleared as a
  			// result of a set()/update() call made by this wrapper, we return false
  			// so that it doesn't get torn down
  			if (this.updating) {
  				return false;
  			}

  			template = Object.getOwnPropertyDescriptor(this.obj, this.prop);
  			set = template && template.set;

  			if (!set) {
  				// most likely, this was an array member that was spliced out
  				return;
  			}

  			wrappers = set._ractiveWrappers;

  			index = wrappers.indexOf(this);
  			if (index !== -1) {
  				wrappers.splice(index, 1);
  			}

  			// Last one out, turn off the lights
  			if (!wrappers.length) {
  				value = this.obj[this.prop];

  				Object.defineProperty(this.obj, this.prop, this.originalDescriptor || {
  					writable: true,
  					enumerable: true,
  					configurable: true
  				});

  				this.obj[this.prop] = value;
  			}
  		}
  	};
  } catch (err) {
  	magicAdaptor = false; // no magic in this browser
  }

  var adaptors_magic = magicAdaptor;

  function createAccessors(originalWrapper, value, template) {

  	var object, property, oldGet, oldSet, get, set;

  	object = originalWrapper.obj;
  	property = originalWrapper.prop;

  	// Is this template configurable?
  	if (template && !template.configurable) {
  		// Special case - array length
  		if (property === "length") {
  			return;
  		}

  		throw new Error("Cannot use magic mode with property \"" + property + "\" - object is not configurable");
  	}

  	// Time to wrap this property
  	if (template) {
  		oldGet = template.get;
  		oldSet = template.set;
  	}

  	get = oldGet || function () {
  		return value;
  	};

  	set = function (v) {
  		if (oldSet) {
  			oldSet(v);
  		}

  		value = oldGet ? oldGet() : v;
  		set._ractiveWrappers.forEach(updateWrapper);
  	};

  	function updateWrapper(wrapper) {
  		var keypath, ractive;

  		wrapper.value = value;

  		if (wrapper.updating) {
  			return;
  		}

  		ractive = wrapper.ractive;
  		keypath = wrapper.keypath;

  		wrapper.updating = true;
  		global_runloop.start(ractive);

  		ractive.viewmodel.mark(keypath);

  		global_runloop.end();
  		wrapper.updating = false;
  	}

  	// Create an array of wrappers, in case other keypaths/ractives depend on this property.
  	// Handily, we can store them as a property of the set function. Yay JavaScript.
  	set._ractiveWrappers = [originalWrapper];
  	Object.defineProperty(object, property, { get: get, set: set, enumerable: true, configurable: true });
  }

  var magicArrayAdaptor, MagicArrayWrapper;

  if (adaptors_magic) {
  	magicArrayAdaptor = {
  		filter: function (object, keypath, ractive) {
  			return adaptors_magic.filter(object, keypath, ractive) && array_index.filter(object);
  		},

  		wrap: function (ractive, array, keypath) {
  			return new MagicArrayWrapper(ractive, array, keypath);
  		}
  	};

  	MagicArrayWrapper = function (ractive, array, keypath) {
  		this.value = array;

  		this.magic = true;

  		this.magicWrapper = adaptors_magic.wrap(ractive, array, keypath);
  		this.arrayWrapper = array_index.wrap(ractive, array, keypath);
  	};

  	MagicArrayWrapper.prototype = {
  		get: function () {
  			return this.value;
  		},
  		teardown: function () {
  			this.arrayWrapper.teardown();
  			this.magicWrapper.teardown();
  		},
  		reset: function (value) {
  			return this.magicWrapper.reset(value);
  		}
  	};
  }

  var magicArray = magicArrayAdaptor;

  var prototype_adapt = Viewmodel$adapt;

  var prefixers = {};
  function Viewmodel$adapt(keypath, value) {
  	var len, i, adaptor, wrapped;

  	if (!this.adaptors) return;

  	// Do we have an adaptor for this value?
  	len = this.adaptors.length;
  	for (i = 0; i < len; i += 1) {
  		adaptor = this.adaptors[i];

  		if (adaptor.filter(value, keypath, this.ractive)) {
  			wrapped = this.wrapped[keypath] = adaptor.wrap(this.ractive, value, keypath, getPrefixer(keypath));
  			wrapped.value = value;
  			return;
  		}
  	}
  }

  function prefixKeypath(obj, prefix) {
  	var prefixed = {},
  	    key;

  	if (!prefix) {
  		return obj;
  	}

  	prefix += ".";

  	for (key in obj) {
  		if (obj.hasOwnProperty(key)) {
  			prefixed[prefix + key] = obj[key];
  		}
  	}

  	return prefixed;
  }

  function getPrefixer(rootKeypath) {
  	var rootDot;

  	if (!prefixers[rootKeypath]) {
  		rootDot = rootKeypath ? rootKeypath + "." : "";

  		prefixers[rootKeypath] = function (relativeKeypath, value) {
  			var obj;

  			if (typeof relativeKeypath === "string") {
  				obj = {};
  				obj[rootDot + relativeKeypath] = value;
  				return obj;
  			}

  			if (typeof relativeKeypath === "object") {
  				// 'relativeKeypath' is in fact a hash, not a keypath
  				return rootDot ? prefixKeypath(relativeKeypath, rootKeypath) : relativeKeypath;
  			}
  		};
  	}

  	return prefixers[rootKeypath];
  }

  // TEMP

  var helpers_getUpstreamChanges = getUpstreamChanges;
  function getUpstreamChanges(changes) {
  	var upstreamChanges = [rootKeypath],
  	    i,
  	    keypath;

  	i = changes.length;
  	while (i--) {
  		keypath = changes[i].parent;

  		while (keypath && !keypath.isRoot) {
  			if (changes.indexOf(keypath) === -1) {
  				addToArray(upstreamChanges, keypath);
  			}
  			keypath = keypath.parent;
  		}
  	}

  	return upstreamChanges;
  }

  var applyChanges_notifyPatternObservers = notifyPatternObservers;

  function notifyPatternObservers(viewmodel, keypath, onlyDirect) {
  	var potentialWildcardMatches;

  	updateMatchingPatternObservers(viewmodel, keypath);

  	if (onlyDirect) {
  		return;
  	}

  	potentialWildcardMatches = keypath.wildcardMatches();
  	potentialWildcardMatches.forEach(function (upstreamPattern) {
  		cascade(viewmodel, upstreamPattern, keypath);
  	});
  }

  function cascade(viewmodel, upstreamPattern, keypath) {
  	var group, map, actualChildKeypath;

  	// TODO should be one or the other
  	upstreamPattern = upstreamPattern.str || upstreamPattern;

  	group = viewmodel.depsMap.patternObservers;
  	map = group && group[upstreamPattern];

  	if (!map) {
  		return;
  	}

  	map.forEach(function (childKeypath) {
  		actualChildKeypath = keypath.join(childKeypath.lastKey); // 'foo.bar.baz'

  		updateMatchingPatternObservers(viewmodel, actualChildKeypath);
  		cascade(viewmodel, childKeypath, actualChildKeypath);
  	});
  }

  function updateMatchingPatternObservers(viewmodel, keypath) {
  	viewmodel.patternObservers.forEach(function (observer) {
  		if (observer.regex.test(keypath.str)) {
  			observer.update(keypath);
  		}
  	});
  }

  var applyChanges = Viewmodel$applyChanges;

  function Viewmodel$applyChanges() {
  	var _this = this;

  	var self = this,
  	    changes,
  	    upstreamChanges,
  	    hash = {},
  	    bindings;

  	changes = this.changes;

  	if (!changes.length) {
  		// TODO we end up here on initial render. Perhaps we shouldn't?
  		return;
  	}

  	function invalidateComputation(computation) {
  		var key = computation.key;

  		if (computation.viewmodel === self) {
  			self.clearCache(key.str);
  			computation.invalidate();

  			changes.push(key);
  			cascade(key);
  		} else {
  			computation.viewmodel.mark(key);
  		}
  	}

  	function cascade(keypath) {
  		var map, computations;

  		if (self.noCascade.hasOwnProperty(keypath.str)) {
  			return;
  		}

  		if (computations = self.deps.computed[keypath.str]) {
  			computations.forEach(invalidateComputation);
  		}

  		if (map = self.depsMap.computed[keypath.str]) {
  			map.forEach(cascade);
  		}
  	}

  	changes.slice().forEach(cascade);

  	upstreamChanges = helpers_getUpstreamChanges(changes);
  	upstreamChanges.forEach(function (keypath) {
  		var computations;

  		// make sure we haven't already been down this particular keypath in this turn
  		if (changes.indexOf(keypath) === -1 && (computations = self.deps.computed[keypath.str])) {
  			computations.forEach(invalidateComputation);
  		}
  	});

  	this.changes = [];

  	// Pattern observers are a weird special case
  	if (this.patternObservers.length) {
  		upstreamChanges.forEach(function (keypath) {
  			return applyChanges_notifyPatternObservers(_this, keypath, true);
  		});
  		changes.forEach(function (keypath) {
  			return applyChanges_notifyPatternObservers(_this, keypath);
  		});
  	}

  	if (this.deps.observers) {
  		upstreamChanges.forEach(function (keypath) {
  			return notifyUpstreamDependants(_this, null, keypath, "observers");
  		});
  		notifyAllDependants(this, changes, "observers");
  	}

  	if (this.deps["default"]) {
  		bindings = [];
  		upstreamChanges.forEach(function (keypath) {
  			return notifyUpstreamDependants(_this, bindings, keypath, "default");
  		});

  		if (bindings.length) {
  			notifyBindings(this, bindings, changes);
  		}

  		notifyAllDependants(this, changes, "default");
  	}

  	// Return a hash of keypaths to updated values
  	changes.forEach(function (keypath) {
  		hash[keypath.str] = _this.get(keypath);
  	});

  	this.implicitChanges = {};
  	this.noCascade = {};

  	return hash;
  }

  function notifyUpstreamDependants(viewmodel, bindings, keypath, groupName) {
  	var dependants, value;

  	if (dependants = findDependants(viewmodel, keypath, groupName)) {
  		value = viewmodel.get(keypath);

  		dependants.forEach(function (d) {
  			// don't "set" the parent value, refine it
  			// i.e. not data = value, but data[foo] = fooValue
  			if (bindings && d.refineValue) {
  				bindings.push(d);
  			} else {
  				d.setValue(value);
  			}
  		});
  	}
  }

  function notifyBindings(viewmodel, bindings, changes) {

  	bindings.forEach(function (binding) {
  		var useSet = false,
  		    i = 0,
  		    length = changes.length,
  		    refinements = [];

  		while (i < length) {
  			var keypath = changes[i];

  			if (keypath === binding.keypath) {
  				useSet = true;
  				break;
  			}

  			if (keypath.slice(0, binding.keypath.length) === binding.keypath) {
  				refinements.push(keypath);
  			}

  			i++;
  		}

  		if (useSet) {
  			binding.setValue(viewmodel.get(binding.keypath));
  		}

  		if (refinements.length) {
  			binding.refineValue(refinements);
  		}
  	});
  }

  function notifyAllDependants(viewmodel, keypaths, groupName) {
  	var queue = [];

  	addKeypaths(keypaths);
  	queue.forEach(dispatch);

  	function addKeypaths(keypaths) {
  		keypaths.forEach(addKeypath);
  		keypaths.forEach(cascade);
  	}

  	function addKeypath(keypath) {
  		var deps = findDependants(viewmodel, keypath, groupName);

  		if (deps) {
  			queue.push({
  				keypath: keypath,
  				deps: deps
  			});
  		}
  	}

  	function cascade(keypath) {
  		var childDeps;

  		if (childDeps = viewmodel.depsMap[groupName][keypath.str]) {
  			addKeypaths(childDeps);
  		}
  	}

  	function dispatch(set) {
  		var value = viewmodel.get(set.keypath);
  		set.deps.forEach(function (d) {
  			return d.setValue(value);
  		});
  	}
  }

  function findDependants(viewmodel, keypath, groupName) {
  	var group = viewmodel.deps[groupName];
  	return group ? group[keypath.str] : null;
  }

  var capture = Viewmodel$capture;

  function Viewmodel$capture() {
  	this.captureGroups.push([]);
  }

  var clearCache = Viewmodel$clearCache;

  function Viewmodel$clearCache(keypath, keepExistingWrapper) {
  	var cacheMap, wrapper;

  	if (!keepExistingWrapper) {
  		// Is there a wrapped property at this keypath?
  		if (wrapper = this.wrapped[keypath]) {
  			// Did we unwrap it?
  			if (wrapper.teardown() !== false) {
  				// Is this right?
  				// What's the meaning of returning false from teardown?
  				// Could there be a GC ramification if this is a "real" ractive.teardown()?
  				this.wrapped[keypath] = null;
  			}
  		}
  	}

  	this.cache[keypath] = undefined;

  	if (cacheMap = this.cacheMap[keypath]) {
  		while (cacheMap.length) {
  			this.clearCache(cacheMap.pop());
  		}
  	}
  }

  var UnresolvedDependency = function (computation, ref) {
  	this.computation = computation;
  	this.viewmodel = computation.viewmodel;
  	this.ref = ref;

  	// TODO this seems like a red flag!
  	this.root = this.viewmodel.ractive;
  	this.parentFragment = this.root.component && this.root.component.parentFragment;
  };

  UnresolvedDependency.prototype = {
  	resolve: function (keypath) {
  		this.computation.softDeps.push(keypath);
  		this.computation.unresolvedDeps[keypath.str] = null;
  		this.viewmodel.register(keypath, this.computation, "computed");
  	}
  };

  var Computation_UnresolvedDependency = UnresolvedDependency;

  var Computation = function (key, signature) {
  	this.key = key;

  	this.getter = signature.getter;
  	this.setter = signature.setter;

  	this.hardDeps = signature.deps || [];
  	this.softDeps = [];
  	this.unresolvedDeps = {};

  	this.depValues = {};

  	this._dirty = this._firstRun = true;
  };

  Computation.prototype = {
  	constructor: Computation,

  	init: function (viewmodel) {
  		var _this = this;

  		var initial;

  		this.viewmodel = viewmodel;
  		this.bypass = true;

  		initial = viewmodel.get(this.key);
  		viewmodel.clearCache(this.key.str);

  		this.bypass = false;

  		if (this.setter && initial !== undefined) {
  			this.set(initial);
  		}

  		if (this.hardDeps) {
  			this.hardDeps.forEach(function (d) {
  				return viewmodel.register(d, _this, "computed");
  			});
  		}
  	},

  	invalidate: function () {
  		this._dirty = true;
  	},

  	get: function () {
  		var _this = this;

  		var newDeps,
  		    dependenciesChanged,
  		    dependencyValuesChanged = false;

  		if (this.getting) {
  			// prevent double-computation (e.g. caused by array mutation inside computation)
  			var msg = "The " + this.key.str + " computation indirectly called itself. This probably indicates a bug in the computation. It is commonly caused by `array.sort(...)` - if that's the case, clone the array first with `array.slice().sort(...)`";
  			warnOnce(msg);
  			return this.value;
  		}

  		this.getting = true;

  		if (this._dirty) {
  			// determine whether the inputs have changed, in case this depends on
  			// other computed values
  			if (this._firstRun || !this.hardDeps.length && !this.softDeps.length) {
  				dependencyValuesChanged = true;
  			} else {
  				[this.hardDeps, this.softDeps].forEach(function (deps) {
  					var keypath, value, i;

  					if (dependencyValuesChanged) {
  						return;
  					}

  					i = deps.length;
  					while (i--) {
  						keypath = deps[i];
  						value = _this.viewmodel.get(keypath);

  						if (!isEqual(value, _this.depValues[keypath.str])) {
  							_this.depValues[keypath.str] = value;
  							dependencyValuesChanged = true;

  							return;
  						}
  					}
  				});
  			}

  			if (dependencyValuesChanged) {
  				this.viewmodel.capture();

  				try {
  					this.value = this.getter();
  				} catch (err) {
  					warnIfDebug("Failed to compute \"%s\"", this.key.str);
  					logIfDebug(err.stack || err);

  					this.value = void 0;
  				}

  				newDeps = this.viewmodel.release();
  				dependenciesChanged = this.updateDependencies(newDeps);

  				if (dependenciesChanged) {
  					[this.hardDeps, this.softDeps].forEach(function (deps) {
  						deps.forEach(function (keypath) {
  							_this.depValues[keypath.str] = _this.viewmodel.get(keypath);
  						});
  					});
  				}
  			}

  			this._dirty = false;
  		}

  		this.getting = this._firstRun = false;
  		return this.value;
  	},

  	set: function (value) {
  		if (this.setting) {
  			this.value = value;
  			return;
  		}

  		if (!this.setter) {
  			throw new Error("Computed properties without setters are read-only. (This may change in a future version of Ractive!)");
  		}

  		this.setter(value);
  	},

  	updateDependencies: function (newDeps) {
  		var i, oldDeps, keypath, dependenciesChanged, unresolved;

  		oldDeps = this.softDeps;

  		// remove dependencies that are no longer used
  		i = oldDeps.length;
  		while (i--) {
  			keypath = oldDeps[i];

  			if (newDeps.indexOf(keypath) === -1) {
  				dependenciesChanged = true;
  				this.viewmodel.unregister(keypath, this, "computed");
  			}
  		}

  		// create references for any new dependencies
  		i = newDeps.length;
  		while (i--) {
  			keypath = newDeps[i];

  			if (oldDeps.indexOf(keypath) === -1 && (!this.hardDeps || this.hardDeps.indexOf(keypath) === -1)) {
  				dependenciesChanged = true;

  				// if this keypath is currently unresolved, we need to mark
  				// it as such. TODO this is a bit muddy...
  				if (isUnresolved(this.viewmodel, keypath) && !this.unresolvedDeps[keypath.str]) {
  					unresolved = new Computation_UnresolvedDependency(this, keypath.str);
  					newDeps.splice(i, 1);

  					this.unresolvedDeps[keypath.str] = unresolved;
  					global_runloop.addUnresolved(unresolved);
  				} else {
  					this.viewmodel.register(keypath, this, "computed");
  				}
  			}
  		}

  		if (dependenciesChanged) {
  			this.softDeps = newDeps.slice();
  		}

  		return dependenciesChanged;
  	}
  };

  function isUnresolved(viewmodel, keypath) {
  	var key = keypath.firstKey;

  	return !(key in viewmodel.data) && !(key in viewmodel.computations) && !(key in viewmodel.mappings);
  }

  var Computation_Computation = Computation;

  var compute = Viewmodel$compute;
  function Viewmodel$compute(key, signature) {
  	var computation = new Computation_Computation(key, signature);

  	if (this.ready) {
  		computation.init(this);
  	}

  	return this.computations[key.str] = computation;
  }

  var FAILED_LOOKUP = { FAILED_LOOKUP: true };

  var viewmodel_prototype_get = Viewmodel$get;

  var viewmodel_prototype_get__empty = {};
  function Viewmodel$get(keypath, options) {
  	var cache = this.cache,
  	    value,
  	    computation,
  	    wrapped,
  	    captureGroup,
  	    keypathStr = keypath.str,
  	    key;

  	options = options || viewmodel_prototype_get__empty;

  	// capture the keypath, if we're inside a computation
  	if (options.capture && (captureGroup = lastItem(this.captureGroups))) {
  		if (! ~captureGroup.indexOf(keypath)) {
  			captureGroup.push(keypath);
  		}
  	}

  	if (hasOwn.call(this.mappings, keypath.firstKey)) {
  		return this.mappings[keypath.firstKey].get(keypath, options);
  	}

  	if (keypath.isSpecial) {
  		return keypath.value;
  	}

  	if (cache[keypathStr] === undefined) {

  		// Is this a computed property?
  		if ((computation = this.computations[keypathStr]) && !computation.bypass) {
  			value = computation.get();
  			this.adapt(keypathStr, value);
  		}

  		// Is this a wrapped property?
  		else if (wrapped = this.wrapped[keypathStr]) {
  			value = wrapped.value;
  		}

  		// Is it the root?
  		else if (keypath.isRoot) {
  			this.adapt("", this.data);
  			value = this.data;
  		}

  		// No? Then we need to retrieve the value one key at a time
  		else {
  			value = retrieve(this, keypath);
  		}

  		cache[keypathStr] = value;
  	} else {
  		value = cache[keypathStr];
  	}

  	if (!options.noUnwrap && (wrapped = this.wrapped[keypathStr])) {
  		value = wrapped.get();
  	}

  	if (keypath.isRoot && options.fullRootGet) {
  		for (key in this.mappings) {
  			value[key] = this.mappings[key].getValue();
  		}
  	}

  	return value === FAILED_LOOKUP ? void 0 : value;
  }

  function retrieve(viewmodel, keypath) {

  	var parentValue, cacheMap, value, wrapped;

  	parentValue = viewmodel.get(keypath.parent);

  	if (wrapped = viewmodel.wrapped[keypath.parent.str]) {
  		parentValue = wrapped.get();
  	}

  	if (parentValue === null || parentValue === undefined) {
  		return;
  	}

  	// update cache map
  	if (!(cacheMap = viewmodel.cacheMap[keypath.parent.str])) {
  		viewmodel.cacheMap[keypath.parent.str] = [keypath.str];
  	} else {
  		if (cacheMap.indexOf(keypath.str) === -1) {
  			cacheMap.push(keypath.str);
  		}
  	}

  	// If this property doesn't exist, we return a sentinel value
  	// so that we know to query parent scope (if such there be)
  	if (typeof parentValue === "object" && !(keypath.lastKey in parentValue)) {
  		return viewmodel.cache[keypath.str] = FAILED_LOOKUP;
  	}

  	value = parentValue[keypath.lastKey];

  	// Do we have an adaptor for this value?
  	viewmodel.adapt(keypath.str, value, false);

  	// Update cache
  	viewmodel.cache[keypath.str] = value;
  	return value;
  }

  var viewmodel_prototype_init = Viewmodel$init;

  function Viewmodel$init() {
  	var key;

  	for (key in this.computations) {
  		this.computations[key].init(this);
  	}
  }

  var prototype_map = Viewmodel$map;

  function Viewmodel$map(key, options) {
  	var mapping = this.mappings[key.str] = new Mapping(key, options);
  	mapping.initViewmodel(this);
  	return mapping;
  }

  var Mapping = function (localKey, options) {
  	this.localKey = localKey;
  	this.keypath = options.keypath;
  	this.origin = options.origin;

  	this.deps = [];
  	this.unresolved = [];

  	this.resolved = false;
  };

  Mapping.prototype = {
  	forceResolution: function () {
  		// TODO warn, as per #1692?
  		this.keypath = this.localKey;
  		this.setup();
  	},

  	get: function (keypath, options) {
  		if (!this.resolved) {
  			return undefined;
  		}
  		return this.origin.get(this.map(keypath), options);
  	},

  	getValue: function () {
  		if (!this.keypath) {
  			return undefined;
  		}
  		return this.origin.get(this.keypath);
  	},

  	initViewmodel: function (viewmodel) {
  		this.local = viewmodel;
  		this.setup();
  	},

  	map: function (keypath) {
  		if (typeof this.keypath === undefined) {
  			return this.localKey;
  		}
  		return keypath.replace(this.localKey, this.keypath);
  	},

  	register: function (keypath, dependant, group) {
  		this.deps.push({ keypath: keypath, dep: dependant, group: group });

  		if (this.resolved) {
  			this.origin.register(this.map(keypath), dependant, group);
  		}
  	},

  	resolve: function (keypath) {
  		if (this.keypath !== undefined) {
  			this.unbind(true);
  		}

  		this.keypath = keypath;
  		this.setup();
  	},

  	set: function (keypath, value) {
  		if (!this.resolved) {
  			this.forceResolution();
  		}

  		this.origin.set(this.map(keypath), value);
  	},

  	setup: function () {
  		var _this = this;

  		if (this.keypath === undefined) {
  			return;
  		}

  		this.resolved = true;

  		// accumulated dependants can now be registered
  		if (this.deps.length) {
  			this.deps.forEach(function (d) {
  				var keypath = _this.map(d.keypath);
  				_this.origin.register(keypath, d.dep, d.group);

  				// TODO this is a bit of a red flag... all deps should be the same?
  				if (d.dep.setValue) {
  					d.dep.setValue(_this.origin.get(keypath));
  				} else if (d.dep.invalidate) {
  					d.dep.invalidate();
  				} else {
  					throw new Error("An unexpected error occurred. Please raise an issue at https://github.com/ractivejs/ractive/issues - thanks!");
  				}
  			});

  			this.origin.mark(this.keypath);
  		}
  	},

  	setValue: function (value) {
  		if (!this.keypath) {
  			throw new Error("Mapping does not have keypath, cannot set value. Please raise an issue at https://github.com/ractivejs/ractive/issues - thanks!");
  		}

  		this.origin.set(this.keypath, value);
  	},

  	unbind: function (keepLocal) {
  		var _this = this;

  		if (!keepLocal) {
  			delete this.local.mappings[this.localKey];
  		}

  		if (!this.resolved) {
  			return;
  		}

  		this.deps.forEach(function (d) {
  			_this.origin.unregister(_this.map(d.keypath), d.dep, d.group);
  		});

  		if (this.tracker) {
  			this.origin.unregister(this.keypath, this.tracker);
  		}
  	},

  	unregister: function (keypath, dependant, group) {
  		var deps, i;

  		if (!this.resolved) {
  			return;
  		}

  		deps = this.deps;
  		i = deps.length;

  		while (i--) {
  			if (deps[i].dep === dependant) {
  				deps.splice(i, 1);
  				break;
  			}
  		}
  		this.origin.unregister(this.map(keypath), dependant, group);
  	}
  };

  var mark = Viewmodel$mark;

  function Viewmodel$mark(keypath, options) {
  	var computation,
  	    keypathStr = keypath.str;

  	// implicit changes (i.e. `foo.length` on `ractive.push('foo',42)`)
  	// should not be picked up by pattern observers
  	if (options) {
  		if (options.implicit) {
  			this.implicitChanges[keypathStr] = true;
  		}
  		if (options.noCascade) {
  			this.noCascade[keypathStr] = true;
  		}
  	}

  	if (computation = this.computations[keypathStr]) {
  		computation.invalidate();
  	}

  	if (this.changes.indexOf(keypath) === -1) {
  		this.changes.push(keypath);
  	}

  	// pass on keepExistingWrapper, if we can
  	var keepExistingWrapper = options ? options.keepExistingWrapper : false;

  	this.clearCache(keypathStr, keepExistingWrapper);

  	if (this.ready) {
  		this.onchange();
  	}
  }

  var mapOldToNewIndex = function (oldArray, newArray) {
  	var usedIndices, firstUnusedIndex, newIndices, changed;

  	usedIndices = {};
  	firstUnusedIndex = 0;

  	newIndices = oldArray.map(function (item, i) {
  		var index, start, len;

  		start = firstUnusedIndex;
  		len = newArray.length;

  		do {
  			index = newArray.indexOf(item, start);

  			if (index === -1) {
  				changed = true;
  				return -1;
  			}

  			start = index + 1;
  		} while (usedIndices[index] && start < len);

  		// keep track of the first unused index, so we don't search
  		// the whole of newArray for each item in oldArray unnecessarily
  		if (index === firstUnusedIndex) {
  			firstUnusedIndex += 1;
  		}

  		if (index !== i) {
  			changed = true;
  		}

  		usedIndices[index] = true;
  		return index;
  	});

  	return newIndices;
  };

  var merge = Viewmodel$merge;

  var comparators = {};
  function Viewmodel$merge(keypath, currentArray, array, options) {
  	var oldArray, newArray, comparator, newIndices;

  	this.mark(keypath);

  	if (options && options.compare) {

  		comparator = getComparatorFunction(options.compare);

  		try {
  			oldArray = currentArray.map(comparator);
  			newArray = array.map(comparator);
  		} catch (err) {
  			// fallback to an identity check - worst case scenario we have
  			// to do more DOM manipulation than we thought...
  			warnIfDebug("merge(): \"%s\" comparison failed. Falling back to identity checking", keypath);

  			oldArray = currentArray;
  			newArray = array;
  		}
  	} else {
  		oldArray = currentArray;
  		newArray = array;
  	}

  	// find new indices for members of oldArray
  	newIndices = mapOldToNewIndex(oldArray, newArray);

  	this.smartUpdate(keypath, array, newIndices, currentArray.length !== array.length);
  }

  function stringify(item) {
  	return JSON.stringify(item);
  }

  function getComparatorFunction(comparator) {
  	// If `compare` is `true`, we use JSON.stringify to compare
  	// objects that are the same shape, but non-identical - i.e.
  	// { foo: 'bar' } !== { foo: 'bar' }
  	if (comparator === true) {
  		return stringify;
  	}

  	if (typeof comparator === "string") {
  		if (!comparators[comparator]) {
  			comparators[comparator] = function (item) {
  				return item[comparator];
  			};
  		}

  		return comparators[comparator];
  	}

  	if (typeof comparator === "function") {
  		return comparator;
  	}

  	throw new Error("The `compare` option must be a function, or a string representing an identifying field (or `true` to use JSON.stringify)");
  }

  var register = Viewmodel$register;

  function Viewmodel$register(keypath, dependant) {
  	var group = arguments[2] === undefined ? "default" : arguments[2];

  	var mapping, depsByKeypath, deps;

  	if (dependant.isStatic) {
  		return; // TODO we should never get here if a dependant is static...
  	}

  	if (mapping = this.mappings[keypath.firstKey]) {
  		mapping.register(keypath, dependant, group);
  	} else {
  		depsByKeypath = this.deps[group] || (this.deps[group] = {});
  		deps = depsByKeypath[keypath.str] || (depsByKeypath[keypath.str] = []);

  		deps.push(dependant);

  		if (!this.depsMap[group]) {
  			this.depsMap[group] = {};
  		}

  		if (!keypath.isRoot) {
  			register__updateDependantsMap(this, keypath, group);
  		}
  	}
  }

  function register__updateDependantsMap(viewmodel, keypath, group) {
  	var map, parent, keypathStr;

  	// update dependants map
  	while (!keypath.isRoot) {
  		map = viewmodel.depsMap[group];
  		parent = map[keypath.parent.str] || (map[keypath.parent.str] = []);

  		keypathStr = keypath.str;

  		// TODO find an alternative to this nasty approach
  		if (parent["_" + keypathStr] === undefined) {
  			parent["_" + keypathStr] = 0;
  			parent.push(keypath);
  		}

  		parent["_" + keypathStr] += 1;
  		keypath = keypath.parent;
  	}
  }

  var release = Viewmodel$release;

  function Viewmodel$release() {
  	return this.captureGroups.pop();
  }

  var reset = Viewmodel$reset;

  function Viewmodel$reset(data) {
  	this.data = data;
  	this.clearCache("");
  }

  var prototype_set = Viewmodel$set;

  function Viewmodel$set(keypath, value) {
  	var options = arguments[2] === undefined ? {} : arguments[2];

  	var mapping, computation, wrapper, keepExistingWrapper;

  	// unless data is being set for data tracking purposes
  	if (!options.noMapping) {
  		// If this data belongs to a different viewmodel,
  		// pass the change along
  		if (mapping = this.mappings[keypath.firstKey]) {
  			return mapping.set(keypath, value);
  		}
  	}

  	computation = this.computations[keypath.str];
  	if (computation) {
  		if (computation.setting) {
  			// let the other computation set() handle things...
  			return;
  		}
  		computation.set(value);
  		value = computation.get();
  	}

  	if (isEqual(this.cache[keypath.str], value)) {
  		return;
  	}

  	wrapper = this.wrapped[keypath.str];

  	// If we have a wrapper with a `reset()` method, we try and use it. If the
  	// `reset()` method returns false, the wrapper should be torn down, and
  	// (most likely) a new one should be created later
  	if (wrapper && wrapper.reset) {
  		keepExistingWrapper = wrapper.reset(value) !== false;

  		if (keepExistingWrapper) {
  			value = wrapper.get();
  		}
  	}

  	if (!computation && !keepExistingWrapper) {
  		resolveSet(this, keypath, value);
  	}

  	if (!options.silent) {
  		this.mark(keypath);
  	} else {
  		// We're setting a parent of the original target keypath (i.e.
  		// creating a fresh branch) - we need to clear the cache, but
  		// not mark it as a change
  		this.clearCache(keypath.str);
  	}
  }

  function resolveSet(viewmodel, keypath, value) {
  	var wrapper, parentValue, wrapperSet, valueSet;

  	wrapperSet = function () {
  		if (wrapper.set) {
  			wrapper.set(keypath.lastKey, value);
  		} else {
  			parentValue = wrapper.get();
  			valueSet();
  		}
  	};

  	valueSet = function () {
  		if (!parentValue) {
  			parentValue = createBranch(keypath.lastKey);
  			viewmodel.set(keypath.parent, parentValue, { silent: true });
  		}
  		parentValue[keypath.lastKey] = value;
  	};

  	wrapper = viewmodel.wrapped[keypath.parent.str];

  	if (wrapper) {
  		wrapperSet();
  	} else {
  		parentValue = viewmodel.get(keypath.parent);

  		// may have been wrapped via the above .get()
  		// call on viewmodel if this is first access via .set()!
  		if (wrapper = viewmodel.wrapped[keypath.parent.str]) {
  			wrapperSet();
  		} else {
  			valueSet();
  		}
  	}
  }

  var smartUpdate = Viewmodel$smartUpdate;

  var implicitOption = { implicit: true },
      noCascadeOption = { noCascade: true };
  function Viewmodel$smartUpdate(keypath, array, newIndices) {
  	var _this = this;

  	var dependants, oldLength, i;

  	oldLength = newIndices.length;

  	// Indices that are being removed should be marked as dirty
  	newIndices.forEach(function (newIndex, oldIndex) {
  		if (newIndex === -1) {
  			_this.mark(keypath.join(oldIndex), noCascadeOption);
  		}
  	});

  	// Update the model
  	// TODO allow existing array to be updated in place, rather than replaced?
  	this.set(keypath, array, { silent: true });

  	if (dependants = this.deps["default"][keypath.str]) {
  		dependants.filter(canShuffle).forEach(function (d) {
  			return d.shuffle(newIndices, array);
  		});
  	}

  	if (oldLength !== array.length) {
  		this.mark(keypath.join("length"), implicitOption);

  		for (i = newIndices.touchedFrom; i < array.length; i += 1) {
  			this.mark(keypath.join(i));
  		}

  		// don't allow removed indexes beyond end of new array to trigger recomputations
  		// TODO is this still necessary, now that computations are lazy?
  		for (i = array.length; i < oldLength; i += 1) {
  			this.mark(keypath.join(i), noCascadeOption);
  		}
  	}
  }

  function canShuffle(dependant) {
  	return typeof dependant.shuffle === "function";
  }

  var prototype_teardown = Viewmodel$teardown;

  function Viewmodel$teardown() {
  	var _this = this;

  	var unresolvedImplicitDependency;

  	// Clear entire cache - this has the desired side-effect
  	// of unwrapping adapted values (e.g. arrays)
  	Object.keys(this.cache).forEach(function (keypath) {
  		return _this.clearCache(keypath);
  	});

  	// Teardown any failed lookups - we don't need them to resolve any more
  	while (unresolvedImplicitDependency = this.unresolvedImplicitDependencies.pop()) {
  		unresolvedImplicitDependency.teardown();
  	}
  }

  var unregister = Viewmodel$unregister;

  function Viewmodel$unregister(keypath, dependant) {
  	var group = arguments[2] === undefined ? "default" : arguments[2];

  	var mapping, deps, index;

  	if (dependant.isStatic) {
  		return;
  	}

  	if (mapping = this.mappings[keypath.firstKey]) {
  		return mapping.unregister(keypath, dependant, group);
  	}

  	deps = this.deps[group][keypath.str];
  	index = deps.indexOf(dependant);

  	if (index === -1) {
  		throw new Error("Attempted to remove a dependant that was no longer registered! This should not happen. If you are seeing this bug in development please raise an issue at https://github.com/RactiveJS/Ractive/issues - thanks");
  	}

  	deps.splice(index, 1);

  	if (keypath.isRoot) {
  		return;
  	}

  	unregister__updateDependantsMap(this, keypath, group);
  }

  function unregister__updateDependantsMap(viewmodel, keypath, group) {
  	var map, parent;

  	// update dependants map
  	while (!keypath.isRoot) {
  		map = viewmodel.depsMap[group];
  		parent = map[keypath.parent.str];

  		parent["_" + keypath.str] -= 1;

  		if (!parent["_" + keypath.str]) {
  			// remove from parent deps map
  			removeFromArray(parent, keypath);
  			parent["_" + keypath.str] = undefined;
  		}

  		keypath = keypath.parent;
  	}
  }

  var Viewmodel = function (options) {
  	var adapt = options.adapt;
  	var data = options.data;
  	var ractive = options.ractive;
  	var computed = options.computed;
  	var mappings = options.mappings;
  	var key;
  	var mapping;

  	// TODO is it possible to remove this reference?
  	this.ractive = ractive;

  	this.adaptors = adapt;
  	this.onchange = options.onchange;

  	this.cache = {}; // we need to be able to use hasOwnProperty, so can't inherit from null
  	this.cacheMap = create(null);

  	this.deps = {
  		computed: create(null),
  		"default": create(null)
  	};
  	this.depsMap = {
  		computed: create(null),
  		"default": create(null)
  	};

  	this.patternObservers = [];

  	this.specials = create(null);

  	this.wrapped = create(null);
  	this.computations = create(null);

  	this.captureGroups = [];
  	this.unresolvedImplicitDependencies = [];

  	this.changes = [];
  	this.implicitChanges = {};
  	this.noCascade = {};

  	this.data = data;

  	// set up explicit mappings
  	this.mappings = create(null);
  	for (key in mappings) {
  		this.map(getKeypath(key), mappings[key]);
  	}

  	if (data) {
  		// if data exists locally, but is missing on the parent,
  		// we transfer ownership to the parent
  		for (key in data) {
  			if ((mapping = this.mappings[key]) && mapping.getValue() === undefined) {
  				mapping.setValue(data[key]);
  			}
  		}
  	}

  	for (key in computed) {
  		if (mappings && key in mappings) {
  			fatal("Cannot map to a computed property ('%s')", key);
  		}

  		this.compute(getKeypath(key), computed[key]);
  	}

  	this.ready = true;
  };

  Viewmodel.prototype = {
  	adapt: prototype_adapt,
  	applyChanges: applyChanges,
  	capture: capture,
  	clearCache: clearCache,
  	compute: compute,
  	get: viewmodel_prototype_get,
  	init: viewmodel_prototype_init,
  	map: prototype_map,
  	mark: mark,
  	merge: merge,
  	register: register,
  	release: release,
  	reset: reset,
  	set: prototype_set,
  	smartUpdate: smartUpdate,
  	teardown: prototype_teardown,
  	unregister: unregister
  };

  var viewmodel_Viewmodel = Viewmodel;

  function HookQueue(event) {
  	this.hook = new hooks_Hook(event);
  	this.inProcess = {};
  	this.queue = {};
  }

  HookQueue.prototype = {

  	constructor: HookQueue,

  	begin: function (ractive) {
  		this.inProcess[ractive._guid] = true;
  	},

  	end: function (ractive) {

  		var parent = ractive.parent;

  		// If this is *isn't* a child of a component that's in process,
  		// it should call methods or fire at this point
  		if (!parent || !this.inProcess[parent._guid]) {
  			fire(this, ractive);
  		}
  		// elsewise, handoff to parent to fire when ready
  		else {
  			getChildQueue(this.queue, parent).push(ractive);
  		}

  		delete this.inProcess[ractive._guid];
  	}
  };

  function getChildQueue(queue, ractive) {
  	return queue[ractive._guid] || (queue[ractive._guid] = []);
  }

  function fire(hookQueue, ractive) {

  	var childQueue = getChildQueue(hookQueue.queue, ractive);

  	hookQueue.hook.fire(ractive);

  	// queue is "live" because components can end up being
  	// added while hooks fire on parents that modify data values.
  	while (childQueue.length) {
  		fire(hookQueue, childQueue.shift());
  	}

  	delete hookQueue.queue[ractive._guid];
  }

  var hooks_HookQueue = HookQueue;

  var helpers_getComputationSignatures = getComputationSignatures;

  var helpers_getComputationSignatures__pattern = /\$\{([^\}]+)\}/g;
  function getComputationSignatures(ractive, computed) {
  	var signatures = {},
  	    key;

  	for (key in computed) {
  		signatures[key] = getComputationSignature(ractive, key, computed[key]);
  	}

  	return signatures;
  }

  function getComputationSignature(ractive, key, signature) {
  	var getter, setter;

  	if (typeof signature === "function") {
  		getter = helpers_getComputationSignatures__bind(signature, ractive);
  	}

  	if (typeof signature === "string") {
  		getter = createFunctionFromString(ractive, signature);
  	}

  	if (typeof signature === "object") {
  		if (typeof signature.get === "string") {
  			getter = createFunctionFromString(ractive, signature.get);
  		} else if (typeof signature.get === "function") {
  			getter = helpers_getComputationSignatures__bind(signature.get, ractive);
  		} else {
  			fatal("`%s` computation must have a `get()` method", key);
  		}

  		if (typeof signature.set === "function") {
  			setter = helpers_getComputationSignatures__bind(signature.set, ractive);
  		}
  	}

  	return { getter: getter, setter: setter };
  }

  function createFunctionFromString(ractive, str) {
  	var functionBody, hasThis, fn;

  	functionBody = "return (" + str.replace(helpers_getComputationSignatures__pattern, function (match, keypath) {
  		hasThis = true;
  		return "__ractive.get(\"" + keypath + "\")";
  	}) + ");";

  	if (hasThis) {
  		functionBody = "var __ractive = this; " + functionBody;
  	}

  	fn = new Function(functionBody);
  	return hasThis ? fn.bind(ractive) : fn;
  }

  function helpers_getComputationSignatures__bind(fn, context) {
  	return /this/.test(fn.toString()) ? fn.bind(context) : fn;
  }

  var constructHook = new hooks_Hook("construct");
  var configHook = new hooks_Hook("config");
  var initHook = new hooks_HookQueue("init");
  var initialise__uid = 0;

  var initialise__registryNames = ["adaptors", "components", "decorators", "easing", "events", "interpolators", "partials", "transitions"];

  var initialise = initialiseRactiveInstance;

  function initialiseRactiveInstance(ractive) {
  	var userOptions = arguments[1] === undefined ? {} : arguments[1];
  	var options = arguments[2] === undefined ? {} : arguments[2];

  	var el, viewmodel;

  	if (_Ractive.DEBUG) {
  		welcome();
  	}

  	initialiseProperties(ractive, options);

  	// TODO remove this, eventually
  	defineProperty(ractive, "data", { get: deprecateRactiveData });

  	// TODO don't allow `onconstruct` with `new Ractive()`, there's no need for it
  	constructHook.fire(ractive, userOptions);

  	// Add registries
  	initialise__registryNames.forEach(function (name) {
  		ractive[name] = utils_object__extend(create(ractive.constructor[name] || null), userOptions[name]);
  	});

  	// Create a viewmodel
  	viewmodel = new viewmodel_Viewmodel({
  		adapt: getAdaptors(ractive, ractive.adapt, userOptions),
  		data: custom_data.init(ractive.constructor, ractive, userOptions),
  		computed: helpers_getComputationSignatures(ractive, utils_object__extend(create(ractive.constructor.prototype.computed), userOptions.computed)),
  		mappings: options.mappings,
  		ractive: ractive,
  		onchange: function () {
  			return global_runloop.addRactive(ractive);
  		}
  	});

  	ractive.viewmodel = viewmodel;

  	// This can't happen earlier, because computed properties may call `ractive.get()`, etc
  	viewmodel.init();

  	// init config from Parent and options
  	config_config.init(ractive.constructor, ractive, userOptions);

  	configHook.fire(ractive);
  	initHook.begin(ractive);

  	// // If this is a component with a function `data` property, call the function
  	// // with `ractive` as context (unless the child was also a function)
  	// if ( typeof ractive.constructor.prototype.data === 'function' && typeof userOptions.data !== 'function' ) {
  	// 	viewmodel.reset( ractive.constructor.prototype.data.call( ractive ) || fatal( '`data` functions must return a data object' ) );
  	// }

  	// Render virtual DOM
  	if (ractive.template) {
  		var cssIds = undefined;

  		if (options.cssIds || ractive.cssId) {
  			cssIds = options.cssIds ? options.cssIds.slice() : [];

  			if (ractive.cssId) {
  				cssIds.push(ractive.cssId);
  			}
  		}

  		ractive.fragment = new virtualdom_Fragment({
  			template: ractive.template,
  			root: ractive,
  			owner: ractive, // saves doing `if ( this.parent ) { /*...*/ }` later on
  			cssIds: cssIds
  		});
  	}

  	initHook.end(ractive);

  	// render automatically ( if `el` is specified )
  	if (el = getElement(ractive.el)) {
  		var promise = ractive.render(el, ractive.append);

  		if (_Ractive.DEBUG_PROMISES) {
  			promise["catch"](function (err) {
  				warnOnceIfDebug("Promise debugging is enabled, to help solve errors that happen asynchronously. Some browsers will log unhandled promise rejections, in which case you can safely disable promise debugging:\n  Ractive.DEBUG_PROMISES = false;");
  				warnIfDebug("An error happened during rendering", { ractive: ractive });
  				err.stack && logIfDebug(err.stack);

  				throw err;
  			});
  		}
  	}
  }

  function getAdaptors(ractive, protoAdapt, userOptions) {
  	var adapt, magic, modifyArrays;

  	protoAdapt = protoAdapt.map(lookup);
  	adapt = ensureArray(userOptions.adapt).map(lookup);

  	adapt = initialise__combine(protoAdapt, adapt);

  	magic = "magic" in userOptions ? userOptions.magic : ractive.magic;
  	modifyArrays = "modifyArrays" in userOptions ? userOptions.modifyArrays : ractive.modifyArrays;

  	if (magic) {
  		if (!environment__magic) {
  			throw new Error("Getters and setters (magic mode) are not supported in this browser");
  		}

  		if (modifyArrays) {
  			adapt.push(magicArray);
  		}

  		adapt.push(adaptors_magic);
  	}

  	if (modifyArrays) {
  		adapt.push(array_index);
  	}

  	return adapt;

  	function lookup(adaptor) {
  		if (typeof adaptor === "string") {
  			adaptor = findInViewHierarchy("adaptors", ractive, adaptor);

  			if (!adaptor) {
  				fatal(missingPlugin(adaptor, "adaptor"));
  			}
  		}

  		return adaptor;
  	}
  }

  function initialise__combine(a, b) {
  	var c = a.slice(),
  	    i = b.length;

  	while (i--) {
  		if (! ~c.indexOf(b[i])) {
  			c.push(b[i]);
  		}
  	}

  	return c;
  }

  function initialiseProperties(ractive, options) {
  	// Generate a unique identifier, for places where you'd use a weak map if it
  	// existed
  	ractive._guid = "r-" + initialise__uid++;

  	// events
  	ractive._subs = create(null);

  	// storage for item configuration from instantiation to reset,
  	// like dynamic functions or original values
  	ractive._config = {};

  	// two-way bindings
  	ractive._twowayBindings = create(null);

  	// animations (so we can stop any in progress at teardown)
  	ractive._animations = [];

  	// nodes registry
  	ractive.nodes = {};

  	// live queries
  	ractive._liveQueries = [];
  	ractive._liveComponentQueries = [];

  	// bound data functions
  	ractive._boundFunctions = [];

  	// observers
  	ractive._observers = [];

  	// properties specific to inline components
  	if (options.component) {
  		ractive.parent = options.parent;
  		ractive.container = options.container || null;
  		ractive.root = ractive.parent.root;

  		ractive.component = options.component;
  		options.component.instance = ractive;

  		// for hackability, this could be an open option
  		// for any ractive instance, but for now, just
  		// for components and just for ractive...
  		ractive._inlinePartials = options.inlinePartials;
  	} else {
  		ractive.root = ractive;
  		ractive.parent = ractive.container = null;
  	}
  }

  function deprecateRactiveData() {
  	throw new Error("Using `ractive.data` is no longer supported - you must use the `ractive.get()` API instead");
  }

  function ComplexParameter(component, template, callback) {
  	this.parentFragment = component.parentFragment;
  	this.callback = callback;

  	this.fragment = new virtualdom_Fragment({
  		template: template,
  		root: component.root,
  		owner: this
  	});

  	this.update();
  }

  var initialise_ComplexParameter = ComplexParameter;

  ComplexParameter.prototype = {
  	bubble: function () {
  		if (!this.dirty) {
  			this.dirty = true;
  			global_runloop.addView(this);
  		}
  	},

  	update: function () {
  		this.callback(this.fragment.getValue());
  		this.dirty = false;
  	},

  	rebind: function (oldKeypath, newKeypath) {
  		this.fragment.rebind(oldKeypath, newKeypath);
  	},

  	unbind: function () {
  		this.fragment.unbind();
  	}
  };

  var createInstance = function (component, Component, attributes, yieldTemplate, partials) {
  	var instance,
  	    parentFragment,
  	    ractive,
  	    fragment,
  	    container,
  	    inlinePartials = {},
  	    data = {},
  	    mappings = {},
  	    ready,
  	    resolvers = [];

  	parentFragment = component.parentFragment;
  	ractive = component.root;

  	partials = partials || {};
  	utils_object__extend(inlinePartials, partials);

  	// Make contents available as a {{>content}} partial
  	partials.content = yieldTemplate || [];

  	// set a default partial for yields with no name
  	inlinePartials[""] = partials.content;

  	if (Component.defaults.el) {
  		warnIfDebug("The <%s/> component has a default `el` property; it has been disregarded", component.name);
  	}

  	// find container
  	fragment = parentFragment;
  	while (fragment) {
  		if (fragment.owner.type === YIELDER) {
  			container = fragment.owner.container;
  			break;
  		}

  		fragment = fragment.parent;
  	}

  	// each attribute represents either a) data or b) a mapping
  	if (attributes) {
  		Object.keys(attributes).forEach(function (key) {
  			var attribute = attributes[key],
  			    parsed,
  			    resolver;

  			if (typeof attribute === "string") {
  				// it's static data
  				parsed = parseJSON(attribute);
  				data[key] = parsed ? parsed.value : attribute;
  			} else if (attribute === 0) {
  				// it had no '=', so we'll call it true
  				data[key] = true;
  			} else if (isArray(attribute)) {
  				// this represents dynamic data
  				if (isSingleInterpolator(attribute)) {
  					mappings[key] = {
  						origin: component.root.viewmodel,
  						keypath: undefined
  					};

  					resolver = createResolver(component, attribute[0], function (keypath) {
  						if (keypath.isSpecial) {
  							if (ready) {
  								instance.set(key, keypath.value); // TODO use viewmodel?
  							} else {
  								data[key] = keypath.value;

  								// TODO errr.... would be better if we didn't have to do this
  								delete mappings[key];
  							}
  						} else {
  							if (ready) {
  								instance.viewmodel.mappings[key].resolve(keypath);
  							} else {
  								// resolved immediately
  								mappings[key].keypath = keypath;
  							}
  						}
  					});
  				} else {
  					resolver = new initialise_ComplexParameter(component, attribute, function (value) {
  						if (ready) {
  							instance.set(key, value); // TODO use viewmodel?
  						} else {
  							data[key] = value;
  						}
  					});
  				}

  				resolvers.push(resolver);
  			} else {
  				throw new Error("erm wut");
  			}
  		});
  	}

  	instance = create(Component.prototype);

  	initialise(instance, {
  		el: null,
  		append: true,
  		data: data,
  		partials: partials,
  		magic: ractive.magic || Component.defaults.magic,
  		modifyArrays: ractive.modifyArrays,
  		// need to inherit runtime parent adaptors
  		adapt: ractive.adapt
  	}, {
  		parent: ractive,
  		component: component,
  		container: container,
  		mappings: mappings,
  		inlinePartials: inlinePartials,
  		cssIds: parentFragment.cssIds
  	});

  	ready = true;
  	component.resolvers = resolvers;

  	return instance;
  };

  function createResolver(component, template, callback) {
  	var resolver;

  	if (template.r) {
  		resolver = Resolvers_createReferenceResolver(component, template.r, callback);
  	} else if (template.x) {
  		resolver = new Resolvers_ExpressionResolver(component, component.parentFragment, template.x, callback);
  	} else if (template.rx) {
  		resolver = new ReferenceExpressionResolver_ReferenceExpressionResolver(component, template.rx, callback);
  	}

  	return resolver;
  }

  function isSingleInterpolator(template) {
  	return template.length === 1 && template[0].t === INTERPOLATOR;
  }

  // TODO how should event arguments be handled? e.g.
  // <widget on-foo='bar:1,2,3'/>
  // The event 'bar' will be fired on the parent instance
  // when 'foo' fires on the child, but the 1,2,3 arguments
  // will be lost

  var initialise_propagateEvents = propagateEvents;

  function propagateEvents(component, eventsDescriptor) {
  	var eventName;

  	for (eventName in eventsDescriptor) {
  		if (eventsDescriptor.hasOwnProperty(eventName)) {
  			propagateEvent(component.instance, component.root, eventName, eventsDescriptor[eventName]);
  		}
  	}
  }

  function propagateEvent(childInstance, parentInstance, eventName, proxyEventName) {
  	if (typeof proxyEventName !== "string") {
  		fatal("Components currently only support simple events - you cannot include arguments. Sorry!");
  	}

  	childInstance.on(eventName, function () {
  		var event, args;

  		// semi-weak test, but what else? tag the event obj ._isEvent ?
  		if (arguments.length && arguments[0] && arguments[0].node) {
  			event = Array.prototype.shift.call(arguments);
  		}

  		args = Array.prototype.slice.call(arguments);

  		shared_fireEvent(parentInstance, proxyEventName, { event: event, args: args });

  		// cancel bubbling
  		return false;
  	});
  }

  var initialise_updateLiveQueries = function (component) {
  	var ancestor, query;

  	// If there's a live query for this component type, add it
  	ancestor = component.root;
  	while (ancestor) {
  		if (query = ancestor._liveComponentQueries["_" + component.name]) {
  			query.push(component.instance);
  		}

  		ancestor = ancestor.parent;
  	}
  };

  var Component_prototype_init = Component$init;
  function Component$init(options, Component) {
  	var parentFragment, root;

  	if (!Component) {
  		throw new Error("Component \"" + this.name + "\" not found");
  	}

  	parentFragment = this.parentFragment = options.parentFragment;
  	root = parentFragment.root;

  	this.root = root;
  	this.type = COMPONENT;
  	this.name = options.template.e;
  	this.index = options.index;
  	this.indexRefBindings = {};
  	this.yielders = {};
  	this.resolvers = [];

  	createInstance(this, Component, options.template.a, options.template.f, options.template.p);
  	initialise_propagateEvents(this, options.template.v);

  	// intro, outro and decorator directives have no effect
  	if (options.template.t0 || options.template.t1 || options.template.t2 || options.template.o) {
  		warnIfDebug("The \"intro\", \"outro\" and \"decorator\" directives have no effect on components", { ractive: this.instance });
  	}

  	initialise_updateLiveQueries(this);
  }

  var Component_prototype_rebind = Component$rebind;

  function Component$rebind(oldKeypath, newKeypath) {
  	var query;

  	this.resolvers.forEach(rebind);

  	for (var k in this.yielders) {
  		if (this.yielders[k][0]) {
  			rebind(this.yielders[k][0]);
  		}
  	}

  	if (query = this.root._liveComponentQueries["_" + this.name]) {
  		query._makeDirty();
  	}

  	function rebind(x) {
  		x.rebind(oldKeypath, newKeypath);
  	}
  }

  var Component_prototype_render = Component$render;

  function Component$render() {
  	var instance = this.instance;

  	instance.render(this.parentFragment.getNode());

  	this.rendered = true;
  	return instance.fragment.detach();
  }

  var Component_prototype_toString = Component$toString;

  function Component$toString() {
  	return this.instance.fragment.toString();
  }

  var Component_prototype_unbind = Component$unbind;

  var Component_prototype_unbind__teardownHook = new hooks_Hook("teardown");
  function Component$unbind() {
  	var instance = this.instance;

  	this.resolvers.forEach(methodCallers__unbind);

  	removeFromLiveComponentQueries(this);

  	instance._observers.forEach(cancel);

  	// teardown the instance
  	instance.fragment.unbind();
  	instance.viewmodel.teardown();

  	if (instance.fragment.rendered && instance.el.__ractive_instances__) {
  		removeFromArray(instance.el.__ractive_instances__, instance);
  	}

  	Component_prototype_unbind__teardownHook.fire(instance);
  }

  function removeFromLiveComponentQueries(component) {
  	var instance, query;

  	instance = component.root;

  	do {
  		if (query = instance._liveComponentQueries["_" + component.name]) {
  			query._remove(component);
  		}
  	} while (instance = instance.parent);
  }

  var Component_prototype_unrender = Component$unrender;

  function Component$unrender(shouldDestroy) {
  	this.shouldDestroy = shouldDestroy;
  	this.instance.unrender();
  }

  var Component = function (options, Constructor) {
  	this.init(options, Constructor);
  };

  Component.prototype = {
  	detach: Component_prototype_detach,
  	find: Component_prototype_find,
  	findAll: Component_prototype_findAll,
  	findAllComponents: Component_prototype_findAllComponents,
  	findComponent: Component_prototype_findComponent,
  	findNextNode: Component_prototype_findNextNode,
  	firstNode: Component_prototype_firstNode,
  	init: Component_prototype_init,
  	rebind: Component_prototype_rebind,
  	render: Component_prototype_render,
  	toString: Component_prototype_toString,
  	unbind: Component_prototype_unbind,
  	unrender: Component_prototype_unrender
  };

  var _Component = Component;

  var Comment = function (options) {
  	this.type = COMMENT;
  	this.value = options.template.c;
  };

  Comment.prototype = {
  	detach: shared_detach,

  	firstNode: function () {
  		return this.node;
  	},

  	render: function () {
  		if (!this.node) {
  			this.node = document.createComment(this.value);
  		}

  		return this.node;
  	},

  	toString: function () {
  		return "<!--" + this.value + "-->";
  	},

  	unrender: function (shouldDestroy) {
  		if (shouldDestroy) {
  			this.node.parentNode.removeChild(this.node);
  		}
  	}
  };

  var items_Comment = Comment;

  var Yielder = function (options) {
  	var container, component;

  	this.type = YIELDER;

  	this.container = container = options.parentFragment.root;
  	this.component = component = container.component;

  	this.container = container;
  	this.containerFragment = options.parentFragment;
  	this.parentFragment = component.parentFragment;

  	var name = this.name = options.template.n || "";

  	var template = container._inlinePartials[name];

  	if (!template) {
  		warnIfDebug("Could not find template for partial \"" + name + "\"", { ractive: options.root });
  		template = [];
  	}

  	this.fragment = new virtualdom_Fragment({
  		owner: this,
  		root: container.parent,
  		template: template,
  		pElement: this.containerFragment.pElement
  	});

  	// even though only one yielder is allowed, we need to have an array of them
  	// as it's possible to cause a yielder to be created before the last one
  	// was destroyed in the same turn of the runloop
  	if (!isArray(component.yielders[name])) {
  		component.yielders[name] = [this];
  	} else {
  		component.yielders[name].push(this);
  	}

  	global_runloop.scheduleTask(function () {
  		if (component.yielders[name].length > 1) {
  			throw new Error("A component template can only have one {{yield" + (name ? " " + name : "") + "}} declaration at a time");
  		}
  	});
  };

  Yielder.prototype = {
  	detach: function () {
  		return this.fragment.detach();
  	},

  	find: function (selector) {
  		return this.fragment.find(selector);
  	},

  	findAll: function (selector, query) {
  		return this.fragment.findAll(selector, query);
  	},

  	findComponent: function (selector) {
  		return this.fragment.findComponent(selector);
  	},

  	findAllComponents: function (selector, query) {
  		return this.fragment.findAllComponents(selector, query);
  	},

  	findNextNode: function () {
  		return this.containerFragment.findNextNode(this);
  	},

  	firstNode: function () {
  		return this.fragment.firstNode();
  	},

  	getValue: function (options) {
  		return this.fragment.getValue(options);
  	},

  	render: function () {
  		return this.fragment.render();
  	},

  	unbind: function () {
  		this.fragment.unbind();
  	},

  	unrender: function (shouldDestroy) {
  		this.fragment.unrender(shouldDestroy);
  		removeFromArray(this.component.yielders[this.name], this);
  	},

  	rebind: function (oldKeypath, newKeypath) {
  		this.fragment.rebind(oldKeypath, newKeypath);
  	},

  	toString: function () {
  		return this.fragment.toString();
  	}
  };

  var items_Yielder = Yielder;

  var Doctype = function (options) {
  	this.declaration = options.template.a;
  };

  Doctype.prototype = {
  	init: noop,
  	render: noop,
  	unrender: noop,
  	teardown: noop,
  	toString: function () {
  		return "<!DOCTYPE" + this.declaration + ">";
  	}
  };

  var items_Doctype = Doctype;

  var Fragment_prototype_init = Fragment$init;

  function Fragment$init(options) {
  	var _this = this;

  	this.owner = options.owner; // The item that owns this fragment - an element, section, partial, or attribute
  	this.parent = this.owner.parentFragment;

  	// inherited properties
  	this.root = options.root;
  	this.pElement = options.pElement;
  	this.context = options.context;
  	this.index = options.index;
  	this.key = options.key;
  	this.registeredIndexRefs = [];

  	// encapsulated styles should be inherited until they get applied by an element
  	this.cssIds = "cssIds" in options ? options.cssIds : this.parent ? this.parent.cssIds : null;

  	this.items = options.template.map(function (template, i) {
  		return createItem({
  			parentFragment: _this,
  			pElement: options.pElement,
  			template: template,
  			index: i
  		});
  	});

  	this.value = this.argsList = null;
  	this.dirtyArgs = this.dirtyValue = true;

  	this.bound = true;
  }

  function createItem(options) {
  	if (typeof options.template === "string") {
  		return new items_Text(options);
  	}

  	switch (options.template.t) {
  		case YIELDER:
  			return new items_Yielder(options);
  		case INTERPOLATOR:
  			return new items_Interpolator(options);
  		case SECTION:
  			return new _Section(options);
  		case TRIPLE:
  			return new _Triple(options);
  		case ELEMENT:
  			var constructor = undefined;
  			if (constructor = Component_getComponent(options.parentFragment.root, options.template.e)) {
  				return new _Component(options, constructor);
  			}
  			return new _Element(options);
  		case PARTIAL:
  			return new _Partial(options);
  		case COMMENT:
  			return new items_Comment(options);
  		case DOCTYPE:
  			return new items_Doctype(options);

  		default:
  			throw new Error("Something very strange happened. Please file an issue at https://github.com/ractivejs/ractive/issues. Thanks!");
  	}
  }

  var Fragment_prototype_rebind = Fragment$rebind;
  function Fragment$rebind(oldKeypath, newKeypath) {

  	// assign new context keypath if needed
  	if (!this.owner || this.owner.hasContext) {
  		assignNewKeypath(this, "context", oldKeypath, newKeypath);
  	}

  	this.items.forEach(function (item) {
  		if (item.rebind) {
  			item.rebind(oldKeypath, newKeypath);
  		}
  	});
  }

  var Fragment_prototype_render = Fragment$render;

  function Fragment$render() {
  	var result;

  	if (this.items.length === 1) {
  		result = this.items[0].render();
  	} else {
  		result = document.createDocumentFragment();

  		this.items.forEach(function (item) {
  			result.appendChild(item.render());
  		});
  	}

  	this.rendered = true;
  	return result;
  }

  var Fragment_prototype_toString = Fragment$toString;

  function Fragment$toString(escape) {
  	if (!this.items) {
  		return "";
  	}

  	return this.items.map(escape ? toEscapedString : Fragment_prototype_toString__toString).join("");
  }

  function Fragment_prototype_toString__toString(item) {
  	return item.toString();
  }

  function toEscapedString(item) {
  	return item.toString(true);
  }

  var Fragment_prototype_unbind = Fragment$unbind;

  function Fragment$unbind() {
  	if (!this.bound) {
  		return;
  	}

  	this.items.forEach(unbindItem);
  	this.bound = false;
  }

  function unbindItem(item) {
  	if (item.unbind) {
  		item.unbind();
  	}
  }

  var Fragment_prototype_unrender = Fragment$unrender;

  function Fragment$unrender(shouldDestroy) {
  	if (!this.rendered) {
  		throw new Error("Attempted to unrender a fragment that was not rendered");
  	}

  	this.items.forEach(function (i) {
  		return i.unrender(shouldDestroy);
  	});
  	this.rendered = false;
  }

  var Fragment = function (options) {
  	this.init(options);
  };

  Fragment.prototype = {
  	bubble: prototype_bubble,
  	detach: Fragment_prototype_detach,
  	find: Fragment_prototype_find,
  	findAll: Fragment_prototype_findAll,
  	findAllComponents: Fragment_prototype_findAllComponents,
  	findComponent: Fragment_prototype_findComponent,
  	findNextNode: prototype_findNextNode,
  	firstNode: prototype_firstNode,
  	getArgsList: getArgsList,
  	getNode: getNode,
  	getValue: prototype_getValue,
  	init: Fragment_prototype_init,
  	rebind: Fragment_prototype_rebind,
  	registerIndexRef: function (idx) {
  		var idxs = this.registeredIndexRefs;
  		if (idxs.indexOf(idx) === -1) {
  			idxs.push(idx);
  		}
  	},
  	render: Fragment_prototype_render,
  	toString: Fragment_prototype_toString,
  	unbind: Fragment_prototype_unbind,
  	unregisterIndexRef: function (idx) {
  		var idxs = this.registeredIndexRefs;
  		idxs.splice(idxs.indexOf(idx), 1);
  	},
  	unrender: Fragment_prototype_unrender
  };

  var virtualdom_Fragment = Fragment;

  var prototype_reset = Ractive$reset;
  var shouldRerender = ["template", "partials", "components", "decorators", "events"],
      resetHook = new hooks_Hook("reset");
  function Ractive$reset(data) {
  	var promise, wrapper, changes, i, rerender;

  	data = data || {};

  	if (typeof data !== "object") {
  		throw new Error("The reset method takes either no arguments, or an object containing new data");
  	}

  	// If the root object is wrapped, try and use the wrapper's reset value
  	if ((wrapper = this.viewmodel.wrapped[""]) && wrapper.reset) {
  		if (wrapper.reset(data) === false) {
  			// reset was rejected, we need to replace the object
  			this.viewmodel.reset(data);
  		}
  	} else {
  		this.viewmodel.reset(data);
  	}

  	// reset config items and track if need to rerender
  	changes = config_config.reset(this);

  	i = changes.length;
  	while (i--) {
  		if (shouldRerender.indexOf(changes[i]) > -1) {
  			rerender = true;
  			break;
  		}
  	}

  	if (rerender) {
  		var component = undefined;

  		this.viewmodel.mark(rootKeypath);

  		// Is this is a component, we need to set the `shouldDestroy`
  		// flag, otherwise it will assume by default that a parent node
  		// will be detached, and therefore it doesn't need to bother
  		// detaching its own nodes
  		if (component = this.component) {
  			component.shouldDestroy = true;
  		}

  		this.unrender();

  		if (component) {
  			component.shouldDestroy = false;
  		}

  		// If the template changed, we need to destroy the parallel DOM
  		// TODO if we're here, presumably it did?
  		if (this.fragment.template !== this.template) {
  			this.fragment.unbind();

  			this.fragment = new virtualdom_Fragment({
  				template: this.template,
  				root: this,
  				owner: this
  			});
  		}

  		promise = this.render(this.el, this.anchor);
  	} else {
  		promise = global_runloop.start(this, true);
  		this.viewmodel.mark(rootKeypath);
  		global_runloop.end();
  	}

  	resetHook.fire(this, data);

  	return promise;
  }

  var resetPartial = function (name, partial) {
  	var promise,
  	    collection = [];

  	function collect(source, dest, ractive) {
  		// if this is a component and it has its own partial, bail
  		if (ractive && ractive.partials[name]) return;

  		source.forEach(function (item) {
  			// queue to rerender if the item is a partial and the current name matches
  			if (item.type === PARTIAL && item.getPartialName() === name) {
  				dest.push(item);
  			}

  			// if it has a fragment, process its items
  			if (item.fragment) {
  				collect(item.fragment.items, dest, ractive);
  			}

  			// or if it has fragments
  			if (isArray(item.fragments)) {
  				collect(item.fragments, dest, ractive);
  			}

  			// or if it is itself a fragment, process its items
  			else if (isArray(item.items)) {
  				collect(item.items, dest, ractive);
  			}

  			// or if it is a component, step in and process its items
  			else if (item.type === COMPONENT && item.instance) {
  				collect(item.instance.fragment.items, dest, item.instance);
  			}

  			// if the item is an element, process its attributes too
  			if (item.type === ELEMENT) {
  				if (isArray(item.attributes)) {
  					collect(item.attributes, dest, ractive);
  				}

  				if (isArray(item.conditionalAttributes)) {
  					collect(item.conditionalAttributes, dest, ractive);
  				}
  			}
  		});
  	}

  	collect(this.fragment.items, collection);
  	this.partials[name] = partial;

  	promise = global_runloop.start(this, true);

  	collection.forEach(function (item) {
  		item.value = undefined;
  		item.setValue(name);
  	});

  	global_runloop.end();

  	return promise;
  };

  // TODO should resetTemplate be asynchronous? i.e. should it be a case
  // of outro, update template, intro? I reckon probably not, since that
  // could be achieved with unrender-resetTemplate-render. Also, it should
  // conceptually be similar to resetPartial, which couldn't be async

  var resetTemplate = Ractive$resetTemplate;
  function Ractive$resetTemplate(template) {
  	var transitionsEnabled, component;

  	template_template.init(null, this, { template: template });

  	transitionsEnabled = this.transitionsEnabled;
  	this.transitionsEnabled = false;

  	// Is this is a component, we need to set the `shouldDestroy`
  	// flag, otherwise it will assume by default that a parent node
  	// will be detached, and therefore it doesn't need to bother
  	// detaching its own nodes
  	if (component = this.component) {
  		component.shouldDestroy = true;
  	}

  	this.unrender();

  	if (component) {
  		component.shouldDestroy = false;
  	}

  	// remove existing fragment and create new one
  	this.fragment.unbind();
  	this.fragment = new virtualdom_Fragment({
  		template: this.template,
  		root: this,
  		owner: this
  	});

  	this.render(this.el, this.anchor);

  	this.transitionsEnabled = transitionsEnabled;
  }

  var reverse = makeArrayMethod("reverse");

  var Ractive_prototype_set = Ractive$set;

  function Ractive$set(keypath, value) {
  	var map, promise;

  	promise = global_runloop.start(this, true);

  	// Set multiple keypaths in one go
  	if (isObject(keypath)) {
  		map = keypath;

  		for (keypath in map) {
  			if (map.hasOwnProperty(keypath)) {
  				value = map[keypath];
  				set(this, keypath, value);
  			}
  		}
  	}

  	// Set a single keypath
  	else {
  		set(this, keypath, value);
  	}

  	global_runloop.end();

  	return promise;
  }

  function set(ractive, keypath, value) {
  	keypath = getKeypath(normalise(keypath));

  	if (keypath.isPattern) {
  		getMatchingKeypaths(ractive, keypath).forEach(function (keypath) {
  			ractive.viewmodel.set(keypath, value);
  		});
  	} else {
  		ractive.viewmodel.set(keypath, value);
  	}
  }

  var shift = makeArrayMethod("shift");

  var prototype_sort = makeArrayMethod("sort");

  var splice = makeArrayMethod("splice");

  var subtract = Ractive$subtract;
  function Ractive$subtract(keypath, d) {
  	return shared_add(this, keypath, d === undefined ? -1 : -d);
  }

  // Teardown. This goes through the root fragment and all its children, removing observers
  // and generally cleaning up after itself

  var Ractive_prototype_teardown = Ractive$teardown;

  var Ractive_prototype_teardown__teardownHook = new hooks_Hook("teardown");
  function Ractive$teardown() {
  	var promise;

  	this.fragment.unbind();
  	this.viewmodel.teardown();

  	this._observers.forEach(cancel);

  	if (this.fragment.rendered && this.el.__ractive_instances__) {
  		removeFromArray(this.el.__ractive_instances__, this);
  	}

  	this.shouldDestroy = true;
  	promise = this.fragment.rendered ? this.unrender() : utils_Promise.resolve();

  	Ractive_prototype_teardown__teardownHook.fire(this);

  	this._boundFunctions.forEach(deleteFunctionCopy);

  	return promise;
  }

  function deleteFunctionCopy(bound) {
  	delete bound.fn[bound.prop];
  }

  var toggle = Ractive$toggle;
  function Ractive$toggle(keypath) {
  	var _this = this;

  	if (typeof keypath !== "string") {
  		throw new TypeError(badArguments);
  	}

  	var changes = undefined;

  	if (/\*/.test(keypath)) {
  		changes = {};

  		getMatchingKeypaths(this, getKeypath(normalise(keypath))).forEach(function (keypath) {
  			changes[keypath.str] = !_this.viewmodel.get(keypath);
  		});

  		return this.set(changes);
  	}

  	return this.set(keypath, !this.get(keypath));
  }

  var toHTML = Ractive$toHTML;

  function Ractive$toHTML() {
  	return this.fragment.toString(true);
  }

  var Ractive_prototype_unrender = Ractive$unrender;
  var unrenderHook = new hooks_Hook("unrender");
  function Ractive$unrender() {
  	var promise, shouldDestroy;

  	if (!this.fragment.rendered) {
  		warnIfDebug("ractive.unrender() was called on a Ractive instance that was not rendered");
  		return utils_Promise.resolve();
  	}

  	promise = global_runloop.start(this, true);

  	// If this is a component, and the component isn't marked for destruction,
  	// don't detach nodes from the DOM unnecessarily
  	shouldDestroy = !this.component || this.component.shouldDestroy || this.shouldDestroy;

  	// Cancel any animations in progress
  	while (this._animations[0]) {
  		this._animations[0].stop(); // it will remove itself from the index
  	}

  	this.fragment.unrender(shouldDestroy);

  	removeFromArray(this.el.__ractive_instances__, this);

  	unrenderHook.fire(this);

  	global_runloop.end();
  	return promise;
  }

  var unshift = makeArrayMethod("unshift");

  var Ractive_prototype_update = Ractive$update;
  var updateHook = new hooks_Hook("update");
  function Ractive$update(keypath) {
  	var promise;

  	keypath = getKeypath(keypath) || rootKeypath;

  	promise = global_runloop.start(this, true);
  	this.viewmodel.mark(keypath);
  	global_runloop.end();

  	updateHook.fire(this, keypath);

  	return promise;
  }

  var prototype_updateModel = Ractive$updateModel;

  function Ractive$updateModel(keypath, cascade) {
  	var values, key, bindings;

  	if (typeof keypath === "string" && !cascade) {
  		bindings = this._twowayBindings[keypath];
  	} else {
  		bindings = [];

  		for (key in this._twowayBindings) {
  			if (!keypath || getKeypath(key).equalsOrStartsWith(keypath)) {
  				// TODO is this right?
  				bindings.push.apply(bindings, this._twowayBindings[key]);
  			}
  		}
  	}

  	values = consolidate(this, bindings);
  	return this.set(values);
  }

  function consolidate(ractive, bindings) {
  	var values = {},
  	    checkboxGroups = [];

  	bindings.forEach(function (b) {
  		var oldValue, newValue;

  		// special case - radio name bindings
  		if (b.radioName && !b.element.node.checked) {
  			return;
  		}

  		// special case - checkbox name bindings come in groups, so
  		// we want to get the value once at most
  		if (b.checkboxName) {
  			if (!checkboxGroups[b.keypath.str] && !b.changed()) {
  				checkboxGroups.push(b.keypath);
  				checkboxGroups[b.keypath.str] = b;
  			}

  			return;
  		}

  		oldValue = b.attribute.value;
  		newValue = b.getValue();

  		if (arrayContentsMatch(oldValue, newValue)) {
  			return;
  		}

  		if (!isEqual(oldValue, newValue)) {
  			values[b.keypath.str] = newValue;
  		}
  	});

  	// Handle groups of `<input type='checkbox' name='{{foo}}' ...>`
  	if (checkboxGroups.length) {
  		checkboxGroups.forEach(function (keypath) {
  			var binding, oldValue, newValue;

  			binding = checkboxGroups[keypath.str]; // one to represent the entire group
  			oldValue = binding.attribute.value;
  			newValue = binding.getValue();

  			if (!arrayContentsMatch(oldValue, newValue)) {
  				values[keypath.str] = newValue;
  			}
  		});
  	}

  	return values;
  }

  var prototype = {
  	add: prototype_add,
  	animate: prototype_animate,
  	detach: prototype_detach,
  	find: prototype_find,
  	findAll: prototype_findAll,
  	findAllComponents: prototype_findAllComponents,
  	findComponent: prototype_findComponent,
  	findContainer: findContainer,
  	findParent: findParent,
  	fire: prototype_fire,
  	get: prototype_get,
  	insert: insert,
  	merge: prototype_merge,
  	observe: observe,
  	observeOnce: observeOnce,
  	off: off,
  	on: on,
  	once: once,
  	pop: pop,
  	push: push,
  	render: prototype_render,
  	reset: prototype_reset,
  	resetPartial: resetPartial,
  	resetTemplate: resetTemplate,
  	reverse: reverse,
  	set: Ractive_prototype_set,
  	shift: shift,
  	sort: prototype_sort,
  	splice: splice,
  	subtract: subtract,
  	teardown: Ractive_prototype_teardown,
  	toggle: toggle,
  	toHTML: toHTML,
  	toHtml: toHTML,
  	unrender: Ractive_prototype_unrender,
  	unshift: unshift,
  	update: Ractive_prototype_update,
  	updateModel: prototype_updateModel
  };

  var wrapMethod = function (method, superMethod, force) {

  	if (force || needsSuper(method, superMethod)) {

  		return function () {

  			var hasSuper = ("_super" in this),
  			    _super = this._super,
  			    result;

  			this._super = superMethod;

  			result = method.apply(this, arguments);

  			if (hasSuper) {
  				this._super = _super;
  			}

  			return result;
  		};
  	} else {
  		return method;
  	}
  };

  function needsSuper(method, superMethod) {
  	return typeof superMethod === "function" && /_super/.test(method);
  }

  var unwrapExtended = unwrap;

  function unwrap(Child) {
  	var options = {};

  	while (Child) {
  		addRegistries(Child, options);
  		addOtherOptions(Child, options);

  		if (Child._Parent !== _Ractive) {
  			Child = Child._Parent;
  		} else {
  			Child = false;
  		}
  	}

  	return options;
  }

  function addRegistries(Child, options) {
  	config_registries.forEach(function (r) {
  		addRegistry(r.useDefaults ? Child.prototype : Child, options, r.name);
  	});
  }

  function addRegistry(target, options, name) {
  	var registry,
  	    keys = Object.keys(target[name]);

  	if (!keys.length) {
  		return;
  	}

  	if (!(registry = options[name])) {
  		registry = options[name] = {};
  	}

  	keys.filter(function (key) {
  		return !(key in registry);
  	}).forEach(function (key) {
  		return registry[key] = target[name][key];
  	});
  }

  function addOtherOptions(Child, options) {
  	Object.keys(Child.prototype).forEach(function (key) {
  		if (key === "computed") {
  			return;
  		}

  		var value = Child.prototype[key];

  		if (!(key in options)) {
  			options[key] = value._method ? value._method : value;
  		}

  		// is it a wrapped function?
  		else if (typeof options[key] === "function" && typeof value === "function" && options[key]._method) {

  			var result = undefined,
  			    needsSuper = value._method;

  			if (needsSuper) {
  				value = value._method;
  			}

  			// rewrap bound directly to parent fn
  			result = wrapMethod(options[key]._method, value);

  			if (needsSuper) {
  				result._method = result;
  			}

  			options[key] = result;
  		}
  	});
  }

  var _extend = _extend__extend;

  function _extend__extend() {
  	for (var _len = arguments.length, options = Array(_len), _key = 0; _key < _len; _key++) {
  		options[_key] = arguments[_key];
  	}

  	if (!options.length) {
  		return extendOne(this);
  	} else {
  		return options.reduce(extendOne, this);
  	}
  }

  function extendOne(Parent) {
  	var options = arguments[1] === undefined ? {} : arguments[1];

  	var Child, proto;

  	// if we're extending with another Ractive instance...
  	//
  	//   var Human = Ractive.extend(...), Spider = Ractive.extend(...);
  	//   var Spiderman = Human.extend( Spider );
  	//
  	// ...inherit prototype methods and default options as well
  	if (options.prototype instanceof _Ractive) {
  		options = unwrapExtended(options);
  	}

  	Child = function (options) {
  		if (!(this instanceof Child)) return new Child(options);
  		initialise(this, options);
  	};

  	proto = create(Parent.prototype);
  	proto.constructor = Child;

  	// Static properties
  	defineProperties(Child, {
  		// alias prototype as defaults
  		defaults: { value: proto },

  		// extendable
  		extend: { value: _extend__extend, writable: true, configurable: true },

  		// Parent - for IE8, can't use Object.getPrototypeOf
  		_Parent: { value: Parent }
  	});

  	// extend configuration
  	config_config.extend(Parent, proto, options);

  	custom_data.extend(Parent, proto, options);

  	if (options.computed) {
  		proto.computed = utils_object__extend(create(Parent.prototype.computed), options.computed);
  	}

  	Child.prototype = proto;

  	return Child;
  }

  var getNodeInfo = function (node) {
  	var info = {},
  	    priv,
  	    indices;

  	if (!node || !(priv = node._ractive)) {
  		return info;
  	}

  	info.ractive = priv.root;
  	info.keypath = priv.keypath.str;
  	info.index = {};

  	// find all index references and resolve them
  	if (indices = Resolvers_findIndexRefs(priv.proxy.parentFragment)) {
  		info.index = Resolvers_findIndexRefs.resolve(indices);
  	}

  	return info;
  };

  var Ractive, properties;

  // Main Ractive required object
  Ractive = function (options) {
  	if (!(this instanceof Ractive)) return new Ractive(options);
  	initialise(this, options);
  };

  // Ractive properties
  properties = {

  	// debug flag
  	DEBUG: { writable: true, value: true },
  	DEBUG_PROMISES: { writable: true, value: true },

  	// static methods:
  	extend: { value: _extend },
  	getNodeInfo: { value: getNodeInfo },
  	parse: { value: _parse },

  	// Namespaced constructors
  	Promise: { value: utils_Promise },

  	// support
  	svg: { value: svg },
  	magic: { value: environment__magic },

  	// version
  	VERSION: { value: "0.7.3" },

  	// Plugins
  	adaptors: { writable: true, value: {} },
  	components: { writable: true, value: {} },
  	decorators: { writable: true, value: {} },
  	easing: { writable: true, value: static_easing },
  	events: { writable: true, value: {} },
  	interpolators: { writable: true, value: static_interpolators },
  	partials: { writable: true, value: {} },
  	transitions: { writable: true, value: {} }
  };

  // Ractive properties
  defineProperties(Ractive, properties);

  Ractive.prototype = utils_object__extend(prototype, config_defaults);

  Ractive.prototype.constructor = Ractive;

  // alias prototype as defaults
  Ractive.defaults = Ractive.prototype;

  // Ractive.js makes liberal use of things like Array.prototype.indexOf. In
  // older browsers, these are made available via a shim - here, we do a quick
  // pre-flight check to make sure that either a) we're not in a shit browser,
  // or b) we're using a Ractive-legacy.js build
  var FUNCTION = "function";

  if (typeof Date.now !== FUNCTION || typeof String.prototype.trim !== FUNCTION || typeof Object.keys !== FUNCTION || typeof Array.prototype.indexOf !== FUNCTION || typeof Array.prototype.forEach !== FUNCTION || typeof Array.prototype.map !== FUNCTION || typeof Array.prototype.filter !== FUNCTION || typeof window !== "undefined" && typeof window.addEventListener !== FUNCTION) {
  	throw new Error("It looks like you're attempting to use Ractive.js in an older browser. You'll need to use one of the 'legacy builds' in order to continue - see http://docs.ractivejs.org/latest/legacy-builds for more information.");
  }

  var _Ractive = Ractive;

  return _Ractive;

}));
//# sourceMappingURL=ractive.js.map
;
define('RedmarinePartials',[], function () {return {"addToCartloader":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"loading-overlay-loader-cart"},"f":[{"t":7,"e":"img","a":{"src":"/opfiles/Shop/Consumer/Assets/Images/simbyo/spinner_large.gif","style":"z-index: 1300; margin: 0 auto;padding: 2em 1em 1em 1em;border-radius: 0.885em;"}}," ",{"t":7,"e":"h5","f":["Adding to cart"]}]}," ",{"t":7,"e":"div","a":{"class":"loading-overlay-cart"}}]},"authenticationFormsForgotPasswordRightNavBlock":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"column_content"},"f":[{"t":7,"e":"div","a":{"class":"iWantToHome"},"f":[{"t":7,"e":"div","a":{"class":"pie"},"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":["I want to ..."]}," ",{"t":7,"e":"hr"}," ",{"t":7,"e":"ul","f":[{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"href":"https://secure.optus.com.au/paymybill/"},"f":["Pay any Optus Bill"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"href":"/customercentre/myaccount/billingandpayments/paymybill"},"f":["Pay my Optus Bill"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"href":"/recharge"},"f":["Recharge any Optus Service"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"href":"/Activate"},"f":["Activate my prepaid service"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"href":"/ActivatePostPaid"},"f":["Activate my postpaid service"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"href":"/customercentre/myaccount/myservices"},"f":["View my usage"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"href":"/customercentre/myaccount/billingandpayments/me2ucredittransfer"},"f":["Me2U credit transfers"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"href":"/TrackOrders"},"f":["Track my orders"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"href":"https://memberservices.optuszoo.com.au/"},"f":["Member services"]}]}]}]}]}]}]}]},"authenticationFormsTermsAndConditions":{"v":3,"t":[{"t":7,"e":"p","f":["Yes Crowd - Terms of Service"]}," ",{"t":7,"e":"p","f":["These terms apply to your use of Yes Crowd website (\"Website\"). By registering and using the Website, you agree to be bound by these terms, the Optus Terms of Use, the Optus Copyright Notice, the Optus Privacy Policy and the Yes Crowd Guidelines."]}," ",{"t":7,"e":"ol","f":[{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["Establishing an account"]}," ",{"t":7,"e":"ol","f":[{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["To post material on the Website you agree to provide true, accurate, current and complete information about yourself as required by the application form (\"Your Details\") and maintain and update Your Details to keep it true, accurate, current and complete. You agree that you are over 18 years old or that your parent or guardian has consented to your registering as a user of the Website and supervises your use of the Website. You must not provide a user name that is the name of another person with the intent to impersonate that person."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["You are responsible for maintaining the confidentiality of Your Details and are responsible for all acts that occur in relation to your account."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["Optus may suspend or terminate your account if you provide any information that is untrue, inaccurate, not current or incomplete, or Optus has a reasonable basis to believe that such information is untrue, inaccurate, not current or incomplete."]}]}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["Your privacy"]}," ",{"t":7,"e":"ol","f":[{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["Optus will deal with Your Details and other personal information in accordance with Optus' Privacy Policy (as amended from time to time). Optus' Privacy Policy may be viewed at http://www.optus.com.au/portal/site/aboutoptus/menuitem.813c6f701cee5a14f0419f108 c8ac7a0/?vgnextoid=0aaba47491954010VgnVCM10000029a67c0aRCRD."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["If you register and use this Website, your communications with Optus may result in the transfer of information (including Your Details) outside of Australia. By visiting this Website and communicating electronically with us, you consent to such transfers."]}]}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["Use of the Website"]}," ",{"t":7,"e":"ol","f":[{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["You are responsible for the content of all material that you post or link to on the Website (\"Material\"). Optus claims no ownership or control over any Material submitted, posted or displayed by you and does not endorse or approve such Material nor any links to third party sites."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["You are responsible for ensuring that your Material:"]}," ",{"t":7,"e":"ol","f":[{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["does not contain prohibited, unlawful or inappropriate material including, but not limited to, material that may be of a defamatory, threatening and/or offensive nature;"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["is not threatening or harassing toward others;"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["does not infringe the rights of any third party, including but not limited to their intellectual property rights;"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["does not promote commercial activities or constitute spam;"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["does not contain any personal information or passwords, or the personal details of others such as phone numbers, mail or email addresses;"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["does not contain anything which is false, misleading or deceptive; and"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["does not contain viruses or any other form of malware."]}]}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["You agree that Optus may access and disclose Your Details and your Material if required to do so by law or Optus has reasonable grounds for believing that it is necessary to:"]}," ",{"t":7,"e":"ol","f":[{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["comply with law;"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["respond to claims that any Material infringes a third party's rights;"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["respond to your requests for customer service; or"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["protect the rights of Optus or others."]}]}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["Subject to clause 3.1, you acknowledge that Optus retains ownership of all content on the Website, its licensors or registered users. You may not use, copy, download, modify, adapt, distribute, transmit, broadcast, communicate or exploit any content on the Website."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["By posting Material on Website which is intended to be available to the members of the public, you grant Optus and others a non-exclusive, royalty-free, transferable, sublicensable, worldwide licence to reproduce, adapt, modify, publish and distribute such Material without requiring a right of attribution to you."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["You acknowledge and agree that your use of the Website is at your own risk."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["You must not collect other users' content or other information on the Website using automated means."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["Optus may contact you about your Material or edit your postings."]}]}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["Optus' rights"]}]}]}," ",{"t":7,"e":"p","f":["Optus may restrict, suspend or terminate your use of the Website if it believes that you have breached any of these terms."]}," ",{"t":7,"e":"ol","a":{"start":"5"},"f":[{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["Liability and indemnity"]}," ",{"t":7,"e":"ol","f":[{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["You agree that to the extent permitted by law Optus excludes all liability to you of any kind (including, without limitation, direct and consequential losses) under any circumstances (including, without limitation, negligence) in connection with your use of the Website, these terms and your Material."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["Nothing in these terms limits or excludes any non-excludable rights you may have or nonexcludable terms that may be implied under the law of New South Wales or the Commonwealth of Australia."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["You agree to indemnify Optus against any third party claims, losses, damages or costs suffered or incurred by Optus in connection with any breach of these terms by you or any laws relating to your use of Website."]}]}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["General"]}," ",{"t":7,"e":"ol","f":[{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["These terms apply to the Website and your use of it. These terms constitute the entire agreement between you and Optus with respect to your use of the Website."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["Optus may vary these terms from time to time."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"p","f":["These terms are governed by the laws of the state of New South Wales, Australia. You agree to submit to the non-exclusive jurisdiction of the courts of New South Wales and the Commonwealth of Australia and agree that any proceedings must be heard in those courts."]}]}]}]}]}]},"bannerWrappersBackground":{"v":3,"t":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperBackground"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t",{"t":3,"r":"scriptForBackground"},"\n\t\t"]}],"n":50,"r":"scriptForBackground"}]}]},"bannerWrappersBodycopy":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"bodycopy"},"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperDescription"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t",{"t":3,"r":"scriptForDescription"},"\n\t\t\t\t"]}],"n":50,"r":"scriptForDescription"}]}]}],"n":50,"r":"wrapperDescription"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"bodycopy no-wrapper"},"f":[{"t":3,"r":"text.description"}]}],"n":50,"r":"text.description"}],"r":"wrapperDescription"}]},"bannerWrappersCta":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperCta"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t",{"t":3,"r":"scriptForCta"},"\n\t\t\t"]}],"n":50,"r":"scriptForCta"}]}],"n":50,"r":"wrapperCta"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-cta","a":{"style":[{"t":2,"r":"style"}],"text":[{"t":2,"r":"text"}],"type":[{"t":2,"r":"type"}],"link":[{"t":2,"r":"link"}],"target":[{"t":2,"r":"target"}]}}],"n":50,"r":"cta"}],"r":"wrapperCta"}]},"bannerWrappersCuratorText":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":[{"t":2,"r":"curatorClass"}]},"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperCuratorText"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t",{"t":3,"r":"scriptForCuratorText"},"\n\t\t\t\t"]}],"n":50,"r":"scriptForCuratorText"}]}]}],"n":50,"r":"wrapperCuratorText"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":[{"t":2,"r":"curatorClass"}]},"f":[{"t":3,"r":"text.curatorText"}]}],"n":50,"r":"text.curatorText"}],"r":"wrapperCuratorText"}]},"bannerWrappersDescription":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":[{"t":2,"r":"descriptionClass"}]},"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperDescription"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t",{"t":3,"r":"scriptForDescription"},"\n\t\t\t\t"]}],"n":50,"r":"scriptForDescription"}]}]}],"n":50,"r":"wrapperDescription"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":[{"t":2,"r":"descriptionClass"}]},"f":[{"t":3,"r":"text.description"}]}],"n":50,"r":"text.description"}],"r":"wrapperDescription"}]},"bannerWrappersIcon":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperIcon"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t",{"t":3,"r":"scriptForIcon"},"\n\t\t\t"]}],"n":50,"r":"scriptForIcon"}]}],"n":50,"r":"wrapperIcon"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icon.name"}],"size":[{"t":2,"r":"icon.size"}],"color":[{"t":2,"r":"icon.color"}]}}],"n":50,"r":"icon"}],"r":"wrapperIcon"}]},"bannerWrappersImage":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperImage"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t",{"t":3,"r":"scriptForImage"},"\n\t\t\t"]}],"n":50,"r":"scriptForImage"}]}],"n":50,"r":"wrapperImage"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-image-srcset"}],"n":50,"r":"image.src"}],"r":"wrapperImage"}]},"bannerWrappersProductName":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":"product-name"},"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperName"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t",{"t":3,"r":"scriptForWrapperName"},"\n\t\t\t\t"]}],"n":50,"r":"scriptForWrapperName"}]}]}],"n":50,"r":"wrapperName"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":"product-name"},"f":[{"t":3,"r":"product.name"},{"t":3,"r":"wrapperProductName"}]}],"n":50,"r":"product.name"}],"r":"wrapperName"}]},"bannerWrappersProductPrice":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"price"},"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperPrice"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t",{"t":3,"r":"scriptForWrapperPrice"},"\n\t\t\t\t"]}],"n":50,"r":"scriptForWrapperPrice"}]}]}],"n":50,"r":"wrapperPrice"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"price"},"f":[{"t":8,"r":"currencySymbol"},{"t":3,"r":"product.price"},{"t":3,"r":"wrapperPrice"}]}],"n":50,"r":"product.price"}],"r":"wrapperPrice"}]},"bannerWrappersProductSpecification":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ul","a":{"class":"specification-block"},"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperSpecification"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t",{"t":3,"r":"scriptForWrapperSpecification"},"\n\t\t\t\t"]}],"n":50,"r":"scriptForWrapperSpecification"}]}]}],"n":50,"r":"wrapperSpecification"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ul","a":{"class":"specification-block"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":3,"r":"."}]}],"r":"product.specification"}," ",{"t":3,"r":"wrapperSpecification"}]}],"n":50,"r":"product.specification"}],"r":"wrapperSpecification"}]},"bannerWrappersProductUnit":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"unit"},"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperUnit"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t",{"t":3,"r":"scriptForWrapperUnit"},"\n\t\t\t\t"]}],"n":50,"r":"scriptForWrapperUnit"}]}]}],"n":50,"r":"wrapperUnit"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"unit"},"f":[{"t":3,"r":"product.unit"},{"t":3,"r":"wrapperUnit"}]}],"n":50,"r":"product.unit"}],"r":"wrapperUnit"}]},"bannerWrappersSticker":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperSticker"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t",{"t":3,"r":"scriptForSticker"},"\n\t\t\t"]}],"n":50,"r":"scriptForSticker"}]}],"n":50,"r":"wrapperSticker"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-sticker-promo"}],"n":50,"r":"sticker"}],"r":"wrapperSticker"}]},"bannerWrappersSubTitle":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"class":[{"t":2,"r":"subTitleClass"}],"level":[{"t":2,"r":"subTitleLevel"}]},"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperSubtitle"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t",{"t":3,"r":"scriptForSubtitle"},"\n\t\t\t\t"]}],"n":50,"r":"scriptForSubtitle"}," ",{"t":7,"e":"wrapper","f":[]}]}]}],"n":50,"r":"wrapperSubtitle"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"class":[{"t":2,"r":"subTitleClass"}],"level":[{"t":2,"r":"subTitleLevel"}]},"f":[{"t":3,"r":"text.subtitle"}]}],"n":50,"r":"text.subtitle"}],"r":"wrapperSubtitle"}]},"bannerWrappersTitle":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"class":[{"t":2,"r":"titleClass"}],"level":[{"t":2,"r":"titleLevel"}]},"f":[{"t":7,"e":"wrapper","f":[{"t":3,"r":"wrapperTitle"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t",{"t":3,"r":"scriptForTitle"},"\n\t\t\t\t"]}],"n":50,"r":"scriptForTitle"}," ",{"t":7,"e":"wrapper","f":[]}]}]}],"n":50,"r":"wrapperTitle"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"class":[{"t":2,"r":"titleClass"}],"level":[{"t":2,"r":"titleLevel"}]},"f":[{"t":3,"r":"text.title"}]}],"n":50,"r":"text.title"}],"r":"wrapperTitle"}]},"btnPrimaryCallToAction":{"v":3,"t":[{"t":7,"e":"input","a":{"type":"submit","href":[{"t":2,"r":"actionUrl"}],"class":["button radius ",{"t":2,"r":"cssClass"}],"value":[{"t":2,"r":"text"}]}}]},"bundleBuilderNavigationActions":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"a","v":{"tap":{"n":"handleBack","d":[{"t":2,"r":"module"}]}},"f":[{"t":7,"e":"ux-icon","a":{"type":"arrow-left","size":"xs"}},"Back"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"a","v":{"tap":{"n":"resetModule","d":[{"t":2,"r":"module"}]}},"f":[{"t":7,"e":"ux-icon","a":{"type":"close","size":"xs"}},"Cancel"]}]}]}]},"bundleBuilderStepCustomise":{"v":3,"t":[{"t":7,"e":"ux-panel","f":[{"t":8,"r":"bundleBuilderNavigationActions"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":["Customise Device"]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"a","a":{"class":"button"},"v":{"tap":{"n":"continueFlow","d":[{"t":2,"r":"module"}]}},"f":["Continue Flow"]}]}]}]}]},"bundleBuilderStepDevice":{"v":3,"t":[{"t":7,"e":"ux-panel","f":[{"t":8,"r":"bundleBuilderNavigationActions"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":["Device"]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"a","a":{"class":"button"},"v":{"tap":{"n":"continueFlow","d":[{"t":2,"r":"module"}]}},"f":["Continue Flow"]}]}]}]}]},"bundleBuilderStepDeviceOrPlan":{"v":3,"t":[{"t":7,"e":"ux-panel","f":[{"t":8,"r":"bundleBuilderNavigationActions"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":["Phone or Plan"]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-tabarea","a":{"module":[{"t":2,"r":"module"}]},"f":[{"t":7,"e":"ux-tablinks","f":[{"t":7,"e":"ux-tablink","a":{"active":"true"},"f":["Devices"]}," ",{"t":7,"e":"ux-tablink","f":["Plans"]}]}," ",{"t":7,"e":"ux-tabpanes","a":{"module":[{"t":2,"r":"module"}]},"f":[{"t":7,"e":"ux-tabpane","f":[{"t":7,"e":"a","a":{"class":"button"},"v":{"tap":{"n":"startFlow","d":[{"t":2,"x":{"r":[],"s":"\"device\""}},", ",{"t":2,"r":"module"}]}},"f":["Device Selected"]}]}," ",{"t":7,"e":"ux-tabpane","f":[{"t":7,"e":"a","a":{"class":"button"},"v":{"tap":{"n":"startFlow","d":[{"t":2,"x":{"r":[],"s":"\"plan\""}},", ",{"t":2,"r":"module"}]}},"f":["Plan Selected"]}]}]}]}]}]}]}]},"bundleBuilderStepDeviceOrSim":{"v":3,"t":[{"t":7,"e":"ux-panel","f":[{"t":8,"r":"bundleBuilderNavigationActions"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":["What are you after?"]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6 medium-5 medium-offset-1"},"f":[{"t":7,"e":"a","a":{"name":"deviceOrPlan"},"v":{"tap":{"n":"setPartial","d":[{"t":2,"x":{"r":[],"s":"\"deviceOrPlan\""}},",",{"t":2,"r":"module"}]}},"f":[{"t":7,"e":"ux-carousel-navigation-block","a":{"datamodel":[{"t":3,"r":"data.deviceOrPlan"}]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 medium-5 medium-pull-1"},"f":[{"t":7,"e":"a","a":{"name":"sim"},"v":{"tap":{"n":"startFlow","d":[{"t":2,"x":{"r":[],"s":"\"sim\""}},",",{"t":2,"r":"module"}]}},"f":[{"t":7,"e":"ux-carousel-navigation-block","a":{"datamodel":[{"t":3,"r":"data.sim"}]}}]}]}]}]}]}]}]},"bundleBuilderStepLanding":{"v":3,"t":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-2 medium-1"},"f":[{"t":7,"e":"ux-icon","a":{"size":"l","class":"vertical-align-middle","type":[{"t":2,"r":"content.icon"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 medium-6"},"f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":[{"t":2,"r":"content.title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":[{"t":7,"e":"a","v":{"tap":{"n":"setPartial","d":[{"t":2,"x":{"r":[],"s":"\"deviceOrSim\""}},",",{"t":2,"r":"module"}]}},"f":[{"t":7,"e":"ux-icon","a":{"size":"m","class":"vertical-align-middle","type":"arrow-right"}},"Choose"]}]}]}]}]},"bundleBuilderStepPlans":{"v":3,"t":[{"t":7,"e":"ux-panel","f":[{"t":8,"r":"bundleBuilderNavigationActions"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":["Plans: ",{"t":2,"r":"data.planType"}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"a","a":{"class":"button"},"v":{"tap":{"n":"continueFlow","d":[{"t":2,"r":"module"}]}},"f":["Continue Flow"]}]}]}]}]},"bundleBuilderStepSummary":{"v":3,"t":[{"t":7,"e":"ux-panel","f":[{"t":8,"r":"bundleBuilderNavigationActions"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":["Summary"]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"a","a":{"class":"button"},"v":{"tap":{"n":"setPartial","d":[{"t":2,"x":{"r":[],"s":"\"landing\""}},", ",{"t":2,"r":"module"}]}},"f":["Back to start"]}]}]}]}]},"cashByOptusCompatibilityTest":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"step-2"},"f":[{"t":7,"e":"ux-row","a":{"class":"panel light-panel"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 "},"f":[{"t":3,"r":"compatibilityText"}]}]}]}],"n":50,"x":{"r":["isPartialVisible"],"s":"_0(\"compatibilityTest\")"}}]},"cashByOptusCustomerType":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"panel light-panel selector-1"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"h4","f":[{"t":3,"r":"content.q1_title"}]}]}," ",{"t":7,"e":"ul","a":{"class":"tabs columns small-12 row-spacer-top","role":"tablist"},"f":[{"t":7,"e":"li","a":{"class":["tab-title columns large-6 medium-6 small-12 ",{"t":4,"f":["active"],"n":50,"x":{"r":["customer_type"],"s":"_0==\"existing\""}}]},"f":[{"t":7,"e":"a","a":{"href":"#existing-customer","class":"columns small-12","role":"tab"},"v":{"tap":"existingCustomerCheck"},"f":[{"t":3,"r":"content.existing_customer_btn_text"}]}]}," ",{"t":7,"e":"li","a":{"class":["tab-title columns large-6 medium-6 small-12 ",{"t":4,"f":["active"],"n":50,"x":{"r":["customer_type"],"s":"_0==\"new\""}}]},"f":[{"t":7,"e":"a","a":{"class":"columns small-12","href":"#new-to-optus","role":"tab"},"v":{"tap":"newCustomerCheck"},"f":[{"t":3,"r":"content.new_customer_btn_text"}]}]}]}]}],"n":50,"x":{"r":["isPartialVisible"],"s":"_0(\"customerType\")"}}]},"cashByOptusDeviceByo":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"panel light-panel selector-3"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"h4","f":[{"t":3,"r":"content.q3_title"}]}]}," ",{"t":7,"e":"ul","a":{"class":"tabs columns small-12 row-spacer-top","role":"tablist"},"f":[{"t":7,"e":"li","a":{"class":["tab-title columns large-6 medium-6 small-12 ",{"t":4,"f":["active"],"n":50,"x":{"r":["device_type"],"s":"_0==\"new\""}}]},"f":[{"t":7,"e":"a","a":{"href":"#new-device","class":"columns small-12","role":"tab"},"v":{"tap":"newDeviceCheck"},"f":[{"t":3,"r":"content.new_device_btn_text"}]}]}," ",{"t":7,"e":"li","a":{"class":["tab-title columns large-6 medium-6 small-12 ",{"t":4,"f":["active"],"n":50,"x":{"r":["device_type"],"s":"_0==\"byo\""}}]},"f":[{"t":7,"e":"a","a":{"class":"columns small-12","href":"#byo","role":"tab"},"v":{"tap":"byoDeviceCheck"},"f":[{"t":3,"r":"content.byo_btn_text"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"hr"}," ",{"t":7,"e":"input","a":{"type":"button","value":"Next","class":"q3-next-btn button yellow radius large-6 medium-6 small-12"},"v":{"tap":"goToNextStep"}}]}],"n":50,"x":{"r":["device_type"],"s":"_0==\"new\""}}]}],"n":50,"x":{"r":["isPartialVisible"],"s":"_0(\"deviceByo\")"}}]},"cashByOptusDeviceSelection":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"panel light-panel selector-4"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"h4","f":[{"t":3,"r":"content.handset_search_section_title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"form","a":{"class":"search-form","autocomplete":"off"},"f":[{"t":7,"e":"fieldset","f":[{"t":7,"e":"label","a":{"for":"globalSearchInput","class":"hide"},"f":["Search"]}," ",{"t":7,"e":"div","a":{"class":"input-group"},"f":[{"t":7,"e":"ux-autocomplete","a":{"class":"search-input","name":"query","value":[{"t":2,"r":"searchValue"}],"source":[{"t":2,"r":"deviceList"}],"queryParameter":"query","placeholder":[{"t":2,"r":"content.handset_search_box_placeholder"}],"limit":"0","responseKeyPath":"data","responseTitleField":"Title","allowScrolling":"false","showSuggestions":"true","typeaheadOption":"true","filter":"true","staticSource":"true"},"f":[]}," ",{"t":7,"e":"input","a":{"class":"button radius ico ico-only ico-search btn-submit","type":"button","title":"Search","value":"Search","style":"display:none"},"v":{"click":"goToNextStep"}}]}," ",{"t":7,"e":"span","a":{"class":[{"t":4,"f":["hide"],"n":50,"x":{"r":["selectedDevice.deviceName","searchValue"],"s":"_0==_1"}}]},"f":[{"t":3,"r":"content.handset_search_section_reminder_text"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 btn-next-step"},"f":[{"t":7,"e":"hr"}," ",{"t":7,"e":"input","a":{"type":"button","value":"Next","class":"search-next-btn button yellow radius large-6 medium-6 small-12"},"v":{"click":"goToNextStep"}}]}],"n":50,"r":"user_next_confirm"}]}],"n":50,"x":{"r":["isPartialVisible"],"s":"_0(\"deviceSelection\")"}}]},"cashByOptusPlanType":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"panel light-panel panel-spacer-top selector-2"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"h4","f":[{"t":3,"r":"content.q2_title"}]}]}," ",{"t":7,"e":"ul","a":{"class":"tabs columns small-12 row-spacer-top","role":"tablist"},"f":[{"t":7,"e":"li","a":{"class":["tab-title columns large-6 medium-6 small-12 ",{"t":4,"f":["active"],"n":50,"x":{"r":["plan_type"],"s":"_0==\"plan\""}}]},"f":[{"t":7,"e":"a","a":{"href":"#plan","class":"columns small-12","role":"tab"},"v":{"tap":"postpaidCheck"},"f":[{"t":3,"r":"content.postpaid_btn_text"}]}]}," ",{"t":7,"e":"li","a":{"class":["tab-title columns large-6 medium-6 small-12 ",{"t":4,"f":["active"],"n":50,"x":{"r":["plan_type"],"s":"_0==\"prepaid\""}}]},"f":[{"t":7,"e":"a","a":{"class":"columns small-12","href":"#prepaid","role":"tab"},"v":{"tap":"prepaidCheck"},"f":[{"t":2,"r":"content.prepaid_btn_text"}]}]}]}]}],"n":50,"x":{"r":["isPartialVisible"],"s":"_0(\"planType\")"}}]},"cashByOptusCartSim":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4 large-4"},"f":[{"t":7,"e":"ux-panel","a":{"class":["light-panel padding-wrapper cboDevice sim ",{"t":4,"f":["active applied"],"n":50,"r":"deviceTypes.sim.selected"}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"v":{"click":"triggerSimSelected"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 heroImgContainer"},"f":[{"t":7,"e":"img","a":{"src":["/opfiles",{"t":3,"r":"deviceTypes.sim.heroImg"}],"alt":"SIM"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"type":"radio","name":"cboItem","class":"cboApplyBtn","id":["radioCboItemSim",{"t":3,"r":"seed"}],"data-devicetype":[{"t":3,"r":"deviceType"}]},"m":[{"t":4,"f":["checked"],"n":50,"x":{"r":["isDeviceTypeChecked"],"s":"_0(\"sim\")"}}],"v":{"click":"simSelected"}}," ",{"t":7,"e":"label","a":{"for":["radioCboItemSim",{"t":3,"r":"seed"}]},"f":[{"t":3,"r":"data.cmsLookupMap.cboMessages.0.sim_radio_label"}]}],"n":50,"x":{"r":["deviceType"],"s":"_0==\"sim\""}}],"n":52,"r":"data.accessoryList"}]}]}," ",{"t":7,"e":"span","a":{"class":"cboLightboxTrigger icon icon-faq sim_popup_text"}}]}," ",{"t":7,"e":"span","a":{"class":"text"},"f":[{"t":3,"r":"data.cmsLookupMap.cboArticles.sim_copy_text"}]}]}],"n":51,"x":{"r":["isIosDevice"],"s":"_0()"}}]},"cashByOptusCartSticker":{"v":3,"t":[{"t":7,"e":"ux-col","a":{"class":["small-12 ",{"t":4,"f":["medium-6 large-6"],"n":50,"x":{"r":["isIosDevice"],"s":"_0()"}},{"t":4,"n":51,"f":["medium-4 large-4"],"x":{"r":["isIosDevice"],"s":"_0()"}}]},"f":[{"t":7,"e":"ux-panel","a":{"class":["light-panel padding-wrapper cboDevice sticker ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["isDeviceTypeOutOfStock"],"s":"_0(\"sticker\")"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["deviceTypes.sticker.selected"],"s":"_0"},"f":["active"]}],"x":{"r":["isDeviceTypeOutOfStock"],"s":"_0(\"sticker\")"}}," ",{"t":4,"f":["applied"],"n":50,"r":"deviceTypes.sticker.applied"}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"v":{"click":"triggerStickerSelected"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 heroImgContainer"},"f":[{"t":7,"e":"img","a":{"src":["/opfiles",{"t":3,"r":"deviceTypes.sticker.heroImg"}],"alt":"Sticker"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"input","a":{"type":"radio","class":"sticker","name":"cboItem","id":["radioCboItemSticker",{"t":3,"r":"seed"}]},"m":[{"t":4,"f":["disabled"],"n":50,"x":{"r":["isDeviceTypeOutOfStock"],"s":"_0(\"sticker\")"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["isDeviceTypeChecked"],"s":"_0(\"sticker\")"},"f":["checked"]}],"x":{"r":["isDeviceTypeOutOfStock"],"s":"_0(\"sticker\")"}}],"v":{"click":"stickerSelected"}}," ",{"t":7,"e":"label","a":{"for":["radioCboItemSticker",{"t":3,"r":"seed"}]},"f":[{"t":3,"r":"data.cmsLookupMap.cboMessages.0.sticker_radio_label"}]}]}," ",{"t":7,"e":"div","a":{"class":"colourItems"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"colourLabel"},"f":[{"t":3,"x":{"r":["getSelectedDeviceProperty"],"s":"_0(\"colour\")"}}]}],"n":50,"x":{"r":["showColourLabel","deviceTypes.sticker"],"s":"_0(_1,\"sticker\")"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"outer"},"f":[{"t":7,"e":"span","a":{"class":"inner","style":["background-color:",{"t":3,"r":"mediaAsset.supportingHtml"}]}}]}],"n":50,"x":{"r":["deviceType"],"s":"_0==\"sticker\""}}],"n":52,"r":"data.accessoryList"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"outOfStock colour"},"f":["coming soon"]}],"n":50,"x":{"r":["isDeviceComingSoon"],"s":"_0(\"sticker\")"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["isDeviceTypeOutOfStock"],"s":"_0(\"sticker\")"},"f":[{"t":7,"e":"div","a":{"class":"outOfStock type"},"f":["out of stock"]}]},{"t":4,"n":50,"x":{"r":["isDeviceTypeOutOfStock","isColourOutOfStock"],"s":"(!(_0(\"sticker\")))&&(_1(\"sticker\"))"},"f":[" ",{"t":7,"e":"div","a":{"class":"outOfStock colour"},"f":["Colour out of stock"]}]}],"x":{"r":["isDeviceComingSoon"],"s":"_0(\"sticker\")"}}]}," ",{"t":7,"e":"span","a":{"class":"cboLightboxTrigger icon icon-faq sticker_popup_text"}}]}," ",{"t":7,"e":"div","a":{"class":["deviceColorPalettes sticker ",{"t":4,"f":["show"],"n":50,"x":{"r":["showColourPalette","deviceTypes.sticker"],"s":"_0(_1)"}},{"t":4,"n":51,"f":["hide"],"x":{"r":["showColourPalette","deviceTypes.sticker"],"s":"_0(_1)"}}]},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"h5","f":[{"t":3,"r":"data.cmsLookupMap.cboMessages.0.colour_label_text"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"data-model":[{"t":3,"r":"modelNumber"}],"data-devicetype":[{"t":3,"r":"deviceType"}],"class":["cube ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["selected","outOfStock","comingSoon"],"s":"_0&&(_1||_2)"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["selected"],"s":"_0"},"f":["active"]}],"x":{"r":["selected","outOfStock","comingSoon"],"s":"_0&&(_1||_2)"}}],"style":["background-color:",{"t":3,"r":"mediaAsset.supportingHtml"}]},"v":{"tap":"deviceColourSelect"},"f":[{"t":7,"e":"span","a":{"class":"label"},"f":[{"t":3,"r":"colour"}]}]}],"n":50,"x":{"r":["deviceType"],"s":"_0==\"sticker\""}}],"n":52,"r":"data.accessoryList"}]}]}," ",{"t":7,"e":"input","a":{"type":"button","value":[{"t":3,"r":"data.cmsLookupMap.cboMessages.0.apply_button_label"}],"class":["btnApply radius ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["isApplyBtnDisabled"],"s":"_0(\"sticker\")"}},{"t":4,"n":51,"f":["cboApplyBtn"],"x":{"r":["isApplyBtnDisabled"],"s":"_0(\"sticker\")"}}]},"v":{"click":"applyStickerSelection"}}]}]}]}]},"cashByOptusCartWristband":{"v":3,"t":[{"t":7,"e":"ux-col","a":{"class":["small-12 ",{"t":4,"f":["medium-6 large-6"],"n":50,"x":{"r":["isIosDevice"],"s":"_0()"}},{"t":4,"n":51,"f":["medium-4 large-4"],"x":{"r":["isIosDevice"],"s":"_0()"}}]},"f":[{"t":7,"e":"ux-panel","a":{"class":["light-panel padding-wrapper cboDevice wristband ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["isDeviceTypeOutOfStock"],"s":"_0(\"band\")"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["deviceTypes.wristband.selected"],"s":"_0"},"f":["active"]}],"x":{"r":["isDeviceTypeOutOfStock"],"s":"_0(\"band\")"}}," ",{"t":4,"f":["applied"],"n":50,"r":"deviceTypes.wristband.applied"}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"v":{"click":"triggerWristbandSelected"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 heroImgContainer"},"f":[{"t":7,"e":"img","a":{"src":["/opfiles",{"t":3,"r":"deviceTypes.wristband.heroImg"}],"alt":"Wristband"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"input","a":{"type":"radio","name":"cboItem","class":"wristband","id":["radioCboItemWristband",{"t":3,"r":"seed"}]},"m":[{"t":4,"f":["disabled"],"n":50,"x":{"r":["isDeviceTypeOutOfStock"],"s":"_0(\"band\")"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["isDeviceTypeChecked"],"s":"_0(\"band\")"},"f":["checked"]}],"x":{"r":["isDeviceTypeOutOfStock"],"s":"_0(\"band\")"}}],"v":{"click":"wristbandSelected"}}," ",{"t":7,"e":"label","a":{"for":["radioCboItemWristband",{"t":3,"r":"seed"}]},"f":[{"t":3,"r":"data.cmsLookupMap.cboMessages.0.wristband_radio_label"}]}]}," ",{"t":7,"e":"div","a":{"class":"colourItems"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"colourLabel"},"f":[{"t":3,"x":{"r":["getSelectedDeviceProperty"],"s":"_0(\"colour\")"}}]}],"n":50,"x":{"r":["showColourLabel","deviceTypes.wristband"],"s":"_0(_1,\"band\")"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"outer"},"f":[{"t":7,"e":"span","a":{"class":"inner","style":["background-color:",{"t":3,"r":"mediaAsset.supportingHtml"}]}}]}],"n":50,"x":{"r":["deviceType"],"s":"_0==\"band\""}}],"n":52,"r":"data.accessoryList"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"outOfStock colour"},"f":["coming soon"]}],"n":50,"x":{"r":["isDeviceComingSoon"],"s":"_0(\"band\")"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["isDeviceTypeOutOfStock"],"s":"_0(\"band\")"},"f":[{"t":7,"e":"div","a":{"class":"outOfStock type"},"f":["out of stock"]}]},{"t":4,"n":50,"x":{"r":["isDeviceTypeOutOfStock","isColourOutOfStock"],"s":"(!(_0(\"band\")))&&(_1(\"band\"))"},"f":[" ",{"t":7,"e":"div","a":{"class":"outOfStock colour"},"f":["Colour out of stock"]}]}],"x":{"r":["isDeviceComingSoon"],"s":"_0(\"band\")"}}]}," ",{"t":7,"e":"span","a":{"class":"cboLightboxTrigger icon icon-faq wristband_popup_text"}}]}," ",{"t":7,"e":"div","a":{"class":["deviceColorPalettes wristband ",{"t":4,"f":["show"],"n":50,"x":{"r":["showColourPalette","deviceTypes.wristband"],"s":"_0(_1)"}},{"t":4,"n":51,"f":["hide"],"x":{"r":["showColourPalette","deviceTypes.wristband"],"s":"_0(_1)"}}]},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"h5","f":[{"t":3,"r":"data.cmsLookupMap.cboMessages.0.colour_label_text"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"data-model":[{"t":3,"r":"modelNumber"}],"data-devicetype":[{"t":3,"r":"deviceType"}],"class":["cube ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["selected","outOfStock","comingSoon"],"s":"_0&&(_1||_2)"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["selected"],"s":"_0"},"f":["active"]}],"x":{"r":["selected","outOfStock","comingSoon"],"s":"_0&&(_1||_2)"}}],"style":["background-color:",{"t":3,"r":"mediaAsset.supportingHtml"}]},"v":{"tap":"deviceColourSelect"},"f":[{"t":7,"e":"span","a":{"class":"label"},"f":[{"t":3,"r":"colour"}]}]}],"n":50,"x":{"r":["deviceType"],"s":"_0==\"band\""}}],"n":52,"r":"data.accessoryList"}]}]}," ",{"t":7,"e":"input","a":{"type":"button","value":[{"t":3,"r":"data.cmsLookupMap.cboMessages.0.apply_button_label"}],"class":["btnApply radius ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["isApplyBtnDisabled"],"s":"_0(\"band\")"}},{"t":4,"n":51,"f":["cboApplyBtn"],"x":{"r":["isApplyBtnDisabled"],"s":"_0(\"band\")"}}]},"v":{"click":"applyWristbandSelection"}}]}]}]}]},"ccaLandingManagePreferences":{"v":3,"t":[{"t":7,"e":"ux-panel","a":{"class":"caption unsubscribe-verification-text"},"f":[{"t":7,"e":"strong","f":["Want to control how Optus communicates with you?"]},{"t":7,"e":"br"}," ",{"t":7,"e":"p","a":{"class":"caption unsubscribe-verification-text"},"f":["Manage your communication preferences and profile details in one place."]}," ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"data.managePreferencesUrl"}],"class":"expand button-manage-preferences button radius","role":"button"},"f":["Manage preferences"]}]}]},"ccaLandingSection":{"v":3,"t":[{"t":7,"e":"li","a":{"class":"tile","data-equalizer-watcher":"tiles"},"t1":"equalizer","f":[" ",{"t":7,"e":"a","a":{"class":"tile__link","href":[{"t":2,"r":"href"}]},"f":[{"t":7,"e":"ux-header","a":{"class":"tile__title","level":"5"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"ux-icon","a":{"class":"tile__icon","size":"xl","type":[{"t":2,"r":"icon"}]}}," ",{"t":7,"e":"p","a":{"class":"caption"},"f":[{"t":2,"r":"description"}]}]}]}]},"ccaLandingServerError":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"red-panel caption no-border"},"f":[{"t":7,"e":"h5","f":["Not sure what happened"]}," ",{"t":2,"r":"error"}]}],"n":50,"r":"error"}]},"ccaLandingSubscription":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"cca-subscription"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscription-category"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"subscriptionCategory"}]}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscription"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"name"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"ux-toggle","a":{"subscriptionCategory":[{"t":2,"r":"subscriptionCategory"}],"subscriptionIndex":[{"t":2,"r":"subscriptionIndex"}],"checked":[{"t":3,"rx":{"r":"data.subscriptionMap","m":[{"t":30,"n":"subscriptionCategory"},{"t":30,"n":"subscriptionIndex"},{"t":30,"n":"subscriptionData.subscriptionContact"},"optedIn"]}}],"onclick":"switchSubscriptionStatus"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"hr","a":{"class":"collapse-top"}}]}]}]}],"n":50,"rx":{"r":"data.subscriptionMap","m":[{"t":30,"n":"subscriptionCategory"},{"t":30,"n":"subscriptionIndex"},{"t":30,"n":"subscriptionData.subscriptionChannelAvailable"}]}}],"n":52,"i":"subscriptionIndex","r":"."}]}],"n":52,"i":"subscriptionCategory","r":"data.subscriptionMap"}]}]},"ccaLoadingSpinner":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cca-loading-spinner text-center"},"f":[{"t":7,"e":"ux-spinner"}]}],"n":50,"r":"status"}]},"ccaPanelError":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"cca-message-panel cca-message-panel-error"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":"cca-message-panel-heading"},"f":[{"t":7,"e":"b","f":[{"t":2,"x":{"r":["title"],"s":"_0||\"Something went wrong!\""}},{"t":7,"e":"b"}]}]}," ",{"t":7,"e":"div","a":{"class":["cca-message-panel-message caption ",{"t":2,"r":"class"}]},"f":[{"t":2,"r":"message"}]}]}]}]}],"n":50,"r":"message"}]},"ccaPanelSuccess":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"cca-message-panel cca-message-panel-success"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":["cca-message-panel-message caption ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"ux-icon","a":{"type":"success-alert","size":"xs"}}," ",{"t":2,"r":"message"}]}]}]}]}],"n":50,"r":"message"}]},"ccaProfileCategory":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"hr","a":{"class":"accordion-separator"}}]}]}],"n":50,"x":{"r":["@index"],"s":"_0>0"}},{"t":7,"e":"ux-accordionitem","a":{"active":[{"t":2,"rx":{"r":"accordionStates","m":[{"t":30,"n":"@key"}]}}],"accordionKey":[{"t":2,"r":"@key"}],"class":[{"t":2,"x":{"r":["kebabCase",".categoryName"],"s":"_0(_1)"}}]},"f":[{"t":7,"e":"ux-anchor","a":{"class":"title-link"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 medium-1 text-left"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":["icon ",{"t":2,"r":"categoryCSSClass"}]}}],"n":50,"r":"categoryCSSClass"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-8 medium-9"},"f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":".categoryName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 text-right"},"f":[{"t":7,"e":"span","a":{"class":"icon-arrow icon-arrow-up"}}," ",{"t":7,"e":"span","a":{"class":"icon-arrow icon-arrow-down"}}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"category-content","active":[{"t":2,"rx":{"r":"accordionStates","m":[{"t":30,"n":"@key"}]}}]},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-content","a":{"class":"widget-content"},"f":[{"t":8,"r":".partial"}]}]}]}]}]}]},"ccaProfileChangeAccountInfoInputField":{"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"strong","a":{"class":"input-label"},"f":[{"t":2,"r":"title"},{"t":4,"f":[{"t":7,"e":"span","a":{"class":"required-field-asterix"},"f":["*"]}],"n":50,"r":"required"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 ",{"t":2,"r":"fieldBinding"}]},"f":[{"t":7,"e":"input","a":{"type":"text","value":[{"t":2,"rx":{"r":"accountInfoTemp","m":[{"t":30,"n":"fieldBinding"}]}}],"placeholder":[{"t":2,"r":"placeholder"}]}}," ",{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"rx":{"r":"accountInfoTemp","m":[{"r":["fieldBinding"],"s":"_0+\"ErrorMsg\""}]}}]}]}]},"ccaProfileChangeAlternateEmail":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"edit-alt-email"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"updateProfileError"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":7,"e":"div","a":{"class":"modal-text"},"f":[{"t":7,"e":"strong","a":{"class":"modal-text-heading"},"f":["Alternate email"]}," ",{"t":7,"e":"p","f":["You'll need to validate your email address before you log in by clicking on the link which we'll send you."]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"modal-form"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-4"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeAccountInfoInputField"}],"x":{"r":[],"s":"{title:\"Email\",required:true,fieldBinding:\"alternateEmail\",placeholder:\"Enter your alternate email address\"}"}}," ",{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeAccountInfoInputField"}],"x":{"r":[],"s":"{title:\"Confirm Email\",required:true,fieldBinding:\"confirmAlternateEmail\",placeholder:\"Confirm your email address\"}"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-2"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"updateProfile"},"a":{"class":["button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}],"role":"button","directory":"accountInfoTemp","profileDataField":"alternateEmail","field":"alternateEmail"},"f":["Update"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"loadingStatusSpinner"}]}]}]}]},"ccaProfileChangeBillingSms":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"edit-billing-mobile"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"updateProfileError"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":7,"e":"div","a":{"class":"modal-text"},"f":[{"t":7,"e":"strong","a":{"class":"modal-text-heading"},"f":["Change SMS"]}," ",{"t":7,"e":"p","f":["Enter the mobile number for which you want to receive your bill notifications."]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"modal-form update-email-form"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-4"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeAccountInfoInputField"}],"x":{"r":[],"s":"{title:\"Add number\",required:true,fieldBinding:\"billingMobile\",placeholder:\"Enter your new mobile number\"}"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-2"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"updateProfile"},"a":{"class":["submit-form button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}],"role":"button","directory":"accountInfoTemp","profileDataField":"billingMobile","field":"accountInfo.sms"},"f":["Update"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"loadingStatusSpinner"}]}]}]}]},"ccaProfileChangeDateOfBirth":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"update-dob"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"updateProfileError"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":7,"e":"div","a":{"class":"modal-text"},"f":[{"t":7,"e":"strong","a":{"class":"modal-text-heading"},"f":["Date of birth"]}," ",{"t":7,"e":"p","f":["Please ensure you enter the correct date of birth as you will not be able to change it once it's updated."]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"modal-form"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-4"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeAccountInfoInputField"}],"x":{"r":[],"s":"{title:\"Date of birth\",required:true,fieldBinding:\"dob\",placeholder:\"DD/MM/YYYY\"}"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-2"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"updateProfile"},"a":{"class":["button-update-dob button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}],"role":"button","directory":"accountInfoTemp","profileDataField":"dob","field":"dateOfBirth"},"f":["Update"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"loadingStatusSpinner"}]}]}]}]},"ccaProfileChangeEmail":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"edit-email"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"updateLogonEmailError"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":7,"e":"div","a":{"class":"modal-text"},"f":[{"t":7,"e":"strong","a":{"class":"modal-text-heading"},"f":["Change Email"]}," ",{"t":7,"e":"p","f":[{"t":4,"f":["Updating your billing email address will also update your My Account login email address."],"n":50,"x":{"r":["currentSection"],"s":"_0==\"billingEmail\""}},{"t":4,"n":51,"f":["You'll need to validate your email address before you log in by clicking on the link which we'll send you",{"t":7,"e":"br"}," Updating your login email address will also update your billing email address."],"x":{"r":["currentSection"],"s":"_0==\"billingEmail\""}}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"modal-form update-email-form"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-4"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeAccountInfoInputField"}],"x":{"r":[],"s":"{title:\"Add Email\",required:true,fieldBinding:\"emailIdentifier\",placeholder:\"Enter your new email\"}"}}," ",{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeAccountInfoInputField"}],"x":{"r":[],"s":"{title:\"Confirm Email\",required:true,fieldBinding:\"confirmEmailIdentifier\",placeholder:\"Re-enter email\"}"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-2"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"updateLogonEmail"},"a":{"class":["submit-form button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}],"role":"button","directory":"accountInfoTemp","field":"accountInfo.email"},"f":["Update"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"loadingStatusSpinner"}]}]}]}]},"ccaProfileChangeGeneralMarketingChannelAddressForm":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"edit-postal-address edit-modal"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-6"},"f":[{"t":7,"e":"strong","a":{"class":"general-marketing-services-form-title"},"f":["Home address"]},{"t":7,"e":"br"}," Choose the postal mailing address where you want to get information about most of the Optus products."]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"current-postal-address small-12 large-6"},"f":[{"t":7,"e":"p","f":["Current address: ",{"t":7,"e":"b","f":[{"t":2,"r":"channelData.Address.currentValue"}]}]}]}]}],"n":50,"r":"channelData.Address.currentValue"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"add-postal-address small-12 large-4"},"f":[{"t":7,"e":"ux-address","a":{"class":"input-marketing-address","formattedAddress":[{"t":2,"r":"postalAddressDataModel.formattedAddress"}],"manualInput":[{"t":2,"r":"postalAddressDataModel.manualInput"}],"required":[{"t":2,"x":{"r":[],"s":"true"}}],"autocomplete":[{"t":2,"r":"postalAddressDataModel.autocomplete"}],"addressMoniker":[{"t":2,"r":"postalAddressDataModel.addressMoniker"}],"unformattedAddress":[{"t":2,"r":"postalAddressDataModel.unformattedAddress"}],"addressMonikerErrorMsg":[{"t":2,"r":"postalAddressDataModel.addressMonikerErrorMsg"}]}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"r":"postalAddressErrorMsg"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"updatePostalAddress"},"a":{"class":["submit-form button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}],"role":"button","field":"accountInfo.changeUsername"},"f":[{"t":4,"f":["Add address"],"n":50,"x":{"r":["channelData.Address.currentValue"],"s":"!_0"}},{"t":4,"n":51,"f":["Change address"],"x":{"r":["channelData.Address.currentValue"],"s":"!_0"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"closeSection"},"a":{"class":["service-add-button button small radius grey expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}]},"f":["Close"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"loadingStatusSpinner"}]}]}]}]},"ccaProfileChangeGeneralMarketingChannelForm":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"general-marketing-services-form"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":7,"e":"div","a":{"class":"modal-text"},"f":[{"t":7,"e":"strong","a":{"class":"modal-text-heading"},"f":[{"t":3,"r":"title"}]}," ",{"t":7,"e":"p","f":[{"t":4,"f":["Choose the email address where you'd like to receive Optus marketing and promotional communications."],"n":50,"x":{"r":["channel"],"s":"_0===\"Email\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["channel"],"s":"_0===\"SMS\""},"f":["Choose the mobile number where you'd like to receive Optus marketing and promotional SMSs."]}],"x":{"r":["channel"],"s":"_0===\"Email\""}}]}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":7,"e":"ul","a":{"class":"marketing-service-list"},"f":[{"t":4,"f":[{"t":8,"r":"ccaProfileChangeGeneralMarketingChannelFormItem"}],"n":52,"x":{"r":["channelData","listBinding","data.cmdmProfileModel"],"s":"_0.sortServicesByPrimary(_2[_1])"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":7,"e":"ux-panel","a":{"class":"no-border caption"},"f":["We have sent a code to your ",{"t":2,"x":{"r":["channel"],"s":"(_0==\"Email\")?\"email address\":\"mobile number\""}}," ",{"t":2,"r":"appendService_marketing"},", please enter it below to verify."]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":7,"e":"label","a":{"class":"service-verify-label"},"f":["Enter verification code"]}," ",{"t":7,"e":"input","a":{"class":"service-verify-input","type":"text","value":[{"t":2,"r":"appendService_marketing_code"}],"placeholder":"Enter your verification code"}}," ",{"t":7,"e":"div","a":{"class":"service-verify-error"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"r":"appendService_marketing_codeErrorMsg"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-2"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"verifyMarketingService"},"a":{"channel":[{"t":3,"r":"channel"}],"class":["service-verify-button button small radius yellow expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}]},"f":["Verify"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"loadingStatusSpinner"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-2"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"cancelVerifyMarketingService"},"a":{"class":"service-verify-cancel-button button small radius grey expand"},"f":["Cancel"]}]}]}],"n":50,"r":"appendService_marketing_verification"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":7,"e":"label","a":{"class":"service-add-label"},"f":[{"t":4,"f":["Add new email"],"n":50,"x":{"r":["channel"],"s":"_0===\"Email\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["channel"],"s":"_0===\"SMS\""},"f":["Add new mobile number"]},{"t":4,"n":50,"x":{"r":["channel"],"s":"(!(_0===\"SMS\"))&&(_0===\"Phone\")"},"f":[" Add new telephone number"]}],"x":{"r":["channel"],"s":"_0===\"Email\""}}]}," ",{"t":7,"e":"input","a":{"class":"service-add-input","type":"text","value":[{"t":2,"r":"appendService_marketing"}],"placeholder":[{"t":2,"x":{"r":["channel"],"s":"_0===\"Email\"?\"Add email\":\"Add number\""}}]}}," ",{"t":7,"e":"div","a":{"class":"service-error-input"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"r":"appendService_marketingErrorMsg"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"appendMarketingService"},"a":{"channel":[{"t":3,"r":"channel"}],"class":["service-add-button button small radius yellow expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}]},"f":[{"t":4,"f":["Add email"],"n":50,"x":{"r":["channel"],"s":"_0===\"Email\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["channel"],"s":"_0===\"SMS\""},"f":["Add mobile number"]},{"t":4,"n":50,"x":{"r":["channel"],"s":"(!(_0===\"SMS\"))&&(_0===\"Phone\")"},"f":[" Add telephone number"]}],"x":{"r":["channel"],"s":"_0===\"Email\""}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"closeSection"},"a":{"class":["service-add-button button small radius grey expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}]},"f":["Close"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"loadingStatusSpinner"}]}]}],"r":"appendService_marketing_verification"}]}]},"ccaProfileChangeGeneralMarketingChannelFormItem":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"strong","f":[{"t":4,"f":[{"t":2,"x":{"r":["channelData","contact"],"s":"_0.formatPhoneNumber(_1)"}}],"n":50,"r":"phoneNumberType"},{"t":4,"n":51,"f":[{"t":2,"r":"contact"}],"r":"phoneNumberType"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"primary-service"},"f":["(Primary)"]}],"n":50,"r":"primaryFlag"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 caption"},"f":[{"t":7,"e":"span","a":{"class":"service-warning"},"f":["Invalid - Remove and add again"]}]}]}],"n":50,"x":{"r":["invalidFlag","hardBounceFlag"],"s":"_0||_1"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 large-4"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"set-primary-service","channel":[{"t":3,"r":"channel"}],"data":[{"t":3,"r":"contact"}]},"v":{"anchorClicked":"marketingServiceSetPrimary"},"f":["Set as primary"]}],"n":50,"x":{"r":["primaryFlag","invalidFlag","hardBounceFlag"],"s":"!_0&&!_1&&!_2"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-3 text-right"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"remove-service","channel":[{"t":3,"r":"channel"}],"data":[{"t":3,"r":"contact"}]},"v":{"anchorClicked":"removeMarketingService"},"f":["Remove"]}]}],"n":50,"x":{"r":["primaryFlag","invalidFlag","hardBounceFlag"],"s":"!_0||(_0&&(_1||_2))"}}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"hr"}]}]}]}],"n":51,"r":"deleted"}]},"ccaProfileChangeGeneralMarketingChannelItem":{"v":3,"t":[{"t":7,"e":"div","a":{"class":["general-marketing-channel ",{"t":3,"r":"class"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"strong","a":{"class":["general-marketing-channel-title ",{"t":4,"f":["general-marketing-channel-disabled"],"n":50,"x":{"r":["status"],"s":"!_0"}}]},"f":[{"t":2,"r":"title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 text-right"},"f":[{"t":7,"e":"ux-toggle","a":{"class":"master-channel-switch","checked":[{"t":3,"r":"status"}],"channel":[{"t":3,"r":"channel"}],"preferenceBinding":[{"t":3,"r":"preferenceBinding"}],"onclick":"toggleMarketingChannel"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ul","a":{"class":"small-block-grid-1 medium-block-grid-2 preference-service-list"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":8,"r":"ccaProfileChangeGeneralMarketingChannelServiceItem"}],"n":52,"x":{"r":["channelData","listBinding","data.cmdmProfileModel"],"s":"_0.sortServicesByPrimary(_2[_1]).slice(0,3)"}}],"n":50,"x":{"r":["listBinding","data.cmdmProfileModel","expandList"],"s":"_1[_0].length>3&&!_2"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":8,"r":"ccaProfileChangeGeneralMarketingChannelServiceItem"}],"n":52,"x":{"r":["channelData","listBinding","data.cmdmProfileModel"],"s":"_0.sortServicesByPrimary(_2[_1])"}}],"x":{"r":["listBinding","data.cmdmProfileModel","expandList"],"s":"_1[_0].length>3&&!_2"}}," ",{"t":7,"e":"li","f":[{"t":7,"e":"ux-anchor","a":{"class":"add-service","section":[{"t":3,"r":"modalSection"}]},"v":{"anchorClicked":"openSection"},"f":[{"t":3,"r":"addText"}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"show-hide-services"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"show-hide-services-button","channel":[{"t":3,"r":"channel"}]},"v":{"anchorClicked":"toggleMarketingChannelListDisplay"},"f":[{"t":7,"e":"span","a":{"class":["icon-arrow ",{"t":2,"x":{"r":["expandList"],"s":"_0?\"icon-arrow-up\":\"icon-arrow-down\""}}]}}," ",{"t":2,"x":{"r":["expandList","listBinding","data.cmdmProfileModel"],"s":"_0?\"Show 3 only\":(_2[_1].length-3)+\" more services\""}}]}]}]}],"n":50,"x":{"r":["listBinding","data.cmdmProfileModel"],"s":"_1[_0].length>3"}}," ",{"t":7,"e":"hr","a":{"class":"collapse-top collapse-bottom"}}]}]},"ccaProfileChangeGeneralMarketingChannelSecondaryItem":{"v":3,"t":[{"t":7,"e":"div","a":{"class":["general-marketing-channel ",{"t":3,"r":"class"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-6"},"f":[{"t":7,"e":"strong","a":{"class":[{"t":4,"f":["general-marketing-channel-disabled"],"n":50,"r":"disabled"}]},"f":[{"t":2,"r":"title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 large-6"},"f":[{"t":7,"e":"ux-row","a":{"class":["collapse ",{"t":4,"f":["general-marketing-channel-disabled"],"n":50,"r":"disabled"}]},"f":[{"t":7,"e":"ux-col","a":{"class":["channel-current-value ",{"t":2,"x":{"r":["invalidStatus"],"s":"(_0)?\"invalid-service\":\"\""}}]},"f":[{"t":2,"x":{"r":["currentValue"],"s":"_0||\"None provided\""}}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"data-tooltip":0,"aria-haspopup":"true","class":"has-tip","title":"The contact details you've entered are incorrect. Please check and try again."},"f":[{"t":7,"e":"ux-icon","a":{"class":"invalid-service-icon","type":"error-alert","size":"xs"},"f":[]}]}],"n":50,"r":"invalidStatus"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"openSection"},"a":{"section":["marketing",{"t":3,"r":"channel"}],"class":"change-service"},"f":[{"t":4,"f":["Add"],"n":50,"r":"disabled"},{"t":4,"n":51,"f":["Change"],"r":"disabled"}]}]}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 text-right"},"f":[{"t":4,"f":[{"t":7,"e":"ux-toggle","a":{"class":"master-channel-switch","checked":[{"t":3,"r":"status"}],"channel":[{"t":3,"r":"channel"}],"preferenceBinding":[{"t":3,"r":"preferenceBinding"}],"onclick":"toggleMarketingChannel"}}],"n":50,"x":{"r":["disabled"],"s":"!_0"}}]}]}]}]},"ccaProfileChangeGeneralMarketingChannelServiceItem":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-checkbox","a":{"on":[{"t":2,"r":"optedIn"}],"class":"service-item-checkbox","disabled":[{"t":2,"x":{"r":["status"],"s":"!_0"}}],"serviceType":[{"t":3,"r":"channel"}]},"f":[{"t":7,"e":"span","m":[{"t":4,"f":["class=\"service-item-warning\""],"n":50,"x":{"r":["invalidFlag","hardBounceFlag"],"s":"_0||_1"}}],"f":[{"t":4,"f":[{"t":2,"x":{"r":["channelData","contact"],"s":"_0.formatPhoneNumber(_1)"}}],"n":50,"r":"phoneNumberType"},{"t":4,"n":51,"f":[{"t":2,"r":"contact"}],"r":"phoneNumberType"}," ",{"t":4,"f":[{"t":7,"e":"b","a":{"class":"primary-service"},"f":["(Primary)"]}],"n":50,"r":"primaryFlag"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"data-tooltip":0,"aria-haspopup":"true","class":"has-tip","title":"The contact details you've entered are incorrect. Please check and try again."},"f":[{"t":7,"e":"ux-icon","a":{"class":"invalid-service-icon","type":"error-alert","size":"xs"},"f":[]}]}],"n":50,"x":{"r":["invalidFlag","hardBounceFlag"],"s":"_0||_1"}}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"change-service","disabled":[{"t":3,"x":{"r":["status"],"s":"!_0"}}],"section":[{"t":3,"r":"modalSection"}]},"v":{"anchorClicked":"openSection"},"f":["Change"]}]}]}]}],"n":51,"r":"deleted"}]},"ccaProfileChangeGeneralMarketingChannels":{"v":3,"t":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeGeneralMarketingChannelItem"}],"r":"channelData.Email"}," ",{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeGeneralMarketingChannelItem"}],"r":"channelData.SMS"}," ",{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeGeneralMarketingChannelItem"}],"r":"channelData.Phone"}," ",{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeGeneralMarketingChannelSecondaryItem"}],"r":"channelData.Address"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"hr"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"general-marketing-channels-footer"},"f":[{"t":7,"e":"em","f":["Choose how you'd like to receive marketing and promotional communications from Optus."]}]}]}]},"ccaProfileChangeGeneralMarketingPreferences":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"general-marketing-preferences"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ul","a":{"class":"small-block-grid-1 medium-block-grid-2 preference-list"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-checkbox","a":{"checkboxname":[{"t":2,"r":"id"}],"on":[{"t":2,"r":"checked"}],"disabled":[{"t":2,"x":{"r":["preferenceData.optOutFlag.checked"],"s":"!_0"}}]},"f":[{"t":7,"e":"b","f":[{"t":2,"r":"name"}]}]}]}]}]}],"n":51,"x":{"r":["id","modifiableFlag"],"s":"_0===\"NM\"||_0===\"EM\"||_0===\"SM\"||_0===\"TM\"||_0===\"DM\"||!_1"}}],"n":52,"r":"preferenceData.preferences"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"opt-out-general-marketing"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-panel","a":{"class":"no-border"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"preferenceData.optOutFlag.name"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"ux-toggle","a":{"name":[{"t":2,"r":"preferenceData.optOutFlag.name"}],"checked":[{"t":2,"r":"preferenceData.optOutFlag.checked"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":["You can choose to opt out from the marketing communications listed above. ",{"t":7,"e":"div","a":{"class":"opt-out-caption caption"},"f":["Please note: You'll still receive the subscription communications you've signed up for and you can manage those subscriptions below."]}]}]}]}]}]}],"n":50,"r":"preferenceData.optOutFlag"}," ",{"t":7,"e":"div","a":{"class":["update-general-marketing ",{"t":4,"f":["hide"],"n":50,"r":"hideSave"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"preferenceData.updateError"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"updatePreferences"},"a":{"class":["button-update-preference button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"preferenceData.loadingStatusSpinner.status"}],"role":"button","field":"update-preference"},"f":["Save Preferences"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"preferenceData.loadingStatusSpinner"}]}]}]}]}]},"ccaProfileChangeMySubscriptionContactAddressForm":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"edit-postal-address edit-modal"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-6"},"f":[{"t":7,"e":"strong","a":{"class":"general-marketing-services-form-title"},"f":["Home address"]},{"t":7,"e":"br"}," ",{"t":7,"e":"p","f":["Choose home address where you want to get information about most of the Optus products."]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"current-postal-address small-12 large-6"},"f":[{"t":7,"e":"p","f":["Current address: ",{"t":7,"e":"b","f":[{"t":2,"r":"currentAddress"}]}]}]}]}],"n":50,"r":"currentAddress"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"add-postal-address small-12 large-4"},"f":[{"t":7,"e":"ux-address","a":{"class":"input-marketing-address","datamodel":[{"t":2,"r":"postalAddressDataModel"}],"manualInput":[{"t":2,"r":"postalAddressDataModel.manualInput"}],"autocomplete":[{"t":2,"r":"postalAddressDataModel.autocomplete"}],"addressMoniker":[{"t":2,"r":"postalAddressDataModel.addressMoniker"}],"address":[{"t":2,"r":"postalAddressDataModel.address"}]}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"r":"postalAddressErrorMsg"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"updatePostalAddress"},"a":{"class":["submit-form button small grey radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}],"role":"button","subscriptionIndex":[{"t":3,"r":"subscriptionIndex"}],"contactChannel":[{"t":3,"r":"contactChannel"}],"field":"subscription"},"f":[{"t":4,"f":["Add address"],"n":50,"x":{"r":["currentAddress"],"s":"!_0"}},{"t":4,"n":51,"f":["Change address"],"x":{"r":["currentAddress"],"s":"!_0"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"loadingStatusSpinner"}]}]}]}]},"ccaProfileChangeMySubscriptionItemAddContact":{"v":3,"t":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-10"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"add-contact","section":[{"t":3,"r":"section"}],"subscriptionCategory":[{"t":3,"r":"subscriptionCategory"}],"subscriptionIndex":[{"t":3,"r":"subscriptionIndex"}],"contactValue":[{"t":3,"r":"contactValue"}],"contactChannel":[{"t":3,"r":"contactChannel"}]},"v":{"anchorClicked":"openSectionSubscriptionContact"},"f":[{"t":2,"r":"text"}]}]}]}]}]}]}]},"ccaProfileChangeMySubscriptionItemContactChannel":{"v":3,"t":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-1 medium-2"},"f":[{"t":7,"e":"ux-checkbox","a":{"on":[{"t":2,"r":"optedIn"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-10"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"span","a":{"class":"subscription-contact-item"},"f":[{"t":2,"r":"contact"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"change-contact","section":["change",{"t":3,"r":"channel"}],"subscriptionCategory":[{"t":3,"r":"subscriptionCategory"}],"subscriptionIndex":[{"t":2,"r":"subscriptionIndex"}],"contactValue":[{"t":3,"r":"contact"}],"contactChannel":[{"t":3,"r":"channel"}]},"v":{"anchorClicked":"openSectionSubscriptionContact"},"f":["Change"]}]}]}]}]}]}]},"ccaProfileChangeMySubscriptionItemContactForm":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"edit-subscription-contact edit-modal"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-6"},"f":[{"t":4,"f":[{"t":7,"e":"p","f":["Change the email address where you'd like to receive your subscriptions."]}],"n":50,"x":{"r":["contactChannel"],"s":"_0===\"EM\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["contactChannel"],"s":"_0===\"SM\""},"f":[{"t":7,"e":"p","f":["Change the mobile number where you'd like to receive your SMS subscriptions."]}]}],"x":{"r":["contactChannel"],"s":"_0===\"EM\""}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"update-contact-form"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-4"},"f":[{"t":7,"e":"div","a":{"class":"label-text"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"label"}]}]}," ",{"t":7,"e":"input","a":{"type":"text","class":"contact-input","value":[{"t":2,"r":"subscriptionContact"}],"placeholder":[{"t":2,"r":"placeholder"}]}}," ",{"t":7,"e":"div","a":{"class":"contact-input-error"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"r":"subscriptionContactErrorMsg"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"updateSubscriptionContact"},"a":{"class":"button yellow radius expand","contactChannel":[{"t":3,"r":"contactChannel"}],"subscriptionIndex":[{"t":3,"r":"subscriptionIndex"}],"subscriptionCategory":[{"t":3,"r":"subscriptionCategory"}],"contactIndex":[{"t":3,"r":"contactIndex"}],"role":"button"},"f":["Update"]}]}]}]}]},"ccaProfileChangeMySubscriptionItemContacts":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"contacts"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ul","a":{"class":"small-block-grid-1 medium-block-grid-2"},"f":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeMySubscriptionItemContactChannel"}],"r":"emailContact"}],"n":50,"r":"emailContact"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["emailChannelAvailable","emailContact"],"s":"_0&&!_1"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeMySubscriptionItemAddContact"}],"x":{"r":["subscriptionCategory","subscriptionIndex","contact"],"s":"{section:\"addEmail\",subscriptionCategory:_0,subscriptionIndex:_1,contactValue:_2,contactChannel:\"EM\",text:\"Add Email\"}"}}]}],"r":"emailContact"}," ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeMySubscriptionItemContactChannel"}],"r":"mobileContact"}],"n":50,"r":"mobileContact"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["mobileChannelAvailable","mobileContact"],"s":"_0&&!_1"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeMySubscriptionItemAddContact"}],"x":{"r":["subscriptionCategory","subscriptionIndex","contact"],"s":"{section:\"addMobileNo\",subscriptionCategory:_0,subscriptionIndex:_1,contactValue:_2,contactChannel:\"SM\",text:\"Add Mobile No\"}"}}]}],"r":"mobileContact"}," ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeMySubscriptionItemContactChannel"}],"r":"postalAddressContact"}],"n":50,"r":"postalAddressContact"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["addressChannelAvailable","postalAddressContact"],"s":"_0&&!_1"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeMySubscriptionItemAddContact"}],"x":{"r":["subscriptionCategory","subscriptionIndex","contact"],"s":"{section:\"addAddress\",subscriptionCategory:_0,subscriptionIndex:_1,contactValue:_2,contactChannel:\"DM\",text:\"Add Address\"}"}}]}],"r":"postalAddressContact"}]}]}]}]}]},"ccaProfileChangeMySubscriptionItems":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"subscriptions"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscription-category"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"subscriptionCategory"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscription"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"name"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"ux-toggle","a":{"subscriptionCategory":[{"t":2,"r":"subscriptionCategory"}],"subscriptionIndex":[{"t":2,"r":"subscriptionIndex"}],"checked":[{"t":2,"rx":{"r":"subscriptionData.switches","m":[{"t":30,"n":"subscriptionCategory"},{"t":30,"n":"subscriptionIndex"},"data","checked"]}}],"onclick":"switchSubscriptionStatus"}}]}]}," ",{"t":4,"f":[{"t":8,"r":"ccaProfileChangeMySubscriptionItemContacts"}],"n":50,"rx":{"r":"subscriptionData.switches","m":[{"t":30,"n":"subscriptionCategory"},{"t":30,"n":"subscriptionIndex"},"data","checked"]}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"hr","a":{"class":"collapse-top"}}]}]}]}],"n":52,"i":"subscriptionIndex","r":"."}]}],"n":52,"i":"subscriptionCategory","r":"subscriptionData.subscriptionCategories"}]}]},"ccaProfileChangePassword":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"edit-password"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"changePasswordError"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"modal-form update-password-form"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4 password-inputs"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangePasswordInputField"}],"x":{"r":[],"s":"{required:true,title:\"Current password\",value:\"oldPwd\"}"}}," ",{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangePasswordInputField"}],"x":{"r":[],"s":"{required:true,title:\"New password\",value:\"newPwd\"}"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4 newPassword"},"f":[{"t":7,"e":"ux-password-strength","a":{"enteredPassword":[{"t":2,"r":"pwd.newPwd"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"modal-form"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":7,"e":"p","a":{"class":"caption password-instructions"},"f":["Your password must be a minimum of 8 characters in length, contain an uppercase and lowercase and a number or symbol."]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangePasswordInputField"}],"x":{"r":[],"s":"{required:true,title:\"Confirm new password\",value:\"confirmPwd\"}"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-2"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"updatePassword"},"a":{"class":["submit-form button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}],"role":"button"},"f":["Update"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"loadingStatusSpinner"}]}]}]}]},"ccaProfileChangePasswordInputField":{"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"strong","a":{"class":"input-label"},"f":[{"t":2,"r":"title"},{"t":4,"f":[{"t":7,"e":"span","a":{"class":"required-field-asterix"},"f":["*"]}],"n":50,"r":"required"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 ",{"t":2,"r":"value"}]},"f":[{"t":7,"e":"input","a":{"type":"password","value":[{"t":2,"rx":{"r":"pwd","m":[{"t":30,"n":"value"}]}}]}}," ",{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"rx":{"r":"pwd","m":[{"r":["value"],"s":"_0+\"ErrorMsg\""}]}}]}]}]},"ccaProfileChangeServicePreference":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"update-service-preference"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"updateProfileError"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":7,"e":"div","a":{"class":"modal-text"},"f":[{"t":7,"e":"strong","a":{"class":"modal-text-heading"},"f":["Primary service number"]}," ",{"t":7,"e":"p","f":["Choose your primary service for which usage details will be displayed upon login (please select one)"]}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":7,"e":"div","a":{"class":"service-list"},"f":[{"t":4,"f":[{"t":7,"e":"ux-radio-button","a":{"label":[{"t":2,"x":{"r":["generalSectionData","."],"s":"_0.formatPhoneNumber(_1)"}}],"selected":[{"t":2,"r":"data.defaultService"}],"value":[{"t":2,"r":"."}],"btn_id":["id_",{"t":2,"r":"."}]}}],"n":52,"r":"data.linkedServices"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-2"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"updateProfile"},"a":{"class":["button-update-service-prefs button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}],"role":"button"},"f":["Update"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"loadingStatusSpinner"}]}]}]}]},"ccaProfileChangeUsername":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"edit-username"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"updateLogonEmailError"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":7,"e":"p","f":["You can log in using your email address rather than a username.",{"t":7,"e":"br"}," Choose an existing address or enter a new one.",{"t":7,"e":"br"}," You'll need to validate your email address by clicking on the link we'll send you."]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-4"},"f":[{"t":7,"e":"p","f":["Username: ",{"t":7,"e":"strong","f":[{"t":2,"r":"data.userName"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"modal-form"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-4"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeAccountInfoInputField"}],"x":{"r":[],"s":"{title:\"Add email\",required:true,fieldBinding:\"emailIdentifier\",placeholder:\"Enter your new login email\"}"}}," ",{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileChangeAccountInfoInputField"}],"x":{"r":[],"s":"{title:\"Confirm email\",required:true,fieldBinding:\"confirmEmailIdentifier\",placeholder:\"Re-enter email\"}"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-2"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"updateLogonEmail"},"a":{"class":["submit-form button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"loadingStatusSpinner.status"}],"role":"button","directory":"accountInfoTemp","profileDataField":"emailIdentifier","field":"accountInfo.changeUsername"},"f":["Update"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"loadingStatusSpinner"}]}]}]}]},"ccaProfileHeader":{"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":"welcome"},"f":[{"t":7,"e":"ux-header","a":{"level":"1"},"f":["Hey ",{"t":2,"r":"data.firstName"},","]}," ",{"t":7,"e":"strong","f":["Thanks for signing up!"]}," ",{"t":7,"e":"p","f":["Tell us about yourself for more relevant communications."]}]}]}]}]},"ccaProfilePlaceholder":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"cca-placeholder"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":["Placeholder"]}," ",{"t":7,"e":"p","f":["Hello ",{"t":2,"r":"data.firstName"},". Lorem ipsum"]}]}]}]}]},"ccaProfileSectionAccountInfo":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"account-info"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileSectionAccountInfoItem"}],"x":{"r":["data.firstName","data.lastName"],"s":"{title:\"Name\",className:\"name\",value:_0+\" \"+_1}"}}," ",{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileSectionAccountInfoItem"}],"x":{"r":["data.userName","data.emailIdentifier","data.emailIdentifierStatus"],"s":"{title:(_1&&(!_2||_2==\"0\"))?\"Email\":\"Username\",className:(_1&&(!_2||_2==\"0\"))?\"email\":\"username\",value:(_1&&(!_2||_2==\"0\"))?_1:_0,section:(_2==1)?null:(_1)?\"emailIdentifier\":\"changeUsername\",editText:(_1&&(!_2||_2==\"0\"))?\"Change\":\"Change to email address\",tooltip:(_1&&(!_2||_2==\"0\"))?\"Change your login email address. This change will occur for both My Account and Yes Crowd, as these details are linked.\":\"\"}"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-panel","a":{"class":"cca-message-panel cca-message-panel-alert caption account-info-email-migration-alert"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":["You will need to confirm your email address before you can log in. Alternatively you can provide a ",{"t":7,"e":"ux-anchor","a":{"class":"email-migration-change","section":"changeUsername"},"v":{"anchorClicked":"openSection"},"f":["new email address"]}]}]}]}]}]}],"n":50,"x":{"r":["data.emailIdentifierStatus"],"s":"_0==1"}}," ",{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileSectionAccountInfoItem"}],"x":{"r":[],"s":"{title:\"Password\",className:\"password\",value:\"*********\",section:\"pwd\",tooltip:\"Change your password. This change will occur for both My Account and Yes Crowd, as these details are linked.\"}"}}," ",{"t":7,"e":"ux-row","a":{"class":"account-info-item accountInfo-dob"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"p","a":{"class":"account-heading"},"f":["Date of Birth ",{"t":7,"e":"span","a":{"data-tooltip":0,"class":"has-tip tip-down teal","title":[{"t":2,"x":{"r":["data.dob"],"s":"(_0)?\"Date of birth incorrect? Call us on 133 937 to change it\":\"Please enter your date of birth\""}}]},"f":[{"t":7,"e":"ux-icon","a":{"type":"tooltip-question-mark","size":"s"}}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":2,"x":{"r":["data.dob"],"s":"(_0)?\"small-9\":\"small-6\""}}]},"f":[{"t":7,"e":"p","a":{"class":"account-value"},"f":[{"t":7,"e":"strong","f":[{"t":4,"f":[{"t":2,"r":"data.dob"}],"r":"data.dob"},{"t":4,"n":51,"f":["Not Available"],"r":"data.dob"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-3 text-right"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"account-change-action","section":"dateOfBirth"},"v":{"anchorClicked":"openSection"},"f":["Add"]}]}],"n":51,"r":"data.dob"}]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileSectionAccountInfoItem"}],"x":{"r":["data.alternateEmail"],"s":"{title:\"Alternate Email\",className:\"alt-email\",value:_0,section:\"alternateEmail\",editText:(_0)?\"Change\":\"Add\"}"}}]}]},"ccaProfileSectionAccountInfoItem":{"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":["account-info-item account-info-",{"t":3,"r":"className"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"p","a":{"class":"account-heading"},"f":[{"t":2,"r":"title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":[{"t":7,"e":"span","a":{"class":"account-value"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"value"}]}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"data-tooltip":0,"aria-haspopup":"true","class":"has-tip","title":[{"t":2,"r":"tooltip"}]},"f":[{"t":7,"e":"ux-icon","a":{"class":"tooltip-icon","type":"tooltip-question-mark","size":"s"}}]}],"n":50,"r":"tooltip"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"account-change-action","section":[{"t":3,"r":"section"}]},"v":{"anchorClicked":"openSection"},"f":[{"t":2,"x":{"r":["editText"],"s":"_0||\"Change\""}}]}],"n":50,"r":"section"}]}]}]},"ccaProfileSectionBillingNotifications":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"billing-notifications"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"generalSectionData.updateProfileError"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"p","a":{"class":"subtext"},"f":[{"t":7,"e":"em","f":["Select how you would like your bill notifications to be sent"]}]}," ",{"t":7,"e":"p","f":["I prefer my billing notification via (please select one)"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"preferenceList"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileSectionBillingNotificationsPreferenceItem"}],"x":{"r":[],"s":"{label:\"Email\",value:\"email\",section:\"billingEmail\",fieldBinding:\"billingEmail\"}"}}," ",{"t":4,"n":53,"f":[{"t":8,"r":"ccaProfileSectionBillingNotificationsPreferenceItem"}],"x":{"r":[],"s":"{label:\"SMS\",value:\"sms\",section:\"billingSms\",fieldBinding:\"billingMobile\"}"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["button small yellow expand radius billing-notifications-update ",{"t":4,"f":["disabled"],"n":50,"r":"generalSectionData.loadingStatusSpinner.status"}]},"v":{"anchorClicked":"updateProfile"},"f":["Save changes"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"generalSectionData.loadingStatusSpinner"}]}]}]}]},"ccaProfileSectionBillingNotificationsPreferenceItem":{"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"collapse preference-item"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-2"},"f":[{"t":7,"e":"ux-radio-button","a":{"btn_id":[{"t":2,"r":"value"}],"selected":[{"t":2,"r":"data.billingNotification"}],"value":[{"t":2,"r":"value"}],"label":[{"t":2,"r":"label"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 large-10"},"f":[{"t":7,"e":"b","a":{"class":["preference-value billing-",{"t":3,"r":"value"}]},"f":[{"t":4,"f":[{"t":2,"x":{"r":["generalSectionData","fieldBinding","data"],"s":"_0.formatPhoneNumber(_2[_1])||\"None provided\""}}],"n":50,"x":{"r":["value"],"s":"_0===\"sms\""}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["fieldBinding","data"],"s":"_1[_0]||\"None provided\""}}],"x":{"r":["value"],"s":"_0===\"sms\""}}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 text-right"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["update-billing-",{"t":2,"r":"value"}],"section":[{"t":3,"r":"section"}]},"v":{"anchorClicked":"openSection"},"f":[{"t":4,"f":["Add"],"n":50,"x":{"r":["fieldBinding","data"],"s":"!_1[_0]"}},{"t":4,"n":51,"f":["Change"],"x":{"r":["fieldBinding","data"],"s":"!_1[_0]"}}]}]}]}]},"ccaProfileSectionCommunityProfile":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"p","f":["You can now access or register for Yes Crowd using your My Account login details. To change your community profile settings, head to Yes Crowd."]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"data.resourceUrls.communityLogonUrl"}],"class":"button small yellow radius expand"},"f":["Edit Profile"]}]}]}]},"ccaProfileSectionGeneralMarketing":{"v":3,"t":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"x":{"r":[],"s":"{class:\"cca-profile-cmdm-error\",message:\"Something went wrong on our side. Please try again later\"}"}}],"n":50,"x":{"r":["data.cmdmProfileModel"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-alert","a":{"class":"alert-notification"},"f":["As a minor, you are not permitted to manage your General Marketing preferences"]}],"n":50,"r":"data.under14"}," ",{"t":7,"e":"div","a":{"class":["general-marketing ",{"t":4,"f":["age-restricted"],"n":50,"r":"data.under14"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"p","a":{"class":"subtext"},"f":[{"t":7,"e":"em","f":["Manage your marketing communications from Optus. (This does not include billing or account information)."]}]}]}]}," ",{"t":8,"r":"ccaProfileChangeGeneralMarketingChannels"}," ",{"t":8,"r":"ccaProfileChangeGeneralMarketingPreferences"}]}],"x":{"r":["data.cmdmProfileModel"],"s":"!_0"}}]},"ccaProfileSectionMarketingSubscriptions":{"v":3,"t":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"x":{"r":[],"s":"{class:\"cca-profile-cmdm-error\",message:\"Something went wrong on our side. Please try again later\"}"}}],"n":50,"x":{"r":["data.cmdmProfileModel"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-alert","a":{"class":"alert-notification"},"f":["As a minor, you are not permitted to manage your Marketing Subscriptions"]}],"n":50,"r":"data.under14"}," ",{"t":7,"e":"div","a":{"class":["marketing-subscriptions communications-from-optus ",{"t":4,"f":["age-restricted"],"n":50,"r":"data.under14"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"p","a":{"class":"subtext"},"f":[{"t":7,"e":"em","f":["Select which subscriptions you would like to be contacted on"]}]}]}]}," ",{"t":8,"r":"ccaProfileChangeMySubscriptionItems"}," ",{"t":7,"e":"div","a":{"class":"update-marketing-subscriptions"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"subscriptionData.updateError"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":7,"e":"ux-anchor","v":{"anchorClicked":"updateSubscriptions"},"a":{"class":["button-update-subscription button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"subscriptionData.loadingStatusSpinner.status"}],"role":"button","field":"update-subscription"},"f":["Save subscriptions"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"subscriptionData.loadingStatusSpinner"}]}]}]}]}],"x":{"r":["data.cmdmProfileModel"],"s":"!_0"}}]},"ccaProfileSectionReveal":{"v":3,"t":[{"t":7,"e":"ux-reveal","a":{"class":"cca-profile-section-modal full-screen-modal","modalVisible":[{"t":2,"r":"modalVisible"}]},"f":[{"t":7,"e":"div","a":{"class":"reveal-section-header"},"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":[{"t":2,"r":"sectionTitle"}]}]}," ",{"t":8,"r":"partial"}]}]},"ccaProfileSectionServicePreference":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"service-preference"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"loadServicesErrorMsg"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":"subtext"},"f":[{"t":7,"e":"em","f":["You can specify which service you would like to see first on your dashboard"]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"current-preference"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":["Primary service number"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"b","a":{"class":"current-preference-value"},"f":[{"t":2,"x":{"r":["generalSectionData","data.defaultService"],"s":"_0.formatPhoneNumber(_1)||\"None Provided\""}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 text-right"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"button-change-service-prefs"},"v":{"anchorClicked":"openSection_servicePreference"},"f":["Change"]}]}]}]}]},"ccaProfileServices":{"v":3,"t":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"x":{"r":[],"s":"{class:\"cca-profile-cmdm-error\",message:\"Something went wrong on our side. Please try again later\"}"}}],"n":50,"r":"servicesTabData.cmdmErrorStatus"},{"t":4,"n":51,"f":[{"t":8,"r":"ccaProfileServicesRequestContact"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 managed-services-assign-contact-text"},"f":["Looks like you've got more than one service. You can assign your service to a specific user, by adding a contact."]}]}],"n":50,"x":{"r":["servicesTabData.unassignedServices.length"],"s":"_0>1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-accordion","a":{"servicesTabData":[{"t":2,"r":"servicesTabData"}],"class":"services-tab-accordion managed-services-list"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"class":"services-heading","level":"4"},"f":["YOUR SERVICES"]}," ",{"t":4,"f":[{"t":8,"r":"ccaProfileServicesManagedItem"}],"n":52,"r":"servicesTabData.managedServices"}],"n":50,"x":{"r":["servicesTabData.managedServices.length"],"s":"_0>0"}}," ",{"t":4,"f":[{"t":7,"e":"ux-header","a":{"class":"services-heading","level":"4"},"f":["SERVICES ASSIGNED TO YOU"]}," ",{"t":4,"f":[{"t":8,"r":"ccaProfileServicesRelatedItem"}],"n":52,"r":"servicesTabData.relatedServices"}],"n":50,"x":{"r":["servicesTabData.relatedServices.length"],"s":"_0>0"}}]}]}]}],"n":50,"x":{"r":["servicesTabData.managedServices.length","servicesTabData.relatedServices.length"],"s":"_0>0||_1>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 managed-services-no-services-alert"},"f":[{"t":7,"e":"ux-icon","a":{"type":"error-alert","size":"xs"}}," ",{"t":7,"e":"b","f":["No services available!"]}]}]}],"x":{"r":["servicesTabData.managedServices.length","servicesTabData.relatedServices.length"],"s":"_0>0||_1>0"}}],"r":"servicesTabData.cmdmErrorStatus"},{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-accordion","a":{"servicesTabData":[{"t":2,"r":"servicesTabData"}],"class":"services-tab-accordion secondary-accordion"},"f":[{"t":4,"f":[{"t":8,"r":"ccaProfileServicesTabCategory"}],"n":52,"r":"servicesTabData.tabCategories"}]}]}]}]},"ccaProfileServicesItemAssignContact":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"service-assign-contact"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":["Assign a contact"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"rx":{"r":"servicesTabData.managedServices","m":[{"t":30,"n":"@index"},"assignContactError"]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8 assign-contact-text"},"f":["Assigning a contact to this service allows them to manage their own profile and marketing communications."]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"service-assign-contact-pending"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelSuccess"}],"x":{"r":[],"s":"{class:\"service-assign-contact-pending-panel\",message:\"Invitation sent successfully! Please check your email.\"}"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-6"},"f":[{"t":7,"e":"b","f":["Didn't get the email? ",{"t":7,"e":"ux-anchor","a":{"class":"service-assign-contact-resend","contactIndex":[{"t":3,"r":"@index"}]},"v":{"anchorClicked":"serviceAssignContactResend"},"f":["Resend new one"]}]}]}]}]}],"n":50,"r":"pendingStatus"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-6 assign-contact-input-label"},"f":[{"t":7,"e":"strong","a":{"class":"caption"},"f":["Contact email address"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-6"},"f":[{"t":7,"e":"input","a":{"class":"service-assign-contact-input","type":"text","value":[{"t":2,"r":"assignContactEmail"}],"placeholder":"enter an email address"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8 service-assign-contact-error"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"r":"assignContactEmailErrorMsg"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["service-assign-contact-submit button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"servicesTabData.loadingStatusSpinner.status"}],"contactIndex":[{"t":3,"r":"@index"}],"identifier":[{"t":3,"r":"identifier"}],"serviceType":[{"t":3,"r":"serviceType"}]},"v":{"anchorClicked":"serviceAssignContact"},"f":["Invite by email"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"servicesTabData.loadingStatusSpinner"}]}]}],"r":"pendingStatus"}]}]},"ccaProfileServicesItemContactRequest":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"service-contact-request"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"contactRequestError"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":7,"e":"ux-panel","a":{"class":"no-border"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"b","f":["Contact request"]},{"t":7,"e":"br"}," ",{"t":2,"r":"contactName"}," has requested to be a contact for this service."]},{"t":7,"e":"p","f":[]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["service-contact-request-accept button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"servicesTabData.contactRequestloadingStatusSpinner.status"}],"action":"approve","contactIndex":[{"t":2,"r":"@index"}]},"v":{"anchorClicked":"contactRequest"},"f":["Approve"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["service-contact-request-deny button small grey radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"servicesTabData.contactRequestloadingStatusSpinner.status"}],"action":"deny","contactIndex":[{"t":2,"r":"@index"}]},"v":{"anchorClicked":"contactRequest"},"f":["Deny"]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"servicesTabData.contactRequestloadingStatusSpinner"}]}]}]}]}]}]}]},"ccaProfileServicesItemRemoveContact":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"service-remove-contact"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":["Remove contact"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"rx":{"r":"servicesTabData.managedServices","m":[{"t":30,"n":"@index"},"removeContactErrorMsg"]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 assign-contact-text"},"f":["Removing the contact from this service means they will no longer share some account management."]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"b","f":["Are you sure you want to remove contact?"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["service-remove-contact-confirm button small yellow radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"servicesTabData.removeLoadingStatusSpinner.status"}],"contactIndex":[{"t":3,"r":"@index"}]},"v":{"anchorClicked":"serviceConfirmRemoveContact"},"f":["Confirm"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"servicesTabData.removeLoadingStatusSpinner"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["service-remove-contact-cancel button small grey radius expand ",{"t":4,"f":["disabled"],"n":50,"r":"servicesTabData.removeLoadingStatusSpinner.status"}],"contactIndex":[{"t":3,"r":"@index"}],"removeConfirmStatus":"false"},"v":{"anchorClicked":"serviceSetRemoveConfirmStatus"},"f":["Cancel"]}]}]}],"n":50,"r":"removeConfirmStatus"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"service-remove-contact-submit button small yellow radius expand","serviceList":[{"t":3,"x":{"r":["accountNumber"],"s":"_0?\"managedServices\":\"relatedServices\""}}],"contactIndex":[{"t":3,"r":"@index"}],"removeConfirmStatus":"true"},"v":{"anchorClicked":"serviceSetRemoveConfirmStatus"},"f":["Remove"]}]}]}],"r":"removeConfirmStatus"}]}]},"ccaProfileServicesManagedItem":{"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"hr","a":{"class":"collapse-top collapse-bottom"}}]}]}," ",{"t":7,"e":"ux-accordionitem","a":{"active":[{"t":2,"r":".active"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"service-loading-overlay"},"f":[{"t":7,"e":"ux-spinner"}]}],"n":50,"x":{"r":["loadStatus"],"s":"!_0"}}," ",{"t":7,"e":"ux-anchor","a":{"class":"title-link"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 medium-1 text-left"},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"x":{"r":["servicesTabData",".serviceType"],"s":"_0.getIconType(_1)"}}],"size":"xl","class":"service-icon"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-8 medium-9"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 service-identifier"},"f":[{"t":7,"e":"b","f":[{"t":4,"f":[{"t":2,"x":{"r":["servicesTabData","identifier"],"s":"_0.formatMobileNumber(_1)"}}],"n":50,"x":{"r":["servicesTabData","identifier"],"s":"_0.serviceIsMobileNumber(_1)"}},{"t":4,"n":51,"f":[{"t":2,"r":"identifier"}],"x":{"r":["servicesTabData","identifier"],"s":"_0.serviceIsMobileNumber(_1)"}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 service-account-number"},"f":["Account no: ",{"t":2,"r":"accountNumber"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 service-assigned-contact"},"f":["Assigned to: ",{"t":7,"e":"b","a":{"class":"service-assigned-contact-name"},"f":[{"t":2,"r":"contactName"}]}]}]}],"n":50,"x":{"r":["contactName","relationshipStatus"],"s":"_0&&_1===\"A\""}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 text-right"},"f":[{"t":7,"e":"span","a":{"class":"icon-arrow icon-arrow-up"}}," ",{"t":7,"e":"span","a":{"class":"icon-arrow icon-arrow-down"}}]}]}]}," ",{"t":7,"e":"ux-content","a":{"active":[{"t":2,"r":".active"}]},"f":[{"t":4,"f":[{"t":8,"r":"ccaProfileServicesItemRemoveContact"}],"n":50,"x":{"r":["relatedPartyId","relationshipStatus"],"s":"_0&&_1===\"A\""}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":7,"e":"ux-panel","a":{"class":"service-contact-request-denied cca-message-panel cca-message-panel-error caption"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-icon","a":{"type":"error-alert","size":"xs"}}," Contact request denied."]}]}]}]}]}],"n":50,"r":"assignContactRequestDenyStatus"}," ",{"t":4,"f":[{"t":8,"r":"ccaProfileServicesItemContactRequest"}],"n":50,"x":{"r":["relationshipStatus"],"s":"_0===\"P\""}},{"t":4,"n":51,"f":[{"t":8,"r":"ccaProfileServicesItemAssignContact"}],"x":{"r":["relationshipStatus"],"s":"_0===\"P\""}}],"x":{"r":["relatedPartyId","relationshipStatus"],"s":"_0&&_1===\"A\""}}]}]}]},"ccaProfileServicesRelatedItem":{"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"hr","a":{"class":"collapse-top collapse-bottom"}}]}]}," ",{"t":7,"e":"ux-accordionitem","a":{"active":[{"t":2,"r":".active"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"service-loading-overlay"},"f":[{"t":7,"e":"ux-spinner"}]}],"n":50,"x":{"r":["loadStatus"],"s":"!_0"}}," ",{"t":7,"e":"ux-anchor","a":{"class":"title-link"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 service-identifier"},"f":[{"t":7,"e":"b","f":[{"t":4,"f":[{"t":2,"x":{"r":["servicesTabData","serviceId"],"s":"_0.formatMobileNumber(_1)"}}],"n":50,"x":{"r":["servicesTabData","serviceId"],"s":"_0.serviceIsMobileNumber(_1)"}},{"t":4,"n":51,"f":[{"t":2,"r":"serviceId"}],"x":{"r":["servicesTabData","serviceId"],"s":"_0.serviceIsMobileNumber(_1)"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 service-assigned-contact"},"f":["Owned by: ",{"t":7,"e":"b","a":{"class":"service-owner-name"},"f":[{"t":2,"r":"contactName"}]}]}]}],"n":50,"x":{"r":["contactName","relationshipStatus"],"s":"_0&&_1===\"A\""}}]}]}]}," ",{"t":7,"e":"ux-content"}]}]},"ccaProfileServicesRequestContact":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"managed-services-request-contact"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8 request-contact-text"},"f":["You can request to link your additional Optus services so you can view them in your profile and manage your preferences."]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse request-pending-confirmation"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelSuccess"}],"x":{"r":[],"s":"{class:\"request-pending-panel\",message:\"You’ve successfully linked another service to your profile.\"}"}}]}]}],"n":50,"r":"servicesTabData.requestServiceConfirmation.status"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"servicesTabData.requestServiceError"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-6 request-contact-input-label"},"f":[{"t":7,"e":"strong","a":{"class":"caption"},"f":["Service/Account number"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-6"},"f":[{"t":7,"e":"input","a":{"class":"request-contact-input","type":"text","value":[{"t":2,"r":"servicesTabData.requestServiceIdentifier"}],"placeholder":"enter a service or account number"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8 service-assign-contact-error"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"r":"servicesTabData.requestServiceIdentifierErrorMsg"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-3"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["button small radius expand yellow request-contact-submit-button ",{"t":4,"f":["disabled"],"n":50,"r":"servicesTabData.loadingStatusSpinner.status"}]},"v":{"anchorClicked":"requestService"},"f":["Send request"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"servicesTabData.loadingStatusSpinner"}]}]}]}]},"ccaProfileServicesTabCategory":{"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"hr","a":{"class":"collapse-top collapse-bottom"}}]}]}," ",{"t":7,"e":"ux-accordionitem","a":{"active":[{"t":2,"r":".active"}]},"f":[{"t":7,"e":"ux-anchor","a":{"class":"title-link"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-10"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 text-right"},"f":[{"t":7,"e":"span","a":{"class":"icon-arrow icon-arrow-up"}}," ",{"t":7,"e":"span","a":{"class":"icon-arrow icon-arrow-down"}}]}]}]}," ",{"t":7,"e":"ux-content","a":{"active":[{"t":2,"r":".active"}]},"f":[{"t":8,"r":".partial"}]}]}]},"ccaProfileServicesTabCategoryDemergeRequest":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"demerge-request"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8 demerge-request-text"},"f":["If you notice any problem with any of the services displayed on this page please let us know."]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-10"},"f":[{"t":7,"e":"ux-panel","a":{"class":"demerge-request-confirmation-panel cca-message-panel cca-message-panel-success"},"f":[{"t":7,"e":"div","a":{"class":"panel-heading"},"f":[{"t":7,"e":"b","f":["Thanks!"]}]}," ",{"t":7,"e":"div","a":{"class":"panel-text"},"f":[{"t":7,"e":"ux-icon","a":{"type":"success-alert","size":"xs"}}," We'll process your request and will be in touch in 3-4 business days."]}]}]}]}],"n":50,"r":"servicesTabData.demergeRequestSubmitStatus"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaPanelError"}],"r":"servicesTabData.demergeRequestError"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"strong","a":{"class":"input-label"},"f":["Contact email address"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"input","a":{"type":"text","class":"demerge-request-contact","value":[{"t":2,"r":"servicesTabData.demergeRequestContactEmail"}]}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 demerge-request-contact-error"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"r":"servicesTabData.demergeRequestContactEmailErrorMsg"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"strong","a":{"class":"input-label"},"f":["Comments"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"textarea","a":{"class":"demerge-request-comment","value":[{"t":2,"r":"servicesTabData.demergeRequestComment"}]}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 demerge-request-comment-error"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"r":"servicesTabData.demergeRequestCommentErrorMsg"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["demerge-request-submit button small yellow expand radius ",{"t":4,"f":["disabled"],"n":50,"r":"servicesTabData.mergeLoadingStatusSpinner.status"}]},"v":{"anchorClicked":"demergeRequest"},"f":["Send report"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"servicesTabData.mergeLoadingStatusSpinner"}]}]}],"r":"servicesTabData.demergeRequestSubmitStatus"}]}]},"ccaProfileServicesTabCategoryMergeRequest":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"merge-request"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8 merge-request-text"},"f":["Do you own other Optus services that don't appear below?",{"t":7,"e":"br"}," If so, please enter account ID/s or service number/s."]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-10"},"f":[{"t":7,"e":"ux-panel","a":{"class":"merge-request-confirmation-panel cca-message-panel cca-message-panel-success"},"f":[{"t":7,"e":"div","a":{"class":"panel-heading"},"f":[{"t":7,"e":"b","f":["Thanks!"]}]}," ",{"t":7,"e":"div","a":{"class":"panel-text"},"f":[{"t":7,"e":"ux-icon","a":{"type":"success-alert","size":"xs"}}," We'll process your request and will be in touch in 3-4 business days."]}]}]}]}],"n":50,"r":"servicesTabData.mergeRequestSubmitStatus"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":8,"r":"ccaPanelError"}]}]}],"n":52,"r":"servicesTabData.mergeRequestError"}],"r":"servicesTabData.mergeRequestSubmitStatus"}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"strong","a":{"class":"input-label"},"f":["Service ID"]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-10 medium-6"},"f":[{"t":7,"e":"input","a":{"type":"text","class":["merge-request-contact merge-request-contact-",{"t":2,"x":{"r":["@index"],"s":"_0+1"}}],"value":[{"t":2,"r":"identifier"}],"contactIndex":[{"t":2,"r":"@index"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 medium-6 merge-request-contact-error-",{"t":2,"x":{"r":["@index"],"s":"_0+1"}}]},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"rx":{"r":"servicesTabData.mergeRequestContacts","m":[{"t":30,"n":"@index"},"identifierErrorMsg"]}}]}]}],"n":52,"r":"servicesTabData.mergeRequestContacts"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"merge-request-add"},"v":{"anchorClicked":"mergeRequestAdd"},"f":["Add another service"]}]}]}],"n":50,"x":{"r":["servicesTabData.mergeRequestContacts.length"],"s":"_0<3"}}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["merge-request-submit button small yellow expand radius ",{"t":4,"f":["disabled"],"n":50,"r":"servicesTabData.mergeLoadingStatusSpinner.status"}]},"v":{"anchorClicked":"mergeRequest"},"f":["Request merge"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-1 end"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"ccaLoadingSpinner"}],"r":"servicesTabData.mergeLoadingStatusSpinner"}]}]}]}]},"ccaProfileSummary":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-accordion","a":{"categories":[{"t":2,"r":"categories"}],"preferenceData":[{"t":2,"r":"preferenceData"}],"channelData":[{"t":2,"r":"channelData"}],"subscriptionData":[{"t":2,"r":"subscriptionData"}],"generalSectionData":[{"t":2,"r":"generalSectionData"}],"accordionStates":[{"t":2,"r":"accordionStates"}],"kebabCase":[{"t":2,"r":"kebabCase"}],"class":"category-list"},"f":[{"t":4,"f":[{"t":8,"r":"ccaProfileCategory"}],"n":52,"r":"categories"}]}]}]}],"n":50,"r":"categories"}]},"changeWorryFreeLoginPartial":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"changeWorryFreeLoginPartial v-normal-bottom"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 subsection-header"},"f":[{"t":2,"r":"initData.worryFree.worryFreeFooterMsg"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onWorryFreeLogin"},"f":[{"t":2,"r":"initData.worryFree.worryFreeFooterMsgBody.reEnterLinkText"}]}," ",{"t":2,"r":"initData.worryFree.worryFreeFooterMsgBody.reEnterLinkMsg"}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"onOnePassLogin"},"f":[{"t":2,"r":"initData.worryFree.worryFreeFooterMsgBody.onePassLinkText"}]}," ",{"t":2,"r":"initData.worryFree.worryFreeFooterMsgBody.onePassLinkMsg"}]}]}]}]},"checkCustomerEligibilityCannotAdd":{"v":3,"t":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"p","f":[{"t":2,"r":"initData.cannotAddMessage"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-p-normal-top text-center"},"f":[{"t":7,"e":"ux-button-sd","a":{"text":[{"t":2,"r":"initData.buttonLabelCatalogBrowsing"}],"type":"primary","ontap":"buttonNextStep","mode":"cannotAdd"}}]}]},"communityFeedSimpleRow":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"bordered-bottom"},"f":[{"t":7,"e":"p","a":{"class":"heading-quaternary"},"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"view_href"}],"target":"_blank","class":"noTransform noUnderline weight-medium"},"f":[{"t":3,"r":"subject"}]}]}," ",{"t":7,"e":"caption","f":["by ",{"t":2,"r":"author_login"}," - ",{"t":2,"r":"last_post_time"}]}," ",{"t":4,"f":[{"t":7,"e":"caption","f":[{"t":7,"e":"ux-icon","a":{"type":"monitoring"}}," ",{"t":7,"e":"span","f":[{"t":2,"x":{"r":["formatNumber","views"],"s":"_0(_1)"}}]}," ",{"t":7,"e":"ux-icon","a":{"type":"arrow-left-organic"}}," ",{"t":7,"e":"span","f":[{"t":2,"x":{"r":["formatNumber","replies"],"s":"_0(_1)"}}]}]}],"n":51,"r":"hideCounts"}]}]}]}],"n":52,"r":"."}]},"creditCheckConditionalApproval":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":2,"r":"initData.creditCheckErrorTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"p","f":[{"t":3,"r":"conditionalAcceptMaxSubsMessage"}]}]}],"r":"conditionalAcceptMaxSubsMessage"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-seperator","a":{"height":"1"}}],"n":50,"r":"conditionalAcceptMaxSubsMessage"}," ",{"t":7,"e":"div","f":[{"t":7,"e":"p","f":[{"t":3,"r":"conditionalAcceptMaxRCMessage"}]}]}],"r":"conditionalAcceptMaxRCMessage"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-seperator","a":{"height":"1"}}],"n":50,"x":{"r":["conditionalAcceptMaxRCMessage","conditionalAcceptMaxSubsMessage"],"s":"_0||_1"}}," ",{"t":7,"e":"div","f":[{"t":7,"e":"p","f":[{"t":3,"r":"conditionalAcceptMaxDevicePriceMessage"}]}]}],"r":"conditionalAcceptMaxDevicePriceMessage"}]}]}]},"creditCheckDecline":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":2,"r":"initData.creditCheckDeclineErrorTitle"}]}," ",{"t":7,"e":"div","a":{"class":"text-center"},"f":[{"t":7,"e":"ux-icon","a":{"type":"error","color":"#ccc","size":"xxl"}}]}," ",{"t":7,"e":"div","a":{"class":"v-p-normal-top"},"f":[{"t":7,"e":"p","f":[{"t":3,"r":"initData.declineMessage"}]}]}]}]}]},"creditCheckReferred":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":2,"r":"initData.creditCheckErrorTitle"}]}," ",{"t":7,"e":"p","f":[{"t":3,"r":"initData.referralMessage1"}]}," ",{"t":7,"e":"p","f":[{"t":3,"r":"initData.referralMessage2"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"referredOrderIdMessage"}]}]}]}]},"creditCheckReferredWithdraw":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":2,"r":"initData.creditCheckErrorTitle"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"referralOrWithdrawalMessage"}]}]}]}]},"creditCheckWithdraw":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":2,"r":"initData.creditCheckErrorTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"r":"withdrawInterflowMessage"}]}],"n":50,"r":"withdrawInterflowMessage"}," ",{"t":7,"e":"p","f":[{"t":3,"r":"initData.withdrawalMessage"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"withdrawOrderIdMessage"}]}]}]}]},"currencySymbol":{"v":3,"t":["$"]},"directDebitExistingCardForm":{"v":3,"t":[{"t":7,"e":"form","a":{"action":[{"t":2,"r":"createUrl"}],"class":"custom bind-foundation","id":"DirectDebitFormExisting"},"v":{"submit":"doFormSubmitExistingCard"},"f":[{"t":7,"e":"div","a":{"class":"row spacer-top-short inner "},"f":[{"t":7,"e":"div","a":{"class":"columns"},"f":[{"t":7,"e":"label","a":{"for":"existingCreditCardDropdown"},"f":["SELECT CARD"]}," ",{"t":7,"e":"select","a":{"id":"existingCreditCardDropdown","class":"medium","name":"token"},"v":{"change":"doSelectExistingCreditCard"},"f":[{"t":7,"e":"option","a":{"value":"null"},"f":["Select credit card"]}," ",{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":"number"}]},"f":[{"t":2,"r":"nickname"}," / ",{"t":2,"x":{"r":["helpers","number"],"s":"_0.maskCardNumber(_1)"}}]}],"r":"storedCreditCards"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"row spacer-top-short spacer-bottom-short inner"},"f":[{"t":7,"e":"div","a":{"class":"columns large-6 medium-6"},"f":[{"t":7,"e":"label","a":{"for":"selectedCardType"},"f":["CARD TYPE"]}," ",{"t":7,"e":"input","a":{"type":"text","value":[{"t":2,"x":{"r":["helpers","selectedExistingCard.type"],"s":"_0.creditCardType(_1)"}}],"disabled":"disabled"}}]}," ",{"t":7,"e":"div","a":{"class":"columns large-6 medium-6"},"f":[{"t":7,"e":"label","a":{"for":"selectedCardExpMonth"},"f":["Expiry Date (mm/yy)"]}," ",{"t":7,"e":"input","a":{"type":"text","value":[{"t":2,"r":"selectedExistingCard.expiryDate"}],"disabled":"disabled"}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"expiryMonth","value":[{"t":2,"x":{"r":["helpers","selectedExistingCard.expiryDate"],"s":"_0.splitString(_1,\"/\")[0]"}}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"expiryYear","value":[{"t":2,"x":{"r":["helpers","selectedExistingCard.expiryDate"],"s":"_0.splitString(_1,\"/\")[1]"}}]}}]}]}],"n":50,"x":{"r":["helpers","selectedExistingCard.type"],"s":"_0.creditCardType(_1)"}}," ",{"t":7,"e":"div","a":{"class":"row spacer-top-short spacer-bottom-short inner bg-light-grey"},"f":[{"t":7,"e":"div","a":{"class":"column"},"f":[{"t":8,"r":"directDebitTerms"}," ",{"t":7,"e":"rcheckbox","a":{"toggleKeypath":"tnc_existing"}}," ",{"t":7,"e":"strong","f":["I AGREE TO ALL OF THIS"]}]}]}," ",{"t":8,"r":"errorList"}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"directDebitType","value":"ExistingCard"}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"billingAccountNo","value":[{"t":2,"r":"billingAccountNo"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"cardNumber","value":[{"t":2,"r":"cardNumber"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"cardName","value":[{"t":2,"r":"cardName"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"cardHolderName","value":[{"t":2,"r":"cardHolderName"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"cardType","value":[{"t":2,"r":"cardType"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"directDebitSetup","value":[{"t":2,"r":"directDebitSetup"}]}}," ",{"t":7,"e":"div","a":{"class":"row spacer-top-short outer"},"f":[{"t":7,"e":"div","a":{"class":"large-4 columns spacer-bottom-short outer"},"f":[{"t":7,"e":"input","a":{"type":"submit","value":"Setup Direct Debit","title":"Please agree to terms and conditions","class":["button radius full-width ",{"t":4,"f":["disabled"],"n":51,"r":"tnc_existing"}]},"m":[{"t":4,"f":["disabled=\"disabled\""],"n":51,"r":"tnc_existing"}]}]}," ",{"t":7,"e":"div","a":{"class":"large-4 columns spacer-bottom-short outer"},"f":[{"t":7,"e":"button","a":{"type":"button","class":"button radius full-width teal right"},"v":{"click":"reloadPage"},"f":["Cancel"]}]}]}]}]},"directDebitGeneralInfo":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"row spacer-top-short inner"},"f":[{"t":7,"e":"div","a":{"class":"column"},"f":[{"t":7,"e":"div","a":{"class":"feature-box"},"f":[{"t":7,"e":"p","f":["A direct debit will activate in 48 hours and will debit on the day your bill is due. If your account is due within 48 hours, you will need to pay that amount manually."]}," ",{"t":7,"e":"p","f":["The direct debit will be made on your billing date."]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"row spacer-top-short spacer-bottom-short inner bg-light-grey"},"f":[{"t":7,"e":"div","a":{"class":"column push-1 large-12"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"column"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-generic icon-info teal"}}," Please note that these details will be used to pay for ",{"t":7,"e":"strong","f":["all services linked to below account number."]}," ",{"t":7,"e":"div","a":{"class":"row spacer-top-short spacer-bottom-short inner"},"f":[{"t":7,"e":"h4","a":{"class":"center"},"f":[{"t":2,"r":"data.billingAccountNo"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"column large-12"},"f":[{"t":7,"e":"ul","a":{"class":"no-style"},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"service-list-item"},"f":[{"t":7,"e":"span","a":{"class":["icon icon-service-type teal ",{"t":2,"x":{"r":["helpers","type"],"s":"_0.serviceDetails(_1).icon"}}]}}," ",{"t":7,"e":"span","a":{"class":"service-desc"},"f":["x ",{"t":2,"r":"."}]}]}],"i":"type","r":"data.directDebitViewSupportModel.accountServiceMap"}]}]}]}]}]}],"n":50,"r":"data.directDebitViewSupportModel"}]},"directDebitTerms":{"v":3,"t":[{"t":7,"e":"label","a":{"for":"dd_tnc_agreement","class":"required"},"f":["PLEASE REVIEW THE FOLLOWING:"]}," ",{"t":7,"e":"ol","f":[{"t":7,"e":"li","f":["I authorise Optus† and/or its billing agent (until further notice) to arrange payment of my Optus account as per details above by debiting my account as described above. ",{"t":7,"e":"br"}," I acknowledge that Optus may terminate this request any time by written or verbal notice, in which case I adopt an alternative method of payment."]}," ",{"t":7,"e":"li","f":["I am the financial account holder and have read and accepted the ",{"t":7,"e":"a","a":{"href":"//www.optus.com.au/aboutoptus/About+Optus/Legal+%26+Regulatory/Regulatory/Direct+Debit+Payments","target":"_blank"},"f":["Terms and Conditions"]}," for Direct Debit."]}," ",{"t":7,"e":"li","f":["Yes I've read your ",{"t":7,"e":"a","a":{"href":"//www.optus.com.au/privacy","target":"_blank"},"f":["privacy policy"]},"."]}]}]},"entertainmentServicesSwitchOffPage":{"v":3,"t":[{"t":7,"e":"ux-col","a":{"class":"large-7"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"hide-for-medium-down large-2"},"f":[{"t":7,"e":"div","a":{"class":"serviceOption"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"x":{"r":["getImage","selectedService.serviceName"],"s":"_0(_1,\"small\")"}}]}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-3 serviceName serviceDropDown"},"f":[{"t":7,"e":"strong","f":[{"t":7,"e":"ux-select","a":{"datamodel":["{ 'showSelectedValue': true, 'options': ",{"t":2,"x":{"r":["getOptions"],"s":"_0()"}}," }"]},"v":{"change":"selectChosenService"},"f":[]}]}]}],"n":50,"r":"showDropDown"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"large-3 serviceName"},"f":[{"t":7,"e":"strong","f":[{"t":4,"f":[{"t":2,"r":"serviceName"}],"r":"data.entertainmentOptions"}]}]}],"r":"showDropDown"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"hide-for-medium-down large-1 verticalDivider"}}," ",{"t":7,"e":"ux-col","a":{"class":"large-6 serviceName serviceDropDown"},"f":[{"t":7,"e":"ux-select","a":{"datamodel":["{ 'showSelectedValue': true, 'options': ",{"t":2,"x":{"r":["getPlanOptions"],"s":"_0()"}}," }"]},"v":{"change":"selectChosenPlan"},"f":[]}]}],"n":50,"r":"showPlanDropDown"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"hide-for-medium-down large-1 verticalDivider"}}," ",{"t":7,"e":"ux-col","a":{"class":"large-6 planName"},"f":[{"t":7,"e":"strong","f":[{"t":4,"f":[{"t":2,"r":"serviceId"}],"r":"selectedService.planOptions"}]}," ",{"t":7,"e":"br"}," ",{"t":4,"f":[{"t":2,"r":"planName"}],"r":"selectedService.planOptions"}]}],"r":"showPlanDropDown"}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"hr","a":{"class":"tertiaryLine spaceTop"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-alert","a":{"datamodel":["{ 'text': '",{"t":2,"r":"successMsg"},"', 'class': 'success radius' }"]},"f":[]}],"n":50,"r":"isSwitchOff"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-alert","a":{"datamodel":["{ 'text': '",{"t":2,"r":"errortext"},"', 'class': 'alert radius' }"]},"f":[]}],"r":"isSwitchOff"}],"n":50,"r":"hideSwitchOff"}," ",{"t":4,"f":[{"t":7,"e":"ux-alert","a":{"datamodel":["{ 'text': '",{"t":2,"r":"failtext"},"', 'class': 'alert radius' }"]},"f":[]}],"n":50,"r":"switchOffStatus"}," ",{"t":7,"e":"ux-col","a":{"class":"large-7"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header"},"f":[{"t":2,"r":"data.cmsContentMap.dcbTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"p","f":[{"t":3,"x":{"r":["getContentWithService"],"s":"_0(\"switchedOffText\")"}}]}],"n":50,"r":"isSwitchOff"},{"t":4,"n":51,"f":[{"t":7,"e":"p","f":[{"t":3,"x":{"r":["getContentWithService"],"s":"_0(\"serviceSwitchOffText\")"}}]}],"r":"isSwitchOff"}," ",{"t":7,"e":"div","a":{"class":"spaceTop"},"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"dcbPanel"},"f":[{"t":7,"e":"p","f":[{"t":3,"x":{"r":["getContentWithService"],"s":"_0(\"switchOffConfirmText\")"}}]}," ",{"t":7,"e":"ux-row","a":{"class":"space-above-buttons"},"f":[{"t":7,"e":"ux-col","a":{"class":"hide-for-small medium-6 large-4"},"f":[{"t":7,"e":"ux-button","a":{"class":"radius yellow confirmSwitchOffButton","onclick":"switchOff","role":"button","text":[{"t":2,"r":"data.cmsContentMap.switchOffButtonText"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"hide-for-small medium-6 large-8"},"f":[{"t":7,"e":"ux-button","a":{"class":"radius cancelButton","role":"button","text":[{"t":2,"r":"data.cmsContentMap.cancelButtonText"}],"onclick":"cancelSwitchOff"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"space-above-buttons"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6 hide-for-medium-up"},"f":[{"t":7,"e":"ux-button","a":{"class":"radius tiny confirmSwitchOffButtonSmall","onclick":"switchOff","role":"button","text":[{"t":2,"r":"data.cmsContentMap.switchOffButtonText"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 hide-for-medium-up"},"f":[{"t":7,"e":"ux-button","a":{"class":"radius tiny cancelButtonSmall","role":"button","text":[{"t":2,"r":"data.cmsContentMap.cancelButtonText"}],"onclick":"cancelSwitchOff"}}]}]}]}],"n":50,"r":"confirmSwitchOff"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"hide-for-medium-up yellow radius expand switchOffSmall","onclick":"confirmSwitchOff","role":"button","text":[{"t":2,"r":"data.cmsContentMap.switchOffButtonText"}]}}," ",{"t":7,"e":"ux-button","a":{"class":"hide-for-small yellow radius switchOff","onclick":"confirmSwitchOff","role":"button","text":[{"t":2,"r":"data.cmsContentMap.switchOffButtonText"}]}}],"n":50,"x":{"r":["hideSwitchOff"],"s":"!_0"}}],"r":"confirmSwitchOff"}," ",{"t":7,"e":"hr"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header"},"f":[{"t":2,"r":"data.cmsContentMap.paymentHistoryTitle"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"data.cmsContentMap.lastPaymentText"}," ",{"t":2,"x":{"r":["getPaymentDate","lastChargeDate"],"s":"_0(_1)"}}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"data.cmsContentMap.paidUptoText"}," ",{"t":2,"x":{"r":["getPaymentDate","paidThroughDate"],"s":"_0(_1)"}}]}," ",{"t":7,"e":"hr"}],"n":50,"x":{"r":["lastChargeDate","paidThroughDate"],"s":"_0&&_1"}}],"r":"selectedPlan"}]}]}]},"eplEligibilityCodeValidator":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"code-sent-block"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"span","a":{"class":"code-sent-title"},"f":[{"t":2,"r":"content.message.codeSentTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"code-resent-text"},"f":[{"t":3,"r":"content.message.codeResentText"}]}],"n":50,"r":"data.codeResent"},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"code-sent-text"},"f":[{"t":3,"r":"content.message.codeSentText"}]}],"r":"data.codeResent"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"input","a":{"type":"tel","pattern":"[0-9]*","maxlength":"6","class":["verification-code-input ",{"t":4,"f":["error"],"n":50,"x":{"r":["data.verificationCodeErrorMsg.message","data.codeVerify","data.codeResent"],"s":"_0||_1===false||_2===false"}}],"placeholder":[{"t":2,"r":"content.message.codeInputPlaceholder"}],"value":[{"t":2,"r":"data.verificationCode"}]}}," ",{"t":7,"e":"div","a":{"class":"verification-code-error"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"eplValidationError"}],"r":"data.verificationCodeErrorMsg"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["epl-default-btn btn-lg code-submit-btn ",{"t":4,"f":["disabled"],"n":50,"r":"data.buttonDisabled"}],"text":[{"t":2,"r":"content.message.submitText"}],"role":"button","action":"codeCheck","url":[{"t":2,"r":"data.urls.checkService"}],"disabled":[{"t":4,"f":["true"],"n":50,"r":"data.buttonDisabled"}],"onclick":"submitCode"},"f":[]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-anchor","a":{"class":["code-resend-btn ",{"t":4,"f":["disabled"],"n":50,"r":"data.buttonDisabled"}],"action":"codeCheck","url":[{"t":2,"r":"data.urls.sendCode"}]},"v":{"anchorClicked":"resendCode"},"f":[{"t":2,"r":"content.message.resendCodeText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"n":53,"f":[{"t":8,"r":"eplValidationError"}],"r":"data.errors"}]}]}],"n":50,"r":"data.codeSent"}]},"eplEligibilityDivider":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"epl-divider"}}]}]}]},"eplEligibilityEligibleAdded":{"v":3,"t":[{"t":4,"f":[{"t":8,"r":"eplEligibilityDivider"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 epl-content-bottom"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"epl-content-bottom-title"},"f":[{"t":2,"r":"content.added.bottomTitleAdded"}]}," ",{"t":7,"e":"p","a":{"class":"epl-content-bottom-text"},"f":[{"t":3,"r":"content.message.bottomMessageAdded"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["epl-default-btn btn-flex ",{"t":4,"f":["error"],"n":50,"r":"data.errors.message"}," ",{"t":4,"f":["disabled"],"n":50,"r":"data.buttonDisabled"}],"text":[{"t":3,"x":{"r":["renderCurrency"],"s":"_0(\"added.btnAddToEpl\")"}}],"role":"button","disabled":[{"t":4,"f":["true"],"n":50,"r":"data.buttonDisabled"}],"onclick":"btnToSignup"},"f":[]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"eplValidationError"}],"r":"data.errors"}]}]}]}]}],"n":50,"x":{"r":["eligible"],"s":"_0===\"added\""}}]},"eplEligibilityFaq":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"epl-content-faq"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"epl-faq-content-block"},"f":[{"t":7,"e":"ux-accordion-sd","a":{"title":[{"t":2,"r":"content.faq.title"}],"style":"alt list"},"f":[{"t":3,"r":"content.faq.content"}]}]}]}]}]},"eplEligibilityInputFields":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"epl-content-title"},"f":[{"t":4,"f":[{"t":2,"r":"content.message.mobileTitle"}],"n":50,"x":{"r":["data.serviceType","data.mobileService"],"s":"_0===_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["data.serviceType","data.broadbandService"],"s":"_0===_1"},"f":[{"t":2,"r":"content.message.broadbandTitle"}]},{"t":4,"n":50,"x":{"r":["data.broadbandService","data.serviceType","data.mobileBroadbandService"],"s":"(!(_1===_0))&&(_1===_2)"},"f":[" ",{"t":2,"r":"content.message.mbbtTitle"}]}],"x":{"r":["data.serviceType","data.mobileService"],"s":"_0===_1"}}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":8,"r":"eplEligibilityMobileServiceType"}," ",{"t":7,"e":"div","a":{"class":"epl-input-label caption"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"content.message.orderidInputLabel"}],"n":50,"x":{"r":["content.groupRadioBtns.selected"],"s":"_0===\"orderid\""}},{"t":4,"n":51,"f":[{"t":2,"r":"content.message.mobileInputLabel"}],"x":{"r":["content.groupRadioBtns.selected"],"s":"_0===\"orderid\""}}],"n":50,"x":{"r":["data.serviceType","data.mobileService"],"s":"_0===_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["data.serviceType","data.broadbandService"],"s":"_0===_1"},"f":[{"t":2,"r":"content.message.broadbandInputLabel"}]},{"t":4,"n":50,"x":{"r":["data.broadbandService","data.serviceType","data.mobileBroadbandService"],"s":"(!(_1===_0))&&(_1===_2)"},"f":[" ",{"t":2,"r":"content.message.mbbtInputLabel"}]}],"x":{"r":["data.serviceType","data.mobileService"],"s":"_0===_1"}}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"type":"text","class":["serviceId-input ",{"t":4,"f":["error"],"n":50,"r":"data.serviceIdErrorMsg.message"}],"value":[{"t":2,"r":"data.serviceId"}],"maxlength":"50","disabled":[{"t":4,"f":["disabled"],"n":50,"r":"data.codeSent"}]}}," ",{"t":7,"e":"div","a":{"class":"serviceid-input-error"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"eplValidationError"}],"r":"data.serviceIdErrorMsg"}]}],"n":50,"x":{"r":["content.groupRadioBtns.selected"],"s":"_0===\"orderid\""}},{"t":4,"n":51,"f":[{"t":7,"e":"input","a":{"type":"tel","pattern":"[0-9]*","class":["mobile-number-input ",{"t":4,"f":["error"],"n":50,"r":"data.mobileNumberErrorMsg.message"}],"value":[{"t":2,"r":"data.mobileNumber"}],"placeholder":"04","maxlength":"10","disabled":[{"t":4,"f":["disabled"],"n":50,"r":"data.codeSent"}]}}," ",{"t":7,"e":"div","a":{"class":"mobile-input-error"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"eplValidationError"}],"r":"data.mobileNumberErrorMsg"}]}],"x":{"r":["content.groupRadioBtns.selected"],"s":"_0===\"orderid\""}}],"n":50,"x":{"r":["data.serviceType","data.mobileService"],"s":"_0===_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"serviceid-inputfield"},"f":[{"t":7,"e":"input","a":{"type":"text","class":["serviceId-input ",{"t":4,"f":["error"],"n":50,"r":"data.serviceIdErrorMsg.message"}],"value":[{"t":2,"r":"data.serviceId"}],"maxlength":"50"}}," ",{"t":7,"e":"ux-anchor","a":{"class":"tooltip-icon"},"v":{"anchorClicked":"tooltipReveal"},"f":[{"t":7,"e":"ux-icon","a":{"type":"tooltip-question-mark","size":"s","text":"ServiceID Tooltip"}}]}]}," ",{"t":7,"e":"div","a":{"class":"serviceid-input-error"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"eplValidationError"}],"r":"data.serviceIdErrorMsg"}]}],"x":{"r":["data.serviceType","data.mobileService"],"s":"_0===_1"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"dob-field"},"f":[{"t":7,"e":"div","a":{"class":"epl-input-label caption"},"f":[{"t":2,"r":"content.message.dobInputLabel"}]}," ",{"t":7,"e":"div","a":{"class":"datefield"},"f":[{"t":7,"e":"input","a":{"type":"tel","pattern":"[0-9]*","maxlength":"2","class":["day-input ",{"t":4,"f":["error"],"n":50,"r":"data.dobDayErrorMsg.message"}],"placeholder":"DD","value":[{"t":2,"r":"data.dobDay"}],"disabled":[{"t":4,"f":["disabled"],"n":50,"r":"data.codeSent"}]}}," ",{"t":7,"e":"input","a":{"type":"tel","pattern":"[0-9]*","maxlength":"2","class":["month-input ",{"t":4,"f":["error"],"n":50,"r":"data.dobMonthErrorMsg.message"}],"placeholder":"MM","value":[{"t":2,"r":"data.dobMonth"}],"disabled":[{"t":4,"f":["disabled"],"n":50,"r":"data.codeSent"}]}}," ",{"t":7,"e":"input","a":{"type":"tel","pattern":"[0-9]*","maxlength":"4","class":["year-input ",{"t":4,"f":["error"],"n":50,"r":"data.dobYearErrorMsg.message"}],"placeholder":"YYYY","value":[{"t":2,"r":"data.dobYear"}],"disabled":[{"t":4,"f":["disabled"],"n":50,"r":"data.codeSent"}]}}," ",{"t":7,"e":"div","a":{"class":"dob-input-error"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"eplValidationError"}],"r":"data.dobDayErrorMsg"}," ",{"t":4,"n":53,"f":[{"t":8,"r":"eplValidationError"}],"r":"data.dobMonthErrorMsg"}," ",{"t":4,"n":53,"f":[{"t":8,"r":"eplValidationError"}],"r":"data.dobYearErrorMsg"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"postcode-field"},"f":[{"t":7,"e":"div","a":{"class":"epl-input-label caption"},"f":[{"t":2,"r":"content.message.postcodeInputLabel"}]}," ",{"t":7,"e":"input","a":{"type":"tel","pattern":"[0-9]*","class":["postcode-input ",{"t":4,"f":["error"],"n":50,"r":"data.postcodeErrorMsg.message"}],"value":[{"t":2,"r":"data.postcode"}],"maxlength":"4","disabled":[{"t":4,"f":["disabled"],"n":50,"r":"data.codeSent"}]}}," ",{"t":7,"e":"div","a":{"class":"postcode-input-error"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"eplValidationError"}],"r":"data.postcodeErrorMsg"}]}]}]}],"n":50,"x":{"r":["data.broadbandService","data.serviceType","data.mobileBroadbandService","content.groupRadioBtns.selected"],"s":"_1===_0||_1===_2||_3===\"orderid\""}},{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-checkbox","a":{"class":"epl-checkbox","on":[{"t":2,"r":"data.accountHolderChecked"}],"disabled":[{"t":4,"f":["disabled"],"n":50,"r":"data.codeSent"}],"labelvalue":[{"t":2,"r":"content.message.accountHolderText"}]},"f":[]}," ",{"t":7,"e":"ux-button","a":{"disabled":[{"t":4,"f":["true"],"n":50,"x":{"r":["data.codeSent","data.buttonDisabled"],"s":"_0||_1"}}],"class":["epl-default-btn btn-lg ",{"t":4,"f":["error"],"n":50,"x":{"r":["data.errors.message","data.codeSent"],"s":"_0&&!_1"}}," ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["data.codeSent","data.buttonDisabled"],"s":"_0||_1"}}],"text":[{"t":4,"f":[{"t":2,"r":"content.message.smsSubmitText"}],"n":50,"x":{"r":["data.serviceType","data.mobileService","content.groupRadioBtns.selected"],"s":"_0===_1&&_2===\"mobile\""}},{"t":4,"n":51,"f":[{"t":2,"r":"content.message.submitText"}],"x":{"r":["data.serviceType","data.mobileService","content.groupRadioBtns.selected"],"s":"_0===_1&&_2===\"mobile\""}}],"role":"button","action":[{"t":4,"f":[{"t":4,"f":["orderidEligibilityCheck"],"n":50,"x":{"r":["content.groupRadioBtns.selected"],"s":"_0===\"orderid\""}},{"t":4,"n":51,"f":["mobileEligibilityCheck"],"x":{"r":["content.groupRadioBtns.selected"],"s":"_0===\"orderid\""}}],"n":50,"x":{"r":["data.serviceType","data.mobileService"],"s":"_0===_1"}},{"t":4,"n":51,"f":["eligibilityCheck"],"x":{"r":["data.serviceType","data.mobileService"],"s":"_0===_1"}}],"onclick":"eligibilityCheck"},"f":[]}," ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"eplValidationError"}],"r":"data.errors"}],"n":50,"x":{"r":["data.codeSent"],"s":"!_0"}}]}]}]},"eplEligibilityMobileServiceType":{"v":3,"t":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"radio-btns"},"f":[{"t":7,"e":"ux-radio-button-group","a":{"style":"basic stacked","class":[{"t":4,"f":["disabled"],"n":50,"r":"data.codeSent"}],"selected":[{"t":2,"r":".selected"}],"radio_btns":[{"t":2,"r":".options"}]},"f":[]}]}],"r":"content.groupRadioBtns"}],"n":50,"x":{"r":["data.serviceType","data.mobileService"],"s":"_0===_1"}}]},"eplEligibilityModalbox":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-reveal","a":{"modalVisible":"true"},"f":[{"t":3,"r":"modalMessage"}]}],"n":50,"r":"modalMessage"},{"t":7,"e":"ux-reveal","a":{"modalVisible":[{"t":2,"r":"modalVisible"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"tooltip-modal-left"},"f":[{"t":3,"r":"content.tooltip.broadband.content"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"epl-divider"}}," ",{"t":7,"e":"div","a":{"class":"tooltip-modal-right"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"content.tooltip.broadband.src"}],"alt":[{"t":2,"r":"content.tooltip.broadband.alt"}],"title":[{"t":2,"r":"content.tooltip.broadband.alt"}]}}]}],"n":50,"r":"content.tooltip.broadband.src"}],"n":50,"x":{"r":["data.serviceType","data.broadbandService"],"s":"_0===_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["data.serviceType","data.mobileBroadbandService"],"s":"_0===_1"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-modal-left"},"f":[{"t":3,"r":"content.tooltip.mobileBroadband.content"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"epl-divider"}}," ",{"t":7,"e":"div","a":{"class":"tooltip-modal-right"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"content.tooltip.mobileBroadband.src"}],"alt":[{"t":2,"r":"content.tooltip.mobileBroadband.alt"}],"title":[{"t":2,"r":"content.tooltip.mobileBroadband.alt"}]}}]}],"n":50,"r":"content.tooltip.mobileBroadband.src"}]}],"x":{"r":["data.serviceType","data.broadbandService"],"s":"_0===_1"}}]}]},"eplEligibilitySidebar":{"v":3,"t":[{"t":7,"e":"ux-col","a":{"class":"epl-content-sidebar show-for-large-up large-4"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"epl-content-sidebar-block"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":".urls"}],"title":[{"t":2,"r":".title"}],"alt":[{"t":2,"r":".description"}]}}," ",{"t":7,"e":"div","f":[]}]}],"n":52,"r":"content.sidebarImage"}]}]},"eplEligibilityStatusError":{"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"epl-content-wrapper"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-7"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"epl-refresh-block"},"f":[{"t":3,"r":"data.errors.statusErrorMessage"}]}]}]}," ",{"t":8,"r":"eplEligibilitySidebar"}]}," ",{"t":8,"r":"eplEligibilityFaq"}]},"eplManagementPlanStatus":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"epl-plan-status"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"epl-plan-status-top"},"f":[{"t":7,"e":"div","a":{"class":"status-container-top"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"span","a":{"class":"status-container-text"},"f":[{"t":2,"r":"content.manage.subscriptionStatus"}]}," ",{"t":7,"e":"span","a":{"class":"active-until-text"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["renderExpiryDate"],"s":"_0(\"cancelSubscription.activeUntilText\")"}}],"n":50,"r":"data.boltonExpiryDate"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"active-email"},"f":["(",{"t":2,"r":"data.email"},")"]}],"n":50,"r":"data.email"}]}]}]}],"n":50,"x":{"r":["data.cancelEplSubscription"],"s":"!_0"}}," ",{"t":7,"e":"div","a":{"class":"status-container-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"epl-plan-status-price"},"f":[{"t":3,"x":{"r":["renderCurrency"],"s":"_0(\"manage.billingText\")"}}]}],"n":50,"r":"data.boltonPrice"}," ",{"t":7,"e":"div","a":{"class":"epl-plan-status-servicetype"},"f":[{"t":7,"e":"ux-icon","a":{"class":"servicetype-icon","size":"xl","text":"Service Type","type":[{"t":2,"x":{"r":["getIconType","data.serviceType"],"s":"_0(_1)"}}]},"f":[]}," ",{"t":7,"e":"div","a":{"class":["servicetype-content ",{"t":4,"f":["servicetype-vertical-padding"],"n":50,"x":{"r":["data.bundleName"],"s":"!_0"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"servicetype-name"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"data.serviceId"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"servicetype-text"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"data.bundleName"}]}]}],"n":50,"r":"data.bundleName"}],"n":50,"r":"data.serviceId"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-spinner"}],"r":"data.serviceId"}]}]}]}]}]},"eplValidationError":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":"epl-error"},"f":[{"t":7,"e":"ux-icon","a":{"type":"error-alert","class":"icon","size":"s"},"f":[]}," ",{"t":3,"r":"message"}]}],"n":50,"r":"message"}]},"errorList":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"column spacer-bottom-short outer"},"f":[{"t":4,"f":[{"t":7,"e":"small","a":{"class":"error"},"f":[{"t":3,"r":"errorMsg"}]}],"r":"errors"}]}]}],"n":50,"r":"errors"}]},"formField":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"column"},"f":[{"t":7,"e":"label","a":{"for":["dd_",{"t":2,"r":"name"}],"class":"required"},"f":[{"t":2,"r":"label"}]}," ",{"t":4,"f":[{"t":7,"e":"span","o":{"n":"tooltip","d":["{content:",{"t":2,"r":"tooltip"},"}"]},"f":[{"t":7,"e":"span","a":{"class":"icon icon-tooltip-question-mark"}}]}],"n":50,"r":"tooltip"}," ",{"t":7,"e":"input","a":{"id":["dd_",{"t":2,"r":"name"}],"name":[{"t":2,"r":"name"}],"type":"text","value":[{"t":2,"r":"value"}]},"m":[{"t":4,"f":["maxlength=\"",{"t":2,"r":"maxlength"},"\""],"n":50,"r":"maxlength"}]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"r":"valueErrorMsg"}]}]}]},"formRowInput":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"column"},"f":[{"t":7,"e":"div","a":{"class":"name-field"},"f":[{"t":7,"e":"label","a":{"for":[{"t":2,"r":"id"}],"class":[{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"r":"label"}]}," ",{"t":7,"e":"input","a":{"id":[{"t":2,"r":"id"}],"placeholder":"","required":0,"type":[{"t":2,"r":"type"}],"value":[{"t":2,"r":"value"}]}}," ",{"t":7,"e":"small","a":{"class":"error"},"f":["This field is required."]}]}]}]}]},"genericCMSFragmentMessage":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"column","data-cms-fragment-id":[{"t":2,"r":"id"}]},"f":[{"t":3,"r":"value"}]}]}]},"ippLegacy":{"v":3,"t":[{"t":7,"e":"form","a":{"method":"POST","action":[{"t":2,"r":"actionUrl"}],"name":"ippLegacyForm","class":"bind-foundation"},"v":{"submit":"ippLegacySubmit"},"f":[{"t":7,"e":"input","a":{"type":"hidden","name":"directDebitType","value":"NewCard"}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"billingAccountNo","value":[{"t":2,"r":"billingAccountNo"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"directDebitSetup","value":[{"t":2,"r":"directDebitSetup"}]}}," ",{"t":7,"e":"div","a":{"class":"ippContainer"}}," ",{"t":7,"e":"div","a":{"class":"cardFrameAdditionalfields hidden"},"f":[{"t":7,"e":"div","a":{"class":"row spacer-bottom-short outer"},"f":[{"t":7,"e":"div","a":{"class":"small-12 large-4 columns"},"f":[{"t":7,"e":"label","a":{"for":"nickname"},"f":["Credit/Debit card nickname"]}]}," ",{"t":7,"e":"div","a":{"class":"small-12 large-8 columns"},"f":[{"t":7,"e":"input","a":{"type":"text","path":"cardNickname","id":"nickname"}}," ",{"t":7,"e":"div","a":{"class":"validateErrors"}}]}]}," ",{"t":7,"e":"div","a":{"class":"row spacer-bottom-short outer"},"f":[{"t":7,"e":"div","a":{"class":"small-12 columns"},"f":[{"t":7,"e":"rcheckbox","a":{"toggleKeypath":"tncNewCreditCard"}},"  Yes I've read your ",{"t":7,"e":"a","a":{"href":"//www.optus.com.au/privacy","target":"_blank","title":"Optus Privacy Policy"},"f":["privacy policy"]},". ",{"t":7,"e":"div","a":{"class":"validateErrors"}}]}]}," ",{"t":8,"r":"errorList"}," ",{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"large-4 columns spacer-bottom-short outer"},"f":[{"t":7,"e":"input","a":{"type":"submit","name":"submit","value":"Save","class":["button radius full-width ",{"t":4,"f":["disabled"],"n":51,"r":"tncNewCreditCard"}]},"m":[{"t":4,"f":["disabled=\"disabled\""],"n":51,"r":"tncNewCreditCard"}]}]}," ",{"t":7,"e":"div","a":{"class":"large-4 columns spacer-bottom-short outer"},"f":[{"t":7,"e":"button","a":{"type":"button","class":"button radius full-width teal right"},"v":{"click":"reloadPage"},"f":["Cancel"]}]}]}]}]}," ",{"t":7,"e":"script","f":["    // Only trigger if this plugin is defined in this page.\n    if (typeof $.fn.cardFrame === 'function') {\n        $('.ippContainer').cardFrame(\n                '",{"t":2,"r":"data.directDebitViewSupportModel.sessionId"},"',\n                '",{"t":2,"r":"data.directDebitViewSupportModel.sst"},"',\n                {\n                    resizeIframe: true,\n                    generateNewSST: false\n                }\n        );\n    }"]}]},"miniCartBlocks":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["block step step-",{"t":2,"r":"@index"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"block-title bold"},"f":[{"t":2,"r":"title"}]}],"n":50,"x":{"r":["keyValues.length"],"s":"_0>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"minicart-title"},"f":[{"t":2,"r":"title"}]}],"x":{"r":["keyValues.length"],"s":"_0>0"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"p","f":[{"t":4,"f":[{"t":2,"r":"keyValues.length"}," ",{"t":4,"f":["Premium Add-on"],"n":50,"x":{"r":["keyValues.length"],"s":"_0===1"}},{"t":4,"n":51,"f":["Premium Add-ons"],"x":{"r":["keyValues.length"],"s":"_0===1"}}],"n":50,"x":{"r":["keyValues.length"],"s":"_0>0"}}]}],"n":50,"x":{"r":["title"],"s":"_0===\"Premium Add-ons\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["title"],"s":"_0===\"Accessories\""},"f":[{"t":7,"e":"p","f":[{"t":4,"f":[{"t":2,"r":"keyValues.length"}," ",{"t":4,"f":["Accessory"],"n":50,"x":{"r":["keyValues.length"],"s":"_0===1"}},{"t":4,"n":51,"f":["Accessories"],"x":{"r":["keyValues.length"],"s":"_0===1"}}],"n":50,"x":{"r":["keyValues.length"],"s":"_0>0"}}]}]},{"t":4,"n":50,"x":{"r":["title"],"s":"!(_0===\"Accessories\")"},"f":[" ",{"t":7,"e":"p","f":[{"t":4,"f":[{"t":2,"r":"keyValues.length"}," ",{"t":4,"f":["Add-on"],"n":50,"x":{"r":["keyValues.length"],"s":"_0===1"}},{"t":4,"n":51,"f":["Add-ons"],"x":{"r":["keyValues.length"],"s":"_0===1"}}],"n":50,"x":{"r":["keyValues.length"],"s":"_0>0"}}]}]}],"x":{"r":["title"],"s":"_0===\"Premium Add-ons\""}}],"n":50,"x":{"r":["title"],"s":"_0===\"Add on\"||_0===\"Add-ons\"||_0===\"Add ons\"||_0===\"Accessories\"||_0===\"Premium Add-ons\""}},{"t":4,"n":51,"f":[{"t":7,"e":"p","f":[{"t":4,"f":[{"t":4,"f":[",",{"t":7,"e":"br"}],"n":50,"r":"@index"},{"t":2,"r":"value"}],"n":52,"r":"keyValues"}]}],"x":{"r":["title"],"s":"_0===\"Add on\"||_0===\"Add-ons\"||_0===\"Add ons\"||_0===\"Accessories\"||_0===\"Premium Add-ons\""}}]}],"n":52,"r":"steps"},{"t":7,"e":"div","a":{"class":"block darker mobile-inline expanded-inline"},"f":[{"t":7,"e":"div","a":{"class":"price-line"},"f":[{"t":7,"e":"div","a":{"class":"block-title bold left"},"f":[{"t":2,"r":"initData.upfrontLabel"}]}," ",{"t":7,"e":"div","a":{"class":"upfront-amount"},"f":["$",{"t":2,"x":{"r":["oneTimeCost"],"s":"_0.toFixed(2)"}}]}]}," ",{"t":7,"e":"div","a":{"class":"price-line monthly"},"f":[{"t":7,"e":"div","a":{"class":"block-title bold left"},"f":[{"t":2,"r":"initData.monthlyLabel"}]}," ",{"t":7,"e":"div","a":{"class":"monthly-amount"},"f":["$",{"t":2,"x":{"r":["monthly"],"s":"_0.toFixed(2)"}}]}]}," ",{"t":7,"e":"div","a":{"class":"expanded-hidden"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"arrow arrow-down","ontap":"expandCart","alt":"Expand cart"}}]}," ",{"t":7,"e":"div","a":{"class":"expanded-visible"},"f":[{"t":7,"e":"ux-button","a":{"class":"button round","ontap":"miniCartContinue","text":[{"t":2,"r":"initData.continueLabel"}]}}]}]}]},"miniCartPopupBlocks":{"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"modal-view"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["step step-",{"t":2,"r":"@index"}," show-for-medium-up"]},"f":[{"t":7,"e":"ux-row","a":{"class":"step-content"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"block-title bold title"},"f":[{"t":2,"r":"title"}]}],"n":50,"x":{"r":["keyValues.length"],"s":"_0>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"minicart-title bold"},"f":[{"t":2,"r":"title"}]}],"x":{"r":["keyValues.length"],"s":"_0>0"}}," ",{"t":7,"e":"p","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"block-content-first-line"},"f":[{"t":4,"f":[{"t":2,"r":"keyValues.length"}," ",{"t":4,"f":["Add-on"],"n":50,"x":{"r":["keyValues.length"],"s":"_0===1"}},{"t":4,"n":51,"f":["Add-ons"],"x":{"r":["keyValues.length"],"s":"_0===1"}}],"n":50,"x":{"r":["keyValues.length"],"s":"_0>0"}}]}],"n":50,"x":{"r":["title"],"s":"_0===\"Add on\"||_0===\"Add-ons\"||_0===\"Add ons\"||_0===\"Premium Add-ons\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["title"],"s":"_0===\"Accessories\""},"f":[{"t":7,"e":"div","a":{"class":"block-content-first-line"},"f":[{"t":4,"f":[{"t":2,"r":"keyValues.length"}," ",{"t":4,"f":["Accessory"],"n":50,"x":{"r":["keyValues.length"],"s":"_0===1"}},{"t":4,"n":51,"f":["Accessories"],"x":{"r":["keyValues.length"],"s":"_0===1"}}],"n":50,"x":{"r":["keyValues.length"],"s":"_0>0"}}]}]}],"x":{"r":["title"],"s":"_0===\"Add on\"||_0===\"Add-ons\"||_0===\"Add ons\"||_0===\"Premium Add-ons\""}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"block-details"},"f":[{"t":3,"r":"value"}]}],"n":50,"x":{"r":["title"],"s":"_0===\"Add on\"||_0===\"Add-ons\"||_0===\"Add ons\"||_0===\"Accessories\"||_0===\"Premium Add-ons\""}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["block-content-first-line"],"n":50,"x":{"r":["@index"],"s":"_0===0"}}," block-details"]},"f":[{"t":3,"r":"value"}]}],"x":{"r":["title"],"s":"_0===\"Add on\"||_0===\"Add-ons\"||_0===\"Add ons\"||_0===\"Accessories\"||_0===\"Premium Add-ons\""}}],"n":52,"r":"keyValues"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":["step-",{"t":2,"r":"@index"}," show-for-small-only mobile"]},"f":[{"t":7,"e":"ux-row","a":{"class":"step-content"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"block-title bold title"},"f":[{"t":2,"r":"title"}]}],"n":50,"x":{"r":["keyValues.length"],"s":"_0>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"minicart-title bold"},"f":[{"t":2,"r":"title"}]}],"x":{"r":["keyValues.length"],"s":"_0>0"}}," ",{"t":7,"e":"p","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"block-content-first-line"},"f":[{"t":3,"r":"value"}]}],"n":50,"x":{"r":["title"],"s":"_0===\"Add on\"||_0===\"Add-ons\"||_0===\"Add ons\"||_0===\"Accessories\"||_0===\"Premium Add-ons\""}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["block-content-first-line"],"n":50,"x":{"r":["@index"],"s":"_0===0"}}," block-details"]},"f":[{"t":3,"r":"value"}]}],"x":{"r":["title"],"s":"_0===\"Add on\"||_0===\"Add-ons\"||_0===\"Add ons\"||_0===\"Accessories\"||_0===\"Premium Add-ons\""}}],"n":52,"r":"keyValues"}]}," "]}]}],"n":52,"r":"steps"}," ",{"t":7,"e":"div","a":{"class":"block darker mobile-inline expanded-inline summary-content show-for-medium-up"},"f":[{"t":7,"e":"ux-row","a":{"class":"step-content"},"f":[{"t":7,"e":"div","a":{"class":"dark-block-title amount-title title bold"},"f":[{"t":2,"r":"initData.amountLabel"}]}," ",{"t":7,"e":"div","a":{"class":"price-line show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"block-content-first-line upfront-amount"},"f":[{"t":2,"r":"initData.upfrontLabel"}]}," ",{"t":7,"e":"div","a":{"class":"block-content-first-line upfront-amount"},"f":["$",{"t":2,"x":{"r":["upfront"],"s":"_0.toFixed(2)"}}]}]}," ",{"t":7,"e":"div","a":{"class":"price-line show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"block-content-first-line monthly-amount"},"f":[{"t":2,"r":"initData.monthlyLabel"}]}," ",{"t":7,"e":"div","a":{"class":"block-content-first-line monthly-amount"},"f":["$",{"t":2,"x":{"r":["monthly"],"s":"_0.toFixed(2)"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"price-line show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"div","a":{"class":"block-content-first-line summary-label"},"f":[{"t":2,"r":"initData.oneTimeCostLabel"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"div","a":{"class":"block-content-first-line upfront-amount"},"f":["$",{"t":2,"x":{"r":["oneTimeCost"],"s":"_0.toFixed(2)"}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"dark-block-title show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":2,"r":"initData.payUpfrontLabel"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":["$",{"t":2,"x":{"r":["upfront"],"s":"_0.toFixed(2)"}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"dark-block-title  show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":2,"r":"initData.additionLabel"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":["$",{"t":2,"x":{"r":["additionCost"],"s":"_0.toFixed(2)"}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"price-line show-for-medium-up v-medium-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"div","a":{"class":"block-content-first-line monthly-amount  summary-label show-for-medium-up"},"f":[{"t":2,"r":"initData.monthlySubscriptionLabel"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"div","a":{"class":"block-content-first-line monthly-amount"},"f":["$",{"t":2,"x":{"r":["monthly"],"s":"_0.toFixed(2)"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"expanded-hidden"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"arrow arrow-down","ontap":"expandCart","alt":"Expand cart"},"f":[{"t":2,"r":"initData.expandCartLabel"}]}]}," ",{"t":7,"e":"div","a":{"class":"expanded-visible"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"miniCartContinue"},"f":[{"t":7,"e":"ux-button","a":{"class":"button round mini-cart-button bottom-aligned-button","text":[{"t":2,"r":"initData.continueLabel"}]}}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"show-for-small-only mobile summary-content"},"f":[{"t":7,"e":"ux-row","a":{"class":"step-content"},"f":[{"t":7,"e":"div","a":{"class":"price-line"},"f":[{"t":7,"e":"div","a":{"class":"block-title amount-title title bold"},"f":[{"t":2,"r":"initData.upfrontLabel"}]},{"t":7,"e":"div","a":{"class":"upfront-amount"},"f":["$",{"t":2,"x":{"r":["upfront"],"s":"_0.toFixed(2)"}}]}]}," ",{"t":7,"e":"div","a":{"class":"price-line monthly"},"f":[{"t":7,"e":"div","a":{"class":"block-title amount-title  title bold"},"f":[{"t":2,"r":"initData.monthlyLabel"}]},{"t":7,"e":"div","a":{"class":"monthly-amount"},"f":["$",{"t":2,"x":{"r":["monthly"],"s":"_0.toFixed(2)"}}]}]}," ",{"t":7,"e":"div","a":{"class":"expanded-visible v-large-top continue-button"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"miniCartContinue","alt":[{"t":2,"r":"initData.continueLabel"}]},"f":[{"t":2,"r":"initData.continueLabel"}]}]}]}]}]}]},"mobileListingCarouselPlanContainerInner":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"carousel-itemOuterContainer carousel-itemOuterContainer-plans"},"f":[{"t":7,"e":"div","a":{"class":"carousel-itemContainer"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"carousel-item","unselectable":"off"},"f":[{"t":7,"e":"div","a":{"class":"planSummaryItem panel"},"f":[{"t":7,"e":"div","a":{"class":"planHeading"},"f":[{"t":7,"e":"h2","f":[{"t":7,"e":"span","a":{"class":"heading-emphasis"},"f":[{"t":7,"e":"sup","f":["$"]},{"t":2,"x":{"r":["helpers","productOfferingContractPrice"],"s":"_0.currencyConvert(_1)"}}]}," ",{"t":7,"e":"span","a":{"class":"uppercase calloutPlan"},"f":["per month"]}]}]}," ",{"t":7,"e":"div","a":{"class":"planViewDetails"},"v":{"tap":"doViewDetailsClick"},"f":[{"t":7,"e":"div","a":{"class":"large-10 small-10 columns"},"f":[{"t":7,"e":"h5","f":["View Details"]}]}," ",{"t":7,"e":"div","a":{"class":"large-2 small-2 columns"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"icon icon-arrow-up"}}],"n":50,"r":"viewDetails"},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"icon icon-arrow-down"}}],"r":"viewDetails"}]}]}," ",{"t":7,"e":"div","a":{"class":"planBody"},"f":[{"t":7,"e":"div","a":{"class":"planBorder"},"f":[{"t":7,"e":"h4","f":[{"t":3,"r":"allocatedCalls"}," ",{"t":4,"f":["MINS"],"n":50,"x":{"r":["allocatedCalls"],"s":"_0==\"Unlimited\""}}]}," ",{"t":7,"e":"p","a":{"class":[{"t":4,"f":["hide"],"n":51,"r":"viewDetails"}]},"f":[{"t":7,"e":"span","a":{"class":"planCalloutText"},"f":[{"t":3,"r":"tcpStdCallText"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"planBorder"},"f":[{"t":7,"e":"h4","f":[{"t":3,"r":"tcpStdSmsValue"}," SMS/MMS"]}," ",{"t":7,"e":"p","a":{"class":[{"t":4,"f":["hide"],"n":51,"r":"viewDetails"}]},"f":[{"t":7,"e":"span","a":{"class":"planCalloutText"},"f":[{"t":3,"r":"tcpStdSmsText"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"planBorder"},"f":[{"t":7,"e":"h4","f":[{"t":3,"r":"allocatedData"}," "]}," ",{"t":7,"e":"p","a":{"class":[{"t":4,"f":["hide"],"n":51,"r":"viewDetails"}]},"f":[{"t":7,"e":"span","a":{"class":"planCalloutText"},"f":["$10 per extra 1GB"]},{"t":7,"e":"br"},{"t":7,"e":"span","a":{"class":"planCalloutText"},"f":["Cost of ",{"t":3,"r":"tcpMbDataText"}," ",{"t":3,"r":"tcpMbDataValue"}]}]}]}," ",{"t":7,"e":"p","f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"documentWrapperPath"}]},"v":{"tap":"doNavigate"},"f":["Critical Info Summary"]}]}," ",{"t":7,"e":"p","f":[{"t":7,"e":"a","a":{"href":"#","class":"button radius small yellow full-width planSelectButton","data-column":[{"t":2,"r":"@index"}]},"v":{"tap":"doSelectPlan"},"f":[{"t":2,"x":{"r":["selectedColumn","@index"],"s":"_0==_1?\"Selected\":\"Select this plan\""}}]}]}]}]}]}],"n":52,"r":"."}]}]}]},"mobileListingItem":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"mobileListingItem"},"f":[{"t":7,"e":"div","a":{"class":"feature-container"},"f":[{"t":7,"e":"h3","a":{"class":"heading-tertiary"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"feature-body"},"f":[{"t":7,"e":"div","a":{"class":"row display"},"f":[{"t":7,"e":"div","a":{"class":"large-4 small-4 columns"},"f":[{"t":7,"e":"img","a":{"class":"handset_img","src":[{"t":2,"r":"mediaAsset"}],"alt":[{"t":2,"r":"title"}]}}," ",{"t":7,"e":"p","a":{"class":"moreInfoLink marginLeft"},"f":[{"t":7,"e":"a","a":{"class":"moreInfo","href":[{"t":2,"x":{"r":["helpers","."],"s":"_0.linkToProductSelector(_1)"}}]},"f":["More info"]}]}," ",{"t":4,"f":[{"t":7,"e":"img","a":{"class":"network_img marginLeft","src":[{"t":2,"r":"networkCoverageMediaAsset"}],"alt":[{"t":2,"r":"title"}]}}],"n":50,"r":"networkCoverageMediaAsset"}]}," ",{"t":7,"e":"div","a":{"class":"large-8 small-8 columns deviceTileRightColumn"},"f":[{"t":7,"e":"div","a":{"class":"device-price show-for-large-up"},"f":[{"t":7,"e":"strong","f":[{"t":7,"e":"sup","f":["$"]},{"t":2,"x":{"r":["helpers","phatPrice"],"s":"_0.currencyConvert(_1)"}}]}," ",{"t":7,"e":"br","a":{"class":"show-for-medium-down"}}," ",{"t":7,"e":"span","a":{"class":"price-per-month"},"f":["Per Month"]}]}," ",{"t":7,"e":"div","a":{"class":"device-price-small show-for-medium-down"},"f":[{"t":7,"e":"div","a":{"class":"small-6 medium-6 columns"},"f":[{"t":7,"e":"strong","f":[{"t":7,"e":"sup","f":["$"]},{"t":2,"x":{"r":["helpers","phatPrice"],"s":"_0.currencyConvert(_1)"}}]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","a":{"class":"price-per-month"},"f":["Per Month"]}]}," ",{"t":7,"e":"div","a":{"class":"small-6 medium-6 columns borderLeft"},"f":[{"t":7,"e":"div","a":{"class":"small-12 medium-12 columns subPrice"},"f":[{"t":7,"e":"strong","f":[{"t":7,"e":"sup","f":["$"]},{"t":2,"x":{"r":["helpers","planData.planPrice"],"s":"_0.currencyConvert(_1)"}}]}," ",{"t":7,"e":"span","a":{"class":"berryBorderinfoText"},"f":["Plan"]}]}," ",{"t":7,"e":"div","a":{"class":"small-12 medium-12 columns subPrice subPricePlus"},"f":["+"]}," ",{"t":7,"e":"div","a":{"class":"small-12 medium-12 columns subPrice"},"f":[{"t":7,"e":"strong","f":[{"t":7,"e":"sup","f":["$"]},{"t":2,"x":{"r":["helpers","handsetRepayments"],"s":"_0.currencyConvert(_1)"}}]}," ",{"t":7,"e":"span","a":{"class":"berryBorderinfoText"},"f":["Phone"]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"small-12 medium-12 large-12 columns handset_mtc"},"f":[{"t":7,"e":"strong","f":["Min total cost over ",{"t":2,"r":"contractLength"}," months is $",{"t":2,"x":{"r":["helpers","totalMinimumCost"],"s":"_0.currencyConvert(_1)"}}]}]}," ",{"t":7,"e":"div","a":{"class":"large-12 columns berry-info-box-column"},"f":[{"t":7,"e":"div","a":{"class":"berry-info-box show-for-large-up"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"strong","f":[{"t":7,"e":"sup","f":["$"]},{"t":2,"x":{"r":["helpers","planData.planPrice"],"s":"_0.currencyConvert(_1)"}}]}," ",{"t":7,"e":"span","a":{"class":"berryBorderinfoText"},"f":["Plan"]}," + ",{"t":7,"e":"strong","f":[{"t":7,"e":"sup","f":["$"]},{"t":2,"x":{"r":["helpers","handsetRepayments"],"s":"_0.currencyConvert(_1)"}}]}," ",{"t":7,"e":"span","a":{"class":"berryBorderinfoText"},"f":["Phone"]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"product-configuration-section"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"hide-for-touch"},"f":[{"t":4,"f":[{"t":7,"e":"form","a":{"action":"","id":"custom","class":"custom"},"v":{"submit":""},"f":[{"t":7,"e":"div","a":{"class":"large-12 small-12 columns itemCoulorArea"},"f":[{"t":7,"e":"select","a":{"class":"medium","value":[{"t":2,"r":"activeColour"}],"name":"colourSelectLarge"},"v":{"change":{"n":"doProductConfigChange","a":"activeColour"}},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":"."}]},"f":[{"t":2,"r":"."}]}],"n":52,"r":"colours"}]}]}]}],"n":51,"x":{"r":["colours.length"],"s":"_0==1"}}]}," ",{"t":7,"e":"div","a":{"class":"show-for-touch"},"f":[{"t":7,"e":"div","a":{"class":"large-12 small-12 columns itemCoulorArea"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"select","a":{"class":"medium","value":[{"t":2,"r":"activeColour"}],"name":"colourSelectSmall"},"v":{"change":{"n":"doProductConfigChange","a":"activeColour"}},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":"."}]},"f":[{"t":2,"r":"."}]}],"n":52,"r":"colours"}]}]}],"n":51,"x":{"r":["colours.length"],"s":"_0==1"}}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"large-4 small-4 columns"},"f":[{"t":7,"e":"a","a":{"value":[{"t":2,"r":"./capacity"}],"class":["button radius small capacityButton ",{"t":4,"f":["active"],"n":50,"x":{"r":["../../activeCapacity","./capacity"],"s":"_0==_1"}}," ",{"t":4,"f":["outofstock"],"n":50,"x":{"r":["stockStatus"],"s":"_0==\"outofstock\""}}]},"v":{"tap":{"n":"doProductConfigClick","a":"activeCapacity"}},"f":[{"t":2,"r":"./capacity"}]}]}],"n":52,"r":"capacities"}],"n":51,"x":{"r":["capacities.length"],"s":"_0==1"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["stockConfigBanner ",{"t":4,"f":["noPointer"],"n":50,"x":{"r":["capacities.length"],"s":"_0==1"}}," ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["stockStatus"],"s":"_0==\"outofstock\""}}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"large-12 small-12 columns"},"f":[{"t":4,"f":["Out of Stock"],"n":50,"x":{"r":["stockStatus"],"s":"_0==\"outofstock\""}},{"t":4,"n":51,"f":["In Stock"],"x":{"r":["stockStatus"],"s":"_0==\"outofstock\""}}]}]}]}],"n":50,"x":{"r":["colours.length"],"s":"_0==1"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":["stockConfigBanner ",{"t":4,"f":["noPointer"],"n":50,"x":{"r":["capacities.length"],"s":"_0==1"}}," ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["stockStatus"],"s":"_0==\"outofstock\""}}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"large-12 small-12 columns"},"f":[{"t":3,"r":"../../activeCapacity"}," ",{"t":3,"r":"../../activeColour"}," ",{"t":4,"f":["- Out of Stock"],"n":50,"x":{"r":["stockStatus"],"s":"_0==\"outofstock\""}},{"t":4,"n":51,"f":["- In Stock"],"x":{"r":["stockStatus"],"s":"_0==\"outofstock\""}}]}]}]}],"x":{"r":["colours.length"],"s":"_0==1"}}]}]}," ",{"t":7,"e":"div","a":{"class":"row text-center addTocartDiv"},"f":[{"t":7,"e":"div","a":{"class":"large-12 small-12 columns "},"f":[{"t":4,"f":[{"t":7,"e":"a","a":{"href":"#","disabled":0,"class":"disabled button radius large yellow phoneSelectButton"},"v":{"tap":"doDisabledNavigate"},"f":["Out of Stock"]}],"n":50,"x":{"r":["stockStatus"],"s":"_0==\"outofstock\""}},{"t":4,"n":51,"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"addToCartUrl"},{"t":4,"f":["&atcid=",{"t":2,"r":"timestamp"}],"n":51,"x":{"r":["flow"],"s":"_0==\"RECONTRACT\""}}],"class":"button radius large yellow phoneSelectButton"},"v":{"click":"doNavigate"},"f":["Add to Cart"]}],"x":{"r":["stockStatus"],"s":"_0==\"outofstock\""}}]}]}]}]}]}]},"Modal":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"modal_bg show"}}," ",{"t":7,"e":"div","a":{"id":[{"t":2,"r":"id"}],"class":["modal full_modal ",{"t":2,"r":"size"}," ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"a","a":{"class":"close_modal"},"v":{"click":"doCloseModal"},"f":[" "]}," ",{"t":7,"e":"div","a":{"class":"modalContent"},"f":[{"t":8,"r":"content"}]}]}],"r":"displayState"}]},"myAccountGeneralError":{"v":3,"t":[{"t":7,"e":"ux-panel","a":{"class":"light-panel error-panel"},"f":[{"t":7,"e":"ux-header","f":["We are working on it!"]}," ",{"t":7,"e":"ux-header","a":{"level":"3"},"f":["We are currently experiencing some technical difficulties. Please try again soon!"]}]}]},"myEntertainmentPlansList":{"v":3,"t":[{"t":7,"e":"div","a":{"class":[{"t":2,"r":"spinner"}," spin-flex-container spinner-container"]},"f":[{"t":7,"e":"ux-spinner","a":{"class":"spin-flex-view"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":[{"t":2,"r":"template"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"large-8"},"f":[{"t":7,"e":"ux-header","a":{"level":"1"},"f":[{"t":2,"r":"cmsContent.section_name"}]}," ",{"t":7,"e":"span","a":{"class":"doubleTopSeparated"},"f":[{"t":2,"r":"cmsContent.ineligible_copy"}]}]}]}],"n":50,"x":{"r":["serviceListOptions.length"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":["service-list-container ",{"t":2,"r":"template"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"service-list-header showPlans"},"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 large-9 medium-12 breadcrumb-link backButton ",{"t":2,"r":"planView"}]},"f":[{"t":7,"e":"a","a":{"href":"javascript:void(0);"},"v":{"click":"goBack"},"f":[{"t":7,"e":"span","a":{"class":"left"},"f":[{"t":7,"e":"ux-icon","a":{"class":"icon icon-arrow-left xl"}}]}," ",{"t":7,"e":"span","a":{"class":"left text-link"},"f":["Back to ",{"t":2,"r":"cmsContent.section_name"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"clearfix"}}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 large-9 medium-12 left"},"f":[{"t":7,"e":"ux-header","a":{"level":"1"},"f":[{"t":2,"r":"cmsContent.section_name"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":["service-list-content ",{"t":2,"r":"plansListView"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-9 medium-12"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"cmsContent.service_list_desc"}]}]}," ",{"t":7,"e":"div","a":{"class":"clearfix"}}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 large-7 medium-12 show-for-medium-up serviceListWrap"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-12 medium-12 service-list-section-container"},"f":[{"t":7,"e":"a","v":{"click":{"n":"onClickPlan","d":[{"t":2,"r":"serviceId"}]}},"a":{"class":"hidden-link"},"f":[{"t":7,"e":"ux-row","a":{"class":"service-list-section vertical-align-containers"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-1 section-icon"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-icon","a":{"class":"icon ico-mobile xl"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 section-service-id"},"f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"serviceId"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 section-subtext text-left"},"f":[{"t":7,"e":"span","a":{"class":"plan-subtext"},"f":[{"t":2,"r":"serviceType"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 section-price"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":7,"e":"sup","f":["$ "]},{"t":2,"x":{"r":["getBoltonPrice","myEntertainmentBoltonPrice"],"s":"_0(_1)"}}]}," ",{"t":7,"e":"ux-header","a":{"level":"6","class":"price-frequency"},"f":["Monthly"]}]}],"n":50,"r":"myEntertainmentBoltonPrice"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 section-price"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":7,"e":"sup","f":[" "]}," "]}," ",{"t":7,"e":"ux-header","a":{"level":"6","class":"price-frequency"},"f":[" "]}]}],"r":"myEntertainmentBoltonPrice"}," ",{"t":7,"e":"ux-col","a":{"class":"small-1 section-icon-teal"},"f":[{"t":7,"e":"ux-icon","a":{"class":"icon icon-arrow-right xl hover-color"}}]}]}]}]}]}],"r":"serviceListOptions"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12 hide-for-medium-up"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-12 medium-12 service-list-section-container"},"f":[{"t":7,"e":"a","v":{"click":{"n":"onClickPlan","d":[{"t":2,"r":"serviceId"}]}},"a":{"class":"hidden-link"},"f":[{"t":7,"e":"ux-row","a":{"class":"service-list-section vertical-align-containers"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 section-icon"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-icon","a":{"class":"icon ico-mobile xl"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 section-service-id text-left"},"f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"serviceId"}]}," ",{"t":7,"e":"span","a":{"class":"plan-subtext ellipsis small-12 columns text-left remove-left-padding"},"f":[{"t":2,"r":"serviceType"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 section-price"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":7,"e":"sup","f":["$ "]},{"t":2,"x":{"r":["getBoltonPrice","myEntertainmentBoltonPrice"],"s":"_0(_1)"}}]}," ",{"t":7,"e":"ux-header","a":{"level":"6","class":"price-frequency"},"f":["Monthly"]}]}],"n":50,"r":"myEntertainmentBoltonPrice"}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 section-icon-teal"},"f":[{"t":7,"e":"ux-icon","a":{"class":"icon icon-arrow-right xl hover-color"}}]}]}]}]}]}],"r":"serviceListOptions"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":[{"t":2,"r":"planView"}]},"f":[" ",{"t":7,"e":"ux-row","a":{"class":"service-list-content show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-7 medium-12"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-12 medium-12 service-list-section-container"},"f":[{"t":7,"e":"ux-row","a":{"class":"service-list-section vertical-align-containers"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-1 section-icon"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-icon","a":{"class":"icon ico-mobile xl"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 section-service-id"},"f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"plan.serviceId"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 section-subtext text-left"},"f":[{"t":7,"e":"span","a":{"class":"plan-subtext"},"f":[{"t":2,"r":"plan.serviceType"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 section-price"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":7,"e":"sup","f":["$ "]},{"t":2,"x":{"r":["getBoltonPrice","plan.myEntertainmentBoltonPrice"],"s":"_0(_1)"}}]}," ",{"t":7,"e":"ux-header","a":{"level":"6","class":"price-frequency"},"f":["Monthly"]}]}],"n":50,"r":"plan.myEntertainmentBoltonPrice"}]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"service-list-content hide-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-7 medium-12"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-12 medium-12 service-list-section-container"},"f":[{"t":7,"e":"ux-row","a":{"class":"service-list-section vertical-align-containers"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 section-icon"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-icon","a":{"class":"icon ico-mobile xl"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-7 section-service-id text-left"},"f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"plan.serviceId"}]}," ",{"t":7,"e":"span","a":{"class":"plan-subtext ellipsis small-12 columns text-left remove-left-padding"},"f":[{"t":2,"r":"plan.serviceType"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-3 section-price"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":7,"e":"sup","f":["$ "]},{"t":2,"x":{"r":["getBoltonPrice","plan.myEntertainmentBoltonPrice"],"s":"_0(_1)"}}]}," ",{"t":7,"e":"ux-header","a":{"level":"6","class":"price-frequency"},"f":["Monthly"]}]}],"n":50,"r":"plan.myEntertainmentBoltonPrice"}]}]}]}]}]}]}]}],"x":{"r":["serviceListOptions.length"],"s":"!_0"}}]},"myOrdersOrderList":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-accordion-sd","a":{"style":"order","description":[{"t":2,"r":"description"}],"opened":[{"t":2,"r":"isOpened"}],"icons_services":[{"t":2,"x":{"r":["initServicesIcons","implOrderActionOutput"],"s":"_0(_1)"}}],"orderDate":[{"t":2,"x":{"r":["RactiveHelpers","orderCreationDateTime"],"s":"_0.formatTimestampToDate(_1)"}}],"number":[{"t":2,"r":"orderId"}]},"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"ux-list-item","a":{"icon_right":[{"t":4,"f":["arrow-right"],"n":50,"r":"../../isCompleteTab"}],"icon_right_size":[{"t":4,"f":["xl"],"n":50,"r":"../../isCompleteTab"}],"onclick":[{"t":4,"f":["showServiceDetails:",{"t":2,"r":"orderActionId"}],"n":50,"r":"../../isCompleteTab"}],"icon_left":"warning-circular","icon_left_size":"xl","primary_text":[{"t":2,"r":"planName"}],"secondary_text":[{"t":4,"f":[{"t":2,"r":"description"}],"n":50,"x":{"r":["shipmentDeliveryDetails"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["getLastShipmentStatus","shipmentDeliveryDetails"],"s":"_0(_1)"}}],"x":{"r":["shipmentDeliveryDetails"],"s":"!_0"}}]},"f":[]}],"n":52,"r":"implOrderActionOutput"}]}]}],"n":52,"r":"list"}]},"notificationCheckboxList":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"checkbox-list"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["checkbox-wrapper ",{"t":2,"r":"class"}," ",{"t":4,"f":["v-p-normal"],"n":51,"r":"textValue"}]},"f":[{"t":7,"e":"input","a":{"type":"checkbox","id":[{"t":2,"r":"namePattern"},"-",{"t":2,"r":"@index"}],"value":[{"t":2,"r":"head"},":",{"t":2,"r":"value"}],"checked":[{"t":2,"r":"notify"}]}}," ",{"t":7,"e":"label","a":{"class":"v-p-small","for":[{"t":2,"r":"namePattern"},"-",{"t":2,"r":"@index"}]},"f":[{"t":7,"e":"div","a":{"class":"head"},"f":[{"t":2,"r":"head"},{"t":4,"f":[":"],"n":50,"r":"textValue"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"value"},"f":[{"t":7,"e":"span","f":[{"t":3,"r":"textValue"}]}," ",{"t":4,"f":[{"t":7,"e":"small","a":{"class":"annotation"},"f":[{"t":2,"r":"annotation"}]}],"n":50,"r":"annotation"}]}],"n":50,"r":"textValue"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"name":[{"t":2,"r":"head"}],"class":[{"t":2,"x":{"r":["head"],"s":"_0.replace(/\\s/g,\"-\").toLowerCase()"}},"-change"],"ontap":"openModal","ariaLabel":["Change ",{"t":2,"r":"head"}," Link"]},"f":[{"t":2,"r":"ctaText"}]}],"r":"changeCTA"}]}],"n":52,"r":"checkboxes"}]}]},"notificationMultiType":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":[{"t":2,"r":"initData.title"}]}," ",{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"initData.description"}]}," ",{"t":7,"e":"ux-accordion","a":{"data":[{"t":2,"r":"."}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"div","a":{"class":"blabla"},"f":["blabla"]}," ",{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":[{"t":2,"rx":{"r":"data.initData.notificationTypes","m":[{"t":30,"n":"@index"},"title"]}}]}," ",{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"rx":{"r":"data.initData.notificationTypes","m":[{"t":30,"n":"@index"},"description"]}}]}]}," ",{"t":7,"e":"ux-content","f":[{"t":7,"e":"ux-manage-items","a":{"datamodel":[{"t":3,"r":"."}]}}]}]}],"n":52,"r":"data.notificationTypes"}]}]}]}]},"notificationService":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"notification-service"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"v-small-bottom"},"f":["Service ID: ",{"t":2,"r":"subscriberId"}]}," ",{"t":7,"e":"div","a":{"class":"usages"},"f":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":"description v-normal-bottom"},"f":[{"t":2,"r":"name"},{"t":7,"e":"br"},{"t":2,"r":"available"}," Data available of ",{"t":2,"r":"total"}," Shared"]}," ",{"t":7,"e":"div","a":{"class":"usage-wrapper v-small-bottom"},"f":[{"t":7,"e":"p","a":{"class":"head v-small-bottom"},"f":[{"t":2,"r":"head"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["checkbox-wrapper step-",{"t":2,"r":"@index"}]},"f":[{"t":7,"e":"input","a":{"type":"checkbox","id":["service-",{"t":2,"r":"serviceIndex"},"-data-usage-step-",{"t":2,"r":"@index"}],"name":[{"t":2,"r":"../../checkboxname"}],"value":[{"t":2,"r":"value"}]}}," ",{"t":7,"e":"label","a":{"for":["service-",{"t":2,"r":"serviceIndex"},"-data-usage-step-",{"t":2,"r":"@index"}],"class":"v-p-normal data-usage-step"},"f":[{"t":2,"r":"initData.subscriptions.servicesUsage.dataLabelValue"}," ",{"t":2,"r":"labelvalue"},"%"]}]}],"n":52,"r":"steps"}]}],"r":"dataUsage"}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"description v-normal-bottom"},"f":[{"t":2,"r":"name"},{"t":7,"e":"br"},{"t":2,"r":"available"}," SMS available of a total ",{"t":2,"r":"total"}," SMS"]}," ",{"t":7,"e":"div","a":{"class":"usage-wrapper v-small-bottom"},"f":[{"t":7,"e":"p","a":{"class":"head v-small-bottom"},"f":[{"t":2,"r":"head"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["checkbox-wrapper step-",{"t":2,"r":"@index"}]},"f":[{"t":7,"e":"input","a":{"type":"checkbox","id":["service-",{"t":2,"r":"serviceIndex"},"-sms-usage-step-",{"t":2,"r":"@index"}],"name":[{"t":2,"r":"../../checkboxname"}],"value":[{"t":2,"r":"value"}]}}," ",{"t":7,"e":"label","a":{"for":["service-",{"t":2,"r":"serviceIndex"},"-sms-usage-step-",{"t":2,"r":"@index"}],"class":"v-p-normal data-usage-step"},"f":[{"t":2,"r":"initData.subscriptions.servicesUsage.smsLabelValue"}," ",{"t":2,"r":"labelvalue"},"%"]}]}],"n":52,"r":"steps"}]}],"r":"smsUsage"}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"description v-normal-bottom"},"f":[{"t":2,"r":"name"},{"t":7,"e":"br"},{"t":2,"r":"available"}," min available of a total ",{"t":2,"r":"total"}," min"]}," ",{"t":7,"e":"div","a":{"class":"usage-wrapper v-small-bottom"},"f":[{"t":7,"e":"p","a":{"class":"head v-small-bottom"},"f":[{"t":2,"r":"head"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["checkbox-wrapper step-",{"t":2,"r":"@index"}]},"f":[{"t":7,"e":"input","a":{"type":"checkbox","id":["service-",{"t":2,"r":"serviceIndex"},"-voice-usage-step-",{"t":2,"r":"@index"}],"name":[{"t":2,"r":"../../checkboxname"}],"value":[{"t":2,"r":"value"}]}}," ",{"t":7,"e":"label","a":{"for":["service-",{"t":2,"r":"serviceIndex"},"-voice-usage-step-",{"t":2,"r":"@index"}],"class":"v-p-normal data-usage-step"},"f":[{"t":2,"r":"initData.subscriptions.servicesUsage.voiceLabelValue"}," ",{"t":2,"r":"labelvalue"},"%"]}]}],"n":52,"r":"steps"}]}],"r":"voiceUsage"}]}," ",{"t":7,"e":"ux-checkbox","a":{"class":"do-not-notify v-p-normal","labelvalue":[{"t":2,"r":"initData.subscriptions.servicesUsage.doNotNotifyLabelvalue"}],"checked":[{"t":2,"r":"doNotNotify"}]},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"users-wrapper"},"f":[{"t":7,"e":"p","a":{"class":"head strong v-small-bottom"},"f":[{"t":2,"r":"initData.serviceUsersHead"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"user-item v-p-small"},"f":[{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"type":"tv","size":"xl"}}],"n":50,"x":{"r":["icon"],"s":"_0===\"TV\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["icon"],"s":"_0===\"WS\""},"f":[{"t":7,"e":"ux-icon","a":{"type":"phoneservice","size":"xl"}}]},{"t":4,"n":50,"x":{"r":["icon"],"s":"(!(_0===\"WS\"))&&(_0===\"WL\")"},"f":[" ",{"t":7,"e":"ux-icon","a":{"type":"home-wireless-broadband","size":"xl"}}]},{"t":4,"n":50,"x":{"r":["icon"],"s":"(!(_0===\"WS\"))&&((!(_0===\"WL\"))&&(_0===\"IN\"))"},"f":[" ",{"t":7,"e":"ux-icon","a":{"type":"internet","size":"xl"}}]},{"t":4,"n":50,"x":{"r":["icon"],"s":"(!(_0===\"WS\"))&&((!(_0===\"WL\"))&&((!(_0===\"IN\"))&&(_0===\"FP\")))"},"f":[" ",{"t":7,"e":"ux-icon","a":{"type":"fixed-line","size":"xl"}}]}],"x":{"r":["icon"],"s":"_0===\"TV\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"r":"name"}]}],"n":50,"r":"name"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"number"},"f":[{"t":2,"r":"number"}]}],"n":50,"r":"number"}]}],"n":52,"r":"users"}]}],"n":50,"r":"users"}]}]},"notificationStandAloneType":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":[{"t":2,"r":"initData.title"}]}," ",{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"initData.description"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-manage-items","a":{"datamodel":[{"t":3,"r":"."}]}}],"n":53,"r":"notificationType"}]}]}]},"opcAlertMessage":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-alert","a":{"datamodel":["{ 'text': '",{"t":2,"r":".message"},"', 'class': '",{"t":2,"r":".class"},"' }"]}}]}]}],"r":"opcAlert"}]},"opcErrorMessage":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"error"},"f":[{"t":7,"e":"small","f":[{"t":2,"r":"errorMsgObj.message"}]}]}],"n":50,"x":{"r":["errorMsgObj.status"],"s":"_0===\"error\""}}]},"opcSummaryAdditionalReport":{"v":3,"t":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-header","a":{"level":"6"},"f":["Additional Options"]}," ",{"t":7,"e":"ux-row","a":{"class":"small-offset-1"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-2"},"f":[{"t":7,"e":"label","a":{"for":"reportType"},"f":["Report Type:"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-10"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-checkbox","a":{"on":[{"t":2,"r":"data.CORPORATE"}],"labelvalue":"Corporate (Predefined Available Number)"},"f":[]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-checkbox","a":{"on":[{"t":2,"r":"data.CORPORATE_GOLD"}],"labelvalue":"Corporate Gold"},"f":[]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-checkbox","a":{"on":[{"t":2,"r":"data.CORPORATE_PREMIUM"}],"labelvalue":"Corporate Premium"},"f":[]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-checkbox","a":{"on":[{"t":2,"r":"data.INTERNATIONAL"}],"labelvalue":"International"},"f":[]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-checkbox","a":{"on":[{"t":2,"r":"data.ALPHA"}],"labelvalue":"Alpha/Shortcode"},"f":[]}]}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-2"},"f":[{"t":7,"e":"label","a":{"for":"numberPattern"},"f":["Number pattern:"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-input-box","a":{"name":"numberPattern","value":[{"t":2,"r":"data.numberPattern"}],"placeholder":""},"f":[]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"opcErrorMessage"}],"x":{"r":["data.numberPatternErrorMsg"],"s":"{errorMsgObj:_0}"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-1"}}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-2"},"f":[{"t":7,"e":"label","a":{"for":"zeroTransaction"},"f":["Zero Transactions only:"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-checkbox","a":{"on":[{"t":2,"r":"data.showOnlyZeroTransaction"}],"labelvalue":" "},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-1"}}]}]}]}]}]}]}]},"opcSummaryExportLinks":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 text-left"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"data.summaryListUrl"},"/XLS"]},"f":["Export XLS"]}," | ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"data.summaryListUrl"},"/CSV"]},"f":["Export CSV"]}],"n":50,"r":"data.reportSummaries"}]}]}]},"opcSummaryShortCodeSmsMmsResult":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"table","a":{"class":"ux-table full-width small-12","role":"grid"},"f":[{"t":7,"e":"thead","a":{"class":"header-class"},"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"ux-table-head-cell","a":{"datamodel":"{\n\t\t\t\t\t\t\t'sortConfig': {\n\t\t\t\t\t\t\t\t'field': 'DETAIL_PARTNER_NAME',\n\t\t\t\t\t\t\t\t'direction': 'DESC',\n\t\t\t\t\t\t\t\t'sort': 'true',\n\t\t\t\t\t\t\t\t'sorted': 'false' }\n\t\t\t\t\t\t}","class":"subsection-header"},"f":[{"t":7,"e":"span","f":["Partner Name"]}]}," ",{"t":7,"e":"ux-table-head-cell","a":{"datamodel":"{\n\t\t\t\t\t\t\t'sortConfig': {\n\t\t\t\t\t\t\t\t'field': 'DETAIL_A_PARTY',\n\t\t\t\t\t\t\t\t'direction': 'DESC',\n\t\t\t\t\t\t\t\t'sort': 'true',\n\t\t\t\t\t\t\t\t'sorted': 'false' }\n\t\t\t\t\t\t}","class":"subsection-header"},"f":[{"t":7,"e":"span","f":["A-Party"]}]}," ",{"t":7,"e":"ux-table-head-cell","a":{"datamodel":"{\n\t\t\t\t\t\t\t'sortConfig': {\n\t\t\t\t\t\t\t\t'field': 'DETAIL_TRANSACTION_TYPE',\n\t\t\t\t\t\t\t\t'direction': 'DESC',\n\t\t\t\t\t\t\t\t'sort': 'true',\n\t\t\t\t\t\t\t\t'sorted': 'false' }\n\t\t\t\t\t\t}","class":"subsection-header"},"f":[{"t":7,"e":"span","f":["Transaction Type"]}]}," ",{"t":7,"e":"ux-table-head-cell","a":{"datamodel":"{\n\t\t\t\t\t\t\t'sortConfig': {\n\t\t\t\t\t\t\t\t'field': 'DETAIL_NUMBER_TYPE',\n\t\t\t\t\t\t\t\t'direction': 'DESC',\n\t\t\t\t\t\t\t\t'sort': 'true',\n\t\t\t\t\t\t\t\t'sorted': 'false' }\n\t\t\t\t\t\t}","class":"subsection-header"},"f":[{"t":7,"e":"span","f":["Number Type"]}]}," ",{"t":7,"e":"ux-table-head-cell","a":{"datamodel":"{\n\t\t\t\t\t\t\t'sortConfig': {\n\t\t\t\t\t\t\t\t'field': 'DETAIL_PRODUCT_CODE',\n\t\t\t\t\t\t\t\t'direction': 'DESC',\n\t\t\t\t\t\t\t\t'sort': 'true',\n\t\t\t\t\t\t\t\t'sorted': 'false' }\n\t\t\t\t\t\t}","class":"subsection-header"},"f":[{"t":7,"e":"span","f":["Product Code"]}]}," ",{"t":7,"e":"ux-table-head-cell","a":{"datamodel":"{\n\t\t\t\t\t\t\t'sortConfig': {\n\t\t\t\t\t\t\t\t'field': 'DETAIL_NO_OF_TRANSACTION',\n\t\t\t\t\t\t\t\t'direction': 'DESC',\n\t\t\t\t\t\t\t\t'sort': 'true',\n\t\t\t\t\t\t\t\t'sorted': 'false' }\n\t\t\t\t\t\t}","class":"subsection-header"},"f":[{"t":7,"e":"span","f":["# of Transactions"]}]}]}]}," ",{"t":7,"e":"tbody","a":{"class":"body-class"},"f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"row-class"},"f":[{"t":7,"e":"td","f":[{"t":2,"r":"optusPartnerId"}]}," ",{"t":7,"e":"td","f":[{"t":2,"r":"productCode"}]}," ",{"t":7,"e":"td","f":[{"t":2,"r":"transactions"}]}," ",{"t":7,"e":"td","f":[{"t":2,"r":"optusPartnerId"}]}," ",{"t":7,"e":"td","f":[{"t":2,"r":"productCode"}]}," ",{"t":7,"e":"td","f":[{"t":2,"r":"transactions"}]}]}],"r":"data.reportSummaries"}]}]}]}]}]},"opcSummaryShortCodeSmsMmsTabArea":{"v":3,"t":[{"t":7,"e":"ux-tabarea","a":{"data":["{ 'reportSummaries': ",{"t":2,"r":"data.reportSummaries"},", 'summaryListUrl': ",{"t":2,"r":"data.summaryListUrl"}," }"]},"f":[{"t":7,"e":"ux-tablinks","f":[{"t":7,"e":"ux-tablink","a":{"active":"true"},"f":[{"t":7,"e":"ux-header","a":{"level":"6"},"f":["Summary"]}]}," ",{"t":7,"e":"ux-tablink","f":[{"t":7,"e":"ux-header","a":{"level":"6"},"f":["Details"]}]}]}," ",{"t":7,"e":"ux-tabpanes","a":{"data":["{ 'reportSummaries': ",{"t":2,"r":"data.reportSummaries"},", 'summaryListUrl': ",{"t":2,"r":"data.summaryListUrl"}," }"]},"f":[{"t":7,"e":"ux-tabpane","a":{"data":["{ 'reportSummaries': ",{"t":2,"r":"data.reportSummaries"},", 'summaryListUrl': ",{"t":2,"r":"data.summaryListUrl"}," }"]},"f":[{"t":8,"r":"opcSummaryExportLinks"}," ",{"t":8,"r":"opcSummarySmsMmsResult"}]}," ",{"t":7,"e":"ux-tabpane","a":{"data":["{ 'reportSummaries': ",{"t":2,"r":"data.reportSummaries"},", 'summaryListUrl': ",{"t":2,"r":"data.summaryListUrl"}," }"]},"f":[{"t":8,"r":"opcSummaryExportLinks"}," ",{"t":8,"r":"opcSummaryShortCodeSmsMmsResult"}]}]}]}]},"opcSummarySmsMmsResult":{"v":3,"t":[{"t":7,"e":"table","a":{"class":"ux-table full-width small-12","role":"grid"},"f":[{"t":7,"e":"thead","a":{"class":"header-class"},"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"ux-table-head-cell","a":{"datamodel":"{\n\t\t\t\t\t'sortConfig': {\n\t\t\t\t\t\t'field': 'PARTNER_NAME',\n\t\t\t\t\t\t'direction': 'DESC',\n\t\t\t\t\t\t'sort': 'true',\n\t\t\t\t\t\t'sorted': 'false' }\n\t\t\t\t}","class":"subsection-header"},"f":[{"t":7,"e":"span","f":["Partner Name"]}]}," ",{"t":7,"e":"ux-table-head-cell","a":{"datamodel":"{\n\t\t\t\t\t'sortConfig': {\n\t\t\t\t\t\t'field': 'PRODUCT_CODE',\n\t\t\t\t\t\t'direction': 'DESC',\n\t\t\t\t\t\t'sort': 'true',\n\t\t\t\t\t\t'sorted': 'false' }\n\t\t\t\t}","class":"subsection-header"},"f":[{"t":7,"e":"span","f":["Product Code"]}]}," ",{"t":7,"e":"ux-table-head-cell","a":{"datamodel":"{\n\t\t\t\t\t'sortConfig': {\n\t\t\t\t\t\t'field': 'NO_OF_TRANSACTION',\n\t\t\t\t\t\t'direction': 'DESC',\n\t\t\t\t\t\t'sort': 'true',\n\t\t\t\t\t\t'sorted': 'false' }\n\t\t\t\t}","class":"subsection-header"},"f":[{"t":7,"e":"span","f":["# of Transactions"]}]}]}]}," ",{"t":7,"e":"tbody","a":{"class":"body-class"},"f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"row-class"},"f":[{"t":7,"e":"td","f":[{"t":2,"r":"optusPartnerId"}]}," ",{"t":7,"e":"td","f":[{"t":2,"r":"productCode"}]}," ",{"t":7,"e":"td","f":[{"t":2,"r":"transactions"}]}]}],"r":"data.reportSummaries"}]}]}]},"opcSummarySmsMmsTabArea":{"v":3,"t":[{"t":7,"e":"ux-tabarea","a":{"data":["{ 'reportSummaries': ",{"t":2,"r":"data.reportSummaries"},", 'summaryListUrl': ",{"t":2,"r":"data.summaryListUrl"}," }"]},"f":[{"t":7,"e":"ux-tablinks","f":[{"t":7,"e":"ux-tablink","a":{"active":"true"},"f":[{"t":7,"e":"ux-header","a":{"level":"6"},"f":["Summary"]}]}]}," ",{"t":7,"e":"ux-tabpanes","a":{"data":["{ 'reportSummaries': ",{"t":2,"r":"data.reportSummaries"},", 'summaryListUrl': ",{"t":2,"r":"data.summaryListUrl"}," }"]},"f":[{"t":7,"e":"ux-tabpane","a":{"data":["{ 'reportSummaries': ",{"t":2,"r":"data.reportSummaries"},", 'summaryListUrl': ",{"t":2,"r":"data.summaryListUrl"}," }"]},"f":[{"t":8,"r":"opcSummaryExportLinks"}," ",{"t":8,"r":"opcSummarySmsMmsResult"}]}]}]}]},"overduePaymentAutopayCompleted":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"messageBox"},"f":[{"t":7,"e":"ux-panel","f":[{"t":3,"x":{"r":["renderContent"],"s":"_0(\"completed\")"}}," ",{"t":7,"e":"ux-icon","a":{"type":"confirm-tick","color":"green","size":"xxl"}}]}]}]},"overduePaymentAutopayConfirm":{"v":3,"t":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":3,"x":{"r":["renderContent"],"s":"_0(\"directDebitConfirmText\")"}}]}," ",{"t":3,"x":{"r":["renderContent"],"s":"_0(\"labels.accountNumber\")"}},": ",{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"maskedAccountNumber"}]}," ",{"t":7,"e":"ux-panel","f":["Due: ",{"t":2,"x":{"r":["dueDate"],"s":"_0()"}}]}," ",{"t":7,"e":"ux-header","a":{"level":"3"},"f":["Summary"]}," ",{"t":7,"e":"hr"}," ",{"t":7,"e":"form","a":{"method":"POST"},"v":{"submit":{"n":"saveDirectDebit","d":[{"t":2,"r":"directDebitOptionSelected"}]}},"f":[{"t":7,"e":"input","a":{"type":"hidden","name":"billingAccountNo","value":[{"t":2,"x":{"r":["accountNumber"],"s":"_0()"}}]}}," ",{"t":7,"e":"div","a":{"class":"reviewDetails"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":["Name:"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 left"},"f":[{"t":2,"r":".cardHolderName"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":["Card Number:"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 left"},"f":[{"t":2,"r":".maskedCard"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":["Card Type:"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 left"},"f":[{"t":2,"r":".cardType"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":["Expiry:"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 left"},"f":[{"t":2,"r":".expiryDate"}]}]}],"r":"reviewCCDetails"}],"n":50,"x":{"r":["directDebitOptionSelected"],"s":"_0===\"creditcard\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["directDebitOptionSelected"],"s":"_0===\"bankaccount\""},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":["Account Name:"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 left"},"f":[{"t":2,"r":".bankAccountName"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":["BSB:"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 left"},"f":[{"t":2,"r":".bsb"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":["Account Number:"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 left"},"f":[{"t":2,"r":".bankAccountId"}]}]}],"r":"responseData"}]}],"x":{"r":["directDebitOptionSelected"],"s":"_0===\"creditcard\""}}]}," ",{"t":7,"e":"div","a":{"class":"cardDetailsHiddenContainer"},"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"type":"hidden","name":[{"t":2,"r":"@key"}],"value":[{"t":2,"r":"."}]}}],"n":52,"r":"cardDetailsHidden"}]}," ",{"t":7,"e":"div","a":{"class":"tncContainer"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"strong","f":[{"t":3,"x":{"r":["renderContent"],"s":"_0(\"reviewTncText\")"}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"spacer-bottom-short outer"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"rcheckbox","a":{"toggleKeypath":"tnc"}},"  Yes I've read your ",{"t":7,"e":"a","a":{"href":[{"t":2,"r":"data.content.urls.privacyUrl"}],"target":"_blank","title":"Optus Privacy Policy"},"f":["privacy policy"]},"."]}]}]}," ",{"t":7,"e":"div","a":{"class":"reviewActionsContainer"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-4 small-12 spacer-bottom-short outer"},"f":[{"t":7,"e":"input","a":{"type":"submit","name":"submit","value":"confirm","class":["button radius full-width ",{"t":4,"f":["disabled"],"n":51,"r":"tnc"}]},"m":[{"t":4,"f":["disabled=\"disabled\""],"n":51,"r":"tnc"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-4 spacer-bottom-short outer"},"f":[{"t":7,"e":"button","a":{"type":"button","class":"button radius full-width teal right"},"v":{"tap":"cancelDirectDebit"},"f":["Cancel"]}]}]}]}]}," ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"x":{"r":["errorMessage"],"s":"{message:_0}"}}],"n":50,"r":"errorMessage"}]},"overduePaymentAutopaySetup":{"v":3,"t":[{"t":7,"e":"div","a":{"id":"directDebitContainer"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"headerMessage"},"f":[{"t":3,"x":{"r":["renderContent"],"s":"_0(\"header\")"}}]}],"n":50,"x":{"r":["showOverdueView"],"s":"!_0"}}," ",{"t":3,"x":{"r":["renderContent"],"s":"_0(\"description\",\"autopay\")"}}," ",{"t":4,"f":[{"t":7,"e":"form","v":{"submit":"renderDirectDebitActions"},"f":[{"t":7,"e":"select","a":{"value":[{"t":2,"r":"directDebitOptionSelected"}]},"v":{"change":"displayDirectDebitDescription"},"f":[{"t":7,"e":"option","a":{"selected":0,"value":""},"f":["Select an option"]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":"type"}]},"f":[{"t":2,"r":"title"}]}],"n":50,"r":"title"}],"n":52,"i":"type","r":"."}]}," ",{"t":4,"f":[{"t":3,"r":"directDebitOptionDescription"}," ",{"t":4,"f":[{"t":7,"e":"ux-ippayment-form","a":{"data":[{"t":2,"r":"ippData"}]}}],"n":50,"x":{"r":["directDebitOptionSelected"],"s":"_0===\"creditcard\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["directDebitOptionSelected"],"s":"_0===\"bankaccount\""},"f":[{"t":7,"e":"ux-direct-debit-bank-account-form","a":{"dataoverride":[{"t":3,"r":"directDebitBankAccountModel"}]}}]}],"x":{"r":["directDebitOptionSelected"],"s":"_0===\"creditcard\""}}],"n":50,"r":"directDebitOptionSelected"},{"t":4,"n":51,"f":[{"t":3,"x":{"r":["renderContent"],"s":"_0(\"furtherDirectDebitOptions\")"}}],"r":"directDebitOptionSelected"}," ",{"t":4,"f":[{"t":8,"r":"overduePaymentInProgress"}],"n":50,"r":"displayDirectDebitDoneButton"}]}],"n":53,"r":"availableDirectDebitOptions"}," ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"x":{"r":["errorMessage"],"s":"{message:_0}"}}],"n":50,"r":"errorMessage"}]}]},"overduePaymentAutopayThankYou":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"center"},"f":[{"t":7,"e":"ux-panel","f":[{"t":3,"x":{"r":["renderContent"],"s":"_0(\"thankyou\")"}}," ",{"t":7,"e":"ux-icon","a":{"type":"confirm-tick","color":"green","size":"xxl"}}," ",{"t":3,"x":{"r":["renderContent"],"s":"_0(\"completed\")"}}]}]}]},"overduePaymentInProgress":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"center"},"f":[{"t":7,"e":"ux-spinner","a":{"class":"text-center"}}]}],"n":50,"r":"inProgress"},{"t":4,"n":51,"f":[{"t":7,"e":"button","a":{"class":"submit yellow full-width"},"f":[{"t":2,"r":"content.labels.done"}]}],"r":"inProgress"}]},"overduePaymentOverdue":{"v":3,"t":[{"t":7,"e":"div","a":{"id":"paymentContainer"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["hide"],"n":50,"r":"ipResponseData"}]},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"headerMessage"},"f":[{"t":3,"x":{"r":["renderContent"],"s":"_0(\"header\",\"overdue\")"}}]}," ",{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":3,"x":{"r":["renderContent"],"s":"_0(\"description\",\"overdue\")"}}," ",{"t":7,"e":"p","f":[{"t":3,"r":"content.labels.accountNumber"},{"t":7,"e":"br"}," ",{"t":7,"e":"strong","f":[{"t":3,"r":"maskedAccountNumber"}]}]}," ",{"t":7,"e":"p","f":[{"t":3,"r":"content.labels.overdueAmount"},{"t":7,"e":"br"}," ",{"t":7,"e":"strong","f":[{"t":2,"r":"formattedOverdueAmount"}]}]}," ",{"t":7,"e":"ux-panel","a":{"class":"uppercase center"},"f":[{"t":3,"r":"content.labels.dueDate"},": ",{"t":7,"e":"span","a":{"class":"uppercase"},"f":[{"t":3,"r":"data.user.bill.overdueDate"}]}]}," ",{"t":3,"x":{"r":["renderContent"],"s":"_0(\"paymentDescription\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"form","v":{"submit":"renderPaymentActions"},"f":[" ",{"t":4,"f":[{"t":7,"e":"select","a":{"value":[{"t":2,"r":"paymentOptionSelected"}]},"v":{"change":"displayPaymentDescription"},"f":[{"t":4,"f":[{"t":7,"e":"option","m":[{"t":4,"f":["selected"],"n":50,"x":{"r":["type","paymentOptionSelected"],"s":"_0===_1"}}],"a":{"value":[{"t":2,"r":"type"}]},"f":[{"t":2,"r":"title"}]}," "],"n":52,"i":"type","r":"."},"}"]}],"n":50,"x":{"r":["alreadypaid","remindmelater"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"optionDescription"},"f":[{"t":3,"r":"paymentOptionDescription"}]}],"n":50,"r":"paymentOptionSelected"}," ",{"t":4,"f":[{"t":8,"r":"overduePaymentInProgress"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"errorMessage"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"p","a":{"class":"response error"},"f":[{"t":2,"r":"errorMessage"}]}]}]}],"n":50,"r":"errorMessage"}],"n":50,"r":"displayPaymentDoneButton"}]}],"n":53,"r":"availablePaymentOptions"}]}," ",{"t":7,"e":"div","a":{"class":"payNowContainer"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-ippayment-form","a":{"data":[{"t":2,"r":"ippData"}]}}],"n":50,"x":{"r":["ipResponseData"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":8,"r":"ipResponseView"}],"x":{"r":["ipResponseData"],"s":"!_0"}}],"n":50,"x":{"r":["paymentOptionSelected"],"s":"_0===\"paynow\""}}]}]}]},"overduePaymentPayNowFail":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"messageBox"},"f":[{"t":7,"e":"ux-panel","f":[{"t":3,"x":{"r":["renderContent"],"s":"_0(\"overdue_paymentFail\")"}}," ",{"t":7,"e":"div","a":{"class":"ippErrMsg"},"f":[{"t":2,"r":"ipResponseData.declinedMessage"}]}]}]}]},"overduePaymentPayNowSuccess":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"messageBox"},"f":[{"t":7,"e":"ux-panel","f":[{"t":3,"x":{"r":["renderContent"],"s":"_0(\"overdue_paymentCompletedLineOne\")"}}," ",{"t":7,"e":"ux-icon","a":{"type":"confirm-tick","color":"green","size":"xxl"}}," ",{"t":3,"x":{"r":["renderContent"],"s":"_0(\"overdue_paymentCompletedLineTwo\")"}}]}," ",{"t":7,"e":"hr"}]}]},"paymentHistoryListBillSummaryPanel":{"v":3,"t":[{"t":7,"e":"ux-summary-panel","a":{"major_icon":"bill-settings","reference":[{"t":2,"x":{"r":["billNumber"],"s":"\"Bill No: \"+_0"}}],"title":"Bill","bodycopy":[{"t":2,"x":{"r":["RactiveHelpers","billClosedDate"],"s":"\"Bill for the month of \"+_0.convertMilisTimestampToDate(_1,\"MMM YY\")"}}],"value":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","totalChargesIncludeTax"],"s":"_0.convertUnits(_1,\"showdecimals\",2)"}}],"n":50,"r":"asDecimalAmount"},{"t":4,"n":51,"f":[{"t":2,"r":"totalChargesIncludeTax"}],"r":"asDecimalAmount"}],"theme":""},"f":[]}]},"paymentHistoryListPaymentSummaryPanel":{"v":3,"t":[{"t":7,"e":"ux-summary-panel","a":{"major_icon":[{"t":2,"x":{"r":["paymentStatus"],"s":"_0===\"Successful\"?\"valid-2\":\"credit-transfer\""}}],"reference":[{"t":2,"x":{"r":["confirmationNumber"],"s":"\"Ref: \"+_0"}}],"title":[{"t":2,"x":{"r":["paymentStatus","initData.PaymentSuccessfulText","initData.PaymentFailureText"],"s":"_0===\"Successful\"?_1:_2"}}],"bodycopy":[{"t":2,"x":{"r":["RactiveHelpers","paymentDate","paymentData"],"s":"\"Payment on \"+_0.convertMilisTimestampToDate(_1,\"DD MMM YY\")+_2"}}],"value":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","paymentStatus","amount","originalAmount"],"s":"_0.convertUnits(_1===\"Successful\"?_2:_3,\"showdecimals\",2)"}}],"n":50,"r":"asDecimalAmount"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["paymentStatus","amount","originalAmount"],"s":"_0===\"Successful\"?_1:_2"}}],"r":"asDecimalAmount"}],"theme":[{"t":2,"x":{"r":["paymentStatus"],"s":"_0===\"Successful\"?\"\":\"warning\""}}]},"f":[]}]},"phoneFilter":{"v":3,"t":[{"t":7,"e":"div","a":{"class":["columns medium-12 large-12 device-filter ",{"t":4,"f":["fixedTop"],"n":50,"r":"filterDiv.fixed"}]},"f":[{"t":7,"e":"div","a":{"class":"show-for-large-up"},"f":[{"t":7,"e":"div","a":{"class":"large-6 small-12 columns"},"f":[{"t":7,"e":"h4","f":["Now...choose your phone below on $",{"t":2,"x":{"r":["helpers","planData.planPrice"],"s":"_0.currencyConvert(_1)"}}," Plan"]}," ",{"t":7,"e":"h6","f":["Secure Checkout and FREE Delivery"]}]}," ",{"t":7,"e":"form","a":{"action":"","class":"custom","id":"mobileListingFilterForm"},"v":{"submit":""},"f":[{"t":7,"e":"div","a":{"class":"large-3 small-12 columns"},"f":[{"t":7,"e":"label","a":{"class":"filterSelectLabel","for":"brandFilter"},"f":["Brands"]}," ",{"t":7,"e":"select","a":{"id":"brandFilter","class":"medium","value":[{"t":2,"r":"selectedBrand"}],"name":"brandFilter"},"v":{"change":{"n":"doFilterSelect","a":"make"}},"f":[{"t":7,"e":"option","a":{"selected":"selected","value":""},"f":["All Phones"]}," ",{"t":4,"f":[{"t":7,"e":"option","m":[{"t":4,"f":["selected=\"selected\""],"n":50,"x":{"r":["selectedBrand","."],"s":"_0==_1"}}],"a":{"value":[{"t":2,"r":"."}]},"f":[{"t":2,"r":"."}]}],"n":52,"r":"sortedPhonesList"}]}]}," ",{"t":7,"e":"div","a":{"class":"large-3 small-12 columns"},"f":[{"t":7,"e":"label","a":{"class":"filterSelectLabel","for":"sortMobile"},"f":["Sort By"]}," ",{"t":7,"e":"select","a":{"id":"sortMobile","class":"medium","name":"sortMobile"},"v":{"change":"doSortByType"},"f":[{"t":7,"e":"option","a":{"selected":"selected","value":"weight"},"f":["Most Popular"]}," ",{"t":7,"e":"option","a":{"value":"phatPrice"},"f":["Price Low to High"]}," ",{"t":7,"e":"option","a":{"value":"phatPrice","data-column-reverse":"true"},"f":["Price High to Low"]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-down mobile-device-filter"},"f":[{"t":7,"e":"div","a":{"class":"small-6 medium-6 columns mobilePlanPrice"},"v":{"tap":"doChangePlanResponsive"},"f":[{"t":7,"e":"h2","f":["$",{"t":2,"x":{"r":["helpers","planData.planPrice"],"s":"_0.currencyConvert(_1)"}}," Plan ",{"t":7,"e":"a","a":{"href":"#","class":"changePlanResponsive"},"v":{"tap":"doChangePlanResponsive"},"f":["Change"]}]}]}," ",{"t":7,"e":"div","a":{"class":"small-6 medium-6 columns mobilePlanFilterDark"},"v":{"click":"doSelectFilter"},"f":[{"t":7,"e":"a","a":{"href":"#","class":"button radius small yellow filterSelectButton"},"v":{"click":"doSelectFilter"},"f":["Filter Phones ",{"t":7,"e":"span","a":{"class":"icon icon-arrow-down"}}]}]}," ",{"t":7,"e":"div","a":{"class":["mobileListingFilter ",{"t":4,"f":["show"],"n":50,"r":"filterCollapse"},{"t":4,"n":51,"f":["hide"],"r":"filterCollapse"}]},"f":[{"t":7,"e":"div","a":{"class":"small-12 medium-12 columns mobilePlanFilterDarkDropdown"},"f":[{"t":7,"e":"label","a":{"class":"filterSelectLabel","for":"brandFilter"},"f":["Brands"]}," ",{"t":7,"e":"div","a":{"class":"show-for-touch"},"f":[{"t":7,"e":"select","a":{"id":"brandFilter","class":"medium","value":[{"t":2,"r":"selectedBrand"}],"name":"brandFilter"},"v":{"change":{"n":"doFilterSelect","a":"make"}},"f":[{"t":7,"e":"option","a":{"selected":"selected","value":""},"f":["All Phones"]}," ",{"t":4,"f":[{"t":7,"e":"option","m":[{"t":4,"f":["selected=\"selected\""],"n":50,"x":{"r":["selectedBrand","."],"s":"_0==_1"}}],"a":{"value":[{"t":2,"r":"."}]},"f":[{"t":2,"r":"."}]}],"n":52,"r":"sortedPhonesList"}]}]}," ",{"t":7,"e":"div","a":{"class":"medium-12 hide-for-touch columns"},"f":[{"t":7,"e":"form","a":{"action":"","class":"custom","id":"mobileListingFilterForm"},"v":{"submit":""},"f":[{"t":7,"e":"select","a":{"id":"brandFilter","class":"medium","value":[{"t":2,"r":"selectedBrand"}],"name":"brandFilter"},"v":{"change":{"n":"doFilterSelect","a":"make"}},"f":[{"t":7,"e":"option","a":{"selected":"selected","value":""},"f":["All Phones"]}," ",{"t":4,"f":[{"t":7,"e":"option","m":[{"t":4,"f":["selected=\"selected\""],"n":50,"x":{"r":["selectedBrand","."],"s":"_0==_1"}}],"a":{"value":[{"t":2,"r":"."}]},"f":[{"t":2,"r":"."}]}],"n":52,"r":"sortedPhonesList"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"small-12 medium-12 columns mobilePlanFilterDarkDropdown"},"f":[{"t":7,"e":"label","a":{"class":"filterSelectLabel","for":"sortMobile"},"f":["Sort By"]}," ",{"t":7,"e":"div","a":{"class":"show-for-touch"},"f":[{"t":7,"e":"select","a":{"id":"sortMobile","class":"medium","name":"sortMobile"},"v":{"change":"doSortByType"},"f":[{"t":7,"e":"option","a":{"selected":"selected","value":"weight"},"f":["Most Popular"]}," ",{"t":7,"e":"option","a":{"value":"phatPrice"},"f":["Price Low to High"]}," ",{"t":7,"e":"option","a":{"value":"phatPrice","data-column-reverse":"true"},"f":["Price High to Low"]}]}]}," ",{"t":7,"e":"div","a":{"class":"medium-12 hide-for-touch columns"},"f":[{"t":7,"e":"form","a":{"action":"","class":"custom","id":"mobileListingFilterForm"},"v":{"submit":""},"f":[{"t":7,"e":"select","a":{"id":"sortMobile","class":"medium","name":"sortMobile"},"v":{"change":"doSortByType"},"f":[{"t":7,"e":"option","a":{"selected":"selected","value":"weight"},"f":["Most Popular"]}," ",{"t":7,"e":"option","a":{"value":"phatPrice"},"f":["Price Low to High"]}," ",{"t":7,"e":"option","a":{"value":"phatPrice","data-column-reverse":"true"},"f":["Price High to Low"]}]}]}]}]}]}]}]}]},"planInfoAddOns":{"v":3,"t":[{"t":7,"e":"ux-panel","a":{"class":"light-panel"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"p","a":{"class":"panel-header"},"f":["Add Ons:"]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":[{"t":2,"r":"."}]}],"n":52,"r":"addOns"}],"n":50,"r":"addOns"},{"t":4,"n":51,"f":[{"t":7,"e":"p","f":["You have no active add-ons"]}],"r":"addOns"}]}]}]}]},"planInfoDetail":{"v":3,"t":[{"t":7,"e":"ux-panel","a":{"class":"light-panel"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":7,"e":"p","a":{"class":"panel-header"},"f":["Plan"]}," ",{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"planName"}]}," ",{"t":7,"e":"div","a":{"class":"plan-detail"},"f":[{"t":4,"f":[{"t":7,"e":"ux-spinner","a":{"class":"contract-spinner"}}],"n":50,"r":"contractEndLoading"}," ",{"t":4,"f":[{"t":7,"e":"p","f":[{"t":7,"e":"b","f":["Contracted Until:"]},{"t":7,"e":"span","a":{"class":"contract-until"},"f":[{"t":3,"r":"contractEnd"}]}]}],"n":50,"r":"contractEnd"}," ",{"t":4,"f":[{"t":7,"e":"p","f":[{"t":7,"e":"b","f":["Shareable Data: "]},{"t":2,"r":"sharableDataFormatted"}]}],"n":50,"r":"sharableDataFormatted"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":7,"e":"a","a":{"class":"button small radius yellow","href":[{"t":2,"r":"changeRatePlanUrl"}],"target":"_blank"},"f":["Change Plan"]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-spinner","a":{"class":"cis-spinner"}}]}]}],"n":50,"r":"cisLoading"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"p","a":{"class":"sub-header"},"f":["Plan Information:"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"cis"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"em","f":["Optus’ Critical Information Summary"]}," contains detailed information about your products and services in plain language that is easy to understand."]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":7,"e":"a","a":{"class":"button small radius","target":"_blank","href":[{"t":2,"r":"cis.url"}]},"f":[{"t":2,"r":"cis.label"}]}," ",{"t":7,"e":"p","a":{"class":"caption text-right"},"f":["(pdf < 1MB)"]}]}]}],"n":50,"r":"cis"}]}]},"planInfoServiceNumber":{"v":3,"t":[{"t":7,"e":"ux-panel","a":{"class":"light-panel"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":7,"e":"p","a":{"class":"panel-header"},"f":["Service Number"]}," ",{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"serviceId"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":7,"e":"a","a":{"class":"button small radius yellow","href":[{"t":2,"r":"changeOwnershipUrl"}],"target":"_blank"},"f":["Transfer Ownership"]}]}]}]}]},"planListingModuleDesktop":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"planSelectorModule"},"f":[{"t":7,"e":"table","a":{"class":"table-1 horizontal-headers theme-business planListingTable","border":"1","cellpadding":"0","cellspacing":"0"},"f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"th","a":{"class":"table-head","scope":"row"},"f":[{"t":7,"e":"span","a":{"class":"uppercase"},"f":["24 MONTH CONTRACT"]}]}," ",{"t":4,"f":[{"t":7,"e":"th","a":{"class":["table-head",{"t":4,"f":[" plan_selected_",{"t":2,"r":"selectedColumn"}," column-highlighted"],"n":50,"x":{"r":["selectedColumn","@index"],"s":"_0==_1"}}],"scope":"row"},"f":[{"t":7,"e":"span","a":{"class":"heading-emphasis"},"f":[{"t":7,"e":"sup","f":["$"]},{"t":2,"x":{"r":["helpers","productOfferingContractPrice"],"s":"_0.currencyConvert(_1)"}}]}]}],"n":52,"r":"."}]},{"t":7,"e":"tr","f":[]},{"t":7,"e":"tr","a":{"valign":"top"},"f":[{"t":7,"e":"th","a":{"scope":"row","class":"text-left border-right border-top padding-left-none"},"f":[{"t":7,"e":"span","a":{"class":"heading-quinary"},"f":["INCLUDED Minutes"]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","a":{"class":"table-heading-secondary"},"f":["Standard Australian mobiles and landlines, 13/1300 numbers, voicemail and international* calls"]}]}," ",{"t":4,"f":[{"t":7,"e":"td","a":{"class":["text-left border-right border-top",{"t":4,"f":[" column-highlighted"],"n":50,"x":{"r":["selectedColumn","@index"],"s":"_0==_1"}}]},"f":[{"t":7,"e":"span","a":{"class":"heading-quinary"},"f":[{"t":3,"r":"allocatedCalls"}]}," ",{"t":7,"e":"span","a":{"class":"planCalloutText"},"f":[{"t":3,"r":"tcpStdCallText"}]}]}],"n":52,"r":"."}]}," ",{"t":7,"e":"tr","a":{"valign":"top"},"f":[{"t":7,"e":"th","a":{"scope":"row","class":"text-left border-right border-top padding-left-none"},"f":[{"t":7,"e":"span","a":{"class":"heading-quinary"},"f":["INCLUDED SMS/MMS"]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","a":{"class":"table-heading-secondary"},"f":["Standard national & international^ SMS/MMS"]}]}," ",{"t":4,"f":[{"t":7,"e":"td","a":{"class":["text-left border-right border-top",{"t":4,"f":[" column-highlighted"],"n":50,"x":{"r":["selectedColumn","@index"],"s":"_0==_1"}}]},"f":[{"t":7,"e":"span","a":{"class":"heading-quinary"},"f":[{"t":2,"r":"tcpStdSmsValue"}]}," ",{"t":7,"e":"br"}]}],"n":52,"r":"."}]}," ",{"t":7,"e":"tr","a":{"valign":"top"},"f":[{"t":7,"e":"th","a":{"scope":"row","class":"text-left border-right border-top padding-left-none"},"f":[{"t":7,"e":"span","a":{"class":"heading-quinary"},"f":["INCLUDED DATA"]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","a":{"class":"table-heading-secondary"},"f":["You can share this data with up to 5 mobile devices"]}]}," ",{"t":4,"f":[{"t":7,"e":"td","a":{"class":["text-left border-right border-top",{"t":4,"f":[" column-highlighted"],"n":50,"x":{"r":["selectedColumn","@index"],"s":"_0==_1"}}]},"f":[{"t":7,"e":"span","a":{"class":"heading-quinary"},"f":[{"t":3,"r":"allocatedData"}]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","a":{"class":"planCalloutText planCalloutTextLineHeight"},"f":["$10 per extra 1GB"]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","a":{"class":"planCalloutText"},"f":["Cost of ",{"t":3,"r":"tcpMbDataText"}," ",{"t":3,"r":"tcpMbDataValue"}]}]}],"n":52,"r":"."}]}," ",{"t":7,"e":"tr","a":{"valign":"top","class":"border-top"},"f":[{"t":7,"e":"td","a":{"class":"text-left border-right border-top"},"f":[{"t":7,"e":"span","a":{"class":"uppercase"}}]}," ",{"t":4,"f":[{"t":7,"e":"td","a":{"class":["text-left border-right border-top",{"t":4,"f":[" column-highlighted"],"n":50,"x":{"r":["selectedColumn","@index"],"s":"_0==_1"}}]},"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"documentWrapperPath"}],"class":"cisLink"},"v":{"click":"doNavigate"},"f":["Critical Info Summary"]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"a","a":{"href":"#","class":"button radius small yellow planSelectButton","data-column":[{"t":2,"r":"@index"}]},"v":{"click":"doSelectPlan"},"f":[{"t":4,"f":["Selected"],"n":50,"x":{"r":["selectedColumn","@index"],"s":"_0==_1"}},{"t":4,"n":51,"f":["Select"],"x":{"r":["selectedColumn","@index"],"s":"_0==_1"}}]}]}],"n":52,"r":"."}]}]}]}]}]},"planListingModuleMobile":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"carousel show-for-small","unselectable":"on"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"mobileListingCarouselPlanContainerInner"}],"r":"."}]}," ",{"t":7,"e":"div","a":{"class":"carousel is-smart-section show-for-medium","unselectable":"on"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"mobileListingCarouselPlanContainerInner"}],"r":"."}]}]},"portingNumberOptusKeepNumber":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-10 small-12 v-large-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":2,"r":"initData.keepNumberSMBTitle"}]}],"n":50,"x":{"r":["portinNumberData.subtype","isSMB"],"s":"_0!==\"MBL\"&&_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":2,"r":"initData.keepNumberTitle"}]}],"x":{"r":["portinNumberData.subtype","isSMB"],"s":"_0!==\"MBL\"&&_1"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"ux-input-box","a":{"label_value":[{"t":2,"r":"initData.enterMobileNumber"}],"value":[{"t":2,"r":"mobileNumber.value"}],"validity":[{"t":2,"r":"mobileNumber.valueValidityMessage"}]}}]}]}],"n":50,"x":{"r":["portinNumberData.subtype"],"s":"_0!==\"LAT\""}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"ux-select","a":{"options":[{"t":2,"r":"initData.carriers"}],"showSelectedValue":"true","selected_value":[{"t":2,"r":"currentCarrier"}],"label_value":[{"t":2,"r":"initData.currentCarrierLabel"}]}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"small","a":{"class":"carrier-help-text"},"f":[{"t":2,"r":"currentCarrierHelpText"}]}]}],"n":50,"r":"currentCarrierHelpText.length"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"ux-input-box","a":{"class":"v-normal-top","value":[{"t":2,"r":"fixedAccountNumber.value"}],"label_value":[{"t":2,"r":"initData.fixedAccountNumber"}],"validity":[{"t":2,"r":"fixedAccountNumber.valueValidityMessage"}]}}]}],"n":50,"x":{"r":["portinNumberData.subtype"],"s":"_0===\"LAT\""}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal small-12 medium-6"},"f":[{"t":7,"e":"ux-date-of-birth","a":{"mandatory":"true","isStandAlone":"true","globalDOBLabel":[{"t":2,"r":"initData.dobLabel"}],"value":[{"t":2,"r":"date"}]}}]}],"n":50,"x":{"r":["currentCarrier"],"s":"_0!==\"telstra\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal small-12 medium-6"},"f":[{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"initData.telstraPortingOptions"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-radio-button","a":{"value":"telstraPrepaid","label":[{"t":2,"r":"initData.telstraPrepaidNumber"}],"name":"telstraOptions","onclick":"setSelectedTelstraOption"}}," ",{"t":4,"f":[{"t":7,"e":"ux-date-of-birth","a":{"mandatory":"true","isStandAlone":"true","globalDOBLabel":[{"t":2,"r":"initData.dobLabel"}],"value":[{"t":2,"r":"date"}]}}],"n":50,"x":{"r":["selectedTelstraOption.value"],"s":"_0==\"telstraPrepaid\""}}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-radio-button","a":{"value":"telstraPostpaid","label":[{"t":2,"r":"initData.telstraPostpaidNumber"}],"name":"telstraOptions","onclick":"setSelectedTelstraOption"}}," ",{"t":4,"f":[{"t":7,"e":"ux-input-box","a":{"class":"v-normal-top sub-content","value":[{"t":2,"r":"telstraAccountNumber.value"}],"label_value":[{"t":2,"r":"initData.telstraAccountNumber"}]}}],"n":50,"x":{"r":["selectedTelstraOption.value"],"s":"_0==\"telstraPostpaid\""}}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"ux-form-validity"}],"r":"selectedTelstraOption.valueValidityMessage"}]}],"n":50,"x":{"r":["selectedTelstraOption.valueValidityMessage.status"],"s":"_0===\"error\""}}]}],"x":{"r":["currentCarrier"],"s":"_0!==\"telstra\""}}],"x":{"r":["portinNumberData.subtype"],"s":"_0===\"LAT\""}}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":[{"t":2,"r":"initData.customerAcknowledgement"}]}," ",{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"initData.certifyLabel"}]}," ",{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"initData.certifyDescription"}]}," ",{"t":7,"e":"ux-checkbox","a":{"class":"v-normal-bottom","labelvalue":[{"t":2,"r":"initData.agreeLabel"}],"checked":[{"t":2,"r":"agree.value"}],"validity":[{"t":2,"r":"agree.valueValidityMessage"}]}}," ",{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"initData.advisedLabel"}]}," ",{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"initData.advisedDescription"}]}," ",{"t":7,"e":"ux-checkbox","a":{"labelvalue":[{"t":2,"r":"initData.acknowledgeLabel"}],"checked":[{"t":2,"r":"acknowledge.value"}],"validity":[{"t":2,"r":"acknowledge.valueValidityMessage"}]}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top choices-container small-12 medium-6"},"f":[{"t":7,"e":"ux-checkbox","a":{"labelvalue":[{"t":2,"r":"initData.whitepagesLabel"}],"checked":[{"t":2,"r":"showWhitelist"}]}}," ",{"t":7,"e":"ux-checkbox","a":{"labelvalue":[{"t":2,"r":"initData.callerIdLabel"}],"checked":[{"t":2,"r":"showCallerId"}]}}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button-sd","a":{"type":"primary v-normal-top v-large-bottom","text":[{"t":2,"r":"initData.keepNumberCta"}],"ontap":"validKeepNumber"}}]}]}]},"portingNumberOptusNewNumber":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-10 small-12 v-large-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":2,"r":"initData.newNumberChoiceTitle"}]}," ",{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"initData.newNumberChoiceDescription"}]}," ",{"t":7,"e":"ul","a":{"class":"new-number v-normal-bottom"},"f":[{"t":7,"e":"ux-radio-button-group","a":{"selected":[{"t":2,"r":"mobileNumber.value"}],"style":"basic stacked","radio_btns":[{"t":2,"r":"radioValues"}]}}]}," ",{"t":7,"e":"div","a":{"class":" choices-container"},"f":[{"t":7,"e":"ux-checkbox","a":{"labelvalue":[{"t":2,"r":"initData.whitepagesLabel"}],"checked":[{"t":2,"r":"newNumberShowWhitelist"}]}}," ",{"t":7,"e":"ux-checkbox","a":{"labelvalue":[{"t":2,"r":"initData.callerIdLabel"}],"checked":[{"t":2,"r":"newNumberShowCallerId"}]}}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ux-button-sd","a":{"type":"primary v-normal-top v-large-bottom","text":[{"t":2,"r":"initData.newNumberCta"}],"ontap":"validNewNumber","disabled":[{"t":4,"f":["disabled"],"n":50,"x":{"r":["mobileNumber.value"],"s":"_0===\"\""}}]}}]}],"n":50,"r":"isSMB"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":2,"r":"initData.newNumberTitle"}]}," ",{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"initData.newNumberDescription"}]}," ",{"t":7,"e":"p","a":{"class":"new-number"},"f":[{"t":2,"r":"portinNumberData.suggestedNumbers.0"}]}," ",{"t":7,"e":"div","a":{"class":"choices-container"},"f":[{"t":7,"e":"ux-checkbox","a":{"labelvalue":[{"t":2,"r":"initData.whitepagesLabel"}],"checked":[{"t":2,"r":"newNumberShowWhitelist"}]}}," ",{"t":7,"e":"ux-checkbox","a":{"labelvalue":[{"t":2,"r":"initData.callerIdLabel"}],"checked":[{"t":2,"r":"newNumberShowCallerId"}]}}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ux-button-sd","a":{"type":"primary v-normal-top v-large-bottom","text":[{"t":2,"r":"initData.newNumberCta"}],"ontap":"validNewNumber"}}]}],"r":"isSMB"}]}]}]},"prepaidDashboardPartitionChart":{"v":3,"t":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-centered v-p-large"},"f":[{"t":7,"e":"ux-error-widget","a":{"errorIcon":[{"t":2,"r":"initData.widgetLoadingMessage.errorIcon"}],"errorTitle":[{"t":2,"r":"initData.widgetLoadingMessage.errorTitle"}],"errorMessage":[{"t":3,"r":"initData.widgetLoadingMessage.errorMessage"}]}}]}]}],"n":50,"r":"statusMessage"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["expireNotifications"],"s":"_0"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-centered v-p-large"},"f":[{"t":7,"e":"ux-warning-alert","a":{"notifications":[{"t":2,"r":"expireNotifications"}]}}]}]}]},{"t":4,"n":50,"x":{"r":["expireNotifications"],"s":"!(_0)"},"f":[" ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-centered prepaidBalanceGraphContainer"},"f":[{"t":7,"e":"ux-carousel-image-nav","a":{"style":"clean","tile_renderer":"none","space_between":"0"},"f":[{"t":4,"f":[{"t":7,"e":"ux-donut-chart-multi-ring-prepaid","a":{"heading":[{"t":3,"r":"initData.chartModel.your"}," ",{"t":2,"r":"name"}],"mb_used":[{"t":2,"r":"partitionPrepaidBalanceDetails.used"}],"remaining":[{"t":2,"r":"partitionPrepaidBalanceDetails.remaining"}],"data_available_prefix":[{"t":3,"r":"initData.chartModel.left_of_label"}],"total_mb_in_plan":[{"t":2,"r":"partitionPrepaidBalanceDetails.fullAmount"}],"usage_unit_display":[{"t":2,"r":"unit"}],"remaining_usage_unit":[{"t":2,"r":"remaningUnit"}],"days_remaining":[{"t":2,"r":"days_remaining"}],"hoursOrDaysInd":[{"t":4,"f":[{"t":2,"r":"initData.chartModel.hours"}],"n":50,"x":{"r":["planType"],"s":"_0===\"daily\""}}],"has_tiered":"false","showRemainingData":[{"t":2,"x":{"r":["time_remaining","days_remaining"],"s":"_0||_1"}}],"showRemainingPercent":"true","used_up_label":"left of","time_remaining_label":[{"t":3,"r":"initData.chartModel.time_remaining"}],"time_remaining":[{"t":2,"r":"time_remaining"}],"partitionDenomination":[{"t":2,"r":"partitionDenomination"}],"planType":[{"t":2,"r":"planType"}]}}],"n":52,"r":"mainBalance.roamingPartitions"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-donut-chart-multi-ring-prepaid","a":{"heading":[{"t":3,"r":"initData.chartModel.your"}," ",{"t":2,"r":"name"}],"mb_used":[{"t":2,"r":"partitionPrepaidBalanceDetails.used"}],"remaining":[{"t":2,"r":"partitionPrepaidBalanceDetails.remaining"}],"data_available_prefix":[{"t":3,"r":"initData.chartModel.left_of_label"}],"total_mb_in_plan":[{"t":2,"r":"partitionPrepaidBalanceDetails.fullAmount"}],"usage_unit_display":[{"t":2,"r":"unit"}],"days_remaining":[{"t":2,"r":"days_remaining"}],"hoursOrDaysInd":[{"t":2,"r":"initData.chartModel.hours"}],"has_tiered":"false","remaining_usage_unit":[{"t":2,"r":"remaningUnit"}],"showRemainingData":[{"t":2,"x":{"r":["time_remaining","days_remaining"],"s":"_0||_1"}}],"showRemainingPercent":"true","time_remaining_label":[{"t":3,"r":"initData.chartModel.time_remaining"}],"time_remaining":[{"t":2,"r":"time_remaining"}],"used_up_label":"left of","partitionDenomination":[{"t":2,"r":"partitionDenomination"}],"planType":[{"t":2,"r":"planType"}]}}],"n":52,"i":"i","r":"usageDailyPartitions"}],"n":50,"x":{"r":["planType"],"s":"_0===\"daily\""}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-donut-chart-multi-ring-prepaid","a":{"heading":[{"t":3,"r":"initData.chartModel.your"}," ",{"t":2,"r":"name"}],"mb_used":[{"t":2,"r":"partitionPrepaidBalanceDetails.used"}],"remaining":[{"t":2,"r":"partitionPrepaidBalanceDetails.remaining"}],"data_available_prefix":[{"t":3,"r":"initData.chartModel.left_of_label"}],"total_mb_in_plan":[{"t":2,"r":"partitionPrepaidBalanceDetails.fullAmount"}],"usage_unit_display":[{"t":2,"x":{"r":["RactiveHelpers","partitionDenomination","unit"],"s":"_2==\"SMS\"?\"\":_2===undefined?_0.defieneUnit(_1):\" \"+_2"}}],"remaining_usage_unit":[{"t":2,"r":"remaningUnit"}],"days_remaining":[{"t":2,"r":"days_remaining"}],"hoursOrDaysInd":[{"t":4,"f":[{"t":2,"r":"initData.chartModel.hours"}],"n":50,"x":{"r":["planType"],"s":"_0===\"daily\""}}],"has_tiered":"false","showRemainingData":[{"t":2,"x":{"r":["time_remaining","days_remaining"],"s":"_0||_1"}}],"showRemainingPercent":"true","time_remaining_label":[{"t":3,"r":"initData.chartModel.time_remaining"}],"time_remaining":[{"t":2,"r":"time_remaining"}],"used_up_label":"left of","partitionDenomination":[{"t":2,"r":"partitionDenomination"}],"planType":[{"t":2,"r":"planType"}]}}],"n":50,"x":{"r":["partitionPlanType","partitionDenomination"],"s":"_0!==\"MyCredit\"&&_1!=\"Money\""}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-donut-chart-multi-ring-prepaid","a":{"showRemainingOnly":"true","heading":[{"t":3,"r":"initData.chartModel.your"}," ",{"t":2,"r":"name"}],"mb_used":[{"t":2,"r":"partitionPrepaidBalanceDetails.used"}],"total_mb_in_plan":[{"t":2,"r":"partitionPrepaidBalanceDetails.fullAmount"}],"remaining":[{"t":2,"r":"partitionPrepaidBalanceDetails.remaining"}],"usage_unit_display":[{"t":2,"r":"unit"}],"data_available_prefix":"remaining","hoursOrDaysInd":[{"t":2,"r":"initData.chartModel.days"}],"days_remaining":[{"t":2,"r":"days_remaining"}],"has_tiered":"false","used_up_label":"remaining","showRemainingData":[{"t":2,"x":{"r":["time_remaining","days_remaining"],"s":"_0||_1"}}],"time_remaining_label":[{"t":3,"r":"initData.chartModel.time_remaining"}],"time_remaining":[{"t":2,"r":"time_remaining"}],"partitionDenomination":[{"t":2,"r":"partitionDenomination"}],"planType":[{"t":2,"r":"planType"}]}}],"n":50,"x":{"r":["partitionPlanType","partitionDenomination"],"s":"_0!==\"MyCredit\"&&_1==\"Money\""}}],"x":{"r":["partitionPlanType","partitionDenomination"],"s":"_0!==\"MyCredit\"&&_1!=\"Money\""}}],"n":52,"i":"i","r":"mainBalance.partitionsToDisplay"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-donut-chart-multi-ring-prepaid","a":{"showRemainingOnly":"true","heading":[{"t":3,"r":"initData.chartModel.your"}," ",{"t":2,"r":"name"}],"mb_used":[{"t":2,"r":"amount"}],"total_mb_in_plan":[{"t":2,"r":"amount"}],"remaining":[{"t":2,"r":"amount"}],"usage_unit_display":[{"t":2,"r":"unit"}],"data_available_prefix":"remaining","hoursOrDaysInd":[{"t":2,"r":"initData.chartModel.days"}],"days_remaining":[{"t":2,"r":"days_remaining"}],"has_tiered":"false","showRemainingData":[{"t":2,"x":{"r":["time_remaining","days_remaining"],"s":"_0||_1"}}],"time_remaining_label":[{"t":3,"r":"initData.chartModel.time_remaining"}],"time_remaining":[{"t":2,"r":"time_remaining"}],"planType":[{"t":2,"r":"planType"}]}}],"n":53,"r":"myCredit"}],"n":50,"r":"myCredit"}]}]}]}],"n":53,"r":"prepaidBalanceByServiceID"}],"n":50,"x":{"r":["prepaidBalanceByServiceID.state"],"s":"_0===\"Active\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-table-cell-small","a":{"style":"excess","type":[{"t":2,"r":"alert_type"}],"name":[{"t":2,"r":"text"}]}}],"n":52,"r":"lowNotifications"}]}]}," ",{"t":4,"f":[],"n":50,"x":{"r":["lowNotifications.length","lowNotifications.0.field"],"s":"_0===1&&_1==\"notificationLowMyCredit\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-centered v-p-large-bottom"},"f":[{"t":7,"e":"ux-button-sd","a":{"type":[{"t":2,"r":"data.btntype"}],"buttonType":[{"t":2,"r":"data.buttonType"}],"text":[{"t":2,"r":"initData.addDataBtnText"}],"ontap":"redirectToAddData"}}]}]}],"x":{"r":["lowNotifications.length","lowNotifications.0.field"],"s":"_0===1&&_1==\"notificationLowMyCredit\""}}],"n":50,"r":"lowNotifications"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-centered"},"f":[{"t":7,"e":"p","f":[{"t":3,"r":"initData.spendText"}," ",{"t":3,"r":"initData.dailyPlanFullPoint"}," ",{"t":3,"r":"initData.autoBumpLimitText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-centered"},"f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":["$",{"t":2,"r":"dailyLevelSpend.value"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-centered"},"f":[{"t":4,"f":[{"t":7,"e":"ux-simple-bar","a":{"value":[{"t":2,"r":"percentages"}],"colour":[{"t":2,"r":"initData.bar.color"}]}}],"n":53,"r":"dailyLevelSpend"}]}]}],"n":50,"x":{"r":["planType"],"s":"_0===\"daily\""}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-centered v-p-normal-top"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"initData.mycreditText"}," ",{"t":7,"e":"b","f":[{"t":2,"x":{"r":["moment","mycreditText.currentDate"],"s":"_0(_1).format(\"DD MMMM YYYY, hh:mm a\")"}}]}," ",{"t":2,"r":"initData.isText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-centered"},"f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":[{"t":2,"x":{"r":["RactiveHelpers","myCredit.amountToDisplay"],"s":"_0.convertUnits(_1,\"$\",true)"}}]}]}]}],"n":50,"r":"myCredit"}],"n":50,"x":{"r":["state"],"s":"_0===\"Active\""}}],"n":53,"r":"prepaidBalanceByServiceID"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-centered v-p-small"},"f":[{"t":7,"e":"ux-warning-alert","a":{"notifications":[{"t":2,"r":"initData.notifications"}]}}]}]}],"n":50,"x":{"r":["data.lowRoamCrdt"],"s":"_0===true"}}]}],"r":"statusMessage"}],"n":50,"r":"showPrepiadSummary"}]},"privacyAcceptance":{"v":3,"t":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"checkbox","id":"privacyAcceptance","name":"privacyAcceptance","class":"noBorder fc_privacy_acceptance"},"v":{"click":{"n":"doToggleKeypath","a":"tncNewCreditCard"}}},"  Yes I've read your ",{"t":7,"e":"a","a":{"href":"//www.optus.com.au/privacy","target":"_blank","title":"Optus Privacy Policy"},"f":["privacy policy"]},"."]}]},"productSelectorFilter":{"v":3,"t":[{"t":7,"e":"div","a":{"class":["filter ",{"t":2,"x":{"r":["RactiveHelpers","filterName"],"s":"_0.snakeCase(_1)"}}]},"f":[{"t":7,"e":"h5","a":{"class":"filter-header"},"f":[{"t":2,"r":"filterTitle"}," ",{"t":7,"e":"span","a":{"class":"value"},"f":[{"t":2,"r":"defaultOption"}]}]}," ",{"t":7,"e":"div","a":{"class":["filter-options ",{"t":2,"x":{"r":["RactiveHelpers","filterName"],"s":"_0.snakeCase(_1)"}}]},"f":[{"t":4,"f":[{"t":7,"e":"button","a":{"class":["filter-option ",{"t":2,"x":{"r":["RactiveHelpers","filterName","optionName"],"s":"_0.snakeCase(_1+\"_\"+_2)"}}," ",{"t":4,"f":["active"],"x":{"r":["../../filterName","data.defaultFilters","optionName"],"s":"_1[_0]===_2"}}],"title":[{"t":3,"r":"toolTipText"}],"role":"button"},"v":{"click":{"n":"selectFilter","d":[{"t":2,"r":"."},",",{"t":2,"r":"filterName"}]}},"f":[{"t":4,"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"mediumMediaFilePath"}],"alt":[{"t":2,"r":"displayName"}],"class":[{"t":4,"f":["active"],"x":{"r":["../../filterName","data.defaultFilters","displayName"],"s":"_1[_0]===_2"}}]}}],"n":50,"x":{"r":["../../filterType"],"s":"_0===\"image\""}},{"t":4,"n":51,"f":[{"t":2,"r":"displayName"}],"x":{"r":["../../filterType"],"s":"_0===\"image\""}}]}],"n":52,"i":"childIndex","r":"productFilterOptionModels"}]}]}]},"productSelectorFilterContent":{"v":3,"t":[{"t":7,"e":"ul","a":{"class":["filter-options ",{"t":2,"r":"classNames"}," small-block-grid-1 medium-block-grid-",{"t":2,"r":"productFilterOptionModels.length"}]},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":["filter-option ",{"t":2,"x":{"r":["RactiveHelpers","filterName","optionName"],"s":"_0.snakeCase(_1+\"_\"+_2)"}}," ",{"t":4,"f":["active"],"x":{"r":["../../filterName","data.defaultFilters","optionName"],"s":"_1[_0]===_2"}}]},"f":[{"t":7,"e":"a","v":{"tap":{"n":"selectFilter","d":[{"t":2,"r":"."},",",{"t":2,"r":"filterName"}]}},"f":[{"t":2,"r":"displayName"}]}]}],"n":52,"r":"productFilterOptionModels"}]}]},"productSelectorOneColRow":{"v":3,"t":[{"t":7,"e":"div","a":{"class":["filter ",{"t":2,"x":{"r":["RactiveHelpers","filterName"],"s":"_0.snakeCase(_1)"}}]},"f":[{"t":4,"f":[{"t":7,"e":"h5","a":{"class":"filter-header"},"f":[{"t":4,"f":["Choose Option"],"n":50,"x":{"r":["filterTitle"],"s":"_0===\"Select an Option\""}},{"t":4,"n":51,"f":[{"t":2,"r":"filterTitle"}],"x":{"r":["filterTitle"],"s":"_0===\"Select an Option\""}}]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorFilterContent"}],"x":{"r":[],"s":"{classNames:\"grouped\"}"}}," "],"n":50,"x":{"r":["parentFilterName"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorFilterContent"}],"x":{"r":[],"s":"{classNames:\"children\"}"}}],"n":50,"r":"productFilterOptionModels"}],"n":52,"r":"filterSelectedSubFilters"}],"x":{"r":["parentFilterType","data.defaultFilters","parentFilterName"],"s":"_1[_0]===_2"}}],"x":{"r":["parentFilterName"],"s":"!_0"}}]}]},"productSelectorPlanFeature":{"v":3,"t":[{"t":7,"e":"div","a":{"class":["feature ",{"t":2,"r":"type"}," ",{"t":2,"r":"classNames"}," ",{"t":4,"f":["unavailable"],"n":51,"r":"available"}," ",{"t":4,"f":["first"],"n":50,"x":{"r":["index"],"s":"_0===0"}}],"data-equalizer-selector":[{"t":2,"r":"type"}]},"o":{"n":"responsiveEqualizer","d":["['viewDetails.",{"t":2,"r":"type"},"']"]},"f":[{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":4,"f":[{"t":3,"r":"description"}],"n":50,"r":"available"},{"t":4,"n":51,"f":[{"t":3,"r":"standardDescription"}," ",{"t":7,"e":"span","a":{"class":"legal"},"f":[{"t":2,"r":"data.content.staticText.PLAN_FEATURE_NOT_INCLUDED_CAPTION"}]}],"r":"available"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["more-info ",{"t":4,"f":["hide"],"n":51,"rx":{"r":"viewDetails","m":[{"t":30,"n":"type"}]}}]},"f":[{"t":3,"r":"moreDescription"}]}," ",{"t":7,"e":"div","a":{"class":"more-link"},"f":[{"t":7,"e":"a","v":{"click":{"n":"viewMoreDetails","d":[{"t":2,"r":"type"}]}},"f":[{"t":4,"f":[{"t":2,"r":"data.content.staticText.PLAN_FEATURE_LESS_LINK_CAPTION"}],"n":50,"rx":{"r":"viewDetails","m":[{"t":30,"n":"type"}]}},{"t":4,"n":51,"f":[{"t":2,"r":"data.content.staticText.PLAN_FEATURE_MORE_LINK_CAPTION"}],"rx":{"r":"viewDetails","m":[{"t":30,"n":"type"}]}}]}]}],"n":50,"r":"moreDescription"}]}]},"productSelectorPlanListing":{"v":3,"t":[{"t":7,"e":"ux-carousel","a":{"items":[{"t":2,"r":"plans"}],"class":"plan-slider","slidesPerView":"3.5","spaceBetween":"10","grabCursor":"true","navigation":"true","nextButton":".plan-slider .swiper-button-next","prevButton":".plan-slider .swiper-button-prev","pagination":".plan-slider .swiper-pagination","paginationClickable":"true","breakpoints":"{\n\t\t\"1024\": {\n\t\t\t\"slidesPerView\": 2.5\n\t\t},\n\t\t\"768\": {\n\t\t\t\"slidesPerView\": 2\n\t\t},\n\t\t\"640\": {\n\t\t\t\"slidesPerView\": 1.5\n\t\t},\n\t\t\"480\": {\n\t\t\t\"slidesPerView\": 1,\n\t\t\t\"paginationHide\": false\n\t\t},\n\t\t\"320\": {\n\t\t\t\"slidesPerView\": 1,\n\t\t\t\"paginationHide\": false\n\t\t}\n\t}"},"f":[{"t":7,"e":"div","a":{"class":["plan ",{"t":4,"f":["recommended"],"n":50,"r":"planAttributes.recommendedPlan"}," ",{"t":4,"f":["selected"],"n":50,"x":{"r":["isSelectedPlan","."],"s":"_0(_1)"}}],"data-plan-external-id":[{"t":2,"r":"planAttributes.externalPackageId"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"recommended-badge"},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"data.content.staticText.RECOMMENDED_BADGE_TEXT"}]}]}],"n":50,"r":"planAttributes.recommendedPlan"}," ",{"t":7,"e":"div","a":{"class":"plan-header","data-equalizer-listener":"plan-heading"},"o":{"n":"height","d":[{"t":2,"rx":{"r":"equalizerHeights","m":[{"r":[],"s":"\"plan-heading\""}]}}]},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorPriceBreakup"}],"x":{"r":["planAttributes.totalPrice","planAttributes.frequencyText","planAttributes.planPrice","planAttributes.devicePayment","planAttributes.minimumTotalCostText"],"s":"{totalPrice:_0,frequency:_1,planPrice:_2,deviceRepayment:_3,minPriceMessage:_4}"}}]}," ",{"t":7,"e":"div","a":{"class":"features"},"f":[" ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorPlanFeature"}],"x":{"r":["@index"],"s":"{classNames:\"standard\",index:_0}"}}],"r":"planAttributes.features"}," ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorPlanFeature"}],"x":{"r":["@index"],"s":"{classNames:\"bonus\",index:_0}"}}],"r":"planAttributes.extraFeatures"}," ",{"t":7,"e":"div","a":{"class":"plan-footer","data-equalizer-listener":"footer"},"o":{"n":"height","d":[{"t":2,"rx":{"r":"equalizerHeights","m":[{"r":[],"s":"\"footer\""}]}}]},"f":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":"restriction"},"f":[{"t":3,"r":"planAttributes.usageRestrictionText"}]}],"n":50,"r":"planAttributes.usageRestrictionText"}," ",{"t":7,"e":"div","a":{"class":"cta"},"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"expand disabled out-of-stock","arialabel":[{"t":2,"r":"callToActionText"}],"text":[{"t":2,"r":"callToActionText"}]}}],"n":50,"r":"isOutOfStock"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":["expand ",{"t":4,"f":["blue"],"n":50,"x":{"r":["isSelectedPlan","."],"s":"_0(_1)"}},{"t":4,"n":51,"f":["yellow"],"x":{"r":["isSelectedPlan","."],"s":"_0(_1)"}}],"onclick":"selectPlan","plan":[{"t":2,"r":"."}],"text":[{"t":4,"f":[{"t":2,"r":"data.content.staticText.PLAN_SELECTED_BUTTON_CAPTION"}],"n":50,"x":{"r":["isSelectedPlan","."],"s":"_0(_1)"}},{"t":4,"n":51,"f":[{"t":2,"r":"data.content.staticText.PLAN_SELECT_BUTTON_CAPTION"}],"x":{"r":["isSelectedPlan","."],"s":"_0(_1)"}}]},"f":[]}],"r":"isOutOfStock"}]}," ",{"t":7,"e":"p","a":{"class":"cis"},"f":[{"t":7,"e":"span","a":{"class":"ico icon-download-pdf"}}," ",{"t":7,"e":"a","a":{"class":"cis-link","target":"_blank","href":[{"t":2,"r":"planAttributes.cisDocumentPath"}]},"f":[{"t":2,"r":"data.content.staticText.CIS_LINK_TEXT"}]}]}]}]}]}]}]},"productSelectorPriceBreakup":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"prices"},"f":[{"t":7,"e":"div","a":{"class":"col total"},"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"span","a":{"class":"amount"},"f":[{"t":7,"e":"sup","f":["$"]},{"t":2,"x":{"r":["totalPrice"],"s":"_0/100"}}]}," ",{"t":7,"e":"span","a":{"class":"caption"},"f":[{"t":2,"r":"frequency"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"col breakup"},"f":[{"t":7,"e":"div","a":{"class":"col price"},"f":[{"t":7,"e":"span","a":{"class":"amount"},"f":[{"t":7,"e":"sup","f":["$"]},{"t":2,"x":{"r":["planPrice"],"s":"_0/100"}}]}," ",{"t":7,"e":"span","a":{"class":"caption"},"f":[{"t":2,"r":"data.content.staticText.PLAN_CAPTION"}]}]}," ",{"t":7,"e":"div","a":{"class":"col plus"},"f":["+"]}," ",{"t":7,"e":"div","a":{"class":"col price"},"f":[{"t":7,"e":"span","a":{"class":"amount"},"f":[{"t":7,"e":"sup","f":["$"]},{"t":2,"x":{"r":["deviceRepayment"],"s":"_0/100"}}]}," ",{"t":7,"e":"span","a":{"class":"caption"},"f":[{"t":2,"r":"data.content.staticText.PHONE_CAPTION"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"min-payment"},"f":[{"t":2,"r":"minPriceMessage"}]}],"r":"minPriceMessage"}]}]},"productSelectorPriceTotalSummary":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"prices"},"f":[{"t":7,"e":"div","a":{"class":"col total"},"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"span","a":{"class":"amount"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorAddonsPrice"}],"x":{"r":["monthly"],"s":"{price:_0}"}}]}," ",{"t":7,"e":"span","a":{"class":"caption"},"f":[{"t":2,"r":"data.content.staticText.FREQUENCY_PER_MONTH"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"col total"},"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"span","a":{"class":"amount"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorAddonsPrice"}],"x":{"r":["upfront"],"s":"{price:_0}"}}]}," ",{"t":7,"e":"span","a":{"class":"caption"},"f":[{"t":2,"r":"data.content.staticText.FREQUENCY_UPFRONT"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"min-payment"},"f":[{"t":2,"r":"minPriceMessage"}]}],"r":"minPriceMessage"}]}]},"productSelectorStickyHeader":{"v":3,"t":[{"t":7,"e":"div","a":{"class":["product-selector-sticky-header hide-for-small hide-for-medium ",{"t":4,"f":["show"],"r":"showStickyHeader"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 left-section"},"f":[{"t":4,"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"selectedImage"}],"alt":[{"t":2,"r":"data.title"}],"class":"thumbnail"}}],"n":50,"r":"selectedImage"}," ",{"t":7,"e":"section","a":{"class":"info"},"f":[{"t":7,"e":"h3","a":{"class":"title"},"f":[{"t":2,"r":"data.title"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"filters"},"f":[{"t":4,"f":[{"t":8,"r":"productSelectorFilter"}],"n":52,"r":"twoColumnFilters"}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[" ",{"t":7,"e":"nav","a":{"class":"ctas"},"f":[{"t":7,"e":"a","v":{"tap":"scrollToPlans"},"f":[{"t":2,"r":"data.content.staticText.STICKY_HEADER_PLANS_LINK_TITLE"}]}," ",{"t":4,"f":[{"t":7,"e":"a","v":{"tap":{"n":"goToTab","d":[{"t":2,"r":"@index"}]}},"f":[{"t":2,"r":"tabName"}]}],"r":"tabsToBeDisplayed"}]}," ",{"t":7,"e":"section","a":{"class":["price-breakup-section ",{"t":4,"f":["hide"],"n":51,"r":"startingPlan"}]},"f":[{"t":7,"e":"h5","a":{"class":"total-label"},"f":[{"t":4,"f":[{"t":2,"r":"data.content.staticText.PLAN_TOTAL_SHORT"}],"n":50,"r":"selectedPlan"},{"t":4,"n":51,"f":[{"t":2,"r":"data.content.staticText.PLAN_STARTING_FROM_SHORT"}],"r":"selectedPlan"}]}," ",{"t":7,"e":"div","a":{"class":"price-breakup"},"f":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorPriceTotalSummary"}],"x":{"r":["price.monthly.total","price.upfront.total"],"s":"{monthly:_0,upfront:_1}"}}],"n":50,"r":"selectedPlan"},{"t":4,"n":51,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorPriceBreakup"}],"x":{"r":["startingPlan.planAttributes.totalPrice","startingPlan.planAttributes.frequencyText","startingPlan.planAttributes.planPrice","startingPlan.planAttributes.deviceRepayment"],"s":"{totalPrice:_0,frequency:_1,planPrice:_2,deviceRepayment:_3}"}}],"r":"selectedPlan"}]}]}," ",{"t":7,"e":"div","a":{"class":"mtc"},"f":[{"t":4,"f":[{"t":2,"r":"price.minTotalCost.message"}],"n":50,"r":"selectedPlan"},{"t":4,"n":51,"f":[{"t":2,"r":"startingPlan.planAttributes.minimumTotalCostText"}],"r":"selectedPlan"}]}]}]}]}]},"productSelectorAddonsAddRemoveButton":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"white small remove-cta option-cta","onclick":"removeFromCart","optionId":[{"t":2,"r":"externalComponentId"}],"text":[{"t":2,"r":"data.content.staticText.BOLTON_REMOVE_BUTTON_CAPTION"}],"arialabel":[{"t":2,"r":"data.content.staticText.BOLTON_REMOVE_BUTTON_CAPTION"}]},"f":[]}],"n":50,"r":"addedToCart"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":"teal small add-cta option-cta","onclick":"addToCart","optionId":[{"t":2,"r":"externalComponentId"}],"text":[{"t":2,"r":"data.content.staticText.BOLTON_ADD_BUTTON_CAPTION"}],"arialabel":[{"t":2,"r":"data.content.staticText.BOLTON_ADD_BUTTON_CAPTION"}]},"f":[]}],"r":"addedToCart"}]},"productSelectorAddonsBundleDiscount":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"group-options"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["option option",{"t":2,"r":"optionIndex"}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"columns large-3 option-media"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"mediaAsset.mediumMediaFilePath"}],"alt":[{"t":2,"r":"title"}]}}]}],"n":50,"r":"mediaAsset"}," ",{"t":7,"e":"div","a":{"class":["columns option-content ",{"t":4,"f":["large-9"],"n":50,"r":"mediaAsset"},{"t":4,"n":51,"f":["large-12"],"r":"mediaAsset"}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"columns"},"f":[{"t":8,"r":"productSelectorAddonsOptionInfo"}," ",{"t":7,"e":"div","a":{"class":"ux-checkbox"},"f":[{"t":7,"e":"input","a":{"type":"checkbox","id":[{"t":2,"r":"externalComponentId"}]},"v":{"click":{"n":"handleBundleDiscount","d":[{"t":2,"r":"externalComponentId"}]}}}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"externalComponentId"}]},"f":[{"t":3,"r":"data.content.staticText.BUNDLE_DISCOUNT_MESSAGE"}]}]}]}]}]}]}]}],"n":52,"i":"optionIndex","r":"options"}]}],"n":50,"r":"options"}]},"productSelectorAddonsOptionInfo":{"v":3,"t":[{"t":7,"e":"h3","a":{"class":"option-title"},"f":[{"t":2,"r":"name"}]}," ",{"t":7,"e":"div","a":{"class":"option-description"},"f":[{"t":3,"r":"shortDescription"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["more-desc ",{"t":4,"f":["hide"],"n":50,"x":{"r":["showMoreDesc"],"s":"!_0"}}]},"f":[{"t":3,"r":"longDescription"}]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"toggleMoreDesc","option":[{"t":2,"r":"."}],"class":"learn-more-link"},"f":[{"t":4,"f":[{"t":2,"r":"data.content.staticText.BOLTON_LEARN_MORE_TEXT"}],"n":50,"x":{"r":["showMoreDesc"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":2,"r":"data.content.staticText.BOLTON_LEARN_LESS_TEXT"}],"x":{"r":["showMoreDesc"],"s":"!_0"}}]}],"n":50,"r":"longDescription"}]},"productSelectorAddonsOptionsGrouped":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"group-options"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["option option",{"t":2,"r":"optionIndex"}," ",{"t":4,"f":["dependent"],"n":50,"r":"parents"}," ",{"t":4,"f":["hide"],"n":50,"x":{"r":["visible"],"s":"!_0"}}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"columns large-3 option-media"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"mediaAsset.mediumMediaFilePath"}],"alt":[{"t":2,"r":"title"}]}}]}],"n":50,"r":"mediaAsset"}," ",{"t":7,"e":"div","a":{"class":["columns option-content ",{"t":4,"f":["large-9"],"n":50,"r":"mediaAsset"},{"t":4,"n":51,"f":["large-12"],"r":"mediaAsset"}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"columns medium-7 large-8"},"f":[{"t":8,"r":"productSelectorAddonsOptionInfo"}]}," ",{"t":7,"e":"div","a":{"class":"columns medium-5 large-4"},"f":[{"t":7,"e":"div","a":{"class":"option-info"},"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"span","a":{"class":"amount"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorAddonsPrice"}],"x":{"r":["formattedPrice"],"s":"{price:_0}"}}]}," ",{"t":7,"e":"span","a":{"class":"frequency"},"f":[{"t":2,"r":"formattedFrequency"}]}]}," ",{"t":4,"f":[{"t":8,"r":"productSelectorAddonsAddRemoveButton"}],"n":50,"r":"parents"},{"t":4,"n":51,"f":[{"t":8,"r":"productSelectorAddonsSelectButton"}],"r":"parents"}]}]}]}]}]}]}],"n":50,"r":"displayIndicator"}],"n":52,"i":"optionIndex","r":"options"}]}],"n":50,"r":"options"}]},"productSelectorAddonsOptionsIncluded":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"group-options"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["option option",{"t":2,"r":"optionIndex"}," ",{"t":4,"f":["hide"],"n":50,"x":{"r":["visible"],"s":"!_0"}}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"columns large-3 option-media"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"mediaAsset.mediumMediaFilePath"}],"alt":[{"t":2,"r":"title"}]}}]}],"n":50,"r":"mediaAsset"}," ",{"t":7,"e":"div","a":{"class":["columns option-content ",{"t":4,"f":["large-9"],"n":50,"r":"mediaAsset"},{"t":4,"n":51,"f":["large-12"],"r":"mediaAsset"}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"columns medium-7 large-8"},"f":[{"t":8,"r":"productSelectorAddonsOptionInfo"}]}," ",{"t":7,"e":"div","a":{"class":"columns medium-5 large-4"},"f":[{"t":7,"e":"div","a":{"class":"option-info"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"included"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-tick"}}," ",{"t":7,"e":"span","a":{"class":"text"},"f":[{"t":2,"r":"data.content.staticText.BOLTON_INCLUDED_CAPTION"}]}]}],"n":50,"r":"addedToCart"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":"yellow option-cta","onclick":"addToCart","optionId":[{"t":2,"r":"externalComponentId"}],"text":[{"t":2,"r":"data.content.staticText.BOLTON_ADD_BUTTON_CAPTION"}],"arialabel":[{"t":2,"r":"data.content.staticText.BOLTON_ADD_BUTTON_CAPTION"}]},"f":[]}],"r":"addedToCart"}]}]}]}]}]}]}],"n":50,"r":"displayIndicator"}],"n":52,"i":"optionIndex","r":"options"}]}],"n":50,"r":"options"}]},"productSelectorAddonsOptionsOptional":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"group-options"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["option option",{"t":2,"r":"optionIndex"}," ",{"t":4,"f":["hide"],"n":50,"x":{"r":["visible"],"s":"!_0"}}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"columns large-3 option-media"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"mediaAsset.mediumMediaFilePath"}],"alt":[{"t":2,"r":"title"}]}}]}],"n":50,"r":"mediaAsset"}," ",{"t":7,"e":"div","a":{"class":["columns option-content ",{"t":4,"f":["large-9"],"n":50,"r":"mediaAsset"},{"t":4,"n":51,"f":["large-12"],"r":"mediaAsset"}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"columns medium-7 large-8"},"f":[{"t":8,"r":"productSelectorAddonsOptionInfo"}]}," ",{"t":7,"e":"div","a":{"class":"columns medium-5 large-4"},"f":[{"t":7,"e":"div","a":{"class":"option-info"},"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"span","a":{"class":"amount"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorAddonsPrice"}],"x":{"r":["formattedPrice"],"s":"{price:_0}"}}]}," ",{"t":7,"e":"span","a":{"class":"frequency"},"f":[{"t":2,"r":"formattedFrequency"}]}]}," ",{"t":8,"r":"productSelectorAddonsAddRemoveButton"}]}]}]}]}]}]}],"n":50,"r":"displayIndicator"}],"n":52,"i":"optionIndex","r":"options"}]}],"n":50,"r":"options"}]},"productSelectorAddonsPrice":{"v":3,"t":[{"t":4,"f":[{"t":3,"r":"price.dollars"},{"t":7,"e":"sup","a":{"class":["cents ",{"t":4,"f":["zero"],"n":50,"x":{"r":["price.cents"],"s":"_0==0"}}]},"f":[{"t":2,"r":"price.cents"}]}],"n":50,"r":"price.dollars"},{"t":4,"n":51,"f":["-"],"r":"price.dollars"}]},"productSelectorAddonsSelectButton":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"small option-cta select-cta disabled","disabled":"true","text":[{"t":2,"r":"data.content.staticText.PLAN_SELECTED_BUTTON_CAPTION"}]},"f":[]}],"n":50,"r":"addedToCart"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":"yellow small select-cta option-cta","onclick":"addToCart","optionId":[{"t":2,"r":"externalComponentId"}],"text":[{"t":2,"r":"data.content.staticText.PLAN_SELECT_BUTTON_CAPTION"}],"arialabel":[{"t":2,"r":"data.content.staticText.PLAN_SELECT_BUTTON_CAPTION"}]},"f":[]}],"r":"addedToCart"}]},"productSelectorAddonsSummary":{"v":3,"t":[{"t":7,"e":"section","a":{"class":["summary ",{"t":4,"f":["hide"],"n":51,"r":"showSummary"}]},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"columns"},"f":[{"t":7,"e":"h1","f":[{"t":2,"r":"data.content.staticText.SUMMARY_TITLE"}]}," ",{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"columns medium-6 large-7"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price-group"},"f":[{"t":7,"e":"h4","f":[{"t":2,"r":"data.content.staticText.SUMMARY_MONTHLY_CAPTION"}]}," ",{"t":7,"e":"table","a":{"class":"pricing-table"},"f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"caption"},"f":[{"t":2,"r":"formattedDeviceTitle"}]}," ",{"t":7,"e":"td","a":{"class":"amount"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorAddonsPrice"}],"x":{"r":["price.monthly.deviceRepayment"],"s":"{price:_0}"}}]}]}],"n":50,"r":"price.monthly.deviceRepayment"}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"caption"},"f":[{"t":2,"r":"data.selectedPlan.planAttributes.planFamily"}]}," ",{"t":7,"e":"td","a":{"class":"amount"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorAddonsPrice"}],"x":{"r":["price.monthly.planPrice"],"s":"{price:_0}"}}]}]}],"n":50,"r":"price.monthly.planPrice"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"caption"},"f":[{"t":2,"r":"name"}]}," ",{"t":7,"e":"td","a":{"class":"amount"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorAddonsPrice"}],"x":{"r":["formattedPrice"],"s":"{price:_0}"}}]}]}],"n":50,"r":"displayIndicator"}],"n":52,"r":"price.monthly.boltons"}]}]}]}],"n":50,"r":"price.monthly.total.actual"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price-group"},"f":[{"t":7,"e":"h4","f":[{"t":2,"r":"data.content.staticText.SUMMARY_UPFRONT_CAPTION"}]}," ",{"t":7,"e":"table","a":{"class":"pricing-table"},"f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"caption"},"f":[{"t":2,"r":"data.content.staticText.PHONE_CAPTION"}]}," ",{"t":7,"e":"td","a":{"class":"amount"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorAddonsPrice"}],"x":{"r":["price.upfront.deviceRepayment"],"s":"{price:_0}"}}]}]}],"n":50,"r":"price.upfront.deviceRepayment"}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"caption"},"f":[{"t":2,"r":"data.content.staticText.PLAN_CAPTION"}]}," ",{"t":7,"e":"td","a":{"class":"amount"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorAddonsPrice"}],"x":{"r":["price.upfront.planPrice"],"s":"{price:_0}"}}]}]}],"n":50,"r":"price.upfront.planPrice"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"caption"},"f":[{"t":2,"r":"name"}]}," ",{"t":7,"e":"td","a":{"class":"amount"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorAddonsPrice"}],"x":{"r":["formattedPrice"],"s":"{price:_0}"}}]}]}],"n":50,"r":"displayIndicator"}],"n":52,"r":"price.upfront.boltons"}]}]}]}],"n":50,"r":"price.upfront.total.actual"}]}," ",{"t":7,"e":"div","a":{"class":"columns medium-6 large-4"},"f":[{"t":7,"e":"div","a":{"class":"totals"},"f":[{"t":7,"e":"table","a":{"class":"pricing-table"},"f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"caption"},"f":[{"t":2,"r":"data.content.staticText.SUMMARY_TOTAL_MONTHLY_CAPTION"}]}," ",{"t":7,"e":"td","a":{"class":"amount"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorAddonsPrice"}],"x":{"r":["price.monthly.total"],"s":"{price:_0}"}}]}]}],"n":50,"r":"price.monthly.total.actual"}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"caption"},"f":[{"t":2,"r":"data.content.staticText.SUMMARY_TOTAL_UPFRONT_CAPTION"}]}," ",{"t":7,"e":"td","a":{"class":"amount"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"productSelectorAddonsPrice"}],"x":{"r":["price.upfront.total"],"s":"{price:_0}"}}]}]}],"n":50,"r":"price.upfront.total.actual"}]}]}," ",{"t":7,"e":"p","a":{"class":"min-cost-message"},"f":[{"t":2,"r":"price.minTotalCost.message"}]}," ",{"t":7,"e":"a","a":{"href":[{"t":2,"r":"url"}],"class":"button yellow buy-now"},"f":[{"t":2,"r":"data.selectedPlan.callToActionText"}]}]}]}]}]}]}]}]},"productSelectorAddonsWidgetTitle":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"widget-title"},"f":[{"t":7,"e":"div","a":{"class":"icon-wrapper"},"f":[{"t":7,"e":"span","a":{"class":["icon ",{"t":2,"r":"data.content.staticText.CONFIGURATOR_TITLE_ICON"}]}}]}," ",{"t":7,"e":"div","a":{"class":"title-wrapper"},"f":[{"t":7,"e":"h2","a":{"class":"title"},"f":[{"t":2,"r":"data.content.staticText.CONFIGURATOR_TITLE"}]}," ",{"t":3,"r":"data.content.staticText.CONFIGURATOR_TITLE_DESCRIPTION"}]}]}]},"productSelectorHeaderBannerSlider":{"v":3,"t":[{"t":4,"f":[" ",{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"columns"},"f":[{"t":7,"e":"ux-carousel","a":{"class":"banner-slider","items":[{"t":2,"r":"data._extended.banners"}],"navigation":"true","nextButton":".banner-slider .swiper-button-next","prevButton":".banner-slider .swiper-button-prev","pagination":".banner-slider .swiper-pagination","paginationClickable":"true"},"f":[" ",{"t":7,"e":"div","a":{"class":"banner-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"url"}],"target":"_blank"},"f":[{"t":8,"r":"bannerImage"}]}],"n":50,"r":"url"},{"t":4,"n":51,"f":[{"t":8,"r":"bannerImage"}],"r":"url"}]}],"p":{"bannerImage":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"image"}],"alt":[{"t":2,"r":"caption"}]},"m":[{"t":4,"f":["class=\"hide-for-small\""],"n":50,"r":"imageMobile"}]}," ",{"t":4,"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"imageMobile"}],"class":"show-for-small","alt":[{"t":2,"r":"caption"}]}}],"n":50,"r":"imageMobile"}]}}]}]}," "],"n":50,"r":"data._extended.banners"}]},"productSelectorHeaderDeliveryDiscountInfo":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["info ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"h4","a":{"class":"caption"},"f":[{"t":4,"f":[{"t":7,"e":"i","a":{"class":[{"t":2,"r":"info.icon"}]}}],"n":50,"r":"info.icon"}," ",{"t":2,"r":"info.title"}]}," ",{"t":7,"e":"div","a":{"class":"message"},"f":[{"t":3,"r":"info.content"}]}]}],"n":50,"x":{"r":["info.hide"],"s":"!_0"}}]},"rcheckbox":{"v":3,"t":[{"t":7,"e":"span","a":{"class":["checkbox ",{"t":4,"f":["checked"],"r":"checked"}," "]},"v":{"click":"toggleCheckbox"}}]},"recaptcha":{"v":3,"t":[{"t":7,"e":"script","a":{"type":"text/javascript"},"f":[]}]},"searchForm":{"v":3,"t":[{"t":7,"e":"form","a":{"action":[{"t":2,"r":"actionUrl"}],"method":[{"t":2,"r":"method"}],"class":"search-form","autocomplete":"off"},"v":{"submit":"doSearch"},"f":[{"t":7,"e":"fieldset","f":[{"t":8,"r":"searchInputBox"}]}]}]},"searchInputBox":{"v":3,"t":[{"t":7,"e":"label","a":{"for":"globalSearchInput","class":"hide"},"f":["Search"]}," ",{"t":7,"e":"div","a":{"class":"input-group"},"f":[{"t":7,"e":"ux-autocomplete","a":{"class":"search-input","name":[{"t":2,"r":"name"}],"value":[{"t":2,"r":"searchValue"}],"source":[{"t":2,"r":"autoCompleteURL"}],"queryParameter":"query","placeholder":[{"t":2,"r":"placeholder"}],"limit":"5","responseKeyPath":"data","responseTitleField":"title","responseUrlField":"url","allowScrolling":"false","showSuggestions":[{"t":2,"r":"autoSuggest"}],"typeaheadOption":[{"t":2,"r":"typeaheadOption"}],"customContent":[{"t":2,"r":"customContent"}],"autosuggestResult":[{"t":2,"r":"autosuggestResult"}],"closeAutoSuggestion":[{"t":2,"r":"closeAutoSuggestion"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":["group-",{"t":2,"r":"gi"}," group-title disabled"]},"f":[{"t":7,"e":"h4","f":[{"t":2,"r":".groupTitle"}]}]}],"n":50,"x":{"r":["multipleSources",".groupTitle"],"s":"_0&&_1!==\"\""}}," ",{"t":4,"f":[{"t":7,"e":"li","m":[{"t":4,"f":["class=\"group-",{"t":2,"r":"groupIndex"},"\""],"r":"multipleSources"}],"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"url"}],"class":[{"t":4,"f":["selected"],"n":50,"x":{"r":[".index","selectedIndex"],"s":"_0==_1"}}," ",{"t":4,"f":["recommendedResultLink RMOCServiceHub"],"n":50,"x":{"r":["groupIndex"],"s":"_0===1"}}]},"m":[{"t":4,"f":["data-rv-class-selected=\"result.selected\" data-rv-href=\"result.url\" data-rv-text=\"result.label\""],"n":50,"x":{"r":["groupIndex"],"s":"_0===1"}}],"v":{"tap":"selectOption"},"f":[{"t":3,"r":".title"}]}]}],"n":52,"r":".options"}],"n":52,"i":"gi","r":".autosuggestResult"}]}," ",{"t":7,"e":"input","a":{"class":"button radius btn-submit","type":"submit","title":"Search","value":""}}," ",{"t":7,"e":"a","a":{"href":"#"},"v":{"click":"doSearch"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-search-large"}}]}]}]},"serviceSelectorAlertNotification":{"v":3,"t":[{"t":7,"e":"ux-alert","a":{"class":"security-notification"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-1 text-right"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-notification-yellow"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-10 medium-11"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":["Security tip!"]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"p","f":["Take care when tethering - Any device tethered to your phone will be able to access this page and see your account details."]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"dismiss"},"v":{"anchorClicked":"dismissModal"},"f":["Dismiss"]}]}]}]}]}]}]},"serviceSelectorFilter":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"service-filter-box"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-4 small-12"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse service-filter"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-10"},"f":[{"t":7,"e":"label","a":{"for":"serviceSearch","class":"skip-links"},"f":[{"t":2,"r":"content.serviceSearchLabel"}]}," ",{"t":7,"e":"input","a":{"type":"text","value":[{"t":2,"r":"serviceSearchTerm"}],"placeholder":[{"t":2,"r":"content.serviceSearchLabel"}],"name":"serviceSearch"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"button postfix icon icon-only icon-search","aria-title":"Search"}}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-4 small-12"},"f":[{"t":7,"e":"select","a":{"name":"serviceServiceType","value":[{"t":2,"r":"serviceServiceType"}]},"f":[{"t":7,"e":"option","a":{"value":""},"f":["Filter by service type"]}," ",{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":"."}]},"f":[{"t":2,"r":"."}]}],"n":52,"r":"serviceTypes"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-4 small-12"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"reset-filters"},"v":{"anchorClicked":"resetServiceFilters"},"f":["Reset filters"]}]}]}]}]},"serviceSelectorSetEmailLogin":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"set-email-login-container"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"spinner-overlay"},"f":[{"t":7,"e":"ux-spinner","a":{"datamodel":""}}]}],"r":"loadingSpinnerStatus"}," ",{"t":7,"e":"ux-reveal","a":{"class":"set-emai-login-modal","modalVisible":"visibility"},"f":[{"t":7,"e":"div","a":{"class":"reveal-section-header"},"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":["Change your username to an email address"]}]}," ",{"t":7,"e":"div","a":{"class":"edit-username"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-alert","a":{"class":["alert-notification ",{"t":2,"r":"setLoginEmailStatusBox.class"}]},"f":[{"t":2,"r":"setLoginEmailStatusBox.message"}]}]}]}],"r":"setLoginEmailStatusBox.show"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":3,"r":"introduction"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8"},"f":[{"t":7,"e":"p","f":["Username: ",{"t":7,"e":"strong","f":[{"t":2,"r":"loggedInUserName"}]}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8 email-input"},"f":[{"t":7,"e":"ux-input-box","a":{"value":[{"t":2,"r":"loginEmailInput.value"}],"datamodel":[{"t":3,"r":"loginEmailInput"}]}}," ",{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"r":"loginEmailInput.valueErrorMsg"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-8 confirm-email-input"},"f":[{"t":7,"e":"ux-input-box","a":{"value":[{"t":2,"r":"confirmLoginEmailInput.value"}],"datamodel":[{"t":3,"r":"confirmLoginEmailInput"}]}}," ",{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"r":"confirmLoginEmailInput.valueErrorMsg"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":3,"r":"additionalInformation"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"updateLoginEmail","class":"button yellow radius expand submit-email","role":"button"},"f":["Change"]}]}]}]}]}]}]},"shippingAddressChooseMultipleAddresses":{"v":3,"t":[{"t":4,"f":[" ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-sub-heading","a":{"title":[{"t":2,"x":{"r":["@index"],"s":"_0+1"}},". ",{"t":2,"r":"mockedDisplayItem.title"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[" ",{"t":7,"e":"ux-detailed-product-panel","a":{"isDataModel":"true","datamodel":[{"t":3,"r":"mockedDisplayItem"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"deliveryAddressFormTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-radio-button-group","a":{"id":[{"t":2,"r":"./catalogID"}],"productOrderItemId":[{"t":2,"r":"./productOrderItemId"}],"style":"basic stacked","selected":[{"t":2,"r":"./selected"}],"radio_btns":[{"t":2,"r":"./radioButtonOptions"}]}}]}],"n":50,"r":"enableDeliveryAddressRadioBtn"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-customer-address","a":{"initData":[{"t":2,"r":"initData"}],"disableSaveButton":"true","id":[{"t":2,"rx":{"r":"displayItems","m":[{"t":30,"n":"@index"},"productOrderItemId"]}}],"addressResponseHolder":[{"t":2,"rx":{"r":"displayItems","m":[{"t":30,"n":"@index"},"addressResponseHolder"]}}],"productId":[{"t":2,"rx":{"r":"displayItems","m":[{"t":30,"n":"@index"},"productOrderItemId"]}}],"isSalesFlow":"true","hideReadPrivacy":"true"}}]}],"n":50,"rx":{"r":"displayItems","m":[{"t":30,"n":"@index"},"showCustomerAddressForm"]}}," ",{"t":7,"e":"div","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-textarea","a":{"id":[{"t":2,"rx":{"r":"displayItems","m":[{"t":30,"n":"@index"},"catalogID"]}}],"index":[{"t":2,"r":"@index"}],"label_value":[{"t":2,"r":"initData.customerCommentsTextareaLabel"}],"value":[{"t":2,"rx":{"r":"displayItems","m":[{"t":30,"n":"@index"},"shippingInstructions"]}}],"class":"comments","rows":"3","onblurEvent":"checkCommentsValidation","validity":[{"t":2,"rx":{"r":"displayItems","m":[{"t":30,"n":"@index"},"shippingInstructionsErrorMsg"]}}]},"f":[]}]}]}],"r":"displayItems"},{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-checkbox","a":{"checkboxid":"readPrivacyAddress","data-id":"readPrivacyChkBox","mandatory":"true","checked":[{"t":2,"r":"readMultipleItemsPrivacy"}],"labelvalue":[{"t":2,"r":"initData.address.updateAddressPrivacyLabel"}],"validity":[{"t":2,"r":"readMultipleItemsPrivacyErrorMsg"}]}}]}],"n":50,"r":"showMultipleItemsPrivacyCB"},{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-button-sd","a":{"text":[{"t":2,"r":"initData.buttonLabelMultipleAddressesConfirm"}],"type":"primary","ontap":"buttonConfirmMultipleAddresses","disabled":[{"t":2,"r":"disableNextButton"}]}}]}]},"TabsArea":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"tabs"},"f":[{"t":8,"r":"content"}]}]},"TabsLink":{"v":3,"t":[{"t":7,"e":"div","a":{"class":["tabs-link ",{"t":2,"r":"class"}," ",{"t":4,"f":["active"],"n":50,"r":"active"}],"data-targetPaneId":[{"t":2,"r":"targetPaneId"}]},"f":[{"t":7,"e":"a","a":{"href":"#"},"v":{"click":"clicked"},"f":[{"t":8,"r":"content"}]}]}]},"TabsPane":{"v":3,"t":[{"t":7,"e":"div","a":{"class":["tabs-pane ",{"t":2,"r":"class"}," ",{"t":4,"f":["hide"],"n":50,"x":{"r":["active"],"s":"!_0"}}],"id":[{"t":2,"r":"id"}]},"f":[{"t":8,"r":"content"}]}]},"termsAndConditions":{"v":3,"t":[{"t":7,"e":"ux-accordion","a":{"class":"terms-and-conditions"},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","a":{"class":"terms-heading","href":"#"},"f":[{"t":7,"e":"span","a":{"class":"terms-heading-text"},"f":["Terms & Conditions"]}," ",{"t":7,"e":"span","a":{"class":"icon icon-arrow-up"}}," ",{"t":7,"e":"span","a":{"class":"icon icon-dropdown"}}]}," ",{"t":7,"e":"ux-content","f":[{"t":7,"e":"p","f":[{"t":7,"e":"strong","f":["Prepaid services:"]}," GST inclusive for Prepaid mobile services.",{"t":7,"e":"br"}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"strong","f":["IMPORTANT NOTICE"]},{"t":7,"e":"br"}," Heads up: If you've been roaming on Optus Prepaid and have used data in Zone 1 countries the rate per 10kb is $0.004883. If you've used 10kb or less, you'll see it rounded down to $0.00. However you will still be charged for what you have used. For more info on Prepaid roaming visit ",{"t":7,"e":"a","a":{"href":"//www.optus.com.au/travel"},"f":["optus.com.au/travel"]},".",{"t":7,"e":"br"}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"strong","f":["Postpaid services:"]}," Due to processing time, recent usage may not appear in the summary above. Amounts shown are: GST exclusive for telephony, Postpaid mobile and mobile broadband services. Usage balance, including charges and data usage may not take into account plan inclusions/discounts or adjustments. If you have over 7000 records, unbilled usage shown will be approximate. Please refer to your invoice for actual charges."]}," ",{"t":7,"e":"p","f":["For more information:"]}," ",{"t":7,"e":"ul","f":[{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"target":"_blank","href":"http://www.optus.com.au/shop/support/answer?answerId=1325&question=%20&typeId=6"},"f":["Please view our usage information page"]},"."]}]}]}]}]}]},"unbilledUsageFixedDashboardSummary":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center"},"f":[{"t":7,"e":"ux-list","a":{"noNavigation":"true","pageHide":"hidePagination","datamodel":[{"t":3,"r":"unbilled_usage.fixed_service_list"}]}}]}]}],"n":50,"x":{"r":["unbilled_usage.fixed_service_list.list_items.length"],"s":"_0>1"}}]},"unbilledUsageInMigrationPeriodMessage":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"usage-details-warning v-p-normal-top "},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"layout-main-section--form-element"},"f":[{"t":7,"e":"ux-warning-alert","a":{"notifications":[{"t":2,"r":"inMigrationNotifications"}]}}]}]}]}]},"unbilledUsageMultiServicesDashboardSummary":{"v":3,"t":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"section-header"},"f":[{"t":2,"r":"initData.data_usage_title"}]}]}]}],"n":50,"x":{"r":["unbilled_usage.mobile_service_list.list_items.length"],"s":"_0>1"}}],"n":51,"r":"unbilled_usage.shared_service"},{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center"},"f":[{"t":4,"f":[{"t":7,"e":"ux-list-item","a":{"noNavigation":"true","pageHide":"hidePagination","icon_left":[{"t":2,"r":"icon_left"}],"icon_left_size":"xl"},"f":[]}],"r":"unbilled_usage.mobile_service_list.list_items"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"moreServicePanel"},"f":[{"t":4,"f":[{"t":7,"e":"ux-list-item","a":{"noNavigation":"true","pageHide":"hidePagination","icon_left":[{"t":2,"r":"icon_left"}],"icon_left_size":"xl"},"f":[]}],"r":"unbilled_usage.sharedOtherServiceAccordianItems.list_items"}]}],"n":51,"r":"initData.hide_more"}," ",{"t":7,"e":"ux-anchor","a":{"class":["text-center moreUsageText ",{"t":4,"f":["hide"],"n":51,"r":"initData.hide_more"}],"ontap":"showMoreServices"},"f":[{"t":2,"r":"unbilled_usage.link.content"}]}],"n":50,"r":"unbilled_usage.sharedOtherServiceAccordian"}]}]}]},"unbilledUsageOtherDashboardSummary":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"section-header"},"f":[{"t":2,"r":"initData.other_services_label"}]}]}]}],"n":50,"r":"unbilled_usage.multi_service"},{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal"},"f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":7,"e":"ux-list","a":{"noNavigation":"true","pageHide":"hidePagination","datamodel":[{"t":3,"r":"unbilled_usage.other_service_list"}],"icon_left":[{"t":2,"x":{"r":["RactiveHelpers","unbilled_usage.other_service_list.type"],"s":"_0.getServicePropLobOptus(_1,\"icon\")"}}],"icon_left_size":"xl"}}]}]}]}]},"unbilledUsageSharedDashboardSummary":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"section-header"},"f":[{"t":2,"r":"initData.shared_data_usage_title"}]}],"n":50,"x":{"r":["unbilled_usage.multi_service","unbilled_usage.isSingleSharedService"],"s":"_0&&!_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["unbilled_usage.multi_service","unbilled_usage.isSingleSharedService"],"s":"_0&&_1"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"section-header"},"f":[{"t":4,"f":[{"t":2,"r":"unbilled_usage.nickName"}],"n":50,"r":"unbilled_usage.nickName"},{"t":4,"n":51,"f":[{"t":2,"r":"initData.data_usage_title"}],"r":"unbilled_usage.nickName"}]}]},{"t":4,"n":50,"x":{"r":["unbilled_usage.multi_service","unbilled_usage.isSingleSharedService"],"s":"!(_0&&_1)"},"f":[" ",{"t":7,"e":"ux-header","a":{"level":"5","class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","unbilled_usage.nickName"],"s":"_0.formatForDisplayPhoneNumber(_1)"}}]}]}],"x":{"r":["unbilled_usage.multi_service","unbilled_usage.isSingleSharedService"],"s":"_0&&!_1"}}," ",{"t":7,"e":"ux-header","a":{"level":"6","class":"section-header"},"f":[{"t":2,"r":"unbilled_usage.cycleStartDate"}," - today"]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal"},"f":[{"t":7,"e":"ux-donut-chart-multi-ring","a":{"datamodel":[{"t":3,"r":"unbilled_usage.donut_chart"}],"end_date":[{"t":2,"r":"unbilled_usage.cycleEndDate"}]}}]}]}],"n":50,"x":{"r":["unbilled_usage.usageHaventRun","unbilled_usage.donut_chart.total_mb_in_plan"],"s":"_0&&_1!==0"}}]},"unbilledUsageSingleServiceDashboardSummary":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"section-header"},"f":[{"t":2,"r":"unbilled_usage.nickName"}]}," ",{"t":7,"e":"ux-header","a":{"level":"6","class":"section-header"},"f":[{"t":2,"r":"unbilled_usage.cycleStartDate"}," - today"]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal text-center"},"f":[{"t":7,"e":"ux-donut-chart-multi-ring","a":{"datamodel":[{"t":3,"r":"unbilled_usage.donut_chart"}]}}]}],"n":50,"r":"unbilled_usage.shared_service"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"text-center"},"f":[{"t":7,"e":"ux-donut-chart-multi-ring","a":{"days_remaining":[{"t":2,"r":"unbilled_usage.donut_chart.days_remaining"}],"mb_used":[{"t":2,"r":"unbilled_usage.donut_chart.mb_used"}],"excess_amount":[{"t":2,"r":"unbilled_usage.donut_chart.excess_amount"}],"excess_used":[{"t":2,"r":"unbilled_usage.donut_chart.excess_used"}],"total_mb_in_plan":[{"t":2,"r":"unbilled_usage.donut_chart.total_mb_in_plan"}],"has_tiered":[{"t":2,"r":"unbilled_usage.donut_chart.has_tiered"}],"used_date":[{"t":2,"r":"unbilled_usage.donut_chart.used_date"}],"usage_unit_display":[{"t":2,"r":"unbilled_usage.donut_chart.usage_unit_display"}],"used_up_label":[{"t":2,"r":"unbilled_usage.donut_chart.used_up_label"}],"days_left":[{"t":2,"r":"unbilled_usage.donut_chart.days_left"}],"remaining_next_bill_label":[{"t":2,"r":"unbilled_usage.donut_chart.remaining_next_bill_label"}],"days_left_next_bill_label":[{"t":2,"r":"unbilled_usage.donut_chart.days_left_next_bill_label"}],"you_have_label":[{"t":2,"r":"unbilled_usage.donut_chart.you_have_label"}],"data_available_prefix":[{"t":2,"r":"unbilled_usage.donut_chart.data_available_prefix"}],"left_of_label":[{"t":2,"r":"unbilled_usage.donut_chart.left_of_label"}],"we_added_label":[{"t":2,"r":"unbilled_usage.donut_chart.we_added_label"}],"used_label":[{"t":2,"r":"unbilled_usage.donut_chart.used_label"}],"used_of_label":[{"t":2,"r":"unbilled_usage.donut_chart.used_of_label"}],"usage_type_label":[{"t":2,"r":"unbilled_usage.donut_chart.usage_type_label"}],"allowance_label":[{"t":2,"r":"unbilled_usage.donut_chart.allowance_label"}],"end_date":[{"t":2,"r":"unbilled_usage.cycleEndDate"}],"partitionDenomination":"Data","final_tier":[{"t":2,"r":"unbilled_usage.donut_chart.final_tier"}],"tiering_message":[{"t":2,"r":"unbilled_usage.donut_chart.tiering_message"}],"notifications":[{"t":2,"r":"unbilled_usage.donut_chart.notifications"}]}}]}],"r":"unbilled_usage.shared_service"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-normal text-center"},"f":[{"t":7,"e":"ux-button-sd","a":{"type":"primary","text":[{"t":2,"r":"initData.view_details_text"}],"ontap":"buttonTapHandler"}}]}]}],"n":50,"x":{"r":["unbilled_usage.usageHaventRun","unbilled_usage.donut_chart.total_mb_in_plan"],"s":"_0&&_1!==0"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["unbilled_usage.donut_chart.total_mb_in_plan"],"s":"_0==0"},"f":[" ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center "},"f":[{"t":7,"e":"ux-list","a":{"noNavigation":"true","datamodel":[{"t":3,"r":"unbilled_usage.mobile_service_list"}],"icon_left":[{"t":2,"x":{"r":["RactiveHelpers","unbilled_usage.mobile_service_list.type"],"s":"_0.getServicePropLobOptus(_1,\"icon\")"}}],"icon_left_size":"xl"}}]}]}]},{"t":4,"n":50,"x":{"r":["unbilled_usage.donut_chart.total_mb_in_plan"],"s":"!(_0==0)"},"f":[" ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","unbilled_usage.nickName"],"s":"_0.formatForDisplayPhoneNumber(_1)"}}]}," ",{"t":7,"e":"ux-header","a":{"level":"6","class":"section-header"},"f":[{"t":2,"r":"unbilled_usage.cycleStartDate"}," - today"]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-normal text-center"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"initData.noDataUsageText"}]}," ",{"t":7,"e":"p","a":{"class":"days-remaining strong"},"f":[{"t":2,"x":{"r":["unbilled_usage.daysToNextBill"],"s":"Math.round(_0)"}},{"t":2,"r":"unbilled_usage.donut_chart.days_left_next_bill_label"}," ",{"t":2,"r":"unbilled_usage.cycleEndDate"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-normal text-center"},"f":[{"t":7,"e":"ux-button-sd","a":{"type":"primary","text":[{"t":2,"r":"initData.view_details_text"}],"ontap":"buttonTapHandler"}}]}]}]}],"x":{"r":["unbilled_usage.usageHaventRun","unbilled_usage.donut_chart.total_mb_in_plan"],"s":"_0&&_1!==0"}}]},"usageMeterBbMeter":{"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"collapse row-spacer-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 uppercase meter-label"},"f":[{"t":7,"e":"div","a":{"class":"heading-quaternary hide-for-small"},"f":[{"t":7,"e":"span","a":{"class":"ico ico-internet strong"}}," ",{"t":7,"e":"span","a":{"class":"small-quantity"},"f":[{"t":2,"r":"meter.name"}]}]}," ",{"t":7,"e":"div","a":{"class":"heading-quinary small-quantity show-for-small"},"f":[{"t":2,"r":"meter.name"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-10 medium-11 small-12"},"f":[{"t":7,"e":"div","a":{"class":["meter ",{"t":4,"f":["stripes"],"n":50,"r":"meter.isUnlimited"}," green"]},"f":[{"t":7,"e":"div","a":{"class":"usage","style":["width: ",{"t":2,"x":{"r":["meter.isUnlimited","meter.usagePrecentage"],"s":"_0?\"100\":_1"}},"%"]},"f":[{"t":7,"e":"span","f":[{"t":4,"f":[{"t":2,"r":"meter.consumedUsage"}," used of ",{"t":2,"r":"meter.totalUsage"}],"n":51,"r":"meter.isUnlimited"}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-2 medium-3 hide-for-small quantity"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"usage-remaining"},"f":[{"t":7,"e":"div","a":{"class":"remaining heading-quaternary"},"f":[{"t":2,"r":"meter.remainingUsage"}]}," Left from ",{"t":2,"r":"meter.totalUsage"}]}],"n":51,"r":"meter.isUnlimited"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"meter-extra-details collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 remaining-usage heading-quinary"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"used-percentage"},"f":[{"t":2,"r":"meter.usagePrecentage"},"%"]}," used"],"n":51,"r":"meter.isUnlimited"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"meter-data-separator"},"f":["|"]}],"n":50,"r":"meter.displayDataSperator"}," ",{"t":4,"f":[{"t":2,"r":"meter.dateRange.daysRemaining"}," day",{"t":2,"x":{"r":["meter.dateRange.daysRemaining"],"s":"_0>1?\"s\":\"\""}}," remaining"],"n":50,"r":"meter.dateRange"}]}]}]},"usageMeterHwbbMeter":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":"alert-box alert-notification alert-notification-data"},"f":[{"t":7,"e":"div","a":{"class":"caption"},"f":[{"t":4,"f":[{"t":7,"e":"strong","f":["Alert:"]}," ",{"t":2,"r":"meter.warningMsg"}],"n":50,"r":"meter.isWarning"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["meter.isThrottled"],"s":"_0"},"f":[{"t":7,"e":"strong","f":["Alert:"]}," ",{"t":2,"r":"meter.throttledMsg"}]}],"r":"meter.isWarning"}]}]}]}]}],"n":50,"x":{"r":["meter.isWarning","meter.isThrottled"],"s":"_0||_1"}}," ",{"t":7,"e":"ux-row","a":{"class":"collapse hide-for-small"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 heading-tertiary meter-label"},"f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":7,"e":"span","a":{"class":"icon ico-internet"}},"Data"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse show-for-small"},"f":[{"t":7,"e":"div","a":{"class":"table"},"f":[{"t":7,"e":"div","a":{"class":"tr"},"f":[{"t":7,"e":"div","a":{"class":"td"},"f":[{"t":7,"e":"div","a":{"class":" meter-label"},"f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":7,"e":"abbr","a":{"title":"Included Data"},"f":["Data"]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"td"},"f":[{"t":7,"e":"div","a":{"class":"units-label remaining-container right"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":["Limit Reached"]}],"n":50,"r":"meter.isThrottled"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":[{"t":2,"r":"meter.remainingUsage"},{"t":7,"e":"span","a":{"class":"units"},"f":[" remaining"]}]}],"r":"meter.isThrottled"}]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse row-spacer-top"},"f":[" ",{"t":7,"e":"ux-col","a":{"class":"medium-9 small-12 progress-bar"},"f":[{"t":7,"e":"ux-row","a":{"class":"usage collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":["progress bar ",{"t":2,"r":"meter.colourCss"}," ",{"t":4,"f":["small-12"],"n":50,"x":{"r":["meter.isLastTier","meter.isThrottled"],"s":"_0||_1"}},{"t":4,"n":51,"f":["small-9 medium-10 large-10"],"x":{"r":["meter.isLastTier","meter.isThrottled"],"s":"_0||_1"}}," small-collapse"]},"f":[{"t":7,"e":"span","a":{"class":"meter","style":["width:",{"t":2,"r":"meter.usagePrecentage"},"%"]}}]}," ",{"t":7,"e":"ux-header","a":{"level":"5","class":"progress-label"},"f":[{"t":2,"r":"meter.usagePrecentage"},"% Used"]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-3 medium-2 large-2 tiers valign-middle"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-3 medium-4 large-3"},"f":[{"t":7,"e":"span","a":{"class":"center"},"f":["+"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-9 medium-8 large-9"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"hide-for-small quota"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"meter.nextTierExtraUsage"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"meter.nextTierExtraCost"}]}]}," ",{"t":7,"e":"ux-header","a":{"level":"5","class":"show-for-small small-quota"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"meter.nextTierExtraUsage"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"meter.nextTierExtraCost"}]}]}]}]}]}],"n":51,"x":{"r":["meter.isLastTier","meter.isThrottled"],"s":"_0||_1"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3 hide-for-small quantity"},"f":[{"t":7,"e":"div","a":{"class":"remaining-container"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"remaining-limit"},"f":["Limit Reached"]}],"n":50,"r":"meter.isThrottled"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"remaining"},"f":[{"t":2,"r":"meter.remainingUsage"}]}," ",{"t":7,"e":"ux-header","a":{"level":"5"},"f":["Remaining"]}],"r":"meter.isThrottled"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"meter-extra-details collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 total-usage heading-quinary"},"f":["Included ",{"t":2,"r":"meter.totalUsage"}]}]}]},"usageSummaryAlertNotification":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-alert","a":{"class":["alert-notification ",{"t":4,"f":["alert-notification-",{"t":2,"r":".class"}],"n":50,"r":".class"}]},"f":[{"t":7,"e":"span","a":{"class":"caption"},"f":[{"t":7,"e":"strong","f":["Alert:"]}," ",{"t":3,"r":".text"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"a","a":{"href":[{"t":4,"f":[{"t":2,"r":".url"}],"n":50,"r":".url"},{"t":4,"n":51,"f":["#"],"r":".url"}],"class":"caption"},"v":{"tap":{"n":[{"t":4,"f":["openExcessUsageDetails"],"n":50,"r":".openDetails"}],"d":[]}},"f":[{"t":2,"r":".label"}]}]}],"n":52,"r":".links"}]}],"n":53,"r":"alert"}]},"usageSummaryExcludedUsage":{"v":3,"t":[{"t":7,"e":"ux-panel","a":{"class":"light-panel collapse-side-bottom usage-charge-tables"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-7 small-8"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"hide-for-small"},"f":["Excess and Excluded charges"]}," ",{"t":7,"e":"ux-header","a":{"level":"4","class":"show-for-small"},"f":["Exc. & Excl. charges"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-5 small-4 text-right usage-charge-totals"},"f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"chargesTotal"}]}," ",{"t":7,"e":"p","a":{"class":"caption"},"f":["(excl GST)"]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"hr"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["usage-charge-",{"t":2,"r":".name"}],"n":50,"r":".name"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"small-7"},"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":[{"t":2,"r":".heading"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 text-right"},"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":[{"t":2,"r":".total"}]}," ",{"t":7,"e":"p","a":{"class":"caption"},"f":["(excl GST)"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":["simple-accordion ",{"t":4,"f":["usage-table-",{"t":2,"r":".name"}],"n":50,"r":".name"}]},"f":[{"t":7,"e":"ux-accordion","a":{"table":[{"t":2,"r":".table"}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"table":[{"t":2,"r":".table"}]},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-anchor","a":{"class":"show-details"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-arrow-down icon-small"}}," Show Details"]}," ",{"t":7,"e":"ux-anchor","a":{"class":"hide-details"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-arrow-up icon-small"}}," Hide Details"]}]}," ",{"t":7,"e":"ux-content","a":{"table":[{"t":2,"r":".table"}]},"f":[{"t":7,"e":"ux-table","a":{"datamodel":[{"t":3,"r":".table"}]}}]}]}]}]}]}]}],"n":52,"r":"charges"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"hr","a":{"class":"collapse-top"}}]}]}],"n":50,"r":"hasCharges"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"p","a":{"class":"caption"},"f":[{"t":7,"e":"strong","f":["Note:"]}," The above calculations do not account for any Optus Travel",{"t":7,"e":"sup","f":["TM"]}," Packs you may have purchased. Please refer to your PDF bill for all applicable usage and charges."]}]}]}]}]},"usageSummaryHeader":{"v":3,"t":[{"t":7,"e":"ux-panel","a":{"class":"light-panel usage-summary-header"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"small-12 medium-6 columns usage"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"hide-for-small medium-1 columns icon"},"f":[{"t":7,"e":"span","a":{"class":"icon-calendar"}}]}," ",{"t":7,"e":"div","a":{"class":"small-12 medium-11 columns usage-header-billing-period"},"f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":[{"t":2,"r":"usageHeader.periodStart"}," to ",{"t":2,"r":"usageHeader.periodEnd"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"caption"},"f":["Your usage was last updated ",{"t":7,"e":"strong","f":[{"t":2,"r":"usageHeader.usageLastUpdated"}]}]}],"n":50,"r":"usageHeader.usageLastUpdated"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"small-12 medium-6 columns wrapper-remaining"},"f":[{"t":7,"e":"ux-label","a":{"class":["radius ",{"t":2,"r":"usageHeader.remainingClass"}," days-remaining"]},"f":[{"t":2,"r":"usageHeader.remainingMessage"}]}]}]}]}]},"usageSummaryIITBanner":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"industrie-banner"},"f":[{"t":3,"r":"industrieITBanner"}]}]}]},"usageSummaryPrepaidUsage":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"usage-panels"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"hr","a":{"class":"collapse-top"}}]}]}," ",{"t":7,"e":"ux-panel","a":{"class":"no-border"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-table","a":{"datamodel":[{"t":2,"r":"usageTable"}]}}]}]}]}," ",{"t":7,"e":"ux-panel","a":{"class":"light-panel no-border"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"p","f":["Your Pre-paid balance is as of ",{"t":7,"e":"strong","f":[{"t":2,"r":"usageHeader.usageLastUpdated"}]}]}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"hr","a":{"class":"collapse-top"}}]}]}," ",{"t":7,"e":"ux-panel","a":{"class":"no-border"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":7,"e":"p","f":["Your service will expire if not recharged before ",{"t":7,"e":"strong","f":[{"t":2,"r":"usageHeader.periodEnd"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":[{"t":7,"e":"a","a":{"class":"button small radius yellow","href":[{"t":2,"r":"usageHeader.rechargePrepaidUrl"}],"target":"_blank"},"f":["RECHARGE NOW"]}]}]}]}]}]},"usageSummaryTable":{"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":["simple-accordion ",{"t":4,"f":[{"t":2,"x":{"r":["formatMeterName",".meter"],"s":"_0(_1)"}}],"n":50,"r":".meter"}]},"f":[{"t":7,"e":"ux-accordion","a":{"table":[{"t":2,"r":".table"}],"class":["accordion-",{"t":2,"r":".meter.name"}],"sharedMeters":[{"t":2,"r":".sharedMeters"}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-anchor","a":{"class":"show-details"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-arrow-down icon-small"}}," Show Details"]}," ",{"t":7,"e":"ux-anchor","a":{"class":"hide-details"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-arrow-up icon-small"}}," Hide Details"]}]}," ",{"t":7,"e":"ux-content","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-usage-meter-tiered","a":{"datamodel":[{"t":3,"r":"."}]}}],"n":52,"r":".sharedMeters"}],"n":50,"r":".sharedMeters"}," ",{"t":7,"e":"ux-table","a":{"datamodel":[{"t":3,"r":".table"}]}}]}]}]}]}]}]}]},"usageSummaryUsagePanel":{"v":3,"t":[{"t":7,"e":"div","a":{"class":"usage-panels"},"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":["light-panel collapse ",{"t":4,"f":["last"],"n":50,"x":{"r":["@index","usageMeters.length"],"s":"(_0+1)===_1"}}]},"f":[{"t":4,"f":[{"t":8,"r":"usageSummaryAlertNotification"}],"n":50,"r":"alert.text"}," ",{"t":7,"e":"div","a":{"class":"usage-summary-meters"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-usage-meter-tiered","a":{"datamodel":[{"t":3,"r":".meter"}]}}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"b","a":{"class":"incl caption"},"f":[{"t":2,"r":"meter.inclusion"}]}]}],"n":50,"r":"meter.inclusion"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"b","a":{"class":"base-tier caption"},"f":[{"t":2,"x":{"r":["getBaseTierMessage","meter"],"s":"_0(_1)"}}," ",{"t":4,"f":["(Standard National Talk)"],"n":50,"x":{"r":["showPlanInclTalkNote","meter"],"s":"_0(_1)"}}]}]}],"n":50,"x":{"r":["showBaseTierMessage","meter"],"s":"_0(_1)"}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"b","a":{"class":"tier-total caption"},"f":[{"t":2,"x":{"r":["getTierSummaryMessage","meter.tier"],"s":"_0(_1)"}}]}]}],"n":50,"x":{"r":["showTierSummaryMessage","meter"],"s":"_0(_1)"}}]}]}]}]}," ",{"t":4,"f":[{"t":8,"r":"usageSummaryTable"}],"n":50,"x":{"r":["showUsageTable","meter","table","sharedMeters"],"s":"_0(_1,_2,_3)"}}]}],"n":52,"r":"usageMeters"}]}]},"ux-selected-billing-offer":{"v":3,"t":[{"t":7,"e":"div","f":[{"t":2,"rx":{"r":"addonActionsRead.productConfiguration.allProductsByCatalogId","m":[{"t":30,"n":"selectedOption"},"productTitle"]}}]}]},"ux-selected-charge-to-service":{"v":3,"t":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["selectedOption.primaryResource"],"s":"_0||_0"}}]}]},"ux-selected-default-template":{"v":3,"t":[{"t":7,"e":"div","f":[{"t":2,"r":"selectedOption"}]}]},"ux-selected-service":{"v":3,"t":[{"t":7,"e":"div","f":[{"t":2,"r":"selectedOption.serviceId"}]}]},"ux-selected-value":{"v":3,"t":[{"t":7,"e":"div","f":[{"t":2,"r":"selectedOption.serviceId"}]}]},"validationError":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":"error"},"f":[{"t":3,"r":"message"}]}],"n":50,"r":"message"}]},"validationErrorMsg":{"v":3,"t":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":[{"t":2,"r":"../errorMsgName"}]},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"n":53,"f":[{"t":8,"r":"validationError"}],"x":{"r":["message"],"s":"{message:_0}"}}]}]}],"n":50,"x":{"r":["status"],"s":"_0!==\"valid\""}}],"n":53,"r":"./errorMsg"}]},"validationServerErrors":{"v":3,"t":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-alert","a":{"class":"alert-notification errors"},"f":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":["error ",{"t":2,"r":"./errorId"}]},"f":[{"t":2,"r":"./errorMsg"}]}],"n":52,"r":"errors"}]}]}]}],"n":50,"r":"errors"}]},"xhrLoading":{"v":3,"t":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-spinner","a":{"class":"text-center"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"loading-message"},"f":[{"t":7,"e":"p","f":["Please be patient.... it can take up to a few minutes to retrieve data."]}]}]}]}]}}});
define('globalRactivePartials',['ractive', 'RedmarinePartials'], function(Ractive, RedmarinePartials) {
	/*global lux_skip_global_partials*/
	// This flag is to allow nodejs unit testing to proceed, without having to have a DOM defined.
	if (typeof lux_skip_global_partials === 'undefined' || lux_skip_global_partials !== true) {
		// Set global partials for all widgets/components to use.
		Ractive.partials = RedmarinePartials;
	}
});

/**
 * @license
 * lodash 3.10.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash compat -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.2';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to fix the JScript `[[DontEnum]]` bug. */
  var shadowProps = [
    'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable',
    'toLocaleString', 'toString', 'valueOf'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */
  var isHostObject = (function() {
    try {
      Object({ 'toString': 0 } + '');
    } catch(e) {
      return function() { return false; };
    }
    return function(value) {
      // IE < 9 presents many host objects as `Object` objects that can coerce
      // to strings despite having improperly defined `toString` methods.
      return typeof value.toString != 'function' && typeof (value + '') == 'string';
    };
  }());

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        errorProto = Error.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to lookup a type array constructors by `toStringTag`. */
    var ctorByTag = {};
    ctorByTag[float32Tag] = context.Float32Array;
    ctorByTag[float64Tag] = context.Float64Array;
    ctorByTag[int8Tag] = context.Int8Array;
    ctorByTag[int16Tag] = context.Int16Array;
    ctorByTag[int32Tag] = context.Int32Array;
    ctorByTag[uint8Tag] = Uint8Array;
    ctorByTag[uint8ClampedTag] = context.Uint8ClampedArray;
    ctorByTag[uint16Tag] = context.Uint16Array;
    ctorByTag[uint32Tag] = context.Uint32Array;

    /** Used to avoid iterating over non-enumerable properties in IE < 9. */
    var nonEnumProps = {};
    nonEnumProps[arrayTag] = nonEnumProps[dateTag] = nonEnumProps[numberTag] = { 'constructor': true, 'toLocaleString': true, 'toString': true, 'valueOf': true };
    nonEnumProps[boolTag] = nonEnumProps[stringTag] = { 'constructor': true, 'toString': true, 'valueOf': true };
    nonEnumProps[errorTag] = nonEnumProps[funcTag] = nonEnumProps[regexpTag] = { 'constructor': true, 'toString': true };
    nonEnumProps[objectTag] = { 'constructor': true };

    arrayEach(shadowProps, function(key) {
      for (var tag in nonEnumProps) {
        if (hasOwnProperty.call(nonEnumProps, tag)) {
          var props = nonEnumProps[tag];
          props[key] = hasOwnProperty.call(props, key);
        }
      }
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    (function(x) {
      var Ctor = function() { this.x = x; },
          object = { '0': x, 'length': x },
          props = [];

      Ctor.prototype = { 'valueOf': x, 'y': x };
      for (var key in new Ctor) { props.push(key); }

      /**
       * Detect if `name` or `message` properties of `Error.prototype` are
       * enumerable by default (IE < 9, Safari < 5.1).
       *
       * @memberOf _.support
       * @type boolean
       */
      support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') ||
        propertyIsEnumerable.call(errorProto, 'name');

      /**
       * Detect if `prototype` properties are enumerable by default.
       *
       * Firefox < 3.6, Opera > 9.50 - Opera < 11.60, and Safari < 5.1
       * (if the prototype or a property on the prototype has been set)
       * incorrectly set the `[[Enumerable]]` value of a function's `prototype`
       * property to `true`.
       *
       * @memberOf _.support
       * @type boolean
       */
      support.enumPrototypes = propertyIsEnumerable.call(Ctor, 'prototype');

      /**
       * Detect if properties shadowing those on `Object.prototype` are non-enumerable.
       *
       * In IE < 9 an object's own properties, shadowing non-enumerable ones,
       * are made non-enumerable as well (a.k.a the JScript `[[DontEnum]]` bug).
       *
       * @memberOf _.support
       * @type boolean
       */
      support.nonEnumShadows = !/valueOf/.test(props);

      /**
       * Detect if own properties are iterated after inherited properties (IE < 9).
       *
       * @memberOf _.support
       * @type boolean
       */
      support.ownLast = props[0] != 'x';

      /**
       * Detect if `Array#shift` and `Array#splice` augment array-like objects
       * correctly.
       *
       * Firefox < 10, compatibility modes of IE 8, and IE < 9 have buggy Array
       * `shift()` and `splice()` functions that fail to remove the last element,
       * `value[0]`, of array-like objects even though the "length" property is
       * set to `0`. The `shift()` method is buggy in compatibility modes of IE 8,
       * while `splice()` is buggy regardless of mode in IE < 9.
       *
       * @memberOf _.support
       * @type boolean
       */
      support.spliceObjects = (splice.call(object, 0, 1), !object[0]);

      /**
       * Detect lack of support for accessing string characters by index.
       *
       * IE < 8 can't access characters by index. IE 8 can only access characters
       * by index on string literals, not string objects.
       *
       * @memberOf _.support
       * @type boolean
       */
      support.unindexedChars = ('x'[0] + Object('x')[0]) != 'xx';
    }(1, 0));

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          if (isHostObject(value)) {
            return object ? value : {};
          }
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf === baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      object = toObject(object);
      if (pathKey !== undefined && pathKey in object) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = toObject(object)[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag && !isHostObject(object),
          othIsObj = othTag == objectTag && !isHostObject(other),
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          object = toObject(object);
          return object[key] === value && (value !== undefined || (key in object));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : toObject(object)[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf === baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          // Safari 5 mobile incorrectly has `Object` as the constructor of typed arrays.
          if (Ctor instanceof Ctor) {
            Ctor = ctorByTag[tag];
          }
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object) || isString(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      if (lodash.support.unindexedChars && isString(value)) {
        return value.split('');
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      if (lodash.support.unindexedChars && isString(value)) {
        var index = -1,
            length = value.length,
            result = Object(value);

        while (++index < length) {
          result[index] = value.charAt(index);
        }
        return result;
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it's only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf === baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it's invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it's invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() === baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      if (isArrayLike(collection)) {
        collection = toIterable(collection);
      }
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `target` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it's
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it's invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it's
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with up to three argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 3))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it's invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with up to three argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 3))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it's an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it's invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with up to
     * three arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 which returns 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it's invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isHostObject(value) && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      if (lodash.support.ownLast) {
        baseForIn(value, function(subValue, key, object) {
          result = hasOwnProperty.call(object, key);
          return false;
        });
        return result !== false;
      }
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return (lodash.support.unindexedChars && isString(value))
        ? value.split('')
        : arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it's invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it's invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), (path + ''));
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object) || isString(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object == 'function' ? lodash.support.enumPrototypes : isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length,
          support = lodash.support;

      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object) || isString(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          proto = (isFunction(Ctor) && Ctor.prototype) || objectProto,
          isProto = proto === object,
          result = Array(length),
          skipIndexes = length > 0,
          skipErrorProps = support.enumErrorProps && (object === errorProto || object instanceof Error),
          skipProto = support.enumPrototypes && isFunction(object);

      while (++index < length) {
        result[index] = (index + '');
      }
      // lodash skips the `constructor` property when it infers it's iterating
      // over a `prototype` object because IE < 9 can't set the `[[Enumerable]]`
      // attribute of an existing property and the `constructor` property of a
      // prototype defaults to non-enumerable.
      for (var key in object) {
        if (!(skipProto && key == 'prototype') &&
            !(skipErrorProps && (key == 'message' || key == 'name')) &&
            !(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      if (support.nonEnumShadows && object !== objectProto) {
        var tag = object === stringProto ? stringTag : (object === errorProto ? errorTag : objToString.call(object)),
            nonEnums = nonEnumProps[tag] || nonEnumProps[objectTag];

        if (tag == objectTag) {
          proto = objectProto;
        }
        length = shadowProps.length;
        while (length--) {
          key = shadowProps[length];
          var nonEnum = nonEnums[key];
          if (!(isProto && nonEnum) &&
              (nonEnum ? hasOwnProperty.call(object, key) : object[key] !== proto[key])) {
            result.push(key);
          }
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it's invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it's invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : toObject(object)[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : toObject(object)[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it's created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it's set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), (path + ''));
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it's
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it's invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it's invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var protoFunc = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          fixObjects = !support.spliceObjects && /^(?:pop|shift|splice)$/.test(methodName),
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      // Avoid array-like object bugs with `Array#shift` and `Array#splice` in
      // IE < 9, Firefox < 10, and RingoJS.
      var func = !fixObjects ? protoFunc : function() {
        var result = protoFunc.apply(this, arguments);
        if (this.length === 0) {
          delete this[0];
        }
        return result;
      };

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define('lodash-compat',[],function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

define('ConfigStrings',['lodash-compat'], function (_) {

	return {
		ekycMyInfoLogin: {
			imagePath: {
				src: '/content/dam/catalogs/singpass_logo_fullcolours.png',
				alt: 'Singpass Image'
			},
			heading: {
				guestCheckout: 'Fill form instantly with Singpass',
				fulfillment: 'Retrieve your personal details securely via Singpass.'
			},
			newTag: 'NEW',
			text: {
				fulfillment: 'Skip having to upload your supporting documents.',
				guestCheckout: 'Retrieve your personal details securely and skip ' +
				'having to upload your supporting documents.'
			},
			disclaimer: 'By proceeding, you will be leaving our website to access ' +
						'Government of Singapore\'s website. ' +
						'Please ensure you understand the terms and conditions of ' +
						'Government of Singapore\'s website before continuing.',
			disclaimerLink: 'Learn more about Singpass',
			dataMissMatchModal: {
				popupheader: 'Oops!',
				description: 'Retrieved NRIC doesn\'t match entered NRIC.',
				textleft: 'MobileT&Cs',
				textright: 'ok',
				linkright: '/content/singtel/en/personal/products-services/login-guest-checkout.html'
			},
			manualFormDisclaimer: 'Upload of supporting documents required'
		},
		RRP: {
			maxCartValue: 10000,
			cartLimitExceeded: 'Maximum cart limit of $10000, exceeded.',
			productSpecContainmentID: '17987931',
			replaceIpp: {
				header: 'Replace Ipp Item',
				description: 'You already have an Ipp item, do you want to replace it?',
				replaceItemBtn: 'Replace IPP Item',
				keepExistingBtn: 'Cancel'
			},
			error: {
				genericErrorHeader: 'Oops!',
				genericErrorMessage: 'An error occurred. Please try again later or call 1688.',
				sessionExpiredHeader: 'Your Session has expired',
				sessionExpiredMessage: 'Due to inactivity, the items in your Shopping Cart have been removed.',
				isWorryFreeLoginHeader: 'Starting a new order without a plan?',
				isWorryFreeLoginMessage: 'This will clear your current progress and Shopping Cart.',
				slotsNotFoundHeader: 'Slots not available',
				slotsNotFoundMessage: 'No slots available',
				maxQuantityReachedHeader: 'Your Shopping Cart is full',
				maxQuantityReachedMessage1: 'The Maximum limit per order has been reached.',
				maxQuantityReachedMessage2: 'To choose another product, please remove an item from your cart first.',
				couponAlreadyApplied: 'Please remove existing coupon and try again',
				CouponInvalidCoupon: 'Please remove existing coupon and try again',
				couponError: 'Sorry, we’re unable to apply your coupon at this moment.' +
				'Please try again later.\r\n' +
				'Alternatively, you may call 1609 for assistance.',
				invalidCodeMessage: 'Sorry, the promo code you applied is invalid/expired.',
				underagedError: 'Customer must be 21 years of age or older to be eligible.',
				ippIneligiblePlan: 'Not eligible for instalment plan'
			},
			success: {
				genericSuccessHeader: 'Congtratulations',
				mtposPartiallyReservation: 'Not all devices are reserved. Please check shoppingCart.',
				promoCodeSuccessHeader: 'Promo code has been sent',
				promoCodeSuccessMessage: 'Promo code has been successfully sent to your email' +
					' address. Please retrieve it from your inbox.',
				orderCancelledHeader: 'Order Cancelled',
				orderCancelled: 'Your order has been cancelled.'
			},
			pages: {
				catlogUrl: '/content/singtel/en/personal/products-services/mobile/accessories.html',
				shoppingCartUrl: '/content/singtel/en/personal/products-services/mobile/' +
					'accessories/shopping-cart.html',
				ippShoppingCartUrl: '/content/singtel/en/personal/products-services/mobile/' +
				'accessories/rrp-ipp-shopping-cart.html',
				cutsomerRegistrationUrl: '/content/singtel/en/personal/products-services/mobile/' +
					'accessories/customer-reg.html',
				fulfillmentUrl: '/content/singtel/en/personal/products-services/mobile/' +
					'accessories/fulfillment.html',
				orderSummaryUrl: '/content/singtel/en/personal/products-services/mobile/' +
					'accessories/order-summary.html',
				orderConfirmationUrl: '/content/singtel/en/personal/products-services/mobile/' +
					'accessories/order-confirmation.html',
				emptyCartUrl: '/content/singtel/en/personal/products-services/mobile/' +
					'accessories/empty-shopping-cart.html',
				serviceSelectionUrl: '/content/singtel/en/personal/products-services/mobile/' +
					'accessories/rrp-select-mobile-line-for-ipp.html',
				rrpOrderConfirmation: '/content/singtel/en/personal/products-services/' +
					'rrp/rrp-order-confirmation'
			},
			paymentInfoPending: {
				nextSections: [
					{
						'message': 'You will receive an update on your order status shortly.' +
									' In the meantime, please do not submit another order'
					}
				]
			},
			itemAllowedForPOPStationEnabled: 2
		},
		redMemberShip: {
			modalHeader: 'Red Membership',
			planHeader: 'Plan',
			tenureHeader: 'Membership period',
			costHeader: 'Total cost',
			proceed: 'Proceed',
			rightItems: [{
				label: 'Membership Fee',
				class: 'no wrap',
				tooltip: 'Membership fee to be paid annually.'
			}]
		},
		rrpCropTextConfig: {
			desktopChars: 45,
			tabletChars: 275,
			mobileChars: 140,
			catalogMobileChars: 40
		},
		unallowNames: [
			'unallowName'
		],
		addList: [
			{
				value: 'Street',
				text: 'Street'
			},
			{
				value: 'International',
				text: 'International'
			},
			{
				value: 'Delivery',
				text: 'Delivery'
			}
		],
		tvPackTagsConfig: {
			starterPack: 'nxt:Category/All Packs/Starter Pack',
			trioPack: 'nxt:Category/All Packs/Trio Pack',
			valuePack: 'nxt:Category/All Packs/Value Pack',
			ultimatePack: 'nxt:Category/All Packs/Variety Pack'
		},
		consent: {
			liner: 'I have acknowledged and hereby consent to the collection and disclosure of my personal' +
			' information by Singtel’s data protection policy.'
		},
		manageCustomerInfoAddress: {
			'notePreAnchor': 'Note: If your address is not available please',
			'notePostAnchor': 'to update your address.'
		},
		autoComplete: {
			'noResultMsg': 'Your entry is not a Zone 1 country. Please re-enter country name'
		},
		brandsList: [
			{
				name: 'Apple',
				friendlyName: 'Apple'
			},
			{
				name: 'Bberry',
				friendlyName: 'Blackberry'
			},
			{
				name: 'HTC',
				friendlyName: 'HTC'
			},
			{
				name: 'Huawei',
				friendlyName: 'Huawei'
			},
			{
				name: 'LG',
				friendlyName: 'LG'
			},
			{
				name: 'Motorola',
				friendlyName: 'Motorola'
			},
			{
				name: 'Nokia',
				friendlyName: 'Nokia'
			},
			{
				name: 'Samsung',
				friendlyName: 'Samsung'
			},
			{
				name: 'Sony',
				friendlyName: 'Sony'
			}
		],
		booleanSelectList: [
			{
				value: true,
				text: 'True'
			},
			{
				value: false,
				text: 'False'
			}
		],
		mediaBreakpoints: {
			small: 492,
			medium: 852,
			large: 1020,
			xlarge: 1200
		},
		tvPacksHeader: 'TV Packs',
		paymentMethods: {
			CA: 'Cash',
			CB: 'Bank Credit Advice',
			CC: 'Credit Card',
			CE: 'eNETS debit',
			CH: 'Cheque',
			CN: 'NETS',
			CP: 'Internet/Phonebank',
			CS: 'CashCard',
			CV: 'Voucher',
			DD: 'Direct Debit',
			DH: 'Singtel Dash',
			DSH: 'Singtel Dash',
			AP: 'ATM',
			MP: 'Migration Payment',
			MD: 'Migration Deposit',
			BT: 'Transfer Between Account',
			BC: 'Credit Balance',
			RD: 'Refund of Deposit',
			BP: 'Negative Balance Payment',
			HPB: 'HPB eVoucher',
			yuu: 'yuu eVoucher'
		},
		paymentTypes: {
			B: 'Bank',
			C: 'Credit Card',
			P: 'Portal',
			A: 'Agent/Kiosk',
			O: 'Online',
			M: 'Online',
			STSHOP: 'Singtel Shop',
			SERS: 'Singtel Retail',
			DST: 'Digital Sales Telesales',
			RIM: 'Singtel Shop'
		},
		paymentHistoryItemLabels: {
			byDirectDebit: ' by direct debit ',
			end: ' ending with ',
			usingCreditCard: ' using Credit Card ',
			usingCash: ' using Cash ',
			usingCheque: ' using Cheque ',
			usingDirectDebit: ' using Direct Debit ',
			usingBankAccount: ' using Bank Account number '
		},
		paymentHistory: {
			lables: {
				transactionId: 'Transaction Id'
			}
		},
		prepaidMobileBalance: {
			dailyRechargeMessage: 'Your service will expire if not recharged before ',
			dailyRolloverMessage: ' so you can roll over unused MyCredit.',
			nonDailyRolloverMessage: ' We will rollover your unused MyCredit if you recharge on or before this date. ',
			daysLeftToRecharge: 'days left until the next recharge date ',
			rechargeBeforeText: ' Recharge before '
		},
		constants: {
			ADDON_FIELD: 'catalogTechDescriptionX8',
			ADDON_VALUE: 'AddOn',
			BROADBAND_OFFSET: 0,
			MOBILE_OFFSET: 1,
			CATALOGITEMS: {
				TV_FILTER_COMPONENT: ['14446806'],
				ALA_CARTE_MAIN_COMPONENT: '8633042',
				MOBILE_CONTENT_COMPONENT: '10140891',
				REPLACE_SIM: 8026552,
				CHANGE_MOBILE_NUMBER: 8026552,
				SUSPEND_SERVICE: 8026552,
				RESUME_SERVICE: 8026552,
				CHANGE_PLAN: 8026582,
				SAMSUNG_SC_BO: '14426026',
				MOBILE_SWP_BO: '14482',
				APPLE_CARE_BO: '12357321-0',
				APPLE_CARE_CO: '8472782-0',
				DEVICE_CARE_CO: '10612',
				RC_CHAR: '10048781',
				TV_MAIN_PACK_COMPONENT: '8635012'
			},
			PLANSELECTOR: {
				RECONTRACT: 'RECONTRACT',
				PREPAY_TO_POSTPAY: 'PREPAY_TO_POSTPAY',
				CONTRACT: 'CONTRACT'
			},
			SERVICESELECTOR: {
				MOBILE: 'Mobile',
				MOBILE_BROADBAND: 'Mobile Broadband',
				PREPAID: 'Prepaid',
				BROADBAND: 'Broadband',
				TELEPHONE: 'Telephone',
				METER_MESSAGE: 'message',
				SHARED_SERVICE_TYPES: {
					PRINCIPAL: 'principal',
					PRIMARY: 'primary',
					OTHER: 'other'
				},
				POSTPAID: 'PostpaidMobile',
				INTLROAMING: 'internationalRoaming',
				PLANINFO: 'planInfo',
				PURCHASE_DATA_BLOCKS_URL: '/portal/site/customercentre/template.BINARYPORTLET/menuitem.f39ec65e471' +
				'e36c6aaaee655f1c647a0/resource.process/?javax.portlet.tpst=dc2b9bcd4f4cd42d10324b96f1c647a0&javax.' +
				'portlet.rst_dc2b9bcd4f4cd42d10324b96f1c647a0=serviceId%3D[SERVICE_ID]&javax.portlet.rid_dc2b9bcd4f4' +
				'cd42d10324b96f1c647a0=purchaseDataBlocks&javax.portlet.rcl_dc2b9bcd4f4cd42d10324b96f1c647a0=' +
				'cacheLevelPage&javax.portlet.begCacheTok=com.vignette.cachetoken&javax.portlet.endCacheTok=com.' +
				'vignette.cachetoken&vgnextoid=962f922698751410VgnVCM1000001760740aRCRD',
				PORTLET_BASE_URL: '/portal/site/customercentre/template.BINARYPORTLET/menuitem.f39ec65e471e36c6aaa' +
				'ee655f1c647a0/resource.process/?',
				PRINT_USAGE_DETAILS_QUERY_KEY: 'javax.portlet.rst_dc2b9bcd4f4cd42d10324b96f1c647a0'
			},
			USAGESUMMARY: {
				POSTPAID_MOBILE: 'PostpaidMobile',
				PREPAID_MOBILE: 'PrepaidMobile',
				LEGACY_PLANTYPE: 'LEGACY',
				DATATYPE_POSTPAID_LEGACY: 'usageTablePostpaidLegacy',
				IIT_MARKUP_URL: '/portal/site/customercentre/template.BINARYPORTLET/menuitem.f39ec65e471e36c6aaae' +
				'e655f1c647a0/resource.process/?javax.portlet.tpst=dc2b9bcd4f4cd42d10324b96f1c647a0&javax.portlet.' +
				'rst_dc2b9bcd4f4cd42d10324b96f1c647a0=serviceId%3D[SERVICE_ID]&javax.portlet.rid_dc2b9bcd4f4cd42d1032' +
				'4b96f1c647a0=industryITUpgradeJson&javax.portlet.rcl_dc2b9bcd4f4cd42d10324b96f1c647a0=cacheLevelPage' +
				'&javax.portlet.begCacheTok=com.vignette.cachetoken&javax.portlet.endCacheTok=com.vignette.cachetoken' +
				'&vgnextoid=962f922698751410VgnVCM1000001760740aRCRD'
			},
			BCC_NINE_DOLLAR_PLAN: '$9 OPTUS PLAN',
			BYTECONVERSIONMATRIX: {
				FIXED: {
					gb: 1048576000,
					mb: 1048576,
					kb: 1024
				},
				DEFAULT: {
					gb: 1073741824,
					mb: 1048576,
					kb: 1024
				}
			},
			TIER_TIMELESS: 'TIMELESS',
			NO_ACTIVE_SERVICE: {
				LINK_ACCOUNTS: 'https://www.optus.com.au/customercentre/myaccount/linkmyservice',
				CONTACT: 'http://www.optus.com.au/shop/support/answer/how-to-contact-optus?requestType=NormalRequest&' +
				'id=1371&typeId=5'
			},
			COMMUNITY_FEED: {
				TYPE: {
					SIMPLE: 'simple',
					EXPANDED: 'expanded',
					INTERACTIVE: 'interactive'
				}
			},
			RESPONSE_STATUS: {
				SUCCESS: 'success',
				ERROR: 'error'
			},
			PG_MESSAGE: {
				'1PAY_01001': 'Maximum tries exceeded, please try again.',
				'1PAY_01002': 'Transaction cancelled.',
				'1PAY_01003': 'Session expired.',
				'1PAY_01004': 'The system is unable to process your payment at the moment. Please try again later.',
				'1PAY_05000': 'Your payment transaction is unsuccessful.' +
				' Please verify the credit card information entered or use another credit card for our payment.',
				'1PAY_06000': 'The system cannot process your topup at the' +
				' moment, we will follow-up and inform you within 2 days. Please don’t retry.',
				'1PAY_07000': 'Your payment transaction is unsuccessful.' +
				' Please verify the mCash account used for the payment.',
				'1PAY_08000': 'Your payment transaction is unsuccessful.' +
				' Please verify the debit account of eNETS used for the payment.',
				'1PAY_10001': 'Invalid order parameters',
				'1PAY_10002': 'Duplicated transaction',
				'1PAY_10003': 'Invalid transaction id',
				'1PAY_10004': 'Transaction time out',
				'1PAY_11001': 'Invalid user/password',
				'1PAY_11002': 'Unauthorized sales channel',
				'1PAY_12001': 'Invalid customer ID',
				'1PAY_12002': 'Service already subscribed',
				'1PAY_12006': 'Customer subscription is pending,',
				'1PAY_12007': 'Customer credit limit exceeded',
				'1PAY_13001': 'Invalid MER account code',
				'1PAY_13002': 'Transaction older than the specified',
				'1PAY_13003': 'Invalid product code',
				'1PAY_13004': 'Invalid order amount',
				'1PAY_14001': 'General application permanent error',
				'1PAY_10005': 'Invalid Order Status',
				'GIRO_10001': 'GIRO payment failed'
			},
			TITLE: {
				EASY_MOBILE: 'Easy Mobile'
			}
		},
		'serviceConfigOptus': {
			'WS': {
				'name': 'Optus Mobile',
				'icon': 'mobile-service',
				'userNameProp': 'MSISDN'
			},
			'IN': {
				'name': 'Optus Broadband',
				'icon': 'broadband-service',
				'userNameProp': 'Optus ID'
			},
			'TV': {
				'name': 'Optus TV',
				'icon': 'tv-service',
				'userNameProp': 'No.'
			},
			'WL': {
				'name': 'Optus Line',
				'icon': 'phone-service',
				'userNameProp': 'Telephone No'
			},
			'BN': {
				'name': 'Optus Bundle',
				'icon': 'circles-line',
				'userNameProp': 'Account No'
			},
			'Mobile': {
				'name': 'Optus Mobile',
				'icon': 'mobile-service',
				'userNameProp': 'MSISDN'
			},
			'M': {
				'name': 'Optus Mobile',
				'icon': 'mobile-service',
				'userNameProp': 'MSISDN'
			},
			'MOB': {
				'name': 'Optus Mobile',
				'icon': 'mobile-service',
				'userNameProp': 'MSISDN'
			},
			'MB': {
				'name': 'Optus Mobile Broadbande',
				'icon': 'mobile-broadband',
				'userNameProp': 'MSISDN'
			},
			'SIM': {
				'name': 'Optus Sim',
				'icon': 'sim-card-service',
				'userNameProp': 'MSISDN'
			}
		},
		'serviceConfig': {
			'WS': {
				'name': 'Mobile',
				'icon': 'mobile-line',
				'userNameProp': 'MSISDN'
			},
			'FBB': {
				'name': 'Fibre Broadband',
				'icon': 'computer-line',
				'userNameProp': 'Singnet ID'
			},
			'BB': {
				'name': 'Fibre Broadband',
				'icon': 'broadband-line',
				'userNameProp': 'Singnet ID'
			},
			'TV': {
				'name': 'Singtel TV',
				'icon': 'tv-line',
				'userNameProp': 'No.'
			},
			'FV': {
				'name': 'Home Telephone',
				'icon': 'landline-line',
				'userNameProp': 'Telephone No'
			},
			'BN': {
				'name': 'Fibre Entertainment Bundle',
				'icon': 'circles-line',
				'userNameProp': 'Account No'
			},
			'GLP': {
				'name': '',
				'icon': 'circles-line',
				'userNameProp': 'Bundle ID'
			},
			'BP': {
				'name': 'Fibre Entertainment Bundle Plus',
				'icon': 'broadband-line',
				'userNameProp': 'Account No'
			},
			'MBB': {
				'name': 'Mobile',
				'icon': 'mobile-line',
				'userNameProp': 'MSISDN'
			},
			'MOB': {
				'name': 'Mobile',
				'icon': 'mobile-line',
				'userNameProp': 'MSISDN'
			},
			'ON': {
				'name': 'Mobile',
				'icon': 'mobile-line',
				'userNameProp': 'MSISDN'
			},
			'EASY_MOB': {
				'name': 'Easy Mobile',
				'icon': 'mobile-line',
				'userNameProp': 'MSISDN'
			},
			'Mobile': {
				'name': 'Mobile',
				'icon': 'mobile-line',
				'userNameProp': 'MSISDN'
			},
			'FEB': {
				'name': 'Fibre Entertainment Bundle',
				'icon': 'circles-line',
				'userNameProp': 'Account No'
			},
			'FEBP': {
				'name': 'Fibre Entertainment Bundle Plus',
				'icon': 'circles-line',
				'userNameProp': 'Account No'
			},
			'FHB': {
				'name': 'Fibre Home Bundle',
				'icon': 'circles-line',
				'userNameProp': 'Singnet ID'
			},
			'MIO VOICE': {
				'name': 'Mio Voice',
				'icon': 'landline-line',
				'userNameProp': 'Telephone No'
			},
			'Mio Voice': {
				'name': 'Mio Voice',
				'icon': 'landline-line',
				'userNameProp': 'Telephone No'
			},
			'SingNet': {
				'name': 'Fibre Broadband',
				'icon': 'broadband-line',
				'userNameProp': 'Singnet ID'
			},
			'Singtel TV': {
				'name': 'Singtel TV',
				'icon': 'tv-line',
				'userNameProp': 'No.'
			},
			'Telephone': {
				'name': 'Home Digital Line',
				'icon': 'landline-line',
				'userNameProp': 'Telephone No'
			},
			'OTHER': {
				'name': 'Other Charges & Credit',
				'icon': 'mobile-line',
				'userNameProp': ''
			},
			'': {
				'name': 'default-icon',
				'icon': 'circles-line',
				'userNameProp': ''
			},
			'WL': {
				'name': 'Energy',
				'icon': 'circle-energy',
				'userNameProp': 'MSISDN'
			},
			'Singtel Energy': {
				'name': 'Energy',
				'icon': 'circle-energy',
				'userNameProp': 'MSSL'
			},
			'ENRG': {
				'name': 'Energy',
				'icon': 'energy-line',
				'userNameProp': 'MSISDN'
			},
			'RED': {
				'name': 'Red Membership',
				'icon': 'red-member',
				'userNameProp': '',
				'lineofBusiness': 'RED'
			}
		},
		'spacingConfig': {
			'TOP': {
				'small': 'v-small-top',
				'medium': 'v-medium-top',
				'large': 'v-large-top'
			},
			'BOTTOM': {
				'small': 'v-small-bottom',
				'medium': 'v-medium-bottom',
				'large': 'v-large-bottom'
			},
			'LEFT': {
				'small': 'v-small-left',
				'medium': 'v-medium-left',
				'large': 'v-large-left'
			},
			'RIGHT': {
				'small': 'v-small-right',
				'medium': 'v-medium-right',
				'large': 'v-large-right'
			}
		},
		ebillDeregisterValues: {
			ebillDeregisterReasons: [
				{
					value: 'INeedPaperBillForClaimReimbursement',
					dispayText: 'I need a paper bill for claims reinbursements.'
				},
				{
					value: 'INeedPaperBillBecauseIAmNotTheOneMakingPayment',
					dispayText: 'I need a paper bill as I am not the one making payments for the subscribed service(s).'
				},
				{
					value: 'ITendToForgetToMakePaymentWithoutPaperBill',
					dispayText: 'I tend to forget to pay the bills without a paper bill.'
				},
				{
					value: 'ISimplyPreferPaperBill',
					dispayText: 'I prefer receiving a paper bill'
				},
				{
					value: 'ITendToForgetLoginIdPassword',
					dispayText: 'I tend to forget my login credentials (OnePass and password).'
				},
				{
					value: 'IFrequentlyEncounterLoginIssues',
					dispayText: 'I frequently encounter login issues.'
				},
				{
					value: 'ISignedUpEbillByMistake',
					dispayText: 'I signed up for eBill by mistake.'
				}
			],
			ebillHeader: 'With eBill, you\'ll receive a detailed breakdown of your usage and be able to pay' +
			' for your bills online via My Account and My Singtel app. Are you sure that you\'d like ' +
			'to unsubscribe from eBill?',
			reasonHeader: 'Reason(s) for opting out:',
			deregistrationHeader: 'You are unsubscribed',
			ebillActivation: {
				partOne: 'Please update your email address in your ',
				partTwo: ' contact details to confirm your eBill activation.'
			},
			eBillRegisteredModal: {
				partOne: 'Your electronic bill ready notification will be sent to ',
				partTwo: '. If this is incorrect, please change this on your',
				partThree: ' page.'
			},
			eBillRegisterConfirmModal: {
				registrationReasonOne: 'All hard copy paper bills will be stopped upon eBill activation.',
				registrationReasonOneOne: 'Each billing account will receive 1 email notification ' +
				'after activating eBill.',
				registrationReasonTwo: 'All billing account(s) under my NRIC will be automatically set ' +
				'to receive electronic bills.',
				partOne: 'Your electronic bill ready notification will be sent to ',
				partTwo: '. If this is incorrect, please change this on your ',
				partThree: ' page.'
			},
			invalidEmailErrorTitle: 'Invalid email address'
		},
		changeBillPreference: {
			waiverCharge: 1.07,
			waivedPaperBillDeregisteredConfirmationModal: {
				header: 'De-register for hard copy bill',
				subHeader: 'You are currently enjoying a waiver of $1.07 for your free hardcopy bill.',
				confirmationMsg: 'By de-registering now, charges will be incurred when you register for' +
				' hardcopy bills in the future.',
				successMsg: 'You have successfully de-registered for your hard copy bill!'
			},
			waivedMobileBillRegisterConfirmationModal: {
				header: 'Register for mobile detailed paper bills',
				subHeader: 'You are requesting to receive mobile detailed paper bills along with your eBill.',
				confirmationMsg: 'You\'re currently enjoying a waiver of $1.07 for your hardcopy paper bill ' +
				'(without details). By receiving mobile detailed paper bill for this number, your waiver will ' +
				'be turned off and you will be charged for both the paper bill and the mobile detail bill.'
			},
			waivedMobileBillRegisteredModal: {
				subHeader: 'You have successfully registered for mobile detailed bill for your number.',
				confirmationMsg: 'By receiving mobile detailed paper bill for this number, your waiver will be ' +
				'turned off and you will be charged for both the paper bill and the mobile detail bill.'
			},
			prsDeregisteredModal: {
				header: 'Activate Details of Current Charges Bill'
			},
			prsRegisteredModal: {
				header: 'Deactivate Details of Current Charges'
			}
		},
		relocateServicesTimeSlots: [
			'9:00 AM - 1:00 PM',
			'2:00 PM - 5:00 PM'
		],
		appointmentStartsAfterDays: 8,
		appointmentEndsAfterDays: 1000,
		alertMessages: {
			suspensionMessage: 'This service is under suspension from ',
			futureSuspensionMessage: 'This service will be under suspension from ',
			reconMessage: 'This line is eligible for recontract'
		},
		recontractLabels: {
			broadbandAfterDateMsg: 'You can upgrade your plan for free after',
			broadbandRecontractDateMsg: 'Your recontract Date is ',
			recontractBtn: 'Recontract your Plan',
			tv: 'You can upgrade your plan for free after',
			tvReconEligibilityDateHeader: 'Recontract eligibility date'
		},
		date: {
			days: [
				{ value: '01', title: '01'},
				{ value: '02', title: '02'},
				{ value: '03', title: '03'},
				{ value: '04', title: '04'},
				{ value: '05', title: '05'},
				{ value: '06', title: '06'},
				{ value: '07', title: '07'},
				{ value: '08', title: '08'},
				{ value: '09', title: '09'},
				{ value: '10', title: '10'},
				{ value: '11', title: '11'},
				{ value: '12', title: '12'},
				{ value: '13', title: '13'},
				{ value: '14', title: '14'},
				{ value: '15', title: '15'},
				{ value: '16', title: '16'},
				{ value: '17', title: '17'},
				{ value: '18', title: '18'},
				{ value: '19', title: '19'},
				{ value: '20', title: '20'},
				{ value: '21', title: '21'},
				{ value: '22', title: '22'},
				{ value: '23', title: '23'},
				{ value: '24', title: '24'},
				{ value: '25', title: '25'},
				{ value: '26', title: '26'},
				{ value: '27', title: '27'},
				{ value: '28', title: '28'},
				{ value: '29', title: '29'},
				{ value: '30', title: '30'},
				{ value: '31', title: '31'}
			],
			months: [
				{
					value: '01',
					title: 'January'
				},
				{
					value: '02',
					title: 'February'
				},
				{
					value: '03',
					title: 'March'
				},
				{
					value: '04',
					title: 'April'
				},
				{
					value: '05',
					title: 'May'
				},
				{
					value: '06',
					title: 'June'
				},
				{
					value: '07',
					title: 'July'
				},
				{
					value: '08',
					title: 'August'
				},
				{
					value: '09',
					title: 'September'
				},
				{
					value: '10',
					title: 'October'
				},
				{
					value: '11',
					title: 'November'
				},
				{
					value: '12',
					title: 'December'
				}
			],
			years: [
				{
					value: 2017,
					title: '2017'
				},
				{
					value: 2016,
					title: '2016'
				},
				{
					value: 2015,
					title: '2015'
				}
			],
			months2: [
				{
					value: 'Month',
					title: 'Month'
				},
				{
					value: '01',
					title: '1'
				},
				{
					value: '02',
					title: '2'
				},
				{
					value: '03',
					title: '3'
				},
				{
					value: '04',
					title: '4'
				},
				{
					value: '05',
					title: '5'
				},
				{
					value: '06',
					title: '6'
				},
				{
					value: '07',
					title: '7'
				},
				{
					value: '08',
					title: '8'
				},
				{
					value: '09',
					title: '9'
				},
				{
					value: '10',
					title: '10'
				},
				{
					value: '11',
					title: '11'
				},
				{
					value: '12',
					title: '12'
				}
			],
			months3: [
				{
					value: 'January',
					title: 'Jan'
				},
				{
					value: 'February',
					title: 'Feb'
				},
				{
					value: 'March',
					title: 'Mar'
				},
				{
					value: 'April',
					title: 'Apr'
				},
				{
					value: 'May',
					title: 'May'
				},
				{
					value: 'June',
					title: 'Jun'
				},
				{
					value: 'July',
					title: 'Jul'
				},
				{
					value: 'August',
					title: 'Aug'
				},
				{
					value: 'September',
					title: 'Sep'
				},
				{
					value: 'October',
					title: 'Oct'
				},
				{
					value: 'November',
					title: 'Nov'
				},
				{
					value: 'December',
					title: 'Dec'
				}
			]
		},
		serviceTypeMapping: {
			MOBILE: ['PostpaidMobile', 'Shared', 'Unknown', 'Wholesale', 'Postpaid'],
			MOBILE_BROADBAND: ['OWBPostpaid', 'OWBPostpaidNonKitKat'],
			PREPAID: ['OWBPrepaid', 'Prepaid', 'PrepaidMobile'],
			BROADBAND: ['OWT', 'OWF', 'DSLD', 'FBB', 'WBB', 'Cable', 'OPEN1', 'OPEN2'],
			TELEPHONE: ['LAD', 'FTEL', 'OfficeLAD']
		},
		validationPassowrdRequired: true,
		icons: {
			data: 'icon-internet',
			voice: 'icon-contact-us',
			message: 'icon-webmail',
			international: 'icon-contact-us',
			idd: 'icon-contact-us',
			shareddata: 'ico-internet',
			mapping: {
				planInfo: 'icon-services-other',
				usageSummary: 'icon-usage',
				usageDetails: 'icon-summary',
				internationalRoaming: 'icon-international',
				settingsLink: 'icon-settings',
				optionsExtras: 'ico-tools-2'
			},
			MOBILE: 'mobile',
			MOBILE_BROADBAND: 'mobile-broadband',
			PREPAID: 'prepaid',
			BROADBAND: 'internet',
			TELEPHONE: ''
		},
		verifyToken: 'Token verification in progress',
		title: {
			small: {
				data: 'Data',
				international: 'Int\'l min.',
				idd: 'Int\'l min.'
			},
			large: {
				data: 'Data',
				voice: 'Talk',
				international: 'International Minutes',
				idd: 'International Minutes',
				message: 'Text',
				plancorevalue: 'Plan Core Value',
				excessusage: 'Excess Usage',
				shareddata: 'Shared Data',
				dataused: 'Data Used'
			}
		},
		changeAddress: {
			whatNextLabel: 'What\'s next?',
			description: 'An email notifiying the new billing address will be sent to your Singtel contact email',
			heading: 'Your request processed successfully.'
		},

		tableHeaders: {
			data: {
				cell: [
					{label: 'Level'},
					{label: 'Used'},
					{label: 'Charges <span class="sublabel">(excl. GST)</span>'}
				]
			},
			voice: {
				cell: [
					{label: 'Level'},
					{label: 'Used'},
					{label: 'Charges <span class="sublabel">(excl. GST)</span>'}
				]
			},
			intlRoaming: {
				cell: [
					{label: 'Usage Type'},
					{label: 'Used'},
					{label: 'Charges <span class="sublabel">(excl. GST)</span>'}
				]
			},
			owbPostpaid: {
				cell: [
					{label: 'Usage Type'},
					{label: 'Quantity'}
				]
			},
			charges: {
				excludedusage: {
					cell: [
						{label: 'Usage Type'},
						{label: 'Used'},
						{label: 'Excluded Usage Charges <span class="sublabel">(excl. GST)</span>'}
					]
				},
				excessusage: {
					cell: [
						{label: 'Usage Type'},
						{label: 'Used'},
						{label: 'Excess Usage Charges <span class="sublabel">(excl. GST)</span>'}
					]
				}
			},
			prepaidTwoDollarDays: {
				cell: [
					{label: 'Usage Type'},
					{label: 'Balance'},
					{label: 'Expiry'}
				]
			}
		},

		usageCategory: {
			EXCLUDED: 'excluded usage'
		},

		pageIds: {
			dashboard: 'home:my-account:my-dashboard',
			usageSummary: 'customer-center:my-account:usage:usage'
		},

		scheduleChangeAddress: {
			message: 'Message one',
			information: 'Message Two'
		},
		singtelHeaderCheckoutText: 'Checkout',
		singtelHeaderVerisignImgPath: '/etc/designs/springd/clientlibs/osg/assets/images/header/verisign.png',
		singtelHeaderVerisignImgAlt: 'verisign',
		paybillDetails: {
			payMyBillsHeader: 'Pay My Bills',
			account: 'Account',
			bank: 'Bank',
			amount: 'Amount',
			total: 'TOTAL',
			due: 'DUE',
			next: 'Next',
			choosePayment: 'I would like to pay via',
			giroOnDemand: 'Giro-On-Demand',
			accountNumber: 'Account Number',
			debitCreditCard: 'Debit/Credit Card',
			online: 'Online',
			eNets: 'eNETS Debit',
			eNetsDesc: '',
			mCash: 'mCash',
			mCashDesc: 'Pay contactless with mCash securely',
			giro: 'GIRO',
			giroSuccessful: 'Your payment received Successfully.',
			giroFailed: 'Your payment not Received.',
			payWithCard: '',
			payThirdPartyHeader: 'Pay for Other account',
			payBillHeader: 'Your outstanding invoices are listed below . You can specify the amount to ' +
			'pay - full payment, partial payment and payment in credit are all accepted. ' +
			'',
			payThirdPartyBillHeader: 'You can pay bills for 3rd party bills by specifing account' +
			' number and the amount.',
			payThirdPartyBillMsg: '',
			message: 'Message one',
			information: 'Message Two',
			details: 'Message Three',
			notes: '',
			accountErrorMsg: 'only Numeric values allowed',
			amountErrorMsg: 'Enter valid values',
			accountId3rdParty: {
				required: 'Account Id can not be empty.',
				maxlength: 'Account Id must be 9 digits.'
			},
			amount3rdParty: {
				required: 'Amount can not be empty.',
				floating: 'Enter valid value.'
			},
			validateAccountFailErrorMsg: 'Oops! An error has occurred. In the meantime, please use other ' +
			'payment channels such as AXS or SAM machines or internet banking',
			maxPaybleAmount: 1000,
			MESSAGE_LEVEL: {
				BLOCK: 'Block',
				WARN: 'Warn'
			},
			amountValidation: {
				overMaxPaybleAmount: 'To protect you from unintentional overpayment, we advise that your ' +
				'payment amount for account {ACCOUNT_NO} be lowered to maximum {AMOUNT}.',
				minSettlementAmount: 'You are about to make payment that exceeds your minimum ' +
				'settlement amount of {AMOUNT} for account {ACCOUNT_NO}.',
				amountErrorHeader: 'Attention!',
				warningErrorHeader: 'Important!',
				overMaxPaybleAmountInputFieldMsg: 'Please enter an amount below $1,000.00'
			}
		},
		widgetLoadingError: {
			errorIcon: {
				'type': 'alert-circular',
				'size': 'xl',
				'color': '#D93A1B'
			},
			errorTitle: 'Section failed to load',
			errorMessage: 'Try reloading the browser window.'
		},
		usageAlerts: {
			errorMessage: {
				eventDetailsText: 'There is no detail Usage.',
				detailsUsageText: 'There is no Usage for the Service.'
			},
			voice: {
				base_85: 'You have used more than 85% of your base plan\'s minutes.',
				base_100: 'You have exceeded your base plan\'s minutes. There will be additional charges to your ' +
				'next bill.',
				base_next_100: 'You have exceeded your base plan\'s minutes. Extra minutes have been added and ' +
				'there will be additional charges to your next bill.',
				unlimited_100: 'You\'ve exceeded your minutes so we\'ve given you unlimited minutes for standard ' +
				'national voice calls to use for the remainder of this billing month. There will be ' +
				'additional charges to your next bill.',
				additional_levels_85: 'You have used more than 85% of your additional minutes for Voice.',
				additional_levels_100: 'You have exceeded your extra minutes for Voice. Extra minutes have been ' +
				'added and there will be additional charges to your next bill.',
				unlimited: 'Your plan has unlimited minutes for standard national voice to use each billing month.'
			},
			intl: {
				base_50: 'You have used more than 50% of your base plan for International Minutes.',
				base_85: 'You have used more than 85% of your base plan for International Minutes.',
				base_100: 'You have exceeded your base plan for International Minutes. There will be additional ' +
				'charges to your next bill.'
			},
			ciac: {
				base_85: 'You have used more than 85% of your Plan Core Value.',
				base_100: 'You have used more than 100% of your Plan Core Value.'
			},
			data: {
				base_85: 'You have used more than 85% of your base plan for Data.',
				base_100: 'You have exceeded your base plan for Data. There will be additional charges to your ' +
				'next bill.',
				base_next_100: 'You have exceeded your base plan for Data. Extra Data has been added and there ' +
				'will be additional charges to your next bill.',
				additional_levels_85: 'You have used more than 85% of your extra Data.',
				additional_levels_100: '100% of your extra Data has been used.  Extra data has been added and ' +
				'there will be additional charges to your next bill.',
				maximum_tier_85: 'You\'ve used more than 85% of your additional tiers. Once you reach 100% we may ' +
				'need to either limit your use for the rest of the month or continue to apply additional ' +
				'charges. See Optus Mobile Fair Go ™ Policy.',
				maximum_tier_100: 'You\'ve used more than your base and the maximum additional tiers. ' +
				'We may need to either limit your use for the rest of the month or continue to apply additional ' +
				'charges. See Optus Mobile Fair Go ™ Policy.'
			},
			shared: {
				base_85: 'You have used more than 85% of your shared Data.',
				base_100: 'You have exceeded your shared Data. There will be additional charges to your next bill.',
				base_next_100: 'You have exceeded your shared Data. Extra Data will be added and there will be ' +
				'additional charges to your next bill.',
				additional_levels_85: 'You have used more than 85% of your extra shared Data.',
				additional_levels_100: '100% of your extra shared Data has been used.  Extra data has been added ' +
				'and there will be additional charges to your next bill.',
				maximum_tier_85: 'You\'ve used more than 85% of your additional tiers. Once you reach 100% we may ' +
				'need to either limit your use for the rest of the month or continue to apply additional ' +
				'charges. See Optus Mobile Fair Go ™ Policy.',
				maximum_tier_100: 'You\'ve used more than your base and the maximum additional tiers. ' +
				'We may need to either limit your use for the rest of the month or continue to apply additional ' +
				'charges. See Optus Mobile Fair Go ™ Policy.'
			},
			hwbb: {
				maximum_tier_90: 'You have used more than 90% of your Plan Core Value.',
				maximum_tier_100: 'You have exceeded 100% of your monthly data usage allowance. As a result, ' +
				'the speed of your service will be limited until the first day of your next billing cycle.'
			}
		},

		usageAlertActions: {
			openDetails: {
				label: 'Show details',
				openDetails: true
			},
			learnMoreFairGo: {
				label: 'Learn more',
				url: 'http://www.optus.com.au/opfiles/Aboutoptus/Legal/SharedStaticFiles/SharedDocuments/AppS.doc'
			},
			learnMoreDefault: {
				label: 'Learn more',
				url: 'http://www.optus.com.au/shop/support/answer?requestType=NormalRequest&id=1450'
			}
		},

		CBO_DEVICES: {
			SIM: 'sim',
			STICKER: 'sticker',
			WRISTBAND: 'band'
		},

		CBO_DEVICE_DEFAULT_COLOUR: {
			STICKER: 'black',
			WRISTBAND: 'red'
		},

		COLOUR_CODE_MAPPING: [
			{
				key: 'bk', value: 'black'
			},
			{
				key: 'wt', value: 'white'
			},
			{
				key: 'pk', value: 'pink'
			},
			{
				key: 'rd', value: 'red'
			},
			{
				key: 'bl', value: 'blue'
			},
			{
				key: 'teal', value: 'teal'
			},
			{
				key: 'si', value: 'silver'
			}
		],
		prepaidTopUp: {
			error: 'An error occurred. Please try again later or call 1688.',
			heading: 'Oops!'
		},
		entertainment: {
			notEligible : 'Sorry you don’t have any eligible products'
		},
		errors: {
			genericErrorHeader: 'Oops',
			noPopStationsFound: '0 POPStation found near ',
			noPopStationsFoundTryAgain: 'Please try with another postal code.',
			noPaymentHistoryError: 'There is no data to be shown',
			tweakErrorMsg: 'We are sorry Something went wrong, please try later or call 1688 888 8000',
			duplicateNomination: 'Removing Below duplicate nomination entry.',
			removedNominationSuccess: 'Nomination removed successfully',
			removedNominationFailed: 'Nomination removed Failed, Please try again after some time.',
			tweakErrorHeading: 'Our apologies.',
			noBillsError: 'There is no data to be shown',
			maxAttemptsReached: 'You have reached maxinum number of login attempts',
			addressNotFoundError: 'Sorry, this address can\'t be found. Please enter another postal code and try again.',
			numberPortinError: 'Enter a valid Starhub/M1 Postpaid Number or Singtel Prepaid Number associated with you.',
			numberPortinErrorGomo: 'Only StarHub, M1, TPG, Singtel Prepaid and GOMO numbers can be transferred online ' +
			'at this time. Please also ensure that this is the same ID used to sign up for that mobile number.',
			entityExistsError: 'Sorry, this cards is alreday existing. Please try again with different card.',
			genericError: 'Sorry, we\'re unable to proceed with your transaction. Please call 1688 for ' +
			'further assistance.',
			genericError2: 'Sorry, we’re unable to proceed with your order. Please call 1609.',
			genericUpdateError: 'Sorry, we’re unable to proceed with your request. Please try again later or call 1609.',
			printError: 'Sorry, we\'re unable to proceed with your transaction. Please try again ' +
			'later.',
			apiRetrieveError: 'Sorry, we\'re unable to retrieve your information at this moment. Please ' +
			'try again later.',
			nonPrestigeError: 'Redemption is only applicable to Singtel Prestige members.',
			encounteredError: 'Oops, looks like we\'ve encountered an error.',
			ipaUserMessage: 'Sorry, we\'re unable to proceed with your transaction. Please make payment for your ' +
			'monthly instalment payment arrangement to proceed',
			genericErrorHeading : 'Our apologies.',
			genericParticipateHeading: 'Thank you for participating!',
			dataNotPresentError: 'We noticed that you may have skipped some parts of the buy flow. ' +
			'Please start your purchase ',
			dataNotPresentErrorAtConfirmation: 'You are unable to proceed further. To start shopping, please click ',
			login: {
				phone: 'Only account level logins are supported now please register for a My Account login.'
			},
			singtelLogin: {
				invalidLogin: 'You have entered invalid User ID and/or password. Please re-try'
			},
			feedBackError: {
				error: 'An error occurred. Please try again later or call 1688.',
				heading: 'Oops!'
			},
			replaceSim: {
				error: 'An error occurred. Please try again later or call 1688.',
				heading: 'Oops!'
			},
			bookAnAppoitmentError: {
				error: 'An error occurred. Please try again later or call 1688.',
				heading: 'Oops!'
			},
			orderDetails: {
				heading: 'Oops!',
				error: 'An error occurred. Please try again later or call 1688.'
			},
			viewBill: {
				heading: 'Oops!',
				error: 'An error occurred. Please try again later or call 1688.',
				noSubscriptionUsageHeader: 'Oops!',
				noSubscriptionUsageDesc: 'It seems that you don\'t have any mobile subscription with usage charges.'
			},
			accountHeader: {
				nickName: {
					required: 'Please enter a nickname for your account.',
					maxlength: 'Please note that a maximum of 12 characters can be entered.',
					alpha_numeric: 'Your account name can only contain letters and numbers.'
				}
			},
			travelPlan: {
				invalidDate : 'Please select a valid date'
			},
			documentUploadedError: 'Please upload file less than ',
			appointmentError: 'You have exceeded maximum number of appointments..',
			existingAppointmentError: 'You already have an exisiting Appointment',
			manageCustomerInfo: {
				digit: 'Please Enter Digits',
				minlength: 'Please enter a minimum of 4 digits',
				notificationEmail: 'Please add proper email id to set selected notification preferences',
				notificationSMS: 'Please add proper MSN to set selected notification preferences',
				notificationBoth: 'Please add proper values to set selected notification preferences',
				confirmpasswordFailed: 'Please enter correct password to update email'
			},
			changeBillPreference: {
				ebillDeregistrationReason: {
					maxlength: 'Reason for deactivating eBill should only be up to 100 characters long.',
					required: 'Please specify a reason for deactivation of eBill.'
				},
				failureTitle: 'Sorry!'
			},
			changePassword: {
				passwordMinLength: 'Please enter minimum of 6 characters',
				passwordMaxLength: 'Please enter maximum of 50 characters',
				passwordNotMatch: 'Password not match, please enter same password.',
				passwordRequired: 'Password cannot be empty',
				confirmPasswordRequired: 'Confirm password cannot be empty'
			},
			autoCustAddrsValidationRule: {
				'addressAuto': {
					optusAddress: 'Please check if the address you entered is valid',
					required: 'Field is required'
				}
			},
			apartmentValidationRule: {
				'streetNo': {
					digits: 'Please check if the street number you entered is valid',
					required: 'Field is required'
				},
				'streetName': {
					optusAddress: 'Please check if the street name you entered is valid',
					required: 'Field is required'
				},
				'streetType': {
					required: 'Field is required',
					selectionRequired: 'Select street type'
				},
				'suburb': {
					containsNoSpecialChars: 'Please check if the suburb name you entered is valid',
					required: 'Field is required'
				},
				'state': {
					required: 'Field is required'
				},
				'postcode': {
					optusPostCode: 'Please check if the postcode you entered is valid',
					required: 'Field is required'
				},
				'country': {
					required: 'Field is required'
				}
			},
			internationalValidationRule: {
				'addressLine1': {
					digits: 'Please check if the Address Line 1 you entered is valid',
					required: 'Field is required'
				},
				'state': {
					required: 'Field is required'
				},
				'postcode': {
					required: 'Field is required'
				},
				'country': {
					required: 'Field is required'
				}
			},
			poBoxValidationRule: {
				'suburb': {
					required: 'Field is required'
				},
				'state': {
					required: 'Field is required'
				},
				'postcode': {
					required: 'Field is required'
				},
				'deliveryNum': {
					required: 'Field is required'
				},
				'country': {
					required: 'Field is required'
				}
			},
			privacyPolicy: 'Please select the privacy policy',
			selectAutoAddress: 'Select valid address',
			payBillsError: {
				'amountToPay': {
					decimalNumber: 'Please Enter only Numbers',
					required: 'Please enter the amount you are paying – you cannot leave this blank.',
					non_negative: 'Payment amount should be greater than zero.'
				},
				ssn: {
					required: 'Please enter your card’s security code',
					amexMinlength: ' Your card’s security code has four digits (display for AmEx)',
					amexMaxlength: ' Your card’s security code has four digits (display for AmEx)',
					minlength: 'Your card’s security code has three digits (display for Visa, MasterCard and Diners).',
					maxlength: 'Your card’s security code has three digits (display for Visa, MasterCard and Diners).',
					digit: 'Please enter only numbers'
				}
			},
			directDebit: {
				newBankAccountError: {
					accountName: {
						required: 'Account name can not be empty'
					},
					accountNumber: {
						required: 'Account number can not be empty',
						maxlength: 'Your account number may be alpha-numeric and is up to 10 characters long',
						alphanum: 'Your account number may be alpha-numeric and is up to 9 characters long',
						minlength: 'Account number may be alpha-numeric and it should contain at least 6 characters'
					},
					bankName: {
						required: 'Bank name can not be empty'
					},
					bsb: {
						required: 'BSB number can not be empty',
						bsbFormatOptus: 'BSB number must be 6 digits'
					},
					bankBranch: {
						required: 'Branch name can not be empty'
					},
					bsbNotFoundError: 'Bank cannot be found. Please check the BSB and update.',
					agreedTerms: 'You must agree to the terms and conditions'
				},
				noDueDirectDebit: 'There is no pending direct debit for the current bill.'
			},
			authenticationError: 'Token Expired, Please try again..!!',
			authenticationGenericError: 'Sorry, your session has expired. Please try again',
			invalidOtpError: 'Please enter valid OTP',
			otpSuccessMessage: 'OTP has been successfuly sent to your Mobile Number.',
			singnetIdError: 'This user ID is currently in use. Please choose a new user ID.',
			installationAddressFound: 'You already have an exisiting installation address. ' +
			'Please click on Ok to continue further.',
			invalidDate: 'Please select valid date.',
			addonValidationRule: {
				characteristic: {
					requried: 'This field is mandatory',
					maxlength: 'Max length is exceeded',
					duration: 'Please select correct end date'
				},
				billingOffer: {
					requried: 'This field is mandatory'
				},
				mobileNo: {
					requried: 'This field is mandatory',
					format: 'This doesn\'t look like a valid phone number. Please carefully check your ' +
							'contact number and enter again.',
					sendOtp: 'Failed to send OTP. Please try again.',
					validateVas: 'Failed to validate addon. Please try again.',
					notEligible: 'You are not eligible to buy this addon. Please call 1688 for assistance'
				},
				otp: {
					requried: 'This field is mandatory',
					accountNo: 'Please enter a valid account number (digits only)',
					digits: 'Please enter a valid OTP (digits only)',
					invalidOtp: 'Please enter valid OTP',
					validateOtp: 'Failed to validate OTP. Please try again.',
					minLength: 'Please enter minimum 6 digits'
				}
			},
			mainLineError: 'No Record Found',
			nonEasyMobileError: 'Please complete your exisiting order to proceed further.',
			guestIdTypeError: 'Please select valid ID type.',
			guestIdNumberError: 'Please select valid ID Number.',
			onePassRegister: 'Please register in One Pass to continue further.',
			updateAddress: {
				postCode: {
					digits: 'Enter a valid 6-digit postal code.',
					minlength: 'Enter a valid 6-digit postal code.'
				},
				floorNo: {
					required: 'Floor Number and Unit Number is required for this address.',
					invalid: 'Floor Number or Unit Number is invalid. Please provide valid information.'
				}
			},
			errorIcon: {
				type: 'exclamation',
				size: 'xl',
				color: '#D93A1B'
			},
			errorModalButton: {
				'type': 'secondary',
				'text': 'OK'
			},
			backend: {
				errorTitle: 'Server timed out',
				errorMessage: 'The server is not responding to the request that was sent, please try again later'
			},
			network: {
				errorTitle: 'Network connection error',
				errorMessage: 'Disconnected from server, not connected to the internet'
			},
			serverError: {
				errorTitle: 'Unexpected error',
				errorMessage: 'Unexpected error occured, please try again later.'
			},
			redirectMessage: 'Back to previous page',
			url: '#',
			deviceOutOfStockError: 'Your handset is out of stock.',
			accesoryOutOfStockError: 'We are sorry, currenly following item(s) are not available in stock :-',
			freebieOutOfStockError: 'The following items are currently not available :',
			collectAtStoreErrorHeader: 'Your selected phone is only available for collection at Singtel ' +
			'Shop at this time',
			collectAtStoreErrorMessage: '<ul><li>Trade-in of phones and purchase of accessories are currently ' +
			'unavailable for this collection method.</li><li>Free gifts are subject to stock availability.</li></ul>',
			removeItemsError: 'The phone you have selected is only available for collection at Singtel Shop.' +
			'Trade-in of phones and purchase of accessories are not available for this delivery option at the moment.' +
			' Free gift is subjected to stock availability.',
			simNumberValidationRule: {
				simNumber: 'SIM number should be 13 or 19 digits',
				optus_SimCard_Luhn_Algorithm: 'The SIM number entered is not valid. Please update the SIM card number.',
				required: 'This field is mandatory'
			},
			authenticationFailed: 'Dear customer, we are unable to proceed with your request. ' +
				'Please ensure that you enter the NRIC used during your pre-order.',
			newFlowError: 'Sorry, Please complete your existing order before starting with new Flow.',
			newFlowHeading : 'Error!!',
			numberSelectError: 'Please select valid number',
			addonsLoadError: 'We are sorry, we are unable to load Add-Ons.\r\n' +
			'Please click Proceed To Cart to continue without Add-Ons.',
			addonsNoRemoveMsg: 'This add-on cannot be removed as it is in contract.',
			registerInterestHeading: 'Confirmation Message',
			registerInterestFailureHeading: 'Error Message',
			registerInterestFailureMessage: 'Oops something went wrong. We will contact you shortly.',
			registerInterestSuccessMessage: 'Thank you for registering your intrest with us.' +
			'We\'ll be in contact with you shortly.',
			invalidName : 'Please enter valid name.',
			invalidStaffUser: 'Your login credentials do not match. Please re-enter the correct credentials to proceed',
			orderCancelErrorOnSummary: 'You can not continue futher,' +
			' as the device you selected is no longer in stock',
			relocateServices: {
				nricFormat: 'Please enter valid NRIC',
				validateNRICWithBcc: false
			},
			EmailAlreadyUpdated: 'Email already updated.',
			SubmitTimeElapsed: 'Token Expired. Please raise another request for update.',
			storeNotFound: 'The handset you wish to purchase is currently not available for collection' +
				' in stores. Please select an alternative delivery option.',
			pdfDownloadFail: 'We are sorry currently we are unable to download this file',
			addonMaxComponentError: 'Sorry, you have an existing {{existing_addon_name}} subscription.' +
			' Please complete your current order and call 1688 if you wish to have {{new_addon_name}}.',
			noTvProductError: 'No TV Service(s) Found.',
			roiAbandonCartMessage: 'Roi Abandcon cart',
			retrieveVoucherFailed: 'Sorry, we’re unable to retrieve your vouchers at this time.' +
			'Please try again later.\r\n' +
			'Alternatively, you may call 1609 for assistance.',
			pickUpStoreNotFound: 'The handset you wish to purchase is currently not available for collection' +
				' in stores. Please select an alternative delivery option.',
			collectNowStoreNotFound: 'The handset you have selected is currently unavailable for Collect Now. ' +
				'Please select an alternative delivery option.',
			saveCartFailed: 'Sorry, this feature is currently unavailable. Please try again later',
			orderAmendedInOtherFlow: 'Sorry, you are unable to proceed further due to a concurrent order ' +
				'in another tab/window. Please close this browser to start your purchase again ' +
				'and refrain from opening multiple tabs.',
			updateConfirmDeliveryOption: {
				heading: 'Confirm delivery option',
				message: 'To continue, please update and confirm your preferred delivery option.',
				cta: 'Update'
			},
			storeSlotsNotFound: 'Please select an alternative delivery option.',
			orderUnderProcessing: {
				heading: 'Order can’t be processed',
				message: 'Your current order can’t be processed at this moment as there is a previous' +
				' pending order tied to the same mobile line. Confirmation email could take up to 30 mins to reach you.'
			}
		},
		card: {
			brandsList: {
				amex: 'Amex'
			}
		},
		numbers: {
			Optus: '131 123'
		},
		pageUrls: {
			selectNumberPageUrl: '/content/singtel/en/personal/products-services/mobile/configuration' +
			'/mobile-number.html',
			orderFullfilmentUrl: '/content/singtel/en/personal/products-services/order/fulfillment.html',
			homePageUrl: '/content/singtel/en/personal.html',
			shoppingCartUrl: '/content/singtel/en/personal/products-services/shopping-cart.html',
			orderSummaryUrl: '/content/singtel/en/personal/products-services/order/summary.html',
			phoneCatalogPageUrl: '/content/singtel/en/personal/products-services/mobile/phones.html',
			tabletCatalogPageUrl: '/content/singtel/en/personal/products-services/mobile/tablets.html',
			loginUrl: '/content/singtel/en/personal/products-services/login-guest-checkout.html',
			justLoginUrl: '/content/singtel/en/personal/products-services/login.html',
			installationAddressUrl: '/content/singtel/en/personal/products-services/broadband' +
			'/configuration/fibre-coverage-check.html',
			tvInstallationAddressUrl: '/content/singtel/en/personal/products-services/tv' +
			'/configuration/fibre-coverage-check.html',
			fixedNumberUrl: '/content/singtel/en/personal/products-services/broadband/configuration/fixed-line.html',
			addonsPageUrl: '/content/singtel/en/personal/products-services/mobile/configuration/add-ons.html',
			broadbandAddonsPageUrl: '/content/singtel/en/personal/products-services/broadband' +
			'/configuration/add-ons.html',
			tvAddonsPageUrl: '/content/singtel/en/personal/products-services/tv/configuration/add-ons.html',
			orderConfirmationUrl: '/content/singtel/en/personal/products-services/order/confirmation.html',
			mainLineSelectionPageUrl: '/content/singtel/en/personal/products-services/mobile/main-line-selection.html',
			selectPlanPageUrl: '/content/singtel/en/personal/products-services/mobile/postpaid-plans.html',
			broadBandPageUrl: '/content/singtel/en/personal/products-services/broadband/fibre-broadband-plans.html',
			optusPhonesPageUrl: 'http://www.optus.com.au/shop/mobile/phones',
			tvPlanPageUrl: '/content/singtel/en/personal/products-services/tv/packs',
			mBBPlanUrl: '/content/singtel/en/personal/products-services/mobile/mobile-broadband-plans.html',
			readErrorUrl: '/content/singtel/en/includes/error/400.html',
			updateErrorUrl: '/content/singtel/en/includes/error/400.html',
			customerProfileCloseIframeUrl: '/content/singtel/en/personal/my-account/my-portal/closeiframe.html',
			settopBoxUrl: '/content/singtel/en/personal/products-services/tv/configuration/set-top-box.html',
			premiumAddonUrl: '/content/singtel/en/personal/products-services/broadband/configuration/top-ups.html',
			accessoriesUrl: '/content/singtel/en/personal/products-services/mobile/configuration/accessories.html',
			dashboard: '/content/singtel/en/personal/my-account/manage-accounts/account-summary.html',
			mobileStaffPlan: '/content/singtel/en/personal/products-services/mobile/staff-plans.html',
			broadbandStaffPlan: '/content/singtel/en/personal/products-services/tv/packs/staff-plans.html',
			tvStaffPlan: '/content/singtel/en/personal/products-services/tv/staff-catalogue-value-pack.html',
			userProfileLink: '/content/singtel/en/personal/my-account/manage-profile/profile.html',
			manageAddOns: '/content/singtel/en/personal/my-account/manage-accounts/manage-add-ons.html',
			timelinePageUrl: '/content/singtel/en/personal/my-account/orders-appointments/track-your-order.html',
			payrUrl: '/content/singtel/en/personal/i/phones-plans/international-calling/travelling-overseas' +
			'/roaming-services.html',
			changeDOBURL: '/content/singtel/en/personal/my-account/my-portal/profile.html',
			changeAppointmentUrl: '/content/singtel/en/personal/my-account/orders-appointments/change-appointment.html',
			billHistoryUrl: '/content/singtel/en/personal/my-account/bills-payments/view-bills.html',
			premiumProductsUrl: '/content/singtel/en/personal/products-services/broadband/configuration/premium.html',
			webChatUrl: 'https://api.whatsapp.com/send?phone=6590181688&text=ONLINESALESCHATS'
		},
		customerProfileErrorMsg: {
			salutationErrorMsg: 'Salutation does not match with selected gender',
			emailErrorMsg: 'Please enter correct email id',
			phoneErrorMsg: 'This doesn\'t look like a valid Australian phone number. Please carefully check your ' +
							'contact number and enter again.',
			mobilePhoneErrorMsg: 'This doesn\'t look like a valid Australian mobile phone number. Please carefully' +
								' check your contact number and enter again.',
			specialPhoneErrorMsg: 'This doesn\'t look like a valid Australian special phone number. Please carefully' +
								' check your contact number and enter again.',
			smsMsg: 'SMS notifications won\'t be sent on this number'
		},
		updateCustomerProfileErrorMsg: {
			salutationErrorMsg: 'Salutation does not match with selected gender',
			emailErrorMsg: 'Please enter correct email id',
			phoneErrorMsg: 'This doesn\'t look like a valid phone number. Please carefully check your ' +
							'contact number and enter again.',
			smsMsg: 'Please enter a valid mobile number to receive SMS notifications.',
			dobToolTip: 'Your date of birth entitles you to birthday treats ' +
			'and ensures you can view password-protected documents from Singtel.',
			mobilePhoneContactErrorMsg: 'Please enter a valid mobile number beginning with 8 or 9.'
		},
		tweakSuspensionErrorMsg: 'Your service is under suspension,Please contact customer care.',
		easyMobileTweakError: 'Tweak Your plan, Value can not be zero',
		billDeliveryType: [
			'METH_EMAIL', 'METH_PAPER', 'METH_SMS', 'METH_NON_PAPER'
		],
		consolidateAccount: {
			selecteMasterAccount: 'Select your main account',
			viewMySerice: 'View My Services',
			notificationMsg: 'Your main account\'s billing preferences, notifications and settings will apply across ' +
			'the accounts that you are about to consolidate.',
			chooseAccountTitle: 'Choose the accounts for consolidation',
			copywriterMsg: 'Please tick the boxes of the accounts that you would like to consolidate.',
			billingAddress: 'Billing Address',
			newBillingAddress: 'New Billing Address:',
			isBaStatusActive: 'You Billing Account is not Active.',
			consolidateAccountTitle: 'Consolidate accounts',
			successMessage: 'Congratulations! Your request to consolidate your accounts has been received.' +
			' Please allow 3 working days for this request to be processed. Please note that your main' +
			' account\'s billing preferences, notifications and settings will apply across the rest of your' +
			' accounts that you are about to consolidate.',
			errorMessage: 'We are sorry Something went wrong, please try later or call 1688'
		},
		graphColor: ['#327A43', '#4D327A', '#919B16', '#F5E70A', '#1F0E76',
		'#999999', '#000000', '#006280', '#d93a1b', '#fff8D9',
		'#e5e5e5', '#760E1F', '#471216', '#19EB7C', '#49EB19'],
		viewBill: {
			taxInclusionTitle: '(which includes GST of $XXXX)',
			dueAmountText: 'Please refer to your PDF bill for payment information and more details.'
		},
		viewBillChargeType: {
			'CT_DemServ': 'CT_DemServ',
			'DBT': 'International Voice',
			'Data': 'Data Usage',
			'Distance': 'Distance',
			'GPRS': 'Roaming Data Usage',
			'GSM voice': 'Voice Usage',
			'Local_calls': 'Local Voice Usage',
			'MMS': 'MMS Usage',
			'SMS': 'Premium SMS Usage',
			'ST_SansFrais': 'ST_SansFrais'
		},
		viewBillPopUp: {
			ebillTitle: 'Singtel eBill',
			paperBillErrorMsg: 'Sorry, there are no bills available for the period you have chosen.' +
			' Please select your dates again.',
			ebillHeader: 'Would you like to register for eBill?',
			ebillMsgParaOne: 'Wondering what is eBill all about?',
			ebillMsgParaTwo: 'eBill shows you a detailed break down of your Singtel bill and allows you ' +
			'to pay for your bills online through My Account and My Singtel app.' +
			' You\'ll receive a Bill-Ready Notification in your email inbox with a link to view your bill ' +
			'online. As an eBill user, you will not be receiving paper bills anymore.',
			ebillMsgParaThree: 'If you\'d like to also receive a paper bill, you\'ll always be able to so via ' +
			'<a href="/content/singtel/en/personal/my-account/bills-payments/bill-request-alerts.html">' +
			'Notifications and Alerts</a>. Please note that you\'ll still receive the electronic bill' +
			' when you\'re subscribed to the paper bill.',
			ebillMsgParaFour: 'Would you like to activate eBill?',
			ebillMsgParaFive: 'Please note that you will receive 1 email notification for each billing' +
			' account to notify you that you had activated eBill for all accounts.',
			ebillBannerTitle: 'Be part of this green initiative!',
			ebillBanner: 'Join the many Singaporeans who have gone paperless and receive your bills online today.',
			ebillReasonList: [
				{value: 'E_BILL_METH_NON_PAPER',dispayText: 'I' +
				' would like to stop receiving paper bills and subscribe as an eBill user.',title: 'Just eBill'},
				{value: 'E_BILL',dispayText: 'I would like to subscribe to eBill.',
				title: 'eBill and paper bill ($1.07/bill)'},
				{value: 'NO_ACTION',dispayText: 'Continue as a non-eBill user.',title: 'Non-eBill'},
				{value: 'METH_PAPER',dispayText: 'I would like to stop receiving details paper bills, and' +
				' continue as a non-eBill user.',title: 'Non-eBill'}
			],
			remindOption: 'Don\'t remind me of this again',
			ebillChangeSuccessfulMsg: 'Your bill preferences updated successfully.',
			errorTitle: 'Sorry!',
			errorMessage: 'We are sorry Something went wrong, please try later or call 1688',
			printStatus: 'Please note that {FAILED} out of {TOTAL} Copy Bills requested cannot be processed.' +
			' Kindly call 1688 for further assistance.',
			hardCopyErrorMsg: 'There are no bills for the selected period {STARTDATE} to {ENDDATE}.',
			invalidEmailErrorTitle: 'Invalid email address'
		},
		viewBillPopUpUser: {
			ebillTitle: 'Singtel eBill',
			paperBillErrorMsg: 'No bills are available for the above date. Please select your dates again.',
			ebillHeader: 'Wondering what eBill is all about?',
			ebillMsgParaOne: 'Go Paperless. Switch to eBill now !',
			ebillMsgParaTwo: '<ul><li> It\'s hassle-free, convenient and available 24/7.' +
				'<li>Details of your Mobile talktime and SMS are provided.</li>' +
				'<li>Receive alerts when your bill is ready or when your payment is due.</li></ul>',
			ebillMsgParaThree: 'Would you like to activate eBill?',
			ebillMsgParaFour: 'Please note that you will receive 1 email notification for each billing account' +
			' to notify you that you had activated eBill for all accounts.',
			ebillBannerTitle: 'Be part of this green initiative!',
			ebillBanner: 'Join the many Singaporeans who have gone paperless and receive your bills online today.',
			ebillReasonList: [
				{value: 'E_BILL_METH_NON_PAPER',dispayText: 'I' +
				' would like to subscribe to eBill.',title: 'eBill Only'},
				{value: 'E_BILL',dispayText: 'I would like to subscribe to eBill and ' +
				'receive the paper bill at $1.07 per bill.',title: 'eBill and paper bill ($1.07/bill)'},
				{value: 'NO_ACTION',dispayText: 'I would like to continue as a non-eBill ' +
				'user.',title: 'Non-eBill only'},
				{value: 'METH_PAPER',dispayText: 'I would like to receive eBill Overview ' +
				'only.',title: 'Non-eBill with eBill Overview only'}
			],
			remindOption: 'Don\'t remind me of this again',
			ebillChangeSuccessfulMsg: 'Your bill preferences updated successfully.',
			errorTitle: 'Sorry!',
			errorMessage: 'We are sorry Something went wrong, please try later or call 1688'
		},
		singtelInbox: {
			deleteMessagwWarning: 'This message applies to multiple services in your account.<br/>' +
			'Would you like to delete all messages?'
		},
		PERSONAL: 'Personal',
		BUSINESS: 'Business',
		personalType: ['consumer','both'],
		businessType: ['enterprise','both'],
		selectAService: 'Select a Service',
		selectAServiceDescription: '',
		newServices: [
			{
				serviceId: 'newMobilePostpaid',
				serviceName: 'Mobile',
				lob: 'WS',
				applicable: ['Personal']
			},
			{
				serviceId: 'newMobileBroadband',
				serviceName: 'Mobile Broadband',
				lob: 'MBB',
				applicable: ['Personal']
			},
			{
				serviceId: 'newHomePhone',
				serviceName: 'Home Telephone',
				lob: 'FV',
				applicable: ['Personal']
			},
			{
				serviceId: 'newFibre',
				serviceName: 'Fibre Broadband',
				lob: 'BB',
				applicable: ['Business','Personal']
			},
			{
				serviceId: 'newTV',
				serviceName: 'Singtel TV',
				lob: 'TV',
				applicable: ['Personal']
			}

		],
		languages: [
			{
				value: 'English',
				title: 'English'
			},
			{
				value: 'Mandarin',
				title: 'Mandarin'
			}
		],
		enquiryOptions: [
			{
				'value': 'General',
				'title': 'General'
			},
			{
				'value': 'Billing',
				'title': 'Billing'
			},
			{
				'value': 'Technical',
				'title': 'Technical Support'
			},
			{
				'value': 'Sales',
				'title': 'Recontract / New service sign up'
			}
		],
		singaporeCoordinates: {
			lat: 1.303920,
			lon: 103.843127
		},
		maxQuotaVoice: 10000,
		maxQuotaData: 31457280,
		mobileShareIds: ['14317472', '14308172', '8517942', '25988684',
			'25972184', '26019054'],
		usageAddon: {
			title: 'Stay connected!',
			description: 'Get additional 1GB local data just at $10'
		},
		pageRefreshInterval: 60000,
		maxQuotaSms: 10000,
		prepaidTopupAnmTemplate: {
			createTopup: 'mcss.prepaid.top.up.notification',
			moditfyTopup: 'mcss.prepaid.top.up.notification',
			cancelTopup: 'mcss.prepaid.top.up.notification'
		},
		deviceDetailsTitles: {
			chooseColor: 'Choose a Color',
			chooseSize: 'Choose a Size',
			techSpec: 'Technical Specifications',
			specifications: 'Specifications',
			features: 'Features',
			whatsInABox: 'What\'s in the box',
			stockLinkText: 'Check Stock availablity for all variants'
		},
		qnomyCustomerIdTypes: {
			'Diplomatic': 2,
			'Entre Pass': 6,
			'Foreigner Dependent Pass': 5,
			'Foreigner Employment Pass': 15,
			'Foreigner S Pass': 7,
			'Foreigner Social Visit Pass': 8,
			'Foreigner Student Pass': 9,
			'Foreigner Work Permit': 10,
			'National Registration ID Card (NRIC)': 1,
			'Non-diplomatic': 16,
			'Passport Number': 3,
			'Previous BRN/UEN': 11,
			'Unique Entity Number (UEN)': 13
		},
		videoProviderHost: {
			youtube: 'https://www.youtube.com/embed/'
		},
		managePermission: {
			mainTitle: 'CONTACT & PERMISSION',
			text: 'will no longer be able to view and manage your bills',
			subText: 'Note that this contact still has service permissions for',
			subBillText: 'of your other services and is a nominee for ',
			subBilEndText: ' of your bills',
			servicePermissionPostfixText: 'of your other services',
			billPermissionOnlyPrefixText: 'Note that this contact still nominee for'
		},
		guestCheckoutValidationError: {
			idNumber: {
				idRequired: 'Please fill in this field.',
				inValidError: 'Please enter a valid Id.',
				maxLengthError: 'Please enter a maximum of 8 characters.',
				minLengthError: 'Please enter a minimum of 8 characters.'
			},
			mobileNumber: {
				mobileRequired: 'Please fill in this field.',
				mobileDigitOnly: 'Please enter a valid contact number (digits only).',
				maxLengthError: 'Please enter a maximum of 8 digits.',
				minLengthError: 'Please enter a minimum of 8 digits.',
				inValidMobile: 'Please enter a valid Number starting with 6, 8 or 9.',
				inValidMobileNumber: 'Please enter a valid mobile number starting with 8 or 9.'
			},
			customerName: {
				nameRequired: 'Please fill in this field.',
				inValidName: 'Please omit any special characters. (e.g $, %)',
				maxLengthError: 'Please enter a maximum of 50 characters.',
				minLengthError: 'Please enter a minimum of 2 characters.',
				alpha_numeric: 'Your full name can only contain letters'
			},
			emailAddress: {
				nameRequired: 'Please fill in this field.',
				inValidEmail: 'Please enter a valid Email.'
			},
			genderErrorMsg: 'Please select Gender.',
			salutationErrorMsg: 'Please select Salutation.',
			dateOfBirth: {
				isPastDate: 'Please enter a valid date of birth.',
				isValidDate: 'Please enter a valid date.',
				required: 'Please enter your date of birth.'
			}

		},
		tvSelfHelpValidationErrors: {
			idNumber: {
				idRequired: 'Please fill in the Customer ID.',
				inValidError: 'Please enter a valid Id.',
				maxLengthError: 'Please enter a maximum of 8 characters.',
				minLengthError: 'Please enter a minimum of 8 characters.'
			},
			customerName: {
				nameRequired: 'Name cannot be empty.',
				inValidName: 'Please enter a valid Name.',
				maxLengthError: 'Please enter a maximum of 50 characters.',
				minLengthError: 'Please enter a minimum of 2 characters.'
			},
			mobileNumber: {
				mobileRequired: 'Contact Number cannot be empty.',
				mobileDigitOnly: 'Please enter a valid number (digits only).',
				maxLengthError: 'Please enter a maximum of 8 digits.',
				minLengthError: 'Please enter a minimum of 8 digits.',
				inValidMobile: 'Please enter a valid number starting with 6, 8 or 9.'
			},
			idType: 'Please select ID Type.',
			idNum: 'Please select ID.',
			serviceType: 'Please select 1 service type.',
			serialNo: 'Please fill in new STB serial number.',
			guidID: 'Please fill in new GUID.',
			stbType: 'Please fill in  the STB type.',
			stbSubscription: 'Please select a premium package.',
			invalidName: 'Please enter valid name.',
			stbError: 'Please fill in  the STB type.',
			stbNumError: 'Please fill in new STB serial number.',
			guidError: 'Please fill in new GUID.'
		},
		tvSelfHelpBillingOffers: {
			additionalStb: {
				non_Dvr: [
					{
						value: '',
						title: 'No discount'
					},
					{
						value: '19723949',
						title: 'Gen3 DVR/DVR/HD Set-Top Box Rental'
					},
					{
						value: '19569701',
						title: '$5 for 6 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569711',
						title: '$5 for 12 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569721',
						title: '$5 for 24 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569421',
						title: '50% off 6 mths on STB (HD/DVR/Gen DVR)'
					},
					{
						value: '19569411',
						title: '50% off 12 mths on STB (HD/DVR/Gen DVR)'
					},
					{
						value: '19569391',
						title: '50% off 24 mths on STB (HD/DVR/Gen DVR)'
					},
					{
						value: '19569591',
						title: '$5 off 6 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569601',
						title: '$5 off 12 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569611',
						title: '$5 off 24 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569341',
						title: 'Free 3 mths on STB (HD/DVR/Gen DVR)'
					}
				],
				dvr: [
					{
						title: 'No discount',
						value: ''
					}
				],
				gen3Record: [
					{
						title: 'No discount',
						value: ''
					}
				],
				gen3NonRecord: [
					{
						title: 'No discount',
						value: ''
					},
					{
						value: '19723949',
						title: 'Gen3 DVR/DVR/HD Set-Top Box Rental'
					},
					{
						value: '19569591',
						title: '$5 off 6 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569601',
						title: '$5 off 12 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569611',
						title: '$5 off 24 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569421',
						title: '50% off 6 mths on STB (HD/DVR/Gen DVR)'
					},
					{
						value: '19569411',
						title: '50% off 12 mths on STB (HD/DVR/Gen DVR)'
					},
					{
						value: '19569391',
						title: '50% off 24 mths on STB (HD/DVR/Gen DVR)'
					},
					{
						value: '19569631',
						title: '$10 off 6 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569641',
						title: '$10 off 12 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569651',
						title: '$10 off 24 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569341',
						title: 'Free 3 mths on STB (HD/DVR/Gen DVR)'
					}
				],
				andriodStb: [
					{
						title: 'No discount',
						value: ''
					},
					{
						value: '19723949',
						title: 'Gen3 DVR/DVR/HD Set-Top Box Rental'
					},
					{
						value: '19569701',
						title: '$5 for 6 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569711',
						title: '$5 for 12 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569721',
						title: '$5 for 24 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569421',
						title: '50% off 6 mths on STB (HD/DVR/Gen DVR)'
					},
					{
						value: '19569411',
						title: '50% off 12 mths on STB (HD/DVR/Gen DVR)'
					},
					{
						value: '19569391',
						title: '50% off 24 mths on STB (HD/DVR/Gen DVR)'
					},
					{
						value: '19569591',
						title: '$5 off 6 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569601',
						title: '$5 off 12 mths on Adl STB (HD/Gen3 DVR Non Record)'
					},
					{
						value: '19569611',
						title: '$5 off 24 mths on Adl STB (HD/Gen3 DVR Non Record)'
					}
				]
			},
			mainStb: {
				dvr: {
					upgd: [
						{
							title: 'No discount',
							value: ''
						},
						{
							title: 'Gen3 DVR/DVR/HD Set-Top Box Rental',
							value: '19723949'
						},
						{
							title: '$4.90 for 6 mths on 1st STB (DVR)',
							value: '19569741'
						},
						{
							title: '$4.90 for 12 mths on 1st STB (DVR)',
							value: '19569751'
						},
						{
							title: '$4.90 for 24 mths on 1st STB (DVR)',
							value: '19569761'
						},
						{
							title: '50% off 6 mths on STB (HD/DVR/Gen DVR)',
							value: '19569421'
						},
						{
							title: '50% off 12 mths on STB (HD/DVR/Gen DVR)',
							value: '19569411'
						},
						{
							title: '50% off 24 mths on STB (HD/DVR/Gen DVR)',
							value: '19569391'
						},
						{
							value: '19569341',
							title: 'Free 3 mths on STB (HD/DVR/Gen DVR)'
						}
					],
					dwngd: [
						{
							title: 'No discount',
							value: ''
						},
						{
							title: 'Gen3 DVR/DVR/HD Set-Top Box Rental',
							value: '19723949'
						}
					]
				},
				non_Dvr: {
					upgd: [
						{
							title: 'No discount',
							value: ''
						}
					],
					dwngd: [
						{
							title: 'No discount',
							value: ''
						},
						{
							value: '19723949',
							title: 'Gen3 DVR/ DVR / HD Set - Top Box Rental'
						}
					]
				},
				gen3Record: {
					upgd: [
						{
							value: '',
							title: 'No discount'
						},
						{
							value: '19723949',
							title: 'Gen3 DVR/DVR/HD Set-Top Box Rental'
						},
						{
							value: '19569551',
							title: '$5 off 6 mths on 1st STB (Gen3 DVR Record)'
						},
						{
							value: '19569561',
							title: '$5 off 12 mths on 1st STB (Gen3 DVR Record)'
						},
						{
							value: '19569571',
							title: '$5 off 24 mths on 1st STB (Gen3 DVR Record)'
						},
						{
							value: '19569661',
							title: '$10 off 6 mths on 1st STB (Gen3 DVR Record)'
						},
						{
							value: '19569671',
							title: '$10 off 12 mths on 1st STB (Gen3 DVR Record)'
						},
						{
							value: '19569681',
							title: '$10 off 24 mths on 1st STB (Gen3 DVR Record)'
						},
						{
							value: '19569421',
							title: '50% off 6 mths on STB (HD/DVR/Gen DVR)'
						},
						{
							value: '19569411',
							title: '50% off 12 mths on STB (HD/DVR/Gen DVR)'
						},
						{
							value: '19569391',
							title: '50% off 24 mths on STB (HD/DVR/Gen DVR)'
						},
						{
							value: '19569481',
							title: '$2 off 6 mths on 1st STB (HD/Gen3 DVR Record)'
						},
						{
							value: '19569491',
							title: '$2 off 12 mths on 1st STB (HD/Gen3 DVR Record)'
						},
						{
							value: '19569501',
							title: '$2 off 24 mths on 1st STB (HD/Gen3 DVR Record)'
						},
						{
							value: '19569341',
							title: 'Free 3 mths on STB (HD/DVR/Gen DVR)'
						}
					],
					dwngd: [
						{
							title: 'No discount',
							value: ''
						}
					]
				},
				gen3NonRecord: {
					upgd: [
						{
							title: 'No discount',
							value: ''
						},
						{
							value: '19723949',
							title: 'Gen3 DVR/DVR/HD Set-Top Box Rental'
						},
						{
							value: '19569591',
							title: '$5 off 6 mths on Adl STB (HD/Gen3 DVR Non Record)'
						},
						{
							value: '19569601',
							title: '$5 off 12 mths on Adl STB (HD/Gen3 DVR Non Record)'
						},
						{
							value: '19569611',
							title: '$5 off 24 mths on Adl STB (HD/Gen3 DVR Non Record)'
						},
						{
							value: '19569421',
							title: '50% off 6 mths on STB (HD/DVR/Gen DVR)'
						},
						{
							value: '19569411',
							title: '50% off 12 mths on STB (HD/DVR/Gen DVR)'
						},
						{
							value: '19569391',
							title: '50% off 24 mths on STB (HD/DVR/Gen DVR)'
						},
						{
							value: '19569631',
							title: '$10 off 6 mths on Adl STB (HD/Gen3 DVR Non Record)'
						},
						{
							value: '19569641',
							title: '$10 off 12 mths on Adl STB (HD/Gen3 DVR Non Record)'
						},
						{
							value: '19569651',
							title: '$10 off 24 mths on Adl STB (HD/Gen3 DVR Non Record)'
						},
						{
							value: '19569341',
							title: 'Free 3 mths on STB (HD/DVR/Gen DVR)'
						}
					],
					dwngd: [
						{
							title: 'No discount',
							value: ''
						}
					]
				},
				andriodStb: {
					upgd: [
						{
							title: 'No discount',
							value: ''
						}
					],
					dwngd: [
						{
							title: 'No discount',
							value: ''
						},
						{
							title: '19723949',
							value: 'Gen3 DVR/DVR/HD Set-Top Box Rental'
						}
					]
				}
			},
			sentinelValue: [{
				title: 'No discount',
				value: ''
			}]
		},
		guestGenderOptions: [
			{value: 'Male', text: 'Male'},
			{value: 'Female', text: 'Female'}
		],
		genderList: [
			{value: 'M', text: 'Male'},
			{value: 'F', text: 'Female'},
			{value: 'Please Specify', text: 'Please Specify'},
			{value: 'GD', text: 'Gender Diverse'},
			{value: 'U', text: 'Not Specified/Unknown'}
		],
		guestSalutationOptions: [
			{value: 'Mr', text: 'Mr'},
			{value: 'Mrs', text: 'Mrs'},
			{value: 'Miss', text: 'Miss'},
			{value: 'Dr', text: 'Dr'}
		],
		guestIDPrefixOptions: [
			{
				'value': 'F',
				'title': 'F'
			},
			{
				'value': 'G',
				'title': 'G'
			},
			{
				'value': 'S',
				'title': 'S'
			},
			{
				'value': 'T',
				'title': 'T'
			},
			{
				'value': 'M',
				'title': 'M'
			}
		],
		tvSelfHelpOptions: [
			{
				'default': false,
				'title': 'NRIC',
				'value': 'National Registration ID Card (NRIC)',
				'rank': 0,
				'ID': 'S'
			},
			{
				'default': false,
				'title': 'Work Permit',
				'value': 'Foreigner Work Permit',
				'rank': 1,
				'ID': 'F'
			},
			{
				'default': false,
				'title': 'Employment Pass',
				'value': 'Foreigner Employment Pass',
				'rank': 2,
				'ID': 'G'
			},
			{
				'default': false,
				'title': 'Foreigner S Pass',
				'value': 'Foreigner S Pass',
				'rank': 3,
				'ID': 'F'
			},
			{
				'default': false,
				'title': 'Diplomat',
				'value': 'Diplomat',
				'rank': 4,
				'ID': 'G'
			}
		],
		guestIdTypeOptions: [
			{
				'default': false,
				'title': 'Work Permit',
				'value': 'Foreigner Work Permit',
				'rank': 0,
				'ID': 'F'
			},
			{
				'default': false,
				'title': 'Work Permit',
				'value': 'Foreigner Work Permit',
				'rank': 1,
				'ID': 'G'
			},
			{
				'default': false,
				'title': 'Employment Pass',
				'value': 'Foreigner Employment Pass',
				'rank': 2,
				'ID': 'G'
			},
			{
				'default': false,
				'title': 'Employment Pass',
				'value': 'Foreigner Employment Pass',
				'rank': 3,
				'ID': 'F'
			},
			{
				'default': false,
				'title': 'Foreigner S Pass',
				'value': 'Foreigner S Pass',
				'rank': 4,
				'ID': 'F'
			},
			{
				'default': false,
				'title': 'Foreigner S Pass',
				'value': 'Foreigner S Pass',
				'rank': 5,
				'ID': 'G'
			},
			{
				'default': false,
				'title': 'NRIC',
				'value': 'National Registration ID Card (NRIC)',
				'rank': 6,
				'ID': 'S'
			},
			{
				'default': false,
				'title': 'NRIC',
				'value': 'National Registration ID Card (NRIC)',
				'rank': 7,
				'ID': 'T'
			},
			{
				'default': false,
				'title': 'Diplomat',
				'value': 'Diplomat',
				'rank': 8,
				'ID': 'G'
			},
			{
				'default': false,
				'title': 'Diplomat',
				'value': 'Diplomat',
				'rank': 9,
				'ID': 'F'
			},
			{
				'default': false,
				'title': 'Work Permit',
				'value': 'Foreigner Work Permit',
				'rank': 10,
				'ID': 'M'
			},
			{
				'default': false,
				'title': 'Employment Pass',
				'value': 'Foreigner Employment Pass',
				'rank': 11,
				'ID': 'M'
			},
			{
				'default': false,
				'title': 'Foreigner S Pass',
				'value': 'Foreigner S Pass',
				'rank': 12,
				'ID': 'M'
			},
			{
				'default': false,
				'title': 'Diplomat',
				'value': 'Diplomat',
				'rank': 14,
				'ID': 'M'
			}
		],
		deltaGuesIdTypeOptions: [
			{
				'default': false,
				'title': 'Passport',
				'value': 'Passport Number'
			}
		],
		passportNumberErrorMessage: {
			required: 'Please enter a valid Passport Number',
			invalidPassportId: 'Please enter valid ID Number'
		},
		balanceDisplayPrefix: {
			'due': 'Balance Due:',
			'credit': 'Balance Credit:',
			'dueBal': 'due',
			'creditBal': 'credit'
		},
		loginErrorSenario: {
			0: 'Error in login',
			1: 'Password Must Change',
			2: 'Invalid session',
			3: 'Sm_Api_Reason_RevokedSession ',
			4: 'Sm_Api_Reason_ExpiredSession ',
			5: 'Sm_Api_Reason_AuthLevelTooLow ',
			6: 'Sm_Api_Reason_UnknownUser ',
			7: 'Sm_Api_Reason_UserDisabled',
			8: 'Sm_Api_Reason_InvalidSessionId ',
			9: 'Sm_Api_Reason_InvalidSessionIp ',
			10: 'Sm_Api_Reason_CertificateRevoked ',
			11: 'Sm_Api_Reason_CRLOutOfDate ',
			12: 'Sm_Api_Reason_CertRevokedKeyCompromised ',
			13: 'Sm_Api_Reason_CertRevokedAffiliationChange ',
			14: 'Sm_Api_Reason_CertOnHold ',
			15: 'Sm_Api_Reason_TokenCardChallenge ',
			16: 'Sm_Api_Reason_ImpersonatedUserNotInDir ',
			17: 'Sm_Api_Reason_Anonymous ',
			18: 'Sm_Api_Reason_PwWillExpire ',
			19: 'Sm_Api_Reason_PwExpired',
			20: 'Sm_Api_Reason_ImmedPWChangeRequired ',
			21: 'Sm_Api_Reason_PWChangeFailed',
			22: 'Sm_Api_Reason_BadPWChange ',
			23: 'Sm_Api_Reason_PWChangeAccepted ',
			24: 'Sm_Api_Reason_ExcessiveFailedLoginAttempts ',
			25: 'Sm_Api_Reason_AccountInactivity ',
			26: 'Sm_Api_Reason_NoRedirectConfigured',
			27: 'Sm_Api_Reason_ErrorMessageIsRedirect ',
			28: 'Sm_Api_Reason_Next_Tokencode ',
			29: 'Sm_Api_Reason_New_PIN_Select ',
			30: 'Sm_Api_Reason_New_PIN_Sys_Tokencode ',
			31: 'Sm_Api_Reason_New_User_PIN_Tokencode ',
			32: 'Sm_Api_Reason_New_PIN_Accepted ',
			33: 'Sm_Api_Reason_Guest ',
			34: 'Sm_Api_Reason_PWSelfChange ',
			35: 'Sm_Api_Reason_ServerException ',
			36: 'Sm_Api_Reason_UnknownScheme ',
			37: 'Sm_Api_Reason_UnsupportedScheme ',
			38: 'Sm_Api_Reason_Misconfigured ',
			39: 'Sm_Api_Reason_BufferOverflow',
			40: 'Sm_Api_Reason_SetPersistentSessionFailed ',
			41: 'Sm_Api_Reason_UserLogout ',
			42: 'Sm_Api_Reason_IdleSession ',
			43: 'Sm_Api_Reason_PolicyServerEnforcedTimeout ',
			44: 'Sm_Api_Reason_PolicyServerEnforcedIdle ',
			45: 'Sm_Api_Reason_ImpersonationNotAllowed ',
			46: 'Sm_Api_Reason_ImpersonationNotAllowedUser ',
			47: 'Sm_Api_Reason_FederationNoLoginID ',
			48: 'Sm_Api_Reason_FederationUserNotInDir ',
			49: 'Sm_Api_Reason_FederationInvalidMessage ',
			50: 'Sm_Api_Reason_FederationUnacceptedMessage ',
			51: 'Sm_Api_Reason_ADnativeUserDisabled '
		},
		optusLogout: {
			targetUrl: '/content/optus/en/Login_component.html',
			siteMinderLogoutUrl: '/logout'
		},
		ipPaymentConfiguration: {
			ipPaymentUrl: '/api/cxf/optusredirectservice/ippayments?target='
		},
		modalHeader: {
			show: false
		},
		productSupportServletUrl: '/bin/services/singtel/FaqSupportServlet.dir.q=',
		pricePlanServiceUrl: '/bin/services/singtel/priceplan.:',
		blockStoreError: 'You are not allowed to book Store Appointment.' +
		' You already have maximum limit of this Service Type.',
		blockStoreBlackListError: 'Please visit your nearest Singtel Shop to proceed.',
		notificationArray: [
			{
				'label': 'BY EMAIL',
				'btn_id': 'radioBtn_EMAIL',
				'value': 'EMAIL'
			}, {
				'label': 'BY SMS',
				'btn_id': 'radioBtn_SMS',
				'value': 'SMS'
			}
		],
		myOrders: {
			inProgress: 'In Progress',
			of: 'of',
			productInOrder: 'products in this order',
			singleProductInOrder: 'product in this order',
			shipment: 'Shipment',
			serviceActivation: 'Service Activation',
			activationDateText: 'Activated on: ',
			plannedActivationDateText: 'Planned activation date: ',
			delivery: 'Delivery to',
			orderActionStatusMap: {
				AM: 'Amended',
				BA: 'Being Amended',
				DE: 'Delivery',
				FU: 'Future',
				IN: 'Initial',
				NE: 'Negotiation',
				NO: 'Completion',
				TC: 'To Be Cancelled',
				CA: 'Cancelled',
				DC: 'Discontinued',
				DO: 'Done',
				FI: 'Fictitious',
				OH: 'On Hold',
				RE: 'Rejected'
			},
			orderStatusMap: {
				CA: 'Cancelled',
				DC: 'Cancelled',
				EP: 'Cancelled',
				DO: 'Closed/Completed',
				EX: 'In process',
				FU: 'In process',
				IN: 'In process',
				SB: 'In process',
				SR: 'In process',
				RE: 'Rejected',
				TC: 'To be cancelled',
				ER: 'Error'
			},
			orderActionInProgressStatusMap: ['AM', 'BA', 'DE', 'FU', 'IN', 'NE', 'NO', 'TC']
		},
		tvPlanId: '8637312',
		tvPlanRelId: '8637322',
		cca: {
			subscriptionMsg: {
				sms: 'Your mobile number',
				email: 'Your email address',
				success: 'Your subscriptions have been updated successfully'
			},
			specificSubscriptionTitle: {
				smart_phone_alerts: 'Choose your preferred smartphone brand:'
			},
			formattedAddressValidationErrorMessage: 'Your suburb and postcode do not match!',
			incorrectVerificationCodeErrorMessage: 'Your verification code is incorrect! Please try again.',
			errorMessage: 'Something went wrong on our side. Please try again later.',
			noMarketing: 'NM',
			channel: {
				sms: 'SM',
				email: 'EM'
			},
			optedOut: {
				true: 'OPT-OUT',
				false: 'OPT-IN'
			}
		},

		epl: {
			mobile: 'MOB',
			broadband: 'BB',
			mobileBroadband: 'OWB',
			serviceId: {
				required: 'Please enter Username or Account Number or homephone Number'
			},
			orderid: {
				required: 'Please enter Order ID'
			},
			verificationCode: {
				param: 6,
				lengthCheck: 'Please enter 6 digit code',
				required: 'Please enter a verification code'
			},
			dobDay: {
				isValidDay: 'Please enter valid day',
				required: 'Day is required'
			},
			dobMonth: {
				isValidMonth: 'Please enter valid month',
				required: 'Month is required'
			},
			dobYear: {
				isValidAge: 'Please enter valid year',
				required: 'Year is required'
			},
			postcode: {
				param: 4
			}
		},

		validation: {
			pwd: {
				minlength: {
					param: 8,
					message: 'Your password must be a minimum of 8 characters.'
				},
				uppercase: 'Your password must contain a uppercase character.',
				lowercase: 'Your password must contain a lowercase character.',
				symbols: 'Your password must contain a number or symbol.',
				required: 'Your password cannot be blank.',
				containsNoSpaces: 'Your password cannot contain spaces.'
			},
			pwdMin: {
				minlength: {
					param: 8,
					message: 'Your password must be a minimum of 8 characters.'
				},
				required: 'Your password cannot be blank.',
				containsNoSpaces: 'Your password cannot contain spaces.'
			},
			email: {
				required: 'Please enter your email',
				email: 'Please enter a valid email'
			},
			passcode: {
				required: 'Please enter the passcode',
				digits: 'Please enter only digits',
				minlength: {
					'param': 4,
					'message': 'Please enter minimum of 4 digits'
				},
				maxlength: {
					'param': 4,
					'message': 'Please enter maximum of 4 digits'
				}
			},
			mobilePhone: {
				required: 'Please enter a mobile number',
				mobilePhone: 'This doesn\'t look like a valid Australian mobile phone number. Please carefully' +
								' check your contact number and enter again.'
			},
			homePhone: {
				homePhone: 'This doesn\'t look like a valid Australian phone number. Please carefully check your ' +
							'contact number and enter again.',
				required: 'Please enter a phone number.'
			},
			specialPhone: {
				specialPhone: 'This doesn\'t look like a valid Australian special phone number. Please carefully ' +
							'check your contact number and enter again.',
				required: 'Please enter a phone number.'
			},
			dateOfBirth: {
				isPastDate: 'Please enter a valid date of birth.',
				isValidDate: 'Please enter a valid date.',
				required: 'Please enter your date of birth.'
			},
			address: {
				streetNumber: {
					required: 'Please enter a street number.',
					maxlength: {
						param: 9,
						message: 'please enter a maximum of 9 digits.'
					}
				},
				streetName: {
					required: 'Please enter a street name.',
					alpha_numeric: 'Please enter a valid street name.',
					maxlength: {
						param: 45,
						message: 'please enter a maximum of 45 letters.'
					}
				},
				streetType: {
					required: 'Please enter a street type.'
				},
				suburb: {
					required: 'Please enter a suburb.',
					alpha_numeric: 'Please enter a valid suburb.'
				},
				state: {
					required: 'Please select a state.'
				},
				postcode: {
					required: 'Please enter a postcode.',
					digits: 'Please enter a valid postcode. (Digits only)',
					maxlength: {
						param: 4,
						message: 'Please enter a maximum of 4 digits.'
					},
					minlength: {
						param: 4,
						message: 'Please enter a minimum of 4 digits.'
					}
				}
			},
			sqAddress: {
				addressMoniker: {
					required: 'Please enter a valid address.'
				}
			},
			chooseIdentificationDocument: {
				passportNumber: {
					required: 'Passport number required',
					alpha_numeric: 'Please enter a valid passport number'
				},
				licenseNumber: {
					required: 'License number required',
					alpha_numeric: 'Please enter a valid license number'
				},
				stateOfIssue: {
					required: 'Please select state of issue'
				},
				countryOfIssue: {
					required: 'Please select country of issue'
				},
				medicareCardType: {
					required: 'Please select card type'
				},
				medicareCardNum: {
					required: 'Card number required',
					digits: 'Please enter a 10 digit card number',
					minlength: {
						param: 10,
						message: 'Please enter a 10 digits card number'
					},
					maxlength: {
						param: 10,
						message: 'Please enter a 10 digits card number'
					}
				},
				medicareCardIRN: {
					required: 'IRN number required',
					digits: 'Please enter a 1 digit IRN number',
					minlength: {
						param: 1,
						message: 'Please enter a 1 digit IRN number'
					},
					maxlength: {
						param: 1,
						message: 'Please enter a 1 digit IRN number'
					}
				},
				medicareNameOnCard: {
					required: 'Name on card required'
				},
				expiryDate: {
					isFutureDate: 'The expiry date must be in the future'
				},
				expiryYear: {
					required: 'Select the year of expiry'
				},
				expiryMonth: {
					required: 'Select the month of expiry'
				},
				expiryDay: {
					required: 'Select the day of expiry'
				},
				detailsToBeCheckedConfirmed: {
					ischecked: 'Please confirm you agree that your identification details will be checked.'
				}
			},
			occupation: {
				yearSelected: {
					required: 'Please select Year'
				},
				monthSelected: {
					required: 'Please select Month'
				},
				industryType: {
					required: 'Please select Industry type'
				},
				employmentStatus: {
					required: 'Please select Employment status'
				},
				employerName: {
					required: 'Employer name is required'
				},
				occupation: {
					required: 'Please select Occupation'
				}
			}
		},
		unbilledInstructionalMessage: {
			data: {
				'noTierText': 'You have used #UsedAmount form the allocated data #IncludedBaseAmount.',
				'0': {
					'startText': 'Just letting you know that <b>#UsedAmount</b> of your <b>#IncludedBaseAmount</b>' +
						' included data has been used. If you exceed #IncludedBaseAmount we\'ll' +
						' automatically give you an <b>extra #NextTierUpliftAmount for' +
						' $#NextierUpliftCharge</b>, to use this billing month.'
				},
				'1': {
					'startText': 'Your #IncludedBaseAmount included data has been exceeded and we\'ve' +
						' automatically given you an <b>extra #CurrentTierUpliftAmount for' +
						' $#CurrentTierUpliftCharge</b>, to use this billing month.',
					'bottomText': 'A total of <b>#UsedAmount</b> of your <b>#AllocatedData</b>' +
						' allocated data has been used' +
						'. If this <b>#AllocatedData</b> is exceeded we’ll automatically give you an' +
						' additional #NextTierUpliftAmount for' +
						' $#NextierUpliftCharge, to use this billing month.'
				},
				'2': {
					'startText': 'Your #PreviousAllocatedData allocated data has been exceeded and we' +
						' automatically gave you an <b>extra #CurrentTierUpliftAmount for' +
						' $#CurrentTierUpliftCharge</b>, to use this billing month.',
					'bottomText': 'A total of <b>#UsedAmount</b> of your <b>#AllocatedData</b>' +
						' allocated data has been used' +
						'. If this #AllocatedData is exceeded we’ll automatically give you an' +
						' additional #NextTierUpliftAmount for' +
						' $#NextierUpliftCharge, to use this billing month.'
				},
				'3': {
					'startText': '<p>Your #PreviousAllocatedData allocated data has been exceeded and we' +
						' automatically gave you an <b>extra #CurrentTierUpliftAmount for' +
						' $#CurrentTierUpliftCharge</b>, to use this billing month.</p>' +
						'<p>A total of <b>#UsedAmount</b> of your <b>#AllocatedData</b>' +
						' allocated data has been used' +
						'. If this #AllocatedData is exceeded we’ll automatically give you an' +
						' additional #NextTierUpliftAmount for' +
						' $#NextierUpliftCharge, to use this billing month,' +
						' after which we may restrict your data use for the rest of this billing month' +
						' or continue to charge you at $#NextierUpliftCharge per #NextTierUpliftAmount.</p>'
				},
				'4': {
					'startText': 'Your <b>#AllocatedData</b> allocated data has been exceeded and we automatically' +
						' gave you an <b>extra #CurrentTierUpliftAmount for $#CurrentTierUpliftCharge</b>' +
						' , to use this billing month. We may need to restrict your data use for the rest' +
						' of this billing month or continue to charge you at' +
						' $#NextierUpliftCharge per #NextTierUpliftAmount.'
				}
			},
			sharedData: {
				'noTierText': '#UsedAmount is used form the allocated shared data #IncludedBaseAmount.',
				'0': {
					'startText': 'Just letting you know that <b>#UsedAmount</b> of your <b>#IncludedBaseAmount</b>' +
						' included shared data has been used. If you exceed #IncludedBaseAmount we\'ll' +
						' automatically give you an <b>extra #NextTierUpliftAmount for' +
						' $#NextierUpliftCharge</b>, to use this billing month.'
				},
				'1': {
					'startText': 'Your #IncludedBaseAmount included shared data has been exceeded and we\'ve' +
						' automatically given you an <b>extra #CurrentTierUpliftAmount for' +
						' $#CurrentTierUpliftCharge</b>, to use this billing month.',
					'bottomText': 'A total of <b>#UsedAmount</b> of your <b>#AllocatedData</b>' +
						' allocated shared data has been used' +
						'. If this #AllocatedData is exceeded we’ll automatically give you an' +
						' additional #NextTierUpliftAmount for' +
						' $#NextierUpliftCharge, to use this billing month.'
				},
				'2': {
					'startText': 'Your #PreviousAllocatedData allocated shared data has been exceeded and we' +
						' automatically gave you an <b>extra #CurrentTierUpliftAmount for' +
						' $#CurrentTierUpliftCharge</b>, to use this billing month.',
					'bottomText': 'A total of <b>#UsedAmount</b> of your <b>#AllocatedData</b>' +
						' allocated shared data has been used' +
						'. If this #AllocatedData is exceeded we’ll automatically give you an' +
						' additional #NextTierUpliftAmount for' +
						' $#NextierUpliftCharge, to use this billing month.'
				},
				'3': {
					'startText': '<p>Your #PreviousAllocatedData allocated shared data has been exceeded and we' +
						' automatically gave you an <b>extra #CurrentTierUpliftAmount for' +
						' $#CurrentTierUpliftCharge</b>, to use this billing month.</p>' +
						'<p>A total of <b>#UsedAmount</b> of your <b>#AllocatedData</b>' +
						' allocated shared data has been used' +
						'. If this #AllocatedData is exceeded we’ll automatically give you an' +
						' additional #NextTierUpliftAmount for' +
						' $#NextierUpliftCharge, to use this billing month,' +
						' after which we may restrict your data use for the rest of this billing month' +
						' or continue to charge you at $#NextierUpliftCharge per #NextTierUpliftAmount.</p>'
				},
				'4': {
					'startText': 'Your <b>#AllocatedData</b> allocated shared data has been exceeded' +
						' and we automatically' +
						' gave you an extra #CurrentTierUpliftAmount for $#CurrentTierUpliftCharge' +
						' , to use this billing month. We may need to restrict your data use for the rest' +
						' of this billing month or continue to charge you at' +
						' $#NextierUpliftCharge per #NextTierUpliftAmount.'
				}
			},
			voiceData: {
				'baseUnlimited': 'The following is unlimited on your plan: standard national ' +
					'voice calls to Optus and other Australian mobiles; standard national voice ' +
					'calls to fixed lines; national diversions; calls to 13/1300 numbers; calls ' +
					'to 1800 numbers; voicemail diversions, deposits and retrievals.',
				'0': {
					'startText': 'Just letting you know that <b>#usedMin</b> of your <b>#allocatedMins</b> included ' +
						'minutes has been used. If you exceed #allocatedMins min we’ll automatically' +
						' give you an <b>extra #nextTierAmount min for' +
						' $#nextTierCharge</b>, for this billing month.',
					'unlimitedText': 'Just letting you know that <b>#usedMin</b> of your <b>#allocatedMins</b> ' +
						'included minutes has been used. If this #allocatedMins min is exceeded we’ll automatically' +
						' give you unlimited minutes for' +
						' $#nextTierCharge, for this billing month.'
				},
				'1': {
					'startText': 'Your #previousAllocatedMin included minutes have been exceeded and we' +
					' automatically gave you an <b>extra #previousAddedMin min for $#previousAddedCharge</b>,' +
					' to use this billing month.',
					'bottomText': 'A total of <b>#usedMin</b> of your <b>#allocatedMins</b> allocated minutes have' +
					' been used. If this #allocatedMins min is exceeded we’ll automatically give you an additional' +
					' #nextTierAmount minutes for $#nextTierCharge, for this billing month.',
					'unlimitedText': 'A total of <b>#usedMin</b> of your <b>#allocatedMins</b> allocated minutes have' +
					' been used. If this #allocatedMins min is exceeded we’ll automatically give unlimited minutes for' +
					' $#nextTierCharge, for this billing month.'
				},
				'2': {
					'startText': 'Your #previousAllocatedMin allocated minutes have been exceeded and we' +
					' automatically gave you an <b>extra #previousAddedMin min for $#previousAddedCharge</b>,' +
					' to use this billing month.',
					'bottomText': 'A total of <b>#usedMin</b> of your <b>#allocatedMins</b> allocated minutes have ' +
					' been used. If this #allocatedMins min is exceeded we’ll automatically give you an additional' +
					' #nextTierAmount minutes for $#nextTierCharge, for this billing month.',
					'unlimitedText': 'A total of <b>#usedMin</b> of your <b>#allocatedMins</b> allocated minutes have' +
					' been used. If this #allocatedMins min is exceeded we’ll automatically give unlimited minutes for' +
					' $#nextTierCharge, for this billing month.'
				},
				'unlimitedReached': 'Your #previousAllocatedMin allocated minutes have been exceeded and we’ve' +
					' automatically given you <b>unlimited minutes for $#previousAddedCharge</b>, for this' +
					' billing month.'
			}
		},
		addressStateTypeSelectOptions: [
			{value: '', text: 'Select'},
			{value: 'ACT', text: 'ACT'},
			{value: 'NSW', text: 'NSW'},
			{value: 'NT', text: 'NT'},
			{value: 'QLD', text: 'QLD'},
			{value: 'SA', text: 'SA'},
			{value: 'TAS', text: 'TAS'},
			{value: 'VIC', text: 'VIC'},
			{value: 'WA', text: 'WA'}
		],

		addressStreetTypeSelectOptions: [
			{
				groupLabel: 'select',
				items: [
					{value: '', text: 'Select'},
					{value: 'Avenue', text: 'Avenue'},
					{value: 'Close', text: 'Close'},
					{value: 'Court', text: 'Court'},
					{value: 'Crescent', text: 'Crescent'},
					{value: 'Drive', text: 'Drive'},
					{value: 'Parade', text: 'Parade'},
					{value: 'Place', text: 'Place'},
					{value: 'Road', text: 'Road'},
					{value: 'Street', text: 'Street'},
					{value: 'No Street Type', text: 'No Street Type'}
				]
			},
			{
				groupLabel: '---------------------------',
				items: [
					{value: 'Access', text: 'Access'},
					{value: 'Alley', text: 'Alley'},
					{value: 'Alleyway', text: 'Alleyway'},
					{value: 'Amble', text: 'Amble'},
					{value: 'Anchorage', text: 'Anchorage'},
					{value: 'Approach', text: 'Approach'},
					{value: 'Arcade', text: 'Arcade'},
					{value: 'Arterial', text: 'Arterial'},
					{value: 'Artery', text: 'Artery'},
					{value: 'Banan', text: 'Banan'},
					{value: 'Bank', text: 'Bank'},
					{value: 'Barracks', text: 'Barracks'},
					{value: 'Basin', text: 'Basin'},
					{value: 'Bay', text: 'Bay'},
					{value: 'Beach', text: 'Beach'},
					{value: 'Bend', text: 'Bend'},
					{value: 'Block', text: 'Block'},
					{value: 'Boardwalk', text: 'Boardwalk'},
					{value: 'Boulevard', text: 'Boulevard'},
					{value: 'Boundary', text: 'Boundary'},
					{value: 'Bowl', text: 'Bowl'},
					{value: 'Brace', text: 'Brace'},
					{value: 'Brae', text: 'Brae'},
					{value: 'Branch', text: 'Branch'},
					{value: 'Break', text: 'Break'},
					{value: 'Bridge', text: 'Bridge'},
					{value: 'Broadway', text: 'Broadway'},
					{value: 'Brow', text: 'Brow'},
					{value: 'Building', text: 'Building'},
					{value: 'Bypass', text: 'Bypass'},
					{value: 'Byway', text: 'Byway'},
					{value: 'Causeway', text: 'Causeway'},
					{value: 'Centre', text: 'Centre'},
					{value: 'Centreway', text: 'Centreway'},
					{value: 'Chambers', text: 'Chambers'},
					{value: 'Chase', text: 'Chase'},
					{value: 'Circle', text: 'Circle'},
					{value: 'Circlet', text: 'Circlet'},
					{value: 'Circuit', text: 'Circuit'},
					{value: 'Circus', text: 'Circus'},
					{value: 'Colonnade', text: 'Colonnade'},
					{value: 'Common', text: 'Common'},
					{value: 'Community', text: 'Community'},
					{value: 'Complex', text: 'Complex'},
					{value: 'Concourse', text: 'Concourse'},
					{value: 'Connection', text: 'Connection'},
					{value: 'Copse', text: 'Copse'},
					{value: 'Corner', text: 'Corner'},
					{value: 'Corso', text: 'Corso'},
					{value: 'Course', text: 'Course'},
					{value: 'Courtyard', text: 'Courtyard'},
					{value: 'Cove', text: 'Cove'},
					{value: 'Creek', text: 'Creek'},
					{value: 'Crest', text: 'Crest'},
					{value: 'Crief', text: 'Crief'},
					{value: 'Cross', text: 'Cross'},
					{value: 'Crossing', text: 'Crossing'},
					{value: 'Crossroad', text: 'Crossroad'},
					{value: 'Crossway', text: 'Crossway'},
					{value: 'Cruiseway', text: 'Cruiseway'},
					{value: 'Cul de sac', text: 'Cul de sac'},
					{value: 'Cul-de-sac', text: 'Cul-de-sac'},
					{value: 'Cutting', text: 'Cutting'},
					{value: 'Dale', text: 'Dale'},
					{value: 'Dell', text: 'Dell'},
					{value: 'Deviation', text: 'Deviation'},
					{value: 'Dip', text: 'Dip'},
					{value: 'Distributor', text: 'Distributor'},
					{value: 'Downs', text: 'Downs'},
					{value: 'Driveway', text: 'Driveway'},
					{value: 'Easement', text: 'Easement'},
					{value: 'Edge', text: 'Edge'},
					{value: 'Elbow', text: 'Elbow'},
					{value: 'End', text: 'End'},
					{value: 'Entrance', text: 'Entrance'},
					{value: 'Esplanade', text: 'Esplanade'},
					{value: 'Establishment', text: 'Establishment'},
					{value: 'Estate', text: 'Estate'},
					{value: 'Expressway', text: 'Expressway'},
					{value: 'Fair', text: 'Fair'},
					{value: 'Fairway', text: 'Fairway'},
					{value: 'Firetrack', text: 'Firetrack'},
					{value: 'Firetrail', text: 'Firetrail'},
					{value: 'Flat', text: 'Flat'},
					{value: 'Follow', text: 'Follow'},
					{value: 'Footway', text: 'Footway'},
					{value: 'Foreshore', text: 'Foreshore'},
					{value: 'Formation', text: 'Formation'},
					{value: 'Freeway', text: 'Freeway'},
					{value: 'Front', text: 'Front'},
					{value: 'Frontage', text: 'Frontage'},
					{value: 'Gap', text: 'Gap'},
					{value: 'Garden', text: 'Garden'},
					{value: 'Gardens', text: 'Gardens'},
					{value: 'Gate', text: 'Gate'},
					{value: 'Gates', text: 'Gates'},
					{value: 'Gateway', text: 'Gateway'},
					{value: 'Glade', text: 'Glade'},
					{value: 'Glen', text: 'Glen'},
					{value: 'Grange', text: 'Grange'},
					{value: 'Green', text: 'Green'},
					{value: 'Ground', text: 'Ground'},
					{value: 'Grove', text: 'Grove'},
					{value: 'Gully', text: 'Gully'},
					{value: 'Heath', text: 'Heath'},
					{value: 'Heights', text: 'Heights'},
					{value: 'Highroad', text: 'Highroad'},
					{value: 'Highway', text: 'Highway'},
					{value: 'Hill', text: 'Hill'},
					{value: 'Hillside', text: 'Hillside'},
					{value: 'Home', text: 'Home'},
					{value: 'Homes', text: 'Homes'},
					{value: 'House', text: 'House'},
					{value: 'Interchange', text: 'Interchange'},
					{value: 'Intersection', text: 'Intersection'},
					{value: 'Island', text: 'Island'},
					{value: 'Junction', text: 'Junction'},
					{value: 'Key', text: 'Key'},
					{value: 'Knoll', text: 'Knoll'},
					{value: 'Landing', text: 'Landing'},
					{value: 'Lane', text: 'Lane'},
					{value: 'Laneway', text: 'Laneway'},
					{value: 'Lees', text: 'Lees'},
					{value: 'Level', text: 'Level'},
					{value: 'Line', text: 'Line'},
					{value: 'Link', text: 'Link'},
					{value: 'Little', text: 'Little'},
					{value: 'Location', text: 'Location'},
					{value: 'Lookout', text: 'Lookout'},
					{value: 'Loop', text: 'Loop'},
					{value: 'Mall', text: 'Mall'},
					{value: 'Market', text: 'Market'},
					{value: 'Marketland', text: 'Marketland'},
					{value: 'Marketown', text: 'Marketown'},
					{value: 'Meander', text: 'Meander'},
					{value: 'Mew', text: 'Mew'},
					{value: 'Mews', text: 'Mews'},
					{value: 'Motorway', text: 'Motorway'},
					{value: 'Mount', text: 'Mount'},
					{value: 'Mountain', text: 'Mountain'},
					{value: 'New', text: 'New'},
					{value: 'Nook', text: 'Nook'},
					{value: 'Outlook', text: 'Outlook'},
					{value: 'Oval', text: 'Oval'},
					{value: 'Paradise', text: 'Paradise'},
					{value: 'Park', text: 'Park'},
					{value: 'Parklands', text: 'Parklands'},
					{value: 'Parkway', text: 'Parkway'},
					{value: 'Part', text: 'Part'},
					{value: 'Pass', text: 'Pass'},
					{value: 'Passage', text: 'Passage'},
					{value: 'Path', text: 'Path'},
					{value: 'Pathway', text: 'Pathway'},
					{value: 'Peninsula', text: 'Peninsula'},
					{value: 'Piazza', text: 'Piazza'},
					{value: 'Pier', text: 'Pier'},
					{value: 'Plateau', text: 'Plateau'},
					{value: 'Plaza', text: 'Plaza'},
					{value: 'Pocket', text: 'Pocket'},
					{value: 'Point', text: 'Point'},
					{value: 'Port', text: 'Port'},
					{value: 'Promenade', text: 'Promenade'},
					{value: 'Pursuit', text: 'Pursuit'},
					{value: 'Quad', text: 'Quad'},
					{value: 'Quadrangle', text: 'Quadrangle'},
					{value: 'Quadrant', text: 'Quadrant'},
					{value: 'Quay', text: 'Quay'},
					{value: 'Quays', text: 'Quays'},
					{value: 'Racecourse', text: 'Racecourse'},
					{value: 'Railway Siding', text: 'Railway Siding'},
					{value: 'Ramble', text: 'Ramble'},
					{value: 'Ramp', text: 'Ramp'},
					{value: 'Range', text: 'Range'},
					{value: 'Reach', text: 'Reach'},
					{value: 'Reserve', text: 'Reserve'},
					{value: 'Rest', text: 'Rest'},
					{value: 'Retreat', text: 'Retreat'},
					{value: 'Return', text: 'Return'},
					{value: 'Ride', text: 'Ride'},
					{value: 'Ridge', text: 'Ridge'},
					{value: 'Ridgeway', text: 'Ridgeway'},
					{value: 'Right of Way', text: 'Right of Way'},
					{value: 'Ring', text: 'Ring'},
					{value: 'Rise', text: 'Rise'},
					{value: 'River', text: 'River'},
					{value: 'Riverway', text: 'Riverway'},
					{value: 'Riviera', text: 'Riviera'},
					{value: 'Roads', text: 'Roads'},
					{value: 'Roadside', text: 'Roadside'},
					{value: 'Roadway', text: 'Roadway'},
					{value: 'Ronde', text: 'Ronde'},
					{value: 'Rosebowl', text: 'Rosebowl'},
					{value: 'Rotary', text: 'Rotary'},
					{value: 'Round', text: 'Round'},
					{value: 'Route', text: 'Route'},
					{value: 'Row', text: 'Row'},
					{value: 'Rowe', text: 'Rowe'},
					{value: 'Rue', text: 'Rue'},
					{value: 'Run', text: 'Run'},
					{value: 'Section', text: 'Section'},
					{value: 'Service Way', text: 'Service Way'},
					{value: 'Serviceway', text: 'Serviceway'},
					{value: 'Shunt', text: 'Shunt'},
					{value: 'Siding', text: 'Siding'},
					{value: 'Slope', text: 'Slope'},
					{value: 'Sound', text: 'Sound'},
					{value: 'Spur', text: 'Spur'},
					{value: 'Square', text: 'Square'},
					{value: 'Stairs', text: 'Stairs'},
					{value: 'State Highway', text: 'State Highway'},
					{value: 'Station', text: 'Station'},
					{value: 'Steps', text: 'Steps'},
					{value: 'Straight', text: 'Straight'},
					{value: 'Strand', text: 'Strand'},
					{value: 'Strip', text: 'Strip'},
					{value: 'Subway', text: 'Subway'},
					{value: 'Tarn', text: 'Tarn'},
					{value: 'Terrace', text: 'Terrace'},
					{value: 'Thoroughfare', text: 'Thoroughfare'},
					{value: 'Tollway', text: 'Tollway'},
					{value: 'Top', text: 'Top'},
					{value: 'Tor', text: 'Tor'},
					{value: 'Tower', text: 'Tower'},
					{value: 'Towers', text: 'Towers'},
					{value: 'Track', text: 'Track'},
					{value: 'Trail', text: 'Trail'},
					{value: 'Trailer', text: 'Trailer'},
					{value: 'Triangle', text: 'Triangle'},
					{value: 'Trunkway', text: 'Trunkway'},
					{value: 'Turn', text: 'Turn'},
					{value: 'Underpass', text: 'Underpass'},
					{value: 'Vale', text: 'Vale'},
					{value: 'Valley', text: 'Valley'},
					{value: 'Viaduct', text: 'Viaduct'},
					{value: 'View', text: 'View'},
					{value: 'Village', text: 'Village'},
					{value: 'Villas', text: 'Villas'},
					{value: 'Vista', text: 'Vista'},
					{value: 'Wade', text: 'Wade'},
					{value: 'Walk', text: 'Walk'},
					{value: 'Walkway', text: 'Walkway'},
					{value: 'Waters', text: 'Waters'},
					{value: 'Way', text: 'Way'},
					{value: 'Wharf', text: 'Wharf'},
					{value: 'Wood', text: 'Wood'},
					{value: 'Wynd', text: 'Wynd'},
					{value: 'Yard', text: 'Yard'}
				]
			}
		],
		usageMeterColourCss: {
			green: '',
			red: 'maximum',
			orange: 'warning'
		},

		setEmailLoginMessages: {
			emailNotAvailable: 'The email you have provided is already in use. Please use a different email address.',
			maxAttempt: 'You have exceeded the maximum number of attempts available at this time. ' +
			'Please try again in 24 hours in the \'Profile\' section of My Account.',
			generic: 'Due to an error we have been unable to switch you to email login. ' +
			'You can try again later by going to the \'Profile\' section of My Account.'
		},
		apiGenericError: 'Something went wrong on our side. Please try again later.',
		maxChildError: 'Maximum Shared Line Reached for this selection.',
		phoneUsageDetails: {
			on: 'On',
			all: 'All',
			voice: 'Voice',
			data: 'Data',
			sms: 'SMS',
			text: 'Text'
		},
		oneTimePassword: {
			textPartOne: 'Account for email',
			textPartTwo: 'A passcode has been sent to mobile ending'
		},
		'technologyConfig': {
			'DEL': {
				'title': 'Analog'
			},
			'HDL': {
				'title': 'Home Digital Line'
			}
		},
		changePasswordCase: {
			'0': 'Success',
			'1': 'User Doesnt  exist.',
			'2': 'Oops… that password is incorrect. Please try again.',
			'3': 'You have entered invalid password length.',
			'4': 'Maximum attempts limit reached, please try after sometime.',
			'5': 'Old and new password cannot be same.',
			'error': 'Something went wrong on our side. Please try again later.'
		},
		dealerID: 'D2519',
		vendorID: 'T0001',
		dealerIDErrorMsg: 'Please select the Dealer Code',
		dealerCodeOptions: [
			{'title': 'SERV@OC', 'value': 'D1021', 'vendorID': 'VFDO' },
			{'title': 'SERV@Ubi', 'value': 'D1022', 'vendorID': 'VFDO' },
			{'title': 'SERV@WDL', 'value': 'D1026', 'vendorID': 'VFDO' }
		],
		singtelInstallationMessage: { //to move in AEM later
			'priceMessage': 'will be added to your first month bill',
			'shouldBeAtHome': 'You should be at home during installation.',
			'installationMessage': 'Week Day $90.00, Weekend $135.00 will be charged to your first month bill'
		},
		singtelLobs: {
			'mobile': ['Mobile', 'MOB', 'WS'],
			'tv': ['TV', 'FEB'],
			'fibre': ['FEB', 'FHB', 'BB']
		},
		singtelFixedLineLobs: ['TV', 'FEB', 'FHB', 'BB', 'IN', 'BP', 'FEBP', 'FV', 'FBB'],
		singtelPlanSpecs: {
			palnSpecsAttributes: {
				data: {
					paramName: 'Local Data',
					catalogItemId: '9213302',
					title: 'Data'
				},
				voice: {
					paramName: 'Talktime',
					catalogItemId: '9213282',
					title: 'Talktime'
				},
				sms: {
					paramName: 'SMS/MMS',
					catalogItemId: '9213292',
					title: 'Local SMS/MMS'
				},
				wifi: {
					paramName: 'Singtel Wifi',
					catalogItemId: '9213382',
					title: 'Singtel WiFi Data'
				}
			},
			easyMobPalnSpecsAttributes: {
				data: {
					paramName: 'Number of Data Units',
					catalogItemId: '8212',
					title: 'Data Units'
				},
				voice: {
					paramName: 'Number of Voice Units',
					catalogItemId: '8192',
					title: 'Voice Units'
				},
				sms: {
					paramName: 'Number of SMS Units',
					catalogItemId: '8202',
					title: 'SMS Units'
				},
				wifi: {
					paramName: 'Singtel Wifi',
					catalogItemId: '9213382',
					title: 'Singtel WiFi Data'
				}
			}
		},
		pdpa: {
			mobileAppCode: 'mobileApp',
			resourceCode: 'EMP',
			resourceType: 'E123456',
			heading: 'Our apologies.',
			errorMessage: 'We are sorry Something went wrong, please try later or call 1688',
			yesToAllConsentCheckboxLabel: 'Apply yes to all'
		},
		userRegStatus: {
			title: 'User Registration',
			description: 'You have notlogged in previously so we have sent an email to '
		},
		serviceResumeCharges: 21.40,
		serviceSuspendCharges: 0.00,
		avayaOffset: 3,
		physicalAddressValues: {
			'country' : 'SGP',
			'state': 'SNG',
			'city': 'Singapore',
			'countryCode1': 'Singapore',
			'countryCode2': '65',
			'SNG': 'Singapore'
		},
		defaultAccountNickName: 'Account Name',
		mobileWidth: 800,
		topupPlanOptions: [
			{
				'title': 'easyAccount Monthly hi!Card $10',
				'value': 'easyAccount Monthly hi!Card $10',
				'code': '50000005:G1',
				'monthlyRecurring': 'Y',
				'opId': '50000005',
				'planId': 'G1',
				'type': 'Mobile',
				'chargedAgainst': 'Mobile'
			},
			{
				'title': 'easyAccount Monthly BigHot$130',
				'value': 'easyAccount Monthly BigHot$130',
				'code': '50000005:G11',
				'monthlyRecurring': 'Y',
				'opId': '50000005',
				'planId': 'G11',
				'type': 'Mobile',
				'chargedAgainst': 'Mobile'
			},
			{
				'title': 'easyAccount Monthly hi!Card $20',
				'value': 'easyAccount Monthly hi!Card $20',
				'code': '50000005:G2',
				'monthlyRecurring': 'Y',
				'opId': '50000005',
				'planId': 'G2',
				'type': 'Mobile',
				'chargedAgainst': 'Mobile'
			},
			{
				'title': 'easyAccount Monthly hi!Card $50',
				'value': 'easyAccount Monthly hi!Card $50',
				'code': '50000005:G3',
				'monthlyRecurring': 'Y',
				'opId': '50000005',
				'planId': 'G3',
				'type': 'Mobile',
				'chargedAgainst': 'Mobile'
			},
			{
				'title': 'easyAccount Monthly HOT$128',
				'value': 'easyAccount Monthly HOT$128',
				'code': '50000005:G4',
				'monthlyRecurring': 'Y',
				'opId': '50000005',
				'planId': 'G4',
				'type': 'Mobile',
				'chargedAgainst': 'Mobile'
			},
			{
				'title': 'easyAccount Monthly HOT$55',
				'value': 'easyAccount Monthly HOT$55',
				'code': '50000005:G5',
				'monthlyRecurring': 'Y',
				'opId': '50000005',
				'planId': 'G5',
				'type': 'Mobile',
				'chargedAgainst': 'Mobile'
			},
			{
				'title': 'easyAccount hi!Card $10',
				'value': 'easyAccount hi!Card $10',
				'code': '50000005:G6',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'G6',
				'type': 'Mobile',
				'chargedAgainst': 'Mobile'
			},
			{
				'title': 'easyAccount hi!Card $20',
				'value': 'easyAccount hi!Card $20',
				'code': '50000005:G7',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'G7',
				'type': 'Mobile',
				'chargedAgainst': 'Mobile'
			},
			{
				'title': 'easyAccount hi!Card $50',
				'value': 'easyAccount hi!Card $50',
				'code': '50000005:G8',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'G8',
				'type': 'Mobile',
				'chargedAgainst': 'Mobile'
			},
			{
				'title': 'easyAccount YO! $18',
				'value': 'easyAccount YO! $18',
				'code': '50000005:G9-DELETED',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'G9',
				'type': 'Mobile',
				'chargedAgainst': 'Mobile'
			},
			{
				'title': 'easyAccount Monthly hi!Card $10',
				'value': 'easyAccount Monthly hi!Card $10',
				'code': '50000005:R1',
				'monthlyRecurring': 'Y',
				'opId': '50000005',
				'planId': 'R1',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount Monthly BigHot$130',
				'value': 'easyAccount Monthly BigHot$130',
				'code': '50000005:R11',
				'monthlyRecurring': 'Y',
				'opId': '50000005',
				'planId': 'R11',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount Monthly hi!Card $20',
				'value': 'easyAccount Monthly hi!Card $20',
				'code': '50000005:R2',
				'monthlyRecurring': 'Y',
				'opId': '50000005',
				'planId': 'R2',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount Monthly hi!Card $50',
				'value': 'easyAccount Monthly hi!Card $50',
				'code': '50000005:R3',
				'monthlyRecurring': 'Y',
				'opId': '50000005',
				'planId': 'R3',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount Monthly HOT$128',
				'value': 'easyAccount Monthly HOT$128',
				'code': '50000005:R4',
				'monthlyRecurring': 'Y',
				'opId': '50000005',
				'planId': 'R4',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount Monthly HOT$55',
				'value': 'easyAccount Monthly HOT$55',
				'code': '50000005:R5',
				'monthlyRecurring': 'Y',
				'opId': '50000005',
				'planId': 'R5',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount hi!Card $10',
				'value': 'easyAccount hi!Card $10',
				'code': '50000005:R6',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'R6',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount hi!Card $20',
				'value': 'easyAccount hi!Card $20',
				'code': '50000005:R7',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'R7',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount hi!Card $50',
				'value': 'easyAccount hi!Card $50',
				'code': '50000005:R8',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'R8',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount YO! $18',
				'value': 'easyAccount YO! $18',
				'code': '50000005:R9-DELETED',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'R9',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': '7-Day 10MB Plan',
				'value': '7-Day 10MB Plan',
				'code': '50000005:H1',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H1',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '1-Day Ultimate 2GB Plan',
				'value': '1-Day Ultimate 2GB Plan',
				'code': '50000005:H12',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H12',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '3-Day Ultimate 6GB Plan',
				'value': '3-Day Ultimate 6GB Plan',
				'code': '50000005:H13',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H13',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day Ultimate 15GB Plan',
				'value': '7-Day Ultimate 15GB Plan',
				'code': '50000005:H14',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H14',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day 1GB Plan',
				'value': '30-Day 1GB Plan',
				'code': '50000005:H18',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H18',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day 3GB Plan',
				'value': '30-Day 3GB Plan',
				'code': '50000005:H19',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H19',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day 1GB Plan',
				'value': '7-Day 1GB Plan',
				'code': '50000005:H2',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H2',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day 5GB Plan',
				'value': '30-Day 5GB Plan',
				'code': '50000005:H20',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H20',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '1-Day WhatsApp Plan',
				'value': '1-Day WhatsApp Plan',
				'code': '50000005:H21',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H21',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day WhatsApp Plan',
				'value': '7-Day WhatsApp Plan',
				'code': '50000005:H22',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H22',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day WhatsApp Plan',
				'value': '30-Day WhatsApp Plan',
				'code': '50000005:H23',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H23',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '1-Day Facebook Plan',
				'value': '1-Day Facebook Plan',
				'code': '50000005:H27',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H27',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day Facebook Plan',
				'value': '7-Day Facebook Plan',
				'code': '50000005:H28',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H28',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day Facebook Plan',
				'value': '30-Day Facebook Plan',
				'code': '50000005:H29',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H29',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '1-Day WeChat Plan',
				'value': '1-Day WeChat Plan',
				'code': '50000005:H34',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H34',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day WeChat Plan',
				'value': '7-Day WeChat Plan',
				'code': '50000005:H35',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H35',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day WeChat Plan',
				'value': '30-Day WeChat Plan',
				'code': '50000005:H36',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H36',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '1-Day LINE Plan',
				'value': '1-Day LINE Plan',
				'code': '50000005:H37',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H37',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day LINE Plan',
				'value': '7-Day LINE Plan',
				'code': '50000005:H38',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H38',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day LINE Plan',
				'value': '30-Day LINE Plan',
				'code': '50000005:H39',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H39',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'Topup $5',
				'value': 'Topup $5',
				'code': '50000005:Z0',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'Z0',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'easyAccount HOT$128',
				'value': 'easyAccount HOT$128',
				'code': '50000005:Z11',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'Z11',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'easyAccount Bonus$30',
				'value': 'easyAccount Bonus$30',
				'code': '50000005:Z12',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'Z12',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'easyAccount HOT$55',
				'value': 'easyAccount HOT$55',
				'code': '50000005:Z13',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'Z13',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'DataTalk$22',
				'value': 'DataTalk$22',
				'code': '50000005:Z14',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'Z14',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'easyAccount BigHot$130',
				'value': 'easyAccount BigHot$130',
				'code': '50000005:Z19',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'Z19',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'easyAccount Monthly hi!Card $10',
				'value': 'easyAccount Monthly hi!Card $10',
				'code': '50000006:R1',
				'monthlyRecurring': 'Y',
				'opId': '50000006',
				'planId': 'R1',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount Monthly BigHot$130',
				'value': 'easyAccount Monthly BigHot$130',
				'code': '50000006:R11',
				'monthlyRecurring': 'Y',
				'opId': '50000006',
				'planId': 'R11',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount Monthly hi!Card $20',
				'value': 'easyAccount Monthly hi!Card $20',
				'code': '50000006:R2',
				'monthlyRecurring': 'Y',
				'opId': '50000006',
				'planId': 'R2',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount Monthly hi!Card $50',
				'value': 'easyAccount Monthly hi!Card $50',
				'code': '50000006:R3',
				'monthlyRecurring': 'Y',
				'opId': '50000006',
				'planId': 'R3',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount Monthly HOT$128',
				'value': 'easyAccount Monthly HOT$128',
				'code': '50000006:R4',
				'monthlyRecurring': 'Y',
				'opId': '50000006',
				'planId': 'R4',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount Monthly HOT$55',
				'value': 'easyAccount Monthly HOT$55',
				'code': '50000006:R5',
				'monthlyRecurring': 'Y',
				'opId': '50000006',
				'planId': 'R5',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount hi!Card $10',
				'value': 'easyAccount hi!Card $10',
				'code': '50000006:R6',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'R6',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount hi!Card $20',
				'value': 'easyAccount hi!Card $20',
				'code': '50000006:R7',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'R7',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount hi!Card $50',
				'value': 'easyAccount hi!Card $50',
				'code': '50000006:R8',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'R8',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': 'easyAccount YO! $18',
				'value': 'easyAccount YO! $18',
				'code': '50000006:R9-DELETED',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'R9',
				'type': 'Mobile',
				'chargedAgainst': 'DEL'
			},
			{
				'title': '7-Day 10MB Plan',
				'value': '7-Day 10MB Plan',
				'code': '50000006:H1',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H1',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '1-Day Ultimate 2GB Plan',
				'value': '1-Day Ultimate 2GB Plan',
				'code': '50000006:H12',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H12',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '3-Day Ultimate 6GB Plan',
				'value': '3-Day Ultimate 6GB Plan',
				'code': '50000006:H13',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H13',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day Ultimate 15GB Plan',
				'value': '7-Day Ultimate 15GB Plan',
				'code': '50000006:H14',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H14',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day 1GB Plan',
				'value': '30-Day 1GB Plan',
				'code': '50000006:H18',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H18',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day 3GB Plan',
				'value': '30-Day 3GB Plan',
				'code': '50000006:H19',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H19',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day 1GB Plan',
				'value': '7-Day 1GB Plan',
				'code': '50000006:H2',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H2',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day 5GB Plan',
				'value': '30-Day 5GB Plan',
				'code': '50000006:H20',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H20',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '1-Day WhatsApp Plan',
				'value': '1-Day WhatsApp Plan',
				'code': '50000006:H21',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H21',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day WhatsApp Plan',
				'value': '7-Day WhatsApp Plan',
				'code': '50000006:H22',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H22',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day WhatsApp Plan',
				'value': '30-Day WhatsApp Plan',
				'code': '50000006:H23',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H23',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '1-Day Facebook Plan',
				'value': '1-Day Facebook Plan',
				'code': '50000006:H27',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H27',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day Facebook Plan',
				'value': '7-Day Facebook Plan',
				'code': '50000006:H28',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H28',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day Facebook Plan',
				'value': '30-Day Facebook Plan',
				'code': '50000006:H29',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H29',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '1-Day WeChat Plan',
				'value': '1-Day WeChat Plan',
				'code': '50000006:H34',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H34',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day WeChat Plan',
				'value': '7-Day WeChat Plan',
				'code': '50000006:H35',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H35',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day WeChat Plan',
				'value': '30-Day WeChat Plan',
				'code': '50000006:H36',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H36',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '1-Day LINE Plan',
				'value': '1-Day LINE Plan',
				'code': '50000006:H37',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H37',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day LINE Plan',
				'value': '7-Day LINE Plan',
				'code': '50000006:H38',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H38',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day LINE Plan',
				'value': '30-Day LINE Plan',
				'code': '50000006:H39',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H39',
				'type': 'Social',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'Topup $5',
				'value': 'Topup $5',
				'code': '50000006:Z0',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'Z0',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'easyAccount HOT$128',
				'value': 'easyAccount HOT$128',
				'code': '50000006:Z11',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'Z11',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'easyAccount Bonus$30',
				'value': 'easyAccount Bonus$30',
				'code': '50000006:Z12',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'Z12',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'easyAccount HOT$55',
				'value': 'easyAccount HOT$55',
				'code': '50000006:Z13',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'Z13',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'DataTalk$22',
				'value': 'DataTalk$22',
				'code': '50000006:Z14',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'Z14',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'easyAccount BigHot$130',
				'value': 'easyAccount BigHot$130',
				'code': '50000006:Z19',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'Z19',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day 100MB Plan',
				'value': '7-Day 100MB Plan',
				'code': '50000005:H48',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'H48',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day 100MB Plan',
				'value': '7-Day 100MB Plan',
				'code': '50000006:H48',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'H48',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day 1.5GB $10 Value+ Plan',
				'value': '7-Day 1.5GB $10 Value+ Plan',
				'code': '50000005:881',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': '881',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '7-Day 1.5GB $10 Value+ Plan',
				'value': '7-Day 1.5GB $10 Value+ Plan',
				'code': '50000006:881',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': '881',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day 1.5GB $13 Value+ Plan',
				'value': '30-Day 1.5GB $13 Value+ Plan',
				'code': '50000005:882',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': '882',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day 1.5GB $13 Value+ Plan',
				'value': '30-Day 1.5GB $13 Value+ Plan',
				'code': '50000006:882',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': '882',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day 4GB $25 Value+ Plan',
				'value': '30-Day 4GB $25 Value+ Plan',
				'code': '50000005:883',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': '883',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': '30-Day 4GB $25 Value+ Plan',
				'value': '30-Day 4GB $25 Value+ Plan',
				'code': '50000006:883',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': '883',
				'type': 'Data',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'easyAccount LocalSaver$18',
				'value': 'easyAccount LocalSaver$18',
				'code': '50000005:Z21',
				'monthlyRecurring': 'N',
				'opId': '50000005',
				'planId': 'Z21',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			},
			{
				'title': 'easyAccount LocalSaver$18',
				'value': 'easyAccount LocalSaver$18',
				'code': '50000006:Z21',
				'monthlyRecurring': 'N',
				'opId': '50000006',
				'planId': 'Z21',
				'type': 'Mobile',
				'chargedAgainst': 'Both'
			}
		],
		templates: {
			paymentTemplateId: 'impl.unsuccessful.credit.card.payment',
			paymentThirdPartyTemplateId: 'impl.unsuccessful.third.party.credit.card.payment',
			s6TemplateId: 'impl.fibre.support.template',
			s2TemplateId: 'impl.fibre.crc.template',
			consolidateAccount: 'impl.consolidate.accounts.pattern',
			paperBillTemplate: 'impl.get.hard.copy.bill.pattern.r11',
			orderConfirmationSuccessTemplateId: 'orderConfirmationSuccessTemplateId',
			orderConfirmationFailureTemplateId: 'orderConfirmationFailureTemplateId',
			recontractFailTemplateId : 'impl.fibre.crc.template', //need to change once we get actual template
			febTemplateId : 'impl.fibre.crc.template',//need to change once we get actual template
			blockUserTemplateId: 'impl.fibre.crc.template',//need to change once we get actual template
			crcTemplateId: 'impl.fibre.crc.customer.template',
			roiTemplate: 'impl.fibre.crc.template'//to change later
		},
		emailIds: {
			s6EmailId: 'g-eshoptemp@singtel.com',
			s2EmailId: 'g-eshoptemp@singtel.com',
			supportEmailId: 'g-eshoptemp@singtel.com'
		},
		securedUrl: '/content/singtel/en/personal/my-account/ebills/details/view-bill-pdf-secured.html',
		permission: {
			'blacklistMsg': 'Some functionality is not available. Please call 1688.',
			'blacklistMsgRelocate': 'This functionality is not available. Please call 1688.',
			'heading': 'Oops!',
			'suspendedMsg': 'We\'ve encountered an issue. Please visit your nearest Singtel Shop to proceed.',
			'isOrderPendingMsg': 'Your have pending order. Please Try again later.',
			'ipaMsg': 'We\'ve encountered an issue. Please visit your nearest Singtel Shop to proceed.',
			'pendingOrdersMsg': 'Your have pending order. To proceed futher do you wish to cancel previous orders.',
			'primaryFieldMsg': 'Please fill required field data.'
		},
		easyMobileUnits: {
			'easyMobileCatalogItemID': '11092',
			'dataUnitsCatalogItemID': '8212',
			'voiceUnitsCatalogItemID': '8192',
			'smsUnitsCatalogItemID': '8202'
		},
		ChangePlanE2C: {
			billingDetailsHeader: 'Select Your Billing Account',
			billingDetailsubHeader: 'You can merge your new service into an existing billing account' +
			' or create a new account'
		},
		ALLOWED_ACTIONS: {
			REMOVE: 'RM',
			ADD: 'AD',
			UPDATE: 'UP',
			SUSPEND: 'SU',
			RESUME: 'RS'
		},
		occupation: {
			years: [
				{ text: 'Years', value: null},
				{ text: '0', value: 0},
				{ text: '1', value: 1},
				{ text: '2', value: 2},
				{ text: '3', value: 3},
				{ text: '4', value: 4},
				{ text: '5', value: 5},
				{ text: '6', value: 6},
				{ text: '7', value: 7},
				{ text: '8', value: 8},
				{ text: '9', value: 9},
				{ text: '10', value: 10},
				{ text: '11', value: 11},
				{ text: '12', value: 12},
				{ text: '13', value: 13},
				{ text: '14', value: 14},
				{ text: '15', value: 15},
				{ text: '16', value: 16},
				{ text: '17', value: 17},
				{ text: '18', value: 18},
				{ text: '19', value: 19},
				{ text: '20+', value: 20}
			],
			months: [
				{ text: 'Months', value: null},
				{ text: '0', value: 0},
				{ text: '1', value: 1},
				{ text: '2', value: 2},
				{ text: '3', value: 3},
				{ text: '4', value: 4},
				{ text: '5', value: 5},
				{ text: '6', value: 6},
				{ text: '7', value: 7},
				{ text: '8', value: 8},
				{ text: '9', value: 9},
				{ text: '10', value: 10},
				{ text: '11', value: 11}
			]
		},

		livedInAddress: {
			years: [
				{ text: 'Years', value: 0},
				{ text: '1', value: 1},
				{ text: '2', value: 2},
				{ text: '3', value: 3},
				{ text: '4', value: 4},
				{ text: '5', value: 5},
				{ text: '6', value: 6},
				{ text: '7', value: 7},
				{ text: '8', value: 8},
				{ text: '9', value: 9},
				{ text: '10', value: 10},
				{ text: '11', value: 11},
				{ text: '12', value: 12},
				{ text: '13', value: 13},
				{ text: '14', value: 14},
				{ text: '15', value: 15},
				{ text: '16', value: 16},
				{ text: '17', value: 17},
				{ text: '18', value: 18},
				{ text: '19', value: 19},
				{ text: '20+', value: 20}
			],
			months: [
				{ text: 'Months', value: 0},
				{ text: '1', value: 1},
				{ text: '2', value: 2},
				{ text: '3', value: 3},
				{ text: '4', value: 4},
				{ text: '5', value: 5},
				{ text: '6', value: 6},
				{ text: '7', value: 7},
				{ text: '8', value: 8},
				{ text: '9', value: 9},
				{ text: '10', value: 10},
				{ text: '11', value: 11}
			]
		},

		timelineWidget: {
			'header': 'Your Account Activity and Transaction History',
			'lastUpdate': 'Last Updated: '
		},
		resumeWidget: {
			resumeDateHeader: 'Resume Date'
		},
		defaultAvatarIdindex: 0,
		easyMobFeedback: {
			enable: true,
			link: '/personal/my-account/send-feedback',
			title: 'Send Feedback',
			ariaLable: 'Send Feedback'
		},

		roamingRates: {
			callsndSMS: 'Voice Calls (Per Min) & SMS',
			incomingCalls: 'Incoming Calls',
			outgoingLocalCalls: 'Outgoing Local Calls in Roaming Country',
			callingSingapore: 'Calling Singapore',
			callIntenational: 'Call International',
			sendSMS: 'Send SMS',
			receiveSMS: 'Receive SMS',
			networkDetails: 'Network Details',
			dataRoaming3G: 'Data Roaming/ 3G',
			handsetDisplay: 'Handset Display',
			internationalAccessCode: 'International Access Code',
			localCustomerCode: 'Local Customer Number',
			emergency: 'Emergency',
			nationalDirectory: 'National Directory',
			errorTitle: 'Whoops!!',
			errorMessage: 'Sorry, there seems to be an error connecting through this portal. Please try again later.',
			countryListFetchError: 'Unable to fetch country List',
			dataPerMb: 'Data (Per MB)',
			videoCallPerMin: 'Video Call (Per Min)',
			dataRoamingAndMMS: 'Data Roaming and MMS (Pay Per Use per MB)'
		},
		singnetIdSuccess: 'Success! Your Singnet ID is validated.',
		replaceSimBillingOffers: {
			nfcSimOfferId: '16642',
			nonNfcSimOfferId: '16642',
			adminCharges: '10807601'
		},
		pickAndGo: {
			simBO: '16642',
			regBO: '8425922'
		},
		mbbDetails: {
			mbbOfferId: '11297311',
			mbbRelationId: '11295171'
		},
		cardData: {
			card_ending: 'card ending',
			visa_card_ending: 'Visa card ending',
			expiry_date: 'Expiry date : '
		},
		itemCodeToCategory: {
			Device_BCC: 'products',
			Insurance_BCC: 'addons',
			EPL: 'addons',
			Music_Streaming_Group_BCC: 'addons',
			Mobile_Main_BCC: 'products',
			Plan_BCC: 'products',
			Accessory: 'accessories',
			Accessories: 'accessories',
			discounts: 'discounts',
			addresses: 'address',
			DEFAULT_CATEGORY: 'others'
		},
		itemCodeToFeeChargesCategory: [
			'Contract', 'Device_BCC', 'Accessory', 'Accessories'
		],
		tvSelectPackType: '12384509',
		newsRoomFeeds: {
			facebookLogoSrc: '/assets/images/logo/facebook-logo.png',
			twitterLogoSrc: '/assets/images/logo/twitter-logo.png',
			facebookUrl: 'https://www.facebook.com/singtel',
			twitterUrl: 'https://twitter.com/SingtelNews',
			viewallText: 'View all',
			followFacebookText: 'Follow us on Facebook',
			followTwitterText: 'Follow @Singtel on Twitter'
		},
		addOnNext: {
			tvNextName: 'Continue to Set-Top Box',
			bbNextName: 'Continue to Top-up',
			wsNextName: 'Add Accessories',
			wsShoppingCartLinkName: 'Skip to Shopping Cart'
		},
		salesAddonHandling: {
			addComponentList: ['9722', '9609763', '9610343', '9610243', '8625512', '8635202', '9607933',
				'9607833', '12650391', '11982', '12374571', '14396101', '8613482', '9622523', '9622623',
				'10247821', '8625502', '8625472', '8625492', '8625532', '8625582', '14396081', '12358201',
				'12360611', '8472832', '18659731', '18661641', '18733721', '18727471', '18659731','14438091',
				'8472632', '18985921'],
			removeComponentList: ['9722', '9609763', '9610343', '9610243', '8625512', '8635202', '9607933',
				'9607833', '12650391', '11982', '12374571', '14396101', '8613482', '9622523', '9622623',
				'10247821', '8625502', '8625472', '8625492', '8625532', '8625582', '14396081', '12358201',
				'12360611', '8472832', '18659731', '18661641', '18733721', '18727471', '18659731', '14438091',
				'8472632', '18985921'],
			removeParentForLastChildList: ['11495061', '11495051', '8635122', '8635142', '17498491', '18708221',
				'26560004', '17498471', '17498451', '17498461', '17498481'],
			componentsWithDropdown: [],
			addComponentDiscountList: [],
			removeComponentDiscountList: [],
			removeParentForLastChildDiscountList: []
		},
		warehouseId: 'warehouseId',
		stepIndicator: {
			stepLabel: 'Step',
			ofLabel: 'of'
		},
		priorityPhoneDetails: {
			heading: 'FOR Registration of Interest Customer Only',
			message: 'The new iPhone is currently only available if you have registered their interest previously. ' +
				'Please ensure that you enter the NRIC number used during your registration of interest.',
			NoQuotaAvailable: 'no quota available'
		},
		availableServicesOptions: [
			{
				title: 'Please Select Service Type',
				value: 'selectServiceType'
			},
			{
				title: 'Swap faulty STB/accessories',
				value: 'replaceHardware',
				reasonCode: 'FLTSTB'
			},
			{
				title: 'Additional STB',
				value: 'buySTB',
				reasonCode: 'ADTSTB'
			},
			{
				title: 'Upgrade STB',
				value: 'upgrdSTB',
				reasonCode: 'UPGSTB'
			},
			{
				title: 'Downgrade STB',
				value: 'dwngrdSTB',
				reasonCode: 'DWNSTB'
			}
		],
		existingSTBTypeOptions: [
			{
				title: 'Please Select STB Type',
				value: 'selectStb'
			},
			{
				title: 'Non-DVR STB',
				value: 'Non-DVR'
			},
			{
				title: 'DVR STB',
				value: 'DVR'
			},
			{
				title: 'Gen 3 DVR record STB',
				value: 'Gen 3 DVR record'
			},
			{
				title: 'Gen 3 DVR non record STB',
				value: 'Gen 3 DVR non record'
			},
			{
				title: 'Android TV',
				value: 'Android TV'
			}
		],
		existingSTBReturnedOptions: [
			{
				title: 'Returned',
				value: 'returned'
			},
			{
				title: 'Returned with physical damage',
				value: 'returnedWithDamage'
			},
			{
				title: 'Not returned',
				value: 'notReturned'
			}
		],
		existingRemoteReturnedOptions: [
			{
				title: 'Returned',
				value: 'returned'
			},
			{
				title: 'Returned with physical damage',
				value: 'returnedWithDamage'
			},
			{
				title: 'Not returned',
				value: 'notReturned'
			}
		],
		existingPowerReturnedOptions: [
			{
				title: 'Returned',
				value: 'returned'
			},
			{
				title: 'Returned with physical damage',
				value: 'returnedWithDamage'
			},
			{
				title: 'Not returned',
				value: 'notReturned'
			}
		],
		roamingCountryList: {
			smallPlanPopupTitle: 'Roaming Plans',
			smallPlanDescription: 'These are the available plans for the selected country above',
			smallSearchPlaceHolder: 'Search Country'
		},
		maxAvatarLimit: 4,
		lables: {
			addressFloorNotApplicable: 'Floor No. and Unit No. are not applicable for my address.'
		},
		bookAnAppoitmentURL: '/personal/my-account/orders-appointments/book-an-appointment',
		bookAnAppoitment: {
			trackAppointmentHeader: 'Track your appointment',
			trackOrderDesc: 'Navigate to your <ux-anchor href="">transaction history</ux-anchor>' +
			' to view this support ticket, and all other transactions you have with Singtel.',
			thingToBring: 'Key in your details upon arrival.',
			thingToBringDesc: 'Do bring along the following documents for your appointment<br>' +
			'<ol><li>Original Identification (ID with photo for customers above 18 years)</li>' +
			'<li>Company Staff Pass (ID with photo for Corporate Individual Scheme Customer)</li>' +
			'<li>Bearer’s Identification and Letter of Authorization (In the absence of subscriber)</li>' +
			'<li>Original Identification with accompany Sponsor and Sponsor’s Identification ' +
			'(ID with photo below 18 years)</li></ol>',
			existingAppointmentHeader: 'Existing Appointment Found',
			existingAppointmentDesc: 'There is already an existing Appointment on this number.' +
			' Are you Sure you want to cancel the same?.',
			callBookingDetails: 'Call booking details',
			callBookingConfirmation: 'Call booking confirmation',
			backendDown: 'Backend system is down, please try again later.',
			thankYou: 'Success!',
			termsAndCondition: 'http://www.singtel.com',
			appointmentConfirmed: 'Your new Singtel shop appointment has been confirmed. The appointment ID is '
		},
		addonLabels: {
			contractDuration: 'Months Contract',
			tncLink: 'http://www.singtel.com',
			tncText: 'Terms & Conditions',
			faqLink: 'http://www.singtel.com',
			faqText: 'FAQs',
			selectPreferenceLabel: 'Select your preference.'
		},
		genericError: {
			header: 'Our apologies.',
			getDocumentHeader: 'We are unable to retrieve your Detailed Statement.',
			getDocument: 'This could be due to one of the following reasons:<br><br>' +
			'<ul><li>There is no Singtel Postpaid Mobile service in this account.</li>' +
			'<li>There was no mobile voice, data or outgoing SMS usage for the billing month.</li>' +
			'<li>We are currently experiencing an error. Please try again later.</li></ul>',
			updateDelivery: 'Oops! We\'re unable to update your details. Please try again later.',
			tweakErrorMsg: 'Oops! We\'re unable to update your details. Please try again later.',
			updateAddressErrorMsg: 'Oops! We\'re unable to update your details. Please try again later.',
			nickNameAndAvatarErrorMsg: 'Oops! We\'re unable to update your details. Please try again later.',
			consolidateAccountMergeError: 'Oops! We\'re unable to update your details. Please try again later.',
			profilePageUpdateErrorMsg: 'Oops! We\'re unable to update your details. Please try again later.',
			productDetailsErrorMsg: 'Oops! We\'re unable to retrieve your service details. Please try again later.',
			usageErrorMsg: 'Oops! We\'re unable to retrieve your usage details. Please try again later.',
			voucherErrorMsg: 'Oops! We\'re unable to retrieve your voucher details. Please try again later.',
			tweakDataErrorMsg: 'Oops! We\'re unable to retrieve your newly tweaked details. Please try again later.',
			relocatePostalCodeErrorMsg: 'Oops! We\'re unable to retrieve your address. Please try again later.',
			notificationSms: 'Oops! We\'re unable to update your details. Please try again later.',
			checkAppointmentStatus: 'No response for given appointment id.',
			alertMessage: 'The product you\'ve chosen is on a different billing account. ' +
				'Please complete the check out for the product that is currently in your cart ' +
				'before you proceed to purchase this product.',
			alertLabel: 'Our apologies.',
			checkAppointmentFailed: 'Appointment retrieval failed, Please try again after sometime.',
			invalidNric: 'Please try again with valid NRIC',
			ineligible: 'Invalid NRIC to do relocate service.',
			ERROR_DONOR_ORDER_VALIDATION: 'We’ve encountered an error. Please contact customer care.',
			numberError: 'The number that you\'ve selected is already taken. Please choose another number.',
			selectAnotherApptError: 'Please select another Date and time in order to book an appointment',
			reconNotAllowed: 'We are sorry, we do not support recontract for Mobile Broadband online.' +
			'Please walk-in to the nearest retail store for the same.',
			pdfBillNotFound: 'No Bill found',
			circleErrorMsg: 'We are not able to process your request now.' +
				'You may call us at 1688 for any clarification.'
		},
		errorHandlerActionMap: {
			accountDashboard: ['billing-entity', 'products-api'],
			viewBillSummary: ['billing-entity', 'get-balance', 'getBillList'],
			changeBillPreference: ['billing-entity'],
			payBills: ['billing-entity'],
			consolidateAccounts: ['billing-entity'],
			paymentHistory: ['search-direct-debit', 'payments'],
			singtelInbox: ['/inbox/message', 'billing-entity']
		},
		updatedDirectDebit: {
			part1: 'The first payment will be taken on',
			part2: 'from your card.'
		},
		loadindMessage: 'Retrieving your information',
		contactPermission: {
			noContactMsg: 'No contacts exist',
			removeAccountPermissionNavTitle: 'Account Level Permissions',
			removeAccountPermTitle: 'Remove account level permissions ?',
			removeAccountPermDesc: 'Once you remove these account level permissions this contact will no ' +
			'longer be able to view and manage it:',
			deleteUnsuccessfulMsg: 'Oops Something went wrong. Please try again',
			removePermission: 'Remove Permissions'
		},
		creditCard: {
			change: 'Change',
			remove: 'Remove',
			use: 'Use',
			card: 'card',
			changeCard: 'Change card',
			removeCard: 'Remove card',
			imageBaseUrl: '/content/dam/optus/images/my-account/card-images/',
			defaultImage: 'error-message-olly'
		},
		TMC: {
			part1: 'Minimum total cost of',
			part2: 'over',
			part3: 'months.'
		},
		rbaLinksConfig: {
			SMB_ACC_MGMNT: {CU: true, CA: true, BA: false, SL: false, SA: false},
			ORDER_TRACKING: {CU: true, CA: true, BA: false, SL: false, SA: false}
		},
		orderPurchaseLimit: {
			WS: 4,
			FHB: 1,
			TV: 1,
			error: 'Sorry..!! you can not purchase more , please complete your exisiting order '
		},
		registerInterest: {
			emailId: 'am_stambol@singtel.com',
			templateId: 'dummy'
		},
		prepaidActivationSummary: {
			simNumber: {
				productTitle: 'SIM number',
				descriptionPart1: 'Your SIM number:'
			},
			plan: {
				productTitle: 'Your plan',
				descriptionPart1: 'This service will be activated on the',
				descriptionPart2: 'Your SIM has been preloaded with $'
			},
			profileDetails: {
				productTitle: 'Profile details',
				title1: 'Personal details',
				title2: 'Home address'
			},
			phoneNumber: {
				productTitle: 'Your phone number',
				descriptionPart1: 'New number:'
			},
			recharge: {
				productTitle: 'Recharge',
				descriptionPart1: 'Your SIM is already preloaded with $',
				descriptionPart2: 'which is applied once you\'re active'
			},
			identity: {
				productTitle: 'Your Identity',
				descriptionPart1: 'Your identity was verified using the details you provided'
			},
			activate: {
				productTitle: 'Activate',
				descriptionPart1: 'Please agree to Terms and Conditions in order to proceed with the activation'
			}
		},
		tvContentPacks: [
			{
				sourceId: '8849602',
				targetId: '9229412',
				addonId: '10167561'
			},
			{
				sourceId: '11914941',
				targetId: '9229412',
				addonId: '10167561'
			},
			{
				sourceId: '-1',
				targetId: '9230892',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '9230152',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '9231692',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '9231652',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '10182401',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '9231172',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '9231372',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '10180921',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '10181401',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '10181441',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '10181521',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '13043631',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '9230852',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '9231772',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '9231812',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '10182241',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '10182361',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '9231572',
				addonId: '8830012'
			},
			{
				sourceId: '-1',
				targetId: '9230932',
				addonId: '8830012'
			}
		],
		deviceList: {
			compareLabelStart: 'Click to add',
			compareLabelEnd: 'to the compare List'
		},
		compareBar: {
			headingAriaLabel: 'selected products, view details and compare',
			compareLabel: 'Add device to compare list'
		},
		usageCharges: {
			M: 'Min(s)',
			O: 'Message(s)',
			U: 'Unit(s)',
			N: 'No(s)',
			NotMeasurableUnit: '-'
		},
		stbDiscountsOptions: [
			{
				title: 'No discount',
				value: ''
			},
			{
				title: '50% discount 12 months',
				value: '123456'
			},
			{
				title: '50% discount 24 months',
				value: '12345678'
			}
		],
		componentWithSpecialCharacteristics: [
			{
				productSpecContainmentID: '9610243',
				characteristicID: '8622642'
			},
			{
				productSpecContainmentID: '9610343',
				characteristicID: '8622642'
			},
			{
				productSpecContainmentID: '8625502',
				characteristicID: '8622642'
			}
		],
		headerLogoutOption: {
			title: 'Logout',
			href: '',
			active: true
		},
		updateEmailError: {
			'SubmitTimeElapsed': 'Your token expired.',
			'EmailAlreadyUpdated': 'Email is already updated.'
		},
		updateEmailSuccess: {
			'header': 'Your email has been verified'
		},
		checkLogin: '/online-api/cxf/sg-loginservice/checkLogin',
		uiamAcessToken: 'online_usertoken',
		defaultLandingURL: '/personal/my-account/manage-accounts/account-summary',
		checkLogin1: '/etc/designs/springd/clientlibs/uxf/businesswidget/' +
		'repository_l9_common/common/fixture/check-login.json',
		checkAppointmentStatusTrack: {
			statusMapping: {
				'Done': 'Completed',
				'Enroute': 'Engineer on the way',
				'En Route': 'Engineer on the way',
				'Onsite': 'Engineer onsite',
				'Tentative': 'Scheduled',
				'Open': 'Scheduled',
				'Work in Progress': 'Engineer onsite',
				'Appointments Awaiting Allocation': 'Scheduled',
				'Booked Appointment': 'Scheduled',
				'Appointment Awaiting Approval': 'Scheduled',
				'Assigned': 'Scheduled',
				'Dispatched': 'Scheduled',
				'Open Awaiting Appointment': 'Scheduled',
				'Work In Progress': 'Engineer onsite',
				'Arrived': 'Engineer onsite'
			},
			commentMapping: {
				'Cancellation due Wiring Constraint': 'A representative from Singtel will be ' +
				'in touch to assist you with your request.',
				'CSIM - 2nd port activation': 'The new service(s) is required to be activated ' +
				'on the second port of the Fibre Termination Point. Singtel will be contacting ' +
				'you for onsite re-appointments with Netlink Trust (NLT) and Singtel respectively.',
				'CSIM - Cancellation not verify with sub': 'We have received a service cancellation ' +
				'request. A representative from Singtel will be in touch with you to verify and complete ' +
				'the request. Please note that cancellation charges may apply.',
				'CSIM - Change of service plan not verify with sub': 'We are currently processing your ' +
				'request to make changes to your subsciptions/add-on/service(s). A representative from ' +
				'Singtel will be in touch with you to verify and complete the request.',
				'CSIM - Fibre Signal out of spec BS Esc': 'We noticed an issue with your fibre signal ' +
				'during the installation appointment, and have escalated this to NetLinkTrust (NLT) for ' +
				'assistance. A representative from Singtel will be in touch within the next 48 hours to ' +
				'assist you with onsite re-appointment(s).',
				'CSIM - Fibre signal out of spec 8hr Esc': 'We noticed an issue with your fibre signal during ' +
				'the installation appointment, and have escalated this to NetLinkTrust (NLT) for assistance. ' +
				'A representative from Singtel will be in touch within the next 48 hours to assist you with onsite' +
				're-appointment(s).',
				'CSIM - FTP Relocation Repair Restoration': 'Our field engineers have identified that the Fibre ' +
				'Termination Point in your premises requires to be either repaired, restored, or relocated before ' +
				'the Singtel Fibre installation can be completed. Please note that additional ' +
				'charges may be applicable ' +
				'to NetLink Trust (NLT). A representative from Singtel will be in touch to assist you with the request.',
				'CSIM - Incomplete orders for MCC OE': 'We are currently processing your request.',
				'CSIM - No light source 1hr Esc': 'We noticed an issue with your ' +
				'fibre signal during the installation ' +
				'appointment, and have escalated this to NetLinkTrust (NLT) for assistance. ' +
				'A representative from Singtel ' +
				'will be in touch within the next 48 hours to assist you with onsite re-appointment(s).',
				'CSIM - No light source 8hr Esc': 'We noticed an issue with your fibre signal ' +
				'during the installation ' +
				'appointment, and have escalated this to NetLinkTrust (NLT) for assistance. ' +
				'A representative from Singtel ' +
				'will be in touch within the next 48 hours to assist you with onsite re-appointment(s).',
				'CSIM - No light source BS Esc': 'We noticed an issue with your fibre signal during the installation ' +
				'appointment, and have escalated this to NetLinkTrust (NLT) for assistance. A representative from ' +
				'Singtel will be in touch within the next 48 hours to assist you with onsite re-appointment(s).',
				'CSIM - ONT Unable to range': 'We noticed an issue with your fibre signal during the installation ' +
				'appointment, and have escalated this to NetLinkTrust (NLT) for assistance. A representative from ' +
				'Singtel will be in touch within the next 48 hours to assist you with onsite re-appointment(s).',
				'CSIM - Outstanding bill to be settled': 'We are unable to proceed with the installation due to your ' +
				'account status. A representative from Singtel will be in touch with you. Alternatively, you may ' +
				'contact our Billing Department  to assist you with the request.',
				'CSIM - reappt due to late arrival': 'A new appointment has been scheduled. Thank you.',
				'CSIM - System issue DWFM PEG AWIS FMS': 'Your request has been successfully completed. Thank you.',
				'CSIM-Fibre Signal out of spec 1hr Esc': 'We noticed an issue with your fibre signal during the ' +
				'installation appointment, and have escalated this to NetLinkTrust (NLT) for assistance. ' +
				'A representative from Singtel will be in touch within the next 48 hours to assist you with ' +
				'onsite re-appointment(s).',
				'Cust - Cust 3rd party device Issue': 'Our field engineers have identified that the issue you ' +
				'have experienced is due to non-Singtel devices/equipment/accessories which are connected to your ' +
				'broadband service. Please contact your 3rd Party Device Vendor for further advice. You may refer ' +
				'to our Restoration Card for more details.',
				'Cust - Customer houselock': 'Our field engineers were unable to proceed with the installation due ' +
				'to denied access during the appointment. A representative from ' +
				'Singtel will be in touch to assist ' +
				'you with reappointment.',
				'Cust - Equipment missing': 'We are unable to proceed with the installation ' +
				'as one or more of your ' +
				'existing equipment is not available at the point of installation. ' +
				'A representative from Singtel will ' +
				'be in touch to assist you with onsite re-appointment(s). ',
				'Cust - reappointment request': 'A representative from Singtel will ' +
				'be in touch to assist you with your ' +
				'request.',
				'Cust - Request POS to follow up': 'A representative from Singtel will ' +
				'be in touch to assist ' +
				'you with your request.',
				'Cust - Waiting reno to complete': 'Our field engineers have noted that ' +
				'the premises is undergoing ' +
				'renovation. A representative from Singtel will be in touch to assist you ' +
				'with onsite re-appointment(s). ' +
				'Alternatively, you may contact us at 1688 once renovation has completed.',
				'Cust - Wireless limitation coverage': 'Our field engineers have identified that there may ' +
				'be weak wireless coverage for certain parts of your premises. A representative from Singtel ' +
				'will be in touch with you to advise on the options to enhance wireless coverage with additional ' +
				'equipment. Please note that additional charges may apply for these equipment.',
				'Cust - Wiring constraint': 'We are unable to proceed with the installation. A representative ' +
				'from Singtel will be in touch with you to verify and complete the request.',
				'NFTS Dispute': 'Our field engineers have identified that the issue you have experienced is due ' +
				'to non-Singtel devices/equipment/accessories which are connected to your broadband service. ' +
				'Please contact your 3rd Party Device Vendor for further advice. You may refer to our Restoration ' +
				'Card for more details.',
				'NW - ANO issue for Home Line': 'Our field engineers have identified issues related to the ' +
				'underground cable and have informed the relevant team for further investigation. ' +
				'A representative from Singtel will be in touch to update you on the progress and ' +
				'arrange for re-appointment(s).',
				'NW - Call Zone issue': 'A representative from Singtel will be in touch to assist; ' +
				'you with your request.',
				'NW - FTTH Resource allocation DLY': 'Our field engineers have encountered issues during ' +
				'the installation process and have escalated to the respective team for further investigation. ' +
				'A representative from Singtel will be in touch to update you on the progress and arrange ' +
				'for re-appointment(s).',
				'NW - HDL related issue': 'A representative from Singtel will be in touch to assist you ' +
				'with your request.',
				'NW - MioTV related issue': 'A representative from Singtel will be in touch ' +
				'to assist you with your request.',
				'NW - SNBB related issue': 'A representative from Singtel will be in touch ' +
				'to assist you with your request.',
				'NW - UG or DP for ANM action': 'Our field engineers have identified issues ' +
				'related to the underground cable and have informed the relevant team for ' +
				'further investigation. A representative from Singtel will be in touch to ' +
				'update you on the progress and arrange for re-appointment(s).',
				'OE - Amend order verified sub ICON sent': 'We are currently processing ' +
				'your request.',
				'ON - Awaiting verification from QP': 'We understand that NetLink Trust (NLT) ' +
				'was unable to complete the job due to unresolved constraints. ' +
				'A representative from Singtel will be in touch to update you on ' +
				'the progress and arrange for re-appointment(s).',
				'ON - Capacity Issue': 'We are unable to proceed with your Singtel ' +
				'installation as NetLink Trust (NLT) encountered a network resource ' +
				'issue which they need to resolve. Please note that this may take up ' +
				'to 8 weeks. A representative from Singtel will be in touch to update ' +
				'you on the progress and arrange for re-appointment(s).',
				'ON - Capacity resolved pending reappt': 'The network resource issue has ' +
				'been resolved by NetLink Trust (NLT). A representative from Singtel will ' +
				'be in touch with you to arrange for a re-appointment.',
				'ON - Concealed wiring': 'We are unable to proceed with the installation. ' +
				'A representative from Singtel will be in touch with you to verify and ' +
				'complete the request.',
				'ON - Delay due to end user decision': 'We are unable to proceed with the ' +
				'installation. A representative from Singtel will be in touch with you to ' +
				'verify and complete the request.',
				'ON - MCST awaiting bldg mgt': 'We are unable to proceed with your Singtel ' +
				'installation as NetLink Trust (NLT) had encountered access issues. Please note ' +
				'that this may take up to 8 weeks. A representative from Singtel will be in touch ' +
				'to update you on the progress and arrange for re-appointment(s).',
				'ON - Network termination record checked': 'We are unable to proceed with your ' +
				'Singtel installation as NetLink Trust (NLT) had encountered a network resource ' +
				'issue which they need to resolve. Please note that this may take up to 8 weeks. ' +
				'A representative from Singtel will be in touch to update you on the progress and ' +
				'arrange for re-appointment(s).',
				'ON - No specific pending reason from OpenNet': 'We are awaiting a status update ' +
				'from NetLink Trust (NLT). A representative from Singtel will be in touch to update ' +
				'you on the progress and arrange for re-appointment(s).',
				'ON - OpenNet network Issue': 'We are unable to proceed with your Singtel installation ' +
				'as NetLink Trust (NLT) had encountered a network resource issue which they need to ' +
				'resolve. Please note that this may take up to 8 weeks. A representative from Singtel ' +
				'will be in touch to update you on the progress and arrange for re-appointment(s).',
				'ON - Pending cancellation with sub': 'We have received a service cancellation request. ' +
				'A representative from Singtel will be in touch with you to verify and complete the request. ' +
				'Please note that cancellation charges may apply.',
				'ON - Pipe block external': 'NetLink Trust (NLT) was unable to complete the installation ' +
				'due to a choked pipe outside your premises. NLT will discuss with the relevant agencies ' +
				'to resolve the issue. A representative from Singtel will be in touch to arrange for ' +
				're-appointment(s) when the issue has been resolved. Please note that this may take ' +
				'up to 12 weeks.',
				'ON - Rejected due to houselock': 'Our field engineers were unable to proceed with the ' +
				'installation due to denied access during the appointment. A representative from Singtel ' +
				'will be in touch to assist you with reappointment.',
				'ON - Spring board bldg mgt reject access': 'We are unable to proceed with your Singtel ' +
				'installation as NetLink Trust (NLT) had encountered access issues. Please note that this ' +
				'may take up to 12 weeks. A representative from Singtel will be in touch to update you on ' +
				'the progress and arrange for re-appointment(s).',
				'SME - 2nd port activation': 'The new service(s) is required to be activated on the second ' +
				'port of the Fibre Termination Point. Singtel will be contacting you for onsite ' +
				're-appointments with Netlink Trust (NLT) and Singtel respectively.',
				'SME - Cancellation': 'We have received a service cancellation request. ' +
				'A representative from Singtel will be in touch with you to verify and complete ' +
				'the request. Please note that cancellation charges may apply.',
				'SME - Fibre signal out of spec': 'We noticed an issue with your fibre signal ' +
				'during the installation appointment, and have escalated this to NetLinkTrust (NLT) ' +
				'for assistance. A representative from Singtel will be in touch within the next ' +
				'48 hours to assist you with onsite re-appointment(s).',
				'SME - FTP Relocation Repair Restoration': 'Our field engineers have identified ' +
				'that the Fibre Termination Point in your premises requires to be either repaired, ' +
				'restored, or relocated before the Singtel Fibre installation can be completed. ' +
				'Please note that additional charges may be applicable to NetLink Trust (NLT). ' +
				'A representative from Singtel will be in touch to assist you with the request.',
				'SME - No light source': 'We noticed an issue with your fibre signal during the ' +
				'installation appointment, and have escalated this to NetLinkTrust (NLT) for ' +
				'assistance. A representative from Singtel will be in touch within the next 48 ' +
				'hours to assist you with onsite re-appointment(s).',
				'SME-Fibre Infra NRD (T-2)': 'Our field engineers have identified that the Fibre ' +
				'Termination Point in your premises requires to be either repaired, restored, ' +
				'or relocated before the Singtel Fibre installation can be completed. Please ' +
				'note that additional charges may be applicable to NetLink Trust (NLT). ' +
				'A representative from Singtel will be in touch to assist you with the request.',
				'Cancellation due Others - Miscs': 'A representative from Singtel will be in ' +
				'touch with you to verify and complete the request. Please note that cancellation ' +
				'charges may apply.',
				'Cancellation due POS Dispute': 'A representative from Singtel will be in touch ' +
				'with you to verify and complete the request. Please note that cancellation ' +
				'charges may apply.',
				'Cancellation due to Customer expectation': 'A representative from Singtel ' +
				'will be in touch with you to verify and complete the request. Please note that ' +
				'cancellation charges may apply.'
			}
		},
		manageAddOn: {
			startDateCharId: '8128572',
			endDateCharId: '8128562',
			durationCharId: '8034942',
			dateFormat: 'DD-MM-YYYY',
			DataRoamAddonRemove: [{
				productSpecContainmentID: '17284961',
				productTitle: 'In-flight DataRoam (24-hr Unlimited)'
			}, {
				productSpecContainmentID: '2820385',
				productTitle: 'Cruise DataRoam (Daily Unlimited)'
			}],
			readyRoamBOs: ['4157035', '2490676', '4157025', '2495716', '2254045'],
			lables: {
				penaltyLable: 'Early Termination Charges'
			}
		},
		ignoredPackList: ['IPTV FREE PREVIEW', 'SVOD', '(FC)ALL BTV', '50% DISCOUNT', 'BUNDLED DISCOUNT'],
		cropTextConfig: {
			desktopChars: 275,
			tabletChars: 275,
			mobileChars: 140
		},
		sizeVariantCropTextConfig: {
			desktopChars: 65,
			tabletChars: 100,
			mobileChars: 50
		},
		channelsToShow: 20,
		mstaCropTextConfig: {
			mobileChars: 37
		},
		mstaAddon: {
			flowEndUrl: 'mysingtel://app/usage'
		},
		inboxCropTextConfig: {
			desktopChars: 140,
			tabletChars: 140,
			mobileChars: 140
		},
		breakpoints: {
			desktop: {
				minWidth: 852
			},
			tablet: {
				minWidth: 493,
				maxWidth: 851
			},
			mobile: {
				maxWidth: 492
			}
		},
		'mobileContentGroups': [
			{
				'groupName': 'content',
				'description': null,
				'title': 'Lifestyle services',
				'items': [
					{
						'contract': '0',
						'price': '0',
						'ranking': '311',
						'productSpecContainmentID': '11419901',
						'simpleProductSpecID': '11451211',
						'productTitle': 'Spotify Premium',
						'productDescription': 'The app that lets you build a music collection with personal ',
						'baseType': 'mobileContent'
					},
					{
						'contract': '0',
						'price': '0',
						'ranking': '312',
						'productSpecContainmentID': '13317892',
						'simpleProductSpecID': '13961391',
						'productTitle': 'Saavn Premium',
						'productDescription': 'The app that houses all your favourite songs, ranging from Bollywood',
						'baseType': 'mobileContent'
					},
					{
						'contract': '0',
						'price': '0',
						'ranking': '313',
						'productSpecContainmentID': '11419911',
						'productTitle': 'KKBOX Premium',
						'productDescription': 'The app that buys you more than 30 million songs with the most',
						'baseType': 'mobileContent'
					},
					{
						'contract': '12',
						'price': '4.58',
						'ranking': '321',
						'productSpecContainmentID': '12369991',
						'productTitle': 'Viu Premium',
						'productDescription': 'Watch the latest Korean shows and dramas first on Viu Premium.',
						'baseType': 'mobileContent'
					},
					{
						'contract': ' ',
						'price': '4.58',
						'ranking': '322',
						'productSpecContainmentID': '12369941',
						'productTitle': 'Kids Pack',
						'productDescription': 'Keep your kids entertained with a never-ending line-up of hit shows.'
					},
					{
						'contract': '0',
						'price': '0',
						'ranking': '331',
						'productSpecContainmentID': '13980211',
						'productTitle': 'The Wall Street Journal',
						'productDescription': 'Get unrivaled perspective and in-depth analysis that goes beyond',
						'baseType': 'mobileContent'
					},
					{
						'contract': '0',
						'price': '0',
						'ranking': '332',
						'productSpecContainmentID': '13980221',
						'productTitle': 'TIME',
						'productDescription': 'Breaking news and analysis from TIME.com. Politics, world news, photos.',
						'baseType': 'mobileContent'
					},
					{
						'contract': '0',
						'price': '0',
						'ranking': '333',
						'productSpecContainmentID': '13980231',
						'productTitle': 'Fortune',
						'productDescription': 'Fortune speaks the language of the street: Wall Street, Silicon Valley.',
						'baseType': 'mobileContent'
					}
				]
			}
		],
		mobileRecontractAllowedPlans: [
			{
				//combo plans
				sourcePlans: ['6722', '6752', '6782', '6812', '17402', '8363892',
					'12729561', '12729571', '12729591', '12729621', '12729651'],
				targetPlans: ['6722', '6752', '6782', '6812', '17402', '8363892',
					'12729561', '12729571', '12729591', '12729621', '12729651',
					'9969283', '13898981', '13898991']
			},
			{
				//youth plans
				sourcePlans: ['6652', '6692', '6732', '6762', '6792', '12729581',
					'12729601', '12729611', '12729661'],
				targetPlans: ['6652', '6692', '6732', '6762', '6792', '12729581',
					'12729601', '12729611', '12729661', '6722', '6752', '6782', '6812', '17402', '8363892',
					'12729561', '12729571', '12729591', '12729621', '12729651']
			},
			{
				//SimOnly
				sourcePlans: ['9969283', '13898981', '13898991'],
				targetPlans: ['6722', '6752', '6782', '6812', '17402', '8363892',
					'12729561', '12729571', '12729591', '12729621', '12729651',
					'6822', '6832', '6842', '6852', '9969283', '13898981', '13898991',
					'9969283', '13898981', '13898991']
			},
			{
				//Easy Mobile
				sourcePlans: ['6822', '6832', '6842', '6852'],
				targetPlans: ['6722', '6752', '6782', '6812', '17402', '8363892',
					'12729561', '12729571', '12729591', '12729621', '12729651',
					'6822', '6832', '6842', '6852', '9969283', '13898981', '13898991']
			},
			{
				//Silver
				sourcePlans: ['6642', '6682', '12729631'],
				targetPlans: ['6642', '6682', '12729631', '6722', '6752', '6782', '6812', '17402', '8363892',
					'12729561', '12729571', '12729591', '12729621', '12729651']
			},
			{
				//Mobile Share
				sourcePlans: ['8518152'],
				targetPlans: ['9969283', '13898981', '13898991',
					'6722', '6752', '6782', '6812', '17402', '8363892',
					'12729561', '12729571', '12729591', '12729621', '12729651']
			},
			{
				//MBB Plans
				sourcePlans: ['6872', '6882', '18102', '18112', '18122', '18132', '18142',
					'18152', '18162', '18172', '8548642', '8648642',
					'8648802', '8648812', '8648822', '8648832', '8648842', '8653412', '11207661',
					'11207671', '11207681', '11207691', '11207701', '11207711', '11207721', '11207731',
					'11207741', '11207751', '11207761', '11207771', '11207781', '11207791', '11207801',
					'11207811', '11207821', '11207831', '11207841', '11207851', '11207861', '11207871',
					'11207881', '11207891', '11207901', '11207911', '11207921', '11207931', '11207941',
					'11207951', '11207961', '11207971', '11207981', '11207991', '11208001', '11208011',
					'11208021', '11208031', '11208041', '11208051', '11208061', '11208071', '11208081',
					'11208091', '11208101', '11208111', '11208121', '11208131', '11208141', '11208151',
					'11208161', '11208171', '11208181', '11208191', '11208201', '11208211', '11208221',
					'11208231', '11208241', '11208251', '11208261', '11208271', '11208281', '11208291',
					'11208301', '10050851'],
				targetPlans: ['6872', '6882', '18102', '18112', '18122', '18132', '18142',
					'18152', '18162', '18172', '8548642', '8648642',
					'8648802', '8648812', '8648822', '8648832', '8648842', '8653412', '11207661',
					'11207671', '11207681', '11207691', '11207701', '11207711', '11207721', '11207731',
					'11207741', '11207751', '11207761', '11207771', '11207781', '11207791', '11207801',
					'11207811', '11207821', '11207831', '11207841', '11207851', '11207861', '11207871',
					'11207881', '11207891', '11207901', '11207911', '11207921', '11207931', '11207941',
					'11207951', '11207961', '11207971', '11207981', '11207991', '11208001', '11208011',
					'11208021', '11208031', '11208041', '11208051', '11208061', '11208071', '11208081',
					'11208091', '11208101', '11208111', '11208121', '11208131', '11208141', '11208151',
					'11208161', '11208171', '11208181', '11208191', '11208201', '11208211', '11208221',
					'11208231', '11208241', '11208251', '11208261', '11208271', '11208281', '11208291',
					'11208301', '10050851']
			}
		],
		recontractBlocked: {
			error: 'We are sorry, this line can\'t be recontracted to the selected plan.' +
			'Please call 1688 for assistance.'
		},
		SESSION_TIMEOUT_INTERVAL: 3900000,
		sessionTimeOut: {
			sess_warningMins: 15,
			sess_expireMins: 20,
			warningHeading: 'Your session is about to expire. Please complete your purchase within the next ',
			warningMessage: 'Please note that the products/services you have added to your shopping cart will be ' +
			'removed once your session expires.',
			expireHeading: 'Your session has expired.',
			expireMessage: 'Please note that the products/services you have added to your shopping cart are removed.' +
			' Please start your purchase again.'
		},
		tvRecommender: {
			languagesforIDHiding: ['English', 'Tagalog']
		},
		deviceCare: {
			'removeDeviceCareHeader': 'Warning!',
			'14426026': 'Your Samsung Conceirge will be removed. Are you sure ?',
			'14482': 'Your Mobile Swop will be removed. Are you sure ?',
			'12357321': 'Your Apple Care will be removed. Are you sure ?'
		},
		bb10GPlanRelId: '12733821',
		personIdTypeOptions: [
			{
				title: 'F',
				value: 'F',
				selected: 'true'
			},
			{
				title: 'G',
				value: 'G'
			},
			{
				title: 'S',
				value: 'S'
			},
			{
				title: 'T',
				value: 'T'
			}
		],
		invalidNRICFormatMsg: 'Please enter a valid NRIC number',
		customerNRICNotInBCC: {
			heading: 'Sorry!',
			body: 'This transfer of ownership of your mobile line cannot' +
			' be done as the the new owner is not a current Singtel customer.'
		},
		//-------------------------------------
		transfer_ownership_charges: {
			billingOffer: 10807571
		},
		transfer_Ownership_Page: {
			Button_Accept: {
				Data: {
					btn_text: 'Accept',
					btn_event: 'transferOwnershipAccept',
					btn_class: 'expand-for-mobile',
					enabled: true
				}
			},
			Button_Reject: {
				Data: {
					btn_text: 'Reject',
					btn_event: 'transferOwnershipReject',
					btn_class: 'expand-for-mobile light',
					enabled: true
				}
			}
		},
		transfer_Ownership_Reject: {
			Button_Confirm: {
				Data: {
					btn_text: 'Confirm',
					btn_event: 'transferOwnershipRejectConfirm',
					btn_class: 'expand-for-mobile',
					enabled: true
				}
			}
		},
		transfer_Ownership_Accept: {
			TNC: 'I agree to Terms and Condition',
			Button_Confirm: {
				Data: {
					btn_text: 'Confirm',
					btn_event: 'transferOwnershipProcess',
					btn_class: 'text-right',
					enabled: true
				}
			}
		},
		transfer_Ownership_Process: {
			Button_Confirm: {
				Data: {
					btn_text: 'Confirm',
					btn_event: 'transferOwnershipConfirm',
					enabled: false
				}
			},
			notes: [
				'The transfer fee will be billed to your next Singtel bill.'
			],
			tncLabels: [
				{
					theme: '',
					labelvalue: 'I agree to &nbsp;'
				},
				{
					theme: 'link',
					labelvalue: 'Terms and Conditions',
					href: 'http://www.singtel.com',
					target: '_blank'
				}
			]
		},
		transfer_Ownership_Confirm: {
			Button_Confirm: {
				Data: {
					btn_text: 'Confirm',
					btn_event: 'transferOwnershipComplete',
					btn_class: 'text-right',
					enabled: true
				}
			}
		},
		transferOwnershipStatus: {
			'INITITIATED': 'Initiated',
			'EXPIRED': 'Expired',
			'REJECTED': 'Rejected',
			'ACCEPTED': 'Accepted',
			'CLOSED': 'Closed'
		},
		//------------------------------------
		//10GEnhnce-3050725,3072145,  5GEnhance-3135155,3203355,  3GEnhance-3152025,3169135,3225295,3247485
		bbPlanIdsForEform: ['3050725','3072145', '3135155', '3203355', '3152025', '3169135', '3225295', '3247485'],
		bb10GplanIds: ['12737121','12733731'],
		dashPayment: {
			heading: 'Dash is now Singapore’s most widely accepted all-in-one mobile wallet.',
			message: 'Would you like to sign up for Singtel Dash?'
		},
		orderSummary: {
			labels: {
				oneTimeCost: 'Addition to First Bill',
				monthlyPayment: 'Monthly Fee',
				upfrontPayment: 'Upfront Fee'
			}
		},
		SIN_COORDINATES: {
			lat: 1.2891912,
			lon: 103.8468
		},
		changeOwnerShipErrorCode: {
			'ERROR_DONOR_NOT_ALLOWED_001': 'We’ve encountered an error. Please contact customer care.',
			'ERROR_DONOR_NOT_ALLOWED_002': 'We’ve encountered an error. Please contact customer care.',
			'ERROR_DONOR_NOT_ALLOWED_003': 'Please wait for the new owner to accept the transfer request.' +
			' It can take up to 3 working days.',
			'ERROR_DONOR_NOT_ALLOWED_004': 'For further assistance, head to ' +
			'<a href="https://singtel.com/help" target="_blank">' + 'singtel.com/help</a>' +
			' to get in touch with us.',
			'ERROR_DONOR_NOT_ALLOWED_005': 'Please make full payment on the bill before transferring ownership.',
			'ERROR_DONOR_NOT_ALLOWED_006': 'Please make full payment on your upcoming bill before' +
			' transferring ownership.',
			'ERROR_DONOR_NOT_ALLOWED_007': 'Please wait for the suspension to start before transferring ownership.',
			'ERROR_DONOR_RECIPIENT_VALIDATION': 'This transfer of ownership of your mobile line cannot' +
			' be done as the the new owner is not a current Singtel customer.'
		},
		changeOwnerShipErrorHeaderCode: {
			'ERROR_DONOR_NOT_ALLOWED_001': 'Oops!',
			'ERROR_DONOR_NOT_ALLOWED_002': 'Oops!',
			'ERROR_DONOR_NOT_ALLOWED_003': 'You have a pending transfer ownership request',
			'ERROR_DONOR_NOT_ALLOWED_004': 'Sorry, we’re unable to proceed with this request',
			'ERROR_DONOR_NOT_ALLOWED_005': 'You have an outstanding bill',
			'ERROR_DONOR_NOT_ALLOWED_006': 'You have an upcoming bill',
			'ERROR_DONOR_NOT_ALLOWED_007': 'You have a pending temporary account suspension request',
			'ERROR_DONOR_RECIPIENT_VALIDATION': 'Oops!'
		},
		mobileShare: {
			roamingAlertMsgPartOne: 'Alert me when I’ve incurred ',
			roamingAlertMsgPartTwo: ' or more.'
		},
		express: {
			needOnepassCheckApi: '/online-api/cxf/buyflow/customer/needonepasscheck',
			transactionEmailApi: '/bin/services/singtel/office365PurchaseNotificationServlet',
			provisionApi: '/online-api/cxf/buyflow/provision',
			checkEligibilityApi: '/online-api/cxf/buyflow/eligibility',
			sendOtpApi: '/online-api/cxf/express/sendOTP',
			validateOTPApi: '/online-api/cxf/express/validateOTP',
			validateSessionApi: '/online-api/cxf/express/validateSession',
			requestCallbackApi: '/bin/services/singtel/office365Servlet',
			office365AppId: 2
		},
		getRewardsCustomerUrl: '/online-api/cxf/lms-api/rewards/customer/profile/',
		getRewardsHistoryUrl: '/online-api/cxf/lms-api/history/',
		getRewardsHistoryHeaderUrl: '/online-api/cxf/lms-api/history/header/',
		submitRewardsEmailUrl: '/online-api/cxf/lms-api/rewards/redemption/email/',
		submitRewardsPhysicalUrl: '/online-api/cxf/lms-api/rewards/redemption/physical/',
		submitRewardsLuckyDrawUrl: '/online-api/cxf/lms-api/rewards/redemption/luckydraw/',
		submitRewardsBirthdayUrl: '/online-api/cxf/lms-api/rewards/redemption/birthday/',
		submitPrestigeLuckyDrawUrl: '/online-api/cxf/lms-api/rewards/event/luckydraw/',
		submitPrestigePhysicalUrl: '/online-api/cxf/lms-api/rewards/event/physical/',
		submitPrestigeEmailUrl: '/online-api/cxf/lms-api/rewards/event/email/',
		isFullyRedeemedUrl: '/online-api/cxf/lms-api/rewards/stock/',
		getRewardsUrl: '/content/singtel/en/personal/my-account/rewards/singtel-rewards-list/',
		getUserInfoUrl: '/mcssapi/rp-webapp-9-common/user/information',
		rewardsBannerUrl: '/content/dam/singtel/rewards/',
		requestOrderTrackingURL: '/api/order-tracking/v1/order/track',
		nonClickableUsageCharge: 'Local Calls',
		populateSpecialComponentsCharacteristics: [
			{
				productSpecContainmentID: '8625512',
				productSpecName: 'Security Suite',
				characteristicID: '8622642',
				type: 'Email_Validation'
			},
			{
				productSpecContainmentID: '8625512',
				productSpecName: 'Security Suite',
				characteristicID: '12171391',
				type: 'License_Type'
			},
			{
				productSpecContainmentID: '9610243',
				productSpecName: 'Anti-Spam',
				characteristicID: '8622642',
				type: 'All_Email'
			},
			{
				productSpecContainmentID: '9610343',
				productSpecName: 'Anti-Virus',
				characteristicID: '8622642',
				type: 'All_Email'
			},
			{
				productSpecContainmentID: '8625502',
				productSpecName: 'Family Protection',
				characteristicID: '8622642',
				type: 'Email_Validation'
			},
			{
				productSpecContainmentID: '8472832',
				productSpecName: 'Apple Care',
				characteristicID: '8622642',
				type: 'Email_Validation'
			},
			{
				productSpecContainmentID: '8472832',
				productSpecName: 'Apple Care',
				characteristicID: '8178471',
				type: 'Email_Validation'
			},
			{
				productSpecContainmentID: '8472832',
				productSpecName: 'Apple Care',
				characteristicID: '8302',
				type: 'Ignore'
			},
			{
				productSpecContainmentID: '8472832',
				productSpecName: 'Apple Care',
				characteristicID: '8489052',
				type: 'Ignore'
			},
			{
				productSpecContainmentID: '8472832',
				productSpecName: 'Apple Care',
				characteristicID: '8832',
				type: 'Ignore'
			},
			{
				productSpecContainmentID: '8635202',
				productSpecName: 'Singtel TV GO',
				characteristicID: '8232',
				type: 'ContractDuration',
				defaultValue: '12'
			},
			{
				productSpecContainmentID: '8625582',
				productSpecName: 'Email',
				characteristicID: '8622642',
				type: 'PrimaryPaidEmail'
			}
		],
		homeLineTest: {
			url: {
				techLineTest: '/smartlink/api/v1/linetestmicrosite/techlinetest',
				techGetApptType: '/smartlink/api/v1/appointment/techGetApptType',
				techGetNextAppt: '/smartlink/api/v1/appointment/getNextAppt',
				techCreateNewAppt: '/smartlink/api/v1/appointment/techCreateNewAppt',
				techInsertToIVRQueue: '/smartlink/api/v1/techXferToIVRQueue',
				getSvcIdentifierByCust: '/smartlink/api/v1/getSvcIdentifierByCust',
				saveAppRating: '/smartlink/api/v1/appointment/saveAppRating',
				consumeSessionTransferToken: '/smartlink/api/v1/sessiondata/consume',
				createSessionTransferToken: '/smartlink/api/v1/sessiondata/creation',
				urlMap: '/bin/services/singtel/homelinetest.dir.responseCode=/'
			},
			appName: 'portal',
			ratingPage: '/content/homelinetest/en/tech-line-test/line-test-rating.html',
			genericError: '/content/homelinetest/en/tech-line-test/general-error.html',
			inContractPage: '/content/homelinetest/en/tech-line-test/self-replacement-centres.html',
			outContractPage: '/content/homelinetest/en/tech-line-test/self-replacement-centres2.html',
			calederData: {
				location: 'Residence/Office',
				subject: 'Maintenance Appointment',
				description: 'Maintenance appointment Booked'
			}
		},
		deliveryChange: {
			heading: 'Delivery Change',
			message: 'You need to reselect your Delivery and Installation appointment (if applicable), ' +
			'all your previous appointments will ' +
			'get cancelled. Are you sure you want to continue with it?.'
		},
		voucherSortingField: 'expiryDateX8',
		roiTextMessage: {
			heading: 'iPhone Pre-Order',
			description: 'Dear customer, please ensure that you enter the NRIC number used during your pre-order.',
			cisMessage: 'For Corporate Individual Scheme customers, please enter your company email address.',
			otpMessage: 'An email has been sent to your corporate email account.' +
			'Please enter your OTP (One Time Password)',
			invalidOtp: 'Invalid Otp.Please retry.'
		},
		singtelPopStation: {
			KioskId: 'P68',
			name: 'POPStation@Singtel Shop Comcentre',
			operationHours: '24 hours',
			blockOrHouseNum: '31B',
			unitNumber: '00',
			floorNo: '#01',
			buildingName: 'Singtel Comcentre II',
			streetName: 'Exeter Road',
			region: 'Central',
			postcode: '972300',
			latitude: '1.29906',
			longitude: '103.83902',
			zipCode: '239733',
			pickupMainTitle: 'Select your Collection Point',
			description: '',
			city: 'Singapore',
			location: 'Level 1, inside Singtel Shop'
		},
		FS_APPOINTMENT: {
			'LEAD_DAYS': 5,
			'PAYMENT_MODE': 'CASH',
			'DEALER_CODE': 'D2519',
			'HOME_DELIVERY_MOBILE': 'M',
			'HOME_DELIVERY_HOMEPRODUCT': 'V',
			'POP_STATION_MOBILE': 'P',
			'POP_STATION_HOMEPRODUCT': 'S',
			'SNAIL_MAIL_MOBILE': 'N'
		},
		couponApply: {
			error: 'Sorry, we’re unable to apply your coupon at this moment.' +
				'Please try again later.\r\n' +
				'Alternatively, you may call 1609 for assistance.',
			heading: 'Oops!',
			invalidCodeMessage: 'Sorry, the promo code you applied is invalid/expired.'
		},
		worryFreeAPI: {
			enquiryProduct: {
				url: '/api/precurring/v1/enquiryProduct',
				appId: 'PrepaidPortal'
			},
			getProduct: {
				url: '/api/precurring/v1/getProduct',
				appId: 'PrepaidPortal'
			},
			registerProduct: {
				url: '/api/precurring/v1/registerProductController',
				appId: 'PrepaidPortal'
			},
			cancelSubscription: {
				url: '/api/precurring/v1/terminateProduct',
				appId: 'PrepaidPortal'
			},
			modifySubscription: {
				url: '/api/precurring/v1/updateProduct',
				appId: 'PrepaidPortal'
			},
			getWorryFreeSubscriptionsUrl1: 'amdocs/contact/:contactId/customer/:customerId'
		},
		prepaidTopup: {
			worryFreeAppId: 'WRQ-SD-1',
			planLabels: {
				topupPlanTitle: 'Topup Plans',
				topupPlanDesc: 'Topup prepaid balance with favourite cards',
				dataPlanTitle: 'Data Plans',
				dataPlanDesc: 'Surf worry-free and get more value. Whatever your data needs' +
					' are, we have you covered.',
				socialPlanTitle: 'Social Plans',
				socialPlanDesc: 'Browse FAcebook, WhatsApp, WeChat and more, with no extra data chages.',
				selectSubscriptionTitle: 'Singtel Services',
				selectSubscriptionDesc: '{PLAN_PRICE} will be charged to the next bill of selected singtel service' +
				' number.'
			},
			topupAccount: {
				labels: {
					enterNumberHeader: 'Singtel Prepaid Number',
					enterNumberDesc: 'Enter the prepaid number you would like to topup.'
				}
			},
			topupPlanSelect: {
				whatNextTitle: 'Next Steps',
				whatNextDesc: ['A confirmation SMS will be sent to Prepaid number {PREPAID_NO} ' +
				'and {POSTPAID_NO} within the next 5 minutes']
			},
			automatedTopupExpiryDayOptions: [{
				title: '3 Days',
				value: '3'
			},{
				title: '7 Days',
				value: '7'
			},{
				title: '14 Days',
				value: '14'
			},{
				title: '30 Days',
				value: '30'
			},{
				title: 'Not Set',
				value: ''
			}],
			automatedTopupAmountOptions: [{
				title: '$1',
				value: '100'
			},{
				title: '$3',
				value: '300'
			},{
				title: '$8',
				value: '800'
			},{
				title: '$10',
				value: '1000'
			},{
				title: 'Not Set',
				value: ''
			}],
			automatedTopup: {
				noAutomatedTopup: 'You do not have any automated top-up',
				setAutoTopupTitle: 'Set Automated Top-up',
				autoTopupDesc: 'Would you like to automatically top up PREPAID number {PREPAID_NO} ' +
				'when the Main Account falls below certain amount?',
				setAutoTopupDesc: 'Setup automated top-up for your preferred Prepaid hi!Card number.',
				noThanksTitle: 'No, thanks',
				yesAutomatedTopupTitle: 'Yes, set up automated top-up',
				mainAcoountFallsBelowLabel: 'If Main Account falls below',
				expiryDateLabel: 'If expiry date is less than',
				chargeToLabel: 'Charge To',
				addBtnLabel: 'Add',
				tncText: 'I agree to the ',
				tncLinkText: 'terms and conditions',
				automatedTuopupTnCLink: 'http://www.singtel.com/prepaid',
				removeAutomatedTopupTitle: 'Remove automated top-up',
				removeAutomatedTopupDesc: 'Would you like to remove this automated top-up? ' +
				'Your recurring top up will stop immediately once you confirm the request.',
				cancelLabel: 'Cancel',
				yesRemoveLabel: 'Yes, remove automated top-up',
				addAutomatedTopupLabel: 'Add automated top-up',
				worryFreePlans: {
					'8022:Z1': {
						'price': 1000,
						'description': 'Automated Top Up $10',
						'code': '8022:Z1',
						'mode': 'worryfree',
						'accountId': '0'
					},
					'8022:Z51': {
						'price': 5000,
						'description': 'Automated Top Up $50',
						'code': '8022:Z5',
						'mode': 'worryfree',
						'accountId': '3'
					},
					'8022:Z15': {
						'price': 2800,
						'description': 'Automated Top Up SuperHot$128',
						'code': '8022:Z15',
						'mode': 'worryfree',
						'accountId': '1'
					}
				},
				requireWorryfreePlanErrMsg: 'Please select plan.',
				requireChargeToErrMsg: 'Please select charge to',
				requireDaysErrMsg: 'Please select expiry days',
				requireAmtErrMsg: 'Please select amount.',
				topupOptionsTitle: 'Top-up Options',
				modifyTopupTitle: 'Modify Automated Top-up',
				modifyBtnLabel: 'Modify',
				removeAutomatedTopupSuccessDesc: 'Your request for cancelling your Automated top-up has been received.'
			}
		},
		simulatorConfig: {
			isSimulatorOn: false,
			baseUrl: '/etc/designs/springd/clientlibs/uxf',
			'POST': {
				'amdocs/contact/(.*)/customer/(.*)': {
					url: '/businesswidget/repository_l9_common/common/fixture/information.json',
					isSimulatorOn: true
				},
				'/precurring/api/v1/enquiryProduct': {
					url: '/businesswidget/repository_l9_common/common/fixture/retrieveSponsPrepaidPrdt.json',
					isSimulatorOn: true
				},
				'/precurring/api/v1/getProduct': {
					url: '/businesswidget/repository_l9_common/common/fixture/getPrepaidPrdt.json',
					isSimulatorOn: true
				},
				'/precurring/api/v1/registerProduct': {
					url: '/businesswidget/repository_l9_common/common/fixture/registerProduct.json',
					isSimulatorOn: true
				},
				'/precurring/api/v1/terminateProduct': {
					url: '/businesswidget/repository_l9_common/common/fixture/terminateProduct.json',
					isSimulatorOn: true
				},
				'/precurring/api/v1/updateProduct': {
					url: '/businesswidget/repository_l9_common/common/fixture/updateProduct.json',
					isSimulatorOn: true
				},
				'/bin/services/singtel/ProductComponentModelServlet\\?mobiles=(.*)': {
					url: '/businesswidget/repository_l9_common/common/fixture/ProductComponent.json',
					isSimulatorOn: true
				}
			},
			'GET': {
				'/amdocs/contact/(.*)/customer/(.*)': {
					url: '/businesswidget/repository_l9_common/common/fixture/information.json',
					isSimulatorOn: true
				},
				'online-api/cxf/sg-loginservice/checkLogin(.*)': {
					url: '/businesswidget/repository_l9_common/common/fixture/checkLogin.json',
					isSimulatorOn: true
				}
			}
		},
		KeylineNominationCircleTwo: {
			headings: {
				mobile: 'Mobile',
				fibre: 'Fibre Broadband',
				fibreInline: 'Fibre',
				tv: 'Singtel TV',
				homeLine: 'Home Line',
				homeLineInline: 'Home Telephone',
				singtelCircle: 'Singtel Circle',
				addMobileLines: 'Additional mobile lines',
				keyNominationForMobile: 'This is your key nomination for mobile.',
				keyNominationForMobileInLine: 'Key mobile line',
				additionalNominated: 'Additional nominated mobile lines'
			},
			links: {
				marketingUrl: 'https://www.singtel.com/singtelcircle',
				eligibilityCriteriaUrl: 'https://www.singtel.com/content/dam/singtel/Ads_TermsAndConditions/' +
					'new_singtel_circle_eligibility_table.pdf',
				tAndCUrl: 'https://www.singtel.com/content/dam/singtel/Ads_TermsAndConditions/' +
					'new_singtel_circle_tncs.pdf'
			},
			mainScreen: {
				heading: 'Manage Singtel Circle',
				learnHowItWorks: 'Learn how it works',
				mobileImage: '/etc/designs/springd/clientlibs/osg/assets/images/circle/m-four-categories.png',
				desktopImage: '/etc/designs/springd/clientlibs/osg/assets/images/circle/d-four-categories.png',
				mainDescription: 'Bundle your Mobile plans, Fibre Broadband, Home Line and Singtel TV to form ' +
					'Singtel Circle and enjoy 10% OFF your Singtel bill.',
				addCircleBtn: 'Add Singtel Circle'
			},
			noCoreServicePopUp: {
				title: 'You are not eligible for Singtel Circle',
				description: 'To proceed, you will need to have a Mobile, Fibre Broadband, Home Line' +
					' and Singtel TV subscription that is registered under your ID.',
				elibilityCriteriaBtnTxt: 'See eligible criteria'
			},
			addEditCircle: {
				heading: 'Singtel Circle',
				showTextFields: 14,
				viewEligibleCriteriaLink: 'View eligibility criteria',
				viewEligibleCriteriaText: ' for service nomination and discounts.',
				nominateBtn: 'Review nomination',
				cancelBtn: 'Cancel',
				moreMobileLines: 'Add mobile lines',
				mobileSection: {
					topNote: 'Early device upgrade fee waiver is only applicable to your nominated key mobile line.' +
					' <a target="_blank" href="https://www.singtel.com/content/dam/singtel/Ads_TermsAndConditions/' +
					'new_singtel_circle_eligibility_table.pdf">View eligibility criteria</a> for service' +
					' nomination and discounts.',
					errorNote: 'Please nominate at least one XO Plus plan for Mobile.' +
						' This does not have to be your key nomination and could ' +
						'also be mobile lines that are not owned by you.',
					primaryKeylineinfoMsg: 'Once nominated, this will be your key mobile line and cannot be changed.',
					notSelectPrimaryMobLineError: 'Select a mobile number to proceed',
					defaultSelectedOption: 'Select key mobile line'
				},
				nonKeyLineSection: {
					heading: 'Additional mobile line nomination (optional)',
					infoMessage: 'You may also nominate additional mobile lines that are not registered under ' +
					' your ID, if it shares the same billing address as any of your Home Line installation ' +
					'addresses. Please ensure that your nominee has agreed to his/her mobile number being used by ' +
					'you for your Singtel Circle nomination.',
					addMoreMobLines: 'Add more mobile lines',
					errorMessages: {
						phoneNoFormat: 'Please enter a valid mobile number starting with 8 or 9',
						minLength: 'Please enter a minimum of 8 digits',
						maxLength: 'Please enter a maximum of 8 digits',
						doubleEnteredNumberError: 'You have entered the same number in your current nomination.' +
						' Please key in another number.'
					}
				}
			},
			reviewYourNomination: {
				heading: 'Review nomination',
				keyMobileLine: 'Nominated Key mobile line',
				confirmNominationBtn: 'Confirm'
			},
			looseExistingNomination: {
				title: 'By proceeding with the changes, you will lose your current discount entitlement',
				description: 'You will lose your current Singtel Circle discount entitlement and will have' +
					' to re-nominate your services to enjoy Singtel Circle benefits again.',
				viewTAndC: 'View Terms and Conditions',
				learnWorksLinkTxt: 'Learn more',
				proceedBtnTxt: 'Proceed anyway'
			},
			apiErrorOccurred: {
				header: 'Something went wrong',
				description: 'We are currently unable to proceed with your request. Please try again later.',
				backToCircleBtn: 'Back to Singtel Circle'
			},
			confirmNominationScreen: {
				heading: 'Nomination successful',
				description: {
					heading: 'What\'s next',
					descriptionLists: [
						'It may take up 2 billing cycles for any applicable discounts to be ' +
						'reflected on your bill statement.',
						'You may manage your Singtel Circle in My Account anytime.'
					]
				},
				manageSingtelCircle: 'Manage Singtel Circle'
			},
			validationErrorCodes: {
				'10005': 'Please nominate at least one XO Plus Mobile plan to proceed. This does not have to' +
					' be your key mobile line nomination and you may include any mobile lines not' +
					' registered under your ID.',
				'10006': 'Select a mobile number to proceed',
				'10007': 'Only Singtel postpaid mobile lines are eligible for nomination',
				'10008': 'Only active Singtel postpaid services are eligible for nomination',
				'10010': 'We are unable to process this request. For further assistance, please <u class="v-none-left' +
					' v-none-bottom"><a class="body-text" target="_blank" href="https://help.singtel.com/chat">chat' +
					' with us on WhatsApp</a></u>.',
				'10009': 'This mobile line is already an existing nomination under Singtel Circle',
				'10012': 'This mobile line does not share the same billing address as as any of your' +
					' Home Line installation addresses',
				'10013': 'This service does not meet the <u class="v-none-left v-none-bottom inline-block">' +
					'<a class="body-text" target="_blank" ' +
					'href="https://www.singtel.com/content/dam/singtel/Ads_TermsAndConditions/' +
					'new_singtel_circle_eligibility_table.pdf">eligibility criteria</a></u>',
				'10015': 'You have exceeded the maximum nominations of 15 mobile lines per Singtel Circle.' +
					' Please remove a mobile line to proceed.',
				'10016': 'You have entered the same number in your current nomination.' +
					' Please key in another number.'
			}
		},
		countryList: [
			{
				countryCode: '65',
				country: 'Singapore'
			},
			{
				countryCode: '93',
				country: 'Afghanistan'
			},
			{
				countryCode: '355',
				country: 'Albania'
			},
			{
				countryCode: '213',
				country: 'Algeria'
			},
			{
				countryCode: '376',
				country: 'Andorra'
			},
			{
				countryCode: '244',
				country: 'Angola'
			},
			{
				countryCode: '1264',
				country: 'Anguilla'
			},
			{
				countryCode: '1268',
				country: 'Antigua and Barbuda'
			},
			{
				countryCode: '54',
				country: 'Argentina'
			},
			{
				countryCode: '374',
				country: 'Armenia'
			},
			{
				countryCode: '297',
				country: 'Aruba'
			},
			{
				countryCode: '61',
				country: 'Australia'
			},
			{
				countryCode: '672',
				country: 'Australian Antarctic'
			},
			{
				countryCode: '43',
				country: 'Austria'
			},
			{
				countryCode: '994',
				country: 'Azerbaijan'
			},
			{
				countryCode: '1242',
				country: 'Bahamas'
			},
			{
				countryCode: '973',
				country: 'Bahrain'
			},
			{
				countryCode: '880',
				country: 'Bangladesh'
			},
			{
				countryCode: '1246',
				country: 'Barbados'
			},
			{
				countryCode: '375',
				country: 'Belarus'
			},
			{
				countryCode: '32',
				country: 'Belgium'
			},
			{
				countryCode: '501',
				country: 'Belize'
			},
			{
				countryCode: '229',
				country: 'Benin'
			},
			{
				countryCode: '1441',
				country: 'Bermuda'
			},
			{
				countryCode: '975',
				country: 'Bhutan'
			},
			{
				countryCode: '591',
				country: 'Bolivia'
			},
			{
				countryCode: '387',
				country: 'Bosnia and Herzegovina'
			},
			{
				countryCode: '267',
				country: 'Botswana'
			},
			{
				countryCode: '55',
				country: 'Brazil'
			},
			{
				countryCode: '673',
				country: 'Brunei'
			},
			{
				countryCode: '359',
				country: 'Bulgaria'
			},
			{
				countryCode: '226',
				country: 'Burkina Faso'
			},
			{
				countryCode: '257',
				country: 'Burundi'
			},
			{
				countryCode: '855',
				country: 'Cambodia'
			},
			{
				countryCode: '237',
				country: 'Cameroon'
			},
			{
				countryCode: '1',
				country: 'Canada'
			},
			{
				countryCode: '238',
				country: 'Cape Verde'
			},
			{
				countryCode: '1345',
				country: 'Cayman Islands'
			},
			{
				countryCode: '236',
				country: 'Central African Republic'
			},
			{
				countryCode: '235',
				country: 'Chad'
			},
			{
				countryCode: '56',
				country: 'Chile'
			},
			{
				countryCode: '86',
				country: 'China'
			},
			{
				countryCode: '61',
				country: 'Christmas Island'
			},
			{
				countryCode: '61',
				country: 'Cocos (Keeling) Islands'
			},
			{
				countryCode: '57',
				country: 'Colombia'
			},
			{
				countryCode: '269',
				country: 'Comoros'
			},
			{
				countryCode: '242',
				country: 'Congo'
			},
			{
				countryCode: '682',
				country: 'Cook Islands'
			},
			{
				countryCode: '506',
				country: 'Costa Rica'
			},
			{
				countryCode: '385',
				country: 'Croatia'
			},
			{
				countryCode: '53',
				country: 'Cuba'
			},
			{
				countryCode: '357',
				country: 'Cyprus'
			},
			{
				countryCode: '420',
				country: 'Czech Republic'
			},
			{
				countryCode: '45',
				country: 'Denmark'
			},
			{
				countryCode: '246',
				country: 'Diego Garcia'
			},
			{
				countryCode: '253',
				country: 'Djibouti'
			},
			{
				countryCode: '1767',
				country: 'Dominica'
			},
			{
				countryCode: '1809',
				country: 'Dominican Republic'
			},
			{
				countryCode: '670',
				country: 'East Timor'
			},
			{
				countryCode: '593',
				country: 'Ecuador'
			},
			{
				countryCode: '20',
				country: 'Egypt'
			},
			{
				countryCode: '503',
				country: 'El Salvador'
			},
			{
				countryCode: '240',
				country: 'Equatorial Guinea'
			},
			{
				countryCode: '291',
				country: 'Eritrea'
			},
			{
				countryCode: '372',
				country: 'Estonia'
			},
			{
				countryCode: '251',
				country: 'Ethiopia'
			},
			{
				countryCode: '500',
				country: 'Falkland Islands'
			},
			{
				countryCode: '679',
				country: 'Fiji'
			},
			{
				countryCode: '358',
				country: 'Finland'
			},
			{
				countryCode: '33',
				country: 'France'
			},
			{
				countryCode: '594',
				country: 'French Gulana'
			},
			{
				countryCode: '241',
				country: 'Gabon'
			},
			{
				countryCode: '220',
				country: 'Gambia'
			},
			{
				countryCode: '995',
				country: 'Georgia'
			},
			{
				countryCode: '49',
				country: 'Germany'
			},
			{
				countryCode: '233',
				country: 'Ghana'
			},
			{
				countryCode: '350',
				country: 'Gibraltar'
			},
			{
				countryCode: '30',
				country: 'Greece'
			},
			{
				countryCode: '299',
				country: 'Greenland'
			},
			{
				countryCode: '1473',
				country: 'Grenada'
			},
			{
				countryCode: '590',
				country: 'Guadeloupe'
			},
			{
				countryCode: '1671',
				country: 'Guam'
			},
			{
				countryCode: '53',
				country: 'Guantanamo'
			},
			{
				countryCode: '502',
				country: 'Guatemala'
			},
			{
				countryCode: '224',
				country: 'Guinea'
			},
			{
				countryCode: '245',
				country: 'Guinea-Bissau'
			},
			{
				countryCode: '592',
				country: 'Guyana'
			},
			{
				countryCode: '509',
				country: 'Haiti'
			},
			{
				countryCode: '504',
				country: 'Honduras'
			},
			{
				countryCode: '852',
				country: 'Hong Kong'
			},
			{
				countryCode: '36',
				country: 'Hungary'
			},
			{
				countryCode: '354',
				country: 'Iceland'
			},
			{
				countryCode: '91',
				country: 'India'
			},
			{
				countryCode: '62',
				country: 'Indonesia'
			},
			{
				countryCode: '98',
				country: 'Iran'
			},
			{
				countryCode: '964',
				country: 'Iraq'
			},
			{
				countryCode: '353',
				country: 'Ireland'
			},
			{
				countryCode: '972',
				country: 'Israel'
			},
			{
				countryCode: '39',
				country: 'Italy'
			},
			{
				countryCode: '225',
				country: 'Ivory Coast'
			},
			{
				countryCode: '1876',
				country: 'Jamaica'
			},
			{
				countryCode: '81',
				country: 'Japan'
			},
			{
				countryCode: '962',
				country: 'Jordan'
			},
			{
				countryCode: '7',
				country: 'Kazakhstan'
			},
			{
				countryCode: '254',
				country: 'Kenya'
			},
			{
				countryCode: '686',
				country: 'Kiribati'
			},
			{
				countryCode: '965',
				country: 'Kuwait'
			},
			{
				countryCode: '996',
				country: 'Kyrgyzstan'
			},
			{
				countryCode: '856',
				country: 'Laos'
			},
			{
				countryCode: '371',
				country: 'Latvia'
			},
			{
				countryCode: '961',
				country: 'Lebanon'
			},
			{
				countryCode: '266',
				country: 'Lesotho'
			},
			{
				countryCode: '231',
				country: 'Liberia'
			},
			{
				countryCode: '218',
				country: 'Libya'
			},
			{
				countryCode: '423',
				country: 'Liechtenstein'
			},
			{
				countryCode: '370',
				country: 'Lithuania'
			},
			{
				countryCode: '352',
				country: 'Luxembourg'
			},
			{
				countryCode: '853',
				country: 'Macau'
			},
			{
				countryCode: '389',
				country: 'Macedonia'
			},
			{
				countryCode: '261',
				country: 'Madagascar'
			},
			{
				countryCode: '265',
				country: 'Malawi'
			},
			{
				countryCode: '60',
				country: 'Malaysia'
			},
			{
				countryCode: '960',
				country: 'Maldives'
			},
			{
				countryCode: '223',
				country: 'Mali'
			},
			{
				countryCode: '356',
				country: 'Malta'
			},
			{
				countryCode: '1670',
				country: 'Mariana Islands'
			},
			{
				countryCode: '692',
				country: 'Marshall Islands'
			},
			{
				countryCode: '596',
				country: 'Martinique'
			},
			{
				countryCode: '222',
				country: 'Mauritania'
			},
			{
				countryCode: '230',
				country: 'Mauritius'
			},
			{
				countryCode: '52',
				country: 'Mexico'
			},
			{
				countryCode: '691',
				country: 'Micronesia'
			},
			{
				countryCode: '1808',
				country: 'Midway Islands'
			},
			{
				countryCode: '373',
				country: 'Moldova'
			},
			{
				countryCode: '377',
				country: 'Monaco'
			},
			{
				countryCode: '976',
				country: 'Mongolia'
			},
			{
				countryCode: '1664',
				country: 'Montserrat'
			},
			{
				countryCode: '212',
				country: 'Morocco'
			},
			{
				countryCode: '258',
				country: 'Mozambique'
			},
			{
				countryCode: '95',
				country: 'Myanmar'
			},
			{
				countryCode: '264',
				country: 'Namibia'
			},
			{
				countryCode: '674',
				country: 'Nauru'
			},
			{
				countryCode: '977',
				country: 'Nepal'
			},
			{
				countryCode: '31',
				country: 'Netherlands'
			},
			{
				countryCode: '599',
				country: 'Netherlands Antilles'
			},
			{
				countryCode: '687',
				country: 'New Caledonia'
			},
			{
				countryCode: '64',
				country: 'New Zealand'
			},
			{
				countryCode: '505',
				country: 'Nicaragua'
			},
			{
				countryCode: '227',
				country: 'Niger'
			},
			{
				countryCode: '234',
				country: 'Nigeria'
			},
			{
				countryCode: '683',
				country: 'Niue'
			},
			{
				countryCode: '672',
				country: 'Norfolk Island'
			},
			{
				countryCode: '850',
				country: 'North Korea'
			},
			{
				countryCode: '47',
				country: 'Norway'
			},
			{
				countryCode: '968',
				country: 'Oman'
			},
			{
				countryCode: '92',
				country: 'Pakistan'
			},
			{
				countryCode: '507',
				country: 'Panama'
			},
			{
				countryCode: '675',
				country: 'Papua New Guinea'
			},
			{
				countryCode: '595',
				country: 'Paraguay'
			},
			{
				countryCode: '51',
				country: 'Peru'
			},
			{
				countryCode: '63',
				country: 'Philippines'
			},
			{
				countryCode: '48',
				country: 'Poland'
			},
			{
				countryCode: '351',
				country: 'Portugal'
			},
			{
				countryCode: '1787',
				country: 'Puerto Rico'
			},
			{
				countryCode: '974',
				country: 'Qatar'
			},
			{
				countryCode: '262',
				country: 'Reunion Islands'
			},
			{
				countryCode: '40',
				country: 'Romania'
			},
			{
				countryCode: '7',
				country: 'Russia'
			},
			{
				countryCode: '250',
				country: 'Rwanda'
			},
			{
				countryCode: '684',
				country: 'Samoa American'
			},
			{
				countryCode: '685',
				country: 'Samoa Western'
			},
			{
				countryCode: '378',
				country: 'San Marino'
			},
			{
				countryCode: '239',
				country: 'Sao Tome and Principe'
			},
			{
				countryCode: '966',
				country: 'Saudi Arabia'
			},
			{
				countryCode: '221',
				country: 'Senegal'
			},
			{
				countryCode: '248',
				country: 'Seychelles'
			},
			{
				countryCode: '232',
				country: 'Sierra Leone'
			},
			{
				countryCode: '421',
				country: 'Slovakia'
			},
			{
				countryCode: '386',
				country: 'Slovenia'
			},
			{
				countryCode: '677',
				country: 'Solomon Islands'
			},
			{
				countryCode: '252',
				country: 'Somalia'
			},
			{
				countryCode: '27',
				country: 'South Africa'
			},
			{
				countryCode: '82',
				country: 'South Korea'
			},
			{
				countryCode: '34',
				country: 'Spain'
			},
			{
				countryCode: '94',
				country: 'Sri Lanka'
			},
			{
				countryCode: '290',
				country: 'Saint Helena'
			},
			{
				countryCode: '1869',
				country: 'Saint Kitts and Nevis'
			},
			{
				countryCode: '1758',
				country: 'Saint Lucia'
			},
			{
				countryCode: '508',
				country: 'Saint Pierre and Miquelon'
			},
			{
				countryCode: '1784',
				country: 'Saint Vincent and the Grenadines'
			},
			{
				countryCode: '249',
				country: 'Sudan'
			},
			{
				countryCode: '597',
				country: 'Suriname'
			},
			{
				countryCode: '268',
				country: 'Swaziland'
			},
			{
				countryCode: '46',
				country: 'Sweden'
			},
			{
				countryCode: '41',
				country: 'Switzerland'
			},
			{
				countryCode: '963',
				country: 'Syria'
			},
			{
				countryCode: '689',
				country: 'Tahiti'
			},
			{
				countryCode: '886',
				country: 'Taiwan'
			},
			{
				countryCode: '992',
				country: 'Tajikistan'
			},
			{
				countryCode: '255',
				country: 'Tanzania'
			},
			{
				countryCode: '66',
				country: 'Thailand'
			},
			{
				countryCode: '88216',
				country: 'Thuraya'
			},
			{
				countryCode: '228',
				country: 'Togo'
			},
			{
				countryCode: '690',
				country: 'Tokelau'
			},
			{
				countryCode: '676',
				country: 'Tonga'
			},
			{
				countryCode: '1868',
				country: 'Trinidad and Tobago'
			},
			{
				countryCode: '216',
				country: 'Tunisia'
			},
			{
				countryCode: '90',
				country: 'Turkey'
			},
			{
				countryCode: '993',
				country: 'Turkmenistan'
			},
			{
				countryCode: '1649',
				country: 'Turks and Caicos Islands'
			},
			{
				countryCode: '688',
				country: 'Tuvalu'
			},
			{
				countryCode: '256',
				country: 'Uganda'
			},
			{
				countryCode: '380',
				country: 'Ukraine'
			},
			{
				countryCode: '971',
				country: 'United Arab Emirates'
			},
			{
				countryCode: '44',
				country: 'United Kingdom'
			},
			{
				countryCode: '1',
				country: 'United States of America'
			},
			{
				countryCode: '598',
				country: 'Uruguay'
			},
			{
				countryCode: '998',
				country: 'Uzbekistan'
			},
			{
				countryCode: '678',
				country: 'Vanuatu'
			},
			{
				countryCode: '39',
				country: 'Vatican City'
			},
			{
				countryCode: '58',
				country: 'Venezuela'
			},
			{
				countryCode: '84',
				country: 'Vietnam'
			},
			{
				countryCode: '1284',
				country: 'Virgin Islands (British)'
			},
			{
				countryCode: '1340',
				country: 'Virgin Islands (US)'
			},
			{
				countryCode: '681',
				country: 'Wallis and Futuna'
			},
			{
				countryCode: '967',
				country: 'Yemen'
			},
			{
				countryCode: '381',
				country: 'Yugoslavia'
			},
			{
				countryCode: '243',
				country: 'Zaire'
			},
			{
				countryCode: '260',
				country: 'Zambia'
			},
			{
				countryCode: '263',
				country: 'Zimbabwe'
			}
		],
		expressCheckout: {
			title: 'How would you like to proceed?.',
			description: 'We are introducing an express checkout which simplifies the checkout process.' +
			'Would you like to try it?.',
			continueShoppingLink: 'No thanks',
			expressCheckoutButtonLabel: 'Express Checkout',
			contactNumberHeading: 'Update my contact number',
			contactNumberMsg: 'Please enter your new mobile contact number below.',
			changeEmailHeading: 'Update my email address',
			changeEmailMsg: 'Your future eBill notification will be sent to your new email address.',
			successHeading: 'Successful!',
			successMsg: 'Your contact details is updated.'
		},
		singtelEnergy: {
			housingDetails: [
				{
					'value': 'Please Select',
					'text': 'Please Select',
					'selected' : true
				},
				{
					'value': 'Bungalow/Penthouse/Townhouse',
					'text': 'Bungalow/Penthouse/Townhouse'
				},
				{
					'value': 'HDB 1-Room',
					'text': 'HDB 1-Room'
				},
				{
					'value': 'HDB 2-Room',
					'text': 'HDB 2-Room'
				},
				{
					'value': 'HDB 3-Room',
					'text': 'HDB 3-Room'
				},
				{
					'value': 'HDB 4-Room',
					'text': 'HDB 4-Room'
				},
				{
					'value': 'HDB 5-Room',
					'text': 'HDB 5-Room'
				},
				{
					'value': 'HDB Executive/HUDC Flat',
					'text': 'HDB Executive/HUDC Flat'
				},
				{
					'value': 'Private Apartment/Condominium',
					'text': 'Private Apartment/Condominium'
				},
				{
					'value': 'Semi-Detached House',
					'text': 'Semi-Detached House'
				},
				{
					'value': 'Terrace House',
					'text': 'Terrace House'
				}
			]
		},
		roiEmailNotification: {
			nric: 'email_nric',
			mobile: 'email_mobile',
			email: 'email_email',
			okToContact: 'email_okToContact',
			createdDate: 'email_createdDate',
			lastModifyDate: 'email_lastModifyDate',
			campaignCode: 'email_campaignCode',
			cusName: 'email_name',
			serviceAddress: 'email_serviceAdd'
		},
		callbackEmailNotification: {
			desc: 'email_desc',
			name: 'email_name',
			number: 'email_mobile',
			nric: 'email_nric',
			selectedPlan: 'email_plan',
			srp_event_energy: 'email_energy'
		},
		roiCampaignCode: '201810_Energy',
		reconVoucher: '22',
		redVoucher: '25',
		switchToEbill: 'Switch to eBill',
		eBillRegistrationUrl: '/content/singtel/en/personal/my-account/bills-payments/bill-request-alerts',
		isWorryFreeCREnabled: true,
		worryFreeLobTopics: {
			'DeviceIdAndPlanIdInContextTopic':
			'businesswidget/repository_l9_common/common/viewmodel/contextTopics/DeviceIdAndPlanIdInContextTopic',
			'MiniCartInContextTopic':
			'businesswidget/repository_l9_common/common/viewmodel/contextTopics/MiniCartInContextTopic',
			'OrderInContextTopicViewModel':
			'businesswidget/repository_l9_common/common/viewmodel/contextTopics/OrderInContextTopicViewModel'
		},
		worryFree: {
			'otpSendHeader': 'Recontract',
			'otpSendSubHeader': 'Enter the Singtel mobile you would like to recontract to receive a' +
			' one-time PIN and the NRIC/FIN subscribed to this number.',
			'otpSendNricHeader': 'NRIC or FIN',
			'onePassSigninClickText': 'Or sign in via OnePass',
			'otpSendIdTypeHeader': 'Id Type',
			'contactNumberLabel': 'Mobile number',
			'otpVerifyHeader': 'Verify your mobile number',
			'otpVerifySubHeader': 'Enter your one-time PIN(OTP) sent to your mobile number ' +
			'within the next ',
			'otpVerifyOtpHeader': 'One-time PIN(OTP)',
			'otpVerifyResendHeader': 'Resend OTP',
			'otpVerifyFAHeader': 'Verify your Singtel services',
			'otpVerifyFASubHeader': 'Enter the Singtel account number so that we can verify your service with' +
			'us.<br/>You can find your account number on your Singtel bill.',
			'otpVerifyFAToolTip': 'Your Singtel Account Number can be found on the top right hand side' +
			' of your printed bill and e-Bill from My Singtel App',
			'otpVerifyFAToolTipImg': {
				'src': 'assets/images/avatars/chunk.jpg',
				'alt' : 'imagealt'
			},
			'otpVerifyFANumberLabel': 'Account number',
			'invalidPhoneNumber': 'Invalid phone number',
			'requiredField': 'Field can not be empty',
			'worryFreeNewCustomer': 'This is new Customer',
			'worryFreeOtpSendError': 'Error in Sending OTP Please try after some time',
			'worryFreeOtpSendFailed': 'Error Occured ! Please try after some time',
			'worryFreeOtpNotVerified': 'Please Enter valid OTP',
			'worryFreeOtpReconNotVerified': 'Please re-enter correct Recon number',
			'worryFreeOtpVerifyError': 'Virification failed, please try after sometime',
			'worryFreeOtpVerifyFailed': 'Virification failed',
			'worryFreeOtpBillingActVerifyFailed': 'Fa verification failed',
			'worryFreeOtpBillingActVerifyError': 'Fa verification pending, please try after some time',
			'worryFreeExistingCustomerReSendOTP': 'OTP resend Successfully',
			'worryFreeOtpSendErrorReSendOTP': 'Error in Sending OTP Please try after some time',
			'worryFreeOtpSendFailedReSendOTP': 'Error Occured ! Please try after some time',
			'timer': 3,
			'worryFreeOtpExpired': 'OTP Expired! Please try sending new OTP',
			'worryFreeFooterMsg': 'Want to recontract a different number ',
			'worryFreeFooterMsgBody': {
				'reEnterLinkText': 'Re-enter',
				'reEnterLinkMsg': ' mobile number ',
				'onePassLinkText': 'One Pass',
				'onePassLinkMsg': 'Via one pass'
			},
			'idontKnowLink': '/content/singtel/en/personal/my-account/bills-payments/bill-request-alerts',
			'idontKnowText': 'I don\'t know'
		},
		recontractSim: {
			heading: 'SIM Card',
			description: 'Would you like to have a new SIM card?\r\nNew SIM card fee of $37.45 will apply.',
			noButtonText: 'No',
			yesButtonText: 'Yes'
		},
		collectNowZoneList: [
		{
			'value': '',
			'text': 'Please Select'
		},
		{
			'value': 'central',
			'text': 'Central'
		},
		{
			'value': 'north',
			'text': 'North'
		},
		{
			'value': 'east',
			'text': 'East'
		},
		{
			'value': 'west',
			'text': 'West'
		},
		{
			'value': 'south',
			'text': 'South'
		}],
		deliveryGroupOptions: [{
			'groupId': 'collectNow',
			'groupHeader': 'Self collection Now',
			'groupTitle': 'Pick up from your available collection points at your convenience.',
			'notes': 'collect now notes',
			'price': null,
			'groupRibbon': 'recommended'
		},
		{
			'groupId': 'collectLater',
			'groupHeader': 'Self collection Later',
			'groupTitle': 'Pick up from your preferred POPstation or Singtel Shop at your convenience',
			'notes': 'collect later notes',
			'price': '4',
			'groupRibbon': null
		},
		{
			'groupId': 'delivery',
			'groupHeader': 'Delivery',
			'groupTitle': 'Get your purchase delivered to your door step.',
			'notes': 'delivery notes',
			'price': '6',
			'groupRibbon': null
		}],
		map: {
			'west': 'West',
			'Central': 'Central',
			'east': 'East',
			'north': 'North',
			'south': 'South',
			'northeast': 'North East',
			'central': 'Central'

		},
		onePayEBillCrOn: false,
		deliveryGroupPriority: [{
			'groupId': 'collectNow',
			'index': 0
		},
		{
			'groupId': 'collectLater',
			'index': 2
		},
		{
			'groupId': 'delivery',
			'index': 3
		}],
		storeZoneList: [
		{
			'value': '',
			'text': 'Please Select'
		},
		{
			'value': 'central',
			'text': 'Central'
		},
		{
			'value': 'north',
			'text': 'North'
		},
		{
			'value': 'east',
			'text': 'East'
		},
		{
			'value': 'west',
			'text': 'West'
		},
		{
			'value': 'south',
			'text': 'South'
		}],
		eAppointmentCrOn: true,
		eAppointmentCareCrOn: true,
		shopEApt: {
			shop: {
				cusIdType: 'C',
				source: 'eShop'
			},
			care: {
				cusIdType: 'C',
				anonymousCusIdType: 'M',
				source: 'eCare',
				endDays: 5
			},
			transactionType: {
				existingService: 'existing_service',
				newService: 'new_service'
			},
			endDays: 5,
			aAptTimeLimitHours: 1,
			skuDateFormat: 'DD/MM/YYYY HH:mm',
			onlyDateFormat: 'DD/MM/YYYY',
			lobToServiceType: {
				'MOB': 'Mobile',
				'WS': 'Mobile',
				'FV': 'home telephone',
				'BB': 'fibre broadband',
				'FBB': 'fibre broadband',
				'TV': 'Singtel TV',
				'MBB': 'mobile broadband'
			}
		},
		numberMap: {
			'0': 'zero',
			'1': 'one',
			'2': 'two',
			'3': 'three',
			'4': 'four',
			'5': 'five',
			'6': 'six',
			'7': 'seven',
			'8': 'eight',
			'9': 'nine',
			'10': 'ten'
		},
		ftthCrOn: true,
		singnetIdOptions: {
			totalNoOfChar: 9,
			firstChar: 'BB',
			totalNumbers: 7
		},
		PROMO: {
			redeemPromoLink: 'https://www.singtel.com/personal/products-services/' +
			'broadband/fibre-broadband-plans'
		},
		tvCropTextConfig: {
			desktopChars: 150,
			mobileChars: 80,
			tabletChars: 130,
			mobileTitleChars: 30
		},
		deviceCareBOs: [/*{
			name: 'MobileSwop',
			id: '14482'
		},{
			name: 'MobileSwop',
			id: '17396731'
		},{
			name: 'MobileSwop',
			id: '17396741'
		},{
			name: 'MobileSwop',
			id: '26082514'
		},{
			name: 'MobileSwop',
			id: '26082504'
		},{
			name: 'MobileSwop',
			id: '17394531'
		},
		{
			name: 'MobileSwop',
			id: '26082494'
		}*/{
			name: 'SamsungConcierge',
			id: '14426026'

		},{
			name: 'AppleCare',
			id: '12357331',
			specIds: ['71138676', '71138706', '71138736', '71138766', '71138796', '71138826', '71138856', '71157546',
			'71157576', '71157616', '71157646', '71157676', '71157706', '71157736', '71157766', '71157796', '71157826',
			'71224606']
		},{
			name: 'AppleCare',
			id: '12357321',
			specIds: ['17480961','17480991','17481021','17481051','17481081','17481111','12509761','12509791',
			'12509821','12509851','14395352','14395382','14395412','14395442','12509641','12509671','12509701',
			'12509731','12509521','12509551','12509581','12509611','12509161','12509191','12509221','8448892',
			'14783396','12509071','12509101','12509131','12508981','12509011','12509041','13956991','13957021',
			'13957051','13957801','17480931','13957231','13957261','13957291','13957321','13957351','14881936',
			'13957081','13957111','13957141','13957171','13957201','14881756','40031243','40031273']

		},{
			name: 'AppleCare',
			id: '8436122',
			specIds: ['12507451','12507481','12507511','12507541','12507571','12507601','12507631','12507661',
			'12507691','12507721','12507751','12507781','12507811','12507841','12507871','12507901','12507931',
			'12507961','12507991','12508021','12508051','12508081','12508111','12508141','12508171','12508201',
			'12508231','12508261','12508291','12508321','12508351','12508381','12508411','12508441','12508471',
			'12508501','12508531','12508561','12508591','12508621','12508651','12508681','12508711','12508741',
			'12508771','14395472','14395502','14395532','14395562','14395592','14395622']

		},{
			name: 'AppleCare',
			id: '12357311',
			specIds: ['17481291', '17481321', '17481351', '17481381', '17481411', '17481441', '12510121', '12510151',
			'12510181','12510211','14395232','14395262','14395292','14395322','12510001','12510031','12510061',
			'12510091','12509881','12509911','12509941','12509971','12509431','12509461','12509491','12509341',
			'12509371','12509401','12509251','12509281','12509311','13957381','13957411','13957441','13957471',
			'17481261','13957651','13957681','13957711','13957741','13957771','14882976','13957501','13957531',
			'13957561','13957591','13957621','14882946','40031303','40031333','41223442','41223472','41223502',
			'41223532','41223562','41223592','41223622','41239492','41223682','41223712','41223742','41223772',
			'41223802','41223832','41222782','41222812','41222842','41222872','71152706','71152736','71152766',
			'71152796','71152826','71152856','71152886','71152916','71152946','71152976','71153006','71153036',
			'71153066','71153096','71153126','71153156','71153186','71153216']
		},{
			name: 'AppleCare',
			id: '17478061',
			specIds: ['17481141','17481171', '17481201', '17481231','41222902','41222932','41222962','41222992',
			'41223022','41223052','41251492','41223112','41223142','41223172','41223202','41223232','41223262',
			'41223292','41223322','41223352','41223382','41223412','71153246','71153276','71153306','71153336',
			'71153366','71153396','71153426','71153456','71153486','71153516','71153546','71153576','71153606',
			'71153636','71153666','71153696','71153726','71153756','71153786','71153816','71153846','71153876',
			'71153906','71153936']
		},{
			name: 'AppleCare',
			id: '40028702',
			specIds: ['12507991','12508021','12508051','18449241','18449271','18449301','18449331','18449361',
			'18449391']
		},{
			name: 'AppleCare',
			id: '40028712',
			specIds: ['15159596','15159626','15159656','15159686','15159716','15159746','15159776','15159806',
			'15159836','15159866','15159896','15159926','50026052','50026082','50026112','50026142','50026172',
			'50026202','50026232','50026262','50026292','50026322','50026352','50026382','50026412','50026442',
			'50026472','50026502','71368776','71368806','71368836','71368866','71368896','71368926','71368956',
			'71368986','71369016','71369046','71369076','71369106','71369136','71369166','71369196','71369226']
		},{
			name: 'AppleCare',
			id: '17456671',
			specIds: ['71385896','71385926','71385956','71385986','71386016','71386046','71386076','71386106',
			'71386136']
		}],
		unbilledUsagePlansList: {
			basePlansList: '3000,1001,1002',
			dataStackingPlansList: '34000',
			dataX2List: '34999',
			dataX3List: '3136'
		},
		ippPlansStrings : {
			deviceAndAccessoriesTitle: 'Devices/accessories',
			instalment: 'instalment'
		},
		distanceLimit: 10000,
		allowedStbTypes: {
			upgd: {
				'DVR': ['Gen 3 DVR record'],
				'Non-DVR': ['Gen 3 DVR record', 'DVR', 'Android TV '],
				'Android TV ': ['Gen 3 DVR record', 'DVR']
			},
			dwngd: {
				'Gen 3 DVR record': ['Non-DVR', 'DVR', 'Android TV '],
				'DVR': ['Non-DVR', 'Android TV '],
				'Android TV ': ['Non-DVR']
			}
		},
		ineligible: {
			dwngd: 'Downgrade is not allowed with available STB types.',
			upgd: 'Upgrade is not allowed with available STB types.'
		},
		IPPReconError: {
			header: 'IPP Recon Error',
			messages: 'Recon can\'t be done within 1 month.'
		},
		redemptionHeader: {
			headerText : 'Redemption Of'
		},
		futureSuspendErrorMsg: 'We are sorry, you are not allowed to do recontract on this service. Please' +
			' contact our customer care.',
		tosEligibility: 'Sorry, your Mobile line is not eligible for Temporary Suspension of Service at the moment.' +
			'There is a min. of 3 months before the service may be suspended again',
		submittedReconOrderFoundMsg: 'You already have submitted an order for this plan. Please call 1609.',
		deviceNotUpgradedMsg: 'Sorry, you will need to have fulfilled more than 12 months of your contract' +
			' in order to upgrade your device. For more information, check out our FAQs.',
		pendingPaymentErrorMsg: 'We are sorry, you can not continue with this order as your previous order' +
			' is pending payment realization.',
		redPlanOffers: ['2235725'],
		preOrderDateSelectionLiner: 'Note that for pre-orders, your selection is an indicative date and will ' +
			'be subjected to stock availability.',
		preOrderDeliveryHeader: 'Delivery',
		preOrderDeliveryDateAndTimeSubheader: 'Date and Time:',
		preOrderDeliveryAddressSubheader: 'Address:',
		preOrderLabel: '[Pre-order]',
		preOrderAvailabilityMsg: 'Available as pre-order',
		voucherType: '25',
		mbbOfferIdsList: ['11297311', '10050821', '18779331','18797191'],
		creditLimitIncreasePopup: {
			headerText: 'Singtel Credit Limit Review Completed',
			bodyText: 'You may continue with your purchase.',
			addOnsButton: 'Select add-ons',
			changePlanButton: 'Proceed to change plan',
			transferOwnershipButton: 'Proceed to transfer ownership'
		},
		tvContentPackUrl: '/personal/products-services/tv/packs',
		priorityItemIconUrl: '/content/dam/singtel/online-draft/5G_Priority_FA.gif'
	};
});

!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define('moment',t):e.moment=t()}(this,function(){"use strict";var H;function _(){return H.apply(null,arguments)}function y(e){return e instanceof Array||"[object Array]"===Object.prototype.toString.call(e)}function F(e){return null!=e&&"[object Object]"===Object.prototype.toString.call(e)}function c(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function L(e){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(e).length;for(var t in e)if(c(e,t))return;return 1}function g(e){return void 0===e}function w(e){return"number"==typeof e||"[object Number]"===Object.prototype.toString.call(e)}function V(e){return e instanceof Date||"[object Date]"===Object.prototype.toString.call(e)}function G(e,t){for(var n=[],s=e.length,i=0;i<s;++i)n.push(t(e[i],i));return n}function E(e,t){for(var n in t)c(t,n)&&(e[n]=t[n]);return c(t,"toString")&&(e.toString=t.toString),c(t,"valueOf")&&(e.valueOf=t.valueOf),e}function l(e,t,n,s){return Wt(e,t,n,s,!0).utc()}function p(e){return null==e._pf&&(e._pf={empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidEra:null,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],era:null,meridiem:null,rfc2822:!1,weekdayMismatch:!1}),e._pf}function A(e){var t,n,s=e._d&&!isNaN(e._d.getTime());return s&&(t=p(e),n=j.call(t.parsedDateParts,function(e){return null!=e}),s=t.overflow<0&&!t.empty&&!t.invalidEra&&!t.invalidMonth&&!t.invalidWeekday&&!t.weekdayMismatch&&!t.nullInput&&!t.invalidFormat&&!t.userInvalidated&&(!t.meridiem||t.meridiem&&n),e._strict)&&(s=s&&0===t.charsLeftOver&&0===t.unusedTokens.length&&void 0===t.bigHour),null!=Object.isFrozen&&Object.isFrozen(e)?s:(e._isValid=s,e._isValid)}function I(e){var t=l(NaN);return null!=e?E(p(t),e):p(t).userInvalidated=!0,t}var j=Array.prototype.some||function(e){for(var t=Object(this),n=t.length>>>0,s=0;s<n;s++)if(s in t&&e.call(this,t[s],s,t))return!0;return!1},Z=_.momentProperties=[],z=!1;function q(e,t){var n,s,i,r=Z.length;if(g(t._isAMomentObject)||(e._isAMomentObject=t._isAMomentObject),g(t._i)||(e._i=t._i),g(t._f)||(e._f=t._f),g(t._l)||(e._l=t._l),g(t._strict)||(e._strict=t._strict),g(t._tzm)||(e._tzm=t._tzm),g(t._isUTC)||(e._isUTC=t._isUTC),g(t._offset)||(e._offset=t._offset),g(t._pf)||(e._pf=p(t)),g(t._locale)||(e._locale=t._locale),0<r)for(n=0;n<r;n++)g(i=t[s=Z[n]])||(e[s]=i);return e}function $(e){q(this,e),this._d=new Date(null!=e._d?e._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===z&&(z=!0,_.updateOffset(this),z=!1)}function k(e){return e instanceof $||null!=e&&null!=e._isAMomentObject}function B(e){!1===_.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+e)}function e(r,a){var o=!0;return E(function(){if(null!=_.deprecationHandler&&_.deprecationHandler(null,r),o){for(var e,t,n=[],s=arguments.length,i=0;i<s;i++){if(e="","object"==typeof arguments[i]){for(t in e+="\n["+i+"] ",arguments[0])c(arguments[0],t)&&(e+=t+": "+arguments[0][t]+", ");e=e.slice(0,-2)}else e=arguments[i];n.push(e)}B(r+"\nArguments: "+Array.prototype.slice.call(n).join("")+"\n"+(new Error).stack),o=!1}return a.apply(this,arguments)},a)}var J={};function Q(e,t){null!=_.deprecationHandler&&_.deprecationHandler(e,t),J[e]||(B(t),J[e]=!0)}function a(e){return"undefined"!=typeof Function&&e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}function X(e,t){var n,s=E({},e);for(n in t)c(t,n)&&(F(e[n])&&F(t[n])?(s[n]={},E(s[n],e[n]),E(s[n],t[n])):null!=t[n]?s[n]=t[n]:delete s[n]);for(n in e)c(e,n)&&!c(t,n)&&F(e[n])&&(s[n]=E({},s[n]));return s}function K(e){null!=e&&this.set(e)}_.suppressDeprecationWarnings=!1,_.deprecationHandler=null;var ee=Object.keys||function(e){var t,n=[];for(t in e)c(e,t)&&n.push(t);return n};function r(e,t,n){var s=""+Math.abs(e);return(0<=e?n?"+":"":"-")+Math.pow(10,Math.max(0,t-s.length)).toString().substr(1)+s}var te=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,ne=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,se={},ie={};function s(e,t,n,s){var i="string"==typeof s?function(){return this[s]()}:s;e&&(ie[e]=i),t&&(ie[t[0]]=function(){return r(i.apply(this,arguments),t[1],t[2])}),n&&(ie[n]=function(){return this.localeData().ordinal(i.apply(this,arguments),e)})}function re(e,t){return e.isValid()?(t=ae(t,e.localeData()),se[t]=se[t]||function(s){for(var e,i=s.match(te),t=0,r=i.length;t<r;t++)ie[i[t]]?i[t]=ie[i[t]]:i[t]=(e=i[t]).match(/\[[\s\S]/)?e.replace(/^\[|\]$/g,""):e.replace(/\\/g,"");return function(e){for(var t="",n=0;n<r;n++)t+=a(i[n])?i[n].call(e,s):i[n];return t}}(t),se[t](e)):e.localeData().invalidDate()}function ae(e,t){var n=5;function s(e){return t.longDateFormat(e)||e}for(ne.lastIndex=0;0<=n&&ne.test(e);)e=e.replace(ne,s),ne.lastIndex=0,--n;return e}var oe={D:"date",dates:"date",date:"date",d:"day",days:"day",day:"day",e:"weekday",weekdays:"weekday",weekday:"weekday",E:"isoWeekday",isoweekdays:"isoWeekday",isoweekday:"isoWeekday",DDD:"dayOfYear",dayofyears:"dayOfYear",dayofyear:"dayOfYear",h:"hour",hours:"hour",hour:"hour",ms:"millisecond",milliseconds:"millisecond",millisecond:"millisecond",m:"minute",minutes:"minute",minute:"minute",M:"month",months:"month",month:"month",Q:"quarter",quarters:"quarter",quarter:"quarter",s:"second",seconds:"second",second:"second",gg:"weekYear",weekyears:"weekYear",weekyear:"weekYear",GG:"isoWeekYear",isoweekyears:"isoWeekYear",isoweekyear:"isoWeekYear",w:"week",weeks:"week",week:"week",W:"isoWeek",isoweeks:"isoWeek",isoweek:"isoWeek",y:"year",years:"year",year:"year"};function o(e){return"string"==typeof e?oe[e]||oe[e.toLowerCase()]:void 0}function ue(e){var t,n,s={};for(n in e)c(e,n)&&(t=o(n))&&(s[t]=e[n]);return s}var le={date:9,day:11,weekday:11,isoWeekday:11,dayOfYear:4,hour:13,millisecond:16,minute:14,month:8,quarter:7,second:15,weekYear:1,isoWeekYear:1,week:5,isoWeek:5,year:1};var de=/\d/,t=/\d\d/,he=/\d{3}/,ce=/\d{4}/,fe=/[+-]?\d{6}/,n=/\d\d?/,me=/\d\d\d\d?/,_e=/\d\d\d\d\d\d?/,ye=/\d{1,3}/,ge=/\d{1,4}/,we=/[+-]?\d{1,6}/,pe=/\d+/,ke=/[+-]?\d+/,Me=/Z|[+-]\d\d:?\d\d/gi,ve=/Z|[+-]\d\d(?::?\d\d)?/gi,i=/[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,u=/^[1-9]\d?/,d=/^([1-9]\d|\d)/;function h(e,n,s){Ye[e]=a(n)?n:function(e,t){return e&&s?s:n}}function De(e,t){return c(Ye,e)?Ye[e](t._strict,t._locale):new RegExp(f(e.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(e,t,n,s,i){return t||n||s||i})))}function f(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function m(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function M(e){var e=+e,t=0;return t=0!=e&&isFinite(e)?m(e):t}var Ye={},Se={};function v(e,n){var t,s,i=n;for("string"==typeof e&&(e=[e]),w(n)&&(i=function(e,t){t[n]=M(e)}),s=e.length,t=0;t<s;t++)Se[e[t]]=i}function Oe(e,i){v(e,function(e,t,n,s){n._w=n._w||{},i(e,n._w,n,s)})}function be(e){return e%4==0&&e%100!=0||e%400==0}var D=0,Y=1,S=2,O=3,b=4,T=5,Te=6,xe=7,Ne=8;function We(e){return be(e)?366:365}s("Y",0,0,function(){var e=this.year();return e<=9999?r(e,4):"+"+e}),s(0,["YY",2],0,function(){return this.year()%100}),s(0,["YYYY",4],0,"year"),s(0,["YYYYY",5],0,"year"),s(0,["YYYYYY",6,!0],0,"year"),h("Y",ke),h("YY",n,t),h("YYYY",ge,ce),h("YYYYY",we,fe),h("YYYYYY",we,fe),v(["YYYYY","YYYYYY"],D),v("YYYY",function(e,t){t[D]=2===e.length?_.parseTwoDigitYear(e):M(e)}),v("YY",function(e,t){t[D]=_.parseTwoDigitYear(e)}),v("Y",function(e,t){t[D]=parseInt(e,10)}),_.parseTwoDigitYear=function(e){return M(e)+(68<M(e)?1900:2e3)};var x,Pe=Re("FullYear",!0);function Re(t,n){return function(e){return null!=e?(Ue(this,t,e),_.updateOffset(this,n),this):Ce(this,t)}}function Ce(e,t){if(!e.isValid())return NaN;var n=e._d,s=e._isUTC;switch(t){case"Milliseconds":return s?n.getUTCMilliseconds():n.getMilliseconds();case"Seconds":return s?n.getUTCSeconds():n.getSeconds();case"Minutes":return s?n.getUTCMinutes():n.getMinutes();case"Hours":return s?n.getUTCHours():n.getHours();case"Date":return s?n.getUTCDate():n.getDate();case"Day":return s?n.getUTCDay():n.getDay();case"Month":return s?n.getUTCMonth():n.getMonth();case"FullYear":return s?n.getUTCFullYear():n.getFullYear();default:return NaN}}function Ue(e,t,n){var s,i,r;if(e.isValid()&&!isNaN(n)){switch(s=e._d,i=e._isUTC,t){case"Milliseconds":return i?s.setUTCMilliseconds(n):s.setMilliseconds(n);case"Seconds":return i?s.setUTCSeconds(n):s.setSeconds(n);case"Minutes":return i?s.setUTCMinutes(n):s.setMinutes(n);case"Hours":return i?s.setUTCHours(n):s.setHours(n);case"Date":return i?s.setUTCDate(n):s.setDate(n);case"FullYear":break;default:return}t=n,r=e.month(),e=29!==(e=e.date())||1!==r||be(t)?e:28,i?s.setUTCFullYear(t,r,e):s.setFullYear(t,r,e)}}function He(e,t){var n;return isNaN(e)||isNaN(t)?NaN:(n=(t%(n=12)+n)%n,e+=(t-n)/12,1==n?be(e)?29:28:31-n%7%2)}x=Array.prototype.indexOf||function(e){for(var t=0;t<this.length;++t)if(this[t]===e)return t;return-1},s("M",["MM",2],"Mo",function(){return this.month()+1}),s("MMM",0,0,function(e){return this.localeData().monthsShort(this,e)}),s("MMMM",0,0,function(e){return this.localeData().months(this,e)}),h("M",n,u),h("MM",n,t),h("MMM",function(e,t){return t.monthsShortRegex(e)}),h("MMMM",function(e,t){return t.monthsRegex(e)}),v(["M","MM"],function(e,t){t[Y]=M(e)-1}),v(["MMM","MMMM"],function(e,t,n,s){s=n._locale.monthsParse(e,s,n._strict);null!=s?t[Y]=s:p(n).invalidMonth=e});var Fe="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),Le="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),Ve=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,Ge=i,Ee=i;function Ae(e,t){if(e.isValid()){if("string"==typeof t)if(/^\d+$/.test(t))t=M(t);else if(!w(t=e.localeData().monthsParse(t)))return;var n=(n=e.date())<29?n:Math.min(n,He(e.year(),t));e._isUTC?e._d.setUTCMonth(t,n):e._d.setMonth(t,n)}}function Ie(e){return null!=e?(Ae(this,e),_.updateOffset(this,!0),this):Ce(this,"Month")}function je(){function e(e,t){return t.length-e.length}for(var t,n,s=[],i=[],r=[],a=0;a<12;a++)n=l([2e3,a]),t=f(this.monthsShort(n,"")),n=f(this.months(n,"")),s.push(t),i.push(n),r.push(n),r.push(t);s.sort(e),i.sort(e),r.sort(e),this._monthsRegex=new RegExp("^("+r.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+i.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+s.join("|")+")","i")}function Ze(e,t,n,s,i,r,a){var o;return e<100&&0<=e?(o=new Date(e+400,t,n,s,i,r,a),isFinite(o.getFullYear())&&o.setFullYear(e)):o=new Date(e,t,n,s,i,r,a),o}function ze(e){var t;return e<100&&0<=e?((t=Array.prototype.slice.call(arguments))[0]=e+400,t=new Date(Date.UTC.apply(null,t)),isFinite(t.getUTCFullYear())&&t.setUTCFullYear(e)):t=new Date(Date.UTC.apply(null,arguments)),t}function qe(e,t,n){n=7+t-n;return n-(7+ze(e,0,n).getUTCDay()-t)%7-1}function $e(e,t,n,s,i){var r,t=1+7*(t-1)+(7+n-s)%7+qe(e,s,i),n=t<=0?We(r=e-1)+t:t>We(e)?(r=e+1,t-We(e)):(r=e,t);return{year:r,dayOfYear:n}}function Be(e,t,n){var s,i,r=qe(e.year(),t,n),r=Math.floor((e.dayOfYear()-r-1)/7)+1;return r<1?s=r+N(i=e.year()-1,t,n):r>N(e.year(),t,n)?(s=r-N(e.year(),t,n),i=e.year()+1):(i=e.year(),s=r),{week:s,year:i}}function N(e,t,n){var s=qe(e,t,n),t=qe(e+1,t,n);return(We(e)-s+t)/7}s("w",["ww",2],"wo","week"),s("W",["WW",2],"Wo","isoWeek"),h("w",n,u),h("ww",n,t),h("W",n,u),h("WW",n,t),Oe(["w","ww","W","WW"],function(e,t,n,s){t[s.substr(0,1)]=M(e)});function Je(e,t){return e.slice(t,7).concat(e.slice(0,t))}s("d",0,"do","day"),s("dd",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),s("ddd",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),s("dddd",0,0,function(e){return this.localeData().weekdays(this,e)}),s("e",0,0,"weekday"),s("E",0,0,"isoWeekday"),h("d",n),h("e",n),h("E",n),h("dd",function(e,t){return t.weekdaysMinRegex(e)}),h("ddd",function(e,t){return t.weekdaysShortRegex(e)}),h("dddd",function(e,t){return t.weekdaysRegex(e)}),Oe(["dd","ddd","dddd"],function(e,t,n,s){s=n._locale.weekdaysParse(e,s,n._strict);null!=s?t.d=s:p(n).invalidWeekday=e}),Oe(["d","e","E"],function(e,t,n,s){t[s]=M(e)});var Qe="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),Xe="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),Ke="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),et=i,tt=i,nt=i;function st(){function e(e,t){return t.length-e.length}for(var t,n,s,i=[],r=[],a=[],o=[],u=0;u<7;u++)s=l([2e3,1]).day(u),t=f(this.weekdaysMin(s,"")),n=f(this.weekdaysShort(s,"")),s=f(this.weekdays(s,"")),i.push(t),r.push(n),a.push(s),o.push(t),o.push(n),o.push(s);i.sort(e),r.sort(e),a.sort(e),o.sort(e),this._weekdaysRegex=new RegExp("^("+o.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+a.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+r.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+i.join("|")+")","i")}function it(){return this.hours()%12||12}function rt(e,t){s(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),t)})}function at(e,t){return t._meridiemParse}s("H",["HH",2],0,"hour"),s("h",["hh",2],0,it),s("k",["kk",2],0,function(){return this.hours()||24}),s("hmm",0,0,function(){return""+it.apply(this)+r(this.minutes(),2)}),s("hmmss",0,0,function(){return""+it.apply(this)+r(this.minutes(),2)+r(this.seconds(),2)}),s("Hmm",0,0,function(){return""+this.hours()+r(this.minutes(),2)}),s("Hmmss",0,0,function(){return""+this.hours()+r(this.minutes(),2)+r(this.seconds(),2)}),rt("a",!0),rt("A",!1),h("a",at),h("A",at),h("H",n,d),h("h",n,u),h("k",n,u),h("HH",n,t),h("hh",n,t),h("kk",n,t),h("hmm",me),h("hmmss",_e),h("Hmm",me),h("Hmmss",_e),v(["H","HH"],O),v(["k","kk"],function(e,t,n){e=M(e);t[O]=24===e?0:e}),v(["a","A"],function(e,t,n){n._isPm=n._locale.isPM(e),n._meridiem=e}),v(["h","hh"],function(e,t,n){t[O]=M(e),p(n).bigHour=!0}),v("hmm",function(e,t,n){var s=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s)),p(n).bigHour=!0}),v("hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s,2)),t[T]=M(e.substr(i)),p(n).bigHour=!0}),v("Hmm",function(e,t,n){var s=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s))}),v("Hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s,2)),t[T]=M(e.substr(i))});i=Re("Hours",!0);var ot,ut={calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},longDateFormat:{LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},invalidDate:"Invalid date",ordinal:"%d",dayOfMonthOrdinalParse:/\d{1,2}/,relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",w:"a week",ww:"%d weeks",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},months:Fe,monthsShort:Le,week:{dow:0,doy:6},weekdays:Qe,weekdaysMin:Ke,weekdaysShort:Xe,meridiemParse:/[ap]\.?m?\.?/i},W={},lt={};function dt(e){return e&&e.toLowerCase().replace("_","-")}function ht(e){for(var t,n,s,i,r=0;r<e.length;){for(t=(i=dt(e[r]).split("-")).length,n=(n=dt(e[r+1]))?n.split("-"):null;0<t;){if(s=ct(i.slice(0,t).join("-")))return s;if(n&&n.length>=t&&function(e,t){for(var n=Math.min(e.length,t.length),s=0;s<n;s+=1)if(e[s]!==t[s])return s;return n}(i,n)>=t-1)break;t--}r++}return ot}function ct(t){var e,n;if(void 0===W[t]&&"undefined"!=typeof module&&module&&module.exports&&(n=t)&&n.match("^[^/\\\\]*$"))try{e=ot._abbr,require("./locale/"+t),ft(e)}catch(e){W[t]=null}return W[t]}function ft(e,t){return e&&((t=g(t)?P(e):mt(e,t))?ot=t:"undefined"!=typeof console&&console.warn&&console.warn("Locale "+e+" not found. Did you forget to load it?")),ot._abbr}function mt(e,t){if(null===t)return delete W[e],null;var n,s=ut;if(t.abbr=e,null!=W[e])Q("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),s=W[e]._config;else if(null!=t.parentLocale)if(null!=W[t.parentLocale])s=W[t.parentLocale]._config;else{if(null==(n=ct(t.parentLocale)))return lt[t.parentLocale]||(lt[t.parentLocale]=[]),lt[t.parentLocale].push({name:e,config:t}),null;s=n._config}return W[e]=new K(X(s,t)),lt[e]&&lt[e].forEach(function(e){mt(e.name,e.config)}),ft(e),W[e]}function P(e){var t;if(!(e=e&&e._locale&&e._locale._abbr?e._locale._abbr:e))return ot;if(!y(e)){if(t=ct(e))return t;e=[e]}return ht(e)}function _t(e){var t=e._a;return t&&-2===p(e).overflow&&(t=t[Y]<0||11<t[Y]?Y:t[S]<1||t[S]>He(t[D],t[Y])?S:t[O]<0||24<t[O]||24===t[O]&&(0!==t[b]||0!==t[T]||0!==t[Te])?O:t[b]<0||59<t[b]?b:t[T]<0||59<t[T]?T:t[Te]<0||999<t[Te]?Te:-1,p(e)._overflowDayOfYear&&(t<D||S<t)&&(t=S),p(e)._overflowWeeks&&-1===t&&(t=xe),p(e)._overflowWeekday&&-1===t&&(t=Ne),p(e).overflow=t),e}var yt=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,gt=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,wt=/Z|[+-]\d\d(?::?\d\d)?/,pt=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/],["YYYYMM",/\d{6}/,!1],["YYYY",/\d{4}/,!1]],kt=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],Mt=/^\/?Date\((-?\d+)/i,vt=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,Dt={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};function Yt(e){var t,n,s,i,r,a,o=e._i,u=yt.exec(o)||gt.exec(o),o=pt.length,l=kt.length;if(u){for(p(e).iso=!0,t=0,n=o;t<n;t++)if(pt[t][1].exec(u[1])){i=pt[t][0],s=!1!==pt[t][2];break}if(null==i)e._isValid=!1;else{if(u[3]){for(t=0,n=l;t<n;t++)if(kt[t][1].exec(u[3])){r=(u[2]||" ")+kt[t][0];break}if(null==r)return void(e._isValid=!1)}if(s||null==r){if(u[4]){if(!wt.exec(u[4]))return void(e._isValid=!1);a="Z"}e._f=i+(r||"")+(a||""),xt(e)}else e._isValid=!1}}else e._isValid=!1}function St(e,t,n,s,i,r){e=[function(e){e=parseInt(e,10);{if(e<=49)return 2e3+e;if(e<=999)return 1900+e}return e}(e),Le.indexOf(t),parseInt(n,10),parseInt(s,10),parseInt(i,10)];return r&&e.push(parseInt(r,10)),e}function Ot(e){var t,n,s=vt.exec(e._i.replace(/\([^()]*\)|[\n\t]/g," ").replace(/(\s\s+)/g," ").replace(/^\s\s*/,"").replace(/\s\s*$/,""));s?(t=St(s[4],s[3],s[2],s[5],s[6],s[7]),function(e,t,n){if(!e||Xe.indexOf(e)===new Date(t[0],t[1],t[2]).getDay())return 1;p(n).weekdayMismatch=!0,n._isValid=!1}(s[1],t,e)&&(e._a=t,e._tzm=(t=s[8],n=s[9],s=s[10],t?Dt[t]:n?0:60*(((t=parseInt(s,10))-(n=t%100))/100)+n),e._d=ze.apply(null,e._a),e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),p(e).rfc2822=!0)):e._isValid=!1}function bt(e,t,n){return null!=e?e:null!=t?t:n}function Tt(e){var t,n,s,i,r,a,o,u,l,d,h,c=[];if(!e._d){for(s=e,i=new Date(_.now()),n=s._useUTC?[i.getUTCFullYear(),i.getUTCMonth(),i.getUTCDate()]:[i.getFullYear(),i.getMonth(),i.getDate()],e._w&&null==e._a[S]&&null==e._a[Y]&&(null!=(i=(s=e)._w).GG||null!=i.W||null!=i.E?(u=1,l=4,r=bt(i.GG,s._a[D],Be(R(),1,4).year),a=bt(i.W,1),((o=bt(i.E,1))<1||7<o)&&(d=!0)):(u=s._locale._week.dow,l=s._locale._week.doy,h=Be(R(),u,l),r=bt(i.gg,s._a[D],h.year),a=bt(i.w,h.week),null!=i.d?((o=i.d)<0||6<o)&&(d=!0):null!=i.e?(o=i.e+u,(i.e<0||6<i.e)&&(d=!0)):o=u),a<1||a>N(r,u,l)?p(s)._overflowWeeks=!0:null!=d?p(s)._overflowWeekday=!0:(h=$e(r,a,o,u,l),s._a[D]=h.year,s._dayOfYear=h.dayOfYear)),null!=e._dayOfYear&&(i=bt(e._a[D],n[D]),(e._dayOfYear>We(i)||0===e._dayOfYear)&&(p(e)._overflowDayOfYear=!0),d=ze(i,0,e._dayOfYear),e._a[Y]=d.getUTCMonth(),e._a[S]=d.getUTCDate()),t=0;t<3&&null==e._a[t];++t)e._a[t]=c[t]=n[t];for(;t<7;t++)e._a[t]=c[t]=null==e._a[t]?2===t?1:0:e._a[t];24===e._a[O]&&0===e._a[b]&&0===e._a[T]&&0===e._a[Te]&&(e._nextDay=!0,e._a[O]=0),e._d=(e._useUTC?ze:Ze).apply(null,c),r=e._useUTC?e._d.getUTCDay():e._d.getDay(),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[O]=24),e._w&&void 0!==e._w.d&&e._w.d!==r&&(p(e).weekdayMismatch=!0)}}function xt(e){if(e._f===_.ISO_8601)Yt(e);else if(e._f===_.RFC_2822)Ot(e);else{e._a=[],p(e).empty=!0;for(var t,n,s,i,r,a=""+e._i,o=a.length,u=0,l=ae(e._f,e._locale).match(te)||[],d=l.length,h=0;h<d;h++)n=l[h],(t=(a.match(De(n,e))||[])[0])&&(0<(s=a.substr(0,a.indexOf(t))).length&&p(e).unusedInput.push(s),a=a.slice(a.indexOf(t)+t.length),u+=t.length),ie[n]?(t?p(e).empty=!1:p(e).unusedTokens.push(n),s=n,r=e,null!=(i=t)&&c(Se,s)&&Se[s](i,r._a,r,s)):e._strict&&!t&&p(e).unusedTokens.push(n);p(e).charsLeftOver=o-u,0<a.length&&p(e).unusedInput.push(a),e._a[O]<=12&&!0===p(e).bigHour&&0<e._a[O]&&(p(e).bigHour=void 0),p(e).parsedDateParts=e._a.slice(0),p(e).meridiem=e._meridiem,e._a[O]=function(e,t,n){if(null==n)return t;return null!=e.meridiemHour?e.meridiemHour(t,n):null!=e.isPM?((e=e.isPM(n))&&t<12&&(t+=12),t=e||12!==t?t:0):t}(e._locale,e._a[O],e._meridiem),null!==(o=p(e).era)&&(e._a[D]=e._locale.erasConvertYear(o,e._a[D])),Tt(e),_t(e)}}function Nt(e){var t,n,s,i=e._i,r=e._f;if(e._locale=e._locale||P(e._l),null===i||void 0===r&&""===i)return I({nullInput:!0});if("string"==typeof i&&(e._i=i=e._locale.preparse(i)),k(i))return new $(_t(i));if(V(i))e._d=i;else if(y(r)){var a,o,u,l,d,h,c=e,f=!1,m=c._f.length;if(0===m)p(c).invalidFormat=!0,c._d=new Date(NaN);else{for(l=0;l<m;l++)d=0,h=!1,a=q({},c),null!=c._useUTC&&(a._useUTC=c._useUTC),a._f=c._f[l],xt(a),A(a)&&(h=!0),d=(d+=p(a).charsLeftOver)+10*p(a).unusedTokens.length,p(a).score=d,f?d<u&&(u=d,o=a):(null==u||d<u||h)&&(u=d,o=a,h)&&(f=!0);E(c,o||a)}}else if(r)xt(e);else if(g(r=(i=e)._i))i._d=new Date(_.now());else V(r)?i._d=new Date(r.valueOf()):"string"==typeof r?(n=i,null!==(t=Mt.exec(n._i))?n._d=new Date(+t[1]):(Yt(n),!1===n._isValid&&(delete n._isValid,Ot(n),!1===n._isValid)&&(delete n._isValid,n._strict?n._isValid=!1:_.createFromInputFallback(n)))):y(r)?(i._a=G(r.slice(0),function(e){return parseInt(e,10)}),Tt(i)):F(r)?(t=i)._d||(s=void 0===(n=ue(t._i)).day?n.date:n.day,t._a=G([n.year,n.month,s,n.hour,n.minute,n.second,n.millisecond],function(e){return e&&parseInt(e,10)}),Tt(t)):w(r)?i._d=new Date(r):_.createFromInputFallback(i);return A(e)||(e._d=null),e}function Wt(e,t,n,s,i){var r={};return!0!==t&&!1!==t||(s=t,t=void 0),!0!==n&&!1!==n||(s=n,n=void 0),(F(e)&&L(e)||y(e)&&0===e.length)&&(e=void 0),r._isAMomentObject=!0,r._useUTC=r._isUTC=i,r._l=n,r._i=e,r._f=t,r._strict=s,(i=new $(_t(Nt(i=r))))._nextDay&&(i.add(1,"d"),i._nextDay=void 0),i}function R(e,t,n,s){return Wt(e,t,n,s,!1)}_.createFromInputFallback=e("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(e){e._d=new Date(e._i+(e._useUTC?" UTC":""))}),_.ISO_8601=function(){},_.RFC_2822=function(){};me=e("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=R.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:I()}),_e=e("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=R.apply(null,arguments);return this.isValid()&&e.isValid()?this<e?this:e:I()});function Pt(e,t){var n,s;if(!(t=1===t.length&&y(t[0])?t[0]:t).length)return R();for(n=t[0],s=1;s<t.length;++s)t[s].isValid()&&!t[s][e](n)||(n=t[s]);return n}var Rt=["year","quarter","month","week","day","hour","minute","second","millisecond"];function Ct(e){var e=ue(e),t=e.year||0,n=e.quarter||0,s=e.month||0,i=e.week||e.isoWeek||0,r=e.day||0,a=e.hour||0,o=e.minute||0,u=e.second||0,l=e.millisecond||0;this._isValid=function(e){var t,n,s=!1,i=Rt.length;for(t in e)if(c(e,t)&&(-1===x.call(Rt,t)||null!=e[t]&&isNaN(e[t])))return!1;for(n=0;n<i;++n)if(e[Rt[n]]){if(s)return!1;parseFloat(e[Rt[n]])!==M(e[Rt[n]])&&(s=!0)}return!0}(e),this._milliseconds=+l+1e3*u+6e4*o+1e3*a*60*60,this._days=+r+7*i,this._months=+s+3*n+12*t,this._data={},this._locale=P(),this._bubble()}function Ut(e){return e instanceof Ct}function Ht(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function Ft(e,n){s(e,0,0,function(){var e=this.utcOffset(),t="+";return e<0&&(e=-e,t="-"),t+r(~~(e/60),2)+n+r(~~e%60,2)})}Ft("Z",":"),Ft("ZZ",""),h("Z",ve),h("ZZ",ve),v(["Z","ZZ"],function(e,t,n){n._useUTC=!0,n._tzm=Vt(ve,e)});var Lt=/([\+\-]|\d\d)/gi;function Vt(e,t){var t=(t||"").match(e);return null===t?null:0===(t=60*(e=((t[t.length-1]||[])+"").match(Lt)||["-",0,0])[1]+M(e[2]))?0:"+"===e[0]?t:-t}function Gt(e,t){var n;return t._isUTC?(t=t.clone(),n=(k(e)||V(e)?e:R(e)).valueOf()-t.valueOf(),t._d.setTime(t._d.valueOf()+n),_.updateOffset(t,!1),t):R(e).local()}function Et(e){return-Math.round(e._d.getTimezoneOffset())}function At(){return!!this.isValid()&&this._isUTC&&0===this._offset}_.updateOffset=function(){};var It=/^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,jt=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;function C(e,t){var n,s=e;return Ut(e)?s={ms:e._milliseconds,d:e._days,M:e._months}:w(e)||!isNaN(+e)?(s={},t?s[t]=+e:s.milliseconds=+e):(t=It.exec(e))?(n="-"===t[1]?-1:1,s={y:0,d:M(t[S])*n,h:M(t[O])*n,m:M(t[b])*n,s:M(t[T])*n,ms:M(Ht(1e3*t[Te]))*n}):(t=jt.exec(e))?(n="-"===t[1]?-1:1,s={y:Zt(t[2],n),M:Zt(t[3],n),w:Zt(t[4],n),d:Zt(t[5],n),h:Zt(t[6],n),m:Zt(t[7],n),s:Zt(t[8],n)}):null==s?s={}:"object"==typeof s&&("from"in s||"to"in s)&&(t=function(e,t){var n;if(!e.isValid()||!t.isValid())return{milliseconds:0,months:0};t=Gt(t,e),e.isBefore(t)?n=zt(e,t):((n=zt(t,e)).milliseconds=-n.milliseconds,n.months=-n.months);return n}(R(s.from),R(s.to)),(s={}).ms=t.milliseconds,s.M=t.months),n=new Ct(s),Ut(e)&&c(e,"_locale")&&(n._locale=e._locale),Ut(e)&&c(e,"_isValid")&&(n._isValid=e._isValid),n}function Zt(e,t){e=e&&parseFloat(e.replace(",","."));return(isNaN(e)?0:e)*t}function zt(e,t){var n={};return n.months=t.month()-e.month()+12*(t.year()-e.year()),e.clone().add(n.months,"M").isAfter(t)&&--n.months,n.milliseconds=+t-+e.clone().add(n.months,"M"),n}function qt(s,i){return function(e,t){var n;return null===t||isNaN(+t)||(Q(i,"moment()."+i+"(period, number) is deprecated. Please use moment()."+i+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),n=e,e=t,t=n),$t(this,C(e,t),s),this}}function $t(e,t,n,s){var i=t._milliseconds,r=Ht(t._days),t=Ht(t._months);e.isValid()&&(s=null==s||s,t&&Ae(e,Ce(e,"Month")+t*n),r&&Ue(e,"Date",Ce(e,"Date")+r*n),i&&e._d.setTime(e._d.valueOf()+i*n),s)&&_.updateOffset(e,r||t)}C.fn=Ct.prototype,C.invalid=function(){return C(NaN)};Fe=qt(1,"add"),Qe=qt(-1,"subtract");function Bt(e){return"string"==typeof e||e instanceof String}function Jt(e){return k(e)||V(e)||Bt(e)||w(e)||function(t){var e=y(t),n=!1;e&&(n=0===t.filter(function(e){return!w(e)&&Bt(t)}).length);return e&&n}(e)||function(e){var t,n,s=F(e)&&!L(e),i=!1,r=["years","year","y","months","month","M","days","day","d","dates","date","D","hours","hour","h","minutes","minute","m","seconds","second","s","milliseconds","millisecond","ms"],a=r.length;for(t=0;t<a;t+=1)n=r[t],i=i||c(e,n);return s&&i}(e)||null==e}function Qt(e,t){var n,s;return e.date()<t.date()?-Qt(t,e):-((n=12*(t.year()-e.year())+(t.month()-e.month()))+(t-(s=e.clone().add(n,"months"))<0?(t-s)/(s-e.clone().add(n-1,"months")):(t-s)/(e.clone().add(1+n,"months")-s)))||0}function Xt(e){return void 0===e?this._locale._abbr:(null!=(e=P(e))&&(this._locale=e),this)}_.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",_.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";Ke=e("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(e){return void 0===e?this.localeData():this.locale(e)});function Kt(){return this._locale}var en=126227808e5;function tn(e,t){return(e%t+t)%t}function nn(e,t,n){return e<100&&0<=e?new Date(e+400,t,n)-en:new Date(e,t,n).valueOf()}function sn(e,t,n){return e<100&&0<=e?Date.UTC(e+400,t,n)-en:Date.UTC(e,t,n)}function rn(e,t){return t.erasAbbrRegex(e)}function an(){for(var e,t,n,s=[],i=[],r=[],a=[],o=this.eras(),u=0,l=o.length;u<l;++u)e=f(o[u].name),t=f(o[u].abbr),n=f(o[u].narrow),i.push(e),s.push(t),r.push(n),a.push(e),a.push(t),a.push(n);this._erasRegex=new RegExp("^("+a.join("|")+")","i"),this._erasNameRegex=new RegExp("^("+i.join("|")+")","i"),this._erasAbbrRegex=new RegExp("^("+s.join("|")+")","i"),this._erasNarrowRegex=new RegExp("^("+r.join("|")+")","i")}function on(e,t){s(0,[e,e.length],0,t)}function un(e,t,n,s,i){var r;return null==e?Be(this,s,i).year:(r=N(e,s,i),function(e,t,n,s,i){e=$e(e,t,n,s,i),t=ze(e.year,0,e.dayOfYear);return this.year(t.getUTCFullYear()),this.month(t.getUTCMonth()),this.date(t.getUTCDate()),this}.call(this,e,t=r<t?r:t,n,s,i))}s("N",0,0,"eraAbbr"),s("NN",0,0,"eraAbbr"),s("NNN",0,0,"eraAbbr"),s("NNNN",0,0,"eraName"),s("NNNNN",0,0,"eraNarrow"),s("y",["y",1],"yo","eraYear"),s("y",["yy",2],0,"eraYear"),s("y",["yyy",3],0,"eraYear"),s("y",["yyyy",4],0,"eraYear"),h("N",rn),h("NN",rn),h("NNN",rn),h("NNNN",function(e,t){return t.erasNameRegex(e)}),h("NNNNN",function(e,t){return t.erasNarrowRegex(e)}),v(["N","NN","NNN","NNNN","NNNNN"],function(e,t,n,s){s=n._locale.erasParse(e,s,n._strict);s?p(n).era=s:p(n).invalidEra=e}),h("y",pe),h("yy",pe),h("yyy",pe),h("yyyy",pe),h("yo",function(e,t){return t._eraYearOrdinalRegex||pe}),v(["y","yy","yyy","yyyy"],D),v(["yo"],function(e,t,n,s){var i;n._locale._eraYearOrdinalRegex&&(i=e.match(n._locale._eraYearOrdinalRegex)),n._locale.eraYearOrdinalParse?t[D]=n._locale.eraYearOrdinalParse(e,i):t[D]=parseInt(e,10)}),s(0,["gg",2],0,function(){return this.weekYear()%100}),s(0,["GG",2],0,function(){return this.isoWeekYear()%100}),on("gggg","weekYear"),on("ggggg","weekYear"),on("GGGG","isoWeekYear"),on("GGGGG","isoWeekYear"),h("G",ke),h("g",ke),h("GG",n,t),h("gg",n,t),h("GGGG",ge,ce),h("gggg",ge,ce),h("GGGGG",we,fe),h("ggggg",we,fe),Oe(["gggg","ggggg","GGGG","GGGGG"],function(e,t,n,s){t[s.substr(0,2)]=M(e)}),Oe(["gg","GG"],function(e,t,n,s){t[s]=_.parseTwoDigitYear(e)}),s("Q",0,"Qo","quarter"),h("Q",de),v("Q",function(e,t){t[Y]=3*(M(e)-1)}),s("D",["DD",2],"Do","date"),h("D",n,u),h("DD",n,t),h("Do",function(e,t){return e?t._dayOfMonthOrdinalParse||t._ordinalParse:t._dayOfMonthOrdinalParseLenient}),v(["D","DD"],S),v("Do",function(e,t){t[S]=M(e.match(n)[0])});ge=Re("Date",!0);s("DDD",["DDDD",3],"DDDo","dayOfYear"),h("DDD",ye),h("DDDD",he),v(["DDD","DDDD"],function(e,t,n){n._dayOfYear=M(e)}),s("m",["mm",2],0,"minute"),h("m",n,d),h("mm",n,t),v(["m","mm"],b);var ln,ce=Re("Minutes",!1),we=(s("s",["ss",2],0,"second"),h("s",n,d),h("ss",n,t),v(["s","ss"],T),Re("Seconds",!1));for(s("S",0,0,function(){return~~(this.millisecond()/100)}),s(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),s(0,["SSS",3],0,"millisecond"),s(0,["SSSS",4],0,function(){return 10*this.millisecond()}),s(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),s(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),s(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),s(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),s(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),h("S",ye,de),h("SS",ye,t),h("SSS",ye,he),ln="SSSS";ln.length<=9;ln+="S")h(ln,pe);function dn(e,t){t[Te]=M(1e3*("0."+e))}for(ln="S";ln.length<=9;ln+="S")v(ln,dn);fe=Re("Milliseconds",!1),s("z",0,0,"zoneAbbr"),s("zz",0,0,"zoneName");u=$.prototype;function hn(e){return e}u.add=Fe,u.calendar=function(e,t){1===arguments.length&&(arguments[0]?Jt(arguments[0])?(e=arguments[0],t=void 0):function(e){for(var t=F(e)&&!L(e),n=!1,s=["sameDay","nextDay","lastDay","nextWeek","lastWeek","sameElse"],i=0;i<s.length;i+=1)n=n||c(e,s[i]);return t&&n}(arguments[0])&&(t=arguments[0],e=void 0):t=e=void 0);var e=e||R(),n=Gt(e,this).startOf("day"),n=_.calendarFormat(this,n)||"sameElse",t=t&&(a(t[n])?t[n].call(this,e):t[n]);return this.format(t||this.localeData().calendar(n,this,R(e)))},u.clone=function(){return new $(this)},u.diff=function(e,t,n){var s,i,r;if(!this.isValid())return NaN;if(!(s=Gt(e,this)).isValid())return NaN;switch(i=6e4*(s.utcOffset()-this.utcOffset()),t=o(t)){case"year":r=Qt(this,s)/12;break;case"month":r=Qt(this,s);break;case"quarter":r=Qt(this,s)/3;break;case"second":r=(this-s)/1e3;break;case"minute":r=(this-s)/6e4;break;case"hour":r=(this-s)/36e5;break;case"day":r=(this-s-i)/864e5;break;case"week":r=(this-s-i)/6048e5;break;default:r=this-s}return n?r:m(r)},u.endOf=function(e){var t,n;if(void 0!==(e=o(e))&&"millisecond"!==e&&this.isValid()){switch(n=this._isUTC?sn:nn,e){case"year":t=n(this.year()+1,0,1)-1;break;case"quarter":t=n(this.year(),this.month()-this.month()%3+3,1)-1;break;case"month":t=n(this.year(),this.month()+1,1)-1;break;case"week":t=n(this.year(),this.month(),this.date()-this.weekday()+7)-1;break;case"isoWeek":t=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1)+7)-1;break;case"day":case"date":t=n(this.year(),this.month(),this.date()+1)-1;break;case"hour":t=this._d.valueOf(),t+=36e5-tn(t+(this._isUTC?0:6e4*this.utcOffset()),36e5)-1;break;case"minute":t=this._d.valueOf(),t+=6e4-tn(t,6e4)-1;break;case"second":t=this._d.valueOf(),t+=1e3-tn(t,1e3)-1;break}this._d.setTime(t),_.updateOffset(this,!0)}return this},u.format=function(e){return e=e||(this.isUtc()?_.defaultFormatUtc:_.defaultFormat),e=re(this,e),this.localeData().postformat(e)},u.from=function(e,t){return this.isValid()&&(k(e)&&e.isValid()||R(e).isValid())?C({to:this,from:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},u.fromNow=function(e){return this.from(R(),e)},u.to=function(e,t){return this.isValid()&&(k(e)&&e.isValid()||R(e).isValid())?C({from:this,to:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},u.toNow=function(e){return this.to(R(),e)},u.get=function(e){return a(this[e=o(e)])?this[e]():this},u.invalidAt=function(){return p(this).overflow},u.isAfter=function(e,t){return e=k(e)?e:R(e),!(!this.isValid()||!e.isValid())&&("millisecond"===(t=o(t)||"millisecond")?this.valueOf()>e.valueOf():e.valueOf()<this.clone().startOf(t).valueOf())},u.isBefore=function(e,t){return e=k(e)?e:R(e),!(!this.isValid()||!e.isValid())&&("millisecond"===(t=o(t)||"millisecond")?this.valueOf()<e.valueOf():this.clone().endOf(t).valueOf()<e.valueOf())},u.isBetween=function(e,t,n,s){return e=k(e)?e:R(e),t=k(t)?t:R(t),!!(this.isValid()&&e.isValid()&&t.isValid())&&("("===(s=s||"()")[0]?this.isAfter(e,n):!this.isBefore(e,n))&&(")"===s[1]?this.isBefore(t,n):!this.isAfter(t,n))},u.isSame=function(e,t){var e=k(e)?e:R(e);return!(!this.isValid()||!e.isValid())&&("millisecond"===(t=o(t)||"millisecond")?this.valueOf()===e.valueOf():(e=e.valueOf(),this.clone().startOf(t).valueOf()<=e&&e<=this.clone().endOf(t).valueOf()))},u.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)},u.isSameOrBefore=function(e,t){return this.isSame(e,t)||this.isBefore(e,t)},u.isValid=function(){return A(this)},u.lang=Ke,u.locale=Xt,u.localeData=Kt,u.max=_e,u.min=me,u.parsingFlags=function(){return E({},p(this))},u.set=function(e,t){if("object"==typeof e)for(var n=function(e){var t,n=[];for(t in e)c(e,t)&&n.push({unit:t,priority:le[t]});return n.sort(function(e,t){return e.priority-t.priority}),n}(e=ue(e)),s=n.length,i=0;i<s;i++)this[n[i].unit](e[n[i].unit]);else if(a(this[e=o(e)]))return this[e](t);return this},u.startOf=function(e){var t,n;if(void 0!==(e=o(e))&&"millisecond"!==e&&this.isValid()){switch(n=this._isUTC?sn:nn,e){case"year":t=n(this.year(),0,1);break;case"quarter":t=n(this.year(),this.month()-this.month()%3,1);break;case"month":t=n(this.year(),this.month(),1);break;case"week":t=n(this.year(),this.month(),this.date()-this.weekday());break;case"isoWeek":t=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1));break;case"day":case"date":t=n(this.year(),this.month(),this.date());break;case"hour":t=this._d.valueOf(),t-=tn(t+(this._isUTC?0:6e4*this.utcOffset()),36e5);break;case"minute":t=this._d.valueOf(),t-=tn(t,6e4);break;case"second":t=this._d.valueOf(),t-=tn(t,1e3);break}this._d.setTime(t),_.updateOffset(this,!0)}return this},u.subtract=Qe,u.toArray=function(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]},u.toObject=function(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}},u.toDate=function(){return new Date(this.valueOf())},u.toISOString=function(e){var t;return this.isValid()?(t=(e=!0!==e)?this.clone().utc():this).year()<0||9999<t.year()?re(t,e?"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"):a(Date.prototype.toISOString)?e?this.toDate().toISOString():new Date(this.valueOf()+60*this.utcOffset()*1e3).toISOString().replace("Z",re(t,"Z")):re(t,e?"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYY-MM-DD[T]HH:mm:ss.SSSZ"):null},u.inspect=function(){var e,t,n;return this.isValid()?(t="moment",e="",this.isLocal()||(t=0===this.utcOffset()?"moment.utc":"moment.parseZone",e="Z"),t="["+t+'("]',n=0<=this.year()&&this.year()<=9999?"YYYY":"YYYYYY",this.format(t+n+"-MM-DD[T]HH:mm:ss.SSS"+(e+'[")]'))):"moment.invalid(/* "+this._i+" */)"},"undefined"!=typeof Symbol&&null!=Symbol.for&&(u[Symbol.for("nodejs.util.inspect.custom")]=function(){return"Moment<"+this.format()+">"}),u.toJSON=function(){return this.isValid()?this.toISOString():null},u.toString=function(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")},u.unix=function(){return Math.floor(this.valueOf()/1e3)},u.valueOf=function(){return this._d.valueOf()-6e4*(this._offset||0)},u.creationData=function(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}},u.eraName=function(){for(var e,t=this.localeData().eras(),n=0,s=t.length;n<s;++n){if(e=this.clone().startOf("day").valueOf(),t[n].since<=e&&e<=t[n].until)return t[n].name;if(t[n].until<=e&&e<=t[n].since)return t[n].name}return""},u.eraNarrow=function(){for(var e,t=this.localeData().eras(),n=0,s=t.length;n<s;++n){if(e=this.clone().startOf("day").valueOf(),t[n].since<=e&&e<=t[n].until)return t[n].narrow;if(t[n].until<=e&&e<=t[n].since)return t[n].narrow}return""},u.eraAbbr=function(){for(var e,t=this.localeData().eras(),n=0,s=t.length;n<s;++n){if(e=this.clone().startOf("day").valueOf(),t[n].since<=e&&e<=t[n].until)return t[n].abbr;if(t[n].until<=e&&e<=t[n].since)return t[n].abbr}return""},u.eraYear=function(){for(var e,t,n=this.localeData().eras(),s=0,i=n.length;s<i;++s)if(e=n[s].since<=n[s].until?1:-1,t=this.clone().startOf("day").valueOf(),n[s].since<=t&&t<=n[s].until||n[s].until<=t&&t<=n[s].since)return(this.year()-_(n[s].since).year())*e+n[s].offset;return this.year()},u.year=Pe,u.isLeapYear=function(){return be(this.year())},u.weekYear=function(e){return un.call(this,e,this.week(),this.weekday()+this.localeData()._week.dow,this.localeData()._week.dow,this.localeData()._week.doy)},u.isoWeekYear=function(e){return un.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)},u.quarter=u.quarters=function(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)},u.month=Ie,u.daysInMonth=function(){return He(this.year(),this.month())},u.week=u.weeks=function(e){var t=this.localeData().week(this);return null==e?t:this.add(7*(e-t),"d")},u.isoWeek=u.isoWeeks=function(e){var t=Be(this,1,4).week;return null==e?t:this.add(7*(e-t),"d")},u.weeksInYear=function(){var e=this.localeData()._week;return N(this.year(),e.dow,e.doy)},u.weeksInWeekYear=function(){var e=this.localeData()._week;return N(this.weekYear(),e.dow,e.doy)},u.isoWeeksInYear=function(){return N(this.year(),1,4)},u.isoWeeksInISOWeekYear=function(){return N(this.isoWeekYear(),1,4)},u.date=ge,u.day=u.days=function(e){var t,n,s;return this.isValid()?(t=Ce(this,"Day"),null!=e?(n=e,s=this.localeData(),e="string"!=typeof n?n:isNaN(n)?"number"==typeof(n=s.weekdaysParse(n))?n:null:parseInt(n,10),this.add(e-t,"d")):t):null!=e?this:NaN},u.weekday=function(e){var t;return this.isValid()?(t=(this.day()+7-this.localeData()._week.dow)%7,null==e?t:this.add(e-t,"d")):null!=e?this:NaN},u.isoWeekday=function(e){var t,n;return this.isValid()?null!=e?(t=e,n=this.localeData(),n="string"==typeof t?n.weekdaysParse(t)%7||7:isNaN(t)?null:t,this.day(this.day()%7?n:n-7)):this.day()||7:null!=e?this:NaN},u.dayOfYear=function(e){var t=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==e?t:this.add(e-t,"d")},u.hour=u.hours=i,u.minute=u.minutes=ce,u.second=u.seconds=we,u.millisecond=u.milliseconds=fe,u.utcOffset=function(e,t,n){var s,i=this._offset||0;if(!this.isValid())return null!=e?this:NaN;if(null==e)return this._isUTC?i:Et(this);if("string"==typeof e){if(null===(e=Vt(ve,e)))return this}else Math.abs(e)<16&&!n&&(e*=60);return!this._isUTC&&t&&(s=Et(this)),this._offset=e,this._isUTC=!0,null!=s&&this.add(s,"m"),i!==e&&(!t||this._changeInProgress?$t(this,C(e-i,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,_.updateOffset(this,!0),this._changeInProgress=null)),this},u.utc=function(e){return this.utcOffset(0,e)},u.local=function(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e)&&this.subtract(Et(this),"m"),this},u.parseZone=function(){var e;return null!=this._tzm?this.utcOffset(this._tzm,!1,!0):"string"==typeof this._i&&(null!=(e=Vt(Me,this._i))?this.utcOffset(e):this.utcOffset(0,!0)),this},u.hasAlignedHourOffset=function(e){return!!this.isValid()&&(e=e?R(e).utcOffset():0,(this.utcOffset()-e)%60==0)},u.isDST=function(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()},u.isLocal=function(){return!!this.isValid()&&!this._isUTC},u.isUtcOffset=function(){return!!this.isValid()&&this._isUTC},u.isUtc=At,u.isUTC=At,u.zoneAbbr=function(){return this._isUTC?"UTC":""},u.zoneName=function(){return this._isUTC?"Coordinated Universal Time":""},u.dates=e("dates accessor is deprecated. Use date instead.",ge),u.months=e("months accessor is deprecated. Use month instead",Ie),u.years=e("years accessor is deprecated. Use year instead",Pe),u.zone=e("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",function(e,t){return null!=e?(this.utcOffset(e="string"!=typeof e?-e:e,t),this):-this.utcOffset()}),u.isDSTShifted=e("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",function(){var e,t;return g(this._isDSTShifted)&&(q(e={},this),(e=Nt(e))._a?(t=(e._isUTC?l:R)(e._a),this._isDSTShifted=this.isValid()&&0<function(e,t,n){for(var s=Math.min(e.length,t.length),i=Math.abs(e.length-t.length),r=0,a=0;a<s;a++)(n&&e[a]!==t[a]||!n&&M(e[a])!==M(t[a]))&&r++;return r+i}(e._a,t.toArray())):this._isDSTShifted=!1),this._isDSTShifted});d=K.prototype;function cn(e,t,n,s){var i=P(),s=l().set(s,t);return i[n](s,e)}function fn(e,t,n){if(w(e)&&(t=e,e=void 0),e=e||"",null!=t)return cn(e,t,n,"month");for(var s=[],i=0;i<12;i++)s[i]=cn(e,i,n,"month");return s}function mn(e,t,n,s){t=("boolean"==typeof e?w(t)&&(n=t,t=void 0):(t=e,e=!1,w(n=t)&&(n=t,t=void 0)),t||"");var i,r=P(),a=e?r._week.dow:0,o=[];if(null!=n)return cn(t,(n+a)%7,s,"day");for(i=0;i<7;i++)o[i]=cn(t,(i+a)%7,s,"day");return o}d.calendar=function(e,t,n){return a(e=this._calendar[e]||this._calendar.sameElse)?e.call(t,n):e},d.longDateFormat=function(e){var t=this._longDateFormat[e],n=this._longDateFormat[e.toUpperCase()];return t||!n?t:(this._longDateFormat[e]=n.match(te).map(function(e){return"MMMM"===e||"MM"===e||"DD"===e||"dddd"===e?e.slice(1):e}).join(""),this._longDateFormat[e])},d.invalidDate=function(){return this._invalidDate},d.ordinal=function(e){return this._ordinal.replace("%d",e)},d.preparse=hn,d.postformat=hn,d.relativeTime=function(e,t,n,s){var i=this._relativeTime[n];return a(i)?i(e,t,n,s):i.replace(/%d/i,e)},d.pastFuture=function(e,t){return a(e=this._relativeTime[0<e?"future":"past"])?e(t):e.replace(/%s/i,t)},d.set=function(e){var t,n;for(n in e)c(e,n)&&(a(t=e[n])?this[n]=t:this["_"+n]=t);this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+"|"+/\d{1,2}/.source)},d.eras=function(e,t){for(var n,s=this._eras||P("en")._eras,i=0,r=s.length;i<r;++i){switch(typeof s[i].since){case"string":n=_(s[i].since).startOf("day"),s[i].since=n.valueOf();break}switch(typeof s[i].until){case"undefined":s[i].until=1/0;break;case"string":n=_(s[i].until).startOf("day").valueOf(),s[i].until=n.valueOf();break}}return s},d.erasParse=function(e,t,n){var s,i,r,a,o,u=this.eras();for(e=e.toUpperCase(),s=0,i=u.length;s<i;++s)if(r=u[s].name.toUpperCase(),a=u[s].abbr.toUpperCase(),o=u[s].narrow.toUpperCase(),n)switch(t){case"N":case"NN":case"NNN":if(a===e)return u[s];break;case"NNNN":if(r===e)return u[s];break;case"NNNNN":if(o===e)return u[s];break}else if(0<=[r,a,o].indexOf(e))return u[s]},d.erasConvertYear=function(e,t){var n=e.since<=e.until?1:-1;return void 0===t?_(e.since).year():_(e.since).year()+(t-e.offset)*n},d.erasAbbrRegex=function(e){return c(this,"_erasAbbrRegex")||an.call(this),e?this._erasAbbrRegex:this._erasRegex},d.erasNameRegex=function(e){return c(this,"_erasNameRegex")||an.call(this),e?this._erasNameRegex:this._erasRegex},d.erasNarrowRegex=function(e){return c(this,"_erasNarrowRegex")||an.call(this),e?this._erasNarrowRegex:this._erasRegex},d.months=function(e,t){return e?(y(this._months)?this._months:this._months[(this._months.isFormat||Ve).test(t)?"format":"standalone"])[e.month()]:y(this._months)?this._months:this._months.standalone},d.monthsShort=function(e,t){return e?(y(this._monthsShort)?this._monthsShort:this._monthsShort[Ve.test(t)?"format":"standalone"])[e.month()]:y(this._monthsShort)?this._monthsShort:this._monthsShort.standalone},d.monthsParse=function(e,t,n){var s,i;if(this._monthsParseExact)return function(e,t,n){var s,i,r,e=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],s=0;s<12;++s)r=l([2e3,s]),this._shortMonthsParse[s]=this.monthsShort(r,"").toLocaleLowerCase(),this._longMonthsParse[s]=this.months(r,"").toLocaleLowerCase();return n?"MMM"===t?-1!==(i=x.call(this._shortMonthsParse,e))?i:null:-1!==(i=x.call(this._longMonthsParse,e))?i:null:"MMM"===t?-1!==(i=x.call(this._shortMonthsParse,e))||-1!==(i=x.call(this._longMonthsParse,e))?i:null:-1!==(i=x.call(this._longMonthsParse,e))||-1!==(i=x.call(this._shortMonthsParse,e))?i:null}.call(this,e,t,n);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),s=0;s<12;s++){if(i=l([2e3,s]),n&&!this._longMonthsParse[s]&&(this._longMonthsParse[s]=new RegExp("^"+this.months(i,"").replace(".","")+"$","i"),this._shortMonthsParse[s]=new RegExp("^"+this.monthsShort(i,"").replace(".","")+"$","i")),n||this._monthsParse[s]||(i="^"+this.months(i,"")+"|^"+this.monthsShort(i,""),this._monthsParse[s]=new RegExp(i.replace(".",""),"i")),n&&"MMMM"===t&&this._longMonthsParse[s].test(e))return s;if(n&&"MMM"===t&&this._shortMonthsParse[s].test(e))return s;if(!n&&this._monthsParse[s].test(e))return s}},d.monthsRegex=function(e){return this._monthsParseExact?(c(this,"_monthsRegex")||je.call(this),e?this._monthsStrictRegex:this._monthsRegex):(c(this,"_monthsRegex")||(this._monthsRegex=Ee),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)},d.monthsShortRegex=function(e){return this._monthsParseExact?(c(this,"_monthsRegex")||je.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(c(this,"_monthsShortRegex")||(this._monthsShortRegex=Ge),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)},d.week=function(e){return Be(e,this._week.dow,this._week.doy).week},d.firstDayOfYear=function(){return this._week.doy},d.firstDayOfWeek=function(){return this._week.dow},d.weekdays=function(e,t){return t=y(this._weekdays)?this._weekdays:this._weekdays[e&&!0!==e&&this._weekdays.isFormat.test(t)?"format":"standalone"],!0===e?Je(t,this._week.dow):e?t[e.day()]:t},d.weekdaysMin=function(e){return!0===e?Je(this._weekdaysMin,this._week.dow):e?this._weekdaysMin[e.day()]:this._weekdaysMin},d.weekdaysShort=function(e){return!0===e?Je(this._weekdaysShort,this._week.dow):e?this._weekdaysShort[e.day()]:this._weekdaysShort},d.weekdaysParse=function(e,t,n){var s,i;if(this._weekdaysParseExact)return function(e,t,n){var s,i,r,e=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],s=0;s<7;++s)r=l([2e3,1]).day(s),this._minWeekdaysParse[s]=this.weekdaysMin(r,"").toLocaleLowerCase(),this._shortWeekdaysParse[s]=this.weekdaysShort(r,"").toLocaleLowerCase(),this._weekdaysParse[s]=this.weekdays(r,"").toLocaleLowerCase();return n?"dddd"===t?-1!==(i=x.call(this._weekdaysParse,e))?i:null:"ddd"===t?-1!==(i=x.call(this._shortWeekdaysParse,e))?i:null:-1!==(i=x.call(this._minWeekdaysParse,e))?i:null:"dddd"===t?-1!==(i=x.call(this._weekdaysParse,e))||-1!==(i=x.call(this._shortWeekdaysParse,e))||-1!==(i=x.call(this._minWeekdaysParse,e))?i:null:"ddd"===t?-1!==(i=x.call(this._shortWeekdaysParse,e))||-1!==(i=x.call(this._weekdaysParse,e))||-1!==(i=x.call(this._minWeekdaysParse,e))?i:null:-1!==(i=x.call(this._minWeekdaysParse,e))||-1!==(i=x.call(this._weekdaysParse,e))||-1!==(i=x.call(this._shortWeekdaysParse,e))?i:null}.call(this,e,t,n);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),s=0;s<7;s++){if(i=l([2e3,1]).day(s),n&&!this._fullWeekdaysParse[s]&&(this._fullWeekdaysParse[s]=new RegExp("^"+this.weekdays(i,"").replace(".","\\.?")+"$","i"),this._shortWeekdaysParse[s]=new RegExp("^"+this.weekdaysShort(i,"").replace(".","\\.?")+"$","i"),this._minWeekdaysParse[s]=new RegExp("^"+this.weekdaysMin(i,"").replace(".","\\.?")+"$","i")),this._weekdaysParse[s]||(i="^"+this.weekdays(i,"")+"|^"+this.weekdaysShort(i,"")+"|^"+this.weekdaysMin(i,""),this._weekdaysParse[s]=new RegExp(i.replace(".",""),"i")),n&&"dddd"===t&&this._fullWeekdaysParse[s].test(e))return s;if(n&&"ddd"===t&&this._shortWeekdaysParse[s].test(e))return s;if(n&&"dd"===t&&this._minWeekdaysParse[s].test(e))return s;if(!n&&this._weekdaysParse[s].test(e))return s}},d.weekdaysRegex=function(e){return this._weekdaysParseExact?(c(this,"_weekdaysRegex")||st.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(c(this,"_weekdaysRegex")||(this._weekdaysRegex=et),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)},d.weekdaysShortRegex=function(e){return this._weekdaysParseExact?(c(this,"_weekdaysRegex")||st.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(c(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=tt),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)},d.weekdaysMinRegex=function(e){return this._weekdaysParseExact?(c(this,"_weekdaysRegex")||st.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(c(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=nt),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)},d.isPM=function(e){return"p"===(e+"").toLowerCase().charAt(0)},d.meridiem=function(e,t,n){return 11<e?n?"pm":"PM":n?"am":"AM"},ft("en",{eras:[{since:"0001-01-01",until:1/0,offset:1,name:"Anno Domini",narrow:"AD",abbr:"AD"},{since:"0000-12-31",until:-1/0,offset:1,name:"Before Christ",narrow:"BC",abbr:"BC"}],dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10;return e+(1===M(e%100/10)?"th":1==t?"st":2==t?"nd":3==t?"rd":"th")}}),_.lang=e("moment.lang is deprecated. Use moment.locale instead.",ft),_.langData=e("moment.langData is deprecated. Use moment.localeData instead.",P);var _n=Math.abs;function yn(e,t,n,s){t=C(t,n);return e._milliseconds+=s*t._milliseconds,e._days+=s*t._days,e._months+=s*t._months,e._bubble()}function gn(e){return e<0?Math.floor(e):Math.ceil(e)}function wn(e){return 4800*e/146097}function pn(e){return 146097*e/4800}function kn(e){return function(){return this.as(e)}}de=kn("ms"),t=kn("s"),ye=kn("m"),he=kn("h"),Fe=kn("d"),_e=kn("w"),me=kn("M"),Qe=kn("Q"),i=kn("y"),ce=de;function Mn(e){return function(){return this.isValid()?this._data[e]:NaN}}var we=Mn("milliseconds"),fe=Mn("seconds"),ge=Mn("minutes"),Pe=Mn("hours"),d=Mn("days"),vn=Mn("months"),Dn=Mn("years");var Yn=Math.round,Sn={ss:44,s:45,m:45,h:22,d:26,w:null,M:11};function On(e,t,n,s){var i=C(e).abs(),r=Yn(i.as("s")),a=Yn(i.as("m")),o=Yn(i.as("h")),u=Yn(i.as("d")),l=Yn(i.as("M")),d=Yn(i.as("w")),i=Yn(i.as("y")),r=(r<=n.ss?["s",r]:r<n.s&&["ss",r])||(a<=1?["m"]:a<n.m&&["mm",a])||(o<=1?["h"]:o<n.h&&["hh",o])||(u<=1?["d"]:u<n.d&&["dd",u]);return(r=(r=null!=n.w?r||(d<=1?["w"]:d<n.w&&["ww",d]):r)||(l<=1?["M"]:l<n.M&&["MM",l])||(i<=1?["y"]:["yy",i]))[2]=t,r[3]=0<+e,r[4]=s,function(e,t,n,s,i){return i.relativeTime(t||1,!!n,e,s)}.apply(null,r)}var bn=Math.abs;function Tn(e){return(0<e)-(e<0)||+e}function xn(){var e,t,n,s,i,r,a,o,u,l,d;return this.isValid()?(e=bn(this._milliseconds)/1e3,t=bn(this._days),n=bn(this._months),(o=this.asSeconds())?(s=m(e/60),i=m(s/60),e%=60,s%=60,r=m(n/12),n%=12,a=e?e.toFixed(3).replace(/\.?0+$/,""):"",u=Tn(this._months)!==Tn(o)?"-":"",l=Tn(this._days)!==Tn(o)?"-":"",d=Tn(this._milliseconds)!==Tn(o)?"-":"",(o<0?"-":"")+"P"+(r?u+r+"Y":"")+(n?u+n+"M":"")+(t?l+t+"D":"")+(i||s||e?"T":"")+(i?d+i+"H":"")+(s?d+s+"M":"")+(e?d+a+"S":"")):"P0D"):this.localeData().invalidDate()}var U=Ct.prototype;return U.isValid=function(){return this._isValid},U.abs=function(){var e=this._data;return this._milliseconds=_n(this._milliseconds),this._days=_n(this._days),this._months=_n(this._months),e.milliseconds=_n(e.milliseconds),e.seconds=_n(e.seconds),e.minutes=_n(e.minutes),e.hours=_n(e.hours),e.months=_n(e.months),e.years=_n(e.years),this},U.add=function(e,t){return yn(this,e,t,1)},U.subtract=function(e,t){return yn(this,e,t,-1)},U.as=function(e){if(!this.isValid())return NaN;var t,n,s=this._milliseconds;if("month"===(e=o(e))||"quarter"===e||"year"===e)switch(t=this._days+s/864e5,n=this._months+wn(t),e){case"month":return n;case"quarter":return n/3;case"year":return n/12}else switch(t=this._days+Math.round(pn(this._months)),e){case"week":return t/7+s/6048e5;case"day":return t+s/864e5;case"hour":return 24*t+s/36e5;case"minute":return 1440*t+s/6e4;case"second":return 86400*t+s/1e3;case"millisecond":return Math.floor(864e5*t)+s;default:throw new Error("Unknown unit "+e)}},U.asMilliseconds=de,U.asSeconds=t,U.asMinutes=ye,U.asHours=he,U.asDays=Fe,U.asWeeks=_e,U.asMonths=me,U.asQuarters=Qe,U.asYears=i,U.valueOf=ce,U._bubble=function(){var e=this._milliseconds,t=this._days,n=this._months,s=this._data;return 0<=e&&0<=t&&0<=n||e<=0&&t<=0&&n<=0||(e+=864e5*gn(pn(n)+t),n=t=0),s.milliseconds=e%1e3,e=m(e/1e3),s.seconds=e%60,e=m(e/60),s.minutes=e%60,e=m(e/60),s.hours=e%24,t+=m(e/24),n+=e=m(wn(t)),t-=gn(pn(e)),e=m(n/12),n%=12,s.days=t,s.months=n,s.years=e,this},U.clone=function(){return C(this)},U.get=function(e){return e=o(e),this.isValid()?this[e+"s"]():NaN},U.milliseconds=we,U.seconds=fe,U.minutes=ge,U.hours=Pe,U.days=d,U.weeks=function(){return m(this.days()/7)},U.months=vn,U.years=Dn,U.humanize=function(e,t){var n,s;return this.isValid()?(n=!1,s=Sn,"object"==typeof e&&(t=e,e=!1),"boolean"==typeof e&&(n=e),"object"==typeof t&&(s=Object.assign({},Sn,t),null!=t.s)&&null==t.ss&&(s.ss=t.s-1),e=this.localeData(),t=On(this,!n,s,e),n&&(t=e.pastFuture(+this,t)),e.postformat(t)):this.localeData().invalidDate()},U.toISOString=xn,U.toString=xn,U.toJSON=xn,U.locale=Xt,U.localeData=Kt,U.toIsoString=e("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",xn),U.lang=Ke,s("X",0,0,"unix"),s("x",0,0,"valueOf"),h("x",ke),h("X",/[+-]?\d+(\.\d{1,3})?/),v("X",function(e,t,n){n._d=new Date(1e3*parseFloat(e))}),v("x",function(e,t,n){n._d=new Date(M(e))}),_.version="2.30.1",H=R,_.fn=u,_.min=function(){return Pt("isBefore",[].slice.call(arguments,0))},_.max=function(){return Pt("isAfter",[].slice.call(arguments,0))},_.now=function(){return Date.now?Date.now():+new Date},_.utc=l,_.unix=function(e){return R(1e3*e)},_.months=function(e,t){return fn(e,t,"months")},_.isDate=V,_.locale=ft,_.invalid=I,_.duration=C,_.isMoment=k,_.weekdays=function(e,t,n){return mn(e,t,n,"weekdays")},_.parseZone=function(){return R.apply(null,arguments).parseZone()},_.localeData=P,_.isDuration=Ut,_.monthsShort=function(e,t){return fn(e,t,"monthsShort")},_.weekdaysMin=function(e,t,n){return mn(e,t,n,"weekdaysMin")},_.defineLocale=mt,_.updateLocale=function(e,t){var n,s;return null!=t?(s=ut,null!=W[e]&&null!=W[e].parentLocale?W[e].set(X(W[e]._config,t)):(t=X(s=null!=(n=ct(e))?n._config:s,t),null==n&&(t.abbr=e),(s=new K(t)).parentLocale=W[e],W[e]=s),ft(e)):null!=W[e]&&(null!=W[e].parentLocale?(W[e]=W[e].parentLocale,e===ft()&&ft(e)):null!=W[e]&&delete W[e]),W[e]},_.locales=function(){return ee(W)},_.weekdaysShort=function(e,t,n){return mn(e,t,n,"weekdaysShort")},_.normalizeUnits=o,_.relativeTimeRounding=function(e){return void 0===e?Yn:"function"==typeof e&&(Yn=e,!0)},_.relativeTimeThreshold=function(e,t){return void 0!==Sn[e]&&(void 0===t?Sn[e]:(Sn[e]=t,"s"===e&&(Sn.ss=t-1),!0))},_.calendarFormat=function(e,t){return(e=e.diff(t,"days",!0))<-6?"sameElse":e<-1?"lastWeek":e<0?"lastDay":e<1?"sameDay":e<2?"nextDay":e<7?"nextWeek":"sameElse"},_.prototype=u,_.HTML5_FMT={DATETIME_LOCAL:"YYYY-MM-DDTHH:mm",DATETIME_LOCAL_SECONDS:"YYYY-MM-DDTHH:mm:ss",DATETIME_LOCAL_MS:"YYYY-MM-DDTHH:mm:ss.SSS",DATE:"YYYY-MM-DD",TIME:"HH:mm",TIME_SECONDS:"HH:mm:ss",TIME_MS:"HH:mm:ss.SSS",WEEK:"GGGG-[W]WW",MONTH:"YYYY-MM"},_});
//# sourceMappingURL=moment.min.js.map;
/*jshint bitwise: false*/
define('RactiveValidate',['lodash-compat', 'moment'], function (_, moment) {

	var Validate = function (ractive, rules, errorSuffix) {

		var self = this;

		self.ractive = ractive;

		self.rules = rules;

		/**
         * If set, if there is a validation error with a given keypath, then the
         * error text will be set at the keypath with the errorSuffix appended.
         */
		self.errorSuffix = errorSuffix || 'ErrorMsg';

		self.cwd = 'data';
		self.dateFormat = 'DD/MM/YYYY';
		self.dateToMoment = function (date) {
			// Always return date object
			if (date instanceof Date) {
				return moment(date);
			} else {
				return moment(date, self.dateFormat, true);
			}
		};

		self.keypath = function (keypath) {
			return [
				this.cwd,
				keypath
			].filter(function (value) {
				return value;
			}).join('.');
		};

		self.patterns = {
			alpha: /^[a-zA-Z\s]+$/,
			alphaNoSpace: /^[a-zA-Z]+$/,
			alpha_numeric: /^[a-zA-Z\d\s]+$/,
			alphaAndNumeric: /^(?=.*\d)(?=.*[a-zA-Z])/,
			digits: /^\d+$/,
			decimalNumber: /^\d+(\.\d+)?$/,
			expiryDatePattern: /^(0[1-9]|1[0-2])\/([0-9]{2})$/,
			simNumber: /^((\d{13})|(896102\d{13})(?!.))$/,
			uppercase: /[A-Z]/,
			lowercase: /[a-z]/,
			symbols: /[_\W0-9]/,
			dayPattern: /^[1-9]$|^0[0-9]$|^[1-2][0-9]$|^3[0-1]$/,
			validMobileNumber: /^[89][0-9]{7}$/, //mobile number should start with 8 or
			validPhoneNumber: /^[689][0-9]{7}$/, //mobile number should start with 6, 8 or 9
			orderNumber: /^[0-9]{8}$|^[0-9]{1,10}[A-Z]{1}$/,
			validUserName: /^[a-zA-Z\s\/?]+$/,
			//Account number should start with 8 should be 10 digits or starting with 9 should be 9 digits
			validAccNumber: /^[8]\d{9}$|^[9]\d{9}$/,
			email: function (value) {
				var exp = new RegExp (['^(([^<>()[\\]\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\.,;:\\s@\"]+)*)|(\\".+\"))@',
				'(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$'].join(''), 'i');
				return exp.test(value);
			},
			emailId : /^[A-Za-z0-9._-]+@([a-z0-9]+\.)*[A-Za-z0-9]+\.[A-Za-z]{2,3}$/,
			//
			mobilePhone: function (value) {
				if (value) {
					var formated = value.replace(/\s/g, '');
					return new RegExp(/^((0|(61)|(\+61))4{1}[0-9]{8})$/).test(formated);
				} else {
					return false;
				}
			},
			travelPackStartDate: function (value) {
				if (!moment(value, 'ddd MMM DD YYYY', true).isValid()) {
					return false;
				} else {
					var date = moment(moment(value, 'ddd MMM DD YYYY').valueOf());
					var validrange = date.isBetween(moment(new Date()), moment(new Date()).add(30, 'day'), null, '[]');
					var travelPackSameDay = date.isSame(moment(new Date()).format('YYYY-MM-DD'));
					var travelPackLastDay = date.isSame(moment(new Date()).add(30, 'day').format('YYYY-MM-DD'));
					return (validrange || travelPackSameDay || travelPackLastDay);
				}
			},
			homePhone: function (value) {
				if (value) {
					var formated = value.replace(/\s/g, '');
					return new RegExp(/^((0|(61)|(\+61))(2|3|5|6|7|8|9){1}[0-9]{8})$/).test(formated);
				} else {
					return false;
				}
			},
			specialPhone: function (value) {
				if (value) {
					var formated = value.replace(/\s/g, '');
					return new RegExp(/^((1300|1800){1}[0-9]{6})|((131){1}[0-9]{3})$/).test(formated);
				} else {
					return false;
				}
			},
			isPhoneNumber: function (value) {
				return this.mobilePhone(value) || this.homePhone(value) ||
					this.specialPhone(value);
			},
			ischecked: function (value) {
				return value;
			},
			matchfield: function (value, param) {
				var otherFieldValue = self.ractive.get(self.keypath(param));
				return _.isEqual(value, otherFieldValue);
			},
			matchemailfield: function (value, param) {
				//if entered email is valid then check for match
				if (!this.email(value)) {
					return true;
				}
				var otherFieldValue = self.ractive.get(self.keypath(param));
				return _.isEqual(value, otherFieldValue);
			},
			// Validation to check if user has entered valid Optus username or registered email
			validUsernameOrEmail: function (value) {
				var internetUserRegex = /^[A-Za-z][A-Za-z0-9_.-]{3,}$/;

				return (this.email(value) || internetUserRegex.test(value));
			},
			//password needs to contain a minimum of 8 characters, uppercase and lowercase and a number or a symbol
			isValidPassword: function (value) {
				if (!value || value.length < 8) {
					return false;
				}
				return (/[a-z]+/.test(value) && /[A-Z]+/.test(value) && (/[\W]+/.test(value) || /[0-9]+/.test(value)));
			},
			required: function (value) {
				if (typeof (value) === 'boolean') {
					return !_.isNull(value) && value;
				} else {
					value = _.trim(value);
					return !_.isNull(value) && !_.isEqual(value, '') && !_.isUndefined(value);
				}
			},
			minlength: function (value, param) {
				return !_.isNull(value) && !_.isUndefined(value) && !_.isBoolean(value) &&
						String(value).length >= parseInt(param, 10);
			},
			maxlength: function (value, param) {
				return !_.isNull(value) && !_.isUndefined(value) && !_.isBoolean(value) &&
						String(value).length <= parseInt(param, 10);
			},
			date: function (value) {
				var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
				// Match the date format through regular expression
				if (value && value.match(dateformat)) {
					var date = value.split('/');
					if (date.length === 1) {
						date = value.split('-');
					}
					var dd = parseInt(date[0]);
					var mm  = parseInt(date[1]);
					var yy = parseInt(date[2]);
					// Create list of days of a month [assume there is no leap year by default]
					var ListofDays = [31,28,31,30,31,30,31,31,30,31,30,31];
					if (mm === 1 || mm > 2) {
						if (dd > ListofDays[mm - 1]) {
							return false;
						}
					}
					if (mm === 2) {
						var lyear = false;
						if ((yy % 4 === 0) && ((yy % 100 !== 0) || (yy % 400 === 0))) {
							lyear = true;
						}
						if ((lyear === false) && (dd >= 29)) {
							return false;
						}
						if ((lyear === true) && (dd > 29)) {
							return false;
						}
					}
				} else {
					return false;
				}
				return true;
			},
			matchPassword: function (value, param) {
				return _.eq(value, param);
			},
			mobileOptus : /^(\+\d{1,3}[\s]?)?(\+\d{1,3}[\-]?)?\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{2,4}$/,
			website: /https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,}/,
			websiteOrEmpty: /^$|https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,}/,
			bsbFormatOptus: /^\d{3}-?\d{3}$/,
			year: function (value) {
				var date = new Date();
				if (value && parseInt(value) <= date.getFullYear()) {
					return true;
				}
				return false;
			},
			matchMonth: function (value, year) {
				var date = new Date();
				var selectedMonth = new Date(Date.parse(value + '1')).getMonth() + 1;
				if (year === date.getFullYear().toString()) {
					if (selectedMonth && selectedMonth === date.getMonth() + 1 || selectedMonth <= date.getMonth() + 1) {
						return true;
					} else if (selectedMonth > date.getMonth() + 1) {
						return false;
					} else {
						return true;
					}
				} else {
					return true;
				}
			},
			day: function (value, param) {
				var month = param[0];
				var year = param[1];
				var selectedMonth = new Date(Date.parse(month + '1')).getMonth() + 1;
				var date = new Date();
				if (year === date.getFullYear().toString()) {
					if (selectedMonth === date.getMonth() + 1) {
						if (value && value > selectedMonth) {
							return false;
						}
						return true;
					} else {
						return true;
					}
				} else {
					return true;
				}
			},
			isFutureDate: function (dateValue) {
				var value = self.dateToMoment(dateValue);
				var today = moment(); // current time
				return value.isValid() && value.isAfter(today);
			},
			isPastDate: function (dateValue) {
				var value = self.dateToMoment(dateValue);
				var today = moment(); // current time
				return value.isValid() && value.isBefore(today);
			},
			//'isValidDate' is the preferred rule over 'date' for date validation.
			isValidDate: function (dateValue) {
				var value = self.dateToMoment(dateValue);
				//true is for strict validation, otherwise it allows DD/02/YYYY date
				return value.isValid();
			},
			isValidDay: function (value) {
				return moment(value, 'DD', true).isValid();
			},
			isValidMonth: function (value) {
				return moment(value, 'MM', true).isValid();
			},
			isValidAge: function (value) {
				var dobYear = moment([value]),
					diff = moment().diff(dobYear, 'years');
				return diff > 14;
			},
			isAdult: function (value) {
				return !moment(value, 'DD/MM/YYYY', true).isAfter(moment().subtract(18, 'years'));
			},
			isDobNricVal: function (value) {
				var nric = value.nric;
				var dob = moment(value.dob, 'DD/MM/YYYY', true).year();
				var indentType = nric.charAt(0);
				if (indentType === 'S' || indentType === 'T') {
					var subnric = nric.substring(1, 3);
					var subDob = String(dob).substring(2, 4);
					if ((dob >= 2000 && (indentType === 'T')) ||
					((dob >= 1968 && dob <= 1999) && (indentType === 'S') && subnric >= 68)) {
						return (subnric === subDob);
					} else if ((indentType === 'S') && subnric <= 67) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			},
			containsNoSpaces: function (value) {
				return (String(value).indexOf(' ') === -1);
			},
			containsNoSpecialChars: function (value) {
				var specialChars = '£¬¦<>@!#$%^&*()_+[]{}?:;|\'\"\\~`=,.-';
				var check = function (string) {
					for (var i = 0; i < specialChars.length; i++) {
						if (string.indexOf(specialChars[i]) > -1) {
							return false;
						}
					}
					return true;
				};
				return check(value);
			},
			optusAddress: function (value) {
				//	Here we allow ,.-/ as they could be in a valid address
				var specialChars = '£¬¦<>@!#$%^&*()_+[]{}?:;|\'\"\\~`=';
				var check = function (string) {
					for (var i = 0; i < specialChars.length; i++) {
						if (string.indexOf(specialChars[i]) > -1) {
							return false;
						}
					}
					return true;
				};
				return check(value);
			},
			optusPostCode: /^([0-9]{4})$/,
			selectionRequired: function (value) {
				if (value === 'Please Specify') {
					return false;
				}
				return true;
			},
			optusName_noNumericaChars: /^[a-zA-Z-\s']+$/,
			optusName_blankHyphensApostrophes: function (value) {
				var blankHyphenPatternsNotAllowed =
						['  ', '--', '\'\'', '- ', ' -', ' \'', '\' ', '-\'', '\'-'];
				var isValid = true;
				for (var i = 0; i < blankHyphenPatternsNotAllowed.length; i++) {
					if (value.indexOf(blankHyphenPatternsNotAllowed[i]) !== -1) {
						isValid = false;
						break;
					}
				}
				return isValid;
			},
			optusName_isNotInBlacklist : function (value, param) {
				var isIn = $.inArray(value, param) > -1;
				return !isIn;
			},
			optusName_singleChar: function (value) {
				if (value.length === 1 && value.toLowerCase() !== 'o') {
					return false;
				}
				return true;
			},
			optus_SimCard_Luhn_Algorithm: function (luhn) {
				var len = luhn.length,
					mul = 0,
					prodArr = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]],
					sum = 0;

				while (len--) {
					sum += prodArr[mul][parseInt(luhn.charAt(len), 10)];
					mul ^= 1;
				}

				return sum % 10 === 0 && sum > 0;
			}
		};
	};

	Validate.prototype = {

		validate: function () {
			var self = this;
			var invalidCount = _.filter(self.rules, function (rules, ruleKey) {
				var keypath = self.keypath(ruleKey);
				var value = self.ractive.get(keypath);
				var valuePopulated = value || value === 0 || value === false;
				var invalid = _.map(rules, function (params, rule) {
					var passed = false;
					var param = params.param || null;
					var valid = {
						status: 'valid'
					};

					if (_.isFunction(self.patterns[rule])) {
						// if a value exists, or is required, then validate
						if (param && param.isNullAllowed) {
							passed = self.patterns[rule].call(self, value, param);
						} else if (valuePopulated || rule === 'required') {
							passed = self.patterns[rule](value, param);
						} else {  //no value and not required -> passed
							passed = true;
						}
					}
					if (_.isRegExp(self.patterns[rule]) && valuePopulated) { //value exists, then validate
						passed = self.patterns[rule].test(value);
					}

					// reset each field validation state
					self.ractive.set(keypath + self.errorSuffix, valid);

					return {
						params: params,
						rule: rule,
						passed: passed
					};

				}).filter(function (rule) {
					return !rule.passed;
				}).map(function (rule) {
					self.invalidate(ruleKey, rule.rule);
					return rule;
				});

				return invalid.length > 0;
			}).length;

			return {
				valid: invalidCount === 0
			};
		},


		invalidate: function (ruleKey, rule) {
			var self = this;
			var keypath = self.keypath(ruleKey);
			var errorMsg = self.rules[ruleKey][rule];
			var error = {
				rule: rule,
				passed: false,
				status: 'error',
				message: errorMsg.message || errorMsg
			};
			self.ractive.set(keypath + self.errorSuffix, error);
			return error;
		},

		findValidationErrorsInResponse: function (response) {
			var self = this;
			return _(response.errors)
					.filter(function (error) {
						return error.errorId && error.errorId.indexOf('.field.') !== -1;
					})
					.map(function (error) {
						var ruleObj = error.errorId
								.replace('.field', '')
								.split('.');
						return self.invalidate(ruleObj[0], ruleObj[1]);
					});
		}

	};

	return Validate;
});

/**
 * FingerprintJS v0.2.1 - Copyright (c) FingerprintJS, Inc, 2024 (https://fingerprint.com)
 * Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
 *
 * This software contains code from open-source projects:
 * MurmurHash3 by Karan Lyons (https://github.com/karanlyons/murmurHash3.js)
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define('FingerprintJs',['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.FingerprintJS = {}));
})(this, (function (exports) { 'use strict';

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */


    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (g && (g = 0, op[0] && (_ = 0)), _) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    }

    var version = "0.2.1";

    function wait(durationMs, resolveWith) {
        return new Promise(function (resolve) { return setTimeout(resolve, durationMs, resolveWith); });
    }
    function requestIdleCallbackIfAvailable(fallbackTimeout, deadlineTimeout) {
        if (deadlineTimeout === void 0) { deadlineTimeout = Infinity; }
        var requestIdleCallback = window.requestIdleCallback;
        if (requestIdleCallback) {
            // The function `requestIdleCallback` loses the binding to `window` here.
            // `globalThis` isn't always equal `window` (see https://github.com/fingerprintjs/fingerprintjs/issues/683).
            // Therefore, an error can occur. `call(window,` prevents the error.
            return new Promise(function (resolve) { return requestIdleCallback.call(window, function () { return resolve(); }, { timeout: deadlineTimeout }); });
        }
        else {
            return wait(Math.min(fallbackTimeout, deadlineTimeout));
        }
    }
    function isPromise(value) {
        return !!value && typeof value.then === 'function';
    }
    /**
     * Calls a maybe asynchronous function without creating microtasks when the function is synchronous.
     * Catches errors in both cases.
     *
     * If just you run a code like this:
     * ```
     * console.time('Action duration')
     * await action()
     * console.timeEnd('Action duration')
     * ```
     * The synchronous function time can be measured incorrectly because another microtask may run before the `await`
     * returns the control back to the code.
     */
    function awaitIfAsync(action, callback) {
        try {
            var returnedValue = action();
            if (isPromise(returnedValue)) {
                returnedValue.then(function (result) { return callback(true, result); }, function (error) { return callback(false, error); });
            }
            else {
                callback(true, returnedValue);
            }
        }
        catch (error) {
            callback(false, error);
        }
    }
    /**
     * If you run many synchronous tasks without using this function, the JS main loop will be busy and asynchronous tasks
     * (e.g. completing a network request, rendering the page) won't be able to happen.
     * This function allows running many synchronous tasks such way that asynchronous tasks can run too in background.
     */
    function mapWithBreaks(items, callback, loopReleaseInterval) {
        if (loopReleaseInterval === void 0) { loopReleaseInterval = 16; }
        return __awaiter(this, void 0, void 0, function () {
            var results, lastLoopReleaseTime, i, now;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        results = Array(items.length);
                        lastLoopReleaseTime = Date.now();
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < items.length)) return [3 /*break*/, 4];
                        results[i] = callback(items[i], i);
                        now = Date.now();
                        if (!(now >= lastLoopReleaseTime + loopReleaseInterval)) return [3 /*break*/, 3];
                        lastLoopReleaseTime = now;
                        // Allows asynchronous actions and microtasks to happen
                        return [4 /*yield*/, wait(0)];
                    case 2:
                        // Allows asynchronous actions and microtasks to happen
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        ++i;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, results];
                }
            });
        });
    }
    /**
     * Makes the given promise never emit an unhandled promise rejection console warning.
     * The promise will still pass errors to the next promises.
     *
     * Otherwise, promise emits a console warning unless it has a `catch` listener.
     */
    function suppressUnhandledRejectionWarning(promise) {
        promise.then(undefined, function () { return undefined; });
    }

    /*
     * Taken from https://github.com/karanlyons/murmurHash3.js/blob/a33d0723127e2e5415056c455f8aed2451ace208/murmurHash3.js
     */
    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // added together as a 64bit int (as an array of two 32bit ints).
    //
    function x64Add(m, n) {
        m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
        n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
        var o = [0, 0, 0, 0];
        o[3] += m[3] + n[3];
        o[2] += o[3] >>> 16;
        o[3] &= 0xffff;
        o[2] += m[2] + n[2];
        o[1] += o[2] >>> 16;
        o[2] &= 0xffff;
        o[1] += m[1] + n[1];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[0] += m[0] + n[0];
        o[0] &= 0xffff;
        return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]];
    }
    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // multiplied together as a 64bit int (as an array of two 32bit ints).
    //
    function x64Multiply(m, n) {
        m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
        n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
        var o = [0, 0, 0, 0];
        o[3] += m[3] * n[3];
        o[2] += o[3] >>> 16;
        o[3] &= 0xffff;
        o[2] += m[2] * n[3];
        o[1] += o[2] >>> 16;
        o[2] &= 0xffff;
        o[2] += m[3] * n[2];
        o[1] += o[2] >>> 16;
        o[2] &= 0xffff;
        o[1] += m[1] * n[3];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[1] += m[2] * n[2];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[1] += m[3] * n[1];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
        o[0] &= 0xffff;
        return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]];
    }
    //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) rotated left by that number of positions.
    //
    function x64Rotl(m, n) {
        n %= 64;
        if (n === 32) {
            return [m[1], m[0]];
        }
        else if (n < 32) {
            return [(m[0] << n) | (m[1] >>> (32 - n)), (m[1] << n) | (m[0] >>> (32 - n))];
        }
        else {
            n -= 32;
            return [(m[1] << n) | (m[0] >>> (32 - n)), (m[0] << n) | (m[1] >>> (32 - n))];
        }
    }
    //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) shifted left by that number of positions.
    //
    function x64LeftShift(m, n) {
        n %= 64;
        if (n === 0) {
            return m;
        }
        else if (n < 32) {
            return [(m[0] << n) | (m[1] >>> (32 - n)), m[1] << n];
        }
        else {
            return [m[1] << (n - 32), 0];
        }
    }
    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // xored together as a 64bit int (as an array of two 32bit ints).
    //
    function x64Xor(m, n) {
        return [m[0] ^ n[0], m[1] ^ n[1]];
    }
    //
    // Given a block, returns murmurHash3's final x64 mix of that block.
    // (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
    // only place where we need to right shift 64bit ints.)
    //
    function x64Fmix(h) {
        h = x64Xor(h, [0, h[0] >>> 1]);
        h = x64Multiply(h, [0xff51afd7, 0xed558ccd]);
        h = x64Xor(h, [0, h[0] >>> 1]);
        h = x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53]);
        h = x64Xor(h, [0, h[0] >>> 1]);
        return h;
    }
    //
    // Given a string and an optional seed as an int, returns a 128 bit
    // hash using the x64 flavor of MurmurHash3, as an unsigned hex.
    //
    function x64hash128(key, seed) {
        key = key || '';
        seed = seed || 0;
        var remainder = key.length % 16;
        var bytes = key.length - remainder;
        var h1 = [0, seed];
        var h2 = [0, seed];
        var k1 = [0, 0];
        var k2 = [0, 0];
        var c1 = [0x87c37b91, 0x114253d5];
        var c2 = [0x4cf5ad43, 0x2745937f];
        var i;
        for (i = 0; i < bytes; i = i + 16) {
            k1 = [
                (key.charCodeAt(i + 4) & 0xff) |
                    ((key.charCodeAt(i + 5) & 0xff) << 8) |
                    ((key.charCodeAt(i + 6) & 0xff) << 16) |
                    ((key.charCodeAt(i + 7) & 0xff) << 24),
                (key.charCodeAt(i) & 0xff) |
                    ((key.charCodeAt(i + 1) & 0xff) << 8) |
                    ((key.charCodeAt(i + 2) & 0xff) << 16) |
                    ((key.charCodeAt(i + 3) & 0xff) << 24),
            ];
            k2 = [
                (key.charCodeAt(i + 12) & 0xff) |
                    ((key.charCodeAt(i + 13) & 0xff) << 8) |
                    ((key.charCodeAt(i + 14) & 0xff) << 16) |
                    ((key.charCodeAt(i + 15) & 0xff) << 24),
                (key.charCodeAt(i + 8) & 0xff) |
                    ((key.charCodeAt(i + 9) & 0xff) << 8) |
                    ((key.charCodeAt(i + 10) & 0xff) << 16) |
                    ((key.charCodeAt(i + 11) & 0xff) << 24),
            ];
            k1 = x64Multiply(k1, c1);
            k1 = x64Rotl(k1, 31);
            k1 = x64Multiply(k1, c2);
            h1 = x64Xor(h1, k1);
            h1 = x64Rotl(h1, 27);
            h1 = x64Add(h1, h2);
            h1 = x64Add(x64Multiply(h1, [0, 5]), [0, 0x52dce729]);
            k2 = x64Multiply(k2, c2);
            k2 = x64Rotl(k2, 33);
            k2 = x64Multiply(k2, c1);
            h2 = x64Xor(h2, k2);
            h2 = x64Rotl(h2, 31);
            h2 = x64Add(h2, h1);
            h2 = x64Add(x64Multiply(h2, [0, 5]), [0, 0x38495ab5]);
        }
        k1 = [0, 0];
        k2 = [0, 0];
        switch (remainder) {
            case 15:
                k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 14)], 48));
            // fallthrough
            case 14:
                k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 13)], 40));
            // fallthrough
            case 13:
                k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 12)], 32));
            // fallthrough
            case 12:
                k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 11)], 24));
            // fallthrough
            case 11:
                k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 10)], 16));
            // fallthrough
            case 10:
                k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 9)], 8));
            // fallthrough
            case 9:
                k2 = x64Xor(k2, [0, key.charCodeAt(i + 8)]);
                k2 = x64Multiply(k2, c2);
                k2 = x64Rotl(k2, 33);
                k2 = x64Multiply(k2, c1);
                h2 = x64Xor(h2, k2);
            // fallthrough
            case 8:
                k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 7)], 56));
            // fallthrough
            case 7:
                k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 6)], 48));
            // fallthrough
            case 6:
                k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 5)], 40));
            // fallthrough
            case 5:
                k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 4)], 32));
            // fallthrough
            case 4:
                k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 3)], 24));
            // fallthrough
            case 3:
                k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 2)], 16));
            // fallthrough
            case 2:
                k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 1)], 8));
            // fallthrough
            case 1:
                k1 = x64Xor(k1, [0, key.charCodeAt(i)]);
                k1 = x64Multiply(k1, c1);
                k1 = x64Rotl(k1, 31);
                k1 = x64Multiply(k1, c2);
                h1 = x64Xor(h1, k1);
            // fallthrough
        }
        h1 = x64Xor(h1, [0, key.length]);
        h2 = x64Xor(h2, [0, key.length]);
        h1 = x64Add(h1, h2);
        h2 = x64Add(h2, h1);
        h1 = x64Fmix(h1);
        h2 = x64Fmix(h2);
        h1 = x64Add(h1, h2);
        h2 = x64Add(h2, h1);
        return (('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) +
            ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) +
            ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) +
            ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8));
    }

    /**
     * Converts an error object to a plain object that can be used with `JSON.stringify`.
     * If you just run `JSON.stringify(error)`, you'll get `'{}'`.
     */
    function errorToObject(error) {
        var _a;
        return __assign({ name: error.name, message: error.message, stack: (_a = error.stack) === null || _a === void 0 ? void 0 : _a.split('\n') }, error);
    }

    /*
     * This file contains functions to work with pure data only (no browser features, DOM, side effects, etc).
     */
    /**
     * Does the same as Array.prototype.includes but has better typing
     */
    function includes(haystack, needle) {
        for (var i = 0, l = haystack.length; i < l; ++i) {
            if (haystack[i] === needle) {
                return true;
            }
        }
        return false;
    }
    /**
     * Like `!includes()` but with proper typing
     */
    function excludes(haystack, needle) {
        return !includes(haystack, needle);
    }
    /**
     * Be careful, NaN can return
     */
    function toInt(value) {
        return parseInt(value);
    }
    /**
     * Be careful, NaN can return
     */
    function toFloat(value) {
        return parseFloat(value);
    }
    function replaceNaN(value, replacement) {
        return typeof value === 'number' && isNaN(value) ? replacement : value;
    }
    function countTruthy(values) {
        return values.reduce(function (sum, value) { return sum + (value ? 1 : 0); }, 0);
    }
    function round(value, base) {
        if (base === void 0) { base = 1; }
        if (Math.abs(base) >= 1) {
            return Math.round(value / base) * base;
        }
        else {
            // Sometimes when a number is multiplied by a small number, precision is lost,
            // for example 1234 * 0.0001 === 0.12340000000000001, and it's more precise divide: 1234 / (1 / 0.0001) === 0.1234.
            var counterBase = 1 / base;
            return Math.round(value * counterBase) / counterBase;
        }
    }
    /**
     * Parses a CSS selector into tag name with HTML attributes.
     * Only single element selector are supported (without operators like space, +, >, etc).
     *
     * Multiple values can be returned for each attribute. You decide how to handle them.
     */
    function parseSimpleCssSelector(selector) {
        var _a, _b;
        var errorMessage = "Unexpected syntax '".concat(selector, "'");
        var tagMatch = /^\s*([a-z-]*)(.*)$/i.exec(selector);
        var tag = tagMatch[1] || undefined;
        var attributes = {};
        var partsRegex = /([.:#][\w-]+|\[.+?\])/gi;
        var addAttribute = function (name, value) {
            attributes[name] = attributes[name] || [];
            attributes[name].push(value);
        };
        for (;;) {
            var match = partsRegex.exec(tagMatch[2]);
            if (!match) {
                break;
            }
            var part = match[0];
            switch (part[0]) {
                case '.':
                    addAttribute('class', part.slice(1));
                    break;
                case '#':
                    addAttribute('id', part.slice(1));
                    break;
                case '[': {
                    var attributeMatch = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(part);
                    if (attributeMatch) {
                        addAttribute(attributeMatch[1], (_b = (_a = attributeMatch[4]) !== null && _a !== void 0 ? _a : attributeMatch[5]) !== null && _b !== void 0 ? _b : '');
                    }
                    else {
                        throw new Error(errorMessage);
                    }
                    break;
                }
                default:
                    throw new Error(errorMessage);
            }
        }
        return [tag, attributes];
    }

    function ensureErrorWithMessage(error) {
        return error && typeof error === 'object' && 'message' in error ? error : { message: error };
    }
    function isFinalResultLoaded(loadResult) {
        return typeof loadResult !== 'function';
    }
    /**
     * Loads the given entropy source. Returns a function that gets an entropy component from the source.
     *
     * The result is returned synchronously to prevent `loadSources` from
     * waiting for one source to load before getting the components from the other sources.
     */
    function loadSource(source, sourceOptions) {
        var sourceLoadPromise = new Promise(function (resolveLoad) {
            var loadStartTime = Date.now();
            // `awaitIfAsync` is used instead of just `await` in order to measure the duration of synchronous sources
            // correctly (other microtasks won't affect the duration).
            awaitIfAsync(source.bind(null, sourceOptions), function () {
                var loadArgs = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    loadArgs[_i] = arguments[_i];
                }
                var loadDuration = Date.now() - loadStartTime;
                // Source loading failed
                if (!loadArgs[0]) {
                    return resolveLoad(function () { return ({ error: ensureErrorWithMessage(loadArgs[1]), duration: loadDuration }); });
                }
                var loadResult = loadArgs[1];
                // Source loaded with the final result
                if (isFinalResultLoaded(loadResult)) {
                    return resolveLoad(function () { return ({ value: loadResult, duration: loadDuration }); });
                }
                // Source loaded with "get" stage
                resolveLoad(function () {
                    return new Promise(function (resolveGet) {
                        var getStartTime = Date.now();
                        awaitIfAsync(loadResult, function () {
                            var getArgs = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                getArgs[_i] = arguments[_i];
                            }
                            var duration = loadDuration + Date.now() - getStartTime;
                            // Source getting failed
                            if (!getArgs[0]) {
                                return resolveGet({ error: ensureErrorWithMessage(getArgs[1]), duration: duration });
                            }
                            // Source getting succeeded
                            resolveGet({ value: getArgs[1], duration: duration });
                        });
                    });
                });
            });
        });
        suppressUnhandledRejectionWarning(sourceLoadPromise);
        return function getComponent() {
            return sourceLoadPromise.then(function (finalizeSource) { return finalizeSource(); });
        };
    }
    /**
     * Loads the given entropy sources. Returns a function that collects the entropy components.
     *
     * The result is returned synchronously in order to allow start getting the components
     * before the sources are loaded completely.
     *
     * Warning for package users:
     * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
     */
    function loadSources(sources, sourceOptions, excludeSources) {
        var includedSources = Object.keys(sources).filter(function (sourceKey) { return excludes(excludeSources, sourceKey); });
        // Using `mapWithBreaks` allows asynchronous sources to complete between synchronous sources
        // and measure the duration correctly
        var sourceGettersPromise = mapWithBreaks(includedSources, function (sourceKey) {
            return loadSource(sources[sourceKey], sourceOptions);
        });
        suppressUnhandledRejectionWarning(sourceGettersPromise);
        return function getComponents() {
            return __awaiter(this, void 0, void 0, function () {
                var sourceGetters, componentPromises, componentArray, components, index;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, sourceGettersPromise];
                        case 1:
                            sourceGetters = _a.sent();
                            return [4 /*yield*/, mapWithBreaks(sourceGetters, function (sourceGetter) {
                                    var componentPromise = sourceGetter();
                                    suppressUnhandledRejectionWarning(componentPromise);
                                    return componentPromise;
                                })];
                        case 2:
                            componentPromises = _a.sent();
                            return [4 /*yield*/, Promise.all(componentPromises)
                                // Keeping the component keys order the same as the source keys order
                            ];
                        case 3:
                            componentArray = _a.sent();
                            components = {};
                            for (index = 0; index < includedSources.length; ++index) {
                                components[includedSources[index]] = componentArray[index];
                            }
                            return [2 /*return*/, components];
                    }
                });
            });
        };
    }
    /**
     * Modifies an entropy source by transforming its returned value with the given function.
     * Keeps the source properties: sync/async, 1/2 stages.
     *
     * Warning for package users:
     * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
     */
    function transformSource(source, transformValue) {
        var transformLoadResult = function (loadResult) {
            if (isFinalResultLoaded(loadResult)) {
                return transformValue(loadResult);
            }
            return function () {
                var getResult = loadResult();
                if (isPromise(getResult)) {
                    return getResult.then(transformValue);
                }
                return transformValue(getResult);
            };
        };
        return function (options) {
            var loadResult = source(options);
            if (isPromise(loadResult)) {
                return loadResult.then(transformLoadResult);
            }
            return transformLoadResult(loadResult);
        };
    }

    /*
     * Functions to help with features that vary through browsers
     */
    /**
     * Checks whether the browser is based on Trident (the Internet Explorer engine) without using user-agent.
     *
     * Warning for package users:
     * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
     */
    function isTrident() {
        var w = window;
        var n = navigator;
        // The properties are checked to be in IE 10, IE 11 and not to be in other browsers in October 2020
        return (countTruthy([
            'MSCSSMatrix' in w,
            'msSetImmediate' in w,
            'msIndexedDB' in w,
            'msMaxTouchPoints' in n,
            'msPointerEnabled' in n,
        ]) >= 4);
    }
    /**
     * Checks whether the browser is based on EdgeHTML (the pre-Chromium Edge engine) without using user-agent.
     *
     * Warning for package users:
     * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
     */
    function isEdgeHTML() {
        // Based on research in October 2020
        var w = window;
        var n = navigator;
        return (countTruthy(['msWriteProfilerMark' in w, 'MSStream' in w, 'msLaunchUri' in n, 'msSaveBlob' in n]) >= 3 &&
            !isTrident());
    }
    /**
     * Checks whether the browser is based on Chromium without using user-agent.
     *
     * Warning for package users:
     * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
     */
    function isChromium() {
        // Based on research in October 2020. Tested to detect Chromium 42-86.
        var w = window;
        var n = navigator;
        return (countTruthy([
            'webkitPersistentStorage' in n,
            'webkitTemporaryStorage' in n,
            n.vendor.indexOf('Google') === 0,
            'webkitResolveLocalFileSystemURL' in w,
            'BatteryManager' in w,
            'webkitMediaStream' in w,
            'webkitSpeechGrammar' in w,
        ]) >= 5);
    }
    /**
     * Checks whether the browser is based on mobile or desktop Safari without using user-agent.
     * All iOS browsers use WebKit (the Safari engine).
     *
     * Warning for package users:
     * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
     */
    function isWebKit() {
        // Based on research in September 2020
        var w = window;
        var n = navigator;
        return (countTruthy([
            'ApplePayError' in w,
            'CSSPrimitiveValue' in w,
            'Counter' in w,
            n.vendor.indexOf('Apple') === 0,
            'getStorageUpdates' in n,
            'WebKitMediaKeys' in w,
        ]) >= 4);
    }
    /**
     * Checks whether the WebKit browser is a desktop Safari.
     *
     * Warning for package users:
     * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
     */
    function isDesktopSafari() {
        var w = window;
        return (countTruthy([
            'safari' in w,
            !('DeviceMotionEvent' in w),
            !('ongestureend' in w),
            !('standalone' in navigator),
        ]) >= 3);
    }
    /**
     * Checks whether the browser is based on Gecko (Firefox engine) without using user-agent.
     *
     * Warning for package users:
     * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
     */
    function isGecko() {
        var _a, _b;
        var w = window;
        // Based on research in September 2020
        return (countTruthy([
            'buildID' in navigator,
            'MozAppearance' in ((_b = (_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.style) !== null && _b !== void 0 ? _b : {}),
            'onmozfullscreenchange' in w,
            'mozInnerScreenX' in w,
            'CSSMozDocumentRule' in w,
            'CanvasCaptureMediaStream' in w,
        ]) >= 4);
    }
    /**
     * Checks whether the browser is based on Chromium version ≥86 without using user-agent.
     * It doesn't check that the browser is based on Chromium, there is a separate function for this.
     */
    function isChromium86OrNewer() {
        // Checked in Chrome 85 vs Chrome 86 both on desktop and Android
        var w = window;
        return (countTruthy([
            !('MediaSettingsRange' in w),
            'RTCEncodedAudioFrame' in w,
            '' + w.Intl === '[object Intl]',
            '' + w.Reflect === '[object Reflect]',
        ]) >= 3);
    }
    /**
     * Checks whether the browser is based on WebKit version ≥606 (Safari ≥12) without using user-agent.
     * It doesn't check that the browser is based on WebKit, there is a separate function for this.
     *
     * @link https://en.wikipedia.org/wiki/Safari_version_history#Release_history Safari-WebKit versions map
     */
    function isWebKit606OrNewer() {
        // Checked in Safari 9–14
        var w = window;
        return (countTruthy([
            'DOMRectList' in w,
            'RTCPeerConnectionIceEvent' in w,
            'SVGGeometryElement' in w,
            'ontransitioncancel' in w,
        ]) >= 3);
    }
    /**
     * Checks whether the device is an iPad.
     * It doesn't check that the engine is WebKit and that the WebKit isn't desktop.
     */
    function isIPad() {
        // Checked on:
        // Safari on iPadOS (both mobile and desktop modes): 8, 11, 12, 13, 14
        // Chrome on iPadOS (both mobile and desktop modes): 11, 12, 13, 14
        // Safari on iOS (both mobile and desktop modes): 9, 10, 11, 12, 13, 14
        // Chrome on iOS (both mobile and desktop modes): 9, 10, 11, 12, 13, 14
        // Before iOS 13. Safari tampers the value in "request desktop site" mode since iOS 13.
        if (navigator.platform === 'iPad') {
            return true;
        }
        var s = screen;
        var screenRatio = s.width / s.height;
        return (countTruthy([
            'MediaSource' in window,
            !!Element.prototype.webkitRequestFullscreen,
            // iPhone 4S that runs iOS 9 matches this. But it won't match the criteria above, so it won't be detected as iPad.
            screenRatio > 0.65 && screenRatio < 1.53,
        ]) >= 2);
    }
    /**
     * Warning for package users:
     * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
     */
    function getFullscreenElement() {
        var d = document;
        return d.fullscreenElement || d.msFullscreenElement || d.mozFullScreenElement || d.webkitFullscreenElement || null;
    }
    function exitFullscreen() {
        var d = document;
        // `call` is required because the function throws an error without a proper "this" context
        return (d.exitFullscreen || d.msExitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen).call(d);
    }
    /**
     * Checks whether the device runs on Android without using user-agent.
     *
     * Warning for package users:
     * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
     */
    function isAndroid() {
        var isItChromium = isChromium();
        var isItGecko = isGecko();
        // Only 2 browser engines are presented on Android.
        // Actually, there is also Android 4.1 browser, but it's not worth detecting it at the moment.
        if (!isItChromium && !isItGecko) {
            return false;
        }
        var w = window;
        // Chrome removes all words "Android" from `navigator` when desktop version is requested
        // Firefox keeps "Android" in `navigator.appVersion` when desktop version is requested
        return (countTruthy([
            'onorientationchange' in w,
            'orientation' in w,
            isItChromium && !('SharedWorker' in w),
            isItGecko && /android/i.test(navigator.appVersion),
        ]) >= 2);
    }

    /**
     * A deep description: https://fingerprint.com/blog/audio-fingerprinting/
     * Inspired by and based on https://github.com/cozylife/audio-fingerprint
     */
    function getAudioFingerprint() {
        var w = window;
        var AudioContext = w.OfflineAudioContext || w.webkitOfflineAudioContext;
        if (!AudioContext) {
            return -2 /* SpecialFingerprint.NotSupported */;
        }
        // In some browsers, audio context always stays suspended unless the context is started in response to a user action
        // (e.g. a click or a tap). It prevents audio fingerprint from being taken at an arbitrary moment of time.
        // Such browsers are old and unpopular, so the audio fingerprinting is just skipped in them.
        // See a similar case explanation at https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
        if (doesCurrentBrowserSuspendAudioContext()) {
            return -1 /* SpecialFingerprint.KnownToSuspend */;
        }
        var hashFromIndex = 4500;
        var hashToIndex = 5000;
        var context = new AudioContext(1, hashToIndex, 44100);
        var oscillator = context.createOscillator();
        oscillator.type = 'triangle';
        oscillator.frequency.value = 10000;
        var compressor = context.createDynamicsCompressor();
        compressor.threshold.value = -50;
        compressor.knee.value = 40;
        compressor.ratio.value = 12;
        compressor.attack.value = 0;
        compressor.release.value = 0.25;
        oscillator.connect(compressor);
        compressor.connect(context.destination);
        oscillator.start(0);
        var _a = startRenderingAudio(context), renderPromise = _a[0], finishRendering = _a[1];
        var fingerprintPromise = renderPromise.then(function (buffer) { return getHash(buffer.getChannelData(0).subarray(hashFromIndex)); }, function (error) {
            if (error.name === "timeout" /* InnerErrorName.Timeout */ || error.name === "suspended" /* InnerErrorName.Suspended */) {
                return -3 /* SpecialFingerprint.Timeout */;
            }
            throw error;
        });
        // Suppresses the console error message in case when the fingerprint fails before requested
        suppressUnhandledRejectionWarning(fingerprintPromise);
        return function () {
            finishRendering();
            return fingerprintPromise;
        };
    }
    /**
     * Checks if the current browser is known to always suspend audio context
     */
    function doesCurrentBrowserSuspendAudioContext() {
        return isWebKit() && !isDesktopSafari() && !isWebKit606OrNewer();
    }
    /**
     * Starts rendering the audio context.
     * When the returned function is called, the render process starts finishing.
     */
    function startRenderingAudio(context) {
        var renderTryMaxCount = 3;
        var renderRetryDelay = 500;
        var runningMaxAwaitTime = 500;
        var runningSufficientTime = 5000;
        var finalize = function () { return undefined; };
        var resultPromise = new Promise(function (resolve, reject) {
            var isFinalized = false;
            var renderTryCount = 0;
            var startedRunningAt = 0;
            context.oncomplete = function (event) { return resolve(event.renderedBuffer); };
            var startRunningTimeout = function () {
                setTimeout(function () { return reject(makeInnerError("timeout" /* InnerErrorName.Timeout */)); }, Math.min(runningMaxAwaitTime, startedRunningAt + runningSufficientTime - Date.now()));
            };
            var tryRender = function () {
                try {
                    var renderingPromise = context.startRendering();
                    // `context.startRendering` has two APIs: Promise and callback, we check that it's really a promise just in case
                    if (isPromise(renderingPromise)) {
                        // Suppresses all unhadled rejections in case of scheduled redundant retries after successful rendering
                        suppressUnhandledRejectionWarning(renderingPromise);
                    }
                    switch (context.state) {
                        case 'running':
                            startedRunningAt = Date.now();
                            if (isFinalized) {
                                startRunningTimeout();
                            }
                            break;
                        // Sometimes the audio context doesn't start after calling `startRendering` (in addition to the cases where
                        // audio context doesn't start at all). A known case is starting an audio context when the browser tab is in
                        // background on iPhone. Retries usually help in this case.
                        case 'suspended':
                            // The audio context can reject starting until the tab is in foreground. Long fingerprint duration
                            // in background isn't a problem, therefore the retry attempts don't count in background. It can lead to
                            // a situation when a fingerprint takes very long time and finishes successfully. FYI, the audio context
                            // can be suspended when `document.hidden === false` and start running after a retry.
                            if (!document.hidden) {
                                renderTryCount++;
                            }
                            if (isFinalized && renderTryCount >= renderTryMaxCount) {
                                reject(makeInnerError("suspended" /* InnerErrorName.Suspended */));
                            }
                            else {
                                setTimeout(tryRender, renderRetryDelay);
                            }
                            break;
                    }
                }
                catch (error) {
                    reject(error);
                }
            };
            tryRender();
            finalize = function () {
                if (!isFinalized) {
                    isFinalized = true;
                    if (startedRunningAt > 0) {
                        startRunningTimeout();
                    }
                }
            };
        });
        return [resultPromise, finalize];
    }
    function getHash(signal) {
        var hash = 0;
        for (var i = 0; i < signal.length; ++i) {
            hash += Math.abs(signal[i]);
        }
        return hash;
    }
    function makeInnerError(name) {
        var error = new Error(name);
        error.name = name;
        return error;
    }

    /**
     * Creates and keeps an invisible iframe while the given function runs.
     * The given function is called when the iframe is loaded and has a body.
     * The iframe allows to measure DOM sizes inside itself.
     *
     * Notice: passing an initial HTML code doesn't work in IE.
     *
     * Warning for package users:
     * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
     */
    function withIframe(action, initialHtml, domPollInterval) {
        var _a, _b, _c;
        if (domPollInterval === void 0) { domPollInterval = 50; }
        return __awaiter(this, void 0, void 0, function () {
            var d, iframe;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        d = document;
                        _d.label = 1;
                    case 1:
                        if (!!d.body) return [3 /*break*/, 3];
                        return [4 /*yield*/, wait(domPollInterval)];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 1];
                    case 3:
                        iframe = d.createElement('iframe');
                        _d.label = 4;
                    case 4:
                        _d.trys.push([4, , 10, 11]);
                        return [4 /*yield*/, new Promise(function (_resolve, _reject) {
                                var isComplete = false;
                                var resolve = function () {
                                    isComplete = true;
                                    _resolve();
                                };
                                var reject = function (error) {
                                    isComplete = true;
                                    _reject(error);
                                };
                                iframe.onload = resolve;
                                iframe.onerror = reject;
                                var style = iframe.style;
                                style.setProperty('display', 'block', 'important'); // Required for browsers to calculate the layout
                                style.position = 'absolute';
                                style.top = '0';
                                style.left = '0';
                                style.visibility = 'hidden';
                                if (initialHtml && 'srcdoc' in iframe) {
                                    iframe.srcdoc = initialHtml;
                                }
                                else {
                                    iframe.src = 'about:blank';
                                }
                                d.body.appendChild(iframe);
                                // WebKit in WeChat doesn't fire the iframe's `onload` for some reason.
                                // This code checks for the loading state manually.
                                // See https://github.com/fingerprintjs/fingerprintjs/issues/645
                                var checkReadyState = function () {
                                    var _a, _b;
                                    // The ready state may never become 'complete' in Firefox despite the 'load' event being fired.
                                    // So an infinite setTimeout loop can happen without this check.
                                    // See https://github.com/fingerprintjs/fingerprintjs/pull/716#issuecomment-986898796
                                    if (isComplete) {
                                        return;
                                    }
                                    // Make sure iframe.contentWindow and iframe.contentWindow.document are both loaded
                                    // The contentWindow.document can miss in JSDOM (https://github.com/jsdom/jsdom).
                                    if (((_b = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.readyState) === 'complete') {
                                        resolve();
                                    }
                                    else {
                                        setTimeout(checkReadyState, 10);
                                    }
                                };
                                checkReadyState();
                            })];
                    case 5:
                        _d.sent();
                        _d.label = 6;
                    case 6:
                        if (!!((_b = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.body)) return [3 /*break*/, 8];
                        return [4 /*yield*/, wait(domPollInterval)];
                    case 7:
                        _d.sent();
                        return [3 /*break*/, 6];
                    case 8: return [4 /*yield*/, action(iframe, iframe.contentWindow)];
                    case 9: return [2 /*return*/, _d.sent()];
                    case 10:
                        (_c = iframe.parentNode) === null || _c === void 0 ? void 0 : _c.removeChild(iframe);
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        });
    }
    /**
     * Creates a DOM element that matches the given selector.
     * Only single element selector are supported (without operators like space, +, >, etc).
     */
    function selectorToElement(selector) {
        var _a = parseSimpleCssSelector(selector), tag = _a[0], attributes = _a[1];
        var element = document.createElement(tag !== null && tag !== void 0 ? tag : 'div');
        for (var _i = 0, _b = Object.keys(attributes); _i < _b.length; _i++) {
            var name_1 = _b[_i];
            var value = attributes[name_1].join(' ');
            // Changing the `style` attribute can cause a CSP error, therefore we change the `style.cssText` property.
            // https://github.com/fingerprintjs/fingerprintjs/issues/733
            if (name_1 === 'style') {
                addStyleString(element.style, value);
            }
            else {
                element.setAttribute(name_1, value);
            }
        }
        return element;
    }
    /**
     * Adds CSS styles from a string in such a way that doesn't trigger a CSP warning (unsafe-inline or unsafe-eval)
     */
    function addStyleString(style, source) {
        // We don't use `style.cssText` because browsers must block it when no `unsafe-eval` CSP is presented: https://csplite.com/csp145/#w3c_note
        // Even though the browsers ignore this standard, we don't use `cssText` just in case.
        for (var _i = 0, _a = source.split(';'); _i < _a.length; _i++) {
            var property = _a[_i];
            var match = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(property);
            if (match) {
                var name_2 = match[1], value = match[2], priority = match[4];
                style.setProperty(name_2, value, priority || ''); // The last argument can't be undefined in IE11
            }
        }
    }

    // We use m or w because these two characters take up the maximum width.
    // And we use a LLi so that the same matching fonts can get separated.
    var testString = 'mmMwWLliI0O&1';
    // We test using 48px font size, we may use any size. I guess larger the better.
    var textSize = '48px';
    // A font will be compared against all the three default fonts.
    // And if for any default fonts it doesn't match, then that font is available.
    var baseFonts = ['monospace', 'sans-serif', 'serif'];
    var fontList = [
        // This is android-specific font from "Roboto" family
        'sans-serif-thin',
        'ARNO PRO',
        'Agency FB',
        'Arabic Typesetting',
        'Arial Unicode MS',
        'AvantGarde Bk BT',
        'BankGothic Md BT',
        'Batang',
        'Bitstream Vera Sans Mono',
        'Calibri',
        'Century',
        'Century Gothic',
        'Clarendon',
        'EUROSTILE',
        'Franklin Gothic',
        'Futura Bk BT',
        'Futura Md BT',
        'GOTHAM',
        'Gill Sans',
        'HELV',
        'Haettenschweiler',
        'Helvetica Neue',
        'Humanst521 BT',
        'Leelawadee',
        'Letter Gothic',
        'Levenim MT',
        'Lucida Bright',
        'Lucida Sans',
        'Menlo',
        'MS Mincho',
        'MS Outlook',
        'MS Reference Specialty',
        'MS UI Gothic',
        'MT Extra',
        'MYRIAD PRO',
        'Marlett',
        'Meiryo UI',
        'Microsoft Uighur',
        'Minion Pro',
        'Monotype Corsiva',
        'PMingLiU',
        'Pristina',
        'SCRIPTINA',
        'Segoe UI Light',
        'Serifa',
        'SimHei',
        'Small Fonts',
        'Staccato222 BT',
        'TRAJAN PRO',
        'Univers CE 55 Medium',
        'Vrinda',
        'ZWAdobeF',
    ];
    // kudos to http://www.lalit.org/lab/javascript-css-font-detect/
    function getFonts() {
        // Running the script in an iframe makes it not affect the page look and not be affected by the page CSS. See:
        // https://github.com/fingerprintjs/fingerprintjs/issues/592
        // https://github.com/fingerprintjs/fingerprintjs/issues/628
        return withIframe(function (_, _a) {
            var document = _a.document;
            var holder = document.body;
            holder.style.fontSize = textSize;
            // div to load spans for the default fonts and the fonts to detect
            var spansContainer = document.createElement('div');
            var defaultWidth = {};
            var defaultHeight = {};
            // creates a span where the fonts will be loaded
            var createSpan = function (fontFamily) {
                var span = document.createElement('span');
                var style = span.style;
                style.position = 'absolute';
                style.top = '0';
                style.left = '0';
                style.fontFamily = fontFamily;
                span.textContent = testString;
                spansContainer.appendChild(span);
                return span;
            };
            // creates a span and load the font to detect and a base font for fallback
            var createSpanWithFonts = function (fontToDetect, baseFont) {
                return createSpan("'".concat(fontToDetect, "',").concat(baseFont));
            };
            // creates spans for the base fonts and adds them to baseFontsDiv
            var initializeBaseFontsSpans = function () {
                return baseFonts.map(createSpan);
            };
            // creates spans for the fonts to detect and adds them to fontsDiv
            var initializeFontsSpans = function () {
                // Stores {fontName : [spans for that font]}
                var spans = {};
                var _loop_1 = function (font) {
                    spans[font] = baseFonts.map(function (baseFont) { return createSpanWithFonts(font, baseFont); });
                };
                for (var _i = 0, fontList_1 = fontList; _i < fontList_1.length; _i++) {
                    var font = fontList_1[_i];
                    _loop_1(font);
                }
                return spans;
            };
            // checks if a font is available
            var isFontAvailable = function (fontSpans) {
                return baseFonts.some(function (baseFont, baseFontIndex) {
                    return fontSpans[baseFontIndex].offsetWidth !== defaultWidth[baseFont] ||
                        fontSpans[baseFontIndex].offsetHeight !== defaultHeight[baseFont];
                });
            };
            // create spans for base fonts
            var baseFontsSpans = initializeBaseFontsSpans();
            // create spans for fonts to detect
            var fontsSpans = initializeFontsSpans();
            // add all the spans to the DOM
            holder.appendChild(spansContainer);
            // get the default width for the three base fonts
            for (var index = 0; index < baseFonts.length; index++) {
                defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth; // width for the default font
                defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight; // height for the default font
            }
            // check available fonts
            return fontList.filter(function (font) { return isFontAvailable(fontsSpans[font]); });
        });
    }

    function getPlugins() {
        var rawPlugins = navigator.plugins;
        if (!rawPlugins) {
            return undefined;
        }
        var plugins = [];
        // Safari 10 doesn't support iterating navigator.plugins with for...of
        for (var i = 0; i < rawPlugins.length; ++i) {
            var plugin = rawPlugins[i];
            if (!plugin) {
                continue;
            }
            var mimeTypes = [];
            for (var j = 0; j < plugin.length; ++j) {
                var mimeType = plugin[j];
                mimeTypes.push({
                    type: mimeType.type,
                    suffixes: mimeType.suffixes,
                });
            }
            plugins.push({
                name: plugin.name,
                description: plugin.description,
                mimeTypes: mimeTypes,
            });
        }
        return plugins;
    }

    // https://www.browserleaks.com/canvas#how-does-it-work
    function getCanvasFingerprint() {
        var winding = false;
        var geometry;
        var text;
        var _a = makeCanvasContext(), canvas = _a[0], context = _a[1];
        if (!isSupported(canvas, context)) {
            geometry = text = ''; // The value will be 'unsupported' in v3.4
        }
        else {
            winding = doesSupportWinding(context);
            renderTextImage(canvas, context);
            var textImage1 = canvasToString(canvas);
            var textImage2 = canvasToString(canvas); // It's slightly faster to double-encode the text image
            // Some browsers add a noise to the canvas: https://github.com/fingerprintjs/fingerprintjs/issues/791
            // The canvas is excluded from the fingerprint in this case
            if (textImage1 !== textImage2) {
                geometry = text = 'unstable';
            }
            else {
                text = textImage1;
                // Text is unstable:
                // https://github.com/fingerprintjs/fingerprintjs/issues/583
                // https://github.com/fingerprintjs/fingerprintjs/issues/103
                // Therefore it's extracted into a separate image.
                renderGeometryImage(canvas, context);
                geometry = canvasToString(canvas);
            }
        }
        return { winding: winding, geometry: geometry, text: text };
    }
    function makeCanvasContext() {
        var canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = 1;
        return [canvas, canvas.getContext('2d')];
    }
    function isSupported(canvas, context) {
        return !!(context && canvas.toDataURL);
    }
    function doesSupportWinding(context) {
        // https://web.archive.org/web/20170825024655/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
        // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
        context.rect(0, 0, 10, 10);
        context.rect(2, 2, 6, 6);
        return !context.isPointInPath(5, 5, 'evenodd');
    }
    function renderTextImage(canvas, context) {
        // Resizing the canvas cleans it
        canvas.width = 240;
        canvas.height = 60;
        context.textBaseline = 'alphabetic';
        context.fillStyle = '#f60';
        context.fillRect(100, 1, 62, 20);
        context.fillStyle = '#069';
        // It's important to use explicit built-in fonts in order to exclude the affect of font preferences
        // (there is a separate entropy source for them).
        context.font = '11pt "Times New Roman"';
        // The choice of emojis has a gigantic impact on rendering performance (especially in FF).
        // Some newer emojis cause it to slow down 50-200 times.
        // There must be no text to the right of the emoji, see https://github.com/fingerprintjs/fingerprintjs/issues/574
        // A bare emoji shouldn't be used because the canvas will change depending on the script encoding:
        // https://github.com/fingerprintjs/fingerprintjs/issues/66
        // Escape sequence shouldn't be used too because Terser will turn it into a bare unicode.
        var printedText = "Cwm fjordbank gly ".concat(String.fromCharCode(55357, 56835) /* 😃 */);
        context.fillText(printedText, 2, 15);
        context.fillStyle = 'rgba(102, 204, 0, 0.2)';
        context.font = '18pt Arial';
        context.fillText(printedText, 4, 45);
    }
    function renderGeometryImage(canvas, context) {
        // Resizing the canvas cleans it
        canvas.width = 122;
        canvas.height = 110;
        // Canvas blending
        // https://web.archive.org/web/20170826194121/http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
        // http://jsfiddle.net/NDYV8/16/
        context.globalCompositeOperation = 'multiply';
        for (var _i = 0, _a = [
            ['#f2f', 40, 40],
            ['#2ff', 80, 40],
            ['#ff2', 60, 80],
        ]; _i < _a.length; _i++) {
            var _b = _a[_i], color = _b[0], x = _b[1], y = _b[2];
            context.fillStyle = color;
            context.beginPath();
            context.arc(x, y, 40, 0, Math.PI * 2, true);
            context.closePath();
            context.fill();
        }
        // Canvas winding
        // https://web.archive.org/web/20130913061632/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
        // http://jsfiddle.net/NDYV8/19/
        context.fillStyle = '#f9c';
        context.arc(60, 60, 60, 0, Math.PI * 2, true);
        context.arc(60, 60, 20, 0, Math.PI * 2, true);
        context.fill('evenodd');
    }
    function canvasToString(canvas) {
        return canvas.toDataURL();
    }

    /**
     * This is a crude and primitive touch screen detection. It's not possible to currently reliably detect the availability
     * of a touch screen with a JS, without actually subscribing to a touch event.
     *
     * @see http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
     * @see https://github.com/Modernizr/Modernizr/issues/548
     */
    function getTouchSupport() {
        var n = navigator;
        var maxTouchPoints = 0;
        var touchEvent;
        if (n.maxTouchPoints !== undefined) {
            maxTouchPoints = toInt(n.maxTouchPoints);
        }
        else if (n.msMaxTouchPoints !== undefined) {
            maxTouchPoints = n.msMaxTouchPoints;
        }
        try {
            document.createEvent('TouchEvent');
            touchEvent = true;
        }
        catch (_a) {
            touchEvent = false;
        }
        var touchStart = 'ontouchstart' in window;
        return {
            maxTouchPoints: maxTouchPoints,
            touchEvent: touchEvent,
            touchStart: touchStart,
        };
    }

    function getOsCpu() {
        return navigator.oscpu;
    }

    function getLanguages() {
        var n = navigator;
        var result = [];
        var language = n.language || n.userLanguage || n.browserLanguage || n.systemLanguage;
        if (language !== undefined) {
            result.push([language]);
        }
        if (Array.isArray(n.languages)) {
            // Starting from Chromium 86, there is only a single value in `navigator.language` in Incognito mode:
            // the value of `navigator.language`. Therefore the value is ignored in this browser.
            if (!(isChromium() && isChromium86OrNewer())) {
                result.push(n.languages);
            }
        }
        else if (typeof n.languages === 'string') {
            var languages = n.languages;
            if (languages) {
                result.push(languages.split(','));
            }
        }
        return result;
    }

    function getColorDepth() {
        return window.screen.colorDepth;
    }

    function getDeviceMemory() {
        // `navigator.deviceMemory` is a string containing a number in some unidentified cases
        return replaceNaN(toFloat(navigator.deviceMemory), undefined);
    }

    function getScreenResolution() {
        var s = screen;
        // Some browsers return screen resolution as strings, e.g. "1200", instead of a number, e.g. 1200.
        // I suspect it's done by certain plugins that randomize browser properties to prevent fingerprinting.
        // Some browsers even return  screen resolution as not numbers.
        var parseDimension = function (value) { return replaceNaN(toInt(value), null); };
        var dimensions = [parseDimension(s.width), parseDimension(s.height)];
        dimensions.sort().reverse();
        return dimensions;
    }

    var screenFrameCheckInterval = 2500;
    var roundingPrecision = 10;
    // The type is readonly to protect from unwanted mutations
    var screenFrameBackup;
    var screenFrameSizeTimeoutId;
    /**
     * Starts watching the screen frame size. When a non-zero size appears, the size is saved and the watch is stopped.
     * Later, when `getScreenFrame` runs, it will return the saved non-zero size if the current size is null.
     *
     * This trick is required to mitigate the fact that the screen frame turns null in some cases.
     * See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
     */
    function watchScreenFrame() {
        if (screenFrameSizeTimeoutId !== undefined) {
            return;
        }
        var checkScreenFrame = function () {
            var frameSize = getCurrentScreenFrame();
            if (isFrameSizeNull(frameSize)) {
                screenFrameSizeTimeoutId = setTimeout(checkScreenFrame, screenFrameCheckInterval);
            }
            else {
                screenFrameBackup = frameSize;
                screenFrameSizeTimeoutId = undefined;
            }
        };
        checkScreenFrame();
    }
    function getScreenFrame() {
        var _this = this;
        watchScreenFrame();
        return function () { return __awaiter(_this, void 0, void 0, function () {
            var frameSize;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        frameSize = getCurrentScreenFrame();
                        if (!isFrameSizeNull(frameSize)) return [3 /*break*/, 2];
                        if (screenFrameBackup) {
                            return [2 /*return*/, __spreadArray([], screenFrameBackup, true)];
                        }
                        if (!getFullscreenElement()) return [3 /*break*/, 2];
                        // Some browsers set the screen frame to zero when programmatic fullscreen is on.
                        // There is a chance of getting a non-zero frame after exiting the fullscreen.
                        // See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
                        return [4 /*yield*/, exitFullscreen()];
                    case 1:
                        // Some browsers set the screen frame to zero when programmatic fullscreen is on.
                        // There is a chance of getting a non-zero frame after exiting the fullscreen.
                        // See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
                        _a.sent();
                        frameSize = getCurrentScreenFrame();
                        _a.label = 2;
                    case 2:
                        if (!isFrameSizeNull(frameSize)) {
                            screenFrameBackup = frameSize;
                        }
                        return [2 /*return*/, frameSize];
                }
            });
        }); };
    }
    /**
     * Sometimes the available screen resolution changes a bit, e.g. 1900x1440 → 1900x1439. A possible reason: macOS Dock
     * shrinks to fit more icons when there is too little space. The rounding is used to mitigate the difference.
     */
    function getRoundedScreenFrame() {
        var _this = this;
        var screenFrameGetter = getScreenFrame();
        return function () { return __awaiter(_this, void 0, void 0, function () {
            var frameSize, processSize;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, screenFrameGetter()];
                    case 1:
                        frameSize = _a.sent();
                        processSize = function (sideSize) { return (sideSize === null ? null : round(sideSize, roundingPrecision)); };
                        // It might look like I don't know about `for` and `map`.
                        // In fact, such code is used to avoid TypeScript issues without using `as`.
                        return [2 /*return*/, [processSize(frameSize[0]), processSize(frameSize[1]), processSize(frameSize[2]), processSize(frameSize[3])]];
                }
            });
        }); };
    }
    function getCurrentScreenFrame() {
        var s = screen;
        // Some browsers return screen resolution as strings, e.g. "1200", instead of a number, e.g. 1200.
        // I suspect it's done by certain plugins that randomize browser properties to prevent fingerprinting.
        //
        // Some browsers (IE, Edge ≤18) don't provide `screen.availLeft` and `screen.availTop`. The property values are
        // replaced with 0 in such cases to not lose the entropy from `screen.availWidth` and `screen.availHeight`.
        return [
            replaceNaN(toFloat(s.availTop), null),
            replaceNaN(toFloat(s.width) - toFloat(s.availWidth) - replaceNaN(toFloat(s.availLeft), 0), null),
            replaceNaN(toFloat(s.height) - toFloat(s.availHeight) - replaceNaN(toFloat(s.availTop), 0), null),
            replaceNaN(toFloat(s.availLeft), null),
        ];
    }
    function isFrameSizeNull(frameSize) {
        for (var i = 0; i < 4; ++i) {
            if (frameSize[i]) {
                return false;
            }
        }
        return true;
    }

    function getHardwareConcurrency() {
        // sometimes hardware concurrency is a string
        return replaceNaN(toInt(navigator.hardwareConcurrency), undefined);
    }

    function getTimezone() {
        var _a;
        var DateTimeFormat = (_a = window.Intl) === null || _a === void 0 ? void 0 : _a.DateTimeFormat;
        if (DateTimeFormat) {
            var timezone = new DateTimeFormat().resolvedOptions().timeZone;
            if (timezone) {
                return timezone;
            }
        }
        // For browsers that don't support timezone names
        // The minus is intentional because the JS offset is opposite to the real offset
        var offset = -getTimezoneOffset();
        return "UTC".concat(offset >= 0 ? '+' : '').concat(Math.abs(offset));
    }
    function getTimezoneOffset() {
        var currentYear = new Date().getFullYear();
        // The timezone offset may change over time due to daylight saving time (DST) shifts.
        // The non-DST timezone offset is used as the result timezone offset.
        // Since the DST season differs in the northern and the southern hemispheres,
        // both January and July timezones offsets are considered.
        return Math.max(
        // `getTimezoneOffset` returns a number as a string in some unidentified cases
        toFloat(new Date(currentYear, 0, 1).getTimezoneOffset()), toFloat(new Date(currentYear, 6, 1).getTimezoneOffset()));
    }

    function getSessionStorage() {
        try {
            return !!window.sessionStorage;
        }
        catch (error) {
            /* SecurityError when referencing it means it exists */
            return true;
        }
    }

    // https://bugzilla.mozilla.org/show_bug.cgi?id=781447
    function getLocalStorage() {
        try {
            return !!window.localStorage;
        }
        catch (e) {
            /* SecurityError when referencing it means it exists */
            return true;
        }
    }

    function getIndexedDB() {
        // IE and Edge don't allow accessing indexedDB in private mode, therefore IE and Edge will have different
        // visitor identifier in normal and private modes.
        if (isTrident() || isEdgeHTML()) {
            return undefined;
        }
        try {
            return !!window.indexedDB;
        }
        catch (e) {
            /* SecurityError when referencing it means it exists */
            return true;
        }
    }

    function getOpenDatabase() {
        return !!window.openDatabase;
    }

    function getCpuClass() {
        return navigator.cpuClass;
    }

    function getPlatform() {
        // Android Chrome 86 and 87 and Android Firefox 80 and 84 don't mock the platform value when desktop mode is requested
        var platform = navigator.platform;
        // iOS mocks the platform value when desktop version is requested: https://github.com/fingerprintjs/fingerprintjs/issues/514
        // iPad uses desktop mode by default since iOS 13
        // The value is 'MacIntel' on M1 Macs
        // The value is 'iPhone' on iPod Touch
        if (platform === 'MacIntel') {
            if (isWebKit() && !isDesktopSafari()) {
                return isIPad() ? 'iPad' : 'iPhone';
            }
        }
        return platform;
    }

    function getVendor() {
        return navigator.vendor || '';
    }

    /**
     * Checks for browser-specific (not engine specific) global variables to tell browsers with the same engine apart.
     * Only somewhat popular browsers are considered.
     */
    function getVendorFlavors() {
        var flavors = [];
        for (var _i = 0, _a = [
            // Blink and some browsers on iOS
            'chrome',
            // Safari on macOS
            'safari',
            // Chrome on iOS (checked in 85 on 13 and 87 on 14)
            '__crWeb',
            '__gCrWeb',
            // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
            'yandex',
            // Yandex Browser on iOS (checked in 21.2 on 14)
            '__yb',
            '__ybro',
            // Firefox on iOS (checked in 32 on 14)
            '__firefox__',
            // Edge on iOS (checked in 46 on 14)
            '__edgeTrackingPreventionStatistics',
            'webkit',
            // Opera Touch on iOS (checked in 2.6 on 14)
            'oprt',
            // Samsung Internet on Android (checked in 11.1)
            'samsungAr',
            // UC Browser on Android (checked in 12.10 and 13.0)
            'ucweb',
            'UCShellJava',
            // Puffin on Android (checked in 9.0)
            'puffinDevice',
            // UC on iOS and Opera on Android have no specific global variables
            // Edge for Android isn't checked
        ]; _i < _a.length; _i++) {
            var key = _a[_i];
            var value = window[key];
            if (value && typeof value === 'object') {
                flavors.push(key);
            }
        }
        return flavors.sort();
    }

    /**
     * navigator.cookieEnabled cannot detect custom or nuanced cookie blocking configurations. For example, when blocking
     * cookies via the Advanced Privacy Settings in IE9, it always returns true. And there have been issues in the past with
     * site-specific exceptions. Don't rely on it.
     *
     * @see https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js Taken from here
     */
    function areCookiesEnabled() {
        var d = document;
        // Taken from here: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js
        // navigator.cookieEnabled cannot detect custom or nuanced cookie blocking configurations. For example, when blocking
        // cookies via the Advanced Privacy Settings in IE9, it always returns true. And there have been issues in the past
        // with site-specific exceptions. Don't rely on it.
        // try..catch because some in situations `document.cookie` is exposed but throws a
        // SecurityError if you try to access it; e.g. documents created from data URIs
        // or in sandboxed iframes (depending on flags/context)
        try {
            // Create cookie
            d.cookie = 'cookietest=1; SameSite=Strict;';
            var result = d.cookie.indexOf('cookietest=') !== -1;
            // Delete cookie
            d.cookie = 'cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT';
            return result;
        }
        catch (e) {
            return false;
        }
    }

    /**
     * Only single element selector are supported (no operators like space, +, >, etc).
     * `embed` and `position: fixed;` will be considered as blocked anyway because it always has no offsetParent.
     * Avoid `iframe` and anything with `[src=]` because they produce excess HTTP requests.
     *
     * The "inappropriate" selectors are obfuscated. See https://github.com/fingerprintjs/fingerprintjs/issues/734.
     * A function is used instead of a plain object to help tree-shaking.
     *
     * The function code is generated automatically. See docs/content_blockers.md to learn how to make the list.
     */
    function getFilters() {
        var fromB64 = atob; // Just for better minification
        return {
            abpIndo: [
                '#Iklan-Melayang',
                '#Kolom-Iklan-728',
                '#SidebarIklan-wrapper',
                fromB64('YVt0aXRsZT0iN25hZ2EgcG9rZXIiIGld'),
                '[title="ALIENBOLA" i]',
            ],
            abpvn: [
                '#quangcaomb',
                fromB64('Lmlvc0Fkc2lvc0Fkcy1sYXlvdXQ='),
                '.quangcao',
                fromB64('W2hyZWZePSJodHRwczovL3I4OC52bi8iXQ=='),
                fromB64('W2hyZWZePSJodHRwczovL3piZXQudm4vIl0='),
            ],
            adBlockFinland: [
                '.mainostila',
                fromB64('LnNwb25zb3JpdA=='),
                '.ylamainos',
                fromB64('YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd'),
                fromB64('YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd'),
            ],
            adBlockPersian: ['#navbar_notice_50', '.kadr', 'TABLE[width="140px"]', '#divAgahi', fromB64('I2FkMl9pbmxpbmU=')],
            adBlockWarningRemoval: [
                '#adblock-honeypot',
                '.adblocker-root',
                '.wp_adblock_detect',
                fromB64('LmhlYWRlci1ibG9ja2VkLWFk'),
                fromB64('I2FkX2Jsb2NrZXI='),
            ],
            adGuardAnnoyances: [
                'amp-embed[type="zen"]',
                '.hs-sosyal',
                '#cookieconsentdiv',
                'div[class^="app_gdpr"]',
                '.as-oil',
            ],
            adGuardBase: [
                '.BetterJsPopOverlay',
                fromB64('I2FkXzMwMFgyNTA='),
                fromB64('I2Jhbm5lcmZsb2F0MjI='),
                fromB64('I2FkLWJhbm5lcg=='),
                fromB64('I2NhbXBhaWduLWJhbm5lcg=='),
            ],
            adGuardChinese: [
                fromB64('LlppX2FkX2FfSA=='),
                fromB64('YVtocmVmKj0iL29kMDA1LmNvbSJd'),
                fromB64('YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd'),
                '.qq_nr_lad',
                '#widget-quan',
            ],
            adGuardFrench: [
                fromB64('I2Jsb2NrLXZpZXdzLWFkcy1zaWRlYmFyLWJsb2NrLWJsb2Nr'),
                '#pavePub',
                fromB64('LmFkLWRlc2t0b3AtcmVjdGFuZ2xl'),
                '.mobile_adhesion',
                '.widgetadv',
            ],
            adGuardGerman: [
                fromB64('LmJhbm5lcml0ZW13ZXJidW5nX2hlYWRfMQ=='),
                fromB64('LmJveHN0YXJ0d2VyYnVuZw=='),
                fromB64('LndlcmJ1bmcz'),
                fromB64('YVtocmVmXj0iaHR0cDovL3d3dy5laXMuZGUvaW5kZXgucGh0bWw/cmVmaWQ9Il0='),
                fromB64('YVtocmVmXj0iaHR0cHM6Ly93d3cudGlwaWNvLmNvbS8/YWZmaWxpYXRlSWQ9Il0='),
            ],
            adGuardJapanese: [
                '#kauli_yad_1',
                fromB64('YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0='),
                fromB64('Ll9wb3BJbl9pbmZpbml0ZV9hZA=='),
                fromB64('LmFkZ29vZ2xl'),
                fromB64('LmFkX3JlZ3VsYXIz'),
            ],
            adGuardMobile: [
                fromB64('YW1wLWF1dG8tYWRz'),
                fromB64('LmFtcF9hZA=='),
                'amp-embed[type="24smi"]',
                '#mgid_iframe1',
                fromB64('I2FkX2ludmlld19hcmVh'),
            ],
            adGuardRussian: [
                fromB64('YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0='),
                fromB64('LnJlY2xhbWE='),
                'div[id^="smi2adblock"]',
                fromB64('ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd'),
                fromB64('I2FkX3NxdWFyZQ=='),
            ],
            adGuardSocial: [
                fromB64('YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0='),
                fromB64('YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0='),
                '.etsy-tweet',
                '#inlineShare',
                '.popup-social',
            ],
            adGuardSpanishPortuguese: [
                '#barraPublicidade',
                '#Publicidade',
                '#publiEspecial',
                '#queTooltip',
                fromB64('W2hyZWZePSJodHRwOi8vYWRzLmdsaXNwYS5jb20vIl0='),
            ],
            adGuardTrackingProtection: [
                '#qoo-counter',
                fromB64('YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=='),
                fromB64('YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0='),
                fromB64('YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=='),
                '#top100counter',
            ],
            adGuardTurkish: [
                '#backkapat',
                fromB64('I3Jla2xhbWk='),
                fromB64('YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0='),
                fromB64('YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd'),
                fromB64('YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ=='),
            ],
            bulgarian: [
                fromB64('dGQjZnJlZW5ldF90YWJsZV9hZHM='),
                '#ea_intext_div',
                '.lapni-pop-over',
                '#xenium_hot_offers',
                fromB64('I25ld0Fk'),
            ],
            easyList: [
                fromB64('I0FEX0NPTlRST0xfMjg='),
                fromB64('LnNlY29uZC1wb3N0LWFkcy13cmFwcGVy'),
                '.universalboxADVBOX03',
                fromB64('LmFkdmVydGlzZW1lbnQtNzI4eDkw'),
                fromB64('LnNxdWFyZV9hZHM='),
            ],
            easyListChina: [
                fromB64('YVtocmVmKj0iLndlbnNpeHVldGFuZy5jb20vIl0='),
                fromB64('LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=='),
                fromB64('LmZyb250cGFnZUFkdk0='),
                '#taotaole',
                '#aafoot.top_box',
            ],
            easyListCookie: [
                '#AdaCompliance.app-notice',
                '.text-center.rgpd',
                '.panel--cookie',
                '.js-cookies-andromeda',
                '.elxtr-consent',
            ],
            easyListCzechSlovak: [
                '#onlajny-stickers',
                fromB64('I3Jla2xhbW5pLWJveA=='),
                fromB64('LnJla2xhbWEtbWVnYWJvYXJk'),
                '.sklik',
                fromB64('W2lkXj0ic2tsaWtSZWtsYW1hIl0='),
            ],
            easyListDutch: [
                fromB64('I2FkdmVydGVudGll'),
                fromB64('I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=='),
                '.adstekst',
                fromB64('YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0='),
                '#semilo-lrectangle',
            ],
            easyListGermany: [
                fromB64('I0FkX1dpbjJkYXk='),
                fromB64('I3dlcmJ1bmdzYm94MzAw'),
                fromB64('YVtocmVmXj0iaHR0cDovL3d3dy5yb3RsaWNodGthcnRlaS5jb20vP3NjPSJd'),
                fromB64('I3dlcmJ1bmdfd2lkZXNreXNjcmFwZXJfc2NyZWVu'),
                fromB64('YVtocmVmXj0iaHR0cDovL2xhbmRpbmcucGFya3BsYXR6a2FydGVpLmNvbS8/YWc9Il0='),
            ],
            easyListItaly: [
                fromB64('LmJveF9hZHZfYW5udW5jaQ=='),
                '.sb-box-pubbliredazionale',
                fromB64('YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd'),
                fromB64('YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd'),
                fromB64('YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ=='),
            ],
            easyListLithuania: [
                fromB64('LnJla2xhbW9zX3RhcnBhcw=='),
                fromB64('LnJla2xhbW9zX251b3JvZG9z'),
                fromB64('aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd'),
                fromB64('aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd'),
                fromB64('aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd'),
            ],
            estonian: [fromB64('QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==')],
            fanboyAnnoyances: [
                '#feedback-tab',
                '#taboola-below-article',
                '.feedburnerFeedBlock',
                '.widget-feedburner-counter',
                '[title="Subscribe to our blog"]',
            ],
            fanboyAntiFacebook: ['.util-bar-module-firefly-visible'],
            fanboyEnhancedTrackers: [
                '.open.pushModal',
                '#issuem-leaky-paywall-articles-zero-remaining-nag',
                '#sovrn_container',
                'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
                '.BlockNag__Card',
            ],
            fanboySocial: [
                '.td-tags-and-social-wrapper-box',
                '.twitterContainer',
                '.youtube-social',
                'a[title^="Like us on Facebook"]',
                'img[alt^="Share on Digg"]',
            ],
            frellwitSwedish: [
                fromB64('YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=='),
                fromB64('YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=='),
                'article.category-samarbete',
                fromB64('ZGl2LmhvbGlkQWRz'),
                'ul.adsmodern',
            ],
            greekAdBlock: [
                fromB64('QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd'),
                fromB64('QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=='),
                fromB64('QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd'),
                'DIV.agores300',
                'TABLE.advright',
            ],
            hungarian: [
                '#cemp_doboz',
                '.optimonk-iframe-container',
                fromB64('LmFkX19tYWlu'),
                fromB64('W2NsYXNzKj0iR29vZ2xlQWRzIl0='),
                '#hirdetesek_box',
            ],
            iDontCareAboutCookies: [
                '.alert-info[data-block-track*="CookieNotice"]',
                '.ModuleTemplateCookieIndicator',
                '.o--cookies--container',
                '.cookie-msg-info-container',
                '#cookies-policy-sticky',
            ],
            icelandicAbp: [fromB64('QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==')],
            latvian: [
                fromB64('YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0O' +
                    'iA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0='),
                fromB64('YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6I' +
                    'DMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ=='),
            ],
            listKr: [
                fromB64('YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0='),
                fromB64('I2xpdmVyZUFkV3JhcHBlcg=='),
                fromB64('YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=='),
                fromB64('aW5zLmZhc3R2aWV3LWFk'),
                '.revenue_unit_item.dable',
            ],
            listeAr: [
                fromB64('LmdlbWluaUxCMUFk'),
                '.right-and-left-sponsers',
                fromB64('YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=='),
                fromB64('YVtocmVmKj0iYm9vcmFxLm9yZyJd'),
                fromB64('YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd'),
            ],
            listeFr: [
                fromB64('YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=='),
                fromB64('I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=='),
                fromB64('YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0='),
                '.site-pub-interstitiel',
                'div[id^="crt-"][data-criteo-id]',
            ],
            officialPolish: [
                '#ceneo-placeholder-ceneo-12',
                fromB64('W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd'),
                fromB64('YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=='),
                fromB64('YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=='),
                fromB64('ZGl2I3NrYXBpZWNfYWQ='),
            ],
            ro: [
                fromB64('YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd'),
                'a[href^="/magazin/"]',
                fromB64('YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd'),
                fromB64('YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0='),
                fromB64('YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd'),
            ],
            ruAd: [
                fromB64('YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd'),
                fromB64('YVtocmVmKj0iLy91dGltZy5ydS8iXQ=='),
                fromB64('YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0='),
                '#pgeldiz',
                '.yandex-rtb-block',
            ],
            thaiAds: [
                'a[href*=macau-uta-popup]',
                fromB64('I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=='),
                fromB64('LmFkczMwMHM='),
                '.bumq',
                '.img-kosana',
            ],
            webAnnoyancesUltralist: [
                '#mod-social-share-2',
                '#social-tools',
                fromB64('LmN0cGwtZnVsbGJhbm5lcg=='),
                '.zergnet-recommend',
                '.yt.btn-link.btn-md.btn',
            ],
        };
    }
    /**
     * The order of the returned array means nothing (it's always sorted alphabetically).
     *
     * Notice that the source is slightly unstable.
     * Safari provides a 2-taps way to disable all content blockers on a page temporarily.
     * Also content blockers can be disabled permanently for a domain, but it requires 4 taps.
     * So empty array shouldn't be treated as "no blockers", it should be treated as "no signal".
     * If you are a website owner, don't make your visitors want to disable content blockers.
     */
    function getDomBlockers(_a) {
        var _b = _a === void 0 ? {} : _a, debug = _b.debug;
        return __awaiter(this, void 0, void 0, function () {
            var filters, filterNames, allSelectors, blockedSelectors, activeBlockers;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!isApplicable()) {
                            return [2 /*return*/, undefined];
                        }
                        filters = getFilters();
                        filterNames = Object.keys(filters);
                        allSelectors = (_c = []).concat.apply(_c, filterNames.map(function (filterName) { return filters[filterName]; }));
                        return [4 /*yield*/, getBlockedSelectors(allSelectors)];
                    case 1:
                        blockedSelectors = _d.sent();
                        if (debug) {
                            printDebug(filters, blockedSelectors);
                        }
                        activeBlockers = filterNames.filter(function (filterName) {
                            var selectors = filters[filterName];
                            var blockedCount = countTruthy(selectors.map(function (selector) { return blockedSelectors[selector]; }));
                            return blockedCount > selectors.length * 0.6;
                        });
                        activeBlockers.sort();
                        return [2 /*return*/, activeBlockers];
                }
            });
        });
    }
    function isApplicable() {
        // Safari (desktop and mobile) and all Android browsers keep content blockers in both regular and private mode
        return isWebKit() || isAndroid();
    }
    function getBlockedSelectors(selectors) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var d, root, elements, blockedSelectors, i, element, holder, i;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        d = document;
                        root = d.createElement('div');
                        elements = new Array(selectors.length);
                        blockedSelectors = {} // Set() isn't used just in case somebody need older browser support
                        ;
                        forceShow(root);
                        // First create all elements that can be blocked. If the DOM steps below are done in a single cycle,
                        // browser will alternate tree modification and layout reading, that is very slow.
                        for (i = 0; i < selectors.length; ++i) {
                            element = selectorToElement(selectors[i]);
                            holder = d.createElement('div') // Protects from unwanted effects of `+` and `~` selectors of filters
                            ;
                            forceShow(holder);
                            holder.appendChild(element);
                            root.appendChild(holder);
                            elements[i] = element;
                        }
                        _b.label = 1;
                    case 1:
                        if (!!d.body) return [3 /*break*/, 3];
                        return [4 /*yield*/, wait(50)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 1];
                    case 3:
                        d.body.appendChild(root);
                        try {
                            // Then check which of the elements are blocked
                            for (i = 0; i < selectors.length; ++i) {
                                if (!elements[i].offsetParent) {
                                    blockedSelectors[selectors[i]] = true;
                                }
                            }
                        }
                        finally {
                            // Then remove the elements
                            (_a = root.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(root);
                        }
                        return [2 /*return*/, blockedSelectors];
                }
            });
        });
    }
    function forceShow(element) {
        element.style.setProperty('display', 'block', 'important');
    }
    function printDebug(filters, blockedSelectors) {
        var message = 'DOM blockers debug:\n```';
        for (var _i = 0, _a = Object.keys(filters); _i < _a.length; _i++) {
            var filterName = _a[_i];
            message += "\n".concat(filterName, ":");
            for (var _b = 0, _c = filters[filterName]; _b < _c.length; _b++) {
                var selector = _c[_b];
                message += "\n  ".concat(blockedSelectors[selector] ? '🚫' : '➡️', " ").concat(selector);
            }
        }
        // console.log is ok here because it's under a debug clause
        // eslint-disable-next-line no-console
        console.log("".concat(message, "\n```"));
    }

    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/color-gamut
     */
    function getColorGamut() {
        // rec2020 includes p3 and p3 includes srgb
        for (var _i = 0, _a = ['rec2020', 'p3', 'srgb']; _i < _a.length; _i++) {
            var gamut = _a[_i];
            if (matchMedia("(color-gamut: ".concat(gamut, ")")).matches) {
                return gamut;
            }
        }
        return undefined;
    }

    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/inverted-colors
     */
    function areColorsInverted() {
        if (doesMatch$4('inverted')) {
            return true;
        }
        if (doesMatch$4('none')) {
            return false;
        }
        return undefined;
    }
    function doesMatch$4(value) {
        return matchMedia("(inverted-colors: ".concat(value, ")")).matches;
    }

    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/forced-colors
     */
    function areColorsForced() {
        if (doesMatch$3('active')) {
            return true;
        }
        if (doesMatch$3('none')) {
            return false;
        }
        return undefined;
    }
    function doesMatch$3(value) {
        return matchMedia("(forced-colors: ".concat(value, ")")).matches;
    }

    var maxValueToCheck = 100;
    /**
     * If the display is monochrome (e.g. black&white), the value will be ≥0 and will mean the number of bits per pixel.
     * If the display is not monochrome, the returned value will be 0.
     * If the browser doesn't support this feature, the returned value will be undefined.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/monochrome
     */
    function getMonochromeDepth() {
        if (!matchMedia('(min-monochrome: 0)').matches) {
            // The media feature isn't supported by the browser
            return undefined;
        }
        // A variation of binary search algorithm can be used here.
        // But since expected values are very small (≤10), there is no sense in adding the complexity.
        for (var i = 0; i <= maxValueToCheck; ++i) {
            if (matchMedia("(max-monochrome: ".concat(i, ")")).matches) {
                return i;
            }
        }
        throw new Error('Too high value');
    }

    /**
     * @see https://www.w3.org/TR/mediaqueries-5/#prefers-contrast
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-contrast
     */
    function getContrastPreference() {
        if (doesMatch$2('no-preference')) {
            return 0 /* ContrastPreference.None */;
        }
        // The sources contradict on the keywords. Probably 'high' and 'low' will never be implemented.
        // Need to check it when all browsers implement the feature.
        if (doesMatch$2('high') || doesMatch$2('more')) {
            return 1 /* ContrastPreference.More */;
        }
        if (doesMatch$2('low') || doesMatch$2('less')) {
            return -1 /* ContrastPreference.Less */;
        }
        if (doesMatch$2('forced')) {
            return 10 /* ContrastPreference.ForcedColors */;
        }
        return undefined;
    }
    function doesMatch$2(value) {
        return matchMedia("(prefers-contrast: ".concat(value, ")")).matches;
    }

    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
     */
    function isMotionReduced() {
        if (doesMatch$1('reduce')) {
            return true;
        }
        if (doesMatch$1('no-preference')) {
            return false;
        }
        return undefined;
    }
    function doesMatch$1(value) {
        return matchMedia("(prefers-reduced-motion: ".concat(value, ")")).matches;
    }

    /**
     * @see https://www.w3.org/TR/mediaqueries-5/#dynamic-range
     */
    function isHDR() {
        if (doesMatch('high')) {
            return true;
        }
        if (doesMatch('standard')) {
            return false;
        }
        return undefined;
    }
    function doesMatch(value) {
        return matchMedia("(dynamic-range: ".concat(value, ")")).matches;
    }

    var M = Math; // To reduce the minified code size
    var fallbackFn = function () { return 0; };
    /**
     * @see https://gitlab.torproject.org/legacy/trac/-/issues/13018
     * @see https://bugzilla.mozilla.org/show_bug.cgi?id=531915
     */
    function getMathFingerprint() {
        // Native operations
        var acos = M.acos || fallbackFn;
        var acosh = M.acosh || fallbackFn;
        var asin = M.asin || fallbackFn;
        var asinh = M.asinh || fallbackFn;
        var atanh = M.atanh || fallbackFn;
        var atan = M.atan || fallbackFn;
        var sin = M.sin || fallbackFn;
        var sinh = M.sinh || fallbackFn;
        var cos = M.cos || fallbackFn;
        var cosh = M.cosh || fallbackFn;
        var tan = M.tan || fallbackFn;
        var tanh = M.tanh || fallbackFn;
        var exp = M.exp || fallbackFn;
        var expm1 = M.expm1 || fallbackFn;
        var log1p = M.log1p || fallbackFn;
        // Operation polyfills
        var powPI = function (value) { return M.pow(M.PI, value); };
        var acoshPf = function (value) { return M.log(value + M.sqrt(value * value - 1)); };
        var asinhPf = function (value) { return M.log(value + M.sqrt(value * value + 1)); };
        var atanhPf = function (value) { return M.log((1 + value) / (1 - value)) / 2; };
        var sinhPf = function (value) { return M.exp(value) - 1 / M.exp(value) / 2; };
        var coshPf = function (value) { return (M.exp(value) + 1 / M.exp(value)) / 2; };
        var expm1Pf = function (value) { return M.exp(value) - 1; };
        var tanhPf = function (value) { return (M.exp(2 * value) - 1) / (M.exp(2 * value) + 1); };
        var log1pPf = function (value) { return M.log(1 + value); };
        // Note: constant values are empirical
        return {
            acos: acos(0.123124234234234242),
            acosh: acosh(1e308),
            acoshPf: acoshPf(1e154),
            asin: asin(0.123124234234234242),
            asinh: asinh(1),
            asinhPf: asinhPf(1),
            atanh: atanh(0.5),
            atanhPf: atanhPf(0.5),
            atan: atan(0.5),
            sin: sin(-1e300),
            sinh: sinh(1),
            sinhPf: sinhPf(1),
            cos: cos(10.000000000123),
            cosh: cosh(1),
            coshPf: coshPf(1),
            tan: tan(-1e300),
            tanh: tanh(1),
            tanhPf: tanhPf(1),
            exp: exp(1),
            expm1: expm1(1),
            expm1Pf: expm1Pf(1),
            log1p: log1p(10),
            log1pPf: log1pPf(10),
            powPI: powPI(-100),
        };
    }

    /**
     * We use m or w because these two characters take up the maximum width.
     * Also there are a couple of ligatures.
     */
    var defaultText = 'mmMwWLliI0fiflO&1';
    /**
     * Settings of text blocks to measure. The keys are random but persistent words.
     */
    var presets = {
        /**
         * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
         * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
         */
        default: [],
        /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */
        apple: [{ font: '-apple-system-body' }],
        /** User can change it in desktop Chrome and desktop Firefox. */
        serif: [{ fontFamily: 'serif' }],
        /** User can change it in desktop Chrome and desktop Firefox. */
        sans: [{ fontFamily: 'sans-serif' }],
        /** User can change it in desktop Chrome and desktop Firefox. */
        mono: [{ fontFamily: 'monospace' }],
        /**
         * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
         * The height can be 0 in Chrome on a retina display.
         */
        min: [{ fontSize: '1px' }],
        /** Tells one OS from another in desktop Chrome. */
        system: [{ fontFamily: 'system-ui' }],
    };
    /**
     * The result is a dictionary of the width of the text samples.
     * Heights aren't included because they give no extra entropy and are unstable.
     *
     * The result is very stable in IE 11, Edge 18 and Safari 14.
     * The result changes when the OS pixel density changes in Chromium 87. The real pixel density is required to solve,
     * but seems like it's impossible: https://stackoverflow.com/q/1713771/1118709.
     * The "min" and the "mono" (only on Windows) value may change when the page is zoomed in Firefox 87.
     */
    function getFontPreferences() {
        return withNaturalFonts(function (document, container) {
            var elements = {};
            var sizes = {};
            // First create all elements to measure. If the DOM steps below are done in a single cycle,
            // browser will alternate tree modification and layout reading, that is very slow.
            for (var _i = 0, _a = Object.keys(presets); _i < _a.length; _i++) {
                var key = _a[_i];
                var _b = presets[key], _c = _b[0], style = _c === void 0 ? {} : _c, _d = _b[1], text = _d === void 0 ? defaultText : _d;
                var element = document.createElement('span');
                element.textContent = text;
                element.style.whiteSpace = 'nowrap';
                for (var _e = 0, _f = Object.keys(style); _e < _f.length; _e++) {
                    var name_1 = _f[_e];
                    var value = style[name_1];
                    if (value !== undefined) {
                        element.style[name_1] = value;
                    }
                }
                elements[key] = element;
                container.appendChild(document.createElement('br'));
                container.appendChild(element);
            }
            // Then measure the created elements
            for (var _g = 0, _h = Object.keys(presets); _g < _h.length; _g++) {
                var key = _h[_g];
                sizes[key] = elements[key].getBoundingClientRect().width;
            }
            return sizes;
        });
    }
    /**
     * Creates a DOM environment that provides the most natural font available, including Android OS font.
     * Measurements of the elements are zoom-independent.
     * Don't put a content to measure inside an absolutely positioned element.
     */
    function withNaturalFonts(action, containerWidthPx) {
        if (containerWidthPx === void 0) { containerWidthPx = 4000; }
        /*
         * Requirements for Android Chrome to apply the system font size to a text inside an iframe:
         * - The iframe mustn't have a `display: none;` style;
         * - The text mustn't be positioned absolutely;
         * - The text block must be wide enough.
         *   2560px on some devices in portrait orientation for the biggest font size option (32px);
         * - There must be much enough text to form a few lines (I don't know the exact numbers);
         * - The text must have the `text-size-adjust: none` style. Otherwise the text will scale in "Desktop site" mode;
         *
         * Requirements for Android Firefox to apply the system font size to a text inside an iframe:
         * - The iframe document must have a header: `<meta name="viewport" content="width=device-width, initial-scale=1" />`.
         *   The only way to set it is to use the `srcdoc` attribute of the iframe;
         * - The iframe content must get loaded before adding extra content with JavaScript;
         *
         * https://example.com as the iframe target always inherits Android font settings so it can be used as a reference.
         *
         * Observations on how page zoom affects the measurements:
         * - macOS Safari 11.1, 12.1, 13.1, 14.0: zoom reset + offsetWidth = 100% reliable;
         * - macOS Safari 11.1, 12.1, 13.1, 14.0: zoom reset + getBoundingClientRect = 100% reliable;
         * - macOS Safari 14.0: offsetWidth = 5% fluctuation;
         * - macOS Safari 14.0: getBoundingClientRect = 5% fluctuation;
         * - iOS Safari 9, 10, 11.0, 12.0: haven't found a way to zoom a page (pinch doesn't change layout);
         * - iOS Safari 13.1, 14.0: zoom reset + offsetWidth = 100% reliable;
         * - iOS Safari 13.1, 14.0: zoom reset + getBoundingClientRect = 100% reliable;
         * - iOS Safari 14.0: offsetWidth = 100% reliable;
         * - iOS Safari 14.0: getBoundingClientRect = 100% reliable;
         * - Chrome 42, 65, 80, 87: zoom 1/devicePixelRatio + offsetWidth = 1px fluctuation;
         * - Chrome 42, 65, 80, 87: zoom 1/devicePixelRatio + getBoundingClientRect = 100% reliable;
         * - Chrome 87: offsetWidth = 1px fluctuation;
         * - Chrome 87: getBoundingClientRect = 0.7px fluctuation;
         * - Firefox 48, 51: offsetWidth = 10% fluctuation;
         * - Firefox 48, 51: getBoundingClientRect = 10% fluctuation;
         * - Firefox 52, 53, 57, 62, 66, 67, 68, 71, 75, 80, 84: offsetWidth = width 100% reliable, height 10% fluctuation;
         * - Firefox 52, 53, 57, 62, 66, 67, 68, 71, 75, 80, 84: getBoundingClientRect = width 100% reliable, height 10%
         *   fluctuation;
         * - Android Chrome 86: haven't found a way to zoom a page (pinch doesn't change layout);
         * - Android Firefox 84: font size in accessibility settings changes all the CSS sizes, but offsetWidth and
         *   getBoundingClientRect keep measuring with regular units, so the size reflects the font size setting and doesn't
         *   fluctuate;
         * - IE 11, Edge 18: zoom 1/devicePixelRatio + offsetWidth = 100% reliable;
         * - IE 11, Edge 18: zoom 1/devicePixelRatio + getBoundingClientRect = reflects the zoom level;
         * - IE 11, Edge 18: offsetWidth = 100% reliable;
         * - IE 11, Edge 18: getBoundingClientRect = 100% reliable;
         */
        return withIframe(function (_, iframeWindow) {
            var iframeDocument = iframeWindow.document;
            var iframeBody = iframeDocument.body;
            var bodyStyle = iframeBody.style;
            bodyStyle.width = "".concat(containerWidthPx, "px");
            bodyStyle.webkitTextSizeAdjust = bodyStyle.textSizeAdjust = 'none';
            // See the big comment above
            if (isChromium()) {
                iframeBody.style.zoom = "".concat(1 / iframeWindow.devicePixelRatio);
            }
            else if (isWebKit()) {
                iframeBody.style.zoom = 'reset';
            }
            // See the big comment above
            var linesOfText = iframeDocument.createElement('div');
            linesOfText.textContent = __spreadArray([], Array((containerWidthPx / 20) << 0), true).map(function () { return 'word'; }).join(' ');
            iframeBody.appendChild(linesOfText);
            return action(iframeDocument, iframeBody);
        }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
    }

    /**
     * @see Credits: https://stackoverflow.com/a/49267844
     */
    function getVideoCard() {
        var _a;
        var canvas = document.createElement('canvas');
        var gl = (_a = canvas.getContext('webgl')) !== null && _a !== void 0 ? _a : canvas.getContext('experimental-webgl');
        if (gl && 'getExtension' in gl) {
            var debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
            if (debugInfo) {
                return {
                    vendor: (gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) || '').toString(),
                    renderer: (gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || '').toString(),
                };
            }
        }
        return undefined;
    }

    function isPdfViewerEnabled() {
        return navigator.pdfViewerEnabled;
    }

    /**
     * Unlike most other architectures, on x86/x86-64 when floating-point instructions
     * have no NaN arguments, but produce NaN output, the output NaN has sign bit set.
     * We use it to distinguish x86/x86-64 from other architectures, by doing subtraction
     * of two infinities (must produce NaN per IEEE 754 standard).
     *
     * See https://codebrowser.bddppq.com/pytorch/pytorch/third_party/XNNPACK/src/init.c.html#79
     */
    function getArchitecture() {
        var f = new Float32Array(1);
        var u8 = new Uint8Array(f.buffer);
        f[0] = Infinity;
        f[0] = f[0] - f[0];
        return u8[3];
    }

    // @ts-nocheck
    var storageKeyName = "device-unique-id";
    var baseDomain = ".singtel.com";
    // Function to set a cookie
    function setCookie(name, value, options) {
        if (options === void 0) { options = {}; }
        var cookie = "".concat(encodeURIComponent(name), "=").concat(encodeURIComponent(value), ";path=/;domain=").concat(baseDomain, ";");
        Object.keys(options).forEach(function (key) {
            cookie = "".concat(cookie).concat(key, "=").concat(options[key], ";");
        });
        document.cookie = cookie;
    }
    // Function to get a cookie by name
    function getCookie(name) {
        var cookieName = encodeURIComponent(name) + '=';
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return decodeURIComponent(cookie.substring(cookieName.length));
            }
        }
        return null;
    }
    function getNetworkIP(options) {
        return __awaiter(this, void 0, void 0, function () {
            var found, resolve, promise, pc;
            return __generator(this, function (_a) {
                found = false;
                promise = new Promise(function (res) {
                    resolve = res;
                });
                pc = new RTCPeerConnection({ iceServers: [] });
                pc.createDataChannel('');
                pc.createOffer().then(function (desc) {
                    pc.setLocalDescription(desc);
                });
                pc.addEventListener('icecandidate', function (e) {
                    var _a, _b;
                    if (!e.candidate || found)
                        return;
                    var sdpArray = ((_b = (_a = pc.localDescription) === null || _a === void 0 ? void 0 : _a.sdp) === null || _b === void 0 ? void 0 : _b.split('\n')) || [];
                    var webrtcUniqueInfo = "";
                    sdpArray.forEach(function (item, index) {
                        if (item.includes("a=candidate") || item.includes("a=fingerprint")) {
                            webrtcUniqueInfo += item;
                        }
                    });
                    resolve(webrtcUniqueInfo);
                    setCookie(storageKeyName, JSON.stringify(webrtcUniqueInfo), options.cookies);
                    found = !!webrtcUniqueInfo;
                });
                return [2 /*return*/, promise];
            });
        });
    }
    function getPrivateIp(options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var ip, ip_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!window.location.origin.includes(baseDomain)) {
                            return [2 /*return*/, ''];
                        }
                        ip = getCookie(storageKeyName);
                        if (!ip) return [3 /*break*/, 1];
                        console.log("[FINGERPRINTJS]: IP Returned from cookie");
                        return [2 /*return*/, JSON.parse(ip)];
                    case 1:
                        console.log("[FINGERPRINTJS]: IP Returned from get network ip");
                        return [4 /*yield*/, getNetworkIP(options)];
                    case 2:
                        ip_1 = _a.sent();
                        return [2 /*return*/, ip_1];
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, ''];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }

    /**
     * The list of entropy sources used to make visitor identifiers.
     *
     * This value isn't restricted by Semantic Versioning, i.e. it may be changed without bumping minor or major version of
     * this package.
     *
     * Note: Rollup and Webpack are smart enough to remove unused properties of this object during tree-shaking, so there is
     * no need to export the sources individually.
     */
    var sources = {
        // READ FIRST:
        // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-make-an-entropy-source
        // to learn how entropy source works and how to make your own.
        // The sources run in this exact order.
        // The asynchronous sources are at the start to run in parallel with other sources.
        fonts: getFonts,
        domBlockers: getDomBlockers,
        fontPreferences: getFontPreferences,
        audio: getAudioFingerprint,
        screenFrame: getRoundedScreenFrame,
        osCpu: getOsCpu,
        languages: getLanguages,
        colorDepth: getColorDepth,
        deviceMemory: getDeviceMemory,
        screenResolution: getScreenResolution,
        hardwareConcurrency: getHardwareConcurrency,
        timezone: getTimezone,
        sessionStorage: getSessionStorage,
        localStorage: getLocalStorage,
        indexedDB: getIndexedDB,
        openDatabase: getOpenDatabase,
        cpuClass: getCpuClass,
        platform: getPlatform,
        plugins: getPlugins,
        canvas: getCanvasFingerprint,
        touchSupport: getTouchSupport,
        vendor: getVendor,
        vendorFlavors: getVendorFlavors,
        cookiesEnabled: areCookiesEnabled,
        colorGamut: getColorGamut,
        invertedColors: areColorsInverted,
        forcedColors: areColorsForced,
        monochrome: getMonochromeDepth,
        contrast: getContrastPreference,
        reducedMotion: isMotionReduced,
        hdr: isHDR,
        math: getMathFingerprint,
        videoCard: getVideoCard,
        pdfViewerEnabled: isPdfViewerEnabled,
        architecture: getArchitecture,
        privateIp: getPrivateIp,
    };
    /**
     * Loads the built-in entropy sources.
     * Returns a function that collects the entropy components to make the visitor identifier.
     */
    function loadBuiltinSources(options, excludeSources) {
        if (excludeSources === void 0) { excludeSources = []; }
        return loadSources(sources, options, excludeSources);
    }

    var commentTemplate = '$ if upgrade to Pro: https://fpjs.dev/pro';
    function getConfidence(components) {
        var openConfidenceScore = getOpenConfidenceScore(components);
        var proConfidenceScore = deriveProConfidenceScore(openConfidenceScore);
        return { score: openConfidenceScore, comment: commentTemplate.replace(/\$/g, "".concat(proConfidenceScore)) };
    }
    function getOpenConfidenceScore(components) {
        // In order to calculate the true probability of the visitor identifier being correct, we need to know the number of
        // website visitors (the higher the number, the less the probability because the fingerprint entropy is limited).
        // JS agent doesn't know the number of visitors, so we can only do an approximate assessment.
        if (isAndroid()) {
            return 0.4;
        }
        // Safari (mobile and desktop)
        if (isWebKit()) {
            return isDesktopSafari() ? 0.5 : 0.3;
        }
        var platform = components.platform.value || '';
        // Windows
        if (/^Win/.test(platform)) {
            // The score is greater than on macOS because of the higher variety of devices running Windows.
            // Chrome provides more entropy than Firefox according too
            // https://netmarketshare.com/browser-market-share.aspx?options=%7B%22filter%22%3A%7B%22%24and%22%3A%5B%7B%22platform%22%3A%7B%22%24in%22%3A%5B%22Windows%22%5D%7D%7D%5D%7D%2C%22dateLabel%22%3A%22Trend%22%2C%22attributes%22%3A%22share%22%2C%22group%22%3A%22browser%22%2C%22sort%22%3A%7B%22share%22%3A-1%7D%2C%22id%22%3A%22browsersDesktop%22%2C%22dateInterval%22%3A%22Monthly%22%2C%22dateStart%22%3A%222019-11%22%2C%22dateEnd%22%3A%222020-10%22%2C%22segments%22%3A%22-1000%22%7D
            // So we assign the same score to them.
            return 0.6;
        }
        // macOS
        if (/^Mac/.test(platform)) {
            // Chrome provides more entropy than Safari and Safari provides more entropy than Firefox.
            // Chrome is more popular than Safari and Safari is more popular than Firefox according to
            // https://netmarketshare.com/browser-market-share.aspx?options=%7B%22filter%22%3A%7B%22%24and%22%3A%5B%7B%22platform%22%3A%7B%22%24in%22%3A%5B%22Mac%20OS%22%5D%7D%7D%5D%7D%2C%22dateLabel%22%3A%22Trend%22%2C%22attributes%22%3A%22share%22%2C%22group%22%3A%22browser%22%2C%22sort%22%3A%7B%22share%22%3A-1%7D%2C%22id%22%3A%22browsersDesktop%22%2C%22dateInterval%22%3A%22Monthly%22%2C%22dateStart%22%3A%222019-11%22%2C%22dateEnd%22%3A%222020-10%22%2C%22segments%22%3A%22-1000%22%7D
            // So we assign the same score to them.
            return 0.5;
        }
        // Another platform, e.g. a desktop Linux. It's rare, so it should be pretty unique.
        return 0.7;
    }
    function deriveProConfidenceScore(openConfidenceScore) {
        return round(0.99 + 0.01 * openConfidenceScore, 0.0001);
    }

    function componentsToCanonicalString(components) {
        var result = '';
        for (var _i = 0, _a = Object.keys(components).sort(); _i < _a.length; _i++) {
            var componentKey = _a[_i];
            var component = components[componentKey];
            var value = component.error ? 'error' : JSON.stringify(component.value);
            result += "".concat(result ? '|' : '').concat(componentKey.replace(/([:|\\])/g, '\\$1'), ":").concat(value);
        }
        return result;
    }
    function componentsToDebugString(components) {
        return JSON.stringify(components, function (_key, value) {
            if (value instanceof Error) {
                return errorToObject(value);
            }
            return value;
        }, 2);
    }
    function hashComponents(components) {
        return x64hash128(componentsToCanonicalString(components));
    }
    /**
     * Makes a GetResult implementation that calculates the visitor id hash on demand.
     * Designed for optimisation.
     */
    function makeLazyGetResult(components) {
        var visitorIdCache;
        // This function runs very fast, so there is no need to make it lazy
        var confidence = getConfidence(components);
        // A plain class isn't used because its getters and setters aren't enumerable.
        return {
            get visitorId() {
                if (visitorIdCache === undefined) {
                    visitorIdCache = hashComponents(this.components);
                }
                return visitorIdCache;
            },
            set visitorId(visitorId) {
                visitorIdCache = visitorId;
            },
            confidence: confidence,
            components: components,
            version: version,
        };
    }
    /**
     * A delay is required to ensure consistent entropy components.
     * See https://github.com/fingerprintjs/fingerprintjs/issues/254
     * and https://github.com/fingerprintjs/fingerprintjs/issues/307
     * and https://github.com/fingerprintjs/fingerprintjs/commit/945633e7c5f67ae38eb0fea37349712f0e669b18
     */
    function prepareForSources(delayFallback) {
        if (delayFallback === void 0) { delayFallback = 50; }
        // A proper deadline is unknown. Let it be twice the fallback timeout so that both cases have the same average time.
        return requestIdleCallbackIfAvailable(delayFallback, delayFallback * 2);
    }
    /**
     * The function isn't exported from the index file to not allow to call it without `load()`.
     * The hiding gives more freedom for future non-breaking updates.
     *
     * A factory function is used instead of a class to shorten the attribute names in the minified code.
     * Native private class fields could've been used, but TypeScript doesn't allow them with `"target": "es5"`.
     */
    function makeAgent(getComponents, debug) {
        var creationTime = Date.now();
        return {
            get: function (options) {
                return __awaiter(this, void 0, void 0, function () {
                    var startTime, components, result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                startTime = Date.now();
                                return [4 /*yield*/, getComponents()];
                            case 1:
                                components = _a.sent();
                                result = makeLazyGetResult(components);
                                if (debug || (options === null || options === void 0 ? void 0 : options.debug)) {
                                    // console.log is ok here because it's under a debug clause
                                    // eslint-disable-next-line no-console
                                    console.log("Copy the text below to get the debug data:\n\n```\nversion: ".concat(result.version, "\nuserAgent: ").concat(navigator.userAgent, "\ntimeBetweenLoadAndGet: ").concat(startTime - creationTime, "\nvisitorId: ").concat(result.visitorId, "\ncomponents: ").concat(componentsToDebugString(components), "\n```"));
                                }
                                return [2 /*return*/, result];
                        }
                    });
                });
            },
        };
    }
    /**
     * Sends an unpersonalized AJAX request to collect installation statistics
     */
    function monitor() {
        // The FingerprintJS CDN (https://github.com/fingerprintjs/cdn) replaces `window.__fpjs_d_m` with `true`
        if (window.__fpjs_d_m || Math.random() >= 0.001) {
            return;
        }
        try {
            var request = new XMLHttpRequest();
            request.open('get', "https://m1.openfpcdn.io/fingerprintjs/v".concat(version, "/npm-monitoring"), true);
            request.send();
        }
        catch (error) {
            // console.error is ok here because it's an unexpected error handler
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }
    /**
     * Builds an instance of Agent and waits a delay required for a proper operation.
     */
    function load(_a) {
        var _b = _a === void 0 ? {} : _a, delayFallback = _b.delayFallback, debug = _b.debug, _c = _b.monitoring, monitoring = _c === void 0 ? false : _c, _d = _b.excludeSources, excludeSources = _d === void 0 ? [] : _d, _e = _b.cookies, cookies = _e === void 0 ? {} : _e;
        return __awaiter(this, void 0, void 0, function () {
            var getComponents;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (monitoring) {
                            monitor();
                        }
                        return [4 /*yield*/, prepareForSources(delayFallback)];
                    case 1:
                        _f.sent();
                        getComponents = loadBuiltinSources({ debug: debug, cookies: cookies }, excludeSources);
                        return [2 /*return*/, makeAgent(getComponents, debug)];
                }
            });
        });
    }

    // The default export is a syntax sugar (`import * as FP from '...' → import FP from '...'`).
    // It should contain all the public exported values.
    var index = { load: load, hashComponents: hashComponents, componentsToDebugString: componentsToDebugString };
    // The exports below are for private usage. They may change unexpectedly. Use them at your own risk.
    /** Not documented, out of Semantic Versioning, usage is at your own risk */
    var murmurX64Hash128 = x64hash128;

    exports.componentsToDebugString = componentsToDebugString;
    exports.default = index;
    exports.getFullscreenElement = getFullscreenElement;
    exports.getScreenFrame = getScreenFrame;
    exports.hashComponents = hashComponents;
    exports.isAndroid = isAndroid;
    exports.isChromium = isChromium;
    exports.isDesktopSafari = isDesktopSafari;
    exports.isEdgeHTML = isEdgeHTML;
    exports.isGecko = isGecko;
    exports.isTrident = isTrident;
    exports.isWebKit = isWebKit;
    exports.load = load;
    exports.loadSources = loadSources;
    exports.murmurX64Hash128 = murmurX64Hash128;
    exports.prepareForSources = prepareForSources;
    exports.sources = sources;
    exports.transformSource = transformSource;

    Object.defineProperty(exports, '__esModule', { value: true });

}));

define('browser',[], function () {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 *
	 * ref: https://github.com/lancedikson/bowser
	 */

	/**
	 * See useragents.js for examples of navigator.userAgent
	 */

	var t = true;

	function detect(ua) {

		function getFirstMatch(regex) {
			var match = ua.match(regex);
			return (match && match.length > 1 && match[1]) || '';
		}

		function getSecondMatch(regex) {
			var match = ua.match(regex);
			return (match && match.length > 1 && match[2]) || '';
		}

		var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase(),
			likeAndroid = /like android/i.test(ua),
			android = !likeAndroid && /android/i.test(ua),
			nexusMobile = /nexus\s*[0-6]\s*/i.test(ua),
			nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua),
			chromeos = /CrOS/.test(ua),
			silk = /silk/i.test(ua),
			sailfish = /sailfish/i.test(ua),
			tizen = /tizen/i.test(ua),
			webos = /(web|hpw)os/i.test(ua),
			windowsphone = /windows phone/i.test(ua),
			// samsungBrowser = /SamsungBrowser/i.test(ua),
			windows = !windowsphone && /windows/i.test(ua),
			mac = !iosdevice && !silk && /macintosh/i.test(ua),
			linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua),
			edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i),
			versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i),
			tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua),
			mobile = !tablet && /[^-]mobi/i.test(ua),
			xbox = /xbox/i.test(ua),
			result;

		if (/opera/i.test(ua)) {
			//  an old Opera
			result = {
				name: 'Opera',
				opera: t,
				version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
			};
		} else if (/opr\/|opios/i.test(ua)) {
			// a new Opera
			result = {
				name: 'Opera',
				opera: t,
				version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
			};
		} else if (/SamsungBrowser/i.test(ua)) {
			result = {
				name: 'Samsung Internet for Android',
				samsungBrowser: t,
				version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
			};
		} else if (/coast/i.test(ua)) {
			result = {
				name: 'Opera Coast',
				coast: t,
				version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
			};
		} else if (/yabrowser/i.test(ua)) {
			result = {
				name: 'Yandex Browser',
				yandexbrowser: t,
				version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
			};
		} else if (/ucbrowser/i.test(ua)) {
			result = {
				name: 'UC Browser',
				ucbrowser: t,
				version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
			};
		} else if (/mxios/i.test(ua)) {
			result = {
				name: 'Maxthon',
				maxthon: t,
				version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
			};
		} else if (/epiphany/i.test(ua)) {
			result = {
				name: 'Epiphany',
				epiphany: t,
				version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
			};
		} else if (/puffin/i.test(ua)) {
			result = {
				name: 'Puffin',
				puffin: t,
				version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
			};
		} else if (/sleipnir/i.test(ua)) {
			result = {
				name: 'Sleipnir',
				sleipnir: t,
				version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
			};
		} else if (/k-meleon/i.test(ua)) {
			result = {
				name: 'K-Meleon',
				kMeleon: t,
				version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
			};
		} else if (windowsphone) {
			result = {
				name: 'Windows Phone',
				osname: 'Windows Phone',
				windowsphone: t
			};
			if (edgeVersion) {
				result.msedge = t;
				result.version = edgeVersion;
			} else {
				result.msie = t;
				result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i);
			}
		} else if (/msie|trident/i.test(ua)) {
			result = {
				name: 'Internet Explorer',
				msie: t,
				version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
			};
		} else if (chromeos) {
			result = {
				name: 'Chrome',
				osname: 'Chrome OS',
				chromeos: t,
				chromeBook: t,
				chrome: t,
				version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
			};
		} else if (/edg([ea]|ios)/i.test(ua)) {
			result = {
				name: 'Microsoft Edge',
				msedge: t,
				version: edgeVersion
			};
		}
		else if (/vivaldi/i.test(ua)) {
			result = {
				name: 'Vivaldi',
				vivaldi: t,
				version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
			};
		}
		else if (sailfish) {
			result = {
				name: 'Sailfish',
				osname: 'Sailfish OS',
				sailfish: t,
				version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
			};
		}
		else if (/seamonkey\//i.test(ua)) {
			result = {
				name: 'SeaMonkey',
				seamonkey: t,
				version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
			};
		}
		else if (/firefox|iceweasel|fxios/i.test(ua)) {
			result = {
				name: 'Firefox',
				firefox: t,
				version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
			};
			if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
				result.firefoxos = t;
				result.osname = 'Firefox OS';
			}
		}
		else if (silk) {
			result = {
				name: 'Amazon Silk',
				silk: t,
				version: getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
			};
		}
		else if (/phantom/i.test(ua)) {
			result = {
				name: 'PhantomJS',
				phantom: t,
				version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
			};
		}
		else if (/slimerjs/i.test(ua)) {
			result = {
				name: 'SlimerJS',
				slimer: t,
				version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
			};
		}
		else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
			result = {
				name: 'BlackBerry',
				osname: 'BlackBerry OS',
				blackberry: t,
				version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
			};
		} else if (webos) {
			result = {
				name: 'WebOS',
				osname: 'WebOS',
				webos: t,
				version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
			};
			if (/touchpad\//i.test(ua)) {
				result.touchpad = t;
			}
		} else if (/bada/i.test(ua)) {
			result = {
				name: 'Bada',
				osname: 'Bada',
				bada: t,
				version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
			};
		} else if (tizen) {
			result = {
				name: 'Tizen',
				osname: 'Tizen',
				tizen: t,
				version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
			};
		} else if (/qupzilla/i.test(ua)) {
			result = {
				name: 'QupZilla',
				qupzilla: t,
				version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
			};
		} else if (/chromium/i.test(ua)) {
			result = {
				name: 'Chromium',
				chromium: t,
				version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
			};
		} else if (/chrome|crios|crmo/i.test(ua)) {
			result = {
				name: 'Chrome',
				chrome: t,
				version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
			};
		} else if (android) {
			result = {
				name: 'Android',
				version: versionIdentifier
			};
		} else if (/safari|applewebkit/i.test(ua)) {
			result = {
				name: 'Safari',
				safari: t
			};
			if (versionIdentifier) {
				result.version = versionIdentifier;
			}
		} else if (iosdevice) {
			result = {
				name: iosdevice === 'iphone' ? 'iPhone' : iosdevice === 'ipad' ? 'iPad' : 'iPod'
			};
			// WTF: version is not part of user agent in web apps
			if (versionIdentifier) {
				result.version = versionIdentifier;
			}
		} else if (/googlebot/i.test(ua)) {
			result = {
				name: 'Googlebot',
				googlebot: t,
				version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
			};
		}
		else {
			result = {
				name: getFirstMatch(/^(.*)\/(.*) /),
				version: getSecondMatch(/^(.*)\/(.*) /)
			};
		}

		// set webkit or gecko flag for browsers based on these engines
		if (!result.msedge && /(apple)?webkit/i.test(ua)) {
			if (/(apple)?webkit\/537\.36/i.test(ua)) {
				result.name = result.name || 'Blink';
				result.blink = t;
			} else {
				result.name = result.name || 'Webkit';
				result.webkit = t;
			}
			if (!result.version && versionIdentifier) {
				result.version = versionIdentifier;
			}
		} else if (!result.opera && /gecko\//i.test(ua)) {
			result.name = result.name || 'Gecko';
			result.gecko = t;
			result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i);
		}

		// set OS flags for platforms that have multiple browsers
		if (!result.windowsphone && (android || result.silk)) {
			result.android = t;
			result.osname = 'Android';
		} else if (!result.windowsphone && iosdevice) {
			result[iosdevice] = t;
			result.ios = t;
			result.osname = 'iOS';
		} else if (mac) {
			result.mac = t;
			result.osname = 'macOS';
		} else if (xbox) {
			result.xbox = t;
			result.osname = 'Xbox';
		} else if (windows) {
			result.windows = t;
			result.osname = 'Windows';
		} else if (linux) {
			result.linux = t;
			result.osname = 'Linux';
		}

		function getWindowsVersion(s) {
			switch (s) {
				case 'NT':
					return 'NT';
				case 'XP':
					return 'XP';
				case 'NT 5.0':
					return '2000';
				case 'NT 5.1':
					return 'XP';
				case 'NT 5.2':
					return '2003';
				case 'NT 6.0':
					return 'Vista';
				case 'NT 6.1':
					return '7';
				case 'NT 6.2':
					return '8';
				case 'NT 6.3':
					return '8.1';
				case 'NT 10.0':
					return '10';
				default:
					return undefined;
			}
		}

		// OS version extraction
		var osVersion = '';
		if (result.windows) {
			osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i));
		} else if (result.windowsphone) {
			osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
		} else if (result.mac) {
			osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
			osVersion = osVersion.replace(/[_\s]/g, '.');
		} else if (iosdevice) {
			osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
			osVersion = osVersion.replace(/[_\s]/g, '.');
		} else if (android) {
			osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
		} else if (result.webos) {
			osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
		} else if (result.blackberry) {
			osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
		} else if (result.bada) {
			osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
		} else if (result.tizen) {
			osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
		}
		if (osVersion) {
			result.osversion = osVersion;
		}

		// device type extraction
		var osMajorVersion = !result.windows && osVersion.split('.')[0];
		if (
			tablet ||
			nexusTablet ||
			iosdevice === 'ipad' ||
			(android && (osMajorVersion === 3 || (osMajorVersion >= 4 && !mobile))) ||
			result.silk
		) {
			result.tablet = t;
		} else if (
			mobile ||
			iosdevice === 'iphone' ||
			iosdevice === 'ipod' ||
			android ||
			nexusMobile ||
			result.blackberry ||
			result.webos ||
			result.bada
		) {
			result.mobile = t;
		}

		// Graded Browser Support
		// http://developer.yahoo.com/yui/articles/gbs
		if (result.msedge ||
			(result.msie && result.version >= 10) ||
			(result.yandexbrowser && result.version >= 15) ||
			(result.vivaldi && result.version >= 1.0) ||
			(result.chrome && result.version >= 20) ||
			(result.samsungBrowser && result.version >= 4) ||
			(result.firefox && result.version >= 20.0) ||
			(result.safari && result.version >= 6) ||
			(result.opera && result.version >= 10.0) ||
			(result.ios && result.osversion && result.osversion.split('.')[0] >= 6) ||
			(result.blackberry && result.version >= 10.1) ||
			(result.chromium && result.version >= 20)
		) {
			result.a = t;
		}
		else if ((result.msie && result.version < 10) ||
			(result.chrome && result.version < 20) ||
			(result.firefox && result.version < 20.0) ||
			(result.safari && result.version < 6) ||
			(result.opera && result.version < 10.0) ||
			(result.ios && result.osversion && result.osversion.split('.')[0] < 6) ||
			(result.chromium && result.version < 20)
		) {
			result.c = t;
		} else {
			result.x = t;
		}

		return result;
	}

	var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '');

	bowser.test = function (browserList) {
		for (var i = 0; i < browserList.length; ++i) {
			var browserItem = browserList[i];
			if (typeof browserItem === 'string') {
				if (browserItem in bowser) {
					return true;
				}
			}
		}
		return false;
	};

	/**
	 * Get version precisions count
	 *
	 * @example
	 *   getVersionPrecision("1.10.3") // 3
	 *
	 * @param  {string} version
	 * @return {number}
	 */
	function getVersionPrecision(version) {
		return version.split('.').length;
	}

	/**
	 * Array::map polyfill
	 *
	 * @param  {Array} arr
	 * @param  {Function} iterator
	 * @return {Array}
	 */
	function map(arr, iterator) {
		var result = [], i;
		if (Array.prototype.map) {
			return Array.prototype.map.call(arr, iterator);
		}
		for (i = 0; i < arr.length; i++) {
			result.push(iterator(arr[i]));
		}
		return result;
	}

	/**
	 * Calculate browser version weight
	 *
	 * @example
	 *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	 *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	 *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	 *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	 *
	 * @param  {Array<String>} versions versions to compare
	 * @return {Number} comparison result
	 */
	function compareVersions(versions) {
		// 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
		var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
		var chunks = map(versions, function (version) {
			var delta = precision - getVersionPrecision(version);

			// 2) "9" -> "9.0" (for precision = 2)
			version = version + new Array(delta + 1).join('.0');

			// 3) "9.0" -> ["000000000"", "000000009"]
			return map(version.split('.'), function (chunk) {
				return new Array(20 - chunk.length).join('0') + chunk;
			}).reverse();
		});

		// iterate in reverse order by reversed chunks array
		while (--precision >= 0) {
			// 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
			if (chunks[0][precision] > chunks[1][precision]) {
				return 1;
			}
			else if (chunks[0][precision] === chunks[1][precision]) {
				if (precision === 0) {
					// all version chunks are same
					return 0;
				}
			}
			else {
				return -1;
			}
		}
	}

	/**
	 * Check if browser is unsupported
	 *
	 * @example
	 *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
	 *
	 * @param  {Object}  minVersions map of minimal version to browser
	 * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	 * @param  {String}  [ua] user agent string
	 * @return {Boolean}
	 */
	function isUnsupportedBrowser(minVersions, strictMode, ua) {
		var _bowser = bowser;

		// make strictMode param optional with ua param usage
		if (typeof strictMode === 'string') {
			ua = strictMode;
			strictMode = void(0);
		}

		if (strictMode === void(0)) {
			strictMode = false;
		}
		if (ua) {
			_bowser = detect(ua);
		}

		var version = '' + _bowser.version;
		for (var browser in minVersions) {
			if (minVersions.hasOwnProperty(browser)) {
				if (_bowser[browser]) {
					if (typeof minVersions[browser] !== 'string') {
						throw new Error('Browser version in the minVersion map should be a string: ' +
							browser + ': ' + String(minVersions));
					}

					// browser version and min supported version.
					return compareVersions([version, minVersions[browser]]) < 0;
				}
			}
		}

		return strictMode; // not found
	}

	/**
	 * Check if browser is supported
	 *
	 * @param  {Object} minVersions map of minimal version to browser
	 * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	 * @param  {String}  [ua] user agent string
	 * @return {Boolean}
	 */
	function check(minVersions, strictMode, ua) {
		return !isUnsupportedBrowser(minVersions, strictMode, ua);
	}

	bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	bowser.compareVersions = compareVersions;
	bowser.check = check;

	/*
     * Set our detect method to the main bowser object so we can
     * reuse it to test other user agents.
     * This is needed to implement future tests.
     */
	bowser._detect = detect;

	/*
     * Set our detect public method to the main bowser object
     * This is needed to implement bowser in server side
     */
	bowser.detect = detect;
	return bowser;
});

define('RactiveHelpers',['lodash-compat', 'moment', 'ConfigStrings', 'jquery',
'RactiveValidate', 'FingerprintJs',
'browser'], function (_, moment, ConfigStrings, $, RactiveValidate, FingerprintJs, browser) {

	return {
		/*
		 * @param model (object)
		 * Returns the path to a property from its model. Handle radio button models.
		 * */
		getPathFromModel: function (model) {
			var path = '';
			var i = 0;
			do {
				if (i >= Object.keys(model).length) {
					break;
				}
				path = Object.keys(model)[i++];
			} while (path.startsWith('${'));

			return path;
		},
		currencyConvert: function (price) {
			return price / 100;
		},
		/**
		 * @param simNumber
         * @returns if 13 digits => add 896102 optus sim prefix
		 * returns a 19 digits SIM Number
         */
		getSimNumber: function (simNumber) {
			var exp = /^\d{13}$/;
			var simPrefix = '896102';
			if (exp.test(simNumber)) {
				simNumber = simPrefix + simNumber;
			}
			return simNumber;
		},

		billEventMobileNumberFormat: function (num) {
			if (num) {
				num = num.toString();
				if (num.length > 8 && !num.startsWith('65')) {
					return num;
				} else {
					return this.mobileNumberFormat(num);
				}
			}
		},
		serviceFormat: function (service) {
			if (service.length === 8 && !isNaN(service)) {
				return this.mobileNumberFormat(service);
			} else {
				return service;
			}
		},
		/**
		 * @param {number} 8 digital phone Number (eg. 99998888)
		 * @returns {string} the number with a space in the middle (eg. '9999 8888')
		 */
		mobileNumberFormat: function (num) {
			num = num.toString();
			if (num.length > 8) {
				num = this.removePrefix(num);
			}
			return num.replace(/\B(?=(\d{4})+(?!\d))/g, ' ');
		},
		formatForInputPhoneNumber: function (phone) {
			return phone.replace(/[^(\d\s\+)]/g, '');
		},
		formatForSavePhoneNumber: function (phone) {
			var formated = phone.replace(/\s/g, '');
			formated = formated.replace(/^\+?6{1}1{1}/, '0');
			return formated;
		},
		formatForDisplayPhoneNumber: function (number) {
			var formatedPhone = '',
				countryCode = '',
				exp = '';
			//if country code at the begining (check if phone number is much longer than 10 char)
			var isCountryCode = number.length > 10;
			if (isCountryCode && !isNaN(number)) {
				//if no + but countryCode, add +
				number = number.replace(/^(?!\+)(\d*)/g, '+$1');
				countryCode = number.substring(0, 3) + ' ';
				number = number.substring(3);
			}
			//if needs parenthesis (other than numbers begining with 1800 008 or 04
			exp = new RegExp('/^(?!(008|1800|04))(\d{2})(\d*)(\d{4})(\d{4})/', 'g');
			var needsParenthesis = exp.test(number);
			if (needsParenthesis) {
				//Put parenthesis and the space between last 4 digits groups
				formatedPhone = number.replace(exp, '($2)$3 $4 $5');
			} else {
				//insert space between the two groups of 3 digits at the end
				formatedPhone = number.replace(/^(008|1800|04|[1-9])(\d*)(\d{3})(\d{3})$/g, '$1$2 $3 $4');
				formatedPhone = formatedPhone.replace('  ', ' ');
			}

			//replace country code
			formatedPhone = countryCode + formatedPhone;

			return formatedPhone;
		},
		/**
		 *    Formatting functions for phone numbers
		 *    @param: Ten digit phone number string e.g 'xxxxxxxxxx'
		 *    @returns: formatted phone number strings '04xx xxx xxx'/'0x xxxx xxxx'.
		 **/
		formatMobileNumber: function (number) {
			if (!number) {
				return null;
			}
			return [number.slice(0, 4), number.slice(4, 7), number.slice(7, 10)].join(' ');
		},

		formatLandlineNumber: function (number) {
			if (!number) {
				return null;
			}
			return [number.slice(0, 2), number.slice(2, 6), number.slice(6, 10)].join(' ');
		},
		formatBSBNumberForSave: function (bsb) {
			if (bsb) {
				if (bsb.match(/^\d{6}$/)) {
					return bsb.replace(/^(\d{3})/, '$1-');
				} else {
					return bsb;
				}
			}
		},
		/**
		 * Given mobile listing data model, provide a link to the product selector page (moreInfo) and augment it
		 * with hash values to preselect colour and model of phone.
		 * @param mobileListingModel As per mobileListing Redmarine widget.
		 * @returns {string} A full (or relative) url.
		 */
		linkToProductSelector: function (mobileListingModel) {

			var parts = [];

			parts.push(mobileListingModel.moreInfo);

			parts.push('#');

			parts.push(mobileListingModel.colour);

			if (mobileListingModel.capacity) {
				parts.push('-');
				parts.push(mobileListingModel.capacity);
			}

			if (mobileListingModel.flow === 'RECONTRACT') {
				parts.push('-');
				parts.push('existing');
			}

			if (mobileListingModel.flow === 'PREPAY_TO_POSTPAY') {
				parts.push('-');
				parts.push('existing');
				parts.push('-');
				parts.push('Pre2Post');
			}

			return parts.join('').toLowerCase();

		},
		nameValidator: function (name) {
			//Define Regular Expression
			return true;
		},

		emailValidator: function (email) {
			var exp = new RegExp(['^(([^<>()[\\]\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\.,;:\\s@\"]+)*)|(\\".+\"))@',
				'(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$'].join(''), 'i');
			return exp.test(email);
		},

		phoneValidator: function (phone) {
			if (phone && phone.length > 8) {
				return false;
			}
			var exp = /^[(]{0,1}[6|8|9]{1}[)]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}/;
			return exp.test(phone);
		},
		phoneValidatorEmpty: function (phone) {
			if (phone !== '' && phone.length !== 0 && phone.length < 9) {
				var exp = /^[(]{0,1}[6|8|9]{1}[)]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}/;
				return exp.test(phone);
			} else if (phone.length > 8) {
				return false;
			}
			return true;
		},
		prepaidLineValidator: function (phone) {
			if (phone.length > 8) {
				return false;
			}
			var exp = /^[(]{0,1}[6|8|9]{1}[)]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}/;
			return exp.test(phone);
		},
		mobileValidator: function (phone) {
			if (phone.length > 8) {
				return false;
			}
			var exp = /^[(]{0,1}[8|9]{1}[)]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}/;
			return exp.test(phone);
		},
		isEmpty: function (value) {
			return value.length === 0 ? false : true;
		},

		getPercentage: function (amount, total) {
			var percentage;
			// avoiding division by zero
			if (total === 0) {
				return 0;
			} else if (amount === 0 && total < 0) {
				return -1;
			}

			percentage = ((amount / total) * 100).toFixed(2);

			if (percentage < 0.01 && percentage > 0) {
				percentage = 1;
				// Pav. Q: is that correct? 0.001 will become 1 whereas 0.2 will remain 0.2
			}

			return parseFloat(percentage, 10);
		},

		/**
		 * calculates the percentage value of the total. e.g.
		 * If we want to calulate GST (7%) of total price.
		 * @param 'total' Total of which we want to calculate percentage value
		 * @param 'percentage' Percentage to caclulate
		 * @returns {Float}
		 */
		calculatePercentage: function (total, percentage) {
			var percentTotal = ((total * percentage) / 100);
			return parseFloat(percentTotal, 10);
		},

		/**
		 * remove prefix +65 fron phoone number
		 * @param value is actual value.
		 */
		removePrefix: function (str) {
			return str.substr(str.length - 8, str.length);
		},

		/**
		 * Converts kb values to higher level values (mb, gb).
		 * units can be overridden to pass base-10 values through (needed for some UI).
		 */
		kilobyteConversion: function (value, showUnits, units) {

			//default byte conversion
			units = units || {
					gb: 1048576,
					mb: 1024,
					kb: 1
				};

			var amount = +(value) || 0,
				gb = units.gb,
				mb = units.mb,
				kb = units.kb;

			var scale = (amount >= gb) ? gb : ((amount >= mb) ? mb : kb);
			var units = (amount >= gb) ? 'GB' : ((amount >= mb || !amount) ? 'MB' : 'KB');

			var convertedValue = parseFloat((amount / scale).toFixed(2));

			if (showUnits) {
				convertedValue = [convertedValue, units].join(' ');
			}

			// Convention: Any negative values are treated as unlimited.
			return (value < 0) ? 'Unlimited' : convertedValue;
		},

		/**
		 * Converts kb values to higher level values (mb, gb).
		 * units can be overridden to pass base-10 values through (needed for some UI).
		 * Converted Unit upto 4 point of decimal
		 */
		UsageSummarykilobyteConversion: function (value, showUnits, units) {

			//default byte conversion
			units = units || {
					gb: 1048576,
					mb: 1024,
					kb: 1
				};

			var amount = +(value) || 0,
				gb = units.gb,
				mb = units.mb,
				kb = units.kb;

			var scale = (amount >= gb) ? gb : ((amount >= mb) ? mb : kb);
			var units = (amount >= gb) ? 'GB' : ((amount >= mb || !amount) ? 'MB' : 'KB');

			var convertedValue = parseFloat((amount / scale).toFixed(4));

			if (showUnits) {
				convertedValue = [convertedValue, units].join(' ');
			}

			// Convention: Any negative values are treated as unlimited.
			return (value < 0) ? 'Unlimited' : convertedValue;
		},

		/**
		 * Converts string to Lowecase
		 */
		convertToLowerCase: function (value) {
			return value.toLowerCase();
		},
		timeConversion: function (value, showUnits, handler) {
			var handler = handler || Math.round,
				result = value < 0 ? 'Unlimited' : handler(value / 60);
			result += (value > 0 || showUnits) ? ' Mins' : '';
			return result;
		},

		/**
		 * Converts the seconds duration into the hours:minutes:seconds string
		 *
		 * @param duration in seconds
		 * @param isMilliseconds boolean
		 * @returns {String}
		 */
		formatDurationSeconds: function (duration, isMilliseconds) {
			if (!duration || isNaN(duration)) {
				return '';
			}
			// If duration come in milliseconds, just uncomment below line.
			if (isMilliseconds) {
				duration = duration / 1000;
			}
			var hr = Math.floor(duration / 3600);
			var min = Math.floor(duration / 60) % 60;
			var sec = duration % 60;
			if (sec > 0 || min > 0 || hr > 0) {
				sec = sec + 's';
			} else {
				sec = '';
			}
			if (min > 0 || hr > 0) {
				min = min + 'm';
			} else {
				min = '';
			}
			if (hr > 0) {
				hr = hr + 'h';
			} else {
				hr = '';
			}
			var dur = hr ? [hr, min, sec].join(':') : (min ? [min, sec].join(':') : sec);
			return dur;
		},

		commaSeparateUnits: function (value) {
			var result = value;
			// Limit to 2 decimal format.
			var resDecFormat = (result.indexOf('.') >= 0) ?
			(result.substr(0, result.indexOf('.')) + result.substr(result.indexOf('.'), 3)) : result;

			value = resDecFormat.toString().split(',').join('');
			if (value < 0) {
				value = -1 * value;
				result = '-' + (value || 0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			} else {
				result = (value || 0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			}
			return result;
		},

		convertUnits: function (value, type, showUnits, handler) {
			var result = value;

			if (_.isNull(showUnits) || _.isUndefined(showUnits)) {
				showUnits = false;
			}

			switch (type.toLowerCase()) {
				case 'voice':
				case 'secs':
				case 'sec':
				case 'idd':
				case 'seconds':
				case 'second':
					result = this.timeConversion(value, showUnits, handler);
					break;

				case 'data':
				case 'kbs':
					result = this.kilobyteConversion(value, showUnits);
					break;
				case 'byte':
				case 'bytes':
					// Convert bytes to kb.
					value = value / 1024;
					result = this.kilobyteConversion(value, showUnits);
					break;
				case 'messages':
					var plural = value === 1 ? '' : 's';
					result = value + ' Message' + plural;
					break;
				case 'cent':
				case 'cents':
					// showUnits is redundant in this use case.
					// Multiple purposing showUnits to determine how many decimals we want to show.
					var decimals = _.isBoolean(showUnits) ? 2 : showUnits;
					result = this.convertCentsToDollars(value, 1, decimals);
					break;
				case '$':
				case 'dollar':
					// No change to value - server provided data in correct format.
					// Force to 2 decimal places, that means 50 -> $50.00.
					// Comma separate units for more than 4 digits
					value = _.isNull(showUnits) || _.isUndefined(showUnits) ? 0 : value;
					value = parseFloat(value);
					if (value < 0) {
						value = -1 * value;
						result = '-$' + (value || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
					} else {
						result = '$' + (value || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
					}
					break;
				case '$withoutdecimal':
				case 'dollarwithoutdecimal':
					// No change to value - server provided data in correct format.
					// Force to 2 decimal places, that means 50 -> $50.
					// Comma separate units for more than 4 digits
					value = _.isNull(showUnits) || _.isUndefined(showUnits) ? 0 : value;
					value = parseFloat(value);
					if (value < 0) {
						value = -1 * value;
						result = '-$' + (value || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
					} else {
						result = '$' + (value || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
					}
					break;
				case 'aud':
					// show 2 decimal if not rounded amount, else show rounder amount,
					// that means 50 -> $50, 50.5 -> 50.50.
					value = _.isNull(showUnits) || _.isUndefined(showUnits) ? 0 : value;
					value = parseFloat(value);

					if (value < 0) {
						value = -1 * value;
						result = '$' + value.toFixed(2) + '(CR)';
					} else {
						result = '$' + value.toFixed(2);
					}
					break;
				case '10000 cents':
					result = this.convertCentsToDollars(value / 10000, 1, 2);
					break;
				case 'showdecimals':
					var decimals = _.isBoolean(showUnits) ? 2 : showUnits;
					result = parseFloat(value).toFixed(decimals);
					break;
				case 'showdollars':
					value = parseFloat(value);
					value = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

					result = '$' + value.substr(0, value.indexOf('.'));
					break;
				case 'showcents':
					value = parseFloat(value);
					value = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

					result = value.substr(value.indexOf('.'), value.length);
					break;
				default:
					result = showUnits ? [result, type].join(' ') : result;
					break;
			}

			return result;

		},

		sortData: function (data, column) {
			return _.sortBy(data, column);
		},

		zeroPadding: function (value, limit) {
			value = value + '';
			var limit = limit - value.length;
			for (var i = 0; i < limit; i++) {
				value = '0' + value;
			}
			return value;
		},

		convertPrepaidUnits: function (value, type, showUnits) {

			var result = value;

			switch (type.toLowerCase()) {
				case 'byte':
				case 'bytes':
					result = value >= 99999999000 ? 'Unlimited' : this.convertUnits(value, type, showUnits);
					break;

				case 'kbs':
					result = value >= 99999999 ? 'Unlimited' : this.convertUnits(value, type, showUnits);
					break;

				case 'sms':
					result = value >= 20000 ? 'Unlimited' : showUnits ? value + ' SMS' : value;
					break;

				case 'mms':
					result = value >= 20000 ? 'Unlimited' : showUnits ? value + ' MMS' : value;
					break;

				case 'sms/mms':
					result = value >= 20000 ? 'Unlimited' : showUnits ? value + ' SMS/MMS' : value;
					break;

				case 'call':
				case 'calls':
					result = showUnits ? value + ' Calls' : value;
					break;

				case 'seconds':
				case 'second':
					result = value >= 1200000 ? 'Unlimited' : this.convertUnits(value, type, showUnits);
					break;

				case 'cents':
				case 'cent':
					result = value >= 500000 ? 'Unlimited' : this.convertUnits(value, type, showUnits);
					break;

				default:
					result = this.convertUnits(value, type, showUnits);
					break;
			}

			return result;

		},

		convertCentsToDollars: function (amount, unit, decimals) {
			amount = typeof amount !== 'undefined' ? amount : 0;
			unit = typeof unit !== 'undefined' ? parseInt(unit, 10) : 100;
			decimals = typeof decimals !== 'undefined' ? decimals : 2;
			if (isNaN(unit)) {
				unit = 0;
				console.warn('unit is reset to 0 instead of being NaN', arguments);
			}

			var result = (amount / unit / 100).toFixed(decimals);

			return '$' + result;
		},

		dayDiff : function (first, second) {
			return Math.round((second - first) / (1000 * 60 * 60 * 24));
		},

		getRemainingDays: function (periodEnd, currentDateTime, isSuffix) {
			var daysLeft = moment(periodEnd).diff(currentDateTime, 'days', true);
			var suffix = isSuffix ? 'day' : '';
			return Math.ceil(daysLeft, 10) + ' ' + (daysLeft === 1) ? suffix : suffix + 's';
		},

		getRemainingDaysString: function (periodEnd, currentDateTime) {

			var isSameMonth = moment(periodEnd).month() === moment(currentDateTime).month();
			var isSameDay = moment(periodEnd).date() === moment(currentDateTime).date();

			var daysLeft = moment(periodEnd).diff(currentDateTime, 'days', true);

			var expiryString = '';

			if (isSameMonth && isSameDay && daysLeft > 0) {
				expiryString = 'Expires Today';
			} else if (daysLeft <= 0) {
				expiryString = 'Expires Today';
			} else {
				var expiryStringPluralSuffix = (daysLeft > 1) ? 's' : '';
				expiryString = [Math.ceil(daysLeft, 10), ' Day', expiryStringPluralSuffix, ' Remaining'].join('');
			}

			return expiryString;
		},
		addDaysFromToday: function (days, format) {
			var today = new Date(), result;
			result = new Date(today.setTime(today.getTime() + days * 86400000));
			return moment(result).format(format) ;
		},

		/**
		 * this will return the string truncated to word boundaries. The max length is the length of the
		 * return value including the trail truncateStringToWord('Wagga Wagga says YES to Optus 4G', 10)
		 * will return 'Wagga Wagga says...'
		 */
		truncateStringToWord: function (longString, maxLength) {

			var trail = '...';

			// adjust the index to truncate the string so the truncated string will not exceed the max char length
			var truncateFrom = maxLength - trail.length;

			if (longString.length <= maxLength) {
				return longString;
			}

			var truncatedString = _.trim(longString).substring(0, truncateFrom + 1);

			// edge case where truncatedString is a whole word that exactly fits maxLength - '...'
			if (truncatedString.match(/\W$/)) {
				return truncatedString.replace(/\W$/, '') + trail;
			}

			// \W matches any non-word character (eg space -,|{} ...)
			return truncatedString.replace(/\W$/, '').split(/(?=\W)/).slice(0, -1).join('') + trail;

		},

		/**
		 * This formats a number using groups.  So 3000 will become 3,000
		 *
		 * @param numberToFormat
		 * @returns {String}
		 */
		formatNumber: function (numberToFormat) {
			return numberToFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		},

		/**
		 * This formats a number to have decimal places. Default is 2 decimal places.
		 *
		 * @param numberToFormat
		 * @param decimals
		 * @returns {String}
		 */
		formatNumberDecimal: function (numberToFormat, decimals) {
			decimals = typeof decimals !== 'undefined' ? decimals : 2;
			return numberToFormat.toFixed(decimals);
		},

		/**
		 * This formats unescapes the html string.
		 *
		 * @param escapedStr
		 * @returns {String}
		 */
		unescapeString: function (escapedStr) {
			return _.unescape(escapedStr);
		},
		formatTimestampToDate: function (timeStamp, format) {
			if (!format) {
				format = 'DD/MM/YYYY';
			}
			return moment.unix(timeStamp).format(format);
		},
		formatTimestampInToDate: function (timeStamp, format) {
			if (!format) {
				format = 'DD/MM/YYYY';
			}
			return moment(timeStamp).format(format);
		},
		/**
		 * Converts the miliseconds date into the readable date
		 *
		 * @param timestamp in miliseconds
		 * @returns {String}
		 */
		convertMilisTimestampToDate: function (timeStamp, format) {
			if (timeStamp) {
				return this.formatTimestampToDate(timeStamp / 1000, format);
			}
			return timeStamp;
		},

		convertMilisTimestampToDateSGP: function (timeStamp, format) {
			if (timeStamp) {
				return this.formatTimestampToDateSGP(timeStamp / 1000, format);
			}
			return timeStamp;
		},

		formatTimestampToDateSGP: function (timeStamp, format) {
			if (!format) {
				format = 'DD/MM/YYYY';
			}
			return moment.unix(timeStamp).utcOffset('+0800').format(format);
		},

		getParameterByName: function (name, decodeURINotRequied) {
			name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
			var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
				results = regex.exec(location.search);
			if (decodeURINotRequied) {
				return results === null ? '' : results[1];
			} else {
				return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
			}
		},

		/**
		 * Get the service properties as per lob and property passed
		 *
		 * @param lob Line of bisuness
		 * @param prop Property to read from configuration
		 * @returns {String}
		 */
		getServicePropLob: function (lob, prop) {
			return ConfigStrings.serviceConfig[lob][prop];
		},

		/**
		 * Get the service properties as per lob and property passed
		 *
		 * @param lob Line of bisuness
		 * @param prop Property to read from configuration
		 * @returns {String}
		 */
		getServicePropLobOptus: function (lob, prop) {
			return ConfigStrings.serviceConfigOptus[lob][prop];
		},
		/**
		 * Get the card brand image URL
		 *
		 * @param brand
		 * @returns {imageURL}
		 */
		getCardBrandImageOptus: function (brand, grayStyle) {
			var imageBaseUrl = ConfigStrings.creditCard.imageBaseUrl;
			var brandString = brand.trim().replace(/\s/g, '-').toLowerCase();
			var imageUrl;
			switch (brandString) {
				//@todo: remove one of the amex cases when backend's response becomes consistent
				case 'amex':
					imageUrl = imageBaseUrl + brandString;
					break;
				case 'american-express':
					imageUrl = imageBaseUrl + 'amex';
					break;
				case 'visa':
					imageUrl = imageBaseUrl + brandString;
					break;
				case 'diners':
					imageUrl = imageBaseUrl + brandString;
					break;
				case 'mastercard':
					imageUrl = imageBaseUrl + brandString;
					break;
				default:
					imageUrl = imageBaseUrl + ConfigStrings.creditCard.defaultImage;
					break;
			}
			// add suffix if needed
			if (grayStyle) {
				imageUrl += '-gray';
			}
			// add extension
			imageUrl += '.png';
			console.log('imageUrl: ' + imageUrl);
			return imageUrl;
		},

		getUsageValueAndUnits: function (value) {
			var day = parseInt(value / (24 * 3600) + 1e-6);
			var hour = parseInt((value - (day * 24 * 3600)) / 3600 + 1e-6);
			var minute = parseInt((value - (day * 24 * 3600) - (hour * 3600)) / 60 + 1e-6);
			var second = parseInt(value - (day * 24 * 3600) - (hour * 3600) - (minute * 60) + 1e-6);
			var unitDay = ' day';
			var unitDays = ' days';
			var unitHour = ' hours';
			var unitMinute = ' mins';
			// 4 Days 23hr 59min 59sec; 1 Day 00hr 00min 01sec
			//if (day > 0 && second > 0)      //gen1 logic
			if (day > 0 && (hour > 0 || minute > 0 || second > 0)) {
				day = day + 1;
				if (day > 1) {
					return day + unitDays;
				} else {
					return day + unitDay;
				}
			}
			// 4 Days 00hr 00min 00sec; 1 Day 00hr 00min 00sec
			if (day > 0 && hour === 0 && minute === 0 && second === 0) {
				if (day > 1) {
					return day + unitDays;
				} else {
					hour = day * 24;
					return hour + unitHour;
				}
			}
			// 0 Day 23hr 59min 59sec; 0 Day 01hr 00min 00sec
			if (day === 0 && hour > 0) {
				return hour + unitHour;
			}
			if (day === 0 && hour === 0 && minute > 0) {
				return minute + unitMinute;
			}
			// 0 Day 00hr 00min 59sec; 0 Day 00hr 00min 01sec
			if (day === 0 && hour === 0 && minute === 0 && second > 0) {
				minute = minute + 1;
				return minute + unitMinute;
			}
			return '0 mins';
		},
		getUsageLimitValue: function (usageLimit) {
			var totalDays = parseInt(Math.ceil(usageLimit / (24 * 3600)));
			var totalSeconds = parseInt(totalDays * 24 * 3600);
			var totalHours = parseInt(totalSeconds / 3600 + 1e-6);
			var minute1 = parseInt((usageLimit - (totalHours * 3600)) / 60 + 1e-6);
			var unitDay1 = ' day';
			var unitDays1 = ' days';
			var unitHour1 = ' hours';
			if (totalDays > 1) {
				return (totalDays + unitDays1);
			} else if (totalDays === 1) {
				return (totalDays + unitDay1);
			} else if (totalDays < 1 && totalHours > 0) {
				return totalHours + unitHour1;
			}
			return minute1 + ' mins';
		},
		getUsageValue: function (value, unit) {
			if (unit) {
				return Number(Math.round((value / unit) + 'e1') + 'e-1');
			} else {
				return Number(Math.round(value + 'e1') + 'e-1');
			}
		},
		getRoundedOffValue: function (value, digits) {
			digits = digits ? digits.toString() : '0';
			return Number(Math.round(value + 'e' + digits) + 'e-' + digits);
		},
		/**
		 * Map the spacing properties received from AEM with appropriate spacing styles
		 *
		 * @param pos Line of bisuness
		 * @param val Property to read from configuration
		 * @returns {String}
		 */
		getSpacingStyle: function (pos, val) {
			return ConfigStrings.spacingConfig[pos][val];
		},

		generatedSessionId: function () {
			function generateDigitPattern() {
				return Math.floor((1 + Math.random()) * 0x10000)
					.toString(16)
					.substring(1);
			}

			return generateDigitPattern() + generateDigitPattern() + '-' + generateDigitPattern() + '-' +
				generateDigitPattern() + '-' + generateDigitPattern() + '-' + generateDigitPattern() +
				generateDigitPattern() + generateDigitPattern();
		},

		replaceUrlPathParam: function (url, params) {
			_.each(params, function (value, key) {
				url = url.replace(':' + key, value);
			});
			return url;
		},

		getSimulatorConifuration: function (method, url, payload) {
			var simulatorConfig = {
				isSimulatorOn: ConfigStrings.simulatorConfig.isSimulatorOn
			};
			if (ConfigStrings.simulatorConfig.isSimulatorOn) {
				var urlList = ConfigStrings.simulatorConfig[method];
				var match = null;
				var simConf = _.find(urlList, function (simConfig, key) {
					var regex = new RegExp(key, 'i');
					match = regex.exec(url);
					return match;
				});
				if (simConf) {
					simulatorConfig = _.merge(simulatorConfig, simConf);
					if (match.length > 1) {
						//there are parameters to get
						simulatorConfig.params = match.splice(1, match.length);
					}
				}
			}
			return simulatorConfig;
		},

		getDeviceID: function () {
			var deferred = $.Deferred();
			var self = this;
			var deviceAgentId = self.getCookie('visitor-agent-id');
			if (deviceAgentId) {
				deferred.resolve(deviceAgentId);
			} else {
				var fpPromise = FingerprintJs.load({ cookies: { 'max-age': '2592000' } })
					.then(function (fp) {
						return fp.get();
					})
					.then(function (result) {
						var deviceId = result.visitorId;
						var date = new Date();
						date.setTime(date.getTime() + 10080 * 60 * 1000); // 7days
						self.setCookie('visitor-agent-id', deviceId, date, '/', '.singtel.com');
						return deviceId;
					})
					.catch(function (e) {
						deferred.reject('error loading fp agentId');
						return e;
					});
				fpPromise.then(function (deviceId) {
					deferred.resolve(deviceId);
				});
			}
			return deferred;
		},

		doAjaxJSONCallWithSimulator: function (method, url, successCallback, errorCallback, payload) {
			var simulaotConfig = this.getSimulatorConifuration(method, url, payload);
			if (simulaotConfig.isSimulatorOn) {
				if (simulaotConfig.url) {
					url = ConfigStrings.simulatorConfig.baseUrl + simulaotConfig.url;
					method = 'GET';
				}
			}
			return this.doAjaxJSONCall(method, url, successCallback, errorCallback, payload);
		},

		doAjaxJSONCall: function (method, url, successCallback, errorCallback, payload) {
			var promise = $.Deferred();
			var xhr = new XMLHttpRequest();
			if (typeof method !== 'undefined' && method !== '' &&
				typeof url !== 'undefined' && url !== ''
			) {
				xhr.open(method, encodeURI(url));
				xhr.setRequestHeader('Content-Type', 'application/json');
				xhr.onload = function () {
					if (xhr.status === 200) {
						var jsonResponse = JSON.parse(xhr.responseText);
						if (successCallback) {
							successCallback(jsonResponse);
						}
						promise.resolve(jsonResponse);
					} else {
						if (errorCallback) {
							errorCallback(xhr);
						}
						promise.reject(xhr);
					}
				};

				if (method === 'PUT' || method === 'POST') {
					xhr.send(JSON.stringify(payload));
				} else {
					xhr.send();
				}

			} else {
				var errMsg = {message: ' method : "' + method + '" or url : "' + url + '" are not valid !'};
				errorCallback(errMsg);
				promise.reject(errMsg);
			}
			return promise;
		},

		getQNomyScriptToInject: function (userInfo, onepassInfo, customerIdType, appointmentType,
			emailId, isCareFlow, authorComments) {

			var enableFieldIds = 'var enableFieldIds = [' +
				'"txtCustomerId"' +
				(!onepassInfo.isWorryFreeLogin ? ',"txtPhoneNumber"' : '') +
				',"txtFullName"' +
				(!onepassInfo.isWorryFreeLogin ? ',"txtEmail"' : '') +
				',"ddCustomerIdType"' + '];';

			var disableFieldIds = 'var disableFieldIds = [' +
				'"txtCustomerId"' +
				(!onepassInfo.isWorryFreeLogin ? ',"txtPhoneNumber"' : '') +
				',"txtFullName"' +
				(!onepassInfo.isWorryFreeLogin ? ',"txtEmail"' : '') +
				',"ddCustomerIdType"' + '];';

			var setDisabledFieldFunction = 'var setDisabledField = function(id, disabled){' +
				'	var field = document.getElementById(id);' +
				'	if(field){ field.disabled = disabled;}' +
				'};';

			var setFieldFunction = 'var setFieldValue = function(id, value){' +
				'	var field = document.getElementById(id);' +
				'	if(field){field.value = value;}' +
				'};';

			var isLoggedIn = 'var isLoggedIn = ' + ((onepassInfo && onepassInfo.nric) ? true : false) +	';';
			return 'try{' +
				'baseUrl = "/Q-FlowWebUI/";' +
				'var cancelBtn = document.getElementById("cancel-btn");' +
				'if(cancelBtn){ cancelBtn.style.display = "none";}' +
				enableFieldIds +
				setFieldFunction +
				disableFieldIds +
				setDisabledFieldFunction +
				isLoggedIn +
				'var commentDoc = document.getElementById("txtComment");' +
				'if (commentDoc) {' +
				'commentDoc.style.display = "none";' +
				'if (' + isCareFlow + ') {' +
				'commentDoc.after("' + authorComments + '");' +
				'} else {' +
				'$( ' + '\'label' + '[for=' + '"txtComment"' + '] ' + '\' ).hide();' +
				'}}' +
				'var setAllFields = function(){' +
				'	setFieldValue("txtCustomerId", "' + onepassInfo.nric + '");' +
				(!onepassInfo.isWorryFreeLogin ? '	setFieldValue("txtPhoneNumber", "' +
				userInfo.contactDetails.phone + '");' : '') +
				'	setFieldValue("txtFullName", "' + userInfo.contactDetails.firstName + ' ' +
				userInfo.contactDetails.lastName + '");' +
				(!onepassInfo.isWorryFreeLogin ? '	setFieldValue("txtEmail", "' + emailId + '");' : '') +
				((appointmentType === 'phone' && isCareFlow) ?
				'setFieldValue("txtComment", "' + authorComments + '");' : '') +
				'	setFieldValue("ddCustomerIdType", ' + customerIdType + ');' +
				'};' +
				'var disableAllFields = function(){' + 'if (isLoggedIn) {' +
					'	for(var i=0;i<disableFieldIds.length;i++){setDisabledField(disableFieldIds[i],true);}' +
					'}' + '};' +
				'var enableAllFields = function(){' +
				'	for(var i=0;i<enableFieldIds.length;i++){setDisabledField(enableFieldIds[i],false);}' +
				'};' +
				'var customerInfoForm = document.getElementById("customerInfo-form");' +
				'if(customerInfoForm){' +
				'	customerInfoForm.onsubmit=function(){' +
				'		enableAllFields();' +
				'		var $customerInfo = $("#customerInfo-form");' +
				'		if($customerInfo && $customerInfo.length > 0){ ' +
				'			if(!$customerInfo.valid()){disableAllFields();}' +
				'		}' +
				'	};' +
				'}' +
				'var doneBtn = document.getElementsByClassName("btn-default");' +
				'if(doneBtn && doneBtn[0] && (doneBtn[0].text === "Done")){ doneBtn[0].style.display = "none";}' +
				'var appContainer = document.getElementsByClassName("appointment-container");' +
				'if(appContainer && appContainer[0]){ ' +
				'	var appContainerLinks = appContainer[0].getElementsByTagName("a");' +
				'	for(var i=0;i<appContainerLinks.length;i++){appContainerLinks[i].style.display = "none";}' +
				'}' +
				'setAllFields();' +
				'disableAllFields();' +
				'var errorMessages = document.getElementsByClassName("field-validation-error");' +
				'for(var j=0;j<errorMessages.length;j++){' +
				'	if((errorMessages[j].innerHTML.indexOf("existing appointment") !== -1) && ' +
				'	(errorMessages[j].innerHTML.indexOf("You can manage it via My Account.") === -1)){' +
				'		errorMessages[j].innerHTML += ' +
				'			"You can manage it via My Account.";' +
				'	}' +
				'}' +
				'}catch(e){console.log("Something went wrong : ",e);}';

		},
		/**
		 * /*
		 * Calculate distance (in km) between two points specified by
		 * latitude/longitude with Haversine formula
		 *
		 * Latitude and longitude have to be in degree,
		 * they will be converted in radian by this function.
		 *
		 * @param loc1 (Object {lat:(number), lon:(number)})
		 * @param loc2 (Object {lat:(number), lon:(number)})
		 * @returns {number}
		 */
		latLongDist: function (loc1, loc2) {
			var p1 = {}, p2 = {};
			p1.lat = loc1.lat * Math.PI / 180;
			p1.lon = loc1.lon * Math.PI / 180;
			p2.lat = loc2.lat * Math.PI / 180;
			p2.lon = loc2.lon * Math.PI / 180;
			var R = 6371; // earth's mean radius in km
			var dLat = p2.lat - p1.lat;
			var dLong = p2.lon - p1.lon;

			var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
				Math.cos(p1.lat) * Math.cos(p2.lat) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
			var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			var d = R * c;

			return d;
		},
		/**
		 * This function formats the Optus account id in specific format
		 *
		 * @param faId the account Id to be formatted
		 * @returns {String} formatted faid in the format '111 111 1111'
		 */
		formatAccountId: function (faId) {
			if (faId) {
				this.optusAccountNumberPadding(faId);
				faId = faId.substr(0, 3) + ' ' + faId.substr(3, 3) + ' ' + faId.substr(6);
				return faId;
			}
		},

		// converts the string into snake case using lodash
		snakeCase: function (str) {
			return _.snakeCase(str);
		},

		/*
		 * This function formats the Optus account id in specific format for Dashboard
		 *
		 * @param faId the account Id to be formatted
		 * @returns {String} formatted faid in the format '111 111 1111'
		 */
		formatAccountIdDashboard: function (faId) {
			if (faId) {
				faId = this.optusAccountNumberPadding(faId);
				faId = faId.substr(0, 4) + ' ' + faId.substr(4, 4) + ' ' + faId.substr(8);
				return faId;
			}
		},
		/**
		 * This function appends a prefix '62' to the Account Number to make it 11 digit
		 *
		 * @param faId the account Id to be formatted
		 * @returns {String} formatted faid in the format '621111111111'
		 */
		optusAccountNumberPadding: function (value, limit) {
			value = value + '';
			if (value.length === 9) {
				value = '62' + value;
			}
			return value;
		},
		/**
		 * This function formats the  number if lob is mobile
		 *
		 * @param number the mobile number to be formatted
		 * @param lob line of bussiness of number
		 * @returns {String} formatted number 1234 1234
		 */
		formatMobileNumberWithSpace: function (number, lob) {
			if (_.indexOf(['WS', 'FV', 'MBB', 'MOB', 'Mobile'], lob) > -1) {
				number = number.substr(0, 4) + ' ' + number.substr(4);
				return number;
			} else {
				return number;
			}
		},
		/**
		 * This function formats the credit card expiry year to 2 digit for paybill
		 *
		 * @param year Credit card expiry year to be formatted
		 * @returns {String} formatted year last 2 digit '11'
		 */
		formatCCExpiryYear: function (year) {
			if (year) {
				year = year.substr(2);
				return year;
			} else {
				return moment().format('YY');
			}
		},
		/**
		 * This function returns the password strength
		 *
		 * @param password string
		 * @returns {String} either 'weak' or 'good' or 'strong' (based on ux-input-box component)
		 */
		checkPasswordStrength: function (pwString) {
			var passwordStrength;
			if (pwString.length < 6) {
				passwordStrength = 'weak';
			} else {
				var strength = 0;

				strength += /[A-Z]+/.test(pwString) ? 1 : 0;
				strength += /[a-z]+/.test(pwString) ? 1 : 0;
				strength += /[0-9]+/.test(pwString) ? 1 : 0;
				strength += /[\W]+/.test(pwString) ? 1 : 0;

				switch (strength) {
					case 3:
						passwordStrength = 'good';
						break;
					case 4:
						passwordStrength = 'strong';
						break;
					default:
						passwordStrength = 'weak';
						break;
				}
			}
			return passwordStrength;
		},
		/**
		 * This function returns the full order status
		 *
		 * @param short status (ex: CA) string
		 * @returns {String} full order status
		 */
		getFullOrderStatus: function (status) {
			var orderStatus = {
				CA: 'Cancelled',
				DC: 'Discontinued',
				DO: 'Closed',
				EP: 'Expired',
				ER: 'In Error',
				EX: 'Open',
				FU: 'Future',
				IN: 'Initial',
				RE: 'Reject',
				SB: 'Submitted',
				SR: 'Submit Requested',
				TC: 'To be Cancelled'
			};
			return orderStatus[status];
		},

		/**
		 * This function returns the password strength
		 *
		 * @param password string
		 * @returns {String} either 'weak' or 'good' or 'strong' (based on ux-input-box component)
		 */
		getPgMessage: function (responseCode) {
			return ConfigStrings.constants.PG_MESSAGE[responseCode];
		},

		splitString: function (string, splitChar, index) {
			return string.split(splitChar)[index];
		},

		getSuspendMessage: function (value) {
			return ConfigStrings.alertMessages[value];
		},

		getEasyMobiletitle: function () {
			return ConfigStrings.constants.TITLE.EASY_MOBILE;
		},

		onImageLoadError: function (e) {
			e.node.classList = 'hide';
			e.node.style.display = 'none';
			console.warn('Unable to load image', e);
			return e;
		},

		/*
		 * Generate unique id
		 * rfc4122 version 4 compliant solution
		 * http://stackoverflow.com/a/2117523
		 * */
		getUid: function (prefix) {
			prefix = prefix ? prefix + '-' : '';
			return prefix + 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					/* jshint ignore:start */
					var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
					return v.toString(16);
					/* jshint ignore:end */
				});
		},
		getHomeLineUid: function () {
			var uid = this.getUid();
			return uid.substring(0, 20);
		},

		/**
		 * Add/Update querystring parameter
		 */
		replaceQueryStringParameter: function (url, param, value) {
			var re = new RegExp('[\\?&]' + param + '=([^&#]*)'),
				match = re.exec(url),
				delimiter,
				newString;

			if (match === null) {
				// append new param
				var hasQuestionMark = /\?/.test(url);
				delimiter = hasQuestionMark ? '&' : '?';
				newString = url + delimiter + param + '=' + value;
			} else {
				delimiter = match[0].charAt(0);
				newString = url.replace(re, delimiter + param + '=' + value);
			}

			return newString;
		},

		getQueryParamsObj: function (paramName) {
			var queryObj = _.object(_.compact(_.map(location.search.slice(1).split('&'),
				function (item) {
					if (item) {
						return item.split('=');
					}
				}))) || {};
			return paramName ? queryObj[paramName] : queryObj;
		},

		getFullHost: function () {
			var fullHost = location.protocol + '//' +
				location.hostname + (location.port ? ':' +
				location.port : '');
			return fullHost;
		},

		/**
		 * Get the service properties as per lob and property passed
		 *
		 * @param lob Line of business
		 * @param prop Property to read from configuration
		 * @returns {String}
		 */
		isFileMatch: function (fileTypes, fileToUpload) {
			var isFileTypeValid = _.filter(fileTypes, function (obj) {
				return fileToUpload.type.match(obj);
			});
			if (isFileTypeValid && isFileTypeValid.length > 0) {
				isFileTypeValid = true;
			} else {
				isFileTypeValid = false;
			}
			return isFileTypeValid;
		},

		getURLParameter: function (name) {
			return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)')
					.exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
		},
		/**
		 * Get the cardnumber which is passed
		 *
		 * @param cardNumber creditcard number
		 * @returns {String}
		 */
		setCardNumber: function (cardNumber) {
			var str = cardNumber.substring(12);
			return 'XXXX XXXX XXXX ' + str;
		},

		downloadBase64: function (filename, text) {
			var pom = document.createElement('a');
			pom.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
			pom.setAttribute('download', filename);

			if (document.createEvent) {
				var event = document.createEvent('MouseEvents');
				event.initEvent('click', true, true);
				pom.dispatchEvent(event);
			} else {
				pom.click();
			}
		},

		getBackgroundImage: function (srcSet) {
			var screenSize = window.innerWidth,
				bgImage;

			if (!srcSet) {
				return false;
			}

			if (screenSize < ConfigStrings.mediaBreakpoints.small) {
				bgImage = srcSet.small;
			} else if (screenSize < ConfigStrings.mediaBreakpoints.medium) {
				bgImage = srcSet.medium;
			} else if (screenSize < ConfigStrings.mediaBreakpoints.large) {
				bgImage = srcSet.large;
			} else {
				bgImage = srcSet.original;
			}

			return bgImage;
		},
		getBalanceAmount: function (amount, showDecimals) {
			if (typeof showDecimals !== 'undefined' && !isNaN(showDecimals)) {
				return this.convertUnits(amount, 'showdecimals', showDecimals);
			} else {
				return Math.max(amount, 0);
			}
		},
		closeAllModal: function (ractiveWidget) {
			var modals = ractiveWidget.findAllComponents('ux-modal');
			if (modals && modals.length) {
				modals.forEach(function (modal) {
					//modal.set('displayState', false);
					modal.set('displayState', false);
				});
			}
		},
		toggleModal: function (ractiveWidget, modalId, state) {
			return this.setModalProperty(ractiveWidget, modalId, 'displayState', state);
		},
		setModalProperty: function (ractiveWidget, modalId, modalProperty, value) {
			var modal = this.findModal(ractiveWidget, modalId);
			if (modal) {
				modal.set(modalProperty, value);
			}
			return modal;
		},
		findModal: function (parentComponent, modalId) {
			var modals = parentComponent.findAllComponents('ux-modal');
			var modal = modals.filter(function (component) {
				return modalId === component.get('modalId');
			});
			if (modal && modal.length > 1) {
				var visibleModal = _.find(modal, function (item) {
					return item.get('displayState');
				});
				return visibleModal ? visibleModal : modal[0];
			} else {
				return modal[0];
			}
		},

		isSingtelWsSub: function (subType) {
			var wsSubTypes = ['WS', 'Mobile', 'MBB', 'MOB'];
			return wsSubTypes.indexOf(subType) > -1;
		},
		isMobile: function () {
			var isMobile = false; //initiate as false
			// device detection
			var regex1 = '(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|' +
				'iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|' +
				'palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|' +
				'vodafone|wap|windows (ce|phone)|xda|xiino';
			var regex2 = '1207|6310|6590|3gso|' +
				'4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|' +
				'ar(ch|go)|as(te|us) |attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|' +
				'bw\-(n|u)|c55\/|capi|ccwa |cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|' +
				'devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|' +
				'fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|' +
				'hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|' +
				'ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|' +
				'kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|' +
				'mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|' +
				'mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|' +
				'nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|' +
				'pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|' +
				'r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|' +
				'nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|' +
				'sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|' +
				'ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|' +
				'vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|' +
				'wonu|x700|yas\-|your|zeto|zte\-';

			if (new RegExp(regex1, 'i').test(navigator.userAgent) ||
				new RegExp(regex2, 'i').test(navigator.userAgent.substr(0, 4))) {
				isMobile = true;
			}
			return isMobile;
		},
		getMonth : function (month) {
			var isNumber = isNaN(month);
			if (isNumber) {
				var month = _.find(ConfigStrings.date.months, function (mon) {
					return mon.title === month;
				});
				return parseInt(month.value);
			} else {
				return parseInt(month, 10);
			}
		},

		/**
		 * Get the icon based on the serviceType
		 */
		getIconType: function (serviceType) {
			var iconType;

			_.each(ConfigStrings.serviceTypeMapping, function (types, subType) {
				_.each(types, function (type) {
					if (type.toUpperCase() === serviceType.toUpperCase()) {
						iconType = subType;
					}
				});
			});

			return ConfigStrings.icons[iconType];
		},
		formatCharacteristicValue: function (characteristic) {
			var value = characteristic.value;
			if (value) {
				switch (characteristic.productSpecCharacteristic.valueBasicType) {
					case 'DATE':
						value = this.convertMilisTimestampToDate(value);
						break;
					case 'INTEGER':
						value = parseFloat(value, 10);
						break;
				}
				switch (characteristic.displayInformation.displayFormat) {
					case 'DROPDOWN_LISTBOX':
						var validValues = characteristic.productSpecCharacteristic.values;
						var validValue = _.find(validValues, function (option) {
							return option.value === value;
						});
						if (validValue) {
							value = validValue.valueForDisplay;
						}
						break;
				}
			}
			return value;
		},
		getTimeFormatedString: function (value, type) {
			var formattedString;
			value = parseInt(value);
			switch (type.toLowerCase()) {
				case 'min':
				case 'minutes':
					formattedString = (new Date((value * 60) * 1000)).toUTCString()
						.match(/(\d\d:\d\d:\d\d)/)[0];
					formattedString = formattedString.split(':');
					formattedString = formattedString[0] + 'hr:' + formattedString[1] +
						'mm:' + formattedString[2] + 'ss';
					break;
				default:
					formattedString = value + '' + type;
					break;
			}
			return formattedString;
		},
		/*
		 this function is suppose to convert the Mm in to GB if it is grater than 1GB
		 input data in mb
		 output converted data with unit
		 */
		convertIntoGB: function (data, roundUp) {
			data = Math.abs(data);
			var convertedString;
			if (data >= 1024) {
				var value = (data / 1024);
				convertedString = this.convertRoundUpDownValue(value, roundUp) + ' GB ';
			} else {
				convertedString = this.roundUpMbUsage(data, roundUp) + ' MB ';
			}
			return convertedString;
		},
		/*
		 this function is suppose to round up the MB usage
		 input data in mb
		 */
		roundUpMbUsage: function (data, roundUp) {
			if (data <= 0 || !roundUp) {
				return parseInt(data);
			}
			if (data < 1) {
				data = 1;
			} else {
				data = Math.ceil(data);
			}
			return data;
		},
		/*
		Rounding up and down the value
		ex 7.01 will be 7.1 in case of rounding up
		7.01 will be 7 in case of rounding down
		*/
		convertRoundUpDownValue: function (num, roundUp) {
			var newNumber = num;
			if (roundUp) {
				num = num.toString();
				num = num.split('.');
				var decimal = (num[1]) || '';
				if (decimal && decimal.length > 1) {
					var valueAfterDecimal = parseInt(decimal[0]) + 1;
					if (valueAfterDecimal === 10) {
						num[0] = parseInt(num[0]) + 1;
						valueAfterDecimal = 0;
					}
					newNumber = num[0] + '.' + valueAfterDecimal;
				}
				newNumber = Math.floor(newNumber * 10) / 10;
			} else {
				num = num.toString();
				num = num.split('.');
				var decimal = (num[1]) || '';
				if (decimal && decimal[0] === 0) {
					newNumber = num[0];
				}
				newNumber = Math.floor(newNumber * 10) / 10;
			}
			return newNumber;
		},
		convertIntoGB_for_Prepaid: function (data) {
			data = parseInt(data);
			var convertedString;
			if (data < 1000) {
				convertedString = (data) + ' KB left';
			} else if (data > 1000 && data <= 1000000) {
				convertedString = (data / 1024).toFixed(2) + ' MB left';
			} else {
				convertedString = (data).toFixed(2) + ' GB left ';
			}
			return convertedString;
		},
		defieneUnit: function (unit) {
			//need to update this according to new implementation of prepaid for 1088 defect
			switch (unit) {
				case 'Data':
					return '';
				case 'Minutes':
					return '';
				case 'Text':
					return '';
				default:
					return '';
			}
		},

		testConnection: function (success, error) {
			$.ajax({
				url: window.location.href,
				cache: false,
				async: false,
				error: function (XMLHttpRequest, textStatus, errorThrown) {
					error();
				},
				success: function (html) {
					success();
				}
			});
		},

		configStringMap: {
			errorIcon: ConfigStrings.errors.errorIcon,
			errorTitle: {
				network: ConfigStrings.errors.network.errorTitle,
				backend: ConfigStrings.errors.backend.errorTitle,
				serverError: ConfigStrings.errors.serverError.errorTitle
			},
			errorMessage: {
				network: ConfigStrings.errors.network.errorMessage,
				backend: ConfigStrings.errors.backend.errorMessage,
				serverError: ConfigStrings.errors.serverError.errorMessage
			},
			errorModalButton: ConfigStrings.errors.errorModalButton,
			redirectMessage: ConfigStrings.errors.redirectMessage,
			url: ConfigStrings.errors.url
		},

		getErrorString: function (property, type) {
			var self = this;
			if (!self.configStringMap[property]) {
				return '';
			}
			if (type) {
				var typeSpecificString = self.configStringMap[property][type];
				if (typeSpecificString) {
					return typeSpecificString;
				} else {
					return self.configStringMap[property];
				}
			} else {
				return self.configStringMap[property];
			}
		},
		/**
		 * Get the service properties as per lob and property passed
		 *
		 * @param technology
		 * @param prop Property to read from configuration
		 * @returns {String}
		 */
		getTechnologyConfig: function (technology, prop) {
			return ConfigStrings.technologyConfig[technology][prop];
		},
		/**
		 * Fire the custome event to expose REST response
		 *
		 * @param eventName
		 * @param ractiveComponent
		 */
		fireCustomEventForSignal: function (eventName, ractiveComponent, dataToExpose) {
			var originalEve = new Event('dummyEvent');
			ractiveComponent.fire(eventName, Object.assign({}, {
				component: ractiveComponent,
				context: dataToExpose,
				original: originalEve,
				name: eventName
			}));
		},
		isAccessAllowedForContact: function (componentName) {
			var shortRoleKey;
			var contactRoleKey = 'businesswidget/repository_l9_common/' +
			'common/viewmodel/contextTopics/ImplUserTypeTopicViewModel';
			var userContactRoleName = this.getValueFromSessionStorage(contactRoleKey);
			switch (userContactRoleName) {
				case 'Account Holder':
					shortRoleKey = 'CU';
					break;
				case 'Account Contact':
					shortRoleKey = 'CA';
					break;
				case 'Billing Contact (P)':
					shortRoleKey = 'BA';
					break;
				case 'Billing Contact (S)':
					shortRoleKey = 'BA';
					break;
				case 'Service Contact':
					shortRoleKey = 'SL';
					break;
				case 'Service Authentication':
					shortRoleKey = 'SA';
					break;
				default:
					return false;
			}
			return ConfigStrings.rbaLinksConfig[componentName][shortRoleKey];
		},
		getCookieByKey: function (sKey) {
			if (!sKey) {
				return null;
			}
			return decodeURIComponent(document.cookie.replace(
				new RegExp('(?:(?:^|.*;)\\s*' +
					encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') +
					'\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
		},

		modifyConfigUrl: function (url) {
			var currentUrl = window.location.href;
			//remove /content/singtel/en & .html for publisher instance
			if (currentUrl.indexOf('/content/singtel/en') === -1) {
				url = url.replace('/content/singtel/en', '');
				url = url.replace('.html', '');
			}
			return url;
		},
		addBaseContentUrl: function (url) {
			//add /content/singte'/en for all pages accessed via AJAX on publisher instance
			if (url.indexOf('/content/singtel/en') === -1) {
				url = '/content/singtel/en' + url;
			}
			return url;
		},
		inIframe: function () {
			try {
				return window.self !== window.top;
			} catch (e) {
				return true;
			}
		},
		parseParamsFromUrl: function () {
			var params = {};
			var parts = window.location.search.substr(1).split('\x26');
			for (var i = 0; i < parts.length; i++) {
				var keyValuePair = parts[i].split('=');
				var key = decodeURIComponent(keyValuePair[0]);
				params[key] = keyValuePair[1] ?
					decodeURIComponent(keyValuePair[1].replace(/\+/g, ' ')) :
					keyValuePair[1];
			}
			return params;
		},
		removeParam: function (url, parameter) {
			//prefer to use l.search if you have a location/link object
			var urlparts = url.split('?');
			if (urlparts.length >= 2) {
				var prefix = encodeURIComponent(parameter) + '=';
				var pars = urlparts[1].split(/[&;]/g);
				//reverse iteration as may be destructive
				for (var i = pars.length; i-- > 0;) {
					//idiom for string.startsWith
					if (pars[i].lastIndexOf(prefix, 0) !== -1) {
						pars.splice(i, 1);
					}
				}
				url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
				return url;
			} else {
				return url;
			}
		},
		disableSunday: function (date) {
			var day = date.getDay();
			return day === 0;
		},
		validateNRIC: function (str) {
			if (str.length !== 9) {
				return false;
			}

			str = str.toUpperCase();

			var i,
			icArray = [];
			for (i = 0; i < 9; i++) {
				icArray[i] = str.charAt(i);
			}

			icArray[1] = parseInt(icArray[1], 10) * 2;
			icArray[2] = parseInt(icArray[2], 10) * 7;
			icArray[3] = parseInt(icArray[3], 10) * 6;
			icArray[4] = parseInt(icArray[4], 10) * 5;
			icArray[5] = parseInt(icArray[5], 10) * 4;
			icArray[6] = parseInt(icArray[6], 10) * 3;
			icArray[7] = parseInt(icArray[7], 10) * 2;

			var weight = 0;
			for (i = 1; i < 8; i++) {
				weight += icArray[i];
			}

			var offset = (icArray[0] === 'T' || icArray[0] === 'G') ? 4 : icArray[0] === 'M' ? 3 : 0;
			var temp = (offset + weight) % 11;

			var st = ['J','Z','I','H','G','F','E','D','C','B','A'];
			var fg = ['X','W','U','T','R','Q','P','N','M','L','K'];

			var theAlpha;
			if (icArray[0] === 'S' || icArray[0] === 'T') {
				theAlpha = st[temp];
			} else if (icArray[0] === 'F' || icArray[0] === 'G' || icArray[0] === 'M') {
				theAlpha = fg[temp];
			}

			return (icArray[8] === theAlpha);
		},
		getChargeFrequency: function (chargeFrequency, monthlyText, dailyText) {
			var frequncy = monthlyText || 'Monthly';
			if (chargeFrequency) {
				if (chargeFrequency.frequencyUnit === 'MONTH') {
					frequncy = monthlyText || 'Monthly';
				} else if (chargeFrequency.frequencyUnit === 'DAY') {
					frequncy = dailyText || 'Daily';
				}
			}
			return frequncy;
		},
		addressMapper: function (address) {
			var newAddress = {
				apartment: address.room,
				blockOrHouseNum: address.houseNumber || address.blockOrHouseNum,
				blockNumbers: address.room,
				buildingName: address.buildingName ? address.buildingName : '',
				floorNo: address.floor,
				postCode : address.postCode ? address.postCode : address.postcode,
				unitNo: address.unitNumber,
				streetName: address.streetName,
				floorOptions: address.floorOptions,
				floorAndUnitAddressMap: address.floorAndUnitAddressMap
			};
			return newAddress;
		},
		addressToString: function (address, type) {
			var addressStr = '';
			switch (type) {
				case 'timeline':
					addressStr += address.buildingName ? address.buildingName + ', ' : '';
					addressStr += address.blockOrHouseNum ? address.blockOrHouseNum + ' ' : '';
					addressStr += address.streetName ? address.streetName + ', ' : '';
					addressStr += address.unitNumber ? address.unitNumber + ', ' : '';
					addressStr += address.city ? address.city + ' ' : 'SINGAPORE ';
					addressStr += address.postcode ? address.postcode : '';
					break;
			}
			return addressStr;
		},
		isBrowserIE: function (includeEdge) {
			var ua = window.navigator.userAgent;
			var msie = ua.indexOf('MSIE ');
			if (msie > 0) {
				// IE 10 or older => return version number
				return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
			}
			var trident = ua.indexOf('Trident/');
			if (trident > 0) {
				// IE 11 => return version number
				var rv = ua.indexOf('rv:');
				return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
			}

			if (includeEdge) {
				var edge = ua.indexOf('Edge/');
				if (edge > 0) {
					// Edge (IE 12+) => return version number
					return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
				}
			}
			// other browser
			return false;
		},
		/**
		 * Detect browser and platform specifications.
		 * @return {Object} object with keys indicating the browser and platform types
		 *
		 * Implementation is a trimmed down version of
		 * @ref: https://github.com/lancedikson/bowser
		 */
		browser: browser,// jshint ignore:line
		getCookieVal: function (offset) {
			var endstr = document.cookie.indexOf (';', offset);
			if (endstr === -1) {
				endstr = document.cookie.length;
			}
			return decodeURI(document.cookie.substring(offset, endstr));
		},
		getCookie: function (name) {
			var arg = name + '=';
			var alen = arg.length;
			var clen = document.cookie.length;
			var i = 0;
			while (i < clen) {
				var j = i + alen;
				if (document.cookie.substring(i, j) === arg) {
					return this.getCookieVal (j);
				}
				i = document.cookie.indexOf(' ', i) + 1;
				if (i === 0) {
					break;
				}
			}
			return null;
		},
		deleteCookie: function (name) {
			if (this.getCookie(name)) {
				document.cookie = name + '=;' +
					' expires=Thu, 01-Jan-70 00:00:01 GMT;' +
					' path=/;' +
					' domain=' + window.location.host + ';' +
					' secure=;';
			}
		},
		setCookie: function (name,value,expires,path,domain,secure) {
			document.cookie = name + '=' + encodeURI (value) +
				((expires) ? '; expires=' + expires.toGMTString() : '') +
				((path) ? '; path=' + path : '') +
				((domain) ? '; domain=' + domain : '') +
				((secure) ? '; secure' : '');
		},
		getHomeLineSession: function (ractiveInstance, successCallback, errorCallback, token) {
			var payload = {
				'consumeSessionTransferTokenReq': {
					'tokenId': token || this.getHomeLineContext('tokenId'),
					'appName': this.getHomeLineContext('appName') || ConfigStrings.homeLineTest.appName,
					'requestId': this.getHomeLineUid() || '1229929922'
				}
			};
			this.doAjaxJSONCallWithSimulator('POST', ConfigStrings.homeLineTest.url.consumeSessionTransferToken,
				function (response) {
					if (response && response.consumeSessionTransferTokenResp &&
						response.consumeSessionTransferTokenResp.statusCode === '00') {
						response = JSON.parse(response.consumeSessionTransferTokenResp.payload);
						if (response && response.appName) {
							sessionStorage.setItem('appName', response.appName);
						}
						if (response && response.inContract) {
							sessionStorage.setItem('inContract', response.inContract);
						}
						if (response && response.backToHome) {
							sessionStorage.setItem('backToHome', response.backToHome);
						}
						successCallback(response).then(function () {
							ractiveInstance.set('inProcess', false);
						}, function () {
							ractiveInstance.set('inProcess', false);
						});
					}
				}, function () {
					errorCallback();
				}, payload);
		},
		getHomeLinePageRedirectionUrl: function (url, callBack) {
			this.doAjaxJSONCall('GET', url, function (response) {
				callBack(response);
			}, function () {
				callBack();
			});
		},
		setHomeLineContext: function (key, value) {
			sessionStorage.setItem(key, value);
		},
		getHomeLineContext: function (key) {
			return sessionStorage.getItem(key);
		},
		deleteHomelineContext: function (key) {
			sessionStorage.removeItem(key);
		},
		autoSelectOne: function (domClass) {
			var domElements = document.querySelectorAll(domClass);
			if (domElements.length === 1) {
				domElements[0].click();
			}
		},
		checkLoginStatus: function (ractiveWidget) {
			var response = {
				isLoggedIn: false,
				nickname: ''
			};
			var agentId = this.getCookie('visitor-agent-id');
			if (!agentId) {
				this.getDeviceID();
			}
			var promise = $.Deferred();
			var cookieFromLandingWeb = this.getCookie(ConfigStrings.uiamAcessToken);
			if (cookieFromLandingWeb) {
				response.isLoggedIn = true;
				if (ractiveWidget) {
					ractiveWidget.set('isLoggedIn', true);
				}
				promise.resolve(response);
			}else {
				if (ractiveWidget) {
					ractiveWidget.set('isLoggedIn', false);
				}
				response.isLoggedIn = false;
				promise.resolve(response);
			}
			return promise;
		},
		//We need to fetch Login URL from AEM and please modify in ConfigStrings.
		redirectUiamLoginPage : function (loginURL, targetURL, ractiveWidget) {
			loginURL = loginURL || ConfigStrings.defaultLandingURL;
			if (!targetURL) {
				targetURL = this.getFullHost() + ConfigStrings.defaultLandingURL;
			}
			if (loginURL.indexOf('targetUrl') > -1) {
				targetURL = null;
			}
			var rewriteloginURL = loginURL;
			if (targetURL) {
				var delimiter = '?';
				if (loginURL.indexOf('?') > -1) {
					delimiter = '&';
				}
				if (targetURL.indexOf('https://') === -1 && targetURL.indexOf('https%3A%2F%2F') === -1) {
					targetURL = this.getFullHost() + targetURL;
				}
				rewriteloginURL = loginURL + delimiter + 'targetUrl=' + targetURL;
			}
			window.location.href = this.modifyConfigUrl(rewriteloginURL);
		},
		fireGenericEvent: function (ractiveWidget, eventName, failureReason) {
			var failureData = {};
			var orderContext = ractiveWidget.get('orderContext');
			if (orderContext && orderContext.orderId) {
				failureData.orderId = orderContext.orderId;
			}
			var deviceIdAndPlanContext = ractiveWidget.get('deviceIdAndPlanId');
			if (deviceIdAndPlanContext && deviceIdAndPlanContext.planId) {
				failureData.planId = deviceIdAndPlanContext.planId;
			}
			var miniCartSave = ractiveWidget.get('miniCartSave');
			if (miniCartSave && miniCartSave.id) {
				failureData.flowType = miniCartSave.id;
			}
			var contractDetails = ractiveWidget.get('contractDetails');
			if (contractDetails && contractDetails.selectedRecontractDetails) {
				failureData.subscriptionId = contractDetails.selectedRecontractDetails.subscriptionId;
			}
			var selectNumber = ractiveWidget.get('selectNumber');
			if (selectNumber && selectNumber.selectedExistingLine) {
				failureData.subscriptionId = selectNumber.selectedExistingLine.subscriberId;
			}

			failureData.failureReason = failureReason;
			ractiveWidget.fire(eventName, {
				name: eventName,
				data: failureData
			});
		},
		setCartLpData: function (ractiveWidget, type, orderData) {
			var cartItems = '';
			var products = [];
			if (orderData.mobile && orderData.mobile.length > 0) {
				_.each(orderData.mobile, function (mobile) {
					var cartItems = '';
					var planDetails = mobile.planDetails;
					if (planDetails && planDetails.length > 0) {
						cartItems = cartItems.concat(planDetails[0].planName, ';');
					}
					if (!mobile.isfreeMbb) {
						var deviceData = mobile.deviceDetails;
						if (deviceData && deviceData.length > 0) {
							deviceData = deviceData[0];
							cartItems = cartItems.concat(deviceData.deviceName, ' ',
								deviceData.colour, ' ', deviceData.deviceSize, ';');
						}
					}
					cartItems = cartItems.concat(mobile.subscriptionId, ';');
					_.each(mobile.addons, function (addons) {
						cartItems = cartItems.concat(addons.name, ';');
					});
					products.push({
						product: {
							name: cartItems
						}
					});
				});
			}
			this.setCartFlowData(cartItems, products, orderData.tv);
			this.setCartFlowData(cartItems, products, orderData.bundle);
			this.setCartFlowData(cartItems, products, orderData.fv);
			var total = 0;
			if (orderData.recurringPrice.finalAmountIncludingTax) {
				total = 24 * (orderData.recurringPrice.finalAmountIncludingTax);
			}
			if (orderData.oneTimePrice.finalAmountIncludingTax > 0) {
				total = total + orderData.oneTimePrice.finalAmountIncludingTax;
			}
			if (orderData.checkoutPrice.finalAmountIncludingTax > 0) {
				total = total + orderData.checkoutPrice.finalAmountIncludingTax;
			}
			var productData = {
				type: type,
				total: total,
				products: products
			};
			ractiveWidget.set('lpData', productData);
		},

		setCartFlowData: function (cartItems, products, orderData) {
			if (orderData && orderData.length > 0) {
				var cartItems = '';
				_.each(orderData, function (item) {
					var planName = item.categoryName;
					if (item.isBundle) {
						planName = (item.broadBandPlanDetails) ? (item.broadBandPlanDetails.serviceType) : planName;
					}
					if (item.lineofBusiness === 'TV' || item.lob === 'tv') {
						planName = (item.tvPlanDetails) ? (item.tvPlanDetails.serviceType) : planName;
					}
					cartItems = cartItems.concat(planName, ';');
					cartItems = cartItems.concat(item.subscriptionId, ';');
					_.each(item.addons, function (addons) {
						cartItems = cartItems.concat(addons.name, ';');
					});
					if (item.topup && item.topup.length > 0) {
						_.each(item.topup, function (data) {
							cartItems = cartItems.concat(data.name, ';');
						});
					}
					if (item.premiumAddons && item.premiumAddons.length > 0) {
						_.each(item.premiumAddons, function (data) {
							cartItems = cartItems.concat(data.name, ';');
						});
					}
					products.push({
						product: {
							name: cartItems
						}
					});
				});
			}
		},
		validateContactName: function (errorMessage, keypath, self) {
			var rules = {};
			rules[keypath] = {
				maxlength: {
					param: 50,
					message: errorMessage.maxLengthError
				},
				validUserName: errorMessage.validUserName,
				required: errorMessage.required
			};
			self.nameValidation = new RactiveValidate(self,rules);
			self.nameValidation.cwd = '';
			return self.nameValidation.validate(self.nameValidation);
		},

		validateContactNum: function (errorMessage, keypath, self) {
			var rules = {};
			rules[keypath] = {
				validMobileNumber: errorMessage.inValidMobile,
				minlength: {
					param: 8,
					message: errorMessage.minLengthError
				},
				maxlength: {
					param: 8,
					message: errorMessage.maxLengthError
				},
				digits: errorMessage.digits,
				required: errorMessage.required
			};
			self.contactValidation = new RactiveValidate(self,rules);
			self.contactValidation.cwd = '';
			return self.contactValidation.validate(self.contactValidation);
		},

		validateEmailId: function (errorMessage, keypath, self) {
			var rules = {};
			rules[keypath] = {
				emailId: errorMessage.inValidEmail,
				required: errorMessage.required
			};
			self.emailValidation = new RactiveValidate(self,rules);
			self.emailValidation.cwd = '';
			return self.emailValidation.validate(self.emailValidation);
		},

		validatePostCode: function (errorMessage, keypath, self) {
			var rules = {};
			rules[keypath] = {
				minlength: {
					param: 6,
					message: errorMessage.minLengthError
				},
				maxlength: {
					param: 6,
					message: errorMessage.maxLengthError
				},
				digits: errorMessage.digits,
				required: errorMessage.required
			};
			self.postcodeValidation = new RactiveValidate(self,rules);
			self.postcodeValidation.cwd = '';
			return self.postcodeValidation.validate(self.postcodeValidation);
		},
		handleRemovalOfAddon: function (orderData, aemData) {
			var self = this;
			_.each(orderData, function (orderItem) {
				if (orderItem.addons && orderItem.addons.length > 0) {
					self.checkForAllAddons(orderItem.addons, aemData);
				}
			});
		},
		checkForAllAddons: function (addonItems, aemData) {
			var self = this;
			_.each(addonItems, function (addon) {
				var isZeroAddon = self.findZeroAddons(addon);
				if (isZeroAddon && _.contains(aemData, isZeroAddon.offerID)) {
					addon.hideDisplay = true;
				}
			});
		},
		findZeroAddons: function (addon) {
			var isZeroAddon = false;
			if (addon.oneTimePrice && addon.oneTimePrice.finalAmountIncludingTax === 0 &&
				addon.recurringPrice && addon.recurringPrice.finalAmountIncludingTax === 0 &&
				addon.checkoutPrice && addon.checkoutPrice.finalAmountIncludingTax === 0) {
				isZeroAddon = true;
			}
			return (isZeroAddon ? addon : null);
		},
		//hide remove link for addons for 5G devices configured in AEM
		check5GAddons: function (addonItems, aemData, modelName, isAddonPage) {
			var self = this;
			if (aemData && aemData.length > 0 && addonItems && addonItems.length > 0) {
				_.each(aemData, function (aemItem) {
					if (aemItem && aemItem.id && _.contains(aemItem.modelIds, modelName)) {
						self.populateAdditionalAddonValues(addonItems, aemItem, modelName, isAddonPage);
					}
				});
			}
		},
		//set Remove link flag to true for addons configured in AEM
		populateAdditionalAddonValues: function (addonItems, aemItem, modelName, isAddonPage) {
			if (addonItems && addonItems.length > 0) {
				_.find(addonItems, function (addon) {
					if ((!isAddonPage && aemItem.id === addon.offerID) ||
						(isAddonPage && aemItem.id === addon.addonId)) {
						if (isAddonPage) {
							_.find(addon.allowedActions, function (action) {
								if (action.type === 'RM') {
									action.allowed = false;
									return true;
								}
							});
							addon.enableUpgradeButton = true;
						} else {
							addon.hideRemoveLink = true;
						}
						return true;
					}
				});
			}
		},
		stringToBoolean: function (string) {
			if (string && string.length > 0) {
				switch (string.toLowerCase().trim()) {
					case 'true': case 'yes': case '1': return true;
					case 'false': case 'no': case '0': case null: return false;
					default: return Boolean(string);
				}
			} else {
				return false;
			}
		},
		maskBlockHouseNo: function (blockHouseNo) {
			if (blockHouseNo && blockHouseNo.length) {
				switch (blockHouseNo.length) {
					case 1:
					case 2:
					case 3:
						return blockHouseNo.replace(/\w$/, '*');
					case 4:
						return blockHouseNo.replace(/\w{2}$/, '**');
				}
			}
			return blockHouseNo;
		},
		maskPostalCode: function (postCode) {
			if (postCode && postCode.length) {
				return postCode.replace(/\w$/, '*');
			}
			return postCode;
		},
		maskPhoneNo: function (phoneNo) {
			phoneNo = '' + phoneNo;
			if (phoneNo && phoneNo.length) {
				return phoneNo.replace(/^\w{4}/, '****');
			}
			return phoneNo;
		},
		maskEmailId: function (email) {
			if (email && email.length) {
				return email.replace(/^(\w|@){4}/, '****');
			}
			return email;
		},
		maskAccountNo: function (accountNo) {
			accountNo = '' + accountNo;
			if (accountNo && accountNo.length) {
				//Take last 4 charcters of account number;
				accountNo = accountNo.substr(-4);
				if (accountNo.length < 4) {
					var noOfZerosToAppend = 4 - accountNo.length;
					do {
						accountNo = '0' + accountNo;
						noOfZerosToAppend--;
					} while (noOfZerosToAppend > 0);
				}
				return '****' + accountNo;
			}
			return accountNo;
		},
		maskNric: function (nric) {
			if (nric && nric.length) {
				return nric.replace(/\w(?=\w{4})/gi, '*');
			}
			return nric;
		},
		getEAErrorMessageByErrCode: function (errorCode, errorMessages) {
			var errMsg = _.find(errorMessages, function (error) {
				return error.errorCode === errorCode;
			});
			return errMsg;
		},
		getRRPProductDetailsBySku: function (skus, successCallback, errorCallback, payload) {
			var url = '/bin/services/singtel/RRPProductComponentModelServlet.:skus=' + skus.join('_') + '.json';
			return this.doAjaxJSONCallWithSimulator('GET', url, successCallback, errorCallback, payload);
		},
		clearContextForRRP: function () {
			window.sessionStorage.clear();
			window.localStorage.removeItem('LightsaberSessionToken');
		},
		getTotalItemsInCart: function (orderDetails) {
			var num = 0;
			var orderItems = orderDetails.orderItems;
			_.each(orderItems, function (item) {
				num = num + item.quantity;
			});
			return num;
		},
		redirectOnBlankOrder: function () {
			var rrpOrderId = JSON.parse(this.getHomeLineContext('businesswidget/' +
			'repository_l9_common/common/viewmodel/rrp/RRPOrderContextTopic'));
			if (rrpOrderId === null && !this.isAuthoringMode()) {
				var emptyCartUrl = this.modifyConfigUrl(
					ConfigStrings.RRP.pages.emptyCartUrl);
				window.location.href = emptyCartUrl;
			}
		},
		isAuthoringMode: function () {
			if (window.location.href.indexOf('/content/singtel/en') !== -1) {
				return true; //This is authoring mode
			} else {
				return false; //Publisher mode
			}
		},
		deleteAllCookies: function () {
			var cookies = document.cookie.split('; ');
			for (var c = 0; c < cookies.length; c++) {
				var d = window.location.hostname.split('.');
				while (d.length > 0) {
					var cookieBase = encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) +
						'=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
					var p = location.pathname.split('/');
					document.cookie = cookieBase + '/';
					while (p.length > 0) {
						document.cookie = cookieBase + p.join('/');
						p.pop();
					}
					d.shift();
				}
			}
		},
		checkIndentType: function (nric) {
			if (nric && nric !== '') {
				var indentType = nric.substring(0, 1);
				if (indentType === 'F' || indentType === 'G'  || indentType === 'M') {
					return true;
				} else {
					return false;
				}
			}
			return false;
		},
		adjustPromoPrice: function (order, premiumPromoList) {
			var tb = order;
			if (order && order.bundle && order.bundle.length > 0 &&
				premiumPromoList && premiumPromoList.length > 0) {
				_.each(order.bundle, function (bundle) {
					if (bundle.promotions && bundle.promotions.length > 0) {
						_.each(bundle.promotions, function (promotion) {
							var aemPromo = _.find(premiumPromoList, function (premiumPromo) {
								return promotion.offerID && premiumPromo.boid &&
								premiumPromo.boid === promotion.offerID;
							});
							if (aemPromo && aemPromo.paymentTerms) {
								var origOneTimePriceWithtax, tempOneTimePriceWithtax,
								origFinalAmount, origFinalTaxAmount;
								origOneTimePriceWithtax = promotion.oneTimePrice.finalAmountIncludingTax;
								origFinalAmount = promotion.oneTimePrice.finalAmount;
								origFinalTaxAmount = promotion.oneTimePrice.finalTaxAmount;
								tempOneTimePriceWithtax = origOneTimePriceWithtax;
								origOneTimePriceWithtax = origOneTimePriceWithtax - tempOneTimePriceWithtax;
								promotion.oneTimePrice.finalAmountIncludingTax = origOneTimePriceWithtax;
								var paymentTerm = Number(aemPromo.paymentTerms);
								promotion.recurringPrice.finalAmountIncludingTax = tempOneTimePriceWithtax / paymentTerm;
								if (tb.oneTimePrice) {
									tb.oneTimePrice.finalAmount = tb.oneTimePrice.finalAmount - origFinalAmount;
									tb.oneTimePrice.finalAmountIncludingTax =
										tb.oneTimePrice.finalAmountIncludingTax - tempOneTimePriceWithtax;
									tb.oneTimePrice.finalTaxAmount =
										tb.oneTimePrice.finalTaxAmount - origFinalTaxAmount;
								}
								if (tb.bundle[0].oneTimePrice) {
									tb.bundle[0].oneTimePrice.finalAmount = tb.oneTimePrice.finalAmount;
									tb.bundle[0].oneTimePrice.finalAmountIncludingTax =
										tb.oneTimePrice.finalAmountIncludingTax < 0 ? 0 :
										tb.oneTimePrice.finalAmountIncludingTax;
									tb.bundle[0].oneTimePrice.finalTaxAmount = tb.oneTimePrice.finalTaxAmount;
								}
							}
						});
					}
				});
			}
			return order;
		},
		updateOneTimePrice: function (order, mobileContentList) {
			if (order && order.mobile && order.mobile.length > 0 &&
				mobileContentList && mobileContentList.length > 0) {
				var orderOneTimePrice =  order.oneTimePrice;
				_.each(order.mobile, function (mobile) {
					if (mobile.mobileContents && mobile.mobileContents.length > 0) {
						var orderActionOneTimePrice = mobile.oneTimePrice;
						_.each(mobile.mobileContents, function (mobileContentDetails) {
							var contentOneTimePrice = mobileContentDetails.oneTimePrice;
							if (contentOneTimePrice && contentOneTimePrice.finalAmountIncludingTax === 0) {
								var aemContent = _.find (mobileContentList, function (mobileContent) {
									return mobileContent.productSpecContainmentID ===
										mobileContentDetails.simpleProductSpecID &&
										mobileContent.onetimePrice && mobileContent.onetimePrice.length > 0 &&
										mobileContent.onetimePriceWithoutGST &&
										mobileContent.onetimePriceWithoutGST.length > 0;
								});
								if (aemContent) {
									var actualContentPrice = Number(aemContent.onetimePrice);
									var actualContentPriceWithoutGST = Number(aemContent.onetimePriceWithoutGST);
									var finalTaxAmount = actualContentPrice - actualContentPriceWithoutGST;
									contentOneTimePrice.finalAmount =
										contentOneTimePrice.finalAmount + actualContentPriceWithoutGST;
									contentOneTimePrice.finalTaxAmount =
										contentOneTimePrice.finalTaxAmount + finalTaxAmount;
									contentOneTimePrice.finalAmountIncludingTax =
										contentOneTimePrice.finalAmountIncludingTax + actualContentPrice;
									mobileContentDetails.oneTimePrice = contentOneTimePrice;
									orderActionOneTimePrice.finalAmount =
										orderActionOneTimePrice.finalAmount + actualContentPriceWithoutGST;
									orderActionOneTimePrice.finalTaxAmount =
										orderActionOneTimePrice.finalTaxAmount + finalTaxAmount;
									orderActionOneTimePrice.finalAmountIncludingTax =
										orderActionOneTimePrice.finalAmountIncludingTax + actualContentPrice;
									orderOneTimePrice.finalAmount =
										orderOneTimePrice.finalAmount + actualContentPriceWithoutGST;
									orderOneTimePrice.finalTaxAmount =
										orderOneTimePrice.finalTaxAmount + finalTaxAmount;
									orderOneTimePrice.finalAmountIncludingTax =
										orderOneTimePrice.finalAmountIncludingTax + actualContentPrice;
								}
							}
						});
						mobile.oneTimePrice = orderActionOneTimePrice;
					}
				});
				order.oneTimePrice = orderOneTimePrice;
			}
			return order;
		},
		isIppPlan: function () {
			var RRPOrderContextTopic = JSON.parse(this.getHomeLineContext('businesswidget' +
			'/repository_l9_common/common/viewmodel/rrp/RRPOrderContextTopic'));
			if (RRPOrderContextTopic && RRPOrderContextTopic.ippOrderId) {
				return true;
			}
			return false;
		},
		isRrpPlan: function () {
			var RRPOrderContextTopic = JSON.parse(this.getHomeLineContext('businesswidget' +
			'/repository_l9_common/common/viewmodel/rrp/RRPOrderContextTopic'));
			if (RRPOrderContextTopic && RRPOrderContextTopic.rrpOrderId) {
				return true;
			}
			return false;
		},
		processQuoteResponse: function (ractiveWidget, updateResponseData, promotionsPath,
			youSavePath, actualPricePath, orderItemsPath, ippOrderItemsPath) {
			var accessoriesAdded = [],
				promotions = [];
			var youSave = {
				finalAmount: 0,
				finalTaxAmount: 0,
				finalAmountIncludingTax: 0
			};
			var self = this;
			if (updateResponseData.productOfferings && updateResponseData.productOfferings[0]) {
				var productOrderItems = updateResponseData.productOfferings[0].productOrderItems;
				_.each(productOrderItems, function (productOrderItem) {
					if (productOrderItem && productOrderItem.displayableSimpleProductReferences) {
						_.each(productOrderItem.displayableSimpleProductReferences,
							function (displayableSimpleProductReference) {
							if (displayableSimpleProductReference.productSpecContainmentID ===
								ConfigStrings.RRP.productSpecContainmentID &&
								displayableSimpleProductReference.action === 'AD' &&
								displayableSimpleProductReference.status === 'AC') {
								accessoriesAdded.push(displayableSimpleProductReference);
							}
						});
						_.each(productOrderItem.displayableItems, function (displayableItem) {
							if (displayableItem.productSpecContainmentID === '10381311' ||
								displayableItem.productSpecContainmentID === '11337471' ||
								displayableItem.productSpecContainmentID === '11344731' ||
								displayableItem.productSpecContainmentID === '11343321') {
								var result = self.createCustomPropertiesForItem(displayableItem, true);
								_.each(displayableItem.displayableCharacteristics,
									function (displayableCharacteristic) {
									if (displayableCharacteristic.productSpecCharacteristicID === '10383541') {
										result.name = displayableCharacteristic.value;
									}
								});
								if (typeof result.name === 'undefined' || result.name === null) {
									result.name = displayableItem.name;
								}
								//to check
								promotions.push(result);
							}
						});
						_.each(promotions, function (promotion) {
							youSave.finalAmount += promotion.price.finalAmount;
							youSave.finalTaxAmount += promotion.price.finalTaxAmount;
							youSave.finalAmountIncludingTax += promotion.price.afterTax;
						});
					}
				});
			}
			ractiveWidget.set(promotionsPath, promotions);
			ractiveWidget.set(youSavePath, youSave);
			self.processQuoteReference(accessoriesAdded, ractiveWidget, actualPricePath, orderItemsPath,
				ippOrderItemsPath, promotions);
		},
		createCustomPropertiesForItem: function (item, devicePayment, displayAs, customItem) {
			if (typeof customItem === 'undefined' || customItem === null) {
				customItem = {};
			}
			if (typeof item.totalOneTimeCalculatedPrice === 'undefined' ||
				item.totalOneTimeCalculatedPrice === null) {
				item.totalOneTimeCalculatedPrice = {};
			}
			if (typeof item.totalRecurringCalculatedPrice === 'undefined' ||
				item.totalRecurringCalculatedPrice === null) {
				item.totalRecurringCalculatedPrice = {};
			}
			if (devicePayment) {
				customItem.price = {
					finalAmount: item.totalOneTimeCalculatedPrice.finalAmount || 0,
					finalTaxAmount: item.totalOneTimeCalculatedPrice.finalTaxAmount || 0,
					afterTax: item.totalOneTimeCalculatedPrice.finalAmountIncludingTax || 0
				};
				customItem.oneTimePrice = {
					finalAmount: 0,
					finalTaxAmount: 0,
					finalAmountIncludingTax: 0
				};

			} else {
				customItem.oneTimePrice = {
					finalAmount: item.totalOneTimeCalculatedPrice.finalAmount || 0,
					finalTaxAmount: item.totalOneTimeCalculatedPrice.finalTaxAmount || 0,
					finalAmountIncludingTax: item.totalOneTimeCalculatedPrice.finalAmountIncludingTax || 0
				};
				if (typeof customItem.checkoutPrice === 'undefined' ||
					customItem.checkoutPrice === null ||
					typeof customItem.checkoutPrice.finalAmountIncludingTax === 'undefined' ||
					customItem.checkoutPrice.finalAmountIncludingTax === null) {

					customItem.checkoutPrice = {
						finalAmount: 0,
						finalTaxAmount: 0,
						finalAmountIncludingTax: 0
					};
				}
			}

			customItem.recurringPrice = {
				finalAmount: item.totalRecurringCalculatedPrice.finalAmount || 0,
				finalTaxAmount: item.totalRecurringCalculatedPrice.finalTaxAmount || 0,
				finalAmountIncludingTax: item.totalRecurringCalculatedPrice.finalAmountIncludingTax || 0
			};
			if (displayAs) {
				if (displayAs === 'oneTimePrice' && customItem.oneTimePrice) {
					customItem.oneTimePrice.finalAmountIncludingTax = 'Free';
				} else if (displayAs === 'checkoutPrice' && customItem.checkoutPrice) {
					customItem.checkoutPrice.finalAmountIncludingTax = 'Free';
				} else if (displayAs === 'recurringPrice' && customItem.recurringPrice) {
					customItem.recurringPrice.finalAmountIncludingTax = 'Free';
				}
			}
			customItem.isImmediateCharge = item.isImmediateCharge; //todo

			return customItem;
		},
		processQuoteReference: function (accessoriesAdded, ractiveWidget, actualPricePath, orderItemsPath,
			ippOrderItemsPath, promotions) {
			var orderItems = [];
			var individualOrderItems = [];
			var ippOrderItems = [];
			var actualPrice = {
				afterTax: 0,
				beforeTax: 0,
				taxAmount: 0,
				recurringAmount: 0
			};
			_.each(accessoriesAdded, function (accessory) {
				var individualOrderItem = {};
				if (accessory.displayableCharacteristics) {
					_.each(accessory.displayableCharacteristics, function (displayableCharacteristic) {
						if (displayableCharacteristic.productSpecCharacteristicID === '8852' &&
							displayableCharacteristic.value) {
							individualOrderItem.model = displayableCharacteristic.value;
						} else if (displayableCharacteristic.productSpecCharacteristicID === '8842' &&
							displayableCharacteristic.value) {
							individualOrderItem.brand = displayableCharacteristic.value;
						} else if (displayableCharacteristic.productSpecCharacteristicID === '8832') {
							individualOrderItem.sku = displayableCharacteristic.value;
						} else if (displayableCharacteristic.productSpecCharacteristicID === '13897781' &&
							displayableCharacteristic.value === 'Instalments') {
							individualOrderItem.installmentCharValue = true;
						} else if (displayableCharacteristic.productSpecCharacteristicID === '8272') {
							individualOrderItem.numberOfInstalment = displayableCharacteristic.value;
						}
					});
					individualOrderItem.title = accessory.name;
					individualOrderItem.totalOneTimeCalculatedPrice = accessory.totalOneTimeCalculatedPrice;
					individualOrderItem.totalRecurringCalculatedPrice = accessory.totalRecurringCalculatedPrice;
					individualOrderItem.identifier = accessory.simpleProductSpecID;
					individualOrderItem.orderItemId = accessory.productID;
					if (individualOrderItem.installmentCharValue) {
						if (accessory.displayableBillingOffers) {
							var displayableBillingOffer = _.find(accessory.displayableBillingOffers, function (bo) {
								return bo.productSpecPricing && bo.productSpecPricing.childPricingSchema &&
									bo.productSpecPricing.childPricingSchema.id === '18993991';
							});
							if (displayableBillingOffer && displayableBillingOffer.oneTimeCalculatedPrices &&
								displayableBillingOffer.oneTimeCalculatedPrices.length > 0) {
								var oneTimeCalculatedPrice = _.min(displayableBillingOffer.oneTimeCalculatedPrices,
									function (priceObj) {
										return priceObj.finalAmount;
									});
								individualOrderItem.actualPrice = {
									afterTax: oneTimeCalculatedPrice.finalAmount +
										oneTimeCalculatedPrice.finalTaxAmount,
									beforeTax: oneTimeCalculatedPrice.finalAmount,
									taxAmount: oneTimeCalculatedPrice.finalTaxAmount
								};
								actualPrice.recurringAmount = actualPrice.recurringAmount +
									oneTimeCalculatedPrice.finalAmount + oneTimeCalculatedPrice.finalTaxAmount;
							}
						}
					} else {
						if (accessory.displayableBillingOffers) {
							var displayableBillingOffer = _.find(accessory.displayableBillingOffers, function (bo) {
								return bo.productSpecPricing && bo.productSpecPricing.childPricingSchema &&
									bo.productSpecPricing.childPricingSchema.id === '8680162';
							});
							if (displayableBillingOffer && displayableBillingOffer.oneTimeCalculatedPrices &&
								displayableBillingOffer.oneTimeCalculatedPrices.length > 0) {
								actualPrice.afterTax = actualPrice.afterTax +
									displayableBillingOffer.oneTimeCalculatedPrices[0].finalAmount +
									displayableBillingOffer.oneTimeCalculatedPrices[0].finalTaxAmount;
								actualPrice.beforeTax = actualPrice.beforeTax +
									displayableBillingOffer.oneTimeCalculatedPrices[0].finalAmount;
								actualPrice.taxAmount = actualPrice.taxAmount +
									displayableBillingOffer.oneTimeCalculatedPrices[0].finalTaxAmount;
								individualOrderItem.actualPrice = {
									afterTax: displayableBillingOffer.oneTimeCalculatedPrices[0].finalAmount +
										displayableBillingOffer.oneTimeCalculatedPrices[0].finalTaxAmount,
									beforeTax: displayableBillingOffer.oneTimeCalculatedPrices[0].finalAmount,
									taxAmount: displayableBillingOffer.oneTimeCalculatedPrices[0]
										.finalTaxAmount
								};
							}
						}
					}
				}
				if (individualOrderItem.installmentCharValue === true) {
					individualOrderItem.quantity = 1;
					individualOrderItem.productDetails = {
						title: individualOrderItem.title,
						brand: individualOrderItem.brand,
						model: individualOrderItem.model,
						price: individualOrderItem.actualPrice.afterTax
					};
					individualOrderItem.monthlyPrice = individualOrderItem.actualPrice;
					if (individualOrderItem.actualPrice.afterTax <= 0) {
						ractiveWidget.set('isZeroDollarDevice', true);
					}
					ippOrderItems.push(individualOrderItem);
				} else {
					individualOrderItems.push(individualOrderItem);
				}
			});
			_.each(promotions, function (promotion) {
				actualPrice.afterTax = actualPrice.afterTax +
					promotion.price.afterTax;
				actualPrice.beforeTax = actualPrice.beforeTax +
					promotion.finalAmount;
				actualPrice.taxAmount = actualPrice.taxAmount +
					promotion.finalTaxAmount;
			});
			ractiveWidget.set(actualPricePath, actualPrice);
			var orderItemsGroupedBySku = _.groupBy(individualOrderItems, function (individualOrderItem) {
				return individualOrderItem.sku;
			});
			for (var sku in orderItemsGroupedBySku) {
				if (orderItemsGroupedBySku[sku] && orderItemsGroupedBySku[sku].length > 0) {
					var priceBySku = {
						taxAmount: 0,
						beforeTax: 0,
						afterTax: 0
					};
					for (var i = 0; i < orderItemsGroupedBySku[sku].length; i++) {
						priceBySku.taxAmount += orderItemsGroupedBySku[sku][i].actualPrice.taxAmount;
						priceBySku.beforeTax += orderItemsGroupedBySku[sku][i].actualPrice.beforeTax;
						priceBySku.afterTax += orderItemsGroupedBySku[sku][i].actualPrice.afterTax;

					}
					var obj = orderItemsGroupedBySku[sku][0];
					var processedOrderItem = {
						sku: sku,
						quantity: orderItemsGroupedBySku[sku].length,
						identifier: obj.identifier,
						productDetails: {
							title: obj.title,
							brand: obj.brand,
							model: obj.model,
							price: obj.totalOneTimeCalculatedPrice.finalAmountIncludingTax,
							numberOfInstalment: obj.numberOfInstalment
						},
						orderItemDetails: orderItemsGroupedBySku[sku],
						actualPrice: priceBySku
					};
					orderItems.push(processedOrderItem);
				}
			}

			var ippOrderItemsGroupedBySku = _.groupBy(ippOrderItems, function (individualOrderItem) {
				return individualOrderItem.sku;
			});
			var modIppOrderItems = [];
			for (var sku in ippOrderItemsGroupedBySku) {
				if (ippOrderItemsGroupedBySku[sku] && ippOrderItemsGroupedBySku[sku].length > 0) {
					var obj = ippOrderItemsGroupedBySku[sku][0];
					var processedOrderItem = {
						sku: sku,
						quantity: ippOrderItemsGroupedBySku[sku].length,
						identifier: obj.identifier,
						productDetails: {
							title: obj.title,
							brand: obj.brand,
							model: obj.model,
							price: obj.totalOneTimeCalculatedPrice.finalAmountIncludingTax,
							numberOfInstalment: obj.numberOfInstalment
						},
						orderItemDetails: ippOrderItemsGroupedBySku[sku],
						monthlyPrice: {
							afterTax: obj.actualPrice.afterTax,
							beforeTax: obj.actualPrice.beforeTax,
							taxAmount: obj.actualPrice.taxAmount
						}
					};
					modIppOrderItems.push(processedOrderItem);
				}
			}
			var totalCount = individualOrderItems.length + ippOrderItems.length;
			var num = totalCount;
			$('.shopping-item-num').remove();
			var div1 = document.createElement('div');
			div1.className = 'shopping-item-num';
			div1.innerHTML = num;
			var div2 = document.createElement('div');
			div2.className = 'shopping-item-num';
			div2.innerHTML = num;
			$('.ux-header-singtel .header-action-list .ux-icon.shop-icon').prepend(div1);
			$('.ux-header-singtel .text-center.shopping-car-icon .ux-icon').prepend(div2);
			ractiveWidget.set(orderItemsPath, orderItems);
			ractiveWidget.set(ippOrderItemsPath, modIppOrderItems);
			ractiveWidget.set('totalCount', totalCount);
		},
		maskContent: function (key, value) {
			var self = this;

			return {
				MOBILE_NUMBER: self.maskPhoneNo,
				EMAIL_ID: self.maskEmailId
			}[key](value);
		},

		/** Return a string with replaced values in placeholder
		 * @example - without valueMapper
		 *  data = {
		 *  	orderId: '#5433',
		 * 		product: 'Spotify'
		 * 	}
		 *  message = 'Purchased {product} successfully. Your Order ID is {orderId}.';
		 *  return 'Purchased Spotify successfully. Your Order ID is #5433.'
		 *
		 * @example - with valueMapper
		 *  data = {
		 *  	order: {
		 * 			id: '#5433',
		 *    		productName: 'Spotify'
		 * 		}
		 *  }
		 * 	valueMapper = {
		 *  	orderId: 'order.id',
		 * 		product: 'order.productName'
		 *  }
		 *  message = 'Purchased {product} successfully. Your Order ID is {orderId}.';
		 *  return 'Purchased Spotify successfully. Your Order ID is #5433.'
		 *
		 * @param {string} message content string with placeholder (eg. Successful order Id: {ORDER_ID})
		 * @param {object} data  value of data (e.g { ORDER_ID: 3200 } OR { order: { id: 3200 }})
		 * @param {object} [valueMapper] define where to get object value in data (e.g { ORDER_ID: 'order.id' })
		 * @param {string} [placeholderFormat={key}] define the placeholder pattern with `key` in between the symbol
		 * @returns {string}
		 */
		mapPlaceholderToValue: function (message, data, valueMapper, transform, placeholderFormat) {
			const placeholderIndicator = (placeholderFormat || '{key}').split('key');

			const placeholder = _.map(placeholderIndicator, function (placeholder) {
				return placeholder.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			});

			const newRegex = new RegExp(placeholder[0] + '(.*?)' + placeholder[1], 'g');
			const placeholders = message.match(newRegex);

			if (!placeholders) {
				return message;
			}

			return _.reduce(placeholders, function (acc, placeholder) {
				const key = placeholder.substring(
					placeholderIndicator[0].length,
					placeholder.length - placeholderIndicator[1].length
				);

				const replaceValue = _.get(data, valueMapper ? valueMapper[key] : key) || '';

				if (typeof transform === 'function') {
					return acc.replace(placeholder, transform(key, replaceValue));
				}

				return acc.replace(placeholder, replaceValue);
			}, message);
		},
		isRedFlow: function (planOfferId) {
			var redPlanOffers = ConfigStrings.redPlanOffers;
			return _.contains(redPlanOffers, planOfferId);
		},
		getMobileOperatingSystem: function () {
			var userAgent = navigator.userAgent || navigator.vendor || window.opera;
			// Windows Phone must come first because its UA also contains "Android"
			if (/windows phone/i.test(userAgent)) {
				return 'windows';
			}
			if (/android/i.test(userAgent)) {
				return 'android';
			}
			// iOS detection
			if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
				return 'ios';
			}
			return 'undefined';
		},
		getUrlParams: function () {
			const urlSearchParams = new URLSearchParams(window.location.search); // jshint ignore:line
			const params = Object.fromEntries(urlSearchParams.entries());
			return params;
		}
	};
});

/**
 * Created by shuyiwu on 5/12/16.
 */
define('CommonHelpers',['lodash-compat'], function (_) {

	/**
	 * The following functions are for device details page interactions
	 */

	return {
		/**
		 *get a mecId related object(s)
		 *
		 * @param list the initial data list
		 * @param mecId the selected mecId
		 * @returns {Object} the object with giving mecId
		 */
		getObjectForMecId: function (list, mecId) {
			var obj = null,
				length = list.length;
			if (length < 1) {
				return obj;
			}
			for (var i = 0; i < length; i++) {
				if (list[i].mecId === mecId) {
					obj = list[i];
					break;
				}
			}
			return obj;
		},
		/**
		 *get a list of mecIds related selected value
		 *
		 * @param list the initial full data list
		 * @param value the selected value
		 * @returns {Array} A list of mecIds
		 */
		getMecIdsForValue: function (list, value) {
			var mecIds = [];
			if (list.length < 1) {
				return mecIds;
			}
			_.each(list, function (obj) {
				if (obj.value === value) {
					mecIds.push(obj.mecId);
				}
			});

			return mecIds;
		},
		/**
		 *get an array of objects, each of them has unique value
		 *
		 * @param list the initial data list
		 * @returns {Array} the object array
		 */
		getUniqueValueList: function (list) {
			var uniqueValues = [],
				uniqueObjects = [];
			if (list.length < 1) {
				return uniqueObjects;
			}
			_.each(list, function (obj) {
				if (_.indexOf(uniqueValues, obj.value) < 0) {
					uniqueValues.push(obj.value);
					uniqueObjects.push(obj);
				}
			});
			return uniqueObjects;
		},
		/**
		 *get a list of objects which match given mecId list
		 *
		 * @param list the initial data list
		 * @param mecIds the array of mecIds
		 * @returns {Array} the objects with match giving mecIds
		 */
		getObjectsForMecIds: function (list, mecIds) {
			var objectList = [];
			if (list.length < 1 || mecIds.length < 1) {
				return objectList;
			}
			_.each(mecIds, function (mecId) {
				_.each(list, function (obj) {
					if (obj.mecId === mecId) {
						objectList.push(obj);
					}
				});
			});
			return objectList;
		}
	};
});

/**
 * ractive-foundation - Ractive components for Foundation 5
 * @version 0.21.0
 * @link https://github.com/ractive-foundation/ractive-foundation
 * @license MIT
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define('RactiveF',['ractive', 'lodash-compat'], factory);
    } else if (typeof exports === 'object') {
        factory(require('ractive'), require('lodash-compat'));
    } else {
        factory(root.Ractive, root._);
    }
}(this, function (Ractive, _) {
/* jshint ignore:start */
/*
 * When working with nested components we only want to find child
 * components, not all decendants.
 * @param name
 */
Ractive.defaults.findAllChildComponents = function (name) {
	return _.filter(this.findAllComponents(name), function (component) {
		return this._guid === component.parent._guid;
	}.bind(this));
};

/**
 * If we have a "datamodel" property, that should override any other data.
 * This is now a "data-driven" component.
 * isDataModel is a flag for hbs logic, on whether to use datamodel data or call {{yield}}.
 * @see http://docs.ractivejs.org/latest/ractive-reset
 *
 * TODO Understand the difference between rendering components off the page vs nested inside others.
 * onconstruct has empty opts for the latter.
 */
Ractive.defaults.onconstruct = function (opts) {
	if (opts.data && opts.data.datamodel) {
		var datamodel = _.cloneDeep(opts.data.datamodel);
		datamodel.isDataModel = true;
		opts.data = _.assign(opts.data, datamodel);
		delete opts.data.datamodel;
	}
};

/**
 * For any data-driven component - if something sets 'datamodel', lift that into root scope.
 */
Ractive.defaults.onrender = function () {

	// Wait for parent component to set "datamodel" and then map that back into data again.
	this.observe('datamodel', function (newDataModel) {
		if (newDataModel) {
			// Lift datamodel data into root data scope.
			this.set(newDataModel);
		}
	});

};

/**
 * Get the current coordinates of the given element, relative to the document.
 *
 * Useful for viewport checks etc
 *
 * Use Ractive's this.find(selector) to pass that element in.
 *
 * Helper function for cross-browser element offset.
 * window.pageYOffset is not supported below IE 9.
 */
Ractive.defaults.elementOffset = function (elem) {

	// Defensive code for isomorphic execution.
	if (typeof document === 'undefined' || typeof window === 'undefined') {
		return {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		};
	}

	var box = elem.getBoundingClientRect();

	var body = document.body;
	var docEl = document.documentElement;
	var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
	var clientTop = docEl.clientTop || body.clientTop || 0;

	var top = box.top + (scrollTop - clientTop);
	var pageXOffset = window.pageXOffset || document.documentElement.scrollLeft;

	return {
		top: Math.round(top),
		right: Math.round(box.right + pageXOffset),
		bottom: Math.round(box.bottom + top),
		left: Math.round(box.left + pageXOffset)
	};

};

/**
 * IE8 friendly function.
 * TODO Make the return object the same as offset?
 */
Ractive.defaults.pageYOffset = function () {
	// Defensive code for isomorphic execution.
	if (typeof document === 'undefined' || typeof window === 'undefined') {
		return 0;
	}
	return window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
};

Ractive.defaults.templates = {};

Ractive.defaults.templates["ux-accordion"] = {"v":3,"t":[{"t":7,"e":"ul","a":{"id":[{"t":2,"r":"guid"}],"class":["accordion ",{"t":2,"r":"class"}],"data-accordion":0},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-accordionitem","a":{"datamodel":[{"t":3,"r":"."}]}}],"n":52,"r":"items"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
Ractive.defaults.templates["ux-accordionitem"] = {"v":3,"t":[{"t":7,"e":"li","a":{"id":[{"t":2,"r":"guid"}],"class":["accordion-navigation ",{"t":2,"r":"class"}," ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"ux-content","f":[{"t":3,"r":"content"}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":"isDataModel"}]}]};
Ractive.defaults.templates["ux-alert"] = {"v":3,"t":[{"t":7,"e":"div","a":{"data-alert":0,"class":["alert-box ",{"t":2,"r":"class"}],"aria-live":"assertive","role":"alertdialog"},"f":[{"t":4,"f":[{"t":3,"r":"text"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":"isDataModel"}," ",{"t":7,"e":"button","a":{"class":"close","aria-label":"Close Alert"},"v":{"tap":"closeClicked"},"f":["×"]}]}]};
Ractive.defaults.templates["ux-anchor"] = {"v":3,"t":[{"t":7,"e":"a","a":{"id":[{"t":2,"r":"guid"}],"class":["ux-anchor ",{"t":2,"r":"class"}]},"m":[{"t":4,"f":["href=\"",{"t":2,"r":"href"},"\""],"n":50,"r":"href"},{"t":4,"f":["role=\"",{"t":2,"r":"role"},"\""],"n":50,"r":"role"},{"t":4,"f":["aria-label=\"",{"t":2,"r":"ariaLabel"},"\""],"n":50,"r":"ariaLabel"},{"t":4,"f":["target=\"",{"t":2,"r":"target"},"\""],"n":50,"r":"target"},{"t":4,"f":["title=\"",{"t":2,"r":"title"},"\""],"n":50,"r":"title"},{"t":4,"f":["tabindex=\"",{"t":2,"x":{"r":["tabindex"],"s":"_0||0"}},"\""],"n":50,"x":{"r":["tabindex"],"s":"_0!==null"}}],"v":{"tap":"anchorClicked"},"f":[{"t":4,"f":[{"t":3,"r":"content"}],"n":50,"r":".isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":".isDataModel"}]}]};
Ractive.defaults.templates["ux-breadcrumb-item"] = {"v":3,"t":[{"t":7,"e":"li","a":{"role":"menuitem","class":[{"t":2,"r":"class"}," ",{"t":4,"f":["unavailable"],"r":"unavailable"}," ",{"t":4,"f":["current"],"r":"current"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"isDataModel":"false","href":[{"t":2,"r":"href"}]},"f":[{"t":2,"r":"content"}]}],"n":50,"r":".isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":".isDataModel"}]}]};
Ractive.defaults.templates["ux-breadcrumbs"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"nav","a":{"class":"breadcrumbs","role":"menubar","aria-label":"breadcrumbs"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-breadcrumb-item","a":{"datamodel":[{"t":3,"r":"."}]}}],"i":"i","r":"items"}],"n":50,"r":"items"},{"t":4,"n":51,"f":[{"t":16}],"r":"items"}]}],"n":50,"r":"isNav"},{"t":4,"n":51,"f":[{"t":7,"e":"ul","a":{"class":"breadcrumbs"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-breadcrumb-item","a":{"datamodel":[{"t":3,"r":"."}]}}],"n":52,"r":"items"}],"n":50,"r":"items"},{"t":4,"n":51,"f":[{"t":16}],"r":"items"}]}],"r":"isNav"}]};
Ractive.defaults.templates["ux-button"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"a","a":{"class":["ux-button button ",{"t":2,"r":"class"}]},"m":[{"t":4,"f":["href=\"",{"t":2,"r":"href"},"\""],"n":50,"r":"href"},{"t":4,"f":[" role=\"",{"t":2,"r":"role"},"\""],"n":50,"r":"role"},{"t":4,"f":[" aria-label=\"",{"t":2,"r":"arialabel"},"\""],"n":50,"r":"arialabel"},{"t":4,"f":[" tabindex=\"",{"t":2,"r":"tabindex"},"\""],"n":50,"r":"tabindex"},{"t":4,"f":[" disabled"],"n":50,"r":"isDisabled"}],"v":{"tap":{"m":"clickHandler","a":{"r":[],"s":"[]"}}},"f":[{"t":4,"f":[{"t":3,"r":"text"}],"n":50,"r":"text"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"text"}]}],"n":50,"r":"href"},{"t":4,"n":51,"f":[{"t":7,"e":"button","a":{"class":["ux-button button ",{"t":2,"r":"class"}],"type":[{"t":2,"r":"type"}]},"m":[{"t":4,"f":["role=\"",{"t":2,"r":"role"},"\""],"n":50,"r":"role"},{"t":4,"f":[" aria-label=\"",{"t":2,"r":"arialabel"},"\""],"n":50,"r":"arialabel"},{"t":4,"f":[" tabindex=\"",{"t":2,"r":"tabindex"},"\""],"n":50,"r":"tabindex"},{"t":4,"f":[" disabled"],"n":50,"r":"isDisabled"}],"v":{"tap":{"m":"clickHandler","a":{"r":[],"s":"[]"}}},"f":[{"t":4,"f":[{"t":2,"r":"text"}],"n":50,"r":"text"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"text"}]}],"r":"href"}]};
Ractive.defaults.templates["ux-col"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":[{"t":2,"r":"class"}," columns"]},"f":[{"t":16}]}]};
Ractive.defaults.templates["ux-content"] = {"v":3,"t":[{"t":7,"e":"div","a":{"id":[{"t":2,"r":"guid"}],"class":["content ",{"t":4,"f":["active"],"n":50,"r":"active"}," ",{"t":2,"r":"class"}]},"f":[{"t":16}]}]};
Ractive.defaults.templates["ux-flex-video"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-flex-video"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["flex-video ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"iframe","a":{"src":[{"t":2,"r":"src"}],"height":[{"t":2,"r":"height"}],"width":[{"t":2,"r":"width"}],"frameborder":[{"t":2,"r":"frameborder"}]},"m":[{"t":4,"f":[{"t":2,"r":"allowfullscreen"}],"r":"allowfullscreen"}],"f":[]}]}],"n":50,"r":".isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":".isDataModel"}]}]};
Ractive.defaults.templates["ux-header"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"h1","m":[{"t":4,"f":["id=\"",{"t":2,"r":"id"},"\""],"r":"id"},{"t":4,"f":["class=\"",{"t":2,"r":"class"},"\""],"r":"class"}],"f":[{"t":4,"f":[{"t":3,"r":"content"}],"n":50,"r":".isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":".isDataModel"}]}],"n":50,"x":{"r":["level"],"s":"_0==1"}},{"t":4,"f":[{"t":7,"e":"h2","m":[{"t":4,"f":["id=\"",{"t":2,"r":"id"},"\""],"r":"id"},{"t":4,"f":["class=\"",{"t":2,"r":"class"},"\""],"r":"class"}],"f":[{"t":4,"f":[{"t":3,"r":"content"}],"n":50,"r":".isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":".isDataModel"}]}],"n":50,"x":{"r":["level"],"s":"_0==2"}},{"t":4,"f":[{"t":7,"e":"h3","m":[{"t":4,"f":["id=\"",{"t":2,"r":"id"},"\""],"r":"id"},{"t":4,"f":["class=\"",{"t":2,"r":"class"},"\""],"r":"class"}],"f":[{"t":4,"f":[{"t":3,"r":"content"}],"n":50,"r":".isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":".isDataModel"}]}],"n":50,"x":{"r":["level"],"s":"_0==3"}},{"t":4,"f":[{"t":7,"e":"h4","m":[{"t":4,"f":["id=\"",{"t":2,"r":"id"},"\""],"r":"id"},{"t":4,"f":["class=\"",{"t":2,"r":"class"},"\""],"r":"class"}],"f":[{"t":4,"f":[{"t":3,"r":"content"}],"n":50,"r":".isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":".isDataModel"}]}],"n":50,"x":{"r":["level"],"s":"_0==4"}},{"t":4,"f":[{"t":7,"e":"h5","m":[{"t":4,"f":["id=\"",{"t":2,"r":"id"},"\""],"r":"id"},{"t":4,"f":["class=\"",{"t":2,"r":"class"},"\""],"r":"class"}],"f":[{"t":4,"f":[{"t":3,"r":"content"}],"n":50,"r":".isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":".isDataModel"}]}],"n":50,"x":{"r":["level"],"s":"_0==5"}},{"t":4,"f":[{"t":7,"e":"h6","m":[{"t":4,"f":["id=\"",{"t":2,"r":"id"},"\""],"r":"id"},{"t":4,"f":["class=\"",{"t":2,"r":"class"},"\""],"r":"class"}],"f":[{"t":4,"f":[{"t":3,"r":"content"}],"n":50,"r":".isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":".isDataModel"}]}],"n":50,"x":{"r":["level"],"s":"_0==6"}}]};
Ractive.defaults.templates["ux-iconbar"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["icon-bar ",{"t":2,"r":"upNumClass"}," ",{"t":2,"r":"class"}],"role":"navigation"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-iconbaritem","a":{"datamodel":[{"t":2,"x":{"r":["getItemData","."],"s":"_0(_1)"}}]}}],"r":"items"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
Ractive.defaults.templates["ux-iconbaritem"] = {"v":3,"t":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"href"}],"class":["item ",{"t":2,"r":"class"}],"tabindex":"0","role":"button"},"m":[{"t":4,"f":["aria-labelledby=\"",{"t":2,"r":"guid"},"\""],"n":50,"r":"labels"},{"t":4,"f":["aria-label=",{"t":2,"r":"arialabel"}],"n":50,"r":"arialabel"}],"f":[{"t":4,"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"src"}]}}],"n":50,"r":"src"}," ",{"t":4,"f":[{"t":7,"e":"label","a":{"id":[{"t":2,"r":"guid"}]},"f":[{"t":4,"f":[{"t":3,"r":"label"}],"n":50,"r":"label"},{"t":4,"n":51,"f":[{"t":16}],"r":"label"}]}],"n":50,"r":"labels"}]}]};
Ractive.defaults.templates["ux-inline-list"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-inline-list ",{"t":2,"r":"class"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-inline-list-item","a":{"datamodel":[{"t":2,"x":{"r":["getItemData","."],"s":"_0(_1)"}}]}}],"r":"items"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
Ractive.defaults.templates["ux-inline-list-item"] = {"v":3,"t":[{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"href"}]},"f":[{"t":2,"r":"text"}]}]}]};
Ractive.defaults.templates["ux-keystrokes"] = {"v":3,"t":[{"t":7,"e":"kbd","f":[{"t":4,"f":[{"t":2,"r":"text"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":"isDataModel"}]}]};
Ractive.defaults.templates["ux-label"] = {"v":3,"t":[{"t":7,"e":"span","a":{"class":[{"t":2,"r":"class"}," label"]},"f":[{"t":4,"f":[{"t":2,"r":"text"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":"isDataModel"}]}]};
Ractive.defaults.templates["ux-li"] = {"v":3,"t":[{"t":7,"e":"li","m":[{"t":4,"f":["class=\"",{"t":2,"r":"class"},"\""],"n":50,"r":"class"},{"t":4,"f":["role=\"",{"t":2,"r":"role"},"\""],"n":50,"r":"role"}],"f":[{"t":16}]}]};
Ractive.defaults.templates["ux-off-canvas"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["off-canvas-wrap ",{"t":2,"r":"getExpandedClass"}," ",{"t":2,"r":"class"}],"data-offcanvas":0},"f":[{"t":7,"e":"div","a":{"class":"inner-wrap"},"f":[{"t":7,"e":"nav","a":{"class":"tab-bar"},"f":[{"t":4,"f":[{"t":7,"e":"section","a":{"class":"left-small"},"f":[{"t":7,"e":"a","a":{"class":"left-off-canvas-toggle menu-icon","aria-expanded":[{"t":2,"x":{"r":["expandedState"],"s":"_0==\"left\"?\"true\":\"false\""}}]},"v":{"tap":{"n":"updateMenu","a":"left"}},"f":[{"t":7,"e":"span"}]}]}],"n":50,"r":"leftItems"}," ",{"t":7,"e":"section","a":{"class":"middle tab-bar-section"},"f":[{"t":7,"e":"h1","a":{"class":"title"},"f":[{"t":2,"r":"title"}]}]}," ",{"t":4,"f":[{"t":7,"e":"section","a":{"class":"right-small"},"f":[{"t":7,"e":"a","a":{"class":"right-off-canvas-toggle menu-icon","aria-expanded":[{"t":2,"x":{"r":["expandedState"],"s":"_0==\"right\"?\"true\":\"false\""}}]},"v":{"tap":{"n":"updateMenu","a":"right"}},"f":[{"t":7,"e":"span"}]}]}],"n":50,"r":"rightItems"}]}," ",{"t":4,"f":[{"t":7,"e":"aside","a":{"class":"left-off-canvas-menu"},"f":[{"t":7,"e":"ux-off-canvas-list","a":{"items":[{"t":2,"r":"leftItems"}]}}]}],"n":50,"r":"leftItems"}," ",{"t":4,"f":[{"t":7,"e":"aside","a":{"class":"right-off-canvas-menu"},"f":[{"t":7,"e":"ux-off-canvas-list","a":{"items":[{"t":2,"r":"rightItems"}]}}]}],"n":50,"r":"rightItems"}," ",{"t":7,"e":"section","a":{"class":"main-section"},"f":[{"t":4,"f":[{"t":3,"r":"mainContent"}],"n":50,"r":"mainContent"},{"t":4,"n":51,"f":[{"t":16}],"r":"mainContent"}]}," ",{"t":7,"e":"a","a":{"class":"exit-off-canvas"},"v":{"tap":"updateMenu"}}]}]}]};
Ractive.defaults.templates["ux-off-canvas-list"] = {"v":3,"t":[{"t":7,"e":"ul","a":{"class":["off-canvas-list ",{"t":2,"r":"class"}]},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"./href"}]},"v":{"tap":"menuSelect"},"m":[{"t":4,"f":["target=\"",{"t":2,"r":"./target"},"\""],"n":50,"r":"./target"}],"f":[{"t":3,"r":"./label"}]}],"n":50,"r":"./href"},{"t":4,"n":51,"f":[{"t":7,"e":"label","f":[{"t":3,"r":"./label"}]}],"r":"./href"}]}],"n":52,"r":"./items"}]}]};
Ractive.defaults.templates["ux-orbit"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-orbit ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"div","a":{"class":["orbit-container ",{"t":2,"r":"currentPageCssClass"}]},"f":[{"t":7,"e":"ul","a":{"class":"pageContainer example-orbit orbit-slides-container"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":["orbit-slides-slide ",{"t":4,"f":["active"],"n":50,"x":{"r":["i","currentPage"],"s":"_0+1===_1"}}]},"v":{"swipeleft":"nextPage","swiperight":"prevPage"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"imagesrc"}],"alt":[{"t":2,"r":"imagealt"}]}}," ",{"t":7,"e":"div","a":{"class":"orbit-caption"},"f":[{"t":2,"r":"caption"}]}]}],"i":"i","r":"items"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}," ",{"t":4,"f":[{"t":7,"e":"li","a":{"class":"orbit-slides-slide"},"f":[{"t":7,"e":"h2","f":["No slides found"]}]}],"x":{"r":["slidesTotal"],"s":"_0==0"}}]}," ",{"t":4,"f":[{"t":7,"e":"a","a":{"class":"orbit-prev"},"v":{"tap":"prevPage"},"f":["Prev ",{"t":7,"e":"span"}]}," ",{"t":7,"e":"a","a":{"class":"orbit-next"},"v":{"tap":"nextPage"},"f":["Next ",{"t":7,"e":"span"}]}],"n":50,"r":"navigation_arrows"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"orbit-slide-number"},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"currentPage"}]}," of ",{"t":7,"e":"span","f":[{"t":2,"r":"slidesTotal"}]}]}],"n":50,"r":"slide_number"}]}," ",{"t":4,"f":[{"t":7,"e":"ol","a":{"class":"orbit-bullets"},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"data-orbit-slide-number":[{"t":2,"r":"i"}],"class":[{"t":4,"f":["active"],"n":50,"x":{"r":["i","currentPage"],"s":"_0+1===_1"}}]},"f":[]}],"i":"i","r":"items"}]}],"n":50,"r":"bullets"}]}]};
Ractive.defaults.templates["ux-page-swipe"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-page-swipe ",{"t":2,"r":"isOnPage"}," ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"div","a":{"class":"pageContainer "},"f":[{"t":8,"r":"content"}]}]}]};
Ractive.defaults.templates["ux-pagination"] = {"v":3,"t":[{"t":7,"e":"ul","a":{"class":"pagination","role":"menubar","aria-label":"Pagination"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-pagination-page","a":{"isDataModel":"true","tabindex":"0","href":[{"t":2,"r":"href"}],"content":[{"t":2,"r":"content"}]}}],"i":"i","r":"pages"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":"isDataModel"}]}]};
Ractive.defaults.templates["ux-pagination-page"] = {"v":3,"t":[{"t":7,"e":"li","a":{"class":[{"t":2,"r":"class"}," ",{"t":4,"f":["arrow"],"r":"arrow"}," ",{"t":4,"f":["current"],"r":"current"}," ",{"t":4,"f":["unavailable"],"r":"unavailable"}]},"m":[{"t":4,"f":["aria-disabled=\"true\""],"r":"unavailable"}],"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"href"}],"target":[{"t":2,"r":"target"}],"title":[{"t":2,"r":"title"}]},"f":[{"t":3,"r":"content"}]}],"n":50,"r":".isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":".isDataModel"}]}]};
Ractive.defaults.templates["ux-panel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["panel ",{"t":2,"r":"class"}]},"f":[{"t":4,"f":[{"t":2,"r":"text"}],"n":50,"r":"text"},{"t":4,"n":51,"f":[{"t":16}],"r":"text"}]}]};
Ractive.defaults.templates["ux-pricingtable"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-pricingtable"},"f":[{"t":7,"e":"ul","a":{"class":["pricing-table ",{"t":2,"r":"class"}]},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"title"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"li","a":{"class":"price"},"f":[{"t":2,"r":"price"}]}," ",{"t":7,"e":"li","a":{"class":"description"},"f":[{"t":2,"r":"description"}]}," ",{"t":4,"f":[{"t":7,"e":"li","a":{"class":"bullet-item"},"f":[{"t":2,"r":"."}]}],"r":"features"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":"isDataModel"}," ",{"t":7,"e":"li","a":{"class":"cta-button"},"f":[{"t":4,"f":[{"t":7,"e":"a","a":{"class":"button disabled","href":"#"},"v":{"tap":"buyNow"},"f":["Coming Soon"]}],"n":50,"x":{"r":["status"],"s":"_0==\"comingsoon\""}}," ",{"t":4,"f":[{"t":7,"e":"a","a":{"class":"button","href":[{"t":2,"r":"href"}]},"v":{"tap":"buyNow"},"f":["Buy Now"]}],"n":50,"x":{"r":["status"],"s":"!_0"}}]}]}]}]};
Ractive.defaults.templates["ux-progress"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["progress ",{"t":2,"r":"class"}]},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":["meter ",{"t":2,"r":"class"}],"style":["width:",{"t":2,"r":"value"},"%"]}}],"r":"meters"}]}]};
Ractive.defaults.templates["ux-reveal"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-reveal reveal ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"a","a":{"target":"_blank","class":"open-reveal-modal"},"v":{"tap":"toggleModal"},"f":[{"t":2,"r":"text"}]}," ",{"t":7,"e":"div","a":{"class":["reveal-modal-bg ",{"t":4,"f":["modal-visible"],"n":50,"r":"modalVisible"}],"aria-hidden":[{"t":2,"r":"modalVisible"}]},"v":{"tap":"closeOnBgClick"},"f":[{"t":7,"e":"div","a":{"class":["reveal-modal ",{"t":2,"r":"size"}," ",{"t":4,"f":["modal-visible"],"n":50,"r":"modalVisible"}],"aria-hidden":[{"t":2,"r":"modalVisible"}]},"v":{"tap":"innerClick"},"f":[{"t":4,"f":[{"t":3,"r":"content"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":"isDataModel"}," ",{"t":4,"f":[{"t":7,"e":"a","a":{"class":"close-reveal-modal","target":"_blank"},"v":{"tap":"toggleModal"},"f":[{"t":3,"r":"closetext"}]}],"n":50,"x":{"r":["hideCloseButton"],"s":"!_0"}}]}]}]}]};
Ractive.defaults.templates["ux-row"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["row ",{"t":2,"r":"class"}]},"f":[{"t":16}]}]};
Ractive.defaults.templates["ux-sidenav"] = {"v":3,"t":[{"t":7,"e":"ul","a":{"class":["side-nav ",{"t":2,"r":"class"}],"role":"menu"},"m":[{"t":4,"f":["title=\"",{"t":2,"r":"title"},"\""],"r":"title"}],"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-li","a":{"class":["heading ",{"t":2,"r":"class"}]},"f":[{"t":2,"r":".label"}]}],"r":"isHeading"}," ",{"t":4,"f":[{"t":7,"e":"ux-li","a":{"class":["divider ",{"t":2,"r":"class"}]}}],"r":"isDivider"}," ",{"t":4,"f":[{"t":7,"e":"ux-li","a":{"class":[{"t":4,"f":["active"],"r":"active"}," ",{"t":2,"r":"class"}],"role":"menuitem"},"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":".href"}]},"f":[{"t":2,"r":".label"}]}]}],"r":"href"}],"n":52,"r":"items"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":"isDataModel"}]}]};
Ractive.defaults.templates["ux-sub-nav"] = {"v":3,"t":[{"t":7,"e":"dl","a":{"class":["sub-nav ux-sub-nav ",{"t":2,"r":"class"}],"role":"menu","title":[{"t":2,"r":"title"},"Menu List"]},"f":[{"t":7,"e":"dt","f":[{"t":4,"f":[{"t":2,"r":"title"},":"],"r":"title"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"dd","a":{"role":"menuitem","class":[{"t":4,"f":["active"],"r":"active"}]},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"href"}],"class":[{"t":2,"r":"class"}]},"f":[{"t":3,"r":"content"}]}]}],"i":"i","r":"items"}],"n":50,"r":"items.length"},{"t":4,"n":51,"f":[{"t":16}],"r":"items.length"}]}]};
Ractive.defaults.templates["ux-switch"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["switch ",{"t":2,"r":"class"}]},"m":[{"t":4,"f":["role=\"",{"t":2,"r":"role"},"\""],"n":50,"r":"role"},{"t":4,"f":[" aria-label=\"",{"t":2,"r":"arialabel"},"\""],"n":50,"r":"arialabel"},{"t":4,"f":[" tabindex=\"",{"t":2,"r":"tabindex"},"\""],"n":50,"r":"tabindex"}],"v":{"tap":"clickHandler"},"f":[{"t":7,"e":"input","m":[{"t":4,"f":["type=\"radio\" group=\"",{"t":2,"r":"group"},"\""],"n":50,"r":"group"},{"t":4,"n":51,"f":["type=\"checkbox\""],"r":"group"},{"t":4,"f":[" name=\"",{"t":2,"r":"name"},"\""],"n":50,"r":"name"}],"a":{"checked":[{"t":2,"r":"checked"}]}}," ",{"t":7,"e":"label"}]}]};
Ractive.defaults.templates["ux-tabarea"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["tabs-area ",{"t":2,"r":"class"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-tablinks","a":{"items":[{"t":2,"r":"items"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-tablink","a":{"id":[{"t":2,"r":".id"}],"active":[{"t":2,"r":".active"}]},"f":[{"t":2,"r":".title"}]}],"n":52,"r":"items"}]}," ",{"t":7,"e":"ux-tabpanes","a":{"items":[{"t":2,"r":"items"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-tabpane","f":[{"t":3,"r":".content"}]}],"n":52,"r":"items"}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
Ractive.defaults.templates["ux-table"] = {"v":3,"t":[{"t":7,"e":"table","a":{"class":["ux-table ",{"t":2,"r":".class"}]},"m":[{"t":4,"f":["role=\"",{"t":2,"r":"role"},"\""],"n":50,"r":"role"}],"f":[{"t":4,"f":[{"t":7,"e":"caption","f":[{"t":3,"r":".caption"}]}],"n":50,"r":".caption"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"thead","m":[{"t":4,"f":["class=\"",{"t":2,"r":".header.class"},"\""],"n":50,"r":".header.class"}],"f":[{"t":7,"e":"tr","f":[{"t":4,"f":[{"t":7,"e":"th","m":[{"t":4,"f":["id=\"",{"t":2,"r":".id"},"\""],"n":50,"r":".id"},{"t":4,"f":["scope=\"",{"t":2,"r":".scope"},"\""],"n":50,"r":".scope"},{"t":4,"f":["width=\"",{"t":2,"r":".width"},"\""],"n":50,"r":".width"},{"t":4,"f":["height=\"",{"t":2,"r":".height"},"\""],"n":50,"r":".height"},{"t":4,"f":["colspan=\"",{"t":2,"r":".colspan"},"\""],"n":50,"r":".colspan"},{"t":4,"f":["rowspan=\"",{"t":2,"r":".rowspan"},"\""],"n":50,"r":".rowspan"},{"t":4,"f":["headers=\"",{"t":2,"r":".headers"},"\""],"n":50,"r":".headers"},{"t":4,"f":["class=\"",{"t":2,"r":".class"},"\""],"n":50,"r":".class"}],"f":[{"t":3,"r":".label"}]}],"n":52,"r":".header.cell"}]}]}],"n":50,"r":".header"}," ",{"t":4,"f":[{"t":7,"e":"tbody","m":[{"t":4,"f":["class=\"",{"t":2,"r":".body.class"},"\""],"n":50,"r":".body.class"}],"f":[{"t":4,"f":[{"t":7,"e":"tr","m":[{"t":4,"f":["class=\"",{"t":2,"r":".class"},"\""],"n":50,"r":".class"}],"f":[{"t":4,"f":[{"t":7,"e":"td","m":[{"t":4,"f":["id=\"",{"t":2,"r":".id"},"\""],"n":50,"r":".id"},{"t":4,"f":["scope=\"",{"t":2,"r":".scope"},"\""],"n":50,"r":".scope"},{"t":4,"f":["width=\"",{"t":2,"r":".width"},"\""],"n":50,"r":".width"},{"t":4,"f":["height=\"",{"t":2,"r":".height"},"\""],"n":50,"r":".height"},{"t":4,"f":["colspan=\"",{"t":2,"r":".colspan"},"\""],"n":50,"r":".colspan"},{"t":4,"f":["rowspan=\"",{"t":2,"r":".rowspan"},"\""],"n":50,"r":".rowspan"},{"t":4,"f":["headers=\"",{"t":2,"r":".headers"},"\""],"n":50,"r":".headers"},{"t":4,"f":["class=\"",{"t":2,"r":".class"},"\""],"n":50,"r":".class"}],"f":[{"t":3,"r":".label"}]}],"n":52,"r":".cell"}]}],"n":52,"r":".body.rows"}]}],"n":50,"r":".body"}," ",{"t":4,"f":[{"t":7,"e":"tfoot","m":[{"t":4,"f":["class=\"",{"t":2,"r":".footer.class"},"\""],"n":50,"r":".footer.class"}],"f":[{"t":7,"e":"tr","f":[{"t":4,"f":[{"t":7,"e":"td","m":[{"t":4,"f":["id=\"",{"t":2,"r":".id"},"\""],"n":50,"r":".id"},{"t":4,"f":["scope=\"",{"t":2,"r":".scope"},"\""],"n":50,"r":".scope"},{"t":4,"f":["width=\"",{"t":2,"r":".width"},"\""],"n":50,"r":".width"},{"t":4,"f":["height=\"",{"t":2,"r":".height"},"\""],"n":50,"r":".height"},{"t":4,"f":["colspan=\"",{"t":2,"r":".colspan"},"\""],"n":50,"r":".colspan"},{"t":4,"f":["rowspan=\"",{"t":2,"r":".rowspan"},"\""],"n":50,"r":".rowspan"},{"t":4,"f":["headers=\"",{"t":2,"r":".headers"},"\""],"n":50,"r":".headers"},{"t":4,"f":["class=\"",{"t":2,"r":".class"},"\""],"n":50,"r":".class"}],"f":[{"t":3,"r":".label"}]}],"n":52,"r":".footer.cell"}]}]}],"n":50,"r":".footer"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":"isDataModel"}]}]};
Ractive.defaults.templates["ux-tablink"] = {"v":3,"t":[{"t":7,"e":"li","a":{"class":["tab-title ",{"t":2,"r":".class"}," ",{"t":4,"f":["active"],"n":50,"r":".active"}],"role":"presentational"},"f":[{"t":7,"e":"a","a":{"href":["#",{"t":2,"r":".id"}]},"v":{"tap":"changeTab"},"f":[{"t":16}]}]}]};
Ractive.defaults.templates["ux-tablinks"] = {"v":3,"t":[{"t":7,"e":"ul","a":{"class":["tabs ",{"t":4,"f":["vertical"],"r":"vertical"}," ",{"t":2,"r":"class"}],"role":"tablist"},"f":[{"t":8,"r":"content"}]}]};
Ractive.defaults.templates["ux-tabpane"] = {"v":3,"t":[{"t":7,"e":"section","a":{"class":["content ",{"t":2,"r":"class"}," ",{"t":4,"f":["active"],"n":50,"r":"active"},{"t":4,"n":51,"f":["hide"],"r":"active"}],"role":"tabpanel","aria-hidden":[{"t":4,"f":["false"],"n":50,"r":"active"},{"t":4,"n":51,"f":["true"],"r":"active"}]},"f":[{"t":16}]}]};
Ractive.defaults.templates["ux-tabpanes"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["tabs-content ",{"t":2,"r":"class"}]},"f":[{"t":8,"r":"content"}]}]};
Ractive.defaults.templates["ux-thumbnail"] = {"v":3,"t":[{"t":7,"e":"a","a":{"class":"th","role":"button","aria-label":"Thumbnail","href":[{"t":2,"r":"href"}]},"f":[{"t":7,"e":"img","a":{"aria-hidden":"true","src":[{"t":2,"r":"src"}]}}]}]};
Ractive.defaults.templates["ux-tooltip"] = {"v":3,"t":["This is just a normal text but ",{"t":7,"e":"span","o":{"n":"tooltip","d":[{"t":2,"r":"."}]},"a":{"tabindex":"0"},"f":[{"t":7,"e":"strong","f":["here"]}]}," is a tooltip."]};
Ractive.defaults.templates["ux-top-bar"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-top-bar ",{"t":4,"f":["fixed"],"n":50,"r":"isfixed"}," ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"nav","a":{"class":["top-bar ",{"t":4,"f":["expanded"],"n":50,"r":"isexpanded"}],"data-top-bar":0,"role":"navigation","data-options":[{"t":2,"r":"dataoptions"}]},"f":[{"t":4,"f":[{"t":7,"e":"ul","a":{"class":"title-area"},"f":[{"t":7,"e":"li","a":{"class":"name"},"f":[{"t":7,"e":"h1","f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"href"}]},"f":[{"t":2,"r":"title"}]}]}]}," ",{"t":7,"e":"li","a":{"class":"toggle-topbar menu-icon"},"f":[{"t":7,"e":"a","a":{"href":"#"},"v":{"tap":"toggleMenu"},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"menulabel"}]}]}]}]}],"n":50,"r":"menulabel"}," ",{"t":7,"e":"section","a":{"class":"top-bar-section"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-top-bar-items","a":{"class":"right","items":[{"t":2,"r":"rightitems"}]}}],"n":50,"r":"rightitems"}," ",{"t":4,"f":[{"t":7,"e":"ux-top-bar-items","a":{"class":"left","items":[{"t":2,"r":"leftitems"}]}}],"n":50,"r":"leftitems"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]}]}]};
Ractive.defaults.templates["ux-top-bar-item"] = {"v":3,"t":[{"t":7,"e":"li","a":{"class":[{"t":2,"r":"topBarItemCssClass"}]},"f":[{"t":4,"f":[" ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"href"}]},"f":[{"t":3,"r":"label"}]}," ",{"t":4,"f":[" ",{"t":7,"e":"ux-top-bar-items","a":{"class":"dropdown","items":[{"t":2,"r":"items"}]}}],"n":50,"r":"items"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":"isDataModel"}]}]};
Ractive.defaults.templates["ux-top-bar-items"] = {"v":3,"t":[{"t":7,"e":"ul","a":{"class":["ux-top-bar-items ",{"t":2,"r":"class"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-top-bar-item","a":{"datamodel":[{"t":3,"r":"."}]}}],"n":52,"r":"items"}],"n":50,"r":"items"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"items"}]}]};
Ractive.transitions.equalizer = /*jshint unused:false */
/*jshint -W025 */

function(t) {

	if (t.isIntro) {
		var node = t.node,
			parent = t.root.el,
			identifier = t.node.attributes['data-equalizer-watcher'].value;

		// find parent
		while (node !== null) {
			node = node.parentElement;
			if (node !== null &&
				node.attributes['data-equalizer'] &&
				node.attributes['data-equalizer'].value === identifier) {

				parent = node;
				node = null;
			}
		}
		var listeners = parent.querySelectorAll('[data-equalizer-watcher="' + identifier + '"]');
		var max = _.max(listeners, function(listener) {
			return listener.offsetHeight;
		});

		if (max) {
			t.setStyle('height', max.offsetHeight  + 'px');
		}

		t.complete(true);
	}
}

Ractive.decorators.tooltip = /*jshint unused:false */
/*jshint -W025 */

function(node, options) {
	var tooltip, handlers, eventName, enterSection, leaveSection,
		config = {
			tagElement: options.tagElement || 'span',
			className: options.className || 'tooltip',
			selectorName: options.selectorName || 'tooltip' + Math.floor((Math.random() * 1000000000000000) + 1),
			content: options.content || '',
			delay: options.delay || 0,
			show_on: options.show_on || 'small medium large'
		};

	enterSection = function() {
		var tooltip_exists = document.getElementById(config.selectorName);
		if (tooltip_exists || !config.content.length) {
			return;
		}

		node.setAttribute('aria-haspopup', 'true');
		node.setAttribute('aria-describedby', config.selectorName);
		node.className = node.className + ' ux-tooltip ' + config.show_on;

		tooltip = document.createElement(config.tagElement);
		tooltip.id = config.selectorName;
		tooltip.className = config.className;
		tooltip.setAttribute('role', 'tooltip');
		tooltip.innerHTML = config.content;

		if (config.delay) {
			// for screen-reader accessibility purposes
			tooltip.setAttribute('style', 'left:-100000px;');
		}

		node.appendChild(tooltip);

		tooltip.addEventListener('click', leaveSection);

		setTimeout(function () {
			tooltip.setAttribute('style', 'left:inherit;');
		}, config.delay);
	};

	leaveSection = function () {
		if (tooltip && tooltip.parentNode) {
			tooltip.parentNode.className = tooltip.parentNode.className.replace(' ux-tooltip ' + config.show_on, '');
			tooltip.parentNode.removeChild(tooltip);
		}
	};

	handlers = {
		mouseover: enterSection,
		focus: enterSection,

		mouseleave: leaveSection,
		blur: leaveSection
	};

	for (eventName in handlers) {
		if (handlers.hasOwnProperty(eventName)) {
			node.addEventListener(eventName, handlers[eventName]);
		}
	}

	return {
		teardown: function () {
			for (eventName in handlers) {
				if (handlers.hasOwnProperty(eventName)) {
					node.removeEventListener(eventName, handlers[ eventName ]);
				}
			}
		}
	};
}

Ractive.components["ux-accordion"] = Ractive.extend({

	template: Ractive.defaults.templates['ux-accordion'],

	isolated: true,

	computed: {
		guid: function () {
			return this._guid;
		}
	},

	oninit: function () {

		this.set('componentItems', this.findAllChildComponents('ux-accordionitem'));

		this.on('*.changeAccordion', function (srcItem) {

			_.each(this.get('componentItems'), function (component) {

				// Is this the item the user clicked on?
				if (component._guid === srcItem._guid) {

					// Support open and close behaviours with repeated clicking by User.
					component.toggle('active');

				} else {

					// Not where the User clicked, so close it (if open).
					component.set('active', false);

				}

			});
		});

	}

});

Ractive.components["ux-accordionitem"] = Ractive.extend({

	template: Ractive.defaults.templates['ux-accordionitem'],

	isolated: true,

	computed: {
		guid: function () {
			return this._guid;
		}
	},

	oninit: function () {

		var anchorComponent = this.findComponent('ux-anchor'),
			contentComponent = this.findComponent('ux-content');

		// Link the anchor to the content by the content's id for nice html.
		anchorComponent.set({
			href: '#' + contentComponent._guid
		});

		contentComponent.set({
			active: this.get('active') || false
		});

		// Listen for click event on accordion title element, and then fire a semantic event for accordion.
		anchorComponent.on('anchorClicked', function (e) {
			this.fire('changeAccordion', this);
			return false;
		}.bind(this));

		this.set({
			contentComponent: contentComponent,
			initialized: true
		});

	},

	onchange: function () {

		if (!this.get('initialized')) {
			// Not ready yet for onchange.
			return;
		}

		this.get('contentComponent').set({
			active: this.get('active')
		});

	}

});

Ractive.components["ux-alert"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-alert'],
	oninit: function (options) {
		this.on('closeClicked', function () {
			this.teardown();
			return false;
		});
	}
});

Ractive.components["ux-anchor"] = /*global Ractive */
/*jshint sub:true*/
Ractive.extend({
	template: Ractive.defaults.templates['ux-anchor'],
	isolated: true,
	computed: {
		guid: function () {
			return this._guid;
		}
	},
	onconfig: function () {
		this.on('anchorClicked', function () {
			var customEvent = this.get('ontap');
			if (customEvent) {
				var customParams = customEvent.split(':');
				var customEventName = customParams[0];
				if (customParams.length > 1) {
					var params = customParams[1].split(',');
					this.fire.apply(this, [customEventName, this].concat(params));
				} else {
					this.fire(customEvent, this);
				}
				return false;
			}
		});
	}
});

Ractive.components["ux-breadcrumb-item"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-breadcrumb-item'],
	isolated: true
});

Ractive.components["ux-breadcrumbs"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-breadcrumbs'],
	isolated: true
});

Ractive.components["ux-button"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-button'],
	isolated: true,
	computed: {
		isDisabled: function () {
			var disabled = this.get('disabled');
			if (typeof disabled === 'undefined') {
				return false;
			}
			return disabled !== '';
		}
	},
	data: function () {
		return {
			type: 'button'
		};
	},
	clickHandler: function () {

		// if a click event is specified propagate the click event
		if (this.get('onclick')) {
			console.log('Firing event');
			this.fire(this.get('onclick'), this);
		}

		// prevent bubbling
		return true;
	}
});

Ractive.components["ux-col"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-col'],
	isolated: true
});

Ractive.components["ux-content"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-content'],
	isolated: true,
	computed: {
		guid: function () {
			return this._guid;
		}
	}
});

Ractive.components["ux-flex-video"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-flex-video'],
	isolated: true
});

Ractive.components["ux-header"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-header'],
	isolated: true,
	data: function () {
		return {
			level: 1
		};
	}
});

Ractive.components["ux-iconbar"] = Ractive.extend({

	getUpNumClass: function (num) {

		var supportedWords = [
			'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight'
		];

		if (!supportedWords[num]) {
			//console.error('ux-iconbar#numberToWord: num NOT supported: ' + num);
			return '';
		}

		return supportedWords[num] + '-up';

	},

	template: Ractive.defaults.templates['ux-iconbar'],

	isolated: true,

	data: {

		getItemData: function (itemData) {
			// Nothing needs to be mapped, but we don't want parent data leaking down.
			return itemData;
		}

	},

	computed: {

		/**
		* TODO Move to generic helpers location?
		* @returns {string} The number of child items as a css class, e.g. "one-up", "three-up", etc.
		*/
		upNumClass: function () {

			var items = this.get('items');

			if (!items) {
				return '';
			}

			// Data-driven component has items data.
			return this.getUpNumClass(items.length);

		}

	},

	oninit: function () {

		// Only needed for markup mode.
		if (!this.get('isDataModel')) {
			var itemComponents = this.findAllChildComponents('ux-iconbaritem');
			var cssClass = this.get('class') || '';
			this.set('class', cssClass + ' ' + this.getUpNumClass(itemComponents.length));
		}

	}

});

Ractive.components["ux-iconbaritem"] = Ractive.extend({

	template: Ractive.defaults.templates['ux-iconbaritem'],

	isolated: true,

	data: {
		labels: true
	},

	computed: {
		guid: function () {
			return this._guid;
		}
	}

});

Ractive.components["ux-inline-list"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-inline-list'],
	isolated: true,
	data: {
		getItemData: function (itemData) {
			// Nothing needs to be mapped, but we don't want parent data leaking down.
			return itemData;
		}
	}
});

Ractive.components["ux-inline-list-item"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-inline-list-item'],
	isolated: true
});

Ractive.components["ux-keystrokes"] = Ractive.extend({
	isolated: true,
	template: Ractive.defaults.templates['ux-keystrokes']
});

Ractive.components["ux-label"] = Ractive.extend({
	isolated: true,
	template: Ractive.defaults.templates['ux-label']
});

Ractive.components["ux-li"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-li'],
	isolated: true
});

Ractive.components["ux-off-canvas"] = Ractive.extend({

	template: Ractive.defaults.templates['ux-off-canvas'],

	isolated: true,

	data: function () {
		return {
			expandedState: '',
			leftItems: [],
			rightItems: [],
			mainContent: ''
		};
	},

	computed: {

		/**
		 * @returns {string} CSS class: left = move-right or right = move-left.
		 */
		getExpandedClass: function () {

			// Default is empty string for no css class.
			var classMap = {
				'left': 'move-right',
				'right': 'move-left'
			};

			return classMap[this.get('expandedState')] || '';

		}

	},

	oninit: function () {

		// You can expand from left or right, or none. Can't do both at the same time.
		this.on('updateMenu', function (event, direction) {
			this.set('expandedState', direction);
		});

		this.on('*.menuSelect', function (event) {
			this.set('expandedState', '');
		});

	}

});

Ractive.components["ux-off-canvas-list"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-off-canvas-list'],
	isolated: true
});

Ractive.components["ux-orbit"] = Ractive.extend({

	template: Ractive.defaults.templates['ux-orbit'],

	isolated: true,

	data: {
		currentPage: 1,
		navigation_arrows: true,
		slide_number: true,
		bullets: true
	},

	computed: {
		currentPageCssClass: function () {
			return 'currentPage' + this.get('currentPage');
		}
	},

	oninit: function () {

		this.on('nextPage', function (e) {
			var nextPage = this.get('currentPage') + 1,
				slideTotal = this.get('slidesTotal');

			nextPage = nextPage > slideTotal ? slideTotal : nextPage;
			this.set('currentPage', nextPage);
			return false;
		});

		this.on('prevPage', function (e) {
			var prevPage = this.get('currentPage') - 1;
			// FIXME Quick hack for bounds.
			prevPage = prevPage < 1 ? 1 : prevPage;
			this.set('currentPage', prevPage);
			return false;
		});

	},

	oncomplete: function () {
		var slidesTotal = this.findAll('.orbit-slides-slide').length;
		this.set('slidesTotal', slidesTotal);
	}

});

Ractive.components["ux-pagination"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-pagination'],
	data: {
		currentPage: 1,
		displayPages: 10,
		nextText: '&raquo;',
		prevText: '&laquo;',
		skipText: '&hellip;',
		isCollapsed: function (current, page, total, visible) {
			// page is always shown if it is at the ends or is the current page
			if (page === 1 || page === current || page === total) {
				return false;
			}

			// are we showing 1 or 2 collapsed sections?
			if (current < visible / 2) {
				// 1 collapsed section
				return page > visible - 2;
			} else if (total - current <= visible / 2) {
				// 1 collapsed section
				return page < total - visible + 3;
			} else {
				// 2 collapsed sections
				return Math.abs(current - page) > (visible - 4) / 2;
			}
		}
	},
	computed: {
		pages: function () {
			var pages        = [],
				currentPage  = this.get('currentPage'),
				totalPages   = this.get('totalPages'),
				displayPages = this.get('displayPages'),
				isCollapsed  = this.get('isCollapsed'),
				splitStart   = false;

			pages.push({
				arrow: true,
				unavailable: currentPage !== 1,
				content: this.get('prevText'),
				page: currentPage - 1,
				class: 'prev'
			});

			for (var i = 1; i <= totalPages; i++) {
				if (isCollapsed(currentPage, i, totalPages, displayPages)) {
					if (!splitStart) {
						splitStart = true;
						pages.push({
							unavailable: true,
							content: this.get('skipText'),
							class: 'skip'
						});
					}
				} else {
					splitStart = false;
					pages.push({
						current: currentPage === i,
						content: i,
						page: i,
						class: 'page-' + i
					});
				}
			}

			pages.push({
				arrow: true,
				unavailable: currentPage !== totalPages,
				content: this.get('nextText'),
				page: currentPage + 1,
				class: 'next'
			});

			return pages;
		}
	}
});

Ractive.components["ux-pagination-page"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-pagination-page'],
	onrender: function () {
		this.on('anchorClicked', function () {
			this.fire('setPagination', this.get('page'));
		}.bind(this));
	}
});

Ractive.components["ux-panel"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-panel'],
	isolated: true
});

Ractive.components["ux-pricingtable"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-pricingtable'],
	isolated: true,
	oninit: function () {

		this.on('buyNow', function (syntheticEvent) {

			if (!syntheticEvent.context.status || 'buynow' === syntheticEvent.context.status) {
				return;
			}

			// Else - it's in a disabled state, so stop the browser's default action for an anchor.
			syntheticEvent.original.preventDefault();

		});

	}
});

Ractive.components["ux-progress"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-progress'],
	isolated: true,
	computed: {
		meters: function () {
			return this.get('items') || { class: '', value: this.get('value')};
		}
	}
});

Ractive.components["ux-reveal"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-reveal'],
	isolated: true,

	data: {
		modalVisible: false,
		closetext: '&times;',
		closeOnEsc: true,
		lockBackground: false,
		hideClose: false
	},

	oninit: function () {
		this.on('toggleModal', function (e) {
			this.toggle('modalVisible');
			this.fire('toggleReveal', e);
			return false;
		});

		this.on('innerClick', function (e) {
			// captures clicks inside the modal, to prevent event propagation from closing the modal.
			return false;
		});

		this.observe('modalVisible', function (newValue, oldValue, keypath) {
			document.body.style.overflow = (newValue === true) ? 'hidden' : 'auto';

			if (this.get('closeOnEsc')) {
				if (newValue === true) {
					this.registerCloseOnEsc();
				} else {
					this.unregisterCloseOnEsc();
				}
			}

			return false;
		});

		this.on('closeOnBgClick', function (e) {
			if (!this.get('lockBackground')) {
				this.fire('toggleModal', e);
			}
		});
	},

	// close the modal when ESC key is pressed
	closeOnEsc: function (evt) {
		evt = evt || window.event;
		var isEscape = false;
		// evt.keyCode is about to be deprecated, hence checking 'key' first
		if (evt.key) {
			isEscape = evt.key === 'Escape';
		} else {
			isEscape = evt.keyCode === 27;
		}
		if (isEscape) {
			this.set('modalVisible', false);
		}
	},

	registerCloseOnEsc: function () {
		document.addEventListener('keydown', this.closeOnEsc.bind(this), false);
	},

	unregisterCloseOnEsc: function () {
		document.removeEventListener('keydown', this.closeOnEsc.bind(this), false);
	},

	onteardown: function () {
		this.unregisterCloseOnEsc();
	}

});

Ractive.components["ux-row"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-row'],
	isolated: true
});

Ractive.components["ux-sidenav"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-sidenav'],
	isolated: true
});

Ractive.components["ux-sub-nav"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-sub-nav']
});

Ractive.components["ux-switch"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-switch'],
	isolated: true,
	data: function () {
		return {
			type: 'switch',
			checked: false
		};
	},

	oninit: function () {
		this.on('clickHandler', function (event) {
			this.toggle('checked');
			this.fire(this.get('onclick'), event);
			return false;
		});
	}

});

Ractive.components["ux-tabarea"] = Ractive.extend({

	template: Ractive.defaults.templates['ux-tabarea'],

	isolated: true,

	oninit: function () {

		var tabLinks = this.findComponent('ux-tablinks');
		var tabPanes = this.findComponent('ux-tabpanes');

		if (!tabLinks || !tabPanes) {
			// Because datamodel driven components can trigger this too early?
			return;
		}

		var tabLink = tabLinks.findAllChildComponents('ux-tablink');
		var tabPane = tabPanes.findAllChildComponents('ux-tabpane');

		_.each(tabLink, function (link, i) {
			var childPane = tabPane[i];
			if (childPane) {
				link.set({
					tabPane: childPane,
					uid: link._guid
				});
			}
		});
	}

});

Ractive.components["ux-table"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-table'],
	isolated: true,
	data: {
		role: 'grid'
	}
});

Ractive.components["ux-tablink"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-tablink'],
	components: Ractive.components,
	isolated: true,
	oninit: function () {
		var active = this.get('active') || false;
		var tabPane = this.get('tabPane') || null;

		if (tabPane) {
			tabPane.set('active', active);
		}
	}
});

Ractive.components["ux-tablinks"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-tablinks'],
	isolated: true,
	oninit: function () {

		// Defensive code for isomorphic execution.
		if (typeof window !== 'undefined') {
			// If there is a hash. We want to check deeplinking.
			if (window.location.hash.length) {
				var hash = window.location.hash.substr(1);
				var components = this.findAllChildComponents('ux-tablink');

				var hasMatchingHash = _.filter(components, function (component) {
					return component.get('id') === hash;
				});

				if (hasMatchingHash.length) {
					_.each(components, function (component) {
						var isActive = component.get('id') === hash;
						component.set('active', isActive);
						component.get('tabPane').set('active', isActive);
					});
				}

			}
		}

		this.on('*.changeTab', function (event) {

			/**
			 * This currently doesnt work.
			 * @see https://github.com/ractive-foundation/ractive-foundation/issues/122
			 */
			event.original.preventDefault();

			var components = this.findAllChildComponents('ux-tablink');

			_.each(components, function (component) {
				var isActive = component._guid === event.context.uid;
				component.set('active', isActive);
				component.get('tabPane').set('active', isActive);
			});

			this.fire.apply(this, [event.name].concat(arguments));

			return false;
		});
	}
});

Ractive.components["ux-tabpane"] = Ractive.extend({

	template: Ractive.defaults.templates['ux-tabpane'],

	isolated: true

});

Ractive.components["ux-tabpanes"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-tabpanes'],
	isolated: true
});

Ractive.components["ux-thumbnail"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-thumbnail']
});

Ractive.components["ux-tooltip"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-tooltip']
});

Ractive.components["ux-top-bar"] = Ractive.extend({

	template: Ractive.defaults.templates['ux-top-bar'],

	isolated: true,

	oninit: function () {

		var self = this;

		this.on('toggleMenu', function (e) {

			if (self.get('isexpanded')) {
				self.set('isexpanded', false);
			} else {
				self.set('isexpanded', true);
			}

			return false;

		});

	},

	oncomplete: function () {

		// Defensive code for isomorphic execution.
		if (typeof window !== 'undefined') {

			var self = this;
			var topbar = self.find('.top-bar');
			var topbarOffset = self.elementOffset(topbar);

			window.addEventListener('scroll', function (e) {
				if (self.get('issticky')) {
					self.set('isfixed', self.pageYOffset() > topbarOffset.top);
				}
			});

		}

	}

});

Ractive.components["ux-top-bar-item"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-top-bar-item'],
	isolated: true,
	computed: {
		topBarItemCssClass: function () {
			var classes = [this.get('class')],
				active  = this.get('active'),
				hasForm = this.get('hasForm'),
				items   = this.get('items');
			if (active) {
				classes.push('active');
			}
			if (hasForm) {
				classes.push('has-form');
			}
			if (items && items.length > 0) {
				// Note: not-click needed for focus/hover with html class=js. Silly.
				classes.push('has-dropdown not-click');
			}
			return classes.join(' ');
		}
	}
});

Ractive.components["ux-top-bar-items"] = Ractive.extend({
	template: Ractive.defaults.templates['ux-top-bar-items'],
	isolated: true
});

/* jshint ignore:end */
}));
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (typeof define === 'function' && define.amd) {
    define('hammerjs',[],function() {
        return Hammer;
    });
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');

;(function (root, factory) {

  if (typeof define === 'function' && define.amd) {
    define('RactiveTouch',['ractive', 'hammerjs'], factory);
  }

  else if (typeof module !== 'undefined') {
    factory(require('ractive'), require('hammerjs'));
  }

  else {
    factory(root.Ractive, root.Hammer);
  }

}(this, function (Ractive, Hammer) {

  // Check the recognizers documentation.
  // http://hammerjs.github.io/recognizer-tap

  var defaults = {
    tap: {
      recognizerClass: Hammer.Tap,
      options: {
        time: 500
      },
      events: [
        'tap' 
      ]
    },
    doubletap: {
      recognizerClass: Hammer.Tap,
      options: {
        taps: 2,
        event: 'doubletap'
      },
      recognizeWith: ['tap'],
      events: [
        'doubletap' 
      ]
    },
    swipe: {
      recognizerClass: Hammer.Swipe,
      options: {},
      events: [
        'swipe',
        'swipeleft',
        'swiperight',
        'swipeup',
        'swipedown' 
      ]
    },
    pan: {
      recognizerClass: Hammer.Pan,
      options: {
        direction: Hammer.DIRECTION_HORIZONTAL
      },
      recognizeWith: ['swipe'],
      events: [
        'pan',
        'panstart',
        'panmove',
        'panend',
        'pancancel',
        'panleft',
        'panright',
        'panup',
        'pandown' 
      ]
    },
    press: {
      recognizerClass: Hammer.Press,
      options: {},
      events: [
        'press' 
      ]
    },
    rotate: {
      recognizerClass: Hammer.Rotate,
      options: {},
      events: [
        'rotate',
        'rotatestart',
        'rotatemove',
        'rotateend',
        'rotatecancel' 
      ]
    },
    pinch: {
      recognizerClass: Hammer.Pinch,
      options: {},
      recognizeWith: ['rotate'],
      events: [
        'pinch',
        'pinchstart',
        'pinchmove',
        'pinchend',
        'pinchcancel',
        'pinchin',
        'pinchout' 
      ]
    }
  };

  var aliases;

  // bind all events using buildEvent
  for (var recognizerName in defaults) {
    if (!defaults.hasOwnProperty(recognizerName)) continue;
    
    var events = defaults[recognizerName].events;
    for (var i = 0; i < events.length; i++) {
      buildEvent(events[i], recognizerName, defaults[recognizerName]);
    }
  }

  /**
   * buildEvent : buildEvent(event, recognizerName, config)
   * (private) registers an event handler for buildEvent.
   *
   *     buildEvent('panstart', 'pan', { ... });
   */

  function buildEvent(eventName, recognizerName, config) {
    Ractive.events[eventName] = buildEventHandler(eventName, recognizerName, config);
  }

  /**
   * buildEventHandler() : buildEventHandler(event, recognizerName, config)
   * (private) Creates the event handler for a given `eventName` that will be
   * registered to `Ractive.events`.
   */

  function buildEventHandler(eventName, recognizerName, config) {
    return function (node, fire) {
      var hammerManager = getHammerManager(node);

      var recognizerExists = (hammerManager.get(recognizerName) !== null);

      if (!recognizerExists) {
        // init with default options
        var recognizer = new config.recognizerClass(config.options);

        // Hammer.Recognizer.set merges it on top of the defaults supplied above
        var options = parseOptions(node, recognizerName);
        if (options)
          recognizer.set(options);

        hammerManager.add(recognizer);
        
        updateRecognizeWith(hammerManager);
      }

      // register the handler
      hammerManager.on(eventName, function (e) {
        fire({
          node: node,
          original: e
        });
      });

      // handle exits
      function teardown() {
        getHammerManager(node).destroy();
        delete node._hammer;
      }

      return { teardown: teardown };
    };
  }

  /**
   * updateRecognizeWith : updateRecognizeWith(hammerManager)
   * (private) Sets recognizeWith if defaults have it
   *
   * Since we add recognizers dynamically and without any strict order,
   *  we need to guard against trying to set a requireWith for a recognizer
   *  that haven't been created yet.
   * 
   */
  function updateRecognizeWith(hammerManager) {
    for (var i = 0; i < hammerManager.recognizers.length; i++) {
      var recognizer = hammerManager.recognizers[i];
      var recognizerName = recognizer.options.event;

      if (!defaults[recognizerName].hasOwnProperty('recognizeWith')) continue;
      
      var recognizeWiths = defaults[recognizerName].recognizeWith;
      for (var k = 0; k < recognizeWiths.length; k++) {
        // Verify that the recgonizer we're trying to depend on is really there
        if (!hammerManager.get(recognizeWiths[k])) continue;

        // It's safe to recognizeWith multiple times for the same recognizer
        recognizer.recognizeWith(recognizeWiths[k]);
      }
    }
  }

  /**
   * parseOptions : parseOptions(node, key)
   * (private) Returns options for a given DOM node.
   *
   *     node = <div data-swipe-direction='left' data-swipe-threshold='2'>
   *
   *     parseOptions(node, 'swipe')
   *     => { direction: 'left', threshold: 2 }
   */

  function parseOptions(node, key) {
    var attrs = node.attributes,
        output,
        re = new RegExp("^(?:data-)?"+key+"-(.*)$");

    for (var i = attrs.length-1; i >= 0; i--) {
      var attr = attrs[i],
          m = attr.name.match(re);

      if (!m) continue;
      if (!output) output = {};
      output[m[1]] = parseHammerValue(attr.value, m[1]);
    }

    return output;
  }

  /**
   * parseHammerValue : parseHammerValue(str, key)
   * (private) Value-izes a given string `str`, converting it to a number as
   * needed. If `key` is given, it can also resolve aliases for that given
   * key.
   *
   * Used by `getData()`. 
   *
   *     parseHammerValue("100")   => 100
   *     parseHammerValue("right") => "right"
   *     parseHammerValue("right", "direction") => Hammer.DIRECTION_RIGHT
   */

  function parseHammerValue(str, key) {
    if (str.match && str.match(/^-?\d+(?:\.\d+)?$/)) return +str;
    return (aliases[key] && aliases[key][str]) ||
      aliases.all[str] || str;
  }

  /*
   * Aliases for `val()`.
   */

  aliases = {
    all: {
      'true': true,
      'false': false,
      'undefined': undefined,
      'null': null
    },
    direction: {
      'none': Hammer.DIRECTION_NONE,
      'all': Hammer.DIRECTION_ALL,
      'up': Hammer.DIRECTION_UP,
      'down': Hammer.DIRECTION_DOWN,
      'left': Hammer.DIRECTION_LEFT,
      'right': Hammer.DIRECTION_RIGHT,
      'horizontal': Hammer.DIRECTION_HORIZONTAL,
      'vertical': Hammer.DIRECTION_VERTICAL
    }
  };

  /**
   * getHammerManager : getHammerManager(node)
   * (private) Returns the `HammerManager` instance for the given node.
   */

  function getHammerManager(node) {
    if (node._hammer) return node._hammer;

    node._hammer = new Hammer.Manager(node, {recognizers: []});
    return node._hammer;
  }


  return {defaults: defaults};

}));

!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define('ractiveTooltip',[],t):"object"==typeof exports?exports.RactiveTooltip=t():e.RactiveTooltip=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){function r(e,t,n){var r={x:e.pageX,y:e.pageY},o=n.offsetWidth,s=n.offsetHeight,a=r.y-n.offsetHeight-5,f=r.x-5,u=a-s-5,p=f+o-i.innerWidth;p>0&&(f-=o-5),u<0&&(a+=2*s-5),n.style.left=f+"px",n.style.top=a+"px"}function o(e,t){var n,o,i,a=function(o){t&&0!==t.length&&(n||(n=s.createElement("div"),n.className="ractive-tooltip",n.textContent=t),r(o,e,n),s.body.appendChild(n))},f=function(t){return n?void r(t,e,n):void a(t)},u=function(e){n&&n.parentNode&&n.parentNode.removeChild(n)};o={mouseenter:a,touchstart:a,mousemove:f,touchmove:f,mouseleave:u,touchend:u};for(i in o)o.hasOwnProperty(i)&&e.addEventListener(i,o[i],!1);return{update:function(e){t=e,n&&(n.textContent=t),t&&0!==t.length||!n||!n.parentNode||n.parentNode.removeChild(n)},teardown:function(){n&&n.parentNode&&(n.parentNode.removeChild(n),n=null);for(i in o)o.hasOwnProperty(i)&&e.removeEventListener(i,o[i],!1)}}}n(1);var i=window,s=i.document;e.exports=o},function(e,t,n){var r=n(2);"string"==typeof r&&(r=[[e.id,r,""]]);n(4)(r,{});r.locals&&(e.exports=r.locals)},function(e,t,n){t=e.exports=n(3)(),t.push([e.id,".ractive-tooltip{position:absolute;display:table;padding:.5em;color:#fff;background:#000;box-shadow:0 2px 2px rgba(0,0,0,.1);border-radius:5px;white-space:nowrap;z-index:99999;font-style:normal;text-transform:none;pointer-events:none}",""])},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var n=this[t];n[2]?e.push("@media "+n[2]+"{"+n[1]+"}"):e.push(n[1])}return e.join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var r={},o=0;o<this.length;o++){var i=this[o][0];"number"==typeof i&&(r[i]=!0)}for(o=0;o<t.length;o++){var s=t[o];"number"==typeof s[0]&&r[s[0]]||(n&&!s[2]?s[2]=n:n&&(s[2]="("+s[2]+") and ("+n+")"),e.push(s))}},e}},function(e,t,n){function r(e,t){for(var n=0;n<e.length;n++){var r=e[n],o=l[r.id];if(o){o.refs++;for(var i=0;i<o.parts.length;i++)o.parts[i](r.parts[i]);for(;i<r.parts.length;i++)o.parts.push(u(r.parts[i],t))}else{for(var s=[],i=0;i<r.parts.length;i++)s.push(u(r.parts[i],t));l[r.id]={id:r.id,refs:1,parts:s}}}}function o(e){for(var t=[],n={},r=0;r<e.length;r++){var o=e[r],i=o[0],s=o[1],a=o[2],f=o[3],u={css:s,media:a,sourceMap:f};n[i]?n[i].parts.push(u):t.push(n[i]={id:i,parts:[u]})}return t}function i(e,t){var n=m(),r=x[x.length-1];if("top"===e.insertAt)r?r.nextSibling?n.insertBefore(t,r.nextSibling):n.appendChild(t):n.insertBefore(t,n.firstChild),x.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(t)}}function s(e){e.parentNode.removeChild(e);var t=x.indexOf(e);t>=0&&x.splice(t,1)}function a(e){var t=document.createElement("style");return t.type="text/css",i(e,t),t}function f(e){var t=document.createElement("link");return t.rel="stylesheet",i(e,t),t}function u(e,t){var n,r,o;if(t.singleton){var i=y++;n=g||(g=a(t)),r=p.bind(null,n,i,!1),o=p.bind(null,n,i,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=f(t),r=d.bind(null,n),o=function(){s(n),n.href&&URL.revokeObjectURL(n.href)}):(n=a(t),r=c.bind(null,n),o=function(){s(n)});return r(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;r(e=t)}else o()}}function p(e,t,n,r){var o=n?"":r.css;if(e.styleSheet)e.styleSheet.cssText=b(t,o);else{var i=document.createTextNode(o),s=e.childNodes;s[t]&&e.removeChild(s[t]),s.length?e.insertBefore(i,s[t]):e.appendChild(i)}}function c(e,t){var n=t.css,r=t.media;if(r&&e.setAttribute("media",r),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}function d(e,t){var n=t.css,r=t.sourceMap;r&&(n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var o=new Blob([n],{type:"text/css"}),i=e.href;e.href=URL.createObjectURL(o),i&&URL.revokeObjectURL(i)}var l={},h=function(e){var t;return function(){return"undefined"==typeof t&&(t=e.apply(this,arguments)),t}},v=h(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),m=h(function(){return document.head||document.getElementsByTagName("head")[0]}),g=null,y=0,x=[];e.exports=function(e,t){t=t||{},"undefined"==typeof t.singleton&&(t.singleton=v()),"undefined"==typeof t.insertAt&&(t.insertAt="bottom");var n=o(e);return r(n,t),function(e){for(var i=[],s=0;s<n.length;s++){var a=n[s],f=l[a.id];f.refs--,i.push(f)}if(e){var u=o(e);r(u,t)}for(var s=0;s<i.length;s++){var f=i[s];if(0===f.refs){for(var p=0;p<f.parts.length;p++)f.parts[p]();delete l[f.id]}}}};var b=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()}])});
define('ProductFacade',['lodash-compat', 'moment', 'ConfigStrings'], function (_, moment, ConfigStrings) {

	var ProductFacade = function (product) {
		this.RECON_DATE_FORMAT = 'DD/MM/YYYY';
		this.product = product;
		this.servicesMapByName = {};
		this.servicesMapByCatalogId = {};
		this.parametersMapByName = {};
		this.parametersMapByCatalogId = {};
		this.pricePackagesMapByName = {};
		this.pricePackagesMapByCatalogId = {};
		this.addOnsMapByName = {};
		this.addOnsMapByCatalogId = {};
		this.addOnsMapByAsignedProductId = {};
		this.accounts = null;
		this.CIAmts = null;
		this.CIErrorDetails = {};
		this.CIFailedFlag = false;
		this.addOnField = ConfigStrings.constants.ADDON_FIELD;
		this.addonValue = ConfigStrings.constants.ADDON_VALUE;
		this.broadbandOffset = ConfigStrings.constants.BROADBAND_OFFSET;
		this.mobileOffset = ConfigStrings.constants.MOBILE_OFFSET;
		this.tvAlaCarteMainComponentCatlogId = ConfigStrings.constants.CATALOGITEMS.ALA_CARTE_MAIN_COMPONENT;
		this.tvMainPackComponentCatlogId = ConfigStrings.constants.CATALOGITEMS.TV_MAIN_PACK_COMPONENT;
		this.tvFilterComponentCatlogId = ConfigStrings.constants.CATALOGITEMS.TV_FILTER_COMPONENT;
		this.componentRcCatlogId = ConfigStrings.constants.CATALOGITEMS.RC_CHAR;
		//Optional attributes. Will be set on demand
		this.recontractData = null;
		this.tvMainPack = null;
		this.ippContractData = null;
		this.productsList = null;
		this.nominatedKeyLines = null;
		this.ciContractStartDate = '17/09/2019';
		this.setCatalogItemIDMap(this.product.services, {id: 0});
		if (this.product && this.product.lineOfBusiness === 'TV') {
			this.populateTVAddons();
		}
		this.setCatalogItemIDMap(this.product.packages, {id: 0});
		if (this.product.devices) {
			this.setCatalogItemIDMap(this.product.devices, {id: 0});
		}
		ProductFacade.productFacadeMap[this.product.id] = this;
		this.freeEmailIdFlag = false;
		this.isNonKeyLinePlan = false;
	};

	//Singleton map of all services.
	ProductFacade.productFacadeMap = {};
	ProductFacade.prototype = {
		populateTVAddons: function () {
			var packages = _.map(this.product.packages, function (tvPackage) {
				tvPackage[this.addOnField] = this.addonValue;
				return tvPackage;
			}.bind(this));
			packages = _.filter(packages, function (tvPackage) {
				if (this.tvFilterComponentCatlogId.indexOf(tvPackage.catalogItemID) === -1) {
					tvPackage.tvContentPackFlag = true;
					var reconDateParam = _.find(tvPackage.parameters, function (param) {
						return param.catalogId === '8252';
					});
					if (reconDateParam) {
						tvPackage.actualReconDate = moment(reconDateParam.valueName, this.RECON_DATE_FORMAT);
					}
					return true;
				}
			}.bind(this));
			this.populatePricePackagesAndAddons(packages, {id: 0});
			this.markAlaCarteComponentsAsAddon();
			this.populateMainTVPack();
		},
		populateMainTVPack: function () {
			var mainPackComponent = _.find(this.product.services, function (service) {
				return service.catalogItemID === this.tvMainPackComponentCatlogId;
			}.bind(this));
			if (mainPackComponent) {
				this.tvMainPack = {
					catalogItemName: mainPackComponent.catalogItemName,
					catalogItemDescription: mainPackComponent.catalogItemDescription
				};
				mainPackComponent.containedServices = _.find(mainPackComponent.containedServices,
				function (containedService) {
					if (containedService.catalogItemID === '8610872' ||
						containedService.catalogItemName === 'Contract') {
						var reconDateParam = _.find(containedService.parameters, function (param) {
							return param.catalogId === '8252';
						});
						if (reconDateParam) {
							this.tvMainPack.actualReconDate = moment(reconDateParam.valueName, this.RECON_DATE_FORMAT);
						}
						return true;
					}
				}.bind(this));
			}
		},
		markAlaCarteComponentsAsAddon: function () {
			var alaCarteComponent = _.find(this.product.services, function (service) {
				return service.catalogItemID === this.tvAlaCarteMainComponentCatlogId;
			}.bind(this));

			if (alaCarteComponent) {
				alaCarteComponent.containedServices = _.map(alaCarteComponent.containedServices,
				function (containedService) {
					containedService[this.addOnField] = this.addonValue;
					return containedService;
				}.bind(this));
				if (alaCarteComponent.containedServices) {
					this.populatePricePackagesAndAddons(alaCarteComponent.containedServices, alaCarteComponent);
				}
			}
			return alaCarteComponent;
		},
		setCatalogItemIDMap: function (services, parentService) {
			_.each(services, function (service) {
				service.parent = parentService.id;
				this.servicesMapByName[service.catalogItemName] = service;
				this.servicesMapByCatalogId[service.catalogItemID] = service;

				if (service.parameters && service.parameters.length > 0) {
					this.populateParametersMap(service.parameters, service);
				}
				if (service.pricePackages && service.pricePackages.length > 0) {
					this.populatePricePackagesAndAddons(service.pricePackages, service);
				}
				if (service.containedServices && service.containedServices.length > 0) {
					//Call recursively
					this.setCatalogItemIDMap(service.containedServices, service);
				}
			}.bind(this));
		},

		populatePricePackagesAndAddons: function (pricePackages, parentService) {
			_.each(pricePackages, function (pricePackage) {
				pricePackage.parent = parentService.id;
				this.pricePackagesMapByName[pricePackage.catalogItemName] = pricePackage;
				this.pricePackagesMapByCatalogId[pricePackage.catalogItemID] = pricePackage;
				if (pricePackage[this.addOnField] && pricePackage[this.addOnField].indexOf(this.addonValue) > -1) {
					this.addOnsMapByName[pricePackage.catalogItemName] = pricePackage;
					this.addOnsMapByCatalogId[pricePackage.catalogItemID] = pricePackage;
					this.addOnsMapByAsignedProductId[pricePackage.id] = pricePackage;
				}
			}.bind(this));
		},

		populateParametersMap: function (parameters, parentService) {
			_.each(parameters, function (param) {
				param.parent = parentService.id;
				param.parentCatalogItemID = parentService.catalogItemID;
				var existingParam = this.parametersMapByCatalogId[param.catalogId];
				if (existingParam) {
					//If parameter with same value is presesnt then create an array and of parameters.
					if (!Array.isArray(existingParam)) {
						var existingParam = [existingParam];
					}
					existingParam.push(param);
					this.parametersMapByCatalogId[param.catalogId] = existingParam;
					this.parametersMapByName[param.name] = existingParam;
				} else {
					this.parametersMapByCatalogId[param.catalogId] = param;
					this.parametersMapByName[param.name] = param;
				}
			}.bind(this));
		},

		getParameterValueById: function (paramCatalogId, catalogItemID) {
			var value = null;
			var param = this.parametersMapByCatalogId[paramCatalogId];
			if (!_.isEmpty(param)) {
				if (Array.isArray(param) && !catalogItemID) {
					value = _.sortBy(param, function (p) {
						return p.parent;
					})[0].valueName;
				} else if (Array.isArray(param) && catalogItemID) {
					value = _.sortBy(param, function (p) {
						if (p.parentCatalogItemID === catalogItemID) {
							return p.parent;
						}
					})[0].valueName;
				} else {
					value = this.parametersMapByCatalogId[paramCatalogId].valueName;
				}
			}
			return value;
		},

		getParameterValueByIdByParentCatlogId: function (paramCatalogId, parentCatlogId) {
			var value = null;
			var param = this.parametersMapByCatalogId[paramCatalogId];
			if (!_.isEmpty(param)) {
				if (Array.isArray(param)) {
					if (parentCatlogId) {
						param = _.filter(param, function (p) {
							return parentCatlogId === p.parentCatalogItemID;
						});
					}
					if (param.length) {
						value = _.sortBy(param, function (p) {
							return p.parent;
						})[0].valueName;
					}
				} else {
					if (parentCatlogId) {
						if (parentCatlogId === param.parentCatalogItemID) {
							value = param.valueName;
						}
					} else {
						value = param.valueName;
					}
				}
			}
			return value;
		},

		getDateParameterValueByIdByParentCatlogId: function (paramCatalogId, parentCatlogId) {
			var value = null;
			var param = this.parametersMapByCatalogId[paramCatalogId];
			if (!_.isEmpty(param)) {
				if (Array.isArray(param)) {
					if (parentCatlogId) {
						param = _.filter(param, function (p) {
							return parentCatlogId === p.parentCatalogItemID;
						});
					}
					if (param.length) {
						var maxDate = _.sortBy(param, function (dateParam) {
							var epoch = moment(dateParam.valueName, this.RECON_DATE_FORMAT).unix();
							return -epoch;
						}.bind(this))[0];
						value = maxDate.valueName;
					}
				} else {
					if (parentCatlogId) {
						if (parentCatlogId === param.parentCatalogItemID) {
							value = param.valueName;
						}
					} else {
						value = param.valueName;
					}
				}
			}
			return value;
		},

		getDateParameterValueById: function (paramCatalogId) {
			var value = null;
			var param = this.parametersMapByCatalogId[paramCatalogId];
			if (!_.isEmpty(param)) {
				if (Array.isArray(param)) {
					var maxDate = _.sortBy(param, function (dateParam) {
						var epoch = moment(dateParam.valueName, this.RECON_DATE_FORMAT).unix();
						return -epoch;
					}.bind(this))[0];
					value = maxDate.valueName;
				} else {
					value = this.parametersMapByCatalogId[paramCatalogId].valueName;
				}
			}
			return value;
		},

		getParameterValueByName: function (paramName) {
			var value = null;
			if (!_.isEmpty(this.parametersMapByName[paramName])) {
				value = this.parametersMapByName[paramName].valueName;
			}
			return value;
		},

		setAccounts: function (accounts) {
			this.accounts = accounts;
		},
		setCIAmts: function (CIAmts) {
			this.CIAmts = CIAmts;
		},
		setIsNonKeyLinePlan: function (isNonKeyLinePlan) {
			this.isNonKeyLinePlan = isNonKeyLinePlan;
		},
		setCIErrorDetails: function (CIErrorDetails) {
			this.CIErrorDetails = CIErrorDetails;
			this.CIFailedFlag = CIErrorDetails.statusX9;
		},
		setNominatedKeyLines: function (nominatedKeyLines) {
			this.nominatedKeyLines = nominatedKeyLines;
		},
		isRecontractDataPresent: function () {
			return !_.isEmpty(this.accounts);
		},
		isIppComponentAvailbale: function () {
			if (this.product && this.product.services && this.product.services.length > 0) {
				var matchFound = _.find(this.product.services, function (service) {
					return service.catalogItemID === '9672';
				});
				if (matchFound) {
					return true;
				}
			}
			return false;
		},

		getBundleTypes: function () {
			var allBundleTypes = [];
			_.each(this.accounts, function (account) {
				if (account.assignedProducts) {
					var bundleTypes = _.map(account.assignedProducts.bundles, function (bundle) {
						return bundle.bundleType;
					});
					allBundleTypes = allBundleTypes.concat(bundleTypes);
				}
			});
			return allBundleTypes;
		},
		calculateMobileRecontractData: function () {
			if (this.isRecontractDataPresent()) {
				var price18Mon = '-', price12Mon = '-', price6Mon = '-', price3Mon = '-';
				var bundleTypes = this.getBundleTypes();
				var reconDate = this.getDateParameterValueById('8692');
				if (reconDate) {
					var deviceContractEndDate = moment(reconDate, this.RECON_DATE_FORMAT);
					var contractParticularStartDate = moment(this.ciContractStartDate, this.RECON_DATE_FORMAT);
					var recontractData = {
						actualReconDate: deviceContractEndDate,
						deviceContractEndDate: deviceContractEndDate,
						deviceContractStartDate: moment(this.getDateParameterValueById('8682'), this.RECON_DATE_FORMAT),
						deviceContractDuration: this.getParameterValueById('8672'),
						planContractStartDate: moment(this.getDateParameterValueById('8242'), this.RECON_DATE_FORMAT),
						planContractEndtDate: moment(this.getDateParameterValueById('8252'), this.RECON_DATE_FORMAT),
						planContractDuration: this.getParameterValueById('8632'),
						display: true,
						isEligibleForRecon: false,
						isNotOutOfContract: true,
						showCIDetails: true
					};
					var contractAfterParticularDate =
						moment.duration(recontractData.deviceContractStartDate.diff(
							contractParticularStartDate)).asDays();




					var reconDate18MonthBefore = moment(deviceContractEndDate)
						.add(this.mobileOffset, 'day').subtract(18, 'month');
					var reconDate12MonthBefore = moment(deviceContractEndDate)
						.add(this.mobileOffset, 'day').subtract(12, 'month');
					var reconDate6MonthBefore = moment(deviceContractEndDate)
						.add(this.mobileOffset, 'day').subtract(6, 'month');
					var reconDate3MonthBefore = moment(deviceContractEndDate)
						.add(this.mobileOffset, 'day').subtract(3, 'month');
					_.each(this.CIAmts, function (CIItem) {
						if (CIItem.cimonthX9 === '18') {
							price18Mon = CIItem.ciamtX9;
						}
						if (CIItem.cimonthX9 === '12') {
							price12Mon = CIItem.ciamtX9;
						}
						if (CIItem.cimonthX9 === '06') {
							price6Mon = CIItem.ciamtX9;
						}
						if (CIItem.cimonthX9 === '21') {
							price3Mon = CIItem.ciamtX9;
						}
					});
					if (contractAfterParticularDate < 0) {
						if (moment.duration(moment().diff(
							moment(reconDate18MonthBefore.format('MM/YYYY'), 'MM/YYYY')
							)).asDays() > 0) {
							recontractData.isEligibleForRecon = true;
						}
					} else {
						this.CIErrorDetails = null;
						this.CIFailedFlag = true;
						if (moment.duration(moment().diff(
							moment(reconDate12MonthBefore.format('MM/YYYY'), 'MM/YYYY')
							)).asDays() > 0) {
							recontractData.isEligibleForRecon = true;
						}
					}
					if (deviceContractEndDate) {
						if (moment.duration(moment().diff(
							moment(deviceContractEndDate.format('MM/YYYY'), 'MM/YYYY')
							)).asDays() > 0) {
							recontractData.isNotOutOfContract = false;
						}
					}

					if (moment.duration(moment().diff(
						moment(reconDate12MonthBefore.format('MM/YYYY'), 'MM/YYYY')
						)).asDays() < 0) {
						recontractData.recon18MonthsBefore = {
							reonDate: reconDate18MonthBefore,
							reconPrice: price6Mon
						};
					}

					if (moment.duration(moment().diff(
						moment(reconDate6MonthBefore.format('MM/YYYY'), 'MM/YYYY')
						)).asDays() < 0) {
						recontractData.recon12MonthsBefore = {
							reonDate: reconDate12MonthBefore,
							reconPrice: price12Mon
						};
					}

					if (moment.duration(moment().diff(
						moment(reconDate3MonthBefore.format('MM/YYYY'), 'MM/YYYY')
						)).asDays() < 0) {
						recontractData.recon6MonthsBefore = {
							reonDate: reconDate6MonthBefore,
							reconPrice: price18Mon
						};
					}

					recontractData.recon3MonthsBefore = {
						reonDate: reconDate3MonthBefore,
						reconPrice: price3Mon
					};
					recontractData.actualReconDate = reconDate3MonthBefore;
					if (bundleTypes.indexOf('FEB') > -1 || bundleTypes.indexOf('FEBP') > -1) {
						if (!this.isNonKeyLinePlan && this.product.keyLineIndX8) {
							recontractData.actualReconDate = reconDate12MonthBefore;
							if (contractAfterParticularDate < 0) {
								delete recontractData.recon6MonthsBefore;
							} else {
								recontractData.actualReconDate = reconDate6MonthBefore;
							}
							delete recontractData.recon3MonthsBefore;
						}
					}
					if (contractAfterParticularDate >= 0 && recontractData.recon18MonthsBefore) {
						delete recontractData.recon18MonthsBefore;
					}
					this.getEligibleCiData(recontractData);
					this.recontractData = recontractData;
				}
			} else {
				// throw('Mandatory data is not present');
				console.log('Mandatory data is not present');
			}
		},
		getEligibleCiData: function (recontractData) {
			if (!(recontractData.isNotOutOfContract && (recontractData.recon18MonthsBefore ||
				recontractData.recon12MonthsBefore || recontractData.recon6MonthsBefore ||
				recontractData.recon3MonthsBefore))) {
				recontractData.showCIDetails = false;
			}
		},
		calculateSimOnlyMobileRecontractData: function () {
			if (this.isRecontractDataPresent()) {
				var reconDate = this.getDateParameterValueByIdByParentCatlogId('8252', '18139391');
				if (reconDate) {
					var deviceContractEndDate = moment(reconDate, this.RECON_DATE_FORMAT);
					var recontractData = {
						actualReconDate: deviceContractEndDate,
						deviceContractEndDate: deviceContractEndDate,
						deviceContractStartDate: moment(
							this.getDateParameterValueByIdByParentCatlogId('8242', '18139391'), this.RECON_DATE_FORMAT),
						deviceContractDuration: this.getParameterValueByIdByParentCatlogId('8232', '18139391'),
						display: true,
						isEligibleForRecon: false
					};

					var reconDate18MonthBefore = moment(deviceContractEndDate)
						.add(this.mobileOffset, 'day').subtract(18, 'month');
					var reconDate12MonthBefore = moment(deviceContractEndDate)
						.add(this.mobileOffset, 'day').subtract(12, 'month');
					var reconDate6MonthBefore = moment(deviceContractEndDate)
						.add(this.mobileOffset, 'day').subtract(6, 'month');
					var reconDate3MonthBefore = moment(deviceContractEndDate)
						.add(this.mobileOffset, 'day').subtract(3, 'month');

					if (moment.duration(moment().diff(
						moment(reconDate18MonthBefore.format('MM/YYYY'), 'MM/YYYY')
						)).asDays() > 0) {
						recontractData.isEligibleForRecon = true;
					}

					if (moment.duration(moment().diff(
						moment(reconDate6MonthBefore.format('MM/YYYY'), 'MM/YYYY')
						)).asDays() < 1) {
						recontractData.recon12MonthsBefore = {
							reonDate: reconDate12MonthBefore,
							reconPrice: 300
						};
					}

					if (moment.duration(moment().diff(
						moment(reconDate3MonthBefore.format('MM/YYYY'), 'MM/YYYY')
						)).asDays() < 1) {
						recontractData.recon6MonthsBefore = {
							reonDate: reconDate6MonthBefore,
							reconPrice: 100
						};
					}
					this.recontractData = recontractData;
				}
			} else {
				throw('Mandatory data is not present');
			}
		},
		calculateIppMobileContractData: function () {
			if (this.isIppComponentAvailbale()) {
				var ippContractData = {
					ippDeviceContractEndDate: moment(this.getDateParameterValueById('19225281'), this.RECON_DATE_FORMAT),
					ippDeviceContractStartDate: moment(this.getDateParameterValueById('19225271'),
						this.RECON_DATE_FORMAT),
					ippContractDuration: this.getParameterValueById('8272', '19225251') !== null ?
					this.getParameterValueById('8272', '19225251').toLowerCase() :
					this.getParameterValueById('8272', '19225251'),
					//display property value will be true only if device is added with PP2.0 plan and ipp plan is active
					display: this.getParameterValueById('19225421') === 'Y' &&
					!(this.checkIPPContractEndDateExpire(this.getDateParameterValueById('19225281'))) ? true : false,
					deviceName: this.displayDeviceName()
				};
				this.ippContractData = ippContractData;
			}
		},
		checkIPPContractEndDateExpire: function (date) {
			var contractEndDate;
			var currentDate = Date.parse(new Date());
			if (date) {
				contractEndDate = Date.parse(date);
				if (currentDate > contractEndDate) {
					return true;
				}
				return false;
			}
		},
		calculateBroadbandRecontractData: function () {
			if (this.isRecontractDataPresent()) {
				//8252 is Contract end Date
				var reconDate = this.getDateParameterValueById('8252');
				if (reconDate) {
					var deviceContractEndDate = moment(reconDate, this.RECON_DATE_FORMAT);
					var recontractData = {
						actualReconDate: deviceContractEndDate,
						deviceContractEndDate: deviceContractEndDate,
						display: true,
						isEligibleForRecon: false
					};
					var reconDate3MonthBefore = moment(deviceContractEndDate)
						.add(this.broadbandOffset, 'day').subtract(3, 'month');
					var reconDateFirstDay = reconDate3MonthBefore.startOf('month');
					if (moment.duration(moment().diff(reconDate3MonthBefore)).asDays() >= 1) {
						recontractData.isEligibleForRecon = true;
					}
					recontractData.recon3MonthsBefore = {
						reonDate: reconDate3MonthBefore,
						reonDateFirstDay: reconDateFirstDay
					};
					recontractData.actualReconDate = reconDate3MonthBefore;
					this.recontractData = recontractData;
				}
			} else {
				throw('Mandatory data is not present');
			}
		},
		calculateTVRecontractData: function () {
			if (this.isRecontractDataPresent()) {
				//8252 is Contract end Date
				var reconDates = [];
				//var reconDate = this.getDateParameterValueById('8252');
				var reconDate = this.tvMainPack && this.tvMainPack.actualReconDate;
				if (reconDate) {
					var deviceContractEndDate = moment(reconDate, this.RECON_DATE_FORMAT);
					reconDates.push(deviceContractEndDate);
					var recontractData = {
						//deviceContractStartDate: moment(this.getParameterValueById('8242'), this.RECON_DATE_FORMAT),
						//deviceContractDuration: this.getParameterValueById('8252'),
						deviceContractEndDate: deviceContractEndDate,
						actualReconDate: deviceContractEndDate,
						display: true,
						isEligibleForRecon: false,
						isMainPackReconEligible: false
					};
					if (moment.duration(moment().diff(deviceContractEndDate)).asDays() >= 1) {
						recontractData.isEligibleForRecon = true;
						recontractData.isMainPackReconEligible = true;
					}
					recontractData.reconEligibleContentPacks = _.map(_.filter(this.addOnsMapByAsignedProductId,
						function (addon) {
							if (addon.tvContentPackFlag && addon.actualReconDate) {
								reconDates.push(addon.actualReconDate);
								return moment.duration(moment().diff(addon.actualReconDate)).asDays() >= 1;
							}
						}),
						function (addon) {
							return addon.catalogItemName;
						});
					recontractData.reconEligibleContentPacks = recontractData.reconEligibleContentPacks.length === 0 ?
						undefined : recontractData.reconEligibleContentPacks;
					if (!recontractData.isEligibleForRecon && recontractData.reconEligibleContentPacks) {
						recontractData.isEligibleForRecon = true;
					}
					if (!recontractData.isEligibleForRecon) {
						reconDates.sort(function (dateOne, dateTwo) {
							return dateOne.diff(dateTwo);
						});
						recontractData.earliestReconDate = reconDates[0];
					}
					this.recontractData = recontractData;
				}
			} else {
				throw('Mandatory data is not present');
			}
		},
		calculateWLRecontractData: function () {
			if (this.isRecontractDataPresent()) {
				//8252 is Contract end Date
				var reconDate = this.getDateParameterValueByIdByParentCatlogId('8252', '18652491');
				if (reconDate) {
					var deviceContractEndDate = moment(reconDate, this.RECON_DATE_FORMAT);
					var recontractData = {
						//deviceContractStartDate: moment(this.getParameterValueById('8242'), this.RECON_DATE_FORMAT),
						//deviceContractDuration: this.getParameterValueById('8252'),
						deviceContractEndDate: deviceContractEndDate,
						actualReconDate: deviceContractEndDate,
						display: true,
						isEligibleForRecon: false
					};
					var diffAsMonth = moment.duration(moment().diff(deviceContractEndDate)).asMonths();
					//Allow recontract 1 month beofore
					if (diffAsMonth >= -1) {
						// recontractData.isEligibleForRecon = true;
						//Always hide recontract option, As it is out of scope.
						recontractData.isEligibleForRecon = false;
					}
					this.recontractData = recontractData;
				}
			} else {
				console.log('Mandatory data is not present');
			}
		},
		mergeProductConfigWithAddon: function (implementedProductByAssignedProductIdConfiguration) {
			_.each(this.addOnsMapByAsignedProductId, function (addOn) {
				var implementedProduct = implementedProductByAssignedProductIdConfiguration[addOn.id];
				_.extend(addOn, implementedProduct, {
					'productTitle': addOn.catalogItemName
				});
				if (implementedProduct) {
					this.addOnsMapByCatalogId[implementedProduct.productSpecContainmentID] = addOn;
				}
				var parent = implementedProductByAssignedProductIdConfiguration[addOn.parent];
				if (!addOn.totalRecurringCalculatedPrice ||
					addOn.totalRecurringCalculatedPrice.finalAmount === undefined) {
					//Price is not defined. So check the parent for price.
					if (parent && parent.totalRecurringCalculatedPrice &&
							parent.totalRecurringCalculatedPrice.finalAmount) {
						addOn.totalRecurringCalculatedPrice = parent.totalRecurringCalculatedPrice;
					} else {
						//If price is not present then check if parent characteristic has the price characteristic.
						var price = 0;
						var rcChar = this.parametersMapByCatalogId[this.componentRcCatlogId];
						if (Array.isArray(rcChar)) {
							rcChar = _.find(rcChar, function (char) {
								return char.parent === addOn.parent;
							});
						}
						if (rcChar && rcChar.parent === addOn.parent) {
							price = rcChar.valueName;
						}
						addOn.totalRecurringCalculatedPrice = {
							'discountAmount': 0,
							'discountPercentage': 0,
							'finalAmount': price,
							'finalTaxAmount': 0,
							'finalAmountIncludingTax': price,
							'originalAmount': price,
							'currency': 'SGD'
						};
					}
				}
				if (!addOn.totalOneTimeCalculatedPrice || !addOn.totalOneTimeCalculatedPrice.finalAmount) {
					if (parent && parent.totalOneTimeCalculatedPrice &&
							parent.totalOneTimeCalculatedPrice.finalAmount) {
						addOn.totalOneTimeCalculatedPrice = parent.totalOneTimeCalculatedPrice;
					} else {
						addOn.totalOneTimeCalculatedPrice = {
							'discountAmount': 0,
							'discountPercentage': 0,
							'finalAmount': 0,
							'finalTaxAmount': 0,
							'finalAmountIncludingTax': 0,
							'originalAmount': 0,
							'currency': 'SGD'
						};
					}
				}
			}.bind(this));
		},
		calculateFreeBoIdPresent: function (freeBoIds, existingBoIds) {
			var isAddonPresent = _.find(this.addOnsMapByCatalogId, function (addOn) {
				return _.contains(freeBoIds, addOn.catalogItemID);
			});
			var hasContradictingAddons = false;
			if (isAddonPresent && existingBoIds && existingBoIds.length > 0) {
				hasContradictingAddons = _.find(this.addOnsMapByCatalogId,
					function (addonItem) {
					return _.contains(existingBoIds, addonItem.catalogItemID);
				});
			}
			if (isAddonPresent && !hasContradictingAddons) {
				this.freeEmailIdFlag = true;
			} else {
				this.freeEmailIdFlag = false;
			}
		},
		displayDeviceName: function () {
				var deviceName = null;
				if (this.product && this.product.devices && this.product.devices.length > 0) {
					_.find(this.product.devices, function (device) {
						if (device.productSpecContainmentID === '10492') {
							deviceName = device.catalogItemName;
						}
					});
					return deviceName;
				}
			}
	};
	return ProductFacade;
});

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define('ractive-events-keys',['exports'], factory) :
	factory(global.Ractive.events)
}(this, function (exports) { 'use strict';

	// TODO can we just declare the keydowhHandler once? using `this`?
	function makeKeyDefinition(code) {
		return function (node, fire) {
			function keydownHandler(event) {
				var which = event.which || event.keyCode;

				if (which === code) {
					event.preventDefault();

					fire({
						node: node,
						original: event
					});
				}
			}

			node.addEventListener('keydown', keydownHandler, false);

			return {
				teardown: function teardown() {
					node.removeEventListener('keydown', keydownHandler, false);
				}
			};
		};
	}

	var enter = makeKeyDefinition(13);
	var tab = makeKeyDefinition(9);
	var ractive_events_keys__escape = makeKeyDefinition(27);
	var space = makeKeyDefinition(32);

	var leftarrow = makeKeyDefinition(37);
	var rightarrow = makeKeyDefinition(39);
	var downarrow = makeKeyDefinition(40);
	var uparrow = makeKeyDefinition(38);

	exports.enter = enter;
	exports.tab = tab;
	exports.escape = ractive_events_keys__escape;
	exports.space = space;
	exports.leftarrow = leftarrow;
	exports.rightarrow = rightarrow;
	exports.downarrow = downarrow;
	exports.uparrow = uparrow;

}));
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define('ractiveTransitionsFly',factory) :
	global.Ractive.transitions.fly = factory();
}(this, function () { 'use strict';

	var DEFAULTS = {
		duration: 400,
		easing: 'easeOut',
		opacity: 0,
		x: -500,
		y: 0
	};

	function addPx(num) {
		if (num === 0 || typeof num === 'string') {
			return num;
		}

		return num + 'px';
	}
	function fly(t, params) {
		params = t.processParams(params, DEFAULTS);

		var x = addPx(params.x);
		var y = addPx(params.y);

		var offscreen = {
			transform: 'translate(' + x + ',' + y + ')',
			opacity: 0
		};

		var target = undefined;

		if (t.isIntro) {
			// animate to the current style
			target = t.getStyle(['opacity', 'transform']);

			// set offscreen style
			t.setStyle(offscreen);
		} else {
			target = offscreen;
		}

		t.animateStyle(target, params).then(t.complete);
	}

	return fly;

}));
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define('ractive-transitions-fade',factory) :
	global.Ractive.transitions.fade = factory()
}(this, function () { 'use strict';

	var ractive_transitions_fade = fade;
	var DEFAULTS = {
		delay: 0,
		duration: 300,
		easing: "linear"
	};
	function fade(t, params) {
		var targetOpacity;

		params = t.processParams(params, DEFAULTS);

		if (t.isIntro) {
			targetOpacity = t.getStyle("opacity");
			t.setStyle("opacity", 0);
		} else {
			targetOpacity = 0;
		}

		t.animateStyle("opacity", targetOpacity, params).then(t.complete);
	}

	return ractive_transitions_fade;

}));
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define('ractive-transitions-slide',factory) :
	global.Ractive.transitions.slide = factory()
}(this, function () { 'use strict';

	var ractive_transitions_slide = slide;
	var DEFAULTS = {
		duration: 300,
		easing: "easeInOut"
	};

	var PROPS = ["height", "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom", "marginTop", "marginBottom"];

	var COLLAPSED = {
		height: 0,
		borderTopWidth: 0,
		borderBottomWidth: 0,
		paddingTop: 0,
		paddingBottom: 0,
		marginTop: 0,
		marginBottom: 0
	};
	function slide(t, params) {
		var targetStyle;

		params = t.processParams(params, DEFAULTS);

		if (t.isIntro) {
			targetStyle = t.getStyle(PROPS);
			t.setStyle(COLLAPSED);
		} else {
			// make style explicit, so we're not transitioning to 'auto'
			t.setStyle(t.getStyle(PROPS));
			targetStyle = COLLAPSED;
		}

		t.setStyle("overflowY", "hidden");

		t.animateStyle(targetStyle, params).then(t.complete);
	}

	return ractive_transitions_slide;

}));
define('LUXComponentTemplates',["ractive"],function(ractive){

this["ux-accessory-filter"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-accessory-filter"},"f":[{"t":7,"e":"ux-row","a":{"class":"column-control-mobile"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","a":{"class":"margin-zero panel30"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"filter-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-9"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"main-header v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"headerText"}]}," ",{"t":7,"e":"div","a":{"class":"section-description v-medium-bottom show-for-small-only"},"f":[{"t":3,"r":"descriptionText"}]}," ",{"t":7,"e":"div","a":{"class":"section-description v-large-bottom show-for-medium-up"},"f":[{"t":3,"r":"descriptionText"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"ux-button","a":{"class":["round v-normal-top right cart-button ",{"t":2,"r":"disabledCart"}],"onclick":"proceedToCart"},"f":["Proceed to Cart"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"left-selections"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 v-small-bottom"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header show-result"},"f":[{"t":2,"r":"filterCriteriaText"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-3 left"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header sort-by "},"f":[{"t":2,"r":"sortCriteriaText"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"left-selections"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 spacing-for-mobile"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-deal","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"deal"}],"options":[{"t":2,"r":"deals"}],"onChangeEvent":"changedDeals"},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only v-normal-top"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header sort-by "},"f":[{"t":2,"r":"sortCriteriaText"}]}]}," ",{"t":7,"e":"ux-select","a":{"id":"select-sort","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"sortBy"}],"options":[{"t":2,"r":"sortByList"}],"onChangeEvent":"changedSortBy"},"f":[]}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]}]}]}]};
this["ux-accordion-filter"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-accordion-filter"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"brands-filter singtel-accordion"},"f":[{"t":7,"e":"ux-accordion","a":{"data":[{"t":2,"r":"brands"}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"class":"filter-box"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"clearfix p-medium-left"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-none-padding"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"div","a":{"class":"left subsection-header"},"f":["Brands"]}," ",{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item p-medium-left"},"f":[{"t":7,"e":"ux-row","a":{"class":"brands-checkbox free-gifts p-normal-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-10 checkbox-item show-for-medium-up p-small-bottom p-small-top p-none-left"},"f":[{"t":7,"e":"ux-checkbox","a":{"onChangeEvent":"onBrandsClicks","checkboxid":[{"t":2,"r":"value"},"-brands-",{"t":2,"r":"idx"}],"checkboxvalue":[{"t":2,"r":"value"}],"labelvalue":[{"t":2,"r":"text"}],"checked":[{"t":2,"r":"checked"}]},"f":[]}]}],"n":52,"i":"idx","r":"data"}]}," ",{"t":7,"e":"ux-anchor","a":{"onclick":"clearAllBrands"},"f":["Clear"]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"categories-filter singtel-accordion"},"f":[{"t":7,"e":"ux-accordion","a":{"data":[{"t":2,"r":"categories"}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"class":"filter-box"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"clearfix  p-medium-left"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-none-padding"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"div","a":{"class":"left subsection-header"},"f":["Categories"]}," ",{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item p-medium-left"},"f":[{"t":7,"e":"ux-row","a":{"class":"categories-checkbox free-gifts p-normal-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-10 checkbox-item show-for-medium-up p-small-top p-small-bottom p-none-left"},"f":[{"t":7,"e":"ux-checkbox","a":{"onChangeEvent":"onCategoriesClicks","checkboxid":[{"t":2,"r":"value"},"-categories-",{"t":2,"r":"idx"}],"checkboxvalue":[{"t":2,"r":"value"}],"labelvalue":[{"t":2,"r":"text"}],"checked":[{"t":2,"r":"checked"}]},"f":[]}]}],"n":52,"i":"idx","r":"data"}]}," ",{"t":7,"e":"ux-anchor","a":{"onclick":"clearAllCategories"},"f":["Clear"]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"dropdown-container p-normal-top large-12 small-12"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header p-medium-left"},"f":[{"t":2,"r":"sortCriteriaText"}]}," ",{"t":7,"e":"div","a":{"class":"p-normal-top v-medium-left v-medium-right"},"f":[{"t":7,"e":"ux-select","a":{"id":"filter_sortBy_desktop","showSelectedValue":"true","options":[{"t":2,"r":"sortByList"}],"selected_value":[{"t":2,"r":"selectedSortByOrder"}],"onChangeEvent":"changedSortBy"},"f":[]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only mobile-view small-12"},"f":[{"t":7,"e":"ux-row","a":{"class":" small-12 flex-container flex-container-end"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6 sort-select v-medium-right p-none-left-mobile p-none-right-mobile"},"f":[{"t":7,"e":"ux-select","a":{"id":"filter_sortBy","selectedClass":"section-tab-text","customClass":"section-tab-text","showSelectedValue":"true","options":[{"t":2,"r":"sortByList"}],"defaultOption":"Sort By","onChangeEvent":"changedSortBy"},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 filter-btn p-none-left-mobile p-none-right-mobile"},"f":[{"t":7,"e":"ux-anchor","a":{"onclick":"openFilterModel","class":"section-tab-text","textColor":[{"t":2,"r":"filterAnchorColor"}]},"f":[{"t":7,"e":"span","a":{"class":"p-medium-right section-tab-text"},"f":["Filter"]},{"t":7,"e":"ux-icon","a":{"size":"s","type":"filter-icon"}}]}]}]}]}]}]};
this["ux-accordion-panel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-accordion-panel"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-panel","a":{"class":"panel30"},"f":[{"t":7,"e":"ux-header","a":{"class":"v-normal-left v-normal-right section-header v-medium-top"},"f":[{"t":2,"r":"panelTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"hr"}],"n":50,"r":"isHrNeeded"}," ",{"t":7,"e":"div","a":{"class":"v-normal-left v-normal-right"},"f":[{"t":7,"e":"div","f":[{"t":8,"r":"content"}]}]}]}]}]}]};
this["ux-account-avatar"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-account-avatar"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":[{"t":4,"f":[{"t":2,"r":"ontap"}],"n":50,"x":{"r":["faStatus"],"s":"_0===79||_0===78"}}]},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"avatarImg.src"}],"alt":[{"t":3,"r":"avatarImg.alt"}],"class":["avatarImageContainer ",{"t":4,"f":["imageContainer"],"n":51,"r":"avatarImg.src"}]},"f":[]}]}],"n":50,"r":"ontap"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"avatarImg.src"}],"alt":[{"t":3,"r":"avatarImg.alt"}],"class":["avatarImageContainer ",{"t":4,"f":["imageContainer"],"n":51,"r":"avatarImg.src"}]},"f":[]}],"r":"ontap"}]}],"r":"account"}]};
this["ux-account-header"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-account-header"},"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-1 text-right"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":[{"t":4,"f":["changeAccountDetails"],"n":50,"x":{"r":["faStatus"],"s":"_0===79||_0===78"}}]},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"avatarImg.src"}],"alt":[{"t":3,"r":"avatarImg.alt"}],"class":["avatarImageContainer ",{"t":4,"f":["imageContainer"],"n":51,"r":"avatarImg.src"}]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header wraptext"},"f":[{"t":4,"f":[{"t":2,"r":"nickName"}],"n":50,"r":"nickName"},{"t":4,"n":51,"f":["Account Name"],"r":"nickName"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"changeAddress","ontap":"changeAccountDetails","ariaLabel":"Manage Account Name"},"f":["Manage"]}],"n":50,"x":{"r":["faStatus"],"s":"_0===79||_0===78"}}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top v-normal-bottom"},"f":["Account Number: ",{"t":3,"x":{"r":["RactiveHelpers","faid"],"s":"_0.zeroPadding(_1,7)"}}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"manageRedirection","class":"v-medium-up-left changeAddress"},"f":[{"t":2,"r":"ConfigStrings.switchToEbill"}]}],"n":50,"x":{"r":["billType"],"s":"_0!==\"E_BILL\""}}]}," ",{"t":4,"f":[{"t":7,"e":"ul","a":{"class":"icon-ul"},"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-icon","a":{"type":"alert-lightning-filled"}}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"div","a":{"class":"notice-text"},"f":[{"t":2,"r":"notification"}]}]}]}],"n":50,"r":"notification"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"billingAdressText"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"v-medium-up-left"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"changeBillingAddress"},"f":[{"t":2,"r":"changeAdressLinkText"}]}]}],"n":50,"x":{"r":["faStatus"],"s":"_0===79||_0===78"}}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-right"},"f":[" ",{"t":7,"e":"ux-singtel-address","a":{"addressType":"cmDashboard","address":[{"t":2,"r":"physicalAddress"}]}}]}],"n":50,"r":"permissions.showBillingAddress"}],"n":53,"r":"initData"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-5"},"f":[{"t":7,"e":"div","a":{"class":"amount-align"},"f":[{"t":7,"e":"ul","a":{"class":"inline-list right"},"f":[{"t":7,"e":"li","f":[{"t":7,"e":"div","a":{"class":"badges-text v-normal-right v-small-top"},"f":["AMOUNT",{"t":7,"e":"br"}," DUE"]}]}," ",{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"text-right callout-text-copy main-dollar"},"f":[{"t":2,"r":"balanceAmount"}]}],"n":50,"x":{"r":["balanceAmount"],"s":"_0===\"Error\""}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"main-dollar text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","balanceAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"x":{"r":["balanceAmount"],"s":"_0===\"Error\""}}," ",{"t":7,"e":"div","a":{"class":"no-wrap text-right body-light"},"f":["Due Date: ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","account.dueDate"],"s":"_0.convertMilisTimestampToDate(_1,\"Do MMMM YYYY\")"}}],"n":50,"r":"account.dueDate"},{"t":4,"n":51,"f":["--"],"r":"account.dueDate"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"pay-bills-align v-medium-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ul","a":{"class":"inline-list right margin-zero"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"initData.paymentHistoryLink"}],"ontap":"showPaymentHistory","class":"text-link","account":[{"t":2,"r":"account"}]},"f":[{"t":2,"r":"initData.paymentHistoryLinkText"}]}]}],"n":50,"r":"initData.permissions.showPaymentHistoryLink"}," ",{"t":7,"e":"li","f":[{"t":7,"e":"ux-button","a":{"class":["v-normal-left round right ",{"t":4,"f":["v-none-bottom"],"n":50,"r":"initData.permissions.showBillingAddress"},{"t":4,"n":51,"f":["v-medium-bottom"],"r":"initData.permissions.showBillingAddress"}],"href":[{"t":2,"r":"initData.payBillLink"}],"onclick":"payBill","text":[{"t":2,"r":"initData.payBillBtnText"}]},"f":[]}]}]}," "]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only text-center"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-anchor","a":{"ontap":[{"t":4,"f":["changeAccountDetails"],"n":50,"x":{"r":["faStatus"],"s":"_0===79||_0===78"}}]},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"avatarImg.src"}],"alt":[{"t":3,"r":"avatarImg.alt"}],"class":["v-large-top avatarImageContainer ",{"t":4,"f":["mobileImageContainer"],"n":51,"r":"avatarImg.src"}]}}]}," ",{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header v-normal-top wraptext"},"f":[{"t":2,"r":"nickName"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"changeAccountDetails","ariaLabel":"Change Account Name"},"f":["Manage"]}],"n":50,"x":{"r":["faStatus"],"s":"_0===79||_0===78"}}," ",{"t":7,"e":"div","f":["A/C Number: ",{"t":3,"x":{"r":["RactiveHelpers","faid"],"s":"_0.zeroPadding(_1,7)"}}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"ConfigStrings.eBillRegistrationUrl"}],"class":"changeAddress"},"f":[{"t":2,"r":"ConfigStrings.switchToEbill"}]}],"n":50,"x":{"r":["billType"],"s":"_0!==\"E_BILL\""}}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header v-large-top v-medium-bottom"},"f":[{"t":2,"r":"billingAdressText"}]}," ",{"t":7,"e":"div","f":[" ",{"t":7,"e":"ux-singtel-address","a":{"addressType":"cmDashboard","address":[{"t":2,"r":"physicalAddress"}]},"f":[]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"ontap":"changeBillingAddress"},"f":[{"t":2,"r":"changeAdressLinkText"}]}]}],"n":50,"r":"permissions.showBillingAddress"}],"n":53,"r":"initData"}," ",{"t":7,"e":"div","a":{"class":"badges-text v-large-top"},"f":["AMOUNT DUE"]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"callout-text-copy main-dollar"},"f":[{"t":2,"r":"balanceAmount"}]}],"n":50,"x":{"r":["balanceAmount"],"s":"_0===\"Error\""}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"main-dollar v-small-top v-small-bottom"},"f":[{"t":2,"x":{"r":["RactiveHelpers","balanceAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"x":{"r":["balanceAmount"],"s":"_0===\"Error\""}}," ",{"t":7,"e":"div","a":{"class":"no-wrap"},"f":[{"t":4,"f":["Due Date: ",{"t":2,"x":{"r":["RactiveHelpers","account.dueDate"],"s":"_0.convertMilisTimestampToDate(_1,\"Do MMMM YYYY\")"}}],"n":50,"r":"account.dueDate"},{"t":4,"n":51,"f":["Due Date: --"],"r":"account.dueDate"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ul","a":{"class":"inline-list v-normal-top v-none-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"initData.paymentHistoryLink"}],"ontap":"showPaymentHistory","class":"text-link","account":[{"t":2,"r":"account"}]},"f":[{"t":2,"r":"initData.paymentHistoryLinkText"}]}]}],"n":50,"r":"initData.permissions.showPaymentHistoryLink"}," ",{"t":7,"e":"li","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"class":"round margin-zero","href":[{"t":2,"r":"initData.payBillLink"}],"onclick":"payBill","text":[{"t":2,"r":"initData.payBillBtnText"}]},"f":[]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ul","a":{"class":"icon-ul v-normal-top"},"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-icon","a":{"type":"alert-lightning-filled"}}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"div","a":{"class":"notice-text"},"f":[{"t":2,"r":"notification"}]}]}]}],"n":50,"r":"notification"}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"changeAccountDetails"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Change Account Name"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom"},"f":["Your New Account Name"]}," ",{"t":7,"e":"ux-input-box","a":{"value":[{"t":2,"r":"nickNameValue"}],"validity":[{"t":2,"r":"nickNameValueErrorMsg"}],"maxLength":"12","autofocus":0}}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"ConfigStrings.genericError.nickNameAndAvatarErrorMsg"}],"class":"v-normal-top"},"f":[]}],"n":50,"r":"genericError"}," ",{"t":7,"e":"div","a":{"class":"subsection-header v-normal-top v-medium-bottom"},"f":["Your New Avatar"]}," ",{"t":7,"e":"div","a":{"class":"swiper-container avatar-section"},"f":[{"t":7,"e":"div","a":{"class":"text-center swiper-wrapper v-large-bottom"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","v":{"tap":"selectNewAvatar"},"a":{"class":"swiper-slide pointer"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"src"}],"class":["text-center ",{"t":4,"f":["selected"],"n":50,"r":"selected"}],"alt":[{"t":3,"r":"alt"}]}}]}],"n":50,"x":{"r":["i","ConfigStrings.maxAvatarLimit"],"s":"_0<_1"}}],"n":52,"i":"i","r":"avatars"}]}," "]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"class":"button round margin-zero right","ontap":"confirmChangeAvatarNickName"},"f":["Confirm"]}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"changeBillingAddressModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Change Billing Address"]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"initData.changeAdressMsg"}]}]}],"n":50,"r":"initData.changeAdressMsg"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","validityMsgClass":"margin-zero","message":[{"t":2,"r":"ConfigStrings.genericError.updateAddressErrorMsg"}]},"f":[]}]}]}],"n":50,"r":"updateAddressError"}," ",{"t":7,"e":"ux-address-form","a":{"address":[{"t":2,"r":"editableAddress"}],"addressList":[{"t":2,"r":"addressList"}],"onUpdate":"updateAdressDetails","hideUpdateButton":"true","equalSpacing":"true"}}," ",{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-right medium-6 hide"},"f":[{"t":7,"e":"ux-button","a":{"class":["round margin-zero ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["isEnabled","editableAddress.isNotApplicable","editableAddress.unitNo","editableAddress.floorNo"],"s":"_0&&(_1||(_2&&_2!==\"Select\"&&_3&&_3!==\"Select\"))"}}],"onclick":"scheduleBillingAddress","text":"Schedule"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"text-right medium-12 v-medium-top v-small-bottom"},"f":[{"t":7,"e":"ux-button","a":{"class":["round margin-zero ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["editableAddress.isNotApplicable","editableAddress.unitNo","editableAddress.floorNo"],"s":"_0||(_1&&_1!==\"Select\"&&_2&&_2!==\"Select\")"}}],"onclick":"confirmAddress","text":"Confirm"}}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme setNewAddress","modalId":"scheduleBillingAddressModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Effective Date for New Billing Address"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-calendar","a":{"style":"inline","min_date":"today","disable_weekends":"true","value":[{"t":2,"r":"selectedDate"}],"id":"scheduleDate","max_date":[{"t":2,"x":{"r":["moment"],"s":"_0().add(\"days\",91).format(\"DD-MMM-YYYY\")"}}]}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom v-normal-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"initData.changeAdressMsg"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"ux-small-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":["Note:"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"ConfigStrings.scheduleChangeAddress.message"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"ConfigStrings.scheduleChangeAddress.information"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":"round","onclick":"billingAddressScheduleCase","text":"Confirm"}}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"thankYouModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"section-title collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Thank You!"]}]}," ",{"t":7,"e":"ux-col","f":["Your billing address has been updated successfully."]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":["Account Number"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"currentFaId"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":["New Billing Address"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-singtel-address","a":{"addressType":"crmUpdatedAddressFormat","address":[{"t":2,"r":"editableAddress"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":["Effective Date"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":2,"r":"selectedDate"}],"n":50,"r":"selectedDate"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["moment"],"s":"_0().format(\"YYYY-MM-DD\")"}}],"r":"selectedDate"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":2,"r":"ConfigStrings.changeAddress.whatNextLabel"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":2,"r":"ConfigStrings.changeAddress.description"}]}]}]}]}],"r":"account"}]};
this["ux-account-service"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-account-service ",{"t":2,"r":"class"}]},"o":"loadMask","f":[{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-accordion","a":{"product":[{"t":2,"r":"product"}],"RactiveHelpers":[{"t":2,"r":"RactiveHelpers"}],"ConfigStrings":[{"t":2,"r":"ConfigStrings"}],"initData":[{"t":2,"r":"initData"}],"account":[{"t":2,"r":"account"}],"iconstatus":[{"t":2,"r":"iconstatus"}],"accountSummary":[{"t":2,"r":"accountSummary"}],"permission":[{"t":2,"r":"permission"}],"pendingOrders":[{"t":2,"r":"pendingOrders"}],"productFacade":[{"t":2,"r":"productFacade"}],"energyTopic":[{"t":2,"r":"energyTopic"}],"planIdsForHideChangePlan":[{"t":2,"r":"planIdsForHideChangePlan"}],"planIdsForHideReplaceSim":[{"t":2,"r":"planIdsForHideReplaceSim"}],"planSpecs":[{"t":2,"r":"planSpecs"}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"class":"service-accordion"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":["section-header service-icon-container ",{"t":2,"r":"iconstatus"}," flex-item"]},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":[{"t":2,"x":{"r":["RactiveHelpers","lob"],"s":"_0.getServicePropLob(_1,\"icon\")"}}]}}]}," ",{"t":7,"e":"div","a":{"class":"left p-normal-left"},"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["RactiveHelpers"],"s":"_0.getEasyMobiletitle()"}}]}],"n":50,"r":"account.isEasyMobile"},{"t":4,"n":51,"f":[{"t":7,"e":"div","f":[{"t":4,"f":["Singtel Power - Geneco"],"n":50,"x":{"r":["lob","productName"],"s":"_0===\"WL\"&&_1===\"Singtel Electricity\""}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["RactiveHelpers","lob"],"s":"_0.getServicePropLob(_1,\"name\")"}}],"x":{"r":["lob","productName"],"s":"_0===\"WL\"&&_1===\"Singtel Electricity\""}}]}],"r":"account.isEasyMobile"}," ",{"t":7,"e":"div","a":{"class":"body-light-account v-small-top"},"f":[{"t":4,"f":["MSSL No."],"n":50,"x":{"r":["lob","productName"],"s":"_0===\"WL\"&&_1===\"Singtel Electricity\""}}," ",{"t":2,"x":{"r":["RactiveHelpers","serviceId","lob"],"s":"_0.formatMobileNumberWithSpace(_1,_2)"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":7,"e":"ux-icon","a":{"outerClass":"right","type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"outerClass":"right","type":"chevron-down"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"service-alert callout-text-copy v-normal-right right"},"f":[{"t":7,"e":"div","a":{"class":"left alert-icon"},"f":[{"t":7,"e":"ux-icon","a":{"type":"alert-lightning-filled"}}]}," ",{"t":7,"e":"div","a":{"class":"left alert-msg"},"f":[{"t":2,"r":"initData.voucherInitData.voucherAlert"}]}]}],"n":50,"x":{"r":["voucherDetails.voucherValue"],"s":"_0&&_0>0"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"service-alert callout-text-copy v-normal-right right"},"f":[{"t":7,"e":"div","a":{"class":"left alert-icon"},"f":[{"t":7,"e":"ux-icon","a":{"type":"alert-lightning-filled"}}]}," ",{"t":7,"e":"div","a":{"class":"left alert-msg"},"f":[{"t":2,"x":{"r":["RactiveHelpers"],"s":"_0.getSuspendMessage(\"suspensionMessage\")"}}," ",{"t":2,"x":{"r":["RactiveHelpers","subscrStatusChangeDate"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMMM YY\")"}}]}]}],"n":50,"x":{"r":["subscrStatus"],"s":"_0===83||_0===85"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"service-alert callout-text-copy v-normal-right right"},"f":[{"t":7,"e":"div","a":{"class":"left alert-icon"},"f":[{"t":7,"e":"ux-icon","a":{"type":"alert-lightning-filled"}}]}," ",{"t":7,"e":"div","a":{"class":"left alert-msg"},"f":[{"t":2,"x":{"r":["RactiveHelpers"],"s":"_0.getSuspendMessage(\"futureSuspensionMessage\")"}}," ",{"t":2,"r":"pendingOrders.futureSuspensionDate"}]}]}],"n":50,"r":"pendingOrders.isFutureSuspendRequest"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"service-alert callout-recon-text v-normal-right right"},"f":[{"t":7,"e":"div","a":{"class":"left alert-icon"},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-tick"}}]}," ",{"t":7,"e":"div","a":{"class":""},"f":[{"t":2,"x":{"r":["RactiveHelpers"],"s":"_0.getSuspendMessage(\"reconMessage\")"}}]}]}],"n":50,"r":"isReconEligibleNotification"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":["section-header service-icon-container ",{"t":2,"r":"iconstatus"}," flex-item"]},"f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-item flex-item-top-align"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":[{"t":2,"x":{"r":["RactiveHelpers","lob"],"s":"_0.getServicePropLob(_1,\"icon\")"}}]}}]}," ",{"t":7,"e":"div","a":{"class":"flex-item p-normal-left flex-item-top-align"},"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["RactiveHelpers"],"s":"_0.getEasyMobiletitle()"}}]}],"n":50,"r":"account.isEasyMobile"},{"t":4,"n":51,"f":[{"t":7,"e":"div","f":[{"t":4,"f":["Singtel Power - Geneco"],"n":50,"x":{"r":["lob","productName"],"s":"_0===\"WL\"&&_1===\"Singtel Electricity\""}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["RactiveHelpers","lob"],"s":"_0.getServicePropLob(_1,\"name\")"}}],"x":{"r":["lob","productName"],"s":"_0===\"WL\"&&_1===\"Singtel Electricity\""}}]}],"r":"account.isEasyMobile"}," ",{"t":7,"e":"div","a":{"class":"body-light-account v-small-top"},"f":[{"t":4,"f":["MSSL No."],"n":50,"x":{"r":["lob","productName"],"s":"_0===\"WL\"&&_1===\"Singtel Electricity\""}}," ",{"t":2,"x":{"r":["RactiveHelpers","serviceId","lob"],"s":"_0.formatMobileNumberWithSpace(_1,_2)"}}]}," ",{"t":7,"e":"div","a":{"class":"flex-container flex-container-wrap"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"service-alert callout-text-copy flex-item"},"f":[{"t":7,"e":"div","a":{"class":"left alert-icon"},"f":[{"t":7,"e":"ux-icon","a":{"type":"alert-lightning-filled"}}]}," ",{"t":7,"e":"div","a":{"class":"left alert-msg"},"f":[{"t":2,"r":"initData.voucherInitData.voucherAlert"}]}]}],"n":50,"x":{"r":["voucherDetails.voucherValue"],"s":"_0&&_0>0"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"service-alert callout-text-copy flex-item"},"f":[{"t":7,"e":"div","a":{"class":"left alert-icon"},"f":[{"t":7,"e":"ux-icon","a":{"type":"alert-lightning-filled"}}]}," ",{"t":7,"e":"div","a":{"class":"left alert-msg"},"f":[{"t":2,"x":{"r":["RactiveHelpers"],"s":"_0.getSuspendMessage(\"suspensionMessage\")"}}," ",{"t":2,"x":{"r":["RactiveHelpers","subscrStatusChangeDate"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMMM YY\")"}}]}]}],"n":50,"x":{"r":["subscrStatus"],"s":"_0===83||_0===85"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"service-alert callout-text-copy flex-item"},"f":[{"t":7,"e":"div","a":{"class":"left alert-icon"},"f":[{"t":7,"e":"ux-icon","a":{"type":"alert-lightning-filled"}}]}," ",{"t":7,"e":"div","a":{"class":"left alert-msg"},"f":[{"t":2,"x":{"r":["RactiveHelpers"],"s":"_0.getSuspendMessage(\"futureSuspensionMessage\")"}}," ",{"t":2,"r":"pendingOrders.futureSuspensionDate"}]}]}],"n":50,"r":"pendingOrders.isFutureSuspendRequest"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"service-alert callout-recon-text v-normal-right right"},"f":[{"t":7,"e":"div","a":{"class":"left alert-icon"},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-tick"}}]}," ",{"t":7,"e":"div","a":{"class":"left alert-msg"},"f":[{"t":2,"x":{"r":["RactiveHelpers"],"s":"_0.getSuspendMessage(\"reconMessage\")"}}]}]}],"n":50,"r":"isReconEligibleNotification"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"flex-item flex-item-top-align v-medium-top"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item serviceRightPadding"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":4,"f":[{"t":7,"e":"ux-mobile-sub","a":{"product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}],"initData":[{"t":2,"r":"initData"}],"accountSummary":[{"t":2,"r":"accountSummary"}],"permission":[{"t":2,"r":"permission"}],"productFacade":[{"t":2,"r":"productFacade"}],"pendingOrders":[{"t":2,"r":"pendingOrders"}],"planIdsForHideChangePlan":[{"t":2,"r":"planIdsForHideChangePlan"}],"planIdsForHideReplaceSim":[{"t":2,"r":"planIdsForHideReplaceSim"}],"planSpecs":[{"t":2,"r":"planSpecs"}]}}],"n":50,"x":{"r":["lob"],"s":"_0===\"MOB\"||_0===\"WS\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["productDetails"],"s":"_0===\"productDetailsError\""},"f":[{"t":7,"e":"div","a":{"class":"callout-text-copy v-normal-bottom"},"f":[{"t":2,"r":"ConfigStrings.genericError.productDetailsErrorMsg"}]}]},{"t":4,"n":50,"x":{"r":["productDetails","lob","product.productDetails"],"s":"(!(_0===\"productDetailsError\"))&&((_1===\"FBB\"||_1===\"BB\")&&_2)"},"f":[" ",{"t":7,"e":"ux-broadband-sub","a":{"product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}],"initData":[{"t":2,"r":"initData"}],"accountSummary":[{"t":2,"r":"accountSummary"}],"permission":[{"t":2,"r":"permission"}],"productFacade":[{"t":2,"r":"productFacade"}]}}]},{"t":4,"n":50,"x":{"r":["productDetails","lob","product.productDetails"],"s":"(!(_0===\"productDetailsError\"))&&((!((_1===\"FBB\"||_1===\"BB\")&&_2))&&((_1===\"TV\")&&_2))"},"f":[" ",{"t":7,"e":"ux-tv-sub","a":{"product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}],"initData":[{"t":2,"r":"initData"}],"accountSummary":[{"t":2,"r":"accountSummary"}],"permission":[{"t":2,"r":"permission"}],"productFacade":[{"t":2,"r":"productFacade"}]}}]},{"t":4,"n":50,"x":{"r":["productDetails","lob","product.productDetails"],"s":"(!(_0===\"productDetailsError\"))&&((!((_1===\"FBB\"||_1===\"BB\")&&_2))&&((!((_1===\"TV\")&&_2))&&((_1===\"FV\")&&_2)))"},"f":[" ",{"t":7,"e":"ux-wireline-sub","a":{"product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}],"initData":[{"t":2,"r":"initData"}],"accountSummary":[{"t":2,"r":"accountSummary"}],"permission":[{"t":2,"r":"permission"}],"productFacade":[{"t":2,"r":"productFacade"}]}}]},{"t":4,"n":50,"x":{"r":["productDetails","lob","product.productDetails","product.productName"],"s":"(!(_0===\"productDetailsError\"))&&((!((_1===\"FBB\"||_1===\"BB\")&&_2))&&((!((_1===\"TV\")&&_2))&&((!((_1===\"FV\")&&_2))&&((_1===\"WL\")&&_2&&_3===\"Singtel Electricity\"))))"},"f":[" ",{"t":7,"e":"ux-energy-sub","a":{"product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}],"initData":[{"t":2,"r":"initData"}],"accountSummary":[{"t":2,"r":"accountSummary"}],"permission":[{"t":2,"r":"permission"}],"productFacade":[{"t":2,"r":"productFacade"}],"energyTopic":[{"t":2,"r":"energyTopic"}]}}]},{"t":4,"n":50,"x":{"r":["productDetails","lob","product.productDetails","product.productName"],"s":"(!(_0===\"productDetailsError\"))&&((!((_1===\"FBB\"||_1===\"BB\")&&_2))&&((!((_1===\"TV\")&&_2))&&((!((_1===\"FV\")&&_2))&&(!((_1===\"WL\")&&_2&&_3===\"Singtel Electricity\")))))"},"f":[" "]}],"x":{"r":["lob"],"s":"_0===\"MOB\"||_0===\"WS\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider margin-zero"}}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"subscript-text"},"f":["NOTE:"]}," ",{"t":7,"e":"div","a":{"class":"fine-print-text"},"f":[{"t":3,"x":{"r":["RactiveHelpers","initData.notes"],"s":"_0.unescapeString(_1)"}}]}]}]}],"n":50,"x":{"r":["initData.notes","lob"],"s":"_0&&(_1===\"MOB\"||_1===\"WS\")"}}]}]}],"n":53,"r":"product"}]}]}]}]}]};
this["ux-activation-modal"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-activation-modal"},"f":[{"t":7,"e":"ux-modal","a":{"width":[{"t":2,"r":"modalWindowWidth"}],"class":"light-theme sticky-modal","modalId":"resendActivationEmailModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":[{"t":2,"r":"reActivation.emailModalHeading"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top collapse section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":3,"r":"reActivation.emailModalDesc"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom","for":"emailId"},"f":["Email Address"]}," ",{"t":7,"e":"ux-input-box","a":{"id":"emailId","type":"text","placeholder":"E.g johnlim@gmail.com","value":[{"t":2,"r":"newContactDetails.emailId"}],"onInputEvent":"updateEmail","onblurEvent":"validateEmail","validity":[{"t":2,"r":"newContactDetails.emailIdErrorMsg"}]},"f":[]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-top text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":"round small-only-expand text-center","text":"Next","role":"button","onclick":"updateContactEmail","arialabel":"Next"}}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":[{"t":2,"r":"modalWindowWidth"}],"class":"light-theme sticky-modal","modalId":"resendActivationDetailsModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":[{"t":2,"r":"reActivation.detailsModalHeading"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-top section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":3,"r":"reActivation.detailsModalDesc"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Add-on"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"addon.productTitle"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":[{"t":4,"f":["Mobile Number"],"n":50,"r":"isMobile"},{"t":4,"n":51,"f":["Email Address"],"r":"isMobile"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","newContactDetails.phoneNo"],"s":"_0.mobileNumberFormat(_1)"}}],"n":50,"r":"isMobile"},{"t":4,"n":51,"f":[{"t":2,"r":"newContactDetails.emailId"}],"r":"isMobile"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider v-large-bottom"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-top text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":"round small-only-expand text-center","text":"Confirm","role":"button","onclick":"reactivateAddon","arialabel":"Confirm"}}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":[{"t":2,"r":"modalWindowWidth"}],"class":"light-theme sticky-modal","modalId":"successFailureModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":[{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"class":"v-normal-right","type":"success-tick","size":"l"},"f":[]},{"t":2,"r":"reActivation.successModalHeading"}],"n":50,"r":"isSuccess"},{"t":4,"n":51,"f":[{"t":2,"r":"reActivation.failureModalHeading"}],"r":"isSuccess"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-top section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":4,"f":[{"t":3,"r":"reActivation.successMobileModalDesc"}],"n":50,"r":"isMobile"},{"t":4,"n":51,"f":[{"t":3,"r":"reActivation.successEmailModalDesc"}],"r":"isMobile"}],"n":50,"r":"isSuccess"},{"t":4,"n":51,"f":[{"t":3,"r":"reActivation.failureModalDesc"}],"r":"isSuccess"}]}]}]}]}]};
this["ux-add-card"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-add-card ",{"t":4,"f":["open"],"n":50,"r":"isActive"},{"t":4,"f":[" ",{"t":2,"r":"class"}],"n":50,"r":"class"}],"aria-expanded":[{"t":2,"x":{"r":["isActive"],"s":"_0?\"true\":\"false\""}}]},"f":[{"t":7,"e":"ux-accordion","a":{"initData":[{"t":2,"r":"initData"}],"showNewCardDetails":[{"t":2,"r":"showNewCardDetails"}],"ipPaymentUrl":[{"t":2,"r":"ipPaymentUrl"}],"newCardDetails":[{"t":2,"r":"newCardDetails"}],"errorMessage":[{"t":2,"r":"errorMessage"}],"amountToPay":[{"t":2,"r":"amountToPay"}],"saveThisCard":[{"t":2,"r":"saveThisCard"}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"class":"service-accordion"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"removeDecor"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"title"},"f":[{"t":2,"r":"initData.useDifferentCard"}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item clearfix"},"f":[{"t":7,"e":"div","a":{"class":"card-detail","aria-hidden":[{"t":2,"x":{"r":["open"],"s":"_0?\"false\":\"true\""}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"errorMessage"}]},"f":[]}],"n":50,"r":"errorMessage"}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"card-details"},"f":[{"t":7,"e":"span","a":{"class":"visa-card-hack v-small-bottom"},"f":[{"t":7,"e":"p","a":{"class":"size4"},"f":[{"t":2,"r":"initData.cardEnding"}," ",{"t":2,"r":"newCardDetails.cardNumberEnding"}]}]}," ",{"t":7,"e":"div","a":{"class":"card-expiry small"},"f":[{"t":2,"r":"initData.expiryDate"},{"t":7,"e":"span","a":{"class":"card-date"},"f":[{"t":2,"r":"newCardDetails.cardExpiryDate"}]}]}," ",{"t":7,"e":"div","a":{"class":"security-code v-normal"},"f":[{"t":7,"e":"ux-input-box","a":{"datamodel":[{"t":3,"r":"initData.securityCodeInput"}],"value":[{"t":2,"r":"newCardDetails.security"}],"mandatory":"true","maxLength":"3"}}]}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ux-button-sd","a":{"text":["pay $ ",{"t":2,"r":"amountToPay"}],"type":["v-normal primary ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["newCardDetails.security.length"],"s":"_0!==3"}}],"ontap":"payBillNewCard","data-type":"new"},"m":[{"t":4,"f":["ariaDisabled=\"true\""],"n":50,"x":{"r":["newCardDetails.security.length"],"s":"_0!==3"}}],"f":[]}]}],"n":50,"r":"showNewCardDetails"},{"t":4,"n":51,"f":[{"t":7,"e":"iframe","a":{"src":[{"t":2,"r":"ipPaymentUrl"}],"frameborder":"0"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-checkbox","a":{"labelvalue":[{"t":2,"r":"initData.saveThisCardForFuture"}],"checkboxid":"saveThisCard","checked":[{"t":2,"r":"saveThisCard"}]}}]}],"n":50,"r":"initData.saveThisCardForFuture"}],"r":"showNewCardDetails"}]}]}]}]}]}]};
this["ux-add-vouchers"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-add-vouchers ",{"t":4,"f":["v-normal"],"n":50,"x":{"r":["shoppingCartPanel"],"s":"!_0"}}]},"f":[{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["small-collapse medium-uncollapse"],"n":50,"r":"shoppingCartPanel"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-offset-1 medium-11 clearfix"},"f":[{"t":7,"e":"div","a":{"class":"section-header left"},"f":[{"t":2,"r":"voucherInfo.title"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"voucher"},"f":[{"t":7,"e":"div","a":{"class":"v-small-top v-medium-bottom"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"left add-voucher-link","ontap":"doOpenShowVouchersModal"},"f":[{"t":2,"r":"voucherInfo.link.title"}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["small-collapse medium-uncollapse"],"n":50,"r":"shoppingCartPanel"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["small-8 medium-4"],"n":50,"x":{"r":["lob"],"s":"_0===\"bundle\""}},{"t":4,"n":51,"f":["small-8"],"x":{"r":["lob"],"s":"_0===\"bundle\""}}," medium-offset-1"]},"f":[{"t":7,"e":"span","a":{"class":"v-medium-right"},"f":[{"t":4,"f":["Red-Bill rebates $80 over 24mths"],"n":50,"x":{"r":["voucherType"],"s":"_0===\"25\""}},{"t":4,"n":51,"f":[{"t":2,"r":"name"}],"x":{"r":["voucherType"],"s":"_0===\"25\""}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":["doRemoveVoucher:",{"t":2,"r":"idX8"}]},"f":["Remove"]}],"n":50,"r":"shoppingCartPanel"}]}," ",{"t":7,"e":"ux-col","a":{"class":["small-4 medium-2 text-right",{"t":4,"f":[" nullprice"],"n":50,"x":{"r":["lob"],"s":"_0===\"bundle\""}}]},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"x":{"r":["lob"],"s":"_0!==\"bundle\""}},{"t":4,"n":51,"f":[{"t":7,"e":"p","f":[" "]}],"x":{"r":["lob"],"s":"_0!==\"bundle\""}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-4 medium-2 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","Charges.recurringPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["lob"],"s":"_0===\"bundle\""}}],"r":"preSelectedVouchers"}]}],"n":50,"r":"preSelectedVouchers"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-modal","a":{"width":"800","class":"light-theme select-vouchers-modal","modalId":"addVoucherModal"},"f":[{"t":7,"e":"div","a":{"class":"section-title"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":["Added a voucher previously?"]}],"n":50,"x":{"r":["enableRetrieveVoucher","lob"],"s":"_0&&_1===\"bundle\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":["Add a voucher"]}],"x":{"r":["enableRetrieveVoucher","lob"],"s":"_0&&_1===\"bundle\""}}," ",{"t":4,"f":[{"t":7,"e":"p","f":["You currently do not have any applicable vouchers"]}],"n":50,"x":{"r":["noNewVoucher","enableRetrieveVoucher","lob"],"s":"_0&&!_1&&_2===\"bundle\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["noNewVoucher","enableRetrieveVoucher"],"s":"_0&&!_1"},"f":[{"t":7,"e":"p","f":["Sorry, it seems that you do not have a voucher."]}]},{"t":4,"n":50,"x":{"r":["noNewVoucher","enableRetrieveVoucher"],"s":"(!(_0&&!_1))&&(!_0&&!_1)"},"f":[" ",{"t":7,"e":"p","f":["You are entitled to use the voucher(s) below for your purchase (T&Cs apply)"]}]}],"x":{"r":["noNewVoucher","enableRetrieveVoucher","lob"],"s":"_0&&!_1&&_2===\"bundle\""}}," ",{"t":4,"f":[{"t":7,"e":"p","f":["Please retrieve your vouchers if you can't find your voucher(s) displayed here."]}," ",{"t":7,"e":"ux-button","a":{"class":"large-text-right right round v-normal-top","onclick":"doOpenRetrieveVoucherModal"},"f":["Retrieve Voucher"]}," ",{"t":7,"e":"hr"}],"n":50,"x":{"r":["enableRetrieveVoucher","lob"],"s":"_0&&_1!==\"bundle\""}}," ",{"t":4,"f":[{"t":7,"e":"p","f":["You might have recently added a voucher to another transaction that was not completed. Refresh your voucher list to add to this transaction."]}," ",{"t":7,"e":"ux-button","a":{"class":"large-text-right right round v-normal-top","onclick":"onUnReserveVouchers"},"f":["Refresh"]}," ",{"t":7,"e":"hr"}],"n":50,"x":{"r":["enableRetrieveVoucher","lob"],"s":"_0&&_1===\"bundle\""}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"product-title"},"f":[{"t":4,"f":["Fibre Broadband: ",{"t":2,"r":"number"}],"n":50,"x":{"r":["lob"],"s":"_0===\"bundle\""}},{"t":4,"n":51,"f":["Mobile: ",{"t":2,"x":{"r":["RactiveHelpers","number"],"s":"_0.mobileNumberFormat(_1)"}},{"t":4,"f":[" (",{"t":2,"r":"type"},")"],"n":50,"x":{"r":["type"],"s":"_0&&_0!=\"\""}}],"x":{"r":["lob"],"s":"_0===\"bundle\""}}]}," ",{"t":7,"e":"div","a":{"class":"section-details clearfix v-normal-top v-large-bottom show-for-medium-up"},"f":[{"t":7,"e":"ux-row","a":{"class":"subsection-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-10 medium-3"},"f":["Voucher"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-10 medium-2"},"f":["Issue Date"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-10 medium-2"},"f":["Expiry Date"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-2 medium-1 text-right"},"f":["Value"]}]}," ",{"t":7,"e":"hr"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-1 medium-1"},"f":[{"t":7,"e":"ux-checkbox","a":{"class":"left","onChangeEvent":"onVouchersClick","checkboxid":["voucherList",{"t":2,"r":"guid"},"-",{"t":2,"r":"i"},{"t":2,"r":"j"}],"aria_label":["Select Voucher",{"t":2,"r":"i"},{"t":2,"r":"j"}],"checked":[{"t":4,"f":[{"t":2,"r":"check"}],"n":50,"r":"SingleVoucher"}]},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-9 medium-3"},"f":[{"t":2,"r":"finalizedNameX8"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-9 medium-2"},"f":[{"t":2,"x":{"r":["moment","issueDateX8"],"s":"_0(_1).format(\"DD/MM/YYYY\")"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-9 medium-2"},"f":[{"t":2,"x":{"r":["moment","expiryDateX8"],"s":"_0(_1).format(\"DD/MM/YYYY\")"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-1 medium-1 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","amountX8"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"i":"j","r":"voucherList"}]}," ",{"t":7,"e":"div","a":{"class":"section-details clearfix v-normal-top v-large-bottom show-for-small-only"},"f":[{"t":7,"e":"hr"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom v-large-top center-align"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-checkbox","a":{"class":"medium","onChangeEvent":"onVouchersClick","checkboxid":["voucherListMobileView",{"t":2,"r":"guid"},"-",{"t":2,"r":"i"},{"t":2,"r":"j"}],"aria_label":["Select Voucher",{"t":2,"r":"i"},{"t":2,"r":"j"}],"checked":[{"t":4,"f":[{"t":2,"r":"checkMobile"}],"n":50,"r":"SingleVoucher"}]},"f":[]}]}]}," ",{"t":7,"e":"div","a":{"class":"center-align"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6 "},"f":["Voucher:"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 "},"f":[{"t":2,"r":"finalizedNameX8"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":["Issue Date:"]}," ",{"t":7,"e":"ux-col","a":{"class":" small-6"},"f":[{"t":2,"x":{"r":["moment","issueDateX8"],"s":"_0(_1).format(\"DD/MM/YYYY\")"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6 "},"f":["Expiry Date:"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 "},"f":[{"t":2,"x":{"r":["moment","expiryDateX8"],"s":"_0(_1).format(\"DD/MM/YYYY\")"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6 "},"f":["Value:"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 v-large-bottom "},"f":[{"t":2,"x":{"r":["RactiveHelpers","amountX8"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}]}]}],"i":"j","r":"voucherList"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":["This voucher value will be split over 24 months to offset your monthly bill."]}]}]}],"n":50,"x":{"r":["lob"],"s":"_0===\"bundle\""}}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["large-text-right right round show-for-medium-up",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["lob","disabled"],"s":"_0===\"bundle\"&&_1"}}],"onclick":"doSelectVouchers"},"f":["Apply"]}," ",{"t":7,"e":"ux-button","a":{"class":["large-text-right right round show-for-small-only",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["lob","disabled"],"s":"_0===\"bundle\"&&_1"}}],"onclick":"doSelectVouchers"},"f":["Apply"]}]}]}],"i":"i","r":"voucher.mobile"}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"noVoucherModal"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":["Add a voucher"]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"voucherInfo.vouchersNotFound"}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"loginForm"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header v-small-bottom"},"f":[{"t":2,"r":"initData.loginLabel"}]}]}]}],"n":50,"x":{"r":["initData.loginLabel"],"s":"_0&&_0!=\"\""}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-singtel-login","a":{"loginUrl":[{"t":2,"r":"initData.loginUrl"}],"isShopFlow":"true"},"m":[{"t":4,"f":["referenceUrl=\"",{"t":2,"r":"referenceUrl"},"\""],"n":50,"r":"referenceUrl"}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"retrieveVoucherModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":["Retrieve my voucher(s)"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","f":["You may be required to re-apply your vouchers to your purchase after retrieving."]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 text-center v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"text":"Yes","class":"round light margin-zero small-only-expand","onclick":"onUnReserveVouchers","arialabel":"OK"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 text-center v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"text":"No","class":"round light margin-zero small-only-expand","onclick":"reOpenVoucherModal","arialabel":"Cancel"}}]}]}]}],"n":50,"r":"hideVouchersModal"}]}]};
this["ux-addon-accordion"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-addon-accordion v-normal-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"online-exclusive-wrapper v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"text-center online-exclusive badges-text"},"f":[{"t":2,"r":"ribbonMarketingText"}]}]}],"n":50,"r":"ribbonMarketingText"}," ",{"t":7,"e":"div","a":{"class":"section-header v-medium-bottom"},"v":{"click":"showConfiguration"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-11"},"f":[{"t":2,"r":"accordionTitle"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-1"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":[{"t":4,"f":["icon-solid-chevron-up"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===false"}}]}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":[{"t":4,"f":["icon-solid-chevron-down"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===true"}}]},"f":[]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"main-content"},"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"r":"contentClass"}]},"f":[{"t":8,"r":"content"}]}]}]}]};
this["ux-addon-characteristic"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-addon-characteristic"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold"},"f":[{"t":2,"x":{"r":["displayInformation.name","productSpecCharacteristic.name"],"s":"_0?_0:_1"}}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"ux-calendar","a":{"dateFormat":"DD-MM-YYYY","min_date":[{"t":2,"x":{"r":["getMinDate"],"s":"_0()"}}],"max_date":[{"t":2,"x":{"r":["getMaxDate"],"s":"_0()"}}],"selected_date":[{"t":2,"r":"value"}],"default_date":[{"t":2,"x":{"r":["value"],"s":"_0||undefined"}}],"validity":[{"t":2,"r":"valueErrorMsg"}],"calendar_id":["calendar_",{"t":2,"r":"productSpecCharacteristicID"},"_",{"t":2,"x":{"r":[],"s":"Math.random().toString(36).substr(2)"}}],"type":"text","theme":"singtel-calendar","readonly":"true"}}],"n":50,"x":{"r":["displayInformation.displayFormat"],"s":"_0===\"CALENDAR\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["displayInformation.displayFormat"],"s":"_0===\"TEXTBOX\""},"f":[{"t":7,"e":"ux-input-box","a":{"value":[{"t":2,"r":"value"}],"id":[{"t":2,"r":"productSpecCharacteristicID"}],"validity":[{"t":2,"r":"valueErrorMsg"}],"mandatory":[{"t":2,"r":"mandatory"}],"type":"text"},"m":[{"t":4,"f":["maxLength=\"",{"t":2,"r":"productSpecCharacteristic.length"},"\""],"n":50,"r":"productSpecCharacteristic.length"}]}]},{"t":4,"n":50,"x":{"r":["displayInformation.displayFormat"],"s":"(!(_0===\"TEXTBOX\"))&&(_0===\"DROPDOWN_LISTBOX\")"},"f":[" ",{"t":7,"e":"ux-custom-select","a":{"selectedOption":[{"t":2,"r":"value"}],"selectedValueTemplate":"ux-selected-default-template","validity":[{"t":2,"r":"valueErrorMsg"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-custom-option","a":{"class":"option","selectable":"true","value":[{"t":2,"r":"value"}]},"f":[{"t":2,"r":"valueForDisplay"}]}],"n":52,"r":"productSpecCharacteristic.values"}]}]}],"x":{"r":["displayInformation.displayFormat"],"s":"_0===\"CALENDAR\""}}]}]}],"n":53,"r":"characteristic"}]};
this["ux-addon-listing-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-addon-listing-singtel"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","a":{"class":"margin-zero panel30"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"section-header v-normal-bottom"},"f":[{"t":3,"r":"addonGroupTitle"}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"sub-section-header v-normal-bottom"},"f":[{"t":3,"r":"addonGroupDescription"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"section-header v-normal-bottom"},"f":[{"t":3,"r":"description"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider extend-for-small extend-for-medium"}}," ",{"t":7,"e":"div","a":{"class":"addon-section p-large-left-medium"},"f":[{"t":7,"e":"ux-addon-singtel","a":{"addon":[{"t":2,"r":"."}]}}]}],"n":52,"r":"items"}],"n":52,"i":"i","r":"selectedTagGroup"}]}]}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-addon-singtel"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-addon-singtel","id":[{"t":2,"x":{"r":["catlogId","productSpecContainmentID"],"s":"_0||_1"}}]},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"online-exclusive-wrapper v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"text-center online-exclusive badges-text"},"f":[{"t":2,"r":"ribbonMarketingText"}]}]}],"n":50,"r":"ribbonMarketingText"}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"section-header v-medium-bottom show-for-medium-up"},"f":[{"t":2,"r":"productTitle"}," ",{"t":4,"f":[{"t":2,"r":"deviceName"}," (IMEI ",{"t":2,"r":"imei"},")"],"n":50,"r":"isMobileSwopAddon"}]}," ",{"t":7,"e":"div","a":{"class":"section-header v-medium-bottom pointer show-for-small-only"},"v":{"click":"showConfiguration"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-11"},"f":[{"t":2,"r":"productTitle"}," ",{"t":4,"f":[{"t":2,"r":"deviceName"}," (IMEI  ",{"t":2,"r":"imei"},")"],"n":50,"r":"isMobileSwopAddon"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-1"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":[{"t":4,"f":["icon-solid-chevron-up"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===false"}}]}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":[{"t":4,"f":["icon-solid-chevron-down"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===true"}}]},"f":[]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":[{"t":4,"f":["showConfigurePanel"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===true"}},{"t":4,"n":51,"f":["hidePanel"],"x":{"r":["showConfigurePanel"],"s":"_0===true"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":["Duration ",{"t":2,"x":{"r":["moment","duration.startDate"],"s":"_0(parseInt(_1)).format(\"DD/MM/YYYY\")"}}," - ",{"t":2,"x":{"r":["moment","duration.endDate"],"s":"_0(parseInt(_1)).format(\"DD/MM/YYYY\")"}}]}],"n":50,"r":"isDataRoamDurationPresent"}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"span","a":{"class":["body-light text-left ",{"t":4,"f":["hide"],"n":50,"x":{"r":["isMyAddon","hideContract"],"s":"_0||_1"}}]},"f":[{"t":4,"f":[{"t":2,"r":"contract"}," ",{"t":2,"r":"addonLabels.contractDuration"}],"n":50,"x":{"r":["contract"],"s":"_0>1"}},{"t":4,"n":51,"f":[{"t":4,"f":["1 Month Contract"],"n":50,"x":{"r":["contract"],"s":"_0==1"}},{"t":4,"n":51,"f":["0 Month Contract"],"x":{"r":["contract"],"s":"_0==1"}}],"x":{"r":["contract"],"s":"_0>1"}}," ",{"t":4,"f":[{"t":7,"e":"span","f":[{"t":7,"e":"span","a":{"class":"promo-text"},"f":[{"t":2,"r":"initData.displayText"}]}," ",{"t":7,"e":"div","a":{"class":"icon-btn show-tooltip"},"v":{"click":{"n":[{"t":4,"f":["showTooltip"],"n":50,"r":"displayRoamingCredit"}],"d":[]}},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":2,"r":"initData.toolTipText"}]}]}],"n":50,"r":"displayRoamingCredit"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":[{"t":4,"f":["margin-zero"],"n":50,"r":"hideContract"}," promo-text"]},"f":[{"t":2,"r":"promotionText"}]}],"n":50,"r":"promotionText"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":["body-light text-left v-medium-bottom ",{"t":4,"f":["hide"],"n":50,"x":{"r":["isMyAddon","hideContract"],"s":"_0||_1"}}]},"f":[{"t":4,"f":[{"t":2,"r":"contract"}," ",{"t":2,"r":"addonLabels.contractDuration"}],"n":50,"x":{"r":["contract"],"s":"_0>1"}},{"t":4,"n":51,"f":[{"t":4,"f":["1 Month Contract"],"n":50,"x":{"r":["contract"],"s":"_0==1"}},{"t":4,"n":51,"f":["0 Month Contract"],"x":{"r":["contract"],"s":"_0==1"}}],"x":{"r":["contract"],"s":"_0>1"}}," ",{"t":4,"f":[{"t":7,"e":"span","f":[{"t":7,"e":"span","a":{"class":"promo-text"},"f":[{"t":2,"r":"roamingLabel"}]}," ",{"t":7,"e":"div","a":{"class":"icon-btn show-tooltip"},"v":{"click":{"n":[{"t":4,"f":["showTooltip"],"n":50,"r":"displayRoamingCredit"}],"d":[]}},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":2,"r":"initData.toolTipText"}]}]}],"n":50,"r":"displayRoamingCredit"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"promo-text margin-zero"},"f":[{"t":2,"r":"promotionText"}]}],"n":50,"r":"promotionText"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-crop-text","a":{"text":[{"t":2,"r":"productDescription"}],"desktopChars":[{"t":2,"r":"cropTextConfig.desktopChars"}],"tabletChars":[{"t":2,"r":"cropTextConfig.tabletChars"}],"mobileChars":[{"t":2,"r":"cropTextConfig.mobileChars"}],"showComplete":[{"t":2,"r":"viewMore"}],"elipses":"..."},"f":[]}]}],"n":50,"r":"productDescription"}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"viewMoreLess"}],"x":{"r":["viewMore","tncDescription","faqDescription"],"s":"{viewMore:_0,tncDescription:_1,faqDescription:_2}"}}],"n":50,"x":{"r":["productDescription","productDescription.length","cropTextConfig.tabletChars","tncDescription","faqDescription"],"s":"(_0&&_1>_2)||_3||_4"}}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"viewMoreLess"}],"x":{"r":["viewMore","tncDescription","faqDescription"],"s":"{viewMore:_0,tncDescription:_1,faqDescription:_2}"}}],"n":50,"x":{"r":["productDescription","productDescription.length","cropTextConfig.mobileChars","tncDescription","faqDescription"],"s":"(_0&&_1>_2)||_3||_4"}}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-normal-top"},"f":["Duration ",{"t":2,"x":{"r":["moment","reactivationDetails.serviceStartDate"],"s":"_0(_1,\"DD-MMM-YYYY HH:mm:ss\").format(\"DD/MM/YYYY\")"}}," - ",{"t":2,"x":{"r":["moment","reactivationDetails.serviceEndDate"],"s":"_0(_1,\"DD-MMM-YYYY HH:mm:ss\").format(\"DD/MM/YYYY\")"}}]}],"n":50,"x":{"r":["reactivationDetails.serviceStartDate","reactivationDetails.serviceEndDate"],"s":"_0&&_1"}}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"resendActivationLink","class":"button round light action-button wifiMesh-button margin-zero increasePadding"},"f":[{"t":4,"f":[{"t":2,"r":"initData.resendActivationButtonText"}],"n":50,"r":"initData.resendActivationButtonText"},{"t":4,"n":51,"f":["Resend Activation Link"],"r":"initData.resendActivationButtonText"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"resendActivationLink","class":"button round light wifiMesh-button fullwidth margin-zero increasePadding"},"f":[{"t":4,"f":[{"t":2,"r":"initData.resendActivationButtonText"}],"n":50,"r":"initData.resendActivationButtonText"},{"t":4,"n":51,"f":["Resend Activation Link"],"r":"initData.resendActivationButtonText"}]}]}]}],"n":50,"x":{"r":["isMyAddon","reactivationDetails"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"homeInsuranceLink","class":"button round light action-button increasePadding margin-zero"},"f":[{"t":4,"f":[{"t":2,"r":"initData.submitClaimButtonTxt"}],"n":50,"r":"initData.submitClaimButtonTxt"},{"t":4,"n":51,"f":["Submit a claim"],"r":"initData.submitClaimButtonTxt"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"homeInsuranceLink","class":"button round light increasePadding fullwidth margin-zero"},"f":[{"t":4,"f":[{"t":2,"r":"initData.submitClaimButtonTxt"}],"n":50,"r":"initData.submitClaimButtonTxt"},{"t":4,"n":51,"f":["Submit a claim"],"r":"initData.submitClaimButtonTxt"}]}]}]}],"n":50,"x":{"r":["isMyAddon","homeInsuranceAddonFlag"],"s":"_0&&_1"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["showConfigurePanel"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===true"}},{"t":4,"n":51,"f":["hidePanel"],"x":{"r":["showConfigurePanel"],"s":"_0===true"}}]},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header v-large-top v-medium-bottom"},"f":[{"t":2,"r":"addonLabels.selectPreferenceLabel"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["col-unit-",{"t":2,"x":{"r":["groupSize"],"s":"parseInt(_0)||2"}}," show-for-medium-up ux-addon-subgroup-container v-normal-bottom ",{"t":4,"f":["p-medium-right p-none-left"],"n":50,"x":{"r":["i","groupSize"],"s":"_0%(parseInt(_1)||2)==0"}},{"t":4,"n":51,"f":["p-medium-left"],"x":{"r":["i","groupSize"],"s":"_0%(parseInt(_1)||2)==0"}}]},"f":[{"t":7,"e":"ux-addon-subgroup","a":{"subGroupAddon":[{"t":2,"r":"."}],"enabled":[{"t":2,"x":{"r":["addon.isPendingOrder"],"s":"!_0"}}]}}]}," ",{"t":7,"e":"div","a":{"class":"col-unit-12 show-for-small-only ux-addon-subgroup-container v-normal-bottom"},"f":[{"t":7,"e":"ux-addon-subgroup","a":{"subGroupAddon":[{"t":2,"r":"."}],"enabled":[{"t":2,"x":{"r":["addon.isPendingOrder"],"s":"!_0"}}]}}]}],"n":52,"i":"i","r":"subGroups"}]}],"n":50,"r":"subGroups"}]}," ",{"t":7,"e":"div","a":{"class":[{"t":4,"f":["showConfigurePanel"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===true"}},{"t":4,"n":51,"f":["hidePanel"],"x":{"r":["showConfigurePanel"],"s":"_0===true"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-6 medium-2 fee-area v-large-top-mobile ",{"t":4,"f":["hide"],"n":50,"r":"isMyAddon"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"original-price"},"f":["U.P. ",{"t":2,"x":{"r":["RactiveHelpers","originalAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["finalAmount","originalAmount"],"s":"_1!==_0&&_1>0"}}," ",{"t":4,"f":["FREE"],"n":50,"x":{"r":["finalAmount","finalAmountIncludingTax"],"s":"_0==0||_1==0"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["finalAmountIncludingTax","finalAmount"],"s":"(_0||_1)"},"f":[{"t":2,"x":{"r":["RactiveHelpers","finalAmountIncludingTax","finalAmount"],"s":"_0.convertUnits(_1||_2,\"$\")"}}]},{"t":4,"n":50,"x":{"r":["finalAmountIncludingTax","finalAmount"],"s":"!((_0||_1))"},"f":[" FREE"]}],"x":{"r":["finalAmount","finalAmountIncludingTax"],"s":"_0==0||_1==0"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":["Set up Cost"]}],"r":"totalOneTimeCalculatedPrice"}]}," ",{"t":7,"e":"ux-col","a":{"class":["small-6 ",{"t":4,"f":["medium-4"],"n":50,"r":"isMyAddon"},{"t":4,"n":51,"f":["medium-2"],"r":"isMyAddon"}," fee-area"]},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["hide"],"n":50,"r":"isMyAddon"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"original-price"},"f":["U.P. ",{"t":2,"x":{"r":["RactiveHelpers","originalAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["finalAmount","originalAmount"],"s":"_1!==_0&&_1>0"}}," ",{"t":4,"f":["FREE"],"n":50,"x":{"r":["finalAmount","finalAmountIncludingTax"],"s":"_0==0||_1==0"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["finalAmountIncludingTax","finalAmount"],"s":"(_0||_1)"},"f":[{"t":2,"x":{"r":["RactiveHelpers","finalAmountIncludingTax","finalAmount"],"s":"_0.convertUnits(_1||_2,\"$\")"}}]},{"t":4,"n":50,"x":{"r":["finalAmountIncludingTax","finalAmount"],"s":"!((_0||_1))"},"f":[" FREE"]}],"x":{"r":["finalAmount","finalAmountIncludingTax"],"s":"_0==0||_1==0"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light v-medium-bottom"},"f":[{"t":2,"x":{"r":["RactiveHelpers","recurringChargeFrequency"],"s":"_0.getChargeFrequency(_1)"}}]}],"r":"totalRecurringCalculatedPrice"}],"n":50,"r":"totalRecurringCalculatedPrice"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header"},"f":["FREE"]}," ",{"t":7,"e":"div","a":{"class":"body-light v-medium-bottom"},"f":["Monthly"]}],"r":"totalRecurringCalculatedPrice"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["action-area"],"n":50,"r":"productDescription"},{"t":4,"n":51,"f":["v-large-top"],"r":"productDescription"}," show-for-medium-up ",{"t":4,"f":["margin-zero"],"n":50,"r":"isMyAddon"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"initData.insuranceDetails.viewPolicyLink"}],"class":"text-link rightMargin","target":"_blank"},"f":[{"t":3,"r":"initData.insuranceDetails.viewPolicyText"}]}],"n":50,"x":{"r":["isMyAddon","homeInsuranceAddonFlag"],"s":"_0&&_1"}}," ",{"t":7,"e":"ux-anchor","a":{"ontap":[{"t":4,"f":["removeAddonClicked"],"n":50,"x":{"r":["isRemoveButtonDisabled"],"s":"!_0"}}],"class":["button round light ",{"t":4,"f":["disabled"],"n":50,"r":"isRemoveButtonDisabled"}," action-button wifiMesh-button margin-zero"]},"f":[{"t":4,"f":[{"t":2,"r":"initData.removeButtonText"}],"n":50,"r":"initData.removeButtonText"},{"t":4,"n":51,"f":["Remove"],"r":"initData.removeButtonText"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip tooltip-right"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 width-percent-90 tooltip-padding20 fine-print-text-fix-white text-left"},"f":[{"t":2,"r":"removedDisabledMsg"}]}]}]}]}],"n":50,"x":{"r":["isRemoveButtonDisabled","removedDisabledMsg"],"s":"_0&&_1"}}]}],"n":50,"r":"isRemoveButton"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["action-area"],"n":50,"r":"productDescription"},{"t":4,"n":51,"f":["v-large-top"],"r":"productDescription"}," ",{"t":4,"f":["margin-zero"],"n":50,"r":"isMyAddon"}," show-for-medium-up"]},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":[{"t":4,"f":["upgradeAddonClicked"],"n":50,"x":{"r":["isUpgradeButtonDisabled"],"s":"!_0"}}],"class":["button round light ",{"t":4,"f":["disabled"],"n":50,"r":"isUpgradeButtonDisabled"}," action-button wifiMesh-button margin-zero"]},"f":[{"t":4,"f":[{"t":2,"r":"initData.upgradeButtonText"}],"n":50,"r":"initData.upgradeButtonText"},{"t":4,"n":51,"f":["Upgrade"],"r":"initData.upgradeButtonText"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip tooltip-right"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 width-percent-90 tooltip-padding20 fine-print-text-fix-white text-left"},"f":[{"t":2,"r":"removedDisabledMsg"}]}]}]}]}],"n":50,"x":{"r":["isUpgradeButtonDisabled","removedDisabledMsg"],"s":"_0&&_1"}}]}],"n":50,"r":"isUpgradeButton"}]}],"n":50,"x":{"r":["isUpgradeButton","isRemoveButton","showPrice"],"s":"_0||_1||_2"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["isAddButton"],"s":"_0"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-2  fee-area v-large-top-mobile"},"f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","selected_value":[{"t":2,"r":"selectedMonthlySubscription"}],"options":[{"t":2,"r":"monthlySubscriptionOptions"}],"onChangeEvent":"changedSelectedMonthlySubscription"}}]}],"n":50,"r":"multipleAddonPossible"}," ",{"t":7,"e":"ux-col","a":{"class":["small-12 ",{"t":4,"f":["medium-2"],"n":50,"r":"multipleAddonPossible"},{"t":4,"n":51,"f":["medium-4"],"r":"multipleAddonPossible"}," fee-area v-large-top-mobile"]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"div","a":{"class":"badges-text"},"f":["From"]},{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["price"],"s":"_0&&_0>0"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["groupType","multipleAddonPossible"],"s":"_0!==\"wifi\"&&_1"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":["FREE"]}]}],"x":{"r":["price"],"s":"_0&&_0>0"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light v-medium-bottom"},"f":[{"t":2,"r":"lstPriceLabel"}]}],"n":50,"r":"lstPriceLabel"}," ",{"t":7,"e":"div","a":{"class":[{"t":4,"f":["action-area "],"n":50,"r":"productDescription"},{"t":4,"n":51,"f":["v-large-top "],"r":"productDescription"},"show-for-medium-up"]},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":[{"t":4,"f":["addAddonClicked"],"n":50,"x":{"r":["isAddButtonDisabled"],"s":"!_0"}}],"addon":[{"t":2,"r":"addon"}],"class":["button round light wifiMesh-button ",{"t":4,"f":["disabled"],"r":"isAddButtonDisabled"}," ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["aemAddonIds","productSpecContainmentID","aemAddonIds.deviceCareCatalogId","aemAddonIds.deviceCareAddonlength"],"s":"_0&&_1==_2&&_3===3"}}]},"f":[{"t":4,"f":["Add"],"n":50,"r":"showAddButtonLabel"},{"t":4,"n":51,"f":["Update"],"r":"showAddButtonLabel"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip tooltip-right"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 width-percent-90 tooltip-padding20 fine-print-text-fix-white text-left"},"f":[{"t":2,"r":"initData.mobileSwopMsg"}]}]}]}]}],"n":50,"x":{"r":["showAddButtonLabel","aemAddonIds","productSpecContainmentID","aemAddonIds.deviceCareCatalogId","aemAddonIds.deviceCareAddonlength"],"s":"_0&&_1&&_2==_3&&_4===3"}}]}]}]}],"x":{"r":["isUpgradeButton","isRemoveButton","showPrice"],"s":"_0||_1||_2"}}]}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-2"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===true"}},{"t":4,"n":51,"f":["medium-6"],"x":{"r":["showConfigurePanel"],"s":"_0===true"}}," show-for-medium-up"]},"f":[{"t":7,"e":"div","a":{"class":"text-right expand-collapse-icon pointer"},"v":{"click":"showConfiguration"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":[{"t":4,"f":["icon-solid-chevron-up"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===false"}}]}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":[{"t":4,"f":["icon-solid-chevron-down"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===true"}}]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"action-area v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["showConfigurePanel"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===true"}},{"t":4,"n":51,"f":["hidePanel"],"x":{"r":["showConfigurePanel"],"s":"_0===true"}}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"initData.insuranceDetails.viewPolicyLink"}],"class":"text-link rightMargin","target":"_blank"},"f":[{"t":3,"r":"initData.insuranceDetails.viewPolicyText"}]}],"n":50,"x":{"r":["isMyAddon","homeInsuranceAddonFlag"],"s":"_0&&_1"}}," ",{"t":7,"e":"ux-anchor","a":{"ontap":[{"t":4,"f":["removeAddonClicked"],"n":50,"x":{"r":["isRemoveButtonDisabled"],"s":"!_0"}}],"addon":[{"t":2,"r":"addon"}],"class":["button round light ",{"t":4,"f":["disabled"],"n":50,"r":"isRemoveButtonDisabled"}," wifiMesh-button fullwidth margin-zero"]},"f":[{"t":4,"f":[{"t":2,"r":"initData.removeButtonText"}],"n":50,"r":"initData.removeButtonText"},{"t":4,"n":51,"f":["Remove"],"r":"initData.removeButtonText"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top singtel-tooltip tooltip-center"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext center tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 width-percent-90 tooltip-padding20 fine-print-text-fix-white"},"f":[{"t":2,"r":"removedDisabledMsg"}]}]}]}]}],"n":50,"x":{"r":["isRemoveButtonDisabled","removedDisabledMsg"],"s":"_0&&_1"}}],"n":50,"r":"isRemoveButton"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":[{"t":4,"f":["upgradeAddonClicked"],"n":50,"x":{"r":["isUpgradeButtonDisabled"],"s":"!_0"}}],"addon":[{"t":2,"r":"addon"}],"class":["button round light ",{"t":4,"f":["disabled"],"n":50,"r":"isUpgradeButtonDisabled"}," wifiMesh-button fullwidth margin-zero"]},"f":[{"t":4,"f":[{"t":2,"r":"initData.upgradeButtonText"}],"n":50,"r":"initData.upgradeButtonText"},{"t":4,"n":51,"f":["Upgrade"],"r":"initData.upgradeButtonText"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top singtel-tooltip tooltip-center"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext center tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 width-percent-90 tooltip-padding20 fine-print-text-fix-white"},"f":[{"t":2,"r":"removedDisabledMsg"}]}]}]}]}],"n":50,"x":{"r":["isUpgradeButtonDisabled","removedDisabledMsg"],"s":"_0&&_1"}}],"n":50,"r":"isUpgradeButton"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":[{"t":4,"f":["addAddonClicked"],"n":50,"x":{"r":["isAddButtonDisabled"],"s":"!_0"}}],"addon":[{"t":2,"r":"addon"}],"class":["button round light fullwidth wifiMesh-button ",{"t":4,"f":["disabled"],"r":"isAddButtonDisabled"}," ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["aemAddonIds","productSpecContainmentID","aemAddonIds.deviceCareCatalogId","aemAddonIds.deviceCareAddonlength"],"s":"_0&&_1==_2&&_3===3"}}]},"f":[{"t":4,"f":["Add"],"n":50,"r":"showAddButtonLabel"},{"t":4,"n":51,"f":["Update"],"r":"showAddButtonLabel"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top singtel-tooltip tooltip-center"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext center tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 width-percent-90 tooltip-padding20 fine-print-text-fix-white"},"f":[{"t":2,"r":"initData.mobileSwopMsg"}]}]}]}]}],"n":50,"x":{"r":["showAddButtonLabel","aemAddonIds","productSpecContainmentID","aemAddonIds.deviceCareCatalogId","aemAddonIds.deviceCareAddonlength"],"s":"_0&&_1&&_2==_3&&_4===3"}}],"n":50,"r":"isAddButton"}]}," ",{"t":7,"e":"div","f":[]}]}]}]}]}],"n":53,"r":"addon"}],"p":{"viewMoreLess":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"viewMore"},"f":["View More"]}],"n":51,"r":"viewMore"}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","f":[{"t":3,"x":{"r":["RactiveHelpers","tncDescription"],"s":"_0.unescapeString(_1)"}}]}," ",{"t":7,"e":"div","a":{"class":"v-large"},"f":[{"t":3,"r":"faqDescription"}]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"viewLess"},"f":["View Less"]}]}],"r":"viewMore"}]}};
this["ux-addon-subgroup"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["ux-addon-subgroup ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"div","a":{"class":["text-center data-box ",{"t":4,"f":["active"],"n":50,"r":"selected"}," ",{"t":4,"f":["pointer enabled"],"n":50,"r":"enabled"},{"t":4,"n":51,"f":["disabled"],"r":"enabled"}]},"v":{"tap":{"n":"selectSubPlan","d":[{"t":2,"r":"."},", ",{"t":2,"r":"enabled"}]}},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"r":"productTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":["From ",{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"price"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"x":{"r":["RactiveHelpers","totalOneTimeCalculatedPrice.finalAmount"],"s":"_1?_0.convertUnits(_1,\"$\"):\"FREE\""}}]}],"n":50,"x":{"r":["totalOneTimeCalculatedPrice"],"s":"_0&&_0.hasOwnProperty(\"finalAmount\")"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"x":{"r":["RactiveHelpers","totalRecurringCalculatedPrice.finalAmount"],"s":"_1?_0.convertUnits(_1,\"$\"):\"FREE\""}},"/Month"]}],"n":50,"x":{"r":["totalRecurringCalculatedPrice"],"s":"_0&&_0.hasOwnProperty(\"finalAmount\")"}}],"r":"price"}]}]}],"n":53,"r":"subGroupAddon"}]};
this["ux-addon"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":[{"t":2,"r":"class"}," ux-addon"]},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-7 addons-title"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"p","f":[{"t":3,"r":"description"}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-accordion","a":{"class":"addon","data":[{"t":2,"r":"items"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"panel-divider-top"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"online-exclusive-wrapper spacer-top"},"f":[{"t":7,"e":"div","a":{"class":"online-exclusive"},"f":[{"t":2,"r":"ribbonMarketingText"}]}]}],"n":50,"r":"ribbonMarketingText"}," ",{"t":7,"e":"ux-col","a":{"class":"small-2"},"f":[{"t":4,"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"productImage"}]}}],"n":50,"r":"productImage"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-10 columns spacer-top"},"f":[{"t":7,"e":"ux-accordionitem","a":{"class":"ux-addon-item"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header"},"f":[{"t":2,"r":"productTitle"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header"},"f":[{"t":4,"f":[{"t":7,"e":"small","a":{"class":"strike-through-dollar"},"f":["U.P. $",{"t":2,"r":"totalOneTimeCalculatedPrice.originalAmount"}]}],"n":50,"x":{"r":["totalOneTimeCalculatedPrice","totalOneTimeCalculatedPrice.originalAmount","totalOneTimeCalculatedPrice.amount"],"s":"_0&&_1>_2"}}," ",{"t":4,"f":["$",{"t":2,"r":"totalOneTimeCalculatedPrice.amount"}],"n":50,"r":"totalOneTimeCalculatedPrice"},{"t":4,"n":51,"f":["Free"],"r":"totalOneTimeCalculatedPrice"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 text-right"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header"},"f":[{"t":4,"f":[{"t":7,"e":"small","f":["FROM "]},"$",{"t":2,"r":"subGroups.0.totalRecurringCalculatedPrice.amount"}],"n":50,"x":{"r":["subGroups","subGroups.0","subGroups.0.totalRecurringCalculatedPrice"],"s":"_0&&_1&&_2"}},{"t":4,"n":51,"f":[{"t":4,"f":["$",{"t":2,"r":"totalOneTimeCalculatedPrice.amount"}],"n":50,"r":"totalRecurringCalculatedPrice"},{"t":4,"n":51,"f":["Free"],"r":"totalRecurringCalculatedPrice"}],"x":{"r":["subGroups","subGroups.0","subGroups.0.totalRecurringCalculatedPrice"],"s":"_0&&_1&&_2"}}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-7"},"f":[{"t":7,"e":"div","a":{"class":"description-wrapper"},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"contract"}," contract"]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"black subsection-header"},"f":[{"t":2,"r":"promotionText"}]}],"n":50,"r":"promotionText"}]}," ",{"t":7,"e":"div","a":{"class":"text fixed-height spacer-top"},"f":[{"t":2,"r":"productDescription"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 text-right"},"f":[{"t":7,"e":"div","a":{"class":"description-wrapper"},"f":[{"t":7,"e":"span","f":["Set up Cost"]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 text-right"},"f":[{"t":7,"e":"div","a":{"class":"description-wrapper"},"f":[{"t":7,"e":"span","f":["Monthly Subscription"]}]}," ",{"t":7,"e":"div","a":{"class":"add-remove-buttons"},"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"text":"Add","role":"button","arialabel":"Add","addon":[{"t":2,"r":"."}],"class":["default round ",{"t":4,"f":["disabled"],"n":50,"r":"isAddButtonDisabled"}],"onclick":"addVas"}}],"n":50,"r":"isAddButton"}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"text":"Remove","role":"button","arialabel":"Remove","addon":[{"t":2,"r":"."}],"class":[" default text-link floating ",{"t":4,"f":["disabled"],"n":50,"r":"isRemoveButtonDisabled"}],"onclick":"removeVas"}}],"n":50,"r":"isRemoveButton"}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"row"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"p","a":{"class":"subsection-header"},"f":["How to Activate:"]}," ",{"t":7,"e":"ul","a":{"class":"disc"},"f":[{"t":7,"e":"li","f":["Dial *1688"]}," ",{"t":7,"e":"li","f":["Use ",{"t":7,"e":"a","a":{"class":"text-link","href":"#","target":"_blank"},"f":["My Singtel App"]}]}," ",{"t":7,"e":"li","f":["Login to ",{"t":7,"e":"a","a":{"class":"text-link","href":"#","target":"_blank"},"f":["My Account"]}]}," ",{"t":7,"e":"li","f":["Visit a ",{"t":7,"e":"a","a":{"class":"text-link","href":"#","target":"_blank"},"f":["hello! Store"]}," or"]}," ",{"t":7,"e":"li","f":["Visit ",{"t":7,"e":"a","a":{"class":"text-link","href":"#","target":"_blank"},"f":["Singtel Exclusive Retailer"]}]}]}," ",{"t":7,"e":"p","a":{"class":"subsection-header"},"f":["Benefits:"]}," ",{"t":7,"e":"ul","a":{"class":"disc"},"f":[{"t":7,"e":"li","f":["Helpful - Know who is calling before you answer and minimise the number of unknown prank calls"]}," ",{"t":7,"e":"li","f":["Empowering - Decide which calls you want to answer"]}," ",{"t":7,"e":"li","f":["Affordable - Enjoy a low monitering subscription fee"]}]}," ",{"t":7,"e":"ul","a":{"class":"links no-bullet"},"f":[{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"class":"text-link","href":"#","target":"_blank"},"f":["FAQs"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"a","a":{"class":"text-link","href":"#","target":"_blank"},"f":["Terms & Conditions"]}]}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9 spacer-bottom"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"addon-anchor"},"f":[{"t":7,"e":"span","a":{"class":"view-more"},"f":["View More"]}," ",{"t":7,"e":"span","a":{"class":"view-less"},"f":["View Less"]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"size-wrapper spacer-bottom"},"f":[{"t":7,"e":"p","a":{"class":"subsection-header"},"f":["Select your preference."]}," ",{"t":4,"f":[{"t":7,"e":"input","a":{"type":"radio","id":["size-",{"t":2,"r":"productSpecContainmentID"},"-",{"t":2,"r":"index"}],"name":["size-",{"t":2,"r":"productTitle"}],"value":["size-",{"t":2,"r":"productSpecContainmentID"},"-",{"t":2,"r":"index"}]},"m":[{"t":2,"x":{"r":["index"],"s":"_0===0?\"checked\":\"\""}}]}," ",{"t":7,"e":"label","a":{"for":["size-",{"t":2,"r":"productSpecContainmentID"},"-",{"t":2,"r":"index"}]},"f":[{"t":7,"e":"span","a":{"class":"size"},"f":[{"t":2,"r":"productTitle"}]}," ",{"t":7,"e":"span","a":{"class":"price-per-months"},"f":["$",{"t":2,"x":{"r":["totalOneTimeCalculatedPrice.amount"],"s":"_0.toFixed(2)"}},"/",{"t":2,"r":"totalOneTimeCalculatedPrice.chargeFrequencyUnit"}]}]}],"n":52,"i":"index","r":"subGroups"}]}],"n":50,"r":"subGroups"}]}]}]}],"n":52,"i":"index","r":"data"}]}]}]}]}]}]};
this["ux-address-form-new"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-address-form-new"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"errorMessage"}],"validityMsgClass":"margin-zero"},"f":[]}]}]}],"n":50,"r":"errorMessage"}," ",{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-6 small-6"],"n":50,"r":"equalSpacing"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["leftOneColumn"],"s":"_0"},"f":["medium-4 small-6"]},{"t":4,"n":50,"x":{"r":["leftOneColumn"],"s":"!(_0)"},"f":["medium-8 small-6"]}],"r":"equalSpacing"}]},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom p-top-zero"},"f":["Postal Code"]}," ",{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":7,"e":"ux-input-box","a":{"type":"text","class":"postal-code-input","placeholder":"e.g 123456","value":[{"t":2,"r":"address.postCode"}],"onblurEvent":"validateZipCode","onInputEvent":"enableAddrButton","maxLength":"6","validity":[{"t":2,"r":"address.postCodeErrorMsg"}]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-6 small-6 {elseif leftOneColumn}} medium-4 small-6"],"n":50,"r":"equalSpacing"},{"t":4,"n":51,"f":["medium-4 small-6"],"r":"equalSpacing"}," text-center"]},"f":[{"t":7,"e":"div","a":{"class":"inline-form retrieve-address-form"},"f":[{"t":7,"e":"ux-button","a":{"class":["default postal-code-input-button round fullwidth ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["address.postCodeErrorMsg.status","onInitRetrieveAddressDisabled"],"s":"(_0===\"error\")||_1"}}],"text":"Retrieve","role":"button","arialabel":"Retrieve","onclick":[{"t":4,"f":["retrieveAddress"],"n":50,"x":{"r":["address.postCodeErrorMsg","address.postCodeErrorMsg.status"],"s":"typeof _0===\"undefined\"||_1!==\"error\""}}]},"f":[]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-4 small-6"],"n":50,"r":"leftOneColumn"},{"t":4,"n":51,"f":["small-12 medium-6"],"r":"leftOneColumn"}]},"f":[{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":7,"e":"ux-input-box","a":{"readonly":"true","placeholder":"123","label_value":"House / Block No.","id":"house-block-no","value":[{"t":2,"r":"address.blockOrHouseNum"}]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-4 small-6"],"n":50,"r":"leftOneColumn"},{"t":4,"n":51,"f":["small-12 medium-6"],"r":"leftOneColumn"}]},"f":[{"t":7,"e":"ux-input-box","a":{"readonly":"true","placeholder":"East Avenue","label_value":"Street name","id":"street-name","value":[{"t":2,"r":"address.streetName"}]},"f":[]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":["v-normal-top ",{"t":4,"f":["medium-8 small-12"],"n":50,"r":"leftOneColumn"},{"t":4,"n":51,"f":["small-12 medium-12"],"r":"leftOneColumn"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6 medium-6 "},"f":[{"t":7,"e":"ux-input-box","a":{"readonly":"true","placeholder":"Eg. Comcentre","label_value":"Building / Estate","id":"building-estate","value":[{"t":2,"r":"address.buildingName"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 medium-3 padding-for-mobile"},"f":[{"t":7,"e":"ux-select","a":{"class":"medium left","id":"select-floor","name":"floor","showSelectedValue":"true","options":[{"t":2,"r":"floorOptions"}],"selected_value":[{"t":2,"r":"address.selectedFloor"}],"label_value":"Floor","onChangeEvent":"onFloorChange","defaultOption":"Select","disabled":[{"t":2,"x":{"r":["address.isNotApplicable","address.blockOrHouseNum"],"s":"_0||!_1||_1===\"\""}}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 medium-3 padding-for-mobile"},"f":[{"t":7,"e":"ux-select","a":{"class":"medium left","id":"select-unit","name":"unit","showSelectedValue":"true","options":[{"t":2,"r":"unitOptions"}],"selected_value":[{"t":2,"r":"address.unitNo"}],"label_value":"Unit","onChangeEvent":"onUnitChange","defaultOption":"Select","disabled":[{"t":2,"r":"address.isNotApplicable"}]}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-bottom medium-8 small-12 v-normal-top"},"f":[{"t":7,"e":"ux-checkbox","a":{"class":"","checkboxid":[{"t":2,"r":"guid"}],"on":[{"t":2,"r":"address.isNotApplicable"}],"checked":[{"t":2,"r":"address.isNotApplicable"}],"labelvalue":[{"t":2,"r":"lables.addressFloorNotApplicable"}]}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"confirm-new-address-button-holder left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"spacer-bottom"},"f":[{"t":7,"e":"ux-button","a":{"class":["round right show-for-medium-up ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["address","disableConfirmButton","address.isNotApplicable","address.floorNo","address.unitNo"],"s":"(_0===undefined)||(_1===true)||!(_2||(_3&&_3!==\"Select\"&&_4&&_4!==\"Select\"))"}}],"text":[{"t":2,"r":"buttonText"}],"role":"button","arialabel":"Confirm New Address","onclick":"updateAddress"},"f":[]}," ",{"t":7,"e":"ux-button","a":{"class":["round center show-for-small-only ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["address","disableConfirmButton","address.isNotApplicable","address.floorNo","address.unitNo"],"s":"(_0===undefined)||(_1===true)||!(_2||(_3&&_3!==\"Select\"&&_4&&_4!==\"Select\"))"}}],"text":[{"t":2,"r":"buttonText"}],"role":"button","arialabel":"Confirm New Address","onclick":"updateAddress"},"f":[]}]}]}],"n":51,"r":"hideUpdateButton"}]}]};
this["ux-address-form"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-address-form ",{"t":2,"r":"class"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"errorMessage"}],"validityMsgClass":"margin-zero"},"f":[]}]}]}],"n":50,"r":"errorMessage"}," ",{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-6 small-6"],"n":50,"r":"equalSpacing"},{"t":4,"n":51,"f":["medium-8 small-6"],"r":"equalSpacing"}]},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom p-top-zero"},"f":["Postal Code"]}," ",{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":4,"f":[{"t":7,"e":"ux-input-box","a":{"type":"text","class":"postal-code-input","placeholder":"EG. 612356","value":[{"t":2,"r":"address.postCode"}],"onblurEvent":"validateZipCode","onInputEvent":"enableAddrButton","maxLength":"6","validity":[{"t":2,"r":"address.postCodeErrorMsg"}]}}],"n":50,"x":{"r":["isNotEditable"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":2,"r":"address.postCode"}],"x":{"r":["isNotEditable"],"s":"!_0"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-6 small-6"],"n":50,"r":"equalSpacing"},{"t":4,"n":51,"f":["medium-4 small-6"],"r":"equalSpacing"}," text-center"]},"f":[{"t":7,"e":"div","a":{"class":"inline-form retrieve-address-form"},"f":[{"t":7,"e":"ux-button","a":{"class":["default postal-code-input-button round fullwidth ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["address.postCodeErrorMsg.status","onInitRetrieveAddressDisabled"],"s":"(_0===\"error\")||_1"}}],"text":"Retrieve","role":"button","arialabel":"Retrieve","onclick":[{"t":4,"f":["retrieveAddress"],"n":50,"x":{"r":["address.postCodeErrorMsg","address.postCodeErrorMsg.status"],"s":"typeof _0!==\"undefined\"&&_1!==\"error\""}}]},"f":[]}]}]}],"n":50,"x":{"r":["isNotEditable"],"s":"!_0"}}]}," ",{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 v-normal-top"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom"},"f":["House / Block Number"]}," ",{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":4,"f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","selected_value":[{"t":2,"r":"address.blockOrHouseNum"}],"name":"address.blockOrHouseNum","options":[{"t":2,"r":"blockNumbers"}],"onChangeEvent":"onBlockOrHouseNumChange"}}],"n":50,"x":{"r":["blockNumbers","blockNumbers.length"],"s":"_0&&_1>1"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["address.blockOrHouseNum"],"s":"_0||\"Eg. 123\""}}],"x":{"r":["blockNumbers","blockNumbers.length"],"s":"_0&&_1>1"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 v-normal-top"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom"},"f":["Street Name"]}," ",{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"type":"text","placeholder":"Eg. Exeter Road","value":[{"t":2,"r":"address.streetName"}]}}],"n":50,"r":"addressFormEditable"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["address.streetName"],"s":"_0||\"Eg. Exeter Road\""}}],"r":"addressFormEditable"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom"},"f":["Building / Estate Name"]}," ",{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"type":"text","placeholder":"Eg. Comcentre","value":[{"t":2,"r":"address.buildingName"}]}}],"n":50,"r":"addressFormEditable"},{"t":4,"n":51,"f":[{"t":4,"f":["-"],"n":50,"x":{"r":["address.buildingName"],"s":"_0===\"\""}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["address.buildingName"],"s":"_0||\"Eg. Comcentre\""}}],"x":{"r":["address.buildingName"],"s":"_0===\"\""}}],"r":"addressFormEditable"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6 padding-for-mobile v-normal-top"},"f":[{"t":7,"e":"ux-select","a":{"class":"medium left","id":"select-floor","name":"floor","showSelectedValue":"true","options":[{"t":2,"r":"floorOptions"}],"label_value":"Floor No.","selected_value":[{"t":2,"r":"address.selectedFloor"}],"onChangeEvent":"onFloorChange","defaultOption":"Select"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 padding-for-mobile v-normal-top"},"f":[{"t":7,"e":"ux-select","a":{"class":"medium left","id":"select-unit","name":"unit","showSelectedValue":"true","options":[{"t":2,"r":"unitOptions"}],"selected_value":[{"t":2,"r":"address.unitNo"}],"label_value":"Unit No","onChangeEvent":"onUnitChange","defaultOption":"Select"}}]}]}],"n":51,"r":"address.isNotApplicable"}," ",{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-bottom v-normal-top"},"f":[{"t":7,"e":"ux-checkbox","a":{"class":"","checkboxid":[{"t":2,"r":"guid"}],"on":[{"t":2,"r":"address.isNotApplicable"}],"checked":[{"t":2,"r":"address.isNotApplicable"}],"labelvalue":[{"t":2,"r":"lables.addressFloorNotApplicable"}]}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"confirm-new-address-button-holder left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"spacer-bottom"},"f":[{"t":7,"e":"ux-button","a":{"class":["round right show-for-medium-up ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["address","disableConfirmButton","address.isNotApplicable","address.floorNo","address.unitNo"],"s":"(_0===undefined)||(_1===true)||!(_2||(_3&&_3!==\"Select\"&&_4&&_4!==\"Select\"))"}}],"text":"Confirm New Address","role":"button","arialabel":"Confirm New Address","onclick":"updateAddress"},"f":[]}," ",{"t":7,"e":"ux-button","a":{"class":["round center show-for-small-only ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["address","disableConfirmButton","address.isNotApplicable","address.floorNo","address.unitNo"],"s":"(_0===undefined)||(_1===true)||!(_2||(_3&&_3!==\"Select\"&&_4&&_4!==\"Select\"))"}}],"text":"Confirm New Address","role":"button","arialabel":"Confirm New Address","onclick":"updateAddress"},"f":[]}]}]}],"n":51,"r":"hideUpdateButton"}]}]};
this["ux-alert"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-alert"},"t2":{"n":"fade","a":[1000]},"f":[{"t":7,"e":"div","a":{"class":"alert_bg"},"f":[{"t":7,"e":"div","a":{"id":[{"t":2,"r":"id"}],"class":"alert"},"f":[{"t":7,"e":"div","a":{"class":"alertContent"},"f":[{"t":7,"e":"div","a":{"class":"message"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"message"}]}]}]}]}]}]}],"r":"displayState"}]};
this["ux-anchor-location"] = {"v":3,"t":[{"t":7,"e":"a","a":{"class":"ux-anchor-location","id":[{"t":2,"r":"anchorId"}]}}]};
this["ux-anchor"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"style","f":["    #",{"t":2,"r":"guid"},".ux-anchor {\n",{"t":4,"f":["        color: ",{"t":2,"r":"textColor.color"}," !important;\n"],"n":50,"r":"textColor.color"},"    }\n    #",{"t":2,"r":"guid"},".ux-anchor:hover{\n",{"t":4,"f":["        color: ",{"t":2,"r":"textColor.hoverColor"}," !important;\n"],"n":50,"r":"textColor.hoverColor"},"    }\n  "]}],"n":50,"r":"textColor"},{"t":4,"f":[{"t":7,"e":"style","f":["    ",{"t":4,"f":["\n      #",{"t":2,"r":"guid"},".ux-anchor {\n        background-color: ",{"t":2,"r":"backgroundColor.color"}," !important;\n\n      }\n"],"n":50,"r":"backgroundColor.color"},"    ",{"t":4,"f":["\n      #",{"t":2,"r":"guid"},".ux-anchor:hover{\n        background-color: ",{"t":2,"r":"backgroundColor.hoverColor"}," !important;\n      }\n"],"n":50,"r":"backgroundColor.hoverColor"},"  "]}],"n":50,"r":"backgroundColor"},{"t":4,"f":[{"t":7,"e":"style","f":["    ",{"t":4,"f":["\n      #",{"t":2,"r":"guid"},".ux-anchor:after {\n        border-color: ",{"t":2,"r":"borderColor.color"},";\n      }\n"],"n":50,"r":"borderColor.color"},"  "]}],"n":50,"r":"borderColor"},{"t":4,"f":[{"t":7,"e":"a","a":{"id":[{"t":2,"r":"guid"}],"class":["ux-anchor ",{"t":2,"r":"class"}]},"m":[{"t":4,"f":["href=\"",{"t":2,"r":"href"},"\""],"n":50,"r":"href"},{"t":4,"f":["role=\"",{"t":2,"r":"role"},"\""],"n":50,"r":"role"},{"t":4,"f":["aria-label=\"",{"t":2,"r":"ariaLabel"},"\""],"n":50,"r":"ariaLabel"},{"t":4,"f":["target=\"",{"t":2,"r":"target"},"\""],"n":50,"r":"target"},{"t":4,"f":["title=\"",{"t":2,"r":"title"},"\""],"n":50,"r":"title"},{"t":4,"f":["tabindex=\"",{"t":2,"x":{"r":["tabindex"],"s":"_0||0"}},"\""],"n":50,"x":{"r":["tabindex"],"s":"_0!==null"}}],"v":{"tap":"anchorClicked","enter":"anchorClicked","mousedown":"anchorMouseDwon"},"f":[{"t":4,"f":[{"t":3,"r":"content"}],"n":50,"r":".isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":".isDataModel"}]}],"n":50,"r":"ontap"},{"t":4,"n":51,"f":[{"t":7,"e":"a","a":{"id":[{"t":2,"r":"guid"}],"class":["ux-anchor ",{"t":2,"r":"class"}," ",{"t":2,"x":{"r":["borderColor"],"s":"_0?\"button-border\":\"\""}}]},"m":[{"t":4,"f":["href=\"",{"t":2,"r":"href"},"\""],"n":50,"r":"href"},{"t":4,"f":["role=\"",{"t":2,"r":"role"},"\""],"n":50,"r":"role"},{"t":4,"f":["aria-label=\"",{"t":2,"r":"ariaLabel"},"\""],"n":50,"r":"ariaLabel"},{"t":4,"f":["target=\"",{"t":2,"r":"target"},"\""],"n":50,"r":"target"},{"t":4,"f":["title=\"",{"t":2,"r":"title"},"\""],"n":50,"r":"title"},{"t":4,"f":["tabindex=\"",{"t":2,"x":{"r":["tabindex"],"s":"_0||0"}},"\""],"n":50,"x":{"r":["tabindex"],"s":"_0!==null"}}],"v":{"click":"anchorClicked","mousedown":"anchorMouseDwon"},"f":[{"t":4,"f":[{"t":3,"r":"content"}],"n":50,"r":".isDataModel"},{"t":4,"n":51,"f":[{"t":16}],"r":".isDataModel"}]}],"r":"ontap"}]};
this["ux-ask-francis"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-ask-francis"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["fixed-button ",{"t":4,"f":["show"],"n":50,"r":"enable"}]},"f":[" ",{"t":7,"e":"ux-anchor","a":{"ontap":"openCisChatModal"},"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":3,"r":"popupImage"}],"class":["popup-message show-for-medium-up ",{"t":4,"f":["hide"],"n":50,"r":"hidePopUp"}]}}," ",{"t":7,"e":"ux-image","a":{"img":[{"t":3,"r":"franCISImage"}]}}]}]}],"n":50,"r":"enable"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["ux-francis ",{"t":4,"f":["show"],"n":50,"r":"showChatPopup"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"mainHeight  p-large-top action-bar top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-10 large-4 medium-5 shadow mainHeight"},"f":[" ",{"t":7,"e":"ux-row","a":{"class":"mainHeight"},"f":[{"t":7,"e":"ux-col","a":{"class":"p-none-left p-none-right mainHeight"},"f":[{"t":7,"e":"iframe","a":{"id":"ChatWindow","class":"frame","scrolling":"no","frameborder":"1","src":[{"t":2,"r":"franCisIframeURL"}]}}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 p-small-top p-normal-left iconCol"},"f":[{"t":7,"e":"ux-row","a":{"class":"img-cross"},"f":[{"t":7,"e":"ux-col","a":{"class":"p-small-top"},"f":[{"t":7,"e":"ux-icon","a":{"type":"close","ontap":"doCisChatMinimize","class":"close center-cross-align"},"f":[]}]}]}," "]}]}]}],"n":50,"r":"showChatPopup"}]}]};
this["ux-ask-shirley"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-ask-shirley"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"div","a":{"class":"ask-shirley-header"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"icon-container medium-2 text-center v-normal-bottom"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"shirleyimagesrc"}],"alt":[{"t":3,"r":"shirleyimagealt"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-10 small-only-text-center"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header v-medium-bottom"},"f":[{"t":2,"r":"greetings"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":2,"r":"description"}]}," ",{"t":7,"e":"ux-row","a":{"class":"row collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":" medium-6 large-10"},"f":[{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":7,"e":"ux-input-box","a":{"id":"question","value":[{"t":2,"r":"question"}],"placeholder":[{"t":2,"r":"placeholder"}],"name":"question","onEnterEvent":"doAsk"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":" medium-6 large-2 text-center"},"f":[{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":7,"e":"ux-button","a":{"class":"round small-only-expand v-normal-left","text":[{"t":2,"r":"buttonLabel"}],"role":"button","arialabel":"Ask Button","onclick":"doAsk"},"f":[]}]}]}]}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["show"],"n":50,"r":"displayFlag"},{"t":4,"n":51,"f":["hide"],"r":"displayFlag"}]},"f":[{"t":7,"e":"ux-virtual-agent","f":[]}]}],"n":50,"r":"independent"}]}]};
this["ux-avatar-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-avatar-singtel"},"f":[{"t":4,"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"avatarImg.src"}],"alt":[{"t":3,"r":"avatarImg.alt"}]}}],"n":50,"r":"avatarImg.src"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-image","a":{"src":"assets/images/default/default-avatar.png","alt":"default avatar"}}],"r":"avatarImg.src"}]}]};
this["ux-background-image"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-background-image ",{"t":2,"r":"class"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["show-for-medium-up ",{"t":4,"f":["fullWidth"],"n":50,"r":"fullWidth"}," ",{"t":2,"r":"imagePosition"}," ",{"t":2,"r":"extraClass"}],"style":["background-image:url('",{"t":3,"r":"src"},"'); height:",{"t":2,"x":{"r":["height"],"s":"_0?(_0+\"px\"):\"auto\""}}]}}],"r":"desktop"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["show-for-small-only ",{"t":4,"f":["fullWidth"],"n":50,"r":"fullWidth"}," ",{"t":2,"r":"imagePosition"}," ",{"t":2,"r":"extraClass"}],"style":["background-image:url('",{"t":3,"r":"src"},"'); height:",{"t":2,"x":{"r":["height"],"s":"_0?(_0+\"px\"):\"auto\""}}]}}],"r":"mobile"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["fullWidth"],"n":50,"r":"fullWidth"}," ",{"t":2,"r":"imagePosition"}," ",{"t":2,"r":"extraClass"}],"style":["background-image:url('",{"t":3,"r":"src"},"'); height:",{"t":2,"x":{"r":["height"],"s":"_0?(_0+\"px\"):\"auto\""}}]}}],"r":"img"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["fullWidth"],"n":50,"r":"fullWidth"}," ",{"t":2,"r":"imagePosition"}," ",{"t":2,"r":"extraClass"}],"style":["background-image:url('",{"t":3,"r":"src"},"'); height:",{"t":2,"x":{"r":["height"],"s":"_0?(_0+\"px\"):\"auto\""}}]}}],"n":50,"r":"src"}],"n":50,"x":{"r":["isDataModel","src"],"s":"_0||_1"}},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"x":{"r":["isDataModel","src"],"s":"_0||_1"}}]}]};
this["ux-banner-overlap"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-banner-overlap show-for-medium-up v-normal-bottom","style":["margin-top:-",{"t":2,"r":"desktopHighlightY"},"px;"]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"ux-banner-overlap-container"},"f":[{"t":7,"e":"div","a":{"class":["hero-text ",{"t":2,"r":"theme"}]},"m":[{"t":4,"f":["style=\"margin-left:-",{"t":2,"r":"desktopHighlightX"},"px;\""],"n":50,"r":"desktopHighlightX"}],"f":[{"t":2,"r":"pageSummary"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onTap","class":"no-print"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"printImage.src"}],"alt":[{"t":2,"r":"printImage.alt"}]}}," ",{"t":2,"r":"printText"}]}],"n":50,"r":"showPrintIcon"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"ux-banner-overlap show-for-small-only","style":["margin-top:-",{"t":2,"r":"mobileHighlightY"},"px;padding:0 0px;"]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":["hero-text mobileAlignment ",{"t":2,"r":"theme"}]},"m":[{"t":4,"f":["style=\"margin-left:-",{"t":2,"r":"mobileHighlightX"},"px;\""],"n":50,"r":"mobileHighlightX"}],"f":[{"t":2,"r":"pageSummary"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"text-center"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onTap","class":"no-print"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"printImage.src"}],"alt":[{"t":2,"r":"printImage.alt"}]}}," ",{"t":2,"r":"printText"}]}]}]}]};
this["ux-banner-tab"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-banner-tab"},"f":[{"t":4,"f":[" ",{"t":7,"e":"ul","a":{"class":["tab-wrapper ",{"t":4,"f":["tab-type-float"],"n":50,"x":{"r":["tabPosition"],"s":"_0===\"inside\""}}]},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":[{"t":4,"f":["active"],"n":50,"x":{"r":["tabActiveIndex","i"],"s":"_0===_1"}}],"style":["border-top-color: ",{"t":2,"r":"tabColorPrimary"},"; border-bottom-color: ",{"t":2,"r":"tabColorPrimary"},"; border-right-color: ",{"t":2,"r":"tabColorPrimary"},"; ",{"t":4,"f":[{"t":4,"f":["border-left: 1px solid ",{"t":2,"r":"tabColorPrimary"},";"],"n":50,"r":"tabColorPrimary"}," border-radius: 4px 0 0 4px;"],"n":50,"x":{"r":["i"],"s":"_0===0"}}," ",{"t":4,"f":["background-color: ",{"t":2,"r":"tabColorSecondary"},";"],"n":50,"x":{"r":["tabActiveIndex","i"],"s":"_0===_1"}}]},"f":[{"t":7,"e":"a","a":{"href":"#","id":[{"t":2,"r":"i"}]},"v":{"click":{"n":"onTabClicked","d":[{"t":2,"r":"i"}]}},"f":[{"t":7,"e":"span","a":{"class":"tab-title","style":["color: ",{"t":4,"f":[{"t":2,"r":"tabTextColorSecondary"}],"n":50,"x":{"r":["tabActiveIndex","i"],"s":"_0===_1"}},{"t":4,"n":51,"f":[{"t":2,"r":"tabTextColorPrimary"}],"x":{"r":["tabActiveIndex","i"],"s":"_0===_1"}}]},"f":[{"t":2,"r":"tabTitle"}]}]}]}],"n":52,"i":"i","r":"tabData"}]}," ",{"t":7,"e":"div","a":{"class":"tab-content"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["tab-item ",{"t":4,"f":["active"],"n":50,"x":{"r":["tabActiveIndex","i"],"s":"_0===_1"}}]},"f":[{"t":7,"e":"ux-fullwidth-banner","a":{"datamodel":[{"t":3,"r":"fullWidthBannerData"}]}}]}],"n":52,"i":"i","r":"tabData"}]}," "],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-barchart"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-barchart v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[" ",{"t":7,"e":"ul","a":{"class":"chart"},"f":[{"t":7,"e":"li","m":[{"t":4,"f":["class=\"negativeYaxisBorder\" style=\"top:",{"t":2,"r":"finalMaxCreditTop"},"px\""],"n":50,"r":"hasCreditBalance"}],"f":[{"t":7,"e":"span","a":{"class":"dateXaxisFormatting"},"m":[{"t":4,"f":["style=\"top:-",{"t":2,"x":{"r":["finalMaxCreditTop","initialMaxCreditTop"],"s":"_0-_1"}},"px;\""],"n":50,"r":"hasCreditBalance"}],"f":["Date"]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["RactiveHelpers","totalChargesWithoutBalance"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":["bar paid ",{"t":2,"r":"category"}],"style":["height:",{"t":2,"x":{"r":["totalChargesWithoutBalance","highest"],"s":"((_0/_1)*16)/6.25"}},"px"]},"f":[]}," ",{"t":7,"e":"span","a":{"class":"xaxisFormatting"},"f":[{"t":2,"x":{"r":["moment","endDate"],"s":"_0.unix(_1/1000).format(\"MMM YY\")"}},{"t":4,"f":[" (Interim)"],"n":50,"r":"interim"}]}]}],"n":50,"x":{"r":["totalChargesWithoutBalance"],"s":"_0>=0"}},{"t":4,"n":51,"f":[{"t":7,"e":"li","a":{"style":["top:",{"t":2,"x":{"r":["totalChargesWithoutBalance","highest"],"s":"Math.abs((_0/_1)*16)/6.25+30"}},"px;"]},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["moment","endDate"],"s":"_0.unix(_1/1000).format(\"MMM YY\")"}},{"t":4,"f":[" (Interim)"],"n":50,"r":"interim"}]}," ",{"t":7,"e":"div","a":{"class":["bar paid ",{"t":2,"r":"category"}],"style":["height:",{"t":2,"x":{"r":["totalChargesWithoutBalance","highest"],"s":"Math.abs((_0/_1)*16)/6.25"}},"px;margin-bottom:5px;"]},"f":[]}," ",{"t":7,"e":"span","a":{"class":"graph-amount"},"f":[{"t":2,"x":{"r":["RactiveHelpers","totalChargesWithoutBalance"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"x":{"r":["totalChargesWithoutBalance"],"s":"_0>=0"}}],"n":52,"x":{"r":["RactiveHelpers","barList"],"s":"_0.sortData(_1,\"billClosedDate\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"style":["height:",{"t":2,"x":{"r":["finalMaxCreditTop"],"s":"_0+270"}},"px"]},"f":[]}],"n":50,"r":"hasCreditBalance"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[" ",{"t":7,"e":"ul","a":{"class":"chart"},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"negativeYaxisBorder","style":["top:",{"t":2,"r":"finalMaxCreditTop"},"px"]},"f":[]}],"n":50,"r":"hasCreditBalance"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"span","a":{"class":"graph-amount"},"f":[{"t":2,"x":{"r":["RactiveHelpers","totalChargesWithoutBalance"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":["bar paid ",{"t":2,"r":"category"}],"style":["height:",{"t":2,"x":{"r":["totalChargesWithoutBalance","highest"],"s":"((_0/_1)*16)/6.25"}},"px"]},"f":[]}," ",{"t":7,"e":"span","f":[{"t":2,"x":{"r":["moment","endDate"],"s":"_0.unix(_1/1000).format(\"MMM\")"}},{"t":4,"f":[" (Interim)"],"n":50,"r":"interim"}]}]}],"n":50,"x":{"r":["totalChargesWithoutBalance"],"s":"_0>=0"}},{"t":4,"n":51,"f":[{"t":7,"e":"li","a":{"style":["top:",{"t":2,"x":{"r":["totalChargesWithoutBalance","highest"],"s":"Math.abs((_0/_1)*16)/6.25+30"}},"px;"]},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["moment","endDate"],"s":"_0.unix(_1/1000).format(\"MMM\")"}},{"t":4,"f":[" (Interim)"],"n":50,"r":"interim"}]}," ",{"t":7,"e":"div","a":{"class":["bar paid ",{"t":2,"r":"category"}],"style":["height:",{"t":2,"x":{"r":["totalChargesWithoutBalance","highest"],"s":"Math.abs((_0/_1)*16)/6.25"}},"px;margin-bottom:5px;"]},"f":[]}," ",{"t":7,"e":"span","a":{"class":"graph-amount"},"f":[{"t":2,"x":{"r":["RactiveHelpers","totalChargesWithoutBalance"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"x":{"r":["totalChargesWithoutBalance"],"s":"_0>=0"}}],"n":52,"x":{"r":["RactiveHelpers","barList"],"s":"_0.sortData(_1,\"billClosedDate\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"style":["height:",{"t":2,"x":{"r":["finalMaxCreditTop"],"s":"_0+270"}},"px"]},"f":[]}],"n":50,"r":"hasCreditBalance"}]}," "]}]};
this["ux-benefit-component"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-benefit-component"},"f":[{"t":7,"e":"ux-row","a":{"class":[{"t":2,"r":"theme"}," v-medium-left"]},"f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-start"},"f":[{"t":7,"e":"div","a":{"class":"flex-item flex-item-top-align"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"img.src"}],"alt":[{"t":2,"r":"img.alt"}]}}]}," ",{"t":7,"e":"div","a":{"class":"flex-item flex-item-top-align p-medium-left p-medium-right"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"text"}]}],"n":50,"r":"text"}]}]}]}]}]};
this["ux-bill-explainer-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-bill-explainer-singtel ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}," ",{"t":4,"f":["v-",{"t":2,"r":"bottomSpacing"},"-bottom"],"n":50,"r":"bottomSpacing"}]},"f":[{"t":7,"e":"ux-panel","a":{"class":"clearfix"},"f":[{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-accordion","a":{"class":"specification-accordion","messageState":[{"t":2,"r":"messageState"}],"label":[{"t":2,"r":"label"}],"billMessage":[{"t":2,"r":"billMessage"}],"msgTopPos":[{"t":2,"r":"msgTopPos"}],"infoClickedStatus":[{"t":2,"r":"infoClickedStatus"}],"data":[{"t":3,"r":"."}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"class":"free-gifts"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"clearfix"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"div","a":{"class":"left v-medium-top accordion-title"},"f":[{"t":2,"r":"data.billExplainerTitle"}]}," ",{"t":7,"e":"div","a":{"class":"right v-normal-top"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"clearfix v-normal-top expand-panel-item"},"f":[{"t":7,"e":"div","a":{"class":"bill-tab-container left"},"f":[{"t":7,"e":"ux-tabarea","a":{"infoClickedStatus":[{"t":2,"r":"infoClickedStatus"}],"data":[{"t":2,"r":"data"}]},"f":[{"t":7,"e":"ux-tablinks","a":{"items":[{"t":2,"r":"data.billTabInfo"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-tablink","a":{"active":[{"t":3,"x":{"r":["active"],"s":"_0?true:false"}}],"id":["page",{"t":2,"r":"i"}]},"f":[{"t":2,"r":"tabTitle"}]}],"n":52,"i":"i","r":"items"}]}," ",{"t":7,"e":"ux-tabpanes","a":{"dotselection":[{"t":2,"r":"infoClickedStatus"}],"panels":[{"t":2,"r":"data.billTabInfo"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-tabpane","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"bill-container v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"bill-image-container"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"billImage"}]}}," ",{"t":7,"e":"div","a":{"class":"bill-dots"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["dot ",{"t":2,"rx":{"r":"dotselection","m":[{"r":["k","i"],"s":"_0+\"\"+_1"}]}}],"style":["top:",{"t":2,"r":"y"},"px; left:",{"t":2,"r":"x"},"px;"]},"v":{"tap":{"n":"showBillInfoForPoint","d":[{"t":2,"r":"k"},",",{"t":2,"r":"message"},",",{"t":2,"r":"i"}]},"mouseover":{"n":"showBillInfoForPoint","d":[{"t":2,"r":"k"},",",{"t":2,"r":"message"},",",{"t":2,"r":"i"}]},"mouseleave":{"n":"showBillInfoForPoint","d":[{"t":2,"r":"k"},",",{"t":2,"r":"message"},",",{"t":2,"r":"i"}]}},"f":[{"t":2,"r":"label"}]}],"i":"i","r":"infoPoint"}]}]}]}],"i":"k","r":"billExplainerData"}," ",{"t":7,"e":"div","a":{"class":["highlight-box hide ",{"t":2,"r":"highlightState"}],"style":["top:",{"t":2,"r":"highlightY"},"px; left:",{"t":2,"r":"highlightX"},"px; width:",{"t":2,"r":"highlightW"},"px; height:",{"t":2,"r":"highlightH"},"px;"]}}]}],"n":52,"i":"i","r":"panels"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"bill-message-container right show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":["bill-message v-large-right hide ",{"t":2,"r":"messageState"}],"style":["top:",{"t":2,"r":"msgTopPos"},"px;"]},"f":[{"t":7,"e":"div","a":{"class":"dot selected left"},"f":[{"t":2,"r":"label"}]}," ",{"t":7,"e":"div","a":{"class":"msg"},"f":[{"t":3,"r":"billMessage"}]}]}]}]}]}]}]}]}]}]};
this["ux-billing-accounts"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-billing-accounts"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["show-for-medium-up account v-normal-top hover-container ",{"t":4,"f":["v-normal-bottom"],"n":50,"x":{"r":["i","accounts.length"],"s":"_0<_1-1"}},{"t":4,"n":51,"f":["v-medium-bottom"],"x":{"r":["i","accounts.length"],"s":"_0<_1-1"}}," ",{"t":4,"f":["selected"],"n":50,"r":"isSelected"}],"data-account-id":[{"t":2,"r":"billingAccountNumber"}]},"v":{"click":{"n":"doSelectAccount","d":[{"t":2,"r":"i"}]}},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-1"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"avatarImg.src"}],"alt":[{"t":3,"r":"avatarImg.alt"}],"class":"avatar full-sized"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-7"},"f":[{"t":7,"e":"div","a":{"class":"section-header v-medium-bottom"},"f":[{"t":2,"r":"nickName"}," (Account no.: ",{"t":2,"r":"faid"},")"]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":["Easy Mobile: ",{"t":2,"x":{"r":["RactiveHelpers","subscribers.0.subscriberResourceVal"],"s":"_0.formatMobileNumberWithSpace(_1,\"MOB\")"}}]}],"n":50,"r":"isEasyMobile"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"x":{"r":["RactiveHelpers","subscriberType"],"s":"_0.getServicePropLob(_1?_1:\"BN\",\"name\")"}},": ",{"t":2,"x":{"r":["RactiveHelpers","subscriberResourceVal","subscriberType"],"s":"_0.formatMobileNumberWithSpace(_1,_2)"}}]}],"n":52,"i":"i","r":"subscribers"}],"r":"isEasyMobile"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4 text-right"},"f":[{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"r":"ConfigStrings.consolidateAccount.billingAddress"},{"t":7,"e":"br"}," ",{"t":4,"f":[{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"physicalAddress"}]}}],"n":53,"r":"physicalAddress"}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":["show-for-small-only text-center ",{"t":4,"f":["selected"],"n":50,"r":"isSelected"}],"data-account-id":[{"t":2,"r":"billingAccountNumber"}]},"v":{"click":"doSelectAccount"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"avatarImg.src"}],"alt":[{"t":3,"r":"avatarImg.alt"}],"class":"avatar full-sized"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"section-header section-header-full-width"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"nickName"}]}," ",{"t":7,"e":"div","f":["(A/C: ",{"t":2,"r":"faid"},")"]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":2,"r":"ConfigStrings.consolidateAccount.billingAddress"}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-bottom body-copy"},"f":[{"t":4,"f":[{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"physicalAddress"}]}}],"n":53,"r":"physicalAddress"}]}," ",{"t":7,"e":"br"},{"t":7,"e":"br"}," ",{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","f":["Easy Mobile: ",{"t":2,"x":{"r":["RactiveHelpers","subscribers.0.subscriberResourceVal"],"s":"_0.formatMobileNumberWithSpace(_1,\"MOB\")"}}]}],"n":50,"r":"isEasyMobile"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["RactiveHelpers","subscriberType"],"s":"_0.getServicePropLob(_1?_1:\"BN\",\"name\")"}},": ",{"t":2,"x":{"r":["RactiveHelpers","subscriberResourceVal","subscriberType"],"s":"_0.formatMobileNumberWithSpace(_1,_2)"}}]}],"n":52,"r":"subscribers"}],"r":"isEasyMobile"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"class":[{"t":4,"f":["light"],"n":51,"x":{"r":["homeAccount.billingAccountNumber","billingAccountNumber"],"s":"_0===_1"}}," round margin-zero"],"onclick":"","text":"Select"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider v-large v-none-left-medium v-none-right-medium extend-for-small"}}],"n":50,"x":{"r":["i","accounts.length"],"s":"_0<_1-1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-top v-medium-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"class":[{"t":4,"f":["light"],"n":51,"x":{"r":["homeAccount.billingAccountNumber","billingAccountNumber"],"s":"_0===_1"}}," round margin-zero"],"onclick":"doSelectAccount","text":"Select"}}]}]}],"x":{"r":["i","accounts.length"],"s":"_0<_1-1"}}]}],"n":50,"x":{"r":["faStatus"],"s":"_0!==88&&_0!==78"}}],"n":52,"i":"i","r":"accounts"}]}]};
this["ux-billing-details"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-billing-details ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"large-row column-control-mobile"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","a":{"class":"panel30 margin-zero"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-top v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"initData.billingDetails.mainTitle"}]}]}]}],"n":50,"x":{"r":["orderFullfilment.billingDetails.recontractAccount"],"s":"!_0"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":2,"r":"initData.billingDetails.description"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"select-account-wrapper"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 large-4"},"f":[{"t":7,"e":"input","a":{"id":"account-0","checked":0,"type":"radio","name":"select-billing-account","value":[{"t":2,"r":"billingAccountNumber"}]}}," ",{"t":7,"e":"label","a":{"for":"account-0"},"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":3,"r":"avatar"}]}}," ",{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"r":"nickName"}]}," ",{"t":7,"e":"p","a":{"class":"body-copy-text"},"f":[{"t":2,"r":"initData.accountNumberLabel"},": ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","faId"],"s":"_0.maskAccountNo(_1)"}}],"n":50,"x":{"r":["onepassInfo.isWorryFreeLogin","onepassInfo.isWorryFreeFaVerfied"],"s":"_0&&!_1"}},{"t":4,"n":51,"f":[{"t":2,"r":"faId"}],"x":{"r":["onepassInfo.isWorryFreeLogin","onepassInfo.isWorryFreeFaVerfied"],"s":"_0&&!_1"}}]}," ",{"t":7,"e":"div","a":{"class":"subsection-header v-medium-top"},"f":[{"t":2,"r":"initData.billingAddressLabel"}]}," ",{"t":7,"e":"p","a":{"class":"body-copy-text"},"f":[{"t":7,"e":"ux-singtel-address","a":{"addressType":"crmUpdatedAddressFormat","useOriginalCase":"true","isMaskingReqd":[{"t":2,"x":{"r":["onepassInfo.isWorryFreeLogin","onepassInfo.isWorryFreeFaVerfied"],"s":"_0&&!_1"}}],"address":[{"t":2,"r":"physicalAddress"}]},"f":[]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}],"n":53,"r":"physicalAddress"}],"n":50,"x":{"r":[],"s":"false"}}]}]}]}],"n":53,"r":"selectedAccount"}],"n":50,"r":"selectedAccount"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 large-4"},"f":[{"t":7,"e":"input","a":{"id":["account-",{"t":2,"r":"i"}],"type":"radio","name":"select-billing-account","value":[{"t":2,"r":"billingAccountNumber"}]},"v":{"change":{"n":"selectAccount","d":[{"t":2,"r":"billingAccountNumber"}]}}}," ",{"t":7,"e":"label","a":{"for":["account-",{"t":2,"r":"i"}]},"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":3,"r":"avatar"}]}}," ",{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"r":"nickName"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"initData.accountNumberLabel"},": ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","faId"],"s":"_0.maskAccountNo(_1)"}}],"n":50,"x":{"r":["onepassInfo.isWorryFreeLogin","onepassInfo.isWorryFreeFaVerfied"],"s":"_0&&!_1"}},{"t":4,"n":51,"f":[{"t":2,"r":"faId"}],"x":{"r":["onepassInfo.isWorryFreeLogin","onepassInfo.isWorryFreeFaVerfied"],"s":"_0&&!_1"}}]}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.billingAddressLabel"}]}," ",{"t":7,"e":"ux-singtel-address","a":{"addressType":"crmUpdatedAddressFormat","useOriginalCase":"true","isMaskingReqd":[{"t":2,"x":{"r":["onepassInfo.isWorryFreeLogin","onepassInfo.isWorryFreeFaVerfied"],"s":"_0&&!_1"}}],"address":[{"t":2,"r":"physicalAddress"}]},"f":[]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}],"n":53,"r":"physicalAddress"}],"n":50,"x":{"r":[],"s":"false"}}]}]}],"n":52,"i":"i","r":"accounts"}],"n":50,"x":{"r":["orderFullfilment.billingDetails.billPayer"],"s":"_0===\"1\"||_0===1"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 large-4"},"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"id":"contact-address","type":"radio","name":"select-billing-account","value":[{"t":2,"r":"postcode"}]},"v":{"change":{"n":"selectAccount","a":[-1]}}}," ",{"t":7,"e":"label","a":{"for":"contact-address"},"f":[{"t":7,"e":"ux-image","a":{"class":"contact-image-holder"},"m":[{"t":4,"f":["img=\"",{"t":3,"r":"contactAvatar"},"\""],"n":50,"r":"contactAvatar"}]}," ",{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"initData.contactAddressLabel"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"initData.asNewBillingAddressLabel"}]}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.contactAddressLabel"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}]}],"n":53,"r":"contactAddress"}]}],"n":50,"x":{"r":["contactAddress","contactAddress.postcode"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 large-4"},"f":[{"t":7,"e":"input","a":{"id":"installation-contact-address","type":"radio","name":"select-billing-account","value":[{"t":2,"r":"installationAddress.postcode"}]},"v":{"change":{"n":"selectAccount","a":[-2]}}}," ",{"t":7,"e":"label","a":{"for":"installation-contact-address"},"f":[{"t":7,"e":"ux-image","a":{"class":"contact-image-holder"},"m":[{"t":4,"f":["img=\"",{"t":3,"r":"contactAvatar"},"\""],"n":50,"r":"contactAvatar"}]}," ",{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"initData.installationAddressLabel"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"initData.asNewBillingAddressLabel"}]}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.installationAddressLabel"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}],"n":53,"r":"installationAddress"}]}]}],"n":50,"r":"installationAddress.postcode"}],"n":53,"r":"orderFullfilment.billingDetails"}],"r":"selectedAccount"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 large-4"},"f":[{"t":7,"e":"input","a":{"id":["newAccount-",{"t":2,"r":"i"}],"type":"radio","checked":"chkId","name":"select-billing-account","value":[{"t":2,"r":"postalCode"}]},"v":{"change":"onSelectNewAddress"}}," ",{"t":7,"e":"label","a":{"for":["newAccount-",{"t":2,"r":"i"}]},"f":[{"t":7,"e":"ux-image","a":{"class":"contact-image-holder"},"m":[{"t":4,"f":["img=\"",{"t":3,"r":"contactAvatar"},"\""],"n":50,"r":"contactAvatar"}]}," ",{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"initData.newBillingAddressLabel"}]}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.billingAddressLabel"}]}," ",{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"."}],"addressType":"sdpRetrieveAddress"},"f":[]}]}]}],"n":52,"i":"i","r":"newAddressAdded"}],"n":50,"x":{"r":["newAddressAdded","newAddressAdded.length"],"s":"_0&&_1>0"}}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"addNewAddressLink"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-anchor","a":{"ontap":"showAddNewAddressWindow"},"f":["Add New Billing Address"]}]}]}],"n":50,"x":{"r":["orderFullfilment.billingDetails.installationAddress","selectedAccount","newAddressAdded","orderFullfilment.billingDetails.contactAddress","orderFullfilment.billingDetails.billPayer","accounts","accounts.length"],"s":"_0||_1||_2||_3||((_4===\"1\"||_4===1)&&_5&&_6>0)"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"ux-address-form-new","a":{"addressType":"sdpRetrieveAddress","address":[{"t":2,"r":"addressRetrieve.address"}],"addressList":[{"t":2,"r":"addressList"}],"errorMessage":[{"t":2,"r":"errorMessage"}],"onUpdate":"confirmAddNewAddress","hideUpdateButton":"true"},"f":[]}]}]}],"x":{"r":["orderFullfilment.billingDetails.installationAddress","selectedAccount","newAddressAdded","orderFullfilment.billingDetails.contactAddress","orderFullfilment.billingDetails.billPayer","accounts","accounts.length"],"s":"_0||_1||_2||_3||((_4===\"1\"||_4===1)&&_5&&_6>0)"}}],"n":51,"x":{"r":["deviceIdAndPlanId.reContractFlag","deviceIdAndPlanId.mobileReContractFlag","orderFullfilment.billingDetails.selectedAddress","selectedAccount"],"s":"((_0||_1)&&_2)||_3"}}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider v-small-top"}}," ",{"t":7,"e":"div","a":{"class":"divider show-for-small-only"}}],"n":50,"x":{"r":["orderFullfilment.billingDetails.recontractAccount"],"s":"!_0"}}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"paper-bill-option medium-8"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"description"}]}," ",{"t":7,"e":"ux-radio-button","a":{"use_content":"true","btn_id":"1","value":"e_bill","name":"bill-pref","onclick":"billMethodSelected","selected":[{"t":2,"r":"selected"}],"class":"v-large-top"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"eBillHeader"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"eBillDescription"}]}]}]}," ",{"t":7,"e":"ux-radio-button","a":{"use_content":"true","btn_id":"1","value":"paper_bill","name":"bill-pref","onclick":"billMethodSelected","selected":[{"t":2,"r":"selected"}],"class":"v-normal-top"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"paperBillHeader"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"paperBillDescription"}]}]}]}]}],"n":50,"x":{"r":["orderFullfilment.easyMobileInd","orderFullfilment.billingDetails.isEbillCus","accounts.length"],"s":"!_0&&(!_1||_2===0)"}}],"n":53,"r":"initData.billingDetails.singtelEBill"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","a":{"class":"paper-bill-option-button v-medium-top v-medium-bottom text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["round small-only-expand ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["deviceIdAndPlanId.reContractFlag","dataSelected"],"s":"(_0&&_0===false)||(!_1)"}}],"text":"Next","role":"button","arialabel":"Next","onclick":"eBillNext"}}]}]}],"n":50,"x":{"r":["deviceIdAndPlanId.skipOF","orderFullfilment.billingDetails.hasSim","orderFullfilment.billingDetails.needsOnlyMBBDelivery","orderFullfilment.billingDetails.homeLineDeliveryRequired","orderFullfilment.deliveryDetails.installationRequired","idDocumentsUpload.documentNeeded","isRedemptionRequired","isPremiumProduct"],"s":"!_0&&((_1&&!_2)||_3||_4||_5||(_6&&_7))"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","a":{"class":"paper-bill-option-button v-medium-top v-medium-bottom text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["round small-only-expand ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["deviceIdAndPlanId.reContractFlag","dataSelected"],"s":"(_0&&_0===false)||(!_1)"}}],"text":"Proceed to Order Summary","role":"button","arialabel":"Proceed to Order Summary","onclick":"eBillNext"}}]}]}],"x":{"r":["deviceIdAndPlanId.skipOF","orderFullfilment.billingDetails.hasSim","orderFullfilment.billingDetails.needsOnlyMBBDelivery","orderFullfilment.billingDetails.homeLineDeliveryRequired","orderFullfilment.deliveryDetails.installationRequired","idDocumentsUpload.documentNeeded","isRedemptionRequired","isPremiumProduct"],"s":"!_0&&((_1&&!_2)||_3||_4||_5||(_6&&_7))"}}]}],"n":50,"r":"isOpened"}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"addNewBillingAddress"},"f":[{"t":7,"e":"ux-row","a":{"class":"new-billing-address-form-wrapper collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"section-header"},"f":["Confirm your New Billing Address"]}," ",{"t":7,"e":"div","a":{"class":"body-text"},"f":["We will use new billing address for all communication purpose"]}," ",{"t":7,"e":"ux-row","a":{"class":"new-address-holder"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-5 new-address-holder-left-column"},"f":[{"t":7,"e":"ux-row","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.newBillingAddressLabel"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-anchor","a":{"ontap":"changeNewAddress"},"f":["Change"]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-7 address"},"f":[{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"addressRetrieve.address"}],"addressType":"sdpRetrieveAddress"},"f":[]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-button","a":{"onclick":"confirmAddNewAddress","text":"Confirm","class":"light right round v-normal-top expand-for-mobile"}}]}]}],"n":50,"x":{"r":["toConfirmNewAddress"],"s":"_0===true"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"section-header v-normal-bottom"},"f":[{"t":2,"r":"initData.newBillingAddressLabel"}]}," ",{"t":7,"e":"div","a":{"class":"section-details v-normal-bottom"},"f":["Please enter your details for new billing Address"]}," ",{"t":7,"e":"ux-address-form","a":{"class":"address-form-wrapper section-details","address":[{"t":2,"r":"addressRetrieve.address"}],"errorMessage":[{"t":2,"r":"errorMessage"}],"onUpdate":"createBilling","addressList":[{"t":2,"r":"addressList"}],"disableConfirmButton":[{"t":2,"r":"disableDeliveryConfirmButton"}]}}],"x":{"r":["toConfirmNewAddress"],"s":"_0===true"}}]}]}]}]}]};
this["ux-billpayment-service"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-billpayment-service ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-accordion","a":{"subscription":[{"t":2,"r":"subscription"}],"RactiveHelpers":[{"t":2,"r":"RactiveHelpers"}],"isEasyMobileAccount":[{"t":2,"r":"isEasyMobileAccount"}],"totalClass":[{"t":2,"r":"totalClass"}],"ConfigStrings":[{"t":2,"r":"ConfigStrings"}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"active":"true"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-header flex-container"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 flex-item"},"f":[{"t":7,"e":"div","a":{"class":"left service-icon-container v-normal-right"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":[{"t":2,"x":{"r":["RactiveHelpers","lob"],"s":"_0.getServicePropLob(_1,\"icon\")"}}]}}]}," ",{"t":7,"e":"div","a":{"class":"left service-label"},"f":[{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers"],"s":"_0.getEasyMobiletitle()"}}],"n":50,"x":{"r":["RactiveHelpers","lob","isEasyMobileAccount"],"s":"_0.isSingtelWsSub(_1)&&_2"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["lob"],"s":"_0===\"GLP\""},"f":[{"t":2,"r":"name"}]},{"t":4,"n":50,"x":{"r":["lob"],"s":"!(_0===\"GLP\")"},"f":[" ",{"t":2,"x":{"r":["RactiveHelpers","lob"],"s":"_0.getServicePropLob(_1,\"name\")"}}]}],"x":{"r":["RactiveHelpers","lob","isEasyMobileAccount"],"s":"_0.isSingtelWsSub(_1)&&_2"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":4,"f":["+65 ",{"t":2,"x":{"r":["RactiveHelpers","no"],"s":"_0.mobileNumberFormat(_1)"}}],"n":50,"x":{"r":["lob"],"s":"_0===\"WS\"||_0===\"MOB\"||_0===\"Mobile\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["lob"],"s":"_0===\"GLP\""},"f":[{"t":2,"x":{"r":["RactiveHelpers","lob"],"s":"_0.getServicePropLob(_1,\"userNameProp\")"}},": ",{"t":2,"r":"subscriptionId"}]},{"t":4,"n":50,"x":{"r":["lob","no"],"s":"(!(_0===\"GLP\"))&&(_0&&_1)"},"f":[" ",{"t":2,"x":{"r":["RactiveHelpers","lob"],"s":"_0.getServicePropLob(_1,\"userNameProp\")"}},": ",{"t":2,"r":"no"}]}],"x":{"r":["lob"],"s":"_0===\"WS\"||_0===\"MOB\"||_0===\"Mobile\""}}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-1 flex-item text-right"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-header flex-container"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-11 flex-item"},"f":[{"t":7,"e":"div","a":{"class":"left service-icon-container v-normal-right"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":[{"t":2,"x":{"r":["RactiveHelpers","lob"],"s":"_0.getServicePropLob(_1,\"icon\")"}}]}}]}," ",{"t":7,"e":"div","a":{"class":"left service-label"},"f":[{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers"],"s":"_0.getEasyMobiletitle()"}}],"n":50,"x":{"r":["RactiveHelpers","lob","isEasyMobileAccount"],"s":"_0.isSingtelWsSub(_1)&&_2"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["lob"],"s":"_0===\"GLP\""},"f":[{"t":2,"r":"name"}]},{"t":4,"n":50,"x":{"r":["lob"],"s":"!(_0===\"GLP\")"},"f":[" ",{"t":2,"x":{"r":["RactiveHelpers","lob"],"s":"_0.getServicePropLob(_1,\"name\")"}}]}],"x":{"r":["RactiveHelpers","lob","isEasyMobileAccount"],"s":"_0.isSingtelWsSub(_1)&&_2"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":4,"f":["+65 ",{"t":2,"x":{"r":["RactiveHelpers","no"],"s":"_0.mobileNumberFormat(_1)"}}],"n":50,"x":{"r":["lob"],"s":"_0===\"WS\"||_0===\"MOB\"||_0===\"Mobile\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["lob"],"s":"_0===\"GLP\""},"f":[{"t":2,"x":{"r":["RactiveHelpers","lob"],"s":"_0.getServicePropLob(_1,\"userNameProp\")"}},": ",{"t":2,"r":"subscriptionId"}]},{"t":4,"n":50,"x":{"r":["lob","no"],"s":"(!(_0===\"GLP\"))&&(_0&&_1)"},"f":[" ",{"t":2,"x":{"r":["RactiveHelpers","lob"],"s":"_0.getServicePropLob(_1,\"userNameProp\")"}},": ",{"t":2,"r":"no"}]}],"x":{"r":["lob"],"s":"_0===\"WS\"||_0===\"MOB\"||_0===\"Mobile\""}}]}," ",{"t":7,"e":"div","a":{"class":[{"t":2,"r":"totalClass"}," v-normal-top"]},"f":[{"t":2,"x":{"r":["RactiveHelpers","totalAmountWithoutTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-1 flex-item text-right"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up subscription-charge-details-container"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"charges-confainer"},"f":[" ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-charge-details","a":{"charge":[{"t":2,"r":"."}]}}],"n":50,"x":{"r":["./name","ConfigStrings.nonClickableUsageCharge"],"s":"_0===_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"charge":[{"t":2,"r":"."}],"ontap":"showUsageCharges","class":"charge-details-container","subscription":[{"t":2,"r":"subscription"}]},"f":[{"t":7,"e":"ux-charge-details","a":{"charge":[{"t":2,"r":"."}]}}]}],"x":{"r":["./name","ConfigStrings.nonClickableUsageCharge"],"s":"_0===_1"}}],"n":52,"r":"usageCharges"}]}],"n":50,"r":"usageCharges"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"charges-confainer"},"f":[" ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-charge-details","a":{"charge":[{"t":2,"r":"."}]}}],"n":50,"x":{"r":["./name","ConfigStrings.nonClickableUsageCharge"],"s":"_0===_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"charge":[{"t":2,"r":"."}],"ontap":"showUsageCharges","class":"charge-details-container","subscription":[{"t":2,"r":"subscription"}]},"f":[{"t":7,"e":"ux-charge-details","a":{"charge":[{"t":2,"r":"."}]},"f":[]}]}],"x":{"r":["./name","ConfigStrings.nonClickableUsageCharge"],"s":"_0===_1"}}],"n":52,"r":"usageCharges"}]}],"n":50,"r":"usageCharges"}]}]}]}]}],"n":53,"r":"subscription"}]}]}]}]}]};
this["ux-broadband-block"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-broadband-block"},"f":[{"t":7,"e":"ux-panel","a":{"class":"v-none-padding v-none-left v-none-right"},"f":[{"t":7,"e":"div","a":{"class":"broadband-box broadband-plan"},"f":[{"t":7,"e":"div","a":{"class":"hero-text v-small-bottom"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"planName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"product-title left"},"f":[{"t":2,"r":"subTitle"}]}],"r":"subTitle"}]}," ",{"t":7,"e":"div","a":{"class":"badges-text"},"f":[{"t":2,"r":"planDescription"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"broadband-box v-medium-top v-medium-bottom"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"sectionTitle"}]}," ",{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":2,"r":"."}]}],"r":"sections"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"r":"description"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"broadband-box v-medium-top v-medium-bottom"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"sectionTitle"}]}," ",{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":2,"r":"."}]}],"r":"sections"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"r":"onlinePromo"}," ",{"t":7,"e":"div","a":{"class":"broadband-box v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel"}],"r":"ribbon"}," ",{"t":7,"e":"div","a":{"class":["text-center show-for-small-only ",{"t":4,"f":["v-large-top"],"n":50,"r":"ribbon"},{"t":4,"n":51,"f":["v-small-top"],"r":"ribbon"}]},"f":[{"t":7,"e":"div","a":{"class":"subscript-text v-medium-bottom"},"f":["FROM"]}," ",{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":["Monthly Subscription"]}," ",{"t":7,"e":"ux-button","a":{"onclick":"selectplan","class":"light round select-plan","text":[{"t":2,"r":"buttonText"}]}}]}," ",{"t":7,"e":"div","a":{"class":"text-center show-for-medium-up v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"subscript-text v-medium-bottom"},"f":["FROM"]}," ",{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":["Monthly Subscription"]}," ",{"t":7,"e":"ux-button","a":{"onclick":"selectplan","class":"light round select-plan","text":[{"t":2,"r":"buttonText"}]}}]}]}]}]}]};
this["ux-broadband-catalogue"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-broadband-catalogue"},"f":[{"t":7,"e":"ux-row","a":{"class":"block"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-3 medium-4 small-12"},"f":[{"t":7,"e":"ux-broadband-block","a":{"datamodel":[{"t":3,"r":"."}]}}]}],"r":"broadbandPlans"}]}]}]};
this["ux-broadband-priceplan-block"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-broadband-priceplan-block"},"f":[{"t":7,"e":"ux-panel","a":{"class":"v-none-padding v-none-left v-none-right"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ribbon-box"},"f":[{"t":7,"e":"div","a":{"class":"ribbon-block p-small-top"},"f":[{"t":7,"e":"ux-icon","a":{"type":"gift-icon","class":"v-small-right","size":"s"}},{"t":2,"r":"ribbon"}]}]}],"n":50,"r":"ribbon"}," ",{"t":7,"e":"ux-image","a":{"class":"handset-img","src":[{"t":2,"r":"smallImage"}]}}," ",{"t":7,"e":"div","a":{"class":"broadband-header p-normal-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"6","class":"header-txt v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"planShortDescription"}]}," ",{"t":7,"e":"ux-header","a":{"level":"2","class":"bb-header v-small-top show-for-medium-up"},"f":[{"t":2,"r":"planName"}]}," ",{"t":7,"e":"div","a":{"class":"subsection-header v-small-top show-for-small-only"},"f":[{"t":2,"r":"planName"}]}]}," ",{"t":7,"e":"div","a":{"class":"product-descriptions"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"onl-exc-panel v-medium-top v-medium-bottom v-normal-left v-normal-right v-medium-left-mobile v-medium-right-mobile p-medium-left-mobile p-normal-left p-normal-top p-normal-bottom"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"fine-print-text upper-case v-medium-bottom"},"f":[{"t":2,"r":"sectionTitle"}]}," ",{"t":7,"e":"ul","a":{"class":"v-none-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":2,"r":"."}]}],"r":"sections"}]}]}]}],"n":50,"x":{"r":["sectionTitle","sections"],"s":"!!_0&&!!_1"}}],"r":"onlinePromo"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"bbdesc-panel v-medium-top v-normal-bottom v-medium-left-mobile v-medium-right-mobile p-none-left-mobile p-none-right-mobile"},"f":[{"t":7,"e":"div","a":{"class":"fine-print-text v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"sectionTitle"}]}," ",{"t":7,"e":"ul","a":{"class":"v-none-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":3,"x":{"r":["updateHrefToVal","."],"s":"_0(_1)"}}],"n":50,"x":{"r":["isAnchor","idx","sections"],"s":"_0(_2[_1])"}},{"t":4,"n":51,"f":[{"t":3,"r":"."}],"x":{"r":["isAnchor","idx","sections"],"s":"_0(_2[_1])"}}]}],"i":"idx","r":"sections"}]}]}],"r":"description"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up broadband-box v-medium-top"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"usual-price"},"f":["U.P. $",{"t":2,"r":"usualPrice"}]}],"n":50,"x":{"r":["usualPrice","displayPrice"],"s":"_0&&parseInt(_0)>parseInt(_1)"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","f":[" "]}],"x":{"r":["usualPrice","displayPrice"],"s":"_0&&parseInt(_0)>parseInt(_1)"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"div","a":{"class":"sub-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","displayPrice"],"s":"_0.convertUnits(_1,\"$\")"}},{"t":7,"e":"span","f":["/mth"]}]}," ",{"t":7,"e":"div","a":{"class":"monthly-lbl"},"f":[{"t":2,"r":"contractMonth"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 select-plan-col p-none-right"},"f":[{"t":7,"e":"ux-button","a":{"onclick":"selectplan","class":"light round select-plan right","text":[{"t":2,"r":"buttonText"}]}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only broadband-box v-medium-top-mobile v-medium-left-mobile v-medium-right-mobile p-none-left-mobile p-none-right-mobile"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"usual-price"},"f":["U.P. $",{"t":2,"r":"usualPrice"}]}],"n":50,"x":{"r":["usualPrice","displayPrice"],"s":"_0&&parseInt(_0)>parseInt(_1)"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","f":[" "]}],"x":{"r":["usualPrice","displayPrice"],"s":"_0&&parseInt(_0)>parseInt(_1)"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"div","a":{"class":"sub-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","displayPrice"],"s":"_0.convertUnits(_1,\"$\")"}},{"t":7,"e":"span","f":["/mth"]}]}," ",{"t":7,"e":"div","a":{"class":"monthly-lbl"},"f":[{"t":2,"r":"contractMonth"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 select-plan-col p-none-right"},"f":[{"t":7,"e":"ux-button","a":{"onclick":"selectplan","class":"light round select-plan right","text":[{"t":2,"r":"buttonText"}]}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"promotional-details-sec p-normal-bottom v-medium-top-mobile"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"promotional-details v-normal-left v-normal-right p-medium-left p-medium-right p-medium-top p-medium-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"premium-desc"},"f":[{"t":7,"e":"ux-col","a":{"class":"premium-desc-details body-copy-text p-small-left v-none-left"},"f":[{"t":3,"r":"premiumUpsellDesc"}]}]}]}],"n":50,"r":"premiumUpsellDesc"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"plan-details text-center p-large-top"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"planDetailLink"}],"target":"_blank"},"f":[{"t":3,"r":"planDetailText"}]}]}],"n":50,"x":{"r":["planDetailText","planDetailLink"],"s":"_0&&_1"}}]}]}]}]};
this["ux-broadband-priceplan-list"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-broadband-priceplan-list"},"f":[{"t":7,"e":"ux-tabarea","a":{"broadbandPlans":[{"t":2,"r":"broadbandPlans"}],"tabInfoModels":[{"t":2,"r":"tabInfoModels"}],"eachPlansize":[{"t":2,"r":"eachPlansize"}],"showConfigurePanel":[{"t":2,"r":"showConfigurePanel"}],"isSticky":[{"t":2,"r":"isSticky"}],"enlarge":[{"t":2,"r":"enlarge"}],"offsetTop":[{"t":2,"r":"offsetTop"}]},"f":[{"t":7,"e":"ux-tablinks","a":{"class":"hideSection","items":[{"t":2,"r":"tabInfoModels"}],"eachPlansize":[{"t":2,"r":"eachPlansize"}]},"f":[{"t":7,"e":"div","a":{"class":"swiper-container instance-tab"},"f":[{"t":7,"e":"div","a":{"class":"swiper-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"swiper-slide swiper-slide-tab"},"f":[{"t":7,"e":"ux-tablink","a":{"active":[{"t":2,"r":"tabActive"}],"id":["panel",{"t":2,"r":"i"}]},"f":[{"t":2,"r":"tabTitle"}," (",{"t":2,"rx":{"r":"eachPlansize","m":[{"t":30,"n":"i"}]}},")"]}]}],"n":52,"i":"i","r":"items"}]}]}]}," ",{"t":7,"e":"ux-tabpanes","a":{"broadbandPlans":[{"t":2,"r":"broadbandPlans"}],"enlarge":[{"t":2,"r":"enlarge"}],"tabInfoModels":[{"t":2,"r":"tabInfoModels"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-tabpane","f":[{"t":7,"e":"ux-row","a":{"class":"hideSection"},"f":[{"t":7,"e":"div","a":{"class":["v-medium-left center tab-desc-text ",{"t":4,"f":["enlarge"],"n":50,"r":"enlarge"}]},"f":[{"t":3,"r":"tabDesc"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"block v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":["swiper-container mobile-view instance-",{"t":2,"r":"i"}]},"f":[{"t":7,"e":"div","a":{"class":"swiper-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"swiper-slide"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-broadband-priceplan-block","a":{"datamodel":[{"t":3,"r":"."}]}}]}]}],"r":"broadbandPlans"}]}," ",{"t":7,"e":"div","a":{"class":"swiper-pagination"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-row","a":{"class":"block v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 medium-6 p-medium-bottom"},"f":[{"t":7,"e":"ux-broadband-priceplan-block","a":{"datamodel":[{"t":3,"r":"."}]}}]}],"r":"broadbandPlans"}]}]}]}],"n":50,"x":{"r":["tabTitle"],"s":"_0===\"ALL\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-tabpane","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":["v-medium-left center tab-desc-text ",{"t":4,"f":["enlarge"],"n":50,"r":"enlarge"}]},"f":[{"t":3,"r":"tabDesc"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"block v-large-top"},"f":[{"t":7,"e":"div","a":{"class":["swiper-container instance-",{"t":2,"r":"i"}]},"f":[{"t":7,"e":"div","a":{"class":"swiper-wrapper"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"swiper-slide"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-broadband-priceplan-block","a":{"datamodel":[{"t":3,"r":"."}]}}]}]}],"n":50,"x":{"r":["./category","tabTitle"],"s":"_0===_1"}}],"r":"broadbandPlans"}]}," ",{"t":7,"e":"div","a":{"class":["swiper-button-next btn-next-",{"t":2,"r":"i"}]},"f":[{"t":7,"e":"ux-icon","a":{"type":"carousel-next","size":"l"}}]}," ",{"t":7,"e":"div","a":{"class":["swiper-button-prev btn-prev-",{"t":2,"r":"i"}]},"f":[{"t":7,"e":"ux-icon","a":{"type":"carousel-prev","size":"l"}}]}," ",{"t":7,"e":"div","a":{"class":"swiper-pagination"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-row","a":{"class":"block v-large-top"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 medium-6"},"f":[{"t":7,"e":"ux-broadband-priceplan-block","a":{"datamodel":[{"t":3,"r":"."}]}}]}],"n":50,"x":{"r":["./category","tabTitle"],"s":"_0===_1"}}],"r":"broadbandPlans"}]}]}]}],"x":{"r":["tabTitle"],"s":"_0===\"ALL\""}}],"n":52,"i":"i","r":"tabInfoModels"}]}]}]}]};
this["ux-broadband-sub"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-broadband-sub"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":[{"t":2,"r":"plan.catalogItemName"}]}," "]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"r":"productDetails.subscriberCategoryX8"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":["Plan Specification"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"r":"plan.catalogItemDescription"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header v-medium-right"},"f":["Fibre Broadband Address"]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"relocateService","product":[{"t":2,"r":"."}],"href":[{"t":2,"r":"initData.subInitData.relocateServiceLink"}]},"f":[{"t":2,"r":"initData.subInitData.relocateServiceLinkText"}]}]}," ",{"t":7,"e":"ux-col","f":[" ",{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"address"}],"addressType":[{"t":2,"x":{"r":["address.addressType"],"s":"_0||\"omsProductServiceLevel\""}}]}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"initData.subInitData.recontractOptionsText"}]}," ",{"t":7,"e":"span","a":{"class":"hide"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"showContractDetails"},"f":[{"t":2,"r":"initData.subInitData.recontractOptionsLinkText"}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[" ",{"t":2,"x":{"r":["productFacade.recontractData.recon3MonthsBefore.reonDate"],"s":"_0.format(\"MMM YYYY\")"}}]}," "]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ul","a":{"class":"icon-ul"},"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-icon","a":{"type":"alert"}}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"div","a":{"class":"notice-text"},"f":[{"t":2,"r":"initData.chargeableEmail.alertMsg"}]}]}]}]}],"n":50,"r":"productFacade.freeEmailIdFlag"}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":"light v-large-top round expand-for-mobile","onclick":"recontractMobile","permission":[{"t":2,"r":"permission"}],"isOrderPending":[{"t":2,"r":"pendingOrders.isChangePlanPending"}],"text":[{"t":2,"r":"ConfigStrings.recontractLabels.recontractBtn"}]},"f":[]}]}],"n":50,"r":"productFacade.recontractData.isEligibleForRecon"}]}],"n":50,"r":"productFacade.recontractData.display"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"voucher-panel clearfix"},"f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header v-small-bottom"},"f":["Handset Voucher"]}," ",{"t":7,"e":"div","f":["Nominate up to 4 prepaid lines and enjoy free calls when your prepaid balance reaches $0 with Prepaid’s hi!Family Bundle."]}]}]}],"n":50,"x":{"r":["voucherDetails.voucherValue"],"s":"_0&&_0>0"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-offset-2 medium-4"},"f":[{"t":7,"e":"ux-sub-addon","a":{"subscription":[{"t":2,"r":"."}],"account":[{"t":2,"r":"account"}],"product":[{"t":2,"r":"product"}],"productFacade":[{"t":2,"r":"productFacade"}],"initData":[{"t":2,"r":"initData.addonInitData"}],"permission":[{"t":2,"r":"permission"}]}}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"widht":"700","class":"light-theme manage-service-modal","modalId":"manageServiceModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"left section-header"},"f":[{"t":2,"r":"initData.manageService.header"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":2,"r":"initData.manageService.headerMsg"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"highlight"},"f":[{"t":7,"e":"ux-anchor","a":{"url":[{"t":4,"f":[{"t":2,"r":"initData.changePlanLink"}],"n":50,"x":{"r":["permission.ipa","permission.blacklisted"],"s":"!(_0||_1)"}}],"ontap":"changePlan","product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"font"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header"},"f":[{"t":2,"r":"initData.changePlanText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":2,"r":"initData.manageService.changePlanMsg"}]}]}],"n":50,"x":{"r":["planGroupName"],"s":"_0===\"COMBO\"||_0===\"EASY\""}}," ",{"t":4,"f":[" ",{"t":7,"e":"ux-row","a":{"class":"highlight hover-container"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"cancelPendingSuspendRequest","permission":[{"t":2,"r":"permission"}],"product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header v-medium-bottom"},"f":[{"t":2,"r":"initData.manageService.cancelTerminationServiceText"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"body-text"},"f":[{"t":2,"r":"initData.manageService.cancelTerminationServiceMsg"}]}]}]}],"n":50,"r":"pendingOrders.isFutureSuspendRequest"},{"t":4,"n":51,"f":[" ",{"t":7,"e":"ux-row","a":{"class":"highlight"},"f":[{"t":7,"e":"ux-anchor","a":{"url":[{"t":4,"f":[{"t":2,"r":"initData.manageService.suspensionOfServiceLink"}],"n":50,"x":{"r":["permission.ipa","permission.blacklisted"],"s":"!(_0||_1)"}}],"ontap":"suspendService","product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"font"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header"},"f":[{"t":2,"r":"initData.manageService.suspensionOfServiceText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":2,"r":"initData.manageService.suspensionofServiceMsg"}]}]}],"r":"pendingOrders.isFutureSuspendRequest"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"highlight"},"f":[{"t":7,"e":"ux-anchor","a":{"url":[{"t":4,"f":[{"t":2,"r":"initData.manageService.resumeofServiceLink"}],"n":50,"x":{"r":["permission.ipa","permission.blacklisted"],"s":"!(_0||_1)"}}],"ontap":"resumeService","product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"font"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header"},"f":[{"t":2,"r":"initData.manageService.resumeofServiceText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":2,"r":"initData.manageService.resumeofServiceMsg"}]}]}],"n":50,"x":{"r":["subscrStatus"],"s":"_0===83"}}," ",{"t":7,"e":"ux-row","a":{"class":"highlight"},"f":[{"t":7,"e":"ux-anchor","a":{"product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}],"ontap":"changeMobileNumber","url":[{"t":4,"f":[{"t":2,"r":"initData.manageService.changeMobileNoLink"}],"n":50,"x":{"r":["permission.ipa","permission.blacklisted"],"s":"!(_0||_1)"}}]},"f":[{"t":7,"e":"ux-row","a":{"class":"font"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header"},"f":[{"t":2,"r":"initData.manageService.changeMobileNoText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":2,"r":"initData.manageService.changeMobileNoMsg"}]}]}]}],"n":53,"r":"product"},{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"recontractDetailsModal"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":3,"r":"initData.subInitData.contractEndDateHeaderText"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"r":"ConfigStrings.recontractLabels.broadbandAfterDateMsg"}," ",{"t":2,"x":{"r":["productFacade.recontractData.recon3MonthsBefore.reonDate"],"s":"_0.format(\"D MMMM YYYY\")"}},"."]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"r":"ConfigStrings.recontractLabels.broadbandRecontractDateMsg"}," ",{"t":2,"x":{"r":["productFacade.recontractData.deviceContractEndDate"],"s":"_0.format(\"D MMMM YYYY\")"}},"."]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":"v-large-top round expand-for-mobile","onclick":"recontractMobile","permission":[{"t":2,"r":"permission"}],"text":[{"t":2,"r":"ConfigStrings.recontractLabels.recontractBtn"}]},"f":[]}]}]}],"n":50,"x":{"r":["moment","productFacade.recontractData.recon3MonthsBefore.reonDateFirstDay"],"s":"_0()>_1"}}]}]};
this["ux-button-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-button-singtel text-center"},"o":{"n":"loadMask","a":[{"class":"full-screen"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"round margin-zero","href":[{"t":2,"r":"href"}]},"f":[{"t":2,"r":"label"}]}],"n":50,"x":{"r":["type"],"s":"_0===\"link\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["event"],"s":"_0===\"redirect\""},"f":[{"t":7,"e":"ux-anchor","a":{"class":["round margin-zero small-only-expand button ",{"t":2,"r":"type"}],"ontap":["btnRedirect:",{"t":2,"r":"href"}]},"f":[{"t":2,"r":"label"}]}]},{"t":4,"n":50,"x":{"r":["event","type"],"s":"(!(_0===\"redirect\"))&&(_1===\"Calender\")"},"f":[" ",{"t":7,"e":"ux-anchor","a":{"class":"round margin-zero","ontap":"addCalender"},"f":[{"t":2,"r":"label"}]}," ",{"t":7,"e":"form","a":{"id":"ics-file-download-form","method":"POST","action":"/bin/services/singtel/ics-file-download"},"f":[{"t":7,"e":"input","a":{"type":"hidden","name":"calStr","value":[{"t":2,"r":"calStr"}]}}]}]},{"t":4,"n":50,"x":{"r":["event","type"],"s":"(!(_0===\"redirect\"))&&(!(_1===\"Calender\"))"},"f":[" ",{"t":7,"e":"ux-button","a":{"class":["round margin-zero small-only-expand ",{"t":2,"r":"type"}],"onclick":[{"t":2,"r":"event"}],"text":[{"t":2,"r":"label"}]}}]}],"x":{"r":["type"],"s":"_0===\"link\""}}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme ux-button-singtel customisedLoader","modalId":"loader-Modal"},"f":[{"t":7,"e":"ux-row","a":{"class":"text-center v-large"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-donut-loader","a":{"graph_data":[{"t":2,"r":"graphData"}],"value":[{"t":2,"r":"percentage"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"text-center subsection-header v-medium-bottom "},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"loaderHeader"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"text-center"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"loaderMsg"}]}]}]}]};
this["ux-button-switch"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["switch round ux-button-switch ",{"t":2,"r":"class"}," ",{"t":4,"f":["disabled"],"n":50,"r":"disabled"}]},"m":[{"t":4,"f":["id=\"",{"t":2,"r":"id"},"\""],"n":50,"r":"id"}],"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"r":"switchButtonId"}],"type":"checkbox","checked":[{"t":2,"r":"switchButtonValue"}],"disabled":[{"t":2,"r":"disabled"}]},"v":{"change":"onButtonSwitched"}}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"switchButtonId"}]},"f":[{"t":7,"e":"span","a":{"class":"switch-on"},"f":[{"t":2,"r":"textEnabled"}]}," ",{"t":7,"e":"span","a":{"class":"switch-off"},"f":[{"t":2,"r":"textDisabled"}]}]}]}]};
this["ux-calendar"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-calendar ",{"t":2,"r":"style"}]},"f":[{"t":7,"e":"ux-input-box","a":{"icon":"calendar","id":[{"t":2,"r":"calendar_id"}],"valid":[{"t":2,"r":"valid"}],"value":[{"t":2,"r":"selected_date"}],"validity":[{"t":2,"r":"validity"}],"onblurEvent":[{"t":2,"r":"onblurEvent"}],"readonly":[{"t":2,"r":"readonly"}]},"f":[]}]}]};
this["ux-capacity-variant"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["ux-capacity-variant ",{"t":2,"x":{"r":["getCapacityState"],"s":"_0()"}}," ",{"t":2,"x":{"r":["getSelectedCapacity","size"],"s":"_0(_1)"}}," v-normal-bottom v-normal-right ",{"t":4,"f":["disabled"],"n":50,"r":"isDisabled"}," ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["phoneStatus"],"s":"_0===\"Not available\"||_0===\"Not Available\"||_0===\"n/a\""}}]},"v":{"tap":{"n":"selectCapacity","d":[{"t":2,"r":"size"}]}},"f":[{"t":7,"e":"div","a":{"class":["show-for-medium-up section-header ",{"t":4,"f":["p-small-top p-small-bottom"],"n":50,"r":"isIppPlan"}," text-center capacity"]},"f":[{"t":2,"r":"size"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only section-header text-center capacity"},"f":[{"t":2,"r":"size"}]}," ",{"t":7,"e":"div","a":{"class":["text-center from-price minheight-fromprice ",{"t":4,"f":["ippPrice"],"n":50,"r":"isIppPlan"}]},"f":[{"t":2,"r":"fromPriceFormated"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"no-stock-line"}}," ",{"t":7,"e":"div","a":{"class":"no-stock-text v-normal-bottom body-light text-center"},"f":[{"t":2,"r":"phoneStatus"}]}],"n":50,"x":{"r":["phoneStatus"],"s":"_0===\"Not available\"||_0===\"Not Available\"||_0===\"n/a\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"pre-order-label-spacer"}}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom pre-order-text text-center"},"f":[{"t":2,"r":"ConfigStrings.preOrderAvailabilityMsg"}]}],"n":50,"x":{"r":["selectedDeviceVariant","selectedDeviceVariant.isBackOrder","selectedDeviceVariant.size","size"],"s":"_0&&_1&&_2===_3"}}]}],"n":50,"x":{"r":["phoneStatus"],"s":"_0!==\"n/a\""}}]};
this["ux-card-icon"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-card-icon pointer ",{"t":4,"f":["selected"],"n":50,"r":"selected"}]},"f":[{"t":7,"e":"div","a":{"class":"flex-container text-center flex-container-center full-height"},"v":{"click":"card-click"},"f":[{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":[{"t":2,"r":"iconClass"}]}}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"text"}]}]}]}]}]};
this["ux-care-billing-address"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-care-billing-address ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"large-row column-control-mobile"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","a":{"class":"margin-zero"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-top v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"initData.billingDetails.mainTitle"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":2,"r":"initData.billingDetails.description"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"select-account-wrapper"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 large-4"},"f":[{"t":7,"e":"input","a":{"id":"account-0","checked":0,"type":"radio","name":"select-billing-account","value":[{"t":2,"r":"billingAccountNumber"}]}}," ",{"t":7,"e":"label","a":{"for":"account-0"},"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":3,"r":"avatar"}]}}," ",{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"r":"nickName"}]}," ",{"t":7,"e":"p","a":{"class":"body-copy-text"},"f":[{"t":2,"r":"initData.accountNumberLabel"},": ",{"t":2,"r":"faId"}]}," ",{"t":7,"e":"div","a":{"class":"subsection-header v-medium-top"},"f":[{"t":2,"r":"initData.billingAddressLabel"}]}," ",{"t":7,"e":"p","a":{"class":"body-copy-text"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}],"n":53,"r":"physicalAddress"}]}]}]}],"n":53,"r":"selectedAccount"}],"n":50,"r":"selectedAccount"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 large-4"},"f":[{"t":7,"e":"input","a":{"id":["account-",{"t":2,"r":"i"}],"type":"radio","name":"select-billing-account","value":[{"t":2,"r":"billingAccountNumber"}]},"v":{"change":{"n":"selectAccount","d":[{"t":2,"r":"billingAccountNumber"}]}}}," ",{"t":7,"e":"label","a":{"for":["account-",{"t":2,"r":"i"}]},"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":3,"r":"avatar"}]}}," ",{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"r":"nickName"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"initData.accountNumberLabel"},": ",{"t":2,"r":"faId"}]}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.billingAddressLabel"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}],"n":53,"r":"physicalAddress"}]}]}],"n":52,"i":"i","r":"accounts"}],"n":50,"x":{"r":["orderFullfilment.billingDetails.billPayer"],"s":"_0===\"1\"||_0===1"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 large-4"},"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"id":"contact-address","type":"radio","name":"select-billing-account","value":[{"t":2,"r":"postcode"}]},"v":{"change":{"n":"selectAccount","a":[-1]}}}," ",{"t":7,"e":"label","a":{"for":"contact-address"},"f":[{"t":7,"e":"ux-image","a":{"class":"contact-image-holder"},"m":[{"t":4,"f":["img=\"",{"t":3,"r":"contactAvatar"},"\""],"n":50,"r":"contactAvatar"}]}," ",{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"initData.contactAddressLabel"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"initData.asNewBillingAddressLabel"}]}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.contactAddressLabel"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}]}],"n":53,"r":"contactAddress"}]}],"n":50,"x":{"r":["contactAddress","contactAddress.postcode"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 large-4"},"f":[{"t":7,"e":"input","a":{"id":"installation-contact-address","type":"radio","name":"select-billing-account","value":[{"t":2,"r":"installationAddress.postcode"}]},"v":{"change":{"n":"selectAccount","a":[-2]}}}," ",{"t":7,"e":"label","a":{"for":"installation-contact-address"},"f":[{"t":7,"e":"ux-image","a":{"class":"contact-image-holder"},"m":[{"t":4,"f":["img=\"",{"t":3,"r":"contactAvatar"},"\""],"n":50,"r":"contactAvatar"}]}," ",{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"initData.installationAddressLabel"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"initData.asNewBillingAddressLabel"}]}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.installationAddressLabel"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}],"n":53,"r":"installationAddress"}]}]}],"n":50,"r":"installationAddress.postcode"}],"n":53,"r":"orderFullfilment.billingDetails"}],"r":"selectedAccount"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"new-billing-address-form-wrapper"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header v-normal-bottom v-medium-top"},"f":[{"t":2,"r":"initData.newBillingAddressLabel"}]}," ",{"t":7,"e":"ux-address-form","a":{"class":"address-form-wrapper section-details medium-6","address":[{"t":2,"r":"addressRetrieve.address"}],"disableConfirmButton":[{"t":2,"r":"disableBillingConfirmButton"}],"errorMessage":[{"t":2,"r":"errorMessage"}],"onUpdate":"createBilling","relaxValidation":"true","hideUpdateButton":"true"}}]}]}],"n":51,"r":"selectedAccount"}],"n":51,"x":{"r":["deviceIdAndPlanId.reContractFlag","deviceIdAndPlanId.mobileReContractFlag","selectedAccount"],"s":"_0||_1||_2"}}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"div","a":{"class":"divider show-for-small-only"}}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"paper-bill-option medium-12"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"description"}]}," ",{"t":7,"e":"ux-checkbox","a":{"checkboxid":"paper-bill","checked":[{"t":2,"r":"paperBill"}],"labelvalue":[{"t":2,"r":"labelText"}]}}]}],"n":53,"r":"initData.billingDetails.singtelEBill"}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","a":{"class":"paper-bill-option-button v-medium-top v-medium-bottom"},"f":[{"t":7,"e":"ux-button","a":{"class":["round center show-for-small-only v-normal-bottom ",{"t":4,"f":["disabled"],"n":51,"r":"selectedAddress"}],"text":"Next","role":"button","arialabel":"Next","onclick":"eBillNext"}}," ",{"t":7,"e":"ux-button","a":{"class":["round right show-for-medium-up ",{"t":4,"f":["disabled"],"n":51,"r":"selectedAddress"}],"text":"Next","role":"button","arialabel":"Next","onclick":"eBillNext"}}]}]}]}],"n":50,"r":"isOpened"}]}]}]}]}]};
this["ux-carousel-video"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-carousel-video ",{"t":2,"r":"theme"}]},"v":{"swipeleft":"moveLeft","swiperight":"moveRight"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":3,"r":"header"}]}," ",{"t":7,"e":"ux-anchor","a":{"target":[{"t":4,"f":["_blank"],"n":50,"r":"openNewTab"},{"t":4,"n":51,"f":["_self"],"r":"openNewTab"}],"href":[{"t":2,"r":"link"}]},"f":[{"t":2,"r":"linkText"}]}," ",{"t":7,"e":"ul","a":{"class":"carousel-item-list"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":["carousel-item ",{"t":2,"r":"plan"}," ",{"t":2,"r":"cover"}," ",{"t":2,"r":"transition"}," ",{"t":2,"r":"player"}," ",{"t":2,"r":"level"}," ",{"t":4,"f":["is-middle"],"n":50,"r":"isMiddle"}],"style":[{"t":2,"r":"style"}]},"v":{"click":{"n":"selectItem","d":[{"t":2,"r":"num"}]}},"f":[{"t":7,"e":"span","a":{"class":"carousel-item-cover player"}}," ",{"t":7,"e":"span","a":{"class":"carousel-item-cover blur","style":["background-image:url('http://img.youtube.com/vi/",{"t":2,"r":"videoRef"},"/maxresdefault.jpg')"]}}]}],"n":52,"i":"num","r":"carousel.items"}],"n":50,"r":"isDataModel"}]}," ",{"t":7,"e":"ux-modal","a":{"displayState":[{"t":2,"r":"currentItem.displayState"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-iframe","a":{"src":[{"t":2,"r":"currentItem.videoURL"}],"width":"100%","heightInd":"true","height":"450px"}}]}]}]}]};
this["ux-carousel"] = {"v":3,"t":[" ",{"t":7,"e":"div","a":{"class":["ux-carousel ",{"t":2,"r":"class"}," ",{"t":2,"x":{"r":["hideControls"],"s":"_0?\"without-controls\":\"\""}}," guid-",{"t":2,"r":"guid"}]},"f":[" ",{"t":7,"e":"div","a":{"class":["swiper-container ",{"t":2,"r":"containerId"}]},"v":{"mouseover":"stopswiper","mouseout":"startswiper"},"f":[{"t":4,"f":[{"t":8,"r":"controlsDisplay"}],"n":50,"x":{"r":["controlsAlignment"],"s":"_0===\"top\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"swiper-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["swiper-slide swiper-slide-",{"t":2,"r":"i"}]},"f":[{"t":4,"f":[{"t":3,"r":"content"}],"n":50,"r":"content"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"content"}]}],"i":"i","r":"items"}]}],"n":50,"x":{"r":["items.length"],"s":"_0>0"}},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"x":{"r":["items.length"],"s":"_0>0"}}," ",{"t":4,"f":[{"t":8,"r":"controlsDisplay"}],"n":50,"x":{"r":["controlsAlignment"],"s":"_0===\"bottom\""}}]}]}],"p":{"controls":[{"t":4,"f":[" ",{"t":7,"e":"div","a":{"class":["swiper-button-prev ",{"t":2,"r":"cssPrevButton"}]}}],"n":50,"r":"navigation"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"swiper-pagination"}}],"n":50,"r":"showPagination"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["swiper-button-next ",{"t":2,"r":"cssNextButton"}]}}],"n":50,"r":"navigation"}],"controlsDisplay":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["controls-grouped ",{"t":2,"x":{"r":["hideControls"],"s":"_0?\"hidden\":\"\""}}," alignment-",{"t":2,"r":"controlsAlignment"}]},"f":[{"t":8,"r":"controls"}]}],"n":50,"r":"groupedControls"},{"t":4,"n":51,"f":[{"t":8,"r":"controls"}],"r":"groupedControls"}]}};
this["ux-catalog-filter-facets"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-catalog-filter-facets"},"f":[{"t":7,"e":"ux-row","a":{"class":"column-control-mobile"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","a":{"class":"margin-zero panel30"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"filter-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"main-header v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"initData.ippDetails.ippPhonesHeader"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"contract-filter medium-12"},"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom show-for-medium-up"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"p-large-right"},"f":[{"t":7,"e":"ux-radio-button","a":{"use_content":"true","onclick":"radioFilterSelected","value":[{"t":2,"r":"value"}],"btn_id":[{"t":2,"x":{"r":["i"],"s":"_0+1"}}],"selected":[{"t":2,"r":"selectedFilter"}],"name":"phone_filter"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"p","f":[{"t":2,"r":"text"}]}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"p-medium-left new-liner section-description"},"f":[{"t":2,"r":"ribbon"}]}],"n":50,"r":"ribbon"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"p-small-top v-small-left ","ontap":"showTooltip"},"f":[{"t":7,"e":"span","a":{"class":"icon-btn show-tooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}],"n":50,"x":{"r":["isToolTipActive","initData.ippDetails.ippShowModal"],"s":"_0&&_1"}}]}]}]}],"i":"i","r":"contractFilter"}]}," ",{"t":7,"e":"div","a":{"class":"contract-filter small-12 text-left v-large-bottom show-for-small-only"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-radio-button","a":{"use_content":"true","onclick":"radioFilterSelected","value":[{"t":2,"r":"value"}],"btn_id":[{"t":2,"x":{"r":["i"],"s":"_0+1"}}],"selected":[{"t":2,"r":"selectedFilter"}],"name":"phone_filter"},"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":""},"f":[{"t":2,"r":"text"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"new-liner section-description"},"f":[{"t":2,"r":"ribbon"}]}],"n":50,"r":"ribbon"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"showTooltip"},"f":[{"t":7,"e":"span","a":{"class":"icon-btn show-tooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}],"n":50,"x":{"r":["isToolTipActive","initData.ippDetails.ippShowModal"],"s":"_0&&_1"}}]}]}]}]}],"i":"i","r":"contractFilter"}]}]}]}],"n":50,"r":"isNewPP"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"filter-header"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"main-header v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"initData.headerText"}]}," ",{"t":7,"e":"div","a":{"class":"section-description v-medium-bottom show-for-small-only"},"f":[{"t":3,"r":"initData.descriptionText"}]}," ",{"t":7,"e":"div","a":{"class":"section-description v-large-bottom show-for-medium-up"},"f":[{"t":3,"r":"initData.descriptionText"}]}]}]}],"r":"isNewPP"}," ",{"t":7,"e":"ux-row","a":{"class":"left-selections"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 v-small-bottom"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header show-result"},"f":[{"t":2,"r":"initData.filterCriteriaText"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-3 small-offset-6 left"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header sort-by "},"f":[{"t":2,"r":"initData.sortCriteriaText"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"left-selections"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","id":"select-brand","class":"medium left","selected_value":[{"t":2,"r":"brand"}],"options":[{"t":2,"r":"initData.ippBrands"}],"onChangeEvent":"changedBrands"}}]}],"n":50,"x":{"r":["isNewPP","isIPPPlan"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","id":"select-brand","class":"medium left","selected_value":[{"t":2,"r":"brand"}],"options":[{"t":2,"r":"initData.brands"}],"onChangeEvent":"changedBrands"}}]}],"x":{"r":["isNewPP","isIPPPlan"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 spacing-for-mobile"},"f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","id":"select-deal","class":"medium left","selected_value":[{"t":2,"r":"deal"}],"options":[{"t":2,"r":"initData.ippDeals"}],"onChangeEvent":"changedDeals"}}]}],"n":50,"x":{"r":["isNewPP","isIPPPlan"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 spacing-for-mobile"},"f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","id":"select-deal","class":"medium left","selected_value":[{"t":2,"r":"deal"}],"options":[{"t":2,"r":"initData.deals"}],"onChangeEvent":"changedDeals"}}]}],"x":{"r":["isNewPP","isIPPPlan"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 spacing-for-mobile"},"f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","id":"select-ippPlan","class":"medium left","selected_value":[{"t":2,"r":"ippPlan"}],"options":[{"t":2,"r":"initData.ippPlans"}],"onChangeEvent":"changedPlans"},"f":[]}]}],"n":50,"x":{"r":["isNewPP","isIPPPlan"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 spacing-for-mobile"},"f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","id":"select-combo","class":"medium left","selected_value":[{"t":2,"r":"comboPlan"}],"options":[{"t":2,"r":"initData.comboPlans"}],"onChangeEvent":"changedPlans"}}]}],"x":{"r":["isNewPP","isIPPPlan"],"s":"_0&&_1"}}],"n":50,"x":{"r":["deviceIdAndPlanId.planId"],"s":"_0===null||typeof _0===\"undefined\""}}," ",{"t":7,"e":"ux-col","a":{"class":["medium-3 ",{"t":4,"f":["medium-offset-3"],"n":51,"x":{"r":["initData.comboPlans.length","deviceIdAndPlanId.planId"],"s":"_0>0&&(_1===null||typeof _1===\"undefined\")"}}]},"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only  spacing-for-mobile"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header sort-by "},"f":[{"t":2,"r":"initData.sortCriteriaText"}]}]}," ",{"t":7,"e":"ux-select","a":{"id":"select-sort","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"sortBy"}],"options":[{"t":2,"r":"initData.sortByList"}],"onChangeEvent":"changedSortBy"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"compare-link show-for-medium-up"},"f":[{"t":7,"e":"ux-anchor","a":{"href":"#","ontap":"showCompareWindow","class":"showCompareWindow"},"f":[{"t":2,"r":"initData.comparePhones"}]}]}]}]}]}]}]}]};
this["ux-catalog-rrp-filter"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-catalog-filter-facets"},"f":[{"t":7,"e":"ux-row","a":{"class":"column-control-mobile"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","a":{"class":"margin-zero panel30"},"f":[{"t":7,"e":"ux-row","a":{"class":"filter-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"p-none-right medium-7"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"main-header v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"initData.headerText"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-5 v-medium-top v-normal-top-mobile v-normal-bottom-mobile p-small-top"},"f":[{"t":7,"e":"ux-catalog-splitter","a":{"defaultTab":[{"t":2,"r":"initData.defaultTab"}],"catalogTabList":[{"t":2,"r":"initData.catalogTabList"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"section-description v-medium-bottom show-for-small-only"},"f":[{"t":3,"r":"initData.descriptionText"}]}," ",{"t":7,"e":"div","a":{"class":"section-description v-large-bottom show-for-medium-up"},"f":[{"t":3,"r":"initData.descriptionText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 v-small-bottom"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header show-result"},"f":[{"t":2,"r":"initData.filterCriteriaText"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 v-small-bottom"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header show-result"},"f":["Brands"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3 left"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.promoCriteriaText"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3 left"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header sort-by "},"f":[{"t":2,"r":"initData.sortCriteriaText"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","id":"select-deal","class":"medium left","selected_value":[{"t":2,"r":"dealVal"}],"options":[{"t":2,"r":"initData.deals"}],"onChangeEvent":"changedDeals"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only  spacing-for-mobile"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":["Brands"]}]}," ",{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","id":"select-brand","class":"medium left","selected_value":[{"t":2,"r":"brand"}],"options":[{"t":2,"r":"initData.brands"}],"onChangeEvent":"changedBrands"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only  spacing-for-mobile"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.promoCriteriaText"}]}]}," ",{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","id":"select-prommo","class":"medium left","selected_value":[{"t":2,"r":"promoDeal"}],"options":[{"t":2,"r":"initData.promoDeals"}],"onChangeEvent":"changedPromoDeal"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only  spacing-for-mobile"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header sort-by "},"f":[{"t":2,"r":"initData.sortCriteriaText"}]}]}," ",{"t":7,"e":"ux-select","a":{"id":"select-sort","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"sortByVal"}],"options":[{"t":2,"r":"initData.sortByList"}],"onChangeEvent":"changedSortBy"}}]}]}]}]}]}]}]}]};
this["ux-catalog-splitter"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-catalog-splitter"},"f":[{"t":7,"e":"div","a":{"class":"tabs-area"},"f":[{"t":7,"e":"ul","a":{"class":"tabs flex-container text-center"},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":["tab-title ",{"t":4,"f":["active"],"n":50,"x":{"r":["catalogId","defaultTab"],"s":"_0===_1"}}]},"f":[{"t":7,"e":"ux-anchor","a":{"class":"subsection-header","href":[{"t":2,"r":"catalogUrl"}]},"f":[{"t":2,"r":"catalogName"}]}]}],"n":52,"i":"idx","r":"catalogTabList"}]}]}]}]};
this["ux-catalogue-block"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-catalogue-block"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"panel clearfix"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel"}],"n":50,"r":"ribbon"}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-anchor","a":{"text":[{"t":2,"r":"title"}],"groupId":[{"t":2,"r":"groupId"}],"productUrl":[{"t":2,"r":"productUrl"}],"ontap":"phoneSelected"},"f":[{"t":7,"e":"ux-image","a":{"class":"handset-img","img":[{"t":2,"r":"smallImage"}],"isDataModel":"true"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12"},"f":[{"t":7,"e":"div","a":{"class":"text-center product-title v-normal-top"},"f":[{"t":2,"r":"title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12 text-center v-large-top"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["select-color ",{"t":2,"r":"name"}],"style":["background: ",{"t":2,"r":"hexCode"}]}}],"r":"colors"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12 v-large-top v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"text-center"},"f":[{"t":7,"e":"div","f":["Price is based on capacity"]}]}]}],"n":50,"x":{"r":["isCompare","brand"],"s":"_0&&_1===\"Apple\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12 v-small-top "},"f":[{"t":7,"e":"div","a":{"class":"text-center"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscript-text v-medium-top v-medium-bottom"},"f":["FROM"]}," ",{"t":7,"e":"div","a":{"class":"installment-prices"},"f":[{"t":7,"e":"span","a":{"class":"main-dollar"},"f":["$",{"t":2,"r":"installmentPerMnth"}]}," ",{"t":7,"e":"span","a":{"class":"tag-text"},"f":["/mth"]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":["(",{"t":2,"r":"ippPlanText"},")"]}," ",{"t":7,"e":"div","a":{"class":""},"f":["+ $",{"t":2,"r":"partialUpfrontAmount"}," upfront"]}],"n":50,"x":{"r":["ippPlanText"],"s":"_0&&_0!==\"\""}}],"n":50,"r":"isIPPPlan"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"subscript-text"},"f":["FROM"]}," ",{"t":7,"e":"div","a":{"class":"prices"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-through-dollar"},"f":["$",{"t":2,"r":"originalPrice"}]}],"x":{"r":["originalPrice","publicPrice"],"s":"_0&&_0>_1"}}," ",{"t":7,"e":"span","a":{"class":"main-dollar"},"f":["$",{"t":2,"r":"publicPrice"}]}]}," ",{"t":7,"e":"div","f":["with ",{"t":2,"r":"comboPlan"}," plan"]}],"r":"isIPPPlan"}]}]}],"x":{"r":["isCompare","brand"],"s":"_0&&_1===\"Apple\""}}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal-top v-medium-bottom"},"f":[{"t":7,"e":"ux-button","a":{"class":"select-phones-buttons light round","text":"Select","onclick":"phoneSelected","groupId":[{"t":2,"r":"groupId"}],"productUrl":[{"t":2,"r":"productUrl"}]}}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"panel"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel"}],"r":"ribbon"}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 v-medium-top"},"f":[{"t":7,"e":"ux-anchor","a":{"text":[{"t":2,"r":"title"}],"groupId":[{"t":2,"r":"groupId"}],"productUrl":[{"t":2,"r":"productUrl"}],"ontap":"phoneSelected"},"f":[{"t":7,"e":"ux-image","a":{"class":"handset-img v-large-top v-large-bottom","img":[{"t":2,"r":"smallImage"}]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-7 v-large-top v-large-bottom v-none-padding-left"},"f":[{"t":7,"e":"div","a":{"class":"product-title v-normal-top v-large-bottom"},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["select-color ",{"t":2,"r":"name"}],"style":["background: ",{"t":2,"r":"hexCode"}]}}],"r":"colors"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscript-text v-medium-top v-medium-bottom"},"f":["FROM"]}," ",{"t":7,"e":"div","a":{"class":"installment-prices"},"f":[{"t":7,"e":"span","a":{"class":"main-dollar"},"f":["$",{"t":2,"r":"installmentPerMnth"}]}," ",{"t":7,"e":"span","a":{"class":"tag-text"},"f":["/mth"]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":["(",{"t":2,"r":"ippPlanText"},")"]}," ",{"t":7,"e":"div","a":{"class":""},"f":["+ $",{"t":2,"r":"partialUpfrontAmount"}," upfront"]}],"n":50,"x":{"r":["ippPlanText"],"s":"_0&&_0!==\"\""}}],"n":50,"r":"isIPPPlan"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"subscript-text v-medium-top"},"f":["FROM"]}," ",{"t":7,"e":"div","a":{"class":"prices"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-through-dollar"},"f":["$",{"t":2,"r":"originalPrice"}]}],"x":{"r":["originalPrice","publicPrice"],"s":"_0&&_0>_1"}}," ",{"t":7,"e":"span","a":{"class":"main-dollar"},"f":["$",{"t":2,"r":"publicPrice"}]}]}," ",{"t":7,"e":"div","f":["with ",{"t":2,"r":"comboPlan"}]}],"r":"isIPPPlan"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-center select-phones-buttons-wrapper"},"f":[{"t":7,"e":"ux-button","a":{"class":"select-phones-buttons light round","text":"Select","onclick":"phoneSelected","groupId":[{"t":2,"r":"groupId"}],"productUrl":[{"t":2,"r":"productUrl"}]}}]}]}]}]}],"n":53,"r":"phone"}]}],"n":50,"x":{"r":["displayBlock","phone.display"],"s":"_0||_1"}}]};
this["ux-change-bill-preference"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-change-bill-preference v-normal-top"},"f":[{"t":7,"e":"ux-panel","a":{"class":"panel30 margin-zero"},"f":[{"t":7,"e":"div","a":{"class":"v-medium"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"r":"headerText"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-medium-top v-medium-bottom medium-8 large-7"},"f":[{"t":2,"r":"subHeaderText"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top flex-container"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-9 medium-10 subsection-title flex-item"},"f":[{"t":7,"e":"div","a":{"class":"hide-for-small-only"},"f":[{"t":2,"r":"nickName"}," ",{"t":7,"e":"span","a":{"class":"body-light"},"f":["(A/C: ",{"t":2,"r":"faid"},")"]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":2,"r":"nickName"}," (#",{"t":2,"r":"faid"},")"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 medium-2 flex-item"},"f":[{"t":7,"e":"ux-button-switch","a":{"isSwitchDisabled":[{"t":2,"r":"isSwitchDisabled"}],"switchButtonType":[{"t":2,"r":"switchButtonType"}],"switchButtonValue":[{"t":2,"rx":{"r":".","m":[{"t":30,"n":"switchButtonType"}]}}],"switchButtonId":[{"t":2,"r":"switchButtonType"},{"t":2,"r":"i"}],"account":[{"t":2,"r":"."}],"disabled":[{"t":2,"x":{"r":["isSwitchDisabled","."],"s":"_0(_1)"}}],"class":"line-height-one"}}]}]}],"n":50,"x":{"r":["isEasyMobile"],"s":"!_0"}}],"n":50,"x":{"r":["switchButtonType"],"s":"_0===\"currentChargeDetailsInd\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top flex-container"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-9 medium-10 subsection-title flex-item"},"f":[{"t":7,"e":"div","a":{"class":"subsection-title"},"f":[{"t":7,"e":"div","a":{"class":"hide-for-small-only"},"f":[{"t":2,"r":"nickName"}," ",{"t":7,"e":"span","a":{"class":"body-light"},"f":["(A/C: ",{"t":2,"r":"faid"},")"]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only v-medium-top"},"f":[{"t":2,"r":"nickName"}," (#",{"t":2,"r":"faid"},")"]}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"waiverPaperBillSubHeader"}]}],"n":50,"x":{"r":["deliveryMethod","waiverPaperBillSubHeader"],"s":"_0==\"METH_EBILL\"&&_1"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 medium-2 flex-item"},"f":[{"t":7,"e":"ux-button-switch","a":{"isSwitchDisabled":[{"t":2,"r":"isSwitchDisabled"}],"switchButtonType":[{"t":2,"r":"switchButtonType"}],"switchButtonValue":[{"t":2,"rx":{"r":".","m":[{"t":30,"n":"switchButtonType"}]}}],"switchButtonId":[{"t":2,"r":"switchButtonType"},{"t":2,"r":"i"}],"account":[{"t":2,"r":"."}],"disabled":[{"t":2,"x":{"r":["isSwitchDisabled","."],"s":"_0(_1)"}}],"class":"line-height-one"}}]}]}],"x":{"r":["switchButtonType"],"s":"_0===\"currentChargeDetailsInd\""}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-offset-1 v-normal-top v-normal-bottom"},"f":[{"t":2,"r":"mobileSubHeader"}]}]}],"n":50,"x":{"r":["isMobileSubscriptionPresent","subscribers"],"s":"_0(_1)"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top flex-container flex-container-start"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-offset-1 small-9  medium-7 show-for-small-only flex-item"},"f":[{"t":7,"e":"div","f":["Mobile no: ",{"t":2,"x":{"r":["addSpace","subscriberResourceVal"],"s":"_0(_1,4)"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-offset-1 small-9 medium-7 show-for-medium-up flex-item"},"f":[{"t":7,"e":"div","f":["Mobile no: ",{"t":2,"x":{"r":["addSpace","subscriberResourceVal"],"s":"_0(_1,4)"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 flex-item"},"f":[{"t":7,"e":"ux-button-switch","a":{"isSwitchDisabled":[{"t":2,"r":"isSwitchDisabled"}],"switchButtonType":"itemizedBill","account":[{"t":2,"rx":{"r":"changeBillPreference.accounts","m":[{"t":30,"n":"i"}]}}],"subscription":[{"t":2,"r":"."}],"switchButtonValue":[{"t":2,"r":"subscriptionBillInd"}],"switchButtonId":["itemizedBill",{"t":2,"r":"subscriberResourceVal"},"-",{"t":3,"r":"j"}],"disabled":[{"t":2,"x":{"r":["isSwitchDisabled","i","changeBillPreference.accounts","j","subscribers"],"s":"_0(_2[_1],_4[_3])"}}],"class":"line-height-one"}}]}]}],"n":50,"x":{"r":["subscriberType"],"s":"_0===\"MOB\"||_0===\"WS\""}}],"n":52,"i":"j","r":"subscribers"}],"n":50,"x":{"r":["paperBillInd","showMobileSubscriptions","i","changeBillPreference.accounts","deliveryMethod"],"s":"(_0&&_1)&&(_3[_2].faStatus===79)&&(_4!==\"METH_EBILL\")"}}],"n":52,"i":"i","r":"changeBillPreference.accounts"}]}]}]}]};
this["ux-channel-modal"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-channel-modal"},"f":[{"t":7,"e":"ux-modal","a":{"class":"full-modal v-none-padding","widthPercentage":"100","modalId":"channelList","hideTitle":"true"},"f":[{"t":7,"e":"div","a":{"class":"white-bg"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-large"},"f":[{"t":2,"x":{"r":["packName","title"],"s":"_0||_1"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal"},"f":[{"t":2,"r":"packDescription"}]}],"n":50,"r":"packDescription"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-image"}," ",{"t":7,"e":"ux-header","a":{"class":"subsection-header v-normal-top"},"f":[{"t":2,"r":"packName"}]}," ",{"t":7,"e":"div","f":["CH ",{"t":2,"r":"packId"}]}]}]}]}],"r":"channelList"}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"a","v":{"tap":"closeChannelModal"},"a":{"class":"close-channel"},"f":["< Back"]}]}]}]}]}]};
this["ux-charge-details"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["ux-charge-details ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up v-normal-left p-small-left v-normal-right"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"content-section medium-6"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":7,"e":"span","a":{"class":"marginRight"},"f":[{"t":2,"r":"taxLegendX8"}]},{"t":2,"r":"name"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"r":"description"}]}],"n":50,"r":"description"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","usageVolume"],"s":"_0.formatNumberDecimal(_1,1)"}}," ",{"t":2,"r":"ConfigStrings.usageCharges.M"}],"n":50,"x":{"r":["usageUOMX8"],"s":"_0===\"M\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["usageUOMX8"],"s":"_0===\"O\""},"f":[{"t":2,"r":"usageVolume"}," ",{"t":2,"r":"ConfigStrings.usageCharges.O"}]},{"t":4,"n":50,"x":{"r":["usageUOMX8"],"s":"(!(_0===\"O\"))&&(_0===\"U\")"},"f":[" ",{"t":2,"r":"usageVolume"}," ",{"t":2,"r":"ConfigStrings.usageCharges.U"}]},{"t":4,"n":50,"x":{"r":["usageUOMX8"],"s":"(!(_0===\"O\"))&&((!(_0===\"U\"))&&(_0===\"N\"))"},"f":[" ",{"t":2,"r":"usageVolume"}," ",{"t":2,"r":"ConfigStrings.usageCharges.N"}]},{"t":4,"n":50,"x":{"r":["usageUOMX8"],"s":"(!(_0===\"O\"))&&((!(_0===\"U\"))&&((!(_0===\"N\"))&&(_0===\"K\")))"},"f":[" ",{"t":2,"x":{"r":["RactiveHelpers","usageVolume","configStrings.constants.BYTECONVERSIONMATRIX.FIXED"],"s":"_0.UsageSummarykilobyteConversion(_1,true,_2)"}}]},{"t":4,"n":50,"x":{"r":["usageUOMX8"],"s":"(!(_0===\"O\"))&&((!(_0===\"U\"))&&((!(_0===\"N\"))&&(!(_0===\"K\"))))"},"f":[" -"]}],"x":{"r":["usageUOMX8"],"s":"_0===\"M\""}}],"n":50,"x":{"r":["type"],"s":"_0===\"UC\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"OTHER_CHARGE_CREDIT\"||_0===\"OC\""},"f":[{"t":2,"x":{"r":["RactiveHelpers","chargeDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]},{"t":4,"n":50,"x":{"r":["type"],"s":"!(_0===\"OTHER_CHARGE_CREDIT\"||_0===\"OC\")"},"f":[" ",{"t":2,"x":{"r":["RactiveHelpers","start"],"s":"_0.convertMilisTimestampToDate(_1)"}}," - ",{"t":2,"x":{"r":["RactiveHelpers","end"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}],"x":{"r":["type"],"s":"_0===\"UC\""}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":7,"e":"span","a":{"class":"marginRight"},"f":[{"t":2,"r":"taxLegendX8"}]},{"t":2,"r":"name"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"r":"description"}]}],"n":50,"r":"description"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","usageVolume"],"s":"_0.formatNumberDecimal(_1,1)"}}," ",{"t":2,"r":"ConfigStrings.usageCharges.M"}],"n":50,"x":{"r":["usageUOMX8"],"s":"_0===\"M\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["usageUOMX8"],"s":"_0===\"O\""},"f":[{"t":2,"r":"usageVolume"}," ",{"t":2,"r":"ConfigStrings.usageCharges.O"}]},{"t":4,"n":50,"x":{"r":["usageUOMX8"],"s":"(!(_0===\"O\"))&&(_0===\"U\")"},"f":[" ",{"t":2,"r":"usageVolume"}," ",{"t":2,"r":"ConfigStrings.usageCharges.U"}]},{"t":4,"n":50,"x":{"r":["usageUOMX8"],"s":"(!(_0===\"O\"))&&((!(_0===\"U\"))&&(_0===\"N\"))"},"f":[" ",{"t":2,"r":"usageVolume"}," ",{"t":2,"r":"ConfigStrings.usageCharges.N"}]},{"t":4,"n":50,"x":{"r":["usageUOMX8"],"s":"(!(_0===\"O\"))&&((!(_0===\"U\"))&&((!(_0===\"N\"))&&(_0===\"K\")))"},"f":[" ",{"t":2,"x":{"r":["RactiveHelpers","usageVolume","configStrings.constants.BYTECONVERSIONMATRIX.FIXED"],"s":"_0.UsageSummarykilobyteConversion(_1,true,_2)"}}]},{"t":4,"n":50,"x":{"r":["usageUOMX8"],"s":"(!(_0===\"O\"))&&((!(_0===\"U\"))&&((!(_0===\"N\"))&&(!(_0===\"K\"))))"},"f":[" -"]}],"x":{"r":["usageUOMX8"],"s":"_0===\"M\""}}]}]}],"n":50,"x":{"r":["type"],"s":"_0===\"UC\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"OTHER_CHARGE_CREDIT\"||_0===\"OC\""},"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":2,"x":{"r":["RactiveHelpers","chargeDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}]},{"t":4,"n":50,"x":{"r":["type"],"s":"!(_0===\"OTHER_CHARGE_CREDIT\"||_0===\"OC\")"},"f":[" ",{"t":7,"e":"ux-row","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":2,"x":{"r":["RactiveHelpers","start"],"s":"_0.convertMilisTimestampToDate(_1)"}}," - ",{"t":2,"x":{"r":["RactiveHelpers","end"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}]}],"x":{"r":["type"],"s":"_0===\"UC\""}}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider extend-for-small charge-details-panel-divider"}}]}," ",{"t":7,"e":"ux-modal","a":{"width":"800","class":"light-theme","modalId":"partialChargeModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":["Prorated Charges Calculation"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":"bordered-bottom-small text-center"},"f":["Monthly Subscription (",{"t":2,"x":{"r":["RactiveHelpers","monthlyCharge"],"s":"_0.convertUnits(_1,\"$\")"}},")"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"hr"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 v-small-top"},"f":[" x ",{"t":2,"r":"proratedNoOfDays"}," days"]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":"text-center"},"f":[{"t":2,"r":"noOfDaysInMonth"}," days"]}]}]}]}],"n":53,"r":"charge"}]};
this["ux-chargeable-email"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-chargeable-email"},"f":[{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"chargeableEmailPopup"},"f":[{"t":7,"e":"ux-row","a":{"class":"section-title collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"initData.chargeableEmail.header"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":3,"r":"initData.chargeableEmail.subheader"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ul","a":{"class":"icon-ul v-normal-top"},"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-icon","a":{"type":"alert"}}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"div","a":{"class":"notice-text"},"f":[{"t":2,"r":"initData.chargeableEmail.popUpAlertMsg"}]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"email-wrapper"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"option-container"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"ribbonPosition":"left","ribbon":[{"t":2,"r":"groupRibbon"}]}}],"n":50,"r":"groupRibbon"}," ",{"t":7,"e":"input","a":{"id":["email-option-",{"t":2,"r":"id"}],"type":"radio","name":"select-email-option","value":[{"t":2,"r":"id"}]},"v":{"change":{"n":"selectEmailOption","d":[{"t":2,"r":"id"}]}}}," ",{"t":7,"e":"label","a":{"for":["email-option-",{"t":2,"r":"id"}],"class":[{"t":4,"f":["with-ribbon"],"n":50,"r":"groupRibbon"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-10 small-9"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"title"}]}],"n":50,"r":"title"}," ",{"t":4,"f":[{"t":7,"e":"span","f":[{"t":2,"r":"description"}]}],"n":50,"r":"description"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-2 show-for-small-only text-right"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":["$",{"t":2,"r":"price"}]}," ",{"t":7,"e":"div","f":["per month"]}]}],"n":50,"r":"price"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-offset-1 medium-1 show-for-medium-up text-right"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":["$",{"t":2,"r":"price"}]}," ",{"t":7,"e":"div","f":["per month"]}]}],"n":50,"r":"price"}]}]}],"n":52,"r":"initData.chargeableEmail.options"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["margin-zero round expand-for-mobile ",{"t":4,"f":["disabled"],"n":50,"r":"selected"}],"onclick":"processEmailStatus","text":"Continue"},"f":[]}]}]}]}]}]};
this["ux-chat-ivr"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-chat-ivr"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"script","a":{"src":[{"t":2,"r":"blackList.scriptPathVariable"}],"type":"text/javascript"}}," ",{"t":7,"e":"script","a":{"src":[{"t":2,"r":"blackList.eventsScriptPathVariable"}],"type":"text/javascript"}}],"x":{"r":["disableChatInp"],"s":"_0===\"false\""}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"wrap"},"f":[{"t":7,"e":"div","a":{"class":"logoDiv"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"image"}],"alt":[{"t":2,"r":"altText"}],"class":"logoImg"}}]}," ",{"t":7,"e":"div","a":{"class":"dispNote"},"f":[{"t":7,"e":"p","a":{"class":"paraNote"},"f":[{"t":3,"r":"displayMessage"}]}]}]}]}]}],"n":50,"r":"isDataModel"}]}]};
this["ux-checkbox"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-checkbox"},"f":[{"t":7,"e":"input","a":{"type":"checkbox","checked":[{"t":2,"r":"checked"}],"class":"css-checkbox"},"m":[{"t":4,"f":["id=\"",{"t":3,"r":"checkboxid"},"\""],"n":50,"r":"checkboxid"},{"t":4,"n":51,"f":["id=\"",{"t":2,"r":"guid"},"\""],"r":"checkboxid"},{"t":4,"f":[" name=\"",{"t":2,"r":"checkboxname"},"\""],"n":50,"r":"checkboxname"},{"t":4,"f":["value=\"",{"t":3,"r":"checkboxvalue"},"\""],"n":50,"r":"checkboxvalue"}]}," ",{"t":7,"e":"label","a":{"for":[{"t":4,"f":[{"t":3,"r":"checkboxid"}],"n":50,"r":"checkboxid"},{"t":4,"n":51,"f":[{"t":2,"r":"guid"}],"r":"checkboxid"}],"class":"css-label"},"f":[{"t":3,"r":"labelvalue"}]}]}],"n":50,"x":{"r":["template"],"s":"_0===\"Singtel\""}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":["ux-checkbox ",{"t":2,"r":"style"}," ",{"t":2,"r":"class"}," ",{"t":2,"r":"theme"}," ",{"t":2,"r":"validity.status"}],"aria-checked":[{"t":2,"x":{"r":["checked"],"s":"_0?\"true\":\"false\""}}]},"v":{"blur":"blurHandler"},"m":[{"t":4,"f":["on-tap=\"toggleCheck\""],"n":51,"r":"onChangeEvent"},{"t":4,"f":[" aria-label=\"",{"t":3,"r":"aria_label"},"\""],"n":50,"r":"aria_label"}],"f":[{"t":7,"e":"input","a":{"type":"checkbox","disabled":[{"t":2,"r":"disabled"}],"checked":[{"t":2,"r":"checked"}],"aria-required":[{"t":2,"x":{"r":["mandatory"],"s":"_0?\"true\":\"false\""}}]},"m":[{"t":4,"f":["id=\"",{"t":3,"r":"checkboxid"},"\""],"n":50,"r":"checkboxid"},{"t":4,"n":51,"f":["id=\"",{"t":2,"r":"guid"},"\""],"r":"checkboxid"},{"t":4,"f":[" name=\"",{"t":2,"r":"checkboxname"},"\""],"n":50,"r":"checkboxname"},{"t":4,"f":["value=\"",{"t":3,"r":"checkboxvalue"},"\""],"n":50,"r":"checkboxvalue"}],"v":{"change":"changeHandler"}}," ",{"t":4,"f":[{"t":7,"e":"label","a":{"for":[{"t":2,"r":"checkboxid"}],"class":"multi-labels"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ariaLabel":[{"t":3,"r":"labelvalue"}],"ontap":[{"t":2,"r":"ontap"}],"href":[{"t":2,"r":"href"}],"target":[{"t":2,"r":"target"}],"class":[{"t":2,"r":".theme"}," ",{"t":2,"x":{"r":["@index"],"s":"(_0%2===1)?\"extra-label\":\"\""}}]},"f":[{"t":3,"r":"labelvalue"}]}],"n":50,"x":{"r":["isLink",".theme"],"s":"_0(_1)"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":[{"t":2,"r":".theme"}," ",{"t":2,"x":{"r":["@index"],"s":"(_0%2===1)?\"extra-label\":\"\""}}," text-label"]},"f":[{"t":3,"r":"labelvalue"}]}],"x":{"r":["isLink",".theme"],"s":"_0(_1)"}}],"r":"labels"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"mandatory"},"f":["*"]}],"n":50,"r":"mandatory"}],"n":50,"x":{"r":["postlink"],"s":"!_0"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"sub-title"},"f":[{"t":2,"r":"secondaryLabel"}]}],"n":50,"r":"secondaryLabel"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"aria-live":"assertive","class":"error-message"},"f":[{"t":2,"r":"message"}]}],"r":"validity"}]}],"n":50,"r":"labels"},{"t":4,"n":51,"f":[{"t":7,"e":"label","a":{"for":[{"t":4,"f":[{"t":3,"r":"checkboxid"}],"n":50,"r":"checkboxid"},{"t":4,"n":51,"f":[{"t":2,"r":"guid"}],"r":"checkboxid"}],"class":[{"t":4,"f":["single-label"],"n":50,"x":{"r":["postlink"],"s":"!_0"}}]},"f":[{"t":4,"f":[{"t":3,"r":"labelvalue"}],"n":50,"r":"labelvalue"},{"t":4,"n":51,"f":[{"t":16}],"r":"labelvalue"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"mandatory"},"f":["*"]}],"n":50,"r":"mandatory"}],"n":50,"x":{"r":["postlink"],"s":"!_0"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"sub-title"},"f":[{"t":2,"r":"secondaryLabel"}]}],"n":50,"r":"secondaryLabel"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["icon-btn ",{"t":4,"f":["show"],"n":50,"r":"show_tooltip"}]},"v":{"click":{"n":[{"t":4,"f":["showTooltip"],"n":50,"r":"tooltip_msg"}],"d":[]}},"f":[{"t":7,"e":"ux-icon-button","a":{"icon":"question-mark","size":"s","color":"#888a8c"}}," ",{"t":7,"e":"span","a":{"class":["tooltip-wrapper ",{"t":4,"f":["show"],"n":50,"r":"show_tooltip"}]},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"span","a":{"class":"arrow"}}," ",{"t":7,"e":"p","a":{"class":"tooltip caption"},"f":[{"t":2,"r":"tooltip_msg"}]}]}]}],"n":50,"r":"tooltip_msg"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"aria-live":"assertive","class":"error-message"},"f":[{"t":2,"r":"message"}]}],"r":"validity"}]}],"r":"labels"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ariaLabel":[{"t":2,"r":"postlink.labelvalue"}],"ontap":[{"t":2,"r":"postlink.ontap"}],"href":[{"t":2,"r":"postlink.href"}],"target":[{"t":2,"r":"postlink.target"}],"class":["postlink ",{"t":2,"r":"postlink.theme"}," ",{"t":2,"x":{"r":["@index"],"s":"(_0%2===1)?\"extra-label\":\"\""}}]},"f":[{"t":2,"r":"postlink.labelvalue"}]}],"n":50,"r":"postlink.labelvalue"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"class":["postlink ",{"t":2,"r":"postlink.theme"}," ",{"t":2,"x":{"r":["@index"],"s":"(_0%2===1)?\"extra-label\":\"\""}}]},"f":[{"t":2,"x":{"r":["postlink.labelvalue","postlink"],"s":"_0?_0:_1"}}]}],"r":"postlink.labelvalue"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"mandatory"},"f":["*"]}],"n":50,"r":"mandatory"}],"n":50,"r":"postlink"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"switch-button"}}],"n":50,"x":{"r":["isSwitch",".theme"],"s":"_0(_1)"}}," ",{"t":7,"e":"div","a":{"class":"validity-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"ux-form-validity"}],"r":"validity"}]}]}],"x":{"r":["template"],"s":"_0===\"Singtel\""}}]};
this["ux-checkout-panel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-checkout-panel"},"f":[{"t":7,"e":"ux-row","a":{"class":"medium-uncollapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12 small-12 flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-start price-container v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":7,"e":"span","a":{"class":"section-description"},"f":["Your total today"]}," ",{"t":7,"e":"span","a":{"class":"section-description price-block"},"f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"red subsection-title show-for-medium-up"},"f":["YOU SAVE: ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","retailPrice","price"],"s":"_0.convertUnits(_1-_2,\"$\")"}}],"n":50,"x":{"r":["RactiveHelpers","retailPrice","price","youSave.finalAmountIncludingTax"],"s":"_0.isRrpPlan()&&(_1-_2)<=_3"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["RactiveHelpers","youSave.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}],"x":{"r":["RactiveHelpers","retailPrice","price","youSave.finalAmountIncludingTax"],"s":"_0.isRrpPlan()&&(_1-_2)<=_3"}}]}],"n":50,"x":{"r":["isOrderSummary","youSave.finalAmountIncludingTax"],"s":"_0&&_1>0"}}]}]}," ",{"t":7,"e":"div","a":{"class":"flex-container flex-container-end"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only flex-item flex-item-bottom-align"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"red subsection-title"},"f":["YOU SAVE: ",{"t":2,"x":{"r":["RactiveHelpers","youSave.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["isOrderSummary","youSave.finalAmountIncludingTax"],"s":"_0&&_1>0"}}]}],"n":50,"r":"isOrderSummary"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up p-normal-right flex-item"},"f":[{"t":7,"e":"ux-anchor","a":{"href":"#","class":"no-wrap cart-link empty-cart","ontap":"redirectToCatlog"},"f":["Continue Shopping"]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only flex-item flex-item-bottom-align"},"f":[{"t":7,"e":"ux-anchor","a":{"href":"#","class":"no-wrap cart-link empty-cart","ontap":"redirectToCatlog"},"f":["Continue Shopping"]}]}],"r":"isOrderSummary"}," ",{"t":7,"e":"div","a":{"class":"flex-item show-for-medium-up"},"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":["v-normal-top round button-container ",{"t":4,"f":["disabled"],"r":"isDisabled"}],"onclick":"doCheckout","text":[{"t":2,"r":"buttonText"}],"modalId":"confirmOrderModal"}}],"n":50,"r":"isOrderSummary"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":["v-normal-top round button-container ",{"t":4,"f":["disabled"],"r":"isDisabled"}],"onclick":"doCheckout"},"f":["Checkout"]}],"r":"isOrderSummary"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only small-12"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":["expand-for-mobile v-normal-top round button-container ",{"t":4,"f":["disabled"],"r":"isDisabled"}],"onclick":"doCheckout","text":[{"t":2,"r":"buttonText"}],"modalId":"confirmOrderModal"}}],"n":50,"r":"isOrderSummary"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":["expand-for-mobile v-normal-top round button-container ",{"t":4,"f":["disabled"],"r":"isDisabled"}],"onclick":"doCheckout"},"f":["Checkout"]}],"r":"isOrderSummary"}]}]}]}]};
this["ux-choose-payment-mode"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-choose-payment-mode"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-productvariant-container","a":{"hideStock":"hide","title":[{"t":2,"r":"title.choosePaymentMode"}],"onetimetitle":[{"t":2,"r":"title.oneTimePayment"}],"devicecost":[{"t":2,"r":"price"}],"partialUpfrontAmount":[{"t":2,"r":"partialUpfrontAmount"}],"numofinstallments":[{"t":2,"r":"numberOfInstallment"}],"installmentamout":[{"t":2,"r":"installmentPrice"}]},"f":[{"t":7,"e":"div","a":{"class":["payment-mode v-normal-bottom v-normal-right ",{"t":2,"r":"paymentModeStatus.0"}," ",{"t":2,"r":"paymentModeState"}]},"v":{"tap":{"n":"selectPaymentMode","a":[0]}},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header title"},"f":[{"t":2,"r":"onetimetitle"}]}," ",{"t":7,"e":"div","a":{"class":"clearfix v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"left text-right"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":["$",{"t":2,"r":"devicecost"}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":["DEVICE"]}]}," ",{"t":7,"e":"div","a":{"class":"right text-right"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":["-"]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":["DEVICE TOP UP"]}]}]}]}," ",{"t":7,"e":"div","a":{"class":["payment-mode v-normal-bottom v-normal-right ",{"t":2,"r":"paymentModeStatus.1"}," ",{"t":2,"r":"paymentModeState"}]},"v":{"tap":{"n":"selectPaymentMode","a":[1]}},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header title"},"f":["Installment (",{"t":2,"r":"numofinstallments"}," months)"]}," ",{"t":7,"e":"div","a":{"class":"clearfix v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"left text-right"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":["$",{"t":2,"r":"partialUpfrontAmount"}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":["DEVICE"]}]}," ",{"t":7,"e":"div","a":{"class":"right text-right"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":["$",{"t":2,"r":"installmentamout"}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":["DEVICE TOP UP"]}]}]}]}]}],"n":53,"r":"selectedVariant"}],"n":50,"r":"showPayment"}]}]};
this["ux-cis-form-banner-box"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-cis-form-banner-box"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["show-for-small-only banner-background ",{"t":2,"r":"theme"}," round-edges panel"],"style":["background-image: url('",{"t":2,"r":"backgroundImgMobile"},"'); background-color: ",{"t":2,"r":"backgroundColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"content-outer p-medium-left p-medium-right"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":4,"f":[{"t":7,"e":"img","a":{"class":"","src":[{"t":2,"r":"foregroundImage.src"}]}}],"n":50,"r":"foregroundImage.src"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":[{"t":2,"x":{"r":["headingStyle"],"s":"_0?_0:\"hero-text\""}}," v-normal"]},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"cisSuccessText.ctaButtonLabel"}],"class":[{"t":2,"r":"type"}," round banner-cta v-normal"],"onclick":""},"f":[]}],"n":50,"r":"cisSuccessText.ctaButtonLabel"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-index-success-text v-normal"},"f":[{"t":8,"r":"successEmailContent"}]}],"n":50,"r":"cisSuccessText.cisLiner"}],"n":50,"x":{"r":["submittedSuccess"],"s":"_0==true"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["submitFailed"],"s":"_0==true"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-index-success-text v-large"},"f":[{"t":3,"r":"cisFailText.cisLiner"}]}],"n":50,"r":"cisFailText.cisLiner"}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"cisFailText.ctaButtonLabel"}],"class":[{"t":2,"r":"type"}," default round banner-cta v-normal-top"],"onclick":[{"t":2,"r":"cisFailText.ctaButtonOnClick"}]},"f":[]}],"n":50,"r":"cisFailText.ctaButtonLabel"}]},{"t":4,"n":50,"x":{"r":["submitFailed"],"s":"!(_0==true)"},"f":[" ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-text"},"f":[{"t":3,"r":"text"}]}],"n":50,"r":"text"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-input-label cis-text"},"f":[{"t":3,"r":"inputLabel"}]}],"n":50,"r":"inputLabel"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"input","a":{"name":"cis-email","id":"emailid","type":"text","placeholder":[{"t":2,"r":"ctaPlaceholder"}],"value":[{"t":2,"r":"data.cisEmail"}]}}," ",{"t":4,"f":[{"t":7,"e":"small","a":{"class":"error"},"f":[{"t":2,"r":"data.cisEmailErrorMsg.message"}]}],"n":50,"x":{"r":["data.cisEmailErrorMsg.status"],"s":"_0===\"error\""}}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":["Please do not use your personal email address (Gmail, Hotmail, Yahoo Mail, etc.) or a general business email address (info@, admin@, contact@, etc.)"]}]}],"n":50,"x":{"r":["formType"],"s":"_0==\"inputEmail\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"input","a":{"name":"cis-otp","id":"otpid","type":"text","placeholder":[{"t":2,"r":"ctaPlaceholder"}],"value":[{"t":2,"r":"data.cisOtp"}]},"v":{"blur":"validateOtp"}}," ",{"t":4,"f":[{"t":7,"e":"small","a":{"class":"error"},"f":[{"t":2,"r":"data.cisOtpErrorMsg.message"}]}],"n":50,"x":{"r":["data.cisOtpErrorMsg.status"],"s":"_0===\"error\""}}]}],"n":50,"x":{"r":["formType"],"s":"_0==\"inputOTP\""}}," ",{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"ctaLabel"}],"class":["round cis-form-button button light banner-cta v-large ",{"t":4,"f":["disabled"],"n":50,"r":"data.onInitInputButtonDisabled"}],"onclick":"cisButtonAction"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-text v-large"},"f":[{"t":3,"r":"textBelowButton"}]}],"n":50,"r":"textBelowButton"}]}],"x":{"r":["submittedSuccess"],"s":"_0==true"}}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":["show-for-medium-up banner-background ",{"t":2,"r":"theme"}," round-edges panel"],"style":["background-image: url('",{"t":2,"r":"backgroundImgDesktop"},"'); background-color: ",{"t":2,"r":"backgroundColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-6 large-6"],"n":50,"r":"backgroundImgDesktop"}]},"f":[{"t":7,"e":"div","a":{"class":"content-outer p-large-left p-large-right p-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"content-inner v-large"},"f":[{"t":7,"e":"div","a":{"class":"content v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"x":{"r":["headingStyle"],"s":"_0?_0:\"hero-text\""}}]},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"cisSuccessText.ctaButtonLabel"}],"class":[{"t":2,"r":"type"}," round banner-cta v-normal"],"onclick":""},"f":[]}],"n":50,"r":"cisSuccessText.ctaButtonLabel"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"id":"cisSuccessText","class":"cis-index-success-text v-normal"},"f":[{"t":8,"r":"successEmailContent"}]}],"n":50,"r":"cisSuccessText.cisLiner"}],"n":50,"x":{"r":["submittedSuccess"],"s":"_0==true"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["submitFailed"],"s":"_0==true"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-index-success-text v-large"},"f":[{"t":3,"r":"cisFailText.cisLiner"}]}],"n":50,"r":"cisFailText.cisLiner"}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"cisFailText.ctaButtonLabel"}],"class":[{"t":2,"r":"type"}," default round banner-cta v-normal-top"],"onclick":[{"t":2,"r":"cisFailText.ctaButtonOnClick"}]},"f":[]}],"n":50,"r":"cisFailText.ctaButtonLabel"}]},{"t":4,"n":50,"x":{"r":["submitFailed"],"s":"!(_0==true)"},"f":[" ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-text v-large-top"},"f":[{"t":3,"r":"text"}]}],"n":50,"r":"text"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-input-label cis-text v-normal-top"},"f":[{"t":7,"e":"b","f":[{"t":3,"r":"inputLabel"}]}]}],"n":50,"r":"inputLabel"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"x":{"r":["text"],"s":"_0?\"v-normal\":\"v-large\""}}]},"f":[{"t":7,"e":"input","a":{"name":"cis-email","id":"emailid","type":"text","placeholder":[{"t":2,"r":"ctaPlaceholder"}],"value":[{"t":2,"r":"data.cisEmail"}]}}," ",{"t":4,"f":[{"t":7,"e":"small","a":{"class":"error"},"f":[{"t":2,"r":"data.cisEmailErrorMsg.message"}]}],"n":50,"x":{"r":["data.cisEmailErrorMsg.status"],"s":"_0===\"error\""}}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":["Please do not use your personal email address (Gmail, Hotmail, Yahoo Mail, etc.) or a general business email address (info@, admin@, contact@, etc.)"]}]}],"n":50,"x":{"r":["formType"],"s":"_0==\"inputEmail\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large"},"f":[{"t":7,"e":"input","a":{"name":"cis-otp","id":"otpid","type":"text","placeholder":[{"t":2,"r":"ctaPlaceholder"}],"value":[{"t":2,"r":"data.cisOtp"}]},"v":{"blur":"validateOtp"}}," ",{"t":4,"f":[{"t":7,"e":"small","a":{"class":"error"},"f":[{"t":2,"r":"data.cisOtpErrorMsg.message"}]}],"n":50,"x":{"r":["data.cisOtpErrorMsg.status"],"s":"_0===\"error\""}}]}],"n":50,"x":{"r":["formType"],"s":"_0==\"inputOTP\""}}," ",{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"ctaLabel"}],"class":["round cis-form-button banner-cta v-normal-top ",{"t":4,"f":["disabled"],"n":50,"r":"data.onInitInputButtonDisabled"}],"onclick":"cisButtonAction"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"id":"textBelowButton","class":"cis-text v-large-top"},"f":[{"t":3,"r":"textBelowButton"}]}],"n":50,"r":"textBelowButton"}]}],"x":{"r":["submittedSuccess"],"s":"_0==true"}}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 large-6"},"f":[{"t":7,"e":"div","a":{"class":"foregroundImage"},"f":[{"t":7,"e":"img","a":{"class":"","src":[{"t":2,"r":"foregroundImage.src"}]}}]}]}],"n":50,"r":"foregroundImage.src"}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-cis-form-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-cis-form-banner"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["show-for-small-only banner-background ",{"t":2,"r":"theme"}],"style":["background-image: url('",{"t":2,"r":"backgroundImgMobile"},"'); background-color: ",{"t":2,"r":"backgroundColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":4,"f":[{"t":7,"e":"img","a":{"class":"","src":[{"t":2,"r":"foregroundImage.src"}]}}],"n":50,"r":"foregroundImage.src"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"hero-text v-normal"},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"cisSuccessText.ctaButtonLabel"}],"class":[{"t":2,"r":"type"}," round banner-cta v-normal"],"onclick":""},"f":[]}],"n":50,"r":"cisSuccessText.ctaButtonLabel"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-index-success-text v-normal"},"f":[{"t":8,"r":"successEmailContent"}]}],"n":50,"r":"cisSuccessText.cisLiner"}],"n":50,"x":{"r":["submittedSuccess"],"s":"_0==true"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["submitFailed"],"s":"_0==true"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-index-success-text v-large"},"f":[{"t":3,"r":"cisFailText.cisLiner"}]}],"n":50,"r":"cisFailText.cisLiner"}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"cisFailText.ctaButtonLabel"}],"class":[{"t":2,"r":"type"}," default round banner-cta v-normal-top"],"onclick":[{"t":2,"r":"cisFailText.ctaButtonOnClick"}]},"f":[]}],"n":50,"r":"cisFailText.ctaButtonLabel"}]},{"t":4,"n":50,"x":{"r":["submitFailed"],"s":"!(_0==true)"},"f":[" ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-input-label cis-text"},"f":[{"t":3,"r":"text"}]}],"n":50,"r":"text"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-input-label cis-text"},"f":[{"t":3,"r":"inputLabel"}]}],"n":50,"r":"inputLabel"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"input","a":{"name":"cis-email","id":"emailid","type":"text","placeholder":[{"t":2,"r":"ctaPlaceholder"}],"value":[{"t":2,"r":"data.cisEmail"}]}}," ",{"t":4,"f":[{"t":7,"e":"small","a":{"class":"error"},"f":[{"t":2,"r":"data.cisEmailErrorMsg.message"}]}],"n":50,"x":{"r":["data.cisEmailErrorMsg.status"],"s":"_0===\"error\""}}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":["Please do not provide your personal email address (such as gmail, hotmail, yahoo, etc.) or generic business email address (info@, admin@, contact@ etc.)"]}]}],"n":50,"x":{"r":["formType"],"s":"_0==\"inputEmail\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"input","a":{"name":"cis-otp","id":"otpid","type":"text","placeholder":[{"t":2,"r":"ctaPlaceholder"}],"value":[{"t":2,"r":"data.cisOtp"}]},"v":{"blur":"validateOtp"}}," ",{"t":4,"f":[{"t":7,"e":"small","a":{"class":"error"},"f":[{"t":2,"r":"data.cisOtpErrorMsg.message"}]}],"n":50,"x":{"r":["data.cisOtpErrorMsg.status"],"s":"_0===\"error\""}}]}],"n":50,"x":{"r":["formType"],"s":"_0==\"inputOTP\""}}," ",{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"ctaLabel"}],"class":["round cis-form-button button light banner-cta v-large ",{"t":4,"f":["disabled"],"n":50,"r":"data.onInitInputButtonDisabled"}],"onclick":"cisButtonAction"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-text v-large"},"f":[{"t":3,"r":"textBelowButton"}]}],"n":50,"r":"textBelowButton"}]}],"x":{"r":["submittedSuccess"],"s":"_0==true"}}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":["show-for-medium-up banner-background ",{"t":2,"r":"theme"}],"style":["background-image: url('",{"t":2,"r":"backgroundImgDesktop"},"'); background-color: ",{"t":2,"r":"backgroundColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 large-6"},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner v-large"},"f":[{"t":7,"e":"div","a":{"class":"content v-large"},"f":[{"t":7,"e":"div","a":{"class":"hero-text"},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"cisSuccessText.ctaButtonLabel"}],"class":[{"t":2,"r":"type"}," round banner-cta v-normal"],"onclick":""},"f":[]}],"n":50,"r":"cisSuccessText.ctaButtonLabel"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"id":"cisSuccessText","class":"cis-index-success-text v-normal"},"f":[{"t":8,"r":"successEmailContent"}]}],"n":50,"r":"cisSuccessText.cisLiner"}],"n":50,"x":{"r":["submittedSuccess"],"s":"_0==true"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["submitFailed"],"s":"_0==true"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-index-success-text v-large"},"f":[{"t":3,"r":"cisFailText.cisLiner"}]}],"n":50,"r":"cisFailText.cisLiner"}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"cisFailText.ctaButtonLabel"}],"class":[{"t":2,"r":"type"}," default round banner-cta v-normal-top"],"onclick":[{"t":2,"r":"cisFailText.ctaButtonOnClick"}]},"f":[]}],"n":50,"r":"cisFailText.ctaButtonLabel"}]},{"t":4,"n":50,"x":{"r":["submitFailed"],"s":"!(_0==true)"},"f":[" ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-input-label cis-text v-normal-top"},"f":[{"t":3,"r":"text"}]}],"n":50,"r":"text"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-input-label cis-text v-normal-top"},"f":[{"t":7,"e":"b","f":[{"t":3,"r":"inputLabel"}]}]}],"n":50,"r":"inputLabel"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large"},"f":[{"t":7,"e":"input","a":{"name":"cis-email","id":"emailid","type":"text","placeholder":[{"t":2,"r":"ctaPlaceholder"}],"value":[{"t":2,"r":"data.cisEmail"}]}}," ",{"t":4,"f":[{"t":7,"e":"small","a":{"class":"error"},"f":[{"t":2,"r":"data.cisEmailErrorMsg.message"}]}],"n":50,"x":{"r":["data.cisEmailErrorMsg.status"],"s":"_0===\"error\""}}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":["Please do not provide your personal email address (such as gmail, hotmail, yahoo, etc.) or generic business email address (info@, admin@, contact@ etc.)"]}]}],"n":50,"x":{"r":["formType"],"s":"_0==\"inputEmail\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large"},"f":[{"t":7,"e":"input","a":{"name":"cis-otp","id":"otpid","type":"text","placeholder":[{"t":2,"r":"ctaPlaceholder"}],"value":[{"t":2,"r":"data.cisOtp"}]},"v":{"blur":"validateOtp"}}," ",{"t":4,"f":[{"t":7,"e":"small","a":{"class":"error"},"f":[{"t":2,"r":"data.cisOtpErrorMsg.message"}]}],"n":50,"x":{"r":["data.cisOtpErrorMsg.status"],"s":"_0===\"error\""}}]}],"n":50,"x":{"r":["formType"],"s":"_0==\"inputOTP\""}}," ",{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"ctaLabel"}],"class":["round cis-form-button banner-cta v-normal-top ",{"t":4,"f":["disabled"],"n":50,"r":"data.onInitInputButtonDisabled"}],"onclick":"cisButtonAction"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"id":"textBelowButton","class":"cis-text v-large-top"},"f":[{"t":3,"r":"textBelowButton"}]}],"n":50,"r":"textBelowButton"}]}],"x":{"r":["submittedSuccess"],"s":"_0==true"}}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 large-6"},"f":[{"t":7,"e":"div","a":{"class":"foregroundImage"},"f":[{"t":7,"e":"img","a":{"class":"","src":[{"t":2,"r":"foregroundImage.src"}]}}]}]}],"n":50,"r":"foregroundImage.src"}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-cis-form-myinfo"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-cis-form-myinfo"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"r":"theme"}," round-edges panel ",{"t":4,"f":["parentDisable"],"n":50,"r":"parentDisable"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"content-outer padding-content-outer-cis"},"f":[{"t":7,"e":"div","a":{"class":"content-inner margin-content-inner-cis"},"f":[{"t":7,"e":"div","a":{"class":"content margin-content-cis"},"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"x":{"r":["headingStyle"],"s":"_0?_0:\"section-header\""}}]},"f":[{"t":2,"r":"header"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cis-text margin-top-text-cis"},"f":[{"t":3,"r":"text"}]}],"n":50,"r":"text"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"x":{"r":["text"],"s":"_0?\"v-normal\":\"v-large\""}}]},"f":[{"t":7,"e":"div","a":{"class":"row v-normal-top align-center","style":[{"t":4,"f":["background-color:",{"t":2,"r":"innerBgColor"}],"n":50,"r":"innerBgColor"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"small-3 medium-3 large-3 foregroundImage nopaddingcol"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"innerImg.src"}],"alt":[{"t":2,"r":"innerImg.alt"}]}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-9 medium-9 large-9 v-medium-top v-medium-bottom"},"f":[{"t":3,"r":"innerText"}]}],"n":50,"r":"innerText"}]}]}],"n":50,"x":{"r":["formType"],"s":"_0==\"inputMyinfo\""}}," ",{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"ctaLabel"}],"class":["round cis-form-button banner-cta v-normal-top ",{"t":4,"f":["disabled"],"n":50,"r":"data.onInitInputButtonDisabled"}],"onclick":"cisButtonAction"},"f":[]}]}]}]}]}]}]}],"n":50,"r":"transaction"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-load-mask","f":[{"t":7,"e":"ux-load-mask","f":[]}]}],"r":"transaction"}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme displayMyInfoModal","modalId":"displayMyInfoModal"},"f":[{"t":7,"e":"div","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-tick","size":"l"},"f":[]}," ",{"t":2,"r":"modalTitle"}]}]}," ",{"t":7,"e":"div","a":{"class":"section-details v-normal-top light"},"f":[{"t":7,"e":"div","f":[{"t":3,"r":"modalMessage"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["number-box v-medium-bottom ",{"t":4,"f":["cursor"],"n":50,"x":{"r":["companyLength"],"s":"_0>1"}}," ",{"t":2,"r":"getExistingNumberState"}]},"v":{"tap":{"n":"doSelectCompany","d":[{"t":2,"r":"companyName"}]}},"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-top"},"f":[{"t":7,"e":"ux-col","f":["Employer Name: ",{"t":2,"r":"companyName"},{"t":4,"f":[", ",{"t":2,"r":"employmentDate"}],"n":50,"r":"employmentDate"}]}]}]}],"i":"index","r":"data.myInfoList"}]}]}],"n":50,"r":"data.myInfoList"}," ",{"t":4,"f":[{"t":7,"e":"ux-disclaimer-text","a":{"text":[{"t":2,"r":"modalFooter"}],"topSpacing":"large"},"f":[]}],"n":50,"r":"modalFooter"}," ",{"t":4,"f":[{"t":7,"e":"ux-checkbox","a":{"checked":[{"t":2,"r":"isTncAgreed"}],"labelvalue":[{"t":3,"r":"tncText"}," <a class='tnc-label' href='",{"t":2,"r":"tncLinkUrl"},"' target='_blank'>",{"t":2,"r":"tncLinkText"},"</a>",{"t":2,"r":"tncAdditionalText"}],"class":"v-large-top"},"f":[]}],"n":50,"x":{"r":["tncText","companyLength"],"s":"_0!==null&&_1>0"}}," ",{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"modalButtonLabel"}],"class":["round cis-form-button ",{"t":4,"f":["v-normal-top"],"n":50,"r":"tncText"},{"t":4,"n":51,"f":["v-large-top"],"r":"tncText"}," ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["tncText","isTncAgreed","data.onInitInputButtonDisabled"],"s":"(_0==null||_1)&&!_2"}}],"onclick":"doSubmitMyInfoModal"}}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"genericError"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":[{"t":4,"f":[{"t":2,"r":"modalTitle"}],"n":50,"r":"modalTitle"},{"t":4,"n":51,"f":["Error!!!"],"r":"modalTitle"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details v-xx-large-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"light"},"f":[{"t":3,"r":"modalMessage"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-xx-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-6 medium-6 small-12 "},"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"modalButtonLabel"}],"class":"round cis-form-button banner-cta","onclick":"cisButtonAction"},"f":[]}],"n":50,"r":"noConsentInd"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"modalButtonLabel"}],"href":[{"t":2,"r":"modalButtonUrl"}],"class":"round cis-form-button banner-cta"},"f":[]}],"r":"noConsentInd"}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6 medium-6 small-12 "},"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"modalButton2"}],"href":[{"t":2,"r":"modalButtonUrl2"}],"class":"round cis-form-button banner-cta"},"f":[]}],"n":50,"r":"modalButton2"}]}]}]}]}]};
this["ux-color-variant"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-color-variant ",{"t":2,"x":{"r":["getSelectedColor","name"],"s":"_0(_1)"}}," v-normal-bottom v-normal-right ",{"t":4,"f":["disabled"],"n":50,"r":"isDisabled"}]},"v":{"tap":{"n":"selectColor","d":[{"t":2,"r":"name"}]}},"f":[{"t":7,"e":"div","a":{"class":"color-icon","style":["background-color:",{"t":2,"r":"hexCode"},";"]}}," ",{"t":7,"e":"div","a":{"class":"text-center body-light"},"f":[{"t":2,"r":"name"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"no-stock-line"}}," ",{"t":7,"e":"div","a":{"class":"no-stock-text v-normal-bottom body-light text-center"},"f":["'Not Available'"]}],"n":50,"r":"isDisabled"}]}]};
this["ux-colorcapacity-selector"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-colorcapacity-selector ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}," ",{"t":4,"f":["v-",{"t":2,"r":"bottomSpacing"},"-bottom"],"n":50,"r":"bottomSpacing"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-productvariant-container","a":{"hidePlanDesc":"hide","title":[{"t":2,"r":"title.chooseColor"}]},"m":[{"t":4,"f":["hideStock=\"",{"t":2,"r":"hide"},"\""],"n":50,"r":"hide"}],"f":[{"t":4,"f":[{"t":7,"e":"ux-color-variant","a":{"datamodel":[{"t":3,"r":"."}],"roiVariants":[{"t":2,"r":"roiVariants"}]}}],"n":52,"r":"phoneColors"}]}," ",{"t":7,"e":"ux-productvariant-container","a":{"hideStock":"hide","hidePlanDesc":"show","title":[{"t":2,"r":"title.chooseSize"}],"deviceIdAndPlanId":[{"t":2,"r":"deviceIdAndPlanId"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-capacity-variant","a":{"datamodel":[{"t":3,"r":"."}],"deviceIdAndPlanId":[{"t":2,"r":"deviceIdAndPlanId"}],"isTablet":[{"t":2,"r":"tablet"}],"roiVariants":[{"t":2,"r":"roiVariants"}],"phoneStatus":[{"t":2,"r":"phoneStatus"}]}}],"n":52,"r":"phoneSizes"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"teal-panel v-x-large-top v-medium-top-mobile v-large-bottom medium-12 large-12 small-12"},"f":[{"t":7,"e":"span","a":{"class":"body-copy-text"},"f":[{"t":3,"r":"selectedDeviceVariant.backOrderText"}]}]}],"n":50,"x":{"r":["selectedDeviceVariant","selectedDeviceVariant.backOrderText"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-choose-payment-mode","a":{"datamodel":[{"t":3,"r":"."}]}}],"n":50,"x":{"r":["displayIPP","deviceIdAndPlanId.planId","tablet"],"s":"_0&&_1&&_2"}}," ",{"t":7,"e":"ux-modal","a":{"width":"800","class":"light-theme phone-stock-modal","id":"phoneStockInfo","title":"false"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"section-title clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-header","a":{"class":"left section-header red"},"f":["Oops"]}]}]}," ",{"t":7,"e":"ux-form-validity","a":{"status":"error","message":["Sorry we’re unable to retrieve Stock Availability for ",{"t":2,"r":"header.productTitle"},".Please try again later."]},"f":[]}],"n":50,"r":"errorMessage"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"section-title clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-header","a":{"class":"left section-header"},"f":["Stock Availability for ",{"t":2,"r":"header.productTitle"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"section-details clearfix"},"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"title"},"f":[" "]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header text-center"},"f":[{"t":2,"r":"capacity"}]}]}],"n":52,"r":"data.phoneStockHeaders"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3"},"f":[{"t":7,"e":"div","a":{"class":"color-value"},"f":[{"t":7,"e":"div","a":{"class":"left color-icon","style":["background-color:",{"t":2,"r":"hexCode"},";"]}}," ",{"t":7,"e":"div","a":{"class":"left color-text"},"f":[{"t":2,"r":"color"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-4 medium-3"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header text-center show-for-small-only"},"f":[{"t":2,"r":"capacity"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"stock-status text-center"},"f":[{"t":2,"rx":{"r":"stockInfo","m":[{"t":30,"n":"capacity"},"status"]}}]}],"n":50,"x":{"r":["capacity","stockInfo"],"s":"_1[_0]&&_1[_0].status!==\"\""}}]}],"n":52,"r":"data.phoneStockHeaders"}]}],"r":"data.phoneStock"}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"stock-update-time"},"f":["* Stock status updated at ",{"t":2,"r":"stockUpdateTime"}]}],"n":50,"r":"stockUpdateTime"}," ",{"t":7,"e":"div","a":{"class":"notes"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"data.notes.title"}]}," ",{"t":7,"e":"div","a":{"class":""},"f":[{"t":2,"r":"data.notes.section1.title"}," ",{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":2,"r":"."}]}],"r":"data.notes.section1.content"}]}]}]}]}]}],"r":"errorMessage"}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-column-control"] = {"v":3,"t":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["small-",{"t":2,"r":"small"}],"n":50,"r":"small"},{"t":4,"f":[" medium-",{"t":2,"r":"medium"}],"n":50,"r":"medium"},{"t":4,"f":[" large-",{"t":2,"r":"large"}],"n":50,"r":"large"},{"t":4,"f":[" large-offset-",{"t":2,"r":"largeOffset"}],"n":50,"r":"largeOffset"},{"t":4,"f":[" medium-offset-",{"t":2,"r":"mediumOffset"}],"n":50,"r":"mediumOffset"},{"t":4,"f":[" small-offset-",{"t":2,"r":"smallOffset"}],"n":50,"r":"smallOffset"},{"t":4,"f":[" ",{"t":2,"r":"columnClasses"}],"n":50,"r":"columnClasses"}," column-control"]},"f":[{"t":8,"r":"content"}]}]};
this["ux-consent-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-consent-banner"},"f":[{"t":7,"e":"ux-modal","a":{"class":["consent-banner-singtel ",{"t":4,"f":[{"t":2,"r":"theme"},"-theme"],"n":50,"r":"theme"}],"modalId":"consentBannerModal"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":["v-normal-left v-normal-right ",{"t":4,"f":[{"t":2,"r":"theme"}],"n":50,"r":"theme"}," ",{"t":2,"x":{"r":["descStyle"],"s":"_0?_0:\"body-copy-text\""}}]},"f":[{"t":3,"r":"text"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-modal","a":{"class":["consent-banner-singtel-open-app ",{"t":4,"f":[{"t":2,"r":"openApp.theme"},"-theme"],"n":50,"r":"openApp.theme"}],"modalId":"openAppConsentBannerModal","hideCloseIcon":"true"},"f":[{"t":7,"e":"ux-row","a":{"class":"consent-banner-row"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-2"},"f":[{"t":7,"e":"ux-image","a":{"class":"app-icon","src":[{"t":2,"r":"openApp.imgUrl"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-8 open-app-text"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":[{"t":2,"r":"openApp.theme"}],"n":50,"r":"openApp.theme"}," ",{"t":2,"x":{"r":["descStyle"],"s":"_0?_0:\"body-copy-text\""}}]},"f":[{"t":3,"r":"openApp.text"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 open-app-button"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":[{"t":2,"r":"openApp.theme"}],"n":50,"r":"openApp.theme"}," ",{"t":2,"x":{"r":["descStyle"],"s":"_0?_0:\"body-copy-text\""}}]},"f":[{"t":7,"e":"a","a":{"id":"consent-open-app-button"},"v":{"click":"doRedirectAppStore"},"f":["Open"]}]}]}]}]}],"n":50,"r":"openApp.enable"}]}]};
this["ux-contact-detail-form"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-contact-detail-form ",{"t":2,"r":"class"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"p","a":{"class":"body-copy-text"},"f":[{"t":2,"r":"description"}]}," ",{"t":7,"e":"div","a":{"class":"delivery-inputs medium-5 v-medium-top"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom","for":"emailId"},"f":[{"t":2,"r":"emailTitle"}]}," ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","orderFullfilment.deliveryDetails.emailId"],"s":"_0.maskEmailId(_1)"}}],"n":50,"r":"isEmailDisabled"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-input-box","a":{"id":"emailId","type":"text","placeholder":[{"t":2,"r":"emailTitle"}],"value":[{"t":2,"r":"orderFullfilment.deliveryDetails.emailId"}],"onInputEvent":"updateEmail","onblurEvent":"validateEmail","disabled":[{"t":2,"r":"isEmailDisabled"}],"validity":[{"t":2,"r":"orderFullfilment.deliveryDetails.emailIdErrorMsg"}]},"f":[]}],"r":"isEmailDisabled"}," ",{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom","for":[{"t":2,"r":"contactNumberId"}]},"f":[{"t":2,"r":"contactNumberTitle"}]}," ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","orderFullfilment.deliveryDetails.phone"],"s":"_0.maskPhoneNo(_1)"}}],"n":50,"r":"isPhoneDisabled"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-input-box","a":{"id":"contactNumberId","type":"text","placeholder":[{"t":2,"r":"contactNumberTitle"}],"value":[{"t":2,"r":"orderFullfilment.deliveryDetails.phone"}],"onblurEvent":"validateContactNumber","onInputEvent":"updateNum","disabled":[{"t":2,"r":"isPhoneDisabled"}],"validity":[{"t":2,"r":"orderFullfilment.deliveryDetails.phoneErrorMsg"}]},"f":[]}],"r":"isPhoneDisabled"}]}],"r":"initData.deliveryInstallation.deliveryContactDetail"}],"n":50,"r":"isDataModel"}]}]};
this["ux-contactusaccordion"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-contactusaccordion ",{"t":2,"r":"accordionGroup"}," v-normal-bottom"]},"f":[{"t":7,"e":"div","a":{"class":"accordian"},"f":[{"t":7,"e":"div","a":{"class":"accordianHeader pointer open","role":"button","aria-expanded":"true"},"v":{"tap":{"n":"toggleOpen","d":[{"t":2,"r":"accordionGroup"}]},"click":"changeAccordion"},"f":[{"t":7,"e":"ux-row","a":{"class":"accordion-title"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-11"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"section-header"},"f":[{"t":2,"r":"accordionTitle"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-1"},"f":[{"t":7,"e":"ux-icon","a":{"class":["icon icon-",{"t":2,"r":"type"}],"text":[{"t":2,"x":{"r":["open"],"s":"_0?\"Close\":\"Open\""}}]}}]}]}," ",{"t":7,"e":"hr"}]}]}," ",{"t":7,"e":"div","a":{"class":"main-content"},"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"r":"contentClass"}]},"f":[{"t":8,"r":"content"}]}]}]}]};
this["ux-crop-text"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-crop-text ",{"t":2,"r":"class"}]},"f":[{"t":2,"r":"displayText"}]}]};
this["ux-custom-option"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-custom-option ",{"t":2,"r":"class"}," ",{"t":4,"f":["pointer"],"n":50,"r":"selectable"}]},"v":{"tap":{"n":[{"t":4,"f":["onOptionClick"],"n":50,"r":"selectable"}],"d":[]}},"f":[{"t":8,"r":"content"}]}]};
this["ux-custom-select"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-custom-select"},"f":[{"t":7,"e":"div","a":{"class":"selected-value flex-container pointer"},"f":[{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":8,"r":"selectedValueTemplate"}]}," ",{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-arrow-down"}}]}]}," ",{"t":7,"e":"div","a":{"class":"validity-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"ux-form-validity"}],"r":"validity"}]}," ",{"t":7,"e":"div","a":{"class":["options ",{"t":2,"x":{"r":["showOptions"],"s":"_0?\"open\":\"closed\""}}]},"f":[{"t":7,"e":"div","a":{"class":"options-container"},"f":[{"t":8,"r":"content"}]}]}]}]};
this["ux-customerprofile-header"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-customerprofile-header"},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"customer-profile-header"},"f":[{"t":7,"e":"ux-row","a":{"class":""},"f":[{"t":7,"e":"ux-col","a":{"class":"icon-container medium-1 text-center v-normal-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-image","a":{"datamodel":[{"t":2,"r":"initData.maleAvatar"}]}}],"n":50,"x":{"r":["viewPersonInfo.contactInfo.personGender"],"s":"_0===\"M\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["viewPersonInfo.contactInfo.personGender"],"s":"_0===\"F\""},"f":[{"t":7,"e":"ux-image","a":{"datamodel":[{"t":2,"r":"initData.femaleAvatar"}]}}]}],"x":{"r":["viewPersonInfo.contactInfo.personGender"],"s":"_0===\"M\""}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-11 small-only-text-center"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header v-medium-bottom"},"f":[{"t":2,"r":"greetings"},", ",{"t":2,"r":"onepassInfo.nickName"}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":["Last logged in on ",{"t":2,"r":"lastUpdated"}]}]}]}]}]}]}]}]};
this["ux-date-time-picker"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-date-time-picker ",{"t":2,"r":"style"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header v-normal-bottom"},"f":["Select date and time"]}," ",{"t":7,"e":"div","a":{"class":["appointment-calendar-container ",{"t":2,"r":"calendarContainerClass"}]}}]}],"n":50,"x":{"r":["timeSelectionType"],"s":"_0===\"appointment-booking\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":[{"t":4,"f":["medium-5"],"n":50,"r":"narrowCalendar"},{"t":4,"f":["medium-6"],"n":51,"r":"narrowCalendar"}],"n":50,"x":{"r":["timeSelectionType"],"s":"_0===\"buttons\""}}]},"f":[{"t":4,"f":[{"t":7,"e":"label","a":{"class":"input-label-bold"},"f":["Date"]}],"n":51,"r":"showHeadingText"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Select a Date"]}],"n":50,"r":"showHeadingText"}," ",{"t":7,"e":"div","a":{"class":["calendar-container ",{"t":2,"r":"calendarContainerClass"}]}}]}],"x":{"r":["timeSelectionType"],"s":"_0===\"appointment-booking\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-7"],"n":50,"r":"narrowCalendar"},{"t":4,"f":["medium-6"],"n":51,"r":"narrowCalendar"}," time-slots-container"]},"f":[{"t":4,"f":[{"t":7,"e":"label","f":["Time"]}],"n":51,"r":"showHeadingText"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Select a Time"]}],"n":50,"r":"showHeadingText"}," ",{"t":7,"e":"ux-row","a":{"class":["time-container ",{"t":2,"r":"timeslotContainerClass"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":[{"t":2,"x":{"r":["timeslotClass"],"s":"_0?_0:\"small-6\""}}," time-slot-container ",{"t":2,"x":{"r":["disabled"],"s":"_0?\"disabled\":\"\""}}]},"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"r":"value"},{"t":2,"r":"i"}],"type":"radio","name":[{"t":2,"r":"selected_time"}],"value":[{"t":3,"r":"value"}],"disabled":"disabled"}}],"n":50,"r":"disabled"},{"t":4,"n":51,"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"r":"value"},{"t":2,"r":"i"}],"type":"radio","name":[{"t":2,"r":"selected_time"}],"value":[{"t":3,"r":"value"}]}}],"r":"disabled"}," ",{"t":7,"e":"label","a":{"class":[{"t":4,"f":["selectTime"],"n":50,"x":{"r":["selectedTimeId","value"],"s":"_0===_1"}}],"for":[{"t":2,"r":"value"},{"t":2,"r":"i"}]},"f":[{"t":2,"r":"text"}]}]}],"n":52,"i":"i","r":"timeSlotsOptions"}]}]}],"n":50,"x":{"r":["timeSelectionType"],"s":"_0===\"buttons\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["timeSelectionType"],"s":"(_0===\"appointment-change\")"},"f":[{"t":7,"e":"ux-col","a":{"class":"time-slots-container v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"label","f":["Time"]}],"n":51,"r":"showHeadingText"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":["Select a Time"]}],"n":50,"r":"showHeadingText"}," ",{"t":7,"e":"ux-row","a":{"class":["time-container ",{"t":2,"r":"timeslotContainerClass"}," v-medium-top left-right-collapse"]},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 time-slot-pad"},"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"r":"value"},{"t":2,"r":"i"}],"type":"radio","name":[{"t":2,"r":"selected_time"}],"value":[{"t":3,"r":"value"}]}}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"value"},{"t":2,"r":"i"}]},"f":[{"t":2,"r":"title"}]}]}],"n":52,"i":"i","r":"timeSlotsOptions"}]}]}]},{"t":4,"n":50,"x":{"r":["timeSelectionType"],"s":"(!((_0===\"appointment-change\")))&&((_0===\"appointment-booking\"))"},"f":[" ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 v-medium-top "},"f":[{"t":7,"e":"div","a":{"class":["time-slot ",{"t":2,"x":{"r":["getSlotState","i"],"s":"_0(_1)"}}]},"v":{"tap":{"n":"selectTimeslot","d":[{"t":2,"r":"."},",",{"t":2,"r":"i"}]}},"f":[{"t":2,"r":"."}]}]}],"n":52,"i":"i","r":"timeSlots"}]}]},{"t":4,"n":50,"x":{"r":["timeSelectionType"],"s":"(!((_0===\"appointment-change\")))&&((!((_0===\"appointment-booking\")))&&((_0===\"none\")))"},"f":[" ",{"t":7,"e":"div"}]},{"t":4,"n":50,"x":{"r":["timeSelectionType"],"s":"(!((_0===\"appointment-change\")))&&((!((_0===\"appointment-booking\")))&&(!((_0===\"none\"))))"},"f":[" ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","options":[{"t":2,"r":"timeSlotsOptions"}],"selected_value":[{"t":2,"r":"selected_time"}],"label_value":"Time"}}]}]}],"x":{"r":["timeSelectionType"],"s":"_0===\"buttons\""}}]}]}]};
this["ux-delivery-installation"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-delivery-installation"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"large-row column-control-mobile v-small-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","a":{"class":"panel30 margin-zero"},"f":[{"t":4,"f":[{"t":7,"e":"ux-singtel-breadcrumb-step","a":{"id":"installation-appointment"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-top v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header"},"f":[{"t":2,"r":"initData.fibreInstallation.installationMainTitle"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header"},"f":[{"t":2,"r":"initData.fibreInstallation.installation.title"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":3,"r":"initData.fibreInstallation.installation.description"}]}],"n":50,"r":"initData.fibreInstallation.installation.description"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"delivery-option-wrapper"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"ribbonPosition":"left","ribbon":[{"t":2,"r":"ribbon"}],"class":"v-medium-left"}}],"n":50,"x":{"r":["id","ribbon"],"s":"_0===\"self-installation\"&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"r":"id"}],"type":"radio","name":"select-inst-option","value":[{"t":2,"r":"id"}]},"v":{"change":{"n":"selectInstallationOption","d":[{"t":2,"r":"id"}]}}}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"id"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"span","f":[{"t":2,"r":"description"}]}]}],"n":50,"r":"ribbon"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"span","f":[{"t":2,"r":"description"}]}]}],"r":"ribbon"}],"n":50,"x":{"r":["id"],"s":"_0===\"self-installation\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"span","f":[{"t":2,"r":"description"}]}]}],"x":{"r":["id"],"s":"_0===\"self-installation\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-3 show-for-small-only v-large-top text-right"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":["$",{"t":2,"r":"price"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-2 small-2 show-for-medium-up v-large-top text-right"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":["$",{"t":2,"r":"price"}]}]}],"n":50,"x":{"r":["id","ribbon"],"s":"_0===\"self-installation\"&&_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-3 show-for-small-only text-right"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":["$",{"t":2,"r":"price"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-2 small-2 show-for-medium-up text-right"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":["$",{"t":2,"r":"price"}]}]}],"x":{"r":["id","ribbon"],"s":"_0===\"self-installation\"&&_1"}}]}],"n":50,"x":{"r":["hasPurchasedTV","id","hasPurchasedFibre"],"s":"_0&&_1!==\"self-installation\"||_2"}}],"n":52,"r":"initData.fibreInstallation.installationOptions"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":3,"x":{"r":["RactiveHelpers","initData.fibreInstallation.selfInstallationDescHeader"],"s":"_0.unescapeString(_1)"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top-medium"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4 small-6"},"f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-start flex-container-small-column"},"f":[{"t":7,"e":"ux-image","a":{"class":"text-center-small","src":[{"t":2,"r":"initData.fibreInstallation.selfInstallationPdfImage"}]}}," ",{"t":7,"e":"div","a":{"class":"v-medium-left-medium v-medium-top-medium  text-center-small"},"f":[{"t":3,"r":"initData.fibreInstallation.selfInstallationPdfDesc"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 small-6"},"f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-start flex-container-small-column"},"f":[{"t":7,"e":"ux-image","a":{"class":"text-center-small","src":[{"t":2,"r":"initData.fibreInstallation.selfInstallationVideoImage"}]}}," ",{"t":7,"e":"div","a":{"class":"v-medium-left-medium v-medium-top-medium text-center-small"},"f":[{"t":3,"r":"initData.fibreInstallation.selfInstallationVideoDesc"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 self-installation-promotion-text"},"f":[{"t":7,"e":"div","a":{"class":"subsection-title v-normal-top v-normal-bottom v-medium-left"},"f":[{"t":3,"r":"initData.fibreInstallation.selfInstallationPromotionDesc"}]}]}]}],"n":50,"x":{"r":["selectedInstallationOption","initData.fibreInstallation.selfInstallationPromotionDesc"],"s":"_0===\"self-installation\"&&_1"}}],"n":50,"x":{"r":["selectedInstallationOption","initData.fibreInstallation.selfInstallationDescHeader"],"s":"_0===\"self-installation\"&&_1"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","f":["Date: ",{"t":2,"x":{"r":["moment","implTimeSlotOutput.startDateAndTimeX9"],"s":"_0(_1).format(\"DD/MM/YYYY\")"}}," ",{"t":7,"e":"a","a":{"class":"change-wireline-appointment change-link"},"v":{"tap":{"n":"doChangeApmnt","a":"wirelineAppointment"}},"f":["Change"]}]}," ",{"t":7,"e":"div","f":["Time: ",{"t":2,"r":"implTimeSlotOutput.timeDescriptionX9"}]}],"n":53,"r":"orderFullfilment.existingWirelineAppointments"}],"n":50,"r":"existingAppointments"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top p-medium-left p-medium-right"},"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":7,"e":"b","f":[{"t":2,"r":"initData.fibreInstallation.netlinkInstallation"}]}]}," ",{"t":7,"e":"span","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":3,"r":"toolTipText"}]}]}]}]}," ",{"t":7,"e":"p","a":{"class":"medium-8"},"f":[{"t":3,"r":"initData.fibreInstallation.netlinkInstallationDesc"}]}],"n":50,"x":{"r":["selectedInstallationOption"],"s":"_0===\"singtel-installation\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["selectedInstallationOption"],"s":"_0===\"self-installation\""},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":7,"e":"b","f":[{"t":2,"r":"initData.fibreInstallation.ntlHeader"}]}]}," ",{"t":7,"e":"p","a":{"class":"medium-8 v-normal-top v-medium-bottom","id":"sfInstallation"},"f":[{"t":3,"x":{"r":["RactiveHelpers","initData.fibreInstallation.ntlDescHeader"],"s":"_0.unescapeString(_1)"}}," ",{"t":7,"e":"span","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20 toolTip-para"},"f":[{"t":3,"x":{"r":["RactiveHelpers","initData.fibreInstallation.ntlToolTip"],"s":"_0.unescapeString(_1)"}}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"custom-margin"},"f":[{"t":3,"x":{"r":["RactiveHelpers","initData.fibreInstallation.ntlDescDesc"],"s":"_0.unescapeString(_1)"}}]}]}],"x":{"r":["selectedInstallationOption"],"s":"_0===\"singtel-installation\""}}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"medium-8 v-medium-top"},"f":[{"t":3,"r":"initData.fibreInstallation.installationCalendarDesc"}]}],"n":51,"r":"hideCalendar"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":"medium-8 subsection-header v-large-top"},"f":[{"t":2,"r":"initData.netLinkSelectDateLabel"}," : ",{"t":7,"e":"strong","f":[{"t":2,"r":"initData.netLinkAppDate"}]}]}," ",{"t":7,"e":"div","a":{"class":"msg subsection-header"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"left msg"},"f":[{"t":7,"e":"ux-icon","a":{"type":"success-tick","size":"s","class":"p-medium-right"}}]}],"n":50,"r":"homeAlertFlag"}," ",{"t":7,"e":"div","f":[{"t":7,"e":"strong","f":[{"t":3,"r":"shouldBeAtHome"}]}]}]}],"n":50,"x":{"r":["shouldBeAtHome","initData.netLinkAppDate"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":"medium-8 subsection-header v-large-top"},"f":[{"t":2,"r":"initData.singtelSelectDateLabel"}," : ",{"t":7,"e":"strong","f":[{"t":2,"r":"initData.singtelAppDate"}]}]}],"n":50,"x":{"r":["selectedInstallationOption"],"s":"_0!==\"self-installation\""}},{"t":4,"n":51,"f":[{"t":7,"e":"p","a":{"class":"medium-8 subsection-header v-large-top"},"f":[{"t":2,"r":"initData.singtelEquipmentDeliveryDateLabel"}," : ",{"t":7,"e":"strong","f":[{"t":2,"r":"initData.singtelAppDate"}]}]}],"x":{"r":["selectedInstallationOption"],"s":"_0!==\"self-installation\""}}],"n":50,"r":"initData.singtelAppDate"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"msg subsection-header"},"f":[{"t":7,"e":"div","a":{"class":"left msg"},"f":[{"t":7,"e":"ux-icon","a":{"type":"success-tick","size":"m","class":"p-medium-right"}}]}," ",{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"singtelPresentHomeMsg"}]}]}]}],"n":50,"x":{"r":["selectedInstallationOption"],"s":"_0!==\"self-installation\""}}],"n":50,"r":"hideCalendar"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"calendar-wrapper"},"f":[{"t":7,"e":"ux-fibre-installation"}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"subsection-header v-large-top"},"f":[{"t":2,"r":"initData.notesLabel"},":"]}," ",{"t":7,"e":"ul","a":{"class":"notes-wrapper body-copy-text v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":3,"x":{"r":["RactiveHelpers","noteItem"],"s":"_0.unescapeString(_1)"}}]}],"n":52,"r":"initData.fibreInstallation.notesItems"}]}],"n":50,"r":"manageAppointmentObject.nltInstallation"}],"n":51,"r":"hideCalendar"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}," "],"n":50,"r":"showDwfm"}],"n":50,"x":{"r":["hasPurchasedTV","hasPurchasedFibre","orderFullfilment.deliveryDetails.installationRequired"],"s":"(_0||_1)&&_2"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-x-large-top v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-left text-center-small medium-6"},"f":[{"t":7,"e":"ux-anchor","a":{"role":"link","arialabel":"Back","onclick":"gotoPreviousStep"},"f":["Back"]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-right medium-6"},"f":[{"t":7,"e":"ux-button","a":{"class":["small-only-expand round ",{"t":4,"f":["disabled"],"n":51,"r":"isInstallationSelected"}],"text":"Next","role":"button","arialabel":"Next","onclick":"installationAppointmentNext"}}]}],"n":50,"x":{"r":["hasPurchasedMobile","contactUpdateNeeded","isRedemptionPageEnabled"],"s":"_0||_1||_2"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"text-right medium-6"},"f":[{"t":7,"e":"ux-button","a":{"class":["round right ",{"t":4,"f":["disabled"],"n":51,"r":"isInstallationSelected"}," show-for-medium-up"],"text":"Proceed to Order Summary","role":"button","arialabel":"Proceed to Order Summary","onclick":"installationAppointmentNext"},"f":[]}," ",{"t":7,"e":"ux-button","a":{"class":["round center ",{"t":4,"f":["disabled"],"n":51,"r":"isInstallationSelected"}," show-for-small-only"],"text":"Proceed to Order Summary","role":"button","arialabel":"Proceed to Order Summary","onclick":"installationAppointmentNext"},"f":[]}]}],"x":{"r":["hasPurchasedMobile","contactUpdateNeeded","isRedemptionPageEnabled"],"s":"_0||_1||_2"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-singtel-breadcrumb-step","a":{"id":"delivery-and-installation"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-top v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header"},"f":[{"t":2,"r":"initData.selectedDelivery.mainTitle"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"select-delivery-option v-large-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header v-small-top"},"f":[{"t":2,"r":"initData.selectedDelivery.title"}]}," "]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-top v-medium-bottom"},"f":[{"t":7,"e":"div","a":{"class":"teal-panel v-medium-top left medium-6 large-6"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom"},"f":[{"t":3,"r":"fulfilmentContextualMessage.header"}]}," ",{"t":7,"e":"span","a":{"class":"body-copy-text"},"f":[{"t":3,"r":"fulfilmentContextualMessage.description"}]}]}]}],"n":50,"r":"fulfilmentContextualMessage"}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"div","a":{"class":"delivery-option-wrapper"},"f":[{"t":4,"f":[{"t":4,"f":[" ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"option-container"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"ribbonPosition":"left"}}],"n":50,"r":"ribbon"}," ",{"t":7,"e":"input","a":{"id":[{"t":2,"r":"id"}],"class":"delivery-option","type":"radio","name":"select-option","value":[{"t":2,"r":"id"}]},"v":{"change":{"n":"selectDeliveryOption","d":[{"t":2,"r":"id"}]}}}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"id"}],"class":[{"t":4,"f":["with-ribbon"],"n":50,"r":"ribbon"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"span","f":[{"t":2,"r":"description"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-3 show-for-small-only text-right"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":["$",{"t":2,"r":"price"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-2 small-2 show-for-medium-up text-right"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":["$",{"t":2,"r":"price"}]}]}]}]}],"n":50,"r":"displayFlag"}],"n":52,"r":"initData.selectedDelivery.productDeliveryOptions"}],"n":50,"x":{"r":["initData.deliveryInstallation.installationOptions.length"],"s":"_0>0"}}]}]}]}],"n":50,"x":{"r":["hasPurchasedMobile","skipOrderConsolidate"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"v-medium-top v-medium-bottom panel-divider"}}]}],"n":50,"x":{"r":["hasPurchasedMobile","skipOrderConsolidate"],"s":"_0&&_1"}}," ",{"t":7,"e":"ux-row","a":{"class":"selected-option"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 v-normal-top v-normal-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header medium-8"},"f":[{"t":2,"r":"initData.selectedDelivery.deliveryModeTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"initData.selectedDelivery.deliveryModeDescription"}]}],"n":50,"r":"initData.selectedDelivery.deliveryModeDescription"}],"n":50,"x":{"r":["selectedGroupId"],"s":"_0===\"delivery\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["selectedGroupId"],"s":"(_0===\"collectLater\")"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header medium-8"},"f":[{"t":2,"r":"initData.selectedDelivery.deliveryModeTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"initData.selectedDelivery.fibreCollectionModeDescription"}]}],"n":50,"r":"initData.selectedDelivery.fibreCollectionModeDescription"}]},{"t":4,"n":50,"x":{"r":["selectedGroupId"],"s":"!((_0===\"collectLater\"))"},"f":[" ",{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header medium-8"},"f":[{"t":2,"r":"initData.pickupPopupStation.pickupMainTitle"}]}]}],"x":{"r":["selectedGroupId"],"s":"_0===\"delivery\""}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"div","a":{"class":"row delivery-option-wrapper"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"option-container"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"ribbonPosition":"left","ribbon":[{"t":2,"r":"ribbon"}]}}],"n":50,"r":"ribbon"}," ",{"t":7,"e":"input","a":{"id":[{"t":2,"r":"deliveryId"}],"type":"radio","class":"select-mode-option","name":"select-mode-option","value":[{"t":2,"r":"id"}]},"v":{"change":{"n":"selectDeliveryOption","d":[{"t":2,"r":"id"}]}}}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"deliveryId"}],"class":[{"t":4,"f":["with-ribbon"],"n":50,"r":"ribbon"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":7,"e":"span","f":[{"t":2,"r":"description"}]}],"n":50,"x":{"r":["deliveryId"],"s":"!(_0===\"singtel-store\"||_0===\"pop-station\"||_0===\"singtel-pop-station\")"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-3 show-for-small-only text-right"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":["$",{"t":2,"r":"price"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-2 small-2 show-for-medium-up text-right"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":["$",{"t":2,"r":"price"}]}]}]}]}],"n":50,"r":"displayFlag"}],"n":52,"r":"filteredDeliveryModesList"}]}]}]}],"n":50,"x":{"r":["isCollectNow","filteredDeliveryModesList","filteredDeliveryModesList.length"],"s":"!_0&&_1&&_2>1"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"selected-option delivery-option-top-divider"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header medium-8"},"f":[{"t":2,"r":"initData.selectedDelivery.deliveryAddress.title"}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"initData.selectedDelivery.deliveryAddress.description"}]}],"n":50,"r":"initData.selectedDelivery.deliveryAddress.description"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"delivery-address-wrapper"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 medium-6 v-normal-bottom"},"f":[{"t":7,"e":"input","a":{"id":"delivery-new-address","checked":0,"type":"radio","name":"select-account","value":[{"t":2,"r":"selectedBillAdd.postcode"}]},"v":{"change":{"n":"selectDeliveryAddress","d":[{"t":2,"r":"selectedBillAdd"}]}}}," ",{"t":7,"e":"label","a":{"for":"delivery-new-address"},"f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header address-header"},"f":[{"t":2,"r":"initData.deliverToNewAddressLabel"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"unitNo"}],"n":50,"x":{"r":["floorNo","unitNo"],"s":"_0===_1"}},{"t":4,"n":51,"f":[{"t":2,"r":"floorNo"},"-",{"t":2,"r":"unitNo"}],"x":{"r":["floorNo","unitNo"],"s":"_0===_1"}}],"n":50,"x":{"r":["floorNo","unitNo"],"s":"(_0&&_0!=\"Select\")&&(_1&&_1!=\"Select\")"}}],"n":50,"x":{"r":["type"],"s":"_0===\"sdpRetrieveAddress\""}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}],"x":{"r":["type"],"s":"_0===\"sdpRetrieveAddress\""}}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}]}],"n":53,"r":"selectedBillAdd"}]}]}]}],"n":50,"r":"hasDefaultDeliveryAdd"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"selected-option delivery-option-top-divider"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header medium-8"},"f":[{"t":2,"r":"initData.selectedDelivery.deliveryAddress.title"}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"initData.selectedDelivery.deliveryAddress.description"}]}],"n":50,"r":"initData.selectedDelivery.deliveryAddress.description"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"delivery-address-wrapper"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 medium-6 v-normal-bottom"},"f":[{"t":7,"e":"input","a":{"id":"delivery-new-address","checked":0,"type":"radio","name":"select-account","value":[{"t":2,"r":"deliveryAddress.postcode"}]},"v":{"change":{"n":"selectDeliveryAddress","d":[{"t":2,"r":"deliveryAddress"}]}}}," ",{"t":7,"e":"label","a":{"for":"delivery-new-address"},"f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header address-header"},"f":[{"t":2,"r":"initData.deliverToNewAddressLabel"}]}," ",{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-top"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}],"n":53,"r":"deliveryAddress"}]}]}]}],"n":50,"x":{"r":["deliveryAddress","addressDeliveryMethod"],"s":"_0&&_1!==\"Courier To Home (PoPStation)\"&&_1!==\"Collect Now\"&&_1!==\"Home Delivery (Pop Station)\""}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 medium-6 v-normal-bottom"},"f":[{"t":7,"e":"input","a":{"id":["delivery-account-",{"t":2,"r":"i"}],"type":"radio","name":"select-account","value":[{"t":2,"r":"billingAccountNumber"}]},"v":{"change":{"n":"selectBillingAddress","d":[{"t":2,"r":"billingAccountNumber"}]}}}," ",{"t":7,"e":"label","a":{"for":["delivery-account-",{"t":2,"r":"i"}]},"f":[{"t":7,"e":"div","a":{"class":"subsection-header address-header"},"f":[{"t":2,"r":"initData.deliverItemsLabel"},{"t":7,"e":"br"}," (",{"t":2,"r":"initData.accountToLabel"},": ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","faId"],"s":"_0.maskAccountNo(_1)"}}],"n":50,"x":{"r":["onepassInfo.isWorryFreeLogin","onepassInfo.isWorryFreeFaVerfied"],"s":"_0&&!_1"}},{"t":4,"n":51,"f":[{"t":2,"r":"faId"}],"x":{"r":["onepassInfo.isWorryFreeLogin","onepassInfo.isWorryFreeFaVerfied"],"s":"_0&&!_1"}}," ",{"t":7,"e":"br"}," ",{"t":2,"r":"initData.billingAddLabel"}]}," ",{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-top"},"f":[{"t":7,"e":"ux-singtel-address","a":{"addressType":"crmUpdatedAddressFormat","useOriginalCase":"true","isMaskingReqd":[{"t":2,"x":{"r":["onepassInfo.isWorryFreeLogin","onepassInfo.isWorryFreeFaVerfied"],"s":"_0&&!_1"}}],"address":[{"t":2,"r":"physicalAddress"}]},"f":[]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}],"n":53,"r":"physicalAddress"}],"n":50,"x":{"r":[],"s":"false"}}]}]}]}],"n":52,"i":"i","r":"billingAddress"}],"n":50,"x":{"r":["billPayer"],"s":"_0===\"1\"||_0===1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 medium-6 v-normal-bottom"},"f":[{"t":7,"e":"input","a":{"id":"delivery-contact-address","type":"radio","name":"select-account","value":[{"t":2,"r":"contactAddress.postCode"}]},"v":{"change":{"n":"selectDeliveryAddress","d":[{"t":2,"r":"contactAddress"}]}}}," ",{"t":7,"e":"label","a":{"for":"delivery-contact-address"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header address-header"},"f":[{"t":2,"r":"initData.deliverToContactAddressLabel"}]}," ",{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-top"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}],"n":53,"r":"contactAddress"}]}]}]}],"n":50,"r":"contactAddress"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 medium-6 v-normal-bottom"},"f":[{"t":7,"e":"input","a":{"id":"delivery-installation-address","type":"radio","name":"select-account","value":[{"t":2,"r":"installationAddress.postcode"}]},"v":{"change":{"n":"selectDeliveryAddress","d":[{"t":2,"r":"installationAddress"}]}}}," ",{"t":7,"e":"label","a":{"for":"delivery-installation-address"},"f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header address-header"},"f":[{"t":2,"r":"initData.deliverToInstallationAddressLabel"}]}," ",{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-top"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"apartment"}]}],"n":50,"r":"apartment"}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postCode"}],"n":50,"r":"postCode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postcode"],"s":"_0"},"f":[" ",{"t":2,"r":"postcode"}]}],"r":"postCode"}]}],"n":53,"r":"installationAddress"}]}]}]}],"n":50,"r":"installationAddress.postcode"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 medium-6 v-normal-bottom"},"f":[{"t":7,"e":"input","a":{"id":["newDeliveryAccount-",{"t":2,"r":"i"}],"type":"radio","checked":"chkId","name":"select-account","value":[{"t":2,"r":"postalCode"}]},"v":{"change":"onSelectNewAddress"}}," ",{"t":7,"e":"label","a":{"for":["newDeliveryAccount-",{"t":2,"r":"i"}]},"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":3,"r":"avatar"}]}}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.newDeliveryAddressLabel"}]}," ",{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-top"},"f":[{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"."}],"addressType":"sdpRetrieveAddress"},"f":[]}]}]}]}],"n":52,"i":"i","r":"newAddressAdded"}],"n":50,"x":{"r":["newAddressAdded","newAddressAdded.length"],"s":"_0&&_1>0"}}],"n":53,"r":"orderFullfilment.deliveryDetails"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"addNewAddressLink"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-anchor","a":{"ontap":"showAddNewDeliveryAddressWindow"},"f":["Add New Delivery Address"]}]}]}],"n":50,"x":{"r":["orderFullfilment.deliveryDetails.billingAddress","orderFullfilment.deliveryDetails.installationAddress","selectedBillAdd","newAddressAdded","orderFullfilment.deliveryDetails.contactAddress","onepassInfo","onepassInfo.newcustomer","isMyInfoVerified"],"s":"(_0||_1||_2||_3||_4)&&!(_5&&_6&&_7)"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["onepassInfo","onepassInfo.newcustomer","isMyInfoVerified"],"s":"!(_0&&_1&&_2)"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"ux-address-form-new","a":{"addressType":"sdpRetrieveAddress","address":[{"t":2,"r":"addressRetrieve.address"}],"addressList":[{"t":2,"r":"addressList"}],"errorMessage":[{"t":2,"r":"errorMessage"}],"onUpdate":"confirmAddNewAddress","hideUpdateButton":"true"},"f":[]}]}]}]}],"x":{"r":["orderFullfilment.deliveryDetails.billingAddress","orderFullfilment.deliveryDetails.installationAddress","selectedBillAdd","newAddressAdded","orderFullfilment.deliveryDetails.contactAddress","onepassInfo","onepassInfo.newcustomer","isMyInfoVerified"],"s":"(_0||_1||_2||_3||_4)&&!(_5&&_6&&_7)"}}],"r":"hasDefaultDeliveryAdd"}],"n":50,"x":{"r":["isDeliveryModeSelected","selectedOption"],"s":"(_1===\"courier\"&&_0)||_1===\"sms-mail\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"selected-option"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-select-pickup-location","a":{"pickupData":[{"t":3,"r":"initData.pickupPopupStation"}],"popStationsList":[{"t":2,"r":"popStations"}],"distanceLimited":[{"t":2,"x":{"r":[],"s":"true"}}],"isFulfillment":[{"t":2,"x":{"r":[],"s":"true"}}]},"f":[]}]}]}],"n":50,"x":{"r":["selectedOption"],"s":"_0===\"pop-station\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"selected-option"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-select-pickup-location","a":{"isCollectNow":[{"t":2,"r":"isCollectNow"}],"pickupData":[{"t":3,"r":"initData.collectNowStation"}],"popStationsList":[{"t":2,"r":"selfCollectNowStoresList"}],"zoneList":[{"t":2,"r":"collectNowZoneList"}],"selectedZone":[{"t":2,"r":"selectedZone"}],"isFulfillment":[{"t":2,"x":{"r":[],"s":"true"}}]},"f":[]}]}]}],"n":50,"r":"isCollectNow"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"selected-option delivery-option-top-divider"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 v-normal-bottom"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header medium-8"},"f":[{"t":2,"r":"pickupMainTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"description"}]}],"n":50,"r":"description"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"div","a":{"class":"row delivery-option-wrapper"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"input","a":{"id":"singtelPopstation","type":"radio","class":"select-singtel-option","name":"select-singtel-option","value":[{"t":2,"r":"KioskId"}]},"v":{"change":{"n":"onSingtelStoreSelected","d":[{"t":2,"r":"KioskId"}]}}}," ",{"t":7,"e":"label","a":{"for":"singtelPopstation"},"f":[{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"name"}]}],"n":50,"r":"name"}," ",{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"buildingName"}]}],"n":50,"r":"buildingName"}," ",{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"floorNo"},"-",{"t":2,"r":"unitNumber"}]}," ",{"t":7,"e":"div","a":{"class":"address-line4"},"f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}},"  ",{"t":2,"r":"zipCode"}]}," ",{"t":7,"e":"div","f":["Hours: ",{"t":2,"r":"operationHours"}]}," ",{"t":7,"e":"div","f":["Location: ",{"t":2,"r":"location"}]}]}]}]}]}]}],"r":"ConfigStrings.singtelPopStation"}]}],"n":50,"x":{"r":["selectedOption"],"s":"_0===\"singtel-pop-station\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"selected-option"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-select-pickup-location","a":{"isEAppointment":[{"t":2,"r":"eAppointmentCrOn"}],"pickupData":[{"t":3,"r":"initData.pickupSingtelStore"}],"singtelStoreList":[{"t":2,"r":"singtelStores"}],"zoneList":[{"t":2,"r":"ConfigStrings.storeZoneList"}],"selectedZone":[{"t":2,"r":"selectedZone"}],"isFulfillment":[{"t":2,"x":{"r":[],"s":"true"}}]},"f":[]}]}]}],"n":50,"x":{"r":["selectedOption"],"s":"_0===\"singtel-store\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"v-large-top v-medium-bottom panel-divider"}}]}," ",{"t":7,"e":"ux-row","a":{"class":"selected-option v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"date-time-wrapper-title"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header medium-8"},"f":[{"t":2,"r":"initData.selectedDelivery.deliveryDateTime.title"}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"description"},"f":[{"t":2,"r":"initData.selectedDelivery.deliveryDateTime.description"}]}],"n":50,"r":"initData.selectedDelivery.deliveryDateTime.description"}]}," ",{"t":7,"e":"ux-col","a":{"class":"date-time-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"delivery-date-time-wrapper"},"f":[{"t":7,"e":"ux-date-time-picker","a":{"numberOfMonthsAvailable":"3","timeSelectionType":"buttons","minDate":[{"t":2,"r":"defaultDate"}],"defaultDate":[{"t":2,"r":"enabledDays.0"}],"selected_date":[{"t":2,"r":"defaultDate"}],"enabledDays":[{"t":2,"r":"enabledDays"}],"timeSlots":[{"t":2,"r":"timeslots"}],"narrowCalendar":"true","showHeadingText":"true","setDefaultDate":"true","timeslotClass":"small-5"},"f":[]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"p","a":{"class":"medium-5"},"f":[{"t":2,"r":"initData.appointmentSelectedLabel"}," : ",{"t":2,"r":"selectedAptDetails"}]}]}],"n":50,"x":{"r":["selectedOption","eAppointmentCrOn","selectedAptDetails"],"s":"_0===\"singtel-store\"&&_1&&_2"}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"teal-panel v-medium-top left medium-12 large-12 small-12"},"f":[{"t":7,"e":"span","a":{"class":"body-copy-text"},"f":[{"t":2,"r":"ConfigStrings.preOrderDateSelectionLiner"}]}]}]}],"n":50,"r":"deviceIdAndPlanId.isBackOrder"}],"n":50,"r":"dateTimeShow"}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"p","a":{"class":"subsection-header v-large-top"},"f":[{"t":2,"r":"initData.notesLabel"},":"]}," ",{"t":7,"e":"ul","a":{"class":"notes-wrapper body-copy-text v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":3,"x":{"r":["RactiveHelpers","noteItem"],"s":"_0.unescapeString(_1)"}}]}],"n":52,"r":"initData.selectedNotesItems"}]}]}]}],"n":50,"x":{"r":["selectedOption","eAppointmentCrOn","displayCalendar"],"s":"_0===\"pop-station\"||_0===\"courier\"||_0===\"singtel-pop-station\"||(_0===\"singtel-store\"&&_1&&_2)"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"panel-divider"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header"},"f":[{"t":2,"r":"initData.selectDateTimeLabel"}]}," ",{"t":7,"e":"p","a":{"class":"medium-8"},"f":[{"t":2,"r":"initData.selectDateTimeDescription"}]}," ",{"t":7,"e":"p","a":{"class":"medium-8"},"f":[{"t":4,"f":["Selected AppointmentID : ",{"t":2,"r":"initData.selectedAppointment"}],"n":50,"r":"initData.selectedAppointment"}," ",{"t":4,"f":[{"t":2,"r":"initData.appointmentSelectedLabel"}," : ",{"t":2,"r":"initData.singtelStoreAppointment"}],"n":50,"r":"initData.singtelStoreAppointment"}]}," ",{"t":7,"e":"ux-col","a":{"class":"calendar-wrapper"},"f":[{"t":7,"e":"ux-singtel-store-appointment"}]}," ",{"t":7,"e":"p","a":{"class":"subsection-header v-large-top"},"f":[{"t":2,"r":"initData.notesLabel"},":"]}," ",{"t":7,"e":"ul","a":{"class":"notes-wrapper body-copy-text v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":3,"x":{"r":["RactiveHelpers","noteItem"],"s":"_0.unescapeString(_1)"}}]}],"n":52,"r":"initData.selectedNotesItems"}]}]}]}],"n":50,"x":{"r":["selectedOption","initData.qnomyIframeUrl","initData.storeId","initData.regionId","eAppointmentCrOn"],"s":"_0===\"singtel-store\"&&_1&&_2&&_3&&!_4"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 v-normal"},"f":[{"t":7,"e":"p","a":{"class":"subsection-header v-large-top"},"f":[{"t":2,"r":"initData.notesLabel"},":"]}," ",{"t":7,"e":"div","f":[{"t":3,"x":{"r":["RactiveHelpers","selectedGroupNotes"],"s":"_0.unescapeString(_1)"}}]}]}]}],"n":50,"r":"selectedGroupNotes"}," ",{"t":7,"e":"ux-row","a":{"class":"v-x-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-left text-center-small medium-6 v-normal"},"f":[{"t":7,"e":"ux-anchor","a":{"role":"link","arialabel":"Back","onclick":"gotoPreviousStep"},"f":["Back"]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-right medium-6 v-normal"},"f":[{"t":7,"e":"ux-button","a":{"class":["small-only-expand round ",{"t":4,"f":["disabled"],"n":51,"r":"isDeliverySelected"}],"text":"Next","role":"button","arialabel":"Next","onclick":"deliveryAppointmentNext"}}]}],"n":50,"x":{"r":["contactUpdateNeeded","isRedemptionPageEnabled"],"s":"_0||_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"text-right medium-6 v-normal"},"f":[{"t":7,"e":"ux-button","a":{"class":["round right ",{"t":4,"f":["disabled"],"n":51,"r":"isDeliverySelected"}," show-for-medium-up"],"text":"Proceed to Order Summary","role":"button","arialabel":"Proceed to Order Summary","onclick":"proceedToOrderSummary"},"f":[]}," ",{"t":7,"e":"ux-button","a":{"class":["round center ",{"t":4,"f":["disabled"],"n":51,"r":"isDeliverySelected"}," show-for-small-only"],"text":"Proceed to Order Summary","role":"button","arialabel":"Proceed to Order Summary","onclick":"proceedToOrderSummary"},"f":[]}]}],"x":{"r":["contactUpdateNeeded","isRedemptionPageEnabled"],"s":"_0||_1"}}]}]}," ",{"t":7,"e":"ux-singtel-breadcrumb-step","a":{"id":"contact-information"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-contact-detail-form","a":{"class":"v-medium-top","datamodel":[{"t":3,"r":"."}],"isContactDetailsValid":[{"t":2,"r":"isContactDetailsValid"}]},"f":[]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-x-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-left text-center-small medium-6 v-normal"},"f":[{"t":7,"e":"ux-anchor","a":{"role":"link","arialabel":"Back","onclick":"gotoPreviousStep"},"f":["Back"]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-right medium-6 v-normal"},"f":[{"t":7,"e":"ux-button","a":{"class":["small-only-expand round ",{"t":4,"f":["disabled"],"n":51,"r":"isContactDetailsValid"}],"text":"Next","role":"button","arialabel":"Next","onclick":"contactDetailsNext"}}]}],"n":50,"r":"isRedemptionPageEnabled"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"text-right medium-6 v-normal"},"f":[{"t":7,"e":"ux-button","a":{"class":["round right ",{"t":4,"f":["disabled"],"n":51,"r":"isContactDetailsValid"}," ",{"t":2,"r":"buttonDisabled"}," show-for-medium-up"],"text":"Proceed to Order Summary","role":"button","arialabel":"Proceed to Order Summary","onclick":"proceedToOrderSummary"},"f":[]}," ",{"t":7,"e":"ux-button","a":{"class":["round center ",{"t":4,"f":["disabled"],"n":51,"r":"isContactDetailsValid"}," ",{"t":2,"r":"buttonDisabled"}," show-for-small-only"],"text":"Proceed to Order Summary","role":"button","arialabel":"Proceed to Order Summary","onclick":"proceedToOrderSummary"},"f":[]}]}],"r":"isRedemptionPageEnabled"}]}]}," ",{"t":7,"e":"ux-singtel-breadcrumb-step","a":{"id":"upload-document"},"f":[{"t":4,"f":[{"t":7,"e":"h2","a":{"class":"section-header v-normal-left"},"f":["Identity Document Verification"]}],"n":50,"x":{"r":["showEkycLogin","myInfoDetails"],"s":"_0&&!_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-ekyc-myinfo-login","a":{"type":"ekycMyInfoLoginNotPopUp","isMyInfoCalled":[{"t":2,"x":{"r":[],"s":"false"}}],"isGuestCheckout":[{"t":2,"x":{"r":[],"s":"false"}}],"showEkycLogin":[{"t":2,"r":"showEkycLogin"}]}}],"n":50,"x":{"r":["showEkycLogin","myInfoDetails"],"s":"_0&&!_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-ekyc-document-verificaton","a":{"myInfoDetails":[{"t":2,"r":"myInfoDetails"}],"aemData":[{"t":3,"r":"initData.documentUpload"}]}}],"n":50,"r":"myInfoDetails"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-ekyc-checkout-panel","a":{"isManuallyUpload":[{"t":2,"x":{"r":[],"s":"true"}}],"data":[{"t":2,"r":"documentUploadManually"}]}}],"n":50,"x":{"r":["isManuallyUpload"],"s":"!_0"}}],"n":50,"x":{"r":["showEkycPanel","missingDataInMyInfo"],"s":"_0&&!_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"genericError"}]},"f":[]}],"n":50,"r":"genericError"}," ",{"t":7,"e":"ux-document-upload","a":{"type":"documentPhoto","datamodel":[{"t":3,"r":"."}],"aemData":[{"t":3,"r":"initData.documentUpload"}],"uploadedDocuments":[{"t":2,"r":"documentPhotoUploadedDocuments"}],"showBackButton":"false"},"f":[]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"},"f":[]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-document-upload","a":{"type":"livePhoto","datamodel":[{"t":3,"r":"."}],"aemData":[{"t":3,"r":"initData.livePhotoUpload"}],"uploadedDocuments":[{"t":2,"r":"livePhotoUploadedDocuments"}]},"f":[]}]}],"n":50,"x":{"r":["orderFullfilment.cartPurchaseDetails","orderFullfilment.cartPurchaseDetails.newNewNumber","orderFullfilment.cartPurchaseDetails.existingNewNumber","orderFullfilment.cartPurchaseDetails.newNewPortin","orderFullfilment.cartPurchaseDetails.existingNewPortin","selectedOption"],"s":"_0&&(_1||_2||_3||_4)&&(_5===\"pop-station\"||_5===\"singtel-pop-station\"||_5===\"sms-mail\"||_5===\"collect-now\")"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"},"f":[]}," ",{"t":7,"e":"ux-document-upload","a":{"type":"residentialAddressPhoto","datamodel":[{"t":3,"r":"."}],"aemData":[{"t":3,"r":"initData.residentialPhotoUpload"}],"uploadedDocuments":[{"t":2,"r":"addressUploadedDocuments"}],"showBackButton":"false"},"f":[]}],"n":50,"x":{"r":["onepassInfo","onepassInfo.newcustomer","onepassInfo.customerIdType"],"s":"_0&&_1&&_2!==\"National Registration ID Card (NRIC)\""}}],"n":50,"x":{"r":["RactiveHelpers","documentNeeded","showEkycLogin","myInfoDetails"],"s":"!_0.isIppPlan()&&_1&&!_2&&!_3"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-ekyc-checkout-panel","a":{"isManuallyUpload":[{"t":2,"x":{"r":[],"s":"true"}}],"data":[{"t":2,"r":"documentUploadSingpass"}]}}],"n":50,"r":"isManuallyUpload"}],"n":50,"x":{"r":["showEkycPanel","missingDataInMyInfo"],"s":"_0&&!_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-membershipcard-upload","a":{"datamodel":[{"t":3,"r":"."}],"aemData":[{"t":3,"r":"initData.membershipCardUpload"}],"uploadedDocuments":[{"t":2,"r":"membershipCardUploadedDocuments"}],"membershipCard":[{"t":2,"r":"membershipCard"}]}}]}],"n":50,"x":{"r":["showMembershipCard","membershipCard"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"},"f":[]}],"n":50,"x":{"r":["showEkycLogin"],"s":"!_0"}}," ",{"t":7,"e":"ux-row","a":{"class":" v-x-large-top v-large-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-left text-center-small medium-6 v-normal"},"f":[{"t":7,"e":"ux-anchor","a":{"role":"link","arialabel":"Back","onclick":"gotoPreviousStep"},"f":["Back"]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-right medium-6 v-normal"},"f":[{"t":7,"e":"ux-button","a":{"class":["small-only-expand round ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["isDocumentUploadValid","myInfoDetails"],"s":"_0||_1"}}],"text":"Next","role":"button","arialabel":"Next","onclick":"contactDetailsNext"}}]}],"n":50,"x":{"r":["showEkycLogin","myInfoDetails","isDeliveryRequired","isInstallationRequired","contactUpdateNeeded","isRedemptionPageEnabled"],"s":"!(_0&&!_1)&&(_2||_3||_4||_5)"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["showEkycLogin","myInfoDetails","isLastStep"],"s":"!(_0&&!_1)||_2"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-right medium-6 v-normal"},"f":[{"t":7,"e":"ux-button","a":{"class":["round right ",{"t":2,"r":"buttonDisabled"}," show-for-medium-up"],"text":"Proceed to Order Summary","role":"button","arialabel":"Proceed to Order Summary","onclick":"proceedToOrderSummary"},"f":[]}," ",{"t":7,"e":"ux-button","a":{"class":["round center ",{"t":2,"r":"buttonDisabled"}," show-for-small-only"],"text":"Proceed to Order Summary","role":"button","arialabel":"Proceed to Order Summary","onclick":"proceedToOrderSummary"},"f":[]}]}]}],"x":{"r":["showEkycLogin","myInfoDetails","isDeliveryRequired","isInstallationRequired","contactUpdateNeeded","isRedemptionPageEnabled"],"s":"!(_0&&!_1)&&(_2||_3||_4||_5)"}}]}]}],"n":50,"r":"showDeliveryInstallation"}," "],"n":50,"x":{"r":["isOpened","startDeliveryDisplay"],"s":"_0&&_1"}}]}]}]}],"n":50,"r":"isDataModel"}," ",{"t":7,"e":"ux-modal","a":{"width":"500","class":"light-theme","modalId":"wirelineAppointment"},"f":[{"t":7,"e":"div","a":{"class":"section-title text-center"},"f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":["Change Appointment"]}]}," ",{"t":7,"e":"div","a":{"class":"section-details v-normal-top text-center"},"f":[{"t":7,"e":"p","a":{"class":"v-normal-bottom"},"f":["Change in appointment may delete your existing appointment details. Are you sure you want to continue?"]}," ",{"t":7,"e":"ux-button","a":{"class":"round v-medium-right text-center","onclick":"changeWirelineApmnt"},"f":["Yes"]}," ",{"t":7,"e":"ux-button","a":{"class":"round text-center","onclick":"doCloseModal"},"f":["No"]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"addNewDeliveryAddress"},"f":[{"t":7,"e":"ux-row","a":{"class":"new-billing-address-form-wrapper collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"section-header"},"f":[{"t":2,"r":"initData.confirmYourNewDeliveryAddressLabel"}]}," ",{"t":7,"e":"div","a":{"class":"body-text"},"f":[{"t":2,"r":"initData.confirmYourNewDeliveryAddressDescription"}]}," ",{"t":7,"e":"ux-row","a":{"class":"new-address-holder"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-5 new-address-holder-left-column"},"f":[{"t":7,"e":"ux-row","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.newDeliveryAddressLabel"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-anchor","a":{"ontap":"changeNewAddress"},"f":["Change"]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-7 address"},"f":[{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"addressRetrieve.address"}],"addressType":"sdpRetrieveAddress"},"f":[]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-button","a":{"onclick":"confirmAddNewAddress","text":"Confirm","class":"light right round v-normal-top expand-for-mobile"}}]}]}],"n":50,"r":"toConfirmNewAddress"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"section-header v-normal-bottom"},"f":[{"t":2,"r":"initData.newDeliveryAddressLabel"}]}," ",{"t":7,"e":"div","a":{"class":"section-details v-normal-bottom"},"f":["Please enter your details for new delivery address"]}," ",{"t":7,"e":"ux-address-form","a":{"class":"address-form-wrapper section-details","address":[{"t":2,"r":"addressRetrieve.address"}],"errorMessage":[{"t":2,"r":"errorMessage"}],"onUpdate":"createBilling","addressList":[{"t":2,"r":"addressList"}],"disableConfirmButton":[{"t":2,"r":"disableDeliveryConfirmButton"}]}}],"r":"toConfirmNewAddress"}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"500","class":"light-theme","modalId":"qnomyAppointmentSuccess"},"f":[{"t":7,"e":"div","a":{"class":"section-title text-center"},"f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"initData.deliveryInstallation.qnomyAppointmentHeader"}]}]}," ",{"t":7,"e":"div","a":{"class":"section-details v-normal-top text-center"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":2,"r":"initData.deliveryInstallation.qnomyAppointmentBookedSuccessMsg"}]}," ",{"t":7,"e":"ux-button","a":{"class":"round text-center","onclick":"doCloseModal"},"f":["Ok"]}]}]}]}]};
this["ux-disclaimer-text"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-disclaimer-text fine-print ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"},{"t":4,"f":[" v-",{"t":2,"r":"bottomSpacing"},"-bottom"],"n":50,"r":"bottomSpacing"}]},"f":[{"t":3,"r":"text"}]}]};
this["ux-display-campaign"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-display-campaign"},"f":[{"t":4,"f":[{"t":7,"e":"ux-load-mask"}],"n":50,"r":"loading"}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-fullwidth-banner","a":{"backgroundImage":[{"t":2,"r":"banner.backgroundImage"}],"isDataModel":"true"}}]}],"n":50,"x":{"r":["banner","banner.backgroundImage"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-heading-text","a":{"text":[{"t":2,"r":"campaignDetails.description"}],"heading":[{"t":2,"r":"campaignDetails.title"}],"headingStyle":"hero-text","descStyle":"body-copy-text","topSpacing":"medium","bottomSpacing":"medium","headerDescSpacing":"small","isDataModel":"true"}}]}],"n":50,"r":"campaignDetails"}]}]};
this["ux-document-upload"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-document-upload"},"f":[{"t":7,"e":"ux-row","a":{"class":"large-row column-control-mobile"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"clearfix v-normal-bottom panel-header"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"clearfix header-line"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"medium-text-left large-text-left section-header small-text-left"},"f":[{"t":2,"r":"aemData.uploadIdentity.title"}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"medium-text-left large-text-left change-link","ontap":"doOpenModal:whyAskingYourID"},"f":[{"t":2,"r":"aemData.uploadIdentity.whyIDText"}]}]}," ",{"t":7,"e":"div","a":{"class":"row body-light v-medium-top left medium-8 large-8"},"f":[{"t":3,"r":"aemData.uploadIdentity.info"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"x":{"r":["type"],"s":"_0===\"documentPhoto\""}}," ",{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"teal-panel v-medium-top left medium-8 large-8"},"f":[{"t":7,"e":"span","a":{"class":"body-copy-text v-normal-left"},"f":[{"t":3,"r":"aemData.documentUploadInfoDetails.headerlist"}]}]}]}],"n":50,"x":{"r":["aemData.documentUploadInfoDetails","type"],"s":"_0&&_1===\"documentPhoto\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 v-medium-top sample-img"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-6"],"n":50,"x":{"r":["type"],"s":"_0===\"documentPhoto\""}},{"t":4,"n":51,"f":["medium-12"],"x":{"r":["type"],"s":"_0===\"documentPhoto\""}}," sample-front"]},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"aemData.sampleFrontLabel"}]}," ",{"t":7,"e":"ux-image","a":{"datamodel":[{"t":2,"r":"aemData.sampleImageFront"}]}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 sample-back"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"aemData.sampleBackLabel"}]}," ",{"t":7,"e":"ux-image","a":{"datamodel":[{"t":2,"r":"aemData.sampleImageBack"}]}}]}],"n":50,"x":{"r":["type"],"s":"_0===\"documentPhoto\""}}]}]}],"n":50,"x":{"r":["type"],"s":"_0===\"documentPhoto\""}}," ",{"t":7,"e":"ux-col","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"aemData.uploadPhotoTitle"}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top v-small-bottom small-text-left medium-text-left large-text-left label-section"},"f":[{"t":2,"r":"aemData.uploadPhotoLabel"}]}],"n":50,"x":{"r":["type"],"s":"_0!==\"residentialAddressPhoto\""}}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":3,"r":"aemData.documentUploadInfoDetails.header"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"icon-btn"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"span","a":{"class":"tooltip"},"f":[{"t":2,"r":"aemData.documentUploadInfoDetails.tooltip"}]}],"n":50,"r":"aemData.documentUploadInfoDetails.tooltip"}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":3,"r":"aemData.documentUploadInfoDetails.label"}]}," ",{"t":7,"e":"div","a":{"class":"v-small-bottom small-text-left medium-text-left large-text-left label-section"},"f":[{"t":2,"r":"aemData.documentUploadInfoDetails.uploadsizemessage"}]}],"n":50,"x":{"r":["type"],"s":"_0===\"residentialAddressPhoto\""}}," ",{"t":7,"e":"div","a":{"class":"document-list"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"uploaded-items"},"f":[{"t":7,"e":"ux-col","a":{"class":["small-9 ",{"t":4,"f":["medium-4 "],"n":50,"x":{"r":["type"],"s":"_0===\"documentPhoto\""}},{"t":4,"n":51,"f":["medium-6 "],"x":{"r":["type"],"s":"_0===\"documentPhoto\""}},"file-name"]},"f":[{"t":7,"e":"ux-anchor","a":{"class":"item small-text-center medium-text-left large-text-left wraptext","ontap":["showUploadedImage:",{"t":2,"r":"./documentID"}]},"f":[{"t":2,"r":"./fileName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 medium-4 large-4"},"f":[{"t":7,"e":"ux-anchor","a":{"index":[{"t":2,"r":"i"}],"class":"v-small-left","ontap":["removeUploadedImage:",{"t":2,"r":"./documentID"}]},"f":[{"t":2,"r":"aemData.removeLabel"}]}]}]}]}],"n":52,"i":"i","r":"uploadedDocuments"}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-5 large-4 no-padding"},"f":[{"t":7,"e":"form","a":{"action":"/upload","method":"post","enctype":"multipart/form-data"},"f":[{"t":7,"e":"div","a":{"class":["file-upload button light round v-normal-top ",{"t":2,"r":"disableUpload"}," ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["type","uploadedDocuments","uploadedDocuments.length"],"s":"_0===\"livePhoto\"&&_1&&_2>0"}}]},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"aemData.uploadLabel"}]}," ",{"t":7,"e":"input","a":{"type":"file","name":"file","id":["uploadFile",{"t":2,"r":"type"}],"class":"upload","accept":[{"t":2,"r":"acceptedFileTypes"}]},"m":[{"t":2,"r":"disableUpload"}]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"aemData.eShopErrorModel.eShopStartErrorMsg"}," ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"aemData.eShopErrorModel.eShopFormLinkUrl"}],"target":"_blank"},"f":[{"t":3,"r":"aemData.eShopErrorModel.eShopFormLinkText"}]}," ",{"t":2,"r":"aemData.eShopErrorModel.eShopEndErrorMsg"}]}],"n":50,"r":"dynamicMessage"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"errorMessage"}]},"f":[]}],"r":"dynamicMessage"}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-right"},"f":[{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"aemData.missingDocumentMessage"}]},"f":[]}],"n":50,"r":"displayErrorMessage"}," ",{"t":7,"e":"ux-button","a":{"class":"round small-only-expand","text":"Submit","role":"button","arialabel":"Submit","onclick":"doSubmit"},"f":[]}," ",{"t":7,"e":"ux-col","f":[]}]}]}],"n":50,"r":"isNextButtonRequired"}]}," ",{"t":7,"e":"ux-modal","a":{"width":"1000","class":"light-theme previewImageModal","modalId":"showImageInfo"},"f":[{"t":7,"e":"div","a":{"class":"section-title clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"previewImage.fileName"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"section-details clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"ux-iframe","a":{"id":"iframeID","src":[{"t":2,"r":"previewImage.fileContent"}],"width":"100%"}}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"500","class":"light-theme oriModal","modalId":"uploadProgressInfo"},"f":[{"t":7,"e":"div","a":{"class":"section-title clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"uploadingImageName"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"section-details clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"progress"},"f":[{"t":7,"e":"div","a":{"class":"meter","style":["transition-duration: ",{"t":2,"r":"progressBarDuration"},"ms ;width: ",{"t":2,"r":"progressBarWidth"},"%;"]}}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme smallModal","modalId":"whyAskingYourID"},"f":[{"t":7,"e":"div","a":{"class":"section-title clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":3,"r":"aemData.uploadIdentity.whyIDText"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"section-details clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"div","a":{"class":"row body-light v-medium-top left"},"f":[{"t":3,"r":"aemData.uploadIdentity.whyIDDesc"}]}]}]}]}]}]}]}]}]};
this["ux-donut-loader"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-donut-loader swiper-slide"},"f":[{"t":7,"e":"div","a":{"class":"graph-container"},"f":[{"t":7,"e":"div","a":{"class":"text-container text-center"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-normal-top"},"f":[{"t":2,"r":"value"},"%"]}]}," ",{"t":7,"e":"svg"}]}]}]};
this["ux-easyplan"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-easyplan"},"f":[{"t":7,"e":"ux-row","a":{"class":["plan-select-panel ",{"t":4,"f":["v-none-margin"],"n":50,"r":"isChangePlan"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"plans"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-6 medium-3 ",{"t":2,"r":"planType"}]},"f":[{"t":7,"e":"div","a":{"class":["plan-select-box text-center hover-container ",{"t":4,"f":["plan-select-box-price"],"n":50,"r":"deviceIdAndPlanId.deviceId"}," ",{"t":2,"x":{"r":["getSelectedState","index"],"s":"_0(_1)"}}]},"v":{"tap":{"n":"selectPlan","d":[{"t":2,"r":"index"}]}},"f":[{"t":7,"e":"div","a":{"class":"plan-price section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyCharges"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"plan-type body"},"f":[{"t":2,"r":"planName"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price-divider v-medium-top v-medium-bottom"}}," ",{"t":7,"e":"div","a":{"class":"plan-price section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","./phoneCost"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"plan-type body"},"f":["Phone Price"]}],"n":50,"r":"deviceIdAndPlanId.deviceId"}]}]}],"i":"index","r":"plans"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-large-top easy-mobile-units section-header unitspacing"},"f":[{"t":2,"r":"activeType"}," : ",{"t":2,"r":"totalUnits"}," Units"]}," ",{"t":7,"e":"ux-col","a":{"class":"marketing-message body v-medium-top"},"f":[{"t":2,"r":"activeMessage"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"plan-details-panel"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-text-right body text-center v-large-bottom"},"f":[{"t":2,"r":"individualUnitInfo"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-4 v-normal-bottom talktime-units"},"f":[{"t":7,"e":"div","a":{"class":"active-talktime v-medium-bottom text-center left"},"f":[{"t":2,"r":"activeTalktimeUnits"}]}," ",{"t":7,"e":"div","a":{"class":"unit-label left"},"f":[{"t":7,"e":"div","a":{"class":"units"},"f":["Units"]}," ",{"t":7,"e":"div","a":{"class":"value"},"f":[{"t":2,"r":"activeMinutes"}," ",{"t":2,"r":"talktimeValue"}," Talktime"]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4 v-normal-bottom sms-units"},"f":[{"t":7,"e":"div","a":{"class":"active-sms v-medium-bottom text-center left"},"f":[{"t":2,"r":"activeSMSUnits"}]}," ",{"t":7,"e":"div","a":{"class":"unit-label left"},"f":[{"t":7,"e":"div","a":{"class":"units"},"f":["Units"]}," ",{"t":7,"e":"div","a":{"class":"value"},"f":[{"t":2,"r":"activeSMS"}," ",{"t":2,"r":"smsValue"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4 v-normal-bottom data-units"},"f":[{"t":7,"e":"div","a":{"class":"active-data text-center left"},"f":[{"t":2,"r":"activeDataUnits"}]}," ",{"t":7,"e":"div","a":{"class":"unit-label left"},"f":[{"t":7,"e":"div","a":{"class":"units"},"f":["Units"]}," ",{"t":7,"e":"div","a":{"class":"value"},"f":[{"t":2,"r":"activeData"},{"t":2,"r":"dataValue"}," Data"]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"range-slider"},"f":[]}," ",{"t":7,"e":"ux-col","a":{"class":"text-center v-medium-top callout-text-copy"},"f":[{"t":2,"r":"unitError"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-medium-top callout-text-copy"},"f":[{"t":2,"r":"isValueZeroError"}]}],"n":51,"r":"isValueZero"}]}," ",{"t":7,"e":"ux-col","a":{"class":"body"},"f":[{"t":2,"r":"additionalInfo"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-text-right v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"class":["round small-only-expand ",{"t":4,"f":["disabled"],"n":51,"r":"isValueZero"}],"onclick":"selectEasyMobilePlan","text":[{"t":2,"r":"buttonLabel"}]}}]}]}]}]}]};
this["ux-ebill-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-ebill-singtel"},"f":[{"t":7,"e":"ux-modal","a":{"displayState":"true","widthPercentage":"80","class":"light-theme"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-7"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"subTitle"}]}," ",{"t":7,"e":"ux-header","a":{"level":"2","class":"marketing-text"},"f":[{"t":2,"r":"title"}]}," ",{"t":3,"r":"text"}," ",{"t":4,"f":[{"t":7,"e":"ux-radio-button","a":{"label":[{"t":2,"r":"."}]}}],"r":"selections"}," ",{"t":7,"e":"div","a":{"class":"v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":7,"e":"ux-checkbox","a":{"labelvalue":[{"t":2,"r":"checkboxLabel"}]}}]}," ",{"t":7,"e":"ux-button","a":{"href":[{"t":2,"r":"buttonLink"}],"class":"right round","text":[{"t":2,"r":"buttonText"}]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":[{"t":7,"e":"div","a":{"class":"panel panel-marketing v-large-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"ebillTitle"}]}," ",{"t":7,"e":"div","a":{"class":"marketing-text"},"f":[{"t":2,"r":"ebillText"}]}]}]}]}]}]}]};
this["ux-ekyc-button"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-ekyc-button flex flex-",{"t":2,"r":"alignment"}," ",{"t":4,"f":["hidden"],"n":50,"r":"hidden"}]},"f":[{"t":7,"e":"ux-button","a":{"class":["round v-normal-top ",{"t":4,"f":["light"],"n":50,"x":{"r":["type"],"s":"_0===\"secondary\""}}," ",{"t":4,"f":["disabled"],"n":50,"r":"buttonDisabled"}],"text":[{"t":2,"r":"text"}],"onclick":"handleEkycButtonClick","disabled":[{"t":2,"r":"buttonDisabled"}]}}]}]};
this["ux-ekyc-checkout-panel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-ekyc-checkout-panel"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-left v-normal-top v-normal-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-copy-text-heavy v-small-top"},"f":[{"t":7,"e":"ux-image","a":{"class":"text-left-small","src":[{"t":3,"r":"data.checkoutImage"}]}}]}],"n":50,"r":"isManuallyUpload"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-copy-text-heavy v-small-top"},"f":[{"t":3,"r":"data.sectionHeader"}]}],"n":50,"r":"isManuallyUpload"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-copy-text-light v-small-top"},"f":[{"t":3,"r":"data.sectionDescription"}]}],"n":50,"r":"isManuallyUpload"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-copy-text-light v-small-top"},"f":[{"t":3,"r":"data.proceedingMsg"}]}],"n":50,"r":"isManuallyUpload"}]}]}]}]};
this["ux-ekyc-document-verificaton"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-ekyc-document-verificaton"},"f":[{"t":7,"e":"div","a":{"class":"container"},"f":[{"t":7,"e":"div","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"h2","a":{"class":"section-header v-large-left"},"f":["Identity Document Verification"]}," ",{"t":7,"e":"div","a":{"class":"panel-divider v-large-top "}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-large-left"},"f":[{"t":7,"e":"div","a":{"class":"teal-panel v-normal-top flex-container flex-container-start"},"f":[{"t":7,"e":"ux-icon","a":{"type":"circle-tick","class":"black","size":"m"}}," ",{"t":7,"e":"span","a":{"class":"body-copy-text v-normal-left"},"f":[{"t":2,"r":"initData.myInfoMessages.successscenario"}]}]}]}],"n":50,"r":"fullName"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"v-large-left"},"f":[{"t":7,"e":"div","a":{"class":"teal-panel v-normal-top flex-container flex-container-start"},"f":[{"t":7,"e":"ux-icon","a":{"type":"circle-tick","class":"black","size":"m"}}," ",{"t":7,"e":"span","a":{"class":"body-copy-text v-normal-left"},"f":[{"t":2,"r":"initData.myInfoMessages.incompletedata"}]}]}]}],"r":"fullName"}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top v-large-left"},"f":[{"t":7,"e":"label","f":["Full Name"]}," ",{"t":7,"e":"div","a":{"class":"body-copy-text-heavy v-normal-top"},"f":[{"t":2,"r":"fullName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top v-large-left"},"f":[{"t":7,"e":"label","f":[{"t":2,"r":"passType"}]}," ",{"t":7,"e":"div","a":{"class":"body-copy-text-heavy v-normal-top"},"f":[{"t":2,"r":"uniqueId"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"label","a":{"class":"v-large-left"},"f":["Date of Expiry"]}," ",{"t":7,"e":"div","a":{"class":"body-copy-text-heavy v-normal-top v-large-left"},"f":[{"t":2,"r":"passExpiryDate"}]}]}],"n":50,"x":{"r":["passExpiryDate","passType"],"s":"_0&&_1!==\"National Registration ID Card (NRIC)\""}}]}]}]}]}]};
this["ux-ekyc-myinfo-login"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-ekyc-myinfo-login"},"f":[{"t":7,"e":"ux-row","a":{"class":"large-row column-control-mobile"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"x":{"r":["type"],"s":"_0!==\"ekycMyInfoLoginPopUp\""}}," ",{"t":7,"e":"div","a":{"class":"clearfix v-normal-bottom panel-header"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"clearfix header-line"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"medium-text-left large-text-left section-header small-text-left"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"eKycMyInfo.imagePath.src"}],"alt":[{"t":2,"r":"eKycMyInfo.imagePath.alt"}],"class":"foregroundImage nopaddingcol"}}]}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"description-wrapper v-medium-top left medium-8 large-12"},"f":[{"t":7,"e":"span","a":{"class":[{"t":4,"f":["section-header"],"n":50,"x":{"r":["type"],"s":"_0===\"ekycMyInfoLoginPopUp\""}},{"t":4,"n":51,"f":["subsection-header"],"x":{"r":["type"],"s":"_0===\"ekycMyInfoLoginPopUp\""}}]},"f":[{"t":4,"f":[{"t":2,"r":"eKycMyInfo.heading.guestCheckout"}],"n":50,"r":"isGuestCheckout"},{"t":4,"n":51,"f":[{"t":2,"r":"eKycMyInfo.heading.fulfillment"}],"r":"isGuestCheckout"}]}," ",{"t":7,"e":"span","a":{"class":"new-liner"},"f":[{"t":7,"e":"sup","f":[{"t":2,"r":"eKycMyInfo.newTag"}]}]}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"p","a":{"class":"body-copy-text v-medium-top left medium-8 large-12"},"f":[{"t":4,"f":[{"t":2,"r":"eKycMyInfo.text.guestCheckout"}],"n":50,"r":"isGuestCheckout"},{"t":4,"n":51,"f":[{"t":2,"r":"eKycMyInfo.text.fulfillment"}],"r":"isGuestCheckout"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"buttoncontainer v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"spacer-top line-button button round","tabindex":"10","onclick":"singPassButtonClick"},"f":["Retrieve Myinfo with Singpass"]}," ",{"t":7,"e":"span","a":{"class":"button-spacer"},"f":[" "]}],"n":50,"x":{"r":["isMyInfoCalled"],"s":"!_0"}}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"spacer-top line-button button light round","tabindex":"11","onclick":"uploadDocManuallyButtonClick"},"f":["Fill Form manually"]}],"n":50,"r":"isGuestCheckout"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":"spacer-top line-button button light round","tabindex":"11","onclick":"uploadDocManuallyButtonClick"},"f":["Upload documents manually"]}],"r":"isGuestCheckout"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"new-link"},"f":[{"t":7,"e":"span","f":["Upload of supporting documents required"]}]}],"n":50,"r":"isGuestCheckout"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"x":{"r":["type"],"s":"_0===\"ekycMyInfoLoginPopUp\""}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"disclaimer-section v-medium-top left medium-12 large-12"},"f":[{"t":7,"e":"span","a":{"class":"disclaimer-text"},"f":[{"t":2,"r":"eKycMyInfo.disclaimer"}]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","a":{"class":"disclaimer-link"},"f":[{"t":7,"e":"ux-anchor","a":{"href":"https://www.singpass.gov.sg","target":"_blank","ontap":"learnMoreAboutSingpass"},"f":[{"t":2,"r":"eKycMyInfo.disclaimerLink"}]}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"x":{"r":["type"],"s":"_0!==\"ekycMyInfoLoginPopUp\""}}]}]}]}]};
this["ux-energy-catalog"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-energy-catalog"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up catalog-height"},"f":[{"t":7,"e":"div","a":{"class":"panel v-none-padding clearfix"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"energy-ribbon-label","style":["background-color:",{"t":2,"r":"ribbonColor"},";"]},"f":[{"t":2,"r":"ribbon"}]}],"n":50,"r":"ribbon"}," ",{"t":7,"e":"ux-anchor","a":{"planId":[{"t":2,"r":"planId"}],"ontap":"energyPlanSelected"},"f":[{"t":7,"e":"ux-image","a":{"class":"plan-img","img":[{"t":2,"r":"largeImage"}],"isDataModel":"true"}}]}," ",{"t":7,"e":"div","a":{"class":"p-medium-left p-medium-right"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12"},"f":[{"t":7,"e":"div","a":{"class":"text-center section-header energy-header-size v-large-top v-normal-bottom"},"f":[{"t":2,"r":"priceType"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12"},"f":[{"t":7,"e":"div","a":{"class":"text-center"},"f":[{"t":2,"r":"description"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12 v-large-top "},"f":[{"t":7,"e":"div","a":{"class":"text-center"},"f":[{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"r":"price"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"energyUnit"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12 text-center v-large-top v-normal-bottom"},"f":[{"t":7,"e":"ux-button","a":{"class":"select-plan-buttons light round","text":"Select","onclick":"energyPlanSelected","planId":[{"t":2,"r":"planId"}]}}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"panel v-none-padding"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"energy-ribbon-label","style":["background-color:",{"t":2,"r":"ribbonColor"},";"]},"f":[{"t":2,"r":"ribbon"}]}],"n":50,"r":"ribbon"}," ",{"t":7,"e":"ux-anchor","a":{"planId":[{"t":2,"r":"planId"}],"ontap":"energyPlanSelected"},"f":[{"t":7,"e":"ux-image","a":{"class":"plan-img","img":[{"t":2,"r":"smallImage"}],"isDataModel":"true"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":"text-center section-header energy-header-size v-large-top v-medium-bottom"},"f":[{"t":2,"r":"priceType"}]}," ",{"t":7,"e":"div","a":{"class":"text-center"},"f":[{"t":2,"r":"description"}]}," ",{"t":7,"e":"div","a":{"class":"text-center v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"r":"price"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"energyUnit"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 v-normal-bottom v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"class":"select-plan-button light round","text":"Select","onclick":"energyPlanSelected","planId":[{"t":2,"r":"planId"}]}}]}]}]}],"n":53,"r":"energyPlan"}]}]};
this["ux-energy-plan-callback"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-energy-plan-callback"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-xx-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 large-6 small-12 medium-offset-1"},"f":[{"t":7,"e":"ux-row","a":{"class":"left-padding"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header"},"f":[{"t":2,"r":"initData.requestCallbackTitle"}]}," ",{"t":7,"e":"div","a":{"class":"body v-large-top"},"f":[{"t":2,"r":"initData.requestCallbackDesc"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-normal-top v-small-bottom","for":[{"t":2,"r":"nameId"}]},"f":[{"t":2,"r":"initData.nameTitle"}]}," ",{"t":7,"e":"ux-input-box","a":{"id":"name","type":"text","value":[{"t":2,"r":"name"}],"name":"name","validity":[{"t":2,"r":"nameErrorMsg"}],"onblurEvent":"onblurContactName","onInputEvent":"onInputName"},"f":[]}," ",{"t":7,"e":"label","a":{"class":"input-label-bold v-normal-top v-small-bottom","for":[{"t":2,"r":"contactNumberId"}]},"f":[{"t":2,"r":"initData.contactNumberTitle"}]}," ",{"t":7,"e":"ux-input-box","a":{"id":"phone","value":[{"t":2,"r":"phone"}],"type":"text","name":"phone","onblurEvent":"onblurContactNumber","onInputEvent":"onInputNum","validity":[{"t":2,"r":"phoneErrorMsg"}]},"f":[]}," ",{"t":7,"e":"ux-button","a":{"class":"round v-normal-top small-only-expand","text":"Submit","role":"button","arialabel":"Submit","onclick":"doSubmit"},"m":[{"t":4,"f":["disabled"],"n":50,"r":"disabledButton"}],"f":[]}]}]}]}]}]}]}]};
this["ux-energy-plan-confirmation"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-energy-plan-confirmation"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 small-12 medium-offset-1"},"f":[{"t":7,"e":"ux-row","a":{"class":"left-padding"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-1 small-2 v-large-top"},"f":[{"t":7,"e":"ux-icon","a":{"class":"v-normal-right","type":"success-tick","size":"xl"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-11 small-10 v-large-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header"},"f":[{"t":2,"r":"initData.responseTitle"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top response-desc"},"f":[{"t":7,"e":"p","f":[{"t":3,"r":"initData.responseMessage"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"orderLink"}]},"f":[{"t":2,"r":"singtelEnergyConfirmation.productOrderID"}]}],"n":50,"r":"singtelEnergyConfirmation.productOrderID"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header section-title"},"f":[{"t":2,"r":"initData.nextTitle"}]}],"n":50,"r":"initData.nextTitle"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header v-normal-top"},"f":[{"t":2,"r":"subtitle"}]}],"n":50,"r":"subtitle"}," ",{"t":7,"e":"p","f":[{"t":3,"r":"message"}]}],"r":"initData.nextSections"}]}]}]}]}]}]};
this["ux-energy-plan-details"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-energy-plan-details"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-xx-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 small-12 medium-offset-1"},"f":[{"t":7,"e":"ux-row","a":{"class":"left-padding"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header"},"f":[{"t":2,"r":"initData.enterDetailsTitle"}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"body v-large-top"},"f":[{"t":2,"r":"initData.enterDetailsDesc"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-8 small-12"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-large-top v-medium-bottom"},"f":[{"t":7,"e":"ux-input-box","a":{"label_value":[{"t":2,"r":"initData.mobileNumber"}],"id":"mobileNumber","value":[{"t":2,"r":"contactData.mobileNumber"}],"name":"mobileNumber","maxLength":"8","validity":[{"t":2,"r":"mobileNumberVal.mobileNumberValErrorMsg"}],"onblurEvent":"onBlurContact"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3 small-4 id-selection"},"f":[{"t":7,"e":"label","a":{"for":"#guest-id-number-prefix","class":"input-label-bold v-small-bottom v-medium-top"},"f":[{"t":2,"r":"initData.nricText"}]}," ",{"t":7,"e":"ux-select","a":{"title":[{"t":2,"r":"initData.nricText"}],"showSelectedValue":"true","selected_value":[{"t":2,"r":"contactData.guestIdNumberPrefix"}],"options":[{"t":2,"r":"initData.options"}],"id":"guest-Number","onChangeEvent":"changedGuestId","disabled":[{"t":2,"r":"contactData.readonly"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-9 small-8 v-large-top"},"f":[{"t":7,"e":"ux-input-box","a":{"id":"guestIdNumber","value":[{"t":2,"r":"contactData.guestIdNumber"}],"onblurEvent":"onIdChange","name":"guestIdNumber","disabled":[{"t":2,"r":"contactData.readonly"}],"onInputEvent":"updateIdNumber","validity":[{"t":2,"r":"guestIdNumberErrorMsg"}]},"f":[]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"label","a":{"for":"#guest-id-type","class":"input-label-bold v-small-bottom v-normal-top"},"f":[{"t":2,"r":"initData.finTypeText"}]}," ",{"t":7,"e":"ux-select","a":{"title":[{"t":2,"r":"initData.finTypeText"}],"id":"guestIdType","showSelectedValue":"true","selected_value":[{"t":2,"r":"contactData.guestIdType"}],"options":[{"t":2,"r":"guestIdTypeOptions"}],"onChangeEvent":"onChangeGuestType","name":"guestIdType","disabled":[{"t":2,"r":"contactData.readonly"}]}}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"guestIdMessage"}]},"f":[]}],"n":50,"r":"guestIdMessage"}]}],"n":50,"x":{"r":["contactData.guestIdNumberPrefix"],"s":"_0!==\"S\"&&_0!==\"T\""}}," ",{"t":7,"e":"ux-col","a":{"class":"medium-5 small-12"},"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"initData.submitText"}],"class":["show-for-medium-up v-large-top v-normal-right round next-button small-only-expand ",{"t":4,"f":["disabled"],"n":50,"r":"disabledButton"}],"onclick":"submitDetails"},"f":[]}," ",{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"initData.submitText"}],"class":["show-for-small-only v-large-top round next-button small-only-expand ",{"t":4,"f":["disabled"],"n":50,"r":"disabledButton"}],"onclick":"submitDetails"},"f":[]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-7 v-large-top show-for-medium-up onepass-anchor"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"onePassSigninUrl"}]},"f":[{"t":2,"r":"initData.onePassSigninText"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"text-center small-12 v-normal-top show-for-small-only"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"onePassSigninUrl"}]},"f":[{"t":2,"r":"initData.onePassSigninText"}]}]}],"n":51,"r":"contactData.readonly"}]}]}]}]}]}]};
this["ux-energy-plan-failure"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-energy-plan-failure"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 small-12 medium-offset-1"},"f":[{"t":7,"e":"ux-row","a":{"class":"left-padding"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-1 small-2 v-large-top"},"f":[{"t":7,"e":"ux-icon","a":{"class":"v-normal-right","type":"cross","size":"xl"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-11 small-10 v-large-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header"},"f":[{"t":2,"r":"responseTitle"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"p","f":[{"t":3,"r":"responseMessage"}]}]}]}]}]}]}]};
this["ux-energy-plan-otp"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-energy-plan-otp"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-xx-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 small-12 medium-offset-1"},"f":[{"t":7,"e":"ux-row","a":{"class":"left-padding"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header"},"f":[{"t":2,"r":"aemData.mainHeader"}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"body v-large-top"},"f":[{"t":3,"r":"aemData.mainSubheader"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top medium-7"},"f":[{"t":4,"f":[{"t":7,"e":"ux-input-box","a":{"label_value":[{"t":3,"r":"aemData.leftlabelName"}],"id":"number","value":[{"t":2,"r":"contactData.otpNumber"}],"anchorReqd":"true","labelName":[{"t":2,"r":"aemData.rightlabelName"}],"label_onclick":"resendOTP","onInputEvent":"updateNumber","disableLink":[{"t":2,"r":"isOtpClicked"}]},"f":[]}],"n":50,"x":{"r":["flowType"],"s":"_0===\"otp\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-input-box","a":{"tooltipImage":[{"t":3,"r":"aemData.tooltipImage"}],"label_tooltip_message":[{"t":3,"r":"aemData.tooltipMessage"}],"label_value":[{"t":3,"r":"aemData.leftlabelName"}],"id":"number","value":[{"t":2,"r":"contactData.accountNumber"}],"anchorReqd":"true","labelName":[{"t":2,"r":"aemData.rightlabelName"}],"label_onclick":"routeToPage","onInputEvent":"updateNumber"},"f":[]}],"x":{"r":["flowType"],"s":"_0===\"otp\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"aemData.errorMsg"}]},"f":[]}],"n":50,"r":"invalidNumber"}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"aemData.buttonText"}],"class":"round small-only-expand","onclick":"doSubmitDetails"}}]}]}]}]}]}]};
this["ux-energy-plan-roi"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-energy-plan-roi"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-xx-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 small-12 medium-offset-1"},"f":[{"t":7,"e":"ux-row","a":{"class":"left-padding"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"header-class"},"f":[{"t":7,"e":"ux-icon","a":{"type":"cross","size":"xl"},"f":[]}," ",{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header p-normal-left space-top"},"f":[{"t":2,"r":"initData.roiErrorTitle"}]}]}],"n":50,"r":"roiError"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header"},"f":[{"t":2,"r":"initData.roiTitle"}]}],"r":"roiError"}," ",{"t":7,"e":"div","a":{"class":"body v-large-top"},"f":[{"t":2,"r":"initData.roiDesc"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-8 paddingRight"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-normal-top v-small-bottom","for":[{"t":2,"r":"nameId"}]},"f":[{"t":2,"r":"initData.roiNameTitle"}]}," ",{"t":7,"e":"ux-input-box","a":{"id":"name","value":[{"t":2,"r":"name"}],"name":"name","validity":[{"t":2,"r":"nameErrorMsg"}],"onblurEvent":"onblurContactName","onInputEvent":"onInputName"},"f":[]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-normal-top v-small-bottom","for":[{"t":2,"r":"contactNumberId"}]},"f":[{"t":2,"r":"initData.roiContactNumberTitle"}]}," ",{"t":7,"e":"ux-input-box","a":{"id":"phone","value":[{"t":2,"r":"phone"}],"name":"phone","onblurEvent":"onblurContactNumber","onInputEvent":"onInputNum","validity":[{"t":2,"r":"phoneErrorMsg"}]},"f":[]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-normal-top v-small-bottom","for":"emailId"},"f":[{"t":2,"r":"initData.roiEmailTitle"}]}," ",{"t":7,"e":"ux-input-box","a":{"id":"emailId","value":[{"t":2,"r":"emailId"}],"name":"emailId","onInputEvent":"onInputEmail","onblurEvent":"onblurEmail","validity":[{"t":2,"r":"emailIdErrorMsg"}]},"f":[]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-normal-top v-small-bottom"},"f":[{"t":2,"r":"initData.roiPostalCodeTitle"}]}," ",{"t":7,"e":"ux-input-box","a":{"id":"postalCode","value":[{"t":2,"r":"postalCode"}],"name":"postalCode","onblurEvent":"onblurePostalCode","onInputEvent":"onInputPostcode","maxLength":"6","validity":[{"t":2,"r":"postalCodeErrorMsg"}]},"f":[]}]}," ",{"t":7,"e":"ux-col","f":[]}," ",{"t":7,"e":"ux-checkbox","a":{"class":"v-normal-top","checked":[{"t":2,"r":"roiTnc"}],"labelvalue":[{"t":3,"r":"initData.roiCheckboxLabelText"}]},"f":[]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["round v-normal-top small-only-expand ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["initData.roiType","roiTnc"],"s":"_0===\"notOwner\"&&!_1"}}],"text":"Submit","role":"button","arialabel":"Submit","onclick":"doSubmit"},"f":[]}]}]}]}]}]}]};
this["ux-energy-plan-summary"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-energy-plan-summary"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-xx-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 small-12 medium-offset-1"},"f":[{"t":7,"e":"ux-row","a":{"class":"left-padding"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header"},"f":[{"t":2,"r":"initData.summaryTitle"}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-7 text-right"},"f":[{"t":3,"r":"value"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["panel-divider"],"n":50,"x":{"r":["i","summaryDetails.length"],"s":"_0<_1-1"}}]}}]}],"i":"i","r":"summaryDetails"}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"id":"style-3"},"f":[{"t":3,"x":{"r":["RactiveHelpers","initData.advisoryDetails"],"s":"_0.unescapeString(_1)"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-checkbox","a":{"checked":[{"t":2,"r":"isTncAgreed"}],"class":"left"},"f":[{"t":2,"r":"initData.tncInitalText"},{"t":7,"e":"ux-anchor","a":{"onclick":"openTerms"},"f":[{"t":2,"r":"initData.tncLinkName"}]}," ",{"t":2,"r":"initData.tncAdditionaltext"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"text":"Submit","class":["round small-only-expand ",{"t":4,"f":["disabled"],"n":51,"r":"isTncAgreed"}],"onclick":"proceedSummaryDetails"}}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"termsAndConditions"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"initData.termsAndConditionsTitle"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","f":[{"t":3,"r":"initData.termsAndConditionsDetails"}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"factSheetModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"initData.factSheetTitle"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"id":"style-4"},"f":[{"t":7,"e":"ux-iframe","a":{"src":[{"t":2,"r":"initData.factSheetUrl"}],"width":"100%"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12 small-12 v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"text-center arrowDown"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"scrollDown"},"f":[{"t":7,"e":"ux-icon","a":{"type":"arrow_down_circle","size":"l"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider marginZeroLeft marginZeroRight"}}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"text":"Proceed","class":"round right v-normal-top small-only-expand","onclick":"submitSummaryDetails"}}]}]}]}]}]}]};
this["ux-energy-service-details"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-energy-service-details"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-xx-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 small-12 medium-offset-1"},"f":[{"t":7,"e":"ux-row","a":{"class":"left-padding"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header"},"f":[{"t":2,"r":"initData.serviceDetailsTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header v-large-top v-normal-bottom"},"f":[{"t":2,"r":"initData.serviceAddressTitle"}]}]}],"n":50,"r":"initData.serviceAddressTitle"}," ",{"t":7,"e":"ux-address-form-new","a":{"addressType":"installationAddress","address":[{"t":2,"r":"serviceDetails.installationAddress"}],"addressList":[{"t":2,"r":"installationAddressList"}],"leftOneColumn":"true","hideUpdateButton":"true"},"f":[]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-checkbox","a":{"checkboxid":[{"t":2,"r":"bid"}],"checked":[{"t":2,"r":"serviceDetails.sameBilling"}],"labelvalue":[{"t":2,"r":"initData.checkboxBillingAddText"}]}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header v-large-top v-normal-bottom"},"f":[{"t":2,"r":"initData.billingAddressTitle"}]}," ",{"t":7,"e":"ux-address-form-new","a":{"addressType":"billingAddress","address":[{"t":2,"r":"serviceDetails.billingAddress"}],"addressList":[{"t":2,"r":"billingAddressList"}],"leftOneColumn":"true","hideUpdateButton":"true"}}],"n":51,"r":"serviceDetails.sameBilling"}," ",{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":7,"e":"ux-select","a":{"class":"medium left v-normal-top","id":"select-housing","name":"housing","showSelectedValue":"true","options":[{"t":2,"r":"ConfigStrings.singtelEnergy.housingDetails"}],"label_value":"Type of housing","selected_value":[{"t":2,"r":"contactData.housingDetails"}],"onChangeEvent":"onHousingChange","showToolTip":"true","onblurEvent":"onblurHousingDetails","tooltipText":[{"t":3,"r":"initData.housingDetailsTooltipText"}],"valid":[{"t":4,"f":["error"],"n":50,"r":"housingDetailsErrowMsg"}]},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"initData.errorMessages.housingDetailsErrowMsg"}]},"f":[]}],"n":50,"r":"housingDetailsErrowMsg"}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top medium-8 paddingRight showAHTooltip"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header"},"f":[{"t":2,"r":"initData.enterDetailsTitle"}]}," ",{"t":7,"e":"p","a":{"class":"v-normal-top"},"f":[{"t":2,"r":"initData.enterDetailsDesc"}]}," ",{"t":7,"e":"ux-input-box","a":{"class":"v-normal-top","tooltip_message":[{"t":3,"r":"initData.accountTooltipMessage"}],"placeholder":"1234567890","label_value":[{"t":2,"r":"initData.powerAccountNo"}],"id":"power-account-no","value":[{"t":2,"r":"contactData.accountNo"}],"validity":[{"t":2,"r":"contactData.accountNoErrorMsg"}],"onblurEvent":"onblurAccountNumber","onInputEvent":"onInputAccountNo","tooltipReqd":"true"}}," ",{"t":7,"e":"ux-checkbox","a":{"checked":[{"t":2,"r":"contactData.isOwner"}],"class":"left v-normal-top"},"f":[{"t":2,"r":"initData.ownerAccountNoText"}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-input-box","a":{"label_value":[{"t":2,"r":"initData.accountHolderNameText"}],"id":"accountHolderName","value":[{"t":2,"r":"contactData.accountHolderName"}],"validity":[{"t":2,"r":"contactData.accountHolderNameErrorMsg"}],"onblurEvent":"onblurContactName","onInputEvent":"onInputName"}}]}," ",{"t":7,"e":"label","a":{"class":"input-label-bold v-normal-top"},"f":[{"t":2,"r":"initData.preferredServiceStartDate"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-calendar","a":{"dateFormat":"DD-MM-YYYY","min_date":[{"t":2,"x":{"r":["getMinDate"],"s":"_0()"}}],"max_date":[{"t":2,"x":{"r":["getMaxDate"],"s":"_0()"}}],"selected_date":[{"t":2,"r":"contactData.startDate"}],"default_date":[{"t":2,"x":{"r":["getMinDate"],"s":"_0()"}}],"disable_weekends":"true","validity":[{"t":2,"r":"contactData.startDateErrorMsg"}],"calendar_id":"calendar_service_startdate","type":"text","theme":"singtel-energy-theme","readonly":"true"}}],"n":50,"x":{"r":["contactData.accountHolderName","contactData.accountHolderNameErrorMsg.status"],"s":"_0&&_1===\"valid\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-input-box","a":{"id":"dummybox","value":[{"t":2,"r":"contactData.dummyStartDate"}],"disabled":"true","validity":[{"t":2,"r":"contactData.startDateErrorMsg"}]}}],"x":{"r":["contactData.accountHolderName","contactData.accountHolderNameErrorMsg.status"],"s":"_0&&_1===\"valid\""}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top medium-8 paddingRight"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header"},"f":[{"t":2,"r":"initData.personalInfo.personalDetailsTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-input-box","a":{"class":"v-normal-top","label_value":[{"t":2,"r":"initData.personalInfo.fullNameTitle"}],"id":"full-name-title","value":[{"t":2,"r":"contactData.name"}],"validity":[{"t":2,"r":"contactData.nameErrorMsg"}],"onblurEvent":"onblurFullName","onInputEvent":"onInputFullName"}}],"n":50,"r":"singtelEnergyDetails.customerDetails.newcustomer"}," ",{"t":7,"e":"ux-input-box","a":{"class":"v-normal-top","label_value":"NRIC","id":"nric","value":[{"t":2,"r":"contactData.nric"}],"disabled":"true"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold v-small-bottom"},"f":[{"t":2,"r":"initData.personalInfo.dobTitle"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 dropdown"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-day","showSelectedValue":"true","class":"medium","name":"day","valid":[{"t":4,"f":["error"],"n":50,"r":"dateError"}],"selected_value":[{"t":2,"r":"contactData.day"}],"options":[{"t":2,"r":"defaultOptions.dayOptions"}]},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 dropdown"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-month","showSelectedValue":"true","class":"medium","name":"month","valid":[{"t":4,"f":["error"],"n":50,"r":"dateError"}],"selected_value":[{"t":2,"r":"contactData.month"}],"options":[{"t":2,"r":"defaultOptions.monthOptions"}]},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 dropdown"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-year","showSelectedValue":"true","class":"medium","name":"year","selected_value":[{"t":2,"r":"contactData.year"}],"options":[{"t":2,"r":"defaultOptions.yearOptions"}],"valid":[{"t":4,"f":["error"],"n":50,"r":"dateError"}]},"f":[]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"initData.errorMessages.dateError"}]},"f":[]}]}],"n":50,"r":"dateError"}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold v-small-bottom"},"f":[{"t":2,"r":"initData.personalInfo.genderTitle"}]}," ",{"t":7,"e":"ux-select","a":{"id":"select-gender","showSelectedValue":"true","class":"medium","name":"gender","selected_value":[{"t":2,"r":"contactData.gender"}],"defaultOption":"Select Gender","disabled":[{"t":2,"r":"disableGender"}],"options":[{"t":2,"r":"defaultOptions.genderOptions"}],"onChangeEvent":"onGenderChange","valid":[{"t":4,"f":["error"],"n":50,"r":"genderError"}]},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"initData.errorMessages.genderErrorMsg"}]},"f":[]}]}],"n":50,"r":"genderError"}]}],"n":50,"r":"singtelEnergyDetails.customerDetails.newcustomer"}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom","for":[{"t":2,"r":"contactNumberId"}]},"f":[{"t":2,"r":"initData.contactNumberTitle"}]}," ",{"t":7,"e":"ux-input-box","a":{"id":"contactNumberId","type":"text","placeholder":[{"t":2,"r":"contactNumberTitle"}],"value":[{"t":2,"r":"contactData.phone"}],"onblurEvent":"onblurContactNumber","onInputEvent":"onInputNum","validity":[{"t":2,"r":"contactData.phoneErrorMsg"}]},"f":[]}," ",{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom","for":"emailId"},"f":[{"t":2,"r":"initData.emailTitle"}]}," ",{"t":7,"e":"ux-input-box","a":{"id":"emailId","type":"text","placeholder":[{"t":2,"r":"emailTitle"}],"value":[{"t":2,"r":"contactData.emailId"}],"onInputEvent":"onInputEmail","onblurEvent":"onblurEmail","validity":[{"t":2,"r":"contactData.emailIdErrorMsg"}]},"f":[]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top paddingRight"},"f":[{"t":7,"e":"ux-button","a":{"text":"Submit","class":["round small-only-expand ",{"t":4,"f":["disabled"],"n":50,"r":"disabledButton"}],"onclick":"submitServiceDetails"}}]}]}]}]}]}]};
this["ux-energy-sub"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-energy-sub"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse callout-text-copy v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"ConfigStrings.genericError.productDetailsErrorMsg"}]}]}],"n":50,"x":{"r":["productDetails"],"s":"_0===\"productDetailsError\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["productDetails"],"s":"_0"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":["Plan Name"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"x":{"r":["plan.catalogItemName","planName","plan.displayName"],"s":"_0||_1||_2"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":["Contract Ends"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"x":{"r":["productFacade.recontractData.deviceContractEndDate"],"s":"_0.format(\"DD MMM YYYY\")"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":["Electricity Supply Address"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"address"}],"addressType":[{"t":2,"x":{"r":["address.addressType"],"s":"_0||\"omsProductServiceLevel\""}}]}}]}]}]}],"x":{"r":["productDetails"],"s":"_0===\"productDetailsError\""}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-replace-text","a":{"text":"Current charges for your latest bill is {CURRENT_CHARGE}.","KEY_CURRENT_CHARGE":[{"t":2,"x":{"r":["RactiveHelpers","latestCharge.amount"],"s":"_0.convertUnits(_1,\"$\")"}}]},"f":[]}]}," ",{"t":7,"e":"svg","a":{"width":"100%","height":"520","id":"energySvgContainer"},"f":[{"t":7,"e":"defs","f":[{"t":7,"e":"linearGradient","a":{"id":"grad2","x1":"0%","y1":"0%","x2":"0%","y2":"100%"},"f":[{"t":7,"e":"stop","a":{"offset":"0%","style":"stop-color:#1F96BD;stop-opacity:1"}}," ",{"t":7,"e":"stop","a":{"offset":"100%","style":"stop-color:#B8EEF5;stop-opacity:1"}}]}," ",{"t":7,"e":"filter","a":{"id":"borderShadow","x":"0","y":"0"},"f":[{"t":7,"e":"feGaussianBlur","a":{"in":"SourceGraphic","stdDeviation":"1"}}]}]}," ",{"t":7,"e":"g","a":{"class":"legends"},"f":[{"t":7,"e":"g","a":{"class":"usage-group"},"f":[{"t":7,"e":"rect","a":{"class":"usage-legend-rect","height":"10","width":"10"}}," ",{"t":7,"e":"text","a":{"x":"20","y":"8","font-size":"12px"},"f":["Current Usage"]}," ",{"t":7,"e":"text","a":{"class":"latestUsageValue","x":"120","y":"9","font-size":"12px","font-weight":"bold"}}]}," ",{"t":7,"e":"g","a":{"class":"nationalAvgGroup","transform":"translate(0, 30)"},"f":[{"t":7,"e":"line","a":{"x1":"0","y1":"0","x2":"10","y2":"0","stroke":"#DEBC68","stroke-width":"3"}}," ",{"t":7,"e":"text","a":{"class":"nationalAvgLabel","x":"20","y":"5","font-size":"12px"},"f":["National Average"]}," ",{"t":7,"e":"text","a":{"class":"nationalAvgValue","x":"120","y":"5","font-size":"12px","font-weight":"bold"}}]}," ",{"t":4,"f":[{"t":7,"e":"g","a":{"class":"readingTypeGroup","transform":"translate(0, 60)"},"f":[{"t":7,"e":"text","a":{"x":"2","y":"0","font-size":"12px"},"f":["*"]}," ",{"t":7,"e":"text","a":{"x":"20","y":"0","font-size":"12px"},"f":["Estimated Reading"]}]}],"n":50,"x":{"r":["productFacade"],"s":"_0.getParameterValueById(\"18611541\")===\"SRLP\""}}]}," ",{"t":7,"e":"g","a":{"id":"graphGroup"}}," ",{"t":7,"e":"g","a":{"id":"tooltip","style":"display:none"},"f":[{"t":7,"e":"path","a":{"d":"M0 0 L0 25 L35 25 L45 35 L55 25 L90 25 L90 0 Z","fill":"#FFFFFF","opacity":"1","stroke":"black","stroke-width":"1","filter":"url(#borderShadow)"}}," ",{"t":7,"e":"text","a":{"x":"5","opacity":"1","dy":"1.2em","font-size":"12px","font-weight":"bold"},"f":["June 280 kWh"]}]}]}]}],"n":50,"r":"showGraph"}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme manage-service-modal","modalId":"manageEnergyServiceModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"left section-header"},"f":[{"t":2,"r":"initData.manageServiceEnergy.header"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom"},"f":[{"t":2,"r":"initData.manageServiceEnergy.headerMsg"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"highlight hover-container"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":4,"f":[{"t":2,"r":"initData.changePlanEnergyLink"}],"n":50,"x":{"r":["permission.ipa","permission.blacklisted","pendingOrders.isChangePlanPending"],"s":"!(_0||_1)&&_2"}}],"target":"_blank"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header v-medium-bottom"},"f":[{"t":2,"r":"initData.changePlanEnergyText"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"body-text"},"f":[{"t":2,"r":"initData.manageService.changePlanEnergyMsg"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"highlight hover-container"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"showAutoRenew"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header v-medium-bottom"},"f":[{"t":2,"r":"initData.autoRenewEnergyText"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"body-text"},"f":[{"t":2,"r":"initData.manageService.autoRenewEnergyMsg"}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme manage-service-modal","modalId":"autoRenewSwitchModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"left section-header"},"f":[{"t":2,"r":"initData.manageServiceEnergy.autoRenewHeader"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"flex-container"},"f":[{"t":7,"e":"ux-col","a":{"class":"flex-item small-9"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header"},"f":[{"t":2,"r":"initData.manageServiceEnergy.planRenewLabel"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"flex-item small-3"},"f":[{"t":7,"e":"ux-button-switch","a":{"class":"text-right margin-zero","switchButtonType":"autoRenewInd","switchButtonValue":[{"t":2,"r":"isAutoRenewUserChoice"}],"switchButtonId":"autoRenewInd"},"f":[]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"flex-item small-9"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"initData.manageService.autoRenewEnergyMsg"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":"margin-zero round","onclick":"changeAutoRenew"},"f":["Save"]}]}]}]}],"n":53,"r":"product"}]};
this["ux-error-page"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-error-page"},"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":[{"t":2,"r":"class"}],"n":50,"r":"class"},{"t":4,"n":51,"f":["medium-10 large-6 medium-centered text-center"],"r":"class"}]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"hero-text v-normal-bottom"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"hero-text hero-subtext"},"f":[{"t":3,"r":"subTitle"}]}," ",{"t":7,"e":"div","a":{"class":"copy v-normal-top"},"f":[{"t":3,"r":"desc"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"}}," ",{"t":7,"e":"ux-anchor","a":{"class":"small-text-center","href":[{"t":2,"r":"link"}]},"f":[{"t":2,"r":"linkText"}]}]}]}]}]}]}]}],"n":50,"r":"isDataModel"}]}]};
this["ux-existing-card-singtel"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["ux-existing-card-singtel v-normal hover-container ",{"t":4,"f":["selected"],"n":50,"r":"card.selected"}]},"f":[{"t":7,"e":"div","a":{"class":"v-normal flex-container flex-container-center"},"f":[{"t":7,"e":"div","a":{"class":"flex-item p-normal-right"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"rx":{"r":"initData","m":[{"r":["getBrand","brand"],"s":"_0(_1)"},"src"]}}],"alt":[{"t":3,"rx":{"r":"initData","m":[{"r":["getBrand","brand"],"s":"_0(_1)"},"alt"]}}],"class":"full-sized"},"f":[]}]}," ",{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header margin-zero full-width"},"f":[{"t":2,"r":"firstSixDigits"},"xxxx-x",{"t":2,"r":"lastFourDigits"}]}],"n":50,"x":{"r":["brand"],"s":"_0===\"AMEX\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header margin-zero full-width"},"f":[{"t":2,"r":"firstSixDigits"},"xx-xxxx-",{"t":2,"r":"lastFourDigits"}]}],"x":{"r":["brand"],"s":"_0===\"AMEX\""}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"flex-item p-normal-left"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"removeCard"},"f":["Remove"]}]}],"n":50,"r":"card.activeCard"},{"t":4,"n":51,"f":[{"t":7,"e":"div","v":{"tap":"onCardTap"},"f":["Add"]}],"r":"card.activeCard"}]}]}],"n":53,"r":"card"}]};
this["ux-faq-singtel"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-faq-singtel"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["fixed-button ",{"t":4,"f":["show"],"n":50,"r":"enable"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"arialLabel":"Open a popup modal for FAQ","ontap":"openFaqModal"},"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":3,"r":"popupImage"}],"class":["popup-message ",{"t":4,"f":["proactiveImage bounce"],"n":50,"r":"faqPageContent.virtualAgent.enableProactiveChatInvitation"}," ",{"t":4,"f":["hide"],"n":50,"r":"hidePopUp"}," ",{"t":4,"f":["fadeout"],"n":50,"r":"fadeoutPopUp"}]}}," ",{"t":7,"e":"ux-image","a":{"img":[{"t":3,"r":"image"}]}}]}],"n":50,"r":"faqPageContent.virtualAgent.enable"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":3,"r":"popupImage"}],"class":["popup-message show-for-medium-up ",{"t":4,"f":["hide"],"n":50,"r":"hidePopUp"}]}}," ",{"t":7,"e":"ux-anchor","a":{"arialLabel":"Open a popup modal for FAQ","ontap":"openFaqModal"},"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":3,"r":"image"}]}}]}],"r":"faqPageContent.virtualAgent.enable"}]}],"n":50,"r":"enable"}],"n":53,"r":"triggerIcons"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["ux-faq no-select ",{"t":4,"f":["opened"],"n":50,"r":"enable"}," small-12 medium-5 large-3"]},"f":[{"t":7,"e":"div","a":{"class":"action-bar top"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header v-normal-left"},"f":[{"t":2,"r":"helpTitle"}]}],"n":50,"x":{"r":["state"],"s":"(_0===\"offline\")||(_0===\"help\")"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":3,"r":"imageTitle"}]}}," ",{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header v-small-left"},"f":[{"t":2,"r":"agentTitle"}]}],"x":{"r":["state"],"s":"(_0===\"offline\")||(_0===\"help\")"}}],"n":53,"r":"topSectionData"}," ",{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icons.move"}],"ontap":"doChatMove","onpanstart":"doChatMove","onpanend":"doChatMove","onpanmove":"doChatMove","class":"pan move"}}," ",{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icons.min"}],"ontap":"doChatMinimize","class":"min"}}," ",{"t":7,"e":"button","a":{"class":"close v-none-padding"},"v":{"click":"doChatClose"},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icons.close"}]}}]}]}," ",{"t":4,"f":[{"t":7,"e":"iframe","a":{"id":"ChatWindow","scrolling":"yes","class":[{"t":4,"f":["show"],"n":50,"x":{"r":["topSectionData.chat.enable","enable","topSectionData.enable"],"s":"_0&&_1&&_2"}}],"width":"100%","height":"100%","frameborder":"2","src":[{"t":2,"r":"virtualAgent.chat.iFrameUrl"},{"t":4,"f":["?we=",{"t":2,"r":"virtualAgent.proactiveChatInvitationContext"}],"n":50,"r":"virtualAgent.enableProactiveChatInvitation"}]}}],"n":51,"x":{"r":["topSectionData.closed","closed"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"top-section-text v-normal-left v-normal-right v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-2"},"f":[{"t":7,"e":"ux-image","a":{"class":"top-section-avatar-image v-medium-right","img":[{"t":3,"r":"header.img"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-9 v-default-left"},"f":[{"t":7,"e":"div","a":{"class":"top-section-description v-small-top"},"f":[{"t":4,"f":[{"t":2,"r":"header.description"}],"n":50,"r":"header.description"}," ",{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"description"}," ",{"t":7,"e":"ux-anchor","a":{"class":"text-link","ontap":"doWebChatOpen"},"f":[{"t":2,"r":"button.title"}]}],"r":"online"}],"n":50,"x":{"r":["state"],"s":"_0===\"online\""}}," ",{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"description"}],"r":"busy"}],"n":50,"x":{"r":["state"],"s":"_0===\"busy\""}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-left v-normal-right question-input"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 medium-8 large-8"},"f":[{"t":7,"e":"ux-input-box","a":{"value":[{"t":2,"r":"question"}],"placeholder":[{"t":2,"r":"questionInputPlaceholder"}],"onEnterEvent":"doChatOpen","class":"question-input"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 medium-4 large-4 ask-button"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"button round","ontap":"doChatOpen","ariaLabel":[{"t":2,"r":"askTitle"}]},"f":[{"t":2,"r":"askTitle"}]}]}]}],"n":50,"r":"header.description"}],"n":51,"x":{"r":["state"],"s":"(_0===\"offline\")||(_0===\"help\")"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"top-section-text v-normal-left v-normal-right v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"p-small strong"},"f":[{"t":2,"r":"title"}]}," ",{"t":2,"r":"description"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-left v-normal-top"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"light button round","href":[{"t":3,"r":"callBackButton.src"}],"ariaLabel":[{"t":2,"r":"callBackButton.title"}]},"f":[{"t":2,"r":"callBackButton.title"}]}]}],"n":50,"r":"enableCallback"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"callback-actions left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-7 large-7 small-12"},"f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","selected_value":[{"t":2,"r":"selectedMsisdn"}],"name":"selectedMsisdn","options":[{"t":2,"r":"msisdnList"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-5 large-5 small-12 submit-button v-normal-top-mobile"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"light button round expand-for-mobile","ontap":"submitMsisdn","ariaLabel":[{"t":2,"r":"submitButton.title"}]},"f":[{"t":2,"r":"submitButton.title"}]}]}]}],"r":"enableCallback"}],"n":53,"r":"callback"}]}],"n":50,"x":{"r":["state"],"s":"(_0===\"busy\")||(_0===\"offline\")||(_0===\"help\")"}}],"n":51,"r":"chat.enable"}],"n":53,"r":"topSectionData"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"divider v-medium-top"}}," ",{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header v-normal-left v-normal-top"},"f":[{"t":2,"r":"faqText"}]}," ",{"t":7,"e":"ux-row","a":{"class":"faq-box v-normal-left v-normal-right v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"faq-items-container"},"f":[{"t":7,"e":"ux-accordion","a":{"data":[{"t":3,"r":"."}],"class":"faq-items"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"div","a":{"class":"question-index"},"f":[{"t":2,"x":{"r":["i"],"s":"_0+1"}},"."]}," ",{"t":7,"e":"ux-anchor","a":{"class":"title-link"},"f":[{"t":2,"r":"question"}]}," ",{"t":2,"r":"./active"}," ",{"t":7,"e":"ux-content","f":[{"t":7,"e":"div","a":{"class":"ux-content-wrapper"},"f":[{"t":3,"r":"answer"}]}]}]}]}],"n":52,"i":"i","r":"data.frequentlyAskedQuestionList"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top v-normal-left view-more-link"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"text"}]}],"n":53,"r":"viewMore"}]}],"n":50,"x":{"r":["enable","frequentlyAskedQuestionList.length"],"s":"_0&&_1"}}],"n":53,"r":"faq"}]}],"n":53,"r":"faqPageContent"}]}," ",{"t":7,"e":"ux-modal","a":{"width":"575","class":"light-theme surveyModal","modalId":"surveyModal"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"section-details"},"f":[{"t":7,"e":"ux-image","a":{"class":"avatar show-for-medium-up","img":[{"t":2,"r":"img"}]}}," ",{"t":7,"e":"h2","a":{"class":"section-header"},"f":[{"t":3,"r":"header"}]}," ",{"t":7,"e":"ux-image","a":{"class":"avatar show-for-small-down","img":[{"t":2,"r":"img"}]}}," ",{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":3,"r":"description"}]}," ",{"t":7,"e":"div","a":{"class":"action-links"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"dismiss","ontap":"doSurveyDismiss","href":"#"},"f":[{"t":2,"r":"noButtonLabel"}]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"doSurveyAccess","url":[{"t":2,"r":"surveyUrl"}],"ariaLabel":[{"t":2,"r":"yesButtonAriaLabel"}],"target":"_blank"},"f":[{"t":2,"r":"yesButtonLabel"}]}]}]}],"n":53,"r":"surveyData"}]}],"n":50,"r":"showChat"}]};
this["ux-faq-support"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-faq-support"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header v-normal-left v-normal-top"},"f":[{"t":2,"r":"heading"}]}]}]}],"n":50,"r":"heading"}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-left"},"f":[{"t":7,"e":"ux-accordion","a":{"data":[{"t":3,"r":"."}],"class":"faq-items","viewMore":[{"t":2,"r":"viewMore"}],"firstList":[{"t":2,"r":"firstList"}],"secondList":[{"t":2,"r":"secondList"}]},"f":[" ",{"t":4,"n":53,"f":[{"t":8,"r":"faqListView"}],"x":{"r":["firstList"],"s":"{faqList:_0,initialNumber:0,visible:true}"}}," ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"faqListView"}],"x":{"r":["secondList","firstList.length","viewMore"],"s":"{faqList:_0,initialNumber:_1,visible:_2}"}}," ",{"t":7,"e":"ux-row","a":{"class":"view-more"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"viewMore"},"f":[{"t":2,"r":"data.viewMoreLabel"}]}],"n":51,"r":"viewMore"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"viewLess"},"f":[{"t":2,"r":"data.viewLessLabel"}]}],"r":"viewMore"}]}],"n":50,"r":"data.enabledViewMore"}],"p":{"faqListView":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["hide"],"n":51,"r":"visible"}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"div","a":{"class":"question-index v-small-left"},"f":[{"t":2,"x":{"r":["i","initialNumber"],"s":"_0+1+_1"}},"."]}," ",{"t":7,"e":"ux-anchor","a":{"class":"faq-que-link p-large-left"},"f":[{"t":2,"r":"title"}]}," ",{"t":2,"r":"./active"}," ",{"t":7,"e":"ux-content","a":{"class":"faq-ans-desc p-none-left"},"f":[{"t":7,"e":"div","a":{"class":"ux-content-wrapper faq-ans-desc-padding p-large-left"},"f":[{"t":3,"r":"description"}]}]}]}]}],"n":52,"i":"i","r":"faqList"}]}}]}]}]}]};
this["ux-fibre-coverage-check"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-fibre-coverage-check ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"div","a":{"class":"v-large-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"check-address"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"ux-address-form","a":{"address":[{"t":2,"r":"address"}],"addressList":[{"t":2,"r":"addressList"}],"hideUpdateButton":"true","equalSpacing":"true"},"f":[]}," ",{"t":7,"e":"ux-button","a":{"class":["round small-only-expand check-fibre-availability v-normal-top ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["enableFibreAvaibility","enableFibreCheck"],"s":"_0&&_1"}}],"onclick":"checkFibreAvailability","text":"Check Fibre Availability"},"f":[]}]}]}],"n":50,"r":"showCheckAddressForm"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"check-address"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12"},"f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header v-small-bottom","level":"3"},"f":[{"t":2,"r":"checkCoverage.success.title"}]}," ",{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"address"}],"addressType":[{"t":2,"r":"addressType"}]},"f":[]}]}," ",{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"resetFormAddress"},"f":[{"t":2,"r":"checkCoverage.anotherAddressTitle"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top check-result-message"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"3"},"f":[{"t":2,"r":"checkCoverage.noteLabel"}]}," ",{"t":7,"e":"ul","a":{"class":"note-text"},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"note-text"},"f":[{"t":2,"r":"."}]}],"r":"checkCoverage.success.note"}]}]}]}],"n":50,"x":{"r":["networkCoverageTopic.result.status"],"s":"_0===\"success\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"check-address"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12"},"f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header v-small-bottom","level":"3"},"f":[{"t":2,"r":"checkCoverage.fail.title"}]}," ",{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"address"}],"addressType":[{"t":2,"r":"addressType"}]},"f":[]}," ",{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"resetFormAddress"},"f":[{"t":2,"r":"checkCoverage.anotherAddressTitle"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top check-result-message"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header v-normal-top","level":"3"},"f":[{"t":2,"r":"webChatFailTitle"}]}," ",{"t":7,"e":"div","a":{"class":"top-spacing"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-7 large-8"},"f":[{"t":2,"r":"webChatAgentDesc"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-5 large-4"},"f":[{"t":7,"e":"ux-button","a":{"class":"round small-only-expand","text":"Web Chat","role":"button","onclick":"showWebChat","arialabel":"Web Chat"}}]}]}," ",{"t":7,"e":"div","a":{"class":"top-spacing"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-7 large-8"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"initData.eShopErrorModel.eShopStartErrorMsg"}," ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"initData.eShopErrorModel.eShopFormLinkUrl"}],"target":"_blank"},"f":[{"t":3,"r":"initData.eShopErrorModel.eShopFormLinkText"}]}," ",{"t":2,"r":"initData.eShopErrorModel.eShopEndErrorMsg"}]}]}]}],"n":53,"r":"checkCoverage.fail"}],"n":50,"x":{"r":["networkCoverageTopic.result.failType"],"s":"_0===\"webChat\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["networkCoverageTopic.result.failType"],"s":"_0===\"Telesales\""},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-normal-top","level":"3"},"f":[{"t":2,"r":"webChatFailTitle"}]}," ",{"t":7,"e":"div","a":{"class":"top-spacing"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-7 large-8"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"initData.eShopErrorModel.eShopStartErrorMsg"}," ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"initData.eShopErrorModel.eShopFormLinkUrl"}],"target":"_blank"},"f":[{"t":3,"r":"initData.eShopErrorModel.eShopFormLinkText"}]}," ",{"t":2,"r":"initData.eShopErrorModel.eShopEndErrorMsg"}]}]}]}],"n":53,"r":"checkCoverage.fail"}]},{"t":4,"n":50,"x":{"r":["networkCoverageTopic.result.failType"],"s":"(!(_0===\"Telesales\"))&&(_0===\"retailShop\")"},"f":[" ",{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"r":"retailShopDesc"}]}],"n":53,"r":"checkCoverage.fail"}]},{"t":4,"n":50,"x":{"r":["networkCoverageTopic.result.failType"],"s":"(!(_0===\"Telesales\"))&&((!(_0===\"retailShop\"))&&(_0===\"contactNLT\"))"},"f":[" ",{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"r":"contactNLTDesc"}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"contactNLT"},"f":[{"t":2,"r":"netLinkTrustLabel"}]}," ",{"t":2,"r":"furtherAssistance"}]}],"n":53,"r":"checkCoverage.fail"}]},{"t":4,"n":50,"x":{"r":["networkCoverageTopic.result.failType"],"s":"(!(_0===\"Telesales\"))&&((!(_0===\"retailShop\"))&&(!(_0===\"contactNLT\")))"},"f":[" ",{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"r":"failureMessage"}]}],"n":53,"r":"checkCoverage.fail"}]}],"x":{"r":["networkCoverageTopic.result.failType"],"s":"_0===\"webChat\""}}]}]}]}],"n":50,"x":{"r":["networkCoverageTopic.result.status"],"s":"_0===\"fail\""}}]}]}]};
this["ux-fibre-installation"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-fibre-installation"},"f":[{"t":7,"e":"div","a":{"class":"dwfm-iframe-container"}}]}]};
this["ux-file-upload"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-file-upload ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"form","a":{"action":"/upload","method":"post","enctype":"multipart/form-data"},"f":[{"t":7,"e":"div","a":{"class":["file-upload button light round v-small-top small-only-expand ",{"t":2,"r":"buttonClass"}," ",{"t":2,"r":"disableUpload"}]},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"buttonLabel"}]}," ",{"t":7,"e":"input","a":{"type":"file","name":"file","id":[{"t":2,"r":"id"}],"class":["upload ",{"t":2,"r":"uploadClass"}],"accept":[{"t":2,"r":"acceptedFileTypes"}]},"m":[{"t":2,"r":"disableUpload"}]}]}]}]}]};
this["ux-filter-lable"] = {"v":3,"t":[{"t":7,"e":"span","a":{"class":"filter-label","id":"filter"},"f":[{"t":7,"e":"span","a":{"class":"filter-value"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"span","a":{"class":"close-filter-label"},"v":{"tap":{"n":"doClose","d":[{"t":2,"r":"content"}]}},"f":[{"t":7,"e":"ux-icon","a":{"type":"close","size":"xs","class":"icon-blue"}}]}]}]};
this["ux-filter-modal-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-filter-modal"},"f":[{"t":7,"e":"ux-modal","a":{"modalId":"filterList","class":"modal-size light-theme"},"f":[{"t":7,"e":"div","t1":{"n":"fly","a":[{"x":-200,"y":0,"duration":400}]},"t2":{"n":"fly","a":[{"x":-200,"y":0,"duration":400}]},"f":[{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-left v-medium-top"},"f":[{"t":7,"e":"ux-icon","a":{"type":"filter-icon","class":"icon-blue"},"f":[]}," ",{"t":7,"e":"span","a":{"class":"main-header"},"f":["Filter"]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":7,"e":"div","a":{"class":"close-filter-modal"},"v":{"tap":"doCloseFilterModal"},"f":[{"t":7,"e":"ux-icon","a":{"type":"close-line","class":"icon-blue"}}]}]}]}]}," ",{"t":7,"e":"ux-accordion","a":{"initData":[{"t":2,"r":"initData"}],"isIppTermsEnabled":[{"t":2,"r":"isIppTermsEnabled"}],"minValue":[{"t":2,"r":"minValue"}],"maxValue":[{"t":2,"r":"maxValue"}],"id":"price","minInputClicked":[{"t":2,"r":"minInputClicked"}],"maxInputClicked":[{"t":2,"r":"maxInputClicked"}],"validationFailed":[{"t":2,"r":"validationFailed"}]},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-accordionitem","a":{"id":"price","changeAccordion":["changeAccordion:",{"t":2,"x":{"r":[],"s":"\"price\""}}]},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":"v-medium-left v-medium-top body-copy-text"},"f":["Price"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":"v-medium-top p-medium-right"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":"v-medium-top p-medium-right"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":7,"e":"div","a":{"class":"input-container","id":"price"},"f":[{"t":7,"e":"span","a":{"class":"min-heading"},"f":["Min"]}," ",{"t":7,"e":"span","a":{"class":"max-heading"},"f":["Max"]}," ",{"t":7,"e":"div","a":{"class":["input-block ",{"t":4,"f":["focus-input"],"n":50,"r":"minInputClicked"}," ",{"t":4,"f":["validate-failed"],"n":50,"r":"validationFailed"}]},"f":[{"t":7,"e":"ux-input-box","a":{"id":"min-price","validity":"Incorrect","onblurEvent":"validatePrice","label_value":"$","onFocusEvent":"minInputClicked","type":"number"},"f":[]}]}," ",{"t":7,"e":"span","a":{"class":"separator"},"f":["to"]}," ",{"t":7,"e":"div","a":{"class":["input-block ",{"t":4,"f":["focus-input"],"n":50,"r":"maxInputClicked"}]},"f":[{"t":7,"e":"ux-input-box","a":{"id":"max-price","validity":"Incorrect","onblurEvent":"validatePrice","label_value":"$","onFocusEvent":"maxInputClicked","type":"number"},"f":[]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price-error"},"f":["Max price should be greater than Min price."]}],"n":50,"r":"validationFailed"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-accordionitem","a":{"id":"categories","changeAccordion":["changeAccordion:",{"t":2,"x":{"r":[],"s":"\"categories\""}}]},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":"v-medium-left v-medium-top body-copy-text"},"f":["Categories"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":"v-medium-top p-medium-right"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":"v-medium-top p-medium-right"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top body-copy-text"},"f":[{"t":7,"e":"ux-checkbox","a":{"class":"full-width-link","onChangeEvent":"onCategorySelected","labelvalue":[{"t":2,"r":"text"}],"checkboxvalue":[{"t":2,"r":"value"}],"id":["categories",{"t":2,"r":"i"}]},"f":[]}]}],"i":"i","r":"initData.deals"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-accordionitem","a":{"id":"deals","changeAccordion":["changeAccordion:",{"t":2,"x":{"r":[],"s":"\"deals\""}}]},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":"v-medium-left v-medium-top body-copy-text"},"f":["Deals"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":"v-medium-top p-medium-right"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":"v-medium-top p-medium-right"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item","id":"dealsContent"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top body-copy-text","id":"deals"},"f":[{"t":7,"e":"ux-checkbox","a":{"class":"full-width-link","onChangeEvent":"onDealSelected","labelvalue":[{"t":2,"r":"text"}],"checkboxvalue":[{"t":2,"r":"value"}],"id":["deals",{"t":2,"r":"i"}]},"f":[]}]}],"i":"i","r":"initData.promoDeals"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-accordionitem","a":{"id":"brands","changeAccordion":"changeAccordion"},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":"v-medium-left v-medium-top body-copy-text"},"f":["Brands"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":"v-medium-top p-medium-right"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":"v-medium-top p-medium-right"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top body-copy-text","id":"brands"},"f":[{"t":7,"e":"ux-checkbox","a":{"class":"full-width-link","onChangeEvent":"onBrandSelected","labelvalue":[{"t":2,"r":"text"}],"checkboxvalue":[{"t":2,"r":"value"}],"id":["brands",{"t":2,"r":"i"}]},"f":[]}]}],"i":"i","r":"initData.brands"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":4,"f":[{"t":7,"e":"ux-accordionitem","a":{"id":"paymentMethod","onClick":"paymentSelcted","changeAccordion":"changeAccordion:'paymentMethodAccordionItem'"},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":" v-medium-left v-medium-top body-copy-text"},"f":["Payment Method"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":"v-medium-top p-medium-right"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":"v-medium-top p-medium-right"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item","id":"paymentMethodContent"},"f":[{"t":7,"e":"div","a":{"class":"v-medium-top body-copy-text","id":"paymentMethod"},"f":[{"t":7,"e":"ux-checkbox","a":{"class":"full-width-link","onChangeEvent":"onPaymentMethodSelected","labelvalue":"Singtel PayLater - 0% interest instalment payment plans","id":"paymentMethod"},"f":[]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"r":"isIppTermsEnabled"}]}]}," ",{"t":7,"e":"div","a":{"class":"apply-button-container"},"f":[{"t":7,"e":"ux-row","a":{"class":"small-12 text-center button-size p-normal-left"},"f":[{"t":7,"e":"ux-button","a":{"class":"v-normal-top ux-button button round ux-button--light ","onclick":"doApplyFilter"},"f":["Apply"]}]}," ",{"t":7,"e":"ux-row","a":{"class":"medium-2 small-12 text-center v-medium-bottom clear-button"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"doFilterClear"},"f":["Clear"]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-accordion","a":{"initData":[{"t":2,"r":"initData"}],"minValue":[{"t":2,"r":"minValue"}],"isIppTermsEnabled":[{"t":2,"r":"isIppTermsEnabled"}],"maxValue":[{"t":2,"r":"maxValue"}],"id":"price","minInputClicked":[{"t":2,"r":"minInputClicked"}],"isIppEnabled":[{"t":2,"r":"isIppEnabled"}],"maxInputClicked":[{"t":2,"r":"maxInputClicked"}],"validationFailed":[{"t":2,"r":"validationFailed"}]},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-accordionitem","a":{"id":"price","changeAccordion":["changeAccordion:",{"t":2,"x":{"r":[],"s":"\"price\""}}]},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":"v-medium-left v-medium-top body-copy-text"},"f":["Price"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right p-medium-right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":"icon-blue"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":"icon-blue"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item p-medium-left"},"f":[{"t":7,"e":"div","a":{"class":"input-container"},"f":[{"t":7,"e":"span","a":{"class":"min-heading"},"f":["Min"]}," ",{"t":7,"e":"span","a":{"class":"max-heading"},"f":["Max"]}," ",{"t":7,"e":"span","a":{"class":["filter-input-box ",{"t":4,"f":["focus-input"],"n":50,"r":"minInputClicked"}," ",{"t":4,"f":["validate-failed"],"n":50,"r":"validationFailed"}]},"f":[{"t":7,"e":"ux-input-box","a":{"id":"min-price","validity":"Incorrect","onblurEvent":"validatePrice","prefix":"$","onFocusEvent":"minInputClicked","type":"number"},"f":[]}]}," ",{"t":7,"e":"span","a":{"class":"separator"},"f":["to"]}," ",{"t":7,"e":"span","a":{"class":["filter-input-box ",{"t":4,"f":["focus-input"],"n":50,"r":"maxInputClicked"}]},"f":[{"t":7,"e":"ux-input-box","a":{"id":"max-price","validity":"Incorrect","onblurEvent":"validatePrice","prefix":"$","onFocusEvent":"maxInputClicked","type":"number"},"f":[]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price-error"},"f":["Max price should be greater than Min price."]}],"n":50,"r":"validationFailed"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-accordionitem","a":{"id":"categories","changeAccordion":["changeAccordion:",{"t":2,"x":{"r":[],"s":"\"categories\""}}]},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":" v-medium-left v-medium-top body-copy-text"},"f":["Categories"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right p-medium-right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":"icon-blue"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":"icon-blue"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item p-medium-left"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top body-copy-text p-normal-bottom"},"f":[{"t":7,"e":"ux-checkbox","a":{"class":"full-width-link","onChangeEvent":"onCategorySelected","checkboxClicked":"onCategorySelected","labelvalue":[{"t":2,"r":"text"}],"checkboxvalue":[{"t":2,"r":"value"}],"id":["categories",{"t":2,"r":"i"}]},"f":[]}]}],"i":"i","r":"initData.deals"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-accordionitem","a":{"id":"deals","changeAccordion":["changeAccordion:",{"t":2,"x":{"r":[],"s":"\"deals\""}}]},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":" v-medium-left v-medium-top body-copy-text"},"f":["Deals"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right p-medium-right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":"icon-blue"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":"icon-blue"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item p-medium-left"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top body-copy-text p-normal-bottom","id":"deals"},"f":[{"t":7,"e":"ux-checkbox","a":{"class":"full-width-link","onChangeEvent":"onDealSelected","checkboxClicked":"onDealSelected","labelvalue":[{"t":2,"r":"text"}],"checkboxvalue":[{"t":2,"r":"value"}],"id":["deals",{"t":2,"r":"i"}]},"f":[]}]}],"i":"i","r":"initData.promoDeals"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-accordionitem","a":{"id":"brands","changeAccordion":"changeAccordion"},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":" v-medium-left v-medium-top body-copy-text"},"f":["Brands"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right p-medium-right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":"icon-blue"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":"icon-blue"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item p-medium-left"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top body-copy-text p-normal-bottom","id":"brands"},"f":[{"t":7,"e":"ux-checkbox","a":{"class":"full-width-link","onChangeEvent":"onBrandSelected","checkboxClicked":"onBrandSelected","labelvalue":[{"t":2,"r":"text"}],"checkboxvalue":[{"t":2,"r":"value"}],"id":["brands",{"t":2,"r":"i"}]},"f":[]}]}],"i":"i","r":"initData.brands"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":4,"f":[{"t":7,"e":"ux-accordionitem","a":{"id":"paymentMethod","onClick":"paymentSelcted","changeAccordion":"changeAccordion:'paymentMethodAccordionItem'"},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":"  v-medium-left v-medium-top body-copy-text"},"f":["Payment Method"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right p-medium-right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":"icon-blue"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":"icon-blue"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item p-medium-left","id":"paymentMethodContent"},"f":[{"t":7,"e":"div","a":{"class":"v-medium-top body-copy-text p-normal-bottom","id":"paymentMethod"},"f":[{"t":7,"e":"ux-checkbox","a":{"class":"full-width-link","onChangeEvent":"onPaymentMethodSelected","checkboxClicked":"onPaymentMethodSelected","checked":[{"t":2,"r":"isIppEnabled"}],"labelvalue":"Singtel PayLater - 0% interest instalment payment plans","id":"paymentMethod"},"f":[]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"r":"isIppTermsEnabled"}]}," ",{"t":7,"e":"ux-row","a":{"class":"medium-2 small-12 text-left v-medium-bottom v-medium-left clear-button"},"f":[{"t":7,"e":"ux-anchor","a":{"onclick":"doFilterClear"},"f":["Clear"]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"ux-filter-modal"},"f":[{"t":7,"e":"ux-modal","a":{"modalId":"sortList","class":"modal-size light-theme"},"f":[{"t":7,"e":"div","t1":{"n":"fly","a":[{"x":-200,"y":0,"duration":400}]},"t2":{"n":"fly","a":[{"x":-200,"y":0,"duration":400}]},"f":[{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-left v-medium-top"},"f":[{"t":7,"e":"ux-icon","a":{"type":"sortby-icon","class":"icon-blue"},"f":[]}," ",{"t":7,"e":"span","a":{"class":"main-header"},"f":["Sort by"]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":7,"e":"div","a":{"class":"close-filter-modal"},"v":{"tap":"doCloseSortModal"},"f":[{"t":7,"e":"ux-icon","a":{"type":"close-line","class":"icon-blue"}}]}]}]}]}," ",{"t":7,"e":"ux-accordion","a":{"initData":[{"t":2,"r":"initData"}]},"f":[{"t":7,"e":"div","a":{"class":"panel-divider v-medium-left v-medium-right"}}," ",{"t":7,"e":"ux-accordionitem","a":{"class":"active","id":"sortBy","changeAccordion":["changeAccordion:",{"t":2,"x":{"r":[],"s":"\"sortBy\""}}]},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":" v-medium-left v-medium-top section-header"},"f":["Categories"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"right p-medium-right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":"icon-blue"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":"icon-blue"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item active"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top body-copy-text","id":"sortByList"},"f":[{"t":7,"e":"ux-checkbox","a":{"class":"full-width-link","onChangeEvent":"onSortSelected","labelvalue":[{"t":2,"r":"text"}],"checkboxvalue":[{"t":2,"r":"value"}],"id":["sortBy",{"t":2,"r":"i"}]},"f":[]}]}],"i":"i","r":"initData.sortByList"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]}," ",{"t":7,"e":"div","a":{"class":"apply-button-container"},"f":[{"t":7,"e":"ux-row","a":{"class":"small-12 text-center button-size p-normal-left"},"f":[{"t":7,"e":"ux-button","a":{"class":"v-normal-top ux-button button round ux-button--light ","onclick":"doApplyFilter"},"f":["Apply"]}]}," ",{"t":7,"e":"ux-row","a":{"class":"medium-2 small-12 text-center v-medium-bottom clear-button"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"doSortClear"},"f":["Clear"]}]}]}]}]}]}]}]};
this["ux-footer-links"] = {"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"ux-footer-links"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"show-for-medium-up"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-wrapper"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"subsection-header","href":[{"t":3,"r":"heading.src"}]},"f":[{"t":2,"r":"heading.title"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["footer-link ",{"t":4,"f":["v-medium-bottom"],"n":50,"x":{"r":["children.length","i"],"s":"_0-1!==_1"}}]},"f":[{"t":7,"e":"ux-anchor","a":{"class":"body-light","href":[{"t":2,"r":"src"}]},"f":[{"t":2,"r":"title"}]}]}],"i":"i","r":"children"}]}],"r":"footer.items"}]}," "],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-footer-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-footer-singtel"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":["v-large-bottom v-large-top-mobile v-normal-bottom-mobile ",{"t":4,"f":["template-bg-grey full-width-footer"],"n":50,"x":{"r":["isFullWidth"],"s":"_0===true"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"footer-divider v-large-top v-normal-bottom"}}]}],"n":51,"x":{"r":["isFullWidth"],"s":"_0===true"}}," ",{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":7,"e":"ul","a":{"class":"inline-list margin-zero"},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"v-large-bottom-mobile"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"subscript-text","href":[{"t":2,"r":"link"}]},"f":[{"t":3,"r":"text"}]}]}],"r":"links"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":" medium-4"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up right copyright-holder"},"f":[{"t":7,"e":"div","a":{"class":"fine-print-text"},"f":[{"t":3,"r":"copyrightText"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only text-center copyright-holder"},"f":[{"t":7,"e":"div","a":{"class":"subscript-text"},"f":[{"t":3,"r":"copyrightText"}]}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-form-validity"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"role":"alert","class":["ux-form-validity ",{"t":2,"r":"status"}]},"f":[{"t":7,"e":"div","a":{"class":["validity-msg strong ",{"t":2,"r":"validityMsgClass"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"class":"icon","type":"exclamation","size":"xs"}}],"n":50,"x":{"r":["status"],"s":"_0===\"error\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-icon","a":{"class":"icon","type":"success-inverse","size":"xs"}}],"x":{"r":["status"],"s":"_0===\"error\""}}," ",{"t":4,"f":[{"t":8,"r":"content"}],"n":50,"r":"showContent"},{"t":4,"n":51,"f":[{"t":3,"r":"message"}],"r":"showContent"}]}]}],"n":50,"r":"message"}]};
this["ux-formbuilder-form"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-formbuilder-form"},"f":[{"t":4,"f":[{"t":7,"e":"ux-load-mask"}],"n":50,"r":"loading"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["displayForm"],"s":"_0"},"f":[{"t":7,"e":"form","a":{"action":[{"t":2,"r":"action"}],"method":[{"t":2,"r":"method"}],"name":[{"t":2,"r":"formName"}],"id":[{"t":2,"r":"formName"}],"novalidate":0},"v":{"submit":"submitForm"},"f":[" ",{"t":4,"f":[{"t":7,"e":"ux-formbuilder-input-box","a":{"id":"compPathId","name":"compPathName","type":"hidden","value":[{"t":2,"r":"compPath"}]}}],"n":50,"r":"compPath"}," ",{"t":8,"r":"content"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"message":[{"t":2,"r":"formErrorMsg.message"}],"status":[{"t":2,"r":"formErrorMsg.status"}]}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":"round","type":"submit","text":[{"t":2,"r":"submitButtonText"}]}}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"g-recaptcha","data-sitekey":[{"t":2,"r":"gReCaptchaSiteKey"}],"data-callback":"onRecaptchaSubmit","data-size":"invisible"}}],"n":50,"r":"gReCaptchaSiteKey"}]}]}],"r":"loading"}]}]};
this["ux-formbuilder-input-box"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-formbuilder-input-box ",{"t":2,"r":"type"}]},"f":[{"t":7,"e":"label","a":{"for":[{"t":2,"r":"name"}]},"f":[" ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"field-label"},"f":[{"t":2,"r":"label"}]}],"n":50,"r":"label"}," ",{"t":7,"e":"div","a":{"class":"input-wrapper"},"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"r":"id"}],"name":[{"t":2,"r":"name"}],"value":[{"t":2,"r":"value"}],"placeholder":[{"t":2,"r":"placeholder"}],"type":[{"t":2,"r":"type"}],"validation":[{"t":2,"r":"validation"}],"class":[{"t":2,"r":"valueErrorMsg.status"}],"disabled":[{"t":2,"r":"disabled"}]},"v":{"blur":"formBuilderValidation"}}," ",{"t":4,"f":[{"t":7,"e":"button","a":{"type":"button","class":"toggle-password-visibility"},"v":{"click":"togglePasswordVisibility"},"f":[{"t":7,"e":"img","a":{"src":"/etc/designs/springd/clientlibs/osg/assets/images/eye-solid.svg","class":"show-icon","width":"20px","height":"20px"}}," ",{"t":7,"e":"img","a":{"src":"/etc/designs/springd/clientlibs/osg/assets/images/eye-slash-solid.svg","class":"hide-icon hide","width":"20px","height":"20px"}}]}],"n":50,"x":{"r":["type"],"s":"_0===\"password\""}}]}," ",{"t":7,"e":"ux-form-validity","a":{"message":[{"t":2,"r":"valueErrorMsg.message"}],"status":[{"t":2,"r":"valueErrorMsg.status"}]}}]}]}]};
this["ux-formbuilder-input-checkbox"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-formbuilder-input-checkbox ",{"t":2,"r":"layout"}]},"f":[{"t":7,"e":"label","a":{"class":"field-label"},"f":[{"t":2,"r":"label"}]}," ",{"t":4,"f":[{"t":7,"e":"input","m":[{"t":4,"f":["name=\"",{"t":2,"r":"name"},"\""],"n":53,"r":"~/name"},{"t":4,"f":["validation=\"",{"t":2,"r":"validation"},"\""],"n":53,"r":"~/validation"},{"t":4,"f":["checked"],"n":50,"r":"selected"}],"a":{"type":"checkbox","class":"css-checkbox","id":[{"t":2,"r":"id"}],"value":[{"t":2,"r":"value"}],"selected":[{"t":2,"r":"selected"}]},"v":{"click":"blurHandler"}}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"id"}],"class":"css-label"},"f":[{"t":3,"r":"label"}]}],"n":52,"r":"item"}," ",{"t":7,"e":"ux-form-validity","a":{"message":[{"t":2,"r":"valueErrorMsg.message"}],"status":[{"t":2,"r":"valueErrorMsg.status"}]}}]}]};
this["ux-formbuilder-input-dropdown"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-formbuilder-input-dropdown"},"f":[{"t":7,"e":"label","a":{"for":[{"t":2,"r":"id"}]},"f":[{"t":2,"r":"label"}]}," ",{"t":7,"e":"span","a":{"class":["select ",{"t":2,"r":"valueErrorMsg.status"}]},"f":[{"t":7,"e":"span","a":{"class":"icon icon-arrow-down"}}," ",{"t":7,"e":"span","a":{"class":["select-value ",{"t":2,"r":"selectedClass"}]},"f":[{"t":2,"r":"selectedTitle"}]}," ",{"t":7,"e":"select","a":{"id":[{"t":2,"r":"id"}],"name":[{"t":2,"r":"name"}],"value":[{"t":2,"r":"selected_value"}]},"v":{"change":"onChange","blur":"blurHandler"},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":"value"}],"selected":[{"t":2,"r":"selected"}]},"f":[{"t":2,"r":"title"}]}],"r":"options"}]}]}," ",{"t":7,"e":"ux-form-validity","a":{"message":[{"t":2,"r":"valueErrorMsg.message"}],"status":[{"t":2,"r":"valueErrorMsg.status"}]}}]}]};
this["ux-formbuilder-input-promo"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-formbuilder-input-promo"},"f":[{"t":7,"e":"label","a":{"for":[{"t":2,"r":"name"}]},"f":[" ",{"t":4,"f":[{"t":7,"e":"label","a":{"class":"field-label"},"f":[{"t":2,"r":"label"}]}],"n":50,"r":"label"}," ",{"t":7,"e":"input","a":{"id":[{"t":2,"r":"id"}],"name":[{"t":2,"r":"name"}],"value":[{"t":2,"r":"value"}],"placeholder":[{"t":2,"r":"placeholder"}],"type":"text","class":[{"t":2,"r":"valueErrorMsg.status"}],"validation":[{"t":2,"r":"validation"}]},"v":{"blur":"onBlurHandler"}}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"promo-text"},"f":[{"t":2,"r":"defaultMsg"}]}],"n":50,"r":"defaultMsg"}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"promocode-backtext","id":"promocode-backtext","value":[{"t":2,"r":"backText"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"promocode-fronttext","id":"promocode-fronttext","value":[{"t":2,"r":"frontText"}]}}," ",{"t":7,"e":"ux-form-validity","a":{"message":[{"t":2,"r":"valueErrorMsg.message"}],"status":[{"t":2,"r":"valueErrorMsg.status"}]}}]}]}]};
this["ux-formbuilder-input-radio"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-formbuilder-input-radio ",{"t":2,"r":"layout"}]},"f":[{"t":7,"e":"label","f":[{"t":2,"r":"label"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"item-wrapper"},"f":[{"t":7,"e":"input","a":{"type":"radio","id":[{"t":2,"r":"id"}],"value":[{"t":2,"r":"value"}]},"m":[{"t":4,"f":["name=\"",{"t":2,"r":"name"},"\""],"n":53,"r":"~/name"},{"t":4,"f":["checked"],"n":50,"r":"selected"}],"v":{"blur":"blurHandler","click":"blurHandler"}}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"id"}]},"f":[{"t":3,"r":"label"}]}]}],"n":52,"r":"item"}," ",{"t":7,"e":"ux-form-validity","a":{"message":[{"t":2,"r":"valueErrorMsg.message"}],"status":[{"t":2,"r":"valueErrorMsg.status"}]}}]}]};
this["ux-formbuilder-input-textarea"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-formbuilder-input-textarea"},"f":[" ",{"t":4,"f":[{"t":7,"e":"label","a":{"class":"field-label"},"f":[{"t":2,"r":"label"}]}],"n":50,"r":"label"}," ",{"t":7,"e":"textarea","a":{"id":[{"t":2,"r":"id"}],"name":[{"t":2,"r":"name"}],"rows":[{"t":2,"r":"rows"}],"maxlength":[{"t":2,"r":"maxlength"}],"validation":[{"t":2,"r":"validation"}],"placeholder":[{"t":2,"r":"placeholder"}],"value":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"valueErrorMsg.status"}]},"v":{"blur":"blurHandler"}}," ",{"t":7,"e":"ux-form-validity","a":{"message":[{"t":2,"r":"valueErrorMsg.message"}],"status":[{"t":2,"r":"valueErrorMsg.status"}]}}]}]};
this["ux-formbuilder-panel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-formbuilder-panel"},"f":[{"t":8,"r":"content"}]}]};
this["ux-formbuilder-parameters"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-formbuilder-parameters"},"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"r":"id"}],"name":[{"t":2,"r":"name"}],"value":[{"t":2,"r":"value"}],"type":"hidden"}}]}]};
this["ux-formbuilder-upload-document"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-formbuilder-upload-document"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"upload-label field-label"},"f":[{"t":3,"r":"label"}]}],"n":50,"r":"label"}," ",{"t":7,"e":"div","a":{"class":["document-list ",{"t":4,"f":["hide"],"n":50,"r":"hideImgPath"}," v-medium-top"]},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"ignoreLeft"},"f":[{"t":7,"e":"div","a":{"class":"uploaded-items"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-9 medium-4 file-name"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"item small-text-center medium-text-left large-text-left wraptext","ontap":["showUploadedImage:",{"t":2,"r":"./fileId"}]},"f":[{"t":2,"r":"./fileName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 medium-7 file-name"},"f":[{"t":7,"e":"ux-anchor","a":{"index":[{"t":2,"r":"i"}],"class":"v-medium-left","ontap":["removeUploadedImage:",{"t":2,"r":"./fileId"}]},"f":[{"t":2,"r":"removeLabel"}]}]}]}]}],"n":52,"i":"i","r":"uploadedFileList"}]}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"id"}]},"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-file-upload","a":{"buttonLabel":[{"t":2,"r":"buttonLabel"}],"uploadId":[{"t":2,"r":"id"}],"uploadClass":[{"t":2,"r":"id"}]},"m":[{"t":2,"r":"disableUpload"}]}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"message":[{"t":2,"r":"fileTypesError"}],"status":"error"},"f":[]}],"n":50,"r":"isFileInValid"}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"message":[{"t":2,"r":"fileSizeError"}],"status":"error"},"f":[]}],"n":50,"r":"isMaxFileSizeExcedeed"}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"message":[{"t":2,"r":"valueErrorMsg.message"}],"status":[{"t":2,"r":"valueErrorMsg.status"}]},"f":[]}],"n":50,"r":"valueErrorMsg"}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"1000","class":"light-theme previewImageModal","modalId":["showImageInfo-",{"t":2,"r":"id"}]},"f":[{"t":7,"e":"div","a":{"class":"section-title clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"previewImage.fileName"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"section-details clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"ux-iframe","a":{"id":"iframeID","src":[{"t":2,"r":"previewImage.fileContent"}],"width":"100%","heightInd":"true","height":"600px"}}]}]}]}]}]}]};
this["ux-freeGifts-error"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-freeGifts-error body-text error-margin-top"},"f":[{"t":7,"e":"div","a":{"class":"error-margin-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"important-information-details-list"},"f":[{"t":7,"e":"div","a":{"class":"red medium-offset-1"},"f":[{"t":7,"e":"ux-icon","a":{"class":"warning voucherIcon","type":"cross","size":"xs"}}," ",{"t":7,"e":"span","a":{"class":"v-medim-left"},"f":[{"t":2,"r":"name"}," is no longer available"]}]}]}],"n":52,"r":"unAvailableFreeGifts"}]}]}]};
this["ux-fs-appointment-breadcrumb"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-fs-appointment-breadcrumb"},"f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-wrap flex-container-start"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["flex-item breadcrumb-container ",{"t":4,"f":["flex-item-top-align"],"n":50,"x":{"r":["completionStatus"],"s":"_0===\"PENDING\""}}]},"f":[{"t":7,"e":"div","a":{"class":"icon-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-start"},"f":[{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"type":"circle-tick","outerClass":"left","size":"s","class":[{"t":2,"r":"completionStatus"}]}}],"n":50,"x":{"r":["completionStatus"],"s":"_0===\"DONE\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["completionStatus"],"s":"_0===\"PENDING\""},"f":[{"t":7,"e":"ux-icon","a":{"type":"circle-tick","outerClass":"left","size":"s","class":[{"t":2,"r":"completionStatus"}]}}]},{"t":4,"n":50,"x":{"r":["completionStatus"],"s":"(!(_0===\"PENDING\"))&&(_0===\"FAILED\")"},"f":[" ",{"t":7,"e":"ux-icon","a":{"type":"circle-cancel","outerClass":"left","size":"s","class":[{"t":2,"r":"completionStatus"}]}}]}],"x":{"r":["completionStatus"],"s":"_0===\"DONE\""}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["flex-item flex-full-width connector-line ",{"t":2,"rx":{"r":"fsAppointment.implFulfillmentStatusHistoryList","m":[{"r":["i"],"s":"_0+1"},"completionStatus"]}}]},"f":[]}],"n":50,"x":{"r":["i","fsAppointment.implFulfillmentStatusHistoryList.length"],"s":"_0<_1-1"}}]}]}," ",{"t":7,"e":"div","a":{"class":["message-container ",{"t":2,"r":"completionStatus"}]},"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["currentMessage","currentStatus"],"s":"_0||_1"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["RactiveHelpers","statusChangeDatetimeMilli"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["RactiveHelpers","statusChangeDatetimeMilli"],"s":"_0.convertMilisTimestampToDate(_1,\"hh:mm A\")"}}]}],"n":50,"x":{"r":["completionStatus"],"s":"_0!==\"PENDING\""}}]}]}],"n":52,"i":"i","r":"fsAppointment.implFulfillmentStatusHistoryList"}," ",{"t":4,"f":[],"n":50,"x":{"r":["fsAppointment.implFulfillmentStatusHistoryList.length"],"s":"_0>5"}}]}]}]};
this["ux-fullwidth-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-fullwidth-banner"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["show-for-small-only banner-background ",{"t":2,"r":"theme"}," ",{"t":2,"r":"backgroundImgMobileExtraClass"}," ",{"t":2,"r":"backgroundImgMobileSize"}," ",{"t":2,"r":"mobileImgHeight"}],"style":["background-image: url('",{"t":2,"r":"backgroundImgMobile"},"');",{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 banner-content"},"f":[{"t":7,"e":"div","a":{"class":["banner-image foreground-fix-center ",{"t":2,"r":"mobileImgHeight"}]},"f":[{"t":7,"e":"div","a":{"class":["image ",{"t":2,"r":"foregroundImgMobilePosition"}," ",{"t":2,"r":"foregroundImgMobileSize"}]},"m":[{"t":4,"f":["style=\"background-image: url('",{"t":2,"r":"foregroundImg.mobile.src"},"')\""],"n":50,"r":"foregroundImg.mobile.src"}],"f":[{"t":7,"e":"div","a":{"class":["content-outer ",{"t":2,"r":"alignment"}," ",{"t":2,"x":{"r":["getContentStatusOnHide","hideFor"],"s":"_0(_1)"}}]},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"hero-text v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":3,"r":"desc"}]}],"n":50,"r":"showDescriptionOnMobile"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["logo-holder-label ",{"t":4,"f":["small-3"],"n":50,"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}},{"t":4,"n":51,"f":["small-5"],"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}}]},"f":[{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"r":"logoLabel"}]}],"n":50,"r":"logoLabel"}]}," ",{"t":7,"e":"ux-col","a":{"class":["logo-holder ",{"t":4,"f":["small-6"],"n":50,"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}},{"t":4,"n":51,"f":["small-7"],"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["logo-holder-item ",{"t":4,"f":["small-6"],"n":50,"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}},{"t":4,"n":51,"f":["small-5"],"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}}]},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"logoImg1.src"}],"alt":[{"t":2,"r":"logoImg1.alt"}]}}]}],"n":50,"r":"logoImg1.src"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["logo-holder-item ",{"t":4,"f":["small-6"],"n":50,"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}},{"t":4,"n":51,"f":["small-5"],"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}}]},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"logoImg2.src"}],"alt":[{"t":2,"r":"logoImg2.alt"}]}}]}],"n":50,"r":"logoImg2.src"}]}],"n":50,"x":{"r":["logoImg1.src","logoImg2.src"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["logo-holder-label ",{"t":4,"f":["small-3"],"n":50,"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}},{"t":4,"n":51,"f":["small-6"],"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}}]},"f":[{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"r":"logoLabel"}]}],"n":50,"r":"logoLabel"}]}," ",{"t":7,"e":"ux-col","a":{"class":"logo-holder small-6"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["logo-holder-item ",{"t":4,"f":["small-6"],"n":50,"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}},{"t":4,"n":51,"f":[{"t":4,"f":["small-5"],"n":50,"r":"logoImg2.src"},{"t":4,"n":51,"f":["small-6"],"r":"logoImg2.src"}],"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}}]},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"logoImg1.src"}],"alt":[{"t":2,"r":"logoImg1.alt"}]}}]}],"n":50,"r":"logoImg1.src"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["logo-holder-item ",{"t":4,"f":["small-6"],"n":50,"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}},{"t":4,"n":51,"f":[{"t":4,"f":["small-5"],"n":50,"r":"logoImg1.src"},{"t":4,"n":51,"f":["small-6"],"r":"logoImg1.src"}],"x":{"r":["logoLabel"],"s":"_0==\"\"||_0==null"}}]},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"logoImg2.src"}],"alt":[{"t":2,"r":"logoImg2.alt"}]}}]}],"n":50,"r":"logoImg2.src"}]}],"n":50,"x":{"r":["logoImg1.src","logoImg2.src"],"s":"_0||_1"}}],"x":{"r":["logoImg1.src","logoImg2.src"],"s":"_0&&_1"}}]}],"n":50,"x":{"r":["logoLabel","logoImg1.src","logoImg2.src"],"s":"_0||_1||_2"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"v-default-top"},"f":[{"t":7,"e":"ux-anchor","a":{"id":[{"t":4,"f":[{"t":2,"r":"linkUrl"}],"n":50,"r":"openModal"}],"type":[{"t":4,"f":["modal"],"n":50,"r":"openModal"},{"t":4,"n":51,"f":["anchor"],"r":"openModal"}],"pmodalData":[{"t":2,"r":"pmodalData"}],"target":[{"t":4,"f":["_blank"],"n":50,"r":"firstLinkNewTab"},{"t":4,"n":51,"f":["_self"],"r":"firstLinkNewTab"}],"class":[{"t":4,"f":["ux-button button round"],"n":50,"r":"isButton"},{"t":4,"n":51,"f":["bannerLink"],"r":"isButton"}],"href":[{"t":4,"f":[{"t":2,"r":"linkUrl"}],"n":50,"x":{"r":["openModal"],"s":"!_0"}}],"ontap":[{"t":2,"r":"ontap"}]},"f":[{"t":2,"r":"linkName"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-anchor","a":{"id":[{"t":4,"f":[{"t":2,"r":"linkUrl2"}],"n":50,"r":"openModal2"}],"type":[{"t":4,"f":["modal"],"n":50,"r":"openModal2"},{"t":4,"n":51,"f":["anchor"],"r":"openModal2"}],"pmodalData":[{"t":2,"r":"pmodalData2"}],"target":[{"t":4,"f":["_blank"],"n":50,"r":"secondLinkNewTab"},{"t":4,"n":51,"f":["_self"],"r":"secondLinkNewTab"}],"class":[{"t":4,"f":["ux-button button round"],"n":50,"r":"isButton2"},{"t":4,"n":51,"f":["bannerLink"],"r":"isButton2"}],"href":[{"t":4,"f":[{"t":2,"r":"linkUrl2"}],"n":50,"x":{"r":["openModal2"],"s":"!_0"}}],"ontap":[{"t":2,"r":"ontap"}]},"f":[{"t":2,"r":"linkName2"}]}]}]}],"n":50,"r":"linkUrl2"}]}],"n":50,"r":"linkUrl"}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"round center show-for-small-only v-large-top","text":"Download Now","role":"button","onclick":"launchDownloadApp"}}],"n":50,"x":{"r":["appsmodel.ios.src","appsmodel.android.src"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"play-icon-wrapper"},"f":[{"t":7,"e":"span","a":{"class":"play-icon"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"playBtnImg.src"}],"alt":[{"t":2,"r":"playBtnImg.alt"}],"width":"108"},"v":{"click":"displayVideo"}}]}]}],"n":50,"x":{"r":["videoId","playBtnImg"],"s":"_0&&_1"}}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":["show-for-medium-up banner-background ",{"t":2,"r":"theme"}," ",{"t":2,"r":"backgroundImgDesktopExtraClass"}," ",{"t":2,"r":"backgroundImgDesktopSize"}],"style":["background-image: url('",{"t":2,"r":"backgroundImgDesktop"},"');",{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":["small-12 medium-5 banner-content ",{"t":2,"r":"alignment"}," ",{"t":2,"x":{"r":["getContentStatusOnHide","hideFor"],"s":"_0(_1)"}}," medium-offset-1"]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"hero-text v-medium-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":3,"r":"desc"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"logo-holder-label medium-4"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"logoLabel"}]}]}],"n":50,"r":"logoLabel"}," ",{"t":7,"e":"ux-col","a":{"class":"logo-holder medium-8"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"logo-holder-item medium-4"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"logoImg1.src"}],"alt":[{"t":2,"r":"logoImg1.alt"}]}}]}],"n":50,"r":"logoImg1.src"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"logo-holder-item medium-4"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"logoImg2.src"}],"alt":[{"t":2,"r":"logoImg2.alt"}]}}]}],"n":50,"r":"logoImg2.src"}," ",{"t":7,"e":"ux-col","a":{"class":"logo-holder-item medium-4"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"}}]}]}]}],"n":50,"x":{"r":["logoLabel","logoImg1.src","logoImg2.src"],"s":"_0||_1||_2"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 "},"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-anchor","a":{"id":[{"t":4,"f":[{"t":2,"r":"linkUrl"}],"n":50,"r":"openModal"}],"type":[{"t":4,"f":["modal"],"n":50,"r":"openModal"},{"t":4,"n":51,"f":["anchor"],"r":"openModal"}],"pmodalData":[{"t":2,"r":"pmodalData"}],"target":[{"t":4,"f":["_blank"],"n":50,"r":"firstLinkNewTab"},{"t":4,"n":51,"f":["_self"],"r":"firstLinkNewTab"}],"class":[{"t":4,"f":["ux-button button round"],"n":50,"r":"isButton"},{"t":4,"n":51,"f":["bannerLink v-medium-top"],"r":"isButton"}],"href":[{"t":4,"f":[{"t":2,"r":"linkUrl"}],"n":50,"x":{"r":["openModal"],"s":"!_0"}}],"ontap":[{"t":2,"r":"ontap"}]},"f":[{"t":2,"r":"linkName"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 "},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["v-default-top"],"n":50,"x":{"r":["isButton","isButton2"],"s":"_0&&!_1"}},{"t":4,"n":51,"f":["v-normal-top"],"x":{"r":["isButton","isButton2"],"s":"_0&&!_1"}}]},"f":[{"t":7,"e":"ux-anchor","a":{"id":[{"t":4,"f":[{"t":2,"r":"linkUrl2"}],"n":50,"r":"openModal2"}],"type":[{"t":4,"f":["modal"],"n":50,"r":"openModal2"},{"t":4,"n":51,"f":["anchor"],"r":"openModal2"}],"pmodalData":[{"t":2,"r":"pmodalData2"}],"target":[{"t":4,"f":["_blank"],"n":50,"r":"secondLinkNewTab"},{"t":4,"n":51,"f":["_self"],"r":"secondLinkNewTab"}],"class":[{"t":4,"f":["ux-button button round"],"n":50,"r":"isButton2"},{"t":4,"n":51,"f":["bannerLink v-medium-top v-normal-left"],"r":"isButton2"}],"href":[{"t":4,"f":[{"t":2,"r":"linkUrl2"}],"n":50,"x":{"r":["openModal2"],"s":"!_0"}}],"ontap":[{"t":2,"r":"ontap"}]},"f":[{"t":2,"r":"linkName2"}]}]}]}],"n":50,"r":"linkUrl2"}]}],"n":50,"r":"linkUrl"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"clear-table-css v-large-top"},"f":[{"t":3,"r":"metricsInfo"}]}],"n":50,"r":"metricsInfo"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top appstore show-for-medium-up"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"left"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"appsmodel.ios.link"}]},"f":[{"t":7,"e":"ux-image","a":{"datamodel":[{"t":2,"r":"appsmodel.ios"}]}}]}]}],"n":50,"r":"appsmodel.ios"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"left small-offset-1"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"appsmodel.android.link"}]},"f":[{"t":7,"e":"ux-image","a":{"datamodel":[{"t":2,"r":"appsmodel.android"}]}}]}]}],"n":50,"r":"appsmodel.android"}]}],"n":50,"r":"appsmodel"}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":["small-12 medium-6 banner-visual ",{"t":2,"x":{"r":["getHideStatus","hide_for"],"s":"_0(_1)"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"banner-image foreground-fix-center"},"f":[{"t":7,"e":"div","a":{"class":["image ",{"t":2,"r":"foregroundImgDesktopPosition"}," ",{"t":2,"r":"foregroundImgDesktopSize"}],"style":["background-image: url('",{"t":2,"r":"foregroundImg.desktop.src"},"')"]},"f":[]}]}],"n":50,"r":"foregroundImg.desktop.src"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"play-icon-wrapper"},"f":[{"t":7,"e":"span","a":{"class":"play-icon"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"playBtnImg.src"}],"alt":[{"t":2,"r":"playBtnImg.alt"}],"width":"108"},"v":{"click":"displayVideo"}}]}]}],"n":50,"x":{"r":["videoId","playBtnImg"],"s":"_0&&_1"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-modal","a":{"modalId":"singleFullScreenVideo","hideTitle":"true"},"f":[{"t":7,"e":"iframe","a":{"id":"ytplayer","class":"single-video-item-video","type":"text/html","src":[{"t":2,"r":"videoURL"}],"frameborder":"0"}}]}],"n":50,"x":{"r":["videoId","playBtnImg"],"s":"_0&&_1"}}],"n":50,"x":{"r":["isDataModel","toDisplayBanner"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[],"x":{"r":["isDataModel","toDisplayBanner"],"s":"_0&&_1"}}]}]};
this["ux-generic-sub"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-generic-sub"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":[{"t":2,"r":"plan.displayName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"r":"productDetails.subscriberCategoryX8"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":["Plan Specification"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"r":"plan.displayDescription"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4"},"f":["Addons column"]}]}]}],"n":53,"r":"product"}]};
this["ux-generic-table"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-generic-table ",{"t":2,"r":"theme"}," ",{"t":2,"r":"transparent"}," ",{"t":4,"f":["paddingDesktop-",{"t":2,"r":"paddingDesktop"}],"n":50,"r":"paddingDesktop"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["show-for-medium-up"],"n":50,"x":{"r":["tableType"],"s":"_0!==\"basic\""}},{"t":4,"n":51,"f":["basic-mobile-padding"],"x":{"r":["tableType"],"s":"_0!==\"basic\""}}]},"f":[{"t":7,"e":"table","a":{"class":["small-12 ",{"t":4,"f":["medium-12 large-12"],"n":50,"x":{"r":["tableWidth"],"s":"_0===\"full\""}},{"t":4,"n":51,"f":["medium-10 large-10"],"x":{"r":["tableWidth"],"s":"_0===\"full\""}}]},"f":[{"t":7,"e":"tr","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"td","a":{"class":["small-",{"t":2,"r":"colSize1"}," medium-",{"t":2,"r":"colSize1"}," large-",{"t":2,"r":"colSize1"}," ",{"t":4,"f":["text-",{"t":2,"r":"header1Align"}],"n":50,"r":"header1Align"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header1Link"}],"class":"text-link"},"f":[{"t":2,"r":"header1"}]}],"n":50,"r":"header1Link"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"r":"header1"}],"n":50,"r":"unbold1"},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"header1"}]}],"r":"unbold1"}],"r":"header1Link"}]}],"n":50,"r":"colSize1"}," ",{"t":4,"f":[{"t":7,"e":"td","a":{"class":["small-",{"t":2,"r":"colSize2"}," medium-",{"t":2,"r":"colSize2"}," large-",{"t":2,"r":"colSize2"}," ",{"t":4,"f":["text-",{"t":2,"r":"header2Align"}],"n":50,"r":"header2Align"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header2Link"}],"class":"text-link"},"f":[{"t":2,"r":"header2"}]}],"n":50,"r":"header2Link"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"r":"header2"}],"n":50,"r":"unbold2"},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"header2"}]}],"r":"unbold2"}],"r":"header2Link"}]}],"n":50,"r":"colSize2"}," ",{"t":4,"f":[{"t":7,"e":"td","a":{"class":["small-",{"t":2,"r":"colSize3"}," medium-",{"t":2,"r":"colSize3"}," large-",{"t":2,"r":"colSize3"}," ",{"t":4,"f":["text-",{"t":2,"r":"header3Align"}],"n":50,"r":"header3Align"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header3Link"}],"class":"text-link"},"f":[{"t":2,"r":"header3"}]}],"n":50,"r":"header3Link"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"r":"header3"}],"n":50,"r":"unbold3"},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"header3"}]}],"r":"unbold3"}],"r":"header3Link"}]}],"n":50,"r":"colSize3"}," ",{"t":4,"f":[{"t":7,"e":"td","a":{"class":["small-",{"t":2,"r":"colSize4"}," medium-",{"t":2,"r":"colSize4"}," large-",{"t":2,"r":"colSize4"}," ",{"t":4,"f":["text-",{"t":2,"r":"header4Align"}],"n":50,"r":"header4Align"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header4Link"}],"class":"text-link"},"f":[{"t":2,"r":"header4"}]}],"n":50,"r":"header4Link"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"r":"header4"}],"n":50,"r":"unbold4"},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"header4"}]}],"r":"unbold4"}],"r":"header4Link"}]}],"n":50,"r":"colSize4"}," ",{"t":4,"f":[{"t":7,"e":"td","a":{"class":["small-",{"t":2,"r":"colSize5"}," medium-",{"t":2,"r":"colSize5"}," large-",{"t":2,"r":"colSize5"}," ",{"t":4,"f":["text-",{"t":2,"r":"header5Align"}],"n":50,"r":"header5Align"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header5Link"}],"class":"text-link"},"f":[{"t":2,"r":"header5"}]}],"n":50,"r":"header5Link"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"r":"header5"}],"n":50,"r":"unbold5"},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"header5"}]}],"r":"unbold5"}],"r":"header5Link"}]}],"n":50,"r":"colSize5"}],"n":50,"x":{"r":["header1","header2","header3","header4","header5"],"s":"_0||_1||_2||_3||_4"}}]}," ",{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"tableItems"},"f":[{"t":7,"e":"td","a":{"colspan":[{"t":2,"r":"col1.colspan"}],"class":["body-text ",{"t":4,"f":["text-",{"t":2,"r":"header1Align"}],"n":50,"r":"header1Align"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}],"r":"col1"}]}," ",{"t":4,"f":[],"n":50,"x":{"r":["col1.colspan"],"s":"_0&&_0>=2"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"td","a":{"colspan":[{"t":2,"r":"colspan"}],"class":["body-text ",{"t":4,"f":["text-",{"t":2,"r":"header2Align"}],"n":50,"r":"header2Align"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}],"r":"col2"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"td","a":{"class":"body-text"}}],"r":"colSize2"}],"n":51,"r":"col2"}],"x":{"r":["col1.colspan"],"s":"_0&&_0>=2"}}," ",{"t":4,"f":[],"n":50,"x":{"r":["col2.colspan","col1.colspan"],"s":"(_0&&_0>=2)||(_1&&_1>=3)"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"td","a":{"colspan":[{"t":2,"r":"colspan"}],"class":["body-text ",{"t":4,"f":["text-",{"t":2,"r":"header3Align"}],"n":50,"r":"header3Align"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}],"r":"col3"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"td","a":{"class":"body-text"}}],"r":"colSize3"}],"n":51,"r":"col3"}],"x":{"r":["col2.colspan","col1.colspan"],"s":"(_0&&_0>=2)||(_1&&_1>=3)"}}," ",{"t":4,"f":[],"n":50,"x":{"r":["col3.colspan","col2.colspan","col1.colspan"],"s":"(_0&&_0>=2)||(_1&&_1>=3)||(_2&&_2>=4)"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"td","a":{"colspan":[{"t":2,"r":"colspan"}],"class":["body-text ",{"t":4,"f":["text-",{"t":2,"r":"header4Align"}],"n":50,"r":"header4Align"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}],"r":"col4"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"td","a":{"class":"body-text"}}],"r":"colSize4"}],"n":51,"r":"col4"}],"x":{"r":["col3.colspan","col2.colspan","col1.colspan"],"s":"(_0&&_0>=2)||(_1&&_1>=3)||(_2&&_2>=4)"}}," ",{"t":4,"f":[],"n":50,"x":{"r":["col4.colspan","col3.colspan","col2.colspan","col1.colspan"],"s":"(_0&&_0>=2)||(_1&&_1>=3)||(_2&&_2>=4)||(_3&&_3>=5)"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"td","a":{"class":["body-text ",{"t":4,"f":["text-",{"t":2,"r":"header5Align"}],"n":50,"r":"header5Align"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}],"r":"col5"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"td","a":{"class":"body-text"}}],"r":"colSize5"}],"n":51,"r":"col5"}],"x":{"r":["col4.colspan","col3.colspan","col2.colspan","col1.colspan"],"s":"(_0&&_0>=2)||(_1&&_1>=3)||(_2&&_2>=4)||(_3&&_3>=5)"}}]}],"i":"i","r":"rows"}],"n":50,"r":"rows"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only basic-mobile-padding"},"f":[{"t":4,"f":[{"t":7,"e":"table","f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header2Link"}],"class":"text-link"},"f":[{"t":2,"r":"header2"}]}],"n":50,"r":"header2Link"},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"header2"}]}],"r":"header2Link"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"col2.bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"col2.bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":7,"e":"br"}],"r":"col2"}]}],"r":"col1"}]}],"i":"i","r":"rows"}],"n":50,"r":"rows"}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"medium-6"},"f":[]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 text-right"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}]}]}],"n":50,"r":"link"}],"r":"col2"}],"i":"i","r":"rows"}]}]}],"n":50,"r":"header2"}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header3Link"}],"class":"text-link"},"f":[{"t":2,"r":"header3"}]}],"n":50,"r":"header3Link"},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"header3"}]}],"r":"header3Link"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"col3.bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"col3.bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}],"r":"col3"}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"col2.bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"col2.bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}],"r":"col2"}],"n":50,"x":{"r":["col2.colspan"],"s":"_0&&_0>=2"}}],"n":51,"r":"col3"}]}],"r":"col1"}]}],"i":"i","r":"rows"}],"n":50,"r":"rows"}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"medium-6"},"f":[]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 text-right"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}]}]}],"n":50,"r":"link"}],"r":"col3"}],"i":"i","r":"rows"}]}]}],"n":50,"r":"header3"}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header4Link"}],"class":"text-link"},"f":[{"t":2,"r":"header4"}]}],"n":50,"r":"header4Link"},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"header4"}]}],"r":"header4Link"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"col4.bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"col4.bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}],"r":"col4"}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"col3.bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"col3.bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}],"r":"col3"}],"n":50,"x":{"r":["col3.colspan"],"s":"_0&&_0>=2"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["col2.colspan"],"s":"_0&&_0>=3"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"col2.bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"col2.bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}],"r":"col2"}]}],"x":{"r":["col3.colspan"],"s":"_0&&_0>=2"}}],"n":51,"r":"col4"}]}],"r":"col1"}]}],"i":"i","r":"rows"}],"n":50,"r":"rows"}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"medium-6"},"f":[]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 text-right"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}]}]}],"n":50,"r":"link"}],"r":"col4"}],"i":"i","r":"rows"}]}]}],"n":50,"r":"header4"}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header5Link"}],"class":"text-link"},"f":[{"t":2,"r":"header5"}]}],"n":50,"r":"header5Link"},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"header5"}]}],"r":"header5Link"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"col5.bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"col5.bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}],"r":"col5"}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"col4.bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"col4.bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}],"r":"col4"}],"n":50,"x":{"r":["col4.colspan"],"s":"_0&&_0>=2"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["col3.colspan"],"s":"_0&&_0>=3"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"col3.bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"col3.bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}],"r":"col3"}]},{"t":4,"n":50,"x":{"r":["col3.colspan","col2.colspan"],"s":"(!(_0&&_0>=3))&&(_1&&_1>=4)"},"f":[" ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"col2.bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"col2.bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}],"r":"col2"}]}],"x":{"r":["col4.colspan"],"s":"_0&&_0>=2"}}],"n":51,"r":"col5"}]}],"r":"col1"}]}],"i":"i","r":"rows"}],"n":50,"r":"rows"}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"medium-6"},"f":[]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 text-right"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}]}]}]}],"n":50,"r":"link"}],"r":"col5"}],"i":"i","r":"rows"}]}]}],"n":50,"r":"header5"}]}],"n":50,"x":{"r":["tableType"],"s":"_0===\"compare\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["tableType"],"s":"_0===\"listing\""},"f":[{"t":7,"e":"table","a":{"width":"100%"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"paddingListing"},"f":[{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-accordion","a":{"subscription":[{"t":3,"r":"."}],"header2":[{"t":2,"r":"header2"}],"header2Link":[{"t":2,"r":"header2Link"}],"header3":[{"t":2,"r":"header3"}],"header3Link":[{"t":2,"r":"header3Link"}],"header4":[{"t":2,"r":"header4"}],"header4Link":[{"t":2,"r":"header4Link"}],"header5":[{"t":2,"r":"header5"}],"header5Link":[{"t":2,"r":"header5Link"}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse flex-container "},"f":[{"t":7,"e":"ux-col","a":{"class":"small-11"},"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-1 flex-item text-right"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":[{"t":2,"r":"theme"}]}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":[{"t":2,"r":"theme"}]}}]}]}]}],"r":"col1"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"topminus2"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header2Link"}],"class":"text-link"},"f":[{"t":2,"r":"header2"},":"]}],"n":50,"r":"header2Link"},{"t":4,"n":51,"f":[{"t":2,"r":"header2"},":"],"r":"header2Link"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}]}],"r":"col2"}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top collapse flex-container"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header3Link"}],"class":"text-link"},"f":[{"t":2,"r":"header3"},":"]}],"n":50,"r":"header3Link"},{"t":4,"n":51,"f":[{"t":2,"r":"header3"},":"],"r":"header3Link"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}]}],"r":"col3"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header4Link"}],"class":"text-link"},"f":[{"t":2,"r":"header4"},":"]}],"n":50,"r":"header4Link"},{"t":4,"n":51,"f":[{"t":2,"r":"header4"},":"],"r":"header4Link"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}]}],"r":"col4"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"../header5Link"}],"class":"text-link"},"f":[{"t":2,"r":"header5"},":"]}],"n":50,"r":"header5Link"},{"t":4,"n":51,"f":[{"t":2,"r":"header5"},":"],"r":"header5Link"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}]}],"r":"col5"}]}]}]}],"n":53,"r":"subscription"}]}]}]}]}]}],"i":"i","r":"rows"}],"n":50,"r":"rows"}]}]},{"t":4,"n":50,"x":{"r":["tableType"],"s":"(!(_0===\"listing\"))&&(_0===\"listingNonExpand\")"},"f":[" ",{"t":7,"e":"table","a":{"width":"100%"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":4,"f":[{"t":3,"r":"value"}],"n":50,"r":"unbold1"},{"t":4,"n":51,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"r":"unbold1"}]}]}],"r":"col1"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header2Link"}],"class":"text-link"},"f":[{"t":2,"r":"header2"}]}],"n":50,"r":"header2Link"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"r":"header2"}],"n":50,"r":"unbold2"},{"t":4,"n":51,"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"header2"}]}],"r":"unbold2"}],"r":"header2Link"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}]}],"r":"col2"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header3Link"}],"class":"text-link"},"f":[{"t":2,"r":"header3"}]}],"n":50,"r":"header3Link"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"r":"header3"}],"n":50,"r":"unbold3"},{"t":4,"n":51,"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"header3"}]},">"],"r":"unbold3"}],"r":"header3Link"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}]}],"r":"col3"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"header4Link"}],"class":"text-link"},"f":[{"t":2,"r":"header4"}]}],"n":50,"r":"header4Link"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"r":"header4"}],"n":50,"r":"unbold4"},{"t":4,"n":51,"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"header4"}]}],"r":"unbold4"}],"r":"header4Link"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}]}],"r":"col4"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"../header5Link"}],"class":"text-link"},"f":[{"t":2,"r":"header5"}]}],"n":50,"r":"header5Link"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"r":"header5"}],"n":50,"r":"unbold5"},{"t":4,"n":51,"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"header5"}]}],"r":"unbold5"}],"r":"header5Link"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"strong","f":[{"t":3,"r":"value"}]}],"n":50,"r":"bold"},{"t":4,"n":51,"f":[{"t":3,"r":"value"}],"r":"bold"}],"n":50,"x":{"r":["type"],"s":"_0===\"text\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"icon\""},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"value"}],"class":[{"t":2,"r":"theme"}]}}]}],"x":{"r":["type"],"s":"_0===\"text\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"link"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","class":[{"t":2,"r":"theme"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"tooltip"}]}]}]}]}],"n":50,"r":"tooltip"}]}]}],"r":"col5"}]}]}]}],"i":"i","r":"rows"}],"n":50,"r":"rows"}]}]}],"x":{"r":["tableType"],"s":"_0===\"compare\""}}]}],"n":50,"r":"isDataModel"}]}]};
this["ux-get-new-number"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-get-new-number ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"description v-medium-top v-large-bottom"},"f":[{"t":3,"r":"sectionDesc"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"col5-unit small-6"},"f":[{"t":7,"e":"div","a":{"class":["number-box section-header text-center v-normal-bottom cursor ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"tap":{"n":"selectedNumber","d":[{"t":2,"r":"index"}]}},"f":[{"t":2,"x":{"r":["RactiveHelpers","phoneNo"],"s":"_0.mobileNumberFormat(_1)"}}]}]}],"i":"index","r":"numbersToShow"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"v-medium-bottom show-more-link","onclick":"showAll"},"f":[{"t":2,"r":"showMoreText"}]}]}],"n":50,"x":{"r":["widgetId"],"s":"_0===\"selectFixedLine\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-medium-top"},"f":[{"t":7,"e":"ux-button","a":{"class":"round light show-more-button v-medium-bottom","onclick":"showAll","text":[{"t":2,"r":"showMoreText"}]},"f":[]}]}],"x":{"r":["widgetId"],"s":"_0===\"selectFixedLine\""}}]}],"n":50,"x":{"r":["hideShowMoreButton","hideShowMoreLink"],"s":"_0==\"false\"&&!_1"}}],"n":50,"x":{"r":["numbersToShow","numbersToShow.length"],"s":"_0&&_1>0"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["newNumbersFetchFailed"],"s":"_0"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"ConfigString.errors.genericError2"}]},"f":[]}]}],"x":{"r":["numbersToShow","numbersToShow.length"],"s":"_0&&_1>0"}}]}]};
this["ux-google-search"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-google-search"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header v-normal-top v-normal-bottom"},"f":["Your Search"]}," ",{"t":7,"e":"input","a":{"id":"gcsId","type":"hidden","value":[{"t":3,"r":"googleCustomSearchControlId"}]}}," ",{"t":7,"e":"div","a":{"id":"cse","width":"100%"}}]}]}]}]};
this["ux-guest-form"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-guest-form"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header"},"f":["Guest Checkout"]}," ",{"t":7,"e":"p","a":{"class":"subtitle"},"f":["Copy to explain the advantages of guest checkout"]}," ",{"t":7,"e":"label","a":{"for":"#guest-id-number-prefix","class":""},"f":["ID Number"]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"ux-select","a":{"title":"ID Number","selected_value":[{"t":2,"r":"guestIdNumberPrefix"}],"options":[{"t":2,"r":"initData.options"}],"id":"guestIdNumberPrefix"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-9"},"f":[" ",{"t":7,"e":"input","a":{"type":"text","placeholder":"EG. S612356","value":[{"t":2,"r":"guestIdNumber"}]},"v":{"blur":"onBlurGuestId"}}," ",{"t":4,"f":[{"t":7,"e":"small","a":{"class":"guest-id-error error"},"f":[{"t":2,"r":"message"}]}],"r":"data.guestIdNumberErrorMsg"}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"label","a":{"for":"#guest-id-type"},"f":["ID Type"]}," ",{"t":7,"e":"ux-select","a":{"title":"ID Type","id":"guestIdType","selected_value":[{"t":2,"r":"guestIdType"}],"options":[{"t":2,"r":"guestCheckout.guestIdTypeOptions.options"}]}}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-input-box","a":{"label_value":"Email","value":[{"t":2,"r":"guestEmail"}],"id":"guestEmail","blur":"onBlurEmail"}}," ",{"t":4,"f":[{"t":7,"e":"small","a":{"class":"guest-email-error error"},"f":[{"t":2,"r":"message"}]}],"r":"data.guestEmailErrorMsg"}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button-sd","a":{"text":"Next","type":"submit button round","disabled":[{"t":2,"r":"disabled"}],"onclick":"submitGuestCheckout"}}]}]}]};
this["ux-header-singtel"] = {"v":3,"t":[{"t":7,"e":"style","f":["@media (min-width:80em){.singtel-header-placeholder{height:7.5rem!important}  .singtel-header-fourth-placeholder{height:11.5rem!important} }.singtel-header-placeholder .lt-ie9{height:4.125rem!important}@media (max-width:79.9375em){.singtel-header-placeholder{height:inherit} .singtel-header-fourth-placeholder{height:11.5rem!important} .ux-header-singtel-mobile .ux-modal .icon,.ux-header-singtel-mobile .ux-modal .singtel-accordion .accordion .accordion-navigation .expand-collapse-icon i.icon{font-size:1rem}.ux-header-singtel-mobile .ux-modal .modal{padding:0 .9375rem;display:block;height:100%;top:0;max-width:100%!important}.ux-header-singtel-mobile .ux-modal .close-modal.back{left:.625rem;right:auto}.ux-header-singtel-mobile .ux-modal .search-input input[type=text]{height:2.5rem;border-radius:1.3rem;padding-left:1rem}.ux-header-singtel-mobile .ux-modal .search-input input[type=text]:focus{background-color:#fff;border-color:#dbdbdb}.ux-header-singtel-mobile .ux-modal .search-input .postfix{height:2.5rem;border-radius:0 1.3rem 1.3rem 0;background-color:#fff}.ux-header-singtel-mobile .ux-modal .search-input .postfix .ux-icon{display:block;position:absolute;top:5px;right:1.25rem}.ux-header-singtel-mobile .ux-modal .accordion-navigation.active .body-copy-text{color:#ed1a3d}.ux-header-singtel-mobile .ux-modal .singtel-accordion .accordion .accordion-navigation{margin-top:0!important;margin-bottom:0!important}.ux-header-singtel-mobile .ux-modal .panel-divider{margin:1rem -1.25rem}.ux-header-singtel-mobile .ux-modal .singtel-accordion .accordion .content.active,.ux-header-singtel-mobile .ux-modal .singtel-accordion .accordion .ux-marketing-banner .banner-content-outer .banner-content-inner .active.banner-content,.ux-marketing-banner .banner-content-outer .banner-content-inner .ux-header-singtel-mobile .ux-modal .singtel-accordion .accordion .active.banner-content{padding-left:2rem}.ux-header-singtel-mobile .ux-modal .link-item-link-mobile{color:#231f20}.ux-header-singtel-mobile .ux-modal .full-width-link{display:block;width:100%}.ux-header-singtel-mobile .ux-modal .sub-menu-mobile{display:block}.ux-header-singtel-mobile .ux-modal .close-modal{padding-top:1rem!important;top:1.5625rem}.ux-header-singtel-mobile .ux-modal .body-copy-text{font-size:.875rem;color:#231f20}.ux-header-singtel-mobile .ux-modal .singtel-logo.ux-image{text-align:center;margin-bottom:1rem}.ux-header-singtel-mobile .ux-modal .singtel-logo.ux-image img{margin-top:.9375rem;height:4.5rem}.verisign-logo{height:40px;width:70px;right:30px;margin-top:.625rem!important;position:absolute}.login a{margin-top:1.25rem}}.lt-ie9 .ux-header-singtel-mobile .ux-modal .icon,.lt-ie9 .ux-header-singtel-mobile .ux-modal .singtel-accordion .accordion .accordion-navigation .expand-collapse-icon i.icon{font-size:1rem}.lt-ie9 .ux-header-singtel-mobile .ux-modal .modal{padding:0 .9375rem;display:block;height:100%;top:0;max-width:100%!important}.lt-ie9 .ux-header-singtel-mobile .ux-modal .close-modal.back{left:.625rem;right:auto}.lt-ie9 .ux-header-singtel-mobile .ux-modal .search-input input[type=text]{height:2.5rem;border-radius:1.3rem;padding-left:1rem}.lt-ie9 .ux-header-singtel-mobile .ux-modal .search-input input[type=text]:focus{background-color:#fff;border-color:#dbdbdb}.lt-ie9 .ux-header-singtel-mobile .ux-modal .search-input .postfix{height:2.5rem;border-radius:0 1.3rem 1.3rem 0;background-color:#fff}.lt-ie9 .ux-header-singtel-mobile .ux-modal .search-input .postfix .ux-icon{display:block;position:absolute;top:5px;right:1.25rem}.lt-ie9 .ux-header-singtel-mobile .ux-modal .accordion-navigation.active .body-copy-text{color:#ed1a3d}.lt-ie9 .ux-header-singtel-mobile .ux-modal .singtel-accordion .accordion .accordion-navigation{margin-top:0!important;margin-bottom:0!important}.lt-ie9 .ux-header-singtel-mobile .ux-modal .panel-divider{margin:1rem -1.25rem}.lt-ie9 .ux-header-singtel-mobile .ux-modal .singtel-accordion .accordion .content.active,.lt-ie9 .ux-header-singtel-mobile .ux-modal .singtel-accordion .accordion .ux-marketing-banner .banner-content-outer .banner-content-inner .active.banner-content,.ux-marketing-banner .banner-content-outer .banner-content-inner .lt-ie9 .ux-header-singtel-mobile .ux-modal .singtel-accordion .accordion .active.banner-content{padding-left:2rem}.lt-ie9 .ux-header-singtel-mobile .ux-modal .link-item-link-mobile{color:#231f20}.lt-ie9 .ux-header-singtel-mobile .ux-modal .full-width-link{display:block;width:100%}.lt-ie9 .ux-header-singtel-mobile .ux-modal .sub-menu-mobile{display:block}.lt-ie9 .ux-header-singtel-mobile .ux-modal .close-modal{padding-top:1rem!important;top:1.5625rem}.lt-ie9 .ux-header-singtel-mobile .ux-modal .body-copy-text{font-size:.875rem;color:#231f20}.lt-ie9 .ux-header-singtel-mobile .ux-modal .singtel-logo.ux-image{text-align:center;margin-bottom:1rem}.lt-ie9 .ux-header-singtel-mobile .ux-modal .singtel-logo.ux-image img{margin-top:.9375rem;height:4.5rem}.lt-ie9 .verisign-logo{height:40px;right:30px;margin-top:.625rem!important;position:absolute}.lt-ie9 .login a{margin-top:1.25rem}@media (max-width:79.9375em){.ux-header-singtel.home-page{background:0 0;box-shadow:none}}@media (min-width:80em){.ux-header-singtel.home-page{background:0 0;box-shadow:none}.ux-header-singtel.home-page>.row{width:auto;max-width:100rem;padding-left:3.125rem;padding-right:3.125rem}.checkout-view-verisign-logo{position:absolute;right:.5rem}.verisign-logo{width:100px}.checkout-view{width:100%}.nav{margin-bottom:0}}.lt-ie9 .ux-header-singtel.home-page{background:0 0;box-shadow:none}.lt-ie9 .ux-header-singtel.home-page>.row{width:auto;max-width:100rem;padding-left:3.125rem;padding-right:3.125rem}.lt-ie9 .checkout-view-verisign-logo{position:absolute;right:.5rem}.lt-ie9 .verisign-logo{width:100px}.lt-ie9 .checkout-view{width:100%}.lt-ie9 .nav{margin-bottom:0}.ux-header-singtel{background-color:#fff;box-shadow:1px 2px 10px 1px #d6d6d6;z-index:100}.ux-header-singtel .loginMenu{position:relative;display:inline-block}.ux-header-singtel .dropdown-content{display:none;position:absolute;background-color:#f9f9f9;min-width:160px;box-shadow:0 8px 16px 0 rgba(0,0,0,.2)}.ux-header-singtel .relative{position:relative}.ux-header-singtel .checkout-text{padding-left:1rem}@media (min-width:80em){.ux-header-singtel{min-height:7.5rem;}.ux-header-singtel .singtel-logo.ux-image img{width:5rem}.ux-header-singtel>.row{width:75rem;margin:0 auto}.ux-header-singtel .search-results{width:18.6875rem;background-color:#f5f5f5;margin:2.5rem 0 0;position:absolute}.ux-header-singtel .search-results .amount-due,.ux-header-singtel .search-results .badges-text{color:#999}.ux-header-singtel .search-results img{width:80%}.orderDetailsWidget .activity>.activity-content .event .installation .ux-header-singtel .search-results .value,.ux-header-singtel .search-results .orderDetailsWidget .activity>.activity-content .event .installation .value,.ux-header-singtel .search-results .subsection-header,.ux-header-singtel .search-results .subsection-title,.ux-header-singtel .search-results .ux-heading-text .sub-section-header,.ux-header-singtel .search-results .ux-heading-text-singtel .sub-section-header,.ux-header-singtel .search-results .ux-phone-catalogue .show-more-phones,.ux-header-singtel .search-results .ux-timeline .activity>.activity-content .event .installation .value,.ux-heading-text .ux-header-singtel .search-results .sub-section-header,.ux-heading-text-singtel .ux-header-singtel .search-results .sub-section-header,.ux-phone-catalogue .ux-header-singtel .search-results .show-more-phones,.ux-timeline .activity>.activity-content .event .installation .ux-header-singtel .search-results .value{color:#231f20}.ux-header-singtel .shopping-item-num{color:#fff;height:1rem;width:1rem;font-size:.625rem;border-radius:.5rem;background-color:#ed1a3d;position:absolute;z-index:1;display:inline-block;right:0}.ux-header-singtel img.avatar{height:2.625rem;width:2.625rem}.ux-header-singtel .ux-icon{cursor:pointer}.ux-header-singtel .menu-wrapper{margin-top:4px;height:4.125rem}}.ux-header-singtel .lt-ie9 .singtel-logo.ux-image img{width:5rem}.ux-header-singtel .lt-ie9>.row{width:75rem;margin:0 auto}.ux-header-singtel .lt-ie9 .search-results{width:18.6875rem;background-color:#f5f5f5;margin:2.5rem 0 0;position:absolute}.ux-header-singtel .lt-ie9 .search-results .amount-due,.ux-header-singtel .lt-ie9 .search-results .badges-text{color:#999}.ux-header-singtel .lt-ie9 .search-results img{width:80%}.orderDetailsWidget .activity>.activity-content .event .installation .ux-header-singtel .lt-ie9 .search-results .value,.ux-header-singtel .lt-ie9 .search-results .orderDetailsWidget .activity>.activity-content .event .installation .value,.ux-header-singtel .lt-ie9 .search-results .subsection-header,.ux-header-singtel .lt-ie9 .search-results .subsection-title,.ux-header-singtel .lt-ie9 .search-results .ux-heading-text .sub-section-header,.ux-header-singtel .lt-ie9 .search-results .ux-heading-text-singtel .sub-section-header,.ux-header-singtel .lt-ie9 .search-results .ux-phone-catalogue .show-more-phones,.ux-header-singtel .lt-ie9 .search-results .ux-timeline .activity>.activity-content .event .installation .value,.ux-heading-text .ux-header-singtel .lt-ie9 .search-results .sub-section-header,.ux-heading-text-singtel .ux-header-singtel .lt-ie9 .search-results .sub-section-header,.ux-phone-catalogue .ux-header-singtel .lt-ie9 .search-results .show-more-phones,.ux-timeline .activity>.activity-content .event .installation .ux-header-singtel .lt-ie9 .search-results .value{color:#231f20}.ux-header-singtel .lt-ie9 img.avatar{height:2.625rem;width:2.625rem}.ux-header-singtel .lt-ie9 .menu-wrapper{margin-top:4px;height:4.125rem}@media (max-width:79.9375em){.ux-header-singtel{padding:0 .75rem}.ux-header-singtel .row{margin:0!important}.ux-header-singtel .columns{padding:0!important}.ux-header-singtel .icon-hamburger-line{padding-top:6px;margin-left:-1rem!important}.ux-header-singtel .shopping-item-num{color:#fff;height:1rem;width:1rem;font-size:.625rem;border-radius:.5rem;background-color:#ed1a3d;position:absolute;z-index:1;display:inline-block;margin-left:.625rem}.ux-header-singtel .singtel-logo.ux-image{text-align:center}.ux-header-singtel .singtel-logo.ux-image img{margin-top:.5rem;margin-bottom:.5rem;height:4.5rem}.ux-header-singtel .avatar{width:2.75rem!important;height:2.75rem!important;margin-top:.5rem}.ux-header-singtel .shopping-car-icon{margin-top:.875rem}.ux-header-singtel .shopping-car-icon .ux-icon{margin:0!important}.ux-header-singtel .ux-icon{display:block;cursor:pointer;margin-left:1rem;margin-right:1rem}.ux-header-singtel .ux-icon .icon{color:#231f20}.ux-header-singtel .avatar-holder{margin-top:2px}.ux-header-singtel .ux-icon span.l,.ux-header-singtel .ux-icon span.l:after,.ux-header-singtel .ux-icon span.l:before{font-size:2.375rem}.ux-header-singtel .last-column{display:flex;justify-content:space-evenly;max-width:8.125rem;right:0;position:absolute}}.ux-header-singtel .lt-ie9{min-height:7.5rem;border-top:4px solid #ed1a3d!important;height:4.125rem;padding:0 .75rem}.ux-header-singtel .lt-ie9 .row{margin:0!important}.ux-header-singtel .lt-ie9 .columns{padding:0!important}.ux-header-singtel .lt-ie9 .icon-hamburger-line{padding-top:6px;margin-left:-1rem!important}.ux-header-singtel .lt-ie9 .shopping-item-num{right:0;color:#fff;height:1rem;width:1rem;font-size:.625rem;border-radius:.5rem;background-color:#ed1a3d;position:absolute;z-index:1;display:inline-block;margin-left:.625rem}.ux-header-singtel .lt-ie9 .singtel-logo.ux-image{text-align:center}.ux-header-singtel .lt-ie9 .singtel-logo.ux-image img{margin-top:.9375rem;height:4.5rem}.ux-header-singtel .lt-ie9 .avatar{width:2.75rem!important;height:2.75rem!important;margin-top:.5rem}.ux-header-singtel .lt-ie9 .shopping-car-icon{margin-top: .875rem}.ux-header-singtel .lt-ie9 .shopping-car-icon .ux-icon{margin:0!important}.ux-header-singtel .lt-ie9 .ux-icon{display:block;cursor:pointer;margin-left:1rem;margin-right:1rem}.ux-header-singtel .lt-ie9 .ux-icon .icon{color:#231f20}.ux-header-singtel .lt-ie9 .avatar-holder{margin-top:2px}.ux-header-singtel .lt-ie9 .ux-icon span.l,.ux-header-singtel .lt-ie9 .ux-icon span.l:after,.ux-header-singtel .lt-ie9 .ux-icon span.l:before{font-size:2.375rem}.ux-header-singtel .lt-ie9 .last-column{display:flex;justify-content:space-evenly;max-width:8.125rem;right:0;position:absolute}.ux-header-singtel .inline-list{padding-top:.5rem!important;margin:0!important}.ux-header-singtel .inline-list .ux-anchor{margin-top:0}.ux-header-singtel a.login-button{padding:.5rem;margin-bottom:0}.ux-header-singtel .singtel-top-bar a.active{font-size:.875rem;color:#231f20}.ux-header-singtel .singtel-top-bar a.inactive{font-size:.875rem;color:#605f5f;font-family:Lato-Regular,Arial,Helvetica,sans-serif}.ux-header-singtel .header-subcontent{display:flex;font-size:.875rem}.ux-header-singtel .header-subcontent .menuList{flex:1}.ux-header-singtel .header-subcontent a{display:block;color:#231f20;font-family:Lato-Regular,Arial,Helvetica,sans-serif}.ux-header-singtel .header-subcontent li:not(:last-child){border-right:1px solid #e9e9e9}.ux-header-singtel .header-subcontent li:first-child .mega-menu-spacing{padding:1.875rem 1.875rem 1.875rem 0}.orderDetailsWidget .activity>.activity-content .event .installation .ux-header-singtel .header-subcontent .value,.ux-header-singtel .header-subcontent .orderDetailsWidget .activity>.activity-content .event .installation .value,.ux-header-singtel .header-subcontent .subsection-header,.ux-header-singtel .header-subcontent .subsection-title,.ux-header-singtel .header-subcontent .ux-heading-text .sub-section-header,.ux-header-singtel .header-subcontent .ux-heading-text-singtel .sub-section-header,.ux-header-singtel .header-subcontent .ux-phone-catalogue .show-more-phones,.ux-header-singtel .header-subcontent .ux-timeline .activity>.activity-content .event .installation .value,.ux-heading-text .ux-header-singtel .header-subcontent .sub-section-header,.ux-heading-text-singtel .ux-header-singtel .header-subcontent .sub-section-header,.ux-phone-catalogue .ux-header-singtel .header-subcontent .show-more-phones,.ux-timeline .activity>.activity-content .event .installation .ux-header-singtel .header-subcontent .value{font-size:.875rem;margin-bottom:.5rem;line-height:1;font-weight:700;color:#231f20}.ux-header-singtel .header-subcontent .mega-menu-spacing{padding:1.875rem}.ux-header-singtel ul.header-action-list{overflow:visible}.ux-header-singtel ul.header-action-list h6{margin:.5rem 1.25rem}@media (min-width:80em){.ux-header-singtel ul.header-action-list{margin-top:5px!important}.ux-header-singtel ul.header-action-list>li{float:right!important}}.ux-header-singtel ul.header-action-list .lt-ie9{margin-top:5px!important}.ux-header-singtel ul.header-action-list .lt-ie9>li{float:right!important}.ux-header-singtel ul.header-action-list .ux-icon{cursor:pointer}.ux-header-singtel ul.header-action-list .ux-icon.align-icon{float: left;}.ux-header-singtel ul.header-action-list .ux-icon.hover-state-alignment{overflow: hidden;padding-top: 2px;}.ux-header-singtel ul.header-action-list .ux-icon .icon{color:#231F20;position:relative}.ux-header-singtel ul.header-action-list .ux-icon .ux-icon span.l:after,.ux-header-singtel ul.header-action-list .ux-icon span.l:before{font-size:2.375rem}.ux-header-singtel ul.nav{cursor:default;display:inline-block;position:relative;z-index:500}.ux-header-singtel ul.nav li{list-style:none;float:left}.ux-header-singtel ul.nav li .header-link{display:block;line-height:4rem;padding:0 0 0 20px;position:relative;transition:all .3s ease;z-index:510}.ux-header-singtel .fourth-level-menu,.ux-header-singtel .mega-menu{background:#fff;box-shadow:1px 2px 10px 1px #d6d6d6;position:fixed;left:0}.ux-header-singtel ul.nav li .header-link.active{color:#ed1a3d}.ux-header-singtel ul.nav li .header-link.inactive{color:#231f20}.ux-header-singtel .nav-search input[type=text]{float:left;width:18.75rem;padding:0 .625rem}.ux-header-singtel .nav-search.search-box-width input[type=text]{width:",{"t":2,"r":"setSearchBoxWidthRem"},"rem;}.ux-header-singtel .fourth-level-menu .columns+.columns:last-child.lastMenuItem,.ux-header-singtel .fourth-level-menu-items .columns+.columns:last-child.lastMenuItem{float:right!important}.ux-header-singtel .nav-search input[type=text]:focus{border-color:#3D393A}.ux-header-singtel .nav-search .search-icon-input-background{right:0;top:1px}.ux-header-singtel .fourth-level-menu .lt-ie9,.ux-header-singtel .mega-menu .lt-ie9{top:7.625rem}.ux-header-singtel .mega-menu{width:100%;transition:all .3s ease .15s;opacity:0;visibility:hidden}.ux-header-singtel .mega-menu .row{width:1200px;margin:0 auto}.ux-header-singtel .singtel-accordion .accordion .accordion-navigation .activelink{color:#ed1a3d}.ux-header-singtel .fourth-level-menu .active,.ux-header-singtel .fourth-level-menu-items .active{color:#ed1a3d!important}.ux-header-singtel .fourthLevel .accordion .accordion-navigation>.content,.ux-header-singtel .fourthLevel .accordion .ux-marketing-banner .banner-content-outer .banner-content-inner .accordion-navigation>.banner-content,.ux-marketing-banner .banner-content-outer .banner-content-inner .ux-header-singtel .fourthLevel .accordion .accordion-navigation>.banner-content{padding:0!important}.ux-header-singtel .fourthLevel .singtel-accordion .accordion .accordion-navigation{margin-bottom:0!important}.ux-header-singtel .fourthLevel .body-copy-text{font-weight:700}.ux-header-singtel .fourth-level-menu{width:100%}@media (max-width:79.9375em){.ux-header-singtel .fourth-level-menu,.ux-header-singtel .mega-menu{top:7.625rem}}.ux-header-singtel .fourth-level-menu .row.mega-menu-spacing{width:100%}.ux-header-singtel li:hover>.mega-menu{opacity:1;overflow:visible;visibility:visible}.ux-header-singtel.relative{position:relative}@media (min-width:80em){.ux-header-singtel-itemcart .ux-modal .modal{width:450px;min-height:20rem;left:65%;top:6rem;border-radius:5px;box-shadow:1px 1px 1px 1px #d6d6d6;border-top:0}.ux-header-singtel-itemcart .ux-modal .modal .body-text{padding-top:5px;padding-bottom:10px}}@media (max-width:79.9375em){.ux-header-singtel-itemcart .ux-modal .modal{width:400px;min-height:10rem;left:50%;top:3.8rem;border-radius:5px;box-shadow:1px 1px 1px 1px #d6d6d6;border-top:0}.ux-header-singtel-itemcart .ux-modal .modal .body-text{padding-top:5px;padding-bottom:10px}}.ux-header-singtel-itemcart .ux-modal .lt-ie9 .modal{width:400px;min-height:10rem;left:50%;top:3.8rem;border-radius:5px;box-shadow:1px 1px 1px 1px #d6d6d6;border-top:0}.ux-header-singtel-itemcart .ux-modal .lt-ie9 .modal .body-text{padding-top:5px;padding-bottom:10px}@media (max-width:48.0625em){.ux-header-singtel-itemcart .ux-modal .modal{min-height:10rem;left:0;top:3.8rem;border-radius:5px;box-shadow:1px 1px 1px 1px #d6d6d6;border-top:0}.ux-header-singtel-itemcart .ux-modal .modal .body-text{padding-top:5px;padding-bottom:10px}}.ux-header-singtel-itemcart .ux-modal .modal-bg{background-color:transparent}.ux-header-singtel.hide{display:none}@media (max-width:30em){.ux-header-singtel .singtel-logo.ux-image img{height:auto}}"]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":[" ",{"t":4,"f":["singtel-header-fourth-placeholder"],"n":50,"r":"setFourthLevelMenu"},{"t":4,"n":51,"f":["singtel-header-placeholder"],"r":"setFourthLevelMenu"}," ",{"t":4,"f":["hide"],"n":50,"x":{"r":["hidePlaceHolder"],"s":"_0==true"}}," ",{"t":4,"f":["nav-overlay"],"n":50,"x":{"r":["navTheme"],"s":"_0==\"dark overlay\"||_0==\"light overlay\""}}]}}],"n":51,"r":"homePage"},{"t":7,"e":"div","a":{"class":["ux-header-singtel consentbanner-location fixed ",{"t":4,"f":["fixed-hide"],"n":50,"r":"hideBanner"},{"t":4,"n":51,"f":["fixed-show"],"r":"hideBanner"}," ",{"t":4,"f":["hide"],"n":50,"x":{"r":["hide"],"s":"_0==true"}}," ",{"t":4,"f":["relative"],"n":50,"x":{"r":["relativePosition"],"s":"_0==true"}}," ",{"t":4,"f":["fourth-level-menu-mobile"],"n":50,"r":"setFourthLevelMenu"}," ",{"t":4,"f":["nav-dark"],"n":50,"x":{"r":["navTheme"],"s":"_0==\"dark overlay\""}}," ",{"t":4,"f":["nav-light"],"n":50,"x":{"r":["navTheme"],"s":"_0==\"light overlay\""}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-large-up v-small-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ul","a":{"class":"singtel-top-bar inline-list right"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"src"}],"class":[{"t":4,"f":["active"],"n":50,"r":"active"},{"t":4,"n":51,"f":["inactive"],"r":"active"}]},"f":[{"t":2,"r":"title"}]}]}],"r":"linkItemList"}]}]}]}],"n":51,"x":{"r":["checkout"],"s":"_0===true"}}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-large-up"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"menu-wrapper","role":"navigation"},"f":[{"t":7,"e":"ul","a":{"class":["nav ",{"t":4,"f":["checkout-view v-large-top"],"n":50,"x":{"r":["checkout"],"s":"_0===true"}}," margin-left-zero"],"role":"menubar"},"f":[{"t":7,"e":"li","a":{"role":"menuitem"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"logo.link"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-image","a":{"class":"singtel-logo","img":[{"t":3,"r":"logoDark"}],"alt":[{"t":3,"r":"logoDark.alt"}]}}],"n":50,"x":{"r":["navTheme"],"s":"_0==\"dark overlay\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-image","a":{"class":"singtel-logo","img":[{"t":3,"r":"logo"}],"alt":[{"t":3,"r":"logo.alt"}]}}],"x":{"r":["navTheme"],"s":"_0==\"dark overlay\""}}]}]}," ",{"t":4,"f":[{"t":7,"e":"li","a":{"role":"menuitem"},"f":[{"t":7,"e":"div","a":{"class":"left v-normal-top checkout-text red subsection-header v-medium-left"},"f":[{"t":2,"r":"singtelHeaderCheckoutText"}]}]}," ",{"t":7,"e":"li","a":{"role":"menuitem","class":"checkout-view-verisign-logo"},"f":[{"t":7,"e":"ux-image","a":{"class":"verisign-logo","src":[{"t":2,"r":"singtelHeaderVerisignImgPath"}],"alt":[{"t":2,"x":{"r":[],"s":"\"singtelHeaderVerisignImgAlt\""}}]}}]}],"n":50,"x":{"r":["checkout"],"s":"_0===true"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"role":"menuitem"},"f":[{"t":4,"f":[{"t":7,"e":"a","m":[{"t":4,"f":["href=\"",{"t":3,"r":"src"},"\""],"n":50,"r":"addHref"}],"v":{"mouseover":"resetMenuItems","click":"onMenuItemClick"},"a":{"class":["header-link ",{"t":4,"f":["active"],"n":50,"r":"active"},{"t":4,"n":51,"f":["inactive"],"r":"active"}]},"f":[{"t":3,"r":"title"}]}],"r":"linkItem"}," ",{"t":7,"e":"div","a":{"class":"mega-menu","aria-hidden":"true","role":"menu"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ul","a":{"class":"menuListWrap header-subcontent margin-zero"},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"menuList"},"f":[{"t":7,"e":"div","a":{"class":"mega-menu-spacing"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"menuSectionTitle.src"}]},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header"},"f":[{"t":3,"r":"menuSectionTitle.title"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-copy-text"},"f":[{"t":7,"e":"a","a":{"href":[{"t":3,"r":"linkItem.src"}]},"v":{"click":"onLinkClick"},"f":[{"t":3,"r":"linkItem.title"}]}]}],"r":"menuList"}]}]}],"r":"subMenu"}]}]}]}]}]}],"i":"i","r":"headerList"}],"x":{"r":["checkout"],"s":"_0===true"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"fourth-level-menu","aria-hidden":"true","role":"menu"},"f":[{"t":7,"e":"div","a":{"class":"menuListWrap header-subcontent margin-zero"},"f":[{"t":7,"e":"ux-row","a":{"class":"mega-menu-spacing"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 small-offset-1 p-normal-left v-large-right"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"p-normal-left"},"f":[{"t":7,"e":"ux-header","a":{"level":"1","class":"section-header p-medium-left"},"f":[{"t":3,"r":"menuListFourthLevel.title"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 text-right p-none-right"},"f":[{"t":7,"e":"ux-row","a":{"class":""},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-2 body-copy-text right p-none-right ",{"t":4,"f":["lastMenuItem"],"n":50,"x":{"r":["i","menuListFourthLevel.menuList.length"],"s":"_0===_1-1"}}]},"f":[{"t":7,"e":"a","a":{"href":[{"t":3,"r":"linkItem.src"}],"class":""},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":["subsection-header ",{"t":4,"f":["active"],"n":50,"r":"linkItem.active"},{"t":4,"n":51,"f":["inactive"],"r":"linkItem.active"}]},"f":[{"t":3,"r":"linkItem.title"}]}]}]}],"n":52,"i":"i","r":"menuListFourthLevel.menuList"}]}]}]}]}]}],"n":50,"x":{"r":[],"s":"false"}}," ",{"t":4,"f":[{"t":7,"e":"ul","a":{"class":"header-action-list inline-list v-medium-top right "},"f":[" ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"role":"menuitem"},"f":[{"t":7,"e":"div","v":{"tap":"doOpenCart"},"a":{"class":"text-center relative"},"f":[" ",{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"outerClass":"shop-icon hover-state-alignment","size":"m","type":"11-cart","overIconImageAttribute":"true"}}],"n":50,"x":{"r":["anonymousUser"],"s":"_0===true||_0===\"true\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-icon","a":{"outerClass":"shop-icon hover-state-alignment","size":"m","type":"11-cart","overIconImageAttribute":"true"}}],"x":{"r":["anonymousUser"],"s":"_0===true||_0===\"true\""}}]}]}],"n":51,"r":"hideCart"}],"n":51,"r":"hideShoppingCart"}," ",{"t":4,"f":[{"t":7,"e":"li","a":{"role":"menuitem loginMenu"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"login-icon"},"f":[{"t":7,"e":"ux-icon","a":{"outerClass":"align-icon hover-state-alignment","class":"login-normal","size":"m","type":"09-login","ontap":"redirectToLogin","overIconImageAttribute":"true"}}," ",{"t":7,"e":"ux-icon","a":{"outerClass":"align-icon hover-state-alignment","class":"login-hover","size":"m","type":"09-login","ontap":"redirectToLogin","overIconImageAttribute":"true"}}]}],"n":50,"x":{"r":["currentPath","loginButtonUrl","anonymousUser","portable"],"s":"_0!=_1&&(_2===true||_2===\"true\"||_3===true)"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-singtel-login-header","a":{"datamodel":[{"t":2,"r":"headerOptions"}]},"f":[]}],"n":50,"r":"isUserLogin"}],"x":{"r":["currentPath","loginButtonUrl","anonymousUser","portable"],"s":"_0!=_1&&(_2===true||_2===\"true\"||_3===true)"}}]}],"n":51,"r":"hideLoginBtn"}," ",{"t":7,"e":"li","a":{"role":"menuitem","class":["nav-search ",{"t":4,"f":["search-box-width"],"n":50,"r":"setSearchBoxWidthRem"}," relative"]},"f":[{"t":7,"e":"ux-search-singtel","a":{"showIconInitially":"true","searchUrl":[{"t":2,"r":"googleSearchUrl"}],"searchToken":[{"t":2,"r":"googleSearchToken"}],"searchPlaceholder":[{"t":2,"r":"searchPlaceholder"}],"searchResultPageUrl":[{"t":2,"r":"searchResultPageUrl"}],"searchResultPageUrlText":[{"t":2,"r":"searchResultPageUrlText"}],"personalItemsLimit":[{"t":2,"r":"personalItemNumber"}],"businessItemsLimit":[{"t":2,"r":"businessItemNumber"}],"aboutUsItemsLimit":[{"t":2,"r":"aboutUsItemNumber"}],"maxCharactersTitleMobile":[{"t":2,"r":"maxCharactersTitleMobile"}],"maxCharactersTitleTablet":[{"t":2,"r":"maxCharactersTitleTablet"}],"maxCharactersTitleDesktop":[{"t":2,"r":"maxCharactersTitleDesktop"}],"maxCharactersDescMobile":[{"t":2,"r":"maxCharactersDescMobile"}],"maxCharactersDescTablet":[{"t":2,"r":"maxCharactersDescTablet"}],"maxCharactersDescDesktop":[{"t":2,"r":"maxCharactersDescDesktop"}]}}]}]}],"n":51,"x":{"r":["checkout"],"s":"_0===true"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom fourth-level-menu-items"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"ux-header","a":{"level":"1","class":"section-header"},"f":[{"t":3,"r":"menuListFourthLevel.title"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-8 text-right"},"f":[{"t":7,"e":"ux-row","a":{"class":""},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-2 body-copy-text right ",{"t":4,"f":["lastMenuItem"],"n":50,"x":{"r":["i","menuListFourthLevel.menuList.length"],"s":"_0===_1-1"}}]},"f":[{"t":7,"e":"a","a":{"href":[{"t":3,"r":"linkItem.src"}],"class":""},"f":[{"t":7,"e":"ux-header","a":{"level":"6","class":["margin-zero ",{"t":4,"f":["active"],"n":50,"r":"linkItem.active"},{"t":4,"n":51,"f":["inactive"],"r":"linkItem.active"}]},"f":[{"t":3,"r":"linkItem.title"}]}]}]}],"n":52,"i":"i","r":"menuListFourthLevel.menuList"}]}]}]}]}],"n":50,"r":"setFourthLevelMenu"}]}," ",{"t":7,"e":"ux-row","a":{"class":["hide-for-large-up p-medium-top ",{"t":4,"f":["p-medium-bottom"],"n":50,"x":{"r":["setFourthLevelMenu"],"s":"!_0"}}]},"f":[" ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"logo.link"}],"class":"p-medium-left flex-container flex-container-start"},"f":[{"t":4,"f":[{"t":7,"e":"ux-image","a":{"class":"singtel-logo","src":[{"t":3,"r":"logoDark.src"}],"alt":[{"t":3,"r":"logoDark.alt"}]}}],"n":50,"x":{"r":["navTheme"],"s":"_0==\"dark overlay\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-image","a":{"class":"singtel-logo","src":[{"t":3,"r":"logo.src"}],"alt":[{"t":3,"r":"logo.alt"}]}}],"x":{"r":["navTheme"],"s":"_0==\"dark overlay\""}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"mobile-header-action-list small-8 flex-container flex-container-end"},"f":[{"t":7,"e":"ux-search-singtel","a":{"class":"v-normal-top","showIconInitially":"true","searchUrl":[{"t":2,"r":"googleSearchUrl"}],"searchToken":[{"t":2,"r":"googleSearchToken"}],"searchPlaceholder":[{"t":2,"r":"searchPlaceholder"}],"searchResultPageUrl":[{"t":2,"r":"searchResultPageUrl"}],"searchResultPageUrlText":[{"t":2,"r":"searchResultPageUrlText"}],"personalItemsLimit":[{"t":2,"r":"personalItemNumber"}],"businessItemsLimit":[{"t":2,"r":"businessItemNumber"}],"aboutUsItemsLimit":[{"t":2,"r":"aboutUsItemNumber"}],"maxCharactersTitleMobile":[{"t":2,"r":"maxCharactersTitleMobile"}],"maxCharactersTitleTablet":[{"t":2,"r":"maxCharactersTitleTablet"}],"maxCharactersTitleDesktop":[{"t":2,"r":"maxCharactersTitleDesktop"}],"maxCharactersDescMobile":[{"t":2,"r":"maxCharactersDescMobile"}],"maxCharactersDescTablet":[{"t":2,"r":"maxCharactersDescTablet"}],"maxCharactersDescDesktop":[{"t":2,"r":"maxCharactersDescDesktop"}]}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"login shopping-car-icon v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"login-icon"},"f":[{"t":7,"e":"ux-icon","a":{"outerClass":"align-icon hover-state-alignment","class":"login-normal","size":"m","type":"09-login","ontap":"redirectToLogin","overIconImageAttribute":"true"}}," ",{"t":7,"e":"ux-icon","a":{"outerClass":"align-icon hover-state-alignment","class":"login-hover","size":"m","type":"09-login","ontap":"redirectToLogin","overIconImageAttribute":"true"}}]}]}],"n":50,"x":{"r":["currentPath","loginButtonUrl","anonymousUser"],"s":"_0!=_1&&(_2===true||_2===\"true\")"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-singtel-login-header","a":{"datamodel":[{"t":2,"r":"headerOptions"}]}}],"n":50,"r":"isUserLogin"}],"x":{"r":["currentPath","loginButtonUrl","anonymousUser"],"s":"_0!=_1&&(_2===true||_2===\"true\")"}}],"n":51,"r":"hideLoginBtn"}," ",{"t":4,"f":[{"t":7,"e":"ux-image","a":{"class":"verisign-logo","src":[{"t":2,"r":"singtelHeaderVerisignImgPath"}],"alt":[{"t":2,"x":{"r":[],"s":"\"singtelHeaderVerisignImgAlt\""}}]}}],"n":50,"x":{"r":["checkout"],"s":"_0===true"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","v":{"tap":"doOpenCart"},"a":{"class":"text-center shopping-car-icon v-normal-top"},"f":[{"t":4,"f":[" ",{"t":7,"e":"ux-icon","a":{"outerClass":"shop-icon hover-state-alignment","size":"m","type":"11-cart","overIconImageAttribute":"true"}}," "],"n":51,"r":"hideCartItem"}]}],"n":51,"r":"hideCart"}],"n":51,"r":"hideShoppingCart"}],"x":{"r":["checkout"],"s":"_0===true"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"left v-normal-top checkout-text red subsection-header v-medium-left"},"f":[{"t":2,"r":"singtelHeaderCheckoutText"}]}],"n":50,"x":{"r":["checkout"],"s":"_0===true"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"mobile-menu-icon text-center"},"f":[{"t":7,"e":"ux-icon","a":{"ontap":"doOpenMenu","size":"m","type":"12-menu","class":"left v-normal-top","outerClass":"menu-icon hover-state-alignment"}}]}],"x":{"r":["checkout"],"s":"_0===true"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"hide-for-large-up fourthLevel"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"panel-divider v-large"}}," ",{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-accordion","a":{"menuListFourthLevel":[{"t":2,"r":"mobileMenuListFourthLevel"}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"ux-row","f":[" ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-item small-10"},"f":[{"t":7,"e":"ux-header","a":{"level":"1","class":"section-header"},"f":[{"t":3,"r":"menuListFourthLevel.title"}]}]}," ",{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["v-xx-large-top ",{"t":4,"f":["v-large"],"n":50,"x":{"r":["i","menuListFourthLevel.menuList.length"],"s":"_0==(_1-1)"}}," body-copy-text"]},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"linkItem.src"}],"class":["full-width-link ",{"t":4,"f":["activelink"],"n":50,"r":"linkItem.active"}]},"f":[{"t":3,"r":"linkItem.title"}]}]}],"i":"i","r":"menuListFourthLevel.menuList"}]}]}]}]}]}]}],"n":50,"r":"setFourthLevelMenu"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-header-singtel-mobile"},"f":[{"t":7,"e":"div","a":{"class":"ux-modal"},"f":[{"t":7,"e":"div","t1":{"n":"fly","a":[{"x":-200,"y":0,"duration":400}]},"t2":{"n":"fly","a":[{"x":-200,"y":0,"duration":400}]},"a":{"class":"modal light-theme"},"f":[{"t":7,"e":"a","a":{"class":"close-modal  menu-close-modal"},"v":{"tap":"doCloseMenu"},"f":[{"t":7,"e":"ux-icon","a":{"type":"close-line"}}]}," ",{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"src"}],"class":"link-item-link-mobile full-width-link"},"f":[{"t":3,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"r":"title"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-accordion","a":{"subDisplay":[{"t":3,"r":"subDisplay"}],"headerList":[{"t":3,"r":"headerList"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-accordionitem","a":{"headerListData":[{"t":3,"r":"."}]},"f":[{"t":7,"e":"ux-anchor","a":{"headerListData":[{"t":3,"r":"."}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-left v-medium-top"},"f":[{"t":3,"r":"linkItem.title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":["small-3 ",{"t":4,"f":["hide"],"n":50,"x":{"r":["subMenu","subMenu.length"],"s":"!_0||_1===0"}}]},"f":["  ",{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top body-copy-text"},"f":[{"t":7,"e":"ux-anchor","a":{"subMenuData":[{"t":3,"r":"."}],"ontap":"openMobileSub","class":"full-width-link"},"f":[{"t":3,"r":"menuSectionTitle.title"}]}]}],"r":"subMenu"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"r":"headerList"}]}]}],"n":50,"r":"active"}],"r":"linkItemList"}]}]}]}]}],"n":50,"x":{"r":["display","subDisplayFlag"],"s":"_0&&!_1"}},{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-header-singtel-mobile"},"f":[{"t":7,"e":"div","a":{"class":"ux-modal","modal_id":"MobileSub"},"f":[{"t":7,"e":"div","t1":{"n":"fly","a":[{"x":-200,"y":0,"duration":400}]},"t2":{"n":"fly","a":[{"x":-200,"y":0,"duration":400}]},"a":{"class":"modal light-theme"},"f":[{"t":7,"e":"a","a":{"class":"close-modal  menu-close-modal"},"v":{"tap":"doCloseAllMenu"},"f":[{"t":7,"e":"ux-icon","a":{"type":"close-line"}}]}," ",{"t":7,"e":"a","a":{"class":"close-modal back"},"v":{"tap":"doCloseSubMenu"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-left"}}]}," ",{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"link-item-link-mobile full-width-link","href":[{"t":3,"r":"subMenuLink"}]},"f":[{"t":3,"r":"subMenuTitle"}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top v-medium-left"},"f":[{"t":7,"e":"a","a":{"href":[{"t":3,"r":"linkItem.src"}],"class":"body-copy-text full-width-link"},"v":{"click":"onLinkClick"},"f":[{"t":3,"r":"linkItem.title"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"r":"linkItem.title"}],"r":"subMenuContext"}]}]}]}]}],"r":"subMenuObject"}],"n":50,"x":{"r":["subDisplayFlag","display"],"s":"_0&&!_1"}},{"t":7,"e":"div","a":{"class":"ux-header-singtel-itemcart"},"f":[{"t":4,"f":[{"t":7,"e":"ux-modal","a":{"class":"light-theme","modalId":"itemcart"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":["Items in your cart"]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":["There",{"t":4,"f":[" are"],"n":50,"x":{"r":["shoppingItemNum"],"s":"_0>1"}},{"t":4,"n":51,"f":[" is"],"x":{"r":["shoppingItemNum"],"s":"_0>1"}}," ",{"t":2,"r":"shoppingItemNum"}," item",{"t":4,"f":["s"],"n":50,"x":{"r":["shoppingItemNum"],"s":"_0>1"}}," in your cart."]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-text"},"f":[{"t":2,"r":"title"}]}],"r":"shoppingItemList"}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"ux-button","a":{"class":"round","onclick":"doCheckout","text":"Proceed to Checkout"},"f":[]}]}],"r":"displayCart"}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"eshopModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":[{"t":2,"r":"rrpEshopHeader"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","a":{"class":"light"},"f":[{"t":2,"r":"rrpEshopMsg"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-large-top section-details"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 v-normal-top text-center-small"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"doCancelRedirection"},"f":["Cancel"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 text-right v-medium-top"},"f":[{"t":7,"e":"ux-button","a":{"class":"round light margin-zero small-only-expand","text":"Proceed","onclick":"doRedirectModalToEshopURL"},"f":[]}]}]}]}]};
this["ux-heading-text"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-heading-text ",{"t":4,"f":["hide"],"n":51,"r":"showHeadingText"}," ",{"t":4,"f":["text-",{"t":2,"r":"mobileTextStyle"}],"n":50,"r":"mobileTextStyle"}," ",{"t":4,"f":[{"t":2,"r":"theme"}],"n":50,"r":"theme"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["leftSpacing"],"s":"_0?_0:\"normal\""}},"-left"],"n":50,"r":"leftSpacing"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["rightSpacing"],"s":"_0?_0:\"normal\""}},"-right"],"n":50,"r":"rightSpacing"}," ",{"t":4,"f":["v-minus-large-top"],"n":50,"r":"normalWidthHeight"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["topSpacing"],"s":"_0"},"f":["v-",{"t":2,"x":{"r":["topSpacing"],"s":"_0?_0:\"normal\""}},"-top"]}],"r":"normalWidthHeight"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["bottomSpacing"],"s":"_0?_0:\"normal\""}},"-bottom"],"n":50,"r":"bottomSpacing"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"clearfix moveTop"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":[{"t":2,"r":"mobileHeadingStyle"}],"n":50,"r":"mobileHeadingStyle"}]},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":[{"t":4,"f":[{"t":2,"r":"theme"}," "],"n":50,"r":"theme"},{"t":2,"x":{"r":["headingStyle"],"s":"_0?_0:\"main-header\""}}]},"f":[{"t":2,"r":"heading"}]}]}],"n":50,"r":"heading"}," ",{"t":7,"e":"div","a":{"class":[{"t":4,"f":[{"t":2,"r":"mobileDescriptionStyle"}],"n":50,"r":"mobileDescriptionStyle"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["description-text ",{"t":2,"x":{"r":["descStyle"],"s":"_0?_0:\"body-copy-text\""}}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["headerDescSpacing"],"s":"_0?_0:\"normal\""}},"-top"],"n":50,"r":"headerDescSpacing"}," ",{"t":4,"f":["hide-for-small-only"],"n":50,"r":"hideDescriptionForMobile"}]},"f":[{"t":3,"r":"text"}]}],"n":50,"r":"text"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"link"}],"class":"weight-medium"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"linkText"}]}]}]}],"n":50,"r":"panel"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":[{"t":2,"r":"mobileHeadingStyle"}],"n":50,"r":"mobileHeadingStyle"}]},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":[{"t":4,"f":[{"t":2,"r":"theme"}," "],"n":50,"r":"theme"},{"t":2,"x":{"r":["headingStyle"],"s":"_0?_0:\"main-header\""}}]},"f":[{"t":2,"r":"heading"}]}]}],"n":50,"r":"heading"}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":[{"t":2,"r":"mobileDescriptionStyle"}],"n":50,"r":"mobileDescriptionStyle"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["left-align-text"],"n":50,"r":"descLeftAlign"}," description-text ",{"t":2,"x":{"r":["descStyle"],"s":"_0?_0:\"body-copy-text\""}}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["headerDescSpacing"],"s":"_0?_0:\"normal\""}},"-top"],"n":50,"r":"headerDescSpacing"}]},"f":[{"t":3,"r":"text"}]}],"n":50,"r":"text"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"link"}],"class":"weight-medium"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"linkText"}]}]}],"r":"panel"}]}]}]};
this["ux-hero-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-hero-banner ",{"t":2,"r":"$bannerHeightModifier"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"ctaUrl"}]},"f":[{"t":7,"e":"div","a":{"class":["banner-background ",{"t":2,"r":"$themeCSSClass"}," ",{"t":2,"r":"backgroundImgMobilePosition"}," ",{"t":2,"r":"backgroundImgMobileSize"}," ",{"t":2,"r":"mobileImgHeight"}],"style":["background-image: url('",{"t":2,"r":"backgroundImgMobile"},"');",{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":["banner-image ",{"t":2,"r":"mobileImgHeight"}]},"f":[{"t":7,"e":"div","a":{"class":["image ",{"t":2,"r":"foregroundImgMobilePosition"}," ",{"t":2,"r":"foregroundImgMobileSize"}]},"m":[{"t":4,"f":["style=\"background-image: url('",{"t":2,"r":"foregroundImg.mobile.src"},"')\""],"n":50,"r":"foregroundImg.mobile.src"}],"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"logo-image"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"logoImage.src"}],"alt":[{"t":2,"r":"logoImage.alt"}]}}]}],"n":50,"x":{"r":["logoImage","logoImage.src"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"copy v-small-bottom"},"f":[{"t":3,"r":"topCaption"}]}],"n":50,"r":"topCaption"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"hero-text v-normal-bottom"},"f":[{"t":3,"r":"title"}]}],"n":50,"r":"title"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"copy v-normal-bottom"},"f":[{"t":3,"r":"paragraph"}]}],"n":50,"r":"paragraph"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscript-text"},"f":[{"t":3,"r":"label"}]}],"n":50,"r":"label"}," ",{"t":7,"e":"div","a":{"class":"product-price clearfix"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","sellingPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["hideSellingPrice","sellingPrice"],"s":"!_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers.convertUnits","overwriteSellingPrice"],"s":"_0(_1,\"$\")"}}]}],"n":50,"r":"overwriteSellingPrice"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"strike-through-dollar"},"f":[{"t":3,"r":"listedPrice"}]}],"n":50,"r":"listedPrice"}]}," ",{"t":7,"e":"div","a":{"class":"copy v-small-top"},"f":[{"t":3,"r":"plan"}]}]}]}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"ctaUrl"}]},"f":[{"t":7,"e":"div","a":{"class":["banner-background ",{"t":2,"r":"$themeCSSClass"}," ",{"t":2,"r":"backgroundImgDesktopPosition"}," ",{"t":2,"r":"backgroundImgDesktopSize"}],"style":["background-image: url('",{"t":2,"r":"backgroundImgDesktop"},"');",{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":["medium-5 medium-offset-1 ",{"t":2,"r":"$alignmentCSS"}]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"logo-image"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"logoImage.src"}],"alt":[{"t":2,"r":"logoImage.alt"}]}}]}],"n":50,"x":{"r":["logoImage","logoImage.src"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"copy v-small-bottom"},"f":[{"t":3,"r":"topCaption"}]}],"n":50,"r":"topCaption"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"hero-text v-normal-bottom"},"f":[{"t":3,"r":"title"}]}],"n":50,"r":"title"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"copy v-normal-bottom"},"f":[{"t":3,"r":"paragraph"}]}],"n":50,"r":"paragraph"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscript-text"},"f":[{"t":3,"r":"label"}]}],"n":50,"r":"label"}," ",{"t":7,"e":"div","a":{"class":"product-price clearfix"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","sellingPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["hideSellingPrice","sellingPrice"],"s":"!_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","overwriteSellingPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"overwriteSellingPrice"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"strike-through-dollar"},"f":[{"t":3,"r":"listedPrice"}]}],"n":50,"r":"listedPrice"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"copy"},"f":[{"t":3,"r":"plan"}]}],"n":50,"r":"plan"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 medium-6 ",{"t":2,"r":"$alignmentCSS"}]},"f":[{"t":7,"e":"div","a":{"class":"banner-image"},"f":[{"t":7,"e":"div","a":{"class":["image ",{"t":2,"r":"foregroundImgDesktopPosition"}," ",{"t":2,"r":"foregroundImgDesktopSize"}],"style":["background-image: url('",{"t":2,"r":"foregroundImg.desktop.src"},"')"]},"f":[]}]}]}],"n":50,"r":"foregroundImg.desktop.src"}]}]}]}]}],"n":50,"r":"isImgLink"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":["show-for-small-only banner-background ",{"t":2,"r":"$themeCSSClass"}," ",{"t":2,"r":"backgroundImgMobilePosition"}," ",{"t":2,"r":"backgroundImgMobileSize"}," ",{"t":2,"r":"mobileImgHeight"}],"style":["background-image: url('",{"t":2,"r":"backgroundImgMobile"},"');",{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":["banner-image ",{"t":2,"r":"mobileImgHeight"}]},"f":[{"t":7,"e":"div","a":{"class":["image ",{"t":2,"r":"foregroundImgMobilePosition"}," ",{"t":2,"r":"foregroundImgMobileSize"}]},"m":[{"t":4,"f":["style=\"background-image: url('",{"t":2,"r":"foregroundImg.mobile.src"},"')\""],"n":50,"r":"foregroundImg.mobile.src"}],"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"logo-image"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"logoImage.src"}],"alt":[{"t":2,"r":"logoImage.alt"}]}}]}],"n":50,"x":{"r":["logoImage","logoImage.src"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"copy v-small-bottom"},"f":[{"t":3,"r":"topCaption"}]}],"n":50,"r":"topCaption"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"hero-text v-normal-bottom"},"f":[{"t":3,"r":"title"}]}],"n":50,"r":"title"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"copy v-normal-bottom"},"f":[{"t":3,"r":"paragraph"}]}],"n":50,"r":"paragraph"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscript-text"},"f":[{"t":3,"r":"label"}]}],"n":50,"r":"label"}," ",{"t":7,"e":"div","a":{"class":"product-price clearfix"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","sellingPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["hideSellingPrice","sellingPrice"],"s":"!_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","overwriteSellingPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"overwriteSellingPrice"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"strike-through-dollar"},"f":[{"t":3,"r":"listedPrice"}]}],"n":50,"r":"listedPrice"}]}," ",{"t":7,"e":"div","a":{"class":"copy v-small-top"},"f":[{"t":3,"r":"plan"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"id":[{"t":4,"f":[{"t":2,"r":"ctaUrl"}],"n":50,"r":"openModal"}],"type":[{"t":4,"f":["modal"],"n":50,"r":"openModal"},{"t":4,"n":51,"f":["anchor"],"r":"openModal"}],"pmodalData":[{"t":2,"r":"pmodalData"}],"target":[{"t":4,"f":["_blank"],"n":50,"x":{"r":["openNewWindow"],"s":"_0==\"true\""}},{"t":4,"n":51,"f":["_self"],"x":{"r":["openNewWindow"],"s":"_0==\"true\""}}],"class":["v-normal-top ",{"t":4,"f":["ux-button button round ",{"t":2,"r":"$buttonCSSClass"}],"n":50,"r":"isButton"},{"t":4,"n":51,"f":["bannerLink"],"r":"isButton"}],"href":[{"t":2,"r":"ctaUrl"}],"ontap":[{"t":2,"r":"ontap"}]},"f":[{"t":2,"r":"ctaLabel"}]}],"n":50,"r":"ctaLabel"}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":["show-for-medium-up banner-background ",{"t":2,"r":"$themeCSSClass"}," ",{"t":2,"r":"backgroundImgDesktopPosition"}," ",{"t":2,"r":"backgroundImgDesktopSize"}],"style":["background-image: url('",{"t":2,"r":"backgroundImgDesktop"},"');",{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":["medium-5 medium-offset-1 ",{"t":2,"r":"$alignmentCSS"}]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"logo-image"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"logoImage.src"}],"alt":[{"t":2,"r":"logoImage.alt"}]}}]}],"n":50,"x":{"r":["logoImage","logoImage.src"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"copy v-small-bottom"},"f":[{"t":3,"r":"topCaption"}]}],"n":50,"r":"topCaption"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"hero-text v-normal-bottom"},"f":[{"t":3,"r":"title"}]}],"n":50,"r":"title"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"copy v-normal-bottom"},"f":[{"t":3,"r":"paragraph"}]}],"n":50,"r":"paragraph"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscript-text"},"f":[{"t":3,"r":"label"}]}],"n":50,"r":"label"}," ",{"t":7,"e":"div","a":{"class":"product-price clearfix"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","sellingPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["hideSellingPrice","sellingPrice"],"s":"!_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","overwriteSellingPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"overwriteSellingPrice"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"strike-through-dollar"},"f":[{"t":3,"r":"listedPrice"}]}],"n":50,"r":"listedPrice"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"copy"},"f":[{"t":3,"r":"plan"}]}],"n":50,"r":"plan"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"id":[{"t":4,"f":[{"t":2,"r":"ctaUrl"}],"n":50,"r":"openModal"}],"type":[{"t":4,"f":["modal"],"n":50,"r":"openModal"},{"t":4,"n":51,"f":["anchor"],"r":"openModal"}],"pmodalData":[{"t":2,"r":"pmodalData"}],"target":[{"t":4,"f":["_blank"],"n":50,"x":{"r":["openNewWindow"],"s":"_0==\"true\""}},{"t":4,"n":51,"f":["_self"],"x":{"r":["openNewWindow"],"s":"_0==\"true\""}}],"class":["v-normal-top ",{"t":4,"f":["ux-button button round ",{"t":2,"r":"$buttonCSSClass"}],"n":50,"r":"isButton"},{"t":4,"n":51,"f":["bannerLink"],"r":"isButton"}],"href":[{"t":2,"r":"ctaUrl"}],"ontap":[{"t":2,"r":"ontap"}]},"f":[{"t":2,"r":"ctaLabel"}]}],"n":50,"r":"ctaLabel"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 medium-6 ",{"t":2,"r":"$alignmentCSS"}]},"f":[{"t":7,"e":"div","a":{"class":"banner-image"},"f":[{"t":7,"e":"div","a":{"class":["image ",{"t":2,"r":"foregroundImgDesktopPosition"}," ",{"t":2,"r":"foregroundImgDesktopSize"}],"style":["background-image: url('",{"t":2,"r":"foregroundImg.desktop.src"},"')"]},"f":[]}]}]}],"n":50,"r":"foregroundImg.desktop.src"}]}]}],"r":"isImgLink"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-homeline-appointment-form"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-homeline-appointment-form medium-5"},"o":{"n":"loadMask","a":[{"class":"full-screen"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-row","a":{"class":"column-control-mobile"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","a":{"class":"panel30 margin-zero p-none-top p-none-bottom"},"f":[{"t":7,"e":"ux-accordion","a":{"slot":[{"t":2,"r":"."}],"moment":[{"t":2,"r":"moment"}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"class":"service-accordion"},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-10"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header"},"f":[{"t":2,"r":"slot.date"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2"},"f":[{"t":7,"e":"ux-row","a":{"class":"expand-collapse-icon right"},"f":[{"t":7,"e":"i","a":{"class":"icon"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item clearfix p-none-left p-none-right"},"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal p-large-left"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","v":{"tap":{"n":"selectTimeSlot","d":[{"t":2,"rx":{"r":"slot.time","m":[{"t":30,"n":"i"}]}}]}},"a":{"slot":[{"t":2,"rx":{"r":"slot.time","m":[{"t":30,"n":"i"}]}}]},"f":[{"t":2,"x":{"r":["moment","i","slot.time"],"s":"_0(parseInt(_2[_1].appointmentStartDate),\"YYYYMMDDHHmm\").format(\"hh:mm A\")"}}," - ",{"t":2,"x":{"r":["moment","i","slot.time"],"s":"_0(parseInt(_2[_1].appointmentEndDate),\"YYYYMMDDHHmm\").format(\"hh:mm A\")"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":52,"i":"i","r":"slot.time"}]}]}]}]}]}]}]}],"n":52,"i":"i","r":"sortedAppoitments"}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal text-center"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-anchor","a":{"class":"round margin-zero","ontap":"switchView:CALENDER,DEFAULT"},"f":[{"t":2,"r":"showMoreSlot"}]}]}]}],"n":50,"x":{"r":["view"],"s":"_0==\"DEFAULT\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["view"],"s":"_0==\"CALENDER\""},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-date-time-picker","a":{"minDate":[{"t":2,"r":"minDate"}],"maxDate":[{"t":2,"r":"maxDate"}],"timeSelectionType":"buttons","selected_date":[{"t":2,"r":"selected_date"}],"disable_weekends":"true","disableDaysFunc":[{"t":2,"r":"RactiveHelpers.disableSunday"}],"defaultDate":[{"t":2,"r":"minDate"}],"setDefaultDate":"true","enabledDays":[{"t":2,"r":"availableApptDates"}]},"f":[]}],"n":50,"x":{"r":["minDate","maxDate"],"s":"_0&&_1"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 text-center"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"round  button light margin-zero small-only-expand","ontap":"switchView:DATE,CALENDER"},"f":["Next"]}]}]}]},{"t":4,"n":50,"x":{"r":["view"],"s":"(!(_0==\"CALENDER\"))&&(_0==\"DATE\")"},"f":[" ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal p-large-left"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","v":{"tap":"selectTimeSlot"},"a":{"slot":[{"t":2,"rx":{"r":"timeSlot","m":[{"t":30,"n":"i"}]}}]},"f":[{"t":2,"x":{"r":["moment","appointmentStartDate"],"s":"_0(parseInt(_1),\"YYYYMMDDHHmm\").format(\"hh:mm A\")"}}," - ",{"t":2,"x":{"r":["moment","appointmentEndDate"],"s":"_0(parseInt(_1),\"YYYYMMDDHHmm\").format(\"hh:mm A\")"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":52,"i":"i","r":"timeSlot"}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 text-center"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"round  button light margin-zero small-only-expand","ontap":"switchView:CALENDER,DATE"},"f":["Back"]}]}]}]}],"x":{"r":["view"],"s":"_0==\"DEFAULT\""}}]}]};
this["ux-homeline-appointment-summary"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-homeline-appointment-summary medium-5"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header"},"f":[{"t":2,"r":"title"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider v-normal"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"contactNoLabel"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","contactNo"],"s":"_0.mobileNumberFormat(_1)"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"dateLabel"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"date"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"timeLabel"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"startTime"}," - ",{"t":2,"r":"endTime"}]}]}]}]};
this["ux-homeline-contact-form"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-homeline-contact-form medium-5"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":[{"t":2,"r":"mobileHeadingStyle"}],"n":50,"r":"mobileHeadingStyle"}]},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":[{"t":2,"r":"headingStyle"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["leftSpacing"],"s":"_0?_0:\"normal\""}},"-left"],"n":50,"r":"leftSpacing"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["rightSpacing"],"s":"_0?_0:\"normal\""}},"-right"],"n":50,"r":"rightSpacing"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["topSpacing"],"s":"_0?_0:\"normal\""}},"-top"],"n":50,"r":"topSpacing"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["bottomSpacing"],"s":"_0?_0:\"normal\""}},"-bottom"],"n":50,"r":"bottomSpacing"}]},"f":[{"t":2,"r":"title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":2,"r":"descStyle"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["headerDescSpacing"],"s":"_0?_0:\"normal\""}},"-top"],"n":50,"r":"headerDescSpacing"}]},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":[{"t":2,"r":"mobileDescriptionStyle"}],"n":50,"r":"mobileDescriptionStyle"}]},"f":[{"t":2,"r":"description"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-input-box","a":{"placeholder":[{"t":2,"r":"contactNumberPlaceHolder"}],"value":[{"t":2,"r":"contactNo"}],"validity":[{"t":2,"r":"contactNoErrorMsg"}],"maxLength":"8","onblurEvent":"onBlurContact"}}]}]}]}]};
this["ux-homeline-rating"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-homeline-rating text-",{"t":2,"r":"componentIndentation"}," medium-5"]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":[{"t":2,"r":"titleStyle"}]},"f":[{"t":2,"r":"title"}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":2,"r":"description"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"rating v-normal left"},"f":[{"t":4,"f":[{"t":7,"e":"input","v":{"click":"ratingSelection"},"a":{"type":"radio","id":["star_",{"t":2,"rx":{"r":"ratingValues","m":[{"t":30,"n":"i"}]}}],"name":"webform_starsValues","value":[{"t":2,"rx":{"r":"ratingValues","m":[{"t":30,"n":"i"}]}}]}},{"t":7,"e":"label","a":{"for":["star_",{"t":2,"rx":{"r":"ratingValues","m":[{"t":30,"n":"i"}]}}]}}],"i":"i","r":"ratingValues"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal"},"f":[{"t":2,"r":"thankYouMsg"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-offset-2 small-8"},"f":[{"t":7,"e":"ux-button","a":{"text":"Back to home","class":"round light margin-zero","action":"CLOSE","onclick":"ratingAction"}}]}]}],"n":50,"r":"isRatingSubmited"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"ux-button","a":{"text":"Not now","class":"round left light margin-zero","action":"CLOSE","onclick":"ratingAction"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-5"},"f":[{"t":7,"e":"ux-button","a":{"text":"Submit","class":["round right margin-zero ",{"t":4,"f":["disabled"],"n":51,"r":"selectedStarValue"}],"action":"SUBMIT","onclick":"ratingAction"}}]}]}],"r":"isRatingSubmited"}]}]};
this["ux-homeline-tech-asst"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-homeline-tech-asst"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header v-normal-bottom"},"f":[{"t":2,"r":"hlTechAsstHeader"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"section-title v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":3,"r":"hlTechAsstConfirmationDescription"}]}]}],"n":50,"r":"transferRequsetSubmitted"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"section-title v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-left"},"f":[{"t":2,"r":"hlTechAsstDescription"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-left"},"f":[{"t":7,"e":"ux-input-box","a":{"type":"text","value":[{"t":2,"r":"contactNo"}],"onblurEvent":"onBlurContact","maxLength":"8","validity":[{"t":2,"r":"contactNoErrorMsg"}]}}]}]}],"r":"transferRequsetSubmitted"}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":[{"t":7,"e":"ux-button","a":{"class":"round margin-zero v-medium-left","onclick":"callModalBtnEvent","action":"CANCEL","text":"Cancel"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-offset-2 small-5"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"round margin-zero button v-medium-left","action":"NEXT","href":"tel:1688","onmousedown":"callModalBtnEvent"},"f":["Next"]}]}],"n":50,"r":"transferRequsetSubmitted"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"small-offset-2 small-5"},"f":[{"t":7,"e":"ux-button","a":{"class":["round margin-zero v-medium-left ",{"t":4,"f":["disabled"],"n":51,"r":"isValid"}," ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["contactNo.length"],"s":"_0<8"}}],"action":"CALL","onclick":"callModalBtnEvent","text":"Next"}}]}],"r":"transferRequsetSubmitted"}]}]}]};
this["ux-homeline-vertical-tout"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-homeline-vertical-tout"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"text-center vertical-tout-container","style":["height:",{"t":2,"r":"height"},"px"]},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-image","a":{"img":[{"t":2,"r":"img"}]}}," ",{"t":7,"e":"div","a":{"class":"product-title no-wrap"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"sub-section-header"},"f":[{"t":3,"x":{"r":["RactiveHelpers","text"],"s":"_0.unescapeString(_1)"}}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-homepage-banner-image"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-homepage-banner-image"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"r":"theme"}]},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":["banner-background ux-homepage-banner-img ",{"t":2,"r":"theme"}," ",{"t":2,"r":"backgroundImage.desktop.imagePosition"}],"style":["background-image: url('",{"t":2,"r":"backgroundImage.desktop.src"},"');"]},"f":[]}," ",{"t":7,"e":"ux-row","a":{"class":"banner-content-container"},"f":[{"t":7,"e":"ux-col","a":{"class":["medium-5 medium-offset-1 ",{"t":2,"r":"textAlignment"}," banner-content"]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"hero-text v-medium-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":3,"x":{"r":["RactiveHelpers","description"],"s":"_0.unescapeString(_1)"}}]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"div","a":{"class":"hero-button"},"f":[{"t":7,"e":"ux-button","a":{"class":"round","text":[{"t":2,"r":"buttonText"}],"href":[{"t":2,"r":"buttonLink"}]}}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":["banner-background ux-homepage-banner-img ",{"t":2,"r":"theme"}," ",{"t":2,"r":"backgroundImage.mobile.imagePosition"}],"style":["background-image: url('",{"t":2,"r":"backgroundImage.mobile.src"},"')"]}}," ",{"t":7,"e":"div","a":{"class":"text-center"},"f":[{"t":7,"e":"div","a":{"class":"hero-text v-medium-top v-medium-bottom v-xx-large-left v-xx-large-right"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":3,"x":{"r":["RactiveHelpers","description"],"s":"_0.unescapeString(_1)"}}]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"div","a":{"class":"hero-button"},"f":[{"t":7,"e":"ux-button","a":{"class":"round","text":[{"t":2,"r":"buttonText"}],"href":[{"t":2,"r":"buttonLink"}]}}]}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-homepage-banner-video"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-homepage-banner-video"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"r":"theme"}]},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"banner-background background-video"},"f":[{"t":7,"e":"iframe","a":{"class":"video","id":"ytplayer","frameborder":"0","src":[{"t":2,"r":"videoURL"}]}}]}," ",{"t":7,"e":"ux-row","a":{"class":"banner-content-container"},"f":[{"t":7,"e":"ux-col","a":{"class":["large-offset-1 small-12 medium-9 large-4 ",{"t":2,"r":"textAlignment"}," banner-content"]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"badges-text"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"hero-text"},"f":[{"t":2,"r":"description"}]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"div","a":{"class":"hero-button"},"f":[{"t":7,"e":"ux-button","a":{"class":"round","text":[{"t":2,"r":"buttonText"}],"href":[{"t":2,"r":"buttonLink"}]}}]}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-2 large-6"},"f":[{"t":7,"e":"div","a":{"class":"video-btn-container text-right"},"f":[{"t":7,"e":"div","a":{"class":"video-play-btn"},"v":{"tap":{"n":"playForegroundVideo","a":"playVideoId"}},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"playButtonImage.src"}]}}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"banner-background ux-homepage-banner-img","style":["background-image: url('",{"t":2,"r":"backgroundImage.mobile.src"},"')"]}}," ",{"t":7,"e":"div","a":{"class":"text-center"},"f":[{"t":7,"e":"div","a":{"class":"badges-text"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"hero-text"},"f":[{"t":2,"r":"description"}]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"div","a":{"class":"hero-button"},"f":[{"t":7,"e":"ux-button","a":{"class":"round","text":[{"t":2,"r":"buttonText"}],"href":[{"t":2,"r":"buttonLink"}]}}]}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}," ",{"t":7,"e":"ux-modal","a":{"width":"1068","class":"light-theme","modalId":"playVideoId","hideTitle":"true"},"f":[{"t":7,"e":"div","a":{"class":"modal-video"},"f":[{"t":7,"e":"iframe","a":{"class":"video","frameborder":"0","src":[{"t":2,"r":"foregroundVideoURL"}]},"f":[]}]}]}]}]};
this["ux-homepage-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-homepage-banner"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":["banner-background ",{"t":2,"r":"theme"}," ",{"t":2,"r":"backgroundImgMobilePosition"}," ",{"t":2,"r":"backgroundImgMobileSize"}," ",{"t":2,"r":"mobileImgHeight"}],"style":["background-image: url('",{"t":2,"r":"backgroundImgMobile"},"');",{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":["banner-image ",{"t":2,"r":"mobileImgHeight"}]},"f":[{"t":7,"e":"div","a":{"class":["image ",{"t":2,"r":"foregroundImgMobilePosition"}," ",{"t":2,"r":"foregroundImgMobileSize"}]},"m":[{"t":4,"f":["style=\"background-image: url('",{"t":2,"r":"foregroundImg.mobile.src"},"')\""],"n":50,"r":"foregroundImg.mobile.src"}],"f":[]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":["text-center ",{"t":2,"r":"theme"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"subsection-header v-normal-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"body-copy-text"},"f":[{"t":3,"r":"description"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top show-for-small-only"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"buttonLink"}],"class":"bannerLink"},"f":[{"t":2,"r":"buttonText"}]}],"n":50,"r":"isCtaHyperlink"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":"round","text":[{"t":2,"r":"buttonText"}],"href":[{"t":2,"r":"buttonLink"}]}}],"r":"isCtaHyperlink"}]}],"n":50,"r":"buttonLink"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":["show-for-medium-up banner-background ",{"t":2,"r":"theme"}," ",{"t":2,"r":"backgroundImgDesktopPosition"}," ",{"t":2,"r":"backgroundImgDesktopSize"}],"style":["background-image: url('",{"t":2,"r":"backgroundImgDesktop"},"');",{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":[{"t":2,"r":"class"}],"n":50,"r":"class"},{"t":4,"n":51,"f":["medium-6 large-6"],"r":"class"}," ",{"t":2,"r":"textAlignment"}," medium-offset-1"]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-large-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"body-copy-text"},"f":[{"t":3,"r":"description"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"buttonLink"}],"class":"bannerLink"},"f":[{"t":2,"r":"buttonText"}]}],"n":50,"r":"isCtaHyperlink"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":"round","text":[{"t":2,"r":"buttonText"}],"href":[{"t":2,"r":"buttonLink"}]}}],"r":"isCtaHyperlink"}]}],"n":50,"r":"buttonLink"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-5"},"f":[{"t":7,"e":"div","a":{"class":"banner-image"},"f":[{"t":7,"e":"div","a":{"class":["image ",{"t":2,"r":"foregroundImgDesktopPosition"}," ",{"t":2,"r":"foregroundImgDesktopSize"}],"style":["background-image: url('",{"t":2,"r":"foregroundImg.desktop.src"},"')"]},"f":[]}]}]}],"n":50,"r":"foregroundImg.desktop.src"}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-icon-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-icon-banner"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":["icon-panel text-center ",{"t":2,"r":"theme"}],"style":[{"t":4,"f":["height:",{"t":2,"r":"height"},"px;"],"n":50,"x":{"r":["height"],"s":"_0>0"}}," ",{"t":4,"f":["background-image:url('",{"t":2,"r":"bgImg.src"},"');"],"n":50,"r":"bgImg"}," ",{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"div","a":{"class":"vertical-center"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"iconLink"}]},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"iconClass"}],"class":[{"t":2,"r":"theme"}]}}]}],"n":50,"r":"iconLink"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"iconClass"}],"class":[{"t":2,"r":"theme"}]}}],"r":"iconLink"}," ",{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header v-medium-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":3,"r":"subTitle"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":["icon-panel ",{"t":2,"r":"theme"}],"style":[{"t":4,"f":["background-image:url('",{"t":2,"r":"mobileBgImg.src"},"')"],"n":50,"r":"bgImg"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"iconLink"}]},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"iconClass"}],"class":[{"t":2,"r":"theme"}]}}]}],"n":50,"r":"iconLink"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"iconClass"}],"class":[{"t":2,"r":"theme"}]}}],"r":"iconLink"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header v-medium-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"span","f":[{"t":3,"r":"subTitle"}]}]}]}]}]}]}]};
this["ux-icon"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","m":[{"t":4,"f":["aria-hidden=\"",{"t":2,"r":"ariaHidden"},"\""],"n":50,"r":"ariaHidden"},{"t":4,"f":[" style=\"background-color:",{"t":2,"r":"bgColor"},";\""],"n":50,"r":"bgColor"}],"a":{"class":["ux-icon ",{"t":2,"r":"outerClass"}]},"f":[{"t":4,"f":[{"t":7,"e":"img","a":{"class":["icon icon-",{"t":2,"r":"type"}," ",{"t":2,"r":"class"}," ",{"t":2,"r":"size"}],"src":["https://cdn.aws.singtel.com/style-guide/icon-pack/",{"t":2,"r":"type"},".png"]},"v":{"tap":"iconTapHandler","enter":"iconEnterHandler","panend":"iconDragOver","panstart":"iconDragStart","pan":"iconDrag","panmove":"iconDragMove"},"m":[{"t":4,"f":["tabindex=",{"t":2,"x":{"r":["tabindex"],"s":"_0?_0:0"}}],"n":50,"x":{"r":["noTabIndex"],"s":"!_0"}}]}],"n":50,"x":{"r":["overIconWithImage","overIconImageAttribute"],"s":"_0&&!_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":["icon icon-",{"t":2,"r":"type"}," ",{"t":2,"r":"class"}," ",{"t":2,"r":"size"}]},"m":[{"t":4,"f":["style=\"color:",{"t":2,"r":"color"},";\""],"r":"color"},{"t":4,"f":["tabindex=",{"t":2,"x":{"r":["tabindex"],"s":"_0?_0:0"}}],"n":50,"x":{"r":["noTabIndex"],"s":"!_0"}},{"t":4,"f":[" aria-label=\"",{"t":2,"r":"ariaLabel"},"\""],"n":50,"r":"ariaLabel"},{"t":4,"f":["aria-expanded=\"",{"t":2,"r":"ariaValue"},"\""],"n":50,"r":"ariaValue"}],"v":{"tap":"iconTapHandler","enter":"iconEnterHandler","panend":"iconDragOver","panstart":"iconDragStart","pan":"iconDrag","panmove":"iconDragMove"},"f":[{"t":8,"r":"content"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"ux-icon__text"},"f":[{"t":2,"r":"text"}]}],"n":50,"r":"text"}],"x":{"r":["overIconWithImage","overIconImageAttribute"],"s":"_0&&!_1"}}]}],"n":50,"r":"ontap"},{"t":4,"n":51,"f":[{"t":7,"e":"div","m":[{"t":4,"f":["aria-hidden=\"",{"t":2,"r":"ariaHidden"},"\""],"n":50,"r":"ariaHidden"},{"t":4,"f":[" style=\"background-color:",{"t":2,"r":"bgColor"},";\""],"n":50,"r":"bgColor"}],"a":{"class":["ux-icon ",{"t":2,"r":"outerClass"}]},"f":[{"t":4,"f":[{"t":7,"e":"img","a":{"class":["icon icon-",{"t":2,"r":"type"}," ",{"t":2,"r":"class"}," ",{"t":2,"r":"size"}],"src":["https://cdn.aws.singtel.com/style-guide/icon-pack/",{"t":2,"r":"type"},".png"]},"v":{"tap":"iconTapHandler","enter":"iconEnterHandler"},"m":[{"t":4,"f":["tabindex=",{"t":2,"x":{"r":["tabindex"],"s":"_0?_0:0"}}],"n":50,"x":{"r":["noTabIndex"],"s":"!_0"}}]}],"n":50,"x":{"r":["overIconWithImage","overIconImageAttribute"],"s":"_0&&!_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":["icon icon-",{"t":2,"r":"type"}," ",{"t":2,"r":"class"}," ",{"t":2,"r":"size"}],"role":"button"},"m":[{"t":4,"f":["style=\"color:",{"t":2,"r":"color"},";\""],"r":"color"},{"t":4,"f":[" tabindex=",{"t":2,"x":{"r":["tabindex"],"s":"_0?_0:0"}}],"n":50,"x":{"r":["noTabIndex"],"s":"!_0"}},{"t":4,"f":["aria-expanded=\"",{"t":2,"r":"ariaValue"},"\""],"n":50,"r":"ariaValue"},{"t":4,"f":["aria-label=\"",{"t":2,"r":"aria_label"},"\""],"n":50,"r":"aria_label"}],"f":[{"t":8,"r":"content"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"ux-icon__text"},"f":[{"t":2,"r":"text"}]}],"n":50,"r":"text"}],"x":{"r":["overIconWithImage","overIconImageAttribute"],"s":"_0&&!_1"}}]}],"r":"ontap"}]};
this["ux-iframe"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-iframe",{"t":4,"f":[" iframe-",{"t":2,"r":"alignment"}],"n":50,"r":"alignment"}]},"f":[{"t":7,"e":"div","a":{"style":["width:",{"t":2,"r":"width"},";",{"t":4,"f":["height:",{"t":2,"r":"responsiveHeight"},";"],"n":50,"r":"heightInd"}],"class":["iframe-wrapper ",{"t":4,"f":["responsive"],"n":50,"r":"responsive"}]},"f":[{"t":7,"e":"iframe","a":{"name":[{"t":2,"r":"name"}],"src":[{"t":2,"r":"src"}],"frameBorder":"0","scrolling":[{"t":2,"r":"scrolling"}]}}]}]}]};
this["ux-image-button"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-image-button ",{"t":2,"r":"theme"}]},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"positionRelative"},"f":[{"t":7,"e":"div","a":{"class":"positionAbsolute-100","style":[{"t":4,"f":["top:",{"t":2,"r":"positionTop"},"%;"],"n":50,"r":"positionTop"}]},"f":[{"t":7,"e":"div","a":{"class":"positionRelativeCenter"},"f":[{"t":7,"e":"div","a":{"class":"linkcss","style":[{"t":4,"f":["width:",{"t":2,"r":"widthLink"},"%;"],"n":50,"r":"widthLink"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"nopaddingcol"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"text-center","style":[{"t":4,"f":["padding-top:",{"t":2,"r":"paddingTop"},"%;"],"n":50,"r":"paddingTop"}," ",{"t":4,"f":["float: ",{"t":2,"r":"link1.alignment"},";"],"n":50,"r":"link1.alignment"}," ",{"t":4,"f":["color: ",{"t":2,"r":"link1.buttonColorHover"},";"],"n":50,"x":{"r":["link1.buttonColor"],"s":"_0===\"transparent\""}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"x":{"r":["link1.titleStyle"],"s":"_0?_0:\"body-copy-text\""}}," ",{"t":2,"r":"theme"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["link1.bottomSpacing"],"s":"_0?_0:\"small\""}},"-bottom"],"n":50,"r":"link1.bottomSpacing"}]},"f":[{"t":2,"r":"link1.title"}]}],"r":"link1.title"}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":["round ",{"t":2,"r":"link1.buttonColor"}," btn-responsive"],"text":[{"t":2,"r":"link1.linkText"}],"href":[{"t":2,"r":"link1.linkTo"}]}}],"n":50,"r":"link1.isButton"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"class":"btn-responsive","href":[{"t":2,"r":"link1.linkTo"}]},"f":[{"t":2,"r":"link1.linkText"}]}],"r":"link1.isButton"}]}],"n":50,"r":"link1"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"text-center","style":[{"t":4,"f":["padding-top:",{"t":2,"r":"paddingTop"},"%;"],"n":50,"r":"paddingTop"}," ",{"t":4,"f":["float: ",{"t":2,"r":"link2.alignment"},";"],"n":50,"r":"link2.alignment"}," ",{"t":4,"f":["color: ",{"t":2,"r":"link2.buttonColorHover"},";"],"n":50,"x":{"r":["link2.buttonColor"],"s":"_0===\"transparent\""}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"x":{"r":["link2.titleStyle"],"s":"_0?_0:\"body-copy-text\""}}," ",{"t":2,"r":"theme"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["link2.bottomSpacing"],"s":"_0?_0:\"small\""}},"-bottom"],"n":50,"r":"link2.bottomSpacing"}]},"f":[{"t":2,"r":"link2.title"}]}],"r":"link2.title"}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":["round ",{"t":2,"r":"link2.buttonColor"}," btn-responsive"],"text":[{"t":2,"r":"link2.linkText"}],"href":[{"t":2,"r":"link2.linkTo"}]}}],"n":50,"r":"link2.isButton"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"class":"btn-responsive","href":[{"t":2,"r":"link2.linkTo"}]},"f":[{"t":2,"r":"link2.linkText"}]}],"r":"link2.isButton"}]}],"n":50,"r":"link2"}]}]}],"i":"i","r":"linkList"}],"n":50,"r":"linkList"}]}]}]}," ",{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"backgroundImage.desktop.src"}],"alt":[{"t":2,"r":"backgroundImage.desktop.alt"}],"class":["imageInline100 ",{"t":4,"f":["fullwidth"],"n":50,"r":"fullWidth"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"positionRelative"},"f":[{"t":7,"e":"div","a":{"class":"positionAbsolute-100","style":[{"t":4,"f":["top:",{"t":2,"r":"positionTopMobile"},"%;"],"n":50,"r":"positionTopMobile"}]},"f":[{"t":7,"e":"div","a":{"class":"positionRelativeCenter"},"f":[{"t":7,"e":"div","a":{"class":"linkcss","style":[{"t":4,"f":["width:",{"t":2,"r":"widthLinkMobile"},"%;"],"n":50,"r":"widthLinkMobile"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"nopaddingcol"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"text-center","style":[{"t":4,"f":["padding-top:",{"t":2,"r":"paddingTopMobile"},"%;"],"n":50,"r":"paddingTopMobile"}," ",{"t":4,"f":["float: ",{"t":2,"r":"link1.alignment"},";"],"n":50,"r":"link1.alignment"}," ",{"t":4,"f":["color: ",{"t":2,"r":"link1.buttonColorHover"},";"],"n":50,"x":{"r":["link1.buttonColor"],"s":"_0===\"transparent\""}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"x":{"r":["link1.titleStyle"],"s":"_0?_0:\"body-copy-text\""}}," ",{"t":2,"r":"theme"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["link1.bottomSpacing"],"s":"_0?_0:\"small\""}},"-bottom"],"n":50,"r":"link1.bottomSpacing"}]},"f":[{"t":2,"r":"link1.title"}]}],"r":"link1.title"}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":["round ",{"t":2,"r":"link1.buttonColor"}," btn-responsive"],"text":[{"t":2,"r":"link1.linkText"}],"href":[{"t":2,"r":"link1.linkTo"}]}}],"n":50,"r":"link1.isButton"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"class":"btn-responsive","href":[{"t":2,"r":"link1.linkTo"}]},"f":[{"t":2,"r":"link1.linkText"}]}],"r":"link1.isButton"}]}],"n":50,"r":"link1"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"text-center","style":[{"t":4,"f":["padding-top:",{"t":2,"r":"paddingTopMobile"},"%;"],"n":50,"r":"paddingTopMobile"}," ",{"t":4,"f":["float: ",{"t":2,"r":"link2.alignment"},";"],"n":50,"r":"link2.alignment"}," ",{"t":4,"f":["color: ",{"t":2,"r":"link2.buttonColorHover"},";"],"n":50,"x":{"r":["link2.buttonColor"],"s":"_0===\"transparent\""}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"x":{"r":["link2.titleStyle"],"s":"_0?_0:\"body-copy-text\""}}," ",{"t":2,"r":"theme"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["link2.bottomSpacing"],"s":"_0?_0:\"small\""}},"-bottom"],"n":50,"r":"link2.bottomSpacing"}]},"f":[{"t":2,"r":"link2.title"}]}],"r":"link2.title"}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":["round ",{"t":2,"r":"link2.buttonColor"}," btn-responsive"],"text":[{"t":2,"r":"link2.linkText"}],"href":[{"t":2,"r":"link2.linkTo"}]}}],"n":50,"r":"link2.isButton"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"class":"btn-responsive","href":[{"t":2,"r":"link2.linkTo"}]},"f":[{"t":2,"r":"link2.linkText"}]}],"r":"link2.isButton"}]}],"n":50,"r":"link2"}]}]}],"i":"i","r":"linkList"}],"n":50,"r":"linkList"}]}]}]}," ",{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"backgroundImage.mobile.src"}],"alt":[{"t":2,"r":"backgroundImage.mobile.alt"}],"class":["imageInline100 ",{"t":4,"f":["fullwidth"],"n":50,"r":"fullWidth"}]}}]}]}]}]};
this["ux-image-carousel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-image-carousel"},"f":[{"t":4,"f":[" ",{"t":7,"e":"div","a":{"class":"swiper-container v-large-left v-large-right"},"f":[{"t":7,"e":"div","a":{"class":"swiper-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"swiper-slide"},"f":[{"t":7,"e":"span","a":{"class":"carousel-item-cover"},"f":[{"t":4,"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"imageUrl"}],"target":"_blank"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"imagePath"}],"alt":[{"t":2,"r":"imageAltText"}]}}]}],"n":50,"r":"imageUrl"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"imagePath"}],"alt":[{"t":2,"r":"imageAltText"}]}}],"r":"imageUrl"}]}]}],"n":52,"i":"num","r":"imageCarouselModelList"}]}]}," ",{"t":7,"e":"div","a":{"class":"swiper-button-next"}}," ",{"t":7,"e":"div","a":{"class":"swiper-button-prev"}}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-image-gallery"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-image-gallery ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"img","a":{"class":"gallery-image","src":[{"t":2,"r":"imagePath"}]}}," ",{"t":7,"e":"div","a":{"class":"color-selection"},"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":["image-thumb ",{"t":2,"x":{"r":["getSelectedState","i"],"s":"_0(_1)"}}]},"v":{"tap":{"n":"doShowSelectedImage","d":[{"t":2,"r":"i"}]}},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"."}]}}]}],"n":52,"i":"i","r":"images"}]}]}],"n":50,"x":{"r":["name","selectedColor"],"s":"_0===_1"}}],"n":52,"r":"phoneColors"}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-image"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-image ",{"t":4,"f":[{"t":2,"r":"class"}],"n":50,"r":"class"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"img","a":{"class":["show-for-medium-up ",{"t":4,"f":["fullWidth"],"n":50,"r":"fullWidth"}],"src":[{"t":2,"r":"src"}],"alt":[{"t":2,"r":"alt"}]}}],"r":"desktop"}," ",{"t":4,"f":[{"t":7,"e":"img","a":{"class":["show-for-small-only ",{"t":4,"f":["fullWidth"],"n":50,"r":"fullWidth"}],"src":[{"t":2,"r":"src"}],"alt":[{"t":2,"r":"alt"}]}}],"r":"mobile"}," ",{"t":4,"f":[{"t":7,"e":"img","a":{"src":[{"t":3,"r":"src"}],"alt":[{"t":3,"r":"alt"}]}}],"r":"img"}," ",{"t":4,"f":[{"t":7,"e":"img","a":{"src":[{"t":3,"r":"src"}],"alt":[{"t":3,"r":"alt"}]}}],"n":50,"r":"src"}],"n":50,"x":{"r":["isDataModel","src"],"s":"_0||_1"}},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"x":{"r":["isDataModel","src"],"s":"_0||_1"}}]}]};
this["ux-inbox-card"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-inbox-card ",{"t":2,"r":"class"}," ",{"t":2,"r":"status"}]},"v":{"tap":{"n":"doShowModal","d":[{"t":2,"r":"cardId"}]}},"f":[{"t":7,"e":"ux-panel","a":{"class":"panel30 margin-zero"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-offset-1"},"f":[{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header v-medium"},"f":[{"t":2,"r":"initData.alertsTitle"}]}],"n":50,"x":{"r":["categoryName"],"s":"_0===\"Notice\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header v-medium"},"f":[{"t":2,"r":"initData.rewardsTitle"}]}],"n":50,"x":{"r":["categoryName"],"s":"_0===\"Promotions\"||_0===\"Rewards\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-text"},"f":[{"t":2,"r":"categoryName"}," ● Account ",{"t":2,"r":"accountNumber"}," ● ",{"t":2,"r":"date"}]}],"n":50,"x":{"r":["categoryName"],"s":"_0==\"bills\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["categoryName"],"s":"_0==\"Notice\""},"f":[{"t":7,"e":"div","a":{"class":"body-text"},"f":[{"t":2,"r":"initData.notificationHeader"}," ●  ",{"t":2,"r":"accountPrefix"}," ",{"t":2,"x":{"r":["RactiveHelpers","account"],"s":"_0.mobileNumberFormat(_0.splitString(_1,\"_\",1))"}}," ●  ",{"t":2,"x":{"r":["RactiveHelpers","createDate"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM\")"}}]}]},{"t":4,"n":50,"x":{"r":["categoryName"],"s":"!(_0==\"Notice\")"},"f":[" ",{"t":7,"e":"div","a":{"class":"body-text"},"f":[{"t":2,"r":"categoryName"}," ●  ",{"t":2,"r":"accountPrefix"}," ",{"t":2,"x":{"r":["RactiveHelpers","account"],"s":"_0.mobileNumberFormat(_0.splitString(_1,\"_\",1))"}}," ●  ",{"t":2,"x":{"r":["RactiveHelpers","createDate"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM\")"}}]}]}],"x":{"r":["categoryName"],"s":"_0==\"bills\""}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider v-large"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-offset-1 medium-11"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header v-normal-bottom"},"f":[{"t":2,"r":"subject"}]}," ",{"t":7,"e":"div","a":{"class":"body-text truncate-msg"},"f":[{"t":3,"r":"summary"}]}," ",{"t":7,"e":"ux-image","a":{"class":"rewards-banner v-normal-top","src":[{"t":2,"r":"thumbnail"}]}}]}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"900","class":"light-theme card-details","modalId":[{"t":2,"r":"cardId"}]},"f":[{"t":7,"e":"div","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-medium-bottom"},"f":[{"t":2,"r":"subject"}]}," ",{"t":7,"e":"div","f":["From: ",{"t":2,"r":"from"}]}," ",{"t":7,"e":"div","f":["Date: ",{"t":2,"x":{"r":["RactiveHelpers","createDate"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"section-details clearfix v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"ux-image","a":{"class":"full-width rewards-banner v-medium-bottom","src":[{"t":2,"r":"badgeIcon"}]}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"iframe","a":{"id":"iframeID","width":"100%","height":"400px"}}]}],"n":50,"r":"contentHtml"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"body-text"},"f":[{"t":3,"r":"content"}]}],"r":"contentHtml"}]}," ",{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"right round v-medium-left","href":[{"t":2,"r":"link"}],"type":[{"t":2,"r":"type"}],"text":[{"t":2,"r":"text"}]}}],"i":"i","r":"buttons"}," ",{"t":7,"e":"ux-button","a":{"class":"right light round","onclick":"doDelete"},"f":["Delete"]}]}]}]};
this["ux-info-block-modal"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-info-block-modal"},"f":[{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"cmptbltySttsInfoBlock","hideCloseIcon":"true"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":[{"t":2,"r":"header"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":3,"r":"description"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top collapse section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"p","f":[{"t":3,"r":"."}]}],"n":52,"r":"messages"}]}]}],"n":50,"x":{"r":[],"s":"false"}}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 text-center-left v-normal-top"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"goBack"},"f":[{"t":2,"r":"linkText"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 text-center v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"text":[{"t":2,"r":"buttonLabel"}],"class":"round margin-zero small-only-expand right","onclick":"next","arialabel":"Proceed"}}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"TVReconErrorPopupModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":[{"t":2,"r":"initData.eShopErrorModel.customErrorHeader"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":3,"r":"initData.eShopErrorModel.customErrorDesc"}]}]}]}]};
this["ux-input-box"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-input-box ",{"t":2,"r":"class"}," ",{"t":2,"r":"valid"}," ",{"t":2,"r":"label_position"}," ",{"t":2,"x":{"r":["value.length"],"s":"_0>3?\"showcard\":\"\""}}]},"f":[{"t":4,"f":[{"t":7,"e":"label","a":{"for":[{"t":2,"x":{"r":["id","guid"],"s":"_0?_0:_1"}}]},"f":[{"t":2,"r":"label_value"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"mandatory","aria-label":"mandatory"},"f":["*"]}],"n":50,"r":"mandatory"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-12 small-12 tooltip-padding20"},"f":[{"t":3,"r":"label_tooltip_message"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"tooltipImage.src"}],"alt":[{"t":3,"r":"tooltipImage.alt"}]}}],"n":50,"r":"tooltipImage"}]}]}]}],"n":50,"r":"label_tooltip_message"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"label-help-action"},"f":[{"t":7,"e":"ux-anchor","a":{"onclick":[{"t":3,"r":"label_icon_onclick"}]},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}],"n":50,"r":"label_icon_onclick"}," ",{"t":4,"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-anchor","a":{"class":["right ",{"t":4,"f":["disable-Link"],"n":50,"r":"disableLink"}],"href":[{"t":2,"r":"anchorLink"}],"onclick":[{"t":3,"r":"label_onclick"}]},"f":[{"t":2,"r":"labelName"}]}]}],"n":50,"r":"anchorReqd"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"onclick":"showAHTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":2,"r":"tooltip_message"}]}],"n":50,"r":"tooltipReqd"}]}],"n":50,"r":"label_value"}," ",{"t":7,"e":"div","a":{"class":["input-box-container ",{"t":2,"r":"image_class"}," ",{"t":2,"r":"validity.status"}," ",{"t":2,"r":"icon_class"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"row collapse prefix-radius"},"f":[{"t":7,"e":"div","a":{"class":"small-3 columns"},"f":[{"t":7,"e":"span","a":{"class":"prefix"},"f":[{"t":2,"r":"prefix"}]}]}," ",{"t":7,"e":"div","a":{"class":"small-9 columns"},"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"x":{"r":["id","guid"],"s":"_0?_0:_1"}}],"name":[{"t":2,"r":"name"}],"aria-required":[{"t":2,"x":{"r":["mandatory"],"s":"_0?\"true\":\"false\""}}],"type":[{"t":2,"x":{"r":["getType"],"s":"_0()"}}],"value":[{"t":2,"r":"value"}],"placeholder":[{"t":2,"r":"placeholder"}]},"m":[{"t":4,"f":["maxlength=\"",{"t":2,"r":"maxLength"},"\""],"n":50,"r":"maxLength"},{"t":4,"f":["minLength=\"",{"t":2,"r":"minLength"},"\""],"n":50,"r":"minLength"},{"t":4,"f":["autofocus=\"",{"t":2,"r":"autofocus"},"\""],"n":50,"r":"autofocus"},{"t":4,"f":[" disabled"],"n":50,"r":"disabled"},{"t":4,"f":[" pattern=\"",{"t":2,"r":"pattern"},"\""],"n":50,"r":"pattern"},{"t":4,"f":[" inputmode=\"",{"t":2,"r":"inputmode"},"\""],"n":50,"r":"inputmode"},{"t":4,"f":[" autocomplete=\"",{"t":2,"r":"autocomplete"},"\""],"n":50,"r":"autocomplete"}],"v":{"blur":"blurHandler","input":"inputHandler","enter":"enterHandler","focus":"focusHandler"}}]}]}],"n":50,"r":"prefix"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postfix","postfix_icon"],"s":"_0||_1"},"f":[{"t":7,"e":"div","a":{"class":"row collapse"},"f":[{"t":7,"e":"div","a":{"class":"small-10 columns"},"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"x":{"r":["id","guid"],"s":"_0?_0:_1"}}],"name":[{"t":2,"r":"name"}],"type":"text","value":[{"t":2,"r":"value"}],"placeholder":[{"t":2,"r":"placeholder"}]},"m":[{"t":4,"f":["maxlength=\"",{"t":2,"r":"maxLength"},"\""],"n":50,"r":"maxLength"},{"t":4,"f":["minLength=\"",{"t":2,"r":"minLength"},"\""],"n":50,"r":"minLength"},{"t":4,"f":["autofocus=\"",{"t":2,"r":"autofocus"},"\""],"n":50,"r":"autofocus"},{"t":4,"f":[" pattern=\"",{"t":2,"r":"pattern"},"\""],"n":50,"r":"pattern"},{"t":4,"f":[" inputmode=\"",{"t":2,"r":"inputmode"},"\""],"n":50,"r":"inputmode"},{"t":4,"f":[" autocomplete=\"",{"t":2,"r":"autocomplete"},"\""],"n":50,"r":"autocomplete"}]}]}," ",{"t":7,"e":"div","a":{"class":"small-2 columns"},"f":[{"t":7,"e":"span","a":{"class":"postfix"},"f":[{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"postfix_icon"}]}}],"n":50,"r":"postfix_icon"}]}]}]}]},{"t":4,"n":50,"x":{"r":["postfix","postfix_icon"],"s":"!(_0||_1)"},"f":[" ",{"t":7,"e":"input","a":{"id":[{"t":2,"x":{"r":["id","guid"],"s":"_0?_0:_1"}}],"name":[{"t":2,"r":"name"}],"type":[{"t":2,"x":{"r":["getType"],"s":"_0()"}}],"value":[{"t":2,"r":"value"}],"placeholder":[{"t":2,"r":"placeholder"}]},"m":[{"t":4,"f":["disabled"],"n":50,"r":"disabled"},{"t":4,"f":["readonly"],"n":50,"r":"readonly"},{"t":4,"f":["maxlength=\"",{"t":2,"r":"maxLength"},"\""],"n":50,"r":"maxLength"},{"t":4,"f":["minLength=\"",{"t":2,"r":"minLength"},"\""],"n":50,"r":"minLength"},{"t":4,"f":["autofocus=\"",{"t":2,"r":"autofocus"},"\""],"n":50,"r":"autofocus"},{"t":4,"f":[" pattern=\"",{"t":2,"r":"pattern"},"\""],"n":50,"r":"pattern"},{"t":4,"f":[" inputmode=\"",{"t":2,"r":"inputmode"},"\""],"n":50,"r":"inputmode"},{"t":4,"f":[" autocomplete=\"",{"t":2,"r":"autocomplete"},"\""],"n":50,"r":"autocomplete"}],"v":{"blur":"blurHandler","input":"inputHandler","enter":"enterHandler","focus":"focusHandler"}}]}],"r":"prefix"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"icon-btn"},"f":[{"t":7,"e":"ux-icon","a":{"type":"success-inverse","size":"s","color":"#3c8031"}}]}],"n":50,"x":{"r":["validity.status"],"s":"_0===\"valid\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["icon"],"s":"_0"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"role":"alert","class":["tooltip-wrapper ",{"t":2,"r":"tooltip_position"}," ",{"t":4,"f":["show"],"n":50,"r":"show_tooltip"}]},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"p","a":{"class":"tooltip small"},"f":[{"t":2,"r":"tooltip_msg"}]}]}],"n":50,"x":{"r":["tooltip_msg","show_tooltip"],"s":"_0&&_1"}}," ",{"t":7,"e":"div","a":{"class":"icon-btn tooltip-icon"},"v":{"click":{"n":[{"t":4,"f":["showTooltip"],"n":50,"r":"tooltip_msg"}],"d":[]},"enter":{"n":[{"t":4,"f":["showTooltip"],"n":50,"r":"tooltip_msg"}],"d":[]}},"f":[{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icon"}],"size":[{"t":2,"r":"icon_size"}],"text":[{"t":2,"r":"tooltip_msg"}],"color":[{"t":2,"r":"icon_color"}]},"f":[]}],"n":50,"x":{"r":["image_class"],"s":"_0===\"info-btn\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icon"}],"size":[{"t":2,"r":"icon_size"}],"text":[{"t":2,"r":"tooltip_msg"}],"color":[{"t":2,"r":"icon_color"}],"bubble":"true"}}],"x":{"r":["image_class"],"s":"_0===\"info-btn\""}}]}]}],"x":{"r":["validity.status"],"s":"_0===\"valid\""}}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"caption password-strength"},"f":["Password strength: ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":["strength ",{"t":2,"r":"password.strength"}]},"f":["Weak"]},{"t":7,"e":"ux-simple-bar","a":{"value":"33","style":"fat","colour":"#d93a1b"}}],"n":50,"x":{"r":["password.strength"],"s":"_0===\"weak\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["password.strength"],"s":"_0===\"good\""},"f":[{"t":7,"e":"span","a":{"class":["strength ",{"t":2,"r":"password.strength"}]},"f":["Good"]},{"t":7,"e":"ux-simple-bar","a":{"value":"66","style":"fat","colour":"#ffd100"}}]},{"t":4,"n":50,"x":{"r":["password.strength"],"s":"(!(_0===\"good\"))&&(_0===\"strong\")"},"f":[" ",{"t":7,"e":"span","a":{"class":["strength ",{"t":2,"r":"password.strength"}]},"f":["Strong"]},{"t":7,"e":"ux-simple-bar","a":{"value":"100","style":"fat","colour":"#3c8031"}}]}],"x":{"r":["password.strength"],"s":"_0===\"weak\""}}]}],"n":50,"x":{"r":["password","password.strength"],"s":"_0&&_1"}}," ",{"t":7,"e":"div","a":{"class":"validity-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"ux-form-validity"}],"r":"validity"}]}]}]};
this["ux-installationlink-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-installationlink-banner ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["banner-background ",{"t":2,"r":"theme"}," show-for-medium-up ",{"t":2,"r":"backgroundImgDesktopPosition"}," ",{"t":2,"r":"backgroundImgDesktopSize"}],"style":["background-image: url('",{"t":2,"r":"backgroundImg.desktop.src"},"');"]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-4 banner-visual show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"banner-image foreground-fix-center"},"f":[{"t":7,"e":"div","a":{"class":"image"},"f":[{"t":7,"e":"ux-image","a":{"datamodel":[{"t":3,"r":"foregroundImg"}]}}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4 banner-content"},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"main-header v-medium-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"banner-copy show-for-medium-up"},"f":[{"t":3,"r":"desc"}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"banner-link","href":[{"t":2,"r":"link.src"}],"target":[{"t":4,"f":["_blank"],"n":50,"r":"link.openNewWindow"},{"t":4,"n":51,"f":["_self"],"r":"link.openNewWindow"}]},"f":[{"t":3,"r":"link.title"}]}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4 quick-links"},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":4,"f":[{"t":7,"e":"ux-quicklink","a":{"datamodel":[{"t":2,"r":"."}]}}],"r":"quicklinks"}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":["banner-background ",{"t":2,"r":"theme"}," show-for-small-only ",{"t":2,"r":"backgroundImgMobilePosition"}," ",{"t":2,"r":"backgroundImgMobileSize"}," ",{"t":2,"r":"mobileImgHeight"}],"style":["background-image: url('",{"t":2,"r":"backgroundImg.mobile.src"},"');"]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-4 banner-content"},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"main-header v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"banner-copy"},"f":[{"t":3,"r":"desc"}]}],"n":50,"r":"showDescriptionOnMobile"}," ",{"t":7,"e":"ux-anchor","a":{"class":"banner-link","href":[{"t":2,"r":"link.src"}],"target":[{"t":4,"f":["_blank"],"n":50,"r":"link.openNewWindow"},{"t":4,"n":51,"f":["_self"],"r":"link.openNewWindow"}]},"f":[{"t":3,"r":"link.title"}]}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4 quick-links"},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":4,"f":[{"t":7,"e":"ux-quicklink","a":{"datamodel":[{"t":2,"r":"."}]}}],"r":"quicklinks"}]}]}]}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-invite-friend"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-invite-friend ",{"t":2,"r":"theme"}]},"f":[{"t":7,"e":"ux-panel","a":{"class":"text-center"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"panelImage.desktop.src"}],"alt":[{"t":2,"r":"panelImage.desktop.alt"}],"class":"show-for-large-up"}}," ",{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"panelImage.mobile.src"}],"alt":[{"t":2,"r":"panelImage.desktop.alt"}],"class":"hide-for-large-up"}}," ",{"t":7,"e":"div","a":{"class":"panel-content"},"f":[{"t":7,"e":"div","a":{"class":"section-header v-normal-top"},"f":[{"t":3,"r":"panelTitle"}]}," ",{"t":7,"e":"div","a":{"class":"panel-text v-normal-top v-small-bottom"},"f":[{"t":3,"r":"panelText"}]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":["showModal:",{"t":2,"r":"modalType"}],"class":["light round button v-normal-top v-normal-bottom button-",{"t":2,"r":"modalType"}]},"f":[{"t":2,"r":"panelButtonText"}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"modalId":"referralModal","width":"700","class":["light-theme step-",{"t":2,"r":"invite.step"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-load-mask"}],"n":50,"r":"loading"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title"},"f":[{"t":2,"r":"stepOneTitle"}]}," ",{"t":3,"r":"stepOneDescription"}," ",{"t":7,"e":"div","a":{"class":"input-field"},"f":[{"t":7,"e":"ux-input-box","a":{"placeholder":"e.g. 91234567","label_value":"Mobile number","name":"inviteMobileNumber","value":[{"t":2,"r":"mobileNumber"}],"mandatory":"true","maxLength":"8"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"mobileNumberErrorMsg"}]}}],"n":50,"r":"mobileNumberErrorMsg"}]}," ",{"t":7,"e":"ux-row","a":{"class":"invite-request-actions"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"goBack"},"f":["< Back"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["round step-1",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["invite.step1valid"],"s":"!_0"}}],"onclick":"requestOneTimePin"},"f":["Send OTP"]}]}]}],"n":50,"x":{"r":["invite.step"],"s":"_0===1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title"},"f":[{"t":2,"r":"stepTwoTitle"}]}," ",{"t":7,"e":"p","f":["An OTP has been sent by SMS to ",{"t":7,"e":"strong","f":[{"t":2,"r":"mobileNumber"}]}," and will expire in 3 minutes."]}," ",{"t":7,"e":"div","a":{"class":"input-field invite-request-phone"},"f":[{"t":7,"e":"ux-input-box","a":{"placeholder":"Enter 6-digit OTP","label_value":"One-Time PIN (OTP)","name":"inviteOtp","value":[{"t":2,"r":"oneTimePin"}],"mandatory":"true","minLength":"6","maxLength":"6"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"oneTimePinErrorMessage"}]},"f":[]}],"n":50,"r":"oneTimePinErrorMessage"}]}," ",{"t":7,"e":"p","a":{"class":"v-normal-top"},"f":["No OTP? ",{"t":7,"e":"ux-anchor","a":{"ontap":"requestOneTimePin"},"f":["Resend"]}]}," ",{"t":7,"e":"ux-checkbox","a":{"name":"inviteTnc","checkboxid":"inviteTnc","class":"invite-tnc","checked":[{"t":2,"r":"invite.tnc"}],"labelvalue":[{"t":3,"r":"tnc"}],"onChangeEvent":"setTnc"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"genericErrorMessage"}]}}]}],"n":50,"r":"genericErrorMessage"}," ",{"t":7,"e":"ux-row","a":{"class":"invite-request-actions"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"goBack"},"f":["< Back"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["round step-2",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["invite.step2valid"],"s":"!_0"}}],"onclick":"submitOneTimePin"},"f":["Next"]}]}]}],"n":50,"x":{"r":["invite.step"],"s":"_0===2"}}," ",{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title"},"f":[{"t":2,"r":"stepThreeTitle"}]}," ",{"t":3,"r":"stepThreeDescription"}," ",{"t":7,"e":"div","a":{"class":"input-field"},"f":[{"t":7,"e":"ux-input-box","a":{"placeholder":"Jenny","label_value":"Friend's name","name":"friendsName","value":[{"t":2,"r":"invite.friendsName"}],"maxLength":"200"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"friendsNameErrorMessage"}]}}],"n":50,"r":"friendsNameErrorMessage"}]}," ",{"t":7,"e":"div","a":{"class":"input-field"},"f":[{"t":7,"e":"ux-input-box","a":{"placeholder":"9225 6888","label_value":"Friend's mobile number","name":"friendsMobileNumber","value":[{"t":2,"r":"invite.friendsMobileNumber"}],"maxLength":"8"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"friendsMobileNumberErrorMessage"}]}}],"n":50,"r":"friendsMobileNumberErrorMessage"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"genericErrorMessage"}]}}]}],"n":50,"r":"genericErrorMessage"}," ",{"t":7,"e":"ux-row","a":{"class":"invite-request-actions"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"goBack"},"f":["< Back"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["round step-3",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["invite.step3valid"],"s":"!_0"}}],"onclick":"sendInvite"},"f":["Next"]}]}]}],"n":50,"x":{"r":["invite.step"],"s":"_0===3"}}," ",{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title"},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-tick"}}," ",{"t":2,"r":"stepFourTitle"}]}," ",{"t":3,"x":{"r":["RactiveHelpers","stepFourDescription"],"s":"_0.unescapeString(_1)"}}," ",{"t":7,"e":"div","a":{"class":"invite-code"},"f":[{"t":2,"r":"invite.inviteCode"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"social-share text-center"},"f":[{"t":7,"e":"ul","a":{"class":"inline-list"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-anchor","a":{"class":"facebook","role":"link","href":[{"t":2,"r":"fbShareUrl"},{"t":2,"r":"sharableUrl"}],"target":[{"t":2,"r":"fbTarget"}],"title":[{"t":2,"r":"fbTitle"}]},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-facebook"}}]}]}],"n":50,"r":"fbShareUrl"}," ",{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-anchor","a":{"class":"twitter","role":"link","href":[{"t":2,"r":"twShareUrl"},{"t":2,"r":"sharableUrl"}],"target":[{"t":2,"r":"twTarget"}],"title":[{"t":2,"r":"twTitle"}]},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-twitter"}}]}]}],"n":50,"r":"twShareUrl"}," ",{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-anchor","a":{"class":"whatsapp","role":"link","href":[{"t":2,"r":"whatsappShareUrl"},{"t":2,"r":"sharableUrl"}],"target":[{"t":2,"r":"whatsappTarget"}],"title":[{"t":2,"r":"whatsappTitle"}]},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-whatsapp"}}]}]}],"n":50,"r":"whatsappShareUrl"}," ",{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-anchor","a":{"class":"email","role":"link","href":[{"t":2,"r":"emailShareUrl"},{"t":2,"r":"sharableUrl"}],"title":[{"t":2,"r":"emailTitle"}]},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-email"}}]}]}],"n":50,"r":"whatsappShareUrl"}]}]}],"n":50,"x":{"r":["fbShareUrl","twShareUrl","whatsappShareUrl","emailShareUrl"],"s":"_0||_1||_2||_3"}}],"n":50,"x":{"r":["invite.step"],"s":"_0===4"}}],"n":50,"x":{"r":["modalType"],"s":"_0===\"invite\""}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title"},"f":[{"t":2,"r":"stepOneTitle"}]}," ",{"t":3,"r":"stepOneDescription"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"modal-step-one"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-input-box","a":{"placeholder":"e.g. 91234567","label_value":"Mobile number","name":"signupMobileNumber","value":[{"t":2,"r":"mobileNumber"}],"mandatory":"true","maxLength":"8"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"mobileNumberErrorMsg"}]}}],"n":50,"r":"mobileNumberErrorMsg"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"invite-request-actions"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"goBack"},"f":["< Back"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["round send-otp step-1",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["signup.step1valid"],"s":"!_0"}}],"onclick":"requestOneTimePin"},"f":["Send OTP"]}]}]}],"n":50,"x":{"r":["signup.step"],"s":"_0===1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title"},"f":[{"t":2,"r":"stepTwoTitle"}]}," ",{"t":7,"e":"p","f":["An OTP has been sent by SMS to ",{"t":7,"e":"strong","f":[{"t":2,"r":"mobileNumber"}]}," and will expire in 3 minutes."]}," ",{"t":7,"e":"ux-row","a":{"class":"modal-step-two"},"f":[{"t":7,"e":"ux-input-box","a":{"placeholder":"Enter 6-digit OTP","label_value":"One-Time PIN (OTP)","name":"signupOtp","value":[{"t":2,"r":"oneTimePin"}],"mandatory":"true","minLength":"6","maxLength":"6"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"oneTimePinErrorMessage"}]}}],"n":50,"r":"oneTimePinErrorMessage"}," ",{"t":7,"e":"p","a":{"class":"v-normal-top"},"f":["No OTP? ",{"t":7,"e":"ux-anchor","a":{"ontap":"requestOneTimePin"},"f":["Resend"]}]}," ",{"t":7,"e":"ux-input-box","a":{"placeholder":"e.g. D16HG","label_value":"Invite code (optional)","name":"signupCode","value":[{"t":2,"r":"signup.inviteCode"}]},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"inviteCodeErrorMsg"}]}}],"n":50,"r":"inviteCodeErrorMsg"}," ",{"t":7,"e":"ux-checkbox","a":{"name":"signupTnc","checkboxid":"signupTnc","checked":[{"t":2,"r":"signup.tnc"}],"class":"signup-tnc","labelvalue":[{"t":3,"r":"tnc"}],"onChangeEvent":"setTnc"},"f":[]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"genericErrorMessage"}]}}]}],"n":50,"r":"genericErrorMessage"}," ",{"t":7,"e":"ux-row","a":{"class":"invite-request-actions"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"goBack"},"f":["< Back"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["round step-2",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["signup.step2valid"],"s":"!_0"}}],"onclick":"submitOneTimePin"},"f":["Next"]}]}]}],"n":50,"x":{"r":["signup.step"],"s":"_0===2"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"modal-step-four"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title"},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-tick"}}," ",{"t":2,"r":"stepThreeTitle"}]}," ",{"t":3,"x":{"r":["RactiveHelpers","stepThreeDescription"],"s":"_0.unescapeString(_1)"}}]}]}],"n":50,"x":{"r":["signup.step"],"s":"_0===3"}}],"n":50,"x":{"r":["modalType"],"s":"_0===\"signup\""}}]}]}]};
this["ux-layout-box"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-layout-box"},"f":[{"t":7,"e":"div","a":{"class":"lb-flexbox lb-flex-wrap","data-testid":"widget:layoutBox"},"f":[{"t":4,"f":[{"t":3,"r":"_mockContent"}],"n":50,"r":"_mockContent"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"_mockContent"}]}]}]};
this["ux-load-mask"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-load-mask ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"div","a":{"class":"loading-overlay"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"loading-overlay-loader-text text-center"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"product-header message"},"f":[{"t":3,"r":"pageLoadMessage"}]}]}],"n":50,"r":"pageLoadMessage"}," ",{"t":7,"e":"div","a":{"class":"loading-overlay-loader-image"}}]}]};
this["ux-locate-wifi"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-locate-wifi"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","a":{"class":"filter-header"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"main-header v-normal-bottom v-medium-top"},"f":[{"t":2,"r":"headerText"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":3,"r":"descriptionText"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-location","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"location"}],"options":[{"t":2,"r":"locations"}],"label_value":[{"t":2,"r":"filterLocationText"}]},"v":{"change":"selectLocation"}}]}],"n":50,"r":"locations"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-outlets","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"outlet"}],"options":[{"t":2,"r":"outlets"}],"label_value":[{"t":2,"r":"filterOutletText"}]},"v":{"change":"selectOutlet"}}]}],"n":50,"r":"outlets"}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"section-description"},"f":[{"t":3,"r":"smallDescriptionText"}]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"wifiList"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4 large-3 columns"},"f":[{"t":7,"e":"ux-panel","a":{"class":"show-for-medium-up wifi-location-box"},"f":[{"t":7,"e":"div","a":{"class":["text-left v-medium-bottom cursor ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"tap":{"n":"selectWifiLocation","d":[{"t":2,"r":"."}]}},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"wifiImage"}],"alt":[{"t":2,"r":"wifiImageAlt"}],"class":"wifi-image v-medium-bottom"}}," ",{"t":7,"e":"div","a":{"class":"wifi-title"},"f":[{"t":2,"r":"wifiTitle"}]}," ",{"t":7,"e":"div","a":{"class":"wifi-location"},"f":[{"t":2,"r":"wifiLocation"}]}]}]}," ",{"t":7,"e":"ux-panel","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":["text-left v-medium-bottom cursor ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"tap":{"n":"selectWifiLocation","d":[{"t":2,"r":"."}]}},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"wifiImage"}],"alt":[{"t":2,"r":"wifiImageAlt"}],"class":"wifi-image v-medium-bottom"}}," ",{"t":7,"e":"div","a":{"class":"wifi-title"},"f":[{"t":2,"r":"wifiTitle"}]}," ",{"t":7,"e":"div","a":{"class":"wifi-location"},"f":[{"t":2,"r":"wifiLocation"}]}]}]}]}],"n":50,"r":"display"}],"i":"index","r":"wifiList"}]}," ",{"t":7,"e":"div","a":{"id":"loader","class":"text-center v-large-bottom"},"f":[{"t":7,"e":"img","a":{"src":"assets/images/locate-wifi/preloader.gif"}}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"wifiHotSpotModal"},"f":[{"t":7,"e":"div","a":{"class":"section-title v-normal-bottom"},"f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":["Singtel WiFi Hotspot"]}]}," ",{"t":7,"e":"div","a":{"class":"section-details v-normal-top"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"selectedWifiImage"}],"alt":[{"t":2,"r":"selectedWifiImageAlt"}],"class":"wifi-image v-large-bottom v-normal-top"}}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":["Address"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"selectedTitle"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"selectedAddress"}]}," ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"selectedLocation"}],"ontap":"showMap","address":[{"t":2,"r":"selectedAddress"}]},"f":["View Location"]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top subsection-header"},"f":["Opening Hours"]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":2,"r":"openingHours"}]}," ",{"t":4,"f":[{"t":7,"e":"hr"}," ",{"t":7,"e":"div","a":{"class":"v-large-top v-normal-bottom"},"f":["Coverage Locations"]}," ",{"t":3,"r":"coverageLocation"}],"r":"coverageLocation"}]}]}]}]};
this["ux-loggedin-header"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-loggedin-header ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}," ",{"t":4,"f":["v-",{"t":2,"r":"bottomSpacing"},"-bottom"],"n":50,"r":"bottomSpacing"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":["header-icon medium-1 text-right small-only-text-center ",{"t":4,"f":["v-small-bottom v-none-top-mobile"],"n":50,"r":"isRedUser"},{"t":4,"n":51,"f":["v-normal-bottom"],"r":"isRedUser"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-image","a":{"class":[{"t":4,"f":["v-medium-top v-none-top-mobile"],"n":50,"r":"isRedUser"}],"src":[{"t":2,"r":"avatar"}],"alt":[{"t":2,"r":"alt"}]}}],"n":50,"r":"avatar"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-icon","a":{"outerClass":[{"t":4,"f":["v-medium-top v-none-top-mobile"],"n":50,"r":"isRedUser"}],"size":"xl","type":"avatar"}}],"r":"avatar"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-11"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"product-title red-member-label v-none-bottom v-none-top wraptext small-only-text-center"},"f":["Red Member"]}],"n":50,"r":"isRedUser"}," ",{"t":7,"e":"ux-header","a":{"level":"2","class":["v-small-top",{"t":4,"f":[" ",{"t":2,"r":"headingStyle"}],"n":50,"r":"headingStyle"},{"t":4,"n":51,"f":[" section-header"],"r":"headingStyle"}," small-only-text-center wraptext"]},"f":[{"t":2,"x":{"r":["greetings"],"s":"_0()"}},{"t":4,"f":[", ",{"t":2,"r":"userdata.nickName"}],"n":50,"r":"userdata.nickName"},". ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"changeNickNameLink","ontap":"gotoProfilePageLink"},"f":["Membership details"]}],"n":50,"r":"isRedUser"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"show-for-small-only text-center small-12"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"gotoProfilePageLink"},"f":["Membership details"]}],"n":50,"r":"isRedUser"}]}]}]}]};
this["ux-lptag-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-lptag-singtel"},"f":[]}]};
this["ux-lux-layout"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-lux-layout",{"t":2,"x":{"r":["theme"],"s":"_0?\" uxLuxLayout--\"+_0:\"\""}}]},"f":[{"t":7,"e":"div","a":{"class":["overlay",{"t":2,"x":{"r":["showSideNav"],"s":"_0==false?\"\":\" expanded\""}}]},"v":{"click":"toggleMobileMenu"}}," ",{"t":7,"e":"aside","a":{"class":["block__wrap",{"t":2,"x":{"r":["showSideNav"],"s":"_0==false?\"\":\" expanded\""}}]},"f":[{"t":7,"e":"div","a":{"class":"block__head"},"f":[{"t":7,"e":"a","a":{"href":"/"},"f":[{"t":7,"e":"img","a":{"src":"assets/images/logo/logo.svg","alt":"Optus Logo","width":"120px"}}]}]}," ",{"t":7,"e":"nav","a":{"class":"block__body"},"f":[{"t":4,"f":[{"t":7,"e":"ux-sidenav-searchable"}],"n":50,"r":"searchable"}," ",{"t":7,"e":"ul","a":{"class":"main-nav-container"},"f":[{"t":7,"e":"li","a":{"class":"nav"},"f":[{"t":7,"e":"a","a":{"href":"pages/index.html"},"f":["Docs"]}]}," ",{"t":7,"e":"li","a":{"class":"nav"},"f":[{"t":7,"e":"a","a":{"href":"components.html","class":""},"f":["Components"]}]}," ",{"t":7,"e":"li","a":{"class":"nav"},"f":[{"t":7,"e":"a","a":{"href":"pages/content/widgets.html","class":""},"f":["Widgets"]}]}," ",{"t":7,"e":"li","a":{"class":"nav"},"f":[{"t":7,"e":"a","a":{"href":"pages/content/demo-pages.html","class":""},"f":["Demo Pages"]}]}]}," ",{"t":7,"e":"ux-sidenav","a":{"datamodel":[{"t":3,"r":"navdata"}]}}]}]}," ",{"t":7,"e":"section","f":[{"t":7,"e":"header","a":{"role":"header"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-menu"},"v":{"click":"toggleMobileMenu"}}," ",{"t":7,"e":"ux-spring-nav","a":{"datamodel":"{\"navitems\": [{ \t\t\t\"label\": \"Docs\", \"href\": \"pages/index.html\", \"default\": \"true\" \t\t},{ \t\t\t\"label\": \"Components\", \"href\": \"components.html\" \t\t},{ \t\t\t\"label\": \"Widgets\", \"href\": \"widgets.html\" \t\t},{ \t\t\t\"label\": \"Demo Pages\", \"href\": \"pages/content/demo-pages.html\" \t\t}]}"}}]}," ",{"t":16}]}]}]};
this["ux-marketing-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-marketing-banner"},"f":[{"t":4,"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"link"}]},"f":[{"t":7,"e":"div","a":{"class":["banner-background ",{"t":2,"r":"theme"}," ",{"t":4,"f":["round-corner-shadow"],"n":50,"r":"showCornerAndShadow"}],"style":["background-image: url('",{"t":2,"r":"backgroundImg"},"')"]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"banner-content-outer"},"f":[{"t":7,"e":"div","a":{"class":"banner-content-inner text-center"},"f":[{"t":7,"e":"div","a":{"class":"banner-content v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"title-image"},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscript-text v-medium-top"},"f":[{"t":3,"r":"desc"}]}],"n":50,"r":"desc"}]}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["caption-background ",{"t":2,"r":"theme"}," ",{"t":4,"f":["round-corner-shadow"],"n":50,"r":"showCornerAndShadow"}],"style":[{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner text-center"},"f":[{"t":7,"e":"div","a":{"class":"content body-copy-text"},"f":[{"t":3,"r":"captionCopy"}]}]}]}]}]}]}],"n":50,"r":"captionCopy"}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-marketing-tradein-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-marketing-tradein-banner"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["banner-background ",{"t":2,"r":"theme"}],"style":["background-image: url(",{"t":2,"r":"backgroundImg.src"},")"]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":["small-12 medium-7 large-6 banner-content ",{"t":2,"r":"alignment"}," ",{"t":2,"x":{"r":["getContentStatusOnHide","hideFor"],"s":"_0(_1)"}}]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"main-header"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"banner-copy"},"f":[{"t":7,"e":"p","f":[{"t":3,"r":"desc"}]}," ",{"t":7,"e":"p","f":[{"t":7,"e":"ux-anchor","a":{"ontap":"tradeinWindow"},"f":[{"t":3,"r":"linkName"}]}]}]}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":["small-12 medium-5 large-6 banner-visual ",{"t":2,"x":{"r":["getHideStatus","hide_for"],"s":"_0(_1)"}}]},"f":[{"t":7,"e":"div","a":{"class":"banner-image foreground-fix-center"},"f":[{"t":7,"e":"div","a":{"class":"image"},"f":[{"t":7,"e":"ux-image","a":{"datamodel":[{"t":3,"r":"foregroundImg"}]}}]}]}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}," ",{"t":7,"e":"ux-tradein-modal","a":{"datamodel":[{"t":3,"r":"tradeInInfo"}]},"f":[]}]};
this["ux-membershipcard-upload"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-membershipcard-upload "},"f":[{"t":7,"e":"ux-row","a":{"class":"large-row column-control-mobile "},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"medium-text-left v-medium-left margin-large-mobile large-text-left section-header small-text-left"},"f":[{"t":2,"r":"aemData.title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 small-12"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"clearfix v-medium-bottom panel-header"},"f":[{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"div","a":{"class":"row body-light v-medium-top v-normal-bottom left"},"f":[{"t":3,"r":"membershipCard.info"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"medium-text-left large-text-left change-link","ontap":"doOpenModal:eligibleCards"},"f":[{"t":2,"r":"aemData.eligibleCards.link"}]}],"n":50,"r":"membershipCard.eligibleCards"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"row body-light left"},"f":["Important Note:",{"t":3,"r":"membershipCard.note"}]}],"n":50,"r":"membershipCard.note"}]}]}," ",{"t":7,"e":"div","a":{"class":"v-small-bottom small-text-left medium-text-left large-text-left"},"f":[{"t":2,"r":"aemData.uploadPhotoLabel"}]}," ",{"t":7,"e":"div","a":{"class":"document-list"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"uploaded-items"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-9  medium-6 file-name"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"item small-text-center medium-text-left large-text-left wraptext","ontap":["showUploadedImage:",{"t":2,"r":"./documentID"}]},"f":[{"t":2,"r":"./fileName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 medium-4 large-4"},"f":[{"t":7,"e":"ux-anchor","a":{"index":[{"t":2,"r":"i"}],"class":"v-small-left","ontap":["removeUploadedImage:",{"t":2,"r":"./documentID"}]},"f":[{"t":2,"r":"aemData.removeLabel"}]}]}]}]}],"n":52,"i":"i","r":"uploadedDocuments"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-5 large-4 no-padding margin-bottom-mobile"},"f":[{"t":7,"e":"form","a":{"action":"/upload","method":"post","enctype":"multipart/form-data"},"f":[{"t":7,"e":"div","a":{"class":["file-upload button light round v-normal-top ",{"t":2,"r":"disableUpload"}]},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"aemData.uploadLabel"}]}," ",{"t":7,"e":"input","a":{"type":"file","name":"file","id":"uploadFilemembershipCard","class":"upload","accept":[{"t":2,"r":"acceptedFileTypes"}]},"m":[{"t":2,"r":"disableUpload"}]}]}]}]}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"aemData.eShopErrorModel.eShopStartErrorMsg"}," ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"aemData.eShopErrorModel.eShopFormLinkUrl"}],"target":"_blank"},"f":[{"t":3,"r":"aemData.eShopErrorModel.eShopFormLinkText"}]}," ",{"t":2,"r":"aemData.eShopErrorModel.eShopEndErrorMsg"}]}],"n":50,"r":"dynamicMessage"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"errorMessage"}]},"f":[]}],"r":"dynamicMessage"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 show-for-medium-up v-normal-top"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 sample-front"},"f":[{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"r":"aemData.sampleFrontLabel"}]}," ",{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"r":"aemData.sampleFrontDesc"}]}],"n":50,"r":"aemData.sampleFrontDesc"}," ",{"t":7,"e":"ux-image","a":{"datamodel":[{"t":2,"r":"membershipCard.images.frontSampleImage"}]}}],"n":50,"x":{"r":["membershipCard.images","membershipCard.images.frontSampleImage"],"s":"_0&&_1"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 sample-back"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"aemData.sampleBackLabel"}]}," ",{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"r":"aemData.sampleBackDesc"}]}],"n":50,"r":"aemData.sampleBackDesc"}," ",{"t":7,"e":"ux-image","a":{"datamodel":[{"t":2,"r":"membershipCard.images.backSampleImage"}]}}]}],"n":50,"x":{"r":["membershipCard.images","membershipCard.images.backSampleImage"],"s":"_0&&_1"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-checkbox","a":{"checkboxid":"mask-code","class":"p-desktop-left margin-normal-mobile","checked":[{"t":2,"r":"membershipCard.isMaskChecked"}],"labelvalue":[{"t":2,"r":"membershipCard.maskDetails"}],"onChangeEvent":"checkData"}}," ",{"t":7,"e":"ux-col","f":[]}]}]}],"n":50,"x":{"r":["membershipCard","membershipCard.isMaskInfoRequired"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-right"},"f":[{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"aemData.missingDocumentMessage"}]},"f":[]}],"n":50,"r":"displayErrorMessage"}," ",{"t":7,"e":"ux-button","a":{"class":"round small-only-expand","text":"Submit","role":"button","arialabel":"Submit","onclick":"doSubmit"},"f":[]}," ",{"t":7,"e":"ux-col","f":[]}]}]}],"n":50,"r":"isNextButtonRequired"}," ",{"t":7,"e":"ux-modal","a":{"width":"1000","class":"light-theme previewImageModal","modalId":"showImageInfo"},"f":[{"t":7,"e":"div","a":{"class":"section-title clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"previewImage.fileName"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"section-details clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"ux-iframe","a":{"id":"iframeID","src":[{"t":2,"r":"previewImage.fileContent"}],"width":"100%"}}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"500","class":"light-theme oriModal","modalId":"uploadProgressInfo"},"f":[{"t":7,"e":"div","a":{"class":"section-title clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"uploadingImageName"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"section-details clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"progress"},"f":[{"t":7,"e":"div","a":{"class":"meter","style":["transition-duration: ",{"t":2,"r":"progressBarDuration"},"ms ;width: ",{"t":2,"r":"progressBarWidth"},"%;"]}}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme smallModal","modalId":"eligibleCards"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"section-title clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":3,"r":"aemData.eligibleCards.title"}]}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"row body-light v-medium-top v-medium-bottom left"},"f":[{"t":3,"r":"aemData.eligibleCards.description"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"eligibleCardsContainer"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 small-6"},"f":[{"t":7,"e":"ux-image","a":{"datamodel":[{"t":2,"r":"."}]}}]}],"n":52,"r":"membershipCard.eligibleCards"}]}]}]}]};
this["ux-microsite-price-plan"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-microsite-price-plan"},"f":[{"t":7,"e":"ux-row","a":{"class":"filters v-medium-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 medium-4 small-12 phone"},"f":[{"t":7,"e":"ux-select","a":{"selected_value":[{"t":2,"r":"pricePlanFilterData.selectedPhone"}],"showSelectedValue":"true","options":[{"t":2,"r":"filters.0.options"}],"label_value":[{"t":2,"r":"filters.0.label_value"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-4 medium-4 small-12 color"},"f":[{"t":7,"e":"ux-select","a":{"selected_value":[{"t":2,"r":"pricePlanFilterData.selectedColor"}],"showSelectedValue":"true","options":[{"t":2,"r":"filters.1.options"}],"label_value":[{"t":2,"r":"filters.1.label_value"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-accordion","a":{"data":[{"t":3,"r":"."}],"getDesktopBG":[{"t":2,"r":"getBackgroundImageForDesktop"}],"getMobileBG":[{"t":2,"r":"getBackgroundImageForMobile"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["panel accordion-wrapper ",{"t":2,"r":"metadata.theme"}],"style":["background-color: ",{"t":2,"r":"metadata.backgroundColor"}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","a":{"class":"title-link"},"f":[{"t":7,"e":"div","a":{"class":"ux-accordion-navigation-wrapper plan-group-banner","style":["background-image:url('",{"t":2,"x":{"r":["getDesktopBG","i"],"s":"_0(_1)"}},"')"]},"f":[{"t":7,"e":"ux-row","a":{"class":"collpase","style":["background-color:",{"t":2,"r":"./metadata.backgroundColor"},";"]},"f":[{"t":7,"e":"ux-col","a":{"class":"small-11 medium-6 plan-group-desc"},"f":[{"t":7,"e":"div","a":{"class":["hero-text ",{"t":2,"r":"metadata.theme"}]},"f":[{"t":2,"r":"./groupName"}]}," ",{"t":7,"e":"div","a":{"class":["body-text v-medium-bottom ",{"t":2,"r":"metadata.theme"}]},"f":[{"t":3,"r":"./description"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-1 medium-offset-5 medium-1"},"f":[{"t":7,"e":"div","a":{"class":["v-normal-top ",{"t":2,"r":"metadata.theme"}]},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}]}," ",{"t":2,"r":"./active"}," ",{"t":7,"e":"ux-content","f":[{"t":7,"e":"div","a":{"class":["ux-content-wrapper planGroup",{"t":2,"r":"i"}," ",{"t":2,"r":"metadata.theme"}],"style":["background-color: ",{"t":2,"r":"metadata.backgroundColor"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-easyplan","a":{"datamodel":[{"t":2,"r":"."}],"deviceIdAndPlanId":[{"t":2,"r":"deviceIdAndPlanId"}],"groupType":[{"t":2,"r":"./groupType"}],"selectedGroupType":[{"t":2,"r":"selectedGroupType"}]},"f":[]}],"n":50,"x":{"r":["./groupType"],"s":"_0===\"easyMobile\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["./groupType"],"s":"(_0===\"mobileShare\")"},"f":[{"t":4,"f":[{"t":7,"e":"ux-mobile-share","a":{"datamodel":[{"t":2,"r":"."}],"individualInContext":[{"t":2,"r":"individualInContext"}],"deviceIdAndPlanId":[{"t":2,"r":"deviceIdAndPlanId"}],"groupType":[{"t":2,"r":"./groupType"}],"selectedGroupType":[{"t":2,"r":"selectedGroupType"}]},"f":[]}],"n":50,"x":{"r":["deviceIdAndPlanId.deviceId"],"s":"!_0"}}]},{"t":4,"n":50,"x":{"r":["./groupType"],"s":"(!((_0===\"mobileShare\")))&&((_0===\"comboPlan\"))"},"f":[" ",{"t":7,"e":"ux-plan-list","a":{"datamodel":[{"t":2,"r":"."}],"deviceIdAndPlanId":[{"t":2,"r":"deviceIdAndPlanId"}],"groupType":[{"t":2,"r":"./groupType"}],"mobileplan":"true","selectedGroupType":[{"t":2,"r":"selectedGroupType"}]},"f":[]}]},{"t":4,"n":50,"x":{"r":["./groupType"],"s":"(!((_0===\"mobileShare\")))&&((!((_0===\"comboPlan\")))&&((_0===\"simOnlyPlan\")))"},"f":[" ",{"t":7,"e":"ux-sim-only-plan","a":{"datamodel":[{"t":3,"r":"."}],"deviceIdAndPlanId":[{"t":2,"r":"deviceIdAndPlanId"}],"groupType":[{"t":2,"r":"./groupType"}],"mobileplan":"false","selectedGroupType":[{"t":2,"r":"selectedGroupType"}]},"f":[]}]},{"t":4,"n":50,"x":{"r":["./groupType"],"s":"(!((_0===\"mobileShare\")))&&((!((_0===\"comboPlan\")))&&(!((_0===\"simOnlyPlan\"))))"},"f":[" ",{"t":7,"e":"ux-plan-list","a":{"datamodel":[{"t":2,"r":"."}],"deviceIdAndPlanId":[{"t":2,"r":"deviceIdAndPlanId"}],"groupType":[{"t":2,"r":"./groupType"}],"mobileplan":"false","selectedGroupType":[{"t":2,"r":"selectedGroupType"}]},"f":[]}]}],"x":{"r":["./groupType"],"s":"_0===\"easyMobile\""}}]}]}]}]}],"n":50,"x":{"r":["groupType","deviceIdAndPlanId.deviceId"],"s":"_0!==\"mobileShare\"||(_0===\"mobileShare\"&&!_1)"}}],"n":52,"i":"i","r":"data.planGroups"}]}]}]}]}]};
this["ux-microsite-stock-availability"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-microsite-stock-availability"},"f":[{"t":7,"e":"ux-row","a":{"class":"filters v-medium-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 medium-4 small-12 store-type"},"f":[{"t":7,"e":"ux-select","a":{"selected_value":[{"t":2,"r":"filterData.selectedStoreType"}],"showSelectedValue":"true","options":[{"t":2,"r":"filters.0.options"}],"label_value":[{"t":2,"r":"filters.0.label_value"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-4 medium-4 small-12 phone"},"f":[{"t":7,"e":"ux-select","a":{"selected_value":[{"t":2,"r":"filterData.selectedPhone"}],"showSelectedValue":"true","options":[{"t":2,"r":"filters.1.options"}],"label_value":[{"t":2,"r":"filters.1.label_value"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-4 medium-4 small-12 color"},"f":[{"t":7,"e":"ux-select","a":{"selected_value":[{"t":2,"r":"filterData.selectedColor"}],"showSelectedValue":"true","options":[{"t":2,"r":"filters.2.options"}],"label_value":[{"t":2,"r":"filters.2.label_value"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"stocks v-medium-top"},"f":[{"t":7,"e":"ux-row","a":{"class":["device-list ",{"t":4,"f":["no-stock"],"n":50,"x":{"r":["availableStockHeaders.length"],"s":"_0===0"}}]},"f":[{"t":7,"e":"ux-col","a":{"class":"large-3 medium-3 show-for-medium-up"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header  v-small-bottom show-for-medium-up"},"f":[]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-3 medium-3 show-for-medium-up"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header  v-small-bottom show-for-medium-up"},"f":[{"t":2,"r":"."}]}]}],"i":"i","r":"availableStockHeaders"}],"n":50,"x":{"r":["availableStockHeaders.length"],"s":"_0>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header  v-small-bottom"},"f":["No stock available!"]}]}],"x":{"r":["availableStockHeaders.length"],"s":"_0>0"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"stock-list"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header v-small-bottom"},"f":[{"t":2,"r":"region"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"stock-list"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-3 medium-3 small-12"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"body v-small-bottom v-small-top"},"f":[{"t":2,"r":"storeName"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-3 medium-3 small-12"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6 show-for-small-only"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":" show-for-small-only"},"f":[{"t":2,"r":"stockName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 large-12 medium-12"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":["light stocks-button button round ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["status"],"s":"_0===\"Not available\""}}],"href":[{"t":2,"r":"url"}],"target":"_blank","ontap":"redirectSelection","ariaLabel":[{"t":2,"r":"status"}]},"f":[{"t":2,"r":"status"}]}],"n":50,"r":"url"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"body v-small-bottom"},"f":[{"t":4,"f":[{"t":2,"r":"status"}],"n":50,"r":"storeId"},{"t":4,"n":51,"f":["Unknown"],"r":"storeId"}]}],"r":"url"}]}]}]}],"n":52,"r":"stocks"}]}],"n":52,"r":"mappedLocations"}],"r":"filteredStock"}]}]}]};
this["ux-mobile-share"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-mobile-share"},"f":[{"t":7,"e":"div","a":{"class":"plan-container"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":3,"r":"mobileShareContent"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"x":{"r":["getSelectedState","i"],"s":"_0(_1)"}}," ",{"t":4,"f":["v-normal-bottom"],"n":50,"r":"ribbon"}]},"v":{"tap":{"n":"planSelected","d":[{"t":2,"r":"i"}]}},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"ribbonPosition":"left"}}],"r":"ribbon"}," ",{"t":7,"e":"table","a":{"class":"plan-details-table show-for-medium-up v-normal-bottom"},"f":[{"t":7,"e":"tr","a":{"class":"plan"},"f":[{"t":7,"e":"td","a":{"class":["text-left plan-name p-normal-left row-title ",{"t":4,"f":["with-ribbon"],"n":50,"r":"ribbon"}]},"f":[{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"r":"planName"}]}]}," ",{"t":7,"e":"td","a":{"class":"plan-highlights text-left plan-data"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-11"},"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"data.quantity"},{"t":4,"f":[{"t":2,"r":"data.unit"}],"n":50,"x":{"r":["data.quantity"],"s":"_0!==\"Unlimited\""}}]}," Data",{"t":4,"f":["*"],"n":50,"r":"dataDisclaimer"}],"n":50,"x":{"r":["data.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," ",{"t":4,"f":["+"],"n":50,"x":{"r":["wifiData.quantity","data.quantity"],"s":"_1&&_0&&(_0>0||_0===\"Unlimited\")&&_1>0"}}," ",{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"wifiData.quantity"},{"t":4,"f":[{"t":2,"r":"wifiData.unit"}],"n":50,"x":{"r":["wifiData.quantity"],"s":"_0!==\"Unlimited\""}}]}," Singtel WiFi"],"n":50,"x":{"r":["wifiData.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"talktime.quantity"},{"t":4,"f":[{"t":2,"r":"talktime.unit"}],"n":50,"x":{"r":["talktime.quantity"],"s":"_0!==\"Unlimited\""}}]}," Talktime",{"t":4,"f":["*"],"n":50,"r":"minsDisclaimer"}," +"],"n":50,"x":{"r":["talktime.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," ",{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"sms.quantity"}]}," SMS",{"t":4,"f":["*"],"n":50,"r":"smsDisclaimer"}],"n":50,"x":{"r":["sms.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}]}],"n":50,"x":{"r":["talktime.quantity","sms.quantity"],"s":"(_0&&(_0>0||_0===\"Unlimited\"))||(_1&&(_1>0||_1===\"Unlimited\"))"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":7,"e":"li","f":[{"t":3,"r":"planDescSubLiner"}]}]}],"n":50,"r":"planDescSubLiner"}]}]}]}," ",{"t":7,"e":"td","a":{"class":"last-column text-right"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-normal-bottom"},"f":["Plan"]}," ",{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyCharges"],"s":"_0.convertUnits(_1,\"$\")"}}]},{"t":7,"e":"br"}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":["Monthly"]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":["plan-details-top ",{"t":4,"f":["with-ribbon"],"n":50,"r":"ribbon"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-7"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"r":"planName"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":[{"t":7,"e":"div","a":{"class":"text-right"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-small-bottom"},"f":["Plan"]}," ",{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyCharges"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":["Monthly"]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"plan-details-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"plan-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"data.quantity"},{"t":4,"f":[{"t":2,"r":"data.unit"}],"n":50,"x":{"r":["data.quantity"],"s":"_0!==\"Unlimited\""}}]}," Data",{"t":4,"f":["*"],"n":50,"r":"dataDisclaimer"}],"n":50,"x":{"r":["data.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," ",{"t":4,"f":["+"],"n":50,"x":{"r":["wifiData.quantity","data.quantity"],"s":"_1&&_0&&(_0>0||_0===\"Unlimited\")&&_1>0"}}," ",{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"wifiData.quantity"},{"t":2,"r":"wifiData.unit"}]}," Singtel WiFi"],"n":50,"x":{"r":["wifiData.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"plan-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"talktime.quantity"},{"t":2,"r":"talktime.unit"}]}," Talktime",{"t":4,"f":["*"],"n":50,"r":"minsDisclaimer"}," +"],"n":50,"x":{"r":["talktime.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," ",{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"sms.quantity"}]}," SMS",{"t":4,"f":["*"],"n":50,"r":"smsDisclaimer"}],"n":50,"x":{"r":["sms.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}]}]}],"n":50,"x":{"r":["talktime.quantity","sms.quantity"],"s":"(_0&&(_0>0||_0===\"Unlimited\"))||(_1&&(_1>0||_1===\"Unlimited\"))"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"plan-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"li","f":[{"t":3,"r":"planDescSubLiner"}]}]}]}],"n":50,"r":"planDescSubLiner"}]}]}]}],"n":52,"i":"i","r":"plans"}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"p","f":[{"t":2,"r":"promotion"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom note-text"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header"},"f":["Note:"]}," ",{"t":7,"e":"div","a":{"class":"description-text body-copy-text v-medium-top"},"f":[{"t":3,"r":"notes"}]}]}]}]}]};
this["ux-mobile-sub"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-mobile-sub"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"ConfigStrings.priorityItemIconUrl"}],"class":"priority-item","alt":"Priority"}}]}]}],"n":50,"r":"product.isPriorityItem"}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse callout-text-copy v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"ConfigStrings.genericError.productDetailsErrorMsg"}]}]}],"n":50,"x":{"r":["productDetails"],"s":"_0===\"productDetailsError\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["productDetails"],"s":"_0"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header v-medium-right"},"f":[{"t":2,"x":{"r":["ecarePlanName","plan.displayName"],"s":"_0||_1"}}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"left","ontap":"manageService"},"f":[{"t":2,"r":"initData.manageService.manageServiceText"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"r":"productDetails.subscriberCategoryX8"}," ",{"t":4,"f":[", Nominated for Key Line Discount"],"n":50,"r":"productDetails.keyLineIndX8"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":["Plan Specification"]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"r":"plan.displayDescription"}]}],"n":50,"x":{"r":["subscrType"],"s":"_0===\"MBB\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["dataUnits","smsUnits","voiceUnits"],"s":"_0+_1+_2"}}," Units ",{"t":4,"f":["+ ",{"t":2,"rx":{"r":"productFacade.parametersMapByCatalogId","m":[{"t":30,"n":"easyMobPalnSpecsAttributes.wifi.catalogItemId"},"valueName"]}}," ",{"t":2,"r":"easyMobPalnSpecsAttributes.wifi.title"}],"n":50,"rx":{"r":"productFacade.parametersMapByCatalogId","m":[{"t":30,"n":"easyMobPalnSpecsAttributes.wifi.catalogItemId"}]}}]}],"n":53,"r":"productDetails.units"}],"n":50,"r":"account.isEasyMobile"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["product.planSpecification"],"s":"_0"},"f":[{"t":4,"f":[{"t":3,"rx":{"r":"planSpecs","m":[{"r":["product.offeringId"],"s":"\"\\\"\"+_0+\"\\\"\""},"richText"]}}],"n":50,"x":{"r":["product.offeringId","planSpecs"],"s":"_1&&_1[\"\\\"\"+_0+\"\\\"\"]&&_1[\"\\\"\"+_0+\"\\\"\"].richText"}},{"t":4,"n":51,"f":[{"t":3,"r":"product.planSpecification"}],"x":{"r":["product.offeringId","planSpecs"],"s":"_1&&_1[\"\\\"\"+_0+\"\\\"\"]&&_1[\"\\\"\"+_0+\"\\\"\"].richText"}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"contarctExpiryTitle"},{"t":2,"r":"contarctExpiryValue"}]}],"n":50,"r":"isDisplayContractExpiry"}]},{"t":4,"n":50,"x":{"r":["product.planSpecification"],"s":"!(_0)"},"f":[" ",{"t":4,"f":[{"t":3,"rx":{"r":"planSpecs","m":[{"r":["product.offeringId"],"s":"\"\\\"\"+_0+\"\\\"\""},"richText"]}}],"n":50,"x":{"r":["product.offeringId","planSpecs"],"s":"_1&&_1[\"\\\"\"+_0+\"\\\"\"]&&_1[\"\\\"\"+_0+\"\\\"\"].richText"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"palnSpecsAttributes.voice.title"},": ",{"t":2,"r":"product.talktime.quantity"}," ",{"t":2,"r":"product.talktime.unit"}," Outgoing, Incoming Free"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"palnSpecsAttributes.sms.title"},": ",{"t":2,"r":"product.sms.quantity"}," ",{"t":2,"r":"product.sms.unit"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"palnSpecsAttributes.data.title"},": ",{"t":2,"r":"product.data.quantity"}," ",{"t":2,"r":"product.data.unit"}," Local Data ",{"t":4,"f":[", ",{"t":2,"r":"product.wifiData.quantity"}," ",{"t":2,"r":"product.wifiData.unit"}," ",{"t":2,"r":"palnSpecsAttributes.wifi.title"}],"n":50,"x":{"r":["product.wifiData","product.wifiData.dateFlag"],"s":"_0&&_1"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"product.roamingBenefit"}]}],"n":50,"r":"product.displayRoamingCredit"}],"x":{"r":["product.offeringId","planSpecs"],"s":"_1&&_1[\"\\\"\"+_0+\"\\\"\"]&&_1[\"\\\"\"+_0+\"\\\"\"].richText"}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"contarctExpiryTitle"},{"t":2,"r":"contarctExpiryValue"}]}],"n":50,"r":"isDisplayContractExpiry"}]}],"r":"account.isEasyMobile"}]}],"x":{"r":["subscrType"],"s":"_0===\"MBB\""}}]}],"n":50,"x":{"r":["isSimOnlyPlan","product","product.planSpecification"],"s":"!_0(_1)||(_2)"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["isSimOnlyPlan","product","isDisplayContractExpiry"],"s":"_0(_1)&&_2"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":["Plan Specification"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"contarctExpiryTitle"},{"t":2,"r":"contarctExpiryValue"}]}]}]}]}],"x":{"r":["isSimOnlyPlan","product","product.planSpecification"],"s":"!_0(_1)||(_2)"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":[{"t":2,"r":"ConfigStrings.ippPlansStrings.deviceAndAccessoriesTitle"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"productFacade.ippContractData.deviceName"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"productFacade.ippContractData.ippContractDuration"}," ",{"t":2,"r":"ConfigStrings.ippPlansStrings.instalment"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["productFacade.ippContractData.ippDeviceContractStartDate"],"s":"_0.format(\"DD MMM YYYY\")"}}," - ",{"t":2,"x":{"r":["productFacade.ippContractData.ippDeviceContractEndDate"],"s":"_0.format(\"DD MMM YYYY\")"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":3,"r":"initData.ippMarketingMessage"}]}]}],"n":50,"x":{"r":["planGroupName"],"s":"_0===\"IPPPLANS\""}}],"n":50,"x":{"r":["productFacade.ippContractData","productFacade.ippContractData.display"],"s":"_0&&_1"}}]}],"x":{"r":["productDetails"],"s":"_0===\"productDetailsError\""}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"initData.subInitData.simOnlyRecontractOptionsText"}]}," ",{"t":7,"e":"span","a":{"class":"hide"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"showContractDetails"},"f":[{"t":2,"r":"initData.subInitData.recontractOptionsLinkText"}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":7,"e":"ux-replace-text","a":{"text":[{"t":3,"r":"initData.subInitData.simOnlyRecontractDateText"}],"isObservableKey":"true","KEY_RECONTRACT_DATE":[{"t":2,"x":{"r":["productFacade.recontractData.actualReconDate"],"s":"_0.format(\"MMMM YYYY\")"}}]},"f":[]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"initData.subInitData.simOnlyRecontractAlternativeText"}," ",{"t":7,"e":"br"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}},": Upgrade for ",{"t":2,"x":{"r":["RactiveHelpers","reconPrice"],"s":"_0.convertUnits(_1,\"$withoutDecimal\")"}}]}],"n":53,"r":"productFacade.recontractData.recon12MonthsBefore"}],"n":50,"r":"productFacade.recontractData.recon12MonthsBefore"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}},": Upgrade for ",{"t":2,"x":{"r":["RactiveHelpers","reconPrice"],"s":"_0.convertUnits(_1,\"$withoutDecimal\")"}}]}],"n":53,"r":"productFacade.recontractData.recon6MonthsBefore"}],"n":50,"r":"productFacade.recontractData.recon6MonthsBefore"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":2,"x":{"r":["productFacade.recontractData.actualReconDate"],"s":"_0.format(\"MMMM YYYY\")"}},": Upgrade for FREE"]}],"n":50,"r":"productFacade.recontractData.actualReconDate"}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"br"}," ",{"t":3,"x":{"r":["RactiveHelpers","initData.subInitData.simOnlyRecontractNote"],"s":"_0.unescapeString(_1)"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":"light v-large-top round expand-for-mobile","permission":[{"t":2,"r":"permission"}],"onclick":"recontractMobile","text":[{"t":2,"r":"initData.subInitData.recontractButtonText"}],"isOrderPending":[{"t":2,"r":"pendingOrders.isChangePlanPending"}]},"f":[]}]}],"n":50,"x":{"r":["productFacade.recontractData.isEligibleForRecon","displayReconButton"],"s":"_0&&!_1"}}]}],"n":50,"x":{"r":["planGroupName"],"s":"_0===\"SIMONLY\"||_0===\"MOBILESHARE\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["displayReconButton"],"s":"!_0"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"initData.subInitData.recontractOptionsText"}]}," ",{"t":7,"e":"span","a":{"class":"hide"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"showContractDetails"},"f":[{"t":2,"r":"initData.subInitData.recontractOptionsLinkText"}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":7,"e":"ux-replace-text","a":{"text":[{"t":3,"r":"initData.subInitData.recontractDateText"}],"isObservableKey":"true","KEY_REONCTRACT_DATE":[{"t":2,"x":{"r":["productFacade.recontractData.actualReconDate"],"s":"_0.format(\"MMMM YYYY\")"}}]},"f":[]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"initData.subInitData.recontractAlternativeText"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}},": ",{"t":2,"x":{"r":["RactiveHelpers","reconPrice"],"s":"_0.convertUnits(_1,\"$withoutDecimal\")"}}," ",{"t":2,"r":"initData.subInitData.deviceUpgradeFee"}]}],"n":53,"r":"productFacade.recontractData.recon18MonthsBefore"}],"n":50,"x":{"r":["productFacade.recontractData.recon18MonthsBefore","productFacade.recontractData.recon18MonthsBefore.reconPrice"],"s":"_0&&_1>=0"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}},": ",{"t":2,"x":{"r":["RactiveHelpers","reconPrice"],"s":"_0.convertUnits(_1,\"$withoutDecimal\")"}}," ",{"t":2,"r":"initData.subInitData.deviceUpgradeFee"}]}],"n":53,"r":"productFacade.recontractData.recon12MonthsBefore"}],"n":50,"x":{"r":["productFacade.recontractData.recon12MonthsBefore","productFacade.recontractData.recon12MonthsBefore.reconPrice"],"s":"_0&&_1>=0"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}},": ",{"t":2,"x":{"r":["RactiveHelpers","reconPrice"],"s":"_0.convertUnits(_1,\"$withoutDecimal\")"}}," ",{"t":2,"r":"initData.subInitData.deviceUpgradeFee"}]}],"n":53,"r":"productFacade.recontractData.recon6MonthsBefore"}],"n":50,"x":{"r":["productFacade.recontractData.recon6MonthsBefore","productFacade.recontractData.recon6MonthsBefore.reconPrice"],"s":"_0&&_1>=0"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}},": ",{"t":2,"x":{"r":["RactiveHelpers","reconPrice"],"s":"_0.convertUnits(_1,\"$withoutDecimal\")"}}," ",{"t":2,"r":"initData.subInitData.deviceUpgradeFee"}]}],"n":53,"r":"productFacade.recontractData.recon3MonthsBefore"}],"n":50,"x":{"r":["productFacade.recontractData.recon3MonthsBefore","productFacade.recontractData.recon3MonthsBefore.reconPrice"],"s":"_0&&_1>=0"}}]}],"n":50,"x":{"r":["productFacade.CIFailedFlag","productFacade.recontractData.showCIDetails"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["productFacade.recontractData.showCIDetails"],"s":"_0"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"initData.subInitData.recontractAlternativeText"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}},": ",{"t":2,"r":"initData.earlyCIAPIFailedMsg"}]}],"n":53,"r":"productFacade.recontractData.recon18MonthsBefore"}],"n":50,"r":"productFacade.recontractData.recon18MonthsBefore"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}},": ",{"t":2,"r":"initData.earlyCIAPIFailedMsg"}]}],"n":53,"r":"productFacade.recontractData.recon12MonthsBefore"}],"n":50,"r":"productFacade.recontractData.recon12MonthsBefore"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}},": ",{"t":2,"r":"initData.earlyCIAPIFailedMsg"}]}],"n":53,"r":"productFacade.recontractData.recon6MonthsBefore"}],"n":50,"r":"productFacade.recontractData.recon6MonthsBefore"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}},": ",{"t":2,"r":"initData.earlyCIAPIFailedMsg"}]}],"n":53,"r":"productFacade.recontractData.recon3MonthsBefore"}],"n":50,"r":"productFacade.recontractData.recon3MonthsBefore"}]}]}],"x":{"r":["productFacade.CIFailedFlag","productFacade.recontractData.showCIDetails"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":"light v-large-top round expand-for-mobile","permission":[{"t":2,"r":"permission"}],"onclick":"recontractMobile","text":[{"t":2,"r":"initData.subInitData.recontractButtonText"}],"isOrderPending":[{"t":2,"r":"pendingOrders.isChangePlanPending"}]},"f":[]}]}]}],"n":50,"x":{"r":["productFacade.recontractData.isEligibleForRecon","displayReconButton"],"s":"_0&&!_1"}}]}],"x":{"r":["planGroupName"],"s":"_0===\"SIMONLY\"||_0===\"MOBILESHARE\""}}],"n":50,"r":"productFacade.recontractData.display"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"voucher-panel flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-item v-medium-right"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"initData.voucherInitData.voucherImage.src"}],"alt":[{"t":2,"r":"initData.voucherInitData.voucherImage.alt"}]}}]}," ",{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header v-small-bottom"},"f":["Handset Voucher"]}," ",{"t":7,"e":"div","f":["You are eligible for a ",{"t":2,"x":{"r":["RactiveHelpers","voucherDetails.voucherValue"],"s":"_0.convertUnits(_1,\"$\")"}}," handset voucher if you recontract before ",{"t":2,"x":{"r":["moment","voucherDetails.earliestExpiryDate"],"s":"_0(_1).format(\"DD MMMM YYYY\")"}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large small-only-text-center"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"recontractMobile","isOrderPending":[{"t":2,"r":"pendingOrders.isChangePlanPending"}],"permission":[{"t":2,"r":"permission"}]},"f":["Redeem your voucher now"]}]}],"n":50,"x":{"r":["voucherDetails.voucherValue"],"s":"_0&&_0>0"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["voucherDetails"],"s":"_0===\"voucherFetchError\""},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse callout-text-copy v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"ConfigStrings.genericError.voucherErrorMsg"}]}]}]}],"x":{"r":["voucherDetails.voucherValue"],"s":"_0&&_0>0"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-offset-2 medium-4 v-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-sub-addon","a":{"subscription":[{"t":2,"r":"."}],"account":[{"t":2,"r":"account"}],"productFacade":[{"t":2,"r":"productFacade"}],"product":[{"t":2,"r":"product"}],"initData":[{"t":2,"r":"initData.addonInitData"}],"permission":[{"t":2,"r":"permission"}]}}],"n":50,"x":{"r":["productDetails"],"s":"_0!==\"productDetailsError\""}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-usage-details","a":{"account":[{"t":2,"r":"account"}],"subscription":[{"t":2,"r":"."}],"permission":[{"t":2,"r":"permission"}],"initData":[{"t":2,"r":"initData.usageInitData"}],"addonInitData":[{"t":2,"r":"initData.addonInitData"}],"product":[{"t":2,"r":"product"}],"productFacade":[{"t":2,"r":"productFacade"}]}}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme manage-service-modal","modalId":"manageServiceModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"left section-header"},"f":[{"t":2,"r":"initData.manageService.header"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom"},"f":[{"t":2,"r":"initData.manageService.headerMsg"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"highlight hover-container"},"f":[{"t":7,"e":"ux-anchor","a":{"url":[{"t":4,"f":[{"t":2,"r":"initData.changePlanLink"}],"n":50,"x":{"r":["permission.ipa","permission.blacklisted","pendingOrders.isChangePlanPending"],"s":"!(_0||_1)&&_2"}}],"ontap":"changePlan","product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}],"isOrderPending":[{"t":2,"r":"pendingOrders.isChangePlanPending"}],"permission":[{"t":2,"r":"permission"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header v-medium-bottom"},"f":[{"t":2,"r":"initData.changePlanText"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"body-text"},"f":[{"t":2,"r":"initData.manageService.changePlanMsg"}]}]}]}],"n":50,"x":{"r":["isChangePlanAllowed","planGroupName","shouldHideChangePlan"],"s":"_0(_1)&&!_2()"}}," ",{"t":4,"f":[" ",{"t":7,"e":"ux-row","a":{"class":"highlight hover-container"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"cancelPendingSuspendRequest","permission":[{"t":2,"r":"permission"}],"product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header v-medium-bottom"},"f":[{"t":2,"r":"initData.manageService.cancelTerminationServiceText"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"body-text"},"f":[{"t":2,"r":"initData.manageService.cancelTerminationServiceMsg"}]}]}]}],"n":50,"r":"pendingOrders.isFutureSuspendRequest"},{"t":4,"n":51,"f":[" ",{"t":7,"e":"ux-row","a":{"class":"highlight hover-container"},"f":[{"t":7,"e":"ux-anchor","a":{"url":[{"t":4,"f":[{"t":2,"r":"initData.manageService.suspensionOfServiceLink"}],"n":50,"x":{"r":["permission.ipa","permission.blacklisted","pendingOrders.isSuspendPending"],"s":"!(_0||_1)&&_2"}}],"ontap":"suspendService","permission":[{"t":2,"r":"permission"}],"product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}],"isOrderPending":[{"t":2,"r":"pendingOrders.isSuspendPending"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header v-medium-bottom"},"f":[{"t":2,"r":"initData.manageService.suspensionOfServiceText"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"body-text"},"f":[{"t":2,"r":"initData.manageService.suspensionofServiceMsg"}]}]}]}],"r":"pendingOrders.isFutureSuspendRequest"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"highlight hover-container"},"f":[{"t":7,"e":"ux-anchor","a":{"url":[{"t":4,"f":[{"t":2,"r":"initData.replaceSimLink"}],"n":50,"x":{"r":["permission.ipa","permission.blacklisted","pendingOrders.isResumePending"],"s":"!(_0||_1)&&_2"}}],"permission":[{"t":2,"r":"permission"}],"product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}],"isOrderPending":[{"t":2,"r":"pendingOrders.isResumePending"}],"ontap":"replaceSim"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header v-medium-bottom"},"f":[{"t":2,"r":"initData.manageService.resumeofServiceText"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"body-text"},"f":[{"t":2,"r":"initData.manageService.resumeofServiceMsg"}]}]}]}],"n":50,"x":{"r":["subscrStatus","productDetails.reasonCodeX8","shouldHideReplaceSim"],"s":"_0===83&&_1===\"LNS\"&&!_2()"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["subscrStatus"],"s":"_0===83"},"f":[{"t":7,"e":"ux-row","a":{"class":"highlight hover-container"},"f":[{"t":7,"e":"ux-anchor","a":{"url":[{"t":4,"f":[{"t":2,"r":"initData.manageService.resumeofServiceLink"}],"n":50,"x":{"r":["permission.ipa","permission.blacklisted","pendingOrders.isResumePending"],"s":"!(_0||_1)&&_2"}}],"permission":[{"t":2,"r":"permission"}],"product":[{"t":2,"r":"product"}],"isOrderPending":[{"t":2,"r":"pendingOrders.isResumePending"}],"account":[{"t":2,"r":"account"}],"ontap":"resumeService"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header v-medium-bottom"},"f":[{"t":2,"r":"initData.manageService.resumeofServiceText"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"body-text"},"f":[{"t":2,"r":"initData.manageService.resumeofServiceMsg"}]}]}]}]}],"x":{"r":["subscrStatus","productDetails.reasonCodeX8","shouldHideReplaceSim"],"s":"_0===83&&_1===\"LNS\"&&!_2()"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"highlight hover-container"},"f":[{"t":7,"e":"ux-anchor","a":{"url":[{"t":4,"f":[{"t":2,"r":"initData.replaceSimLink"}],"n":50,"x":{"r":["permission.ipa","permission.blacklisted","pendingOrders.isReplaceSimPending"],"s":"!(_0||_1)&&_2"}}],"ontap":"replaceSim","product":[{"t":2,"r":"product"}],"permission":[{"t":2,"r":"permission"}],"isOrderPending":[{"t":2,"r":"pendingOrders.isReplaceSimPending"}],"account":[{"t":2,"r":"account"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header v-medium-bottom"},"f":[{"t":2,"r":"initData.manageService.replaceSimText"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"body-text"},"f":[{"t":2,"r":"initData.manageService.replaceSimMsg"}]}]}]}],"n":50,"x":{"r":["subscrStatus","productDetails.reasonCodeX8","shouldHideReplaceSim"],"s":"_0!==67&&_1!==\"LNS\"&&!_2()"}}," ",{"t":7,"e":"ux-row","a":{"class":"highlight hover-container"},"f":[{"t":7,"e":"ux-anchor","a":{"url":[{"t":4,"f":[{"t":2,"r":"initData.manageService.changeMobileNoLink"}],"n":50,"x":{"r":["permission.ipa","permission.blacklisted","subscrStatus","pendingOrders.isChangeMobileNumberPending"],"s":"!(_0||_1)&&_2!==83&&_3"}}],"permission":[{"t":2,"r":"permission"}],"product":[{"t":2,"r":"product"}],"ontap":"changeMobileNumber","account":[{"t":2,"r":"account"}],"isOrderPending":[{"t":2,"r":"pendingOrders.isChangeMobileNumberPending"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header v-medium-bottom"},"f":[{"t":2,"r":"initData.manageService.changeMobileNoText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":2,"r":"initData.manageService.changeMobileNoMsg"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"highlight hover-container"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"changeOwnership","product":[{"t":2,"r":"product"}],"account":[{"t":2,"r":"account"}],"isOrderPending":[{"t":2,"r":"pendingOrders.isChangePlanPending"}],"permission":[{"t":2,"r":"permission"}],"Recipient.nric":"","Recipient.idType":"","currentServiceId":[{"t":2,"r":"product.serviceId"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left section-header v-medium-bottom"},"f":[{"t":2,"r":"initData.manageService.changeOwnershipText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":2,"r":"initData.manageService.changeOwnershipMsg"}]}]}],"n":50,"x":{"r":["planGroupName"],"s":"_0!==\"IPPPLANS\""}}," "]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"recontractDetailsModal"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":3,"r":"initData.subInitData.contractEndDateHeaderText"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-replace-text","a":{"text":[{"t":3,"r":"initData.subInitData.recontractDateText"}],"isObservableKey":"true","KEY_REONCTRACT_DATE":[{"t":2,"x":{"r":["productFacade.recontractData.deviceContractEndDate"],"s":"_0.format(\"D MMMM YYYY\")"}}]},"f":[]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":"v-large-top round expand-for-mobile","onclick":"recontractMobile","permission":[{"t":2,"r":"permission"}],"text":[{"t":2,"r":"initData.subInitData.recontractButtonText"}],"isOrderPending":[{"t":2,"r":"pendingOrders.isChangePlanPending"}]},"f":[]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"initData.subInitData.recontractAlternativeText"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"initData.subInitData.dateHeaderText"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"initData.subInitData.deviceUpgradeFeeHeaderText"}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom bordered-bottom-small"}}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","reconPrice"],"s":"_0.convertUnits(_1,\"$withoutDecimal\")"}}]}],"n":53,"r":"productFacade.recontractData.recon18MonthsBefore"}],"n":50,"r":"productFacade.recontractData.recon18MonthsBefore"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","reconPrice"],"s":"_0.convertUnits(_1,\"$withoutDecimal\")"}}]}],"n":53,"r":"productFacade.recontractData.recon12MonthsBefore"}],"n":50,"r":"productFacade.recontractData.recon12MonthsBefore"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","reconPrice"],"s":"_0.convertUnits(_1,\"$withoutDecimal\")"}}]}],"n":53,"r":"productFacade.recontractData.recon6MonthsBefore"}],"n":50,"r":"productFacade.recontractData.recon6MonthsBefore"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["reonDate"],"s":"_0.format(\"MMMM YYYY\")"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","reconPrice"],"s":"_0.convertUnits(_1,\"$withoutDecimal\")"}}]}],"n":53,"r":"productFacade.recontractData.recon3MonthsBefore"}],"n":50,"r":"productFacade.recontractData.recon3MonthsBefore"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"voucher-panel"},"f":[{"t":7,"e":"div","a":{"class":"left v-medium-right"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"initData.voucherInitData.voucherImage.src"}],"alt":[{"t":2,"r":"initData.voucherInitData.voucherImage.alt"}]}}]}," ",{"t":7,"e":"ux-header","a":{"class":"subsection-header v-small-bottom"},"f":["Handset Voucher"]}," ",{"t":7,"e":"div","f":["You are eligible for a ",{"t":2,"x":{"r":["RactiveHelpers","voucherDetails.voucherValue"],"s":"_0.convertUnits(_1,\"$\")"}}," handset voucher if you recontract before ",{"t":2,"x":{"r":["moment","voucherDetails.earliestExpiryDate"],"s":"_0(_1).format(\"DD MMMM YYYY\")"}}]}]}]}],"n":50,"x":{"r":["voucherDetails.voucherValue"],"s":"_0&&_0>0"}}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme change-ownership-START-modal change-OwnerShip-nric","modalId":"changeOwnershipSTART"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_start\""},"titleText"]}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-large-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_start\""},"staticText"]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"input-label-bold collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_start\""},"donorMobileNumberTxt"]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"x":{"r":["RactiveHelpers","product.serviceId"],"s":"_0.mobileNumberFormat(_1)"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom v-normal-top collapse"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_start\""},"recipientIdentification"]}}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ux-col","a":{"class":"small-2"},"f":[{"t":7,"e":"ux-select","a":{"id":"personIdType","class":"medium left","showSelectedValue":"true","options":[{"t":2,"r":"ConfigStrings.personIdTypeOptions"}],"selected_value":[{"t":2,"r":"Recipient.idType"}]},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-left small-9 nricWidth"},"f":[" ",{"t":7,"e":"ux-input-box","a":{"id":"personId","value":[{"t":2,"r":"Recipient.nric"}],"validity":[{"t":2,"r":"Recipient.nricErrorMsg"}],"onblurEvent":"onBlurNric"},"f":[]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"ConfigStrings.invalidNRICFormatMsg"}]}}],"n":50,"x":{"r":["isValid","isValid.valid"],"s":"_0&&(_1===false)"}}," "]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["round margin-zero ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["isValid","isValid.valid"],"s":"_0&&(!_1)"}}],"text":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_start\""},"buttonText"]}}],"onclick":"changeOwnershipEvents","current_State":"START","validation_State":"false","recipient_details":[{"t":2,"r":"Recipient"}],"account":[{"t":2,"r":"account"}],"product":[{"t":2,"r":"product"}]}}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme change-ownership-PROCESS-modal change-OwnerShip","modalId":"changeOwnershipPROCESS"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_process\""},"titleText"]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-bottom"},"f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_process\""},"staticText"]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-padding-left-right"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_process\""},"donorMobileNumberTxt"]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","product.productDetails.serviceId"],"s":"_0.mobileNumberFormat(_1)"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-padding-left-right"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_process\""},"recipientIdentification"]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["Recipient.idType","Recipient.nric"],"s":"_0+_1"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-top v-padding-left-right"},"f":[{"t":7,"e":"ux-col","a":{"class":"subsection-header"},"f":["Note:"]}]}," ",{"t":7,"e":"ux-row","a":{"class":" v-padding-left-right"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ul","a":{"class":"ul-type"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":2,"r":"."}]}],"n":52,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_process\""},"noteMsg"]}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal v-padding-left-right"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-checkbox","a":{"checked":[{"t":2,"r":"isTncAgreed"}],"class":"left"},"f":["I agree to the ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_process\""},"tncLink"]}}],"target":"_blank"},"f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_process\""},"tncText"]}}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-padding-left-right"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["round margin-zero ",{"t":4,"f":["disabled"],"n":51,"r":"isTncAgreed"}],"text":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_process\""},"buttonText"]}}],"onclick":"changeOwnershipEvents","addon":[{"t":2,"r":"productFacade.addOnsMapByCatalogId"}],"account":[{"t":2,"r":"account"}],"product":[{"t":2,"r":"product"}],"current_State":"PROCESS","validation_State":"false"}}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme change-ownership-START-modal change-OwnerShip","modalId":"changeOwnershipCONFIRM"},"f":[" ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_confirm\""},"titleText"]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-bottom"},"f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_confirm\""},"staticText"]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-padding-left-right"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_confirm\""},"donorMobileNumberTxt"]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","product.productDetails.serviceId"],"s":"_0.mobileNumberFormat(_1)"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-padding-left-right"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":[{"t":2,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_confirm\""},"recipientIdentification"]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["Recipient.idType","Recipient.nric"],"s":"_0+_1"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-top v-padding-left-right"},"f":[{"t":7,"e":"ux-col","a":{"class":"subsection-header"},"f":["Note:"]}]}," ",{"t":7,"e":"ux-row","a":{"class":" v-padding-left-right"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ul","a":{"class":"ul-type"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":2,"r":"."}]}],"n":52,"rx":{"r":"initData.changeOwnershipModelSetting","m":[{"r":[],"s":"\"_confirm\""},"noteMsg"]}}]}]}]}]}],"n":53,"r":"product"}]};
this["ux-modal-wrapper"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-modal-wrapper"},"f":[{"t":7,"e":"ux-modal","a":{"width":[{"t":2,"r":"width"}],"class":"light-theme","modalId":[{"t":2,"r":"modalId"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":[{"t":2,"r":"modalDetails.ippModalHeader"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":3,"r":"modalDetails.ippModalDesc"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-center"},"f":[{"t":7,"e":"ux-button","a":{"class":"round text-center","onclick":[{"t":2,"r":"onButtonClick"}],"text":[{"t":2,"r":"modalDetails.ippButtonLabel"}]}}]}]}],"n":50,"r":"onButtonClick"}]}]}]};
this["ux-modal"] = {"v":3,"t":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[" ",{"t":7,"e":"style","f":["\t\t\t\t@media only screen and (min-width: 769px) {\n\t\t\t\t\t.ux-modal .modal.sticky-modal .scrollable-content {\n\t\t\t\t\t\tmax-height: 250px;\n\t\t\t\t\t\toverflow-y: auto;\n\t\t\t\t\t}\n\t\t\t\t\t.ux-modal .modal {\n\t\t\t\t\t\toverflow-y: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t"]}],"n":50,"x":{"r":["RactiveHelpers"],"s":"_0.isBrowserIE(true)"}}],"n":50,"r":"sticky"},{"t":4,"f":[{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":8,"r":"content"}]}],"n":50,"r":"inIframe"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":["ux-modal ",{"t":2,"r":"containerClass"}," ",{"t":4,"f":[{"t":4,"f":["hideModal"],"n":50,"x":{"r":["showModal"],"s":"!_0"}}],"n":50,"r":"isPModal"}],"role":"dialog","id":[{"t":2,"x":{"r":["modalId","modal_id"],"s":"_0||_1"}}]},"t2":{"n":"fade","d":[{"t":4,"f":["fadeDelay"],"n":50,"l":{"t":4,"n":51,"f":["0"],"r":"fadeDelay"},"r":"fadeDelay"}]},"o":{"n":"loadMask","a":[{"selector":".modal","class":"full-screen"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["modal-bg ",{"t":4,"f":[{"t":2,"r":"bgColor"}],"r":"bgColor"}]}}],"n":50,"r":"hideCloseIcon"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":["modal-bg ",{"t":4,"f":[{"t":2,"r":"bgColor"}],"r":"bgColor"}]},"v":{"tap":"doCloseModal"}}," ",{"t":7,"e":"div","a":{"class":"modal-close-ext","tabindex":"0"},"v":{"tap":"doCloseModal","enter":"doCloseModal"},"f":[{"t":7,"e":"ux-icon","a":{"type":"close-line","ariaHidden":"true"}}]}],"r":"hideCloseIcon"}," ",{"t":7,"e":"div","a":{"class":["modal ",{"t":2,"r":"class"}],"style":[{"t":4,"f":["width:",{"t":2,"r":"widthPercentage"},"%;"],"r":"widthPercentage"}," ",{"t":4,"f":["height:",{"t":2,"r":"heightPercentage"},"%;"],"r":"heightPercentage"}," ",{"t":4,"f":["max-width:",{"t":2,"r":"width"},"px;"],"r":"width"}," ",{"t":4,"f":["max-height:",{"t":2,"r":"height"},"px;"],"r":"height"}]},"v":{"tap":{"n":[{"t":4,"f":["doCloseModal"],"n":50,"r":"videoURL"}],"d":[]}},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"a","a":{"class":["close-modal",{"t":4,"f":[" ",{"t":2,"r":"iconClass"}],"n":50,"r":"iconClass"}],"title":"close modal"},"v":{"tap":"doCloseModal"},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icon"}],"size":[{"t":2,"r":"size"}],"ariaHidden":"true"}}]}],"n":50,"r":"icon"},{"t":4,"n":51,"f":[{"t":7,"e":"a","a":{"class":"close-modal","tabindex":"0","title":"close modal"},"v":{"click":"doCloseModal"},"f":[{"t":7,"e":"ux-icon","a":{"type":"close-line","ariaHidden":"true"}}]}],"r":"icon"}],"n":51,"r":"hideCloseIcon"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["modal-title ",{"t":2,"r":"titleClass"}]},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":2,"r":"title"}]}]}],"n":50,"r":"title"}],"n":51,"r":"hideTitle"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"modal-subtitle"},"f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":[{"t":3,"r":"subtitle"}]}]}],"n":50,"r":"subtitle"}," ",{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":8,"r":"content"}]}]}]}],"r":"inIframe"}],"r":"displayState"}]};
this["ux-msoffice-subscription"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-msoffice-subscription ",{"t":2,"r":"theme"}]},"f":[" ",{"t":7,"e":"ux-panel","a":{"class":"text-center dark"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"panelImage.desktop.src"}],"alt":[{"t":2,"r":"panelImage.desktop.alt"}],"class":"show-for-large-up"}}," ",{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"panelImage.mobile.src"}],"alt":[{"t":2,"r":"panelImage.mobile.alt"}],"class":"hide-for-large-up"}}," ",{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"class":"panel-ribbon right","datamodel":[{"t":2,"r":"pannelRibbonText"}]}}],"n":50,"r":"pannelRibbonText"}]}," ",{"t":7,"e":"div","a":{"class":"panel-content"},"f":[{"t":7,"e":"div","a":{"class":"section-header v-normal-top"},"f":[{"t":3,"r":"panelTitle"}]}," ",{"t":7,"e":"div","a":{"class":"panel-text v-normal-top v-large-bottom"},"f":[{"t":3,"x":{"r":["RactiveHelpers","panelText"],"s":"_0.unescapeString(_1)"}}]}," ",{"t":7,"e":"div","a":{"class":"panel-prices"},"f":[{"t":7,"e":"span","a":{"class":"price"},"f":["$",{"t":2,"r":"panelPrice"}]}," ",{"t":7,"e":"span","a":{"class":"usual-price"},"f":["$",{"t":2,"r":"panelUsualPrice"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-subsciption"},"f":[{"t":2,"r":"panelSubscription"}]}," ",{"t":7,"e":"ux-anchor","a":{"onclick":["showModal:",{"t":2,"r":"subscriptionType"}],"class":["light round button v-normal-top v-normal-bottom button-",{"t":2,"r":"subscriptionType"}]},"f":[{"t":2,"r":"panelButtonText"}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"modalId":[{"t":2,"r":"subscriptionType"},"Modal"],"width":"700","class":"light-theme no-top-padding"},"f":[{"t":4,"f":[{"t":7,"e":"ux-load-mask"}],"n":50,"r":"loading"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":2,"r":"mobileNumberFormTitle"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":3,"x":{"r":["RactiveHelpers","mobileNumberFormText"],"s":"_0.unescapeString(_1)"}}]}," ",{"t":7,"e":"div","a":{"class":"input-field v-large-bottom"},"f":[{"t":7,"e":"ux-input-box","a":{"type":"tel","placeholder":"e.g. 91234567","label_value":"Mobile Number","name":"mobileNumber","value":[{"t":2,"r":"mobileNumber"}],"maxLength":"8","onFocusEvent":"scrollTop","id":"mobileNumber"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"mobileNumberErrorMsg"}]}}],"n":50,"r":"mobileNumberErrorMsg"}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"genericErrorMessage"}]}}],"n":50,"r":"genericErrorMessage"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"fixed-footer"},"f":[{"t":7,"e":"div","a":{"class":"action-buttons clearfix"},"f":[{"t":7,"e":"button","a":{"type":"button","class":["ux-button button round right send-otp",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["mobileNumberFormStatus"],"s":"!_0"}}]},"v":{"click":"needOnepassCheck"},"f":["Send OTP"]}]}]}],"n":50,"x":{"r":["mobileNumberForm"],"s":"_0===1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":2,"r":"validateOtpFormTitle"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":3,"x":{"r":["RactiveHelpers","validateOtpFormText"],"s":"_0.unescapeString(_1)"}}]}," ",{"t":7,"e":"ux-input-box","a":{"class":"oneTimePin","placeholder":"Enter 6-digit OTP","label_value":"One-Time Password (OTP)","name":"inviteOtp","value":[{"t":2,"r":"oneTimePin"}],"minLength":"6","maxLength":"6","pattern":"[0-9]*","inputmode":"numeric","type":"tel","autocomplete":"off","onFocusEvent":"scrollTop","id":"oneTimePin"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"oneTimePinErrorMessage"}]}}],"n":50,"r":"oneTimePinErrorMessage"}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"genericErrorMessage"}]}}],"n":50,"r":"genericErrorMessage"}," ",{"t":7,"e":"p","a":{"class":"v-normal-top v-large-bottom"},"f":["No OTP? ",{"t":7,"e":"ux-anchor","a":{"onclick":"needOnepassCheck"},"f":["Resend"]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"fixed-footer"},"f":[{"t":7,"e":"div","a":{"class":"action-buttons clearfix"},"f":[{"t":7,"e":"ux-row","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"left","onclick":"goBack"},"f":["< Back"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"button","a":{"type":"button","class":["ux-button button round right validate-otp",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["validateOtpFormStatus"],"s":"!_0"}}]},"v":{"click":"submitOneTimePin"},"f":["Proceed"]}]}]}]}]}],"n":50,"x":{"r":["validateOtpForm"],"s":"_0===1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":2,"r":"onepassFormTitle"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":3,"x":{"r":["RactiveHelpers","onepassFormText"],"s":"_0.unescapeString(_1)"}}]}]}," ",{"t":7,"e":"ux-singtel-login"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-large-bottom v-large-top"},"f":[{"t":7,"e":"p","f":["Don't have a OnePass account? Request for a callback from our sales representative ",{"t":7,"e":"ux-anchor","a":{"onclick":"showRequestCallbackForm"},"f":["here"]}," or visit our ",{"t":7,"e":"a","a":{"href":[{"t":2,"r":"storeLocatorUrl"}],"target":"_blank"},"f":["stores"]}," today."]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"fixed-footer"},"f":[{"t":7,"e":"div","a":{"class":"action-buttons clearfix"},"f":[{"t":7,"e":"ux-row","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"left","onclick":"goBack"},"f":["< Back"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"button","a":{"type":"button","class":["ux-button button round right validate-otp",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["onepassFormStatus"],"s":"!_0"}}]},"v":{"click":"submitOnepass"},"f":["Submit"]}]}]}]}]}],"n":50,"x":{"r":["onepassForm"],"s":"_0===1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":2,"r":"requestCallbackFormTitle"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":7,"e":"p","f":["Please provide us with your contact details below and our sales representative will contact you within the next business day. Alternatively, you can sign up via ",{"t":7,"e":"a","a":{"href":"https://myaccount.singtel.com","target":"_blank"},"f":["My Account"]},"."]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"input-field v-normal-bottom"},"f":[{"t":7,"e":"ux-input-box","a":{"placeholder":"e.g. John Doe","label_value":"Name","name":"callbackName","value":[{"t":2,"r":"callbackName"}],"onFocusEvent":"scrollTop","id":"callbackName"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"callbackNameErrorMsg"}]}}],"n":50,"r":"callbackNameErrorMsg"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"input-field v-normal-bottom"},"f":[{"t":7,"e":"ux-input-box","a":{"placeholder":"e.g. 91234567","label_value":"Mobile number","name":"callbackMobileNumber","value":[{"t":2,"r":"callbackMobileNumber"}],"maxLength":"8","onFocusEvent":"scrollTop","id":"callbackMobileNumber"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"callbackMobileNumberErrorMsg"}]}}],"n":50,"r":"callbackMobileNumberErrorMsg"}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"genericErrorMessage"}]}}],"n":50,"r":"genericErrorMessage"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-large-bottom"},"f":[{"t":3,"x":{"r":["RactiveHelpers","requestCallbackFormConsent"],"s":"_0.unescapeString(_1)"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"fixed-footer"},"f":[{"t":7,"e":"div","a":{"class":"action-buttons clearfix"},"f":[{"t":7,"e":"ux-row","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"left","onclick":"goBack"},"f":["< Back"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"button","a":{"type":"button","class":["ux-button button round right request-callback",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["requestCallbackFormStatus"],"s":"!_0"}}]},"v":{"click":"submitCallback"},"f":["Submit"]}]}]}]}]}],"n":50,"x":{"r":["requestCallbackForm"],"s":"_0===1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":2,"r":"listAccountFormTitle"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-12 v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":["Please select the service you would like to bill your ",{"t":2,"r":"selectedProduct"}," subsciption to. Only services without an existing subscription will be shown below."]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["v-medium-bottom service",{"t":4,"f":[" selected"],"n":50,"x":{"r":["selectedAccountIdentifier","identifier"],"s":"_0===_1"}}]},"v":{"click":{"n":"setAccountToBill","d":[{"t":2,"r":"identifier"},",",{"t":2,"r":"accountName"},",",{"t":2,"r":"identifierType"}]}},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"service-name"},"f":[{"t":2,"r":"accountName"}]}," ",{"t":7,"e":"p","a":{"class":"service-account"},"f":[{"t":2,"r":"maskedAccount"}]}]}],"r":"services"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"fixed-footer"},"f":[{"t":7,"e":"div","a":{"class":"action-buttons clearfix"},"f":[{"t":7,"e":"ux-row","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"left","onclick":"goBack"},"f":["< Back"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"button","a":{"type":"button","class":["ux-button button round right list-accounts",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["selectedAccountIdentifier"],"s":"!_0"}}]},"v":{"click":"showEmailForm"},"f":["Next"]}]}]}]}]}],"n":50,"x":{"r":["listAccountForm"],"s":"_0===1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":2,"r":"emailFormTitle"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"input-field v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":["Please enter your preferred email address to receive a copy of the ",{"t":2,"r":"selectedProduct"}," product key and activation key."]}," ",{"t":7,"e":"ux-input-box","a":{"placeholder":"e.g. johnsmith@singnet.com","label_value":"Email Address","name":"emailAddress","value":[{"t":2,"r":"emailAddress"}],"onFocusEvent":"scrollTop","id":"emailAddress"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"emailAddressErrorMsg"}]}}],"n":50,"r":"emailAddressErrorMsg"}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"genericErrorMessage"}]}}],"n":50,"r":"genericErrorMessage"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"fixed-footer"},"f":[{"t":7,"e":"div","a":{"class":"action-buttons clearfix"},"f":[{"t":7,"e":"ux-row","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"left","onclick":"goBack"},"f":["< Back"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"button","a":{"type":"button","class":["ux-button button round right list-accounts",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["emailFormStatus"],"s":"!_0"}}]},"v":{"click":"showOrderSummary"},"f":["Order summary"]}]}]}]}]}],"n":50,"x":{"r":["emailForm"],"s":"_0===1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":2,"r":"orderSummaryTitle"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"ux-row","a":{"class":"order v-large-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":3,"x":{"r":["RactiveHelpers","orderSummaryText"],"s":"_0.unescapeString(_1)"}}]}]}," ",{"t":7,"e":"div","a":{"class":"order-item"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 small-6"},"f":[{"t":7,"e":"strong","f":["Description"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-8 small-6 text-right"},"f":[{"t":2,"r":"selectedProduct"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"div","a":{"class":"order-item"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 small-6"},"f":[{"t":7,"e":"strong","f":["Contract Term"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-8 small-6 text-right"},"f":["12-month"]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"div","a":{"class":"order-item"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 small-6"},"f":[{"t":7,"e":"strong","f":["Start Date"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-8 small-6 text-right"},"f":[{"t":2,"r":"currentDate"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"div","a":{"class":"order-item"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 small-6"},"f":[{"t":7,"e":"strong","f":["Email Address"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-8 small-6 text-right"},"f":[{"t":2,"r":"emailAddress"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"div","a":{"class":"order-item"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 small-6"},"f":[{"t":7,"e":"strong","f":["Bill To"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-8 small-6 text-right"},"f":[{"t":2,"r":"selectedAccountName"}," (",{"t":2,"r":"maskedAccount"},")"]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"div","a":{"class":"order-item"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 small-6"},"f":[{"t":7,"e":"strong","f":["Total Cost (Monthly)"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-8 small-6 text-right"},"f":[{"t":7,"e":"span","a":{"class":"order-item__cost"},"f":["$",{"t":2,"r":"totalCost"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"tnc v-large-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-12 tnc"},"f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":["Terms and Conditions:"]}," ",{"t":7,"e":"ul","f":[{"t":7,"e":"li","f":[{"t":7,"e":"small","f":["A 12 month instalment applies. Any remaining unpaid instalments shall be payable."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"small","f":["Customer will receive an activation SMS/email (please allow up to 1 working day) with the product key to activate the license at office.com"]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"small","f":["Customer has a period of 3 months to download and activate Office."]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"small","f":["Singtel is collecting customer information for the purpose of arranging the $10 coffee card collection."]}]}]}," ",{"t":7,"e":"p","f":["By submitting, you are agreeing to the full ",{"t":7,"e":"a","a":{"href":"/content/dam/singtel/office365/office365terms.pdf","target":"_blank"},"f":["terms and conditions"]}," and consent to ",{"t":7,"e":"a","a":{"href":"https://www.singtel.com/personal/i/dataprotection","target":"_blank"},"f":["Singtel’s Data Protection Policy"]},"."]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"fixed-footer"},"f":[{"t":7,"e":"div","a":{"class":"action-buttons clearfix"},"f":[{"t":7,"e":"ux-row","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"left","onclick":"goBack"},"f":["< Back"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"button","a":{"type":"button","class":["ux-button button round right confirm-order",{"t":4,"f":[" disabled"],"n":50,"x":{"r":["confirmOrderStatus"],"s":"!_0"}}]},"v":{"click":"confirmOrder"},"f":["Confirm"]}]}]}]}]}],"n":50,"x":{"r":["orderSummary"],"s":"_0===1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-tick","class":"icon-successful"}}," Thank you"]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":7,"e":"p","f":["You have subscribed to ",{"t":2,"r":"selectedProduct"}," (",{"t":7,"e":"strong","f":["12-month contract"]},") for $",{"t":2,"r":"totalCost"}," per month and this will be charged to your ",{"t":2,"r":"selectedAccountName"}," (",{"t":7,"e":"strong","f":[{"t":2,"r":"maskedAccount"}]},")."]}," ",{"t":7,"e":"ux-header","a":{"level":"6","class":"modal-title"},"f":["Next Steps"]}," ",{"t":7,"e":"ul","f":[{"t":7,"e":"li","f":["You will receive a confirmation SMS (",{"t":7,"e":"strong","f":[{"t":2,"r":"mobileNumber"}]},") in the next 10 minutes."]}," ",{"t":7,"e":"li","f":["You will also receive the product key & activation link via SMS (",{"t":7,"e":"strong","f":[{"t":2,"r":"mobileNumber"}]},") and email (",{"t":7,"e":"strong","f":[{"t":2,"r":"emailAddress"}]},") within the next business day."]}]}]}]}]}]}],"n":50,"x":{"r":["showThankyou"],"s":"_0===\"broadband\"||_0===\"onepass\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["showThankyou"],"s":"_0===\"postpaid\""},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-tick","class":"icon-successful"}}," Thank you"]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":7,"e":"p","f":["You have subscribed to ",{"t":2,"r":"selectedProduct"}," (",{"t":7,"e":"strong","f":["12-month contract"]},") for $",{"t":2,"r":"totalCost"}," per month and this will be charged to your ",{"t":2,"r":"selectedAccountName"}," bill (",{"t":7,"e":"strong","f":[{"t":2,"r":"maskedAccount"}]},")."]}," ",{"t":7,"e":"ux-header","a":{"level":"6","class":"modal-title"},"f":["Next Steps"]}," ",{"t":7,"e":"ul","f":[{"t":7,"e":"li","f":["You will receive a confirmation SMS (",{"t":7,"e":"strong","f":[{"t":2,"r":"mobileNumber"}]},") in the next 10 minutes."]}," ",{"t":7,"e":"li","f":["You will also receive the product key & activation link via SMS (",{"t":7,"e":"strong","f":[{"t":2,"r":"mobileNumber"}]},") and email (",{"t":7,"e":"strong","f":[{"t":2,"r":"emailAddress"}]},") within the next business day."]}]}]}]}]}]}]},{"t":4,"n":50,"x":{"r":["showThankyou"],"s":"(!(_0===\"postpaid\"))&&(_0===\"callback\")"},"f":[" ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-tick","class":"icon-successful"}}," Thank you"]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":7,"e":"p","f":["Your request for callback on ",{"t":2,"r":"selectedProduct"}," subscription has been received."]}," ",{"t":7,"e":"p","f":["Our sales representative will contact you within the next business day."]}]}]}]}]}]}],"x":{"r":["showThankyou"],"s":"_0===\"broadband\"||_0===\"onepass\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title"},"f":[{"t":7,"e":"ux-icon","a":{"type":"cross","class":"icon-error"}}," Your request is unsuccessful."]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":7,"e":"p","f":["Sorry, we are unable to process your request at this time. ",{"t":7,"e":"br"},"Please try again later."]}]}]}]}],"n":50,"x":{"r":["showError"],"s":"_0===\"noCallback\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["showError"],"s":"_0===\"hasCallback\""},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":7,"e":"ux-icon","a":{"type":"cross","class":"icon-error"}}," Sorry, we are unable to process your subscription."]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":["Please ",{"t":7,"e":"ux-anchor","a":{"onclick":"showRequestCallbackForm"},"f":["request for a callback"]}," from our Customer Care Officers or call us at 1688 directly, for assistance."]}]}]}]}]},{"t":4,"n":50,"x":{"r":["showError"],"s":"(!(_0===\"hasCallback\"))&&(_0===\"ineligible\")"},"f":[" ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":7,"e":"ux-icon","a":{"type":"cross","class":"icon-error"}}," Sorry, we are unable to process your subscription."]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":["Please ",{"t":7,"e":"ux-anchor","a":{"onclick":"showRequestCallbackForm"},"f":["request for a callback"]}," from our Customer Care Officers or call us at 1688 directly, for assistance."]}]}]}]}]},{"t":4,"n":50,"x":{"r":["showError"],"s":"(!(_0===\"hasCallback\"))&&((!(_0===\"ineligible\"))&&(_0===\"subscribed\"))"},"f":[" ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header"},"f":[{"t":7,"e":"ux-icon","a":{"type":"cross","class":"icon-error"}}," Sorry, we are unable to process your subscription."]}]}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":["Hello, you are already subscribed to Office 365. Please ",{"t":7,"e":"ux-anchor","a":{"onclick":"showRequestCallbackForm"},"f":["request for a callback"]}," from our Customer Care Officers or call us at 1688 directly, for assistance."]}]}]}]}]}],"x":{"r":["showError"],"s":"_0===\"noCallback\""}}]}]}]};
this["ux-msta-existing-addon"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-msta-existing-addon pointer"},"v":{"tap":{"n":"showUnsubscribeAddonDetails","d":[{"t":2,"r":"."}]}},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":7,"e":"ux-crop-text","a":{"text":[{"t":2,"r":"productTitle"}],"mobileChars":[{"t":2,"r":"cropTextConfig.mobileChars"}],"stopResize":"true","elipses":"..."}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":3,"r":"productDescription"}]}],"n":50,"r":"productDescription"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-normal-top"},"f":["Duration ",{"t":2,"x":{"r":["moment","reactivationDetails.serviceStartDate"],"s":"_0(_1,\"DD-MMM-YYYY HH:mm:ss\").format(\"DD/MM/YYYY\")"}}," - ",{"t":2,"x":{"r":["moment","reactivationDetails.serviceEndDate"],"s":"_0(_1,\"DD-MMM-YYYY HH:mm:ss\").format(\"DD/MM/YYYY\")"}}]}],"n":50,"x":{"r":["reactivationDetails.serviceStartDate","reactivationDetails.serviceEndDate"],"s":"_0&&_1"}}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"resendActivationLink","class":"button round light action-button wifiMesh-button margin-zero"},"f":[{"t":4,"f":[{"t":2,"r":"initData.resendActivationButtonText"}],"n":50,"r":"initData.resendActivationButtonText"},{"t":4,"n":51,"f":["Resend Activation Link"],"r":"initData.resendActivationButtonText"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"resendActivationLink","class":"button round light wifiMesh-button fullwidth margin-zero"},"f":[{"t":4,"f":[{"t":2,"r":"initData.resendActivationButtonText"}],"n":50,"r":"initData.resendActivationButtonText"},{"t":4,"n":51,"f":["Resend Activation Link"],"r":"initData.resendActivationButtonText"}]}]}]}],"n":50,"r":"reactivationDetails"}]}," ",{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-right","outerClass":"v-small-top"}}]}]}]}]}],"n":53,"r":"addon"}]};
this["ux-msta-new-addon"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-msta-new-addon","id":["AllAddOn_",{"t":2,"x":{"r":["groupName","catlogId"],"s":"_0?_0:_1"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom"},"f":[{"t":2,"r":"productTitle"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"body-light text-left"},"f":[{"t":2,"r":"contract"}," ",{"t":2,"r":"addonLabels.contractDuration"}]}],"n":50,"x":{"r":["contract"],"s":"_0>0"}}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"promo-text"},"f":[{"t":2,"r":"promotionText"}]}],"n":50,"r":"promotionText"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium"},"f":[{"t":2,"r":"productDescription"}]}],"n":50,"r":"productDescription"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium addon-group-header background-grey"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"flex-container subsection-header"},"f":[{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":2,"r":"addonLabels.selectPreferenceLabel"}]}," ",{"t":7,"e":"div","a":{"class":"flex-item"},"f":["Cost S$"]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"flex-container","id":["AllAddOn_",{"t":2,"r":"catlogId"}]},"f":[{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":7,"e":"ux-crop-text","a":{"text":[{"t":2,"r":"productTitle"}],"stopResize":"true"}}]}]}," ",{"t":7,"e":"div","a":{"class":"flex-item flex-item-auto-align"},"f":[{"t":4,"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"price"}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-right","ontap":"showAddonDetails","addon":[{"t":2,"r":"."}]}}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider v-medium"}}],"n":50,"x":{"r":["i","subGroups.length"],"s":"_0<_1-1"}}],"n":52,"i":"i","r":"subGroups"}]}]}],"n":50,"r":"subGroups"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-7"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom"},"f":[{"t":2,"r":"productTitle"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"body-light text-left"},"f":[{"t":2,"r":"contract"}," ",{"t":2,"r":"addonLabels.contractDuration"}]}],"n":50,"x":{"r":["contract"],"s":"_0>0"}}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"promo-text"},"f":[{"t":2,"r":"promotionText"}]}],"n":50,"r":"promotionText"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium"},"f":[{"t":2,"r":"productDescription"}]}],"n":50,"r":"productDescription"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 flex-container flex-container-column"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"flex-item"},"f":["From ",{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"n":50,"r":"price"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"subsection-header flex-item"},"f":["FREE"]}],"r":"price"}," ",{"t":7,"e":"div","a":{"class":"action-area v-medium flex-item"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":[{"t":4,"f":["showAddonDetails"],"n":50,"x":{"r":["isAddButtonDisabled"],"s":"!_0"}}],"href":"#/addon/details","addon":[{"t":2,"r":"addon"}],"class":["button round p-none-right p-none-left",{"t":4,"f":[" disabled"],"n":50,"r":"isAddButtonDisabled"},{"t":4,"n":51,"f":[" light"],"r":"isAddButtonDisabled"}]},"f":["View"]}]}]}]}],"r":"subGroups"}]}],"n":53,"r":"addon"}]};
this["ux-multi-select"] = {"v":3,"t":[{"t":7,"e":"div","a":{"id":[{"t":2,"r":"parentGuid"}],"class":"ux-multi-select"},"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"r":"customClass"}," ",{"t":2,"r":"validity.status"}," ",{"t":2,"r":"valid"}," ",{"t":4,"f":["disabled"],"r":"disabled"}]},"f":[{"t":4,"f":[{"t":7,"e":"label","a":{"class":"select-label","for":[{"t":2,"r":"id"}]},"f":[{"t":2,"r":"label_value"},{"t":4,"f":[{"t":7,"e":"span","a":{"class":"mandatory"},"f":["*"]}],"n":50,"r":"mandatory"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"icon-btn"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":2,"r":"tooltipText"}]}],"n":50,"r":"showToolTip"}]}],"n":50,"r":"label_value"}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"open"},"f":[{"t":7,"e":"span","a":{"id":[{"t":2,"r":"parentGuid"}],"class":["select",{"t":4,"f":[" opened"],"n":50,"r":"open"}]},"v":{"tap":"togglePanel"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"icon icon-arrow-up"}}],"n":50,"r":"open"},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"icon icon-arrow-down"}}],"r":"open"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"select-value"},"f":[{"t":2,"r":"selectedTitle"}]}],"n":50,"r":"showSelectedValue"}]}]}," ",{"t":7,"e":"div","a":{"id":[{"t":2,"r":"parentGuid"}],"class":["multi-options ",{"t":4,"f":["hide"],"n":50,"x":{"r":["open"],"s":"!_0"}},{"t":4,"n":51,"f":["show"],"x":{"r":["open"],"s":"!_0"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-checkbox","a":{"class":"","onChangeEvent":"onValueSelect","checkboxid":[{"t":2,"r":"guid"},"-",{"t":2,"x":{"r":["i"],"s":"_0+1"}}],"labelvalue":[{"t":2,"r":"text"}],"checked":[{"t":2,"r":"selected"}]},"f":[]}]}],"i":"i","r":"options"}]}],"n":50,"r":"isDisplay"}]}," ",{"t":7,"e":"div","a":{"class":"validity-wrapper"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":"validity-msg strong"},"f":[{"t":7,"e":"ux-icon","a":{"class":"icon","type":[{"t":2,"r":"icon_name"}]}},{"t":2,"r":"validity_message"}]}],"n":50,"r":"validity_message"}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity"}],"r":"validity"}],"n":50,"x":{"r":["validity","validity_message"],"s":"_0||_1"}}]}]}]}]};
this["ux-need-help-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-need-help-banner"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"container v-large-top"},"f":[{"t":7,"e":"ux-row","a":{"class":""},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"body-text text-center v-large-bottom"},"f":[{"t":3,"r":"separatorText"}]}]}]}]}],"n":50,"r":"separatorText"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-large need-help-header"},"f":[{"t":2,"r":"sectionTitle"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 large-6"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-12 large-3 left-image"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"leftImg.src"}],"alt":[{"t":2,"r":"leftImg.alt"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12 large-9 faq-question"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"faq-links","href":[{"t":2,"r":".link"}]},"f":[{"t":2,"r":".text"}]},{"t":7,"e":"br"}]}],"r":"faqQuestion"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 large-6"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-12 large-3 right-image"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"rightImg.src"}],"alt":[{"t":2,"r":"rightImg.alt"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12 large-9"},"f":[{"t":7,"e":"ux-header","a":{"class":"body-text header1"},"f":[{"t":2,"r":"header1"}]}," ",{"t":7,"e":"div","a":{"class":"body-light text1"},"f":[{"t":3,"r":"text1"}]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"ux-header","a":{"class":"body-text header2"},"f":[{"t":2,"r":"header2"}]}," ",{"t":7,"e":"div","a":{"class":"body-light text2"},"f":[{"t":3,"r":"text2"}]}]}]}]}]}]}]};
this["ux-news-bulletin"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-news-bulletin"},"f":[{"t":7,"e":"div","a":{"class":["show-for-small-only banner-background ",{"t":2,"r":"theme"}," ",{"t":2,"r":"backgroundImgMobilePosition"}," ",{"t":2,"r":"backgroundImgMobileSize"}," ",{"t":2,"r":"mobileImgHeight"}],"style":["padding: 0 5px 0 5px; background-image: url('",{"t":2,"r":"backgroundImgMobile"},"');",{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":["banner-image ",{"t":2,"r":"mobileImgHeight"}]},"f":[{"t":7,"e":"div","a":{"class":["image ",{"t":2,"r":"foregroundImgMobilePosition"}," ",{"t":2,"r":"foregroundImgMobileSize"}]},"m":[{"t":4,"f":["style=\"background-image: url('",{"t":2,"r":"foregroundImg.mobile.src"},"')\""],"n":50,"r":"foregroundImg.mobile.src"}],"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":4,"f":[{"t":7,"e":"ux-image","a":{"class":"logo-image","img":[{"t":2,"r":"logoImage"}]}}],"n":50,"r":"logoImage"}," ",{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"1","class":["hero-text v-normal-bottom ",{"t":2,"r":"theme"}]},"f":[{"t":2,"r":"bulletinTitle"}]}],"n":50,"r":"bulletinTitle"}," ",{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"6","class":["v-normal-bottom ",{"t":2,"r":"theme"}]},"f":[{"t":3,"r":"bulletinTimeCaption"}]}],"n":50,"r":"bulletinTimeCaption"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-copy v-normal-bottom scrollable"},"f":[{"t":3,"r":"paragraph"}]}],"n":50,"r":"paragraph"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"banner-link v-normal-top","ontap":"showAllBulletinNews"},"f":[{"t":2,"r":"ctaLabel"}]}],"n":50,"r":"ctaLabel"}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":["show-for-medium-up banner-background ",{"t":2,"r":"theme"}," ",{"t":2,"r":"backgroundImgDesktopPosition"}," ",{"t":2,"r":"backgroundImgDesktopSize"}],"style":["background-image: url('",{"t":2,"r":"backgroundImgDesktop"},"');",{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":["medium-6 large-6 medium-offset-1 ",{"t":2,"r":"alignment"}]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":4,"f":[{"t":7,"e":"ux-image","a":{"class":"logo-image","img":[{"t":2,"r":"logoImage"}]}}],"n":50,"r":"logoImage"}," ",{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"1","class":["hero-text v-normal-bottom ",{"t":2,"r":"theme"}]},"f":[{"t":2,"r":"bulletinTitle"}]}],"n":50,"r":"bulletinTitle"}," ",{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"6","class":["v-normal-bottom ",{"t":2,"r":"theme"}]},"f":[{"t":3,"r":"bulletinTimeCaption"}]}],"n":50,"r":"bulletinTimeCaption"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-copy v-normal-bottom scrollable"},"f":[{"t":3,"r":"paragraph"}]}],"n":50,"r":"paragraph"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"banner-link v-normal-top","ontap":"showAllBulletinNews"},"f":[{"t":2,"r":"ctaLabel"}]}],"n":50,"r":"ctaLabel"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 medium-5 ",{"t":2,"r":"alignment"}]},"f":[{"t":7,"e":"div","a":{"class":"banner-image"},"f":[{"t":7,"e":"div","a":{"class":["image ",{"t":2,"r":"foregroundImgDesktopPosition"}," ",{"t":2,"r":"foregroundImgDesktopSize"}],"style":["background-image: url('",{"t":2,"r":"foregroundImg.desktop.src"},"')"]},"f":[]}]}]}],"n":50,"r":"foregroundImg.desktop.src"}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"800","class":"light-theme","modalId":"showAllNews"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"modal-padding"},"f":[{"t":7,"e":"ux-header","a":{"level":"1","class":"section-header"},"f":["All News Bulletin"]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"6","class":"v-small-bottom"},"f":[{"t":3,"r":"timeCaption"}]}],"n":50,"r":"timeCaption"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-copy","style":"margin-bottom: 0;"},"f":[{"t":3,"r":"newsText"}]}],"n":50,"r":"newsText"}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"linkURL"}],"class":"v-normal-top"},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"linkText"}]}]}],"n":52,"r":"newsItemList"}]}]}]}]}]};
this["ux-news-releases-details"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-news-releases-details"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header"},"f":[{"t":2,"r":"dateLabel"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":2,"r":"newsDate"}]}," ",{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header"},"f":[{"t":2,"r":"categoryLabel"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":2,"r":"newsCategory"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"newsArticlePath"}]},"f":[{"t":2,"r":"downloadLinkLabel"}]}],"n":50,"r":"newsArticlePath"}]}]}]}]};
this["ux-newsroom-feeds"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-newsroom-feeds"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-7 p-normal-left v-medium-top"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"iconClass"}]}}]},{"t":7,"e":"span","a":{"class":"v-medium-left subsection-header post-header"},"f":[{"t":2,"r":"title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 text-right  p-normal-right v-medium-top"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"text-link v-medium-top p-normal-right","href":[{"t":4,"f":[{"t":2,"r":"facebookUrl"}],"n":50,"r":"facebookUrl"}],"target":"_"},"f":[{"t":2,"r":"viewAllText"}]}]}]}," ",{"t":7,"e":"hr"}," ",{"t":7,"e":"ux-row","a":{"class":"feedsContainer"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"5"},"f":[{"t":7,"e":"div","a":{"class":"fb-profile-img"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"fbprofileImgurl"}]}}]}," ",{"t":7,"e":"div","a":{"class":"postData"},"f":[{"t":2,"r":"message"}]}]}]}]}],"x":{"r":["i","feedscount"],"s":"_0<_1"}}],"i":"i","r":"pagePostsData"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"p-normal-right"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"right text-link","href":[{"t":4,"f":[{"t":2,"r":"facebookUrl"}],"n":50,"r":"facebookUrl"}],"target":"_"},"f":[{"t":7,"e":"div","a":{"class":"follow"},"f":[{"t":2,"r":"followUsSiteText"}]}]}]}]}]}],"n":50,"r":"followFacebook"},{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-newsroom-feeds"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-7  p-normal-left v-medium-top"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"iconClass"}]}}]},{"t":7,"e":"span","a":{"class":"v-medium-left subsection-header post-header"},"f":[{"t":2,"r":"title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 text-right  p-normal-right v-medium-top"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"text-link","href":[{"t":4,"f":[{"t":2,"r":"twitterUrl"}],"n":50,"r":"twitterUrl"}],"target":"_"},"f":[{"t":2,"r":"viewAllText"}]}]}]}," ",{"t":7,"e":"hr"}," ",{"t":7,"e":"ux-row","a":{"class":"feedsContainer"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"div","a":{"id":"container","style":"display:none","class":"twitter-wrapper"}}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"p-normal-right"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"right text-link","href":[{"t":4,"f":[{"t":2,"r":"twitterUrl"}],"n":50,"r":"twitterUrl"}],"target":"_"},"f":[{"t":7,"e":"div","a":{"class":"follow"},"f":[{"t":2,"r":"followUsSiteText"}]}]}]}]}]}],"n":50,"r":"followTwitter"}]};
this["ux-newsroom"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-newsroom"},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","a":{"class":"header-section"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","a":{"class":"filter-header"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-normal-bottom v-medium-top"},"f":[{"t":2,"r":"headingTitle"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 v-small-bottom"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"categoryLabel"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3 left"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"yearLabel"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 v-normal-bottom"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-viewby-category","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"filterCategory"}],"options":[{"t":2,"r":"filterBy"}]},"v":{"change":"filterByCategory"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3 v-normal-bottom"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-viewby","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"yearFilter"}],"options":[{"t":2,"r":"filterByYears"}]},"v":{"change":"filterByYear"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"left medium-3"},"f":[{"t":7,"e":"div","a":{"class":"section-description text-center"},"f":[{"t":2,"r":"newsListCount"}," articles in All categories"]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-bottom newsItemsList"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"news-item"},"f":[{"t":7,"e":"hr"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 large-3"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"newsThumbnail"}],"class":"news-image v-medium-bottom"}}]}],"n":50,"x":{"r":["newsThumbnail"],"s":"_0&&_0!==\"\""}}," ",{"t":7,"e":"ux-col","a":{"class":["small-12 ",{"t":4,"f":["large-9"],"n":50,"x":{"r":["newsThumbnail"],"s":"_0&&_0!==\"\""}},{"t":4,"n":51,"f":["large-12"],"x":{"r":["newsThumbnail"],"s":"_0&&_0!==\"\""}}]},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"newsPagePath"}],"class":"text-link"},"f":[{"t":7,"e":"div","a":{"class":"section-header v-normal-bottom v-medium-top"},"f":[{"t":2,"r":"newsHeadline"}]}]}," ",{"t":7,"e":"div","a":{"class":"v-medium-bottom subsection-header"},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"newsDate"}]}," ",{"t":7,"e":"span","f":[{"t":2,"r":"newsCategory"}]}]}," ",{"t":7,"e":"ux-crop-text","a":{"text":[{"t":2,"r":"newsSummary"}],"mobileChars":"210","tabletChars":"210","desktopChars":"210"}}," ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"newsPagePath"}],"class":"text-link"},"f":["Read more"]}]}]}]}],"n":50,"r":"display"}],"r":"filteredNewsList"}]}," ",{"t":7,"e":"div","a":{"id":"loader","class":"text-center v-large-bottom"}}," ",{"t":7,"e":"ux-row","a":{"class":"text-center"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"onclick":"showmore","text":[{"t":2,"r":"viewMoreLabel"}],"class":["light round v-normal-top expand-for-mobile ",{"t":4,"f":["disabled"],"n":50,"r":"isDisabled"}]}}]}]}]}]}]};
this["ux-nomination-circle-details"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-nomination-circle-details"},"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"p-large-top p-large-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"flex-container flex-container-start"},"f":[{"t":7,"e":"ux-col","a":{"class":"flex-item flex-item-top-align flex-basis-zero"},"f":[{"t":7,"e":"ux-icon","a":{"type":"keyline-nomination","size":"xl"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"flex-item flex-item-top-align p-none-left"},"f":[{"t":7,"e":"ux-row","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":"section-header left v-medium-top v-large-right p-medium-left v-medium-right-mobile"},"f":[{"t":2,"r":"widgetConfig.headings.singtelCircle"}," ",{"t":2,"x":{"r":["index"],"s":"_0+1"}}]}," ",{"t":7,"e":"div","a":{"class":"small-right v-medium-top edit-circle left"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"small-right left","onclick":"circleEdit"},"f":["Edit"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"small-12"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"ux-input-box"},"f":[{"t":7,"e":"label","f":[{"t":2,"r":"widgetConfig.headings.fibre"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top small-12"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"widgetConfig.headings.fibre"}," ",{"t":2,"rx":{"r":"implNominationServiceDetails","m":[{"t":30,"n":"idx"},"serviceId"]}}]}],"n":50,"x":{"r":["idx","implNominationServiceDetails"],"s":"_1[_0].lob===\"BB\"||_1[_0].lob===\"FBB\""}}],"n":52,"i":"idx","r":"implNominationServiceDetails"}]}]}],"n":50,"r":"isFiberPresent"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"ux-input-box"},"f":[{"t":7,"e":"label","f":[{"t":2,"r":"widgetConfig.headings.tv"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top small-12"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"widgetConfig.headings.tv"}," ",{"t":2,"rx":{"r":"implNominationServiceDetails","m":[{"t":30,"n":"idx"},"serviceId"]}}]}],"n":50,"x":{"r":["idx","implNominationServiceDetails"],"s":"_1[_0].lob===\"TV\""}}],"n":52,"i":"idx","r":"implNominationServiceDetails"}]}]}],"n":50,"r":"isTVPresent"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"ux-input-box"},"f":[{"t":7,"e":"label","f":[{"t":2,"r":"widgetConfig.headings.homeLine"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top small-12"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"widgetConfig.headings.homeLineInline"}," ",{"t":2,"rx":{"r":"implNominationServiceDetails","m":[{"t":30,"n":"idx"},"serviceId"]}}]}],"n":50,"x":{"r":["idx","implNominationServiceDetails"],"s":"_1[_0].lob===\"FV\""}}],"n":52,"i":"idx","r":"implNominationServiceDetails"}]}]}],"n":50,"r":"isHomeLinePresent"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"ux-input-box"},"f":[{"t":7,"e":"label","f":[{"t":2,"r":"widgetConfig.headings.mobile"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top small-12"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"widgetConfig.headings.mobile"}," ",{"t":2,"rx":{"r":"implNominationServiceDetails","m":[{"t":30,"n":"idx"},"serviceId"]}}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"widgetConfig.headings.keyNominationForMobileInLine"}]}],"n":50,"x":{"r":["idx","implNominationServiceDetails","keyline"],"s":"(_1[_0].lob===\"WS\"||_1[_0].lob===\"MOB\")&&_2"}}],"n":52,"i":"idx","r":"implNominationServiceDetails"}]}]}],"n":50,"r":"isWSKeyLinePresent"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"ux-input-box"},"f":[{"t":7,"e":"label","f":[{"t":2,"r":"widgetConfig.headings.addMobileLines"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":2,"r":"widgetConfig.headings.mobile"}," ",{"t":2,"rx":{"r":"implNominationServiceDetails","m":[{"t":30,"n":"idx"},"serviceId"]}}]}],"n":50,"x":{"r":["idx","implNominationServiceDetails"],"s":"(_1[_0].lob==\"WS\"||_1[_0].lob==\"MOB\")&&!_1[_0].keyline"}}],"n":52,"i":"idx","r":"implNominationServiceDetails"}]}]}],"n":50,"r":"isWSPresent"}]}]}]}]}],"r":"circleGroup"}]}]};
this["ux-notification-table"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-notification-table ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-header","a":{"class":"left subsection-header"},"f":[{"t":2,"r":"headerText"}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"right text-link","href":[{"t":2,"r":"viewAllTextUrl"}]},"f":[{"t":2,"r":"viewAllText"}," (",{"t":2,"r":"notificationModel.totLength"},")"]}]}," ",{"t":7,"e":"hr"}," ",{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"date-column"},"f":[{"t":2,"x":{"r":["RactiveHelpers","notificationDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}," ",{"t":7,"e":"td","a":{"class":"text-link truncate-text"},"f":[{"t":7,"e":"span","o":{"n":"tooltip","d":[{"t":2,"r":"message"}]},"a":{"tabindex":"0"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"text-link","href":[{"t":2,"r":"viewAllTextUrl"}]},"f":[{"t":2,"r":"message"}]}]}]}," ",{"t":7,"e":"td","a":{"class":"type-column text-right"},"f":[{"t":2,"r":"service"}]}]}],"r":"notificationModel"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"hr","a":{"class":"extend-for-small"}}," ",{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-accordion","a":{"class":"specification-accordion","initData":[{"t":2,"r":"initData"}],"notificationModel":[{"t":2,"r":"notificationModel"}],"RactiveHelpers":[{"t":2,"r":"RactiveHelpers"}],"viewAllTextUrl":[{"t":2,"r":"viewAllTextUrl"}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-iteem"},"f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.headerText"}]}]}," ",{"t":7,"e":"div","a":{"class":"flex-iteem"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"date-column"},"f":[{"t":2,"x":{"r":["RactiveHelpers","notificationDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"text-link","href":[{"t":2,"r":"viewAllTextUrl"}]},"f":[{"t":7,"e":"div","a":{"class":"text-link v-normal-bottom truncate-text"},"f":[{"t":2,"r":"message"}]}]}],"r":"notificationModel"}," ",{"t":7,"e":"ux-anchor","a":{"class":"text-link","href":[{"t":2,"r":"initData.viewAllTextUrl"}]},"f":[{"t":2,"r":"initData.viewAllText"}," (",{"t":2,"r":"notificationModel.totLength"},")"]}]}]}]}]}," ",{"t":7,"e":"hr","a":{"class":"extend-for-small"}}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-onepay-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-onepay-singtel"},"f":[{"t":7,"e":"form","a":{"action":[{"t":2,"r":"initData.pgUrl"}],"method":"POST","id":"paymentGatewayForm"},"f":[{"t":7,"e":"input","a":{"type":"hidden","name":"merchantId","value":[{"t":2,"r":"initData.merchantId"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"successUrl","value":[{"t":2,"r":"initData.successUrl"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"failureUrl","value":[{"t":2,"r":"initData.failureUrl"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"cancelUrl","value":[{"t":2,"r":"initData.cancelUrl"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"salesChannel","value":[{"t":2,"r":"initData.salesChannel"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"custId","value":[{"t":2,"r":"pgData.custId"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"totalPrice","value":[{"t":2,"r":"pgData.totalPrice"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"referenceId","value":[{"t":2,"r":"pgData.referenceId"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"paymentMode","value":[{"t":2,"r":"pgData.paymentMode"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"merchantData","value":[{"t":2,"r":"pgData.merchantData"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"items","value":[{"t":3,"r":"pgData.items"}]}}]}]}]};
this["ux-order-consolidation"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-order-consolidation v-normal-top"},"f":[{"t":7,"e":"ux-row","a":{"class":"large-row column-control-mobile v-small-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","a":{"class":"panel30 margin-zero"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"initData.orderConsolidationTitle"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":3,"r":"initData.orderConsolidationDesc"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"r":"id"}],"type":"radio","name":"select-order-consol-option","value":[{"t":2,"r":"id"}]},"v":{"change":{"n":"selectOrderConsolidation","d":[{"t":2,"r":"id"}]}}}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"id"}]},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","f":[{"t":4,"f":[{"t":2,"r":"."}],"n":52,"r":"purchasedItems"}]}]}],"n":50,"r":"purchasedItems"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","f":[{"t":4,"f":["Delivery Address:"],"n":50,"x":{"r":["slotType"],"s":"_0===\"V\"||_0===\"M\"||_0===\"D\"||_0===\"N\""}},{"t":4,"n":51,"f":["Collection Address:"],"x":{"r":["slotType"],"s":"_0===\"V\"||_0===\"M\"||_0===\"D\"||_0===\"N\""}}," ",{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," ",{"t":2,"r":"streetName"},", ",{"t":4,"f":[{"t":2,"r":"unitNumber"},", "],"n":50,"r":"unitNumber"},{"t":4,"f":[{"t":2,"r":"buildingName"},", "],"n":50,"r":"buildingName"},"Singapore-",{"t":2,"r":"postcode"}],"n":53,"r":"deliveryAddress"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","f":[{"t":4,"f":["Delivery Date & Time: ",{"t":2,"r":"deliveryDate"},", ",{"t":2,"r":"deliveryTime"}],"n":50,"x":{"r":["slotType"],"s":"_0===\"V\"||_0===\"M\"||_0===\"D\"||_0===\"N\""}},{"t":4,"n":51,"f":["Collection Date: ",{"t":2,"r":"deliveryDate"}," ",{"t":4,"f":["Collection Time: ",{"t":2,"r":"deliveryTime"}],"n":50,"r":"deliveryTime"}],"x":{"r":["slotType"],"s":"_0===\"V\"||_0===\"M\"||_0===\"D\"||_0===\"N\""}}]}]}]}]}],"n":52,"i":"i","r":"dispatchAppointmentSlot.orderConsolidationResponse"}," ",{"t":7,"e":"ux-row","a":{"class":" medium-8 collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-5 v-medium-top"},"f":[{"t":7,"e":"ux-button","a":{"text":"Yes","class":["round light margin-zero small-only-expand ",{"t":4,"f":["disabled"],"n":51,"r":"processRecord"}],"onclick":"proceedToConsolidateOrder","arialabel":"Yes"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-7 v-medium-top"},"f":[{"t":7,"e":"ux-button","a":{"text":"No, Skip All","class":"round  light margin-zero small-only-expand","onclick":"skipConsolidateOrder"}}]}]}]}]}]}]}]}]}],"n":50,"r":"orderConsolidation"}]};
this["ux-order-summary-grid"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-order-summary-grid"},"f":[{"t":7,"e":"ux-row","a":{"class":"summary-header show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4 medium-offset-1"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":["Shopping cart Summary"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-2"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header text-right"},"f":["Addition to 1st Bill"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-2"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header text-right"},"f":["Pay Monthly"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-2 left"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header text-right"},"f":["Pay Now"]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider show-for-medium-up"}}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"summary-row"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-summarytitle-row","a":{"icon":"mobile-line","datamodel":[{"t":3,"r":"."}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"expand-panel-item"},"f":[{"t":4,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"i"}],"datamodel":[{"t":3,"r":"."}]}}],"i":"i","r":"."}]}]}],"r":"order.mobile"}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"r":"order.mobile"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"summary-row"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-summarytitle-row","a":{"icon":"broadband-line","datamodel":[{"t":3,"r":"."}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"expand-panel-item"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"i"}],"datamodel":[{"t":3,"r":"."}]}}],"i":"j","r":"serviceDetails"}],"n":50,"x":{"r":["i"],"s":"_0==\"serviceDetails\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"i"}],"datamodel":[{"t":3,"r":"."}]}}],"x":{"r":["i"],"s":"_0==\"serviceDetails\""}}],"i":"i","r":"."}]}]}],"r":"order.bundle"}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"r":"order.bundle"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"summary-row"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-summarytitle-row","a":{"icon":"tv-line","datamodel":[{"t":3,"r":"."}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"expand-panel-item"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"i"}],"datamodel":[{"t":3,"r":"."}]}}],"i":"j","r":"serviceDetails"}],"n":50,"x":{"r":["i"],"s":"_0==\"serviceDetails\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"i"}],"datamodel":[{"t":3,"r":"."}]}}],"x":{"r":["i"],"s":"_0==\"serviceDetails\""}}],"i":"i","r":"."}]}]}],"r":"order.tv"}],"n":50,"r":"order.tv"}]}]}]};
this["ux-order-summary-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-order-summary-singtel ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"div","a":{"class":"hide-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"summary-header"},"f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-8"],"n":50,"r":"isRedMembership"},{"t":4,"n":51,"f":["medium-4"],"r":"isRedMembership"}," medium-offset-1"]},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header"},"f":["Shopping Cart Summary"]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-2"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header text-center label-header"},"f":[{"t":4,"f":[{"t":2,"r":"rightitems.0.label"}],"n":50,"r":"rightitems.0.label"}]}," ",{"t":7,"e":"div","a":{"class":"icon-btn"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":4,"f":[{"t":2,"r":"rightitems.0.tooltip"}],"n":50,"r":"rightitems.0.tooltip"}]}]}],"n":50,"r":"isRedMembership"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-2"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header text-right label-header"},"f":[{"t":4,"f":[{"t":2,"r":"rightitems.0.label"}],"n":50,"r":"rightitems.0.label"},{"t":4,"n":51,"f":[{"t":2,"r":"ConfigStrings.orderSummary.labels.oneTimeCost"}],"r":"rightitems.0.label"}]}," ",{"t":7,"e":"div","a":{"class":"icon-btn"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":4,"f":[{"t":2,"r":"rightitems.0.tooltip"}],"n":50,"r":"rightitems.0.tooltip"},{"t":4,"n":51,"f":["These are one-time charge(s). The charge(s) will be reflected in your first month's bill."],"r":"rightitems.0.tooltip"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-2 medium-2 left"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header text-right label-header"},"f":[{"t":4,"f":[{"t":2,"r":"rightitems.2.label"}],"n":50,"r":"rightitems.2.label"},{"t":4,"n":51,"f":[{"t":2,"r":"ConfigStrings.orderSummary.labels.upfrontPayment"}],"r":"rightitems.2.label"}]}," ",{"t":7,"e":"div","a":{"class":"icon-btn"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":4,"f":[{"t":2,"r":"rightitems.2.tooltip"}],"n":50,"r":"rightitems.2.tooltip"},{"t":4,"n":51,"f":["This is one time upfront cost."],"r":"rightitems.2.tooltip"}]}]}],"r":"isRedMembership"}," ",{"t":7,"e":"ux-col","a":{"class":"medium-10 medium-offset-1"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-ordersummary-row","a":{"isRedMembership":[{"t":2,"r":"isRedMembership"}],"rightitems":[{"t":2,"r":"rightitems"}],"type":"preGST","datamodel":[{"t":3,"r":"order"}]}}," ",{"t":7,"e":"ux-ordersummary-row","a":{"isRedMembership":[{"t":2,"r":"isRedMembership"}],"rightitems":[{"t":2,"r":"rightitems"}],"type":"GST","datamodel":[{"t":3,"r":"order"}]}}," ",{"t":7,"e":"ux-ordersummary-row","a":{"isRedMembership":[{"t":2,"r":"isRedMembership"}],"rightitems":[{"t":2,"r":"rightitems"}],"type":"postGST","datamodel":[{"t":3,"r":"order"}]}}],"r":"order"}]}," ",{"t":7,"e":"div","a":{"class":["show-for-small-only ",{"t":4,"f":["panel"],"n":50,"r":"orderSummaryPanel"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"summary-header v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Shopping Cart Summary"]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-ordersummary-row","a":{"isRedMembership":[{"t":2,"r":"isRedMembership"}],"rightitems":[{"t":2,"r":"rightitems"}],"type":"preGST","datamodel":[{"t":3,"r":"order"}]}}," ",{"t":7,"e":"ux-ordersummary-row","a":{"isRedMembership":[{"t":2,"r":"isRedMembership"}],"rightitems":[{"t":2,"r":"rightitems"}],"type":"GST","datamodel":[{"t":3,"r":"order"}]}}," ",{"t":7,"e":"ux-ordersummary-row","a":{"isRedMembership":[{"t":2,"r":"isRedMembership"}],"rightitems":[{"t":2,"r":"rightitems"}],"type":"postGST","datamodel":[{"t":3,"r":"order"}]}}],"r":"order"}]}]}]};
this["ux-ordersummary-row"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-ordersummary-row"},"f":[{"t":7,"e":"ux-row","a":{"class":"small-collapse medium-uncollapse"},"f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-8"],"n":50,"r":"isRedMembership"},{"t":4,"n":51,"f":["medium-4"],"r":"isRedMembership"}," medium-offset-1 row-data"]},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["subsection-header"],"n":50,"x":{"r":["type"],"s":"_0==\"postGST\""}},{"t":4,"n":51,"f":["body-light"],"x":{"r":["type"],"s":"_0==\"postGST\""}}]},"f":[{"t":7,"e":"div","f":[{"t":3,"r":"rowData"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-2 recurring-price"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-8 left"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header left show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":4,"f":[{"t":2,"r":"ConfigStrings.redMemberShip.rightItems.0.label"}],"n":50,"r":"ConfigStrings.redMemberShip.rightItems.0.label"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"left help-icon"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":4,"f":[{"t":2,"r":"ConfigStrings.redMemberShip.rightItems.0.tooltip"}],"n":50,"r":"ConfigStrings.redMemberShip.rightItems.0.tooltip"}]}],"n":50,"x":{"r":["type"],"s":"_0==\"postGST\""}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 medium-12 text-right"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["section-header"],"n":50,"x":{"r":["type"],"s":"_0==\"postGST\""}},{"t":4,"n":51,"f":["body-light"],"x":{"r":["type"],"s":"_0==\"postGST\""}}," center"]},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"x":{"r":["oneTimePrice"],"s":"_0>0"}},{"t":4,"n":51,"f":["$0.00"],"x":{"r":["oneTimePrice"],"s":"_0>0"}}]}]}]}]}],"n":50,"r":"isRedMembership"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-2 one-time-price"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-8 left"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header left show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":4,"f":[{"t":2,"r":"rightitems.0.label"}],"n":50,"r":"rightitems.0.label"},{"t":4,"n":51,"f":[{"t":2,"r":"ConfigStrings.orderSummary.labels.oneTimeCost"}],"r":"rightitems.0.label"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"left help-icon"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":4,"f":[{"t":2,"r":"rightitems.0.tooltip"}],"n":50,"r":"rightitems.0.tooltip"},{"t":4,"n":51,"f":["These are one-time charge(s). The charge(s) will be reflected in your first month's bill."],"r":"rightitems.0.tooltip"}]}],"n":50,"x":{"r":["type"],"s":"_0==\"postGST\""}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 medium-12 text-right"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["section-header"],"n":50,"x":{"r":["type"],"s":"_0==\"postGST\""}},{"t":4,"n":51,"f":["body-light"],"x":{"r":["type"],"s":"_0==\"postGST\""}}," right"]},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"x":{"r":["oneTimePrice"],"s":"_0>0"}},{"t":4,"n":51,"f":["$0.00"],"x":{"r":["oneTimePrice"],"s":"_0>0"}}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-offset-2 medium-2 checkout-price"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-8 left"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header left show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":4,"f":[{"t":2,"r":"rightitems.2.label"}],"n":50,"r":"rightitems.2.label"},{"t":4,"n":51,"f":[{"t":2,"r":"ConfigStrings.orderSummary.labels.upfrontPayment"}],"r":"rightitems.2.label"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"left help-icon"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":4,"f":[{"t":2,"r":"rightitems.2.tooltip"}],"n":50,"r":"rightitems.2.tooltip"},{"t":4,"n":51,"f":["This is one time upfront cost."],"r":"rightitems.2.tooltip"}]}],"n":50,"x":{"r":["type"],"s":"_0==\"postGST\""}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 medium-12 text-right"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["section-header"],"n":50,"x":{"r":["type"],"s":"_0==\"postGST\""}},{"t":4,"n":51,"f":["body-light"],"x":{"r":["type"],"s":"_0==\"postGST\""}}," right"]},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"x":{"r":["checkoutPrice"],"s":"_0>0"}},{"t":4,"n":51,"f":["$0.00"],"x":{"r":["checkoutPrice"],"s":"_0>0"}}]}]}]}]}],"r":"isRedMembership"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-10 medium-offset-1 v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}],"n":50,"x":{"r":["type"],"s":"_0!==\"postGST\""}}]}]}]};
this["ux-page-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-page-banner"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["show-for-medium-up banner-background ",{"t":2,"r":"theme"}],"style":["background-image: url(",{"t":2,"r":"backgroundImgDesktop"},")"]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8 banner-content"},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"hero-text"},"f":[{"t":2,"r":"title"}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":["show-for-small-only banner-background ",{"t":2,"r":"theme"}],"style":["background-image: url(",{"t":2,"r":"backgroundImgMobile"},")"]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8 banner-content"},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"hero-text"},"f":[{"t":2,"r":"title"}]}]}]}]}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-page-section"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-page-section"},"f":[{"t":7,"e":"style","f":["@media (max-width: ",{"t":2,"r":"smallBreakpoint"},"px) {\n\t\t\t#",{"t":2,"r":"uniqueId"},"_background {\n",{"t":4,"f":["\t\t\t\t\tbackground-image:none !important;\n"],"n":50,"r":"isBgImgHiddenForMobile"},{"t":4,"n":51,"f":["\n",{"t":4,"f":["\t\t\t\t\t\tbackground-image: url('",{"t":2,"r":"backgroundImage.mobile.src"},"') !important;\n"],"n":50,"r":"backgroundImage.mobile.src"},"\t\t\t\t\t",{"t":4,"f":["height: ",{"t":2,"r":"mobileHeight"},"px !important; "],"n":50,"x":{"r":["mobileHeight"],"s":"_0>0"}},"\n\t\t\t\t"],"r":"isBgImgHiddenForMobile"},"\t\t\t}\n\t\t\t#",{"t":2,"r":"uniqueId"},"_contentDiv{\n",{"t":4,"f":["\t\t\t\t\t",{"t":4,"f":["padding-top: ",{"t":2,"r":"paddingTop"},"px !important;"],"n":50,"r":"paddingTop"},"\n\t\t\t\t\t",{"t":4,"f":["padding-bottom: ",{"t":2,"r":"paddingBottom"},"px !important;"],"n":50,"r":"paddingBottom"},"\n\t\t\t\t\t",{"t":4,"f":["padding-left: ",{"t":2,"r":"paddingLeft"},"px !important;"],"n":50,"r":"paddingLeft"},"\n\t\t\t\t\t",{"t":4,"f":["padding-right: ",{"t":2,"r":"paddingRight"},"px !important;"],"n":50,"r":"paddingRight"},"\n"],"r":"paddingMobile"},"\t\t\t}\n\t\t}\n\t\t#",{"t":2,"r":"uniqueId"},"_background{\n",{"t":4,"f":["\t\t\t\tbackground: -webkit-linear-gradient(",{"t":2,"r":"gradientStart"},", ",{"t":2,"r":"gradientEnd"},");\n\t\t\t\tbackground: -o-linear-gradient(",{"t":2,"r":"gradientStart"},", ",{"t":2,"r":"gradientEnd"},");\n\t\t\t\tbackground: -moz-linear-gradient(",{"t":2,"r":"gradientStart"},", ",{"t":2,"r":"gradientEnd"},");\n\t\t\t\tbackground: linear-gradient(",{"t":2,"r":"gradientStart"},", ",{"t":2,"r":"gradientEnd"},");\n"],"n":50,"x":{"r":["backgroundStyle"],"s":"_0==\"gradient\""}},{"t":4,"n":51,"f":["\n\t\t\t\t",{"t":4,"f":["background-color: ",{"t":2,"r":"bgColor"},";"],"n":50,"r":"bgColor"},"\n",{"t":4,"f":["\t\t\t\t\tbackground-image: url('",{"t":2,"r":"backgroundImage.desktop.src"},"');\n"],"n":50,"r":"backgroundImage.desktop.src"},"\t\t\t"],"x":{"r":["backgroundStyle"],"s":"_0==\"gradient\""}},"\t\t\t",{"t":4,"f":["height: ",{"t":2,"r":"desktopHeight"},"px; "],"n":50,"x":{"r":["desktopHeight"],"s":"_0>0"}},"\n\t\t}\n\t\t#",{"t":2,"r":"uniqueId"},"_contentDiv{\n",{"t":4,"f":["\t\t\t\t",{"t":4,"f":["padding-top: ",{"t":2,"r":"paddingTop"},"px;"],"n":50,"r":"paddingTop"},"\n\t\t\t\t",{"t":4,"f":["padding-bottom: ",{"t":2,"r":"paddingBottom"},"px;"],"n":50,"r":"paddingBottom"},"\n\t\t\t\t",{"t":4,"f":["padding-left: ",{"t":2,"r":"paddingLeft"},"px;"],"n":50,"r":"paddingLeft"},"\n\t\t\t\t",{"t":4,"f":["padding-right: ",{"t":2,"r":"paddingRight"},"px;"],"n":50,"r":"paddingRight"},"\n"],"r":"paddingDesktop"},"\t\t}"]}," ",{"t":7,"e":"div","a":{"id":[{"t":2,"r":"uniqueId"},"_background"],"class":["container background ",{"t":2,"r":"shadow"}," ",{"t":2,"r":"theme"}," ",{"t":2,"r":"backgroundPositionClass"}," ",{"t":2,"r":"backgroundSizeClass"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-panel","a":{"class":"clearfix moveTop"},"f":[{"t":7,"e":"div","a":{"id":[{"t":2,"r":"uniqueId"},"_contentDiv"]},"f":[{"t":4,"f":[{"t":3,"r":"body"}],"n":50,"r":"body"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"body"}]}]}]}],"n":50,"r":"isPanelNeeded"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"id":[{"t":2,"r":"uniqueId"},"_contentDiv"]},"f":[{"t":4,"f":[{"t":3,"r":"body"}],"n":50,"r":"body"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"body"}]}],"r":"isPanelNeeded"}]}]}]};
this["ux-pay-bill"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-pay-bill"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-row","a":{"class":"flex-container p-normal-left-medium p-normal-right-medium"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-1 flex-item"},"f":[{"t":4,"f":[{"t":7,"e":"ux-checkbox","a":{"checkboxid":[{"t":2,"r":"billingAccountNumber"}],"checked":[{"t":2,"r":"selected"}]}}],"n":50,"x":{"r":[],"s":"true"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-checkbox","a":{"checkboxid":[{"t":2,"r":"billingAccountNumber"}],"disabled":"true"}}],"x":{"r":[],"s":"true"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-1 flex-item"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"avatarImg.src"}],"alt":[{"t":3,"r":"avatarImg.alt"}],"class":[{"t":4,"f":["image-container"],"n":51,"r":"avatarImg.src"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 flex-item"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header v-small-top v-small-bottom"},"f":[{"t":2,"r":"nickName"}]}," ",{"t":7,"e":"div","f":["Account Number: ",{"t":2,"x":{"r":["RactiveHelpers","faid"],"s":"_0.zeroPadding(_1,7)"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4 flex-item text-right"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":""},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"medium-6 medium-offset-6"},"f":[{"t":7,"e":"ux-input-box","a":{"prefix":"$","value":[{"t":2,"r":"amountToPay"}],"onblurEvent":"onAmountChange","onInputEvent":"onAmountInput","class":[{"t":2,"x":{"r":["amountError"],"s":"_0?\"amount-error\":\"\""}}]}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","validityMsgClass":"margin-zero","message":[{"t":2,"r":"overMaxPaybleAmountInputFieldMsg"}]}}]}],"n":50,"r":"amountError"}],"n":50,"r":"selected"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"section-header no-wrap v-medium-top"},"f":[{"t":2,"x":{"r":["RactiveHelpers","balanceAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"r":"selected"}]}," ",{"t":7,"e":"div","a":{"class":"no-wrap"},"f":["Amount due: ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","balanceAmount"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"x":{"r":["balanceAmount"],"s":"_0>=0"}},{"t":4,"n":51,"f":["--"],"x":{"r":["balanceAmount"],"s":"_0>=0"}}]}," ",{"t":7,"e":"div","a":{"class":"no-wrap"},"f":["Due date: ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","dueDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}],"n":50,"r":"dueDate"},{"t":4,"n":51,"f":["--"],"r":"dueDate"}]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only text-center"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-checkbox","a":{"checkboxid":[{"t":2,"r":"billingAccountNumber"}],"checked":[{"t":2,"r":"selected"}]}}],"n":50,"x":{"r":[],"s":"true"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-checkbox","a":{"checkboxid":[{"t":2,"r":"billingAccountNumber"}],"disabled":"true"}}],"x":{"r":[],"s":"true"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"avatarImg.src"}],"alt":[{"t":3,"r":"avatarImg.alt"}],"class":[{"t":4,"f":["image-container"],"n":51,"r":"avatarImg.src"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"main-header"},"f":[{"t":2,"r":"nickName"}]}," ",{"t":7,"e":"div","f":["A/C: ",{"t":2,"x":{"r":["RactiveHelpers","faid"],"s":"_0.zeroPadding(_1,7)"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"small-6 margin-auto"},"f":[{"t":4,"f":[{"t":7,"e":"ux-input-box","a":{"prefix":"$","value":[{"t":2,"r":"amountToPay"}],"onblurEvent":"onAmountChange","onInputEvent":"onAmountInput","class":[{"t":2,"x":{"r":["amountError"],"s":"_0?\"amount-error\":\"\""}}]}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","validityMsgClass":"margin-zero","message":[{"t":2,"r":"overMaxPaybleAmountInputFieldMsg"}]}}]}],"n":50,"r":"amountError"}],"n":50,"r":"selected"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"product-title"},"f":[{"t":2,"x":{"r":["RactiveHelpers","balanceAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"r":"selected"}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","f":["Amount due: ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","balanceAmount"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"x":{"r":["balanceAmount"],"s":"_0>=0"}},{"t":4,"n":51,"f":["--"],"x":{"r":["balanceAmount"],"s":"_0>=0"}}]}," ",{"t":7,"e":"div","f":["Due date: ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","dueDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}],"n":50,"r":"dueDate"},{"t":4,"n":51,"f":["--"],"r":"dueDate"}]}]}]}]}],"n":53,"r":"account"}]};
this["ux-payment-desc"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-payment-desc"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-9"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header v-normal-bottom"},"f":[{"t":3,"r":"title"}]}," ",{"t":7,"e":"p","f":[{"t":3,"x":{"r":["helpers","desc"],"s":"_0.unescapeString(_1)"}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-medium-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ul","a":{"class":"inline-list right margin-zero"},"f":[{"t":7,"e":"li","f":[{"t":7,"e":"ux-button","a":{"class":"round light right margin-zero","text":[{"t":2,"r":"buttonText"}],"onclick":"onApplyButtonClick"}}]}]}],"n":50,"x":{"r":["payMeansInfo.isGiroActivated"],"s":"_0===\"NO\""}}]}]}]}]};
this["ux-payment-info"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-payment-info p-large-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"p-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-start relative"},"f":[{"t":7,"e":"span","a":{"class":"flex-item relative success-icon flex-item-top-align show-for-medium-up p-medium-right"},"f":[{"t":7,"e":"ux-icon","a":{"color":"#39AA6D","type":"success-tick","size":"xl"}}]}," ",{"t":7,"e":"span","a":{"class":"flex-item relative success-icon flex-item-top-align show-for-small-only"},"f":[{"t":7,"e":"ux-icon","a":{"color":"#39AA6D","type":"success-tick","size":"l"}}]}," ",{"t":7,"e":"span","a":{"class":"main-header flex-item p-medium-left"},"f":["Purchase complete!"]}]}]}],"n":50,"r":"paymentSuccess"}," ",{"t":7,"e":"ux-panel","f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header response-title v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"paymentInfoSuccessful.responseTitle"}]}],"n":50,"r":"paymentInfoSuccessful.responseTitle"}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"v-normal-bottom"},"f":[{"t":3,"r":"paymentInfoSuccessful.responseMessage"}," ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"paymentInfoSuccessful.orderLink"}]},"f":[{"t":2,"r":"orderid"}]}]}],"n":50,"x":{"r":["isBlockOrder","paymentInfoSuccessful.responseMessage"],"s":"_0&&_1"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider expanded padded"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header v-medium-bottom v-normal-top section-title"},"f":[{"t":2,"r":"nextTitle"}]}],"n":50,"x":{"r":["isBlockOrder","nextTitle"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header subsection v-normal-top v-small-bottom"},"f":[{"t":2,"r":"subtitle"}]}," ",{"t":7,"e":"p","f":[{"t":3,"r":"message"}]}],"n":50,"x":{"r":["subtitle","orderConfirmation.billPayer"],"s":"_0!==\"OnePass\"||(_1!==\"1\")"}}],"r":"inserviceOrderNextSections"}],"n":50,"r":"isBlockOrder"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-wrapper p-normal-top p-normal-bottom"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header subsection v-small-bottom v-none-top"},"f":[{"t":2,"x":{"r":["getWithPlaceholderValues","header"],"s":"_0(_1)"}}]}," ",{"t":7,"e":"div","a":{"class":"subsection-body"},"f":[{"t":3,"x":{"r":["getWithPlaceholderValues","message"],"s":"_0(_1)"}}]}]}],"r":"initData.sectionDetails"}],"r":"isBlockOrder"}," "]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider expanded padded v-none-left-medium v-none-right-medium"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"medium-8 v-normal-top notes-section"},"f":[{"t":7,"e":"p","a":{"class":"shout-text"},"f":[{"t":2,"r":"header"}]}," ",{"t":7,"e":"div","a":{"class":""},"f":[{"t":3,"r":"message"}]}]}],"r":"initData.noteSection"}]}],"n":50,"x":{"r":["isBlockOrder","initData.noteSection"],"s":"!_0&&_1"}}]}],"r":"paymentInfoSuccessful.successfulInfo"}],"n":50,"r":"paymentSuccess"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"v-medium-bottom v-medium-top section-header response-title"},"f":[{"t":2,"r":"responseTitle"}]}],"n":50,"r":"responseTitle"}," ",{"t":7,"e":"p","f":[{"t":3,"r":"responseMessage"}," "]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header section-title  v-normal-top v-medium-bottom"},"f":[{"t":2,"r":"nextTitle"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header subsection v-normal-top"},"f":[{"t":2,"r":"subtitle"}]}],"n":50,"r":"subtitle"}," ",{"t":7,"e":"p","f":[{"t":3,"r":"message"}]}],"r":"nextSections"}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"}}]}],"n":53,"r":"unsuccessfulInfo"}],"n":53,"r":"paymentFailObj"}],"r":"paymentSuccess"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header subsection  v-medium-bottom v-normal-top "},"f":[{"t":2,"r":"simOnlyLeaseMessage"}]}," ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"simOnlyLeaseUrl"},"?OrderId=",{"t":2,"r":"orderid"}]},"f":[{"t":2,"r":"simOnlyLeaseUrlText"}]}]}]}],"n":50,"r":"showLeasingPlanLink"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"promo-section"},"f":[{"t":7,"e":"ux-row","a":{"class":"p-medium-top p-normal-bottom p-medium-bottom p-none-left-mobile p-none-right-mobile p-normal-top-mobile"},"f":[{"t":7,"e":"ux-col","f":[" ",{"t":7,"e":"a","a":{"href":[{"t":2,"r":"couponDistribution.url"}],"class":"pointer","target":"_blank"},"f":[{"t":7,"e":"div","a":{"class":"ux-image hide-for-small-only"},"f":[{"t":7,"e":"img","a":{"class":"fullWidth","src":[{"t":2,"r":"couponDistribution.imagePath"},{"t":2,"r":"couponDistribution.campaignGroup"},"_desktop.jpg"]}}]}," ",{"t":7,"e":"div","a":{"class":"ux-image show-for-small-only"},"f":[{"t":7,"e":"img","a":{"class":"fullWidth","src":[{"t":2,"r":"couponDistribution.imagePath"},{"t":2,"r":"couponDistribution.campaignGroup"},"_mobile.jpg"]}}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":2,"r":"couponDistribution.text"}]}],"n":50,"r":"couponDistribution.text"}," ",{"t":7,"e":"div","a":{"class":"flex-container flex-container-small-column v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"flex-item section-header"},"f":["Promo code: ",{"t":2,"r":"couponDistribution.couponCode"}]}," ",{"t":7,"e":"div","a":{"class":"flex-item v-normal-top-mobile flex-small-full-width p-medium-left-mobile p-medium-right-mobile"},"f":[{"t":7,"e":"ux-button","a":{"class":"round margin-zero fullwidth","onclick":"onEmailPromoCode"},"f":["Email Promo Code"]}]}]}]}]}]}],"n":50,"x":{"r":["paymentSuccess","paymentInfoSuccessful.successfulInfo","couponDistribution"],"s":"_0&&_1&&_2"}}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme light","modalId":"emailPromoCodeModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":["Key in Email Address"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-medium-bottom section-details"},"f":[{"t":7,"e":"ux-col","f":["Promo code will be sent to email address you key in below."]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-medium-bottom","for":"contactEmail"},"f":["Email Address"]}," ",{"t":7,"e":"ux-input-box","a":{"validity":[{"t":2,"r":"contactEmailErrorMsg"}],"id":"contactEmail","onblurEvent":"onBlurEmail","class":"input-no-margin"},"f":[]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-medium-top section-details"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 v-normal-top text-center-small medium-text-left"},"f":[{"t":7,"e":"ux-button","a":{"class":"small-only-expand round light","text":"Email me","onclick":"onEmailMe"},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 medium-text-right text-center-small v-normal-top"},"f":[]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme light","modalId":"promoSuccessModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","a":{"class":"flex-container flex-container-start"},"f":[{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-tick","size":"l","class":"green-icon"}}]}," ",{"t":7,"e":"div","a":{"class":"section-header flex-item p-normal-left margin-zero"},"f":["Promo code has been sent"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-medium-bottom section-details"},"f":[{"t":7,"e":"ux-col","f":["Promo code has been successfully sent to your email address. Please retrieve it from your inbox."]}]}]}]}]};
this["ux-phone-catalogue-gui"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-phone-catalogue-gui"},"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-row","a":{"class":"clearfix"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel"}],"r":"ribbon"}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 medium-6 v-medium-top text-right"},"f":[{"t":7,"e":"ux-image","a":{"class":"handset-img","img":[{"t":4,"f":[{"t":2,"r":"handsetImage"}],"n":50,"r":"handsetImage"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"r":"image"}],"r":"colorList.0"}],"r":"handsetImage"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 medium-6 v-large-top v-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"product-title v-normal-top"},"f":[{"t":2,"r":"phoneName"}]}],"n":50,"r":"phoneName"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"select-color"},"v":{"tap":{"n":"selectColor","d":[{"t":2,"r":"image"}]}},"f":[{"t":7,"e":"ux-anchor","a":{"class":[{"t":4,"f":["white"],"n":50,"x":{"r":["colorItem.color"],"s":"_0==\"#ffffff\"||_0==\"#fff\""}}],"backgroundColor":[{"t":2,"r":"colorItem"}]}}]}],"n":50,"r":"colorItem.color"}],"r":"colorList"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscript-text v-medium-top"},"f":[{"t":2,"r":"subscriptText"}]}],"n":50,"r":"subscriptText"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"prices"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-through-dollar"},"f":["$",{"t":2,"r":"originalPrice"}]}],"n":50,"r":"originalPrice"}," ",{"t":7,"e":"span","a":{"class":"main-dollar"},"f":["$",{"t":2,"r":"price"}]}]}],"n":50,"r":"price"}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"planText"}]}],"n":50,"r":"planText"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"buttonLink"}],"class":"bannerLink"},"f":[{"t":2,"r":"buttonText"}]}],"n":50,"r":"isCtaHyperlink"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":"round","text":[{"t":2,"r":"buttonText"}],"href":[{"t":2,"r":"buttonLink"}]}}],"r":"isCtaHyperlink"}]}],"n":50,"r":"buttonText"}]}]}]}],"n":50,"x":{"r":["textAlignment"],"s":"_0===\"right\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["textAlignment"],"s":"_0===\"left\""},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-row","a":{"class":"clearfix"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel"}],"r":"ribbon"}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 medium-6 v-large-top v-large-bottom left text-right"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"product-title v-normal-top"},"f":[{"t":2,"r":"phoneName"}]}],"n":50,"r":"phoneName"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"select-color"},"v":{"tap":{"n":"selectColor","d":[{"t":2,"r":"image"}]}},"f":[{"t":7,"e":"ux-anchor","a":{"class":[{"t":4,"f":["white"],"n":50,"x":{"r":["colorItem.color"],"s":"_0==\"#ffffff\"||_0==\"#fff\""}}],"backgroundColor":[{"t":2,"r":"colorItem"}]}}]}],"n":50,"r":"colorItem.color"}],"r":"colorList"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscript-text v-medium-top"},"f":[{"t":2,"r":"subscriptText"}]}],"n":50,"r":"subscriptText"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"prices"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-through-dollar"},"f":["$",{"t":2,"r":"originalPrice"}]}],"n":50,"r":"originalPrice"}," ",{"t":7,"e":"span","a":{"class":"main-dollar"},"f":["$",{"t":2,"r":"price"}]}]}],"n":50,"r":"price"}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"planText"}]}],"n":50,"r":"planText"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"buttonLink"}],"class":"bannerLink"},"f":[{"t":2,"r":"buttonText"}]}],"n":50,"r":"isCtaHyperlink"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":"round","text":[{"t":2,"r":"buttonText"}],"href":[{"t":2,"r":"buttonLink"}]}}],"r":"isCtaHyperlink"}]}],"n":50,"r":"buttonText"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 medium-6 v-medium-top"},"f":[{"t":7,"e":"ux-image","a":{"class":"handset-img","img":[{"t":4,"f":[{"t":2,"r":"handsetImage"}],"n":50,"r":"handsetImage"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"r":"image"}],"r":"colorList.0"}],"r":"handsetImage"}]}}]}]}]}]},{"t":4,"n":50,"x":{"r":["textAlignment"],"s":"(!(_0===\"left\"))&&(_0===\"bottom\")"},"f":[" ",{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel"}],"r":"ribbon"}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12 v-medium-top text-center"},"f":[{"t":7,"e":"ux-image","a":{"class":"handset-img","img":[{"t":4,"f":[{"t":2,"r":"handsetImage"}],"n":50,"r":"handsetImage"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"r":"image"}],"r":"colorList.0"}],"r":"handsetImage"}]}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"product-title v-normal-top"},"f":[{"t":2,"r":"phoneName"}]}],"n":50,"r":"phoneName"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"select-color"},"v":{"tap":{"n":"selectColor","d":[{"t":2,"r":"image"}]}},"f":[{"t":7,"e":"ux-anchor","a":{"class":[{"t":4,"f":["white"],"n":50,"x":{"r":["colorItem.color"],"s":"_0==\"#ffffff\"||_0==\"#fff\""}}],"backgroundColor":[{"t":2,"r":"colorItem"}]}}]}],"n":50,"r":"colorItem.color"}],"r":"colorList"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscript-text v-medium-top"},"f":[{"t":2,"r":"subscriptText"}]}],"n":50,"r":"subscriptText"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"prices"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-through-dollar"},"f":["$",{"t":2,"r":"originalPrice"}]}],"n":50,"r":"originalPrice"}," ",{"t":7,"e":"span","a":{"class":"main-dollar"},"f":["$",{"t":2,"r":"price"}]}]}],"n":50,"r":"price"}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"planText"}]}],"n":50,"r":"planText"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"buttonLink"}],"class":"bannerLink"},"f":[{"t":2,"r":"buttonText"}]}],"n":50,"r":"isCtaHyperlink"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":"round","text":[{"t":2,"r":"buttonText"}],"href":[{"t":2,"r":"buttonLink"}]}}],"r":"isCtaHyperlink"}]}],"n":50,"r":"buttonText"}]}]}]}],"x":{"r":["textAlignment"],"s":"_0===\"right\""}}]}]};
this["ux-phone-catalogue"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-phone-catalogue"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"medium-collapse v-normal-top"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4 large-3"},"f":[{"t":7,"e":"ux-catalogue-block","m":[{"t":4,"f":["isIPPPlan=\"",{"t":2,"r":"isIPPPlan"},"\""],"n":50,"r":"isIPPPlan"}],"a":{"phone":[{"t":3,"r":"."}],"isDataModel":"true"}}]}],"n":50,"r":"display"}],"n":52,"r":"initData.filteredPhoneList"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12  "},"f":[{"t":2,"r":"initData.ippDetails.ippMarketingText"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"show-for-small-only small-12  "},"f":[{"t":2,"r":"initData.ippDetails.ippMarketingText"}]}],"n":50,"r":"isIPPPlan"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12 "},"f":[{"t":2,"r":"initData.contractMarketingText"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"show-for-small-only  small-12"},"f":[{"t":2,"r":"initData.contractMarketingText"}]}],"r":"isIPPPlan"}],"n":50,"r":"isNewPP"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-12 text-center v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"class":"show-more-phones","text":"Show More Phones","onclick":"viewMore"}}]}],"n":50,"r":"initData.showButton"}]}],"n":50,"r":"startPhoneDisplay"}]}]};
this["ux-phone-compare-filter"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-phone-compare-filter"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"filter-header"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header"},"f":[{"t":2,"r":"initData.addToCompareLabel"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 "},"f":[{"t":7,"e":"ux-select","a":{"id":"select-brand","mandatory":"true","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"filter.selectedBrand"}],"options":[{"t":2,"r":"finalBrands"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"model-filter"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 "},"f":[{"t":7,"e":"ux-select","a":{"id":"select-model","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"filter.selectedModel"}],"options":[{"t":2,"r":"filter.modelList"}]}}]}]}],"n":50,"r":"isDataModel"}]}]};
this["ux-phone-details"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-phone-details"},"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-4 ",{"t":4,"f":["no-right-border"],"n":50,"x":{"r":["i"],"s":"_0==2"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"remove","ontap":["removeSelectedDevice: ",{"t":2,"r":"i"}]},"f":[{"t":7,"e":"ux-icon","a":{"class":"icon-close-line"}}]}," ",{"t":7,"e":"ux-catalogue-block","a":{"displayBlock":"true","isIPPPlan":[{"t":2,"r":"isIPPPlan"}],"phone":[{"t":2,"r":"deviceData"}],"isCompare":"true","isDataModel":"true"}}],"n":50,"r":"showDetails"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-phone-compare-filter","a":{"isDataModel":"true","brands":[{"t":2,"r":"brands"}],"isIPPPlan":[{"t":2,"r":"isIPPPlan"}],"phoneList":[{"t":2,"r":"phoneList"}],"initData":[{"t":2,"r":"initData"}],"filter":[{"t":2,"r":"."}],"filterid":[{"t":2,"r":"i"}]}}],"r":"showDetails"}]}],"n":52,"i":"i","r":"filters"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"heading-line"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-4 "},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-normal-top v-normal-bottom"},"f":[{"t":2,"r":"title"}]}]}],"n":52,"r":"."}]}," ",{"t":7,"e":"ux-row","a":{"class":"content-line"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-4 "},"f":[{"t":7,"e":"div","a":{"class":"body-text"},"f":[{"t":4,"f":[{"t":3,"r":"content"}],"n":50,"r":"content"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-text-list-item"},"f":[{"t":3,"r":"."}]}],"n":52,"r":"contentList"}],"n":50,"r":"contentList"}]}]}],"n":52,"r":"."}]}],"n":52,"r":"options"}," ",{"t":7,"e":"ux-row","a":{"class":"button-wrapper bottom-button-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-4 ",{"t":4,"f":["no-right-border"],"n":50,"x":{"r":["i"],"s":"_0==2"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"light round","text":[{"t":2,"r":"initData.selectLabel"}],"role":"button","arialabel":[{"t":2,"r":"initData.selectLabel"}],"groupId":[{"t":2,"r":"deviceData.groupId"}],"productUrl":[{"t":2,"r":"deviceData.productUrl"}],"onclick":"phoneSelected"}}],"n":50,"r":"showDetails"}]}],"n":52,"i":"i","r":"filters"}]}],"n":50,"r":"hasDetails"}]}]};
this["ux-phone-pricing-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-phone-pricing-banner","id":[{"t":2,"r":"uniqueId"}]},"f":[{"t":7,"e":"style","f":[{"t":4,"f":["\n\t\t\t@media (max-width:425px) {\n\t\t\t\t#",{"t":2,"r":"uniqueId"}," .bg-image{\n\t\t\t\t\tbackground-image: url('",{"t":2,"r":"backgroundImage.mobile.src"},"') !important;\n\t\t\t\t}\n\t\t\t\t#",{"t":2,"r":"uniqueId"}," .flexWrapper{\n\t\t\t\t\theight: ",{"t":2,"r":"mobileHeight"},"px !important;\n\t\t\t\t}\n\t\t\t}\n"],"n":50,"x":{"r":["backgroundImage.mobile.src.length"],"s":"_0>0"}},"\t\t#",{"t":2,"r":"uniqueId"}," .bg-image{\n\t\t\tbackground-image: url('",{"t":2,"r":"backgroundImage.desktop.src"},"');\n\t\t\tpadding-left: ",{"t":2,"r":"desktopPadding"},"%;\n\t\t\tpadding-right: ",{"t":2,"r":"desktopPadding"},"%;\n\t\t}\n\t\t#",{"t":2,"r":"uniqueId"}," .flexWrapper{\n\t\t\theight: ",{"t":2,"r":"desktopHeight"},"px;\n\t\t}"]}," ",{"t":7,"e":"div","a":{"class":["bg-image ",{"t":2,"r":"theme"}]},"f":[{"t":7,"e":"div","a":{"class":"flexWrapper"},"f":[{"t":7,"e":"div","a":{"class":"title"},"f":[{"t":4,"f":[{"t":3,"r":"wrapperTitle"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t\t\t",{"t":3,"r":"scriptForTitle"},"\n\t\t\t\t\t\t"]}],"n":50,"r":"scriptForTitle"}],"n":50,"r":"wrapperTitle"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":3,"r":"text.title"}],"n":50,"r":"text.title"}],"r":"wrapperTitle"}]}," ",{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":4,"f":[{"t":3,"r":"wrapperDescription"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t\t\t",{"t":3,"r":"scriptForDescription"},"\n\t\t\t\t\t\t"]}],"n":50,"r":"scriptForDescription"}],"n":50,"r":"wrapperDescription"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":3,"r":"text.description"}],"n":50,"r":"text.description"}],"r":"wrapperDescription"}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":4,"f":[{"t":3,"r":"wrapperTable"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t\t\t",{"t":3,"r":"scriptForTable"},"\n\t\t\t\t\t\t"]}],"n":50,"r":"scriptForTable"}],"n":50,"r":"wrapperTable"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-phone-pricing-table","a":{"datamodel":[{"t":2,"r":"table"}]}}],"n":50,"r":"table"}],"r":"wrapperTable"}," ",{"t":8,"r":"content"}]}," ",{"t":7,"e":"div","a":{"class":"buttonWrap"},"f":[{"t":4,"f":[{"t":3,"r":"wrapperButton"}," ",{"t":4,"f":[{"t":7,"e":"script","f":["\t\t\t\t\t\t\t",{"t":3,"r":"scriptForButton"},"\n\t\t\t\t\t\t"]}],"n":50,"r":"scriptForButton"}],"n":50,"r":"wrapperButton"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":["round ",{"t":2,"r":"button.buttonColor"}," btn-responsive"],"text":[{"t":2,"r":"button.buttonText"}],"href":[{"t":2,"r":"button.linkTo"}]}}],"n":50,"r":"button"}],"r":"wrapperButton"}]}]}]}]}]};
this["ux-phone-pricing-table"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-phone-pricing-table","style":["margin-top:",{"t":2,"r":"spacingTop"},"%; ",{"t":4,"f":["float:left;margin-left:",{"t":2,"r":"spacingLeft"},"%;"],"n":50,"x":{"r":["alignment"],"s":"_0===\"left\""}}," ",{"t":4,"f":["float:right;margin-right:",{"t":2,"r":"spacingRight"},"%;"],"n":50,"x":{"r":["alignment"],"s":"_0===\"right\""}}," ",{"t":4,"f":["margin-left:",{"t":2,"r":"spacingCenter"},"%;margin-right:",{"t":2,"r":"spacingCenter"},"%;"],"n":50,"x":{"r":["alignment"],"s":"_0===\"center\""}}]},"f":[{"t":7,"e":"div","a":{"class":"table-row table-row-header"},"f":[{"t":7,"e":"span","a":{"class":"table-header-left","style":["padding:",{"t":2,"r":"cellPadding"},"px;"]},"f":[{"t":7,"e":"b","f":[{"t":2,"r":"header1"}]}]}," ",{"t":7,"e":"span","a":{"class":"table-header-right","style":["padding:",{"t":2,"r":"cellPadding"},"px;"]},"f":[{"t":7,"e":"b","f":[{"t":2,"r":"header2"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"white-line"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"table-row"},"f":[{"t":7,"e":"span","a":{"class":"table-col","style":["padding:",{"t":2,"r":"cellPadding"},"px;"]},"f":[{"t":4,"f":[{"t":2,"r":"text1"}],"n":50,"x":{"r":["text1.length"],"s":"_0>0"}}," ",{"t":4,"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"link1"}]},"f":[{"t":2,"r":"linkText1"}]}],"n":50,"x":{"r":["link1.length"],"s":"_0>0"}}]}," ",{"t":7,"e":"span","a":{"class":"table-col","style":["padding:",{"t":2,"r":"cellPadding"},"px;"]},"f":[{"t":4,"f":[{"t":2,"r":"text2"}],"n":50,"x":{"r":["text2.length"],"s":"_0>0"}}," ",{"t":4,"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"link2"}]},"f":[{"t":2,"r":"linkText2"}]}],"n":50,"x":{"r":["linkText2.length"],"s":"_0>0"}}]}]}],"n":52,"i":"r","r":"rows"}]}," ",{"t":7,"e":"div","a":{"style":"clear:both;"}}]};
this["ux-plan-list"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-plan-list v-small-top"},"f":[{"t":7,"e":"div","a":{"class":"plan-container"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"datamodel.discountText"}]}],"n":50,"x":{"r":["datamodel","datamodel.discountText"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-top v-normal-bottom eligibilty-details"},"f":[{"t":3,"r":"ippEligibiltyDetails"}]}]}],"n":50,"x":{"r":["ippEligibiltyDetails"],"s":"_0&&_0!==\"\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":3,"r":"contractHeader"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"medium-12 show-for-medium-up v-large-bottom contract-filter"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-2"},"f":[{"t":7,"e":"ux-radio-button","a":{"use_content":"true","onclick":"ippDurationSelected","value":[{"t":2,"r":"value"}],"btn_id":[{"t":2,"x":{"r":["i"],"s":"_0+1"}}],"selected":[{"t":2,"r":"selectedFilter"}],"name":"phone_filter"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"text"}]}]}]}]}],"i":"i","r":"contractFilter"}]}],"n":50,"x":{"r":["groupType"],"s":"_0===\"simOnlyIppPlan\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only plan-details-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"line-height-one"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 eligibilty-details"},"f":[{"t":3,"r":"ippEligibiltyDetails"}]}]}],"n":50,"x":{"r":["ippEligibiltyDetails"],"s":"_0&&_0!==\"\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":3,"r":"contractHeader"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only contract-filter"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"ux-radio-button","a":{"use_content":"true","onclick":"ippDurationSelected","value":[{"t":2,"r":"value"}],"btn_id":[{"t":2,"x":{"r":["i"],"s":"_0+1"}}],"selected":[{"t":2,"r":"selectedFilter"}],"name":"phone_filter"},"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"text"}]}]}]}]}],"i":"i","r":"contractFilter"}]}],"n":50,"x":{"r":["groupType"],"s":"_0===\"simOnlyIppPlan\""}}]}],"n":50,"x":{"r":["ippEligibiltyDetails","groupType"],"s":"(_0&&_0!==\"\")||(_1===\"simOnlyIppPlan\")"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"x":{"r":["getSelectedState","i"],"s":"_0(_1)"}}," ",{"t":4,"f":["v-normal-bottom"],"n":50,"r":"ribbon"}]},"v":{"tap":{"n":"onCommonPlanClick","d":[{"t":2,"r":"groupType"},",",{"t":2,"r":"i"},",",{"t":2,"r":"isApplicableForTablet"}]}},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"ribbonPosition":"left"}}],"r":"ribbon"}," ",{"t":7,"e":"table","a":{"class":["plan-details-table show-for-medium-up ",{"t":4,"f":["v-normal-bottom"],"n":50,"x":{"r":["i","plans.length"],"s":"_0<_1-1"}}]},"f":[{"t":7,"e":"tr","a":{"class":["plan ",{"t":4,"f":["mobile-bb"],"n":50,"x":{"r":["groupType"],"s":"_0==\"mobileBroadbandPlan\""}}," ",{"t":4,"f":["ipp-plan"],"n":50,"x":{"r":["planGroupName"],"s":"_0===\"IPPPLANS\""}}]},"f":[{"t":7,"e":"td","a":{"class":["text-left plan-name p-normal-left row-title ",{"t":4,"f":["with-ribbon"],"n":50,"r":"ribbon"}]},"f":[{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"r":"len"}," ",{"t":2,"r":"planName"}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":4,"f":[{"t":2,"r":"planExtraLiner"}],"n":50,"r":"planExtraLiner"}]}]}," ",{"t":7,"e":"td","a":{"class":"plan-highlights text-left plan-data"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-11"},"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"data.quantity"},{"t":4,"f":[{"t":2,"r":"data.unit"}],"n":50,"x":{"r":["data.quantity"],"s":"_0!==\"Unlimited\""}}]}," Data",{"t":4,"f":["*"],"n":50,"r":"dataDisclaimer"}],"n":50,"x":{"r":["data.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," ",{"t":4,"f":["+"],"n":50,"x":{"r":["wifiData.quantity","data.quantity"],"s":"_1&&_0&&(_0>0||_0===\"Unlimited\")&&_1>0"}}," ",{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"wifiData.quantity"},{"t":4,"f":[{"t":2,"r":"wifiData.unit"}],"n":50,"x":{"r":["wifiData.quantity"],"s":"_0!==\"Unlimited\""}}]}," Singtel WiFi"],"n":50,"x":{"r":["wifiData.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"talktime.quantity"},{"t":4,"f":[{"t":2,"r":"talktime.unit"}],"n":50,"x":{"r":["talktime.quantity"],"s":"_0!==\"Unlimited\""}}]}," Talktime",{"t":4,"f":["*"],"n":50,"r":"minsDisclaimer"}],"n":50,"x":{"r":["talktime.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," + ",{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"sms.quantity"}]}," SMS",{"t":4,"f":["*"],"n":50,"r":"smsDisclaimer"}],"n":50,"x":{"r":["sms.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}]}],"n":50,"x":{"r":["mobileplan","planGroupName"],"s":"_0||_1===\"IPPPLANS\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":7,"e":"li","f":[{"t":3,"r":"planDescSubLiner"}]}]}],"n":50,"r":"planDescSubLiner"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"td","a":{"class":"text-right ipp-detail"},"f":[{"t":7,"e":"div","a":{"class":"section-header v-large-top"},"f":[{"t":2,"x":{"r":["RactiveHelpers","./partialUpfrontAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":["Upfront"]}]}," ",{"t":7,"e":"td","a":{"class":"text-right plus-icon"},"f":[{"t":7,"e":"span","a":{"class":"section-header"},"f":["+"]}]}],"n":50,"x":{"r":["deviceIdAndPlanId.deviceId","planGroupName"],"s":"_0&&_1===\"IPPPLANS\""}}," ",{"t":7,"e":"td","a":{"class":["text-right ",{"t":4,"f":["ipp-device-cost"],"n":50,"x":{"r":["planGroupName"],"s":"_0===\"IPPPLANS\""}},{"t":4,"n":51,"f":["plan-tag"],"x":{"r":["planGroupName"],"s":"_0===\"IPPPLANS\""}}," device-cost"]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-normal-bottom"},"f":["Phone"]}," ",{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","./phoneCost"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"r":"planDuration"},{"t":2,"r":"interestLabel"}]}],"n":50,"r":"deviceIdAndPlanId.deviceId"}]}," ",{"t":4,"f":[{"t":7,"e":"td","a":{"class":"text-right plan-tag device-top-up"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-normal-bottom"},"f":["Device Top Up"]}," ",{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyDeviceTopup"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"}}],"n":50,"r":"deviceIdAndPlanId.deviceId"}]}],"n":50,"x":{"r":["groupType"],"s":"_0==\"mobileBroadbandPlan\""}}," ",{"t":7,"e":"td","a":{"class":["last-column text-right ",{"t":4,"f":["ipp-detail"],"n":50,"x":{"r":["planGroupName"],"s":"_0===\"IPPPLANS\""}},{"t":4,"n":51,"f":["plan-tag"],"x":{"r":["planGroupName"],"s":"_0===\"IPPPLANS\""}}," monthly-recurring p-normal-right"]},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-normal-bottom"},"f":["Plan"]}," ",{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyCharges"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":["Monthly"]}]}]}]}," ",{"t":7,"e":"div","a":{"class":[{"t":4,"f":["v-normal-bottom"],"n":50,"x":{"r":["i","plans.length"],"s":"_0<_1-1"}}," show-for-small-only v-normal-top"]},"f":[{"t":7,"e":"div","a":{"class":["plan-details-top ",{"t":4,"f":["with-ribbon"],"n":50,"r":"ribbon"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["small-12"],"n":50,"x":{"r":["planGroupName"],"s":"_0===\"IPPPLANS\""}},{"t":4,"n":51,"f":["small-4"],"x":{"r":["planGroupName"],"s":"_0===\"IPPPLANS\""}}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"r":"len"}," ",{"t":2,"r":"planName"}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":4,"f":[{"t":2,"r":"planExtraLiner"}],"n":50,"r":"planExtraLiner"}]}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 text-right"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header "},"f":["Phone"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":["Plan"]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-3"},"f":[{"t":7,"e":"div","a":{"class":"text-right p-medium-right"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","./partialUpfrontAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":["Upfront"]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-1"},"f":[{"t":7,"e":"div","a":{"class":"p-normal-left p-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":["+"]}]}]}],"n":50,"x":{"r":["planGroupName"],"s":"_0===\"IPPPLANS\""}}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"div","a":{"class":"text-right"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-small-bottom"},"f":["Phone"]}],"n":50,"x":{"r":["planGroupName"],"s":"_0!==\"IPPPLANS\""}}," ",{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","./phoneCost"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"r":"planDuration"},{"t":2,"r":"interestLabel"}]}]}]}],"n":50,"r":"deviceIdAndPlanId.deviceId"}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["small-4"],"n":50,"r":"deviceIdAndPlanId.deviceId"},{"t":4,"n":51,"f":["small-8"],"r":"deviceIdAndPlanId.deviceId"}]},"f":[{"t":7,"e":"div","a":{"class":"text-right"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-small-bottom"},"f":["Plan"]}],"n":50,"x":{"r":["planGroupName"],"s":"_0!==\"IPPPLANS\""}}," ",{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyCharges"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":["Monthly"]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"plan-details-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"plan-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"data.quantity"},{"t":4,"f":[{"t":2,"r":"data.unit"}],"n":50,"x":{"r":["data.quantity"],"s":"_0!==\"Unlimited\""}}]}," Data",{"t":4,"f":["*"],"n":50,"r":"dataDisclaimer"}],"n":50,"x":{"r":["data.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," ",{"t":4,"f":["+"],"n":50,"x":{"r":["wifiData.quantity","data.quantity"],"s":"_1&&_0&&(_0>0||_0===\"Unlimited\")&&_1>0"}}," ",{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"wifiData.quantity"},{"t":2,"r":"wifiData.unit"}]}," Singtel WiFi"],"n":50,"x":{"r":["wifiData.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"plan-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"talktime.quantity"},{"t":2,"r":"talktime.unit"}]}," Talktime",{"t":4,"f":["*"],"n":50,"r":"minsDisclaimer"}],"n":50,"x":{"r":["talktime.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," + ",{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"sms.quantity"}]}," SMS",{"t":4,"f":["*"],"n":50,"r":"smsDisclaimer"}],"n":50,"x":{"r":["sms.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}]}]}],"n":50,"x":{"r":["mobileplan","planGroupName"],"s":"_0||_1===\"IPPPLANS\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"plan-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"li","f":[{"t":3,"r":"planDescSubLiner"}]}]}]}],"n":50,"r":"planDescSubLiner"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top plan-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-7"},"f":["Device Top Up"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyDeviceTopup"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"n":50,"x":{"r":["groupType","deviceIdAndPlanId.deviceId"],"s":"_0==\"mobileBroadbandPlan\"&&_1"}}]}]}]}," ",{"t":4,"f":[],"n":50,"r":"banner"}],"n":52,"i":"i","r":"./plans"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large-top text-left"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom fine-print"},"f":[{"t":3,"r":"finePrint"}]}]}],"n":50,"r":"finePrint"}]}]}]};
this["ux-port-in-number"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-port-in-number"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12"},"f":[{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":3,"r":"initData.numberSelectOption.1.sectionDesc"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"number-porting-panel"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Mobile Number"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 medium-4 large-3 field-start"},"f":[{"t":7,"e":"div","a":{"class":"input-field"},"f":[{"t":7,"e":"ux-input-box","a":{"value":[{"t":2,"r":"mobileNumber"}],"onblurEvent":"checkPhoneValidation","validity":[{"t":2,"r":"phoneVal.phoneValErrorMsg"}],"maxLength":"8"},"f":[]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 medium-4 large-3 end"},"f":[{"t":7,"e":"ux-button","a":{"class":"button round light confirm","onclick":"checkNumber"},"f":["Confirm"]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"portinError"}]},"f":[]}]}]}],"n":50,"r":"portinError"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"porting-info v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":7,"e":"div","a":{"class":"body text-justify v-medium-bottom"},"f":[{"t":3,"r":"initData.numberSelectOption.1.portinInfo"}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"text-link","ontap":"portinInfo"},"f":[{"t":3,"r":"initData.numberSelectOption.1.portinInfoLink"}]}]}]}],"n":50,"x":{"r":["isGomoFlow","isPrepaidFlow"],"s":"!_0&&!_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"porting-info v-normal-top"},"f":[{"t":7,"e":"ux-worry-free","a":{"parentRactiveWidget":[{"t":2,"x":{"r":["getRactiveWidget"],"s":"_0()"}}],"initData":[{"t":2,"r":"selectedWFInitData"}],"isGomoFlow":[{"t":2,"r":"isGomoFlow"}],"isPrepaidFlow":[{"t":2,"r":"isPrepaidFlow"}],"worryFreeTopic":[{"t":3,"r":"worryFreeTopic"}],"contactNumber":[{"t":2,"r":"phoneVal.phoneVal"}]},"f":[]}]}],"n":50,"x":{"r":["isGomoFlow","isPrepaidFlow"],"s":"_0||_1"}}]}]};
this["ux-premium-addons"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-premium-addons"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["v-normal-top"],"n":50,"r":"isAccessory"}," alignPanel show-for-medium-up"]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 ",{"t":4,"f":["medium-3"],"n":50,"r":"isAccessory"},{"t":4,"n":51,"f":["medium-4"],"r":"isAccessory"}," column-control v-normal-bottom"]},"f":[{"t":7,"e":"div","a":{"class":"panel addon-select-box text-center"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel"}],"n":50,"r":"ribbon"}," ",{"t":7,"e":"ux-image","a":{"class":"v-large-top","src":[{"t":3,"r":"smallImage.src"}],"alt":[{"t":3,"r":"smallImage.alt"}]}}," ",{"t":7,"e":"ux-header","a":{"level":"2","class":"product-title"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"color-selection v-large-top"},"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"color-dot","style":["background: ",{"t":2,"r":"hexCode"}]}}],"n":52,"i":"i","r":"colorVariants"}]}]}," ",{"t":7,"e":"div","a":{"class":"subscript-text v-medium-top"},"f":[{"t":4,"f":[{"t":2,"r":"fromLabel"}],"n":50,"r":"isAccessory"},{"t":4,"n":51,"f":[{"t":2,"r":"label"}],"r":"isAccessory"}]}," ",{"t":7,"e":"ux-header","a":{"level":"2","class":"main-dollar"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","minOnetimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"isAccessory"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["RactiveHelpers","tempPaymentOptions.monthlyTopup"],"s":"_0.convertUnits(_1,\"$\")"}}],"r":"isAccessory"}]}," ",{"t":7,"e":"ux-row","a":{"class":"prices"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-12"},"f":[{"t":7,"e":"span","a":{"class":"strike-through-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","usualPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}],"n":50,"x":{"r":["isAccessory","usualPrice","minOnetimePrice"],"s":"_0&&_1&&_1>_2"}}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":4,"f":[{"t":2,"r":"oneTimeCostLabel"}],"n":50,"r":"isAccessory"},{"t":4,"n":51,"f":["monthly ",{"t":4,"f":["or ",{"t":2,"x":{"r":["RactiveHelpers","tempPaymentOptions.onetimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}," one time"],"n":50,"x":{"r":["tempPaymentOptions.onetimePrice"],"s":"_0>0"}}],"r":"isAccessory"}]}]}," ",{"t":7,"e":"ux-button","a":{"selectedIndex":[{"t":2,"r":"index"}],"class":"add-btn light round v-normal-top v-normal-bottom","onclick":"doSelectAddon","text":[{"t":4,"f":["Remove"],"n":50,"r":"isRemove"},{"t":4,"n":51,"f":["Add"],"r":"isRemove"}]}}]}]}],"n":50,"r":"display"}],"i":"index","r":"addons"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"class":"show-more-phones","text":"Show More","onclick":"viewMore"}}]}],"n":50,"r":"initData.showButton"}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["round v-normal-top right v-large-right ",{"t":2,"r":"disabledCart"}],"onclick":"proceedToCart"},"f":["Proceed to Cart"]}]}],"n":50,"x":{"r":["isAccessory","isrecommended"],"s":"_0&&!_1"}}]}],"n":50,"x":{"r":["isrecommended"],"s":"!_0"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"combo-panel"},"f":[{"t":7,"e":"div","a":{"class":"swiper-container addon-select-box boxPanel v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"swiper-wrapper combo-list"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["swiper-slide ",{"t":4,"f":["swiper-slide-end"],"n":50,"r":"swipeMarginClass"}]},"f":[{"t":7,"e":"ux-panel","a":{"class":"combo-item"},"f":[{"t":7,"e":"ux-row","a":{"class":"combo-plan text-center small-12"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel"}],"r":"ribbon"}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 v-medium-top"},"f":[{"t":7,"e":"ux-image","a":{"class":"v-normal-top","src":[{"t":3,"r":"smallImage.src"}],"alt":[{"t":3,"r":"smallImage.alt"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 v-large-top v-large-bottom v-none-padding-left"},"f":[{"t":7,"e":"div","a":{"class":"product-title v-large-top v-large-bottom"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"color-selection"},"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"color-dot","style":["background: ",{"t":2,"r":"hexCode"}]}}],"n":52,"i":"i","r":"colorVariants"}]}]}," ",{"t":7,"e":"div","a":{"class":"subscript-text v-medium-top"},"f":[{"t":2,"r":"fromLabel"}]}," ",{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","minOnetimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"r":"oneTimeCostLabel"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 text-center select-phones-buttons-wrapper"},"f":[{"t":7,"e":"ux-button","a":{"selectedIndex":[{"t":2,"r":"index"}],"class":"add-btn light round","onclick":"doSelectAddon","text":[{"t":4,"f":["Remove"],"n":50,"r":"isRemove"},{"t":4,"n":51,"f":["Add"],"r":"isRemove"}]}}]}]}]}]}],"n":50,"r":"display"}],"i":"index","r":"addons"}]}," ",{"t":7,"e":"div","a":{"class":"swiper-button-prev"},"f":[{"t":7,"e":"ux-icon","a":{"type":"carousel-prev","size":"l"}}]}," ",{"t":7,"e":"div","a":{"class":"swiper-button-next"},"f":[{"t":7,"e":"ux-icon","a":{"type":"carousel-next","size":"l"}}]}]}]}]}],"n":50,"r":"isrecommended"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top show-for-small-only"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","a":{"class":"panel addon-select-box"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel"}],"r":"ribbon"}," ",{"t":7,"e":"ux-col","a":{"class":"small-5 v-medium-top"},"f":[{"t":7,"e":"ux-image","a":{"class":"v-normal-top v-normal-bottom","src":[{"t":3,"r":"smallImage.src"}],"alt":[{"t":3,"r":"smallImage.alt"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-7 v-large-top v-large-bottom v-none-padding-left"},"f":[{"t":7,"e":"div","a":{"class":"product-title v-normal-top v-large-bottom"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"color-selection"},"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"color-dot","style":["background: ",{"t":2,"r":"hexCode"}]}}],"n":52,"i":"i","r":"colorVariants"}]}]}," ",{"t":7,"e":"div","a":{"class":"subscript-text v-medium-top"},"f":[{"t":4,"f":[{"t":2,"r":"fromLabel"}],"n":50,"r":"isAccessory"},{"t":4,"n":51,"f":[{"t":2,"r":"label"}],"r":"isAccessory"}]}," ",{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","minOnetimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"isAccessory"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["RactiveHelpers","tempPaymentOptions.monthlyTopup"],"s":"_0.convertUnits(_1,\"$\")"}}],"r":"isAccessory"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"medium-12"},"f":[{"t":7,"e":"span","a":{"class":"strike-through-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","usualPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}],"n":50,"x":{"r":["isAccessory","usualPrice","minOnetimePrice"],"s":"_0&&_1&&_1>_2"}}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":4,"f":[{"t":2,"r":"oneTimeCostLabel"}],"n":50,"r":"isAccessory"},{"t":4,"n":51,"f":["monthly ",{"t":4,"f":["or ",{"t":2,"x":{"r":["RactiveHelpers","tempPaymentOptions.onetimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}," one time"],"n":50,"x":{"r":["tempPaymentOptions.onetimePrice"],"s":"_0>0"}}],"r":"isAccessory"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 text-center select-phones-buttons-wrapper"},"f":[{"t":7,"e":"ux-button","a":{"selectedIndex":[{"t":2,"r":"index"}],"class":"add-btn light round","onclick":"doSelectAddon","text":[{"t":4,"f":["Remove"],"n":50,"r":"isRemove"},{"t":4,"n":51,"f":["Add"],"r":"isRemove"}]}}]}]}]}]}],"n":50,"r":"display"}],"i":"index","r":"addons"}],"r":"isrecommended"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-small-only"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"class":"show-more-phones","text":"Show More","onclick":"viewMore"}}]}],"n":50,"r":"initData.showButton"}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["round v-normal-top right cart-button ",{"t":2,"r":"disabledCart"}],"onclick":"proceedToCart"},"f":["Proceed to Cart"]}]}]}],"n":50,"x":{"r":["isAccessory","isrecommended"],"s":"_0&&!_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-modal","a":{"width":"900","class":"light-theme select-addons-modal","hideTitle":"true","modalId":"selectAddonModal"},"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"title"}]}]}],"n":50,"r":"title"}," ",{"t":7,"e":"div","a":{"class":"section-details clearfix v-normal-top"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"smallImage.src"}],"alt":[{"t":3,"r":"smallImage.alt"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-8 color-size-panel"},"f":[{"t":7,"e":"p","f":[{"t":3,"r":"description"}]}," ",{"t":7,"e":"ux-productvariant-container","a":{"hideStock":"hide","title":"Choose A Color"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["accessory-color-option v-small-top v-normal-bottom v-normal-right ",{"t":2,"rx":{"r":"selectedColor","m":[{"t":30,"n":"option"}]}}," ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["handleAvailStatus","stockStatus"],"s":"(_0)&&(_1===\"Not available\")"}}]},"v":{"tap":{"n":"doSelectColor","d":[{"t":2,"r":"option"}]}},"f":[{"t":7,"e":"div","a":{"class":"color-icon","style":["background-color:",{"t":2,"r":"hexCode"},";"]}}," ",{"t":7,"e":"div","a":{"class":"text-center body-light"},"f":[{"t":2,"r":"name"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"no-stock-line"}}," ",{"t":7,"e":"div","a":{"class":"no-stock-text v-normal-bottom body-light text-center"},"f":[{"t":2,"r":"stockStatus"}]}],"n":50,"x":{"r":["handleAvailStatus","stockStatus"],"s":"_0&&(_1===\"Not available\")"}}]}],"n":52,"i":"option","r":"colors"}],"n":50,"r":"isAccessory"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["color-option v-normal-bottom v-normal-right ",{"t":2,"rx":{"r":"selectedColor","m":[{"t":30,"n":"option"}]}}]},"v":{"tap":{"n":"doSelectColor","d":[{"t":2,"r":"option"}]}},"f":[{"t":7,"e":"div","a":{"class":"color-icon","style":["background-color:",{"t":2,"r":"hexCode"},";"]}}," ",{"t":7,"e":"div","a":{"class":"text-center body-light"},"f":[{"t":2,"r":"name"}]}]}],"n":52,"i":"option","r":"variants"}],"r":"isAccessory"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-productvariant-container","a":{"hideStock":"hide","title":"Choose A Size"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["size-option v-normal-bottom v-normal-right ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["stockStatus"],"s":"_0===\"Not available\""}}," ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["enableCapacity"],"s":"!_0"}}," ",{"t":2,"rx":{"r":"selectedSize","m":[{"t":30,"n":"option"}]}}]},"v":{"tap":{"n":"doSelectSize","d":[{"t":2,"r":"option"}]}},"f":[{"t":7,"e":"div","a":{"class":"size-text-display text-center"},"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"ux-crop-text","a":{"text":[{"t":2,"r":"size"}],"desktopChars":[{"t":2,"r":"cropTextConfig.desktopChars"}],"tabletChars":[{"t":2,"r":"cropTextConfig.tabletChars"}],"mobileChars":[{"t":2,"r":"cropTextConfig.mobileChars"}],"showComplete":[{"t":2,"r":"viewMore"}],"elipses":"..."},"f":[]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 width-percent-90 tooltip-padding20 fine-print-text-fix-white"},"f":[{"t":2,"r":"size"}]}]}]}]}," ",{"t":7,"e":"span","a":{"class":"text-right body-light"},"f":[{"t":2,"r":"unit"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"no-stock-line"}}," ",{"t":7,"e":"div","a":{"class":"no-stock-text v-small-top body-light text-center"},"f":[{"t":2,"r":"stockStatus"}]}],"n":50,"x":{"r":["colorSelected","stockStatus"],"s":"_0&&(_1===\"Not available\")"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"text-center"},"f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":[],"s":"false"}}]}],"n":50,"r":"addonVariants"}],"n":52,"i":"option","r":"addonVariants"}]}],"n":50,"r":"configurationNeeded"}],"n":50,"r":"isAccessory"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-productvariant-container","a":{"hideStock":"hide","title":"Choose a Payment option"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["payment-option v-normal-bottom v-normal-right ",{"t":2,"r":"selectedPayment.onetimePrice"}]},"v":{"tap":{"n":"doSelectPaymentOption","a":"onetimePrice"}},"m":[{"t":2,"x":{"r":["getColorState"],"s":"_0()"}}],"f":[{"t":7,"e":"div","a":{"class":"text-size text-center"},"f":[{"t":2,"x":{"r":["RactiveHelpers","paymentOptions.onetimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"text-center body-light"},"f":[{"t":2,"r":"paymentOptions.onetimeLabel"}]}]}],"n":50,"x":{"r":["paymentOptions.onetimePrice"],"s":"_0>0"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["payment-option v-normal-bottom v-normal-right ",{"t":2,"r":"selectedPayment.monthlyTopup"}]},"v":{"tap":{"n":"doSelectPaymentOption","a":"monthlyTopup"}},"f":[{"t":7,"e":"div","a":{"class":"text-size text-center"},"f":[{"t":2,"x":{"r":["RactiveHelpers","paymentOptions.monthlyTopup"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"text-center body-light"},"f":[{"t":2,"r":"paymentOptions.monthlyLabel"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"text-center body-light"},"f":["+"]}," ",{"t":7,"e":"div","a":{"class":"text-size text-center"},"f":[{"t":2,"x":{"r":["RactiveHelpers","paymentOptions.partialUpfrontAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"text-center body-light"},"f":[{"t":2,"r":"paymentOptions.onetimeLabel"}]}],"n":50,"x":{"r":["paymentOptions.partialUpfrontAmount"],"s":"_0&&_0>0"}}]}],"n":50,"x":{"r":["paymentOptions.monthlyTopup"],"s":"_0>0"}}],"n":50,"r":"paymentOptions"}]}],"r":"isAccessory"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":"You have already added the maximum number of accessories in your cart."},"f":[]}]}]}],"n":50,"r":"maxAccessories"}],"n":50,"r":"isAccessory"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["medium-offset-4 ",{"t":4,"f":["medium-5"],"n":50,"x":{"r":["orignalPrice","accessoryPrice"],"s":"_0&&_0>_1"}},{"t":4,"n":51,"f":["medium-4"],"x":{"r":["orignalPrice","accessoryPrice"],"s":"_0&&_0>_1"}}," v-large-top"]},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-dollar"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"subscript-text v-medium-top"},"f":[{"t":2,"r":"fromLabel"}]}],"n":50,"x":{"r":["priceList.length","colorSelected"],"s":"_0>1&&!_1"}}," ",{"t":2,"x":{"r":["RactiveHelpers","accessoryPrice"],"s":"_0.convertUnits(_1,\"$\")"}}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-through-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","orignalPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["orignalPrice","accessoryPrice"],"s":"_0&&_0>_1"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-3"],"n":50,"x":{"r":["orignalPrice","accessoryPrice"],"s":"_0&&_0>_1"}},{"t":4,"n":51,"f":["medium-4"],"x":{"r":["orignalPrice","accessoryPrice"],"s":"_0&&_0>_1"}}]},"f":[{"t":7,"e":"ux-button","a":{"class":["round v-large-top ",{"t":4,"f":["right"],"n":50,"r":"isAccessory"}," ",{"t":2,"r":"disabledButton"}],"onclick":"doAddToCart"},"f":["Add to Cart"]}]}],"n":50,"r":"isAccessory"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["round v-large-top ",{"t":4,"f":["right"],"n":50,"r":"isAccessory"}," ",{"t":2,"r":"disabledButton"}],"onclick":"doAddToCart"},"f":["Add to Cart"]}]}],"r":"isAccessory"}]}]}]}],"r":"selectedAddon"}],"n":50,"r":"startAccessoryDisplay"}]}]};
this["ux-premium-product-catalog"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-premium-product-catalog"},"f":[{"t":7,"e":"ux-panel","a":{"class":["product-info p-medium-left p-medium-right v-medium-left v-medium-right ",{"t":4,"f":["selected-box"],"n":50,"x":{"r":["isProductSelected","selectedProductId","identifier"],"s":"_0||(_1===_2)"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"ribbonPosition":"right","ribbon":[{"t":2,"r":"ribbon"}],"class":"v-medium-left"}}],"n":50,"r":"ribbon"}," ",{"t":7,"e":"ux-row","a":{"class":"image-sec p-normal-bottom"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"image"}],"alt":[{"t":3,"r":"image"}],"class":"product-image text-center v-normal-top"},"f":[]}]}," ",{"t":7,"e":"ux-row","a":{"class":"text-center p-medium-top p-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"product-title"},"f":[{"t":2,"r":"title"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"text-center p-normal-bottom price-section"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"usual-price strikeout-text"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-through-dollar"},"f":["U.P. ",{"t":2,"x":{"r":["RactiveHelpers","usualPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["usualPrice","displayPrice"],"s":"_0&&parseInt(_0)>parseInt(_1)"}}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","displayPrice"],"s":"_0.convertUnits(_1,\"$\")"}},"/mth"]}]}],"n":50,"r":"displayPrice"}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","f":[{"t":2,"r":"contractPeriodText"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"select-variants flex-container flex-container-start"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["p-medium-left p-medium-right ",{"t":4,"f":["small-7"],"n":50,"x":{"r":["presentCapacities","presentCapacities.length"],"s":"_0&&_1>0"}}]},"f":[{"t":7,"e":"ux-select","a":{"id":"filter_variants","showSelectedValue":"true","options":[{"t":2,"r":"presentColors"}],"selected_value":[{"t":2,"r":"selectedColor"}],"onChangeEvent":"changedColor"},"f":[]}]}],"n":50,"x":{"r":["presentColors","presentColors.length"],"s":"_0&&_1>0"}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["p-medium-left p-medium-right ",{"t":4,"f":["small-5"],"n":50,"x":{"r":["presentColors","presentColors.length"],"s":"_0&&_1>0"}}]},"f":[{"t":7,"e":"ux-select","a":{"id":"filter_capacity","showSelectedValue":"true","options":[{"t":2,"r":"presentCapacities"}],"selected_value":[{"t":2,"r":"selectedSize"}],"onChangeEvent":"changedCapacity"},"f":[]}]}],"n":50,"x":{"r":["presentCapacities","presentCapacities.length"],"s":"_0&&_1>0"}}],"n":50,"r":"variants"}]}," ",{"t":7,"e":"ux-row","a":{"class":"text-center p-normal-top p-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"light round v-none-bottom","text":"Remove","onclick":"doProceed"}}],"n":50,"x":{"r":["isProductSelected","selectedProductId","identifier"],"s":"_0||(_1===_2)"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":"light round v-none-bottom","text":"Add","onclick":"doProceedAhead"}}],"x":{"r":["isProductSelected","selectedProductId","identifier"],"s":"_0||(_1===_2)"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"p-normal-top"},"f":[{"t":7,"e":"ux-anchor","a":{"onclick":"showProductDetails"},"f":["Product Details"]}]}]}]}]}]};
this["ux-prestige-status"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-prestige-status v-normal-bottom"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"medium-offset-1 columns description-text overlay-top48"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"r":"prestigeMessage"}]}],"n":50,"x":{"r":["prestige"],"s":"_0===true"}}," ",{"t":7,"e":"div","a":{"class":"overlay-top10"},"f":[{"t":7,"e":"p","f":[{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"type":"circle-tick","size":"s"}}],"n":50,"r":"statusText"},"  ",{"t":2,"r":"statusText"}]}]}],"n":50,"r":"displayed"},{"t":4,"n":51,"f":[{"t":4,"f":["Sorry, we're unable to retrieve your information at this moment. Please try again later."],"n":50,"r":"urlInvalid"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-load-mask","f":[{"t":7,"e":"ux-load-mask","f":[]}]}],"r":"urlInvalid"}],"r":"displayed"}]}]}]}]}]}]};
this["ux-pricing-table"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-pricing-table"},"f":[" ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"phone-selector text-center swiper-container-phone v-normal-bottom"},"f":[{"t":7,"e":"ul","a":{"class":"swiper-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"swiper-slide swiper-no-swiping"},"f":[{"t":7,"e":"div","a":{"class":["phone-box ",{"t":4,"f":["panel"],"n":50,"r":"selected"}]},"v":{"click":{"n":"selectItem","d":[{"t":2,"r":"num"}]}},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"corner-ribbon right"},"f":[{"t":7,"e":"div","a":{"class":"checkmark"}}]}],"n":50,"r":"selected"}," ",{"t":7,"e":"ux-image","a":{"class":"phone-image","src":[{"t":2,"r":"phoneImageSrc"}],"alt":[{"t":2,"r":"phoneImageAlt"}]}}," ",{"t":7,"e":"span","a":{"class":[{"t":4,"f":["subsection-header"],"n":50,"r":"selected"}]},"f":[{"t":2,"r":"model"}]}]}]}],"n":52,"i":"num","r":"phoneModels"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"phone-selector text-center v-normal-bottom"},"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"div","v":{"click":{"n":"selectItem","d":[{"t":2,"r":"num"}]}},"a":{"class":["phone-box ",{"t":4,"f":["panel"],"n":50,"r":"selected"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"corner-ribbon right"},"f":[{"t":7,"e":"div","a":{"class":"checkmark"}}]}],"n":50,"r":"selected"}," ",{"t":7,"e":"ux-image","a":{"class":"phone-image","src":[{"t":2,"r":"phoneImageSrc"}],"alt":[{"t":2,"r":"phoneImageAlt"}]}}," ",{"t":7,"e":"span","a":{"class":[{"t":4,"f":["subsection-header"],"n":50,"r":"selected"}]},"f":[{"t":2,"r":"model"}]}]}]}],"n":52,"i":"num","r":"phoneModels"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"combo-panel"},"f":[{"t":7,"e":"ux-panel","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-row","a":{"class":"combo-list"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"combo-item col5-unit"},"f":[{"t":7,"e":"ux-row","a":{"class":"combo-plan text-center small-12"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","a":{"class":"plan-details"},"f":[{"t":7,"e":"ux-col","a":{"class":"subsection-header v-large-top v-large-bottom"},"f":[{"t":2,"r":"name"}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"data"}]}," Data"]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"mins"}]}," Mins",{"t":4,"f":["*"],"n":50,"x":{"r":["mins"],"s":"_0===\"Infinite\""}}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"sms"}]}," SMS",{"t":4,"f":["*"],"n":50,"x":{"r":["mins"],"s":"_0===\"Infinite\""}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"strong","f":["Additional Benefits"]}]}," ",{"t":7,"e":"ux-col","f":[{"t":2,"r":"others"}]}],"n":50,"r":"others"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"span","a":{"class":"left"},"f":["Monthly"]}," ",{"t":7,"e":"span","a":{"class":"right"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyPricing"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"panel-divider v-normal-top"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"model"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","a":{"class":"left"},"f":[{"t":2,"r":"capacity"}]}," ",{"t":7,"e":"span","a":{"class":"right"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}]}],"r":"variants"}]}],"n":50,"r":"phoneSelected"}],"r":"phones"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"ux-button","a":{"class":"round light center small-only-expand","href":[{"t":2,"r":"buttoLink"}],"text":[{"t":2,"r":"buttonText"}]},"f":[]}]}],"n":50,"r":"buttonShow"}]}]}],"r":"comboPlans"}]}]}," ",{"t":7,"e":"ux-panel","a":{"class":"swiper-container show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"swiper-wrapper combo-list"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"combo-item swiper-slide col5-unit"},"f":[{"t":7,"e":"ux-row","a":{"class":"combo-plan text-center small-12"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","a":{"class":"plan-details"},"f":[{"t":7,"e":"ux-col","a":{"class":"subsection-header v-large-top v-large-bottom"},"f":[{"t":2,"r":"name"}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"data"}]}," Data"]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"mins"}]}," Mins",{"t":4,"f":["*"],"n":50,"x":{"r":["mins"],"s":"_0===\"Infinite\""}}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"sms"}]}," SMS",{"t":4,"f":["*"],"n":50,"x":{"r":["mins"],"s":"_0===\"Infinite\""}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"strong","f":["Additional Benefits"]}]}," ",{"t":7,"e":"ux-col","f":[{"t":2,"r":"others"}]}],"n":50,"r":"others"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"span","a":{"class":"left"},"f":["Monthly"]}," ",{"t":7,"e":"span","a":{"class":"right"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyPricing"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"panel-divider v-normal-top"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"model"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"left"},"f":[{"t":2,"r":"capacity"}]}," ",{"t":7,"e":"span","a":{"class":"right"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}],"r":"variants"}]}],"n":50,"r":"phoneSelected"}],"r":"phones"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"ux-button","a":{"class":"round light center small-only-expand","href":[{"t":2,"r":"buttonLink"}],"text":[{"t":2,"r":"buttonText"}]},"f":[]}]}],"n":50,"r":"buttonShow"}]}]}],"r":"comboPlans"}]}," ",{"t":7,"e":"div","a":{"class":"swiper-button-prev"},"f":[{"t":7,"e":"ux-icon","a":{"type":"carousel-prev","size":"l"}}]}," ",{"t":7,"e":"div","a":{"class":"swiper-button-next"},"f":[{"t":7,"e":"ux-icon","a":{"type":"carousel-next","size":"l"}}]}]}," ",{"t":7,"e":"ux-col","f":[]}]}]}]}]}]}]};
this["ux-product-catalog"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-product-catalog"},"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"v-none-padding v-none-left v-none-right clearfix"},"f":[{"t":7,"e":"div","a":{"class":"inner-wrapper","style":[{"t":4,"f":["padding-top: 0px;"],"n":50,"x":{"r":["productImage.src","imagePath"],"s":"_0||_1"}},{"t":4,"n":51,"f":[{"t":4,"f":["padding-top: ",{"t":2,"r":"imagePaddingTop"},"px;"],"n":50,"x":{"r":["imagePaddingTop"],"s":"_0&&_0>0"}},{"t":4,"n":51,"f":["padding-top: 20px;"],"x":{"r":["imagePaddingTop"],"s":"_0&&_0>0"}}],"x":{"r":["productImage.src","imagePath"],"s":"_0||_1"}}," ",{"t":4,"f":["padding-bottom: ",{"t":2,"r":"paddingBottom"},"px;"],"n":50,"x":{"r":["paddingBottom"],"s":"_0>=0"}},{"t":4,"n":51,"f":["padding-bottom: 20px;"],"x":{"r":["paddingBottom"],"s":"_0>=0"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"catalog-image-wrapper","style":[{"t":4,"f":["padding-bottom: ",{"t":2,"r":"imagePaddingBottom"},"px;"],"n":50,"x":{"r":["imagePaddingBottom"],"s":"_0>=0"}},{"t":4,"n":51,"f":["padding-bottom: 20px;"],"x":{"r":["imagePaddingBottom"],"s":"_0>=0"}}," ",{"t":4,"f":["padding-top: ",{"t":2,"r":"imagePaddingTop"},"px;"],"n":50,"x":{"r":["imagePaddingTop"],"s":"_0>=0"}},{"t":4,"n":51,"f":["padding-top: 0;"],"x":{"r":["imagePaddingTop"],"s":"_0>=0"}}," ",{"t":4,"f":["background-color: ",{"t":2,"r":"imageBgColor"},";"],"n":50,"r":"imageBgColor"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-image","a":{"img":[{"t":2,"r":"productImage"}],"class":"pack-image text-center"}}]}],"n":50,"x":{"r":["phoneColors"],"s":"!_0"}}],"n":50,"r":"productImage.src"}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-image","a":{"class":"handset-img","img":[{"t":2,"r":"imagePath"}]}}," ",{"t":7,"e":"div","f":[]}]}],"n":50,"r":"imagePath"}]}],"n":50,"x":{"r":["productImage.src","imagePath"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"ribbon":[{"t":2,"r":"ribbon"}]}}],"n":50,"r":"ribbon"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal-top v-normal-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["text-center product-title v-medium-left v-medium-right ",{"t":4,"f":["v-medium-top"],"n":50,"x":{"r":["ribbon","phoneColors","productImage.src"],"s":"_0&&!_1&&!_2"}},{"t":4,"f":[" v-small-bottom"],"n":50,"r":"productDesc"}]},"f":[{"t":3,"r":"productTitle"}]}],"n":50,"r":"productTitle"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-text"},"f":[{"t":3,"r":"productDesc"}]}],"n":50,"r":"productDesc"}]}],"n":50,"x":{"r":["productTitle","productDesc"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal-top v-normal-bottom picker-container"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["select-color ",{"t":2,"r":"name"}],"style":["background: ",{"t":2,"r":"hexCode"}]},"v":{"tap":"colorSelect"}}],"n":52,"r":"phoneColors"}]}],"n":50,"x":{"r":["phoneColors","phoneColors.length"],"s":"_0&&_1>0"}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal-top v-normal-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subscript-text v-small-bottom"},"f":[{"t":2,"r":"supportingTextOne"}]}],"n":50,"r":"supportingTextOne"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"main-dollar v-small-top"},"f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["price"],"s":"typeof _0!==\"undefined\"&&typeof _0!==null&&typeof _0!==\"\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":2,"r":"supportingTextTwo"}]}],"n":50,"r":"supportingTextTwo"}]}],"n":50,"x":{"r":["supportingTextOne","price","supportingTextTwo"],"s":"_0||_1||_2"}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal-top v-normal-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"light round","text":[{"t":2,"r":"ctaLabel"}],"linkto":[{"t":2,"r":"ctaUrl"}],"onclick":"navigateToURL"}}],"n":50,"r":"isButton"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"ctaUrl"}]},"f":[{"t":2,"r":"ctaLabel"}]}],"r":"isButton"}]}],"n":50,"r":"ctaLabel"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-col","a":{"class":"notes-box v-normal-top v-normal-bottom text-left"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"notesTitle"}]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":3,"r":"notesDesc"}]}]}],"n":50,"r":"notesTitle"}]}]}],"n":50,"r":"isDataModel"}]}]};
this["ux-product-header"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-product-header ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}," ",{"t":4,"f":["v-",{"t":2,"r":"bottomSpacing"},"-bottom"],"n":50,"r":"bottomSpacing"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"subsection-header promotion-header"},"f":[{"t":2,"r":"ribbon"}]}]}],"r":"ribbon"}," ",{"t":7,"e":"div","a":{"class":"main-header"},"f":[{"t":2,"r":"header.productTitle"}]}," "]}]};
this["ux-productvariant-container"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-productvariant-container"},"f":[{"t":7,"e":"div","a":{"class":"phone-selection choose-color-panel clearfix"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header left v-normal-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":["stock-warning text-link ",{"t":2,"r":"hideStock"}," left v-normal-top"],"ontap":"doOpenModal:phoneStockInfo"},"f":["Check stock availability for all variants +"]}],"n":50,"x":{"r":["isRoi"],"s":"!_0"}}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":["subsection-header left v-normal-top ",{"t":4,"f":["v-medium-bottom"],"n":50,"x":{"r":["hideStock"],"s":"_0===\"hide\""}}]},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-anchor","a":{"class":["stock-warning text-link ",{"t":2,"r":"hideStock"}," left v-medium-bottom"],"ontap":"doOpenModal:phoneStockInfo"},"f":["Check stock availability for all variants +"]}]}]}],"n":50,"x":{"r":["isRoi"],"s":"!_0"}}]}," ",{"t":7,"e":"div"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":[{"t":2,"r":"hidePlanDesc"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"plan-liner"},"f":[{"t":7,"e":"span","f":["Phone prices shown are with "]},{"t":7,"e":"span","a":{"class":"subsection-title"},"f":[{"t":2,"r":"deviceIdAndPlanId.ippPlanName"}," and Device Instalment Plan (",{"t":2,"r":"deviceIdAndPlanId.installmentDuration"}," months, interest-free)"]}," ",{"t":7,"e":"span","a":{"class":"new-liner"},"f":["NEW"]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"doOpenModal:ippPlanInfo"},"f":[{"t":7,"e":"span","a":{"class":"icon-btn show-tooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}]}]}],"n":50,"x":{"r":["deviceIdAndPlanId.isIppPlan","deviceIdAndPlanId.ippPlanName"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","f":["Device prices shown are with ",{"t":2,"r":"deviceIdAndPlanId.comboPlan"}]}]}],"n":50,"r":"deviceIdAndPlanId.comboPlan"}],"x":{"r":["deviceIdAndPlanId.isIppPlan","deviceIdAndPlanId.ippPlanName"],"s":"_0&&_1"}}]}],"n":50,"x":{"r":["deviceIdAndPlanId","deviceIdAndPlanId.planId","deviceIdAndPlanId.isNewPP"],"s":"_0&&(typeof _1===undefined||_1===null)||_2"}}," ",{"t":7,"e":"div"}," ",{"t":7,"e":"div","a":{"class":"phone-options"},"f":[{"t":8,"r":"content"}]}]}]}]};
this["ux-promo-container"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-promo-container v-large-top v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"phone-promotions-container clearfix"},"f":[{"t":8,"r":"content"}]}]}]};
this["ux-promo-recommendation"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-promo-recommendation paddingTop"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-anchor","a":{"onclick":[{"t":2,"x":{"r":["bannerType"],"s":"_0===\"INSURANCE\"?\"openFindMoreLink\":\"\""}}]},"f":[{"t":7,"e":"div","a":{"class":"background","style":["background-image: url('",{"t":3,"r":"desktopBackgroundImage.src"},"')"]},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 left"},"f":[{"t":7,"e":"div","a":{"class":"badges-text v-small-bottom v-small-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"large-body-text"},"f":[{"t":2,"r":"description"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"onclick":"openFindMoreLink","ariaLabel":"Open in a new browser tab","target":"_blank"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"x":{"r":["bannerType","openNewWindow"],"s":"_0===\"INSURANCE\"&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["openNewWindow"],"s":"_0"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}],"ariaLabel":"Open in a new browser tab","target":"_blank"},"f":[{"t":2,"r":"linkText"}]}]},{"t":4,"n":50,"x":{"r":["openNewWindow"],"s":"!(_0)"},"f":[" ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}],"target":"_self"},"f":[{"t":2,"r":"linkText"}]}]}],"x":{"r":["bannerType","openNewWindow"],"s":"_0===\"INSURANCE\"&&_1"}}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-panel","a":{"class":"margin-zero"},"f":[{"t":7,"e":"ux-anchor","a":{"onclick":[{"t":2,"x":{"r":["bannerType"],"s":"_0===\"INSURANCE\"?\"openFindMoreLink\":\"\""}}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"badges-text v-small-bottom v-normal-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"large-body-text"},"f":[{"t":2,"r":"description"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"onclick":"openFindMoreLink","ariaLabel":"Open in a new browser tab","target":"_blank"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"x":{"r":["bannerType","openNewWindow"],"s":"_0===\"INSURANCE\"&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["openNewWindow"],"s":"_0"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}],"ariaLabel":"Open in a new browser tab","target":"_blank"},"f":[{"t":2,"r":"linkText"}]}]},{"t":4,"n":50,"x":{"r":["openNewWindow"],"s":"!(_0)"},"f":[" ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}],"target":"_self"},"f":[{"t":2,"r":"linkText"}]}]}],"x":{"r":["bannerType","openNewWindow"],"s":"_0===\"INSURANCE\"&&_1"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-none-padding"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"mobileForegroundImage.src"}],"alt":[{"t":3,"r":"mobileForegroundImage.alt"}]}}]}]}]}]}]}]}]};
this["ux-promo-rewards"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-promo-rewards"},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"div","a":{"class":[{"t":2,"r":"theme"}," background"],"style":["background-image: url('",{"t":3,"r":"backgroundImage.src"},"'); background-position: right"]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-10 left"},"f":[{"t":7,"e":"div","a":{"class":"badges-text v-small-bottom v-small-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-large-up"},"f":[{"t":7,"e":"div","a":{"class":"large-body-text"},"f":[{"t":2,"r":"description"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}],"ariaLabel":"Open in a new browser tab","target":"_blank"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"openNewWindow"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}]},"f":[{"t":2,"r":"linkText"}]}],"r":"openNewWindow"}]}]}," ",{"t":7,"e":"div","a":{"class":"hide-for-large-up"},"f":[{"t":7,"e":"div","a":{"class":"large-body-text"},"f":[{"t":2,"r":"description"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}],"ariaLabel":"Open in a new browser tab","target":"_blank"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"openNewWindow"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}]},"f":[{"t":2,"r":"linkText"}]}],"r":"openNewWindow"}]}]}]}]}]}]}]};
this["ux-promobox-title"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-promobox-title"},"f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":[{"t":2,"r":"promotions.title"}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"login-for-promo-msg","href":[{"t":2,"r":"promotions.link"}]},"f":[{"t":2,"r":"promotions.text"}]}]}]};
this["ux-quantity-alteration"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-quantity-alteration"},"f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-start"},"f":[{"t":7,"e":"span","a":{"class":["flex-item border-box rounded-border ",{"t":2,"x":{"r":["isIppEligible","isEnabled","ippEnabled","selectedTerm","enableAddButton","isShoppingCart"],"s":"((_1&&(_2&&_0&&_3===\"0\")||_5)||(_1&&(!_2&&!_3&&_4||_5)))?\"pointer\":\"disabled\""}}," ",{"t":2,"x":{"r":["selectedQty","minValue","selectedTerm"],"s":"(_0<=_1||_2>0)?\"disabled\":\"\""}}],"style":[{"t":2,"x":{"r":["selectedTerm"],"s":"_0>0?\"pointer-events: none;\":\"\""}}]},"v":{"tap":"decrement"},"f":[{"t":7,"e":"ux-icon","a":{"class":"v-small-left","type":"minus","size":"s"},"f":["-"]}]}," ",{"t":7,"e":"span","a":{"class":"flex-item text-center v-normal-left v-normal-right p-small"},"f":[{"t":2,"r":"selectedQty"}]}," ",{"t":7,"e":"span","a":{"class":["flex-item border-box rounded-border ",{"t":2,"x":{"r":["isIppEligible","isEnabled","ippEnabled","selectedTerm","enableAddButton","isShoppingCart"],"s":"((_1&&(_2&&_0&&_3===\"0\")||_5)||(_1&&(!_2&&!_3&&_4||_5)))?\"pointer\":\"disabled\""}}," ",{"t":2,"x":{"r":["selectedQty","maxValue","selectedTerm"],"s":"(_0>=_1||_2>0)?\"disabled\":\"\""}}],"style":[{"t":2,"x":{"r":["selectedTerm"],"s":"_0>0?\"pointer-events: none;\":\"\""}}]},"v":{"tap":"increment"},"f":[{"t":7,"e":"ux-icon","a":{"class":"v-small-left","type":"plus","size":"s"},"f":["+"]}]}]}]}]};
this["ux-quicklink-list"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-quicklink-list clearfix"},"f":[{"t":7,"e":"div","a":{"class":"quick-links"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":4,"f":[{"t":7,"e":"ux-quicklink","a":{"datamodel":[{"t":2,"r":"."}]}}],"r":"quicklinks"}]}]}," ",{"t":7,"e":"div","a":{"class":"swiper-container show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"text-center swiper-wrapper"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"swiper-slide quick-link"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"iconLink"}],"target":[{"t":2,"r":"openNewWindow"}]},"f":[{"t":7,"e":"div","a":{"class":"quick-link v-medium-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"icon-block"},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"iconClass"}],"size":[{"t":2,"r":"size"}],"color":[{"t":2,"r":"color"}]}}]}],"n":50,"r":"iconClass"}," ",{"t":7,"e":"div","a":{"class":"link-text"},"f":[{"t":2,"r":"title"}]}]}]}]}],"n":50,"x":{"r":["hideOnMobile"],"s":"!_0"}}],"r":"quicklinks"}]}," "]}]}]}]};
this["ux-quicklink"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-quicklink"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"quick-link v-medium-bottom clearfix"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"iconLink"}],"target":[{"t":2,"r":"openNewWindow"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"iconClass"}],"size":[{"t":2,"r":"size"}]}}]}],"n":50,"r":"iconClass"}," ",{"t":7,"e":"div","a":{"class":"link-text"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"title"}," ",{"t":4,"f":[{"t":7,"e":"span","f":[{"t":2,"r":"label"}]}],"n":50,"r":"label"}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"share-text"},"f":[{"t":2,"r":"shareScreenInformation"}]}],"n":50,"r":"shareScreenInformation"}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-radio-button"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-radio-button ",{"t":2,"r":"class"}," ",{"t":2,"r":"validity.status"}]},"f":[{"t":7,"e":"div","a":{"class":["btn ",{"t":2,"r":"style"},{"t":4,"f":[" checked"],"n":50,"x":{"r":["selected","value"],"s":"_0===_1"}}]},"v":{"click":"clickHandler","blur":"blurHandler","change":"changeHandler"},"f":[{"t":4,"f":[{"t":7,"e":"label","a":{"for":[{"t":2,"r":"btn_id"}]},"f":[{"t":2,"r":"label"}," ",{"t":7,"e":"input","a":{"type":"radio","id":[{"t":2,"r":"btn_id"}],"value":[{"t":2,"r":"value"}],"name":[{"t":3,"r":"name"}]},"m":[{"t":4,"f":["disabled"],"n":50,"r":"disabled"}]}," ",{"t":8,"r":"content"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"aria-live":"assertive","class":"error-message"},"f":[{"t":2,"r":"message"}]}],"r":"validity"}]}],"n":50,"r":"use_content"},{"t":4,"n":51,"f":[{"t":7,"e":"input","a":{"type":"radio","id":[{"t":2,"r":"btn_id"}],"value":[{"t":2,"r":"value"}],"name":[{"t":3,"r":"name"}]},"m":[{"t":4,"f":["disabled"],"n":50,"r":"disabled"}]}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"btn_id"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"item"},"f":[{"t":3,"r":"."}]}],"r":"labels"}],"n":50,"r":"labels"},{"t":4,"n":51,"f":[{"t":2,"r":"label"}],"r":"labels"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"aria-live":"assertive","class":"error-message"},"f":[{"t":2,"r":"message"}]}],"r":"validity"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":[{"t":2,"r":"link.clickEvent"}],"params":[{"t":2,"r":"link.params"}]},"f":[{"t":2,"r":"link.text"}]}],"r":"link"}],"r":"use_content"}]}]}]};
this["ux-rating"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rating"},"f":[{"t":7,"e":"div","a":{"class":"ratingSection"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"6","class":"ratingQuestion"},"f":[{"t":2,"r":"ratingQuestion"}]}],"r":"ratingQuestion"}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"form","a":{"class":"left","name":[{"t":2,"r":"formName"}],"action":[{"t":2,"r":"callToAction"}],"method":"POST"},"v":{"reset":"resetRating"},"f":[{"t":7,"e":"fieldset","a":{"class":"rating"},"f":[{"t":4,"f":[{"t":7,"e":"input","v":{"click":"ratingSelection"},"a":{"type":"radio","id":["star_",{"t":2,"r":"i"}],"name":"webform_starsValues","value":[{"t":2,"r":"value"}]}},{"t":7,"e":"label","a":{"for":["star_",{"t":2,"r":"i"}]}}],"i":"i","r":"ratingValueModelList"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-modal","f":[{"t":7,"e":"ux-header","a":{"level":"4"},"f":[{"t":2,"r":"thankYouMessage"}]}," ",{"t":7,"e":"div","a":{"class":"display m-medium","style":["display:",{"t":2,"r":"displayFeedbackText"}]},"f":[{"t":2,"r":"feedBackDescription"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["formSubmissionMsg ",{"t":2,"r":"validityClass"}," m-medium"]},"f":[{"t":2,"r":"formSubmissionMsg"}]}],"n":50,"r":"formSubmissionMsg"}," ",{"t":7,"e":"label","a":{"for":"textarea","style":["display:",{"t":2,"r":"displayTextarea"}],"class":"m-medium"},"f":[{"t":2,"r":"commentLabel"}]}," ",{"t":7,"e":"textarea","a":{"rows":"4","cols":"50","style":["display:",{"t":2,"r":"displayTextarea"}],"placeholder":[{"t":2,"r":"commentPlaceHolder"}],"name":"webform_textarea","value":[{"t":2,"r":"feedBackComment"}]},"f":[]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-offset-8 large-4"},"f":[{"t":7,"e":"button","v":{"tap":"starSelection"},"a":{"style":["display:",{"t":2,"r":"displayButton"}],"class":"ratingButton m-medium","type":"button"},"f":[{"t":2,"r":"buttonLabel"}]}]}]}]}],"n":53,"r":"modal"}," ",{"t":7,"e":"input","a":{"class":"not_required_validation","name":[{"t":2,"r":"requiredFilledValidation"}],"value":"","type":"text"}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"webform_selectedStarValue","value":[{"t":2,"r":"selectedStarValue"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"webform_currentPageUrl","value":[{"t":2,"r":"currentPageUrl"}]}}]}]}]}]}]}]};
this["ux-recaptcha-form"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-recaptcha-form v-normal"},"f":[{"t":7,"e":"div","a":{"class":["captcha-scripts-container",{"t":2,"r":"captchaId"}]},"f":[{"t":7,"e":"script","a":{"type":"text/javascript","src":[{"t":2,"r":"recaptchaUrl"}]}}]}]}]};
this["ux-recommended-accessories"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-recommended-accessories ",{"t":2,"r":"alignment"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"expand-panel column-control-mobile"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-accordion","a":{"class":"specification-accordion","data":[{"t":3,"r":"."}],"recommendedAccList":[{"t":2,"r":"recommendedAccList"}],"isActive":[{"t":2,"r":"isActive"}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"active":[{"t":4,"f":["true"],"n":50,"r":"isActive"}],"class":[{"t":4,"f":["force-hide"],"n":50,"x":{"r":["recommendedAccList"],"s":"!_0"}}]},"f":[{"t":7,"e":"ux-panel","a":{"class":"panel30 margin-zero"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 medium-1 left v-normal-right v-medium-top"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":"tech-specs-line"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"left small-7 medium-9 accordion-title v-normal-top"},"f":[{"t":2,"r":"data.headerText"}]}," ",{"t":7,"e":"ux-col","a":{"class":"rightAlign small-2 medium-1 v-normal-top"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":7,"e":"ux-premium-addons","a":{"addons":[{"t":3,"r":"data.recommendedAccList"}],"isAccessory":"true","isrecommended":"true"},"f":[]}]}]}]}]}]}]}]}]};
this["ux-recontract-number"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-recontract-number"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"description v-normal-bottom"},"f":[{"t":2,"r":"sectionDesc"}]}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"x":{"r":["getSelectedState","index"],"s":"_0(_1)"}}]},"v":{"tap":{"n":"selectReContract","d":[{"t":2,"r":"index"}]}},"f":[{"t":7,"e":"div","a":{"class":["recon-panel ",{"t":4,"f":["disabled"],"n":50,"r":"isChildPlan"}," ",{"t":4,"f":["v-normal-bottom"],"n":50,"x":{"r":["index","recontractNumber.length"],"s":"_0<_1-1"}},{"t":4,"n":51,"f":["v-medium-bottom"],"x":{"r":["index","recontractNumber.length"],"s":"_0<_1-1"}}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom"},"f":["Singtel Mobile ",{"t":2,"x":{"r":["RactiveHelpers","serviceId"],"s":"_0.mobileNumberFormat(_1)"}}]}," ",{"t":7,"e":"div","a":{"class":"plan"},"f":[{"t":2,"r":"basePlan"}," Plan"]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"talktime"},"f":["Talktime: ",{"t":2,"r":"talktime.quantity"},{"t":2,"r":"talktime.unit"}]}," ",{"t":7,"e":"div","a":{"class":"talktime"},"f":["Local SMS/MMS: ",{"t":2,"r":"sms.quantity"}]}," ",{"t":7,"e":"div","a":{"class":"talktime"},"f":["Data: ",{"t":2,"r":"data.quantity"},"  ",{"t":2,"r":"data.unit"}," Local Data ",{"t":4,"f":[", ",{"t":2,"r":"wifiData.quantity"},"  ",{"t":2,"r":"wifiData.unit"}," Singtel Wifi Data, "],"n":50,"x":{"r":["wifiData.quantity"],"s":"_0!==\"0\""}}]}],"n":50,"r":"showFlag"}],"n":53,"r":"aemPlan"}],"n":50,"r":"aemPlan"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"."}]}],"n":52,"r":"planDetailsdesc"}],"r":"aemPlan"}," ",{"t":7,"e":"div","a":{"class":"addon"},"f":["Add on: ",{"t":2,"r":"addOn"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"premium"},"f":["Premium Content: ",{"t":2,"r":"premiumContect"}]}],"n":50,"r":"premiumContect"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-offset-1 medium-5"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"flex-container v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"promo"},"f":[{"t":2,"r":"promo"}]}]}],"r":"promo"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"flex-container v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"alert"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-2 medium-1 alert-icon"},"f":[{"t":7,"e":"ux-icon","a":{"type":"alert-lightning-filled"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-10 medium-11 alert-msg"},"f":[{"t":2,"r":"alert"}]}]}]}]}],"r":"alert"}]}," ",{"t":7,"e":"ux-col","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-button","a":{"class":"round v-normal-top light fullwidth"},"f":["Select"]}]}]}]}]}],"i":"index","r":"recontractNumber"}],"n":50,"x":{"r":["recontractNumber","recontractNumber.length"],"s":"_0&&_1>0"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["existingNumbersFailed"],"s":"_0"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"ConfigString.errors.genericError"}]},"f":[]}]}]}]},{"t":4,"n":50,"x":{"r":["existingNumbersFailed","noRecordsError"],"s":"(!(_0))&&(_1)"},"f":[" ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"ConfigString.errors.mainLineError"}]},"f":[]}]}]}]}],"x":{"r":["recontractNumber","recontractNumber.length"],"s":"_0&&_1>0"}}]}]};
this["ux-red-member-sub"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-red-member-sub"},"f":[{"t":7,"e":"ux-row","a":{"class":"red-member-info"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-3 medium-1 text-right-medium icon-container"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":[{"t":2,"rx":{"r":"ConfigStrings.serviceConfig","m":[{"r":[],"s":"\"RED\""},"icon"]}}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-9 medium-10 info-container"},"f":[{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"div","a":{"class":"left section-header v-medium-top"},"f":[{"t":2,"rx":{"r":"ConfigStrings.serviceConfig","m":[{"r":[],"s":"\"RED\""},"name"]}}]}]}," ",{"t":7,"e":"div","a":{"class":"section-details"},"f":[{"t":7,"e":"div","a":{"class":"membership-id-details v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"div","a":{"class":"left input-label-bold"},"f":["Membership ID"]}]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"r":"serviceId"}]}]}," ",{"t":7,"e":"div","a":{"class":"membership-plan-details v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"div","a":{"class":"left input-label-bold"},"f":["Plan Details"]}]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":7,"e":"div","f":["Plan: ",{"t":2,"r":"productName"}]}," ",{"t":7,"e":"div","f":["Membership Period: ",{"t":2,"r":"startDate"}," - ",{"t":2,"r":"endDate"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"membership-recontract-details v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"div","a":{"class":"left input-label-bold"},"f":["Recontracting"]}]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":7,"e":"div","f":["Next Billing Date: ",{"t":2,"r":"nextBillingCycleDate"}," (automatic renewal)"]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider margin-zero"}}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"subscript-text"},"f":[{"t":2,"r":"initData.redMemberNotes.Header"}," :"]}," ",{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":3,"x":{"r":["RactiveHelpers","idx","initData.redMemberNotes.noteList"],"s":"_0.unescapeString(_2[_1])"}}]}],"n":52,"i":"idx","r":"initData.redMemberNotes.noteList"}]}]}]}]}],"n":50,"x":{"r":["initData.redMemberNotes","initData.redMemberNotes.Header"],"s":"_0&&_1"}}]}]}]}]}]};
this["ux-red-service-details"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-red-service-details"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":[{"t":2,"r":"ConfigStrings.redMemberShip.modalHeader"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"flex-container p-medium-left p-medium-right"},"f":[{"t":7,"e":"div","a":{"class":"flex-container-start subsection-title"},"f":[{"t":2,"r":"ConfigStrings.redMemberShip.planHeader"}]}," ",{"t":7,"e":"div","a":{"class":"flex-container-end"},"f":[{"t":4,"f":[{"t":2,"r":"oneClick.order.planName"}],"n":50,"x":{"r":["oneClick","oneClick.order","oneClick.order.planName"],"s":"_0&&_1&&_2"}}]}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"flex-container p-medium-left p-medium-right"},"f":[{"t":7,"e":"div","a":{"class":"flex-container-start subsection-title"},"f":[{"t":2,"r":"ConfigStrings.redMemberShip.tenureHeader"}]}," ",{"t":7,"e":"div","a":{"class":"flex-container-end"},"f":[{"t":4,"f":[{"t":2,"r":"oneClick.order.totalRecurringCalculatedPrice.recurringChargeFrequency.frequencyFactor"}," ",{"t":2,"x":{"r":["oneClick.order.totalRecurringCalculatedPrice.recurringChargeFrequency.frequencyUnit"],"s":"_0&&_0.toLowerCase()"}}],"n":50,"x":{"r":["oneClick","oneClick.order","oneClick.order.totalRecurringCalculatedPrice","oneClick.order.totalRecurringCalculatedPrice.recurringChargeFrequency"],"s":"_0&&_1&&_2&&_3"}}]}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-container-start subsection-title flex-item"},"f":[{"t":2,"r":"ConfigStrings.redMemberShip.costHeader"}]}," ",{"t":7,"e":"div","a":{"class":"flex-container-end section-header initial-width v-none-bottom flex-item"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","oneClick.order.totalOneTimeCalculatedPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}},"/yr"],"n":50,"x":{"r":["oneClick","oneClick.order","oneClick.order.totalOneTimeCalculatedPrice","oneClick.order.totalOneTimeCalculatedPrice.finalAmountIncludingTax"],"s":"_0&&_1&&_2&&_3"}}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"subsection-title"},"f":[{"t":2,"r":"initData.redMembership.checkboxHeader"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"p-medium-bottom p-large-bottom-mobile v-large-bottom-mobile"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-checkbox","a":{"onChangeEvent":"redMembershipCheckboxChange","checkboxid":["redTnc",{"t":2,"r":"idx"}],"checked":[{"t":2,"r":"selected"}],"class":[{"t":4,"f":["v-medium-top"],"n":50,"x":{"r":["idx"],"s":"_0===0"}},{"t":4,"n":51,"f":["v-normal-top"],"x":{"r":["idx"],"s":"_0===0"}}]},"f":[{"t":3,"r":"field"}]}],"n":52,"i":"idx","r":"augmentedCheckboxFields"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up v-large-top proceed-button-container-sticky"},"f":[{"t":7,"e":"div","a":{"class":"p-normal-top p-small-bottom text-right p-xlarge-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["round ",{"t":4,"f":["disabled"],"n":50,"r":"disableProceed"}," v-small-top"],"onclick":"proceedForRed","text":[{"t":2,"r":"ConfigStrings.redMemberShip.proceed"}]},"f":[]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only v-large-top proceed-button-container-sticky v-none-left v-none-right"},"f":[{"t":7,"e":"div","a":{"class":"p-normal-top"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["round ",{"t":4,"f":["disabled"],"n":50,"r":"disableProceed"}," v-small-top"],"onclick":"proceedForRed","text":[{"t":2,"r":"ConfigStrings.redMemberShip.proceed"}]},"f":[]}]}]}]}]}]}]};
this["ux-redemption-details"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-redemption-details"},"f":[{"t":7,"e":"ux-row","a":{"class":"large-row column-control-mobile v-small-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","a":{"class":"panel30 margin-zero"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-7"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"product-title"},"f":[{"t":2,"x":{"r":["initData.redemptionHeader","ConfigStrings.redemptionHeader.headerText"],"s":"_0||_1"}}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 small-12"},"f":[{"t":7,"e":"div","a":{"class":"v-large-top v-medium-bottom panel-divider v-normal-bottom-mobile v-normal-top-mobile v-none-left"}}]}]}],"n":50,"x":{"r":["deviceType","redemptionList","redemptionList.length"],"s":"_0===\"premium\"&&_1&&_2>1"}}," ",{"t":7,"e":"ux-accordion","a":{"redemptionList":[{"t":2,"rx":{"r":"redemptionList","m":[{"t":30,"n":"i"}]}}],"selectRedemptionOption":[{"t":2,"r":"selectRedemptionOption"}],"broadBandOption":[{"t":2,"r":"broadBandOption"}],"premiumOption":[{"t":2,"r":"premiumOption"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-7 small-10 v-large-bottom-medium"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"body-copy-text-heavy"},"f":[{"t":2,"r":"deviceSkuName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-1 medium-2 show-for-medium-up medium-offset-1 medium-1"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 show-for-small-only right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up","class":"right accordion-icon"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down","class":"right accordion-icon"}}]}]}]}," ",{"t":7,"e":"ux-content","f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":" v-normal-bottom v-small-top delivery-wrapper"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8"},"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"x":{"r":["deviceId","redemptionModeId"],"s":"_0+\"_\"+_1"}}],"type":"radio","name":"Broadband","value":[{"t":2,"x":{"r":["deviceId","redemptionModeId"],"s":"_0+\"_\"+_1"}}]},"v":{"change":{"n":"selectBroadBandOption","d":[" ",{"t":2,"x":{"r":["deviceId","redemptionModeId"],"s":"_0+\"_\"+_1"}}]}}}],"n":50,"x":{"r":["deviceType"],"s":"_0===\"Broadband\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["deviceType"],"s":"(_0===\"premium\")"},"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"x":{"r":["deviceId","redemptionModeId"],"s":"_0+\"_\"+_1"}}],"type":"radio","name":"premium","value":[{"t":2,"x":{"r":["deviceId","redemptionModeId"],"s":"_0+\"_\"+_1"}}]},"v":{"change":{"n":"selectPremiumOption","d":[" ",{"t":2,"x":{"r":["deviceId","redemptionModeId"],"s":"_0+\"_\"+_1"}}]}}}]}],"x":{"r":["deviceType"],"s":"_0===\"Broadband\""}}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"x":{"r":["deviceId","redemptionModeId"],"s":"_0+\"_\"+_1"}}]},"f":[{"t":7,"e":"ux-col","a":{"class":"small-1 text-center v-small-top p-none-left-mobile p-none-right-mobile v-normal-right-mobile"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"redemptionModeIcon"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-8 p-none-left-mobile p-none-right-mobile"},"f":[{"t":7,"e":"div","a":{"class":"subsection-title lh-22"},"f":[{"t":2,"r":"redemptionModeTitle"}]}," ",{"t":7,"e":"p","a":{"class":"fine-print-text-default-color-fix-size body-copy-text"},"f":[{"t":3,"r":"redemptionModeDesc"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 text-right v-medium-top"},"f":[{"t":7,"e":"span","a":{"class":"body-copy-text"},"f":[{"t":2,"r":"redemptionModeFreeText"}]}]}]}]}]}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"x":{"r":["deviceId","redemptionModeId"],"s":"_0+\"_\"+_1"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 small-12"},"f":[{"t":3,"r":"instructionDesc"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top v-normal-bottom medium-8 small-12"},"f":[{"t":7,"e":"div","a":{"class":"note p-normal-top p-normal-bottom p-normal-left p-normal-right"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"v-medium-left-mobile subsection-title"},"f":[{"t":3,"r":"noteTitle"}]}," ",{"t":7,"e":"div","a":{"class":" v-small-top v-small-bottom v-medium-left-mobile "},"f":[{"t":3,"r":"noteDesc"}]}]}]}]}],"n":50,"x":{"r":["noteTitle","noteDesc"],"s":"_0&&_1"}}],"n":50,"x":{"r":["broadBandOption","deviceId","redemptionModeId"],"s":"_0===_1+\"_\"+_2"}}," ",{"t":7,"e":"label","f":[{"t":7,"e":"label","a":{"for":[{"t":2,"x":{"r":["deviceId","redemptionModeId"],"s":"_0+\"_\"+_1"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 small-12"},"f":[{"t":3,"r":"instructionDesc"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-top v-normal-bottom medium-8 small-12"},"f":[{"t":7,"e":"div","a":{"class":"note p-normal-top p-normal-bottom p-normal-left p-normal-right"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"v-medium-left-mobile subsection-title"},"f":[{"t":3,"r":"noteTitle"}]}," ",{"t":7,"e":"div","a":{"class":" v-small-top v-small-bottom v-medium-left-mobile "},"f":[{"t":3,"r":"noteDesc"}]}]}]}]}],"n":50,"x":{"r":["noteTitle","noteDesc"],"s":"_0&&_1"}}],"n":50,"x":{"r":["premiumOption","deviceId","redemptionModeId"],"s":"_0===_1+\"_\"+_2"}}," ",{"t":7,"e":"label","f":[]}]}]}]}],"n":52,"r":"redemptionMethodList"}]}]}],"n":53,"r":"redemptionList"}]}],"n":52,"i":"i","r":"redemptionList"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"v-large-top v-normal-bottom panel-divider"}}]}," ",{"t":7,"e":"ux-row","a":{"class":"paper-bill-option-button v-normal-top v-medium-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"left medium-5 small-5 v-small-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"role":"link","arialabel":"Back","onclick":"gotoPreviousStep"},"f":["Back"]}],"n":50,"x":{"r":["hideBackButton"],"s":"!_0"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"right text-right medium-offset-2 small-offset-2 medium-5 small-5"},"f":[{"t":7,"e":"ux-button","a":{"class":["round right ",{"t":4,"f":["disabled"],"n":51,"r":"isRedemptionMethodSelected"}],"text":"Proceed to Order Summary","role":"button","arialabel":"Proceed to Order Summary","onclick":"onNextClick"},"f":[]}]}],"n":50,"x":{"r":["isLastStep"],"s":"!_0"}}]}]}]}]}]}]};
this["ux-redirect-selection"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-redirect-selection"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"modal-content"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header v-none-top v-none-bottom"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"div","a":{"class":"row-wrapper"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"p-normal-bottom"},"f":[{"t":2,"r":"description"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom service"},"v":{"click":{"n":"handleClick","d":[{"t":2,"r":"ctaUrl"}]}},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"service-name"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"p","a":{"class":"v-small-bottom service-account"},"f":[{"t":2,"r":"description"}]}]}],"n":52,"r":"redirectSelection"}]}," ",{"t":7,"e":"div","a":{"class":"v-large-bottom"}}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-replace-text"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-replace-text"},"f":[{"t":3,"x":{"r":["RactiveHelpers","text"],"s":"_0.unescapeString(_1)"}}]}]};
this["ux-rewards-catalog-filter"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rewards-catalog-filter"},"f":[{"t":4,"f":[{"t":7,"e":"ux-rewards-filter-facets","a":{"datamodel":[{"t":3,"r":"."}]}}],"n":50,"r":"categories"}," ",{"t":4,"f":[{"t":7,"e":"ux-rewards-catalogue","a":{"data":[{"t":2,"r":"rewardsFiltered"}]}}],"n":50,"r":"rewardsFiltered"}]}]};
this["ux-rewards-catalogue-block"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-rewards-catalogue-block"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel clearfix zeropadding"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"ribbon":"PRESTIGE"}}],"r":"prestige"}," ",{"t":7,"e":"ux-col","a":{"class":"zeropadding"},"f":[{"t":7,"e":"ux-anchor","a":{"text":[{"t":2,"r":"itemTitle"}],"groupId":[{"t":2,"r":"groupId"}],"productUrl":[{"t":2,"r":"rewardUrl"}],"ontap":"rewardSelected"},"f":[{"t":7,"e":"ux-image","a":{"class":["handset-img ",{"t":4,"f":["fullyredeemed-img"],"n":50,"x":{"r":["fullyRedeemed","buttonType"],"s":"_0&&_1==\"Redeem Now\""}}],"img":[{"t":2,"r":"smallImage"}]}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"no-stock-text v-normal-bottom body-white text-center"},"f":["FULLY REDEEMED"]}],"n":50,"x":{"r":["fullyRedeemed","buttonType"],"s":"_0&&_1==\"Redeem Now\""}}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12 padding-top20 padding-leftright35"},"f":[{"t":7,"e":"div","a":{"class":"text-center product-title v-normal-top"},"f":[{"t":2,"r":"itemTitle"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12 v-small-top padding-leftright35"},"f":[{"t":7,"e":"div","a":{"class":"text-center"},"f":[{"t":7,"e":"div","a":{"class":"product-desc"},"f":[{"t":2,"r":"itemDescription"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12 v-normal-top padding-leftright35"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-large-bottom"},"f":[{"t":7,"e":"ux-button","a":{"class":"select-phones-buttons light round","text":"Find Out More","onclick":"rewardSelected","groupId":[{"t":2,"r":"groupId"}],"productUrl":[{"t":2,"r":"rewardUrl"}]}}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}],"n":50,"r":"display"}]};
this["ux-rewards-catalogue"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rewards-catalogue"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-xx-large-top v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-8 medium-8 small-8"},"f":[{"t":7,"e":"div","a":{"class":"product-title"},"f":[{"t":2,"r":"title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"text-right large-4 medium-4 small-4"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"anchor"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}]},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"linkText"}]}]}],"n":50,"r":"title"}," ",{"t":7,"e":"ux-row","a":{"class":"medium-collapse v-xx-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-4 large-4"},"f":[{"t":7,"e":"ux-rewards-catalogue-block","a":{"datamodel":[{"t":2,"r":"."}],"isDataModel":"true"}}]}],"n":52,"r":"rewardsFiltered"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-12 text-center v-medium-top"},"f":[{"t":7,"e":"ux-button","a":{"class":"show-more-rewards","text":"Show More","onclick":"viewMore"}}]}],"n":50,"r":"showButton"}]}],"n":50,"x":{"r":["rewardsFiltered.length"],"s":"_0>0"}}]}]};
this["ux-rewards-filter-facets"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rewards-filter-facets"},"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","a":{"class":"filter-header"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"main-header v-medium-bottom v-medium-top"},"f":[{"t":2,"r":"headerText"}]}," ",{"t":7,"e":"div","a":{"class":"section-description v-medium-bottom show-for-small-only"},"f":[{"t":3,"r":"descriptionText"}]}," ",{"t":7,"e":"div","a":{"class":"section-description v-large-bottom show-for-medium-up"},"f":[{"t":3,"r":"descriptionText"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"left-selections v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 v-small-bottom"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header show-result"},"f":[{"t":2,"r":"filterCriteriaText"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"left-selections v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-brand","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"category"}],"options":[{"t":2,"r":"categories"}]}}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]}]};
this["ux-rewards-list-desc"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rewards-list-desc v-medium-left v-medium-right paddingTopDesc v-large-bottom"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"main-header"},"f":[{"t":2,"r":"details"}]}," ",{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"."}]},{"t":7,"e":"br"}]}],"r":"description"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 v-large-top"},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"tncTitle"}]},{"t":7,"e":"br"}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"toggleTnc:showTncInfo"},"f":["Terms & Conditions"]}]}],"n":50,"x":{"r":["tnc"],"s":"_0!==null"}}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"showTncInfo"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":["Terms and Conditions"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"section-details"},"f":[{"t":7,"e":"ol","f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":2,"r":"."}]}],"r":"tnc"}]}]}]}]}]}]}]};
this["ux-rewards-list-header"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rewards-list-header v-medium-left v-medium-right v-medium-top v-medium-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"ribbon":"PRESTIGE"}}],"r":"prestige"}," ",{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header"},"f":[{"t":2,"r":"rewardTitle"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 v-normal-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"ribbon":"PRESTIGE"}}],"r":"prestige"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header center"},"f":[{"t":2,"r":"rewardTitle"}]}]}]}]}]};
this["ux-rewards-list-redemption"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rewards-list-redemption v-large-top v-medium-bottom"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"input-label-bold v-medium-left"},"f":["Draw Date : ",{"t":7,"e":"span","a":{"class":"body-text"},"f":[{"t":2,"r":"drawDate"}]}]}," ",{"t":7,"e":"div","a":{"class":"hero-button"},"f":[{"t":7,"e":"ux-button","a":{"class":"round redemption-button","text":[{"t":2,"r":"buttonType"}],"onclick":"doLuckyDraw"}}]}],"n":50,"r":"luckyDraw"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["buttonType"],"s":"_0==\"NA\""},"f":[{"t":4,"f":[" ",{"t":7,"e":"div","a":{"class":"hero-button"},"f":[{"t":7,"e":"ux-button","a":{"class":"round redemption-button","text":"Redeem","onclick":"doBirthdayTreat"}}]}],"n":50,"r":"birthdayTreat"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["prestige"],"s":"_0"},"f":[" "]},{"t":4,"n":50,"x":{"r":["prestige"],"s":"!(_0)"},"f":[" "]}],"r":"birthdayTreat"}]},{"t":4,"n":50,"x":{"r":["buttonType"],"s":"(!(_0==\"NA\"))&&(_0==\"Book Now\")"},"f":[" ",{"t":7,"e":"div","a":{"class":"hero-button"},"f":[{"t":7,"e":"ux-button","a":{"class":"round redemption-button","text":[{"t":2,"r":"buttonType"}],"href":[{"t":2,"r":"detailPageUrl"}]}}]}]},{"t":4,"n":50,"x":{"r":["buttonType"],"s":"(!(_0==\"NA\"))&&((!(_0==\"Book Now\"))&&(_0==\"Find Out More\"))"},"f":[" ",{"t":7,"e":"div","a":{"class":"hero-button"},"f":[{"t":7,"e":"ux-button","a":{"class":"round redemption-button","text":[{"t":2,"r":"buttonType"}],"href":[{"t":2,"r":"detailPageUrl"}]}}]}]},{"t":4,"n":50,"x":{"r":["buttonType"],"s":"(!(_0==\"NA\"))&&((!(_0==\"Book Now\"))&&((!(_0==\"Find Out More\"))&&(_0==\"Redeem Now\")))"},"f":[" ",{"t":7,"e":"div","a":{"class":"hero-button"},"f":[{"t":7,"e":"ux-button","a":{"class":["round redemption-button ",{"t":4,"f":["disabled"],"n":50,"r":"fullyRedeemed"}],"text":[{"t":2,"r":"buttonType"}],"onclick":"doRedeemNow"}}]}]}],"r":"luckyDraw"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"errorMessage"}],"validityMsgClass":"margin-zero"},"f":[]}]}]}],"n":50,"r":"errorMessage"}],"n":50,"r":"transaction"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-load-mask","f":[{"t":7,"e":"ux-load-mask","f":[]}]}],"r":"transaction"}," ",{"t":7,"e":"ux-modal","a":{"width":"590","class":"light-theme","modalId":"redeemByEmail"},"f":[{"t":7,"e":"div","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":4,"f":["Lucky Draw Participation"],"n":50,"r":"luckyDraw"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["buttonType"],"s":"_0==\"Redeem Now\"||_0==\"NA\""},"f":["Redeem Voucher"]}],"r":"luckyDraw"}]}]}," ",{"t":7,"e":"div","a":{"class":"section-details v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"p","f":["Stand a chance to win '",{"t":2,"r":"luckyDrawTitle"},"'"]}],"n":50,"r":"luckyDraw"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["buttonType"],"s":"(_0==\"Redeem Now\"||_0==\"NA\")"},"f":[{"t":7,"e":"p","f":["Kindly confirm the following information before your redemption."]}]}],"r":"luckyDraw"}," ",{"t":7,"e":"div","a":{"class":"v-normal-top input-label-bold flex-item flex-item-medium-left-align"},"f":["Registered Name"]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":2,"r":"account.customerName"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top input-label-bold"},"f":["Email Address"]}," ",{"t":7,"e":"div","a":{"class":"input-field"},"f":[{"t":7,"e":"ux-input-box","a":{"id":"emailAddr","name":"emailAddr","value":[{"t":2,"r":"emailAddr"}],"onblurEvent":"checkEmailValidation","onInputEvent":"enableEmailButton"}}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"emailAddrErrorMsg.message"}]},"f":[]}],"n":50,"r":"emailAddrErrorMsg.message"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top input-label-bold"},"f":["Contact Number"]}," ",{"t":7,"e":"div","a":{"class":"input-field"},"f":[{"t":7,"e":"ux-input-box","a":{"value":[{"t":2,"r":"mobileNumber"}],"onblurEvent":"checkPhoneValidation","onInputEvent":"enablePhoneButton","maxLength":"8"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"phoneVal.phoneValErrorMsg.message"}]},"f":[]}]}]}],"n":50,"r":"phoneVal.phoneValErrorMsg.message"}]}," ",{"t":7,"e":"div","a":{"class":"body-light padding-top-5 v-normal-top v-normal-bottom"},"f":[{"t":4,"f":["By submitting this form, I agree that I have read, understood and accepted the Campaign ",{"t":7,"e":"ux-anchor","a":{"ontap":"toggleTnc:showTncInfo","class":"tnc-label"},"f":["Terms & Conditions"]}," and consent to Singtel collecting, using and disclosing my personal data for the purposes set out in ",{"t":7,"e":"ux-anchor","a":{"href":"https://www.singtel.com/personal/i/dataprotection","class":"tnc-label","target":"_blank"},"f":["Singtel's Data Protection Policy"]}," and ",{"t":7,"e":"ux-anchor","a":{"href":"https://www.singtel.com/terms-general","class":"tnc-label","target":"_blank"},"f":["Clause 15"]}," of Singtel's General Terms & Conditions where applicable. ",{"t":7,"e":"ux-checkbox","a":{"checked":[{"t":2,"r":"isConsentAgreed"}],"labelvalue":"In addition, I consent to Singtel contacting me via phone call, text message, email or post for the purpose of marketing and promotions.","class":"top31 v-medium-top"},"f":[]}],"n":50,"x":{"r":["tnc","luckyDraw"],"s":"_0!==null&&_1"}}," ",{"t":4,"f":["By clicking on the Redeem button, you agree that you have read, understood and accepted the ",{"t":7,"e":"ux-anchor","a":{"ontap":"toggleTnc:showTncInfo","class":"tnc-label"},"f":["Terms & Conditions "]},"."],"n":50,"x":{"r":["tnc","luckyDraw"],"s":"_0!==null&&!_1"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":["round v-medium-top redemption-button ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["emailAddr","mobileNumber","phoneVal.phoneValErrorMsg.message","emailAddrErrorMsg.message","onInitRetrieveAddressDisabled"],"s":"_0&&_1&&!_2&&!_3&&!_4"}}],"onclick":"doLuckyDrawModal","text":[{"t":2,"r":"buttonType"}]}}],"n":50,"r":"luckyDraw"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["birthdayTreat"],"s":"_0"},"f":[{"t":7,"e":"ux-button","a":{"class":["round v-medium-top redemption-button ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["emailAddr","mobileNumber","phoneVal.phoneValErrorMsg.message","emailAddrErrorMsg.message","onInitRetrieveAddressDisabled"],"s":"_0&&_1&&!_2&&!_3&&!_4"}}],"onclick":"doBirthdayTreatModal"},"f":["Redeem"]}]},{"t":4,"n":50,"x":{"r":["birthdayTreat","buttonType"],"s":"(!(_0))&&((_1==\"Redeem Now\"||_1==\"NA\"))"},"f":[" ",{"t":7,"e":"ux-button","a":{"class":["round v-medium-top redemption-button ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["emailAddr","mobileNumber","phoneVal.phoneValErrorMsg.message","emailAddrErrorMsg.message","onInitRetrieveAddressDisabled"],"s":"_0&&_1&&!_2&&!_3&&!_4"}}],"onclick":"doRedeemModal"},"f":["Redeem"]}]}],"r":"luckyDraw"}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"590","class":"light-theme","modalId":"redeemVoucherPhysical"},"f":[{"t":7,"e":"div","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":["Redeem Voucher"]}]}," ",{"t":7,"e":"div","a":{"class":"section-details v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"p","f":["Please confirm the following information before your redemption. Your voucher will be mailed to your selected billing address within 14 working days."]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top input-label-bold"},"f":["Registered Name"]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":2,"r":"account.customerName"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top input-label-bold"},"f":[{"t":4,"f":["Delivery Address"],"n":50,"x":{"r":["account.physicalAddress"],"s":"_0!==\"\""}}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":2,"r":"account.physicalAddress"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top change-address-label"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"changeBillingAddress"},"f":["Change Address"]}]}],"n":50,"r":"chooseFromAddressList"}]}],"n":50,"r":"account.physicalAddress"},{"t":4,"n":51,"f":[{"t":7,"e":"p","f":["Your voucher will be delivered to the selected billing address within 14 working days."]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top input-label-bold"},"f":["Registered Name"]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":2,"r":"account.customerName"}]}],"r":"account.physicalAddress"}," ",{"t":7,"e":"div","a":{"class":"body-light padding-top-5 v-normal-top v-normal-bottom"},"f":[{"t":4,"f":["By submitting this form, I agree that I have read, understood and accepted the Campaign ",{"t":7,"e":"ux-anchor","a":{"ontap":"toggleTnc:showTncInfo","class":"tnc-label"},"f":["Terms & Conditions"]}," and consent to Singtel collecting, using and disclosing my personal data for the purposes set out in ",{"t":7,"e":"ux-anchor","a":{"href":"https://www.singtel.com/personal/i/dataprotection","class":"tnc-label","target":"_blank"},"f":["Singtel's Data Protection Policy"]}," and ",{"t":7,"e":"ux-anchor","a":{"href":"https://www.singtel.com/terms-general","class":"tnc-label","target":"_blank"},"f":["Clause 15"]}," of Singtel's General Terms & Conditions where applicable. ",{"t":7,"e":"ux-checkbox","a":{"checked":[{"t":2,"r":"isConsentAgreed"}],"labelvalue":"In addition, I consent to Singtel contacting me via phone call, text message, email or post for the purpose of marketing and promotions.","class":"top31 v-medium-top"},"f":[]}],"n":50,"x":{"r":["tnc","luckyDraw"],"s":"_0!==null&&_1"}}," ",{"t":4,"f":["By clicking on the Redeem button, you agree that you have read, understood and accepted the ",{"t":7,"e":"ux-anchor","a":{"ontap":"toggleTnc:showTncInfo","class":"tnc-label"},"f":["Terms & Conditions "]},"."],"n":50,"x":{"r":["tnc","luckyDraw"],"s":"_0!==null&&!_1"}}]}," ",{"t":7,"e":"ux-button","a":{"class":"round v-medium-top redemption-button","onclick":"doRedeemModal"},"f":["Redeem"]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"590","class":"light-theme","modalId":"changeBillingAddressModal"},"f":[{"t":7,"e":"div","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":["Change Address"]}]}," ",{"t":7,"e":"div","a":{"class":"section-details v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":["Please select your preferred delivery address. This address will be set as your default delivery address for future redemptions."]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["number-box v-normal-bottom cursor ",{"t":2,"r":"getExistingNumberState"}]},"v":{"tap":{"n":"doSelectAddress","d":[{"t":2,"r":"accountId"}]}},"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-top"},"f":[{"t":7,"e":"ux-col","f":[" ",{"t":2,"r":"address"}]}]}]}],"i":"index","r":"account.addressList"}]}]}],"n":50,"r":"chooseFromAddressList"}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"590","class":"light-theme","modalId":"confirmationModal"},"f":[{"t":7,"e":"div","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":["Thank you for participating!"]}]}," ",{"t":7,"e":"div","a":{"class":"section-details v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"p","f":["You have participated in the lucky draw '",{"t":2,"r":"rewardTitle"},"'. ",{"t":2,"r":"luckyDrawConfirm"}]}],"n":50,"r":"luckyDraw"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["buttonType","retrievalMode"],"s":"_0==\"Redeem Now\"&&_1==\"SendPhysicalVoucher\""},"f":[{"t":7,"e":"p","f":["Thank you. You have redeemed ",{"t":2,"r":"rewardTitle"}," successfully. Your voucher will be sent to your designated address within 14 working days."]}]},{"t":4,"n":50,"x":{"r":["buttonType","retrievalMode"],"s":"(!(_0==\"Redeem Now\"&&_1==\"SendPhysicalVoucher\"))&&(_0==\"Redeem Now\"&&_1==\"Email\")"},"f":[" ",{"t":7,"e":"p","f":["You have redeemed ",{"t":2,"r":"rewardTitle"},". Your voucher will be sent to your email address within 24 hours."]}]},{"t":4,"n":50,"x":{"r":["retrievalMode","buttonType"],"s":"(!(_1==\"Redeem Now\"&&_0==\"SendPhysicalVoucher\"))&&((!(_1==\"Redeem Now\"&&_0==\"Email\"))&&(_1==\"NA\"))"},"f":[" ",{"t":7,"e":"p","f":["You have redeemed ",{"t":2,"r":"rewardTitle"},". Your voucher will be sent to your email address within 24 hours."]}]}],"r":"luckyDraw"}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"loginForm"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header v-small-bottom"},"f":[{"t":2,"r":"loginLabel"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-singtel-login","a":{"loginUrl":[{"t":2,"r":"loginUrl"}]},"m":[{"t":4,"f":["referenceUrl=\"",{"t":2,"r":"referenceUrl"},"\""],"n":50,"r":"referenceUrl"}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"showTncInfo"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":["Terms and Conditions"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"section-details"},"f":[{"t":7,"e":"ol","f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":2,"r":"."}]}],"r":"tnc"}]}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"genericError"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":[{"t":4,"f":[{"t":2,"r":"errorTitle"}],"n":50,"r":"errorTitle"},{"t":4,"n":51,"f":["Error!!!"],"r":"errorTitle"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"errorMessageModal"}]},"f":[]}]}]}]}]}]};
this["ux-rewards-stuob"] = {"v":3,"t":[{"t":7,"e":"ux-row","a":{"class":"modal-content"},"f":[{"t":7,"e":"div","a":{"class":"ux-rewards-stuob"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"modal-title fixed-header v-none-top v-none-bottom"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"scrollable-section"},"f":[{"t":7,"e":"div","a":{"class":"row-wrapper"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"v-medium-bottom v-small-top v-medium-left"},"f":[{"t":2,"r":"textLabel"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"input-field v-medium-left"},"f":[{"t":7,"e":"ux-input-box","a":{"id":"binno","label_value":[{"t":2,"r":"inputLabel"}],"value":[{"t":2,"r":"stuobbin"}],"mandatory":"true","maxLength":"8","autofocus":0,"onblurEvent":"onBinNumberChange","onInputEvent":"onBinNumberChange"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"errorMsg"}]}}],"n":50,"r":"genericErrorMessage"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"fixed-footer"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6 v-medium-top"},"f":[]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["round ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["binNumberValid"],"s":"!_0"}}],"onclick":"requestMobileShare"},"f":["Submit"]}]}]}]}]}]}]};
this["ux-rewards-summary-list"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rewards-summary-list v-large-top"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"activity v-normal-top v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"activity-content"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"v-large-left leftpadding10 section-header"},"f":[{"t":2,"r":"date"}]}]}," ",{"t":7,"e":"ux-panel","a":{"class":"event v-normal-top v-none-bottom"},"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header"},"f":[{"t":2,"r":"date"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"event-top"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"title line titleline"},"f":[{"t":7,"e":"ux-header","a":{"class":"event-title subsection-header","level":"4"},"f":[{"t":2,"r":"description"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"title line"},"f":[{"t":7,"e":"ux-header","a":{"class":"event-title subsection-header","level":"4"},"f":[{"t":2,"r":"description"}]}]}]}],"n":50,"r":"description"}," ",{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":4,"f":["Lucky Draw Date: ",{"t":2,"r":"luckyDrawDate"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":["openDetailsPage:",{"t":2,"r":"luckyDrawItemcode"}]},"f":["View Details"]}]}],"n":50,"x":{"r":["status"],"s":"_0===\"Ongoing\""}}],"n":50,"r":"luckyDraw"}]}]}," ",{"t":7,"e":"hr"}," ",{"t":7,"e":"div","a":{"class":"event-bottom show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"installation line"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-4 medium-4"},"f":[{"t":7,"e":"div","a":{"class":"time"},"f":["Chance: ",{"t":7,"e":"strong","f":[{"t":2,"r":"chance"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-4 medium-4"},"f":[{"t":7,"e":"div","a":{"class":"time"},"f":["Bonus Chance: ",{"t":7,"e":"strong","f":[{"t":2,"r":"bonusChances"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-4 medium-4"},"f":[{"t":7,"e":"div","a":{"class":"status"},"f":["Status: ",{"t":7,"e":"strong","f":[{"t":2,"r":"status"}]}]}]}]}],"n":50,"r":"luckyDraw"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"status"},"f":["Status: ",{"t":7,"e":"strong","f":[{"t":2,"r":"status"}]}]}],"r":"luckyDraw"}]}]}," ",{"t":7,"e":"div","a":{"class":"event-bottom show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"installation line"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"date small-6 value"},"f":["Chance:"]},{"t":7,"e":"ux-col","a":{"class":"text-right small-6 bold"},"f":[{"t":2,"r":"chance"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"time small-6 value"},"f":["Bonus Chance:"]}," ",{"t":7,"e":"ux-col","a":{"class":"text-right small-6 bold"},"f":[{"t":2,"r":"bonusChances"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"status small-6 value"},"f":["Status:"]},{"t":7,"e":"ux-col","a":{"class":"text-right small-6 bold"},"f":[{"t":2,"r":"status"}]}]}],"n":50,"r":"luckyDraw"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"status small-6 value"},"f":["Status:"]},{"t":7,"e":"ux-col","a":{"class":"text-right small-6 bold"},"f":[{"t":2,"r":"status"}]}]}],"r":"luckyDraw"}]}]}]}]}]}],"i":"i","r":"transactions"}],"n":50,"r":"transaction"},{"t":4,"n":51,"f":[{"t":4,"f":["Unable to retrieve the data at this moment. Please try again later."],"n":50,"r":"urlInvalid"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-load-mask","f":[{"t":7,"e":"ux-load-mask","f":[]}]}],"r":"urlInvalid"}],"r":"transaction"}]}]};
this["ux-rewards-table-category"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rewards-table-category paddingDesktop"},"f":[{"t":4,"f":[{"t":7,"e":"table","a":{"class":"small-12 medium-10 large-10"},"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"small-8 medium-6 large-6"},"f":[{"t":2,"r":"headerCategory"}]}," ",{"t":7,"e":"td","a":{"class":"subsection-header small-2 medium-3 large-2 text-center"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"rewardsLink"}],"class":"text-link"},"f":[{"t":2,"r":"headerRewards"}]}],"n":50,"r":"rewardsLink"},{"t":4,"n":51,"f":[{"t":2,"r":"headerRewards"}],"r":"rewardsLink"}]}," ",{"t":7,"e":"td","a":{"class":"subsection-header small-2 medium-3 large-2 text-center"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"prestigeLink"}],"class":"text-link"},"f":[{"t":2,"r":"headerPrestige"}]}],"n":50,"r":"prestigeLink"},{"t":4,"n":51,"f":[{"t":2,"r":"headerPrestige"}],"r":"prestigeLink"}]}]}," ",{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"tableItems"},"f":[{"t":7,"e":"td","a":{"class":"body-text"},"f":[{"t":2,"r":"benefitCategory"}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"benefitLink"}],"class":"text-link"},"f":[{"t":2,"r":"benefitLinkText"}]}]}],"n":50,"r":"benefitLink"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 tooltip-padding20"},"f":[{"t":2,"r":"benefitTooltip"}]}]}]}]}],"n":50,"r":"benefitTooltip"}]}," ",{"t":4,"f":[{"t":7,"e":"td","a":{"colspan":"2","class":"body-text text-center"},"f":[{"t":2,"r":"text"}]}],"n":50,"r":"text"},{"t":4,"n":51,"f":[{"t":7,"e":"td","a":{"class":"body-text text-center"},"f":[{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"type":"circle-tick","size":"sm"}}],"n":50,"r":"benefitRewards"}]}," ",{"t":7,"e":"td","a":{"class":"body-text text-center"},"f":[{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"type":"circle-tick","size":"sm"}}],"n":50,"r":"benefitPrestige"}]}],"r":"text"}]}],"i":"i","r":"tables"}],"n":50,"r":"tables"}]}]}],"n":50,"r":"isDataModel"}]}]};
this["ux-rewards-table-rebate"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rewards-table-rebate paddingDesktop"},"f":[{"t":4,"f":[{"t":7,"e":"table","a":{"class":"small-12 medium-10 large-10"},"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"subsection-header small-6"},"f":[{"t":2,"r":"headerBill"}]}," ",{"t":7,"e":"td","a":{"class":"subsection-header text-right"},"f":[{"t":2,"r":"headerRebate"}]}]}," ",{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"tableItems"},"f":[{"t":7,"e":"td","a":{"class":"body-text v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"billPerMonth"}]}," ",{"t":7,"e":"td","a":{"class":"body-text v-medium-top v-medium-bottom right"},"f":[{"t":2,"r":"rebatePerMonth"}]}]}],"i":"i","r":"tables"}],"n":50,"r":"tables"}]}]}],"n":50,"r":"isDataModel"}]}]};
this["ux-ribbon-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-ribbon-singtel"},"f":[{"t":7,"e":"div","a":{"class":["ribbon-container ",{"t":4,"f":["show-on-left"],"n":50,"x":{"r":["ribbonPosition"],"s":"_0===\"left\""}}," ",{"t":4,"f":[{"t":2,"r":"class"}],"n":50,"r":"class"}]},"f":[{"t":7,"e":"div","a":{"class":"ribbon "},"f":[{"t":2,"r":"ribbon"}]}]}]}]};
this["ux-roaming-countrylist"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-roaming-countrylist"},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"countryListHeading"},"f":[{"t":2,"r":"countryListHeading"}]}," ",{"t":7,"e":"div","a":{"class":"section-description v-medium-bottom descriptionText"},"f":[{"t":2,"r":"descriptionText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"input","a":{"class":"searchClass medium","name":"search-text-input","id":"searchbox","type":"text","placeholder":[{"t":2,"r":"searchPlaceHolder"}],"value":[{"t":2,"r":"countrySearchValue"}]}}," ",{"t":7,"e":"input","a":{"class":"searchClass small","name":"search-text-input","id":"searchbox","type":"text","placeholder":[{"t":2,"r":"ConfigStrings.roamingCountryList.smallSearchPlaceHolder"}],"value":[{"t":2,"r":"countrySearchValue"}]}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"search-results panel"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"large-collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-12"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onCountryClicked","countryData":["{'countryName':",{"t":2,"r":"title"},", 'countryCode':",{"t":2,"r":"countryCode"},", 'countryOperator':",{"t":2,"r":"countryOperator"},", 'countryImage':",{"t":2,"r":"countryImage"},"}"]},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"subsection-header"},"f":[{"t":2,"r":"title"}]}]}]}]}],"r":"countriesListResult"}]}],"n":50,"r":"countryListViewAll"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"id":["zone-",{"t":2,"r":"zoneId"}]},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"p","a":{"class":"zoneName v-normal-top v-medium-bottom"},"f":[{"t":2,"r":"zoneName"}," (",{"t":2,"r":"countries.length"},")"]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ul","a":{"class":"small-block-grid-1 medium-block-grid-4"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"div","a":{"id":["country-",{"t":2,"r":"countryCode"}],"class":["country-select text-center ",{"t":4,"f":["selected"],"n":50,"r":"selected"}]},"v":{"tap":{"n":"selectCountry","d":[{"t":2,"r":"countryCode"}]}},"f":[{"t":7,"e":"div","a":{"class":"flag","style":["background: #e5e5e5 url('",{"t":2,"r":"osgBasePath"},"assets/images/flags/",{"t":2,"r":"countryCode"},".jpg') no-repeat; background-size:cover; background-position: 50%;"]},"f":[]}," ",{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"div","a":{"class":"operatorName"},"f":[{"t":2,"r":"countryOperator"}]}]}]}],"n":52,"r":"countries"}]}]}]}],"n":52,"r":"zones"}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"1068","class":"light-theme","modal_id":"roamingPlansModal"},"f":[{"t":7,"e":"ux-panel","a":{"class":"roaming-plans-header-panel"},"f":[{"t":7,"e":"ux-row","a":{"class":"roaming-plans-header"},"f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"countryImage"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"imgsrc"}]}}]}],"n":50,"r":"imgsrc"}," ",{"t":7,"e":"div","a":{"class":"planPopupTitle"},"f":[{"t":2,"r":"planPopupTitle"}," ",{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"div","a":{"class":"mobilePlanPopupTitle"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"div","a":{"class":"countryOptr"},"f":[{"t":2,"r":"countryOperator"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"mobileRaomingHeading"},"f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":[{"t":7,"e":"div","a":{"class":"mobileRaomingHeadingText"},"f":[{"t":2,"r":"ConfigStrings.roamingCountryList.smallPlanPopupTitle"}]}]}," ",{"t":7,"e":"div","a":{"class":"section-description v-medium-bottom mobileRaomingDescription"},"f":[{"t":2,"r":"ConfigStrings.roamingCountryList.smallPlanDescription"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"ribbon-text-header-panel"},"f":[{"t":7,"e":"ux-addon-singtel","a":{"isAddButton":"true","addon":[{"t":2,"r":"."}],"addAddonClickEvent":"addCountryAddonClicked"}}]}],"r":"roamingAddonsFiltered"}],"n":50,"r":"roamingAddonsFiltered.length"}]}]}]};
this["ux-roaming-rates"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-roaming-rates"},"f":[{"t":7,"e":"ux-row","a":{"class":"roaming-header"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header v-small-bottom v-medium-top"},"f":[{"t":2,"r":"heading"}]}," ",{"t":7,"e":"div","a":{"class":"section-description v-medium-bottom"},"f":[{"t":2,"r":"subHeading"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 padding-for-mobile"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-country","name":"selectcountry","showSelectedValue":"true","class":"medium left","options":[{"t":2,"r":"roamingCountries"}],"defaultOption":" ","select_placeholder":"true","onChangeEvent":"onCountryChange"},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3 padding-for-mobile"},"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"text-right round","text":[{"t":2,"r":"buttonLabel"}],"role":"button","onclick":"findRatesButtonClick","disabled":0},"f":[]}],"n":50,"r":"buttonDisabled"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-button","a":{"class":"text-right round","text":[{"t":2,"r":"buttonLabel"}],"role":"button","onclick":"findRatesButtonClick"},"f":[]}],"r":"buttonDisabled"}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"800","class":"light-theme","modal_id":"roamingRatesModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"roaming-header"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"main-header v-small-bottom v-medium-top"},"f":[{"t":2,"r":"modelHeading"}," ",{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"div","a":{"class":"section-description v-medium-bottom"},"f":[{"t":2,"r":"modelDescription"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"services-header"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.callsndSMS"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.incomingCalls"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"countryInfo.roamingInfo.incomingCharge"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.outgoingLocalCalls"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"countryInfo.roamingInfo.outgoingCharge"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.callingSingapore"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"countryInfo.roamingInfo.localCall"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.callIntenational"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"countryInfo.roamingInfo.Internationalcall"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.sendSMS"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"countryInfo.roamingInfo.smsSend"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.receiveSMS"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"countryInfo.roamingInfo.smsreceive"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-header"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"ConfigStrings.roamingRates.dataPerMb"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.dataRoamingAndMMS"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"countryInfo.roamingInfo.GPRSMMSPerMB"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-header"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"ConfigStrings.roamingRates.videoCallPerMin"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.incomingCalls"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"countryInfo.roamingInfo.videoCallIn"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.outgoingLocalCalls"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"countryInfo.roamingInfo.videoCallOut"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.callingSingapore"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"countryInfo.roamingInfo.localVideoCall"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"operator-details-header"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"ConfigStrings.roamingRates.networkDetails"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"services-header"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"networkOperator"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.dataRoaming3G"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"availableLink"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.handsetDisplay"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"networkName"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.internationalAccessCode"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"intCall"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.localCustomerCode"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"localCustomerNo"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.emergency"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"emergency"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"services-list"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"services-list-wrapper"},"f":[{"t":7,"e":"div","a":{"class":"services-list-name"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.nationalDirectory"}]}," ",{"t":7,"e":"div","a":{"class":"services-list-value"},"f":[{"t":2,"r":"nationalDirectory"}]}]}]}]}],"r":"countryInfo.roamingInfo.operatorInfo"}],"n":50,"r":"countryInfo.roamingInfo.operatorInfo.length"}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modal_id":"errorModal"},"f":[{"t":7,"e":"h3","a":{"class":"italic"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.errorTitle"}]}," ",{"t":7,"e":"p","a":{"class":"italic"},"f":[{"t":2,"r":"ConfigStrings.roamingRates.errorMessage"}]}]}]}]};
this["ux-roaming-recommender"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-roaming-recommender","id":[{"t":2,"r":"widgetId"}]},"f":[{"t":7,"e":"div","a":{"class":"night-view-box"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"openRoamingRecommender","ariaLabel":"openRoamingRecommender"},"f":[{"t":2,"r":"roamingPlanLinkLabel"}]}]}," ",{"t":7,"e":"ux-modal","a":{"class":"light-theme","widthPercentage":"100","modalId":"roamingRecommenderModal"},"f":[{"t":7,"e":"div","a":{"class":"white-bg"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-large-top v-large-bottom"},"f":[{"t":2,"r":"roamingPopupTitle"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"main-header"},"f":[{"t":2,"r":"chooseRoamingTitle"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"destinationsHeading"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-panel","f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"id":["zone-",{"t":2,"r":"zoneId"}]},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"p","a":{"class":"zoneName v-normal-top v-medium-bottom"},"f":[{"t":2,"r":"zoneName"}," (",{"t":2,"r":"countries.length"},")"]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ul","a":{"class":"small-block-grid-2 medium-block-grid-4"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"div","a":{"id":["country-",{"t":2,"r":"countryCode"}],"class":["country-select text-center ",{"t":4,"f":["selected"],"n":50,"r":"selected"}]},"v":{"tap":{"n":"selectCountry","d":[{"t":2,"r":"countryCode"}]}},"f":[{"t":7,"e":"div","a":{"class":"flag","style":["background: #e5e5e5 url('",{"t":2,"r":"osgBasePath"},"assets/images/flags/",{"t":2,"r":"countryCode"},".jpg') no-repeat; background-size:cover; background-position: 50%;"]},"f":[]}," ",{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"r":"countryName"}]}]}]}],"n":52,"r":"countries"}]}]}]}],"n":52,"r":"zones"}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"button button-next round light right","ontap":["goToStep:",{"t":2,"x":{"r":["step"],"s":"_0+1"}}],"ariaLabel":["goToStep:",{"t":2,"x":{"r":["step"],"s":"_0+1"}}]},"f":["Next"]}],"n":50,"x":{"r":["selectedCountries","selectedCountries.length"],"s":"_0&&_1>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"class":"button button-next round light right disabled"},"f":["Next"]}],"x":{"r":["selectedCountries","selectedCountries.length"],"s":"_0&&_1>0"}}]}]}]}],"n":50,"x":{"r":["step"],"s":"_0<=1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"input-label"},"f":["COUNTRY"]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","a":{"class":"section-header selected-country"},"f":[{"t":2,"x":{"r":["printSelectedCountries"],"s":"_0()"}}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"right change-country","ontap":"goToStep:1"},"f":["Change"]}]}]}]}]}],"n":50,"x":{"r":["step"],"s":"_0>=2"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"main-header"},"f":[{"t":2,"r":"chooseDurationTitle"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"chooseDurationDesc"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ul","a":{"class":"small-block-grid-1 medium-block-grid-2"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"div","a":{"id":["duration-",{"t":2,"r":"durationId"}],"class":["duration-select text-center ",{"t":4,"f":["selected"],"n":50,"r":"selected"}]},"v":{"tap":{"n":"selectDuration","d":[{"t":2,"r":"durationId"}]}},"f":[{"t":2,"r":"durationName"}]}]}],"n":52,"r":"durations"}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"button button-next round light right","ontap":["goToStep:",{"t":2,"x":{"r":["step"],"s":"_0+1"}}],"ariaLabel":["goToStep:",{"t":2,"x":{"r":["step"],"s":"_0+1"}}]},"f":["Next"]}],"n":50,"x":{"r":["selectedDurations","selectedDurations.length"],"s":"_0&&_1>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"class":"button button-next round light right disabled"},"f":["Next"]}],"x":{"r":["selectedDurations","selectedDurations.length"],"s":"_0&&_1>0"}}]}]}]}]}],"n":50,"x":{"r":["step"],"s":"_0==2"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"input-label"},"f":["DURATION"]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","a":{"class":"section-header selected-duration"},"f":[{"t":2,"x":{"r":["printSelectedDurations"],"s":"_0()"}}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"right change-duration","ontap":"goToStep:2"},"f":["Change"]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-top "},"f":[{"t":7,"e":"ux-col","a":{"class":"p-normal-left"},"f":[{"t":7,"e":"ux-header","a":{"class":"main-header"},"f":[{"t":2,"r":"recommendedPlansTitle"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-top recommended-plans"},"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"v-medium-bottom plan-info p-normal-left p-large-top"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"addon-section p-large-left-medium"},"f":[{"t":7,"e":"ux-addon-singtel","a":{"addon":[{"t":2,"r":"."}]}}]}]}]}],"n":52,"x":{"r":["getAddons"],"s":"_0()"}}," ",{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"v-medium-bottom no-plan"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","a":{"class":"section-header selected-duration"},"f":["Data Roaming plan for this destination is currently unavailable. However, we are constantly working to expand our coverage. Please check back again for updates."]}]}]}]}],"n":50,"r":"noMatchFound"}]}],"n":50,"x":{"r":["step"],"s":"_0>2"}}]}]}]};
this["ux-roaming-table"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-roaming-table"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"headerText"}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"sub-header"},"f":[{"t":2,"r":"subHeaderText"}]}],"n":50,"r":"subHeaderText"}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkURL"}]},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"linkText"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up","style":"padding-bottom: 50px"},"f":[{"t":7,"e":"ux-row","a":{"class":"column-header"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"first-column"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"firstColumn"}]}]}],"n":50,"r":"firstColumn"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["second-column"],"n":50,"r":"firstColumn"},{"t":4,"n":51,"f":["second-column80"],"r":"firstColumn"}]},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"secondColumn"}]}]}],"n":50,"r":"secondColumn"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"third-column"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"thirdColumn"}]}]}],"n":50,"r":"thirdColumn"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"first-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section1Description"}]}]}],"n":50,"r":"section1Description"}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["second-column"],"n":50,"x":{"r":["section1Description","section1Price"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["section1Description","section1Price"],"s":"_0||_1"},"f":["second-column80"]},{"t":4,"n":50,"x":{"r":["section1Description","section1Price"],"s":"!(_0||_1)"},"f":["second-column100"]}],"x":{"r":["section1Description","section1Price"],"s":"_0&&_1"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"inner-column"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"section1CountryList"}]}," ",{"t":7,"e":"ux-col","a":{"class":"third-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section1Price"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"first-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section2Description"}]}]}],"n":50,"r":"section2Description"}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["second-column"],"n":50,"x":{"r":["section2Description","section2Price"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["section2Description","section2Price"],"s":"_0||_1"},"f":["second-column80"]},{"t":4,"n":50,"x":{"r":["section2Description","section2Price"],"s":"!(_0||_1)"},"f":["second-column100"]}],"x":{"r":["section2Description","section2Price"],"s":"_0&&_1"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"inner-column"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"section2CountryList"}]}," ",{"t":7,"e":"ux-col","a":{"class":"third-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section2Price"}]}]}]}],"n":50,"r":"section2CountryList"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"first-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section3Description"}]}]}],"n":50,"r":"section3Description"}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["second-column"],"n":50,"x":{"r":["section3Description","section3Price"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["section3Description","section3Price"],"s":"_0||_1"},"f":["second-column80"]},{"t":4,"n":50,"x":{"r":["section3Description","section3Price"],"s":"!(_0||_1)"},"f":["second-column100"]}],"x":{"r":["section3Description","section3Price"],"s":"_0&&_1"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"inner-column"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"section3CountryList"}]}," ",{"t":7,"e":"ux-col","a":{"class":"third-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section3Price"}]}]}]}],"n":50,"r":"section3CountryList"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"first-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section4Description"}]}]}],"n":50,"r":"section4Description"}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["second-column"],"n":50,"x":{"r":["section4Description","section4Price"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["section4Description","section4Price"],"s":"_0||_1"},"f":["second-column80"]},{"t":4,"n":50,"x":{"r":["section4Description","section4Price"],"s":"!(_0||_1)"},"f":["second-column100"]}],"x":{"r":["section4Description","section4Price"],"s":"_0&&_1"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"inner-column"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"section4CountryList"}]}," ",{"t":7,"e":"ux-col","a":{"class":"third-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section4Price"}]}]}]}],"n":50,"r":"section4CountryList"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"first-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section5Description"}]}]}],"n":50,"r":"section5Description"}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["second-column"],"n":50,"x":{"r":["section5Description","section5Price"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["section5Description","section5Price"],"s":"_0||_1"},"f":["second-column80"]},{"t":4,"n":50,"x":{"r":["section5Description","section5Price"],"s":"!(_0||_1)"},"f":["second-column100"]}],"x":{"r":["section5Description","section5Price"],"s":"_0&&_1"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"inner-column"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"section5CountryList"}]}," ",{"t":7,"e":"ux-col","a":{"class":"third-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section5Price"}]}]}]}],"n":50,"r":"section5CountryList"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"first-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section6Description"}]}]}],"n":50,"r":"section6Description"}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["second-column"],"n":50,"x":{"r":["section6Description","section6Price"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["section6Description","section6Price"],"s":"_0||_1"},"f":["second-column80"]},{"t":4,"n":50,"x":{"r":["section6Description","section6Price"],"s":"!(_0||_1)"},"f":["second-column100"]}],"x":{"r":["section6Description","section6Price"],"s":"_0&&_1"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"inner-column"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"section6CountryList"}]}," ",{"t":7,"e":"ux-col","a":{"class":"third-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section6Price"}]}]}]}],"n":50,"r":"section6CountryList"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"first-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section7Description"}]}]}],"n":50,"r":"section7Description"}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["second-column"],"n":50,"x":{"r":["section7Description","section7Price"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["section7Description","section7Price"],"s":"_0||_1"},"f":["second-column80"]},{"t":4,"n":50,"x":{"r":["section7Description","section7Price"],"s":"!(_0||_1)"},"f":["second-column100"]}],"x":{"r":["section7Description","section7Price"],"s":"_0&&_1"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"inner-column"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"section7CountryList"}]}," ",{"t":7,"e":"ux-col","a":{"class":"third-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section7Price"}]}]}]}],"n":50,"r":"section7CountryList"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"first-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section8Description"}]}]}],"n":50,"r":"section8Description"}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["second-column"],"n":50,"x":{"r":["section8Description","section8Price"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["section8Description","section8Price"],"s":"_0||_1"},"f":["second-column80"]},{"t":4,"n":50,"x":{"r":["section8Description","section8Price"],"s":"!(_0||_1)"},"f":["second-column100"]}],"x":{"r":["section8Description","section8Price"],"s":"_0&&_1"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"inner-column"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"section8CountryList"}]}," ",{"t":7,"e":"ux-col","a":{"class":"third-column"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section8Price"}]}]}]}],"n":50,"r":"section8CountryList"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only","style":"padding-bottom: 20px;"},"f":[{"t":7,"e":"ux-row","a":{"class":"description-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"firstColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section1Description"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"price-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"thirdColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section1Price"}]}]}]}],"n":50,"r":"thirdColumn"}," ",{"t":7,"e":"ux-accordion","a":{"class":"country-accordion","data":[{"t":3,"r":"."}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","a":{"class":"accordion-anchor"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"left subsection-header"},"f":["View Service Coverage"]}]}]}," ",{"t":7,"e":"ux-content","f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","a":{"style":"padding-bottom: 20px;"},"f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"data.section1CountryList"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"description-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"firstColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section2Description"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"price-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"thirdColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section2Price"}]}]}]}],"n":50,"r":"thirdColumn"}," ",{"t":7,"e":"ux-accordion","a":{"class":"country-accordion","data":[{"t":3,"r":"."}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","a":{"class":"accordion-anchor"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"left subsection-header"},"f":["View Service Coverage"]}]}]}," ",{"t":7,"e":"ux-content","f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","a":{"style":"padding-bottom: 20px;"},"f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"data.section2CountryList"}]}]}]}]}],"n":50,"r":"section2CountryList"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"description-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"firstColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section3Description"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"price-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"thirdColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section3Price"}]}]}]}],"n":50,"r":"thirdColumn"}," ",{"t":7,"e":"ux-accordion","a":{"class":"country-accordion","data":[{"t":3,"r":"."}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","a":{"class":"accordion-anchor"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"left subsection-header"},"f":["View Service Coverage"]}]}]}," ",{"t":7,"e":"ux-content","f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","a":{"style":"padding-bottom: 20px;"},"f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"data.section3CountryList"}]}]}]}]}],"n":50,"r":"section3CountryList"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"description-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"firstColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section4Description"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"price-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"thirdColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section4Price"}]}]}]}],"n":50,"r":"thirdColumn"}," ",{"t":7,"e":"ux-accordion","a":{"class":"country-accordion","data":[{"t":3,"r":"."}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","a":{"class":"accordion-anchor"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"left subsection-header"},"f":["View Service Coverage"]}]}]}," ",{"t":7,"e":"ux-content","f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","a":{"style":"padding-bottom: 20px;"},"f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"data.section4CountryList"}]}]}]}]}],"n":50,"r":"section4CountryList"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"description-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"firstColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section5Description"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"price-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"thirdColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section5Price"}]}]}]}],"n":50,"r":"thirdColumn"}," ",{"t":7,"e":"ux-accordion","a":{"class":"country-accordion","data":[{"t":3,"r":"."}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","a":{"class":"accordion-anchor"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"left subsection-header"},"f":["View Service Coverage"]}]}]}," ",{"t":7,"e":"ux-content","f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","a":{"style":"padding-bottom: 20px;"},"f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"data.section5CountryList"}]}]}]}]}],"n":50,"r":"section5CountryList"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"description-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"firstColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section6Description"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"price-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"thirdColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section6Price"}]}]}]}],"n":50,"r":"thirdColumn"}," ",{"t":7,"e":"ux-accordion","a":{"class":"country-accordion","data":[{"t":3,"r":"."}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","a":{"class":"accordion-anchor"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"left subsection-header"},"f":["View Service Coverage"]}]}]}," ",{"t":7,"e":"ux-content","f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","a":{"style":"padding-bottom: 20px;"},"f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"data.section6CountryList"}]}]}]}]}],"n":50,"r":"section6CountryList"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"description-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"firstColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section7Description"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"price-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"thirdColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section7Price"}]}]}]}],"n":50,"r":"thirdColumn"}," ",{"t":7,"e":"ux-accordion","a":{"class":"country-accordion","data":[{"t":3,"r":"."}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","a":{"class":"accordion-anchor"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"left subsection-header"},"f":["View Service Coverage"]}]}]}," ",{"t":7,"e":"ux-content","f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","a":{"style":"padding-bottom: 20px;"},"f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"data.section7CountryList"}]}]}]}]}],"n":50,"r":"section7CountryList"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"line"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"description-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"firstColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section8Description"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"price-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"thirdColumn"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"section8Price"}]}]}]}],"n":50,"r":"thirdColumn"}," ",{"t":7,"e":"ux-accordion","a":{"class":"country-accordion","data":[{"t":3,"r":"."}]},"f":[{"t":7,"e":"ux-accordionitem","f":[{"t":7,"e":"ux-anchor","a":{"class":"accordion-anchor"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"left subsection-header"},"f":["View Service Coverage"]}]}]}," ",{"t":7,"e":"ux-content","f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"countryName"}]}," ",{"t":7,"e":"p","a":{"style":"padding-bottom: 20px;"},"f":[{"t":2,"r":"telco1"},{"t":4,"f":[", ",{"t":2,"r":"telco2"}],"n":50,"r":"telco2"},{"t":4,"f":[", ",{"t":2,"r":"telco3"}],"n":50,"r":"telco3"}]}]}],"n":52,"r":"data.section8CountryList"}]}]}]}]}],"n":50,"r":"section8CountryList"}]}]}]};
this["ux-rrp-accessories-catalog"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rrp-accessories-catalog"},"f":[{"t":7,"e":"ux-row","a":{"class":"medium-collapse v-normal-top"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6 medium-4 large-4"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up","selectedIndex":[{"t":2,"r":"index"}],"groupId":[{"t":2,"r":"groupId"}],"productUrl":[{"t":2,"r":"productUrl"}]},"v":{"tap":{"n":"doSelectAccessory","d":[{"t":2,"r":"index"}]}},"f":[{"t":7,"e":"div","a":{"class":"panel clearfix rounded panel-m-override"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-top v-normal-bottom rrp-image-height"},"f":[{"t":7,"e":"ux-anchor","a":{"text":[{"t":2,"r":"title"}],"productUrl":[{"t":2,"r":"productUrl"}],"ontap":"doSelectAccessory","selectedIndex":[{"t":2,"r":"index"}]},"f":[{"t":7,"e":"ux-image","a":{"class":"handset-img text-center","img":[{"t":2,"r":"smallImage"}],"isDataModel":"true"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top red subsection-header"},"f":[{"t":2,"r":"ribbon"}]}],"n":50,"r":"ribbon"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"v-small-top red subsection-header hide-tag"},"f":["New"]}],"r":"ribbon"}," ",{"t":7,"e":"div","a":{"class":"product-title v-small-top"},"f":[{"t":7,"e":"div","a":{"class":"singtel-tooltip tooltip-right fix-size"},"o":{"n":"singtelTooltip","a":[{"onmouseover":true,"onclick":true}]},"f":[{"t":7,"e":"ux-crop-text","a":{"text":[{"t":2,"r":"title"}],"desktopChars":[{"t":2,"r":"rrpCropTextConfig.desktopChars"}],"tabletChars":[{"t":2,"r":"rrpCropTextConfig.tabletChars"}],"mobileChars":[{"t":2,"r":"rrpCropTextConfig.mobileChars"}],"showComplete":[{"t":2,"r":"viewMore"}],"elipses":"..."}}," ",{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"width-percent-90 tooltip-padding20 fine-print-text-fix-white text-left"},"f":[{"t":2,"r":"title"}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top v-small-bottom price-box"},"f":[{"t":7,"e":"div","a":{"class":"prices"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"section-description"},"f":["From $",{"t":2,"x":{"r":["minOnetimePrice","maxPaymentTerm"],"s":"(_0/_1).toFixed(2)"}},"/mth ",{"t":7,"e":"br"},"or $",{"t":2,"r":"minOnetimePrice"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"section-description strikeout-text dark-grey-color"},"f":["$",{"t":2,"r":"usualPrice"}]}],"x":{"r":["usualPrice","isDisplayUP"],"s":"_0&&_1"}}]}]}],"n":50,"x":{"r":["ippEnabled","isIppEligible","isIppTermsEnabled","installmentTotalPrice"],"s":"_0&&_1&&_2&&_3>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"section-description"},"f":["From $",{"t":2,"r":"minOnetimePrice"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"section-description strikeout-text dark-grey-color"},"f":["$",{"t":2,"r":"usualPrice"}]}],"x":{"r":["usualPrice","isDisplayUP"],"s":"_0&&_1"}}]}],"x":{"r":["ippEnabled","isIppEligible","isIppTermsEnabled","installmentTotalPrice"],"s":"_0&&_1&&_2&&_3>0"}}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12 v-normal-top hide"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-center select-phones-buttons-wrapper "},"f":[{"t":7,"e":"ux-button","a":{"class":"select-phones-buttons light round","text":"Select","onclick":"doSelectAccessory","selectedIndex":[{"t":2,"r":"index"}]}}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only","selectedIndex":[{"t":2,"r":"index"}],"groupId":[{"t":2,"r":"groupId"}],"productUrl":[{"t":2,"r":"productUrl"}]},"v":{"tap":{"n":"doSelectAccessory","d":[{"t":2,"r":"index"}]}},"f":[{"t":7,"e":"ux-row","a":{"class":"panel rounded"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 v-small-top"},"f":[{"t":7,"e":"ux-anchor","a":{"text":[{"t":2,"r":"title"}],"groupId":[{"t":2,"r":"groupId"}],"productUrl":[{"t":2,"r":"productUrl"}],"selectedIndex":[{"t":2,"r":"index"}],"ontap":"doSelectAccessory"},"f":[{"t":7,"e":"ux-image","a":{"class":"handset-img v-small-top v-small-bottom text-center","img":[{"t":2,"r":"smallImage"}],"isDataModel":"true"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 v-small-top v-small-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"red subsection-header "},"f":[{"t":2,"r":"ribbon"}]}],"n":50,"r":"ribbon"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"red subsection-header hide-tag"},"f":["New"]}],"r":"ribbon"}," ",{"t":7,"e":"div","a":{"class":"product-title v-small-top v-small-bottom fix-size"},"f":[{"t":7,"e":"ux-crop-text","a":{"text":[{"t":2,"r":"title"}],"desktopChars":[{"t":2,"r":"rrpCropTextConfig.desktopChars"}],"tabletChars":[{"t":2,"r":"rrpCropTextConfig.tabletChars"}],"mobileChars":[{"t":2,"r":"rrpCropTextConfig.catalogMobileChars"}],"showComplete":[{"t":2,"r":"viewMore"}],"elipses":"..."}}]}," ",{"t":7,"e":"div","a":{"class":"price-box v-small-bottom"},"f":[{"t":7,"e":"div","a":{"class":"prices"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"section-description"},"f":["From $",{"t":2,"x":{"r":["minOnetimePrice","maxPaymentTerm"],"s":"(_0/_1).toFixed(2)"}},"/mth ",{"t":7,"e":"br"},"or $",{"t":2,"r":"minOnetimePrice"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"section-description strikeout-text dark-grey-color"},"f":["$",{"t":2,"r":"usualPrice"}]}],"x":{"r":["usualPrice","isDisplayUP"],"s":"_0&&_1"}}]}]}],"n":50,"x":{"r":["ippEnabled","isIppEligible","isIppTermsEnabled","installmentTotalPrice"],"s":"_0&&_1&&_2&&_3>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"span","a":{"class":"section-description"},"f":["$",{"t":2,"r":"minOnetimePrice"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"section-description strikeout-text dark-grey-color"},"f":["$",{"t":2,"r":"usualPrice"}]}],"x":{"r":["usualPrice","isDisplayUP"],"s":"_0&&_1"}}]}],"x":{"r":["ippEnabled","isIppEligible","isIppTermsEnabled","installmentTotalPrice"],"s":"_0&&_1&&_2&&_3>0"}}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 v-medium-bottom hide"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-center"},"f":[{"t":7,"e":"ux-button","a":{"class":"light round","text":"Select","onclick":"doSelectAccessory","selectedIndex":[{"t":2,"r":"index"}],"groupId":[{"t":2,"r":"groupId"}],"productUrl":[{"t":2,"r":"productUrl"}]}}]}]}]}]}]}],"n":50,"r":"display"}],"n":52,"i":"index","r":"initData.filteredAccessoriesList"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-12 text-center v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"class":"show-more-accessories","text":"Show More","onclick":"viewMore"}}]}],"n":50,"r":"initData.showButton"}]}]}]};
this["ux-rrp-delivery-details"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rrp-delivery-details"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-bottom-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12 small-12 hide-for-small-only"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-title"},"f":["Standard Delivery"]}," ",{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-container-start"},"f":["Delivery Charge (Normal)"]}," ",{"t":7,"e":"div","a":{"class":"flex-continer-end"},"f":[{"t":2,"x":{"r":["RactiveHelpers","orderDeliveryDetails.deliveryPrice.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"n":50,"x":{"r":["deliveryDiscount"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["deliveryDiscount"],"s":"_0"},"f":[{"t":7,"e":"div","a":{"class":"subsection-title"},"f":["Discount"]}," ",{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-container-start"},"f":["Delivery Charge (Normal)"]}," ",{"t":7,"e":"div","a":{"class":"flex-continer-end"},"f":["-",{"t":2,"x":{"r":["RactiveHelpers","orderDeliveryDetails.deliveryPrice.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}],"x":{"r":["deliveryDiscount"],"s":"!_0"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 show-for-small-only"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-title"},"f":["Standard Delivery"]}," ",{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-container-start"},"f":["Delivery Charge (Normal)"]}," ",{"t":7,"e":"div","a":{"class":"flex-continer-end"},"f":[{"t":2,"x":{"r":["RactiveHelpers","orderDeliveryDetails.deliveryPrice.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"n":50,"x":{"r":["deliveryDiscount"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["deliveryDiscount"],"s":"_0"},"f":[{"t":7,"e":"div","a":{"class":"subsection-title"},"f":["Discount"]}," ",{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-container-start"},"f":["Delivery Charge (Normal)"]}," ",{"t":7,"e":"div","a":{"class":"flex-continer-end"},"f":["-",{"t":2,"x":{"r":["RactiveHelpers","orderDeliveryDetails.deliveryPrice.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}],"x":{"r":["deliveryDiscount"],"s":"!_0"}}]}]}]}]};
this["ux-rrp-delivery-information"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rrp-delivery-information"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"section-header v-normal-top"},"f":["Your Information"]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":3,"x":{"r":["RactiveHelpers","initData.deliveryDescription"],"s":"_0.unescapeString(_1)"}}]}],"n":50,"x":{"r":["isOrderSummary"],"s":"!_0"}}]}],"n":50,"x":{"r":["hideTitle"],"s":"!_0"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-large-top v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":["Delivery Details"]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"flex-container-end","ontap":"onChangeDeliveryAdressLinkClick"},"f":["Change"]}],"n":50,"x":{"r":["hideChangeLink"],"s":"!_0"}}," "]}," ",{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["getDeliveryDate"],"s":"_0()"}}]}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"orderDeliveryDetails.deliveryTime"}],"n":50,"r":"isIpp"},{"t":4,"n":51,"f":[{"t":2,"r":"orderDeliveryDetails.timeDescription"}],"r":"isIpp"}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ux-singtel-address","a":{"addressType":"physicalAddressMultiline","address":[{"t":2,"x":{"r":["orderDeliveryDetails.deliveryAddress","getDeliveryAddress"],"s":"_0||_1()"}}],"isRrp":[{"t":2,"x":{"r":[],"s":"true"}}],"useOriginalCase":[{"t":2,"x":{"r":[],"s":"true"}}],"capitalize":[{"t":2,"x":{"r":[],"s":"true"}}]},"f":[]}]}]}]}]}]};
this["ux-rrp-discount-item"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rrp-discount-item"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 small-12"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-title"},"f":[{"t":7,"e":"div","f":["Discount"]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"promotion.couponCode"}]}],"n":50,"x":{"r":["promotion.promoSubType"],"s":"_0===\"COUPON\""}}]}," ",{"t":7,"e":"div","a":{"class":"hide-for-small-only"},"f":[{"t":2,"x":{"r":["promotion.promoText","promotion.name"],"s":"_0||_1"}}]}],"n":50,"r":"isOrderSummary"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"subsection-title"},"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"promotion.couponCode"}]}],"n":50,"x":{"r":["promotion.promoSubType"],"s":"_0===\"COUPON\""}}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["promotion.promoText","promotion.name"],"s":"_0||_1"}}]}]}],"r":"isOrderSummary"}]}," ",{"t":7,"e":"ux-col","a":{"class":["medium-6 medium-text-right ",{"t":4,"f":["v-medium-top"],"n":50,"r":"isOrderSummary"}," body-light hide-for-small-only"]},"f":[{"t":2,"x":{"r":["RactiveHelpers","promotion.price.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 show-for-small-only body-light"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-container-start"},"f":[{"t":2,"x":{"r":["promotion.promoText","promotion.name"],"s":"_0||_1"}}]}," ",{"t":7,"e":"div","a":{"class":"flex-continer-end"},"f":[{"t":2,"x":{"r":["RactiveHelpers","promotion.price.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"n":50,"r":"isOrderSummary"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["RactiveHelpers","promotion.price.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}}],"r":"isOrderSummary"}]}]}]}]};
this["ux-rrp-group-item"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-rrp-group-item ",{"t":2,"r":"class"}," v-normal-bottom v-right ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["isEnabled","isAvailable"],"s":"_0&&_1"}}," ",{"t":4,"f":["disabled no-stock-line "],"n":50,"x":{"r":["isAvailable"],"s":"!_0"}},{"t":2,"x":{"r":["isSelected"],"s":"_0?\"selected\":\"\""}}]},"v":{"tap":"selectGroupItem"},"f":[{"t":16}," "]}]};
this["ux-rrp-image-gallery"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-rrp-image-gallery ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}," center"]},"f":[{"t":7,"e":"img","a":{"class":"gallery-image","src":[{"t":2,"r":"selectedImage"}]}}," ",{"t":7,"e":"div","a":{"class":"color-selection"},"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":["image-thumb ",{"t":2,"x":{"r":["selectedImage","."],"s":"_0===_1?\"selected\":\"\""}}]},"v":{"tap":{"n":"doShowSelectedImage","d":[{"t":2,"r":"."}]}},"f":[]}],"n":52,"r":"images"}]}]}]}]};
this["ux-rrp-order-item"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-rrp-order-item"},"f":[{"t":7,"e":"div","a":{"class":"hide-for-small-only"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 small-12 v-normal-right-mobile"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"subsection-title"},"f":[{"t":4,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"},", ",{"t":2,"r":"productDetails.size"}],"n":50,"r":"productDetails.size"},{"t":4,"n":51,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"}],"r":"productDetails.size"}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"span","f":["Singtel PayLater (",{"t":2,"r":"productDetails.numberOfInstalment"}," months, 0% interest)"]}]}],"n":50,"r":"isOrderSummary"},{"t":4,"n":51,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"v-normal-bottom subsection-title"},"f":[{"t":4,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"},", ",{"t":2,"r":"productDetails.size"}],"n":50,"r":"productDetails.size"},{"t":4,"n":51,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"}],"r":"productDetails.size"}]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","f":["Singtel PayLater (",{"t":2,"r":"productDetails.numberOfInstalment"}," months, 0% interest)"]}]}],"r":"isOrderSummary"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4 small-12 medium-text-right small-only-text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyPrice.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}},"/mth ",{"t":4,"f":[{"t":7,"e":"br"}," ",{"t":7,"e":"span","f":[{"t":7,"e":"ux-anchor","a":{"ontap":"removeAllSkusIPP"},"f":["Remove"]}]}],"n":50,"x":{"r":["isOrderSummary"],"s":"!_0"}}]}]}],"n":50,"r":"isIpp"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 small-12 v-normal-right-mobile"},"f":[{"t":4,"f":[" ",{"t":7,"e":"div","a":{"class":"subsection-title"},"f":[{"t":4,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"},", ",{"t":2,"r":"productDetails.size"}],"n":50,"r":"productDetails.size"},{"t":4,"n":51,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"}],"r":"productDetails.size"}]}," ",{"t":7,"e":"div","f":["Quantity: ",{"t":2,"r":"quantity"}]}],"n":50,"r":"isOrderSummary"},{"t":4,"n":51,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"subsection-title"},"f":[{"t":4,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"},", ",{"t":2,"r":"productDetails.size"}],"n":50,"r":"productDetails.size"},{"t":4,"n":51,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"}],"r":"productDetails.size"}]}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"ux-quantity-alteration","a":{"selectedQty":[{"t":2,"r":"quantity"}],"maxValue":[{"t":2,"r":"maxAllowedQty"}],"minValue":[{"t":2,"r":"minAllowedQty"}],"originalQuantity":[{"t":2,"r":"originalQuantity"}],"initData":[{"t":2,"r":"initData"}],"totalCount":[{"t":2,"r":"totalCount"}],"isShoppingCart":[{"t":2,"x":{"r":[],"s":"true"}}]}}]}],"r":"isOrderSummary"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4 small-12 medium-text-right small-only-text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","actualPrice.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}}," ",{"t":4,"f":[{"t":7,"e":"br"}," ",{"t":7,"e":"span","f":[{"t":7,"e":"ux-anchor","a":{"ontap":"removeAllSkus"},"f":["Remove"]}]}],"n":50,"x":{"r":["isOrderSummary"],"s":"!_0"}}]}]}],"r":"isIpp"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 small-12 v-normal-right-mobile"},"f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-container-start p-large-right"},"f":[{"t":7,"e":"div","a":{"class":"subsection-title"},"f":[{"t":4,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"},", ",{"t":2,"r":"productDetails.size"}],"n":50,"r":"productDetails.size"},{"t":4,"n":51,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"}],"r":"productDetails.size"}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"v-normal-bottom"},"f":["Singtel PayLater (",{"t":2,"r":"productDetails.numberOfInstalment"}," months, 0% interest)"]}]}]}," ",{"t":7,"e":"div","a":{"class":"flex-container-end flex-item-top-align"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyPrice.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}},"/mth"]}]}]}]}],"n":50,"r":"isOrderSummary"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 small-6 v-normal-right-mobile"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"subsection-title v-normal-bottom"},"f":[{"t":4,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"},", ",{"t":2,"r":"productDetails.size"}],"n":50,"r":"productDetails.size"},{"t":4,"n":51,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"}],"r":"productDetails.size"}]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","f":["Singtel PayLater (",{"t":2,"r":"productDetails.numberOfInstalment"}," months, 0% interest)"]}]}]}," ",{"t":7,"e":"div","a":{"style":"text-align: right; margin-right: 1rem;"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyPrice.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}},"/mth ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","f":[{"t":7,"e":"ux-anchor","a":{"ontap":"removeAllSkusIPP"},"f":["Remove"]}]}]}]}],"r":"isOrderSummary"}],"n":50,"r":"isIpp"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 small-12 v-normal-right-mobile"},"f":[" ",{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-container-start subsection-header p-large-right"},"f":[{"t":4,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"},", ",{"t":2,"r":"productDetails.size"}],"n":50,"r":"productDetails.size"},{"t":4,"n":51,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"}],"r":"productDetails.size"}]}," ",{"t":7,"e":"div","a":{"class":"flex-container-end"},"f":[{"t":2,"x":{"r":["RactiveHelpers","actualPrice.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4 small-12 body-light v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-container-start"},"f":[{"t":7,"e":"div","a":{"class":"subsection-title"},"f":["Quantity: ",{"t":2,"r":"quantity"}]}]}]}]}]}],"n":50,"r":"isOrderSummary"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-offset-2 medium-6 small-7 v-normal-right-mobile"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"subsection-title"},"f":[{"t":4,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"},", ",{"t":2,"r":"productDetails.size"}],"n":50,"r":"productDetails.size"},{"t":4,"n":51,"f":[{"t":2,"r":"productDetails.title"},", ",{"t":2,"r":"productDetails.color"}],"r":"productDetails.size"}]}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-quantity-alteration","a":{"selectedQty":[{"t":2,"r":"quantity"}],"maxValue":[{"t":2,"r":"maxAllowedQty"}],"minValue":[{"t":2,"r":"minAllowedQty"}],"originalQuantity":[{"t":2,"r":"originalQuantity"}],"initData":[{"t":2,"r":"initData"}],"totalCount":[{"t":2,"r":"totalCount"}]}}],"n":50,"x":{"r":["readOnlyCounter"],"s":"!_0"}}]}]}," ",{"t":7,"e":"div","a":{"style":"text-align: right; margin-right: 1rem;"},"f":[{"t":2,"x":{"r":["RactiveHelpers","actualPrice.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","f":[{"t":7,"e":"ux-anchor","a":{"ontap":"removeAllSkus"},"f":["Remove"]}]}]}]}],"r":"isOrderSummary"}],"r":"isIpp"}]}]}],"n":53,"r":"orderItem"}]};
this["ux-rrp-order-summary"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rrp-summary-accordion"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-normal-bottom-mobile subsection-title"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-5 medium-offset-1"},"f":[{"t":2,"r":"initData.cartSummary"}]}," ",{"t":7,"e":"ux-col","a":{"class":"hide-for-small-only medium-5 medium-text-center text-right"},"f":[{"t":2,"r":"initData.feeHeader"}," ",{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"o":{"n":"singtelTooltip","a":[{"onmouseover":false,"onclick":true}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}]}," ",{"t":7,"e":"div","a":{"class":"tooltiptext tooltiptext-inverse flex-container flex-container-column"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-arrow tooltip-arrow-class v-medium-left flex-item"}}," ",{"t":7,"e":"ux-row","a":{"class":"flex-item flex-item-top-align"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12 fine-print-text-fix-white text-left"},"f":[{"t":2,"r":"initData.toolTip"}]}]}]}]}]}]}]}]};
this["ux-rrp-ordersummary-row"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rrp-ordersummary-row"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-offset1 small-9"},"f":[]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-offset1 small-2"},"f":[]}]}]}]};
this["ux-rrp-payment-term-item"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"main-header v-large-top"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","selectedVariant.price"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"span","a":{"class":"strike-through-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","selectedVariant.usualPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}],"n":50,"x":{"r":["selectedVariant.usualPrice","selectedVariant.price"],"s":"_0&&_0>_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","selectedVariant.price"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"x":{"r":["selectedVariant.usualPrice","selectedVariant.price"],"s":"_0&&_0>_1"}}],"n":50,"r":"selectedVariant"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","minOneTimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"span","a":{"class":"strike-through-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","usualPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}],"n":50,"x":{"r":["usualPrice","minOneTimePrice"],"s":"_0&&_0>_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","minOneTimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"x":{"r":["usualPrice","minOneTimePrice"],"s":"_0&&_0>_1"}}],"r":"initData.accessoryDetails"}],"r":"selectedVariant"}]}],"n":50,"x":{"r":["ippEnabled"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-rrp-payment-term-item v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":["Choose Payment Term"]}," ",{"t":7,"e":"div","a":{"class":["term-main row ",{"t":2,"x":{"r":["selectedVariant","enablePaymentTerm"],"s":"(_0&&_1)?\"\":\"disabled\""}}]},"f":[{"t":7,"e":"div","a":{"class":["term-tile v-medium-right p-medium-left v-medium-top ",{"t":4,"f":["selected"],"n":50,"x":{"r":["selectedTerm"],"s":"_0===\"0\""}}]},"v":{"tap":{"n":"onPaymentTermClick","d":[{"t":2,"x":{"r":[],"s":"\"0\""}}]}},"f":[{"t":7,"e":"span","a":{"class":"installment"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","minOneTimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}," ",{"t":7,"e":"span","a":{"class":["strike-through-dollar ",{"t":2,"x":{"r":["selectedVariant","enablePaymentTerm"],"s":"(_0&&_1)?\"\":\"disabled\""}}]},"f":[{"t":2,"x":{"r":["RactiveHelpers","usualPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["usualPrice","minOneTimePrice"],"s":"_0&&_0>_1"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["RactiveHelpers","minOneTimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}],"x":{"r":["usualPrice","minOneTimePrice"],"s":"_0&&_0>_1"}}]}," ",{"t":7,"e":"span","a":{"class":"months"},"f":["Full price"]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["term-tile v-medium-right p-medium-left v-medium-top ",{"t":4,"f":["disabled"],"n":50,"r":"payInFull"}," ",{"t":4,"f":["selected"],"n":50,"x":{"r":["selectedTerm"],"s":"_0===\"12\""}}]},"v":{"tap":{"n":"onPaymentTermClick","d":[{"t":2,"x":{"r":[],"s":"\"12\""}}]}},"f":[{"t":7,"e":"span","a":{"class":"installment"},"f":[{"t":2,"x":{"r":["RactiveHelpers","minOneTimePrice"],"s":"_0.convertUnits(_1/12,\"$\")"}},"/mth"]}," ",{"t":7,"e":"span","a":{"class":"months"},"f":["For 12 months"]}]}],"n":50,"r":"is12MonthEnabled"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["term-tile v-medium-right p-medium-left v-medium-top ",{"t":4,"f":["disabled"],"n":50,"r":"payInFull"}," ",{"t":4,"f":["selected"],"n":50,"x":{"r":["selectedTerm"],"s":"_0===\"24\""}}]},"v":{"tap":{"n":"onPaymentTermClick","d":[{"t":2,"x":{"r":[],"s":"\"24\""}}]}},"f":[{"t":7,"e":"span","a":{"class":"installment"},"f":[{"t":2,"x":{"r":["RactiveHelpers","minOneTimePrice"],"s":"_0.convertUnits(_1/24,\"$\")"}},"/mth"]}," ",{"t":7,"e":"span","a":{"class":"months"},"f":["For 24 months"]}]}],"n":50,"r":"is24MonthEnabled"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["term-tile v-medium-right p-medium-left v-medium-top ",{"t":4,"f":["disabled"],"n":50,"r":"payInFull"}," ",{"t":4,"f":["selected"],"n":50,"x":{"r":["selectedTerm"],"s":"_0===\"36\""}}]},"v":{"tap":{"n":"onPaymentTermClick","d":[{"t":2,"x":{"r":[],"s":"\"36\""}}]}},"f":[{"t":7,"e":"span","a":{"class":"installment"},"f":[{"t":2,"x":{"r":["RactiveHelpers","minOneTimePrice"],"s":"_0.convertUnits(_1/36,\"$\")"}},"/mth"]}," ",{"t":7,"e":"span","a":{"class":"months"},"f":["For 36 months"]}]}],"n":50,"r":"is36MonthEnabled"}],"n":50,"x":{"r":["ippOrderId","isIppEligible"],"s":"!_0&&_1"}}]}," ",{"t":7,"e":"div","a":{"class":"v-large-top"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","minOneTimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"span","a":{"class":"strike-through-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","usualPrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["usualPrice","minOneTimePrice"],"s":"_0&&_0>_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","minOneTimePrice"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"x":{"r":["usualPrice","minOneTimePrice"],"s":"_0&&_0>_1"}}],"n":50,"x":{"r":["selectedTerm"],"s":"_0==\"0\""}}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","minOneTimePrice"],"s":"_0.convertUnits(_1/12,\"$\")"}},"/mth"]}],"n":50,"x":{"r":["selectedTerm"],"s":"_0==\"12\""}}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","minOneTimePrice"],"s":"_0.convertUnits(_1/24,\"$\")"}},"/mth"]}],"n":50,"x":{"r":["selectedTerm"],"s":"_0==\"24\""}}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","minOneTimePrice"],"s":"_0.convertUnits(_1/36,\"$\")"}},"/mth"]}],"n":50,"x":{"r":["selectedTerm"],"s":"_0==\"36\""}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-top p-normal-bottom"},"f":[{"t":7,"e":"ux-replace-text","a":{"text":[{"t":3,"r":"paymentNote"}],"KEY_SELECTED_TERM":"12"},"f":[]}]}],"n":50,"x":{"r":["selectedTerm"],"s":"_0===\"12\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-top p-normal-bottom"},"f":[{"t":7,"e":"ux-replace-text","a":{"text":[{"t":3,"r":"paymentNote"}],"KEY_SELECTED_TERM":"24"},"f":[]}]}],"n":50,"x":{"r":["selectedTerm"],"s":"_0===\"24\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-copy-text v-medium-top p-normal-bottom"},"f":[{"t":7,"e":"ux-replace-text","a":{"text":[{"t":3,"r":"paymentNote"}],"KEY_SELECTED_TERM":"36"},"f":[]}]}],"n":50,"x":{"r":["selectedTerm"],"s":"_0===\"36\""}}]}],"n":50,"x":{"r":["minOneTimePrice","selectedTerm"],"s":"_0||_1"}}],"x":{"r":["ippEnabled"],"s":"!_0"}}]};
this["ux-rrp-personal-information"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rrp-personal-information"},"f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":["Billing Details"]}," "]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"r":"customerDetails.fullName"}]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"r":"customerDetails.contactNumber"}]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"r":"customerDetails.emailId"}]}],"n":50,"r":"isIpp"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"r":"customerDetails.name"}]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"r":"customerDetails.phone"}]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"r":"customerDetails.email"}]}],"r":"isIpp"}," "]}]};
this["ux-rrp-price-item"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rrp-summary-accordion"},"f":[{"t":7,"e":"div","a":{"class":"hide-for-small-only"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6 medium-6"},"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"r":"headerClass"}]},"f":[{"t":2,"r":"priceHeader"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":["small-6 medium-6 medium-text-right text-right v-medium-top-medium ",{"t":2,"r":"amountClass"}]},"f":[{"t":2,"x":{"r":["RactiveHelpers","priceAmount"],"s":"_0.convertUnits(_1,\"$\")"}},{"t":4,"f":["/mth"],"n":50,"x":{"r":["priceHeader"],"s":"_0===\"Monthly Bill\""}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 ",{"t":2,"r":"headerClass"}]},"f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-container-start"},"f":[{"t":7,"e":"div","a":{"class":"subsection-title"},"f":[{"t":2,"r":"priceHeader"}]}]}," ",{"t":7,"e":"div","a":{"class":["flex-container-end ",{"t":2,"r":"amountClass"}]},"f":[{"t":2,"x":{"r":["RactiveHelpers","priceAmount"],"s":"_0.convertUnits(_1,\"$\")"}},{"t":4,"f":["/mth"],"n":50,"x":{"r":["priceHeader"],"s":"_0===\"Monthly Bill\""}}]}]}]}]}]}]}]};
this["ux-rrp-promo-code"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rrp-promo-code"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 small-6"},"f":[" ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"couponPromo.promoText"}]}],"n":50,"r":"couponPromo"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-offset-1 medium-5 small-6 medium-text-right small-only-text-right body-light"},"f":[{"t":2,"x":{"r":["RactiveHelpers","couponPromo.price.afterTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"couponPromo"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4 small-8"},"f":[{"t":7,"e":"ux-input-box","a":{"validity":[{"t":2,"r":"promoCodeErrorMsg"}],"id":"promoCode","disabled":[{"t":2,"x":{"r":["couponPromo"],"s":"_0?true:false"}}],"class":"input-no-margin","value":[{"t":2,"r":"promoCode"}],"placeholder":[{"t":2,"r":"initData.promoCodeHeader"}]},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3 small-3","style":"margin-left: -10px !important;"},"f":[{"t":7,"e":"ux-button","a":{"class":"round margin-zero","onclick":"applyPromoBtnClick"},"f":["Apply"]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-9"},"f":[{"t":7,"e":"ux-input-box","a":{"validity":[{"t":2,"r":"promoCodeErrorMsg"}],"id":"promoCode","disabled":[{"t":2,"x":{"r":["couponPromo"],"s":"_0?true:false"}}],"class":"input-no-margin","value":[{"t":2,"r":"promoCode"}],"placeholder":[{"t":2,"r":"initData.promoCodeHeader"}]},"f":[]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-button","a":{"class":"expand-for-mobile round margin-zero","onclick":"applyPromoBtnClick"},"f":["Apply"]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 small-6"},"f":[{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"removePromoLinkClick"},"f":["Remove"]}]}]}],"n":50,"r":"couponPromo"}]}]};
this["ux-rrp-summary-accordion"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rrp-summary-accordion"},"f":[{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top-mobile v-medium-bottom-mobile"},"f":[{"t":4,"f":[" ",{"t":7,"e":"span"}],"n":50,"r":"isOrderSummary"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-1"}}],"r":"isOrderSummary"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-rrp-order-item","a":{"readOnlyCounter":[{"t":2,"r":"readOnlyCounter"}],"isOrderSummary":[{"t":2,"r":"isOrderSummary"}],"isChangeble":[{"t":2,"r":"isChangeble"}],"orderItem":[{"t":2,"r":"."}],"initData":[{"t":2,"r":"initData"}],"totalCount":[{"t":2,"r":"totalCount"}]},"f":[]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-top-mobile  v-large-bottom-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]}],"n":52,"r":"rrpOrderTopic.orderDetails.orderItems"}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-rrp-discount-item","a":{"isOrderSummary":[{"t":2,"r":"isOrderSummary"}],"rrpOrderTopic":[{"t":2,"r":"rrpOrderTopic"}],"promotion":[{"t":2,"r":"."}]},"f":[]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-top-mobile  v-large-bottom-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]}],"n":50,"x":{"r":["promoSubType","showPromoCodeDiscount"],"s":"_0!==\"COUPON\"||_1"}}],"n":50,"r":"isOrderSummary"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-rrp-discount-item","a":{"isOrderSummary":[{"t":2,"r":"isOrderSummary"}],"rrpOrderTopic":[{"t":2,"r":"rrpOrderTopic"}],"promotion":[{"t":2,"r":"."}]},"f":[]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-top-mobile  v-large-bottom-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]}],"r":"isOrderSummary"}],"n":52,"r":"rrpOrderTopic.orderDetails.promotions"}," ",{"t":4,"f":[" ",{"t":4,"f":[{"t":7,"e":"ux-rrp-order-item","a":{"readOnlyCounter":[{"t":2,"r":"readOnlyCounter"}],"isOrderSummary":[{"t":2,"r":"isOrderSummary"}],"isChangeble":[{"t":2,"r":"isChangeble"}],"orderItem":[{"t":2,"r":"."}],"isIpp":[{"t":2,"x":{"r":[],"s":"true"}}],"initData":[{"t":2,"r":"initData"}],"totalCount":[{"t":2,"r":"totalCount"}]},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom-mobile v-normal-top-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]}],"n":51,"r":"isOrderSummary"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top-mobile  v-large-bottom-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]}],"n":50,"r":"isOrderSummary"}],"n":52,"r":"rrpOrderTopic.orderDetails.ippOrderItems"}],"n":50,"x":{"r":["rrpOrderTopic.orderDetails.ippOrderItems","rrpOrderTopic.orderDetails.ippOrderItems.length"],"s":"_0&&_1>0"}}," ",{"t":4,"f":[{"t":7,"e":"ux-rrp-delivery-details","a":{"deliveryDiscount":"false","orderDeliveryDetails":[{"t":2,"r":"rrpOrderTopic.orderDetails.orderDeliveryDetails"}]},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up v-small-top v-small-bottom"},"f":[]}," ",{"t":7,"e":"ux-rrp-delivery-details","a":{"deliveryDiscount":"true","orderDeliveryDetails":[{"t":2,"r":"rrpOrderTopic.orderDetails.orderDeliveryDetails"}]},"f":[]}],"n":50,"r":"rrpOrderTopic.orderDetails.showDeliveryDiscount"}],"n":50,"r":"rrpOrderTopic.orderDetails.orderDeliveryDetails"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top-mobile v-large-bottom-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]}," ",{"t":7,"e":"ux-rrp-promo-code","a":{"promotions":[{"t":2,"r":"rrpOrderTopic.orderDetails.promotions"}],"rrpOrderTopic":[{"t":2,"r":"rrpOrderTopic"}],"initData":[{"t":2,"r":"initData"}]},"f":[]}],"n":50,"r":"showPromoSection"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top-mobile  v-large-bottom-mobile"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]}],"n":50,"x":{"r":["showPromoSection","rrpOrderTopic.orderDetails.orderDeliveryDetails"],"s":"_0||_1"}}," ",{"t":7,"e":"ux-rrp-price-item","a":{"priceHeader":[{"t":3,"x":{"r":["initData.finalFee"],"s":"_0||\"Your total today\""}}],"headerClass":["subsection-title v-normal-bottom ",{"t":4,"f":["v-medium-top-medium"],"n":50,"r":"isOrderSummary"}],"toolTipEnabled":"true","priceAmount":[{"t":2,"r":"rrpOrderTopic.orderDetails.actualPrice.afterTax"}]}}],"n":50,"x":{"r":["isTotalHidden"],"s":"!_0"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-rrp-price-item","a":{"priceHeader":"Monthly Bill","headerClass":["subsection-title ",{"t":4,"f":["v-medium-top-medium"],"n":50,"r":"isOrderSummary"}],"toolTipEnabled":"true","priceAmount":[{"t":2,"r":"rrpOrderTopic.orderDetails.actualPrice.recurringAmount"}]}}],"n":50,"x":{"r":["rrpOrderTopic.orderDetails.ippOrderItems","rrpOrderTopic.orderDetails.ippOrderItems.length"],"s":"_0&&_1>0"}}],"n":50,"x":{"r":["isOrderSummary","isOrderConfirmation"],"s":"!_0||_1"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-12"},"f":["Payment will be charged to your monthly Singtel bill."]}]}],"n":50,"x":{"r":["rrpOrderTopic.orderDetails.ippOrderItems","rrpOrderTopic.orderDetails.ippOrderItems.length"],"s":"_0&&_1>0"}}],"n":50,"x":{"r":["isOrderSummary","isOrderConfirmation"],"s":"!_0||_1"}}]}]}]}]};
this["ux-rrp-summarydata-row"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-summarydata-row"},"f":[{"t":7,"e":"div","a":{"class":"hide-for-small-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-10 medium-offset-1"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}," ",{"t":7,"e":"ux-row","a":{"class":"row-title"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-10 medium-offset-1"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"left subsection-header row-title"},"f":[{"t":2,"r":"rowTitle"}]}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-4 medium-offset-1"},"f":[{"t":4,"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"image"}],"class":"phone-img right"}}],"n":50,"r":"image"}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":7,"e":"div","a":{"class":"left row-data"},"f":[{"t":3,"r":"rowData"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"removeState"}],"ontap":"removeCartItem","index":[{"t":2,"r":"i"}]},"f":[{"t":4,"f":["Change"],"n":50,"x":{"r":["id"],"s":"_0===\"stb\""}},{"t":4,"n":51,"f":["Remove"],"x":{"r":["id"],"s":"_0===\"stb\""}}]}],"n":51,"r":"hideRemoveLink"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-2 checkout-price"},"f":[{"t":7,"e":"div","a":{"class":"body-light right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"checkoutPrice.finalAmountIncludingTax"}],"n":50,"r":"checkoutPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"checkoutPrice.finalAmountIncludingTax"}],"n":50,"x":{"r":["displayAs"],"s":"_0==\"free\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["displayAs"],"s":"_0==\"strikedout\""},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-text"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"checkoutPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"checkoutPrice.finalAmountIncludingTax"}]},{"t":4,"n":50,"x":{"r":["displayAs"],"s":"!(_0==\"strikedout\")"},"f":[" ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"checkoutPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[{"t":4,"f":["$0.00"],"n":50,"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}},{"t":4,"n":51,"f":[" "],"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}}],"r":"checkoutPrice.finalAmountIncludingTax"}]}],"x":{"r":["displayAs"],"s":"_0==\"free\""}}]}]}]}],"n":51,"r":"hideDisplay"}],"i":"i","r":"rowDetails"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"row-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"left subsection-title row-title"},"f":[{"t":2,"r":"rowTitle"}]}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"image"}],"class":"phone-img right"}}],"n":50,"r":"image"}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":7,"e":"div","a":{"class":"left row-data"},"f":[{"t":3,"r":"rowData"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"removeState"}],"ontap":"removeCartItem"},"f":[{"t":4,"f":["Change"],"n":50,"x":{"r":["id"],"s":"_0===\"stb\""}},{"t":4,"n":51,"f":["Remove"],"x":{"r":["id"],"s":"_0===\"stb\""}}]}],"n":51,"r":"hideRemoveLink"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom row-bottom-border"},"f":[{"t":7,"e":"ux-row","a":{"class":"checkout-price v-small-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 subsection-title"},"f":["Upfront Fee"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"checkoutPrice.finalAmountIncludingTax"}],"n":50,"r":"checkoutPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"checkoutPrice.finalAmountIncludingTax"}],"n":50,"x":{"r":["displayAs"],"s":"_0==\"free\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["displayAs"],"s":"_0==\"strikedout\""},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-text"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"checkoutPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"checkoutPrice.finalAmountIncludingTax"}]},{"t":4,"n":50,"x":{"r":["displayAs"],"s":"!(_0==\"strikedout\")"},"f":[" ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"checkoutPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[{"t":4,"f":["$0.00"],"n":50,"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}},{"t":4,"n":51,"f":[" "],"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}}],"r":"checkoutPrice.finalAmountIncludingTax"}]}],"x":{"r":["displayAs"],"s":"_0==\"free\""}}]}]}]}],"n":51,"r":"hideDisplay"}],"r":"rowDetails"}]}]}],"n":50,"r":"rowTitle"}]};
this["ux-rrp-summarytitle-row"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-summarytitle-row ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"small-1"},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icon"}],"size":"xl"}}]}," ",{"t":7,"e":"ux-col","a":{"class":["small-4 ",{"t":4,"f":["small-8"],"n":50,"r":"shoppingCartPanel"}]},"f":[{"t":7,"e":"div","a":{"class":"section-header category"},"f":[{"t":7,"e":"div","a":{"class":"left v-medium-top"},"f":[{"t":2,"r":"categoryName"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-1 v-medium-top text-right fold-button"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]};
this["ux-rrp-top-bar"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-top-bar-singtel clearfix ",{"t":4,"f":["sticky"],"n":50,"r":"isSticky"},{"t":4,"f":[" offsetTop"],"n":50,"r":"offsetTop"}]},"f":[{"t":7,"e":"div","a":{"class":"row v-normal-bottom subsection-title"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["small-offset-1"],"n":50,"x":{"r":["i"],"s":"_0==0"}}," small-4 columns"]},"f":[{"t":2,"r":"label"}]}],"i":"i","r":"leftitems"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"small-4 columns"},"f":[{"t":7,"e":"div","a":{"class":"text-right"},"f":[{"t":2,"r":"label"}]}," ",{"t":7,"e":"div","a":{"class":"icon-btn show-tooltip"},"v":{"click":{"n":[{"t":4,"f":["showTooltip"],"n":50,"r":"tooltip"}],"d":[]}},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":2,"r":"tooltip"}]}]}],"r":"rightitems"}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]};
this["ux-rrp-variant-selector"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-rrp-variant-selector ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}," ",{"t":4,"f":["v-",{"t":2,"r":"bottomSpacing"},"-bottom"],"n":50,"r":"bottomSpacing"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-productvariant-container","a":{"title":[{"t":3,"r":"initData.metaTitles.chooseColor"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-color-variant","a":{"datamodel":[{"t":3,"r":"."}],"isDisabled":[{"t":2,"r":"isDisabled"}]}}],"n":52,"r":"variants"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-productvariant-container","m":[{"t":4,"f":["hideStock=\"",{"t":2,"r":"hide"},"\""],"n":50,"r":"hide"}],"a":{"title":[{"t":2,"r":"title.chooseSize"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-capacity-variant","a":{"datamodel":[{"t":3,"r":"."}],"phoneStatus":[{"t":2,"r":"phoneStatus"}]}}],"n":52,"r":"variants"}]}],"n":50,"r":"showSize"}," ",{"t":7,"e":"ux-quantity-alteration"}," ",{"t":7,"e":"div","a":{"class":["subsections-header v-normal-top ",{"t":4,"f":["v-medium-bottom"],"n":50,"x":{"r":["hideStock"],"s":"_0===\"hide\""}}]},"f":[{"t":2,"r":"price"}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-rrp-variant"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-rrp-variant"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":["phone-selection choose-color-panel ",{"t":4,"f":["v-large-bottom"],"n":50,"x":{"r":["title"],"s":"_0===\"Choose Colour\""}}]},"f":[{"t":7,"e":"ux-col","a":{"class":["subsection-header left ",{"t":4,"f":["v-normal-top"],"n":50,"x":{"r":["field"],"s":"_0===\"quantity\""}},{"t":4,"n":51,"f":["v-small-top v-normal-bottom"],"x":{"r":["field"],"s":"_0===\"quantity\""}}]},"f":[{"t":4,"f":[{"t":2,"x":{"r":[],"s":"\"Choose Colour: \""}}," ",{"t":2,"r":"selectedColor"}],"n":50,"x":{"r":["title"],"s":"_0===\"Choose Colour\""}},{"t":4,"n":51,"f":[{"t":2,"r":"title"},": ",{"t":2}],"x":{"r":["title"],"s":"_0===\"Choose Colour\""}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"variant-options"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-rrp-group-item","a":{"class":"ux-color-variant rounded-color-variant","variant":[{"t":2,"r":"."}],"groupIndex":[{"t":2,"r":"i"}],"isSelected":[{"t":2,"x":{"r":["isItemSelected","i","groupBy","."],"s":"_0(_2[_1],_3)"}}],"isEnabled":[{"t":2,"x":{"r":["isItemEnabled","i"],"s":"_0(_1)"}}],"isAvailable":[{"t":2,"x":{"r":["isItemAvailable",".","i"],"s":"_0(_1,_2)"}}],"isColor":[{"t":2,"x":{"r":[],"s":"true"}}]},"f":[{"t":7,"e":"div","a":{"class":["color-icon ",{"t":4,"f":["selected"],"n":50,"x":{"r":["isItemSelected","i","groupBy","."],"s":"_0(_2[_1],_3)"}}," ",{"t":4,"f":["not-available"],"n":50,"x":{"r":["isItemAvailable",".","i"],"s":"!_0(_1,_2)"}}],"style":["background-color:",{"t":2,"r":"hexCode"},";"]},"v":{"tap":{"n":"onColorSelect","d":[{"t":2,"r":"name"},",",{"t":2,"r":"identifier"},",",{"t":2,"r":"sku"}]}},"f":[]}]}],"n":50,"x":{"r":["field"],"s":"_0===\"hexCode\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-rrp-group-item","a":{"variant":[{"t":2,"r":"."}],"groupIndex":[{"t":2,"r":"i"}],"isSelected":[{"t":2,"x":{"r":["isItemSelected","i","groupBy","."],"s":"_0(_2[_1],_3)"}}],"isEnabled":[{"t":2,"x":{"r":["isItemEnabled","i"],"s":"_0(_1)"}}],"isAvailable":[{"t":2,"x":{"r":["isItemAvailable",".","i"],"s":"_0(_1,_2)"}}]},"f":[{"t":7,"e":"div","a":{"class":"product-title text-center v-normal-top"},"f":[{"t":2,"rx":{"r":".","m":[{"t":30,"n":"field"}]}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"text-center from-price minheight-fromprice"},"f":["from ",{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["i","groupBy.length"],"s":"_0===_1-1"}}]}],"x":{"r":["field"],"s":"_0===\"hexCode\""}}],"n":52,"x":{"r":["getVariantsByField","field","i"],"s":"_0(_1,_2)"}}]}],"n":50,"x":{"r":["field"],"s":"_0!==\"quantity\""}}]}],"n":50,"r":"isEnabled"}],"n":52,"i":"i","r":"groupBy"}]}]};
this["ux-search-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-search-singtel ",{"t":4,"f":["icon-init"],"n":50,"r":"showIconInitially"}," ",{"t":4,"f":[{"t":2,"r":"class"}],"n":50,"r":"class"}]},"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"id":"search","type":"text","value":[{"t":2,"r":"searchValue"}],"placeholder":[{"t":3,"r":"searchPlaceholder"}],"class":"search-input ss360SearchBox"},"m":[{"t":4,"f":["style=\"display:none;\""],"n":50,"x":{"r":["showSearchBox"],"s":"!_0"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"size":"l","type":"search-small","outerClass":"search-icon-input-background absolute"}}],"n":50,"r":"showSearchBox"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"search-icon"},"f":[{"t":7,"e":"ux-icon","a":{"outerClass":"align-icon hover-state-alignment","class":"search-hover","size":"m","type":"10-search","ontap":"showSearchBox","overIconImageAttribute":"true"}}," ",{"t":7,"e":"ux-icon","a":{"outerClass":"align-icon hover-state-alignment","class":"search-normal","size":"m","type":"10-search","ontap":"showSearchBox","overIconImageAttribute":"true"}}]}],"r":"showSearchBox"}],"n":50,"r":"showIconInitially"},{"t":4,"n":51,"f":[{"t":7,"e":"input","a":{"id":"search","type":"text","value":[{"t":2,"r":"searchValue"}],"placeholder":[{"t":3,"r":"searchPlaceholder"}],"class":"search-input ss360SearchBox"}}],"r":"showIconInitially"}]}]};
this["ux-select-account"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-select-account"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up account v-normal-top hover-container \n\t    \tv-normal-bottom p-normal-top p-normal-bottom p-normal-left p-normal-right pointer"},"v":{"click":{"n":"selectAccount","d":[{"t":2,"r":"i"}]}},"f":[{"t":7,"e":"div","a":{"class":"flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-item flex-item-top-align"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"avatarImg.src"}],"alt":[{"t":3,"r":"avatarImg.alt"}],"class":"avatar full-sized"}}]}," ",{"t":7,"e":"div","a":{"class":"flex-item flex-item-top-align p-normal-left"},"f":[{"t":7,"e":"div","a":{"class":"section-header v-medium-bottom"},"f":[{"t":2,"r":"nickName"}," (Account no.: ",{"t":2,"r":"faid"},")"]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"x":{"r":["RactiveHelpers","subscriberType"],"s":"_0.getServicePropLob(_1?_1:\"BN\",\"name\")"}},": ",{"t":2,"x":{"r":["RactiveHelpers","subscriberResourceVal","subscriberType"],"s":"_0.formatMobileNumberWithSpace(_1,_2)"}}]}],"n":52,"i":"i","r":"subscribers"}]}]}," ",{"t":7,"e":"div","a":{"class":"flex-item p-normal-left"},"f":[{"t":7,"e":"div","a":{"class":"body-light text-right"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"ConfigStrings.consolidateAccount.billingAddress"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"physicalAddress"}]}}],"n":53,"r":"physicalAddress"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":["show-for-small-only text-center ",{"t":4,"f":["selected"],"n":50,"x":{"r":["homeAccount.billingAccountNumber","billingAccountNumber"],"s":"_0===_1"}}]},"f":[{"t":7,"e":"div","a":{"class":"flex-container-column flex-container"},"f":[{"t":7,"e":"div","a":{"class":"flex-item"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":3,"r":"avatarImg.src"}],"alt":[{"t":3,"r":"avatarImg.alt"}],"class":"avatar full-sized"}}]}," ",{"t":7,"e":"div","a":{"class":"flex-item v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"nickName"}]}," ",{"t":7,"e":"div","f":["(A/C: ",{"t":2,"r":"faid"},")"]}]}]}," ",{"t":7,"e":"div","a":{"class":"flex-item v-normal-top body-copy"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"ConfigStrings.consolidateAccount.billingAddress"}]}," ",{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"physicalAddress"}]}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"flex-item v-normal"},"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["RactiveHelpers","subscriberType"],"s":"_0.getServicePropLob(_1?_1:\"BN\",\"name\")"}},": ",{"t":2,"x":{"r":["RactiveHelpers","subscriberResourceVal","subscriberType"],"s":"_0.formatMobileNumberWithSpace(_1,_2)"}}]}],"n":52,"r":"subscribers"}]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"onHideServices"},"f":["Hide My Services"]}],"n":50,"r":"showServices"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onViewServices"},"f":["View My Services"]}]}],"r":"showServices"}," ",{"t":7,"e":"div","a":{"class":"flex-item v-normal flex-full-width"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-button","a":{"class":[{"t":4,"f":["light"],"n":51,"x":{"r":["homeAccount.billingAccountNumber","billingAccountNumber"],"s":"_0===_1"}}," round margin-zero"],"onclick":"selectAccountMobile","index":[{"t":2,"r":"i"}],"text":"Select"}}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider v-large v-none-left-medium v-none-right-medium extend-for-small"}}]}]}]}],"n":50,"x":{"r":["faStatus"],"s":"_0!==88&&_0!==78"}}],"n":52,"i":"i","r":"accounts"}]}]};
this["ux-select-pickup-location"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-select-pickup-location"},"f":[{"t":7,"e":"div","a":{"class":"maps-scripts-container"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":["collapse v-large-top v-medium ",{"t":4,"f":["hide"],"n":50,"r":"data.pickupLocationsHidden"}]},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header","level":"3"},"f":[{"t":2,"r":"pickupData.pickupMainTitle"}]}]}]}],"n":50,"x":{"r":["isCollectNow","isEAppointment"],"s":"_0||_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium"},"f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header","level":"3"},"f":[{"t":2,"r":"pickupData.pickupMainTitle"}]}," "]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"div","f":[" ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"postalCodeInput first small-12 medium-5 v-normal-right"},"f":[{"t":7,"e":"ux-input-box","a":{"label_value":"","maxLength":"6","value":[{"t":2,"r":"data.customerPostalCode"}],"validity":[{"t":2,"r":"data.customerPostalCodeErrorMsg"}],"onblurEvent":"validateZipCode","onFocusEvent":"checkField"}}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"medium-8 description v-normal-bottom"},"f":[{"t":2,"r":"ConfigStrings.errors.noPopStationsFound"}," ",{"t":2,"r":"data.customerPostalCode"},". ",{"t":2,"r":"ConfigStrings.errors.noPopStationsFoundTryAgain"}]}],"n":50,"r":"noPopStationsFound"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"ux-button","a":{"class":["round show-for-small-only small-only-expand ",{"t":4,"f":["v-normal-top disabled"],"n":50,"x":{"r":["data.customerPostalCodeErrorMsg.status","data.onInitPostalCodeDisabled"],"s":"(_0===\"error\")||_1"}}],"text":"Search","role":"button","arialabel":"Search","onclick":[{"t":4,"f":["searchPickupLocations"],"n":51,"x":{"r":["data.customerPostalCodeErrorMsg.status","data.onInitPostalCodeDisabled"],"s":"(_0===\"error\")||_1"}}]},"f":[]}," ",{"t":7,"e":"ux-button","a":{"class":["round show-for-medium-up ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["data.customerPostalCodeErrorMsg.status","data.onInitPostalCodeDisabled"],"s":"(_0===\"error\")||_1"}}],"text":"Search","role":"button","arialabel":"Search","onclick":[{"t":4,"f":["searchPickupLocations"],"n":51,"x":{"r":["data.customerPostalCodeErrorMsg.status","data.onInitPostalCodeDisabled"],"s":"(_0===\"error\")||_1"}}]},"f":[]}]}]}]}]}],"x":{"r":["isCollectNow","isEAppointment"],"s":"_0||_1"}}," ",{"t":7,"e":"div","a":{"class":[{"t":4,"f":["hide"],"n":50,"r":"data.pickupLocationsHidden"}]},"f":[{"t":7,"e":"ux-row","a":{"class":["collapse ",{"t":4,"f":["hide"],"n":50,"x":{"r":["isCollectNow","isEAppointment"],"s":"_0||_1"}}]},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"data.pickupLocationsFiltered.length"}," ",{"t":2,"r":"pickupData.nbFoundText"}," ",{"t":2,"r":"data.customerPostalCode"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse pickup-location-selector"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4 show-for-small-only"},"f":[{"t":4,"f":[{"t":7,"e":"ux-select","a":{"id":"collectNow-zone","name":"zone","showSelectedValue":"true","options":[{"t":2,"r":"zoneList"}],"selected_value":[{"t":2,"r":"selectedZone"}],"onChangeEvent":"onZoneChange"},"f":[]}," ",{"t":7,"e":"p","a":{"class":"v-normal text-color"},"f":[{"t":2,"r":"data.pickupLocationsFiltered.length"}," ",{"t":2,"r":"pickupData.nbFoundText"}," ",{"t":2,"r":"data.customerPostalCode"}]}],"n":50,"x":{"r":["isCollectNow","isEAppointment"],"s":"_0||_1"}}," ",{"t":7,"e":"div","a":{"class":"location-list"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"r":"KioskId"},"-",{"t":2,"r":"i"}],"type":"radio","name":[{"t":2,"r":"data.selectedLocation"},"-"],"class":"pickup-options","value":[{"t":3,"r":"KioskId"}]},"v":{"change":{"n":"selectPopStationOption","d":[{"t":3,"r":"KioskId"}]}}}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"KioskId"},"-",{"t":2,"r":"i"}]},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"POPStationName"}," ",{"t":4,"f":["( ",{"t":2,"r":"Distance"}," km )"],"n":50,"r":"Distance"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"StreetName"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"BuildingName"}]}," ",{"t":7,"e":"div","f":["Singapore   ",{"t":4,"f":[{"t":2,"r":"ZipCode"}],"n":50,"r":"ZipCode"},{"t":4,"n":51,"f":[{"t":2,"r":"PostCode"}],"r":"ZipCode"}]}]}],"n":50,"x":{"r":["selectedOption","i","showLoadMoreButton"],"s":"_0===\"collect-now\"&&(_1<15||!_2)"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["selectedOption","i","showLoadMoreButton"],"s":"_0===\"singtel-store\"&&(_1<15||!_2)"},"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"r":"id"},"-",{"t":2,"r":"i"}],"type":"radio","name":[{"t":2,"r":"data.selectedLocation"},"-"],"class":"pickup-options","value":[{"t":3,"r":"id"}]},"v":{"change":{"n":"selectPopStationOption","d":[{"t":3,"r":"KioskId"}]}}}," ",{"t":7,"e":"label","a":{"class":[{"t":4,"f":["selectStore"],"n":50,"x":{"r":["selectedChangeStoreId","id"],"s":"_0===_1"}}],"for":[{"t":2,"r":"id"},"-",{"t":2,"r":"i"}]},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"name"}," ",{"t":4,"f":["( ",{"t":2,"r":"distance"}," km )"],"n":50,"r":"distance"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"street"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"building"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"country"}," ",{"t":2,"r":"postalCode"}]}]}]}],"x":{"r":["selectedOption","i","showLoadMoreButton"],"s":"_0===\"collect-now\"&&(_1<15||!_2)"}}],"n":52,"i":"i","r":"data.pickupLocationsFiltered"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-medium-top"},"f":[{"t":7,"e":"ux-button","a":{"class":"round light show-more-button v-medium-bottom","onclick":"loadAll","text":"Show More"},"f":[]}]}],"n":50,"r":"showLoadMoreButton"}]}],"n":50,"x":{"r":["isCollectNow","isEAppointment"],"s":"_0||_1"}}," ",{"t":7,"e":"ux-col","a":{"class":["medium-4 ",{"t":4,"f":["hide-for-small-only"],"n":50,"x":{"r":["isCollectNow","isEAppointment"],"s":"_0||_1"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-select","a":{"id":"collectNow-zone","name":"zone","showSelectedValue":"true","options":[{"t":2,"r":"zoneList"}],"selected_value":[{"t":2,"r":"selectedZone"}],"onChangeEvent":"onZoneChange"},"f":[]}," ",{"t":7,"e":"p","a":{"class":"v-normal text-color"},"f":[{"t":2,"r":"data.pickupLocationsFiltered.length"}," ",{"t":2,"r":"pickupData.nbFoundText"}," ",{"t":2,"r":"data.customerPostalCode"}]}],"n":50,"x":{"r":["isCollectNow","isEAppointment"],"s":"_0||_1"}}," ",{"t":7,"e":"div","a":{"class":["location-list ",{"t":4,"f":["location-collect-now"],"n":50,"x":{"r":["isCollectNow","isEAppointment"],"s":"_0||_1"}}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"r":"KioskId"},{"t":2,"r":"i"}],"type":"radio","name":[{"t":2,"r":"data.selectedLocation"}],"class":"pickup-options","value":[{"t":3,"r":"KioskId"}]},"v":{"change":{"n":"selectPopStationOption","d":[{"t":3,"r":"KioskId"}]}}}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"KioskId"},{"t":2,"r":"i"}]},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"POPStationName"}," ",{"t":4,"f":["( ",{"t":2,"r":"Distance"}," km )"],"n":50,"r":"Distance"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"StreetName"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"BuildingName"}]}," ",{"t":7,"e":"div","f":["Singapore   ",{"t":4,"f":[{"t":2,"r":"ZipCode"}],"n":50,"r":"ZipCode"},{"t":4,"n":51,"f":[{"t":2,"r":"PostCode"}],"r":"ZipCode"}]}]}],"n":50,"x":{"r":["selectedOption"],"s":"_0===\"pop-station\"||_0===\"collect-now\""}},{"t":4,"n":51,"f":[{"t":7,"e":"input","a":{"id":[{"t":2,"r":"id"},{"t":2,"r":"i"}],"type":"radio","name":[{"t":2,"r":"data.selectedLocation"}],"value":[{"t":3,"r":"id"}]},"v":{"change":{"n":"selectPopStationOption","d":[{"t":3,"r":"KioskId"}]}}}," ",{"t":7,"e":"label","a":{"class":[{"t":4,"f":["selectStore"],"n":50,"x":{"r":["selectedChangeStoreId","id"],"s":"_0===_1"}}],"for":[{"t":2,"r":"id"},{"t":2,"r":"i"}]},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"name"}," ",{"t":4,"f":["( ",{"t":2,"r":"distance"}," km )"],"n":50,"r":"distance"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"street"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"building"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"country"}," ",{"t":2,"r":"postalCode"}]}]}],"x":{"r":["selectedOption"],"s":"_0===\"pop-station\"||_0===\"collect-now\""}}],"n":52,"i":"i","r":"data.pickupLocationsFiltered"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":["medium-8 ",{"t":4,"f":["hide-for-small-only"],"n":50,"x":{"r":["isCollectNow","isEAppointment"],"s":"_0||_1"}}]},"f":[{"t":7,"e":"div","a":{"id":["mapStractionContainer",{"t":2,"r":"guid"}],"class":"mapStraction-Container"}}]}]}]}]}]};
this["ux-select"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-select ",{"t":2,"r":"customClass"}," ",{"t":2,"r":"validity.status"}," ",{"t":2,"r":"valid"}," ",{"t":4,"f":["disabled"],"r":"disabled"}]},"f":[{"t":4,"f":[{"t":7,"e":"label","a":{"for":[{"t":2,"r":"id"}]},"f":[{"t":2,"r":"label_value"},{"t":4,"f":[{"t":7,"e":"span","a":{"class":"mandatory"},"f":["*"]}],"n":50,"r":"mandatory"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"icon-btn"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":2,"r":"tooltipText"}]}],"n":50,"r":"showToolTip"}]}],"n":50,"r":"label_value"}," ",{"t":7,"e":"span","a":{"class":["select",{"t":4,"f":[" 'active'"],"n":50,"r":"focusStatus"}]},"f":[{"t":7,"e":"span","a":{"class":"icon icon-arrow-down"}}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":["select-value ",{"t":2,"r":"selectedClass"}]},"f":[{"t":2,"r":"selectedTitle"}]}],"n":50,"r":"showSelectedValue"}," ",{"t":7,"e":"select","m":[{"t":4,"f":["id=\"",{"t":2,"r":"id"},"\""],"r":"id"},{"t":4,"f":["name=\"",{"t":3,"r":"name"},"\""],"r":"name"},{"t":4,"f":["disabled=\"true\""],"n":50,"x":{"r":["disabled","selectReadOnly"],"s":"_0||_1"}}],"a":{"value":[{"t":2,"r":"selected_value"}]},"v":{"change":"onChange","blur":"blurHandler","focus":"focusHandler"},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":"defaultOption"}],"disabled":[{"t":4,"f":["disabled"],"n":50,"x":{"r":["select_placeholder"],"s":"_0===true"}}],"selected":0,"class":"default"},"f":[{"t":2,"r":"defaultOption"}]}],"r":"defaultOption"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":"value"}],"selected":[{"t":2,"r":"selected"}],"optionConext":[{"t":2,"r":"optionConext"}]},"v":{"click":"onOptionClick"},"f":[{"t":4,"f":[{"t":2,"r":"text"}],"r":"text"}," ",{"t":4,"f":[{"t":2,"r":"title"}],"r":"title"}," ",{"t":4,"f":[{"t":2,"r":"label"}],"r":"label"}]}],"n":52,"r":"options"}],"n":50,"r":"options"},{"t":4,"n":51,"f":[{"t":16}],"r":"options"}]}]}," ",{"t":7,"e":"div","a":{"class":"validity-wrapper"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":"validity-msg strong"},"f":[{"t":7,"e":"ux-icon","a":{"class":"icon","type":[{"t":2,"r":"icon_name"}]}},{"t":2,"r":"validity_message"}]}],"n":50,"r":"validity_message"}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity"}],"r":"validity"}],"n":50,"x":{"r":["validity","validity_message"],"s":"_0||_1"}}]}]}]};
this["ux-separator"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-separator ",{"t":2,"r":"padding.topPadding"}," ",{"t":2,"r":"padding.rightPadding"}," ",{"t":2,"r":"padding.bottomPadding"}," ",{"t":2,"r":"padding.leftPadding"}]},"f":[{"t":7,"e":"div","a":{"style":["border-bottom:",{"t":2,"r":"style"}," solid ",{"t":2,"r":"color"},";"]},"f":[]}]}]};
this["ux-service-list"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"v-x-large-top"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-row","a":{"class":"v-large-left"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-bottom p-none-left"},"f":[{"t":7,"e":"b","f":[{"t":7,"e":"span","a":{"class":"page-header"},"f":[{"t":2,"r":"initData.headerText"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up v-large-left"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-large-bottom p-none-left"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.description"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only v-large-left v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-large-bottom p-none-left"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"initData.description"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"rounded v-large-left v-large-right"},"f":[{"t":7,"e":"ux-row","a":{"class":"plan ipp-plan"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-10 p-none-bottom text-left plan-name p-normal-left row-title"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"serviceID"}]}," ",{"t":7,"e":"div","a":{"class":"body-light v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"planDetails.planName"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"alert v-medium-right v-medium-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-1 medium-1 p-medium-top text-right"},"f":[{"t":7,"e":"ux-icon","a":{"type":"info"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-11 medium-11 v-medium-top v-medium-bottom"},"f":[{"t":4,"f":[{"t":2,"r":"initData.maximumCapError"}],"n":50,"x":{"r":["accessoryIPPEligibilityDetails.ineligibleErrorCode"],"s":"_0===\"201\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["accessoryIPPEligibilityDetails.ineligibleErrorCode"],"s":"_0===\"202\""},"f":[{"t":2,"r":"initData.nonMobilePlanError"}]},{"t":4,"n":50,"x":{"r":["accessoryIPPEligibilityDetails.ineligibleErrorCode","isPlanEligible"],"s":"(!(_0===\"202\"))&&(!_1)"},"f":[" ",{"t":2,"r":"ConfigStrings.RRP.error.ippIneligiblePlan"}]}],"x":{"r":["accessoryIPPEligibilityDetails.ineligibleErrorCode"],"s":"_0===\"201\""}}]}]}],"n":50,"x":{"r":["accessoryIPPEligibilityDetails.isIPPEligible","isPlanEligible"],"s":"!(_0&&_1)"}}," ",{"t":7,"e":"div","a":{"class":"plan-data show-for-small-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-2 "},"f":[{"t":7,"e":"ux-button","a":{"class":"round small-only-expand button-right-bottom","onclick":"selectService","text":"Select","index":[{"t":2,"r":"apID"}],"disabled":[{"t":4,"f":["true"],"n":50,"x":{"r":["isPlanEligible","accessoryIPPEligibilityDetails.isIPPEligible"],"s":"(_0===false)||!_1"}}]},"f":[]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"plan-data show-for-medium-up medium-2 right"},"f":[{"t":7,"e":"ux-button","a":{"class":"round small-only-expand right","type":"button","onclick":"selectService","text":"Select","index":[{"t":2,"r":"apID"}],"disabled":[{"t":4,"f":["true"],"n":50,"x":{"r":["isPlanEligible","accessoryIPPEligibilityDetails.isIPPEligible"],"s":"(_0===false)||!_1"}}]},"f":[]}]}]}]}],"n":52,"i":"i","r":"./lines"}]}]}]};
this["ux-session-out-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-session-out-singtel"},"f":[{"t":7,"e":"ux-modal","a":{"displayState":[{"t":2,"r":"display"}],"width":"600","class":"light-theme"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"r":"title"}]}," ",{"t":3,"r":"text"}]}]}]};
this["ux-shopping-cart-singtel-information"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-shopping-cart-singtel-information body-text"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-2 medium-1"},"f":[{"t":7,"e":"ux-icon","a":{"class":"warning v-small-top","type":"triangle","size":"l"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-10 medium-11"},"f":[{"t":7,"e":"ux-row","a":{"class":"important-information"},"f":[{"t":7,"e":"div","a":{"class":"section-header information-headline bold"},"f":[{"t":2,"r":"initData.paymentInformationTitle"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":3,"r":"initData.paymentInformationDescription"}]}]}]}],"n":50,"r":"paymentMessage"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"small-10 medium-11"},"f":[{"t":7,"e":"ux-row","a":{"class":"important-information"},"f":[{"t":7,"e":"div","a":{"class":"information-headline bold"},"f":[{"t":2,"r":"initData.importantInformationTitle"}," ",{"t":7,"e":"span","a":{"class":"normal"},"f":[":"]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"normal"},"f":[{"t":2,"r":"numberOfOutOfStockItems"}," ",{"t":2,"r":"initData.importantInformationDetails"}]}],"n":50,"r":"numberOfOutOfStockItems"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"normal"},"f":[{"t":2,"r":"numberOfMissingItems"}," ",{"t":2,"r":"initData.missingItemsDetails"}]}],"n":50,"r":"numberOfMissingItems"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"important-information-details"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"important-information-details-list"},"f":[{"t":2,"r":"name"}," is out of stock ",{"t":7,"e":"ux-anchor","a":{"href":"#","actualData":[{"t":3,"r":"."}],"ontap":"getOutOfStockItem"},"f":[" ",{"t":4,"f":["Get Another Tablet"],"n":50,"x":{"r":["id"],"s":"_0===\"tablet\""}},{"t":4,"n":51,"f":["Get Another Phone"],"x":{"r":["id"],"s":"_0===\"tablet\""}}]},"."]}],"n":52,"r":"informationListItems"}],"n":50,"x":{"r":["informationListItems","informationListItems.length"],"s":"_0&&_1>0"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"important-information-details-list"},"f":[{"t":4,"f":[{"t":2,"r":"initData.importantInformationTitle"},{"t":7,"e":"ux-anchor","a":{"href":"#","ontap":"getMissingItem","actualData":[{"t":3,"r":"."}]},"f":[" Get A New Phone"]}],"n":50,"x":{"r":["id"],"s":"_0===\"device\""}}," ",{"t":4,"f":[{"t":2,"r":"initData.importantInformationTitle"},{"t":7,"e":"ux-anchor","a":{"href":"#","ontap":"getMissingItem","actualData":[{"t":3,"r":"."}]},"f":[" Get A New Tablet"]}],"n":50,"x":{"r":["id"],"s":"_0===\"tablet\""}}," ",{"t":4,"f":[{"t":2,"r":"initData.importantInformationTitle"},{"t":7,"e":"ux-anchor","a":{"href":"#","ontap":"getMissingItem","actualData":[{"t":3,"r":"."}]},"f":[" Get A New Number"]}],"n":50,"x":{"r":["id"],"s":"_0===\"number\""}}," ",{"t":4,"f":[{"t":2,"r":"initData.importantInformationTitle"},{"t":7,"e":"ux-anchor","a":{"href":"#","ontap":"getMissingItem","actualData":[{"t":3,"r":"."}]},"f":[" Get A New Number"]}],"n":50,"x":{"r":["id"],"s":"_0===\"fvNumber\""}}]}],"n":52,"r":"missingListItems"}],"n":50,"x":{"r":["missingListItems","missingListItems.length"],"s":"_0&&_1>0"}}]}]}],"r":"paymentMessage"}]}]}]};
this["ux-sim-only-plan"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-sim-only-plan"},"f":[{"t":7,"e":"div","a":{"class":"plan-container"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":["collapse plan panel base-plan ",{"t":2,"x":{"r":["getSelectedState","planIndex"],"s":"_0(_1)"}}," v-normal-top spacing ",{"t":4,"f":["v-normal-bottom"],"n":50,"r":"ribbon"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-ribbon-singtel","a":{"ribbonPosition":"left"}}],"r":"ribbon"}," ",{"t":7,"e":"ux-anchor","a":{"class":"text-center","ontap":["showConfiguration:",{"t":2,"r":"planIndex"},",",{"t":2,"r":"isApplicableForTablet"}],"index":[{"t":2,"r":"planIndex"}]},"f":[{"t":7,"e":"table","a":{"class":"plan-details-table show-for-medium-up"},"f":[{"t":7,"e":"tr","a":{"class":"plan "},"f":[{"t":7,"e":"td","a":{"class":["text-left row-title ",{"t":4,"f":["with-ribbon"],"n":50,"r":"ribbon"}]},"f":[{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"r":"planName"}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"r":"planDesc"}]}]}," ",{"t":7,"e":"td","a":{"class":"plan-highlights text-left plan-data"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-11"},"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"data.quantity"},{"t":2,"r":"data.unit"}]}," ",{"t":2,"r":"dataLabel"},{"t":4,"f":["*"],"n":50,"r":"dataDisclaimer"}],"n":50,"x":{"r":["data.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," ",{"t":4,"f":["+"],"n":50,"x":{"r":["wifiData.quantity","data.quantity"],"s":"_1&&_0&&(_0>0||_0===\"Unlimited\")&&_1>0"}}," ",{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"wifiData.quantity"},{"t":2,"r":"wifiData.unit"}]}," ",{"t":2,"r":"wifiLabel"}],"n":50,"x":{"r":["wifiData.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}," ",{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"talktime.quantity"},{"t":2,"r":"talktime.unit"}]}],"n":50,"x":{"r":["talktime.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":["-"]}],"x":{"r":["talktime.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," ",{"t":2,"r":"talktimeLabel"},{"t":4,"f":["*"],"n":50,"r":"minsDisclaimer"}," + ",{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"sms.quantity"}]}],"n":50,"x":{"r":["sms.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":["-"]}],"x":{"r":["sms.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," ",{"t":2,"r":"smsLabel"},{"t":4,"f":["*"],"n":50,"r":"smsDisclaimer"}]}," ",{"t":4,"f":[{"t":7,"e":"li","f":[{"t":3,"r":"planDescSubLiner"}]}],"n":50,"r":"planDescSubLiner"}]}]}]}]}," ",{"t":7,"e":"td","a":{"class":"last-column text-right monthly-recurring"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-normal-bottom"},"f":["Plan"]}," ",{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyCharges"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"r":"monthlyLabel"}]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":["plan-details-table show-for-small-only ",{"t":4,"f":["with-ribbon v-normal-top"],"n":50,"r":"ribbon"}]},"f":[{"t":7,"e":"ux-col","a":{"class":" small-7 text-left row-title"},"f":[{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"r":"planName"}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"r":"planDesc"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":" small-5 text-right monthly-recurring"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-small-bottom"},"f":["Plan"]}," ",{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyCharges"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"r":"monthlyLabel"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"plan-highlights plan-data show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":" small-12 text-left plan-header"},"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"data.quantity"},{"t":2,"r":"data.unit"}]}," ",{"t":2,"r":"dataLabel"},{"t":4,"f":["*"],"n":50,"r":"dataDisclaimer"}],"n":50,"x":{"r":["data.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," ",{"t":4,"f":["+"],"n":50,"x":{"r":["wifiData.quantity","data.quantity"],"s":"_1&&_0&&(_0>0||_0===\"Unlimited\")&&_1>0"}}," ",{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"wifiData.quantity"},{"t":2,"r":"wifiData.unit"}]}," ",{"t":2,"r":"wifiLabel"}],"n":50,"x":{"r":["wifiData.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":" small-12 text-left plan-header"},"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"talktime.quantity"},{"t":2,"r":"talktime.unit"}]}],"n":50,"x":{"r":["talktime.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":["-"]}],"x":{"r":["talktime.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," ",{"t":2,"r":"talktimeLabel"},{"t":4,"f":["*"],"n":50,"r":"minsDisclaimer"}," + ",{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"sms.quantity"}]}],"n":50,"x":{"r":["sms.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}},{"t":4,"n":51,"f":[{"t":7,"e":"b","f":["-"]}],"x":{"r":["sms.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}," ",{"t":2,"r":"smsLabel"},{"t":4,"f":["*"],"n":50,"r":"smsDisclaimer"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":" small-12 text-left"},"f":[{"t":7,"e":"li","f":[{"t":3,"r":"planDescSubLiner"}]}]}]}],"n":50,"r":"planDescSubLiner"}]}," ",{"t":7,"e":"ux-row","a":{"class":["collapse text-center show-for-small-only ",{"t":4,"f":["hideButton"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===true"}}]},"f":[{"t":7,"e":"ux-anchor","a":{"class":"text-center","ontap":["showConfiguration:",{"t":2,"r":"planIndex"}],"index":[{"t":2,"r":"planIndex"}]},"f":[{"t":2,"r":"configurePlanLabel"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":["collapse configure ",{"t":4,"f":["showConfigurePanel"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===true"}},{"t":4,"n":51,"f":["hidePanel"],"x":{"r":["showConfigurePanel"],"s":"_0===true"}}]},"f":[{"t":7,"e":"ux-row","a":{"class":"configure-row configure-header-row"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header  configure-header"},"f":[{"t":2,"r":"configureLabel"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"configure-row configure-header-row"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header  configure-header"},"f":[{"t":2,"r":"dataMoreLabel"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse addon-details"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["data-field ",{"t":4,"f":["selected"],"n":50,"x":{"r":["selected","selectedPlanIndex","planIndex"],"s":"_0===true&&_1===_2"}}]},"v":{"tap":{"n":"selectDataAddon","d":[{"t":2,"r":"planIndex"}]}},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"r":"quantity"},{"t":2,"r":"unit"}]}," ",{"t":7,"e":"div","a":{"class":"selected-price"},"f":["+",{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"r":"addons.data.addonDetails"}]}," ",{"t":7,"e":"ux-row","a":{"class":"configure-row configure-header-row v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header  configure-header"},"f":[{"t":2,"r":"talkMoreLabel"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse addon-details talktime-addon-details"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["data-field ",{"t":4,"f":["selected"],"n":50,"x":{"r":["selected","selectedPlanIndex","planIndex"],"s":"_0===true&&_1===_2"}}]},"v":{"tap":{"n":"selectTalktimeAddon","d":[{"t":2,"r":"planIndex"}]}},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"r":"quantity"},{"t":2,"r":"unit"}]}," ",{"t":7,"e":"div","a":{"class":"selected-price"},"f":["+",{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"r":"addons.talktime.addonDetails"}]}," ",{"t":7,"e":"ux-row","a":{"class":"configure-row configure-header-row v-large-top"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header  configure-header"},"f":[{"t":2,"r":"smsMoreLabel"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse addon-details sms-addon-details"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["data-field ",{"t":4,"f":["selected"],"n":50,"x":{"r":["selected","selectedPlanIndex","planIndex"],"s":"_0===true&&_1===_2"}}]},"v":{"tap":{"n":"selectSmsAddon","d":[{"t":2,"r":"planIndex"}]}},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"r":"quantity"}]}," ",{"t":7,"e":"div","a":{"class":"selected-price"},"f":["+",{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"r":"addons.sms.addonDetails"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":["content-container v-normal-top ",{"t":4,"f":["showConfigurePanel"],"n":50,"x":{"r":["showConfigurePanel"],"s":"_0===true"}},{"t":4,"n":51,"f":["hideSection"],"x":{"r":["showConfigurePanel"],"s":"_0===true"}}]},"f":[{"t":7,"e":"ux-row","a":{"class":"note-section"},"f":[{"t":7,"e":"ux-col","a":{"class":"subsection-header small-12"},"f":["Notes:"]}," ",{"t":7,"e":"ux-col","a":{"class":"body-text small-12"},"f":[{"t":3,"r":"noteItems"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"text-center v-normal-bottom show-for-small-only"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"resetSelectSimOnlyPlan","index":[{"t":2,"r":"planIndex"}]},"f":["Reset"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-offset-9 medium-1 v-medium-top show-for-medium-up "},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"resetSelectSimOnlyPlan","index":[{"t":2,"r":"planIndex"}]},"f":["Reset"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-2 small-12"},"f":[{"t":7,"e":"ux-button","a":{"class":"round small-only-expand right","onclick":"selectSimOnlyPlan","text":[{"t":2,"r":"buttonLabel"}],"index":[{"t":2,"r":"planIndex"}],"isApplicableForTablet":[{"t":2,"r":"isApplicableForTablet"}]}}]}]}]}],"n":52,"i":"planIndex","r":"plans"}]}]}]};
this["ux-single-video"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-single-video ",{"t":2,"r":"theme"}]},"f":[{"t":7,"e":"div","a":{"class":"single-video-item"},"v":{"click":"displayVideo"},"f":[{"t":7,"e":"ux-image","a":{"class":"single-video-item-cover","width":"100%","src":["http://img.youtube.com/vi/",{"t":2,"r":"video.videoRef"},"/maxresdefault.jpg"]}}]}," ",{"t":7,"e":"ux-modal","a":{"class":"single-video-modal","modalId":"singleFullScreenVideo"},"f":[{"t":7,"e":"iframe","a":{"id":"ytplayer","class":"single-video-item-video","type":"text/html","src":[{"t":2,"r":"videoURL"}],"frameborder":"0","width":"100%","heightInd":"true","height":"530px"}}]}]}]};
this["ux-singpost-tracker"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singpost-tracker"},"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","a":{"class":"contact-info-section"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"body v-medium-top"},"f":[{"t":2,"r":"title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"input-field"},"f":[{"t":7,"e":"ux-input-box","a":{"class":"tracking-textfield","id":"binno","placeholder":"eg. FS/12/34/56789","label_value":[{"t":2,"r":"label"}],"value":[{"t":2,"r":"trackingNumber"}],"mandatory":"false","maxLength":"15","autofocus":0,"onblurEvent":"onTrackingNumberChange","onInputEvent":"onTrackingNumberChange"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"errorMsg"}]}}],"n":50,"r":"genericErrorMessage"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"center"},"f":[{"t":7,"e":"ux-load-mask","a":{"class":"text-center"}}]}],"n":50,"r":"inProgress"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top text-left"},"f":[{"t":7,"e":"ux-button","a":{"class":["round ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["trackingNumberValid"],"s":"!_0"}}],"onclick":"requestTracking","text":[{"t":2,"r":"trackBtnLabel"}]}}," ",{"t":7,"e":"ux-anchor","a":{"class":"p-normal-left","href":[{"t":2,"r":"txnHistUrl"}]},"f":[{"t":2,"r":"txnHistLabel"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top text-center"},"f":[{"t":7,"e":"ux-button","a":{"class":["tracking-button round ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["trackingNumberValid"],"s":"!_0"}}],"onclick":"requestTracking","text":[{"t":2,"r":"trackBtnLabel"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top text-center"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"txnHistUrl"}]},"f":[{"t":2,"r":"txnHistLabel"}]}]}]}]}]}],"n":50,"r":"searching"}," ",{"t":4,"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","a":{"class":"contact-info-section"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-top v-medium-bottom"},"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only body v-medium-top p-medium-left"},"f":["Tracking Number: ",{"t":2,"r":"trackingNumber"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up body v-medium-top"},"f":["Tracking Number: ",{"t":2,"r":"trackingNumber"}]}]}]}]}," ",{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","a":{"class":"contact-info-section"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-top v-medium-bottom"},"f":[{"t":7,"e":"ux-generic-table","a":{"tableType":"basic","tableWidth":"full","header1":"Date","colSize1":"3",",":0,"header2":"Time","colSize2":"3","header3":"Status","colSize3":"6","datamodel":[{"t":2,"r":"trackingData"}]}}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top text-left"},"f":[{"t":7,"e":"ux-button","a":{"class":"round","onclick":"requestAnotherTracking","text":[{"t":2,"r":"trackAnotherBtnLabel"}]}}," ",{"t":7,"e":"ux-anchor","a":{"class":"p-normal-left","href":[{"t":2,"r":"txnHistUrl"}]},"f":[{"t":2,"r":"txnHistLabel"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top text-center"},"f":[{"t":7,"e":"ux-button","a":{"class":"tracking-button round","onclick":"requestAnotherTracking","text":[{"t":2,"r":"trackAnotherBtnLabel"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top text-center"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"p-normal-left","href":[{"t":2,"r":"txnHistUrl"}]},"f":[{"t":2,"r":"txnHistLabel"}]}]}]}]}]}],"n":50,"r":"result"}]}]};
this["ux-singtel-address"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["ux-singtel-address ",{"t":2,"x":{"r":["useOriginalCase"],"s":"_0?\"original-case\":\"upper-case\""}}," ",{"t":2,"x":{"r":["capitalize"],"s":"_0?\"capitalize\":\"\""}}]},"f":[" ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"},","],"n":50,"r":"buildingName"}," ",{"t":4,"f":[{"t":2,"r":"houseNumber"}],"n":50,"r":"houseNumber"}," ",{"t":4,"f":[{"t":2,"r":"streetName"},","],"n":50,"r":"streetName"}," ",{"t":4,"f":[{"t":2,"r":"unitNumber"},","],"n":50,"r":"unitNumber"}," ",{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}],"n":50,"x":{"r":["addressType"],"s":"_0===\"cmDashboard\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["addressType"],"s":"_0===\"crmUpdatedAddressFormat\""},"f":[{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"x":{"r":["getBlockOrHouseNo","blockOrHouseNum","addressType"],"s":"_0(_1,_2)"}}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"apartment"}],"n":50,"r":"apartment"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"x":{"r":["getPostalCode","postcode","addressType"],"s":"_0(_1,_2)"}}],"n":50,"r":"postcode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postCode"],"s":"_0"},"f":[{"t":2,"x":{"r":["getPostalCode","postCode","addressType"],"s":"_0(_1,_2)"}}]}],"r":"postcode"}]}]},{"t":4,"n":50,"x":{"r":["addressType"],"s":"(!(_0===\"crmUpdatedAddressFormat\"))&&(_0===\"omsProductServiceLevel\")"},"f":[" ",{"t":4,"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"},","],"n":50,"r":"buildingName"}," ",{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"},","],"n":50,"r":"streetName"}," ",{"t":4,"f":[{"t":2,"r":"apartment"},","],"n":50,"r":"apartment"}," ",{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}],"n":50,"r":"addressId"},{"t":4,"n":51,"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"formattedAddress3"},","],"n":50,"r":"formattedAddress3"}," ",{"t":4,"f":[{"t":2,"r":"addressLine2"}," ",{"t":2,"r":"streetX8"},","],"n":50,"x":{"r":["addressLine2","streetX8"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["apartmentAndStreet","addressLine2"],"s":"_0&&_1"},"f":[{"t":2,"r":"apartmentAndStreet"}," ",{"t":2,"r":"addressLine2"},","]},{"t":4,"n":50,"x":{"r":["apartmentAndStreet","addressLine2"],"s":"!(_0&&_1)"},"f":[" ",{"t":2,"r":"addressLine2"},","]}],"x":{"r":["addressLine2","streetX8"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":2,"r":"unitNumberX8"},","],"n":50,"r":"unitNumberX8"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["floor"],"s":"_0"},"f":[{"t":2,"r":"floor"},","]}],"r":"unitNumberX8"}," ",{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postCode"}],"n":50,"r":"postCode"}]}],"r":"addressId"}]},{"t":4,"n":50,"x":{"r":["addressType","isPhysical"],"s":"(!(_0===\"crmUpdatedAddressFormat\"))&&((!(_0===\"omsProductServiceLevel\"))&&(_1===\"relocationAddressType\"))"},"f":[" ",{"t":4,"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"apartment"}],"n":50,"r":"apartment"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}],"n":50,"r":"addressId"},{"t":4,"n":51,"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"formattedAddress3"}],"n":50,"r":"formattedAddress3"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"addressLine2"}," ",{"t":2,"r":"streetX8"}],"n":50,"x":{"r":["addressLine2","streetX8"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["apartmentAndStreet","addressLine2"],"s":"_0&&_1"},"f":[{"t":2,"r":"apartmentAndStreet"}," ",{"t":2,"r":"addressLine2"}]},{"t":4,"n":50,"x":{"r":["apartmentAndStreet","addressLine2"],"s":"!(_0&&_1)"},"f":[" ",{"t":2,"r":"addressLine2"}]}],"x":{"r":["addressLine2","streetX8"],"s":"_0&&_1"}}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"unitNumberX8"}],"n":50,"r":"unitNumberX8"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["floor"],"s":"_0"},"f":[{"t":2,"r":"floor"}]}],"r":"unitNumberX8"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postCode"}],"n":50,"r":"postCode"}]}],"r":"addressId"}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&((!(_0===\"relocationAddressType\"))&&(_1===\"physicalAddress\")))"},"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"},","],"n":50,"r":"buildingName"}," ",{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"},","],"n":50,"r":"streetName"}," ",{"t":4,"f":[{"t":2,"r":"apartment"},","],"n":50,"r":"apartment"}," ",{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&((!(_0===\"relocationAddressType\"))&&((!(_1===\"physicalAddress\"))&&(_1===\"physicalAddressMultiline\"))))"},"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"houseNumber"}],"n":50,"r":"houseNumber"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"unitNumber"}],"n":50,"r":"unitNumber"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&((!(_0===\"relocationAddressType\"))&&((!(_1===\"physicalAddress\"))&&((!(_1===\"physicalAddressMultiline\"))&&(_1==\"sdpRetrieveAddress\")))))"},"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"unitNo"}],"n":50,"x":{"r":["floorNo","unitNo"],"s":"_0===_1"}},{"t":4,"n":51,"f":[{"t":2,"r":"floorNo"},"-",{"t":2,"r":"unitNo"}],"x":{"r":["floorNo","unitNo"],"s":"_0===_1"}}],"n":50,"x":{"r":["floorNo","unitNo"],"s":"(_0&&_0!=\"Select\")&&(_1&&_1!=\"Select\")"}}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postCode"}],"n":50,"r":"postCode"}]}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&((!(_0===\"relocationAddressType\"))&&((!(_1===\"physicalAddress\"))&&((!(_1===\"physicalAddressMultiline\"))&&((!(_1==\"sdpRetrieveAddress\"))&&(_1==\"timeline\"))))))"},"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"unitNumber"}],"n":50,"r":"unitNumber"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&((!(_0===\"relocationAddressType\"))&&((!(_1===\"physicalAddress\"))&&((!(_1===\"physicalAddressMultiline\"))&&((!(_1==\"sdpRetrieveAddress\"))&&((!(_1==\"timeline\"))&&(_1==\"timelineSingleLine\")))))))"},"f":[" ",{"t":4,"f":[{"t":2,"r":"buildingName"},","],"n":50,"r":"buildingName"}," ",{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"},","],"n":50,"r":"streetName"}," ",{"t":4,"f":[{"t":2,"r":"apartment"},","],"n":50,"r":"apartment"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["unitNumber"],"s":"_0"},"f":[{"t":2,"r":"unitNumber"},","]}],"r":"apartment"}," ",{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&((!(_0===\"relocationAddressType\"))&&((!(_1===\"physicalAddress\"))&&((!(_1===\"physicalAddressMultiline\"))&&((!(_1==\"sdpRetrieveAddress\"))&&((!(_1==\"timeline\"))&&((!(_1==\"timelineSingleLine\"))&&(_1==\"popStationAPI\"))))))))"},"f":[" ",{"t":4,"f":[{"t":2,"r":"POPStationName"}],"n":50,"r":"POPStationName"}," ",{"t":4,"f":[{"t":2,"r":"HouseBlockNumber"}],"n":50,"r":"HouseBlockNumber"}," ",{"t":4,"f":[{"t":2,"r":"StreetName"},","],"n":50,"r":"StreetName"}," ",{"t":4,"f":[{"t":2,"r":"BuildingName"},","],"n":50,"r":"BuildingName"}," ",{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"PostCode"}],"n":50,"r":"PostCode"}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&((!(_0===\"relocationAddressType\"))&&((!(_1===\"physicalAddress\"))&&((!(_1===\"physicalAddressMultiline\"))&&((!(_1==\"sdpRetrieveAddress\"))&&((!(_1==\"timeline\"))&&((!(_1==\"timelineSingleLine\"))&&(!(_1==\"popStationAPI\")))))))))"},"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":["APT BLK ",{"t":2,"r":"houseNumber"}],"n":50,"x":{"r":["houseNumber","unitNumber"],"s":"_0&&_1.startsWith(\"#\")"}},{"t":4,"n":51,"f":["HOUSE ",{"t":2,"r":"houseNumber"}],"x":{"r":["houseNumber","unitNumber"],"s":"_0&&_1.startsWith(\"#\")"}}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"unitNumber"}],"n":50,"r":"unitNumber"}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}],"n":50,"r":"isRrp"},{"t":4,"n":51,"f":[{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}],"r":"isRrp"}]}],"x":{"r":["addressType"],"s":"_0===\"cmDashboard\""}}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"},","],"n":50,"r":"buildingName"}," ",{"t":4,"f":[{"t":2,"r":"houseNumber"}],"n":50,"r":"houseNumber"}," ",{"t":4,"f":[{"t":2,"r":"streetName"},","],"n":50,"r":"streetName"}," ",{"t":4,"f":[{"t":2,"r":"unitNumber"},","],"n":50,"r":"unitNumber"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}],"n":50,"x":{"r":["addressType"],"s":"_0===\"cmDashboard\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["isPhysical"],"s":"_0===\"relocationAddressType\""},"f":[" ",{"t":4,"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"apartment"}],"n":50,"r":"apartment"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}],"n":50,"r":"addressId"},{"t":4,"n":51,"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"formattedAddress3"}],"n":50,"r":"formattedAddress3"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"addressLine2"}," ",{"t":2,"r":"streetX8"}],"n":50,"x":{"r":["addressLine2","streetX8"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["apartmentAndStreet","addressLine2"],"s":"_0&&_1"},"f":[{"t":2,"r":"apartmentAndStreet"}," ",{"t":2,"r":"addressLine2"}]},{"t":4,"n":50,"x":{"r":["apartmentAndStreet","addressLine2"],"s":"!(_0&&_1)"},"f":[" ",{"t":2,"r":"addressLine2"}]}],"x":{"r":["addressLine2","streetX8"],"s":"_0&&_1"}}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"unitNumberX8"}],"n":50,"r":"unitNumberX8"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["floor"],"s":"_0"},"f":[{"t":2,"r":"floor"}]}],"r":"unitNumberX8"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postCode"}],"n":50,"r":"postCode"}]}],"r":"addressId"}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_0===\"relocationAddressType\"))&&(_1===\"crmUpdatedAddressFormat\")"},"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"x":{"r":["getBlockOrHouseNo","blockOrHouseNum","addressType"],"s":"_0(_1,_2)"}}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"apartment"}],"n":50,"r":"apartment"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"x":{"r":["getPostalCode","postcode","addressType"],"s":"_0(_1,_2)"}}],"n":50,"r":"postcode"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["postCode"],"s":"_0"},"f":[{"t":2,"x":{"r":["getPostalCode","postCode","addressType"],"s":"_0(_1,_2)"}}]}],"r":"postcode"}]}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_0===\"relocationAddressType\"))&&((!(_1===\"crmUpdatedAddressFormat\"))&&(_1===\"omsProductServiceLevel\"))"},"f":[" ",{"t":4,"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"},","],"n":50,"r":"buildingName"}," ",{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"},","],"n":50,"r":"streetName"}," ",{"t":4,"f":[{"t":2,"r":"unitNumber"},","],"n":50,"r":"unitNumber"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}],"n":50,"r":"addressId"},{"t":4,"n":51,"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"formattedAddress3"},","],"n":50,"r":"formattedAddress3"}," ",{"t":4,"f":[{"t":2,"r":"addressLine2"}," ",{"t":2,"r":"streetX8"},","],"n":50,"x":{"r":["addressLine2","streetX8"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["apartmentAndStreet","addressLine2"],"s":"_0&&_1"},"f":[{"t":2,"r":"apartmentAndStreet"}," ",{"t":2,"r":"addressLine2"},","]},{"t":4,"n":50,"x":{"r":["apartmentAndStreet","addressLine2"],"s":"!(_0&&_1)"},"f":[" ",{"t":2,"r":"addressLine2"},","]}],"x":{"r":["addressLine2","streetX8"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":2,"r":"unitNumberX8"},","],"n":50,"r":"unitNumberX8"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["floor"],"s":"_0"},"f":[{"t":2,"r":"floor"},","]}],"r":"unitNumberX8"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postCode"}],"n":50,"r":"postCode"}]}],"r":"addressId"}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_0===\"relocationAddressType\"))&&((!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&(_1===\"physicalAddress\")))"},"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"},","],"n":50,"r":"buildingName"}," ",{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"},","],"n":50,"r":"streetName"}," ",{"t":4,"f":[{"t":2,"r":"apartment"},","],"n":50,"r":"apartment"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_0===\"relocationAddressType\"))&&((!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&((!(_1===\"physicalAddress\"))&&(_1===\"physicalAddressMultiline\"))))"},"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"houseNumber"}],"n":50,"r":"houseNumber"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"unitNumber"}],"n":50,"r":"unitNumber"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_0===\"relocationAddressType\"))&&((!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&((!(_1===\"physicalAddress\"))&&((!(_1===\"physicalAddressMultiline\"))&&(_1==\"sdpRetrieveAddress\")))))"},"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"unitNo"}],"n":50,"x":{"r":["floorNo","unitNo"],"s":"_0===_1"}},{"t":4,"n":51,"f":[{"t":2,"r":"floorNo"},"-",{"t":2,"r":"unitNo"}],"x":{"r":["floorNo","unitNo"],"s":"_0===_1"}}],"n":50,"x":{"r":["floorNo","unitNo"],"s":"(_0&&_0!=\"Select\")&&(_1&&_1!=\"Select\")"}}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postCode"}],"n":50,"r":"postCode"}]}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_0===\"relocationAddressType\"))&&((!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&((!(_1===\"physicalAddress\"))&&((!(_1===\"physicalAddressMultiline\"))&&((!(_1==\"sdpRetrieveAddress\"))&&(_1==\"timeline\"))))))"},"f":[" ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"unitNumber"}],"n":50,"r":"unitNumber"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_0===\"relocationAddressType\"))&&((!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&((!(_1===\"physicalAddress\"))&&((!(_1===\"physicalAddressMultiline\"))&&((!(_1==\"sdpRetrieveAddress\"))&&((!(_1==\"timeline\"))&&(_1==\"popStationAPI\")))))))"},"f":[" ",{"t":4,"f":[{"t":2,"r":"POPStationName"}],"n":50,"r":"POPStationName"}," ",{"t":4,"f":[{"t":2,"r":"HouseBlockNumber"}],"n":50,"r":"HouseBlockNumber"}," ",{"t":4,"f":[{"t":2,"r":"StreetName"},","],"n":50,"r":"StreetName"}," ",{"t":4,"f":[{"t":2,"r":"BuildingName"},","],"n":50,"r":"BuildingName"}," ",{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":2,"r":"PostCode"}],"n":50,"r":"PostCode"}]},{"t":4,"n":50,"x":{"r":["isPhysical","addressType"],"s":"(!(_0===\"relocationAddressType\"))&&((!(_1===\"crmUpdatedAddressFormat\"))&&((!(_1===\"omsProductServiceLevel\"))&&((!(_1===\"physicalAddress\"))&&((!(_1===\"physicalAddressMultiline\"))&&((!(_1==\"sdpRetrieveAddress\"))&&((!(_1==\"timeline\"))&&(!(_1==\"popStationAPI\"))))))))"},"f":[" ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":4,"f":["APT BLK ",{"t":2,"r":"houseNumber"}],"n":50,"x":{"r":["houseNumber","unitNumber"],"s":"_0&&_1.startsWith(\"#\")"}},{"t":4,"n":51,"f":["HOUSE ",{"t":2,"r":"houseNumber"}],"x":{"r":["houseNumber","unitNumber"],"s":"_0&&_1.startsWith(\"#\")"}}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}," ",{"t":4,"f":[" ",{"t":2,"r":"unitNumber"}],"n":50,"r":"unitNumber"}," ",{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[" ",{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}],"n":50,"r":"isRrp"},{"t":4,"n":51,"f":[{"t":7,"e":"div","f":[{"t":4,"f":["APT BLK ",{"t":2,"r":"houseNumber"}],"n":50,"x":{"r":["houseNumber","unitNumber"],"s":"_0&&_1.startsWith(\"#\")"}},{"t":4,"n":51,"f":["HOUSE ",{"t":2,"r":"houseNumber"}],"x":{"r":["houseNumber","unitNumber"],"s":"_0&&_1.startsWith(\"#\")"}}," ",{"t":4,"f":[{"t":2,"r":"streetName"}],"n":50,"r":"streetName"}," ",{"t":4,"f":[" ",{"t":2,"r":"unitNumber"}],"n":50,"r":"unitNumber"}," ",{"t":4,"f":[" ",{"t":2,"r":"buildingName"}],"n":50,"r":"buildingName"}]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["city","ConfigStrings.physicalAddressValues.city"],"s":"_0||_1"}}," ",{"t":4,"f":[" ",{"t":2,"r":"postcode"}],"n":50,"r":"postcode"}]}],"r":"isRrp"}]}],"x":{"r":["addressType"],"s":"_0===\"cmDashboard\""}}]}]}],"r":"address"}]};
this["ux-singtel-breadcrumb-step"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-singtel-breadcrumb-step ",{"t":4,"f":["hide"],"n":51,"r":"visible"}]},"f":[{"t":16}]}]};
this["ux-singtel-breadcrumbs"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-singtel-breadcrumbs ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-wrap"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["flex-item breadcrumb-container flex-equal-width ",{"t":4,"f":["flex-overright-equal-width-small"],"n":50,"x":{"r":["i","bcConfig.length"],"s":"_0===_1-1"}}," flex-item-top-align ",{"t":2,"r":"status"}]},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-center"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"flex-item flex-full-width connector-line show-for-medium-up"},"f":[]}],"n":50,"x":{"r":["i"],"s":"_0>0"}}," ",{"t":7,"e":"div","a":{"class":["flex-item icon-container ",{"t":4,"f":["first-breadcrumb-icon-container"],"n":50,"x":{"r":["i"],"s":"_0===0"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["i","bcConfig.length"],"s":"_0===_1-1"},"f":["last-breadcrumb-icon-container"]},{"t":4,"n":50,"x":{"r":["i","bcConfig.length"],"s":"!(_0===_1-1)"},"f":[" middle-breadcrumb-icon-container"]}],"x":{"r":["i"],"s":"_0===0"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":["#",{"t":2,"r":"hash"}]},"f":[{"t":7,"e":"ux-icon","a":{"type":"simonly-tick","outerClass":" show-for-medium-up","size":"l"}}," ",{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icon"}],"outerClass":" show-for-small-only","size":"l"}}]}],"n":50,"x":{"r":["status"],"s":"_0===\"completed\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icon"}],"outerClass":"","size":"l"}}],"x":{"r":["status"],"s":"_0===\"completed\""}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"flex-item flex-full-width connector-line"},"f":[]}],"n":50,"x":{"r":["i","bcConfig.length"],"s":"_0<_1-1"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":["#",{"t":2,"r":"hash"}],"class":"no-decoration show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":["message-container ",{"t":2,"r":"status"}," text-center"]},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":["Step ",{"t":2,"x":{"r":["i"],"s":"_0+1"}}]}," ",{"t":7,"e":"div","a":{"class":"body-text"},"f":[{"t":2,"r":"title"}]}]}]}],"n":50,"x":{"r":["status"],"s":"_0===\"completed\""}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up text-center"},"f":[{"t":7,"e":"div","a":{"class":["message-container ",{"t":2,"r":"status"}]},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":["Step ",{"t":2,"x":{"r":["i"],"s":"_0+1"}}]}," ",{"t":7,"e":"div","a":{"class":"body-text"},"f":[{"t":2,"r":"title"}]}]}]}],"x":{"r":["status"],"s":"_0===\"completed\""}}]}],"n":52,"i":"i","r":"bcConfig"}]}," "]}]};
this["ux-singtel-circle-bundle-price"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-circle-bundle-price"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":7,"e":"ux-panel","a":{"class":"pack-panel text-center"},"f":[{"t":7,"e":"div","a":{"class":"product-header text-left"},"f":[{"t":7,"e":"div","a":{"class":"header-title small-offset-1"},"f":[{"t":2,"r":"headerTitle"}]}," ",{"t":7,"e":"div","a":{"class":"header-desc v-medium-bottom small-offset-1"},"f":[{"t":2,"r":"description"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-content"},"f":[{"t":7,"e":"div","a":{"class":"listings"},"f":[{"t":7,"e":"ul","f":[{"t":7,"e":"li","a":{"class":"clearfix v-large-top v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-start"},"f":[{"t":7,"e":"div","a":{"class":"flex-item flex-item-top-align icon-container"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"singtelTVLogo"}]}}]}," ",{"t":7,"e":"div","a":{"class":"flex-item flex-item-top-align p-normal-left p-normal-right text-left"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"singtelTVTitle"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"singtelTVDesc"}]}]}]}]}," ",{"t":7,"e":"li","a":{"class":"clearfix v-large-top v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-start"},"f":[{"t":7,"e":"div","a":{"class":"flex-item flex-item-top-align icon-container"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"broadbandLogo"}]}}]}," ",{"t":7,"e":"div","a":{"class":"flex-item flex-item-top-align p-normal-left p-normal-right text-left"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"broadbandTitle"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"broadbandDesc"}]}]}]}]}," ",{"t":7,"e":"li","a":{"class":"clearfix v-large-top v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"flex-container flex-container-start"},"f":[{"t":7,"e":"div","a":{"class":"flex-item flex-item-top-align icon-container"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"mobileLogo"}]}}]}," ",{"t":7,"e":"div","a":{"class":"flex-item flex-item-top-align p-normal-left p-normal-right text-left"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"mobileTitle"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"mobileDesc"}]}]}]}]}]}]}," ",{"t":7,"e":"hr"}," ",{"t":7,"e":"div","a":{"class":"prices v-large-top"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"main-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","priceForPlan"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"priceLabel"}]}]}," ",{"t":7,"e":"div","a":{"class":"strike-through-dollar"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oldPriceForPlan"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"subsection-header v-large-top v-normal-bottom"},"f":[{"t":2,"r":"youSaveLabel"}," ",{"t":2,"x":{"r":["RactiveHelpers","oldPriceForPlan","priceForPlan"],"s":"_0.convertUnits(_1-_2,\"$\")"}},"!"]}]}]}]}],"r":"bundleList"}]}]}]};
this["ux-singtel-circle-select-services"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-circle-select-services"},"f":[{"t":7,"e":"ux-row","a":{"class":"p-medium-left"},"f":[{"t":7,"e":"div","a":{"class":"main-header v-large-top v-large-bottom"},"f":[{"t":2,"r":"widgetConfig.addEditCircle.heading"}," ",{"t":2,"r":"circleNumber"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"p-large-bottom"},"f":[{"t":7,"e":"ux-panel","a":{"class":"p-large-top"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-anchor","a":{"onclick":"gotoEligibilityCriteria"},"f":[{"t":3,"r":"widgetConfig.addEditCircle.viewEligibleCriteriaLink"}]},{"t":3,"r":"widgetConfig.addEditCircle.viewEligibleCriteriaText"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 v-large-top "},"f":[{"t":7,"e":"span","a":{"class":"ux-input-box"},"f":[{"t":7,"e":"label","a":{"for":"fiberBroadband"},"f":[{"t":2,"r":"widgetConfig.headings.fibre"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-radio-button","a":{"class":"p-small-bottom","use_content":"true","btn_id":[{"t":2,"r":"idx"}],"name":"fiberPlans","value":[{"t":2,"r":"serviceId"}],"selected":[{"t":2,"r":"selectedFiberPlan"}],"onclick":"onChangeRadio"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"body-text"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"widgetConfig.headings.fibre"}," ",{"t":2,"r":"serviceId"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom validation-inline-error"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":3,"r":"validationError.errorMessage"}]},"f":[]}]}],"n":50,"x":{"r":["validationError.serviceId","serviceId"],"s":"(_0).includes(_1)"}}],"n":50,"x":{"r":["lob"],"s":"_0===\"BB\"||_0===\"FBB\""}}],"n":52,"i":"idx","r":"singtelCircle.availableServices"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 v-large-top"},"f":[{"t":7,"e":"span","a":{"class":"ux-input-box"},"f":[{"t":7,"e":"label","a":{"for":"tv"},"f":[{"t":2,"r":"widgetConfig.headings.tv"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-radio-button","a":{"class":"p-small-bottom","use_content":"true","btn_id":[{"t":2,"r":"idx"}],"name":"tvPlans","value":[{"t":2,"r":"serviceId"}],"selected":[{"t":2,"r":"selectedTvPlan"}],"onclick":"onChangeRadio"},"f":[{"t":7,"e":"span","a":{"class":"body-text"},"f":[{"t":2,"r":"widgetConfig.headings.tv"}," ",{"t":2,"r":"serviceId"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom validation-inline-error"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":3,"r":"validationError.errorMessage"}]},"f":[]}]}],"n":50,"x":{"r":["validationError.serviceId","serviceId"],"s":"(_0).includes(_1)"}}],"n":50,"x":{"r":["lob"],"s":"_0==\"TV\""}}],"n":52,"i":"idx","r":"singtelCircle.availableServices"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 v-large-top"},"f":[{"t":7,"e":"span","a":{"class":"ux-input-box"},"f":[{"t":7,"e":"label","a":{"for":"homeLine"},"f":[{"t":2,"r":"widgetConfig.headings.homeLine"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-radio-button","a":{"class":"p-small-bottom","use_content":"true","btn_id":[{"t":2,"r":"idx"}],"name":"homeLinePlans","value":[{"t":2,"r":"serviceId"}],"selected":[{"t":2,"r":"selectedHomeLinePlan"}],"onclick":"onChangeRadio"},"f":[{"t":7,"e":"span","a":{"class":"body-text"},"f":[{"t":2,"r":"widgetConfig.headings.homeLineInline"}," ",{"t":2,"r":"serviceId"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom validation-inline-error"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":3,"r":"validationError.errorMessage"}]},"f":[]}]}],"n":50,"x":{"r":["validationError.serviceId","serviceId"],"s":"(_0).includes(_1)"}}],"n":50,"x":{"r":["lob"],"s":"_0==\"FV\""}}],"n":52,"i":"idx","r":"singtelCircle.availableServices"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 v-large-top"},"f":[{"t":7,"e":"span","a":{"class":"ux-input-box"},"f":[{"t":7,"e":"label","a":{"for":"mobile"},"f":[{"t":2,"r":"widgetConfig.headings.mobile"}]}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"p-medium-top p-medium-bottom p-medium-right p-medium-left v-normal-top v-normal-bottom error-details small-12 medium-8 validation-inline-error"},"f":[{"t":3,"r":"validationError.errorMessage"}]}],"n":50,"x":{"r":["validationError.errorCode"],"s":"_0===\"10005\"||_0===\"10015\""}}," ",{"t":7,"e":"div","a":{"class":"small-12 medium-8"},"f":[{"t":3,"r":"widgetConfig.addEditCircle.mobileSection.topNote"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top v-medium-bottom small-12 medium-4 "},"f":[{"t":4,"f":[{"t":2,"r":"widgetConfig.headings.mobile"}," ",{"t":2,"r":"selectedPrimaryMobileKeyLine.serviceId"}],"n":50,"x":{"r":["isEditMode","singtelCircle.isCircleOne"],"s":"_0&&!_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["presentMobiles","presentMobiles.length"],"s":"_0&&_1===1"},"f":[{"t":2,"r":"widgetConfig.headings.mobile"}," ",{"t":2,"r":"presentMobiles.0.value"}]},{"t":4,"n":50,"x":{"r":["presentMobiles","presentMobiles.length"],"s":"!(_0&&_1===1)"},"f":[" ",{"t":7,"e":"ux-select","a":{"id":"keylineNumbers","showSelectedValue":[{"t":2,"x":{"r":[],"s":"true"}}],"options":[{"t":2,"r":"presentMobiles"}],"customClass":["primary-keyline-numbers ",{"t":4,"f":["error-border"],"n":50,"x":{"r":["validationError.serviceId","selected_value"],"s":"(_0).includes(_1)"}}],"selected_value":[{"t":2,"r":"selectedDevice"}],"select_placeholder":[{"t":2,"x":{"r":[],"s":"true"}}],"defaultOption":[{"t":2,"r":"widgetConfig.addEditCircle.mobileSection.defaultSelectedOption"}],"onChangeEvent":"changeMobileSelect"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom validation-inline-error"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":3,"r":"validationError.errorMessage"}]},"f":[]}]}],"n":50,"x":{"r":["validationError.serviceId","selected_value"],"s":"(_0).includes(_1)"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom validation-inline-error"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":3,"r":"widgetConfig.addEditCircle.mobileSection.notSelectPrimaryMobLineError"}]},"f":[]}]}],"n":50,"r":"primaryKeyNominationNotSelected"}]}],"x":{"r":["isEditMode","singtelCircle.isCircleOne"],"s":"_0&&!_1"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"keyline-info-msg p-medium-top p-medium-right p-medium-left p-medium-bottom template-bg-grey v-normal-bottom small-12 medium-4"},"f":[{"t":2,"r":"widgetConfig.addEditCircle.mobileSection.primaryKeylineinfoMsg"}]}],"n":50,"x":{"r":["isEditMode","singtelCircle.isCircleOne","presentMobiles","presentMobiles.length","showKeylineInfoMsg","validationError.serviceId","selected_value"],"s":"(_0&&!_1)||(_2&&_3===1)||(_4&&!(_5&&(_5).includes(_6)))"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"small-12 medium-8"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-medium-bottom ux-input-box"},"f":[{"t":7,"e":"label","a":{"for":"nonKeyLine"},"f":[{"t":3,"r":"widgetConfig.addEditCircle.nonKeyLineSection.heading"}]}]}," ",{"t":7,"e":"div","a":{"class":"v-medium-bottom"},"f":[{"t":3,"r":"widgetConfig.addEditCircle.nonKeyLineSection.infoMessage"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"div","a":{"class":"relative small-12 medium-4"},"f":[{"t":7,"e":"ux-input-box","a":{"id":[{"t":2,"r":"id"}],"placeholder":"Mobile number","onblurEvent":"validateMobile","textFieldObj":[{"t":2,"rx":{"r":"showTextFields","m":[{"t":30,"n":"i"}]}}],"class":[{"t":4,"f":["error-border v-medium-bottom"],"n":50,"x":{"r":["validationFailed","msgValidity.passed","doubleEnteredNumberError"],"s":"_0&&(!_1||_2)"}},{"t":4,"n":51,"f":["v-normal-bottom"],"x":{"r":["validationFailed","msgValidity.passed","doubleEnteredNumberError"],"s":"_0&&(!_1||_2)"}}],"value":[{"t":2,"r":"simNumber"}]},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"absolute clear-number"},"v":{"tap":"clearNumberField","enter":"clearNumberField"},"f":[{"t":7,"e":"ux-icon","a":{"type":"close-line","size":"xs"}}]}],"n":50,"x":{"r":["simNumber","simNumber.length"],"s":"_0&&_1>0"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom validity-msg strong"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"validation-inline-error"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"msgValidity.message"}]},"f":[]}]}],"n":50,"x":{"r":["msgValidity.message","msgValidity.passed"],"s":"_0&&!_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["doubleEnteredNumberError","msgValidity.status"],"s":"(_0&&_1===\"valid\")"},"f":[{"t":7,"e":"div","a":{"class":"validation-inline-error"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"widgetConfig.addEditCircle.nonKeyLineSection.errorMessages.doubleEnteredNumberError"}]},"f":[]}]}]}],"x":{"r":["msgValidity.message","msgValidity.passed"],"s":"_0&&!_1"}}]}],"n":50,"r":"validationFailed"}]}]}],"n":52,"i":"i","r":"showTextFields"}]}],"n":50,"x":{"r":["showInputBoxes","isEditMode"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top-mobile v-medium-top"},"f":[{"t":7,"e":"ux-anchor","a":{"onclick":"addMobileLines"},"f":[{"t":2,"r":"widgetConfig.addEditCircle.moreMobileLines"}]}]}],"n":50,"r":"showAddMoreLines"}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-button","a":{"onclick":"proceedNomination","class":["round text-center v-medium-bottom small-12 ",{"t":4,"f":["disabled"],"n":50,"r":"isDisabled"}],"text":[{"t":2,"r":"widgetConfig.addEditCircle.nominateBtn"}]}}," ",{"t":7,"e":"ux-button","a":{"onclick":"cancelNomination","class":"round light text-center v-medium-top v-none-bottom small-12","text":[{"t":2,"r":"widgetConfig.addEditCircle.cancelBtn"}]}}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-button","a":{"onclick":"cancelNomination","class":"round light text-center v-normal-right-medium v-none-bottom","text":[{"t":2,"r":"widgetConfig.addEditCircle.cancelBtn"}]}}," ",{"t":7,"e":"ux-button","a":{"onclick":"proceedNomination","class":["round text-center v-none-bottom ",{"t":4,"f":["disabled"],"n":50,"r":"isDisabled"}],"text":[{"t":2,"r":"widgetConfig.addEditCircle.nominateBtn"}]}}]}]}]}]}]}]}]};
this["ux-singtel-circle"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-circle"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"text-center small-12 medium-4"},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-image","a":{"img":[{"t":2,"r":"subscriptionIcon"}],"class":"subscription-icon"}}," ",{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header v-normal-bottom v-normal-top"},"f":[{"t":2,"r":"subscriptionName"}]}," ",{"t":7,"e":"div","a":{"class":"panel-text v-normal-bottom"},"f":[{"t":2,"r":"subscriptionDescription"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-centered"},"f":[{"t":7,"e":"form","f":[{"t":7,"e":"input","a":{"type":"radio","name":[{"t":2,"r":"id"},"-selected"],"value":[{"t":2,"r":"preferences.yesButtonText"}]},"m":[{"t":4,"f":["checked"],"n":50,"x":{"r":["selectedMobileOption","selectedBroadbandOption","id","selectedTvOption","preferences.yesButtonText"],"s":"(_2===\"mobile\"&&_0===_4)||(_2===\"broadband\"&&_1===_4)||(_2===\"tv\"&&_3===_4)"}}]}," ",{"t":7,"e":"label","a":{"class":["box-button ",{"t":4,"f":["checked"],"n":50,"x":{"r":["selectedMobileOption","selectedBroadbandOption","id","selectedTvOption","preferences.yesButtonText"],"s":"(_2===\"mobile\"&&_0===_4)||(_2===\"broadband\"&&_1===_4)||(_2===\"tv\"&&_3===_4)"}}]},"v":{"tap":{"n":"selectProduct","d":[{"t":2,"r":"id"},",",{"t":2,"r":"preferences.yesButtonText"}]}},"f":[{"t":7,"e":"div","a":{"class":"yes-button"}}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":2,"r":"preferences.yesButtonText"}]}]}," ",{"t":7,"e":"input","a":{"type":"radio","name":[{"t":2,"r":"id"},"-selected"],"value":[{"t":2,"r":"preferences.noButtonText"}]},"m":[{"t":4,"f":["checked"],"n":50,"x":{"r":["selectedMobileOption","selectedBroadbandOption","id","selectedTvOption","preferences.noButtonText"],"s":"(_2===\"mobile\"&&_0===_4)||(_2===\"broadband\"&&_1===_4)||(_2===\"tv\"&&_3===_4)"}}]}," ",{"t":7,"e":"label","a":{"class":["box-button ",{"t":4,"f":["checked"],"n":50,"x":{"r":["selectedMobileOption","selectedBroadbandOption","id","selectedTvOption","preferences.noButtonText"],"s":"(_2===\"mobile\"&&_0===_4)||(_2===\"broadband\"&&_1===_4)||(_2===\"tv\"&&_3===_4)"}}]},"v":{"tap":{"n":"selectProduct","d":[{"t":2,"r":"id"},",",{"t":2,"r":"preferences.noButtonText"}]}},"f":[{"t":7,"e":"div","a":{"class":"no-button"}}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":2,"r":"preferences.noButtonText"}]}]}]}]}]}]}]}],"r":"productCircleList"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 text-center"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["button round small-only-expand proceed-button ",{"t":4,"f":["disabled"],"n":50,"r":"onInitEligibleButtonDisabled"}],"ontap":"checkEligibility"},"f":[{"t":2,"r":"preferences.proceedButtonText"}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"eligibilityModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-only-text-center"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header v-normal-bottom"},"f":[{"t":2,"r":"preferences.eligibilityHeading"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 small-only-text-center"},"f":[{"t":3,"r":"modalDescription"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-text-right"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"modalLinkUrl"}],"class":"button round small-only-expand"},"f":[{"t":2,"r":"modalLinkText"}]}]}]}]}]}]};
this["ux-singtel-form-field"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-form-field"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-8"],"n":50,"r":"inline_button"},{"t":4,"n":51,"f":["medium-6"],"r":"inline_button"}]},"f":[{"t":7,"e":"div","a":{"class":"expandable-sections"},"f":[{"t":4,"f":[{"t":7,"e":"ux-input-box","a":{"validity":[{"t":2,"r":"valueErrorMsg"}],"placeholder":[{"t":2,"r":"placeholder"}],"id":[{"t":2,"r":"name"}],"label_value":[{"t":2,"r":"label"}],"mandatory":[{"t":2,"r":"mandatory"}],"value":[{"t":2,"r":"value"}],"type":"text","onblurEvent":"formControlsValidation"}}],"n":50,"x":{"r":["type"],"s":"_0==\"textfield\"||_0==\"email\"||_0==\"password\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0==\"checkbox\""},"f":[{"t":7,"e":"ux-checkbox","a":{"validity":[{"t":2,"r":"valueErrorMsg"}],"checkboxid":[{"t":2,"r":"name"}],"labelvalue":[{"t":2,"r":"labelvalue"}],"mandatory":[{"t":2,"r":"mandatory"}],"checked":[{"t":2,"r":"value"}],"onblurEvent":"formControlsValidation","onChangeEvent":"formControlsValidation"}}]},{"t":4,"n":50,"x":{"r":["type"],"s":"(!(_0==\"checkbox\"))&&(_0==\"select\")"},"f":[" ",{"t":7,"e":"ux-select","a":{"validity":[{"t":2,"r":"valueErrorMsg"}],"id":[{"t":2,"r":"name"}],"label_value":[{"t":2,"r":"label"}],"mandatory":[{"t":2,"r":"mandatory"}],"options":[{"t":2,"r":"options"}],"selected_value":[{"t":2,"r":"value"}],"onblurEvent":"formControlsValidation","showSelectedValue":"true"}}]},{"t":4,"n":50,"x":{"r":["type"],"s":"(!(_0==\"checkbox\"))&&((!(_0==\"select\"))&&(_0==\"textarea\"))"},"f":[" ",{"t":7,"e":"ux-textarea","a":{"validity":[{"t":2,"r":"valueErrorMsg"}],"placeholder":[{"t":2,"r":"placeholder"}],"id":[{"t":2,"r":"name"}],"label_value":[{"t":2,"r":"label"}],"mandatory":[{"t":2,"r":"mandatory"}],"rows":[{"t":2,"r":"rows"}],"value":[{"t":2,"r":"value"}],"onblurEvent":"formControlsValidation","class":"v-normal-top"}}]},{"t":4,"n":50,"x":{"r":["type"],"s":"(!(_0==\"checkbox\"))&&((!(_0==\"select\"))&&((!(_0==\"textarea\"))&&(_0==\"radiogroup\")))"},"f":[" ",{"t":7,"e":"label","a":{"class":[{"t":2,"r":"valid"}," v-medium-top v-medium-bottom"]},"f":[{"t":4,"f":[{"t":3,"r":"label"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"mandatory"},"f":["*"]}],"n":50,"r":"mandatory"}],"n":50,"r":"label"},{"t":4,"n":51,"f":[{"t":16}],"r":"label"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"valueErrorMsg.message"}]}}],"n":50,"x":{"r":["valueErrorMsg","valueErrorMsg.status"],"s":"_0&&_1===\"error\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-radio-button","a":{"class":"v-small-top v-medium-bottom","btn_id":[{"t":2,"r":"btn_id"}],"label":[{"t":2,"r":"label"}],"value":[{"t":2,"r":"value"}],"selected":[{"t":2,"r":"selected"}],"name":[{"t":2,"r":"name"}],"onclick":"radioOptionUpdated"}}],"i":"i","r":"radio_btns"}]}],"x":{"r":["type"],"s":"_0==\"textfield\"||_0==\"email\"||_0==\"password\""}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":["round small-only-expand ",{"t":4,"f":["disabled"],"n":50,"r":"disabledButton"}],"text":[{"t":2,"r":"inline_button.buttonText"}],"ontap":[{"t":2,"r":"inline_button.ontap"}]},"f":[]}],"n":50,"r":"inline_button"}]}]}]}]};
this["ux-singtel-form"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-singtel-form ",{"t":4,"f":[{"t":2,"r":"padding.topPadding"}],"n":50,"r":"padding.topPadding"}," ",{"t":4,"f":[{"t":2,"r":"padding.bottomPadding"}],"n":50,"r":"padding.bottomPadding"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header form-header v-normal-bottom"},"f":[{"t":2,"r":"heading"}]}," ",{"t":7,"e":"ux-header","a":{"level":"6","class":"form-subheader v-normal-bottom"},"f":[{"t":2,"r":"subheading"}]}," ",{"t":7,"e":"div","a":{"class":"note p-normal-bottom"},"f":["(",{"t":7,"e":"span","f":["*"]},") Required Field"]}]}]}," ",{"t":7,"e":"form","a":{"name":[{"t":2,"r":"formname"}]},"v":{"reset":"resetAddSubmitForm"},"f":[{"t":8,"r":"content"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-singtel-form-field"}],"i":"field","r":"formControls"}],"n":50,"r":"formControlsDataModel"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 v-normal-top "},"f":[{"t":7,"e":"input","a":{"class":"not-required-validation","name":[{"t":2,"r":"requiredValidationField"}],"type":"text","value":""}}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"formSubmissionMsg"}]}}],"n":50,"r":"formSubmissionMsg"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 "},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"formValidationMsg"}]}}]}]}],"n":50,"r":"formValidationMsg"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 p-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"class":["round small-only-expand ",{"t":4,"f":["disabled"],"n":50,"r":"disabledButton"}],"onclick":"addSubmitForm","text":[{"t":2,"r":"actionbutton.text"}]}}]}]}]}]}]};
this["ux-singtel-guest-profile"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-guest-profile"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"main-header title"},"f":[{"t":2,"r":"sectionTitle"}]}," ",{"t":7,"e":"div","a":{"class":"body v-normal-top"},"f":[{"t":2,"r":"sectionDesc"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-panel","a":{"class":"panel30 v-none-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"personal-info-section"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-10"},"f":[{"t":7,"e":"div","a":{"class":"teal-panel singpass-report v-normal-top flex-container flex-container-start"},"f":[{"t":7,"e":"ux-icon","a":{"type":"circle-tick","class":"black","size":"m"}}," ",{"t":7,"e":"span","a":{"class":"body-copy-text v-medium-left v-small-top"},"f":[{"t":2,"r":"initData.myInfoMessages.successscenario"}]}]}]}],"n":50,"r":"completeData"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["incompleteData"],"s":"_0"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-10"},"f":[{"t":7,"e":"div","a":{"class":"alert singpass-report v-normal-top flex-container flex-container-start"},"f":[{"t":7,"e":"ux-icon","a":{"type":"info","class":"black v-small-top","size":"m"}}," ",{"t":7,"e":"span","a":{"class":"body-copy-text v-medium-left v-small-top"},"f":[{"t":2,"r":"initData.myInfoMessages.incompletedata"}]}]}]}]}],"r":"completeData"}," ",{"t":7,"e":"ux-col","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"personalInfo.title"}]}," ",{"t":7,"e":"div","a":{"class":"body v-medium-top"},"f":[{"t":2,"r":"personalInfo.desc"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium-top left-right-collapse"},"f":[{"t":7,"e":"div","a":{"class":"input-label"},"f":[{"t":2,"r":"personalInfo.idTitle"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3"},"f":[{"t":7,"e":"ux-select","a":{"id":"guestID","showSelectedValue":"true","class":"medium","name":"guestID","selectReadOnly":[{"t":2,"x":{"r":["disablePopulatedField","cisInfoFlag"],"s":"_0||_1"}}],"selected_value":[{"t":2,"r":"selectedGuestId"}],"options":[{"t":2,"r":"guestIDPrefixOptions"}],"onChangeEvent":"onGuestIdChange"},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-9"},"f":[{"t":7,"e":"ux-input-box","a":{"id":"guestIdNumber","value":[{"t":2,"r":"guestIdNumber"}],"disabled":[{"t":2,"x":{"r":["disablePopulatedField","cisInfoFlag"],"s":"_0||_1"}}],"onInputEvent":"updateIdNumber","onblurEvent":"validateCusId","validity":[{"t":2,"r":"guestIdNumberErrorMsg"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"input-label"},"f":[{"t":2,"r":"personalInfo.idTypeTitle"}]}," ",{"t":7,"e":"ux-select","a":{"id":"guestType","showSelectedValue":"true","class":"medium","name":"guestType","selected_value":[{"t":2,"r":"guestType"}],"selectReadOnly":[{"t":2,"r":"disablePopulatedField"}," || (",{"t":4,"f":["disabled"],"n":50,"x":{"r":["cisInfoFlag","guestIdNumberErrorMsg.status"],"s":"_0||_1!==\"valid\""}},")"],"options":[{"t":2,"r":"guestIdTypeOptions"}]},"f":[]}]}]}],"n":50,"x":{"r":["showIdentificationDetails","singpassFlag"],"s":"_0&&!_1"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-top left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-4 dropdown"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold v-small-bottom"},"f":[{"t":2,"r":"personalInfo.salutationTitle"}]}," ",{"t":7,"e":"ux-select","a":{"id":"select-salutation","name":"salutation","defaultOption":"Select","showSelectedValue":"true","class":"medium","onChangeEvent":"onSalutationChange","selected_value":[{"t":2,"r":"salutation"}],"options":[{"t":2,"r":"defaultOptions.salutationOptions"}]},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"ConfigStrings.guestCheckoutValidationError.salutationErrorMsg"}]},"f":[]}]}],"n":50,"x":{"r":["salutationError","singpassFlag","salutation"],"s":"_0||(_1&&_2===\"Select\")"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold v-small-bottom"},"f":[{"t":2,"r":"personalInfo.nameTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":2,"r":"registeredName"}]}]}],"n":50,"r":"singpassFlag"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-input-box","a":{"id":"registeredName","value":[{"t":2,"r":"registeredName"}],"disabled":[{"t":2,"r":"cisInfoFlag"}],"name":"registeredName","onblurEvent":"validateName","onInputEvent":"updateName","validity":[{"t":2,"r":"registeredNameErrorMsg"}]},"f":[]}],"r":"singpassFlag"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-top left-right-collapse"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold v-small-bottom"},"f":[{"t":2,"r":"personalInfo.dobTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":2,"r":"birthDate"}]}],"n":50,"r":"singpassFlag"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"small-4 dropdown"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-day","showSelectedValue":"true","class":"medium","name":"day","selected_value":[{"t":2,"r":"day"}],"options":[{"t":2,"r":"defaultOptions.dayOptions"}],"selectReadOnly":[{"t":2,"r":"cisInfoFlag"}]},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 dropdown"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-month","showSelectedValue":"true","class":"medium","name":"month","selected_value":[{"t":2,"r":"month"}],"options":[{"t":2,"r":"defaultOptions.monthOptions"}],"selectReadOnly":[{"t":2,"r":"cisInfoFlag"}]},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 dropdown"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-year","showSelectedValue":"true","class":"medium","name":"year","selected_value":[{"t":2,"r":"year"}],"options":[{"t":2,"r":"defaultOptions.yearOptions"}],"selectReadOnly":[{"t":2,"r":"cisInfoFlag"}]},"f":[]}]}],"r":"singpassFlag"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"dateError"}]},"f":[]}]}],"n":50,"r":"dateError"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"right v-small-right"},"f":[{"t":7,"e":"ux-form-validity","a":{"class":"right v-small-right","status":"error","message":[{"t":2,"r":"doyError"}]},"f":[]}]}]}],"n":50,"r":"doyError"}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top left-right-collapse"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold v-small-bottom"},"f":[{"t":2,"r":"personalInfo.genderTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":4,"f":["Male"],"n":50,"x":{"r":["gender"],"s":"_0===\"M\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["gender"],"s":"_0===\"F\""},"f":["Female"]}],"x":{"r":["gender"],"s":"_0===\"M\""}}]}],"n":50,"x":{"r":["singpassFlag","gender"],"s":"_0&&(_1===\"M\"||_1===\"F\")"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":4,"f":["Male"],"n":50,"x":{"r":["gender"],"s":"_0===\"M\""}},{"t":4,"n":51,"f":["Female"],"x":{"r":["gender"],"s":"_0===\"M\""}}]}],"n":50,"x":{"r":["cisInfoFlag","disableGender","salutation"],"s":"(_0||_1)&&(_2===\"MR\"||_2===\"MRS\"||_2===\"MS\")"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-select","a":{"id":"select-gender","showSelectedValue":"true","class":"medium","name":"gender","selected_value":[{"t":2,"r":"gender"}],"defaultOption":"Select","disabled":[{"t":2,"r":"disableGender"}],"options":[{"t":2,"r":"defaultOptions.genderOptions"}],"onChangeEvent":"onGenderChange"},"f":[]}],"x":{"r":["cisInfoFlag","disableGender","salutation"],"s":"(_0||_1)&&(_2===\"MR\"||_2===\"MRS\"||_2===\"MS\")"}}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"ConfigStrings.guestCheckoutValidationError.genderErrorMsg"}]},"f":[]}]}],"n":50,"r":"genderError"}],"x":{"r":["singpassFlag","gender"],"s":"_0&&(_1===\"M\"||_1===\"F\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top left-right-collapse"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold v-small-bottom"},"f":[{"t":2,"r":"guestType"}]}," ",{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":2,"r":"nric"}]}]}],"n":50,"r":"singpassFlag"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top left-right-collapse"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold v-small-bottom"},"f":[{"t":2,"r":"guestType"}]}," ",{"t":7,"e":"ux-input-box","a":{"id":"nric","name":"nric","value":[{"t":2,"r":"nric"}],"onblurEvent":"onNricBlur","onChangeEvent":"updateNric","validity":[{"t":2,"r":"nricErrorMsg"}]}}]}],"n":50,"r":"editableNric"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["worryFreeFlow","singpassFlag"],"s":"_0&&!_1"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top left-right-collapse"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold v-small-bottom"},"f":[{"t":2,"r":"guestType"}]}," ",{"t":7,"e":"ux-input-box","a":{"id":"guestIDWorryFree","name":"guestIDWorryFree","value":[{"t":2,"x":{"r":["selectedGuestId","guestIdNumber"],"s":"_0+_1"}}],"disabled":"true"}}]}]}],"r":"editableNric"}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top left-right-collapse"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold v-small-bottom"},"f":[{"t":2,"r":"personalInfo.contactTitle"}]}," ",{"t":7,"e":"ux-input-box","a":{"id":"contactNumber","name":"contactNumber","value":[{"t":2,"r":"contactNumber"}],"onblurEvent":"validateContactNumber","onInputEvent":"updateNum","validity":[{"t":2,"r":"contactVal.contactValErrorMsg"}]}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top left-right-collapse"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold v-small-bottom"},"f":["Contact Email"]}," ",{"t":7,"e":"ux-input-box","a":{"id":"guestEmail","name":"guestEmail","value":[{"t":2,"r":"guestEmail"}],"onblurEvent":"onEmailChange","onInputEvent":"onEmailChange","validity":[{"t":2,"r":"guestEmailErrorMsg"}]}}]}],"n":50,"r":"worryFreeFlow"}]}]}]}," ",{"t":7,"e":"ux-panel","a":{"class":"panel30 v-none-bottom contact-panel"},"f":[{"t":7,"e":"ux-row","a":{"class":"contact-info-section"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"contactInfo.title"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body v-medium-top"},"f":[{"t":2,"r":"contactInfo.desc"}]}],"n":50,"r":"contactInfo.desc"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 v-normal-top contact-address-form"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"customer-profile-section"},"f":[{"t":7,"e":"ux-row","a":{"class":"personal-info"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-9 medium-12 ekyc-info-container p-left-none"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["ux-address-form ",{"t":2,"r":"class"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"errorMessage"}],"validityMsgClass":"margin-zero"},"f":[]}]}]}],"n":50,"r":"errorMessage"}," ",{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-6 small-6"],"n":50,"r":"equalSpacing"},{"t":4,"n":51,"f":["medium-8 small-6"],"r":"equalSpacing"}]},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom p-top-zero"},"f":["Postal Code"]}," ",{"t":7,"e":"div","a":{"class":"postal-code-input"},"f":[{"t":2,"r":"address.postCode"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 v-normal-top"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom"},"f":["House / Block Number"]}," ",{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":2,"r":"address.blockOrHouseNum"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 v-normal-top"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom"},"f":["Street Name"]}," ",{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":2,"r":"address.streetName"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom"},"f":["Building / Estate Name"]}," ",{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":2,"x":{"r":["address.buildingName"],"s":"_0?_0:\"--\""}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"left-right-collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6 padding-for-mobile v-normal-top"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom"},"f":["Floor No."]}," ",{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":2,"x":{"r":["address.floorToDisplay"],"s":"_0?_0:\"--\""}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 padding-for-mobile v-normal-top"},"f":[{"t":7,"e":"label","a":{"class":"input-label-bold v-small-bottom"},"f":["Unit No."]}," ",{"t":7,"e":"div","a":{"class":"inline-form"},"f":[{"t":2,"x":{"r":["address.unitNumberToDisplay"],"s":"_0?_0:\"--\""}}]}]}]}],"n":51,"r":"address.isNotApplicable"}]}],"n":50,"r":"singpassFlag"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-address-form","a":{"class":[{"t":2,"r":"initData.postalCodeText"}],"datamodel":[{"t":3,"r":"."}],"address":[{"t":2,"r":"newAddress"}],"addressList":[{"t":2,"r":"addressList"}],"onUpdate":"updateAdressDetails","hideUpdateButton":"true"}}],"n":50,"r":"showAddress"}],"r":"singpassFlag"}]}]}]}]}],"n":50,"x":{"r":["singpassFlag","address.postCode","address.isNotApplicable","address.floor","address.unitNumber"],"s":"_0&&_1&&(_2||(_3&&_4))"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":4,"f":[{"t":2,"r":"block"},","],"n":50,"r":"block"}," ",{"t":4,"f":[{"t":2,"r":"street"}],"n":50,"r":"street"}]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":4,"f":["#",{"t":2,"r":"floor"},"-"],"n":50,"r":"floor"},{"t":4,"f":[{"t":2,"r":"unit"}],"n":50,"r":"unit"}," ",{"t":4,"f":[{"t":2,"r":"building"}],"n":50,"r":"building"}]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":4,"f":["Singapore"],"n":50,"x":{"r":["country"],"s":"_0===\"SG\""}},{"t":4,"n":51,"f":[{"t":2,"r":"country"}],"x":{"r":["country"],"s":"_0===\"SG\""}}," ",{"t":4,"f":[{"t":2,"r":"postal"}],"n":50,"r":"postal"}]}],"n":53,"r":"myInfoData.selectedAddress"}],"n":50,"x":{"r":["cisInfoFlag","myInfoData.selectedAddress","myInfoData.selectedAddress.postal"],"s":"_0&&_1&&_2"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-address-form","a":{"address":[{"t":2,"r":"address"}],"addressList":[{"t":2,"r":"addressList"}],"errorMessage":[{"t":2,"r":"errorMessage"}],"hideUpdateButton":"true"}}],"n":50,"r":"showAddress"}],"x":{"r":["cisInfoFlag","myInfoData.selectedAddress","myInfoData.selectedAddress.postal"],"s":"_0&&_1&&_2"}}],"x":{"r":["singpassFlag","address.postCode","address.isNotApplicable","address.floor","address.unitNumber"],"s":"_0&&_1&&(_2||(_3&&_4))"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"checkout-panel"}}," ",{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"v-normal-top action-container"},"f":[{"t":7,"e":"ux-ekyc-checkout-panel","a":{"isManuallyUpload":[{"t":2,"x":{"r":[],"s":"true"}}],"data":[{"t":2,"r":"guestCheckoutSingpass"}]}}]}],"n":50,"r":"isManuallyUpload"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-panel","a":{"class":"v-normal-top action-container"},"f":[{"t":7,"e":"ux-ekyc-checkout-panel","a":{"isManuallyUpload":[{"t":2,"x":{"r":[],"s":"true"}}],"data":[{"t":2,"r":"guestCheckoutFillFormManually"}]}}]}],"r":"isManuallyUpload"}]}]}]}],"n":50,"x":{"r":["eKycEnabled","missingDataInMyInfo"],"s":"_0&&!_1"}}," ",{"t":7,"e":"ux-panel","a":{"class":"panel30"},"f":[{"t":7,"e":"ux-row","a":{"class":"contact-info-section"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"consentInfo.title"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body v-medium-top"},"f":[{"t":2,"r":"consentInfo.desc"}]}],"n":50,"r":"consentInfo.desc"}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-checkbox","a":{"checked":[{"t":2,"r":"isConsentAgreed"}],"labelvalue":[{"t":4,"f":[{"t":2,"r":"consentLiner"}],"n":50,"r":"consentLiner"},{"t":4,"n":51,"f":[{"t":2,"r":"ConfigStrings.consent.liner"}],"r":"consentLiner"}],"class":"top31 v-medium-top"},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"consentAgreedMessage"}]},"f":[]}],"n":50,"r":"consentError"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-top text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":"round small-only-expand","text":"Continue","role":"button","arialabel":"Continue Button","onclick":"doContinue"},"f":[]}]}]}]}]};
this["ux-singtel-heading-text"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-heading-text-singtel"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":["ux-heading-text-singtel-header ",{"t":4,"f":["v-",{"t":2,"x":{"r":["leftSpacing"],"s":"_0?_0:\"normal\""}},"-left"],"n":50,"r":"leftSpacing"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["rightSpacing"],"s":"_0?_0:\"normal\""}},"-right"],"n":50,"r":"rightSpacing"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["topSpacing"],"s":"_0?_0:\"normal\""}},"-top"],"n":50,"r":"topSpacing"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["bottomSpacing"],"s":"_0?_0:\"normal\""}},"-bottom"],"n":50,"r":"bottomSpacing"}]},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":[{"t":2,"x":{"r":["headingStyle"],"s":"_0?_0:\"main-header\""}}]},"f":[{"t":2,"r":"heading"}]}]}],"n":50,"r":"heading"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":["ux-heading-text-singtel-text ",{"t":4,"f":["v-",{"t":2,"x":{"r":["textLeftSpacing"],"s":"_0?_0:\"normal\""}},"-left"],"n":50,"r":"textLeftSpacing"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["textRightSpacing"],"s":"_0?_0:\"normal\""}},"-right"],"n":50,"r":"textRightSpacing"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["textTopSpacing"],"s":"_0?_0:\"normal\""}},"-top"],"n":50,"r":"textTopSpacing"}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["textBottomSpacing"],"s":"_0?_0:\"normal\""}},"-bottom"],"n":50,"r":"textBottomSpacing"}]},"f":[{"t":7,"e":"div","a":{"class":["description-text ",{"t":2,"x":{"r":["descStyle"],"s":"_0?_0:\"body-copy-text\""}}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["headerDescSpacing"],"s":"_0?_0:\"normal\""}},"-top"],"n":50,"r":"headerDescSpacing"}," ",{"t":4,"f":["hide-for-small-only"],"n":50,"r":"hideDescriptionForMobile"}]},"f":[{"t":3,"r":"text"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"link"}],"class":"weight-medium"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"linkText"}," ",{"t":7,"e":"ux-row","f":[]}]}],"n":50,"r":"text"}]}]};
this["ux-singtel-login-header"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-login-header"},"f":[{"t":4,"f":[{"t":7,"e":"a","v":{"click":"doLogin"},"a":{"aria-label":[{"t":2,"x":{"r":["showMenu"],"s":"_0?\"Hide\":\"Show\""}}],"class":"person-icon"},"f":[{"t":7,"e":"div","a":{"class":"login-icon"},"f":[{"t":7,"e":"ux-icon","a":{"outerClass":"align-icon hover-state-alignment","class":"login-hover","size":"m","type":"09-login","overIconImageAttribute":"true"}}," ",{"t":7,"e":"ux-icon","a":{"outerClass":"align-icon hover-state-alignment","class":"login-normal","size":"m","type":"09-login","overIconImageAttribute":"true"}}]}]}],"n":50,"x":{"r":["headerType"],"s":"_0===\"image\""}}," ",{"t":7,"e":"div","a":{"class":["myaccount-menu ",{"t":2,"r":"className"}," icon-menu ",{"t":2,"x":{"r":["showMenu"],"s":"_0?\"show\":\"\""}}," ",{"t":4,"f":["loginTrue"],"n":50,"r":"loggedIn"}]},"f":[{"t":7,"e":"ul","a":{"class":"container"},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":[{"t":4,"f":["v-medium-top"],"n":50,"x":{"r":["i"],"s":"_0===0"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["i","data.links.length"],"s":"_0===_1-1"},"f":["v-medium-bottom"]}],"x":{"r":["i"],"s":"_0===0"}}]},"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"src"}],"class":"link-container"},"v":{"click":{"n":[{"t":4,"f":["do_Logout"],"n":50,"x":{"r":["i","data.links.length"],"s":"_0===_1-1"}}],"d":[]}},"f":[{"t":7,"e":"span","a":{"class":"menu-option"},"f":[{"t":2,"r":"title"}]}]}]}],"n":52,"i":"i","r":"data.links"}]}]}]}]};
this["ux-singtel-login"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-login"},"f":[]}]};
this["ux-singtel-onepass-change-password"] = {"v":3,"t":[{"t":4,"f":[{"t":2,"r":"successMessage"}],"n":50,"r":"successMessage"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"ux-singtel-onepass-change-password"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[" "]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"warningMessage"},"f":[{"t":2,"r":"warningMessageDisplay"}]}],"n":50,"r":"warningMessageDisplay"}]}]}," ",{"t":7,"e":"form","a":{"action":[{"t":2,"r":"changePasswordFormAction"}],"method":"post"},"v":{"submit":{"m":"doSubmitAction","a":{"r":["event"],"s":"[_0]"}}},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Current Password"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"input","a":{"name":"current_password","id":"current_password","type":"password","class":["currentPasswordClass ",{"t":2,"r":"currentPasswordClass"}],"value":[{"t":2,"r":".currentPassword"}]}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["New Password ",{"t":7,"e":"div","a":{"class":"singtel-tooltip"},"f":[{"t":7,"e":"a","f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"span","a":{"class":"tooltiptext tooltiptext-inverse"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":["Minimum 8 characters ",{"t":7,"e":"br"}," Maximum 20 characters ",{"t":7,"e":"br"}," At least 1 uppercase ",{"t":7,"e":"br"}," At least 1 lowercase ",{"t":7,"e":"br"}," At least 1 digit ",{"t":7,"e":"br"}," Spaces, % and & are not allowed"]}]}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"input","a":{"name":"pass","id":"pass","type":"password","class":["newPasswordClass ",{"t":2,"r":"newPasswordClass"}],"value":[{"t":2,"r":".newPassword"}]}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Repeat New Password"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"input","a":{"name":"cpass","id":"cpass","type":"password","class":["newRepeatPasswordClass ",{"t":2,"r":"newPasswordClass"}],"value":[{"t":2,"r":".newRepeatPassword"}]}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-right spacer-top"},"f":[{"t":7,"e":"input","a":{"name":"callbackURL","id":"callbackURL","type":"hidden","value":[{"t":2,"r":"changepassword.callbackURL"}]}}," ",{"t":7,"e":"input","a":{"name":"portalTy","id":"portalTy","type":"hidden","value":[{"t":2,"r":".portalTy"}]}}," ",{"t":7,"e":"input","a":{"type":"submit","class":"button round updatePasswordButtonClass","value":"Update"}}]}]}]}]}],"r":"successMessage"}]};
this["ux-singtel-onepass-login"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-singtel-onepass-login ",{"t":2,"r":"loginType"}," ",{"t":2,"r":"view"}]},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["panel"],"n":50,"r":"panelRequired"}," column-control-mobile"]},"f":[{"t":7,"e":"form","a":{"action":[{"t":2,"r":"loginURL"}],"method":"post","id":"onepassForm"},"v":{"submit":{"m":"doLoginAction","a":{"r":["event"],"s":"[_0]"}}},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":3,"r":"onepassTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"subtitle v-medium-top subtitle-bottom"},"f":[" "]}],"n":50,"x":{"r":["view"],"s":"_0===\"shop\""}}]}]}],"n":50,"r":"onepassTitle"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"6"},"f":[{"t":3,"r":"onepassDescription"}]}]}]}],"n":50,"r":"onepassDescription"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"login-spacer"},"f":[" "]}]}],"n":50,"r":"panelRequired"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"warningMessage"},"f":[{"t":2,"r":"warningMessageDisplay"}]}],"n":50,"r":"warningMessageDisplay"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-small-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Singtel OnePass"]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"select","a":{"name":"country_code","id":"country_code","class":"countryCode","value":[{"t":2,"r":".countryCode"}]},"v":{"focus":{"m":"onfocusCC","a":{"r":[],"s":"[]"}},"blur":{"m":"onblurCC","a":{"r":[],"s":"[]"}}},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":"countryCode"},"-"],"label":[{"t":2,"r":"countryDisplay"}]},"f":[{"t":2,"r":"countryDisplay"}]}],"n":52,"r":"countryList"}]}]}],"n":50,"r":"displayCountryCode"}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":2,"r":"usernameSpacing"}]},"f":[{"t":7,"e":"input","a":{"name":"loginid","id":"loginid","type":"text","class":["inputLogin ",{"t":2,"r":".loginidClass"}],"autocomplete":"off","placeholder":"Email / Mobile number","tabindex":"1","value":[{"t":2,"r":".loginid"}]}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Password"]}," ",{"t":7,"e":"input","a":{"name":"pass","id":"pass","type":"password","class":["inputPass ",{"t":2,"r":".passClass"}],"autocomplete":"off","placeholder":"••••••••","tabindex":"3","value":[{"t":2,"r":".pass"}]}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-right"},"f":[{"t":7,"e":"a","v":{"click":"forgetPasswordURLClicked"},"a":{"href":[{"t":2,"r":"forgetPasswordURL"},"?portalTy=",{"t":2,"r":"portalType"},"&success_callback_url=",{"t":2,"r":"origin"}],"tabindex":"12"},"f":["Forgot password?"]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"input","a":{"name":"password","id":"password","type":"hidden","value":[{"t":2,"r":".password1"}]}}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"temp_ccode","id":"temp_ccode","value":[{"t":2,"r":".tempCcode"}]}}," ",{"t":7,"e":"input","a":{"name":"ssoLoginUserid","id":"ssoLoginUserid","type":"hidden","value":[{"t":2,"r":".ssoLoginUserid"}]}}," ",{"t":7,"e":"input","a":{"name":"loginUserid","id":"loginUserid","type":"hidden","value":[{"t":2,"r":".loginUserid"}]}}," ",{"t":7,"e":"input","a":{"name":"PASSWORD","id":"PASSWORD","type":"hidden","value":[{"t":2,"r":".password2"}]}}," ",{"t":7,"e":"input","a":{"name":"USER","id":"USER","type":"hidden","value":[{"t":2,"r":".username"}]}}," ",{"t":7,"e":"input","a":{"id":"target","class":"inputTarget","type":"hidden","name":"target","value":[{"t":2,"r":".targetURL"}]}}," ",{"t":7,"e":"input","a":{"id":"portalTy","class":"inputPortalTy","name":"portalTy","type":"hidden","value":[{"t":2,"r":".portalType"}]}}," ",{"t":7,"e":"input","a":{"id":"success_callback_url","type":"hidden","name":"success_callback_url","value":[{"t":2,"r":".succesCallBackURL"}]}}," ",{"t":7,"e":"input","a":{"id":"failure_callback_url","type":"hidden","name":"failure_callback_url","value":[{"t":2,"r":".failureCallBackURL"}]}}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"fullbar"},"f":[{"t":7,"e":"ux-col","a":{"class":" small-12 center"},"f":[{"t":7,"e":"input","a":{"type":"submit","value":"Log in","class":"spacer-top line-button button round submit loginButton","tabindex":"10"}}," ",{"t":7,"e":"span","a":{"class":"button-spacer"},"f":[" "]}," ",{"t":7,"e":"a","v":{"click":"registrationURLClicked"},"a":{"href":[{"t":2,"r":"registrationURL"},"?portalTy=",{"t":2,"r":"portalType"},"&success_callback_url=",{"t":2,"r":"origin"}],"class":"spacer-top line-button button light round registrationButton","tabindex":"11"},"f":["Register"]}]}]}],"n":50,"r":"showActionButtons"},{"t":4,"n":51,"f":[{"t":7,"e":"input","a":{"type":"submit","value":"","class":"hide onepass-button","id":"onepassLoginButton"}}],"r":"showActionButtons"}]}," ",{"t":4,"f":[{"t":7,"e":"iframe","a":{"class":"hide","width":"1px","height":"1px","frameBorder":"0","id":"iframeParent"}}," ",{"t":7,"e":"div","a":{"class":"hide","id":"onepassdynamiciframediv"},"f":[]}],"n":50,"x":{"r":["loginType"],"s":"_0===\"ajax\""}}]}]}]};
this["ux-singtel-onepass-profile"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-onepass-profile"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[" "]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"warningMessage"},"f":[{"t":2,"r":"warningMessageDisplay"}]}],"n":50,"r":"warningMessageDisplay"}]}]}," ",{"t":7,"e":"form","a":{"action":[{"t":2,"r":"updateFormAction"}],"method":"post"},"v":{"submit":{"m":"doSubmitAction","a":{"r":["event"],"s":"[_0]"}}},"f":[{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["hide"],"n":50,"r":".displayNickNameOnly"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":["NRIC / FIN No."]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":2,"r":".user.nric"}," ",{"t":7,"e":"input","a":{"name":"nric","id":"mobile-num-submit","type":"hidden","value":[{"t":2,"r":".user.nric"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["hide"],"n":50,"r":".displayNickNameOnly"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":["Salutation"]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"select","a":{"name":"salutation","class":[{"t":2,"r":"genderAndSalutationClass"}],"value":[{"t":2,"r":".user.salutation"}]},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":".value"}]},"m":[{"t":4,"f":["selected=\"selected\""],"n":50,"r":".selected"}],"f":[{"t":2,"r":".value"}]}],"n":52,"r":"defaultOptions.salutationOptions"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Nick Name"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"input","a":{"name":"givenName","id":"givenName","type":"text","class":[" ",{"t":2,"r":"givenNameClass"}],"title":"","value":[{"t":2,"r":".user.givenName"}],"maxlength":"10"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["hide"],"n":50,"r":".displayNickNameOnly"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":["Last Name"]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"input","a":{"name":"lastName","id":"lastName","type":"text","class":[{"t":2,"r":"lastNameClass"}],"title":"","value":[{"t":2,"r":".user.lastName"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"hide"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":["NRIC/FIN TYPE"]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"select","a":{"name":"nricTy","tabindex":"3","id":"nricTy","style":"display: none;","value":[{"t":2,"r":".user.nricTy"}]},"f":[{"t":7,"e":"option","a":{"value":"select","selected":"selected"},"f":["Please select NRIC/FIN type"]}," ",{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":".value"}]},"m":[{"t":4,"f":["selected=\"selected\""],"n":50,"r":".selected"}],"f":[{"t":2,"r":".name"}]}],"n":52,"r":"defaultOptions.nricTyOptions"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["hide"],"n":50,"r":".displayNickNameOnly"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":["Preferred E-mail Address"]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"input","a":{"name":"newContactMail","id":"newContactMail","type":"text","class":"email","title":"","value":[{"t":2,"r":".user.newContactMail"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["hide"],"n":50,"r":".displayNickNameOnly"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":["Preferred Mobile Number"]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 small-4 medium-4"},"f":[{"t":7,"e":"select","a":{"name":"country_code","id":"country_code","class":"countryCode","value":[{"t":2,"r":".user.preferredMobileCountryCode"}]},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":"countryCode"},"-"]},"m":[{"t":4,"f":["selected=\"selected\""],"n":50,"r":".preferredMobileSelected"}],"f":["(+",{"t":2,"r":"countryCode"},")"]}],"n":52,"r":"options.countryList"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6 small-6 medium-6"},"f":[{"t":7,"e":"input","a":{"name":"preferredMobilePlaceHolder","id":"mobile-num","type":"text","value":[{"t":2,"r":".user.preferredMobile"}],"class":[{"t":2,"r":"mobileClass"}]}}]}," ",{"t":7,"e":"input","a":{"name":"preferredMobile","id":"mobile-num-submit","type":"hidden","value":[{"t":2,"r":".user.preferredMobileSubmit"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["hide"],"n":50,"r":".displayNickNameOnly"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":["Home No."]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4 small-4 medium-4"},"f":[{"t":7,"e":"select","a":{"name":"country_code1","id":"country_code1","class":"countryCode1","value":[{"t":2,"r":".user.homeNoCountryCode"}]},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":"countryCode"},"-"]},"m":[{"t":4,"f":["selected=\"selected\""],"n":50,"r":".homeNoSelected"}],"f":["(+",{"t":2,"r":"countryCode"},")"]}],"n":52,"r":"options.countryList"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6 small-6 medium-6"},"f":[{"t":7,"e":"input","a":{"name":"homeNoPlaceHolder","id":"home-num","type":"text","value":[{"t":2,"r":".user.homeNo"}],"class":[{"t":2,"r":"homeNoClass"}]}}]}," ",{"t":7,"e":"input","a":{"name":"homeNo","id":"home-num-submit","type":"hidden","value":[{"t":2,"r":".user.homeNoSubmit"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["hide"],"n":50,"r":".displayNickNameOnly"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":["Date of Birth"]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":[{"t":7,"e":"select","a":{"name":"day","id":"day","value":[{"t":2,"r":".user.dateOfBirth.day"}],"class":[{"t":2,"r":"birthdayClass"}]},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":".value"}]},"m":[{"t":4,"f":["selected=\"selected\""],"n":50,"r":".selected"}],"f":[{"t":2,"r":".value"}]}],"n":52,"r":"defaultOptions.dayOptions"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":[{"t":7,"e":"select","a":{"name":"month","id":"month","value":[{"t":2,"r":".user.dateOfBirth.month"}],"class":[{"t":2,"r":"birthdayClass"}]},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":".value"}]},"m":[{"t":4,"f":["selected=\"selected\""],"n":50,"r":".selected"}],"f":[{"t":2,"r":".name"}]}],"n":52,"r":"defaultOptions.monthOptions"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":[{"t":7,"e":"select","a":{"name":"year","id":"year","value":[{"t":2,"r":".user.dateOfBirth.year"}],"class":[{"t":2,"r":"birthdayClass"}]},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":".value"}]},"m":[{"t":4,"f":["selected=\"selected\""],"n":50,"r":".selected"}],"f":[{"t":2,"r":".value"}]}],"n":52,"r":"defaultOptions.yearOptions"}]}]}]}," ",{"t":7,"e":"input","a":{"type":"hidden","name":"birthday","id":"birthday","value":[{"t":2,"r":".user.dateOfBirth.birthday"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["hide"],"n":50,"r":".displayNickNameOnly"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"large-4"},"f":["Gender"]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6"},"f":[{"t":7,"e":"select","a":{"name":"gender","id":"gender","value":[{"t":2,"r":".user.gender"}],"class":[{"t":2,"r":"genderAndSalutationClass"}]},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"r":".value"}]},"m":[{"t":4,"f":["selected=\"selected\""],"n":50,"r":".selected"}],"f":[{"t":2,"r":".name"}]}],"n":52,"r":"defaultOptions.genderOptions"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-right spacer-top"},"f":[{"t":7,"e":"input","a":{"name":"callbackURL","id":"callbackURL","type":"hidden","value":[{"t":2,"r":".callbackURL"}]}}," ",{"t":7,"e":"input","a":{"name":"portalTy","id":"portalTy","type":"hidden","value":[{"t":2,"r":".portalTy"}]}}," ",{"t":7,"e":"input","a":{"type":"submit","class":"button round","value":"Update"}}]}]}]}]}]};
this["ux-singtel-product-channels"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-product-channels v-large-bottom"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header v-large-top v-medium-bottom"},"f":[{"t":2,"r":"panelTitle"}]}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 medium-4 large-3 columns channels-container v-medium-bottom ",{"t":4,"f":["flip"],"n":50,"r":"flipState"}," cursor"]},"f":[{"t":7,"e":"ux-panel","a":{"class":"channel-box flipper"},"f":[{"t":7,"e":"div","a":{"class":"front text-left v-medium-bottom"},"v":{"tap":{"n":"selectChannel","d":[{"t":2,"r":"index"}]}},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"image"}],"class":"channel-image v-medium-bottom"}}," ",{"t":7,"e":"div","a":{"class":"channel-title"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"channel-genre"},"f":[{"t":4,"f":[{"t":4,"f":[", "],"n":50,"x":{"r":["i"],"s":"_0>0"}},{"t":2,"r":"."}],"n":52,"i":"i","r":"castGenre"}]}]}," ",{"t":7,"e":"div","a":{"class":"back text-left v-medium-bottom"},"v":{"tap":{"n":"selectChannel","d":[{"t":2,"r":"index"}]}},"f":[{"t":7,"e":"div","a":{"class":"channel-title"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"channel-genre"},"f":[{"t":4,"f":[{"t":4,"f":[", "],"n":50,"x":{"r":["i"],"s":"_0>0"}},{"t":2,"r":"."}],"n":52,"i":"i","r":"castGenre"}]}," ",{"t":7,"e":"div","a":{"class":"channel-desc"},"f":[{"t":2,"r":"description"}]}]}]}]}],"i":"index","r":"summaryChannelList"}]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"doOpenModal:fullChannelListing"},"f":["View all ",{"t":2,"r":"totalChannels"}," Channels"]}," ",{"t":7,"e":"ux-modal","a":{"class":"light-theme","widthPercentage":"100","modalId":"fullChannelListing"},"f":[{"t":7,"e":"div","a":{"class":"white-bg"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-large-top v-large-bottom"},"f":[{"t":2,"r":"packName"}," Channels"]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 medium-3 large-3 channels-container v-medium-bottom ",{"t":4,"f":["flip"],"n":50,"r":"flipState"}]},"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-panel","a":{"class":"channel-box flipper"},"f":[{"t":7,"e":"div","a":{"class":"front text-left v-medium-bottom"},"v":{"tap":{"n":"selectChannel","d":[{"t":2,"r":"index"}]}},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"image"}],"class":"channel-image v-medium-bottom"}}," ",{"t":7,"e":"div","a":{"class":"channel-title"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"channel-genre"},"f":[{"t":4,"f":[{"t":4,"f":[", "],"n":50,"x":{"r":["i"],"s":"_0>0"}},{"t":2,"r":"."}],"n":52,"i":"i","r":"castGenre"}]}]}," ",{"t":7,"e":"div","a":{"class":"back text-left v-medium-bottom"},"v":{"tap":{"n":"selectChannel","d":[{"t":2,"r":"index"}]}},"f":[{"t":7,"e":"div","a":{"class":"channel-title"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"channel-desc"},"f":[{"t":2,"r":"description"}]}]}]}]}]}],"i":"index","r":"channelList"}]}]}]}]};
this["ux-singtel-product-info"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-product-info"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header response-title v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"p","a":{"class":"v-normal-bottom"},"f":[{"t":3,"r":"description"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider expanded padded"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header v-medium-bottom v-normal-top section-title"},"f":["What can you do next?"]}," ",{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header subsection v-normal-top v-small-bottom"},"f":["Email Confirmation"]}," ",{"t":7,"e":"p","f":["An email will be sent to you with your reservation details once the order has been confirmed."]}," ",{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header subsection v-normal-top v-small-bottom"},"f":["View Collection Locations"]}," ",{"t":7,"e":"p","f":["Meanwhile, you may wish to ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}],"target":[{"t":4,"f":["_blank"],"n":50,"r":"buttonOpenNewWindow"},{"t":4,"n":51,"f":["_self"],"r":"buttonOpenNewWindow"}],"class":"item small-text-center medium-text-left large-text-left wraptext","ontap":"showCollectionLocations"},"f":[{"t":2,"r":"linkText"}]},"."]}]}]}]}]}]}],"r":"confirmationDetails"}],"n":50,"r":"showSuccessfulTransaction"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["showErrorTransaction"],"s":"_0"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header response-title v-medium-top v-medium-bottom"},"f":["We apologise."]}," ",{"t":7,"e":"p","a":{"class":"v-normal-bottom"},"f":[{"t":3,"r":"failureMessage"}," Your order has not been accepted."]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider expanded padded"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header v-medium-bottom v-normal-top section-title"},"f":["What can you do next?"]}," ",{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header subsection v-normal-top v-small-bottom"},"f":["Try Again"]}," ",{"t":7,"e":"p","f":["You may wish to try making the purchase again with a different credit card. If your credit card is not enabled with 3D Secure payment, you may not be able to make the purchase successfully."]}]}]}]}]}]}]},{"t":4,"n":50,"x":{"r":["showErrorTransaction"],"s":"!(_0)"},"f":[" ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-4 small-12"},"f":[" ",{"t":7,"e":"div","a":{"class":"v-normal-top show-for-small-only"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"mobileImage.src"}]}}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top show-for-medium-up"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"desktopImage.src"}]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-8 small-12"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","f":[{"t":2,"r":"title"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header v-medium-bottom","level":"2"},"f":[{"t":2,"r":"key"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"val"}]}]}]}],"r":"metadata"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-2"},"f":[{"t":7,"e":"ux-header","a":{"class":"subsection-header v-medium-bottom","level":"2"},"f":["Quantity"]}," ",{"t":7,"e":"div","a":{"class":"value"},"f":[{"t":7,"e":"ux-select","a":{"id":"quantityDropdown","class":"medium left","onChangeEvent":"onQuantityChange","options":[{"t":2,"r":"quantityOptions"}],"showSelectedValue":"true","selected_value":[{"t":2,"r":"selectedQty"}]},"f":[]}]}]}]}],"n":50,"r":"quantityOptions"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-large-top v-medium-bottom"},"f":[{"t":2,"r":"footnote"}]}]}],"n":50,"r":"footnote"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-bottom "},"f":[{"t":7,"e":"ux-anchor","a":{"type":"anchor","class":"v-normal-top v-normal-bottom bannerLink","href":[{"t":2,"r":"linkUrl"}],"target":[{"t":4,"f":["_blank"],"n":50,"r":"openNewTab"},{"t":4,"n":51,"f":["_self"],"r":"openNewTab"}]},"f":[{"t":2,"r":"linkText"}]}]}]}],"r":"footerLinks"}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-bottom p-normal-bottom"},"f":[{"t":7,"e":"ux-anchor","a":{"id":[{"t":4,"f":[{"t":2,"r":"ctaUrl"}],"n":50,"r":"enableBuyflow"}],"type":[{"t":4,"f":["modal"],"n":50,"r":"enableBuyflow"},{"t":4,"n":51,"f":["anchor"],"r":"enableBuyflow"}],"pmodalData":[{"t":2,"r":"pmodalData"}],"class":["v-normal-top v-normal-bottom ",{"t":4,"f":["ux-button button round light"],"n":50,"r":"showCtaAsButton"}],"href":[{"t":4,"f":[{"t":2,"r":"ctaUrl"}],"n":50,"x":{"r":["enableBuyflow"],"s":"!_0"}}],"ontap":[{"t":2,"r":"ontap"}]},"f":[{"t":2,"r":"ctaLabel"}]}]}],"n":50,"x":{"r":["hideButton"],"s":"!_0"}}]}]}]}]}],"r":"showSuccessfulTransaction"}]}]};
this["ux-singtel-product-list"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-product-list"},"f":[{"t":7,"e":"ux-row","a":{"class":["list-",{"t":2,"r":"listAlignment"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":7,"e":"ux-singtel-product","a":{"datamodel":[{"t":3,"r":"."}],"fromLabel":[{"t":2,"r":"fromLabel"}],"subscriptionLabel":[{"t":2,"r":"subscriptionLabel"}],"buttonLabel":[{"t":2,"r":"ctaLabel"}],"ribbonColor":[{"t":2,"r":"ribbonColor"}],"ribbonTheme":[{"t":2,"r":"ribbonTheme"}],"ribbonPosition":[{"t":2,"r":"ribbonPosition"}],"CTAasButton":[{"t":2,"r":"CTAasButton"}]}}]}],"n":52,"r":"singtelProductList"}]}]}]};
this["ux-singtel-product"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-singtel-product ribbon-",{"t":2,"r":"ribbonPosition"}," ",{"t":4,"f":["has-ribbon"],"n":50,"r":"ribbonMarketingText"}," ",{"t":4,"f":["has-link-as-button"],"n":50,"r":"showCTAAsButton"}]},"f":[{"t":7,"e":"div","a":{"class":"panel text-center v-medium-bottom p-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["ribbon-label text-center ",{"t":2,"r":"ribbonTheme"}],"style":["background-color: ",{"t":2,"r":"ribbonColor"},";"]},"f":[{"t":2,"r":"ribbonMarketingText"}]}],"n":50,"x":{"r":["ribbonMarketingText","ribbonPosition"],"s":"_0&&_1==\"top\""}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-image","a":{"class":"v-none-bottom"}}],"n":50,"r":"openModal"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"ctaUrl"}]},"f":[{"t":7,"e":"ux-image","a":{"class":"v-none-bottom"}}]}],"r":"openModal"}],"n":50,"x":{"r":["desktop.src","mobile.src"],"s":"_0||_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"online-exclusive-wrapper spacer-top"},"f":[{"t":7,"e":"div","a":{"class":"online-exclusive"},"f":[{"t":2,"r":"ribbonMarketingText"}]}]}],"n":50,"x":{"r":["ribbonMarketingText","ribbonPosition"],"s":"_0&&_1!==\"top\""}}," ",{"t":7,"e":"div","a":{"class":"section-header v-large-top v-medium-bottom"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"panel-text v-large-bottom v-normal-left v-normal-right"},"f":[{"t":2,"r":"text"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"badges-text"},"f":[{"t":2,"r":"fromInfo"}]}],"n":50,"r":"fromInfo"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"badges-text"},"f":[{"t":2,"r":"fromLabel"}]}],"n":50,"r":"fromLabel"}," ",{"t":7,"e":"div","a":{"class":"product-price clearfix"},"f":[{"t":7,"e":"div","a":{"class":"main-dollar v-small-top"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"usualPrice"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"showdollars\")"}}],"r":"usualPrice"}]}," ",{"t":7,"e":"div","a":{"class":["strike-through-dollar ",{"t":4,"f":["in-regular-price"],"n":50,"x":{"r":["usualPrice"],"s":"!_0"}}]},"f":[{"t":4,"f":[{"t":3,"r":"usualPrice"}],"n":50,"r":"usualPrice"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"showcents\")"}}],"r":"usualPrice"}]}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":4,"f":[{"t":2,"r":"billingCycleLabel"}],"n":50,"r":"useProductCatalogBillingCycleLabel"},{"t":4,"n":51,"f":[{"t":2,"r":"subscriptionLabel"}],"r":"useProductCatalogBillingCycleLabel"}]}],"n":50,"x":{"r":["hidePrice"],"s":"!_0"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"product-link v-medium-bottom p-normal-bottom"},"f":[{"t":7,"e":"ux-anchor","a":{"id":[{"t":4,"f":[{"t":2,"r":"ctaUrl"}],"n":50,"r":"openModal"}],"type":[{"t":4,"f":["modal"],"n":50,"r":"openModal"},{"t":4,"n":51,"f":["anchor"],"r":"openModal"}],"pmodalData":"{\"width\":\"700\", \"class\":\"no-padding\",\"height\":\"800\",\"heightPercentage\":\"70\",\"hideTitle\":\"true\",\"containerClass\":\"modal-signup\"}","class":["v-normal-top v-normal-bottom bannerLink ",{"t":4,"f":["ux-button button round light"],"n":50,"r":"showCTAAsButton"}],"href":[{"t":4,"f":[{"t":2,"r":"ctaUrl"}],"n":50,"x":{"r":["openModal"],"s":"!_0"}}],"ontap":[{"t":2,"r":"ontap"}]},"f":[{"t":2,"r":"ctaLabel"}]}]}],"n":50,"x":{"r":["hideButton"],"s":"!_0"}}]}]}]};
this["ux-singtel-store-appointment"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-singtel-store-appointment ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"div","a":{"class":"qNomyIframeContainer"}}]}]};
this["ux-singtel-support-share"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-support-share"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["small-12"],"n":50,"x":{"r":["headerAlignment"],"s":"_0===\"top\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["headerAlignment"],"s":"(_0===\"center\")"},"f":["small-12 center"]},{"t":4,"n":50,"x":{"r":["headerAlignment"],"s":"(!((_0===\"center\")))&&((_0===\"hide\"))"},"f":["hide"]},{"t":4,"n":50,"x":{"r":["headerAlignment"],"s":"(!((_0===\"center\")))&&(!((_0===\"hide\")))"},"f":["small-4"]}],"x":{"r":["headerAlignment"],"s":"_0===\"top\""}}]},"f":[{"t":7,"e":"div","a":{"class":"socialShareDescription input-label-bold"},"f":[{"t":2,"r":"caption"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["small-12"],"n":50,"x":{"r":["headerAlignment"],"s":"_0===\"top\""}},{"t":4,"n":51,"f":["small-8"],"x":{"r":["headerAlignment"],"s":"_0===\"top\""}}]},"f":[{"t":7,"e":"div","a":{"class":"socialShareIcons"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"mailTo pointer","title":[{"t":2,"r":"emDomainName"}]},"v":{"tap":"mailTofunction","mouseover":{"m":"set","a":{"r":[],"s":"[\"mailhover\",true]"}},"mouseout":{"m":"set","a":{"r":[],"s":"[\"mailhover\",false]"}}},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":4,"f":["mail-hover"],"n":50,"r":"mailhover"},{"t":4,"n":51,"f":["mail-active"],"r":"mailhover"}]}}]}],"n":50,"r":"emDomainName"}," ",{"t":4,"f":[{"t":7,"e":"ux-modal","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"emailTitle"}]}," ",{"t":7,"e":"form","a":{"action":[{"t":2,"r":"callToAction"}],"method":"POST","name":[{"t":2,"r":"formName"}]},"f":[{"t":7,"e":"div","a":{"style":["display:",{"t":2,"r":"display"}]},"f":[{"t":7,"e":"ux-header","a":{"level":"6"},"f":[{"t":3,"r":"emailSubtitle"}]}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"resEmailCaption"}]},"f":[{"t":2,"r":"resEmailCaption"}]}," ",{"t":7,"e":"ux-input-box","a":{"class":[{"t":2,"r":"validationClass"}," m-medium"],"type":"text","placeholder":[{"t":2,"r":"placeholderresEmailCaption"}],"name":"webform_multipleEmail","value":[{"t":2,"r":"multipleEmail"}],"title":[{"t":2,"r":"multipleTitle"}]},"v":{"enter":"inputHandler"},"f":[]}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"senderEmailCaption"}]},"f":[{"t":2,"r":"senderEmailCaption"}]}," ",{"t":7,"e":"ux-input-box","a":{"type":"text","class":[{"t":2,"r":"validationClass"}," m-medium"],"placeholder":[{"t":2,"r":"placeholdersenderEmailCaption"}],"name":"webform_userEmail","value":[{"t":2,"r":"userEmail"}]},"v":{"enter":"inputHandler"},"f":[]}," ",{"t":7,"e":"label","a":{"for":[{"t":2,"r":"commentsLabel"}]},"f":[{"t":2,"r":"commentsLabel"}]}," ",{"t":7,"e":"textarea","a":{"class":[{"t":2,"r":"validationClass"}," m-medium"],"required":[{"t":2,"r":"required"}],"value":[{"t":2,"r":"textareaValue"}],"placeholder":[{"t":2,"r":"placeholdertextarea"}],"name":"webform_textareaValue"}}," ",{"t":7,"e":"button","a":{"class":"right","type":"button"},"v":{"tap":"shareUsEmail"},"m":[{"t":2,"r":"disable"}],"f":[{"t":2,"r":"sendButtonLabel"}]}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"formSubmissionMsg"}]}," ",{"t":7,"e":"ux-input-box","a":{"type":"hidden","value":[{"t":2,"r":"currentpageUrl"}],"name":"webform_currentpageurl"}}]}]}],"n":53,"r":"modal"}," ",{"t":4,"f":[{"t":7,"e":"a","a":{"class":"facebookShare","href":"#","onclick":["window.open('http://www.facebook.com/dialog/feed?app_id=",{"t":2,"r":"shareIds.facebookId"},"&link=",{"t":2,"x":{"r":["currentPage_url"],"s":"encodeURIComponent(_0)"}},"','mywindow','width=400,height=500, left=300,top=100')"],"title":[{"t":2,"r":"fbDomainName"}]},"v":{"tap":"facebookLink","mouseover":{"m":"set","a":{"r":[],"s":"[\"facebookhover\",true]"}},"mouseout":{"m":"set","a":{"r":[],"s":"[\"facebookhover\",false]"}}},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":4,"f":["facebook-hover"],"n":50,"r":"facebookhover"},{"t":4,"n":51,"f":["facebook-active"],"r":"facebookhover"}]}}]}," ",{"t":7,"e":"ux-input-box","a":{"type":"hidden","value":[{"t":2,"r":"shareIds.facebookId"}]}}],"n":50,"r":"fbDomainName"}," ",{"t":4,"f":[{"t":7,"e":"a","a":{"class":"twitter-share-button","href":"#","onclick":["window.open('https://twitter.com/intent/tweet?text=",{"t":2,"r":"sharingUrl"},"','mywindow','width=400,height=500, left=300,top=100');"],"title":[{"t":2,"r":"twDomainName"}]},"v":{"tap":"twitterShare","mouseover":{"m":"set","a":{"r":[],"s":"[\"twitterhover\",true]"}},"mouseout":{"m":"set","a":{"r":[],"s":"[\"twitterhover\",false]"}}},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":4,"f":["twitter-hover"],"n":50,"r":"twitterhover"},{"t":4,"n":51,"f":["twitter-active"],"r":"twitterhover"}]}}]}],"n":50,"r":"twDomainName"}," ",{"t":4,"f":[{"t":7,"e":"a","a":{"class":"linkedIn-button","href":"#","onclick":["window.open('http://www.linkedin.com/shareArticle?mini=true&url=",{"t":2,"r":"linkedInUrl"},"&title=[",{"t":2,"r":"liDomainName"},"]&source=[",{"t":2,"x":{"r":["linkedinId","SOURCE","DOMAIN"],"s":"_0||_1/_2"}},"]','mywindow','width=400,height=500, left=300,top=100');"],"title":[{"t":2,"r":"liDomainName"}]},"v":{"tap":"linkedInshare","mouseover":{"m":"set","a":{"r":[],"s":"[\"linkedinhover\",true]"}},"mouseout":{"m":"set","a":{"r":[],"s":"[\"linkedinhover\",false]"}}},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":4,"f":["linkedin-hover"],"n":50,"r":"linkedinhover"},{"t":4,"n":51,"f":["linkedin-active"],"r":"linkedinhover"}]}}]}],"n":50,"r":"liDomainName"}," ",{"t":4,"f":[{"t":7,"e":"a","a":{"class":"gpDomainIcon_button","href":"#","onclick":["window.open('https://plus.google.com/share?url=",{"t":2,"r":"googleUrl"},"','mywindow','width=400,height=500, left=300,top=100');"],"title":[{"t":2,"r":"gpDomainIconName"}]},"v":{"tap":"googleShare","mouseover":{"m":"set","a":{"r":[],"s":"[\"googlehover\",true]"}},"mouseout":{"m":"set","a":{"r":[],"s":"[\"googlehover\",false]"}}},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":4,"f":["google-plus-hover"],"n":50,"r":"googlehover"},{"t":4,"n":51,"f":["google-plus-active"],"r":"googlehover"}]}}]}],"n":50,"r":"gpDomainIconName"}]}]}]}]}]};
this["ux-singtel-tv-go"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-singtel-tv-go"},"f":[{"t":7,"e":"div","a":{"class":"panel text-center"},"f":[{"t":7,"e":"ux-image"}," ",{"t":7,"e":"div","a":{"class":"product-title v-large-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"panel-text v-large-bottom"},"f":[{"t":2,"r":"text"}]}," ",{"t":7,"e":"div","a":{"class":"main-dollar v-small-top"},"f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"subscriptionLabel"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"ux-button","a":{"class":"margin-zero round light small-only-expand","onclick":"selectplan","text":[{"t":2,"r":"buttonLabel"}]}}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"hr"}],"n":50,"r":"planOffer"}," ",{"t":7,"e":"ux-col","a":{"class":"medium-12 product-plan-offers"},"f":[{"t":3,"r":"planOffer"}]}]}]}]}]};
this["ux-snackbar"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"ux-snackbar p-medium-bottom p-medium-top p-normal-left p-normal-right","id":"snackBar"},"f":[{"t":7,"e":"span","a":{"class":"snackbar-message "},"f":[{"t":2,"r":"message"}]}," ",{"t":7,"e":"span","a":{"class":"v-medium-left"},"v":{"tap":"closeSnackbar"},"f":["Close"]}]}],"n":50,"r":"showSnackbar"}]};
this["ux-social-share"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-social-share"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"socialShare"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"socialShareContent"},"f":[{"t":2,"r":"socialShareDescription"}]}],"n":50,"r":"links"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"href"}],"target":[{"t":2,"r":"target"}],"title":[{"t":2,"r":"title"}]},"f":[{"t":7,"e":"ux-image","a":{"datamodel":[{"t":2,"r":"datamodel"}]}}]}],"r":"links"}]}]}]}]}]};
this["ux-spinner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-spinner ",{"t":2,"r":"class"}]},"m":[{"t":4,"f":["id=\"",{"t":2,"r":"id"},"\""],"n":50,"r":"id"}]}]};
this["ux-spring-nav"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-spring-nav"},"f":[{"t":4,"f":[{"t":7,"e":"ux-top-bar","a":{"navitems":[{"t":2,"r":"navitems"}]},"f":[{"t":7,"e":"ul","a":{"class":"uxSpringNav__menu"},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":"uxSpringNav__menuItem"},"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"href"}]},"f":[{"t":2,"r":"label"}]}]}],"n":52,"r":"navitems"}]}]}],"n":50,"r":"navitems"}]}]};
this["ux-stepper-panel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-stepper-panel"},"f":[{"t":7,"e":"div","a":{"class":["top-bottom-padding ",{"t":2,"r":"backgroundTheme"}],"style":[{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"},";"],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"stepper-header"},"f":[{"t":4,"f":[{"t":7,"e":"ux-header","a":{"class":["section-header ",{"t":2,"r":"backgroundTheme"}]},"f":[{"t":2,"r":"headerText"}]}],"n":50,"x":{"r":["headerText"],"s":"_0!==\"\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"section-details"},"f":[{"t":2,"r":"subHeaderText"}]}],"n":50,"r":"subHeaderText"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":["center-column ",{"t":4,"f":["noHeaderText"],"n":50,"x":{"r":["headerText","subHeaderText"],"s":"_0===\"\"&&_1===null"}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-3 medium-3 small-12 fixed-column-width"},"f":[{"t":7,"e":"ux-icon-banner","a":{"datamodel":[{"t":3,"r":"."}]}}]}],"r":"stepperItems"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"stepper-footer section-details"},"f":[{"t":3,"r":"footerText"}]}]}],"n":50,"r":"footerText"}]}]}]};
this["ux-stock-availability"] = {"v":3,"t":[{"t":7,"e":"div","o":"loadMask","f":[{"t":7,"e":"div","a":{"class":"ux-stock-availability"},"f":[{"t":7,"e":"div","a":{"class":[{"t":2,"r":"componentAlignmentStyle"}," stock"]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":["hero-text ",{"t":2,"r":"stockHeaderStyle"}]},"f":[{"t":2,"r":"stockHeader"}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-large-top-mobile"},"f":[{"t":2,"r":"stockDescription"}]}," ",{"t":7,"e":"div","a":{"class":"hide-for-small-only v-normal-top"},"f":[{"t":2,"r":"stockLastUpdatedLabel"}," ",{"t":2,"r":"displayDate"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only v-large-space-top"},"f":[{"t":7,"e":"div","f":[{"t":2,"r":"stockLastUpdatedLabel"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"displayDate"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"hide-for-small-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top medium-offset-4 medium-4 v-large-bottom"},"f":[{"t":7,"e":"ux-select","a":{"customClass":"text-left","selected_value":[{"t":2,"r":"selectedModel"}],"showSelectedValue":"true","options":[{"t":2,"r":"modelsList"}],"label_value":[{"t":2,"r":"stockFilterDropdwonLabel"}],"onChangeEvent":"onModelChange"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"section-details clearfix hide-for-small-only"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":["small-",{"t":2,"x":{"r":["capacityList.length"],"s":"12-(2*_0)"}}]},"f":[{"t":7,"e":"div","a":{"class":"subsection-header text-left"},"f":[{"t":2,"r":"selectedModel"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-2"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header text-center"},"f":[{"t":2,"r":"title"}]}]}],"n":52,"r":"capacityList"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":["small-",{"t":2,"x":{"r":["capacityList.length"],"s":"12-(2*_0)"}}]},"f":[{"t":7,"e":"div","a":{"class":"color-value"},"f":[{"t":7,"e":"div","a":{"class":"left color-icon","style":["background-color:",{"t":2,"r":"hexCode"},";"]}}," ",{"t":7,"e":"div","a":{"class":"left color-text"},"f":[{"t":2,"r":"color"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-2"},"f":[{"t":7,"e":"div","a":{"class":"stock-status text-center v-medium-top"},"f":[{"t":4,"f":["-"],"n":50,"x":{"r":["stockInfo"],"s":"typeof _0===\"undefined\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["stockInfo","stockInfo.length"],"s":"_0&&_1>0"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":["toggleThresholdModal:",{"t":2,"r":"sku"}],"stockInfo":[{"t":2,"r":"."}]},"f":[{"t":2,"r":"stockInfo.length"}," ",{"t":4,"f":["location"],"n":50,"x":{"r":["stockInfo.length"],"s":"_0===1"}},{"t":4,"n":51,"f":["locations"],"x":{"r":["stockInfo.length"],"s":"_0===1"}}]}]},{"t":4,"n":50,"x":{"r":["stockInfo","stockInfo.length"],"s":"!(_0&&_1>0)"},"f":[" Not Available"]}],"x":{"r":["stockInfo"],"s":"typeof _0===\"undefined\""}}]}]}],"r":"phoneStockHeaders"}]}],"r":"finalStockHeaders"}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only v-large-space-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-small-space-bottom"},"f":[{"t":7,"e":"ux-select","a":{"customClass":"text-left","selected_value":[{"t":2,"r":"selectedModel"}],"showSelectedValue":"true","options":[{"t":2,"r":"modelsList"}],"onChangeEvent":"onModelChange"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"section-details clearfix show-for-small-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-large-space-bottom"},"f":[{"t":7,"e":"ux-select","a":{"customClass":"text-left","selected_value":[{"t":2,"r":"selectedCapacty"}],"showSelectedValue":"true","options":[{"t":2,"r":"capacityList"}],"onChangeEvent":"onCapacityChange"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-7"},"f":[{"t":7,"e":"div","a":{"class":"color-value"},"f":[{"t":7,"e":"div","a":{"class":"left color-icon","style":["background-color:",{"t":2,"r":"hexCode"},";"]}}," ",{"t":7,"e":"div","a":{"class":"left color-text"},"f":[{"t":2,"r":"color"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":["toggleThresholdModal:",{"t":2,"r":"sku"}],"stockInfo":[{"t":2,"r":"."}]},"f":[{"t":7,"e":"ux-col","a":{"class":"small-5 right"},"f":[{"t":7,"e":"div","a":{"class":"stock-status text-right"},"f":[{"t":2,"r":"stockInfo.length"}," ",{"t":4,"f":["location"],"n":50,"x":{"r":["stockInfo.length"],"s":"_0===1"}},{"t":4,"n":51,"f":["locations"],"x":{"r":["stockInfo.length"],"s":"_0===1"}}]}]}]}],"n":50,"x":{"r":["stockInfo","stockInfo.length"],"s":"_0&&_1>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"small-5 right"},"f":[{"t":7,"e":"div","a":{"class":"stock-status text-right"},"f":["Not Available"]}]}],"x":{"r":["stockInfo","stockInfo.length"],"s":"_0&&_1>0"}}]}],"r":"mobilePhoneStockHeaders"}]}],"n":50,"r":"startDisplay"}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme threshold-modal","modalId":"thresholdModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-11"},"f":[{"t":7,"e":"ux-header","a":{"level":"3"},"f":[{"t":2,"r":"description"}]}]}],"n":53,"r":"stockDetails"}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top v-small-space-top"},"f":["Found in ",{"t":2,"r":"stockDetails.stockInfo.length"}," ",{"t":4,"f":["location"],"n":50,"x":{"r":["stockDetails.stockInfo.length"],"s":"_0===1"}},{"t":4,"n":51,"f":["locations"],"x":{"r":["stockDetails.stockInfo.length"],"s":"_0===1"}}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","a":{"class":"subsection-header"},"f":[{"t":2,"r":"stockLastUpdatedLabel"}]}," ",{"t":7,"e":"span","f":[{"t":2,"r":"displayDate"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top v-normal-bottom v-space-bottom v-large-space-top v-small-space-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8 small-6"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"shop.name"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4 small-6"},"f":[{"t":7,"e":"div","a":{"class":"stock-Indicator right","style":["background-color:",{"t":4,"f":[{"t":2,"r":"availableBtnColor"}," "],"n":50,"x":{"r":["stock_status"],"s":"_0===\"Available\""}},{"t":4,"n":51,"f":[{"t":2,"r":"sellingFastBtnColor"}," "],"x":{"r":["stock_status"],"s":"_0===\"Available\""}},";"]},"f":[{"t":2,"r":"stock_status"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom v-small-space-bottom collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"eshop.shopDesc"}]}],"n":50,"r":"eshop"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["building","street"],"s":"_0&&_1"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"building"}]}],"n":50,"r":"building"}," ",{"t":7,"e":"div","a":{"class":"address-line2"},"f":[{"t":4,"f":[{"t":2,"r":"blockOrHouseNum"}," "],"n":50,"r":"blockOrHouseNum"}," ",{"t":4,"f":[{"t":2,"r":"street"}],"n":50,"r":"street"}]}," ",{"t":7,"e":"div","a":{"class":"address-line3"},"f":[{"t":2,"r":"country"}," ",{"t":4,"f":[" ",{"t":2,"r":"postalCode"}],"n":50,"r":"postalCode"}]}]}],"r":"eshop"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":["collapse v-large-bottom ",{"t":4,"f":["v-small-space-bottom"],"n":50,"r":"buyOnline"},{"t":4,"n":51,"f":["v-large-space-bottom"],"r":"buyOnline"}]},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address-line1"},"f":[{"t":2,"r":"eshop.shopTiming"}]}],"n":50,"r":"eshop"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"div","f":["Sat - Sun: ",{"t":2,"r":"weekends"}]}],"n":50,"r":"weekends"}," ",{"t":4,"f":[{"t":7,"e":"div","f":["Mon - Fri: ",{"t":2,"r":"weekdays"}]}],"n":50,"r":"weekdays"}],"r":"eshop"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-large-space-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"eshop.shopLinkUrl"}],"class":"left"},"f":[{"t":2,"r":"eshop.shopLinkText"}]}]}]}],"n":50,"r":"eshop"}],"n":53,"r":"shop"}," ",{"t":7,"e":"div","a":{"class":[{"t":4,"f":["panel-divider"],"n":50,"x":{"r":["i","stockDetails.stockInfo.length"],"s":"_0<_1-1"}}]}}],"n":52,"i":"i","r":"stockDetails.stockInfo"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"genericMessageDisplay"}]},"f":[]}]}]}],"n":50,"r":"genericMessageDisplay"}]}]};
this["ux-sub-addon"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-sub-addon"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom bordered-bottom-small"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header"},"f":[{"t":2,"r":"initData.addonTabs.0.title"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom bordered-bottom-small"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"catalogItemName"}]}]}],"n":51,"r":"tvContentPackFlag"}],"n":52,"i":"i","r":"productFacade.addOnsMapByAsignedProductId"}," ",{"t":7,"e":"div","a":{"class":"v-normal-top small-only-text-center"},"f":[{"t":7,"e":"ux-anchor","a":{"manageAddonUrl":[{"t":2,"r":"initData.manageAddonUrl"}],"product":[{"t":2,"r":"product"}],"permission":[{"t":2,"r":"permission"}],"account":[{"t":2,"r":"account"}],"subscription":[{"t":2,"r":"subscription"}],"ontap":"manageAddons"},"f":["Manage Add-ons"]}]}]}]};
this["ux-summary-accordion"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-summary-accordion"},"f":[{"t":7,"e":"div","a":{"class":"singtel-accordion hide-for-small-only"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-top-bar-singtel","a":{"datamodel":[{"t":3,"r":"header"}]}}]}],"n":50,"x":{"r":["idx"],"s":"_0==0"}}," ",{"t":7,"e":"ux-accordion","a":{"data":[{"t":3,"r":"."}],"onePassDetails":[{"t":2,"r":"onePassDetails"}],"spsIds":[{"t":2,"r":"spsIds"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"showChange":[{"t":2,"r":"showChange"}],"idx":[{"t":2,"r":"idx"}],"isActive":[{"t":4,"f":["true"],"n":50,"x":{"r":["~/order.mobile.length","~/order.bundle.length"],"s":"(_0||0)+(_1||0)>=1"}}],"initDataFHB":[{"t":2,"r":"initDataFHB"}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"class":"no-bottom-margin","active":[{"t":4,"f":["true"],"n":50,"r":"isActive"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"left-section"},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-summarytitle-row","a":{"icon":"broadband-line","datamodel":[{"t":3,"r":"data"}],"shoppingCartPanel":"true"}}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"right-section show-for-small-only"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"itemRemoveState"}],"ontap":"removeMultiCartItem","item":[{"t":3,"r":"."}]},"f":["Remove"]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item "},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-summarydata-row","a":{"onePassDetails":[{"t":2,"r":"onePassDetails"}],"type":[{"t":2,"r":"q"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"showChange":[{"t":2,"r":"showChange"}],"spsIds":[{"t":2,"r":"spsIds"}],"datamodel":[{"t":3,"r":"data"}]}}],"n":50,"x":{"r":["q"],"s":"_0===\"broadBandPlanDetails\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["q"],"s":"_0===\"premiumAddons\""},"f":[{"t":7,"e":"ux-summarydata-row","a":{"onePassDetails":[{"t":2,"r":"onePassDetails"}],"type":[{"t":2,"r":"q"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"showChange":[{"t":2,"r":"showChange"}],"datamodel":[{"t":3,"r":"data"}],"spsIds":[{"t":2,"r":"spsIds"}],"premiumHeader":[{"t":2,"r":"initDataFHB.premiumHeader"}]}}]}],"x":{"r":["q"],"s":"_0===\"broadBandPlanDetails\""}}],"i":"q","r":"data"}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"i"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"showChange":[{"t":2,"r":"showChange"}],"datamodel":[{"t":3,"r":"."}],"spsIds":[{"t":2,"r":"spsIds"}]}}],"n":52,"r":"data.serviceDetails"}],"n":50,"x":{"r":["i"],"s":"_0===\"serviceDetails\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["i"],"s":"_0!==\"addons\"&&_0!==\"premiumAddons\"&&_0!==\"broadBandPlanDetails\"&&_0!==\"promotions\""},"f":[{"t":7,"e":"ux-summarydata-row","a":{"onePassDetails":[{"t":2,"r":"onePassDetails"}],"type":[{"t":2,"r":"i"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"showChange":[{"t":2,"r":"showChange"}],"spsIds":[{"t":2,"r":"spsIds"}],"datamodel":[{"t":3,"r":"data"}]}}]}],"x":{"r":["i"],"s":"_0===\"serviceDetails\""}}],"i":"i","r":"data"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-summarydata-row","a":{"onePassDetails":[{"t":2,"r":"onePassDetails"}],"type":[{"t":2,"r":"k"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"showChange":[{"t":2,"r":"showChange"}],"spsIds":[{"t":2,"r":"spsIds"}],"datamodel":[{"t":3,"r":"data"}]}}],"n":50,"x":{"r":["k"],"s":"_0===\"addons\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["k"],"s":"_0===\"promotions\""},"f":[{"t":7,"e":"ux-summarydata-row","a":{"onePassDetails":[{"t":2,"r":"onePassDetails"}],"type":[{"t":2,"r":"k"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"showChange":[{"t":2,"r":"showChange"}],"spsIds":[{"t":2,"r":"spsIds"}],"datamodel":[{"t":3,"r":"data"}]}}]}],"x":{"r":["k"],"s":"_0===\"addons\""}}],"i":"k","r":"data"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"tradein v-large"},"f":[{"t":7,"e":"ux-add-vouchers","a":{"lob":"bundle","voucher":[{"t":3,"r":"voucherTopic"}],"voucherInfo":[{"t":3,"r":"initData.voucherInfo"}],"preSelectedVouchers":[{"t":3,"r":"vouchers"}],"shoppingCartPanel":[{"t":2,"r":"shoppingCartPanel"}],"idx":[{"t":2,"r":"idx"}],"hideVouchersModal":"true","enableRetrieveVoucher":[{"t":2,"r":"enableRetrieveVoucher"}],"noNewVoucher":[{"t":2,"r":"noNewVoucher"}]},"f":[]}]}],"n":50,"x":{"r":["isTablet","shoppingCartPanel"],"s":"!_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["vouchers","vouchers.length"],"s":"_0&&_1>0"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"tradein v-large"},"f":[{"t":7,"e":"ux-add-vouchers","a":{"voucher":[{"t":3,"r":"voucherTopic"}],"voucherInfo":[{"t":3,"r":"initData.voucherInfo"}],"preSelectedVouchers":[{"t":3,"r":"vouchers"}],"shoppingCartPanel":[{"t":2,"r":"shoppingCartPanel"}],"idx":[{"t":2,"r":"idx"}],"lob":"bundle","hideVouchersModal":"true","enableRetrieveVoucher":[{"t":2,"r":"enableRetrieveVoucher"}],"noNewVoucher":[{"t":2,"r":"noNewVoucher"}]},"f":[]}]}]}],"x":{"r":["isTablet","shoppingCartPanel"],"s":"!_0&&_1"}}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"subtotal-row v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-4"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom"},"f":["Subtotal (Inclusive of GST)"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 margin-top-10"},"f":[{"t":7,"e":"div","a":{"class":"section-header right one-time-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-2 small-2 margin-top-10"},"f":[{"t":7,"e":"div","a":{"class":"section-header right checkout-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}]}],"i":"idx","r":"order.bundle"}],"n":50,"i":"idx","r":"order.bundle"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-top-bar-singtel","a":{"datamodel":[{"t":3,"r":"header"}]}}]}],"n":50,"x":{"r":["idx","order.bundle","order.bundle.length"],"s":"_0==0&&!(_1&&_2>0)"}}," ",{"t":7,"e":"ux-accordion","a":{"data":[{"t":3,"r":"."}],"contractFilter":[{"t":2,"r":"contractFilter"}],"hideContractFilter":[{"t":2,"r":"hideContractFilter"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"showChange":[{"t":2,"r":"showChange"}],"idx":[{"t":2,"r":"idx"}],"isRoiDevice":[{"t":2,"r":"isRoiDevice"}],"spsIds":[{"t":2,"r":"spsIds"}],"isActive":[{"t":4,"f":["true"],"n":50,"x":{"r":["~/order.mobile.length","~/order.bundle.length","~/order.tv.length","~/order.fv.length"],"s":"(_0||0)+(_1||0)+(_2||0)+(_3||0)==1"}}],"isRedMembership":[{"t":4,"f":[{"t":2,"r":"isRedMembership"}],"n":50,"x":{"r":["idx","redMembershipLocator"],"s":"_0===_1"}},{"t":4,"n":51,"f":["false"],"x":{"r":["idx","redMembershipLocator"],"s":"_0===_1"}}],"redMembershipLocator":[{"t":2,"r":"redMembershipLocator"}],"ConfigStrings":[{"t":3,"r":"ConfigStrings"}],"isBackOrder":[{"t":2,"x":{"r":["deviceIdAndPlanId.isBackOrder","isOrderConfirmation","orderConfirmation.isBackOrder"],"s":"_0||(_1&&_2)"}}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"class":"no-bottom-margin","active":[{"t":4,"f":["true"],"n":50,"r":"isActive"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"left-section"},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-summarytitle-row","a":{"class":"v-small-top","icon":[{"t":4,"f":[{"t":2,"r":"ConfigStrings.serviceConfig.RED.icon"}],"n":50,"x":{"r":["idx","redMembershipLocator"],"s":"_0===_1"}},{"t":4,"n":51,"f":["mobile-line"],"x":{"r":["idx","redMembershipLocator"],"s":"_0===_1"}}],"datamodel":[{"t":3,"r":"data"}],"shoppingCartPanel":"true"}}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"i"}],"showChange":[{"t":2,"r":"showChange"}],"contractFilter":[{"t":2,"r":"contractFilter"}],"hideContractFilter":[{"t":2,"r":"hideContractFilter"}],"datamodel":[{"t":3,"r":"data"}],"shoppingCartPanel":[{"t":2,"r":"shoppingCartPanel"}],"isRoiDevice":[{"t":2,"r":"isRoiDevice"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"spsIds":[{"t":2,"r":"spsIds"}]}}],"n":50,"x":{"r":["i"],"s":"_0!==\"tradeIn\"&&_0!==\"vouchers\"&&_0!==\"simRegisteration\"&&_0!==\"simDetails\""}}],"i":"i","r":"data"}]}],"n":50,"r":"data.isFreeMBB"}," ",{"t":4,"f":[{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"k"}],"showChange":[{"t":2,"r":"showChange"}],"contractFilter":[{"t":2,"r":"contractFilter"}],"hideContractFilter":[{"t":2,"r":"hideContractFilter"}],"datamodel":[{"t":3,"r":"data"}],"shoppingCartPanel":[{"t":2,"r":"shoppingCartPanel"}],"isRoiDevice":[{"t":2,"r":"isRoiDevice"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"spsIds":[{"t":2,"r":"spsIds"}],"isRedMembership":[{"t":4,"f":[{"t":2,"r":"isRedMembership"}],"n":50,"x":{"r":["idx","redMembershipLocator"],"s":"_0===_1"}}]}}],"n":50,"x":{"r":["i","isRedMembership","k"],"s":"_0!==\"tradeIn\"&&_0!==\"vouchers\"&&(!_1||_1&&_2===\"addons\")"}}],"i":"k","r":"data"}]}],"n":50,"x":{"r":["data.isFreeMBB"],"s":"!_0"}}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"tradein v-large"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-11"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-small-bottom"},"f":[{"t":2,"r":"tradeindata.headerTitle"}]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":["showTradeinModal:",{"t":2,"r":"idx"}]},"f":[{"t":2,"r":"tradeindata.headerDesc"}]}]}]}],"n":50,"r":"shoppingCartPanel"}],"n":50,"r":"showTradein"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["tradeIn"],"s":"_0"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"tradein v-large"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-8"},"f":[{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header left"},"f":[{"t":2,"r":"tradeindata.headerTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-left left"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":["removeTradein:",{"t":2,"r":"idx"}]},"f":["Remove"]}]}],"n":50,"r":"shoppingCartPanel"}]}," ",{"t":7,"e":"div","a":{"class":"body-text v-small-top"},"f":[{"t":2,"r":"tradeIn.tradeInName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2"},"f":[{"t":7,"e":"div","a":{"class":"right checkout-price v-normal-top"},"f":[{"t":2,"x":{"r":["RactiveHelpers","tradeIn.checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}]}],"r":"showTradein"}],"n":50,"x":{"r":["isTablet","order.checkoutPrice.finalAmountIncludingTax","tradeIn"],"s":"!_0&&(_1>0||_2)"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"tradein v-large"},"f":[{"t":7,"e":"ux-add-vouchers","a":{"voucher":[{"t":3,"r":"voucherTopic"}],"voucherInfo":[{"t":3,"r":"initData.voucherInfo"}],"preSelectedVouchers":[{"t":3,"r":"vouchers"}],"shoppingCartPanel":[{"t":2,"r":"shoppingCartPanel"}],"idx":[{"t":2,"r":"idx"}],"hideVouchersModal":"true","enableRetrieveVoucher":[{"t":2,"r":"enableRetrieveVoucher"}],"noNewVoucher":[{"t":2,"r":"noNewVoucher"}]},"f":[]}]}],"n":50,"r":"shoppingCartPanel"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["vouchers","vouchers.length"],"s":"_0&&_1>0"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"tradein v-large"},"f":[{"t":7,"e":"ux-add-vouchers","a":{"voucher":[{"t":3,"r":"voucherTopic"}],"voucherInfo":[{"t":3,"r":"initData.voucherInfo"}],"preSelectedVouchers":[{"t":3,"r":"vouchers"}],"shoppingCartPanel":[{"t":2,"r":"shoppingCartPanel"}],"idx":[{"t":2,"r":"idx"}],"hideVouchersModal":"true","enableRetrieveVoucher":[{"t":2,"r":"enableRetrieveVoucher"}],"noNewVoucher":[{"t":2,"r":"noNewVoucher"}]},"f":[]}]}]}],"r":"shoppingCartPanel"}],"n":50,"x":{"r":["isTablet","deviceDetails","deviceDetails.length","vouchers","vouchers.length","order.checkoutPrice.finalAmountIncludingTax"],"s":"!_0&&(_1&&_2>=1&&((_3&&_4>0)||(_5>0)))"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"div","a":{"class":"error-margin-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"important-information-details-list"},"f":[{"t":7,"e":"div","a":{"class":"red medium-offset-1"},"f":[{"t":7,"e":"ux-icon","a":{"class":"warning","type":"cross","size":"xs"}}," ",{"t":7,"e":"span","a":{"class":"v-medim-left"},"f":[{"t":2,"r":"name"}," is removed."]}]}]}],"n":52,"r":"removedVouchers"}]}],"n":50,"x":{"r":["removedVouchers","removedVouchers.length"],"s":"_0&&_1>0"}}],"n":50,"x":{"r":["isPPOrder"],"s":"!_0"}}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":4,"f":[{"t":7,"e":"ux-freeGifts-error","a":{"unAvailableFreeGifts":[{"t":3,"r":"unAvailableFreeGifts"}],"status":"error"},"f":[]}],"n":50,"x":{"r":["unAvailableFreeGifts","unAvailableFreeGifts.length"],"s":"_0&&_1>0"}}," ",{"t":7,"e":"ux-row","a":{"class":"subtotal-row v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":["small-offset-1 small-4 ",{"t":4,"f":["medium-8"],"n":50,"r":"isRedMembership"}]},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-normal-bottom"},"f":["Subtotal (Inclusive of GST)"]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 medium-2 margin-top-10"},"f":[{"t":7,"e":"div","a":{"class":"section-header center recurring-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"n":50,"r":"isRedMembership"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 margin-top-10"},"f":[{"t":7,"e":"div","a":{"class":"section-header right one-time-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-2 small-2 margin-top-10"},"f":[{"t":7,"e":"div","a":{"class":"section-header right checkout-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"r":"isRedMembership"}]}]}],"i":"idx","r":"order.mobile"}],"n":50,"r":"order.mobile"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-top-bar-singtel","a":{"datamodel":[{"t":3,"r":"header"}]}}]}],"n":50,"x":{"r":["idx","order.mobile","order.mobile.length"],"s":"_0==0&&!(_1&&_2>0)"}}," ",{"t":7,"e":"ux-accordion","a":{"data":[{"t":3,"r":"."}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"spsIds":[{"t":2,"r":"spsIds"}],"showChange":[{"t":2,"r":"showChange"}],"idx":[{"t":2,"r":"idx"}],"isActive":[{"t":4,"f":["true"],"n":50,"x":{"r":["~/order.mobile.length","~/order.bundle.length","~/order.tv.length","~/order.fv.length"],"s":"(_0||0)+(_1||0)+(_2||0)+(_3||0)==1"}}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"class":"no-bottom-margin","active":[{"t":4,"f":["true"],"n":50,"r":"isActive"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"left-section"},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-summarytitle-row","a":{"icon":"tv-line","datamodel":[{"t":3,"r":"data"}],"shoppingCartPanel":"true"}}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"right-section show-for-small-only"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"itemRemoveState"}],"ontap":"removeMultiCartItem","item":[{"t":3,"r":"."}]},"f":["Remove"]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"i"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"spsIds":[{"t":2,"r":"spsIds"}],"showChange":[{"t":2,"r":"showChange"}],"datamodel":[{"t":3,"r":"."}]}}],"i":"j","r":"data.serviceDetails"}],"n":50,"x":{"r":["i"],"s":"_0===\"serviceDetails\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"i"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"showChange":[{"t":2,"r":"showChange"}],"spsIds":[{"t":2,"r":"spsIds"}],"datamodel":[{"t":3,"r":"data"}]}}],"x":{"r":["i"],"s":"_0===\"serviceDetails\""}}],"i":"i","r":"data"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"subtotal-row v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-4"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom"},"f":["Subtotal (Inclusive of GST)"]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"section-header  right recurring-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"x":{"r":["isOrderConfirmation","isRedMembership"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 margin-top-10"},"f":[{"t":7,"e":"div","a":{"class":"section-header right one-time-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-2 small-2 margin-top-10"},"f":[{"t":7,"e":"div","a":{"class":"section-header  right checkout-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"x":{"r":["isOrderConfirmation","isRedMembership"],"s":"_0&&_1"}}]}]}],"i":"idx","r":"order.tv"}],"n":50,"i":"idx","r":"order.tv"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-accordion","a":{"data":[{"t":3,"r":"."}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"spsIds":[{"t":2,"r":"spsIds"}],"showChange":[{"t":2,"r":"showChange"}],"idx":[{"t":2,"r":"idx"}],"isActive":[{"t":4,"f":["true"],"n":50,"x":{"r":["~/order.mobile.length","~/order.bundle.length","~/order.tv.length","~/order.fv.length"],"s":"(_0||0)+(_1||0)+(_2||0)+(_3||0)==1"}}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"class":"no-bottom-margin","active":[{"t":4,"f":["true"],"n":50,"r":"isActive"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"left-section"},"f":[{"t":7,"e":"ux-anchor","f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-summarytitle-row","a":{"icon":"computer-line","datamodel":[{"t":3,"r":"data"}],"shoppingCartPanel":"true"}}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"right-section show-for-small-only"},"f":[{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"itemRemoveState"}],"ontap":"removeMultiCartItem","item":[{"t":3,"r":"."}]},"f":["Remove"]}]}],"n":50,"x":{"r":["order.tv.length"],"s":"_0===0"}}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"i"}],"aspireBillingOfferIds":[{"t":2,"r":"aspireBillingOfferIds"}],"spsIds":[{"t":2,"r":"spsIds"}],"showChange":[{"t":2,"r":"showChange"}],"datamodel":[{"t":3,"r":"."}]}}],"i":"j","r":"data.serviceDetails"}],"n":50,"x":{"r":["i"],"s":"_0===\"serviceDetails\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"i"}],"showChange":[{"t":2,"r":"showChange"}],"spsIds":[{"t":2,"r":"spsIds"}],"datamodel":[{"t":3,"r":"data"}]}}],"x":{"r":["i"],"s":"_0===\"serviceDetails\""}}],"i":"i","r":"data"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"subtotal-row v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-offset-1 small-4"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom"},"f":["Subtotal (Inclusive of GST)"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 margin-top-10"},"f":[{"t":7,"e":"div","a":{"class":"section-header right one-time-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-offset-2 small-2 margin-top-10"},"f":[{"t":7,"e":"div","a":{"class":"section-header right checkout-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}]}],"i":"idx","r":"order.fv"}],"n":50,"i":"idx","r":"order.fv"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-summary-mobile-view","a":{"class":"shopping-cart-panel","icon":"broadband-line","showChange":[{"t":2,"r":"showChange"}],"enableRetrieveVoucher":[{"t":2,"r":"enableRetrieveVoucher"}],"noNewVoucher":[{"t":2,"r":"noNewVoucher"}],"datamodel":[{"t":3,"r":"."}],"shoppingCartPanel":[{"t":2,"r":"shoppingCartPanel"}]}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"small-collapse medium-uncollapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-offset-1 medium-11 clearfix"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom left"},"f":["Vouchers"]}]}," ",{"t":7,"e":"ux-row","a":{"class":"small-collapse medium-uncollapse"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 medium-offset-1"},"f":[{"t":7,"e":"span","a":{"class":"v-medium-right"},"f":[{"t":2,"r":"name"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 medium-2 margin-top-10"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","Charges.recurringPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"r":"vouchers"}]}]}],"n":50,"x":{"r":["shoppingCartPanel","vouchers","vouchers.length"],"s":"!_0&&_1&&_2>=1"}}]}],"i":"i","r":"order.bundle"}],"n":50,"r":"order.bundle"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","a":{"class":"collapse show-for-mobile-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"subsection-header v-medium"},"f":["In Your Cart"]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"panel-divider expanded"}}]}]}," ",{"t":7,"e":"ux-summary-mobile-view","a":{"class":"shopping-cart-panel","icon":[{"t":4,"f":[{"t":2,"r":"ConfigStrings.serviceConfig.RED.icon"}],"n":50,"x":{"r":["idx","redMembershipLocator"],"s":"_0===_1"}},{"t":4,"n":51,"f":["mobile-line"],"x":{"r":["idx","redMembershipLocator"],"s":"_0===_1"}}],"showChange":[{"t":2,"r":"showChange"}],"datamodel":[{"t":3,"r":"."}],"isIppPlan":[{"t":2,"r":"isIppPlan"}],"shoppingCartPanel":[{"t":2,"r":"shoppingCartPanel"}],"idx":[{"t":2,"r":"idx"}],"isRoiDevice":[{"t":2,"r":"isRoiDevice"}],"enableRetrieveVoucher":[{"t":2,"r":"enableRetrieveVoucher"}],"noNewVoucher":[{"t":2,"r":"noNewVoucher"}],"isRedMembership":[{"t":4,"f":[{"t":2,"r":"isRedMembership"}],"n":50,"x":{"r":["idx","redMembershipLocator"],"s":"_0===_1"}}],"isOrderConfirmation":[{"t":2,"r":"isOrderConfirmation"}],"isBackOrder":[{"t":2,"x":{"r":["deviceIdAndPlanId.isBackOrder","isOrderConfirmation","orderConfirmation.isBackOrder"],"s":"_0||(_1&&_2)"}}]}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"small-collapse medium-uncollapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-offset-1 medium-11 clearfix"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom left"},"f":["Vouchers"]}]}," ",{"t":7,"e":"ux-row","a":{"class":"small-collapse medium-uncollapse"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 medium-offset-1"},"f":[{"t":7,"e":"span","a":{"class":"v-medium-right"},"f":[{"t":2,"r":"name"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 medium-2 margin-top-10"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"r":"vouchers"}]}]}],"n":50,"x":{"r":["shoppingCartPanel","vouchers","vouchers.length"],"s":"!_0&&_1&&_2>=1"}}]}],"i":"idx","r":"order.mobile"}],"n":50,"r":"order.mobile"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-summary-mobile-view","a":{"class":"shopping-cart-panel","icon":"tv-line","showChange":[{"t":2,"r":"showChange"}],"datamodel":[{"t":3,"r":"."}],"shoppingCartPanel":[{"t":2,"r":"shoppingCartPanel"}]}}]}],"r":"order.tv"}],"n":50,"r":"order.tv"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-summary-mobile-view","a":{"class":"shopping-cart-panel","icon":"computer-line","showChange":[{"t":2,"r":"showChange"}],"datamodel":[{"t":3,"r":"."}],"shoppingCartPanel":[{"t":2,"r":"shoppingCartPanel"}]}}]}],"r":"order.fv"}],"n":50,"r":"order.fv"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-tradein-modal"}],"n":53,"r":"tradeindata"}]};
this["ux-summary-mobile-view"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-summary-mobile-view ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-top title-line"},"f":[{"t":7,"e":"ux-col","a":{"class":"icon"},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icon"}],"size":"xl"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"name v-none-padding"},"f":[{"t":7,"e":"div","a":{"class":"section-header category"},"f":[{"t":2,"r":"categoryName"}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","subscriptionId"],"s":"_0.mobileNumberFormat(_1,true)"}}],"n":50,"x":{"r":["lineofBusiness"],"s":"_0!==\"Bundle\""}},{"t":4,"n":51,"f":[{"t":2,"r":"subscriptionId"}],"x":{"r":["lineofBusiness"],"s":"_0!==\"Bundle\""}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"remove"},"f":[{"t":7,"e":"div","a":{"class":"text-right"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"showConfirmModal","item":[{"t":3,"r":"."}]},"f":["Remove"]}],"n":50,"r":"shoppingCartPanel"}]}]}],"n":50,"r":"showRemoveLink"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider expanded"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-none-padding"},"f":[{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header left"},"f":[{"t":2,"r":"ConfigStrings.redMemberShip.planHeader"}]}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":4,"f":[{"t":2,"r":"addons.0.name"}],"n":50,"x":{"r":["addons","addons.0","addons.0.name"],"s":"_0&&_1&&_2"}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 subsection-header"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":2,"r":"initData.shoppingCartHeader.rightitems.0.label"}]}," ",{"t":7,"e":"div","a":{"class":"left help-icon"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":2,"r":"initData.shoppingCartHeader.rightitems.0.tooltip"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"n":50,"r":"isRedMembership"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider expanded"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom"},"f":["Trade in Your Phone"]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":["showTradeinModal:",{"t":2,"r":"idx"}]},"f":["Trade in phone to this mobile line"]}]}]}],"n":50,"r":"showTradein"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"panel-divider expanded"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header left"},"f":["Trade in Your Phone"]}," ",{"t":7,"e":"div","a":{"class":"v-normal-left left"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":["removeTradein:",{"t":2,"r":"idx"}]},"f":["Remove"]}],"n":50,"r":"shoppingCartPanel"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-small-top v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"body-text"},"f":[{"t":2,"r":"tradeIn.tradeInName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-8 subsection-header v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":["Addition to First Bill"]}," ",{"t":7,"e":"div","a":{"class":"left help-icon"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":["These are one-time charge(s). The charge(s) will be reflected in your first month's bill."]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right v-medium-top"},"f":["-"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-8 subsection-header"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":["Monthly Fee"]}," ",{"t":7,"e":"div","a":{"class":"left help-icon"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":["This is a recurring charge over your contractual period."]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right"},"f":["-"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-8 subsection-header"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":["Upfront Fee"]}," ",{"t":7,"e":"div","a":{"class":"left help-icon"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":["This is one time upfront cost."]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right"},"f":["-",{"t":2,"x":{"r":["RactiveHelpers","tradeIn.checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"r":"showTradein"}],"n":50,"x":{"r":["order.checkoutPrice.finalAmountIncludingTax","tradeIn"],"s":"_0>0||_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider expanded padded"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-add-vouchers","a":{"voucher":[{"t":3,"r":"voucherTopic"}],"voucherInfo":[{"t":3,"r":"initData.voucherInfo"}],"preSelectedVouchers":[{"t":3,"r":"vouchers"}],"shoppingCartPanel":"true","hideVouchersModal":"true","enableRetrieveVoucher":[{"t":2,"r":"enableRetrieveVoucher"}],"noNewVoucher":[{"t":2,"r":"noNewVoucher"}]},"f":[]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider expanded padded"}}],"n":50,"x":{"r":["isTablet","deviceDetails","deviceDetails.length","modalOpened"],"s":"!_0&&_1&&_2>=1&&!_3"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"error-margin-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"important-information-details-list"},"f":[{"t":7,"e":"div","a":{"class":"red "},"f":[{"t":7,"e":"ux-icon","a":{"class":"warning voucherIcon","type":"cross","size":"xs"}}," ",{"t":7,"e":"span","a":{"class":"v-medim-left"},"f":[{"t":2,"r":"name"}," is removed."]}]}]}],"n":52,"r":"removedVouchers"}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider expanded padded"}}],"n":50,"x":{"r":["removedVouchers","removedVouchers.length"],"s":"_0&&_1>0"}}],"n":50,"x":{"r":["isTablet","shoppingCartPanel","lineofBusiness","lob"],"s":"!_0&&_1&&(_2==\"Mobile\"||_3===\"mobile\")"}}],"n":50,"x":{"r":["isPPOrder"],"s":"!_0"}}," ",{"t":4,"f":[{"t":7,"e":"ux-freeGifts-error","a":{"unAvailableFreeGifts":[{"t":3,"r":"unAvailableFreeGifts"}],"status":"error"},"f":[]}," ",{"t":7,"e":"div","a":{"class":"panel-divider expanded padded"}}],"n":50,"x":{"r":["unAvailableFreeGifts","unAvailableFreeGifts.length"],"s":"_0&&_1>0"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider expanded padded"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-add-vouchers","a":{"voucher":[{"t":3,"r":"voucherTopic"}],"lob":"bundle","voucherInfo":[{"t":3,"r":"initData.voucherInfo"}],"preSelectedVouchers":[{"t":3,"r":"vouchers"}],"shoppingCartPanel":"true","hideVouchersModal":"true","enableRetrieveVoucher":[{"t":2,"r":"enableRetrieveVoucher"}],"noNewVoucher":[{"t":2,"r":"noNewVoucher"}]},"f":[]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider expanded padded"}}],"n":50,"x":{"r":["shoppingCartPanel","lineofBusiness"],"s":"_0&&_1===\"Bundle\""}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top one-time-price collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 subsection-header"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":["Addition to First Bill"]}," ",{"t":7,"e":"div","a":{"class":"left help-icon"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":["These are one-time charge(s). The charge(s) will be reflected in your first month's bill."]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-top checkout-price collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 subsection-header"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":["Upfront Fee"]}," ",{"t":7,"e":"div","a":{"class":"left help-icon"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":["This is one time upfront cost."]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":["showSummaryRowDetails:",{"t":2,"r":"lineofBusiness"},{"t":2,"r":"subscriptionId"}]},"f":["View Details"]}]}]}," ",{"t":7,"e":"ux-modal","a":{"class":"light-theme","modalId":[{"t":2,"r":"lineofBusiness"},{"t":2,"r":"subscriptionId"}],"modalData":[{"t":3,"r":"."}],"icon":"close-line"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"categoryName"}]}," ",{"t":7,"e":"div","a":{"class":"body-light v-small-top"},"f":[{"t":2,"r":"subscriptionId"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":4,"f":[{"t":7,"e":"ux-summarydata-row","a":{"type":[{"t":2,"r":"i"}],"datamodel":[{"t":3,"r":"modalData"}],"isRedMembership":[{"t":2,"r":"isRedMembership"}]}}],"i":"i","r":"modalData"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom"},"f":["Trade in Your Phone"]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":["showTradeinModal:",{"t":2,"r":"idx"}]},"f":["Trade in phone to this mobile line"]}]}]}],"n":50,"r":"showTradein"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header left"},"f":["Trade in Your Phone"]}," ",{"t":7,"e":"div","a":{"class":"v-normal-left left"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":["removeTradein:",{"t":2,"r":"idx"}]},"f":["Remove"]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"div","a":{"class":"body-text v-medium-top"},"f":[{"t":2,"r":"tradeIn.tradeInName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"div","a":{"class":"right checkout-price v-medium-top"},"f":[{"t":2,"x":{"r":["RactiveHelpers","tradeIn.checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}],"r":"showTradein"}],"n":50,"x":{"r":["order.checkoutPrice.finalAmountIncludingTax","tradeIn"],"s":"_0>0||_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-add-vouchers","a":{"voucher":[{"t":3,"r":"voucherTopic"}],"voucherInfo":[{"t":3,"r":"initData.voucherInfo"}],"preSelectedVouchers":[{"t":3,"r":"vouchers"}],"shoppingCartPanel":"true","hideVouchersModal":"false","enableRetrieveVoucher":[{"t":2,"r":"enableRetrieveVoucher"}],"noNewVoucher":[{"t":2,"r":"noNewVoucher"}]},"f":[]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"x":{"r":["deviceDetails","deviceDetails.length"],"s":"_0&&_1>=1"}}],"n":50,"x":{"r":["shoppingCartPanel","lineofBusiness"],"s":"_0&&_1==\"Mobile\""}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header left"},"f":["Trade in Your Phone"]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"div","a":{"class":"body-text v-medium-top"},"f":[{"t":2,"r":"tradeIn.tradeInName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"div","a":{"class":"right checkout-price v-medium-top"},"f":[{"t":2,"x":{"r":["RactiveHelpers","tradeIn.checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}],"n":50,"x":{"r":["data.order.checkoutPrice.finalAmountIncludingTax","tradeIn"],"s":"_0>0||_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"small-collapse medium-uncollapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-offset-1 medium-11 clearfix"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header v-medium-bottom left"},"f":["Vouchers"]}]}," ",{"t":7,"e":"ux-row","a":{"class":"small-collapse medium-uncollapse"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 medium-offset-1"},"f":[{"t":7,"e":"span","a":{"class":"v-medium-right"},"f":[{"t":2,"r":"name"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 medium-2 margin-top-10"},"f":[{"t":7,"e":"div","a":{"class":"right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"r":"vouchers"}]}]}],"n":50,"x":{"r":["vouchers","vouchers.length"],"s":"_0&&_1>=1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-freeGifts-error","a":{"unAvailableFreeGifts":[{"t":3,"r":"unAvailableFreeGifts"}],"status":"error"},"f":[]}]}],"n":50,"x":{"r":["unAvailableFreeGifts","unAvailableFreeGifts.length"],"s":"_0&&_1>0"}}],"n":50,"x":{"r":["shoppingCartPanel","lob","lineofBusiness"],"s":"!_0&&(_1==\"mobile\"||_2==\"Mobile\")"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top one-time-price collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"subsection-header v-normal-bottom"},"f":["Subtotal (Inclusive of GST)"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-8 subsection-header"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":["Addition to First Bill"]}," ",{"t":7,"e":"div","a":{"class":"left help-icon"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":["These are one-time charge(s). The charge(s) will be reflected in your first month's bill."]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-top checkout-price collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 subsection-header"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":["Upfront Fee"]}," ",{"t":7,"e":"div","a":{"class":"left help-icon"},"v":{"click":"showTooltip"},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":["This is one time upfront cost."]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}]}],"r":"isRedMembership"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-tradein-modal"}],"n":53,"r":"tradeindata"}]};
this["ux-summarydata-row"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-summarydata-row"},"f":[{"t":7,"e":"div","a":{"class":"hide-for-small-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-10 medium-offset-1"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}]}," ",{"t":7,"e":"ux-row","a":{"class":"row-title"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-10 medium-offset-1"},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"left subsection-header row-title"},"f":[{"t":2,"r":"rowTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"changeState"}],"ontap":"changeCartItem"},"f":[{"t":4,"f":["Change Number"],"n":50,"x":{"r":["type"],"s":"_0===\"landlineNumber\""}},{"t":4,"n":51,"f":["Change"],"x":{"r":["type"],"s":"_0===\"landlineNumber\""}}]}," ",{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"itemRemoveState"}],"ontap":"removeCartMainItem"},"f":["Remove"]}," ",{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"addMoreState"}],"ontap":"addCartItem"},"f":["Add More"]}],"n":50,"x":{"r":["isFreeMBB","type"],"s":"!_0&&_1!==\"premiumAddons\""}}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"row-title"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-10 medium-offset-1 p-medium-top p-small-bottom"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":2,"r":"rowLabel"}]}]}]}],"n":50,"r":"rowLabel"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-8"],"n":50,"r":"isRedMembership"},{"t":4,"n":51,"f":["medium-4"],"r":"isRedMembership"}," medium-offset-1"]},"f":[{"t":4,"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"image"}],"class":"phone-img right"}}],"n":50,"r":"image"}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":4,"f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","customClass":"ipp-duration medium-8 input-no-margin","selected_value":[{"t":2,"r":"rowData"}],"options":[{"t":2,"r":"contractFilter"}],"onChangeEvent":"changeCartItem","id":"id-duration"},"f":[]}],"n":50,"x":{"r":["hideContractFilter","type","contractFilter","contractFilter.length"],"s":"!_0&&_1===\"ippCharges\"&&_2&&_3>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"left row-data"},"f":[{"t":3,"r":"rowData"}]}],"x":{"r":["hideContractFilter","type","contractFilter","contractFilter.length"],"s":"!_0&&_1===\"ippCharges\"&&_2&&_3>0"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"removeState"}],"ontap":"removeCartItem","index":[{"t":2,"r":"i"}]},"f":[{"t":4,"f":["Change"],"n":50,"x":{"r":["id"],"s":"_0===\"stb\""}},{"t":4,"n":51,"f":["Remove"],"x":{"r":["id"],"s":"_0===\"stb\""}}]}],"n":50,"x":{"r":["type"],"s":"_0!==\"premiumAddons\""}}],"n":51,"r":"hideRemoveLink"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-2 recurring-price"},"f":[{"t":7,"e":"div","a":{"class":"body-light center"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"recurringPrice.finalAmountIncludingTax"}],"n":50,"r":"recurringPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"recurringPrice.finalAmountIncludingTax"}],"n":50,"x":{"r":["displayAs"],"s":"_0==\"free\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["displayAs"],"s":"_0==\"strikedout\""},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-text"},"f":[{"t":2,"x":{"r":["RactiveHelpers","recurringPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"recurringPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"recurringPrice.finalAmountIncludingTax"}]},{"t":4,"n":50,"x":{"r":["displayAs"],"s":"!(_0==\"strikedout\")"},"f":[" ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"oneTimePrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[{"t":4,"f":["$0.00"],"n":50,"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}},{"t":4,"n":51,"f":[" "],"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}}],"r":"oneTimePrice.finalAmountIncludingTax"}]}],"x":{"r":["displayAs"],"s":"_0==\"free\""}}]}]}],"n":50,"r":"isRedMembership"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-2 one-time-price"},"f":[{"t":7,"e":"div","a":{"class":"body-light right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"oneTimePrice.finalAmountIncludingTax"}],"n":50,"r":"oneTimePrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"oneTimePrice.finalAmountIncludingTax"}],"n":50,"x":{"r":["displayAs"],"s":"_0==\"free\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["displayAs"],"s":"_0==\"strikedout\""},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-text"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"oneTimePrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"oneTimePrice.finalAmountIncludingTax"}]},{"t":4,"n":50,"x":{"r":["displayAs"],"s":"!(_0==\"strikedout\")"},"f":[" ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"oneTimePrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[{"t":4,"f":["$0.00"],"n":50,"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}},{"t":4,"n":51,"f":[" "],"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}}],"r":"oneTimePrice.finalAmountIncludingTax"}]}],"x":{"r":["displayAs"],"s":"_0==\"free\""}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-2 recurring-price"},"f":[{"t":7,"e":"div","a":{"class":"body-light right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"recurringPrice.finalAmountIncludingTax"}],"n":50,"r":"recurringPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"recurringPrice.finalAmountIncludingTax"}],"n":50,"x":{"r":["displayAs"],"s":"_0==\"free\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["displayAs"],"s":"_0==\"strikedout\""},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-text"},"f":[{"t":2,"x":{"r":["RactiveHelpers","recurringPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"recurringPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"recurringPrice.finalAmountIncludingTax"}]},{"t":4,"n":50,"x":{"r":["displayAs"],"s":"!(_0==\"strikedout\")"},"f":[" ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","recurringPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"recurringPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[{"t":4,"f":["$0.00"],"n":50,"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}},{"t":4,"n":51,"f":[" "],"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}}],"r":"recurringPrice.finalAmountIncludingTax"}]}],"x":{"r":["displayAs"],"s":"_0==\"free\""}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-2 checkout-price"},"f":[{"t":7,"e":"div","a":{"class":"body-light right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"checkoutPrice.finalAmountIncludingTax"}],"n":50,"r":"checkoutPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"checkoutPrice.finalAmountIncludingTax"}],"n":50,"x":{"r":["displayAs"],"s":"_0==\"free\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["displayAs"],"s":"_0==\"strikedout\""},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-text"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"checkoutPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"checkoutPrice.finalAmountIncludingTax"}]},{"t":4,"n":50,"x":{"r":["displayAs"],"s":"!(_0==\"strikedout\")"},"f":[" ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"checkoutPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[{"t":4,"f":["$0.00"],"n":50,"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}},{"t":4,"n":51,"f":[" "],"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}}],"r":"checkoutPrice.finalAmountIncludingTax"}]}],"x":{"r":["displayAs"],"s":"_0==\"free\""}}]}]}],"r":"isRedMembership"}]}],"n":51,"r":"hideDisplay"}],"i":"i","r":"rowDetails"}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"row-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"left subsection-title row-title"},"f":[{"t":2,"r":"rowTitle"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"changeState"}],"ontap":"changeCartItem"},"f":[{"t":4,"f":["Change Number"],"n":50,"x":{"r":["type"],"s":"_0===\"landlineNumber\""}},{"t":4,"n":51,"f":["Change"],"x":{"r":["type"],"s":"_0===\"landlineNumber\""}}]}," ",{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"itemRemoveState"}],"ontap":"removeCartMainItem"},"f":["Remove"]}," ",{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"addMoreState"}],"ontap":"addCartItem"},"f":["Add More"]}],"n":50,"x":{"r":["isFreeMBB"],"s":"!_0"}}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"row-title"},"f":[{"t":7,"e":"ux-col","a":{"class":"p-medium-top p-small-bottom"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":2,"r":"rowLabel"}]}]}]}],"n":50,"r":"rowLabel"}," ",{"t":7,"e":"ux-row","a":{"class":"v-small-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"image"}],"class":"phone-img right"}}],"n":50,"r":"image"}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":4,"f":[{"t":7,"e":"ux-select","a":{"showSelectedValue":"true","customClass":"ipp-duration small-8 input-no-margin","selected_value":[{"t":2,"r":"rowData"}],"options":[{"t":2,"r":"contractFilter"}],"onChangeEvent":"changeCartItem","id":"id-duration"},"f":[]}],"n":50,"x":{"r":["hideContractFilter","type","contractFilter","contractFilter.length"],"s":"!_0&&_1===\"ippCharges\"&&_2&&_3>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"left row-data"},"f":[{"t":3,"r":"rowData"}]}],"x":{"r":["hideContractFilter","type","contractFilter","contractFilter.length"],"s":"!_0&&_1===\"ippCharges\"&&_2&&_3>0"}}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"removeState"}],"ontap":"removeCartItem","index":[{"t":2,"r":"i"}]},"f":[{"t":4,"f":["Change"],"n":50,"x":{"r":["id"],"s":"_0===\"stb\""}},{"t":4,"n":51,"f":["Remove"],"x":{"r":["id"],"s":"_0===\"stb\""}}]}],"n":51,"r":"hideRemoveLink"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom row-bottom-border"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top one-time-price"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 subsection-title"},"f":["Addition to First Bill"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"oneTimePrice.finalAmountIncludingTax"}],"n":50,"r":"oneTimePrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"oneTimePrice.finalAmountIncludingTax"}],"n":50,"x":{"r":["displayAs"],"s":"_0==\"free\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["displayAs"],"s":"_0==\"strikedout\""},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-text"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"oneTimePrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"oneTimePrice.finalAmountIncludingTax"}]},{"t":4,"n":50,"x":{"r":["displayAs"],"s":"!(_0==\"strikedout\")"},"f":[" ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"oneTimePrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[{"t":4,"f":["$0.00"],"n":50,"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}},{"t":4,"n":51,"f":[" "],"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}}],"r":"oneTimePrice.finalAmountIncludingTax"}]}],"x":{"r":["displayAs"],"s":"_0==\"free\""}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"recurring-price"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 subsection-title"},"f":["Monthly Fee"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"recurringPrice.finalAmountIncludingTax"}],"n":50,"r":"recurringPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"recurringPrice.finalAmountIncludingTax"}],"n":50,"x":{"r":["displayAs"],"s":"_0==\"free\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["displayAs"],"s":"_0==\"strikedout\""},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-text"},"f":[{"t":2,"x":{"r":["RactiveHelpers","recurringPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"recurringPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"recurringPrice.finalAmountIncludingTax"}]},{"t":4,"n":50,"x":{"r":["displayAs"],"s":"!(_0==\"strikedout\")"},"f":[" ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","recurringPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"recurringPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[{"t":4,"f":["$0.00"],"n":50,"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}},{"t":4,"n":51,"f":[" "],"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}}],"r":"recurringPrice.finalAmountIncludingTax"}]}],"x":{"r":["displayAs"],"s":"_0==\"free\""}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"checkout-price v-small-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8 subsection-title"},"f":["Upfront Fee"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4 text-right"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":2,"r":"checkoutPrice.finalAmountIncludingTax"}],"n":50,"r":"checkoutPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"checkoutPrice.finalAmountIncludingTax"}],"n":50,"x":{"r":["displayAs"],"s":"_0==\"free\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["displayAs"],"s":"_0==\"strikedout\""},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"strike-text"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}],"n":50,"r":"checkoutPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[" "],"r":"checkoutPrice.finalAmountIncludingTax"}]},{"t":4,"n":50,"x":{"r":["displayAs"],"s":"!(_0==\"strikedout\")"},"f":[" ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"checkoutPrice.finalAmountIncludingTax"},{"t":4,"n":51,"f":[{"t":4,"f":["$0.00"],"n":50,"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}},{"t":4,"n":51,"f":[" "],"x":{"r":["checkoutPrice.finalAmountIncludingTax"],"s":"_0==0"}}],"r":"checkoutPrice.finalAmountIncludingTax"}]}],"x":{"r":["displayAs"],"s":"_0==\"free\""}}]}]}]}],"n":51,"r":"hideDisplay"}],"i":"i","r":"rowDetails"}]}]}],"n":50,"r":"rowTitle"}]};
this["ux-summarytitle-row"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-summarytitle-row ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"ux-col","a":{"class":"small-1"},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icon"}],"size":"xl"}}]}," ",{"t":7,"e":"ux-col","a":{"class":["small-4 colspacing ",{"t":4,"f":["small-10"],"n":50,"r":"shoppingCartPanel"}]},"f":[{"t":7,"e":"div","a":{"class":"section-header category"},"f":[{"t":7,"e":"div","a":{"class":"left v-medium-top"},"f":[{"t":2,"r":"categoryName"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":["left change-link ",{"t":2,"r":"itemRemoveState"}," show-for-medium-up removelink-shoppingcart"],"ontap":"showConfirmModal","item":[{"t":3,"r":"."}]},"f":["Remove"]}],"n":50,"r":"showRemoveLink"}]}," ",{"t":7,"e":"div","a":{"class":"body-light v-small-top"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","subscriptionId"],"s":"_0.mobileNumberFormat(_1,true)"}}],"n":50,"x":{"r":["lineofBusiness","ConfigStrings.serviceConfig.RED.lineofBusiness"],"s":"!(_0===\"Bundle\"||_0===_1)"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["lineofBusiness","ConfigStrings.serviceConfig.RED.lineofBusiness"],"s":"_0===_1"},"f":[{"t":2,"r":"serviceId"}]},{"t":4,"n":50,"x":{"r":["lineofBusiness","ConfigStrings.serviceConfig.RED.lineofBusiness"],"s":"!(_0===_1)"},"f":[" ",{"t":2,"r":"subscriptionId"}]}],"x":{"r":["lineofBusiness","ConfigStrings.serviceConfig.RED.lineofBusiness"],"s":"!(_0===\"Bundle\"||_0===_1)"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-2 v-default-top"},"f":[{"t":7,"e":"div","a":{"class":"right one-time-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","oneTimePrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 v-default-top"},"f":[{"t":7,"e":"div","a":{"class":"right recurring-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","recurringPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-2 v-default-top"},"f":[{"t":7,"e":"div","a":{"class":"right checkout-price"},"f":[{"t":2,"x":{"r":["RactiveHelpers","checkoutPrice.finalAmountIncludingTax"],"s":"_0.convertUnits(_1,\"$\")"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-top text-right"},"f":[{"t":4,"f":["-",{"t":2,"x":{"r":["RactiveHelpers","tradeindata.tradeinPhoneValue"],"s":"_0.convertUnits(_1,\"$\")"}}],"n":50,"r":"tradeindata.displayTradeinValue"}]}],"n":50,"x":{"r":["lineofBusiness"],"s":"_0==\"Mobile\""}}]}]}],"n":50,"x":{"r":["shoppingCartPanel"],"s":"!_0"}}," ",{"t":7,"e":"ux-col","a":{"class":"small-1 v-medium-top text-right fold-button"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]};
this["ux-support-decision-tree"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-support-decision-tree"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"3"},"f":[{"t":2,"r":"question"}]}," ",{"t":7,"e":"div","f":[{"t":3,"r":"answer"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"light round","text":[{"t":2,"r":"./title"}],"role":"button","itemIndex":[{"t":2,"r":"./title"}],"arialabel":[{"t":2,"r":"./title"}],"nextActionSrc":[{"t":3,"r":"./src"}],"onclick":"nextStep"},"f":[]}],"n":52,"i":"i","r":"options"}]}]}],"n":50,"x":{"r":["options","options.length"],"s":"_0&&_1>0"}}]}]}]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"sourceTreeChildNodes"}],"x":{"r":["moreOptions","indexItem"],"s":"{moreOption:_0[_1],indexItem:_1}"}}]}],"p":{"sourceTreeChildNodes":[{"t":7,"e":"div","a":{"class":"ux-support-decision-child-tree"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","f":[{"t":3,"r":"answer"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"light round","text":[{"t":2,"r":"./title"}],"indexItem":[{"t":2,"r":"indexItem"}],"index":[{"t":2,"r":"i"}],"role":"button","arialabel":[{"t":2,"r":"./title"}],"nextActionSrc":[{"t":3,"r":"./src"}],"onclick":"nextStepChild"},"f":[]}],"n":52,"i":"i","r":"options"}]}]}],"n":50,"x":{"r":["options","options.length"],"s":"_0&&_1>0"}}," ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"sourceTreeChildNodes"}],"x":{"r":["./moreElement","indexItem"],"s":"{moreOption:_0,indexItem:_1}"}}],"n":50,"r":"./moreElement"}]}]}]}],"r":"moreOption"}]}]}};
this["ux-support-navigation"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-support-navigation"},"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6 medium-3 text-center"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":3,"r":"link"}]},"f":[{"t":7,"e":"ux-panel","f":[{"t":4,"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icon"}]}}],"r":"iconStyle"}," ",{"t":4,"f":[{"t":7,"e":"ux-image"}],"r":"imageStyle"}," ",{"t":7,"e":"ux-header","a":{"level":"3","class":"section-header"},"f":[{"t":2,"r":"title"}]}]}]}]}],"r":"visibleList"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"button view-button round","ontap":"showAll"},"f":[{"t":2,"r":"buttonText"}]}]}]}],"n":50,"r":"buttonDisable"}]}]};
this["ux-support-videos"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-support-videos"},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header v-normal-bottom"},"f":[{"t":2,"r":"supportVideoTitle"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":7,"e":"div","a":{"class":"support-video v-normal-bottom"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":["openModal:",{"t":3,"r":"youtubeVideoId"}]},"f":[{"t":7,"e":"ux-image","a":{"datamodel":[{"t":3,"r":"."}]}}," ",{"t":7,"e":"div","a":{"class":"play-icon"}}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"modalId":[{"t":3,"r":"youtubeVideoId"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-iframe","a":{"src":["https://www.youtube.com/embed/",{"t":3,"r":"youtubeVideoId"}],"width":"100%","heightInd":"true","height":"450px","position":"absolute"}}]}]}],"r":"videoListDisplayed"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"text-center"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"button round view-button","ontap":"viewMore"},"f":[{"t":2,"r":"showMoreText"}]}]}]}],"n":50,"r":"hideButton"}]}]}]};
this["ux-table-head-cell"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"th","a":{"id":"component","class":["ux-table-head-cell ",{"t":4,"f":[{"t":2,"r":"sortConfig.sortableClass"}],"r":"sortConfig.sort"}," ",{"t":2,"r":"class"}]},"v":{"click":"cellClick"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12 align-center"},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":16}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["left sort ",{"t":2,"x":{"r":["sortConfig.direction","sortConfig.ascClass","sortConfig.descClass"],"s":"_0===\"ASC\"?_1:_2"}}]},"f":[{"t":7,"e":"div","a":{"class":["arrow-up ",{"t":2,"x":{"r":["sortConfig.direction"],"s":"_0===\"ASC\"?\"active\":\"\""}}]}}," ",{"t":7,"e":"div","a":{"class":"arrow-separator"}}," ",{"t":7,"e":"div","a":{"class":["arrow-down ",{"t":2,"x":{"r":["sortConfig.direction"],"s":"_0===\"ASC\"?\"\":\"active\""}}]}}]}],"r":"sortConfig.sort"}]}]}]}],"n":53,"r":"columnConfig"}]};
this["ux-techspec-accordion"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-techspec-accordion ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}," ",{"t":4,"f":["v-",{"t":2,"r":"bottomSpacing"},"-bottom"],"n":50,"r":"bottomSpacing"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"expand-panel column-control-mobile"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","a":{"class":"panel30 margin-zero techspec-panel"},"f":[{"t":7,"e":"div","a":{"class":"singtel-accordion"},"f":[{"t":7,"e":"ux-accordion","a":{"class":"specification-accordion","data":[{"t":3,"r":"."}],"freeGiftsList":[{"t":2,"r":"freeGiftsList"}]},"f":[{"t":7,"e":"ux-accordionitem","a":{"class":["free-gifts ",{"t":4,"f":["force-hide"],"n":50,"x":{"r":["freeGiftsList"],"s":"!_0"}}]},"f":[{"t":7,"e":"ux-anchor","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"div","a":{"class":"left v-normal-right"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":"rewards-line"}}]}," ",{"t":7,"e":"div","a":{"class":"left accordion-title"},"f":[{"t":2,"r":"data.title.freeGifts"}]}," ",{"t":7,"e":"div","a":{"class":"right v-medium-top"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":7,"e":"ux-row","a":{"class":"free-gifts"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-10 freegift-row show-for-medium-up"},"f":[{"t":7,"e":"ux-tout-singtel","a":{"forPlans":"false","img":[{"t":2,"r":"img.desktop"}],"spacing":"true","datamodel":[{"t":3,"r":"."}]},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-10 freegift-row show-for-small-only"},"f":[{"t":7,"e":"ux-tout-singtel","a":{"forPlans":"false","img":[{"t":2,"r":"img.mobile"}],"spacing":"true","datamodel":[{"t":3,"r":"."}]},"f":[]}]}],"n":52,"r":"freeGiftsList"}]}]}]}," ",{"t":7,"e":"div","a":{"class":["panel-divider ",{"t":4,"f":["force-hide"],"n":50,"x":{"r":["freeGiftsList"],"s":"!_0"}}]}}," ",{"t":7,"e":"ux-accordionitem","a":{"class":"tech-spec"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"div","a":{"class":"left v-normal-right"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":"tech-specs-line"}}]}," ",{"t":7,"e":"div","a":{"class":"left accordion-title"},"f":[{"t":2,"r":"data.title.techSpec"}]}," ",{"t":7,"e":"div","a":{"class":"right v-medium-top"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"large-6 techspec-col"},"f":[{"t":7,"e":"div","a":{"class":"spec-details-column"},"f":[{"t":7,"e":"div","a":{"class":"spec-details-row clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"specification-title"},"f":[{"t":2,"r":"data.title.specifications"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider margin-zero"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"spec-details-row clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-7 text-right"},"f":[{"t":2,"r":"content"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["panel-divider margin-zero"],"n":50,"x":{"r":["i","data.specifications.length"],"s":"_0<_1-1"}}]}}]}]}],"i":"i","r":"data.specifications"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-6 techspec-col"},"f":[{"t":7,"e":"div","a":{"class":"spec-details-column"},"f":[{"t":7,"e":"div","a":{"class":"spec-details-row clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"specification-title show-for-medium-up"},"f":[{"t":2,"r":"data.title.features"}]}," ",{"t":7,"e":"ux-col","a":{"class":"specification-title show-for-small-only v-normal-top"},"f":[{"t":2,"r":"data.title.features"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":"panel-divider margin-zero"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"spec-details-row clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-5"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-7 text-right"},"f":[{"t":2,"r":"content"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["panel-divider margin-zero"],"n":50,"x":{"r":["i","data.features.length"],"s":"_0<_1-1"}}]}}]}]}],"i":"i","r":"data.features"}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-accordionitem","a":{"class":"whats-in-box"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":7,"e":"div","a":{"class":"left v-normal-right"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":"whats-in-the-box-line"}}]}," ",{"t":7,"e":"div","a":{"class":"left accordion-title"},"f":[{"t":2,"r":"data.title.whatsInABox"}]}," ",{"t":7,"e":"div","a":{"class":"right v-medium-top"},"f":[{"t":7,"e":"ux-icon","a":{"type":"chevron-up"}}," ",{"t":7,"e":"ux-icon","a":{"type":"chevron-down"}}]}]}]}]}]}," ",{"t":7,"e":"ux-content","a":{"class":"expand-panel-item"},"f":[{"t":7,"e":"ul","a":{"class":"notes-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":2,"r":"."}]}],"r":"data.whatsInABox"}]}]}]}]}]}]}]}]}]}]};
this["ux-textarea"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-textarea ",{"t":2,"r":"class"}," ",{"t":2,"r":"validity.status"}," ",{"t":2,"r":"valid"}]},"f":[{"t":4,"f":[{"t":7,"e":"label","a":{"for":[{"t":2,"r":"id"}]},"f":[{"t":2,"r":"label_value"},{"t":4,"f":[{"t":7,"e":"span","a":{"aria-live":"assertive","class":"mandatory"},"f":["*"]}],"n":50,"r":"mandatory"}]}],"n":50,"r":"label_value"}," ",{"t":7,"e":"textarea","a":{"id":[{"t":2,"r":"id"}],"value":[{"t":3,"r":"value"}],"rows":[{"t":2,"r":"rows"}],"placeholder":[{"t":2,"r":"placeholder"}],"aria-required":[{"t":2,"x":{"r":["mandatory"],"s":"_0?\"true\":\"false\""}}]},"v":{"blur":"blurHandler"},"m":[{"t":4,"f":["readonly"],"n":50,"r":"textAreaReadOnly"}]}," ",{"t":7,"e":"div","a":{"class":"validity-wrapper","aria-hidden":"true"},"f":[{"t":4,"f":[{"t":7,"e":"ux-form-validity"}],"r":"validity"}]}]}]};
this["ux-threetext-image"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-threetext-image"},"f":[{"t":7,"e":"ux-panel","a":{"class":"v-none-left v-none-right"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"div","a":{"class":"badges-text"},"f":[{"t":2,"r":"subText"}]}," ",{"t":7,"e":"div","a":{"class":"large-body-text"},"f":[{"t":2,"r":"text"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"show-for-medium-up","ariaLabel":"Open in a new browser tab","target":"_blank"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"openNewTab"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"show-for-medium-up"},"f":[{"t":2,"r":"linkText"}]}],"r":"openNewTab"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":4,"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":2,"r":"img"}]}}],"n":50,"r":"img"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["src","alt"],"s":"_0&&_1"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"src"}],"alt":[{"t":2,"r":"alt"}]}}]}],"r":"img"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"show-for-small-only","ariaLabel":"Open in a new browser tab","target":"_blank"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"openNewTab"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"show-for-small-only"},"f":[{"t":2,"r":"linkText"}]}],"r":"openNewTab"}]}]}]}]}]};
this["ux-timeline"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-timeline v-large-top"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"activity v-normal-top v-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"openFaqModal","class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":"cart-filled-filled"}}]}],"n":50,"x":{"r":["type"],"s":"_0===\"purchase\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["type"],"s":"_0===\"message\""},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"openFaqModal","class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":"youtube-round"}}]}]},{"t":4,"n":50,"x":{"r":["type"],"s":"!(_0===\"message\")"},"f":[" ",{"t":7,"e":"ux-anchor","a":{"ontap":"changeAppointment","class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":"account-activity-filled"}}]}]}],"x":{"r":["type"],"s":"_0===\"purchase\""}}," ",{"t":7,"e":"div","a":{"class":"activity-content"},"f":[{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"v-medium-left section-header"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","date"],"s":"_0.convertMilisTimestampToDate(_1,\"DD/MM/YYYY\")"}}],"n":50,"x":{"r":["type"],"s":"_0===\"purchase\""}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["RactiveHelpers","date"],"s":"_0.convertMilisTimestampToDate(_1,\"DD/MM/YYYY, hh:mm A\")"}}],"x":{"r":["type"],"s":"_0===\"purchase\""}}]}," ",{"t":7,"e":"div","a":{"class":"v-medium-left links line"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"link"},"f":[{"t":2,"r":"label"}," ",{"t":7,"e":"ux-anchor","a":{"class":"details-link","activity":[{"t":2,"rx":{"r":"activities","m":[{"t":30,"n":"i"}]}}],"link":[{"t":2,"r":"."}],"ontap":"onLinkClick"},"f":[{"t":2,"r":"link"}]}]}],"n":52,"r":"links"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"event v-normal-top v-none-bottom"},"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"flex-container inline-block"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":"cart-filled-filled"}}]}],"n":50,"x":{"r":["i","activities"],"s":"_1[_0].type===\"purchase\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["i","activities"],"s":"_1[_0].type===\"message\""},"f":[{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":"youtube-round"}}]}]},{"t":4,"n":50,"x":{"r":["i","activities"],"s":"!(_1[_0].type===\"message\")"},"f":[" ",{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":7,"e":"ux-icon","a":{"size":"xl","type":"account-activity-filled"}}]}]}],"x":{"r":["i","activities"],"s":"_1[_0].type===\"purchase\""}}," ",{"t":7,"e":"div","a":{"class":"left"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"v-medium-left section-header"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","date"],"s":"_0.convertMilisTimestampToDate(_1,\"DD/MM/YYYY\")"}}],"n":50,"x":{"r":["i","activities"],"s":"_1[_0].type===\"purchase\""}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["RactiveHelpers","date"],"s":"_0.convertMilisTimestampToDate(_1,\"DD/MM/YYYY, hh:mm A\")"}}],"x":{"r":["i","activities"],"s":"_1[_0].type===\"purchase\""}}]}," ",{"t":7,"e":"div","a":{"class":"v-medium-left links line"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"link"},"f":[{"t":2,"r":"label"}," ",{"t":7,"e":"ux-anchor","a":{"class":"details-link","activity":[{"t":2,"rx":{"r":"activities","m":[{"t":30,"n":"i"}]}}],"link":[{"t":2,"r":"."}],"ontap":"onLinkClick"},"f":[{"t":2,"r":"link"}]}]}],"n":52,"r":"links"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"event-top"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"title line titleline"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"saveAppointmentDetails","activity":[{"t":2,"rx":{"r":"activities","m":[{"t":30,"n":"i"}]}}],"eventObj":[{"t":2,"r":"."}],"class":"description margin-zero"},"f":[{"t":7,"e":"div","a":{"class":"event-title subsection-header","level":"4"},"f":[{"t":2,"r":"title"}]}]}],"n":50,"r":"isLinkedApptIdExist"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"class":"event-title subsection-header","level":"4"},"f":[{"t":2,"r":"title"}]}],"r":"isLinkedApptIdExist"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"change-link","activity":[{"t":2,"rx":{"r":"activities","m":[{"t":30,"n":"i"}]}}],"eventObj":[{"t":2,"r":"."}],"ontap":"doOpenModal"},"f":["Change"]}],"n":50,"r":"changeable"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"cancel-link","ontap":"cancelActivity","activity":[{"t":2,"rx":{"r":"activities","m":[{"t":30,"n":"i"}]}}],"eventObj":[{"t":2,"r":"."}]},"f":["Cancel"]}],"n":50,"r":"cancelable"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"ticket-link","activity":[{"t":2,"rx":{"r":"activities","m":[{"t":30,"n":"i"}]}}],"eventObj":[{"t":2,"r":"."}],"ontap":"doOpenModal"},"f":["Details"]}],"n":50,"r":"viewable"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"ticket-link","activity":[{"t":2,"rx":{"r":"activities","m":[{"t":30,"n":"i"}]}}],"eventObj":[{"t":2,"r":"."}],"ontap":"downloadFsAppointmentDetails"},"f":["Download Delivery Order"]}],"n":50,"r":"appointetDetails"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"title line"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"saveAppointmentDetails","activity":[{"t":2,"rx":{"r":"activities","m":[{"t":30,"n":"i"}]}}],"eventObj":[{"t":2,"r":"."}],"class":"description margin-zero"},"f":[{"t":7,"e":"div","a":{"class":"event-title subsection-header","level":"4"},"f":[{"t":2,"r":"title"}]}]}],"n":50,"r":"isLinkedApptIdExist"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-header","a":{"class":"event-title subsection-header","level":"4"},"f":[{"t":2,"r":"title"}]}],"r":"isLinkedApptIdExist"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"change-link","activity":[{"t":2,"rx":{"r":"activities","m":[{"t":30,"n":"i"}]}}],"eventObj":[{"t":2,"r":"."}],"ontap":"doOpenModal"},"f":["Change"]}],"n":50,"r":"changeable"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"cancel-link","ontap":"cancelActivity","activity":[{"t":2,"rx":{"r":"activities","m":[{"t":30,"n":"i"}]}}],"eventObj":[{"t":2,"r":"."}]},"f":["Cancel"]}],"n":50,"r":"cancelable"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"ticket-link","activity":[{"t":2,"rx":{"r":"activities","m":[{"t":30,"n":"i"}]}}],"eventObj":[{"t":2,"r":"."}],"ontap":"doOpenModal"},"f":["Details"]}],"n":50,"r":"viewable"}," ",{"t":4,"f":["    ",{"t":7,"e":"ux-anchor","a":{"class":"ticket-link","activity":[{"t":2,"rx":{"r":"activities","m":[{"t":30,"n":"i"}]}}],"eventObj":[{"t":2,"r":"."}],"ontap":"downloadFsAppointmentDetails"},"f":["Download Delivery Order"]}],"n":50,"r":"appointetDetails"}]}]}],"n":50,"r":"title"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":2,"r":"."}]}],"n":52,"r":"description"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"text"},"f":[{"t":2,"r":"installation.service"}]}],"n":50,"x":{"r":["i","activities"],"s":"_1[_0].type===\"Shop\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address line"},"f":[{"t":7,"e":"div","a":{"class":"text"},"f":[{"t":2,"r":"address"}]}]}],"n":50,"x":{"r":["address"],"s":"typeof _0===\"string\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"address line"},"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"address"}]}}]}],"n":50,"x":{"r":["address"],"s":"typeof _0===\"object\""}}]}," ",{"t":7,"e":"hr"}," ",{"t":7,"e":"div","a":{"class":"event-bottom show-for-medium-up"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"installation line"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"date"},"f":["Delivery Date : ",{"t":7,"e":"span","a":{"class":"value"},"f":[{"t":2,"x":{"r":["RactiveHelpers","deliveryDate"],"s":"_0.convertMilisTimestampToDateSGP(_1)"}}]}]}],"n":50,"r":"deliveryDate"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"time"},"f":["Delivery Time : ",{"t":7,"e":"span","a":{"class":"value"},"f":[{"t":2,"r":"deliveryTime"}]}]}],"n":50,"r":"deliveryTime"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"time"},"f":["Installation Time : ",{"t":7,"e":"span","a":{"class":"value"},"f":[{"t":2,"r":"installationTime"}]}]}],"n":50,"r":"installationTime"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"time"},"f":["Appointment Time : ",{"t":7,"e":"span","a":{"class":"value"},"f":[{"t":2,"r":"shopApointmentTime"}]}]}],"n":50,"r":"shopApointmentTime"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"date"},"f":["Installation (Singtel) : ",{"t":7,"e":"span","a":{"class":"value"},"f":[{"t":2,"x":{"r":["RactiveHelpers","wfmAppointmentDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}],"n":50,"r":"wfmAppointmentDate"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"date"},"f":["Appointment Date : ",{"t":7,"e":"span","a":{"class":"value"},"f":[{"t":2,"x":{"r":["RactiveHelpers","shopApointmentDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}],"n":50,"r":"shopApointmentDate"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"date"},"f":["Installation Date : ",{"t":7,"e":"span","a":{"class":"value"},"f":[{"t":2,"x":{"r":["RactiveHelpers","installationDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}],"n":50,"r":"installationDate"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"date"},"f":["Installation (Net Link Trust) : ",{"t":7,"e":"span","a":{"class":"value"},"f":[{"t":2,"x":{"r":["RactiveHelpers","netLinkDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}],"n":50,"r":"netLinkDate"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"status"},"f":["Status : ",{"t":7,"e":"span","a":{"class":"value"},"f":[{"t":2,"r":"status"}]}]}],"n":50,"r":"status"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"status"},"f":[{"t":3,"x":{"r":["RactiveHelpers","interactionDesc"],"s":"_0.unescapeString(_1)"}}]}],"n":50,"r":"interactionDesc"}]}],"n":53,"r":"installation"}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"ontap":"addAppointmentToCalendar","class":"margin-zero","event":[{"t":2,"rx":{"r":"events","m":[{"t":30,"n":"j"}]}}]},"f":["Add to Calendar"]}]}],"n":50,"x":{"r":["showAddToCalendar","j","events"],"s":"_0(_2[_1])"}}],"n":50,"r":"installation"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"}}," ",{"t":7,"e":"ux-fs-appointment-breadcrumb","a":{"fsAppointment":[{"t":2,"r":"fsAppointment"}]}}],"n":50,"r":"fsAppointment"}]}," ",{"t":7,"e":"div","a":{"class":"event-bottom show-for-small-only"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"installation line"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"date small-6 value"},"f":["Installation (Singtel) :"]},{"t":7,"e":"ux-col","a":{"class":"text-right small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","wfmAppointmentDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}],"n":50,"r":"wfmAppointmentDate"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"date small-6 value"},"f":["Appointment Date :"]},{"t":7,"e":"ux-col","a":{"class":"text-right small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","shopApointmentDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}],"n":50,"r":"shopApointmentDate"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"date small-6 value"},"f":["Installation Date :"]},{"t":7,"e":"ux-col","a":{"class":"text-right small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","installationDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}],"n":50,"r":"installationDate"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"date small-6 value"},"f":["Installation (Net Link Trust) :"]},{"t":7,"e":"ux-col","a":{"class":"text-right small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","netLinkDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}],"n":50,"r":"netLinkDate"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"time small-6 value"},"f":["Delivery Date :"]}," ",{"t":7,"e":"ux-col","a":{"class":"text-right small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","deliveryDate"],"s":"_0.convertMilisTimestampToDateSGP(_1)"}}]}]}],"n":50,"r":"deliveryDate"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"time small-6 value"},"f":["Delivery Time :"]}," ",{"t":7,"e":"ux-col","a":{"class":"text-right small-6"},"f":[{"t":2,"r":"deliveryTime"}]}]}],"n":50,"r":"deliveryTime"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"time small-6 value"},"f":["Installation Time :"]},{"t":7,"e":"ux-col","a":{"class":"text-right small-6"},"f":[{"t":2,"r":"installationTime"}]}]}],"n":50,"r":"installationTime"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"time small-6 value"},"f":["Appointment Time :"]},{"t":7,"e":"ux-col","a":{"class":"text-right small-6"},"f":[{"t":2,"r":"shopApointmentTime"}]}]}],"n":50,"r":"shopApointmentTime"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-small-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"status small-6 value"},"f":["Status :"]},{"t":7,"e":"ux-col","a":{"class":"text-right small-6"},"f":[{"t":2,"r":"status"}]}]}],"n":50,"r":"status"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"status"},"f":[{"t":3,"x":{"r":["RactiveHelpers","interactionDesc"],"s":"_0.unescapeString(_1)"}}]}]}],"n":50,"r":"interactionDesc"}]}],"n":53,"r":"installation"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"text-center-small"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"addAppointmentToCalendar","class":"margin-zero","event":[{"t":2,"rx":{"r":"events","m":[{"t":30,"n":"j"}]}}]},"f":["Add to Calendar"]}]}],"n":50,"x":{"r":["showAddToCalendar","j","events"],"s":"_0(_2[_1])"}}],"n":50,"r":"installation"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"}}," ",{"t":7,"e":"ux-fs-appointment-breadcrumb","a":{"fsAppointment":[{"t":2,"r":"fsAppointment"}]}}],"n":50,"r":"fsAppointment"}]}]}],"n":52,"i":"j","r":"events"}]}]}],"n":50,"r":"date"}],"i":"i","r":"activities"}," ",{"t":7,"e":"form","a":{"id":"ics-file-download-form","method":"POST","action":"/bin/services/singtel/ics-file-download"},"f":[{"t":7,"e":"input","a":{"type":"hidden","name":"calStr","value":[{"t":2,"r":"calStr"}]}}]}," ",{"t":7,"e":"ux-modal","a":{"widthPercentage":"60","heightPercentage":"80","class":"light-theme ticket-info-modal","modalId":"showTicketInfo"},"f":[{"t":7,"e":"ux-row","a":{"class":"section-title collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Opened Support Ticket"]}," ",{"t":7,"e":"div","f":["Ticket Number: ",{"t":2,"r":"ticketNumber"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"section-details clearfix"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"input-label"},"f":["Nature of Feedback"]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"r":"ticketType"}]}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"input-label"},"f":["Area of Feedback"]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"r":"ticketArea"}]}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"input-label"},"f":["Your Comments"]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"r":"ticketComments"}]}]}," ",{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"div","a":{"class":"input-label"},"f":["Attachment"]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}]},"f":[{"t":2,"r":"text"}]},{"t":7,"e":"br"}],"r":"ticketAttachments"}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"widthPercentage":"60","class":"light-theme appointment-modal","modalId":"changeInstallationAppointment"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"left-column"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Change ",{"t":2,"r":"appointmentType"}," Appointment"]}," ",{"t":7,"e":"div","f":["Service Type: ",{"t":2,"r":"appointmentService"}]}," ",{"t":7,"e":"div","f":["Service Number: ",{"t":2,"r":"appointmentServiceNum"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"section-details collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-5 small-12 v-normal-bottom left-column"},"f":[{"t":7,"e":"div","a":{"class":"v-large-top v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":[{"t":2,"r":"appointmentType"}," Address"]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"appointmentAddress"}]}],"n":50,"x":{"r":["appointmentAddress"],"s":"typeof _0===\"string\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"appointmentAddress"}]}}],"n":50,"x":{"r":["appointmentAddress"],"s":"typeof _0===\"object\""}}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Current ",{"t":2,"r":"appointmentType"}," Date"]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["moment","existingApptTimeSlot.dateNumber"],"s":"_0(_1,\"YYYYMMDD\",true).format(\"DD MMM YYYY\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Current ",{"t":2,"r":"appointmentType"}," Time"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"existingApptTimeSlot.localizedTextSlot"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-7 small-12 right-column p-large-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-date-time-picker","a":{"class":"v-large-top","numberOfMonthsAvailable":"1","minDate":[{"t":2,"r":"enabledDays.0"}],"defaultDate":[{"t":2,"r":"enabledDays.0"}],"selected_date":[{"t":2,"r":"defaultDay"}],"enabledDays":[{"t":2,"r":"enabledDays"}],"timeSlotsOptions":[{"t":2,"r":"timeSlotsOptions"}],"timeSelectionType":"appointment-change","showHeadingText":"true"}}],"n":50,"r":"displayCalendar"}," ",{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-button","a":{"class":["round light margin-zero right ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["isInstalltionDateSlotSelected","isInstalltionTimeSlotSelected"],"s":"_0&&_1"}}],"onclick":"onChangeInstallationAppointment","text":"Change"}}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme confirm-installation-appointment","modalId":"confirmInstallationAppointment"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Change ",{"t":2,"r":"appointmentType"}," Appointment"]}," ",{"t":7,"e":"div","f":["Confirm the change details for your ",{"t":2,"r":"appointmentType"}," appointment"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Service Type"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"appointmentService"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Service Number"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"appointmentServiceNum"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"appointmentType"}," Address"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"appointmentAddress"}]}],"n":50,"x":{"r":["appointmentAddress"],"s":"typeof _0===\"string\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"appointmentAddress"}]}}],"n":50,"x":{"r":["appointmentAddress"],"s":"typeof _0===\"object\""}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Current ",{"t":2,"r":"appointmentType"}," date & time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["moment","existingApptTimeSlot.dateNumber"],"s":"_0(_1,\"YYYYMMDD\",true).format(\"DD-MM-YYYY\")"}},{"t":7,"e":"br"},{"t":2,"r":"existingApptTimeSlot.localizedTextSlot"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["New ",{"t":2,"r":"appointmentType"}," date & time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["moment","selectedDate"],"s":"_0(_1).format(\"DD-MM-YYYY\")"}},{"t":7,"e":"br"},{"t":2,"r":"selectedTime"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"ux-checkbox","a":{"checked":[{"t":2,"r":"isTncAgreed"}],"class":"left"},"f":["I agree to the ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"initData.tncLink"}],"target":"_blank"},"f":[{"t":2,"r":"initData.tandcText"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["round light right margin-zero ",{"t":4,"f":["disabled"],"n":51,"r":"isTncAgreed"}],"onclick":"onSubmitInstallationAppointment","text":"Submit"}}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"650","class":"light-theme","modalId":"appointmentSuccessModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Appointment confirmation"]}," ",{"t":7,"e":"div","f":["Thank you! Your new installation appointment has been confirmed."]}," ",{"t":7,"e":"div","f":["The appointment ID is ",{"t":7,"e":"strong","f":[{"t":2,"r":"newAppointmentId"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Service Type"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"appointmentService"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Service Number"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"appointmentServiceNum"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Date"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["moment","selectedDate"],"s":"_0(_1).format(\"DD-MM-YYYY\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"selectedTime"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"class"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-center v-normal-bottom"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"addNewAppointmentToCalendar","class":"margin-zero","event":[{"t":2,"r":"currentEvent"}]},"f":["Add to Calendar"]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"section-header v-normal-bottom"},"f":["What Next?"]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ul","f":[{"t":7,"e":"li","f":["View your transaction history"]}," ",{"t":7,"e":"li","f":["Navigate to your ",{"t":7,"e":"ux-anchor","f":["Transaction History "]},"to view this appointment, and all other transactions you have with Singtel."]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 left-column"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-top v-small-bottom"},"f":["Things to remember to do"]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ul","f":[{"t":7,"e":"li","f":["Please get ready your proof of identification, a signed letter of authorisation if needed, equipment if applicable during your shop appointment (copy to be written during interface sprint)"]}," ",{"t":7,"e":"li","f":["Email confirmation"]}," ",{"t":7,"e":"li","f":["You will receive an email to confirm this appointment."]}]}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"cancelAppointment"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Cancel Appointment"]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-bottom"},"f":["Service Type: ",{"t":2,"r":"events.0.installation.service"}]}," ",{"t":7,"e":"div","f":["Service Number: ",{"t":2,"r":"events.0.installation.serviceNumber"}]}],"n":50,"x":{"r":["type"],"s":"_0!==\"Shop\""}}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"x":{"r":["type"],"s":"_0!==\"Shop\""}}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":["Are you sure you want to cancel this appointment?"]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Store"]}],"n":50,"x":{"r":["type"],"s":"_0===\"Shop\""}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Installtion Address"]}],"x":{"r":["type"],"s":"_0===\"Shop\""}}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":4,"f":[{"t":2,"r":"events.0.address"}],"n":50,"x":{"r":["events.0.address"],"s":"typeof _0===\"string\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"events.0.address"}]}}],"n":50,"x":{"r":["events.0.address"],"s":"typeof _0===\"object\""}}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top input-label-bold"},"f":["Date"]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":2,"x":{"r":["moment","date"],"s":"_0(_1).format(\"ddd, DD MMMM YYYY\")"}}]}],"n":50,"x":{"r":["type"],"s":"_0===\"Shop\""}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":2,"x":{"r":["moment","date"],"s":"_0(_1).format(\"DD-MM-YYYY\")"}}]}],"x":{"r":["type"],"s":"_0===\"Shop\""}}," ",{"t":7,"e":"div","a":{"class":"v-normal-top input-label-bold"},"f":["Time"]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":2,"r":"events.0.installation.shopApointmentTime"}]}],"n":50,"x":{"r":["type"],"s":"_0===\"Shop\""}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":2,"r":"events.0.installation.installationTime"}]}],"x":{"r":["type"],"s":"_0===\"Shop\""}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"ux-checkbox","a":{"checked":[{"t":2,"r":"isTncAgreed"}],"class":"left"},"f":["I agree to the ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"initData.tncLink"}],"target":"_blank"},"f":[{"t":2,"r":"initData.tandcText"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-button","a":{"class":["round light margin-zero right",{"t":4,"f":[" disabled"],"n":51,"r":"isTncAgreed"}],"onclick":"cancelConfimation","text":"Confirm"}}]}]}],"n":53,"r":"currentAppointment"}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"cancelConfimationModal"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"type"}," appointment cancelled"]}," ",{"t":7,"e":"div","f":["Your ",{"t":2,"r":"type"}," appointment has been cancelled."]}]}]}],"n":53,"r":"currentAppointment"}]}," ",{"t":7,"e":"ux-modal","a":{"width":"800","class":"light-theme errorModal","modalId":"errorModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header","level":"2"},"f":[{"t":2,"r":"ConfigStrings.genericError.header"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"ConfigStrings.errors.genericError"}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"widthPercentage":"60","heightPercentage":"90","class":"light-theme","modalId":"changeShopAppointment"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Change Appointment"]}," ",{"t":7,"e":"div","f":["Service Type: ",{"t":2,"r":"appointmentService"}]}," ",{"t":7,"e":"div","f":["Service Number: ",{"t":2,"r":"appointmentServiceNum"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-select-pickup-location","a":{"pickupData":[{"t":3,"r":"initData.pickupSingtelStore"}]}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-top collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"calendar-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"ux-singtel-store-appointment"}],"n":50,"x":{"r":["initData.qnomyIframeUrl","initData.storeId","initData.regionId","initData.appointmentTypeId"],"s":"_0&&_1&&_2&&_3"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-modal","a":{"widthPercentage":"60","class":"light-theme order-details-modal","modalId":"showOrderDetails"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Your Order: ",{"t":2,"r":"id"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"delivery-info"},"f":[{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header"},"f":["Delivery"]}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"r":"deliveryDescription"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 large-4 customer-info"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"input-label"},"f":["Delivery Address"]}," ",{"t":7,"e":"ux-singtel-address","a":{"addressType":"timeline","address":[{"t":2,"r":"deliveryAddress"}],"class":"body"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 large-4 customer-info"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"input-label"},"f":["Delivery Date & Time"]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"x":{"r":["moment","deliveryStartDateAndTime"],"s":"_0(_1).format(\"DD-MM-YYYY\")"}}]}," ",{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":2,"r":"deliveryTimeSlot"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"r":"deliveryAddress"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"delivery-info"},"f":[{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"subsection-header"},"f":["Installation"]}]}," ",{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"r":"installationDescription"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 large-4 customer-info"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"input-label"},"f":["Installation Address"]}," ",{"t":7,"e":"ux-singtel-address","a":{"class":"body","addressType":"timeline","addres":[{"t":2,"r":"installationAddress"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6 large-4 customer-info"},"f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"input-label"},"f":["Installation Date"]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":7,"e":"div","a":{"class":"date"},"f":["Installation (Net Link Trust) : ",{"t":7,"e":"span","a":{"class":"value"},"f":[{"t":2,"x":{"r":["RactiveHelpers","installation.netLinkDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}]}],"n":50,"r":"installation.netLinkDate"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body"},"f":[{"t":7,"e":"div","a":{"class":"date"},"f":["Installation (Singtel) : ",{"t":7,"e":"span","a":{"class":"value"},"f":[{"t":2,"x":{"r":["RactiveHelpers","installation.wfmAppointmentDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}]}],"n":50,"r":"installation.wfmAppointmentDate"}],"n":53,"x":{"r":["getInstallationDate"],"s":"_0()"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":50,"r":"installationAddress"}]}]}," ",{"t":7,"e":"div","a":{"class":"order-summary-content v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"order-info"},"f":[{"t":7,"e":"div","a":{"class":"body-light"},"f":[{"t":2,"r":"orderDescription"}]}," ",{"t":7,"e":"ux-order-summary-grid","a":{"header":[{"t":2,"r":"shoppingCartHeader"}],"datamodel":[{"t":2,"r":"orderData"}]}}," ",{"t":7,"e":"ux-order-summary-singtel","a":{"class":"v-large-top","datamodel":[{"t":2,"r":"orderData"}]}}]}]}]}]}]}],"n":53,"r":"orderData.order"}," ",{"t":7,"e":"ux-modal","a":{"widthPercentage":"60","class":"light-theme appointment-modal","modalId":"changeFsDelAppointment"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"left-column"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Change Delivery Date & Time"]}," ",{"t":7,"e":"div","f":["Service Type: ",{"t":2,"x":{"r":["RactiveHelpers","currentEvent.lineOfBusiness"],"s":"_0.getServicePropLob(_1,\"name\")"}}]}," ",{"t":7,"e":"div","f":["Service Number: ",{"t":2,"r":"currentEvent.serviceNumber"}," (on ",{"t":2,"r":"currentEvent.planName"}," plan)"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"section-details collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-5 small-12 v-normal-bottom left-column"},"f":[{"t":7,"e":"div","a":{"class":"v-large-top v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Delivery Address"]}," ",{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"currentEvent.fsAppointment.implPhysicalAddress"}]}}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Current Delivery Date"]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["RactiveHelpers","currentEvent.fsAppointment.deliveryDateMilli"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM YYYY\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":""},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Current Delivery Time"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"currentEvent.fsAppointment.deliverySlot"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-7 small-12 right-column p-large-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-date-time-picker","a":{"class":"v-large-top","numberOfMonthsAvailable":"1","minDate":[{"t":2,"r":"enabledDays.0"}],"defaultDate":[{"t":2,"r":"enabledDays.0"}],"selected_date":[{"t":2,"r":"defaultDay"}],"enabledDays":[{"t":2,"r":"enabledDays"}],"timeSlotsOptions":[{"t":2,"r":"timeSlotsOptions"}],"timeSelectionType":"appointment-change","showHeadingText":"true"}}],"n":50,"r":"displayCalendar"}," ",{"t":7,"e":"div","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"ux-button","a":{"class":["round light margin-zero right ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["isInstalltionDateSlotSelected","isInstalltionTimeSlotSelected"],"s":"_0&&_1"}}],"onclick":"onChangeFsDelAppointment","text":"Change"}}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme confirm-fsdel-appointment","modalId":"confirmFsDelAppointment"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Change Delivery Date & Time"]}," ",{"t":7,"e":"div","f":["Confirm the change details for your Delivery appointment"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Service Type"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","currentEvent.lineOfBusiness"],"s":"_0.getServicePropLob(_1,\"name\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Service Number"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"currentEvent.serviceNumber"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Delivery Address"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"currentEvent.fsAppointment.implPhysicalAddress"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Current Delivery date & time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","currentEvent.fsAppointment.deliveryDateMilli"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM YYYY\")"}},{"t":7,"e":"br"},{"t":2,"r":"currentEvent.fsAppointment.deliverySlot"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["New Delivery date & time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["moment","selectedDate"],"s":"_0(_1).format(\"DD MMM YYYY\")"}},{"t":7,"e":"br"},{"t":2,"r":"selectedTime"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"ux-checkbox","a":{"checked":[{"t":2,"r":"isTncAgreed"}],"class":"left"},"f":["I agree to the ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"initData.tncLink"}],"target":"_blank"},"f":[{"t":2,"r":"initData.tandcText"}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["round light right margin-zero ",{"t":4,"f":["disabled"],"n":51,"r":"isTncAgreed"}],"onclick":"onSubmitFsDelAppointment","text":"Submit"}}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme success-fsdel-appointment","modalId":"changeFsDelAppointmentSuccessModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Delivery Appointment confirmation"]}," ",{"t":7,"e":"div","f":["Thank you! Your new delivery appointment has been confirmed."]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Service Type"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","currentEvent.lineOfBusiness"],"s":"_0.getServicePropLob(_1,\"name\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Service Number"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"currentEvent.serviceNumber"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Delivery Address"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"currentEvent.fsAppointment.implPhysicalAddress"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Current Delivery date & time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","currentEvent.fsAppointment.deliveryDateMilli"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM YYYY\")"}},{"t":7,"e":"br"},{"t":2,"r":"currentEvent.fsAppointment.deliverySlot"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["New Delivery date & time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["moment","selectedDate"],"s":"_0(_1).format(\"DD MMM YYYY\")"}},{"t":7,"e":"br"},{"t":2,"r":"selectedTime"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"section-header v-normal-bottom"},"f":["What Next?"]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ul","f":[{"t":7,"e":"li","f":["View your transaction history"]}," ",{"t":7,"e":"li","f":["Navigate to your ",{"t":7,"e":"ux-anchor","f":["Transaction History "]},"to view this appointment, and all other transactions you have with Singtel."]}]}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"widthPercentage":"60","class":"light-theme","modalId":"changeFsPopStationAppointment","selectedOption":"pop-station"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"left-column"},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Change Collection Address & Date"]}," ",{"t":7,"e":"div","f":["Service Type: ",{"t":2,"x":{"r":["RactiveHelpers","currentEvent.lineOfBusiness"],"s":"_0.getServicePropLob(_1,\"name\")"}}]}," ",{"t":7,"e":"div","f":["Service Number: ",{"t":2,"r":"currentEvent.serviceNumber"}," (on ",{"t":2,"r":"currentEvent.planName"}," plan)"]}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider modal-full-length-panel-divider"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"section-details collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Collection Address"]}," ",{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"currentEvent.fsAppointment.implPhysicalAddress"}]}}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ux-button","a":{"class":"round light margin-zero left","onclick":"onChangeFsPopAddress","text":"Change"}}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Current Collection Date"]}," ",{"t":7,"e":"div","f":[{"t":2,"x":{"r":["RactiveHelpers","currentEvent.fsAppointment.deliveryDateMilli"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM YYYY\")"}}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ux-button","a":{"class":"round light margin-zero left","onclick":"onChangeFsPopStationDate","text":"Change"}}]}]}]}],"n":50,"x":{"r":["isChangeFsPopAddress","isChangeFsPopDate"],"s":"!_0&&!_1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["isChangeFsPopAddress"],"s":"_0"},"f":[{"t":7,"e":"ux-select-pickup-location","a":{"pickupData":[{"t":3,"r":"initData.pickupPopupStation"}],"popStationsList":[{"t":2,"r":"timeLineData.popStations"}],"popStations":[{"t":2,"r":"timeLineData.popStations"}]},"f":[]}," ",{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"round left v-large","onclick":"onNewPopStationSelected","text":"Change"}}],"n":50,"r":"changePopStation.address"}]},{"t":4,"n":50,"x":{"r":["isChangeFsPopAddress","isChangeFsPopDate"],"s":"(!(_0))&&(_1)"},"f":[" ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":["Collection Address"]}," ",{"t":4,"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"changePopStation.address"}],"addressType":"popStationAPI"},"f":[]}],"n":50,"r":"changePopStation.address"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"currentEvent.fsAppointment.implPhysicalAddress"}]}}],"r":"changePopStation.address"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6"},"f":[{"t":4,"f":[{"t":7,"e":"ux-date-time-picker","a":{"class":"v-large-top","numberOfMonthsAvailable":"1","minDate":[{"t":2,"r":"enabledDays.0"}],"defaultDate":[{"t":2,"r":"enabledDays.0"}],"selected_date":[{"t":2,"r":"defaultDay"}],"enabledDays":[{"t":2,"r":"enabledDays"}],"timeSlotsOptions":[{"t":2,"r":"timeSlotsOptions"}],"timeSelectionType":"appointment-change","showHeadingText":"true"}}],"n":50,"r":"displayCalendar"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["round light margin-zero left ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["isInstalltionDateSlotSelected","isInstalltionTimeSlotSelected"],"s":"_0&&_1"}}],"onclick":"onChangePopStationAppointment","text":"Change"}}]}]}]}],"x":{"r":["isChangeFsPopAddress","isChangeFsPopDate"],"s":"!_0&&!_1"}}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme confirm-fsdel-appointment","modalId":"confirmFsPopStationAppointment"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Change Collection Address & Date"]}," ",{"t":7,"e":"div","f":["Confirm the change details for your Collection appointment"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Service Type"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","currentEvent.lineOfBusiness"],"s":"_0.getServicePropLob(_1,\"name\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Service Number"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"currentEvent.serviceNumber"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Current Collection Address"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"currentEvent.fsAppointment.implPhysicalAddress"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["New Collection Address"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"changePopStation.address"}],"addressType":"popStationAPI"},"f":[]}]}]}],"n":50,"r":"changePopStation.address"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Collection Address"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"currentEvent.fsAppointment.implPhysicalAddress"}]}}]}]}],"r":"changePopStation.address"}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Current Collection date & time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","currentEvent.fsAppointment.deliveryDateMilli"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM YYYY\")"}},{"t":7,"e":"br"},{"t":2,"r":"currentEvent.fsAppointment.deliverySlot"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["New Collection date & time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["moment","selectedDate"],"s":"_0(_1).format(\"DD MMM YYYY\")"}},{"t":7,"e":"br"},{"t":2,"r":"selectedTime"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-8"},"f":[{"t":7,"e":"ux-checkbox","a":{"checked":[{"t":2,"r":"changePopStation.isTncAgreed"}],"class":"left"},"f":["I agree to the ",{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"initData.tncLink"}],"target":"_blank"},"f":[{"t":2,"r":"initData.tandcText"}]}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["round light right margin-zero ",{"t":4,"f":["disabled"],"n":51,"r":"changePopStation.isTncAgreed"}],"onclick":"onSubmitPopStationAppointment","text":"Submit"}}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme success-fspopstation-appointment","modalId":"changeFsPopStationAppointmentSuccessModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Collection Appointment confirmation"]}," ",{"t":7,"e":"div","f":["Thank you! Your new collection appointment has been confirmed."]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Service Type"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","currentEvent.lineOfBusiness"],"s":"_0.getServicePropLob(_1,\"name\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Service Number"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"r":"currentEvent.serviceNumber"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Current Collection Address"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"currentEvent.fsAppointment.implPhysicalAddress"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["New Collection Address"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"changePopStation.address"}],"addressType":"popStationAPI"},"f":[]}]}]}],"n":50,"r":"changePopStation.address"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Collection Address"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-singtel-address","a":{"class":"text","address":[{"t":2,"r":"currentEvent.fsAppointment.implPhysicalAddress"}]}}]}]}],"r":"changePopStation.address"}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Current Collection date & time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["RactiveHelpers","currentEvent.fsAppointment.deliveryDateMilli"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM YYYY\")"}},{"t":7,"e":"br"},{"t":2,"r":"currentEvent.fsAppointment.deliverySlot"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["New Collection date & time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["moment","selectedDate"],"s":"_0(_1).format(\"DD MMM YYYY\")"}},{"t":7,"e":"br"},{"t":2,"r":"selectedTime"}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"section-header v-normal-bottom"},"f":["What Next?"]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ul","f":[{"t":7,"e":"li","f":["View your transaction history"]}," ",{"t":7,"e":"li","f":["Navigate to your ",{"t":7,"e":"ux-anchor","f":["Transaction History "]},"to view this appointment, and all other transactions you have with Singtel."]}]}]}]}]}]}]}]};
this["ux-timer-popup"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-timer-popup"},"f":[{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"timerModalPopup","hideCloseIcon":"true"},"f":[{"t":7,"e":"ux-row","a":{"class":"section-title collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"timerModalData.header"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse error v-normal-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":3,"r":"timerModalData.description"}]},"f":[]}]}]}],"n":50,"r":"timerModalData.description"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":3,"r":"timerDurationDesc"}]}]}],"n":51,"r":"timerDuration"}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":["margin-zero round expand-for-mobile ",{"t":4,"f":["disabled"],"n":50,"r":"selected"}],"onclick":"processOrderNow","text":[{"t":4,"f":[{"t":2,"r":"timerModalData.buttonTxt"}],"n":50,"r":"timerModalData.buttonTxt"},{"t":4,"n":51,"f":["Continue"],"r":"timerModalData.buttonTxt"}]},"f":[]}]}]}]}]}]};
this["ux-togglestate-button"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-togglestate-button ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}," ",{"t":4,"f":["v-",{"t":2,"r":"bottomSpacing"},"-bottom"],"n":50,"r":"bottomSpacing"}]},"f":[{"t":7,"e":"div","a":{"class":["select-phone-button ",{"t":2,"r":"nextButtonCSSState"}," small-only-text-center"]},"f":[{"t":7,"e":"ux-button","a":{"class":["button round ",{"t":4,"f":["disabled"],"n":50,"r":"nextButtonState"}],"onclick":"doNavigateView","text":[{"t":2,"r":"selectButton.text"}]}}]}]}]};
this["ux-top-bar-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-top-bar-singtel clearfix ",{"t":4,"f":["sticky"],"n":50,"r":"isSticky"},{"t":4,"f":[" offsetTop"],"n":50,"r":"offsetTop"}]},"f":[{"t":7,"e":"div","a":{"class":"row v-normal-bottom subsection-title"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["small-offset-1"],"n":50,"x":{"r":["i"],"s":"_0==0"}}," small-4 ",{"t":4,"f":["medium-8"],"n":50,"r":"isRedMembership"}," columns"]},"f":[{"t":2,"r":"label"}]}],"i":"i","r":"leftitems"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"small-2 columns"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["text-center"],"n":50,"r":"isRedMembership"},{"t":4,"n":51,"f":["text-right"],"r":"isRedMembership"}]},"f":[{"t":2,"r":"label"}]}," ",{"t":7,"e":"div","a":{"class":"icon-btn show-tooltip"},"v":{"click":{"n":[{"t":4,"f":["showTooltip"],"n":50,"r":"tooltip"}],"d":[]}},"f":[{"t":7,"e":"ux-icon","a":{"type":"help-filled","size":"sm"}}]}," ",{"t":7,"e":"div","a":{"class":"tooltip"},"f":[{"t":2,"r":"tooltip"}]}]}],"r":"rightitems"}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}]}]};
this["ux-tout-singtel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-tout-singtel ",{"t":4,"f":["v-",{"t":2,"r":"leftSpacing"},"-left"],"n":50,"r":"leftSpacing"}," ",{"t":4,"f":["v-",{"t":2,"r":"rightSpacing"},"-right"],"n":50,"r":"rightSpacing"}," ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}," ",{"t":4,"f":["v-",{"t":2,"r":"bottomSpacing"},"-bottom"],"n":50,"r":"bottomSpacing"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["row v-normal-top ",{"t":2,"r":"theme"}],"style":[{"t":4,"f":["background-color:",{"t":2,"r":"bgColor"}],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"div","a":{"class":"ux-tout-singtel-image-holder"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"img.src"}],"alt":[{"t":2,"r":"img.alt"}]}}]}," ",{"t":7,"e":"div","a":{"class":"ux-tout-singtel-text-holder v-medium-left"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"title"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["body ",{"t":4,"f":["normal-line-height"],"n":50,"r":"normalLineHeight"}," ",{"t":4,"f":["v-normal-top"],"n":50,"r":"spacing"}]},"f":[{"t":2,"r":"text"}]}],"n":50,"r":"text"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"}}," ",{"t":7,"e":"a","a":{"href":[{"t":2,"r":"link"}]},"f":[{"t":2,"r":"linkText"}]}],"n":50,"r":"link"}],"n":50,"r":"linkText"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"}}," ",{"t":7,"e":"a","a":{"href":[{"t":2,"r":"link2"}]},"f":[{"t":2,"r":"linkText2"}]}],"n":50,"r":"link2"}],"n":50,"r":"linkText2"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"}}," ",{"t":7,"e":"a","a":{"href":[{"t":2,"r":"link3"}]},"f":[{"t":2,"r":"linkText3"}]}],"n":50,"r":"link3"}],"n":50,"r":"linkText3"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"}}," with ",{"t":4,"f":[{"t":2,"r":"planName"},{"t":4,"f":[","],"n":50,"x":{"r":["i","plans.length"],"s":"_0<(_1-1)"}},{"t":4,"n":51,"f":["."],"x":{"r":["i","plans.length"],"s":"_0<(_1-1)"}}],"n":52,"i":"i","r":"plans"}],"n":50,"r":"forPlans"}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-tradein-modal"] = {"v":3,"t":[{"t":7,"e":"ux-modal","a":{"width":"580","class":"ux-tradein-modal light-theme","icon":"close-line","modalId":"tradeInModal","hideTitle":"true"},"f":[{"t":7,"e":"div","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"p","a":{"class":"cart-desc v-small-top small-only-text-left"},"f":[{"t":2,"r":"desc"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top body-text clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"select-label v-medium-bottom"},"f":["Brand"]}," ",{"t":7,"e":"ux-select","a":{"id":"brandSelect","options":[{"t":2,"r":"brands"}],"showSelectedValue":"true","onChangeEvent":"onBrandsChange","defaultOption":"Select Brand"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"select-label v-medium-bottom"},"f":["Phone Model"]}," ",{"t":7,"e":"ux-select","a":{"id":"modelSelect","options":[{"t":2,"r":"models"}],"showSelectedValue":"true","onChangeEvent":"onModelsChange","defaultOption":"Select Model","disabled":[{"t":2,"r":"modelDropdownStatus"}]}}]}," ",{"t":7,"e":"ux-col","a":{"class":"hide-for-small-only v-normal-bottom"},"f":[{"t":7,"e":"hr"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only panel-divider"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6 v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":["Trade-in Value"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["RactiveHelpers","tradeinValue"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":"round","onclick":"onSubmitModal"},"f":["Submit"]}," ",{"t":7,"e":"ux-col","f":[]}]}]}]}]};
this["ux-tv-carousel"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-tv-carousel"},"f":[{"t":4,"f":[" ",{"t":7,"e":"div","a":{"class":"swiper-container"},"f":[{"t":7,"e":"div","a":{"class":"swiper-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"swiper-slide"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"carousel-item-cover"},"v":{"click":{"n":"selectItem","d":[{"t":2,"r":"num"}]}},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"videoThumbnail"}],"alt":[{"t":2,"r":"videoThumbnail"}]}}]}," ",{"t":7,"e":"span","a":{"class":"carousel-video-play-btn"},"v":{"click":{"n":"selectItem","d":[" ",{"t":2,"r":"num"}]}}}],"n":50,"x":{"r":["imageOrVideo"],"s":"_0===\"video\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["imageOrVideo"],"s":"_0===\"image\""},"f":[{"t":7,"e":"span","a":{"class":"carousel-item-cover"},"v":{"click":{"n":"selectImage","d":[{"t":2,"r":"num"}]}},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"imagePath"}],"alt":[{"t":2,"r":"imageAltText"}]}}]}]}],"x":{"r":["imageOrVideo"],"s":"_0===\"video\""}}]}],"n":52,"i":"num","r":"tvCarouselModelList"}]}," ",{"t":7,"e":"div","a":{"class":"swiper-button-next"}}," ",{"t":7,"e":"div","a":{"class":"swiper-button-prev"}}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}," ",{"t":7,"e":"ux-modal","a":{"width":"1068","containerClass":"carousel-video-modal","class":"light-theme","displayState":[{"t":2,"r":"currentItem.displayState"}]},"f":[{"t":4,"f":[{"t":7,"e":"iframe","a":{"id":"ytplayer","class":"carousel-item-video","type":"text/html","src":[{"t":2,"r":"currentItem.videoURL"}],"frameborder":"0"}}],"n":50,"x":{"r":["currentItem.type"],"s":"_0===\"video\""}}]}," ",{"t":7,"e":"ux-modal","a":{"width":"1068","class":"light-theme","modal_id":"imageTypeModal"},"f":[{"t":7,"e":"ux-header","a":{"level":"1","class":"section-header v-medium-left v-large-bottom"},"f":[{"t":2,"r":"currentItem.imageAltText"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-3"],"n":50,"x":{"r":["currentItem.imagePath","currentItem.mImagePath"],"s":"_0===_1"}},{"t":4,"n":51,"f":["large-6"],"x":{"r":["currentItem.imagePath","currentItem.mImagePath"],"s":"_0===_1"}}," small-12"]},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"currentItem.imagePath"}],"alt":[{"t":2,"r":"currentItem.imageAltText"}],"class":"carousel-item-cover v-normal-bottom"}}]}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-9"],"n":50,"x":{"r":["currentItem.imagePath","currentItem.mImagePath"],"s":"_0===_1"}},{"t":4,"n":51,"f":["large-6"],"x":{"r":["currentItem.imagePath","currentItem.mImagePath"],"s":"_0===_1"}}," small-12"]},"f":[{"t":7,"e":"ux-header","a":{"level":"5","class":"v-normal-left v-normal-right"},"f":[{"t":3,"r":"currentItem.description"}]}]}]}]}]};
this["ux-tv-channel-epg"] = {"v":3,"t":[{"t":7,"e":"div","o":"loadMask","f":[{"t":7,"e":"div","a":{"class":"ux-tv-channel-epg"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"id":"header-section","class":["header-section large-12 ",{"t":4,"f":["stick"],"n":50,"r":"sticky"}]},"m":[{"t":4,"f":["style=\"width:",{"t":2,"r":"stickyWidth"},"px;top:",{"t":2,"r":"headerTop"},"px\""],"n":50,"r":"sticky"}],"f":[{"t":7,"e":"ux-row","a":{"class":"filter-header p-normal-left"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"main-header v-normal-bottom v-medium-top"},"f":[{"t":2,"r":"headingText"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":3,"r":"headingDescription"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-12 p-normal-left medium-6 p-normal-right search-container"},"f":[{"t":7,"e":"ux-input-box","a":{"class":"medium-12 small-12","type":"text","placeholder":"Search by channel name","value":[{"t":2,"r":"searchFilter"}],"onInputEvent":"searchChannel"},"f":[]}," ",{"t":7,"e":"ux-icon","a":{"size":"l","type":"search-small","outerClass":"search-icon-input-background"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"day-selector-wrap"},"f":[{"t":7,"e":"ul","a":{"class":"medium-block-grid-7 small-block-grid-4 day-selector"},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"class":[{"t":4,"f":["selected"],"n":50,"r":"selectState"}," cursor"]},"v":{"tap":{"n":"selectDay","d":[{"t":2,"r":"completeDate"}]}},"f":[{"t":7,"e":"div","a":{"class":"day"},"f":[{"t":2,"r":"dayOfWeek"}]}," ",{"t":7,"e":"div","a":{"class":"date"},"f":[{"t":2,"r":"dateStr"}]}]}],"r":"daysToShow"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"day-slider"},"f":[{"t":7,"e":"div","a":{"class":"button-prev "},"f":[{"t":7,"e":"span","a":{"class":"icon icon-chevron-left"},"v":{"tap":"onNextDay"}}]}," ",{"t":7,"e":"div","a":{"class":"day-selector-wrap small-12"},"f":[{"t":7,"e":"ul","a":{"id":"mob-day-container","class":"day-selector"},"f":[{"t":4,"f":[{"t":7,"e":"li","a":{"id":"mob-day-selector","class":[{"t":4,"f":["selected"],"n":50,"r":"selectState"}," cursor"]},"v":{"tap":{"n":"selectDay","d":[{"t":2,"r":"completeDate"}]}},"f":[{"t":7,"e":"div","a":{"class":"day"},"f":[{"t":2,"r":"dayOfWeek"}]}," ",{"t":7,"e":"div","a":{"class":"date"},"f":[{"t":2,"r":"dateStr"}]}]}],"r":"daysToShow"}]}]}," ",{"t":7,"e":"div","a":{"class":"button-next "},"f":[{"t":7,"e":"span","a":{"class":"icon icon-chevron-right"},"v":{"tap":"onPrevDay"}}]}]}]}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-panel","a":{"class":"time-panel margin-zero"},"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"div","a":{"class":"timetable channelList"},"f":[{"t":7,"e":"div","a":{"class":["slider ",{"t":4,"f":["stick"],"n":50,"r":"sticky"}]},"m":[{"t":4,"f":["style=\"width:",{"t":2,"r":"stickyWidth"},"px;top:",{"t":2,"x":{"r":["stickTop","headerTop"],"s":"_0+_1"}},"px\""],"n":50,"r":"sticky"}],"f":[{"t":7,"e":"div","a":{"class":"button-prev"},"f":[{"t":7,"e":"div","a":{"class":"ux-icon"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-chevron-left"},"v":{"tap":"onNext"}}]}]}," ",{"t":7,"e":"div","a":{"class":"button-next"},"f":[{"t":7,"e":"div","a":{"class":"ux-icon"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-chevron-right"},"v":{"tap":"onPrev"}}]}]}]}," ",{"t":7,"e":"div","a":{"id":"epg-time","class":[{"t":4,"f":["stick"],"n":50,"r":"sticky"}]},"m":[{"t":4,"f":["style=\"width:",{"t":2,"r":"stickyWidth"},"px;top:",{"t":2,"x":{"r":["stickTop","headerTop"],"s":"_0+_1"}},"px\""],"n":50,"r":"sticky"}],"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"span","a":{"class":"time-label"},"f":[{"t":2,"r":"timeOfDay"}]}]}],"r":"timeToShow"}]}]}," ",{"t":7,"e":"div","a":{"id":"list-content"},"f":[{"t":7,"e":"div","a":{"class":"aside"},"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"div","a":{"class":["channel-desc ",{"t":4,"f":["medium-7"],"n":50,"r":"displayImage"},{"t":4,"n":51,"f":["medium-12"],"r":"displayImage"}]},"f":[{"t":7,"e":"span","a":{"class":["row-heading ",{"t":4,"f":["medium-12"],"n":50,"x":{"r":["displayImage"],"s":"!_0"}}]},"f":["CH ",{"t":2,"r":"channelId"}]}," ",{"t":7,"e":"span","a":{"class":["v-small-top channel-title ",{"t":4,"f":["medium-12"],"n":50,"x":{"r":["displayImage"],"s":"!_0"}}]},"f":[{"t":2,"r":"title"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"medium-5"},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"image"}]}}]}],"n":50,"r":"displayImage"}]}],"n":50,"x":{"r":["display","tvProgramme","tvProgramme.length","catchUp"],"s":"_0&&_1&&_2>0&&!_3"}}],"r":"filteredChannelList"}]}]}," ",{"t":7,"e":"div","a":{"id":"section_des","class":"section"},"f":[{"t":7,"e":"ul","a":{"class":"room-timeline"},"f":[{"t":7,"e":"div","a":{"id":"epg-marker","style":["left:",{"t":2,"r":"epgMarker"}]}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"time-entry","style":["width:",{"t":2,"r":"width"},";left:",{"t":2,"r":"left"}]},"v":{"tap":{"n":"selectShow","d":[{"t":2,"r":"channel"},", ",{"t":2,"r":"programId"},", ",{"t":2,"r":"startDate"},", ",{"t":2,"r":"chIdToDisplay"}]}},"f":[{"t":7,"e":"div","a":{"class":"show-title"},"f":[{"t":2,"r":"name"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"episode"},"f":["Episode ",{"t":2,"r":"episode"}]}],"n":50,"r":"episode"}]}],"i":"index","r":"tvProgramme"}]}],"n":50,"x":{"r":["display","tvProgramme","tvProgramme.length","catchUp"],"s":"_0&&_1&&_2>0&&!_3"}}],"r":"filteredChannelList"}]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"div","a":{"class":"timetable channelList"},"f":[{"t":7,"e":"div","a":{"id":"mob_slider","class":["slider ",{"t":4,"f":["stick"],"n":50,"r":"sticky"}]},"m":[{"t":4,"f":["style=\"width:",{"t":2,"r":"stickyWidth"},"px;top:",{"t":2,"x":{"r":["stickTop","headerTop"],"s":"_0+_1"}},"px\""],"n":50,"r":"sticky"}],"f":[{"t":7,"e":"div","a":{"class":"button-prev"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-chevron-left"},"v":{"tap":"onNext"}}]}," ",{"t":7,"e":"div","a":{"class":"button-next"},"f":[{"t":7,"e":"span","a":{"class":"icon icon-chevron-right"},"v":{"tap":"onPrev"}}]}]}," ",{"t":7,"e":"div","a":{"class":["epg_time ",{"t":4,"f":["stick"],"n":50,"r":"sticky"}],"id":"epg-time"},"m":[{"t":4,"f":["style=\"width:",{"t":2,"r":"stickyWidth"},"px;top:",{"t":2,"x":{"r":["stickTop","headerTop"],"s":"_0+_1"}},"px\""],"n":50,"r":"sticky"}],"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"span","a":{"class":"time-label"},"f":[{"t":2,"r":"timeOfDay"}]}]}],"r":"timeToShow"}]}]}," ",{"t":7,"e":"div","a":{"class":"aside"},"f":[{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"div","f":[{"t":7,"e":"strong","f":["CH ",{"t":2,"r":"channelId"}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"title"}]}]}]}],"n":50,"x":{"r":["display","tvProgramme","tvProgramme.length","catchUp"],"s":"_0&&_1&&_2>0&&!_3"}}],"r":"filteredChannelList"}]}]}," ",{"t":7,"e":"div","a":{"id":"section_mob","class":"section"},"f":[{"t":7,"e":"ul","a":{"class":"room-timeline"},"f":[{"t":7,"e":"div","a":{"class":"epg_marker","id":"epg-marker","style":["left:",{"t":2,"r":"epgMarker"}]}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"time-entry","style":["width:",{"t":2,"r":"width"},";left:",{"t":2,"r":"left"}]},"v":{"tap":{"n":"selectShow","d":[{"t":2,"r":"channel"},", ",{"t":2,"r":"programId"},", ",{"t":2,"r":"startDate"},", ",{"t":2,"r":"chIdToDisplay"}]}},"f":[{"t":7,"e":"div","a":{"class":"show-title"},"f":[{"t":2,"r":"name"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"episode"},"f":["Episode ",{"t":2,"r":"episode"}]}],"n":50,"r":"episode"}]}],"i":"index","r":"tvProgramme"}]}],"n":50,"x":{"r":["display","tvProgramme","tvProgramme.length","catchup"],"s":"_0&&_1&&_2>0&&!_3"}}],"r":"filteredChannelList"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 small-12"},"f":[{"t":7,"e":"div","a":{"class":"section-description text-left"},"f":[{"t":2,"r":"errorMessage"}]}]}]}],"n":50,"x":{"r":["filteredChannelList","filteredChannelList.length"],"s":"_0&&_1===0"}}]}]}]}," ",{"t":7,"e":"div","a":{"id":"loader","class":"text-center v-large-bottom"}}]}," ",{"t":7,"e":"div","a":{"class":"ux-tv-channel-epg"},"f":[{"t":4,"f":[{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modalId":"programmeModal"},"f":[{"t":7,"e":"div","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"progTitle"}," ",{"t":7,"e":"span","f":[{"t":2,"r":"pg"}]}]}," ",{"t":7,"e":"div","f":["CH ",{"t":2,"r":"channelId"},", ",{"t":2,"r":"schedule"}]}]}," ",{"t":7,"e":"div","a":{"class":"section-details"},"f":[{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":4,"f":["Episode ",{"t":2,"r":"episode"},","],"n":50,"r":"episode"}," ",{"t":2,"r":"duration"}," minutes"]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":2,"r":"progDescription"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","f":["Director:"]}," ",{"t":7,"e":"span","f":[{"t":2,"r":"directors"}]}]}],"n":50,"r":"directors"}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","f":["Starring:"]}," ",{"t":7,"e":"span","f":[{"t":2,"r":"actors"}]}]}],"n":50,"r":"actors"}]}]}," ",{"t":7,"e":"div","a":{"class":"section-button v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"left text-left previous-show v-normal-top"},"f":[{"t":7,"e":"ux-anchor","a":{"href":"#","ontap":"navigateShow","channelid":[{"t":2,"r":"prevP.channelid"}],"programid":[{"t":2,"r":"prevP.programId"}],"starttime":[{"t":2,"r":"startDateTime"}],"channelId":[{"t":2,"r":"prevP.channelId"}]},"f":["Previously"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"prevTime"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"prevP.program.title"},{"t":4,"f":[", E",{"t":2,"r":"prevEpisode"}],"n":50,"r":"prevEpisode"}]}]}],"r":"prevP"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"right text-right next-show v-normal-top"},"f":[{"t":7,"e":"ux-anchor","a":{"href":"#","ontap":"navigateShow","channelid":[{"t":2,"r":"nextP.channelid"}],"programid":[{"t":2,"r":"nextP.programId"}],"starttime":[{"t":2,"r":"startDateTime"}],"channelId":[{"t":2,"r":"nextP.channelId"}]},"f":["Next"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"nextTime"}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"nextP.program.title"},{"t":4,"f":[", E",{"t":2,"r":"nextEpisode"}],"n":50,"r":"nextEpisode"}]}]}],"r":"nextP"}]}]}],"r":"progDetails"}]}]}]};
this["ux-tv-channel-listing"] = {"v":3,"t":[{"t":7,"e":"div","o":"loadMask","f":[{"t":7,"e":"div","a":{"class":"ux-tv-channel-listing"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"mobilePadding"},"f":[{"t":7,"e":"div","a":{"id":"header-section"},"f":[{"t":7,"e":"ux-panel","a":{"class":"margin-zero panel30"},"f":[{"t":7,"e":"div","a":{"class":"header-section large-12"},"f":[{"t":7,"e":"ux-row","a":{"class":"filter-header"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"main-header v-small-bottom v-medium-top"},"f":[{"t":2,"r":"headingText"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":3,"r":"headingDescription"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 padding-for-mobile v-small-bottom show-for-medium-up"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header show-result"},"f":["Language"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3 padding-for-mobile v-small-bottom show-for-medium-up"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header show-result"},"f":["Genre"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3 padding-for-mobile v-small-bottom show-for-medium-up"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header show-result"},"f":["Pack"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"id":"select-language"},"f":[{"t":7,"e":"ux-multi-select","a":{"showSelectedValue":"true",",":0,"class":"medium left","selected_value":[{"t":2,"r":"category"}],"options":[{"t":2,"r":"categories"}],"onChangeEvent":"selectCategory"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"id":"select-genre"},"f":[{"t":7,"e":"ux-multi-select","a":{"showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"genre"}],"options":[{"t":2,"r":"genreList"}],"onChangeEvent":"selectedGenre"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 v-normal-bottom"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-viewby-pack","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"pack"}],"options":[{"t":2,"r":"packList"}],"onChangeEvent":"filterPack"},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 select-tvtype text-center v-small-bottom"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["medium-6 ",{"t":4,"f":["removeRightCorner"],"n":50,"x":{"r":["idx"],"s":"_0===0"}},{"t":4,"n":51,"f":["removeLeftCorner"],"x":{"r":["idx"],"s":"_0===0"}}]},"f":[{"t":7,"e":"div","a":{"class":["choose-block cursor ",{"t":4,"f":["selected"],"n":50,"r":"selectState"}]},"v":{"tap":{"n":"selectTvType","d":[{"t":2,"r":"name"}]}},"f":[{"t":2,"r":"value"}]}]}],"n":52,"i":"idx","r":"tvTypeFilters"}],"n":50,"x":{"r":[],"s":"false"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 v-small-bottom"},"f":[{"t":7,"e":"div","a":{"id":"select-language"},"f":[{"t":7,"e":"ux-multi-select","a":{"showSelectedValue":"true",",":0,"class":"medium left","selected_value":[{"t":2,"r":"category"}],"label_value":"Language","options":[{"t":2,"r":"categories"}],"onChangeEvent":"selectCategory"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 v-small-bottom"},"f":[{"t":7,"e":"div","a":{"id":"select-genre"},"f":[{"t":7,"e":"ux-multi-select","a":{"showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"genre"}],"label_value":"Genre","options":[{"t":2,"r":"genreList"}],"onChangeEvent":"filterCategory"}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 v-small-bottom"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-viewby-pack","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"pack"}],"label_value":"Pack","options":[{"t":2,"r":"packList"}],"onChangeEvent":"filterPack"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 select-tvtype text-center v-small-bottom"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-6 ",{"t":4,"f":["removeRightCorner"],"n":50,"x":{"r":["idx"],"s":"_0===0"}},{"t":4,"n":51,"f":["removeLeftCorner"],"x":{"r":["idx"],"s":"_0===0"}}]},"f":[{"t":7,"e":"div","a":{"class":["choose-block cursor ",{"t":4,"f":["selected"],"n":50,"r":"selectState"}]},"v":{"tap":{"n":"selectTvType","d":[{"t":2,"r":"name"}]}},"f":[{"t":2,"r":"value"}]}]}],"n":52,"i":"idx","r":"tvTypeFilters"}],"n":50,"x":{"r":[],"s":"false"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4 small-12 "},"f":[{"t":7,"e":"div","a":{"class":"section-description"},"f":[{"t":2,"r":"broadcastCount"}," Broadcast channel(s) and ",{"t":2,"r":"catchUpCount"}," Catch-up channel(s)"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-2 small-12"},"f":[{"t":7,"e":"div","a":{"class":"section-description catchUp"},"f":[{"t":7,"e":"span","a":{"class":"catch-up"}},{"t":7,"e":"span","f":["On Demand"]}]}]}]}],"n":50,"x":{"r":["displayCatchUp"],"s":"_0&&false"}}]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"channelList"},"f":[{"t":7,"e":"div","a":{"class":"channels mobilePadding"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-bottom v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"main-header"},"f":[{"t":2,"r":"name"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-6 medium-4 large-3 flip-container ",{"t":4,"f":["flip"],"n":50,"r":"flipState"}," cursor"]},"f":[{"t":7,"e":"ux-panel","a":{"class":"channel-box flipper"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["hide"],"n":50,"r":"flipState"}," front text-left v-medium-bottom"]},"v":{"tap":{"n":"selectChannel","d":[{"t":2,"r":"x"},",",{"t":2,"r":"index"}]}},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"image"}],"class":"channel-image v-medium-bottom"}}," ",{"t":7,"e":"div","a":{"class":"channel-title"},"f":[{"t":7,"e":"ux-crop-text","a":{"text":[{"t":2,"r":"title"}],"desktopChars":[{"t":2,"r":"cropTextConfig.desktopChars"}],"tabletChars":[{"t":2,"r":"cropTextConfig.tabletChars"}],"mobileChars":[{"t":2,"r":"cropTextConfig.mobileTitleChars"}],"showComplete":[{"t":2,"r":"viewMore"}],"elipses":"..."},"f":[]}]}," ",{"t":7,"e":"div","a":{"class":"channel-number"},"f":[{"t":7,"e":"span","f":["CH ",{"t":2,"r":"channelId"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"catch-up"}}],"n":50,"r":"catchUp"}]}]}," ",{"t":7,"e":"div","a":{"class":[{"t":4,"f":["hide"],"n":51,"r":"flipState"}," back text-left v-medium-bottom"]},"v":{"tap":{"n":"selectChannel","d":[{"t":2,"r":"x"},",",{"t":2,"r":"index"}]}},"f":[{"t":7,"e":"div","a":{"class":"channel-title"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"channel-number"},"f":["CH ",{"t":2,"r":"channelId"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"catch-up"}}],"n":50,"r":"catchUp"}]}," ",{"t":7,"e":"div","a":{"class":"channel-desc"},"f":[{"t":7,"e":"ux-crop-text","a":{"text":[{"t":2,"r":"description"}],"desktopChars":[{"t":2,"r":"cropTextConfig.desktopChars"}],"tabletChars":[{"t":2,"r":"cropTextConfig.tabletChars"}],"mobileChars":[{"t":2,"r":"cropTextConfig.mobileChars"}],"showComplete":[{"t":2,"r":"viewMore"}],"elipses":"..."},"f":[]}]}]}]}]}],"n":50,"x":{"r":["displayChannel","showChannel"],"s":"_0&&_1"}}],"i":"index","r":"channels"}],"n":50,"x":{"r":["displayGenre","hideGenre"],"s":"_0&&!_1"}}],"i":"x","r":"genreChannels"}],"n":50,"r":"hasGenres"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["hasGenres"],"s":"(_0===false)"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top v-large-left formValid"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"errorMessage"}]},"f":[]}]}]}],"r":"hasGenres"}]}]}," ",{"t":7,"e":"div","a":{"id":"loader","class":"text-center v-large-bottom"}}]}]}]};
this["ux-tv-pack-catalogue"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-tv-pack-catalogue"},"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":7,"e":"ux-tv-pack","a":{"datamodel":[{"t":3,"r":"."}]}}]}],"r":"tvPackList"}]}]}]};
this["ux-tv-pack-landing"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-tv-pack-landing"},"f":[{"t":7,"e":"div","a":{"class":["show-for-medium-up ",{"t":2,"r":"theme"}]},"f":[{"t":7,"e":"ux-row","a":{"class":"center"},"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-col","a":{"class":["large-1 ",{"t":2,"r":"textAlignment"}]},"f":[" "]}," ",{"t":7,"e":"ux-col","a":{"class":["small-12 medium-7 large-4 ",{"t":2,"r":"textAlignment"}]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"section-header v-large-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"subscript-text body-light v-medium-top"},"f":[{"t":2,"r":"subTitle"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":3,"r":"description"}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}]},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"linkUrl"}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":["large-1 ",{"t":2,"r":"textAlignment"}]},"f":[" "]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-5 large-6"},"f":[{"t":7,"e":"div","a":{"class":"banner-image"},"f":[{"t":7,"e":"ux-image"}]}]}]}],"n":50,"r":"panel"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 medium-7 large-6 ",{"t":2,"r":"textAlignment"}]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"section-header v-large-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"subscript-text body-light v-medium-top"},"f":[{"t":2,"r":"subTitle"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":3,"r":"description"}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}]},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"linkUrl"}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-5 large-6"},"f":[{"t":7,"e":"div","a":{"class":"banner-image"},"f":[{"t":7,"e":"ux-image"}]}]}],"r":"panel"}]}]}," ",{"t":7,"e":"div","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-row","a":{"class":"center"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-5 large-6"},"f":[{"t":7,"e":"div","a":{"class":"banner-image"},"f":[{"t":7,"e":"ux-image"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":["small-12 medium-7 large-6 ",{"t":2,"r":"textAlignment"}]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"section-header v-medium-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"subscript-text body-light v-medium-top"},"f":[{"t":2,"r":"subTitle"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":3,"r":"description"}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}]},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"linkUrl"}]}]}]}]}],"n":50,"x":{"r":["mobileImageAlignment"],"s":"_0==\"top\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":["small-12 medium-7 large-6 ",{"t":2,"r":"textAlignment"}]},"f":[{"t":7,"e":"div","a":{"class":"content-outer"},"f":[{"t":7,"e":"div","a":{"class":"content-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"section-header v-medium-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"subscript-text body-light v-medium-top"},"f":[{"t":2,"r":"subTitle"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":3,"r":"description"}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"linkUrl"}]},"f":[{"t":2,"r":"linkText"}]}]}],"n":50,"r":"linkUrl"}]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-5 large-6"},"f":[{"t":7,"e":"div","a":{"class":"banner-image"},"f":[{"t":7,"e":"ux-image"}]}]}],"x":{"r":["mobileImageAlignment"],"s":"_0==\"top\""}}]}]}]}]};
this["ux-tv-pack-listing"] = {"v":3,"t":[{"t":7,"e":"div","o":"loadMask","f":[{"t":7,"e":"div","a":{"class":"ux-tv-pack-listing"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"mobilePadding"},"f":[{"t":7,"e":"div","a":{"id":"header-section"},"f":[{"t":7,"e":"ux-panel","a":{"class":"margin-zero panel30"},"f":[{"t":7,"e":"div","a":{"class":"header-section large-12"},"f":[{"t":7,"e":"ux-row","a":{"class":"filter-header"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"4","class":"main-header v-normal-bottom v-normal-top"},"f":[{"t":2,"r":"packTitle"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-bottom"},"f":[{"t":3,"r":"packDescription"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 padding-for-mobile v-small-bottom show-for-medium-up"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header show-result"},"f":["Language"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-3 padding-for-mobile v-small-bottom show-for-medium-up"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header show-result"},"f":["Genre"]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-3 padding-for-mobile v-small-bottom show-for-medium-up"},"f":[{"t":7,"e":"span","a":{"class":"subsection-header show-result"},"f":["Pack"]}]}],"n":50,"r":"isDisplayPack"}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 v-normal-bottom"},"f":[{"t":7,"e":"ux-multi-select","a":{"id":"select-viewby-category","showSelectedValue":"true",",":0,"class":"medium left","selected_value":[{"t":2,"r":"language"}],"options":[{"t":2,"r":"languagesList"}],"onChangeEvent":"selectLanguage"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 v-normal-bottom"},"f":[{"t":7,"e":"ux-multi-select","a":{"id":"select-viewby","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"genre"}],"options":[{"t":2,"r":"genreList"}],"onChangeEvent":"selectedGenre"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 v-normal-bottom"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-viewby-pack","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"pack"}],"options":[{"t":2,"r":"packList"}],"onChangeEvent":"filterPack"}}]}],"n":50,"r":"isDisplayPack"}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 select-tvtype text-center v-small-bottom"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["medium-6 ",{"t":4,"f":["removeRightCorner"],"n":50,"x":{"r":["idx"],"s":"_0===0"}},{"t":4,"n":51,"f":["removeLeftCorner"],"x":{"r":["idx"],"s":"_0===0"}}]},"f":[{"t":7,"e":"div","a":{"class":["choose-block cursor ",{"t":4,"f":["selected"],"n":50,"r":"selectState"}]},"v":{"tap":{"n":"selectTvType","d":[{"t":2,"r":"name"}]}},"f":[{"t":2,"r":"value"}]}]}],"n":52,"i":"idx","r":"tvTypeFilters"}],"n":50,"x":{"r":[],"s":"false"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 v-small-bottom"},"f":[{"t":7,"e":"ux-multi-select","a":{"id":"select-viewby-category","showSelectedValue":"true",",":0,"class":"medium left","selected_value":[{"t":2,"r":"language"}],"options":[{"t":2,"r":"languagesList"}],"label_value":"Language","onChangeEvent":"selectLanguage"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 v-small-bottom"},"f":[{"t":7,"e":"ux-multi-select","a":{"id":"select-viewby","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"genre"}],"options":[{"t":2,"r":"genreList"}],"label_value":"Genre","onChangeEvent":"selectedGenre"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 v-small-bottom"},"f":[{"t":7,"e":"ux-select","a":{"id":"select-viewby-pack","showSelectedValue":"true","class":"medium left","selected_value":[{"t":2,"r":"pack"}],"options":[{"t":2,"r":"packList"}],"label_value":"Pack","onChangeEvent":"filterPack"}}]}],"n":50,"r":"isDisplayPack"}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-3 select-tvtype text-center v-small-bottom"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-6 ",{"t":4,"f":["removeRightCorner"],"n":50,"x":{"r":["idx"],"s":"_0===0"}},{"t":4,"n":51,"f":["removeLeftCorner"],"x":{"r":["idx"],"s":"_0===0"}}]},"f":[{"t":7,"e":"div","a":{"class":["choose-block cursor ",{"t":4,"f":["selected"],"n":50,"r":"selectState"}]},"v":{"tap":{"n":"selectTvType","d":[{"t":2,"r":"name"}]}},"f":[{"t":2,"r":"value"}]}]}],"n":52,"i":"idx","r":"tvTypeFilters"}],"n":50,"x":{"r":[],"s":"false"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4 small-12 "},"f":[{"t":7,"e":"div","a":{"class":"section-description"},"f":[{"t":2,"r":"broadcastCount"}," channel(s)"]}]}," ",{"t":7,"e":"ux-col","a":{"class":[{"t":4,"f":["medium-offset-3"],"n":50,"r":"isDisplayPack"}," medium-2 small-12"]},"f":[{"t":7,"e":"div","a":{"class":"section-description catchUp"},"f":[{"t":7,"e":"span","a":{"class":"catch-up"}},{"t":7,"e":"span","f":["On Demand"]}]}]}]}],"n":50,"r":"displayCatchUp"}]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"channelList"},"f":[{"t":7,"e":"div","a":{"class":"channels mobilePadding"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-medium-bottom v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"main-header"},"f":[{"t":2,"r":"name"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":["small-6 medium-4 large-3 columns flip-container ",{"t":4,"f":["flip"],"n":50,"r":"flipState"}," cursor"]},"f":[{"t":7,"e":"ux-panel","a":{"class":"channel-box flipper"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":["hide "],"n":50,"r":"flipState"},"front text-left v-medium-bottom"]},"v":{"tap":{"n":"selectChannel","d":[{"t":2,"r":"x"},",",{"t":2,"r":"index"}]}},"f":[{"t":7,"e":"ux-image","a":{"src":[{"t":2,"r":"image"}],"class":"channel-image v-medium-bottom"}}," ",{"t":7,"e":"div","a":{"class":"channel-title"},"f":[{"t":7,"e":"ux-crop-text","a":{"text":[{"t":2,"r":"title"}],"desktopChars":[{"t":2,"r":"cropTextConfig.desktopChars"}],"tabletChars":[{"t":2,"r":"cropTextConfig.tabletChars"}],"mobileChars":[{"t":2,"r":"cropTextConfig.mobileTitleChars"}],"showComplete":[{"t":2,"r":"viewMore"}],"elipses":"..."},"f":[]}]}," ",{"t":7,"e":"div","a":{"class":"channel-number"},"f":[{"t":7,"e":"span","f":["CH ",{"t":2,"r":"channelId"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"catch-up"}}],"n":50,"r":"catchUp"}]}]}," ",{"t":7,"e":"div","a":{"class":[{"t":4,"f":["hide"],"n":51,"r":"flipState"}," back text-left v-medium-bottom"]},"v":{"tap":{"n":"selectChannel","d":[{"t":2,"r":"x"},",",{"t":2,"r":"index"}]}},"f":[{"t":7,"e":"div","a":{"class":"channel-title"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"channel-number"},"f":["CH ",{"t":2,"r":"channelId"}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"catch-up"}}],"n":50,"r":"catchUp"}]}," ",{"t":7,"e":"div","a":{"class":"channel-desc"},"f":[{"t":7,"e":"ux-crop-text","a":{"text":[{"t":2,"r":"description"}],"desktopChars":[{"t":2,"r":"cropTextConfig.desktopChars"}],"tabletChars":[{"t":2,"r":"cropTextConfig.tabletChars"}],"mobileChars":[{"t":2,"r":"cropTextConfig.mobileChars"}],"showComplete":[{"t":2,"r":"viewMore"}],"elipses":"..."},"f":[]}]}]}]}]}],"n":50,"r":"displayChannel"}],"i":"index","r":"channels"}],"n":50,"r":"displayGenre"}],"i":"x","r":"genreChannels"}],"n":50,"r":"hasGenres"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["nochannelsFlag","hasGenres"],"s":"(_0||(_1===false))"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top v-large-left formValid"},"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"errorMessage"}]},"f":[]}]}]}],"r":"hasGenres"}]}]}," ",{"t":7,"e":"div","a":{"id":"loader","class":"text-center v-large-bottom"}}]}]}]};
this["ux-tv-pack"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-tv-pack p-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"panel pack-panel text-center"},"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":2,"r":"img"}],"class":"pack-image"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ribbon-wrapper spacer-top"},"f":[{"t":7,"e":"div","a":{"class":"ribbon"},"f":[{"t":2,"r":"ribbon"}]}]}],"n":50,"r":"ribbon"}," ",{"t":7,"e":"div","a":{"class":"product-title v-normal-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"panel-text v-small-bottom"},"f":[{"t":4,"f":[{"t":2,"r":"text"}],"n":50,"r":"text"},{"t":4,"n":51,"f":[{"t":2,"r":"description"}],"r":"text"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"target":"_blank"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"x":{"r":["linkText","link"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-12"},"f":[{"t":7,"e":"span","a":{"class":"left"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"a","v":{"tap":"showChannelModal"},"a":{"class":"right"},"f":[{"t":2,"r":"packChannelNum"}," Channels"]}," ",{"t":7,"e":"hr"}]}],"r":"tvPacks"}]}],"n":50,"r":"tvPacks"},{"t":4,"n":51,"f":[{"t":7,"e":"a","v":{"tap":"showChannelModal"},"a":{"class":"text-link"},"f":[{"t":2,"r":"packChannelNum"}," Channels"]}],"r":"tvPacks"}],"x":{"r":["linkText","link"],"s":"_0&&_1"}}," ",{"t":7,"e":"div","a":{"class":"main-dollar v-small-top"},"f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"planText"}]}," ",{"t":7,"e":"ux-button","a":{"onclick":"selectplan","text":[{"t":2,"r":"buttonText"}],"class":"light round v-normal-top v-normal-bottom"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-channel-modal"}],"r":"channelListInfo"}]}]};
this["ux-tv-recommender"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-tv-recommender"},"f":[{"t":7,"e":"div","a":{"class":["night-view-box ",{"t":4,"f":[{"t":2,"r":"padding.topPadding"}],"n":50,"r":"padding.topPadding"}," ",{"t":4,"f":[{"t":2,"r":"padding.bottomPadding"}],"n":50,"r":"padding.bottomPadding"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-button","a":{"class":"button light round","text":[{"t":2,"r":"linkText"}],"onclick":"openRecommenderModal"}}],"n":50,"r":"isButtonNeeded"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"openRecommenderModal","ariaLabel":"openRecommenderModal"},"f":[{"t":2,"r":"linkText"}]}],"r":"isButtonNeeded"}]}," ",{"t":7,"e":"ux-modal","a":{"class":"full-modal v-none-padding","widthPercentage":"100","modalId":"selectModal"},"f":[{"t":7,"e":"div","a":{"class":"white-bg"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-large-top v-large-bottom"},"f":[{"t":2,"r":"modalHeader"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"main-header"},"f":[{"t":2,"r":"languageSectionHeader"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"languageSectionText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-panel","a":{"class":"p-large-top p-large-bottom p-large-right p-large-left"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ul","a":{"class":"small-block-grid-2 large-block-grid-4"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"div","a":{"class":["choose-block flex-container flex-container-center ",{"t":4,"f":["selected"],"n":50,"r":"chosen"}]},"v":{"tap":"choose"},"f":[{"t":7,"e":"div","a":{"class":"flex-item text-center"},"f":[{"t":7,"e":"div","a":{"class":"subsection-header"},"f":[{"t":2,"r":"name"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"r":"id"}]}],"n":51,"r":"hideID"}],"n":50,"r":"id"}]}]}]}],"r":"languageList"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"p-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"button round light right","ontap":"languageNext","ariaLabel":"languageNext"},"f":[{"t":2,"r":"nextButtonText"}]}],"n":50,"r":"languageListFiltered"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"class":"button round light right disabled"},"f":[{"t":2,"r":"nextButtonText"}]}],"r":"languageListFiltered"}]}]}]}]}],"n":50,"r":"languagePanel"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"badges-text"},"f":[{"t":2,"r":"languageLabel"}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["displaySelectedResult","languageListFiltered"],"s":"_0(_1)"}}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"right","ontap":"languageChange"},"f":[{"t":2,"r":"changeLinkText"}]}]}]}]}]}],"n":50,"r":"languageResults"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"main-header"},"f":[{"t":2,"r":"genreSectionHeader"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"genreSectionText"}]}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-panel","a":{"class":"p-large-top  p-large-bottom p-large-right p-large-left"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ul","a":{"class":"small-block-grid-2 large-block-grid-5"},"f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"div","a":{"class":["choose-block flex-container flex-container-center ",{"t":4,"f":["selected"],"n":50,"r":"chosen"}]},"v":{"tap":"choose"},"f":[{"t":7,"e":"div","a":{"class":"flex-item text-center"},"f":[{"t":7,"e":"ux-icon","a":{"type":["tv-",{"t":2,"r":"id"}]}}," ",{"t":7,"e":"div","f":[{"t":2,"r":"id"}]}]}]}]}],"r":"genreList"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"p-normal-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"button round light right","ontap":"genreNext","ariaLabel":"genreNext"},"f":[{"t":2,"r":"nextButtonText"}]}],"n":50,"r":"genreListFiltered"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"class":"button round light right disabled"},"f":[{"t":2,"r":"nextButtonText"}]}],"r":"genreListFiltered"}]}]}]}]}],"n":50,"r":"genrePanel"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-panel","f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"badges-text"},"f":[{"t":2,"r":"genreLabel"}]}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","a":{"class":"section-header"},"f":[{"t":2,"x":{"r":["displaySelectedResult","genreListFiltered"],"s":"_0(_1)"}}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"right","ontap":"genreChange"},"f":[{"t":2,"r":"changeLinkText"}]}]}]}]}]}],"n":50,"r":"genreResults"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"main-header v-x-large-top v-x-large-bottom"},"f":[{"t":3,"r":"tvPackHeader"}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":7,"e":"div","a":{"class":"panel pack-panel text-center"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-ribbon-singtel"},"f":[{"t":7,"e":"div","a":{"class":"ribbon-container  ribbon-left"},"f":[{"t":7,"e":"div","a":{"class":"ribbon "},"f":[{"t":2,"r":"panelText"}]}]}]}],"n":50,"r":"panelText"}," ",{"t":7,"e":"ux-image","a":{"img":[{"t":2,"r":"img"}]}}," ",{"t":7,"e":"div","a":{"class":"product-title v-normal-top"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"div","a":{"class":"panel-text v-small-bottom"},"f":[{"t":2,"r":"text"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-text v-medium-top v-medium-bottom"},"f":[{"t":2,"r":"recommendedPlanText"}]}],"n":50,"r":"recommendedPlanText"}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"target":"_blank"},"f":[{"t":2,"r":"linkText"}]}],"n":50,"x":{"r":["linkText","link"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"left"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"a","v":{"tap":"showChannelModal"},"a":{"class":"right"},"f":[{"t":2,"r":"packChannelNum"}," Channels"]}," ",{"t":7,"e":"hr"}],"r":"tvPacks"}]}],"n":50,"r":"listView"},{"t":4,"n":51,"f":[{"t":7,"e":"a","v":{"tap":"showPackList"},"a":{"class":"text-link"},"f":[{"t":2,"r":"linkText"}]}],"r":"listView"}],"x":{"r":["linkText","link"],"s":"_0&&_1"}}," ",{"t":7,"e":"div","a":{"class":"main-dollar v-large-top"},"f":[{"t":2,"x":{"r":["RactiveHelpers","price"],"s":"_0.convertUnits(_1,\"$\")"}}]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"~/planText"}]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":["getTvPack:",{"t":2,"r":"index"}],"class":"button light round v-normal-top v-normal-bottom"},"f":[{"t":2,"r":"~/buttonText"}]}]}]}],"i":"index","r":"packListShown"}]}],"n":50,"r":"packResults"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-channel-modal"}],"r":"channelListInfo"}]}]};
this["ux-tv-sub"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-tv-sub"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"collapse v-normal-bottom medium-6 small-6"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":[{"t":2,"r":"ConfigStrings.tvPacksHeader"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"collapse v-normal-bottom medium-6 small-6"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":[{"t":2,"r":"ConfigStrings.recontractLabels.tvReconEligibilityDateHeader"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"collapse medium-6 small-6"},"f":[{"t":2,"r":"productFacade.tvMainPack.catalogItemName"}]}," ",{"t":7,"e":"ux-col","a":{"class":"collapse medium-6 body-light small-6"},"f":[{"t":2,"x":{"r":["productFacade.tvMainPack.actualReconDate"],"s":"_0.format(\"D MMMM YYYY\")"}}]}]}],"n":50,"r":"productFacade.tvMainPack"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"collapse medium-6 small-6"},"f":[{"t":2,"r":"catalogItemName"}]}," ",{"t":7,"e":"ux-col","a":{"class":"collpase medium-6 body-light small-6"},"f":[{"t":2,"x":{"r":["actualReconDate"],"s":"_0.format(\"D MMMM YYYY\")"}}]}]}],"n":50,"x":{"r":["tvContentPackFlag","actualReconDate"],"s":"_0&&_1"}}],"n":52,"r":"productFacade.addOnsMapByAsignedProductId"}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":["Plan Specification"]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"r":"productFacade.tvMainPack.catalogItemName"}]}],"n":50,"r":"productFacade.tvMainPack"}," ",{"t":4,"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"catalogItemName"}]}],"n":52,"r":"productFacade.addOnsMapByAsignedProductId"}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header v-medium-right"},"f":[{"t":2,"r":"initData.subInitData.tvInstallationAddressText"}]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"relocateService","product":[{"t":2,"r":"."}],"href":[{"t":2,"r":"initData.subInitData.relocateServiceLink"}]},"f":[{"t":2,"r":"initData.subInitData.relocateServiceLinkText"}]}," ",{"t":7,"e":"div","f":[" ",{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"address"}],"addressType":[{"t":2,"x":{"r":["address.addressType"],"s":"_0||\"omsProductServiceLevel\""}}]}}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"light round expand-for-mobile button","manageAddonUrl":[{"t":2,"r":"ConfigStrings.tvContentPackUrl"}],"product":[{"t":2,"r":"product"}],"permission":[{"t":2,"r":"permission"}],"account":[{"t":2,"r":"account"}],"subscription":[{"t":2,"r":"."}],"ontap":"manageAddons"},"f":[{"t":2,"r":"initData.subInitData.addContentText"}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":[{"t":7,"e":"span","f":[{"t":2,"r":"initData.subInitData.recontractOptionsText"}]}," ",{"t":7,"e":"span","a":{"class":"hide"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"showContractDetails"},"f":[{"t":2,"r":"initData.subInitData.recontractOptionsLinkText"}]}]}]}]}," ",{"t":4,"f":["You are eligible to recontract your ",{"t":4,"f":[{"t":2,"r":"productFacade.tvMainPack.catalogItemName"}," TV pack"],"n":50,"r":"productFacade.recontractData.isMainPackReconEligible"}," ",{"t":4,"f":[", and"],"n":50,"x":{"r":["productFacade.recontractData.reconEligibleContentPacks","productFacade.recontractData.isMainPackReconEligible"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":2,"rx":{"r":"productFacade.recontractData.reconEligibleContentPacks","m":[{"t":30,"n":"idx"}]}}," ",{"t":4,"f":[","],"n":50,"x":{"r":["idx","productFacade.recontractData.reconEligibleContentPacks.length"],"s":"_0<_1-1"}}],"n":52,"i":"idx","r":"productFacade.recontractData.reconEligibleContentPacks"}," ",{"t":4,"f":["content pack",{"t":4,"f":["s"],"n":50,"x":{"r":["productFacade.recontractData.reconEligibleContentPacks.length"],"s":"_0>1"}}],"n":50,"r":"productFacade.recontractData.reconEligibleContentPacks"}," "],"n":50,"r":"productFacade.recontractData.isEligibleForRecon"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"r":"ConfigStrings.recontractLabels.tv"}," ",{"t":2,"x":{"r":["productFacade.recontractData.earliestReconDate"],"s":"_0.format(\"D MMMM YYYY\")"}}]}," "],"r":"productFacade.recontractData.isEligibleForRecon"},"."]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":"light v-large-top round expand-for-mobile","onclick":"recontractMobile","permission":[{"t":2,"r":"permission"}],"isOrderPending":[{"t":2,"r":"pendingOrders.isChangePlanPending"}],"text":[{"t":2,"r":"ConfigStrings.recontractLabels.recontractBtn"}]},"f":[]}]}]}],"n":50,"r":"productFacade.recontractData.isEligibleForRecon"}],"n":50,"r":"productFacade.recontractData.display"}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-4 medium-offset-2 small-12"},"f":[{"t":7,"e":"ux-sub-addon","a":{"subscription":[{"t":2,"r":"."}],"account":[{"t":2,"r":"account"}],"product":[{"t":2,"r":"product"}],"productFacade":[{"t":2,"r":"productFacade"}],"initData":[{"t":2,"r":"initData.addonInitData"}],"permission":[{"t":2,"r":"permission"}]}}]}]}]}],"n":53,"r":"product"},{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"recontractDetailsModal"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":3,"r":"initData.subInitData.contractEndDateHeaderText"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"ConfigStrings.recontractLabels.tv"}," ",{"t":2,"x":{"r":["productFacade.recontractData.deviceContractEndDate"],"s":"_0.format(\"D MMMM YYYY\")"}},"."]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":"v-large-top round expand-for-mobile","onclick":"recontractMobile","permission":[{"t":2,"r":"permission"}],"text":[{"t":2,"r":"ConfigStrings.recontractLabels.recontractBtn"}]},"f":[]}]}]}],"n":50,"x":{"r":["moment","productFacade.recontractData.deviceContractEndDate"],"s":"_0()>_1"}}]}]};
this["ux-tweakplan"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-tweakplan"},"f":[{"t":7,"e":"div","a":{"class":"plan-details-panel"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"subscription.productDetails.plan.catalogItemName"}," (",{"t":2,"x":{"r":["initActiveTalktimeUnits","initActiveSMSUnits","initActiveDataUnits"],"s":"_0+_1+_2"}}," Units)"]}]}," ",{"t":7,"e":"ux-row","a":{"class":"current-plan"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header v-normal-bottom"},"f":["Current Plan"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"active-talktime text-center disabled left"},"f":[{"t":2,"r":"initActiveTalktimeUnits"}]}," ",{"t":7,"e":"div","a":{"class":"left unit-label"},"f":[{"t":7,"e":"div","a":{"class":"units"},"f":["Units"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"initTalktimeValue"}," min"]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"active-sms text-center disabled left"},"f":[{"t":2,"r":"initActiveSMSUnits"}]}," ",{"t":7,"e":"div","a":{"class":"left unit-label"},"f":[{"t":7,"e":"div","a":{"class":"units"},"f":["Units"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"initSmsValue"}," SMS"]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"active-data text-center small-4 disabled left"},"f":[{"t":2,"r":"initActiveDataUnits"}]}," ",{"t":7,"e":"div","a":{"class":"left unit-label"},"f":[{"t":7,"e":"div","a":{"class":"units"},"f":["Units"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"initDataValue"}," GB Data"]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top new-plan"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header v-normal-bottom"},"f":["New Plan"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"active-talktime text-center left"},"f":[{"t":2,"r":"activeTalktimeUnits"}]}," ",{"t":7,"e":"div","a":{"class":"left unit-label"},"f":[{"t":7,"e":"div","a":{"class":"units"},"f":["Units"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"activeMinutes"}," min"]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"active-sms text-center left"},"f":[{"t":2,"r":"activeSMSUnits"}]}," ",{"t":7,"e":"div","a":{"class":"left unit-label"},"f":[{"t":7,"e":"div","a":{"class":"units"},"f":["Units"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"activeSMS"}," SMS"]}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"active-data text-center left"},"f":[{"t":2,"r":"activeDataUnits"}]}," ",{"t":7,"e":"div","a":{"class":"left unit-label"},"f":[{"t":7,"e":"div","a":{"class":"units"},"f":["Units"]}," ",{"t":7,"e":"div","f":[{"t":2,"r":"activeData"}," GB Data"]}]}]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"div","a":{"class":"range-slider"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-medium-top callout-text-copy"},"f":[{"t":2,"r":"unitError"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"initData.individualUnitInfo"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"ux-col","f":["Note: Any changes to plan will take effect from the start of next billing cycle beginning"]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-bottom error"},"f":[{"t":7,"e":"ux-col","a":{"class":"left alert-icon icon-ul small-1"},"f":[{"t":7,"e":"ux-icon","a":{"type":"alert-lightning-filled"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-11"},"f":[{"t":2,"r":"tweakSuspensionErrorMsg"}]}]}],"n":50,"x":{"r":["subscription.subscrStatus"],"s":"_0===83||_0===85"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["permission.ipa"],"s":"_0"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-bottom error"},"f":[{"t":7,"e":"ux-col","a":{"class":"left alert-icon icon-ul small-1"},"f":[{"t":7,"e":"ux-icon","a":{"type":"alert-lightning-filled"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-11"},"f":[{"t":2,"r":"ipaMsg"}]}]}]},{"t":4,"n":50,"x":{"r":["permission.ipa","permission.blacklisted"],"s":"(!(_0))&&(_1)"},"f":[" ",{"t":7,"e":"ux-row","a":{"class":"v-large-bottom error"},"f":[{"t":7,"e":"ux-col","a":{"class":"left alert-icon icon-ul small-1"},"f":[{"t":7,"e":"ux-icon","a":{"type":"alert-lightning-filled"}}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-11"},"f":[{"t":2,"r":"blacklistMsg"}]}]}]}],"x":{"r":["subscription.subscrStatus"],"s":"_0===83||_0===85"}}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top show-for-small-only"},"f":[{"t":7,"e":"ux-button","a":{"class":"round default","onclick":"resetEasyMobilePlan","text":"Reset"}}," ",{"t":7,"e":"ux-button","a":{"class":["round margin-zero ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["subscription.subscrStatus","permission.ipa","permission.blacklisted"],"s":"(_0===83||_0===85)||(_1||_2)"}}," ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["initActiveTalktimeUnits","initActiveSMSUnits","initActiveDataUnits","totalUnits"],"s":"(_0+_1+_2)===_3"}}],"onclick":"tweakEasyMobilePlan","text":"Save"}}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-normal-top show-for-medium-up"},"f":[{"t":7,"e":"ux-button","a":{"class":"round margin-zero default","onclick":"resetEasyMobilePlan","text":"Reset"}}," ",{"t":7,"e":"ux-button","a":{"class":["round margin-zero right ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["subscription.subscrStatus","permission.ipa","permission.blacklisted"],"s":"(_0===83||_0===85)||(_1||_2)"}}," ",{"t":4,"f":["disabled"],"n":51,"x":{"r":["initActiveTalktimeUnits","initActiveSMSUnits","initActiveDataUnits","totalUnits"],"s":"(_0+_1+_2)===_3"}}],"onclick":"tweakEasyMobilePlan","text":"Save"}}]}]}]}]};
this["ux-two-image-banner"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"style","f":["      .panel.backgroundcss {\n        background-color: ",{"t":2,"r":"bgColor"}," !important;\n      }\n  "]}],"n":50,"r":"bgColor"},{"t":7,"e":"div","a":{"class":"ux-two-image-banner"},"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":["margin-zero ",{"t":4,"f":["backgroundcss"],"n":50,"r":"bgColor"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"show-for-medium-up medium-2 large-2"},"f":[" "]}," ",{"t":7,"e":"ux-col","a":{"class":"v-large-top small-12 medium-8 large-8"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":[{"t":2,"r":"mobileHeadingStyle"}],"n":50,"r":"mobileHeadingStyle"}]},"f":[{"t":7,"e":"ux-header","a":{"level":"2","class":["wraptext ",{"t":2,"x":{"r":["headingStyle"],"s":"_0?_0:\"main-header\""}}]},"f":[{"t":2,"r":"heading"}]}]}],"n":50,"r":"heading"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"show-for-medium-up medium-2 large-2"},"f":[" "]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-8 large-8"},"f":[{"t":7,"e":"div","a":{"class":[{"t":4,"f":[{"t":2,"r":"mobileDescriptionStyle"}],"n":50,"r":"mobileDescriptionStyle"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["wraptext ",{"t":4,"f":["left-align-text"],"n":50,"r":"descLeftAlign"}," description-text ",{"t":2,"x":{"r":["descStyle"],"s":"_0?_0:\"body-copy-text\""}}," ",{"t":4,"f":["v-",{"t":2,"x":{"r":["headerDescSpacing"],"s":"_0?_0:\"normal\""}},"-top"],"n":50,"r":"headerDescSpacing"}]},"f":[{"t":3,"r":"text"}]}],"n":50,"r":"text"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"text-center v-large-top v-medium-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"show-for-medium-up large-2"},"f":[" "]}," ",{"t":7,"e":"ux-col","a":{"class":"large-4 medium-6 small-12 v-xx-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link1"}]},"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":2,"r":"img1"}]}}]}],"n":50,"r":"link1"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":2,"r":"img1"}]}}],"r":"link1"}," ",{"t":7,"e":"div","a":{"class":"subsection-header wraptext"},"f":[{"t":2,"r":"title1"}]}," ",{"t":7,"e":"div","a":{"class":"description-text wraptext"},"f":[{"t":3,"r":"text1"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"large-4 medium-6 small-12 v-xx-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link2"}]},"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":2,"r":"img2"}]}}]}],"n":50,"r":"link2"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":2,"r":"img2"}]}}],"r":"link2"}," ",{"t":7,"e":"div","a":{"class":"subsection-header wraptext"},"f":[{"t":2,"r":"title2"}]}," ",{"t":7,"e":"div","a":{"class":"description-text wraptext"},"f":[{"t":3,"r":"text2"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"show-for-medium-up large-2"},"f":[" "]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-unbilled-usage"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-unbilled-usage"},"f":[" ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","volume"],"s":"_0.getUsageValue(_1,false)"}}," MB"],"n":50,"x":{"r":["volume"],"s":"_0<1024"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["volume"],"s":"(_0/1024).toFixed(2)"}}," GB"],"x":{"r":["volume"],"s":"_0<1024"}}," / ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["quota"],"s":"{value:_0}"}}," Additional Data"],"n":50,"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"unlimitedText"},"f":["Unlimited Additional Data"]}],"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1"}}]}," ",{"t":7,"e":"span","v":{"tap":{"n":"onShowDetailedSponsoredUnbilledUsage","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-anchor","f":["View Details"]}]}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"exceed-limit"},"f":["Multiple expiry date"]}],"n":50,"x":{"r":["usageSummary.sponsoredData","usageSummary.sponsoredData.length"],"s":"_0&&_1>1"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"exceed-limit"},"f":[{"t":4,"f":["Expires today at ",{"t":2,"x":{"r":["moment","expiryDate"],"s":"_0(_1,\"DD-MMM-YYYY HH:mm\").format(\"HH:mm A\")"}}],"n":50,"x":{"r":["expiryDate","moment"],"s":"_1(_0,\"DD-MMM-YYYY HH:mm\").isSame(_1(),\"day\")"}},{"t":4,"n":51,"f":["Expires ",{"t":2,"x":{"r":["moment","expiryDate"],"s":"_0(_1,\"DD-MMM-YYYY HH:mm\").format(\"DD MMM, HH:mm A\")"}}],"x":{"r":["expiryDate","moment"],"s":"_1(_0,\"DD-MMM-YYYY HH:mm\").isSame(_1(),\"day\")"}}]}],"x":{"r":["usageSummary.sponsoredData","usageSummary.sponsoredData.length"],"s":"_0&&_1>1"}}],"n":50,"r":"expiryDate"}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","v":{"tap":{"n":"onShowDetailedSponsoredUnbilledUsage","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-progress","a":{"value":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?_0:100"}}],"class":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?\"progress-blue\":\"progress-red\""}}," ",{"t":2,"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1?\"limited-quota\":\"unlimited-quota\""}}]}}]}]}]}],"n":53,"r":"usageSummary.combinedSponsoredUsage"}],"n":50,"r":"usageSummary.combinedSponsoredUsage"}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":8,"r":"dataUsage"}],"n":53,"r":"usageSummary.DATA"}],"n":50,"r":"usageSummary.ASPIRE_FLAG"}],"n":50,"x":{"r":["summaryType","usageSummary.DATA"],"s":"_0===\"Local\"&&_1"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":8,"r":"dataUsage"}],"n":52,"r":"usageSummary.DATA"}],"x":{"r":["summaryType","usageSummary.DATA"],"s":"_0===\"Local\"&&_1"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","volume"],"s":"_0.getUsageValue(_1,false)"}}," MB"],"n":50,"x":{"r":["volume"],"s":"_0<1024"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["volume"],"s":"(_0/1024).toFixed(2)"}}," GB"],"x":{"r":["volume"],"s":"_0<1024"}}," ",{"t":4,"f":["/ ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["quota"],"s":"{value:_0}"}}," Data"],"n":50,"x":{"r":["quota","ConfigStrings.maxQuotaData","isXLiteAddonPresent"],"s":"_0<_1&&!_2"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"unlimitedText"},"f":["Unlimited* Data"]}],"x":{"r":["quota","ConfigStrings.maxQuotaData","isXLiteAddonPresent"],"s":"_0<_1&&!_2"}}],"n":50,"x":{"r":["quota"],"s":"_0!==0"}}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"exceed-limit"},"f":["(Exceeded data limit by ",{"t":2,"x":{"r":["volume","quota"],"s":"((_0-_1)/1024).toFixed(2)"}}," GB)"]}],"n":50,"x":{"r":["utilizedQuotaPercentage","isXLiteAddonPresent"],"s":"_0>100&&!_1"}}," ",{"t":7,"e":"span","v":{"tap":{"n":"onShowDetailedUnbilledUsage","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-anchor","f":["View Details"]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","v":{"tap":{"n":"onShowDetailedUnbilledUsage","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-progress","a":{"value":"100","class":"progress-blue unlimited-quota"}}]}]}],"n":50,"r":"isXLiteAddonPresent"},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","v":{"tap":{"n":"onShowDetailedUnbilledUsage","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-progress","a":{"value":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?_0:100"}}],"class":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?\"progress-blue\":\"progress-red\""}}," ",{"t":2,"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1?\"limited-quota\":\"unlimited-quota\""}}]}}]}]}],"r":"isXLiteAddonPresent"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":2,"r":"initData.usageInitData.freeSundayDescription"}]}],"n":50,"rx":{"r":"productFacade.addOnsMapByCatalogId","m":[{"r":[],"s":"\"11459431\""}]}}]}],"n":53,"r":"usageSummary.combinedLocalUsage"}],"n":50,"r":"usageSummary.combinedLocalUsage"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","volume"],"s":"_0.getUsageValue(_1,false)"}}," MB"],"n":50,"x":{"r":["volume"],"s":"_0<1024"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["volume"],"s":"(_0/1024).toFixed(2)"}}," GB"],"x":{"r":["volume"],"s":"_0<1024"}}," / ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["quota"],"s":"{value:_0}"}}],"n":50,"x":{"r":["quota","ConfigStrings.maxQuotaVoice"],"s":"_0<_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"unlimitedText"},"f":["Unlimited* Data"]}],"x":{"r":["quota","ConfigStrings.maxQuotaVoice"],"s":"_0<_1"}}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"exceed-limit"},"f":["(Exceeded data limit by ",{"t":2,"x":{"r":["volume","quota"],"s":"((_0-_1)/1024).toFixed(2)"}}," GB)"]}],"n":50,"x":{"r":["utilizedQuotaPercentage"],"s":"_0>100"}}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","v":{"tap":{"n":"onShowUnbilledData","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-progress","a":{"value":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?_0:100"}}],"class":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?\"progress-blue\":\"progress-red\""}}," ",{"t":2,"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1?\"limited-quota\":\"unlimited-quota\""}}]}}]}]}]}],"n":52,"i":"i","r":"usageSummary.infinity"}],"n":50,"r":"usageSummary.infinity"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"div","f":[{"t":4,"f":["$",{"t":2,"r":"volume"}," / $",{"t":2,"r":"quota"}," Pay-Per-Use data"],"n":50,"x":{"r":["volume"],"s":"_0%1===0"}},{"t":4,"n":51,"f":["$",{"t":2,"x":{"r":["volume"],"s":"_0.toFixed(2)"}}," / $",{"t":2,"r":"quota"}," Pay-Per-Use data"],"x":{"r":["volume"],"s":"_0%1===0"}}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-progress","a":{"value":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?_0:100"}}],"class":"progress-blue"}}]}]}]}],"n":52,"i":"i","r":"usageSummary.payForUse"}],"n":50,"r":"usageSummary.payForUse"}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","volume"],"s":"_0.getUsageValue(_1,false)"}}," MB"],"n":50,"x":{"r":["volume"],"s":"_0<1024"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["volume"],"s":"(_0/1024).toFixed(2)"}}," GB"],"x":{"r":["volume"],"s":"_0<1024"}}," / ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","quota"],"s":"_0.getUsageValue(_1,1024)"}}," GB Singtel WiFi"],"n":50,"x":{"r":["quota"],"s":"_0<1024"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["quota"],"s":"(_0/1024).toFixed(2)"}}," GB Singtel WiFi"],"x":{"r":["quota"],"s":"_0<1024"}}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"exceed-limit"},"f":["(Exceeded data limit by ",{"t":2,"x":{"r":["volume","quota"],"s":"((_0-_1)/1024).toFixed(2)"}}," GB)"]}],"n":50,"x":{"r":["utilizedQuotaPercentage"],"s":"_0>100"}}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","v":{"tap":{"n":"onShowUnbilledData","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-progress","a":{"value":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?_0:100"}}],"class":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?\"progress-blue\":\"progress-red\""}}," ",{"t":2,"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1?\"limited-quota\":\"unlimited-quota\""}}]}}]}]}]}],"n":50,"x":{"r":["quota"],"s":"_0&&_0>0"}}],"n":52,"i":"i","r":"usageSummary.singtelWifi"}],"n":50,"r":"usageSummary.singtelWifi"}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","quota","volume"],"s":"_0.getUsageValueAndUnits(_1-_2)"}}," left"],"n":50,"x":{"r":["unitOfMeasurement"],"s":"_0===\"SECONDS\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["volume"],"s":"_0<1024"},"f":[{"t":2,"x":{"r":["RactiveHelpers","volume"],"s":"_0.getUsageValue(_1,false)"}}," MB"]},{"t":4,"n":50,"x":{"r":["volume"],"s":"!(_0<1024)"},"f":[" ",{"t":2,"x":{"r":["volume"],"s":"(_0/1024).toFixed(2)"}}," GB"]}],"x":{"r":["unitOfMeasurement"],"s":"_0===\"SECONDS\""}}," / ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","quota"],"s":"_0.getUsageLimitValue(_1)"}}," "],"n":50,"x":{"r":["unitOfMeasurement"],"s":"_0===\"SECONDS\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["quota"],"s":"_0<1024"},"f":[{"t":2,"x":{"r":["RactiveHelpers","quota"],"s":"_0.getUsageValue(_1,1024)"}}," GB"]},{"t":4,"n":50,"x":{"r":["quota"],"s":"!(_0<1024)"},"f":[" ",{"t":2,"x":{"r":["quota"],"s":"(_0/1024).toFixed(2)"}}," GB"]}],"x":{"r":["unitOfMeasurement"],"s":"_0===\"SECONDS\""}}," (",{"t":2,"r":"name"}," ",{"t":4,"f":["from ",{"t":2,"x":{"r":["moment","startDate"],"s":"_0(_1,\"DD-MMM-YYYY HH:mm\").format(\"DD MMM YYYY\")"}}],"n":50,"r":"startDate"}," ",{"t":4,"f":["to ",{"t":2,"x":{"r":["moment","expiryDate"],"s":"_0(_1,\"DD-MMM-YYYY HH:mm\").format(\"DD MMM YYYY\")"}}],"n":50,"r":"expiryDate"}," )"]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-progress","a":{"value":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?_0:100"}}],"class":"progress-default"}}]}]}]}],"n":50,"x":{"r":["quota"],"s":"_0&&_0>0"}}],"n":52,"i":"i","r":"usageSummary.bonusDataUsage"}],"n":50,"x":{"r":["usageSummary.ASPIRE_FLAG","summaryType","usageSummary.bonusDataUsage"],"s":"(_0||_1===\"Roaming\")&&_2"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-normal"},"f":[{"t":2,"r":"initData.usageCatchUpMessage"}]}],"n":50,"x":{"r":["initData.hideUsagesFrom","moment","initData.hideUsagesTill"],"s":"_1().isBetween(_1(_0,\"x\"),_1(_2,\"x\"))"}},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["volume"],"s":"Math.round(_0)"}}," min ",{"t":4,"f":[{"t":4,"f":["/ ",{"t":2,"r":"quota"}," min Talktime"],"n":50,"x":{"r":["quota"],"s":"_0>0"}}],"n":50,"x":{"r":["quota","ConfigStrings.maxQuotaVoice"],"s":"_0<_1"}},{"t":4,"n":51,"f":["/",{"t":7,"e":"span","a":{"class":"unlimitedText"},"f":[" Unlimited* Talktime"]}],"x":{"r":["quota","ConfigStrings.maxQuotaVoice"],"s":"_0<_1"}}," ",{"t":4,"f":[{"t":4,"f":["(",{"t":2,"rx":{"r":"subscription.usageSummary.easyMobileTcUnits","m":[{"r":[],"s":"\"voiceUnits\""}]}}," units)"],"n":50,"x":{"r":["subscription.usageSummary.easyMobileTcUnits"],"s":"_0[\"voiceUnits\"]>1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["subscription.usageSummary.easyMobileTcUnits"],"s":"_0[\"voiceUnits\"]===1"},"f":["(",{"t":2,"rx":{"r":"subscription.usageSummary.easyMobileTcUnits","m":[{"r":[],"s":"\"voiceUnits\""}]}}," unit)"]}],"x":{"r":["subscription.usageSummary.easyMobileTcUnits"],"s":"_0[\"voiceUnits\"]>1"}}],"n":50,"r":"subscription.productDetails.easyMobileIndX8"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"exceed-limit"},"f":["(Exceeded voice limit by ",{"t":2,"x":{"r":["volume","quota"],"s":"_0-_1"}}," min)"]}," ",{"t":7,"e":"span","v":{"tap":{"n":"onShowUnbilledData","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-anchor","f":["View Details"]}]}],"n":50,"x":{"r":["utilizedQuotaPercentage"],"s":"_0>100"}}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","v":{"tap":{"n":"onShowUnbilledData","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-progress","a":{"value":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?_0:100"}}],"class":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?\"progress-purple\":\"progress-red\""}}," ",{"t":2,"x":{"r":["quota","ConfigStrings.maxQuotaVoice"],"s":"_0<_1?\"limited-quota\":\"unlimited-quota\""}}]},"f":[]}]}]}]}],"n":53,"r":"usageSummary.VOICE"}],"n":50,"r":"usageSummary.VOICE"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","f":[{"t":2,"r":"volume"}," SMS ",{"t":4,"f":[{"t":4,"f":["/ ",{"t":2,"r":"quota"}," SMS"],"n":50,"x":{"r":["quota"],"s":"_0>0"}}],"n":50,"x":{"r":["quota","ConfigStrings.maxQuotaSms"],"s":"_0<_1"}},{"t":4,"n":51,"f":["/",{"t":7,"e":"span","a":{"class":"unlimitedText"},"f":[" Unlimited* SMS"]}],"x":{"r":["quota","ConfigStrings.maxQuotaSms"],"s":"_0<_1"}}," ",{"t":4,"f":[{"t":4,"f":["(",{"t":2,"rx":{"r":"subscription.usageSummary.easyMobileTcUnits","m":[{"r":[],"s":"\"smsUnits\""}]}}," units)"],"n":50,"x":{"r":["subscription.usageSummary.easyMobileTcUnits"],"s":"_0[\"smsUnits\"]>1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["subscription.usageSummary.easyMobileTcUnits"],"s":"_0[\"smsUnits\"]===1"},"f":["(",{"t":2,"rx":{"r":"subscription.usageSummary.easyMobileTcUnits","m":[{"r":[],"s":"\"smsUnits\""}]}}," unit)"]}],"x":{"r":["subscription.usageSummary.easyMobileTcUnits"],"s":"_0[\"smsUnits\"]>1"}}],"n":50,"r":"subscription.productDetails.easyMobileIndX8"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"exceed-limit"},"f":["(Exceeded SMS limit by ",{"t":2,"x":{"r":["volume","quota"],"s":"_0-_1"}}," sms)"]}," ",{"t":7,"e":"span","v":{"tap":{"n":"onShowUnbilledData","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-anchor","f":["View Details"]}]}],"n":50,"x":{"r":["utilizedQuotaPercentage"],"s":"_0>100"}}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","v":{"tap":{"n":"onShowUnbilledData","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-progress","a":{"value":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?_0:100"}}],"class":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?\"progress-orange\":\"progress-red\""}}," ",{"t":2,"x":{"r":["quota","ConfigStrings.maxQuotaSms"],"s":"_0<_1?\"limited-quota\":\"unlimited-quota\""}}]}}]}]}]}],"n":53,"r":"usageSummary.MESSAGE"}],"n":50,"r":"usageSummary.MESSAGE"}],"x":{"r":["initData.hideUsagesFrom","moment","initData.hideUsagesTill"],"s":"_1().isBetween(_1(_0,\"x\"),_1(_2,\"x\"))"}}],"p":{"dataUnitConverter":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","value"],"s":"_0.getUsageValue(_1,false)"}}," MB"],"n":50,"x":{"r":["value"],"s":"_0<1024"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["value"],"s":"(_0/1024).toFixed(2)"}}," GB"],"x":{"r":["value"],"s":"_0<1024"}}],"dataUsage":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","volume"],"s":"_0.getUsageValue(_1,false)"}}," MB"],"n":50,"x":{"r":["volume"],"s":"_0<1024"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["volume"],"s":"(_0/1024).toFixed(2)"}}," GB"],"x":{"r":["volume"],"s":"_0<1024"}}," / ",{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","quota"],"s":"_0.getUsageValue(_1,1024)"}}," GB Data ",{"t":4,"f":["- ",{"t":2,"r":"name"}],"n":50,"x":{"r":["planTypeX8"],"s":"_0===\"Roaming\""}}],"n":50,"x":{"r":["quota"],"s":"_0<1024"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["quota"],"s":"(_0/1024).toFixed(2)"}}," GB Data ",{"t":4,"f":["- ",{"t":2,"r":"name"}],"n":50,"x":{"r":["planTypeX8"],"s":"_0===\"Roaming\""}}],"x":{"r":["quota"],"s":"_0<1024"}}," ",{"t":4,"f":[{"t":4,"f":["(",{"t":2,"rx":{"r":"subscription.usageSummary.easyMobileTcUnits","m":[{"r":[],"s":"\"dataUnits\""}]}}," units)"],"n":50,"x":{"r":["subscription.usageSummary.easyMobileTcUnits"],"s":"_0[\"dataUnits\"]>1"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["subscription.usageSummary.easyMobileTcUnits"],"s":"_0[\"dataUnits\"]===1"},"f":["(",{"t":2,"rx":{"r":"subscription.usageSummary.easyMobileTcUnits","m":[{"r":[],"s":"\"dataUnits\""}]}}," unit)"]}],"x":{"r":["subscription.usageSummary.easyMobileTcUnits"],"s":"_0[\"dataUnits\"]>1"}}],"n":50,"r":"subscription.productDetails.easyMobileIndX8"}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"exceed-limit"},"f":["(Exceeded data limit by ",{"t":2,"x":{"r":["volume","quota"],"s":"((_0-_1)/1024).toFixed(2)"}}," GB)"]}],"n":50,"x":{"r":["utilizedQuotaPercentage"],"s":"_0>100"}}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","v":{"tap":{"n":"onShowUnbilledData","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-progress","a":{"value":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?_0:100"}}],"class":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?\"progress-blue\":\"progress-red\""}}]}}]}]}]}],"n":50,"x":{"r":["quota"],"s":"_0&&_0>0"}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["volume"],"s":"_0&&(_0>0)"},"f":[{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","f":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","volume"],"s":"_0.getUsageValue(_1,false)"}}," MB used"],"n":50,"x":{"r":["volume"],"s":"_0<1024"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["volume"],"s":"(_0/1024).toFixed(2)"}}," GB used"],"x":{"r":["volume"],"s":"_0<1024"}}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"exceed-limit"},"f":["(Exceeded data limit by ",{"t":2,"x":{"r":["volume","quota"],"s":"((_0-_1)/1024).toFixed(2)"}}," GB)"]}],"n":50,"x":{"r":["utilizedQuotaPercentage"],"s":"_0>100"}}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","v":{"tap":{"n":"onShowUnbilledData","d":[{"t":2,"r":"."},", ",{"t":2,"r":"summaryType"}]}},"f":[{"t":7,"e":"ux-progress","a":{"value":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?_0:100"}}],"class":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?\"progress-blue\":\"progress-red\""}}]}}]}]}]}]}],"x":{"r":["quota"],"s":"_0&&_0>0"}}]}}]};
this["ux-upcoming-events"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-upcoming-events ",{"t":4,"f":["v-",{"t":2,"r":"topSpacing"},"-top"],"n":50,"r":"topSpacing"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"clearfix"},"f":[{"t":7,"e":"ux-header","a":{"class":"left subsection-header"},"f":[{"t":2,"r":"eventsHeading"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"right text-link","href":[{"t":2,"r":"eventsRootPath"}]},"f":[{"t":2,"r":"allEventLinkText"}]}],"n":50,"r":"eventsRootPath"}]}," ",{"t":7,"e":"hr"}," ",{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"date-column"},"f":[{"t":2,"r":"eventDate"}]}," ",{"t":7,"e":"td","a":{"class":"text-link truncate-text"},"f":[{"t":7,"e":"ux-anchor","a":{"class":"text-link","href":[{"t":2,"r":"link"}]},"f":[{"t":2,"r":"eventTitle"}]}]}]}],"x":{"r":["i","eventsToBeDisplayed"],"s":"_0<_1"}}],"i":"i","r":"eventsList"}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-usage-details"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-usage-details"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-tabarea","a":{"tabs":[{"t":2,"r":"initData.tabs"}],"RactiveHelpers":[{"t":2,"r":"RactiveHelpers"}],"subscription":[{"t":2,"r":"subscription"}],"ConfigStrings":[{"t":2,"r":"ConfigStrings"}],"initData":[{"t":2,"r":"initData"}],"account":[{"t":2,"r":"account"}],"isParentLine":[{"t":2,"r":"isParentLine"}],"selectedTab":[{"t":2,"r":"selectedTab"}],"tweakData":[{"t":2,"r":"tweakData"}],"easyMobFeedback":[{"t":2,"r":"easyMobFeedback"}],"productFacade":[{"t":2,"r":"productFacade"}]},"f":[{"t":7,"e":"div","a":{"class":"v-normal-left right show-for-medium-up v-normal-right"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"plan-usage-header"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onLocalDataSetting","ariaLabel":"mobileShareModal"},"f":["Local Data & Alert Settings"]}],"n":50,"x":{"r":["selectedTab"],"s":"_0===\"local\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onRoamingDataSetting","ariaLabel":"mobileShareModal"},"f":["Roaming Data & Alert Settings"]}],"x":{"r":["selectedTab"],"s":"_0===\"local\""}}," "]}],"n":50,"x":{"r":["initData.mobileShareSettings.mobileShareSettingsLink","subscription.productDetails.isChildLine"],"s":"_0&&_1"}}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-left right show-for-medium-up"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"plan-usage-header"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onAlertHistory","selectedTab":[{"t":2,"r":"selectedTab"}],"ariaLabel":"dataSettingsModal"},"f":["Alert History"]}," "]}],"n":50,"x":{"r":["initData.dataSettings.dataSettingsLink","subscription.productDetails.isChildLine"],"s":"_0&&_1"}}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ux-tablinks","a":{"class":"left"},"f":[{"t":7,"e":"ux-tablink","a":{"id":"local","active":"true"},"f":["Local"]}," ",{"t":7,"e":"ux-tablink","a":{"id":"roaming","active":"false"},"f":["Roaming"]}]}]}," ",{"t":7,"e":"ux-tabpanes","a":{"class":"v-none-bottom","items":[{"t":2,"r":"tabs"}],"RactiveHelpers":[{"t":2,"r":"RactiveHelpers"}],"subscription":[{"t":2,"r":"subscription"}],"isParentLine":[{"t":2,"r":"isParentLine"}],"ConfigStrings":[{"t":2,"r":"ConfigStrings"}],"initData":[{"t":2,"r":"initData"}],"productFacade":[{"t":2,"r":"productFacade"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-tabpane","f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"callout-text-copy"},"f":[{"t":2,"r":"ConfigStrings.genericError.usageErrorMsg"}]}],"n":50,"x":{"r":["usageSummary"],"s":"_0===\"usageSummaryError\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["usageSummary.Local"],"s":"_0"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header v-medium-right"},"f":[{"t":2,"r":"plan.displayName"}]}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onMobileShareSetting","subscription":[{"t":2,"r":"subscription"}],"ariaLabel":"dataSettingsModal"},"f":["Manage MobileShare"]}],"n":50,"r":"isParentLine"}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top v-large-bottom"},"f":["From ",{"t":2,"x":{"r":["RactiveHelpers","usageSummary.cycleStartDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}," To ",{"t":2,"x":{"r":["RactiveHelpers","usageSummary.cycleEndDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}," ",{"t":7,"e":"ux-unbilled-usage","a":{"usageSummary":[{"t":2,"r":"usageSummary.Local"}],"summaryType":"Local","subscription":[{"t":2,"r":"subscription"}],"initData":[{"t":2,"r":"initData"}],"productFacade":[{"t":2,"r":"productFacade"}]},"f":[{"t":7,"e":"ux-unbilled-usage"}]}]}],"x":{"r":["usageSummary"],"s":"_0===\"usageSummaryError\""}}]}]}]}," ",{"t":7,"e":"ux-tabpane","f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"medium-8"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"callout-text-copy"},"f":[{"t":2,"r":"ConfigStrings.genericError.usageErrorMsg"}]}],"n":50,"x":{"r":["usageSummary"],"s":"_0===\"usageSummaryError\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["usageSummary.Roaming"],"s":"_0"},"f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"subsection-header"},"f":[{"t":2,"x":{"r":["ecarePlanName","plan.displayName"],"s":"_0||_1"}}]}," ",{"t":7,"e":"div","a":{"class":"v-small-top v-large-bottom"},"f":["From ",{"t":2,"x":{"r":["RactiveHelpers","usageSummary.cycleStartDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}," To ",{"t":2,"x":{"r":["RactiveHelpers","usageSummary.cycleEndDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}," ",{"t":7,"e":"ux-unbilled-usage","a":{"usageSummary":[{"t":2,"r":"usageSummary.Roaming"}],"subscription":[{"t":2,"r":"subscription"}],"summaryType":"Roaming","initData":[{"t":2,"r":"initData"}]},"f":[{"t":7,"e":"ux-unbilled-usage"}]}]}],"x":{"r":["usageSummary"],"s":"_0===\"usageSummaryError\""}}]}]}]}],"n":53,"r":"subscription"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"text-center show-for-small-only v-normal-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"plan-usage-header"},"f":[" ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onLocalDataSetting","ariaLabel":"mobileShareModal"},"f":["Local Data & Alert Settings"]}],"n":50,"x":{"r":["selectedTab"],"s":"_0===\"local\""}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onRoamingDataSetting","ariaLabel":"mobileShareModal"},"f":["Roaming Data & Alert Settings"]}],"x":{"r":["selectedTab"],"s":"_0===\"local\""}}]}],"n":50,"x":{"r":["initData.mobileShareSettings.mobileShareSettingsLink","subscription.productDetails.isChildLine"],"s":"_0&&_1"}}]}],"n":50,"x":{"r":["initData.mobileShareSettings.mobileShareSettingsLink","subscription.productDetails.isChildLine"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"text-center show-for-small-only v-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"plan-usage-header"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onAlertHistory","selectedTab":[{"t":2,"r":"selectedTab"}],"ariaLabel":"dataSettingsModal"},"f":["Alert History"]}," "]}],"n":50,"x":{"r":["initData.dataSettings.dataSettingsLink","subscription.productDetails.isChildLine"],"s":"_0&&_1"}}]}],"n":50,"x":{"r":["initData.dataSettings.dataSettingsLink","subscription.productDetails.isChildLine"],"s":"_0&&_1"}}," ",{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"borderColor"},"f":[{"t":7,"e":"div","f":["New unit allocation starting from next cycle"]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"b","f":[{"t":2,"r":"subscription.tweakData.talktime.unit"},"units - ",{"t":2,"r":"subscription.tweakData.talktime.quantity"},"min Talktime ",{"t":2,"r":"subscription.tweakData.sms.unit"},"units - ",{"t":2,"r":"subscription.tweakData.sms.quantity"},"SMS ",{"t":2,"r":"subscription.tweakData.data.unit"},"units - ",{"t":2,"r":"subscription.tweakData.data.quantity"},"GB Data"]}]}]}]}],"n":50,"r":"subscription.tweakData"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"medium-6 text-left v-normal-bottom-mobile v-small-top small-only-text-center"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"easyMobFeedback.link"}],"ariaLabel":[{"t":2,"r":"easyMobFeedback.ariaLable"}]},"f":[{"t":2,"r":"easyMobFeedback.title"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-6 text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":"round default expand-for-mobile margin-zero","onclick":"tweakPlan","text":"Tweak Your Plan"},"f":[]}]}],"n":50,"r":"easyMobFeedback.enable"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"text-right"},"f":[{"t":7,"e":"ux-button","a":{"class":"round default expand-for-mobile margin-zero","onclick":"tweakPlan","text":"Tweak Your Plan"},"f":[]}]}],"r":"easyMobFeedback.enable"}],"n":50,"r":"account.isEasyMobile"}]}]}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-modal","a":{"width":"900","class":"light-theme","modalId":"dataSettingsModal"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":2,"r":"dataSettings.dataSettingsHeaderText"}]}," ",{"t":7,"e":"ux-iframe","a":{"src":[{"t":2,"r":"dataSettings.dataSettingsLink"}],"width":"100%"}}]}],"n":50,"r":"dataSettings.dataSettingsLink"}," ",{"t":4,"f":[{"t":7,"e":"ux-modal","a":{"width":"900","class":"light-theme","modalId":"mobileShareModal"},"f":[{"t":7,"e":"ux-header","a":{"level":"2"},"f":[{"t":2,"r":"mobileShareSettings.mobileShareSettingsHeaderText"}]}," ",{"t":7,"e":"ux-iframe","a":{"src":[{"t":2,"r":"mobileShareSettings.mobileShareSettingsLink"}],"width":"100%"}}]}],"n":50,"r":"mobileShareSettings.mobileShareSettingsLink"}],"n":53,"r":"initData"},{"t":4,"f":[{"t":7,"e":"ux-modal","a":{"width":"900","class":"light-theme","modalId":"unbilledEventsModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":[{"t":2,"r":"unbilledUsageEventContext.summaryType"}," ",{"t":2,"r":"unbilledUsageEventContext.usageType"}," usage - Unbilled"]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","f":["Usage for ",{"t":2,"r":"serviceId"}]}," ",{"t":7,"e":"div","f":["From ",{"t":2,"x":{"r":["RactiveHelpers","usageSummary.cycleStartDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}," To ",{"t":2,"x":{"r":["RactiveHelpers","usageSummary.cycleEndDate"],"s":"_0.convertMilisTimestampToDate(_1)"}}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"table","a":{"class":"unbilled-usage-events-table show-for-medium-up"},"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"th","f":["Date"]}," ",{"t":7,"e":"th","f":["Time"]}," ",{"t":7,"e":"th","f":["Direction"]}," ",{"t":7,"e":"th","f":["Bytes Usage"]}," ",{"t":7,"e":"th","f":["Amount (Before free bundle)"]}]}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":2,"x":{"r":["RactiveHelpers","startTime"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM\")"}}]}," ",{"t":7,"e":"td","f":[{"t":2,"x":{"r":["RactiveHelpers","startTime"],"s":"_0.convertMilisTimestampToDate(_1,\"h:mm A\")"}}]}," ",{"t":7,"e":"td","f":[{"t":2,"r":"direction"}]}," ",{"t":7,"e":"td","f":[{"t":2,"x":{"r":["volume"],"s":"_0*1024*1024"}}," bytes"]}," ",{"t":7,"e":"td","f":[{"t":2,"x":{"r":["RactiveHelpers","chargeAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"n":52,"rx":{"r":"unbilledUsageEvents","m":[{"t":30,"n":"unbilledUsageEventContext.summaryType"},{"t":30,"n":"unbilledUsageEventContext.usageType"}]}}]}," ",{"t":7,"e":"div","a":{"class":"unbilled-usage-events-table show-for-small-only"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Date"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","startTime"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM\")"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","startTime"],"s":"_0.convertMilisTimestampToDate(_1,\"h:mm A\")"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Direction"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"r":"direction"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Bytes Usage"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["volume"],"s":"_0*1024*1024"}}," bytes"]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Amount (Before free bundle)"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","chargeAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":52,"rx":{"r":"unbilledUsageEvents","m":[{"t":30,"n":"unbilledUsageEventContext.summaryType"},{"t":30,"n":"unbilledUsageEventContext.usageType"}]}}]}],"n":50,"x":{"r":["unbilledUsageEventContext.usageType"],"s":"_0===\"DATA\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["unbilledUsageEventContext.usageType"],"s":"_0===\"VOICE\""},"f":[{"t":7,"e":"table","a":{"class":"unbilled-usage-events-table show-for-medium-up"},"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"th","f":["Date"]}," ",{"t":7,"e":"th","f":["Time"]}," ",{"t":7,"e":"th","f":["Direction"]}," ",{"t":7,"e":"th","f":["Mobile Number"]}," ",{"t":7,"e":"th","f":["Duration"]}," ",{"t":7,"e":"th","f":["Amount (Before free bundle)"]}]}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":2,"x":{"r":["RactiveHelpers","startTime"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM\")"}}]}," ",{"t":7,"e":"td","f":[{"t":2,"x":{"r":["RactiveHelpers","startTime"],"s":"_0.convertMilisTimestampToDate(_1,\"h:mm A\")"}}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":["Incoming"],"n":50,"r":"incoming"},{"t":4,"n":51,"f":["Outgoing"],"r":"incoming"}]}," ",{"t":7,"e":"td","f":[{"t":2,"r":"destinationCountry"}," ",{"t":2,"r":"destinationNumber"}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":2,"x":{"r":["moment","hours","minutes","seconds"],"s":"_0({hour:_1,minute:_2,seconds:_3}).format(\"HH:mm:ss\")"}}],"n":53,"r":"duration"}]}," ",{"t":7,"e":"td","f":[{"t":2,"x":{"r":["RactiveHelpers","chargeAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"n":52,"rx":{"r":"unbilledUsageEvents","m":[{"t":30,"n":"unbilledUsageEventContext.summaryType"},{"t":30,"n":"unbilledUsageEventContext.usageType"}]}}]}," ",{"t":7,"e":"div","a":{"class":"unbilled-usage-events-table show-for-small-only"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Date"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","startTime"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM\")"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","startTime"],"s":"_0.convertMilisTimestampToDate(_1,\"h:mm A\")"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Direction"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":4,"f":["Incoming"],"n":50,"r":"incoming"},{"t":4,"n":51,"f":["Outgoing"],"r":"incoming"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Mobile Number"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"r":"destinationCountry"}," ",{"t":2,"r":"destinationNumber"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Duration"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["moment","hours","minutes","seconds"],"s":"_0({hour:_1,minute:_2,seconds:_3}).format(\"HH:mm:ss\")"}}],"n":53,"r":"duration"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Amount (Before free bundle)"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","chargeAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":52,"rx":{"r":"unbilledUsageEvents","m":[{"t":30,"n":"unbilledUsageEventContext.summaryType"},{"t":30,"n":"unbilledUsageEventContext.usageType"}]}}]}]},{"t":4,"n":50,"x":{"r":["unbilledUsageEventContext.usageType"],"s":"(!(_0===\"VOICE\"))&&(_0===\"MESSAGE\")"},"f":[" ",{"t":7,"e":"table","a":{"class":"unbilled-usage-events-table show-for-medium-up"},"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"th","f":["Date"]}," ",{"t":7,"e":"th","f":["Time"]}," ",{"t":7,"e":"th","f":["Mobile Number"]}," ",{"t":7,"e":"th","f":["Amount (Before free bundle)"]}]}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":2,"x":{"r":["RactiveHelpers","startTime"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM\")"}}]}," ",{"t":7,"e":"td","f":[{"t":2,"x":{"r":["RactiveHelpers","startTime"],"s":"_0.convertMilisTimestampToDate(_1,\"h:mm A\")"}}]}," ",{"t":7,"e":"td","f":[{"t":2,"r":"destinationCountry"}," ",{"t":2,"r":"destinationNumber"}]}," ",{"t":7,"e":"td","f":[{"t":2,"x":{"r":["RactiveHelpers","chargeAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}],"n":52,"rx":{"r":"unbilledUsageEvents","m":[{"t":30,"n":"unbilledUsageEventContext.summaryType"},{"t":30,"n":"unbilledUsageEventContext.usageType"}]}}]}," ",{"t":7,"e":"div","a":{"class":"unbilled-usage-events-table show-for-small-only"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Date"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","startTime"],"s":"_0.convertMilisTimestampToDate(_1,\"DD MMM\")"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Time"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","startTime"],"s":"_0.convertMilisTimestampToDate(_1,\"h:mm A\")"}}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Mobile Number"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"r":"destinationCountry"}," ",{"t":2,"r":"destinationNumber"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":7,"e":"strong","f":["Amount (Before free bundle)"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"x":{"r":["RactiveHelpers","chargeAmount"],"s":"_0.convertUnits(_1,\"$\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider"}}],"n":52,"rx":{"r":"unbilledUsageEvents","m":[{"t":30,"n":"unbilledUsageEventContext.summaryType"},{"t":30,"n":"unbilledUsageEventContext.usageType"}]}}]}]}],"x":{"r":["unbilledUsageEventContext.usageType"],"s":"_0===\"DATA\""}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"text-center center"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onLoadMoreClick"},"f":["Load More"]}]}]}],"n":50,"x":{"r":["unbilledUsageEvents.itemsFetched","unbilledUsageEvents.totalResults"],"s":"_0<_1"}}]}],"n":53,"r":"subscription"},{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"tweakPlanModal"},"f":[{"t":7,"e":"ux-row","a":{"class":"section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Tweak Your Plan"]}]}]}," ",{"t":7,"e":"ux-tweakplan","a":{"permission":[{"t":2,"r":"permission"}],"subscription":[{"t":2,"r":"subscription"}],"initData":[{"t":2,"r":"initData"}]}}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"ux-usage-details light-theme","modalId":"localUsageDistributionModal"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Local Data Usage"]}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":" v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["combinedLocalUsage.volume"],"s":"{value:_0}"}}," / ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["combinedLocalUsage.quota"],"s":"{value:_0}"}}],"n":50,"x":{"r":["combinedLocalUsage.quota","ConfigStrings.maxQuotaData","combinedLocalUsage.isXLiteAddonPresent"],"s":"_0<_1&&!_2"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"unlimitedText"},"f":["Unlimited* Data"]}],"x":{"r":["combinedLocalUsage.quota","ConfigStrings.maxQuotaData","combinedLocalUsage.isXLiteAddonPresent"],"s":"_0<_1&&!_2"}}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"exceed-limit"},"f":["(Exceeded data limit by ",{"t":2,"x":{"r":["combinedLocalUsage.volume","combinedLocalUsage.quota"],"s":"((_0-_1)/1024).toFixed(2)"}}," GB)"]}],"n":50,"x":{"r":["combinedLocalUsage.utilizedQuotaPercentage","combinedLocalUsage.isXLiteAddonPresent"],"s":"_0>100&&!_1"}}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-progress","a":{"value":"100","class":"progress-blue unlimited-quota"}}]}]}],"n":50,"r":"combinedLocalUsage.isXLiteAddonPresent"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-progress","a":{"value":[{"t":2,"x":{"r":["combinedLocalUsage.utilizedQuotaPercentage"],"s":"_0<=100?_0:100"}}],"class":[{"t":2,"x":{"r":["combinedLocalUsage.utilizedQuotaPercentage"],"s":"_0<=100?\"progress-blue\":\"progress-red\""}}]}}]}]}],"r":"combinedLocalUsage.isXLiteAddonPresent"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"r":"name"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"span","a":{"class":"unlimitedText"},"f":["Unlimited"]}]}]}],"n":50,"x":{"r":["combinedLocalUsage.isXLiteAddonPresent","isAddon"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"r":"name"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":2,"x":{"r":["i"],"s":"_0>0?\"+\":\"\""}},{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["quota"],"s":"{value:_0}"}}]}]}],"x":{"r":["combinedLocalUsage.isXLiteAddonPresent","isAddon"],"s":"_0&&_1"}}],"n":52,"i":"i","r":"DATA"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-medium"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":[{"t":2,"r":"name"}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":["+",{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["quota"],"s":"{value:_0}"}}]}]}],"n":52,"r":"bonusDataUsage"}," ",{"t":7,"e":"div","a":{"class":"panel-divider v-medium"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":["Total"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"unlimitedText"},"f":["Unlimited"]}],"n":50,"r":"combinedLocalUsage.isXLiteAddonPresent"},{"t":4,"n":51,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["combinedLocalUsage.quota"],"s":"{value:_0}"}}],"r":"combinedLocalUsage.isXLiteAddonPresent"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":["Used"]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-anchor","a":{"combinedLocalUsage":[{"t":2,"r":"combinedLocalUsage"}],"ontap":"onShowUnbilledData:false,Local"},"f":["-",{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["combinedLocalUsage.volume"],"s":"{value:_0}"}}]}]}],"n":50,"x":{"r":["combinedLocalUsage.volume","combinedLocalUsage.quota"],"s":"(_0-_1)>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":["-",{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["combinedLocalUsage.volume"],"s":"{value:_0}"}}]}],"x":{"r":["combinedLocalUsage.volume","combinedLocalUsage.quota"],"s":"(_0-_1)>0"}}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider v-medium"}}," ",{"t":7,"e":"ux-row","a":{"class":"subsection-header"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":["Balance"]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"span","a":{"class":"unlimitedText"},"f":["Unlimited* Data"]}]}],"n":50,"r":"combinedLocalUsage.isXLiteAddonPresent"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":7,"e":"ux-anchor","a":{"combinedLocalUsage":[{"t":2,"r":"combinedLocalUsage"}],"ontap":"onShowUnbilledData:false,Local"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["combinedLocalUsage.quota","combinedLocalUsage.volume"],"s":"{value:_0-_1}"}}]}]}],"n":50,"x":{"r":["combinedLocalUsage.volume","combinedLocalUsage.quota"],"s":"(_0-_1)>0"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["combinedLocalUsage.quota","combinedLocalUsage.volume"],"s":"{value:_0-_1}"}}]}],"x":{"r":["combinedLocalUsage.volume","combinedLocalUsage.quota"],"s":"(_0-_1)>0"}}],"r":"combinedLocalUsage.isXLiteAddonPresent"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"panel-divider v-normal"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":["Exceeded"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right alert-text"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["combinedLocalUsage.volume","combinedLocalUsage.quota"],"s":"{value:(_0-_1)}"}}]}]}],"n":50,"x":{"r":["combinedLocalUsage.utilizedQuotaPercentage","combinedLocalUsage.isXLiteAddonPresent"],"s":"_0>100&&!_1"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-large-top"},"f":[{"t":7,"e":"ux-col","a":{"class":"subsection-header"},"f":[{"t":2,"r":"ConfigStrings.usageAddon.title"}]}," ",{"t":7,"e":"ux-col","f":[{"t":2,"r":"ConfigStrings.usageAddon.description"}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-anchor","a":{"manageAddonUrl":[{"t":2,"r":"addonInitData.manageAddonUrl"}],"product":[{"t":2,"r":"product"}],"permission":[{"t":2,"r":"permission"}],"account":[{"t":2,"r":"account"}],"subscription":[{"t":2,"r":"subscription"}],"ontap":"manageAddons"},"f":["Manage Add-ons"]}]}]}],"n":50,"x":{"r":["combinedLocalUsage.utilizedQuotaPercentage"],"s":"_0>100"}}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"subsection-header v-large-top v-normal-bottom"},"f":[{"t":2,"r":"initData.usageInitData.dataBreakupNoteTitle"}]}," ",{"t":7,"e":"ux-col","f":[{"t":3,"x":{"r":["RactiveHelpers","initData.usageInitData.dataBreakupNoteDescription"],"s":"_0.unescapeString(_1)"}}]}]}],"n":53,"r":"subscription.usageSummary.Local"}],"n":50,"x":{"r":["subscription","subscription.usageSummary"],"s":"_0&&_1"}}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"ux-usage-details light-theme","modalId":"sponsoredUsageDistributionModal"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"2","class":"section-header"},"f":["Additional Local Data"]}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal"},"f":[{"t":7,"e":"ux-col","a":{"class":"subsection-header"},"f":[{"t":2,"r":"ecarePlanName"}]}," ",{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":4,"f":["Expires today at ",{"t":2,"x":{"r":["moment","expiryDate"],"s":"_0(_1,\"DD-MMM-YYYY HH:mm\").format(\"HH:mm A\")"}}],"n":50,"x":{"r":["expiryDate","moment"],"s":"_1(_0,\"DD-MMM-YYYY HH:mm\").isSame(_1(),\"day\")"}},{"t":4,"n":51,"f":["Expires ",{"t":2,"x":{"r":["moment","expiryDate"],"s":"_0(_1,\"DD-MMM-YYYY HH:mm\").format(\"DD MMM, HH:mm A\")"}}],"x":{"r":["expiryDate","moment"],"s":"_1(_0,\"DD-MMM-YYYY HH:mm\").isSame(_1(),\"day\")"}}],"n":50,"r":"expiryDate"}]}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"span","f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["volume"],"s":"{value:_0}"}}," / ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["quota"],"s":"{value:_0}"}}],"n":50,"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"unlimitedText"},"f":["Unlimited* Data"]}],"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-progress","a":{"value":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?_0:100"}}],"class":[{"t":2,"x":{"r":["utilizedQuotaPercentage"],"s":"_0<=100?\"progress-blue\":\"progress-red\""}}]}}]}]}],"n":50,"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"ux-progress","a":{"value":"100","class":"progress-blue unlimited-quota"}}]}]}],"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1"}}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":["Free Data"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["quota"],"s":"{value:_0}"}}],"n":50,"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1"}},{"t":4,"n":51,"f":[{"t":7,"e":"span","a":{"class":"unlimitedText"},"f":["Unlimited* Data"]}],"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1"}}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":["Used"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":["-",{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["volume"],"s":"{value:_0}"}}]}]}," ",{"t":7,"e":"div","a":{"class":"panel-divider v-normal"}}," ",{"t":7,"e":"ux-row","a":{"class":"subsection-header v-large-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-6"},"f":["Balance"]}," ",{"t":7,"e":"ux-col","a":{"class":"small-6 text-right"},"f":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"dataUnitConverter"}],"x":{"r":["quota","volume"],"s":"{value:_0-_1}"}}],"n":50,"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1"}},{"t":4,"n":51,"f":["Unlimited* Data"],"x":{"r":["quota","ConfigStrings.maxQuotaData"],"s":"_0<_1"}}]}]}],"n":52,"i":"i","r":"sponsoredData"}],"n":53,"r":"subscription.usageSummary.Local"}],"n":50,"x":{"r":["subscription","subscription.usageSummary"],"s":"_0&&_1"}}]}],"p":{"dataUnitConverter":[{"t":4,"f":[{"t":2,"x":{"r":["RactiveHelpers","value"],"s":"_0.getUsageValue(_1,false)"}}," MB"],"n":50,"x":{"r":["value"],"s":"_0<1024&&_0>=-1024"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["value"],"s":"(_0/1024).toFixed(2)"}}," GB"],"x":{"r":["value"],"s":"_0<1024&&_0>=-1024"}}]}};
this["ux-use-existing-number"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-use-existing-number ",{"t":2,"r":"class"}]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"medium-4"},"f":[{"t":4,"f":[{"t":7,"e":"ux-form-validity","a":{"status":"error","message":[{"t":2,"r":"existingNumberError"}]},"f":[]}],"n":50,"r":"existingNumberError"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["number-box section-header v-medium-bottom cursor ",{"t":2,"r":"associatedtechnology"}," ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["fibreEligibility"],"s":"!_0"}}," ",{"t":2,"r":"getExistingNumberState"}]},"v":{"tap":{"n":"setSelectedLine","d":[{"t":2,"r":"associatedtechnology"}]}},"f":[{"t":2,"x":{"r":["RactiveHelpers","serviceID"],"s":"_0.mobileNumberFormat(_1)"}}," ",{"t":7,"e":"span","a":{"class":"v-medium-left body-light"},"f":[{"t":2,"x":{"r":["RactiveHelpers","associatedtechnology"],"s":"_0.getTechnologyConfig(_1,\"title\")"}}]}]}],"i":"index","r":"existingNumbers"}]}]}]}]};
this["ux-vertical-plan"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-vertical-plan margin-center-plan swiper-slide"},"f":[{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up center-column"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-none-padding radius-plan","style":["width:calc(100%/",{"t":3,"r":"plans.length"},"); float:left;position:relative;"]},"f":[{"t":7,"e":"div","a":{"class":["panel panel-height text-center margin-zero p-none-top ",{"t":4,"f":[{"t":2,"r":"verticalMetaData.theme"}],"n":50,"x":{"r":["verticalMetaData.gradientStart","verticalMetaData.gradientEnd","featured"],"s":"_0&&_1&&_2"}}],"style":[{"t":4,"f":["background: -webkit-linear-gradient(",{"t":2,"r":"verticalMetaData.gradientStart"},", ",{"t":2,"r":"verticalMetaData.gradientEnd"},"); background: -o-linear-gradient(",{"t":2,"r":"verticalMetaData.gradientStart"},", ",{"t":2,"r":"verticalMetaData.gradientEnd"},"); background: -moz-linear-gradient(",{"t":2,"r":"verticalMetaData.gradientStart"},", ",{"t":2,"r":"verticalMetaData.gradientEnd"},"); background: linear-gradient(",{"t":2,"r":"verticalMetaData.gradientStart"},", ",{"t":2,"r":"verticalMetaData.gradientEnd"},");"],"n":50,"x":{"r":["verticalMetaData.gradientStart","verticalMetaData.gradientEnd","featured"],"s":"_0&&_1&&_2"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ribbon-box"},"f":[{"t":7,"e":"div","a":{"class":["ribbon-block ",{"t":4,"f":[{"t":2,"r":"verticalMetaData.theme"}],"n":50,"r":"ribbon"}],"style":[{"t":4,"f":["background-color: ",{"t":2,"r":"verticalMetaData.ribbonColor"},";"],"n":50,"r":"verticalMetaData.ribbonColor"}]},"f":[{"t":2,"r":"ribbon"}]}]}],"n":50,"r":"ribbon"}," ",{"t":7,"e":"div","a":{"class":"product-title v-2x-large-top v-2x-large-bottom"},"f":[{"t":7,"e":"b","f":[{"t":2,"r":"planName"}]}]}," ",{"t":7,"e":"div","a":{"class":["v-small-large-bottom ",{"t":4,"f":["simonly-panel"],"n":50,"r":"contractMonth"}]},"f":[{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"data.quantity"},{"t":2,"r":"data.unit"}]}," ",{"t":4,"f":[{"t":2,"r":"dataLabel"}],"n":50,"r":"dataLabel"},{"t":4,"n":51,"f":["Data"],"r":"dataLabel"},{"t":4,"f":["*"],"n":50,"r":"dataDisclaimer"}],"n":50,"x":{"r":["data.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"simOnlyData.quantity"},{"t":2,"r":"simOnlyData.unit"}]}," ",{"t":2,"r":"simOnlyDataLabel"},{"t":4,"f":["*"],"n":50,"r":"simOnlyDataDisclaimer"}],"n":50,"x":{"r":["simOnlyData.quantity","simOnlyDataLabel"],"s":"_0&&_1"}}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"talktime.quantity"}]}," Mins",{"t":4,"f":["*"],"n":50,"r":"minsDisclaimer"}],"n":50,"x":{"r":["talktime.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"sms.quantity"}]}," SMS",{"t":4,"f":["*"],"n":50,"r":"smsDisclaimer"}],"n":50,"x":{"r":["sms.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"contractMonth"}],"n":50,"r":"contractMonth"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"benefit-panel"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"b","f":[{"t":2,"r":"subTitle"}]}]}],"n":50,"r":"subTitle"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-spacing"},"f":[{"t":2,"r":"subLiner"}]}],"n":50,"r":"subLiner"}]}," ",{"t":7,"e":"div","a":{"class":"panel-height20 v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":[{"t":4,"f":[{"t":2,"r":"verticalMetaData.theme"}," a",{"t":2,"r":"verticalMetaData.theme"}],"n":50,"x":{"r":["verticalMetaData.gradientStart","verticalMetaData.gradientEnd","featured"],"s":"_0&&_1&&_2"}}],"ontap":"toggleDetails:showDetails","selectedPlan":[{"t":2,"r":"."}]},"f":[{"t":2,"r":"planUrlTitle"}]}],"n":50,"r":"planUrlTitle"}]}],"n":50,"x":{"r":["verticalMetaData.hideBenefitPanel"],"s":"!_0"}}," ",{"t":7,"e":"div","a":{"class":[{"t":4,"f":["v-x-large-top"],"n":50,"x":{"r":["verticalMetaData.hideBenefitPanel"],"s":"!_0"}}," v-large-bottom line"]}}," ",{"t":7,"e":"div","a":{"class":"v-small-bottom p-medium-top flex-container flex-container-center"},"f":[{"t":7,"e":"span","a":{"class":"dollar-txt"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyCharges"],"s":"_0.convertUnits(_1,\"showdollars\")"}}]}," ",{"t":7,"e":"span","a":{"class":"cent-txt"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyCharges"],"s":"_0.convertUnits(_1,\"showcents\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"p-small-bottom"},"f":["monthly"]}," ",{"t":7,"e":"div","a":{"class":"v-small-large-top","style":["color : ",{"t":2,"r":"verticalMetaData.gradientEnd"},";"]},"f":[{"t":7,"e":"ux-button","a":{"class":["v-large-bottom select-phones-buttons ",{"t":4,"f":["transparent"],"n":50,"x":{"r":["verticalMetaData.gradientStart","verticalMetaData.gradientEnd","featured"],"s":"_0&&_1&&_2"}},{"t":4,"n":51,"f":[{"t":2,"r":"verticalMetaData.brand"}],"x":{"r":["verticalMetaData.gradientStart","verticalMetaData.gradientEnd","featured"],"s":"_0&&_1&&_2"}}," round"],"text":"Select","linkto":[{"t":2,"r":"./linkUrl"}],"onclick":"navigateToPath"}}]}]}]}],"n":52,"i":"i","r":"./plans"}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only center-column"},"f":[{"t":7,"e":"div","a":{"class":"swiper-container"},"f":[{"t":7,"e":"div","a":{"class":"swiper-wrapper"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"swiper-slide"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 v-none-padding fixed-column-width radius-plan"},"f":[{"t":7,"e":"div","a":{"class":["panel panel-height text-center margin-zero p-none-top ",{"t":4,"f":[{"t":2,"r":"verticalMetaData.theme"}],"n":50,"x":{"r":["verticalMetaData.gradientStart","verticalMetaData.gradientEnd","featured"],"s":"_0&&_1&&_2"}}],"style":[{"t":4,"f":["background: -webkit-linear-gradient(",{"t":2,"r":"verticalMetaData.gradientStart"},", ",{"t":2,"r":"verticalMetaData.gradientEnd"},"); background: -o-linear-gradient(",{"t":2,"r":"verticalMetaData.gradientStart"},", ",{"t":2,"r":"verticalMetaData.gradientEnd"},"); background: -moz-linear-gradient(",{"t":2,"r":"verticalMetaData.gradientStart"},", ",{"t":2,"r":"verticalMetaData.gradientEnd"},"); background: linear-gradient(",{"t":2,"r":"verticalMetaData.gradientStart"},", ",{"t":2,"r":"verticalMetaData.gradientEnd"},");"],"n":50,"x":{"r":["verticalMetaData.gradientStart","verticalMetaData.gradientEnd","featured"],"s":"_0&&_1&&_2"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ribbon-box"},"f":[{"t":7,"e":"div","a":{"class":["ribbon-block ",{"t":4,"f":[{"t":2,"r":"verticalMetaData.theme"}],"n":50,"r":"ribbon"}],"style":[{"t":4,"f":["background-color: ",{"t":2,"r":"verticalMetaData.ribbonColor"},";"],"n":50,"r":"verticalMetaData.ribbonColor"}]},"f":[{"t":2,"r":"ribbon"}]}]}],"n":50,"r":"ribbon"}," ",{"t":7,"e":"div","a":{"class":"product-title v-2x-large-top v-2x-large-bottom"},"f":[{"t":7,"e":"b","f":[{"t":2,"r":"planName"}]}]}," ",{"t":7,"e":"div","a":{"class":["v-small-large-bottom ",{"t":4,"f":["simonly-panel"],"n":50,"r":"contractMonth"}]},"f":[{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"data.quantity"},{"t":2,"r":"data.unit"}]}," ",{"t":4,"f":[{"t":2,"r":"dataLabel"}],"n":50,"r":"dataLabel"},{"t":4,"n":51,"f":["Data"],"r":"dataLabel"},{"t":4,"f":["*"],"n":50,"r":"dataDisclaimer"}],"n":50,"x":{"r":["data.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"simOnlyData.quantity"},{"t":2,"r":"simOnlyData.unit"}]}," ",{"t":2,"r":"simOnlyDataLabel"},{"t":4,"f":["*"],"n":50,"r":"simOnlyDataDisclaimer"}],"n":50,"x":{"r":["simOnlyData.quantity","simOnlyDataLabel"],"s":"_0&&_1"}}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"talktime.quantity"}]}," Mins",{"t":4,"f":["*"],"n":50,"r":"minsDisclaimer"}],"n":50,"x":{"r":["talktime.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":7,"e":"b","f":[{"t":2,"r":"sms.quantity"}]}," SMS",{"t":4,"f":["*"],"n":50,"r":"smsDisclaimer"}],"n":50,"x":{"r":["sms.quantity"],"s":"_0&&(_0>0||_0===\"Unlimited\")"}}]}," ",{"t":7,"e":"div","f":[{"t":4,"f":[{"t":2,"r":"contractMonth"}],"n":50,"r":"contractMonth"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"mbenefit-panel p-large-left p-large-right"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"v-medium-bottom"},"f":[{"t":7,"e":"b","f":[{"t":2,"r":"subTitle"}]}]}],"n":50,"r":"subTitle"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"body-spacing"},"f":[{"t":2,"r":"subLiner"}]}],"n":50,"r":"subLiner"}]}," ",{"t":7,"e":"div","a":{"class":"panel-height20 v-medium-top"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":[{"t":4,"f":[{"t":2,"r":"verticalMetaData.theme"}," a",{"t":2,"r":"verticalMetaData.theme"}],"n":50,"x":{"r":["verticalMetaData.gradientStart","verticalMetaData.gradientEnd","featured"],"s":"_0&&_1&&_2"}}],"ontap":"toggleDetails:showDetails","selectedPlan":[{"t":2,"r":"."}]},"f":[{"t":2,"r":"planUrlTitle"}]}],"n":50,"r":"planUrlTitle"}]}],"n":50,"x":{"r":["verticalMetaData.hideBenefitPanel"],"s":"!_0"}}," ",{"t":7,"e":"div","a":{"class":[{"t":4,"f":["v-x-large-top"],"n":50,"x":{"r":["verticalMetaData.hideBenefitPanel"],"s":"!_0"}}," v-large-bottom line"]}}," ",{"t":7,"e":"div","a":{"class":"v-small-bottom"},"f":[{"t":7,"e":"span","a":{"class":"dollar-txt"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyCharges"],"s":"_0.convertUnits(_1,\"showdollars\")"}}]}," ",{"t":7,"e":"span","a":{"class":"cent-txt"},"f":[{"t":2,"x":{"r":["RactiveHelpers","monthlyCharges"],"s":"_0.convertUnits(_1,\"showcents\")"}}]}]}," ",{"t":7,"e":"div","f":["monthly"]}," ",{"t":7,"e":"div","a":{"class":"v-large-top","style":["color : ",{"t":2,"r":"verticalMetaData.gradientEnd"},";"]},"f":[{"t":7,"e":"ux-button","a":{"class":["select-phones-buttons ",{"t":4,"f":["transparent"],"n":50,"x":{"r":["verticalMetaData.gradientStart","verticalMetaData.gradientEnd","featured"],"s":"_0&&_1&&_2"}},{"t":4,"n":51,"f":[{"t":2,"r":"verticalMetaData.brand"}],"x":{"r":["verticalMetaData.gradientStart","verticalMetaData.gradientEnd","featured"],"s":"_0&&_1&&_2"}}," round"],"text":"Select","linkto":[{"t":2,"r":"./linkUrl"}],"onclick":"navigateToPath"}}]}]}]}]}],"n":52,"i":"i","r":"./plans"}]}," ",{"t":7,"e":"div","a":{"class":"swiper-button-next"},"f":[{"t":7,"e":"ux-icon","a":{"type":"carousel-next","size":"l"}}]}," ",{"t":7,"e":"div","a":{"class":"swiper-button-prev"},"f":[{"t":7,"e":"ux-icon","a":{"type":"carousel-prev","size":"l"}}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"700","class":"light-theme","modalId":"showDetails"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header"},"f":[{"t":2,"r":"planDetailsTitleSelected"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-medium-top"},"f":[{"t":7,"e":"div","a":{"class":"section-details"},"f":[{"t":3,"r":"planDetailsSelected"}]}]}]}]}]}]};
this["ux-vertical-tout-fill"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-vertical-tout-fill"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"banner-background vertical-tout-fill-container","style":["background-image:url('",{"t":2,"r":"backgroundImg"},"');height:",{"t":2,"r":"height"},"px"]},"f":[{"t":7,"e":"div","a":{"class":"banner-content-outer"},"f":[{"t":7,"e":"div","a":{"class":"banner-content-inner"},"f":[{"t":7,"e":"div","a":{"class":"banner-content"},"f":[{"t":7,"e":"div","a":{"class":"text-center v-normal-top"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}],"class":"v-medium-top"},"f":[{"t":2,"r":"linkText"}]}]}]}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-vertical-tout"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"style","f":["      .panel.backgroundcss {\n        background-color: ",{"t":2,"r":"bgColor"}," !important;\n      }\n  "]}],"n":50,"r":"bgColor"},{"t":7,"e":"div","a":{"class":["ux-vertical-tout ",{"t":4,"f":["full-img"],"n":50,"x":{"r":["imageType"],"s":"_0===\"fullWidth\""}}," ",{"t":4,"f":["full-img-title"],"n":50,"x":{"r":["imageType"],"s":"_0===\"fullWidthTitle\""}}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-panel","a":{"class":["margin-zero ",{"t":4,"f":["withoutShadow"],"n":50,"r":"isWithoutShadow"}," ",{"t":4,"f":["backgroundcss"],"n":50,"r":"bgColor"}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"full-img-container","style":["background-image: url(",{"t":2,"r":"img.src"},");"]},"f":[{"t":4,"f":[{"t":7,"e":"h1","f":[{"t":2,"r":"title"}]}],"n":50,"x":{"r":["imageType"],"s":"_0===\"fullWidthTitle\""}}]}],"n":50,"x":{"r":["imageType"],"s":"_0===\"fullWidth\"||_0===\"fullWidthTitle\""}}," ",{"t":7,"e":"ux-row","a":{"class":[{"t":4,"f":["text-center"],"n":51,"x":{"r":["imageType"],"s":"_0===\"fullWidthTitle\""}}," vertical-tout-container"],"style":["height:",{"t":2,"r":"height"},"px"]},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":7,"e":"ux-image","a":{"img":[{"t":2,"r":"img"}]}}],"n":51,"x":{"r":["imageType"],"s":"_0===\"fullWidth\"||_0===\"fullWidthTitle\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["product-title no-wrap ",{"t":4,"f":["dark"],"n":50,"x":{"r":["theme"],"s":"_0===\"dark\""}}]},"f":[{"t":2,"r":"title"}]}],"n":51,"x":{"r":["imageType"],"s":"_0===\"fullWidthTitle\""}}," ",{"t":7,"e":"p","a":{"class":[{"t":4,"f":["dark"],"n":50,"x":{"r":["theme"],"s":"_0===\"dark\""}}]},"f":[{"t":3,"r":"text"}]}," ",{"t":7,"e":"div","a":{"class":"v-normal-top v-large-bottom"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"link"}]},"f":[{"t":2,"r":"linkText"}]}]}]}]}]}],"n":50,"r":"isDataModel"},{"t":4,"n":51,"f":[{"t":8,"r":"content"}],"r":"isDataModel"}]}]};
this["ux-virtual-agent"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["ux-virtual-agent ",{"t":4,"f":["opened"],"n":50,"r":"enable"}]},"f":[{"t":7,"e":"div","a":{"class":"action-bar top"},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icons.move"}],"class":"pan move"}}," ",{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icons.close"}],"ontap":"doChatClose"}}]}," ",{"t":7,"e":"iframe","a":{"id":"ChatWindow","scroll":"","width":"100%","height":"100%","frameborder":"2","src":[{"t":2,"r":"iFrameUrl"}]}}," ",{"t":7,"e":"div","a":{"class":"action-bar bottom"},"f":[{"t":7,"e":"ux-icon","a":{"type":[{"t":2,"r":"icons.resize"}],"class":"pan resize"}}]}]}],"n":53,"r":"virtualAgentChat"},{"t":7,"e":"ux-modal","a":{"width":"550","class":"light-theme surveyModal","modalId":"surveyModal"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"section-details"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"small-7"},"f":[{"t":7,"e":"p","f":[{"t":3,"r":"description"}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"light button round","ontap":"doSurveyAccess return false","href":[{"t":2,"r":"surveyUrl"}],"ariaLabel":[{"t":2,"r":"yesButtonAriaLabel"}],"target":"_blank"},"f":[{"t":2,"r":"yesButtonLabel"}]}," ",{"t":7,"e":"ux-anchor","a":{"class":"light button round v-small-top","ontap":"doSurveyDismiss","href":"#"},"f":[{"t":2,"r":"noButtonLabel"}]}," ",{"t":7,"e":"p","f":[{"t":7,"e":"small","f":[{"t":2,"r":"notes"}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-4"},"f":[{"t":7,"e":"ux-image","a":{"datamodel":[{"t":2,"r":"image"}]}}]}]}]}],"n":53,"r":"virtualAgentModal"}]}]};
this["ux-widget-inclusion"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-widget-inclusion"},"f":[{"t":7,"e":"script","a":{"async":0,"defer":0,"src":[{"t":2,"r":"bootstrap_src"}],"data-component-id":[{"t":2,"r":"widgetid"}],"data-model":[{"t":2,"x":{"r":["."],"s":"JSON.stringify(_0)"}}]}}]}]};
this["ux-wifi-adsense"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-wifi-adsense"},"f":[{"t":7,"e":"div","a":{"id":[{"t":2,"r":"googleAdId"}]},"f":[]}]}]};
this["ux-wifi-agreement"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-wifi-agreement v-normal"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"p","a":{"class":"heading"},"f":[{"t":3,"r":"heading"}]}," ",{"t":7,"e":"div","v":{"tap":"divOnTap"},"a":{"class":"v-normal"},"f":[{"t":3,"r":"text"}]}," ",{"t":7,"e":"ux-checkbox","a":{"checkboxid":"CBIAgree","labelvalue":"I agree to the above","checked":[{"t":2,"r":"checked"}],"template":"Singtel"}}," ",{"t":7,"e":"div","a":{"class":"v-normal-top"},"f":[{"t":3,"r":"disclaimer"}]}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","a":{"class":"buttoncontainer v-normal-top"},"f":[{"t":7,"e":"ux-button","a":{"class":"text-right round","onclick":"proceedButtonClick"},"f":["Proceed"]}]}]}]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modal_id":"macAddressModal"},"f":[{"t":7,"e":"h3","f":["What is a MAC address?"]}," ",{"t":7,"e":"p","f":["A Media Access Control (MAC) address refers to the hardware identification number that uniquely identifies each device on the connected network."]}," ",{"t":7,"e":"p","f":["Please be assured that you will not be identified personally through the sharing of your MAC address."]}]}," ",{"t":7,"e":"ux-modal","a":{"width":"600","class":"light-theme","modal_id":"errorModal"},"f":[{"t":7,"e":"h3","a":{"class":"italic"},"f":["Whoops!"]}," ",{"t":7,"e":"p","a":{"class":"italic"},"f":["Sorry, there seems to be an error connecting through this portal. Please try again later."]}]}]}]};
this["ux-wifi-banner"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-wifi-banner"},"f":[{"t":7,"e":"div","a":{"class":"banner-background dark","style":["background-image: url(",{"t":2,"r":"backgroundImg.src"},")"]},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"img","a":{"class":"wifi-logo-desktop","src":[{"t":3,"r":"foregroundImg.desktop.src"}],"alt":[{"t":3,"r":"foregroundImg.desktop.alt"}]}}," ",{"t":7,"e":"img","a":{"class":"wifi-logo-mobile","src":[{"t":3,"r":"foregroundImg.mobile.src"}],"alt":[{"t":3,"r":"foregroundImg.mobile.alt"}]}}," ",{"t":7,"e":"span","a":{"class":"wifi-title"},"f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-row","f":[]}]}]}]}]}]}]};
this["ux-wifi-footer"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-wifi-footer"},"f":[{"t":7,"e":"div","a":{"class":"ux-footer-singtel"},"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"div","a":{"class":"footer-divider"}}," ",{"t":7,"e":"div","a":{"class":"footer-text"},"f":[{"t":3,"r":"text"}]}]}]}]}]}]};
this["ux-wifi-header"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-wifi-header"},"f":[{"t":7,"e":"ux-row","a":{"class":"v-normal-top v-normal-bottom"},"f":[{"t":7,"e":"div","a":{"class":"header-logo"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"logo.link"}]},"f":[{"t":7,"e":"ux-image","a":{"class":"singtel-logo","src":[{"t":2,"r":"logo.src"}],"alt":[{"t":2,"r":"logo.alt"}]}}]}]}," ",{"t":7,"e":"div","a":{"class":["header-skip ",{"t":4,"f":["skip-display"],"n":50,"r":"show"},{"t":4,"n":51,"f":["skip-hide"],"r":"show"}]},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"skipURL"}]},"f":["SKIP"]}],"r":"skip"}]}]}]}]};
this["ux-wifi-imagetext"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-wifi-imagetext"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"logo-center"},"f":[{"t":4,"f":[{"t":7,"e":"a","a":{"href":[{"t":2,"r":"logo.link"}]},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"logo.src"}],"alt":[{"t":2,"r":"logo.alt"}]}}]}],"n":50,"r":"logo.link"},{"t":4,"n":51,"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"logo.src"}],"alt":[{"t":2,"r":"logo.alt"}]}}],"r":"logo.link"}]}]}],"n":50,"r":"logo.src"}," ",{"t":7,"e":"ux-row","f":[{"t":7,"e":"div","a":{"class":"text-center"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":"text-line-1"},"f":[{"t":2,"r":"textLine1"},{"t":2,"r":"locationName"}]}],"r":"textLine1"}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"text-line-2"},"f":[{"t":2,"r":"textLine2"}]}],"r":"textLine2"}],"n":50,"r":"merchantId"},{"t":4,"n":51,"f":[{"t":7,"e":"p","a":{"class":"text-line-1"},"f":[{"t":2,"r":"apologyText"}]}],"r":"merchantId"}]}]}]}]};
this["ux-wireline-sub"] = {"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"ux-wireline-sub"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 medium-6"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":[{"t":2,"r":"plan.catalogItemName"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"r":"productDetails.subscriberCategoryX8"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header"},"f":["Plan Specification"]}]}," ",{"t":7,"e":"ux-col","a":{"class":"v-small-top"},"f":[{"t":2,"r":"plan.catalogItemDescription"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"level":"3","class":"left subsection-header v-medium-right"},"f":["Home Line Installation Address"]}," ",{"t":7,"e":"ux-anchor","a":{"ontap":"relocateService","product":[{"t":2,"r":"."}],"href":[{"t":2,"r":"initData.subInitData.relocateServiceLink"}]},"f":[{"t":2,"r":"initData.subInitData.relocateServiceLinkText"}]}]}," ",{"t":7,"e":"ux-col","f":[" ",{"t":7,"e":"ux-singtel-address","a":{"address":[{"t":2,"r":"address"}],"addressType":[{"t":2,"x":{"r":["address.addressType"],"s":"_0||\"omsProductServiceLevel\""}}]}}]}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12 medium-offset-2 medium-4 v-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-sub-addon","a":{"subscription":[{"t":2,"r":"."}],"account":[{"t":2,"r":"account"}],"productFacade":[{"t":2,"r":"productFacade"}],",":0,"product":[{"t":2,"r":"product"}],"initData":[{"t":2,"r":"initData.addonInitData"}],"permission":[{"t":2,"r":"permission"}]}}],"n":50,"x":{"r":["productDetails"],"s":"_0!==\"productDetailsError\""}}]}]}]}],"n":53,"r":"product"}]};
this["ux-worry-free"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":["ux-worry-free ",{"t":4,"f":["medium-6"],"n":50,"x":{"r":["isFtthCrEnabled","isGomoFlow","isPrepaidFlow"],"s":"_0||_1||_2"}}]},"o":"loadMask","f":[" ",{"t":7,"e":"ux-singtel-breadcrumbs","a":{"bcConfig":[{"t":2,"r":"bcConfig"}],"class":"hide","skipPrevStepCheck":"true"}}," ",{"t":7,"e":"ux-singtel-breadcrumb-step","a":{"id":"enter-mobile-no"},"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-details v-large-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":3,"r":"initData.otpSendSubHeader"}],"n":50,"r":"isReconFlow"},{"t":4,"n":51,"f":[{"t":3,"r":"initData.otpSendSubHeaderProvideFlow"}],"r":"isReconFlow"}]}]}],"n":50,"r":"isFtthCrEnabled"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-normal-bottom","level":"2"},"f":[{"t":4,"f":[{"t":2,"r":"initData.otpSendHeader"}],"n":50,"r":"isReconFlow"},{"t":4,"n":51,"f":[{"t":3,"r":"initData.otpSendHeaderProvideFlow"}],"r":"isReconFlow"}]}]}]}],"n":50,"r":"initData.otpSendHeader"}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details v-large-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":3,"r":"initData.otpSendSubHeader"}],"n":50,"r":"isReconFlow"},{"t":4,"n":51,"f":[{"t":3,"r":"initData.otpSendSubHeaderProvideFlow"}],"r":"isReconFlow"}]}]}],"r":"isFtthCrEnabled"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":""},"f":[{"t":7,"e":"ux-input-box","a":{"label_value":[{"t":2,"r":"initData.contactNumberLabel"}],"value":[{"t":2,"r":"contactNumber"}],"validity":[{"t":2,"r":"contactNumberErrorMsg"}],"maxLength":"8","id":"contactNumber","onblurEvent":"onBlurContact","class":"input-no-margin"},"f":[]}]}],"n":50,"r":"isReconFlow"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-col","a":{"class":""},"f":[{"t":7,"e":"ux-input-box","a":{"label_value":[{"t":2,"r":"initData.contactNumberLabelProvideFlow"}],"value":[{"t":2,"r":"contactNumber"}],"validity":[{"t":2,"r":"contactNumberErrorMsg"}],"maxLength":"8","id":"contactNumber","onblurEvent":"onBlurContact","class":"input-no-margin"},"f":[]}]}],"r":"isReconFlow"}]}],"n":50,"x":{"r":["isFtthCrEnabled","isGomoFlow","isPrepaidFlow"],"s":"!_0&&!_1&&!_2"}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-large-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":""},"f":[{"t":7,"e":"ux-select","a":{"title":"Passport ID Type","id":"passportIdType","showSelectedValue":"true","selected_value":[{"t":2,"r":"passportIdType"}],"label_value":[{"t":2,"r":"initData.otpSendIdTypeHeader"}],"options":[{"t":2,"r":"passportTypeOption"}],"validity":[{"t":2,"r":"guestIdTypeErrorMsg"}],"onChangeEvent":"onChangePassportType","customClass":"input-no-margin"},"f":[]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse v-large-bottom"},"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":3,"r":"initData.otpSendNricHeader"}],"n":50,"r":"isReconFlow"},{"t":4,"n":51,"f":[{"t":3,"r":"initData.otpSendNricHeaderProvideFlow"}],"r":"isReconFlow"}]}]}," ",{"t":7,"e":"ux-col","a":{"class":"small-12"},"f":[{"t":7,"e":"ux-input-box","a":{"id":"passportIdNumber","value":[{"t":2,"r":"passportIdNumber"}],"validity":[{"t":2,"r":"passportIdNumberErrorMsg"}],"disabled":[{"t":2,"r":"myInfoData.readOnly"}],"onblurEvent":"onPassportIdNumberBlur","class":"input-no-margin"},"f":[]}]}]}],"n":50,"r":"isPrepaidFlow"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"left-right-collapse v-large-bottom"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"input-label-bold"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"initData.otpSendNricPassportHeader"}]}]}],"n":50,"x":{"r":["passportIdType"],"s":"_0===\"Passport Number\""}}," ",{"t":7,"e":"div","a":{"class":"collapse input-label-bold v-medium-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":4,"f":[{"t":3,"r":"initData.otpSendNricHeader"}],"n":50,"r":"isReconFlow"},{"t":4,"n":51,"f":[{"t":3,"r":"initData.otpSendNricHeaderProvideFlow"}],"r":"isReconFlow"}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"ux-col","a":{"class":["medium-2 small-3 ",{"t":4,"f":["p-medium-right"],"n":50,"r":"isFtthCrEnabled"}]},"f":[{"t":7,"e":"ux-select","a":{"id":"idPrefixType","customClass":"input-no-margin","showSelectedValue":"true","options":[{"t":2,"r":"guestPrefixIdTypeOptions"}],"selected_value":[{"t":2,"r":"idPrefixType"}],"selectReadOnly":[{"t":2,"r":"myInfoData.readOnly"}],"onChangeEvent":"changedGuestId"},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"medium-10 small-9"},"f":[{"t":7,"e":"ux-input-box","a":{"id":"idNumber","value":[{"t":2,"r":"idNumber"}],"validity":[{"t":2,"r":"idNumberErrorMsg"}],"disabled":[{"t":2,"r":"myInfoData.readOnly"}],"onblurEvent":"onIdNumberBlur","class":"input-no-margin"},"f":[]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-large-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-select","a":{"title":"ID Type","id":"guestIdType","showSelectedValue":"true","selected_value":[{"t":2,"r":"guestIdType"}],"label_value":[{"t":2,"r":"initData.otpSendIdTypeHeader"}],"options":[{"t":2,"r":"guestIdTypeOptions"}],"selectReadOnly":[{"t":2,"r":"myInfoData.readOnly"}],"validity":[{"t":2,"r":"guestIdTypeErrorMsg"}],"onChangeEvent":"onChangeGuestType","customClass":"input-no-margin"},"f":[]}]}]}],"n":50,"x":{"r":["idPrefixType"],"s":"_0!==\"S\"&&_0!==\"T\""}}],"n":50,"x":{"r":["isPrepaidFlow","passportIdType"],"s":"!_0||_1===\"Passport Number\""}}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-large-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":""},"f":[{"t":7,"e":"ux-input-box","a":{"label_value":[{"t":2,"r":"initData.postalCodeLabel"}],"value":[{"t":2,"r":"postalcode"}],"validity":[{"t":2,"r":"postalcodeErrorMsg"}],"maxLength":"6","id":"postalcode","onblurEvent":"onBlurPostalcode","class":"input-no-margin"},"f":[]}]}]}],"n":50,"r":"isFtthCrEnabled"}," ",{"t":4,"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-large-bottom callout-text-copy"},"f":[{"t":7,"e":"ux-col","a":{"class":""},"f":[{"t":3,"x":{"r":["RactiveHelpers","reconOTPSendModalError"],"s":"_0.unescapeString(_1)"}}]}]}],"n":50,"r":"reconOTPSendModalError"},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["reconOTPVerifyModalError"],"s":"_0"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-large-bottom callout-text-copy"},"f":[{"t":7,"e":"ux-col","a":{"class":""},"f":[{"t":3,"x":{"r":["RactiveHelpers","reconOTPVerifyModalError"],"s":"_0.unescapeString(_1)"}}]}]}]},{"t":4,"n":50,"x":{"r":["reconOTPVerifyModalError","reconWorryFreeMsg"],"s":"(!(_0))&&(_1)"},"f":[" ",{"t":7,"e":"ux-row","a":{"class":"collapse v-large-bottom callout-text-copy"},"f":[{"t":7,"e":"ux-col","a":{"class":""},"f":[{"t":3,"x":{"r":["RactiveHelpers","reconWorryFreeMsg"],"s":"_0.unescapeString(_1)"}}]}]}]}],"r":"reconOTPSendModalError"}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-medium-up collapse v-large-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":"round margin-zero","text":"Submit","onclick":"onOtpSendClick"}}," ",{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"class":"v-normal-left","ontap":"onePassSigninClick"},"f":[{"t":2,"r":"initData.onePassSigninClickText"}]}],"n":50,"r":"isReconFlow"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"class":"v-normal-left","ontap":"onePassSigninClick"},"f":[{"t":2,"r":"initData.onePassSigninClickTextProvideFlow"}]}],"r":"isReconFlow"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"show-for-small-only collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"small-12 v-large-bottom"},"f":[{"t":7,"e":"ux-button","a":{"class":"round margin-zero small-only-expand","text":"Submit","onclick":"onOtpSendClick"},"f":[]}]}," ",{"t":7,"e":"ux-col","a":{"class":"center small-12"},"f":[{"t":4,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onePassSigninClick"},"f":[{"t":2,"r":"initData.onePassSigninClickText"}]}],"n":50,"r":"isReconFlow"},{"t":4,"n":51,"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onePassSigninClick"},"f":[{"t":2,"r":"initData.onePassSigninClickTextProvideFlow"}]}],"r":"isReconFlow"}]}]}]}," ",{"t":7,"e":"ux-singtel-breadcrumb-step","a":{"id":"verify-account"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-normal-bottom","level":"2"},"f":[{"t":2,"r":"initData.otpVerifyFAHeader"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":3,"r":"initData.otpVerifyFASubHeader"}]}]}," ",{"t":7,"e":"div","a":{"class":"idontKnowLink right"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"initData.idontKnowLink"}],"target":"_blank"},"f":[{"t":2,"r":"initData.idontKnowText"}]}]}," ",{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse accountNumber"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-input-box","a":{"value":[{"t":2,"r":"accountNumber"}],"label_value":[{"t":2,"r":"initData.otpVerifyFANumberLabel"}],"id":"accountNumber","tooltipImage":[{"t":2,"r":"initData.otpVerifyFAToolTipImg"}],"anchorReqd":"I don't know this","label_tooltip_message":[{"t":2,"r":"initData.otpVerifyFAToolTip"}],"onblurEvent":"onBlurAccountNumber","validity":[{"t":2,"r":"accountNumberErrorMsg"}],"class":"input-no-margin"},"f":[]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":"round margin-zero small-only-expand","text":"Submit","onclick":"onFAVerifyClick"},"f":[]}]}]}]}," ",{"t":7,"e":"ux-singtel-breadcrumb-step","a":{"id":"verify-otp"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-normal-bottom","level":"2"},"f":[{"t":2,"r":"initData.otpVerifyHeader"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details v-large-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"initData.otpVerifySubHeader"}," ",{"t":2,"r":"otpTimer"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"input-label-bold left small-6"},"f":[{"t":2,"r":"initData.otpVerifyOtpHeader"}]}," ",{"t":7,"e":"ux-col","a":{"class":"text-right small-6"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onOtpReSendClick"},"f":[{"t":2,"r":"initData.otpVerifyResendHeader"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-input-box","a":{"class":"input-no-margin","value":[{"t":2,"r":"otpNumber"}],"id":"otpNumber","maxLength":"6","validity":[{"t":2,"r":"otpNumberErrorMsg"}],"onblurEvent":"onBlurOtp"},"f":[]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["round margin-zero small-only-expand ",{"t":4,"f":["disabled"],"n":51,"r":"resendOtp"}],"text":"Next","onclick":"onOtpVerifyClick"},"f":[]}]}]}]}," ",{"t":7,"e":"ux-singtel-breadcrumb-step","a":{"id":"verify-mobile-number"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-normal-bottom","level":"2"},"f":[{"t":2,"r":"initData.otpVerifyServiceHeader"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":3,"r":"initData.otpVerifyServiceSubHeader"}]}]}," ",{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse v-large-bottom"},"f":[{"t":7,"e":"ux-col","a":{"class":""},"f":[{"t":7,"e":"ux-input-box","a":{"label_value":[{"t":2,"r":"initData.contactNumberLabel"}],"value":[{"t":2,"r":"serviceNumber"}],"validity":[{"t":2,"r":"serviceNumberErrorMsg"}],"maxLength":"8","id":"serviceNumber","onblurEvent":"onBlurService","class":"input-no-margin"},"f":[]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":"round margin-zero small-only-expand","text":"Submit","onclick":"onServiceVerifyClick"},"f":[]}]}]}]}," ",{"t":7,"e":"ux-singtel-breadcrumb-step","a":{"id":"verify-account-prepaid"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-normal-bottom","level":"2"},"f":[{"t":2,"r":"initData.otpVerifyFAHeader"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details v-normal-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":3,"r":"initData.otpVerifyFASubHeader"}]}]}," ",{"t":7,"e":"div","a":{"class":"idontKnowLink right"},"f":[{"t":7,"e":"ux-anchor","a":{"href":[{"t":2,"r":"initData.idontKnowLink"}],"target":"_blank"},"f":[{"t":2,"r":"initData.idontKnowText"}]}]}," ",{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse accountNumber"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-input-box","a":{"value":[{"t":2,"r":"prepaidAccountNumber"}],"label_value":[{"t":2,"r":"initData.otpVerifyFANumberLabel"}],"id":"prepaidAccountNumber","tooltipImage":[{"t":2,"r":"initData.otpVerifyFAToolTipImg"}],"anchorReqd":"I don't know this","label_tooltip_message":[{"t":2,"r":"initData.otpVerifyFAToolTip"}],"onblurEvent":"onBlurPrepaidAccountNumber","validity":[{"t":2,"r":"prepaidAccountNumberErrorMsg"}],"class":"input-no-margin"},"f":[]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":"round margin-zero small-only-expand","text":"Submit","onclick":"onPrepaidFAVerifyClick"},"f":[]}]}]}]}," ",{"t":7,"e":"ux-singtel-breadcrumb-step","a":{"id":"verify-otp-prepaid"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse section-title"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-header","a":{"class":"section-header v-normal-bottom","level":"2"},"f":[{"t":2,"r":"initData.otpVerifyHeader"}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse section-details v-large-bottom"},"f":[{"t":7,"e":"ux-col","f":[{"t":2,"r":"initData.otpVerifySubHeader"}," ",{"t":2,"r":"otpTimer"}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"v-medium-bottom collapse"},"f":[{"t":7,"e":"ux-col","a":{"class":"input-label-bold left small-6"},"f":[{"t":2,"r":"initData.otpVerifyOtpHeader"}]}," ",{"t":7,"e":"ux-col","a":{"class":"text-right small-6"},"f":[{"t":7,"e":"ux-anchor","a":{"ontap":"onAcceptorOtpReSendClick"},"f":[{"t":2,"r":"initData.otpVerifyResendHeader"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"v-large-bottom"},"f":[{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-input-box","a":{"class":"input-no-margin","value":[{"t":2,"r":"prepaidOtpNumber"}],"id":"prepaidOtpNumber","maxLength":"6","validity":[{"t":2,"r":"prepaidOtpNumberErrorMsg"}],"onblurEvent":"onBlurPrepaidOtp"},"f":[]}]}]}]}," ",{"t":7,"e":"ux-row","a":{"class":"collapse"},"f":[{"t":7,"e":"ux-col","f":[{"t":7,"e":"ux-button","a":{"class":["round margin-zero small-only-expand ",{"t":4,"f":["disabled"],"n":51,"r":"acceptorResendOtp"}],"text":"Next","onclick":"onServiceOtpVerifyClick"},"f":[]}]}]}]}]}]};
this["ux-youth-plans"] = {"v":3,"t":[{"t":7,"e":"div","a":{"class":"ux-youth-plans"},"f":[{"t":7,"e":"ux-row","f":[{"t":4,"f":[{"t":7,"e":"ux-col","a":{"class":"large-6 v-bottom-normal"},"f":[{"t":7,"e":"ux-row","a":{"class":"text-center holder"},"f":[{"t":7,"e":"ux-col","a":{"class":"large-12 banner"},"f":[{"t":7,"e":"div","a":{"class":"banner-content"},"f":[{"t":7,"e":"div","a":{"class":"banner-text"},"f":[{"t":7,"e":"div","a":{"class":"combo_header"},"f":[{"t":2,"r":"comboHeader"}]}," ",{"t":7,"e":"div","a":{"class":"combo_price money_font"},"f":[{"t":2,"x":{"r":["RactiveHelpers","comboPrice"],"s":"_0.convertUnits(_1,\"showdollars\")"}}," ",{"t":7,"e":"span","a":{"class":"cents"},"f":[{"t":2,"x":{"r":["RactiveHelpers","comboPrice"],"s":"_0.convertUnits(_1,\"showcents\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"combo_period"},"f":[{"t":2,"r":"comboPeriod"}]}," ",{"t":7,"e":"a","a":{"class":"youth-plans-select-button button","target":"_blank","href":[{"t":2,"r":"planDetailLink"}]},"f":[{"t":2,"r":"selectButtonLabel"}]}]}," ",{"t":7,"e":"div","a":{"class":"banner-button"},"f":[]}]}]}," ",{"t":7,"e":"table","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"heavy"},"f":[{"t":2,"r":"beforeLabel"}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"levelUpImage"}],"id":"lvlup"}}]}]}," ",{"t":7,"e":"tr","f":[{"t":4,"f":[{"t":7,"e":"td","a":{"class":""},"f":[{"t":7,"e":"span","a":{"class":"heavy"},"f":[{"t":2,"r":"beforeSpecs.totalData"}]}," Data ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","a":{"class":"heavy"},"f":[{"t":2,"r":"beforeSpecs.freeData"}]}," Free Data ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","a":{"class":"heavy"},"f":[{"t":2,"r":"beforeSpecs.talkTime"}]}," Talktime"]}],"n":50,"r":"beforeSpecs"}," ",{"t":4,"f":[{"t":7,"e":"td","a":{"class":""},"f":[{"t":7,"e":"span","a":{"class":"heavy"},"f":[{"t":2,"r":"levelupSpecs.totalData"}]}," Data ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","a":{"class":"heavy"},"f":[{"t":2,"r":"levelupSpecs.freeData"}]}," Free Data ",{"t":7,"e":"br"}," ",{"t":7,"e":"span","a":{"class":"heavy"},"f":[{"t":2,"r":"levelupSpecs.talkTime"}]}," Talktime"]}],"n":50,"r":"levelupSpecs"}]}," ",{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"span","a":{"class":"heavy"},"f":[{"t":2,"r":"beforeData"}]}," ",{"t":2,"r":"beforePrice"}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"span","a":{"class":"heavy"},"f":[{"t":2,"r":"levelupData"}]}," ",{"t":2,"r":"levelupPrice"}]}]}," ",{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"span","a":{"class":"large money_font"},"f":[{"t":2,"r":"beforeTotalData"}]}," ",{"t":7,"e":"br"}," Total Data"]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"span","a":{"class":"large money_font"},"f":[{"t":2,"r":"levelupTotalData"}]}," ",{"t":7,"e":"br"}," Total Data"]}]}]}]}]}],"r":"youthPlansItems"}]}]}]};
return this;

});

/*
* Underscore.string
* (c) 2010 Esa-Matti Suuronen <esa-matti aet suuronen dot org>
* Underscore.string is freely distributable under the terms of the MIT license.
* Documentation: https://github.com/epeli/underscore.string
* Some code is borrowed from MooTools and Alexandru Marasteanu.
* Version '3.3.6'
* @preserve
*/

(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define('underscoreString',[],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.s = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
var trim = require('./trim');
var decap = require('./decapitalize');

module.exports = function camelize(str, decapitalize) {
  str = trim(str).replace(/[-_\s]+(.)?/g, function(match, c) {
    return c ? c.toUpperCase() : '';
  });

  if (decapitalize === true) {
    return decap(str);
  } else {
    return str;
  }
};

},{"./decapitalize":10,"./trim":65}],2:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function capitalize(str, lowercaseRest) {
  str = makeString(str);
  var remainingChars = !lowercaseRest ? str.slice(1) : str.slice(1).toLowerCase();

  return str.charAt(0).toUpperCase() + remainingChars;
};

},{"./helper/makeString":20}],3:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function chars(str) {
  return makeString(str).split('');
};

},{"./helper/makeString":20}],4:[function(require,module,exports){
module.exports = function chop(str, step) {
  if (str == null) return [];
  str = String(str);
  step = ~~step;
  return step > 0 ? str.match(new RegExp('.{1,' + step + '}', 'g')) : [str];
};

},{}],5:[function(require,module,exports){
var capitalize = require('./capitalize');
var camelize = require('./camelize');
var makeString = require('./helper/makeString');

module.exports = function classify(str) {
  str = makeString(str);
  return capitalize(camelize(str.replace(/[\W_]/g, ' ')).replace(/\s/g, ''));
};

},{"./camelize":1,"./capitalize":2,"./helper/makeString":20}],6:[function(require,module,exports){
var trim = require('./trim');

module.exports = function clean(str) {
  return trim(str).replace(/\s\s+/g, ' ');
};

},{"./trim":65}],7:[function(require,module,exports){

var makeString = require('./helper/makeString');

var from  = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșşšŝťțţŭùúüűûñÿýçżźž',
  to    = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz';

from += from.toUpperCase();
to += to.toUpperCase();

to = to.split('');

// for tokens requireing multitoken output
from += 'ß';
to.push('ss');


module.exports = function cleanDiacritics(str) {
  return makeString(str).replace(/.{1}/g, function(c){
    var index = from.indexOf(c);
    return index === -1 ? c : to[index];
  });
};

},{"./helper/makeString":20}],8:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function(str, substr) {
  str = makeString(str);
  substr = makeString(substr);

  if (str.length === 0 || substr.length === 0) return 0;
  
  return str.split(substr).length - 1;
};

},{"./helper/makeString":20}],9:[function(require,module,exports){
var trim = require('./trim');

module.exports = function dasherize(str) {
  return trim(str).replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase();
};

},{"./trim":65}],10:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function decapitalize(str) {
  str = makeString(str);
  return str.charAt(0).toLowerCase() + str.slice(1);
};

},{"./helper/makeString":20}],11:[function(require,module,exports){
var makeString = require('./helper/makeString');

function getIndent(str) {
  var matches = str.match(/^[\s\\t]*/gm);
  var indent = matches[0].length;
  
  for (var i = 1; i < matches.length; i++) {
    indent = Math.min(matches[i].length, indent);
  }

  return indent;
}

module.exports = function dedent(str, pattern) {
  str = makeString(str);
  var indent = getIndent(str);
  var reg;

  if (indent === 0) return str;

  if (typeof pattern === 'string') {
    reg = new RegExp('^' + pattern, 'gm');
  } else {
    reg = new RegExp('^[ \\t]{' + indent + '}', 'gm');
  }

  return str.replace(reg, '');
};

},{"./helper/makeString":20}],12:[function(require,module,exports){
var makeString = require('./helper/makeString');
var toPositive = require('./helper/toPositive');

module.exports = function endsWith(str, ends, position) {
  str = makeString(str);
  ends = '' + ends;
  if (typeof position == 'undefined') {
    position = str.length - ends.length;
  } else {
    position = Math.min(toPositive(position), str.length) - ends.length;
  }
  return position >= 0 && str.indexOf(ends, position) === position;
};

},{"./helper/makeString":20,"./helper/toPositive":22}],13:[function(require,module,exports){
var makeString = require('./helper/makeString');
var escapeChars = require('./helper/escapeChars');

var regexString = '[';
for(var key in escapeChars) {
  regexString += key;
}
regexString += ']';

var regex = new RegExp( regexString, 'g');

module.exports = function escapeHTML(str) {

  return makeString(str).replace(regex, function(m) {
    return '&' + escapeChars[m] + ';';
  });
};

},{"./helper/escapeChars":17,"./helper/makeString":20}],14:[function(require,module,exports){
module.exports = function() {
  var result = {};

  for (var prop in this) {
    if (!this.hasOwnProperty(prop) || prop.match(/^(?:include|contains|reverse|join|map|wrap)$/)) continue;
    result[prop] = this[prop];
  }

  return result;
};

},{}],15:[function(require,module,exports){
var makeString = require('./makeString');

module.exports = function adjacent(str, direction) {
  str = makeString(str);
  if (str.length === 0) {
    return '';
  }
  return str.slice(0, -1) + String.fromCharCode(str.charCodeAt(str.length - 1) + direction);
};

},{"./makeString":20}],16:[function(require,module,exports){
var escapeRegExp = require('./escapeRegExp');

module.exports = function defaultToWhiteSpace(characters) {
  if (characters == null)
    return '\\s';
  else if (characters.source)
    return characters.source;
  else
    return '[' + escapeRegExp(characters) + ']';
};

},{"./escapeRegExp":18}],17:[function(require,module,exports){
/* We're explicitly defining the list of entities we want to escape.
nbsp is an HTML entity, but we don't want to escape all space characters in a string, hence its omission in this map.

*/
var escapeChars = {
  '¢' : 'cent',
  '£' : 'pound',
  '¥' : 'yen',
  '€': 'euro',
  '©' :'copy',
  '®' : 'reg',
  '<' : 'lt',
  '>' : 'gt',
  '"' : 'quot',
  '&' : 'amp',
  '\'' : '#39'
};

module.exports = escapeChars;

},{}],18:[function(require,module,exports){
var makeString = require('./makeString');

module.exports = function escapeRegExp(str) {
  return makeString(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
};

},{"./makeString":20}],19:[function(require,module,exports){
/*
We're explicitly defining the list of entities that might see in escape HTML strings
*/
var htmlEntities = {
  nbsp: ' ',
  cent: '¢',
  pound: '£',
  yen: '¥',
  euro: '€',
  copy: '©',
  reg: '®',
  lt: '<',
  gt: '>',
  quot: '"',
  amp: '&',
  apos: '\''
};

module.exports = htmlEntities;

},{}],20:[function(require,module,exports){
/**
 * Ensure some object is a coerced to a string
 **/
module.exports = function makeString(object) {
  if (object == null) return '';
  return '' + object;
};

},{}],21:[function(require,module,exports){
module.exports = function strRepeat(str, qty){
  if (qty < 1) return '';
  var result = '';
  while (qty > 0) {
    if (qty & 1) result += str;
    qty >>= 1, str += str;
  }
  return result;
};

},{}],22:[function(require,module,exports){
module.exports = function toPositive(number) {
  return number < 0 ? 0 : (+number || 0);
};

},{}],23:[function(require,module,exports){
var capitalize = require('./capitalize');
var underscored = require('./underscored');
var trim = require('./trim');

module.exports = function humanize(str) {
  return capitalize(trim(underscored(str).replace(/_id$/, '').replace(/_/g, ' ')));
};

},{"./capitalize":2,"./trim":65,"./underscored":67}],24:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function include(str, needle) {
  if (needle === '') return true;
  return makeString(str).indexOf(needle) !== -1;
};

},{"./helper/makeString":20}],25:[function(require,module,exports){
/*
* Underscore.string
* (c) 2010 Esa-Matti Suuronen <esa-matti aet suuronen dot org>
* Underscore.string is freely distributable under the terms of the MIT license.
* Documentation: https://github.com/epeli/underscore.string
* Some code is borrowed from MooTools and Alexandru Marasteanu.
* Version '3.3.6'
* @preserve
*/



function s(value) {
  /* jshint validthis: true */
  if (!(this instanceof s)) return new s(value);
  this._wrapped = value;
}

s.VERSION = '3.3.6';

s.isBlank          = require('./isBlank');
s.stripTags        = require('./stripTags');
s.capitalize       = require('./capitalize');
s.decapitalize     = require('./decapitalize');
s.chop             = require('./chop');
s.trim             = require('./trim');
s.clean            = require('./clean');
s.cleanDiacritics  = require('./cleanDiacritics');
s.count            = require('./count');
s.chars            = require('./chars');
s.swapCase         = require('./swapCase');
s.escapeHTML       = require('./escapeHTML');
s.unescapeHTML     = require('./unescapeHTML');
s.splice           = require('./splice');
s.insert           = require('./insert');
s.replaceAll       = require('./replaceAll');
s.include          = require('./include');
s.join             = require('./join');
s.lines            = require('./lines');
s.dedent           = require('./dedent');
s.reverse          = require('./reverse');
s.startsWith       = require('./startsWith');
s.endsWith         = require('./endsWith');
s.pred             = require('./pred');
s.succ             = require('./succ');
s.titleize         = require('./titleize');
s.camelize         = require('./camelize');
s.underscored      = require('./underscored');
s.dasherize        = require('./dasherize');
s.classify         = require('./classify');
s.humanize         = require('./humanize');
s.ltrim            = require('./ltrim');
s.rtrim            = require('./rtrim');
s.truncate         = require('./truncate');
s.prune            = require('./prune');
s.words            = require('./words');
s.pad              = require('./pad');
s.lpad             = require('./lpad');
s.rpad             = require('./rpad');
s.lrpad            = require('./lrpad');
s.sprintf          = require('./sprintf');
s.vsprintf         = require('./vsprintf');
s.toNumber         = require('./toNumber');
s.numberFormat     = require('./numberFormat');
s.strRight         = require('./strRight');
s.strRightBack     = require('./strRightBack');
s.strLeft          = require('./strLeft');
s.strLeftBack      = require('./strLeftBack');
s.toSentence       = require('./toSentence');
s.toSentenceSerial = require('./toSentenceSerial');
s.slugify          = require('./slugify');
s.surround         = require('./surround');
s.quote            = require('./quote');
s.unquote          = require('./unquote');
s.repeat           = require('./repeat');
s.naturalCmp       = require('./naturalCmp');
s.levenshtein      = require('./levenshtein');
s.toBoolean        = require('./toBoolean');
s.exports          = require('./exports');
s.escapeRegExp     = require('./helper/escapeRegExp');
s.wrap             = require('./wrap');
s.map              = require('./map');

// Aliases
s.strip     = s.trim;
s.lstrip    = s.ltrim;
s.rstrip    = s.rtrim;
s.center    = s.lrpad;
s.rjust     = s.lpad;
s.ljust     = s.rpad;
s.contains  = s.include;
s.q         = s.quote;
s.toBool    = s.toBoolean;
s.camelcase = s.camelize;
s.mapChars  = s.map;


// Implement chaining
s.prototype = {
  value: function value() {
    return this._wrapped;
  }
};

function fn2method(key, fn) {
  if (typeof fn !== 'function') return;
  s.prototype[key] = function() {
    var args = [this._wrapped].concat(Array.prototype.slice.call(arguments));
    var res = fn.apply(null, args);
    // if the result is non-string stop the chain and return the value
    return typeof res === 'string' ? new s(res) : res;
  };
}

// Copy functions to instance methods for chaining
for (var key in s) fn2method(key, s[key]);

fn2method('tap', function tap(string, fn) {
  return fn(string);
});

function prototype2method(methodName) {
  fn2method(methodName, function(context) {
    var args = Array.prototype.slice.call(arguments, 1);
    return String.prototype[methodName].apply(context, args);
  });
}

var prototypeMethods = [
  'toUpperCase',
  'toLowerCase',
  'split',
  'replace',
  'slice',
  'substring',
  'substr',
  'concat'
];

for (var method in prototypeMethods) prototype2method(prototypeMethods[method]);


module.exports = s;

},{"./camelize":1,"./capitalize":2,"./chars":3,"./chop":4,"./classify":5,"./clean":6,"./cleanDiacritics":7,"./count":8,"./dasherize":9,"./decapitalize":10,"./dedent":11,"./endsWith":12,"./escapeHTML":13,"./exports":14,"./helper/escapeRegExp":18,"./humanize":23,"./include":24,"./insert":26,"./isBlank":27,"./join":28,"./levenshtein":29,"./lines":30,"./lpad":31,"./lrpad":32,"./ltrim":33,"./map":34,"./naturalCmp":35,"./numberFormat":38,"./pad":39,"./pred":40,"./prune":41,"./quote":42,"./repeat":43,"./replaceAll":44,"./reverse":45,"./rpad":46,"./rtrim":47,"./slugify":48,"./splice":49,"./sprintf":50,"./startsWith":51,"./strLeft":52,"./strLeftBack":53,"./strRight":54,"./strRightBack":55,"./stripTags":56,"./succ":57,"./surround":58,"./swapCase":59,"./titleize":60,"./toBoolean":61,"./toNumber":62,"./toSentence":63,"./toSentenceSerial":64,"./trim":65,"./truncate":66,"./underscored":67,"./unescapeHTML":68,"./unquote":69,"./vsprintf":70,"./words":71,"./wrap":72}],26:[function(require,module,exports){
var splice = require('./splice');

module.exports = function insert(str, i, substr) {
  return splice(str, i, 0, substr);
};

},{"./splice":49}],27:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function isBlank(str) {
  return (/^\s*$/).test(makeString(str));
};

},{"./helper/makeString":20}],28:[function(require,module,exports){
var makeString = require('./helper/makeString');
var slice = [].slice;

module.exports = function join() {
  var args = slice.call(arguments),
    separator = args.shift();

  return args.join(makeString(separator));
};

},{"./helper/makeString":20}],29:[function(require,module,exports){
var makeString = require('./helper/makeString');

/**
 * Based on the implementation here: https://github.com/hiddentao/fast-levenshtein
 */
module.exports = function levenshtein(str1, str2) {
  'use strict';
  str1 = makeString(str1);
  str2 = makeString(str2);

  // Short cut cases  
  if (str1 === str2) return 0;
  if (!str1 || !str2) return Math.max(str1.length, str2.length);

  // two rows
  var prevRow = new Array(str2.length + 1);

  // initialise previous row
  for (var i = 0; i < prevRow.length; ++i) {
    prevRow[i] = i;
  }

  // calculate current row distance from previous row
  for (i = 0; i < str1.length; ++i) {
    var nextCol = i + 1;

    for (var j = 0; j < str2.length; ++j) {
      var curCol = nextCol;

      // substution
      nextCol = prevRow[j] + ( (str1.charAt(i) === str2.charAt(j)) ? 0 : 1 );
      // insertion
      var tmp = curCol + 1;
      if (nextCol > tmp) {
        nextCol = tmp;
      }
      // deletion
      tmp = prevRow[j + 1] + 1;
      if (nextCol > tmp) {
        nextCol = tmp;
      }

      // copy current col value into previous (in preparation for next iteration)
      prevRow[j] = curCol;
    }

    // copy last col value into previous (in preparation for next iteration)
    prevRow[j] = nextCol;
  }

  return nextCol;
};

},{"./helper/makeString":20}],30:[function(require,module,exports){
module.exports = function lines(str) {
  if (str == null) return [];
  return String(str).split(/\r\n?|\n/);
};

},{}],31:[function(require,module,exports){
var pad = require('./pad');

module.exports = function lpad(str, length, padStr) {
  return pad(str, length, padStr);
};

},{"./pad":39}],32:[function(require,module,exports){
var pad = require('./pad');

module.exports = function lrpad(str, length, padStr) {
  return pad(str, length, padStr, 'both');
};

},{"./pad":39}],33:[function(require,module,exports){
var makeString = require('./helper/makeString');
var defaultToWhiteSpace = require('./helper/defaultToWhiteSpace');
var nativeTrimLeft = String.prototype.trimLeft;

module.exports = function ltrim(str, characters) {
  str = makeString(str);
  if (!characters && nativeTrimLeft) return nativeTrimLeft.call(str);
  characters = defaultToWhiteSpace(characters);
  return str.replace(new RegExp('^' + characters + '+'), '');
};

},{"./helper/defaultToWhiteSpace":16,"./helper/makeString":20}],34:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function(str, callback) {
  str = makeString(str);

  if (str.length === 0 || typeof callback !== 'function') return str;

  return str.replace(/./g, callback);
};

},{"./helper/makeString":20}],35:[function(require,module,exports){
module.exports = function naturalCmp(str1, str2) {
  if (str1 == str2) return 0;
  if (!str1) return -1;
  if (!str2) return 1;

  var cmpRegex = /(\.\d+|\d+|\D+)/g,
    tokens1 = String(str1).match(cmpRegex),
    tokens2 = String(str2).match(cmpRegex),
    count = Math.min(tokens1.length, tokens2.length);

  for (var i = 0; i < count; i++) {
    var a = tokens1[i],
      b = tokens2[i];

    if (a !== b) {
      var num1 = +a;
      var num2 = +b;
      if (num1 === num1 && num2 === num2) {
        return num1 > num2 ? 1 : -1;
      }
      return a < b ? -1 : 1;
    }
  }

  if (tokens1.length != tokens2.length)
    return tokens1.length - tokens2.length;

  return str1 < str2 ? -1 : 1;
};

},{}],36:[function(require,module,exports){
/* global window, exports, define */

!function() {
    'use strict'

    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    }

    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments)
    }

    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []))
    }

    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
        for (i = 0; i < tree_length; i++) {
            if (typeof parse_tree[i] === 'string') {
                output += parse_tree[i]
            }
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                if (ph.keys) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < ph.keys.length; k++) {
                        if (arg == undefined) {
                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                        }
                        arg = arg[ph.keys[k]]
                    }
                }
                else if (ph.param_no) { // positional argument (explicit)
                    arg = argv[ph.param_no]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                    arg = arg()
                }

                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                }

                if (re.number.test(ph.type)) {
                    is_positive = arg >= 0
                }

                switch (ph.type) {
                    case 'b':
                        arg = parseInt(arg, 10).toString(2)
                        break
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10))
                        break
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10)
                        break
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
                        break
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
                        break
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
                        break
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
                        break
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8)
                        break
                    case 's':
                        arg = String(arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 't':
                        arg = String(!!arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0
                        break
                    case 'v':
                        arg = arg.valueOf()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16)
                        break
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
                        break
                }
                if (re.json.test(ph.type)) {
                    output += arg
                }
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-'
                        arg = arg.toString().replace(re.sign, '')
                    }
                    else {
                        sign = ''
                    }
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
                    pad_length = ph.width - (sign + arg).length
                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output
    }

    var sprintf_cache = Object.create(null)

    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
            return sprintf_cache[fmt]
        }

        var _fmt = fmt, match, parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree.push(match[0])
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree.push('%')
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1])
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else {
                                throw new SyntaxError('[sprintf] failed to parse named argument key')
                            }
                        }
                    }
                    else {
                        throw new SyntaxError('[sprintf] failed to parse named argument key')
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                }

                parse_tree.push(
                    {
                        placeholder: match[0],
                        param_no:    match[1],
                        keys:        match[2],
                        sign:        match[3],
                        pad_char:    match[4],
                        align:       match[5],
                        width:       match[6],
                        precision:   match[7],
                        type:        match[8]
                    }
                )
            }
            else {
                throw new SyntaxError('[sprintf] unexpected placeholder')
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return sprintf_cache[fmt] = parse_tree
    }

    /**
     * export to either browser or node.js
     */
    /* eslint-disable quote-props */
    if (typeof exports !== 'undefined') {
        exports['sprintf'] = sprintf
        exports['vsprintf'] = vsprintf
    }
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf
        window['vsprintf'] = vsprintf

        if (typeof define === 'function' && define['amd']) {
            define(function() {
                return {
                    'sprintf': sprintf,
                    'vsprintf': vsprintf
                }
            })
        }
    }
    /* eslint-enable quote-props */
}(); // eslint-disable-line

},{}],37:[function(require,module,exports){
(function (global){(function (){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],38:[function(require,module,exports){
module.exports = function numberFormat(number, dec, dsep, tsep) {
  if (isNaN(number) || number == null) return '';

  number = number.toFixed(~~dec);
  tsep = typeof tsep == 'string' ? tsep : ',';

  var parts = number.split('.'),
    fnums = parts[0],
    decimals = parts[1] ? (dsep || '.') + parts[1] : '';

  return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + tsep) + decimals;
};

},{}],39:[function(require,module,exports){
var makeString = require('./helper/makeString');
var strRepeat = require('./helper/strRepeat');

module.exports = function pad(str, length, padStr, type) {
  str = makeString(str);
  length = ~~length;

  var padlen = 0;

  if (!padStr)
    padStr = ' ';
  else if (padStr.length > 1)
    padStr = padStr.charAt(0);

  switch (type) {
  case 'right':
    padlen = length - str.length;
    return str + strRepeat(padStr, padlen);
  case 'both':
    padlen = length - str.length;
    return strRepeat(padStr, Math.ceil(padlen / 2)) + str + strRepeat(padStr, Math.floor(padlen / 2));
  default: // 'left'
    padlen = length - str.length;
    return strRepeat(padStr, padlen) + str;
  }
};

},{"./helper/makeString":20,"./helper/strRepeat":21}],40:[function(require,module,exports){
var adjacent = require('./helper/adjacent');

module.exports = function succ(str) {
  return adjacent(str, -1);
};

},{"./helper/adjacent":15}],41:[function(require,module,exports){
/**
 * _s.prune: a more elegant version of truncate
 * prune extra chars, never leaving a half-chopped word.
 * @author github.com/rwz
 */
var makeString = require('./helper/makeString');
var rtrim = require('./rtrim');

module.exports = function prune(str, length, pruneStr) {
  str = makeString(str);
  length = ~~length;
  pruneStr = pruneStr != null ? String(pruneStr) : '...';

  if (str.length <= length) return str;

  var tmpl = function(c) {
      return c.toUpperCase() !== c.toLowerCase() ? 'A' : ' ';
    },
    template = str.slice(0, length + 1).replace(/.(?=\W*\w*$)/g, tmpl); // 'Hello, world' -> 'HellAA AAAAA'

  if (template.slice(template.length - 2).match(/\w\w/))
    template = template.replace(/\s*\S+$/, '');
  else
    template = rtrim(template.slice(0, template.length - 1));

  return (template + pruneStr).length > str.length ? str : str.slice(0, template.length) + pruneStr;
};

},{"./helper/makeString":20,"./rtrim":47}],42:[function(require,module,exports){
var surround = require('./surround');

module.exports = function quote(str, quoteChar) {
  return surround(str, quoteChar || '"');
};

},{"./surround":58}],43:[function(require,module,exports){
var makeString = require('./helper/makeString');
var strRepeat = require('./helper/strRepeat');

module.exports = function repeat(str, qty, separator) {
  str = makeString(str);

  qty = ~~qty;

  // using faster implementation if separator is not needed;
  if (separator == null) return strRepeat(str, qty);

  // this one is about 300x slower in Google Chrome
  /*eslint no-empty: 0*/
  for (var repeat = []; qty > 0; repeat[--qty] = str) {}
  return repeat.join(separator);
};

},{"./helper/makeString":20,"./helper/strRepeat":21}],44:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function replaceAll(str, find, replace, ignorecase) {
  var flags = (ignorecase === true)?'gi':'g';
  var reg = new RegExp(find, flags);

  return makeString(str).replace(reg, replace);
};

},{"./helper/makeString":20}],45:[function(require,module,exports){
var chars = require('./chars');

module.exports = function reverse(str) {
  return chars(str).reverse().join('');
};

},{"./chars":3}],46:[function(require,module,exports){
var pad = require('./pad');

module.exports = function rpad(str, length, padStr) {
  return pad(str, length, padStr, 'right');
};

},{"./pad":39}],47:[function(require,module,exports){
var makeString = require('./helper/makeString');
var defaultToWhiteSpace = require('./helper/defaultToWhiteSpace');
var nativeTrimRight = String.prototype.trimRight;

module.exports = function rtrim(str, characters) {
  str = makeString(str);
  if (!characters && nativeTrimRight) return nativeTrimRight.call(str);
  characters = defaultToWhiteSpace(characters);
  return str.replace(new RegExp(characters + '+$'), '');
};

},{"./helper/defaultToWhiteSpace":16,"./helper/makeString":20}],48:[function(require,module,exports){
var trim = require('./trim');
var dasherize = require('./dasherize');
var cleanDiacritics = require('./cleanDiacritics');

module.exports = function slugify(str) {
  return trim(dasherize(cleanDiacritics(str).replace(/[^\w\s-]/g, '-').toLowerCase()), '-');
};

},{"./cleanDiacritics":7,"./dasherize":9,"./trim":65}],49:[function(require,module,exports){
var chars = require('./chars');

module.exports = function splice(str, i, howmany, substr) {
  var arr = chars(str);
  arr.splice(~~i, ~~howmany, substr);
  return arr.join('');
};

},{"./chars":3}],50:[function(require,module,exports){
var deprecate = require('util-deprecate');

module.exports = deprecate(require('sprintf-js').sprintf,
  'sprintf() will be removed in the next major release, use the sprintf-js package instead.');

},{"sprintf-js":36,"util-deprecate":37}],51:[function(require,module,exports){
var makeString = require('./helper/makeString');
var toPositive = require('./helper/toPositive');

module.exports = function startsWith(str, starts, position) {
  str = makeString(str);
  starts = '' + starts;
  position = position == null ? 0 : Math.min(toPositive(position), str.length);
  return str.lastIndexOf(starts, position) === position;
};

},{"./helper/makeString":20,"./helper/toPositive":22}],52:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function strLeft(str, sep) {
  str = makeString(str);
  sep = makeString(sep);
  var pos = !sep ? -1 : str.indexOf(sep);
  return~ pos ? str.slice(0, pos) : str;
};

},{"./helper/makeString":20}],53:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function strLeftBack(str, sep) {
  str = makeString(str);
  sep = makeString(sep);
  var pos = str.lastIndexOf(sep);
  return~ pos ? str.slice(0, pos) : str;
};

},{"./helper/makeString":20}],54:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function strRight(str, sep) {
  str = makeString(str);
  sep = makeString(sep);
  var pos = !sep ? -1 : str.indexOf(sep);
  return~ pos ? str.slice(pos + sep.length, str.length) : str;
};

},{"./helper/makeString":20}],55:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function strRightBack(str, sep) {
  str = makeString(str);
  sep = makeString(sep);
  var pos = !sep ? -1 : str.lastIndexOf(sep);
  return~ pos ? str.slice(pos + sep.length, str.length) : str;
};

},{"./helper/makeString":20}],56:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function stripTags(str) {
  return makeString(str).replace(/<\/?[^>]+>/g, '');
};

},{"./helper/makeString":20}],57:[function(require,module,exports){
var adjacent = require('./helper/adjacent');

module.exports = function succ(str) {
  return adjacent(str, 1);
};

},{"./helper/adjacent":15}],58:[function(require,module,exports){
module.exports = function surround(str, wrapper) {
  return [wrapper, str, wrapper].join('');
};

},{}],59:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function swapCase(str) {
  return makeString(str).replace(/\S/g, function(c) {
    return c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase();
  });
};

},{"./helper/makeString":20}],60:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function titleize(str) {
  return makeString(str).toLowerCase().replace(/(?:^|\s|-)\S/g, function(c) {
    return c.toUpperCase();
  });
};

},{"./helper/makeString":20}],61:[function(require,module,exports){
var trim = require('./trim');

function boolMatch(s, matchers) {
  var i, matcher, down = s.toLowerCase();
  matchers = [].concat(matchers);
  for (i = 0; i < matchers.length; i += 1) {
    matcher = matchers[i];
    if (!matcher) continue;
    if (matcher.test && matcher.test(s)) return true;
    if (matcher.toLowerCase() === down) return true;
  }
}

module.exports = function toBoolean(str, trueValues, falseValues) {
  if (typeof str === 'number') str = '' + str;
  if (typeof str !== 'string') return !!str;
  str = trim(str);
  if (boolMatch(str, trueValues || ['true', '1'])) return true;
  if (boolMatch(str, falseValues || ['false', '0'])) return false;
};

},{"./trim":65}],62:[function(require,module,exports){
module.exports = function toNumber(num, precision) {
  if (num == null) return 0;
  var factor = Math.pow(10, isFinite(precision) ? precision : 0);
  return Math.round(num * factor) / factor;
};

},{}],63:[function(require,module,exports){
var rtrim = require('./rtrim');

module.exports = function toSentence(array, separator, lastSeparator, serial) {
  separator = separator || ', ';
  lastSeparator = lastSeparator || ' and ';
  var a = array.slice(),
    lastMember = a.pop();

  if (array.length > 2 && serial) lastSeparator = rtrim(separator) + lastSeparator;

  return a.length ? a.join(separator) + lastSeparator + lastMember : lastMember;
};

},{"./rtrim":47}],64:[function(require,module,exports){
var toSentence = require('./toSentence');

module.exports = function toSentenceSerial(array, sep, lastSep) {
  return toSentence(array, sep, lastSep, true);
};

},{"./toSentence":63}],65:[function(require,module,exports){
var makeString = require('./helper/makeString');
var defaultToWhiteSpace = require('./helper/defaultToWhiteSpace');
var nativeTrim = String.prototype.trim;

module.exports = function trim(str, characters) {
  str = makeString(str);
  if (!characters && nativeTrim) return nativeTrim.call(str);
  characters = defaultToWhiteSpace(characters);
  return str.replace(new RegExp('^' + characters + '+|' + characters + '+$', 'g'), '');
};

},{"./helper/defaultToWhiteSpace":16,"./helper/makeString":20}],66:[function(require,module,exports){
var makeString = require('./helper/makeString');

module.exports = function truncate(str, length, truncateStr) {
  str = makeString(str);
  truncateStr = truncateStr || '...';
  length = ~~length;
  return str.length > length ? str.slice(0, length) + truncateStr : str;
};

},{"./helper/makeString":20}],67:[function(require,module,exports){
var trim = require('./trim');

module.exports = function underscored(str) {
  return trim(str).replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
};

},{"./trim":65}],68:[function(require,module,exports){
var makeString = require('./helper/makeString');
var htmlEntities = require('./helper/htmlEntities');

module.exports = function unescapeHTML(str) {
  return makeString(str).replace(/\&([^;]{1,10});/g, function(entity, entityCode) {
    var match;

    if (entityCode in htmlEntities) {
      return htmlEntities[entityCode];
    /*eslint no-cond-assign: 0*/
    } else if (match = entityCode.match(/^#x([\da-fA-F]+)$/)) {
      return String.fromCharCode(parseInt(match[1], 16));
    /*eslint no-cond-assign: 0*/
    } else if (match = entityCode.match(/^#(\d+)$/)) {
      return String.fromCharCode(~~match[1]);
    } else {
      return entity;
    }
  });
};

},{"./helper/htmlEntities":19,"./helper/makeString":20}],69:[function(require,module,exports){
module.exports = function unquote(str, quoteChar) {
  quoteChar = quoteChar || '"';
  if (str[0] === quoteChar && str[str.length - 1] === quoteChar)
    return str.slice(1, str.length - 1);
  else return str;
};

},{}],70:[function(require,module,exports){
var deprecate = require('util-deprecate');

module.exports = deprecate(require('sprintf-js').vsprintf,
  'vsprintf() will be removed in the next major release, use the sprintf-js package instead.');

},{"sprintf-js":36,"util-deprecate":37}],71:[function(require,module,exports){
var isBlank = require('./isBlank');
var trim = require('./trim');

module.exports = function words(str, delimiter) {
  if (isBlank(str)) return [];
  return trim(str, delimiter).split(delimiter || /\s+/);
};

},{"./isBlank":27,"./trim":65}],72:[function(require,module,exports){
// Wrap
// wraps a string by a certain width

var makeString = require('./helper/makeString');

module.exports = function wrap(str, options){
  str = makeString(str);
  
  options = options || {};
  
  var width = options.width || 75;
  var seperator = options.seperator || '\n';
  var cut = options.cut || false;
  var preserveSpaces = options.preserveSpaces || false;
  var trailingSpaces = options.trailingSpaces || false;
  
  var result;
  
  if(width <= 0){
    return str;
  }
  
  else if(!cut){
  
    var words = str.split(' ');
    var current_column = 0;
    result = '';
  
    while(words.length > 0){
      
      // if adding a space and the next word would cause this line to be longer than width...
      if(1 + words[0].length + current_column > width){
        //start a new line if this line is not already empty
        if(current_column > 0){
          // add a space at the end of the line is preserveSpaces is true
          if (preserveSpaces){
            result += ' ';
            current_column++;
          }
          // fill the rest of the line with spaces if trailingSpaces option is true
          else if(trailingSpaces){
            while(current_column < width){
              result += ' ';
              current_column++;
            }            
          }
          //start new line
          result += seperator;
          current_column = 0;
        }
      }
  
      // if not at the begining of the line, add a space in front of the word
      if(current_column > 0){
        result += ' ';
        current_column++;
      }
  
      // tack on the next word, update current column, a pop words array
      result += words[0];
      current_column += words[0].length;
      words.shift();
  
    }
  
    // fill the rest of the line with spaces if trailingSpaces option is true
    if(trailingSpaces){
      while(current_column < width){
        result += ' ';
        current_column++;
      }            
    }
  
    return result;
  
  }
  
  else {
  
    var index = 0;
    result = '';
  
    // walk through each character and add seperators where appropriate
    while(index < str.length){
      if(index % width == 0 && index > 0){
        result += seperator;
      }
      result += str.charAt(index);
      index++;
    }
  
    // fill the rest of the line with spaces if trailingSpaces option is true
    if(trailingSpaces){
      while(index % width > 0){
        result += ' ';
        index++;
      }            
    }
    
    return result;
  }
};

},{"./helper/makeString":20}]},{},[25])(25)
});

define('query',[
	'jquery',
	'lodash-compat'
], function ($, _) {

	return function (url, params, skipLegacyStatusCheck) {

		if (!url) {
			throw new Error('url not found');
		}

		// FIXME: This is only required for the working with local test mocks
		// this logic should be moved outside of the framework to the server side

		var unwrapIfMocked = function (response) {

			// this is to work with the local mocks, they have different structure.
			var result = response;
			if (response._data) {
				result = response._data.serviceDataList || response._data;
			}

			return result;

		};

		var handleSessionTimeout = function (data, textStatus, jqXHR, success) {

			var dfr = $.Deferred();

			var resolveWith = (success) ? data : jqXHR;

			var getResponseHeader = jqXHR.getResponseHeader || data.getResponseHeader;

			if (!getResponseHeader) {
				dfr.resolve(jqXHR);
			}

			var redirectUrl = getResponseHeader('SESSION_TIMEOUT_REDIRECT_URL');

			if (redirectUrl) {
				window.location.replace(redirectUrl);
				dfr.reject(jqXHR);
			} else {
				dfr.resolve(resolveWith);
			}

			return dfr.promise();
		};

		var postProcess = function (response) {
			return unwrapIfMocked(response);
		};

		var requestParams = _.extend({
			url: url,
			cache: false,
			dataType: 'json postProcess',
			jsonp: false,
			converters: {
				// do custom post processing if needed
				'json postProcess': postProcess
			}
		}, params);

		var legacyStatusCheck = function (res) {

			if (skipLegacyStatusCheck) {
				return this;
			}

			var dfr = $.Deferred();

			// The response may be an array.
			var result = _.first(res) || res;

			// success flag for legacy API calls.
			// status for redmarine/lux API calls.
			if (result.status === 'ok' || result.status === 200 || result.success === true) {
				dfr.resolve(res);
			} else {
				dfr.reject(res);
			}

			return dfr.promise();
		};

		return $.ajax(requestParams)
			// Pav 2Mar15
			// Success and fail callbacks in .fail method have different signatures
			// see http://api.jquery.com/jquery.ajax/
			// below is to solve it
			.then(function (data, textStatus, jqXHR) {
				return handleSessionTimeout(data, textStatus, jqXHR, true);
			}, function (jqXHR, textStatus, errorThrown) {
				return handleSessionTimeout(errorThrown, textStatus, jqXHR);
			})
			.then(legacyStatusCheck);
	};

});
/*! nouislider - 8.5.1 - 2016-04-24 16:00:29 */

(function (factory) {

    if ( typeof define === 'function' && define.amd ) {

        // AMD. Register as an anonymous module.
        define('jslider',[], factory);

    } else if ( typeof exports === 'object' ) {

        // Node/CommonJS
        module.exports = factory();

    } else {

        // Browser globals
        window.noUiSlider = factory();
    }

}(function( ){

	'use strict';


	// Removes duplicates from an array.
	function unique(array) {
		return array.filter(function(a){
			return !this[a] ? this[a] = true : false;
		}, {});
	}

	// Round a value to the closest 'to'.
	function closest ( value, to ) {
		return Math.round(value / to) * to;
	}

	// Current position of an element relative to the document.
	function offset ( elem ) {

	var rect = elem.getBoundingClientRect(),
		doc = elem.ownerDocument,
		docElem = doc.documentElement,
		pageOffset = getPageOffset();

		// getBoundingClientRect contains left scroll in Chrome on Android.
		// I haven't found a feature detection that proves this. Worst case
		// scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
		if ( /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) ) {
			pageOffset.x = 0;
		}

		return {
			top: rect.top + pageOffset.y - docElem.clientTop,
			left: rect.left + pageOffset.x - docElem.clientLeft
		};
	}

	// Checks whether a value is numerical.
	function isNumeric ( a ) {
		return typeof a === 'number' && !isNaN( a ) && isFinite( a );
	}

	// Sets a class and removes it after [duration] ms.
	function addClassFor ( element, className, duration ) {
		addClass(element, className);
		setTimeout(function(){
			removeClass(element, className);
		}, duration);
	}

	// Limits a value to 0 - 100
	function limit ( a ) {
		return Math.max(Math.min(a, 100), 0);
	}

	// Wraps a variable as an array, if it isn't one yet.
	function asArray ( a ) {
		return Array.isArray(a) ? a : [a];
	}

	// Counts decimals
	function countDecimals ( numStr ) {
		var pieces = numStr.split(".");
		return pieces.length > 1 ? pieces[1].length : 0;
	}

	// http://youmightnotneedjquery.com/#add_class
	function addClass ( el, className ) {
		if ( el.classList ) {
			el.classList.add(className);
		} else {
			el.className += ' ' + className;
		}
	}

	// http://youmightnotneedjquery.com/#remove_class
	function removeClass ( el, className ) {
		if ( el.classList ) {
			el.classList.remove(className);
		} else {
			el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		}
	}

	// https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
	function hasClass ( el, className ) {
		return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
	function getPageOffset ( ) {

		var supportPageOffset = window.pageXOffset !== undefined,
			isCSS1Compat = ((document.compatMode || "") === "CSS1Compat"),
			x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
			y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;

		return {
			x: x,
			y: y
		};
	}

	// we provide a function to compute constants instead
	// of accessing window.* as soon as the module needs it
	// so that we do not compute anything if not needed
	function getActions ( ) {

		// Determine the events to bind. IE11 implements pointerEvents without
		// a prefix, which breaks compatibility with the IE10 implementation.
		return window.navigator.pointerEnabled ? {
			start: 'pointerdown',
			move: 'pointermove',
			end: 'pointerup'
		} : window.navigator.msPointerEnabled ? {
			start: 'MSPointerDown',
			move: 'MSPointerMove',
			end: 'MSPointerUp'
		} : {
			start: 'mousedown touchstart',
			move: 'mousemove touchmove',
			end: 'mouseup touchend'
		};
	}


// Value calculation

	// Determine the size of a sub-range in relation to a full range.
	function subRangeRatio ( pa, pb ) {
		return (100 / (pb - pa));
	}

	// (percentage) How many percent is this value of this range?
	function fromPercentage ( range, value ) {
		return (value * 100) / ( range[1] - range[0] );
	}

	// (percentage) Where is this value on this range?
	function toPercentage ( range, value ) {
		return fromPercentage( range, range[0] < 0 ?
			value + Math.abs(range[0]) :
				value - range[0] );
	}

	// (value) How much is this percentage on this range?
	function isPercentage ( range, value ) {
		return ((value * ( range[1] - range[0] )) / 100) + range[0];
	}


// Range conversion

	function getJ ( value, arr ) {

		var j = 1;

		while ( value >= arr[j] ){
			j += 1;
		}

		return j;
	}

	// (percentage) Input a value, find where, on a scale of 0-100, it applies.
	function toStepping ( xVal, xPct, value ) {

		if ( value >= xVal.slice(-1)[0] ){
			return 100;
		}

		var j = getJ( value, xVal ), va, vb, pa, pb;

		va = xVal[j-1];
		vb = xVal[j];
		pa = xPct[j-1];
		pb = xPct[j];

		return pa + (toPercentage([va, vb], value) / subRangeRatio (pa, pb));
	}

	// (value) Input a percentage, find where it is on the specified range.
	function fromStepping ( xVal, xPct, value ) {

		// There is no range group that fits 100
		if ( value >= 100 ){
			return xVal.slice(-1)[0];
		}

		var j = getJ( value, xPct ), va, vb, pa, pb;

		va = xVal[j-1];
		vb = xVal[j];
		pa = xPct[j-1];
		pb = xPct[j];

		return isPercentage([va, vb], (value - pa) * subRangeRatio (pa, pb));
	}

	// (percentage) Get the step that applies at a certain value.
	function getStep ( xPct, xSteps, snap, value ) {

		if ( value === 100 ) {
			return value;
		}

		var j = getJ( value, xPct ), a, b;

		// If 'snap' is set, steps are used as fixed points on the slider.
		if ( snap ) {

			a = xPct[j-1];
			b = xPct[j];

			// Find the closest position, a or b.
			if ((value - a) > ((b-a)/2)){
				return b;
			}

			return a;
		}

		if ( !xSteps[j-1] ){
			return value;
		}

		return xPct[j-1] + closest(
			value - xPct[j-1],
			xSteps[j-1]
		);
	}


// Entry parsing

	function handleEntryPoint ( index, value, that ) {

		var percentage;

		// Wrap numerical input in an array.
		if ( typeof value === "number" ) {
			value = [value];
		}

		// Reject any invalid input, by testing whether value is an array.
		if ( Object.prototype.toString.call( value ) !== '[object Array]' ){
			throw new Error("noUiSlider: 'range' contains invalid value.");
		}

		// Covert min/max syntax to 0 and 100.
		if ( index === 'min' ) {
			percentage = 0;
		} else if ( index === 'max' ) {
			percentage = 100;
		} else {
			percentage = parseFloat( index );
		}

		// Check for correct input.
		if ( !isNumeric( percentage ) || !isNumeric( value[0] ) ) {
			throw new Error("noUiSlider: 'range' value isn't numeric.");
		}

		// Store values.
		that.xPct.push( percentage );
		that.xVal.push( value[0] );

		// NaN will evaluate to false too, but to keep
		// logging clear, set step explicitly. Make sure
		// not to override the 'step' setting with false.
		if ( !percentage ) {
			if ( !isNaN( value[1] ) ) {
				that.xSteps[0] = value[1];
			}
		} else {
			that.xSteps.push( isNaN(value[1]) ? false : value[1] );
		}
	}

	function handleStepPoint ( i, n, that ) {

		// Ignore 'false' stepping.
		if ( !n ) {
			return true;
		}

		// Factor to range ratio
		that.xSteps[i] = fromPercentage([
			 that.xVal[i]
			,that.xVal[i+1]
		], n) / subRangeRatio (
			that.xPct[i],
			that.xPct[i+1] );
	}


// Interface

	// The interface to Spectrum handles all direction-based
	// conversions, so the above values are unaware.

	function Spectrum ( entry, snap, direction, singleStep ) {

		this.xPct = [];
		this.xVal = [];
		this.xSteps = [ singleStep || false ];
		this.xNumSteps = [ false ];

		this.snap = snap;
		this.direction = direction;

		var index, ordered = [ /* [0, 'min'], [1, '50%'], [2, 'max'] */ ];

		// Map the object keys to an array.
		for ( index in entry ) {
			if ( entry.hasOwnProperty(index) ) {
				ordered.push([entry[index], index]);
			}
		}

		// Sort all entries by value (numeric sort).
		if ( ordered.length && typeof ordered[0][0] === "object" ) {
			ordered.sort(function(a, b) { return a[0][0] - b[0][0]; });
		} else {
			ordered.sort(function(a, b) { return a[0] - b[0]; });
		}


		// Convert all entries to subranges.
		for ( index = 0; index < ordered.length; index++ ) {
			handleEntryPoint(ordered[index][1], ordered[index][0], this);
		}

		// Store the actual step values.
		// xSteps is sorted in the same order as xPct and xVal.
		this.xNumSteps = this.xSteps.slice(0);

		// Convert all numeric steps to the percentage of the subrange they represent.
		for ( index = 0; index < this.xNumSteps.length; index++ ) {
			handleStepPoint(index, this.xNumSteps[index], this);
		}
	}

	Spectrum.prototype.getMargin = function ( value ) {
		return this.xPct.length === 2 ? fromPercentage(this.xVal, value) : false;
	};

	Spectrum.prototype.toStepping = function ( value ) {

		value = toStepping( this.xVal, this.xPct, value );

		// Invert the value if this is a right-to-left slider.
		if ( this.direction ) {
			value = 100 - value;
		}

		return value;
	};

	Spectrum.prototype.fromStepping = function ( value ) {

		// Invert the value if this is a right-to-left slider.
		if ( this.direction ) {
			value = 100 - value;
		}

		return fromStepping( this.xVal, this.xPct, value );
	};

	Spectrum.prototype.getStep = function ( value ) {

		// Find the proper step for rtl sliders by search in inverse direction.
		// Fixes issue #262.
		if ( this.direction ) {
			value = 100 - value;
		}

		value = getStep(this.xPct, this.xSteps, this.snap, value );

		if ( this.direction ) {
			value = 100 - value;
		}

		return value;
	};

	Spectrum.prototype.getApplicableStep = function ( value ) {

		// If the value is 100%, return the negative step twice.
		var j = getJ(value, this.xPct), offset = value === 100 ? 2 : 1;
		return [this.xNumSteps[j-2], this.xVal[j-offset], this.xNumSteps[j-offset]];
	};

	// Outside testing
	Spectrum.prototype.convert = function ( value ) {
		return this.getStep(this.toStepping(value));
	};

/*	Every input option is tested and parsed. This'll prevent
	endless validation in internal methods. These tests are
	structured with an item for every option available. An
	option can be marked as required by setting the 'r' flag.
	The testing function is provided with three arguments:
		- The provided value for the option;
		- A reference to the options object;
		- The name for the option;

	The testing function returns false when an error is detected,
	or true when everything is OK. It can also modify the option
	object, to make sure all values can be correctly looped elsewhere. */

	var defaultFormatter = { 'to': function( value ){
		return value !== undefined && value.toFixed(2);
	}, 'from': Number };

	function testStep ( parsed, entry ) {

		if ( !isNumeric( entry ) ) {
			throw new Error("noUiSlider: 'step' is not numeric.");
		}

		// The step option can still be used to set stepping
		// for linear sliders. Overwritten if set in 'range'.
		parsed.singleStep = entry;
	}

	function testRange ( parsed, entry ) {

		// Filter incorrect input.
		if ( typeof entry !== 'object' || Array.isArray(entry) ) {
			throw new Error("noUiSlider: 'range' is not an object.");
		}

		// Catch missing start or end.
		if ( entry.min === undefined || entry.max === undefined ) {
			throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
		}

		// Catch equal start or end.
		if ( entry.min === entry.max ) {
			throw new Error("noUiSlider: 'range' 'min' and 'max' cannot be equal.");
		}

		parsed.spectrum = new Spectrum(entry, parsed.snap, parsed.dir, parsed.singleStep);
	}

	function testStart ( parsed, entry ) {

		entry = asArray(entry);

		// Validate input. Values aren't tested, as the public .val method
		// will always provide a valid location.
		if ( !Array.isArray( entry ) || !entry.length || entry.length > 2 ) {
			throw new Error("noUiSlider: 'start' option is incorrect.");
		}

		// Store the number of handles.
		parsed.handles = entry.length;

		// When the slider is initialized, the .val method will
		// be called with the start options.
		parsed.start = entry;
	}

	function testSnap ( parsed, entry ) {

		// Enforce 100% stepping within subranges.
		parsed.snap = entry;

		if ( typeof entry !== 'boolean' ){
			throw new Error("noUiSlider: 'snap' option must be a boolean.");
		}
	}

	function testAnimate ( parsed, entry ) {

		// Enforce 100% stepping within subranges.
		parsed.animate = entry;

		if ( typeof entry !== 'boolean' ){
			throw new Error("noUiSlider: 'animate' option must be a boolean.");
		}
	}

	function testAnimationDuration ( parsed, entry ) {

		parsed.animationDuration = entry;

		if ( typeof entry !== 'number' ){
			throw new Error("noUiSlider: 'animationDuration' option must be a number.");
		}
	}

	function testConnect ( parsed, entry ) {

		if ( entry === 'lower' && parsed.handles === 1 ) {
			parsed.connect = 1;
		} else if ( entry === 'upper' && parsed.handles === 1 ) {
			parsed.connect = 2;
		} else if ( entry === true && parsed.handles === 2 ) {
			parsed.connect = 3;
		} else if ( entry === false ) {
			parsed.connect = 0;
		} else {
			throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
		}
	}

	function testOrientation ( parsed, entry ) {

		// Set orientation to an a numerical value for easy
		// array selection.
		switch ( entry ){
		  case 'horizontal':
			parsed.ort = 0;
			break;
		  case 'vertical':
			parsed.ort = 1;
			break;
		  default:
			throw new Error("noUiSlider: 'orientation' option is invalid.");
		}
	}

	function testMargin ( parsed, entry ) {

		if ( !isNumeric(entry) ){
			throw new Error("noUiSlider: 'margin' option must be numeric.");
		}

		// Issue #582
		if ( entry === 0 ) {
			return;
		}

		parsed.margin = parsed.spectrum.getMargin(entry);

		if ( !parsed.margin ) {
			throw new Error("noUiSlider: 'margin' option is only supported on linear sliders.");
		}
	}

	function testLimit ( parsed, entry ) {

		if ( !isNumeric(entry) ){
			throw new Error("noUiSlider: 'limit' option must be numeric.");
		}

		parsed.limit = parsed.spectrum.getMargin(entry);

		if ( !parsed.limit ) {
			throw new Error("noUiSlider: 'limit' option is only supported on linear sliders.");
		}
	}

	function testDirection ( parsed, entry ) {

		// Set direction as a numerical value for easy parsing.
		// Invert connection for RTL sliders, so that the proper
		// handles get the connect/background classes.
		switch ( entry ) {
		  case 'ltr':
			parsed.dir = 0;
			break;
		  case 'rtl':
			parsed.dir = 1;
			parsed.connect = [0,2,1,3][parsed.connect];
			break;
		  default:
			throw new Error("noUiSlider: 'direction' option was not recognized.");
		}
	}

	function testBehaviour ( parsed, entry ) {

		// Make sure the input is a string.
		if ( typeof entry !== 'string' ) {
			throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
		}

		// Check if the string contains any keywords.
		// None are required.
		var tap = entry.indexOf('tap') >= 0,
			drag = entry.indexOf('drag') >= 0,
			fixed = entry.indexOf('fixed') >= 0,
			snap = entry.indexOf('snap') >= 0,
			hover = entry.indexOf('hover') >= 0;

		// Fix #472
		if ( drag && !parsed.connect ) {
			throw new Error("noUiSlider: 'drag' behaviour must be used with 'connect': true.");
		}

		parsed.events = {
			tap: tap || snap,
			drag: drag,
			fixed: fixed,
			snap: snap,
			hover: hover
		};
	}

	function testTooltips ( parsed, entry ) {

		var i;

		if ( entry === false ) {
			return;
		} else if ( entry === true ) {

			parsed.tooltips = [];

			for ( i = 0; i < parsed.handles; i++ ) {
				parsed.tooltips.push(true);
			}

		} else {

			parsed.tooltips = asArray(entry);

			if ( parsed.tooltips.length !== parsed.handles ) {
				throw new Error("noUiSlider: must pass a formatter for all handles.");
			}

			parsed.tooltips.forEach(function(formatter){
				if ( typeof formatter !== 'boolean' && (typeof formatter !== 'object' || typeof formatter.to !== 'function') ) {
					throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
				}
			});
		}
	}

	function testFormat ( parsed, entry ) {

		parsed.format = entry;

		// Any object with a to and from method is supported.
		if ( typeof entry.to === 'function' && typeof entry.from === 'function' ) {
			return true;
		}

		throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
	}

	function testCssPrefix ( parsed, entry ) {

		if ( entry !== undefined && typeof entry !== 'string' && entry !== false ) {
			throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
		}

		parsed.cssPrefix = entry;
	}

	function testCssClasses ( parsed, entry ) {

		if ( entry !== undefined && typeof entry !== 'object' ) {
			throw new Error("noUiSlider: 'cssClasses' must be an object.");
		}

		if ( typeof parsed.cssPrefix === 'string' ) {
			parsed.cssClasses = {};

			for ( var key in entry ) {
				if ( !entry.hasOwnProperty(key) ) { continue; }

				parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
			}
		} else {
			parsed.cssClasses = entry;
		}
	}

	// Test all developer settings and parse to assumption-safe values.
	function testOptions ( options ) {

		// To prove a fix for #537, freeze options here.
		// If the object is modified, an error will be thrown.
		// Object.freeze(options);

		var parsed = {
			margin: 0,
			limit: 0,
			animate: true,
			animationDuration: 300,
			format: defaultFormatter
		}, tests;

		// Tests are executed in the order they are presented here.
		tests = {
			'step': { r: false, t: testStep },
			'start': { r: true, t: testStart },
			'connect': { r: true, t: testConnect },
			'direction': { r: true, t: testDirection },
			'snap': { r: false, t: testSnap },
			'animate': { r: false, t: testAnimate },
			'animationDuration': { r: false, t: testAnimationDuration },
			'range': { r: true, t: testRange },
			'orientation': { r: false, t: testOrientation },
			'margin': { r: false, t: testMargin },
			'limit': { r: false, t: testLimit },
			'behaviour': { r: true, t: testBehaviour },
			'format': { r: false, t: testFormat },
			'tooltips': { r: false, t: testTooltips },
			'cssPrefix': { r: false, t: testCssPrefix },
			'cssClasses': { r: false, t: testCssClasses }
		};

		var defaults = {
			'connect': false,
			'direction': 'ltr',
			'behaviour': 'tap',
			'orientation': 'horizontal',
			'cssPrefix' : 'noUi-',
			'cssClasses': {
				target: 'target',
				base: 'base',
				origin: 'origin',
				handle: 'handle',
				handleLower: 'handle-lower',
				handleUpper: 'handle-upper',
				horizontal: 'horizontal',
				vertical: 'vertical',
				background: 'background',
				connect: 'connect',
				ltr: 'ltr',
				rtl: 'rtl',
				draggable: 'draggable',
				drag: 'state-drag',
				tap: 'state-tap',
				active: 'active',
				stacking: 'stacking',
				tooltip: 'tooltip',
				pips: 'pips',
				pipsHorizontal: 'pips-horizontal',
				pipsVertical: 'pips-vertical',
				marker: 'marker',
				markerHorizontal: 'marker-horizontal',
				markerVertical: 'marker-vertical',
				markerNormal: 'marker-normal',
				markerLarge: 'marker-large',
				markerSub: 'marker-sub',
				value: 'value',
				valueHorizontal: 'value-horizontal',
				valueVertical: 'value-vertical',
				valueNormal: 'value-normal',
				valueLarge: 'value-large',
				valueSub: 'value-sub'
			}
		};

		// Run all options through a testing mechanism to ensure correct
		// input. It should be noted that options might get modified to
		// be handled properly. E.g. wrapping integers in arrays.
		Object.keys(tests).forEach(function( name ){

			// If the option isn't set, but it is required, throw an error.
			if ( options[name] === undefined && defaults[name] === undefined ) {

				if ( tests[name].r ) {
					throw new Error("noUiSlider: '" + name + "' is required.");
				}

				return true;
			}

			tests[name].t( parsed, options[name] === undefined ? defaults[name] : options[name] );
		});

		// Forward pips options
		parsed.pips = options.pips;

		// Pre-define the styles.
		parsed.style = parsed.ort ? 'top' : 'left';

		return parsed;
	}


function closure ( target, options, originalOptions ){
	var
		actions = getActions( ),
		// All variables local to 'closure' are prefixed with 'scope_'
		scope_Target = target,
		scope_Locations = [-1, -1],
		scope_Base,
		scope_Handles,
		scope_Spectrum = options.spectrum,
		scope_Values = [],
		scope_Events = {},
		scope_Self;


	// Delimit proposed values for handle positions.
	function getPositions ( a, b, delimit ) {

		// Add movement to current position.
		var c = a + b[0], d = a + b[1];

		// Only alter the other position on drag,
		// not on standard sliding.
		if ( delimit ) {
			if ( c < 0 ) {
				d += Math.abs(c);
			}
			if ( d > 100 ) {
				c -= ( d - 100 );
			}

			// Limit values to 0 and 100.
			return [limit(c), limit(d)];
		}

		return [c,d];
	}

	// Provide a clean event with standardized offset values.
	function fixEvent ( e, pageOffset ) {

		// Prevent scrolling and panning on touch events, while
		// attempting to slide. The tap event also depends on this.
		e.preventDefault();

		// Filter the event to register the type, which can be
		// touch, mouse or pointer. Offset changes need to be
		// made on an event specific basis.
		var touch = e.type.indexOf('touch') === 0,
			mouse = e.type.indexOf('mouse') === 0,
			pointer = e.type.indexOf('pointer') === 0,
			x,y, event = e;

		// IE10 implemented pointer events with a prefix;
		if ( e.type.indexOf('MSPointer') === 0 ) {
			pointer = true;
		}

		if ( touch ) {
			// noUiSlider supports one movement at a time,
			// so we can select the first 'changedTouch'.
			x = e.changedTouches[0].pageX;
			y = e.changedTouches[0].pageY;
		}

		pageOffset = pageOffset || getPageOffset();

		if ( mouse || pointer ) {
			x = e.clientX + pageOffset.x;
			y = e.clientY + pageOffset.y;
		}

		event.pageOffset = pageOffset;
		event.points = [x, y];
		event.cursor = mouse || pointer; // Fix #435

		return event;
	}

	// Append a handle to the base.
	function addHandle ( direction, index ) {

		var origin = document.createElement('div'),
			handle = document.createElement('div'),
			classModifier = [options.cssClasses.handleLower, options.cssClasses.handleUpper];

		if ( direction ) {
			classModifier.reverse();
		}

		addClass(handle, options.cssClasses.handle);
		addClass(handle, classModifier[index]);

		addClass(origin, options.cssClasses.origin);
		origin.appendChild(handle);

		return origin;
	}

	// Add the proper connection classes.
	function addConnection ( connect, target, handles ) {

		// Apply the required connection classes to the elements
		// that need them. Some classes are made up for several
		// segments listed in the class list, to allow easy
		// renaming and provide a minor compression benefit.
		switch ( connect ) {
			case 1:	addClass(target, options.cssClasses.connect);
					addClass(handles[0], options.cssClasses.background);
					break;
			case 3: addClass(handles[1], options.cssClasses.background);
					/* falls through */
			case 2: addClass(handles[0], options.cssClasses.connect);
					/* falls through */
			case 0: addClass(target, options.cssClasses.background);
					break;
		}
	}

	// Add handles to the slider base.
	function addHandles ( nrHandles, direction, base ) {

		var index, handles = [];

		// Append handles.
		for ( index = 0; index < nrHandles; index += 1 ) {

			// Keep a list of all added handles.
			handles.push( base.appendChild(addHandle( direction, index )) );
		}

		return handles;
	}

	// Initialize a single slider.
	function addSlider ( direction, orientation, target ) {

		// Apply classes and data to the target.
		addClass(target, options.cssClasses.target);

		if ( direction === 0 ) {
			addClass(target, options.cssClasses.ltr);
		} else {
			addClass(target, options.cssClasses.rtl);
		}

		if ( orientation === 0 ) {
			addClass(target, options.cssClasses.horizontal);
		} else {
			addClass(target, options.cssClasses.vertical);
		}

		var div = document.createElement('div');
		addClass(div, options.cssClasses.base);
		target.appendChild(div);
		return div;
	}


	function addTooltip ( handle, index ) {

		if ( !options.tooltips[index] ) {
			return false;
		}

		var element = document.createElement('div');
		element.className = options.cssClasses.tooltip;
		return handle.firstChild.appendChild(element);
	}

	// The tooltips option is a shorthand for using the 'update' event.
	function tooltips ( ) {

		if ( options.dir ) {
			options.tooltips.reverse();
		}

		// Tooltips are added with options.tooltips in original order.
		var tips = scope_Handles.map(addTooltip);

		if ( options.dir ) {
			tips.reverse();
			options.tooltips.reverse();
		}

		bindEvent('update', function(f, o, r) {
			if ( tips[o] ) {
				tips[o].innerHTML = options.tooltips[o] === true ? f[o] : options.tooltips[o].to(r[o]);
			}
		});
	}


	function getGroup ( mode, values, stepped ) {

		// Use the range.
		if ( mode === 'range' || mode === 'steps' ) {
			return scope_Spectrum.xVal;
		}

		if ( mode === 'count' ) {

			// Divide 0 - 100 in 'count' parts.
			var spread = ( 100 / (values-1) ), v, i = 0;
			values = [];

			// List these parts and have them handled as 'positions'.
			while ((v=i++*spread) <= 100 ) {
				values.push(v);
			}

			mode = 'positions';
		}

		if ( mode === 'positions' ) {

			// Map all percentages to on-range values.
			return values.map(function( value ){
				return scope_Spectrum.fromStepping( stepped ? scope_Spectrum.getStep( value ) : value );
			});
		}

		if ( mode === 'values' ) {

			// If the value must be stepped, it needs to be converted to a percentage first.
			if ( stepped ) {

				return values.map(function( value ){

					// Convert to percentage, apply step, return to value.
					return scope_Spectrum.fromStepping( scope_Spectrum.getStep( scope_Spectrum.toStepping( value ) ) );
				});

			}

			// Otherwise, we can simply use the values.
			return values;
		}
	}

	function generateSpread ( density, mode, group ) {

		function safeIncrement(value, increment) {
			// Avoid floating point variance by dropping the smallest decimal places.
			return (value + increment).toFixed(7) / 1;
		}

		var originalSpectrumDirection = scope_Spectrum.direction,
			indexes = {},
			firstInRange = scope_Spectrum.xVal[0],
			lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length-1],
			ignoreFirst = false,
			ignoreLast = false,
			prevPct = 0;

		// This function loops the spectrum in an ltr linear fashion,
		// while the toStepping method is direction aware. Trick it into
		// believing it is ltr.
		scope_Spectrum.direction = 0;

		// Create a copy of the group, sort it and filter away all duplicates.
		group = unique(group.slice().sort(function(a, b){ return a - b; }));

		// Make sure the range starts with the first element.
		if ( group[0] !== firstInRange ) {
			group.unshift(firstInRange);
			ignoreFirst = true;
		}

		// Likewise for the last one.
		if ( group[group.length - 1] !== lastInRange ) {
			group.push(lastInRange);
			ignoreLast = true;
		}

		group.forEach(function ( current, index ) {

			// Get the current step and the lower + upper positions.
			var step, i, q,
				low = current,
				high = group[index+1],
				newPct, pctDifference, pctPos, type,
				steps, realSteps, stepsize;

			// When using 'steps' mode, use the provided steps.
			// Otherwise, we'll step on to the next subrange.
			if ( mode === 'steps' ) {
				step = scope_Spectrum.xNumSteps[ index ];
			}

			// Default to a 'full' step.
			if ( !step ) {
				step = high-low;
			}

			// Low can be 0, so test for false. If high is undefined,
			// we are at the last subrange. Index 0 is already handled.
			if ( low === false || high === undefined ) {
				return;
			}

			// Find all steps in the subrange.
			for ( i = low; i <= high; i = safeIncrement(i, step) ) {

				// Get the percentage value for the current step,
				// calculate the size for the subrange.
				newPct = scope_Spectrum.toStepping( i );
				pctDifference = newPct - prevPct;

				steps = pctDifference / density;
				realSteps = Math.round(steps);

				// This ratio represents the ammount of percentage-space a point indicates.
				// For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-devided.
				// Round the percentage offset to an even number, then divide by two
				// to spread the offset on both sides of the range.
				stepsize = pctDifference/realSteps;

				// Divide all points evenly, adding the correct number to this subrange.
				// Run up to <= so that 100% gets a point, event if ignoreLast is set.
				for ( q = 1; q <= realSteps; q += 1 ) {

					// The ratio between the rounded value and the actual size might be ~1% off.
					// Correct the percentage offset by the number of points
					// per subrange. density = 1 will result in 100 points on the
					// full range, 2 for 50, 4 for 25, etc.
					pctPos = prevPct + ( q * stepsize );
					indexes[pctPos.toFixed(5)] = ['x', 0];
				}

				// Determine the point type.
				type = (group.indexOf(i) > -1) ? 1 : ( mode === 'steps' ? 2 : 0 );

				// Enforce the 'ignoreFirst' option by overwriting the type for 0.
				if ( !index && ignoreFirst ) {
					type = 0;
				}

				if ( !(i === high && ignoreLast)) {
					// Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
					indexes[newPct.toFixed(5)] = [i, type];
				}

				// Update the percentage count.
				prevPct = newPct;
			}
		});

		// Reset the spectrum.
		scope_Spectrum.direction = originalSpectrumDirection;

		return indexes;
	}

	function addMarking ( spread, filterFunc, formatter ) {

		var element = document.createElement('div'),
			out = '',
			valueSizeClasses = [
				options.cssClasses.valueNormal,
				options.cssClasses.valueLarge,
				options.cssClasses.valueSub
			],
			markerSizeClasses = [
				options.cssClasses.markerNormal,
				options.cssClasses.markerLarge,
				options.cssClasses.markerSub
			],
			valueOrientationClasses = [
				options.cssClasses.valueHorizontal,
				options.cssClasses.valueVertical
			],
			markerOrientationClasses = [
				options.cssClasses.markerHorizontal,
				options.cssClasses.markerVertical
			];

		addClass(element, options.cssClasses.pips);
		addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);

		function getClasses( type, source ){
			var a = source === options.cssClasses.value,
				orientationClasses = a ? valueOrientationClasses : markerOrientationClasses,
				sizeClasses = a ? valueSizeClasses : markerSizeClasses;

			return source + ' ' + orientationClasses[options.ort] + ' ' + sizeClasses[type];
		}

		function getTags( offset, source, values ) {
			return 'class="' + getClasses(values[1], source) + '" style="' + options.style + ': ' + offset + '%"';
		}

		function addSpread ( offset, values ){

			if ( scope_Spectrum.direction ) {
				offset = 100 - offset;
			}

			// Apply the filter function, if it is set.
			values[1] = (values[1] && filterFunc) ? filterFunc(values[0], values[1]) : values[1];

			// Add a marker for every point
			out += '<div ' + getTags(offset, options.cssClasses.marker, values) + '></div>';

			// Values are only appended for points marked '1' or '2'.
			if ( values[1] ) {
				out += '<div ' + getTags(offset, options.cssClasses.value, values) + '>' + formatter.to(values[0]) + '</div>';
			}
		}

		// Append all points.
		Object.keys(spread).forEach(function(a){
			addSpread(a, spread[a]);
		});

		element.innerHTML = out;

		return element;
	}

	function pips ( grid ) {

	var mode = grid.mode,
		density = grid.density || 1,
		filter = grid.filter || false,
		values = grid.values || false,
		stepped = grid.stepped || false,
		group = getGroup( mode, values, stepped ),
		spread = generateSpread( density, mode, group ),
		format = grid.format || {
			to: Math.round
		};

		return scope_Target.appendChild(addMarking(
			spread,
			filter,
			format
		));
	}


	// Shorthand for base dimensions.
	function baseSize ( ) {
		var rect = scope_Base.getBoundingClientRect(), alt = 'offset' + ['Width', 'Height'][options.ort];
		return options.ort === 0 ? (rect.width||scope_Base[alt]) : (rect.height||scope_Base[alt]);
	}

	// External event handling
	function fireEvent ( event, handleNumber, tap ) {

		var i;

		// During initialization, do not fire events.
		for ( i = 0; i < options.handles; i++ ) {
			if ( scope_Locations[i] === -1 ) {
				return;
			}
		}

		if ( handleNumber !== undefined && options.handles !== 1 ) {
			handleNumber = Math.abs(handleNumber - options.dir);
		}

		Object.keys(scope_Events).forEach(function( targetEvent ) {

			var eventType = targetEvent.split('.')[0];

			if ( event === eventType ) {
				scope_Events[targetEvent].forEach(function( callback ) {

					callback.call(
						// Use the slider public API as the scope ('this')
						scope_Self,
						// Return values as array, so arg_1[arg_2] is always valid.
						asArray(valueGet()),
						// Handle index, 0 or 1
						handleNumber,
						// Unformatted slider values
						asArray(inSliderOrder(Array.prototype.slice.call(scope_Values))),
						// Event is fired by tap, true or false
						tap || false,
						// Left offset of the handle, in relation to the slider
						scope_Locations
					);
				});
			}
		});
	}

	// Returns the input array, respecting the slider direction configuration.
	function inSliderOrder ( values ) {

		// If only one handle is used, return a single value.
		if ( values.length === 1 ){
			return values[0];
		}

		if ( options.dir ) {
			return values.reverse();
		}

		return values;
	}


	// Handler for attaching events trough a proxy.
	function attach ( events, element, callback, data ) {

		// This function can be used to 'filter' events to the slider.
		// element is a node, not a nodeList

		var method = function ( e ){

			if ( scope_Target.hasAttribute('disabled') ) {
				return false;
			}

			// Stop if an active 'tap' transition is taking place.
			if ( hasClass(scope_Target, options.cssClasses.tap) ) {
				return false;
			}

			e = fixEvent(e, data.pageOffset);

			// Ignore right or middle clicks on start #454
			if ( events === actions.start && e.buttons !== undefined && e.buttons > 1 ) {
				return false;
			}

			// Ignore right or middle clicks on start #454
			if ( data.hover && e.buttons ) {
				return false;
			}

			e.calcPoint = e.points[ options.ort ];

			// Call the event handler with the event [ and additional data ].
			callback ( e, data );

		}, methods = [];

		// Bind a closure on the target for every event type.
		events.split(' ').forEach(function( eventName ){
			element.addEventListener(eventName, method, false);
			methods.push([eventName, method]);
		});

		return methods;
	}

	// Handle movement on document for handle and range drag.
	function move ( event, data ) {

		// Fix #498
		// Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
		// https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
		// IE9 has .buttons and .which zero on mousemove.
		// Firefox breaks the spec MDN defines.
		if ( navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0 ) {
			return end(event, data);
		}

		var handles = data.handles || scope_Handles, positions, state = false,
			proposal = ((event.calcPoint - data.start) * 100) / data.baseSize,
			handleNumber = handles[0] === scope_Handles[0] ? 0 : 1, i;

		// Calculate relative positions for the handles.
		positions = getPositions( proposal, data.positions, handles.length > 1);

		state = setHandle ( handles[0], positions[handleNumber], handles.length === 1 );

		if ( handles.length > 1 ) {

			state = setHandle ( handles[1], positions[handleNumber?0:1], false ) || state;

			if ( state ) {
				// fire for both handles
				for ( i = 0; i < data.handles.length; i++ ) {
					fireEvent('slide', i);
				}
			}
		} else if ( state ) {
			// Fire for a single handle
			fireEvent('slide', handleNumber);
		}
	}

	// Unbind move events on document, call callbacks.
	function end ( event, data ) {

		// The handle is no longer active, so remove the class.
		var active = scope_Base.querySelector( '.' + options.cssClasses.active ),
			handleNumber = data.handles[0] === scope_Handles[0] ? 0 : 1;

		if ( active !== null ) {
			removeClass(active, options.cssClasses.active);
		}

		// Remove cursor styles and text-selection events bound to the body.
		if ( event.cursor ) {
			document.body.style.cursor = '';
			document.body.removeEventListener('selectstart', document.body.noUiListener);
		}

		var d = document.documentElement;

		// Unbind the move and end events, which are added on 'start'.
		d.noUiListeners.forEach(function( c ) {
			d.removeEventListener(c[0], c[1]);
		});

		// Remove dragging class.
		removeClass(scope_Target, options.cssClasses.drag);

		// Fire the change and set events.
		fireEvent('set', handleNumber);
		fireEvent('change', handleNumber);

		// If this is a standard handle movement, fire the end event.
		if ( data.handleNumber !== undefined ) {
			fireEvent('end', data.handleNumber);
		}
	}

	// Fire 'end' when a mouse or pen leaves the document.
	function documentLeave ( event, data ) {
		if ( event.type === "mouseout" && event.target.nodeName === "HTML" && event.relatedTarget === null ){
			end ( event, data );
		}
	}

	// Bind move events on document.
	function start ( event, data ) {

		var d = document.documentElement;

		// Mark the handle as 'active' so it can be styled.
		if ( data.handles.length === 1 ) {
			// Support 'disabled' handles
			if ( data.handles[0].hasAttribute('disabled') ) {
				return false;
			}

			addClass(data.handles[0].children[0], options.cssClasses.active);
		}

		// Fix #551, where a handle gets selected instead of dragged.
		event.preventDefault();

		// A drag should never propagate up to the 'tap' event.
		event.stopPropagation();

		// Attach the move and end events.
		var moveEvent = attach(actions.move, d, move, {
			start: event.calcPoint,
			baseSize: baseSize(),
			pageOffset: event.pageOffset,
			handles: data.handles,
			handleNumber: data.handleNumber,
			buttonsProperty: event.buttons,
			positions: [
				scope_Locations[0],
				scope_Locations[scope_Handles.length - 1]
			]
		}), endEvent = attach(actions.end, d, end, {
			handles: data.handles,
			handleNumber: data.handleNumber
		});

		var outEvent = attach("mouseout", d, documentLeave, {
			handles: data.handles,
			handleNumber: data.handleNumber
		});

		d.noUiListeners = moveEvent.concat(endEvent, outEvent);

		// Text selection isn't an issue on touch devices,
		// so adding cursor styles can be skipped.
		if ( event.cursor ) {

			// Prevent the 'I' cursor and extend the range-drag cursor.
			document.body.style.cursor = getComputedStyle(event.target).cursor;

			// Mark the target with a dragging state.
			if ( scope_Handles.length > 1 ) {
				addClass(scope_Target, options.cssClasses.drag);
			}

			var f = function(){
				return false;
			};

			document.body.noUiListener = f;

			// Prevent text selection when dragging the handles.
			document.body.addEventListener('selectstart', f, false);
		}

		if ( data.handleNumber !== undefined ) {
			fireEvent('start', data.handleNumber);
		}
	}

	// Move closest handle to tapped location.
	function tap ( event ) {

		var location = event.calcPoint, total = 0, handleNumber, to;

		// The tap event shouldn't propagate up and cause 'edge' to run.
		event.stopPropagation();

		// Add up the handle offsets.
		scope_Handles.forEach(function(a){
			total += offset(a)[ options.style ];
		});

		// Find the handle closest to the tapped position.
		handleNumber = ( location < total/2 || scope_Handles.length === 1 ) ? 0 : 1;

		// Check if handler is not disablet if yes set number to the next handler
		if (scope_Handles[handleNumber].hasAttribute('disabled')) {
			handleNumber = handleNumber ? 0 : 1;
		}

		location -= offset(scope_Base)[ options.style ];

		// Calculate the new position.
		to = ( location * 100 ) / baseSize();

		if ( !options.events.snap ) {
			// Flag the slider as it is now in a transitional state.
			// Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
			addClassFor( scope_Target, options.cssClasses.tap, options.animationDuration );
		}

		// Support 'disabled' handles
		if ( scope_Handles[handleNumber].hasAttribute('disabled') ) {
			return false;
		}

		// Find the closest handle and calculate the tapped point.
		// The set handle to the new position.
		setHandle( scope_Handles[handleNumber], to );

		fireEvent('slide', handleNumber, true);
		fireEvent('set', handleNumber, true);
		fireEvent('change', handleNumber, true);

		if ( options.events.snap ) {
			start(event, { handles: [scope_Handles[handleNumber]] });
		}
	}

	// Fires a 'hover' event for a hovered mouse/pen position.
	function hover ( event ) {

		var location = event.calcPoint - offset(scope_Base)[ options.style ],
			to = scope_Spectrum.getStep(( location * 100 ) / baseSize()),
			value = scope_Spectrum.fromStepping( to );

		Object.keys(scope_Events).forEach(function( targetEvent ) {
			if ( 'hover' === targetEvent.split('.')[0] ) {
				scope_Events[targetEvent].forEach(function( callback ) {
					callback.call( scope_Self, value );
				});
			}
		});
	}

	// Attach events to several slider parts.
	function events ( behaviour ) {

		// Attach the standard drag event to the handles.
		if ( !behaviour.fixed ) {

			scope_Handles.forEach(function( handle, index ){

				// These events are only bound to the visual handle
				// element, not the 'real' origin element.
				attach ( actions.start, handle.children[0], start, {
					handles: [ handle ],
					handleNumber: index
				});
			});
		}

		// Attach the tap event to the slider base.
		if ( behaviour.tap ) {

			attach ( actions.start, scope_Base, tap, {
				handles: scope_Handles
			});
		}

		// Fire hover events
		if ( behaviour.hover ) {
			attach ( actions.move, scope_Base, hover, { hover: true } );
		}

		// Make the range draggable.
		if ( behaviour.drag ){

			var drag = [scope_Base.querySelector( '.' + options.cssClasses.connect )];
			addClass(drag[0], options.cssClasses.draggable);

			// When the range is fixed, the entire range can
			// be dragged by the handles. The handle in the first
			// origin will propagate the start event upward,
			// but it needs to be bound manually on the other.
			if ( behaviour.fixed ) {
				drag.push(scope_Handles[(drag[0] === scope_Handles[0] ? 1 : 0)].children[0]);
			}

			drag.forEach(function( element ) {
				attach ( actions.start, element, start, {
					handles: scope_Handles
				});
			});
		}
	}


	// Test suggested values and apply margin, step.
	function setHandle ( handle, to, noLimitOption ) {

		var trigger = handle !== scope_Handles[0] ? 1 : 0,
			lowerMargin = scope_Locations[0] + options.margin,
			upperMargin = scope_Locations[1] - options.margin,
			lowerLimit = scope_Locations[0] + options.limit,
			upperLimit = scope_Locations[1] - options.limit;

		// For sliders with multiple handles,
		// limit movement to the other handle.
		// Apply the margin option by adding it to the handle positions.
		if ( scope_Handles.length > 1 ) {
			to = trigger ? Math.max( to, lowerMargin ) : Math.min( to, upperMargin );
		}

		// The limit option has the opposite effect, limiting handles to a
		// maximum distance from another. Limit must be > 0, as otherwise
		// handles would be unmoveable. 'noLimitOption' is set to 'false'
		// for the .val() method, except for pass 4/4.
		if ( noLimitOption !== false && options.limit && scope_Handles.length > 1 ) {
			to = trigger ? Math.min ( to, lowerLimit ) : Math.max( to, upperLimit );
		}

		// Handle the step option.
		to = scope_Spectrum.getStep( to );

		// Limit percentage to the 0 - 100 range
		to = limit(to);

		// Return false if handle can't move
		if ( to === scope_Locations[trigger] ) {
			return false;
		}

		// Set the handle to the new position.
		// Use requestAnimationFrame for efficient painting.
		// No significant effect in Chrome, Edge sees dramatic
		// performace improvements.
		if ( window.requestAnimationFrame ) {
			window.requestAnimationFrame(function(){
				handle.style[options.style] = to + '%';
			});
		} else {
			handle.style[options.style] = to + '%';
		}

		// Force proper handle stacking
		if ( !handle.previousSibling ) {
			removeClass(handle, options.cssClasses.stacking);
			if ( to > 50 ) {
				addClass(handle, options.cssClasses.stacking);
			}
		}

		// Update locations.
		scope_Locations[trigger] = to;

		// Convert the value to the slider stepping/range.
		scope_Values[trigger] = scope_Spectrum.fromStepping( to );

		fireEvent('update', trigger);

		return true;
	}

	// Loop values from value method and apply them.
	function setValues ( count, values ) {

		var i, trigger, to;

		// With the limit option, we'll need another limiting pass.
		if ( options.limit ) {
			count += 1;
		}

		// If there are multiple handles to be set run the setting
		// mechanism twice for the first handle, to make sure it
		// can be bounced of the second one properly.
		for ( i = 0; i < count; i += 1 ) {

			trigger = i%2;

			// Get the current argument from the array.
			to = values[trigger];

			// Setting with null indicates an 'ignore'.
			// Inputting 'false' is invalid.
			if ( to !== null && to !== false ) {

				// If a formatted number was passed, attemt to decode it.
				if ( typeof to === 'number' ) {
					to = String(to);
				}

				to = options.format.from( to );

				// Request an update for all links if the value was invalid.
				// Do so too if setting the handle fails.
				if ( to === false || isNaN(to) || setHandle( scope_Handles[trigger], scope_Spectrum.toStepping( to ), i === (3 - options.dir) ) === false ) {
					fireEvent('update', trigger);
				}
			}
		}
	}

	// Set the slider value.
	function valueSet ( input, fireSetEvent ) {

		var count, values = asArray( input ), i;

		// Event fires by default
		fireSetEvent = (fireSetEvent === undefined ? true : !!fireSetEvent);

		// The RTL settings is implemented by reversing the front-end,
		// internal mechanisms are the same.
		if ( options.dir && options.handles > 1 ) {
			values.reverse();
		}

		// Animation is optional.
		// Make sure the initial values where set before using animated placement.
		if ( options.animate && scope_Locations[0] !== -1 ) {
			addClassFor( scope_Target, options.cssClasses.tap, options.animationDuration );
		}

		// Determine how often to set the handles.
		count = scope_Handles.length > 1 ? 3 : 1;

		if ( values.length === 1 ) {
			count = 1;
		}

		setValues ( count, values );

		// Fire the 'set' event for both handles.
		for ( i = 0; i < scope_Handles.length; i++ ) {

			// Fire the event only for handles that received a new value, as per #579
			if ( values[i] !== null && fireSetEvent ) {
				fireEvent('set', i);
			}
		}
	}

	// Get the slider value.
	function valueGet ( ) {

		var i, retour = [];

		// Get the value from all handles.
		for ( i = 0; i < options.handles; i += 1 ){
			retour[i] = options.format.to( scope_Values[i] );
		}

		return inSliderOrder( retour );
	}

	// Removes classes from the root and empties it.
	function destroy ( ) {

		for ( var key in options.cssClasses ) {
			if ( !options.cssClasses.hasOwnProperty(key) ) { continue; }
			removeClass(scope_Target, options.cssClasses[key]);
		}

		while (scope_Target.firstChild) {
			scope_Target.removeChild(scope_Target.firstChild);
		}

		delete scope_Target.noUiSlider;
	}

	// Get the current step size for the slider.
	function getCurrentStep ( ) {

		// Check all locations, map them to their stepping point.
		// Get the step point, then find it in the input list.
		var retour = scope_Locations.map(function( location, index ){

			var step = scope_Spectrum.getApplicableStep( location ),

				// As per #391, the comparison for the decrement step can have some rounding issues.
				// Round the value to the precision used in the step.
				stepDecimals = countDecimals(String(step[2])),

				// Get the current numeric value
				value = scope_Values[index],

				// To move the slider 'one step up', the current step value needs to be added.
				// Use null if we are at the maximum slider value.
				increment = location === 100 ? null : step[2],

				// Going 'one step down' might put the slider in a different sub-range, so we
				// need to switch between the current or the previous step.
				prev = Number((value - step[2]).toFixed(stepDecimals)),

				// If the value fits the step, return the current step value. Otherwise, use the
				// previous step. Return null if the slider is at its minimum value.
				decrement = location === 0 ? null : (prev >= step[1]) ? step[2] : (step[0] || false);

			return [decrement, increment];
		});

		// Return values in the proper order.
		return inSliderOrder( retour );
	}

	// Attach an event to this slider, possibly including a namespace
	function bindEvent ( namespacedEvent, callback ) {
		scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
		scope_Events[namespacedEvent].push(callback);

		// If the event bound is 'update,' fire it immediately for all handles.
		if ( namespacedEvent.split('.')[0] === 'update' ) {
			scope_Handles.forEach(function(a, index){
				fireEvent('update', index);
			});
		}
	}

	// Undo attachment of event
	function removeEvent ( namespacedEvent ) {

		var event = namespacedEvent && namespacedEvent.split('.')[0],
			namespace = event && namespacedEvent.substring(event.length);

		Object.keys(scope_Events).forEach(function( bind ){

			var tEvent = bind.split('.')[0],
				tNamespace = bind.substring(tEvent.length);

			if ( (!event || event === tEvent) && (!namespace || namespace === tNamespace) ) {
				delete scope_Events[bind];
			}
		});
	}

	// Updateable: margin, limit, step, range, animate, snap
	function updateOptions ( optionsToUpdate, fireSetEvent ) {

		// Spectrum is created using the range, snap, direction and step options.
		// 'snap' and 'step' can be updated, 'direction' cannot, due to event binding.
		// If 'snap' and 'step' are not passed, they should remain unchanged.
		var v = valueGet(), newOptions = testOptions({
			start: [0, 0],
			margin: optionsToUpdate.margin,
			limit: optionsToUpdate.limit,
			step: optionsToUpdate.step === undefined ? options.singleStep : optionsToUpdate.step,
			range: optionsToUpdate.range,
			animate: optionsToUpdate.animate,
			snap: optionsToUpdate.snap === undefined ? options.snap : optionsToUpdate.snap
		});

		['margin', 'limit', 'range', 'animate'].forEach(function(name){

			// Only change options that we're actually passed to update.
			if ( optionsToUpdate[name] !== undefined ) {
				options[name] = optionsToUpdate[name];
			}
		});

		// Save current spectrum direction as testOptions in testRange call
		// doesn't rely on current direction
		newOptions.spectrum.direction = scope_Spectrum.direction;
		scope_Spectrum = newOptions.spectrum;

		// Invalidate the current positioning so valueSet forces an update.
		scope_Locations = [-1, -1];
		valueSet(optionsToUpdate.start || v, fireSetEvent);
	}


	// Throw an error if the slider was already initialized.
	if ( scope_Target.noUiSlider ) {
		throw new Error('Slider was already initialized.');
	}

	// Create the base element, initialise HTML and set classes.
	// Add handles and links.
	scope_Base = addSlider( options.dir, options.ort, scope_Target );
	scope_Handles = addHandles( options.handles, options.dir, scope_Base );

	// Set the connect classes.
	addConnection ( options.connect, scope_Target, scope_Handles );

	if ( options.pips ) {
		pips(options.pips);
	}

	if ( options.tooltips ) {
		tooltips();
	}

	scope_Self = {
		destroy: destroy,
		steps: getCurrentStep,
		on: bindEvent,
		off: removeEvent,
		get: valueGet,
		set: valueSet,
		updateOptions: updateOptions,
		options: originalOptions, // Issue #600
		target: scope_Target, // Issue #597
		pips: pips // Issue #594
	};

	// Attach user events.
	events( options.events );

	return scope_Self;

}


	// Run the standard initializer
	function initialize ( target, originalOptions ) {

		if ( !target.nodeName ) {
			throw new Error('noUiSlider.create requires a single element.');
		}

		// Test the options and create the slider environment;
		var options = testOptions( originalOptions, target ),
			slider = closure( target, options, originalOptions );

		// Use the public value method to set the start values.
		slider.set(options.start);

		target.noUiSlider = slider;
		return slider;
	}

	// Use an object instead of a function for future expansibility;
	return {
		create: initialize
	};

}));
/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/Pikaday/Pikaday
 */

(function (root, factory)
{
    'use strict';

    var moment;
    if (typeof exports === 'object') {
        // CommonJS module
        // Load moment.js as an optional dependency
        try { moment = require('moment'); } catch (e) {}
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('pikaday',['require'],function (req)
        {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try { moment = req(id); } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
}(this, function (moment)
{
    'use strict';

    /**
     * feature detection and helper functions
     */
    var hasMoment = typeof moment === 'function',

    hasEventListeners = !!window.addEventListener,

    document = window.document,

    sto = window.setTimeout,

    addEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },

    removeEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },

    trim = function(str)
    {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
    },

    hasClass = function(el, cn)
    {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },

    addClass = function(el, cn)
    {
        if (!hasClass(el, cn)) {
            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
        }
    },

    removeClass = function(el, cn)
    {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },

    isArray = function(obj)
    {
        return (/Array/).test(Object.prototype.toString.call(obj));
    },

    isDate = function(obj)
    {
        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
    },

    isWeekend = function(date)
    {
        var day = date.getDay();
        return day === 0 || day === 6;
    },

    isLeapYear = function(year)
    {
        // solution lifted from date.js (MIT license): https://github.com/datejs/Datejs
        return ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
    },

    getDaysInMonth = function(year, month)
    {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },

    setToStartOfDay = function(date)
    {
        if (isDate(date)) date.setHours(0,0,0,0);
    },

    compareDates = function(a,b)
    {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
    },

    extend = function(to, from, overwrite)
    {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                }
                else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },

    fireEvent = function(el, eventName, data)
    {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },

    adjustCalendar = function(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month)/12);
            calendar.month -= 12;
        }
        return calendar;
    },

    /**
     * defaults and localisation
     */
    defaults = {

        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // data-attribute on the input field with an aria assistance text (only applied when `bound` is set)
        ariaLabel: 'Use the arrow keys to pick a date',

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        format: 'YYYY-MM-DD',

        // the toString function which gets passed a current date object and format
        // and returns a string
        toString: null,

        // used to create date object from current input string
        parse: null,

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // minimum number of days in the week that gets week number one
        // default ISO 8601, week 01 is the week with the first Thursday (4)
        firstWeekOfYearMinDays: 4,

        // the default flag for moment's strict date parsing
        formatStrict: false,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // Week picker mode
        pickWholeWeek: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,

        // Allows user to select days that fall in the next or previous month
        enableSelectionDaysInNextAndPreviousMonths: false,

        // how many months are visible
        numberOfMonths: 1,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // Blur field when date is selected
        blurFieldOnSelect : true,

        // internationalization
        i18n: {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        },

        // Theme Classname
        theme: null,

        // events array
        events: [],

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null,

        // Enable keyboard input
        keyboardInput: true
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function(opts, day, abbr)
    {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },

    renderDay = function(opts)
    {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
            if (opts.showDaysInNextAndPreviousMonths) {
                arr.push('is-outside-current-month');

                if(!opts.enableSelectionDaysInNextAndPreviousMonths) {
                    arr.push('is-selection-disabled');
                }

            } else {
                return '<td class="is-empty"></td>';
            }
        }
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
            ariaSelected = 'true';
        }
        if (opts.hasEvent) {
            arr.push('has-event');
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
                 '<button class="pika-button pika-day" type="button" ' +
                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
                        opts.day +
                 '</button>' +
               '</td>';
    },

    isoWeek = function(date, firstWeekOfYearMinDays) {
        // Ensure we're at the start of the day.
        date.setHours(0, 0, 0, 0);

        // Thursday in current week decides the year because January 4th
        // is always in the first week according to ISO8601.
        var yearDay        = date.getDate(),
            weekDay        = date.getDay(),
            dayInFirstWeek = firstWeekOfYearMinDays,
            dayShift       = dayInFirstWeek - 1, // counting starts at 0
            daysPerWeek    = 7,
            prevWeekDay    = function(day) { return (day + daysPerWeek - 1) % daysPerWeek; };

        // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
        date.setDate(yearDay + dayShift - prevWeekDay(weekDay));

        var jan4th      = new Date(date.getFullYear(), 0, dayInFirstWeek),
            msPerDay    = 24 * 60 * 60 * 1000,
            daysBetween = (date.getTime() - jan4th.getTime()) / msPerDay,
            weekNum     = 1 + Math.round((daysBetween - dayShift + prevWeekDay(jan4th.getDay())) / daysPerWeek);

        return weekNum;
    },

    renderWeek = function (d, m, y, firstWeekOfYearMinDays) {
        var date = new Date(y, m, d),
            week = hasMoment ? moment(date).isoWeek() : isoWeek(date, firstWeekOfYearMinDays);

        return '<td class="pika-week">' + week + '</td>';
    },

    renderRow = function(days, isRTL, pickWholeWeek, isRowSelected)
    {
        return '<tr class="pika-row' + (pickWholeWeek ? ' pick-whole-week' : '') + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },

    renderBody = function(rows)
    {
        return '<tbody>' + rows.join('') + '</tbody>';
    },

    renderHead = function(opts)
    {
        var i, arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
    },

    renderTitle = function(instance, c, year, month, refYear, randId)
    {
        var i, j, arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
                (i === month ? ' selected="selected"': '') +
                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? ' disabled="disabled"' : '') + '>' +
                opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"': '') + '>' + (i) + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === (instance._o.numberOfMonths - 1) ) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },

    renderTable = function(opts, data, randId)
    {
        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
    },


    /**
     * Pikaday constructor
     */
    Pikaday = function(options)
    {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function(e)
        {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                    if (opts.bound) {
                        sto(function() {
                            self.hide();
                            if (opts.blurFieldOnSelect && opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                }
                else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                }
                else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            }
            else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
        };

        self._onKeyChange = function(e)
        {
            e = e || window.event;

            if (self.isVisible()) {

                switch(e.keyCode){
                    case 13:
                    case 27:
                        if (opts.field) {
                            opts.field.blur();
                        }
                        break;
                    case 37:
                        self.adjustDate('subtract', 1);
                        break;
                    case 38:
                        self.adjustDate('subtract', 7);
                        break;
                    case 39:
                        self.adjustDate('add', 1);
                        break;
                    case 40:
                        self.adjustDate('add', 7);
                        break;
                    case 8:
                    case 46:
                        self.setDate(null);
                        break;
                }
            }
        };

        self._parseFieldValue = function()
        {
            if (opts.parse) {
                return opts.parse(opts.field.value, opts.format);
            } else if (hasMoment) {
                var date = moment(opts.field.value, opts.format, opts.formatStrict);
                return (date && date.isValid()) ? date.toDate() : null;
            } else {
                return new Date(Date.parse(opts.field.value));
            }
        };

        self._onInputChange = function(e)
        {
            var date;

            if (e.firedBy === self) {
                return;
            }
            date = self._parseFieldValue();
            if (isDate(date)) {
              self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };

        self._onInputFocus = function()
        {
            self.show();
        };

        self._onInputClick = function()
        {
            self.show();
        };

        self._onInputBlur = function()
        {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));

            if (!self._c) {
                self._b = sto(function() {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);

        if (opts.keyboardInput) {
            addEvent(document, 'keydown', self._onKeyChange);
        }

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                opts.defaultDate = self._parseFieldValue();
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };


    /**
     * public Pikaday API
     */
    Pikaday.prototype = {


        /**
         * configure functionality
         */
        config: function(options)
        {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;

            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
                this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function(format)
        {
            format = format || this._o.format;
            if (!isDate(this._d)) {
                return '';
            }
            if (this._o.toString) {
              return this._o.toString(this._d, format);
            }
            if (hasMoment) {
              return moment(this._d).format(format);
            }
            return this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function()
        {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function(date, preventOnSelect)
        {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection
         */
        getDate: function()
        {
            return isDate(this._d) ? new Date(this._d.getTime()) : null;
        },

        /**
         * set the current selection
         */
        setDate: function(date, preventOnSelect)
        {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());
            setToStartOfDay(this._d);
            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * clear and reset the date
         */
        clear: function()
        {
            this.setDate(null);
        },

        /**
         * change view to a specific date
         */
        gotoDate: function(date)
        {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustDate: function(sign, days) {

            var day = this.getDate() || new Date();
            var difference = parseInt(days)*24*60*60*1000;

            var newDay;

            if (sign === 'add') {
                newDay = new Date(day.valueOf() + difference);
            } else if (sign === 'subtract') {
                newDay = new Date(day.valueOf() - difference);
            }

            this.setDate(newDay);
        },

        adjustCalendars: function() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function()
        {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function(month)
        {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function()
        {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function()
        {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function(year)
        {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.minDate = value;
                this._o.minYear  = value.getFullYear();
                this._o.minMonth = value.getMonth();
            } else {
                this._o.minDate = defaults.minDate;
                this._o.minYear  = defaults.minYear;
                this._o.minMonth = defaults.minMonth;
                this._o.startRange = defaults.startRange;
            }

            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.maxDate = value;
                this._o.maxYear = value.getFullYear();
                this._o.maxMonth = value.getMonth();
            } else {
                this._o.maxDate = defaults.maxDate;
                this._o.maxYear = defaults.maxYear;
                this._o.maxMonth = defaults.maxMonth;
                this._o.endRange = defaults.endRange;
            }

            this.draw();
        },

        setStartRange: function(value)
        {
            this._o.startRange = value;
        },

        setEndRange: function(value)
        {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function(force)
        {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '',
                randId;

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            for (var c = 0; c < opts.numberOfMonths; c++) {
                randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if(opts.field.type !== 'hidden') {
                    sto(function() {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                this._o.onDraw(this);
            }

            if (opts.bound) {
                // let the screen reader user know to use arrow keys
                opts.field.setAttribute('aria-label', opts.ariaLabel);
            }
        },

        adjustPosition: function()
        {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect, leftAligned, bottomAligned;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
            leftAligned = true;
            bottomAligned = true;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top  = pEl.offsetTop + pEl.offsetHeight;
                while((pEl = pEl.offsetParent)) {
                    left += pEl.offsetLeft;
                    top  += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if ((this._o.reposition && left + width > viewportWidth) ||
                (
                    this._o.position.indexOf('right') > -1 &&
                    left - width + field.offsetWidth > 0
                )
            ) {
                left = left - width + field.offsetWidth;
                leftAligned = false;
            }
            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
                (
                    this._o.position.indexOf('top') > -1 &&
                    top - height - field.offsetHeight > 0
                )
            ) {
                top = top - height - field.offsetHeight;
                bottomAligned = false;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';

            addClass(this.el, leftAligned ? 'left-aligned' : 'right-aligned');
            addClass(this.el, bottomAligned ? 'bottom-aligned' : 'top-aligned');
            removeClass(this.el, !leftAligned ? 'left-aligned' : 'right-aligned');
            removeClass(this.el, !bottomAligned ? 'bottom-aligned' : 'top-aligned');
        },

        /**
         * render HTML for a particular month
         */
        render: function(year, month, randId)
        {
            var opts   = this._o,
                now    = new Date(),
                days   = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data   = [],
                row    = [];
            setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var previousMonth = month === 0 ? 11 : month - 1,
                nextMonth = month === 11 ? 0 : month + 1,
                yearOfPreviousMonth = month === 0 ? year - 1 : year,
                yearOfNextMonth = month === 11 ? year + 1 : year,
                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
            var cells = days + before,
                after = cells;
            while(after > 7) {
                after -= 7;
            }
            cells += 7 - after;
            var isWeekSelected = false;
            for (var i = 0, r = 0; i < cells; i++)
            {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
                    isEmpty = i < before || i >= (days + before),
                    dayNumber = 1 + (i - before),
                    monthNumber = month,
                    yearNumber = year,
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = (opts.minDate && day < opts.minDate) ||
                                 (opts.maxDate && day > opts.maxDate) ||
                                 (opts.disableWeekends && isWeekend(day)) ||
                                 (opts.disableDayFn && opts.disableDayFn(day));

                if (isEmpty) {
                    if (i < before) {
                        dayNumber = daysInPreviousMonth + dayNumber;
                        monthNumber = previousMonth;
                        yearNumber = yearOfPreviousMonth;
                    } else {
                        dayNumber = dayNumber - days;
                        monthNumber = nextMonth;
                        yearNumber = yearOfNextMonth;
                    }
                }

                var dayConfig = {
                        day: dayNumber,
                        month: monthNumber,
                        year: yearNumber,
                        hasEvent: hasEvent,
                        isSelected: isSelected,
                        isToday: isToday,
                        isDisabled: isDisabled,
                        isEmpty: isEmpty,
                        isStartRange: isStartRange,
                        isEndRange: isEndRange,
                        isInRange: isInRange,
                        showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths,
                        enableSelectionDaysInNextAndPreviousMonths: opts.enableSelectionDaysInNextAndPreviousMonths
                    };

                if (opts.pickWholeWeek && isSelected) {
                    isWeekSelected = true;
                }

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year, opts.firstWeekOfYearMinDays));
                    }
                    data.push(renderRow(row, opts.isRTL, opts.pickWholeWeek, isWeekSelected));
                    row = [];
                    r = 0;
                    isWeekSelected = false;
                }
            }
            return renderTable(opts, data, randId);
        },

        isVisible: function()
        {
            return this._v;
        },

        show: function()
        {
            if (!this.isVisible()) {
                this._v = true;
                this.draw();
                removeClass(this.el, 'is-hidden');
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function()
        {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }

                if (!this._o.container) {
                    this.el.style.position = 'static'; // reset
                    this.el.style.left = 'auto';
                    this.el.style.top = 'auto';
                }
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function()
        {
            var opts = this._o;

            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            if (opts.keyboardInput) {
                removeEvent(document, 'keydown', this._onKeyChange);
            }
            if (opts.field) {
                removeEvent(opts.field, 'change', this._onInputChange);
                if (opts.bound) {
                    removeEvent(opts.trigger, 'click', this._onInputClick);
                    removeEvent(opts.trigger, 'focus', this._onInputFocus);
                    removeEvent(opts.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;
}));

/*! iScroll v5.2.0 ~ (c) 2008-2016 Matteo Spinelli ~ http://cubiq.org/license */
(function (window, document, Math) {
var rAF = window.requestAnimationFrame	||
	window.webkitRequestAnimationFrame	||
	window.mozRequestAnimationFrame		||
	window.oRequestAnimationFrame		||
	window.msRequestAnimationFrame		||
	function (callback) { window.setTimeout(callback, 1000 / 60); };

var utils = (function () {
	var me = {};

	var _elementStyle = document.createElement('div').style;
	var _vendor = (function () {
		var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
			transform,
			i = 0,
			l = vendors.length;

		for ( ; i < l; i++ ) {
			transform = vendors[i] + 'ransform';
			if ( transform in _elementStyle ) return vendors[i].substr(0, vendors[i].length-1);
		}

		return false;
	})();

	function _prefixStyle (style) {
		if ( _vendor === false ) return false;
		if ( _vendor === '' ) return style;
		return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
	}

	me.getTime = Date.now || function getTime () { return new Date().getTime(); };

	me.extend = function (target, obj) {
		for ( var i in obj ) {
			target[i] = obj[i];
		}
	};

	me.addEvent = function (el, type, fn, capture) {
		el.addEventListener(type, fn, !!capture);
	};

	me.removeEvent = function (el, type, fn, capture) {
		el.removeEventListener(type, fn, !!capture);
	};

	me.prefixPointerEvent = function (pointerEvent) {
		return window.MSPointerEvent ?
			'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8):
			pointerEvent;
	};

	me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
		var distance = current - start,
			speed = Math.abs(distance) / time,
			destination,
			duration;

		deceleration = deceleration === undefined ? 0.0006 : deceleration;

		destination = current + ( speed * speed ) / ( 2 * deceleration ) * ( distance < 0 ? -1 : 1 );
		duration = speed / deceleration;

		if ( destination < lowerMargin ) {
			destination = wrapperSize ? lowerMargin - ( wrapperSize / 2.5 * ( speed / 8 ) ) : lowerMargin;
			distance = Math.abs(destination - current);
			duration = distance / speed;
		} else if ( destination > 0 ) {
			destination = wrapperSize ? wrapperSize / 2.5 * ( speed / 8 ) : 0;
			distance = Math.abs(current) + destination;
			duration = distance / speed;
		}

		return {
			destination: Math.round(destination),
			duration: duration
		};
	};

	var _transform = _prefixStyle('transform');

	me.extend(me, {
		hasTransform: _transform !== false,
		hasPerspective: _prefixStyle('perspective') in _elementStyle,
		hasTouch: 'ontouchstart' in window,
		hasPointer: !!(window.PointerEvent || window.MSPointerEvent), // IE10 is prefixed
		hasTransition: _prefixStyle('transition') in _elementStyle
	});

	/*
	This should find all Android browsers lower than build 535.19 (both stock browser and webview)
	- galaxy S2 is ok
    - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
    - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S3 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S4 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S5 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
   - galaxy S6 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
  */
	me.isBadAndroid = (function() {
		var appVersion = window.navigator.appVersion;
		// Android browser is not a chrome browser.
		if (/Android/.test(appVersion) && !(/Chrome\/\d/.test(appVersion))) {
			var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
			if(safariVersion && typeof safariVersion === "object" && safariVersion.length >= 2) {
				return parseFloat(safariVersion[1]) < 535.19;
			} else {
				return true;
			}
		} else {
			return false;
		}
	})();

	me.extend(me.style = {}, {
		transform: _transform,
		transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
		transitionDuration: _prefixStyle('transitionDuration'),
		transitionDelay: _prefixStyle('transitionDelay'),
		transformOrigin: _prefixStyle('transformOrigin')
	});

	me.hasClass = function (e, c) {
		var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
		return re.test(e.className);
	};

	me.addClass = function (e, c) {
		if ( me.hasClass(e, c) ) {
			return;
		}

		var newclass = e.className.split(' ');
		newclass.push(c);
		e.className = newclass.join(' ');
	};

	me.removeClass = function (e, c) {
		if ( !me.hasClass(e, c) ) {
			return;
		}

		var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
		e.className = e.className.replace(re, ' ');
	};

	me.offset = function (el) {
		var left = -el.offsetLeft,
			top = -el.offsetTop;

		// jshint -W084
		while (el = el.offsetParent) {
			left -= el.offsetLeft;
			top -= el.offsetTop;
		}
		// jshint +W084

		return {
			left: left,
			top: top
		};
	};

	me.preventDefaultException = function (el, exceptions) {
		for ( var i in exceptions ) {
			if ( exceptions[i].test(el[i]) ) {
				return true;
			}
		}

		return false;
	};

	me.extend(me.eventType = {}, {
		touchstart: 1,
		touchmove: 1,
		touchend: 1,

		mousedown: 2,
		mousemove: 2,
		mouseup: 2,

		pointerdown: 3,
		pointermove: 3,
		pointerup: 3,

		MSPointerDown: 3,
		MSPointerMove: 3,
		MSPointerUp: 3
	});

	me.extend(me.ease = {}, {
		quadratic: {
			style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
			fn: function (k) {
				return k * ( 2 - k );
			}
		},
		circular: {
			style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',	// Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
			fn: function (k) {
				return Math.sqrt( 1 - ( --k * k ) );
			}
		},
		back: {
			style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
			fn: function (k) {
				var b = 4;
				return ( k = k - 1 ) * k * ( ( b + 1 ) * k + b ) + 1;
			}
		},
		bounce: {
			style: '',
			fn: function (k) {
				if ( ( k /= 1 ) < ( 1 / 2.75 ) ) {
					return 7.5625 * k * k;
				} else if ( k < ( 2 / 2.75 ) ) {
					return 7.5625 * ( k -= ( 1.5 / 2.75 ) ) * k + 0.75;
				} else if ( k < ( 2.5 / 2.75 ) ) {
					return 7.5625 * ( k -= ( 2.25 / 2.75 ) ) * k + 0.9375;
				} else {
					return 7.5625 * ( k -= ( 2.625 / 2.75 ) ) * k + 0.984375;
				}
			}
		},
		elastic: {
			style: '',
			fn: function (k) {
				var f = 0.22,
					e = 0.4;

				if ( k === 0 ) { return 0; }
				if ( k == 1 ) { return 1; }

				return ( e * Math.pow( 2, - 10 * k ) * Math.sin( ( k - f / 4 ) * ( 2 * Math.PI ) / f ) + 1 );
			}
		}
	});

	me.tap = function (e, eventName) {
		var ev = document.createEvent('Event');
		ev.initEvent(eventName, true, true);
		ev.pageX = e.pageX;
		ev.pageY = e.pageY;
		e.target.dispatchEvent(ev);
	};

	me.click = function (e) {
		var target = e.target,
			ev;

		if ( !(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName) ) {
			ev = document.createEvent('MouseEvents');
			ev.initMouseEvent('click', true, true, e.view, 1,
				target.screenX, target.screenY, target.clientX, target.clientY,
				e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
				0, null);

			ev._constructed = true;
			target.dispatchEvent(ev);
		}
	};

	return me;
})();
function IScroll (el, options) {
	this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
	this.scroller = this.wrapper.children[0];
	this.scrollerStyle = this.scroller.style;		// cache style for better performance

	this.options = {

		resizeScrollbars: true,

		mouseWheelSpeed: 20,

		snapThreshold: 0.334,

// INSERT POINT: OPTIONS
		disablePointer : !utils.hasPointer,
		disableTouch : utils.hasPointer || !utils.hasTouch,
		disableMouse : utils.hasPointer || utils.hasTouch,
		startX: 0,
		startY: 0,
		scrollY: true,
		directionLockThreshold: 5,
		momentum: true,

		bounce: true,
		bounceTime: 600,
		bounceEasing: '',

		preventDefault: true,
		preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },

		HWCompositing: true,
		useTransition: true,
		useTransform: true,
		bindToWrapper: typeof window.onmousedown === "undefined"
	};

	for ( var i in options ) {
		this.options[i] = options[i];
	}

	// Normalize options
	this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';

	this.options.useTransition = utils.hasTransition && this.options.useTransition;
	this.options.useTransform = utils.hasTransform && this.options.useTransform;

	this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
	this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

	// If you want eventPassthrough I have to lock one of the axes
	this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
	this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;

	// With eventPassthrough we also need lockDirection mechanism
	this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
	this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

	this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;

	this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;

	if ( this.options.tap === true ) {
		this.options.tap = 'tap';
	}

	if ( this.options.shrinkScrollbars == 'scale' ) {
		this.options.useTransition = false;
	}

	this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;

// INSERT POINT: NORMALIZATION

	// Some defaults
	this.x = 0;
	this.y = 0;
	this.directionX = 0;
	this.directionY = 0;
	this._events = {};

// INSERT POINT: DEFAULTS

	this._init();
	this.refresh();

	this.scrollTo(this.options.startX, this.options.startY);
	this.enable();
}

IScroll.prototype = {
	version: '5.2.0',

	_init: function () {
		this._initEvents();

		if ( this.options.scrollbars || this.options.indicators ) {
			this._initIndicators();
		}

		if ( this.options.mouseWheel ) {
			this._initWheel();
		}

		if ( this.options.snap ) {
			this._initSnap();
		}

		if ( this.options.keyBindings ) {
			this._initKeys();
		}

// INSERT POINT: _init

	},

	destroy: function () {
		this._initEvents(true);
		clearTimeout(this.resizeTimeout);
 		this.resizeTimeout = null;
		this._execEvent('destroy');
	},

	_transitionEnd: function (e) {
		if ( e.target != this.scroller || !this.isInTransition ) {
			return;
		}

		this._transitionTime();
		if ( !this.resetPosition(this.options.bounceTime) ) {
			this.isInTransition = false;
			this._execEvent('scrollEnd');
		}
	},

	_start: function (e) {
		// React to left mouse button only
		if ( utils.eventType[e.type] != 1 ) {
		  // for button property
		  // http://unixpapa.com/js/mouse.html
		  var button;
	    if (!e.which) {
	      /* IE case */
	      button = (e.button < 2) ? 0 :
	               ((e.button == 4) ? 1 : 2);
	    } else {
	      /* All others */
	      button = e.button;
	    }
			if ( button !== 0 ) {
				return;
			}
		}

		if ( !this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated) ) {
			return;
		}

		if ( this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
			e.preventDefault();
		}

		var point = e.touches ? e.touches[0] : e,
			pos;

		this.initiated	= utils.eventType[e.type];
		this.moved		= false;
		this.distX		= 0;
		this.distY		= 0;
		this.directionX = 0;
		this.directionY = 0;
		this.directionLocked = 0;

		this.startTime = utils.getTime();

		if ( this.options.useTransition && this.isInTransition ) {
			this._transitionTime();
			this.isInTransition = false;
			pos = this.getComputedPosition();
			this._translate(Math.round(pos.x), Math.round(pos.y));
			this._execEvent('scrollEnd');
		} else if ( !this.options.useTransition && this.isAnimating ) {
			this.isAnimating = false;
			this._execEvent('scrollEnd');
		}

		this.startX    = this.x;
		this.startY    = this.y;
		this.absStartX = this.x;
		this.absStartY = this.y;
		this.pointX    = point.pageX;
		this.pointY    = point.pageY;

		this._execEvent('beforeScrollStart');
	},

	_move: function (e) {
		if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
			return;
		}

		if ( this.options.preventDefault ) {	// increases performance on Android? TODO: check!
			e.preventDefault();
		}

		var point		= e.touches ? e.touches[0] : e,
			deltaX		= point.pageX - this.pointX,
			deltaY		= point.pageY - this.pointY,
			timestamp	= utils.getTime(),
			newX, newY,
			absDistX, absDistY;

		this.pointX		= point.pageX;
		this.pointY		= point.pageY;

		this.distX		+= deltaX;
		this.distY		+= deltaY;
		absDistX		= Math.abs(this.distX);
		absDistY		= Math.abs(this.distY);

		// We need to move at least 10 pixels for the scrolling to initiate
		if ( timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10) ) {
			return;
		}

		// If you are scrolling in one direction lock the other
		if ( !this.directionLocked && !this.options.freeScroll ) {
			if ( absDistX > absDistY + this.options.directionLockThreshold ) {
				this.directionLocked = 'h';		// lock horizontally
			} else if ( absDistY >= absDistX + this.options.directionLockThreshold ) {
				this.directionLocked = 'v';		// lock vertically
			} else {
				this.directionLocked = 'n';		// no lock
			}
		}

		if ( this.directionLocked == 'h' ) {
			if ( this.options.eventPassthrough == 'vertical' ) {
				e.preventDefault();
			} else if ( this.options.eventPassthrough == 'horizontal' ) {
				this.initiated = false;
				return;
			}

			deltaY = 0;
		} else if ( this.directionLocked == 'v' ) {
			if ( this.options.eventPassthrough == 'horizontal' ) {
				e.preventDefault();
			} else if ( this.options.eventPassthrough == 'vertical' ) {
				this.initiated = false;
				return;
			}

			deltaX = 0;
		}

		deltaX = this.hasHorizontalScroll ? deltaX : 0;
		deltaY = this.hasVerticalScroll ? deltaY : 0;

		newX = this.x + deltaX;
		newY = this.y + deltaY;

		// Slow down if outside of the boundaries
		if ( newX > 0 || newX < this.maxScrollX ) {
			newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
		}
		if ( newY > 0 || newY < this.maxScrollY ) {
			newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
		}

		this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
		this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

		if ( !this.moved ) {
			this._execEvent('scrollStart');
		}

		this.moved = true;

		this._translate(newX, newY);

/* REPLACE START: _move */

		if ( timestamp - this.startTime > 300 ) {
			this.startTime = timestamp;
			this.startX = this.x;
			this.startY = this.y;
		}

/* REPLACE END: _move */

	},

	_end: function (e) {
		if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
			return;
		}

		if ( this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
			e.preventDefault();
		}

		var point = e.changedTouches ? e.changedTouches[0] : e,
			momentumX,
			momentumY,
			duration = utils.getTime() - this.startTime,
			newX = Math.round(this.x),
			newY = Math.round(this.y),
			distanceX = Math.abs(newX - this.startX),
			distanceY = Math.abs(newY - this.startY),
			time = 0,
			easing = '';

		this.isInTransition = 0;
		this.initiated = 0;
		this.endTime = utils.getTime();

		// reset if we are outside of the boundaries
		if ( this.resetPosition(this.options.bounceTime) ) {
			return;
		}

		this.scrollTo(newX, newY);	// ensures that the last position is rounded

		// we scrolled less than 10 pixels
		if ( !this.moved ) {
			if ( this.options.tap ) {
				utils.tap(e, this.options.tap);
			}

			if ( this.options.click ) {
				utils.click(e);
			}

			this._execEvent('scrollCancel');
			return;
		}

		if ( this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100 ) {
			this._execEvent('flick');
			return;
		}

		// start momentum animation if needed
		if ( this.options.momentum && duration < 300 ) {
			momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
			momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
			newX = momentumX.destination;
			newY = momentumY.destination;
			time = Math.max(momentumX.duration, momentumY.duration);
			this.isInTransition = 1;
		}


		if ( this.options.snap ) {
			var snap = this._nearestSnap(newX, newY);
			this.currentPage = snap;
			time = this.options.snapSpeed || Math.max(
					Math.max(
						Math.min(Math.abs(newX - snap.x), 1000),
						Math.min(Math.abs(newY - snap.y), 1000)
					), 300);
			newX = snap.x;
			newY = snap.y;

			this.directionX = 0;
			this.directionY = 0;
			easing = this.options.bounceEasing;
		}

// INSERT POINT: _end

		if ( newX != this.x || newY != this.y ) {
			// change easing function when scroller goes out of the boundaries
			if ( newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY ) {
				easing = utils.ease.quadratic;
			}

			this.scrollTo(newX, newY, time, easing);
			return;
		}

		this._execEvent('scrollEnd');
	},

	_resize: function () {
		var that = this;

		clearTimeout(this.resizeTimeout);

		this.resizeTimeout = setTimeout(function () {
			that.refresh();
		}, this.options.resizePolling);
	},

	resetPosition: function (time) {
		var x = this.x,
			y = this.y;

		time = time || 0;

		if ( !this.hasHorizontalScroll || this.x > 0 ) {
			x = 0;
		} else if ( this.x < this.maxScrollX ) {
			x = this.maxScrollX;
		}

		if ( !this.hasVerticalScroll || this.y > 0 ) {
			y = 0;
		} else if ( this.y < this.maxScrollY ) {
			y = this.maxScrollY;
		}

		if ( x == this.x && y == this.y ) {
			return false;
		}

		this.scrollTo(x, y, time, this.options.bounceEasing);

		return true;
	},

	disable: function () {
		this.enabled = false;
	},

	enable: function () {
		this.enabled = true;
	},

	refresh: function () {
		var rf = this.wrapper.offsetHeight;		// Force reflow

		this.wrapperWidth	= this.wrapper.clientWidth;
		this.wrapperHeight	= this.wrapper.clientHeight;

/* REPLACE START: refresh */

		this.scrollerWidth	= this.scroller.offsetWidth;
		this.scrollerHeight	= this.scroller.offsetHeight;

		this.maxScrollX		= this.wrapperWidth - this.scrollerWidth;
		this.maxScrollY		= this.wrapperHeight - this.scrollerHeight;

/* REPLACE END: refresh */

		this.hasHorizontalScroll	= this.options.scrollX && this.maxScrollX < 0;
		this.hasVerticalScroll		= this.options.scrollY && this.maxScrollY < 0;

		if ( !this.hasHorizontalScroll ) {
			this.maxScrollX = 0;
			this.scrollerWidth = this.wrapperWidth;
		}

		if ( !this.hasVerticalScroll ) {
			this.maxScrollY = 0;
			this.scrollerHeight = this.wrapperHeight;
		}

		this.endTime = 0;
		this.directionX = 0;
		this.directionY = 0;

		this.wrapperOffset = utils.offset(this.wrapper);

		this._execEvent('refresh');

		this.resetPosition();

// INSERT POINT: _refresh

	},

	on: function (type, fn) {
		if ( !this._events[type] ) {
			this._events[type] = [];
		}

		this._events[type].push(fn);
	},

	off: function (type, fn) {
		if ( !this._events[type] ) {
			return;
		}

		var index = this._events[type].indexOf(fn);

		if ( index > -1 ) {
			this._events[type].splice(index, 1);
		}
	},

	_execEvent: function (type) {
		if ( !this._events[type] ) {
			return;
		}

		var i = 0,
			l = this._events[type].length;

		if ( !l ) {
			return;
		}

		for ( ; i < l; i++ ) {
			this._events[type][i].apply(this, [].slice.call(arguments, 1));
		}
	},

	scrollBy: function (x, y, time, easing) {
		x = this.x + x;
		y = this.y + y;
		time = time || 0;

		this.scrollTo(x, y, time, easing);
	},

	scrollTo: function (x, y, time, easing) {
		easing = easing || utils.ease.circular;

		this.isInTransition = this.options.useTransition && time > 0;
		var transitionType = this.options.useTransition && easing.style;
		if ( !time || transitionType ) {
				if(transitionType) {
					this._transitionTimingFunction(easing.style);
					this._transitionTime(time);
				}
			this._translate(x, y);
		} else {
			this._animate(x, y, time, easing.fn);
		}
	},

	scrollToElement: function (el, time, offsetX, offsetY, easing) {
		el = el.nodeType ? el : this.scroller.querySelector(el);

		if ( !el ) {
			return;
		}

		var pos = utils.offset(el);

		pos.left -= this.wrapperOffset.left;
		pos.top  -= this.wrapperOffset.top;

		// if offsetX/Y are true we center the element to the screen
		if ( offsetX === true ) {
			offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
		}
		if ( offsetY === true ) {
			offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
		}

		pos.left -= offsetX || 0;
		pos.top  -= offsetY || 0;

		pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
		pos.top  = pos.top  > 0 ? 0 : pos.top  < this.maxScrollY ? this.maxScrollY : pos.top;

		time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x-pos.left), Math.abs(this.y-pos.top)) : time;

		this.scrollTo(pos.left, pos.top, time, easing);
	},

	_transitionTime: function (time) {
		time = time || 0;

		var durationProp = utils.style.transitionDuration;
		this.scrollerStyle[durationProp] = time + 'ms';

		if ( !time && utils.isBadAndroid ) {
			this.scrollerStyle[durationProp] = '0.0001ms';
			// remove 0.0001ms
			var self = this;
			rAF(function() {
				if(self.scrollerStyle[durationProp] === '0.0001ms') {
					self.scrollerStyle[durationProp] = '0s';
				}
			});
		}


		if ( this.indicators ) {
			for ( var i = this.indicators.length; i--; ) {
				this.indicators[i].transitionTime(time);
			}
		}


// INSERT POINT: _transitionTime

	},

	_transitionTimingFunction: function (easing) {
		this.scrollerStyle[utils.style.transitionTimingFunction] = easing;


		if ( this.indicators ) {
			for ( var i = this.indicators.length; i--; ) {
				this.indicators[i].transitionTimingFunction(easing);
			}
		}


// INSERT POINT: _transitionTimingFunction

	},

	_translate: function (x, y) {
		if ( this.options.useTransform ) {

/* REPLACE START: _translate */

			this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;

/* REPLACE END: _translate */

		} else {
			x = Math.round(x);
			y = Math.round(y);
			this.scrollerStyle.left = x + 'px';
			this.scrollerStyle.top = y + 'px';
		}

		this.x = x;
		this.y = y;


	if ( this.indicators ) {
		for ( var i = this.indicators.length; i--; ) {
			this.indicators[i].updatePosition();
		}
	}


// INSERT POINT: _translate

	},

	_initEvents: function (remove) {
		var eventType = remove ? utils.removeEvent : utils.addEvent,
			target = this.options.bindToWrapper ? this.wrapper : window;

		eventType(window, 'orientationchange', this);
		eventType(window, 'resize', this);

		if ( this.options.click ) {
			eventType(this.wrapper, 'click', this, true);
		}

		if ( !this.options.disableMouse ) {
			eventType(this.wrapper, 'mousedown', this);
			eventType(target, 'mousemove', this);
			eventType(target, 'mousecancel', this);
			eventType(target, 'mouseup', this);
		}

		if ( utils.hasPointer && !this.options.disablePointer ) {
			eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
			eventType(target, utils.prefixPointerEvent('pointermove'), this);
			eventType(target, utils.prefixPointerEvent('pointercancel'), this);
			eventType(target, utils.prefixPointerEvent('pointerup'), this);
		}

		if ( utils.hasTouch && !this.options.disableTouch ) {
			eventType(this.wrapper, 'touchstart', this);
			eventType(target, 'touchmove', this);
			eventType(target, 'touchcancel', this);
			eventType(target, 'touchend', this);
		}

		eventType(this.scroller, 'transitionend', this);
		eventType(this.scroller, 'webkitTransitionEnd', this);
		eventType(this.scroller, 'oTransitionEnd', this);
		eventType(this.scroller, 'MSTransitionEnd', this);
	},

	getComputedPosition: function () {
		var matrix = window.getComputedStyle(this.scroller, null),
			x, y;

		if ( this.options.useTransform ) {
			matrix = matrix[utils.style.transform].split(')')[0].split(', ');
			x = +(matrix[12] || matrix[4]);
			y = +(matrix[13] || matrix[5]);
		} else {
			x = +matrix.left.replace(/[^-\d.]/g, '');
			y = +matrix.top.replace(/[^-\d.]/g, '');
		}

		return { x: x, y: y };
	},
	_initIndicators: function () {
		var interactive = this.options.interactiveScrollbars,
			customStyle = typeof this.options.scrollbars != 'string',
			indicators = [],
			indicator;

		var that = this;

		this.indicators = [];

		if ( this.options.scrollbars ) {
			// Vertical scrollbar
			if ( this.options.scrollY ) {
				indicator = {
					el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
					interactive: interactive,
					defaultScrollbars: true,
					customStyle: customStyle,
					resize: this.options.resizeScrollbars,
					shrink: this.options.shrinkScrollbars,
					fade: this.options.fadeScrollbars,
					listenX: false
				};

				this.wrapper.appendChild(indicator.el);
				indicators.push(indicator);
			}

			// Horizontal scrollbar
			if ( this.options.scrollX ) {
				indicator = {
					el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
					interactive: interactive,
					defaultScrollbars: true,
					customStyle: customStyle,
					resize: this.options.resizeScrollbars,
					shrink: this.options.shrinkScrollbars,
					fade: this.options.fadeScrollbars,
					listenY: false
				};

				this.wrapper.appendChild(indicator.el);
				indicators.push(indicator);
			}
		}

		if ( this.options.indicators ) {
			// TODO: check concat compatibility
			indicators = indicators.concat(this.options.indicators);
		}

		for ( var i = indicators.length; i--; ) {
			this.indicators.push( new Indicator(this, indicators[i]) );
		}

		// TODO: check if we can use array.map (wide compatibility and performance issues)
		function _indicatorsMap (fn) {
			if (that.indicators) {
				for ( var i = that.indicators.length; i--; ) {
					fn.call(that.indicators[i]);
				}
			}
		}

		if ( this.options.fadeScrollbars ) {
			this.on('scrollEnd', function () {
				_indicatorsMap(function () {
					this.fade();
				});
			});

			this.on('scrollCancel', function () {
				_indicatorsMap(function () {
					this.fade();
				});
			});

			this.on('scrollStart', function () {
				_indicatorsMap(function () {
					this.fade(1);
				});
			});

			this.on('beforeScrollStart', function () {
				_indicatorsMap(function () {
					this.fade(1, true);
				});
			});
		}


		this.on('refresh', function () {
			_indicatorsMap(function () {
				this.refresh();
			});
		});

		this.on('destroy', function () {
			_indicatorsMap(function () {
				this.destroy();
			});

			delete this.indicators;
		});
	},

	_initWheel: function () {
		utils.addEvent(this.wrapper, 'wheel', this);
		utils.addEvent(this.wrapper, 'mousewheel', this);
		utils.addEvent(this.wrapper, 'DOMMouseScroll', this);

		this.on('destroy', function () {
			clearTimeout(this.wheelTimeout);
			this.wheelTimeout = null;
			utils.removeEvent(this.wrapper, 'wheel', this);
			utils.removeEvent(this.wrapper, 'mousewheel', this);
			utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
		});
	},

	_wheel: function (e) {
		if ( !this.enabled ) {
			return;
		}

		e.preventDefault();

		var wheelDeltaX, wheelDeltaY,
			newX, newY,
			that = this;

		if ( this.wheelTimeout === undefined ) {
			that._execEvent('scrollStart');
		}

		// Execute the scrollEnd event after 400ms the wheel stopped scrolling
		clearTimeout(this.wheelTimeout);
		this.wheelTimeout = setTimeout(function () {
			if(!that.options.snap) {
				that._execEvent('scrollEnd');
			}
			that.wheelTimeout = undefined;
		}, 400);

		if ( 'deltaX' in e ) {
			if (e.deltaMode === 1) {
				wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
				wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
			} else {
				wheelDeltaX = -e.deltaX;
				wheelDeltaY = -e.deltaY;
			}
		} else if ( 'wheelDeltaX' in e ) {
			wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
			wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
		} else if ( 'wheelDelta' in e ) {
			wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
		} else if ( 'detail' in e ) {
			wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
		} else {
			return;
		}

		wheelDeltaX *= this.options.invertWheelDirection;
		wheelDeltaY *= this.options.invertWheelDirection;

		if ( !this.hasVerticalScroll ) {
			wheelDeltaX = wheelDeltaY;
			wheelDeltaY = 0;
		}

		if ( this.options.snap ) {
			newX = this.currentPage.pageX;
			newY = this.currentPage.pageY;

			if ( wheelDeltaX > 0 ) {
				newX--;
			} else if ( wheelDeltaX < 0 ) {
				newX++;
			}

			if ( wheelDeltaY > 0 ) {
				newY--;
			} else if ( wheelDeltaY < 0 ) {
				newY++;
			}

			this.goToPage(newX, newY);

			return;
		}

		newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
		newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

		this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
		this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;

		if ( newX > 0 ) {
			newX = 0;
		} else if ( newX < this.maxScrollX ) {
			newX = this.maxScrollX;
		}

		if ( newY > 0 ) {
			newY = 0;
		} else if ( newY < this.maxScrollY ) {
			newY = this.maxScrollY;
		}

		this.scrollTo(newX, newY, 0);

// INSERT POINT: _wheel
	},

	_initSnap: function () {
		this.currentPage = {};

		if ( typeof this.options.snap == 'string' ) {
			this.options.snap = this.scroller.querySelectorAll(this.options.snap);
		}

		this.on('refresh', function () {
			var i = 0, l,
				m = 0, n,
				cx, cy,
				x = 0, y,
				stepX = this.options.snapStepX || this.wrapperWidth,
				stepY = this.options.snapStepY || this.wrapperHeight,
				el;

			this.pages = [];

			if ( !this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight ) {
				return;
			}

			if ( this.options.snap === true ) {
				cx = Math.round( stepX / 2 );
				cy = Math.round( stepY / 2 );

				while ( x > -this.scrollerWidth ) {
					this.pages[i] = [];
					l = 0;
					y = 0;

					while ( y > -this.scrollerHeight ) {
						this.pages[i][l] = {
							x: Math.max(x, this.maxScrollX),
							y: Math.max(y, this.maxScrollY),
							width: stepX,
							height: stepY,
							cx: x - cx,
							cy: y - cy
						};

						y -= stepY;
						l++;
					}

					x -= stepX;
					i++;
				}
			} else {
				el = this.options.snap;
				l = el.length;
				n = -1;

				for ( ; i < l; i++ ) {
					if ( i === 0 || el[i].offsetLeft <= el[i-1].offsetLeft ) {
						m = 0;
						n++;
					}

					if ( !this.pages[m] ) {
						this.pages[m] = [];
					}

					x = Math.max(-el[i].offsetLeft, this.maxScrollX);
					y = Math.max(-el[i].offsetTop, this.maxScrollY);
					cx = x - Math.round(el[i].offsetWidth / 2);
					cy = y - Math.round(el[i].offsetHeight / 2);

					this.pages[m][n] = {
						x: x,
						y: y,
						width: el[i].offsetWidth,
						height: el[i].offsetHeight,
						cx: cx,
						cy: cy
					};

					if ( x > this.maxScrollX ) {
						m++;
					}
				}
			}

			this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);

			// Update snap threshold if needed
			if ( this.options.snapThreshold % 1 === 0 ) {
				this.snapThresholdX = this.options.snapThreshold;
				this.snapThresholdY = this.options.snapThreshold;
			} else {
				this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
				this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
			}
		});

		this.on('flick', function () {
			var time = this.options.snapSpeed || Math.max(
					Math.max(
						Math.min(Math.abs(this.x - this.startX), 1000),
						Math.min(Math.abs(this.y - this.startY), 1000)
					), 300);

			this.goToPage(
				this.currentPage.pageX + this.directionX,
				this.currentPage.pageY + this.directionY,
				time
			);
		});
	},

	_nearestSnap: function (x, y) {
		if ( !this.pages.length ) {
			return { x: 0, y: 0, pageX: 0, pageY: 0 };
		}

		var i = 0,
			l = this.pages.length,
			m = 0;

		// Check if we exceeded the snap threshold
		if ( Math.abs(x - this.absStartX) < this.snapThresholdX &&
			Math.abs(y - this.absStartY) < this.snapThresholdY ) {
			return this.currentPage;
		}

		if ( x > 0 ) {
			x = 0;
		} else if ( x < this.maxScrollX ) {
			x = this.maxScrollX;
		}

		if ( y > 0 ) {
			y = 0;
		} else if ( y < this.maxScrollY ) {
			y = this.maxScrollY;
		}

		for ( ; i < l; i++ ) {
			if ( x >= this.pages[i][0].cx ) {
				x = this.pages[i][0].x;
				break;
			}
		}

		l = this.pages[i].length;

		for ( ; m < l; m++ ) {
			if ( y >= this.pages[0][m].cy ) {
				y = this.pages[0][m].y;
				break;
			}
		}

		if ( i == this.currentPage.pageX ) {
			i += this.directionX;

			if ( i < 0 ) {
				i = 0;
			} else if ( i >= this.pages.length ) {
				i = this.pages.length - 1;
			}

			x = this.pages[i][0].x;
		}

		if ( m == this.currentPage.pageY ) {
			m += this.directionY;

			if ( m < 0 ) {
				m = 0;
			} else if ( m >= this.pages[0].length ) {
				m = this.pages[0].length - 1;
			}

			y = this.pages[0][m].y;
		}

		return {
			x: x,
			y: y,
			pageX: i,
			pageY: m
		};
	},

	goToPage: function (x, y, time, easing) {
		easing = easing || this.options.bounceEasing;

		if ( x >= this.pages.length ) {
			x = this.pages.length - 1;
		} else if ( x < 0 ) {
			x = 0;
		}

		if ( y >= this.pages[x].length ) {
			y = this.pages[x].length - 1;
		} else if ( y < 0 ) {
			y = 0;
		}

		var posX = this.pages[x][y].x,
			posY = this.pages[x][y].y;

		time = time === undefined ? this.options.snapSpeed || Math.max(
			Math.max(
				Math.min(Math.abs(posX - this.x), 1000),
				Math.min(Math.abs(posY - this.y), 1000)
			), 300) : time;

		this.currentPage = {
			x: posX,
			y: posY,
			pageX: x,
			pageY: y
		};

		this.scrollTo(posX, posY, time, easing);
	},

	next: function (time, easing) {
		var x = this.currentPage.pageX,
			y = this.currentPage.pageY;

		x++;

		if ( x >= this.pages.length && this.hasVerticalScroll ) {
			x = 0;
			y++;
		}

		this.goToPage(x, y, time, easing);
	},

	prev: function (time, easing) {
		var x = this.currentPage.pageX,
			y = this.currentPage.pageY;

		x--;

		if ( x < 0 && this.hasVerticalScroll ) {
			x = 0;
			y--;
		}

		this.goToPage(x, y, time, easing);
	},

	_initKeys: function (e) {
		// default key bindings
		var keys = {
			pageUp: 33,
			pageDown: 34,
			end: 35,
			home: 36,
			left: 37,
			up: 38,
			right: 39,
			down: 40
		};
		var i;

		// if you give me characters I give you keycode
		if ( typeof this.options.keyBindings == 'object' ) {
			for ( i in this.options.keyBindings ) {
				if ( typeof this.options.keyBindings[i] == 'string' ) {
					this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
				}
			}
		} else {
			this.options.keyBindings = {};
		}

		for ( i in keys ) {
			this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
		}

		utils.addEvent(window, 'keydown', this);

		this.on('destroy', function () {
			utils.removeEvent(window, 'keydown', this);
		});
	},

	_key: function (e) {
		if ( !this.enabled ) {
			return;
		}

		var snap = this.options.snap,	// we are using this alot, better to cache it
			newX = snap ? this.currentPage.pageX : this.x,
			newY = snap ? this.currentPage.pageY : this.y,
			now = utils.getTime(),
			prevTime = this.keyTime || 0,
			acceleration = 0.250,
			pos;

		if ( this.options.useTransition && this.isInTransition ) {
			pos = this.getComputedPosition();

			this._translate(Math.round(pos.x), Math.round(pos.y));
			this.isInTransition = false;
		}

		this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;

		switch ( e.keyCode ) {
			case this.options.keyBindings.pageUp:
				if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
					newX += snap ? 1 : this.wrapperWidth;
				} else {
					newY += snap ? 1 : this.wrapperHeight;
				}
				break;
			case this.options.keyBindings.pageDown:
				if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
					newX -= snap ? 1 : this.wrapperWidth;
				} else {
					newY -= snap ? 1 : this.wrapperHeight;
				}
				break;
			case this.options.keyBindings.end:
				newX = snap ? this.pages.length-1 : this.maxScrollX;
				newY = snap ? this.pages[0].length-1 : this.maxScrollY;
				break;
			case this.options.keyBindings.home:
				newX = 0;
				newY = 0;
				break;
			case this.options.keyBindings.left:
				newX += snap ? -1 : 5 + this.keyAcceleration>>0;
				break;
			case this.options.keyBindings.up:
				newY += snap ? 1 : 5 + this.keyAcceleration>>0;
				break;
			case this.options.keyBindings.right:
				newX -= snap ? -1 : 5 + this.keyAcceleration>>0;
				break;
			case this.options.keyBindings.down:
				newY -= snap ? 1 : 5 + this.keyAcceleration>>0;
				break;
			default:
				return;
		}

		if ( snap ) {
			this.goToPage(newX, newY);
			return;
		}

		if ( newX > 0 ) {
			newX = 0;
			this.keyAcceleration = 0;
		} else if ( newX < this.maxScrollX ) {
			newX = this.maxScrollX;
			this.keyAcceleration = 0;
		}

		if ( newY > 0 ) {
			newY = 0;
			this.keyAcceleration = 0;
		} else if ( newY < this.maxScrollY ) {
			newY = this.maxScrollY;
			this.keyAcceleration = 0;
		}

		this.scrollTo(newX, newY, 0);

		this.keyTime = now;
	},

	_animate: function (destX, destY, duration, easingFn) {
		var that = this,
			startX = this.x,
			startY = this.y,
			startTime = utils.getTime(),
			destTime = startTime + duration;

		function step () {
			var now = utils.getTime(),
				newX, newY,
				easing;

			if ( now >= destTime ) {
				that.isAnimating = false;
				that._translate(destX, destY);

				if ( !that.resetPosition(that.options.bounceTime) ) {
					that._execEvent('scrollEnd');
				}

				return;
			}

			now = ( now - startTime ) / duration;
			easing = easingFn(now);
			newX = ( destX - startX ) * easing + startX;
			newY = ( destY - startY ) * easing + startY;
			that._translate(newX, newY);

			if ( that.isAnimating ) {
				rAF(step);
			}
		}

		this.isAnimating = true;
		step();
	},
	handleEvent: function (e) {
		switch ( e.type ) {
			case 'touchstart':
			case 'pointerdown':
			case 'MSPointerDown':
			case 'mousedown':
				this._start(e);
				break;
			case 'touchmove':
			case 'pointermove':
			case 'MSPointerMove':
			case 'mousemove':
				this._move(e);
				break;
			case 'touchend':
			case 'pointerup':
			case 'MSPointerUp':
			case 'mouseup':
			case 'touchcancel':
			case 'pointercancel':
			case 'MSPointerCancel':
			case 'mousecancel':
				this._end(e);
				break;
			case 'orientationchange':
			case 'resize':
				this._resize();
				break;
			case 'transitionend':
			case 'webkitTransitionEnd':
			case 'oTransitionEnd':
			case 'MSTransitionEnd':
				this._transitionEnd(e);
				break;
			case 'wheel':
			case 'DOMMouseScroll':
			case 'mousewheel':
				this._wheel(e);
				break;
			case 'keydown':
				this._key(e);
				break;
			case 'click':
				if ( this.enabled && !e._constructed ) {
					e.preventDefault();
					e.stopPropagation();
				}
				break;
		}
	}
};
function createDefaultScrollbar (direction, interactive, type) {
	var scrollbar = document.createElement('div'),
		indicator = document.createElement('div');

	if ( type === true ) {
		scrollbar.style.cssText = 'position:absolute;z-index:9999';
		indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
	}

	indicator.className = 'iScrollIndicator';

	if ( direction == 'h' ) {
		if ( type === true ) {
			scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
			indicator.style.height = '100%';
		}
		scrollbar.className = 'iScrollHorizontalScrollbar';
	} else {
		if ( type === true ) {
			scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
			indicator.style.width = '100%';
		}
		scrollbar.className = 'iScrollVerticalScrollbar';
	}

	scrollbar.style.cssText += ';overflow:hidden';

	if ( !interactive ) {
		scrollbar.style.pointerEvents = 'none';
	}

	scrollbar.appendChild(indicator);

	return scrollbar;
}

function Indicator (scroller, options) {
	this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
	this.wrapperStyle = this.wrapper.style;
	this.indicator = this.wrapper.children[0];
	this.indicatorStyle = this.indicator.style;
	this.scroller = scroller;

	this.options = {
		listenX: true,
		listenY: true,
		interactive: false,
		resize: true,
		defaultScrollbars: false,
		shrink: false,
		fade: false,
		speedRatioX: 0,
		speedRatioY: 0
	};

	for ( var i in options ) {
		this.options[i] = options[i];
	}

	this.sizeRatioX = 1;
	this.sizeRatioY = 1;
	this.maxPosX = 0;
	this.maxPosY = 0;

	if ( this.options.interactive ) {
		if ( !this.options.disableTouch ) {
			utils.addEvent(this.indicator, 'touchstart', this);
			utils.addEvent(window, 'touchend', this);
		}
		if ( !this.options.disablePointer ) {
			utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
			utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
		}
		if ( !this.options.disableMouse ) {
			utils.addEvent(this.indicator, 'mousedown', this);
			utils.addEvent(window, 'mouseup', this);
		}
	}

	if ( this.options.fade ) {
		this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
		var durationProp = utils.style.transitionDuration;
		this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';
		// remove 0.0001ms
		var self = this;
		if(utils.isBadAndroid) {
			rAF(function() {
				if(self.wrapperStyle[durationProp] === '0.0001ms') {
					self.wrapperStyle[durationProp] = '0s';
				}
			});
		}
		this.wrapperStyle.opacity = '0';
	}
}

Indicator.prototype = {
	handleEvent: function (e) {
		switch ( e.type ) {
			case 'touchstart':
			case 'pointerdown':
			case 'MSPointerDown':
			case 'mousedown':
				this._start(e);
				break;
			case 'touchmove':
			case 'pointermove':
			case 'MSPointerMove':
			case 'mousemove':
				this._move(e);
				break;
			case 'touchend':
			case 'pointerup':
			case 'MSPointerUp':
			case 'mouseup':
			case 'touchcancel':
			case 'pointercancel':
			case 'MSPointerCancel':
			case 'mousecancel':
				this._end(e);
				break;
		}
	},

	destroy: function () {
		if ( this.options.fadeScrollbars ) {
			clearTimeout(this.fadeTimeout);
			this.fadeTimeout = null;
		}
		if ( this.options.interactive ) {
			utils.removeEvent(this.indicator, 'touchstart', this);
			utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
			utils.removeEvent(this.indicator, 'mousedown', this);

			utils.removeEvent(window, 'touchmove', this);
			utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
			utils.removeEvent(window, 'mousemove', this);

			utils.removeEvent(window, 'touchend', this);
			utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
			utils.removeEvent(window, 'mouseup', this);
		}

		if ( this.options.defaultScrollbars ) {
			this.wrapper.parentNode.removeChild(this.wrapper);
		}
	},

	_start: function (e) {
		var point = e.touches ? e.touches[0] : e;

		e.preventDefault();
		e.stopPropagation();

		this.transitionTime();

		this.initiated = true;
		this.moved = false;
		this.lastPointX	= point.pageX;
		this.lastPointY	= point.pageY;

		this.startTime	= utils.getTime();

		if ( !this.options.disableTouch ) {
			utils.addEvent(window, 'touchmove', this);
		}
		if ( !this.options.disablePointer ) {
			utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
		}
		if ( !this.options.disableMouse ) {
			utils.addEvent(window, 'mousemove', this);
		}

		this.scroller._execEvent('beforeScrollStart');
	},

	_move: function (e) {
		var point = e.touches ? e.touches[0] : e,
			deltaX, deltaY,
			newX, newY,
			timestamp = utils.getTime();

		if ( !this.moved ) {
			this.scroller._execEvent('scrollStart');
		}

		this.moved = true;

		deltaX = point.pageX - this.lastPointX;
		this.lastPointX = point.pageX;

		deltaY = point.pageY - this.lastPointY;
		this.lastPointY = point.pageY;

		newX = this.x + deltaX;
		newY = this.y + deltaY;

		this._pos(newX, newY);

// INSERT POINT: indicator._move

		e.preventDefault();
		e.stopPropagation();
	},

	_end: function (e) {
		if ( !this.initiated ) {
			return;
		}

		this.initiated = false;

		e.preventDefault();
		e.stopPropagation();

		utils.removeEvent(window, 'touchmove', this);
		utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
		utils.removeEvent(window, 'mousemove', this);

		if ( this.scroller.options.snap ) {
			var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

			var time = this.options.snapSpeed || Math.max(
					Math.max(
						Math.min(Math.abs(this.scroller.x - snap.x), 1000),
						Math.min(Math.abs(this.scroller.y - snap.y), 1000)
					), 300);

			if ( this.scroller.x != snap.x || this.scroller.y != snap.y ) {
				this.scroller.directionX = 0;
				this.scroller.directionY = 0;
				this.scroller.currentPage = snap;
				this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
			}
		}

		if ( this.moved ) {
			this.scroller._execEvent('scrollEnd');
		}
	},

	transitionTime: function (time) {
		time = time || 0;
		var durationProp = utils.style.transitionDuration;
		this.indicatorStyle[durationProp] = time + 'ms';

		if ( !time && utils.isBadAndroid ) {
			this.indicatorStyle[durationProp] = '0.0001ms';
			// remove 0.0001ms
			var self = this;
			rAF(function() {
				if(self.indicatorStyle[durationProp] === '0.0001ms') {
					self.indicatorStyle[durationProp] = '0s';
				}
			});
		}
	},

	transitionTimingFunction: function (easing) {
		this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
	},

	refresh: function () {
		this.transitionTime();

		if ( this.options.listenX && !this.options.listenY ) {
			this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
		} else if ( this.options.listenY && !this.options.listenX ) {
			this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
		} else {
			this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
		}

		if ( this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll ) {
			utils.addClass(this.wrapper, 'iScrollBothScrollbars');
			utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');

			if ( this.options.defaultScrollbars && this.options.customStyle ) {
				if ( this.options.listenX ) {
					this.wrapper.style.right = '8px';
				} else {
					this.wrapper.style.bottom = '8px';
				}
			}
		} else {
			utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
			utils.addClass(this.wrapper, 'iScrollLoneScrollbar');

			if ( this.options.defaultScrollbars && this.options.customStyle ) {
				if ( this.options.listenX ) {
					this.wrapper.style.right = '2px';
				} else {
					this.wrapper.style.bottom = '2px';
				}
			}
		}

		var r = this.wrapper.offsetHeight;	// force refresh

		if ( this.options.listenX ) {
			this.wrapperWidth = this.wrapper.clientWidth;
			if ( this.options.resize ) {
				this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
				this.indicatorStyle.width = this.indicatorWidth + 'px';
			} else {
				this.indicatorWidth = this.indicator.clientWidth;
			}

			this.maxPosX = this.wrapperWidth - this.indicatorWidth;

			if ( this.options.shrink == 'clip' ) {
				this.minBoundaryX = -this.indicatorWidth + 8;
				this.maxBoundaryX = this.wrapperWidth - 8;
			} else {
				this.minBoundaryX = 0;
				this.maxBoundaryX = this.maxPosX;
			}

			this.sizeRatioX = this.options.speedRatioX || (this.scroller.maxScrollX && (this.maxPosX / this.scroller.maxScrollX));
		}

		if ( this.options.listenY ) {
			this.wrapperHeight = this.wrapper.clientHeight;
			if ( this.options.resize ) {
				this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
				this.indicatorStyle.height = this.indicatorHeight + 'px';
			} else {
				this.indicatorHeight = this.indicator.clientHeight;
			}

			this.maxPosY = this.wrapperHeight - this.indicatorHeight;

			if ( this.options.shrink == 'clip' ) {
				this.minBoundaryY = -this.indicatorHeight + 8;
				this.maxBoundaryY = this.wrapperHeight - 8;
			} else {
				this.minBoundaryY = 0;
				this.maxBoundaryY = this.maxPosY;
			}

			this.maxPosY = this.wrapperHeight - this.indicatorHeight;
			this.sizeRatioY = this.options.speedRatioY || (this.scroller.maxScrollY && (this.maxPosY / this.scroller.maxScrollY));
		}

		this.updatePosition();
	},

	updatePosition: function () {
		var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
			y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;

		if ( !this.options.ignoreBoundaries ) {
			if ( x < this.minBoundaryX ) {
				if ( this.options.shrink == 'scale' ) {
					this.width = Math.max(this.indicatorWidth + x, 8);
					this.indicatorStyle.width = this.width + 'px';
				}
				x = this.minBoundaryX;
			} else if ( x > this.maxBoundaryX ) {
				if ( this.options.shrink == 'scale' ) {
					this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
					this.indicatorStyle.width = this.width + 'px';
					x = this.maxPosX + this.indicatorWidth - this.width;
				} else {
					x = this.maxBoundaryX;
				}
			} else if ( this.options.shrink == 'scale' && this.width != this.indicatorWidth ) {
				this.width = this.indicatorWidth;
				this.indicatorStyle.width = this.width + 'px';
			}

			if ( y < this.minBoundaryY ) {
				if ( this.options.shrink == 'scale' ) {
					this.height = Math.max(this.indicatorHeight + y * 3, 8);
					this.indicatorStyle.height = this.height + 'px';
				}
				y = this.minBoundaryY;
			} else if ( y > this.maxBoundaryY ) {
				if ( this.options.shrink == 'scale' ) {
					this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
					this.indicatorStyle.height = this.height + 'px';
					y = this.maxPosY + this.indicatorHeight - this.height;
				} else {
					y = this.maxBoundaryY;
				}
			} else if ( this.options.shrink == 'scale' && this.height != this.indicatorHeight ) {
				this.height = this.indicatorHeight;
				this.indicatorStyle.height = this.height + 'px';
			}
		}

		this.x = x;
		this.y = y;

		if ( this.scroller.options.useTransform ) {
			this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
		} else {
			this.indicatorStyle.left = x + 'px';
			this.indicatorStyle.top = y + 'px';
		}
	},

	_pos: function (x, y) {
		if ( x < 0 ) {
			x = 0;
		} else if ( x > this.maxPosX ) {
			x = this.maxPosX;
		}

		if ( y < 0 ) {
			y = 0;
		} else if ( y > this.maxPosY ) {
			y = this.maxPosY;
		}

		x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
		y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;

		this.scroller.scrollTo(x, y);
	},

	fade: function (val, hold) {
		if ( hold && !this.visible ) {
			return;
		}

		clearTimeout(this.fadeTimeout);
		this.fadeTimeout = null;

		var time = val ? 250 : 500,
			delay = val ? 0 : 300;

		val = val ? '1' : '0';

		this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';

		this.fadeTimeout = setTimeout((function (val) {
			this.wrapperStyle.opacity = val;
			this.visible = +val;
		}).bind(this, val), delay);
	}
};

IScroll.utils = utils;

if ( typeof module != 'undefined' && module.exports ) {
	module.exports = IScroll;
} else if ( typeof define == 'function' && define.amd ) {
        define( 'IScroll',[],function () { return IScroll; } );
} else {
	window.IScroll = IScroll;
}

})(window, document, Math);

/**
 * Swiper 3.3.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * 
 * http://www.idangero.us/swiper/
 * 
 * Copyright 2016, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 * 
 * Licensed under MIT
 * 
 * Released on: January 10, 2016
 */
!function(){"use strict";function e(e){e.fn.swiper=function(a){var i;return e(this).each(function(){var e=new t(this,a);i||(i=e)}),i}}var a,t=function(e,r){function s(e){return Math.floor(e)}function n(){b.autoplayTimeoutId=setTimeout(function(){b.params.loop?(b.fixLoop(),b._slideNext(),b.emit("onAutoplay",b)):b.isEnd?r.autoplayStopOnLast?b.stopAutoplay():(b._slideTo(0),b.emit("onAutoplay",b)):(b._slideNext(),b.emit("onAutoplay",b))},b.params.autoplay)}function o(e,t){var i=a(e.target);if(!i.is(t))if("string"==typeof t)i=i.parents(t);else if(t.nodeType){var r;return i.parents().each(function(e,a){a===t&&(r=t)}),r?t:void 0}if(0!==i.length)return i[0]}function l(e,a){a=a||{};var t=window.MutationObserver||window.WebkitMutationObserver,i=new t(function(e){e.forEach(function(e){b.onResize(!0),b.emit("onObserverUpdate",b,e)})});i.observe(e,{attributes:"undefined"==typeof a.attributes?!0:a.attributes,childList:"undefined"==typeof a.childList?!0:a.childList,characterData:"undefined"==typeof a.characterData?!0:a.characterData}),b.observers.push(i)}function p(e){e.originalEvent&&(e=e.originalEvent);var a=e.keyCode||e.charCode;if(!b.params.allowSwipeToNext&&(b.isHorizontal()&&39===a||!b.isHorizontal()&&40===a))return!1;if(!b.params.allowSwipeToPrev&&(b.isHorizontal()&&37===a||!b.isHorizontal()&&38===a))return!1;if(!(e.shiftKey||e.altKey||e.ctrlKey||e.metaKey||document.activeElement&&document.activeElement.nodeName&&("input"===document.activeElement.nodeName.toLowerCase()||"textarea"===document.activeElement.nodeName.toLowerCase()))){if(37===a||39===a||38===a||40===a){var t=!1;if(b.container.parents(".swiper-slide").length>0&&0===b.container.parents(".swiper-slide-active").length)return;var i={left:window.pageXOffset,top:window.pageYOffset},r=window.innerWidth,s=window.innerHeight,n=b.container.offset();b.rtl&&(n.left=n.left-b.container[0].scrollLeft);for(var o=[[n.left,n.top],[n.left+b.width,n.top],[n.left,n.top+b.height],[n.left+b.width,n.top+b.height]],l=0;l<o.length;l++){var p=o[l];p[0]>=i.left&&p[0]<=i.left+r&&p[1]>=i.top&&p[1]<=i.top+s&&(t=!0)}if(!t)return}b.isHorizontal()?((37===a||39===a)&&(e.preventDefault?e.preventDefault():e.returnValue=!1),(39===a&&!b.rtl||37===a&&b.rtl)&&b.slideNext(),(37===a&&!b.rtl||39===a&&b.rtl)&&b.slidePrev()):((38===a||40===a)&&(e.preventDefault?e.preventDefault():e.returnValue=!1),40===a&&b.slideNext(),38===a&&b.slidePrev())}}function d(e){e.originalEvent&&(e=e.originalEvent);var a=b.mousewheel.event,t=0,i=b.rtl?-1:1;if(e.detail)t=-e.detail;else if("mousewheel"===a)if(b.params.mousewheelForceToAxis)if(b.isHorizontal()){if(!(Math.abs(e.wheelDeltaX)>Math.abs(e.wheelDeltaY)))return;t=e.wheelDeltaX*i}else{if(!(Math.abs(e.wheelDeltaY)>Math.abs(e.wheelDeltaX)))return;t=e.wheelDeltaY}else t=Math.abs(e.wheelDeltaX)>Math.abs(e.wheelDeltaY)?-e.wheelDeltaX*i:-e.wheelDeltaY;else if("DOMMouseScroll"===a)t=-e.detail;else if("wheel"===a)if(b.params.mousewheelForceToAxis)if(b.isHorizontal()){if(!(Math.abs(e.deltaX)>Math.abs(e.deltaY)))return;t=-e.deltaX*i}else{if(!(Math.abs(e.deltaY)>Math.abs(e.deltaX)))return;t=-e.deltaY}else t=Math.abs(e.deltaX)>Math.abs(e.deltaY)?-e.deltaX*i:-e.deltaY;if(0!==t){if(b.params.mousewheelInvert&&(t=-t),b.params.freeMode){var r=b.getWrapperTranslate()+t*b.params.mousewheelSensitivity,s=b.isBeginning,n=b.isEnd;if(r>=b.minTranslate()&&(r=b.minTranslate()),r<=b.maxTranslate()&&(r=b.maxTranslate()),b.setWrapperTransition(0),b.setWrapperTranslate(r),b.updateProgress(),b.updateActiveIndex(),(!s&&b.isBeginning||!n&&b.isEnd)&&b.updateClasses(),b.params.freeModeSticky?(clearTimeout(b.mousewheel.timeout),b.mousewheel.timeout=setTimeout(function(){b.slideReset()},300)):b.params.lazyLoading&&b.lazy&&b.lazy.load(),0===r||r===b.maxTranslate())return}else{if((new window.Date).getTime()-b.mousewheel.lastScrollTime>60)if(0>t)if(b.isEnd&&!b.params.loop||b.animating){if(b.params.mousewheelReleaseOnEdges)return!0}else b.slideNext();else if(b.isBeginning&&!b.params.loop||b.animating){if(b.params.mousewheelReleaseOnEdges)return!0}else b.slidePrev();b.mousewheel.lastScrollTime=(new window.Date).getTime()}return b.params.autoplay&&b.stopAutoplay(),e.preventDefault?e.preventDefault():e.returnValue=!1,!1}}function u(e,t){e=a(e);var i,r,s,n=b.rtl?-1:1;i=e.attr("data-swiper-parallax")||"0",r=e.attr("data-swiper-parallax-x"),s=e.attr("data-swiper-parallax-y"),r||s?(r=r||"0",s=s||"0"):b.isHorizontal()?(r=i,s="0"):(s=i,r="0"),r=r.indexOf("%")>=0?parseInt(r,10)*t*n+"%":r*t*n+"px",s=s.indexOf("%")>=0?parseInt(s,10)*t+"%":s*t+"px",e.transform("translate3d("+r+", "+s+",0px)")}function c(e){return 0!==e.indexOf("on")&&(e=e[0]!==e[0].toUpperCase()?"on"+e[0].toUpperCase()+e.substring(1):"on"+e),e}if(!(this instanceof t))return new t(e,r);var m={direction:"horizontal",touchEventsTarget:"container",initialSlide:0,speed:300,autoplay:!1,autoplayDisableOnInteraction:!0,autoplayStopOnLast:!1,iOSEdgeSwipeDetection:!1,iOSEdgeSwipeThreshold:20,freeMode:!1,freeModeMomentum:!0,freeModeMomentumRatio:1,freeModeMomentumBounce:!0,freeModeMomentumBounceRatio:1,freeModeSticky:!1,freeModeMinimumVelocity:.02,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",coverflow:{rotate:50,stretch:0,depth:100,modifier:1,slideShadows:!0},flip:{slideShadows:!0,limitRotation:!0},cube:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94},fade:{crossFade:!1},parallax:!1,scrollbar:null,scrollbarHide:!0,scrollbarDraggable:!1,scrollbarSnapOnRelease:!1,keyboardControl:!1,mousewheelControl:!1,mousewheelReleaseOnEdges:!1,mousewheelInvert:!1,mousewheelForceToAxis:!1,mousewheelSensitivity:1,hashnav:!1,breakpoints:void 0,spaceBetween:0,slidesPerView:1,slidesPerColumn:1,slidesPerColumnFill:"column",slidesPerGroup:1,centeredSlides:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,onlyExternal:!1,threshold:0,touchMoveStopPropagation:!0,pagination:null,paginationElement:"span",paginationClickable:!1,paginationHide:!1,paginationBulletRender:null,paginationProgressRender:null,paginationFractionRender:null,paginationCustomRender:null,paginationType:"bullets",resistance:!0,resistanceRatio:.85,nextButton:null,prevButton:null,watchSlidesProgress:!1,watchSlidesVisibility:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,lazyLoading:!1,lazyLoadingInPrevNext:!1,lazyLoadingInPrevNextAmount:1,lazyLoadingOnTransitionStart:!1,preloadImages:!0,updateOnImagesReady:!0,loop:!1,loopAdditionalSlides:0,loopedSlides:null,control:void 0,controlInverse:!1,controlBy:"slide",allowSwipeToPrev:!0,allowSwipeToNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",slideClass:"swiper-slide",slideActiveClass:"swiper-slide-active",slideVisibleClass:"swiper-slide-visible",slideDuplicateClass:"swiper-slide-duplicate",slideNextClass:"swiper-slide-next",slidePrevClass:"swiper-slide-prev",wrapperClass:"swiper-wrapper",bulletClass:"swiper-pagination-bullet",bulletActiveClass:"swiper-pagination-bullet-active",buttonDisabledClass:"swiper-button-disabled",paginationCurrentClass:"swiper-pagination-current",paginationTotalClass:"swiper-pagination-total",paginationHiddenClass:"swiper-pagination-hidden",paginationProgressbarClass:"swiper-pagination-progressbar",observer:!1,observeParents:!1,a11y:!1,prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}",runCallbacksOnInit:!0},f=r&&r.virtualTranslate;r=r||{};var h={};for(var g in r)if("object"!=typeof r[g]||null===r[g]||(r[g].nodeType||r[g]===window||r[g]===document||"undefined"!=typeof i&&r[g]instanceof i||"undefined"!=typeof jQuery&&r[g]instanceof jQuery))h[g]=r[g];else{h[g]={};for(var v in r[g])h[g][v]=r[g][v]}for(var w in m)if("undefined"==typeof r[w])r[w]=m[w];else if("object"==typeof r[w])for(var y in m[w])"undefined"==typeof r[w][y]&&(r[w][y]=m[w][y]);var b=this;if(b.params=r,b.originalParams=h,b.classNames=[],"undefined"!=typeof a&&"undefined"!=typeof i&&(a=i),("undefined"!=typeof a||(a="undefined"==typeof i?window.Dom7||window.Zepto||window.jQuery:i))&&(b.$=a,b.currentBreakpoint=void 0,b.getActiveBreakpoint=function(){if(!b.params.breakpoints)return!1;var e,a=!1,t=[];for(e in b.params.breakpoints)b.params.breakpoints.hasOwnProperty(e)&&t.push(e);t.sort(function(e,a){return parseInt(e,10)>parseInt(a,10)});for(var i=0;i<t.length;i++)e=t[i],e>=window.innerWidth&&!a&&(a=e);return a||"max"},b.setBreakpoint=function(){var e=b.getActiveBreakpoint();if(e&&b.currentBreakpoint!==e){var a=e in b.params.breakpoints?b.params.breakpoints[e]:b.originalParams;for(var t in a)b.params[t]=a[t];b.currentBreakpoint=e}},b.params.breakpoints&&b.setBreakpoint(),b.container=a(e),0!==b.container.length)){if(b.container.length>1)return void b.container.each(function(){new t(this,r)});b.container[0].swiper=b,b.container.data("swiper",b),b.classNames.push("swiper-container-"+b.params.direction),b.params.freeMode&&b.classNames.push("swiper-container-free-mode"),b.support.flexbox||(b.classNames.push("swiper-container-no-flexbox"),b.params.slidesPerColumn=1),b.params.autoHeight&&b.classNames.push("swiper-container-autoheight"),(b.params.parallax||b.params.watchSlidesVisibility)&&(b.params.watchSlidesProgress=!0),["cube","coverflow","flip"].indexOf(b.params.effect)>=0&&(b.support.transforms3d?(b.params.watchSlidesProgress=!0,b.classNames.push("swiper-container-3d")):b.params.effect="slide"),"slide"!==b.params.effect&&b.classNames.push("swiper-container-"+b.params.effect),"cube"===b.params.effect&&(b.params.resistanceRatio=0,b.params.slidesPerView=1,b.params.slidesPerColumn=1,b.params.slidesPerGroup=1,b.params.centeredSlides=!1,b.params.spaceBetween=0,b.params.virtualTranslate=!0,b.params.setWrapperSize=!1),("fade"===b.params.effect||"flip"===b.params.effect)&&(b.params.slidesPerView=1,b.params.slidesPerColumn=1,b.params.slidesPerGroup=1,b.params.watchSlidesProgress=!0,b.params.spaceBetween=0,b.params.setWrapperSize=!1,"undefined"==typeof f&&(b.params.virtualTranslate=!0)),b.params.grabCursor&&b.support.touch&&(b.params.grabCursor=!1),b.wrapper=b.container.children("."+b.params.wrapperClass),b.params.pagination&&(b.paginationContainer=a(b.params.pagination),"bullets"===b.params.paginationType&&b.params.paginationClickable?b.paginationContainer.addClass("swiper-pagination-clickable"):b.params.paginationClickable=!1,b.paginationContainer.addClass("swiper-pagination-"+b.params.paginationType)),b.isHorizontal=function(){return"horizontal"===b.params.direction},b.rtl=b.isHorizontal()&&("rtl"===b.container[0].dir.toLowerCase()||"rtl"===b.container.css("direction")),b.rtl&&b.classNames.push("swiper-container-rtl"),b.rtl&&(b.wrongRTL="-webkit-box"===b.wrapper.css("display")),b.params.slidesPerColumn>1&&b.classNames.push("swiper-container-multirow"),b.device.android&&b.classNames.push("swiper-container-android"),b.container.addClass(b.classNames.join(" ")),b.translate=0,b.progress=0,b.velocity=0,b.lockSwipeToNext=function(){b.params.allowSwipeToNext=!1},b.lockSwipeToPrev=function(){b.params.allowSwipeToPrev=!1},b.lockSwipes=function(){b.params.allowSwipeToNext=b.params.allowSwipeToPrev=!1},b.unlockSwipeToNext=function(){b.params.allowSwipeToNext=!0},b.unlockSwipeToPrev=function(){b.params.allowSwipeToPrev=!0},b.unlockSwipes=function(){b.params.allowSwipeToNext=b.params.allowSwipeToPrev=!0},b.params.grabCursor&&(b.container[0].style.cursor="move",b.container[0].style.cursor="-webkit-grab",b.container[0].style.cursor="-moz-grab",b.container[0].style.cursor="grab"),b.imagesToLoad=[],b.imagesLoaded=0,b.loadImage=function(e,a,t,i,r){function s(){r&&r()}var n;e.complete&&i?s():a?(n=new window.Image,n.onload=s,n.onerror=s,t&&(n.srcset=t),a&&(n.src=a)):s()},b.preloadImages=function(){function e(){"undefined"!=typeof b&&null!==b&&(void 0!==b.imagesLoaded&&b.imagesLoaded++,b.imagesLoaded===b.imagesToLoad.length&&(b.params.updateOnImagesReady&&b.update(),b.emit("onImagesReady",b)))}b.imagesToLoad=b.container.find("img");for(var a=0;a<b.imagesToLoad.length;a++)b.loadImage(b.imagesToLoad[a],b.imagesToLoad[a].currentSrc||b.imagesToLoad[a].getAttribute("src"),b.imagesToLoad[a].srcset||b.imagesToLoad[a].getAttribute("srcset"),!0,e)},b.autoplayTimeoutId=void 0,b.autoplaying=!1,b.autoplayPaused=!1,b.startAutoplay=function(){return"undefined"!=typeof b.autoplayTimeoutId?!1:b.params.autoplay?b.autoplaying?!1:(b.autoplaying=!0,b.emit("onAutoplayStart",b),void n()):!1},b.stopAutoplay=function(e){b.autoplayTimeoutId&&(b.autoplayTimeoutId&&clearTimeout(b.autoplayTimeoutId),b.autoplaying=!1,b.autoplayTimeoutId=void 0,b.emit("onAutoplayStop",b))},b.pauseAutoplay=function(e){b.autoplayPaused||(b.autoplayTimeoutId&&clearTimeout(b.autoplayTimeoutId),b.autoplayPaused=!0,0===e?(b.autoplayPaused=!1,n()):b.wrapper.transitionEnd(function(){b&&(b.autoplayPaused=!1,b.autoplaying?n():b.stopAutoplay())}))},b.minTranslate=function(){return-b.snapGrid[0]},b.maxTranslate=function(){return-b.snapGrid[b.snapGrid.length-1]},b.updateAutoHeight=function(){var e=b.slides.eq(b.activeIndex)[0];if("undefined"!=typeof e){var a=e.offsetHeight;a&&b.wrapper.css("height",a+"px")}},b.updateContainerSize=function(){var e,a;e="undefined"!=typeof b.params.width?b.params.width:b.container[0].clientWidth,a="undefined"!=typeof b.params.height?b.params.height:b.container[0].clientHeight,0===e&&b.isHorizontal()||0===a&&!b.isHorizontal()||(e=e-parseInt(b.container.css("padding-left"),10)-parseInt(b.container.css("padding-right"),10),a=a-parseInt(b.container.css("padding-top"),10)-parseInt(b.container.css("padding-bottom"),10),b.width=e,b.height=a,b.size=b.isHorizontal()?b.width:b.height)},b.updateSlidesSize=function(){b.slides=b.wrapper.children("."+b.params.slideClass),b.snapGrid=[],b.slidesGrid=[],b.slidesSizesGrid=[];var e,a=b.params.spaceBetween,t=-b.params.slidesOffsetBefore,i=0,r=0;"string"==typeof a&&a.indexOf("%")>=0&&(a=parseFloat(a.replace("%",""))/100*b.size),b.virtualSize=-a,b.rtl?b.slides.css({marginLeft:"",marginTop:""}):b.slides.css({marginRight:"",marginBottom:""});var n;b.params.slidesPerColumn>1&&(n=Math.floor(b.slides.length/b.params.slidesPerColumn)===b.slides.length/b.params.slidesPerColumn?b.slides.length:Math.ceil(b.slides.length/b.params.slidesPerColumn)*b.params.slidesPerColumn,"auto"!==b.params.slidesPerView&&"row"===b.params.slidesPerColumnFill&&(n=Math.max(n,b.params.slidesPerView*b.params.slidesPerColumn)));var o,l=b.params.slidesPerColumn,p=n/l,d=p-(b.params.slidesPerColumn*p-b.slides.length);for(e=0;e<b.slides.length;e++){o=0;var u=b.slides.eq(e);if(b.params.slidesPerColumn>1){var c,m,f;"column"===b.params.slidesPerColumnFill?(m=Math.floor(e/l),f=e-m*l,(m>d||m===d&&f===l-1)&&++f>=l&&(f=0,m++),c=m+f*n/l,u.css({"-webkit-box-ordinal-group":c,"-moz-box-ordinal-group":c,"-ms-flex-order":c,"-webkit-order":c,order:c})):(f=Math.floor(e/p),m=e-f*p),u.css({"margin-top":0!==f&&b.params.spaceBetween&&b.params.spaceBetween+"px"}).attr("data-swiper-column",m).attr("data-swiper-row",f)}"none"!==u.css("display")&&("auto"===b.params.slidesPerView?(o=b.isHorizontal()?u.outerWidth(!0):u.outerHeight(!0),b.params.roundLengths&&(o=s(o))):(o=(b.size-(b.params.slidesPerView-1)*a)/b.params.slidesPerView,b.params.roundLengths&&(o=s(o)),b.isHorizontal()?b.slides[e].style.width=o+"px":b.slides[e].style.height=o+"px"),b.slides[e].swiperSlideSize=o,b.slidesSizesGrid.push(o),b.params.centeredSlides?(t=t+o/2+i/2+a,0===e&&(t=t-b.size/2-a),Math.abs(t)<.001&&(t=0),r%b.params.slidesPerGroup===0&&b.snapGrid.push(t),b.slidesGrid.push(t)):(r%b.params.slidesPerGroup===0&&b.snapGrid.push(t),b.slidesGrid.push(t),t=t+o+a),b.virtualSize+=o+a,i=o,r++)}b.virtualSize=Math.max(b.virtualSize,b.size)+b.params.slidesOffsetAfter;var h;if(b.rtl&&b.wrongRTL&&("slide"===b.params.effect||"coverflow"===b.params.effect)&&b.wrapper.css({width:b.virtualSize+b.params.spaceBetween+"px"}),(!b.support.flexbox||b.params.setWrapperSize)&&(b.isHorizontal()?b.wrapper.css({width:b.virtualSize+b.params.spaceBetween+"px"}):b.wrapper.css({height:b.virtualSize+b.params.spaceBetween+"px"})),b.params.slidesPerColumn>1&&(b.virtualSize=(o+b.params.spaceBetween)*n,b.virtualSize=Math.ceil(b.virtualSize/b.params.slidesPerColumn)-b.params.spaceBetween,b.wrapper.css({width:b.virtualSize+b.params.spaceBetween+"px"}),b.params.centeredSlides)){for(h=[],e=0;e<b.snapGrid.length;e++)b.snapGrid[e]<b.virtualSize+b.snapGrid[0]&&h.push(b.snapGrid[e]);b.snapGrid=h}if(!b.params.centeredSlides){for(h=[],e=0;e<b.snapGrid.length;e++)b.snapGrid[e]<=b.virtualSize-b.size&&h.push(b.snapGrid[e]);b.snapGrid=h,Math.floor(b.virtualSize-b.size)>Math.floor(b.snapGrid[b.snapGrid.length-1])&&b.snapGrid.push(b.virtualSize-b.size)}0===b.snapGrid.length&&(b.snapGrid=[0]),0!==b.params.spaceBetween&&(b.isHorizontal()?b.rtl?b.slides.css({marginLeft:a+"px"}):b.slides.css({marginRight:a+"px"}):b.slides.css({marginBottom:a+"px"})),b.params.watchSlidesProgress&&b.updateSlidesOffset()},b.updateSlidesOffset=function(){for(var e=0;e<b.slides.length;e++)b.slides[e].swiperSlideOffset=b.isHorizontal()?b.slides[e].offsetLeft:b.slides[e].offsetTop},b.updateSlidesProgress=function(e){if("undefined"==typeof e&&(e=b.translate||0),0!==b.slides.length){"undefined"==typeof b.slides[0].swiperSlideOffset&&b.updateSlidesOffset();var a=-e;b.rtl&&(a=e),b.slides.removeClass(b.params.slideVisibleClass);for(var t=0;t<b.slides.length;t++){var i=b.slides[t],r=(a-i.swiperSlideOffset)/(i.swiperSlideSize+b.params.spaceBetween);if(b.params.watchSlidesVisibility){var s=-(a-i.swiperSlideOffset),n=s+b.slidesSizesGrid[t],o=s>=0&&s<b.size||n>0&&n<=b.size||0>=s&&n>=b.size;o&&b.slides.eq(t).addClass(b.params.slideVisibleClass)}i.progress=b.rtl?-r:r}}},b.updateProgress=function(e){"undefined"==typeof e&&(e=b.translate||0);var a=b.maxTranslate()-b.minTranslate(),t=b.isBeginning,i=b.isEnd;0===a?(b.progress=0,b.isBeginning=b.isEnd=!0):(b.progress=(e-b.minTranslate())/a,b.isBeginning=b.progress<=0,b.isEnd=b.progress>=1),b.isBeginning&&!t&&b.emit("onReachBeginning",b),b.isEnd&&!i&&b.emit("onReachEnd",b),b.params.watchSlidesProgress&&b.updateSlidesProgress(e),b.emit("onProgress",b,b.progress)},b.updateActiveIndex=function(){var e,a,t,i=b.rtl?b.translate:-b.translate;for(a=0;a<b.slidesGrid.length;a++)"undefined"!=typeof b.slidesGrid[a+1]?i>=b.slidesGrid[a]&&i<b.slidesGrid[a+1]-(b.slidesGrid[a+1]-b.slidesGrid[a])/2?e=a:i>=b.slidesGrid[a]&&i<b.slidesGrid[a+1]&&(e=a+1):i>=b.slidesGrid[a]&&(e=a);(0>e||"undefined"==typeof e)&&(e=0),t=Math.floor(e/b.params.slidesPerGroup),t>=b.snapGrid.length&&(t=b.snapGrid.length-1),e!==b.activeIndex&&(b.snapIndex=t,b.previousIndex=b.activeIndex,b.activeIndex=e,b.updateClasses())},b.updateClasses=function(){b.slides.removeClass(b.params.slideActiveClass+" "+b.params.slideNextClass+" "+b.params.slidePrevClass);var e=b.slides.eq(b.activeIndex);if(e.addClass(b.params.slideActiveClass),e.next("."+b.params.slideClass).addClass(b.params.slideNextClass),e.prev("."+b.params.slideClass).addClass(b.params.slidePrevClass),b.paginationContainer&&b.paginationContainer.length>0){var t,i=b.params.loop?Math.ceil((b.slides.length-2*b.loopedSlides)/b.params.slidesPerGroup):b.snapGrid.length;if(b.params.loop?(t=Math.ceil(b.activeIndex-b.loopedSlides)/b.params.slidesPerGroup,t>b.slides.length-1-2*b.loopedSlides&&(t-=b.slides.length-2*b.loopedSlides),t>i-1&&(t-=i),0>t&&"bullets"!==b.params.paginationType&&(t=i+t)):t="undefined"!=typeof b.snapIndex?b.snapIndex:b.activeIndex||0,"bullets"===b.params.paginationType&&b.bullets&&b.bullets.length>0&&(b.bullets.removeClass(b.params.bulletActiveClass),b.paginationContainer.length>1?b.bullets.each(function(){a(this).index()===t&&a(this).addClass(b.params.bulletActiveClass)}):b.bullets.eq(t).addClass(b.params.bulletActiveClass)),"fraction"===b.params.paginationType&&(b.paginationContainer.find("."+b.params.paginationCurrentClass).text(t+1),b.paginationContainer.find("."+b.params.paginationTotalClass).text(i)),"progress"===b.params.paginationType){var r=(t+1)/i,s=r,n=1;b.isHorizontal()||(n=r,s=1),b.paginationContainer.find("."+b.params.paginationProgressbarClass).transform("translate3d(0,0,0) scaleX("+s+") scaleY("+n+")").transition(b.params.speed)}"custom"===b.params.paginationType&&b.params.paginationCustomRender&&b.paginationContainer.html(b.params.paginationCustomRender(b,t+1,i))}b.params.loop||(b.params.prevButton&&(b.isBeginning?(a(b.params.prevButton).addClass(b.params.buttonDisabledClass),b.params.a11y&&b.a11y&&b.a11y.disable(a(b.params.prevButton))):(a(b.params.prevButton).removeClass(b.params.buttonDisabledClass),b.params.a11y&&b.a11y&&b.a11y.enable(a(b.params.prevButton)))),b.params.nextButton&&(b.isEnd?(a(b.params.nextButton).addClass(b.params.buttonDisabledClass),b.params.a11y&&b.a11y&&b.a11y.disable(a(b.params.nextButton))):(a(b.params.nextButton).removeClass(b.params.buttonDisabledClass),b.params.a11y&&b.a11y&&b.a11y.enable(a(b.params.nextButton)))))},b.updatePagination=function(){if(b.params.pagination&&b.paginationContainer&&b.paginationContainer.length>0){var e="";if("bullets"===b.params.paginationType){for(var a=b.params.loop?Math.ceil((b.slides.length-2*b.loopedSlides)/b.params.slidesPerGroup):b.snapGrid.length,t=0;a>t;t++)e+=b.params.paginationBulletRender?b.params.paginationBulletRender(t,b.params.bulletClass):"<"+b.params.paginationElement+' class="'+b.params.bulletClass+'"></'+b.params.paginationElement+">";b.paginationContainer.html(e),b.bullets=b.paginationContainer.find("."+b.params.bulletClass),b.params.paginationClickable&&b.params.a11y&&b.a11y&&b.a11y.initPagination()}"fraction"===b.params.paginationType&&(e=b.params.paginationFractionRender?b.params.paginationFractionRender(b,b.params.paginationCurrentClass,b.params.paginationTotalClass):'<span class="'+b.params.paginationCurrentClass+'"></span> / <span class="'+b.params.paginationTotalClass+'"></span>',b.paginationContainer.html(e)),"progress"===b.params.paginationType&&(e=b.params.paginationProgressRender?b.params.paginationProgressRender(b,b.params.paginationProgressbarClass):'<span class="'+b.params.paginationProgressbarClass+'"></span>',b.paginationContainer.html(e))}},b.update=function(e){function a(){i=Math.min(Math.max(b.translate,b.maxTranslate()),b.minTranslate()),b.setWrapperTranslate(i),b.updateActiveIndex(),b.updateClasses()}if(b.updateContainerSize(),b.updateSlidesSize(),b.updateProgress(),b.updatePagination(),b.updateClasses(),b.params.scrollbar&&b.scrollbar&&b.scrollbar.set(),e){var t,i;b.controller&&b.controller.spline&&(b.controller.spline=void 0),b.params.freeMode?(a(),b.params.autoHeight&&b.updateAutoHeight()):(t=("auto"===b.params.slidesPerView||b.params.slidesPerView>1)&&b.isEnd&&!b.params.centeredSlides?b.slideTo(b.slides.length-1,0,!1,!0):b.slideTo(b.activeIndex,0,!1,!0),t||a())}else b.params.autoHeight&&b.updateAutoHeight()},b.onResize=function(e){b.params.breakpoints&&b.setBreakpoint();var a=b.params.allowSwipeToPrev,t=b.params.allowSwipeToNext;if(b.params.allowSwipeToPrev=b.params.allowSwipeToNext=!0,b.updateContainerSize(),b.updateSlidesSize(),("auto"===b.params.slidesPerView||b.params.freeMode||e)&&b.updatePagination(),b.params.scrollbar&&b.scrollbar&&b.scrollbar.set(),b.controller&&b.controller.spline&&(b.controller.spline=void 0),b.params.freeMode){var i=Math.min(Math.max(b.translate,b.maxTranslate()),b.minTranslate());b.setWrapperTranslate(i),b.updateActiveIndex(),b.updateClasses(),b.params.autoHeight&&b.updateAutoHeight()}else b.updateClasses(),("auto"===b.params.slidesPerView||b.params.slidesPerView>1)&&b.isEnd&&!b.params.centeredSlides?b.slideTo(b.slides.length-1,0,!1,!0):b.slideTo(b.activeIndex,0,!1,!0);b.params.allowSwipeToPrev=a,b.params.allowSwipeToNext=t};var T=["mousedown","mousemove","mouseup"];window.navigator.pointerEnabled?T=["pointerdown","pointermove","pointerup"]:window.navigator.msPointerEnabled&&(T=["MSPointerDown","MSPointerMove","MSPointerUp"]),b.touchEvents={start:b.support.touch||!b.params.simulateTouch?"touchstart":T[0],move:b.support.touch||!b.params.simulateTouch?"touchmove":T[1],end:b.support.touch||!b.params.simulateTouch?"touchend":T[2]},(window.navigator.pointerEnabled||window.navigator.msPointerEnabled)&&("container"===b.params.touchEventsTarget?b.container:b.wrapper).addClass("swiper-wp8-"+b.params.direction),b.initEvents=function(e){var t=e?"off":"on",i=e?"removeEventListener":"addEventListener",s="container"===b.params.touchEventsTarget?b.container[0]:b.wrapper[0],n=b.support.touch?s:document,o=b.params.nested?!0:!1;b.browser.ie?(s[i](b.touchEvents.start,b.onTouchStart,!1),n[i](b.touchEvents.move,b.onTouchMove,o),n[i](b.touchEvents.end,b.onTouchEnd,!1)):(b.support.touch&&(s[i](b.touchEvents.start,b.onTouchStart,!1),s[i](b.touchEvents.move,b.onTouchMove,o),s[i](b.touchEvents.end,b.onTouchEnd,!1)),!r.simulateTouch||b.device.ios||b.device.android||(s[i]("mousedown",b.onTouchStart,!1),document[i]("mousemove",b.onTouchMove,o),document[i]("mouseup",b.onTouchEnd,!1))),window[i]("resize",b.onResize),b.params.nextButton&&(a(b.params.nextButton)[t]("click",b.onClickNext),b.params.a11y&&b.a11y&&a(b.params.nextButton)[t]("keydown",b.a11y.onEnterKey)),b.params.prevButton&&(a(b.params.prevButton)[t]("click",b.onClickPrev),b.params.a11y&&b.a11y&&a(b.params.prevButton)[t]("keydown",b.a11y.onEnterKey)),b.params.pagination&&b.params.paginationClickable&&(a(b.paginationContainer)[t]("click","."+b.params.bulletClass,b.onClickIndex),b.params.a11y&&b.a11y&&a(b.paginationContainer)[t]("keydown","."+b.params.bulletClass,b.a11y.onEnterKey)),(b.params.preventClicks||b.params.preventClicksPropagation)&&s[i]("click",b.preventClicks,!0)},b.attachEvents=function(e){b.initEvents()},b.detachEvents=function(){b.initEvents(!0)},b.allowClick=!0,b.preventClicks=function(e){b.allowClick||(b.params.preventClicks&&e.preventDefault(),b.params.preventClicksPropagation&&b.animating&&(e.stopPropagation(),e.stopImmediatePropagation()))},b.onClickNext=function(e){e.preventDefault(),(!b.isEnd||b.params.loop)&&b.slideNext()},b.onClickPrev=function(e){e.preventDefault(),(!b.isBeginning||b.params.loop)&&b.slidePrev()},b.onClickIndex=function(e){e.preventDefault();var t=a(this).index()*b.params.slidesPerGroup;b.params.loop&&(t+=b.loopedSlides),b.slideTo(t)},b.updateClickedSlide=function(e){var t=o(e,"."+b.params.slideClass),i=!1;if(t)for(var r=0;r<b.slides.length;r++)b.slides[r]===t&&(i=!0);if(!t||!i)return b.clickedSlide=void 0,void(b.clickedIndex=void 0);if(b.clickedSlide=t,b.clickedIndex=a(t).index(),b.params.slideToClickedSlide&&void 0!==b.clickedIndex&&b.clickedIndex!==b.activeIndex){var s,n=b.clickedIndex;if(b.params.loop){if(b.animating)return;s=a(b.clickedSlide).attr("data-swiper-slide-index"),b.params.centeredSlides?n<b.loopedSlides-b.params.slidesPerView/2||n>b.slides.length-b.loopedSlides+b.params.slidesPerView/2?(b.fixLoop(),n=b.wrapper.children("."+b.params.slideClass+'[data-swiper-slide-index="'+s+'"]:not(.swiper-slide-duplicate)').eq(0).index(),setTimeout(function(){b.slideTo(n)},0)):b.slideTo(n):n>b.slides.length-b.params.slidesPerView?(b.fixLoop(),n=b.wrapper.children("."+b.params.slideClass+'[data-swiper-slide-index="'+s+'"]:not(.swiper-slide-duplicate)').eq(0).index(),setTimeout(function(){b.slideTo(n)},0)):b.slideTo(n)}else b.slideTo(n)}};var x,S,C,z,M,P,E,k,I,L,D="input, select, textarea, button",H=Date.now(),B=[];b.animating=!1,b.touches={startX:0,startY:0,currentX:0,currentY:0,diff:0};var A,G;if(b.onTouchStart=function(e){if(e.originalEvent&&(e=e.originalEvent),A="touchstart"===e.type,A||!("which"in e)||3!==e.which){if(b.params.noSwiping&&o(e,"."+b.params.noSwipingClass))return void(b.allowClick=!0);if(!b.params.swipeHandler||o(e,b.params.swipeHandler)){var t=b.touches.currentX="touchstart"===e.type?e.targetTouches[0].pageX:e.pageX,i=b.touches.currentY="touchstart"===e.type?e.targetTouches[0].pageY:e.pageY;if(!(b.device.ios&&b.params.iOSEdgeSwipeDetection&&t<=b.params.iOSEdgeSwipeThreshold)){if(x=!0,S=!1,C=!0,M=void 0,G=void 0,b.touches.startX=t,b.touches.startY=i,z=Date.now(),b.allowClick=!0,b.updateContainerSize(),b.swipeDirection=void 0,b.params.threshold>0&&(k=!1),"touchstart"!==e.type){var r=!0;a(e.target).is(D)&&(r=!1),document.activeElement&&a(document.activeElement).is(D)&&document.activeElement.blur(),r&&e.preventDefault()}b.emit("onTouchStart",b,e)}}}},b.onTouchMove=function(e){if(e.originalEvent&&(e=e.originalEvent),!(A&&"mousemove"===e.type||e.preventedByNestedSwiper)){if(b.params.onlyExternal)return b.allowClick=!1,void(x&&(b.touches.startX=b.touches.currentX="touchmove"===e.type?e.targetTouches[0].pageX:e.pageX,b.touches.startY=b.touches.currentY="touchmove"===e.type?e.targetTouches[0].pageY:e.pageY,z=Date.now()));if(A&&document.activeElement&&e.target===document.activeElement&&a(e.target).is(D))return S=!0,void(b.allowClick=!1);if(C&&b.emit("onTouchMove",b,e),!(e.targetTouches&&e.targetTouches.length>1)){if(b.touches.currentX="touchmove"===e.type?e.targetTouches[0].pageX:e.pageX,b.touches.currentY="touchmove"===e.type?e.targetTouches[0].pageY:e.pageY,"undefined"==typeof M){var t=180*Math.atan2(Math.abs(b.touches.currentY-b.touches.startY),Math.abs(b.touches.currentX-b.touches.startX))/Math.PI;M=b.isHorizontal()?t>b.params.touchAngle:90-t>b.params.touchAngle}if(M&&b.emit("onTouchMoveOpposite",b,e),"undefined"==typeof G&&b.browser.ieTouch&&(b.touches.currentX!==b.touches.startX||b.touches.currentY!==b.touches.startY)&&(G=!0),x){if(M)return void(x=!1);if(G||!b.browser.ieTouch){b.allowClick=!1,b.emit("onSliderMove",b,e),e.preventDefault(),b.params.touchMoveStopPropagation&&!b.params.nested&&e.stopPropagation(),S||(r.loop&&b.fixLoop(),E=b.getWrapperTranslate(),b.setWrapperTransition(0),b.animating&&b.wrapper.trigger("webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd"),b.params.autoplay&&b.autoplaying&&(b.params.autoplayDisableOnInteraction?b.stopAutoplay():b.pauseAutoplay()),L=!1,b.params.grabCursor&&(b.container[0].style.cursor="move",b.container[0].style.cursor="-webkit-grabbing",b.container[0].style.cursor="-moz-grabbin",b.container[0].style.cursor="grabbing")),S=!0;var i=b.touches.diff=b.isHorizontal()?b.touches.currentX-b.touches.startX:b.touches.currentY-b.touches.startY;i*=b.params.touchRatio,b.rtl&&(i=-i),b.swipeDirection=i>0?"prev":"next",P=i+E;var s=!0;if(i>0&&P>b.minTranslate()?(s=!1,b.params.resistance&&(P=b.minTranslate()-1+Math.pow(-b.minTranslate()+E+i,b.params.resistanceRatio))):0>i&&P<b.maxTranslate()&&(s=!1,b.params.resistance&&(P=b.maxTranslate()+1-Math.pow(b.maxTranslate()-E-i,b.params.resistanceRatio))),s&&(e.preventedByNestedSwiper=!0),!b.params.allowSwipeToNext&&"next"===b.swipeDirection&&E>P&&(P=E),!b.params.allowSwipeToPrev&&"prev"===b.swipeDirection&&P>E&&(P=E),b.params.followFinger){if(b.params.threshold>0){if(!(Math.abs(i)>b.params.threshold||k))return void(P=E);if(!k)return k=!0,b.touches.startX=b.touches.currentX,b.touches.startY=b.touches.currentY,P=E,void(b.touches.diff=b.isHorizontal()?b.touches.currentX-b.touches.startX:b.touches.currentY-b.touches.startY)}(b.params.freeMode||b.params.watchSlidesProgress)&&b.updateActiveIndex(),b.params.freeMode&&(0===B.length&&B.push({position:b.touches[b.isHorizontal()?"startX":"startY"],time:z}),B.push({position:b.touches[b.isHorizontal()?"currentX":"currentY"],time:(new window.Date).getTime()})),b.updateProgress(P),b.setWrapperTranslate(P)}}}}}},b.onTouchEnd=function(e){if(e.originalEvent&&(e=e.originalEvent),C&&b.emit("onTouchEnd",b,e),C=!1,x){b.params.grabCursor&&S&&x&&(b.container[0].style.cursor="move",b.container[0].style.cursor="-webkit-grab",b.container[0].style.cursor="-moz-grab",b.container[0].style.cursor="grab");var t=Date.now(),i=t-z;if(b.allowClick&&(b.updateClickedSlide(e),b.emit("onTap",b,e),300>i&&t-H>300&&(I&&clearTimeout(I),I=setTimeout(function(){b&&(b.params.paginationHide&&b.paginationContainer.length>0&&!a(e.target).hasClass(b.params.bulletClass)&&b.paginationContainer.toggleClass(b.params.paginationHiddenClass),
b.emit("onClick",b,e))},300)),300>i&&300>t-H&&(I&&clearTimeout(I),b.emit("onDoubleTap",b,e))),H=Date.now(),setTimeout(function(){b&&(b.allowClick=!0)},0),!x||!S||!b.swipeDirection||0===b.touches.diff||P===E)return void(x=S=!1);x=S=!1;var r;if(r=b.params.followFinger?b.rtl?b.translate:-b.translate:-P,b.params.freeMode){if(r<-b.minTranslate())return void b.slideTo(b.activeIndex);if(r>-b.maxTranslate())return void(b.slides.length<b.snapGrid.length?b.slideTo(b.snapGrid.length-1):b.slideTo(b.slides.length-1));if(b.params.freeModeMomentum){if(B.length>1){var s=B.pop(),n=B.pop(),o=s.position-n.position,l=s.time-n.time;b.velocity=o/l,b.velocity=b.velocity/2,Math.abs(b.velocity)<b.params.freeModeMinimumVelocity&&(b.velocity=0),(l>150||(new window.Date).getTime()-s.time>300)&&(b.velocity=0)}else b.velocity=0;B.length=0;var p=1e3*b.params.freeModeMomentumRatio,d=b.velocity*p,u=b.translate+d;b.rtl&&(u=-u);var c,m=!1,f=20*Math.abs(b.velocity)*b.params.freeModeMomentumBounceRatio;if(u<b.maxTranslate())b.params.freeModeMomentumBounce?(u+b.maxTranslate()<-f&&(u=b.maxTranslate()-f),c=b.maxTranslate(),m=!0,L=!0):u=b.maxTranslate();else if(u>b.minTranslate())b.params.freeModeMomentumBounce?(u-b.minTranslate()>f&&(u=b.minTranslate()+f),c=b.minTranslate(),m=!0,L=!0):u=b.minTranslate();else if(b.params.freeModeSticky){var h,g=0;for(g=0;g<b.snapGrid.length;g+=1)if(b.snapGrid[g]>-u){h=g;break}u=Math.abs(b.snapGrid[h]-u)<Math.abs(b.snapGrid[h-1]-u)||"next"===b.swipeDirection?b.snapGrid[h]:b.snapGrid[h-1],b.rtl||(u=-u)}if(0!==b.velocity)p=b.rtl?Math.abs((-u-b.translate)/b.velocity):Math.abs((u-b.translate)/b.velocity);else if(b.params.freeModeSticky)return void b.slideReset();b.params.freeModeMomentumBounce&&m?(b.updateProgress(c),b.setWrapperTransition(p),b.setWrapperTranslate(u),b.onTransitionStart(),b.animating=!0,b.wrapper.transitionEnd(function(){b&&L&&(b.emit("onMomentumBounce",b),b.setWrapperTransition(b.params.speed),b.setWrapperTranslate(c),b.wrapper.transitionEnd(function(){b&&b.onTransitionEnd()}))})):b.velocity?(b.updateProgress(u),b.setWrapperTransition(p),b.setWrapperTranslate(u),b.onTransitionStart(),b.animating||(b.animating=!0,b.wrapper.transitionEnd(function(){b&&b.onTransitionEnd()}))):b.updateProgress(u),b.updateActiveIndex()}return void((!b.params.freeModeMomentum||i>=b.params.longSwipesMs)&&(b.updateProgress(),b.updateActiveIndex()))}var v,w=0,y=b.slidesSizesGrid[0];for(v=0;v<b.slidesGrid.length;v+=b.params.slidesPerGroup)"undefined"!=typeof b.slidesGrid[v+b.params.slidesPerGroup]?r>=b.slidesGrid[v]&&r<b.slidesGrid[v+b.params.slidesPerGroup]&&(w=v,y=b.slidesGrid[v+b.params.slidesPerGroup]-b.slidesGrid[v]):r>=b.slidesGrid[v]&&(w=v,y=b.slidesGrid[b.slidesGrid.length-1]-b.slidesGrid[b.slidesGrid.length-2]);var T=(r-b.slidesGrid[w])/y;if(i>b.params.longSwipesMs){if(!b.params.longSwipes)return void b.slideTo(b.activeIndex);"next"===b.swipeDirection&&(T>=b.params.longSwipesRatio?b.slideTo(w+b.params.slidesPerGroup):b.slideTo(w)),"prev"===b.swipeDirection&&(T>1-b.params.longSwipesRatio?b.slideTo(w+b.params.slidesPerGroup):b.slideTo(w))}else{if(!b.params.shortSwipes)return void b.slideTo(b.activeIndex);"next"===b.swipeDirection&&b.slideTo(w+b.params.slidesPerGroup),"prev"===b.swipeDirection&&b.slideTo(w)}}},b._slideTo=function(e,a){return b.slideTo(e,a,!0,!0)},b.slideTo=function(e,a,t,i){"undefined"==typeof t&&(t=!0),"undefined"==typeof e&&(e=0),0>e&&(e=0),b.snapIndex=Math.floor(e/b.params.slidesPerGroup),b.snapIndex>=b.snapGrid.length&&(b.snapIndex=b.snapGrid.length-1);var r=-b.snapGrid[b.snapIndex];b.params.autoplay&&b.autoplaying&&(i||!b.params.autoplayDisableOnInteraction?b.pauseAutoplay(a):b.stopAutoplay()),b.updateProgress(r);for(var s=0;s<b.slidesGrid.length;s++)-Math.floor(100*r)>=Math.floor(100*b.slidesGrid[s])&&(e=s);return!b.params.allowSwipeToNext&&r<b.translate&&r<b.minTranslate()?!1:!b.params.allowSwipeToPrev&&r>b.translate&&r>b.maxTranslate()&&(b.activeIndex||0)!==e?!1:("undefined"==typeof a&&(a=b.params.speed),b.previousIndex=b.activeIndex||0,b.activeIndex=e,b.rtl&&-r===b.translate||!b.rtl&&r===b.translate?(b.params.autoHeight&&b.updateAutoHeight(),b.updateClasses(),"slide"!==b.params.effect&&b.setWrapperTranslate(r),!1):(b.updateClasses(),b.onTransitionStart(t),0===a?(b.setWrapperTranslate(r),b.setWrapperTransition(0),b.onTransitionEnd(t)):(b.setWrapperTranslate(r),b.setWrapperTransition(a),b.animating||(b.animating=!0,b.wrapper.transitionEnd(function(){b&&b.onTransitionEnd(t)}))),!0))},b.onTransitionStart=function(e){"undefined"==typeof e&&(e=!0),b.params.autoHeight&&b.updateAutoHeight(),b.lazy&&b.lazy.onTransitionStart(),e&&(b.emit("onTransitionStart",b),b.activeIndex!==b.previousIndex&&(b.emit("onSlideChangeStart",b),b.activeIndex>b.previousIndex?b.emit("onSlideNextStart",b):b.emit("onSlidePrevStart",b)))},b.onTransitionEnd=function(e){b.animating=!1,b.setWrapperTransition(0),"undefined"==typeof e&&(e=!0),b.lazy&&b.lazy.onTransitionEnd(),e&&(b.emit("onTransitionEnd",b),b.activeIndex!==b.previousIndex&&(b.emit("onSlideChangeEnd",b),b.activeIndex>b.previousIndex?b.emit("onSlideNextEnd",b):b.emit("onSlidePrevEnd",b))),b.params.hashnav&&b.hashnav&&b.hashnav.setHash()},b.slideNext=function(e,a,t){if(b.params.loop){if(b.animating)return!1;b.fixLoop();b.container[0].clientLeft;return b.slideTo(b.activeIndex+b.params.slidesPerGroup,a,e,t)}return b.slideTo(b.activeIndex+b.params.slidesPerGroup,a,e,t)},b._slideNext=function(e){return b.slideNext(!0,e,!0)},b.slidePrev=function(e,a,t){if(b.params.loop){if(b.animating)return!1;b.fixLoop();b.container[0].clientLeft;return b.slideTo(b.activeIndex-1,a,e,t)}return b.slideTo(b.activeIndex-1,a,e,t)},b._slidePrev=function(e){return b.slidePrev(!0,e,!0)},b.slideReset=function(e,a,t){return b.slideTo(b.activeIndex,a,e)},b.setWrapperTransition=function(e,a){b.wrapper.transition(e),"slide"!==b.params.effect&&b.effects[b.params.effect]&&b.effects[b.params.effect].setTransition(e),b.params.parallax&&b.parallax&&b.parallax.setTransition(e),b.params.scrollbar&&b.scrollbar&&b.scrollbar.setTransition(e),b.params.control&&b.controller&&b.controller.setTransition(e,a),b.emit("onSetTransition",b,e)},b.setWrapperTranslate=function(e,a,t){var i=0,r=0,n=0;b.isHorizontal()?i=b.rtl?-e:e:r=e,b.params.roundLengths&&(i=s(i),r=s(r)),b.params.virtualTranslate||(b.support.transforms3d?b.wrapper.transform("translate3d("+i+"px, "+r+"px, "+n+"px)"):b.wrapper.transform("translate("+i+"px, "+r+"px)")),b.translate=b.isHorizontal()?i:r;var o,l=b.maxTranslate()-b.minTranslate();o=0===l?0:(e-b.minTranslate())/l,o!==b.progress&&b.updateProgress(e),a&&b.updateActiveIndex(),"slide"!==b.params.effect&&b.effects[b.params.effect]&&b.effects[b.params.effect].setTranslate(b.translate),b.params.parallax&&b.parallax&&b.parallax.setTranslate(b.translate),b.params.scrollbar&&b.scrollbar&&b.scrollbar.setTranslate(b.translate),b.params.control&&b.controller&&b.controller.setTranslate(b.translate,t),b.emit("onSetTranslate",b,b.translate)},b.getTranslate=function(e,a){var t,i,r,s;return"undefined"==typeof a&&(a="x"),b.params.virtualTranslate?b.rtl?-b.translate:b.translate:(r=window.getComputedStyle(e,null),window.WebKitCSSMatrix?(i=r.transform||r.webkitTransform,i.split(",").length>6&&(i=i.split(", ").map(function(e){return e.replace(",",".")}).join(", ")),s=new window.WebKitCSSMatrix("none"===i?"":i)):(s=r.MozTransform||r.OTransform||r.MsTransform||r.msTransform||r.transform||r.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,"),t=s.toString().split(",")),"x"===a&&(i=window.WebKitCSSMatrix?s.m41:16===t.length?parseFloat(t[12]):parseFloat(t[4])),"y"===a&&(i=window.WebKitCSSMatrix?s.m42:16===t.length?parseFloat(t[13]):parseFloat(t[5])),b.rtl&&i&&(i=-i),i||0)},b.getWrapperTranslate=function(e){return"undefined"==typeof e&&(e=b.isHorizontal()?"x":"y"),b.getTranslate(b.wrapper[0],e)},b.observers=[],b.initObservers=function(){if(b.params.observeParents)for(var e=b.container.parents(),a=0;a<e.length;a++)l(e[a]);l(b.container[0],{childList:!1}),l(b.wrapper[0],{attributes:!1})},b.disconnectObservers=function(){for(var e=0;e<b.observers.length;e++)b.observers[e].disconnect();b.observers=[]},b.createLoop=function(){b.wrapper.children("."+b.params.slideClass+"."+b.params.slideDuplicateClass).remove();var e=b.wrapper.children("."+b.params.slideClass);"auto"!==b.params.slidesPerView||b.params.loopedSlides||(b.params.loopedSlides=e.length),b.loopedSlides=parseInt(b.params.loopedSlides||b.params.slidesPerView,10),b.loopedSlides=b.loopedSlides+b.params.loopAdditionalSlides,b.loopedSlides>e.length&&(b.loopedSlides=e.length);var t,i=[],r=[];for(e.each(function(t,s){var n=a(this);t<b.loopedSlides&&r.push(s),t<e.length&&t>=e.length-b.loopedSlides&&i.push(s),n.attr("data-swiper-slide-index",t)}),t=0;t<r.length;t++)b.wrapper.append(a(r[t].cloneNode(!0)).addClass(b.params.slideDuplicateClass));for(t=i.length-1;t>=0;t--)b.wrapper.prepend(a(i[t].cloneNode(!0)).addClass(b.params.slideDuplicateClass))},b.destroyLoop=function(){b.wrapper.children("."+b.params.slideClass+"."+b.params.slideDuplicateClass).remove(),b.slides.removeAttr("data-swiper-slide-index")},b.fixLoop=function(){var e;b.activeIndex<b.loopedSlides?(e=b.slides.length-3*b.loopedSlides+b.activeIndex,e+=b.loopedSlides,b.slideTo(e,0,!1,!0)):("auto"===b.params.slidesPerView&&b.activeIndex>=2*b.loopedSlides||b.activeIndex>b.slides.length-2*b.params.slidesPerView)&&(e=-b.slides.length+b.activeIndex+b.loopedSlides,e+=b.loopedSlides,b.slideTo(e,0,!1,!0))},b.appendSlide=function(e){if(b.params.loop&&b.destroyLoop(),"object"==typeof e&&e.length)for(var a=0;a<e.length;a++)e[a]&&b.wrapper.append(e[a]);else b.wrapper.append(e);b.params.loop&&b.createLoop(),b.params.observer&&b.support.observer||b.update(!0)},b.prependSlide=function(e){b.params.loop&&b.destroyLoop();var a=b.activeIndex+1;if("object"==typeof e&&e.length){for(var t=0;t<e.length;t++)e[t]&&b.wrapper.prepend(e[t]);a=b.activeIndex+e.length}else b.wrapper.prepend(e);b.params.loop&&b.createLoop(),b.params.observer&&b.support.observer||b.update(!0),b.slideTo(a,0,!1)},b.removeSlide=function(e){b.params.loop&&(b.destroyLoop(),b.slides=b.wrapper.children("."+b.params.slideClass));var a,t=b.activeIndex;if("object"==typeof e&&e.length){for(var i=0;i<e.length;i++)a=e[i],b.slides[a]&&b.slides.eq(a).remove(),t>a&&t--;t=Math.max(t,0)}else a=e,b.slides[a]&&b.slides.eq(a).remove(),t>a&&t--,t=Math.max(t,0);b.params.loop&&b.createLoop(),b.params.observer&&b.support.observer||b.update(!0),b.params.loop?b.slideTo(t+b.loopedSlides,0,!1):b.slideTo(t,0,!1)},b.removeAllSlides=function(){for(var e=[],a=0;a<b.slides.length;a++)e.push(a);b.removeSlide(e)},b.effects={fade:{setTranslate:function(){for(var e=0;e<b.slides.length;e++){var a=b.slides.eq(e),t=a[0].swiperSlideOffset,i=-t;b.params.virtualTranslate||(i-=b.translate);var r=0;b.isHorizontal()||(r=i,i=0);var s=b.params.fade.crossFade?Math.max(1-Math.abs(a[0].progress),0):1+Math.min(Math.max(a[0].progress,-1),0);a.css({opacity:s}).transform("translate3d("+i+"px, "+r+"px, 0px)")}},setTransition:function(e){if(b.slides.transition(e),b.params.virtualTranslate&&0!==e){var a=!1;b.slides.transitionEnd(function(){if(!a&&b){a=!0,b.animating=!1;for(var e=["webkitTransitionEnd","transitionend","oTransitionEnd","MSTransitionEnd","msTransitionEnd"],t=0;t<e.length;t++)b.wrapper.trigger(e[t])}})}}},flip:{setTranslate:function(){for(var e=0;e<b.slides.length;e++){var t=b.slides.eq(e),i=t[0].progress;b.params.flip.limitRotation&&(i=Math.max(Math.min(t[0].progress,1),-1));var r=t[0].swiperSlideOffset,s=-180*i,n=s,o=0,l=-r,p=0;if(b.isHorizontal()?b.rtl&&(n=-n):(p=l,l=0,o=-n,n=0),t[0].style.zIndex=-Math.abs(Math.round(i))+b.slides.length,b.params.flip.slideShadows){var d=b.isHorizontal()?t.find(".swiper-slide-shadow-left"):t.find(".swiper-slide-shadow-top"),u=b.isHorizontal()?t.find(".swiper-slide-shadow-right"):t.find(".swiper-slide-shadow-bottom");0===d.length&&(d=a('<div class="swiper-slide-shadow-'+(b.isHorizontal()?"left":"top")+'"></div>'),t.append(d)),0===u.length&&(u=a('<div class="swiper-slide-shadow-'+(b.isHorizontal()?"right":"bottom")+'"></div>'),t.append(u)),d.length&&(d[0].style.opacity=Math.max(-i,0)),u.length&&(u[0].style.opacity=Math.max(i,0))}t.transform("translate3d("+l+"px, "+p+"px, 0px) rotateX("+o+"deg) rotateY("+n+"deg)")}},setTransition:function(e){if(b.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),b.params.virtualTranslate&&0!==e){var t=!1;b.slides.eq(b.activeIndex).transitionEnd(function(){if(!t&&b&&a(this).hasClass(b.params.slideActiveClass)){t=!0,b.animating=!1;for(var e=["webkitTransitionEnd","transitionend","oTransitionEnd","MSTransitionEnd","msTransitionEnd"],i=0;i<e.length;i++)b.wrapper.trigger(e[i])}})}}},cube:{setTranslate:function(){var e,t=0;b.params.cube.shadow&&(b.isHorizontal()?(e=b.wrapper.find(".swiper-cube-shadow"),0===e.length&&(e=a('<div class="swiper-cube-shadow"></div>'),b.wrapper.append(e)),e.css({height:b.width+"px"})):(e=b.container.find(".swiper-cube-shadow"),0===e.length&&(e=a('<div class="swiper-cube-shadow"></div>'),b.container.append(e))));for(var i=0;i<b.slides.length;i++){var r=b.slides.eq(i),s=90*i,n=Math.floor(s/360);b.rtl&&(s=-s,n=Math.floor(-s/360));var o=Math.max(Math.min(r[0].progress,1),-1),l=0,p=0,d=0;i%4===0?(l=4*-n*b.size,d=0):(i-1)%4===0?(l=0,d=4*-n*b.size):(i-2)%4===0?(l=b.size+4*n*b.size,d=b.size):(i-3)%4===0&&(l=-b.size,d=3*b.size+4*b.size*n),b.rtl&&(l=-l),b.isHorizontal()||(p=l,l=0);var u="rotateX("+(b.isHorizontal()?0:-s)+"deg) rotateY("+(b.isHorizontal()?s:0)+"deg) translate3d("+l+"px, "+p+"px, "+d+"px)";if(1>=o&&o>-1&&(t=90*i+90*o,b.rtl&&(t=90*-i-90*o)),r.transform(u),b.params.cube.slideShadows){var c=b.isHorizontal()?r.find(".swiper-slide-shadow-left"):r.find(".swiper-slide-shadow-top"),m=b.isHorizontal()?r.find(".swiper-slide-shadow-right"):r.find(".swiper-slide-shadow-bottom");0===c.length&&(c=a('<div class="swiper-slide-shadow-'+(b.isHorizontal()?"left":"top")+'"></div>'),r.append(c)),0===m.length&&(m=a('<div class="swiper-slide-shadow-'+(b.isHorizontal()?"right":"bottom")+'"></div>'),r.append(m)),c.length&&(c[0].style.opacity=Math.max(-o,0)),m.length&&(m[0].style.opacity=Math.max(o,0))}}if(b.wrapper.css({"-webkit-transform-origin":"50% 50% -"+b.size/2+"px","-moz-transform-origin":"50% 50% -"+b.size/2+"px","-ms-transform-origin":"50% 50% -"+b.size/2+"px","transform-origin":"50% 50% -"+b.size/2+"px"}),b.params.cube.shadow)if(b.isHorizontal())e.transform("translate3d(0px, "+(b.width/2+b.params.cube.shadowOffset)+"px, "+-b.width/2+"px) rotateX(90deg) rotateZ(0deg) scale("+b.params.cube.shadowScale+")");else{var f=Math.abs(t)-90*Math.floor(Math.abs(t)/90),h=1.5-(Math.sin(2*f*Math.PI/360)/2+Math.cos(2*f*Math.PI/360)/2),g=b.params.cube.shadowScale,v=b.params.cube.shadowScale/h,w=b.params.cube.shadowOffset;e.transform("scale3d("+g+", 1, "+v+") translate3d(0px, "+(b.height/2+w)+"px, "+-b.height/2/v+"px) rotateX(-90deg)")}var y=b.isSafari||b.isUiWebView?-b.size/2:0;b.wrapper.transform("translate3d(0px,0,"+y+"px) rotateX("+(b.isHorizontal()?0:t)+"deg) rotateY("+(b.isHorizontal()?-t:0)+"deg)")},setTransition:function(e){b.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),b.params.cube.shadow&&!b.isHorizontal()&&b.container.find(".swiper-cube-shadow").transition(e)}},coverflow:{setTranslate:function(){for(var e=b.translate,t=b.isHorizontal()?-e+b.width/2:-e+b.height/2,i=b.isHorizontal()?b.params.coverflow.rotate:-b.params.coverflow.rotate,r=b.params.coverflow.depth,s=0,n=b.slides.length;n>s;s++){var o=b.slides.eq(s),l=b.slidesSizesGrid[s],p=o[0].swiperSlideOffset,d=(t-p-l/2)/l*b.params.coverflow.modifier,u=b.isHorizontal()?i*d:0,c=b.isHorizontal()?0:i*d,m=-r*Math.abs(d),f=b.isHorizontal()?0:b.params.coverflow.stretch*d,h=b.isHorizontal()?b.params.coverflow.stretch*d:0;Math.abs(h)<.001&&(h=0),Math.abs(f)<.001&&(f=0),Math.abs(m)<.001&&(m=0),Math.abs(u)<.001&&(u=0),Math.abs(c)<.001&&(c=0);var g="translate3d("+h+"px,"+f+"px,"+m+"px)  rotateX("+c+"deg) rotateY("+u+"deg)";if(o.transform(g),o[0].style.zIndex=-Math.abs(Math.round(d))+1,b.params.coverflow.slideShadows){var v=b.isHorizontal()?o.find(".swiper-slide-shadow-left"):o.find(".swiper-slide-shadow-top"),w=b.isHorizontal()?o.find(".swiper-slide-shadow-right"):o.find(".swiper-slide-shadow-bottom");0===v.length&&(v=a('<div class="swiper-slide-shadow-'+(b.isHorizontal()?"left":"top")+'"></div>'),o.append(v)),0===w.length&&(w=a('<div class="swiper-slide-shadow-'+(b.isHorizontal()?"right":"bottom")+'"></div>'),o.append(w)),v.length&&(v[0].style.opacity=d>0?d:0),w.length&&(w[0].style.opacity=-d>0?-d:0)}}if(b.browser.ie){var y=b.wrapper[0].style;y.perspectiveOrigin=t+"px 50%"}},setTransition:function(e){b.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e)}}},b.lazy={initialImageLoaded:!1,loadImageInSlide:function(e,t){if("undefined"!=typeof e&&("undefined"==typeof t&&(t=!0),0!==b.slides.length)){var i=b.slides.eq(e),r=i.find(".swiper-lazy:not(.swiper-lazy-loaded):not(.swiper-lazy-loading)");!i.hasClass("swiper-lazy")||i.hasClass("swiper-lazy-loaded")||i.hasClass("swiper-lazy-loading")||(r=r.add(i[0])),0!==r.length&&r.each(function(){var e=a(this);e.addClass("swiper-lazy-loading");var r=e.attr("data-background"),s=e.attr("data-src"),n=e.attr("data-srcset");b.loadImage(e[0],s||r,n,!1,function(){if(r?(e.css("background-image","url("+r+")"),e.removeAttr("data-background")):(n&&(e.attr("srcset",n),e.removeAttr("data-srcset")),s&&(e.attr("src",s),e.removeAttr("data-src"))),e.addClass("swiper-lazy-loaded").removeClass("swiper-lazy-loading"),i.find(".swiper-lazy-preloader, .preloader").remove(),b.params.loop&&t){var a=i.attr("data-swiper-slide-index");if(i.hasClass(b.params.slideDuplicateClass)){var o=b.wrapper.children('[data-swiper-slide-index="'+a+'"]:not(.'+b.params.slideDuplicateClass+")");b.lazy.loadImageInSlide(o.index(),!1)}else{var l=b.wrapper.children("."+b.params.slideDuplicateClass+'[data-swiper-slide-index="'+a+'"]');b.lazy.loadImageInSlide(l.index(),!1)}}b.emit("onLazyImageReady",b,i[0],e[0])}),b.emit("onLazyImageLoad",b,i[0],e[0])})}},load:function(){var e;if(b.params.watchSlidesVisibility)b.wrapper.children("."+b.params.slideVisibleClass).each(function(){b.lazy.loadImageInSlide(a(this).index())});else if(b.params.slidesPerView>1)for(e=b.activeIndex;e<b.activeIndex+b.params.slidesPerView;e++)b.slides[e]&&b.lazy.loadImageInSlide(e);else b.lazy.loadImageInSlide(b.activeIndex);if(b.params.lazyLoadingInPrevNext)if(b.params.slidesPerView>1||b.params.lazyLoadingInPrevNextAmount&&b.params.lazyLoadingInPrevNextAmount>1){var t=b.params.lazyLoadingInPrevNextAmount,i=b.params.slidesPerView,r=Math.min(b.activeIndex+i+Math.max(t,i),b.slides.length),s=Math.max(b.activeIndex-Math.max(i,t),0);for(e=b.activeIndex+b.params.slidesPerView;r>e;e++)b.slides[e]&&b.lazy.loadImageInSlide(e);for(e=s;e<b.activeIndex;e++)b.slides[e]&&b.lazy.loadImageInSlide(e)}else{var n=b.wrapper.children("."+b.params.slideNextClass);n.length>0&&b.lazy.loadImageInSlide(n.index());var o=b.wrapper.children("."+b.params.slidePrevClass);o.length>0&&b.lazy.loadImageInSlide(o.index())}},onTransitionStart:function(){b.params.lazyLoading&&(b.params.lazyLoadingOnTransitionStart||!b.params.lazyLoadingOnTransitionStart&&!b.lazy.initialImageLoaded)&&b.lazy.load()},onTransitionEnd:function(){b.params.lazyLoading&&!b.params.lazyLoadingOnTransitionStart&&b.lazy.load()}},b.scrollbar={isTouched:!1,setDragPosition:function(e){var a=b.scrollbar,t=b.isHorizontal()?"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].pageX:e.pageX||e.clientX:"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].pageY:e.pageY||e.clientY,i=t-a.track.offset()[b.isHorizontal()?"left":"top"]-a.dragSize/2,r=-b.minTranslate()*a.moveDivider,s=-b.maxTranslate()*a.moveDivider;r>i?i=r:i>s&&(i=s),i=-i/a.moveDivider,b.updateProgress(i),b.setWrapperTranslate(i,!0)},dragStart:function(e){var a=b.scrollbar;a.isTouched=!0,e.preventDefault(),e.stopPropagation(),a.setDragPosition(e),clearTimeout(a.dragTimeout),a.track.transition(0),b.params.scrollbarHide&&a.track.css("opacity",1),b.wrapper.transition(100),a.drag.transition(100),b.emit("onScrollbarDragStart",b)},dragMove:function(e){var a=b.scrollbar;a.isTouched&&(e.preventDefault?e.preventDefault():e.returnValue=!1,a.setDragPosition(e),b.wrapper.transition(0),a.track.transition(0),a.drag.transition(0),b.emit("onScrollbarDragMove",b))},dragEnd:function(e){var a=b.scrollbar;a.isTouched&&(a.isTouched=!1,b.params.scrollbarHide&&(clearTimeout(a.dragTimeout),a.dragTimeout=setTimeout(function(){a.track.css("opacity",0),a.track.transition(400)},1e3)),b.emit("onScrollbarDragEnd",b),b.params.scrollbarSnapOnRelease&&b.slideReset())},enableDraggable:function(){var e=b.scrollbar,t=b.support.touch?e.track:document;a(e.track).on(b.touchEvents.start,e.dragStart),a(t).on(b.touchEvents.move,e.dragMove),a(t).on(b.touchEvents.end,e.dragEnd)},disableDraggable:function(){var e=b.scrollbar,t=b.support.touch?e.track:document;a(e.track).off(b.touchEvents.start,e.dragStart),a(t).off(b.touchEvents.move,e.dragMove),a(t).off(b.touchEvents.end,e.dragEnd)},set:function(){if(b.params.scrollbar){var e=b.scrollbar;e.track=a(b.params.scrollbar),e.drag=e.track.find(".swiper-scrollbar-drag"),0===e.drag.length&&(e.drag=a('<div class="swiper-scrollbar-drag"></div>'),e.track.append(e.drag)),e.drag[0].style.width="",e.drag[0].style.height="",e.trackSize=b.isHorizontal()?e.track[0].offsetWidth:e.track[0].offsetHeight,e.divider=b.size/b.virtualSize,e.moveDivider=e.divider*(e.trackSize/b.size),e.dragSize=e.trackSize*e.divider,b.isHorizontal()?e.drag[0].style.width=e.dragSize+"px":e.drag[0].style.height=e.dragSize+"px",e.divider>=1?e.track[0].style.display="none":e.track[0].style.display="",b.params.scrollbarHide&&(e.track[0].style.opacity=0)}},setTranslate:function(){if(b.params.scrollbar){var e,a=b.scrollbar,t=(b.translate||0,a.dragSize);e=(a.trackSize-a.dragSize)*b.progress,b.rtl&&b.isHorizontal()?(e=-e,e>0?(t=a.dragSize-e,e=0):-e+a.dragSize>a.trackSize&&(t=a.trackSize+e)):0>e?(t=a.dragSize+e,e=0):e+a.dragSize>a.trackSize&&(t=a.trackSize-e),b.isHorizontal()?(b.support.transforms3d?a.drag.transform("translate3d("+e+"px, 0, 0)"):a.drag.transform("translateX("+e+"px)"),a.drag[0].style.width=t+"px"):(b.support.transforms3d?a.drag.transform("translate3d(0px, "+e+"px, 0)"):a.drag.transform("translateY("+e+"px)"),a.drag[0].style.height=t+"px"),b.params.scrollbarHide&&(clearTimeout(a.timeout),a.track[0].style.opacity=1,a.timeout=setTimeout(function(){a.track[0].style.opacity=0,a.track.transition(400)},1e3))}},setTransition:function(e){b.params.scrollbar&&b.scrollbar.drag.transition(e)}},b.controller={LinearSpline:function(e,a){this.x=e,this.y=a,this.lastIndex=e.length-1;var t,i;this.x.length;this.interpolate=function(e){return e?(i=r(this.x,e),t=i-1,(e-this.x[t])*(this.y[i]-this.y[t])/(this.x[i]-this.x[t])+this.y[t]):0};var r=function(){var e,a,t;return function(i,r){for(a=-1,e=i.length;e-a>1;)i[t=e+a>>1]<=r?a=t:e=t;return e}}()},getInterpolateFunction:function(e){b.controller.spline||(b.controller.spline=b.params.loop?new b.controller.LinearSpline(b.slidesGrid,e.slidesGrid):new b.controller.LinearSpline(b.snapGrid,e.snapGrid))},setTranslate:function(e,a){function i(a){e=a.rtl&&"horizontal"===a.params.direction?-b.translate:b.translate,"slide"===b.params.controlBy&&(b.controller.getInterpolateFunction(a),s=-b.controller.spline.interpolate(-e)),s&&"container"!==b.params.controlBy||(r=(a.maxTranslate()-a.minTranslate())/(b.maxTranslate()-b.minTranslate()),s=(e-b.minTranslate())*r+a.minTranslate()),b.params.controlInverse&&(s=a.maxTranslate()-s),a.updateProgress(s),a.setWrapperTranslate(s,!1,b),a.updateActiveIndex()}var r,s,n=b.params.control;if(b.isArray(n))for(var o=0;o<n.length;o++)n[o]!==a&&n[o]instanceof t&&i(n[o]);else n instanceof t&&a!==n&&i(n)},setTransition:function(e,a){function i(a){a.setWrapperTransition(e,b),0!==e&&(a.onTransitionStart(),a.wrapper.transitionEnd(function(){s&&(a.params.loop&&"slide"===b.params.controlBy&&a.fixLoop(),a.onTransitionEnd())}))}var r,s=b.params.control;if(b.isArray(s))for(r=0;r<s.length;r++)s[r]!==a&&s[r]instanceof t&&i(s[r]);else s instanceof t&&a!==s&&i(s)}},b.hashnav={init:function(){if(b.params.hashnav){b.hashnav.initialized=!0;var e=document.location.hash.replace("#","");if(e)for(var a=0,t=0,i=b.slides.length;i>t;t++){var r=b.slides.eq(t),s=r.attr("data-hash");if(s===e&&!r.hasClass(b.params.slideDuplicateClass)){var n=r.index();b.slideTo(n,a,b.params.runCallbacksOnInit,!0)}}}},setHash:function(){b.hashnav.initialized&&b.params.hashnav&&(document.location.hash=b.slides.eq(b.activeIndex).attr("data-hash")||"")}},b.disableKeyboardControl=function(){b.params.keyboardControl=!1,a(document).off("keydown",p)},b.enableKeyboardControl=function(){b.params.keyboardControl=!0,a(document).on("keydown",p)},b.mousewheel={event:!1,lastScrollTime:(new window.Date).getTime()},b.params.mousewheelControl){try{new window.WheelEvent("wheel"),b.mousewheel.event="wheel"}catch(O){}b.mousewheel.event||void 0===document.onmousewheel||(b.mousewheel.event="mousewheel"),b.mousewheel.event||(b.mousewheel.event="DOMMouseScroll")}b.disableMousewheelControl=function(){return b.mousewheel.event?(b.container.off(b.mousewheel.event,d),!0):!1},b.enableMousewheelControl=function(){return b.mousewheel.event?(b.container.on(b.mousewheel.event,d),!0):!1},b.parallax={setTranslate:function(){b.container.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(){u(this,b.progress)}),b.slides.each(function(){var e=a(this);e.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(){var a=Math.min(Math.max(e[0].progress,-1),1);u(this,a)})})},setTransition:function(e){"undefined"==typeof e&&(e=b.params.speed),b.container.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(){var t=a(this),i=parseInt(t.attr("data-swiper-parallax-duration"),10)||e;0===e&&(i=0),t.transition(i)})}},b._plugins=[];for(var N in b.plugins){var R=b.plugins[N](b,b.params[N]);R&&b._plugins.push(R)}return b.callPlugins=function(e){for(var a=0;a<b._plugins.length;a++)e in b._plugins[a]&&b._plugins[a][e](arguments[1],arguments[2],arguments[3],arguments[4],arguments[5])},b.emitterEventListeners={},b.emit=function(e){b.params[e]&&b.params[e](arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]);var a;if(b.emitterEventListeners[e])for(a=0;a<b.emitterEventListeners[e].length;a++)b.emitterEventListeners[e][a](arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]);b.callPlugins&&b.callPlugins(e,arguments[1],arguments[2],arguments[3],arguments[4],arguments[5])},b.on=function(e,a){return e=c(e),b.emitterEventListeners[e]||(b.emitterEventListeners[e]=[]),b.emitterEventListeners[e].push(a),b},b.off=function(e,a){var t;if(e=c(e),"undefined"==typeof a)return b.emitterEventListeners[e]=[],b;if(b.emitterEventListeners[e]&&0!==b.emitterEventListeners[e].length){for(t=0;t<b.emitterEventListeners[e].length;t++)b.emitterEventListeners[e][t]===a&&b.emitterEventListeners[e].splice(t,1);return b}},b.once=function(e,a){e=c(e);var t=function(){a(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4]),b.off(e,t)};return b.on(e,t),b},b.a11y={makeFocusable:function(e){return e.attr("tabIndex","0"),e},addRole:function(e,a){return e.attr("role",a),e},addLabel:function(e,a){return e.attr("aria-label",a),e},disable:function(e){return e.attr("aria-disabled",!0),e},enable:function(e){return e.attr("aria-disabled",!1),e},onEnterKey:function(e){13===e.keyCode&&(a(e.target).is(b.params.nextButton)?(b.onClickNext(e),b.isEnd?b.a11y.notify(b.params.lastSlideMessage):b.a11y.notify(b.params.nextSlideMessage)):a(e.target).is(b.params.prevButton)&&(b.onClickPrev(e),b.isBeginning?b.a11y.notify(b.params.firstSlideMessage):b.a11y.notify(b.params.prevSlideMessage)),a(e.target).is("."+b.params.bulletClass)&&a(e.target)[0].click())},liveRegion:a('<span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>'),notify:function(e){var a=b.a11y.liveRegion;0!==a.length&&(a.html(""),a.html(e))},init:function(){if(b.params.nextButton){var e=a(b.params.nextButton);b.a11y.makeFocusable(e),b.a11y.addRole(e,"button"),b.a11y.addLabel(e,b.params.nextSlideMessage)}if(b.params.prevButton){var t=a(b.params.prevButton);b.a11y.makeFocusable(t),b.a11y.addRole(t,"button"),b.a11y.addLabel(t,b.params.prevSlideMessage)}a(b.container).append(b.a11y.liveRegion)},initPagination:function(){b.params.pagination&&b.params.paginationClickable&&b.bullets&&b.bullets.length&&b.bullets.each(function(){var e=a(this);b.a11y.makeFocusable(e),b.a11y.addRole(e,"button"),b.a11y.addLabel(e,b.params.paginationBulletMessage.replace(/{{index}}/,e.index()+1))})},destroy:function(){b.a11y.liveRegion&&b.a11y.liveRegion.length>0&&b.a11y.liveRegion.remove()}},b.init=function(){b.params.loop&&b.createLoop(),b.updateContainerSize(),b.updateSlidesSize(),b.updatePagination(),b.params.scrollbar&&b.scrollbar&&(b.scrollbar.set(),b.params.scrollbarDraggable&&b.scrollbar.enableDraggable()),"slide"!==b.params.effect&&b.effects[b.params.effect]&&(b.params.loop||b.updateProgress(),b.effects[b.params.effect].setTranslate()),b.params.loop?b.slideTo(b.params.initialSlide+b.loopedSlides,0,b.params.runCallbacksOnInit):(b.slideTo(b.params.initialSlide,0,b.params.runCallbacksOnInit),0===b.params.initialSlide&&(b.parallax&&b.params.parallax&&b.parallax.setTranslate(),b.lazy&&b.params.lazyLoading&&(b.lazy.load(),b.lazy.initialImageLoaded=!0))),b.attachEvents(),b.params.observer&&b.support.observer&&b.initObservers(),b.params.preloadImages&&!b.params.lazyLoading&&b.preloadImages(),b.params.autoplay&&b.startAutoplay(),b.params.keyboardControl&&b.enableKeyboardControl&&b.enableKeyboardControl(),b.params.mousewheelControl&&b.enableMousewheelControl&&b.enableMousewheelControl(),b.params.hashnav&&b.hashnav&&b.hashnav.init(),b.params.a11y&&b.a11y&&b.a11y.init(),b.emit("onInit",b)},b.cleanupStyles=function(){b.container.removeClass(b.classNames.join(" ")).removeAttr("style"),b.wrapper.removeAttr("style"),b.slides&&b.slides.length&&b.slides.removeClass([b.params.slideVisibleClass,b.params.slideActiveClass,b.params.slideNextClass,b.params.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-column").removeAttr("data-swiper-row"),b.paginationContainer&&b.paginationContainer.length&&b.paginationContainer.removeClass(b.params.paginationHiddenClass),b.bullets&&b.bullets.length&&b.bullets.removeClass(b.params.bulletActiveClass),b.params.prevButton&&a(b.params.prevButton).removeClass(b.params.buttonDisabledClass),b.params.nextButton&&a(b.params.nextButton).removeClass(b.params.buttonDisabledClass),b.params.scrollbar&&b.scrollbar&&(b.scrollbar.track&&b.scrollbar.track.length&&b.scrollbar.track.removeAttr("style"),b.scrollbar.drag&&b.scrollbar.drag.length&&b.scrollbar.drag.removeAttr("style"))},b.destroy=function(e,a){b.detachEvents(),b.stopAutoplay(),b.params.scrollbar&&b.scrollbar&&b.params.scrollbarDraggable&&b.scrollbar.disableDraggable(),b.params.loop&&b.destroyLoop(),a&&b.cleanupStyles(),b.disconnectObservers(),b.params.keyboardControl&&b.disableKeyboardControl&&b.disableKeyboardControl(),b.params.mousewheelControl&&b.disableMousewheelControl&&b.disableMousewheelControl(),b.params.a11y&&b.a11y&&b.a11y.destroy(),b.emit("onDestroy"),e!==!1&&(b=null)},b.init(),b}};t.prototype={isSafari:function(){var e=navigator.userAgent.toLowerCase();return e.indexOf("safari")>=0&&e.indexOf("chrome")<0&&e.indexOf("android")<0}(),isUiWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent),isArray:function(e){return"[object Array]"===Object.prototype.toString.apply(e)},browser:{ie:window.navigator.pointerEnabled||window.navigator.msPointerEnabled,
ieTouch:window.navigator.msPointerEnabled&&window.navigator.msMaxTouchPoints>1||window.navigator.pointerEnabled&&window.navigator.maxTouchPoints>1},device:function(){var e=navigator.userAgent,a=e.match(/(Android);?[\s\/]+([\d.]+)?/),t=e.match(/(iPad).*OS\s([\d_]+)/),i=e.match(/(iPod)(.*OS\s([\d_]+))?/),r=!t&&e.match(/(iPhone\sOS)\s([\d_]+)/);return{ios:t||r||i,android:a}}(),support:{touch:window.Modernizr&&Modernizr.touch===!0||function(){return!!("ontouchstart"in window||window.DocumentTouch&&document instanceof DocumentTouch)}(),transforms3d:window.Modernizr&&Modernizr.csstransforms3d===!0||function(){var e=document.createElement("div").style;return"webkitPerspective"in e||"MozPerspective"in e||"OPerspective"in e||"MsPerspective"in e||"perspective"in e}(),flexbox:function(){for(var e=document.createElement("div").style,a="alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "),t=0;t<a.length;t++)if(a[t]in e)return!0}(),observer:function(){return"MutationObserver"in window||"WebkitMutationObserver"in window}()},plugins:{}};for(var i=(function(){var e=function(e){var a=this,t=0;for(t=0;t<e.length;t++)a[t]=e[t];return a.length=e.length,this},a=function(a,t){var i=[],r=0;if(a&&!t&&a instanceof e)return a;if(a)if("string"==typeof a){var s,n,o=a.trim();if(o.indexOf("<")>=0&&o.indexOf(">")>=0){var l="div";for(0===o.indexOf("<li")&&(l="ul"),0===o.indexOf("<tr")&&(l="tbody"),(0===o.indexOf("<td")||0===o.indexOf("<th"))&&(l="tr"),0===o.indexOf("<tbody")&&(l="table"),0===o.indexOf("<option")&&(l="select"),n=document.createElement(l),n.innerHTML=a,r=0;r<n.childNodes.length;r++)i.push(n.childNodes[r])}else for(s=t||"#"!==a[0]||a.match(/[ .<>:~]/)?(t||document).querySelectorAll(a):[document.getElementById(a.split("#")[1])],r=0;r<s.length;r++)s[r]&&i.push(s[r])}else if(a.nodeType||a===window||a===document)i.push(a);else if(a.length>0&&a[0].nodeType)for(r=0;r<a.length;r++)i.push(a[r]);return new e(i)};return e.prototype={addClass:function(e){if("undefined"==typeof e)return this;for(var a=e.split(" "),t=0;t<a.length;t++)for(var i=0;i<this.length;i++)this[i].classList.add(a[t]);return this},removeClass:function(e){for(var a=e.split(" "),t=0;t<a.length;t++)for(var i=0;i<this.length;i++)this[i].classList.remove(a[t]);return this},hasClass:function(e){return this[0]?this[0].classList.contains(e):!1},toggleClass:function(e){for(var a=e.split(" "),t=0;t<a.length;t++)for(var i=0;i<this.length;i++)this[i].classList.toggle(a[t]);return this},attr:function(e,a){if(1===arguments.length&&"string"==typeof e)return this[0]?this[0].getAttribute(e):void 0;for(var t=0;t<this.length;t++)if(2===arguments.length)this[t].setAttribute(e,a);else for(var i in e)this[t][i]=e[i],this[t].setAttribute(i,e[i]);return this},removeAttr:function(e){for(var a=0;a<this.length;a++)this[a].removeAttribute(e);return this},data:function(e,a){if("undefined"!=typeof a){for(var t=0;t<this.length;t++){var i=this[t];i.dom7ElementDataStorage||(i.dom7ElementDataStorage={}),i.dom7ElementDataStorage[e]=a}return this}if(this[0]){var r=this[0].getAttribute("data-"+e);return r?r:this[0].dom7ElementDataStorage&&e in this[0].dom7ElementDataStorage?this[0].dom7ElementDataStorage[e]:void 0}},transform:function(e){for(var a=0;a<this.length;a++){var t=this[a].style;t.webkitTransform=t.MsTransform=t.msTransform=t.MozTransform=t.OTransform=t.transform=e}return this},transition:function(e){"string"!=typeof e&&(e+="ms");for(var a=0;a<this.length;a++){var t=this[a].style;t.webkitTransitionDuration=t.MsTransitionDuration=t.msTransitionDuration=t.MozTransitionDuration=t.OTransitionDuration=t.transitionDuration=e}return this},on:function(e,t,i,r){function s(e){var r=e.target;if(a(r).is(t))i.call(r,e);else for(var s=a(r).parents(),n=0;n<s.length;n++)a(s[n]).is(t)&&i.call(s[n],e)}var n,o,l=e.split(" ");for(n=0;n<this.length;n++)if("function"==typeof t||t===!1)for("function"==typeof t&&(i=arguments[1],r=arguments[2]||!1),o=0;o<l.length;o++)this[n].addEventListener(l[o],i,r);else for(o=0;o<l.length;o++)this[n].dom7LiveListeners||(this[n].dom7LiveListeners=[]),this[n].dom7LiveListeners.push({listener:i,liveListener:s}),this[n].addEventListener(l[o],s,r);return this},off:function(e,a,t,i){for(var r=e.split(" "),s=0;s<r.length;s++)for(var n=0;n<this.length;n++)if("function"==typeof a||a===!1)"function"==typeof a&&(t=arguments[1],i=arguments[2]||!1),this[n].removeEventListener(r[s],t,i);else if(this[n].dom7LiveListeners)for(var o=0;o<this[n].dom7LiveListeners.length;o++)this[n].dom7LiveListeners[o].listener===t&&this[n].removeEventListener(r[s],this[n].dom7LiveListeners[o].liveListener,i);return this},once:function(e,a,t,i){function r(n){t(n),s.off(e,a,r,i)}var s=this;"function"==typeof a&&(a=!1,t=arguments[1],i=arguments[2]),s.on(e,a,r,i)},trigger:function(e,a){for(var t=0;t<this.length;t++){var i;try{i=new window.CustomEvent(e,{detail:a,bubbles:!0,cancelable:!0})}catch(r){i=document.createEvent("Event"),i.initEvent(e,!0,!0),i.detail=a}this[t].dispatchEvent(i)}return this},transitionEnd:function(e){function a(s){if(s.target===this)for(e.call(this,s),t=0;t<i.length;t++)r.off(i[t],a)}var t,i=["webkitTransitionEnd","transitionend","oTransitionEnd","MSTransitionEnd","msTransitionEnd"],r=this;if(e)for(t=0;t<i.length;t++)r.on(i[t],a);return this},width:function(){return this[0]===window?window.innerWidth:this.length>0?parseFloat(this.css("width")):null},outerWidth:function(e){return this.length>0?e?this[0].offsetWidth+parseFloat(this.css("margin-right"))+parseFloat(this.css("margin-left")):this[0].offsetWidth:null},height:function(){return this[0]===window?window.innerHeight:this.length>0?parseFloat(this.css("height")):null},outerHeight:function(e){return this.length>0?e?this[0].offsetHeight+parseFloat(this.css("margin-top"))+parseFloat(this.css("margin-bottom")):this[0].offsetHeight:null},offset:function(){if(this.length>0){var e=this[0],a=e.getBoundingClientRect(),t=document.body,i=e.clientTop||t.clientTop||0,r=e.clientLeft||t.clientLeft||0,s=window.pageYOffset||e.scrollTop,n=window.pageXOffset||e.scrollLeft;return{top:a.top+s-i,left:a.left+n-r}}return null},css:function(e,a){var t;if(1===arguments.length){if("string"!=typeof e){for(t=0;t<this.length;t++)for(var i in e)this[t].style[i]=e[i];return this}if(this[0])return window.getComputedStyle(this[0],null).getPropertyValue(e)}if(2===arguments.length&&"string"==typeof e){for(t=0;t<this.length;t++)this[t].style[e]=a;return this}return this},each:function(e){for(var a=0;a<this.length;a++)e.call(this[a],a,this[a]);return this},html:function(e){if("undefined"==typeof e)return this[0]?this[0].innerHTML:void 0;for(var a=0;a<this.length;a++)this[a].innerHTML=e;return this},text:function(e){if("undefined"==typeof e)return this[0]?this[0].textContent.trim():null;for(var a=0;a<this.length;a++)this[a].textContent=e;return this},is:function(t){if(!this[0])return!1;var i,r;if("string"==typeof t){var s=this[0];if(s===document)return t===document;if(s===window)return t===window;if(s.matches)return s.matches(t);if(s.webkitMatchesSelector)return s.webkitMatchesSelector(t);if(s.mozMatchesSelector)return s.mozMatchesSelector(t);if(s.msMatchesSelector)return s.msMatchesSelector(t);for(i=a(t),r=0;r<i.length;r++)if(i[r]===this[0])return!0;return!1}if(t===document)return this[0]===document;if(t===window)return this[0]===window;if(t.nodeType||t instanceof e){for(i=t.nodeType?[t]:t,r=0;r<i.length;r++)if(i[r]===this[0])return!0;return!1}return!1},index:function(){if(this[0]){for(var e=this[0],a=0;null!==(e=e.previousSibling);)1===e.nodeType&&a++;return a}},eq:function(a){if("undefined"==typeof a)return this;var t,i=this.length;return a>i-1?new e([]):0>a?(t=i+a,new e(0>t?[]:[this[t]])):new e([this[a]])},append:function(a){var t,i;for(t=0;t<this.length;t++)if("string"==typeof a){var r=document.createElement("div");for(r.innerHTML=a;r.firstChild;)this[t].appendChild(r.firstChild)}else if(a instanceof e)for(i=0;i<a.length;i++)this[t].appendChild(a[i]);else this[t].appendChild(a);return this},prepend:function(a){var t,i;for(t=0;t<this.length;t++)if("string"==typeof a){var r=document.createElement("div");for(r.innerHTML=a,i=r.childNodes.length-1;i>=0;i--)this[t].insertBefore(r.childNodes[i],this[t].childNodes[0])}else if(a instanceof e)for(i=0;i<a.length;i++)this[t].insertBefore(a[i],this[t].childNodes[0]);else this[t].insertBefore(a,this[t].childNodes[0]);return this},insertBefore:function(e){for(var t=a(e),i=0;i<this.length;i++)if(1===t.length)t[0].parentNode.insertBefore(this[i],t[0]);else if(t.length>1)for(var r=0;r<t.length;r++)t[r].parentNode.insertBefore(this[i].cloneNode(!0),t[r])},insertAfter:function(e){for(var t=a(e),i=0;i<this.length;i++)if(1===t.length)t[0].parentNode.insertBefore(this[i],t[0].nextSibling);else if(t.length>1)for(var r=0;r<t.length;r++)t[r].parentNode.insertBefore(this[i].cloneNode(!0),t[r].nextSibling)},next:function(t){return new e(this.length>0?t?this[0].nextElementSibling&&a(this[0].nextElementSibling).is(t)?[this[0].nextElementSibling]:[]:this[0].nextElementSibling?[this[0].nextElementSibling]:[]:[])},nextAll:function(t){var i=[],r=this[0];if(!r)return new e([]);for(;r.nextElementSibling;){var s=r.nextElementSibling;t?a(s).is(t)&&i.push(s):i.push(s),r=s}return new e(i)},prev:function(t){return new e(this.length>0?t?this[0].previousElementSibling&&a(this[0].previousElementSibling).is(t)?[this[0].previousElementSibling]:[]:this[0].previousElementSibling?[this[0].previousElementSibling]:[]:[])},prevAll:function(t){var i=[],r=this[0];if(!r)return new e([]);for(;r.previousElementSibling;){var s=r.previousElementSibling;t?a(s).is(t)&&i.push(s):i.push(s),r=s}return new e(i)},parent:function(e){for(var t=[],i=0;i<this.length;i++)e?a(this[i].parentNode).is(e)&&t.push(this[i].parentNode):t.push(this[i].parentNode);return a(a.unique(t))},parents:function(e){for(var t=[],i=0;i<this.length;i++)for(var r=this[i].parentNode;r;)e?a(r).is(e)&&t.push(r):t.push(r),r=r.parentNode;return a(a.unique(t))},find:function(a){for(var t=[],i=0;i<this.length;i++)for(var r=this[i].querySelectorAll(a),s=0;s<r.length;s++)t.push(r[s]);return new e(t)},children:function(t){for(var i=[],r=0;r<this.length;r++)for(var s=this[r].childNodes,n=0;n<s.length;n++)t?1===s[n].nodeType&&a(s[n]).is(t)&&i.push(s[n]):1===s[n].nodeType&&i.push(s[n]);return new e(a.unique(i))},remove:function(){for(var e=0;e<this.length;e++)this[e].parentNode&&this[e].parentNode.removeChild(this[e]);return this},add:function(){var e,t,i=this;for(e=0;e<arguments.length;e++){var r=a(arguments[e]);for(t=0;t<r.length;t++)i[i.length]=r[t],i.length++}return i}},a.fn=e.prototype,a.unique=function(e){for(var a=[],t=0;t<e.length;t++)-1===a.indexOf(e[t])&&a.push(e[t]);return a},a}()),r=["jQuery","Zepto","Dom7"],s=0;s<r.length;s++)window[r[s]]&&e(window[r[s]]);var n;n="undefined"==typeof i?window.Dom7||window.Zepto||window.jQuery:i,n&&("transitionEnd"in n.fn||(n.fn.transitionEnd=function(e){function a(s){if(s.target===this)for(e.call(this,s),t=0;t<i.length;t++)r.off(i[t],a)}var t,i=["webkitTransitionEnd","transitionend","oTransitionEnd","MSTransitionEnd","msTransitionEnd"],r=this;if(e)for(t=0;t<i.length;t++)r.on(i[t],a);return this}),"transform"in n.fn||(n.fn.transform=function(e){for(var a=0;a<this.length;a++){var t=this[a].style;t.webkitTransform=t.MsTransform=t.msTransform=t.MozTransform=t.OTransform=t.transform=e}return this}),"transition"in n.fn||(n.fn.transition=function(e){"string"!=typeof e&&(e+="ms");for(var a=0;a<this.length;a++){var t=this[a].style;t.webkitTransitionDuration=t.MsTransitionDuration=t.msTransitionDuration=t.MozTransitionDuration=t.OTransitionDuration=t.transitionDuration=e}return this})),window.Swiper=t}(),"undefined"!=typeof module?module.exports=window.Swiper:"function"==typeof define&&define.amd&&define('swiper',[],function(){"use strict";return window.Swiper});
//# sourceMappingURL=maps/swiper.min.js.map
;
/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
(function() {
  'use strict'

  var keyCounter = 0
  var allWaypoints = {}

  /* http://imakewebthings.com/waypoints/api/waypoint */
  function Waypoint(options) {
    if (!options) {
      throw new Error('No options passed to Waypoint constructor')
    }
    if (!options.element) {
      throw new Error('No element option passed to Waypoint constructor')
    }
    if (!options.handler) {
      throw new Error('No handler option passed to Waypoint constructor')
    }

    this.key = 'waypoint-' + keyCounter
    this.options = Waypoint.Adapter.extend({}, Waypoint.defaults, options)
    this.element = this.options.element
    this.adapter = new Waypoint.Adapter(this.element)
    this.callback = options.handler
    this.axis = this.options.horizontal ? 'horizontal' : 'vertical'
    this.enabled = this.options.enabled
    this.triggerPoint = null
    this.group = Waypoint.Group.findOrCreate({
      name: this.options.group,
      axis: this.axis
    })
    this.context = Waypoint.Context.findOrCreateByElement(this.options.context)

    if (Waypoint.offsetAliases[this.options.offset]) {
      this.options.offset = Waypoint.offsetAliases[this.options.offset]
    }
    this.group.add(this)
    this.context.add(this)
    allWaypoints[this.key] = this
    keyCounter += 1
  }

  /* Private */
  Waypoint.prototype.queueTrigger = function(direction) {
    this.group.queueTrigger(this, direction)
  }

  /* Private */
  Waypoint.prototype.trigger = function(args) {
    if (!this.enabled) {
      return
    }
    if (this.callback) {
      this.callback.apply(this, args)
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/destroy */
  Waypoint.prototype.destroy = function() {
    this.context.remove(this)
    this.group.remove(this)
    delete allWaypoints[this.key]
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/disable */
  Waypoint.prototype.disable = function() {
    this.enabled = false
    return this
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/enable */
  Waypoint.prototype.enable = function() {
    this.context.refresh()
    this.enabled = true
    return this
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/next */
  Waypoint.prototype.next = function() {
    return this.group.next(this)
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/previous */
  Waypoint.prototype.previous = function() {
    return this.group.previous(this)
  }

  /* Private */
  Waypoint.invokeAll = function(method) {
    var allWaypointsArray = []
    for (var waypointKey in allWaypoints) {
      allWaypointsArray.push(allWaypoints[waypointKey])
    }
    for (var i = 0, end = allWaypointsArray.length; i < end; i++) {
      allWaypointsArray[i][method]()
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/destroy-all */
  Waypoint.destroyAll = function() {
    Waypoint.invokeAll('destroy')
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/disable-all */
  Waypoint.disableAll = function() {
    Waypoint.invokeAll('disable')
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/enable-all */
  Waypoint.enableAll = function() {
    Waypoint.Context.refreshAll()
    for (var waypointKey in allWaypoints) {
      allWaypoints[waypointKey].enabled = true
    }
    return this
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/refresh-all */
  Waypoint.refreshAll = function() {
    Waypoint.Context.refreshAll()
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/viewport-height */
  Waypoint.viewportHeight = function() {
    return window.innerHeight || document.documentElement.clientHeight
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/viewport-width */
  Waypoint.viewportWidth = function() {
    return document.documentElement.clientWidth
  }

  Waypoint.adapters = []

  Waypoint.defaults = {
    context: window,
    continuous: true,
    enabled: true,
    group: 'default',
    horizontal: false,
    offset: 0
  }

  Waypoint.offsetAliases = {
    'bottom-in-view': function() {
      return this.context.innerHeight() - this.adapter.outerHeight()
    },
    'right-in-view': function() {
      return this.context.innerWidth() - this.adapter.outerWidth()
    }
  }

  window.Waypoint = Waypoint
}())
;(function() {
  'use strict'

  function requestAnimationFrameShim(callback) {
    window.setTimeout(callback, 1000 / 60)
  }

  var keyCounter = 0
  var contexts = {}
  var Waypoint = window.Waypoint
  var oldWindowLoad = window.onload

  /* http://imakewebthings.com/waypoints/api/context */
  function Context(element) {
    this.element = element
    this.Adapter = Waypoint.Adapter
    this.adapter = new this.Adapter(element)
    this.key = 'waypoint-context-' + keyCounter
    this.didScroll = false
    this.didResize = false
    this.oldScroll = {
      x: this.adapter.scrollLeft(),
      y: this.adapter.scrollTop()
    }
    this.waypoints = {
      vertical: {},
      horizontal: {}
    }

    element.waypointContextKey = this.key
    contexts[element.waypointContextKey] = this
    keyCounter += 1
    if (!Waypoint.windowContext) {
      Waypoint.windowContext = true
      Waypoint.windowContext = new Context(window)
    }

    this.createThrottledScrollHandler()
    this.createThrottledResizeHandler()
  }

  /* Private */
  Context.prototype.add = function(waypoint) {
    var axis = waypoint.options.horizontal ? 'horizontal' : 'vertical'
    this.waypoints[axis][waypoint.key] = waypoint
    this.refresh()
  }

  /* Private */
  Context.prototype.checkEmpty = function() {
    var horizontalEmpty = this.Adapter.isEmptyObject(this.waypoints.horizontal)
    var verticalEmpty = this.Adapter.isEmptyObject(this.waypoints.vertical)
    var isWindow = this.element == this.element.window
    if (horizontalEmpty && verticalEmpty && !isWindow) {
      this.adapter.off('.waypoints')
      delete contexts[this.key]
    }
  }

  /* Private */
  Context.prototype.createThrottledResizeHandler = function() {
    var self = this

    function resizeHandler() {
      self.handleResize()
      self.didResize = false
    }

    this.adapter.on('resize.waypoints', function() {
      if (!self.didResize) {
        self.didResize = true
        Waypoint.requestAnimationFrame(resizeHandler)
      }
    })
  }

  /* Private */
  Context.prototype.createThrottledScrollHandler = function() {
    var self = this
    function scrollHandler() {
      self.handleScroll()
      self.didScroll = false
    }

    this.adapter.on('scroll.waypoints', function() {
      if (!self.didScroll || Waypoint.isTouch) {
        self.didScroll = true
        Waypoint.requestAnimationFrame(scrollHandler)
      }
    })
  }

  /* Private */
  Context.prototype.handleResize = function() {
    Waypoint.Context.refreshAll()
  }

  /* Private */
  Context.prototype.handleScroll = function() {
    var triggeredGroups = {}
    var axes = {
      horizontal: {
        newScroll: this.adapter.scrollLeft(),
        oldScroll: this.oldScroll.x,
        forward: 'right',
        backward: 'left'
      },
      vertical: {
        newScroll: this.adapter.scrollTop(),
        oldScroll: this.oldScroll.y,
        forward: 'down',
        backward: 'up'
      }
    }

    for (var axisKey in axes) {
      var axis = axes[axisKey]
      var isForward = axis.newScroll > axis.oldScroll
      var direction = isForward ? axis.forward : axis.backward

      for (var waypointKey in this.waypoints[axisKey]) {
        var waypoint = this.waypoints[axisKey][waypointKey]
        if (waypoint.triggerPoint === null) {
          continue
        }
        var wasBeforeTriggerPoint = axis.oldScroll < waypoint.triggerPoint
        var nowAfterTriggerPoint = axis.newScroll >= waypoint.triggerPoint
        var crossedForward = wasBeforeTriggerPoint && nowAfterTriggerPoint
        var crossedBackward = !wasBeforeTriggerPoint && !nowAfterTriggerPoint
        if (crossedForward || crossedBackward) {
          waypoint.queueTrigger(direction)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
      }
    }

    for (var groupKey in triggeredGroups) {
      triggeredGroups[groupKey].flushTriggers()
    }

    this.oldScroll = {
      x: axes.horizontal.newScroll,
      y: axes.vertical.newScroll
    }
  }

  /* Private */
  Context.prototype.innerHeight = function() {
    /*eslint-disable eqeqeq */
    if (this.element == this.element.window) {
      return Waypoint.viewportHeight()
    }
    /*eslint-enable eqeqeq */
    return this.adapter.innerHeight()
  }

  /* Private */
  Context.prototype.remove = function(waypoint) {
    delete this.waypoints[waypoint.axis][waypoint.key]
    this.checkEmpty()
  }

  /* Private */
  Context.prototype.innerWidth = function() {
    /*eslint-disable eqeqeq */
    if (this.element == this.element.window) {
      return Waypoint.viewportWidth()
    }
    /*eslint-enable eqeqeq */
    return this.adapter.innerWidth()
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-destroy */
  Context.prototype.destroy = function() {
    var allWaypoints = []
    for (var axis in this.waypoints) {
      for (var waypointKey in this.waypoints[axis]) {
        allWaypoints.push(this.waypoints[axis][waypointKey])
      }
    }
    for (var i = 0, end = allWaypoints.length; i < end; i++) {
      allWaypoints[i].destroy()
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-refresh */
  Context.prototype.refresh = function() {
    /*eslint-disable eqeqeq */
    var isWindow = this.element == this.element.window
    /*eslint-enable eqeqeq */
    var contextOffset = isWindow ? undefined : this.adapter.offset()
    var triggeredGroups = {}
    var axes

    this.handleScroll()
    axes = {
      horizontal: {
        contextOffset: isWindow ? 0 : contextOffset.left,
        contextScroll: isWindow ? 0 : this.oldScroll.x,
        contextDimension: this.innerWidth(),
        oldScroll: this.oldScroll.x,
        forward: 'right',
        backward: 'left',
        offsetProp: 'left'
      },
      vertical: {
        contextOffset: isWindow ? 0 : contextOffset.top,
        contextScroll: isWindow ? 0 : this.oldScroll.y,
        contextDimension: this.innerHeight(),
        oldScroll: this.oldScroll.y,
        forward: 'down',
        backward: 'up',
        offsetProp: 'top'
      }
    }

    for (var axisKey in axes) {
      var axis = axes[axisKey]
      for (var waypointKey in this.waypoints[axisKey]) {
        var waypoint = this.waypoints[axisKey][waypointKey]
        var adjustment = waypoint.options.offset
        var oldTriggerPoint = waypoint.triggerPoint
        var elementOffset = 0
        var freshWaypoint = oldTriggerPoint == null
        var contextModifier, wasBeforeScroll, nowAfterScroll
        var triggeredBackward, triggeredForward

        if (waypoint.element !== waypoint.element.window) {
          elementOffset = waypoint.adapter.offset()[axis.offsetProp]
        }

        if (typeof adjustment === 'function') {
          adjustment = adjustment.apply(waypoint)
        }
        else if (typeof adjustment === 'string') {
          adjustment = parseFloat(adjustment)
          if (waypoint.options.offset.indexOf('%') > - 1) {
            adjustment = Math.ceil(axis.contextDimension * adjustment / 100)
          }
        }

        contextModifier = axis.contextScroll - axis.contextOffset
        waypoint.triggerPoint = Math.floor(elementOffset + contextModifier - adjustment)
        wasBeforeScroll = oldTriggerPoint < axis.oldScroll
        nowAfterScroll = waypoint.triggerPoint >= axis.oldScroll
        triggeredBackward = wasBeforeScroll && nowAfterScroll
        triggeredForward = !wasBeforeScroll && !nowAfterScroll

        if (!freshWaypoint && triggeredBackward) {
          waypoint.queueTrigger(axis.backward)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
        else if (!freshWaypoint && triggeredForward) {
          waypoint.queueTrigger(axis.forward)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
        else if (freshWaypoint && axis.oldScroll >= waypoint.triggerPoint) {
          waypoint.queueTrigger(axis.forward)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
      }
    }

    Waypoint.requestAnimationFrame(function() {
      for (var groupKey in triggeredGroups) {
        triggeredGroups[groupKey].flushTriggers()
      }
    })

    return this
  }

  /* Private */
  Context.findOrCreateByElement = function(element) {
    return Context.findByElement(element) || new Context(element)
  }

  /* Private */
  Context.refreshAll = function() {
    for (var contextId in contexts) {
      contexts[contextId].refresh()
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-find-by-element */
  Context.findByElement = function(element) {
    return contexts[element.waypointContextKey]
  }

  window.onload = function() {
    if (oldWindowLoad) {
      oldWindowLoad()
    }
    Context.refreshAll()
  }


  Waypoint.requestAnimationFrame = function(callback) {
    var requestFn = window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      requestAnimationFrameShim
    requestFn.call(window, callback)
  }
  Waypoint.Context = Context
}())
;(function() {
  'use strict'

  function byTriggerPoint(a, b) {
    return a.triggerPoint - b.triggerPoint
  }

  function byReverseTriggerPoint(a, b) {
    return b.triggerPoint - a.triggerPoint
  }

  var groups = {
    vertical: {},
    horizontal: {}
  }
  var Waypoint = window.Waypoint

  /* http://imakewebthings.com/waypoints/api/group */
  function Group(options) {
    this.name = options.name
    this.axis = options.axis
    this.id = this.name + '-' + this.axis
    this.waypoints = []
    this.clearTriggerQueues()
    groups[this.axis][this.name] = this
  }

  /* Private */
  Group.prototype.add = function(waypoint) {
    this.waypoints.push(waypoint)
  }

  /* Private */
  Group.prototype.clearTriggerQueues = function() {
    this.triggerQueues = {
      up: [],
      down: [],
      left: [],
      right: []
    }
  }

  /* Private */
  Group.prototype.flushTriggers = function() {
    for (var direction in this.triggerQueues) {
      var waypoints = this.triggerQueues[direction]
      var reverse = direction === 'up' || direction === 'left'
      waypoints.sort(reverse ? byReverseTriggerPoint : byTriggerPoint)
      for (var i = 0, end = waypoints.length; i < end; i += 1) {
        var waypoint = waypoints[i]
        if (waypoint.options.continuous || i === waypoints.length - 1) {
          waypoint.trigger([direction])
        }
      }
    }
    this.clearTriggerQueues()
  }

  /* Private */
  Group.prototype.next = function(waypoint) {
    this.waypoints.sort(byTriggerPoint)
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
    var isLast = index === this.waypoints.length - 1
    return isLast ? null : this.waypoints[index + 1]
  }

  /* Private */
  Group.prototype.previous = function(waypoint) {
    this.waypoints.sort(byTriggerPoint)
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
    return index ? this.waypoints[index - 1] : null
  }

  /* Private */
  Group.prototype.queueTrigger = function(waypoint, direction) {
    this.triggerQueues[direction].push(waypoint)
  }

  /* Private */
  Group.prototype.remove = function(waypoint) {
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
    if (index > -1) {
      this.waypoints.splice(index, 1)
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/first */
  Group.prototype.first = function() {
    return this.waypoints[0]
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/last */
  Group.prototype.last = function() {
    return this.waypoints[this.waypoints.length - 1]
  }

  /* Private */
  Group.findOrCreate = function(options) {
    return groups[options.axis][options.name] || new Group(options)
  }

  Waypoint.Group = Group
}())
;(function() {
  'use strict'

  var $ = window.jQuery
  var Waypoint = window.Waypoint

  function JQueryAdapter(element) {
    this.$element = $(element)
  }

  $.each([
    'innerHeight',
    'innerWidth',
    'off',
    'offset',
    'on',
    'outerHeight',
    'outerWidth',
    'scrollLeft',
    'scrollTop'
  ], function(i, method) {
    JQueryAdapter.prototype[method] = function() {
      var args = Array.prototype.slice.call(arguments)
      return this.$element[method].apply(this.$element, args)
    }
  })

  $.each([
    'extend',
    'inArray',
    'isEmptyObject'
  ], function(i, method) {
    JQueryAdapter[method] = $[method]
  })

  Waypoint.adapters.push({
    name: 'jquery',
    Adapter: JQueryAdapter
  })
  Waypoint.Adapter = JQueryAdapter
}())
;(function() {
  'use strict'

  var Waypoint = window.Waypoint

  function createExtension(framework) {
    return function() {
      var waypoints = []
      var overrides = arguments[0]

      if (framework.isFunction(arguments[0])) {
        overrides = framework.extend({}, arguments[1])
        overrides.handler = arguments[0]
      }

      this.each(function() {
        var options = framework.extend({}, overrides, {
          element: this
        })
        if (typeof options.context === 'string') {
          options.context = framework(this).closest(options.context)[0]
        }
        waypoints.push(new Waypoint(options))
      })

      return waypoints
    }
  }

  if (window.jQuery) {
    window.jQuery.fn.waypoint = createExtension(window.jQuery)
  }
  if (window.Zepto) {
    window.Zepto.fn.waypoint = createExtension(window.Zepto)
  }
}())
;
define("waypoints", function(){});

/*
 MAPSTRACTION   v2.0.18   http://www.mapstraction.com

 Copyright (c) 2012 Tom Carden, Steve Coast, Mikel Maron, Andrew Turner, Henri Bergius, Rob Moran, Derek Fowler, Gary Gale
 All rights reserved.

 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

 * Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * Neither the name of the Mapstraction nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
// Auto-load scripts
//
// specify which map providers to load by using
// <script src="mxn.js?(provider1,provider2,[module1,module2])" ...
// in your HTML
//
// for each provider mxn.provider.module.js and mxn.module.js will be loaded
// module 'core' is always loaded
//
// NOTE: if you call without providers
// <script src="mxn.js" ...
// no scripts will be loaded at all and it is then up to you to load the scripts independently
define('mxn',[], function () {
	//var providers = null;
	//var modules = 'core';
	//var scriptBase;
	//var scripts = document.getElementsByTagName('script');
	//
	//// Determine which scripts we need to load
	//for (var i = 0; i < scripts.length; i++) {
	//	var match = scripts[i].src.replace(/%20/g, '').match(/^(.*?)mxn\.js(\?\(\[?(.*?)\]?\))?$/);
	//	if (match !== null) {
	//		scriptBase = match[1];
	//		if (match[3]) {
	//			var settings = match[3].split(',[');
	//			providers = settings[0].replace(']', '');
	//			if (settings[1]) {
	//				modules += ',' + settings[1];
	//			}
	//		}
	//		break;
	//	}
	//}
	//
	//if (providers === null || providers == 'none') {
	//	return; // Bail out if no auto-load has been found
	//}
	//providers = providers.replace(/ /g, '').split(',');
	//modules = modules.replace(/ /g, '').split(',');
	//
	//// Actually load the scripts
	//var scriptTagStart = '<script type="text/javascript" src="' + scriptBase + 'mxn.';
	//var scriptTagEnd = '.js"></script>';
	//var scriptsAry = [];
	//for (i = 0; i < modules.length; i++) {
	//	scriptsAry.push(scriptTagStart + modules[i] + scriptTagEnd);
	//	for (var j = 0; j < providers.length; j++) {
	//		scriptsAry.push(scriptTagStart + providers[j] + '.' + modules[i] + scriptTagEnd);
	//	}
	//}
	//document.write(scriptsAry.join(''));


// holds all our implementing functions
	var apis = {};

// Our special private methods
	/**
	 * Calls the API specific implementation of a particular method.
	 * Deferrable: If the API implmentation includes a deferable hash such as { getCenter: true, setCenter: true},
	 * then the methods calls mentioned with in it will be queued until runDeferred is called.
	 *
	 * @private
	 */
	var invoke = function (sApiId, sObjName, sFnName, oScope, args) {
		if (!hasImplementation(sApiId, sObjName, sFnName)) {
			throw 'Method ' + sFnName + ' of object ' + sObjName + ' is not supported by API ' + sApiId + '. Are you missing a script tag?';
		}
		if (typeof(apis[sApiId][sObjName].deferrable) != 'undefined' && apis[sApiId][sObjName].deferrable[sFnName] === true) {
			mxn.deferUntilLoaded.call(oScope, function () {
				return apis[sApiId][sObjName][sFnName].apply(oScope, args);
			});
		}
		else {
			return apis[sApiId][sObjName][sFnName].apply(oScope, args);
		}
	};

	/**
	 * Determines whether the specified API provides an implementation for the
	 * specified object and function name.
	 * @private
	 */
	var hasImplementation = function (sApiId, sObjName, sFnName) {
		if (typeof(apis[sApiId]) == 'undefined') {
			throw 'API ' + sApiId + ' not loaded. Are you missing a script tag?';
		}
		if (typeof(apis[sApiId][sObjName]) == 'undefined') {
			throw 'Object definition ' + sObjName + ' in API ' + sApiId + ' not loaded. Are you missing a script tag?';
		}
		return typeof(apis[sApiId][sObjName][sFnName]) == 'function';
	};

	/**
	 * @name mxn
	 * @namespace
	 */
	var mxn = window.mxn = /** @lends mxn */ {

		/**
		 * Registers a set of provider specific implementation functions.
		 * @function
		 * @private
		 * @param {String} sApiId The API ID to register implementing functions for.
		 * @param {Object} oApiImpl An object containing the API implementation.
		 */
		register: function (sApiId, oApiImpl) {
			if (!apis.hasOwnProperty(sApiId)) {
				apis[sApiId] = {};
			}
			mxn.util.merge(apis[sApiId], oApiImpl);
		},

		/**
		 * Adds a list of named proxy methods to the prototype of a
		 * specified constructor function.
		 * @private
		 * @function
		 * @param {Function} func Constructor function to add methods to
		 * @param {Array} aryMethods Array of method names to create
		 * @param {Boolean} bWithApiArg Optional. Whether the proxy methods will use an API argument
		 */
		addProxyMethods: function (func, aryMethods, bWithApiArg) {
			for (var i = 0; i < aryMethods.length; i++) {
				var sMethodName = aryMethods[i];
				if (bWithApiArg) {
					func.prototype[sMethodName] = new Function('return this.invoker.go(\'' + sMethodName + '\', arguments, { overrideApi: true } );');
				}
				else {
					func.prototype[sMethodName] = new Function('return this.invoker.go(\'' + sMethodName + '\', arguments);');
				}
			}
		},

		/**
		 * @private
		 */
		checkLoad: function (funcDetails) {
			if (this.loaded[this.api] === false) {
				var scope = this;
				this.onload[this.api].push(function () {
					funcDetails.callee.apply(scope, funcDetails);
				});
				return true;
			}
			return false;
		},

		/**
		 * @private
		 */
		deferUntilLoaded: function (fnCall) {
			if (this.loaded[this.api] === false) {
				var scope = this;
				this.onload[this.api].push(fnCall);
			} else {
				fnCall.call(this);
			}
		},

		/**
		 * Bulk add some named events to an object.
		 * @function
		 * @private
		 * @param {Object} oEvtSrc The event source object.
		 * @param {String[]} aEvtNames Event names to add.
		 */
		addEvents: function (oEvtSrc, aEvtNames) {
			for (var i = 0; i < aEvtNames.length; i++) {
				var sEvtName = aEvtNames[i];
				if (sEvtName in oEvtSrc) {
					throw 'Event or method ' + sEvtName + ' already declared.';
				}
				oEvtSrc[sEvtName] = new mxn.Event(sEvtName, oEvtSrc);
			}
		}

	};

	/**
	 * Instantiates a new Event
	 * @constructor
	 * @private
	 * @param {String} sEvtName The name of the event.
	 * @param {Object} oEvtSource The source object of the event.
	 */
	mxn.Event = function (sEvtName, oEvtSource) {
		var handlers = [];
		if (!sEvtName) {
			throw 'Event name must be provided';
		}
		/**
		 * Add a handler to the Event.
		 * @private
		 * @param {Function} fn The handler function.
		 * @param {Object} ctx The context of the handler function.
		 */
		this.addHandler = function (fn, ctx) {
			handlers.push({context: ctx, handler: fn});
		};
		/**
		 * Remove a handler from the Event.
		 * @private
		 * @param {Function} fn The handler function.
		 * @param {Object} ctx The context of the handler function.
		 */
		this.removeHandler = function (fn, ctx) {
			for (var i = 0; i < handlers.length; i++) {
				if (handlers[i].handler == fn && handlers[i].context == ctx) {
					handlers.splice(i, 1);
				}
			}
		};
		/**
		 * Remove all handlers from the Event.
		 * @private
		 */
		this.removeAllHandlers = function () {
			handlers = [];
		};
		/**
		 * Fires the Event.
		 * @private
		 * @param {Object} oEvtArgs Event arguments object to be passed to the handlers.
		 */
		this.fire = function (oEvtArgs) {
			var args = [sEvtName, oEvtSource, oEvtArgs];
			for (var i = 0; i < handlers.length; i++) {
				handlers[i].handler.apply(handlers[i].context, args);
			}
		};
	};

	/**
	 * Creates a new Invoker, a class which helps with on-the-fly
	 * invocation of the correct API methods.
	 * @constructor
	 * @private
	 * @param {Object} aobj The core object whose methods will make cals to go()
	 * @param {String} asClassName The name of the Mapstraction class to be invoked, normally the same name as aobj's constructor function
	 * @param {Function} afnApiIdGetter The function on object aobj which will return the active API ID
	 */
	mxn.Invoker = function (aobj, asClassName, afnApiIdGetter) {
		var obj = aobj;
		var sClassName = asClassName;
		var fnApiIdGetter = afnApiIdGetter;
		var defOpts = {
			overrideApi: false, // {Boolean} API ID is overridden by value in first argument
			context: null, // {Object} Local vars can be passed from the body of the method to the API method within this object
			fallback: null // {Function} If an API implementation doesn't exist this function is run instead
		};

		/**
		 * Invoke the API implementation of a specific method.
		 * @private
		 * @param {String} sMethodName The method name to invoke
		 * @param {Array} args Arguments to pass on
		 * @param {Object} oOptions Optional. Extra options for invocation
		 * @param {Boolean} oOptions.overrideApi When true the first argument is used as the API ID.
		 * @param {Object} oOptions.context A context object for passing extra information on to the provider implementation.
		 * @param {Function} oOptions.fallback A fallback function to run if the provider implementation is missing.
		 */
		this.go = function (sMethodName, args, oOptions) {

			// make sure args is an array
			args = typeof(args) != 'undefined' ? Array.prototype.slice.apply(args) : [];

			if (typeof(oOptions) == 'undefined') {
				oOptions = defOpts;
			}

			var sApiId;
			if (oOptions.overrideApi) {
				sApiId = args.shift();
			}
			else {
				sApiId = fnApiIdGetter.apply(obj);
			}

			if (typeof(sApiId) != 'string') {
				throw 'API ID not available.';
			}

			if (typeof(oOptions.context) != 'undefined' && oOptions.context !== null) {
				args.push(oOptions.context);
			}

			if (typeof(oOptions.fallback) == 'function' && !hasImplementation(sApiId, sClassName, sMethodName)) {
				// we've got no implementation but have got a fallback function
				return oOptions.fallback.apply(obj, args);
			}
			else {
				return invoke(sApiId, sClassName, sMethodName, obj, args);
			}

		};

	};

	/**
	 * @namespace
	 */
	mxn.util = {

		/**
		 * Merges properties of one object into another recursively.
		 * @name mxn.util.merge
		 * @param {Object} oRecv The object receiveing properties
		 * @param {Object} oGive The object donating properties
		 */
		merge: function (oRecv, oGive) {
			for (var sPropName in oGive) {
				if (oGive.hasOwnProperty(sPropName)) {
					if (!oRecv.hasOwnProperty(sPropName) || typeof(oRecv[sPropName]) !== 'object' || typeof(oGive[sPropName]) !== 'object') {
						oRecv[sPropName] = oGive[sPropName];
					}
					else {
						mxn.util.merge(oRecv[sPropName], oGive[sPropName]);
					}
				}
			}
		},

		/**
		 * $m, the dollar function, elegantising getElementById()
		 * @name mxn.util.$m
		 * @return An HTML element or array of HTML elements
		 */
		$m: function () {
			var elements = [];
			for (var i = 0; i < arguments.length; i++) {
				var element = arguments[i];
				if (typeof(element) == 'string') {
					element = document.getElementById(element);
				}
				if (arguments.length == 1) {
					return element;
				}
				elements.push(element);
			}
			return elements;
		},

		/**
		 * loadScript is a JSON data fetcher
		 * @name mxn.util.loadScript
		 * @param {String} src URL to JSON file
		 * @param {Function} callback Callback function
		 */
		loadScript: function (src, callback) {
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = src;
			if (callback) {
				if (script.addEventListener) {
					script.addEventListener('load', callback, true);
				}
				else if (script.attachEvent) {
					var done = false;
					script.attachEvent("onreadystatechange", function () {
						if (!done && document.readyState === "complete") {
							done = true;
							callback();
						}
					});
				}
			}
			var h = document.getElementsByTagName('head')[0];
			h.appendChild(script);
			return;
		},

		/**
		 * @private
		 * @param {Object} point
		 * @param {Object} level
		 */
		convertLatLonXY_Yahoo: function (point, level) { //Mercator
			var size = 1 << (26 - level);
			var pixel_per_degree = size / 360.0;
			var pixel_per_radian = size / (2 * Math.PI);
			var origin = new YCoordPoint(size / 2, size / 2);
			var answer = new YCoordPoint();
			answer.x = Math.floor(origin.x + point.lon * pixel_per_degree);
			var sin = Math.sin(point.lat * Math.PI / 180.0);
			answer.y = Math.floor(origin.y + 0.5 * Math.log((1 + sin) / (1 - sin)) * -pixel_per_radian);
			return answer;
		},

		/**
		 * Load a stylesheet from a remote file.
		 * @name mxn.util.loadStyle
		 * @param {String} href URL to the CSS file
		 */
		loadStyle: function (href) {
			var link = document.createElement('link');
			link.type = 'text/css';
			link.rel = 'stylesheet';
			link.href = href;
			document.getElementsByTagName('head')[0].appendChild(link);
			return;
		},

		/**
		 * getStyle provides cross-browser access to css
		 * @name mxn.util.getStyle
		 * @param {Object} el HTML Element
		 * @param {String} prop Style property name
		 */
		getStyle: function (el, prop) {
			var y;
			if (el.currentStyle) {
				y = el.currentStyle[prop];
			}
			else if (window.getComputedStyle) {
				y = window.getComputedStyle(el, '').getPropertyValue(prop);
			}
			return y;
		},

		/**
		 * Convert longitude to metres
		 * http://www.uwgb.edu/dutchs/UsefulData/UTMFormulas.HTM
		 * "A degree of longitude at the equator is 111.2km... For other latitudes,
		 * multiply by cos(lat)"
		 * assumes the earth is a sphere but good enough for our purposes
		 * @name mxn.util.lonToMetres
		 * @param {Float} lon
		 * @param {Float} lat
		 */
		lonToMetres: function (lon, lat) {
			return lon * (111200 * Math.cos(lat * (Math.PI / 180)));
		},

		/**
		 * Convert metres to longitude
		 * @name mxn.util.metresToLon
		 * @param {Object} m
		 * @param {Object} lat
		 */
		metresToLon: function (m, lat) {
			return m / (111200 * Math.cos(lat * (Math.PI / 180)));
		},

		/**
		 * Convert kilometres to miles
		 * @name mxn.util.KMToMiles
		 * @param {Float} km
		 * @returns {Float} miles
		 */
		KMToMiles: function (km) {
			return km / 1.609344;
		},

		/**
		 * Convert miles to kilometres
		 * @name mxn.util.MilesToKM
		 * @param {Float} miles
		 * @returns {Float} km
		 */
		milesToKM: function (miles) {
			return miles * 1.609344;
		},

		// stuff to convert google zoom levels to/from degrees
		// assumes zoom 0 = 256 pixels = 360 degrees
		//		 zoom 1 = 256 pixels = 180 degrees
		// etc.

		/**
		 * @name mxn.util.getDegreesFromGoogleZoomLevel
		 * @param {Object} pixels
		 * @param {Object} zoom
		 */
		getDegreesFromGoogleZoomLevel: function (pixels, zoom) {
			return (360 * pixels) / (Math.pow(2, zoom + 8));
		},

		/**
		 * @name mxn.util.getGoogleZoomLevelFromDegrees
		 * @param {Object} pixels
		 * @param {Object} degrees
		 */
		getGoogleZoomLevelFromDegrees: function (pixels, degrees) {
			return mxn.util.logN((360 * pixels) / degrees, 2) - 8;
		},

		/**
		 * @name mxn.util.logN
		 * @param {Object} number
		 * @param {Object} base
		 */
		logN: function (number, base) {
			return Math.log(number) / Math.log(base);
		},

		/**
		 * Returns array of loaded provider apis
		 * @name mxn.util.getAvailableProviders
		 * @returns {Array} providers
		 */
		getAvailableProviders: function () {
			var providers = [];
			for (var propertyName in apis) {
				if (apis.hasOwnProperty(propertyName)) {
					providers.push(propertyName);
				}
			}
			return providers;
		},

		/**
		 * Formats a string, inserting values of subsequent parameters at specified
		 * @name mxn.util.stringFormat
		 * locations. e.g. stringFormat('{0} {1}', 'hello', 'world');
		 */
		stringFormat: function (strIn) {
			var replaceRegEx = /\{\d+\}/g;
			var args = Array.prototype.slice.apply(arguments);
			args.shift();
			return strIn.replace(replaceRegEx, function (strVal) {
				var num = strVal.slice(1, -1);
				return args[num];
			});
		},

		/**
		 * Traverses an object graph using a series of map functions provided as arguments
		 * 2 to n. Map functions are only called if the working object is not undefined/null.
		 * For usage see mxn.google.geocoder.js.
		 * @name mxn.util.traverse
		 */
		traverse: function (start) {
			var args = Array.prototype.slice.apply(arguments);
			args.shift();
			var working = start;
			while (typeof(working) != 'undefined' && working !== null && args.length > 0) {
				var op = args.shift();
				working = op(working);
			}
		},

		/**
		 * Sanitises and cleans a templated tile server URL, converting all uppercase template
		 * references, such as {Z}, {X} or {Y} to their lowercase forms.
		 * @name mxn.util.sanitizeTileURL
		 * @param {String} url Source URL to sanitise
		 * @returns {String} The sanitised URL
		 */
		sanitizeTileURL: function (url) {
			return url.replace(/\{S\}/g, '{s}').replace(/\{Z\}/g, '{z}').replace(/\{X\}/g, '{x}').replace(/\{Y\}/g, '{y}');
		},

		/**
		 * Replaces the subdomain in a templated tile server URL with a randomly chosen element
		 * from a choice of subdomains. Some tile servers automagically replaces instances of
		 * {s} in templated URLs but for those that don't this helper function will do the job
		 * @name mxn.util.getSubdomainTileURL
		 * @param {String} url Templated tile server URL
		 * @param {Object} subdomains List of subdomains; can be supplied as a string or as an array
		 * @returns {String} The modified template URL
		 */
		getSubdomainTileURL: function (url, subdomains) {
			var pos = url.search('{s}');
			if (pos !== -1) {
				var random_element = Math.floor(Math.random() * subdomains.length);
				var domain;
				if (typeof subdomains === 'string') {
					domain = subdomains.substring(random_element, random_element + 1);
				}

				else {
					domain = subdomains[random_element];
				}

				if (typeof domain !== 'undefined') {
					return url.replace(/\{s\}/g, domain);
				}
			}

			return url;
		}
	};

	/**
	 * Helper class for converting between HTML and RGB integer color formats.
	 * @constructor
	 * @param {variable} color Specify as either a single argument containing an HTML
	 * color string or three numeric arguments for R, G and B respectively.
	 */
	mxn.util.Color = function () {
		if (arguments.length == 3) {
			this.red = arguments[0];
			this.green = arguments[1];
			this.blue = arguments[2];
		}
		else if (arguments.length == 1) {
			this.setHexColor(arguments[0]);
		}
	};

	mxn.util.Color.prototype.reHex = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

	/**
	 * Set the color from the supplied HTML hex string.
	 * @param {String} hexColor A HTML hex color string e.g. '#00FF88'.
	 */
	mxn.util.Color.prototype.setHexColor = function (hexColor) {
		var match = hexColor.match(this.reHex);
		if (match) {
			// grab the code - strips off the preceding # if there is one
			hexColor = match[1];
		}
		else {
			throw 'Invalid HEX color format, expected #000, 000, #000000 or 000000';
		}
		// if a three character hex code was provided, double up the values
		if (hexColor.length == 3) {
			hexColor = hexColor.replace(/\w/g, function (str) {
				return str.concat(str);
			});
		}
		this.red = parseInt(hexColor.substr(0, 2), 16);
		this.green = parseInt(hexColor.substr(2, 2), 16);
		this.blue = parseInt(hexColor.substr(4, 2), 16);
	};

	/**
	 * Retrieve the color value as an HTML hex string.
	 * @returns {String} Format '#00FF88'.
	 */
	mxn.util.Color.prototype.getHexColor = function () {
		var rgb = this.blue | (this.green << 8) | (this.red << 16);
		var hexString = rgb.toString(16).toUpperCase();
		if (hexString.length < 6) {
			hexString = '0' + hexString;
		}
		return '#' + hexString;
	};

	/*
	 MAPSTRACTION   v2.0.18   http://www.mapstraction.com

	 Copyright (c) 2012 Tom Carden, Steve Coast, Mikel Maron, Andrew Turner, Henri Bergius, Rob Moran, Derek Fowler, Gary Gale
	 All rights reserved.

	 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	 * Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	 * Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	 * Neither the name of the Mapstraction nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

	 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */


	/**
	 * @exports mxn.util.$m as $m
	 */
	var $m = mxn.util.$m;

	/**
	 * Initialise our provider. This function should only be called
	 * from within Mapstraction code, not exposed as part of the API.
	 * @private
	 */
	var initCore = function () {
		this.invoker.go('init', [this.currentElement, this.api]);
		this.applyOptions();
	};

	/**
	 * <p>Creates and loads a Mapstraction map into a specified HTML element. The following mapping APIs
	 * are supported by Mapstraction:</p>
	 *
	 * <ul>
	 * <li><code>cloudmade</code> - CloudMade</li>
	 * <li><code>esri</code> - ESRI ArcGIS</li>
	 * <li><code>google</code> - Google v2</li>
	 * <li><code>googlev3</code> - Google v3</li>
	 * <li><code>leaflet</code> - Leaflet</li>
	 * <li><code>mapquest</code> - MapQuest</li>
	 * <li><code>microsoft</code> - Microsoft Bing v6</li>
	 * <li><code>microsoft7</code> - Microsoft Bing v7</li>
	 * <li><code>nokia</code> - Nokia Here</li>
	 * <li><code>openlayers</code> - OpenLayers</li>
	 * <li><code>openmq</code> - MapQuest Open</li>
	 * <li><code>openspace</code> - Ordnance Survey OpenSpace</li>
	 * <li><code>ovi</code> - Nokia Ovi</li>
	 * <li><code>yahoo</code> - <strong><em>Yahoo (obsoleted)</em></strong></li>
	 * <li><code>yandex</code> - Yandex</li>
	 * </ul>
	 * @name mxn.Mapstraction
	 * @constructor
	 * @param {string} element The HTML element to replace with a map.
	 * @param {string} api The API ID of the mapping API to use; if omitted, the first loaded provider implementation is used.
	 * @param {boolean} [debug] optional parameter to turn on debug support; this uses alert panels for unsupported actions.
	 * @exports Mapstraction as mxn.Mapstraction
	 */
	var Mapstraction = mxn.Mapstraction = function (element, api, debug) {
		if (!api) {
			api = mxn.util.getAvailableProviders()[0];
		}

		/**
		 * The name of the active API.
		 * @name mxn.Mapstraction#api
		 * @type {string}
		 */
		this.api = api;

		this.maps = {};

		/**
		 * The DOM element containing the map.
		 * @name mxn.Mapstraction#currentElement
		 * @property
		 * @type {DOMElement}
		 */
		this.currentElement = $m(element);

		this.eventListeners = [];

		/**
		 * The array of all layers that have been added to the map.
		 * @name mxn.Mapstraction#tileLayers
		 * @property
		 * @type {Array}
		 */
		this.tileLayers = [];

		/**
		 * The array of currently loaded <code>mxn.Marker</code> objects.
		 * @name mxn.Mapstraction#markers
		 * @property
		 * @type {Array}
		 */
		this.markers = [];

		/**
		 * The array of currently loaded <code>mxn.Polyline</code> objects.
		 * @name mxn.Mapstraction#polylines
		 * @property
		 * @type {Array}
		 */
		this.polylines = [];

		this.images = [];
		this.controls = [];
		this.loaded = {};
		this.onload = {};
		//this.loaded[api] = true; // FIXME does this need to be true? -ajturner
		this.onload[api] = [];

		/**
		 * The original element value passed to the constructor.
		 * @name mxn.Mapstraction#element
		 * @property
		 * @type {string|DOMElement}
		 */
		this.element = element;

		/**
		 * Options defaults.
		 * @name mxn.Mapstraction#options
		 * @property {Object}
		 */
		this.options = {
			enableScrollWheelZoom: false,
			enableDragging: true
		};

		this.addControlsArgs = {};

		// set up our invoker for calling API methods
		this.invoker = new mxn.Invoker(this, 'Mapstraction', function () {
			return this.api;
		});

		// Adding our events
		mxn.addEvents(this, [

		/**
		 * Map has loaded
		 * @name mxn.Mapstraction#load
		 * @event
		 */
			'load',

		/**
		 * Map is clicked {location: mxn.LatLonPoint}
		 * @name mxn.Mapstraction#click
		 * @event
		 */
			'click',

		/**
		 * Map is panned
		 * @name mxn.Mapstraction#endPan
		 * @event
		 */
			'endPan',

		/**
		 * Zoom is changed
		 * @name mxn.Mapstraction#changeZoom
		 * @event
		 */
			'changeZoom',

		/**
		 * Marker is added {marker: Marker}
		 * @name mxn.Mapstraction#markerAdded
		 * @event
		 */
			'markerAdded',

		/**
		 * Marker is removed {marker: Marker}
		 * @name mxn.Mapstraction#markerRemoved
		 * @event
		 */
			'markerRemoved',

		/**
		 * Polyline is added {polyline: Polyline}
		 * @name mxn.Mapstraction#polylineAdded
		 * @event
		 */
			'polylineAdded',

		/**
		 * Polyline is removed {polyline: Polyline}
		 * @name mxn.Mapstraction#polylineRemoved
		 * @event
		 */
			'polylineRemoved'
		]);

		// finally initialize our proper API map
		initCore.apply(this);
	};

// Map type constants
	Mapstraction.ROAD = 1;
	Mapstraction.SATELLITE = 2;
	Mapstraction.HYBRID = 3;
	Mapstraction.PHYSICAL = 4;

// methods that have no implementation in mapstraction core
	mxn.addProxyMethods(Mapstraction, [
	/**
	 * Adds a large map panning control and zoom buttons to the map
	 * @name mxn.Mapstraction#addLargeControls
	 * @function
	 */
		'addLargeControls',

	/**
	 * Adds a map type control to the map (streets, aerial imagery etc)
	 * @name mxn.Mapstraction#addMapTypeControls
	 * @function
	 */
		'addMapTypeControls',

	/**
	 * Adds a GeoRSS or KML overlay to the map
	 *  some flavors of GeoRSS and KML are not supported by some of the Map providers
	 * @name mxn.Mapstraction#addOverlay
	 * @function
	 * @param {string} url GeoRSS or KML feed URL
	 * @param {boolean} autoCenterAndZoom Set true to auto center and zoom after the feed is loaded
	 */
		'addOverlay',

	/**
	 * Adds a small map panning control and zoom buttons to the map
	 * @name mxn.Mapstraction#addSmallControls
	 * @function
	 */
		'addSmallControls',

	/**
	 * Applies the current option settings
	 * @name mxn.Mapstraction#applyOptions
	 * @function
	 */
		'applyOptions',

	/**
	 * Gets the BoundingBox of the map
	 * @name mxn.Mapstraction#getBounds
	 * @function
	 * @returns {mxn.BoundingBox} The bounding box for the current map state
	 */
		'getBounds',

	/**
	 * Gets the central point of the map
	 * @name mxn.Mapstraction#getCenter
	 * @function
	 * @returns {mxn.LatLonPoint} The center point of the map
	 */
		'getCenter',

	/**
	 * <p>Gets the imagery type for the map. The type can be one of:</p>
	 *
	 * <ul>
	 * <li><code>mxn.Mapstraction.ROAD</code></li>
	 * <li><code>mxn.Mapstraction.SATELLITE</code></li>
	 * <li><code>mxn.Mapstraction.HYBRID</code></li>
	 * <li><code>mxn.Mapstraction.PHYSICAL</code></li>
	 * </ul>
	 *
	 * @name mxn.Mapstraction#getMapType
	 * @function
	 * @returns {Number}
	 */
		'getMapType',

	/**
	 * Returns a ratio to turn distance into pixels based on the current projection.
	 * @name mxn.Mapstraction#getPixelRatio
	 * @function
	 * @returns {number} ratio
	 */
		'getPixelRatio',

	/**
	 * Returns the zoom level of the map
	 * @name mxn.Mapstraction#getZoom
	 * @function
	 * @returns {number} The zoom level of the map
	 */
		'getZoom',

	/**
	 * Returns the best zoom level for bounds given
	 * @name mxn.Mapstraction#getZoomLevelForBoundingBox
	 * @function
	 * @param {mxn.BoundingBox} bbox The bounds to fit
	 * @returns {number} The closest zoom level that contains the bounding box
	 */
		'getZoomLevelForBoundingBox',

	/**
	 * Displays the coordinates of the cursor in the HTML element
	 * @name mxn.Mapstraction#mousePosition
	 * @function
	 * @param {string} element ID of the HTML element to display the coordinates in
	 */
		'mousePosition',

	/**
	 * Resize the current map to the specified width and height
	 * (since it is actually on a child div of the mapElement passed
	 * as argument to the Mapstraction constructor, the resizing of this
	 * mapElement may have no effect on the size of the actual map)
	 * @name mxn.Mapstraction#resizeTo
	 * @function
	 * @param {number} width The width the map should be.
	 * @param {number} height The width the map should be.
	 */
		'resizeTo',

	/**
	 * Sets the map to the appropriate location and zoom for a given BoundingBox
	 * @name mxn.Mapstraction#setBounds
	 * @function
	 * @param {mxn.BoundingBox} bounds The bounding box you want the map to show
	 */
		'setBounds',

	/**
	 * setCenter sets the central point of the map
	 * @name mxn.Mapstraction#setCenter
	 * @function
	 * @param {mxn.LatLonPoint} point The point at which to center the map
	 * @param {Object} [options] Optional parameters
	 * @param {boolean} options.pan Whether the map should move to the locations using a pan or just jump straight there
	 */
		'setCenter',

	/**
	 * Centers the map to some place and zoom level
	 * @name mxn.Mapstraction#setCenterAndZoom
	 * @function
	 * @param {mxn.LatLonPoint} point Where the center of the map should be
	 * @param {number} zoom The zoom level where 0 is all the way out.
	 */
		'setCenterAndZoom',

	/**
	 * <p>Sets the imagery type for the map. The type can be one of:</p>
	 *
	 * <ul>
	 * <li><code>mxn.Mapstraction.ROAD</code></li>
	 * <li><code>mxn.Mapstraction.SATELLITE</code></li>
	 * <li><code>mxn.Mapstraction.HYBRID</code></li>
	 * <li><code>mxn.Mapstraction.PHYSICAL</code></li>
	 * </ul>
	 *
	 * @name mxn.Mapstraction#setMapType
	 * @function
	 * @param {Number} type
	 */
		'setMapType',

	/**
	 * Sets the zoom level for the map.
	 * @name mxn.Mapstraction#setZoom
	 * @function
	 * @param {Number} zoom The (native to the map) level zoom the map to.
	 */
		'setZoom',

	/**
	 * Turns a tile layer on or off
	 * @name mxn.Mapstraction#toggleTileLayer
	 * @function
	 * @param {tile_url} url of the tile layer that was created.
	 */
		'toggleTileLayer'
	]);

	/**
	 * Sets the current options to those specified in oOpts and applies them
	 * @param {Object} oOpts Hash of options to set
	 */
	Mapstraction.prototype.setOptions = function (oOpts) {
		mxn.util.merge(this.options, oOpts);
		this.applyOptions();
	};

	/**
	 * Sets an option and applies it.
	 * @param {string} sOptName Option name
	 * @param vVal Option value
	 */
	Mapstraction.prototype.setOption = function (sOptName, vVal) {
		this.options[sOptName] = vVal;
		this.applyOptions();
	};

	/**
	 * Enable scroll wheel zooming
	 * @deprecated Use setOption instead.
	 */
	Mapstraction.prototype.enableScrollWheelZoom = function () {
		this.setOption('enableScrollWheelZoom', true);
	};

	/**
	 * Enable/disable dragging of the map
	 * @param {boolean} on
	 * @deprecated Use setOption instead.
	 */
	Mapstraction.prototype.dragging = function (on) {
		this.setOption('enableDragging', on);
	};

	/**
	 * Change the current API on the fly
	 * @see mxn.Mapstraction
	 * @param {Object} element The DOM element containing the map
	 * @param {string} api The API to swap to
	 */
	Mapstraction.prototype.swap = function (element, api) {
		if (this.api === api) {
			return;
		}

		var center = this.getCenter();
		var zoom = this.getZoom();

		this.currentElement.style.visibility = 'hidden';
		this.currentElement.style.display = 'none';

		this.currentElement = $m(element);
		this.currentElement.style.visibility = 'visible';
		this.currentElement.style.display = 'block';

		this.api = api;
		this.onload[api] = [];

		if (!this.maps.hasOwnProperty(this.api)) {
			initCore.apply(this);

			for (var i = 0; i < this.markers.length; i++) {
				this.addMarker(this.markers[i], true);
			}

			for (var j = 0; j < this.polylines.length; j++) {
				this.addPolyline(this.polylines[j], true);
			}

			this.setCenterAndZoom(center, zoom);
		}
		else {

			//sync the view
			this.setCenterAndZoom(center, zoom);

			//TODO synchronize the markers and polylines too
			// (any overlays created after api instantiation are not sync'd)
		}

		this.addControls(this.addControlsArgs);

	};

	/**
	 * Returns the loaded state of a Map Provider
	 * @param {string} [api] Optional API to query for. If not specified, returns the state of the originally created API
	 */
	Mapstraction.prototype.isLoaded = function (api) {
		if (api === null) {
			api = this.api;
		}
		return this.loaded[api];
	};

	/**
	 * Set the debugging on or off - shows alert panels for functions that don't exist in Mapstraction
	 * @param {boolean} [debug] Specify <code>true</code> to turn on debugging or <code>false</code> to turn it off
	 */
	Mapstraction.prototype.setDebug = function (debug) {
		if (debug !== null) {
			this.debug = debug;
		}
		return this.debug;
	};

	/**
	 * Set the api call deferment on or off - When it's on, mxn.invoke will queue up provider API calls until
	 * runDeferred is called, at which time everything in the queue will be run in the order it was added.
	 * @param {boolean} set deferred to true to turn on deferment
	 */
	Mapstraction.prototype.setDefer = function (deferred) {
		this.loaded[this.api] = !deferred;
	};

	/**
	 * Run any queued provider API calls for the methods defined in the provider's implementation.
	 * For example, if defferable in mxn.[provider].core.js is set to {getCenter: true, setCenter: true}
	 * then any calls to map.setCenter or map.getCenter will be queued up in this.onload. When the provider's
	 * implementation loads the map, it calls this.runDeferred and any queued calls will be run.
	 */
	Mapstraction.prototype.runDeferred = function () {
		while (this.onload[this.api].length > 0) {
			this.onload[this.api].shift().apply(this); //run deferred calls
		}
	};

/////////////////////////
//
// Event Handling
//
// FIXME need to consolidate some of these handlers...
//
///////////////////////////

// Click handler attached to native API
	Mapstraction.prototype.clickHandler = function (lat, lon, me) {
		this.callEventListeners('click', {
			location: new LatLonPoint(lat, lon)
		});
	};

// Move and zoom handler attached to native API
	Mapstraction.prototype.moveendHandler = function (me) {
		this.callEventListeners('moveend', {});
	};

	/**
	 * Add a listener for an event.
	 * @param {string} type Event type to attach listener to
	 * @param {Function} func Callback function
	 * @param {Object} caller Callback object
	 */
	Mapstraction.prototype.addEventListener = function () {
		var listener = {};
		listener.event_type = arguments[0];
		listener.callback_function = arguments[1];

		// added the calling object so we can retain scope of callback function
		if (arguments.length == 3) {
			listener.back_compat_mode = false;
			listener.callback_object = arguments[2];
		}
		else {
			listener.back_compat_mode = true;
			listener.callback_object = null;
		}
		this.eventListeners.push(listener);
	};

	/**
	 * Call listeners for a particular event.
	 * @param {string} sEventType Call listeners of this event type
	 * @param {Object} oEventArgs Event args object to pass back to the callback
	 */
	Mapstraction.prototype.callEventListeners = function (sEventType, oEventArgs) {
		oEventArgs.source = this;
		for (var i = 0; i < this.eventListeners.length; i++) {
			var evLi = this.eventListeners[i];
			if (evLi.event_type == sEventType) {
				// only two cases for this, click and move
				if (evLi.back_compat_mode) {
					if (evLi.event_type == 'click') {
						evLi.callback_function(oEventArgs.location);
					}
					else {
						evLi.callback_function();
					}
				}
				else {
					var scope = evLi.callback_object || this;
					evLi.callback_function.call(scope, oEventArgs);
				}
			}
		}
	};


////////////////////
//
// map manipulation
//
/////////////////////


	/**
	 * <p><code>addControls</code> adds (or removes) controls to/from the map. You specify which controls to add in
	 * the object literal that is the only argument.<p>
	 * <p>To remove all controls from the map, call <code>addControls</code> with an empty object literal as the
	 * argument.<p>
	 * <p>Each time <code>addControls</code> is called, those controls present in the <code>args</code> object literal will
	 * be added; those that are not specified or as specified as false will be removed.</p>
	 *
	 * <pre>
	 * args = {
 *	 pan:		true,
 *	 zoom:		'large' | 'small',
 *	 overview:	true,
 *	 scale:		true,
 *	 map_type:	true,
 * }
	 * </pre>
	 * @param {Array} args Which controls to switch on
	 */
	Mapstraction.prototype.addControls = function (args) {
		this.addControlsArgs = args;
		this.invoker.go('addControls', arguments);
	};

	/**
	 * Adds a marker pin to the map
	 * @param {mxn.Marker} marker The marker to add
	 * @param {boolean} old If true, doesn't add this marker to the markers array. Used by the "swap" method
	 */
	Mapstraction.prototype.addMarker = function (marker, old) {
		marker.mapstraction = this;
		marker.api = this.api;
		marker.location.api = this.api;
		marker.map = this.maps[this.api];
		var propMarker = this.invoker.go('addMarker', arguments);
		marker.setChild(propMarker);
		if (!old) {
			this.markers.push(marker);
		}
		this.markerAdded.fire({'marker': marker});
	};

	/**
	 * addMarkerWithData will addData to the marker, then add it to the map
	 * @param {mxn.Marker} marker The marker to add
	 * @param {Object} data A data has to add
	 */
	Mapstraction.prototype.addMarkerWithData = function (marker, data) {
		marker.addData(data);
		this.addMarker(marker);
	};

	/**
	 * addPolylineWithData will addData to the polyline, then add it to the map
	 * @param {Polyline} polyline The polyline to add
	 * @param {Object} data A data has to add
	 */
	Mapstraction.prototype.addPolylineWithData = function (polyline, data) {
		polyline.addData(data);
		this.addPolyline(polyline);
	};

	/**
	 * Removes a Marker from the map
	 * @param {mxn.Marker} marker The marker to remove
	 */
	Mapstraction.prototype.removeMarker = function (marker) {
		var current_marker;
		for (var i = 0; i < this.markers.length; i++) {
			current_marker = this.markers[i];
			if (marker == current_marker) {
				marker.closeBubble();
				this.invoker.go('removeMarker', arguments);
				marker.onmap = false;
				this.markers.splice(i, 1);
				this.markerRemoved.fire({'marker': marker});
				break;
			}
		}
	};

	/**
	 * Removes all the Markers currently loaded on a map
	 */
	Mapstraction.prototype.removeAllMarkers = function () {
		var current_marker;
		while (this.markers.length > 0) {
			current_marker = this.markers.pop();
			this.invoker.go('removeMarker', [current_marker]);
		}
	};

	/**
	 * Declutter the markers on the map, group together overlapping markers.
	 * @param {Object} opts Declutter options
	 */
	Mapstraction.prototype.declutterMarkers = function (opts) {
		if (this.loaded[this.api] === false) {
			var me = this;
			this.onload[this.api].push(function () {
				me.declutterMarkers(opts);
			});
			return;
		}

		var map = this.maps[this.api];

		switch (this.api) {
			//	case 'yahoo':
			//
			//	  break;
			//	case 'google':
			//
			//	  break;
			//	case 'openstreetmap':
			//
			//	  break;
			//	case 'microsoft':
			//
			//	  break;
			//	case 'openlayers':
			//
			//	  break;
			case 'multimap':
				/*
				 * Multimap supports quite a lot of decluttering options such as whether
				 * to use an accurate of fast declutter algorithm and what icon to use to
				 * represent a cluster. Using all this would mean abstracting all the enums
				 * etc so we're only implementing the group name function at the moment.
				 */
				map.declutterGroup(opts.groupName);
				break;
			//	case 'mapquest':
			//
			//	  break;
			//	case 'map24':
			//
			//	  break;
			case '  dummy':
				break;
			default:
				if (this.debug) {
					throw new Error(this.api + ' not supported by Mapstraction.declutterMarkers');
				}
		}
	};

	/**
	 * Add a polyline to the map
	 * @param {Polyline} polyline The Polyline to add to the map
	 * @param {boolean} old If true replaces an existing Polyline
	 */
	Mapstraction.prototype.addPolyline = function (polyline, old) {
		polyline.api = this.api;
		polyline.map = this.maps[this.api];
		var propPoly = this.invoker.go('addPolyline', arguments);
		polyline.setChild(propPoly);
		if (!old) {
			this.polylines.push(polyline);
		}
		this.polylineAdded.fire({'polyline': polyline});
	};

// Private remove implementation
	var removePolylineImpl = function (polyline) {
		this.invoker.go('removePolyline', arguments);
		polyline.onmap = false;
		this.polylineRemoved.fire({'polyline': polyline});
	};

	/**
	 * Remove the polyline from the map
	 * @param {Polyline} polyline The Polyline to remove from the map
	 */
	Mapstraction.prototype.removePolyline = function (polyline) {
		var current_polyline;
		for (var i = 0; i < this.polylines.length; i++) {
			current_polyline = this.polylines[i];
			if (polyline == current_polyline) {
				this.polylines.splice(i, 1);
				removePolylineImpl.call(this, polyline);
				break;
			}
		}
	};

	/**
	 * Removes all polylines from the map
	 */
	Mapstraction.prototype.removeAllPolylines = function () {
		var current_polyline;
		while (this.polylines.length > 0) {
			current_polyline = this.polylines.pop();
			removePolylineImpl.call(this, current_polyline);
		}
	};

	var collectPoints = function (bMarkers, bPolylines, predicate) {
		var points = [];

		if (bMarkers) {
			for (var i = 0; i < this.markers.length; i++) {
				var mark = this.markers[i];
				if (!predicate || predicate(mark)) {
					points.push(mark.location);
				}
			}
		}

		if (bPolylines) {
			for (i = 0; i < this.polylines.length; i++) {
				var poly = this.polylines[i];
				if (!predicate || predicate(poly)) {
					for (var j = 0; j < poly.points.length; j++) {
						points.push(poly.points[j]);
					}
				}
			}
		}

		return points;
	};

	/**
	 * Sets the center and zoom of the map to the smallest bounding box
	 * containing all markers and polylines
	 */
	Mapstraction.prototype.autoCenterAndZoom = function () {
		var points = collectPoints.call(this, true, true);

		this.centerAndZoomOnPoints(points);
	};

	/**
	 * centerAndZoomOnPoints sets the center and zoom of the map from an array of points
	 *
	 * This is useful if you don't want to have to add markers to the map
	 */
	Mapstraction.prototype.centerAndZoomOnPoints = function (points) {
		var bounds = new BoundingBox(90, 180, -90, -180);

		for (var i = 0, len = points.length; i < len; i++) {
			bounds.extend(points[i]);
		}

		this.setBounds(bounds);
	};

	/**
	 * Sets the center and zoom of the map to the smallest bounding box
	 * containing all visible markers and polylines
	 * will only include markers and polylines with an attribute of "visible"
	 */
	Mapstraction.prototype.visibleCenterAndZoom = function () {
		var predicate = function (obj) {
			return obj.getAttribute("visible");
		};
		var points = collectPoints.call(this, true, true, predicate);

		this.centerAndZoomOnPoints(points);
	};

	/**
	 * Automatically sets center and zoom level to show all polylines
	 * @param {Number} padding Optional number of kilometers to pad around polyline
	 */
	Mapstraction.prototype.polylineCenterAndZoom = function (padding) {
		padding = padding || 0;

		var points = collectPoints.call(this, false, true);

		if (padding > 0) {
			var padPoints = [];
			for (var i = 0; i < points.length; i++) {
				var point = points[i];

				var kmInOneDegreeLat = point.latConv();
				var kmInOneDegreeLon = point.lonConv();

				var latPad = padding / kmInOneDegreeLat;
				var lonPad = padding / kmInOneDegreeLon;

				var ne = new LatLonPoint(point.lat + latPad, point.lon + lonPad);
				var sw = new LatLonPoint(point.lat - latPad, point.lon - lonPad);

				padPoints.push(ne, sw);
			}
			points = points.concat(padPoints);
		}

		this.centerAndZoomOnPoints(points);
	};

	/**
	 * addImageOverlay layers an georeferenced image over the map
	 * @param {id} unique DOM identifier
	 * @param {src} url of image
	 * @param {opacity} opacity 0-100
	 * @param {west} west boundary
	 * @param {south} south boundary
	 * @param {east} east boundary
	 * @param {north} north boundary
	 */
	Mapstraction.prototype.addImageOverlay = function (id, src, opacity, west, south, east, north) {

		var b = document.createElement("img");
		b.style.display = 'block';
		b.setAttribute('id', id);
		b.setAttribute('src', src);
		b.style.position = 'absolute';
		b.style.zIndex = 1;
		b.setAttribute('west', west);
		b.setAttribute('south', south);
		b.setAttribute('east', east);
		b.setAttribute('north', north);

		var oContext = {
			imgElm: b
		};

		this.invoker.go('addImageOverlay', arguments, {context: oContext});
	};

	Mapstraction.prototype.setImageOpacity = function (id, opacity) {
		if (opacity < 0) {
			opacity = 0;
		}
		if (opacity >= 100) {
			opacity = 100;
		}
		var c = opacity / 100;
		var d = document.getElementById(id);
		if (typeof(d.style.filter) == 'string') {
			d.style.filter = 'alpha(opacity:' + opacity + ')';
		}
		if (typeof(d.style.KHTMLOpacity) == 'string') {
			d.style.KHTMLOpacity = c;
		}
		if (typeof(d.style.MozOpacity) == 'string') {
			d.style.MozOpacity = c;
		}
		if (typeof(d.style.opacity) == 'string') {
			d.style.opacity = c;
		}
	};

	Mapstraction.prototype.setImagePosition = function (id) {
		var imgElement = document.getElementById(id);
		var oContext = {
			latLng: {
				top: imgElement.getAttribute('north'),
				left: imgElement.getAttribute('west'),
				bottom: imgElement.getAttribute('south'),
				right: imgElement.getAttribute('east')
			},
			pixels: {top: 0, right: 0, bottom: 0, left: 0}
		};

		this.invoker.go('setImagePosition', arguments, {context: oContext});

		imgElement.style.top = oContext.pixels.top.toString() + 'px';
		imgElement.style.left = oContext.pixels.left.toString() + 'px';
		imgElement.style.width = (oContext.pixels.right - oContext.pixels.left).toString() + 'px';
		imgElement.style.height = (oContext.pixels.bottom - oContext.pixels.top).toString() + 'px';
	};

	Mapstraction.prototype.addJSON = function (json) {
		var features;
		if (typeof(json) == "string") {
			if (window.JSON && window.JSON.parse) {
				features = window.JSON.parse(json);
			} else {
				features = eval('(' + json + ')');
			}
		} else {
			features = json;
		}
		features = features.features;
		var map = this.maps[this.api];
		var html = "";
		var item;
		var polyline;
		var marker;
		var markers = [];

		if (features.type == "FeatureCollection") {
			this.addJSON(features.features);
		}

		for (var i = 0; i < features.length; i++) {
			item = features[i];
			switch (item.geometry.type) {
				case "Point":
					html = "<strong>" + item.title + "</strong><p>" + item.description + "</p>";
					marker = new Marker(new LatLonPoint(item.geometry.coordinates[1], item.geometry.coordinates[0]));
					markers.push(marker);
					this.addMarkerWithData(marker, {
						infoBubble: html,
						label: item.title,
						date: "new Date(\"" + item.date + "\")",
						iconShadow: item.icon_shadow,
						marker: item.id,
						iconShadowSize: item.icon_shadow_size,
						icon: item.icon,
						iconSize: item.icon_size,
						category: item.source_id,
						draggable: false,
						hover: false
					});
					break;
				case "Polygon":
					var points = [];
					for (var j = 0; j < item.geometry.coordinates[0].length; j++) {
						points.push(new LatLonPoint(item.geometry.coordinates[0][j][1], item.geometry.coordinates[0][j][0]));
					}
					polyline = new Polyline(points);
					this.addPolylineWithData(polyline, {
						fillColor: item.poly_color,
						date: "new Date(\"" + item.date + "\")",
						category: item.source_id,
						width: item.line_width,
						opacity: item.line_opacity,
						color: item.line_color,
						closed: points[points.length - 1].equals(points[0]) //first point = last point in the polygon so its closed
					});
					markers.push(polyline);
					break;
				default:
				// console.log("Geometry: " + features.items[i].geometry.type);
			}
		}
		return markers;
	};

	/**
	 * <p>Adds a Tile Layer to the map.</p>
	 *
	 * <p>Requires providing a templated tile URL. Use <code>{S}</code>, <code>{Z}</code>, <code>{X}</code>, and <code>{Y}</code> to specify where the parameters
	 * should go in the URL. <code>{S}</code> is the (optional) subdomain to be used in the URL. <code>{Z}</code> is the zoom level.
	 * <code>{X}</code> and <code>{Y}</code> are the longitude and latitude of the tile.</p>
	 *
	 * <p>Sample templated tile URLs are :-</p>
	 *
	 * <ul>
	 * <li>OpenStreetMap - <code>http://{S}.tile.openstreetmap.org/{Z}/{X}/{Y}.png</code></li>
	 * <li>Stamen Toner - <code>http://tile.stamen.com/toner/{Z}/{X}/{Y}.png</code></li>
	 * <li>MapQuest OSM - <code>http://otile{s}.mqcdn.com/tiles/1.0.0/map/{z}/{x}/{y}.jpg</code></li>
	 * <li>MapQuest Open Aerial - <code>http://otile{s}.mqcdn.com/tiles/1.0.0/sat/{z}/{x}/{y}.jpg</code></li>
	 * </ul>
	 *
	 * @param {string} tile_url Template URL of the tiles.
	 * @param {number} opacity Opacity of the tile layer - 0 is transparent, 1 is opaque. (default=0.6)
	 * @param {string} label The label to be used for the tile layer in the Map Type control
	 * @param {string} attribution The attribution and/or copyright text to use for the tile layer
	 * @param {Int} min_zoom Minimum (furthest out) zoom level that tiles are available (default=1)
	 * @param {Int} max_zoom Maximum (closest in) zoom level that the tiles are available (default=18)
	 * @param {boolean} map_type Should the tile layer be a selectable map type in the layers palette (default=false)
	 * @param {String|Array} subdomains List of subdomains that the tile server in <code>tile_url</code> refers to. Can be specified as a string "abc" or as an array [1, 2, 3]
	 * @return {Object} The tile layer object
	 */
	Mapstraction.prototype.addTileLayer = function (tile_url, opacity, label, attribution, min_zoom, max_zoom, map_type, subdomains) {
		if (!tile_url) {
			return;
		}

		opacity = opacity || 0.6;
		label = label || "Mapstraction";
		attribution = attribution || "Mapstraction";
		min_zoom = min_zoom || 1;
		max_zoom = max_zoom || 18;
		map_type = map_type || false;

		return this.invoker.go('addTileLayer', [tile_url, opacity, label, attribution, min_zoom, max_zoom, map_type, subdomains]);
	};

	/**
	 * addFilter adds a marker filter
	 * @param {field} name of attribute to filter on
	 * @param {operator} presently only "ge" or "le"
	 * @param {value} the value to compare against
	 */
	Mapstraction.prototype.addFilter = function (field, operator, value) {
		if (!this.filters) {
			this.filters = [];
		}
		this.filters.push([field, operator, value]);
	};

	/**
	 * Remove the specified filter
	 * @param {Object} field
	 * @param {Object} operator
	 * @param {Object} value
	 */
	Mapstraction.prototype.removeFilter = function (field, operator, value) {
		if (!this.filters) {
			return;
		}

		var del;
		for (var f = 0; f < this.filters.length; f++) {
			if (this.filters[f][0] == field &&
				(!operator || (this.filters[f][1] == operator && this.filters[f][2] == value))) {
				this.filters.splice(f, 1);
				f--; //array size decreased
			}
		}
	};

	/**
	 * Delete the current filter if present; otherwise add it
	 * @param {Object} field
	 * @param {Object} operator
	 * @param {Object} value
	 */
	Mapstraction.prototype.toggleFilter = function (field, operator, value) {
		if (!this.filters) {
			this.filters = [];
		}

		var found = false;
		for (var f = 0; f < this.filters.length; f++) {
			if (this.filters[f][0] == field && this.filters[f][1] == operator && this.filters[f][2] == value) {
				this.filters.splice(f, 1);
				f--; //array size decreased
				found = true;
			}
		}

		if (!found) {
			this.addFilter(field, operator, value);
		}
	};

	/**
	 * removeAllFilters
	 */
	Mapstraction.prototype.removeAllFilters = function () {
		this.filters = [];
	};

	/**
	 * doFilter executes all filters added since last call
	 * Now supports a callback function for when a marker is shown or hidden
	 * @param {Function} showCallback
	 * @param {Function} hideCallback
	 * @returns {Int} count of visible markers
	 */
	Mapstraction.prototype.doFilter = function (showCallback, hideCallback) {
		var map = this.maps[this.api];
		var visibleCount = 0;
		var f;
		if (this.filters) {
			switch (this.api) {
				case 'multimap':
					/* TODO polylines aren't filtered in multimap */
					var mmfilters = [];
					for (f = 0; f < this.filters.length; f++) {
						mmfilters.push(new MMSearchFilter(this.filters[f][0], this.filters[f][1], this.filters[f][2]));
					}
					map.setMarkerFilters(mmfilters);
					map.redrawMap();
					break;
				case '  dummy':
					break;
				default:
					var vis;
					for (var m = 0; m < this.markers.length; m++) {
						vis = true;
						for (f = 0; f < this.filters.length; f++) {
							if (!this.applyFilter(this.markers[m], this.filters[f])) {
								vis = false;
							}
						}
						if (vis) {
							visibleCount++;
							if (showCallback) {
								showCallback(this.markers[m]);
							}
							else {
								this.markers[m].show();
							}
						}
						else {
							if (hideCallback) {
								hideCallback(this.markers[m]);
							}
							else {
								this.markers[m].hide();
							}
						}

						this.markers[m].setAttribute("visible", vis);
					}
					break;
			}
		}
		return visibleCount;
	};

	Mapstraction.prototype.applyFilter = function (o, f) {
		var vis = true;
		switch (f[1]) {
			case 'ge':
				if (o.getAttribute(f[0]) < f[2]) {
					vis = false;
				}
				break;
			case 'le':
				if (o.getAttribute(f[0]) > f[2]) {
					vis = false;
				}
				break;
			case 'eq':
				if (o.getAttribute(f[0]) == f[2]) {
					vis = false;
				}
				break;
			case 'in':
				if (typeof(o.getAttribute(f[0])) == 'undefined') {
					vis = false;
				} else if (o.getAttribute(f[0]).indexOf(f[2]) == -1) {
					vis = false;
				}
				break;
		}

		return vis;
	};

	/**
	 * getAttributeExtremes returns the minimum/maximum of "field" from all markers
	 * @param {field} name of "field" to query
	 * @returns {Array} of minimum/maximum
	 */
	Mapstraction.prototype.getAttributeExtremes = function (field) {
		var min;
		var max;
		for (var m = 0; m < this.markers.length; m++) {
			if (!min || min > this.markers[m].getAttribute(field)) {
				min = this.markers[m].getAttribute(field);
			}
			if (!max || max < this.markers[m].getAttribute(field)) {
				max = this.markers[m].getAttribute(field);
			}
		}
		for (var p = 0; m < this.polylines.length; m++) {
			if (!min || min > this.polylines[p].getAttribute(field)) {
				min = this.polylines[p].getAttribute(field);
			}
			if (!max || max < this.polylines[p].getAttribute(field)) {
				max = this.polylines[p].getAttribute(field);
			}
		}

		return [min, max];
	};

	/**
	 * getMap returns the native map object that mapstraction is talking to
	 * @returns the native map object mapstraction is using
	 */
	Mapstraction.prototype.getMap = function () {
		// FIXME in an ideal world this shouldn't exist right?
		return this.maps[this.api];
	};


//////////////////////////////
//
//   LatLonPoint
//
/////////////////////////////

	/**
	 * Defines a coordinate point, expressed as a latitude and longitude.
	 * @name mxn.LatLonPoint
	 * @constructor
	 * @param {number} lat The point's latitude
	 * @param {number} lon The point's longitude
	 * @exports LatLonPoint as mxn.LatLonPoint
	 */
	var LatLonPoint = mxn.LatLonPoint = function (lat, lon) {
		this.lat = Number(lat); // force to be numeric
		this.lon = Number(lon);
		this.lng = this.lon; // lets be lon/lng agnostic

		this.invoker = new mxn.Invoker(this, 'LatLonPoint');
	};

	mxn.addProxyMethods(LatLonPoint, [
	/**
	 * Extract the lat and lon values from a proprietary point.
	 * @name mxn.LatLonPoint#fromProprietary
	 * @function
	 * @param {string} api The API ID of the proprietary point.
	 * @param {Object} point The proprietary point.
	 */
		'fromProprietary',

	/**
	 * Converts the current LatLonPoint to a proprietary one for the API specified by <code>api</code>.
	 * @name mxn.LatLonPoint#toProprietary
	 * @function
	 * @param {string} api The API ID of the proprietary point.
	 * @returns A proprietary point.
	 */
		'toProprietary'
	], true);

	/**
	 * Returns a string representation of a point
	 * @name mxn.LatLonPoint#toString
	 * @param {Number} places Optional number of decimal places to display for the lat and long
	 * @returns A string like '51.23, -0.123'
	 * @type {string}
	 */
	LatLonPoint.prototype.toString = function (places) {
		if (typeof places !== 'undefined') {
			return this.lat.toFixed(places) + ', ' + this.lon.toFixed(places);
		}
		else {
			return this.lat + ', ' + this.lon;
		}
	};

	/**
	 * Returns the distance in kilometers between two <code>mxn.LatLonPoint</code> objects.
	 * @param {mxn.LatLonPoint} otherPoint The other point to measure the distance from to this one
	 * @returns The distance between the points in kilometers
	 * @type {number}
	 */
	LatLonPoint.prototype.distance = function (otherPoint) {
		// Uses Haversine formula from http://www.movable-type.co.uk
		var rads = Math.PI / 180;
		var diffLat = (this.lat - otherPoint.lat) * rads;
		var diffLon = (this.lon - otherPoint.lon) * rads;
		var a = Math.sin(diffLat / 2) * Math.sin(diffLat / 2) +
			Math.cos(this.lat * rads) * Math.cos(otherPoint.lat * rads) *
			Math.sin(diffLon / 2) * Math.sin(diffLon / 2);
		return 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)) * 6371; // Earth's mean radius in km
	};

	/**
	 * Tests if this <code>mxn.LatLonPoint</code> is equal to another point by precisely comparing the latitude and longitude values.
	 * @param {mxn.LatLonPoint} otherPoint The other point to test with
	 * @returns true or false
	 * @type {boolean}
	 */
	LatLonPoint.prototype.equals = function (otherPoint) {
		return this.lat == otherPoint.lat && this.lon == otherPoint.lon;
	};

	/**
	 * Returns the latitude conversion based on the map's current projection
	 * @returns {number} conversion
	 */
	LatLonPoint.prototype.latConv = function () {
		return this.distance(new LatLonPoint(this.lat + 0.1, this.lon)) * 10;
	};

	/**
	 * Returns the longitude conversion based on the map's current projection
	 * @returns {number} conversion
	 */
	LatLonPoint.prototype.lonConv = function () {
		return this.distance(new LatLonPoint(this.lat, this.lon + 0.1)) * 10;
	};


//////////////////////////
//
//  BoundingBox
//
//////////////////////////

	/**
	 * Defines a bounding box, expressed as a rectangle by coordinates for the south west and north east corners.
	 * @name mxn.BoundingBox
	 * @constructor
	 * @param {number} swlat The latitude of the south-west point
	 * @param {number} swlon The longitude of the south-west point
	 * @param {number} nelat The latitude of the north-east point
	 * @param {number} nelon The longitude of the north-east point
	 * @exports BoundingBox as mxn.BoundingBox
	 */
	var BoundingBox = mxn.BoundingBox = function (swlat, swlon, nelat, nelon) {
		//FIXME throw error if box bigger than world
		this.sw = new LatLonPoint(swlat, swlon);
		this.ne = new LatLonPoint(nelat, nelon);
		this.se = new LatLonPoint(swlat, nelon);
		this.nw = new LatLonPoint(nelat, swlon);
	};

	/**
	 * Returns the <code>mxn.LatLonPoint</code> of the south-west point of the bounding box
	 * @returns The south-west point of the bounding box
	 * @type {mxn.LatLonPoint}
	 */
	BoundingBox.prototype.getSouthWest = function () {
		return this.sw;
	};

	/**
	 * Returns the <code>mxn.LatLonPoint</code> of the south-east point of the bounding box
	 * @returns The south-east point of the bounding box
	 * @type {mxn.LatLonPoint}
	 */
	BoundingBox.prototype.getSouthEast = function () {
		return this.se;
	};

	/**
	 * Returns the <code>mxn.LatLonPoint</code> of the north-west point of the bounding box
	 * @returns The north-west point of the bounding box
	 * @type {mxn.LatLonPoint}
	 */
	BoundingBox.prototype.getNorthWest = function () {
		return this.nw;
	};

	/**
	 * Returns the <code>mxn.LatLonPoint</code> of the north-east point of the bounding box
	 * @returns The north-east point of the bounding box
	 * @type {mxn.LatLonPoint}
	 */
	BoundingBox.prototype.getNorthEast = function () {
		return this.ne;
	};

	/**
	 * Determines if this <code>mxn.BoundingBox</code> has a zero area
	 * @returns Whether the north-east and south-west points of the bounding box are the same point
	 * @type {boolean}
	 */
	BoundingBox.prototype.isEmpty = function () {
		return this.ne == this.sw; // is this right? FIXME
	};

	/**
	 * Determines whether a given <code>mxn.LatLonPoint</code> is within an <code>mxn.BoundingBox</code>
	 * @param {mxn.LatLonPoint} point the point to test with
	 * @returns Whether point is within this bounding box
	 * @type {boolean}
	 */
	BoundingBox.prototype.contains = function (point) {
		return point.lat >= this.sw.lat && point.lat <= this.ne.lat &&
			((this.sw.lon <= this.ne.lon && point.lon >= this.sw.lon && point.lon <= this.ne.lon) ||
			(this.sw.lon > this.ne.lon && (point.lon >= this.sw.lon || point.lon <= this.ne.lon)));
	};

	/**
	 * Returns an <code>mxn.LatLonPoint</code> with the lat and lon as the height and width of the <code>mxn.BoundingBox</code>
	 * @returns A <code>mxn.LatLonPoint</code> containing the height and width of this the <code>mxn.BoundingBox</code>
	 * @type {mxn.LatLonPoint}
	 */
	BoundingBox.prototype.toSpan = function () {
		return new LatLonPoint(Math.abs(this.sw.lat - this.ne.lat), Math.abs(this.sw.lon - this.ne.lon));
	};


	/**
	 * Returns a string representation of an <code>mxn.BoundingBox</code>
	 * @param {Number} [places] Optional number of decimal places to display for each lat and long
	 * @returns A string like <code>SW: 52.62647572585443, 41.90677719368304, NE: 55.21343254471387, 56.01322251932069</code>
	 * @type {string}
	 */
	BoundingBox.prototype.toString = function (places) {
		var sw;
		var ne;

		if (typeof places !== 'undefined') {
			sw = this.sw.toString(places);
			ne = this.ne.toString(places);
		}
		else {

			sw = this.sw;
			ne = this.ne;
		}

		return 'SW: ' + sw + ', NE: ' + ne;
	};

	/**
	 * Extends the <code>mxn.BoundingBox</code> to include the new the <code>mxn.LatLonPoint</code>
	 * @param {mxn.LatLonPoint} point The <code>mxn.LatLonPoint</code> around which the <code>mxn.BoundingBox</code> should be extended
	 */
	BoundingBox.prototype.extend = function (point) {
		var extended = false;
		if (this.sw.lat > point.lat) {
			this.sw.lat = point.lat;
			extended = true;
		}
		if (this.sw.lon > point.lon) {
			this.sw.lon = point.lon;
			extended = true;
		}
		if (this.ne.lat < point.lat) {
			this.ne.lat = point.lat;
			extended = true;
		}
		if (this.ne.lon < point.lon) {
			this.ne.lon = point.lon;
			extended = true;
		}

		if (extended) {
			this.se = new LatLonPoint(this.sw.lat, this.ne.lon);
			this.nw = new LatLonPoint(this.ne.lat, this.sw.lon);
		}
		return;
	};

	/**
	 * Determines whether a given <code>mxn.BoundingBox</code> intersects another <code>mxn.BoundingBox</code>
	 * @param {mxn.BoundingBox} other The <code>mxn.BoundingBox</code> to test against
	 * @returns Whether the current <code>mxn.BoundingBox</code> overlaps the other
	 * @type {boolean}
	 */
	BoundingBox.prototype.intersects = function (other) {
		return this.sw.lat <= other.ne.lat && this.ne.lat >= other.sw.lat &&
			((this.sw.lon <= this.ne.lon && other.sw.lon <= other.ne.lon && this.sw.lon <= other.ne.lon && this.ne.lon >= other.sw.lon) ||
			(this.sw.lon > this.ne.lon && other.sw.lon > other.ne.lon) ||
			(this.sw.lon > this.ne.lon && other.sw.lon <= other.ne.lon && (this.sw.lon <= other.ne.lon || this.ne.lon >= other.sw.lon)) ||
			(this.sw.lon <= this.ne.lon && other.sw.lon > other.ne.lon && (this.ne.lon >= other.sw.lon || this.sw.lon <= other.ne.lon)));
	};

//////////////////////////////
//
//  Marker
//
///////////////////////////////

	/**
	 * Creates a Mapstraction map marker capable of showing an optional <code>infoBubble</code> pop-up.
	 * @name mxn.Marker
	 * @constructor
	 * @param {mxn.LatLonPoint} point The point specifying where on the map the <code>mxn.Marker</code> should be positioned.
	 * @exports Marker as mxn.Marker
	 */
	var Marker = mxn.Marker = function (point) {
		this.api = null;
		this.location = point;
		this.onmap = false;
		this.proprietary_marker = false;
		this.attributes = [];
		this.invoker = new mxn.Invoker(this, 'Marker', function () {
			return this.api;
		});
		mxn.addEvents(this, [
			'openInfoBubble',	// Info bubble opened
			'closeInfoBubble', 	// Info bubble closed
			'click'				// Marker clicked
		]);
	};

	mxn.addProxyMethods(Marker, [
	/**
	 * Retrieve the settings from a proprietary marker.
	 * @name mxn.Marker#fromProprietary
	 * @function
	 * @param {string} api The API ID of the proprietary point.
	 * @param {Object} marker The proprietary marker.
	 */
		'fromProprietary',

	/**
	 * Hide the marker.
	 * @name mxn.Marker#hide
	 * @function
	 */
		'hide',

	/**
	 * Open the marker's <code>infoBubble</code> pop-up
	 * @name mxn.Marker#openBubble
	 * @function
	 */
		'openBubble',

	/**
	 * Closes the marker's <code>infoBubble</code> pop-up
	 * @name mxn.Marker#closeBubble
	 * @function
	 */
		'closeBubble',

	/**
	 * Show the marker.
	 * @name mxn.Marker#show
	 * @function
	 */
		'show',

	/**
	 * Converts the current Marker to a proprietary one for the API specified by <code>api</code>.
	 * @name mxn.Marker#toProprietary
	 * @function
	 * @param {string} api The API ID of the proprietary marker.
	 * @returns {Object} A proprietary marker.
	 */
		'toProprietary',

	/**
	 * Updates the Marker with the location of the attached proprietary marker on the map.
	 * @name mxn.Marker#update
	 * @function
	 */
		'update'
	]);

	/**
	 * Sets a proprietary marker as a child of the current <code>mxn.Marker</code>.
	 * @name mxn.Marker#setChild
	 * @function
	 * @param {Object} childMarker The proprietary marker's object
	 */
	Marker.prototype.setChild = function (childMarker) {
		this.proprietary_marker = childMarker;
		childMarker.mapstraction_marker = this;
		this.onmap = true;
	};

	/**
	 * Sets the label text of the current <code>mxn.Marker</code>. The label is used in some maps
	 * API implementation as the text to be displayed when the mouse pointer hovers over the marker.
	 * @name mxn.Marker#setLabel
	 * @function
	 * @param {string} labelText The text to be used for the label
	 */
	Marker.prototype.setLabel = function (labelText) {
		this.labelText = labelText;
	};

	/**
	 * Sets the properties of a marker via an object literal, which contains the following
	 * property name/value pairs:
	 *
	 * <pre>
	 * options = {
 *	label: 'marker label; see <code>mxn.Marker.setLabel()</code>',
 *	infoBubble: 'infoBubble text or HTML, see <code>mxn.Marker.setInfoBubble()</code>',
 *	icon: 'icon image URL, see <code>mxn.Marker.setIcon()</code>',
 *	iconSize: 'icon image size, see <code>mxn.Marker.setIcon()</code>',
 *	iconAnchor: 'icon image anchor, see <code>mxn.Marker.setIcon()</code>',
 *	iconShadow: 'icon shadow image URL, see <code>mxn.Marker.setShadowIcon()</code>',
 *	iconShadowSize: 'icon shadow size, see <code>mxn.Marker.setShadowIcon()</code>',
 *	infoDiv: 'informational div, see <code>mxn.Marker.setInfoDiv()</code>',
 *	draggable: 'draggable state, see <code>mxn.Marker.setDraggable()</code>',
 *	hover: 'hover text, see <code>mxn.Marker.setHover()</code>',
 *	hoverIcon: 'hover icon URL, see <code>mxn.Marker.setHoverIcon()</code>',
 *	openBubble: 'if specified, calls <code>mxn.Marker.openBubble()</code>',
 *	closeBubble: 'if specified, calls <code>mxn.Marker.closeBubble()</code>',
 *	groupName: 'marker group name, see <code>mxn.Marker.setGroupName()</code>'
 * };
	 * </pre>
	 *
	 * <p>Any other literal name value pairs are added to the marker's list of properties.</p>
	 * @param {Object} options An object literal of property name/value pairs.
	 */
	Marker.prototype.addData = function (options) {
		for (var sOptKey in options) {
			if (options.hasOwnProperty(sOptKey)) {
				switch (sOptKey) {
					case 'label':
						this.setLabel(options.label);
						break;
					case 'infoBubble':
						this.setInfoBubble(options.infoBubble);
						break;
					case 'icon':
						if (options.iconSize && options.iconAnchor) {
							this.setIcon(options.icon, options.iconSize, options.iconAnchor);
						}
						else if (options.iconSize) {
							this.setIcon(options.icon, options.iconSize);
						}
						else {
							this.setIcon(options.icon);
						}
						break;
					case 'iconShadow':
						if (options.iconShadowSize) {
							this.setShadowIcon(options.iconShadow, [options.iconShadowSize[0], options.iconShadowSize[1]]);
						}
						else {
							this.setIcon(options.iconShadow);
						}
						break;
					case 'infoDiv':
						this.setInfoDiv(options.infoDiv[0], options.infoDiv[1]);
						break;
					case 'draggable':
						this.setDraggable(options.draggable);
						break;
					case 'hover':
						this.setHover(options.hover);
						break;
					case 'hoverIcon':
						this.setHoverIcon(options.hoverIcon);
						break;
					case 'openBubble':
						this.openBubble();
						break;
					case 'closeBubble':
						this.closeBubble();
						break;
					case 'groupName':
						this.setGroupName(options.groupName);
						break;
					default:
						// don't have a specific action for this bit of
						// data so set a named attribute
						this.setAttribute(sOptKey, options[sOptKey]);
						break;
				}
			}
		}
	};

	/**
	 * Sets the HTML or text content for the marker's <code>InfoBubble</code> pop-up.
	 * @param {string} infoBubble The HTML or plain text to be displayed
	 */
	Marker.prototype.setInfoBubble = function (infoBubble) {
		this.infoBubble = infoBubble;
	};

	/**
	 * Sets the text content and the id of the <code>DIV</code> element to display additional
	 * information associated with the marker; useful for putting information in a <code>DIV</code>
	 * outside of the map
	 * @param {string} infoDiv The HMTML or text content to be displayed
	 * @param {string} div The element id to use for displaying the HTML or text content
	 */
	Marker.prototype.setInfoDiv = function (infoDiv, div) {
		this.infoDiv = infoDiv;
		this.div = div;
	};

	/**
	 * Sets the icon for a marker
	 * @param {string} iconUrl The URL of the image you want to be the icon
	 */
	Marker.prototype.setIcon = function (iconUrl, iconSize, iconAnchor) {
		this.iconUrl = iconUrl;
		if (iconSize) {
			this.iconSize = iconSize;
		}
		if (iconAnchor) {
			this.iconAnchor = iconAnchor;
		}
		if (this.proprietary_marker && this.proprietary_marker.setIcon) {
			this.proprietary_marker.setIcon(this.iconUrl, this.iconSize, this.iconAnchor);
		}
	};

	/**
	 * Sets the size of the icon for a marker
	 * @param {Array} iconSize The array size in pixels of the marker image: <code>[width, height]</code>
	 */
	Marker.prototype.setIconSize = function (iconSize) {
		if (iconSize) {
			this.iconSize = iconSize;
		}
	};

	/**
	 * Sets the anchor point for a marker
	 * @param {Array} iconAnchor The array offset in pixels of the anchor point from top left: <code>[right, down]</code>
	 */
	Marker.prototype.setIconAnchor = function (iconAnchor) {
		if (iconAnchor) {
			this.iconAnchor = iconAnchor;
		}
	};

	/**
	 * Sets the icon for a marker
	 * @param {string} iconUrl The URL of the image you want to be the icon
	 */
	Marker.prototype.setShadowIcon = function (iconShadowUrl, iconShadowSize) {
		this.iconShadowUrl = iconShadowUrl;
		if (iconShadowSize) {
			this.iconShadowSize = iconShadowSize;
		}
	};

	/**
	 * Sets the icon to be used on hover
	 * @param {strong} hoverIconUrl The URL of the image to be used
	 */
	Marker.prototype.setHoverIcon = function (hoverIconUrl) {
		this.hoverIconUrl = hoverIconUrl;
	};

	/**
	 * Sets the draggable state of the marker
	 * @param {boolean} draggable Set to <code>true</code> if the marker should be draggable by the user
	 */
	Marker.prototype.setDraggable = function (draggable) {
		this.draggable = draggable;
	};

	/**
	 * Sets that the marker label is to be displayed on hover
	 * @param {boolean} hover Set to <code>true</code> if the marker should display the label on hover
	 */
	Marker.prototype.setHover = function (hover) {
		this.hover = hover;
	};

	/**
	 * Add this marker to a named group; used in decluttering a group of markers.
	 * @param {string} groupName Name of the marker's group
	 * @see mxn.Mapstraction.declutterGroup
	 */
	Marker.prototype.setGroupName = function (groupName) {
		this.groupName = groupName;
	};

	/**
	 * Set an arbitrary property name and value on a marker
	 * @param {string} key The property key name
	 * @param {string} value The property value to be associated with the key
	 */
	Marker.prototype.setAttribute = function (key, value) {
		this.attributes[key] = value;
	};

	/**
	 * Gets the value of a marker's property
	 * @param {string} key The key whose value is to be returned
	 * @returns {string} The value associated with the key
	 */
	Marker.prototype.getAttribute = function (key) {
		return this.attributes[key];
	};


///////////////
// Polyline ///
///////////////

	/**
	 * Creates a Mapstraction Polyline; either an open-ended polyline or an enclosed polygon.
	 * @name mxn.Polyline
	 * @constructor
	 * @param {Array} points Array of <code>mxn.LatLonPoint</code> that make up the Polyline.
	 * @exports Polyline as mxn.Polyline
	 */
	var Polyline = mxn.Polyline = function (points) {
		this.api = null;
		this.points = points;
		this.attributes = [];
		this.onmap = false;
		this.proprietary_polyline = false;
		this.pllID = "mspll-" + new Date().getTime() + '-' + (Math.floor(Math.random() * Math.pow(2, 16)));
		this.invoker = new mxn.Invoker(this, 'Polyline', function () {
			return this.api;
		});
		this.color = "#000000";
		this.width = 3;
		this.opacity = 0.5;
		this.closed = false;
		this.fillColor = "#808080";
	};

	mxn.addProxyMethods(Polyline, [

	/**
	 * Retrieve the settings from a proprietary polyline.
	 * @name mxn.Polyline#fromProprietary
	 * @function
	 * @param {string} api The API ID of the proprietary polyline.
	 * @param {Object} polyline The proprietary polyline.
	 */
		'fromProprietary',

	/**
	 * Hide the polyline.
	 * @name mxn.Polyline#hide
	 * @function
	 */
		'hide',

	/**
	 * Show the polyline.
	 * @name mxn.Polyline#show
	 * @function
	 */
		'show',

	/**
	 * Converts the current Polyline to a proprietary one for the API specified by <code>api</code>.
	 * @name mxn.Polyline#toProprietary
	 * @function
	 * @param {string} api The API ID of the proprietary polyline.
	 * @returns {Object} A proprietary polyline.
	 */
		'toProprietary',

	/**
	 * Updates the Polyline with the path of the attached proprietary polyline on the map.
	 * @name mxn.Polyline#update
	 * @function
	 */
		'update'
	]);

	/**
	 * <p>Sets the properties of a polyline via an object literal, which contains the following
	 * property name/value pairs:</p>
	 *
	 * <pre>
	 * options = {
 *	color: 'line color; see <code>mxn.Polyline.setColor()</code>',
 *	width: 'line stroke width; see <code>mxn.Polyline.setWidth()</code>',
 *	opacity: 'polyline opacity; see <code>mxn.Polyline.setOpacity()</code>',
 *	closed: 'polyline or polygon; see <code>mxn.Polyline.setClosed()</code>',
 *	fillColor: 'fill color; see <code>mxn.Polyline.seFillColor()</code>',
 * };
	 * </pre>
	 *
	 * <p>Any other literal name value pairs are added to the marker's list of properties.</p>
	 * @param {Object} options An object literal of property name/value pairs.
	 */
	Polyline.prototype.addData = function (options) {
		for (var sOpt in options) {
			if (options.hasOwnProperty(sOpt)) {
				switch (sOpt) {
					case 'color':
						this.setColor(options.color);
						break;
					case 'width':
						this.setWidth(options.width);
						break;
					case 'opacity':
						this.setOpacity(options.opacity);
						break;
					case 'closed':
						this.setClosed(options.closed);
						break;
					case 'fillColor':
						this.setFillColor(options.fillColor);
						break;
					default:
						this.setAttribute(sOpt, options[sOpt]);
						break;
				}
			}
		}
	};

	/**
	 * Sets a proprietary polyline as a child of the current <code>mxn.Polyline</code>.
	 * @param {Object} childPolyline The proprietary polyline's object
	 */
	Polyline.prototype.setChild = function (childPolyline) {
		this.proprietary_polyline = childPolyline;
		this.onmap = true;
	};

	/**
	 * Sets the line color for the polyline.
	 * @param {string} color RGB color expressed in the form <code>#RRGGBB</code>
	 */
	Polyline.prototype.setColor = function (color) {
		this.color = (color.length == 7 && color[0] == "#") ? color.toUpperCase() : color;
	};

	/**
	 * Sets the line stroke width of the polyline
	 * @param {number} width Line stroke width in pixels.
	 */
	Polyline.prototype.setWidth = function (width) {
		this.width = width;
	};

	/**
	 * Sets the polyline opacity.
	 * @param {number} opacity A number between <code>0.0</code> (transparent) and <code>1.0</code> (opaque)
	 */
	Polyline.prototype.setOpacity = function (opacity) {
		this.opacity = opacity;
	};

	/**
	 * Marks the polyline as a closed polygon
	 * @param {boolean} closed Specify as <code>true</code> to mark the polyline as an enclosed polygon
	 */
	Polyline.prototype.setClosed = function (closed) {
		this.closed = closed;
	};

	/**
	 * Sets the fill color for a closed polyline.
	 * @param {string} color RGB color expressed in the form <code>#RRGGBB</code>
	 */
	Polyline.prototype.setFillColor = function (fillColor) {
		this.fillColor = fillColor;
	};


	/**
	 * Set an arbitrary property name and value on a polyline
	 * @param {string} key The property key name
	 * @param {string} value The property value to be associated with the key
	 */
	Polyline.prototype.setAttribute = function (key, value) {
		this.attributes[key] = value;
	};

	/**
	 * Gets the value of a polyline's property
	 * @param {string} key The key whose value is to be returned
	 * @returns {string} The value associated with the key
	 */
	Polyline.prototype.getAttribute = function (key) {
		return this.attributes[key];
	};

	/**
	 * Simplifies a polyline, averaging and reducing the points
	 * @param {number} tolerance The simplification tolerance; 1.0 is a good starting point
	 */
	Polyline.prototype.simplify = function (tolerance) {
		var reduced = [];

		// First point
		reduced[0] = this.points[0];

		var markerPoint = 0;

		for (var i = 1; i < this.points.length - 1; i++) {
			if (this.points[i].distance(this.points[markerPoint]) >= tolerance) {
				reduced[reduced.length] = this.points[i];
				markerPoint = i;
			}
		}

		// Last point
		reduced[reduced.length] = this.points[this.points.length - 1];

		// Revert
		this.points = reduced;
	};

///////////////
// Radius	//
///////////////

	/**
	 * Creates a Mapstraction Radius for drawing circles around a given point. Note that creating
	 * a radius performs a lot of initial calculation which can lead to increased page load times.
	 * @name mxn.Radius
	 * @constructor
	 * @param {mxn.LatLonPoint} center Central <code>mxn.LatLonPoint</code> of the radius
	 * @param {number} quality Number of points that comprise the approximated circle (20 is a good starting point)
	 * @exports Radius as mxn.Radius
	 */
	var Radius = mxn.Radius = function (center, quality) {
		this.center = center;
		var latConv = center.latConv();
		var lonConv = center.lonConv();

		// Create Radian conversion constant
		var rad = Math.PI / 180;
		this.calcs = [];

		for (var i = 0; i < 360; i += quality) {
			this.calcs.push([Math.cos(i * rad) / latConv, Math.sin(i * rad) / lonConv]);
		}
	};

	/**
	 * Returns the <code>mxn.Polyline</code> of a circle around the point based on a new radius value.
	 * @param {number} radius The new radius value
	 * @param {string} color RGB fill color expressed in the form <code>#RRGGBB</code>
	 * @returns {Polyline} The calculated <code>mxn.Polyline</code>
	 */
	Radius.prototype.getPolyline = function (radius, color) {
		var points = [];

		for (var i = 0; i < this.calcs.length; i++) {
			var point = new LatLonPoint(
				this.center.lat + (radius * this.calcs[i][0]),
				this.center.lon + (radius * this.calcs[i][1])
			);
			points.push(point);
		}

		// Add first point
		points.push(points[0]);

		var line = new Polyline(points);
		line.setColor(color);

		return line;
	};

	/**
	 * Initialise our provider. This function should only be called
	 * from within mapstraction code, not exposed as part of the API.
	 * @private
	 */
	var initGeocoder = function () {
		this.invoker.go('init');
	};

	/**
	 * Geocoder instantiates a geocoder with some API choice
	 * @name mxn.Geocoder
	 * @constructor
	 * @param {String} api The API to use, currently only 'mapquest' is supported
	 * @param {Function} callback The function to call when a geocode request returns (function(waypoint))
	 * @param {Function} error_callback The optional function to call when a geocode request fails
	 * @exports Geocoder as mxn.Geocoder
	 */
	var Geocoder = mxn.Geocoder = function (api, callback, error_callback) {
		this.api = api;
		this.geocoders = {};
		this.callback = callback;
		this.error_callback = error_callback || function () {
			};

		// set up our invoker for calling API methods
		this.invoker = new mxn.Invoker(this, 'Geocoder', function () {
			return this.api;
		});
		initGeocoder.apply(this);
	};

	mxn.addProxyMethods(Geocoder, [

	/**
	 * Geocodes the provided address.
	 * @name mxn.Geocoder#geocode
	 * @function
	 * @param {Object} address Address hash, keys are: street, locality, region, country.
	 */
		'geocode',

		'geocode_callback'

	]);

	/**
	 * Change the geocoding API in use
	 * @name mxn.Geocoder#swap
	 * @param {String} api The API to swap to
	 */
	Geocoder.prototype.swap = function (api) {
		if (this.api == api) {
			return;
		}

		this.api = api;
		if (!this.geocoders.hasOwnProperty(this.api)) {
			initGeocoder.apply(this);
		}
	};

	/*
	 MAPSTRACTION   v2.0.18   http://www.mapstraction.com

	 Copyright (c) 2012 Tom Carden, Steve Coast, Mikel Maron, Andrew Turner, Henri Bergius, Rob Moran, Derek Fowler, Gary Gale
	 All rights reserved.

	 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	 * Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	 * Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	 * Neither the name of the Mapstraction nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

	 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	mxn.register('googlev3', {

		Mapstraction: {

			init: function (element, api) {
				var me = this;

				if (typeof google.maps.Map === 'undefined') {
					throw new Error(api + ' map script not imported');
				}

				var myOptions = {
					disableDefaultUI: true,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					mapTypeControl: false,
					mapTypeControlOptions: null,
					navigationControl: false,
					navigationControlOptions: null,
					scrollwheel: false,
					disableDoubleClickZoom: true
				};

				// Background color can only be set at construction
				// To provide some control, adopt any explicit element style
				var backgroundColor = null;
				if (element.currentStyle) {
					backgroundColor = element.currentStyle['background-color'];
				}
				else if (window.getComputedStyle) {
					backgroundColor = document.defaultView.getComputedStyle(element, null).getPropertyValue('background-color');
				}
				// Only set the background if a style has been explicitly set, ruling out the "transparent" default
				if (backgroundColor && 'transparent' !== backgroundColor) {
					myOptions.backgroundColor = backgroundColor;
				}

				// find controls
				if (!this.addControlsArgs && loadoptions.addControlsArgs) {
					this.addControlsArgs = loadoptions.addControlsArgs;
				}
				if (this.addControlsArgs) {
					if (this.addControlsArgs.zoom) {
						myOptions.navigationControl = true;
						if (this.addControlsArgs.zoom == 'small') {
							myOptions.navigationControlOptions = {style: google.maps.NavigationControlStyle.SMALL};
						}
						if (this.addControlsArgs.zoom == 'large') {
							myOptions.navigationControlOptions = {style: google.maps.NavigationControlStyle.ZOOM_PAN};
						}
					}
					if (this.addControlsArgs.map_type) {
						myOptions.mapTypeControl = true;
						myOptions.mapTypeControlOptions = {style: google.maps.MapTypeControlStyle.DEFAULT};
					}
					if (this.addControlsArgs.overview) {
						myOptions.overviewMapControl = true;
						myOptions.overviewMapControlOptions = {opened: true};
					}
				}

				var map = new google.maps.Map(element, myOptions);

				var fireOnNextIdle = [];

				google.maps.event.addListener(map, 'idle', function () {
					var fireListCount = fireOnNextIdle.length;
					if (fireListCount > 0) {
						var fireList = fireOnNextIdle.splice(0, fireListCount);
						var handler;
						while ((handler = fireList.shift())) {
							handler();
						}
					}
				});

				// deal with click
				google.maps.event.addListener(map, 'click', function (location) {
					me.click.fire({
						'location': new mxn.LatLonPoint(location.latLng.lat(), location.latLng.lng())
					});
				});

				// deal with zoom change
				google.maps.event.addListener(map, 'zoom_changed', function () {
					// zoom_changed fires before the zooming has finished so we
					// wait for the next idle event before firing our changezoom
					// so that method calls report the correct values
					fireOnNextIdle.push(function () {
						me.changeZoom.fire();
					});
				});

				// deal with map movement
				var is_dragging = false;

				google.maps.event.addListener(map, 'dragstart', function () {
					is_dragging = true;
				});

				google.maps.event.addListener(map, 'dragend', function () {
					me.moveendHandler(me);
					me.endPan.fire();
					is_dragging = false;
				});

				google.maps.event.addListener(map, 'center_changed', function () {
					if (!is_dragging) {
						fireOnNextIdle.push(function () {
							me.endPan.fire();
						});
					}
				});

				// deal with initial tile loading
				var loadListener = google.maps.event.addListener(map, 'tilesloaded', function () {
					me.load.fire();
					google.maps.event.removeListener(loadListener);
				});

				this.maps[api] = map;
				this.loaded[api] = true;
			},

			applyOptions: function () {
				var map = this.maps[this.api];
				var myOptions = [];
				if (this.options.enableDragging) {
					myOptions.draggable = true;
				}
				else {
					myOptions.draggable = false;
				}
				if (this.options.enableScrollWheelZoom) {
					myOptions.scrollwheel = true;
				}
				else {
					myOptions.scrollwheel = false;
				}
				if (this.options.disableDoubleClickZoom) {
					myOptions.disableDoubleClickZoom = true;
				}
				else {
					myOptions.disableDoubleClickZoom = false;
				}
				map.setOptions(myOptions);
			},

			resizeTo: function (width, height) {
				this.currentElement.style.width = width;
				this.currentElement.style.height = height;
				var map = this.maps[this.api];
				google.maps.event.trigger(map, 'resize');
			},

			addControls: function (args) {
				/* args = {
				 *     pan:      true,
				 *     zoom:     'large' || 'small',
				 *     overview: true,
				 *     scale:    true,
				 *     map_type: true,
				 * }
				 */

				var map = this.maps[this.api];
				var myOptions;

				// Google has a combined zoom and pan control.

				if ('pan' in args && args.pan) {
					myOptions = {panControl: true};
					map.setOptions(myOptions);
					this.addControlsArgs.pan = true;

				}

				else if (!('pan' in args) || ('pan' in args && !args.pan)) {
					myOptions = {panControl: false};
					map.setOptions(myOptions);
					this.addControlsArgs.pan = false;
				}

				if ('zoom' in args) {
					if (args.zoom == 'small') {
						this.addSmallControls();
					}

					else if (args.zoom == 'large') {
						this.addLargeControls();
					}
				}

				else {
					myOptions = {zoomControl: false};
					map.setOptions(myOptions);
					this.addControlsArgs.zoom = false;
				}

				if ('scale' in args && args.scale) {
					myOptions = {
						scaleControl: true,
						scaleControlOptions: {style: google.maps.ScaleControlStyle.DEFAULT}
					};
					map.setOptions(myOptions);
					this.addControlsArgs.scale = true;
				}

				else {
					myOptions = {scaleControl: false};
					map.setOptions(myOptions);
					this.addControlsArgs.scale = false;
				}

				if ('map_type' in args && args.map_type) {
					this.addMapTypeControls();
				}

				else {
					myOptions = {mapTypeControl: false};
					map.setOptions(myOptions);
					this.addControlsArgs.map_type = false;
				}

				if ('overview' in args) {
					myOptions = {
						overviewMapControl: true,
						overviewMapControlOptions: {opened: true}
					};
					map.setOptions(myOptions);
					this.addControlsArgs.overview = true;
				}

				else {
					myOptions = {overviewMapControl: false};
					map.setOptions(myOptions);
					this.addControlsArgs.overview = false;
				}
			},

			addSmallControls: function () {
				var map = this.maps[this.api];
				var myOptions = {
					zoomControl: true,
					zoomControlOptions: {style: google.maps.ZoomControlStyle.SMALL}
				};
				map.setOptions(myOptions);
				this.addControlsArgs.zoom = 'small';
			},

			addLargeControls: function () {
				var map = this.maps[this.api];
				var myOptions = {
					panControl: true,
					zoomControl: true,
					zoomControlOptions: {style: google.maps.ZoomControlStyle.LARGE}
				};
				map.setOptions(myOptions);
				this.addControlsArgs.pan = true;
				this.addControlsArgs.zoom = 'large';
			},

			addMapTypeControls: function () {
				var map = this.maps[this.api];
				var myOptions = {
					mapTypeControl: true,
					mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DEFAULT}
				};
				map.setOptions(myOptions);
				this.addControlsArgs.map_type = true;
			},

			setCenterAndZoom: function (point, zoom) {
				var map = this.maps[this.api];
				var pt = point.toProprietary(this.api);
				map.setCenter(pt);
				map.setZoom(zoom);
			},

			addMarker: function (marker, old) {
				return marker.toProprietary(this.api);
			},

			removeMarker: function (marker) {
				marker.proprietary_marker.setMap(null);
			},

			declutterMarkers: function (opts) {
				throw new Error('Mapstraction.declutterMarkers is not currently supported by provider ' + this.api);
			},

			addPolyline: function (polyline, old) {
				var map = this.maps[this.api];
				var propPolyline = polyline.toProprietary(this.api);
				propPolyline.setMap(map);
				return propPolyline;
			},

			removePolyline: function (polyline) {
				var map = this.maps[this.api];
				polyline.proprietary_polyline.setMap(null);
			},

			getCenter: function () {
				var map = this.maps[this.api];
				var pt = map.getCenter();
				return new mxn.LatLonPoint(pt.lat(), pt.lng());
			},

			setCenter: function (point, options) {
				var map = this.maps[this.api];
				var pt = point.toProprietary(this.api);
				if (options && options.pan) {
					map.panTo(pt);
				}
				else {
					map.setCenter(pt);
				}
			},

			setZoom: function (zoom) {
				var map = this.maps[this.api];
				map.setZoom(zoom);
			},

			getZoom: function () {
				var map = this.maps[this.api];
				return map.getZoom();
			},

			getZoomLevelForBoundingBox: function (bbox) {
				var map = this.maps[this.api];
				var sw = bbox.getSouthWest().toProprietary(this.api);
				var ne = bbox.getNorthEast().toProprietary(this.api);
				var gLatLngBounds = new google.maps.LatLngBounds(sw, ne);
				map.fitBounds(gLatLngBounds);
				return map.getZoom();
			},

			setMapType: function (type) {
				var map = this.maps[this.api];
				switch (type) {
					case mxn.Mapstraction.ROAD:
						map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
						break;
					case mxn.Mapstraction.SATELLITE:
						map.setMapTypeId(google.maps.MapTypeId.SATELLITE);
						break;
					case mxn.Mapstraction.HYBRID:
						map.setMapTypeId(google.maps.MapTypeId.HYBRID);
						break;
					case mxn.Mapstraction.PHYSICAL:
						map.setMapTypeId(google.maps.MapTypeId.TERRAIN);
						break;
					default:
						map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
				}
			},

			getMapType: function () {
				var map = this.maps[this.api];
				var type = map.getMapTypeId();
				switch (type) {
					case google.maps.MapTypeId.ROADMAP:
						return mxn.Mapstraction.ROAD;
					case google.maps.MapTypeId.SATELLITE:
						return mxn.Mapstraction.SATELLITE;
					case google.maps.MapTypeId.HYBRID:
						return mxn.Mapstraction.HYBRID;
					case google.maps.MapTypeId.TERRAIN:
						return mxn.Mapstraction.PHYSICAL;
					default:
						return null;
				}
			},

			getBounds: function () {
				var map = this.maps[this.api];
				var gLatLngBounds = map.getBounds();
				if (!gLatLngBounds) {
					throw 'Mapstraction.getBounds; bounds not available, map must be initialized';
				}
				var sw = gLatLngBounds.getSouthWest();
				var ne = gLatLngBounds.getNorthEast();
				return new mxn.BoundingBox(sw.lat(), sw.lng(), ne.lat(), ne.lng());
			},

			setBounds: function (bounds) {
				var map = this.maps[this.api];
				var sw = bounds.getSouthWest().toProprietary(this.api);
				var ne = bounds.getNorthEast().toProprietary(this.api);
				var gLatLngBounds = new google.maps.LatLngBounds(sw, ne);
				map.fitBounds(gLatLngBounds);
			},

			addImageOverlay: function (id, src, opacity, west, south, east, north, oContext) {
				var map = this.maps[this.api];

				var imageBounds = new google.maps.LatLngBounds(
					new google.maps.LatLng(south, west),
					new google.maps.LatLng(north, east));

				var groundOverlay = new google.maps.GroundOverlay(src, imageBounds);
				groundOverlay.setMap(map);
			},

			setImagePosition: function (id, oContext) {
				throw new Error('Mapstraction.declutterMarkers is not currently supported by provider ' + this.api);
			},

			addOverlay: function (url, autoCenterAndZoom) {
				var map = this.maps[this.api];

				var opt = {preserveViewport: (!autoCenterAndZoom)};
				var layer = new google.maps.KmlLayer(url, opt);
				layer.setMap(map);
			},

			addTileLayer: function (tile_url, opacity, label, attribution, min_zoom, max_zoom, map_type, subdomains) {
				var map = this.maps[this.api];
				var z_index = this.tileLayers.length || 0;
				var tilelayer = {
					getTileUrl: function (coord, zoom) {
						var url = mxn.util.sanitizeTileURL(tile_url);
						if (typeof subdomains !== 'undefined') {
							url = mxn.util.getSubdomainTileURL(url, subdomains);
						}
						var x = coord.x;
						var maxX = Math.pow(2, zoom);
						while (x < 0) {
							x += maxX;
						}
						while (x >= maxX) {
							x -= maxX;
						}
						url = url.replace(/\{Z\}/gi, zoom);
						url = url.replace(/\{X\}/gi, x);
						url = url.replace(/\{Y\}/gi, coord.y);
						return url;
					},
					tileSize: new google.maps.Size(256, 256),
					isPng: true,
					minZoom: min_zoom,
					maxZoom: max_zoom,
					opacity: opacity,
					name: label
				};

				var tileLayerOverlay = new google.maps.ImageMapType(tilelayer);
				this.tileLayers.push([tile_url, tileLayerOverlay, true, z_index]);

				if (map_type) {
					map.mapTypes.set('tile' + z_index, tileLayerOverlay);
					var mapTypeIds = [
						google.maps.MapTypeId.ROADMAP,
						google.maps.MapTypeId.HYBRID,
						google.maps.MapTypeId.SATELLITE,
						google.maps.MapTypeId.TERRAIN
					];
					for (var f = 0; f < this.tileLayers.length; f++) {
						mapTypeIds.push('tile' + f);
					}
					var optionsUpdate = {mapTypeControlOptions: {mapTypeIds: mapTypeIds}};
					map.setOptions(optionsUpdate);
				}
				else {
					map.overlayMapTypes.insertAt(z_index, tileLayerOverlay);
				}

				return tileLayerOverlay;
			},

			toggleTileLayer: function (tile_url) {
				var map = this.maps[this.api];
				for (var f = 0; f < this.tileLayers.length; f++) {
					var tileLayer = this.tileLayers[f];
					if (tileLayer[0] == tile_url) {
						if (tileLayer[2]) {
							map.overlayMapTypes.removeAt(tileLayer[3]);
							tileLayer[2] = false;
						}
						else {
							map.overlayMapTypes.insertAt(tileLayer[3], tileLayer[1]);
							tileLayer[2] = true;
						}
					}
				}
			},

			getPixelRatio: function () {
				throw new Error('Mapstraction.getPixelRatio is not currently supported by provider ' + this.api);
			},

			mousePosition: function (element) {
				var map = this.maps[this.api];
				var locDisp = document.getElementById(element);
				if (locDisp !== null) {
					google.maps.event.addListener(map, 'mousemove', function (point) {
						var loc = point.latLng.lat().toFixed(4) + ' / ' + point.latLng.lng().toFixed(4);
						locDisp.innerHTML = loc;
					});
					locDisp.innerHTML = '0.0000 / 0.0000';
				}
			}
		},

		LatLonPoint: {

			toProprietary: function () {
				return new google.maps.LatLng(this.lat, this.lon);
			},

			fromProprietary: function (googlePoint) {
				this.lat = googlePoint.lat();
				this.lon = googlePoint.lng();
			}

		},

		Marker: {

			toProprietary: function () {
				var options = {};

				// do we have an Anchor?
				var ax = 0;  // anchor x
				var ay = 0;  // anchor y

				if (this.iconAnchor) {
					ax = this.iconAnchor[0];
					ay = this.iconAnchor[1];
				}
				var gAnchorPoint = new google.maps.Point(ax, ay);

				if (this.iconUrl) {
					options.icon = new google.maps.MarkerImage(
						this.iconUrl,
						new google.maps.Size(this.iconSize[0], this.iconSize[1]),
						new google.maps.Point(0, 0),
						gAnchorPoint
					);

					// do we have a Shadow?
					if (this.iconShadowUrl) {
						if (this.iconShadowSize) {
							var x = this.iconShadowSize[0];
							var y = this.iconShadowSize[1];
							options.shadow = new google.maps.MarkerImage(
								this.iconShadowUrl,
								new google.maps.Size(x, y),
								new google.maps.Point(0, 0),
								gAnchorPoint
							);
						}
						else {
							options.shadow = new google.maps.MarkerImage(this.iconShadowUrl);
						}
					}
				}
				if (this.draggable) {
					options.draggable = this.draggable;
				}
				if (this.labelText) {
					options.title = this.labelText;
				}
				if (this.imageMap) {
					options.shape = {
						coord: this.imageMap,
						type: 'poly'
					};
				}

				options.position = this.location.toProprietary(this.api);
				options.map = this.map;

				var marker = new google.maps.Marker(options);

				if (this.infoBubble) {
					var event_action = "click";
					if (this.hover) {
						event_action = "mouseover";
					}
					google.maps.event.addListener(marker, event_action, function () {
						marker.mapstraction_marker.openBubble();
					});
				}

				if (this.hoverIconUrl) {
					var gSize = new google.maps.Size(this.iconSize[0], this.iconSize[1]);
					var zerozero = new google.maps.Point(0, 0);
					var hIcon = new google.maps.MarkerImage(
						this.hoverIconUrl,
						gSize,
						zerozero,
						gAnchorPoint
					);
					var Icon = new google.maps.MarkerImage(
						this.iconUrl,
						gSize,
						zerozero,
						gAnchorPoint
					);
					google.maps.event.addListener(
						marker,
						"mouseover",
						function () {
							marker.setIcon(hIcon);
						}
					);
					google.maps.event.addListener(
						marker,
						"mouseout",
						function () {
							marker.setIcon(Icon);
						}
					);
				}

				google.maps.event.addListener(marker, 'click', function () {
					marker.mapstraction_marker.click.fire();
				});

				return marker;
			},

			openBubble: function () {
				var infowindow, marker = this;
				if (!this.hasOwnProperty('proprietary_infowindow') || this.proprietary_infowindow === null) {
					infowindow = new google.maps.InfoWindow({
						content: this.infoBubble
					});
					google.maps.event.addListener(infowindow, 'closeclick', function (closedWindow) {
						marker.closeBubble();
					});
				}
				else {
					infowindow = this.proprietary_infowindow;
				}
				this.openInfoBubble.fire({'marker': this});
				infowindow.open(this.map, this.proprietary_marker);
				this.proprietary_infowindow = infowindow; // Save so we can close it later
			},

			closeBubble: function () {
				if (this.hasOwnProperty('proprietary_infowindow') && this.proprietary_infowindow !== null) {
					this.proprietary_infowindow.close();
					this.proprietary_infowindow = null;
					this.closeInfoBubble.fire({'marker': this});
				}
			},

			hide: function () {
				this.proprietary_marker.setOptions({visible: false});
			},

			show: function () {
				this.proprietary_marker.setOptions({visible: true});
			},

			update: function () {
				var point = new mxn.LatLonPoint();
				point.fromProprietary('googlev3', this.proprietary_marker.getPosition());
				this.location = point;
			}

		},

		Polyline: {

			toProprietary: function () {
				var coords = [];

				for (var i = 0, length = this.points.length; i < length; i++) {
					coords.push(this.points[i].toProprietary('googlev3'));
				}

				var polyOptions = {
					path: coords,
					strokeColor: this.color,
					strokeOpacity: this.opacity,
					strokeWeight: this.width
				};

				if (this.closed) {
					if (!(this.points[0].equals(this.points[this.points.length - 1]))) {
						coords.push(coords[0]);
					}
				}

				else if (this.points[0].equals(this.points[this.points.length - 1])) {
					this.closed = true;
				}

				if (this.closed) {
					polyOptions.fillColor = this.fillColor;
					polyOptions.fillOpacity = polyOptions.strokeOpacity;

					this.proprietary_polyline = new google.maps.Polygon(polyOptions);
				}
				else {
					this.proprietary_polyline = new google.maps.Polyline(polyOptions);
				}

				return this.proprietary_polyline;
			},

			show: function () {
				this.proprietary_polyline.setVisible(true);
			},

			hide: function () {
				this.proprietary_polyline.setVisible(false);
			}
		}

	});

	/*
	 MAPSTRACTION   v2.0.18   http://www.mapstraction.com

	 Copyright (c) 2012 Tom Carden, Steve Coast, Mikel Maron, Andrew Turner, Henri Bergius, Rob Moran, Derek Fowler, Gary Gale
	 All rights reserved.

	 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	 * Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	 * Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	 * Neither the name of the Mapstraction nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

	 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	mxn.register('googlev3', {

		Geocoder: {
			init: function () {
				this.geocoders[this.api] = new google.maps.Geocoder();
			},

			geocode: function (query, rowlimit) {
				var me = this;
				me.row_limit = rowlimit || 1; //default to one result
				var geocode_request_object = {};
				if (typeof(query) == 'object') {
					// query is a LatLonPoint object (reverse geocode)
					if (query.hasOwnProperty('lat') && query.hasOwnProperty('lon')) {
						geocode_request_object.latLng = query.toProprietary(this.api);
					}
					// query is an address object
					else {
						var queryParams = [];
						if (query.street) {
							queryParams.push(query.street);
						}
						if (query.locality) {
							queryParams.push(query.locality);
						}
						if (query.country) {
							queryParams.push(query.country);
						}

						geocode_request_object.address = queryParams.join(', ');

						if (query.region) {
							geocode_request_object.region = query.region;
						}
					}
				}

				// query is an address string
				else {
					geocode_request_object.address = query;
				}

				this.geocoders[this.api].geocode(geocode_request_object, function (results, status) {
					me.geocode_callback(results, status);
				});
			},

			geocode_callback: function (results, status) {
				if (status != google.maps.GeocoderStatus.OK) {
					this.error_callback(status);
				}

				else {
					var places = [];

					// Code Health Warning
					// Don't let the fact that the Google geocoder returns 'results' as an array
					// fool you. Google 'generally' returns a single value when geocoding address
					// lookups; multiple values 'may' be returned but only where there is ambiguity
					// See https://developers.google.com/maps/documentation/geocoding/#JSON

					for (i = 0; i < results.length; i++) {
						place = results[i];
						var streetparts = [];
						var return_location = {};

						for (var k = 0; k < place.address_components.length; k++) {
							var addressComponent = place.address_components[k];
							for (var j = 0; j < addressComponent.types.length; j++) {
								var componentType = addressComponent.types[j];
								switch (componentType) {
									case 'country':
										return_location.country = addressComponent.long_name;
										break;
									case 'administrative_area_level_1':
										return_location.region = addressComponent.long_name;
										break;
									case 'locality':
										return_location.locality = addressComponent.long_name;
										break;
									case 'street_address':
										return_location.street = addressComponent.long_name;
										break;
									case 'postal_code':
										return_location.postcode = addressComponent.long_name;
										break;
									case 'street_number':
										streetparts.unshift(addressComponent.long_name);
										break;
									case 'route':
										streetparts.push(addressComponent.long_name);
										break;
								}
							}
						}

						if (return_location.street === '' && streetparts.length > 0) {
							return_location.street = streetparts.join(' ');
						}

						return_location.point = new mxn.LatLonPoint(place.geometry.location.lat(), place.geometry.location.lng());

						places.push(return_location);
					}

					if (this.row_limit <= 1) {
						this.callback(places[0]);
					}
					else {
						if (places.length > this.row_limit) {
							places.length = this.row_limit;
						}
						this.callback(places);
					}
				}
			}
		}

	});

	return mxn;

});


!function() {
  var d3 = {
    version: "3.5.17"
  };
  var d3_arraySlice = [].slice, d3_array = function(list) {
    return d3_arraySlice.call(list);
  };
  var d3_document = this.document;
  function d3_documentElement(node) {
    return node && (node.ownerDocument || node.document || node).documentElement;
  }
  function d3_window(node) {
    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
  }
  if (d3_document) {
    try {
      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
    } catch (e) {
      d3_array = function(list) {
        var i = list.length, array = new Array(i);
        while (i--) array[i] = list[i];
        return array;
      };
    }
  }
  if (!Date.now) Date.now = function() {
    return +new Date();
  };
  if (d3_document) {
    try {
      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
    } catch (error) {
      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
      d3_element_prototype.setAttribute = function(name, value) {
        d3_element_setAttribute.call(this, name, value + "");
      };
      d3_element_prototype.setAttributeNS = function(space, local, value) {
        d3_element_setAttributeNS.call(this, space, local, value + "");
      };
      d3_style_prototype.setProperty = function(name, value, priority) {
        d3_style_setProperty.call(this, name, value + "", priority);
      };
    }
  }
  d3.ascending = d3_ascending;
  function d3_ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }
  d3.descending = function(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
  };
  d3.min = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
    }
    return a;
  };
  d3.max = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
    }
    return a;
  };
  d3.extent = function(array, f) {
    var i = -1, n = array.length, a, b, c;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    }
    return [ a, c ];
  };
  function d3_number(x) {
    return x === null ? NaN : +x;
  }
  function d3_numeric(x) {
    return !isNaN(x);
  }
  d3.sum = function(array, f) {
    var s = 0, n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
    } else {
      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
    }
    return s;
  };
  d3.mean = function(array, f) {
    var s = 0, n = array.length, a, i = -1, j = n;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
    }
    if (j) return s / j;
  };
  d3.quantile = function(values, p) {
    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
    return e ? v + e * (values[h] - v) : v;
  };
  d3.median = function(array, f) {
    var numbers = [], n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
    }
    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
  };
  d3.variance = function(array, f) {
    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
    if (arguments.length === 1) {
      while (++i < n) {
        if (d3_numeric(a = d3_number(array[i]))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    } else {
      while (++i < n) {
        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    }
    if (j > 1) return s / (j - 1);
  };
  d3.deviation = function() {
    var v = d3.variance.apply(this, arguments);
    return v ? Math.sqrt(v) : v;
  };
  function d3_bisector(compare) {
    return {
      left: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
        }
        return lo;
      },
      right: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
        }
        return lo;
      }
    };
  }
  var d3_bisect = d3_bisector(d3_ascending);
  d3.bisectLeft = d3_bisect.left;
  d3.bisect = d3.bisectRight = d3_bisect.right;
  d3.bisector = function(f) {
    return d3_bisector(f.length === 1 ? function(d, x) {
      return d3_ascending(f(d), x);
    } : f);
  };
  d3.shuffle = function(array, i0, i1) {
    if ((m = arguments.length) < 3) {
      i1 = array.length;
      if (m < 2) i0 = 0;
    }
    var m = i1 - i0, t, i;
    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
    }
    return array;
  };
  d3.permute = function(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while (i--) permutes[i] = array[indexes[i]];
    return permutes;
  };
  d3.pairs = function(array) {
    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
    return pairs;
  };
  d3.transpose = function(matrix) {
    if (!(n = matrix.length)) return [];
    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
        row[j] = matrix[j][i];
      }
    }
    return transpose;
  };
  function d3_transposeLength(d) {
    return d.length;
  }
  d3.zip = function() {
    return d3.transpose(arguments);
  };
  d3.keys = function(map) {
    var keys = [];
    for (var key in map) keys.push(key);
    return keys;
  };
  d3.values = function(map) {
    var values = [];
    for (var key in map) values.push(map[key]);
    return values;
  };
  d3.entries = function(map) {
    var entries = [];
    for (var key in map) entries.push({
      key: key,
      value: map[key]
    });
    return entries;
  };
  d3.merge = function(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while (++i < n) j += arrays[i].length;
    merged = new Array(j);
    while (--n >= 0) {
      array = arrays[n];
      m = array.length;
      while (--m >= 0) {
        merged[--j] = array[m];
      }
    }
    return merged;
  };
  var abs = Math.abs;
  d3.range = function(start, stop, step) {
    if (arguments.length < 3) {
      step = 1;
      if (arguments.length < 2) {
        stop = start;
        start = 0;
      }
    }
    if ((stop - start) / step === Infinity) throw new Error("infinite range");
    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
    start *= k, stop *= k, step *= k;
    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
    return range;
  };
  function d3_range_integerScale(x) {
    var k = 1;
    while (x * k % 1) k *= 10;
    return k;
  }
  function d3_class(ctor, properties) {
    for (var key in properties) {
      Object.defineProperty(ctor.prototype, key, {
        value: properties[key],
        enumerable: false
      });
    }
  }
  d3.map = function(object, f) {
    var map = new d3_Map();
    if (object instanceof d3_Map) {
      object.forEach(function(key, value) {
        map.set(key, value);
      });
    } else if (Array.isArray(object)) {
      var i = -1, n = object.length, o;
      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
    } else {
      for (var key in object) map.set(key, object[key]);
    }
    return map;
  };
  function d3_Map() {
    this._ = Object.create(null);
  }
  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
  d3_class(d3_Map, {
    has: d3_map_has,
    get: function(key) {
      return this._[d3_map_escape(key)];
    },
    set: function(key, value) {
      return this._[d3_map_escape(key)] = value;
    },
    remove: d3_map_remove,
    keys: d3_map_keys,
    values: function() {
      var values = [];
      for (var key in this._) values.push(this._[key]);
      return values;
    },
    entries: function() {
      var entries = [];
      for (var key in this._) entries.push({
        key: d3_map_unescape(key),
        value: this._[key]
      });
      return entries;
    },
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
    }
  });
  function d3_map_escape(key) {
    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
  }
  function d3_map_unescape(key) {
    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
  }
  function d3_map_has(key) {
    return d3_map_escape(key) in this._;
  }
  function d3_map_remove(key) {
    return (key = d3_map_escape(key)) in this._ && delete this._[key];
  }
  function d3_map_keys() {
    var keys = [];
    for (var key in this._) keys.push(d3_map_unescape(key));
    return keys;
  }
  function d3_map_size() {
    var size = 0;
    for (var key in this._) ++size;
    return size;
  }
  function d3_map_empty() {
    for (var key in this._) return false;
    return true;
  }
  d3.nest = function() {
    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
    function map(mapType, array, depth) {
      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
      while (++i < n) {
        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
          values.push(object);
        } else {
          valuesByKey.set(keyValue, [ object ]);
        }
      }
      if (mapType) {
        object = mapType();
        setter = function(keyValue, values) {
          object.set(keyValue, map(mapType, values, depth));
        };
      } else {
        object = {};
        setter = function(keyValue, values) {
          object[keyValue] = map(mapType, values, depth);
        };
      }
      valuesByKey.forEach(setter);
      return object;
    }
    function entries(map, depth) {
      if (depth >= keys.length) return map;
      var array = [], sortKey = sortKeys[depth++];
      map.forEach(function(key, keyMap) {
        array.push({
          key: key,
          values: entries(keyMap, depth)
        });
      });
      return sortKey ? array.sort(function(a, b) {
        return sortKey(a.key, b.key);
      }) : array;
    }
    nest.map = function(array, mapType) {
      return map(mapType, array, 0);
    };
    nest.entries = function(array) {
      return entries(map(d3.map, array, 0), 0);
    };
    nest.key = function(d) {
      keys.push(d);
      return nest;
    };
    nest.sortKeys = function(order) {
      sortKeys[keys.length - 1] = order;
      return nest;
    };
    nest.sortValues = function(order) {
      sortValues = order;
      return nest;
    };
    nest.rollup = function(f) {
      rollup = f;
      return nest;
    };
    return nest;
  };
  d3.set = function(array) {
    var set = new d3_Set();
    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
    return set;
  };
  function d3_Set() {
    this._ = Object.create(null);
  }
  d3_class(d3_Set, {
    has: d3_map_has,
    add: function(key) {
      this._[d3_map_escape(key += "")] = true;
      return key;
    },
    remove: d3_map_remove,
    values: d3_map_keys,
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key));
    }
  });
  d3.behavior = {};
  function d3_identity(d) {
    return d;
  }
  d3.rebind = function(target, source) {
    var i = 1, n = arguments.length, method;
    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
    return target;
  };
  function d3_rebind(target, source, method) {
    return function() {
      var value = method.apply(source, arguments);
      return value === source ? target : value;
    };
  }
  function d3_vendorSymbol(object, name) {
    if (name in object) return name;
    name = name.charAt(0).toUpperCase() + name.slice(1);
    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
      var prefixName = d3_vendorPrefixes[i] + name;
      if (prefixName in object) return prefixName;
    }
  }
  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
  function d3_noop() {}
  d3.dispatch = function() {
    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    return dispatch;
  };
  function d3_dispatch() {}
  d3_dispatch.prototype.on = function(type, listener) {
    var i = type.indexOf("."), name = "";
    if (i >= 0) {
      name = type.slice(i + 1);
      type = type.slice(0, i);
    }
    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
    if (arguments.length === 2) {
      if (listener == null) for (type in this) {
        if (this.hasOwnProperty(type)) this[type].on(name, null);
      }
      return this;
    }
  };
  function d3_dispatch_event(dispatch) {
    var listeners = [], listenerByName = new d3_Map();
    function event() {
      var z = listeners, i = -1, n = z.length, l;
      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
      return dispatch;
    }
    event.on = function(name, listener) {
      var l = listenerByName.get(name), i;
      if (arguments.length < 2) return l && l.on;
      if (l) {
        l.on = null;
        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
        listenerByName.remove(name);
      }
      if (listener) listeners.push(listenerByName.set(name, {
        on: listener
      }));
      return dispatch;
    };
    return event;
  }
  d3.event = null;
  function d3_eventPreventDefault() {
    d3.event.preventDefault();
  }
  function d3_eventSource() {
    var e = d3.event, s;
    while (s = e.sourceEvent) e = s;
    return e;
  }
  function d3_eventDispatch(target) {
    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    dispatch.of = function(thiz, argumentz) {
      return function(e1) {
        try {
          var e0 = e1.sourceEvent = d3.event;
          e1.target = target;
          d3.event = e1;
          dispatch[e1.type].apply(thiz, argumentz);
        } finally {
          d3.event = e0;
        }
      };
    };
    return dispatch;
  }
  d3.requote = function(s) {
    return s.replace(d3_requote_re, "\\$&");
  };
  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
  var d3_subclass = {}.__proto__ ? function(object, prototype) {
    object.__proto__ = prototype;
  } : function(object, prototype) {
    for (var property in prototype) object[property] = prototype[property];
  };
  function d3_selection(groups) {
    d3_subclass(groups, d3_selectionPrototype);
    return groups;
  }
  var d3_select = function(s, n) {
    return n.querySelector(s);
  }, d3_selectAll = function(s, n) {
    return n.querySelectorAll(s);
  }, d3_selectMatches = function(n, s) {
    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
    d3_selectMatches = function(n, s) {
      return d3_selectMatcher.call(n, s);
    };
    return d3_selectMatches(n, s);
  };
  if (typeof Sizzle === "function") {
    d3_select = function(s, n) {
      return Sizzle(s, n)[0] || null;
    };
    d3_selectAll = Sizzle;
    d3_selectMatches = Sizzle.matchesSelector;
  }
  d3.selection = function() {
    return d3.select(d3_document.documentElement);
  };
  var d3_selectionPrototype = d3.selection.prototype = [];
  d3_selectionPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, group, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selector(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_select(selector, this);
    };
  }
  d3_selectionPrototype.selectAll = function(selector) {
    var subgroups = [], subgroup, node;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
          subgroup.parentNode = node;
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selectorAll(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_selectAll(selector, this);
    };
  }
  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
  var d3_nsPrefix = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: d3_nsXhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
  };
  d3.ns = {
    prefix: d3_nsPrefix,
    qualify: function(name) {
      var i = name.indexOf(":"), prefix = name;
      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
      return d3_nsPrefix.hasOwnProperty(prefix) ? {
        space: d3_nsPrefix[prefix],
        local: name
      } : name;
    }
  };
  d3_selectionPrototype.attr = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node();
        name = d3.ns.qualify(name);
        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
      }
      for (value in name) this.each(d3_selection_attr(value, name[value]));
      return this;
    }
    return this.each(d3_selection_attr(name, value));
  };
  function d3_selection_attr(name, value) {
    name = d3.ns.qualify(name);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrConstant() {
      this.setAttribute(name, value);
    }
    function attrConstantNS() {
      this.setAttributeNS(name.space, name.local, value);
    }
    function attrFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
    }
    function attrFunctionNS() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
    }
    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
  }
  function d3_collapse(s) {
    return s.trim().replace(/\s+/g, " ");
  }
  d3_selectionPrototype.classed = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
        if (value = node.classList) {
          while (++i < n) if (!value.contains(name[i])) return false;
        } else {
          value = node.getAttribute("class");
          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
        }
        return true;
      }
      for (value in name) this.each(d3_selection_classed(value, name[value]));
      return this;
    }
    return this.each(d3_selection_classed(name, value));
  };
  function d3_selection_classedRe(name) {
    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
  }
  function d3_selection_classes(name) {
    return (name + "").trim().split(/^|\s+/);
  }
  function d3_selection_classed(name, value) {
    name = d3_selection_classes(name).map(d3_selection_classedName);
    var n = name.length;
    function classedConstant() {
      var i = -1;
      while (++i < n) name[i](this, value);
    }
    function classedFunction() {
      var i = -1, x = value.apply(this, arguments);
      while (++i < n) name[i](this, x);
    }
    return typeof value === "function" ? classedFunction : classedConstant;
  }
  function d3_selection_classedName(name) {
    var re = d3_selection_classedRe(name);
    return function(node, value) {
      if (c = node.classList) return value ? c.add(name) : c.remove(name);
      var c = node.getAttribute("class") || "";
      if (value) {
        re.lastIndex = 0;
        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
      } else {
        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
      }
    };
  }
  d3_selectionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
        return this;
      }
      if (n < 2) {
        var node = this.node();
        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
      }
      priority = "";
    }
    return this.each(d3_selection_style(name, value, priority));
  };
  function d3_selection_style(name, value, priority) {
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleConstant() {
      this.style.setProperty(name, value, priority);
    }
    function styleFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
    }
    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
  }
  d3_selectionPrototype.property = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") return this.node()[name];
      for (value in name) this.each(d3_selection_property(value, name[value]));
      return this;
    }
    return this.each(d3_selection_property(name, value));
  };
  function d3_selection_property(name, value) {
    function propertyNull() {
      delete this[name];
    }
    function propertyConstant() {
      this[name] = value;
    }
    function propertyFunction() {
      var x = value.apply(this, arguments);
      if (x == null) delete this[name]; else this[name] = x;
    }
    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
  }
  d3_selectionPrototype.text = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.textContent = v == null ? "" : v;
    } : value == null ? function() {
      this.textContent = "";
    } : function() {
      this.textContent = value;
    }) : this.node().textContent;
  };
  d3_selectionPrototype.html = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.innerHTML = v == null ? "" : v;
    } : value == null ? function() {
      this.innerHTML = "";
    } : function() {
      this.innerHTML = value;
    }) : this.node().innerHTML;
  };
  d3_selectionPrototype.append = function(name) {
    name = d3_selection_creator(name);
    return this.select(function() {
      return this.appendChild(name.apply(this, arguments));
    });
  };
  function d3_selection_creator(name) {
    function create() {
      var document = this.ownerDocument, namespace = this.namespaceURI;
      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
    }
    function createNS() {
      return this.ownerDocument.createElementNS(name.space, name.local);
    }
    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
  }
  d3_selectionPrototype.insert = function(name, before) {
    name = d3_selection_creator(name);
    before = d3_selection_selector(before);
    return this.select(function() {
      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
    });
  };
  d3_selectionPrototype.remove = function() {
    return this.each(d3_selectionRemove);
  };
  function d3_selectionRemove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
  }
  d3_selectionPrototype.data = function(value, key) {
    var i = -1, n = this.length, group, node;
    if (!arguments.length) {
      value = new Array(n = (group = this[0]).length);
      while (++i < n) {
        if (node = group[i]) {
          value[i] = node.__data__;
        }
      }
      return value;
    }
    function bind(group, groupData) {
      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
      if (key) {
        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
        for (i = -1; ++i < n; ) {
          if (node = group[i]) {
            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
              exitNodes[i] = node;
            } else {
              nodeByKeyValue.set(keyValue, node);
            }
            keyValues[i] = keyValue;
          }
        }
        for (i = -1; ++i < m; ) {
          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          } else if (node !== true) {
            updateNodes[i] = node;
            node.__data__ = nodeData;
          }
          nodeByKeyValue.set(keyValue, true);
        }
        for (i = -1; ++i < n; ) {
          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
            exitNodes[i] = group[i];
          }
        }
      } else {
        for (i = -1; ++i < n0; ) {
          node = group[i];
          nodeData = groupData[i];
          if (node) {
            node.__data__ = nodeData;
            updateNodes[i] = node;
          } else {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          }
        }
        for (;i < m; ++i) {
          enterNodes[i] = d3_selection_dataNode(groupData[i]);
        }
        for (;i < n; ++i) {
          exitNodes[i] = group[i];
        }
      }
      enterNodes.update = updateNodes;
      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
      enter.push(enterNodes);
      update.push(updateNodes);
      exit.push(exitNodes);
    }
    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
    if (typeof value === "function") {
      while (++i < n) {
        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
      }
    } else {
      while (++i < n) {
        bind(group = this[i], value);
      }
    }
    update.enter = function() {
      return enter;
    };
    update.exit = function() {
      return exit;
    };
    return update;
  };
  function d3_selection_dataNode(data) {
    return {
      __data__: data
    };
  }
  d3_selectionPrototype.datum = function(value) {
    return arguments.length ? this.property("__data__", value) : this.property("__data__");
  };
  d3_selectionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_filter(selector) {
    return function() {
      return d3_selectMatches(this, selector);
    };
  }
  d3_selectionPrototype.order = function() {
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
        if (node = group[i]) {
          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
          next = node;
        }
      }
    }
    return this;
  };
  d3_selectionPrototype.sort = function(comparator) {
    comparator = d3_selection_sortComparator.apply(this, arguments);
    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
    return this.order();
  };
  function d3_selection_sortComparator(comparator) {
    if (!arguments.length) comparator = d3_ascending;
    return function(a, b) {
      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
    };
  }
  d3_selectionPrototype.each = function(callback) {
    return d3_selection_each(this, function(node, i, j) {
      callback.call(node, node.__data__, i, j);
    });
  };
  function d3_selection_each(groups, callback) {
    for (var j = 0, m = groups.length; j < m; j++) {
      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
        if (node = group[i]) callback(node, i, j);
      }
    }
    return groups;
  }
  d3_selectionPrototype.call = function(callback) {
    var args = d3_array(arguments);
    callback.apply(args[0] = this, args);
    return this;
  };
  d3_selectionPrototype.empty = function() {
    return !this.node();
  };
  d3_selectionPrototype.node = function() {
    for (var j = 0, m = this.length; j < m; j++) {
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        var node = group[i];
        if (node) return node;
      }
    }
    return null;
  };
  d3_selectionPrototype.size = function() {
    var n = 0;
    d3_selection_each(this, function() {
      ++n;
    });
    return n;
  };
  function d3_selection_enter(selection) {
    d3_subclass(selection, d3_selection_enterPrototype);
    return selection;
  }
  var d3_selection_enterPrototype = [];
  d3.selection.enter = d3_selection_enter;
  d3.selection.enter.prototype = d3_selection_enterPrototype;
  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
  d3_selection_enterPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, upgroup, group, node;
    for (var j = -1, m = this.length; ++j < m; ) {
      upgroup = (group = this[j]).update;
      subgroups.push(subgroup = []);
      subgroup.parentNode = group.parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
          subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  d3_selection_enterPrototype.insert = function(name, before) {
    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
    return d3_selectionPrototype.insert.call(this, name, before);
  };
  function d3_selection_enterInsertBefore(enter) {
    var i0, j0;
    return function(d, i, j) {
      var group = enter[j].update, n = group.length, node;
      if (j != j0) j0 = j, i0 = 0;
      if (i >= i0) i0 = i + 1;
      while (!(node = group[i0]) && ++i0 < n) ;
      return node;
    };
  }
  d3.select = function(node) {
    var group;
    if (typeof node === "string") {
      group = [ d3_select(node, d3_document) ];
      group.parentNode = d3_document.documentElement;
    } else {
      group = [ node ];
      group.parentNode = d3_documentElement(node);
    }
    return d3_selection([ group ]);
  };
  d3.selectAll = function(nodes) {
    var group;
    if (typeof nodes === "string") {
      group = d3_array(d3_selectAll(nodes, d3_document));
      group.parentNode = d3_document.documentElement;
    } else {
      group = d3_array(nodes);
      group.parentNode = null;
    }
    return d3_selection([ group ]);
  };
  d3_selectionPrototype.on = function(type, listener, capture) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof type !== "string") {
        if (n < 2) listener = false;
        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
        return this;
      }
      if (n < 2) return (n = this.node()["__on" + type]) && n._;
      capture = false;
    }
    return this.each(d3_selection_on(type, listener, capture));
  };
  function d3_selection_on(type, listener, capture) {
    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
    if (i > 0) type = type.slice(0, i);
    var filter = d3_selection_onFilters.get(type);
    if (filter) type = filter, wrap = d3_selection_onFilter;
    function onRemove() {
      var l = this[name];
      if (l) {
        this.removeEventListener(type, l, l.$);
        delete this[name];
      }
    }
    function onAdd() {
      var l = wrap(listener, d3_array(arguments));
      onRemove.call(this);
      this.addEventListener(type, this[name] = l, l.$ = capture);
      l._ = listener;
    }
    function removeAll() {
      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
      for (var name in this) {
        if (match = name.match(re)) {
          var l = this[name];
          this.removeEventListener(match[1], l, l.$);
          delete this[name];
        }
      }
    }
    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
  }
  var d3_selection_onFilters = d3.map({
    mouseenter: "mouseover",
    mouseleave: "mouseout"
  });
  if (d3_document) {
    d3_selection_onFilters.forEach(function(k) {
      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
    });
  }
  function d3_selection_onListener(listener, argumentz) {
    return function(e) {
      var o = d3.event;
      d3.event = e;
      argumentz[0] = this.__data__;
      try {
        listener.apply(this, argumentz);
      } finally {
        d3.event = o;
      }
    };
  }
  function d3_selection_onFilter(listener, argumentz) {
    var l = d3_selection_onListener(listener, argumentz);
    return function(e) {
      var target = this, related = e.relatedTarget;
      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
        l.call(target, e);
      }
    };
  }
  var d3_event_dragSelect, d3_event_dragId = 0;
  function d3_event_dragSuppress(node) {
    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
    if (d3_event_dragSelect == null) {
      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
    }
    if (d3_event_dragSelect) {
      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
      style[d3_event_dragSelect] = "none";
    }
    return function(suppressClick) {
      w.on(name, null);
      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
      if (suppressClick) {
        var off = function() {
          w.on(click, null);
        };
        w.on(click, function() {
          d3_eventPreventDefault();
          off();
        }, true);
        setTimeout(off, 0);
      }
    };
  }
  d3.mouse = function(container) {
    return d3_mousePoint(container, d3_eventSource());
  };
  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
  function d3_mousePoint(container, e) {
    if (e.changedTouches) e = e.changedTouches[0];
    var svg = container.ownerSVGElement || container;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      if (d3_mouse_bug44083 < 0) {
        var window = d3_window(container);
        if (window.scrollX || window.scrollY) {
          svg = d3.select("body").append("svg").style({
            position: "absolute",
            top: 0,
            left: 0,
            margin: 0,
            padding: 0,
            border: "none"
          }, "important");
          var ctm = svg[0][0].getScreenCTM();
          d3_mouse_bug44083 = !(ctm.f || ctm.e);
          svg.remove();
        }
      }
      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
      point.y = e.clientY;
      point = point.matrixTransform(container.getScreenCTM().inverse());
      return [ point.x, point.y ];
    }
    var rect = container.getBoundingClientRect();
    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
  }
  d3.touch = function(container, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
      if ((touch = touches[i]).identifier === identifier) {
        return d3_mousePoint(container, touch);
      }
    }
  };
  d3.behavior.drag = function() {
    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
    function drag() {
      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
    }
    function dragstart(id, position, subject, move, end) {
      return function() {
        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
        if (origin) {
          dragOffset = origin.apply(that, arguments);
          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
        } else {
          dragOffset = [ 0, 0 ];
        }
        dispatch({
          type: "dragstart"
        });
        function moved() {
          var position1 = position(parent, dragId), dx, dy;
          if (!position1) return;
          dx = position1[0] - position0[0];
          dy = position1[1] - position0[1];
          dragged |= dx | dy;
          position0 = position1;
          dispatch({
            type: "drag",
            x: position1[0] + dragOffset[0],
            y: position1[1] + dragOffset[1],
            dx: dx,
            dy: dy
          });
        }
        function ended() {
          if (!position(parent, dragId)) return;
          dragSubject.on(move + dragName, null).on(end + dragName, null);
          dragRestore(dragged);
          dispatch({
            type: "dragend"
          });
        }
      };
    }
    drag.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return drag;
    };
    return d3.rebind(drag, event, "on");
  };
  function d3_behavior_dragTouchId() {
    return d3.event.changedTouches[0].identifier;
  }
  d3.touches = function(container, touches) {
    if (arguments.length < 2) touches = d3_eventSource().touches;
    return touches ? d3_array(touches).map(function(touch) {
      var point = d3_mousePoint(container, touch);
      point.identifier = touch.identifier;
      return point;
    }) : [];
  };
  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
  function d3_sgn(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
  }
  function d3_cross2d(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
  }
  function d3_acos(x) {
    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
  }
  function d3_asin(x) {
    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
  }
  function d3_sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }
  function d3_cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }
  function d3_tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }
  function d3_haversin(x) {
    return (x = Math.sin(x / 2)) * x;
  }
  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
  d3.interpolateZoom = function(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < ε2) {
      S = Math.log(w1 / w0) / ρ;
      i = function(t) {
        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
      };
    } else {
      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / ρ;
      i = function(t) {
        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
      };
    }
    i.duration = S * 1e3;
    return i;
  };
  d3.behavior.zoom = function() {
    var view = {
      x: 0,
      y: 0,
      k: 1
    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
    if (!d3_behavior_zoomWheel) {
      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return d3.event.wheelDelta;
      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
        return -d3.event.detail;
      }, "MozMousePixelScroll");
    }
    function zoom(g) {
      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
    }
    zoom.event = function(g) {
      g.each(function() {
        var dispatch = event.of(this, arguments), view1 = view;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.zoom", function() {
            view = this.__chart__ || {
              x: 0,
              y: 0,
              k: 1
            };
            zoomstarted(dispatch);
          }).tween("zoom:zoom", function() {
            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
            return function(t) {
              var l = i(t), k = dx / l[2];
              this.__chart__ = view = {
                x: cx - l[0] * k,
                y: cy - l[1] * k,
                k: k
              };
              zoomed(dispatch);
            };
          }).each("interrupt.zoom", function() {
            zoomended(dispatch);
          }).each("end.zoom", function() {
            zoomended(dispatch);
          });
        } else {
          this.__chart__ = view;
          zoomstarted(dispatch);
          zoomed(dispatch);
          zoomended(dispatch);
        }
      });
    };
    zoom.translate = function(_) {
      if (!arguments.length) return [ view.x, view.y ];
      view = {
        x: +_[0],
        y: +_[1],
        k: view.k
      };
      rescale();
      return zoom;
    };
    zoom.scale = function(_) {
      if (!arguments.length) return view.k;
      view = {
        x: view.x,
        y: view.y,
        k: null
      };
      scaleTo(+_);
      rescale();
      return zoom;
    };
    zoom.scaleExtent = function(_) {
      if (!arguments.length) return scaleExtent;
      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.center = function(_) {
      if (!arguments.length) return center;
      center = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.size = function(_) {
      if (!arguments.length) return size;
      size = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.duration = function(_) {
      if (!arguments.length) return duration;
      duration = +_;
      return zoom;
    };
    zoom.x = function(z) {
      if (!arguments.length) return x1;
      x1 = z;
      x0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    zoom.y = function(z) {
      if (!arguments.length) return y1;
      y1 = z;
      y0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    function location(p) {
      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
    }
    function point(l) {
      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
    }
    function scaleTo(s) {
      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
    }
    function translateTo(p, l) {
      l = point(l);
      view.x += p[0] - l[0];
      view.y += p[1] - l[1];
    }
    function zoomTo(that, p, l, k) {
      that.__chart__ = {
        x: view.x,
        y: view.y,
        k: view.k
      };
      scaleTo(Math.pow(2, k));
      translateTo(center0 = p, l);
      that = d3.select(that);
      if (duration > 0) that = that.transition().duration(duration);
      that.call(zoom.event);
    }
    function rescale() {
      if (x1) x1.domain(x0.range().map(function(x) {
        return (x - view.x) / view.k;
      }).map(x0.invert));
      if (y1) y1.domain(y0.range().map(function(y) {
        return (y - view.y) / view.k;
      }).map(y0.invert));
    }
    function zoomstarted(dispatch) {
      if (!zooming++) dispatch({
        type: "zoomstart"
      });
    }
    function zoomed(dispatch) {
      rescale();
      dispatch({
        type: "zoom",
        scale: view.k,
        translate: [ view.x, view.y ]
      });
    }
    function zoomended(dispatch) {
      if (!--zooming) dispatch({
        type: "zoomend"
      }), center0 = null;
    }
    function mousedowned() {
      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
      d3_selection_interrupt.call(that);
      zoomstarted(dispatch);
      function moved() {
        dragged = 1;
        translateTo(d3.mouse(that), location0);
        zoomed(dispatch);
      }
      function ended() {
        subject.on(mousemove, null).on(mouseup, null);
        dragRestore(dragged);
        zoomended(dispatch);
      }
    }
    function touchstarted() {
      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
      started();
      zoomstarted(dispatch);
      subject.on(mousedown, null).on(touchstart, started);
      function relocate() {
        var touches = d3.touches(that);
        scale0 = view.k;
        touches.forEach(function(t) {
          if (t.identifier in locations0) locations0[t.identifier] = location(t);
        });
        return touches;
      }
      function started() {
        var target = d3.event.target;
        d3.select(target).on(touchmove, moved).on(touchend, ended);
        targets.push(target);
        var changed = d3.event.changedTouches;
        for (var i = 0, n = changed.length; i < n; ++i) {
          locations0[changed[i].identifier] = null;
        }
        var touches = relocate(), now = Date.now();
        if (touches.length === 1) {
          if (now - touchtime < 500) {
            var p = touches[0];
            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
            d3_eventPreventDefault();
          }
          touchtime = now;
        } else if (touches.length > 1) {
          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
          distance0 = dx * dx + dy * dy;
        }
      }
      function moved() {
        var touches = d3.touches(that), p0, l0, p1, l1;
        d3_selection_interrupt.call(that);
        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
          p1 = touches[i];
          if (l1 = locations0[p1.identifier]) {
            if (l0) break;
            p0 = p1, l0 = l1;
          }
        }
        if (l1) {
          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
          scaleTo(scale1 * scale0);
        }
        touchtime = null;
        translateTo(p0, l0);
        zoomed(dispatch);
      }
      function ended() {
        if (d3.event.touches.length) {
          var changed = d3.event.changedTouches;
          for (var i = 0, n = changed.length; i < n; ++i) {
            delete locations0[changed[i].identifier];
          }
          for (var identifier in locations0) {
            return void relocate();
          }
        }
        d3.selectAll(targets).on(zoomName, null);
        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
        dragRestore();
        zoomended(dispatch);
      }
    }
    function mousewheeled() {
      var dispatch = event.of(this, arguments);
      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
      mousewheelTimer = setTimeout(function() {
        mousewheelTimer = null;
        zoomended(dispatch);
      }, 50);
      d3_eventPreventDefault();
      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
      translateTo(center0, translate0);
      zoomed(dispatch);
    }
    function dblclicked() {
      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
    }
    return d3.rebind(zoom, event, "on");
  };
  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
  d3.color = d3_color;
  function d3_color() {}
  d3_color.prototype.toString = function() {
    return this.rgb() + "";
  };
  d3.hsl = d3_hsl;
  function d3_hsl(h, s, l) {
    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
  }
  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
  d3_hslPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, this.l / k);
  };
  d3_hslPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, k * this.l);
  };
  d3_hslPrototype.rgb = function() {
    return d3_hsl_rgb(this.h, this.s, this.l);
  };
  function d3_hsl_rgb(h, s, l) {
    var m1, m2;
    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
    l = l < 0 ? 0 : l > 1 ? 1 : l;
    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
    m1 = 2 * l - m2;
    function v(h) {
      if (h > 360) h -= 360; else if (h < 0) h += 360;
      if (h < 60) return m1 + (m2 - m1) * h / 60;
      if (h < 180) return m2;
      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
      return m1;
    }
    function vv(h) {
      return Math.round(v(h) * 255);
    }
    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
  }
  d3.hcl = d3_hcl;
  function d3_hcl(h, c, l) {
    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
  }
  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
  d3_hclPrototype.brighter = function(k) {
    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.darker = function(k) {
    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.rgb = function() {
    return d3_hcl_lab(this.h, this.c, this.l).rgb();
  };
  function d3_hcl_lab(h, c, l) {
    if (isNaN(h)) h = 0;
    if (isNaN(c)) c = 0;
    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
  }
  d3.lab = d3_lab;
  function d3_lab(l, a, b) {
    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
  }
  var d3_lab_K = 18;
  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
  var d3_labPrototype = d3_lab.prototype = new d3_color();
  d3_labPrototype.brighter = function(k) {
    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.darker = function(k) {
    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.rgb = function() {
    return d3_lab_rgb(this.l, this.a, this.b);
  };
  function d3_lab_rgb(l, a, b) {
    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
    x = d3_lab_xyz(x) * d3_lab_X;
    y = d3_lab_xyz(y) * d3_lab_Y;
    z = d3_lab_xyz(z) * d3_lab_Z;
    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
  }
  function d3_lab_hcl(l, a, b) {
    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
  }
  function d3_lab_xyz(x) {
    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
  }
  function d3_xyz_lab(x) {
    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
  }
  function d3_xyz_rgb(r) {
    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
  }
  d3.rgb = d3_rgb;
  function d3_rgb(r, g, b) {
    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
  }
  function d3_rgbNumber(value) {
    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
  }
  function d3_rgbString(value) {
    return d3_rgbNumber(value) + "";
  }
  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
  d3_rgbPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    var r = this.r, g = this.g, b = this.b, i = 30;
    if (!r && !g && !b) return new d3_rgb(i, i, i);
    if (r && r < i) r = i;
    if (g && g < i) g = i;
    if (b && b < i) b = i;
    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
  };
  d3_rgbPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_rgb(k * this.r, k * this.g, k * this.b);
  };
  d3_rgbPrototype.hsl = function() {
    return d3_rgb_hsl(this.r, this.g, this.b);
  };
  d3_rgbPrototype.toString = function() {
    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
  };
  function d3_rgb_hex(v) {
    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
  }
  function d3_rgb_parse(format, rgb, hsl) {
    var r = 0, g = 0, b = 0, m1, m2, color;
    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
    if (m1) {
      m2 = m1[2].split(",");
      switch (m1[1]) {
       case "hsl":
        {
          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
        }

       case "rgb":
        {
          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
        }
      }
    }
    if (color = d3_rgb_names.get(format)) {
      return rgb(color.r, color.g, color.b);
    }
    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
      if (format.length === 4) {
        r = (color & 3840) >> 4;
        r = r >> 4 | r;
        g = color & 240;
        g = g >> 4 | g;
        b = color & 15;
        b = b << 4 | b;
      } else if (format.length === 7) {
        r = (color & 16711680) >> 16;
        g = (color & 65280) >> 8;
        b = color & 255;
      }
    }
    return rgb(r, g, b);
  }
  function d3_rgb_hsl(r, g, b) {
    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
    if (d) {
      s = l < .5 ? d / (max + min) : d / (2 - max - min);
      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
      h *= 60;
    } else {
      h = NaN;
      s = l > 0 && l < 1 ? 0 : h;
    }
    return new d3_hsl(h, s, l);
  }
  function d3_rgb_lab(r, g, b) {
    r = d3_rgb_xyz(r);
    g = d3_rgb_xyz(g);
    b = d3_rgb_xyz(b);
    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
  }
  function d3_rgb_xyz(r) {
    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
  }
  function d3_rgb_parseNumber(c) {
    var f = parseFloat(c);
    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
  }
  var d3_rgb_names = d3.map({
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  });
  d3_rgb_names.forEach(function(key, value) {
    d3_rgb_names.set(key, d3_rgbNumber(value));
  });
  function d3_functor(v) {
    return typeof v === "function" ? v : function() {
      return v;
    };
  }
  d3.functor = d3_functor;
  d3.xhr = d3_xhrType(d3_identity);
  function d3_xhrType(response) {
    return function(url, mimeType, callback) {
      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
      mimeType = null;
      return d3_xhr(url, mimeType, response, callback);
    };
  }
  function d3_xhr(url, mimeType, response, callback) {
    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
      request.readyState > 3 && respond();
    };
    function respond() {
      var status = request.status, result;
      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
        try {
          result = response.call(xhr, request);
        } catch (e) {
          dispatch.error.call(xhr, e);
          return;
        }
        dispatch.load.call(xhr, result);
      } else {
        dispatch.error.call(xhr, request);
      }
    }
    request.onprogress = function(event) {
      var o = d3.event;
      d3.event = event;
      try {
        dispatch.progress.call(xhr, request);
      } finally {
        d3.event = o;
      }
    };
    xhr.header = function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers[name];
      if (value == null) delete headers[name]; else headers[name] = value + "";
      return xhr;
    };
    xhr.mimeType = function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return xhr;
    };
    xhr.responseType = function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return xhr;
    };
    xhr.response = function(value) {
      response = value;
      return xhr;
    };
    [ "get", "post" ].forEach(function(method) {
      xhr[method] = function() {
        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
      };
    });
    xhr.send = function(method, data, callback) {
      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
      request.open(method, url, true);
      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
      if (responseType != null) request.responseType = responseType;
      if (callback != null) xhr.on("error", callback).on("load", function(request) {
        callback(null, request);
      });
      dispatch.beforesend.call(xhr, request);
      request.send(data == null ? null : data);
      return xhr;
    };
    xhr.abort = function() {
      request.abort();
      return xhr;
    };
    d3.rebind(xhr, dispatch, "on");
    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
  }
  function d3_xhr_fixCallback(callback) {
    return callback.length === 1 ? function(error, request) {
      callback(error == null ? request : null);
    } : callback;
  }
  function d3_xhrHasResponse(request) {
    var type = request.responseType;
    return type && type !== "text" ? request.response : request.responseText;
  }
  d3.dsv = function(delimiter, mimeType) {
    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
    function dsv(url, row, callback) {
      if (arguments.length < 3) callback = row, row = null;
      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
      xhr.row = function(_) {
        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
      };
      return xhr;
    }
    function response(request) {
      return dsv.parse(request.responseText);
    }
    function typedResponse(f) {
      return function(request) {
        return dsv.parse(request.responseText, f);
      };
    }
    dsv.parse = function(text, f) {
      var o;
      return dsv.parseRows(text, function(row, i) {
        if (o) return o(row, i - 1);
        var a = new Function("d", "return {" + row.map(function(name, i) {
          return JSON.stringify(name) + ": d[" + i + "]";
        }).join(",") + "}");
        o = f ? function(row, i) {
          return f(a(row), i);
        } : a;
      });
    };
    dsv.parseRows = function(text, f) {
      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
      function token() {
        if (I >= N) return EOF;
        if (eol) return eol = false, EOL;
        var j = I;
        if (text.charCodeAt(j) === 34) {
          var i = j;
          while (i++ < N) {
            if (text.charCodeAt(i) === 34) {
              if (text.charCodeAt(i + 1) !== 34) break;
              ++i;
            }
          }
          I = i + 2;
          var c = text.charCodeAt(i + 1);
          if (c === 13) {
            eol = true;
            if (text.charCodeAt(i + 2) === 10) ++I;
          } else if (c === 10) {
            eol = true;
          }
          return text.slice(j + 1, i).replace(/""/g, '"');
        }
        while (I < N) {
          var c = text.charCodeAt(I++), k = 1;
          if (c === 10) eol = true; else if (c === 13) {
            eol = true;
            if (text.charCodeAt(I) === 10) ++I, ++k;
          } else if (c !== delimiterCode) continue;
          return text.slice(j, I - k);
        }
        return text.slice(j);
      }
      while ((t = token()) !== EOF) {
        var a = [];
        while (t !== EOL && t !== EOF) {
          a.push(t);
          t = token();
        }
        if (f && (a = f(a, n++)) == null) continue;
        rows.push(a);
      }
      return rows;
    };
    dsv.format = function(rows) {
      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
      var fieldSet = new d3_Set(), fields = [];
      rows.forEach(function(row) {
        for (var field in row) {
          if (!fieldSet.has(field)) {
            fields.push(fieldSet.add(field));
          }
        }
      });
      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
        return fields.map(function(field) {
          return formatValue(row[field]);
        }).join(delimiter);
      })).join("\n");
    };
    dsv.formatRows = function(rows) {
      return rows.map(formatRow).join("\n");
    };
    function formatRow(row) {
      return row.map(formatValue).join(delimiter);
    }
    function formatValue(text) {
      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
    }
    return dsv;
  };
  d3.csv = d3.dsv(",", "text/csv");
  d3.tsv = d3.dsv("	", "text/tab-separated-values");
  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
    setTimeout(callback, 17);
  };
  d3.timer = function() {
    d3_timer.apply(this, arguments);
  };
  function d3_timer(callback, delay, then) {
    var n = arguments.length;
    if (n < 2) delay = 0;
    if (n < 3) then = Date.now();
    var time = then + delay, timer = {
      c: callback,
      t: time,
      n: null
    };
    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
    d3_timer_queueTail = timer;
    if (!d3_timer_interval) {
      d3_timer_timeout = clearTimeout(d3_timer_timeout);
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
    return timer;
  }
  function d3_timer_step() {
    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
    if (delay > 24) {
      if (isFinite(delay)) {
        clearTimeout(d3_timer_timeout);
        d3_timer_timeout = setTimeout(d3_timer_step, delay);
      }
      d3_timer_interval = 0;
    } else {
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
  }
  d3.timer.flush = function() {
    d3_timer_mark();
    d3_timer_sweep();
  };
  function d3_timer_mark() {
    var now = Date.now(), timer = d3_timer_queueHead;
    while (timer) {
      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
      timer = timer.n;
    }
    return now;
  }
  function d3_timer_sweep() {
    var t0, t1 = d3_timer_queueHead, time = Infinity;
    while (t1) {
      if (t1.c) {
        if (t1.t < time) time = t1.t;
        t1 = (t0 = t1).n;
      } else {
        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
      }
    }
    d3_timer_queueTail = t0;
    return time;
  }
  function d3_format_precision(x, p) {
    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
  }
  d3.round = function(x, n) {
    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
  };
  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
  d3.formatPrefix = function(value, precision) {
    var i = 0;
    if (value = +value) {
      if (value < 0) value *= -1;
      if (precision) value = d3.round(value, d3_format_precision(value, precision));
      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
    }
    return d3_formatPrefixes[8 + i / 3];
  };
  function d3_formatPrefix(d, i) {
    var k = Math.pow(10, abs(8 - i) * 3);
    return {
      scale: i > 8 ? function(d) {
        return d / k;
      } : function(d) {
        return d * k;
      },
      symbol: d
    };
  }
  function d3_locale_numberFormat(locale) {
    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
      while (i > 0 && g > 0) {
        if (length + g + 1 > width) g = Math.max(1, width - length);
        t.push(value.substring(i -= g, i + g));
        if ((length += g + 1) > width) break;
        g = locale_grouping[j = (j + 1) % locale_grouping.length];
      }
      return t.reverse().join(locale_thousands);
    } : d3_identity;
    return function(specifier) {
      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
      if (precision) precision = +precision.substring(1);
      if (zfill || fill === "0" && align === "=") {
        zfill = fill = "0";
        align = "=";
      }
      switch (type) {
       case "n":
        comma = true;
        type = "g";
        break;

       case "%":
        scale = 100;
        suffix = "%";
        type = "f";
        break;

       case "p":
        scale = 100;
        suffix = "%";
        type = "r";
        break;

       case "b":
       case "o":
       case "x":
       case "X":
        if (symbol === "#") prefix = "0" + type.toLowerCase();

       case "c":
        exponent = false;

       case "d":
        integer = true;
        precision = 0;
        break;

       case "s":
        scale = -1;
        type = "r";
        break;
      }
      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
      if (type == "r" && !precision) type = "g";
      if (precision != null) {
        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
      }
      type = d3_format_types.get(type) || d3_format_typeDefault;
      var zcomma = zfill && comma;
      return function(value) {
        var fullSuffix = suffix;
        if (integer && value % 1) return "";
        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
        if (scale < 0) {
          var unit = d3.formatPrefix(value, precision);
          value = unit.scale(value);
          fullSuffix = unit.symbol + suffix;
        } else {
          value *= scale;
        }
        value = type(value, precision);
        var i = value.lastIndexOf("."), before, after;
        if (i < 0) {
          var j = exponent ? value.lastIndexOf("e") : -1;
          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
        } else {
          before = value.substring(0, i);
          after = locale_decimal + value.substring(i + 1);
        }
        if (!zfill && comma) before = formatGroup(before, Infinity);
        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
        negative += prefix;
        value = before + after;
        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
      };
    };
  }
  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
  var d3_format_types = d3.map({
    b: function(x) {
      return x.toString(2);
    },
    c: function(x) {
      return String.fromCharCode(x);
    },
    o: function(x) {
      return x.toString(8);
    },
    x: function(x) {
      return x.toString(16);
    },
    X: function(x) {
      return x.toString(16).toUpperCase();
    },
    g: function(x, p) {
      return x.toPrecision(p);
    },
    e: function(x, p) {
      return x.toExponential(p);
    },
    f: function(x, p) {
      return x.toFixed(p);
    },
    r: function(x, p) {
      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
    }
  });
  function d3_format_typeDefault(x) {
    return x + "";
  }
  var d3_time = d3.time = {}, d3_date = Date;
  function d3_date_utc() {
    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
  }
  d3_date_utc.prototype = {
    getDate: function() {
      return this._.getUTCDate();
    },
    getDay: function() {
      return this._.getUTCDay();
    },
    getFullYear: function() {
      return this._.getUTCFullYear();
    },
    getHours: function() {
      return this._.getUTCHours();
    },
    getMilliseconds: function() {
      return this._.getUTCMilliseconds();
    },
    getMinutes: function() {
      return this._.getUTCMinutes();
    },
    getMonth: function() {
      return this._.getUTCMonth();
    },
    getSeconds: function() {
      return this._.getUTCSeconds();
    },
    getTime: function() {
      return this._.getTime();
    },
    getTimezoneOffset: function() {
      return 0;
    },
    valueOf: function() {
      return this._.valueOf();
    },
    setDate: function() {
      d3_time_prototype.setUTCDate.apply(this._, arguments);
    },
    setDay: function() {
      d3_time_prototype.setUTCDay.apply(this._, arguments);
    },
    setFullYear: function() {
      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
    },
    setHours: function() {
      d3_time_prototype.setUTCHours.apply(this._, arguments);
    },
    setMilliseconds: function() {
      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
    },
    setMinutes: function() {
      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
    },
    setMonth: function() {
      d3_time_prototype.setUTCMonth.apply(this._, arguments);
    },
    setSeconds: function() {
      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
    },
    setTime: function() {
      d3_time_prototype.setTime.apply(this._, arguments);
    }
  };
  var d3_time_prototype = Date.prototype;
  function d3_time_interval(local, step, number) {
    function round(date) {
      var d0 = local(date), d1 = offset(d0, 1);
      return date - d0 < d1 - date ? d0 : d1;
    }
    function ceil(date) {
      step(date = local(new d3_date(date - 1)), 1);
      return date;
    }
    function offset(date, k) {
      step(date = new d3_date(+date), k);
      return date;
    }
    function range(t0, t1, dt) {
      var time = ceil(t0), times = [];
      if (dt > 1) {
        while (time < t1) {
          if (!(number(time) % dt)) times.push(new Date(+time));
          step(time, 1);
        }
      } else {
        while (time < t1) times.push(new Date(+time)), step(time, 1);
      }
      return times;
    }
    function range_utc(t0, t1, dt) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = t0;
        return range(utc, t1, dt);
      } finally {
        d3_date = Date;
      }
    }
    local.floor = local;
    local.round = round;
    local.ceil = ceil;
    local.offset = offset;
    local.range = range;
    var utc = local.utc = d3_time_interval_utc(local);
    utc.floor = utc;
    utc.round = d3_time_interval_utc(round);
    utc.ceil = d3_time_interval_utc(ceil);
    utc.offset = d3_time_interval_utc(offset);
    utc.range = range_utc;
    return local;
  }
  function d3_time_interval_utc(method) {
    return function(date, k) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = date;
        return method(utc, k)._;
      } finally {
        d3_date = Date;
      }
    };
  }
  d3_time.year = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setMonth(0, 1);
    return date;
  }, function(date, offset) {
    date.setFullYear(date.getFullYear() + offset);
  }, function(date) {
    return date.getFullYear();
  });
  d3_time.years = d3_time.year.range;
  d3_time.years.utc = d3_time.year.utc.range;
  d3_time.day = d3_time_interval(function(date) {
    var day = new d3_date(2e3, 0);
    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    return day;
  }, function(date, offset) {
    date.setDate(date.getDate() + offset);
  }, function(date) {
    return date.getDate() - 1;
  });
  d3_time.days = d3_time.day.range;
  d3_time.days.utc = d3_time.day.utc.range;
  d3_time.dayOfYear = function(date) {
    var year = d3_time.year(date);
    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
  };
  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
    i = 7 - i;
    var interval = d3_time[day] = d3_time_interval(function(date) {
      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
      return date;
    }, function(date, offset) {
      date.setDate(date.getDate() + Math.floor(offset) * 7);
    }, function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
    });
    d3_time[day + "s"] = interval.range;
    d3_time[day + "s"].utc = interval.utc.range;
    d3_time[day + "OfYear"] = function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
    };
  });
  d3_time.week = d3_time.sunday;
  d3_time.weeks = d3_time.sunday.range;
  d3_time.weeks.utc = d3_time.sunday.utc.range;
  d3_time.weekOfYear = d3_time.sundayOfYear;
  function d3_locale_timeFormat(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    function d3_time_format(template) {
      var n = template.length;
      function format(date) {
        var string = [], i = -1, j = 0, c, p, f;
        while (++i < n) {
          if (template.charCodeAt(i) === 37) {
            string.push(template.slice(j, i));
            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
            string.push(c);
            j = i + 1;
          }
        }
        string.push(template.slice(j, i));
        return string.join("");
      }
      format.parse = function(string) {
        var d = {
          y: 1900,
          m: 0,
          d: 1,
          H: 0,
          M: 0,
          S: 0,
          L: 0,
          Z: null
        }, i = d3_time_parse(d, template, string, 0);
        if (i != string.length) return null;
        if ("p" in d) d.H = d.H % 12 + d.p * 12;
        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
          date.setFullYear(d.y, 0, 1);
          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
        } else date.setFullYear(d.y, d.m, d.d);
        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
        return localZ ? date._ : date;
      };
      format.toString = function() {
        return template;
      };
      return format;
    }
    function d3_time_parse(date, template, string, j) {
      var c, p, t, i = 0, n = template.length, m = string.length;
      while (i < n) {
        if (j >= m) return -1;
        c = template.charCodeAt(i++);
        if (c === 37) {
          t = template.charAt(i++);
          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
          if (!p || (j = p(date, string, j)) < 0) return -1;
        } else if (c != string.charCodeAt(j++)) {
          return -1;
        }
      }
      return j;
    }
    d3_time_format.utc = function(template) {
      var local = d3_time_format(template);
      function format(date) {
        try {
          d3_date = d3_date_utc;
          var utc = new d3_date();
          utc._ = date;
          return local(utc);
        } finally {
          d3_date = Date;
        }
      }
      format.parse = function(string) {
        try {
          d3_date = d3_date_utc;
          var date = local.parse(string);
          return date && date._;
        } finally {
          d3_date = Date;
        }
      };
      format.toString = local.toString;
      return format;
    };
    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
    locale_periods.forEach(function(p, i) {
      d3_time_periodLookup.set(p.toLowerCase(), i);
    });
    var d3_time_formats = {
      a: function(d) {
        return locale_shortDays[d.getDay()];
      },
      A: function(d) {
        return locale_days[d.getDay()];
      },
      b: function(d) {
        return locale_shortMonths[d.getMonth()];
      },
      B: function(d) {
        return locale_months[d.getMonth()];
      },
      c: d3_time_format(locale_dateTime),
      d: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      e: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      H: function(d, p) {
        return d3_time_formatPad(d.getHours(), p, 2);
      },
      I: function(d, p) {
        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
      },
      j: function(d, p) {
        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
      },
      L: function(d, p) {
        return d3_time_formatPad(d.getMilliseconds(), p, 3);
      },
      m: function(d, p) {
        return d3_time_formatPad(d.getMonth() + 1, p, 2);
      },
      M: function(d, p) {
        return d3_time_formatPad(d.getMinutes(), p, 2);
      },
      p: function(d) {
        return locale_periods[+(d.getHours() >= 12)];
      },
      S: function(d, p) {
        return d3_time_formatPad(d.getSeconds(), p, 2);
      },
      U: function(d, p) {
        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
      },
      w: function(d) {
        return d.getDay();
      },
      W: function(d, p) {
        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
      },
      x: d3_time_format(locale_date),
      X: d3_time_format(locale_time),
      y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
      },
      Y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
      },
      Z: d3_time_zone,
      "%": function() {
        return "%";
      }
    };
    var d3_time_parsers = {
      a: d3_time_parseWeekdayAbbrev,
      A: d3_time_parseWeekday,
      b: d3_time_parseMonthAbbrev,
      B: d3_time_parseMonth,
      c: d3_time_parseLocaleFull,
      d: d3_time_parseDay,
      e: d3_time_parseDay,
      H: d3_time_parseHour24,
      I: d3_time_parseHour24,
      j: d3_time_parseDayOfYear,
      L: d3_time_parseMilliseconds,
      m: d3_time_parseMonthNumber,
      M: d3_time_parseMinutes,
      p: d3_time_parseAmPm,
      S: d3_time_parseSeconds,
      U: d3_time_parseWeekNumberSunday,
      w: d3_time_parseWeekdayNumber,
      W: d3_time_parseWeekNumberMonday,
      x: d3_time_parseLocaleDate,
      X: d3_time_parseLocaleTime,
      y: d3_time_parseYear,
      Y: d3_time_parseFullYear,
      Z: d3_time_parseZone,
      "%": d3_time_parseLiteralPercent
    };
    function d3_time_parseWeekdayAbbrev(date, string, i) {
      d3_time_dayAbbrevRe.lastIndex = 0;
      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseWeekday(date, string, i) {
      d3_time_dayRe.lastIndex = 0;
      var n = d3_time_dayRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonthAbbrev(date, string, i) {
      d3_time_monthAbbrevRe.lastIndex = 0;
      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonth(date, string, i) {
      d3_time_monthRe.lastIndex = 0;
      var n = d3_time_monthRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseLocaleFull(date, string, i) {
      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
    }
    function d3_time_parseLocaleDate(date, string, i) {
      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
    }
    function d3_time_parseLocaleTime(date, string, i) {
      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
    }
    function d3_time_parseAmPm(date, string, i) {
      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
      return n == null ? -1 : (date.p = n, i);
    }
    return d3_time_format;
  }
  var d3_time_formatPads = {
    "-": "",
    _: " ",
    "0": "0"
  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
  function d3_time_formatPad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
  }
  function d3_time_formatRe(names) {
    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
  }
  function d3_time_formatLookup(names) {
    var map = new d3_Map(), i = -1, n = names.length;
    while (++i < n) map.set(names[i].toLowerCase(), i);
    return map;
  }
  function d3_time_parseWeekdayNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
    return n ? (date.w = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberSunday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.U = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberMonday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.W = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseFullYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
    return n ? (date.y = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
  }
  function d3_time_parseZone(date, string, i) {
    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
    i + 5) : -1;
  }
  function d3_time_expandYear(d) {
    return d + (d > 68 ? 1900 : 2e3);
  }
  function d3_time_parseMonthNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
  }
  function d3_time_parseDay(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.d = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseDayOfYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.j = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseHour24(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.H = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMinutes(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.M = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseSeconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.S = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMilliseconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.L = +n[0], i + n[0].length) : -1;
  }
  function d3_time_zone(d) {
    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
  }
  function d3_time_parseLiteralPercent(date, string, i) {
    d3_time_percentRe.lastIndex = 0;
    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }
  function d3_time_formatMulti(formats) {
    var n = formats.length, i = -1;
    while (++i < n) formats[i][0] = this(formats[i][0]);
    return function(date) {
      var i = 0, f = formats[i];
      while (!f[1](date)) f = formats[++i];
      return f[0](date);
    };
  }
  d3.locale = function(locale) {
    return {
      numberFormat: d3_locale_numberFormat(locale),
      timeFormat: d3_locale_timeFormat(locale)
    };
  };
  var d3_locale_enUS = d3.locale({
    decimal: ".",
    thousands: ",",
    grouping: [ 3 ],
    currency: [ "$", "" ],
    dateTime: "%a %b %e %X %Y",
    date: "%m/%d/%Y",
    time: "%H:%M:%S",
    periods: [ "AM", "PM" ],
    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
  });
  d3.format = d3_locale_enUS.numberFormat;
  d3.geo = {};
  function d3_adder() {}
  d3_adder.prototype = {
    s: 0,
    t: 0,
    add: function(y) {
      d3_adderSum(y, this.t, d3_adderTemp);
      d3_adderSum(d3_adderTemp.s, this.s, this);
      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
    },
    reset: function() {
      this.s = this.t = 0;
    },
    valueOf: function() {
      return this.s;
    }
  };
  var d3_adderTemp = new d3_adder();
  function d3_adderSum(a, b, o) {
    var x = o.s = a + b, bv = x - a, av = x - bv;
    o.t = a - av + (b - bv);
  }
  d3.geo.stream = function(object, listener) {
    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
      d3_geo_streamObjectType[object.type](object, listener);
    } else {
      d3_geo_streamGeometry(object, listener);
    }
  };
  function d3_geo_streamGeometry(geometry, listener) {
    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
      d3_geo_streamGeometryType[geometry.type](geometry, listener);
    }
  }
  var d3_geo_streamObjectType = {
    Feature: function(feature, listener) {
      d3_geo_streamGeometry(feature.geometry, listener);
    },
    FeatureCollection: function(object, listener) {
      var features = object.features, i = -1, n = features.length;
      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
    }
  };
  var d3_geo_streamGeometryType = {
    Sphere: function(object, listener) {
      listener.sphere();
    },
    Point: function(object, listener) {
      object = object.coordinates;
      listener.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
    },
    LineString: function(object, listener) {
      d3_geo_streamLine(object.coordinates, listener, 0);
    },
    MultiLineString: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
    },
    Polygon: function(object, listener) {
      d3_geo_streamPolygon(object.coordinates, listener);
    },
    MultiPolygon: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
    },
    GeometryCollection: function(object, listener) {
      var geometries = object.geometries, i = -1, n = geometries.length;
      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
    }
  };
  function d3_geo_streamLine(coordinates, listener, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    listener.lineStart();
    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
    listener.lineEnd();
  }
  function d3_geo_streamPolygon(coordinates, listener) {
    var i = -1, n = coordinates.length;
    listener.polygonStart();
    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
    listener.polygonEnd();
  }
  d3.geo.area = function(object) {
    d3_geo_areaSum = 0;
    d3.geo.stream(object, d3_geo_area);
    return d3_geo_areaSum;
  };
  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
  var d3_geo_area = {
    sphere: function() {
      d3_geo_areaSum += 4 * π;
    },
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_areaRingSum.reset();
      d3_geo_area.lineStart = d3_geo_areaRingStart;
    },
    polygonEnd: function() {
      var area = 2 * d3_geo_areaRingSum;
      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
    }
  };
  function d3_geo_areaRingStart() {
    var λ00, φ00, λ0, cosφ0, sinφ0;
    d3_geo_area.point = function(λ, φ) {
      d3_geo_area.point = nextPoint;
      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
      sinφ0 = Math.sin(φ);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      φ = φ * d3_radians / 2 + π / 4;
      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
      d3_geo_areaRingSum.add(Math.atan2(v, u));
      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
    }
    d3_geo_area.lineEnd = function() {
      nextPoint(λ00, φ00);
    };
  }
  function d3_geo_cartesian(spherical) {
    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
  }
  function d3_geo_cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
  }
  function d3_geo_cartesianCross(a, b) {
    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
  }
  function d3_geo_cartesianAdd(a, b) {
    a[0] += b[0];
    a[1] += b[1];
    a[2] += b[2];
  }
  function d3_geo_cartesianScale(vector, k) {
    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
  }
  function d3_geo_cartesianNormalize(d) {
    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l;
    d[1] /= l;
    d[2] /= l;
  }
  function d3_geo_spherical(cartesian) {
    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
  }
  function d3_geo_sphericalEqual(a, b) {
    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
  }
  d3.geo.bounds = function() {
    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
    var bound = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        bound.point = ringPoint;
        bound.lineStart = ringStart;
        bound.lineEnd = ringEnd;
        dλSum = 0;
        d3_geo_area.polygonStart();
      },
      polygonEnd: function() {
        d3_geo_area.polygonEnd();
        bound.point = point;
        bound.lineStart = lineStart;
        bound.lineEnd = lineEnd;
        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
        range[0] = λ0, range[1] = λ1;
      }
    };
    function point(λ, φ) {
      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
      if (φ < φ0) φ0 = φ;
      if (φ > φ1) φ1 = φ;
    }
    function linePoint(λ, φ) {
      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
      if (p0) {
        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
        d3_geo_cartesianNormalize(inflection);
        inflection = d3_geo_spherical(inflection);
        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = inflection[1] * d3_degrees;
          if (φi > φ1) φ1 = φi;
        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = -inflection[1] * d3_degrees;
          if (φi < φ0) φ0 = φi;
        } else {
          if (φ < φ0) φ0 = φ;
          if (φ > φ1) φ1 = φ;
        }
        if (antimeridian) {
          if (λ < λ_) {
            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
          } else {
            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
          }
        } else {
          if (λ1 >= λ0) {
            if (λ < λ0) λ0 = λ;
            if (λ > λ1) λ1 = λ;
          } else {
            if (λ > λ_) {
              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
            } else {
              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
            }
          }
        }
      } else {
        point(λ, φ);
      }
      p0 = p, λ_ = λ;
    }
    function lineStart() {
      bound.point = linePoint;
    }
    function lineEnd() {
      range[0] = λ0, range[1] = λ1;
      bound.point = point;
      p0 = null;
    }
    function ringPoint(λ, φ) {
      if (p0) {
        var dλ = λ - λ_;
        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
      } else λ__ = λ, φ__ = φ;
      d3_geo_area.point(λ, φ);
      linePoint(λ, φ);
    }
    function ringStart() {
      d3_geo_area.lineStart();
    }
    function ringEnd() {
      ringPoint(λ__, φ__);
      d3_geo_area.lineEnd();
      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
      range[0] = λ0, range[1] = λ1;
      p0 = null;
    }
    function angle(λ0, λ1) {
      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
    }
    function compareRanges(a, b) {
      return a[0] - b[0];
    }
    function withinRange(x, range) {
      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
    }
    return function(feature) {
      φ1 = λ1 = -(λ0 = φ0 = Infinity);
      ranges = [];
      d3.geo.stream(feature, bound);
      var n = ranges.length;
      if (n) {
        ranges.sort(compareRanges);
        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
          b = ranges[i];
          if (withinRange(b[0], a) || withinRange(b[1], a)) {
            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
          } else {
            merged.push(a = b);
          }
        }
        var best = -Infinity, dλ;
        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
          b = merged[i];
          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
        }
      }
      ranges = range = null;
      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
    };
  }();
  d3.geo.centroid = function(object) {
    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
    d3.geo.stream(object, d3_geo_centroid);
    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
    if (m < ε2) {
      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
      m = x * x + y * y + z * z;
      if (m < ε2) return [ NaN, NaN ];
    }
    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
  };
  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
  var d3_geo_centroid = {
    sphere: d3_noop,
    point: d3_geo_centroidPoint,
    lineStart: d3_geo_centroidLineStart,
    lineEnd: d3_geo_centroidLineEnd,
    polygonStart: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
    }
  };
  function d3_geo_centroidPoint(λ, φ) {
    λ *= d3_radians;
    var cosφ = Math.cos(φ *= d3_radians);
    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
  }
  function d3_geo_centroidPointXYZ(x, y, z) {
    ++d3_geo_centroidW0;
    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
  }
  function d3_geo_centroidLineStart() {
    var x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroid.point = nextPoint;
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_centroidLineEnd() {
    d3_geo_centroid.point = d3_geo_centroidPoint;
  }
  function d3_geo_centroidRingStart() {
    var λ00, φ00, x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ00 = λ, φ00 = φ;
      d3_geo_centroid.point = nextPoint;
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    d3_geo_centroid.lineEnd = function() {
      nextPoint(λ00, φ00);
      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
      d3_geo_centroid.point = d3_geo_centroidPoint;
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
      d3_geo_centroidX2 += v * cx;
      d3_geo_centroidY2 += v * cy;
      d3_geo_centroidZ2 += v * cz;
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_compose(a, b) {
    function compose(x, y) {
      return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
  }
  function d3_true() {
    return true;
  }
  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
    var subject = [], clip = [];
    segments.forEach(function(segment) {
      if ((n = segment.length - 1) <= 0) return;
      var n, p0 = segment[0], p1 = segment[n];
      if (d3_geo_sphericalEqual(p0, p1)) {
        listener.lineStart();
        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
        listener.lineEnd();
        return;
      }
      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
      a.o = b;
      subject.push(a);
      clip.push(b);
      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
      a.o = b;
      subject.push(a);
      clip.push(b);
    });
    clip.sort(compare);
    d3_geo_clipPolygonLinkCircular(subject);
    d3_geo_clipPolygonLinkCircular(clip);
    if (!subject.length) return;
    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
      clip[i].e = entry = !entry;
    }
    var start = subject[0], points, point;
    while (1) {
      var current = start, isSubject = true;
      while (current.v) if ((current = current.n) === start) return;
      points = current.z;
      listener.lineStart();
      do {
        current.v = current.o.v = true;
        if (current.e) {
          if (isSubject) {
            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.n.x, 1, listener);
          }
          current = current.n;
        } else {
          if (isSubject) {
            points = current.p.z;
            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.p.x, -1, listener);
          }
          current = current.p;
        }
        current = current.o;
        points = current.z;
        isSubject = !isSubject;
      } while (!current.v);
      listener.lineEnd();
    }
  }
  function d3_geo_clipPolygonLinkCircular(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while (++i < n) {
      a.n = b = array[i];
      b.p = a;
      a = b;
    }
    a.n = b = array[0];
    b.p = a;
  }
  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other;
    this.e = entry;
    this.v = false;
    this.n = this.p = null;
  }
  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
    return function(rotate, listener) {
      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          clip.point = pointRing;
          clip.lineStart = ringStart;
          clip.lineEnd = ringEnd;
          segments = [];
          polygon = [];
        },
        polygonEnd: function() {
          clip.point = point;
          clip.lineStart = lineStart;
          clip.lineEnd = lineEnd;
          segments = d3.merge(segments);
          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
          if (segments.length) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
          } else if (clipStartInside) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            interpolate(null, null, 1, listener);
            listener.lineEnd();
          }
          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
          segments = polygon = null;
        },
        sphere: function() {
          listener.polygonStart();
          listener.lineStart();
          interpolate(null, null, 1, listener);
          listener.lineEnd();
          listener.polygonEnd();
        }
      };
      function point(λ, φ) {
        var point = rotate(λ, φ);
        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
      }
      function pointLine(λ, φ) {
        var point = rotate(λ, φ);
        line.point(point[0], point[1]);
      }
      function lineStart() {
        clip.point = pointLine;
        line.lineStart();
      }
      function lineEnd() {
        clip.point = point;
        line.lineEnd();
      }
      var segments;
      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
      function pointRing(λ, φ) {
        ring.push([ λ, φ ]);
        var point = rotate(λ, φ);
        ringListener.point(point[0], point[1]);
      }
      function ringStart() {
        ringListener.lineStart();
        ring = [];
      }
      function ringEnd() {
        pointRing(ring[0][0], ring[0][1]);
        ringListener.lineEnd();
        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
        ring.pop();
        polygon.push(ring);
        ring = null;
        if (!n) return;
        if (clean & 1) {
          segment = ringSegments[0];
          var n = segment.length - 1, i = -1, point;
          if (n > 0) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            while (++i < n) listener.point((point = segment[i])[0], point[1]);
            listener.lineEnd();
          }
          return;
        }
        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
      }
      return clip;
    };
  }
  function d3_geo_clipSegmentLength1(segment) {
    return segment.length > 1;
  }
  function d3_geo_clipBufferListener() {
    var lines = [], line;
    return {
      lineStart: function() {
        lines.push(line = []);
      },
      point: function(λ, φ) {
        line.push([ λ, φ ]);
      },
      lineEnd: d3_noop,
      buffer: function() {
        var buffer = lines;
        lines = [];
        line = null;
        return buffer;
      },
      rejoin: function() {
        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
      }
    };
  }
  function d3_geo_clipSort(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
  }
  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
  function d3_geo_clipAntimeridianLine(listener) {
    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
    return {
      lineStart: function() {
        listener.lineStart();
        clean = 1;
      },
      point: function(λ1, φ1) {
        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
        if (abs(dλ - π) < ε) {
          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          listener.point(λ1, φ0);
          clean = 0;
        } else if (sλ0 !== sλ1 && dλ >= π) {
          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          clean = 0;
        }
        listener.point(λ0 = λ1, φ0 = φ1);
        sλ0 = sλ1;
      },
      lineEnd: function() {
        listener.lineEnd();
        λ0 = φ0 = NaN;
      },
      clean: function() {
        return 2 - clean;
      }
    };
  }
  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
  }
  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
    var φ;
    if (from == null) {
      φ = direction * halfπ;
      listener.point(-π, φ);
      listener.point(0, φ);
      listener.point(π, φ);
      listener.point(π, 0);
      listener.point(π, -φ);
      listener.point(0, -φ);
      listener.point(-π, -φ);
      listener.point(-π, 0);
      listener.point(-π, φ);
    } else if (abs(from[0] - to[0]) > ε) {
      var s = from[0] < to[0] ? π : -π;
      φ = direction * s / 2;
      listener.point(-s, φ);
      listener.point(0, φ);
      listener.point(s, φ);
    } else {
      listener.point(to[0], to[1]);
    }
  }
  function d3_geo_pointInPolygon(point, polygon) {
    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
    d3_geo_areaRingSum.reset();
    for (var i = 0, n = polygon.length; i < n; ++i) {
      var ring = polygon[i], m = ring.length;
      if (!m) continue;
      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
      while (true) {
        if (j === m) j = 0;
        point = ring[j];
        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
          d3_geo_cartesianNormalize(arc);
          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
          d3_geo_cartesianNormalize(intersection);
          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
          }
        }
        if (!j++) break;
        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
      }
    }
    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
  }
  function d3_geo_clipCircle(radius) {
    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
    function visible(λ, φ) {
      return Math.cos(λ) * Math.cos(φ) > cr;
    }
    function clipLine(listener) {
      var point0, c0, v0, v00, clean;
      return {
        lineStart: function() {
          v00 = v0 = false;
          clean = 1;
        },
        point: function(λ, φ) {
          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
          if (!point0 && (v00 = v0 = v)) listener.lineStart();
          if (v !== v0) {
            point2 = intersect(point0, point1);
            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
              point1[0] += ε;
              point1[1] += ε;
              v = visible(point1[0], point1[1]);
            }
          }
          if (v !== v0) {
            clean = 0;
            if (v) {
              listener.lineStart();
              point2 = intersect(point1, point0);
              listener.point(point2[0], point2[1]);
            } else {
              point2 = intersect(point0, point1);
              listener.point(point2[0], point2[1]);
              listener.lineEnd();
            }
            point0 = point2;
          } else if (notHemisphere && point0 && smallRadius ^ v) {
            var t;
            if (!(c & c0) && (t = intersect(point1, point0, true))) {
              clean = 0;
              if (smallRadius) {
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
              } else {
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
              }
            }
          }
          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
            listener.point(point1[0], point1[1]);
          }
          point0 = point1, v0 = v, c0 = c;
        },
        lineEnd: function() {
          if (v0) listener.lineEnd();
          point0 = null;
        },
        clean: function() {
          return clean | (v00 && v0) << 1;
        }
      };
    }
    function intersect(a, b, two) {
      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
      if (!determinant) return !two && a;
      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
      d3_geo_cartesianAdd(A, B);
      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
      if (t2 < 0) return;
      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
      d3_geo_cartesianAdd(q, A);
      q = d3_geo_spherical(q);
      if (!two) return q;
      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
        d3_geo_cartesianAdd(q1, A);
        return [ q, d3_geo_spherical(q1) ];
      }
    }
    function code(λ, φ) {
      var r = smallRadius ? radius : π - radius, code = 0;
      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
      return code;
    }
  }
  function d3_geom_clipLine(x0, y0, x1, y1) {
    return function(line) {
      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
      r = x0 - ax;
      if (!dx && r > 0) return;
      r /= dx;
      if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = x1 - ax;
      if (!dx && r < 0) return;
      r /= dx;
      if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      r = y0 - ay;
      if (!dy && r > 0) return;
      r /= dy;
      if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = y1 - ay;
      if (!dy && r < 0) return;
      r /= dy;
      if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      if (t0 > 0) line.a = {
        x: ax + t0 * dx,
        y: ay + t0 * dy
      };
      if (t1 < 1) line.b = {
        x: ax + t1 * dx,
        y: ay + t1 * dy
      };
      return line;
    };
  }
  var d3_geo_clipExtentMAX = 1e9;
  d3.geo.clipExtent = function() {
    var x0, y0, x1, y1, stream, clip, clipExtent = {
      stream: function(output) {
        if (stream) stream.valid = false;
        stream = clip(output);
        stream.valid = true;
        return stream;
      },
      extent: function(_) {
        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
        if (stream) stream.valid = false, stream = null;
        return clipExtent;
      }
    };
    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
  };
  function d3_geo_clipExtent(x0, y0, x1, y1) {
    return function(listener) {
      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          listener = bufferListener;
          segments = [];
          polygon = [];
          clean = true;
        },
        polygonEnd: function() {
          listener = listener_;
          segments = d3.merge(segments);
          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
          if (inside || visible) {
            listener.polygonStart();
            if (inside) {
              listener.lineStart();
              interpolate(null, null, 1, listener);
              listener.lineEnd();
            }
            if (visible) {
              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
            }
            listener.polygonEnd();
          }
          segments = polygon = ring = null;
        }
      };
      function insidePolygon(p) {
        var wn = 0, n = polygon.length, y = p[1];
        for (var i = 0; i < n; ++i) {
          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
            b = v[j];
            if (a[1] <= y) {
              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
            } else {
              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
            }
            a = b;
          }
        }
        return wn !== 0;
      }
      function interpolate(from, to, direction, listener) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
          do {
            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
          } while ((a = (a + direction + 4) % 4) !== a1);
        } else {
          listener.point(to[0], to[1]);
        }
      }
      function pointVisible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
      }
      function point(x, y) {
        if (pointVisible(x, y)) listener.point(x, y);
      }
      var x__, y__, v__, x_, y_, v_, first, clean;
      function lineStart() {
        clip.point = linePoint;
        if (polygon) polygon.push(ring = []);
        first = true;
        v_ = false;
        x_ = y_ = NaN;
      }
      function lineEnd() {
        if (segments) {
          linePoint(x__, y__);
          if (v__ && v_) bufferListener.rejoin();
          segments.push(bufferListener.buffer());
        }
        clip.point = point;
        if (v_) listener.lineEnd();
      }
      function linePoint(x, y) {
        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
        var v = pointVisible(x, y);
        if (polygon) ring.push([ x, y ]);
        if (first) {
          x__ = x, y__ = y, v__ = v;
          first = false;
          if (v) {
            listener.lineStart();
            listener.point(x, y);
          }
        } else {
          if (v && v_) listener.point(x, y); else {
            var l = {
              a: {
                x: x_,
                y: y_
              },
              b: {
                x: x,
                y: y
              }
            };
            if (clipLine(l)) {
              if (!v_) {
                listener.lineStart();
                listener.point(l.a.x, l.a.y);
              }
              listener.point(l.b.x, l.b.y);
              if (!v) listener.lineEnd();
              clean = false;
            } else if (v) {
              listener.lineStart();
              listener.point(x, y);
              clean = false;
            }
          }
        }
        x_ = x, y_ = y, v_ = v;
      }
      return clip;
    };
    function corner(p, direction) {
      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
    }
    function compare(a, b) {
      return comparePoints(a.x, b.x);
    }
    function comparePoints(a, b) {
      var ca = corner(a, 1), cb = corner(b, 1);
      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
  }
  function d3_geo_conic(projectAt) {
    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
    p.parallels = function(_) {
      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
    };
    return p;
  }
  function d3_geo_conicEqualArea(φ0, φ1) {
    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
    function forward(λ, φ) {
      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = ρ0 - y;
      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
    };
    return forward;
  }
  (d3.geo.conicEqualArea = function() {
    return d3_geo_conic(d3_geo_conicEqualArea);
  }).raw = d3_geo_conicEqualArea;
  d3.geo.albers = function() {
    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
  };
  d3.geo.albersUsa = function() {
    var lower48 = d3.geo.albers();
    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
    var point, pointStream = {
      point: function(x, y) {
        point = [ x, y ];
      }
    }, lower48Point, alaskaPoint, hawaiiPoint;
    function albersUsa(coordinates) {
      var x = coordinates[0], y = coordinates[1];
      point = null;
      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
      return point;
    }
    albersUsa.invert = function(coordinates) {
      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
      return {
        point: function(x, y) {
          lower48Stream.point(x, y);
          alaskaStream.point(x, y);
          hawaiiStream.point(x, y);
        },
        sphere: function() {
          lower48Stream.sphere();
          alaskaStream.sphere();
          hawaiiStream.sphere();
        },
        lineStart: function() {
          lower48Stream.lineStart();
          alaskaStream.lineStart();
          hawaiiStream.lineStart();
        },
        lineEnd: function() {
          lower48Stream.lineEnd();
          alaskaStream.lineEnd();
          hawaiiStream.lineEnd();
        },
        polygonStart: function() {
          lower48Stream.polygonStart();
          alaskaStream.polygonStart();
          hawaiiStream.polygonStart();
        },
        polygonEnd: function() {
          lower48Stream.polygonEnd();
          alaskaStream.polygonEnd();
          hawaiiStream.polygonEnd();
        }
      };
    };
    albersUsa.precision = function(_) {
      if (!arguments.length) return lower48.precision();
      lower48.precision(_);
      alaska.precision(_);
      hawaii.precision(_);
      return albersUsa;
    };
    albersUsa.scale = function(_) {
      if (!arguments.length) return lower48.scale();
      lower48.scale(_);
      alaska.scale(_ * .35);
      hawaii.scale(_);
      return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
      if (!arguments.length) return lower48.translate();
      var k = lower48.scale(), x = +_[0], y = +_[1];
      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      return albersUsa;
    };
    return albersUsa.scale(1070);
  };
  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_pathAreaPolygon = 0;
      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
    }
  };
  function d3_geo_pathAreaRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathArea.point = function(x, y) {
      d3_geo_pathArea.point = nextPoint;
      x00 = x0 = x, y00 = y0 = y;
    };
    function nextPoint(x, y) {
      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
      x0 = x, y0 = y;
    }
    d3_geo_pathArea.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
  var d3_geo_pathBounds = {
    point: d3_geo_pathBoundsPoint,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_pathBoundsPoint(x, y) {
    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
  }
  function d3_geo_pathBuffer() {
    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointCircle = d3_geo_pathBufferCircle(_);
        return stream;
      },
      result: function() {
        if (buffer.length) {
          var result = buffer.join("");
          buffer = [];
          return result;
        }
      }
    };
    function point(x, y) {
      buffer.push("M", x, ",", y, pointCircle);
    }
    function pointLineStart(x, y) {
      buffer.push("M", x, ",", y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      buffer.push("L", x, ",", y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      buffer.push("Z");
    }
    return stream;
  }
  function d3_geo_pathBufferCircle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
  }
  var d3_geo_pathCentroid = {
    point: d3_geo_pathCentroidPoint,
    lineStart: d3_geo_pathCentroidLineStart,
    lineEnd: d3_geo_pathCentroidLineEnd,
    polygonStart: function() {
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
    }
  };
  function d3_geo_pathCentroidPoint(x, y) {
    d3_geo_centroidX0 += x;
    d3_geo_centroidY0 += y;
    ++d3_geo_centroidZ0;
  }
  function d3_geo_pathCentroidLineStart() {
    var x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
  }
  function d3_geo_pathCentroidLineEnd() {
    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
  }
  function d3_geo_pathCentroidRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      z = y0 * x - x0 * y;
      d3_geo_centroidX2 += z * (x0 + x);
      d3_geo_centroidY2 += z * (y0 + y);
      d3_geo_centroidZ2 += z * 3;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
    d3_geo_pathCentroid.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  function d3_geo_pathContext(context) {
    var pointRadius = 4.5;
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointRadius = _;
        return stream;
      },
      result: d3_noop
    };
    function point(x, y) {
      context.moveTo(x + pointRadius, y);
      context.arc(x, y, pointRadius, 0, τ);
    }
    function pointLineStart(x, y) {
      context.moveTo(x, y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      context.lineTo(x, y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      context.closePath();
    }
    return stream;
  }
  function d3_geo_resample(project) {
    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
    function resample(stream) {
      return (maxDepth ? resampleRecursive : resampleNone)(stream);
    }
    function resampleNone(stream) {
      return d3_geo_transformPoint(stream, function(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      });
    }
    function resampleRecursive(stream) {
      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
      var resample = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          stream.polygonStart();
          resample.lineStart = ringStart;
        },
        polygonEnd: function() {
          stream.polygonEnd();
          resample.lineStart = lineStart;
        }
      };
      function point(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      }
      function lineStart() {
        x0 = NaN;
        resample.point = linePoint;
        stream.lineStart();
      }
      function linePoint(λ, φ) {
        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
        stream.point(x0, y0);
      }
      function lineEnd() {
        resample.point = point;
        stream.lineEnd();
      }
      function ringStart() {
        lineStart();
        resample.point = ringPoint;
        resample.lineEnd = ringEnd;
      }
      function ringPoint(λ, φ) {
        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
        resample.point = linePoint;
      }
      function ringEnd() {
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
        resample.lineEnd = lineEnd;
        lineEnd();
      }
      return resample;
    }
    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
      if (d2 > 4 * δ2 && depth--) {
        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
          stream.point(x2, y2);
          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
        }
      }
    }
    resample.precision = function(_) {
      if (!arguments.length) return Math.sqrt(δ2);
      maxDepth = (δ2 = _ * _) > 0 && 16;
      return resample;
    };
    return resample;
  }
  d3.geo.path = function() {
    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
    function path(object) {
      if (object) {
        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
        d3.geo.stream(object, cacheStream);
      }
      return contextStream.result();
    }
    path.area = function(object) {
      d3_geo_pathAreaSum = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathArea));
      return d3_geo_pathAreaSum;
    };
    path.centroid = function(object) {
      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
    };
    path.bounds = function(object) {
      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
    };
    path.projection = function(_) {
      if (!arguments.length) return projection;
      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
      return reset();
    };
    path.context = function(_) {
      if (!arguments.length) return context;
      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
      return reset();
    };
    path.pointRadius = function(_) {
      if (!arguments.length) return pointRadius;
      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
      return path;
    };
    function reset() {
      cacheStream = null;
      return path;
    }
    return path.projection(d3.geo.albersUsa()).context(null);
  };
  function d3_geo_pathProjectStream(project) {
    var resample = d3_geo_resample(function(x, y) {
      return project([ x * d3_degrees, y * d3_degrees ]);
    });
    return function(stream) {
      return d3_geo_projectionRadians(resample(stream));
    };
  }
  d3.geo.transform = function(methods) {
    return {
      stream: function(stream) {
        var transform = new d3_geo_transform(stream);
        for (var k in methods) transform[k] = methods[k];
        return transform;
      }
    };
  };
  function d3_geo_transform(stream) {
    this.stream = stream;
  }
  d3_geo_transform.prototype = {
    point: function(x, y) {
      this.stream.point(x, y);
    },
    sphere: function() {
      this.stream.sphere();
    },
    lineStart: function() {
      this.stream.lineStart();
    },
    lineEnd: function() {
      this.stream.lineEnd();
    },
    polygonStart: function() {
      this.stream.polygonStart();
    },
    polygonEnd: function() {
      this.stream.polygonEnd();
    }
  };
  function d3_geo_transformPoint(stream, point) {
    return {
      point: point,
      sphere: function() {
        stream.sphere();
      },
      lineStart: function() {
        stream.lineStart();
      },
      lineEnd: function() {
        stream.lineEnd();
      },
      polygonStart: function() {
        stream.polygonStart();
      },
      polygonEnd: function() {
        stream.polygonEnd();
      }
    };
  }
  d3.geo.projection = d3_geo_projection;
  d3.geo.projectionMutator = d3_geo_projectionMutator;
  function d3_geo_projection(project) {
    return d3_geo_projectionMutator(function() {
      return project;
    })();
  }
  function d3_geo_projectionMutator(projectAt) {
    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
      x = project(x, y);
      return [ x[0] * k + δx, δy - x[1] * k ];
    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
    function projection(point) {
      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
      return [ point[0] * k + δx, δy - point[1] * k ];
    }
    function invert(point) {
      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
    }
    projection.stream = function(output) {
      if (stream) stream.valid = false;
      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
      stream.valid = true;
      return stream;
    };
    projection.clipAngle = function(_) {
      if (!arguments.length) return clipAngle;
      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
      return invalidate();
    };
    projection.clipExtent = function(_) {
      if (!arguments.length) return clipExtent;
      clipExtent = _;
      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
      return invalidate();
    };
    projection.scale = function(_) {
      if (!arguments.length) return k;
      k = +_;
      return reset();
    };
    projection.translate = function(_) {
      if (!arguments.length) return [ x, y ];
      x = +_[0];
      y = +_[1];
      return reset();
    };
    projection.center = function(_) {
      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
      λ = _[0] % 360 * d3_radians;
      φ = _[1] % 360 * d3_radians;
      return reset();
    };
    projection.rotate = function(_) {
      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
      δλ = _[0] % 360 * d3_radians;
      δφ = _[1] % 360 * d3_radians;
      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
      return reset();
    };
    d3.rebind(projection, projectResample, "precision");
    function reset() {
      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
      var center = project(λ, φ);
      δx = x - center[0] * k;
      δy = y + center[1] * k;
      return invalidate();
    }
    function invalidate() {
      if (stream) stream.valid = false, stream = null;
      return projection;
    }
    return function() {
      project = projectAt.apply(this, arguments);
      projection.invert = project.invert && invert;
      return reset();
    };
  }
  function d3_geo_projectionRadians(stream) {
    return d3_geo_transformPoint(stream, function(x, y) {
      stream.point(x * d3_radians, y * d3_radians);
    });
  }
  function d3_geo_equirectangular(λ, φ) {
    return [ λ, φ ];
  }
  (d3.geo.equirectangular = function() {
    return d3_geo_projection(d3_geo_equirectangular);
  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
  d3.geo.rotation = function(rotate) {
    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
    function forward(coordinates) {
      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    }
    forward.invert = function(coordinates) {
      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    };
    return forward;
  };
  function d3_geo_identityRotation(λ, φ) {
    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
  }
  d3_geo_identityRotation.invert = d3_geo_equirectangular;
  function d3_geo_rotation(δλ, δφ, δγ) {
    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
  }
  function d3_geo_forwardRotationλ(δλ) {
    return function(λ, φ) {
      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
    };
  }
  function d3_geo_rotationλ(δλ) {
    var rotation = d3_geo_forwardRotationλ(δλ);
    rotation.invert = d3_geo_forwardRotationλ(-δλ);
    return rotation;
  }
  function d3_geo_rotationφγ(δφ, δγ) {
    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
    function rotation(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
    }
    rotation.invert = function(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
    };
    return rotation;
  }
  d3.geo.circle = function() {
    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
    function circle() {
      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
      interpolate(null, null, 1, {
        point: function(x, y) {
          ring.push(x = rotate(x, y));
          x[0] *= d3_degrees, x[1] *= d3_degrees;
        }
      });
      return {
        type: "Polygon",
        coordinates: [ ring ]
      };
    }
    circle.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return circle;
    };
    circle.angle = function(x) {
      if (!arguments.length) return angle;
      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
      return circle;
    };
    circle.precision = function(_) {
      if (!arguments.length) return precision;
      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
      return circle;
    };
    return circle.angle(90);
  };
  function d3_geo_circleInterpolate(radius, precision) {
    var cr = Math.cos(radius), sr = Math.sin(radius);
    return function(from, to, direction, listener) {
      var step = direction * precision;
      if (from != null) {
        from = d3_geo_circleAngle(cr, from);
        to = d3_geo_circleAngle(cr, to);
        if (direction > 0 ? from < to : from > to) from += direction * τ;
      } else {
        from = radius + direction * τ;
        to = radius - .5 * step;
      }
      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
      }
    };
  }
  function d3_geo_circleAngle(cr, point) {
    var a = d3_geo_cartesian(point);
    a[0] -= cr;
    d3_geo_cartesianNormalize(a);
    var angle = d3_acos(-a[1]);
    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
  }
  d3.geo.distance = function(a, b) {
    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
  };
  d3.geo.graticule = function() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
      return {
        type: "MultiLineString",
        coordinates: lines()
      };
    }
    function lines() {
      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
        return abs(x % DX) > ε;
      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
        return abs(y % DY) > ε;
      }).map(y));
    }
    graticule.lines = function() {
      return lines().map(function(coordinates) {
        return {
          type: "LineString",
          coordinates: coordinates
        };
      });
    };
    graticule.outline = function() {
      return {
        type: "Polygon",
        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
      };
    };
    graticule.extent = function(_) {
      if (!arguments.length) return graticule.minorExtent();
      return graticule.majorExtent(_).minorExtent(_);
    };
    graticule.majorExtent = function(_) {
      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
      X0 = +_[0][0], X1 = +_[1][0];
      Y0 = +_[0][1], Y1 = +_[1][1];
      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
      return graticule.precision(precision);
    };
    graticule.minorExtent = function(_) {
      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
      x0 = +_[0][0], x1 = +_[1][0];
      y0 = +_[0][1], y1 = +_[1][1];
      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
      return graticule.precision(precision);
    };
    graticule.step = function(_) {
      if (!arguments.length) return graticule.minorStep();
      return graticule.majorStep(_).minorStep(_);
    };
    graticule.majorStep = function(_) {
      if (!arguments.length) return [ DX, DY ];
      DX = +_[0], DY = +_[1];
      return graticule;
    };
    graticule.minorStep = function(_) {
      if (!arguments.length) return [ dx, dy ];
      dx = +_[0], dy = +_[1];
      return graticule;
    };
    graticule.precision = function(_) {
      if (!arguments.length) return precision;
      precision = +_;
      x = d3_geo_graticuleX(y0, y1, 90);
      y = d3_geo_graticuleY(x0, x1, precision);
      X = d3_geo_graticuleX(Y0, Y1, 90);
      Y = d3_geo_graticuleY(X0, X1, precision);
      return graticule;
    };
    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
  };
  function d3_geo_graticuleX(y0, y1, dy) {
    var y = d3.range(y0, y1 - ε, dy).concat(y1);
    return function(x) {
      return y.map(function(y) {
        return [ x, y ];
      });
    };
  }
  function d3_geo_graticuleY(x0, x1, dx) {
    var x = d3.range(x0, x1 - ε, dx).concat(x1);
    return function(y) {
      return x.map(function(x) {
        return [ x, y ];
      });
    };
  }
  function d3_source(d) {
    return d.source;
  }
  function d3_target(d) {
    return d.target;
  }
  d3.geo.greatArc = function() {
    var source = d3_source, source_, target = d3_target, target_;
    function greatArc() {
      return {
        type: "LineString",
        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
      };
    }
    greatArc.distance = function() {
      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
    };
    greatArc.source = function(_) {
      if (!arguments.length) return source;
      source = _, source_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.target = function(_) {
      if (!arguments.length) return target;
      target = _, target_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.precision = function() {
      return arguments.length ? greatArc : 0;
    };
    return greatArc;
  };
  d3.geo.interpolate = function(source, target) {
    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
  };
  function d3_geo_interpolate(x0, y0, x1, y1) {
    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
    var interpolate = d ? function(t) {
      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
    } : function() {
      return [ x0 * d3_degrees, y0 * d3_degrees ];
    };
    interpolate.distance = d;
    return interpolate;
  }
  d3.geo.length = function(object) {
    d3_geo_lengthSum = 0;
    d3.geo.stream(object, d3_geo_length);
    return d3_geo_lengthSum;
  };
  var d3_geo_lengthSum;
  var d3_geo_length = {
    sphere: d3_noop,
    point: d3_noop,
    lineStart: d3_geo_lengthLineStart,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_lengthLineStart() {
    var λ0, sinφ0, cosφ0;
    d3_geo_length.point = function(λ, φ) {
      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
      d3_geo_length.point = nextPoint;
    };
    d3_geo_length.lineEnd = function() {
      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
    };
    function nextPoint(λ, φ) {
      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
    }
  }
  function d3_geo_azimuthal(scale, angle) {
    function azimuthal(λ, φ) {
      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
    }
    azimuthal.invert = function(x, y) {
      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
    };
    return azimuthal;
  }
  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
    return Math.sqrt(2 / (1 + cosλcosφ));
  }, function(ρ) {
    return 2 * Math.asin(ρ / 2);
  });
  (d3.geo.azimuthalEqualArea = function() {
    return d3_geo_projection(d3_geo_azimuthalEqualArea);
  }).raw = d3_geo_azimuthalEqualArea;
  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
    var c = Math.acos(cosλcosφ);
    return c && c / Math.sin(c);
  }, d3_identity);
  (d3.geo.azimuthalEquidistant = function() {
    return d3_geo_projection(d3_geo_azimuthalEquidistant);
  }).raw = d3_geo_azimuthalEquidistant;
  function d3_geo_conicConformal(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), t = function(φ) {
      return Math.tan(π / 4 + φ / 2);
    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
    if (!n) return d3_geo_mercator;
    function forward(λ, φ) {
      if (F > 0) {
        if (φ < -halfπ + ε) φ = -halfπ + ε;
      } else {
        if (φ > halfπ - ε) φ = halfπ - ε;
      }
      var ρ = F / Math.pow(t(φ), n);
      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
    };
    return forward;
  }
  (d3.geo.conicConformal = function() {
    return d3_geo_conic(d3_geo_conicConformal);
  }).raw = d3_geo_conicConformal;
  function d3_geo_conicEquidistant(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
    if (abs(n) < ε) return d3_geo_equirectangular;
    function forward(λ, φ) {
      var ρ = G - φ;
      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = G - y;
      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
    };
    return forward;
  }
  (d3.geo.conicEquidistant = function() {
    return d3_geo_conic(d3_geo_conicEquidistant);
  }).raw = d3_geo_conicEquidistant;
  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / cosλcosφ;
  }, Math.atan);
  (d3.geo.gnomonic = function() {
    return d3_geo_projection(d3_geo_gnomonic);
  }).raw = d3_geo_gnomonic;
  function d3_geo_mercator(λ, φ) {
    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
  }
  d3_geo_mercator.invert = function(x, y) {
    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
  };
  function d3_geo_mercatorProjection(project) {
    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
    m.scale = function() {
      var v = scale.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.translate = function() {
      var v = translate.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.clipExtent = function(_) {
      var v = clipExtent.apply(m, arguments);
      if (v === m) {
        if (clipAuto = _ == null) {
          var k = π * scale(), t = translate();
          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
        }
      } else if (clipAuto) {
        v = null;
      }
      return v;
    };
    return m.clipExtent(null);
  }
  (d3.geo.mercator = function() {
    return d3_geo_mercatorProjection(d3_geo_mercator);
  }).raw = d3_geo_mercator;
  var d3_geo_orthographic = d3_geo_azimuthal(function() {
    return 1;
  }, Math.asin);
  (d3.geo.orthographic = function() {
    return d3_geo_projection(d3_geo_orthographic);
  }).raw = d3_geo_orthographic;
  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / (1 + cosλcosφ);
  }, function(ρ) {
    return 2 * Math.atan(ρ);
  });
  (d3.geo.stereographic = function() {
    return d3_geo_projection(d3_geo_stereographic);
  }).raw = d3_geo_stereographic;
  function d3_geo_transverseMercator(λ, φ) {
    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
  }
  d3_geo_transverseMercator.invert = function(x, y) {
    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
  };
  (d3.geo.transverseMercator = function() {
    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
    projection.center = function(_) {
      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
    };
    projection.rotate = function(_) {
      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
      [ _[0], _[1], _[2] - 90 ]);
    };
    return rotate([ 0, 0, 90 ]);
  }).raw = d3_geo_transverseMercator;
  d3.geom = {};
  function d3_geom_pointX(d) {
    return d[0];
  }
  function d3_geom_pointY(d) {
    return d[1];
  }
  d3.geom.hull = function(vertices) {
    var x = d3_geom_pointX, y = d3_geom_pointY;
    if (arguments.length) return hull(vertices);
    function hull(data) {
      if (data.length < 3) return [];
      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
      for (i = 0; i < n; i++) {
        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
      }
      points.sort(d3_geom_hullOrder);
      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
      return polygon;
    }
    hull.x = function(_) {
      return arguments.length ? (x = _, hull) : x;
    };
    hull.y = function(_) {
      return arguments.length ? (y = _, hull) : y;
    };
    return hull;
  };
  function d3_geom_hullUpper(points) {
    var n = points.length, hull = [ 0, 1 ], hs = 2;
    for (var i = 2; i < n; i++) {
      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
      hull[hs++] = i;
    }
    return hull.slice(0, hs);
  }
  function d3_geom_hullOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
  }
  d3.geom.polygon = function(coordinates) {
    d3_subclass(coordinates, d3_geom_polygonPrototype);
    return coordinates;
  };
  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
  d3_geom_polygonPrototype.area = function() {
    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
    while (++i < n) {
      a = b;
      b = this[i];
      area += a[1] * b[0] - a[0] * b[1];
    }
    return area * .5;
  };
  d3_geom_polygonPrototype.centroid = function(k) {
    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
    if (!arguments.length) k = -1 / (6 * this.area());
    while (++i < n) {
      a = b;
      b = this[i];
      c = a[0] * b[1] - b[0] * a[1];
      x += (a[0] + b[0]) * c;
      y += (a[1] + b[1]) * c;
    }
    return [ x * k, y * k ];
  };
  d3_geom_polygonPrototype.clip = function(subject) {
    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
    while (++i < n) {
      input = subject.slice();
      subject.length = 0;
      b = this[i];
      c = input[(m = input.length - closed) - 1];
      j = -1;
      while (++j < m) {
        d = input[j];
        if (d3_geom_polygonInside(d, a, b)) {
          if (!d3_geom_polygonInside(c, a, b)) {
            subject.push(d3_geom_polygonIntersect(c, d, a, b));
          }
          subject.push(d);
        } else if (d3_geom_polygonInside(c, a, b)) {
          subject.push(d3_geom_polygonIntersect(c, d, a, b));
        }
        c = d;
      }
      if (closed) subject.push(subject[0]);
      a = b;
    }
    return subject;
  };
  function d3_geom_polygonInside(p, a, b) {
    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
  }
  function d3_geom_polygonIntersect(c, d, a, b) {
    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
    return [ x1 + ua * x21, y1 + ua * y21 ];
  }
  function d3_geom_polygonClosed(coordinates) {
    var a = coordinates[0], b = coordinates[coordinates.length - 1];
    return !(a[0] - b[0] || a[1] - b[1]);
  }
  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
  function d3_geom_voronoiBeach() {
    d3_geom_voronoiRedBlackNode(this);
    this.edge = this.site = this.circle = null;
  }
  function d3_geom_voronoiCreateBeach(site) {
    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
    beach.site = site;
    return beach;
  }
  function d3_geom_voronoiDetachBeach(beach) {
    d3_geom_voronoiDetachCircle(beach);
    d3_geom_voronoiBeaches.remove(beach);
    d3_geom_voronoiBeachPool.push(beach);
    d3_geom_voronoiRedBlackNode(beach);
  }
  function d3_geom_voronoiRemoveBeach(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
      x: x,
      y: y
    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
    d3_geom_voronoiDetachBeach(beach);
    var lArc = previous;
    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
      previous = lArc.P;
      disappearing.unshift(lArc);
      d3_geom_voronoiDetachBeach(lArc);
      lArc = previous;
    }
    disappearing.unshift(lArc);
    d3_geom_voronoiDetachCircle(lArc);
    var rArc = next;
    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
      next = rArc.N;
      disappearing.push(rArc);
      d3_geom_voronoiDetachBeach(rArc);
      rArc = next;
    }
    disappearing.push(rArc);
    d3_geom_voronoiDetachCircle(rArc);
    var nArcs = disappearing.length, iArc;
    for (iArc = 1; iArc < nArcs; ++iArc) {
      rArc = disappearing[iArc];
      lArc = disappearing[iArc - 1];
      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiAddBeach(site) {
    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
    while (node) {
      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
      if (dxl > ε) node = node.L; else {
        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
        if (dxr > ε) {
          if (!node.R) {
            lArc = node;
            break;
          }
          node = node.R;
        } else {
          if (dxl > -ε) {
            lArc = node.P;
            rArc = node;
          } else if (dxr > -ε) {
            lArc = node;
            rArc = node.N;
          } else {
            lArc = rArc = node;
          }
          break;
        }
      }
    }
    var newArc = d3_geom_voronoiCreateBeach(site);
    d3_geom_voronoiBeaches.insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
      d3_geom_voronoiDetachCircle(lArc);
      rArc = d3_geom_voronoiCreateBeach(lArc.site);
      d3_geom_voronoiBeaches.insert(newArc, rArc);
      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      d3_geom_voronoiAttachCircle(lArc);
      d3_geom_voronoiAttachCircle(rArc);
      return;
    }
    if (!rArc) {
      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      return;
    }
    d3_geom_voronoiDetachCircle(lArc);
    d3_geom_voronoiDetachCircle(rArc);
    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
      x: (cy * hb - by * hc) / d + ax,
      y: (bx * hc - cx * hb) / d + ay
    };
    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
  }
  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site.y === directrix ? site.x : Infinity;
  }
  function d3_geom_voronoiCell(site) {
    this.site = site;
    this.edges = [];
  }
  d3_geom_voronoiCell.prototype.prepare = function() {
    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
    while (iHalfEdge--) {
      edge = halfEdges[iHalfEdge].edge;
      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
    }
    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
    return halfEdges.length;
  };
  function d3_geom_voronoiCloseCells(extent) {
    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
    while (iCell--) {
      cell = cells[iCell];
      if (!cell || !cell.prepare()) continue;
      halfEdges = cell.edges;
      nHalfEdges = halfEdges.length;
      iHalfEdge = 0;
      while (iHalfEdge < nHalfEdges) {
        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
            x: x0,
            y: abs(x2 - x0) < ε ? y2 : y1
          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
            x: abs(y2 - y1) < ε ? x2 : x1,
            y: y1
          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
            x: x1,
            y: abs(x2 - x1) < ε ? y2 : y0
          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
            x: abs(y2 - y0) < ε ? x2 : x0,
            y: y0
          } : null), cell.site, null));
          ++nHalfEdges;
        }
      }
    }
  }
  function d3_geom_voronoiHalfEdgeOrder(a, b) {
    return b.angle - a.angle;
  }
  function d3_geom_voronoiCircle() {
    d3_geom_voronoiRedBlackNode(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
  }
  function d3_geom_voronoiAttachCircle(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -ε2) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = cy + Math.sqrt(x * x + y * y);
    circle.cy = cy;
    arc.circle = circle;
    var before = null, node = d3_geom_voronoiCircles._;
    while (node) {
      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
        if (node.L) node = node.L; else {
          before = node.P;
          break;
        }
      } else {
        if (node.R) node = node.R; else {
          before = node;
          break;
        }
      }
    }
    d3_geom_voronoiCircles.insert(before, circle);
    if (!before) d3_geom_voronoiFirstCircle = circle;
  }
  function d3_geom_voronoiDetachCircle(arc) {
    var circle = arc.circle;
    if (circle) {
      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
      d3_geom_voronoiCircles.remove(circle);
      d3_geom_voronoiCirclePool.push(circle);
      d3_geom_voronoiRedBlackNode(circle);
      arc.circle = null;
    }
  }
  function d3_geom_voronoiClipEdges(extent) {
    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
    while (i--) {
      e = edges[i];
      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
        e.a = e.b = null;
        edges.splice(i, 1);
      }
    }
  }
  function d3_geom_voronoiConnectEdge(edge, extent) {
    var vb = edge.b;
    if (vb) return true;
    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
      if (fx < x0 || fx >= x1) return;
      if (lx > rx) {
        if (!va) va = {
          x: fx,
          y: y0
        }; else if (va.y >= y1) return;
        vb = {
          x: fx,
          y: y1
        };
      } else {
        if (!va) va = {
          x: fx,
          y: y1
        }; else if (va.y < y0) return;
        vb = {
          x: fx,
          y: y0
        };
      }
    } else {
      fm = (lx - rx) / (ry - ly);
      fb = fy - fm * fx;
      if (fm < -1 || fm > 1) {
        if (lx > rx) {
          if (!va) va = {
            x: (y0 - fb) / fm,
            y: y0
          }; else if (va.y >= y1) return;
          vb = {
            x: (y1 - fb) / fm,
            y: y1
          };
        } else {
          if (!va) va = {
            x: (y1 - fb) / fm,
            y: y1
          }; else if (va.y < y0) return;
          vb = {
            x: (y0 - fb) / fm,
            y: y0
          };
        }
      } else {
        if (ly < ry) {
          if (!va) va = {
            x: x0,
            y: fm * x0 + fb
          }; else if (va.x >= x1) return;
          vb = {
            x: x1,
            y: fm * x1 + fb
          };
        } else {
          if (!va) va = {
            x: x1,
            y: fm * x1 + fb
          }; else if (va.x < x0) return;
          vb = {
            x: x0,
            y: fm * x0 + fb
          };
        }
      }
    }
    edge.a = va;
    edge.b = vb;
    return true;
  }
  function d3_geom_voronoiEdge(lSite, rSite) {
    this.l = lSite;
    this.r = rSite;
    this.a = this.b = null;
  }
  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, rSite);
    d3_geom_voronoiEdges.push(edge);
    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
    return edge;
  }
  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, null);
    edge.a = va;
    edge.b = vb;
    d3_geom_voronoiEdges.push(edge);
    return edge;
  }
  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
    if (!edge.a && !edge.b) {
      edge.a = vertex;
      edge.l = lSite;
      edge.r = rSite;
    } else if (edge.l === rSite) {
      edge.b = vertex;
    } else {
      edge.a = vertex;
    }
  }
  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
    var va = edge.a, vb = edge.b;
    this.edge = edge;
    this.site = lSite;
    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
  }
  d3_geom_voronoiHalfEdge.prototype = {
    start: function() {
      return this.edge.l === this.site ? this.edge.a : this.edge.b;
    },
    end: function() {
      return this.edge.l === this.site ? this.edge.b : this.edge.a;
    }
  };
  function d3_geom_voronoiRedBlackTree() {
    this._ = null;
  }
  function d3_geom_voronoiRedBlackNode(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null;
  }
  d3_geom_voronoiRedBlackTree.prototype = {
    insert: function(after, node) {
      var parent, grandpa, uncle;
      if (after) {
        node.P = after;
        node.N = after.N;
        if (after.N) after.N.P = node;
        after.N = node;
        if (after.R) {
          after = after.R;
          while (after.L) after = after.L;
          after.L = node;
        } else {
          after.R = node;
        }
        parent = after;
      } else if (this._) {
        after = d3_geom_voronoiRedBlackFirst(this._);
        node.P = null;
        node.N = after;
        after.P = after.L = node;
        parent = after;
      } else {
        node.P = node.N = null;
        this._ = node;
        parent = null;
      }
      node.L = node.R = null;
      node.U = parent;
      node.C = true;
      after = node;
      while (parent && parent.C) {
        grandpa = parent.U;
        if (parent === grandpa.L) {
          uncle = grandpa.R;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.R) {
              d3_geom_voronoiRedBlackRotateLeft(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
          }
        } else {
          uncle = grandpa.L;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.L) {
              d3_geom_voronoiRedBlackRotateRight(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
          }
        }
        parent = after.U;
      }
      this._.C = false;
    },
    remove: function(node) {
      if (node.N) node.N.P = node.P;
      if (node.P) node.P.N = node.N;
      node.N = node.P = null;
      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
      if (parent) {
        if (parent.L === node) parent.L = next; else parent.R = next;
      } else {
        this._ = next;
      }
      if (left && right) {
        red = next.C;
        next.C = node.C;
        next.L = left;
        left.U = next;
        if (next !== right) {
          parent = next.U;
          next.U = node.U;
          node = next.R;
          parent.L = node;
          next.R = right;
          right.U = next;
        } else {
          next.U = parent;
          parent = next;
          node = next.R;
        }
      } else {
        red = node.C;
        node = next;
      }
      if (node) node.U = parent;
      if (red) return;
      if (node && node.C) {
        node.C = false;
        return;
      }
      do {
        if (node === this._) break;
        if (node === parent.L) {
          sibling = parent.R;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            sibling = parent.R;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.R || !sibling.R.C) {
              sibling.L.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateRight(this, sibling);
              sibling = parent.R;
            }
            sibling.C = parent.C;
            parent.C = sibling.R.C = false;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            node = this._;
            break;
          }
        } else {
          sibling = parent.L;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            sibling = parent.L;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.L || !sibling.L.C) {
              sibling.R.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
              sibling = parent.L;
            }
            sibling.C = parent.C;
            parent.C = sibling.L.C = false;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            node = this._;
            break;
          }
        }
        sibling.C = true;
        node = parent;
        parent = parent.U;
      } while (!node.C);
      if (node) node.C = false;
    }
  };
  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
  }
  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
  }
  function d3_geom_voronoiRedBlackFirst(node) {
    while (node.L) node = node.L;
    return node;
  }
  function d3_geom_voronoi(sites, bbox) {
    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
    d3_geom_voronoiEdges = [];
    d3_geom_voronoiCells = new Array(sites.length);
    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
    while (true) {
      circle = d3_geom_voronoiFirstCircle;
      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
        if (site.x !== x0 || site.y !== y0) {
          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
          d3_geom_voronoiAddBeach(site);
          x0 = site.x, y0 = site.y;
        }
        site = sites.pop();
      } else if (circle) {
        d3_geom_voronoiRemoveBeach(circle.arc);
      } else {
        break;
      }
    }
    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
    var diagram = {
      cells: d3_geom_voronoiCells,
      edges: d3_geom_voronoiEdges
    };
    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
    return diagram;
  }
  function d3_geom_voronoiVertexOrder(a, b) {
    return b.y - a.y || b.x - a.x;
  }
  d3.geom.voronoi = function(points) {
    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
    if (points) return voronoi(points);
    function voronoi(data) {
      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
          var s = e.start();
          return [ s.x, s.y ];
        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
        polygon.point = data[i];
      });
      return polygons;
    }
    function sites(data) {
      return data.map(function(d, i) {
        return {
          x: Math.round(fx(d, i) / ε) * ε,
          y: Math.round(fy(d, i) / ε) * ε,
          i: i
        };
      });
    }
    voronoi.links = function(data) {
      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
        return edge.l && edge.r;
      }).map(function(edge) {
        return {
          source: data[edge.l.i],
          target: data[edge.r.i]
        };
      });
    };
    voronoi.triangles = function(data) {
      var triangles = [];
      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
        while (++j < m) {
          e0 = e1;
          s0 = s1;
          e1 = edges[j].edge;
          s1 = e1.l === site ? e1.r : e1.l;
          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
          }
        }
      });
      return triangles;
    };
    voronoi.x = function(_) {
      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
    };
    voronoi.y = function(_) {
      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
    };
    voronoi.clipExtent = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
      return voronoi;
    };
    voronoi.size = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
    };
    return voronoi;
  };
  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
  function d3_geom_voronoiTriangleArea(a, b, c) {
    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
  }
  d3.geom.delaunay = function(vertices) {
    return d3.geom.voronoi().triangles(vertices);
  };
  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
    if (compat = arguments.length) {
      x = d3_geom_quadtreeCompatX;
      y = d3_geom_quadtreeCompatY;
      if (compat === 3) {
        y2 = y1;
        x2 = x1;
        y1 = x1 = 0;
      }
      return quadtree(points);
    }
    function quadtree(data) {
      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
      if (x1 != null) {
        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
      } else {
        x2_ = y2_ = -(x1_ = y1_ = Infinity);
        xs = [], ys = [];
        n = data.length;
        if (compat) for (i = 0; i < n; ++i) {
          d = data[i];
          if (d.x < x1_) x1_ = d.x;
          if (d.y < y1_) y1_ = d.y;
          if (d.x > x2_) x2_ = d.x;
          if (d.y > y2_) y2_ = d.y;
          xs.push(d.x);
          ys.push(d.y);
        } else for (i = 0; i < n; ++i) {
          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
          if (x_ < x1_) x1_ = x_;
          if (y_ < y1_) y1_ = y_;
          if (x_ > x2_) x2_ = x_;
          if (y_ > y2_) y2_ = y_;
          xs.push(x_);
          ys.push(y_);
        }
      }
      var dx = x2_ - x1_, dy = y2_ - y1_;
      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
      function insert(n, d, x, y, x1, y1, x2, y2) {
        if (isNaN(x) || isNaN(y)) return;
        if (n.leaf) {
          var nx = n.x, ny = n.y;
          if (nx != null) {
            if (abs(nx - x) + abs(ny - y) < .01) {
              insertChild(n, d, x, y, x1, y1, x2, y2);
            } else {
              var nPoint = n.point;
              n.x = n.y = n.point = null;
              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
              insertChild(n, d, x, y, x1, y1, x2, y2);
            }
          } else {
            n.x = x, n.y = y, n.point = d;
          }
        } else {
          insertChild(n, d, x, y, x1, y1, x2, y2);
        }
      }
      function insertChild(n, d, x, y, x1, y1, x2, y2) {
        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
        n.leaf = false;
        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
        if (right) x1 = xm; else x2 = xm;
        if (below) y1 = ym; else y2 = ym;
        insert(n, d, x, y, x1, y1, x2, y2);
      }
      var root = d3_geom_quadtreeNode();
      root.add = function(d) {
        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
      };
      root.visit = function(f) {
        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
      };
      root.find = function(point) {
        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
      };
      i = -1;
      if (x1 == null) {
        while (++i < n) {
          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
        }
        --i;
      } else data.forEach(root.add);
      xs = ys = data = d = null;
      return root;
    }
    quadtree.x = function(_) {
      return arguments.length ? (x = _, quadtree) : x;
    };
    quadtree.y = function(_) {
      return arguments.length ? (y = _, quadtree) : y;
    };
    quadtree.extent = function(_) {
      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
      y2 = +_[1][1];
      return quadtree;
    };
    quadtree.size = function(_) {
      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
      return quadtree;
    };
    return quadtree;
  };
  function d3_geom_quadtreeCompatX(d) {
    return d.x;
  }
  function d3_geom_quadtreeCompatY(d) {
    return d.y;
  }
  function d3_geom_quadtreeNode() {
    return {
      leaf: true,
      nodes: [],
      point: null,
      x: null,
      y: null
    };
  }
  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
    if (!f(node, x1, y1, x2, y2)) {
      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
    }
  }
  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
    var minDistance2 = Infinity, closestPoint;
    (function find(node, x1, y1, x2, y2) {
      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
      if (point = node.point) {
        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
        if (distance2 < minDistance2) {
          var distance = Math.sqrt(minDistance2 = distance2);
          x0 = x - distance, y0 = y - distance;
          x3 = x + distance, y3 = y + distance;
          closestPoint = point;
        }
      }
      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
        if (node = children[i & 3]) switch (i & 3) {
         case 0:
          find(node, x1, y1, xm, ym);
          break;

         case 1:
          find(node, xm, y1, x2, ym);
          break;

         case 2:
          find(node, x1, ym, xm, y2);
          break;

         case 3:
          find(node, xm, ym, x2, y2);
          break;
        }
      }
    })(root, x0, y0, x3, y3);
    return closestPoint;
  }
  d3.interpolateRgb = d3_interpolateRgb;
  function d3_interpolateRgb(a, b) {
    a = d3.rgb(a);
    b = d3.rgb(b);
    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
    return function(t) {
      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
    };
  }
  d3.interpolateObject = d3_interpolateObject;
  function d3_interpolateObject(a, b) {
    var i = {}, c = {}, k;
    for (k in a) {
      if (k in b) {
        i[k] = d3_interpolate(a[k], b[k]);
      } else {
        c[k] = a[k];
      }
    }
    for (k in b) {
      if (!(k in a)) {
        c[k] = b[k];
      }
    }
    return function(t) {
      for (k in i) c[k] = i[k](t);
      return c;
    };
  }
  d3.interpolateNumber = d3_interpolateNumber;
  function d3_interpolateNumber(a, b) {
    a = +a, b = +b;
    return function(t) {
      return a * (1 - t) + b * t;
    };
  }
  d3.interpolateString = d3_interpolateString;
  function d3_interpolateString(a, b) {
    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
    a = a + "", b = b + "";
    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
      if ((bs = bm.index) > bi) {
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) {
        if (s[i]) s[i] += bm; else s[++i] = bm;
      } else {
        s[++i] = null;
        q.push({
          i: i,
          x: d3_interpolateNumber(am, bm)
        });
      }
      bi = d3_interpolate_numberB.lastIndex;
    }
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; else s[++i] = bs;
    }
    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
      return b(t) + "";
    }) : function() {
      return b;
    } : (b = q.length, function(t) {
      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    });
  }
  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
  d3.interpolate = d3_interpolate;
  function d3_interpolate(a, b) {
    var i = d3.interpolators.length, f;
    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
    return f;
  }
  d3.interpolators = [ function(a, b) {
    var t = typeof b;
    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
  } ];
  d3.interpolateArray = d3_interpolateArray;
  function d3_interpolateArray(a, b) {
    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
    for (;i < na; ++i) c[i] = a[i];
    for (;i < nb; ++i) c[i] = b[i];
    return function(t) {
      for (i = 0; i < n0; ++i) c[i] = x[i](t);
      return c;
    };
  }
  var d3_ease_default = function() {
    return d3_identity;
  };
  var d3_ease = d3.map({
    linear: d3_ease_default,
    poly: d3_ease_poly,
    quad: function() {
      return d3_ease_quad;
    },
    cubic: function() {
      return d3_ease_cubic;
    },
    sin: function() {
      return d3_ease_sin;
    },
    exp: function() {
      return d3_ease_exp;
    },
    circle: function() {
      return d3_ease_circle;
    },
    elastic: d3_ease_elastic,
    back: d3_ease_back,
    bounce: function() {
      return d3_ease_bounce;
    }
  });
  var d3_ease_mode = d3.map({
    "in": d3_identity,
    out: d3_ease_reverse,
    "in-out": d3_ease_reflect,
    "out-in": function(f) {
      return d3_ease_reflect(d3_ease_reverse(f));
    }
  });
  d3.ease = function(name) {
    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
    t = d3_ease.get(t) || d3_ease_default;
    m = d3_ease_mode.get(m) || d3_identity;
    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
  };
  function d3_ease_clamp(f) {
    return function(t) {
      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
    };
  }
  function d3_ease_reverse(f) {
    return function(t) {
      return 1 - f(1 - t);
    };
  }
  function d3_ease_reflect(f) {
    return function(t) {
      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
    };
  }
  function d3_ease_quad(t) {
    return t * t;
  }
  function d3_ease_cubic(t) {
    return t * t * t;
  }
  function d3_ease_cubicInOut(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    var t2 = t * t, t3 = t2 * t;
    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
  }
  function d3_ease_poly(e) {
    return function(t) {
      return Math.pow(t, e);
    };
  }
  function d3_ease_sin(t) {
    return 1 - Math.cos(t * halfπ);
  }
  function d3_ease_exp(t) {
    return Math.pow(2, 10 * (t - 1));
  }
  function d3_ease_circle(t) {
    return 1 - Math.sqrt(1 - t * t);
  }
  function d3_ease_elastic(a, p) {
    var s;
    if (arguments.length < 2) p = .45;
    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
    return function(t) {
      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
    };
  }
  function d3_ease_back(s) {
    if (!s) s = 1.70158;
    return function(t) {
      return t * t * ((s + 1) * t - s);
    };
  }
  function d3_ease_bounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
  }
  d3.interpolateHcl = d3_interpolateHcl;
  function d3_interpolateHcl(a, b) {
    a = d3.hcl(a);
    b = d3.hcl(b);
    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
    };
  }
  d3.interpolateHsl = d3_interpolateHsl;
  function d3_interpolateHsl(a, b) {
    a = d3.hsl(a);
    b = d3.hsl(b);
    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
    };
  }
  d3.interpolateLab = d3_interpolateLab;
  function d3_interpolateLab(a, b) {
    a = d3.lab(a);
    b = d3.lab(b);
    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
    return function(t) {
      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
    };
  }
  d3.interpolateRound = d3_interpolateRound;
  function d3_interpolateRound(a, b) {
    b -= a;
    return function(t) {
      return Math.round(a + b * t);
    };
  }
  d3.transform = function(string) {
    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
    return (d3.transform = function(string) {
      if (string != null) {
        g.setAttribute("transform", string);
        var t = g.transform.baseVal.consolidate();
      }
      return new d3_transform(t ? t.matrix : d3_transformIdentity);
    })(string);
  };
  function d3_transform(m) {
    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
    if (r0[0] * r1[1] < r1[0] * r0[1]) {
      r0[0] *= -1;
      r0[1] *= -1;
      kx *= -1;
      kz *= -1;
    }
    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
    this.translate = [ m.e, m.f ];
    this.scale = [ kx, ky ];
    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
  }
  d3_transform.prototype.toString = function() {
    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
  };
  function d3_transformDot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
  }
  function d3_transformNormalize(a) {
    var k = Math.sqrt(d3_transformDot(a, a));
    if (k) {
      a[0] /= k;
      a[1] /= k;
    }
    return k;
  }
  function d3_transformCombine(a, b, k) {
    a[0] += k * b[0];
    a[1] += k * b[1];
    return a;
  }
  var d3_transformIdentity = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
  };
  d3.interpolateTransform = d3_interpolateTransform;
  function d3_interpolateTransformPop(s) {
    return s.length ? s.pop() + "," : "";
  }
  function d3_interpolateTranslate(ta, tb, s, q) {
    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
      var i = s.push("translate(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ta[0], tb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ta[1], tb[1])
      });
    } else if (tb[0] || tb[1]) {
      s.push("translate(" + tb + ")");
    }
  }
  function d3_interpolateRotate(ra, rb, s, q) {
    if (ra !== rb) {
      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
        x: d3_interpolateNumber(ra, rb)
      });
    } else if (rb) {
      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
    }
  }
  function d3_interpolateSkew(wa, wb, s, q) {
    if (wa !== wb) {
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
        x: d3_interpolateNumber(wa, wb)
      });
    } else if (wb) {
      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
    }
  }
  function d3_interpolateScale(ka, kb, s, q) {
    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ka[0], kb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ka[1], kb[1])
      });
    } else if (kb[0] !== 1 || kb[1] !== 1) {
      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
    }
  }
  function d3_interpolateTransform(a, b) {
    var s = [], q = [];
    a = d3.transform(a), b = d3.transform(b);
    d3_interpolateTranslate(a.translate, b.translate, s, q);
    d3_interpolateRotate(a.rotate, b.rotate, s, q);
    d3_interpolateSkew(a.skew, b.skew, s, q);
    d3_interpolateScale(a.scale, b.scale, s, q);
    a = b = null;
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  }
  function d3_uninterpolateNumber(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return (x - a) / b;
    };
  }
  function d3_uninterpolateClamp(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return Math.max(0, Math.min(1, (x - a) / b));
    };
  }
  d3.layout = {};
  d3.layout.bundle = function() {
    return function(links) {
      var paths = [], i = -1, n = links.length;
      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
      return paths;
    };
  };
  function d3_layout_bundlePath(link) {
    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
    while (start !== lca) {
      start = start.parent;
      points.push(start);
    }
    var k = points.length;
    while (end !== lca) {
      points.splice(k, 0, end);
      end = end.parent;
    }
    return points;
  }
  function d3_layout_bundleAncestors(node) {
    var ancestors = [], parent = node.parent;
    while (parent != null) {
      ancestors.push(node);
      node = parent;
      parent = parent.parent;
    }
    ancestors.push(node);
    return ancestors;
  }
  function d3_layout_bundleLeastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
    while (aNode === bNode) {
      sharedNode = aNode;
      aNode = aNodes.pop();
      bNode = bNodes.pop();
    }
    return sharedNode;
  }
  d3.layout.chord = function() {
    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
    function relayout() {
      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
      chords = [];
      groups = [];
      k = 0, i = -1;
      while (++i < n) {
        x = 0, j = -1;
        while (++j < n) {
          x += matrix[i][j];
        }
        groupSums.push(x);
        subgroupIndex.push(d3.range(n));
        k += x;
      }
      if (sortGroups) {
        groupIndex.sort(function(a, b) {
          return sortGroups(groupSums[a], groupSums[b]);
        });
      }
      if (sortSubgroups) {
        subgroupIndex.forEach(function(d, i) {
          d.sort(function(a, b) {
            return sortSubgroups(matrix[i][a], matrix[i][b]);
          });
        });
      }
      k = (τ - padding * n) / k;
      x = 0, i = -1;
      while (++i < n) {
        x0 = x, j = -1;
        while (++j < n) {
          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
          subgroups[di + "-" + dj] = {
            index: di,
            subindex: dj,
            startAngle: a0,
            endAngle: a1,
            value: v
          };
        }
        groups[di] = {
          index: di,
          startAngle: x0,
          endAngle: x,
          value: groupSums[di]
        };
        x += padding;
      }
      i = -1;
      while (++i < n) {
        j = i - 1;
        while (++j < n) {
          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
          if (source.value || target.value) {
            chords.push(source.value < target.value ? {
              source: target,
              target: source
            } : {
              source: source,
              target: target
            });
          }
        }
      }
      if (sortChords) resort();
    }
    function resort() {
      chords.sort(function(a, b) {
        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
      });
    }
    chord.matrix = function(x) {
      if (!arguments.length) return matrix;
      n = (matrix = x) && matrix.length;
      chords = groups = null;
      return chord;
    };
    chord.padding = function(x) {
      if (!arguments.length) return padding;
      padding = x;
      chords = groups = null;
      return chord;
    };
    chord.sortGroups = function(x) {
      if (!arguments.length) return sortGroups;
      sortGroups = x;
      chords = groups = null;
      return chord;
    };
    chord.sortSubgroups = function(x) {
      if (!arguments.length) return sortSubgroups;
      sortSubgroups = x;
      chords = null;
      return chord;
    };
    chord.sortChords = function(x) {
      if (!arguments.length) return sortChords;
      sortChords = x;
      if (chords) resort();
      return chord;
    };
    chord.chords = function() {
      if (!chords) relayout();
      return chords;
    };
    chord.groups = function() {
      if (!groups) relayout();
      return groups;
    };
    return chord;
  };
  d3.layout.force = function() {
    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
    function repulse(node) {
      return function(quad, x1, _, x2) {
        if (quad.point !== node) {
          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
          if (dw * dw / theta2 < dn) {
            if (dn < chargeDistance2) {
              var k = quad.charge / dn;
              node.px -= dx * k;
              node.py -= dy * k;
            }
            return true;
          }
          if (quad.point && dn && dn < chargeDistance2) {
            var k = quad.pointCharge / dn;
            node.px -= dx * k;
            node.py -= dy * k;
          }
        }
        return !quad.charge;
      };
    }
    force.tick = function() {
      if ((alpha *= .99) < .005) {
        timer = null;
        event.end({
          type: "end",
          alpha: alpha = 0
        });
        return true;
      }
      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
      for (i = 0; i < m; ++i) {
        o = links[i];
        s = o.source;
        t = o.target;
        x = t.x - s.x;
        y = t.y - s.y;
        if (l = x * x + y * y) {
          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
          x *= l;
          y *= l;
          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
          t.y -= y * k;
          s.x += x * (k = 1 - k);
          s.y += y * k;
        }
      }
      if (k = alpha * gravity) {
        x = size[0] / 2;
        y = size[1] / 2;
        i = -1;
        if (k) while (++i < n) {
          o = nodes[i];
          o.x += (x - o.x) * k;
          o.y += (y - o.y) * k;
        }
      }
      if (charge) {
        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
        i = -1;
        while (++i < n) {
          if (!(o = nodes[i]).fixed) {
            q.visit(repulse(o));
          }
        }
      }
      i = -1;
      while (++i < n) {
        o = nodes[i];
        if (o.fixed) {
          o.x = o.px;
          o.y = o.py;
        } else {
          o.x -= (o.px - (o.px = o.x)) * friction;
          o.y -= (o.py - (o.py = o.y)) * friction;
        }
      }
      event.tick({
        type: "tick",
        alpha: alpha
      });
    };
    force.nodes = function(x) {
      if (!arguments.length) return nodes;
      nodes = x;
      return force;
    };
    force.links = function(x) {
      if (!arguments.length) return links;
      links = x;
      return force;
    };
    force.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return force;
    };
    force.linkDistance = function(x) {
      if (!arguments.length) return linkDistance;
      linkDistance = typeof x === "function" ? x : +x;
      return force;
    };
    force.distance = force.linkDistance;
    force.linkStrength = function(x) {
      if (!arguments.length) return linkStrength;
      linkStrength = typeof x === "function" ? x : +x;
      return force;
    };
    force.friction = function(x) {
      if (!arguments.length) return friction;
      friction = +x;
      return force;
    };
    force.charge = function(x) {
      if (!arguments.length) return charge;
      charge = typeof x === "function" ? x : +x;
      return force;
    };
    force.chargeDistance = function(x) {
      if (!arguments.length) return Math.sqrt(chargeDistance2);
      chargeDistance2 = x * x;
      return force;
    };
    force.gravity = function(x) {
      if (!arguments.length) return gravity;
      gravity = +x;
      return force;
    };
    force.theta = function(x) {
      if (!arguments.length) return Math.sqrt(theta2);
      theta2 = x * x;
      return force;
    };
    force.alpha = function(x) {
      if (!arguments.length) return alpha;
      x = +x;
      if (alpha) {
        if (x > 0) {
          alpha = x;
        } else {
          timer.c = null, timer.t = NaN, timer = null;
          event.end({
            type: "end",
            alpha: alpha = 0
          });
        }
      } else if (x > 0) {
        event.start({
          type: "start",
          alpha: alpha = x
        });
        timer = d3_timer(force.tick);
      }
      return force;
    };
    force.start = function() {
      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
      for (i = 0; i < n; ++i) {
        (o = nodes[i]).index = i;
        o.weight = 0;
      }
      for (i = 0; i < m; ++i) {
        o = links[i];
        if (typeof o.source == "number") o.source = nodes[o.source];
        if (typeof o.target == "number") o.target = nodes[o.target];
        ++o.source.weight;
        ++o.target.weight;
      }
      for (i = 0; i < n; ++i) {
        o = nodes[i];
        if (isNaN(o.x)) o.x = position("x", w);
        if (isNaN(o.y)) o.y = position("y", h);
        if (isNaN(o.px)) o.px = o.x;
        if (isNaN(o.py)) o.py = o.y;
      }
      distances = [];
      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
      strengths = [];
      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
      charges = [];
      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
      function position(dimension, size) {
        if (!neighbors) {
          neighbors = new Array(n);
          for (j = 0; j < n; ++j) {
            neighbors[j] = [];
          }
          for (j = 0; j < m; ++j) {
            var o = links[j];
            neighbors[o.source.index].push(o.target);
            neighbors[o.target.index].push(o.source);
          }
        }
        var candidates = neighbors[i], j = -1, l = candidates.length, x;
        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
        return Math.random() * size;
      }
      return force.resume();
    };
    force.resume = function() {
      return force.alpha(.1);
    };
    force.stop = function() {
      return force.alpha(0);
    };
    force.drag = function() {
      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
      if (!arguments.length) return drag;
      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
    };
    function dragmove(d) {
      d.px = d3.event.x, d.py = d3.event.y;
      force.resume();
    }
    return d3.rebind(force, event, "on");
  };
  function d3_layout_forceDragstart(d) {
    d.fixed |= 2;
  }
  function d3_layout_forceDragend(d) {
    d.fixed &= ~6;
  }
  function d3_layout_forceMouseover(d) {
    d.fixed |= 4;
    d.px = d.x, d.py = d.y;
  }
  function d3_layout_forceMouseout(d) {
    d.fixed &= ~4;
  }
  function d3_layout_forceAccumulate(quad, alpha, charges) {
    var cx = 0, cy = 0;
    quad.charge = 0;
    if (!quad.leaf) {
      var nodes = quad.nodes, n = nodes.length, i = -1, c;
      while (++i < n) {
        c = nodes[i];
        if (c == null) continue;
        d3_layout_forceAccumulate(c, alpha, charges);
        quad.charge += c.charge;
        cx += c.charge * c.cx;
        cy += c.charge * c.cy;
      }
    }
    if (quad.point) {
      if (!quad.leaf) {
        quad.point.x += Math.random() - .5;
        quad.point.y += Math.random() - .5;
      }
      var k = alpha * charges[quad.point.index];
      quad.charge += quad.pointCharge = k;
      cx += k * quad.point.x;
      cy += k * quad.point.y;
    }
    quad.cx = cx / quad.charge;
    quad.cy = cy / quad.charge;
  }
  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
  d3.layout.hierarchy = function() {
    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
    function hierarchy(root) {
      var stack = [ root ], nodes = [], node;
      root.depth = 0;
      while ((node = stack.pop()) != null) {
        nodes.push(node);
        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
          var n, childs, child;
          while (--n >= 0) {
            stack.push(child = childs[n]);
            child.parent = node;
            child.depth = node.depth + 1;
          }
          if (value) node.value = 0;
          node.children = childs;
        } else {
          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
          delete node.children;
        }
      }
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var childs, parent;
        if (sort && (childs = node.children)) childs.sort(sort);
        if (value && (parent = node.parent)) parent.value += node.value;
      });
      return nodes;
    }
    hierarchy.sort = function(x) {
      if (!arguments.length) return sort;
      sort = x;
      return hierarchy;
    };
    hierarchy.children = function(x) {
      if (!arguments.length) return children;
      children = x;
      return hierarchy;
    };
    hierarchy.value = function(x) {
      if (!arguments.length) return value;
      value = x;
      return hierarchy;
    };
    hierarchy.revalue = function(root) {
      if (value) {
        d3_layout_hierarchyVisitBefore(root, function(node) {
          if (node.children) node.value = 0;
        });
        d3_layout_hierarchyVisitAfter(root, function(node) {
          var parent;
          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
          if (parent = node.parent) parent.value += node.value;
        });
      }
      return root;
    };
    return hierarchy;
  };
  function d3_layout_hierarchyRebind(object, hierarchy) {
    d3.rebind(object, hierarchy, "sort", "children", "value");
    object.nodes = object;
    object.links = d3_layout_hierarchyLinks;
    return object;
  }
  function d3_layout_hierarchyVisitBefore(node, callback) {
    var nodes = [ node ];
    while ((node = nodes.pop()) != null) {
      callback(node);
      if ((children = node.children) && (n = children.length)) {
        var n, children;
        while (--n >= 0) nodes.push(children[n]);
      }
    }
  }
  function d3_layout_hierarchyVisitAfter(node, callback) {
    var nodes = [ node ], nodes2 = [];
    while ((node = nodes.pop()) != null) {
      nodes2.push(node);
      if ((children = node.children) && (n = children.length)) {
        var i = -1, n, children;
        while (++i < n) nodes.push(children[i]);
      }
    }
    while ((node = nodes2.pop()) != null) {
      callback(node);
    }
  }
  function d3_layout_hierarchyChildren(d) {
    return d.children;
  }
  function d3_layout_hierarchyValue(d) {
    return d.value;
  }
  function d3_layout_hierarchySort(a, b) {
    return b.value - a.value;
  }
  function d3_layout_hierarchyLinks(nodes) {
    return d3.merge(nodes.map(function(parent) {
      return (parent.children || []).map(function(child) {
        return {
          source: parent,
          target: child
        };
      });
    }));
  }
  d3.layout.partition = function() {
    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
    function position(node, x, dx, dy) {
      var children = node.children;
      node.x = x;
      node.y = node.depth * dy;
      node.dx = dx;
      node.dy = dy;
      if (children && (n = children.length)) {
        var i = -1, n, c, d;
        dx = node.value ? dx / node.value : 0;
        while (++i < n) {
          position(c = children[i], x, d = c.value * dx, dy);
          x += d;
        }
      }
    }
    function depth(node) {
      var children = node.children, d = 0;
      if (children && (n = children.length)) {
        var i = -1, n;
        while (++i < n) d = Math.max(d, depth(children[i]));
      }
      return 1 + d;
    }
    function partition(d, i) {
      var nodes = hierarchy.call(this, d, i);
      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
      return nodes;
    }
    partition.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return partition;
    };
    return d3_layout_hierarchyRebind(partition, hierarchy);
  };
  d3.layout.pie = function() {
    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
    function pie(data) {
      var n = data.length, values = data.map(function(d, i) {
        return +value.call(pie, d, i);
      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
        return values[j] - values[i];
      } : function(i, j) {
        return sort(data[i], data[j]);
      });
      index.forEach(function(i) {
        arcs[i] = {
          data: data[i],
          value: v = values[i],
          startAngle: a,
          endAngle: a += v * k + pa,
          padAngle: p
        };
      });
      return arcs;
    }
    pie.value = function(_) {
      if (!arguments.length) return value;
      value = _;
      return pie;
    };
    pie.sort = function(_) {
      if (!arguments.length) return sort;
      sort = _;
      return pie;
    };
    pie.startAngle = function(_) {
      if (!arguments.length) return startAngle;
      startAngle = _;
      return pie;
    };
    pie.endAngle = function(_) {
      if (!arguments.length) return endAngle;
      endAngle = _;
      return pie;
    };
    pie.padAngle = function(_) {
      if (!arguments.length) return padAngle;
      padAngle = _;
      return pie;
    };
    return pie;
  };
  var d3_layout_pieSortByValue = {};
  d3.layout.stack = function() {
    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
    function stack(data, index) {
      if (!(n = data.length)) return data;
      var series = data.map(function(d, i) {
        return values.call(stack, d, i);
      });
      var points = series.map(function(d) {
        return d.map(function(v, i) {
          return [ x.call(stack, v, i), y.call(stack, v, i) ];
        });
      });
      var orders = order.call(stack, points, index);
      series = d3.permute(series, orders);
      points = d3.permute(points, orders);
      var offsets = offset.call(stack, points, index);
      var m = series[0].length, n, i, j, o;
      for (j = 0; j < m; ++j) {
        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
        for (i = 1; i < n; ++i) {
          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
        }
      }
      return data;
    }
    stack.values = function(x) {
      if (!arguments.length) return values;
      values = x;
      return stack;
    };
    stack.order = function(x) {
      if (!arguments.length) return order;
      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
      return stack;
    };
    stack.offset = function(x) {
      if (!arguments.length) return offset;
      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
      return stack;
    };
    stack.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      return stack;
    };
    stack.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      return stack;
    };
    stack.out = function(z) {
      if (!arguments.length) return out;
      out = z;
      return stack;
    };
    return stack;
  };
  function d3_layout_stackX(d) {
    return d.x;
  }
  function d3_layout_stackY(d) {
    return d.y;
  }
  function d3_layout_stackOut(d, y0, y) {
    d.y0 = y0;
    d.y = y;
  }
  var d3_layout_stackOrders = d3.map({
    "inside-out": function(data) {
      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
        return max[a] - max[b];
      }), top = 0, bottom = 0, tops = [], bottoms = [];
      for (i = 0; i < n; ++i) {
        j = index[i];
        if (top < bottom) {
          top += sums[j];
          tops.push(j);
        } else {
          bottom += sums[j];
          bottoms.push(j);
        }
      }
      return bottoms.reverse().concat(tops);
    },
    reverse: function(data) {
      return d3.range(data.length).reverse();
    },
    "default": d3_layout_stackOrderDefault
  });
  var d3_layout_stackOffsets = d3.map({
    silhouette: function(data) {
      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o > max) max = o;
        sums.push(o);
      }
      for (j = 0; j < m; ++j) {
        y0[j] = (max - sums[j]) / 2;
      }
      return y0;
    },
    wiggle: function(data) {
      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
      y0[0] = o = o0 = 0;
      for (j = 1; j < m; ++j) {
        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
          }
          s2 += s3 * data[i][j][1];
        }
        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
        if (o < o0) o0 = o;
      }
      for (j = 0; j < m; ++j) y0[j] -= o0;
      return y0;
    },
    expand: function(data) {
      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
      }
      for (j = 0; j < m; ++j) y0[j] = 0;
      return y0;
    },
    zero: d3_layout_stackOffsetZero
  });
  function d3_layout_stackOrderDefault(data) {
    return d3.range(data.length);
  }
  function d3_layout_stackOffsetZero(data) {
    var j = -1, m = data[0].length, y0 = [];
    while (++j < m) y0[j] = 0;
    return y0;
  }
  function d3_layout_stackMaxIndex(array) {
    var i = 1, j = 0, v = array[0][1], k, n = array.length;
    for (;i < n; ++i) {
      if ((k = array[i][1]) > v) {
        j = i;
        v = k;
      }
    }
    return j;
  }
  function d3_layout_stackReduceSum(d) {
    return d.reduce(d3_layout_stackSum, 0);
  }
  function d3_layout_stackSum(p, d) {
    return p + d[1];
  }
  d3.layout.histogram = function() {
    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
    function histogram(data, i) {
      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
      while (++i < m) {
        bin = bins[i] = [];
        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
        bin.y = 0;
      }
      if (m > 0) {
        i = -1;
        while (++i < n) {
          x = values[i];
          if (x >= range[0] && x <= range[1]) {
            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
            bin.y += k;
            bin.push(data[i]);
          }
        }
      }
      return bins;
    }
    histogram.value = function(x) {
      if (!arguments.length) return valuer;
      valuer = x;
      return histogram;
    };
    histogram.range = function(x) {
      if (!arguments.length) return ranger;
      ranger = d3_functor(x);
      return histogram;
    };
    histogram.bins = function(x) {
      if (!arguments.length) return binner;
      binner = typeof x === "number" ? function(range) {
        return d3_layout_histogramBinFixed(range, x);
      } : d3_functor(x);
      return histogram;
    };
    histogram.frequency = function(x) {
      if (!arguments.length) return frequency;
      frequency = !!x;
      return histogram;
    };
    return histogram;
  };
  function d3_layout_histogramBinSturges(range, values) {
    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
  }
  function d3_layout_histogramBinFixed(range, n) {
    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
    while (++x <= n) f[x] = m * x + b;
    return f;
  }
  function d3_layout_histogramRange(values) {
    return [ d3.min(values), d3.max(values) ];
  }
  d3.layout.pack = function() {
    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
    function pack(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
        return radius;
      };
      root.x = root.y = 0;
      d3_layout_hierarchyVisitAfter(root, function(d) {
        d.r = +r(d.value);
      });
      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
      if (padding) {
        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r += dr;
        });
        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r -= dr;
        });
      }
      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
      return nodes;
    }
    pack.size = function(_) {
      if (!arguments.length) return size;
      size = _;
      return pack;
    };
    pack.radius = function(_) {
      if (!arguments.length) return radius;
      radius = _ == null || typeof _ === "function" ? _ : +_;
      return pack;
    };
    pack.padding = function(_) {
      if (!arguments.length) return padding;
      padding = +_;
      return pack;
    };
    return d3_layout_hierarchyRebind(pack, hierarchy);
  };
  function d3_layout_packSort(a, b) {
    return a.value - b.value;
  }
  function d3_layout_packInsert(a, b) {
    var c = a._pack_next;
    a._pack_next = b;
    b._pack_prev = a;
    b._pack_next = c;
    c._pack_prev = b;
  }
  function d3_layout_packSplice(a, b) {
    a._pack_next = b;
    b._pack_prev = a;
  }
  function d3_layout_packIntersects(a, b) {
    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
    return .999 * dr * dr > dx * dx + dy * dy;
  }
  function d3_layout_packSiblings(node) {
    if (!(nodes = node.children) || !(n = nodes.length)) return;
    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
    function bound(node) {
      xMin = Math.min(node.x - node.r, xMin);
      xMax = Math.max(node.x + node.r, xMax);
      yMin = Math.min(node.y - node.r, yMin);
      yMax = Math.max(node.y + node.r, yMax);
    }
    nodes.forEach(d3_layout_packLink);
    a = nodes[0];
    a.x = -a.r;
    a.y = 0;
    bound(a);
    if (n > 1) {
      b = nodes[1];
      b.x = b.r;
      b.y = 0;
      bound(b);
      if (n > 2) {
        c = nodes[2];
        d3_layout_packPlace(a, b, c);
        bound(c);
        d3_layout_packInsert(a, c);
        a._pack_prev = c;
        d3_layout_packInsert(c, b);
        b = a._pack_next;
        for (i = 3; i < n; i++) {
          d3_layout_packPlace(a, b, c = nodes[i]);
          var isect = 0, s1 = 1, s2 = 1;
          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
            if (d3_layout_packIntersects(j, c)) {
              isect = 1;
              break;
            }
          }
          if (isect == 1) {
            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
              if (d3_layout_packIntersects(k, c)) {
                break;
              }
            }
          }
          if (isect) {
            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
            i--;
          } else {
            d3_layout_packInsert(a, c);
            b = c;
            bound(c);
          }
        }
      }
    }
    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
    for (i = 0; i < n; i++) {
      c = nodes[i];
      c.x -= cx;
      c.y -= cy;
      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
    }
    node.r = cr;
    nodes.forEach(d3_layout_packUnlink);
  }
  function d3_layout_packLink(node) {
    node._pack_next = node._pack_prev = node;
  }
  function d3_layout_packUnlink(node) {
    delete node._pack_next;
    delete node._pack_prev;
  }
  function d3_layout_packTransform(node, x, y, k) {
    var children = node.children;
    node.x = x += k * node.x;
    node.y = y += k * node.y;
    node.r *= k;
    if (children) {
      var i = -1, n = children.length;
      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
    }
  }
  function d3_layout_packPlace(a, b, c) {
    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
    if (db && (dx || dy)) {
      var da = b.r + c.r, dc = dx * dx + dy * dy;
      da *= da;
      db *= db;
      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
      c.x = a.x + x * dx + y * dy;
      c.y = a.y + x * dy - y * dx;
    } else {
      c.x = a.x + db;
      c.y = a.y;
    }
  }
  d3.layout.tree = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
    function tree(d, i) {
      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
      d3_layout_hierarchyVisitBefore(root1, secondWalk);
      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
        var left = root0, right = root0, bottom = root0;
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          if (node.x < left.x) left = node;
          if (node.x > right.x) right = node;
          if (node.depth > bottom.depth) bottom = node;
        });
        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          node.x = (node.x + tx) * kx;
          node.y = node.depth * ky;
        });
      }
      return nodes;
    }
    function wrapTree(root0) {
      var root1 = {
        A: null,
        children: [ root0 ]
      }, queue = [ root1 ], node1;
      while ((node1 = queue.pop()) != null) {
        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
          queue.push((children[i] = child = {
            _: children[i],
            parent: node1,
            children: (child = children[i].children) && child.slice() || [],
            A: null,
            a: null,
            z: 0,
            m: 0,
            c: 0,
            s: 0,
            t: null,
            i: i
          }).a = child);
        }
      }
      return root1.children[0];
    }
    function firstWalk(v) {
      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
      if (children.length) {
        d3_layout_treeShift(v);
        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
        if (w) {
          v.z = w.z + separation(v._, w._);
          v.m = v.z - midpoint;
        } else {
          v.z = midpoint;
        }
      } else if (w) {
        v.z = w.z + separation(v._, w._);
      }
      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    function secondWalk(v) {
      v._.x = v.z + v.parent.m;
      v.m += v.parent.m;
    }
    function apportion(v, w, ancestor) {
      if (w) {
        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
          vom = d3_layout_treeLeft(vom);
          vop = d3_layout_treeRight(vop);
          vop.a = v;
          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
          if (shift > 0) {
            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
            sip += shift;
            sop += shift;
          }
          sim += vim.m;
          sip += vip.m;
          som += vom.m;
          sop += vop.m;
        }
        if (vim && !d3_layout_treeRight(vop)) {
          vop.t = vim;
          vop.m += sim - sop;
        }
        if (vip && !d3_layout_treeLeft(vom)) {
          vom.t = vip;
          vom.m += sip - som;
          ancestor = v;
        }
      }
      return ancestor;
    }
    function sizeNode(node) {
      node.x *= size[0];
      node.y = node.depth * size[1];
    }
    tree.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return tree;
    };
    tree.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null ? sizeNode : null;
      return tree;
    };
    tree.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) == null ? null : sizeNode;
      return tree;
    };
    return d3_layout_hierarchyRebind(tree, hierarchy);
  };
  function d3_layout_treeSeparation(a, b) {
    return a.parent == b.parent ? 1 : 2;
  }
  function d3_layout_treeLeft(v) {
    var children = v.children;
    return children.length ? children[0] : v.t;
  }
  function d3_layout_treeRight(v) {
    var children = v.children, n;
    return (n = children.length) ? children[n - 1] : v.t;
  }
  function d3_layout_treeMove(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
  }
  function d3_layout_treeShift(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while (--i >= 0) {
      w = children[i];
      w.z += shift;
      w.m += shift;
      shift += w.s + (change += w.c);
    }
  }
  function d3_layout_treeAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
  }
  d3.layout.cluster = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
    function cluster(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var children = node.children;
        if (children && children.length) {
          node.x = d3_layout_clusterX(children);
          node.y = d3_layout_clusterY(children);
        } else {
          node.x = previousNode ? x += separation(node, previousNode) : 0;
          node.y = 0;
          previousNode = node;
        }
      });
      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
        node.x = (node.x - root.x) * size[0];
        node.y = (root.y - node.y) * size[1];
      } : function(node) {
        node.x = (node.x - x0) / (x1 - x0) * size[0];
        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
      });
      return nodes;
    }
    cluster.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return cluster;
    };
    cluster.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null;
      return cluster;
    };
    cluster.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) != null;
      return cluster;
    };
    return d3_layout_hierarchyRebind(cluster, hierarchy);
  };
  function d3_layout_clusterY(children) {
    return 1 + d3.max(children, function(child) {
      return child.y;
    });
  }
  function d3_layout_clusterX(children) {
    return children.reduce(function(x, child) {
      return x + child.x;
    }, 0) / children.length;
  }
  function d3_layout_clusterLeft(node) {
    var children = node.children;
    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
  }
  function d3_layout_clusterRight(node) {
    var children = node.children, n;
    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
  }
  d3.layout.treemap = function() {
    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
    function scale(children, k) {
      var i = -1, n = children.length, child, area;
      while (++i < n) {
        area = (child = children[i]).value * (k < 0 ? 0 : k);
        child.area = isNaN(area) || area <= 0 ? 0 : area;
      }
    }
    function squarify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while ((n = remaining.length) > 0) {
          row.push(child = remaining[n - 1]);
          row.area += child.area;
          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
            remaining.pop();
            best = score;
          } else {
            row.area -= row.pop().area;
            position(row, u, rect, false);
            u = Math.min(rect.dx, rect.dy);
            row.length = row.area = 0;
            best = Infinity;
          }
        }
        if (row.length) {
          position(row, u, rect, true);
          row.length = row.area = 0;
        }
        children.forEach(squarify);
      }
    }
    function stickify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), remaining = children.slice(), child, row = [];
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while (child = remaining.pop()) {
          row.push(child);
          row.area += child.area;
          if (child.z != null) {
            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
            row.length = row.area = 0;
          }
        }
        children.forEach(stickify);
      }
    }
    function worst(row, u) {
      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
      while (++i < n) {
        if (!(r = row[i].area)) continue;
        if (r < rmin) rmin = r;
        if (r > rmax) rmax = r;
      }
      s *= s;
      u *= u;
      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
    }
    function position(row, u, rect, flush) {
      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
      if (u == rect.dx) {
        if (flush || v > rect.dy) v = rect.dy;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dy = v;
          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
        }
        o.z = true;
        o.dx += rect.x + rect.dx - x;
        rect.y += v;
        rect.dy -= v;
      } else {
        if (flush || v > rect.dx) v = rect.dx;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dx = v;
          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
        }
        o.z = false;
        o.dy += rect.y + rect.dy - y;
        rect.x += v;
        rect.dx -= v;
      }
    }
    function treemap(d) {
      var nodes = stickies || hierarchy(d), root = nodes[0];
      root.x = root.y = 0;
      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
      if (stickies) hierarchy.revalue(root);
      scale([ root ], root.dx * root.dy / root.value);
      (stickies ? stickify : squarify)(root);
      if (sticky) stickies = nodes;
      return nodes;
    }
    treemap.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return treemap;
    };
    treemap.padding = function(x) {
      if (!arguments.length) return padding;
      function padFunction(node) {
        var p = x.call(treemap, node, node.depth);
        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
      }
      function padConstant(node) {
        return d3_layout_treemapPad(node, x);
      }
      var type;
      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
      padConstant) : padConstant;
      return treemap;
    };
    treemap.round = function(x) {
      if (!arguments.length) return round != Number;
      round = x ? Math.round : Number;
      return treemap;
    };
    treemap.sticky = function(x) {
      if (!arguments.length) return sticky;
      sticky = x;
      stickies = null;
      return treemap;
    };
    treemap.ratio = function(x) {
      if (!arguments.length) return ratio;
      ratio = x;
      return treemap;
    };
    treemap.mode = function(x) {
      if (!arguments.length) return mode;
      mode = x + "";
      return treemap;
    };
    return d3_layout_hierarchyRebind(treemap, hierarchy);
  };
  function d3_layout_treemapPadNull(node) {
    return {
      x: node.x,
      y: node.y,
      dx: node.dx,
      dy: node.dy
    };
  }
  function d3_layout_treemapPad(node, padding) {
    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
    if (dx < 0) {
      x += dx / 2;
      dx = 0;
    }
    if (dy < 0) {
      y += dy / 2;
      dy = 0;
    }
    return {
      x: x,
      y: y,
      dx: dx,
      dy: dy
    };
  }
  d3.random = {
    normal: function(µ, σ) {
      var n = arguments.length;
      if (n < 2) σ = 1;
      if (n < 1) µ = 0;
      return function() {
        var x, y, r;
        do {
          x = Math.random() * 2 - 1;
          y = Math.random() * 2 - 1;
          r = x * x + y * y;
        } while (!r || r > 1);
        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
      };
    },
    logNormal: function() {
      var random = d3.random.normal.apply(d3, arguments);
      return function() {
        return Math.exp(random());
      };
    },
    bates: function(m) {
      var random = d3.random.irwinHall(m);
      return function() {
        return random() / m;
      };
    },
    irwinHall: function(m) {
      return function() {
        for (var s = 0, j = 0; j < m; j++) s += Math.random();
        return s;
      };
    }
  };
  d3.scale = {};
  function d3_scaleExtent(domain) {
    var start = domain[0], stop = domain[domain.length - 1];
    return start < stop ? [ start, stop ] : [ stop, start ];
  }
  function d3_scaleRange(scale) {
    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
  }
  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
    return function(x) {
      return i(u(x));
    };
  }
  function d3_scale_nice(domain, nice) {
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
    if (x1 < x0) {
      dx = i0, i0 = i1, i1 = dx;
      dx = x0, x0 = x1, x1 = dx;
    }
    domain[i0] = nice.floor(x0);
    domain[i1] = nice.ceil(x1);
    return domain;
  }
  function d3_scale_niceStep(step) {
    return step ? {
      floor: function(x) {
        return Math.floor(x / step) * step;
      },
      ceil: function(x) {
        return Math.ceil(x / step) * step;
      }
    } : d3_scale_niceIdentity;
  }
  var d3_scale_niceIdentity = {
    floor: d3_identity,
    ceil: d3_identity
  };
  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
    if (domain[k] < domain[0]) {
      domain = domain.slice().reverse();
      range = range.slice().reverse();
    }
    while (++j <= k) {
      u.push(uninterpolate(domain[j - 1], domain[j]));
      i.push(interpolate(range[j - 1], range[j]));
    }
    return function(x) {
      var j = d3.bisect(domain, x, 1, k) - 1;
      return i[j](u[j](x));
    };
  }
  d3.scale.linear = function() {
    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
  };
  function d3_scale_linear(domain, range, interpolate, clamp) {
    var output, input;
    function rescale() {
      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
      output = linear(domain, range, uninterpolate, interpolate);
      input = linear(range, domain, uninterpolate, d3_interpolate);
      return scale;
    }
    function scale(x) {
      return output(x);
    }
    scale.invert = function(y) {
      return input(y);
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(Number);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.rangeRound = function(x) {
      return scale.range(x).interpolate(d3_interpolateRound);
    };
    scale.clamp = function(x) {
      if (!arguments.length) return clamp;
      clamp = x;
      return rescale();
    };
    scale.interpolate = function(x) {
      if (!arguments.length) return interpolate;
      interpolate = x;
      return rescale();
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      d3_scale_linearNice(domain, m);
      return rescale();
    };
    scale.copy = function() {
      return d3_scale_linear(domain, range, interpolate, clamp);
    };
    return rescale();
  }
  function d3_scale_linearRebind(scale, linear) {
    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
  }
  function d3_scale_linearNice(domain, m) {
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    return domain;
  }
  function d3_scale_linearTickRange(domain, m) {
    if (m == null) m = 10;
    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
    extent[0] = Math.ceil(extent[0] / step) * step;
    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
    extent[2] = step;
    return extent;
  }
  function d3_scale_linearTicks(domain, m) {
    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
  }
  function d3_scale_linearTickFormat(domain, m, format) {
    var range = d3_scale_linearTickRange(domain, m);
    if (format) {
      var match = d3_format_re.exec(format);
      match.shift();
      if (match[8] === "s") {
        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
        match[8] = "f";
        format = d3.format(match.join(""));
        return function(d) {
          return format(prefix.scale(d)) + prefix.symbol;
        };
      }
      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
      format = match.join("");
    } else {
      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
    }
    return d3.format(format);
  }
  var d3_scale_linearFormatSignificant = {
    s: 1,
    g: 1,
    p: 1,
    r: 1,
    e: 1
  };
  function d3_scale_linearPrecision(value) {
    return -Math.floor(Math.log(value) / Math.LN10 + .01);
  }
  function d3_scale_linearFormatPrecision(type, range) {
    var p = d3_scale_linearPrecision(range[2]);
    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
  }
  d3.scale.log = function() {
    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
  };
  function d3_scale_log(linear, base, positive, domain) {
    function log(x) {
      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
    }
    function pow(x) {
      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
    }
    function scale(x) {
      return linear(log(x));
    }
    scale.invert = function(x) {
      return pow(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      positive = x[0] >= 0;
      linear.domain((domain = x.map(Number)).map(log));
      return scale;
    };
    scale.base = function(_) {
      if (!arguments.length) return base;
      base = +_;
      linear.domain(domain.map(log));
      return scale;
    };
    scale.nice = function() {
      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
      linear.domain(niced);
      domain = niced.map(pow);
      return scale;
    };
    scale.ticks = function() {
      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
      if (isFinite(j - i)) {
        if (positive) {
          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
          ticks.push(pow(i));
        } else {
          ticks.push(pow(i));
          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
        }
        for (i = 0; ticks[i] < u; i++) {}
        for (j = ticks.length; ticks[j - 1] > v; j--) {}
        ticks = ticks.slice(i, j);
      }
      return ticks;
    };
    scale.tickFormat = function(n, format) {
      if (!arguments.length) return d3_scale_logFormat;
      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
      var k = Math.max(1, base * n / scale.ticks().length);
      return function(d) {
        var i = d / pow(Math.round(log(d)));
        if (i * base < base - .5) i *= base;
        return i <= k ? format(d) : "";
      };
    };
    scale.copy = function() {
      return d3_scale_log(linear.copy(), base, positive, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
    floor: function(x) {
      return -Math.ceil(-x);
    },
    ceil: function(x) {
      return -Math.floor(-x);
    }
  };
  d3.scale.pow = function() {
    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
  };
  function d3_scale_pow(linear, exponent, domain) {
    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
    function scale(x) {
      return linear(powp(x));
    }
    scale.invert = function(x) {
      return powb(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      linear.domain((domain = x.map(Number)).map(powp));
      return scale;
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      return scale.domain(d3_scale_linearNice(domain, m));
    };
    scale.exponent = function(x) {
      if (!arguments.length) return exponent;
      powp = d3_scale_powPow(exponent = x);
      powb = d3_scale_powPow(1 / exponent);
      linear.domain(domain.map(powp));
      return scale;
    };
    scale.copy = function() {
      return d3_scale_pow(linear.copy(), exponent, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_scale_powPow(e) {
    return function(x) {
      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
    };
  }
  d3.scale.sqrt = function() {
    return d3.scale.pow().exponent(.5);
  };
  d3.scale.ordinal = function() {
    return d3_scale_ordinal([], {
      t: "range",
      a: [ [] ]
    });
  };
  function d3_scale_ordinal(domain, ranger) {
    var index, range, rangeBand;
    function scale(x) {
      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
    }
    function steps(start, step) {
      return d3.range(domain.length).map(function(i) {
        return start + step * i;
      });
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = [];
      index = new d3_Map();
      var i = -1, n = x.length, xi;
      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
      return scale[ranger.t].apply(scale, ranger.a);
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      rangeBand = 0;
      ranger = {
        t: "range",
        a: arguments
      };
      return scale;
    };
    scale.rangePoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
      0) : (stop - start) / (domain.length - 1 + padding);
      range = steps(start + step * padding / 2, step);
      rangeBand = 0;
      ranger = {
        t: "rangePoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundPoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
      0) : (stop - start) / (domain.length - 1 + padding) | 0;
      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
      rangeBand = 0;
      ranger = {
        t: "rangeRoundPoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
      range = steps(start + step * outerPadding, step);
      if (reverse) range.reverse();
      rangeBand = step * (1 - padding);
      ranger = {
        t: "rangeBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
      if (reverse) range.reverse();
      rangeBand = Math.round(step * (1 - padding));
      ranger = {
        t: "rangeRoundBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeBand = function() {
      return rangeBand;
    };
    scale.rangeExtent = function() {
      return d3_scaleExtent(ranger.a[0]);
    };
    scale.copy = function() {
      return d3_scale_ordinal(domain, ranger);
    };
    return scale.domain(domain);
  }
  d3.scale.category10 = function() {
    return d3.scale.ordinal().range(d3_category10);
  };
  d3.scale.category20 = function() {
    return d3.scale.ordinal().range(d3_category20);
  };
  d3.scale.category20b = function() {
    return d3.scale.ordinal().range(d3_category20b);
  };
  d3.scale.category20c = function() {
    return d3.scale.ordinal().range(d3_category20c);
  };
  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
  d3.scale.quantile = function() {
    return d3_scale_quantile([], []);
  };
  function d3_scale_quantile(domain, range) {
    var thresholds;
    function rescale() {
      var k = 0, q = range.length;
      thresholds = [];
      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
      return scale;
    }
    function scale(x) {
      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.quantiles = function() {
      return thresholds;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
    };
    scale.copy = function() {
      return d3_scale_quantile(domain, range);
    };
    return rescale();
  }
  d3.scale.quantize = function() {
    return d3_scale_quantize(0, 1, [ 0, 1 ]);
  };
  function d3_scale_quantize(x0, x1, range) {
    var kx, i;
    function scale(x) {
      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
    }
    function rescale() {
      kx = range.length / (x1 - x0);
      i = range.length - 1;
      return scale;
    }
    scale.domain = function(x) {
      if (!arguments.length) return [ x0, x1 ];
      x0 = +x[0];
      x1 = +x[x.length - 1];
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      y = y < 0 ? NaN : y / kx + x0;
      return [ y, y + 1 / kx ];
    };
    scale.copy = function() {
      return d3_scale_quantize(x0, x1, range);
    };
    return rescale();
  }
  d3.scale.threshold = function() {
    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
  };
  function d3_scale_threshold(domain, range) {
    function scale(x) {
      if (x <= x) return range[d3.bisect(domain, x)];
    }
    scale.domain = function(_) {
      if (!arguments.length) return domain;
      domain = _;
      return scale;
    };
    scale.range = function(_) {
      if (!arguments.length) return range;
      range = _;
      return scale;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return [ domain[y - 1], domain[y] ];
    };
    scale.copy = function() {
      return d3_scale_threshold(domain, range);
    };
    return scale;
  }
  d3.scale.identity = function() {
    return d3_scale_identity([ 0, 1 ]);
  };
  function d3_scale_identity(domain) {
    function identity(x) {
      return +x;
    }
    identity.invert = identity;
    identity.domain = identity.range = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(identity);
      return identity;
    };
    identity.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    identity.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    identity.copy = function() {
      return d3_scale_identity(domain);
    };
    return identity;
  }
  d3.svg = {};
  function d3_zero() {
    return 0;
  }
  d3.svg.arc = function() {
    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
    function arc() {
      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
        if (!cw) p1 *= -1;
        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
      }
      if (r1) {
        x0 = r1 * Math.cos(a0 + p1);
        y0 = r1 * Math.sin(a0 + p1);
        x1 = r1 * Math.cos(a1 - p1);
        y1 = r1 * Math.sin(a1 - p1);
        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
          var h1 = (a0 + a1) / 2;
          x0 = r1 * Math.cos(h1);
          y0 = r1 * Math.sin(h1);
          x1 = y1 = null;
        }
      } else {
        x0 = y0 = 0;
      }
      if (r0) {
        x2 = r0 * Math.cos(a1 - p0);
        y2 = r0 * Math.sin(a1 - p0);
        x3 = r0 * Math.cos(a0 + p0);
        y3 = r0 * Math.sin(a0 + p0);
        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
          var h0 = (a0 + a1) / 2;
          x2 = r0 * Math.cos(h0);
          y2 = r0 * Math.sin(h0);
          x3 = y3 = null;
        }
      } else {
        x2 = y2 = 0;
      }
      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
        cr = r0 < r1 ^ cw ? 0 : 1;
        var rc1 = rc, rc0 = rc;
        if (da < π) {
          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
        }
        if (x1 != null) {
          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
          if (rc === rc1) {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
          } else {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
          }
        } else {
          path.push("M", x0, ",", y0);
        }
        if (x3 != null) {
          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
          if (rc === rc0) {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          } else {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          }
        } else {
          path.push("L", x2, ",", y2);
        }
      } else {
        path.push("M", x0, ",", y0);
        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
        path.push("L", x2, ",", y2);
        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
      }
      path.push("Z");
      return path.join("");
    }
    function circleSegment(r1, cw) {
      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
    }
    arc.innerRadius = function(v) {
      if (!arguments.length) return innerRadius;
      innerRadius = d3_functor(v);
      return arc;
    };
    arc.outerRadius = function(v) {
      if (!arguments.length) return outerRadius;
      outerRadius = d3_functor(v);
      return arc;
    };
    arc.cornerRadius = function(v) {
      if (!arguments.length) return cornerRadius;
      cornerRadius = d3_functor(v);
      return arc;
    };
    arc.padRadius = function(v) {
      if (!arguments.length) return padRadius;
      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
      return arc;
    };
    arc.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return arc;
    };
    arc.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return arc;
    };
    arc.padAngle = function(v) {
      if (!arguments.length) return padAngle;
      padAngle = d3_functor(v);
      return arc;
    };
    arc.centroid = function() {
      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
      return [ Math.cos(a) * r, Math.sin(a) * r ];
    };
    return arc;
  };
  var d3_svg_arcAuto = "auto";
  function d3_svg_arcInnerRadius(d) {
    return d.innerRadius;
  }
  function d3_svg_arcOuterRadius(d) {
    return d.outerRadius;
  }
  function d3_svg_arcStartAngle(d) {
    return d.startAngle;
  }
  function d3_svg_arcEndAngle(d) {
    return d.endAngle;
  }
  function d3_svg_arcPadAngle(d) {
    return d && d.padAngle;
  }
  function d3_svg_arcSweep(x0, y0, x1, y1) {
    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
  }
  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
  }
  function d3_svg_line(projection) {
    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
    function line(data) {
      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
      function segment() {
        segments.push("M", interpolate(projection(points), tension));
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
        } else if (points.length) {
          segment();
          points = [];
        }
      }
      if (points.length) segment();
      return segments.length ? segments.join("") : null;
    }
    line.x = function(_) {
      if (!arguments.length) return x;
      x = _;
      return line;
    };
    line.y = function(_) {
      if (!arguments.length) return y;
      y = _;
      return line;
    };
    line.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return line;
    };
    line.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      return line;
    };
    line.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return line;
    };
    return line;
  }
  d3.svg.line = function() {
    return d3_svg_line(d3_identity);
  };
  var d3_svg_lineInterpolators = d3.map({
    linear: d3_svg_lineLinear,
    "linear-closed": d3_svg_lineLinearClosed,
    step: d3_svg_lineStep,
    "step-before": d3_svg_lineStepBefore,
    "step-after": d3_svg_lineStepAfter,
    basis: d3_svg_lineBasis,
    "basis-open": d3_svg_lineBasisOpen,
    "basis-closed": d3_svg_lineBasisClosed,
    bundle: d3_svg_lineBundle,
    cardinal: d3_svg_lineCardinal,
    "cardinal-open": d3_svg_lineCardinalOpen,
    "cardinal-closed": d3_svg_lineCardinalClosed,
    monotone: d3_svg_lineMonotone
  });
  d3_svg_lineInterpolators.forEach(function(key, value) {
    value.key = key;
    value.closed = /-closed$/.test(key);
  });
  function d3_svg_lineLinear(points) {
    return points.length > 1 ? points.join("L") : points + "Z";
  }
  function d3_svg_lineLinearClosed(points) {
    return points.join("L") + "Z";
  }
  function d3_svg_lineStep(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
    if (n > 1) path.push("H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepBefore(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepAfter(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
    return path.join("");
  }
  function d3_svg_lineCardinalOpen(points, tension) {
    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineCardinalClosed(points, tension) {
    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
  }
  function d3_svg_lineCardinal(points, tension) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineHermite(points, tangents) {
    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
      return d3_svg_lineLinear(points);
    }
    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
    if (quad) {
      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
      p0 = points[1];
      pi = 2;
    }
    if (tangents.length > 1) {
      t = tangents[1];
      p = points[pi];
      pi++;
      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      for (var i = 2; i < tangents.length; i++, pi++) {
        p = points[pi];
        t = tangents[i];
        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      }
    }
    if (quad) {
      var lp = points[pi];
      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
    }
    return path;
  }
  function d3_svg_lineCardinalTangents(points, tension) {
    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
    while (++i < n) {
      p0 = p1;
      p1 = p2;
      p2 = points[i];
      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
    }
    return tangents;
  }
  function d3_svg_lineBasis(points) {
    if (points.length < 3) return d3_svg_lineLinear(points);
    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    points.push(points[n - 1]);
    while (++i <= n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    points.pop();
    path.push("L", pi);
    return path.join("");
  }
  function d3_svg_lineBasisOpen(points) {
    if (points.length < 4) return d3_svg_lineLinear(points);
    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
    while (++i < 3) {
      pi = points[i];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
    --i;
    while (++i < n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBasisClosed(points) {
    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
    while (++i < 4) {
      pi = points[i % n];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    --i;
    while (++i < m) {
      pi = points[i % n];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBundle(points, tension) {
    var n = points.length - 1;
    if (n) {
      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
      while (++i <= n) {
        p = points[i];
        t = i / n;
        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
      }
    }
    return d3_svg_lineBasis(points);
  }
  function d3_svg_lineDot4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
  }
  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
  function d3_svg_lineBasisBezier(path, x, y) {
    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
  }
  function d3_svg_lineSlope(p0, p1) {
    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
  }
  function d3_svg_lineFiniteDifferences(points) {
    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
    while (++i < j) {
      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
    }
    m[i] = d;
    return m;
  }
  function d3_svg_lineMonotoneTangents(points) {
    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
    while (++i < j) {
      d = d3_svg_lineSlope(points[i], points[i + 1]);
      if (abs(d) < ε) {
        m[i] = m[i + 1] = 0;
      } else {
        a = m[i] / d;
        b = m[i + 1] / d;
        s = a * a + b * b;
        if (s > 9) {
          s = d * 3 / Math.sqrt(s);
          m[i] = s * a;
          m[i + 1] = s * b;
        }
      }
    }
    i = -1;
    while (++i <= j) {
      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
      tangents.push([ s || 0, m[i] * s || 0 ]);
    }
    return tangents;
  }
  function d3_svg_lineMonotone(points) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
  }
  d3.svg.line.radial = function() {
    var line = d3_svg_line(d3_svg_lineRadial);
    line.radius = line.x, delete line.x;
    line.angle = line.y, delete line.y;
    return line;
  };
  function d3_svg_lineRadial(points) {
    var point, i = -1, n = points.length, r, a;
    while (++i < n) {
      point = points[i];
      r = point[0];
      a = point[1] - halfπ;
      point[0] = r * Math.cos(a);
      point[1] = r * Math.sin(a);
    }
    return points;
  }
  function d3_svg_area(projection) {
    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
    function area(data) {
      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
        return x;
      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
        return y;
      } : d3_functor(y1), x, y;
      function segment() {
        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
        } else if (points0.length) {
          segment();
          points0 = [];
          points1 = [];
        }
      }
      if (points0.length) segment();
      return segments.length ? segments.join("") : null;
    }
    area.x = function(_) {
      if (!arguments.length) return x1;
      x0 = x1 = _;
      return area;
    };
    area.x0 = function(_) {
      if (!arguments.length) return x0;
      x0 = _;
      return area;
    };
    area.x1 = function(_) {
      if (!arguments.length) return x1;
      x1 = _;
      return area;
    };
    area.y = function(_) {
      if (!arguments.length) return y1;
      y0 = y1 = _;
      return area;
    };
    area.y0 = function(_) {
      if (!arguments.length) return y0;
      y0 = _;
      return area;
    };
    area.y1 = function(_) {
      if (!arguments.length) return y1;
      y1 = _;
      return area;
    };
    area.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return area;
    };
    area.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      interpolateReverse = interpolate.reverse || interpolate;
      L = interpolate.closed ? "M" : "L";
      return area;
    };
    area.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return area;
    };
    return area;
  }
  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
  d3.svg.area = function() {
    return d3_svg_area(d3_identity);
  };
  d3.svg.area.radial = function() {
    var area = d3_svg_area(d3_svg_lineRadial);
    area.radius = area.x, delete area.x;
    area.innerRadius = area.x0, delete area.x0;
    area.outerRadius = area.x1, delete area.x1;
    area.angle = area.y, delete area.y;
    area.startAngle = area.y0, delete area.y0;
    area.endAngle = area.y1, delete area.y1;
    return area;
  };
  d3.svg.chord = function() {
    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
    function chord(d, i) {
      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
    }
    function subgroup(self, f, d, i) {
      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
      return {
        r: r,
        a0: a0,
        a1: a1,
        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
      };
    }
    function equals(a, b) {
      return a.a0 == b.a0 && a.a1 == b.a1;
    }
    function arc(r, p, a) {
      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
    }
    function curve(r0, p0, r1, p1) {
      return "Q 0,0 " + p1;
    }
    chord.radius = function(v) {
      if (!arguments.length) return radius;
      radius = d3_functor(v);
      return chord;
    };
    chord.source = function(v) {
      if (!arguments.length) return source;
      source = d3_functor(v);
      return chord;
    };
    chord.target = function(v) {
      if (!arguments.length) return target;
      target = d3_functor(v);
      return chord;
    };
    chord.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return chord;
    };
    chord.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return chord;
    };
    return chord;
  };
  function d3_svg_chordRadius(d) {
    return d.radius;
  }
  d3.svg.diagonal = function() {
    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
    function diagonal(d, i) {
      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
        x: p0.x,
        y: m
      }, {
        x: p3.x,
        y: m
      }, p3 ];
      p = p.map(projection);
      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
    }
    diagonal.source = function(x) {
      if (!arguments.length) return source;
      source = d3_functor(x);
      return diagonal;
    };
    diagonal.target = function(x) {
      if (!arguments.length) return target;
      target = d3_functor(x);
      return diagonal;
    };
    diagonal.projection = function(x) {
      if (!arguments.length) return projection;
      projection = x;
      return diagonal;
    };
    return diagonal;
  };
  function d3_svg_diagonalProjection(d) {
    return [ d.x, d.y ];
  }
  d3.svg.diagonal.radial = function() {
    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
    diagonal.projection = function(x) {
      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
    };
    return diagonal;
  };
  function d3_svg_diagonalRadialProjection(projection) {
    return function() {
      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
      return [ r * Math.cos(a), r * Math.sin(a) ];
    };
  }
  d3.svg.symbol = function() {
    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
    function symbol(d, i) {
      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
    }
    symbol.type = function(x) {
      if (!arguments.length) return type;
      type = d3_functor(x);
      return symbol;
    };
    symbol.size = function(x) {
      if (!arguments.length) return size;
      size = d3_functor(x);
      return symbol;
    };
    return symbol;
  };
  function d3_svg_symbolSize() {
    return 64;
  }
  function d3_svg_symbolType() {
    return "circle";
  }
  function d3_svg_symbolCircle(size) {
    var r = Math.sqrt(size / π);
    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
  }
  var d3_svg_symbols = d3.map({
    circle: d3_svg_symbolCircle,
    cross: function(size) {
      var r = Math.sqrt(size / 5) / 2;
      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
    },
    diamond: function(size) {
      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
    },
    square: function(size) {
      var r = Math.sqrt(size) / 2;
      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
    },
    "triangle-down": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
    },
    "triangle-up": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
    }
  });
  d3.svg.symbolTypes = d3_svg_symbols.keys();
  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
  d3_selectionPrototype.transition = function(name) {
    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
      time: Date.now(),
      ease: d3_ease_cubicInOut,
      delay: 0,
      duration: 250
    };
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_selectionPrototype.interrupt = function(name) {
    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
  };
  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
  function d3_selection_interruptNS(ns) {
    return function() {
      var lock, activeId, active;
      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
        active.timer.c = null;
        active.timer.t = NaN;
        if (--lock.count) delete lock[activeId]; else delete this[ns];
        lock.active += .5;
        active.event && active.event.interrupt.call(this, this.__data__, active.index);
      }
    };
  }
  function d3_transition(groups, ns, id) {
    d3_subclass(groups, d3_transitionPrototype);
    groups.namespace = ns;
    groups.id = id;
    return groups;
  }
  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
  d3_transitionPrototype.call = d3_selectionPrototype.call;
  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
  d3_transitionPrototype.node = d3_selectionPrototype.node;
  d3_transitionPrototype.size = d3_selectionPrototype.size;
  d3.transition = function(selection, name) {
    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
  };
  d3.transition.prototype = d3_transitionPrototype;
  d3_transitionPrototype.select = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
          if ("__data__" in node) subnode.__data__ = node.__data__;
          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
          subgroup.push(subnode);
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.selectAll = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          transition = node[ns][id];
          subnodes = selector.call(node, node.__data__, i, j);
          subgroups.push(subgroup = []);
          for (var k = -1, o = subnodes.length; ++k < o; ) {
            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
            subgroup.push(subnode);
          }
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_transition(subgroups, this.namespace, this.id);
  };
  d3_transitionPrototype.tween = function(name, tween) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
    return d3_selection_each(this, tween == null ? function(node) {
      node[ns][id].tween.remove(name);
    } : function(node) {
      node[ns][id].tween.set(name, tween);
    });
  };
  function d3_transition_tween(groups, name, value, tween) {
    var id = groups.id, ns = groups.namespace;
    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
    } : (value = tween(value), function(node) {
      node[ns][id].tween.set(name, value);
    }));
  }
  d3_transitionPrototype.attr = function(nameNS, value) {
    if (arguments.length < 2) {
      for (value in nameNS) this.attr(value, nameNS[value]);
      return this;
    }
    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrTween(b) {
      return b == null ? attrNull : (b += "", function() {
        var a = this.getAttribute(name), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttribute(name, i(t));
        });
      });
    }
    function attrTweenNS(b) {
      return b == null ? attrNullNS : (b += "", function() {
        var a = this.getAttributeNS(name.space, name.local), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttributeNS(name.space, name.local, i(t));
        });
      });
    }
    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.attrTween = function(nameNS, tween) {
    var name = d3.ns.qualify(nameNS);
    function attrTween(d, i) {
      var f = tween.call(this, d, i, this.getAttribute(name));
      return f && function(t) {
        this.setAttribute(name, f(t));
      };
    }
    function attrTweenNS(d, i) {
      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
      return f && function(t) {
        this.setAttributeNS(name.space, name.local, f(t));
      };
    }
    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.style(priority, name[priority], value);
        return this;
      }
      priority = "";
    }
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleString(b) {
      return b == null ? styleNull : (b += "", function() {
        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
        return a !== b && (i = d3_interpolate(a, b), function(t) {
          this.style.setProperty(name, i(t), priority);
        });
      });
    }
    return d3_transition_tween(this, "style." + name, value, styleString);
  };
  d3_transitionPrototype.styleTween = function(name, tween, priority) {
    if (arguments.length < 3) priority = "";
    function styleTween(d, i) {
      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
      return f && function(t) {
        this.style.setProperty(name, f(t), priority);
      };
    }
    return this.tween("style." + name, styleTween);
  };
  d3_transitionPrototype.text = function(value) {
    return d3_transition_tween(this, "text", value, d3_transition_text);
  };
  function d3_transition_text(b) {
    if (b == null) b = "";
    return function() {
      this.textContent = b;
    };
  }
  d3_transitionPrototype.remove = function() {
    var ns = this.namespace;
    return this.each("end.transition", function() {
      var p;
      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
    });
  };
  d3_transitionPrototype.ease = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].ease;
    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
    return d3_selection_each(this, function(node) {
      node[ns][id].ease = value;
    });
  };
  d3_transitionPrototype.delay = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].delay;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].delay = +value.call(node, node.__data__, i, j);
    } : (value = +value, function(node) {
      node[ns][id].delay = value;
    }));
  };
  d3_transitionPrototype.duration = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].duration;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
    } : (value = Math.max(1, value), function(node) {
      node[ns][id].duration = value;
    }));
  };
  d3_transitionPrototype.each = function(type, listener) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) {
      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
      try {
        d3_transitionInheritId = id;
        d3_selection_each(this, function(node, i, j) {
          d3_transitionInherit = node[ns][id];
          type.call(node, node.__data__, i, j);
        });
      } finally {
        d3_transitionInherit = inherit;
        d3_transitionInheritId = inheritId;
      }
    } else {
      d3_selection_each(this, function(node) {
        var transition = node[ns][id];
        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
      });
    }
    return this;
  };
  d3_transitionPrototype.transition = function() {
    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if (node = group[i]) {
          transition = node[ns][id0];
          d3_transitionNode(node, i, ns, id1, {
            time: transition.time,
            ease: transition.ease,
            delay: transition.delay + transition.duration,
            duration: transition.duration
          });
        }
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id1);
  };
  function d3_transitionNamespace(name) {
    return name == null ? "__transition__" : "__transition_" + name + "__";
  }
  function d3_transitionNode(node, i, ns, id, inherit) {
    var lock = node[ns] || (node[ns] = {
      active: 0,
      count: 0
    }), transition = lock[id], time, timer, duration, ease, tweens;
    function schedule(elapsed) {
      var delay = transition.delay;
      timer.t = delay + time;
      if (delay <= elapsed) return start(elapsed - delay);
      timer.c = start;
    }
    function start(elapsed) {
      var activeId = lock.active, active = lock[activeId];
      if (active) {
        active.timer.c = null;
        active.timer.t = NaN;
        --lock.count;
        delete lock[activeId];
        active.event && active.event.interrupt.call(node, node.__data__, active.index);
      }
      for (var cancelId in lock) {
        if (+cancelId < id) {
          var cancel = lock[cancelId];
          cancel.timer.c = null;
          cancel.timer.t = NaN;
          --lock.count;
          delete lock[cancelId];
        }
      }
      timer.c = tick;
      d3_timer(function() {
        if (timer.c && tick(elapsed || 1)) {
          timer.c = null;
          timer.t = NaN;
        }
        return 1;
      }, 0, time);
      lock.active = id;
      transition.event && transition.event.start.call(node, node.__data__, i);
      tweens = [];
      transition.tween.forEach(function(key, value) {
        if (value = value.call(node, node.__data__, i)) {
          tweens.push(value);
        }
      });
      ease = transition.ease;
      duration = transition.duration;
    }
    function tick(elapsed) {
      var t = elapsed / duration, e = ease(t), n = tweens.length;
      while (n > 0) {
        tweens[--n].call(node, e);
      }
      if (t >= 1) {
        transition.event && transition.event.end.call(node, node.__data__, i);
        if (--lock.count) delete lock[id]; else delete node[ns];
        return 1;
      }
    }
    if (!transition) {
      time = inherit.time;
      timer = d3_timer(schedule, 0, time);
      transition = lock[id] = {
        tween: new d3_Map(),
        time: time,
        timer: timer,
        delay: inherit.delay,
        duration: inherit.duration,
        ease: inherit.ease,
        index: i
      };
      inherit = null;
      ++lock.count;
    }
  }
  d3.svg.axis = function() {
    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
    function axis(g) {
      g.each(function() {
        var g = d3.select(this);
        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
        d3.transition(path));
        tickEnter.append("line");
        tickEnter.append("text");
        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
        if (orient === "bottom" || orient === "top") {
          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
        } else {
          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
        }
        lineEnter.attr(y2, sign * innerTickSize);
        textEnter.attr(y1, sign * tickSpacing);
        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
        if (scale1.rangeBand) {
          var x = scale1, dx = x.rangeBand() / 2;
          scale0 = scale1 = function(d) {
            return x(d) + dx;
          };
        } else if (scale0.rangeBand) {
          scale0 = scale1;
        } else {
          tickExit.call(tickTransform, scale1, scale0);
        }
        tickEnter.call(tickTransform, scale0, scale1);
        tickUpdate.call(tickTransform, scale1, scale1);
      });
    }
    axis.scale = function(x) {
      if (!arguments.length) return scale;
      scale = x;
      return axis;
    };
    axis.orient = function(x) {
      if (!arguments.length) return orient;
      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
      return axis;
    };
    axis.ticks = function() {
      if (!arguments.length) return tickArguments_;
      tickArguments_ = d3_array(arguments);
      return axis;
    };
    axis.tickValues = function(x) {
      if (!arguments.length) return tickValues;
      tickValues = x;
      return axis;
    };
    axis.tickFormat = function(x) {
      if (!arguments.length) return tickFormat_;
      tickFormat_ = x;
      return axis;
    };
    axis.tickSize = function(x) {
      var n = arguments.length;
      if (!n) return innerTickSize;
      innerTickSize = +x;
      outerTickSize = +arguments[n - 1];
      return axis;
    };
    axis.innerTickSize = function(x) {
      if (!arguments.length) return innerTickSize;
      innerTickSize = +x;
      return axis;
    };
    axis.outerTickSize = function(x) {
      if (!arguments.length) return outerTickSize;
      outerTickSize = +x;
      return axis;
    };
    axis.tickPadding = function(x) {
      if (!arguments.length) return tickPadding;
      tickPadding = +x;
      return axis;
    };
    axis.tickSubdivide = function() {
      return arguments.length && axis;
    };
    return axis;
  };
  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  };
  function d3_svg_axisX(selection, x0, x1) {
    selection.attr("transform", function(d) {
      var v0 = x0(d);
      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
    });
  }
  function d3_svg_axisY(selection, y0, y1) {
    selection.attr("transform", function(d) {
      var v0 = y0(d);
      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
    });
  }
  d3.svg.brush = function() {
    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
    function brush(g) {
      g.each(function() {
        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
        var background = g.selectAll(".background").data([ 0 ]);
        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
        var resize = g.selectAll(".resize").data(resizes, d3_identity);
        resize.exit().remove();
        resize.enter().append("g").attr("class", function(d) {
          return "resize " + d;
        }).style("cursor", function(d) {
          return d3_svg_brushCursor[d];
        }).append("rect").attr("x", function(d) {
          return /[ew]$/.test(d) ? -3 : null;
        }).attr("y", function(d) {
          return /^[ns]/.test(d) ? -3 : null;
        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
        resize.style("display", brush.empty() ? "none" : null);
        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
        if (x) {
          range = d3_scaleRange(x);
          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
          redrawX(gUpdate);
        }
        if (y) {
          range = d3_scaleRange(y);
          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
          redrawY(gUpdate);
        }
        redraw(gUpdate);
      });
    }
    brush.event = function(g) {
      g.each(function() {
        var event_ = event.of(this, arguments), extent1 = {
          x: xExtent,
          y: yExtent,
          i: xExtentDomain,
          j: yExtentDomain
        }, extent0 = this.__chart__ || extent1;
        this.__chart__ = extent1;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.brush", function() {
            xExtentDomain = extent0.i;
            yExtentDomain = extent0.j;
            xExtent = extent0.x;
            yExtent = extent0.y;
            event_({
              type: "brushstart"
            });
          }).tween("brush:brush", function() {
            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
            xExtentDomain = yExtentDomain = null;
            return function(t) {
              xExtent = extent1.x = xi(t);
              yExtent = extent1.y = yi(t);
              event_({
                type: "brush",
                mode: "resize"
              });
            };
          }).each("end.brush", function() {
            xExtentDomain = extent1.i;
            yExtentDomain = extent1.j;
            event_({
              type: "brush",
              mode: "resize"
            });
            event_({
              type: "brushend"
            });
          });
        } else {
          event_({
            type: "brushstart"
          });
          event_({
            type: "brush",
            mode: "resize"
          });
          event_({
            type: "brushend"
          });
        }
      });
    };
    function redraw(g) {
      g.selectAll(".resize").attr("transform", function(d) {
        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
      });
    }
    function redrawX(g) {
      g.select(".extent").attr("x", xExtent[0]);
      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
    }
    function redrawY(g) {
      g.select(".extent").attr("y", yExtent[0]);
      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
    }
    function brushstart() {
      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
      if (d3.event.changedTouches) {
        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
      } else {
        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
      }
      g.interrupt().selectAll("*").interrupt();
      if (dragging) {
        origin[0] = xExtent[0] - origin[0];
        origin[1] = yExtent[0] - origin[1];
      } else if (resizing) {
        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
        origin[0] = xExtent[ex];
        origin[1] = yExtent[ey];
      } else if (d3.event.altKey) center = origin.slice();
      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
      d3.select("body").style("cursor", eventTarget.style("cursor"));
      event_({
        type: "brushstart"
      });
      brushmove();
      function keydown() {
        if (d3.event.keyCode == 32) {
          if (!dragging) {
            center = null;
            origin[0] -= xExtent[1];
            origin[1] -= yExtent[1];
            dragging = 2;
          }
          d3_eventPreventDefault();
        }
      }
      function keyup() {
        if (d3.event.keyCode == 32 && dragging == 2) {
          origin[0] += xExtent[1];
          origin[1] += yExtent[1];
          dragging = 0;
          d3_eventPreventDefault();
        }
      }
      function brushmove() {
        var point = d3.mouse(target), moved = false;
        if (offset) {
          point[0] += offset[0];
          point[1] += offset[1];
        }
        if (!dragging) {
          if (d3.event.altKey) {
            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
            origin[0] = xExtent[+(point[0] < center[0])];
            origin[1] = yExtent[+(point[1] < center[1])];
          } else center = null;
        }
        if (resizingX && move1(point, x, 0)) {
          redrawX(g);
          moved = true;
        }
        if (resizingY && move1(point, y, 1)) {
          redrawY(g);
          moved = true;
        }
        if (moved) {
          redraw(g);
          event_({
            type: "brush",
            mode: dragging ? "move" : "resize"
          });
        }
      }
      function move1(point, scale, i) {
        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
        if (dragging) {
          r0 -= position;
          r1 -= size + position;
        }
        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
        if (dragging) {
          max = (min += position) + size;
        } else {
          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
          if (position < min) {
            max = min;
            min = position;
          } else {
            max = position;
          }
        }
        if (extent[0] != min || extent[1] != max) {
          if (i) yExtentDomain = null; else xExtentDomain = null;
          extent[0] = min;
          extent[1] = max;
          return true;
        }
      }
      function brushend() {
        brushmove();
        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
        d3.select("body").style("cursor", null);
        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
        dragRestore();
        event_({
          type: "brushend"
        });
      }
    }
    brush.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.clamp = function(z) {
      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
      return brush;
    };
    brush.extent = function(z) {
      var x0, x1, y0, y1, t;
      if (!arguments.length) {
        if (x) {
          if (xExtentDomain) {
            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
          } else {
            x0 = xExtent[0], x1 = xExtent[1];
            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
            if (x1 < x0) t = x0, x0 = x1, x1 = t;
          }
        }
        if (y) {
          if (yExtentDomain) {
            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
          } else {
            y0 = yExtent[0], y1 = yExtent[1];
            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
            if (y1 < y0) t = y0, y0 = y1, y1 = t;
          }
        }
        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
      }
      if (x) {
        x0 = z[0], x1 = z[1];
        if (y) x0 = x0[0], x1 = x1[0];
        xExtentDomain = [ x0, x1 ];
        if (x.invert) x0 = x(x0), x1 = x(x1);
        if (x1 < x0) t = x0, x0 = x1, x1 = t;
        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
      }
      if (y) {
        y0 = z[0], y1 = z[1];
        if (x) y0 = y0[1], y1 = y1[1];
        yExtentDomain = [ y0, y1 ];
        if (y.invert) y0 = y(y0), y1 = y(y1);
        if (y1 < y0) t = y0, y0 = y1, y1 = t;
        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
      }
      return brush;
    };
    brush.clear = function() {
      if (!brush.empty()) {
        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
        xExtentDomain = yExtentDomain = null;
      }
      return brush;
    };
    brush.empty = function() {
      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
    };
    return d3.rebind(brush, event, "on");
  };
  var d3_svg_brushCursor = {
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
  };
  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
  var d3_time_formatUtc = d3_time_format.utc;
  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
  function d3_time_formatIsoNative(date) {
    return date.toISOString();
  }
  d3_time_formatIsoNative.parse = function(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
  };
  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
  d3_time.second = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 1e3) * 1e3);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
  }, function(date) {
    return date.getSeconds();
  });
  d3_time.seconds = d3_time.second.range;
  d3_time.seconds.utc = d3_time.second.utc.range;
  d3_time.minute = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 6e4) * 6e4);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
  }, function(date) {
    return date.getMinutes();
  });
  d3_time.minutes = d3_time.minute.range;
  d3_time.minutes.utc = d3_time.minute.utc.range;
  d3_time.hour = d3_time_interval(function(date) {
    var timezone = date.getTimezoneOffset() / 60;
    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
  }, function(date) {
    return date.getHours();
  });
  d3_time.hours = d3_time.hour.range;
  d3_time.hours.utc = d3_time.hour.utc.range;
  d3_time.month = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setDate(1);
    return date;
  }, function(date, offset) {
    date.setMonth(date.getMonth() + offset);
  }, function(date) {
    return date.getMonth();
  });
  d3_time.months = d3_time.month.range;
  d3_time.months.utc = d3_time.month.utc.range;
  function d3_time_scale(linear, methods, format) {
    function scale(x) {
      return linear(x);
    }
    scale.invert = function(x) {
      return d3_time_scaleDate(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
      linear.domain(x);
      return scale;
    };
    function tickMethod(extent, count) {
      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
        return d / 31536e6;
      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
    }
    scale.nice = function(interval, skip) {
      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
      if (method) interval = method[0], skip = method[1];
      function skipped(date) {
        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
      }
      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
        floor: function(date) {
          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
          return date;
        },
        ceil: function(date) {
          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
          return date;
        }
      } : interval));
    };
    scale.ticks = function(interval, skip) {
      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
        range: interval
      }, skip ];
      if (method) interval = method[0], skip = method[1];
      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
    };
    scale.tickFormat = function() {
      return format;
    };
    scale.copy = function() {
      return d3_time_scale(linear.copy(), methods, format);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_time_scaleDate(t) {
    return new Date(t);
  }
  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
    return d.getMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getMinutes();
  } ], [ "%I %p", function(d) {
    return d.getHours();
  } ], [ "%a %d", function(d) {
    return d.getDay() && d.getDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getDate() != 1;
  } ], [ "%B", function(d) {
    return d.getMonth();
  } ], [ "%Y", d3_true ] ]);
  var d3_time_scaleMilliseconds = {
    range: function(start, stop, step) {
      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
    },
    floor: d3_identity,
    ceil: d3_identity
  };
  d3_time_scaleLocalMethods.year = d3_time.year;
  d3_time.scale = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
  };
  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
    return [ m[0].utc, m[1] ];
  });
  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
    return d.getUTCMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getUTCSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getUTCMinutes();
  } ], [ "%I %p", function(d) {
    return d.getUTCHours();
  } ], [ "%a %d", function(d) {
    return d.getUTCDay() && d.getUTCDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getUTCDate() != 1;
  } ], [ "%B", function(d) {
    return d.getUTCMonth();
  } ], [ "%Y", d3_true ] ]);
  d3_time_scaleUtcMethods.year = d3_time.year.utc;
  d3_time.scale.utc = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
  };
  d3.text = d3_xhrType(function(request) {
    return request.responseText;
  });
  d3.json = function(url, callback) {
    return d3_xhr(url, "application/json", d3_json, callback);
  };
  function d3_json(request) {
    return JSON.parse(request.responseText);
  }
  d3.html = function(url, callback) {
    return d3_xhr(url, "text/html", d3_html, callback);
  };
  function d3_html(request) {
    var range = d3_document.createRange();
    range.selectNode(d3_document.body);
    return range.createContextualFragment(request.responseText);
  }
  d3.xml = d3_xhrType(function(request) {
    return request.responseXML;
  });
  if (typeof define === "function" && define.amd) this.d3 = d3, define('d3',d3); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
}();
/*

© 2011 by Jerry Sievert

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/


(function () {
    /** @class Date */
    // constants
    var monthsAbbr = [], monthsFull = [], daysAbbr = [], daysFull = [], dayNames = {}, monthsAll, daysAll = [], monthNames = [];
    monthsAbbr = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];

    monthsFull = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];

    daysAbbr = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ];

    daysFull = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ];

    dayNames = {
        'su':         0,
        'sun':        0,
        'sunday':     0,
        'mo':         1,
        'mon':        1,
        'monday':     1,
        'tu':         2,
        'tue':        2,
        'tuesday':    2,
        'we':         3,
        'wed':        3,
        'wednesday':  3,
        'th':         4,
        'thu':        4,
        'thursday':   4,
        'fr':         5,
        'fri':        5,
        'friday':     5,
        'sa':         6,
        'sat':        6,
        'saturday':   6
    };
    monthsAll = monthsFull.concat(monthsAbbr);
    daysAll = [
        'su',
        'sun',
        'sunday',
        'mo',
        'mon',
        'monday',
        'tu',
        'tue',
        'tuesday',
        'we',
        'wed',
        'wednesday',
        'th',
        'thu',
        'thursday',
        'fr',
        'fri',
        'friday',
        'sa',
        'sat',
        'saturday'
    ];

    monthNames = {
        'jan':        0,
        'january':    0,
        'feb':        1,
        'february':   1,
        'mar':        2,
        'march':      2,
        'apr':        3,
        'april':      3,
        'may':        4,
        'jun':        5,
        'june':       5,
        'jul':        6,
        'july':       6,
        'aug':        7,
        'august':     7,
        'sep':        8,
        'september':  8,
        'oct':        9,
        'october':    9,
        'nov':        10,
        'november':   10,
        'dec':        11,
        'december':   11
    };

    var daysInMonth = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];


    // private helper functions
    /** @ignore */
    function pad(str, length) {
        str = String(str);
        while (str.length < length) {
            str = '0' + str;
        }
        return str;
    }

    var isInteger = function (str) {
        if (str.match(/^(\d+)$/)) {
            return true;
        }
        return false;
    };
    var getInt = function (str, i, minlength, maxlength) {
        for (var x = maxlength; x >= minlength; x--) {
            var token = str.substring(i, i + x);
            if (token.length < minlength) {
                return null;
            }
            if (isInteger(token)) {
                return token;
            }
        }
        return null;
    };

    // static class methods
    var origParse = Date.parse;
    // ------------------------------------------------------------------
    // getDateFromFormat( date_string , format_string )
    //
    // This function takes a date string and a format string. It matches
    // If the date string matches the format string, it returns the
    // getTime() of the date. If it does not match, it returns NaN.
    // Original Author: Matt Kruse <matt@mattkruse.com>
    // WWW: http://www.mattkruse.com/
    // Adapted from: http://www.mattkruse.com/javascript/date/source.html
    // ------------------------------------------------------------------


    var getDateFromFormat = function (val, format) {
        val = val + "";
        format = format + "";
        var iVal = 0;
        var iFormat = 0;
        var c = "";
        var token = "";
        var token2 = "";
        var x, y;
        var now = new Date();
        var year = now.getYear();
        var month = now.getMonth() + 1;
        var date = 1;
        var hh = 0;
        var mm = 0;
        var ss = 0;
        var ampm = "";



        while (iFormat < format.length) {
            // Get next token from format string
            c = format.charAt(iFormat);
            token = "";
            while ((format.charAt(iFormat) === c) && (iFormat < format.length)) {
                token += format.charAt(iFormat++);
            }
            // Extract contents of value based on format token
            if (token === "yyyy" || token === "yy" || token === "y") {
                if (token === "yyyy") {
                    x = 4;
                    y = 4;
                }
                if (token === "yy") {
                    x = 2;
                    y = 2;
                }
                if (token === "y") {
                    x = 2;
                    y = 4;
                }
                year = getInt(val, iVal, x, y);
                if (year === null) {
                    return NaN;
                }
                iVal += year.length;
                if (year.length === 2) {
                    if (year > 70) {
                        year = 1900 + (year - 0);
                    } else {
                        year = 2000 + (year - 0);
                    }
                }
            } else if (token === "MMM" || token === "NNN") {
                month = 0;
                for (var i = 0; i < monthsAll.length; i++) {
                    var monthName = monthsAll[i];
                    if (val.substring(iVal, iVal + monthName.length).toLowerCase() === monthName.toLowerCase()) {
                        if (token === "MMM" || (token === "NNN" && i > 11)) {
                            month = i + 1;
                            if (month > 12) {
                                month -= 12;
                            }
                            iVal += monthName.length;
                            break;
                        }
                    }
                }
                if ((month < 1) || (month > 12)) {
                    return NaN;
                }
            } else if (token === "EE" || token === "E") {
                for (var n = 0; n < daysAll.length; n++) {
                    var dayName = daysAll[n];
                    if (val.substring(iVal, iVal + dayName.length).toLowerCase() === dayName.toLowerCase()) {
                        iVal += dayName.length;
                        break;
                    }
                }
            } else if (token === "MM" || token === "M") {
                month = getInt(val, iVal, token.length, 2);
                if (month === null || (month < 1) || (month > 12)) {
                    return NaN;
                }
                iVal += month.length;
            } else if (token === "dd" || token === "d") {
                date = getInt(val, iVal, token.length, 2);
                if (date === null || (date < 1) || (date > 31)) {
                    return NaN;
                }
                iVal += date.length;
            } else if (token === "hh" || token === "h") {
                hh = getInt(val, iVal, token.length, 2);
                if (hh === null || (hh < 1) || (hh > 12)) {
                    return NaN;
                }
                iVal += hh.length;
            } else if (token === "HH" || token === "H") {
                hh = getInt(val, iVal, token.length, 2);
                if (hh === null || (hh < 0) || (hh > 23)) {
                    return NaN;
                }
                iVal += hh.length;
            } else if (token === "KK" || token === "K") {
                hh = getInt(val, iVal, token.length, 2);
                if (hh === null || (hh < 0) || (hh > 11)) {
                    return NaN;
                }
                iVal += hh.length;
            } else if (token === "kk" || token === "k") {
                hh = getInt(val, iVal, token.length, 2);
                if (hh === null || (hh < 1) || (hh > 24)) {
                    return NaN;
                }
                iVal += hh.length;
                hh--;
            } else if (token === "mm" || token === "m") {
                mm = getInt(val, iVal, token.length, 2);
                if (mm === null || (mm < 0) || (mm > 59)) {
                    return NaN;
                }
                iVal += mm.length;
            } else if (token === "ss" || token === "s") {
                ss = getInt(val, iVal, token.length, 2);
                if (ss === null || (ss < 0) || (ss > 59)) {
                    return NaN;
                }
                iVal += ss.length;
            } else if (token === "a") {
                if (val.substring(iVal, iVal + 2).toLowerCase() === "am") {
                    ampm = "AM";
                } else if (val.substring(iVal, iVal + 2).toLowerCase() === "pm") {
                    ampm = "PM";
                } else {
                    return NaN;
                }
                iVal += 2;
            } else {
                if (val.substring(iVal, iVal + token.length) !== token) {
                    return NaN;
                } else {
                    iVal += token.length;
                }
            }
        }
        // If there are any trailing characters left in the value, it doesn't match
        if (iVal !== val.length) {
            return NaN;
        }
        // Is date valid for month?
        if (month === 2) {
            // Check for leap year
            if (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) { // leap year
                if (date > 29) {
                    return NaN;
                }
            } else {
                if (date > 28) {
                    return NaN;
                }
            }
        }
        if ((month === 4) || (month === 6) || (month === 9) || (month === 11)) {
            if (date > 30) {
                return NaN;
            }
        }
        // Correct hours value
        if (hh < 12 && ampm === "PM") {
            hh = hh - 0 + 12;
        } else if (hh > 11 && ampm === "AM") {
            hh -= 12;
        }
        var newdate = new Date(year, month - 1, date, hh, mm, ss);
        return newdate.getTime();
    };


    /** @ignore */
    Date.parse = function (date, format) {
        if (format) {
            return getDateFromFormat(date, format);
        }
        var timestamp = origParse(date), minutesOffset = 0, match;
        if (isNaN(timestamp) && (match = /^(\d{4}|[+\-]\d{6})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?))?/.exec(date))) {
            if (match[8] !== 'Z') {
                minutesOffset = +match[10] * 60 + (+match[11]);

                if (match[9] === '+') {
                    minutesOffset = 0 - minutesOffset;
                }
            }

            match[7] = match[7] || '000';

            timestamp = Date.UTC(+match[1], +match[2] - 1, +match[3], +match[4], +match[5] + minutesOffset, +match[6], +match[7].substr(0, 3));
        }

        return timestamp;
    };

    function polyfill(name, func) {
        if (Date.prototype[name] === undefined) {
            Date.prototype[name] = func;
        }
    }

    /**
        Returns new instance of Date object with the date set to today and
        the time set to midnight
        @static
        @returns {Date} Today's Date
        @function today
        @memberof Date
     */
    Date.today = function () {
        return new Date().clearTime();
    };

    /**
        Returns new instance of Date object with the date set to today and
        the time set to midnight in UTC
        @static
        @returns {Date} Today's Date in UTC
        @function UTCtoday
        @memberof Date
     */
    Date.UTCtoday = function () {
        return new Date().clearUTCTime();
    };

    /**
        Returns new instance of Date object with the date set to tomorrow and
        the time set to midnight
        @static
        @returns {Date} Tomorrow's Date
        @function tomorrow
        @memberof Date
     */
    Date.tomorrow = function () {
        return Date.today().add({days: 1});
    };

    /**
        Returns new instance of Date object with the date set to tomorrow and
        the time set to midnight in UTC
        @static
        @returns {Date} Tomorrow's Date in UTC
        @function UTCtomorrow
        @memberof Date
     */
    Date.UTCtomorrow = function () {
        return Date.UTCtoday().add({days: 1});
    };

    /**
        Returns new instance of Date object with the date set to yesterday and
        the time set to midnight
        @static
        @returns {Date} Yesterday's Date
        @function yesterday
        @memberof Date
     */
    Date.yesterday = function () {
        return Date.today().add({days: -1});
    };

    /**
        Returns new instance of Date object with the date set to yesterday and
        the time set to midnight in UTC
        @static
        @returns {Date} Yesterday's Date in UTC
        @function UTCyesterday
        @memberof Date
     */
    Date.UTCyesterday = function () {
        return Date.UTCtoday().add({days: -1});
    };

   /**
       Returns whether the day is valid
       @static
       @param day {Number} day of the month
       @param year {Number} year
       @param month {Number} month of the year [0-11]
       @returns {Boolean}
       @function validateDay
       @memberof Date
    */
    Date.validateDay = function (day, year, month) {
        var date = new Date(year, month, day);
        return (date.getFullYear() === year &&
            date.getMonth() === month &&
            date.getDate() === day);
    };

    /**
       Returns whether the year is valid
       @static
       @param year {Number} year
       @returns {Boolean}
       @function validateYear
       @memberof Date
    */
    Date.validateYear = function (year) {
        return (year >= 0 && year <= 9999);
    };

    /**
       Returns whether the second is valid
       @static
       @param second {Number} second
       @returns {Boolean}
       @function validateSecond
       @memberof Date
    */
    Date.validateSecond = function (second) {
        return (second >= 0 && second < 60);
    };

    /**
       Returns whether the month is valid [0-11]
       @static
       @param month {Number} month
       @returns {Boolean}
       @function validateMonth
       @memberof Date
    */
    Date.validateMonth = function (month) {
        return (month >= 0 && month < 12);
    };

    /**
       Returns whether the minute is valid
       @static
       @param minute {Number} minute
       @returns {Boolean}
       @function validateMinute
       @memberof Date
    */
    Date.validateMinute = function (minute) {
        return (minute >= 0 && minute < 60);
    };

  /**
     Returns whether the millisecond is valid
     @static
     @param millisecond {Number} millisecond
     @returns {Boolean}
     @function validateMillisecond
     @memberof Date
  */
    Date.validateMillisecond = function (milli) {
        return (milli >= 0 && milli < 1000);
    };

    /**
       Returns whether the hour is valid [0-23]
       @static
       @param hour {Number} hour
       @returns {Boolean}
       @function validateHour
       @memberof Date
    */
    Date.validateHour = function (hour) {
        return (hour >= 0 && hour < 24);
    };

    /**
       Compares two dates
       @static
       @param date1 {Date} first date
       @param date2 {Date} second date
       @returns {Number} -1 if date1 is less than date2, 0 if they are equal, 1 if date1 is more than date2
       @function compare
       @memberof Date
    */
    Date.compare = function (date1, date2) {
        if (date1.valueOf() < date2.valueOf()) {
            return -1;
        } else if (date1.valueOf() > date2.valueOf()) {
            return 1;
        }
        return 0;
    };

    /**
       Compares two dates to the millisecond
       @static
       @param date1 {Date} first date
       @param date2 {Date} second date
       @returns {Boolean}
       @function equals
       @memberof Date
    */
    Date.equals = function (date1, date2) {
        return date1.valueOf() === date2.valueOf();
    };

    /**
       Compares two dates by day
       @static
       @param date1 {Date} first date
       @param date2 {Date} second date
       @returns {Boolean}
       @function equalsDay
       @memberof Date
    */
    Date.equalsDay = function (date1, date2) {
        return date1.toYMD() === date2.toYMD();
    };

    /**
       Returns the day number for a day [0-6]
       @static
       @param day {String} day name
       @returns {Number}
       @function getDayNumberFromName
       @memberof Date
    */
    Date.getDayNumberFromName = function (name) {
        return dayNames[name.toLowerCase()];
    };

    /**
       Returns the day number for a month [0-11]
       @static
       @param month {String} month name
       @returns {Number}
       @function getMonthNumberFromName
       @memberof Date
    */
    Date.getMonthNumberFromName = function (name) {
        return monthNames[name.toLowerCase()];
    };

    /**
       Returns the month name for a month [0-11]
       @static
       @param month {Number} month
       @returns {String}
       @function getMonthNameFromNumber
       @memberof Date
    */
    Date.getMonthNameFromNumber = function (number) {
        return monthsFull[number];
    };

    /**
       Returns the month name abbreviated for a month [0-11]
       @static
       @param month {Number} month
       @returns {String}
       @function getMonthAbbrFromNumber
       @memberof Date
    */
    Date.getMonthAbbrFromNumber = function (number) {
        return monthsAbbr[number];
    };

    /**
       Returns whether or not the year is a leap year
       @static
       @param year {Number} year
       @returns {Boolean}
       @function isLeapYear
       @memberof Date
    */
    Date.isLeapYear = function (year) {
        return (new Date(year, 1, 29).getDate() === 29);
    };

    /**
       Returns the number of days in a month
       @static
       @param year {Number} year
       @param month {Number} month
       @returns {Number}
       @function getDaysInMonth
       @memberof Date
    */
    Date.getDaysInMonth = function (year, month) {
        if (month === 1) {
            return Date.isLeapYear(year) ? 29 : 28;
        }
        return daysInMonth[month];
    };

    /**
       Returns the abbreviated month name
       @returns {String}
       @function getMonthAbbr
       @instance
       @memberof Date
    */
    polyfill('getMonthAbbr', function () {
        return monthsAbbr[this.getMonth()];
    });

    /**
       Returns the month name
       @returns {String}
       @function getMonthName
       @instance
       @memberof Date
    */
    polyfill('getMonthName', function () {
        return monthsFull[this.getMonth()];
    });

    /**
       Returns the name of last month
       @returns {String}
       @function getLastMonthName
       @instance
       @memberof Date
    */
    polyfill('getLastMonthName', function () {
        var i = this.getMonth();
        i = (i === 0 ? 11 : i - 1);
        return monthsFull[i];
    });

    /**
       Returns the current UTC office
       @returns {String}
       @function getUTCOffset
       @instance
       @memberof Date
    */
    polyfill('getUTCOffset', function () {
        var tz = pad(Math.abs(this.getTimezoneOffset() / 0.6), 4);
        if (this.getTimezoneOffset() > 0) {
            tz = '-' + tz;
        }
        return tz;
    });

    /**
       Returns a padded Common Log Format
       @returns {String}
       @function toCLFString
       @deprecated Will be deprecated in version 2.0 in favor of toFormat
       @instance
       @memberof Date
    */
    polyfill('toCLFString',  function () {
        return pad(this.getDate(), 2) + '/' + this.getMonthAbbr() + '/' +
               this.getFullYear() + ':' + pad(this.getHours(), 2) + ':' +
               pad(this.getMinutes(), 2) + ':' + pad(this.getSeconds(), 2) +
               ' ' + this.getUTCOffset();
    });

    /**
       Returns a padded Year/Month/Day
       @returns {String}
       @param separator {String} optional, defaults to "-"
       @function toYMD
       @deprecated Will be deprecated in version 2.0 in favor of toFormat
       @instance
       @memberof Date
    */
    polyfill('toYMD', function (separator) {
        separator = typeof separator === 'undefined' ? '-' : separator;
        return this.getFullYear() + separator + pad(this.getMonth() + 1, 2) +
            separator + pad(this.getDate(), 2);
    });

    /**
       Returns a formatted String for database insertion
       @returns {String}
       @function toDBString
       @deprecated Will be deprecated in version 2.0 in favor of toFormat
       @instance
       @memberof Date
    */
    polyfill('toDBString', function () {
        return this.getUTCFullYear() + '-' +  pad(this.getUTCMonth() + 1, 2) +
               '-' + pad(this.getUTCDate(), 2) + ' ' + pad(this.getUTCHours(), 2) +
               ':' + pad(this.getUTCMinutes(), 2) + ':' + pad(this.getUTCSeconds(), 2);
    });

    /**
       Sets the time to 00:00:00.0000 and returns a new Date object
       @returns {Date}
       @function clearTime
       @instance
       @memberof Date
    */
    polyfill('clearTime', function () {
        this.setHours(0);
        this.setMinutes(0);
        this.setSeconds(0);
        this.setMilliseconds(0);

        return this;
    });

    /**
       Sets the time to 00:00:00.0000 and returns a new Date object with set to UTC
       @returns {Date}
       @function clearUTCTime
       @instance
       @memberof Date
    */
    polyfill('clearUTCTime', function () {
        this.setUTCHours(0);
        this.setUTCMinutes(0);
        this.setUTCSeconds(0);
        this.setUTCMilliseconds(0);

        return this;
    });

    /**
       Adds `milliseconds`, `seconds`, `minutes`, `hours`, `days`, `weeks`, `months`, and `years` and returns a new Date.
       Usage: `data.add({ "seconds": 10, "days": 1 })`
       @param additions {Object}
       @returns {Date}
       @function add
       @instance
       @memberof Date
    */
    polyfill('add', function (obj) {
        if (obj.milliseconds !== undefined) {
            this.setMilliseconds(this.getMilliseconds() + obj.milliseconds);
        }
        if (obj.seconds !== undefined) {
            this.setSeconds(this.getSeconds() + obj.seconds);
        }
        if (obj.minutes !== undefined) {
            this.setMinutes(this.getMinutes() + obj.minutes);
        }
        if (obj.hours !== undefined) {
            this.setHours(this.getHours() + obj.hours);
        }
        if (obj.days !== undefined) {
            this.setDate(this.getDate() + obj.days);
        }
        if (obj.weeks !== undefined) {
            this.setDate(this.getDate() + (obj.weeks * 7));
        }
        if (obj.months !== undefined) {
            this.setMonth(this.getMonth() + obj.months);
        }
        if (obj.years !== undefined) {
            this.setFullYear(this.getFullYear() + obj.years);
        }
        return this;
    });

    /**
       Adds milliseconds to the Date and returns it
       @returns {Date}
       @param milliseconds {Number} Number of milliseconds to add
       @function addMilliseconds
       @deprecated Will be deprecated in version 2.0 in favor of add
       @instance
       @memberof Date
    */
    polyfill('addMilliseconds', function (milliseconds) {
        return this.add({ milliseconds: milliseconds });
    });

    /**
       Adds seconds to the Date and returns it
       @returns {Date}
       @param seconds {Number} Number of seconds to add
       @function addSeconds
       @deprecated Will be deprecated in version 2.0 in favor of add
       @instance
       @memberof Date
    */
    polyfill('addSeconds', function (seconds) {
        return this.add({ seconds: seconds });
    });

    /**
       Adds minutes to the Date and returns it
       @returns {Date}
       @param minutes {Number} Number of minutes to add
       @function addMinutes
       @deprecated Will be deprecated in version 2.0 in favor of add
       @instance
       @memberof Date
    */
    polyfill('addMinutes', function (minutes) {
        return this.add({ minutes: minutes });
    });

    /**
       Adds hours to the Date and returns it
       @returns {Date}
       @param hours {Number} Number of hours to add
       @function addHours
       @deprecated Will be deprecated in version 2.0 in favor of add
       @instance
       @memberof Date
    */
    polyfill('addHours', function (hours) {
        return this.add({ hours: hours });
    });

    /**
       Adds days to the Date and returns it
       @returns {Date}
       @param days {Number} Number of days to add
       @function addSeconds
       @deprecated Will be deprecated in version 2.0 in favor of add
       @instance
       @memberof Date
    */
    polyfill('addDays', function (days) {
        return this.add({ days: days });
    });

    /**
       Adds weeks to the Date and returns it
       @returns {Date}
       @param weeks {Number} Number of weeks to add
       @function addWeeks
       @deprecated Will be deprecated in version 2.0 in favor of add
       @instance
       @memberof Date
    */
    polyfill('addWeeks', function (weeks) {
        return this.add({ days: (weeks * 7) });
    });

    /**
       Adds months to the Date and returns it
       @returns {Date}
       @param months {Number} Number of months to add
       @function addMonths
       @deprecated Will be deprecated in version 2.0 in favor of add
       @instance
       @memberof Date
    */
    polyfill('addMonths', function (months) {
        return this.add({ months: months });
    });

    /**
       Adds years to the Date and returns it
       @returns {Date}
       @param years {Number} Number of years to add
       @function addYears
       @deprecated Will be deprecated in version 2.0 in favor of add
       @instance
       @memberof Date
    */
    polyfill('addYears', function (years) {
        return this.add({ years: years });
    });

    /**
       Removes `milliseconds`, `seconds`, `minutes`, `hours`, `days`, `weeks`, `months`, and `years` and returns a new Date.
       Usage: `data.remove({ "seconds": 10, "days": 1 })`
       @param removals {Object}
       @returns {Date}
       @function remove
       @instance
       @memberof Date
    */
    polyfill('remove', function (obj) {
        if (obj.seconds !== undefined) {
            this.setSeconds(this.getSeconds() - obj.seconds);
        }
        if (obj.minutes !== undefined) {
            this.setMinutes(this.getMinutes() - obj.minutes);
        }
        if (obj.hours !== undefined) {
            this.setHours(this.getHours() - obj.hours);
        }
        if (obj.days !== undefined) {
            this.setDate(this.getDate() - obj.days);
        }
        if (obj.weeks !== undefined) {
            this.setDate(this.getDate() - (obj.weeks * 7));
        }
        if (obj.months !== undefined) {
            this.setMonth(this.getMonth() - obj.months);
        }
        if (obj.years !== undefined) {
            this.setFullYear(this.getFullYear() - obj.years);
        }
        return this;
    });

    /**
       Removes milliseconds from the Date and returns it
       @returns {Date}
       @param milliseconds {Number} Number of millseconds to remove
       @function removeMilliseconds
       @deprecated Will be deprecated in version 2.0 in favor of remove
       @instance
       @memberof Date
    */
    polyfill('removeMilliseconds', function (milliseconds) {
        throw new Error('Not implemented');
    });

    /**
       Removes seconds from the Date and returns it
       @returns {Date}
       @param seconds {Number} Number of seconds to remove
       @function removeSeconds
       @deprecated Will be deprecated in version 2.0 in favor of remove
       @instance
       @memberof Date
    */
    polyfill('removeSeconds', function (seconds) {
        return this.remove({ seconds: seconds });
    });

    /**
       Removes minutes from the Date and returns it
       @returns {Date}
       @param seconds {Number} Number of minutes to remove
       @function removeMinutes
       @deprecated Will be deprecated in version 2.0 in favor of remove
       @instance
       @memberof Date
    */
    polyfill('removeMinutes', function (minutes) {
        return this.remove({ minutes: minutes });
    });

    /**
       Removes hours from the Date and returns it
       @returns {Date}
       @param hours {Number} Number of hours to remove
       @function removeHours
       @deprecated Will be deprecated in version 2.0 in favor of remove
       @instance
       @memberof Date
    */
    polyfill('removeHours', function (hours) {
        return this.remove({ hours: hours });
    });

    /**
       Removes days from the Date and returns it
       @returns {Date}
       @param days {Number} Number of days to remove
       @function removeDays
       @deprecated Will be deprecated in version 2.0 in favor of remove
       @instance
       @memberof Date
    */
    polyfill('removeDays', function (days) {
        return this.remove({ days: days });
    });

    /**
       Removes weeks from the Date and returns it
       @returns {Date}
       @param weeks {Number} Number of weeks to remove
       @function removeWeeks
       @deprecated Will be deprecated in version 2.0 in favor of remove
       @instance
       @memberof Date
    */
    polyfill('removeWeeks', function (weeks) {
        return this.remove({ days: (weeks * 7) });
    });

    /**
       Removes months from the Date and returns it
       @returns {Date}
       @param months {Number} Number of months to remove
       @function removeMonths
       @deprecated Will be deprecated in version 2.0 in favor of remove
       @instance
       @memberof Date
    */
    polyfill('removeMonths', function (months) {
        return this.remove({ months: months });
    });

    /**
       Removes years from the Date and returns it
       @returns {Date}
       @param years {Number} Number of years to remove
       @function removeYears
       @deprecated Will be deprecated in version 2.0 in favor of remove
       @instance
       @memberof Date
    */
    polyfill('removeYears', function (years) {
        return this.remove({ years: years });
    });

    /**
       Adds weekdays based on a Mon-Fri work schedule and returns it
       @returns {Date}
       @param weekdays {Number} Number of weekdays to add
       @function addWeekdays
       @instance
       @memberof Date
    */
    polyfill('addWeekdays', function (weekdays) {
        var day = this.getDay();
        if (day === 0) { day = 7; }
        var daysOffset = weekdays;
        var weekspan = Math.floor(( weekdays + day - 1 ) / 5.0);
        if (weekdays > 0){
            daysOffset += weekspan * 2;
            if ( day > 5 ) { daysOffset -= day - 5; }
        } else {
            daysOffset += Math.min( weekspan * 2, 0);
            if ( day > 6 ) { daysOffset -= 1; }
        }
        return this.addDays( daysOffset );
    });

    /**
       Sets the time and date to now
       @function setTimeToNow
       @instance
       @memberof Date
    */
    polyfill('setTimeToNow', function () {
        var n = new Date();
        this.setMilliseconds(n.getMilliseconds());
        this.setSeconds(n.getSeconds());
        this.setMinutes(n.getMinutes());
        this.setHours(n.getHours());
    });

    /**
       Returns a cloned copy of the current Date
       @function clone
       @instance
       @memberof Date
    */
    polyfill('clone', function () {
        return new Date(this.valueOf());
    });

    /**
       Returns whether this Date is between a start and end date
       @function between
       @returns {Boolean}
       @instance
       @memberof Date
    */
    polyfill('between', function (start, end) {
        return (this.valueOf() >= start.valueOf() &&
                this.valueOf() <= end.valueOf());
    });
    /**
       Compares a Date to this Date
       @param {Date} Date to compare to
       @function compareTo
       @returns {Number} -1 if less than date, 0 if they are equal, 1 if more than date
       @instance
       @memberof Date
    */
    polyfill('compareTo', function (date) {
        return Date.compare(this, date);
    });

    /**
       Compares a Date and time to this Date and time for equality
       @param {Date} Date to compare to
       @function equals
       @returns {Boolean}
       @instance
       @memberof Date
    */
    polyfill('equals', function (date) {
        return Date.equals(this, date);
    });

    /**
       Compares a Date to this Date for equality
       @param {Date} Date to compare to
       @function equalsDay
       @returns {Boolean}
       @instance
       @memberof Date
    */
    polyfill('equalsDay', function (date) {
        return Date.equalsDay(this, date);
    });

    /**
       Checks to see if the Date is today
       @function isToday
       @returns {Boolean}
       @instance
       @memberof Date
    */
    polyfill('isToday', function () {
        return Date.equalsDay(this, Date.today());
    });

    /**
       Compares a Date to this Date for to see if it is after the Date passed
       @param {Date} Date to compare to
       @function isAfter
       @returns {Boolean}
       @instance
       @memberof Date
    */
    polyfill('isAfter', function (date) {
        date = date ? date : new Date();
        return (this.compareTo(date) > 0);
    });

    /**
       Compares a Date to this Date for to see if it is before the Date passed
       @param {Date} Date to compare to
       @function isBefore
       @returns {Boolean}
       @instance
       @memberof Date
    */
    polyfill('isBefore', function (date) {
        date = date ? date : new Date();
        return (this.compareTo(date) < 0);
    });

    /**
       Returns `true` if the Date is a weekend using standard Saturday/Sunday definition of a weekend
       @function isWeekend
       @returns {Boolean}
       @instance
       @memberof Date
    */
    polyfill('isWeekend', function (date) {
        return (this.getDay() % 6 === 0);
    });

    /**
       Returns the number of days between this Date and the Date passed in
       @function getDaysBetween
       @param {Date} Date to compare to
       @returns {Number}
       @instance
       @memberof Date
    */
    polyfill('getDaysBetween', function (date) {
        return ((date.clone().valueOf() - this.valueOf()) / 86400000) | 0;
    });

    /**
       Returns the number of hours between this Date and the Date passed in
       @function getHoursBetween
       @param {Date} Date to compare to
       @returns {Number}
       @instance
       @memberof Date
    */
    polyfill('getHoursBetween', function (date) {
        return ((date.clone().valueOf() - this.valueOf()) / 3600000) | 0;
    });

    /**
       Returns the number of minutes between this Date and the Date passed in
       @function getMinutesBetween
       @param {Date} Date to compare to
       @returns {Number}
       @instance
       @memberof Date
    */
    polyfill('getMinutesBetween', function (date) {
        return ((date.clone().valueOf() - this.valueOf()) / 60000) | 0;
    });

    /**
       Returns the number of seconds between this Date and the Date passed in
       @function getSecondsBetween
       @param {Date} Date to compare to
       @returns {Number}
       @instance
       @memberof Date
    */
    polyfill('getSecondsBetween', function (date) {
        return ((date.clone().valueOf() - this.valueOf()) / 1000) | 0;
    });

    /**
       Returns the number of milliseconds between this Date and the Date passed in
       @function getMillisecondsBetween
       @param {Date} Date to compare to
       @returns {Number}
       @instance
       @memberof Date
    */
    polyfill('getMillisecondsBetween', function (date) {
        return ((date.clone().valueOf() - this.valueOf())) | 0;
    });

    /**
       Returns the number of months between this Date and the Date passed in
       @function getMonthsBetween
       @param {Date} Date to compare to
       @returns {Number}
       @instance
       @memberof Date
    */
    polyfill('getMonthsBetween', function (date) {
      var daysDiff = Math.abs(((+this) / (86400 * 1000)) - ((+date) / (86400 * 1000)));
      var start = new Date((+date) < (+this) ? (+date) : (+this));
      var end = new Date((date) > (+this) ? (+date) : (+this));

      var months = 0;
      while (+start < +end) {
        months++;
        start = start.addMonths(1);
      }

      var days = Math.abs(((+start) / (86400 * 1000)) - ((+end) / (86400 * 1000)));

      return months - (days / 31);
    });

    /**
       Returns the ordinal number of this Date
       @function getOrdinalNumber
       @returns {Number}
       @instance
       @memberof Date
    */
    polyfill('getOrdinalNumber', function () {
        return Math.ceil((this.clone().clearTime() - new Date(this.getFullYear(), 0, 1)) / 86400000) + 1;
    });

    /**
       Returns the a formatted version of this Date
       @function toFormat
       @param format {String} Format of the Date, using `YYYY`, `YY`, `MM`, `DD`, `HH`, `HH24`, `MI`, `SS`, etc
       @returns {String}
       @instance
       @memberof Date
    */
    polyfill('toFormat', function (format) {
        return toFormat(format, getReplaceMap(this));
    });

    /**
       Returns the a formatted version of the UTC version of this Date
       @function toUTCFormat
       @param format {String} Format of the Date, using `YYYY`, `YY`, `MM`, `DD`, `HH`, `HH24`, `MI`, `SS`, etc
       @returns {String}
       @instance
       @memberof Date
    */
    polyfill('toUTCFormat', function (format) {
        return toFormat(format, getUTCReplaceMap(this));
    });

    /**
       Returns the week number of this Date
       @function getWeekNumber
       @returns {Number}
       @instance
       @memberof Date
    */
    polyfill('getWeekNumber', function() {
        var onejan = new Date(this.getFullYear(),0,1);
        return Math.ceil((((this - onejan) / 86400000) + onejan.getDay()+1)/7);
    });

    /**
       Returns the week number of this Date, zero padded
       @function getFullWeekNumber
       @returns {Number}
       @instance
       @memberof Date
    */
    polyfill('getFullWeekNumber', function() {
        var weekNumber = '' + this.getWeekNumber();
        if (weekNumber.length === 1) {
            weekNumber = "0" + weekNumber;
        }

        return weekNumber;
    });

    var toFormat = function(format, replaceMap) {
        var f = [ format ], i, l, s;
        var replace = function (str, rep) {
            var i = 0, l = f.length, j, ll, t, n = [];
            for (; i < l; i++) {
                if (typeof f[i] == 'string') {
                    t = f[i].split(str);
                    for (j = 0, ll = t.length - 1; j < ll; j++) {
                        n.push(t[j]);
                        n.push([rep]); // replacement pushed as non-string
                    }
                    n.push(t[ll]);
                } else {
                    // must be a replacement, don't process, just push
                    n.push(f[i]);
                }
            }
            f = n;
        };

        for (i in replaceMap) {
            replace(i, replaceMap[i]);
        }

        s = '';
        for (i = 0, l = f.length; i < l; i++)
          s += typeof f[i] == 'string' ? f[i] : f[i][0];
        return f.join('');
    };

    var getReplaceMap = function(date) {
        var hours = (date.getHours() % 12) ? date.getHours() % 12 : 12;
        return {
            'YYYY': date.getFullYear(),
            'YY': String(date.getFullYear()).slice(-2),
            'MMMM': monthsFull[date.getMonth()],
            'MMM': monthsAbbr[date.getMonth()],
            'MM': pad(date.getMonth() + 1, 2),
            'MI': pad(date.getMinutes(), 2),
            'M': date.getMonth() + 1,
            'DDDD': daysFull[date.getDay()],
            'DDD': daysAbbr[date.getDay()],
            'DD': pad(date.getDate(), 2),
            'D': date.getDate(),
            'HH24': pad(date.getHours(), 2),
            'HH': pad(hours, 2),
            'H': hours,
            'SS': pad(date.getSeconds(), 2),
            'PP': (date.getHours() >= 12) ? 'PM' : 'AM',
            'P': (date.getHours() >= 12) ? 'pm' : 'am',
            'LL': pad(date.getMilliseconds(), 3)
        };
    };

    var getUTCReplaceMap = function(date) {
        var hours = (date.getUTCHours() % 12) ? date.getUTCHours() % 12 : 12;
        return {
            'YYYY': date.getUTCFullYear(),
            'YY': String(date.getUTCFullYear()).slice(-2),
            'MMMM': monthsFull[date.getUTCMonth()],
            'MMM': monthsAbbr[date.getUTCMonth()],
            'MM': pad(date.getUTCMonth() + 1, 2),
            'MI': pad(date.getUTCMinutes(), 2),
            'M': date.getUTCMonth() + 1,
            'DDDD': daysFull[date.getUTCDay()],
            'DDD': daysAbbr[date.getUTCDay()],
            'DD': pad(date.getUTCDate(), 2),
            'D': date.getUTCDate(),
            'HH24': pad(date.getUTCHours(), 2),
            'HH': pad(hours, 2),
            'H': hours,
            'SS': pad(date.getUTCSeconds(), 2),
            'PP': (date.getUTCHours() >= 12) ? 'PM' : 'AM',
            'P': (date.getUTCHours() >= 12) ? 'pm' : 'am',
            'LL': pad(date.getUTCMilliseconds(), 3)
        };
    };

    /*
     * change the language
     * @param lang => support "es" Spanish, "fr" french, "pt-BR" Portuguese Brazil
     * translate => diego
     */
    var language = function (lang) {
        if (lang == "es") {
            monthsAbbr = [
                'Ene',
                'Feb',
                'Mar',
                'Abr',
                'May',
                'Jun',
                'Jul',
                'Ago',
                'Sep',
                'Oct',
                'Nov',
                'Dic'
            ];

            monthsFull = [
                'Enero',
                'Febrero',
                'Marzo',
                'Abril',
                'Mayo',
                'Junio',
                'Julio',
                'Agosto',
                'Septiembre',
                'Octubre',
                'Noviembre',
                'Diciembre'
            ];

            daysAbbr = [
                'Dom',
                'Lun',
                'Mar',
                'Mie',
                'Jue',
                'Vie',
                'Sab'
            ];

            daysFull = [
                'Domingo',
                'Lunes',
                'Martes',
                'Miércoles',
                'Jueves',
                'Viernes',
                'Sábado'
            ];

            dayNames = {
                'do': 0,
                'dom': 0,
                'domingo': 0,
                'lu': 1,
                'lun': 1,
                'lunes': 1,
                'ma': 2,
                'mar': 2,
                'martes': 2,
                'mi': 3,
                'mie': 3,
                'miercoles': 3,
                'ju': 4,
                'jue': 4,
                'jueves': 4,
                'vi': 5,
                'vie': 5,
                'viernes': 5,
                'sa': 6,
                'sab': 6,
                'sabado': 6
            };
            monthsAll = monthsFull.concat(monthsAbbr);
            daysAll = [
                'do',
                'dom',
                'domingo',
                'lu',
                'lun',
                'lunes',
                'ma',
                'mar',
                'martes',
                'mi',
                'mie',
                'miércoles',
                'ju',
                'jue',
                'jueves',
                'vi',
                'vie',
                'viernes',
                'sa',
                'sab',
                'sábado'
            ];

            monthNames = {
                'ene': 0,
                'enero': 0,
                'feb': 1,
                'febrero': 1,
                'mar': 2,
                'marzo': 2,
                'abr': 3,
                'abril': 3,
                'may': 4,
                'mayo':4,
                'jun': 5,
                'junio': 5,
                'jul': 6,
                'julio': 6,
                'ago': 7,
                'agosto': 7,
                'sep': 8,
                'septiembre': 8,
                'oct': 9,
                'octubre': 9,
                'nov': 10,
                'noviembre': 10,
                'dic': 11,
                'diciembre': 11
            };
        } else if (lang == "fr") {
            monthsAbbr = [
                'Jan',
                'Fév',
                'Mar',
                'Avr',
                'Mai',
                'Jui',
                'Jul',
                'Aoû',
                'Sep',
                'Oct',
                'Nov',
                'Déc'
            ];

            monthsFull = [
                'Janvier',
                'Février',
                'Mars',
                'Avril',
                'Mai',
                'Juin',
                'Juillet',
                'Août',
                'Septembre',
                'Octobre',
                'Novembre',
                'Décembre'
            ];

            daysAbbr = [
                'Dim',
                'Lun',
                'Mar',
                'Mer',
                'Jeu',
                'Ven',
                'Sam'
            ];

            daysFull = [
                'Dimanchi',
                'Lundi',
                'Mardi',
                'Mercredi',
                'Jeudi',
                'Vendredi',
                'Samedi'
            ];

            dayNames = {
                'di': 0,
                'dim': 0,
                'dimanchi': 0,
                'lu': 1,
                'lun': 1,
                'lundi': 1,
                'ma': 2,
                'mar': 2,
                'mardi': 2,
                'me': 3,
                'mer': 3,
                'mercredi': 3,
                'je': 4,
                'jeu': 4,
                'jeudi': 4,
                've': 5,
                'ven': 5,
                'vendredi': 5,
                'sa': 6,
                'sam': 6,
                'samedi': 6
            };
            monthsAll = monthsFull.concat(monthsAbbr);
            daysAll = [
                'di',
                'dim',
                'dimanchi',
                'lu',
                'lun',
                'lundi',
                'ma',
                'mar',
                'mardi',
                'me',
                'mer',
                'mercredi',
                'je',
                'jeu',
                'jeudi',
                've',
                'ven',
                'vendredi',
                'sa',
                'sam',
                'samedi'
            ];

            monthNames = {
                'jan': 0,
                'janvier': 0,
                'fév': 1,
                'février': 1,
                'mar': 2,
                'mars': 2,
                'avr': 3,
                'avril': 3,
                'mai': 4,
                'jui': 5,
                'juin': 5,
                'jul': 6,
                'juillet': 6,
                'aoû': 7,
                'août': 7,
                'sep': 8,
                'septembre': 8,
                'oct': 9,
                'octobre': 9,
                'nov': 10,
                'novembre': 10,
                'déc': 11,
                'décembre': 11
            };
        } else if (lang == "pt-BR") {
            monthsAbbr = [
                'Jan',
                'Fev',
                'Mar',
                'Abr',
                'Mai',
                'Jun',
                'Jul',
                'Ago',
                'Set',
                'Out',
                'Nov',
                'Dez'
            ];

            monthsFull = [
                'Janeiro',
                'Fevereiro',
                'Março',
                'Abril',
                'Maio',
                'Junho',
                'Julho',
                'Agosto',
                'Setembro',
                'Outubro',
                'Novembro',
                'Dezembro'
            ];

            daysAbbr = [
                'Dom',
                'Seg',
                'Ter',
                'Qua',
                'Qui',
                'Sex',
                'Sab'
            ];

            daysFull = [
                'Domingo',
                'Segunda',
                'Terça',
                'Quarta',
                'Quinta',
                'Sexta',
                'Sábado'
            ];

            dayNames = {
                'do': 0,
                'dom': 0,
                'domingo': 0,
                'se': 1,
                'seg': 1,
                'segunda': 1,
                'te': 2,
                'ter': 2,
                'terca': 2,
                'qa': 3,
                'qua': 3,
                'quarta': 3,
                'qi': 4,
                'qui': 4,
                'quinta': 4,
                'se': 5,
                'sex': 5,
                'sexta': 5,
                'sa': 6,
                'sab': 6,
                'sabado': 6
            };
            monthsAll = monthsFull.concat(monthsAbbr);
            daysAll = [
                'do',
                'dom',
                'domingo',
                'se',
                'seg',
                'segunda',
                'te',
                'ter',
                'terça',
                'qa',
                'qua',
                'quarta',
                'qi',
                'qui',
                'quinta',
                'se',
                'sex',
                'sexta',
                'sa',
                'sab',
                'sábado'
            ];

            monthNames = {
                'jan': 0,
                'janeiro': 0,
                'fev': 1,
                'fevereiro': 1,
                'mar': 2,
                'março': 2,
                'abr': 3,
                'abril': 3,
                'mai': 4,
                'jun': 5,
                'junho': 5,
                'jul': 6,
                'julho': 6,
                'ago': 7,
                'agosto': 7,
                'set': 8,
                'setembro': 8,
                'out': 9,
                'outubro': 9,
                'nov': 10,
                'novembro': 10,
                'dez': 11,
                'dezembro': 11
            };
        }
    };

    // Are we being imported?..
    if (typeof module !== "undefined" && typeof module.exports === "object") {
        module.exports.language = language;
    } else if (typeof exports === "object") {
        exports.language = language;
    } else if (typeof Date.language === "undefined"){
        // ...if not and if no language, then add statically to Date (for browsers.)
        Date.language = language;
    }
}());

define("DateUtils", (function (global) {
    return function () {
        var ret, fn;
        return ret || global.DateUtils;
    };
}(this)));

define('polyfills',[
	'jquery',
	'lodash-compat'
], function ($, _) {

	if (!Object.prototype.watch) {
		Object.defineProperty(Object.prototype, 'watch', {
			enumerable: false,
			configurable: true,
			writable: false,
			value: function (prop, handler) {
				var oldval = this[prop],
					newval = oldval,
					getter = function () {
						return newval;
					},
					setter = function (val) {
						oldval = newval;
						newval = handler.call(this, prop, oldval, val);
						return newval;
					};

				if (delete this[prop]) { // can't watch constants
					Object.defineProperty(this, prop, {
						get: getter,
						set: setter,
						enumerable: true,
						configurable: true
					});
				}
			}
		});
	}

	// object.unwatch
	if (!Object.prototype.unwatch) {
		Object.defineProperty(Object.prototype, 'unwatch', {
			enumerable: false,
			configurable: true,
			writable: false,
			value: function (prop) {
				var val = this[prop];
				delete this[prop]; // remove accessors
				this[prop] = val;
			}
		});
	}

});

define('parseJSON',[], function () {

	return function (jsonString) {
		try {
			// http://stackoverflow.com/a/20392392
			var o = JSON.parse(jsonString);
			if (o && typeof o === 'object' && o !== null) {
				return o;
			}
		}
		catch (err) {
			console.error('parseJSON fail, err:', err.message, jsonString);
		}
		return false;
	};

});

!function(n,r){var e=n.define;e&&e.amd?e("rlite",[],r):"undefined"!=typeof module&&module.exports?module.exports=r():n.Rlite=r()}(this,function(){return function(){function n(n){return n}function r(n){return~n.indexOf("/?")&&(n=n.replace("/?","?")),"/"==n[0]&&(n=n.slice(1)),"/"==n[n.length-1]&&(n=n.slice(0,-1)),n}function e(n,r){for(var e=n.split("/"),t=o,i={},u=0;u<e.length&&t;++u){var a=r(e[u]);t=t[a.toLowerCase()]||t[":"],t&&t["~"]&&(i[t["~"]]=a)}return t&&{cb:t["@"],params:i}}function t(n,r,e){if(n&&r.cb)for(var t=n.indexOf("#"),i=(0>t?n:n.slice(0,t)).split("&"),o=0;o<i.length;++o){var u=i[o].split("=");r.params[u[0]]=e(u[1])}return r}function i(i){var o=r(i).split("?"),a=~i.indexOf("%")?u:n;return t(o[1],e(o[0],a)||{},a)}var o={},u=decodeURIComponent;return{add:function(n,r){for(var e=n.split("/"),t=o,i=0;i<e.length;++i){var u=e[i],a=":"==u[0]?":":u.toLowerCase();t=t[a]||(t[a]={}),":"==a&&(t["~"]=u.slice(1))}t["@"]=r},exists:function(n){return!!i(n).cb},lookup:i,run:function(n){var r=i(n);return r.cb&&r.cb({url:n,params:r.params}),!!r.cb}}}});
//# sourceMappingURL=rlite.min.js.map;
define("rlite", function(){});

define('router',[
	'lodash-compat',
	'ractive',
	'rlite',
	'jquery'
], function (_, Ractive, rlite, $) {
	Ractive.defaults._subs = Ractive.defaults._subs ? Ractive.defaults._subs : [];
	var r = rlite();

	// demo route
	r.add('foo/:bar', function () {
		console.log('arguments', arguments);
	});

	var suffux = '#';

	var router = {

		// Main router instance
		api: r,

		suffix: suffux,

		processHash: function () {
			var hash = location.hash || suffux;
			r.run(hash.slice(suffux.length));
		},

		isRoutingHash: function (hash) {
			hash = hash || location.hash;
			return _.includes(hash, suffux) && r.exists(hash.slice(suffux.length));
		},

		onDeepLinkChange: function (component, handler) {
			var alias = component.get('alias') || 'default';
			Ractive.defaults.on('dl', function (payload) {
				// Filter out to find targeted component with required alias
				// and exute handler for each match
				_(payload)
					.filter('params.alias', alias)
					.map(handler)
					.value();
			});
		},

		fireDeepLinkChange: function (payload) {
			Ractive.defaults.fire('dl', payload);
		},

		updateHash: function (params) {
			var hashArray = [];
			params.type ? hashArray.push(params.type) : '';
			params.alias ? hashArray.push(params.alias) : '';
			params.target ? hashArray.push(params.target) : '';
			window.location.hash = hashArray.join('/');
		},

		scrollTo: function (target, speed) {

			speed = speed || 250;

			// Give priority to css selector first for specificity
			var $target = $(target);

			if (!$target.length) {
				// Fallback to the name attribute to find anchor if no element found with target id
				// More or anchors: https://www.w3.org/TR/html4/struct/links.html#h-12.2.3
				$target = $('[name="' + target.replace(/!|#/g, '') + '"]');
			}

			if (!$target.offset()) {
				return;
			}

			$('html, body').animate({
				scrollTop: $target.offset().top
			}, speed);

		}

	};

	window.addEventListener('hashchange', router.processHash);
	Ractive.defaults.on('process-explicit-hash', router.processHash.bind(router));
	return router;

});

/*! store2 - v2.3.2 - 2015-10-27
* Copyright (c) 2015 Nathan Bubna; Licensed MIT, GPL */
;(function(window, define) {
    var _ = {
        version: "2.3.2",
        areas: {},
        apis: {},

        // utilities
        inherit: function(api, o) {
            for (var p in api) {
                if (!o.hasOwnProperty(p)) {
                    o[p] = api[p];
                }
            }
            return o;
        },
        stringify: function(d) {
            return d === undefined || typeof d === "function" ? d+'' : JSON.stringify(d);
        },
        parse: function(s) {
            // if it doesn't parse, return as is
            try{ return JSON.parse(s); }catch(e){ return s; }
        },

        // extension hooks
        fn: function(name, fn) {
            _.storeAPI[name] = fn;
            for (var api in _.apis) {
                _.apis[api][name] = fn;
            }
        },
        get: function(area, key){ return area.getItem(key); },
        set: function(area, key, string){ area.setItem(key, string); },
        remove: function(area, key){ area.removeItem(key); },
        key: function(area, i){ return area.key(i); },
        length: function(area){ return area.length; },
        clear: function(area){ area.clear(); },

        // core functions
        Store: function(id, area, namespace) {
            var store = _.inherit(_.storeAPI, function(key, data, overwrite) {
                if (arguments.length === 0){ return store.getAll(); }
                if (data !== undefined){ return store.set(key, data, overwrite); }
                if (typeof key === "string" || typeof key === "number"){ return store.get(key); }
                if (!key){ return store.clear(); }
                return store.setAll(key, data);// overwrite=data, data=key
            });
            store._id = id;
            try {
                var testKey = '_safariPrivate_';
                area.setItem(testKey, 'sucks');
                store._area = area;
                area.removeItem(testKey);
            } catch (e) {}
            if (!store._area) {
                store._area = _.inherit(_.storageAPI, { items: {}, name: 'fake' });
            }
            store._ns = namespace || '';
            if (!_.areas[id]) {
                _.areas[id] = store._area;
            }
            if (!_.apis[store._ns+store._id]) {
                _.apis[store._ns+store._id] = store;
            }
            return store;
        },
        storeAPI: {
            // admin functions
            area: function(id, area) {
                var store = this[id];
                if (!store || !store.area) {
                    store = _.Store(id, area, this._ns);//new area-specific api in this namespace
                    if (!this[id]){ this[id] = store; }
                }
                return store;
            },
            namespace: function(namespace, noSession) {
                if (!namespace){
                    return this._ns ? this._ns.substring(0,this._ns.length-1) : '';
                }
                var ns = namespace, store = this[ns];
                if (!store || !store.namespace) {
                    store = _.Store(this._id, this._area, this._ns+ns+'.');//new namespaced api
                    if (!this[ns]){ this[ns] = store; }
                    if (!noSession){ store.area('session', _.areas.session); }
                }
                return store;
            },
            isFake: function(){ return this._area.name === 'fake'; },
            toString: function() {
                return 'store'+(this._ns?'.'+this.namespace():'')+'['+this._id+']';
            },

            // storage functions
            has: function(key) {
                if (this._area.has) {
                    return this._area.has(this._in(key));//extension hook
                }
                return !!(this._in(key) in this._area);
            },
            size: function(){ return this.keys().length; },
            each: function(fn, and) {
                for (var i=0, m=_.length(this._area); i<m; i++) {
                    var key = this._out(_.key(this._area, i));
                    if (key !== undefined) {
                        if (fn.call(this, key, and || this.get(key)) === false) {
                            break;
                        }
                    }
                    if (m > _.length(this._area)) { m--; i--; }// in case of removeItem
                }
                return and || this;
            },
            keys: function() {
                return this.each(function(k, list){ list.push(k); }, []);
            },
            get: function(key, alt) {
                var s = _.get(this._area, this._in(key));
                return s !== null ? _.parse(s) : alt || s;// support alt for easy default mgmt
            },
            getAll: function() {
                return this.each(function(k, all){ all[k] = this.get(k); }, {});
            },
            set: function(key, data, overwrite) {
                var d = this.get(key);
                if (d != null && overwrite === false) {
                    return data;
                }
                return _.set(this._area, this._in(key), _.stringify(data), overwrite) || d;
            },
            setAll: function(data, overwrite) {
                var changed, val;
                for (var key in data) {
                    val = data[key];
                    if (this.set(key, val, overwrite) !== val) {
                        changed = true;
                    }
                }
                return changed;
            },
            remove: function(key) {
                var d = this.get(key);
                _.remove(this._area, this._in(key));
                return d;
            },
            clear: function() {
                if (!this._ns) {
                    _.clear(this._area);
                } else {
                    this.each(function(k){ _.remove(this._area, this._in(k)); }, 1);
                }
                return this;
            },
            clearAll: function() {
                var area = this._area;
                for (var id in _.areas) {
                    if (_.areas.hasOwnProperty(id)) {
                        this._area = _.areas[id];
                        this.clear();
                    }
                }
                this._area = area;
                return this;
            },

            // internal use functions
            _in: function(k) {
                if (typeof k !== "string"){ k = _.stringify(k); }
                return this._ns ? this._ns + k : k;
            },
            _out: function(k) {
                return this._ns ?
                    k && k.indexOf(this._ns) === 0 ?
                        k.substring(this._ns.length) :
                        undefined : // so each() knows to skip it
                    k;
            }
        },// end _.storeAPI
        storageAPI: {
            length: 0,
            has: function(k){ return this.items.hasOwnProperty(k); },
            key: function(i) {
                var c = 0;
                for (var k in this.items){
                    if (this.has(k) && i === c++) {
                        return k;
                    }
                }
            },
            setItem: function(k, v) {
                if (!this.has(k)) {
                    this.length++;
                }
                this.items[k] = v;
            },
            removeItem: function(k) {
                if (this.has(k)) {
                    delete this.items[k];
                    this.length--;
                }
            },
            getItem: function(k){ return this.has(k) ? this.items[k] : null; },
            clear: function(){ for (var k in this.list){ this.removeItem(k); } },
            toString: function(){ return this.length+' items in '+this.name+'Storage'; }
        }// end _.storageAPI
    };

    // setup the primary store fn
    if (window.store){ _.conflict = window.store; }
    var store =
        // safely set this up (throws error in IE10/32bit mode for local files)
        _.Store("local", (function(){try{ return localStorage; }catch(e){}})());
    store.local = store;// for completeness
    store._ = _;// for extenders and debuggers...
    // safely setup store.session (throws exception in FF for file:/// urls)
    store.area("session", (function(){try{ return sessionStorage; }catch(e){}})());

    //Expose store to the global object
    window.store = store;

    if (typeof define === 'function' && define.amd !== undefined) {
        define('store',[],function () {
            return store;
        });
    } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = store;
    }

})(this, this.define);

define('storage',[
	'lodash-compat',
	'store'
], function (_, store) {

	var storage = {
		namespace: function (namespace) {
			// namespacing everything under 'lux:' prefix
			return store.namespace('lux:' + namespace);
		},
		global: store,
		window: {
			get: function (name) {
				return _.get(window, 'lux-' + name);
			},
			set: function (name, value) {
				_.set(window, 'lux-' + name, value);
			}
		}
	};

	return storage;

});

define('ICS',[], function () {

	var ics = function(uidDomain, prodId) {
	  'use strict';

	  if (navigator.userAgent.indexOf('MSIE') > -1 && navigator.userAgent.indexOf('MSIE 10') == -1) {
	    console.log('Unsupported Browser');
	    return;
	  }

	  if (typeof uidDomain === 'undefined') { uidDomain = 'default'; }
	  if (typeof prodId === 'undefined') { prodId = 'Calendar'; }

	  var SEPARATOR = (navigator.appVersion.indexOf('Win') !== -1) ? '\r\n' : '\n';
	  var calendarEvents = [];
	  var calendarStart = [
	    'BEGIN:VCALENDAR',
	    'PRODID:' + prodId,
	    'VERSION:2.0'
	  ].join(SEPARATOR);
	  var calendarEnd = SEPARATOR + 'END:VCALENDAR';
	  var BYDAY_VALUES = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

	  return {
	    /**
	     * Returns events array
	     * @return {array} Events
	     */
	    'events': function() {
	      return calendarEvents;
	    },

	    /**
	     * Returns calendar
	     * @return {string} Calendar in iCalendar format
	     */
	    'calendar': function() {
	      return calendarStart + SEPARATOR + calendarEvents.join(SEPARATOR) + calendarEnd;
	    },

	    /**
	     * Add event to the calendar
	     * @param  {string} subject     Subject/Title of event
	     * @param  {string} description Description of event
	     * @param  {string} location    Location of event
	     * @param  {string} begin       Beginning date of event
	     * @param  {string} stop        Ending date of event
	     */
	    'addEvent': function(subject, description, location, begin, stop, rrule) {
	      // I'm not in the mood to make these optional... So they are all required
	      if (typeof subject === 'undefined' ||
	        typeof description === 'undefined' ||
	        typeof location === 'undefined' ||
	        typeof begin === 'undefined' ||
	        typeof stop === 'undefined'
	      ) {
	        return false;
	      }

	      // validate rrule
	      if (rrule) {
	        if (!rrule.rrule) {
	          if (rrule.freq !== 'YEARLY' && rrule.freq !== 'MONTHLY' && rrule.freq !== 'WEEKLY' && rrule.freq !== 'DAILY') {
	            throw "Recurrence rrule frequency must be provided and be one of the following: 'YEARLY', 'MONTHLY', 'WEEKLY', or 'DAILY'";
	          }

	          if (rrule.until) {
	            if (isNaN(Date.parse(rrule.until))) {
	              throw "Recurrence rrule 'until' must be a valid date string";
	            }
	          }

	          if (rrule.interval) {
	            if (isNaN(parseInt(rrule.interval))) {
	              throw "Recurrence rrule 'interval' must be an integer";
	            }
	          }

	          if (rrule.count) {
	            if (isNaN(parseInt(rrule.count))) {
	              throw "Recurrence rrule 'count' must be an integer";
	            }
	          }

	          if (typeof rrule.byday !== 'undefined') {
	            if ((Object.prototype.toString.call(rrule.byday) !== '[object Array]')) {
	              throw "Recurrence rrule 'byday' must be an array";
	            }

	            if (rrule.byday.length > 7) {
	              throw "Recurrence rrule 'byday' array must not be longer than the 7 days in a week";
	            }

	            // Filter any possible repeats
	            rrule.byday = rrule.byday.filter(function(elem, pos) {
	              return rrule.byday.indexOf(elem) == pos;
	            });

	            for (var d in rrule.byday) {
	              if (BYDAY_VALUES.indexOf(rrule.byday[d]) < 0) {
	                throw "Recurrence rrule 'byday' values must include only the following: 'SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'";
	              }
	            }
	          }
	        }
	      }

	      //TODO add time and time zone? use moment to format?
	      var start_date = new Date(begin);
	      var end_date = new Date(stop);
	      var now_date = new Date();

	      var start_year = ("0000" + (start_date.getFullYear().toString())).slice(-4);
	      var start_month = ("00" + ((start_date.getMonth() + 1).toString())).slice(-2);
	      var start_day = ("00" + ((start_date.getDate()).toString())).slice(-2);
	      var start_hours = ("00" + (start_date.getHours().toString())).slice(-2);
	      var start_minutes = ("00" + (start_date.getMinutes().toString())).slice(-2);
	      var start_seconds = ("00" + (start_date.getSeconds().toString())).slice(-2);

	      var end_year = ("0000" + (end_date.getFullYear().toString())).slice(-4);
	      var end_month = ("00" + ((end_date.getMonth() + 1).toString())).slice(-2);
	      var end_day = ("00" + ((end_date.getDate()).toString())).slice(-2);
	      var end_hours = ("00" + (end_date.getHours().toString())).slice(-2);
	      var end_minutes = ("00" + (end_date.getMinutes().toString())).slice(-2);
	      var end_seconds = ("00" + (end_date.getSeconds().toString())).slice(-2);

	      var now_year = ("0000" + (now_date.getFullYear().toString())).slice(-4);
	      var now_month = ("00" + ((now_date.getMonth() + 1).toString())).slice(-2);
	      var now_day = ("00" + ((now_date.getDate()).toString())).slice(-2);
	      var now_hours = ("00" + (now_date.getHours().toString())).slice(-2);
	      var now_minutes = ("00" + (now_date.getMinutes().toString())).slice(-2);
	      var now_seconds = ("00" + (now_date.getSeconds().toString())).slice(-2);

	      // Since some calendars don't add 0 second events, we need to remove time if there is none...
	      var start_time = '';
	      var end_time = '';
	      if (start_hours + start_minutes + start_seconds + end_hours + end_minutes + end_seconds != 0) {
	        start_time = 'T' + start_hours + start_minutes + start_seconds;
	        end_time = 'T' + end_hours + end_minutes + end_seconds;
	      }
	      var now_time = 'T' + now_hours + now_minutes + now_seconds;

	      var start = start_year + start_month + start_day + start_time;
	      var end = end_year + end_month + end_day + end_time;
	      var now = now_year + now_month + now_day + now_time;

	      // recurrence rrule vars
	      var rruleString;
	      if (rrule) {
	        if (rrule.rrule) {
	          rruleString = rrule.rrule;
	        } else {
	          rruleString = 'rrule:FREQ=' + rrule.freq;

	          if (rrule.until) {
	            var uDate = new Date(Date.parse(rrule.until)).toISOString();
	            rruleString += ';UNTIL=' + uDate.substring(0, uDate.length - 13).replace(/[-]/g, '') + '000000Z';
	          }

	          if (rrule.interval) {
	            rruleString += ';INTERVAL=' + rrule.interval;
	          }

	          if (rrule.count) {
	            rruleString += ';COUNT=' + rrule.count;
	          }

	          if (rrule.byday && rrule.byday.length > 0) {
	            rruleString += ';BYDAY=' + rrule.byday.join(',');
	          }
	        }
	      }

	      var stamp = new Date().toISOString();

	      var calendarEvent = [
	        'BEGIN:VEVENT',
	        'UID:' + calendarEvents.length + "@" + uidDomain,
	        'CLASS:PUBLIC',
	        'DESCRIPTION:' + description,
	        'DTSTAMP;VALUE=DATE-TIME:' + now,
	        'DTSTART;VALUE=DATE-TIME:' + start,
	        'DTEND;VALUE=DATE-TIME:' + end,
	        'LOCATION:' + location,
	        'SUMMARY;LANGUAGE=en-us:' + subject,
	        'TRANSP:TRANSPARENT',
	        'END:VEVENT'
	      ];

	      if (rruleString) {
	        calendarEvent.splice(4, 0, rruleString);
	      }

	      calendarEvent = calendarEvent.join(SEPARATOR);

	      calendarEvents.push(calendarEvent);
	      return calendarEvent;
	    },

	    /**
	     * Download calendar using the saveAs function from filesave.js
	     * @param  {string} filename Filename
	     * @param  {string} ext      Extention
	     */
	    'download': function(filename, ext) {
	      if (calendarEvents.length < 1) {
	        return false;
	      }

	      ext = (typeof ext !== 'undefined') ? ext : '.ics';
	      filename = (typeof filename !== 'undefined') ? filename : 'calendar';
	      var calendar = calendarStart + SEPARATOR + calendarEvents.join(SEPARATOR) + calendarEnd;

	      var blob;
	      if (navigator.userAgent.indexOf('MSIE 10') === -1) { // chrome or firefox
	        blob = new Blob([calendar]);
	      } else { // ie
	        var bb = new BlobBuilder();
	        bb.append(calendar);
	        blob = bb.getBlob('text/x-vCalendar;charset=' + document.characterSet);
	      }
	      saveAs(blob, filename + ext);
	      return calendar;
	    },

	    /**
	     * Build and return the ical contents
	     */
	    'build': function() {
	      if (calendarEvents.length < 1) {
	        return false;
	      }

	      var calendar = calendarStart + SEPARATOR + calendarEvents.join(SEPARATOR) + calendarEnd;

	      return calendar;
	    }
	  };
	};

	return ics;
});
define('ICSListener',[], function () {

	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;

				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}

				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";

				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}

		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;

		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;

		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window

	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if ((typeof define !== "undefined" && define !== null) && (define.amd !== null)) {
	  define("FileSaver.js", [],function() {
	    return saveAs;
	  });
	}

	return saveAs;

});

define('PasswordStrength',[], function () {
	return {
		passwordStrengthCheck: function (pwdString) {
			var pwdStrength         = 0,
				pwdNumber           = false,
				pwdUpperCase        = false,
				pwdLowerCase        = false,
				pwdSpecialCharacter = false;

			if (!pwdString) {
				return pwdStrength;
			}
			if (/[A-Z]+/.test(pwdString)) {
				pwdUpperCase = true;
			}
			if (/[a-z]+/.test(pwdString)) {
				pwdLowerCase = true;
			}
			if (/[0-9]+/.test(pwdString)) {
				pwdNumber = true;
			}
			if (/[\W]+/.test(pwdString)) {
				pwdSpecialCharacter = true;
			}

			if (pwdNumber && (pwdLowerCase || pwdUpperCase)) {
				pwdStrength += 1;
				if (pwdNumber && pwdLowerCase && pwdUpperCase) {
					pwdStrength += 1;
					if (pwdString.length >= 8) {
						pwdStrength += 1;
						if (pwdSpecialCharacter) {
							pwdStrength += 1;
							if (pwdString.length >= 10) {
								pwdStrength += 1;
							}
						}
					}
				}
			}

			return pwdStrength;
		}
	};

});

define('CapslockWarning',[], function () {
	return {
		message: function (event) {
			var eventOriginal     = event.original,
				keyCode           = eventOriginal.keyCode || eventOriginal.charCode,
				characterFromCode = String.fromCharCode(keyCode);
			if (characterFromCode.toUpperCase() === characterFromCode &&
				characterFromCode.toLowerCase() !== characterFromCode && !eventOriginal.shiftKey) {
				return 'Caps Lock is on!';
			} else {
				return '';
			}
		}
	};
});

/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */

;(function (name, context, factory) {
    var matchMedia = window.matchMedia;

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = factory(matchMedia);
    }
    else if (typeof define === 'function' && define.amd) {
        define('enquire',[],function() {
            return (context[name] = factory(matchMedia));
        });
    }
    else {
        context[name] = factory(matchMedia);
    }
}('enquire', this, function (matchMedia) {

    'use strict';

    /*jshint unused:false */
    /**
     * Helper function for iterating over a collection
     *
     * @param collection
     * @param fn
     */
    function each(collection, fn) {
        var i      = 0,
            length = collection.length,
            cont;

        for(i; i < length; i++) {
            cont = fn(collection[i], i);
            if(cont === false) {
                break; //allow early exit
            }
        }
    }

    /**
     * Helper function for determining whether target object is an array
     *
     * @param target the object under test
     * @return {Boolean} true if array, false otherwise
     */
    function isArray(target) {
        return Object.prototype.toString.apply(target) === '[object Array]';
    }

    /**
     * Helper function for determining whether target object is a function
     *
     * @param target the object under test
     * @return {Boolean} true if function, false otherwise
     */
    function isFunction(target) {
        return typeof target === 'function';
    }

    /**
     * Delegate to handle a media query being matched and unmatched.
     *
     * @param {object} options
     * @param {function} options.match callback for when the media query is matched
     * @param {function} [options.unmatch] callback for when the media query is unmatched
     * @param {function} [options.setup] one-time callback triggered the first time a query is matched
     * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
     * @constructor
     */
    function QueryHandler(options) {
        this.options = options;
        !options.deferSetup && this.setup();
    }
    QueryHandler.prototype = {

        /**
         * coordinates setup of the handler
         *
         * @function
         */
        setup : function() {
            if(this.options.setup) {
                this.options.setup();
            }
            this.initialised = true;
        },

        /**
         * coordinates setup and triggering of the handler
         *
         * @function
         */
        on : function() {
            !this.initialised && this.setup();
            this.options.match && this.options.match();
        },

        /**
         * coordinates the unmatch event for the handler
         *
         * @function
         */
        off : function() {
            this.options.unmatch && this.options.unmatch();
        },

        /**
         * called when a handler is to be destroyed.
         * delegates to the destroy or unmatch callbacks, depending on availability.
         *
         * @function
         */
        destroy : function() {
            this.options.destroy ? this.options.destroy() : this.off();
        },

        /**
         * determines equality by reference.
         * if object is supplied compare options, if function, compare match callback
         *
         * @function
         * @param {object || function} [target] the target for comparison
         */
        equals : function(target) {
            return this.options === target || this.options.match === target;
        }

    };
    /**
     * Represents a single media query, manages it's state and registered handlers for this query
     *
     * @constructor
     * @param {string} query the media query string
     * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
     */
    function MediaQuery(query, isUnconditional) {
        this.query = query;
        this.isUnconditional = isUnconditional;
        this.handlers = [];
        this.mql = matchMedia(query);

        var self = this;
        this.listener = function(mql) {
            self.mql = mql;
            self.assess();
        };
        this.mql.addListener(this.listener);
    }
    MediaQuery.prototype = {

        /**
         * add a handler for this query, triggering if already active
         *
         * @param {object} handler
         * @param {function} handler.match callback for when query is activated
         * @param {function} [handler.unmatch] callback for when query is deactivated
         * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
         * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
         */
        addHandler : function(handler) {
            var qh = new QueryHandler(handler);
            this.handlers.push(qh);

            this.matches() && qh.on();
        },

        /**
         * removes the given handler from the collection, and calls it's destroy methods
         *
         * @param {object || function} handler the handler to remove
         */
        removeHandler : function(handler) {
            var handlers = this.handlers;
            each(handlers, function(h, i) {
                if(h.equals(handler)) {
                    h.destroy();
                    return !handlers.splice(i,1); //remove from array and exit each early
                }
            });
        },

        /**
         * Determine whether the media query should be considered a match
         *
         * @return {Boolean} true if media query can be considered a match, false otherwise
         */
        matches : function() {
            return this.mql.matches || this.isUnconditional;
        },

        /**
         * Clears all handlers and unbinds events
         */
        clear : function() {
            each(this.handlers, function(handler) {
                handler.destroy();
            });
            this.mql.removeListener(this.listener);
            this.handlers.length = 0; //clear array
        },

        /*
         * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
         */
        assess : function() {
            var action = this.matches() ? 'on' : 'off';

            each(this.handlers, function(handler) {
                handler[action]();
            });
        }
    };
    /**
     * Allows for registration of query handlers.
     * Manages the query handler's state and is responsible for wiring up browser events
     *
     * @constructor
     */
    function MediaQueryDispatch () {
        if(!matchMedia) {
            throw new Error('matchMedia not present, legacy browsers require a polyfill');
        }

        this.queries = {};
        this.browserIsIncapable = !matchMedia('only all').matches;
    }

    MediaQueryDispatch.prototype = {

        /**
         * Registers a handler for the given media query
         *
         * @param {string} q the media query
         * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
         * @param {function} options.match fired when query matched
         * @param {function} [options.unmatch] fired when a query is no longer matched
         * @param {function} [options.setup] fired when handler first triggered
         * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
         * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
         */
        register : function(q, options, shouldDegrade) {
            var queries         = this.queries,
                isUnconditional = shouldDegrade && this.browserIsIncapable;

            if(!queries[q]) {
                queries[q] = new MediaQuery(q, isUnconditional);
            }

            //normalise to object in an array
            if(isFunction(options)) {
                options = { match : options };
            }
            if(!isArray(options)) {
                options = [options];
            }
            each(options, function(handler) {
                if (isFunction(handler)) {
                    handler = { match : handler };
                }
                queries[q].addHandler(handler);
            });

            return this;
        },

        /**
         * unregisters a query and all it's handlers, or a specific handler for a query
         *
         * @param {string} q the media query to target
         * @param {object || function} [handler] specific handler to unregister
         */
        unregister : function(q, handler) {
            var query = this.queries[q];

            if(query) {
                if(handler) {
                    query.removeHandler(handler);
                }
                else {
                    query.clear();
                    delete this.queries[q];
                }
            }

            return this;
        }
    };

    return new MediaQueryDispatch();

}));
/* this is taken from
	http://ifandelse.com/its-not-hard-making-your-library-support-amd-and-commonjs/ */
(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		// Now we're wrapping the factory and assigning the return
		// value to the root (window) and returning it as well to
		// the AMD loader.
		define('parallaxDecorator',['parallaxDecorator'], function (parallaxDecorator) {
			return (root.parallaxDecorator = factory(parallaxDecorator));
		});
	} else if (typeof module === 'object' && module.exports) {
		// I've not encountered a need for this yet, since I haven't
		// run into a scenario where plain modules depend on CommonJS
		// *and* I happen to be loading in a CJS browser environment
		// but I'm including it for the sake of being thorough
		module.exports = (root.myModule = factory(require('parallaxDecorator')));
	} else {
		root.parallaxDecorator = factory(root.parallaxDecorator);
	}
}(this, function (parallaxDecorator) {
	// module code here....

	var parallaxDecorator = function (node) {
		var handlers, eventName, scrollHandler;
		var parallaxBg = function () {

			//0% is when rect.top = 0;
			//50% is when rect.top = (browserHeight/2) - (displayHeight/2);
			//100% is when rect.top = browserHeight

			var bg = node,//this.ractive.find('.bg'),
				actualHeight = bg.getBoundingClientRect().height,
				displayHeight = bg.offsetHeight,
				diff = (actualHeight - displayHeight),
				browserHeight = isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight,
				rect = node.parentNode.getBoundingClientRect();

			bg.classList.add('is-parallaxBg');

			if ((rect.top < browserHeight && (rect.top > -displayHeight))) {
				var pcnt = ((rect.top + displayHeight) / (browserHeight + displayHeight));
				bg.style.top =  (-diff / 2) + ((diff) * pcnt) + 'px';
			}
		};


		window.addEventListener('scroll', scrollHandler = function () {
			parallaxBg();
		}.bind(this), false);

		// Create some event handlers. NB we can use addEventListener
		// with impunity, even in old IE, by using a legacy build:
		// https://docs.ractivejs.org/latest/Legacy-builds
		handlers = {
			// mouseover: function () {
			// 	console.log('SEEMS TO BE WORKING', parallax);
			// }
		};

		// Add event handlers to the node
		for (eventName in handlers) {
			if (handlers.hasOwnProperty(eventName)) {
				node.addEventListener(eventName, handlers[eventName], false);
			}
		}

		//this is a hack as the height isn't immediately available
		var count = 0,
			heightRegistered =
				setInterval(
					function () {
						if (node.offsetHeight > 0 || count >= 1300) {
							clearInterval(heightRegistered);
							parallaxBg();
						}
						count++;
					}.bind(this), 10);

		// Return an object with a `teardown()` method that removes the
		// event handlers when we no longer need them
		return {
			teardown: function () {
				for (eventName in handlers) {
					if (handlers.hasOwnProperty(eventName)) {
						node.removeEventListener(eventName, handlers[eventName], false);
					}
				}
				window.removeEventListener('scroll', scrollHandler);
			}
		};
	};

	return parallaxDecorator;
}));

/* this is taken from
 http://ifandelse.com/its-not-hard-making-your-library-support-amd-and-commonjs/ */
(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		// Now we're wrapping the factory and assigning the return
		// value to the root (window) and returning it as well to
		// the AMD loader.
		define('enterViewDecorator',['enterViewDecorator'], function (enterViewDecorator) {
			return (root.enterViewDecorator = factory(enterViewDecorator));
		});
	} else if (typeof module === 'object' && module.exports) {
		// I've not encountered a need for this yet, since I haven't
		// run into a scenario where plain modules depend on CommonJS
		// *and* I happen to be loading in a CJS browser environment
		// but I'm including it for the sake of being thorough
		module.exports = (root.myModule = factory(require('enterViewDecorator')));
	} else {
		root.enterViewDecorator = factory(root.enterViewDecorator);
	}
}(this, function (enterViewDecorator) {
	// module code here....

	var enterViewDecorator = function (node, heightInView) {
		var scrollHandler;

		var inIframe = function () {
			try {
				return window.self !== window.top;
			} catch (e) {
				return true;
			}
		};

		var checkVisible = function () {
			var el = node;
			var rect = el.getBoundingClientRect();
			var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
			//checks if banner is at least half way up the page
			var isVisible = !(rect.bottom < 0 || rect.top - viewHeight + (rect.height / heightInView) >= 0);

			if (isVisible || inIframe()) {
				node._ractive.root.set('entered_view', 'entered-view');
				window.removeEventListener('scroll', scrollHandler);
			}
		};

		window.addEventListener('scroll', scrollHandler = function () {
			checkVisible();
		}.bind(this), false);


		//this is a hack as the height isn't immediately available
		setTimeout(
			function () {
				checkVisible();
			}, 1000);

		// Return an object with a `teardown()` method that removes the
		// event handlers when we no longer need them
		return {
			teardown: function () {
				window.removeEventListener('scroll', scrollHandler);
			}
		};
	};

	return enterViewDecorator;
}));

/* this is taken from
 http://ifandelse.com/its-not-hard-making-your-library-support-amd-and-commonjs/ */
(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		// Now we're wrapping the factory and assigning the return
		// value to the root (window) and returning it as well to
		// the AMD loader.
		define('equaliseHeightsDecorator',['equaliseHeightsDecorator'], function (equaliseHeight) {
			return (root.equaliseHeightsDecorator = factory(equaliseHeight));
		});
	} else if (typeof module === 'object' && module.exports) {
		// I've not encountered a need for this yet, since I haven't
		// run into a scenario where plain modules depend on CommonJS
		// *and* I happen to be loading in a CJS browser environment
		// but I'm including it for the sake of being thorough
		module.exports = (root.myModule = factory(require('equaliseHeightsDecorator')));
	} else {
		root.equaliseHeightsDecorator = factory(root.equaliseHeightsDecorator);
	}
}(this, function (equaliseHeight) {
	// module code here....

	var equaliseHeight = function (node) {
		var scrollHandler;

		var inIframe = function () {
			try {
				return window.self !== window.top;
			} catch (e) {
				return true;
			}
		};

		var equaliseChildHeights = function () {
			var cards = node._ractive.root.findAllChildComponents(),
				normalisedCards = [],
				card;
			//filter the cards for only those that have equalise set
			cards = _.filter(cards, function (card) {
				return card.get('equalise') === true;
			});
			//get the HTML elements of the card
			for (var j = 0; j < cards.length; j++) {
				card = cards[j];
				normalisedCards.push(cards[j].el.firstChild);
			}
			//if the cards aren't components but sub components then they cannot have properties set, they need
			//to have a data value of data-equalise somewhere in the HTML
			//e.g.  <div class="blah" data-equalise>
			var dataEqualise = [].slice.call(node._ractive.root.el.querySelectorAll('[data-equalise]'));
			normalisedCards = normalisedCards.concat(dataEqualise);
			var height = 0, i;
			for (i = 0; i < normalisedCards.length; i++) {
				card = normalisedCards[i];
				// card = cards[i].el.firstChild;
				//get tallest card
				card.style.height = '';
				//returns a string like "23.42px"
				var cardHeight = window.getComputedStyle(card).height;
				//convert to a number - did it like this instead of using offsetHeight as this was creating rounding
				//errors when used in conjunction with minHeight.  E.g. minHeight may be 252 but actual height may be
				//252.24px which causes an error in float behaviour
				cardHeight = Math.ceil(Number(cardHeight.split('px')[0]));
				height = Math.max(cardHeight, height);
			}
			for (i = 0; i < normalisedCards.length; i++) {
				card = normalisedCards[i];
				//set all cards to that height
				//Check inside Iframe
				if (inIframe()) {
					card.style.height = 'auto';
				} else {
					card.style.height = height + 'px';
				}
			}
		};

		window.addEventListener('resize', scrollHandler = function () {
				equaliseChildHeights();
		}.bind(this), false);

		// This is a hack, Wait untill component wrapper widgets initialized to recalculate height.
		$(document).on('allWidgetsInitialized.lux', function () {
			_.delay(function () {
				equaliseChildHeights();
			}, 500);
		});

		// This is a hack as the height isn't immediately available
		node.style.visibility = 'none';
		var check = setInterval(function () {
			//check if this has been rendered
			if (node._ractive.root.fragment.rendered) {
				clearInterval(check);
				setTimeout(function () {
					equaliseChildHeights();
					node.style.visibility = 'visible';
				}, 500);
			}
		}, 25);
		// Return an object with a `teardown()` method that removes the
		// event handlers when we no longer need them
		return {
			teardown: function () {
				window.removeEventListener('resize', scrollHandler);
			}
		};
	};

	return equaliseHeight;
}));

define('loadMaskDecorator',['ractive'], function (Ractive) {
	/*
	var options = {
		observeField: 'inProcess',
		selector: 'DOM Node'
	}
	*/
	var loadMask = function (node, options) {
		var ractiveComponent = this;
		options = options || {};
		observeField = options.observeField || 'inProcess';
		ractiveComponent.viewmodel.data[observeField] = false;
		var fieldObserver = ractiveComponent.observe(observeField, function (value) {
			var selectorNode = this.find(options.selector) || node;
			if (value) {
				this.spinner = new Ractive.components['ux-load-mask']({
					el: selectorNode,
					append: true,
					data: {
						class: options.class,
						pageLoadMessage: options.pageLoadMessage
					}
				});
			} else {
				if (this.spinner) {
					this.spinner.teardown();
				}
			}
			
		}, {init: false, context: this});
		// Return an object with a `teardown()` method that removes the
		// event handlers when we no longer need them
		return {
			teardown: function () {
				fieldObserver.cancel();
			}
		};
	};

	Ractive.decorators.loadMask = loadMask;

	return loadMask;
});

define('LUXComponents',["ractive","RactiveF","RactiveTouch","ractiveTooltip","RactiveHelpers","CommonHelpers","ProductFacade","RactiveValidate","ractive-events-keys","ractiveTransitionsFly","ractive-transitions-fade","ractive-transitions-slide","LUXComponentTemplates","underscoreString","hammerjs","query","jslider","pikaday","IScroll","swiper","waypoints","moment","mxn","d3","DateUtils","polyfills","ConfigStrings","parseJSON","router","storage","ICS","ICSListener","PasswordStrength","CapslockWarning","enquire","parallaxDecorator","enterViewDecorator","equaliseHeightsDecorator","loadMaskDecorator"],function(Ractive,RactiveF,RactiveTouch,ractiveTooltip,RactiveHelpers,CommonHelpers,ProductFacade,RactiveValidate,RactiveEventsKeys,ractiveTransitionsFly,ractiveTransitionsFade,ractiveTransitionsSlide,LUXComponentTemplates,underscoreString,Hammer,query,jslider,Pikaday,IScroll,swiper,waypoints,moment,mxn,d3,DateUtils,polyfills,ConfigStrings,parseJSON,router,storage,ICS,ICSListener,PasswordStrength,CapslockWarning,enquire,parallaxDecorator,enterViewDecorator,equaliseHeightsDecorator,loadMaskDecorator){

Ractive.components["ux-accessory-filter"] = Ractive.extend({
	template: LUXComponentTemplates['ux-accessory-filter'],
	data: function () {
		return {
			disabledCart: 'disabled'
		};
	},
	onrender: function () {

		var deal = this.get('deal');
		if (typeof deal === 'undefined' || deal === null) {
			this.set('deal', this.get('deals')[0].value);
		}
		var sortBy = this.get('sortBy');
		if (typeof sortBy === 'undefined' || sortBy === null) {
			this.set('sortBy', this.get('sortByList')[0].value);
		}

		this.on('*.changedDeals', function (newValue) {
			this.filterChanged('deal', newValue);
		}.bind(this));

		this.on('*.changedSortBy', function (newValue) {
			this.filterChanged('sortBy', newValue);
		}.bind(this));
	},

	filterChanged: function (keypath, newValue) {
		this.fire('filterChanged', keypath, newValue);
	}
});

Ractive.components["ux-accordion-filter"] = Ractive.extend({
	template: LUXComponentTemplates['ux-accordion-filter'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			filterAnchorColor: {
				color: 'inherit'
			}
		};
	},






	onrender: function () {
		var self = this;
		self.parent.on('updateAccordionFilter', function (event) {
		
			console.log('not called');
		});
		self.on('ux-checkbox.onBrandsClicks', function (event) {
			var value = event.original.currentTarget.value;
			var isChecked = event.original.currentTarget.checked;
			console.log(value, isChecked);
			self.fire('updateProductBrands', value, isChecked, true);
		});
		self.on('ux-checkbox.onCategoriesClicks', function (event) {
			var value = event.original.currentTarget.value;
			var isChecked = event.original.currentTarget.checked;
			console.log(value, isChecked);
			self.fire('updateProductCategories', value, isChecked, true);
		});
		self.on('ux-anchor.clearAllBrands', function (event) {
			var checkboxes = event.parent.findAllComponents('ux-checkbox');
			_.each(checkboxes, function (checkbox) {
				checkbox.set('checked', false);
			});
			self.fire('clearAllBrands', true);
		});
		self.on('ux-anchor.clearAllCategories', function (event) {
			var checkboxes = event.parent.findAllComponents('ux-checkbox');
			_.each(checkboxes, function (checkbox) {
				checkbox.set('checked', false);
			});
			self.fire('clearAllCategories', true);
		});
		self.on('*.changedSortBy', function (newValue) {
			var self = this;
			self.fire('sortAllProduct', newValue);
		});
		self.on('*.openFilterModel', function () {
			console.log('clicked bro');
			self.fire('openFilterModel');
		});
		self.on('*.openSortByModal', function () {
			console.log('clicked bro');
			self.fire('openSortByModal');
		});
	}
});

Ractive.components["ux-accordion-panel"] = Ractive.extend({
		template: LUXComponentTemplates['ux-accordion-panel']});

Ractive.components["ux-account-avatar"] = Ractive.extend({
	template: LUXComponentTemplates['ux-account-avatar'],
	isolated : true,
	oninit : function () {
		var self = this;
		self.observe('account.avatarImageId', self.onAvatarChange, {context: self});
	},

	onAvatarChange : function () {
		var self = this;
		var account = self.get('account');
		var avatars = self.getAvatarListAsPerAccountType();
		self.set('avatars', avatars);

		var avatarImg = _.find(avatars, function (avatar, index) {
			if (avatar.id === parseInt(account.avatarImageId)) {
				this.set('avatars.' + index + '.selected', true);
				return avatar;
			}
		}.bind(this));
		self.set('avatarImg', avatarImg);
	},

	getAvatarListAsPerAccountType : function () {
		var self = this;
		var account = self.get('account');
		var avatars = null;

		if (account.isEasyMobile) {
			avatars = this.get('emAvatarImages');
		} else {
			avatars = this.get('opAvatarImages');
		}
		return avatars;
	}
});

Ractive.components["ux-account-header"] = Ractive.extend({
	template: LUXComponentTemplates['ux-account-header'],
	isolated : true,
	data: function () {
		return {
			moment: moment,
			RactiveHelpers: RactiveHelpers,
			RactiveValidate: RactiveValidate,
			ConfigStrings: ConfigStrings
		};
	},
	oninit : function () {
		var self = this;
		self.set('currentAccountId', '');
		self.set('selectedDate', '');
		self.observe('account.avatarImageId', self.onAvatarChange, {context: self});
		self.observe('account.faStatus', function (faStatus, oldValue, keypath) {
			if (faStatus && (faStatus === 67 || faStatus === 78)) {
				var accountKeypath = 'account';
				var account = this.get(accountKeypath);
				var notificationKeypath = 'notification';
				var notification = this.get('initData.accountDeactivationNotification');
				notification = notification.replace('{DISCONTINUE_DATE}',
					RactiveHelpers.convertMilisTimestampToDate(
						account.faStatusChangeDate));
				notification = notification.replace('{REMOVAL_PERIOD}', this.get('initData.accountRemovalPeriod'));
				self.set(notificationKeypath, notification);
			}
		});

		self.observe('account.acountUpdatesStatus',
			self.acountUpdatesStatusChange, {context: self});

		self.observe('billingSummaryActions.billingAccountSummaryVmStatus',
			self.onBillingAccountSummaryVmStatusChange, {context: self});
		self.parent.observe('updatePersonInfo.updateCutomerProfileVmStatus',
			self.onCustomerProfileVmStatusChange, {context: self});
		self.parent.observe('retrieveSDPAddress.addressVMStatus',
			self.onRetrieveSDPAddressChange, {context: self});

		self.parent.observe('supportCase.createCaseVmStatus',
			self.onCaseVmStatusChange, {context: self});
	},

	acountUpdatesStatusChange: function (acountUpdatesStatus) {
		switch (acountUpdatesStatus) {
			case 'updateBillingAddressSuccess':
				this.parent.setLoaderAndModalProperty('changeBillingAddressModal', 'inProcess', false);
				this.set('editableAddress', this.get('account.physicalAddress'));
				this.toggleModel('thankYouModal', true);
				break;
			case 'updateBillingAddressFailed':
				this.parent.setModalProperty('changeBillingAddressModal', 'inProcess', false);
				this.set('updateAddressError', true);
				break;
		}
		this.set('account.acountUpdatesStatus', 'DetailsUpdated');
	},
	onRetrieveSDPAddressChange: function (vmStatus) {
		if (this.get('currentAccountId') === this.get('account').billingAccountNumber) {
			switch (vmStatus) {
				case 'getAddressSuccess':
					this.parent.setModalProperty('changeBillingAddressModal', 'inProcess', false);
					var addressComponent = this.findComponent('ux-address-form');
					if (addressComponent) {
						addressComponent.set('errorMessage', null);
					}
				
				
					this.set('editableAddress', {});
				
				
					var addressList = this.parent.get('retrieveSDPAddress.addressList');
					this.set('addressList', addressList);
					break;
				case 'getAddressError':
					this.parent.setModalProperty('changeBillingAddressModal', 'inProcess', false);
					var addressComponent = this.findComponent('ux-address-form');
					addressComponent.set('errorMessage', ConfigStrings.errors.addressNotFoundError);
					break;
			}
			this.parent.set('retrieveSDPAddress.addressVMStatus', 'updatedAddressSet');
		}
	},

	onCustomerProfileVmStatusChange: function (vmStatus) {
		if (this.get('currentAccountId') === this.get('account').billingAccountNumber) {
			switch (vmStatus) {
				case 'contactInfoUpdatedSuccessfully':
					this.toggleModel('changeBillingAddressModal', false);
					this.toggleModel('thankYouModal', true);
					break;
				case 'contactInfoUpdateFailed':
					break;
			}
			this.parent.set('updatePersonInfo.updateCutomerProfileVmStatus', 'updatedAddressSet');
		}
	},

	onBillingAccountSummaryVmStatusChange: function (billingAccountSummaryVmStatus) {
		switch (billingAccountSummaryVmStatus) {
			case 'error':
				this.parent.setModalProperty('changeAccountDetails', 'inProcess', false);
				this.set('genericError', true);
				break;
			case 'changeAvatarAndNickNameSuccess':
				var account = this.get('account');
				var selectedAvatar = this.parent.get('selectedAvatar');
				this.parent.set('billingSummaryActions.billingAccountSummaryVmStatus', 'changeAvatarAndNickNameSet');
				if (account.billingAccountNumber === selectedAvatar[0]) {
					account.nickName = this.get('nickNameValue');
					account.avatarImageId = selectedAvatar[1];
					this.set('account', account);
					this.parent.setModalProperty('changeAccountDetails', 'inProcess', false);
					this.toggleModel('changeAccountDetails', false);
				}
				break;
		}
	},

	onCaseVmStatusChange: function (createCaseVmStatus) {
		if (this.get('currentAccountId') === this.get('account').billingAccountNumber) {
			switch (createCaseVmStatus) {
				case 'createCaseSuccessful':
					this.parent.setLoaderAndModalProperty('scheduleBillingAddressModal', 'inProcess', false);
					this.toggleModel('thankYouModal', true);
					break;
			}
		}
	},

	onAvatarChange : function () {
		var self = this;
		var account = self.get('account');
		var avatars = self.getAvatarListAsPerAccountType();
		self.set('nickNameValue', account.nickName ? account.nickName : ' ');
		self.set('avatars', avatars);
		self.set('avatars.*.selected', false);
	
		var avatarImg = null;

		_.each(avatars, function (avatar, index) {
			if (avatar.id === parseInt(account.avatarImageId)) {
				this.set('avatars.' + index + '.selected', true);
				avatarImg = avatar;
			}
		}.bind(this));
		self.set('avatarImg', avatarImg);
		self.setDefaultAvatar();
	},

	setDefaultAvatar: function () {
		var account = this.get('account');
		var selectedAvatar = [];
		selectedAvatar[0] = account.billingAccountNumber;
		selectedAvatar[1] = account.avatarImageId;
		this.parent.set('selectedAvatar', selectedAvatar);
	},

	getAvatarListAsPerAccountType : function () {
		var self = this;
		var account = self.get('account');
		var avatars = null;

		if (account.isEasyMobile) {
			avatars = this.get('initData.emAvatarImages');
		} else {
			avatars = this.get('initData.opAvatarImages');
		}
		return avatars;
	},

	toggleModel: function (modal_id, state) {
		var self = this;
		var modalList = self.findAllComponents('ux-modal');
		var modal = _.find(modalList, function (modal) {
			return modal.get('modalId') === modal_id;
		});
		modal.set('displayState', state);
	},

	onrender: function () {
		var self = this;

		self.on('*.showPaymentHistory', function (event) {
			self.fire('showPaymentHistory', event);
		});

		self.on('*.manageRedirection', function () {
			window.location.href = RactiveHelpers.modifyConfigUrl(
				ConfigStrings.eBillRegistrationUrl) + '?billPreference=EBill';
		});

		self.on('*.payBill', function () {
			self.fire('payBill', self);
		});

		self.on('*.changeAccountDetails', function (event) {
			self.onAvatarChange();
			this.set('genericError', false);
			this.set('nickNameValueErrorMsg', null);
			this.toggleModel('changeAccountDetails', true);
		
			this.swiper = new Swiper(this.find('.swiper-container'), {
			
				paginationClickable: false,
				slidesPerView: 5,
				spaceBetween: 20,
				breakpoints: {
					480: {
						slidesPerView: 4,
						spaceBetween: 10
					},
					340: {
						slidesPerView: 3,
						spaceBetween: 10
					}
				}
			});
		});

		self.on('*.changeBillingAddress', function (event) {
			var account = this.get('account');
			this.set('currentAccountId', account.billingAccountNumber);
			this.set('currentFaId', account.faid);
			this.set('editableAddress', '');
			this.set('updateAddressError', false);
			this.set('genericError', false);
			this.toggleModel('changeBillingAddressModal', true);
		});

		self.on('*.scheduleBillingAddress', function (event) {
			this.set('genericError', false);
			this.toggleModel('changeBillingAddressModal', false);
			this.toggleModel('scheduleBillingAddressModal', true);
		});

		self.on('*.confirmAddress', function (event) {
			this.set('updateAddressError', false);
			var account = this.get('account');
			this.set('currentAccountId', account.billingAccountNumber);
			this.set('billingSummaryActions.selectedAccount', account.faid);
			var editableAddress = this.get('editableAddress');
			this.set('account.newAddress', editableAddress);
			var isValid = this.findComponent('ux-address-form').validateFloorAndUnitNumber();
			if (isValid) {
				var eventName = 'billingSummaryActions.updateAccountAddress';
				self.parent.fire(eventName, {
					name: eventName
				});
				this.parent.setLoaderAndModalProperty('changeBillingAddressModal', 'inProcess', true);
			}
		});

		self.on('*.getAddress', function (addressComponent) {
			this.set('updateAddressError', false);
			var address = this.get('editableAddress');
			self.parent.set('retrieveSDPAddress.postalCode', address.postCode);
			var eventName = 'retrieveSDPAddress.getAddress';
			self.parent.fire(eventName, {
				name: eventName
			});
			this.parent.setLoaderAndModalProperty('changeBillingAddressModal', 'inProcess', true);
		});

		self.on('*.billingAddressScheduleCase', function (event) {
			var selectedDate = this.get('selectedDate');
			var editableAddress = this.get('editableAddress');
		
		
		
		
			delete editableAddress.isNotApplicable;
			self.set('currentAccountId', this.get('account.billingAccountNumber'));
			self.parent.set('supportCase.barId', this.get('currentAccountId'));
			var eventName = 'supportCase.updateAddressCase';
			self.parent.fire(eventName, {
				name: eventName
			});
			self.parent.set('supportCase.caseDescription', JSON.stringify(editableAddress) +
				' selectedDate' + selectedDate);
			var createCaseEvent = 'supportCase.submitCase';
			self.parent.fire(createCaseEvent, {
				name: createCaseEvent
			});
			self.parent.setLoaderAndModalProperty('scheduleBillingAddressModal', 'inProcess', true);
		});
		self.on('*.selectNewAvatar', function (event) {
			self.set('avatars.*.selected', false);
			self.set(event.keypath + '.selected', true);
			var selectedAvatar = [];
			selectedAvatar[0] = self.get('account').billingAccountNumber;
			selectedAvatar[1] = self.get(event.keypath).id;
			self.parent.set('selectedAvatar', selectedAvatar);
		
		});

		self.on('*.confirmChangeAvatarNickName', function () {
			this.set('genericError', false);
			var validity = this.validation.validate();
			if (validity.valid) {
				var selectedAvatar = self.parent.get('selectedAvatar');
				var nickNameValue = self.get('nickNameValue');
				var account = self.get('account');
				self.parent.set('billingSummaryActions.selectedAvatar', selectedAvatar[1]);
				self.parent.set('billingSummaryActions.nickName', nickNameValue);
				self.parent.set('billingSummaryActions.currentAccount', account);
				self.parent.set('billingSummaryActions.customerId', account.customerId);
				var eventName = 'billingSummaryActions.changeAvatarAndNickName';
				self.parent.fire(eventName, {
					name: eventName
				});
				self.parent.setLoaderAndModalProperty('changeAccountDetails', 'inProcess', true);
			}
		});

		self.validation = new RactiveValidate(self, {
			'nickNameValue': {
				required: ConfigStrings.errors.accountHeader.nickName.required,
				maxlength: {
					param: 12,
					message: ConfigStrings.errors.accountHeader.nickName.maxlength
				},
				alpha_numeric: ConfigStrings.errors.accountHeader.nickName.alpha_numeric
			}
		});
		self.validation.patterns.alpha_numeric = /^[a-z0-9\s]+$/i;
		self.validation.cwd = '';
	}
});

Ractive.components["ux-account-service"] = Ractive.extend({
	template: LUXComponentTemplates['ux-account-service'],
	isolated : true,
	data : function () {
		return {
			RactiveHelpers : RactiveHelpers,
			ConfigStrings : ConfigStrings,
			productFacade: null,
			moment: moment
		};
	},
	oninit: function () {
		this.set('suspendMessage', ConfigStrings.alertMessages.suspensionMessage);

		this.set('easyMobiletitle', ConfigStrings.constants.TITLE.EASY_MOBILE);

		this.on('*.recontractMobile', function (event) {
			var context = {
				productId : this.get('product.id'),
				permission : this.get('permission'),
				lob: this.get('product.lob'),
				barId: this.get('account.faid'),
				hideReconSection: this.get('product.hideReconSection'),
				freeEmailIdFlag: this.get('productFacade').freeEmailIdFlag
			};
			var eventName = 'startReconFlow';
			this.fire(eventName, event, context);
		});

		this.on('*.changeAccordion', function (accordionComponent) {
			var account = this.get('account');
			this.parent.set('easyMobileTweak.faid', account.faid);
			var lob = this.get('product.lob');
			if (accordionComponent.get().active) {
				var product = this.getPlanDetails(lob);
				if (product) {
					product.isPriorityItem = false;
				}
				if (lob === 'WS' || lob === 'MOB') {
					this.fire('populateUnbilledUsage', {
						customerId: this.get('account.customerId'),
						faid: this.get('account.faid'),
						subscriptionId: this.get('product.subscriptionId'),
						serviceId: this.get('product.serviceId'),
						chNodeId: this.get('product.chNodeId'),
						planId: this.get('product.offeringId')
					});
					this.fire('fetchAllVouchers', {
						customerId: this.get('account.customerId'),
						faid: this.get('account.faid'),
						subscriptionId: this.get('product.subscriptionId'),
						productId: this.get('product.id')
					});
					this.fire('retrieveCIAmounts', {
						serviceId: this.get('product.serviceId')
					});
				}
				this.set('product', product);
				this.fire('populateProductDetails', {
					customerId: this.get('account.customerId'),
					faid: this.get('account.faid'),
					subscriptionId: this.get('product.subscriptionId'),
					productId: this.get('product.id')
				});
				this.set('inProcess', true);
			}
		}.bind(this));

		this.observe('product.productDetails', function (productDetails) {
			if (productDetails) {
				var productFacade = new ProductFacade(productDetails, {
					setRecontractData: true
				});
				productFacade.setIsNonKeyLinePlan(this.isNonKeyLinePlan(productDetails));
				productFacade.setAccounts(this.get('accountSummary.accounts'));
				if (productDetails.lineOfBusiness === 'WS' || productDetails.lineOfBusiness === 'MOB') {
					productFacade.setCIAmts(this.get('accountSummary.CIAmts'));
					productFacade.setCIErrorDetails(this.get('accountSummary.CIErrorDetails'));
					if (productDetails.planGroupName && (productDetails.planGroupName === 'SIMONLY' ||
						productDetails.planGroupName === 'MOBILESHARE')) {
						productFacade.calculateSimOnlyMobileRecontractData();
					} else if (productDetails.planGroupName && productDetails.planGroupName === 'IPPPLANS') {
						productFacade.calculateIppMobileContractData();
					}else {
						productFacade.calculateMobileRecontractData();
					}
				} else if (productDetails.lineOfBusiness === 'BB' || productDetails.lineOfBusiness === 'FBB') {
					var freeEmailIds = this.get('initData.chargeableEmail.freeBillingOfferList');
					var existingBoIds = this.get('initData.chargeableEmail.existingBoIds');
					if (freeEmailIds && freeEmailIds.length > 0) {
						productFacade.calculateFreeBoIdPresent(freeEmailIds, existingBoIds);
					}
					productFacade.calculateBroadbandRecontractData();
				} else if (productDetails.lineOfBusiness === 'TV') {
					productFacade.calculateTVRecontractData();
				} else if (productDetails.lineOfBusiness === 'WL') {
					productFacade.calculateWLRecontractData();
				}
				this.set('productFacade', productFacade);
				var product = this.getPlanDetails(productDetails.lineOfBusiness);
				this.set('product', product);
				this.set('inProcess', false);
			}
		});
		this.observe('product.pendingOrderMap', function (pendingOrderMap) {
			if (pendingOrderMap) {
								this.set('pendingOrders', this.getPendingOrderDetails(pendingOrderMap));
				this.identifyFutureDatedSuspensionRequest(pendingOrderMap);
				console.log(this.get('pendingOrders'));
			}
		});
	},
	toggleModal: function (modal_id, state) {
		var self = this;
		var modalList = self.findAllComponents('ux-modal');
		var modal = _.find(modalList, function (modal) {
			return modal.get('modalId') === modal_id;
		});
		modal.set('displayState', state);
	},
	getPendingOrderDetails: function (pendingOrderDetails) {
		var pendingOrderMap = {
			isResumePending: pendingOrderDetails
			[ConfigStrings.constants.CATALOGITEMS.RESUME_SERVICE] ? false : true,
			isSuspendPending: pendingOrderDetails
			[ConfigStrings.constants.CATALOGITEMS.SUSPEND_SERVICE] ? false : true,
			isChangeMobileNumberPending: pendingOrderDetails
			[ConfigStrings.constants.CATALOGITEMS.CHANGE_MOBILE_NUMBER] ? false : true,
			isChangePlanPending: pendingOrderDetails
			[ConfigStrings.constants.CATALOGITEMS.CHANGE_PLAN] ? false : true,
			isReplaceSimPending: pendingOrderDetails
			[ConfigStrings.constants.CATALOGITEMS.REPLACE_SIM] ? false : true
		};
		return pendingOrderMap;
	},
	identifyFutureDatedSuspensionRequest: function (pendingOrderDetails) {
		var serviceId = this.get('product.serviceId');
		var pendingItem = _.find(pendingOrderDetails, function (order) {
			return (parseInt(order.resourceId) === parseInt(serviceId) &&
				(order.captionId && order.captionId.includes('SU-')));
		});
		if (pendingItem && pendingItem.captionId) {
			var captionId = pendingItem.captionId;
			var suspensionDate = moment(captionId.substr(captionId.indexOf('-') + 1,
				captionId.lastIndexOf('-') - 3), 'ddd MMM DD hh:mm:ss zz YYYY');
			this.set('pendingOrders.futureSuspensionDate', suspensionDate.format('DD MMMM YY'));
			this.set('product.futureSuspensionDate', suspensionDate);
			this.set('product.pendingOrderDetails', pendingItem);
			this.set('pendingOrders.isFutureSuspendRequest', true);
		}
	},
	getPlanDetails: function (lob) {
		var self = this;
		var product = self.get('product');
		var plans = null;
		if (lob === 'WL') {
			plans = self.get('initData.energyPlans');
		} else {
			plans = self.get('initData.plans');
		}
		var plan = _.find(plans, function (plan) {
		
			if (plan.basePriceSchemaId === self.get('product.plan.catalogItemID') &&
				plan.planId === self.get('product.offeringId')
				) {
				return true;
			}
		});

		if (plan && plan.roamingBenefit && plan.aspireLaunchDate &&
				!moment(plan.aspireLaunchDate).isAfter(
				self.get('productFacade.recontractData.planContractStartDate'))
			) {
			plan.displayRoamingCredit = true;
		}
		_.extend(product, plan);
		return product;
	},
	isNonKeyLinePlan: function (productDetails) {
		var offeringID = productDetails.offeringId;
		if (!offeringID && productDetails.plan) {
			offeringID = productDetails.plan.catalogItemID;
		}
		var nonKeyLinePlanIds = this.get('initData.nonKeyLinePlanIds');
		if (nonKeyLinePlanIds && offeringID) {
			var nonKeyLinePlans = nonKeyLinePlanIds.split(',');
			var matchFound = _.find(nonKeyLinePlans, function (nonKeyLinePlan) {
				var tempPlanIds = nonKeyLinePlan.split('_');
				return _.contains(tempPlanIds, offeringID);
			});
			if (matchFound) {
				return true;
			}
		}
		return false;
	}
});

Ractive.components["ux-activation-modal"] = Ractive.extend({
	template: LUXComponentTemplates['ux-activation-modal'],
	onrender: function () {
		var self = this;
		self.on('*.updateEmail', function (event) {
		
			self.set('newContactDetails.emailIdErrorMsg', {
				message: '',
				status: ''
			});
		});
		self.on('ux-input-box.validateEmail', function (event) {
			self.validateContactEmail();
		});

		self.on('*.updateContactEmail', function (event) {
			var isValid = self.validateContactEmail();
			if (isValid) {
				self.handleModal(false, 'resendActivationEmailModal');
				self.handleModal(true, 'resendActivationDetailsModal');
			}
		});

		self.on('*.reactivateAddon', function (event) {
			self.fire('sendNotificationLink', self.get());
		});
	},
	handleModal: function (visibility, cardId) {
		var modals = this.findAllChildComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return cardId === component.get('modalId');
		})[0];
		modal.set('displayState', visibility);
	},
	validateContactEmail: function () {
		var error = ConfigStrings.guestCheckoutValidationError.emailAddress;
		this.contactEmailValidationRule = new RactiveValidate(this,{
			'newContactDetails.emailId'	: {
				required: error.nameRequired,
				email: error.inValidEmail
			}
		});
		this.contactEmailValidationRule.cwd = '';
		return this.contactEmailValidationRule.validate(this.contactEmailValidationRule).valid;
	}
});

Ractive.components["ux-add-card"] = Ractive.extend({
	template: LUXComponentTemplates['ux-add-card'],
	isolated: true,
	data: function () {
		return {
			ConfigStrings: ConfigStrings,
			showNewCardDetails: false
		};
	},
	oncomplete: function () {
		var self = this;
		this.set('index_open', '');
		this.on('setAddCard', function () {
			if (!this.get('open')) {
				this.fire('addCard');
			}
		});
		this.on('*.changeAccordion', function (event) {
			if (event.get('active')) {
				this.set('isActive', true);
				this.fire('addCard');
			} else {
				this.set('isActive', false);
			}
		});
		this.observe('isActive', function (isActive) {
			if (!isActive) {
			
				var uxAccordionComponent = self.get('uxAccordionComponent');
				if (typeof uxAccordionComponent !== 'undefined') {
					_.each(uxAccordionComponent.get('componentItems'), function (component) {
						component.set('active', false);
					});
				}
				self.fire('addCardClosed');
			}
		});
	
		this.set('uxAccordionComponent', this.findAllChildComponents('ux-accordion')[0]);
		this.observe('payBills.payBillVmStatus', this.onPaybillStatusChange, {init: true, context: this});
	},
	onPaybillStatusChange: function (payBillVmStatus) {
		switch (payBillVmStatus) {
			case 'SessionDetailsSet':
				this.showIframe();
				break;
			case 'TokenisationDone':
				this.set('errorMessage', null);
				var transactionDetails = this.get('payBills.transactionDetails');
				this.set('showNewCardDetails', true);
				var newCardDetails = {
					cardTitle: transactionDetails.cardType,
					cardNumberEnding: transactionDetails.token.substr(12),
					cardExpiryDate: transactionDetails.expiryDate,
					security: null
				};
				this.set('newCardDetails', newCardDetails);
				break;
			case 'TransactionFailed':
				var transactionDetails = this.get('payBills.transactionDetails');
				if (transactionDetails.result === '0') {
				
					if (transactionDetails.declinedCode === '998') {
					
						this.set('open', false);
					} else {
						this.set('errorMessage',
							decodeURIComponent(transactionDetails.declinedMessage.replace(/\+/g,  ' ')));
					
						this.fire('addCardFailed', transactionDetails);
					}
				} else if (transactionDetails.result === '3') {
				
					this.fire('addCard');
				}
				break;
			case 'GetTransactionDetailsFailed':
				break;
		}
	},

	showIframe: function () {
		var sessionDetails = this.get('payBills.sessionDetails');
		this.set('showNewCardDetails', false);
		if (sessionDetails.sst) {
			var ipPaymentUrl = sessionDetails.ihppUrl +
				'?SessionId=' + sessionDetails.sessionId +
				'&SST=' + sessionDetails.sst;
			this.set('ipPaymentUrl', ipPaymentUrl);
		}
	}
});

Ractive.components["ux-add-vouchers"] = Ractive.extend({
	template: LUXComponentTemplates['ux-add-vouchers'],
	computed: {
		guid: function () {
			return this._guid;
		}
	},
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			moment: moment
		};
	},
	onrender: function () {
		var self = this;
		if (self.get('lob') === 'bundle') {
			self.set('disabled', false);
			if (window && window.innerWidth <= 852) {
				self.set('checkMobile', true);
			} else {
				self.set('check', true);
			}
		}
		var action = sessionStorage.getItem('action');
		if (action === 'addVoucher') {
			if (self.get('voucher.personId')) {
				self.fire('getVouchers', self.get('idx'));
			}
			sessionStorage.removeItem('action');
		}

		self.on('*.doOpenShowVouchersModal', function (event) {
			if (this.get('voucher.personId')) {
				self.fire('getVouchers', self.get('idx'));
			} else {
				var loginUrl = self.get('initData.loginUrl');
				var originUrl;
				if (loginUrl) {
					originUrl = window.location.href;
					originUrl = RactiveHelpers.removeParam(originUrl, 'loginstatus');
					self.set('initData.referenceUrl', originUrl);
				}
				sessionStorage.setItem('loginClicked', true);
				self.handleModal(true, 'loginForm', 'addVoucher', originUrl);
			}
		});

		self.on('*.doCloseModal', function (event) {
			sessionStorage.removeItem('action');
		});

		self.on('ux-checkbox.onVouchersClick', function (event) {
			var checkboxes = this.findComponent('ux-modal').findAllComponents('ux-checkbox');
			var vouchers = this.get('voucher.mobile');
			var isOneSelected = false;
			_.each(checkboxes, function (checkbox) {
				var value = checkbox.get('checked');
				if (typeof value !== 'undefined') {
					if (value) {
						isOneSelected = true;
						var mobileId = checkbox.get('checkboxid').substr(-2, 1);
						var voucherId = checkbox.get('checkboxid').substr(-1, 1);
						var selectedvoucher = vouchers[mobileId].voucherList[voucherId];
						_.each(vouchers, function (voucher, key1) {
							_.each(voucher.voucherList, function (item, key2) {
								if (item.idX8 === selectedvoucher.idX8) {
									var guid = self.get('guid');
									var id = 'voucherList' + guid + '-' + key1 + key2;
									var idMobileView = 'voucherListMobileView' + guid + '-' + key1 + key2;
									if (id !== null && id !== checkbox.get('checkboxid')) {
										document.getElementById(id).disabled = true;
									}
									if (idMobileView !== null && idMobileView !== checkbox.get('checkboxid')) {
										document.getElementById(idMobileView).disabled = true;
									}
								}
							});
						});
					} else {
						var mobileId = checkbox.get('checkboxid').substr(-2, 1);
						var voucherId = checkbox.get('checkboxid').substr(-1, 1);
						var unSelectedvoucher = vouchers[mobileId].voucherList[voucherId];
						_.each(vouchers, function (voucher, key1) {
							_.each(voucher.voucherList, function (item, key2) {
								if (item.idX8 === unSelectedvoucher.idX8) {
									var guid = self.get('guid');
									var id = 'voucherList' + guid + '-' + key1 + key2;
									var idMobileView = 'voucherListMobileView' + guid + '-' + key1 + key2;
									if (id !== null && id !== checkbox.get('checkboxid')) {
										document.getElementById(id).disabled = false;
									}
									if (idMobileView !== null && idMobileView !== checkbox.get('checkboxid')) {
										document.getElementById(idMobileView).disabled = false;
									}
								}
							});
						});
					}
				}
			});
			self.set('disabled', !isOneSelected);
		});

		self.on('*.doSelectVouchers', function (event) {
			var checkboxes = this.findComponent('ux-modal').findAllComponents('ux-checkbox');
			var vouchers = this.get('voucher.mobile');
			var selectedVouchers = [];

			_.each(checkboxes, function (checkbox) {
				if (checkbox.get('checked')) {
					var mobileId = checkbox.get('checkboxid').substr(-2, 1);
					var voucherId = checkbox.get('checkboxid').substr(-1, 1);
					selectedVouchers.push({
						productOrderItemID: vouchers[mobileId].productOrderItemID,
						serviceId: vouchers[mobileId].serviceId,
						selectedVouchers: vouchers[mobileId].voucherList[voucherId]
					});
				}
			});

			if (selectedVouchers.length > 0) {
				self.set('selectedVouchers', selectedVouchers);
			
			} else {
				self.set('selectedVouchers', '');
				self.set('userSelectedVouchers', '');
			}

			self.handleModal(false, 'addVoucherModal');

						self.fire('doApplyVoucher', selectedVouchers);

			self.parent.on('openModal', function () {
				self.handleModal(true, 'addVoucherModal');
			});

		});

		self.on('*.doRemoveVoucher', function (event, idx) {
			var selectedVouchers = self.get('selectedVouchers');
			if (typeof selectedVouchers !== 'undefined' && selectedVouchers.length > 0) {
				var vouchers = _.filter(selectedVouchers, function (item) {
					return item.selectedVouchers.idX8 === idx;
				});
				self.set('removedVoucher', vouchers);

				selectedVouchers = _.filter(selectedVouchers, function (item) {
					return item.selectedVouchers.idX8 !== idx;
				});
				if (selectedVouchers.length === 0) {
					self.set('userSelectedVouchers', '');
				}
				self.set('selectedVouchers', selectedVouchers);
			}
			var vouchers = self.get('preSelectedVouchers');
			var vouchers = _.filter(vouchers, function (item) {
				return item.idX8 === idx;
			});
			self.fire('doRemoveSelectedVoucher', vouchers);
		});

		self.on('*.doOpenRetrieveVoucherModal', function (event, idx) {
			self.handleModal(false, 'addVoucherModal');
			self.handleModal(true, 'retrieveVoucherModal');
		});
		self.on('*.reOpenVoucherModal', function (event, idx) {
			self.handleModal(false, 'retrieveVoucherModal');
			self.handleModal(true, 'addVoucherModal');
		});
		self.on('*.onUnReserveVouchers', function (event, idx) {
			self.handleModal(false, 'retrieveVoucherModal');
			self.fire('doUnReserveVouchers');
		});
	},

	handleModal: function (visibility, cardId, action, originUrl) {
		if (visibility) {
			this.set('hideVouchersModal', true);
		}
		var modals = this.parent.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return cardId === component.get('modalId');
		})[0];
		if (action && cardId === 'loginForm') {
			sessionStorage.setItem('action', action);
			if (originUrl) {
				modal.set('referenceUrl', originUrl);
			}
		}
		modal.set('displayState', visibility);
	}
});

Ractive.components["ux-addon-accordion"] = Ractive.extend({
	template: LUXComponentTemplates['ux-addon-accordion'],
		oninit: function () {
		this.set('showConfigurePanel', false);

		if (this.isEditMode()) {
			this.set('contentClass', 'show');
		} else {
			this.set('contentClass', 'hide');
		}

		this.on('showConfiguration', function (event) {
			var flag = this.get('showConfigurePanel');
			flag = (flag === true) ? false : true;
			this.set('showConfigurePanel', flag);
			
			this.set('contentClass', (flag === true) ? 'show' : 'hide');
		});
	},
	isEditMode: function () {
		try {
			return window.self !== window.top;
		} catch (e) {
			return true;
		}
	}
});

Ractive.components["ux-addon-characteristic"] = Ractive.extend({
	template: LUXComponentTemplates['ux-addon-characteristic'],
	isolated: false,
	data: function () {
		return {
			getMinDate: function () {
				var minDate = this.get('minDate');
				return minDate || 'today';
			},

			getMaxDate: function () {
				var minDate = this.get('minDate') || moment();
				var duration = this.get('maxDuration') || 365;
				return moment(minDate).add(duration, 'days');
			}
		};
	}
});

Ractive.components["ux-addon-listing-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-addon-listing-singtel'],
	onconfig : function () {
		this.set('RactiveHelpers', RactiveHelpers);
	},
	onrender : function () {

		var self = this;
		self.on('ux-addon-singtel.addAddonClicked', _.bind(self.onAddAddonClick, self));
	},
	onAddAddonClick: function (addon) {
		if (addon.isOtpExpressAddonFlow) {
			Ractive.defaults.fire('otpexpressaddon_add', {
				productSpecContainmentID: addon.productSpecContainmentID,
				isOtpExpressAddon: true,
				price: addon.price,
				productTitle: addon.productTitle,
				productDescription: addon.productDescription
			});
		}else {
			window.location.href = RactiveHelpers.modifyConfigUrl(ConfigStrings.pageUrls.manageAddOns);
		}
	}
});

Ractive.components["ux-addon-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-addon-singtel'],
	isolated: true,
	data: function () {
		return {
			isRemoveButton: false,
			isAddButton: false,
			isUpgradeButtonDisabled: false,
			isRemoveButtonDisabled: false,
			isAddButtonDisabled: false,
			viewMore: false,
			moment: moment,
			addAddonClickEvent: 'addAddonClicked',
			removeAddonClickedEvent: 'removeAddonClicked',
			upgradeAddonClickEvent: 'upgradeAddonClicked',
			RactiveHelpers: RactiveHelpers,
			addonLabels: ConfigStrings.addonLabels,
			cropTextConfig: ConfigStrings.cropTextConfig,
			showAddButtonLabel: true,
			showPrice: false,
			removedDisabledMsg: null,
			originalAddon: null
		};
	},

	select: function (selectedSubGroupAddon) {
		var addon = this.get('addon');
		var subGroups = addon.subGroups;
	
	
		_.each(subGroups, function (subGroupAddon, index) {
			if (subGroupAddon.sales) {
				this.set('hideContract', false);
				if (selectedSubGroupAddon.addonId && subGroupAddon.addonId &&
					selectedSubGroupAddon.addonId === subGroupAddon.addonId) {
					this.set('addon.subGroups.' + index + '.selected', true);
				} else if (selectedSubGroupAddon.simpleProductSpecID && subGroupAddon.simpleProductSpecID &&
					selectedSubGroupAddon.simpleProductSpecID === subGroupAddon.simpleProductSpecID) {
					this.set('addon.subGroups.' + index + '.selected', true);
				} else {
					this.set('addon.subGroups.' + index + '.selected', false);
				}
			} else {
				if (selectedSubGroupAddon.productSpecContainmentID === subGroupAddon.productSpecContainmentID) {
					this.set('addon.subGroups.' + index + '.selected', true);
				} else {
					this.set('addon.subGroups.' + index + '.selected', false);
				}
			}
		}.bind(this));
		var promotionText = selectedSubGroupAddon.promotionText;
		addon = _.extend(addon, selectedSubGroupAddon, {selected: false});
		if (addon.sales) {
			addon.promotionText = promotionText;
			this.calculateButtonDisplay(addon);
		}
	
	
		this.set('addon', addon);
	},
	calculateButtonDisplay: function (selectedSubGroupAddon) {
		if (selectedSubGroupAddon.vasType === 'Exclusive') {
		
			var originalAddon = this.get('originalAddon');
			var originalAddonRemoveAction = _.find(originalAddon.allowedActions, function (action) {
				return action.type === ConfigStrings.ALLOWED_ACTIONS.REMOVE;
			});
			if (originalAddonRemoveAction && originalAddonRemoveAction.allowed) {
			
			
			
			
				if (selectedSubGroupAddon.addonId === originalAddon.addonId) {
				
				
					selectedSubGroupAddon.isRemoveButton = true;
					selectedSubGroupAddon.isUpgradeButton = false;
				} else {
				
				
					selectedSubGroupAddon.isRemoveButton = false;
					selectedSubGroupAddon.isUpgradeButton = true;
				}
			} else {
			
			
			
			
			
				selectedSubGroupAddon.isRemoveButton = true;
				selectedSubGroupAddon.isRemoveButtonDisabled = true;
				selectedSubGroupAddon.isUpgradeButton = false;
				if (originalAddon.enableUpgradeButton) {
					selectedSubGroupAddon.isRemoveButton = false;
					selectedSubGroupAddon.isUpgradeButton = true;
				}
			}
		} else {
		
		
			var selectedAddonRemoveAction = _.find(selectedSubGroupAddon.allowedActions, function (action) {
				return action.type === ConfigStrings.ALLOWED_ACTIONS.REMOVE;
			});
			if (selectedAddonRemoveAction && selectedAddonRemoveAction.allowed) {
			
			
			
				selectedSubGroupAddon.isRemoveButton = true;
				selectedSubGroupAddon.isRemoveButtonDisabled = false;
				selectedSubGroupAddon.isUpgradeButton = false;
			} else {
				var selectedAddonAddAction = _.find(selectedSubGroupAddon.allowedActions, function (action) {
					return action.type === ConfigStrings.ALLOWED_ACTIONS.ADD;
				});
				if (selectedAddonRemoveAction && selectedAddonAddAction.allowed) {
				
				
				
				
					selectedSubGroupAddon.isRemoveButton = false;
					selectedSubGroupAddon.isUpgradeButton = false;
					selectedSubGroupAddon.isAddButton = true;
					selectedSubGroupAddon.isAddButtonDisabled = false;
				}
			}
		}
	},
	oninit: function () {
		var originalAddon = _.clone(this.get('addon'));
		this.set('originalAddon', originalAddon);
		if (this.get('addon.subGroups')) {
			var selectedProductSpecContainmentID = this.get('selectedProductSpecContainmentID');
			if (selectedProductSpecContainmentID) {
				this.select(selectedProductSpecContainmentID);
			}
		}
		this.set('showConfigurePanel', true);

		this.on('ux-addon-subgroup.selectSubPlan', function (event, subGroupAddon, enabled) {
			if (enabled) {
				this.set('selectedSubGroupAddon', subGroupAddon);
				if (this.get('isAddButton')) {
					this.set('isAddButtonDisabled', false);
					this.set('addon.isAddButtonDisabled', false);
				}
				if (this.get('isUpgradeButton')) {
					this.set('isUpgradeButtonDisabled', false);
					this.set('addon.isUpgradeButtonDisabled', false);
				}
				this.select(subGroupAddon);
			}
		});

		this.on('ux-anchor.viewMore', function (event) {
			this.set('viewMore', true);
		});

		this.on('showConfiguration', function (event) {
			var addonLobs = this.get('showConfigurePanel');
			if (addonLobs === true) {
				addonLobs = false;
			} else {
				addonLobs  = true;
			}
			this.set('showConfigurePanel', addonLobs);
		});

		this.on('*.changedSelectedMonthlySubscription', function (newValue) {
			var perMonthAmount = this.get('addon.monthlyPrice');
			var totalAmount = perMonthAmount * newValue;
			this.set('addon.price', totalAmount);
		});

		this.on('ux-anchor.viewLess', function (event) {
			this.set('viewMore', false);
		});

		this.on('ux-anchor.removeAddonClicked', function (event) {
			var addon = this.getAddonToRemove();
			this.set('addon', addon);
			this.fire('removeAddonClicked', addon);
		
		});
		this.on('ux-anchor.upgradeAddonClicked', function (event) {
			var addon = this.getAddonToRemove();
			var originalAddon = this.get('originalAddon');
			this.set('addon', addon);
			this.fire('upgradeAddonClicked', addon, originalAddon);
		});

		this.on('ux-anchor.addAddonClicked', function (event) {
			var addon = this.getAddonToAdd();
			this.set('addon', addon);
			this.fire(this.get('addAddonClickEvent'), addon);
		});

		this.on('ux-anchor.resendActivationLink', function (event) {
			this.fire('resendActivationLinkEvent', this.get('addon'));
		}.bind(this));
		this.on('ux-anchor.homeInsuranceLink', function (event) {
			this.fire('homeInsuranceLinkEvent');
		}.bind(this));
		this.on('showTooltip', function (event) {

			if (event.original.currentTarget.nextElementSibling.style.display !== 'block') {
				_.each(document.getElementsByClassName('tooltip'), function (v) {
					v.style.display = 'none';
				});
				event.original.currentTarget.nextElementSibling.style.display = 'block';
			} else {
				event.original.currentTarget.nextElementSibling.style.display = 'none';
			}

			return false;
		});
	},
	oncomplete: function () {
		var addon = this.get('addon');
		var isSales = false;
		var isPendingOrder = addon.isPendingOrder;
		var initRemoveTooltip = this.get('initData.removeButtonTooltip');
		this.set('removedDisabledMsg', '');
		addon.removedDisabledMsg = '';
		if (addon.subGroups && addon.subGroups.length > 0) {
			isSales = addon.subGroups[0].sales;
		
		
			var isMyAddon = this.get('isMyAddon') ? true : false;
			var subGroupAddon = _.find(addon.subGroups, function (subgroup) {
				return subgroup.selected;
			});
		
			if (addon.productTitle && addon.productTitle.indexOf('More') > 0) {
				addon = _.extend(addon, subGroupAddon, {selected: isMyAddon}, {isUpgradeButton: isMyAddon});
			} else {
				addon = _.extend(addon, subGroupAddon, {selected: isMyAddon});
			}
		} else {
			isSales = addon.sales;
		}
		if (isSales) {
			var groupType = this.get('groupType');
			if (groupType === 'wifi') {
				if (addon.showAddButton) {
					this.set('isAddButton', true);
				} else if (addon.showUpdateButton) {
					this.set('isAddButton', true);
					this.set('showAddButtonLabel', false);
				}
				if (addon.showRemoveButton) {
					addon.isRemoveButton = true;
				
				} else if (addon.isTwinPack && !this.get('isAddButton')) {
					this.set('showPrice', true);
				}
			} else if (groupType === 'MyAddon') {
				if (addon.action === 'AD') {
					addon.isRemoveButton = true;
					this.set('isRemoveButton', true);
					var removeButton = this.disableRemoveButton(addon, true);
					if (removeButton) {
						addon.isRemoveButtonDisabled = true;
						addon.removedDisabledMsg = initRemoveTooltip;
						this.set('isRemoveButtonDisabled', true);
						this.set('removedDisabledMsg', initRemoveTooltip);
					} else {
						var allowedAction = _.find(addon.allowedActions, function (allowedAction) {
							return allowedAction.type === ConfigStrings.ALLOWED_ACTIONS.REMOVE;
						});
						if (allowedAction && !allowedAction.allowed) {
							addon.isRemoveButtonDisabled = true;
							addon.removedDisabledMsg = initRemoveTooltip;
							this.set('isRemoveButtonDisabled', true);
							this.set('removedDisabledMsg', initRemoveTooltip);
						} else {
						
						
						
						
						
						
						
						
						
						
						
						
						
						
						
						
						
						
						
						
						
							if (addon.subGroups) {
								this.select(addon);
							}
						}
					}
				} else {
					addon.isRemoveButton = true;
					addon.isRemoveButtonDisabled = true;
					addon.removedDisabledMsg = initRemoveTooltip;
					this.set('isRemoveButton', true);
					this.set('isRemoveButtonDisabled', true);
					this.set('removedDisabledMsg', initRemoveTooltip);
				}
			} else {
				if (addon.appendUserName && addon.primaryEmailId) {
					addon.productTitle = addon.productTitle + ' - ' + addon.primaryEmailId + '@singnet.com.sg';
				}
				if (addon.subGroups && addon.subGroups.length > 0) {
					if (this.get('disableGrouping') && this.get('groupType') !== 'MyAddon') {
						addon = _.extend(addon, addon.subGroups[0], { promotionText: addon.promotionText },
							{ productTitle: addon.productTitle },
							{ productDescription: addon.productDescription },
							{ isAddButtonDisabled: true },
							{ faqDescription: addon.faqDescription },
							{ tncDescription: addon.tncDescription },
							{ contract: null});
						this.set('hideContract', true);
						var minPriceAddon = _.min(addon.subGroups, function (subGroup) {
							if (subGroup.price) {
								return Number(subGroup.price);
							}
						});
						if (minPriceAddon && minPriceAddon.price) {
							addon.price = minPriceAddon.price;
						}
						if (this.get('initData.isAccordianEnabled')) {
							this.set('showConfigurePanel', false);
						}
					} else {
						addon.subGroups[0].selected = true;
						addon = _.extend(addon, addon.subGroups[0], { selected: false });
					}
				}
				this.set('isAddButton', true);
				var allowedAction = _.find(addon.allowedActions, function (allowedAction) {
					return allowedAction.type === ConfigStrings.ALLOWED_ACTIONS.ADD;
				});
				if (allowedAction && !allowedAction.allowed) {
					this.set('isAddButtonDisabled', true);
				}else {
					if (addon.groupId) {
					
						this.set('isAddButtonDisabled', true);
					}
				}
			}

			this.set('addon', addon);
		} else {
			var planId = this.get('planId');
			var contractStartDate = this.get('contractStartDate');
			if (addon.applicableForRoamingCredit && planId && contractStartDate) {
				this.applicableForRoamingCredit(addon);
			}
			if (addon.selected) {
				if (addon.isUpgradeButton) {
					this.set('isUpgradeButton', true);
					this.set('isUpgradeButtonDisabled', isPendingOrder ? true : false);
				} else {
					addon.isRemoveButton = true;
					this.set('isRemoveButton', true);
				}
				var relaxRemoveButton = this.disableRemoveButton(addon, false);
				if (relaxRemoveButton) {
				
					addon.removedDisabledMsg = initRemoveTooltip;
					addon.isRemoveButtonDisabled = true;
					this.set('isRemoveButtonDisabled', true);
					this.set('removedDisabledMsg', initRemoveTooltip);
				} else {
					if (addon.allowedActions && !addon.allowedActions[ConfigStrings.ALLOWED_ACTIONS.REMOVE]) {
						addon.isRemoveButtonDisabled = true;
						addon.removedDisabledMsg = initRemoveTooltip;
						this.set('isRemoveButtonDisabled', true);
					
					}
				}
			} else {
				this.set('isAddButton', true);
				if (addon.allowedActions && !addon.allowedActions[ConfigStrings.ALLOWED_ACTIONS.ADD]) {
					addon.isAddButtonDisabled = true;
					this.set('isAddButtonDisabled', true);
				} else {
					if (addon.subGroups) {
					
						addon.isAddButtonDisabled = true;
						this.set('isAddButtonDisabled', true);
					}
				}
			}
			this.set('addon', addon);
		}
			},

	getAddonToRemove: function (addon) {
		var addon = this.get('addon');
		_.extend(addon, {
			action: 'remove'
		});
		return addon;
	},

	disableRemoveButton: function (addon, sales) {
		var aspireBillingOfferIds = this.get('initData.aspireBillingOfferIds');
		var atomicsVasSpsIds = this.get('initData.spsIds');
		var disableRemoveButton = false;
		if ((aspireBillingOfferIds && aspireBillingOfferIds.length > 0) ||
			(atomicsVasSpsIds && atomicsVasSpsIds.length)) {
			if (sales) {
				if (_.contains(aspireBillingOfferIds, addon.addonId) ||
					_.contains(atomicsVasSpsIds, addon.simpleProductSpecID)) {
					disableRemoveButton = true;
				}
			} else {
				if (_.contains(aspireBillingOfferIds, addon.productSpecContainmentID) ||
					_.contains(atomicsVasSpsIds, addon.simpleProductSpecID)) {
					disableRemoveButton = true;
				}
			}

		}
		return disableRemoveButton;
	},

	getAddonToAdd: function (addon) {
		var addon = this.get('addon');
		_.extend(addon, {
			action: 'add'
		});
		return addon;
	},

	applicableForRoamingCredit: function (addon) {
		var planId = this.get('planId');
		var contractStartDate = this.get('contractStartDate');
		var plans = this.get('initData.plans');
		if (plans && plans.length > 0) {
			var plan = _.find(plans, function (plan) {
				return plan.basePriceSchemaId === planId;
			});
			if (plan && plan.aspireLaunchDate &&
				!moment(plan.aspireLaunchDate).isAfter(contractStartDate)) {
				addon.displayRoamingCredit = true;
				this.set('addon', addon);
			}
		}
	}
});

Ractive.components["ux-addon-subgroup"] = Ractive.extend({
	template: LUXComponentTemplates['ux-addon-subgroup'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},
	isolated: true
});

Ractive.components["ux-addon"] = Ractive.extend({
	template: LUXComponentTemplates['ux-addon']
});

Ractive.components["ux-address-form-new"] = Ractive.extend({
	template: LUXComponentTemplates['ux-address-form-new'],
	isolated: true,
	regexAraay: [
		/^#(\d+)-(\d+{\d+-\d+})$/
	],
	data: function () {
		return {
			lables: ConfigStrings.lables
		};
	},

	validateZipCode: function () {
		this.validation.cwd = 'address';
		this.validation.validate();
		this.set('onInitRetrieveAddressDisabled', false);
	},

	enableAddrButton: function () {
		var postalCode = this.get('address.postCode');
		if (postalCode.length === 6) {
			this.validateZipCode();
		} else {
			this.set('onInitRetrieveAddressDisabled', true);
		}
	},

	retrieveAddress: function () {
		var postCode = this.get('address.postCode');
		this.set('address', {
			postCode: postCode
		});
		this.fire('getPostalAddress', this);
		this.initAddressData(postCode);
	},

	initAddressData: function (postCode) {
		this.set('errorMessage', null);
		this.set('blockNumbers', null);
		this.set('floorOptions', null);
		this.set('unitOptions', null);
		this.set('relaxValidationForUnitAddress', false);
		this.set('address.isNotApplicable', false);
		this.set('address.postCode', postCode);
		this.set('address.buildingName', null);
	
	},

	validateFloorAndUnitNumber: function () {
		var relaxValidation = this.get('relaxValidation');
		if (relaxValidation) {
			return true;
		}
		var relaxValidationForUnitAddress = this.get('relaxValidationForUnitAddress');
		if (relaxValidationForUnitAddress) {
			var address = this.get('address');
			if (!_.isEmpty(address.floorUnitNoMap)) {
				address.floorNo = address.floorUnitNoMap['01'][0].floorValue;
				address.unitNo = address.floorNo;
			} else {
				address.floorNo = '';
				address.unitNo = address.floorNo;
			}
			this.set('address', address);
			return true;
		}
		var floorAndUnitAddressMap = this.get('address.floorUnitNoMap');
		var unitNo = this.get('address.unitNo');
		var floorNo = this.get('address.floorNo');
		var addressNotApplicable = this.get('address.isNotApplicable');
		if (addressNotApplicable) {
			if (!_.isEmpty(floorAndUnitAddressMap)) {
				this.set('errorMessage', this.get('initData.floorAndUnitNoReqd') ||
					ConfigStrings.errors.updateAddress.floorNo.required);
				return false;
			}
		} else {
			if (!floorNo || floorNo === 'Select' || !unitNo || unitNo === 'Select') {
				this.set('errorMessage', this.get('initData.floorAndUnitNoReqd') ||
					ConfigStrings.errors.updateAddress.floorNo.required);
				return false;
			}
		}
		this.set('errorMessage', null);
		return true;
	},

	onrender: function () {
		this.set('onInitRetrieveAddressDisabled', true);

		this.on('*.onUnitChange', function (fieldName, unitOption) {
			if (unitOption.unitNoObj) {
				this.set('address.floorNo', unitOption.unitNoObj.floorValue);
			}
			var selectedUnitValue = this.get('address.unitNo');
			var selectedFloorValue = this.get('address.floorNo');
			if (selectedUnitValue && selectedUnitValue !== 'Select' &&
				selectedFloorValue && selectedFloorValue !== 'Select') {
				this.fire('addressNotApplicable', true);
			}
		});

		this.validation = new RactiveValidate(this, {
			'postCode': {
				digits: ConfigStrings.errors.updateAddress.postCode.digits,
				minlength: {
					param: 6,
					message: ConfigStrings.errors.updateAddress.postCode.minlength
				}
			}
		});
		this.observe('address.postCode', function (newVal, oldVal) {
			if (newVal && newVal !== null && oldVal && oldVal !== null && newVal !== oldVal) {
				this.set('errorMessage', null);
				this.set('blockNumbers', null);
				this.set('floorOptions', null);
				this.set('unitOptions', null);
				this.set('address', {
					isNotApplicable: false,
					postCode: newVal
				});
			}
		}.bind(this));

		this.observe('address.buildingName', function (newVal, oldVal) {
			if (typeof newVal === 'undefined' && (oldVal === null || oldVal === '')) {
				this.set('address.buildingName', '');
			}
		}.bind(this));

		this.observe('address.isNotApplicable', function () {
			var isNotApplicable = this.get('address.isNotApplicable');
			var relaxValidationForUnitAddress = this.get('relaxValidationForUnitAddress');
			if (isNotApplicable === true || relaxValidationForUnitAddress) {
				this.set('address.floorNo', '');
				this.set('address.selectedFloor', '');
				this.set('address.unitNo', '');
			}
			this.fire('addressNotApplicable', isNotApplicable);
		}.bind(this));

		this.observe('addressList', this.onAddressListChange, {context: this});

		this.on('ux-input-box.validateZipCode', function (event) {
			this.validateZipCode();
		}.bind(this));

		this.on('ux-button.retrieveAddress', function () {
			this.set('errorMessage', null);
			this.retrieveAddress();
		}.bind(this));

		this.on('ux-input-box.enableAddrButton', function (event) {
			this.enableAddrButton();
		}.bind(this));

		this.on('ux-button.updateAddress', function (event) {
			this.fire(this.get('onUpdate'), this);
		}.bind(this));

		this.on('*.onBlockOrHouseNumChange', function () {
			this.setDefaultAddress();
		}.bind(this));

		this.on('*.onFloorChange', function (fiendNAme, floorOption) {
			this.populateUnitOptions(this.get('address.selectedFloor'));
		}.bind(this));
	},

	onAddressListChange: function (addressList) {
		if (addressList && addressList.length) {
			var addressByBlockNo = this._getAddressesByBlockNo(addressList);
			this.setDefaultAddress();
			console.log(addressByBlockNo);
		}
	},
	setDefaultAddress: function () {
		this.set('relaxValidationForUnitAddress', false);
		var addressByBlockNo = this.get('addressByBlockNo');
		var blockOrHouseNum = this.get('address.blockOrHouseNum');
		var blockNumbers = _.keys(addressByBlockNo);
		var address = addressByBlockNo[blockOrHouseNum || blockNumbers[0]];
		if (blockNumbers.length > 1) {
		
			var blockNumbers = _.map(blockNumbers, function (blockNumber) {
				return {
					text: blockNumber,
					value: blockNumber
				};
			});
			this.set('blockNumbers', blockNumbers);
		}
		this.set('address', _.clone(address));
		this.populateFloorOptions();
	},
	shouldSkipUnitNoFloorNo: function () {
		var address = this.get('address');
		var isSkipUnitFloor = (address.blockOrHouseAddr === 'House' && address.buildingClassification === 'Landed') &&
		((!_.isEmpty(address.floorUnitNoMap) && Object.keys(address.floorUnitNoMap).length === 1 &&
			address.floorUnitNoMap.hasOwnProperty('01') && address.floorUnitNoMap['01'].length === 1) ||
			(_.isEmpty(address.floorUnitNoMap) || !address.floorNo || !address.unitNo));
		this.set('relaxValidationForUnitAddress', isSkipUnitFloor);
		return isSkipUnitFloor;
	},
	populateFloorOptions: function () {
		this.set('floorOptions', null);
		this.set('unitOptions', null);
		var floorUnitNoMap = this.get('address.floorUnitNoMap');
		var floorOptions = _.chain(floorUnitNoMap).map(function (unitNoObj, floorNo) {
			return {text: floorNo, value: floorNo};
		}).sortBy(function (o) {
			if (isNaN(o.text)) {
				return o.text;
			} else {
				return parseInt(o.text, 10);
			}
		}).value();
		this.set('floorOptions', floorOptions);
		this.set('address.floorNo', 'Select');
		this.set('address.unitNo', 'Select');
		var shouldSkipUnitNoFloorNo = this.shouldSkipUnitNoFloorNo();
		if (shouldSkipUnitNoFloorNo) {
			floorOptions = [];
			this.set('address.isNotApplicable', true);
			this.set('floorOptions', floorOptions);
		}
	},
	populateUnitOptions: function (selectedFloor) {
		this.set('address.unitNo', 'Select');
		this.set('unitOptions', null);
		if (selectedFloor) {
			var floorUnitNoMap = this.get('address.floorUnitNoMap');
			var unitList = floorUnitNoMap[selectedFloor];
			var unitOptions = _.chain(unitList).map(function (unitNoObj) {
				return {
					text: unitNoObj.unitNumber,
					value: unitNoObj.unitNumberValue,
					unitNoObj: unitNoObj
				};
			}).sortBy(function (o) {
				if (isNaN(o.text)) {
					return o.text;
				} else {
					return parseInt(o.text, 10);
				}
			}).value();
			this.set('unitOptions', unitOptions);
		}
	},
	_getAddressesByBlockNo: function (addressList) {
		var self = this;
		var addressByBlockNo = _.chain(addressList)
		.groupBy('blockOrHouseNum')
		.omit('undefined').value();
	
		addressByBlockNo = _.chain(addressByBlockNo).map(function (addresses, blockOrHouseNum) {
			var floorUnitNoMap = _.reduce(addresses, function (map, address) {
			if (address.floor && address.unitNumber) {
				var floor = address.floor.trim();
				var unitNumber = address.unitNumber.trim();
				var isFloorUnitSame = false;
				if (floor === unitNumber) {
					isFloorUnitSame = true;
				
				
				
				
				
				
					var lastIndexOfDash = floor.lastIndexOf('-');
					var lastIndexOfSpace = floor.lastIndexOf(' ');
				
					var isRegexMatched = false;
					for (var i = 0; i < self.regexAraay.length; i++) {
						var groups = unitNumber.match(self.regexAraay[i]);
						if (groups) {
							isRegexMatched = true;
							floor = groups[1];
							unitNumber = groups[2];
						}
					}
					if (!isRegexMatched) {
						if (lastIndexOfDash !== -1) {
						
						
							unitNumber = floor.substr(lastIndexOfDash + 1);
							floor = floor.substr(0, lastIndexOfDash);
						} else if (lastIndexOfSpace !== -1) {
						
							unitNumber = floor.substr(lastIndexOfSpace + 1);
							floor = floor.substr(0, lastIndexOfSpace);
						}
					
					}
					floor = floor.replace(/^#/, '');
					unitNumber = unitNumber.replace(/^#/, '');
				}
				var unitNoList = map[floor] || [];
				var unitNoObj = {
					unitNumber: unitNumber,
					unitNumberValue: address.unitNumber,
					floorValue: address.floor
				};
				unitNoList.push(unitNoObj);
				map[floor] = unitNoList;
			}
			return map;
		}, {});

			var addressMetadata = {
				blockOrHouseNum: blockOrHouseNum,
				floorUnitNoMap: floorUnitNoMap,
				buildingName: addresses[0].buildingName,
				buildingClassification: addresses[0].buildingClassification,
				streetName: addresses[0].streetName,
				postCode: addresses[0].postcode,
				blockOrHouseAddr: addresses[0].blockOrHouseAddr,
				floorNo: null,
				unitNo: null,
				type: 'sdpRetrieveAddress'
			};
			return addressMetadata;
		}).reduce(function (memo, addressMetadata) {
			memo[addressMetadata.blockOrHouseNum] = addressMetadata;
			return memo;
		}, {}).value();
		console.log(addressByBlockNo);
		this.set('addressByBlockNo', addressByBlockNo);
		return addressByBlockNo;
	}
});

Ractive.components["ux-address-form"] = Ractive.extend({
	template: LUXComponentTemplates['ux-address-form'],
	isolated: true,
	regexAraay: [
		/^#(\d+)-(\d+{\d+-\d+})$/
	],
	data: function () {
		return {
			lables: ConfigStrings.lables
		};
	},

	validateZipCode: function () {
		this.validation.cwd = 'address';
		this.validation.validate();
		this.set('onInitRetrieveAddressDisabled', false);
	},

	enableAddrButton: function () {
		var postalCode = this.get('address.postCode');

		if (postalCode.length === 6) {
			this.validateZipCode();
		} else {
			this.set('onInitRetrieveAddressDisabled', true);
		}
	},

	retrieveAddress: function () {
		var postCode = this.get('address.postCode');
		this.set('address', {
			postCode: postCode
		});
		this.fire('getAddress', this);
		this.initAddressData(postCode);
	},

	initAddressData: function (postCode) {
		this.set('errorMessage', null);
		this.set('blockNumbers', null);
		this.set('floorOptions', null);
		this.set('unitOptions', null);
		this.set('relaxValidationForUnitAddress', false);
		this.set('address.isNotApplicable', false);
		this.set('address.postCode', postCode);
		this.set('address.buildingName', null);
	
	},

	validateFloorAndUnitNumber: function () {
		var relaxValidation = this.get('relaxValidation');
		if (relaxValidation) {
			return true;
		}
		var relaxValidationForUnitAddress = this.get('relaxValidationForUnitAddress');
		if (relaxValidationForUnitAddress) {
			var address = this.get('address');
			if (!_.isEmpty(address.floorUnitNoMap)) {
				address.floorNo = address.floorUnitNoMap['01'][0].floorValue;
				address.unitNo = address.floorNo;
			} else {
				address.floorNo = '';
				address.unitNo = address.floorNo;
			}
			this.set('address', address);
			return true;
		}
		var floorAndUnitAddressMap = this.get('address.floorUnitNoMap');
		var unitNo = this.get('address.unitNo');
		var floorNo = this.get('address.floorNo');
		var addressNotApplicable = this.get('address.isNotApplicable');
		if (addressNotApplicable) {
			if (!_.isEmpty(floorAndUnitAddressMap)) {
				this.set('errorMessage', this.get('initData.floorAndUnitNoReqd') ||
					ConfigStrings.errors.updateAddress.floorNo.required);
				return false;
			}
		} else {
			if (!floorNo || floorNo === 'Select' || !unitNo || unitNo === 'Select') {
				this.set('errorMessage', this.get('initData.floorAndUnitNoReqd') ||
					ConfigStrings.errors.updateAddress.floorNo.required);
				return false;
			}
		}
		this.set('errorMessage', null);
		return true;
	},

	onrender: function () {
		this.set('onInitRetrieveAddressDisabled', true);

		this.on('*.onUnitChange', function (fieldName, unitOption) {
			if (unitOption.unitNoObj) {
				this.set('address.floorNo', unitOption.unitNoObj.floorValue);
			}
			var selectedUnitValue = this.get('address.unitNo');
			var selectedFloorValue = this.get('address.floorNo');
			if (selectedUnitValue && selectedUnitValue !== 'Select' &&
				selectedFloorValue && selectedFloorValue !== 'Select') {
				this.fire('addressNotApplicable', true);
			}
		});

		this.validation = new RactiveValidate(this, {
			'postCode': {
				digits: ConfigStrings.errors.updateAddress.postCode.digits,
				minlength: {
					param: 6,
					message: ConfigStrings.errors.updateAddress.postCode.minlength
				}
			}
		});

		this.observe('address.buildingName', function (newVal, oldVal) {
			if (typeof newVal === 'undefined' && (oldVal === null || oldVal === '')) {
				this.set('address.buildingName', '');
			}
		}.bind(this));

		this.observe('address.isNotApplicable', function () {
			var isNotApplicable = this.get('address.isNotApplicable');
			var relaxValidationForUnitAddress = this.get('relaxValidationForUnitAddress');
			if (isNotApplicable === true || relaxValidationForUnitAddress) {
				this.set('address.floorNo', '');
				this.set('address.unitNo', '');
			}
			this.fire('addressNotApplicable', isNotApplicable);
		}.bind(this));

		this.observe('addressList', this.onAddressListChange, {context: this});

		this.on('ux-input-box.validateZipCode', function (event) {
			this.validateZipCode();
		}.bind(this));

		this.on('ux-button.retrieveAddress', function () {
			this.retrieveAddress();
		}.bind(this));

		this.on('ux-input-box.enableAddrButton', function (event) {
			this.enableAddrButton();
		}.bind(this));

		this.on('ux-button.updateAddress', function (event) {
			this.fire(this.get('onUpdate'), this);
		}.bind(this));

		this.on('*.onBlockOrHouseNumChange', function () {
			this.setDefaultAddress();
		}.bind(this));

		this.on('*.onFloorChange', function (fiendNAme, floorOption) {
			this.populateUnitOptions(floorOption.value);
		}.bind(this));
	},

	onAddressListChange: function (addressList) {
		if (addressList && addressList.length) {
			var addressByBlockNo = this._getAddressesByBlockNo(addressList);
			this.setDefaultAddress();
			console.log(addressByBlockNo);
		}
	},
	setDefaultAddress: function () {
		this.set('relaxValidationForUnitAddress', false);
		var addressByBlockNo = this.get('addressByBlockNo');
		var blockOrHouseNum = this.get('address.blockOrHouseNum');
		var blockNumbers = _.keys(addressByBlockNo);
		var address = addressByBlockNo[blockOrHouseNum || blockNumbers[0]];
		if (blockNumbers.length > 1) {
		
			var blockNumbers = _.map(blockNumbers, function (blockNumber) {
				return {
					text: blockNumber,
					value: blockNumber
				};
			});
			this.set('blockNumbers', blockNumbers);
		}
		this.set('address', _.clone(address));
		this.populateFloorOptions();
	},
	shouldSkipUnitNoFloorNo: function () {
		var address = this.get('address');
		var isSkipUnitFloor = (address.blockOrHouseAddr === 'House' && address.buildingClassification === 'Landed') &&
			((!_.isEmpty(address.floorUnitNoMap) && Object.keys(address.floorUnitNoMap).length === 1 &&
			address.floorUnitNoMap.hasOwnProperty('01') && address.floorUnitNoMap['01'].length === 1) ||
			(_.isEmpty(address.floorUnitNoMap) || !address.floorNo || !address.unitNo));
		this.set('relaxValidationForUnitAddress', isSkipUnitFloor);
		return isSkipUnitFloor;
	},
	populateFloorOptions: function () {
		this.set('floorOptions', null);
		this.set('unitOptions', null);
		var floorUnitNoMap = this.get('address.floorUnitNoMap');
		var floorOptions = _.chain(floorUnitNoMap).map(function (unitNoObj, floorNo) {
			return {text: floorNo, value: floorNo};
		}).sortBy(function (o) {
			if (isNaN(o.text)) {
				return o.text;
			} else {
				return parseInt(o.text, 10);
			}
		}).value();
		this.set('floorOptions', floorOptions);
		this.set('address.floorNo', 'Select');
		this.set('address.unitNo', 'Select');
		var shouldSkipUnitNoFloorNo = this.shouldSkipUnitNoFloorNo();
		if (shouldSkipUnitNoFloorNo) {
			floorOptions = [];
			this.set('address.isNotApplicable', true);
			this.set('floorOptions', floorOptions);
		}
	},
	populateUnitOptions: function (selectedFloor) {
		this.set('address.unitNo', 'Select');
		this.set('unitOptions', null);
		if (selectedFloor) {
			var floorUnitNoMap = this.get('address.floorUnitNoMap');
			var unitList = floorUnitNoMap[selectedFloor];
			var unitOptions = _.chain(unitList).map(function (unitNoObj) {
				return {
					text: unitNoObj.unitNumber,
					value: unitNoObj.unitNumberValue,
					unitNoObj: unitNoObj
				};
			}).sortBy(function (o) {
				if (isNaN(o.text)) {
					return o.text;
				} else {
					return parseInt(o.text, 10);
				}
			}).value();
			this.set('unitOptions', unitOptions);
		}
	},
	_getAddressesByBlockNo: function (addressList) {
		var self = this;
		var addressByBlockNo = _.chain(addressList)
		.groupBy('blockOrHouseNum')
		.omit('undefined').value();
	
		addressByBlockNo = _.chain(addressByBlockNo).map(function (addresses, blockOrHouseNum) {
			var floorUnitNoMap = _.reduce(addresses, function (map, address) {
			if (address.floor && address.unitNumber) {
				var floor = address.floor.trim();
				var unitNumber = address.unitNumber.trim();
				var isFloorUnitSame = false;
				if (floor === unitNumber) {
					isFloorUnitSame = true;
				
				
				
				
				
				
					var lastIndexOfDash = floor.lastIndexOf('-');
					var lastIndexOfSpace = floor.lastIndexOf(' ');
				
					var isRegexMatched = false;
					for (var i = 0; i < self.regexAraay.length; i++) {
						var groups = unitNumber.match(self.regexAraay[i]);
						if (groups) {
							isRegexMatched = true;
							floor = groups[1];
							unitNumber = groups[2];
						}
					}
					if (!isRegexMatched) {
						if (lastIndexOfDash !== -1) {
						
						
							unitNumber = floor.substr(lastIndexOfDash + 1);
							floor = floor.substr(0, lastIndexOfDash);
						} else if (lastIndexOfSpace !== -1) {
						
							unitNumber = floor.substr(lastIndexOfSpace + 1);
							floor = floor.substr(0, lastIndexOfSpace);
						}
					
					}
					floor = floor.replace(/^#/, '');
					unitNumber = unitNumber.replace(/^#/, '');
				}
				var unitNoList = map[floor] || [];
				var unitNoObj = {
					unitNumber: unitNumber,
					unitNumberValue: address.unitNumber,
					floorValue: address.floor
				};
				unitNoList.push(unitNoObj);
				map[floor] = unitNoList;
			}
			return map;
		}, {});

			var addressMetadata = {
				blockOrHouseNum: blockOrHouseNum,
				floorUnitNoMap: floorUnitNoMap,
				buildingName: addresses[0].buildingName,
				buildingClassification: addresses[0].buildingClassification,
				streetName: addresses[0].streetName,
				postCode: addresses[0].postcode,
				blockOrHouseAddr: addresses[0].blockOrHouseAddr,
				floorNo: null,
				unitNo: null,
				type: 'sdpRetrieveAddress'
			};
			return addressMetadata;
		}).reduce(function (memo, addressMetadata) {
			memo[addressMetadata.blockOrHouseNum] = addressMetadata;
			return memo;
		}, {}).value();
		console.log(addressByBlockNo);
		this.set('addressByBlockNo', addressByBlockNo);
		return addressByBlockNo;
	}
});

Ractive.components["ux-alert"] = Ractive.extend({
	template: LUXComponentTemplates['ux-alert']
});

Ractive.components["ux-anchor-location"] = Ractive.extend({
	template: LUXComponentTemplates['ux-anchor-location'],

	setScrollStyling : function () {
		var headerHeight = $('.ux-header-singtel').outerHeight();
		var cookieConsentBannerHeight = $('.consent-banner-singtel').outerHeight();
		$('.ux-anchor-location').css('scroll-margin-top', headerHeight + cookieConsentBannerHeight);
	},
	onrender : function () {
		var self = this;
		if (window.location.hash) {
			window.onload = (function () {
				setTimeout(function () {
					var hash = window.location.hash;
					window.location.hash = '';
					window.location.hash = hash;
					self.setScrollStyling();
				}, 1000);
			}());
		}
	}
});

Ractive.components["ux-anchor"] = Ractive.extend({
	template: LUXComponentTemplates['ux-anchor'],
	isolated: true,
	events: {
		enter: RactiveEventsKeys.enter
	},
	computed: {
		guid: function () {
			return this._guid;
		}
	},
	fireEvent: function (event,customEvent,selfObj) {
		if (customEvent) {
			var customParams = customEvent.split(':');
			var customEventName = customParams[0];
			if (customParams.length > 1) {
				var params = customParams[1].split(',');
			
				selfObj.fire.apply(this, [customEventName, this].concat(params));
			} else {
				selfObj.fire(customEvent, this);
			}
			event.original.preventDefault();
		}
	},
	onconfig: function () {
		this.on('anchorClicked', function (event) {
			if (this.get('type') === 'modal') {
				var jsonObj = this.get('pmodalData');
				Ractive.defaults.fire('openUXPModal', event, this.get('id'), jsonObj);
			} else {
				var customEvent = this.get('ontap') || this.get('onclick');
				this.fireEvent(event, customEvent, this);
			}
		});
		this.on('anchorMouseDwon', function (event) {
			var customEvent = this.get('onmousedown');
			if (customEvent) {
				this.fireEvent(event, customEvent, this);
			}
		});
	}
});

Ractive.components["ux-ask-francis"] = Ractive.extend({
	template: LUXComponentTemplates['ux-ask-francis'],
	oninit: function () {
		this.storage = localStorage;
		var self = this;
		this.set('enable', true);
		this.set('showChatPopup', false);
		self.setTriggerIcon();
		this.set('hidePopUp', false);
		this.on('*.doCisChatMove', function (event) {
			this.cisChat = this.el.querySelector('.ux-francis.show');
			if (!this.cisChat.classList.contains('move-handled')) {
				this.handleChatMoveAndResize('move');
				this.cisChat.classList.add('move-handled');
			}
		});
		this.on('*.doCisChatMinimize', function (event) {
			this.set('showChatPopup', false);
			this.set('enable', true);
		});
		this.on('*.openCisChatModal', function (event) {
			self.set('hidePopUp', true);
			self.set('showChatPopup', true);
			this.set('enable', false);
		});
	},
	setTriggerIcon: function () {
		var self = this;
				var screenSize = window.innerWidth;

		if (screenSize > ConfigStrings.mediaBreakpoints.small) {
			var hours  = moment(new Date()).hours();
			if (hours > 4 && hours < 12) {
				self.set('popupImage', self.get('franCisPopUpImageMorning'));
			} else if (hours >= 12 && hours <= 17) {
				self.set('popupImage', self.get('franCisPopUpImageAfternoon'));
			} else {
				self.set('popupImage', self.get('franCisPopUpImageEvening'));
			}

			self.set('hidePopUp', false);

			setTimeout(function () {
				self.set('hidePopUp', true);
			}, self.get('messageDuration'));
		}
	},
	handleChatMoveAndResize: function () {
		var self = this;
		this.cisChat = this.el.querySelector('.ux-francis.show');
		var icon = this.el.querySelector('.pan.move');
		icon.classList.remove('disabled');

	
		var chatBounding;

	
		var xOrigin, yOrigin;
		var pointerXOrigin, pointerYOrigin;
		var containerBounding = document.body.getBoundingClientRect();

	

		var mc = new Hammer(icon);
		mc.get('pan').set({
			direction: Hammer.DIRECTION_ALL,
			threshold: 1
		});

		mc.on('panstart', function (event) {
			icon.classList.add('user-action');
		
			chatBounding = self.cisChat.getBoundingClientRect();
		
			xOrigin = containerBounding.right - chatBounding.right;
			yOrigin = containerBounding.bottom - chatBounding.bottom;

			pointerXOrigin = event.pointers[0].clientX;
			pointerYOrigin = event.pointers[0].clientY;

		

			this.xMin = 0;
			this.yMin = 0;
			this.xMax = containerBounding.width - chatBounding.width;
			this.yMax = containerBounding.height - chatBounding.height;

			return false;
		}.bind(this));

		mc.on('pan', function (event) {
			var newX = pointerXOrigin - event.pointers[0].clientX;
			var newY = pointerYOrigin - event.pointers[0].clientY;
			var moveX = false;
			var moveY = false;
			var px = xOrigin + newX;
			var py = yOrigin + newY;
			moveX = (px > 0 && px < this.xMax);
			moveY = (py > 0 && py < this.yMax);
			if (moveX) {
				this.storage.vaPosX = px;
				this.cisChat.style.right = px + 'px';
			}
			if (moveY) {
				this.storage.vaPosY = py;
			
				this.cisChat.style.bottom = py + 'px';
			}
			return false;

		}.bind(this));

		mc.on('panmove panleft panright panup pandown', function (event) {

			var newX = pointerXOrigin - event.pointers[0].clientX;
			var newY = pointerYOrigin - event.pointers[0].clientY;
			var moveX = false;
			var moveY = false;
			var px = xOrigin + newX;
			var py = yOrigin + newY;
			moveX = (px > this.xMin && px < this.xMax);
			moveY = (py > this.yMin && py < this.yMax);
			if (moveX) {
				this.storage.vaPosX = px;
				this.cisChat.style.right = px + 'px';
			}
			if (moveY) {
				this.storage.vaPosY = py;
			
				this.cisChat.style.bottom = py + 'px';
			}
			return false;

		}.bind(this));
		mc.on('panend', function (event) {
			icon.classList.remove('user-action');
			return false;
		}.bind(this));

	}
});

Ractive.components["ux-ask-shirley"] = Ractive.extend({
	template: LUXComponentTemplates['ux-ask-shirley'],
	isolated: false,
	setCookie: function (name,value,expires,path,domain,secure) {
		document.cookie = name + '=' + encodeURI (value) +
			((expires) ? '; expires=' + expires.toGMTString() : '') +
			((path) ? '; path=' + path : '') +
			((domain) ? '; domain=' + domain : '') +
			((secure) ? '; secure' : '');
	},
	getCookieVal: function (offset) {
		var endstr = document.cookie.indexOf (';', offset);
		if (endstr === -1) {
			endstr = document.cookie.length;
		}
		return decodeURI(document.cookie.substring(offset, endstr));
	},
	getCookie: function (name) {
		var arg = name + '=';
		var alen = arg.length;
		var clen = document.cookie.length;
		var i = 0;
		while (i < clen) {
			var j = i + alen;
			if (document.cookie.substring(i, j) === arg) {
				return this.getCookieVal (j);
			}
			i = document.cookie.indexOf(' ', i) + 1;
			if (i === 0) {
				break;
			}
		}
		return null;
	},
	retrieveAnswer: function () {
		var self = this;
		var question = self.find('#question').value || '';
		Ractive.defaults.fire('askShirley_openFaqModal', question);
	},

	onrender: function () {
		this.on('ux-button.doAsk ux-input-box.doAsk', function () {
			this.retrieveAnswer();
		}.bind(this));
	}

});

Ractive.components["ux-avatar-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-avatar-singtel'],

	computed : {
		avatarImg : function () {
			var account = this.get('account');
			var avatars = this.getAvatarListAsPerAccountType();

			var avatarImg = null;
			_.each(avatars, function (avatar) {
				if (avatar.id === account.avatar) {
					avatarImg = avatar;
					avatarImg.selected = false;
				}
			});
			console.log(avatarImg);
			return avatarImg;
		}
	},

	getAvatarListAsPerAccountType : function () {
		var self = this;
		var account = self.get('account');
		var avatars = null;

		if (account.isEasyMobile) {
			avatars = this.get('initData.emAvatarImages');
		} else {
			avatars = this.get('initData.opAvatarImages');
		}
		console.log(avatars);
		return avatars;
	}
});

Ractive.components["ux-background-image"] = Ractive.extend({
	template: LUXComponentTemplates['ux-background-image'],
	oninit: function () {
		var self = this;
		var mobileImgSrc = self.get('mobile.src') || self.get('desktop.src');
		var mobileImgAlt = self.get('mobile.alt') || self.get('desktop.alt');
		self.set('mobile.src', mobileImgSrc);
		self.set('mobile.alt', mobileImgAlt);
	}
});

Ractive.components["ux-banner-overlap"] = Ractive.extend({
	template: LUXComponentTemplates['ux-banner-overlap'],

	oninit: function () {
		this.on('ux-anchor.onTap', function (event) {
			this.doPrint();
		}.bind(this));
	},

	doPrint: function () {
		window.print();
	}
});

Ractive.components["ux-banner-tab"] = Ractive.extend({
	template: LUXComponentTemplates['ux-banner-tab'],

	oninit: function () {
		var self = this;
		var tabData = self.get('tabData');
		self.set('tabActiveIndex', null);

		var defaultTabSelectedArr = _.map(tabData, function (item) {
			return item.fullWidthBannerData.defaultTabSelected;
		});

		_.each(defaultTabSelectedArr, function (item, i) {
			if (item === true) {
				self.set('tabActiveIndex', i);
			}
		});

		if (self.get('tabActiveIndex') === null) {
			self.set('tabActiveIndex', 0);
		}

		self.on('onTabClicked', function (event, id) {
			event.original.preventDefault();
			self.set('tabActiveIndex', id);
		});

	}
});

Ractive.components["ux-barchart"] = Ractive.extend({
	template: LUXComponentTemplates['ux-barchart'],

	data: function () {
		return {
			moment: moment,
			RactiveHelpers: RactiveHelpers
		};
	},

	oninit: function () {
		var self = this;
		self.observe('barList', function (barList) {
			if (barList && barList.length) {
				var highest = 1;
				var barList = this.get('barList');
				var initialMaxCreditTop = 30;
				var finalMaxCreditTop = 30;
				var totalChargesWithoutBalance = 0;
			
				for (var i = 0; i < barList.length; i++) {
					totalChargesWithoutBalance = barList[i].totalChargesWithoutBalance;
					if (totalChargesWithoutBalance < 0) {
						self.set('hasCreditBalance', true);
					}
					if (highest < (Math.abs(totalChargesWithoutBalance))) {
						highest = Math.abs(totalChargesWithoutBalance);
					}
				}
				var maxGraphHeight = highest / 100;
				self.set('highest', maxGraphHeight);
				var calculatedHeight = 0;
				for (var i = 0; i < barList.length; i++) {
					totalChargesWithoutBalance = barList[i].totalChargesWithoutBalance;
					calculatedHeight = (Math.abs((totalChargesWithoutBalance / maxGraphHeight) * 16) / 6.25) + 30;
					if (totalChargesWithoutBalance < 0) {
						if (finalMaxCreditTop < calculatedHeight) {
							finalMaxCreditTop = calculatedHeight;
						}
					}
				}
				self.set('finalMaxCreditTop', finalMaxCreditTop);
				self.set('initialMaxCreditTop', initialMaxCreditTop);
				var amountArray = [];
				var incrementAmount = Math.ceil(highest / 4);
				amountArray[0] = 0 ;
				for (var i = 1; i < 5; i++) {
					amountArray[i] =  amountArray[i - 1] + incrementAmount;
				}
				amountArray = _.sortBy(amountArray).reverse();
				self.set('amountArray', amountArray);
			}
		});
	}
});

Ractive.components["ux-benefit-component"] = Ractive.extend({
	template: LUXComponentTemplates['ux-benefit-component']
});

Ractive.components["ux-bill-explainer-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-bill-explainer-singtel'],

	oninit: function () {
		var self = this;

		var spacings = ['small', 'medium', 'large'];

	
		var topSpacing = self.get('topSpacing');
		topSpacing = _.indexOf(spacings, topSpacing) !== -1 ?
			self.set('topSpacing', topSpacing) : self.set('topSpacing', 'normal');

	
		var btmSpcng = self.get('bottomSpacing');
		btmSpcng = _.indexOf(spacings, btmSpcng) !== -1 ?
			self.set('bottomSpacing', btmSpcng) : self.set('bottomSpacing', 'normal');


		var billTabInfo = self.get('billTabInfo');
		_.each(billTabInfo, function (v, index) {
			v.tabIndex = self._guid + index;
		});
		self.set('billTabInfo', billTabInfo);

		self.on('*.changeTab', function (event) {
			self.set('messageState', '');
			self.set('infoClickedStatus.*', '');
			self.lastDotSelected.set({'highlightState' : ''});
			self.update();
		});

	},

	onrender: function () {
		var self = this;

		self.on('ux-tabpanes.showBillInfoForPoint', function (proxyEvent, imgIdx, message, dotIdx) {
			if ('mouseover' === proxyEvent.original.type) {
				self.set({
					'billMessage': message,
					'msgTopPos': self.calculateTopPos(proxyEvent, imgIdx, proxyEvent.context.y),
					'label': proxyEvent.context.label,
					'messageState': 'show'
				});
				var ypos = self.calculateTopPos(proxyEvent, imgIdx, proxyEvent.context.highlight.y) + 15;
				proxyEvent.component.component.instance.set({
					'highlightState': 'show',
					'highlightX': proxyEvent.context.highlight.x,
					'highlightY': ypos,
					'highlightW': proxyEvent.context.highlight.width,
					'highlightH': proxyEvent.context.highlight.height
				});
				self.lastDotSelected = proxyEvent.component.component.instance;
				self.set('infoClickedStatus.*', '');
				self.set('infoClickedStatus.' + imgIdx + dotIdx, 'selected');
				self.update();
			} else if ('mouseleave' === proxyEvent.original.type) {
				self.set({
					'billMessage': message,
					'msgTopPos': self.calculateTopPos(proxyEvent, imgIdx, proxyEvent.context.y),
					'label': proxyEvent.context.label,
					'messageState': 'show'
				});
				var ypos = self.calculateTopPos(proxyEvent, imgIdx, proxyEvent.context.highlight.y) + 15;
				proxyEvent.component.component.instance.set({
					'highlightState': '',
					'highlightX': proxyEvent.context.highlight.x,
					'highlightY': ypos,
					'highlightW': proxyEvent.context.highlight.width,
					'highlightH': proxyEvent.context.highlight.height
				});
				self.lastDotSelected = proxyEvent.component.component.instance;
				self.set('infoClickedStatus.*', '');
				self.set('infoClickedStatus.' + imgIdx + dotIdx, 'selected');
				self.update();
			}
		});

	},

	calculateTopPos: function (proxyEvent, idx, ypos) {
		var imgHeight = proxyEvent.component.el.getElementsByTagName('img')[idx].height + 20;
		return (imgHeight * Number(idx)) + Number(ypos);
	}
});

Ractive.components["ux-billing-accounts"] = Ractive.extend({
	template: LUXComponentTemplates['ux-billing-accounts'],
	data : function () {
		return {
			ConfigStrings : ConfigStrings,
			RactiveHelpers : RactiveHelpers
		};
	},
	selectAccount: function (event, value) {
		this.set('accounts.*.isSelected', false);
		this.set(event.keypath + '.isSelected', true);
		this.fire('selectBillingAccount');
	},
	onrender: function () {
		this.on('doSelectAccount', function (event, value) {
			this.selectAccount(event, value);
		}.bind(this));
	}
});

Ractive.components["ux-billing-details"] = Ractive.extend({
	template: LUXComponentTemplates['ux-billing-details'],
	isolated: true,
	data : function () {
		return {
			ConfigStrings : ConfigStrings,
			onUpdate: 'createBilling',
			hasChangedBillAddress: false,
			RactiveHelpers: RactiveHelpers
		};
	},
	onSelectAccount: function (value, selectedAddress) {
		this.set('selectedBillingId', null);
		this.parent.set('selectedBillingId', null);
		if (value === -1) {
			var address = this.get('orderFullfilment.billingDetails.contactAddress') || selectedAddress;
			address.state = ConfigStrings.physicalAddressValues.state;
			address.country = ConfigStrings.physicalAddressValues.country;
			this.parent.set('selectedBillingAddress', address);
			this.onBillAddressSelect(value, address);
		} else if (value === -2) {
			var address = this.get('orderFullfilment.billingDetails.installationAddress') || selectedAddress;
			address.state = ConfigStrings.physicalAddressValues.state;
			address.country = ConfigStrings.physicalAddressValues.country;
			this.parent.set('selectedBillingAddress', address);
			this.onBillAddressSelect(value, address);
		} else if (value === -3) {
			var address = this.get('orderFullfilment.billingDetails.newAddress') || selectedAddress;
			address.state = ConfigStrings.physicalAddressValues.state;
			address.country = ConfigStrings.physicalAddressValues.country;
			this.parent.set('selectedBillingAddress', address);
			this.onBillAddressSelect(value, address);
		} else {
			this.parent.set('selectedBillingId', value);
			var accounts = this.get('accounts');
			accounts = _.where(accounts, {billingAccountNumber: value})[0].physicalAddress;
			this.parent.set('selectedBillingAddress', accounts);
			this.onBillAddressSelect(value, accounts);
		}
		if (selectedAddress) {
			var inputElement = document.getElementsByName('select-billing-account');
			var elementId = value < 0 ? (selectedAddress.postcode || selectedAddress.postCode) :
			selectedAddress.billingAccountNumber;
			_.find(inputElement, function (element) {
				if (element.value === elementId) {
					element.checked = true;
				}
			});
		}
		this.set('selectedAddress', true);
		this.checkIfAllDataSelected();
		this.set('addressRetrieve.addressList', undefined);
		var hasChangedBillAddress = this.get('hasChangedBillAddress');
		if (hasChangedBillAddress) {
			Ractive.defaults.fire('onBillAddChange', event, this.get());
		}
	},

	onrender: function () {
		this.set('selectedAddress', false);
		this.set('disableDeliveryConfirmButton', true);
		this.on('selectAccount', function (event, value) {
			this.onSelectAccount(value);
		}.bind(this));

		this.observe('orderFullfilment.billingDetails.selectedBillOption', function (selectedBillOption) {
			if (selectedBillOption) {
				this.parent.set('billType', selectedBillOption);
				this.set('selected', selectedBillOption);
				this.set('billMethodSelected', true);
				this.checkIfAllDataSelected();
			}
		}.bind(this));

		this.on('*.eBillNext', function (btn) {
			this.ebillNext();
		}.bind(this));

		this.on('*.billMethodSelected', function (event, context) {
			this.setBillType();
		}.bind(this));

		this.on('*.getAddress', function (event) {
			this.set('selectedAddress', false);
			this.fire('getCustomerAddress', event, 'billing');
		}.bind(this));

		this.on('*.getPostalAddress', function (event) {
			this.fire('getPostAddress', event, 'billing');
		}.bind(this));

		this.on('*.createBilling', function (event, value) {
			var errorFlag = false;
			this.findComponent('ux-address-form').set('errorMessage', false);
			var address = this.get('addressRetrieve.address');
			if (!address.postCode || (address.postCodeErrorMsg && address.postCodeErrorMsg.status === 'error')) {
				errorFlag = true;
			}
			var isValid = this.findComponent('ux-address-form').validateFloorAndUnitNumber();
			if (!errorFlag && isValid) {
				this.set('selectedAddress', true);
				this.set('toConfirmNewAddress', true);
			}
		}.bind(this));

		this.on('*.showAddNewAddressWindow', function (event, value) {
			this.resetToDefaultValues();
			this.toggleModal('addNewBillingAddress', true);
		}.bind(this));

		this.on('*.changeNewAddress', function (event, value) {
			this.resetToDefaultValues();
		}.bind(this));

		this.on('*.doCloseModal', function () {
			this.resetToDefaultValues();
			this.findComponent('ux-modal').set('displayState', false);
			this.set('toConfirmNewAddress', false);
			return false;
		});

		this.on('*.confirmAddNewAddress', function (event, value) {
			var retrievedAddress = _.clone(this.get('addressRetrieve.address'));
			this.set('orderFullfilment.billingDetails.newAddress', retrievedAddress);
			this.set('toConfirmNewAddress', false);
			var newAddressAdded = this.get('newAddressAdded');
			if (!newAddressAdded) {
				newAddressAdded = [];
			}
			newAddressAdded.push(retrievedAddress);
			var index = newAddressAdded.length - 1;
			_.each(newAddressAdded, function (item) {
				item.chkId = false;
			});
			newAddressAdded[index].chkId = true;
			this.set('newAddressAdded', newAddressAdded);
			this.toggleModal('addNewBillingAddress', false);
			this.onSelectAccount(-3);
		}.bind(this));

		this.set('eBill', true);
		this.observe('addressRetrieve.addressVMStatus', function (value) {
			if (value === 'getAddressSuccess') {
				this.set('disableDeliveryConfirmButton', false);
			}
		}.bind(this));

		this.observe('orderFullfilment.billingDetails.billingAccountDetails', function (value) {
			this.onAvatarChange(value);
		}.bind(this));

		this.on('onSelectNewAddress', function (event, value) {
			var address = event.context.address || event.context;
			address.state = ConfigStrings.physicalAddressValues.state;
			address.country = ConfigStrings.physicalAddressValues.country;
			address.postcode = address.postCode;
			this.parent.set('selectedBillingId', null);
			this.parent.set('selectedBillingAddress', address);
			var billingButton = document.getElementsByClassName('paper-bill-option');
			if (billingButton && billingButton.length > 0) {
				billingButton[0].scrollIntoView({block: 'start', behavior: 'smooth'});
			} else {
				document.getElementsByClassName('paper-bill-option-button')[0].
				scrollIntoView({block: 'start', behavior: 'smooth'});
			}
			this.resetScrollHeight();
			var hasChangedBillAddress = this.get('hasChangedBillAddress');
			if (hasChangedBillAddress) {
				Ractive.defaults.fire('onBillAddChange', event, this.get());
			}
		}.bind(this));

		this.parent.on('disableBillingConfirmationButton', function () {
			var allRadios = document.getElementsByName('select-account');
			_.each(allRadios, function (v) {
				v.checked = false;
			});
			this.set('disableDeliveryConfirmButton', false);
		}.bind(this));

	},
	onBillAddressSelect: function (value, address) {
		var selectedAddress = {
			value: value,
			address: address
		};
		sessionStorage.setItem('selectedBillingAddress', JSON.stringify(selectedAddress));
	},
	setBillType: function () {
		var selected = this.get('selected');
		this.parent.set('paperBill',
			(selected === 'e_bill' ? true : false));
		this.parent.set('billType', selected);
		this.set('billMethodSelected', true);
		sessionStorage.setItem('billType', selected);
		this.checkIfAllDataSelected();
	},
	ebillNext: function () {
		var isNewAdd = this.parent.get('newAddressForm'),
		isValid = (isNewAdd === 'billing' ? false : true);
		if (isNewAdd === 'billing') {
			isValid = this.validateAddress(this.get('addressRetrieve.address'), 'sdpRetrieveAddress');
			if (isValid) {
				var address = this.get('addressRetrieve.address');
				address.state = ConfigStrings.physicalAddressValues.state;
				address.country = ConfigStrings.physicalAddressValues.country;
				address.postcode = address.postCode;
				this.parent.set('selectedBillingId', null);
				this.parent.set('selectedBillingAddress', address);
			}
		}
		if (isValid) {
			this.fire('onEBillNext', {context: this});
			this.set('hasChangedBillAddress', true);
			Ractive.defaults.fire('onEBillNext', event, this.get());
			var docNeeded = ((this.get('orderFullfilment.billingDetails.hasSim') &&
				!this.get('orderFullfilment.billingDetails.needsOnlyMBBDelivery')) ||
				this.get('orderFullfilment.billingDetails.homeLineDeliveryRequired') ||
				this.get('orderFullfilment.deliveryDetails.installationRequired') ||
				this.get('idDocumentsUpload.documentNeeded')) ||
				(this.get('isRedemptionRequired') && this.get('isPremiumProduct'));
			if (!docNeeded) {
				this.fire('continueWithSummary');
			}
		}
	},
	onAvatarChange : function (value) {
		var self = this;
		var accounts = value;
		var emAvatars = this.get('initData.emAvatarImages');
		var opAvatar = this.get('initData.opAvatarImages');
		var selectedAddress = self.get('orderFullfilment.billingDetails.selectedAddress');
		var addressFound = false;
		if (typeof accounts === 'undefined' || accounts === null ||
			accounts.length === 0) {
			self.set('eBill', false);
		}
		var finalAccounts = [];
		_.each(accounts, function (account, key) {
			var avatars = null;

			if (account.easyMobileInd === 'Y' || account.easyMobileInd === 'y' || account.easyMobileInd === true) {
				avatars = emAvatars;
			} else {
				avatars = opAvatar;
				if (account.billDeliveryMethod === 'METH_NON_PAPER') {
					self.set('eBill', false);
				}
			}
			if (typeof account.avatarImageId !== 'undefined' && account.avatarImageId !== null) {
				var avatar = _.find(avatars, function (item) {
					var id = item.id;
					if (typeof account.avatarImageId === 'string') {
						id = id.toString();
					}
					return id === account.avatarImageId;
				});
				account.avatar = avatar;
			} else {
				account.avatar = avatars[key];
			}
			if (selectedAddress &&
					selectedAddress.billingAccountNumber === account.billingAccountNumber &&
					account.dataEligible) {
				addressFound = true;
				self.set('selectedAccount', account);
				self.parent.set('selectedBillingAddress', account.physicalAddress);
				self.parent.set('selectedBillingId', account.billingAccountNumber);
				self.set('selectedAddress', true);
				self.checkIfAllDataSelected();
			}
			if (account.dataEligible) {
				finalAccounts.push(account);
			}

		});
		if (selectedAddress && addressFound === false && finalAccounts &&
			finalAccounts.length === 0) {
			_.each(accounts, function (account) {
				if (account.dataEligible) {
					finalAccounts.push(account);
				}
			});
		}
		self.set('accounts', finalAccounts);
	},
	toggleModal: function (modalId, state) {

		var modals = this.findAllComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];

		modal.set('displayState', state);
	},
	resetToDefaultValues: function () {
		if (this.get('addressList')) {
			this.set('disableDeliveryConfirmButton', false);
		} else {
			this.set('disableDeliveryConfirmButton', true);
		}
		this.set('toConfirmNewAddress', false);
		this.set('errorMessage', false);
		this.set('addressRetrieve', null);
		this.set('addressList', null);
		var component = this.findComponent('ux-address-form');
		if (component) {
			component.set('blockNumbers', null);
			component.set('floorOptions', null);
		}
	},
	validateAddress: function (address, addressType) {
		var isValidAddress = false;
		var components = this.findAllComponents('ux-address-form-new');
		var component = _.find(components, function (component) {
			if (component.get('addressType') === addressType) {
				return true;
			}
		});
		component.set('errorMessage', false);
		if (address && address.postCode && address.blockOrHouseNum) {
			isValidAddress = component.validateFloorAndUnitNumber();
		} else {
			component.set('errorMessage', this.get('initData.errorMessages.addressMissing'));
		}
		return isValidAddress;
	},
	checkIfAllDataSelected: function () {
		var adddressSelected = this.get('selectedAddress'),
			billMethodSelected = this.get('billMethodSelected') ||
			this.get('orderFullfilment.billingDetails.isEbillCus'),
			recontractAccount =
			this.get('orderFullfilment.billingDetails.recontractAccount');
		if (billMethodSelected && (adddressSelected || recontractAccount || this.get('deviceIdAndPlanId.skipOF'))) {
			this.set('dataSelected', true);
			return true;
		} else {
			this.set('dataSelected', false);
			return false;
		}
	}
});

Ractive.components["ux-billpayment-service"] = Ractive.extend({
	template: LUXComponentTemplates['ux-billpayment-service'],
	isolated : true,
	data : function () {
		return {
			RactiveHelpers : RactiveHelpers,
			ConfigStrings: ConfigStrings
		};
	}
});

Ractive.components["ux-broadband-block"] = Ractive.extend({
	template: LUXComponentTemplates['ux-broadband-block'],

	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},

	onrender : function () {

		var self = this;

		self.on('ux-button.selectplan', function (event) {
			self.fire('planselected', self);
		});
	}
});

Ractive.components["ux-broadband-catalogue"] = Ractive.extend({
	template: LUXComponentTemplates['ux-broadband-catalogue']
});

Ractive.components["ux-broadband-priceplan-block"] = Ractive.extend({
	template: LUXComponentTemplates['ux-broadband-priceplan-block'],
	data: function () {
		return {
			anchorFinder: function (str) {
				if (str.indexOf('<a>') >= 0 && str.indexOf('</a>') >= 0) {
					var addFunction = ' href="javascript:void(0)" onclick="showPopUp" >';
					str = str.replace('>', addFunction);
				}
				return str;
			},
			isAnchor: function (str) {
				var flag = (str.indexOf('<a') >= 0 && str.indexOf('</a>') >= 0);
				return flag;
			},
			updateHrefToVal: function (str) {
				str = str.replaceAll('href', 'class="show-plan-pop-up" value');
				return str;
			},
			RactiveHelpers: RactiveHelpers
		};
	},
	onrender: function () {
		var self = this;
		self.on('ux-button.selectplan', function (event) {
			self.fire('planselected', self);
		});
		self.on('*.showPopUp', function (ele) {
			var anchor = ele.event.original.currentTarget.querySelector('a');
			if (anchor) {
				var href = anchor.getAttribute('value');
				self.fire('openCurrentSelectePopUp', href);
			}
		});
	}
});

Ractive.components["ux-broadband-priceplan-list"] = Ractive.extend({
	template: LUXComponentTemplates['ux-broadband-priceplan-list'],
	oninit: function () {
		this.set('slidesPerView', 'auto');

		this.set('showConfigurePanel', false);
		this.set('isSticky', false);
		this.set('enlarge', false);
	},

	countPlansize: function (ractive) {
		var planssize = ractive.get('broadbandPlans').length;
		return planssize;
	},

	onrender: function (argument) {
		var self = this;
		console.log('isSticky before' + self.get('isSticky'));

		var active = self.get('ux-tablink.active') || false;
		var tabPane = self.get('ux-tabpane.tabPane') || null;

		console.log('active before' + self.get('ux-tablink.active'));
		console.log('tabPane before' + self.get('ux-tabpane.tabPane'));

		if (tabPane) {
			tabPane.set('active', active);
		}

	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	


	
	
	
	
	
	
	
	
	
	
	


		var planssize = self.countPlansize(self);
		console.log('planssize : ' + planssize);

		var plans = this.get('broadbandPlans');
		var eachPlansize = [];
		eachPlansize.push(plans.length);
		var tabInfoModels = this.get('tabInfoModels');

		for (var t = 1; t < tabInfoModels.length; t++) {
			var size = 0;
			for (var i = 0; i < plans.length; i++) {
				if (plans[i].category === tabInfoModels[t].tabTitle) {
					size = size + 1;
				}
			}
			eachPlansize.push(size);
		}

		self.set('eachPlansize', eachPlansize);

		var swipers = [];

	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
		var swiper = new Swiper(this.find('.swiper-container.mobile-view'), {
			direction: 'horizontal',
			loop: false,
			slidesPerView: 'auto',
			spaceBetween: 0,
			centeredSlides: true,
			observer: true,
			observeParents: true,
			initialSlide: 0,
			paginationClickable: true,
			pagination: this.find('.swiper-pagination')
		});
		swipers.push(swiper);
		var swipers2 = [];

		var swipertab = new Swiper(this.find('.instance-tab'), {
			direction: 'horizontal',
			nextButton: this.find('.btn-next'),
			prevButton: this.find('.btn-prev'),
			slidesPerView: 'auto',
			loop: false,
			spaceBetween: 0,
			observer: true,
			observeParents: true,
			freeMode: true,
			initialSlide: 0
		});
		swipers2.push(swipertab);

		self.on('selectItem', function (event, index) {
			this.selectItem(index, false);
		});

		self.on('selectImage', function (event, index) {
			this.showImage(index, false);
		});

		self.on('ux-tabarea.showConfiguration', function (event) {
			console.log('show show show');
			var addonLobs = self.get('showConfigurePanel');
			console.log('addonLobs : ' + addonLobs);
			if (addonLobs === true) {
				addonLobs = false;
			} else {
				addonLobs  = true;
			}
			self.set('showConfigurePanel', addonLobs);
		});
	
		var selectors = [
			'.ux-broadband-priceplan-block .product-descriptions',
			'.ux-broadband-priceplan-block .product-descriptions .onl-exc-panel',
			'.ux-broadband-priceplan-block .promotional-details-sec',
			'.ux-broadband-priceplan-block .broadband-header .bb-header',
			'.ux-broadband-priceplan-block .broadband-header .header-txt'
		
		
		];
	
	
	
		_.each(selectors, function (selector) {
			var maxHeight = 0;
			var elements = document.querySelectorAll(selector);
			_.each(elements, function (ele) {
				if (ele.clientHeight > maxHeight) {
					maxHeight = ele.clientHeight;
				}
			});
			_.each(elements, function (ele) {
				if (ele.clientHeight && maxHeight) {
					ele.style.height = maxHeight + 'px';
				}
			});
		});
	},
	oncomplete: function () {
		var self = this;
		var anchorElements = document.getElementsByClassName('show-plan-pop-up');
		_.each(anchorElements, function (element) {
			element.addEventListener('click', function (event) {
				var eleValue = event.currentTarget.getAttribute('value');
				if (eleValue) {
					self.fire('openCurrentSelectePopUp', eleValue);
				}
			}.bind(self));
		});
	}
});

Ractive.components["ux-broadband-sub"] = Ractive.extend({
	template: LUXComponentTemplates['ux-broadband-sub'],
	data : function () {
		return {
			ConfigStrings : ConfigStrings,
			moment : moment
		};
	},
	onrender : function () {
		var self = this;
		var uxService = this.parent;
		self.on('*.manageService', function () {
			uxService.parent.toggleModal('manageServiceModal', true);
		});
		self.on('*.showContractDetails', function () {
			var productFacade = self.get('productFacade');
			RactiveHelpers.toggleModal(self, 'recontractDetailsModal', true);
			console.log(productFacade.recontractData.deviceContractEndDate.format('DD/MM/YYYY'));
		});
	}
});

Ractive.components["ux-button-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-button-singtel'],
	data: function () {
		return {
			contactNo: '',
			isValid: false,
			configStrings: ConfigStrings,
			moment: moment,
			config: ConfigStrings.homeLineTest,
			base64CalDataUri: null,
			calStr: null,
			caneldarFileName: 'calendar.ics',
			inProcess: false
		};
	},
	oninit: function (argument) {
		console.log('oninit');
		_.bindAll(this, 'initiatedLineTest', 'CheckForExistingSlot', 'createNewAppointment',
			'navigate', 'selfReplacementInContractCheck', 'redirect');
		var data = [
			{
				'value': 0,
				'colour': '#da3a00'
			},
			{
				'value': 20,
				'colour': '#dbdbdb'
			}];
		this.set('graphData', data);
		this.set('percentage', 0);
		this.on('*.addCalender', function (event) {
			$('#ics-file-download-form').submit();
		});
	},
	toggleModal: function (modalId, displayState) {
		var modalList = this.findAllComponents('ux-modal');
		var targetModal = modalList.filter(function (modal) {
			return modal.get('modalId') === modalId;
		})[0];

		targetModal.set('displayState', displayState);
	},
	onrender: function () {
		var self = this;
		self.on('*.onSummaryPageAppointmentConfirm', function () {
			self.set('inProcess', true);
			self.publishToGTM();
			RactiveHelpers.getHomeLineSession(self, self.createNewAppointment, self.redirect);
		
		});
		self.on('*.onSummaryPageAppointmentCancel', function () {
			RactiveHelpers.deleteHomelineContext('slot');
			self.redirect(true);
		});

		self.on('*.doCloseModal', function (event) {
			if (event.component.get('modalId') === 'loader-Modal') {
				self.toggleModal(event.component.get('modalId'), true);
			}
		});
		self.on('*.speakToTechnicalAssistant', function () {
		
		});
		self.on('*.selfReplacement', function () {
			self.set('inProcess', true);
			self.publishToGTM();
			RactiveHelpers.getHomeLineSession(self, self.selfReplacementInContractCheck, self.redirect);
			self.set('inProcess', false);
		});
		self.on('*.hlBackToHome', function () {
			self.publishToGTM();
			self.navigate(RactiveHelpers.getHomeLineContext('backToHome'));
		});
		self.on('*.btnRedirect', function (href) {
			self.publishToGTM();
			self.navigate(href.event.context.ontap.split(':')[1]);
		});
		self.on('*.initiateLineTest', function () {
		
		
		
		
		
			window.setInterval(function () {
				var percentage = this.get('percentage');
				if (percentage < 100) {
					var value = this.get('graphData');
					value[0].value = value[0].value + 1;
					value[1].value = value[1].value - 1;
					this.set('graphData', value);
					this.set('percentage', percentage + 5);
				}
			}.bind(self), 10000);
			self.toggleModal('loader-Modal', true);
			var token = RactiveHelpers.getParameterByName('token', true);
			RactiveHelpers.setHomeLineContext('tokenId', token);
			self.publishToGTM();
			RactiveHelpers.getHomeLineSession(self, self.initiatedLineTest, self.redirect, token);
		});
		self.on('*.checkForExistingAppointment', function () {
			var inputBoxVal = $('input')[0].value;
			if (RactiveHelpers.phoneValidator (inputBoxVal)) {
				RactiveHelpers.setHomeLineContext('contactNo', inputBoxVal);
				self.set('inProcess', true);
				self.publishToGTM();
				RactiveHelpers.getHomeLineSession(self, self.CheckForExistingSlot, self.redirect);
				self.set('inProcess', false);
			}
		});
	},
	oncomplete: function () {
		this.set('contactNo', RactiveHelpers.getHomeLineContext('contactNo') || '');
		if (this.get('contactNo')) {
			this.set('isValid', true);
		}
	
	
	
	
		this.setCalendarData();
	},

	setCalendarData: function () {
		var config = this.get('config');
		var cal = ICS();
		var date = RactiveHelpers.getHomeLineContext('date');
		var startTime = RactiveHelpers.getHomeLineContext('startTime');
		var endTime = RactiveHelpers.getHomeLineContext('endTime');
		var moment = this.get('moment');
		if (date && startTime && endTime) {
			cal.addEvent(config.calederData.subject, config.calederData.description,
				config.calederData.location,
				moment(startTime, 'DDMMYYYYHHmm').format('MM/DD/YYYY hh:mm a'),
				moment(endTime, 'DDMMYYYYHHmm').format('MM/DD/YYYY hh:mm A'));
			var base64CalDataUri = 'data:text/calendar;charset=' + document.charset + ';base64,' +
				btoa(cal.calendar());
			var calStr = cal.calendar();
			console.log(base64CalDataUri);
			this.set('calStr', calStr);
			this.set('base64CalDataUri', base64CalDataUri);
		}
	},
	initiatedLineTest: function (param) {
		var self = this;
		var config = this.get('config');
		var payload = {
			'techLineTestReq': {
				'tokenId': RactiveHelpers.getHomeLineContext('tokenId'),
				'appName': param.appName || config.appName,
				'requestId': RactiveHelpers.getHomeLineUid(),
				'customerIdentifier': param.customerIdentifier,
				'serviceIdentifier': param.serviceIdentifier
			}
		};
		if (param && param.mobileAuthenticatedNumber) {
			RactiveHelpers.setHomeLineContext('contactNo', param.mobileAuthenticatedNumber);
		}
		if (param && param.appointmentType) {
			RactiveHelpers.setHomeLineContext('apptType', param.appointmentType);
		}
		return RactiveHelpers.doAjaxJSONCallWithSimulator('POST', config.url.techLineTest, function (response) {
			if (response && response.techLineTestResp && response.techLineTestResp.statusCode === '00') {
			
				response = response.techLineTestResp;
				var pageId = response.actionId + '_' +
				response.severityId + '_' +
				response.result;
				if (pageId === '0_0_0') {
					pageId = pageId + '_' + response.broadband_type;
				}
				if (pageId === '6_-1_2') {
					RactiveHelpers.setHomeLineContext('date', response.Scheduled_Maintenance_StartDate);
					RactiveHelpers.setHomeLineContext('startTime', response.Scheduled_Maintenance_StartDate);
					RactiveHelpers.setHomeLineContext('endTime', response.Scheduled_Maintenance_StartDate);
				} else if (pageId === '5_-1_1') {
				
					RactiveHelpers.setHomeLineContext('date', response.Planned_Maintenance_StartDate);
					RactiveHelpers.setHomeLineContext('startTime', response.Planned_Maintenance_StartDate);
					RactiveHelpers.setHomeLineContext('endTime', response.Planned_Maintenance_EndDate);
				}
				var url = config.url.urlMap + pageId;
				RactiveHelpers.getHomeLinePageRedirectionUrl(url, self.navigate);
			} else {
				self.redirect();
			}
		}.bind(self), function () {
			self.redirect();
		}.bind(self), payload);
	},

	selfReplacementInContractCheck: function (param) {
		var self = this;
		var config = this.get('config');
		var inContract = param.inContract;
		if (inContract === 'true') {
			self.navigate(config.inContractPage);
		} else {
			self.navigate(config.outContractPage);
		}
	},

	CheckForExistingSlot: function (param, pageId) {
		var self = this;
		var config = this.get('config');
		var moment = this.get('moment');
		var payload = {
			'techGetApptTypeReq': {
				'tokenId': RactiveHelpers.getHomeLineContext('tokenId'),
				'appName': RactiveHelpers.getHomeLineContext('appName'),
				'requestId': RactiveHelpers.getHomeLineUid(),
				'customerIdentifier': param.customerIdentifier,
				'serviceIdentifier': param.serviceIdentifier
			}
		};
		return RactiveHelpers.doAjaxJSONCallWithSimulator('POST', config.url.techGetApptType, function (response) {
			var response = response && response.techGetApptTypeResp;
			if (response && response.appointmentDateTime && response.appointmentID) {
			
				RactiveHelpers.setHomeLineContext('apptType', response.appointmentType);
				RactiveHelpers.setHomeLineContext('date',
					moment(response.appointmentDateTime, 'YYYYMMDDHHmm').format('DDMMYYYYHHmm'));
				RactiveHelpers.setHomeLineContext('startTime',
					moment(response.appointmentDateTime, 'YYYYMMDDHHmm').format('DDMMYYYYHHmm'));
				RactiveHelpers.setHomeLineContext('endTime',
					moment(response.appointmentDateTime, 'YYYYMMDDHHmm').format('DDMMYYYYHHmm'));
				var url = config.url.urlMap + '6_-1_2';
				RactiveHelpers.getHomeLinePageRedirectionUrl(url, self.navigate);
			} else if (response && (response.statusCode === '10')) {
			
				self.redirect(true);
			} else {
				var bookApptErrUrl = this.get('bookApptErrorPageUrl');
				self.navigate(bookApptErrUrl);
			}
		}.bind(self), function () {
			self.redirect();
		}.bind(self), payload);
	},
	createNewAppointment: function (param) {
		var self = this;
		var config = this.get('config');
		self.publishToGTM();
		this.set('inProcess', true);
		var payload = {
			'techCreateNewApptReq': {
				'tokenId': RactiveHelpers.getHomeLineContext('tokenId'),
				'appName': RactiveHelpers.getHomeLineContext('appName'),
				'requestId': RactiveHelpers.getHomeLineUid(),
				'customerIdentifier': param.customerIdentifier,
				'serviceIdentifier': param.serviceIdentifier,
				'serviceNumber': param.serviceNumber,
				'appointmentType': RactiveHelpers.getHomeLineContext('apptType') || 'MAINTENANCE',
				'calendarId': RactiveHelpers.getHomeLineContext('calendarId'),
				'appointmentID': RactiveHelpers.getHomeLineContext('appointmentId'),
				'contactNumber': RactiveHelpers.getHomeLineContext('contactNo'),
				'failReason': ''
			}
		};
		return RactiveHelpers.doAjaxJSONCallWithSimulator('POST', config.url.techCreateNewAppt, function (response) {
			if (response && response.techCreateNewApptResp && response.techCreateNewApptResp.statusCode === '00') {
				this.set('inProcess', false);
				self.redirect(true);
			} else {
				var bookApptErrUrl = this.get('bookApptErrorPageUrl');
				self.navigate(bookApptErrUrl);
			}
		}.bind(self), function () {
			self.redirect();
		}.bind(self), payload);
	},
	navigate: function (url) {
		this.set('href', url);
		this.redirect(url ? true : false);
	},
	redirect: function (isSuccess) {
		window.location.href = isSuccess ? this.get('href') : this.get('genericErrorPageUrl');
	},
	publishToGTM: function () {
		var appName = RactiveHelpers.getHomeLineContext('appName');
		var tokenId = RactiveHelpers.getHomeLineContext('tokenId');
		var currentPageUrl = window.location.href;
		this.set({
			appName: appName,
			tokenId: tokenId,
			currentPageUrl: currentPageUrl
		});
		this.fire('HomeLineTest');
	}
});

Ractive.components["ux-button-switch"] = Ractive.extend({

	template: LUXComponentTemplates['ux-button-switch'],
	isolated: true,
	computed: {
		guid: function () {
			return this._guid;
		}
	},

	oninit: function () {
		var self = this;

		var switchButtonId = this.get('switchButtonId');
		if (!switchButtonId) {
			this.set('switchButtonId', 'switchButton-' + new Date().getTime());
		}

		this.on('onButtonSwitched', function () {
			self.fire('buttonSwitched', {
				'buttonComponent' : this,
				'buttonId': this.get('switchButtonId'),
				'value': this.get('switchButtonValue')
			});
		});

	}

});

Ractive.components["ux-calendar"] = Ractive.extend({
	template: LUXComponentTemplates['ux-calendar'],
	onrender: function () {
		var calendarTheme = this.get('theme') || 'optussd-theme';
		if (this.get('min_date') === 'today') {
			this.set('computed_min_date', new Date());
		} else if (this.get('min_date') !== undefined) {
			this.set('computed_min_date', new Date(this.get('min_date')));
		}

		if (this.get('max_date') === 'today') {
			this.set('computed_max_date', new Date());
		} else if (this.get('max_date') !== undefined) {
			this.set('computed_max_date', new Date(this.get('max_date')));
		}

		if (!this.get('year_range')) {
			this.set('year_range', [1900,2050]);
		}

		var daysRange = this.get('days_range');
		var enabledDays;
		if (daysRange) {
			enabledDays = {};
			for (var i = 0; i <= daysRange; i++) {
				enabledDays[Date.today().addDays(i).toYMD()] = true;
			}
		}

		var DATE_FORMAT = this.get('dateFormat') || 'ddd MMM DD YYYY';

		var adjustClass,
			container;
		var defaultDate = moment((this.get('default_date') !== undefined) ?
			moment(this.get('default_date'), DATE_FORMAT) :
			new Date()).format(DATE_FORMAT);

		var field = this.find('#' + this.get('calendar_id')),
			bound = true;
		if (this.get('style') === 'inline') {
		
			container = this.el;
			bound = false;
		}

		var picker = new Pikaday({
				format: DATE_FORMAT,
				field: field,
				bound: bound,
				container: container,
				theme: calendarTheme,
				minDate: this.get('computed_min_date'),
				maxDate: this.get('computed_max_date'),
				defaultDate: new Date(moment(defaultDate, DATE_FORMAT)),
				yearRange: this.get('year_range'),
				setDefaultDate: true,
				disableWeekends: this.get('disable_weekends') ? true : false,
				disableDayFn: function (date) {

					var i;
					if (enabledDays) {
						return !enabledDays[date.toYMD()];
					} else {
						var disabledDays = this.get('disabled_days') || [];
						for (i = 0; i < disabledDays.length; i++) {
							var disabledDate = new Date(disabledDays[i]);
							if (Date.equalsDay(disabledDate, date)) {
							
								return true;
							}
						}
						return false;
					}

				}.bind(this),
				onOpen: adjustClass,
				onSelect: function () {
					this.set('selected_date', moment(picker.getDate()).format(DATE_FORMAT));
				}.bind(this)
			}
		);

		if (this.get('style') !== 'inline') {
		
			adjustClass = function () {
				var clientRect = this.find('#' + this.get('calendar_id')).getBoundingClientRect();
				var top = clientRect.bottom + window.pageYOffset,
					calendar_box = picker.el.style.top;
				calendar_box = calendar_box.substring(0, calendar_box.length - 2);

				if (calendar_box < top) {
				
					picker.el.classList.add('calendar_above');
					picker.el.classList.remove('calendar_below');
				} else {
				
					picker.el.classList.remove('calendar_above');
					picker.el.classList.add('calendar_below');
				}
			}.bind(this);
		}

		this.set('selected_date', defaultDate);

		if (this.get('style') !== 'inline') {
		
			window.onresize = function () {
				picker.adjustPosition();
				adjustClass();
			}.bind(this);
		} else {
			picker.el.classList.add('inline');
		}

	}
});

Ractive.components["ux-capacity-variant"] = Ractive.extend({
	template: LUXComponentTemplates['ux-capacity-variant'],
	computed: {
			},
	data: function () {
		return {
			ConfigStrings: ConfigStrings
		};
	},
	onrender: function () {


		this.on('selectCapacity', function (event, size) {
			this.fire('doSelectCapacity', size, event.context.price);
		}.bind(this));

		this.set('getSelectedCapacity', function (size) {
			return this.get('selectedCapacityState.' + size.toLowerCase());
		}.bind(this));

		this.set('getCapacityState', function () {
			return this.get('selectedCapacityState');
		}.bind(this));
	}
});

Ractive.components["ux-card-icon"] = Ractive.extend({
	template: LUXComponentTemplates['ux-card-icon'],
	isolated: true,
	data: {
		'iconClass': 'broadband-line',
		'text': '<default-text>',
		'clickAction': '',
		'linkUrl': '',
		'modalId': '',
		'modalData': '{}'
	},
	onconfig: function () {
		this.unregisterEvents = [

			this.on('card-click', function (event) {
				if (this.get('clickAction') === 'modal') {
					var jsonObj = this.get('modalData');
					Ractive.defaults.fire('openUXPModal', event, this.get('modalId'), jsonObj);
				} else {
					var customEvent = this.get('ontap') || this.get('onclick');
					if (customEvent) {
						this.fireEvent(event, customEvent, this);
					}
				}

			})
		];
	},
	fireEvent: function (event, customEvent, self) {
		if (customEvent) {
			var customParams = customEvent.split(':');
			var customEventName = customParams[0];
			if (customParams.length > 1) {
				var params = customParams[1].split(',');
			
				self.fire.apply(this, [customEventName, event].concat(params, this));
			} else {
				self.fire.apply(this, [customEvent, event]);
			}
			event.original.preventDefault();
		}
	},
	onteardown: function () {
		this.unregisterEvents.forEach(function (ev) {
			if (ev && ev.cancel) {
				ev.cancel();
			}
		});
	}
});

Ractive.components["ux-care-billing-address"] = Ractive.extend({
	template: LUXComponentTemplates['ux-care-billing-address'],
	isolated: true,
	data : function () {
		return {
			ConfigStrings : ConfigStrings,
			onUpdate: 'createBilling'
		};
	},

	onSelectAccount: function (value) {
		this.set('selectedBillingId', null);
		this.parent.set('selectedBillingId', null);
		if (value === -1) {
			var address = this.get('orderFullfilment.billingDetails.contactAddress');
			address.state = ConfigStrings.physicalAddressValues.state;
			address.country = ConfigStrings.physicalAddressValues.country;
			this.parent.set('selectedBillingAddress', address);
		} else if (value === -2) {
			var address = this.get('orderFullfilment.billingDetails.installationAddress');
			address.state = ConfigStrings.physicalAddressValues.state;
			address.country = ConfigStrings.physicalAddressValues.country;
			this.parent.set('selectedBillingAddress', address);
		} else {
			this.parent.set('selectedBillingId', value);
			var accounts = this.get('accounts');
			accounts = _.where(accounts, {billingAccountNumber: value})[0].physicalAddress;
			this.parent.set('selectedBillingAddress', accounts);
		}
		this.set('selectedAddress', true);
		this.set('addressRetrieve.addressList', undefined);
		var billingButton = document.getElementsByClassName('paper-bill-option');
		if (billingButton && billingButton.length > 0) {
		
			billingButton[0].scrollIntoView({block: 'start', behavior: 'smooth'});
		} else {
			document.getElementsByClassName('paper-bill-option-button')[0].
			scrollIntoView({block: 'start', behavior: 'smooth'});
		}
		this.resetScrollHeight();
	},

	onrender: function () {
		this.set('selectedAddress', false);
		this.set('disableDeliveryConfirmButton', true);
		this.on('selectAccount', function (event, value) {
			this.onSelectAccount(value);
		}.bind(this));

		this.on('*.eBillNext', function () {
			this.parent.set('paperBill', this.get('paperBill'));
			this.fire('onEBillNext', {context: this});
		});

		this.on('*.getAddress', function (event) {
			this.set('selectedAddress', false);
			this.fire('getCustomerAddress', event, 'billing');
		}.bind(this));

		this.observe('addressRetrieve.address', function (value) {
			if (typeof value !== 'undefined' && value !== null && value.postCode !== '') {
				value.state = ConfigStrings.physicalAddressValues.state;
				value.country = ConfigStrings.physicalAddressValues.country;
				this.parent.set('selectedBillingAddress', value);
				this.parent.set('selectedBillingId', null);

			
				var allRadios = document.getElementsByName('select-account');
				_.each(allRadios, function (v) {
					v.checked = false;
				});
			}
		}.bind(this));

		this.set('eBill', true);
		this.observe('orderFullfilment.billingDetails.billingAccountDetails', function (value) {
			this.onAvatarChange(value);
		}.bind(this));

		this.on('*.createBilling', function (event, value) {
			var errorFlag = false;
			this.findComponent('ux-address-form').set('errorMessage', false);
			var address = this.get('addressRetrieve.address');
			if (!address.postCode || (address.postCodeErrorMsg && address.postCodeErrorMsg.status === 'error')) {
				errorFlag = true;
			}
			var isValid = this.findComponent('ux-address-form').validateFloorAndUnitNumber();
			if (!errorFlag && isValid) {
				this.set('selectedAddress', true);
			}
		}.bind(this));
	},

	onAvatarChange : function (value) {
		var self = this;
		var accounts = value;
		var emAvatars = this.get('initData.emAvatarImages');
		var opAvatar = this.get('initData.opAvatarImages');
		var selectedAddress = self.get('orderFullfilment.billingDetails.selectedAddress');
		var addressFound = false;
		if (typeof accounts === 'undefined' || accounts === null ||
			accounts.length === 0) {
			self.set('eBill', false);
		}
		var finalAccounts = [];
		_.each(accounts, function (account, key) {
			var avatars = null;

			if (account.easyMobileInd === 'Y' || account.easyMobileInd === 'y' || account.easyMobileInd === true) {
				avatars = emAvatars;
			} else {
				avatars = opAvatar;
				if (account.billDeliveryMethod === 'METH_NON_PAPER') {
					self.set('eBill', false);
				}
			}
			if (typeof account.avatarImageId !== 'undefined' && account.avatarImageId !== null) {
				var avatar = _.find(avatars, function (item) {
					var id = item.id;
					if (typeof account.avatarImageId === 'string') {
						id = id.toString();
					}
					return id === account.avatarImageId;
				});
				account.avatar = avatar;
			} else {
				account.avatar = avatars[key];
			}
			if (selectedAddress &&
					selectedAddress.billingAccountNumber === account.billingAccountNumber) {
				addressFound = true;
				self.set('selectedAccount', account);
				self.parent.set('selectedBillingAddress', account.physicalAddress);
				self.parent.set('selectedBillingId', account.billingAccountNumber);
				self.set('selectedAddress', true);
			}
			if (account.dataEligible) {
				finalAccounts.push(account);
			}

		});
		if (selectedAddress && addressFound === false && finalAccounts &&
			finalAccounts.length === 0) {
			_.each(accounts, function (account) {
				if (account.easyMobileInd === 'N' || account.easyMobileInd === 'n') {
					finalAccounts.push(account);
				}
			});
		}
		self.set('accounts', finalAccounts);
	},
	toggleModal: function (modalId, state) {

		var modals = this.findAllComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];

		modal.set('displayState', state);
	},
	resetScrollHeight: function () {
		var headerEl = document.getElementsByClassName('ux-header-singtel');
		if (headerEl && headerEl.length > 0) {
			headerEl = headerEl[0];
			document.querySelector('html body').scrollTop -= headerEl.offsetHeight;
		}
	}
});

Ractive.components["ux-carousel-video"] = Ractive.extend({
	template: LUXComponentTemplates['ux-carousel-video'],
	CarouselVideo: function (params) {

		var carouselContainer = this;

	
		var carousel = {
			container: this.find('.ux-carousel-video'),
			items: [],
			viewItems: [],
			middleX: 0,
			length: 0,
			currentIndex: 0,
			levelNumber: 0,
			videos: [],
			itemWidth: params.itemWidth,
			itemSpace: params.itemSpace,
			scaleForeground: params.scaleForeground,
			scaleStep: params.scaleStep,
			zPositionMax: 248,
			visibleItemsNumber: params.visibleItemsNumber
		};

	
		carousel.construct = function () {
			if (carouselContainer.get('videos') !== undefined) {
				carousel.videos = carouselContainer.get('videos');
				carousel.length = carousel.videos.length;
			}
		
			carousel.middleX = carousel.getMiddleX();
		
			carousel.levelNumber = Math.round((carousel.visibleItemsNumber - 1) / 2);
			carousel.selectItem(carousel.currentIndex, true);
		};

		carousel.addItem = function (item) {
			carousel.items.push(item);
		};

		carousel.getMiddleX = function () {
			return carousel.container.offsetWidth / 2 - (carousel.itemWidth / 2);
		};

	
		carousel.selectItem = function (index, isBuilding) {
			var item,
				itemPositionX,
				itemPositionZ,
				zIndex;

			if (index === carousel.currentIndex && !isBuilding) {
				item = carousel.items[index];
				item.videoURL = item.host + item.videoRef + '?autoplay=1';
				carouselContainer.set('currentItem', item);
				carouselContainer.set('currentItem.videoURL',
					item.host + item.videoRef + '?autoplay=1');
				carouselContainer.set('currentItem.displayState', true);
			} else {
				carousel.currentIndex = index;
				if (carousel.length > 0) {

					for (var i = 0; i < carousel.length; i++) {
						itemPositionX = carousel.middleX;
						itemPositionZ = 0;
						zIndex = 0;
					
						if (isBuilding) {
							item = carouselContainer.Item({
								object: null,
								positionX: itemPositionX,
								cover: '',
								player: '',
								zIndex: '',
								transition: '',
								content: carousel.videos[i]
							});
							carousel.addItem(item);
						} else {
							item = carousel.items[i];
						}

					
						if (i === index) {
							item.setLevel('item-middle');
							item.isMiddle = true;
							item.setPlayer(true);
							zIndex = carousel.levelNumber + 1;
						} else {

							item.isMiddle = false;
							item.videoURL = '';
							item.setPlayer(false);

							var hasFoundLevel = false;

							for (var j = 1; j <= carousel.levelNumber + 1; j++) {
								if ((i === carousel.getVisibleItemIndex(index, j) ||
									i === carousel.getVisibleItemIndex(index, -j)) && !hasFoundLevel) {

									var level = j;
									itemPositionZ = -20 - (carousel.scaleStep * j * 100);
									if (j === carousel.levelNumber + 1) {
										zIndex = 0;
										item.setLevel('item-next-hidden');
										level = j - 2;
									} else {
										item.setLevel('item-other-level');
										zIndex = (Math.ceil(carousel.visibleItemsNumber / 2) - j);
									}

									if (i === carousel.getVisibleItemIndex(index, j)) {
										itemPositionX = (carousel.middleX) +
											(carousel.itemSpace * level * carousel.itemWidth);
									} else {
										itemPositionX = (carousel.middleX) -
											(carousel.itemSpace * level * carousel.itemWidth);
									}

									hasFoundLevel = true;
								}
							}

							if (!hasFoundLevel) {

								itemPositionZ = -carousel.zPositionMax;
								item.setLevel('item-hidden');
								zIndex = (-(carousel.levelNumber + Math.ceil(carousel.visibleItemsNumber / 2)));
							}
						}

						item.setPosition(itemPositionX, itemPositionZ, zIndex);

						if (isBuilding) {
							item.setAnimation(false);
						} else {
							item.setAnimation(true);
						}
					}
				}
			}

			carouselContainer.set('carousel.items', carousel.items);

			if (isBuilding) {
				carousel.viewItems = carouselContainer.findAll('.carousel-item-list .carousel-item');
			}

		};

		carousel.refreshPositions = function () {
			var newMiddle = carousel.getMiddleX();
			var diffWithPreviousMiddle = newMiddle - carousel.middleX;
			carousel.middleX = newMiddle;
			for (var i = 0; i < carousel.length; i++) {
				var item = carousel.items[i],
				positionX = item.positionX + diffWithPreviousMiddle;
				item.setAnimation(false);
				item.setPosition(positionX, item.positionZ, item.zIndex);
			}

			carouselContainer.set('carousel.items', carousel.items);
		};

				carousel.getVisibleItemIndex = function (index, increment) {
			var calculatedPosition = (index + increment) % carousel.length;

			if (calculatedPosition < 0) {
				return carousel.length + (index + increment);
			} else if (calculatedPosition > 0 && (carousel.length - increment) === index) {
				return 0 + increment;
			}

			return calculatedPosition;
		};

		carousel.moveLeft = function () {
			carousel.selectItem(carousel.getVisibleItemIndex(carousel.currentIndex, 1), false);
		};

		carousel.moveRight = function () {
			carousel.selectItem(carousel.getVisibleItemIndex(carousel.currentIndex, -1), false);
		};

		return carousel;
	},
	Item: function (params) {
		var hosts = {
			youtube: 'https://www.youtube.com/embed/'
		},
		item = {
			object: params.object,
			video: null,
			positionX: params.positionX,
			positionZ: params.positionZ,
			level: params.level,
			videoRef: params.content.videoRef,
			host: hosts[params.content.host],
			player: params.player,
			transition: params.transition,
			cover: params.cover,
			zIndex: params.zIndex,
			style: '',
			videoUrl: '',
			isMiddle: false
		};

		item.setPosition = function (positionX, positionZ, zIndex) {

			item.zIndex = zIndex;
			item.positionX = positionX;
			item.positionZ = positionZ;

			if (item.isMiddle) {
				item.style = 'z-index:' + item.zIndex + '; transform: translate3d(' + item.positionX + 'px, 0, 0)';
			} else {

				item.style = 'z-index:' + item.zIndex +
					'; transform: translate3d(' + item.positionX + 'px, 0, ' + item.positionZ + 'px)';
			}

		};

		item.setPlayer = function (isPlayerVisible) {
			item.player = isPlayerVisible ? 'player-visible' : '';
		};

		item.setCover = function (isCoverDisplayed) {
			item.cover = isCoverDisplayed ? '' : 'no-cover';
		};

		item.setAnimation = function (isTransitionActive) {
			item.transition = isTransitionActive ? 'transition' : '';
		};

		item.setLevel = function (level) {
			item.level = level;
		};

		return item;
	},
	onrender: function () {
		this.isViewReady();
	},
	isViewReady: function () {
		var viewReady = this;
	
		var timer = setTimeout(function () {

			if (document.querySelectorAll('.ux-carousel-video')[0].offsetWidth > 0) {

				var carousel = viewReady.CarouselVideo({
					itemWidth: 472,
					scaleForeground: 1,
					scaleStep: 0.4,
					itemSpace: 1 / 2,
					visibleItemsNumber: 5
				});

				carousel.construct();

				viewReady.on('selectItem', function (event, index) {
					carousel.selectItem(index, false);
				});

				viewReady.on('*.doCloseModal', function (event) {
					viewReady.set('currentItem.displayState', false);
				});

				viewReady.on('moveLeft', function (event) {
					carousel.moveLeft();
				});

				viewReady.on('moveRight', function (event) {
					carousel.moveRight();
				});

				window.addEventListener('resize', function () {
					carousel.refreshPositions();
				});

				clearTimeout(timer);
			} else {
				viewReady.isViewReady();
			}

		}, 5);

	}

});

Ractive.components["ux-carousel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-carousel'],

	data: function () {
		return {
			slidesPerView: 1,
			spaceBetween: 0,
			breakpoints: null,
			items: [],
			observer: true,
			loop: true,
			hashnav: true,
			autoHeight: true,
			hashnavWatchState: true,
			controlsAlignment: 'bottom',
			hideControls: false,
			navigation: true,
			pagination: '.swiper-pagination',
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			showPagination: true,
			paginationClickable: true,
			speed: 250,
			autoplayDisableOnInteraction: true
		};
	},

	computed: {
		guid: function () {
			return this._guid;
		}
	},

	getConfig: function () {
		var config = this.get();
		var	exceptions = ['isDataModel', 'navigation', 'items', 'class'];
	
		var guidSelector = '.guid-' + this._guid;
		var navControls = {
			nextButton: guidSelector + ' .swiper-button-next',
			prevButton: guidSelector + ' .swiper-button-prev'
		};
	
	
		config = Object.assign(config, navControls);

	
	
	
		if (config.breakpoints) {
			_.each(config.breakpoints, function (value, key) {
				delete config.breakpoints[key];
				config.breakpoints[key.replace(/['"]+/g, '')] = value;
			});
		}

	
		_.each(exceptions, function (key) {
			if (config[key]) {
				delete config[key];
			}
		});
		return config;
	},

	oninit: function () {
		this.on('update', this.updateCarousel);

	
	
		this.observe('items', function (newVal, oldVal) {
			if (!_.isEqual(newVal, oldVal)) {
				this.update().then(function () {
					this.updateCarousel();
				}.bind(this));
			}
		}, {
			init: false,
			defer: true
		});
	},

	onrender: function () {
		var self = this;
		var pausecycle = RactiveHelpers.getURLParameter('pausecycle');

		if (pausecycle !== null && pausecycle === 'true') {
			self.set('autoplay', 0);
		}
		self.on('stopswiper', function () {
			if (typeof self.carousel !== 'undefined') {
				self.carousel.stopAutoplay();
			}
		});

		self.on('startswiper', function () {
			if (typeof self.carousel !== 'undefined') {
				self.carousel.startAutoplay();
			}
		});
	},

	oncomplete: function () {
		var config = this.getConfig();
		var self = this;
		var carouselItems = self.findAll('.swiper-slide');
		var containerClassStr = '.' + config.containerId;

		if (carouselItems.length > 0) {
			self.set('showPagination', true);
		} else {
			self.set('showPagination', false);
		}

	
	
		Object.assign(config, {
			onInit: function (instance) {
				this.afterInit(instance);
			}.bind(this)
		});

		setTimeout(function () {
			self.carousel = new Swiper(self.find(containerClassStr), config);
		}, 300);

		$(document).on('allWidgetsInitialized.lux', function () {
			this.carousel.update({ updateTranslate: true });
			this.afterInit(this.carousel);
		}.bind(this));

	
		window.addEventListener('resize', function () {
			_.debounce(this.resize, 300);
		}.bind(this));
	},


	handleControlsDisplay: function (instance) {
	
		if (_.has(instance, 'bullets')) {
			this.set('hideControls', _.size(instance.bullets) === 1);
		}
	},


	afterInit: function (instance) {
		this.handleControlsDisplay(instance);
		this.fire('rendered', this);
	},


	getSlidesPerView: function () {
		var size = window.innerWidth,
			breakpoints = this.get('breakpoints'),
			closest = Object.keys(breakpoints).reduce(function (prev, curr) {
				return (prev - size < 0 ? curr - size < 0 ? null : curr : prev);
			});
		return closest ? breakpoints[closest].slidesPerView : this.get('slidesPerView');
	},


	updateCarousel: function () {
		if (!this.carousel) {
			return false;
		}

		this.carousel.params.slidesPerView = this.getSlidesPerView();
		this.carousel.update();
		this.carousel.slideTo(0);
		this.handleControlsDisplay(this.carousel);
	},

	resize: function () {
		this.updateCarousel();
	}
});

Ractive.components["ux-catalog-filter-facets"] = Ractive.extend({
	template: LUXComponentTemplates['ux-catalog-filter-facets'],

	onrender: function () {
		var brand = this.get('brand');
		if (typeof brand === 'undefined' || brand === null) {
			brand = RactiveHelpers.getParameterByName('brand');
			if (brand) {
				this.doApplyUrlParamFilter(this.get('initData.brands'));
			} else {
				this.set('brand', this.get('initData.brands')[0].value);
			}
		}
		var deal = this.get('deal');
		if (typeof deal === 'undefined' || deal === null) {
			this.set('deal', this.get('initData.deals')[0].value);
		}
		var sortBy = this.get('sortBy');
		if (typeof sortBy === 'undefined' || sortBy === null) {
			this.set('sortBy', this.get('initData.sortByList')[0].value);
		}
		var comboPlan = this.get('comboPlan');
		if (typeof comboPlan === 'undefined' || comboPlan === null) {
			this.set('comboPlan', this.get('initData.selectedComboId'));
		}
		var isIppPlan = this.get('deviceIdAndPlanId.isIppPlan');
		if (isIppPlan && this.get('deviceIdAndPlanId.planId')) {
			this.set('isDurationSelected', true);
		} else {
			this.set('isDurationSelected', false);
		}
		if (this.get('isNewPP')) {
			var contractFilter = this.get('initData.contractFilter');
			var selectedFilter = _.filter(contractFilter, function (item) {
				if (isIppPlan) {
					return item.isIPP;
				} else {
					return item.default;
				}
			});
			if (selectedFilter && selectedFilter.length > 0) {
				this.set('selectedFilter', selectedFilter[0].value);
			} else {
				this.set('selectedFilter', contractFilter[0].value);
			}
			this.set('contractFilter', contractFilter);
			if (isIppPlan && this.get('deviceIdAndPlanId.planId')) {
				this.set('ippPlan', this.get('deviceIdAndPlanId.planId'));
			} else {
				this.set('ippPlan', this.get('initData.selectedIppPlanId'));
			}
			if (selectedFilter && selectedFilter.length > 0 &&
				selectedFilter[0].isIPP) {
				this.contractFilterChanged();
			}
		}
		this.on('*.radioFilterSelected', function (value) {
			this.contractFilterChanged();
		});
		this.on('*.changedBrands', function (newValue) {
			this.filterChanged('brand', newValue);
		}.bind(this));

		this.on('*.changedDeals', function (newValue) {
			this.filterChanged('deal', newValue);
		}.bind(this));

		this.on('*.changedSortBy', function (newValue) {
			this.filterChanged('sortBy', newValue);
		}.bind(this));

		this.on('*.changedPlans', function (newValue) {
			if (this.get('isIPPPlans')) {
				this.filterChanged('ippPlan', newValue);
			} else {
				this.filterChanged('comboPlan', newValue);
			}
		}.bind(this));
		this.on('*.showTooltip', function () {
			this.fire('showIPPModal');
			sessionStorage.setItem('isIPPModalShown', true);
		}.bind(this));
	},

	filterChanged: function (keypath, newValue) {
		this.fire('filterChanged', keypath, newValue);
	},
	doApplyUrlParamFilter: function (brands) {
		var brand = RactiveHelpers.getParameterByName('brand');
		if (brand) {
			var isBrand = _.find(brands, function (tempBrand) {
				return tempBrand.value === brand;
			});
			if (isBrand) {
				this.set('brand', brand);
			} else {
				this.set('brand', brands[0].value);
			}
		}
	},
	contractFilterChanged: function () {
		var contractFilter = this.get('initData.contractFilter');
		var selectedFilter = this.get('selectedFilter');
		var selectedFilterObj = _.find(contractFilter, function (item) {
			return item.value === selectedFilter;
		});
		if (selectedFilterObj && selectedFilterObj.isIPP) {
			if (this.get('initData.ippDetails.ippShowModal')) {
				var isModalShown = sessionStorage.getItem('isIPPModalShown');
				if (!isModalShown) {
					this.fire('showIPPModal');
					sessionStorage.setItem('isIPPModalShown', true);
				}
			}
			this.parent.set('isIPPPlan', true);
			if (this.get('isDurationSelected') && this.get('deviceIdAndPlanId.installmentDuration')) {
				this.parent.set('ippDuration', this.get('deviceIdAndPlanId.installmentDuration'));
			} else {
				this.parent.set('ippDuration', selectedFilterObj.value);
			}
			this.set('isIPPPlans', true);
		} else {
			this.set('isIPPPlans', false);
			this.parent.set('isIPPPlan', false);
		}
		this.resetFilters();
		this.fire('contractFilterChanged');
	},
	resetFilters: function () {
		if (this.get('isIPPPlan')) {
			if (this.get('initData.ippDeals')) {
				this.set('deal', this.get('initData.ippDeals')[0].value);
			}
			if (this.get('initData.ippBrands')) {
				this.set('brand', this.get('initData.ippBrands')[0].value);
			}
		} else {
			this.set('deal', this.get('initData.deals')[0].value);
			this.set('brand', this.get('initData.brands')[0].value);
		}
		this.set('sortBy', this.get('initData.sortByList')[0].value);
		this.set('comboPlan', this.get('initData.selectedComboId'));
		this.set('ippPlan', this.get('initData.selectedIppPlanId'));
	}
});

Ractive.components["ux-catalog-rrp-filter"] = Ractive.extend({
	template: LUXComponentTemplates['ux-catalog-rrp-filter'],
	oncomplete: function () {
		var accessoryList = this.get('initData.accessories');
		this.initializeBradsFilter(accessoryList);
		this.applyUrlParamToFilter(this.get('initData'));
		this.set('sortByVal', this.get('initData.sortByList')[0].value);
		this.on('*.changedBrands', function (newValue) {
			this.filterChanged('brand', newValue);
		}.bind(this));

		this.on('*.changedDeals', function (newValue) {
			this.filterChanged('deal', newValue);
		}.bind(this));

		this.on('*.changedSortBy', function (newValue) {
			this.filterChanged('sortBy', newValue);
		}.bind(this));

		this.on('*.changedPromoDeal', function (newValue) {
			this.filterChanged('promoDeal', newValue);
		}.bind(this));
	},
	filterChanged: function (keypath, newValue) {
		this.fire('filterChanged', keypath, newValue);
	},
	initializeBradsFilter: function (accessoryList) {
		var finalBrandList = [{
				text: 'All Brands',
				value: 'all'
			}
		];
		var brandList = [];
		var brandVariants = [];
		accessoryList = _.filter(accessoryList, function (accessories) {
			return !accessories.hideForDisplay;
		});
		_.each(accessoryList, function (accessory) {
			if (accessory.variants) {
				brandVariants.push({
					'text': accessory.variants[0].brand,
					'value': accessory.variants[0].brand
				});
			}
		});
		brandList = _.uniq(brandVariants, function (brand) {
			return brand.value;
		});
		brandList = _.sortBy(brandList, function (brand) {
			return brand.text;
		});
		finalBrandList = finalBrandList.concat(brandList);

		this.set('initData.brands', finalBrandList);
		this.set('brand', finalBrandList[0].value);
	},
	applyUrlParamToFilter: function (initData) {
		var dealURL = RactiveHelpers.getParameterByName('deal');
		var brandURL = RactiveHelpers.getParameterByName('brand');
		var promoDealURL = RactiveHelpers.getParameterByName('pricedeal');
		if (dealURL) {
			var deals = initData.deals;
			var isDeal = _.find(deals, function (tempDeal) {
				return tempDeal.value.toUpperCase() === dealURL.toUpperCase();
			});
			if (isDeal) {
				this.set('dealVal', dealURL);
				this.filterChanged('deal', dealURL);
			} else {
				this.set('dealVal', initData.deals[0].value);
				this.filterChanged('deal', initData.deals[0].value);
			}
		} else {
			this.set('dealVal', initData.deals[0].value);
		}
		if (brandURL) {
			var brands = initData.brands;
			var isBrand = _.find(brands, function (tempBrand) {
				return tempBrand.value.toUpperCase() === brandURL.toUpperCase();
			});
			if (isBrand) {
				this.set('brand', brandURL);
				this.filterChanged('brand', brandURL);
			} else {
				this.set('brand', initData.brands[0].value);
				this.filterChanged('brand', initData.brands[0].value);
			}
		} else {
			this.set('brand', initData.brands[0].value);
		}
		if (promoDealURL) {
			var promoDeals = initData.promoDeals;
			var isPromo = _.find(promoDeals, function (tempPromo) {
				return tempPromo.value.toUpperCase() === promoDealURL.toUpperCase();
			});
			if (isPromo) {
				this.set('promoDeal', promoDealURL);
				this.filterChanged('promoDeal', promoDealURL);
			} else {
				this.set('promoDeal', initData.promoDeals[0].value);
				this.filterChanged('promoDeal', initData.promoDeals[0].value);
			}
		} else {
			this.set('promoDeal', initData.promoDeals[0].value);
		}
	}
});

Ractive.components["ux-catalog-splitter"] = Ractive.extend({
	template: LUXComponentTemplates['ux-catalog-splitter']
});

Ractive.components["ux-catalogue-block"] = Ractive.extend({
	template: LUXComponentTemplates['ux-catalogue-block']
});

Ractive.components["ux-change-bill-preference"] = Ractive.extend({
	template: LUXComponentTemplates['ux-change-bill-preference'],
	isolated: true,
	computed: {
		guid: function () {
			return this._guid;
		}
	},
	data: function () {
		return {
			isSwitchDisabled: function (account) {
				if (typeof this.get('switchDisabled') === 'function') {
					return this.get('switchDisabled').apply(this.parent, arguments);
				} else {
					return this.get('switchDisabled');
				}
			},
			addSpace: function (mobileNumber, index) {
				if (_.isUndefined(mobileNumber)) {
					return;
				} else {
					return mobileNumber.substr(0, index) + ' ' + mobileNumber.substr(index);
				}
			},
			isMobileSubscriptionPresent: function (subscribers) {
				var mobileSub = _.find(subscribers, function (sub) {
					return sub.subscriberType === 'MOB' || sub.subscriberType === 'WS';
				});

				return mobileSub ? true : false;
			},
			ConfigStrings: ConfigStrings
		};
	}
});

Ractive.components["ux-channel-modal"] = Ractive.extend({
	template: LUXComponentTemplates['ux-channel-modal'],

	toggleModal: function (modalId, displayState) {
		var modalList = this.findAllComponents('ux-modal');
		var targetModal = modalList.filter(function (modal) {
			return modal.get('modalId') === modalId;
		})[0];

		targetModal.set('displayState', displayState);
	},

	oninit: function () {
		this.toggleModal('channelList', true);

		this.on('*.closeChannelModal', function (event) {
			this.toggleModal('channelList', false);
		});
	}
});

Ractive.components["ux-charge-details"] = Ractive.extend({
	template: LUXComponentTemplates['ux-charge-details'],
	isolated : true,
	data : function () {
		return {
			RactiveHelpers : RactiveHelpers,
			ConfigStrings: ConfigStrings
		};
	},
	oninit: function () {
		this.on('showPartialCharge', function () {
			RactiveHelpers.toggleModal(this, 'partialChargeModal', true);
		}.bind(this));
	}
});

Ractive.components["ux-chargeable-email"] = Ractive.extend({
	template: LUXComponentTemplates['ux-chargeable-email'],
	data : function () {
		return {
			selected: true
		};
	},
	onrender: function () {
		var self = this;
		self.parent.on('openCharagableModal', function () {
			self.set('selected', true);
			self.handleModal(true, 'chargeableEmailPopup');
		});

		self.parent.on('hideCharagableModal', function () {
			self.handleModal(false, 'chargeableEmailPopup');
		});
		self.on('ux-button.processEmailStatus', function (event) {
			self.fire('emailSelected', self.get());
			self.handleModal(false, 'chargeableEmailPopup');
		});

		self.on('*.selectEmailOption', function (event, id) {
			if (id !== '' && id !== null) {
				self.set('selected', false);
			}
			self.set('emailOption', id);
		});
	},
	handleModal: function (visibility, cardId) {
		var modals = this.findAllChildComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return cardId === component.get('modalId');
		})[0];
		modal.set('displayState', visibility);
	}
});

Ractive.components["ux-chat-ivr"] = Ractive.extend({
		template: LUXComponentTemplates['ux-chat-ivr'],
		data: function () {
		return {
			scriptPathVariable: '',
			eventsScriptPathVariable: ''
		};
	},
	oninit: function () {
				var self = this;
				self.checkBrowserCompatible(self);
				Ractive.defaults.on('webChatEvent', function (webchat) {
					if (webchat === 'chatting') {
						var chattingMessage = self.get('chattingMessage');
						self.set('displayMessage', chattingMessage);
					}
					if (webchat === 'ended') {
						var chatEndMessage = self.get('chatEndMessage');
						self.set('displayMessage', chatEndMessage);
					}
					if (webchat === 'expire') {
						var chatExpireMessage = self.get('chatExpireMessage');
						self.set('displayMessage', chatExpireMessage);
					}
				});
				var scriptPathVariable = self.get('blackList.scriptPath');
				var eventsScriptPathVariable = self.get('blackList.eventsScriptPath');
				self.set('blackList.scriptPathVariable', scriptPathVariable);
				self.set('blackList.eventsScriptPathVariable', eventsScriptPathVariable);
			},
	checkBrowserCompatible: function (self) {
						var nAgt = navigator.userAgent.toLowerCase();
						var flag = 0;
						var blackList = self.get('blackList');

												for (var x in blackList.osList) {
							if (blackList.osList.hasOwnProperty(x)) {
								if (nAgt.indexOf(blackList.osList[x].toLowerCase()) !== -1) {
									console.log('blacklisted os everywhere : ' + blackList.osList[x]);
									flag = 1;
									var incompatibleMessage = self.get('incompatibleMessage');
									self.set('displayMessage', incompatibleMessage);
									self.set('disableChatInp', 'true');
								}
							}
						}

												for (var y in blackList.browsersList) {
							if (blackList.browsersList.hasOwnProperty(y)) {
								if (nAgt.indexOf(blackList.browsersList[y].
									toLowerCase()) !== -1) {
									flag = 1;
									console.log('blacklisted browser everywhere : ' + blackList.browsersList[y]);
									var incompatibleMessage = self.get('incompatibleMessage');
									self.set('displayMessage', incompatibleMessage);
									self.set('disableChatInp', 'true');
								}
							}
						}

												for (var x in blackList.blackListOSnBrowser) {
							if (blackList.blackListOSnBrowser.hasOwnProperty(x)) {
								console.log('Browser is getting checked under OS: ' +
									blackList.blackListOSnBrowser[x].osName);
								if (nAgt.indexOf(blackList.blackListOSnBrowser[x].osName.toLowerCase()) !== -1) {
									for (var y in blackList.blackListOSnBrowser[x].Browsers) {
										if (blackList.blackListOSnBrowser[x].Browsers.hasOwnProperty(y)) {
											console.log('Browser is getting checked: ' +
												blackList.blackListOSnBrowser[x].Browsers[y]);
											if (nAgt.indexOf(blackList.blackListOSnBrowser[x].Browsers[y].
											toLowerCase()) !== -1) {
												console.log('incompatible ' + blackList.blackListOSnBrowser[x].
												Browsers[y] + ' in ' + blackList.blackListOSnBrowser[x].osName);
												flag = 1;
												var incompatibleMessage = self.get('incompatibleMessage');
												self.set('displayMessage', incompatibleMessage);
												self.set('disableChatInp', 'true');
											}
										}
									}
								}
							}
						}

						if (flag === 0) {
							self.set('disableChatInp', 'false');
							var checkExpireMsg = self.get('displayMessage');
							var chatExpireMsg = self.get('chatExpireMessage');
							if (checkExpireMsg !== chatExpireMsg) {
								var initMessage = self.get('initMessage');
								self.set('displayMessage', initMessage);
							}
						}
					}
});

Ractive.components["ux-checkbox"] = Ractive.extend({
	template: LUXComponentTemplates['ux-checkbox'],
	computed: {
		guid: function () {
			return this._guid;
		}
	},
	data: function () {
		return {
			isLink: function (theme) {
				return theme && theme.indexOf('link') !== -1;
			},
			isSwitch: function () {
				if (this.get('class')) {
					return this.get('class').indexOf('switch') !== -1;
				}
			},
			disabled: false,
			on: false
		};
	},
	onconfig: function () {

	
		var checked = this.get('checked');
		var on = this.get('on');
		if (!on && checked) {
			this.set('on', checked);
		}
		if (on && !checked) {
			this.set('checked', on);
		}

		this.on('blurHandler', function (event) {
			var fireEvent = this.get('onblurEvent');
			if (fireEvent) {
				this.fire(fireEvent, event);
				return false;
			}
		});
		this.on('changeHandler', function (event) {
			var fireEvent = this.get('onChangeEvent');
			if (fireEvent) {
				this.fire(fireEvent, event, this);
				return false;
			}
		});

		this.on('toggleCheck', function (event) {

		
		
			if (event.original.target.tagName === 'A') {
				return;
			}

			event.original.preventDefault();

			if (this.get('disabled')) {
				return false;
			}
			this.toggle('on');

		
			var fireEvent = this.get('checkboxClicked');
			if (fireEvent) {
				this.fire(fireEvent, event);
			}

		});

	},
	onrender: function () {
		this.set('show_tooltip', false);

		this.on('showTooltip', function () {
			this.toggle('show_tooltip');
			return false;
		});
	},
	oninit: function () {
		this.set('initialValue', this.get('checked'));
	}
});

Ractive.components["ux-checkout-panel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-checkout-panel'],
	isolated: false,
	data: function () {
		return {
			ConfigStrings: ConfigStrings
		};
	},
	oncomplete: function () {
		this.on('*.doCheckout', function (event) {
			this.fire('checkoutClicked', event);
		});
	}
});

Ractive.components["ux-choose-payment-mode"] = Ractive.extend({
	template: LUXComponentTemplates['ux-choose-payment-mode'],

	oninit: function (argument) {
		this.set('selectedPaymentMode', '');

		var defaultPhone = this.get('phoneSizes')[0];
		this.set('devicecost', defaultPhone.fromPrice);
		this.set('onetimeprice', defaultPhone.oneTimePrice);
		this.set('partialUpfrontAmount', defaultPhone.partialUpfrontAmount);
		this.set('installmentamout', defaultPhone.installmentAmount);
		this.set('numofinstallments', defaultPhone.numberofInstallments);

		this.parent.on('*.setPaymentModeState', function (state, capacity) {
			if (capacity) {
				var defaultPhone = _.filter(this.get('phoneSizes'), function (phone) {
					return phone.size === capacity;
				})[0];
				this.set('devicecost', defaultPhone.fromPrice);
				this.set('onetimeprice', defaultPhone.oneTimePrice);
				this.set('partialUpfrontAmount', defaultPhone.partialUpfrontAmount);
				this.set('installmentamout', defaultPhone.installmentAmount);
				this.set('numofinstallments', defaultPhone.numberofInstallments);
			}
			if (state === 'disabled') {
				this.set('paymentModeState', 'disabled');
			} else {
				this.set('paymentModeState', '');
			}
			this.update();
		}.bind(this));
	},

	onrender: function () {
		this.on('*.selectPaymentMode', function (event, mode) {
			console.log('select payment mode ' + mode);
			var paymentModeState = this.get('paymentModeState');
			if (paymentModeState === 'disabled') {
				return;
			}
			this.set('selectedPaymentMode', mode);
		
			this.set('paymentModeStatus.*', '');
			this.set('paymentModeStatus.' + mode, 'selected');
			this.fire('doButtonToggleState', 'enabled');
			this.update();

			this.fire('paymentModeChange', mode);
		}.bind(this));
	}
});

Ractive.components["ux-cis-form-banner-box"] = Ractive.extend({
	template: LUXComponentTemplates['ux-cis-form-banner-box'],
	oninit: function () {
		var self = this;
		var backgroundImage = self.get('backgroundImage.mobile.src') || self.get('backgroundImage.desktop.src');
		self.set('backgroundImgDesktop', self.get('backgroundImage.desktop.src'));
		self.set('backgroundImgMobile', backgroundImage);
	},
	onrender: function () {
		var self = this;
		var validateErrorMsg = this.get('validateErrorMsg');

		self.set('data.cisEmail', '');
		self.set('data.cisOtp', '');
	

		self.on('ux-button.cisButtonAction', function (event) {
			self.cisButtonAction();
		});

	
		self.on('*.goBackToForm', function (event) {
			self.set('submitFailed', false);
			self.set('submittedSuccess', false);
		});

		self.on('goBackToForm', function (event) {
			self.set('submitFailed', false);
			self.set('submittedSuccess', false);
		});

		self.observe('data.cisEmail', function (newValue) {
			if (newValue !== '' && typeof newValue !== 'undefined') {
				self.set('data.onInitInputButtonDisabled', false);
			}
		}.bind(self));

		self.observe('data.cisOtp', function (newValue) {
			if (newValue !== '' && typeof newValue !== 'undefined') {
				self.set('data.onInitInputButtonDisabled', false);
			}
		}.bind(self));

	
		self.validationEmail = new RactiveValidate(self, {
			'cisEmail': {
				required: 'Email cannot be empty',
				email: validateErrorMsg
			}
		});
	
		self.validationOtp = new RactiveValidate(self, {
			'cisOtp': {
				required: validateErrorMsg,
				digits: validateErrorMsg,
				maxlength: {
					param: 6,
					message: 'Please enter a maximum of 6 characters'
				},
				minlength: {
					param: 6,
					message: 'Please enter a minimum of 6 characters'
				}
			}
		});

		self.on('validateEmail', function () {
			self.validateEmail();
		}.bind(self));

		self.on('validateOtp', function () {
			self.validateOtp();
		}.bind(self));
	},
	validateEmail: function () {
		this.set('data.cisEmail', this.get('data.cisEmail').toLowerCase());
		this.validationEmail.validate();
	},
	validateOtp: function () {
		this.validationOtp.validate();
	},
	cisButtonAction : function () {
		var formType = this.get('formType');
		this.validateEmail();

		var cisEmailErrorStatus = this.get('data.cisEmailErrorMsg.status');
		var cisOtpErrorStatus = this.get('data.cisOtpErrorMsg.status');

		if (formType === 'inputEmail' && cisEmailErrorStatus === 'valid') {
			this.checkEmailExistCIS();
		} else if (formType === 'inputOTP' && cisOtpErrorStatus) {
			console.log('inputotp');
			this.checkValidOtp();
		}
	},
	checkEmailExistCIS : function () {
	
		var self = this;
		var emailExist = false;
		var emailadd = this.get('data.cisEmail').toLowerCase();
		var authorization = sessionStorage.getItem('apigee_token');

		self.replaceSuccessEmailContent();

	
		self.showPreloader();

		if (authorization) {
			this.ajaxCallApiCIS(emailadd, authorization).then(function (response) {
				if (response.outcome === true) {
					emailExist = true;
				}
				if (emailExist) {
					self.set('submittedSuccess', true);
				} else {
					self.set('submitFailed', true);
				}
			
				self.removePreloader();
			});
		} else {
			self.fire('retrieveAccessTokenCIS');
		}

	},
	checkValidOtp : function () {
	
		var validOtp = false;
		var otp = this.get('data.cisOtp');

		this.showPreloader();
		this.ajaxCallApi(otp).then(function (response) {
			if (response.outcome === true) {
				validOtp = true;
			}
			if (validOtp) {
				this.set('submittedSuccess', true);
			} else {
				this.set('data.cisOtpErrorMsg.rule', 'required');
				this.set('data.cisOtpErrorMsg.passed', 'false');
				this.set('data.cisOtpErrorMsg.status', 'error');
				this.set('data.cisOtpErrorMsg.message', this.get('cisFailText.invalidOtpErrorMsg'));
				console.log('cisOtpErrorMsg', JSON.stringify(this.get('data.cisOtpErrorMsg')));
			}
			this.removePreloader();
		});

	},
	ajaxCallApi : function (parameter) {
	
		var urlweb = location.protocol + '//' + location.host + '/';
		var callApi = urlweb + this.get('callApi') + parameter;

	

		var def = $.Deferred();

		return $.ajax({
			cache:    false,
			url:      callApi,
			crossDomain: true,
			dataType: 'json',
			success:  function (response) {
				def.resolve(response);
			}
		});
	},
	ajaxCallApiCIS : function (parameter, authorization) {

		var def = $.Deferred();
	
		var urlweb = location.protocol + '//' + window.mcssDomain + '/';
		var callApi = urlweb + this.get('callApi') + parameter;
		var requestBody = {
			'appType': 'CIS',
			'emailId': parameter
		};
		var customHeaders;
		customHeaders = {
			'Authorization': authorization,
			'Content-Type': 'application/json'
		};

	

		return $.ajax({
			type: 'POST',
			cache:    false,
			url:      callApi,
			crossDomain: true,
			dataType: 'json',
			data: JSON.stringify(requestBody),
			headers: customHeaders,
			success:  function (response) {
				def.resolve(response);
			}
		});
	},
	replaceSuccessEmailContent : function () {
		var emailadd = this.get('data.cisEmail');
		var cisLiner = this.get('cisSuccessText.cisLiner');
		var cisLinkOnclick = this.get('cisSuccessText.cisLink.onClick');
		var cisLinkText = this.get('cisSuccessText.cisLink.text');
		var cisLinkHref = '';

		if (cisLinkHref !== '' && cisLinkHref !== undefined) {
			cisLinkHref = this.get('cisSuccessText.cisLink.url');
			cisLinkHref = ' href=\'' + cisLinkHref + '\' ';
		}

		var anchorLink = '<a ' + cisLinkHref + 'on-click=\'' + cisLinkOnclick + '\'>' + cisLinkText + '</a>';

		cisLiner = cisLiner.replace('@email', emailadd);
		cisLiner = cisLiner.replace('@cislink', anchorLink);
	
		this.resetPartial('successEmailContent', cisLiner);
	},
	showPreloader : function () {
		$('.banner-background').addClass('wait');
	},
	removePreloader : function () {
		$('.banner-background').removeClass('wait');
	},
	partials: {
		successEmailContent: ''
	}
});




Ractive.components["ux-cis-form-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-cis-form-banner'],
	oninit: function () {
		var self = this;
		var backgroundImage = self.get('backgroundImage.mobile.src') || self.get('backgroundImage.desktop.src');
		self.set('backgroundImgDesktop', self.get('backgroundImage.desktop.src'));
		self.set('backgroundImgMobile', backgroundImage);
	},
	onrender: function () {
		var self = this;
		var validateErrorMsg = this.get('validateErrorMsg');

		self.set('data.cisEmail', '');
		self.set('data.cisOtp', '');
	

		self.on('ux-button.cisButtonAction', function (event) {
			self.cisButtonAction();
		});

	
		self.on('*.goBackToForm', function (event) {
			self.set('submitFailed', false);
			self.set('submittedSuccess', false);
		});

		self.on('goBackToForm', function (event) {
			self.set('submitFailed', false);
			self.set('submittedSuccess', false);
		});

		self.observe('data.cisEmail', function (newValue) {
			if (newValue !== '' && typeof newValue !== 'undefined') {
				self.set('data.onInitInputButtonDisabled', false);
			}
		}.bind(self));

		self.observe('data.cisOtp', function (newValue) {
			if (newValue !== '' && typeof newValue !== 'undefined') {
				self.set('data.onInitInputButtonDisabled', false);
			}
		}.bind(self));

	
		self.validationEmail = new RactiveValidate(self, {
			'cisEmail': {
				required: 'Email cannot be empty',
				email: validateErrorMsg
			}
		});
	
		self.validationOtp = new RactiveValidate(self, {
			'cisOtp': {
				required: validateErrorMsg,
				digits: validateErrorMsg,
				maxlength: {
					param: 6,
					message: 'Please enter a maximum of 6 characters'
				},
				minlength: {
					param: 6,
					message: 'Please enter a minimum of 6 characters'
				}
			}
		});

		self.on('validateEmail', function () {
			self.validateEmail();
		}.bind(self));

		self.on('validateOtp', function () {
			self.validateOtp();
		}.bind(self));
	},
	validateEmail: function () {
		this.set('data.cisEmail', this.get('data.cisEmail').toLowerCase());
		this.validationEmail.validate();
	},
	validateOtp: function () {
		this.validationOtp.validate();
	},
	cisButtonAction : function () {
		var formType = this.get('formType');
		this.validateEmail();

		var cisEmailErrorStatus = this.get('data.cisEmailErrorMsg.status');
		var cisOtpErrorStatus = this.get('data.cisOtpErrorMsg.status');

		if (formType === 'inputEmail' && cisEmailErrorStatus === 'valid') {
			this.checkEmailExistCIS();
		} else if (formType === 'inputOTP' && cisOtpErrorStatus) {
			console.log('inputotp');
			this.checkValidOtp();
		}
	},
	checkEmailExistCIS : function () {
	
		var self = this;
		var emailExist = false;
		var emailadd = this.get('data.cisEmail').toLowerCase();

		self.replaceSuccessEmailContent();

	
		self.showPreloader();
		this.ajaxCallApi(emailadd).then(function (response) {
			if (response.outcome === true) {
				emailExist = true;
			}
			if (emailExist) {
				self.set('submittedSuccess', true);
			} else {
				self.set('submitFailed', true);
			}
		
			self.removePreloader();
		});

	},
	checkValidOtp : function () {
	
		var validOtp = false;
		var otp = this.get('data.cisOtp');

		this.showPreloader();
		this.ajaxCallApi(otp).then(function (response) {
			if (response.outcome === true) {
				validOtp = true;
			}
			if (validOtp) {
				this.set('submittedSuccess', true);
			} else {
				this.set('data.cisOtpErrorMsg.rule', 'required');
				this.set('data.cisOtpErrorMsg.passed', 'false');
				this.set('data.cisOtpErrorMsg.status', 'error');
				this.set('data.cisOtpErrorMsg.message', this.get('cisFailText.invalidOtpErrorMsg'));
				console.log('cisOtpErrorMsg', JSON.stringify(this.get('data.cisOtpErrorMsg')));
			}
			this.removePreloader();
		});

	},
	ajaxCallApi : function (parameter) {
	
		var urlweb = location.protocol + '//' + location.host + '/';
		var callApi = urlweb + this.get('callApi') + parameter;

	

		var def = $.Deferred();

		return $.ajax({
			cache:    false,
			url:      callApi,
			crossDomain: true,
			dataType: 'json',
			success:  function (response) {
				def.resolve(response);
			}
		});
	},
	replaceSuccessEmailContent : function () {
		var emailadd = this.get('data.cisEmail');
		var cisLiner = this.get('cisSuccessText.cisLiner');
		var cisLinkOnclick = this.get('cisSuccessText.cisLink.onClick');
		var cisLinkText = this.get('cisSuccessText.cisLink.text');
		var cisLinkHref = '';

		if (cisLinkHref !== '' && cisLinkHref !== undefined) {
			cisLinkHref = this.get('cisSuccessText.cisLink.url');
			cisLinkHref = ' href=\'' + cisLinkHref + '\' ';
		}

		var anchorLink = '<a ' + cisLinkHref + 'on-click=\'' + cisLinkOnclick + '\'>' + cisLinkText + '</a>';

		cisLiner = cisLiner.replace('@email', emailadd);
		cisLiner = cisLiner.replace('@cislink', anchorLink);
		this.resetPartial('successEmailContent', cisLiner);
	},
	showPreloader : function () {
		$('.banner-background').addClass('wait');
	},
	removePreloader : function () {
		$('.banner-background').removeClass('wait');
	},
	partials: {
		successEmailContent: ''
	}
});




Ractive.components["ux-cis-form-myinfo"] = Ractive.extend({
	template: LUXComponentTemplates['ux-cis-form-myinfo'],
	initVariables: function () {
		var self = this;
		self.set('transaction', true);
		self.set('modalButtonUrl', '');
		self.set('selectedCompany', '');
		self.set('isTncAgreed', false);
		self.set('modalFooter', '');
		self.set('modalButton2', '');
		self.set('modalButtonUrl2', '');
		self.set('noConsentInd', false);
	},
	onrender: function () {
		var self = this;
		self.set('data.onInitInputButtonDisabled', false);
		self.set('data.cisMyInfoCode', '');
		self.initVariables();

		self.on('ux-button.cisButtonAction', function (event) {
			self.set('data.onInitInputButtonDisabled', true);
			self.showPreloader();
			self.cisButtonAction();
			self.removePreloader();
		});

		if (this.validateMyInfoState()) {
			self.checkMyInfoExistCIS();
		}

		self.on('*.doSelectCompany', function (event, type) {
			self.set('data.myInfoList.*.getExistingNumberState', '');

			var companyList = this.get('data.myInfoList');
			_.each(companyList, function (company) {
				if (company.companyName === event.context.companyName) {
					company.getExistingNumberState = 'selected';
					self.set('modalButtonUrl', company.link);
				}
			});

			self.set('data.myInfoList', companyList);

			self.set('selectedCompany', event.context.companyName);
		});

		self.on('*.doSubmitMyInfoModal', function () {
			console.log(' redirect to ' + this.get('modalButtonUrl'));
			window.location.href = this.get('modalButtonUrl');
		});
	},
	validateMyInfoState: function () {
		return !!RactiveHelpers.getParameterByName('myInfoRefToken');
	},

	getCookieTest: function (name) {
		var nameEQ = encodeURIComponent(name) + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1, c.length);
			}
			if (c.indexOf(nameEQ) === 0) {
				return decodeURIComponent(c.substring(nameEQ.length, c.length));
			}
		}
		return null;
	},

	createCookie : function (name, value, hours) {
		var expires;
		if (hours) {
			var date = new Date();
			date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
			expires = '; expires=' + date.toGMTString();
		} else {
		
			expires = '; expires=Thu, 01 Jan 1970 00:00:01 GMT';
		}

		var host = window.location.host;
		var domain;
		var domainParts = host.split('.');
		domainParts.shift();
		domain = '.' + domainParts.join('.');

		var finalCookie = encodeURIComponent(name) + '=' +
		encodeURIComponent(value) + expires + ';domain=' + domain + '; path=/';
		document.cookie = finalCookie;
	},

	eraseCookie : function (name) {
		this.createCookie(name, '', -1);
	},
	cisButtonAction : function () {
		var self = this;
		var state = this.generateId();
		var expiresCookie = this.getCookieTest('cisStateStatus');
		if (expiresCookie && expiresCookie !== -1) {
			this.eraseCookie('cisStateStatus');
		}
		this.createCookie('cisStateStatus', state, 1); 

		var redirectUrl = location.protocol + '//' + location.host + location.pathname;
		var payload = {
			client_id: this.get('apiClientId'),
			attributes: this.get('apiAttributes'),
		
			purpose: this.get('apiPurpose'),
			state: state,
			redirect_uri: redirectUrl
		};
		var myInfoInitiateApi = this.get('ctaUrl');

	
		$.ajax({
			type: 'POST',
			url: myInfoInitiateApi,
			contentType: 'application/json',
			headers: {
				Authorization: sessionStorage.getItem('apigee_token')
			},
			xhrFields: {
				withCredentials: true
			},
			dataType: 'json',
			data: JSON.stringify(payload),
			success: function (response) {
				if (response && response.body.verificationUrl) {
					console.log('url: ' + response.body.verificationUrl);
					window.location.href = response.body.verificationUrl;
				} else {
					console.log('response.body.verificationUrl is empty', response);
					self.set('data.onInitInputButtonDisabled', false);
					self.setModalMessage('myinfoFailText');
					self.handleModal(true, 'genericError');
				}
			},
			error: function (xhr) {
				console.log('error calling api ' + myInfoInitiateApi);
				self.set('data.onInitInputButtonDisabled', false);
				self.setModalMessage('myinfoFailText');
				self.removePreloader();
				self.handleModal(true, 'genericError');
			}
		});
	},
	checkMyInfoExistCIS : function () {
		console.log('start checkMyInfoExistCIS');
	
		var self = this;
		var myInfoValidateApi = this.get('ctaValidateUrl');

		self.showPreloader();
		console.log('myInfoAdd = ' + myInfoValidateApi);
		self.set('companyLength', 0);

		$.ajax({
			type: 'POST',
			url: myInfoValidateApi,
			contentType: 'application/json',
			headers: {
				Authorization: sessionStorage.getItem('apigee_token')
			},
			xhrFields: {
				withCredentials: true
			},
			dataType: 'json',
			data: JSON.stringify({
				myInfoRefToken: RactiveHelpers.getParameterByName('myInfoRefToken')
			}),
			success: function (res) {
				if (res && res.body) {
					console.log('success');
					var response = res.body;
					var companyLength = response.length;
					console.log('company Length = ' + companyLength);
					self.set('companyLength', companyLength);
					self.set('data.myInfoList', response);
					if (companyLength >= 1 && response[0].companyName) {
						console.log('set preselected');
						self.set('modalTitle', self.get('cisSuccessText.modalTitle'));
						self.set('modalMessage', self.get('cisSuccessText.modalDesc'));
						self.set('modalButtonLabel', self.get('cisSuccessText.modalButtonLabel'));
						self.set('modalButtonUrl', response[0].link);
						self.set('selectedCompany', response[0].companyName);
						self.set('data.myInfoList.0.getExistingNumberState', 'selected');
						self.set('data.onInitInputButtonDisabled', false);
						self.set('modalFooter', self.get('cisSuccessText.modalFooter'));
						self.set('modalButton2', self.get('cisSuccessText.modalButton2'));
						self.set('modalButtonUrl2', self.get('cisSuccessText.modalButtonUrl2'));
						self.handleModal(true, 'displayMyInfoModal');
					} else {
						console.log('company length is 0');
						self.set('selectedCompany', '');
						self.setModalMessage('cisFailText');
						self.handleModal(true, 'genericError');
					}
				} else {
				
					console.log('response not success, ' + res);
					self.setModalMessage('cisFailText');
					self.handleModal(true, 'genericError');
				}
			
				self.removePreloader();
			},
			error: function (xhr) {
				console.log('error calling api ' + myInfoValidateApi);
				self.setModalMessage('cisFailText');
				self.removePreloader();
				self.handleModal(true, 'genericError');
			}
		});
	},

	showPreloader : function () {
		this.set('transaction', false);
	},
	removePreloader : function () {
		this.set('transaction', true);
	},
	handleModal: function (visibility, modalId, action, originUrl) {
		if (visibility) {
			this.set('hideModal', true);
		}
		var modals = this.parent.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];
		modal.set('displayState', visibility);
	},
	setModalMessage: function (modalFailText) {
		if (modalFailText) {
			this.set('modalTitle', this.get(modalFailText + '.modalTitle'));
			this.set('modalMessage', this.get(modalFailText + '.modalDesc'));
			this.set('modalButtonLabel', this.get(modalFailText + '.modalButtonLabel'));
			this.set('modalButtonUrl', this.get(modalFailText + '.modalButtonUrl')); 
			this.set('modalButton2', this.get(modalFailText + '.modalButton2'));
			this.set('modalButtonUrl2', this.get(modalFailText + '.modalButtonUrl2'));
		}
	},
	generateId: function () {
		var genId = Math.random().toString(36).substr(2, 16);
		return genId;
	},
	doAjaxJSONCallMyInfo: function (method, url, myInfoCode, successCallback, errorCallback, payload) {
		var promise = $.Deferred();
		var xhr = new XMLHttpRequest();
		if (typeof method !== 'undefined' && method !== '' &&
			typeof url !== 'undefined' && url !== ''
		) {
			xhr.open(method, encodeURI(url));
			xhr.setRequestHeader('Content-Type', 'application/json');
			xhr.setRequestHeader('x-auth-token', myInfoCode);
			xhr.onload = function () {
				if (xhr.status === 200) {
					var jsonResponse = JSON.parse(xhr.responseText);
					if (successCallback) {
						successCallback(jsonResponse);
					}
					promise.resolve(jsonResponse);
				} else {
					if (errorCallback) {
						errorCallback(xhr);
					}
					promise.reject(xhr);
				}
			};

			if (payload !== '' && (method === 'PUT' || method === 'POST')) {
				xhr.send(JSON.stringify(payload));
			} else {
				xhr.send();
			}

		} else {
			var errMsg = {message: ' method : "' + method + '" or url : "' + url + '" are not valid !'};
			errorCallback(errMsg);
			promise.reject(errMsg);
		}
		return promise;
	}
});




Ractive.components["ux-color-variant"] = Ractive.extend({
	template: LUXComponentTemplates['ux-color-variant'],

	onrender: function () {

		this.on('selectColor', function (event, color) {
			this.fire('doSelectColor', color);
		}.bind(this));

		this.set('getSelectedColor', function (color) {
			return this.get('selectedColorState.' + color.toLowerCase());
		}.bind(this));
	}
});

Ractive.components["ux-colorcapacity-selector"] = Ractive.extend({
	template: LUXComponentTemplates['ux-colorcapacity-selector'],

	data: function () {
		return {
			ConfigStrings: ConfigStrings
		};
	},

	onrender: function () {
		var self = this;
		self.disableCapacity();
		self.setPhoneStock();


	
		var spacings = ['small', 'medium', 'large'];
		self.fire('setButtonToggleState', 'disabled');
		var topSpacing = self.get('topSpacing');
		topSpacing = _.indexOf(spacings, topSpacing) !== -1 ?
		self.set('topSpacing', topSpacing) : self.set('topSpacing', 'normal');

		var bottomSpacing = self.get('bottomSpacing');
		bottomSpacing = _.indexOf(spacings, bottomSpacing) !== -1 ?
		self.set('bottomSpacing', bottomSpacing) : self.set('bottomSpacing', 'normal');

		self.on('ux-productvariant-container.doOpenModalContent', function () {
			self.set('noOpenModelInd', false);
			self.fire('getPriceDetails');
		});

		self.parent.on('openModel', function (newValue) {
			if (newValue === 'failure') {
				self.set('errorMessage', true);
			} else {
				self.set('errorMessage', false);
				self.set('productAvailability.availableStocks', newValue);
			}
			self.handleModal();
		});

		self.on('ux-color-variant.doSelectColor', function (imgColor) {
			self.set('selectedColor', imgColor);
			self.set('selectedCapacity', '');
			self.setSelectedState('selectedColorState', self.get('selectedColor'));
			self.fire('setButtonToggleState', 'disabled');
			self.enableCapacity();
			self.updateStockCss();
			self.fire('colorChange', imgColor);
		});

		self.on('ux-capacity-variant.doSelectCapacity', function (imgCapacity) {
			var capacityState = self.get('selectedCapacityState');
			if (capacityState === 'disabled') {
				return;
			}
			self.set('selectedCapacity', imgCapacity);
			self.setSelectedState('selectedCapacityState', self.get('selectedCapacity'));
			var numOfInstallments = 12;
			if (numOfInstallments !== 0) {
				self.fire('setPaymentModeState', 'enabled', imgCapacity);
			} else {
				self.fire('setButtonToggleState', 'enabled');
			}
		});

	},

	setPhoneStock: function () {
		var self = this;
		self.set('noOpenModelInd', true);
		self.fire('getPriceDetails');
	},

	updateStockCss: function () {
		var self = this;
		var selectedColor = self.get('selectedColor');
		var phoneSizes = self.get('phoneSizes');
		var phoneStock = self.get('data.phoneStock');

		if (selectedColor && selectedColor !== '') {
			var stock = _.filter(phoneStock, function (item) {
				return item.color === selectedColor;
			});

			if (stock && stock.length > 0) {
				_.each(phoneSizes, function (obj) {
					if (obj !== undefined && obj.size !== undefined) {
						var itemSize = obj.size;

						var stockInfo = _.filter(stock[0].stockInfo, function (stk) {
							return stk.capacity === itemSize;
						});
						if (stockInfo && stockInfo.length > 0) {
							obj.phoneStatus = stockInfo[0].status;
						} else {
							obj.phoneStatus = 'n/a';
						}
					}
				});
				self.set('phoneSizes', phoneSizes);
				self.update();
			}
		}
	},

	disableCapacity: function () {
		this.fire('setButtonToggleState', 'disabled');
		this.fire('setPaymentModeState', 'disabled');
		this.set('selectedCapacityState', 'disabled');
		this.update();
	},

	enableCapacity: function () {
		this.set('selectedCapacityState', '');
		this.update();
	},

	handleModal: function () {
		var modal = this.parent.findComponent('ux-modal');
		var noOpenModelInd = this.get('noOpenModelInd');

		var availabilities = this.get('productAvailability.availableStocks');
		if (availabilities) {
			var phoneStock = [];

			var phoneColors = this.get('phoneColors');

			var variants = this.get('variants');
			var phoneStockHeaders = {};
			_.each(phoneColors, function (phoneColor) {
				var phone = {};
				phone.color = phoneColor.name;
				phone.hexCode = phoneColor.hexCode;
				phone.stockInfo = {};
				var filteredVariants = [];
				var phoneIds = [];
				_.each(variants, function (variant) {
					if (variant.sku && !_.contains(phoneIds, variant.sku)) {
						phoneIds.push(variant.sku);
						filteredVariants.push(variant);
					}
				});
				var colorVariants = _.filter(filteredVariants, function (obj) {
					return obj.color === phoneColor.name;
				});

				_.each(colorVariants, function (variant) {
					var stock = _.findWhere(availabilities, {itemCode: variant.sku});
					if (stock) {
						phone.stockInfo[variant.size] = {
							capacity: variant.size,
							status: stock.status,
							sku: stock.itemCode
						};
						phoneStockHeaders[variant.size] = {
							capacity: variant.size,
							status: stock.status,
							sku: stock.itemCode
						};
					}
				});

				phoneStock.push(phone);
			});

			this.set('data.phoneStockHeaders', phoneStockHeaders);
			this.set('data.phoneStock', phoneStock);
			var processCapacity = this.get('processCapacity');
			if (typeof processCapacity !== 'undefined' && processCapacity !== null &&
				processCapacity.color && processCapacity.size) {
				var phoneVariant = _.find(phoneStock, function (stock) {
					return stock.color === processCapacity.color;
				});
				if (phoneVariant) {
					var stockCapacity = phoneVariant.stockInfo[processCapacity.size];
					if (stockCapacity && (stockCapacity.status === 'Available' ||
						stockCapacity.status === 'Selling Fast')) {
						this.set('selectedCapacityState', '');
						var capacityComp = this.findAllComponents('ux-capacity-variant');
						if (capacityComp && capacityComp.length > 0) {
							capacityComp = capacityComp[0];
							capacityComp.fire('selectCapacity', {context:
								{price: processCapacity.price}}, stockCapacity.capacity);
						}
					}
				}
			}
		}
		if (!noOpenModelInd) {
			modal.set('displayState', true);
		}
	},

	setSelectedState: function (state, property) {
		var selectedStateStr = state + '.' + property.toString().toLowerCase();
		var selectedStateObj = this.get(state);
		if (selectedStateObj !== undefined && selectedStateObj !== '') {
			_.each(selectedStateObj, function (element, key) {
				if (key !== property.toString().toLowerCase()) {
					selectedStateObj[key] = '';
				}
			});
		}
		this.set(selectedStateStr, 'selected');
		this.update();
	}
});

Ractive.components["ux-column-control"] = Ractive.extend({
	template: LUXComponentTemplates['ux-column-control']
});

Ractive.components["ux-consent-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-consent-banner'],
	isolated: false,

	initVariables: function () {
		var self = this;
	
		self.set('cached', false);

		var expireDays = self.get('expireDays');
		var cookieName = self.get('cookieName');
		this.openAppEnable = self.get('openApp.enable');
		var expiresCookie = this.getCookieTest(cookieName);

	
		if (typeof window.ReactNativeWebView === 'undefined' && this.openAppEnable) {
			self.handleModal(true, 'openAppConsentBannerModal');
		}

		if (expiresCookie && expiresCookie !== -1) {
			self.set('cached', true);
		} else {
			this.createCookie(cookieName, cookieName, expireDays);
			self.handleModal(true, 'consentBannerModal');
		}
	},


	getCookieTest: function (name) {
		var nameEQ = encodeURIComponent(name) + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1, c.length);
			}
			if (c.indexOf(nameEQ) === 0) {
				return decodeURIComponent(c.substring(nameEQ.length, c.length));
			}
		}
		return null;
	},


	createCookie : function (name, value, days) {
		var expires;
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = '; expires=' + date.toGMTString();
		} else {
		
			expires = '; expires=Thu, 01 Jan 1970 00:00:01 GMT';
		}

		var host = window.location.host;
		var domain;
		var domainParts = host.split('.');
		domainParts.shift();
		domain = '.' + domainParts.join('.');

		var finalCookie = encodeURIComponent(name) + '=' +
		encodeURIComponent(value) + expires + ';domain=' + domain + '; path=/';
		document.cookie = finalCookie;
	},

	handleModal: function (visibility, modalId, action, originUrl) {
		if (visibility) {
			this.set('hideModal', true);
		}
		var modals = this.findAllChildComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];
		if (action && modalId === 'loginForm') {
			sessionStorage.setItem('action', action);
			if (originUrl) {
				modal.set('referenceUrl', originUrl);
			}
		}
		modal.set('displayState', visibility);
	},

	onrender: function () {
		var self = this;
		self.initVariables();

		self.on('*.doCloseModal doCloseModal', function () {
			this.set('displayState', false);
			var openAppBannerConsentHeight = $('.consent-banner-singtel-open-app').outerHeight();
			$('.component-container.widget-initialized.luxComponentsWidget').first().removeAttr('style');
			if (typeof window.ReactNativeWebView === 'undefined' && self.openAppEnable) {
				if (window.pageYOffset > 0) {
					$('.consentbanner-location').removeAttr('style');
				}
				if (window.pageYOffset === 0) {
					$('.consentbanner-location').css('margin-top', openAppBannerConsentHeight);
				}
			} else {
				$('.consentbanner-location').removeAttr('style');
			}
		});

		self.on('*.doRedirectAppStore', function () {
			var os = RactiveHelpers.getMobileOperatingSystem();
			if (os === 'android') {
				if (window.location && window.location.href) {
					window.location.href = self.get('openApp.appUrl.android');
				}
			}
			if (os === 'ios') {
				if (window.location && window.location.href) {
					window.location.href = self.get('openApp.appUrl.ios');
				}
			}
			if (os === 'windows') {
				if (window.location && window.location.href) {
					window.location.href = self.get('openApp.appUrl.android');
				}
			}
			if (os === 'undefined') {
				console.error('unsupported device');
			}
		});
	}
});

Ractive.components["ux-contact-detail-form"] = Ractive.extend({
	template: LUXComponentTemplates['ux-contact-detail-form'],
	isolated: true,
	data: function () {
		return {
			RactiveValidate: RactiveValidate,
			emailUpdateRequired: false,
			isEmailDisabled: true,
			isPhoneDisabled: true,
			RactiveHelpers: RactiveHelpers
		};
	},

	validateContactNum: function () {
		var error = ConfigStrings.guestCheckoutValidationError.mobileNumber;
		var phone = this.get('orderFullfilment.deliveryDetails.phone');
		if (this.get('onepassInfo.isWorryFreeLogin') && phone) {
			if (this.get('contactUpdateNeeded')) {
				if (phone.match(/^[89][0-9]{7}$/)) {
					return true;
				} else {
					return false;
				}
			} else if (phone.match(/\*{4}\d{4}/)) {
				return true;
			}
		}
		this.contactNumberValidationRule = new RactiveValidate(this,{
			'orderFullfilment.deliveryDetails.phone': {
				validMobileNumber: error.inValidMobileNumber,
				minlength: {
					param: 8,
					message: error.minLengthError
				},
				maxlength: {
					param: 8,
					message: error.maxLengthError
				},
				digits: error.mobileDigitOnly,
				required: error.mobileRequired
			}
		});
		this.contactNumberValidationRule.cwd = '';
		return this.contactNumberValidationRule.validate(this.contactNumberValidationRule).valid;
	},

	validateContactEmail: function () {
		var error = ConfigStrings.guestCheckoutValidationError.emailAddress;
		var emailId = this.get('orderFullfilment.deliveryDetails.emailId');
		var exp = new RegExp (['^(([^<>()[\\]\\.,;:\\s@\\"\\*]+(\\.[^<>()[\\]\\.,;:\\s@\"\*]+)*)|(\\".+\"))@',
				'(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$'].join(''), 'i');
		if (this.get('onepassInfo.isWorryFreeLogin') && this.get('contactUpdateNeeded') && emailId &&
			!emailId.match(exp)) {
			return false;
		}

		this.contactEmailValidationRule = new RactiveValidate(this,{
			'orderFullfilment.deliveryDetails.emailId'	: {
				required: error.nameRequired,
				email: error.inValidEmail
			}
		});
		this.contactEmailValidationRule.cwd = '';
		return this.contactEmailValidationRule.validate(this.contactEmailValidationRule).valid;
	},
	oncomplete: function () {

		this.on('ux-input-box.validateEmail', function () {
			var isValid = this.validateContactEmail();
			if (isValid) {
				this.fire('emailChanged');
			}
		}.bind(this));

		this.on('ux-input-box.validateContactNumber', function () {
			var isValid = this.validateContactNum();
			if (isValid) {
				this.fire('contactNumberChanged');
			}
		}.bind(this));

		this.on('*.updateNum', function (event) {
		
			this.set('orderFullfilment.deliveryDetails.phoneErrorMsg', {
				message: '',
				status: ''
			});
		});

		this.on('*.updateEmail', function (event) {
		
			this.set('orderFullfilment.deliveryDetails.emailIdErrorMsg', {
				message: '',
				status: ''
			});
		});
		this.observe('orderFullfilment.deliveryDetails.emailId orderFullfilment.deliveryDetails.phone',
			this.validateAllContactDetails, {context: this,init: true});
		this.validateAllContactDetails();
	},
	validateAllContactDetails: function () {
		var isValidEmail = this.validateContactEmail();
		if (this.get('onepassInfo.isWorryFreeLogin') && isValidEmail && !this.get('contactUpdateNeeded')) {
			if (!this.get('isEmailDisabled')) {
				this.get('isEmailDisabled', true);
			}
		} else {
			this.set('isEmailDisabled', false);
		}
		var isValidPhone = this.validateContactNum();

		if (this.get('onepassInfo.isWorryFreeLogin') && isValidPhone && !this.get('contactUpdateNeeded')) {
			if (!this.get('isPhoneDisabled')) {
				this.get('isPhoneDisabled', true);
			}
		} else {
			this.set('isPhoneDisabled', false);
		}
		var isContactDetailsValid = isValidEmail && isValidPhone;
		this.set('isContactDetailsValid', isContactDetailsValid);
	}
});

Ractive.components["ux-contactusaccordion"] = Ractive.extend({
	template: LUXComponentTemplates['ux-contactusaccordion'],
		oncomplete: function () {
		var self = this;
		self.set('open', false);
		self.set('type', 'arrow-down');
		if (!self.isEditMode()) {
			self.set('contentClass', 'hidden');
		}
		var openHeight,
			el = self.find('.main-content');
		self.on('toggleOpen', function (event, groupId) {
			var status = !self.get('open');
			Ractive.defaults.fire('contactus_accordionClose', groupId);
			self.changeLPSection(self.get('lpSection'));
			self.set('open', status);
			self.observe('open', function (newValue) {
				if (newValue) {
					el.style.maxHeight = openHeight + 'px';
					self.set('type', 'up-arrow');
					self.set('contentClass', 'visible');
					self.set('open', true);
				} else {
					if (!openHeight) {
						var counter = 0;
						var checkHeight = setInterval(function () {
							if (el.offsetHeight > 0 || counter > 100) {
								openHeight = el.offsetHeight;
								el.style.maxHeight = '0px';
								self.set('open', false);
								self.set('contentClass', 'hidden');
								self.set('type', 'arrow-down');
								clearInterval(checkHeight);
							}
							counter++;
						}, 100);
					} else {
						el.style.maxHeight = '0px';
						self.set('open', false);
						self.set('contentClass', 'hidden');
						self.set('type', 'arrow-down');
					}
				}
			});
		});

		Ractive.defaults.on('contactus_accordionClose', function (groupId) {
			var self = this;
			if (self.get('accordionGroup').toLowerCase() === groupId.toLowerCase()) {
				self.set('open', false);
			}
		}.bind(self));
	},
	changeLPSection: function (lpSection) {
		var url = window.location.href;
		if (window.lpTag && window.lpTag.newPage) {
		window.lpTag.newPage(url, {  
		section : [lpSection]
		});
	}
	},
	isEditMode: function () {
		try {
			return window.self !== window.top;
		} catch (e) {
			return true;
		}
	}
});

Ractive.components["ux-crop-text"] = Ractive.extend({
	template: LUXComponentTemplates['ux-crop-text'],
	isolated: true,
	oninit: function () {
		this.renderText();
		if (!this.get('stopResize')) {
			window.addEventListener('resize', this.renderText.bind(this));
		}
		this.observe('showComplete', this.renderText.bind(this));
		this.observe('text', this.renderText.bind(this));
	},
	renderText: function () {
		var displayText = this.get('text');
		var showComplete = this.get('showComplete');
		if (!showComplete) {
			displayText = this.cropText(displayText);
		}
		this.set('displayText', displayText);
	},

	cropText: function (displayText) {
		var bp = ConfigStrings.breakpoints;
		var cropTextConfig = ConfigStrings.cropTextConfig;
		var vpWidth = window.innerWidth;
		var maxChars = this.get('mobileChars') || cropTextConfig.mobileChars;
		if (vpWidth > bp.desktop.minWidth) {
		
			maxChars = this.get('desktopChars') || cropTextConfig.desktopChars;
		} else if (vpWidth > bp.tablet.minWidth) {
		
			maxChars = this.get('tabletChars') || cropTextConfig.tabletChars;
		} else {
		
			maxChars = this.get('mobileChars') || cropTextConfig.mobileChars;
		}
		if (displayText && displayText.length > maxChars) {
		
			displayText = displayText.substr(0, maxChars) + (this.get('elipses') || '...');
		}
		return displayText;
	}
});

Ractive.components["ux-custom-option"] = Ractive.extend({
	template: LUXComponentTemplates['ux-custom-option'],
	oninit: function () {
		this.on('onOptionClick', function () {
			var onOptionSelectedEvent = this.get('onOptionSelected');
			if (onOptionSelectedEvent) {
				this.fire(onOptionSelectedEvent, this.get('value'), this);
			} else {
				this.fire('onOptionSelected', this.get('value'), this);
			}
		});
	}
});

Ractive.components["ux-custom-select"] = Ractive.extend({
	template: LUXComponentTemplates['ux-custom-select'],
	isolate: true,

	data: function () {
		return {
			selectedValueTemplate: 'ux-selected-value',
			selectedOption: null,
			selectedOptionComponent: null,
			showOptions: false
		};
	},

	oninit: function () {
		this.on('*.onOptionSelected', function (selectedOption, optionComponent) {
			this.set('selectedOptionComponent', optionComponent);
			this.set('selectedOption', selectedOption);
		}.bind(this));
	},

	oncomplete: function () {
		var actionNode = this.find('.ux-custom-select');

		var mouseClickHandler = function () {
			var showOptions = this.get('showOptions');
			if (showOptions) {
				document.removeEventListener('click', mouseClickHandler);
			} else {
				setTimeout(function () {
					document.addEventListener('click', mouseClickHandler);
				}, 0);
			}
			this.set('showOptions', !showOptions);
		}.bind(this);

		actionNode.addEventListener('click', mouseClickHandler);
		this.selectDefaultOption();
	},
	selectDefaultOption: function () {
	
		var selectedOption = this.get('selectedOption');
		if (!selectedOption) {
			var defaultOptionIndex = this.get('defaultOptionIndex');
			var allOptions = this.findAllChildComponents('ux-custom-option');
			if (allOptions && allOptions.length) {
				this.fire('ux-custom-option.onOptionSelected',
					allOptions[defaultOptionIndex].get('value'),
					allOptions[defaultOptionIndex]);
			}
		} else {
			var comparatorField = this.get('comparatorField');
			var allOptions = this.findAllChildComponents('ux-custom-option');
			if (allOptions && allOptions.length) {
				var selectedOptionComponent = _.find(allOptions, function (option) {
					if (comparatorField) {
						return option.get('value.' + comparatorField) === selectedOption[comparatorField];
					} else {
						return option.get('value') === selectedOption;
					}
				});
				if (selectedOptionComponent) {
					this.fire('ux-custom-option.onOptionSelected',
					selectedOptionComponent.get('value'),
					selectedOptionComponent);
				}
			}
		}
	}
});

Ractive.components["ux-customerprofile-header"] = Ractive.extend({
	template: LUXComponentTemplates['ux-customerprofile-header']
});

Ractive.components["ux-date-time-picker"] = Ractive.extend({
	template: LUXComponentTemplates['ux-date-time-picker'],
	isolated: true,
	oninit: function () {

		this.observe('timeSlots', function (newTimeSlotsValue) {
			var timeSlotsOptions = [];

			if (newTimeSlotsValue) {

				_.forEach(newTimeSlotsValue, function (timeSlot) {
					switch (typeof timeSlot) {
						case 'object':
							var slot = {
								value: timeSlot,
								text: timeSlot,
								disabled: false
							};
							slot = _.extend(slot, timeSlot);
							timeSlotsOptions.push(slot);
							break;
						default:
						case 'string':
							timeSlotsOptions.push({
								value: timeSlot,
								text: timeSlot,
								disabled: false
							});
							break;
					}
				});

				this.set('timeSlotsOptions', timeSlotsOptions);
			}


		}.bind(this));

		this.observe('selected_date', function (newValue) {
			if (newValue) {
				this.fire('dateSelected', newValue, true);
			}
		}.bind(this));

		this.observe('selected_time', function (newValue) {
			if (newValue) {
				var slot = this.getSlotByValue(newValue);
				this.fire('timeSelected', newValue, slot);
			}
		}.bind(this));

		this.set('getSlotState', function (idx) {
			return this.get('selectedSlotState.' + idx);
		});

		this.on('selectTimeslot', function (event, slot, idx) {
			this.set('selectedSlot', slot);
			this.setSelectedState('selectedSlotState', idx);
			this.fire('doSelectTimeslot', slot);
		});

	},

	getSlotByValue: function (slotValue) {
		var slot = _.find(this.get('timeSlotsOptions'), function (timeSlotsOption) {
			return timeSlotsOption.value === slotValue;
		});
		return slot;
	},

	onrender: function () {

	

		this.initCalendar();

	

	},
	initCalendar: function () {

		if (this.get('minDate') === 'today') {
			this.set('computedMinDate', moment().toDate());
		} else if (this.get('minDate') !== undefined) {
			this.set('computedMinDate', moment(this.get('minDate')).toDate());
		}

		if (this.get('numberOfMonthsAvailable')) {
			var maxDate = moment().add(this.get('numberOfMonthsAvailable') - 1, 'M').endOf('month');
			this.set('computedMaxDate', maxDate.toDate());
		} else if (this.get('maxDate') !== undefined) {
			this.set('computedMaxDate', moment(this.get('maxDate')).toDate());
		}

		var defaultDate = (this.get('defaultDate') !== undefined) ?
			moment(this.get('defaultDate')).toDate() : moment().toDate();
		this.fire('dateSelected', defaultDate);

		var container = this.find('.calendar-container');
		if (this.get('timeSelectionType') === 'appointment-booking') {
			container = this.find('.appointment-calendar-container');
		} else {
			container = this.find('.calendar-container');
		}
		container.innerHTML = '';

		var setDefaultDate = (this.get('setDefaultDate') !== undefined) ? this.get('setDefaultDate') : false;

		var picker = new Pikaday({
			minDate: this.get('computedMinDate'),
			maxDate: this.get('computedMaxDate'),
			defaultDate: defaultDate,
			setDefaultDate: setDefaultDate,
			disableWeekends: this.get('disableWeekends'),
			onSelect: function (date) {
				this.set('selected_date', date);
			}.bind(this),
			disableDayFn: function (date) {
				var enabledDays = this.get('enabledDays') || [];

				var disableDaysFunc = this.get('disableDaysFunc');
				if (disableDaysFunc && disableDaysFunc(date)) {
					return true;
				}

				if (enabledDays.length > 0) {

					for (var i = 0; i < enabledDays.length; i++) {
						var enabledDate = moment(enabledDays[i]).toDate();
						if (Date.equalsDay(enabledDate, date)) {
						
							return false;
						}

					}
				
					return true;
				} else {

					var disabledDays = this.get('disabledDays') || [];
					if ((this.get('timeSelectionType') === 'replaceSim') && date.getDay() === 0) {
						disabledDays.push(date);
					}

					for (var i = 0; i < disabledDays.length; i++) {
						var disabledDate = moment(disabledDays[i]).toDate();
						if (Date.equalsDay(disabledDate, date)) {
						
							return true;
						}
					}

					var publicHolidays = this.get('publicHolidays') || [];
					if ((this.get('timeSelectionType') === 'replaceSim') && date.getDay() === 0) {
						publicHolidays.push(date);
					}

					for (var i = 0; i < publicHolidays.length; i++) {
						var disabledDate = moment(publicHolidays[i]).toDate();
						if (Date.equalsDay(disabledDate, date)) {
						
							return true;
						}
					}
				
					return false;
				}
			}.bind(this)
		});
		container.appendChild(picker.el);

		this.set('selected_date', defaultDate);
	},
	setSelectedState: function (state, property) {
		var selectedStateStr = state + '.' + property;
		var selectedStateObj = this.get(state);
		if (selectedStateObj !== undefined) {
			_.each(selectedStateObj, function (element, key) {
				selectedStateObj[key] = '';
			});
		}
		this.set(selectedStateStr, 'selected');
		this.update();
	}
});

Ractive.components["ux-delivery-installation"] = Ractive.extend({
	template: LUXComponentTemplates['ux-delivery-installation'],
	isolated: true,

	computed: {
		guid: function () {
			return this._guid;
		}
	},

	data: function () {
		return {
			RactiveValidate: RactiveValidate,
			RactiveHelpers : RactiveHelpers,
			moment: moment,
			dateTimeShow: false,
			defaultDate: null,
			newDeliveryAddressAdded: false,
			ConfigStrings: ConfigStrings,
			isDeliverySelected: false,
			isInstallationSelected: false,
			hasDefaultDeliveryAdd: false,
			showDocumentUploadFlag: false,
			nextButtonDisabled: 'disabled',
			uploadedDocuments: null,
			documentNeeded: false,
			contactUpdateNeeded: false,
			quonomyAptSelected: null,
			isContactDetailsValid: false,
			isDocumentUploadValid: false,
			showMembershipCard: false,
			originalAppointmentTypeId: -1,
			eAppointmentCrOn: ConfigStrings.eAppointmentCrOn ||
				RactiveHelpers.getParameterByName('eAppointmentCrOn', false),
			aemDevices: null,
			storeOnlyTag: 'singtel:eshop-delivery/store-only-delivery',
			eShopPopStationTag: 'singtel:eshop-delivery/pop-station',
			rrpAccessoryTag: 'nxt:Category/rrp-accessories',
			showEkycLogin: false,
			myInfoDetails: null,
			isEkycDefaultAddressSet: false,
			missingDataInMyInfo: false,
			autoSelectDidRunOnce: false
		};
	},
	oninit: function () {
		var self = this;
		this.set('isRedemptionPageEnabled', self.isRedemptionPageEnabled());
		this.set('isMyInfoVerified', sessionStorage.getItem('isMyInfoVerified'));
		self.on('*.uploadDocsManuallyClick, ux-ekyc-myinfo-login.uploadDocsManuallyClick', function () {
			self.set('showEkycLogin', false);
			self.set('myInfoDetails', null);
			self.set('singpassFlag', true);
			self.set('isManuallyUpload', true);
		});
		var eKycFootnotes = this.get('initData.eKycFootnotes');
		var documentUploadManually = _.find(eKycFootnotes, function (note) {
			return (note && note.scenario === 'documentUploadManually');
		});
		this.set('documentUploadManually', documentUploadManually);
		var documentUploadSingpass = _.find(eKycFootnotes, function (note) {
			return (note && note.scenario === 'documentUploadSingpass');
		});
		this.set('documentUploadSingpass', documentUploadSingpass);
	},
	getAddressListByPostalCode: function (myInfoDetails) {
		if (myInfoDetails && myInfoDetails.postalCode) {
			this.set('address', {
				postCode: myInfoDetails.postalCode
			});
			this.parent.set('myInfoAddressRetrieve', true);
			this.fire('getCustomerAddress', this, 'delivery');
		}
	},
	myInfoNewAddressShow: function () {
		var self = this,
			myInfoDetails = self.get('myInfoAddressDetails'),
			addressList = self.get('addressList');
		if (myInfoDetails && myInfoDetails.postalCode) {
			var myInfoFloorNo = '#' + myInfoDetails.mailingAddrFloor + '-' + myInfoDetails.mailingAddrUnit;
			var isFloorUnitApplicable = true;
			var getAddress = _.find(addressList, function (address) {
				if (address.floor || address.unitNumber) {
					return ((address.floor === myInfoFloorNo || address.unitNumber === myInfoFloorNo) &&
						address.blockOrHouseNum === myInfoDetails.mailingAddrBlock);
				} else {
					isFloorUnitApplicable = false;
					return true;
				}
			});
			if (getAddress) {
				var address = {
					blockOrHouseNum: myInfoDetails.mailingAddrBlock,
					buildingName: myInfoDetails.buildingName,
					streetName: myInfoDetails.mailingAddrStreet,
					postCode: myInfoDetails.postalCode,
					floorNo: isFloorUnitApplicable ? getAddress.floor : '',
					unitNo: isFloorUnitApplicable ? getAddress.unitNumber : '',
					blockOrHouseAddr: getAddress.blockOrHouseAddr || '',
					buildingClassification: getAddress.buildingClassification || '',
					isNotApplicable: !isFloorUnitApplicable,
					type: 'myInfoRetrievedAddress'
				};
				this.set('addressRetrieve.address', address);
				address.state = ConfigStrings.physicalAddressValues.state;
				address.country = ConfigStrings.physicalAddressValues.country;
				address.city = ConfigStrings.physicalAddressValues.city;
				self.parent.set('createDeliveryAddress', address);
				var newAddressAdded = this.get('newAddressAdded');
				if (!newAddressAdded) {
					newAddressAdded = [];
				}
				newAddressAdded.push(address);
				var index = newAddressAdded.length > 0 ? (newAddressAdded.length - 1) : null;
				_.each(newAddressAdded, function (item) {
					item.chkId = false;
				});
				if (typeof index !== 'undefined') {
					newAddressAdded[index].chkId = true;
					this.set('newAddressAdded', newAddressAdded);
					this.checkIfAllDataSelected();
					this.set('isEkycDefaultAddressSet', true);
					this.showCalendar();
				}
				var selectedOption = this.get('selectedOption');
				if (selectedOption === 'sms-mail') {
					this.set('isDeliverySelected', true);
				}
			}
			this.checkIfAllDataSelected();
		}
	},
	initVariables: function () {
	
		this.set('disableDeliveryConfirmButton', true);
		this.set('onInitSearchPopStationDisabled', true);
		this.set('onInitSearchSingtelStoreDisabled', true);
		this.set('onInitSearchSelfCollectionDisabled', true);
	},

	selectDeliveryOption: function (selectedOption) {
		var deliveryOptions = this.get('initData.selectedDelivery.options'),
		deliveryModesList;
		this.set('quonomyAptSelected', null);
		this.parent.set('quonomyAptSelected', null);
		this.resetDeliveryDetails();
		this.parent.set('selectedOption', selectedOption.id);
		if (typeof selectedOption.offset !== 'undefined' &&
			selectedOption.offset !== null) {
			var documentNeeded = (this.get('documentNeeded') && !RactiveHelpers.isIppPlan() ||
				this.get('showMembershipCard')) && !this.get('ekycDocumentVerified');
			if (documentNeeded) {
				this.parent.set('leadDays', Number(selectedOption.offsetDocUpload));
			} else {
				this.parent.set('leadDays', Number(selectedOption.offset));
			}
		}
		this.set('selectedOption', selectedOption.id);
		this.set('selectedTypes', _.uniq(selectedOption.type, function (e) {
			return e.id;
		}));
		console.log(selectedOption);
		if (selectedOption.id === 'courier' || selectedOption.id === 'sms-mail') {
			deliveryModesList = this.getDeliveryModesList(deliveryOptions, selectedOption.id);
		}
		console.log(deliveryModesList);
		var deliveryIdList = _.uniq(_.pluck(deliveryModesList, 'id'));
		console.log(deliveryIdList);
		var needsOnlyMBBDelivery = this.get('orderFullfilment.billingDetails.needsOnlyMBBDelivery');
		if (selectedOption.id === 'collect-now') {
			this.set('selectedOption', selectedOption.id);
			this.parent.set('selectedOption', selectedOption.id);
			this.set('isCollectNow', true);
			this.fire('getCollectNowStores', this.get('selectedZone'));
		}
		if (selectedOption.id === 'courier' || selectedOption.id === 'sms-mail') {
			this.fire('retrieveTimeslots', selectedOption.id);
			var addressDeliveryMethod = this.get('orderFullfilment.deliveryDetails.addressDeliveryMethod');
			if (addressDeliveryMethod &&
				addressDeliveryMethod !== 'Courier To Home (PoPStation)' &&
				addressDeliveryMethod !== 'Collect Now') {
				this.getSelectedDeliveryAddress();
			} else {
				this.set('disableCalendar', true);
			}
		}
		if (deliveryIdList && (deliveryIdList.length > 1 ||
			(needsOnlyMBBDelivery && deliveryIdList.length > 0)) &&
			selectedOption.id === 'courier' || selectedOption.id === 'sms-mail') {
			this.fire('retrieveTimeslots', selectedOption.id);
			this.getSelectedDeliveryAddress();
		}
		if (selectedOption.id === 'courier') {
			this.resetCalendarDates(selectedOption.deliveryId);
		}
		var cartPurchaseDetails = this.get('orderFullfilment.cartPurchaseDetails');
		if (cartPurchaseDetails && selectedOption.id === 'sms-mail' &&
			!(cartPurchaseDetails.hasPurchasedTablet || cartPurchaseDetails.hasPurchasedHandset ||
				cartPurchaseDetails.hasPurchasedAccessories)) {
		
			var billAdd = this.parent.get('selectedBillingAddress');
			this.set('selectedBillAdd', billAdd);
			this.set('hasDefaultDeliveryAdd', true);
			this.onSelectDeliveryAddress(billAdd);
		} else {
			this.set('hasDefaultDeliveryAdd', false);
		}
		this.monoAddrSelector();
		if (selectedOption.id === 'singtel-store' && this.get('eAppointmentCrOn')) {
			this.fire('checkSingtelStoreAvailablity', this.get('initData.pickupSingtelStore'));
		}
		this.parent.set('inProcess', false);
	},
	selectDeliveryGroupOption: function (selectedGroupOption) {
		var deliveryOptions = this.get('initData.selectedDelivery.options'),
		deliveryModesList;
		this.set('selectedGroupNotes', selectedGroupOption.notes);
		this.set('selectedGroupId', selectedGroupOption.groupId);
		if (typeof selectedGroupOption.offset !== 'undefined' &&
			selectedGroupOption.offset !== null) {
			var documentNeeded = this.get('documentNeeded') && !RactiveHelpers.isIppPlan() ||
				this.get('showMembershipCard');
			if (documentNeeded) {
				this.parent.set('leadDays', Number(selectedGroupOption.offsetDocUpload));
			} else {
				this.parent.set('leadDays', Number(selectedGroupOption.offset));
			}
		}
		this.resetDeliveryDetails();
		if (selectedGroupOption.groupId === 'collectNow') {
			this.set('selectedOption', selectedGroupOption.id);
			this.parent.set('selectedOption', selectedGroupOption.id);
			this.set('isCollectNow', true);
			this.fire('getCollectNowStores', this.get('selectedZone'));
		} else {
			deliveryModesList = this.getDeliveryModesList(deliveryOptions, selectedGroupOption.groupId);
		}
		if (selectedGroupOption.groupId === 'delivery') {
			var isCourier = _.contains(_.pluck(deliveryModesList, 'id'), 'courier');
			var optionType = (isCourier ? 'courier' : 'sms-mail');
			this.fire('retrieveTimeslots', optionType);
			var addressDeliveryMethod = this.get('orderFullfilment.deliveryDetails.addressDeliveryMethod');
			if (addressDeliveryMethod &&
				addressDeliveryMethod !== 'Courier To Home (PoPStation)' &&
				addressDeliveryMethod !== 'Collect Now' &&
				addressDeliveryMethod !== 'Home Delivery (Pop Station)') {
				this.getSelectedDeliveryAddress();
			} else {
				this.set('disableCalendar', true);
			}
		}
		if (this.get('filteredDeliveryModesList') && this.get('filteredDeliveryModesList').length === 1) {
			this.selectDeliveryOption(this.get('filteredDeliveryModesList')[0]);
		}
	},
	selectInstallationOption: function (id) {
		this.set('selectedInstallationOption', id);
		var appointments = this.get('existingWirelineAppointments');
		if (typeof appointments !== 'undefined' && appointments !== null) {
			this.set('existingAppointments', true);
		} else {
			this.fire('selectedInstalOption', id);
			var isInstallationSelected = this.get('isInstallationSelected');
			if (!isInstallationSelected) {
				this.fire('disbaleOrderSummaryButton');
			}
		}
	},
	onSelectDeliveryAddress: function (value) {
		var needsOnlyMBBDelivery = this.get('orderFullfilment.billingDetails.needsOnlyMBBDelivery');
		if (needsOnlyMBBDelivery) {
			var installationAddress =
				this.get('orderFullfilment.deliveryDetails.installationAddress');
			if (installationAddress && installationAddress.addressId) {
				value = installationAddress;
			}
		}
		if (value.addressId) {
			this.parent.set('selectedDeliveryAddress', value);
			this.parent.set('createDeliveryAddress', null);
		} else {
			this.parent.set('createDeliveryAddress', value);
			this.parent.set('selectedDeliveryAddress', null);
		}
		this.parent.set('selectedDeliveryAddress', value);
		var selectedOption = this.get('selectedOption');
		if (selectedOption === 'sms-mail') {
			this.set('isDeliverySelected', true);
		}
		this.parent.set('deviceIdAndPlanId.collectionAddress', null);
		this.parent.set('deviceIdAndPlanId.collectionAddressType', null);
		this.checkIfAllDataSelected();
		this.showCalendar();
	},
	onSelectBillingAddress: function (accountNumber) {
		var accounts = this.get('orderFullfilment.deliveryDetails.billingAddress');
		var selectedAddress = _.where(accounts,
			{billingAccountNumber: accountNumber})[0].physicalAddress;
		this.parent.set('selectedDeliveryAddress', selectedAddress);
		this.parent.set('createDeliveryAddress', null);
		this.parent.set('addressRetrieve.addressList', undefined);
		var selectedOption = this.get('selectedOption');
		if (selectedOption === 'sms-mail') {
			this.set('isDeliverySelected', true);
		}
		this.checkIfAllDataSelected();
		this.showCalendar();
	},

	validateSingtelStoreZipCode: function () {
		this.validation.cwd = 'singtelStore';
		this.validation.validate();
	},

	validatePopStationZipCode: function () {
		this.validation.cwd = 'popStation';
		this.validation.validate();
	},

	setDocuments: function (idType, documents) {
		var components = this.findAllChildComponents('ux-document-upload');
		var component;
		if (components && components.length > 0) {
			component = _.find(components, function (comp) {
				return (comp.get('type') === idType);
			});
		}
		if (component) {
			component.set('uploadedDocuments', documents);
		}
		this.checkIfAllDataSelected();
	},

	onrender: function () {
		var self = this;
	
	
		self.initVariables();
		self.set('hideCalendar', false);
		self.set('skipOrderConsolidate', true);
		self.observe({
			'livePhotoUploadedDocuments': function (documents) {
				if (documents) {
					self.setDocuments('livePhoto', documents);
					self.checkIfAllDataSelected();
				}
			},
			'membershipCardUploadedDocuments': function (documents) {
				if (documents) {
					self.setDocuments('membershipCard', documents);
					self.checkIfAllDataSelected();
				}
			},
			'documentPhotoUploadedDocuments': function (documents) {
				if (documents) {
					self.setDocuments('documentPhoto', documents);
					self.checkIfAllDataSelected();
				}
			},
			'addressUploadedDocuments': function (documents) {
				if (documents) {
					self.setDocuments('residentialAddressPhoto', documents);
					self.checkIfAllDataSelected();
				}
			}
		});
		self.on('*.validateData', function () {
			self.checkIfAllDataSelected();
		});
		self.on('*.installationAppointmentNext', function () {
			var furtherStep = (this.get('hasPurchasedMobile') || this.get('contactUpdateNeeded') ||
				this.get('isRedemptionPageEnabled'));
			self.onNextClick(!furtherStep);
		});
		self.on('*.deliveryAppointmentNext', function () {
			var documentOrUpdateContactNeeded = (this.get('contactUpdateNeeded') || this.get('isRedemptionPageEnabled'));
			self.onNextClick(!documentOrUpdateContactNeeded);
		});
		self.on('*.contactDetailsNext', function () {
			self.onNextClick();
		});
		self.on('*.gotoPreviousStep', function () {
			Ractive.defaults.fire('ux-singtel-breadcrumbs.goto-prev-step');
		});
		self.on({
			'ux-document-upload.removeUploadedImageFromPage': function (documentID) {
				self.fire('removeDocumentNow', documentID);
			},
			'ux-membershipcard-upload.removeUploadedImageFromPage': function (documentID) {
				self.fire('removeDocumentNow', documentID);
			}
		});
		self.observe('isDeliveryModeSelected', function (newValue) {
			self.monoAddrSelector();
		}, {
			init: false
		});
		self.observe('orderFullfilment.billingDetails.lobs', function (purchases) {
			if (purchases) {
				var purchasedTVs = _.where(purchases, 'TV');
				var purchasedFibres = _.where(purchases, 'BB');
				var purchasedMobiles = _.where(purchases, 'WS');

				if (purchasedTVs.length > 0) {
					this.set('hasPurchasedTV', true);
				} else {
					this.set('hasPurchasedTV', false);
				}

				if (purchasedFibres.length > 0) {
					this.set('hasPurchasedFibre', true);
				} else {
					this.set('hasPurchasedFibre', false);
				}
				var hasSim = this.get('orderFullfilment.billingDetails.hasSim') &&
					!this.get('orderFullfilment.billingDetails.needsOnlyMBBDelivery');
				var homeLineDeliveryRequired = this.get('orderFullfilment.billingDetails.homeLineDeliveryRequired');
				if ((purchasedMobiles.length > 0 && hasSim) || homeLineDeliveryRequired) {
					this.set('hasPurchasedMobile', true);
				} else {
					this.set('hasPurchasedMobile', false);
					var installationRequired =
						this.get('orderFullfilment.deliveryDetails.installationRequired');
					var isOpened = this.get('isOpened');
					if (installationRequired === false && isOpened) {
						this.fire('enableOrderSummaryButton');
					}
				}
			}
		});

		self.observe('orderFullfilment.deliveryDetails.installationRequired', function (value) {
			if (value === false) {
				var hasPurchasedMobile = self.get('hasPurchasedMobile');
				var isOpened = this.get('isOpened');
				if (isOpened && hasPurchasedMobile === false) {
					this.fire('enableOrderSummaryButton');
				}
			}
		});

		self.observe('isOpened', function (value) {
			if (value === true) {
				var hasPurchasedMobile = self.get('hasPurchasedMobile');
				var installationRequired =
						self.get('orderFullfilment.deliveryDetails.installationRequired');
				if (hasPurchasedMobile === false && installationRequired === false) {
					self.fire('enableOrderSummaryButton');
				}
				var homeLineDeliveryRequired = self.get('orderFullfilment.billingDetails.homeLineDeliveryRequired');
				if (homeLineDeliveryRequired) {
					self.set('initData.selectedDelivery', self.get('initData.fibreInstallation'));
					self.set('initData.selectedDelivery.deliveryGroupOptions',
						self.get('initData.fibreDeliveryGroupOptions'));
					self.set('initData.selectedNotesItems', self.get('initData.fibreNotesItems'));
				} else {
					self.set('initData.selectedDelivery', self.get('initData.deliveryInstallation'));
					self.set('initData.selectedDelivery.deliveryGroupOptions',
						self.get('initData.deliveryGroupOptions'));
					self.set('initData.selectedNotesItems', self.get('initData.notesItems'));
				}
				var deliveryGroupOptions = self.get('initData.selectedDelivery.deliveryGroupOptions');
				if (deliveryGroupOptions && deliveryGroupOptions.length === 1) {
					setTimeout(function () {
						var singularOption = document.getElementById(deliveryGroupOptions[0].groupId);
						while (!singularOption) {
							singularOption = document.getElementById(deliveryGroupOptions[0].groupId);
						}
						singularOption.click();
					}, 0);
				}
				self.set('startDeliveryDisplay', true);
			}
		});

		self.on('*.checkField', function () {
			this.set('dateTimeShow', false);
		});

		self.on('*.initSingtelSelectedApt', function (singtelSelectedApt) {
			if (singtelSelectedApt) {
				self.fire('singtelSelectedApt', singtelSelectedApt);
				self.set('hideCalendar', true);
				self.set('isInstallationSelected', true);
				var hasPurchasedMobile = self.get('hasPurchasedMobile');
				var flag = self.get('isDeliverySelected');
				if (hasPurchasedMobile) {
					if (flag) {
						self.checkIfAllDataSelected();
					}
				} else {
					self.checkIfAllDataSelected();
				}
			}
		});

		self.on('*.proceedToOrderSummary', function (event) {
			self.fire('continueWithSummary');
		});

		self.on('*.showDocumentUpload', function (event) {
			var selectedOption = self.get('selectedOption');
			var nextButtonDisabled = self.get('nextButtonDisabled');
			var documentNeeded = self.get('documentNeeded') && !RactiveHelpers.isIppPlan();
			if (documentNeeded && nextButtonDisabled !== 'disabled' &&
					(selectedOption === 'pop-station' ||
					selectedOption === 'singtel-pop-station' || selectedOption === 'sms-mail' ||
					selectedOption === 'collect-now')) {
				self.set('showDocumentUploadFlag', true);
				var uploadedDocuments = self.get('uploadedDocuments');
				var component = self.findComponent('ux-document-upload');
				if (component) {
					component.set('uploadedDocuments', uploadedDocuments);
				}
			} else {
				this.ractive.set('nextButtonDisabled', '');
				this.ractive.set('nextButtonDisabled', 'disabled');
			}
		});

		self.on('*.singtelAppointmentSelected', function (singtelSelectedApt) {
			if (singtelSelectedApt) {
				self.fire('quonomyAptSelected', singtelSelectedApt);
				self.set('isDeliverySelected', true);
				self.set('isInstallationSelected', true);
				var hasPurchasedMobile = self.get('hasPurchasedMobile');
				var flag = self.get('isDeliverySelected');
				self.set('quonomyAptSelected', singtelSelectedApt);
				RactiveHelpers.toggleModal(this, 'qnomyAppointmentSuccess', true);
				if (hasPurchasedMobile) {
					if (flag) {
						self.checkIfAllDataSelected();
					}
				} else {
					self.checkIfAllDataSelected();
				}
			}
		});

		self.observe('idDocumentsUpload.documentNeeded', function (documentNeeded) {
			if (typeof documentNeeded !== 'undefined' && documentNeeded !== null) {
				self.set('documentNeeded', documentNeeded && !RactiveHelpers.isIppPlan());
				self.checkIfAllDataSelected();
			}
		});

		self.observe('orderFullfilment.contactUpdateNeeded', function (contactUpdateNeeded) {
			if (typeof contactUpdateNeeded !== 'undefined' && contactUpdateNeeded !== null) {
				self.set('contactUpdateNeeded', contactUpdateNeeded);
				self.checkIfAllDataSelected();
			}
		});

		self.observe('orderFullfilment.cartPurchaseDetails', function (cartPurchaseDetails) {
			if (typeof cartPurchaseDetails !== 'undefined' && cartPurchaseDetails !== null) {
				var needsOnlyMBBDelivery = self.get('orderFullfilment.billingDetails.needsOnlyMBBDelivery');
				if (needsOnlyMBBDelivery) {
					setTimeout(function () {
						var options = self.get('initData.deliveryInstallation.options');
						_.find(options, function (option) {
							if (option.id === 'sms-mail') {
								self.set('deliveryModesList', options);
								var comp = self.parent.findComponent('ux-billing-details');
								if (comp) {
									comp.set('hasChangedBillAddress', true);
								}
								self.selectDeliveryOption(option);
								return true;
							}
						});
					}.bind(self), 0);
				}
				if (cartPurchaseDetails.pickNGoValueMatched) {
					var aemCodeList = self.get('initData.membershipCardUpload.pickNGoCodeList');
					var matchedCode = _.find(aemCodeList, function (aemCode) {
						return aemCode.code === cartPurchaseDetails.pickNGoValue;
					});
					if (matchedCode) {
						self.set('membershipCard', matchedCode);
						self.set('showMembershipCard', true);
					}
				}
				var roiDetails = self.get('deviceIdAndPlanId.roiDetails'),
					isOrderConsolidate = self.get('orderConsolidation');
				if (roiDetails && roiDetails.stockCode) {
					roiDetails = true;
				} else {
					roiDetails = false;
				}
				var minimumLeadDays,
					configuredOptions = this.get('initData.selectedDelivery.options'),
					deliveryGroupOptions = this.get('initData.selectedDelivery.deliveryGroupOptions'),
					productDeliveryOptions = this.get('initData.selectedDelivery.productDeliveryOptions'),
					homeLineDeliveryRequired =
						this.get('orderFullfilment.billingDetails.homeLineDeliveryRequired'),
					hideAllOneInventoryOptions = this.get('deviceIdAndPlanId.isStoreScenario'),
					hideStore = cartPurchaseDetails.hideStore,
					hideCollectNow = cartPurchaseDetails.hideCollectNow,
					hideOptionsList = [],
					showOptionsList = [],
					hasPurchasedMobile = this.get('hasPurchasedMobile');
				if (hasPurchasedMobile && hideAllOneInventoryOptions && hideStore && hideCollectNow) {
					self.fire('throwError');
					return true;
				}
				if (hideStore) {
					hideOptionsList.push('singtel-store');
				}
				if (hideCollectNow) {
					hideOptionsList.push('collect-now');
				} else {
					showOptionsList.push('collect-now');
				}
				if (hideAllOneInventoryOptions) {
					showOptionsList.push('singtel-store');
				}
				if (hideAllOneInventoryOptions) {
					configuredOptions = _.filter (configuredOptions, function (configuredOption) {
						return _.contains(showOptionsList, configuredOption.id);
					});
				} else if (hideOptionsList.length > 0) {
					configuredOptions = _.filter (configuredOptions, function (configuredOption) {
						return !_.contains(hideOptionsList, configuredOption.id);
					});
				}
				if (homeLineDeliveryRequired) {
					configuredOptions = _.filter (configuredOptions, function (configuredOption) {
						if (((configuredOption.id === 'singtel-pop-station' || configuredOption.id === 'pop-station') &&
							!(cartPurchaseDetails.hasPurchasedTablet || cartPurchaseDetails.hasPurchasedHandset ||
								cartPurchaseDetails.hasPurchasedAccessories)) ||
							configuredOption.id === 'courier') {
							return true;
						} else {
							return false;
						}
					});
				}
				var storeOnlyDevice = this.findStoreOnlyDevice();
			
			
				if (storeOnlyDevice && !hideStore && !cartPurchaseDetails.hasTradeIn) {
				
					var singtelStoreOption = _.find(configuredOptions, function (configuredOption) {
						return configuredOption.id === 'singtel-store';
					});
					if (singtelStoreOption) {
						configuredOptions = [singtelStoreOption];
					}
				}
				configuredOptions = this.mergeDeliveryOption(configuredOptions, deliveryGroupOptions);
				var idDocumentsUpload = this.get('idDocumentsUpload');
				_.each(configuredOptions, function (option) {
					option.displayFlag = self.checkConfigurationValues(option, cartPurchaseDetails,
						idDocumentsUpload, roiDetails);
					if (isOrderConsolidate && option.groupId === 'collectNow') {
						option.displayFlag = false;
					}
				});
				var filteredConfiguredOptions = _.filter(configuredOptions, function (configuredOption) {
					return configuredOption.displayFlag;
				});
				if (hasPurchasedMobile && filteredConfiguredOptions.length === 0) {
					self.fire('throwError');
					return true;
				}
				var type = [];
				var minPrice;
				var offset;
				var offsetDocUpload;
				_.each(filteredConfiguredOptions, function (option) {
					var price = option.deliveryModeTypePrice;
					if (typeof price === 'undefined' || price === null) {
						price = option.price;
					}
					option.deliveryId =  option.id;
					if (option.deliveryModeTypeId) {
						option.deliveryId =  option.deliveryModeTypeId;
						type.push({
							id: option.deliveryModeTypeId,
							title: option.deliveryModeTypeTitle,
							description: option.deliveryModeTypeDesc,
							price: price
						});
						minPrice = minPrice || option.deliveryModeTypePrice;
						offset = offset || option.offset;
						offsetDocUpload = offsetDocUpload || option.offsetDocUpload;
						if (minPrice > price) {
							minPrice = price;
						}
						if (offset && option.offset && Number(offset) > Number(option.offset)) {
							offset = option.offset;
						} else if (option.offset) {
							offset = option.offset;
						}
						if (offsetDocUpload && option.offsetDocUpload &&
							Number(offsetDocUpload) > Number(option.offsetDocUpload)) {
							offsetDocUpload = option.offsetDocUpload;
						} else if (option.offsetDocUpload) {
							offsetDocUpload = option.offsetDocUpload;
						}
					}
					var tempOffset;
					if ((idDocumentsUpload.documentNeeded && !RactiveHelpers.isIppPlan() ||
						self.get('showMembershipCard')) && !self.get('ekycDocumentVerified')) {
						tempOffset = option.offsetDocUpload;
					} else {
						tempOffset = option.offset;
					}
					if (minimumLeadDays && tempOffset && Number(minimumLeadDays) > Number(tempOffset)) {
						minimumLeadDays = tempOffset;
					} else if (tempOffset) {
						minimumLeadDays = tempOffset;
					}
					if (type.length > 0 && option.id !== 'singtel-store' &&
						_.where(type, {id: option.deliveryId}).length > 0) {
						option.type = type;
						option.offset = offset;
						option.offsetDocUpload = offsetDocUpload;
					}
				});
				var deliveryOptions = [];
				var pickUpOptions = [];
				var productDeliveryOptions = [];
				_.each(filteredConfiguredOptions, function (finalConfigurationOption) {
					if (finalConfigurationOption.isPickUpType) {
						pickUpOptions.push(finalConfigurationOption);
					} else {
						deliveryOptions.push(finalConfigurationOption);
					}
					productDeliveryOptions.push(finalConfigurationOption);
				});
				var eligibleGroups = this.getEligibleGroups(filteredConfiguredOptions);
				var currentOrderActions = self.get('orderContext.currentOrderActions');
				if (currentOrderActions && currentOrderActions[0] &&
					currentOrderActions[0].flowType !== 'rrpIPP' &&
					currentOrderActions[0].lob === 'WS') {
					var aemDevices = self.get('aemDevices');
					var isNotPopStationDevice =
						aemDevices && aemDevices[0].tags.indexOf(self.get('eShopPopStationTag')) === -1;
					if (isNotPopStationDevice) {
						eligibleGroups = eligibleGroups.filter(function (group) {
							return group.id !== 'pop-station' && group.id !== 'singtel-pop-station';
						});
						deliveryOptions = deliveryOptions.filter(function (option) {
							return option.id !== 'pop-station' && option.id !== 'singtel-pop-station';
						});
						productDeliveryOptions = productDeliveryOptions.filter(function (option) {
							return option.id !== 'pop-station' && option.id !== 'singtel-pop-station';
						});
						pickUpOptions = pickUpOptions.filter(function (option) {
							return option.id !== 'pop-station' && option.id !== 'singtel-pop-station';
						});
						var options = self.get('initData.deliveryInstallation.options');
						options = options.filter(function (option) {
							return option.id !== 'pop-station' && option.id !== 'singtel-pop-station';
						});
						self.set('initData.deliveryInstallation.options', options);
						self.set('initData.selectedDelivery.deliveryGroupOptions', eligibleGroups);
						self.set('initData.selectedDelivery.options', deliveryOptions);
						self.set('initData.selectedDelivery.pickUpOptions', pickUpOptions);
						self.set('initData.selectedDelivery.productDeliveryOptions', productDeliveryOptions);
					}
					var accIdentifiers = self.get('orderContext.accessoriesAdded');
					if (!isNotPopStationDevice && accIdentifiers && accIdentifiers.length > 0) {
						var url = '/bin/services/singtel/ProductComponentModelServlet?' + 'addons=' + accIdentifiers;
						self.parent.set('inProcess', true);
						RactiveHelpers.doAjaxJSONCallWithSimulator('POST', url, function (response) {
							var addons = response && response[0] && response[0].addons;
							addons = _.reject(addons, function (addon) {
								return addon.cqTags.indexOf(self.get('rrpAccessoryTag')) !== -1;
							});
							if (addons && addons.length > 0) {
								var anyNonPopStationAccs = _.some(addons, function (accessory) {
									return accessory.cqTags.indexOf(self.get('eShopPopStationTag')) === -1;
								});
								if (anyNonPopStationAccs) {
									eligibleGroups = eligibleGroups.filter(function (group) {
										return group.id !== 'pop-station' && group.id !== 'singtel-pop-station';
									});
									deliveryOptions = deliveryOptions.filter(function (option) {
										return option.id !== 'pop-station' && option.id !== 'singtel-pop-station';
									});
									pickUpOptions = pickUpOptions.filter(function (option) {
										return option.id !== 'pop-station' && option.id !== 'singtel-pop-station';
									});
									var options = self.get('initData.deliveryInstallation.options');
									options = options.filter(function (option) {
										return option.id !== 'pop-station'  && option.id !== 'singtel-pop-station';
									});
									productDeliveryOptions = productDeliveryOptions.filter(function (option) {
										return option.id !== 'pop-station' && option.id !== 'singtel-pop-station';
									});
									self.set('initData.deliveryInstallation.options', options);
									self.set('initData.selectedDelivery.deliveryGroupOptions', eligibleGroups);
									self.set('initData.selectedDelivery.options', deliveryOptions);
									self.set('initData.selectedDelivery.pickUpOptions', pickUpOptions);
									self.set('initData.selectedDelivery.productDeliveryOptions', productDeliveryOptions);
									self.parent.set('inProcess', false);
								}
							}
						}, function (response) {
							self.parent.set('inProcess', false);
							self.setModalDisplayState('genericError', true);
						});
					}
				}
				this.set('initData.selectedDelivery.deliveryGroupOptions', eligibleGroups);
				this.set('initData.selectedDelivery.options', deliveryOptions);
				this.set('initData.selectedDelivery.pickUpOptions', pickUpOptions);
				self.set('initData.selectedDelivery.productDeliveryOptions', productDeliveryOptions);
				var isSingtelShopVisible = _.find(deliveryOptions, function (item) {
					return item.id === 'singtel-store' && item.displayFlag;
				});
				if (self.get('eAppointmentCrOn')) {
					if (self.get('hasPurchasedMobile') &&
						(cartPurchaseDetails.checkConsolidation || isSingtelShopVisible)) {
						setTimeout(function () {
							self.fire('checkAllConsolidateOrder',
								minimumLeadDays, isSingtelShopVisible,
								(cartPurchaseDetails.checkConsolidation && !hideAllOneInventoryOptions));
						}, 0);
					} else {
						setTimeout(function () {
							self.parent.set('consolidateAppointmentTopic.exisitingAppointmentStatus',
								'consolidationSlotsRetrieved');
						}, 0);
					}
				} else if (self.get('hasPurchasedMobile') && cartPurchaseDetails.checkConsolidation) {
					setTimeout(function () {
						self.fire('checkConsolidateOrder', minimumLeadDays);
					}, 0);
				} else {
					setTimeout(function () {
						self.parent.set('dispatchAppointmentSlot.appointmentSlotsVmStatus',
							'consolidationSlotsRetrieved');
					}, 0);
				}

				this.showFulfilmentContextualMessage();
			}
		});
	
		self.observe('popStation.zipCode', function () {
			var zipCode = self.get('popStation.zipCode');
			if (zipCode !== '' && typeof zipCode !== 'undefined') {
				self.set('onInitSearchPopStationDisabled', false);
			}
		});

		self.observe('singtelStore.zipCode', function () {
			var zipCode = self.get('singtelStore.zipCode');
			if (zipCode !== '' && typeof zipCode !== 'undefined') {
				self.set('onInitSearchSingtelStoreDisabled', false);
			}
		});

		self.observe('selfCollection.zipCode', function () {
			var zipCode = self.get('selfCollection.zipCode');
			if (zipCode !== '' && typeof zipCode !== 'undefined') {
				self.set('onInitSearchSelfCollectionDisabled', false);
			}
		});
		self.observe('dateTimeShow', function (value) {
			if (value) {
				setTimeout(function () {
					var component = document.getElementsByClassName('ux-date-time-picker');
					while (!component) {
						component = document.getElementsByClassName('ux-date-time-picker');
					}
					if (component && component.length === 1) {
						var timeSlots = component[0].getElementsByTagName('input');
						var timeSlot = _.find(timeSlots, function (slot) {
							return !_.contains(slot.parentElement.classList, 'disabled');
						});
						if (timeSlot) {
							timeSlot.click();
						}
					}
				}, 0);
			}
		});
		self.parent.on('retrievedAppointments', function (appointmentDetails) {
			var selectedOption = self.get('selectedOption');
			if (selectedOption !== 'sms-mail') {
				var enabledDays = appointmentDetails.enabledDays || [];
				self.set('enabledDays', enabledDays);
				self.set('enabledDaysNew', enabledDays);
				var selectedOption = self.get('selectedOption');
			
				if (enabledDays.length > 0) {
					var timeslots = appointmentDetails.dateTimeSlots[enabledDays[0]];
					if (self.get('eAppointmentCrOn') && selectedOption === 'singtel-store') {
						timeslots = appointmentDetails.dateTimeSlotsObj[enabledDays[0]];
					}
					self.set('timeslots', timeslots);
				}
				self.set('appointmentSlots', appointmentDetails.dateTimeSlots) ;
				self.set('appointmentSlotsNew', appointmentDetails.dateTimeSlots);
				if (self.get('eAppointmentCrOn') && selectedOption === 'singtel-store') {
					self.set('appointmentSlots', appointmentDetails.dateTimeSlotsObj) ;
				}
				var createDeliveryAddress = self.parent.get('createDeliveryAddress');
				var selectedDeliveryAddress = self.parent.get('selectedDeliveryAddress');
				if (createDeliveryAddress || selectedDeliveryAddress) {
					self.set('dateTimeShow', true);
					var component = self.findComponent('ux-date-time-picker');
					if (component) {
						component.initCalendar();
					}
					setTimeout(function () {
						var component = document.getElementsByClassName('ux-date-time-picker');
						while (!component) {
							component = document.getElementsByClassName('ux-date-time-picker');
						}
						if (component && component.length === 1) {
							var timeSlots = component[0].getElementsByTagName('input');
							var timeSlot = _.find(timeSlots, function (slot) {
								return !_.contains(slot.parentElement.classList, 'disabled');
							});
							if (timeSlot) {
								timeSlot.click();
							}
						}
					}, 0);
				}
				var collectLaterList = ['pop-station', 'singtel-pop-station', 'singtel-store'];
				if (selectedOption === 'courier' || self.get('selectedGroupId') === 'delivery') {
					self.populateDeliveryMode(appointmentDetails.dateTimeSlots);
				} else if (_.contains(collectLaterList, selectedOption)) {
					self.set('dateTimeShow', true);
					var component = self.findComponent('ux-date-time-picker');
					if (component) {
						component.initCalendar();
					}
					setTimeout(function () {
						var component = document.getElementsByClassName('ux-date-time-picker');
						while (!component) {
							component = document.getElementsByClassName('ux-date-time-picker');
						}
						if (component && component.length === 1) {
							var timeSlots = component[0].getElementsByTagName('input');
							var timeSlot = _.find(timeSlots, function (slot) {
								return !_.contains(slot.parentElement.classList, 'disabled');
							});
							if (timeSlot) {
								timeSlot.click();
							}
						}
					}, 0);
				}
			}
		});

		self.parent.on('retrievedAppointmentsFailed', function () {

		});
	
		self.validation = new RactiveValidate(self, {
			'zipCode': {
				required: 'The Postal Code cannot be empty',
				digits: 'Please enter a valid Postal Code (digits only)',
				maxlength: {
					param: 6,
					message: 'Please enter a maximum of 6 characters'
				}
			}
		});

	
		self.on('selectDeliveryOption', function (event, id, oldValue) {
			self.selectDeliveryOption(event.context, oldValue);
		});

	
	
	

		self.on('selectDeliveryAddress', function (event, id) {
			self.onSelectDeliveryAddress(id);
		});

		self.on('selectBillingAddress', function (event, id) {
			self.onSelectBillingAddress(id);
		});

		self.on('selectInstallationOption', function (event, id) {
			self.selectInstallationOption(id);
		});

		this.on('*.getAddress', function (event) {
			this.fire('getCustomerAddress', event, 'delivery');
		}.bind(this));

		this.on('*.getPostalAddress', function (event) {
			this.fire('getPostAddress', event, 'delivery');
		}.bind(this));

		self.on('validatePopStationZipCode', function () {
			self.validatePopStationZipCode();
		});

		self.on('validateSingtelStoreZipCode', function () {
			self.validateSingtelStoreZipCode();
		});

		self.on('*.dateSelected', function (date) {

			var isContactForm = this.el && this.el.baseURI &&
				this.el.baseURI.includes('#fulfillment/contact-information');

			if (typeof date !== 'undefined' && !isContactForm) {
				self.set('selectedAptDetails', null);
				var appointmentSlots = self.get('appointmentSlots');
				if (typeof appointmentSlots !== 'undefined') {
					var selectedOption = self.get('selectedOption');
					self.set('selectedDate', date);
					var component = self.findComponent('ux-date-time-picker');
					if (component) {
						component.set('selected_time', null);
					}
					self.set('selected_time', null);
					var selectedDetails = {
						selectedDate : self.get('selectedDate')
					};
					self.set('selectedDetails', selectedDetails);
					if (selectedOption === 'pop-station' || selectedOption === 'singtel-pop-station') {
						self.set('timeslots', appointmentSlots[moment(date).format('YYYY-M-D')]);
						this.set('isDeliverySelected', false);
					} else {
						self.set('timeslots', appointmentSlots[moment(date).format('YYYY-MM-DD')]);
						this.set('isDeliverySelected', false);
					}
					self.fire('disbaleOrderSummaryButton');
					self.checkIfAllDataSelected();
				}
			}

		});
		self.on('*.timeSelected', function (time, slot) {
			var selectedDetails = _.extend({
				selectedDate : self.get('selectedDate'),
				selectedTime : time
			}, slot),
				date = moment(slot.slotDate).format('ddd,DD MMM YYYY');
			self.set('selectedDetails', selectedDetails);
			self.set('selectedAptDetails', date + ',' + slot.slotDesc);
			self.set('isDeliverySelected', true);
			this.fire('confirmReservation', selectedDetails);

			var isInstallationRequired = self.get('orderFullfilment.deliveryDetails.installationRequired');
			var flag = self.get('isInstallationSelected');
			if (isInstallationRequired) {
				if (flag) {
					this.checkIfAllDataSelected();
				}
			} else {
				self.checkIfAllDataSelected();
			}
		});
		self.on('*.pickupLocationSelected', function (selectedStore) {
			self.set('initData.selectedLocation', selectedStore);
			if (selectedStore.KioskId === ConfigStrings.singtelPopStation.KioskId) {
				var documentNeeded = (this.get('documentNeeded') && !RactiveHelpers.isIppPlan() ||
					this.get('showMembershipCard')) && !this.get('ekycDocumentVerified');
				var deliveryModesList = self.get('deliveryModesList');
				var popAtCom = _.find(deliveryModesList, function (mode) {
					return mode.id === 'singtel-pop-station' ||
						mode.deliveryId === 'singtel-pop-station';
				});
				if (popAtCom) {
					if (documentNeeded) {
						this.parent.set('leadDays', Number(popAtCom.offsetDocUpload));
					} else {
						this.parent.set('leadDays', Number(popAtCom.offset));
					}
				}
			}
			if (self.get('selectedOption') === 'singtel-store') {
				self.set('initData.regionId', selectedStore.zoneId);
				self.set('initData.storeId', selectedStore.id);
				self.set('initData.serviceId', selectedStore.qnomyServiceId);
				self.set('isDeliverySelected', false);
				self.set('initData.customerEmailId', self.get('orderFullfilment.deliveryDetails.emailId'));
			
			
				if (self.get('eAppointmentCrOn')) {
					self.fire('getSingtelShopTimeSlot', selectedStore);
				} else {
					var qnomyConfig = self.getQnomyConfigBySku(selectedStore);
					if (qnomyConfig) {
						var originalAppointmentTypeId = this.get('initData.originalAppointmentTypeId');
						if (originalAppointmentTypeId && originalAppointmentTypeId === -1) {
							this.set('initData.originalAppointmentTypeId', self.get('initData.appointmentTypeId'));
						}
						self.set('initData.appointmentTypeId', qnomyConfig.appointmentTypeId);
						self.set('initData.serviceId', qnomyConfig.serviceId);
					} else {
						self.set('initData.appointmentTypeId', this.get('initData.originalAppointmentTypeId'));
					}
					var componentId = self.findComponent('ux-singtel-store-appointment');
					if (componentId) {
						componentId.showQNomyCalendar();
					}
					self.fire('onSelectSingtelStoreId', selectedStore.id);
					self.set('selectedDeliveryAddress', selectedStore);
					console.log('deliveryselectedDeliveryAddress:', self.get('selectedDeliveryAddress'));
					self.checkIfAllDataSelected();
				}
			} else {
				self.set('initData.storeId', selectedStore.KioskId);
				if (self.get('selectedOption') === 'pop-station') {
					self.fire('getSelfCollectionTimeSlot', selectedStore);
				} else if (self.get('selectedOption') === 'collect-now') {
					self.fire('createCollectNowAppointment', selectedStore);
					self.set('isDeliverySelected', true);
				}
				self.set('selectedDeliveryAddress', selectedStore);
				console.log('deliveryselectedDeliveryAddress:', self.get('selectedDeliveryAddress'));
				self.checkIfAllDataSelected();
			}
		});

		self.on('onSingtelStoreSelected', function () {
			self.set('initData.storeId', ConfigStrings.singtelPopStation.KioskId);
			self.parent.set('selectedDeliveryAddress', ConfigStrings.singtelPopStation);
			self.fire('getSelfCollectionTimeSlot', ConfigStrings.singtelPopStation);
			self.checkIfAllDataSelected();
		});
				self.on('doChangeApmnt', function (event, modalId) {
			self.parent.set('appointmentId', event.context.appointmentId);
			self.setModalDisplayState(modalId, true);
		});
		self.on('*.doCloseModal', function (event) {
			self.handleCloseModal();
		});

		self.on('*.changeWirelineApmnt', function (event) {
			self.fire('doChangeWirelineApmnt', self);
			self.handleCloseModal();
		});
		this.on('*.showAddNewDeliveryAddressWindow', function (event, value) {
			this.resetToDefaultValues();
			this.setModalDisplayState('addNewDeliveryAddress', true);
		}.bind(this));

		this.on('*.changeNewAddress', function (event, value) {
			this.resetToDefaultValues();
		}.bind(this));

		this.on('*.confirmAddNewAddress', function (event, value) {
			var retrievedAddress = _.clone(this.get('addressRetrieve.address'));
			retrievedAddress.state = ConfigStrings.physicalAddressValues.state;
			retrievedAddress.country = ConfigStrings.physicalAddressValues.country;
			retrievedAddress.city = ConfigStrings.physicalAddressValues.city;
			self.parent.set('createDeliveryAddress', retrievedAddress);
			self.parent.set('selectedDeliveryAddress', null);
			this.set('toConfirmNewAddress', false);
			var newAddressAdded = this.get('newAddressAdded');
			if (!newAddressAdded) {
				newAddressAdded = [];
			}
			newAddressAdded.push(retrievedAddress);
			var index = newAddressAdded.length - 1;
			_.each(newAddressAdded, function (item) {
				item.chkId = false;
			});
			newAddressAdded[index].chkId = true;
			this.set('newAddressAdded', newAddressAdded);
			this.setModalDisplayState('addNewDeliveryAddress', false);
			var isInstallationRequired = this.get('orderFullfilment.deliveryDetails.installationRequired');
			var flag = this.get('isInstallationSelected');
			if (isInstallationRequired) {
				if (flag) {
					this.checkIfAllDataSelected();
				}
			} else {
				this.checkIfAllDataSelected();
			}
			document.getElementsByClassName('ux-delivery-installation')[0].
			scrollIntoView({behavior: 'smooth'});
			this.resetScrollHeight();
			this.showCalendar();
			var selectedOption = this.get('selectedOption');
			if (selectedOption === 'sms-mail') {
				this.set('isDeliverySelected', true);
			}
		}.bind(this));

		this.on('onSelectNewAddress', function (event, value) {
			var address = event.context.address || event.context;
			address.state = ConfigStrings.physicalAddressValues.state;
			address.country = ConfigStrings.physicalAddressValues.country;
			address.city = ConfigStrings.physicalAddressValues.city;
			this.parent.set('createDeliveryAddress', address);
			this.parent.set('selectedDeliveryAddress', null);
			this.checkIfAllDataSelected();
			this.showCalendar();
		});

		this.on('*.createBilling', function (event, value) {
		
			var errorFlag = false;
			this.findComponent('ux-address-form').set('errorMessage', false);
			var address = this.get('addressRetrieve.address');
			if (!address.postCode || (address.postCodeErrorMsg && address.postCodeErrorMsg.status === 'error')) {
				errorFlag = true;
			}
			var isValid = this.findComponent('ux-address-form').validateFloorAndUnitNumber();
			if (!errorFlag && isValid) {
				this.set('toConfirmNewAddress', true);
			}
		}.bind(this));

		this.parent.on('disableDeliveryConfirmationButton', function () {
			var allRadios = document.getElementsByName('select-account');
			_.each(allRadios, function (v) {
				v.checked = false;
			});
			this.set('disableDeliveryConfirmButton', false);
		}.bind(this));

		this.on('selectDeliveryMode', function (event, value) {
			this.set('isDeliveryModeSelected', true);
			var cartPurchaseDetails = this.get('orderFullfilment.cartPurchaseDetails');
			if (cartPurchaseDetails && value === 'sms-mail' &&
				!(cartPurchaseDetails.hasPurchasedTablet || cartPurchaseDetails.hasPurchasedHandset ||
					cartPurchaseDetails.hasPurchasedAccessories)) {
			
				var billAdd = this.parent.get('selectedBillingAddress');
				this.set('selectedBillAdd', billAdd);
				this.set('hasDefaultDeliveryAdd', true);
				this.onSelectDeliveryAddress(billAdd);
			} else {
				this.set('hasDefaultDeliveryAdd', false);
			}
			if (value === 'courier') {
				this.resetCalendarDates(value);
			}
		}.bind(this));

		Ractive.defaults.on({
			'onBillAddChange': function (event, context) {
				var cartPurchaseDetails = this.get('orderFullfilment.cartPurchaseDetails');
				var selectedOption = this.get('selectedOption');
				if (cartPurchaseDetails && selectedOption === 'sms-mail' &&
					!(cartPurchaseDetails.hasPurchasedTablet || cartPurchaseDetails.hasPurchasedHandset ||
						cartPurchaseDetails.hasPurchasedAccessories)) {
				
					var billAdd = this.parent.get('selectedBillingAddress');
					this.set('selectedBillAdd', billAdd);
					this.set('hasDefaultDeliveryAdd', true);
					this.onSelectDeliveryAddress(billAdd);
				}
				this.checkIfAllDataSelected();
			}.bind(this)
		});
	},

	checkConfigurationValues: function (option, cartPurchaseDetails, idDocumentsUpload, roiDetails) {
		var self = this;
		var displayFlag = true;
		var isBackOrderDevice = this.get('deviceIdAndPlanId.isBackOrder');
		if (roiDetails && cartPurchaseDetails.roi) {
			displayFlag = false;
		} else if (option.handset && cartPurchaseDetails.hasPurchasedHandset) {
			displayFlag = false;
		} else if (option.tablet && cartPurchaseDetails.hasPurchasedTablet) {
			displayFlag = false;
		} else if (option.tradeIn && cartPurchaseDetails.hasTradeIn) {
			displayFlag = false;
		} else if (option.simOnly && cartPurchaseDetails.hasPurchasedSim &&
			!cartPurchaseDetails.hasPurchasedHandset &&
			!cartPurchaseDetails.hasPurchasedTablet && !cartPurchaseDetails.hasPurchasedAccessories) {
			displayFlag = false;
		} else if (option.accessories && cartPurchaseDetails.hasPurchasedAccessories) {
			displayFlag = false;
		} else if (option.freegifts && cartPurchaseDetails.hasPurchasedFreegifts) {
			displayFlag = false;
		} else if (option.uploaddocument && (idDocumentsUpload.documentNeeded &&
			!RactiveHelpers.isIppPlan() || this.get('showMembershipCard'))) {
			displayFlag = false;
		} else if ((option.customerType === 'local' && !cartPurchaseDetails.isLocal) ||
			(option.customerType === 'foreigner' && cartPurchaseDetails.isLocal)) {
			displayFlag = false;
		} else if (option.cutoffTiming && moment(option.cutoffTiming, 'h:mma').isBefore(
			moment(moment().format('LT'), 'h:mma'))) {
			displayFlag = false;
		} else if (option.displayPeriod) {
			var displayPeriods = option.displayPeriod.split('-');
			if (!(moment(displayPeriods[0], 'h:mma').isBefore(
				moment(moment().format('LT'), 'h:mma')) && moment(displayPeriods[1], 'h:mma').isAfter(
				moment(moment().format('LT'), 'h:mma')))) {
				displayFlag = false;
			}
		} else if (self.doCheckCartValues(option.recon, cartPurchaseDetails.hasRecontract) &&
			(self.doCheckCartValues(option.newNewNumber, cartPurchaseDetails.newNewNumber)) &&
			(self.doCheckCartValues(option.newNewPortin, cartPurchaseDetails.newNewPortin)) &&
			(self.doCheckCartValues(option.existingNewNumber, cartPurchaseDetails.existingNewNumber)) &&
			(self.doCheckCartValues(option.existingNewPortin, cartPurchaseDetails.existingNewPortin))) {
			displayFlag = false;
		} else if (!option.recon && !option.newNewNumber && !option.newNewPortin &&
			!option.existingNewNumber && !option.existingNewPortin) {
			displayFlag = false;
		} else if (option.maxAllowedItems) {
			var homeLineDeliveryRequired = self.get('orderFullfilment.billingDetails.homeLineDeliveryRequired');
			if (homeLineDeliveryRequired && option.maxAllowedItems < (cartPurchaseDetails.itemsInCart + 1)) {
				displayFlag = false;
			} else if (option.maxAllowedItems < cartPurchaseDetails.itemsInCart) {
				displayFlag = false;
			}
		} else if (isBackOrderDevice && !option.isApplicableForBackorder) {
			displayFlag = false;
		}
		return displayFlag;
	},

	doCheckCartValues: function (param1, param2) {
		if ((param1 && !param2) ||	(!param1 && !param2) || (!param1 && param2)) {
			return true;
		}
	},

	handleCloseModal: function () {
		var modals = this.findAllComponents('ux-modal');
		modals.forEach(function (component) {
			component.set('displayState', false);
		});
		this.set('toConfirmNewAddress', false);
	},
	setModalDisplayState: function (modalId, state) {

		var modals = this.findAllComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId[0] === component.get('modalId') || modalId ===  component.get('modalId');
		})[0];

		modal.set('displayState', state);
	},
	resetToDefaultValues: function () {
		this.set('disableDeliveryConfirmButton', true);
		this.set('toConfirmNewAddress', false);
		this.set('addressRetrieve', null);
		this.set('addressList', null);
	},
	checkIfAllDataSelected: function () {
		var details = this.get(),
			selectedOption = details.selectedOption,
			selectedDetails = details.selectedDetails,
			selectedDeliveryAddress = this.parent.get('selectedDeliveryAddress'),
			newDeliveryAddress = this.parent.get('createDeliveryAddress'),
			collectionAddress = this.parent.get('deviceIdAndPlanId.collectionAddress'),
			collectionAddressType = this.parent.get('deviceIdAndPlanId.collectionAddressType'),
			popStationAddress = this.parent.get('selfCollectionTimeSlot.selfCollection.selectedStore'),
			selectedLocker = this.parent.get('selfCollectNowTopic.selfCollectNowInputInfo.selectedLocker'),
			isInstallationRequired = this.get('orderFullfilment.deliveryDetails.installationRequired'),
			cartPurchaseDetails = this.get('orderFullfilment.cartPurchaseDetails'),
			documentNeeded = this.get('documentNeeded') && !RactiveHelpers.isIppPlan(),
			flag = this.get('isInstallationSelected'),
			skipOrderConsolidate = this.get('skipOrderConsolidate'),
			orderConsolidateInput = this.parent.get('orderConsolidateInput'),
			quonomyAptSelected = this.get('quonomyAptSelected'),
			furtherProcessing = true,
			singetlShopAddress = this.parent.get('singtelShopEAppointmentTopic.selectedStoreDetails.selectedStore'),
			allDeliveryOptions =
				['courier', 'sms-mail', 'pop-station', 'singtel-pop-station', 'collect-now'],
			needsOnlyMBBDelivery = this.get('orderFullfilment.billingDetails.needsOnlyMBBDelivery'),
			contactUpdateNeeded = this.get('contactUpdateNeeded'),
			onepassInfo = this.get('onepassInfo'),
			residentialPhotoUpload = this.get('addressUploadedDocuments');
		if (sessionStorage.getItem('isMyInfoVerified') && onepassInfo && !onepassInfo.newcustomer) {
			documentNeeded = false;
		} else {
			documentNeeded = this.get('documentNeeded') && !RactiveHelpers.isIppPlan();
		}
		console.log('collectionAddress', collectionAddress);
		console.log('collectionAddressType', collectionAddressType);
		if (documentNeeded) {
			var uploadedDocuments = this.get('documentPhotoUploadedDocuments');
			if (typeof uploadedDocuments === 'undefined' || uploadedDocuments === null ||
					uploadedDocuments.length  === 0) {
				this.fire('disbaleOrderSummaryButton');
				furtherProcessing = false;
				this.set('isDocumentUploadValid', false);
			} else {
				var livePhotoUploadedDocuments = this.get('livePhotoUploadedDocuments');
				if (this.isLivePhotoUploadNeeded()) {
					if (livePhotoUploadedDocuments && livePhotoUploadedDocuments.length > 0) {
						this.set('isDocumentUploadValid', true);
					} else {
						this.set('isDocumentUploadValid', false);
					}
				} else {
					this.set('isDocumentUploadValid', true);
				}
				if (onepassInfo && onepassInfo.newcustomer &&
					onepassInfo.customerIdType !== 'National Registration ID Card (NRIC)' &&
					residentialPhotoUpload && residentialPhotoUpload.length === 0) {
					this.set('isDocumentUploadValid', false);
				}
			}
		}
		if (details.membershipCard) {
			var uploadedDocuments = details.membershipCardUploadedDocuments;
			if (typeof uploadedDocuments === 'undefined' || uploadedDocuments === null ||
					uploadedDocuments.length  === 0 ||
					(details.membershipCard.isMaskInfoRequired && !details.membershipCard.isMaskChecked)) {
				this.fire('disbaleOrderSummaryButton');
				this.set('isDocumentUploadValid', false);
				furtherProcessing = false;
			} else {
				var livePhotoUploadedDocuments = this.get('livePhotoUploadedDocuments');
				if (this.isLivePhotoUploadNeeded()) {
					if (livePhotoUploadedDocuments && livePhotoUploadedDocuments.length > 0) {
						this.set('isDocumentUploadValid', true);
					} else {
						this.set('isDocumentUploadValid', false);
					}
				} else {
					this.set('isDocumentUploadValid', true);
				}
				if (onepassInfo && onepassInfo.newcustomer &&
					onepassInfo.customerIdType !== 'National Registration ID Card (NRIC)' &&
					residentialPhotoUpload && residentialPhotoUpload.length === 0) {
					this.set('isDocumentUploadValid', false);
				}
			}
		}
		if (furtherProcessing) {
			var stationOptionsList = ['pop-station', 'singtel-pop-station'],
				calendarOptionsList =
				['courier', 'pop-station', 'singtel-pop-station', 'collect-now'],
				otherOptionsList =
					['sms-mail', 'pop-station', 'singtel-pop-station', 'collect-now'];
			if (_.contains(allDeliveryOptions, selectedOption)) {
				var isPopStation = (selectedOption === 'pop-station' && popStationAddress &&
						popStationAddress.KioskId) ? true : false,
					isCollectNow = (selectedOption === 'collect-now' && selectedLocker &&
						selectedLocker.KioskId) ? true : false,
					isDeliveryAddSelected = needsOnlyMBBDelivery ? true : ((selectedDeliveryAddress &&
						(selectedDeliveryAddress.postcode || selectedDeliveryAddress.postCode)) ?
						true : false),
					isNewAdd = (newDeliveryAddress && newDeliveryAddress.postCode) ? true : false;
				if (isDeliveryAddSelected || isNewAdd || isPopStation || isCollectNow) {
					if (isInstallationRequired) {
						if (flag) {
							if (selectedOption === 'sms-mail' || selectedOption === 'collect-now' ||
								((_.contains(stationOptionsList, selectedOption)) &&
									selectedDetails && selectedDetails.selectedTime && selectedDetails.selectedDate)) {
								if (documentNeeded) {
									var uploadedDocuments = this.get('livePhotoUploadedDocuments');
									this.set('nextButtonDisabled', '');
									if (uploadedDocuments && uploadedDocuments.length > 0) {
										if (onepassInfo && onepassInfo.newcustomer &&
											onepassInfo.customerIdType !== 'National Registration ID Card (NRIC)' &&
											residentialPhotoUpload && residentialPhotoUpload.length === 0) {
											this.fire('disbaleOrderSummaryButton');
										} else {
											this.set('showDocumentUploadFlag', true);
											this.set('isDocumentUploadValid', true);
											this.fire('enableOrderSummaryButton');
										}
									} else if (cartPurchaseDetails &&
										(cartPurchaseDetails.newNewNumber ||
										cartPurchaseDetails.existingNewNumber ||
										cartPurchaseDetails.newNewPortin ||
										cartPurchaseDetails.existingNewPortin)) {
										this.fire('disbaleOrderSummaryButton');
									} else {
										this.fire('enableOrderSummaryButton');
									}
								} else {
									this.fire('enableOrderSummaryButton');
								}
							} else {
								this.fire('enableOrderSummaryButton');
							}
						} else {
							return true;
						}
					}
					if (_.contains(calendarOptionsList, selectedOption)) {
						if ((selectedDetails && selectedDetails.selectedTime &&  selectedDetails.selectedDate) ||
							selectedOption === 'collect-now') {
							if (_.contains(otherOptionsList, selectedOption)) {
								if (documentNeeded) {
									var uploadedDocuments = this.get('livePhotoUploadedDocuments');
									this.set('nextButtonDisabled', '');
									if (uploadedDocuments && uploadedDocuments.length > 0) {
										if (onepassInfo && onepassInfo.newcustomer &&
											onepassInfo.customerIdType !== 'National Registration ID Card (NRIC)' &&
											residentialPhotoUpload && residentialPhotoUpload.length === 0) {
											this.fire('disbaleOrderSummaryButton');
										} else {
											this.set('showDocumentUploadFlag', true);
											this.set('isDocumentUploadValid', true);
											this.fire('enableOrderSummaryButton');
										}
									} else if (cartPurchaseDetails &&
										(cartPurchaseDetails.newNewNumber ||
										cartPurchaseDetails.existingNewNumber ||
										cartPurchaseDetails.newNewPortin ||
										cartPurchaseDetails.existingNewPortin)) {
										this.fire('disbaleOrderSummaryButton');
									} else {
										this.fire('enableOrderSummaryButton');
									}
								} else {
									this.fire('enableOrderSummaryButton');
								}
							} else {
								this.fire('enableOrderSummaryButton');
							}
						}
					} else {
						if (_.contains(otherOptionsList, selectedOption)) {
							if (documentNeeded) {
								var uploadedDocuments = this.get('livePhotoUploadedDocuments');
								this.set('nextButtonDisabled', '');
								if (uploadedDocuments && uploadedDocuments.length > 0) {
									if (onepassInfo && onepassInfo.newcustomer &&
										onepassInfo.customerIdType !== 'National Registration ID Card (NRIC)' &&
										residentialPhotoUpload && residentialPhotoUpload.length === 0) {
										this.fire('disbaleOrderSummaryButton');
									} else {
										this.set('showDocumentUploadFlag', true);
										this.set('isDocumentUploadValid', true);
										this.fire('enableOrderSummaryButton');
									}
								} else if (cartPurchaseDetails &&
									(cartPurchaseDetails.newNewNumber ||
									cartPurchaseDetails.existingNewNumber ||
									cartPurchaseDetails.newNewPortin ||
									cartPurchaseDetails.existingNewPortin)) {
									this.fire('disbaleOrderSummaryButton');
								} else {
									this.fire('enableOrderSummaryButton');
								}
							} else {
								this.fire('enableOrderSummaryButton');
							}
						} else {
							this.fire('enableOrderSummaryButton');
						}
					}
				}
			} else if (this.get('eAppointmentCrOn') && selectedOption === 'singtel-store' &&
				singetlShopAddress && singetlShopAddress.mtposId &&
				(selectedDetails && selectedDetails.selectedTime &&  selectedDetails.selectedDate)) {
				if (isInstallationRequired) {
					if (flag) {
						this.fire('enableOrderSummaryButton');
					}
				} else {
					this.fire('enableOrderSummaryButton');
				}
			} else if (selectedOption === 'singtel-store' && quonomyAptSelected && quonomyAptSelected.appointmentID) {
				if (isInstallationRequired) {
					if (flag) {
						this.fire('enableOrderSummaryButton');
					}
				} else {
					this.fire('enableOrderSummaryButton');
				}
			} else if (skipOrderConsolidate === false && orderConsolidateInput && orderConsolidateInput.deliveryTime &&
				orderConsolidateInput.deliveryDate && orderConsolidateInput.deliverySlotCode) {
				if (isInstallationRequired) {
					if (flag) {
						this.fire('enableOrderSummaryButton');
					}
				} else {
					this.fire('enableOrderSummaryButton');
				}
			} else if (isInstallationRequired && flag) {
				var hasPurchasedMobile = this.get('hasPurchasedMobile');
				if (hasPurchasedMobile === false) {
					this.fire('enableOrderSummaryButton');
				}
			} else if (contactUpdateNeeded) {
				if ('isContactDetailsValid') {
					this.fire('enableOrderSummaryButton');
				} else {
					this.fire('disbaleOrderSummaryButton');
				}
			} else {
				var hasPurchasedMobile = this.get('hasPurchasedMobile');
				var isInstallationRequired = this.get('isInstallationRequired') ||
				this.get('orderFullfilment.deliveryDetails.installationRequired');
				if (hasPurchasedMobile === false && isInstallationRequired === false) {
					this.fire('enableOrderSummaryButton');
				} else {
					this.fire('disbaleOrderSummaryButton');
				}
			}
		}
	},
	isLivePhotoUploadNeeded: function () {
		var orderFullfilment = this.get('orderFullfilment');
		var possibleDeliveryOptions = [
			'pop-station',
			'singtel-pop-station',
			'sms-mail',
			'collect-now'
		];
		var selectedOption = this.get('selectedOption');
		var isSelectedOptionValid = _.contains(possibleDeliveryOptions, selectedOption);
		var isValidScenario = orderFullfilment.cartPurchaseDetails &&
			(orderFullfilment.cartPurchaseDetails.newNewNumber ||
				orderFullfilment.cartPurchaseDetails.existingNewNumber ||
				orderFullfilment.cartPurchaseDetails.newNewPortin ||
				orderFullfilment.cartPurchaseDetails.existingNewPortin);
		return isSelectedOptionValid && isValidScenario;
	},
	monoAddrSelector: function () {
		var self = this;
		var selectedOption = self.get('selectedOption');
		var newValue = self.get('isDeliveryModeSelected');
		var newAddressAdded = self.get('newAddressAdded');
		var hasDefaultDeliveryAdd = self.get('hasDefaultDeliveryAdd');
		if (newValue && selectedOption === 'courier') {
			var deliveryDetails = self.get('orderFullfilment.deliveryDetails');
			var selectedBillAdd = self.get('selectedBillAdd');
			var addresses = {
				count: 0,
				fieldPopulated: ''
			};
			if (hasDefaultDeliveryAdd && selectedBillAdd) {
				addresses.count += 1;
				if (addresses.count === 1) {
					addresses.fieldPopulated = 'delivery-new-address';
				}
			}
			if (deliveryDetails && deliveryDetails.contactAddress && addresses.count < 2) {
				addresses.count += 1;
				if (addresses.count === 1) {
					addresses.fieldPopulated = 'delivery-contact-address';
				}
			}
			if (deliveryDetails && deliveryDetails.deliveryAddress &&
				deliveryDetails.addressDeliveryMethod !== 'Courier To Home (PoPStation)' &&
				deliveryDetails.addressDeliveryMethod !== 'Collect Now' &&
				addresses.count < 2) {
				addresses.count += 1;
				if (addresses.count === 1) {
					addresses.fieldPopulated = 'delivery-new-address';
				}
			}
			if (deliveryDetails && (deliveryDetails.billPayer === '1' ||
				deliveryDetails.billPayer === 1) && deliveryDetails.billingAddress && addresses.count < 2) {
				addresses.count += deliveryDetails.billingAddress.length;
				if (addresses.count === 1) {
					addresses.fieldPopulated = 'delivery-account-0';
				}
			}
			if (deliveryDetails && deliveryDetails.installationAddress &&
				deliveryDetails.installationAddress.postcode && addresses.count < 2) {
				addresses.count += 1;
				if (addresses.count === 1) {
					addresses.fieldPopulated = 'delivery-installation-address';
				}
			}
			if (newAddressAdded && newAddressAdded.length > 0 && addresses.count < 2) {
				addresses.count += newAddressAdded.length;
				if (addresses.count === 1) {
					addresses.fieldPopulated = 'newDeliveryAccount-0';
				}
			}
			if (addresses.count === 1) {
				setTimeout(function () {
					var defaultAddress = document.getElementById(addresses.fieldPopulated);
					while (!defaultAddress) {
						defaultAddress = document.getElementById(addresses.fieldPopulated);
					}
					defaultAddress.click();
				}, 0);
			} else if (!hasDefaultDeliveryAdd && this.get('isEkycDefaultAddressSet') &&
				newAddressAdded && newAddressAdded.length > 0 &&
				!this.get('autoSelectDidRunOnce')) {
				this.selectEkycAddress(newAddressAdded[newAddressAdded.length - 1]);
			} else {
				setTimeout(function () {
					var allRadios = document.getElementsByName('select-account');
					_.each(allRadios, function (v) {
						v.checked = false;
					});
				}, 0);
			}
		} else if (!hasDefaultDeliveryAdd && (selectedOption === 'sms-mail') &&
			this.get('isEkycDefaultAddressSet') && newAddressAdded && newAddressAdded.length > 0 &&
			!this.get('autoSelectDidRunOnce')) {
			this.selectEkycAddress(newAddressAdded[newAddressAdded.length - 1]);
		}
	},
	selectEkycAddress: function (address) {
		this.onSelectDeliveryAddress(address);
		document.getElementsByClassName('ux-delivery-installation')[0].
			scrollIntoView({behavior: 'smooth'});
		this.resetScrollHeight();
		var selectedOption = this.get('selectedOption');
		if (selectedOption === 'sms-mail') {
			this.set('isDeliverySelected', true);
		}
		this.set('autoSelectDidRunOnce', true);
	},
	resetDeliveryDetails: function () {
		this.fire('disbaleOrderSummaryButton');
		this.parent.set('selectedDeliveryAddress', null);
		this.parent.set('createDeliveryAddress', null);
		this.set('selectedDetails', null);
		this.set('isDeliverySelected', false);
		this.set('isDeliveryModeSelected', false);
		this.set('dateTimeShow', false);
		this.parent.set('orderFullfilment.popStations', []);
		this.parent.set('selfCollectNowTopic.selfCollectNowStoresList', []);
		this.set('popStations', []);
		this.set('selfCollectNowStoresList', []);
		this.parent.set('orderFullfilment.singtelStoreList', []);
		this.set('singtelStores', []);
		this.set('isCollectNow', false);
		this.parent.set('selectedOption', '');
		this.set('deliveryModesList', []);
		this.set('selectedOption', '');
		this.set('selectedAptDetails', null);
	},
	resetScrollHeight: function () {
		var headerEl = document.getElementsByClassName('ux-header-singtel');
		if (headerEl && headerEl.length > 0) {
			headerEl = headerEl[0];
			document.querySelector('html body').scrollTop -= headerEl.offsetHeight;
		}
	},
	getSelectedDeliveryAddress: function () {
		var value = this.get('orderFullfilment.deliveryDetails.deliveryAddress');
		if (value) {
			this.onSelectDeliveryAddress(value);
		}
	},
	showCalendar: function () {
		var timeslots = this.get('timeslots');
		var appointmentSlots = this.get('appointmentSlots');
		if (timeslots && timeslots.length > 0 && appointmentSlots) {
			this.set('dateTimeShow', true);
			var component = this.findComponent('ux-date-time-picker');
			if (component) {
				var enabledDays = this.get('enabledDays');
				component.set('minDate', enabledDays[0]);
				component.initCalendar();
			}
			setTimeout(function () {
				var component = document.getElementsByClassName('ux-date-time-picker');
				while (!component) {
					component = document.getElementsByClassName('ux-date-time-picker');
				}
				if (component && component.length === 1) {
					var timeSlots = component[0].getElementsByTagName('input');
					var timeSlot = _.find(timeSlots, function (slot) {
						return !_.contains(slot.parentElement.classList, 'disabled');
					});
					if (timeSlot) {
						timeSlot.click();
					}
				}
			}, 0);
		}
	},
	resetCalendarDates: function (id) {
		var appointmentSlots = _.clone(this.get('appointmentSlotsNew'));
		var todayDate = moment(new Date()).format('YYYY-MM-DD');
		var enabledDaysNew = this.get('enabledDaysNew');
		var enabledDays;
		if (id === 'standard') {
			if (appointmentSlots && appointmentSlots[todayDate]) {
				delete appointmentSlots[todayDate];
			}
			if (enabledDaysNew && enabledDaysNew.length > 0) {
				enabledDays = _.filter(enabledDaysNew, function (date) {
					return date !== todayDate;
				});
			}
		} else if (id === 'sameDay') {
			for (var key in appointmentSlots) {
				if (key !== todayDate) {
					delete appointmentSlots[key];
				}
			}
			if (enabledDays && enabledDays.length > 0) {
				enabledDays = _.filter(enabledDaysNew, function (date) {
					return date === todayDate;
				});
			}
		}
		this.set('appointmentSlots', appointmentSlots);
		this.set('enabledDays', enabledDays);
		var defaultDate = (enabledDays && enabledDays.length > 0) ? enabledDays[0] : undefined;
		this.set('defaultDate', defaultDate);
		var value = this.get('orderFullfilment.deliveryDetails.deliveryAddress');
		var disableCalendar = this.get('disableCalendar');
		if (value && disableCalendar !== true) {
			this.set('dateTimeShow', true);
			setTimeout(function () {
				var component = document.getElementsByClassName('ux-date-time-picker');
				while (component && component.length === 0) {
					component = document.getElementsByClassName('ux-date-time-picker');
				}
				if (component && component.length === 1) {
					var timeSlots = component[0].getElementsByTagName('input');
					var timeSlot = _.find(timeSlots, function (slot) {
						return !_.contains(slot.parentElement.classList, 'disabled');
					});
					if (timeSlot) {
						timeSlot.click();
					}
				}
			}, 0);
		}
		this.set('disableCalendar', false);
		var dateComp = this.findAllComponents('ux-date-time-picker');
		if (dateComp && dateComp.length > 0) {
			dateComp = dateComp[0];
			dateComp.set('enabledDays', enabledDays);
			dateComp.set('defaultDate', enabledDays[0]);
			dateComp.initCalendar();
		}
	},
	populateDeliveryMode: function (appointmentSlots) {
		var todayDate = moment(new Date()).format('YYYY-MM-DD');
		var flag = false;
		if (appointmentSlots && appointmentSlots[todayDate]) {
			flag = true;
		}
		var options = this.get('deliveryModesList');
		_.each(options, function (item) {
			if (item.deliveryId === 'sameDay') {
				item.displayFlag = flag;
			}
		});
		this.set('deliveryModesList', options);
	
		if (options.length === 1) {
			this.selectDeliveryOption(options[0]);
		}
		this.set('isDeliveryModeSelected', true);
	
	},

	validateAddress: function (address, addressType) {
		var isValidAddress = false;
		var components = this.findAllComponents('ux-address-form-new');
		var component = _.find(components, function (component) {
			if (component.get('addressType') === addressType) {
				return true;
			}
		});
		component.set('errorMessage', false);
		if (address && address.postCode && address.blockOrHouseNum) {
			isValidAddress = component.validateFloorAndUnitNumber();
		} else {
			component.set('errorMessage', this.get('initData.errorMessages.addressMissing'));
		}
		return isValidAddress;
	},

	onNextClick: function (isProceedToSummaryScenario) {
		var isNewAdd = this.parent.get('newAddressForm'),
			isValid = (isNewAdd === 'delivery' ? false : true);
		if (isNewAdd === 'delivery') {
			isValid = this.validateAddress(this.get('addressRetrieve.address'), 'sdpRetrieveAddress');
			if (isValid) {
				var address = this.get('addressRetrieve.address');
				address.state = ConfigStrings.physicalAddressValues.state;
				address.country = ConfigStrings.physicalAddressValues.country;
				address.city = ConfigStrings.physicalAddressValues.city;
				this.parent.set('createDeliveryAddress', address);
			}
		}
		if (isValid) {
			this.checkIfAllDataSelected();
			var buttonDisabled = this.get('buttonDisabled');
			if (isProceedToSummaryScenario && buttonDisabled !== 'disabled') {
				this.fire('continueWithSummary');
			} else {
				Ractive.defaults.fire('ux-singtel-breadcrumbs.goto-next-step');
			}
		}
	},

	getQnomyConfigBySku: function (selectedStore) {
		var skuAppointments = this.get('initData.skufilterAppointment');
		var qnomyConfig = null;
		_.each(skuAppointments, function (skuAppointment) {
			if (skuAppointment.storeID === selectedStore.id) {
				var devices = this.get('deviceIdAndPlanId.deviceResDetails');
				if (_.isNull(devices)) {
					devices = this.get('selectedDevicesSkuIds');
				}
				_.each(devices, function (device) {
					var deviceSku = device.itemCodeX9 || device;
					if (deviceSku && skuAppointment.sku.split(',').indexOf(deviceSku) !== -1) {
						qnomyConfig = skuAppointment;
					}
				});
			}
		}.bind(this));
		return qnomyConfig;
	},
	mergeDeliveryOption: function (configuredOption, deliveryGroupOptions) {
		_.each(configuredOption, function (item) {
			var groupData = _.find(deliveryGroupOptions, function (data) {
				return data.groupId === item.groupId;
			});
			if (groupData) {
				item.groupHeader = groupData.groupHeader;
				item.groupTitle = groupData.groupTitle;
				item.groupPrice = groupData.price;
				item.groupNote = groupData.notes;
				item.groupRibbon = groupData.groupRibbon;
			}
		});
		return configuredOption;
	},
	getDeliveryModesList: function (deliveryOptions, id) {
		var deliveryModesList = _.filter(deliveryOptions, function (item) {
			return item.id === id && item.displayFlag;
		});
		this.set('deliveryModesList', deliveryModesList);
		var filteredDeliveryModesList = _.reject(deliveryModesList, function (mode) {
			return mode.id === 'singtel-pop-station' ||
			mode.deliveryId === 'singtel-pop-station';
		});
		this.set('filteredDeliveryModesList', filteredDeliveryModesList);
		return deliveryModesList;
	},
	getEligibleGroups: function (options) {
		var prorityList = ConfigStrings.deliveryGroupPriority;
		var validOptions = _.filter(options, function (obj, pos, arr) {
			return _.map(arr, function (mapObj) {
				return mapObj.groupId;
			}).indexOf(obj.groupId) === pos;
		});
		if (validOptions.length > 0) {
			_.each(validOptions, function (obj) {
				var matchedId = _.find(prorityList, function (item) {
					return item.groupId === obj.groupId;
				});
				obj.index = matchedId.index;
			});
			return _.sortBy(validOptions, 'index');
		} else {
			return validOptions;
		}
	},
	findStoreOnlyDevice: function () {
		var aemDevices = this.get('aemDevices');
		var storeOnlyDevice = _.find(aemDevices, function (device) {
			return device.tags.indexOf(this.get('storeOnlyTag')) !== -1;
		}.bind(this));
		return storeOnlyDevice;
	},

	isRedemptionPageEnabled: function () {
		var self = this;
		var redemptionEnabled = false;
		var isPremiumProduct = this.get('isPremiumProduct');
		var isRedemptionRequired = this.get('isRedemptionRequired');

		if (isRedemptionRequired && !isPremiumProduct) {
			if (self.get('isInstallationOrDeliveryRequired')) {
				redemptionEnabled = false;
			} else {
				redemptionEnabled = true;
			}
		}
		if (isRedemptionRequired && isPremiumProduct) {
			redemptionEnabled = true;
		}
		return redemptionEnabled;
	},

	showFulfilmentContextualMessage: function () {
		var brandLeadDays = this.get('initData.brandLeadDays');
		var isBackOrder = this.get('deviceIdAndPlanId.isBackOrder');
		var aemDevices = this.get('aemDevices');
		var selectedDeviceSku = aemDevices && aemDevices[0].sku;
		var fulfilmentContextualMessage = null;

	
		if (isBackOrder && brandLeadDays && selectedDeviceSku) {
			for (var i = 0; i < brandLeadDays.length; i++) {
				var brandLeadDay = brandLeadDays[i];
				var handsetSkusArr = brandLeadDay.handsetBrands && brandLeadDay.handsetBrands.split(',');
				if (handsetSkusArr && handsetSkusArr.includes(selectedDeviceSku)) {
					fulfilmentContextualMessage = {
						header: brandLeadDay.fulfillmentLinerHeader,
						description: brandLeadDay.backOrderFulfillmentText
					};
					break;
				}
			}
		}
		this.set('fulfilmentContextualMessage', fulfilmentContextualMessage);
	}

});

Ractive.components["ux-disclaimer-text"] = Ractive.extend({
	template: LUXComponentTemplates['ux-disclaimer-text']
});

Ractive.components["ux-display-campaign"] = Ractive.extend({
	template: LUXComponentTemplates['ux-display-campaign'],
	isolated: true,
	data: {
		noOfTokenRetries: 0
	},
	redirectErrorPage: function () {
		var self = this;
		const errorUrl = self.get('errorPageUrl');
		sessionStorage.removeItem('form-campaignId');
		if (errorUrl) {
			window.location.href = errorUrl;
		}
	},
	getToken: function (callback) {
		var self = this;
		const accessToken = sessionStorage.getItem('apigee_token');
		if (accessToken) {
			callback(accessToken);
			return;
		}

		$.ajax({
			url: self.get('tokenApi'),
			type: 'POST',
			data: { grant_type: 'client_credentials' },
			contentType: 'application/x-www-form-urlencoded',
			headers: { 'x-client-id': 'SPRINGD' },
			success: function (response, status) {
				sessionStorage.setItem(
					'apigee_token',
					'Bearer ' + response.access_token
				);
				if (typeof callback === 'function') {
					callback('Bearer ' + response.access_token);
				}
			},
			error: function (xhr, status, error) {
				self.redirectErrorPage();
			}
		});
	},
	retrieveCampaignSuccess: function (details) {
		var self = this;
		self.set({
			noOfTokenRetries: 0,
			loading: false,
			campaignDetails: {
				description: details.description,
				title: details.title
			},
			banner: {
				backgroundImage: {
					desktop: {
						alt: self.get('defaultBackgroundImage.desktop.alt'),
						src:
							details.desktopBannerImgUrl ||
							self.get('defaultBackgroundImage.desktop.src')
					},
					mobile: {
						alt: self.get('defaultBackgroundImage.mobile.alt'),
						src:
							details.mobileBannerImgUrl ||
							self.get('defaultBackgroundImage.mobile.src')
					}
				}
			}
		});
		const myEvent = new CustomEvent('ekyc-button-display', {
			detail: { type: 'toggle-display', value: false },
			bubbles: true
		});
		window.dispatchEvent(myEvent);
	},
	getCampaignDetails: function () {
		var self = this;
		self.set('loading', true);

		self.getToken(function (token) {
			self.fetchCampaignData(token);
		});
	},
	fetchCampaignData: function (token) {
		var self = this;
		$.ajax({
			url: self.get('campaignApi') + '/' + self.get('queryKeyValue'),
			type: 'GET',
			contentType: 'application/json',
			headers: {
				Authorization: token
			},
			success: function (res) {
				if (res && res.body && res.body.status === 'OK') {
					self.retrieveCampaignSuccess(res.body.result);
				} else {
					self.redirectErrorPage();
				}
			},
			error: function (xhr, status, error) {
				if (xhr.status === 401 && self.get('noOfTokenRetries') < 3) {
					sessionStorage.removeItem('apigee_token');
					self.set('noOfTokenRetries', self.get('noOfTokenRetries') + 1);
					self.getCampaignDetails();
				} else {
					self.redirectErrorPage();
				}
			}
		});
	},
	onrender: function () {
		var self = this;
		const queryKey = self.get('queryKey') || 'campaignId';
		const queryKeyValue = RactiveHelpers.getQueryParamsObj(queryKey);

		if (!queryKeyValue && !RactiveHelpers.isAuthoringMode()) {
			self.redirectErrorPage();
			return;
		}

		if (queryKeyValue) {
			self.set('queryKeyValue', queryKeyValue);
			self.set('noOfTokenRetries', 0);
			sessionStorage.setItem(
				'form-campaignId',
				JSON.stringify({ key: queryKey, value: queryKeyValue })
			);
			self.getCampaignDetails();
		}
	}
});

Ractive.components["ux-document-upload"] = Ractive.extend({
	template: LUXComponentTemplates['ux-document-upload'],

	isolated: true,
	oninit: function (argument) {
		this.documents = [];
		this.set('progressBarWidth', 0);
		this.set('disableUpload', '');
		this.set('disableUploadAddress', '');
		this.set('displayErrorMessage', false);
	},

	onrender: function (argument) {
		var self = this;
		self.on('showTooltip', function (event) {
			if (event.original.currentTarget.nextElementSibling.style.display !== 'block') {
				_.each(document.getElementsByClassName('tooltip'), function (v) {
					v.style.display = 'none';
				});
				event.original.currentTarget.nextElementSibling.style.display = 'block';
			} else {
				event.original.currentTarget.nextElementSibling.style.display = 'none';
			}
			return false;
		});
		self.on('*.gotoPreviousStep', function () {
			Ractive.defaults.fire('ux-singtel-breadcrumbs.goto-prev-step');
		});

		self.on('*.doSubmit', function (event) {
			var uploadedDocuments = self.get('uploadedDocuments');
			if (uploadedDocuments && uploadedDocuments.length > 0) {
				self.fire('nextClicked', self.get());
			} else {
				self.set('displayErrorMessage', true);
			}
		});

		$('#uploadFilelivePhoto').change(function (event) {
			self.fire('fileToUpload', {
				file: event.target.files[0],
				type: 'livePhoto'
			});
			$('#uploadFilelivePhoto')[0].value = '';
		});

		$('#uploadFiledocumentPhoto').change(function (event) {
			self.fire('fileToUpload', {
				file: event.target.files[0],
				type: 'documentPhoto'
			});
			$('#uploadFiledocumentPhoto')[0].value = '';
		});
		$('#uploadFileresidentialAddressPhoto').change(function (event) {
			self.fire('fileToUpload', {
				file: event.target.files[0],
				type: 'residentialAddressPhoto'
			});
			$('#uploadFileresidentialAddressPhoto')[0].value = '';
		});
		self.on('*.showUploadedImage', function (evt, documentId) {
			evt.event.original.preventDefault();
			self.fire('displayUploadedImage', {
				documentId: documentId,
				type: self.get('type')
			});
		});

		self.parent.on('closeUpload', function (evt) {
			var type = self.get('type');
			if (type === evt) {
				self.set('disabled', '');
				self.set('disableUpload', 'disabled');
			}
		});

		self.parent.on('onUpload', function (evt) {
			self.set('disabled', 'disabled');
			self.set('disableUpload', '');
		});

		self.parent.on('onUploadAndNext', function (evt) {
			var type = self.get('type');
			if (type === evt) {
				self.set('disabled', '');
				self.set('disableUpload', '');
			}
		});

		self.on('ux-anchor.removeUploadedImage', function (evt, documentId) {
			evt.event.original.preventDefault();
			self.fire('removeUploadedImageFromPage', {
				documentId: documentId,
				type: self.get('type')
			});
		});

		self.on('ux-anchor.doOpenModal', function (evt, modalId) {
			self.updateModalState(modalId, true);
		});
		$('#uploadFileAddresslivePhoto').change(function (event) {
			self.fire('fileToUpload', {
				file: event.target.files[0],
				type: 'livePhotoAddress'
			});
			$('#uploadFileAddresslivePhoto')[0].value = '';
		});
		$('#uploadFileAddressdocumentPhoto').change(function (event) {
			self.fire('fileToUpload', {
				file: event.target.files[0],
				type: 'documentPhotoAddress'
			});
			$('#uploadFileAddressdocumentPhoto')[0].value = '';
		});
		self.on('*.showUploadedImageAddress', function (evt, documentID) {
			evt.event.original.preventDefault();
			self.fire('displayUploadedImage', {
				documentID: documentID,
				type: self.get('type')
			});
		});
		self.on('ux-anchor.removeUploadedImageAddress', function (evt, documentID) {
			evt.event.original.preventDefault();
			self.fire('removeUploadedImageFromPage', {
				documentID: documentID,
				type: self.get('type')
			});
		});
		self.parent.on('closeUploadAddress', function (evt) {
			var type = self.get('type');
			if (type === evt) {
				self.set('disabled', '');
				self.set('disableUploadAddress', 'disabled');
			}
		});
		self.parent.on('onUploadAddress', function (evt) {
			self.set('disabled', 'disabled');
			self.set('disableUploadAddress', '');
		});
		self.parent.on('onUploadAndNextAddress', function (evt) {
			var type = self.get('type');
			if (type === evt) {
				self.set('disabled', '');
				self.set('disableUploadAddress', '');
			}
		});
	},

	updateModalState: function (modalId, state, hideModal) {

		var modals = this.findAllComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];

		if (hideModal) {
			modal.set('avoidCss', true);
		}
		modal.set('displayState', state);
	}

});

Ractive.components["ux-donut-loader"] = Ractive.extend({
	template: LUXComponentTemplates['ux-donut-loader'],

	onrender: function () {
		this.drawChart();
		this.observe('graph_data', function (newData, oldData, event) {
			if (newData !== undefined) {
				this.updateChart();
			}
		});
	},

	data: function () {
		return {
			getBottomLabelSize: function () {
				if (this.get('text.bottom_label_style') === 'heavy') {
					return 'large';
				} else {
					return 'small';
				}
			}
		};
	},

	getMappedData: function () {
	
		var componentData = this.get('graph_data'),
			dataSet = [],
			colourSet = [],
			labels = [];

		if (componentData) {
			for (var i = 0; i < componentData.length; i++) {
				var obj = componentData[i];
				dataSet.push(obj.value);
				colourSet.push(obj.colour);
				labels.push(obj.label);
			}
		}

	
		this.dataset = dataSet;
		this.colours = colourSet;
		this.labels = labels;
	},

	drawChart: function () {
		this.getMappedData();
		var colors = this.colours;

				var width = 100,//960,
			height = 100,//500,
			radius = Math.min(width, height) / 2;

		this.pie = d3.layout.pie()
			.padAngle(0.025)
			.sort(null);

		this.arc = d3.svg.arc()
			.innerRadius(47)//100)
			.outerRadius(50);//20);

		var svg = d3.select(this.find('svg'))
			.attr('width', width)
			.attr('height', height)
			.append('g')
			.attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
		console.log(radius);

		this.path = svg.selectAll('path')
			.data(function () {
				return this.pie(this.dataset);
			}.bind(this))
			.enter().append('path')
			.attr('fill', function (d, i) {
				return colors[i];
			}.bind(this))
			.attr('d', this.arc)
			.each(function (d) {
				this._current = d;
			});
	},
	updateChart: function () {
		this.getMappedData();
		var enterAntiClockwise = {
			startAngle: Math.PI * 2,
			endAngle: Math.PI * 2
		};

		var colors = this.colours;



		this.path = this.path.data(this.pie(this.dataset));
	
	
		this.path.enter().append('path')
				.attr('fill', function (d, i) {
					return colors[i];
				})
				.attr('d', this.arc(enterAntiClockwise))
				.each(function (d) {
					this._current = {
						data: d.data,
						value: d.value,
						startAngle: enterAntiClockwise.startAngle,
						endAngle: enterAntiClockwise.endAngle
					};
				});

		var arc = this.arc;

		this.path.exit()
				.transition()
				.duration(750)
				.attrTween('d', function (a) {
					var i = d3.interpolate(this._current, {startAngle: Math.PI * 2, endAngle: Math.PI * 2, value: 0});
					this._current = i(0);
					return function (t) {
						return arc(i(t));
					};
				})
				.remove();

		this.path.transition().duration(750).attrTween('d', function (a) {
				var i = d3.interpolate(this._current, a);
				this._current = i(0);
				return function (t) {
					return arc(i(t));
				};
			});
	}
});

Ractive.components["ux-easyplan"] = Ractive.extend({
	template: LUXComponentTemplates['ux-easyplan'],
	easyMobileSlider: jslider,
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			isValueZeroError: ConfigStrings.easyMobileTweakError
		};
	},

	onrender: function () {
		var self = this;

		this.on('selectPlan', function (e, index) {
			this.showSelectedPlanUnits(index);
		});

		this.set('getSelectedState', function (idx) {
			return self.get('selectedState.' + idx);
		});
		var selectedIndex = 2;
		var plans = self.get('plans');
		if (plans && plans.length > 2) {
			selectedIndex = 2;
		} else {
			selectedIndex = 0;
		}
		self.showSelectedPlanUnits(selectedIndex);
		this.on('ux-button.selectEasyMobilePlan', function (event) {
			var eventName = 'onSelectPlan' + '.' + 'planSelected';
			var selectedEasyPlan = this.get();
			var easyMobilePlan = {
				planName: selectedEasyPlan.activeType,
				totalUnits: selectedEasyPlan.totalUnits,
				talktime: {
					quantity: selectedEasyPlan.activeMinutes,
					unit: selectedEasyPlan.activeTalktimeUnits
				},
				sms: {
					quantity: selectedEasyPlan.activeSMS,
					unit: selectedEasyPlan.activeSMSUnits
				},
				data: {
					quantity: selectedEasyPlan.activeData,
					unit: selectedEasyPlan.activeDataUnits
				},
				planId: this.get('planId'),
				planRelId: this.get('planRelId'),
				basePriceSchema: this.get('basePriceSchema'),
				basePriceSchemaId: this.get('basePriceSchema'),
				monthlyCharges: this.get('monthlyCharges'),
				cisDiscountOffers: selectedEasyPlan.cisDiscountOffers,
				staffDiscountOffers: selectedEasyPlan.staffDiscountOffers,
				publicDiscountOffers: selectedEasyPlan.publicDiscountOffers
			};
			this.set('selectedEasyPlan', easyMobilePlan);
			this.fire('selectedGroupType', this.get('groupType'));
		
			this.fire(eventName, easyMobilePlan);
		});

	},
	showSelectedPlanUnits: function (idx) {
		var isValueZero = true;
		if (typeof this.get('plans') !== 'undefined') {
			var selectedPlan = this.get('plans')[idx];


			if (typeof selectedPlan !== 'undefined') {

				if (this.get('activeType')) {
					var currentState = this.get();

					var currentActiveSmsUnits = currentState.activeSMSUnits;
					var currentActiveDataUnits = currentState.activeDataUnits;
					var currentActiveTalkUnits = currentState.activeTalktimeUnits;


					var currentTotalUnits = currentActiveDataUnits + currentActiveSmsUnits + currentActiveTalkUnits;
					var afterTotalUnits = selectedPlan.totalUnits;

					this.set('planId', selectedPlan.planId);
					this.set('planRelId', selectedPlan.planRelId);
					this.set('basePriceSchema', selectedPlan.basePriceSchema || selectedPlan.basePriceSchemaId);
					this.set('monthlyCharges', selectedPlan.monthlyCharges);

					var talktime = Math.floor(currentActiveTalkUnits * afterTotalUnits / currentTotalUnits);
					if (talktime === 0) {
						talktime = 1;
					}

					var smsmms = Math.floor(currentActiveSmsUnits * afterTotalUnits / currentTotalUnits);
					if (smsmms === 0) {
						smsmms = 1;
					}

					var unitdata = afterTotalUnits - talktime - smsmms;


					var totalUnits = Number(talktime) + Number(smsmms) + Number(unitdata);

					this.set('activeType', selectedPlan.planName);
					this.set('totalUnits', totalUnits);
					this.set('activeMessage', selectedPlan.banner);

					this.updateUnits(talktime, smsmms, unitdata);

					this.setSelectedState(idx);

					var sliderStart = Number(talktime);
					var sliderEnd = Number(talktime) + Number(smsmms);
					this.initSlider(totalUnits, sliderStart, sliderEnd);

					if (selectedPlan.talktime && selectedPlan.talktime.unit) {
						this.set('talktimeValue', selectedPlan.talktime.unit);
					} else {
						this.set('talktimeValue', 'mins');
					}

					if (selectedPlan.sms && selectedPlan.sms.unit) {
						this.set('smsValue', selectedPlan.sms.unit);
					} else {
						this.set('smsValue', 'SMS');
					}

					if (selectedPlan.data && selectedPlan.data.unit) {
						this.set('dataValue', selectedPlan.data.unit);
					} else {
						this.set('dataValue', 'GB');
					}
					this.set('cisDiscountOffers', selectedPlan.cisDiscountOffers);
					this.set('staffDiscountOffers', selectedPlan.staffDiscountOffers);
					this.set('publicDiscountOffers', selectedPlan.publicDiscountOffers);

					this.update();
				} else {
					this.set('planId', selectedPlan.planId);
					this.set('planRelId', selectedPlan.planRelId);
					this.set('basePriceSchema', selectedPlan.basePriceSchema || selectedPlan.basePriceSchemaId);
					this.set('monthlyCharges', selectedPlan.monthlyCharges);

					var talktime = selectedPlan.talktime.quantity;
					if (talktime === 0) {
						isValueZero = isValueZero && false;
					}
					var smsmms = selectedPlan.sms.quantity;
					if (smsmms === 0) {
						isValueZero = isValueZero && false;
					}
					var unitdata = selectedPlan.data.quantity;
					if (unitdata === 0) {
						isValueZero = isValueZero && false;
					}

					var totalUnits = Number(talktime) + Number(smsmms) + Number(unitdata);

					this.set('activeType', selectedPlan.planName);
					this.set('isValueZero', isValueZero);
					this.set('totalUnits', totalUnits);
					this.set('activeMessage', selectedPlan.banner);

					this.updateUnits(selectedPlan.talktime.quantity,
						selectedPlan.sms.quantity,
						selectedPlan.data.quantity);

					this.setSelectedState(idx);

					var sliderStart = Number(selectedPlan.talktime.quantity);
					var sliderEnd = Number(selectedPlan.talktime.quantity) + Number(selectedPlan.sms.quantity);
					this.initSlider(totalUnits, sliderStart, sliderEnd);

					if (selectedPlan.talktime && selectedPlan.talktime.unit) {
						this.set('talktimeValue', selectedPlan.talktime.unit);
					} else {
						this.set('talktimeValue', 'mins');
					}

					if (selectedPlan.sms && selectedPlan.sms.unit) {
						this.set('smsValue', selectedPlan.sms.unit);
					} else {
						this.set('smsValue', 'SMS');
					}

					if (selectedPlan.data && selectedPlan.data.unit) {
						this.set('dataValue', selectedPlan.data.unit);
					} else {
						this.set('dataValue', 'GB');
					}
					this.set('cisDiscountOffers', selectedPlan.cisDiscountOffers);
					this.set('staffDiscountOffers', selectedPlan.staffDiscountOffers);
					this.set('publicDiscountOffers', selectedPlan.publicDiscountOffers);

					this.update();
				}


			}
		}
	},

	setSelectedState: function (idx) {
		var self = this;
		var selectedStateStr = 'selectedState.' + idx;
		var selectedStateObj = self.get('selectedState');
		if (selectedStateObj !== undefined) {
			_.each(selectedStateObj, function (element, key) {
				selectedStateObj[key] = '';
			});
		}
		self.set(selectedStateStr, 'selected');
	},

	initSlider: function (maxUnit, start, end) {
		var self = this;
		if (this.slider) {
			this.slider.noUiSlider.destroy();
		}
		this.slider = $('.range-slider')[0];
		this.easyMobileSlider.create(this.slider, {
			start: [start, end],
			step: 1,
			connect: true,
			direction: 'ltr',
			behaviour: 'tap-drag',
			range: {
				'min': 0,
				'max': maxUnit
			}
		});

		this.slider.noUiSlider.on('update', function (values, handle) {
			var talktimeUnits = Math.round(values[0]);
			var smsUnits = Math.round(values[1]) - talktimeUnits;
			var dataUnits = Math.round(maxUnit) - Math.round(values[1]);
			self.updateUnits(talktimeUnits, smsUnits, dataUnits);
		});

		this.slider.noUiSlider.on('change', function (values, handle) {
			var talktimeUnits = Math.round(values[0]);
			var smsUnits = Math.round(values[1]) - talktimeUnits;
			var dataUnits = Math.round(maxUnit) - Math.round(values[1]);
			self.set('isValueZero', true);
			if (talktimeUnits === 0) {
				talktimeUnits = 1;
				smsUnits = smsUnits - 1;
				self.set('unitError', self.get('errorMessages').talktime);
				self.slider.noUiSlider.set([talktimeUnits, (talktimeUnits + smsUnits)]);
			} else if (smsUnits === 0) {
				smsUnits = 1;
				if (handle === 0) {
					talktimeUnits = talktimeUnits - 1;
				} else if (handle === 1) {
					dataUnits = dataUnits - 1;
				}
				self.set('unitError', self.get('errorMessages').smsmms);
				self.slider.noUiSlider.set([talktimeUnits, (talktimeUnits + smsUnits)]);
			} else if (dataUnits === 0) {
				dataUnits = 1;
				smsUnits = smsUnits - 1;
				self.set('unitError', self.get('errorMessages').data);
				self.slider.noUiSlider.set([talktimeUnits, (talktimeUnits + smsUnits)]);
			}
			self.updateUnits(talktimeUnits, smsUnits, dataUnits);

			_.delay(function () {
				self.set('unitError', '');
			}, 5000);
		});
	},

	updateUnits: function (talktimeUnits, smsUnits, dataUnits) {
		var self = this;
		self.set('activeTalktimeUnits', talktimeUnits);
		self.set('activeSMSUnits', smsUnits);
		self.set('activeDataUnits', dataUnits);
		self.unitToValueConversion(talktimeUnits, smsUnits, dataUnits);
		self.update();
	},

	unitToValueConversion: function (minutes, sms, data) {
		var self = this;
		var activeMinutes = Number(minutes) * 25;
		var activeSMS = Number(sms) * 250;
		var activeData = Number(data) * 0.25;
		self.set('activeMinutes', activeMinutes);
		self.set('activeSMS', activeSMS);
		self.set('activeData', activeData);
	}
});

Ractive.components["ux-ebill-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-ebill-singtel']
});

Ractive.components["ux-ekyc-button"] = Ractive.extend({
	template: LUXComponentTemplates['ux-ekyc-button'],
	isolated: true,
	data: {
		noOfTokenRetries: 0
	},
	fetchToken: function (retry, callback) {
		var self = this;
		$.ajax({
			url: self.get('tokenApi'),
			type: 'POST',
			data: { grant_type: 'client_credentials' },
			contentType: 'application/x-www-form-urlencoded',
			headers: { 'x-client-id': 'SPRINGD' },
			success: function (response, status) {
				sessionStorage.setItem('apigee_token', 'Bearer ' + response.access_token);

				if (retry && typeof callback === 'function') {
					callback();
				}
			}
		});
	},
	redirectErrorPage: function () {
		var self = this;
		const errorUrl = self.get('errorMessages.genericUrl');
		if (errorUrl) {
			window.location.href = errorUrl;
		}
	},
	initiateEkyc: function () {
		var self = this;
		const accessToken = sessionStorage.getItem('apigee_token');
		self.set('buttonDisabled', true);

		$.ajax({
			url: self.get('initiateApi'),
			type: 'POST',
			contentType: 'application/json',
			xhrFields: {
				withCredentials: true
			},
			headers: {
				Authorization: accessToken
			},
			dataType: 'json',
			data: JSON.stringify({
				routeToSrp: self.get('sendToSRP'),
				eFormLandingPage: self.get('destinationUrl')
			}),
			success: function (response, status) {
				if (response.body && response.body.eKycVerifyCustomerPage) {
					self.set('buttonDisabled', false);
					window.location.href = response.body.eKycVerifyCustomerPage;
					return;
				}

				self.redirectErrorPage();
			},
			error: function (xhr, status, error) {
				if (xhr.status === 401 && self.get('noOfTokenRetries') < 3) {
					self.set('noOfTokenRetries', self.get('noOfTokenRetries') + 1);
					self.fetchToken(true, self.initiateEkyc.bind(self));
					return;
				} else {
					self.redirectErrorPage();
				}
			}
		});
	},
	toggleButtonDisplay: function (display) {
		var self = this;
		self.set('hidden', display);
	},
	oninit: function () {
		var self = this;
		const hidden = this.get('allowExternalToggle') && !RactiveHelpers.isAuthoringMode();
		self.set('hidden', hidden);
		if (hidden) {
			window.addEventListener('ekyc-button-display', function (event) {
					if (event.detail.type === 'toggle-display') {
						this.toggleButtonDisplay(event.detail.value);
					}
				}.bind(self)
			);
		}
	},
	onrender: function () {
		var self = this;

		self.on('*.handleEkycButtonClick', function (event, idx) {
			self.initiateEkyc();
		});
	}
});

Ractive.components["ux-ekyc-checkout-panel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-ekyc-checkout-panel'],
	data: function () {
		return {
			sectionHeader: function (str) {
				var className = $('#ekyc-singpass').attr('class');
				var className1 = $('#ekyc-manual-upload').attr('class');
				var className2 = $('#ekyc-manual-flow').attr('class');
				var className3 = $('#ekyc-doc-singpass').attr('class');
				if (className === ('add-singpass-link')) {
					str = str.replaceAll('href', 'class="add-singpass-link" href');
				}
				if (className1 === ('add-document-upload')) {
					str = str.replaceAll('href', 'class="add-document-upload" href');
				}
				if (className2 === ('fill-manually')) {
					str = str.replaceAll('href', 'class="fill-manually" href');
				}
				if (className3 === ('add-doc-singpass-link')) {
					str = str.replaceAll('href', 'class="add-doc-singpass-link" href');
				}
				return str;
			},
			sectionDescription: function (str) {
				var className3 = $('#ekyc-doc-singpass').attr('class');
				if (className3 === ('add-doc-singpass-link')) {
					str = str.replaceAll('href', 'class="add-doc-singpass-link" href');
				}
				return str;
			}
		};
	},

	oncomplete: function () {
		var self = this;
		var anchorElements = document.querySelector('a.add-singpass-link');
		if (anchorElements) {
			anchorElements.addEventListener('click', function (event) {
				self.fire('showSingpassFlowCick', null);
			}.bind(self));
		}
		var elements = document.querySelector('a.fill-manually');
		if (elements) {
			elements.addEventListener('click', function (event) {
				self.fire('showManualUploadClick', null);
			}.bind(self));
		}
		var uploadAnchorElements = document.querySelector('a.add-doc-singpass-link');
		if (uploadAnchorElements) {
			uploadAnchorElements.addEventListener('click', function (event) {
				self.fire('myInfoSingpassClick', null);
			}.bind(self));
		}
		var uploadElements = document.querySelector('a.add-document-upload');
		if (uploadElements) {
			uploadElements.addEventListener('click', function (event) {
				self.fire('myInfoManualUploadClick', null);
			}.bind(self));
		}
	}
});

Ractive.components["ux-ekyc-document-verificaton"] = Ractive.extend({
	template: LUXComponentTemplates['ux-ekyc-document-verificaton'],
	date: function () {
		return {
			fullName: '',
			uniqueId: '',
			passExpiryDate: '',
			passType: ''
		};
	}
});

Ractive.components["ux-ekyc-myinfo-login"] = Ractive.extend({
	template: LUXComponentTemplates['ux-ekyc-myinfo-login'],
	data: function () {
		return {
			eKycMyInfo: ConfigStrings.ekycMyInfoLogin
		};
	},

	oninit: function (argument) {
		this.set('disableUpload', '');
	},

	onrender: function (argument) {
		var self = this;
		self.on('*.singPassButtonClick', function (event) {
			self.fire('retrMyInfoSingpassClick', null);
		});
		self.on('*.uploadDocManuallyButtonClick', function (event) {

			self.fire('uploadDocsManuallyClick', null);
		});
	}

});

Ractive.components["ux-energy-catalog"] = Ractive.extend({
	template: LUXComponentTemplates['ux-energy-catalog'],
	onrender: function () {
		var self = this;
		self.on('*.energyPlanSelected', function (event) {
			self.fire('selectedPlanDetails', self.get());
		});
	}
});

Ractive.components["ux-energy-plan-callback"] = Ractive.extend({
	template: LUXComponentTemplates['ux-energy-plan-callback'],

	data: function () {
		return {
			name: '',
			phone: ''
		};
	},

	onrender: function () {
		var self = this;
		self.on({
			'ux-button.doSubmit': function () {
				var isValid = self.validateForm();
				if (isValid) {
					self.fire('submitCallback', self.get());
				}
			},
			'*.onblurContactName': function () {
				self.validateContactName();
			},
			'*.onblurContactNumber': function () {
				self.validateContactNumber();
			},
			'*.onInputName': function () {
				self.clearErrorMessage('nameErrorMsg');
			},
			'*.onInputNum': function () {
				self.clearErrorMessage('phoneErrorMsg');
			}
		});
	},

	validateForm: function () {
		var isValidname = this.validateContactName();
		var	isValidNo = this.validateContactNumber();
		return (isValidname && isValidNo);
	},

	validateContactName: function () {
		var nameErrorMsg = this.get('initData.errorMessages.nameErrorMsg');
		var	isValidname = RactiveHelpers.validateContactName(nameErrorMsg, 'name', this).valid;
		return isValidname;
	},

	validateContactNumber: function () {
		var mobileNumberErrorMsg = this.get('initData.errorMessages.mobileNumberErrorMsg'),
			isValidNo = RactiveHelpers.validateContactNum(mobileNumberErrorMsg, 'phone', this).valid;
		return isValidNo;
	},

	clearErrorMessage: function (id) {
		this.set(id, '');
	}
});

Ractive.components["ux-energy-plan-confirmation"] = Ractive.extend({
	template: LUXComponentTemplates['ux-energy-plan-confirmation']
});

Ractive.components["ux-energy-plan-details"] = Ractive.extend({
	template: LUXComponentTemplates['ux-energy-plan-details'],
	onrender: function () {
		var self = this;
		var contactData = {
			guestIdNumberPrefix: self.get('contactData.guestIdNumberPrefix') || 'S',
			guestIdNumber: self.get('contactData.guestIdNumber') || '',
			guestIdType: self.get('contactData.guestIdType') || 'National Registration ID Card (NRIC)',
			mobileNumber: '',
			readonly: self.get('contactData.readonly') || false
		};
		self.set('contactData', contactData);
		self.on('*.onBlurContact', function (event) {
			self.validateMobileNumber();
		});
		self.on('*.onIdChange', function (value) {
			if (value) {
				self.validateId();
			}
		});
		self.on('*.changedGuestId', function () {
			self.onIDNumPrefixChange();
		});
		self.on('*.onChangeGuestType', function () {
			self.set('guestIdMessage', false);
		});

		self.on('*.submitDetails', function (event) {
			var idValidation = self.validateId();
			var mobileValidation = self.validateMobileNumber();
			var idType = self.get('contactData.guestIdType');
			if (idType === 'Select') {
				self.set('guestIdMessage', ConfigStrings.errors.guestIdTypeError);
			} else {
				self.set('guestIdMessage', false);
				if (idValidation && mobileValidation) {
					self.fire('detailsSubmitted', self.get('contactData'));
				}
			}
		});

		var onePassSigninUrl = self.get('initData.onePassSigninUrl');
		var delimiter = '?';
		if (onePassSigninUrl.indexOf('?') > -1) {
			delimiter = '&';
		}
		var currentUrl = window.location.href;
		if (currentUrl.indexOf('?') > -1) {
			currentUrl = currentUrl + '&redirectSamePage=1';
		} else {
			currentUrl = currentUrl + '?redirectSamePage=1';
		}
		onePassSigninUrl = onePassSigninUrl + delimiter +
			'referenceUrl=' + encodeURIComponent(currentUrl);
		self.set('onePassSigninUrl', onePassSigninUrl);

		self.on('*.updateIdNumber', function (event) {
			self.set('contactData.guestIdNumber', event.get('value').toUpperCase());
		
			self.set('guestIdNumberErrorMsg', '');
		});
	},
	onIDNumPrefixChange: function () {
		var self = this;
		self.filterIDTypeOptions(self.get('contactData.guestIdNumberPrefix'));
	},
	filterIDTypeOptions: function (value) {
		var self = this;
		var allOptions = ConfigStrings.guestIdTypeOptions;
		var filteredOptions = _.filter(allOptions, function (item) {
			return item.ID === value;
		});
		var newFilteredOptions = [];
		if (value !== 'S' && value !== 'T') {
			newFilteredOptions.push({
				title: 'Select',
				value: 'Select'
			});
		}
		newFilteredOptions = newFilteredOptions.concat(filteredOptions);
		setTimeout (function () {
			self.set('contactData.guestIdType', newFilteredOptions[0].value);
			self.set('guestIdTypeOptions', newFilteredOptions);
		}, 0);
	},
	validateMobileNumber: function () {
		var self = this;
		self.set('mobileNumberVal.mobileNumberVal', null);
		var error = ConfigStrings.guestCheckoutValidationError.mobileNumber;
		var validationRule = {
			mobileNumberVal: {
				required: error.mobileRequired,
				minlength: {
					param: 8,
					message: error.minLengthError
				},
				maxlength: {
					param: 8,
					message: error.maxLengthError
				},
				digits: error.mobileDigitOnly,
				validMobileNumber: error.inValidMobileNumber
			}
		};
		self.validation = new RactiveValidate(self, validationRule);
		self.validation.cwd = 'mobileNumberVal';
		self.set('mobileNumberVal.mobileNumberVal', self.get('contactData.mobileNumber'));
		return self.validation.validate(self.validation).valid;
	},
	validateId: function () {
		var self = this;
		self.set('guestIdNumberErrorMsg', null);
		var guestIdNumber = self.get('contactData.guestIdNumberPrefix') +
			self.get('contactData.guestIdNumber');
		var flag = RactiveHelpers.validateNRIC(guestIdNumber);
		if (!flag) {
			self.set('guestIdNumberErrorMsg', {
				message: ConfigStrings.guestCheckoutValidationError.idNumber.inValidError,
				status: 'error'
			});
		}
		return flag;
	}
});

Ractive.components["ux-energy-plan-failure"] = Ractive.extend({
	template: LUXComponentTemplates['ux-energy-plan-failure']
});

Ractive.components["ux-energy-plan-otp"] = Ractive.extend({
	template: LUXComponentTemplates['ux-energy-plan-otp'],
	onrender: function () {
		var self = this;
		self.on('*.doSubmitDetails', function (event) {
			self.set('invalidNumber', false);
			var numberValue;
			var type = self.get('flowType');
			if (type === 'otp') {
				numberValue = self.get('contactData.otpNumber');
			} else {
				numberValue = self.get('contactData.accountNumber');
			}
			var mobileValidation = self.validateNumber(numberValue);
			if (mobileValidation) {
				self.fire('validateNumber', {
					type: type,
					contactData: self.get('contactData')
				});
			} else {
				self.set('invalidNumber', true);
			}
		});

		self.on('*.updateNumber', function (event) {
			self.set('invalidNumber', false);
		});
	},

	validateNumber: function (numberValue) {
		var self = this;
		self.set('numberVal.numberVal', null);
		var error = ConfigStrings.guestCheckoutValidationError.mobileNumber;
		var validationRule = {
			numberVal: {
				required: error.mobileRequired,
				digits: error.mobileDigitOnly
			}
		};
		self.validation = new RactiveValidate(self, validationRule);
		self.validation.cwd = 'numberVal';
		self.set('numberVal.numberVal', numberValue);
		return self.validation.validate(self.validation).valid;
	}
});

Ractive.components["ux-energy-plan-roi"] = Ractive.extend({
	template: LUXComponentTemplates['ux-energy-plan-roi'],

	data: function () {
		return {
			name: '',
			emailId: '',
			phone: '',
			postalCode: '',
			roiTnc: false
		};
	},

	onrender: function () {
		var self = this;
		self.on({
			'ux-button.doSubmit': function () {
				var isValid = self.validateForm();
				if (isValid) {
				
					self.fire('submitEnergyRoi', self.get());
				}
			},
			'*.onblurContactName': function () {
				self.validateContactName();
			},
			'*.onblurContactNumber': function () {
				self.validateContactNumber();
			},
			'*.onblurEmail': function () {
				self.validateEmail();
			},
			'*.onblurePostalCode': function () {
				self.validatePostCode();
			},
			'*.onInputName': function () {
				self.clearErrorMessage('nameErrorMsg');
			},
			'*.onInputNum': function () {
				self.clearErrorMessage('phoneErrorMsg');
			},
			'*.onInputEmail': function () {
				self.clearErrorMessage('emailIdErrorMsg');
			},
			'*.onInputPostcode': function () {
				self.clearErrorMessage('postalCodeErrorMsg');
			}
		});

	},

	validateForm: function () {
		var isValidname = this.validateContactName();
		var	isValidNo = this.validateContactNumber();
		var	isValidEmail = this.validateEmail();
		var	isValidPostcode = this.validatePostCode();
		return (isValidname && isValidNo && isValidEmail && isValidPostcode);
	},

	validateContactName: function () {
		var errorMessages = this.get('initData.errorMessages');
		var	isValidname = RactiveHelpers.validateContactName(errorMessages.nameErrorMsg, 'name', this).valid;
		return isValidname;
	},

	validateContactNumber: function () {
		var errorMessages = this.get('initData.errorMessages');
		var	isValidNo = RactiveHelpers.validateContactNum(errorMessages.mobileNumberErrorMsg, 'phone', this).valid;
		return isValidNo;
	},

	validateEmail: function () {
		var errorMessages = this.get('initData.errorMessages');
		var	isValidEmail = RactiveHelpers.validateEmailId(errorMessages.emailIdErrorMsg, 'emailId', this).valid;
		return isValidEmail;
	},

	validatePostCode: function () {
		var errorMessages = this.get('initData.errorMessages');
		var	isValidPostcode = RactiveHelpers.validatePostCode(errorMessages.postcodeErrorMsg,
			'postalCode', this).valid;
		return isValidPostcode;
	},

	clearErrorMessage: function (id) {
		this.set(id, '');
	}
});

Ractive.components["ux-energy-plan-summary"] = Ractive.extend({
	template: LUXComponentTemplates['ux-energy-plan-summary'],
	data: function () {
		return {
			isTncAgreed: false,
			RactiveHelpers: RactiveHelpers
		};
	},
	onrender: function () {
		this.on({
			'*.openTerms': function () {
				this.setModalDisplayState('termsAndConditions', true);
			},
			'*.proceedSummaryDetails': function () {
				this.setModalDisplayState('factSheetModal', true);
			},
			'*.scrollDown': function () {
				this.scrollToBottom('style-4');
			}
		});
	},
	setModalDisplayState: function (modalId, state) {

		var modals = this.findAllComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId[0] === component.get('modalId') || modalId ===  component.get('modalId');
		})[0];
		modal.set('displayState', state);
	},
	scrollToBottom: function (id) {
		var div = document.getElementById(id);
		div.scrollTop = div.scrollHeight - div.clientHeight;
	}
});

Ractive.components["ux-energy-service-details"] = Ractive.extend({
	template: LUXComponentTemplates['ux-energy-service-details'],
	decorators: {
		tooltip: ractiveTooltip
	},
	data: function () {
		return {
			defaultOptions: {
				genderOptions : [
					{ value : 'M', text : 'Male'},{ value : 'F', text : 'Female'}
				]
			},
			day: '',
			month: '',
			year: '',
			registeredName: '',
			ConfigStrings: ConfigStrings,
			genderError: false,
			getMinDate: function () {
				var minDate = this.get('minDate') || moment();
				var duration = this.get('initData.minDurWithoutAccount');
				if (this.get('contactData.accountNo') && this.get('contactData.accountNo') !== '') {
					duration = this.get('initData.minDurWithAccount');
				}
				var minDate = moment(minDate).add(duration, 'days');
				if (minDate.day() === 0) {
					duration = 1;
				} else if (minDate.day() === 6) {
					duration = 2;
				} else {
					duration = 0;
				}
				minDate = moment(minDate).add(duration, 'days');
				return minDate;
			},
			getMaxDate: function () {
				var minDate = this.get('minDate') || moment();
				var duration = this.get('initData.minDurWithoutAccount');
				if (this.get('contactData.accountNo') && this.get('contactData.accountNo') !== '') {
					duration = this.get('initData.minDurWithAccount');
				}
				duration = duration + 30;
				return moment(minDate).add(duration, 'days');
			}
		};
	},
	oninit : function () {
		var d = new Date();
		var currentYear = d.getFullYear();
		var yearOptions = [];

		yearOptions.push({
			value : 'Year',
			text: 'Year'
		});
		for (var i = 0; i < 100; i++) {
			yearOptions.push({
				value : (currentYear - i),
				text: (currentYear - i)
			});
		}
		this.set('defaultOptions.yearOptions', yearOptions);
		this.set('contactData.year', 'Year');
		this.set('defaultOptions.monthOptions', ConfigStrings.date.months2);
		this.set('contactData.month', 'Month');
		this.set('contactData.housingDetails', 'Please Select');

		var dayOptions = [];
		dayOptions.push({
			value : 'Day',
			text : 'Day'
		});
		for (var i = 0; i < 31; i++) {
			dayOptions.push({
				value : (((i + 1) < 10) ? ('0' + (i + 1)) : (i + 1)),
				text : (i + 1)
			});
		}
		this.set('defaultOptions.dayOptions', dayOptions);
		this.set('contactData.day', 'Day');

		this.set('contactData.salutation', 'Select');
		this.set('contactData.gender', 'Select Gender');
		this.set('contactData.dummyStartDate', '');
	},
	onrender : function () {
		var self = this;
		self.on('*.showAddNewDeliveryAddressWindow', function (event, value) {
			self.resetToDefaultValues();
			self.setModalDisplayState('addNewDeliveryAddress', true);
		});

		self.on('*.onUpdate', function (event, value) {
			var retrievedAddress = _.clone(self.get('addressRetrieve.address'));
			retrievedAddress.state = ConfigStrings.physicalAddressValues.state;
			retrievedAddress.country = ConfigStrings.physicalAddressValues.country;
			retrievedAddress.city = ConfigStrings.physicalAddressValues.city;
		
		
		
			var newAddressAdded = this.get('newAddressAdded');
			if (!newAddressAdded) {
				newAddressAdded = [];
			}
			newAddressAdded.push(retrievedAddress);
			var index = newAddressAdded.length - 1;
			_.each(newAddressAdded, function (item) {
				item.chkId = false;
			});
			newAddressAdded[index].chkId = true;
			self.set('newAddressAdded', newAddressAdded);
			self.setModalDisplayState('addNewDeliveryAddress', false);
		});
		self.on('*.showAHTooltip', function (event) {
			event = event.event;
			if (event.original.currentTarget.nextElementSibling.style.display !== 'block') {
				_.each(document.getElementsByClassName('tooltip'), function (v) {
					v.style.display = 'none';
				});
				event.original.currentTarget.nextElementSibling.style.display = 'block';
			} else {
				event.original.currentTarget.nextElementSibling.style.display = 'none';
			}

			return false;
		});
		self.on({
			'*.onblurContactName': function () {
				self.validateContactName();
			},
			'*.onblurFullName': function () {
				self.validateFullName();
			},
			'*.onInputName': function () {
				self.clearErrorMessage('contactData.accountHolderNameErrorMsg');
				var accountHolderName = self.get('contactData.accountHolderName');
				if (accountHolderName && accountHolderName.length > 2) {
					self.validateContactName();
				}
			},
			'*.onInputFullName': function () {
				self.clearErrorMessage('contactData.nameErrorMsg');
			},
			'*.onblurContactNumber': function () {
				self.validateContactNumber();
			},
			'*.onblurEmail': function () {
				self.validateEmail();
			},
			'*.onInputNum': function () {
				self.clearErrorMessage('contactData.phoneErrorMsg');
			},
			'*.onInputEmail': function () {
				self.clearErrorMessage('contactData.emailIdErrorMsg');
			},
			'*.onInputAccountNo': function () {
				self.clearErrorMessage('contactData.accountNoErrorMsg');
			},
			'*.onblurAccountNumber': function () {
				var accountNo = self.get('contactData.accountNo');
				if (accountNo || self.get('initData.accountNoMandatory')) {
					self.validateAccountNumber();
				}
			},
			'*.submitServiceDetails': function () {
				var accountNo = self.get('contactData.accountNo');
				var isValid = self.validateContactName();
				isValid = self.validateAllAddresses() && isValid;
				isValid = self.validateHousingType() && isValid;
				isValid = self.validateContactNumber() && isValid;
				isValid = self.validateEmail() && isValid;
				isValid = self.validateStartDate() && isValid;
				if (accountNo || self.get('initData.accountNoMandatory')) {
					isValid = self.validateAccountNumber() && isValid;
				}
				var newcustomer = self.get('singtelEnergyDetails.customerDetails.newcustomer');
				if (newcustomer) {
					isValid = self.validateNewCustomer() && isValid;
				}
				if (isValid) {
					self.fire('submitValidServiceDetails', self.get());
				}
			}
		});
	},
	validateNewCustomer: function () {
		var validDOB = this.validateDOB();
		var validGender = this.validateGender();
		var fullName = this.validateFullName();
		return validDOB && validGender && fullName;
	},
	validateDOB: function () {
		this.set('dateError', false);
		var isValidDate = false;
		var date = this.get('contactData.day');
		var month = this.get('contactData.month');
		var year = this.get('contactData.year');
		if (date && date !== '' && month && month !== '' && year && year !== '') {
			var dateString = month + '/' + date + '/' + year;
			if (moment(dateString, 'MM/DD/YYYY', true).isValid()) {
				isValidDate = true;
			}
		}
		this.set('dateError', !isValidDate);
		return isValidDate;
	},
	validateGender: function () {
		this.set('genderError', false);
		var isValidGender = false;
		var gender = this.get('contactData.gender');
		if (gender && (gender === 'M' || gender === 'F')) {
			isValidGender = true;
		}
		this.set('genderError', !isValidGender);
		return isValidGender;
	},
	validateHousingType: function () {
		this.set('housingDetailsErrowMsg', false);
		var isValidHousing = true;
		var housingDetails = this.get('contactData.housingDetails');
		if (housingDetails === 'Please Select') {
			isValidHousing = false;
		}
		this.set('housingDetailsErrowMsg', !isValidHousing);
		return isValidHousing;
	},
	validateContactName: function () {
		var errorMessage = this.get('initData.errorMessages.nameErrorMsg');
		this.nameValidation = new RactiveValidate(this,{
			'contactData.accountHolderName': {
				maxlength: {
					param: 50,
					message: errorMessage.maxLengthError
				},
				validUserName: errorMessage.validUserName,
				required: errorMessage.required
			}
		});
		this.nameValidation.cwd = '';
		return this.nameValidation.validate(this.nameValidation).valid;
	},
	validateFullName: function () {
		var errorMessage = this.get('initData.errorMessages.nameErrorMsg');
		this.nameValidation = new RactiveValidate(this,{
			'contactData.name': {
				maxlength: {
					param: 50,
					message: errorMessage.maxLengthError
				},
				validUserName: errorMessage.validUserName,
				required: errorMessage.required
			}
		});
		this.nameValidation.cwd = '';
		return this.nameValidation.validate(this.nameValidation).valid;
	},
	validateStartDate: function () {
		var errorMessage = this.get('initData.errorMessages.startDateMissing');
		this.nameValidation = new RactiveValidate(this,{
			'contactData.startDate': {
				required: errorMessage
			}
		});
		this.nameValidation.cwd = '';
		return this.nameValidation.validate(this.nameValidation).valid;
	},
	validateContactNumber: function () {
		var errorMessage = this.get('initData.errorMessages.mobileNumberErrorMsg');
		this.contactValidation = new RactiveValidate(this,{
			'contactData.phone': {
				validMobileNumber: errorMessage.inValidMobile,
				minlength: {
					param: 8,
					message: errorMessage.minLengthError
				},
				maxlength: {
					param: 8,
					message: errorMessage.maxLengthError
				},
				digits: errorMessage.digits,
				required: errorMessage.required
			}
		});
		this.contactValidation.cwd = '';
		return this.contactValidation.validate(this.contactValidation).valid;
	},
	validateEmail: function () {
		var errorMessage = this.get('initData.errorMessages.emailIdErrorMsg');
		this.emailValidation = new RactiveValidate(this,{
			'contactData.emailId': {
				emailId: errorMessage.inValidEmail,
				required: errorMessage.required
			}
		});
		this.emailValidation.cwd = '';
		return this.emailValidation.validate(this.emailValidation).valid;
	},
	validateAccountNumber: function () {
		var errorMessage = this.get('initData.errorMessages.accountNoErrorMsg');
		var validations = {
			'contactData.accountNo': {
				minlength: {
					param: 9,
					message: errorMessage
				},
				maxlength: {
					param: 10,
					message: errorMessage
				},
				digits: errorMessage,
				validAccNumber: errorMessage
			}
		};
		if (this.get('initData.accountNoMandatory')) {
			validations['contactData.accountNo'].required = errorMessage;
		}
		this.accountNoValidation = new RactiveValidate(this, validations);
		this.accountNoValidation.cwd = '';
		return this.accountNoValidation.validate(this.accountNoValidation).valid;
	},
	validateAllAddresses: function () {
		var isValidInstallationAddress = this.validateAddress(
			this.get('serviceDetails.installationAddress'), 'installationAddress');
		var isValidBillingAddress = true;
		if (!this.get('serviceDetails.sameBilling')) {
			isValidBillingAddress = this.validateAddress(
				this.get('serviceDetails.billingAddress'), 'billingAddress');
		}
		return isValidInstallationAddress && isValidBillingAddress;
	},
	validateAddress: function (address, addressType) {
		var isValidAddress = false;
		var components = this.findAllComponents('ux-address-form-new');
		var component = _.find(components, function (component) {
			if (component.get('addressType') === addressType) {
				return true;
			}
		});
		component.set('errorMessage', false);
		if (address && address.postCode && address.blockOrHouseNum) {
			isValidAddress = component.validateFloorAndUnitNumber();
		} else {
			component.set('errorMessage', this.get('initData.errorMessages.addressMissing'));
		}
		return isValidAddress;
	},
	resetToDefaultValues: function () {
		this.set('addressList', null);
		this.set('addressRetrieve.address', null);
	},
	setModalDisplayState: function (modalId, state) {

		var modals = this.findAllComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId[0] === component.get('modalId') || modalId ===  component.get('modalId');
		})[0];

		modal.set('displayState', state);
	},
	clearErrorMessage: function (id) {
		this.set(id, '');
	}
});

Ractive.components["ux-energy-sub"] = Ractive.extend({
	template: LUXComponentTemplates['ux-energy-sub'],
	data: function () {
		return {
			isAutoRenewUserChoice: false,
			isAutoRenewOriginalVal: false,
			showGraph: false,
			latestCharge: null
		};
	},



	drawGraph: function () {
	
		var data = this.get('energyTopic.energyUsage');
		if (data && data.length) {
			this.set('showGraph', true);
			var latestCharge = this.get('energyTopic.energyUsage.' + (data.length - 1));
			var nationalAverage = latestCharge.nationalAverageX8;
			this.set('latestCharge', latestCharge);
			var svgDomEl = this.find('#energySvgContainer');
			var svg = d3.select(svgDomEl);
			var widthMargin = 50;
			var heightMargin = 150;
			var xGraphMargin = 30;
			var yGraphMargin = 50;

			var width = svgDomEl.getBoundingClientRect().width - widthMargin;
			var height = svg.attr('height') - heightMargin;

			console.log(d3);
			var x = d3.scaleBand().domain(data.map(function (d) {
			
				return d.chargeDate;
			})).range([0, width]).padding(0.5);

			var y = d3.scaleLinear().domain([0, d3.max(data, function (d) {
				if (d.usageVolume > nationalAverage) {
					return d.usageVolume;
				} else {
					return nationalAverage;
				}
			})]).range([height, 0]);

			var g = svg.select('#graphGroup');
			g.html('');
			g.attr('transform',
				'translate(' + xGraphMargin + ', ' + yGraphMargin + ')');

			var xAxis = d3.axisBottom(x).tickFormat(function (d, index) {
				var usage = data[index];
				var month =  RactiveHelpers.convertMilisTimestampToDate(d, 'MMM');
				if (usage.readingTypeX8 && usage.readingTypeX8 === 'Estimated') {
					month = '*' + month;
				}
				return month;
			});
			g.append('g').attr('transform', 'translate(0, ' + height + ')')
			.call(xAxis);

			var yAxis = g.append('g').attr('class', 'yaxis')
			.call(
				d3.axisLeft(y).tickFormat(function (d) {
					return d + ' ';
				}).ticks(7).tickSize(-width)
			);

			g.append('text')
			.attr('class', 'yaxis-lable')
			.attr('x', -15)
			.attr('y', -10)
			.attr('dy', '0.5em')
			.attr('text-anchor', 'middle')
			.text('kWh');

			g.selectAll('.bar')
			.data(data)
			.enter()
			.append('rect')
			.attr('class', 'bar pointer')
			.attr('x', function (d) {
				return x(d.chargeDate);
			})
			.attr('y', function (d) {
				return y(d.usageVolume);
			})
			.attr('width', function () {
				return x.bandwidth();
			})
			.attr('height', function (d) {
				return height - y(d.usageVolume);
			})
			.on('click', function (usage, index, allRect) {
				var month =  RactiveHelpers.convertMilisTimestampToDate(usage.chargeDate, 'MMM');
				if (usage.readingTypeX8 && usage.readingTypeX8 === 'Estimated') {
					month = '*' + month;
				}
				var text = month + ' ' + usage.usageVolume + ' ' + usage.usageUOMX8;
				var xPos = x(usage.chargeDate) - 40 + (x.bandwidth() / 2) + xGraphMargin;
				var yPos = y(usage.usageVolume) - 40 + yGraphMargin;
				var tooltip = svg.select('#tooltip');
				tooltip.attr('transform', 'translate(' + xPos + ', ' + yPos + ')');
				tooltip.attr('style', 'display: block');
				tooltip.select('text').text(text);
			});

		
			g.append('line')
			.attr('class', 'national-avg-line')
			.attr('x1', 0)
			.attr('y1', function () {
				return y(nationalAverage);
			})
			.attr('x2', width)
			.attr('y2', function () {
				return y(nationalAverage);
			})
			.attr('stroke', '#DEBC68');
			svg.select('.yaxis').selectAll('.domain').remove();


			var legendsXpos = 10;
			var legendsYpos = 30 + height + yGraphMargin;
			d3.select('.legends')
			.attr('transform', 'translate(' + legendsXpos + ', ' + legendsYpos + ')');

			d3.select('.nationalAvgValue')
			.text(nationalAverage + ' kWh');

			d3.select('.latestUsageValue')
			.text(latestCharge.usageVolume + ' kWh');
			console.log(xAxis, yAxis);
		
		}
	},

	onrender : function () {
		var self = this;
		this.set('initData.manageServiceEnergy.header', 'Manage energy subscription');
		this.set('initData.manageServiceEnergy.headerMsg', 'Select any type of options below to manage energy service');
		this.set('initData.changePlanEnergyLink', 'http://www.singtel.com');
		this.set('initData.changePlanEnergyText', 'Change plan');
		this.set('initData.manageService.changePlanEnergyMsg', 'If your plan is still in contract, early downgrade' +
			'penalties may be reflected in your next bill.');
		this.set('initData.autoRenewEnergyText', 'Manage auto-renewal');
		this.set('initData.manageService.autoRenewEnergyMsg', 'Plan is set to auto-renew (12-Month contract)' +
			'by default to ensure your home is continually powered with electricity.');
		this.set('initData.manageServiceEnergy.autoRenewHeader', 'Manage auto-renewal');
		this.set('initData.manageServiceEnergy.planRenewLabel', 'Plan auto-renewal');
		this.set('initData.manageServiceEnergy.planRenewMsg', 'Plan is set to auto-renew by default to ensure your' +
			'home is continually powered. You have the option to switch to another Singtel energy plan 1 month ' +
			'before contract end date.');

		self.on('*.manageEnergyService', function () {
			RactiveHelpers.toggleModal(self, 'manageEnergyServiceModal', true);
		});
		self.observe('energyTopic.energyVmStatus', function (energyVmStatus) {
			switch (energyVmStatus) {
				case 'autoRenewIndicatorSuccessYes':
				case 'autoRenewIndicatorSuccessNo':
					RactiveHelpers.setModalProperty(self, 'autoRenewSwitchModal', 'inProcess', false);
					RactiveHelpers.toggleModal(self, 'autoRenewSwitchModal', false);
					break;
				case 'autoRenewIndicatorError':
					RactiveHelpers.setModalProperty(self, 'autoRenewSwitchModal', 'inProcess', false);
					RactiveHelpers.toggleModal(self, 'autoRenewSwitchModal', false);
					RactiveHelpers.toggleModal(self, 'genericError', true);
					console.log('Error');
					break;
				case 'energyUsageSet':
				
					var serviceId = this.get('product.serviceId');
					if (serviceId === this.get('energyTopic.serviceId')) {
						this.drawGraph();
					}
					break;
			}
		});
		self.on('*.showAutoRenew', function () {
			var uxService = self.parent.parent;
			if ((this.get('permission.ipa') || this.get('permission.blacklisted')) &&
				this.get('pendingOrders.isChangePlanPending')) {
				uxService.parent.toggleModal('blackListedModel', true);
			} else {
			
				var productFacade = this.get('productFacade');
				var isAutoRenewOriginalVal = false;
				var autoRenewParamVal = productFacade.getParameterValueByIdByParentCatlogId('18683321', '18601671');
				if (autoRenewParamVal === 'Yes') {
					isAutoRenewOriginalVal = true;
				}
				this.set('isAutoRenewOriginalVal', isAutoRenewOriginalVal);
				this.set('isAutoRenewUserChoice', isAutoRenewOriginalVal);
				RactiveHelpers.toggleModal(self, 'manageEnergyServiceModal', false);
				RactiveHelpers.toggleModal(self, 'autoRenewSwitchModal', true);
			}
		}.bind(self));

		self.on('*.changeAutoRenew', function () {
			if (this.get('isAutoRenewOriginalVal') !== this.get('isAutoRenewUserChoice')) {
			
				this.fire('changeAutoRenewMode', {
					customerId: this.get('account.customerId'),
					autoRenewIndicator: this.get('isAutoRenewUserChoice') ? 'Yes' : 'No',
					faId: this.get('account.faid'),
					barId: this.get('account.billingAccountNumber'),
					assignedProductId: this.get('product.id'),
					subscriptionId: this.get('product.subscriptionId')
				});
				RactiveHelpers.setModalProperty(self, 'autoRenewSwitchModal', 'inProcess', true);
			}
		}.bind(self));
	}
});

Ractive.components["ux-error-page"] = Ractive.extend({
	template: LUXComponentTemplates['ux-error-page'],
	isolated: true,

	transitions: {
		fly: ractiveTransitionsFly
	},

	oninit: function () {
		var self = this;
		self.set('anonymouUser', true);
	}
});


Ractive.components["ux-existing-card-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-existing-card-singtel'],
	data: function () {
		return {
			getBrand: function (brand) {
				return brand.charAt(0).toUpperCase() + brand.slice(1).toLowerCase();
			}
		};
	},
	oninit: function () {
		this.on('onCardTap', function (event) {
			var onTap = this.get('ontap');
			if (onTap) {
				this.fire(onTap, this);
			}
		});
		this.on('ux-anchor.removeCard', function (event) {
			var onRemove = this.get('onremove');
			if (onRemove) {
				this.fire(onRemove, this);
			}
		});
	}
});

Ractive.components["ux-faq-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-faq-singtel'],

	oninit: function () {
		this.storage = localStorage;
		var self = this;
		self.set('showChat', true);
		window.lpChatWindow = {
			showLPChatWindow: true
		};
		window.lpChatWindow.watch('showLPChatWindow', function (id, oldval, newval) {
			self.set('showChat', newval);
		});

		var hideDigitalHelpTomo = this.get('hideDigitalHelpTomo');

		var hasPartnerIdPartnerCode = false;
		var queryParams = RactiveHelpers.getUrlParams();
		if (queryParams.partnerId && queryParams.partnerCode) {
			hasPartnerIdPartnerCode = true;
		}

		var deviceAndPlanTopicContext = 'businesswidget/repository_l9_common/' +
			'common/viewmodel/contextTopics/DeviceIdAndPlanIdInContextTopic';
		var pgInfoContext = JSON.parse(sessionStorage.getItem(deviceAndPlanTopicContext));

		if (pgInfoContext && pgInfoContext.pgInfo) {
			var partnerId = pgInfoContext.pgInfo.partnerId;
			var partnerCode = pgInfoContext.pgInfo.partnerCode;
			hasPartnerIdPartnerCode = partnerId && partnerCode ? true : hasPartnerIdPartnerCode;
		}

		if (hideDigitalHelpTomo && hasPartnerIdPartnerCode) {
			self.set('showChat', false);
		}

		this.set('closed', true);
		this.resetSelection();
		this.idleStatus = null;
		this.timeoutID = null;
		this.proactiveActive = false;
		this.openChatOnce = false;
		this.proactiveChatEnable = this.get('faqPageContent.virtualAgent.enableProactiveChatInvitation');
		this.idleInterval = this.get('faqPageContent.virtualAgent.proactiveChatInvitationStartAfter');
		this.idleDelay = this.get('faqPageContent.virtualAgent.proactiveChatInvitationEndAfter');
		this.webChatStatuesInterval = this.get('faqPageContent.webChat.webChatStatuesInterval');
		this.webChatStatuesTimeout = this.get('faqPageContent.webChat.webChatStatuesTimeout');
		this.virtualAgentEnable = this.get('faqPageContent.virtualAgent.enable');
		this.helpEnable = this.get('faqPageContent.help.enable');
		if (this.virtualAgentEnable === true) {
			if (this.proactiveChatEnable) {
				self.setTriggerIcon('virtual');
				this.setIdle();
			} else {
				self.setTriggerIcon('virtual');
			}
			if (window.lpTag && window.lpTag.sdes && window.lpTag.sdes.send) {
				setTimeout(function () {
					window.lpTag.sdes.send(
						{
							'type': 'ctmrinfo',
							'info': {
								'cstatus': 'ClosedVA'
							}
						}
					);
				}, 1000);
			}
		}
		if (this.helpEnable ===  true) {
			self.setTriggerIcon('help');
		}
		if (!this.virtualAgentEnable) {
			this.set('triggerIcons.hidePopUp', false);
		}
		this.webChatEnable = this.get('faqPageContent.webChat.enable');
		if (this.webChatEnable ===  true) {
						this.webChatStatuesIntervalFunc = setInterval(function () {
				if (typeof window.lpSpringDigital !== 'undefined' &&
					typeof window.lpSpringDigital.state !== 'undefined') {
					var nstate = window.lpSpringDigital.state;
					self.set('faqPageContent.webChat.state', nstate);
					self.setTriggerIcon(nstate);
					clearInterval(self.webChatStatuesIntervalFunc);
				}
			}, self.webChatStatuesInterval);
						setTimeout(function () {
				clearInterval(self.webChatStatuesIntervalFunc);
				if (typeof self.get('faqPageContent.webChat.state') === 'undefined') {
					self.set('faqPageContent.webChat.state', 'offline');
					self.setTriggerIcon('offline');
				}
			}, self.webChatStatuesTimeout);
		}

		this.setSubscriber(sessionStorage);

		this.on('*.doSurveyAccess', function (anchorComponent) {
			this.toggleModal('surveyModal', false);
			var url = anchorComponent.get('url');
			if (url) {
				window.location.href = url;
			}
		}.bind(this));

		this.on('*.doSurveyDismiss', function () {
			this.storage.vaLastSurveyDismiss = (new Date()).getTime();
			this.toggleModal('surveyModal', false);
		}.bind(this));

		this.on('*.doCloseModal', function () {
			this.storage.disableSurveyInSession = true;
			this.toggleModal('surveyModal', false);
		}.bind(this));
		Ractive.defaults.on('askShirley_openFaqModal', function (question) {
			var self = this;
			self.set('question', question);
		
			var topSectionData;
			self.set('triggerIcons.enable', false);
			self.set('faqPageContent.enable', true);
			self.set('faqPageContent.faq.enable', true);
			self.set('closed', false);
			topSectionData = self.get('faqPageContent.virtualAgent');
			self.set('faqPageContent.topSectionData', topSectionData);
			self.set('faqPageContent.topSectionData.chat.enable', true);
			this.set('faqPageContent.faq.enable', false);
			$('iframe#ChatWindow').on('load', function () {
				self.fire('*.doChatOpen', question);
			});
		}.bind(self));

		this.on('*.openFaqModal', function (event) {
			self.set('triggerIcons.hidePopUp', true);
			if (self.get('minimized') === true) {
				this.set('faqPageContent.enable', true);
				this.set('minimized', false);
				this.set('triggerIcons.enable', false);
			} else {
								if (typeof window.lpSpringDigital !== 'undefined' &&
					typeof window.lpSpringDigital.state !== 'undefined') {

					var nstate = window.lpSpringDigital.state;
					self.set('faqPageContent.webChat.state', nstate);
					self.setTriggerIcon(nstate);
				}

				this.set('triggerIcons.enable', false);
				this.set('faqPageContent.enable', true);
				this.set('faqPageContent.faq.enable', true);

				var topSectionData;
				var escapeVirtualChatLanding = true;

				if (this.virtualAgentEnable === true) {
					this.set('closed', false);
					if (this.proactiveChatEnable) {
						this.openChatOnce = true;
						window.clearTimeout(self.timeoutID);
					}
					topSectionData = this.get('faqPageContent.virtualAgent');
					if (this.storage.escapeVirtualChatLanding === 'true' ||
						this.storage.escapeVirtualChatLanding === true) {
						escapeVirtualChatLanding = true;
					}
					if (window.lpTag && window.lpTag.sdes) {
						window.lpTag.sdes.send(
							{
								'type': 'ctmrinfo',
								'info': {
									'cstatus': 'OpenVA'
								}
							}
						);
					}
				} if (this.helpEnable === true) {
					topSectionData = this.get('faqPageContent.help');
					topSectionData.callback = this.get('faqPageContent.callback');
					topSectionData.callback.enableCallback = true;
					topSectionData.state = 'help';
					escapeVirtualChatLanding = false;
				} else if (this.webChatEnable === true) {
					topSectionData = this.get('faqPageContent.webChat');
					topSectionData.callback = this.get('faqPageContent.callback');
					escapeVirtualChatLanding = false;
					topSectionData.state = window.lpSpringDigital.state;
					if (typeof topSectionData.state === 'undefined' ||
							topSectionData.state === 'offline' ||
							topSectionData.state === 'busy') {
						topSectionData.callback.enableCallback = true;
					}
				}

				this.set('faqPageContent.topSectionData', topSectionData);
				if (escapeVirtualChatLanding) {
					this.set('faqPageContent.topSectionData.chat.enable', true);
					this.set('faqPageContent.faq.enable', false);
					var sessionId = this.getCookie('ChatSessionId');
					if (sessionId && sessionId !== -1) {
						setTimeout(function () {
							window.SubmitQuestionToIr('SummaryRequest', 1);
						}, 1000);
					}
				}
				this.handleChatMoveAndResize('move');
				if (this.virtualAgentEnable === true) {
					this.storage.escapeVirtualChatLanding = true;
				}
			}

		});

		this.on('*.doChatMove doChatMove', function (t) {
			this.chat = this.el.querySelector('.ux-faq');
			if (!this.chat.classList.contains('move-handled')) {
				this.handleChatMoveAndResize('move');
				this.chat.classList.add('move-handled');
			}
		});

		this.on('*.doChatClose doChatClose', function () {
			this.storage.vaLastAction = 'doChatClose';
			this.set('minimized', false);
			this.set('faqPageContent.enable', false);
			this.resetSelection();
			this.storage.escapeVirtualChatLanding = false;
			if (window.lpTag && window.lpTag.sdes) {
				window.lpTag.sdes.send(
					{
						'type': 'ctmrinfo',
						'info': {
							'cstatus': 'ClosedVA'
						}
					}
				);
			}
			this.deleteCookie('ChatSessionId');
			this.set('closed', true);
		});

		this.on('*.doChatMinimize doChatMinimize', function () {
			this.set('minimized', true);
			this.set('faqPageContent.enable', false);
			this.set('triggerIcons.enable', true);
			if (window.lpTag && window.lpTag.sdes) {
				window.lpTag.sdes.send(
					{
						'type': 'ctmrinfo',
						'info': {
							'cstatus': 'ClosedVA'
						}
					}
				);
			}
		});

		this.on('*.doChatOpenExt', function (question) {
			window.globalQuestion = question;
			this.set('faqPageContent.faq.enable', false);
			if (window.SubmitQuestionToIr) {
				var sessionId = this.getCookie('ChatSessionId');
				if (sessionId && sessionId !== -1) {
					window.SubmitQuestionToIr('SummaryRequest', 1);
				}
				setTimeout(function () {
					window.SubmitQuestionToIr('NormalRequest', 1);
				}, 500);
			}
			if (window.lpTag && window.lpTag.sdes) {
				window.lpTag.sdes.send(
					{
						'type': 'ctmrinfo',
						'info': {
							'cstatus': 'OpenVA'
						}
					}
				);
			}
			this.set('faqPageContent.topSectionData.chat.enable', true);
		});
		this.on('*.doChatOpen', function (question) {
			var self = this;
			var question = this.get('question') || this.get('value') || question || '';
			window.globalQuestion = question;
			this.set('faqPageContent.faq.enable', false);
			if (window.SubmitQuestionToIr) {
				var sessionId = this.getCookie('ChatSessionId');
				if (sessionId && sessionId !== -1) {
					window.SubmitQuestionToIr('SummaryRequest', 1);
				}
				setTimeout(function () {
					window.SubmitQuestionToIr('NormalRequest', 1);
					self.set('question', '');
				}, 500);
			}
			if (window.lpTag && window.lpTag.sdes) {
				window.lpTag.sdes.send(
					{
						'type': 'ctmrinfo',
						'info': {
							'cstatus': 'OpenVA'
						}
					}
				);
			}
			this.set('faqPageContent.topSectionData.chat.enable', true);
		});

		this.on('ux-anchor.doWebChatOpen', function (event) {
			this.set('faqPageContent.faq.enable', false);
			if (window.lpTag && window.lpTag.taglets && window.lpTag.taglets.rendererStub &&
				window.lp_EngagementId) {
				window.lpTag.taglets.rendererStub.click(window.lp_EngagementId);
				this.set('triggerIcons.enable', true);
				this.set('triggerIcons.hidePopUp', true);
				this.set('faqPageContent.enable', false);
				this.set('showChat', false);

			}
		});

		this.on('ux-anchor.submitMsisdn', function (event) {
			this.set('faqPageContent.topSectionData.callback.enableCallback', true);
		});

		this.on('ux-anchor.scheduleCallBack', function (event) {
			this.set('faqPageContent.topSectionData.callback.enableCallback', true);
		});

				var msisdnList = this.get('faqPageContent.callback.options');
		if (msisdnList && msisdnList.length > 0) {
			_.each(msisdnList, function (msisdn) {
				msisdn.title = 'Mobile: ' + msisdn.title;
			});
			this.set('faqPageContent.callback.selectedMsisdn', msisdnList[0].value);
			this.set('faqPageContent.callback.msisdnList', msisdnList);
			this.set('faqPageContent.topSectionData.callback.selectedMsisdn', msisdnList[0].value);
			this.set('faqPageContent.topSectionData.callback.msisdnList', msisdnList);
		}

		var loginStatus = RactiveHelpers.getParameterByName('loginstatus');
		if (loginStatus === 'fail') {
			setTimeout(function () {
				if (window.lpTag && window.lpTag.sdes) {
					window.lpTag.sdes.push({
						type: 'error',
						error: {
							code: '0001'
						}
					});
				}
			}, 2500);
		}
	},
	setSubscriber: function (store) {
		if (store.
				getItem('businesswidget/repository_l9_common/common/viewmodel/contextTopics/OnePassTopicViewModel')) {
			var subscriber = JSON.parse(store.
				getItem('businesswidget/repository_l9_common/common/viewmodel/contextTopics/OnePassTopicViewModel')).
				mobileSubscriber;
			if (!subscriber) {
				return;
			}
			var callbackOptionArray = [];
			_.each(subscriber, function (data, index) {
				var obj = {
					title : data,
					value : data
				};
				if (index === 0) {
					obj.selected = true;
				}
				callbackOptionArray.push(obj);
			});
			this.set('faqPageContent.callback.options', callbackOptionArray);
		}

	},
	setIdle: function () {
		var haveInActiveOnce, hideForGood;
		var events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
		var self = this;

		function goInactive() {
			self.idleStatus = true;
			self.setTriggerIcon('virtual');
			haveInActiveOnce = true;
		}

		function startTimer () {
			self.timeoutID = window.setTimeout(goInactive, self.idleInterval * 1000);
		}

		function goActive () {
			if (haveInActiveOnce && !hideForGood) {
				window.setTimeout(function () {
					self.idleStatus = false;
					self.proactiveActive = true;
					self.setTriggerIcon('virtual');
				}, self.idleDelay * 1000);
				hideForGood = true;
			}
			if (!haveInActiveOnce) {
				startTimer();
			}
		}
		function resetTimer () {
		
			if (!self.openChatOnce) {
				window.clearTimeout(self.timeoutID);
				goActive();
			}
		}

		window.onload = startTimer();
		window.focus();
		events.forEach(function (name) {
			window.addEventListener(name, resetTimer);
		});
	},
	setTriggerIcon: function (state) {
		var self = this;
				if (state === 'virtual') {
			self.set('triggerIcons.image', self.get('triggerIcons.virtualChatImg'));
		}
		if (state === 'offline' || state === 'help') {
			self.set('triggerIcons.image', self.get('triggerIcons.helpImg'));
		} else if (state === 'busy' || state === 'online') {
			self.set('triggerIcons.image', self.get('triggerIcons.webChatImg'));
		}
		if (!this.proactiveChatEnable && state === 'virtual') {
		
			var hours  = moment(new Date()).hours();
			if (hours > 4 && hours < 12) {
				self.set('triggerIcons.popupImage', self.get('triggerIcons.virtualChatPopUpImageMorning'));
			} else if (hours >= 12 && hours <= 17) {
				self.set('triggerIcons.popupImage', self.get('triggerIcons.virtualChatPopUpImageAfternoon'));
			} else {
				self.set('triggerIcons.popupImage', self.get('triggerIcons.virtualChatPopUpImageEvening'));
			}
		} else if (state === 'virtual' && this.proactiveChatEnable) {
			self.set('triggerIcons.popupImage', self.get('triggerIcons.proactiveChatInvitationImage'));
		}
		if (state === 'busy' || state === 'online') {
			self.set('triggerIcons.popupImage', self.get('triggerIcons.webChatPopUpImage'));
		}
		if (this.proactiveActive) {
			self.set('triggerIcons.fadeoutPopUp', true);
			this.proactiveActive = false;
		} else if (state === 'virtual' && this.proactiveChatEnable && !this.idleStatus) {
			self.set('triggerIcons.hidePopUp', true);
		} else {
			self.set('triggerIcons.hidePopUp', false);
		}
		if (!this.proactiveChatEnable) {
			setTimeout(function () {
				self.set('triggerIcons.hidePopUp', true);
			}, self.get('triggerIcons.messageDuration'));
		}
	},
	resetSelection: function () {
		this.set('triggerIcons.enable', true);
		this.set('faqPageContent.topSectionData.chat.enable', false);
		this.set('faqPageContent.topSectionData.callback.enableCallback', false);
		this.set('faqPageContent.faq.enable', true);
	},
	suggestSurvey: function () {
		var surveyData = this.get('faqPageContent.virtualAgent.survey');

		this.set('surveyData', surveyData);
		if (!(this.storage.disableSurveyInSession === 'true' || this.storage.disableSurveyInSession === true)) {
			if (!this.storage.vaLastSurveyDismiss) {
				this.toggleModal('surveyModal', true);
			} else {
				var secondsSince = Math.round(((new Date()).getTime() - this.storage.vaLastSurveyDismiss) / 1000);
				var daysSince = Math.round(secondsSince / 60 / 60 / 24);
				if (daysSince > 30) {
					this.toggleModal('surveyModal', true);
				}
			}
		}

	},

	oncomplete: function () {

		this.chat = this.el.querySelector('.ux-faq');

		var action = this.storage.vaLastAction;

		if (action && action.length && action !== 'doChatClose') {

			this.fire(action);

			if (this.storage.vaPosX && this.storage.vaPosX.length) {
				this.chat.style.right = this.storage.vaPosX + 'px';
			}

			if (this.storage.vaPosY && this.storage.vaPosY.length) {
				this.chat.style.bottom = this.storage.vaPosY + 'px';
			}

			this.preventOutsideExpanding();

		} else if (this.get('virtualAgentChat.enable')) {
			this.fire('doChatOpen');
		}

	},

		preventOutsideExpanding: function () {
		this.chat = this.el.querySelector('.ux-faq');
		setTimeout(function () {
			var yMax = document.body.getBoundingClientRect().height - this.chat.getBoundingClientRect().height;
			if (parseInt(this.chat.style.bottom) > yMax) {
				this.chat.style.bottom = yMax + 'px';
			}
		}.bind(this), 100);
	},

	toggleModal: function (modalId, state) {

		var modals = this.findAllComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];

		modal.set('displayState', state);
		if (modalId === 'surveyModal' &&
			typeof this.event !== 'undefined' && this.event.component) {
			var href = this.event.component.get('href');
			if (href && href !== null && href !== '#') {
				window.open(
					href,
					'_blank'
				);
			}
		}
	},

		mapState: function (state) {
		if (state === 0) {
			return 'busy';
		}
		if (state === 1) {
			return 'online';
		}
		if (state === 2) {
			return 'offline';
		}
	},

	handleChatMoveAndResize: function () {
		var self = this;
		this.chat = this.el.querySelector('.ux-faq');
		var icon = this.el.querySelector('.pan.move');
		icon.classList.remove('disabled');

	
		var chatBounding;

	
		var xOrigin, yOrigin;
		var pointerXOrigin, pointerYOrigin;
		var containerBounding = document.body.getBoundingClientRect();

	

		var mc = new Hammer(icon);
		mc.get('pan').set({
			direction: Hammer.DIRECTION_ALL,
			threshold: 1
		});

		mc.on('panstart', function (event) {
			icon.classList.add('user-action');
		
			chatBounding = self.chat.getBoundingClientRect();
		
			xOrigin = containerBounding.right - chatBounding.right;
			yOrigin = chatBounding.bottom;

			pointerXOrigin = event.pointers[0].clientX;
			pointerYOrigin = event.pointers[0].clientY;

		

			this.xMin = 0;
			this.yMin = 0;
			this.xMax = containerBounding.width - chatBounding.width;
			this.yMax = containerBounding.height - chatBounding.height;

			return false;
		}.bind(this));

		mc.on('pan', function (event) {
			var newX = pointerXOrigin - event.pointers[0].clientX;
			var newY = pointerYOrigin - event.pointers[0].clientY;
			var moveX = false;
			var moveY = false;
			var px = xOrigin + newX;
			var py = newY;
			moveX = (px > 0 && px < this.xMax);
			moveY = (py > 0);
			if (moveX) {
				this.storage.vaPosX = px;
				this.chat.style.right = px + 'px';
			}
			if (moveY) {
				this.storage.vaPosY = py;
				this.chat.style.bottom = py + 'px';
			}
			return false;

		}.bind(this));

		mc.on('panmove panleft panright panup pandown', function (event) {

			var newX = pointerXOrigin - event.pointers[0].clientX;
			var newY = pointerYOrigin - event.pointers[0].clientY;
			var moveX = false;
			var moveY = false;
			var px = xOrigin + newX;
			var py = newY;
			moveX = (px > this.xMin && px < this.xMax);
			moveY = (py > this.yMin);
			if (moveX) {
				this.storage.vaPosX = px;
				this.chat.style.right = px + 'px';
			}
			if (moveY) {
				this.storage.vaPosY = py;
				this.chat.style.bottom = py + 'px';
			}
			return false;

		}.bind(this));
		mc.on('panend', function (event) {
			icon.classList.remove('user-action');
			return false;
		}.bind(this));

	},

	getCookieVal: function (offset) {
		var endstr = document.cookie.indexOf (';', offset);
		if (endstr === -1) {
			endstr = document.cookie.length;
		}
		return decodeURI(document.cookie.substring(offset, endstr));
	},

	getCookie: function (name) {
		var arg = name + '=';
		var alen = arg.length;
		var clen = document.cookie.length;
		var i = 0;
		while (i < clen) {
			var j = i + alen;
			if (document.cookie.substring(i, j) === arg) {
				return this.getCookieVal (j);
			}
			i = document.cookie.indexOf(' ', i) + 1;
			if (i === 0) {
				break;
			}
		}
		return null;
	},

	deleteCookie: function (name) {
		if (this.getCookie(name)) {
			document.cookie = name + '=;' +
				' expires=Thu, 01-Jan-70 00:00:01 GMT;' +
				' path=/;' +
				' domain=' + window.location.host + ';' +
				' secure=;';
		}
	},

	setCookie: function (name,value,expires,path,domain,secure) {
		document.cookie = name + '=' + encodeURI (value) +
			((expires) ? '; expires=' + expires.toGMTString() : '') +
			((path) ? '; path=' + path : '') +
			((domain) ? '; domain=' + domain : '') +
			((secure) ? '; secure' : '');
	}

});

Ractive.components["ux-faq-support"] = Ractive.extend({
	template: LUXComponentTemplates['ux-faq-support'],
	data: function () {
		return {
			viewMore: false,
			enabledViewMore: false,
			viewMoreLabel: 'View More',
			viewLessLabel: 'View Less',
			initialQuestions: 0
		};
	},
	oninit: function () {
		var enabledViewMore = this.get('enabledViewMore');
		var firstList;
		var secondList;
		if (enabledViewMore) {
			var initialQuestions = this.get('initialQuestions');
			var faqlist = this.get('faqlist');
			if (initialQuestions === 0 || initialQuestions >= faqlist.length) {
				firstList = faqlist;
			} else {
				firstList = faqlist.slice(0, initialQuestions);
				secondList = faqlist.slice(initialQuestions, faqlist.length);
			}
		} else {
			firstList = this.get('faqlist');
		}

		this.set('firstList', firstList);
		this.set('secondList', secondList);

		this.on('ux-anchor.viewMore', function (event) {
			this.set('viewMore', true);
		});

		this.on('ux-anchor.viewLess', function (event) {
			this.set('viewMore', false);
		});
	}
});

Ractive.components["ux-fibre-coverage-check"] = Ractive.extend({
	template: LUXComponentTemplates['ux-fibre-coverage-check'],

	data: function () {
		return {
			ConfigStrings: ConfigStrings
		};
	},

	onrender: function () {
		this.on('ux-address-form.getAddress', function (event) {
			this.fire('findAddress', this);
		});

		this.on('ux-button.checkFibreAvailability', function () {
			var isValid = this.findComponent('ux-address-form').validateFloorAndUnitNumber();
			if (isValid) {
				this.fire('checkServiceCoverage', this);
			}
		}.bind(this));

		this.on('ux-anchor.resetFormAddress', function () {
			this.fire('resetFibreAvailabilityForm', this);

		}.bind(this));

		this.on('ux-address-form.addressNotApplicable', function (flag) {
			this.set('enableFibreCheck', flag);
		});
	}
});

Ractive.components["ux-fibre-installation"] = Ractive.extend({
	template: LUXComponentTemplates['ux-fibre-installation'],
	onrender: function () {
		this.showDwfmCalendar();
	},

	formatDate: function (fullDate) {
		var finalDate;
		var dateTime = fullDate.split(' ');
		if (dateTime && dateTime.length > 1) {
			try {
				finalDate = moment(dateTime[0], 'DD/MM/YYYY').format('DD/MM/YYYY, ddd, ') +
					dateTime[1];
			} catch (err) {
				finalDate = fullDate;
			}
		} else {
			finalDate = fullDate;
		}
		return finalDate;
	},
	showDwfmCalendar: function () {
		var dwfmIframe = document.createElement('iframe');
		var manageAppointmentObject = this.get('manageAppointmentObject');
		var url = manageAppointmentObject.calendarURL;
		var index = url.indexOf('CalendarPopup');
		if (index  > -1) {
			url = '/dwfm/' + url.substring(index);
		} else {
			index = url.indexOf('vxfield');
			if (index  > -1) {
				url = '/' + url.substring(index);
			}
		}
		var installationStep = this.get('initData.installationStep');

	
		var calendarToHide = '';

		dwfmIframe.src = url;
		dwfmIframe.style.borderWidth = 0;
		dwfmIframe.style.overflow = 'hidden';
		dwfmIframe.style.width = '100%';
		dwfmIframe.style.height = '650px';
		dwfmIframe.scrolling = 'yes';

		if (installationStep === 'singtel') {
			calendarToHide = 'TDC6';
		} else if (installationStep === 'netlink') {
			calendarToHide = 'TDC1';
		}


		dwfmIframe.addEventListener('load', function (e) {

			var injectedScript = document.createElement('script');
			injectedScript.type = 'text/javascript';
			injectedScript.innerHTML =
				'try{document.getElementById("lblWorkRequestInformationHeader").innerHTML = "Singtel Installation";' +
				'$("body").delegate("#pnlCalander6 td div", "click",function(){' +
				'window.parent.window.postMessage("netlinkSelectedDate:="' +
				'+document.getElementById("lblcal6displaydate").innerHTML,"*");});' +
				'$("body").delegate("#pnlCalander td div", "click",function(){' +
				'window.parent.window.postMessage("singtelSelectedDate:="' +
				'+document.getElementById("lblcal1displaydate").innerHTML,"*");});}' +
				'catch(e){console.log("Something went wrong : ", e);}' +
				' var appointmentCheck = function() { ' +
				' var appointmentBooked = false; ' +
				' var lblResultSetReturnValue = document.getElementById("lblResultSetReturnValue"); ' +
				' if (lblResultSetReturnValue) {var innerText = lblResultSetReturnValue.innerText; if (!innerText) { ' +
				' innerText = lblResultSetReturnValue.textContent;}} ' +
				' if (innerText !== "" ) { ' +
				' var appt = eval("(" + innerText + ")"); ' +
				' window.parent.window.postMessage("singtelSelectedApt:="' +
				' +JSON.stringify(appt),"*");' +
				' } ' +
				' }; appointmentCheck ();';


		
			dwfmIframe.contentDocument.body.appendChild(injectedScript);

			var injectedStyle = document.createElement('style');
			injectedStyle.type = 'text/css';
			injectedStyle.innerHTML = 'body{background-color: transparent;}' +
				(calendarToHide !== '' ? '#' + calendarToHide + '{display:none;}' : '') +
				'#pnlscrollbar{overflow: auto !important;}' +
				'#divBottomPaging span,' +
				'#divBottomPaging td.legendSeasonal,' +
				'#divBottomPaging td.legendFull,' +
				'#divBottomPaging td.legendUnavailable,' +
				'#divBottomPaging td.style1' +
				'{display:none;}' +
				'table{margin: auto;}';

		
			dwfmIframe.contentDocument.head.appendChild(injectedStyle);

		}.bind(this), false);

		this.el.getElementsByClassName('dwfm-iframe-container')[0].appendChild(dwfmIframe);

		window.addEventListener('message', function (e) {
			var data = e.data.split(':=');
			if (data[0] === 'netlinkSelectedDate') {
				var fullDate = data[1];
				fullDate = this.formatDate(fullDate);
				this.set('initData.netLinkAppDate', fullDate);
			} else if (data[0] === 'singtelSelectedDate') {
				var fullDate = data[1];
				fullDate = this.formatDate(fullDate);
				this.set('initData.singtelAppDate', fullDate);
			} else if (data[0] === 'singtelSelectedApt') {
				var fullDate = data[1];
				fullDate = JSON.parse(fullDate);
				this.set('initData.singtelSelectedApt', fullDate);
				this.fire('initSingtelSelectedApt', fullDate);
			}
		}.bind(this), false);
	}
});

Ractive.components["ux-file-upload"] = Ractive.extend({
	template: LUXComponentTemplates['ux-file-upload'],

	initVariables: function () {
		var self = this;
	
		var id = self.get('uploadId');
		self.set('id', id ? id : 'uploadFile');

	},

	onrender: function (argument) {
		var self = this;
		self.initVariables();

		var id = self.get('id');
		$('#' + id).change(function (event) {
			self.fire('fileToUpload', event.target.files[0]);
		});
	}
});

Ractive.components["ux-filter-lable"] = Ractive.extend({
	template: LUXComponentTemplates['ux-filter-lable'],
	isolated: false,

	data: function () {
		return {
			showFilterLabel: true
		};
	},
	oninit: function () {
		var self = this;
		self.on('doClose', function (event,content) {
			self.set('showFilterLabel', false);
			this.fire('labelClosed', content);
		});
	}
});

Ractive.components["ux-filter-modal-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-filter-modal-singtel'],
	isolated: false,

	data: function () {
		return {
			isNotApplicable2: false,
			isNotApplicable3: false,
			validationFailed: false,
			maxInputClicked: false,
			minInputClicked: false,
			selectedBrandList: [],
			selectedDealList: [],
			selectedCategoriesList: [],
			selectedPaymentMethodList: [],
			selectedSortList: [],
			selectedPrice: []
		};
	},
	oninit: function () {
		var self = this;
		self.on('doCloseFilterModal', function (event) {
			var modalList = self.findAllComponents('ux-modal');
			var modal = _.find(modalList, function (modal) {
				return modal.get('modalId') === 'filterList';
			});
			modal.set('displayState', false);
			self.parent.set('showFilterModal', false);
		});

		self.on('doCloseSortModal', function (event) {
			var modalList = self.findAllComponents('ux-modal');
			var modal = _.find(modalList, function (modal) {
				return modal.get('modalId') === 'sortList';
			});
			modal.set('displayState', false);
			self.parent.set('showFilterModal', false);
		});

		self.on('*.doFilterClear', function (event) {
			self.set('selectedDealList', []);
			self.set('selectedCategoriesList', []);
			self.set('selectedBrandList', []);
			self.set('selectedPaymentMethodList', []);
			self.set('selectedPrice', []);
			var combinedFilterList = {};
			combinedFilterList.deals = self.get('selectedDealList');
			combinedFilterList.categories = self.get('selectedCategoriesList');
			combinedFilterList.brands = self.get('selectedBrandList');
			combinedFilterList.paymentMethod = self.get('selectedPaymentMethodList');
			combinedFilterList.sortBy = self.get('selectedSortList');
			combinedFilterList.price = self.get('selectedPrice');
			self.set('filterList', combinedFilterList);
			self.set('oldFilterList', combinedFilterList);
			self.set('onepassInfo.filters', combinedFilterList);
			var checkboxArray = self.findAllComponents('ux-checkbox');
			if (checkboxArray.length > 0) {
				_.each(checkboxArray, function (check, i) {
					check.set('checked', false);
				});
			}
			var minBox = this.find('#min-price');
			var maxBox = this.find('#max-price');
			if (minBox) {
				minBox.value = ' ';
			}
			if (maxBox) {
				maxBox.value = ' ';
			}
			self.applyFilter();
		});

		self.on('*.doSortClear', function (event) {
			self.set('selectedSortList', []);
			var combinedFilterList = {};
			combinedFilterList.deals = self.get('selectedDealList');
			combinedFilterList.categories = self.get('selectedCategoriesList');
			combinedFilterList.brands = self.get('selectedBrandList');
			combinedFilterList.paymentMethod = self.get('selectedPaymentMethodList');
			combinedFilterList.sortBy = self.get('selectedSortList');
			combinedFilterList.price = self.get('selectedPrice');
			self.set('filterList', combinedFilterList);
			self.set('oldFilterList', combinedFilterList);
			self.set('onepassInfo.filters', combinedFilterList);
			var checkboxArray = self.findAllComponents('ux-checkbox');
			if (checkboxArray.length > 0) {
				_.each(checkboxArray, function (check, i) {
					check.set('checked', false);
				});
			}
		});

		self.on('*.doApplyFilter', function (event) {
			self.applyFilter();
			var modalList = self.findAllComponents('ux-modal');
			_.each(modalList, function (modal) {
				modal.set('displayState', false);
				self.parent.set('showFilterModal', false);
			});
			this.fire('scrollToCatlog', null);
		});

		self.on('ux-input-box.validatePrice', function (event) {
			self.validatePrice();
		});

		self.on('ux-input-box.minInputClicked', function (event) {
			self.set('minInputClicked', true);
		});

		self.on('ux-input-box.maxInputClicked', function (event) {
			self.set('maxInputClicked', true);
		});

		self.on('ux-checkbox.onDealSelected', function (event) {
			var checkboxIndex = _.clone(event.index.i);
			var selectedDeals = _.clone(self.get('selectedDealList'));
			var tempDeals = this.get('initData');
			var deals = tempDeals.promoDeals;
			if (event.context.checked === true) {
				var filter = deals[checkboxIndex];
				filter.keypath = 'promoDeal';
				filter.id = event.context.id;
				filter.checkboxIndex = checkboxIndex;
				selectedDeals.push(filter);
			} else {
				selectedDeals = _.without(selectedDeals, deals[checkboxIndex]);
			}
			var selectedDealList = _.uniq(selectedDeals);
			self.set('selectedDealList', selectedDealList);
			self.set('onepassInfo.filters.deals', selectedDealList);
			if (self.get('isDesktopView')) {
				self.applyFilter();
			}
		});

		self.on('ux-checkbox.onBrandSelected', function (event) {
			var checkboxIndex = _.clone(event.index.i);
			var selectedBrands = _.clone(self.get('selectedBrandList'));
			var tempBrands = this.get('initData');
			var brands = tempBrands.brands;
			if (event.context.checked === true) {
				var filter = brands[checkboxIndex];
				filter.keypath = 'brand';
				filter.id = event.context.id;
				filter.checkboxIndex = checkboxIndex;
				selectedBrands.push(filter);
			} else {
				selectedBrands = _.without(selectedBrands, brands[checkboxIndex]);
			}
			var selectedBrandList = _.uniq(selectedBrands);
			self.set('selectedBrandList', selectedBrandList);
			self.set('onepassInfo.filters.brands', selectedBrandList);
			if (self.get('isDesktopView')) {
				self.applyFilter();
			}
		});

		self.on('ux-checkbox.onCategorySelected', function (event) {
			var checkboxIndex = _.clone(event.index.i);
			var selectedCategories = _.clone(self.get('selectedCategoriesList'));
			var tempCategories = this.get('initData');
			var categories = tempCategories.deals;
			if (event.context.checked === true) {
				var filter = categories[checkboxIndex];
				filter.keypath = 'deal';
				filter.id = event.context.id;
				filter.checkboxIndex = checkboxIndex;
				selectedCategories.push(filter);
			} else {
				selectedCategories = _.without(selectedCategories, categories[checkboxIndex]);
			}
			var selectedCategoriesList = _.uniq(selectedCategories);
			self.set('selectedCategoriesList', selectedCategoriesList);
			self.set('onepassInfo.filters.categories', selectedCategoriesList);
			if (self.get('isDesktopView')) {
				self.applyFilter();
			}
		});

		self.on('ux-checkbox.onPaymentMethodSelected', function (event) {
			var paymentMethodsList = [];
			if ((event.context.checked && !this.get('isDesktopView')) ||
			(this.get('isDesktopView') && this.get('isIppEnabled'))) {
				var paymentMethod = {
					keypath: 'PaymentMethods',
					id: event.context.id,
					checkboxIndex: 0,
					text: 'Singtel PayLater - 0% interest instalment payment plans'
				};
				if (this.get('isDesktopView')) {
					paymentMethod.ippEnabled = this.get('isIppEnabled');
				} else {
					paymentMethod.ippEnabled = event.context.checked;
				}
				paymentMethodsList.push(paymentMethod);
			}
			var selectedPaymentMethodList = _.uniq(paymentMethodsList);
			self.set('selectedPaymentMethodList', selectedPaymentMethodList);
			self.set('onepassInfo.filters.paymentMethod', selectedPaymentMethodList);
			if (self.get('isDesktopView')) {
				self.applyFilter();
			}
		});

		self.on('ux-checkbox.onSortSelected', function (event) {
			var checkboxIndex = _.clone(event.index.i);
			var selectedSort = [];
			var temdSort = this.get('initData');
			var sortList = temdSort.sortByList;
			if (event.context.checked === true) {
				var filter = sortList[checkboxIndex];
				filter.keypath = 'deal';
				filter.id = event.context.id;
				filter.checkboxIndex = checkboxIndex;
				filter.sortBy = filter.value;
				selectedSort.push(filter);
			} else {
				selectedSort = _.without(selectedSort, sortList[checkboxIndex]);
			}
			var checkboxArray = self.findAllComponents('ux-checkbox');
			_.each(checkboxArray, function (check, i) {
				check.set('checked', false);
				if (check.get('id') === event.context.id) {
					check.set('checked', true);
				}
			});
			var selectedSortList = _.uniq(selectedSort);
			self.set('selectedSortList', selectedSortList);
			self.set('onepassInfo.filters.sortBy', selectedSortList);
		});

		self.on('*.changeAccordion', function (event,accordionId) {
			if (self.get('onepassInfo.filters')) {
				self.set('selectedDealList', self.get('onepassInfo.filters.deals'));
				self.set('selectedCategoriesList', self.get('onepassInfo.filters.categories'));
				self.set('selectedBrandList', self.get('onepassInfo.filters.brands'));
				self.set('selectedPaymentMethodList', self.get('onepassInfo.filters.paymentMethod'));
				self.set('selectedSortList', self.get('onepassInfo.filters.sortBy'));
				self.set('selectedPrice', self.get('onepassInfo.filters.price'));
			}
			var id = event.get('id');
			var filterList = self.get('onepassInfo.filters');
			if (filterList) {
				var fil = filterList[id];
				var filKey = [];
				_.each(fil, function (f) {
					filKey.push(f.id);
				});
				var checkboxArray = self.findAllComponents('ux-checkbox');
				if (filKey.length > 0) {
					_.each(checkboxArray, function (check, i) {
						if (filKey.includes(check.get('id'))) {
							check.set('checked', true);
						} else {
							check.set('checked', false);
						}
					});
				}
				if (id === 'price') {
					var minBox = this.find('#min-price');
					var maxBox = this.find('#max-price');
					if (minBox && filterList && filterList.price.length > 0) {
						minBox.value = String(filterList.price[0].minValue);
					}
					if (maxBox && filterList && filterList.price.length > 0) {
						maxBox.value = String(filterList.price[0].maxValue);
					}

				}
			}
		});
	},
	oncomplete: function () {
		var isDesktopView = window.innerWidth >= 800 ? true : false;
		this.set('isDesktopView', isDesktopView);
		var isIppEnabled = RactiveHelpers.getParameterByName('isIppEnabled') || 'false';
		isIppEnabled = RactiveHelpers.stringToBoolean(isIppEnabled);
		if (this.get('isIppTermsEnabled')) {
			this.set('isIppEnabled', isIppEnabled);
		} else {
			this.set('isIppEnabled', false);
		}
	},
	applyFilter: function () {
		var self = this;
		if (!self.get('isDesktopView')) {
			self.validatePrice();
			self.parent.set('showFilterModal', false);
		}
		var combinedFilterList = {};
		combinedFilterList.deals = self.get('selectedDealList');
		combinedFilterList.categories = self.get('selectedCategoriesList');
		combinedFilterList.brands = self.get('selectedBrandList');
		combinedFilterList.paymentMethod = self.get('selectedPaymentMethodList');
		combinedFilterList.sortBy = self.get('selectedSortList');
		combinedFilterList.price = self.get('selectedPrice');

		self.parent.set('selectedDealList', self.get('selectedDealList'));
		self.parent.set('selectedCategoriesList', self.get('selectedCategoriesList'));
		self.parent.set('selectedBrandList', self.get('selectedBrandList'));
		self.parent.set('selectedPaymentMethodList', self.get('selectedPaymentMethodList'));
		self.parent.set('selectedSortList', self.get('selectedSortList'));
		self.parent.set('selectedPrice', self.get('selectedPrice'));
		self.parent.set('filterList', combinedFilterList);
		self.parent.set('oldFilterList', combinedFilterList);
		self.parent.set('onepassInfo.filters', combinedFilterList);
		this.fire('filterChanged', 'promoDeal', combinedFilterList);
		if (!self.get('isDesktopView')) {
			var modalList = self.findAllComponents('ux-modal');
			var filterModal = _.find(modalList, function (modal) {
				return modal.get('modalId') === 'filterList';
			});
			filterModal.set('displayState', false);
			var sortModal = _.find(modalList, function (modal) {
				return modal.get('modalId') === 'sortList';
			});
			sortModal.set('displayState', false);
		}
	},
	updateFilterValues: function (filterList) {
		var self = this;
		if (filterList) {
			self.set('selectedDealList', filterList.deals);
			self.set('selectedCategoriesList', filterList.categories);
			self.set('selectedBrandList', filterList.brands);
			self.set('selectedPaymentMethodList', filterList.paymentMethod);
			self.set('selectedSortList', filterList.sortBy);
			self.set('selectedPrice', filterList.price);
			self.set('onepassInfo.filters', filterList);
		}
	},
	validatePrice: function () {
		var min = this.find('#min-price') && this.find('#min-price').value;
		var max = this.find('#max-price') && this.find('#max-price').value;
		if (min && max) {
			var priceFilter = [];
			if (parseInt(min) > parseInt(max)) {
				this.set('validationFailed', true);
				this.set('selectedPrice', []);
			} else {
				this.set('validationFailed', false);
				var price = {
					keypath : 'price',
					id: 'price',
					minValue: min,
					maxValue: max
				};
				if (min && max) {
					priceFilter.push(price);
				}
				this.set('selectedPrice', priceFilter);
				if (this.get('isDesktopView')) {
					this.applyFilter();
				}
			}
		} else if (min && (!max || max === '') && this.get('isDesktopView')) {
			var priceFilter = [];
			this.set('validationFailed', false);
			var price = {
				keypath : 'price',
				id: 'price',
				minValue: min,
				maxValue: max
			};
			priceFilter.push(price);
			this.set('selectedPrice', priceFilter);
			this.applyFilter();
		} else if (max && (!min || min === '') && this.get('isDesktopView')) {
			var priceFilter = [];
			this.set('validationFailed', false);
			var price = {
				keypath : 'price',
				id: 'price',
				minValue: min,
				maxValue: max
			};
			priceFilter.push(price);
			this.set('selectedPrice', priceFilter);
			this.applyFilter();
		} else if (!max && !min && this.get('isDesktopView')) {
			var priceFilter = [];
			this.set('validationFailed', false);
			var price = {
				keypath : 'price',
				id: 'price',
				minValue: min,
				maxValue: max
			};
			priceFilter.push(price);
			this.set('selectedPrice', priceFilter);
			this.applyFilter();
		}
		this.set('maxInputClicked', false);
		this.set('minInputClicked', false);
	}
});

Ractive.components["ux-footer-links"] = Ractive.extend({
	template: LUXComponentTemplates['ux-footer-links'],
	isolated: true
});

Ractive.components["ux-footer-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-footer-singtel'],
	isolated: true
});

Ractive.components["ux-form-validity"] = Ractive.extend({
	template: LUXComponentTemplates['ux-form-validity']
});

Ractive.components["ux-formbuilder-form"] = Ractive.extend({
	template: LUXComponentTemplates['ux-formbuilder-form'],
	data: function () {
		return {
			formKey: null,
			apigeeToken: null,
			displayForm: false,
			loading: true,
			noOfTokenRetries: 0
		};
	},
	onrender: function () {
		var self = this;

	
		self.on('submitForm', function (event) {
			event.original.preventDefault();
			self.fire('blurHandler');

		
			if (self.isValidForm()) {
			
				self.disableEmptyFields();

				if (self.get('gReCaptchaSiteKey')) {
					window.grecaptcha.execute();
				} else {
					self.postCallForm();
				}
			}
		});
	},
	getToken: function (retry, callback) {
		var self = this;
		$.ajax({
			url: self.get('apigeeTokenEndPoint'),
			type: 'POST',
			data: { grant_type: 'client_credentials' },
			contentType: 'application/x-www-form-urlencoded',
			headers: { 'x-client-id': 'SPRINGD' },
			success: function (response, status) {
				sessionStorage.setItem('apigee_token', 'Bearer ' + response.access_token);

				if (retry && typeof callback === 'function') {
					callback();
				}
			}
		});
	},
	validateEkyc: function () {
		var self = this;
		const accessToken = sessionStorage.getItem('apigee_token');
		const refToken = RactiveHelpers.getQueryParamsObj('refToken');
		const sourceUrl = self.get('ekyc.sourceUrl');

		if (!refToken) {
			window.location.href = sourceUrl;
		}

		$.ajax({
			url: self.get('ekyc.validateApi'),
			type: 'POST',
			contentType: 'application/json',
			xhrFields: {
				withCredentials: true
			},
			headers: {
				Authorization: accessToken
			},
			data: JSON.stringify({ refToken: refToken }),
			success: function (response, status) {
				if (self.get('noOfTokenRetries') > 0) {
					self.set('noOfTokenRetries', self.get('noOfTokenRetries') + 1);
				}

				if (response.body) {
					if (response.body.status === 'OK' && response.body.result === 'VERIFIED') {
						self.set('displayForm', true);
						self.set('loading', false);
						return;
					} else if (response.body.result === 'FAILED' || response.body.result === 'EXPIRED') {
						self.resetForm();
						window.location.href = self.get('ekyc.sourceUrl');
					} else {
						sessionStorage.setItem('refId', response.body.referenceId);
						self.resetForm();
						window.location.href = self.get('ekyc.errorUrl');

					}
				} else {
					self.resetForm();
					window.location.href = self.get('ekyc.errorUrl');
				}
			},
			error: function (xhr, status, error) {
				const tries = self.get('noOfTokenRetries');
				if (xhr.status === 401 && tries < 3) {
					self.set('noOfTokenRetries', tries + 1);
					self.getToken(true, self.validateEkyc.bind(self));
				} else {
					const errorUrl = self.get('ekyc.errorUrl');
					if (errorUrl) {
						window.location.href = errorUrl;
					}
				}
			}
		});
	},
	disableSubmitBtn: function () {
		var self = this,
		formId = self.get('formName'),
		formId = '#' + formId;

		$(formId).find(':submit').prop('disabled', true);
		$('body').css('cursor', 'progress');

		return;
	},
	enableSubmitBtn: function () {
		var self = this,
			formId = self.get('formName'),
			formId = '#' + formId;

		$(formId).find(':submit').prop('disabled', false);
		$('body').css('cursor', 'default');
		return;
	},
	disableEmptyFields: function () {
		var self = this;

	
		_.each(self.findAllComponents('ux-formbuilder-panel'), function (panel) {
		
			if (panel.get('status') === 'inactive') {
			
				_.each(panel.findAll('input'), function (item) {
					item.disabled = true;
				});

			
				_.each(panel.findAll('select'), function (item) {
					item.disabled = true;
				});

			
				_.each(panel.findAll('textarea'), function (item) {
					item.disabled = true;
				});
			}
		});
	},
	enableAllFields: function () {
		var self = this;

		_.each(self.findAllComponents('ux-formbuilder-panel'), function (panel) {
		
			if (panel.get('status') === 'inactive') {
			
				_.each(panel.findAll('input'), function (item) {
					item.disabled = false;
				});

			
				_.each(panel.findAll('select'), function (item) {
					item.disabled = false;
				});

			
				_.each(panel.findAll('textarea'), function (item) {
					item.disabled = false;
				});

			}
		});
	},
	oninit: function () {
		var self = this;
		self.set('formErrorMsg.status', null);
		self.set('formErrorMsg.message', null);
		const isAuthor = window.location.host.includes('author');
		const formRequireEkyc = self.get('ekyc.required') && !isAuthor;

		if (formRequireEkyc) {
			self.validateEkyc();
		} else {
			self.set('displayForm', true);
			self.set('loading', false);
		}

		if (self.get('gReCaptchaSiteKey')) {
			this.disableSubmitBtn();
			this.injectReCaptcha();
		}
	},
	resetForm: function () {
		var self = this;
		var formId = self.get('formName');
		document.getElementById(formId).reset();
		sessionStorage.removeItem('form-campaignId');
	},
	isValidForm: function () {
		var self = this;
		var formFields;
		var formFieldsInputbox = self.findAllComponents('ux-formbuilder-input-box');

	
		var formFieldsCheckbox = self.findAllComponents('ux-formbuilder-input-checkbox');

	
		var formFieldsDropdown = self.findAllComponents('ux-formbuilder-input-dropdown');

	
		var formFieldsRadio = self.findAllComponents('ux-formbuilder-input-radio');

	
		var formFieldsTextarea = self.findAllComponents('ux-formbuilder-input-textarea');

	
		var formFieldsPromo = self.findAllComponents('ux-formbuilder-input-promo');

	
		var formFieldsUpload = self.findAllComponents('ux-formbuilder-upload-document');

	
		formFields = formFieldsInputbox.concat(
			formFieldsCheckbox,
			formFieldsDropdown,
			formFieldsRadio,
			formFieldsTextarea,
			formFieldsPromo,
			formFieldsUpload
		);

		var invalidFormFields = _.filter(formFields, function (formField) {
			return !formField.validate();
		}).length;

		return invalidFormFields === 0;
	},
	redirectToSuccessPage: function (formData) {
		var self = this;
	
		self.resetForm();
		self.enableAllFields();
		self.enableSubmitBtn();

	
		if (self.get('customSuccessUrl')) {
			var newUrl = self.parameterizeData(self.get('customParamList'), formData);
			window.location.replace(self.get('successUrl') + '?' + newUrl);
		} else {
			window.location.replace(self.get('successUrl'));
		}
	},
	setDefaultErrorMessage: function () {
		var self = this;
		self.set('formErrorMsg.status', 'error');
		self.set('formErrorMsg.message', self.get('failureMessage'));
		if (self.get('gReCaptchaSiteKey')) {
			window.grecaptcha.reset();
		}
		self.enableSubmitBtn();
	},
	safeParse: function (str) {
		try {
			return JSON.parse(str);
		} catch (e) {
			return null;
		}
	},
	submitEkyc: function () {
		var self = this;
		const accessToken = sessionStorage.getItem('apigee_token');
		const refToken = RactiveHelpers.getQueryParamsObj('refToken');
		var formDataEkyc = _.reduce(self.getFormData(), function (acc, field) {
			acc[field.name] = field.value;
			return acc;
		}, {});

		if (!formDataEkyc || _.isEmpty(formDataEkyc)) {
			return;
		} else {
			self.disableSubmitBtn();
			formDataEkyc.recaptchaResponse = self.get('recaptchaResponse');
			const campaignDetails = sessionStorage.getItem('form-campaignId');
			if (campaignDetails && self.safeParse(campaignDetails)) {
				const val = self.safeParse(campaignDetails);
				formDataEkyc[val.key] = val.value;
			}

			$.ajax({
			url: self.get('ekyc.submitApi'),
			type: 'POST',
			contentType: 'application/json',
			xhrFields: {
				withCredentials: true
			},
			headers: {
				Authorization: accessToken
			},
			data: JSON.stringify({ formData: formDataEkyc, refToken: refToken }),
			success: function (response, status) {
				self.enableSubmitBtn();
				if (response.body && response.body.status === 'OK') {
					self.resetForm();
					self.redirectToSuccessPage(formDataEkyc);
				} else {
					self.setDefaultErrorMessage();
				}
			},
			error: function () {
				self.enableSubmitBtn();
				self.setDefaultErrorMessage();
			}
		});
		}
	},
	postCallForm: function () {
		var self = this,
		apigeeTokenAjaxCall,
		tokenAjaxCall,
		submitAjaxCall,
		formData = {},
		isBcc = (self.get('type') === 'bcc'),
		recaptchaResponse = self.get('recaptchaResponse');

		if (apigeeTokenAjaxCall) {
			apigeeTokenAjaxCall.abort();
		}

		if (tokenAjaxCall) {
			tokenAjaxCall.abort();
		}

		if (submitAjaxCall) {
			submitAjaxCall.abort();
		}

		if (self.get('ekyc.required')) {
			self.submitEkyc();
			return;
		}

		if (isBcc) {
			apigeeTokenAjaxCall = $.ajax({
				url: self.get('apigeeTokenEndPoint'),
				type: 'POST',
				data: { grant_type: 'client_credentials' },
				contentType: 'application/x-www-form-urlencoded',
				headers: { 'x-client-id': 'SPRINGD' }
			});

			apigeeTokenAjaxCall.done (function (apigeeTokenReponse) {
				if (apigeeTokenReponse.status === 'approved') {
					self.set('apigeeToken', apigeeTokenReponse.access_token);

					tokenAjaxCall = $.ajax({
						url: self.get('tokenEndPoint'),
						type: 'POST',
						data: JSON.stringify({ captchaResponse: recaptchaResponse }),
						contentType: 'application/json',
						headers: {
							Authorization: 'Bearer ' + apigeeTokenReponse.access_token
						},
						processData: false
					});

					tokenAjaxCall.done(function (tokenResponse) {
						if (tokenResponse.body.status === 'OK') {
							self.set('formKey', tokenResponse.body.result);
							formData = _.reduce(self.getFormData(), function (acc, field) {
								acc[field.name] = field.value;
								return acc;
							}, {});
							if (!formData || _.isEmpty(formData)) {
								return;
							} else {
								formData.caseType = self.get('caseType');
								self.disableSubmitBtn();

								var requestData = {
									formData: formData,
									formKey: tokenResponse.body.result
								};

								submitAjaxCall = $.ajax({
									url: self.get('action'),
									data: JSON.stringify(requestData),
									type: self.get('method'),
									contentType: 'application/json',
									headers: {
										Authorization: 'Bearer ' + apigeeTokenReponse.access_token
									},
									processData: false
								});

								submitAjaxCall.done(function (data, status, jqXHR) {
									if (status === 'success' && data.body.status === 'OK') {
									
										self.resetForm();
										self.enableAllFields();
										self.enableSubmitBtn();

									
										if (self.get('customSuccessUrl')) {
											var newUrl = self.parameterizeData(self.get('customParamList'), formData);
											window.location.replace(self.get('successUrl') + '?' + newUrl);
										} else {
											window.location.replace(self.get('successUrl'));
										}
									} else {
										self.set('formErrorMsg.status', 'error');
																				var referenceId = data.body.referenceId ? data.body.referenceId : '';

										if (data.body.errorCode === 'ERR_EFORM_010') {
											var technicalFailure = _.find(self.get('bccSubmitFailureMessage'), function (msg) {
												return msg.type === 'technical';
											});
											if (technicalFailure) {
												self.set('formErrorMsg.message', technicalFailure.message + referenceId);
											}
										} else if (data.body.errorCode === 'ERR_EFORM_011') {
											var businessFailure = _.find(self.get('bccSubmitFailureMessage'), function (msg) {
												return msg.type === 'business';
											});
											if (businessFailure) {
												self.set('formErrorMsg.message', businessFailure.message);
											}
										} else {
											self.set('formErrorMsg.message', self.get('failureMessage'));
										}
										if (self.get('gReCaptchaSiteKey')) {
											window.grecaptcha.reset();
										}
										self.enableSubmitBtn();
																			}
								});

								submitAjaxCall.fail(function (jqXHR, status) {
									if (status === 'error') {
										self.set('formErrorMsg.status', 'error');
										self.set('formErrorMsg.message', self.get('failureMessage'));
										if (self.get('gReCaptchaSiteKey')) {
											window.grecaptcha.reset();
										}
										self.enableSubmitBtn();
									}
								});
							}
						} else {
							self.set('formErrorMsg.status', 'error');
							self.set('formErrorMsg.message', self.get('failureMessage'));
							if (self.get('gReCaptchaSiteKey')) {
								window.grecaptcha.reset();
							}
							self.enableSubmitBtn();
						}
					});

					tokenAjaxCall.fail(function (jqXHR, status) {
						self.set('formErrorMsg.status', 'error');
						self.set('formErrorMsg.message', self.get('failureMessage'));
						if (self.get('gReCaptchaSiteKey')) {
							window.grecaptcha.reset();
						}
						self.enableSubmitBtn();
					});
				} else {
					self.set('formErrorMsg.status', 'error');
					self.set('formErrorMsg.message', self.get('failureMessage'));
					if (self.get('gReCaptchaSiteKey')) {
						window.grecaptcha.reset();
					}
					self.enableSubmitBtn();
				}

			});

			apigeeTokenAjaxCall.fail (function (jqXHR, status) {
				self.set('formErrorMsg.status', 'error');
				self.set('formErrorMsg.message', self.get('failureMessage'));
				if (self.get('gReCaptchaSiteKey')) {
					window.grecaptcha.reset();
				}
				self.enableSubmitBtn();
			});
		} else {
			formData = self.getFormData();

			if (!formData || _.isEmpty(formData)) {
				return;
			} else {
				self.disableSubmitBtn();

			
				submitAjaxCall = $.ajax({
					url: self.get('action'),
					data: formData,
					type: self.get('method')
				});

			
				submitAjaxCall.done(function (data, status, q) {
					if (status === 'success') {
					
						self.resetForm();
						self.enableAllFields();
						self.enableSubmitBtn();

					
						if (self.get('customSuccessUrl')) {
							var newUrl = self.parameterizeData(self.get('customParamList'), formData);
							window.location.replace(self.get('successUrl') + '?' + newUrl);
						} else {
							window.location.replace(self.get('successUrl'));
						}
					}
				});

			
				submitAjaxCall.fail(function (jqXHR, status) {
					if (status === 'error') {
					
						self.set('formErrorMsg.status', 'error');
						self.set('formErrorMsg.message', self.get('failureMessage'));
						if (self.get('gReCaptchaSiteKey')) {
							window.grecaptcha.reset();
						}
						self.enableSubmitBtn();
					}
				});
			}
		}

		return;
	},
	getFormData: function () {
		var self = this,
		formId = self.get('formName'),
		formData = {};

	
		formId = '#' + formId;
		formData = $(formId).serializeArray();

		var uploadendpoint = self.get('uploadEndPoint');
		var enableUploadDocument = self.get('enableUploadDocument');

	
		if (enableUploadDocument && uploadendpoint !== null && uploadendpoint !== '') {
			formData = self.uploadDocument(uploadendpoint, formId, formData);
		}
		return formData;
	},
	injectReCaptcha: function () {
		var self = this;

		window.onRecaptchaSubmit = function (reCaptchaResponse) {
			self.set('recaptchaResponse', reCaptchaResponse);
			self.postCallForm();
		}.bind(this);

		window.onloadCallback = function () {
			this.enableSubmitBtn();
		}.bind(this);

		const script = document.createElement('script');

		script.async = true;
		script.defer = true;
		script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback';

		if (document.head) {
			document.head.appendChild(script);
		}
	},
	uploadDocument: function (uploadendpoint, formId, formData) {
		var self = this;
		var uploadcomponents = self.findAllComponents('ux-formbuilder-upload-document');
		var ajaxcall;
		var formKey = self.get('formKey');
		var apigeeToken = self.get('apigeeToken');

		$.each(uploadcomponents, function (k, ucomponent) {
			$.each(ucomponent.get('uploadedFileList'), function (i, file) {
				var fn = file.fileName;
				var fi = file.fileId;
				var fieldname = file.fieldName;
				var uploadFormData = new FormData();
				var doc = 'image' + (i + 1);

				uploadFormData.append('file', file.file);
				if (formKey) {
					uploadFormData.append('token', formKey);
					uploadFormData.append('client', 'eform');
				} else {
					uploadFormData.append('token', fi ? fi : 'defaultToken-' + fn);
					uploadFormData.append('type', doc);
				}

				if (ajaxcall) {
					ajaxcall.abort();
				}

				ajaxcall = $.ajax({
					url: uploadendpoint,
					data: uploadFormData,
					cache: false,
					async: false,
					contentType: false,
					headers: apigeeToken ? { Authorization: 'Bearer ' + apigeeToken } : {},
					processData: false,
					method: 'POST',
					type: 'POST'
				});

			
				ajaxcall.done(function (data, status, q) {
					if (status === 'success' && data.result !== 'FAILURE') {
					
						if (formKey === null) {
							formData.push({
								name: fieldname ? fieldname : 'remark',
								value: data.name
							});
						}
					} else {
					
						self.set('formErrorMsg.status', 'error');
						if (data.result === 'FAILURE' && self.get('bccUploadFailureMessage')) {
							self.set('formErrorMsg.message', self.get('bccUploadFailureMessage'));
						} else {
							self.set('formErrorMsg.message', self.get('failureMessage'));
						}
						if (self.get('gReCaptchaSiteKey')) {
							window.grecaptcha.reset();
						}
						self.enableSubmitBtn();
						formData = null;
						return;
					}
				});

				ajaxcall.fail(function () {
				
					var uploadErrorMsg = self.get('uploadFailureMessage');
					self.set('formErrorMsg.status', 'error');
					self.set('formErrorMsg.message', uploadErrorMsg ? uploadErrorMsg : self.get('failureMessage'));
					if (self.get('gReCaptchaSiteKey')) {
						window.grecaptcha.reset();
					}
					self.enableSubmitBtn();
					formData = null;
					return;
				});
			});
		});
		return formData;
	},
		parameterizeData: function (paramList, formData) {
		var formParamField = paramList,
				newStr = '',
				fieldName = '',
				matchedVal = '';
	
		_.each(formParamField, function (item, key) {
			fieldName = _.filter(formData, function (obj) {
				return obj.name === item.mappedField;
			});
		
			newStr += item.parameter + '=';
		
			if (fieldName) {
				_.each(fieldName, function (subItem, index) {
					matchedVal = subItem.value ? subItem.value : '';
					newStr += matchedVal + (index < fieldName.length - 1 ? ',' : '');
				});
			} else {
				newStr = '';
			}
			newStr += key < formParamField.length - 1 ? '&' : '';
		});

	
		return newStr;
	}
});

Ractive.components["ux-formbuilder-input-box"] = Ractive.extend({
	template: LUXComponentTemplates['ux-formbuilder-input-box'],
	data: function () {
		return {
			RactiveValidate: RactiveValidate
		};
	},
	validate: function () {
		var self = this;
		var validateObj = new RactiveValidate(self, {
			value: self.get('validationObj')
		});

	
		if (self.findParent('ux-formbuilder-panel') !== null) {
			var status = self.findParent('ux-formbuilder-panel').get('status');
			if (status === 'inactive') {
			
				self.set('valueErrorMsg', null);
				return true;
			}
		}

	
		var isRequired = self.get('validationObj.required');
		var val = self.get('value');

	
		if (isRequired === undefined && val === '') {
			self.set('valueErrorMsg', null);
			return true;
		} else {
		
			if (self.get('validationType.type') === 'custom') {
				validateObj.patterns.customValidation = self.get('regExpObj');
			}

			validateObj.keypath = function (keypath) {
				return keypath;
			};

			validateObj.cwd = '';
			return validateObj.validate().valid;
		}

	},
	onconfig: function () {
		var self = this;

		if (self.get('validation')) {
		
			self.setValidation();

		
			self.on('formBuilderValidation', function () {
				self.validate();
			});
		}
	},
	setValidation: function () {
		var self = this;

		self.set('validationObj', self.get('validation'));
		self.set('validationType', self.get('validationObj.validationType'));

		var validationObj = self.get('validationObj');
		var rule = self.get('validationType.rule');
		var message = self.get('validationType.message');

	
		switch (self.get('validationType.type')) {
			case 'predefined':
				validationObj[rule] = message;
				break;
			case 'custom':
			
				var regExpObj = new RegExp(rule, 'i');
				self.set('regExpObj', regExpObj);
			
				validationObj.customValidation = message;
				break;
			default:
				break;
		}

	
		this.update('validationObj');

	
		delete validationObj.validationType;
	},
	onrender: function () {
		var self = this;
		self.on('togglePasswordVisibility', function () {
			var input = self.find('input[type="password"], input[type="text"]');
			var showIcon = self.find('.show-icon');
			var hideIcon = self.find('.hide-icon');

			if (input.type === 'password') {
				input.type = 'text';
				showIcon.style.display = 'none';
				hideIcon.style.display = 'block';
			} else {
				input.type = 'password';
				showIcon.style.display = 'block';
				hideIcon.style.display = 'none';
			}
		});
	}
});

Ractive.components["ux-formbuilder-input-checkbox"] = Ractive.extend({
	template: LUXComponentTemplates['ux-formbuilder-input-checkbox'],
	data: function () {
		return {
			RactiveValidate: RactiveValidate
		};
	},
	validate: function () {
		var self = this,
		validateObj = {},
		rule = self.get('validation') ? self.get('validation') : {};

	
		if (self.findParent('ux-formbuilder-panel') !== null) {
			var status = self.findParent('ux-formbuilder-panel').get('status');
			if (status === 'inactive') {
			
				self.set('valueErrorMsg', null);
				return true;
			}
		}

	
		if (rule.ischecked !== undefined) {
			var validateObj = new RactiveValidate(self, {
				value: rule
			});

			validateObj.keypath = function (keypath) {
				return keypath;
			};

			validateObj.cwd = '';

			return validateObj.validate().valid;
		}

		return true;
	},
	oninit: function () {
		var self = this;

	
		if (!self.get('value')) {
			self.set('value', false);
		}

	
		this.on('blurHandler', function () {
			self.setValue();
			self.validate();
		});

	
		if (self.get('urlPreselect')) {
			var checkBoxName = self.get('name');
			var preselectBoxValue = RactiveHelpers.getURLParameter(checkBoxName);
			var items = self.get('item');
			_.each(items, function (item, key) {
				if (item.value === preselectBoxValue) {
					self.set('item[' + key + '].selected', true);
				}
			});
		}

	},
	onrender: function () {
		var self = this;
		self.setValue();
	},
	setValue: function () {
		var self = this;
		var checkBoxName = self.get('name');
		var checkedBoxes = $('input[name="' + checkBoxName + '"]:checked');

		if (checkedBoxes.length > 0) {
			self.set('value', true);
		} else {
			self.set('value', false);
		}
	}
});

Ractive.components["ux-formbuilder-input-dropdown"] = Ractive.extend({
	template: LUXComponentTemplates['ux-formbuilder-input-dropdown'],
	data: function () {
		return {
			RactiveValidate: RactiveValidate
		};
	},
	validate: function () {
		var self = this;
		var validateObj = new RactiveValidate(self, {
			value: self.get('validation')
		});

	
		if (self.findParent('ux-formbuilder-panel') !== null) {
			var status = self.findParent('ux-formbuilder-panel').get('status');
			if (status === 'inactive') {
			
				self.set('valueErrorMsg', null);
				return true;
			}
		}

		validateObj.keypath = function (keypath) {
			return keypath;
		};

		validateObj.cwd = '';

		return validateObj.validate().valid;
	},
	onrender: function () {
		var self = this;
		self.set('selectedTitle', '');
		self.set('selectedClass', '');

		self.observe('selected_value', function (newValue) {

			if (typeof newValue !== 'undefined' && self.get('options')) {
				var selectedOption = _.find(self.get('options'), function (option) {
					return (typeof option !== 'undefined') ? option.value === newValue : false;
				});
			
				if (newValue === '') {
					self.set('selectedClass', 'placeholder');
				} else {
					self.set('selectedClass', '');
					self.set('value', selectedOption);
				}

				if (selectedOption && selectedOption.title) {
					self.set('selectedTitle', selectedOption.title);
				} else {
					self.set('selectedTitle', newValue);
				}

				self.root.fire('panelFire', self.get('name'), self.get('value'));

			} else {
				self.set('selectedTitle', newValue || '');
			}

		}.bind(self));
	},
	onconfig: function () {
		var self = this;
		var fieldName = self.get('name');

		self.on('blurHandler', function () {
			self.validate();
		});

		self.on('onChange', function (event) {
			var selectedIndex = event.original.target.selectedIndex;
			var selectedOptionData;
			var selectedOptionValue;

			if (selectedIndex > 0) {
				selectedOptionData = self.get('options.' + selectedIndex);
			} else {
				selectedOptionData = null;
			}

		
			selectedOptionValue = (selectedOptionData) ? selectedOptionData.value : null;
			self.root.fire('panelFire', fieldName, selectedOptionValue);

		
			self.set('value', selectedOptionData);
		});
	}
});

Ractive.components["ux-formbuilder-input-promo"] = Ractive.extend({
	template: LUXComponentTemplates['ux-formbuilder-input-promo'],
	data: function () {
		return {
			RactiveValidate: RactiveValidate
		};
	},
	oninit: function () {
		var self = this;

	
		self.on('onBlurHandler', function () {
			var code = self.get('value');

		
			code = code.toUpperCase();
			self.set('value', code);

		
			self.validate();
		});
	},
	validatePromoCode: function () {
		var self = this;
		var defaultMsg = null;
		var successMsg = self.get('successMsg');
		var errorMsg = self.get('errorMsg');
		var promoCode = self.get('value');
		var codes = self.get('codes');
		var encryptedCode;

	
		if (self.findParent('ux-formbuilder-panel') !== null) {
			var status = self.findParent('ux-formbuilder-panel').get('status');
			if (status === 'inactive') {
			
				self.set('valueErrorMsg', null);
				return true;
			}
		}

	
		if (promoCode === '') {
			self.set('valueErrorMsg', null);
			self.set({
				'defaultMsg': null,
				'backText': null
			});
			return true;
		}

	
		promoCode = promoCode.toUpperCase();
		encryptedCode = btoa(promoCode);

	
		for (var key in codes) {
			if (codes.hasOwnProperty(key)) {
			
				if (codes[key].code === encryptedCode) {
					self.set('valueErrorMsg', null);
					self.set('frontText', codes[key].frontText);
					self.set('backText', codes[key].backText);

				
					if (successMsg) {
						defaultMsg = successMsg;
					} else if (codes[key].frontText) {
						defaultMsg = codes[key].frontText;
					}

					self.set('defaultMsg', defaultMsg);
					return true;
				}
			}
		}

	
		self.set({
			'valueErrorMsg.message': errorMsg,
			'valueErrorMsg.status': 'error'
		});

		self.set({
			'defaultMsg': null,
			'backText': null
		});

		return false;
	},
	validate: function () {
		var self = this;
		var code = self.get('value');
	
		var validateObj = new RactiveValidate(self, {
			value: self.get('validation')
		});

	
		if (self.findParent('ux-formbuilder-panel') !== null) {
			var status = self.findParent('ux-formbuilder-panel').get('status');
			if (status === 'inactive') {
			
				self.set('valueErrorMsg', null);
				return true;
			}
		}

		validateObj.keypath = function (keypath) {
			return keypath;
		};

		validateObj.cwd = '';

	
		if (code !== '') {
			if (!self.validatePromoCode(code)) {
				return false;
			}
		}

		return validateObj.validate().valid;
	}
});

Ractive.components["ux-formbuilder-input-radio"] = Ractive.extend({
	template: LUXComponentTemplates['ux-formbuilder-input-radio'],
	data: function () {
		return {
			RactiveValidate: RactiveValidate
		};
	},
	validate: function () {
		var self = this,
		validateObj = {},
		rule = self.get('validation') ? self.get('validation') : {};

	
		if (self.findParent('ux-formbuilder-panel') !== null) {
			var status = self.findParent('ux-formbuilder-panel').get('status');
			if (status === 'inactive') {
			
				self.set('valueErrorMsg', null);
				return true;
			}
		}

	
		if (rule.ischecked !== undefined) {
			var validateObj = new RactiveValidate(self, {
				value: rule
			});

			validateObj.keypath = function (keypath) {
				return keypath;
			};

			validateObj.cwd = '';

			return validateObj.validate().valid;
		}

		return true;
	},
	oninit: function () {
		var self = this;

	
		if (!self.get('value')) {
			self.set('value', false);
		}

	
		self.on('blurHandler', function () {
			self.processValue();
			self.validate();
		});
	},
	onrender: function () {
		var self = this;
		self.processValue();
	},
	processValue: function () {
		var self = this;
		var radioBtnName = self.get('name');
		var radioBtns = $('input[name="' + radioBtnName + '"]:checked');

	
		if (radioBtns.length > 0) {
			self.set('value', true);
		} else {
			self.set('value', false);
		}

	
		self.root.fire('panelFire', radioBtnName, radioBtns.val());
	}
});

Ractive.components["ux-formbuilder-input-textarea"] = Ractive.extend({
	template: LUXComponentTemplates['ux-formbuilder-input-textarea'],
	data: function () {
		return {
			RactiveValidate: RactiveValidate
		};
	},
	validate: function () {
		var self = this;
		var validateObj = new RactiveValidate(self, {
			value: self.get('validation')
		});

	
		if (self.findParent('ux-formbuilder-panel') !== null) {
			var status = self.findParent('ux-formbuilder-panel').get('status');
			if (status === 'inactive') {
			
				self.set('valueErrorMsg', null);
				return true;
			}
		}


		validateObj.keypath = function (keypath) {
			return keypath;
		};

		validateObj.cwd = '';

		return validateObj.validate().valid;
	},
	onconfig: function () {
		var self = this;

		if (self.get('validation')) {
		
			self.on('blurHandler', function () {
				self.validate();
			});
		}
	}
});

Ractive.components["ux-formbuilder-panel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-formbuilder-panel'],
	oninit: function (options) {
		var self = this;
		var listenTo = self.get('listenTo');
		var listenToValue = self.get('listenToValue');
		var action = self.get('action');

	
		self.componentCheck();
		self.processAction(action);

	
		self.root.on('panelFire', function (fieldName, data) {
			self.processEvent(
				fieldName,
				data,
				listenTo,
				listenToValue,
				action
			);
		});
	},
	processEvent: function (
		fieldName,
		fieldValue,
		listenTo,
		listenToValue,
		action) {

		var self = this;
		var actionEvent;

	
		if (fieldName === listenTo) {
			if (fieldValue === listenToValue) {
				actionEvent = action;
			} else {
				actionEvent = (action === 'visible') ? 'hidden' : 'visible';
			}
		}

		self.processAction(actionEvent);
	},
	processAction: function (action) {
		var self = this;

		switch (action) {
			case 'visible':
				self.showPanel();
				break;
			case 'hidden':
				self.hidePanel();
				break;
			default:
				break;
		}
	},
	showPanel: function () {
		var self = this;
		var panel = self.find('.ux-formbuilder-panel');
		self.set('status', 'active');
		$(panel).show(200);
	},
	hidePanel: function () {
		var self = this;
		var panel = self.find('.ux-formbuilder-panel');
		self.set('status', 'inactive');
		$(panel).hide(200);
	},
	componentCheck: function () {
		var self = this;

		try {
			if (!self.get('listenTo')) {
				throw new Error ('listenTo is null or undefined');
			}

			if (!self.get('listenToValue')) {
				throw new Error ('listenToValue is null or undefined');
			}

			if (!self.get('action')) {
				throw new Error ('action is null or undefined');
			}
		} catch (err) {
			console.error('[Formbuilder][Panel] ' + err.message);
		}
	}
});

Ractive.components["ux-formbuilder-parameters"] = Ractive.extend({
	template: LUXComponentTemplates['ux-formbuilder-parameters'],

	oninit: function () {
		var self = this;
		self.set('value', '');
	},

	onrender: function () {

		var self = this;
		var parameters = this.get('parameterModelList');
		var valueStr = '';

		for (var t = 0; t < parameters.length; t++) {

			var paraStr = '';

			if (parameters[t].paraCode !== null && RactiveHelpers.getParameterByName(parameters[t].paraCode) !== '') {

				paraStr = parameters[t].paraCode + ' : ' + RactiveHelpers.getParameterByName(parameters[t].paraCode);
				valueStr = paraStr + ', ' + valueStr;

			}

		}

		self.set('value', valueStr);

	}
});

Ractive.components["ux-formbuilder-upload-document"] = Ractive.extend({
	template: LUXComponentTemplates['ux-formbuilder-upload-document'],
	data: function () {
		return {
			RactiveValidate: RactiveValidate,
			uploadedDocuments: null,
			uploadedFileList: [],
			previewImage: {
				fileId: '',
				fileName: '',
				fileContent: ''
			},
			disableUpload: false
		};
	},
	validate: function () {
		var self = this;
		self.set('valueErrorMsg', null);

	
		if (self.findParent('ux-formbuilder-panel') !== null) {
			var status = self.findParent('ux-formbuilder-panel').get('status');
			if (status === 'inactive') {
			
				self.set('valueErrorMsg', null);
				self.set('uploadedFileList', []);
				return true;
			}
		}

	
		var isRequired = self.get('validation.required');
	
		if (isRequired === undefined) {
			self.set('valueErrorMsg', null);
			return true;
		} else {
			var uploadedFileList = this.get('uploadedFileList');
			if (uploadedFileList === null || uploadedFileList.length === 0) {
				self.set('valueErrorMsg.message', isRequired);
				self.set('valueErrorMsg.status', 'error');
				return false;
			}
			var minFileUpload = this.get('minFileUpload') ? this.get('minFileUpload') : 1;
			var minFileMetError = this.get('minFileMetError');
			if (uploadedFileList !== null && uploadedFileList.length < minFileUpload) {
				self.set('valueErrorMsg.message', minFileMetError ? minFileMetError : isRequired);
				self.set('valueErrorMsg.status', 'error');
				return false;
			}
			return true;
		}
	},

	generateFileId: function () {
		var fileId = this.get('id') ? this.get('id') : 'id';
		var genId = fileId + '-' + Math.random().toString(36).substr(2, 16);
		return genId;
	},

	fileUpload: function (file) {
		this.set('isFileInValid', false);
		this.set('isMaxFileSizeExcedeed', false);
		this.set('valueErrorMsg', null);

		if (!this.isFileMatch(file)) {
			this.set('isFileInValid', true);
			return false;
		}
		if (file.size > this.get('maxFileSize')) {
			this.set('isMaxFileSizeExcedeed', true);
			return false;
		}

		var uploadedFileList = this.get('uploadedFileList');
		var fieldName = this.get('name');

		uploadedFileList.push(
			{
				'fileId': this.generateFileId(),
				'fieldName': fieldName,
				'fileName': file.name,
				'fileType': file.type,
				'file': file
			});
		this.set('uploadedFileList', uploadedFileList);

		var maxFileUpload = this.get('maxFileUpload') ? this.get('maxFileUpload') : 3;
		if (uploadedFileList !== null && uploadedFileList.length === maxFileUpload) {
			this.set('disableUpload', 'disabled');
		}
	},
	removeImagePath: function (removeId) {
		this.set('disableUpload', '');
		var uploadedFileList = this.get('uploadedFileList');
		var newlist = _.filter(uploadedFileList, function (uploadedFile) {
			return uploadedFile.fileId !== removeId;
		});
		this.find('input[type="file"]').value = null;
		this.set('uploadedFileList', newlist);
	},
	isFileMatch: function (fileToUpload) {
		var validFileTypes = this.get('fileTypes');
		var isFileTypeValid = _.filter(validFileTypes,  function (obj) {
			return fileToUpload.type.match(obj);
		});
		if (isFileTypeValid && isFileTypeValid.length > 0) {
			isFileTypeValid = true;
		} else {
			isFileTypeValid = false;
		}
		return isFileTypeValid;
	},

	readURL: function (fileId) {
		var self = this;
		var uploadedFileList = self.get('uploadedFileList');
		var uploadId = self.get('id');

		var previewFile = _.filter(uploadedFileList, function (uploadedFile) {
			return uploadedFile.fileId === fileId;
		});

		if (previewFile !== null && previewFile.length > 0) {
			self.set('previewImage.fileName', previewFile[0].fileName);
			self.getBase64(previewFile[0].file);
			self.handleModal(true, 'showImageInfo-' + uploadId);
		}
	},

	getBase64: function (file) {
		var self = this;
		var reader = new FileReader();

		reader.onload = function () {
			self.set('previewImage.fileContent', reader.result);
		};
		reader.onerror = function (error) {
			console.log('Error: ', error);
		};
		reader.readAsDataURL(file);
	},

	handleModal: function (visibility, modalId) {
		if (visibility) {
			this.set('hideModal', true);
		}
		var modals = this.parent.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];
		modal.set('displayState', visibility);
	},

	onrender: function (argument) {
		var self = this;
		var uploadId = self.get('id');

		self.on('*.fileToUpload', function (file) {
			if (file) {
				self.set('isFileInValid', false);
				self.fileUpload(file);
			}
		});

		self.on('*.removeUploadedImage', function (evt, removeId) {
			self.set('isMaxFileSizeExcedeed', false);
			self.set('isFileInValid', false);
			self.removeImagePath(removeId);
		});

		self.on('*.showUploadedImage', function (evt, fileId) {
			evt.event.original.preventDefault();
			self.set('previewImage.fileId', fileId);
			self.readURL(fileId);
		});

		$('#' + uploadId).click(function (event) {
			var uploadedFileList = self.get('uploadedFileList');
			if (uploadedFileList === null || uploadedFileList.length === 0) {
				event.target.value = null;
			}
		});
	}
});

Ractive.components["ux-freeGifts-error"] = Ractive.extend({
	template: LUXComponentTemplates['ux-freeGifts-error'],
	isolated : true,
	data : function () {
		return {
			ConfigStrings : ConfigStrings
		};
	},
	onrender: function () {
	}
});

Ractive.components["ux-fs-appointment-breadcrumb"] = Ractive.extend({
	template: LUXComponentTemplates['ux-fs-appointment-breadcrumb'],
	isolated: true,
	data: function () {
		return {
			'RactiveHelpers': RactiveHelpers
		};
	}
});

Ractive.components["ux-fullwidth-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-fullwidth-banner'],
	isolated: true,
	data: function () {
		return {
			moment: moment,
			RactiveHelpers: RactiveHelpers
		};
	},

	oninit: function () {
		var self = this;
		var backgroundImage = self.get('backgroundImage.mobile.src') || self.get('backgroundImage.desktop.src');
		self.set('backgroundImgDesktop', self.get('backgroundImage.desktop.src'));
		self.set('backgroundImgDesktopExtraClass', self.get('backgroundImage.desktop.imagePosition'));
		self.set('backgroundImgDesktopSize', self.get('backgroundImage.desktop.imageSize'));
		self.set('backgroundImgMobile', backgroundImage);
		self.set('backgroundImgMobileExtraClass',
			self.get('backgroundImage.mobile.imagePosition') || self.get('backgroundImage.desktop.imagePosition'));
		self.set('backgroundImgMobileSize',
			self.get('backgroundImage.mobile.imageSize') || self.get('backgroundImage.desktop.imageSize'));

		self.set('foregroundImgDesktopPosition', self.get('foregroundImg.desktop.imagePosition'));
		self.set('foregroundImgDesktopSize', self.get('foregroundImg.desktop.imageSize'));
		self.set('foregroundImgMobilePosition',
			self.get('foregroundImg.mobile.imagePosition') || self.get('foregroundImg.desktop.imagePosition'));
		self.set('foregroundImgMobileSize',
			self.get('foregroundImg.mobile.imageSize') || self.get('foregroundImg.desktop.imageSize'));
		self.set('toDisplayBanner', true);
	},

	onrender: function () {
		var self = this;

		self.on('navigateToURL', function (event, linkURL) {
			this.fire('doNavigate', linkURL);
		});

		self.on('*.launchDownloadApp', function (event) {
			var os = RactiveHelpers.getMobileOperatingSystem();
			if (os === 'android') {
				if (window.location && window.location.href) {
					window.location.href = self.get('appsmodel.android.link');
				}
			}
			if (os === 'ios') {
				if (window.location && window.location.href) {
					window.location.href = self.get('appsmodel.ios.link');
				}
			}
			if (os === 'windows') {
				if (window.location && window.location.href) {
					window.location.href = self.get('appsmodel.android.link');
				}
			}
			if (os === 'undefined') {
				console.error('unsupported device');
			}
		});

		self.set('getHideStatus', function (status) {
			var map = {
				'mobile': 'hide-for-small-only',
				'mobile-tablet': 'show-for-large-up',
				'tablet': 'hide-for-medium-only',
				'tablet-desktop': 'show-for-small-only',
				'desktop': 'hide-for-large-up',
				'mobile-desktop': 'show-for-medium-only'
			};
			return map[status];
		});

		self.set('getContentStatusOnHide', function (status) {
			var map = {
				'mobile': 'content-height',
				'mobile-tablet': 'medium-12 content-height',
				'tablet': 'medium-12 content-height',
				'tablet-desktop': 'medium-12 large-12',
				'desktop': 'large-12',
				'mobile-desktop': 'medium-12'
			};
			return map[status];
		});

		self.on('ux-button.navigateToPath', function (event) {
			var linkURL = event.get('linkto');
			if (self.get('openNewWindow') === 'true' || self.get('openNewWindow') === true) {
				window.open(linkURL, '_blank');
			} else {
				window.open(linkURL, '_self');
			}
		});

		self.set('videoURL', ConfigStrings.videoProviderHost.youtube + self.get('videoId') + '?autoplay=1');

		self.on('displayVideo', function () {
			self.toggleModal('singleFullScreenVideo', true);
		}.bind(self));

		self.set('toDisplayBanner', self.getDisplayOption());
	},

	getDisplayOption: function () {
		var self = this;
		var startDateTime = self.get('startDateTime');
		var endDateTime = self.get('endDateTime');

		var timestart = typeof startDateTime !== 'undefined' ? moment(startDateTime) : null;
		var timeend = typeof endDateTime !== 'undefined' ? moment(endDateTime) : null;
		var option = false;

		if (timestart !== null && timeend !== null) {
			option = moment().isBetween(timestart, timeend, null, '[]');
		} else if (timestart !== null && timeend === null) {
			option = moment().isSameAfter(timestart);
		} else if (timestart === null && timeend !== null) {
			option = moment().isSameOrBefore(timeend);
		} else {
			option = true;
		}
		return option;
	},

	toggleModal: function (modalId, state) {
		var modals = this.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];
		modal.set('displayState', state);
	}
});

Ractive.components["ux-generic-sub"] = Ractive.extend({
	template: LUXComponentTemplates['ux-generic-sub']
});

Ractive.components["ux-generic-table"] = Ractive.extend({
	template: LUXComponentTemplates['ux-generic-table']
});

Ractive.components["ux-get-new-number"] = Ractive.extend({
	template: LUXComponentTemplates['ux-get-new-number'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},

	oninit: function (argument) {
		var self = this;
		var numPhonesShowFirst = this.get('numToShowFirst') || 20;
		var numberOfResources = self.get('numberOfResources') || 40;
		this.set('widgetId', this.get('id'));
		if (Number(numPhonesShowFirst) < Number(numberOfResources)) {
			self.set('hideShowMoreButton', 'false');
		} else {
			numPhonesShowFirst = numberOfResources;
		}
		var numbersToShow = self.get('selectNumber.receivedNumberList').slice(0, numPhonesShowFirst);
		numbersToShow = numbersToShow.map(function (phoneNo) {
			return {
				phoneNo: phoneNo,
				active: false
			};
		});

		self.observe('selectNumber.receivedNumberList', function (receivedNumberList) {
			if (receivedNumberList && receivedNumberList.length > 0) {
				var numPhonesShowFirst = this.get('numToShowFirst') || 20;
				var numberOfResources = self.get('numberOfResources') || 40;
				if (Number(numPhonesShowFirst) < Number(numberOfResources)) {
					self.set('hideShowMoreButton', 'false');
				} else {
					numPhonesShowFirst = numberOfResources;
				}
				var numbersToShow = receivedNumberList.slice(0, numPhonesShowFirst);
				numbersToShow = numbersToShow.map(function (phoneNo) {
					return {
						phoneNo: phoneNo,
						active: false
					};
				});
				this.set('numbersToShow', numbersToShow);
			}
		});

		self.set('numbersToShow', numbersToShow);

		self.on('ux-button.showAll', function (event) {
			self.handleShowMoreClick(self);
		});

		self.on('ux-anchor.showAll', function (event) {
			self.handleShowMoreClick(self);
		});

		self.on('selectedNumber', function (event, index) {
			var status = !self.get('numbersToShow[' + index + '].active');
			var existingNumbers = self.get('existingNumbers');
			_.each(existingNumbers, function (existingNumber) {
				existingNumber.getExistingNumberState = '';
			});
			self.set('existingNumbers', existingNumbers);
			self.set('numbersToShow.*.active', false);
			self.set('numbersToShow[' + index + '].active', status);

			var element = document.getElementById('scroll-wrapper');
			if (typeof element !== 'undefined' && element !== null) {
				setTimeout(function () {
					element.scrollIntoView({block: 'start', behavior: 'smooth'});
				}, 300);
			}
			self.fire('doNumberSelect', event.context.phoneNo);
		});
	},

	handleShowMoreClick: function (self) {
		var numberOfResources = self.get('numberOfResources') || 40;
		var allNumbers = self.get('selectNumber.receivedNumberList').slice(0, numberOfResources);
		allNumbers = allNumbers.map(function (phoneNo) {
			return {
				phoneNo: phoneNo,
				active: false
			};
		});

		self.set('numbersToShow', allNumbers);
		self.set('hideShowMoreButton', 'true');
	}
});

Ractive.components["ux-google-search"] = Ractive.extend({
	template: LUXComponentTemplates['ux-google-search'],

	oncomplete: function () {
		require([
			'//www.google.com/jsapi'
		], function () {

			google.load('search', '1', {
				callback: function () {
					var customSearchOptions = {};
					var customSearchControl = new google.search.CustomSearchControl($('#gcsId').val(),
						customSearchOptions);

					customSearchControl.setResultSetSize(google.search.Search.FILTERED_CSE_RESULTSET);
					customSearchControl.draw('cse');

					function parseParamsFromUrl() {
						var params = {};
						var parts = window.location.search.substr(1).split('\x26');
						for (var i = 0; i < parts.length; i++) {
							var keyValuePair = parts[i].split('=');
							var key = decodeURIComponent(keyValuePair[0]);
							params[key] = keyValuePair[1] ?
								decodeURIComponent(keyValuePair[1].replace(/\+/g, ' ')) :
								keyValuePair[1];
						}
						return params;
					}

					var urlParams = parseParamsFromUrl();
					var queryParamName = 'rinput';
					if (urlParams[queryParamName]) {
						customSearchControl.execute(urlParams[queryParamName]);
					}
				},
				language: 'en'
			});


		});
	}
});

Ractive.components["ux-guest-form"] = Ractive.extend({
	template: LUXComponentTemplates['ux-guest-form'],

	data: function () {
		return {
			RactiveValidate: RactiveValidate
		};
	},

	validateGuestIDNumber: function () {
	
		this.validation.validate();
		this.set('onInitRetrieveAddressDisabled', false);
	},

	onrender: function () {

		this.validation = new RactiveValidate(this, {
			'guestIdNumber': {
				required: 'The guest ID number cannot be empty',
				minlength: {
					param: 8,
					message: 'Please enter a minimum of 8 characters'
				},
				maxlength: {
					param: 8,
					message: 'Please enter a maximum of 8 characters'
				},
				alpha_numeric: 'Please enter a valid ID'
			}
		});

		this.on('onBlurGuestId', function (event) {
			this.validateGuestIDNumber();
		}.bind(this));

		this.on('ux-button.retrieveAddress', function () {
			this.retrieveAddress();
		}.bind(this));

	}
});

Ractive.components["ux-header-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-header-singtel'],
	isolated: true,

	transitions: {
		fly: ractiveTransitionsFly
	},

	data: function () {
		return {
			setFourthLevelMenu: false,
			mobileMenuListFourthLevel: null,
			subDisplayFlag: false,
			display: false,
			subMenuObject: null,
			showShoppingNum: false,
			anonymousUser: null
		};
	},

	getLoginStatus: function (isUserLogin, isAnonymouse) {
		var self = this;
		return RactiveHelpers.checkLoginStatus(self).then (
			function (response) {
				self.set(isUserLogin, response.isLoggedIn);
				self.set(isAnonymouse, !(response.isLoggedIn));
			}
		);
	},

	toggleModel: function (modal_id, state) {
		var self = this;
		var modalList = self.findAllComponents('ux-modal');
		var modal = _.find(modalList, function (modal) {
			return modal.get('modalId') === modal_id;
		});
		modal.set('displayState', state);
	},

	insertParam: function (key, value, url)	{
		key = encodeURI(key);
		value = encodeURI(value);
		var kvp = url.substr(1).split('&');
		var index = kvp.length;
		var x;
		while (index--) {
			x = kvp[index].split('=');
			if (x[0] === key) {
				x[1] = value;
				kvp[index] = x.join('=');
				break;
			}
		}

		if (index < 0) {
			kvp[kvp.length] = [key,value].join('=');
		}

		return kvp.join('&');
	},
	setScrollStylingConsent : function () {
		var cookieConsentHeight = $('.consent-banner-singtel').outerHeight();
		var openAppConsentHeight = $('.consent-banner-singtel-open-app').outerHeight();
		var consentHeight = cookieConsentHeight + openAppConsentHeight;
		if (cookieConsentHeight > 0) {
			$('.component-container.widget-initialized.luxComponentsWidget').first()
			.css('margin-top', cookieConsentHeight);
		}
		if (consentHeight > 0) {
			$('.consentbanner-location').css('margin-top', consentHeight);
		}
	},
	setHeaderDisplay : function (ractive) {
				window.addEventListener('scroll', function (e) {
			var cookieConsentHeight = $('.consent-banner-singtel').outerHeight();
			var openAppConsentHeight = $('.consent-banner-singtel-open-app').outerHeight();
			var consentHeight = cookieConsentHeight + openAppConsentHeight;
		
			if ((this.openAppHide === false || this.openAppHide === undefined) && consentHeight > 0 && openAppConsentHeight > 0 && window.pageYOffset > 0) {
				$('.consentbanner-location').css('margin-top', consentHeight - openAppConsentHeight);
				this.openAppHide = true;
			}
			if (this.openAppHide === true && consentHeight > 0 && openAppConsentHeight > 0 && window.pageYOffset === 0) {
				$('.consentbanner-location').css('margin-top', consentHeight);
				this.openAppHide = false;
			}
			if (consentHeight === 0) {
				if (this.oldScroll > window.pageYOffset || window.pageYOffset < 120) {
					if (ractive.get('hideBanner')) {
						ractive.set('hideBanner', false);
					}
				} else {
					if (!ractive.get('hideBanner')) {
						ractive.set('hideBanner', true);
					}
				}
				Ractive.defaults.fire('showTvHeader', ractive.get('hideBanner'));
				this.oldScroll = window.pageYOffset;
			}
		});
			},
	onrender: function () {
		var self = this;
		var redirectSamePage = self.get('redirectSamePage');
		var loginButtonUrl = self.get('loginButtonUrl');
		if (redirectSamePage) {
			var delimiter = '?';
			if (loginButtonUrl.indexOf('?') > -1) {
				delimiter = '&';
			}
			var currentUrl = window.location.href;
			if (currentUrl.indexOf('?') > -1) {
				currentUrl = currentUrl + '&redirectSamePage=1';
			} else {
				currentUrl = currentUrl + '?redirectSamePage=1';
			}
			loginButtonUrl = loginButtonUrl + delimiter +
				'targetUrl=' + currentUrl;
		}
		self.set('finalLoginUrl', loginButtonUrl);
	},
	setIsNotTablet: function () {
		var tabletReg = new RegExp('(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)' +
		'(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))');
		var isTablet = tabletReg.test(navigator.userAgent.toLowerCase());
		this.set('isNotTablet', !isTablet && $(window).width() >= 1280);
	},
	oncomplete: function () {
		this.setScrollStylingConsent();
		if ('onorientationchange' in window) {
			window.addEventListener('orientationchange', this.setIsNotTablet.bind(this), false);
		}
	},
	oninit: function () {
		var self = this;
		this.loginPromise = self.getLoginStatus('isUserLogin', 'anonymousUser');
		var links = self.get('links') || [];
		links.push(ConfigStrings.headerLogoutOption);
		var headerOptions = {
			headerType : 'image',
			className : 'headerDropdown',
			data : {
				links : links,
				imagesrc : ''
			}
		};
		self.setHeaderDisplay(self);
		self.set('headerOptions', headerOptions);
		self.set('currentPath', location.pathname);

		self.set('hide', false);
		self.set('hidePlaceHolder', false);
		self.set('relativePosition', false);
		var checkout = window.checkout;
		if (checkout) {
			self.set('checkout', checkout);
		}

		var homePage = window.homePage;
		if (homePage) {
			self.set('homePage', homePage);
		}

		self.set('singtelHeaderVerisignImgPath', ConfigStrings.singtelHeaderVerisignImgPath);
		self.set('singtelHeaderVerisignImgAlt', ConfigStrings.singtelHeaderVerisignImgAlt);
		self.set('singtelHeaderCheckoutText', ConfigStrings.singtelHeaderCheckoutText);

		self.setIsNotTablet();

		var domain = self.get('domain');
		self.set('domain', domain);

		var contextPath = window.location.pathname.substring(0, window.location.pathname.indexOf('/', 2));
		if (contextPath === '/mcss' || contextPath === '/mcss_nuovo') {
			self.set('hideCart', true);
		} else {
			self.set('hideCart', false);
		}

		self.applyDomain(self, domain);

		this.observe('domain', function (value) {
			self.applyDomain(self, value);
		});

		self.on('ux-icon.doOpenMenu', function (event) {
			self.set('display', true);
		});
		self.on('ux-anchor.doOpenMenu', function (event) {
			self.set('display', true);
		});

		self.on('ux-icon.redirectToLogin', function (event) {
			var redirectSamePage = self.get('redirectSamePage');
			var loginButtonUrl = self.get('loginButtonUrl');
			var targetUrl = null;
			if (redirectSamePage) {
				var currentUrl = window.location.href;
				if (currentUrl.indexOf('?') > -1) {
					currentUrl = currentUrl + '&redirectSamePage=1';
				} else {
					currentUrl = currentUrl + '?redirectSamePage=1';
				}
				targetUrl = currentUrl;
			}
			RactiveHelpers.redirectUiamLoginPage(loginButtonUrl, targetUrl, this);
		});

		self.on('doCloseMenu', function (event) {
			self.set('display', false);
		});

		self.on('ux-anchor.openMobileSub', function (event) {
			var subDisplay = {
				subMenuTitle: event.event.context.subMenuData.menuSectionTitle.title,
				subMenuLink: event.event.context.subMenuData.menuSectionTitle.src,
				subMenuContext: event.event.context.subMenuData.menuList
			};
			self.set('subMenuObject', subDisplay);
			setTimeout(function () {
				self.set('subDisplayFlag', true);
				self.set('display', false);
			}, 100);
		});

		self.on('ux-accordionitem.changeAccordion', function (component) {
			var accordions = self.findAllComponents('ux-accordionitem');
			_.each(accordions, function (item) {
				if (item._guid !== component._guid) {
					item.set('active', false);
				}
			});
			var headerListData = component.get('headerListData');
			if (headerListData) {
				var hdList = {
					hdsubMenu: headerListData.subMenu,
					hdLinkData: headerListData.linkItem.src
				};
				if ((!hdList.hdsubMenu ||
					hdList.hdsubMenu.length === 0) && hdList.hdLinkData) {
					setTimeout(function () {
						window.location.href = hdList.hdLinkData;
					}, 100);
				}
			}
		});

		self.on('doCloseSubMenu', function (event) {
			self.set('display', true);
			self.set('subMenuObject', null);
			self.set('subDisplayFlag', false);
		});

		self.on('doCloseAllMenu', function (event) {
			self.set('display', false);
			self.set('subMenuObject', null);
			self.set('subDisplayFlag', false);
		});
		Ractive.defaults.on('setRppIppShoppingCartRedirectUrls', function (data) {
			if (data) {
				ConfigStrings.RRP.pages.ippShoppingCartUrl = data.rrpIppShoppingCartUrl;
				ConfigStrings.RRP.pages.ShoppingCartUrl = data.rrpShoppingCartUrl;
			}
		});
		Ractive.defaults.on('headerCartItems', function (value) {
			if (value && value.cartHeader) {
				self.set('cartHeader', value.cartHeader);
				self.set('orderActionHeader', value.orderActionHeader);
				if (self.get('eshopMigrateFlag') === true) {
					self.set('showShoppingNum', true);
				} else {
					var switchValue = RactiveHelpers.getCookie('HTTP_ENV_VERSION');
					if (switchValue && switchValue !== '1')  {
						self.set('showShoppingNum', true);
					}
				}
				self.set('shoppingItemNum', value.cartHeader.productsCounter);
				var cart = value.cartHeader.cartId;
				if (cart) {
					var url = RactiveHelpers.modifyConfigUrl(ConfigStrings.pageUrls.shoppingCartUrl) +
						'?' + 'orderid=' + cart + '&order=' + cart.substring(0, cart.length - 1) +
						'&customerid=' + value.cartHeader.customerId +
						'&hash=' + value.cartHeader.hashCode;
					self.set('shoppingItemLink', url);
				}
			}
		});

		$(document).on('allWidgetsInitialized.lux', function () {
			self.setScrollStylingConsent();
		});

		document.addEventListener('DOMContentLoaded', function () {
			self.setScrollStylingConsent();
		}, false);
				Ractive.defaults.on('hideHeader', function (value) {
			self.set('hide', true);
		});
		Ractive.defaults.on('hideHeaderPlaceHolder', function (value) {
			self.set('hidePlaceHolder', true);
		});
		Ractive.defaults.on('showHeader', function (value) {
			self.set('hide', false);
		});

		Ractive.defaults.on('setHeaderRelative', function (value) {
			self.set('relativePosition', true);
			self.set('hidePlaceHolder', true);
		});

		self.on('*.doLogout', function () {
			self.fire('lux_logout');
		});
		self.on('*.displayLoggedInOption', function (event) {
			self.set('displayLoggedInOption', true);
			console.log('displayLoggedInOption');

		});
						self.on('onMenuItemClick', function (event) {
			if (window.location.href.indexOf('/personal/products-services/mobile/accessories') !== -1) {
				var RRPOrderContextTopic = JSON.parse(RactiveHelpers.getHomeLineContext('businesswidget/' +
				'repository_l9_common/common/viewmodel/rrp/RRPOrderContextTopic'));
				event.original.preventDefault();
				this.set('rrpEshopHeader', 'Leaving this Page?');
				this.set('rrpEshopMsg', 'This will clear you current progress and Shopping Cart');
				var link = event.context.src;
				this.set('redirectedURLToEshop', link);
			
				if ((link.indexOf('/personal/products-services/mobile/accessories') === -1 &&
					link.indexOf('/personal/products-services/devices-and-gadgets') === -1) &&
					RRPOrderContextTopic && RRPOrderContextTopic.rrpOrderId && RRPOrderContextTopic.rrpOrderId !== '') {
					this.toggleModel('eshopModal', true);
				} else {
					var isClearContext = link.indexOf('/personal/products-services/mobile/accessories') === -1 &&
										link.indexOf('/personal/products-services/devices-and-gadgets') === -1;
					this.redirectToEshopURL(isClearContext);
				}
			}
		});
		self.on('onLinkClick', function (event) {
			if (window.location.href.indexOf('/personal/products-services/mobile/accessories') !== -1) {
				var RRPOrderContextTopic = JSON.parse(RactiveHelpers.getHomeLineContext('businesswidget/' +
				'repository_l9_common/common/viewmodel/rrp/RRPOrderContextTopic'));
				event.original.preventDefault();
				this.set('rrpEshopHeader', 'Leaving this Page?');
				this.set('rrpEshopMsg', 'This will clear you current progress and Shopping Cart');
				var link = event.context.linkItem.src;
				this.set('redirectedURLToEshop', link);
			
				if ((link.indexOf('/personal/products-services/mobile/accessories') === -1 &&
					link.indexOf('/personal/products-services/devices-and-gadgets') === -1) &&
					RRPOrderContextTopic && RRPOrderContextTopic.rrpOrderId && RRPOrderContextTopic.rrpOrderId !== '') {
					this.toggleModel('eshopModal', true);
				} else {
					var isClearContext = link.indexOf('/personal/products-services/mobile/accessories') === -1 &&
										link.indexOf('/personal/products-services/devices-and-gadgets') === -1;
					this.redirectToEshopURL(isClearContext);
				}
			} else if (event.context.linkItem.src
				.indexOf('personal/my-account/orders-appointments/book-an-appointment') !== -1) {
			
				event.original.preventDefault();
				RactiveHelpers.checkLoginStatus(self).then(function (response) {
					if (response.isLoggedIn) {
						window.location.href = event.context.linkItem.src;
					} else {
						window.location.href = self.get('qnomyAnonymousUrl');
					}
					console.log('Login rest successful');
					console.log(response);
				}, function () {
					window.location.href = self.get('qnomyAnonymousUrl');
				});
			}
		});
		self.on('*.doRedirectModalToEshopURL', function (e) {
			RactiveHelpers.clearContextForRRP();
			Ractive.defaults.fire('cancelRRPOrder', this.get('redirectedURLToEshop'));
		});
		self.on('*.doCancelRedirection', function (e) {
			this.toggleModel('eshopModal', false);
		});
		self.on('doOpenCart', function (event) {
			if (window.location.href.indexOf('/personal/products-services/mobile/accessories') !== -1) {
				if (RactiveHelpers.isIppPlan()) {
					Ractive.defaults.fire('redirectCacheApiIPP', self);
				} else {
					Ractive.defaults.fire('redirectCacheApi', self);
				}
			} else if (self.get('portable') === true) {
				var contextPath = window.location.pathname.substring(0, window.location.pathname.indexOf('/', 2));
				if (contextPath === '/easymobile') {
					window.location.href = 'https://www.singtel.com/easymobile/phones-plans/summary.html';
				} else {
					this.navigateToShopPage();
				}
			} else {
				var switchValue = RactiveHelpers.getCookie('HTTP_ENV_VERSION');
				if ((self.get('eshopMigrateFlag') === true) || (switchValue && switchValue !== '1'))  {
					var shoppingItemNum = self.get('shoppingItemNum');
					if (shoppingItemNum && shoppingItemNum > 0) {
						var orderActionHeaders = self.get('orderActionHeader');
						if (orderActionHeaders && orderActionHeaders.length > 0) {
							var shoppingItemList = [];
							_.each (orderActionHeaders, function (orderActionHeader) {
								if (orderActionHeader.lineOfBusiness === 'BB') {
									shoppingItemList.push({title: 'Fibre Broadband'});
								} else if (orderActionHeader.lineOfBusiness === 'WS') {
									shoppingItemList.push({title: 'Singtel Mobile/Mobile BroadBand'});
								} else if (orderActionHeader.lineOfBusiness === 'TV') {
									shoppingItemList.push({title: 'Singtel TV'});
								}
							});
							self.set('shoppingItemList', shoppingItemList);
						}
						self.set('displayCart', true);
						self.toggleModel('itemcart', true);
					} else {
						this.navigateToShopPage();
					}
				} else {
					var isShoppingCartPage = _.find(window.RactiveWidgets, function (widget) {
						return widget.id === 'shoppingCartSingtel';
					});
					if (!isShoppingCartPage && !self.get('isUserLogin')) {
						var deferred = $.Deferred();
						self.clearOrderinContextAndRedirect(deferred);
						deferred.then(function () {
							self.navigateToShopPage();
						}.bind(self));
					} else {
						self.navigateToShopPage();
					}
				}
			}
		});

		self.on('doCloseCart', function (event) {
			self.set('displayCart', false);
		});

		self.on('*.doCheckout', function (event) {
			var shoppingItemLink = self.get('shoppingItemLink');
			if (shoppingItemLink) {
				var cartHeader = self.set('cartHeader');
				if (cartHeader.cartId) {
					shoppingItemLink = self.insertParam('orderid', cartHeader.cartId, shoppingItemLink);
				}
				if (cartHeader.hashCode) {
					shoppingItemLink = self.insertParam('hash', cartHeader.hashCode, shoppingItemLink);
				}
				if (cartHeader.customerId) {
					shoppingItemLink = self.insertParam('customer', cartHeader.customerId, shoppingItemLink);
				}
				window.location.href = shoppingItemLink;
			}
		});
		var switchValue = RactiveHelpers.getCookie('HTTP_ENV_VERSION');
		if ((self.get('eshopMigrateFlag') === true) || (switchValue && switchValue !== '1')) {
			window.isToCallSearchOrder = true;
		} else {
			window.isToCallSearchOrder = false;
		}

	},
	applyDomain : function (self, domain) {
		domain = domain || window.location.origin;
		if (domain) {
			var linkItemList = self.get('linkItemList');
			if (linkItemList) {
				for (var i = 0; i < linkItemList.length; i++) {
					var link = linkItemList[i].src;
					if (link && link.substring(0, 1) === '/') {
						link = domain + link;
						linkItemList[i].src = link;

					}
				}
				self.set('linkItemList', linkItemList);
			}
			var logicSrc = self.get('logo.src');
			if (logicSrc && logicSrc.substring(0, 1) === '/' && logicSrc.substring(0, 2) !== '//') {
				logicSrc = domain + logicSrc;
				self.set('logo.src', logicSrc);
			}
			var headerList = self.get('headerList');
			var isNotTablet = self.get('isNotTablet');

			if (headerList) {
				for (var i = 0; i < headerList.length; i++) {
					var subMenu = headerList[i].subMenu ? headerList[i].subMenu : [];

					if (headerList[i].linkItem) {
						var link = headerList[i].linkItem.src;
						if (link && link.substring(0, 1) === '/') {
							link = domain + link;
							headerList[i].linkItem.src = link;
						}
						headerList[i].linkItem.addHref = isNotTablet || subMenu.length < 1;
					}

					if (subMenu) {
						for (var j = 0; j < subMenu.length; j++) {
							var menuSectionTitleLink = subMenu[j].menuSectionTitle.src;
							if (menuSectionTitleLink && menuSectionTitleLink.substring(0, 1) === '/') {
								menuSectionTitleLink = domain + menuSectionTitleLink;
								subMenu[j].menuSectionTitle.src = menuSectionTitleLink;
							}

							var menuList = subMenu[j].menuList ? subMenu[j].menuList : [];
							var isFouthLevelTrue = null;
							for (var m = 0; m < menuList.length; m++) {
								var nestedMenu = (menuList[m].linkItem && menuList[m].linkItem.menuList) ?
								menuList[m].linkItem.menuList : [];
								if (nestedMenu.length > 0) {
									if (menuList[m].linkItem.src === window.location.pathname) {
										menuList[m].linkItem.active = true;
										isFouthLevelTrue = menuList[m].linkItem;
										break;
									}
									if (!isFouthLevelTrue) {
										for (var k = 0; k < nestedMenu.length; k++) {
											if (nestedMenu[k].linkItem.src === window.location.pathname) {
												menuList[m].linkItem.menuList[k].linkItem.active = true;
												isFouthLevelTrue = menuList[m].linkItem;
												break;
											}
										}
									}
								}
							}
							if (isFouthLevelTrue) {
								self.set('setFourthLevelMenu', true);
								self.set('menuListFourthLevel', isFouthLevelTrue);
							}
							if (menuList) {
								for (var k = 0; k < menuList.length; k++) {
									if (menuList[k].linkItem) {
										var menuListLink = menuList[k].linkItem.src;
										if (menuListLink && menuListLink.substring(0, 1) === '/') {
											menuListLink = domain + menuListLink;
											menuList[k].linkItem.src = menuListLink;
										}
									}
								}
								subMenu[j].menuList = menuList;
							}
						}
						headerList[i].subMenu = subMenu;
					}
				}
				self.set('headerList', headerList);
				var mobileMenuListFourthLevel = this.get('mobileMenuListFourthLevel');
				if (!mobileMenuListFourthLevel) {
					self.getMobileMenu();
					self.setDesktopOverViewOption();
				}
			}

		}
	},
	getMobileMenu : function () {
		var fourthLevelElements = _.cloneDeep(this.get('menuListFourthLevel'));
		if (fourthLevelElements && fourthLevelElements.menuList) {
			var activeObj = _.find(fourthLevelElements.menuList, function (item) {
				return item.linkItem.active;
			});
		
			var parentObj = {
				linkItem: {
					'active': null,
					'title': 'Overview',
					'src': fourthLevelElements.src,
					'menuList': []
				},
				'title': 'Overview'
			};
			if (window.location.pathname === fourthLevelElements.src ||
			(window.location.origin + window.location.pathname) === fourthLevelElements.src) {
				parentObj.linkItem.active = true;
			} else {
			
				fourthLevelElements.active = activeObj.linkItem.active;
			
			
			}
			fourthLevelElements.menuList.splice(0, 0, parentObj);
			this.set('mobileMenuListFourthLevel', fourthLevelElements);
		}
	},
	setDesktopOverViewOption : function () {
		var fourthLevelElements = this.get('menuListFourthLevel');
		if (fourthLevelElements && fourthLevelElements.menuList) {
			var parentObj = {
				linkItem: {
					'active': null,
					'title': 'Overview',
					'src': fourthLevelElements.src,
					'menuList': []
				},
				'title': 'Overview'
			};
			if (window.location.pathname === fourthLevelElements.src ||
			(window.location.origin + window.location.pathname) === fourthLevelElements.src) {
				parentObj.linkItem.active = true;
			}
			var len = fourthLevelElements.menuList.length;
			if (len < 6) {
				fourthLevelElements.menuList.splice(len, 0, parentObj);
			} else if (len >= 6) {
				fourthLevelElements.menuList.splice(5, 0, parentObj);
			}
			this.set('menuListFourthLevel', fourthLevelElements);
		}
	},
	clearOrderinContextAndRedirect: function (deferred) {
		var topic =
		'businesswidget/repository_l9_common/common/viewmodel/contextTopics/OrderInContextTopicViewModel';
		var sessionObject = sessionStorage.getItem(topic) && JSON.parse(sessionStorage.getItem(topic));
		var currentOrderActions = [];
		_.each(sessionObject && sessionObject.currentOrderActions, function (currentOrderAction) {
			currentOrderActions.push(currentOrderAction.productOrderItemID);
		});
		if (currentOrderActions.length === 0) {
			deferred.resolve();
		} else {
			Ractive.defaults.fire('TriggerCancelOrder', deferred);
		}
	},
	navigateToShopPage: function ()  {
		if (this.get('anonymousUser')) {
			var shopURL = this.get('shopButtonUrl') || ConfigStrings.pageUrls.phoneCatalogPageUrl;
			window.location.href = RactiveHelpers.modifyConfigUrl(shopURL);
		} else {
			window.location.href = RactiveHelpers.modifyConfigUrl(ConfigStrings.pageUrls.shoppingCartUrl);
		}
	},
	redirectToEshopURL : function (clearContext) {
		if (clearContext) {
			RactiveHelpers.clearContextForRRP();
		}
		window.location.href = this.get('redirectedURLToEshop');
	}
});

Ractive.components["ux-heading-text"] = Ractive.extend({
	template: LUXComponentTemplates['ux-heading-text'],
	isolated: true,
	data : function () {
		return {
			KEYS: ['{date}', '{startTime}', '{endTime}'],
			showHeadingText : true,
			RactiveHelpers: RactiveHelpers,
			moment: moment
		};
	},
	oncomplete: function () {
		var self = this;
		var text = self.get('text');
		var keys = self.get('KEYS');
		var moment = self.get('moment');
		if (text && text.indexOf(keys[0]) > 0) {
		
			var data = RactiveHelpers.getHomeLineContext('date');
			text = text.replace(keys[0], moment(data, 'DDMMYYYYHHmm').format('DD MMM YYYY'));
		}
		if (text && text.indexOf(keys[1]) > 0) {
		
			var data = RactiveHelpers.getHomeLineContext('startTime');
			text = text.replace(keys[1], moment(data, 'DDMMYYYYHHmm').format('hh:mm A'));
		}
		if (text && text.indexOf(keys[2]) > 0) {
		
			var data = RactiveHelpers.getHomeLineContext('endTime');
			text = text.replace(keys[2], moment(data, 'DDMMYYYYHHmm').format('hh:mm A'));
		}
		self.set('text', text);
		if (self.get('checkPromotionCount')) {
			window.check = window.check || {};
			if (window.check.promotionExist === false) {
				self.set('showHeadingText', false);
			}
			window.check.watch('promotionExist', function (id, oldval, newval) {
				if (newval === false) {
					self.set('showHeadingText', newval);
				}
			});
		}
	}
});

Ractive.components["ux-hero-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-hero-banner'],

		PROP_NAME: {
		THEME: 'theme',
		ALIGNMENT: 'alignment',
		HEIGHT_PRESET: 'heightPreset'
	},

		CONFIG: {
		THEME_CSS: {
			DEFAULT: 'default',
			appleBlue: 'apple-blue',
			light: 'light',
			dark: 'dark'
		},
		ALIGNMENT_CSS: {
			DEFAULT: '',
			left: 'left',
			right: 'right',
			center: ' medium-10 content-align-center'
		},
		HEIGHT_CSS: {
			DEFAULT: '',
			tall: 'banner--tall'
		}
	},

	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},

	computed: {

		$bannerHeightModifier: function () {
			return this.CONFIG.HEIGHT_CSS[
					this.get(this.PROP_NAME.HEIGHT_PRESET)] ||
				this.CONFIG.HEIGHT_CSS.DEFAULT;
		},
				$alignmentCSS: function () {
			return this.CONFIG.ALIGNMENT_CSS[
					this.get(this.PROP_NAME.ALIGNMENT)] ||
				this.CONFIG.ALIGNMENT_CSS.DEFAULT;
		},

				$themeCSSClass: function () {
			return this.CONFIG.THEME_CSS[this.get(this.PROP_NAME.THEME)] ||
				this.CONFIG.THEME_CSS.DEFAULT;
		},

				$buttonCSSClass: function () {
			return 'ux-button--' + this.CONFIG.THEME_CSS[this.get(this.PROP_NAME.THEME)] ||
				this.CONFIG.THEME_CSS.DEFAULT;
		}
	},

	oninit: function () {
		this.set({
			backgroundImgDesktop: this.get('backgroundImage.desktop.src'),
			backgroundImgMobile: this.get('backgroundImage.mobile.src') ||
			this.get('backgroundImage.desktop.src'),
			backgroundImgDesktopPosition: this.get('backgroundImage.desktop.imagePosition'),
			backgroundImgDesktopSize: this.get('backgroundImage.desktop.imageSize'),
			backgroundImgMobilePosition: this.get('backgroundImage.mobile.imagePosition') ||
			this.get('backgroundImage.desktop.imagePosition'),
			backgroundImgMobileSize: this.get('backgroundImage.mobile.imageSize') ||
			this.get('backgroundImage.desktop.imageSize'),
			foregroundImgDesktopPosition: this.get('foregroundImg.desktop.imagePosition'),
			foregroundImgDesktopSize: this.get('foregroundImg.desktop.imageSize'),
			foregroundImgMobilePosition: this.get('foregroundImg.mobile.imagePosition') ||
			this.get('foregroundImg.desktop.imagePosition'),
			foregroundImgMobileSize: this.get('foregroundImg.mobile.imageSize') ||
			this.get('foregroundImg.desktop.imageSize')
		});
	},

	onrender: function () {
		var self = this;

		self.on('ux-button.navigateToURL', function (event) {
			var linkURL = event.get('linkto');
			if (self.get('openNewWindow') === 'true' || self.get('openNewWindow') === true) {
				window.open(linkURL, '_blank');
			} else {
				window.open(linkURL, '_self');
			}

		});
	}
});

Ractive.components["ux-homeline-appointment-form"] = Ractive.extend({
	template: LUXComponentTemplates['ux-homeline-appointment-form'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			configStrings: ConfigStrings,
			moment: moment,
			config: ConfigStrings.homeLineTest,
			view: 'DEFAULT',
			selected_date: '',
			availableApptDate: [],
			inProcess: false
		};
	},
	oninit: function () {
		console.log('init ');
		_.bindAll(this, 'getTimeSlots', 'redirectToError', 'getMinMaxDay');
	},
	onrender: function () {
		console.log('render');
		var self = this;
		RactiveHelpers.getHomeLineSession(self, self.getTimeSlots, self.redirectToError);
	
		self.on('*.switchView', function (event, newView, oldView) {
			self.set('view', newView);
			if (newView === 'CALENDER' && oldView === 'DEFAULT') {
			
				var availableApptDate = this.get('availableApptDate');
				var lastDate = this.getMinMaxDay(availableApptDate.length - 1).add(1, 'days');
				self.getTimeSlots(false, lastDate.format('YYYYMMDD'));
				var minDate = availableApptDate[0];
				minDate = this.getMinMaxDay(0).toISOString();
				self.set('minDate', minDate);
				var availableApptDates = [];
				for (var i = 0; i < availableApptDate.length; i++) {
					var enabledDate =  availableApptDate[i];
					enabledDate = this.getMinMaxDay(i).toISOString();
					availableApptDates.push(enabledDate);
				}
				var lastMaxdate = this.getMinMaxDay(availableApptDate.length - 1).toISOString();
				availableApptDates.push(lastMaxdate);
				self.set('availableApptDates', availableApptDates);
			}
		});
		self.on('*.selectTimeSlot', function (event, slot) {
			this.setAppointmentContext(slot);
			window.location.href = this.get('summaryPageLink');
		});
		self.on('selectTimeSlot', function (event, slot) {
			this.setAppointmentContext(event.context);
			window.location.href = this.get('summaryPageLink');
		});
		self.on('*.dateSelected', function (date, isDateClicked) {
			var date = moment(date).format('dddd, DD-MMM');
			var sortedAppoitments = self.get('sortedAppoitments');
			var filterSlots = _.find(sortedAppoitments, function (item) {
				return item.date === date;
			});
			if (filterSlots && filterSlots.time && date) {
				self.set('selected_date', date);
				self.set('timeSlot', filterSlots.time);
			}
		});
	},
	getTimeSlots: function (param, requestApptDate) {
		var self = this;
		this.set('inProcess', true);
		var config = this.get('config');
		var moment = this.get('moment');
		if (param) {
			this.set('retrieveTokenDetails', param);
		} else {
			param = this.get('retrieveTokenDetails');
		}
		var payload = {
			'techGetNextApptReq': {
				'tokenId': RactiveHelpers.getHomeLineContext('tokenId'),
				'appName': RactiveHelpers.getHomeLineContext('appName'),
				'requestId': RactiveHelpers.getHomeLineUid(),
				'customerIdentifier': param.customerIdentifier,
				'serviceIdentifier': param.serviceIdentifier,
				'appointmentType': RactiveHelpers.getHomeLineContext('apptType') || 'MAINTENANCE',
				'requestApptDate': requestApptDate ? requestApptDate : moment().add(1, 'days').format('YYYYMMDD')
			}
		};
		RactiveHelpers.doAjaxJSONCallWithSimulator('POST', config.url.techGetNextAppt, function (response) {
			var response = response && response.techGetNextApptResp;
			self.set('appointmentDetails', response);
			if (response && response.statusCode === '00') {
				RactiveHelpers.setHomeLineContext('calendarId', response.calendarId);
				var availableApptDate = this.get('availableApptDate').concat(response.availableApptDate);
				availableApptDate = _.unique(availableApptDate, 'appointmentId');
				self.set('availableApptDate', availableApptDate);
				var sortedAppoitment = _.groupBy(availableApptDate, function (item) {
					return moment(parseInt(item.appointmentEndDate), 'YYYYMMDDhhmm').date();
				});
				var sortedAppoitments = _.map(sortedAppoitment, function (item,i) {
					return {
						time: item,
						date: moment(parseInt(item[0].appointmentStartDate), 'YYYYMMDD').format('dddd, DD-MMM')
					};
				});
				self.set('sortedAppoitments', sortedAppoitments);
			
				if (requestApptDate) {
					var maxDate = this.getMinMaxDay(availableApptDate.length - 1).toISOString();
					self.set('maxDate', maxDate);
				}
				this.set('inProcess', false);
			} else {
				var bookApptErrUrl = this.get('bookApptErrorPageUrl');
				self.redirectToError(true, bookApptErrUrl);
			
			}
		}.bind(self), function () {
			self.redirectToError();
		}.bind(self), payload);
	},
	getTimeSlotsTemp: function (param, requestApptDate) {
		var self = this;
		var availableApptDate = this.get('availableApptDate');
		var sortedAppoitment = _.groupBy((availableApptDate), function (item) {
			return moment(parseInt(item.appointmentEndDate), 'YYYYMMDDhhmm').date();
		});
		var sortedAppoitments = _.map(sortedAppoitment, function (item,i) {
			return {
				time: item,
				date: moment(parseInt(item[0].appointmentStartDate), 'YYYYMMDD').format('dddd, DD-MMM')
			};
		});
		self.set('sortedAppoitments', sortedAppoitments);
	
		if (requestApptDate) {
			var maxDate = this.getMinMaxDay(availableApptDate.length - 1).toISOString();
			self.set('maxDate', maxDate);
		}
	},
	setAppointmentContext: function (slotDetails) {
		RactiveHelpers.setHomeLineContext('date',
			moment(slotDetails.appointmentStartDate, 'YYYYMMDDHHmm').format('DDMMYYYYHHmm'));
		RactiveHelpers.setHomeLineContext('startTime',
			moment(slotDetails.appointmentStartDate, 'YYYYMMDDHHmm').format('DDMMYYYYHHmm'));
		RactiveHelpers.setHomeLineContext('endTime',
			moment(slotDetails.appointmentEndDate, 'YYYYMMDDHHmm').format('DDMMYYYYHHmm'));
		RactiveHelpers.setHomeLineContext('appointmentId', slotDetails.appointmentId);
	},
	redirectToError: function (isSuccess, bookAptErrUrl) {
		var config = this.get('config');
		window.location.href = isSuccess ? bookAptErrUrl : config.genericError;
	},
	getMinMaxDay: function (index) {
		var moment = this.get('moment');
		var availableApptDate = this.get('availableApptDate');
		var date = availableApptDate[index];
		date = moment(parseInt(date.appointmentStartDate), 'YYYYMMDD');
		return date;
	}
});

Ractive.components["ux-homeline-appointment-summary"] = Ractive.extend({
	template: LUXComponentTemplates['ux-homeline-appointment-summary'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			configStrings: ConfigStrings,
			moment: moment,
			config: ConfigStrings.homeLineTest
		};
	},
	oninit: function () {
		var moment = this.get('moment');
		this.set('contactNo', RactiveHelpers.getHomeLineContext('contactNo'));
		var date = RactiveHelpers.getHomeLineContext('date');
		var startTime = RactiveHelpers.getHomeLineContext('startTime');
		var endTime = RactiveHelpers.getHomeLineContext('endTime');
		if (date && startTime && endTime) {
			this.set('date', moment(date, 'DDMMYYYYHHmm').format('dddd, D MMM YYYY'));
			this.set('startTime', moment(startTime, 'DDMMYYYYHHmm').format('hh:mm A'));
			this.set('endTime', moment(endTime, 'DDMMYYYYHHmm').format('hh:mm A'));
		}
	},
	onrender: function () {
		console.log('dsdssd');
	}
});

Ractive.components["ux-homeline-contact-form"] = Ractive.extend({
	template: LUXComponentTemplates['ux-homeline-contact-form'],
	data: function () {
		return {
			contactNo: ''
		};
	},
	onrender: function () {
		this.on('*.onBlurContact', function (event) {
			this.contactNumber = new RactiveValidate(this, {
				'contactNo': {
					phoneValidator: 'Invalid phone number',
					required: 'Please enter details'
				}
			});
			this.contactNumber.cwd = '';
			this.contactNumber.patterns.phoneValidator = RactiveHelpers.phoneValidator;
			return this.contactNumber.validate();
		});
	}
});

Ractive.components["ux-homeline-rating"] = Ractive.extend({
	template: LUXComponentTemplates['ux-homeline-rating'],
	data: function () {
		return {
			ratingValues: [],
			ConfigStrings: ConfigStrings,
			config: ConfigStrings.homeLineTest,
			isRatingSubmited: false,
			selectedStarValue: false,
			moment: moment
		};
	},
	oninit: function () {
		this.set('ratingValues', [5, 4, 3, 2, 1]);
		_.bindAll(this, 'submitRating', 'redirectToError');
	},
	onrender: function ()  {
		var self = this;
		self.on('ratingSelection', function (event) {
			var selectStar =  event.context;
			self.set('selectedStarValue', selectStar);
		});
		self.on('*.ratingAction', function (event) {
			if (event.get('action') === 'SUBMIT') {
				RactiveHelpers.getHomeLineSession(self, self.submitRating, self.redirectToError);
			} else {
				window.location.href = RactiveHelpers.getHomeLineContext('backToHome') || 'mysingtel://app/usage';
			}
		});
	},
	submitRating: function (param) {
		var self = this;
		var config = this.get('config');
		var moment = this.get('moment');
		var payload = {
			'saveAppRatingReq': {
				'tokenId': RactiveHelpers.getHomeLineContext('tokenId'),
				'appName': RactiveHelpers.getHomeLineContext('appName'),
				'requestId': RactiveHelpers.getHomeLineUid(),
				'serviceNumber': param.serviceNumber,
				'serviceIdentifier': param.serviceIdentifier,
				'rateDateTime': moment().format('YYYYMMDDHHmm'),
				'rateValue': self.get('selectedStarValue'),
				'rateComments': ''
			}
		};
		RactiveHelpers.doAjaxJSONCallWithSimulator('POST', config.url.saveAppRating, function (response) {
			if (response && response.saveAppRatingResp && response.saveAppRatingResp.statusCode === '00') {
				self.set('isRatingSubmited', true);
			} else {
				self.redirectToError();
			}
		}.bind(self), function () {
			self.redirectToError();
		}.bind(self), payload);
	},
	redirectToError: function () {
		window.location.href = this.get('genericErrorPage');
	}
});

Ractive.components["ux-homeline-tech-asst"] = Ractive.extend({
	template: LUXComponentTemplates['ux-homeline-tech-asst'],
	data: function () {
		return {
			contactNo: '',
			isValid: false,
			ConfigStrings: ConfigStrings,
			config: ConfigStrings.homeLineTest,
			moment: moment
		};
	},
	oninit: function () {
		_.bindAll(this, 'transeferToIVRQueue', 'publishToGTM', 'redirect');
	},
	onrender: function ()  {
		var self = this;
	
		self.on('*.callModalBtnEvent', function (event) {
		
			var event = event.get('action');
			switch (event) {
				case 'CALL':
					RactiveHelpers.getHomeLineSession(self, self.transeferToIVRQueue, self.redirect);
					break;
				case 'NEXT':
					setTimeout(function () {
						var config = self.get('config');
						window.location.href = config.ratingPage;
					}.bind(self), 5000);
					break;
				case 'CANCEL':
					self.set('transferRequsetSubmitted', false);
					window.location.href = RactiveHelpers.getHomeLineContext('backToHome');
					break;
			}
		});
		self.observe('contactNo', function (newValue) {
			self.fire('*.onBlurContact');
		});
		self.on('*.onBlurContact', function (event) {
			self.contactNumber = new RactiveValidate(self, {
				'contactNo': {
					phoneValidator: 'Invalid phone number',
					required: 'Please enter details'
				}
			});
			self.contactNumber.cwd = '';
			self.contactNumber.patterns.phoneValidator = RactiveHelpers.phoneValidator;
			var isValid = self.contactNumber.validate();
			self.set('isValid', isValid.valid);
		});
		self.set('contactNo', '');
		self.set('contactNo', sessionStorage.contactNo);
	},
	transeferToIVRQueue: function (param) {
		var self = this;
		self.publishToGTM();
		this.set('inProcess', true);
		var config = this.get('config');
		var moment = this.get('moment');
		var payload = {
			'techXferToIVRQueueReq': {
				'tokenId': RactiveHelpers.getHomeLineContext('tokenId'),
				'appName': RactiveHelpers.getHomeLineContext('appName'),
				'requestId': RactiveHelpers.getHomeLineUid(),
				'serviceIdentifier': param.serviceIdentifier,
				'callerIdentity': self.get('contactNo'),
				'accountStatus': '',
				'transferDestination': param.transferDestination,
				'transferRequestDatetime': moment().format('YYYYMMDDHHMM'),
				'language': param.language,
				'lastVIVRMenu': param.lastVIVRMenu,
				'migrationStatus': param.migrationStatus,
				'customerType': '',
				'CFU': '',
				'blackListInd': param.blackListInd,
				'ticketNumber': '',
				'serviceNumber': param.serviceNumber,
				'serviceType': '',
				'rentalTariffGroup': '',
				'phoneInInd': param.phoneInInd,
				'redPrestigeInd': false,
				'accountNumber': '',
				'customerName': '',
				'SMSURL': '',
				'custValue': '',
				'customerIdentity': param.customerIdentifier,
				'VIPCode': '',
				'easyMobileInd': false
			}
		};
		return RactiveHelpers.doAjaxJSONCallWithSimulator('POST', config.url.techInsertToIVRQueue, function (response) {
			var response = response && response.techXferToIVRQueueResp;
			if (response && response.statusCode === '00') {
			
				self.set('transferRequsetSubmitted', true);
			} else {
				self.redirect();
			}
		}.bind(self), function () {
			self.redirect();
		}.bind(self), payload);
	},
	redirect: function (isSuccess) {
		window.location.href = isSuccess ? this.get('href') : this.get('genericErrorPageUrl');
	},
	publishToGTM: function () {
		var appName = RactiveHelpers.getHomeLineContext('appName');
		var tokenId = RactiveHelpers.getHomeLineContext('tokenId');
		var currentPageUrl = window.location.href;
		this.set({
			appName: appName,
			tokenId: tokenId,
			currentPageUrl: currentPageUrl
		});
		this.fire('HomeLineTest');
	}
});

Ractive.components["ux-homeline-vertical-tout"] = Ractive.extend({
	template: LUXComponentTemplates['ux-homeline-vertical-tout'],
	isolated: true,
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			KEYS: ['{date}', '{startTime}', '{endTime}'],
			moment: moment
		};
	},
	oncomplete: function () {
		var self = this;
		var text = self.get('text');
		var keys = self.get('KEYS');
		var moment = self.get('moment');
		if (text && text.indexOf(keys[0]) > 0) {
		
			var data = RactiveHelpers.getHomeLineContext('date');
			text = text.replace(keys[0], moment(data, 'DDMMYYYYHHmm').format('DD MMM YYYY'));
		}
		if (text && text.indexOf(keys[1]) > 0) {
		
			var data = RactiveHelpers.getHomeLineContext('startTime');
			text = text.replace(keys[1], moment(data, 'DDMMYYYYHHmm').format('hh:mm A'));
		}
		if (text && text.indexOf(keys[2]) > 0) {
		
			var data = RactiveHelpers.getHomeLineContext('endTime');
			text = text.replace(keys[2], moment(data, 'DDMMYYYYHHmm').format('hh:mm A'));
		}
		self.set('text', text);
	}
});

Ractive.components["ux-homepage-banner-image"] = Ractive.extend({
	template: LUXComponentTemplates['ux-homepage-banner-image'],
	isolated: true,
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},

	oninit: function () {
		var self = this;
		self.set('backgroundImgDesktopPosition', self.get('backgroundImage.desktop.imagePosition'));
		self.set('backgroundImgMobilePosition',
			self.get('backgroundImage.mobile.imagePosition') || self.get('backgroundImage.desktop.imagePosition'));
	}
});

Ractive.components["ux-homepage-banner-video"] = Ractive.extend({
	template: LUXComponentTemplates['ux-homepage-banner-video'],
	onrender: function (argument) {
		this.set('videoURL',
			'https://www.youtube.com/embed/' +
			this.get('video.background.videoId') +
			'?autoplay=1&amp;controls=0&amp;loop=1&amp;showinfo=0&amp;modestbranding=1&amp;disablekb=1&amp;playlist=' +
			this.get('video.background.videoId'));

		this.set('foregroundVideoURL',
			'https://www.youtube.com/embed/' +
			this.get('video.foreground.videoId') +
			'?autoplay=1&amp;controls=0&amp;loop=1&amp;showinfo=0&amp;modestbranding=1&amp;disablekb=1&amp;playlist=' +
			this.get('video.foreground.videoId'));

		this.on('playForegroundVideo', function (modalId) {
			var modal = this.findComponent('ux-modal');
			modal.set('displayState', true);
		});
	}
});

Ractive.components["ux-homepage-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-homepage-banner'],
	oninit: function () {
		var self = this;
		var backgroundImage = self.get('backgroundImage.mobile.src') || self.get('backgroundImage.desktop.src');
		self.set('backgroundImgDesktop', self.get('backgroundImage.desktop.src'));
		self.set('backgroundImgMobile', backgroundImage);
		self.set('backgroundImgDesktopPosition', self.get('backgroundImage.desktop.imagePosition'));
		self.set('backgroundImgDesktopSize', self.get('backgroundImage.desktop.imageSize'));
		self.set('backgroundImgMobilePosition',
			self.get('backgroundImage.mobile.imagePosition') || self.get('backgroundImage.desktop.imagePosition'));
		self.set('backgroundImgMobileSize',
			self.get('backgroundImage.mobile.imageSize') || self.get('backgroundImage.desktop.imageSize'));

		self.set('foregroundImgDesktopPosition', self.get('foregroundImg.desktop.imagePosition'));
		self.set('foregroundImgDesktopSize', self.get('foregroundImg.desktop.imageSize'));
		self.set('foregroundImgMobilePosition',
			self.get('foregroundImg.mobile.imagePosition') || self.get('foregroundImg.desktop.imagePosition'));
		self.set('foregroundImgMobileSize',
			self.get('foregroundImg.mobile.imageSize') || self.get('foregroundImg.desktop.imageSize'));
	}
});

Ractive.components["ux-icon-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-icon-banner'],
	isolated: true,
	oninit: function () {
		var self = this;
		var mobileBgImg = self.get('mobileBgImg.src') || self.get('bgImg.src');
		self.set('mobileBgImg.src', mobileBgImg);
	}
});

Ractive.components["ux-icon"] = Ractive.extend({
	template: LUXComponentTemplates['ux-icon'],
	isolated: true,
	data: function () {
		return {
			bubble: false
		};
	},
	events: {
		enter: RactiveEventsKeys.enter
	},
	oninit: function () {

		var overIconWithImage = false;

		if (window.location.hostname.indexOf('aws.sg.springd.net') !== -1 ||
			window.location.hostname.indexOf('singtel.com') !== -1 ||
			window.location.hostname.indexOf('singtelshop.com') !== -1 ||
			window.location.hostname.indexOf('app.vic') !== -1 ||
			window.location.hostname.indexOf('sg.singtelgroup.net') !== -1) {
			var contextPath = window.location.pathname.substring(0, window.location.pathname.indexOf('/', 2));

			if (contextPath === '/mcss_nuovo' || contextPath === '/mcss') {
				overIconWithImage = true;
			}

			if (RactiveHelpers.isBrowserIE(false)) {
				overIconWithImage = true;
			}

			this.set('overIconWithImage', overIconWithImage);
		}

		this.on('iconTapHandler', function () {
			var onTap = this.get('ontap');

			if (onTap) {
				var splitParams = onTap.split(':');

				if (splitParams.length > 1) {
					var params = splitParams.splice(1, splitParams.length);
					this.fire(splitParams[0], this, params);
				} else {
					this.fire(onTap, this);
				}
			
				return false;
			} else if (!this.get('bubble')) {
				return false;
			}
		});

		this.on('iconEnterHandler', function () {
			var onEnter = this.get('onEnter');
			if (onEnter) {
				this.fire(onEnter, this);
				return false;
			}
		});

		this.on('iconDragOver', function (event) {
			var e = event;

			if (e.preventDefault) {
				e.preventDefault();
			}

			var onpanend = this.get('onpanend');
			if (onpanend) {
				this.fire(onpanend, this);
				return false;
			}
		});

		this.on('iconDragStart', function (event) {
			var e = event;

			if (e.preventDefault) {
				e.preventDefault();
			}

			var onpanstart = this.get('onpanstart');
			if (onpanstart) {
				this.fire(onpanstart, this);
				return false;
			}
		});

		this.on('iconDrag', function (event) {
			var e = event;

			if (e.preventDefault) {
				e.preventDefault();
			}

			var onpan = this.get('onpan');
			if (onpan) {
				this.fire(onpan, this);
				return false;
			}
		});

		this.on('iconDragMove', function (event) {
			var e = event;
			if (e.preventDefault) {
				e.preventDefault();
			}

			var onpanmove = this.get('onpanmove');
			if (onpanmove) {
				this.fire(onpanmove, this);
				return false;
			}
		});

		this.on('iconPress', function (event) {
			var e = event;

			if (e.preventDefault) {
				e.preventDefault();
			}

			var onpress = this.get('onpress');
			if (onpress) {
				this.fire(onpress, this);
				return false;
			}
		});

	}
});

Ractive.components["ux-iframe"] = Ractive.extend({
	template: LUXComponentTemplates['ux-iframe'],
	breakpoints: {
		mobile: 480,
		tablet: 768,
		laptop: 1024
	},
	onrender: function () {
		this.set('scrolling', 'no');
		var iframe = this.find('iframe');
		iframe.onload = function () {
		
			iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';

		
			if (this.get('scriptToInject')) {
				var injectedScript = document.createElement('script');
				injectedScript.type = 'text/javascript';
				injectedScript.innerHTML = 'setInterval(function() {' +
					'window.parent.postMessage(' +
					'\'{\"author\":\"OSG\",\"action\":\"resize\",\"value\":\'+document.body.scrollHeight+\'}\',"*");' +
					'},500);';
				injectedScript.innerHTML += this.get('scriptToInject');
				iframe.contentDocument.body.appendChild(injectedScript);
			}

		}.bind(this);
		window.addEventListener('message', function (e) {
			if (e.data.indexOf('OSG') !== -1) {
				var message = JSON.parse(e.data);

				if (message.action === 'resize') {
					var iframe = this.find('iframe');
					if (iframe) {
						iframe.style.height = message.value + 'px';
						iframe.height = message.value + 'px';
					}
				} else {
					console.log('Unknown message: ', e.data);
				}
			} else {
				console.log('Unknown message: ', e.data);
			}

		}.bind(this), false);
	},
	oncomplete: function () {
		var self = this;
		self.estimateHeight();
	},
	setHeight: function (deviceHeight) {
		var defaultHeight = this.get('height');

		this.set('scrolling', 'auto');
		this.set('responsiveHeight', (deviceHeight || defaultHeight));

	},
	estimateHeight: function () {
		var width = window.innerWidth;

		var height = this.get('height');
		var mobileHeight = this.get('mobileHeight');
		var tabletHeight = this.get('tabletHeight');
		var laptopHeight = this.get('laptopHeight');

	
		if (mobileHeight && width <= this.breakpoints.mobile) {
			this.setHeight(mobileHeight);
			return;
		}

	
		if (tabletHeight && width > this.breakpoints.mobile && width <= this.breakpoints.tablet) {
			this.setHeight(tabletHeight);
			return;
		}

	
		if (laptopHeight && width > this.breakpoints.tablet && width <= this.breakpoints.laptop) {
			this.setHeight(laptopHeight);
			return;
		}

		this.set('responsiveHeight', height);
		return;
	}
});

Ractive.components["ux-image-button"] = Ractive.extend({
	template: LUXComponentTemplates['ux-image-button']
});

Ractive.components["ux-image-carousel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-image-carousel'],
	onrender: function () {
		var self = this;
		self.swiper = new Swiper(self.find('.swiper-container'), {
			direction: 'horizontal',
			nextButton: this.find('.swiper-button-next'),
			prevButton: this.find('.swiper-button-prev'),
			slidesPerView: 5,
			loop: false,
			spaceBetween: 0,
			breakpoints: {
				400: {
					slidesPerView: 2,
					spaceBetween: 10
				},
				769: {
					slidesPerView: 4,
					spaceBetween: 10
				},
				1200: {
					slidesPerView: 5,
					spaceBetween: 10
				}
			}
		});

	}
});

Ractive.components["ux-image-gallery"] = Ractive.extend({
	template: LUXComponentTemplates['ux-image-gallery'],

	onrender: function () {
		var colors = this.get('phoneColors');
		if (colors && colors.length > 0) {
			this.set('selectedColor', colors[0].name);
			this.showImage(0, this.get('selectedColor'));
		}

	
		switch (this.get('topSpacing')) {
			case 'small':
				this.set('topSpacing', 'small');
				break;
			case 'medium':
				this.set('topSpacing', 'medium');
				break;
			case 'large':
				this.set('topSpacing', 'large');
				break;
			default:
				this.set('topSpacing', 'normal');
		}

		this.on('doShowSelectedImage', function (event, imgView) {
			this.showImage(imgView, this.get('selectedColor'));
		}.bind(this));

		this.parent.on('selectedColor', function (imgColor) {
			this.showImage(0, imgColor);
			this.set('selectedColor', imgColor);

		}.bind(this));

		Ractive.defaults.on('bookAptColorChange', function (selectedColor) {
			this.set('selectedColor', selectedColor);
			this.showImage(0, selectedColor);
		}.bind(this));

		this.set('getSelectedState', function (idx) {
			return this.get('selectedImageState.' + idx);
		}.bind(this));

	},

	showImage: function (imgView, imgColor) {
		var selectedColor = _.where(this.get('phoneColors'), {name: imgColor})[0];
		this.set('imagePath', selectedColor.images[imgView]);
		this.setSelectedState('selectedImageState', imgView);
	},

	setSelectedState: function (state, property) {
		var selectedStateStr = state + '.' + property.toString().toLowerCase();
		var selectedStateObj = this.get(state);
		if (typeof selectedStateObj !== undefined) {
			_.each(selectedStateObj, function (element, key) {
				selectedStateObj[key] = '';
			});
		}
		this.set(selectedStateStr, 'selected');
		this.update();
	}
});

Ractive.components["ux-image"] = Ractive.extend({
	template: LUXComponentTemplates['ux-image'],
	oninit: function () {
		var self = this;
		var mobileImgSrc = self.get('mobile.src') || self.get('desktop.src');
		var mobileImgAlt = self.get('mobile.alt') || self.get('desktop.alt');
		self.set('mobile.src', mobileImgSrc);
		self.set('mobile.alt', mobileImgAlt);
	}
});

Ractive.components["ux-inbox-card"] = Ractive.extend({
	template: LUXComponentTemplates['ux-inbox-card'],
	data: function () {
		return {
			moment: moment,
			RactiveHelpers: RactiveHelpers
		};
	},
	onrender: function () {
		var self = this;
		self.on('doShowModal', function (event, cardId) {
			if (self.get('status') === 'expired') {
				return;
			}
			self.set('contentHtml', false);
			self.set('readStatus', true);
			self.handleModal(event, true, cardId);
		});

		self.on('ux-button.doDelete', function (event) {
			var details = {
				account: self.get('account'),
				accountNumber: self.get('accountNumber'),
				timestamp: self.get('createDate')
			};
			self.fire('doDeleteMessage', event, details);
			self.handleCloseModal(event);
		});
	},

	handleModal: function (event, visibility, cardId) {
		var modals = this.parent.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return cardId === component.get('modalId');
		})[0];
		modal.set('displayState', visibility);
		var contentType = this.get('contentType');
		if (contentType && contentType.toUpperCase() === 'html'.toUpperCase()) {
			this.set('contentHtml', true);
		}
		var iframeElementContainer = document.getElementById('iframeID');
		iframeElementContainer = iframeElementContainer.contentWindow ? iframeElementContainer.contentWindow :
		(
			iframeElementContainer.contentDocument.document ? iframeElementContainer.contentDocument.document :
			iframeElementContainer.contentDocument
		);
		iframeElementContainer.document.open();
		iframeElementContainer.document.writeln(this.get('content'));
		iframeElementContainer.document.close();

		var details = {
			accountNumber: this.get('accountNumber'),
			account: this.get('account'),
			timestamp: this.get('createDate'),
			readStatus: this.get('readStatus')
		};
	
		this.fire('onOpenMessage', event, details);
	},
	handleCloseModal : function (event) {
		var modals = this.parent.findAllComponents('ux-modal');
		modals.forEach(function (component) {
			component.set('displayState', false);
		});
	}
});

Ractive.components["ux-info-block-modal"] = Ractive.extend({
	template: LUXComponentTemplates['ux-info-block-modal'],
	data: function () {
		return {
			ConfigStrings: ConfigStrings
		};
	},
	oncomplete: function () {
		var self = this;
		self.parent.on('openBlockingModal', function () {
			self.set('isBlockingMessage', true);
			self.set('header', self.get('initData.tvRecon.blockingHeader') ||
				ConfigStrings.tvRecon.blockingHeader);
			self.set('description', self.get('initData.tvRecon.blockingDescription') ||
				ConfigStrings.tvRecon.blockingDescription);
			self.set('messages', self.get('contractDetails.tvPacksBlockingMessages'));
			self.set('linkText', self.get('initData.tvRecon.linkText'));
			self.set('buttonLabel', self.get('initData.tvRecon.buttonLabel'));
			self.openModal('cmptbltySttsInfoBlock');
		});
		self.parent.on('openInformationModal', function () {
			self.set('isBlockingMessage', false);
			self.set('header', self.get('initData.tvRecon.infoHeader') ||
				ConfigStrings.tvRecon.infoHeader);
			self.set('description', self.get('initData.tvRecon.infoDescription') ||
				ConfigStrings.tvRecon.infoDescription);
			self.set('messages', self.get('contractDetails.tvPacksBlockingMessages'));
			self.set('linkText', self.get('initData.tvRecon.linkText'));
			self.set('buttonLabel', self.get('initData.tvRecon.buttonLabel'));
			self.openModal('cmptbltySttsInfoBlock');
		});
		self.parent.on('openTVReconBlockingModal', function () {
			self.openModal('TVReconErrorPopupModal');
		});
		self.on('*.next', function (e) {
			var isBlockingMessage = self.get('isBlockingMessage');
			if (isBlockingMessage === true) {
				self.fire('proceedBlocked', {
					name: 'proceedBlocked'
				});
			} else if (isBlockingMessage === false) {
				self.parent.set('inProcess', true);
				self.fire('handleObserver', {
					name: 'handleObserver',
					vmState: 'orderSuccesfull',
					listener: 'orderStatus'
				});
			}
		});
		self.on('*.goBack', function () {
			self.fire('goBackInfoBlockModal', {
				name: 'goBackInfoBlockModal'
			});
		});
	},
	openModal: function (modalId) {
		var modals = this.findAllChildComponents('ux-modal');
		var targetModal = _.find(modals, function (modal) {
			return modal.get('modalId') === modalId;
		});
		targetModal.set('displayState', true);
	}
});

Ractive.components["ux-input-box"] = Ractive.extend({
	template: LUXComponentTemplates['ux-input-box'],
	computed: {
		guid: function () {
			return this._guid;
		}
	},
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			getType: function () {
				if (this.get('type')) {
					return this.get('type');
				} else if (this.get('password')) {
					return this.get('password');
				} else {
					return 'text';
				}
			}
		};
	},
	onrender: function () {
		this.set('show_tooltip', false);
		if (this.get('password') && this.get('passwordStrength')) {
			this.observe('value', function (newValue) {
				if (typeof newValue !== 'undefined' && newValue !== '') {
					this.set('password', {
						'strength':  RactiveHelpers.checkPasswordStrength(newValue)
					});
				}
			}.bind(this));
		}

		this.on('showTooltip', function () {
			if (this.get('tooltip_msg')) {
				this.toggle('show_tooltip');
			}
			return false;
		});

		this.on('setPayBillAmt', function () {
			this.fire('setPayBillAmount', this.get('value'));
		});
	},
	onconfig: function () {
		this.on('blurHandler', function () {
			var fireEvent = this.get('onblurEvent');
			if (fireEvent) {
				this.fire(fireEvent, this);
				return false;
			}
		});

		this.on('inputHandler', function () {
			var fireEvent = this.get('onInputEvent');
			if (fireEvent) {
				this.fire(fireEvent, this);
				return false;
			}
		});

		this.on('enterHandler', function () {
			var fireEvent = this.get('onEnterEvent');
			if (fireEvent) {
				this.fire(fireEvent, this);
				return false;
			}
		});
		this.on('focusHandler', function () {
			var fireEvent = this.get('onFocusEvent');
			if (fireEvent) {
				this.fire(fireEvent, this);
				return false;
			}
		});
	}
});

Ractive.components["ux-installationlink-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-installationlink-banner'],

	onrender: function () {
	
		switch (this.get('topSpacing')) {
			case 'small':
				this.set('topSpacing', 'small');
				break;
			case 'medium':
				this.set('topSpacing', 'medium');
				break;
			case 'normal':
				this.set('topSpacing', 'normal');
				break;
			case 'large':
				this.set('topSpacing', 'large');
				break;
			default:
				this.set('topSpacing', 'none');
		}
	},
	oninit: function () {
		var self = this;
		var backgroundImage = self.get('backgroundImg.mobile.src') || self.get('backgroundImg.desktop.src');
		self.set('backgroundImgDesktop', self.get('backgroundImg.desktop.src'));
		self.set('backgroundImgMobile', backgroundImage);
		self.set('backgroundImgDesktopPosition', self.get('backgroundImg.desktop.imagePosition'));
		self.set('backgroundImgDesktopSize', self.get('backgroundImg.desktop.imageSize'));
		self.set('backgroundImgMobilePosition',
			self.get('backgroundImg.mobile.imagePosition') || self.get('backgroundImg.desktop.imagePosition'));
		self.set('backgroundImgMobileSize',
			self.get('backgroundImg.mobile.imageSize') || self.get('backgroundImg.desktop.imageSize'));

		this.set('color', 'white');
		this.set('size', 'l');
	}
});

Ractive.components["ux-invite-friend"] = Ractive.extend({
	template: LUXComponentTemplates['ux-invite-friend'],
	transitions: {
		fade: ractiveTransitionsFade
	},
	data: {
		oneTimePin: '',
		apiEndPoint: '',
		oneTimePinErrorMessage: '',
		mobileNumber: '',
		invite: {
			friendsName: '',
			friendsMobileNumber: '',
			inviteCode: '',
			tnc: false,
			step: 0,
			step1valid: false,
			step2valid: false,
			step3valid: false
		},
		signup: {
			inviteCode: '',
			tnc: false,
			step: 0,
			step1valid: false,
			step2valid: false
		},
		loading: false,
		RactiveHelpers: RactiveHelpers
	},
	putSession: function (name, value, days) {
		var expires;
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = '; expires=' + date.toGMTString();
		} else {
			expires = '';
		}
		document.cookie = name + '=' + value + expires + '; path=/';
	},
	getSession: function (sessionName) {
		if (document.cookie.length > 0) {
			var sessionStart = document.cookie.indexOf(sessionName + '=');
			if (sessionStart !== -1) {
				sessionStart = sessionStart + sessionName.length + 1;
				var sessionEnd = document.cookie.indexOf(';', sessionStart);
				if (sessionEnd === -1) {
					sessionEnd = document.cookie.length;
				}
				return decodeURI(document.cookie.substring(sessionStart, sessionEnd));
			}
		}
		return '';
	},
	resetFields: function () {
		this.set('oneTimePin', '');
		this.set('oneTimePinErrorMessage', '');
		this.set('inviteCodeErrorMsg', '');
		this.set('mobileNumberErrorMsg', '');
		this.set('friendsMobileNumberErrorMessage', '');
		this.set('mobileNumber', '');
		this.set('genericErrorMessage', '');
		this.set('invite.name', '');
		this.set('invite.friendsName', '');
		this.set('invite.friendsMobileNumber', '');
		this.set('invite.inviteCode', '');
		this.set('invite.step', 0);
		this.set('invite.step1valid', false);
		this.set('invite.step2valid', false);
		this.set('invite.step3valid', false);
		this.set('invite.tnc', false);
		this.set('signup.step', 0);
		this.set('signup.oneTimePin', '');
		this.set('signup.inviteCode', '');
		this.set('signup.oneTimePinErrorMessage', '');
		this.set('signup.step1valid', false);
		this.set('signup.step2valid', false);
		this.set('signup.tnc', false);
		this.set('validity.status', '');
	},
	ajaxCallApi : function (parameter, method) {
		var methodType = method === '' ? 'GET' : method;
		var def = $.Deferred();
		var callApi = this.get('apiEndPoint') + '/' + parameter;
		return $.ajax({
			type: methodType,
			cache: false,
			url: callApi,
			crossDomain: true,
			dataType: 'json',
			success: function (response) {
				def.resolve(response);
			},
			error: function (xhr, error, test) {
				console.log(xhr);
			}
		});
	},
	toggleModal: function (modalId, state) {
		var modalList = this.findAllComponents('ux-modal');
		var modal = _.find(modalList, function (modal) {
			return modal.get('modalId') === modalId;
		});
		modal.set('displayState', state);
	},
	getQueryStringValue: function (param) {
		var regex = new RegExp('(^|&)' + param + '=([^&]*)(&|$)');
		var paramMatch = window.location.search.substr(1).match(regex);
		return paramMatch !== null ? decodeURI(paramMatch[2]) : null;
	},
	isValidMobile: function () {
		this.validateMobileNumber = new RactiveValidate(this, {
			'mobileNumber': {
				required: 'Please enter your mobile number',
				digits: 'Please enter numbers only',
				minlength: {
					param: 8,
					message: 'Please your 8 digits mobile number'
				},
				validPhoneNumber: 'Your mobile line is not eligible for this promotion'
			}
		});
		var validate = this.validateMobileNumber.validate();
		return validate.valid;
	},
	isValidOtp: function () {
		this.validateOtpChars = new RactiveValidate(this, {
			'oneTimePin': {
				required: 'This field is required',
				otp: 'An OTP requires 6-digit number'
			}
		});
		this.validateOtpChars.patterns.otp = /^[0-9]{6}$/;
		var validateOtp = this.validateOtpChars.validate();

		return validateOtp.valid;
	},
	isValidName: function () {
		this.validateName = new RactiveValidate(this, {
			'invite.friendsName': {
				required: 'This field is required',
				fullname: 'Please enter a valid name'
			}
		});
		this.validateName.patterns.fullname = /^[a-zA-Z0-9,\.\-\/\s]+$/i;
		var validateName = this.validateName.validate();
		return validateName.valid;
	},
	isValidFriendsMobileNumber: function () {
		this.validateFriendsNumber = new RactiveValidate(this, {
			'invite.friendsMobileNumber': {
				required: 'Please enter your mobile number',
				digits: 'Please enter numbers only',
				minlength: {
					param: 8,
					message: 'Please your 8 digits mobile number'
				},
				validPhoneNumber: 'Please enter a valid mobile number'
			}
		});
		var validateMobileNumber = this.validateFriendsNumber.validate();
		return validateMobileNumber.valid;
	},
	oninit: function () {
		this.set('apiEndPoint', this.get('data.apiEndPoint'));
	},
	onrender: function () {
		var self = this;
		self.set('pageUrl', window.location.href.split('?')[0]);
		var predefinedCode = self.getQueryStringValue('code');

		self.validateInviteCode = new RactiveValidate(self, {
			'signup.inviteCode': {
				required: 'Please enter your mobile number',
				alpha_numeric: 'Invalid code, please re-enter'
			}
		});

				self.on('*.goBack', function () {
			var modalType = self.get(self.get('modalType') + '.step');
			self.set('genericErrorMessage', '');
			if (parseInt(modalType) === 1) {
				self.toggleModal('referralModal', 0);
				return;
			}
			self.set(self.get('modalType') + '.step', modalType - 1);
		});
				self.on('ux-anchor.showModal', function (event, typeOfModal) {
			self.resetFields();
			self.set('modalType', typeOfModal);
			if (typeOfModal === 'invite') {
				self.set('invite.step', 1);
			}

			if (typeOfModal === 'signup') {
				if (predefinedCode !== null) {
					self.set('signup.inviteCode', predefinedCode.replace(/[^A-Z0-9]+/ig, ''));
				}
				self.set('signup.step', 1);
			}
			self.toggleModal('referralModal', true);
		});

				self.observe('mobileNumber', function (newVal, oldVal, keypath) {
			self.set('data.mobileNumber', newVal);
			if (oldVal && newVal.length === 8) {
				if (self.isValidMobile()) {
					self.set(self.get('modalType') + '.step1valid', true);
					self.set('validity.status', '');
					self.set('mobileNumberErrorMsg', '');
				} else {
					self.set(self.get('modalType') + '.step1valid', false);
										self.set('validity.status', self.get('data.mobileNumberErrorMsg.status'));
					self.set('mobileNumberErrorMsg', self.get('data.mobileNumberErrorMsg.message'));
									}
			} else {
				self.set(self.get('modalType') + '.step1valid', false);
			}
		});

				self.on('*.requestOneTimePin', function (event) {
			self.set('loading', true);
			self.set('oneTimePinErrorMessage', '');
			var mobileNumber = self.get('mobileNumber');
			if (self.isValidMobile()) {
				if (self.get('modalType') === 'invite') {
					var validateParam = 'verifySingtelCustomer/' + mobileNumber;
					self.ajaxCallApi(validateParam).then(function (response) {
						if (response.status.code === 200) {
							if (response.body.isSingtelCustomer === 'Y') {
							
								var otpParam = 'sendOTP/' + mobileNumber;
								self.ajaxCallApi(otpParam).then(function (response) {
									if (response.status.code === 200) {
										self.set(self.get('modalType') + '.step', 2);
										self.set(self.get('modalType') + '.step2valid', false);
										self.set('mobileNumberErrorMsg', '');
									} else {
										self.set('mobileNumberErrorMsg', response.status.message);
									}
								});
							
								var codeParam = 'getInviteCode/' + self.get('mobileNumber');
								self.ajaxCallApi(codeParam).then(function (response) {
									if (response.status.code === 200) {
										self.set('invite.inviteCode', response.body.inviteCode);
									} else if (response.status.code === 600) {
										self.set('genericErrorMessage', response.body.errorMessage);
									} else {
										self.set('genericErrorMessage', 'Please enter a valid mobile number');
									}
								});
							} else {
								self.set('mobileNumberErrorMsg', 'Your mobile line is not eligible for this promotion');
							}
						} else {
							self.set('mobileNumberErrorMsg', response.status.message);
						}
					});
				} else {
					var otpParam = 'sendOTP/' + mobileNumber;
					self.ajaxCallApi(otpParam).then(function (response) {
						if (response.status.code === 200) {
							self.set(self.get('modalType') + '.step', 2);
							self.set(self.get('modalType') + '.step2valid', false);
							self.set('mobileNumberErrorMsg', '');
						} else {
							self.set('mobileNumberErrorMsg', response.status.message);
						}
					});
				}
			}
			self.set('loading', false);
		});

				self.observe('oneTimePin', function (newVal, oldVal, keypath) {
			self.set('data.' + keypath, newVal);
			if (oldVal && newVal.length === 6) {
				if (self.isValidOtp()) {
					if (self.get(self.get('modalType') + '.tnc')) {
						self.set(self.get('modalType') + '.step2valid', true);
					}
					self.set('validity.status', '');
					self.set('oneTimePinErrorMessage', '');
					if (self.get('modalType') === 'signup') {
						var validateCode = self.validateInviteCode.validate();
						if (validateCode.valid && self.isValidOtp() && self.get('signup.tnc')) {
							self.set('signup.step2valid', true);
							self.set('validity.status', '');
							self.set('inviteCodeErrorMsg', '');
						} else {
							self.set('signup.step2valid', false);
						}
					}
				} else {
					self.set(self.get('modalType') + '.step2valid', false);
					self.set('validity.status', self.get('data.' + keypath + 'ErrorMsg.status'));
					self.set('oneTimePinErrorMessage',
						self.get('data.' +  keypath + 'ErrorMsg.message')
					);
				}
			} else {
				self.set(self.get('modalType') + '.step2valid', false);
			}
		});

				self.on('*.setTnc', function () {
			var modalType = self.get('modalType');
			var tnc = self.get(modalType + '.tnc') === true ? false : true;
			self.set('data.' + modalType + '.tnc', tnc);
						if (self.get(modalType + '.tnc') && self.get('oneTimePin') && self.isValidOtp()) {
				if (self.get('modalType') === 'signup') {
					var validateCode = self.validateInviteCode.validate();
					var signupCode = self.get('signup.inviteCode');
					if (signupCode === '') {
						self.set('signup.step2valid', true);
					} else {
						if (validateCode.valid) {
							self.set('signup.step2valid', true);
						} else {
							self.set('signup.step2valid', false);
						}
					}
				} else {
					self.set(modalType + '.step2valid', true);
				}
			} else {
				self.set(modalType + '.step2valid', false);
			}
					});

				self.on('*.submitOneTimePin', function () {
			self.set('loading', true);
			var mobileNumber = self.get('mobileNumber');
			var validateParam = 'validateOTP/' + self.get('oneTimePin') + '/' + mobileNumber;
			if (self.isValidOtp()) {
				self.ajaxCallApi(validateParam).then(function (response) {
					if (response.status.code === 200) {
						if (response.body.isValid === true) {
							self.set('oneTimePinErrorMessage', '');
							self.set(self.get('modalType') + '.step', 3);
							self.putSession('userSession', response.body.sessionId, 1);
							if (self.get('modalType') === 'signup') {
								self.fire('*.signup');
							}
						}
												else {
							self.set('oneTimePinErrorMessage',
								'Invalid OTP, please re-enter or re-send OTP (“re-send” is a clickable link to re-send the OTP)');
						}
											} else if (response.status.code === 600) {
						self.set('genericErrorMessage', response.body.errorMessage);
					} else {
						self.set('genericErrorMessage', response.status.message);
					}
				});
			}
			self.set('loading', false);
		});

				self.observe('invite.friendsName', function (newVal, oldVal, keypath) {
			if (!newVal) {
				self.set('data.' + keypath, oldVal);
			} else {
				self.set('data.' + keypath, newVal);
			}
			var name = self.get(keypath);
			if (name.length <= 200 && name.length > 0) {
				if (self.isValidName() && self.isValidFriendsMobileNumber()) {
					self.set('friendsNameErrorMessage', '');
					self.set('invite.step3valid', true);
				} else {
					self.set('invite.step3valid', false);
					if (self.get('data.invite.friendsMobileNumberErrorMsg.status') &&
							self.get('invite.friendsMobileNumber')) {
						self.set(
							'friendsMobileNumberErrorMessage',
							self.get('data.invite.friendsMobileNumberErrorMsg.message')
						);
					}
					self.set('validity.status', self.get('data.invite.friendsNameErrorMsg.status'));
					self.set('friendsNameErrorMessage', self.get('data.invite.friendsNameErrorMsg.message'));
				}
			} else {
				self.set('invite.step3valid', false);
			}
		});

		self.observe('invite.friendsMobileNumber', function (newVal, oldVal, keypath) {
			if (!newVal) {
				self.set('data.invite.friendsMobileNumber', oldVal);
			} else {
				self.set('data.invite.friendsMobileNumber', newVal);
			}
			if (self.get('invite.friendsMobileNumber').length === 8) {
				if (self.isValidName() && self.isValidFriendsMobileNumber()) {
					self.set('invite.step3valid', true);
					self.set('validity.status', '');
					self.set('friendsMobileNumberErrorMessage', '');
				} else {
					self.set('invite.step3valid', false);
					self.set(
						'validity.status',
						self.get('data.invite.friendsMobileNumberErrorMsg.status')
					);
					self.set(
						'friendsMobileNumberErrorMessage',
						self.get('data.invite.friendsMobileNumberErrorMsg.message')
					);
				}
			} else {
				self.set('invite.step3valid', false);
			}
		});

				self.on('*.sendInvite', function () {
			self.set('loading', true);
						if (self.isValidName() && self.isValidFriendsMobileNumber()) {
				var tnc = self.get('invite.tnc') === true ? 'Y' : 'N';
				var submitParam = 'inviteFriend/' + self.get('invite.inviteCode') + '/' + self.get('invite.friendsName') + '/' + self.get('invite.friendsMobileNumber') + '/' + tnc + '/' + self.getSession('userSession');
				self.ajaxCallApi(submitParam, 'POST').then(function (response) {
					if (response.status.code === 200) {
						if (response.body.hasOwnProperty('referrerCode')) {
							self.set('friendsNameErrorMessage', '');
							self.set('genericErrorMessage', '');
							self.set(self.get('modalType') + '.step', 4);
							self.set('sharableUrl',
								encodeURIComponent(
									window.location.href.split('?')[0] + '?code=' + self.get('invite.inviteCode'))
								);
						} else {
							self.set('genericErrorMessage', response.status.message);
						}
					} else if (response.status.code === 600) {
						self.set('genericErrorMessage', response.body.errorMessage);
					} else {
						self.set('genericErrorMessage', response.status.message);
					}
				});
			}
						self.set('loading', false);
		});

				self.observe('signup.inviteCode', function (newVal, oldVal, keypath) {
			if (!newVal) {
				self.set('data.signup.inviteCode', oldVal);
			} else {
				self.set('data.signup.inviteCode', newVal);
			}
			var validateCode = self.validateInviteCode.validate();
			var signupCode = self.get('signup.inviteCode');
			if (self.isValidOtp()) {
				if (validateCode.valid && self.get('signup.tnc')) {
					self.set('signup.step2valid', true);
					self.set('validity.status', '');
					self.set('inviteCodeErrorMsg', '');
				} else if (!validateCode.valid && signupCode.length > 0) {
					self.set('signup.step2valid', false);
					self.set('validity.status',
						self.get('data.signup.inviteCodeErrorMsg.status')
					);
					self.set('inviteCodeErrorMsg',
						self.get('data.signup.inviteCodeErrorMsg.message')
					);
				} else if (signupCode.length === 0 && self.get('signup.tnc')) {
					self.set('signup.step2valid', true);
					self.set('validity.status', '');
					self.set('inviteCodeErrorMsg', '');
				} else {
					self.set('signup.step2valid', false);
				}
			}
			if (self.get('signup.inviteCode') === '') {
				self.set('validity.status', '');
				self.set('inviteCodeErrorMsg', '');
			}
		});
		self.on('*.signup', function () {
			self.set('loading', true);
			if (self.isValidOtp() && self.get('signup.tnc')) {
				var tnc = self.get('signup.tnc') === true ? 'Y' : 'N';
				var inviteCode = self.get('signup.inviteCode') ? self.get('signup.inviteCode') : 'NA';
				var submitParam = 'inviteFriend/' + inviteCode + '/NA/';
				submitParam += self.get('mobileNumber') + '/' + tnc + '/' + self.getSession('userSession');
				self.ajaxCallApi(submitParam).then(function (response) {
					if (response.status.code === 200) {
						if (response.body.hasOwnProperty('referrerCode')) {
							self.set('genericErrorMessage', '');
						} else {
							self.set('genericErrorMessage', response.body.errorMessage);
						}
					} else if (response.status.code === 600) {
						self.set('genericErrorMessage', response.body.errorMessage);
					} else {
						self.set('genericErrorMessage', response.status.message);
					}
				});
			}
			self.set('loading', false);
		});
	}
});

Ractive.components["ux-layout-box"] = Ractive.extend({
	template: LUXComponentTemplates['ux-layout-box'],
	isolated: true,
	computed: {
		$lbChildClasses: function () {
			var classList = [];
			var childrenWidthModifier = this.get('childrenWidthModifier') || [];
			var CONST = this.CONST;
			classList = classList.concat(
				childrenWidthModifier
					.filter(Boolean)
					.map(function (v) {
						return CONST.PROP_MAP.widthModifierPrefix + v;
					}));

			return classList.join(' ');
		}
	},
	CONST: {
		PROP_MAP: {
			widthModifierPrefix: 'width-mod-'
		}
	},
	handleCardClick: function (event, cardId) {
		event.original.preventDefault();

		console.group('Card Click');
		console.log('event object', event);
		console.log('card id', cardId);
		console.groupEnd();
	},

	onrender: function () {

		console.log('instance data', this.get());
		this.on('ux-card-icon.onCardClick', function (event, cardIndex) {
			this.handleCardClick(event, cardIndex);
		});
	}
});

Ractive.components["ux-load-mask"] = Ractive.extend({
	template: LUXComponentTemplates['ux-load-mask']
});

Ractive.components["ux-locate-wifi"] = Ractive.extend({
	template: LUXComponentTemplates['ux-locate-wifi'],
	filterWifiLocations: function () {

		var wifiList = this.get('locateWifiDetail');
		var locationFilter = this.get('location');
		var outletFilter = this.get('outlet');
		var wifiListFiltered = wifiList;

		if (wifiList && wifiList.length > 0) {
			wifiListFiltered = wifiList.filter(function (item) {
				var match = true;
				if (locationFilter && locationFilter !== 'all') {
					if (locationFilter !== item.wifiLocation) {
						match = false;
					}
				}
				if (outletFilter && outletFilter !== 'all') {
					if (outletFilter !== item.wifiOutlet) {
						match = false;
					}
				}
				return match;
			});
		}
		this.set('wifiList', wifiListFiltered);
		this.showWifiLocations(this.showIndex, this.wifiListsShown);
	},
	onrender: function () {
		var self = this;
		var locations = this.get('locations');
		var outlets = this.get('outlets');
	
		if (locations && locations.length > 0) {
			this.set('location', this.get('locations')[0].value);
		} else {
			this.set('location', '');
		}

		if (outlets && outlets.length > 0) {
			this.set('outlet', this.get('outlets')[0].value);
		} else {
			this.set('outlet', '');
		}

		this.observe('location outlet', function (newValue, oldValue, keypath) {
			if (newValue !== oldValue && newValue !== 'undefined' && newValue !== null) {
				this.filterWifiLocations();
			}
		}.bind(this));

		var windowInnerHeight = window.innerHeight;
		var threshold = 400;

		$(window).on('scroll', function (event) {
			var listBottom = self.find('.wifiList').getBoundingClientRect().bottom;
			if (listBottom - windowInnerHeight < threshold) {

				if (!$('#loader').hasClass('active')) {
					$('#loader').addClass('active');
				}
			
				self.showIndex++;
				self.showWifiLocations(self.showIndex, self.wifiListsShown);
			}
		});

		self.on('selectWifiLocation', function (event, selectedLocationDetails) {
			var self = this;
			if (!selectedLocationDetails) {
				selectedLocationDetails = self.get('wifiList')[0];
			}
			var selectedTitle = selectedLocationDetails.wifiTitle;
			var selectedAddress = selectedLocationDetails.wifiAddress;
			var selectedLocation = selectedLocationDetails.wifiLocationUrl;
			var openingHours = selectedLocationDetails.openingHrs;
			var coverageLocation = selectedLocationDetails.coverageLocation;
			var selectedWifiImage = selectedLocationDetails.wifiImage;
			var selectedWifiImageAlt = selectedLocationDetails.wifiImageAlt;
			self.set('selectedTitle', selectedTitle);
			self.set('selectedAddress', selectedAddress);
			self.set('selectedLocation', selectedLocation);
			self.set('openingHours', openingHours);
			self.set('coverageLocation', coverageLocation);
			self.set('selectedWifiImage', selectedWifiImage);
			self.set('selectedWifiImageAlt', selectedWifiImageAlt);
			self.handleModal(true, 'wifiHotSpotModal');
		});

		self.on('*.showMap', function (event) {
			var location = event.get('address');
			window.open('http://maps.google.com/maps?daddr=' + location);
		});

		this.showWifiLocations(this.showIndex, this.wifiListsShown);
	},
	handleModal: function (visibility, cardId) {
		var modals = this.parent.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return cardId === component.get('modalId');
		})[0];
		modal.set('displayState', visibility);
	},
	showWifiLocations: function (num, wifiListsShown) {

		var wifiList = this.get('wifiList');

		if (num === undefined) {
			num = 1;
		}
		if (wifiListsShown === undefined) {
			wifiListsShown = this.showIndex * this.wifiListsShown;
		}

		if (wifiList && wifiList.length > 0) {

			for (var i = 0; i < wifiList.length; i++) {
				if (Math.ceil((1 + i) / wifiListsShown) === num) {
					wifiList[i].display = true;
				} else if (Math.ceil((1 + i) / wifiListsShown) > num) {
					wifiList[i].display = false;
				}
			}
			this.set('wifiList', wifiList);
			$('#loader').removeClass('active');
		} else {
			this.set('showButton', false);
		}

	},
	oninit: function () {
		this.showIndex = 1;
		this.wifiListsShown = 8;
	}
});

Ractive.components["ux-loggedin-header"] = Ractive.extend({
	template: LUXComponentTemplates['ux-loggedin-header'],
	isolated: true,
	data: function () {
		return {
			moment: moment
		};
	},
	onrender: function () {
		var spacings = ['small', 'medium', 'large'];
		var headers = ['main-header', 'hero-text', 'main-dollar', 'section-header', 'product-title',
		'subsection-header', 'badges-text'];

	
		var headingStyle = this.get('headingStyle');
		headingStyle = _.indexOf(headers, headingStyle) !== -1 ?
		this.set('headingStyle', headingStyle) : this.set('headingStyle', 'main-header');

	
		var topSpacing = this.get('topSpacing');
		topSpacing = _.indexOf(spacings, topSpacing) !== -1 ?
		this.set('topSpacing', topSpacing) : this.set('topSpacing', 'normal');

	
		var btmSpcng = this.get('bottomSpacing');
		btmSpcng = _.indexOf(spacings, btmSpcng) !== -1 ?
		this.set('bottomSpacing', btmSpcng) : this.set('bottomSpacing', 'normal');

		this.set('greetings', function () {
			var greetingString = '';
			var hours  = moment(new Date()).hours();
			if (hours > 4 && hours < 12) {
				greetingString = 'Good Morning';
			} else if (hours >= 12 && hours <= 17) {
				greetingString = 'Good Afternoon';
			} else {
				greetingString = 'Good Evening';
			}
			return greetingString;
		});
		this.observe('userContext.userInfo', function () {
			var userInfo = this.get('userContext.userInfo'),
				pathName = window && window.location && window.location.pathname,
				isRedUser = this.get('isRedUser');
			if (userInfo && userInfo.contactDetails && userInfo.contactDetails.redTag === 'Y' &&
				typeof pathName === 'string' && pathName.includes('/account-summary') && !isRedUser) {
				this.set('isRedUser', true);
			}
		});
		this.on('ux-anchor.gotoProfilePageLink', function () {
			if (window && window.location) {
				var userProfileLink = ConfigStrings.pageUrls.changeDOBURL;
				window.location.href = (RactiveHelpers.modifyConfigUrl(userProfileLink) + '?isRedDetails=true');
			}
		});
		this.parent.observe('viewPersonInfo.contactInfo.personGender', function (gender) {
			if (gender) {
				var header = this.findComponent('ux-loggedin-header');
				header.setAvatar();
			}
		});
	},

	setAvatar: function () {
		var gender = this.parent.get('viewPersonInfo.contactInfo.personGender');
		if (this.get('isRedUser') && gender === 'M') {
			this.set('avatar', this.get('maleRedMemberAvatar.src'));
			this.set('alt', this.get('maleRedMemberAvatar.alt'));
		} else if (this.get('isRedUser') && gender === 'M') {
			this.set('avatar', this.get('femaleRedMemberAvatar.src'));
			this.set('alt', this.get('femaleRedMemberAvatar.alt'));
		} else if (gender === 'M') {
			this.set('avatar', this.get('maleAvatar.src'));
			this.set('alt', this.get('maleAvatar.alt'));
		} else if (gender === 'F') {
			this.set('avatar', this.get('femaleAvatar.src'));
			this.set('alt', this.get('femaleAvatar.alt'));
		} else {
			this.set('avatar', '');
			this.set('alt', '');
		}
	}
});

Ractive.components["ux-lptag-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-lptag-singtel'],

	onrender: function () {
		this.observe('productData', function (value, oldValue) {
			if (value && value !== oldValue) {
				this.triggerLpData();
			}
		}.bind(this));
		this.observe('errorData', function (value, oldValue) {
			if (value && value !== oldValue) {
				this.triggerLpData();
			}
		}.bind(this));
	},

	triggerLpData: function () {
		if (window.lpTag && window.lpTag.sdes) {
			var type2 = this.get('type2');
			var type1 = this.get('type1');
			if (type2) {
				setTimeout(function () {
					if (window.lpTag.sdes.send &&
					typeof window.lpTag.sdes.send === 'function') {
						window.lpTag.sdes.send(
						{
							'type': 'ctmrinfo',
							'info': {
								'customerId': type2
							}
						});
					}
				}, 1000);
			}
			if (type1 === 'miniCartWidget') {
				var data = this.get('productData');
				if (data) {
					setTimeout(function () {
						if (window.lpTag.sdes.send &&
							typeof window.lpTag.sdes.send === 'function') {
							window.lpTag.sdes.send(
							{
								'type': 'prodView',
								'products': data
							});
						}
					}, 1000);
				}
			}
			if (type1 === 'cart') {
				var data = this.get('productData');
				if (data) {
					setTimeout(function () {
						if (window.lpTag.sdes.send &&
							typeof window.lpTag.sdes.send === 'function') {
							window.lpTag.sdes.send(
							{
								'type': 'cart',
								'total': data.total,
								'orderId': data.orderid,
								'products': data.products
							});
						}
					}, 1000);
				}
			}
			if (type1 === 'purchase') {
				var data = this.get('productData');
				if (data) {
					setTimeout(function () {
						if (window.lpTag.sdes.send &&
							typeof window.lpTag.sdes.send === 'function') {
							window.lpTag.sdes.send(
							{
								'type': 'purchase',
								'total': data.total,
								'orderId': data.orderid,
								'cart': {
									'products': data.products
								}
							});
						}
					}, 1000);
				}
			}
			if (type1 === 'error') {
				var data = this.get('errorData');
				if (data) {
					setTimeout(function () {
						if (window.lpTag.sdes.send &&
							typeof window.lpTag.sdes.send === 'function') {
							window.lpTag.sdes.send(
							{
								'type': 'error',
								'error': {
									'message': data.message,
									'code': data.code
								}
							});
							if (data.section) {
								window.lpSection = [window.lpSection, data.section];
								window.lpTag.section = window.lpSection;
							}
						}
					}, 1000);
				}
			}
		}
	}
});

Ractive.components["ux-lux-layout"] = Ractive.extend({
	template: LUXComponentTemplates['ux-lux-layout'],
	data: function () {
			return {
				navdata: {},
				showSideNav: false
			};
		},
	onrender: function () {
		console.log(this.get('class'));
		this.on('toggleMobileMenu', function () {
			this.toggle('showSideNav');
		});

	}
});

Ractive.components["ux-marketing-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-marketing-banner']
});

Ractive.components["ux-marketing-tradein-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-marketing-tradein-banner'],
	onrender: function () {
		var self = this;

		self.on('*.tradeinWindow', function (event) {
			var modal = this.findComponent('ux-modal');
			modal.set('displayState', true);
		});

		self.set('getHideStatus', function (status) {
			var map = {
				'mobile': 'hide-for-small-only',
				'mobile-tablet': 'show-for-large-up',
				'tablet': 'hide-for-medium-only',
				'tablet-desktop': 'show-for-small-only',
				'desktop': 'hide-for-large-up',
				'mobile-desktop': 'show-for-medium-only'
			};
			return map[status];
		});

		self.set('getContentStatusOnHide', function (status) {
			var map = {
				'mobile': 'content-height',
				'mobile-tablet': 'medium-12 content-height',
				'tablet': 'medium-12 content-height',
				'tablet-desktop': 'medium-12 large-12',
				'desktop': 'large-12',
				'mobile-desktop': 'medium-12'
			};
			return map[status];
		});
	}
});

Ractive.components["ux-membershipcard-upload"] = Ractive.extend({
	template: LUXComponentTemplates['ux-membershipcard-upload'],

	oninit: function (argument) {
		this.documents = [];
		this.set('progressBarWidth', 0);
		this.set('disableUpload', '');
		this.set('displayErrorMessage', false);
		this.set('membershipCard.isMaskChecked', false);
	},

	onrender: function (argument) {
		var self = this;
		self.on('*.gotoPreviousStep', function () {
			Ractive.defaults.fire('ux-singtel-breadcrumbs.goto-prev-step');
		});

		self.on('*.doSubmit', function (event) {
			var uploadedDocuments = self.get('uploadedDocuments');
			if (uploadedDocuments && uploadedDocuments.length > 0) {
				self.fire('nextClicked', self.get());
			} else {
				self.set('displayErrorMessage', true);
			}
		});

		$('#uploadFilemembershipCard').change(function (event) {
			self.fire('fileToUpload', {
				file: event.target.files[0],
				type: 'membershipCard'
			});
			$('#uploadFilemembershipCard')[0].value = '';
		});

		self.on('*.showUploadedImage', function (evt, documentId) {
			evt.event.original.preventDefault();
			self.fire('displayUploadedImage', {
				documentId: documentId,
				type: self.get('type')
			});
		});

		self.parent.on('closeUpload', function (evt) {
			var type = self.get('type');
			if (type === evt) {
				self.set('disabled', '');
				self.set('disableUpload', 'disabled');
			}
		});

		self.parent.on('onUpload', function (evt) {
			self.set('disabled', 'disabled');
			self.set('disableUpload', '');
		});

		self.parent.on('onUploadAndNext', function (evt) {
			var type = self.get('type');
			if (type === evt) {
				self.set('disabled', '');
				self.set('disableUpload', '');
			}
		});

		self.on('ux-anchor.removeUploadedImage', function (evt, documentId) {
			evt.event.original.preventDefault();
			self.fire('removeUploadedImageFromPage', {
				documentId: documentId,
				type: self.get('type')
			});
		});

		self.on('ux-anchor.doOpenModal', function (evt, modalId) {
			self.updateModalState(modalId, true);
		});

		self.on('*.checkData', function (event) {
			self.fire('validateData', self);
		});
	},

	updateModalState: function (modalId, state, hideModal) {

		var modals = this.findAllComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];

		if (hideModal) {
			modal.set('avoidCss', true);
		}
		modal.set('displayState', state);
	}

});

Ractive.components["ux-microsite-price-plan"] = Ractive.extend({
	template: LUXComponentTemplates['ux-microsite-price-plan'],
	oninit: function () {

		this.retrieveBackgroundImages();
		this.set('pricePlanFilterData', {
			selectedPhone: this.get('filters[0].options[0].value'),
			selectedColor: this.get('filters[1].options[0].value')
		});
		this.observe('pricePlanFilterData', function (value) {
			if (value) {
				$(document).trigger('filterPricePlan');
			}
		});
		this.set('getPlanBGColor', function (plan) {
			var map = {
				'comboPlan': 'combo-plan-bg',
				'youthPlan': 'youth-plan-bg',
				'silverPlan': 'silver-plan-bg',
				'easyMobile': 'easy-mobile-bg',
				'mobileShare': 'mobile-share-bg',
				'simOnlyPlan': 'sim-only-bg'
			};
			return map[plan];
		});
		this.set('getBackgroundImageForDesktop', function (idx) {
			return this.get('data.backgroundImgDesktop')[idx].src;
		});

		this.set('getBackgroundImageForMobile', function (idx) {
			return this.get('data.backgroundImgMobile')[idx].src;
		});
	},
	retrieveBackgroundImages: function () {
		var self = this;
		var planGroups = self.get('planGroups');
		var bgImgMobile = [];
		var bgImgDesktop = [];
		_.forEach(planGroups, function (planGroup) {
			bgImgMobile.push(planGroup.metadata.backgroundImage.mobile ||
				planGroup.metadata.backgroundImage.desktop);
			bgImgDesktop.push(planGroup.metadata.backgroundImage.desktop);
		});
		self.set('backgroundImgDesktop', bgImgDesktop);
		self.set('backgroundImgMobile', bgImgMobile);
	}

});

Ractive.components["ux-microsite-stock-availability"] = Ractive.extend({
	template: LUXComponentTemplates['ux-microsite-stock-availability'],

	oninit: function () {
		var self = this;
		this.set('filterData', {
			selectedStoreType :  this.get('filters[0].options[0].value'),
			selectedPhone: this.get('filters[1].options[0].value'),
			selectedColor: this.get('filters[2].options[0].value')
		});

		self.set('filteredStock', []);
		self.set('availableStockHeaders', []);

		var filterData = self.get('filters');
		var storeType, device, color;
		_.each(filterData, function (filter) {
			if (filter.label_value === 'Store Type') {
				_.each(filter.options, function (o) {
					if (o.selected === 'true' || o.selected === true) {
						storeType = o.value;
					}
				});
			}
			if (filter.label_value === 'Phone') {
				_.each(filter.options, function (o) {
					if (o.selected === 'true' || o.selected === true) {
						device = o.value;
					}
				});
			}
			if (filter.label_value === 'Color') {
				_.each(filter.options, function (o) {
					if (o.selected === 'true' || o.selected === true) {
						color = o.value;
					}
				});
			}
		});

		var facets = {};
		facets.selectedStoreType = storeType;
		facets.selectedPhone = device;
		facets.selectedColor = color;

		this.set('filterData', facets);

		this.on('*.redirectSelection', function (anchore) {
			window.open(anchore.get('href'), '_blank');
		});

		this.observe('filterData', function (value) {
			if (value) {
				this.updateFilteredStockList();
			}
		});
	},


	updateFilteredStockList: function () {
		var self = this;
		var filterData = self.get('filterData');
		var storeType = filterData.selectedStoreType;
		var device = filterData.selectedPhone;
		var color = filterData.selectedColor;
		var stockList = self.get('stockList');
		var filteredStockListStep1 = [];
		var availableStockHeaders = [];
		_.each(stockList, function (v) {
		
			if (v.groupId.replace(/\s+/g, '').toLowerCase() === device.replace(/\s+/g, '').toLowerCase()) {
				_.each(v.items, function (k) {
				
					if (k.data.color === color) {
					
						if (!_.contains(availableStockHeaders, k.data.color + ' ' + k.data.size)) {
							availableStockHeaders.push(k.data.color + ' ' + k.data.size);
						}
						var size = k.data.color + ' ' + k.data.size;
						_.each(k.data.data, function (m) {
							if (m.storeType === storeType) {
								m.stockName = size;
								filteredStockListStep1.push(m);
							}
						});
					}
				});
			}
		});
		if (filteredStockListStep1.length > 0) {
		
			var filteredStockListStep2 = _.groupBy(filteredStockListStep1, function (g) {
				return g.storeRegion;
			});
			var filteredStockListStep3 = [];
			_.each(filteredStockListStep2, function (l) {
				var item = {};
				if (l.length > 0) {
					item.region = l[0].storeRegion;
				
					item.locations = _.groupBy(l, function (g2) {
						return g2.storeName;
					});
				
					var availableSizes = [];
					_.each(availableStockHeaders, function (ash) {
						availableSizes.push({'stockName': ash});
					});
					item.mappedLocations = [];
					_.each(item.locations, function (locationByStoreName) {
						if (locationByStoreName.length < availableStockHeaders.length) {
							var storeName;
							var tempArray =	_.union(availableSizes, locationByStoreName);
							for (var temp = 0; temp < tempArray.length; temp++) {
								if (tempArray[temp].storeName) {
									storeName = tempArray[temp].storeName;
								}
								var num = self.countDuplicateStock(tempArray, tempArray[temp].stockName);
								if (num > 1 && !tempArray[temp].storeName) {
									tempArray.splice(temp, 1);
									temp--;
								}
							}
							tempArray = _.sortBy(tempArray, function (h) {
								return parseInt(h.stockName.replace(/\D/g, '')) / 100;
							});
							var obj = {};
							obj.storeName = storeName;
							obj.stocks = tempArray;
							item.mappedLocations.push(obj);
						} else {
							var obj = {};
							obj.storeName = locationByStoreName[0].storeName;
							obj.stocks = locationByStoreName;
							item.mappedLocations.push(obj);
						}
					});
				}
				filteredStockListStep3.push(item);
			});

		
			availableStockHeaders = _.sortBy(availableStockHeaders, function (h) {
				return parseInt(h.replace(/\D/g, '')) / 100;
			});

			this.set('availableStockHeaders', availableStockHeaders);
			if (availableStockHeaders.length > 0) {
				this.set('filteredStock', filteredStockListStep3);
			} else {
				this.set('filteredStock', []);
			}
		} else {
			this.set('availableStockHeaders', []);
			this.set('filteredStock', []);
		}
	},
	countDuplicateStock: function (stocks, stockName) {
		var num = _.countBy(stocks, function (ta) {
			return ta.stockName === stockName ? true : false;
		});
		return num.true;
	}
});



Ractive.components["ux-mobile-share"] = Ractive.extend({
	template: LUXComponentTemplates['ux-mobile-share'],
	data: function () {
		return {
			'RactiveHelpers': RactiveHelpers
		};
	},
	isolated: true,
	oninit: function () {
		var self = this;
		self.on('planSelected', function (e, idx) {
			this.fire('selectedGroupType', this.get('groupType'));
			var eventName = 'onSelectPlan' + '.' + 'planSelected';
			self.fire(eventName, e.context);
			self.setSelectedState('selectedPlanState', idx);
		});

		self.on('ux-button.showLogin', function () {
			self.updateModalState('loginForm', true);
		});

		self.set('getSelectedState', function (idx) {
			return self.get('selectedPlanState.' + idx);
		});
	},
	updateModalState: function (modalId, state) {

		var modals = this.findAllChildComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];

		modal.set('displayState', state);
	},
	setSelectedState: function (state, property) {
		var selectedStateStr = state + '.' + property;
		var selectedStateObj = this.get(state);
		if (typeof selectedStateObj !== undefined) {
			_.each(selectedStateObj, function (element, key) {
				selectedStateObj[key] = '';
			});
		}
		this.set(selectedStateStr, 'selected');
		this.update();
	}

});

Ractive.components["ux-mobile-sub"] = Ractive.extend({
	template: LUXComponentTemplates['ux-mobile-sub'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			RactiveValidate: RactiveValidate,
			moment: moment,
			Recipient: {'idType': ConfigStrings.personIdTypeOptions[0].value, 'nric': null },
			Donor: {'idType': null, 'nric': null },
			currentSelection : {'serviceId' : null, 'nric': null},
			currentServiceId : null,
			isDisplayContractExpiry: false,
			palnSpecsAttributes: ConfigStrings.singtelPlanSpecs.palnSpecsAttributes,
			easyMobPalnSpecsAttributes: ConfigStrings.singtelPlanSpecs.easyMobPalnSpecsAttributes,
			isTncAgreed: false,
			isValid: {},
			isChangePlanAllowed: function (planGroupName) {
				return planGroupName === 'COMBO' || planGroupName === 'EASY' || planGroupName === 'BIGVALUE';
			},
			isSimOnlyPlan: function (product) {
				var simOnlyPlanIds = this.get('initData.simOnlyPlanIds');
				if (simOnlyPlanIds && simOnlyPlanIds.length > 0 && product.offeringId) {
					var matchFound = _.find(simOnlyPlanIds, function (simOnlyPlanId) {
						var tempPlanIds = simOnlyPlanId.split('_');
						return _.contains(tempPlanIds, product.offeringId);
					});
					if (matchFound) {
						return true;
					}
				}
				return false;
			},
			shouldHideChangePlan: function () {
				if (this.get('planIdsForHideChangePlan') &&
				this.get('planIdsForHideChangePlan').includes(this.get('product.offeringId'))) {
					return true;
				}
				return false;
			},
			shouldHideReplaceSim: function () {
				if (this.get('planIdsForHideReplaceSim') &&
				this.get('planIdsForHideReplaceSim').includes(this.get('product.offeringId'))) {
					return true;
				}
				return false;
			}
		};
	},

	oninit: function () {
		var self = this;
		self.on('*.showContractDetails', function () {
			var productFacade = self.get('productFacade');
			RactiveHelpers.toggleModal(self, 'recontractDetailsModal', true);
			console.log(productFacade.recontractData.deviceContractEndDate.format('DD/MM/YYYY'));
		});

		self.on('*.onBlurNric', function (event) {
			this.validateNRIC();
		}.bind(this));
	},
	validateNRIC: function () {
		this.nric = new RactiveValidate(this, {
			'nricTypeAndNumber': {
				required: 'Please enter details',
				nricFormat: ConfigStrings.invalidNRICFormatMsg
			}
		});
		this.nric.cwd = '';
		this.nric.patterns.nricFormat = RactiveHelpers.validateNRIC;

		var originalNric = this.get('Recipient.nric');
		var idType = this.get('Recipient.idType');
		this.set('nricTypeAndNumber', idType + originalNric);

		var isValid = this.nric.validate();
		this.set('isValid', isValid);
		return isValid.valid;
	},
	getAllProducts: function () {

	},
	showContractExpiryMsg: function (self, productDetails) {
		var simonlyPlanIds = self.get('initData.simonlyPlanIdsContractDate');
		var comboXOPlanIds = self.get('initData.comboXOPlanIdsContractDate');
		if ((simonlyPlanIds && simonlyPlanIds.split(',').includes(self.get('product.offeringId'))) ||
			(comboXOPlanIds && comboXOPlanIds.split(',').includes(self.get('product.offeringId')))) {
			var todayDate = moment(new Date()),
				contractExpiryDate = moment('31/12/1970 11:59 PM', 'DD/MM/YYYY hh:mma'),
				wifiDetailsHideDate = moment('29/01/2021 11:59 PM', 'DD/MM/YYYY hh:mma'),
				dates = {
					endDate: '',
					startDate: ''
				};
			self.setDatesFromDeviceContract(productDetails, dates);
			if (!dates.endDate) {
				self.setDatesFromServiceContract(productDetails, dates);
			}
			if (dates.endDate && dates.startDate) {
				if (simonlyPlanIds && simonlyPlanIds.split(',').includes(self.get('product.offeringId'))) {
					self.setContractExpiryTitleAndValue(true,
						moment(dates.startDate).format('DD MMM YYYY') + ' - ' +
						moment(dates.endDate).format('DD MMM YYYY'));
				} else if (dates.endDate && dates.endDate > todayDate) {
					self.setContractExpiryTitleAndValue(false, moment(dates.endDate).format('DD MMM YYYY'));
				} else if (dates.endDate && dates.endDate < todayDate) {
					if (dates.endDate > contractExpiryDate) {
						self.setContractExpiryTitleAndValue(false, 'Ended on ' +
						moment(dates.endDate).format('DD MMM YYYY'));
					} else {
						self.setContractExpiryTitleAndValue(false, 'Contract ended');
					}
				}
				if (dates.startDate < wifiDetailsHideDate) {
					self.set('product.wifiData.dateFlag', true);
				}
			}
		}
	},
	setDatesFromServiceContract: function (productDetails, dates) {
		var serviceContract;
		_.find(productDetails.services, function (service) {
			if (service && service.catalogItemID === '8026582' && service.containedServices) {
				_.each(service.containedServices, function (containedService) {
					if (containedService && containedService.catalogItemID === '11682') {
						serviceContract = containedService;
						return true;
					}
				});
			}
			return false;
		});
		if (serviceContract && serviceContract.parameters) {
			_.each(serviceContract.parameters, function (parameter) {
				if (parameter.catalogId === '8242') {
					dates.startDate = moment(parameter.valueName, 'DD/MM/YYYY hh:mma');
				} else if (parameter.catalogId === '8252') {
					dates.endDate = moment(parameter.valueName, 'DD/MM/YYYY hh:mma');
				}
			});
		}
	},
	setDatesFromDeviceContract: function (productDetails, dates) {
		var productFacade = this.get('productFacade');
		if (productFacade && productFacade.recontractData) {
			dates.startDate = productFacade.recontractData.deviceContractStartDate;
			dates.endDate = productFacade.recontractData.deviceContractEndDate;
		}
	},
	setContractExpiryTitleAndValue: function (flag, value) {
		var self = this;
		self.set('isDisplayContractExpiry', true);
		self.set('contarctExpiryValue', value);
		if (flag) {
			self.set('contarctExpiryTitle', 'Min. Subscription Period: ');
		} else {
			self.set('contarctExpiryTitle', 'Contract End Date: ');
		}
	},
	onrender: function () {
		var self = this;
		var uxService = this.parent;
		self.on('*.manageService', function () {
			uxService.parent.toggleModal('manageServiceModal', true);
			this.set('isTncAgreed', false);
			this.set('isValid', {});
			this.set('Recipient', {'idType': ConfigStrings.personIdTypeOptions[0].value, 'nric': null });
		});
		self.observe('product.productDetails', function (productDetails) {
			if (productDetails && !self.get('isDisplayContractExpiry') &&
				productDetails.planGroupName !== 'MOBILESHARE' && !productDetails.easyMobileIndX8 &&
				productDetails.lob === 'WS' && productDetails.status === 'AC') {
				self.showContractExpiryMsg(self, productDetails);
			}
		});
	}
});

Ractive.components["ux-modal-wrapper"] = Ractive.extend({
	template: LUXComponentTemplates['ux-modal-wrapper'],
	data: function () {
		return {
			'RactiveHelpers': RactiveHelpers
		};
	},
	oninit: function () {
		var self = this;
		var modalId = self.get('modalId');
		self.parent.on('openIppModal', function (event) {
			RactiveHelpers.toggleModal(self, modalId, true);
		});
		self.on('*.doCloseModal', function (event) {
			self.fire('changePlan');
		});
	}
});

Ractive.components["ux-modal"] = Ractive.extend({
	template: LUXComponentTemplates['ux-modal'],
	transitions: {
		fade: ractiveTransitionsFade
	},
	PROPS: {

				SIZE_PRESET: 'size'
	},
	SIZE_PRESET_CONFIG: {
		SMALL: {
						className: 'modal-sm'
		},
		MEDIUM: {
						className: 'modal-md'
		},
		LARGE: {
						className: 'modal-lg'
		}
	},
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},
	computed: {
		inIframe: function () {
			return RactiveHelpers.inIframe();
		},
		showModal: function () {
			return RactiveHelpers.inIframe() || !this.get('hideModal');
		},

				$sizePresetClass: function () {
			var
				props = this.get(),
				presetClassName = props[this.PROPS.SIZE_PRESET] ?
					this.SIZE_PRESET_CONFIG[props[this.PROPS.SIZE_PRESET]].className :
					null
			;

			return presetClassName;
		}
	},
	oninit: function () {
		if (this.get('hideModal') !== undefined) {
			if (RactiveHelpers.inIframe()) {
				this.set('displayState', true);
			} else {
				this.set('displayState', !this.get('hideModal'));
			}
		}
	},
	onrender: function () {
		var self = this;

		self.on('*.explicitCloseModal', function (event) {
			self.fire('doCloseModal', {
				component: self
			}, event);
		});

		self.on('*.doCloseModal doCloseModal', function () {
			if (this.get('isPModal')) {
				this.closeModal();
			} else {
				this.set('displayState', false);
				if (this.activeElement) {
					this.activeElement.focus();
				}
			}
		});

		self.on('*.doSaveModal', function () {
			this.fire('doSaveModalContent', this.get('modalId'));
		});

		this.observe('displayState', function (displayState) {
			if (!this.get('hideModal') && !this.get('avoidCss')) {
				$('body').css({
					'overflow-y': displayState ? 'hidden' : 'auto',
					'width': displayState ? '100%' : 'initial',
					'height': displayState ? '100%' : 'initial',
					'position': displayState ? ((RactiveHelpers.isBrowserIE(false) <= 0) ?
						'fixed' : 'initial') : 'initial'
				});
			}
		
			setTimeout(function () {
				if (displayState === true) {
					this.activeElement = document.activeElement;
					var focusable_selector = 'a[href], area[href], input:not([disabled]):not([type="hidden"]), ' +
						'select:not([disabled]), textarea:not([disabled]), ' +
						'button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
					var focusable = this.find('.ux-modal').querySelectorAll(focusable_selector);
					var firstFocus = focusable[0];
					var lastFocus = focusable[focusable.length - 1];
					var closeIcon = this.find('.modal-close-ext') || this.find('.close-modal');
					if (closeIcon) {
						closeIcon.focus();
					}

										lastFocus.onkeydown = function (e) {
						if ((e.which === 9 && !e.shiftKey)) {
							e.preventDefault();
							firstFocus.focus();
						}
					};

										firstFocus.onkeydown = function (e) {
						if ((e.which === 9 && e.shiftKey)) {
							e.preventDefault();
							lastFocus.focus();
						}
					};
				}
			}.bind(this), 500);
		});
		Ractive.defaults.on('openUXPModal', function (e, modalId, modalData) {
			if (self.get('modalId') === modalId) {
				if (!self.get('displayState')) {
					self.set('displayState', true);
				}
				self.openModal(modalData);
				e.original.preventDefault();
			}
		});
		Ractive.defaults.on('closeUXPModal', function (modalId) {
			if (self.get('modalId') === modalId) {
				self.closeModal();
			}
		});
	},
	openModal: function (modalData) {
		this.set('hideModal', false);
		var self = this;
		if (modalData) {
			if (typeof modalData === 'string') {
				modalData = JSON.parse(modalData);
			}
			self.set(modalData);
		}
		setTimeout(function () {
			Ractive.defaults.fire('uxModalDataModalUpdated', self,
				self.get('modalId'), modalData);
		}, 500);

		var modalDocument = this.find('.modalDocument');
		if (modalDocument) {
			this.find('.modalDocument').addEventListener('scroll', function () {
				self.scrollHandler(self.get('modalId'));
			}, false);
		}
	},
	closeModal: function () {
		var self = this;
		if (this.get('modalTitle') && this.get('displayState')) {
			var self = this;
			setTimeout(function () {
				self.set('hideModal', true);
			}, 200);
		} else {
			this.set('displayState', false);
		}
		if (this.activeElement) {
			this.activeElement.focus();
		}
		var modalDocument = this.find('.modalDocument');
		if (modalDocument) {
			this.find('.modalDocument').removeEventListener('scroll', self.scrollHandler);
		}
	},
	scrollHandler: function (modalId) {
		Ractive.defaults.fire('uxModalOnScroll', modalId);
	}
});

Ractive.components["ux-msoffice-subscription"] = Ractive.extend({
	template: LUXComponentTemplates['ux-msoffice-subscription'],
	transitions: {
		fade: ractiveTransitionsFade
	},
	data: {
		loginid: '',
		pass: '',
		RactiveHelpers: RactiveHelpers
	},
	toggleModal: function (modalId, state) {
		var modalList = this.findAllComponents('ux-modal');
		var modal = _.find(modalList, function (modal) {
			return modal.get('modalId') === modalId;
		});
		modal.set('displayState', state);
	},
	resetFields: function () {
		this.set('loading', false);
		this.set('loginid', '');
		this.set('genericErrorMessage', '');
		this.set('mobileNumberErrorMsg', '');
		this.set('callbackNameErrorMsg', '');
		this.set('validity.status', '');
		this.set('mobileNumber', '');
		this.set('emailAddress', '');
		this.set('callbackName', '');
		this.set('oneTimePin', '');
		this.set('onepassId', '');
		this.set('onepassPassword', '');
		this.set('fromRedirect', false);
		this.set('confirmOrderStatus', true);
		this.set('selectedAccountId', '');
		this.set('selectedAccountIdentifier', '');
		this.set('selectedAccountNumber', '');
		this.set('selectedAccountName', '');
		this.set('showError', '');
		this.set('showThankyou', '');
		this.set('isExisitingSubscriber', false);
		this.set('typeOfFlow', '');
		this.set('eligibilityToken', '');
		this.set('requestCallbackForm', 0);
		this.set('requestCallbackFormStatus', false);
		this.set('validateOtpForm', 0);
		this.set('mobileNumberForm', 0);
		this.set('mobileNumberFormStatus', false);
		this.set('validateOtpFormStatus', false);
		this.set('emailForm', 0);
		this.set('emailFormStatus', false);
		this.set('listAccountForm', 0);
		this.set('orderSummary', 0);
		this.set('onepassForm', 0);
		this.set('onepassFormStatus', false);
		this.set('password1', '');
		this.set('password2', '');
		this.set('ssoLoginUserid', '');
		this.set('username', '');
		this.set('tempCcode', '');
		this.set('pass', '');
		this.set('loginUserid', '');
		this.set('displayCountryCode', false);
		this.set('onepassFlow', 0);
		this.set('selectedAccountIdentifierType', '');
		this.set('warningMessageDisplay', '');
		this.set('typeOfRequest', '');
		this.set('valueOfRequest', '');
		this.set('warningMessageDisplay', '');
	},
	setTotalCost: function (subscriptionType) {
		var totalCost = subscriptionType === 'home' ? this.get('homePrice') : this.get('personalPrice');
		this.set('totalCost', totalCost);
	},
	setProductInfo: function (subscriptionType) {
		if (subscriptionType === 'home') {
			this.set('productType', 'Office365Home12Mth');
		} else {
			this.set('productType', 'Office365Pers12Mth');//change on dyn comp
		}
		this.set('selectedProduct', this.get('productName'));
	},
	setFlow: function (needle) {
		if (this.get('flow').indexOf(needle) < 0) {
			this.get('flow').push(needle);
		}
	},
	showMobileNumberForm: function () {
		this.set('flow', []);
		this.removeSession('msOfficeSession');
		this.setFlow('showMobileNumberForm');
		this.set('requestCallbackForm', 0);
		this.set('requestCallbackFormStatus', false);
		this.set('validateOtpForm', 0);
		this.set('validateOtpFormStatus', false);
		this.set('emailForm', 0);
		this.set('emailFormStatus', false);
		this.set('listAccountForm', 0);
		this.set('orderSummary', 0);
		this.set('onepassForm', 0);
		this.set('onepassFormStatus', false);
		this.set('showThankyou', '');
		this.set('showError', '');
		this.set('genericErrorMessage', '');
		this.set('warningMessageDisplay', '');
		this.set('genericErrorMessage', '');
		this.set('pass', '');
		this.set('loginUserid', '');
		this.set('loginid', '');
		this.set('displayCountryCode', false);
		this.set('mobileNumberForm', 1);
		this.set('mobileNumber', this.get('mobileNumber'));
		this.showShadow();
	},
	showValidateOtpForm: function () {
		this.setFlow('showValidateOtpForm');
		this.set('requestCallbackForm', 0);
		this.set('requestCallbackFormStatus', false);
		this.set('emailForm', 0);
		this.set('emailFormStatus', false);
		this.set('listAccountForm', 0);
		this.set('orderSummary', 0);
		this.set('onepassForm', 0);
		this.set('onepassFormStatus', false);
		this.set('mobileNumberForm', 0);
		this.set('mobileNumberFormStatus', false);
		this.set('showThankyou', '');
		this.set('showError', '');
		this.set('validateOtpForm', 1);
		this.set('genericErrorMessage', '');
		this.set('warningMessageDisplay', '');
		this.set('genericErrorMessage', '');
		this.set('pass', '');
		this.set('loginUserid', '');
		this.set('loginid', '');
		this.set('displayCountryCode', false);
		this.set('validateOtpFormStatus', false);
		this.showShadow();
	},
	showEmailForm: function () {
		this.setFlow('showEmailForm');
		this.set('requestCallbackForm', 0);
		this.set('requestCallbackFormStatus', false);
		this.set('listAccountForm', 0);
		this.set('orderSummary', 0);
		this.set('onepassForm', 0);
		this.set('onepassFormStatus', false);
		this.set('mobileNumberForm', 0);
		this.set('mobileNumberFormStatus', false);
		this.set('validateOtpForm', 0);
		this.set('validateOtpFormStatus', false);
		this.set('showThankyou', '');
		this.set('showError', '');
		this.set('emailForm', 1);
		this.set('genericErrorMessage', '');
		this.set('emailFormStatus', false);
		this.showShadow();
	},
	showOnepassForm: function () {
		this.setFlow('showOnepassForm');
		this.set('requestCallbackForm', 0);
		this.set('requestCallbackFormStatus', false);
		this.set('listAccountForm', 0);
		this.set('orderSummary', 0);
		this.set('mobileNumberForm', 0);
		this.set('mobileNumberFormStatus', false);
		this.set('validateOtpForm', 0);
		this.set('validateOtpFormStatus', false);
		this.set('emailForm', 0);
		this.set('emailFormStatus', false);
		this.set('showThankyou', '');
		this.set('showError', '');
		this.set('genericErrorMessage', '');
		this.set('warningMessageDisplay', '');
		this.set('pass', '');
		this.set('loginUserid', '');
		this.set('loginid', '');
		this.set('displayCountryCode', false);
		this.set('onepassForm', 1);
		this.set('onepassFormStatus', false);
		this.showShadow();
		this.startToTop();
	},
	showListAccountForm: function () {
		this.setFlow('showListAccountForm');
		this.set('requestCallbackForm', 0);
		this.set('requestCallbackFormStatus', false);
		this.set('orderSummary', 0);
		this.set('mobileNumberForm', 0);
		this.set('mobileNumberFormStatus', false);
		this.set('validateOtpForm', 0);
		this.set('validateOtpFormStatus', false);
		this.set('emailForm', 0);
		this.set('emailFormStatus', false);
		this.set('onepassForm', 0);
		this.set('showThankyou', '');
		this.set('showError', '');
		this.set('genericErrorMessage', '');
		this.set('warningMessageDisplay', '');
		this.set('onepassFormStatus', false);
		this.set('listAccountForm', 1);
		this.showShadow();
	},
	showOrderSummary: function () {
		this.setFlow('showOrderSummary');
		this.set('requestCallbackForm', 0);
		this.set('requestCallbackFormStatus', false);
		this.set('listAccountForm', 0);
		this.set('mobileNumberForm', 0);
		this.set('mobileNumberFormStatus', false);
		this.set('validateOtpForm', 0);
		this.set('validateOtpFormStatus', false);
		this.set('emailForm', 0);
		this.set('emailFormStatus', false);
		this.set('onepassForm', 0);
		this.set('showThankyou', '');
		this.set('showError', '');
		this.set('genericErrorMessage', '');
		this.set('warningMessageDisplay', '');
		this.set('onepassFormStatus', false);
		this.set('orderSummary', 1);
		this.showShadow();
		this.startToTop();
	},
	showRequestCallbackForm: function () {
		this.setFlow('showRequestCallbackForm');
		this.set('orderSummary', 0);
		this.set('mobileNumberForm', 0);
		this.set('mobileNumberFormStatus', false);
		this.set('validateOtpForm', 0);
		this.set('validateOtpFormStatus', false);
		this.set('emailForm', 0);
		this.set('emailFormStatus', false);
		this.set('onepassForm', 0);
		this.set('onepassFormStatus', false);
		this.set('listAccountForm', 0);
		this.set('showThankyou', '');
		this.set('genericErrorMessage', '');
		this.set('warningMessageDisplay', '');
		this.set('showError', '');
		this.set('callbackMobileNumberErrorMsg', '');
		this.set('callbackNameErrorMsg', '');
		this.set('requestCallbackForm', 1);
		this.set('requestCallbackFormStatus', false);
		this.showShadow();
		this.startToTop();
	},
	putSession: function (name, value, days) {
		var expires;

		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = '; expires=' + date.toGMTString();
		} else {
			expires = '';
		}
		var host = window.location.host;

		var domain;
		var domainParts = host.split('.');
		domainParts.shift();
		domain = '.' + domainParts.join('.');

		var finalCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
		finalCookie = finalCookie + expires + ';domain=' + domain + '; path=/';
		document.cookie = finalCookie;
	},
	getSession: function (sessionName) {
		if (document.cookie.length > 0) {
			var sessionStart = document.cookie.indexOf(sessionName + '=');
			if (sessionStart !== -1) {
				sessionStart = sessionStart + sessionName.length + 1;
				var sessionEnd = document.cookie.indexOf(';', sessionStart);
				if (sessionEnd === -1) {
					sessionEnd = document.cookie.length;
				}
				return decodeURI(document.cookie.substring(sessionStart, sessionEnd));
			}
		}
		return '';
	},
	removeSession: function (sessionName) {
		var host = window.location.host;
		var domain;
		var domainParts = host.split('.');
		domainParts.shift();
		domain = '.' + domainParts.join('.');
		var finalCookie = encodeURIComponent(sessionName) + '=';
		document.cookie = finalCookie + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=' + domain + '; path=/';
	},
	ajaxCallApi : function (apiEndpoint, method, userInput, customHeaders) {
		var self = this,
			methodType = method === '' ? 'GET' : method,
			def = $.Deferred(),
			userInput = userInput ? userInput : {},
			customHeaders = customHeaders ? customHeaders : {};

		if (methodType === 'POST') {
			customHeaders['Content-Type'] = 'application/x-www-form-urlencoded';
		} else if (methodType === 'POST-JSON') {
			methodType = 'POST';
			customHeaders['Content-Type'] = 'application/json';
		}
		self.set('loading', true);
		return $.ajax({
			type: methodType,
			cache: false,
			url: apiEndpoint,
			crossDomain: true,
			dataType: 'json',
			data: userInput,
			headers: customHeaders,
			success: function (response) {
				def.resolve(response);
				self.set('loading', false);
			},
			error: function (xhr, status, errorThrownx) {
				self.set('loading', false);
				self.set('genericErrorMessage', 'Unable to process request. Please try again.');
			}
		});
	},
	isValidMobile: function () {
		this.validateMobileNumber = new RactiveValidate(this, {
			'mobileNumber': {
				required: 'Please enter your mobile number.',
				validMobileNumber: 'Please enter a valid mobile number.',
				digits: 'Details provided are invalid. Please try again.'
			}
		});
		var validate = this.validateMobileNumber.validate();
		return validate.valid;
	},
	isValidCallbackMobileNumber: function () {
		this.validateCallbackMobileNumber = new RactiveValidate(this, {
			'callbackMobileNumber': {
				required: 'Please enter your mobile number.',
				validPhoneNumber: 'Please enter a valid mobile number.',
				digits: 'Details provided are invalid. Please try again.'
			}
		});
		var validate = this.validateCallbackMobileNumber.validate();
		return validate.valid;
	},
	isValidOtp: function () {
		this.validateOtpChars = new RactiveValidate(this, {
			'oneTimePin': {
				required: 'This field is required',
				otp: 'Details provided are invalid. An OTP requires 6-digit number'
			}
		});
		this.validateOtpChars.patterns.otp = /^[0-9]{6}$/;
		var validateOtp = this.validateOtpChars.validate();
		return validateOtp.valid;
	},
	isValidEmail: function () {
		this.validateEmailAddress = new RactiveValidate(this, {
			'emailAddress': {
				required: 'Please enter your email address.',
				email: 'Please enter a valid email address.'
			}
		});
		var validate = this.validateEmailAddress.validate();
		return validate.valid;
	},
	isValidOnepassId: function () {
		this.validateOnepassId = new RactiveValidate(this, {
			'loginid': {
				required: 'Please enter your OnePass mobile or email.'
			}
		});
		var validate = this.validateOnepassId.validate();
		return validate.valid;
	},
	isValidOnepassPassword: function () {
		this.validateOnepassPassword = new RactiveValidate(this, {
			'pass': {
				required: 'Please enter your OnePass password.'
			}
		});
		var validate = this.validateOnepassPassword.validate();
		return validate.valid;
	},
	isValidCallbackName: function () {
		this.validateName = new RactiveValidate(this, {
			'callbackName': {
				required: 'This field is required',
				fullname: 'Please enter a valid name'
			}
		});
		this.validateName.patterns.fullname = /^[a-zA-Z0-9,\.\-\/\s]+$/i;
		var validateName = this.validateName.validate();
		return validateName.valid;
	},
	isAndroid: function () {
		var ua = navigator.userAgent.toLowerCase();
		var isAndroid = ua.indexOf('android') > -1;
		return isAndroid;
	},
	startToTop: function () {
		if (this.isAndroid()) {
			var modal = document.getElementsByClassName('modal')[0];
			setTimeout(function () {
				modal.scrollTop = 0;
			}, 700);
		}
	},
	showShadow: function () {
		var modal = document.getElementsByClassName('modal')[0];
		if (modal) {
			var header = document.getElementsByClassName('fixed-header')[0];
			var footer = document.getElementsByClassName('fixed-footer')[0];
			var content = document.getElementsByClassName('scrollable-section')[0];
			var windowWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
			var headerFooterHeight = header.clientHeight + footer.clientHeight;
			var allowableHeight = modal.offsetHeight - headerFooterHeight;

			if (windowWidth > 769) {
				if (content.clientHeight > allowableHeight) {
					footer.classList.add('content-overflow');
				} else {
					footer.classList.remove('content-overflow');
				}
				var contentWithShadowHeight = parseInt(allowableHeight) + 16;
				content.setAttribute('style', 'height:' + contentWithShadowHeight + 'px');
			} else {
				content.removeAttribute('style');

				if (content.clientHeight > allowableHeight) {
					footer.classList.add('content-overflow');
				} else {
					footer.classList.remove('content-overflow');
				}
				content.setAttribute('style', 'padding-bottom:30px');
			}
		}
	},
	isValidOnepassIdPassword : function (ractive) {
		var loginidClass = '';
		var passClass = '';

		var warningMessageDisplay = '';
		if (ractive.get('loginid') === '') {
			loginidClass = 'warningInput';
			warningMessageDisplay = 'Please enter your Login ID.';
		} else if (ractive.get('pass') === '') {
			passClass = 'warningInput';
			warningMessageDisplay = 'Please enter your password.';
		}
		ractive.set('warningMessageDisplay', warningMessageDisplay);
		ractive.set('loginidClass', loginidClass);
		ractive.set('passClass', passClass);

		if (warningMessageDisplay) {
			return false;
		} else {
			return true;
		}
	},
	getTypeOfFlow: function (param) {
		switch (param) {
			case 'MTMO':
				return 'postpaid';
			case 'MTBB':
				return 'broadband';
			case 'SG':
				return 'broadband';
		}
	},
	getProductName: function (param) {
		switch (param) {
			case 'MTMO':
				return 'Singtel Postpaid Mobile';
			case 'MTBB':
				return 'Singtel Mobile Broadband';
			case 'SG':
				return 'Singtel Fibre Broadband';
		}
	},
	getAllowedAccounts: function (obj) {
		var allowedServices = ['MTMO', 'MTBB', 'SG'];
		var accounts = _.filter(obj, function (obj) {
			return allowedServices.indexOf(obj.identifierType) >= 0;
		});
		return accounts;
	},
	getMaskedAccount: function (param) {
		var identifierLn = param.length;
		return '****' + param.substring(identifierLn / 2, identifierLn);
	},
	isSubscribed: function (obj) {
		var accounts =  this.getAllowedAccounts(obj);
		var subscribedAccounts = _.filter(accounts, function (o) {
			return o.allowSubscribe === 'N' || o.status !== 'Active';
		});
		return subscribedAccounts;
	},
	filterSubscribed: function (obj) {
		var accounts =  this.getAllowedAccounts(obj);
		var allowedToSubscribe = _.filter(accounts, function (o) {
			return o.allowSubscribe === 'Y' && o.status === 'Active';
		});
		return allowedToSubscribe;
	},

	suspendedAccounts: function (customerDetails) {
		return _.filter(customerDetails, function (o) {
			return o.status === 'Suspended';
		});
	},
	setServices: function () {
		var self = this;
		var allowedServices = self.get('services');
		var allowedServicesLn = allowedServices.length;
		if (allowedServicesLn === 1) {
			var service = _.first(allowedServices);
			self.set('selectedAccountIdentifierType', service.identifierType);
			self.set('typeOfFlow', self.getTypeOfFlow(service.identifierType));
			self.set('selectedAccountName', self.getProductName(service.identifierType));
			self.set('maskedAccount', self.getMaskedAccount(service.identifier));
			self.set('selectedAccountId', service.id);
			self.set('selectedAccountIdentifier', service.identifier);
			self.showEmailForm();
		} else if (allowedServicesLn > 1) {
			var newServiceList = _.map(allowedServices, function (o) {
				return _.extend({
					'accountName': self.getProductName(o.identifierType),
					'maskedAccount': self.getMaskedAccount(o.identifier)
				}, o);
			});
			self.set('services', newServiceList);

			var firstService = _.first(newServiceList);
			self.set('selectedAccountIdentifierType', firstService.identifierType);
			self.set('typeOfFlow', self.getTypeOfFlow(firstService.identifierType));
			self.set('selectedAccountName', self.getProductName(firstService.identifierType));
			self.set('maskedAccount', self.getMaskedAccount(firstService.identifier));
			self.set('selectedAccountId', firstService.id);
			self.set('selectedAccountIdentifier', firstService.identifier);

			self.showListAccountForm();
		} else {
			self.resetFields();
			self.set('showError', 'ineligible');
		}
	},
	setProductType: function (subscriptionType, selectedAccountIdentifierType) {
		var self = this;
		var productType;
		var productTypes = {
			'personal': {'mobile': 'Office365Pers12Mth', 'broadband': 'BBOffice365Pers12Mth'},
			'home': {'mobile': 'Office365Home12Mth', 'broadband': 'BBOffice365Home12Mth'}
		};

		if (subscriptionType === 'home') {
			switch (selectedAccountIdentifierType) {
				case 'MT':
					productType = productTypes.home.mobile;
					break;
				default:
					productType = productTypes.home.broadband;
			}
		} else {
			switch (selectedAccountIdentifierType) {
				case 'MT':
					productType = productTypes.personal.mobile;
					break;
				default:
					productType = productTypes.personal.broadband;
			}
		}
		self.set('productType', productType);
	},
	oninit: function () {
		var self = this;
		self.on('*.fireLoginEvent', function (result) {
			if (result) {
				self.fire('*.' + result);
			}
			return false;
		}.bind(self));

		self.set('forgetPasswordURL', self.get('forgotPasswordUrl'));
		self.set('serverSuccessCallBackURL', JSON.parse(JSON.stringify('' + self.get('succesCallBackURL'))));
		self.set('serverTargetURL', JSON.parse(JSON.stringify('' + self.get('targetURL'))));
	},
	onrender: function () {
		var self = this;
				self.on('ux-anchor.showModal', function (event, subscriptionType) {
			var sessionId = self.getSession('msOfficeSession');
			if (sessionId) {
				self.removeSession('msOfficeSession');
			}
			self.set('callbackMobileNumber', '');
			self.set('enteredMobileNumber', '');
			self.resetFields();
			self.toggleModal(subscriptionType + 'Modal', true);
			self.set('subscriptionType', subscriptionType);
			self.setTotalCost(subscriptionType);
			self.setProductInfo(subscriptionType);
			self.showMobileNumberForm();
		});
				self.set('ribbon', self.get('pannelRibbonText'));
		self.set('selectedCountryCode', self.get('countryList')[0].countryCode);
		if (self.get('subscriptionType') === 'home') {
			self.set('panelPrice', self.get('homePrice'));
			self.set('panelUsualPrice', self.get('homeUsualPrice'));
		} else {
			self.set('panelPrice', self.get('personalPrice'));
			self.set('panelUsualPrice', self.get('personalUsualPrice'));
		}
				self.on('*.goBack', function (event) {
			if (self.get('flow').length > 1) {
				self.get('flow').pop();
			}
			switch (self.get('flow')[self.get('flow').length - 1]) {
				case 'showMobileNumberForm':
					var mobile = self.get('mobileNumber');
					self.resetFields();
					self.removeSession('msOfficeSession');
					self.showMobileNumberForm();
					self.set('mobileNumber', mobile);

					if (mobile && self.isValidMobile()) {
						self.set('mobileNumberFormStatus', true);
						self.set('mobileNumberErrorMsg', '');
					} else {
						var errorMsg = self.get('data.emailAddressErrorMsg.message');
						self.set('mobileNumberFormStatus', false);
						self.set('mobileNumberErrorMsg', errorMsg);
					}

					if (self.get('enteredMobileNumber')) {
						self.set('mobileNumber', self.get('enteredMobileNumber'));
					}
					break;
				case 'showValidateOtpForm':
					var msOfficeSession = self.getSession('msOfficeSession');
					if (msOfficeSession) {
						self.get('flow').pop();
						self.fire('*.goBack');
					} else {
						self.showValidateOtpForm();
					}
					break;
				case 'showEmailForm':
					self.showEmailForm();
					var email = self.get('emailAddress');
					if (email && self.isValidEmail()) {
						self.set('emailFormStatus', true);
						self.set('emailAddressErrorMsg', '');
					} else {
						self.set('emailAddressErrorMsg', self.get('data.emailAddressErrorMsg.message'));
						self.set('emailFormStatus', false);
					}
					break;
				case 'showOnepassForm':
					var msOfficeSession = self.getSession('msOfficeSession');
					if (msOfficeSession) {
						self.get('flow').pop();
						self.fire('*.goBack');
					} else {
						self.showValidateOtpForm();
					}
					break;
				case 'showListAccountForm':
					self.showListAccountForm();
					break;
				case 'showOrderSummary':
					self.set('confirmOrderStatus', true);
					self.showOrderSummary();
					break;
				case 'showRequestCallbackForm':
					self.showRequestCallbackForm();
					break;
			}
		});

		self.on('*.needOnepassCheck', function () {
			var checkOnepassParam = ConfigStrings.express.needOnepassCheckApi;
			var applicationId = ConfigStrings.express.office365AppId;
			if (self.get('needOnepassCheckApi')) {
				checkOnepassParam = self.get('needOnepassCheckApi');
			}
			self.ajaxCallApi(checkOnepassParam, 'POST', {
				serviceNumber: self.get('mobileNumber'),
				appId: applicationId
			}).then(function (response) {
				if (typeof response.error !== 'undefined') {
					var error = parseInt(response.error);
					if (error === 2009) {
					
						self.set('mobileNumberErrorMsg', 'Unable to process request. Please try again.');
					} else if (error === 1003) {
						self.set('mobileNumberErrorMsg', 'Invalid mobile number');
					} else {
						self.set('callbackMobileNumber', self.get('mobileNumber'));
						self.resetFields();
						self.set('mobileNumberForm', 0);
						self.set('showError', 'hasCallback');
					}
				} else {
					var responseNeedOnepass = parseInt(response.needOnePassCheck);
					if (responseNeedOnepass === 1) {
						self.set('services', []);
						self.showValidateOtpForm();
					} else if (responseNeedOnepass === 2) {
						self.set('mobileNumberForm', 0);
						self.set('callbackMobileNumber', self.get('mobileNumber'));
						self.set('showError', 'ineligible');
					} else if (responseNeedOnepass === 3) {
						self.set('onepassFlow', 1);
						self.set('services', []);
						self.showValidateOtpForm();
					} else {
						self.resetFields();
						self.set('mobileNumberForm', 0);
						self.set('showError', 'hasCallback');
					}
				}
			});
		});
				self.on('*.checkEligibility', function (event, sessionId) {
			var eligibilityParam = ConfigStrings.express.checkEligibilityApi;
			var idType = self.get('typeOfRequest') === 'nric' ? 2 : 1;

			if (self.get('checkEligibilityApi')) {
				eligibilityParam = self.get('checkEligibilityApi');
			}

			self.ajaxCallApi(eligibilityParam, 'POST', {
				type: idType,
				productCode: 'OFFICE_365_MOBILE'
			}, {
				'Authorization-Sessionid': sessionId,
				'Authorization-Mobile': self.get('mobileNumber'),
				'Authorization-AppId': ConfigStrings.express.office365AppId
			}).then(function (response) {
				if (typeof response.error !== 'undefined') {
					self.set('onepassForm', 0);
					self.set('loading', false);
					self.set('callbackMobileNumber', self.get('mobileNumber'));
					self.resetFields();
					self.set('showError', 'hasCallback');
				} else {
					var isNotBlacklisted = parseInt(response.creditRiskRating) === 0;
					var isResidential = parseInt(response.customerType) === 11;
					var isCisConsumer = parseInt(response.customerType) === 34;
					if ((isResidential || isCisConsumer) && isNotBlacklisted) {
						var allowedServices = self.getAllowedAccounts(response.ownServiceDetails);
						var allowedServicesLn = allowedServices.length;
						var accounts = self.filterSubscribed(allowedServices);
						var isSubscribed = self.isSubscribed(response.ownServiceDetails);
						if (allowedServicesLn === 0) {
							self.set('callbackMobileNumber', self.get('mobileNumber'));
							self.resetFields();
							self.set('showError', 'ineligible');
						} else if (isSubscribed.length > 0 && allowedServicesLn === isSubscribed.length) {
							self.set('callbackMobileNumber', self.get('mobileNumber'));
							self.resetFields();
							self.set('showError', 'subscribed');
						} else if (allowedServicesLn >= 1 && accounts.length > 0) {
							self.set('services', accounts);
							self.setServices();
						} else {
							self.set('callbackMobileNumber', self.get('mobileNumber'));
							self.resetFields();
							self.set('showError', 'ineligible');
						}
					} else {
						self.set('onepassForm', 0);
						self.set('loading', false);
						self.set('callbackMobileNumber', self.get('mobileNumber'));
						self.resetFields();
						self.set('showError', 'ineligible');
					}
				}
			});
		});

				self.on('*.submitOneTimePin', function () {
			self.set('genericErrorMessage', '');
			var mobileNumber = self.get('mobileNumber');
			var otpValue = self.get('oneTimePin');
			var validateOTPApi = ConfigStrings.express.validateOTPApi;
			if (self.get('validateOTPApi')) {
				validateOTPApi = self.get('validateOTPApi');
			}
			var validateParam = validateOTPApi;
			if (!isNaN(otpValue)) {
				self.ajaxCallApi(validateParam, 'POST-JSON', JSON.stringify({
					mobileNumber: mobileNumber,
					otp: otpValue
				})).then(function (response) {
					if (response.status.code === 200) {
						if (response.body.isValid === true) {
							var sessionId = response.body.sessionId;
							self.putSession('msOfficeSession', sessionId, 0.5);
							if (self.get('onepassFlow') === 1) {
								self.showOnepassForm();

								self.set('loginid', '');
								self.set('pass', '');

								var iframeParent = document.getElementById('iframeParent');
								var logoutIframe = document.createElement('iframe');

								logoutIframe.frameBorder = 0;
								logoutIframe.width = '1px';
								logoutIframe.height = '1px';
								logoutIframe.id = 'logoutIframe';
								logoutIframe.src = self.get('logoutUrl');

								var doc;
								if (iframeParent.contentDocument) {
									doc = iframeParent.contentDocument;
								} else if (iframeParent.contentWindow) {
									doc = iframeParent.contentWindow.document;
								}
								doc.open();
								doc.writeln('<iframe src="' + self.get('logoutUrl') + '"></iframe>');
								doc.close();

							} else {
								self.set('oneTimePinErrorMessage', '');
								self.set('genericErrorMessage', '');
								self.set('validity.status', '');
								self.set('typeOfRequest', 'mobile');
								self.set('valueOfRequest', self.get('mobileNumber'));
								self.fire('*.checkEligibility', '', sessionId);
							}
						} else {
							self.set('validity.status', 'error');
							self.set('oneTimePinErrorMessage', 'Invalid OTP, please re-enter or re-send OTP.');
						}
					} else if (response.status.code === 600) {
						self.set('validity.status', 'error');
						self.set('genericErrorMessage', response.body.errorMessage);
					} else {
						self.set('validity.status', 'error');
						self.set('genericErrorMessage', response.status.message);
					}
				});
			} else {
				self.isValidOtp();
				self.set('validity.status', self.get('oneTimePinErrorMsg.status'));
				self.set('oneTimePinErrorMessage', self.get('oneTimePinErrorMsg.message'));
				self.showValidateOtpForm();
			}
		});
		self.on('*.confirmOrder', function () {
			self.set('confirmOrderStatus', false);
			var orderParam = ConfigStrings.express.provisionApi;
			var serviceType = self.get('selectedAccountIdentifierType');
			var idType = self.get('typeOfRequest') === 'nric' ? 2 : 1;
			if (serviceType === 'MTMO' || serviceType === 'MTBB') {
				self.set('selectedAccountIdentifierType', 'MT');
			}
						self.setProductType(self.get('subscriptionType'), self.get('selectedAccountIdentifierType'));
			self.ajaxCallApi(orderParam, 'POST', {
				serviceNumber: self.get('selectedAccountIdentifier'),
				serviceType: self.get('selectedAccountIdentifierType'),
				productType: self.get('productType'),
				contactEmail: self.get('emailAddress'),
				contactSmsNo: self.get('mobileNumber'),
				productCode: 'OFFICE_365_MOBILE',
				type: idType
			}, {
				'Authorization-Sessionid': self.getSession('msOfficeSession'),
				'Authorization-Mobile': self.get('mobileNumber'),
				'Authorization-AppId': ConfigStrings.express.office365AppId
			}).then(function (response) {
				if (typeof response.error !== 'undefined') {
					self.set('callbackMobileNumber', self.get('mobileNumber'));
					self.resetFields();
					self.set('showError', 'hasCallback');
				} else {
					if (response.provisionOrderNumber.length > 0 && response.status === '000') {
						self.set('orderSummary', 0);
						self.set('showThankyou', self.get('typeOfFlow'));
						self.removeSession('mobileNumber');
						self.removeSession('subscriptionType');
						self.removeSession('msOfficeSession');
					} else {
						self.resetFields();
						self.set('showError', 'hasCallback');
					}
				}
			}).fail(function () {
				self.set('confirmOrderStatus', true);
			});
		});
		self.on('*.submitCallback', function () {
			var callbackParam = ConfigStrings.express.requestCallbackApi;
			self.ajaxCallApi(callbackParam, 'POST', {
				name: self.get('callbackName'),
				phone: self.get('callbackMobileNumber'),
				productName: self.get('selectedProduct')
			}).then(function (response) {
				self.resetFields();
				if (response.success === true) {
					self.removeSession('msOfficeSession');
					self.resetFields();
					self.set('showThankyou', 'callback');
				} else {
					self.resetFields();
					self.set('showError', 'hasCallback');
				}
			});
		});
		self.on('*.showOrderSummary', function () {
			self.set('currentDate', moment().format('ddd DD MMM YYYY'));
			self.showOrderSummary();
		});
		self.on('*.showRequestCallbackForm', function () {
			self.showRequestCallbackForm();
			if (self.get('mobileNumber')) {
				self.set('callbackMobileNumber', self.get('mobileNumber'));
			}
		});
		self.on('*.setAccountToBill', function (event, id, name, identifierType) {
			self.set('selectedAccountIdentifier', id);
			self.set('selectedAccountName', name);
			self.set('selectedAccountIdentifierType', identifierType);
			self.set('maskedAccount', self.getMaskedAccount(id));
			self.set('typeOfFlow', self.getTypeOfFlow(identifierType));
		});
		self.on('*.showEmailForm', function () {
			var email = self.get('emailAddress');
			self.showEmailForm();
			self.set('emailAddressErrorMsg', '');
			if (email && self.isValidEmail()) {
				self.set('emailFormStatus', true);
			} else {
				self.set('emailFormStatus', false);
			}
		});

		var timeout;
		self.on('*.submitOnepass', function (event) {
			self.set('loading', true);
			document.getElementById('onepassLoginButton').click();
			timeout = window.setTimeout(function () {
				self.fire('*.failure');
				if (window.stop()) {
					window.stop();
				}
				if (navigator.appName === 'Microsoft Internet Explorer') {
					window.frames[0].document.execCommand('Stop');
				} else {
					window.frames[0].stop();
				}
			}, 5000);
		});
				self.on('*.success', function (event) {
			window.clearTimeout(timeout);
			var sessionId = self.getSession('msOfficeSession');
			self.set('typeOfRequest', 'nric');
			self.fire('*.checkEligibility', '', sessionId);
		});
		self.on('*.failure', function (event) {
			self.set('loading', false);
			self.set('warningMessageDisplay', 'You have entered invalid User ID and/or password. Please re-try.');
			return false;
		});

				self.observe('mobileNumber', function (newVal, oldVal, keypath) {
			self.set('genericErrorMessage', '');
			if (!newVal) {
				self.set('data.mobileNumber', oldVal);
			} else {
				self.set('data.mobileNumber', newVal);
			}
			var mobileNumber = self.get('data.mobileNumber');
			if (mobileNumber) {
				var firstCharacter = parseInt(mobileNumber.toString().charAt(0));
				if (firstCharacter !== 8 && firstCharacter !== 9) {
					self.set('mobileNumberFormStatus', false);
					self.set('validity.status', 'error');
					self.set('mobileNumberErrorMsg', 'Please enter a valid mobile number.');
				} else {
					self.set('validity.status', '');
					self.set('mobileNumberErrorMsg', '');
				}
			} else {
				self.set('mobileNumberErrorMsg', '');
			}
			if (mobileNumber && mobileNumber.length === 8) {
				if (self.isValidMobile()) {
					self.set('mobileNumberFormStatus', true);
					self.set('mobileNumberErrorMsg', '');
					self.set('validity.status', '');
					self.set('enteredMobileNumber', JSON.parse(JSON.stringify('' + mobileNumber)));
				} else {
					self.set('mobileNumberErrorMsg', self.get('data.mobileNumberErrorMsg.message'));
					self.set('mobileNumberFormStatus', false);
				}
			} else {
				self.set('mobileNumberFormStatus', false);
			}

			if (!newVal) {
				self.set('mobileNumberErrorMsg', '');
			}
		});
				self.observe('oneTimePin', function (newVal, oldVal, keypath) {
			self.set('genericErrorMessage', '');
			self.set('data.' + keypath, newVal);

			if (newVal && newVal.toString().length >= 6) {
				if (self.isValidOtp()) {
					self.set('validateOtpFormStatus', true);
					self.set('validity.status', '');
					self.set('oneTimePinErrorMessage', '');
				} else {
					self.set('validateOtpFormStatus', false);
					self.set('validity.status', self.get('data.' + keypath + 'ErrorMsg.status'));
					self.set('oneTimePinErrorMessage',
						self.get('data.' +  keypath + 'ErrorMsg.message')
					);
				}
			} else {
				self.set('validity.status', 'error');
				self.set('oneTimePinErrorMessage', '');
				self.set('validateOtpFormStatus', false);
			}

			if (!newVal) {
				self.set('oneTimePinErrorMessage', '');
			}
		});
				self.observe('emailAddress', function (newVal, oldVal, keypath) {
			self.set('genericErrorMessage', '');
			self.set('data.emailAddress', newVal);
			var emailAddress = self.get('data.emailAddress');
			if (emailAddress) {
				if (self.isValidEmail()) {
					self.set('emailFormStatus', true);
					self.set('emailAddressErrorMsg', '');
					self.set('validity.status', '');
				} else {
					self.set('emailAddressErrorMsg', self.get('data.emailAddressErrorMsg.message'));
					self.set('emailFormStatus', false);
				}
			} else {
				self.set('emailFormStatus', false);
			}

			if (!newVal) {
				self.set('emailAddressErrorMsg', '');
			}
		});
				self.observe('callbackName', function (newVal, oldVal, keypath) {
			self.set('genericErrorMessage', '');
			if (!newVal) {
				self.set('data.callbackName', oldVal);
			} else {
				self.set('data.callbackName', newVal);
			}
			var callbackName = self.get('data.callbackName');
			if (callbackName) {
				if (self.isValidCallbackName()) {
					self.set('callbackNameErrorMsg', '');
					self.set('validity.status', '');
				} else {
					self.set('callbackNameErrorMsg', self.get('data.callbackNameErrorMsg.message'));
				}
			}

			if (self.isValidCallbackMobileNumber() && self.isValidCallbackName()) {
				self.set('requestCallbackFormStatus', true);
			} else {
				self.set('requestCallbackFormStatus', false);
			}

			if (!newVal) {
				self.set('callbackNameErrorMsg', '');
			}
		});
				self.observe('callbackMobileNumber', function (newVal, oldVal, keypath) {
			self.set('genericErrorMessage', '');
			if (!newVal) {
				self.set('data.callbackMobileNumber', oldVal);
			} else {
				self.set('data.callbackMobileNumber', newVal);
			}
			var callbackMobileNumber = self.get('data.callbackMobileNumber');
			if (callbackMobileNumber) {
				var firstCharacter = parseInt(callbackMobileNumber.toString().charAt(0));
				if (firstCharacter !== 8 && firstCharacter !== 9) {
					self.set('requestCallbackStatus', false);
					self.set('validity.status', 'error');
					self.set('callbackMobileNumberErrorMsg', 'Please enter a valid mobile number.');
				} else {
					self.set('validity.status', '');
					self.set('callbackMobileNumberErrorMsg', '');
				}
			} else {
				self.set('callbackMobileNumberErrorMsg', '');
			}
			if (callbackMobileNumber && callbackMobileNumber.length === 8) {
				if (self.isValidCallbackMobileNumber()) {
					self.set('callbackMobileNumberErrorMsg', '');
					self.set('validity.status', '');
				} else {
					self.set('callbackMobileNumberErrorMsg', self.get('data.callbackMobileNumberErrorMsg.message'));
				}
			}

			if (self.isValidCallbackMobileNumber() && self.isValidCallbackName()) {
				self.set('requestCallbackFormStatus', true);
			} else {
				self.set('requestCallbackFormStatus', false);
			}

			if (!newVal) {
				self.set('callbackMobileNumberErrorMsg', '');
			}
		});
						self.observe('loginid', function (newVal, oldVal, keypath) {
			self.set('genericErrorMessage', '');
			self.set('data.loginid', newVal);
			var onepassId = newVal;
			if (onepassId) {
				if (self.isValidOnepassId()) {
					self.set('onepassIdErrorMsg', '');
					self.set('validity.status', '');
				} else {
					self.set('loginidErrorMsg', self.get('data.loginidErrorMsg.message'));
				}

				if (self.isValidOnepassPassword() && self.isValidOnepassId()) {
					self.set('onepassFormStatus', true);
				} else {
					self.set('onepassFormStatus', false);
				}
			}

			if (!newVal) {
				self.set('loginidErrorMsg', '');
			}
		});
		self.observe('pass', function (newVal, oldVal, keypath) {
			self.set('genericErrorMessage', '');
			self.set('data.pass', newVal);
			var onepassPassword = newVal;
			if (onepassPassword) {
				if (self.isValidOnepassPassword()) {
					self.set('passErrorMsg', '');
					self.set('validity.status', '');
				} else {
					self.set('passErrorMsg', self.get('data.passErrorMsg.message'));
				}
				if (self.isValidOnepassPassword() && self.isValidOnepassId()) {
					self.set('onepassFormStatus', true);
				} else {
					self.set('onepassFormStatus', false);
				}
			} else {
				self.set('onepassFormStatus', false);
			}
		});
		self.on('*.scrollTop', function (event) {
			var modal = document.getElementsByClassName('modal')[0];
			if (self.isAndroid()) {
				setTimeout(function () {
					var totalScroll = modal.scrollTop + event.el.getBoundingClientRect().top;
					modal.scrollTop = totalScroll;
				}, 750);
			}
		});
		window.addEventListener('resize', _.debounce(function (e) {
			self.showShadow();
		}, 300));
	}
});

Ractive.components["ux-msta-existing-addon"] = Ractive.components['ux-addon-singtel'].extend({
	template: LUXComponentTemplates['ux-msta-existing-addon'],
	isolated: true,
	oninit: function () {
		this._super();
		this.set('cropTextConfig', ConfigStrings.mstaCropTextConfig);
		this.on('ux-anchor.resendActivationLink', function (event) {
			this.fire('resendActivationLinkEvent', this.get('addon'));
		}.bind(this));
	}
});

Ractive.components["ux-msta-new-addon"] = Ractive.components['ux-addon-singtel'].extend({
	template: LUXComponentTemplates['ux-msta-new-addon'],
	isolated: true
});

Ractive.components["ux-multi-select"] = Ractive.extend({
	template: LUXComponentTemplates['ux-multi-select'],
	isolated: true,
	computed: {
		guid: function () {
			return this._guid;
		}
	},
	oninit: function () {
		this.set('parentGuid', this._guid);
		this.set('isDisplay', false);
		var allOptions = this.get('options');
		_.each(allOptions, function (obj) {
			obj.selected = false;
		});
		this.set('options', allOptions);
		this.set('isDisplay', true);
		var self = this;
		$(window).on('click touchstart', function (event) {
			if (!(event.target.matches('.select-value') || event.target.matches('.select') ||
			event.target.matches('.icon-arrow-down'))) {
				if (!(event.target.closest('.multi-options') &&
				event.target.closest('.multi-options').classList.contains('show'))) {
					var dropdowns = document.getElementsByClassName('multi-options show');
					this._.each(dropdowns, function (list) {
						if (list) {
							self.set('open', false);
						}
					});
				}
			} else {
				var dropdowns = document.getElementsByClassName('multi-options show');
				this._.each(dropdowns, function (list) {
					if (list && event.target.offsetParent.id !== list.id) {
						self.set('open', false);
					}
				});
			}
		});
	},
	onrender: function () {
		this.set('open', false);
		var selected_option = this.get('selected_option');
		if (selected_option) {
			var options = this.get('options');
			var index = _.findIndex(options, function (el) {
				return el.value === selected_option;
			});
			if (index !== -1) {
				options[index].selected = true;
				this.set('options', options);
				this.set('selectedTitle', options[index].title || options[index].text);
			} else {
				this.set('selectedTitle', 'All');
			}
		} else {
			this.set('selectedTitle', 'All');
		}
		this.on('showTooltip', function (event) {

			if (event.original.currentTarget.nextElementSibling.style.display !== 'block') {
				_.each(document.getElementsByClassName('tooltip'), function (v) {
					v.style.display = 'none';
				});
				event.original.currentTarget.nextElementSibling.style.display = 'block';
			} else {
				event.original.currentTarget.nextElementSibling.style.display = 'none';
			}

			return false;
		});
	},
	onconfig: function () {
		this.observe('options', function (option) {
			if (option && this.get('isDisplay')) {
				var titleToDisplay = [];
				var selectedOption = [];
				var fireEvent = this.get('onChangeEvent');
				_.each(option, function (el) {
					if (el.selected) {
						titleToDisplay.push(el.text);
						selectedOption.push(el);
					}
				});
				if (titleToDisplay.length) {
					this.set('selectedTitle', titleToDisplay.toString());
				} else {
					this.set('selectedTitle', 'All');
				}
				if (fireEvent) {
					this.fire(fireEvent, selectedOption);
				}
			}
		});
		this.observe('selectedData', function (value) {
			if (value) {
				this.set('selected_value', value);
			}
		});
		this.on('onChange', function (event) {
			var fireEvent = this.get('onChangeEvent');
			if (fireEvent) {
				var selectedIndex = event.original.target.selectedIndex;
				var selectedOptionData = {};
				if (this.get('defaultOption')) {
					selectedIndex = selectedIndex - 1;
					if (selectedIndex > -1) {
						selectedOptionData = this.get('options.' + selectedIndex);
					}
				} else {
					selectedOptionData = this.get('options.' + selectedIndex);
				}
				var flag = this.get('onChangeEventContext');
				var name = this.get('name');
				if (flag) {
					name = this;
				}
				if (!name) {
					name = this.get('selected_value');
				}
				this.fire(fireEvent, name, selectedOptionData, selectedIndex);
				return false;
			}
		});
		this.on('focusHandler', function () {
			this.toggle('focusStatus');
		});
		this.on('ux-anchor.open', function (event) {
			this.toggle('open');
		});
	}
});

Ractive.components["ux-need-help-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-need-help-banner']
});

Ractive.components["ux-news-bulletin"] = Ractive.extend({
	template: LUXComponentTemplates['ux-news-bulletin'],

	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},

	oninit: function () {
		var self = this;
		var backgroundImage = self.get('backgroundImage.mobile.src') || self.get('backgroundImage.desktop.src');
		self.set('backgroundImgDesktop', self.get('backgroundImage.desktop.src'));
		self.set('backgroundImgMobile', backgroundImage);
		self.set('backgroundImgDesktopPosition', self.get('backgroundImage.desktop.imagePosition'));
		self.set('backgroundImgDesktopSize', self.get('backgroundImage.desktop.imageSize'));
		self.set('backgroundImgMobilePosition',
			self.get('backgroundImage.mobile.imagePosition') || self.get('backgroundImage.desktop.imagePosition'));
		self.set('backgroundImgMobileSize',
			self.get('backgroundImage.mobile.imageSize') || self.get('backgroundImage.desktop.imageSize'));

		self.set('foregroundImgDesktopPosition', self.get('foregroundImg.desktop.imagePosition'));
		self.set('foregroundImgDesktopSize', self.get('foregroundImg.desktop.imageSize'));
		self.set('foregroundImgMobilePosition',
			self.get('foregroundImg.mobile.imagePosition') || self.get('foregroundImg.desktop.imagePosition'));
		self.set('foregroundImgMobileSize',
			self.get('foregroundImg.mobile.imageSize') || self.get('foregroundImg.desktop.imageSize'));
	},

	onrender: function () {
		var self = this;

		self.on('ux-anchor.navigateToURL', function (event) {
			var linkURL = event.get('linkto');
			if (self.get('openNewWindow') === 'true' || self.get('openNewWindow') === true) {
				window.open(linkURL, '_blank');
			} else {
				window.open(linkURL, '_self');
			}

		});

		this.on('*.showAllBulletinNews', function (event, value) {
			this.setModalDisplayState('showAllNews', true);
		}.bind(this));
	},

	handleCloseModal: function () {
		var modals = this.findAllComponents('ux-modal');
		modals.forEach(function (component) {
			component.set('displayState', false);
		});
	},

	setModalDisplayState: function (modalId, state) {

		var modals = this.findAllComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId[0] === component.get('modalId') || modalId ===  component.get('modalId');
		})[0];

		modal.set('displayState', state);
	}
});

Ractive.components["ux-news-releases-details"] = Ractive.extend({
	template: LUXComponentTemplates['ux-news-releases-details']
});

Ractive.components["ux-newsroom-feeds"] = Ractive.extend({
	template: LUXComponentTemplates['ux-newsroom-feeds'],
	data: function () {
		return {
			ConfigStrings: ConfigStrings
		};
	},
	oninit: function () {

		var self = this;
		var typeOfPost = self.get('typeofpost');
		var pagePosts = [];

		if (typeOfPost === 'facebook') {
			var app_token = '1782354432044036|9RXM4TQrVmz_-0rMcYD8-3c4glY';
			window.fbAsyncInit = function () {
				FB.init({
					appId      : '1782354432044036',
					xfbml      : true,
					version    : 'v2.7',
					'app_token' : app_token
				});
			};
			(function (d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) {
					return;
				}
				js = d.createElement(s); js.id = id;
				js.src = '//connect.facebook.net/en_US/all.js';
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'facebook-jssdk'));
			var interval = window.setInterval(function () {
				if (typeof (FB) !== 'undefined' && FB !== null) {
					window.clearInterval(interval);
					FB.api('/singtel/picture?access_token=' + app_token, function (response) {
						if (response && !response.error) {
							self.set('fbprofileImgurl', response.data.url);
						}
					});
					FB.api('/singtel/posts/?access_token=' + app_token, function (response) {
						if (response && !response.error) {
							for (var i = 0; i < response.data.length; i++) {
								pagePosts.push(response.data[i]);
							}
						}
					});
				}
			}, 100);
			self.set('pagePostsData', pagePosts);
			self.set('facebookUrl', self.get('followUsSiteUrl'));
			self.set('followFacebook', true);
		}

	
		function overrideTwitterBoxElementsCSS() {
			$('.twitter-timeline').contents().find('.timeline-Widget').
			attr('style', 'background-color:#FFFFFF !important;');
			$('.twitter-timeline').contents().find('.timeline-Tweet-text').
			attr('style', 'font-size:inherit;margin-bottom:-25px;padding-top:0px;');
			$('.twitter-timeline').contents().find('.timeline-Header-title').
			attr('style', 'display:none !important;');
			$('.twitter-timeline').contents().find('.timeline-Tweet-media').
			attr('style', 'display:none !important;');
			$('.twitter-timeline').contents().find('.TweetAuthor-name').
			attr('style', 'display:none !important;');
			$('.twitter-timeline').contents().find('.TweetAuthor-screenName').
			attr('style', 'display:none;');
			$('.twitter-timeline').contents().find('.timeline-Tweet-brand').
			attr('style', 'display:none !important;');
			$('.twitter-timeline').contents().find('.timeline-Tweet-actions').
			attr('style', 'display:none !important;');
			$('.twitter-timeline').contents().find('.timeline-Tweet-metadata').
			attr('style', 'display:none !important;');
			$('.twitter-timeline').contents().find('.timeline-Tweet-text .PrettyLink.hashtag.customisable').
			attr('style', 'color: #009FD4 !important;');
			$('.twitter-timeline').contents().find('.timeline-Tweet-text .PrettyLink.profile.customisable.h-card').
			attr('style', 'color: #009FD4 !important;');
			$('#twitter-widget-0').contents().find('div').css('background-color', '#FFFFFF');
			$('#twitter-widget-0').css('height', '500px');
		}

		if (typeOfPost === 'twitter') {

			window.twttr = (function (d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0],t = window.twttr || {};
				if (d.getElementById(id)) {
					return t;
				}
				js = d.createElement(s);
				js.id = id;
				js.src = 'https://platform.twitter.com/widgets.js';
				fjs.parentNode.insertBefore(js, fjs);
				t._e = [];
				t.ready = function (f) {
					t._e.push(f);
				};
				return t;
			}(document, 'script', 'twitter-wjs'));

			window.twttr.ready(function (twttr) {
				window.twttr.widgets.createTimeline({
					sourceType: 'url',
					url: 'https://twitter.com/SingtelNews',
					widgetId: self.get('widgetid')
				}, document.getElementById('container'), {
					tweetLimit: self.get('feedscount'),
					chrome: 'noheader, nofooter, noborders, transparent, noscrollbar',
					borderColor: '#FFFFFF'
				}).then(function (el) {
					overrideTwitterBoxElementsCSS();
					$('#container').show();
				});
			});

			self.set('twitterUrl', self.get('followUsSiteUrl'));
			self.set('followTwitter', true);
		}
	}

});

Ractive.components["ux-newsroom"] = Ractive.extend({
	template: LUXComponentTemplates['ux-newsroom'],
	mapOptions: function (arr) {
		return arr.map(function (arrItem) {
			return {
				'value': arrItem,
				'text': arrItem
			};
		});
	},
	oninit: function () {
		this.showIndex = 1;
		this.newsListsShown = 8;

		this.set('filterBy', this.mapOptions(this.get('categories')));
		this.set('filterCategory', 'All');

		this.set('filterByYears', this.mapOptions(this.get('years')).sort(function (a, b) {
				return b.value - a.value;
			}));
		this.set('yearFilter', moment(new Date()).format('YYYY'));
	},
	onrender: function () {
		var self =  this;
	

		this.observe('yearFilter', function (newValue, oldValue, keypath) {
			if (newValue !== oldValue && newValue !== 'undefined' && newValue !== null) {
				var yearFilter = this.get('yearFilter');
				this.loadNews(yearFilter);
			
			}
		}.bind(this));

		this.observe('filterCategory newsReleases', function (newValue, oldValue, keypath) {
			if (newValue !== oldValue && newValue !== 'undefined' && newValue !== null) {
				self.showIndex = 1;
				this.filterNews();
				self.showNewsLists(self.showIndex, self.newsListsShown);
			}
		}.bind(this));

		var windowInnerHeight = window.innerHeight;
		var threshold = 100;

		self.on('*.showmore', function (event) {
			var listBottom = self.find('.newsItemsList').getBoundingClientRect().bottom;
			if (listBottom - windowInnerHeight < threshold) {

				if (!$('#loader').hasClass('active')) {
					$('#loader').addClass('active');
				}
			
				self.showIndex++;
				self.showNewsLists(self.showIndex, self.newsListsShown);
				$('#loader').removeClass('active');
			}
		});

	},
	loadNews: function (param) {
		var urlCall = this.get('endPoint') + '.' + param + '.json';
		RactiveHelpers.doAjaxJSONCall('GET', urlCall,
			function (response) {
				this.set('newsReleases', response);
			}.bind(this),
			function (error) {
				console.log('Error loading news.');
				this.set('newsReleases', []);
			}.bind(this)
		);
	},
	filterNews: function () {
		var newsList = this.get('newsReleases');
		var filterBy = this.get('filterCategory');

		if (newsList && newsList.length > 0) {
			var newsListFiltered = newsList.filter(function (item) {
				var isCategoryMatch = true;

				if (!filterBy.startsWith('All')) {
					if (filterBy.indexOf(item.newsCategory) !== -1) {
						isCategoryMatch = true;
					} else {
						isCategoryMatch = false;
					}
				}
				return isCategoryMatch;
			});
			this.set('filteredNewsList', newsListFiltered);
			this.set('newsListCount', newsListFiltered.length);
		} else {
			this.set('filteredNewsList', []);
			this.set('newsListCount', 0);
		}
	},
	showNewsLists: function (num, listShown) {

		var newsList = this.get('filteredNewsList');

		if (num === undefined) {
			num = 1;
		}
		if (listShown === undefined) {
			listShown = this.showIndex * this.newsListsShown;
		}

		if (newsList && newsList.length > 0) {

			for (var i = 0; i < newsList.length; i++) {
				if (Math.ceil((1 + i) / listShown) === num) {
					newsList[i].display = true;
				} else if (Math.ceil((1 + i) / listShown) > num) {
					newsList[i].display = false;
				}
				newsList[i].newsSummary = this.stripHTML(newsList[i].newsSummary);
			}
			this.set('filteredNewsList', newsList);
		}

		if (Math.ceil((this.get('newsListCount') / this.newsListsShown)) > this.showIndex) {
			this.set('isDisabled', false);
		} else {
			this.set('isDisabled', true);
		}
	},
	stripHTML: function (html) {
		return $('<div>').html(html).text();
	}
});

Ractive.components["ux-nomination-circle-details"] = Ractive.extend({
	template: LUXComponentTemplates['ux-nomination-circle-details'],
	onrender: function () {
		var self = this;
		self.on('*.circleEdit', function () {
			self.fire('clickedOnEditCircle', self.get('circleGroup'), (self.get('index') + 1));
		});
	}
});

Ractive.components["ux-notification-table"] = Ractive.extend({
	template: LUXComponentTemplates['ux-notification-table'],
	decorators: {
		tooltip: ractiveTooltip
	},
	data: function (argument) {
		return {
			RactiveHelpers: RactiveHelpers
		};
	}
});

Ractive.components["ux-onepay-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-onepay-singtel'],
	isolated: true,
	onconfig: function () {
		var initData = this.get('initData');
		initData.successUrl =
			this.addStatusParam(initData.successUrl, 'Success');
		initData.failureUrl =
			this.addStatusParam(initData.failureUrl, 'Failure');
		initData.cancelUrl =
			this.addStatusParam(initData.cancelUrl, 'Cancel');
		this.set('initData', initData);
	},
	addStatusParam: function (url, status) {
		if (url) {
			if (url.indexOf('?') === -1) {
			
				url += '?pgStatus=' + status;
			} else {
				url += '&pgStatus=' + status;
			}
		}
		return url;
	},
	redirectToPg: function () {
		this.find('#paymentGatewayForm').submit();
	}
});

Ractive.components["ux-order-consolidation"] = Ractive.extend({
	template: LUXComponentTemplates['ux-order-consolidation'],
	isolated: true,
	data : function () {
		return {
			RactiveHelpers : RactiveHelpers
		};
	},
	onrender: function () {
		var self = this;
		self.on('*.proceedToConsolidateOrder', function (event) {
			var record = self.get('processRecord');
			if (record) {
				self.parent.set('orderConsolidateInput', self.get('processRecord'));
				self.fire('proceedWithConsolidateOrder', {context: self});
			}
		}.bind(this));

		self.on('selectOrderConsolidation', function (event, id) {
			self.set('processRecord', event.context);
		});

		self.on('*.skipConsolidateOrder', function () {
			self.parent.set('orderConsolidation', false);
			self.set('orderConsolidation', false);
			self.set('showDeliveryInstallation', true);
			var component = self.parent.findComponent('ux-delivery-installation');
			if (component) {
				component.set('showDeliveryInstallation', true);
				component.set('skipOrderConsolidate', true);
			}
			Ractive.defaults.fire('process-explicit-hash');
		});
	},
	oncomplete: function () {
		Ractive.defaults.fire('process-explicit-hash');
	}
});

Ractive.components["ux-order-summary-grid"] = Ractive.extend({
	template: LUXComponentTemplates['ux-order-summary-grid']
});

Ractive.components["ux-order-summary-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-order-summary-singtel'],
	data: function () {
		return {
			ConfigStrings: ConfigStrings
		};
	},
	decorators: {
		tooltip: ractiveTooltip
	},
	onrender: function () {
		var self = this;

		self.on('showTooltip', function (event) {

			if (event.original.currentTarget.nextElementSibling.style.display !== 'block') {
				_.each(document.getElementsByClassName('tooltip'), function (v) {
					v.style.display = 'none';
				});
				event.original.currentTarget.nextElementSibling.style.display = 'block';
			} else {
				event.original.currentTarget.nextElementSibling.style.display = 'none';
			}

			return false;
		});
	}
});

Ractive.components["ux-ordersummary-row"] = Ractive.extend({
	template: LUXComponentTemplates['ux-ordersummary-row'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			ConfigStrings: ConfigStrings
		};
	},

	oninit: function () {
		var self = this;
		var type = self.get('type');

		self.map = {

			'preGST' : 'Total (Before GST)',
			'GST': 'GST',
			'postGST' : 'Total (Inclusive of GST)'
		};

		self.setRowData(type);
	},
	onrender: function () {
		var self = this;

		self.on('showTooltip', function (event) {
			if (event.original.currentTarget.nextElementSibling.style.display !== 'block') {
				_.each(document.getElementsByClassName('tooltip'), function (v) {
					v.style.display = 'none';
				});
				event.original.currentTarget.nextElementSibling.style.display = 'block';
			} else {
				event.original.currentTarget.nextElementSibling.style.display = 'none';
			}
			return false;
		});
	},
	setRowData: function (type) {
		var self = this;
		var rowdata = '';
		var oneTimePWT = '';
		var recurringPWT = '';
		var checkoutPWT = '';
		if (type === 'preGST') {
			var detailedData = self.get('');
			rowdata = self.map[type];
			if (typeof detailedData.oneTimePrice !== 'undefined') {
				oneTimePWT = detailedData.oneTimePrice.finalAmount;
			}
			if (typeof detailedData.recurringPrice !== 'undefined') {
				recurringPWT = detailedData.recurringPrice.finalAmount;
			}
			if (typeof detailedData.checkoutPrice !== 'undefined') {
				checkoutPWT = detailedData.checkoutPrice.finalAmount;
			}
		} else if (type === 'GST') {
			var detailedData = self.get('');
			rowdata = self.map[type];
			if (typeof detailedData.oneTimePrice !== 'undefined') {
				oneTimePWT = detailedData.oneTimePrice.finalTaxAmount;
			}
			if (typeof detailedData.recurringPrice !== 'undefined') {
				recurringPWT = detailedData.recurringPrice.finalTaxAmount;
			}
			if (typeof detailedData.checkoutPrice !== 'undefined') {
				checkoutPWT = detailedData.checkoutPrice.finalTaxAmount;
			}
		} else if (type === 'postGST') {
			var detailedData = self.get('');
			rowdata = self.map[type];
			var oneTimePrice = detailedData.oneTimePrice;
			var recurringPrice = detailedData.recurringPrice;
			var checkoutPrice = detailedData.checkoutPrice;
			if (typeof oneTimePrice !== 'undefined') {
				oneTimePWT = oneTimePrice.finalAmountIncludingTax;
			}
			if (typeof recurringPrice !== 'undefined') {
				recurringPWT = recurringPrice.finalAmountIncludingTax;
			}
			if (typeof checkoutPrice !== 'undefined') {
				checkoutPWT = checkoutPrice.finalAmountIncludingTax;
			}
		}
		self.set('rowData', rowdata);
		self.set('oneTimePrice', oneTimePWT);
		self.set('recurringPrice', recurringPWT);
		self.set('checkoutPrice', checkoutPWT);
	}

});

Ractive.components["ux-page-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-page-banner'],

	onrender: function (argument) {
		var self = this;
		self.set('backgroundImgDesktop', self.get('backgroundImage.desktop.src'));
		var backgroundImage = self.get('backgroundImage.mobile.src') || self.get('backgroundImage.desktop.src');
		self.set('backgroundImgMobile', backgroundImage);
	}
});

Ractive.components["ux-page-section"] = Ractive.extend({
	template: LUXComponentTemplates['ux-page-section'],
	oninit: function () {
	
		this.set('smallBreakpoint', ConfigStrings.mediaBreakpoints.small);
	},
	oncomplete: function () {
	
		const mq = window.matchMedia('(min-width: ' + ConfigStrings.mediaBreakpoints.small + 'px)');
		this.handleMediaQuery(this, mq);
		window.addEventListener('resize', function () {
			this.handleMediaQuery(this, mq);
		}.bind(this));
	},
	data: function () {
		return {
			ConfigStrings: ConfigStrings
		};
	},
	handleMediaQuery: function (ractive, mq) {
		if (mq.matches && ractive.get('backgroundImage.desktop.src')) {
			ractive.set('backgroundPositionClass', ractive.get('backgroundImage.desktop.imagePosition'));
			ractive.set('backgroundSizeClass', ractive.get('backgroundImage.desktop.imageSize'));
		} else if (ractive.get('backgroundImage.mobile.src')) {
			ractive.set('backgroundPositionClass', ractive.get('backgroundImage.mobile.imagePosition'));
			ractive.set('backgroundSizeClass', ractive.get('backgroundImage.mobile.imageSize'));
		}
	}
});

Ractive.components["ux-pay-bill"] = Ractive.extend({
	template: LUXComponentTemplates['ux-pay-bill'],

	isolated: true,

	data : {
		RactiveHelpers : RactiveHelpers,
		overMaxPaybleAmountInputFieldMsg: ConfigStrings.paybillDetails.amountValidation.overMaxPaybleAmountInputFieldMsg
	},
	oninit: function () {
		this.on('*.onAmountChange', function () {
			if (this.get('amountBlurEvent')) {
				this.fire(this.get('amountBlurEvent'), this);
			}
		}.bind(this));

		this.on('*.onAmountInput', function () {
			if (this.get('amountInputEvent')) {
				this.fire(this.get('amountInputEvent'), this);
			}
		}.bind(this));
	},
	computed : {
		avatarImg : function () {
			var account = this.get('account');
			var avatars = this.getAvatarListAsPerAccountType();

			var avatarImg = null;
			_.each(avatars, function (avatar) {
				if (avatar.id === parseInt(account.avatarImageId)) {
					avatarImg = avatar;
					avatarImg.selected = false;
				}
			});
			return avatarImg;
		}
	},

	getAvatarListAsPerAccountType : function () {
		var self = this;
		var account = self.get('account');
		var avatars = null;

		if (account.isEasyMobile) {
			avatars = this.get('initData.emAvatarImages');
		} else {
			avatars = this.get('initData.opAvatarImages');
		}
		return avatars;
	}
});

Ractive.components["ux-payment-desc"] = Ractive.extend({
	template: LUXComponentTemplates['ux-payment-desc']
});

Ractive.components["ux-payment-info"] = Ractive.extend({
	template: LUXComponentTemplates['ux-payment-info'],
	data: function () {
		return {
			moment: moment,
			placeholderMap: {
				MOBILE_NUMBER: 'orderData.personalInformation.contactNumber',
				EMAIL_ID: 'orderData.personalInformation.emailId',
				ORDER_ID: 'orderData.order.id'
			},
			requiredMaskFields: {
				MOBILE_NUMBER: true,
				EMAIL_ID: true
			},
			getWithPlaceholderValues: function (content) {
				var self = this;
				const values =  self.get('orderConfirmation');
				const placeholderMap = self.get('placeholderMap');

				const maskingRequired = values.isMaskingReqd;
				const transform = maskingRequired ? function (key, value) {
					if (self.get('requiredMaskFields')[key]) {
						return RactiveHelpers.maskContent(key, value);
					}
					return value;
				} : undefined;
				const newContent = RactiveHelpers.mapPlaceholderToValue(content, values, placeholderMap, transform);
				return newContent;
			}
		};
	},
	oninit: function () {
		var self = this;
		const paymentStatus = self.get('orderConfirmation.paymentStatus');
		self.set('paymentSuccess', paymentStatus === 'paymentSuccess');
	},
	onrender: function () {
		var self = this;
		self.on('*.showUploadedDoc', function (evt, documentId) {
			evt.event.original.preventDefault();
			self.fire('displayUploadedDoc', documentId);
		});
		self.on('*.showOrderDetails', function (evt, orderId) {
			evt.event.original.preventDefault();
			self.fire('displayOrderDetails', orderId);
		});
		self.observe('orderConfirmation.orderData.selectedOption', function (selectedOption) {
			if (selectedOption !== null && typeof selectedOption !== 'undefined') {
				switch (selectedOption) {
					case 'pop-station':
					case 'singtel-pop-station':
						var popstationDelivery = self.get(
							'paymentInfoSuccessful.successfulInfo.popstationDelivery');
						if (popstationDelivery !== null) {
							self.set('delivery', popstationDelivery);
						}
						break;
					case 'sms-mail':
					case 'Self-Collect (w/o appt)':
						var snailMailDelivery = self.get(
							'paymentInfoSuccessful.successfulInfo.snailMailDelivery');
						if (snailMailDelivery !== null) {
							self.set('delivery', snailMailDelivery);
						}
						break;
					case 'courier':
						var courierDelivery = self.get(
							'paymentInfoSuccessful.successfulInfo.courierDelivery');
						if (courierDelivery !== null) {
							self.set('delivery', courierDelivery);
						}
						break;
					case 'singtel-store':
						var singtelStoreDelivery = self.get(
							'paymentInfoSuccessful.successfulInfo.singtelStoreDelivery');
						if (singtelStoreDelivery !== null) {
							self.set('delivery', singtelStoreDelivery);
						}
						break;
					case 'collect-now':
						var collectNowDelivery = self.get(
							'paymentInfoSuccessful.successfulInfo.collectNowStationDelivery');
						if (collectNowDelivery !== null) {
							self.set('delivery', collectNowDelivery);
						}
						break;
				}
			}
		});

		self.observe('orderConfirmation.paymentStatus', function (paymentStatus) {
			if (paymentStatus !== null && typeof paymentStatus !== 'undefined') {
				self.set('paymentSuccess', paymentStatus === 'paymentSuccess');
				var paymentFailObj;
				switch (paymentStatus) {
					case 'CreditBalanceFail':
						var orderData = self.get('orderConfirmation.orderData.order');
						var defaultObj = self.get('paymentStatusUnknown');
						if (orderData.bundle && orderData.bundle.length > 0) {
							paymentFailObj = self.get('bbPaymentStatusUnknown') || defaultObj;
						} else if (orderData.tv && orderData.tv.length > 0) {
							paymentFailObj = self.get('tvPaymentStatusUnknown') || defaultObj;
						} else if (orderData.mobile && orderData.mobile.length > 0) {
							paymentFailObj = defaultObj;
						}
						paymentFailObj.responseMessage = self.get('insufficientCreditBalanceMessage');
						break;
					case 'paymentFailure':
					case 'failure':
					case 'submitOrderPending':
						var orderData = self.get('orderConfirmation.orderData.order');
						var defaultObj = self.get('paymentStatusUnknown');
						if (orderData.bundle && orderData.bundle.length > 0) {
							paymentFailObj = self.get('bbPaymentStatusUnknown') || defaultObj;
						} else if (orderData.tv && orderData.tv.length > 0) {
							paymentFailObj = self.get('tvPaymentStatusUnknown') || defaultObj;
						} else if (orderData.mobile && orderData.mobile.length > 0) {
							paymentFailObj = defaultObj;
						}
						break;
					case 'paymentGatewayReturnedFailure':
						paymentFailObj = self.get('paymentInfoFailure');
						break;
					case 'paymentSuccess':
						var isRed = self.get('isRedMembership');
						const currentLob = (isRed ? 'RED' :
							self.get('orderConfirmation.orderData.order.currentLob'));
						const bodySection = self.get('initData.sectionDetails');
						const notesSection = self.get('initData.noteSection');

						if (bodySection) {
							const currentLobSectionDetails = _.filter(bodySection, function (body) {
								return body.lob === currentLob;
							});
							self.set('initData.sectionDetails', currentLobSectionDetails);
						}

						if (notesSection) {
							const currentNotes = _.filter(notesSection, function (note) {
								return note.lob === currentLob;
							});
							self.set('initData.noteSection', currentNotes);
						}

						break;
				}
				if (paymentFailObj) {
					self.set('paymentFailObj', paymentFailObj);
				}
			}
		});
	}
});

Ractive.components["ux-phone-catalogue-gui"] = Ractive.extend({
	template: LUXComponentTemplates['ux-phone-catalogue-gui'],

	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},

	oncomplete: function () {
		this.on('selectColor', function (event, image) {
			this.set('handsetImage', image);
			console.log(image);
		});
	}
});

Ractive.components["ux-phone-catalogue"] = Ractive.extend({
	template: LUXComponentTemplates['ux-phone-catalogue'],

	showPhones: function (num, handsetsShown) {
		this.set('startPhoneDisplay', false);
		var initialList = this.get('initData.phoneList');
		var phoneList = _.filter(initialList, function (phone) {
			return !phone.hideForDisplay;
		});
		if (num === undefined) {
			num = 1;
		}
		if (handsetsShown === undefined) {
			handsetsShown = this.showIndex * this.handsetsShown;
		}

		if (phoneList && phoneList.length > 0) {

			for (var i = 0; i < phoneList.length; i++) {
				if (Math.ceil((1 + i) / handsetsShown) === num) {
					phoneList[i].display = true;
				} else if (Math.ceil((1 + i) / handsetsShown) > num) {
					phoneList[i].display = false;
				}
			}

			if (num === Math.ceil(phoneList.length / handsetsShown)) {
				this.set('initData.showButton', false);
			} else {
				this.set('initData.showButton', true);
			}
		} else {
			this.set('initData.showButton', false);
		}
		this.set('initData.filteredPhoneList', phoneList);
		this.set('startPhoneDisplay', true);
	},
	oninit: function () {

		this.showIndex = 1;
		this.handsetsShown = 8;

	

		this.on('ux-button.viewMore', function () {
			this.showIndex++;
			this.showPhones(this.showIndex, this.handsetsShown);
		}.bind(this));

	}
});

Ractive.components["ux-phone-compare-filter"] = Ractive.extend({
		template: LUXComponentTemplates['ux-phone-compare-filter'],
		onrender: function () {
		var self = this;
		this.set('filter.selectedBrand', '');
		this.set('filter.selectedModel', '');
				var brands = _.clone(this.get('brands'));
		if (brands[0].text === 'All Brands') {
			brands[0] = {
				'text' : 'Brand',
				'value': ''
			};
		}
		this.set('finalBrands', brands);
		this.set('filter.modelList', [{'text': 'Model', 'value': ''}]);

		this.observe('filter.selectedModel', function (newValue, oldValue) {
			if (typeof newValue !== 'undefined' && newValue !== null) {
				var filter = self.get('filter');
				if (newValue !== oldValue && newValue !== '') {
					var phoneCatalogData = self.getPhoneCatalogData(newValue);
					filter.deviceData = phoneCatalogData;

					RactiveHelpers.doAjaxJSONCall('GET',
						'/bin/services/singtel/phoneCompare.:groupId=' + newValue + '.json',
						function (response) {
							if (response.deviceDataOptions && response.deviceDataOptions.length > 0) {
								filter.deviceDataOptions = response.deviceDataOptions;
								filter.showDetails = true;
								self.set('filter', filter);
							}
						}.bind(self),
						function (error) {
							console.error(error);
						}.bind(self));
				} else if (newValue === '') {
					filter.showDetails = false;
					self.set('filter', filter);
				}
			}
		});

		this.observe('filter.selectedBrand', function (newValue, oldValue) {
			var brand = newValue;
			if (newValue !== oldValue && brand !== '') {
				self.getDeviceFilters(brand);
			} else if (brand === '') {
				this.set('filter.modelList', [{'text': 'Model', 'value': ''}]);
			}
		});
	},

	getDeviceFilters: function (brand) {
		var phoneList = this.get('initData.phoneList');
		var modelList = [{'text': 'Model', 'value': ''}];
		var fullModelList = [];
		if (this.get('isIPPPlan')) {
			phoneList = _.filter(phoneList, function (list) {
				return !list.hideForDisplay;
			});
		}
		_.filter(phoneList, function (v) {
			if (v.brand === brand) {
				fullModelList.push(v);
				modelList.push({'text': v.title, 'value': v.groupId});
			}
		});

		var defaultModel;
		if (modelList && modelList.length > 0 && modelList[0].value === '') {
			defaultModel = modelList[0];
			modelList.shift();
		}
		modelList.sort(function (a, b) {
			var textA = a.text.toUpperCase();
			var textB = b.text.toUpperCase();
			return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
		});

		if (defaultModel && defaultModel.text !== '') {
			modelList.unshift(defaultModel);
		}
		this.set('filter.modelList', modelList);
		this.set('filter.fullModelList', fullModelList);
	},

	getPhoneCatalogData: function (model) {
		var phoneList = this.get('initData.phoneList');
		var data = _.find(phoneList, function (v) {
			if (v.groupId === model) {
				return v;
			}
		});
		return data;
	}
});

Ractive.components["ux-phone-details"] = Ractive.extend({
		template: LUXComponentTemplates['ux-phone-details'],
		onrender: function () {
		var self = this;
		var filters = this.get('filters');
		if (typeof filters === 'undefined') {
			filters = [{},{},{}];
			this.set('filters', filters);
		}

		_.each(filters, function (v) {
			v.initData = self.get('initData');
		});

		this.observe('filters[0].deviceDataOptions', function (value) {
			if (value) {
				this.updateDeviceDataOptions(filters);
			}
		});
		this.observe('filters[1].deviceDataOptions', function (value) {
			if (value) {
				this.updateDeviceDataOptions(filters);
			}
		});
		this.observe('filters[2].deviceDataOptions', function (value) {
			if (value) {
				this.updateDeviceDataOptions(filters);
			}
		});
		this.on('*.removeSelectedDevice', function (e, filterIndex) {
			var filterIndex = parseInt(filterIndex);
			var updatedFilters = this.get('filters');
			updatedFilters[filterIndex].selectedBrand = '';
			updatedFilters[filterIndex].selectedModel = '';
			updatedFilters[filterIndex].modelList = [{'text': 'Model', 'value': ''}];
			updatedFilters[filterIndex].showDetails = false;
			_.each(updatedFilters[filterIndex].deviceDataOptions, function (object) {
				if (object.contentList) {
					object.contentList = [];
				}
				if (object.content) {
					object.content = '';
				}
			});
			var removedIndex = updatedFilters[filterIndex];
			_.each(updatedFilters, function (item, index) {
				if (index >= filterIndex) {
				
					if (index === (updatedFilters.length - 1)) {
						updatedFilters[index] = removedIndex;
					} else {
						updatedFilters[index] = updatedFilters[index + 1];
					}
				
				}
			});
			this.set('filters', updatedFilters);
		}.bind(this));
	},

	updateDeviceDataOptions: function (filters) {
		var self = this;
		self.set('hasDetails', false);
		_.each(filters, function (v) {
			if (v.showDetails && v.showDetails === true) {
				self.set('hasDetails', true);
			}
		});

		var optionsArray = [];
		var optionLength = 0;
		var firstOptionIndex = 0;

		var emptyOption = [];
		_.find(filters, function (v, index) {
			if (v.deviceDataOptions && v.deviceDataOptions.length > 0) {
				optionLength = v.deviceDataOptions.length;
				firstOptionIndex = index;
				emptyOption = JSON.parse(JSON.stringify(v.deviceDataOptions));
			}
		});

		_.each(emptyOption, function (e) {
			e.content = '';
			e.contentList = [];
		});

		_.each(filters, function (v, index) {
			if (!v.deviceDataOptions || v.deviceDataOptions.length === 0) {
				v.deviceDataOptions = emptyOption;
			}
		});

		for (var i = 0; i < optionLength; i++) {
			var option = [];
			for (var m = 0; m < filters.length; m++) {
				option.push(filters[m].deviceDataOptions[i]);
			}
			optionsArray.push(option);
		}
		self.set('options', optionsArray);
	}
});

Ractive.components["ux-phone-pricing-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-phone-pricing-banner']
});

Ractive.components["ux-phone-pricing-table"] = Ractive.extend({
	template: LUXComponentTemplates['ux-phone-pricing-table']
});

Ractive.components["ux-plan-list"] = Ractive.extend({
	template: LUXComponentTemplates['ux-plan-list'],
	data : {
		'RactiveHelpers' : RactiveHelpers
	},
	isolated: true,
	oninit : function () {
		var self = this;
		self.on('onCommonPlanClick', function (event, groupType, idx, isApplicableForTablet) {

			var currentPlanTag = '';
			sessionStorage.setItem('silverComponent', false);
			if (event && event.context && event.context.tags && event.context.tags.length > 0) {
				currentPlanTag = event.context.tags;
				_.each(currentPlanTag, function (plan) {
					if (plan.indexOf('Silver-Customer-Plans') > 0) {
						sessionStorage.setItem('silverComponent', true);
					}
				});
			}
			sessionStorage.setItem('loginClicked', true);
			self.onPlanClick(event, groupType, idx, isApplicableForTablet);
		});
		self.set('getSelectedState', function (idx) {
			return self.get('selectedPlanState.' + idx);
		});
		self.on('ux-radio-button.ippDurationSelected', function () {
			self.onIppDurationChange();
		});
	},
	onPlanClick : function (event, groupType, idx, isApplicableForTablet) {
		var eventName = 'onSelectPlan' + '.' + 'planSelected';
	
		if (groupType === 'mobileBroadbandPlan') {
			this.fire('selectedGroupType', groupType, isApplicableForTablet, this.get('mode'));
		} else {
			this.fire('selectedGroupType', groupType, isApplicableForTablet);
		}
		this.fire(eventName, event.context);
		this.set('planSelected', 'selected');
		this.setSelectedState('selectedPlanState', idx);
	},
	setSelectedState: function (state, property) {
		var selectedStateStr = state + '.' + property;
		var selectedStateObj = this.get(state);
		if (typeof selectedStateObj !== undefined) {
			_.each(selectedStateObj, function (element, key) {
				selectedStateObj[key] = '';
			});
		}
		this.set(selectedStateStr, 'selected');
		this.update();
	},
	onIppDurationChange: function () {
		var selectedDuration = this.get('selectedFilter');
		var plans = this.get('plans');
		_.each(plans, function (allPlans) {
			if (allPlans.installmentAmount && selectedDuration) {
				allPlans.phoneCost = (Math.floor(parseFloat(allPlans.installmentAmount /
					selectedDuration) * 100) / 100).toFixed(2);
			}
			allPlans.planDuration = selectedDuration;
		});
		this.set('plans', plans);
	}

});

Ractive.components["ux-port-in-number"] = Ractive.extend({
	template: LUXComponentTemplates['ux-port-in-number'],
	onrender : function () {
		var self = this;
		self.on('ux-button.checkNumber', self.portNumber, {context: self});

		self.on('*.checkPhoneValidation', function (event) {
			self.checkPhone();
		});
	},
	portNumber : function () {
		var self = this;
		var mobileNumber = self.get('value');
		var isValid = self.checkPhone().valid;
		if (isValid) {
			self.set('portinError', null);
			self.set('isGomoFlow', false);
			self.parent.set('isGomoFlow', false);
			self.set('isPrepaidFlow', false);
			self.parent.set('isPrepaidFlow', false);
			self.fire('validateNumber', mobileNumber);
		}
		return false;
	},
	checkPhone: function () {
		this.phoneValidationRule = new RactiveValidate(this,{
			phoneVal: {
				phoneNoFormat: 'Please enter a valid Contact Number',
				minlength: {
					param: 8,
					message: 'Please enter a minimum of 8 digits'
				},
				maxlength: {
					param: 8,
					message: 'Please enter a maximum of 8 digits'
				},
				digits : 'Please enter a valid Contact Number'
			}
		});
		this.phoneValidationRule.patterns.phoneNoFormat = RactiveHelpers.mobileValidator;
		this.phoneValidationRule.cwd = 'phoneVal';
		this.set('phoneVal.phoneVal', this.get('value'));
		return this.phoneValidationRule.validate(this.phoneValidationRule);
	}
});

Ractive.components["ux-premium-addons"] = Ractive.extend({
	template: LUXComponentTemplates['ux-premium-addons'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			disabledButton: 'disabled',
			selectedCapacityState: 'disabledCapacity',
			colorSelected: false,
			selectedHexCode: null,
			disabledCart: 'disabled',
			cropTextConfig: ConfigStrings.sizeVariantCropTextConfig
		};
	},
	oninit: function () {

		this.showIndex = 1;
		this.handsetsShown = 8;
		this.on('ux-button.viewMore', function () {
			this.showIndex++;
			this.showAccessories(this.showIndex, this.handsetsShown);
		}.bind(this));

	},
	startModelDisplay: function (num, handsetsShown) {
		var self = this;
		var isAccessory = self.get('isAccessory');
		var addonObj = self.get('selectedAddon');
		self.set('priceList', []);
		if (addonObj) {
			if (isAccessory) {
				var variants = addonObj.variants;
				var colorVariants = [];
				var sizeVariants = [];
				_.each(variants, function (item) {
					if (item.hexCode) {
						colorVariants.push(item);
					}
					if (item.size) {
						sizeVariants.push(item);
					}
				});
				var colors = _.uniq(colorVariants, function (i) {
					return i.hexCode;
				});
				var addonSizeVariants = _.uniq(sizeVariants, function (i) {
					return i.size;
				});
				var sizes = sizeVariants;
				addonObj.addonVariants = addonSizeVariants;
				addonObj.sizes = sizes;
				addonObj.colors = colors;
				if (sizes && sizes.length > 0) {
					var flag = _.find(sizes, function (item) {
						item.enableCapacity = false;
						return item.size;
					});
					self.set('configurationNeeded', flag ? true : false);
					if (flag) {
						addonObj.handleAvailStatus = false;
					} else {
						addonObj.handleAvailStatus = true;
					}
				} else {
					addonObj.handleAvailStatus = true;
					self.set('configurationNeeded', false);
				}
				if (addonObj.colors && addonObj.colors.length > 1) {
					var priceList = _.uniq(_.pluck(addonObj.colors, 'price'));
					self.set('priceList', priceList);
				}
			}
			if (addonObj && addonObj.length > 0) {
				var priceList = _.uniq(_.pluck(addonObj.colors, 'price'));
				self.set('priceList', priceList);
			}
			var minSizeObj;
			if (addonObj && addonObj.variants.length > 0) {
				minSizeObj = _.min(addonObj.variants, function (size) {
					return size.price;
				});
			}
			if (minSizeObj) {
				self.set('accessoryPrice', minSizeObj.price);
				self.set('orignalPrice', minSizeObj.usualPrice);
			}
			self.set('selectedAddon', addonObj);
			self.showhideModal(true);
		}
	},
	showAccessories: function (num, handsetsShown) {
		this.set('startAccessoryDisplay', false);
		var initialList = this.get('addons');

		_.each(initialList, function (addon) {
			var variants = addon.variants;
			var colorVariants = [];
			_.each(variants, function (variant) {
				colorVariants.push({
					hexCode: variant.hexCode
				});
			});
			addon.colorVariants = _.uniq(colorVariants, function (i) {
				return i.hexCode;
			});
		});

		var addons = _.filter(initialList, function (accessory) {
			return !accessory.hideForDisplay;
		});
		if (typeof num === 'undefined' || num === null) {
			num = 1;
		}
		if (typeof handsetsShown === 'undefined' || handsetsShown === null) {
			handsetsShown = this.showIndex * this.handsetsShown;
		}

		if (addons && addons.length > 0) {

			for (var i = 0; i < addons.length; i++) {
				if (Math.ceil((1 + i) / handsetsShown) === num) {
					addons[i].display = true;
				} else if (Math.ceil((1 + i) / handsetsShown) > num) {
					addons[i].display = false;
				}
			}

			if (num === Math.ceil(addons.length / handsetsShown)) {
				this.set('initData.showButton', false);
			} else {
				this.set('initData.showButton', true);
			}
		} else {
			this.set('initData.showButton', false);
		}
		this.set('addons', addons);
		this.set('startAccessoryDisplay', true);
	},
	onrender: function () {
		var self = this;
		var isrecommended = self.get('isrecommended');
		if (isrecommended) {
			var mySwiper = new Swiper(self.find('.swiper-container'), {
				direction: 'horizontal',
				nextButton: this.find('.swiper-button-next'),
				prevButton: this.find('.swiper-button-prev'),
				loop: false,
				spaceBetween: 0,
				slidesPerView: '4',
				breakpoints: {
					480: {
						slidesPerView: 1,
						centeredSlides: true
					},
					769: {
						slidesPerView: '3',
						centeredSlides: false
					},
					1200: {
						slidesPerView: '4',
						centeredSlides: false
					}
				}
			});
			mySwiper.on('onSlideChangeStart', function () {
				self.set('addons.*.swipeMarginClass', false);
				var elements = document.getElementsByClassName('swiper-slide');
				if (elements && elements.length > 0) {
					_.each(elements, function (element, index) {
						if (element.className.indexOf('swiper-slide-active') > -1) {
							var addons = self.get('addons');
							if (addons && addons.length > 0 && addons.length > (index + 3)) {
								if (addons[index + 3].ribbon && addons[index + 3].ribbon.length > 0) {
									addons[index + 3].swipeMarginClass = false;
								} else {
									addons[index + 3].swipeMarginClass = true;
								}
								self.set('addons', addons);
							}
						}
					});
				}
			});
		}
		self.on('*.doSelectAddon', function (event) {
			var isAccessory = self.get('isAccessory');
			var idx = event.get('selectedIndex');
			var addonObj = self.get('addons')[idx];
			if (addonObj.isRemove) {
				self.set('selectedAddon', addonObj);
				self.fire('onAddonSelection', self);
				return true;
			}
			self.set('selectedColor.*', '');
			self.set('selectedHexCode', null);
			self.set('selectedPayment.*', '');
			self.set('paymentOptions', []);
			self.set('selectedSize.*', '');
			self.set('selectedAddon', addonObj);
			self.set('disabledButton', 'disabled');
			self.set('colorSelected', false);
			if (isAccessory) {
				self.fire('onAccessorySelection', self);
				return true;
			} else {
				self.showhideModal(true);
			}
		});

		self.set('getColorState', function () {
			return self.get('selectedCapacityState');
		});

		self.on('*.doSelectColor', function (event, colorId) {
			self.set('accessoryPrice', event.context.price);
			self.set('orignalPrice',  event.context.usualPrice);
			self.set('colorSelected', false);
			self.set('selectedHexCode', null);
			self.set('selectedColor.*', '');
			self.set('selectedColor.' + colorId, 'selected');
			self.fire('onSelectColor', event.context.name, colorId);
			self.set('addonId', event.context.identifier);
			self.set('paymentOptions', event.context.paymentOptions);
			self.set('selectedPayment.*', '');
			self.set('selected', '');
			self.set('selectedSize.*', '');
			self.set('disabledButton', 'disabled');
			self.set('selectedCapacityState', '');
			self.fire('onSelectPaymentOption', null);
			self.set('selectedAddon.productSpecID', null);
			var selectedAddon = self.get('selectedAddon');
			var isAccessory = self.get('isAccessory');
			if (isAccessory) {
				var configurationNeeded = self.get('configurationNeeded');
				if (configurationNeeded) {
					_.each(selectedAddon.sizes, function (i) {
						var flag = false;
						_.each(selectedAddon.variants, function (item) {
							if (item.hexCode === event.context.hexCode && item.size === i.size) {
								flag = true;
							}
						});
						i.enableCapacity = flag;
					});
				} else {
					selectedAddon.productSpecID = event.context.identifier;
					self.set('disabledButton', '');
				}
				selectedAddon.smallImage = event.context.smallImage;
				self.set('colorSelected', true);
			}
			self.set('selectedHexCode', event.context.hexCode);
			var hexCode = self.get('selectedHexCode');
			var sizes = selectedAddon.sizes;
			var addonSizes = _.filter(sizes, function (variant) {
				return variant.hexCode === hexCode;
			});
			self.set('selectedAddon.addonVariants', addonSizes);
			self.set('selectedAddon', selectedAddon);
		});

		self.on('*.doSelectPaymentOption', function (event, paymentId) {
			self.set('selectedPayment.*', '');
			self.set('selectedPayment.' + paymentId, 'selected');
			var paymentOptions = self.get('paymentOptions');
			self.set('disabledButton', '');
			self.fire('onSelectPaymentOption', paymentOptions, paymentId);
		});

		self.on('*.doSelectSize', function (event, size) {
			var selectedHexCode = self.get('selectedHexCode');
			if (event.context.enableCapacity === false || typeof selectedHexCode === 'undefined' ||
				selectedHexCode === null) {
				return;
			}
			self.set('selectedSize.*', '');
			var variants = self.get('selectedAddon.variants');
			if (variants) {
				var selectedSize = _.find(variants, function (item) {
					return item.hexCode === selectedHexCode && item.size === event.context.size;
				});
				if (selectedSize) {
					self.set('accessoryPrice', selectedSize.price);
					self.set('orignalPrice',  selectedSize.usualPrice);
				}
			}
			self.set('selectedSize.' + size, 'selected');
			self.set('disabledButton', '');
			self.fire('onSelectSizeOption', event.context.size, size);
			var selectedAddon = self.get('selectedAddon');
			_.each(selectedAddon.variants, function (item) {
				if (item.hexCode === selectedHexCode && item.size === event.context.size) {
					selectedAddon.productSpecID = item.identifier;
				}
			});
			_.each(selectedAddon.sizes, function (item) {
				if (item.hexCode === selectedHexCode && item.size === event.context.size) {
					selectedAddon.smallImage = event.context.smallImage;
				}
			});
			self.set('selectedAddon', selectedAddon);
		});

		self.on('*.doAddToCart', function (event) {
			self.fire('onAddonSelection', this);
			self.showhideModal(false);
		});

		self.on('*.doCloseModal', function (event) {
			self.set('paymentOptions', []);
			self.set('disabledButton', 'disabled');
		});
	},

	showhideModal: function (flag) {
		var modal = this.parent.findAllComponents('ux-modal')[0];
		modal.set('displayState', flag);
	}
});

Ractive.components["ux-premium-product-catalog"] = 
Ractive.extend({
	template: LUXComponentTemplates['ux-premium-product-catalog'],

	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			isProductSelected: false
		};
	},
	onrender: function () {
		var self = this;
		self.set('currentProductDetails', this.get('data'));
		var data = this.get('data');
		if (data.variants && data.variants.length > 0) {
			var colors = [];
			var uniqColors = [];
			_.each(data.variants, function (variant) {
				if (variant.color) {
					var color = {
						value: variant.color,
						label: variant.color
					};
					if (!uniqColors.includes(color.value)) {
						colors.push(color);
						uniqColors.push(color.value);
					}
				}
			});
			if (colors.length > 0) {
				self.set('selectedColor', colors[0].value);
				self.set('data.selectedColor', colors[0].value);
				var currentColorObj = _.find(data.variants, function (obj) {
					return obj.color === colors[0].value;
				});
				if (currentColorObj && currentColorObj.image) {
					self.set('data.image', currentColorObj.image);
				}
			}
			self.set('presentColors', colors);
			self.getCapacities();
			var selectedProductId = self.get('selectedProductId');
			if (selectedProductId && data.variants) {
				var selectedVariant = _.find(data.variants, function (variant) {
					return variant.identifier === selectedProductId;
				});
				if (selectedVariant) {
					self.set('selectedColor', selectedVariant.color);
					self.set('data.selectedColor', selectedVariant.color);
					self.set('selectedSize', selectedVariant.size);
					self.set('data.selectedSize', selectedVariant.size);
				}
			}
		}
		self.on('ux-select.changedColor', function (value) {
			var premiumProductsTopic = self.get('premiumProductsTopic');
			self.getIdentifier();
			var currentProduct = self.get('data');
			var variants = self.get('data.variants');
			self.set('data.selectedColor', value);
			self.set('selectedColor', value);
			var currentColorObj = _.find(variants, function (obj) {
				return obj.color === value;
			});
			if (currentColorObj && currentColorObj.image) {
				self.set('data.image', currentColorObj.image);
			}
			self.getCapacities();
			if (premiumProductsTopic.selectedPremiumAddons && data &&
				currentProduct.identifier === premiumProductsTopic.selectedPremiumAddons.identifier) {
				self.parent.set('premiumProductsTopic.selectedPremiumAddons', self.get('data'));
				self.parent.set('deviceIdAndPlanId.selectedPremiumProductId',  self.get('data.identifier'));
				self.parent.set('selectedProductId', self.get('data.identifier'));
				self.fire('changedColor');
				self.fire('updatePromoForFiberPlanEditedPremium');
			}
		});
		self.on('ux-select.changedCapacity', function (value) {
			var premiumProductsTopic = self.get('premiumProductsTopic');
			self.getIdentifier();
			var currentProduct = self.get('data');
			self.set('data.selectedSize', self.get('selectedSize'));
			if (premiumProductsTopic.selectedPremiumAddons && data &&
				currentProduct.identifier === premiumProductsTopic.selectedPremiumAddons.identifier) {
				self.parent.set('premiumProductsTopic.selectedPremiumAddons', self.get('data'));
				self.parent.set('deviceIdAndPlanId.selectedPremiumProductId',  self.get('data.identifier'));
				self.parent.set('selectedProductId', self.get('data.identifier'));
				self.fire('changedCapacity');
				self.fire('updatePromoForFiberPlanEditedPremium');
			}
		});
		self.on('ux-button.doProceed', function () {
			var isProductSelected = self.get('isProductSelected');
			self.set('isProductSelected', !isProductSelected);
			self.fire('removeSelectedAddon');
		});
		self.on('ux-button.doProceedAhead', function () {
			self.getIdentifier();
			self.parent.set('selectedPremiumAddon', self.get('data'));
			self.fire('shouldAddProductShowPopUp', self.get('data.identifier'));
		});
		self.parent.on('readyToAddProduct', function (productId) {
			var identifier = self.get('data.identifier');
			var isProductSelected = self.get('isProductSelected');
			if (identifier === productId) {
				self.set('isProductSelected', !isProductSelected);
			} else if (isProductSelected && identifier !== productId) {
				self.set('isProductSelected', !isProductSelected);
			}
		});
		self.on('*.showProductDetails', function () {
			var currentProductDetails = this.get('currentProductDetails');
			self.fire('openSelectDetailsPopUp', currentProductDetails);
		});
	},
	getIdentifier: function () {
		var self = this;
		var variants = self.get('data.variants');
		if (variants && variants.length > 0) {
			var size = self.get('selectedSize');
			var color = self.get('selectedColor');
			var selectedVariant = _.find(variants, function (allItems) {
				if (size && color) {
					return allItems.size === size && allItems.color === color;
				} else if (size && !color) {
					return allItems.size === size;
				} else if (!size && color) {
					return allItems.color === color;
				}
			});
			if (selectedVariant) {
				if (selectedVariant.identifier) {
					self.set('data.identifier', selectedVariant.identifier);
				}
				if (selectedVariant.displayPrice && selectedVariant.priceSpecId) {
					self.set('data.displayPrice', selectedVariant.displayPrice);
					self.set('data.priceSpecId', selectedVariant.priceSpecId);
					if (selectedVariant.usualPrice) {
						self.set('data.usualPrice', selectedVariant.usualPrice);
					}
				}
			}
		}
	},
	getCapacities: function () {
		var self = this;
		var capacities = [];
		var isColorsPresent = self.get('presentColors');
		var variants = self.get('data.variants');
		variants = variants.sort(function (a, b) {
			return parseInt(a.ranking) - parseInt(b.ranking);
		});
		var selectedColor = self.get('data.selectedColor');
		_.each(variants, function (variant) {
			if (variant.size) {
				var size = {
					value: variant.size,
					label: variant.size
				};
				if (isColorsPresent && isColorsPresent.length > 0 && variant.color === selectedColor) {
					capacities.push(size);
				} else if (isColorsPresent && isColorsPresent.length <= 0) {
					capacities.push(size);
				}
			}
		});
		if (capacities.length > 0) {
			self.set('isCapacitiesPresent', true);
			self.set('presentCapacities', capacities);
			self.set('selectedSize', capacities[0].value);
			self.set('data.selectedSize', capacities[0].value);
		}
	}
});

Ractive.components["ux-prestige-status"] = Ractive.extend({
	template: LUXComponentTemplates['ux-prestige-status'],
	isolated: true,
	oncomplete: function () {
		var self = this;

		var prestigeMessage = self.get('prestigeMessage');
		self.set('prestige', false);
		self.set('urlInvalid', false);
		self.set('displayed', false);

		if (typeof prestigeMessage !== 'undefined' && prestigeMessage !== null && prestigeMessage !== '') {

		
			var url = ConfigStrings.getRewardsHistoryHeaderUrl;

			if (typeof url !== 'undefined' && url !== '') {
				RactiveHelpers.doAjaxJSONCall('GET', url, function (response) {
					self.set('statusText', response.message);
					self.set('prestige', response.prestige);
					self.set('urlInvalid', false);
					self.set('displayed', true);
				},
			
				function (error) {
				
				
				
					self.set('urlInvalid', true);
					self.set('displayed', true);
				});
			} else {
				self.set('urlInvalid', true);
				self.set('displayed', true);
			}
		} else {
			self.set('urlInvalid', true);
			self.set('displayed', true);
		}
	}
});

Ractive.components["ux-pricing-table"] = Ractive.extend({
	template: LUXComponentTemplates['ux-pricing-table'],
	onconfig : function () {
		this.set('RactiveHelpers', RactiveHelpers);
	},
	oninit: function () {
		this.set('phoneModels.0.selected', true);
		this.selectItem(0);
	},
	selectItem: function (index) {
		var phoneModel = this.get('phoneModels.' + index + '.model');
		this.set('selectPhone', phoneModel);
	},
	onrender: function () {
		var self = this;
		self.swiper = new Swiper(self.find('.swiper-container'), {
			direction: 'horizontal',
			nextButton: this.find('.swiper-button-next'),
			prevButton: this.find('.swiper-button-prev'),
			slidesPerView: 'auto',
			loop: false,
			spaceBetween: 0,
			centeredSlides: true,
			initialSlide: 0
		});

		self.swiper2 = new Swiper(self.find('.swiper-container-phone'), {
			direction: 'horizontal',
			slidesPerView: 3,
			loop: false,
			spaceBetween: 0,
			initialSlide: 0,
			breakpoints: {
				640: {
					noSwiping: true,
					slidesPerView: 3
				},
				960: {
					noSwiping: true,
					slidesPerView: 4
				},
				1200: {
					noSwiping: true,
					slidesPerView: 5
				}
			}

		});

	
	

				this.observe('selectPhone', function (newValue, oldValue, keypath) {
			if (newValue !== oldValue && newValue !== 'undefined' && newValue !== null) {
				var comboPlans = this.get('comboPlans');
				var phoneModels = this.get('phoneModels');

				if (phoneModels) {
					for (var i = 0; i < phoneModels.length; i++) {
						if (phoneModels[i].model === newValue) {
							phoneModels[i].selected = true;
						} else {
							phoneModels[i].selected = false;
						}
					}
				}
				this.set('phoneModels', phoneModels);

				if (comboPlans) {
					for (var i = 0; i < comboPlans.length; i++) {
						var phones = comboPlans[i].phones;
						if (phones) {
							for (var j = 0; j < phones.length; j++) {
								if (phones[j].model === newValue) {
									phones[j].phoneSelected = true;
								} else {
									phones[j].phoneSelected = false;
								}
							}
						}
					}
				}

				this.set('comboPlans', comboPlans);
			}
		}.bind(this));

		this.on('selectItem', function (event, value) {
			this.selectItem(value);
		}.bind(this));

	}

});

Ractive.components["ux-product-catalog"] = Ractive.extend({
	template: LUXComponentTemplates['ux-product-catalog'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},
	oninit: function () {
		var self = this;

		var colors = self.get('phoneColors');
		if (colors && colors.length > 0) {
			var imagePath = {
				src: colors[0].image,
				alt: colors[0].imageAlt
			};
			self.set('imagePath', imagePath);
		}

	
		var desc = self.get('productDesc');
		if (desc && desc.match('<[a-z][\s\S]*>') === null) {
			self.set('productDesc', '<p>' + desc + '</p>');
		}
	},

	onrender: function () {
		var self = this;

		self.on('ux-button.navigateToURL', function (event) {
			var linkURL = event.get('linkto');
			if (self.get('openNewWindow') === 'true' || self.get('openNewWindow') === true) {
				window.open(linkURL, '_blank');
			} else {
				window.open(linkURL, '_self');
			}

		});

		self.on('colorSelect', function (event) {
			var imagePath = {
				src: event.context.image,
				alt: event.context.imageAlt
			};
			self.set('imagePath', imagePath);
		});
	}

});

Ractive.components["ux-product-header"] = Ractive.extend({
	template: LUXComponentTemplates['ux-product-header'],

	onrender: function () {
		var self = this;

	
		var spacings = ['small', 'medium', 'large'];
		var topSpacing = self.get('topSpacing');
		topSpacing = _.indexOf(spacings, topSpacing) !== -1 ?
		self.set('topSpacing', topSpacing) : self.set('topSpacing', 'normal');
		if (typeof window.check === 'undefined' || typeof window.check.promotionExist === 'undefined') {
			var bottomSpacing = self.get('bottomSpacing');
			bottomSpacing = _.indexOf(spacings, bottomSpacing) !== -1 ?
			self.set('bottomSpacing', bottomSpacing) : self.set('bottomSpacing', 'normal');
		} else if (window.check.promotionExist === false) {
			self.set('bottomSpacing', '');
		}
	}
});

Ractive.components["ux-productvariant-container"] = Ractive.extend({
	template: LUXComponentTemplates['ux-productvariant-container'],

	onrender: function () {

		this.on('*.doOpenModal', function (evtObj, modalId) {
			if (modalId === 'ippPlanInfo') {
				this.fire('doOpenIppPlanModal', modalId);
			} else {
				this.fire('doOpenModalContent', modalId);
			}
		}.bind(this));
		this.on('*.showTooltip', function () {
			this.fire('doOpenIppPlanModal', 'ippPlanInfo');
		}.bind(this));
	}
});

Ractive.components["ux-promo-container"] = Ractive.extend({
	template: LUXComponentTemplates['ux-promo-container']
});

Ractive.components["ux-promo-recommendation"] = Ractive.extend({
	template: LUXComponentTemplates['ux-promo-recommendation'],

	onrender: function () {
		var self = this;
		self.on('*.openFindMoreLink', function () {
			self.fire('openFindMoreLink', self);
		});
	}
});

Ractive.components["ux-promo-rewards"] = Ractive.extend({
	template: LUXComponentTemplates['ux-promo-rewards']
});

Ractive.components["ux-promobox-title"] = Ractive.extend({
	template: LUXComponentTemplates['ux-promobox-title']
});

Ractive.components["ux-quantity-alteration"] = Ractive.extend({
	template: LUXComponentTemplates['ux-quantity-alteration'],
	isolated: true,
	data: function () {
		return {
			maxValue: 10,
			minValue: 1,
			selectedQty: 1,
			isEnabled: false,
			RactiveHelpers: RactiveHelpers,
			maxQuantity: 10,
			isVarientPage: false
		};
	},
	onrender: function () {
		this.on('increment', function () {
			if (this.get('selectedQty') < this.get('maxQuantity') && this.get('isEnabled') &&
			((this.get('ippEnabled') && this.get('isIppEligible') && this.get('selectedTerm') === '0') ||
			(!this.get('ippEnabled') && !this.get('selectedTerm') && this.get('enableAddButton')) ||
			this.get('isShoppingCart'))) {
				this.add('selectedQty', 1);
				this.onQuantityChange('increment');
							}
		});

		this.on('decrement', function () {
			if (this.get('selectedQty') > this.get('minValue') && this.get('isEnabled')) {
				this.subtract('selectedQty', 1);
				this.onQuantityChange('decrement');
			}
		});

		this.observe('maxValue', this.enableDisableComp, {context: this, init: true});
	},
	enableDisableComp: function () {
		var maxValue = this.get('maxValue'),
			mixCartMaxAllowedQuantity = this.get('initData.mixCartMaxAllowedQuantity');
		if (RactiveHelpers.isIppPlan()) {
			var totalCount = this.get('totalCount');
			var isVarientPage = this.get('isVarientPage');
			if (totalCount) {
				if (isVarientPage) {
					maxValue = _.min([maxValue, mixCartMaxAllowedQuantity - totalCount]);
				} else {
					var selectedQty = this.get('selectedQty');
					maxValue = _.min([maxValue, selectedQty + mixCartMaxAllowedQuantity - totalCount]);
				}
				this.set('maxValue', maxValue);
			}
		}
		this.set('maxQuantity', maxValue);
		var minValue = this.get('minValue');
		if (maxValue && maxValue >= minValue) {
			this.set('isEnabled', true);
		} else {
			this.set('isEnabled', false);
		}
	},
	onQuantityChange: function (eventType) {
		if (this.get('isEnabled')) {
			this.fire('quantityChange', this.get('selectedQty'), eventType);
		}
	}
	});

Ractive.components["ux-quicklink-list"] = Ractive.extend({
	template: LUXComponentTemplates['ux-quicklink-list'],
	isolated : true,

	data : function () {
		return {
			RactiveHelpers : RactiveHelpers
		};
	},

	onrender: function () {

		setTimeout(function () {
			if (Swiper) {
				this.swiper = new Swiper(this.find('.swiper-container'), {
					slidesPerView: 4,
					spaceBetween: 20,
					freeMode: true,
				
					paginationClickable: false
				});
			}
		}.bind(this), 100);


	}
});

Ractive.components["ux-quicklink"] = Ractive.extend({
	template: LUXComponentTemplates['ux-quicklink']
});

Ractive.components["ux-radio-button"] = Ractive.extend({
	template: LUXComponentTemplates['ux-radio-button'],
	data: function () {
		return {
			name: 'defaultName'
		};
	},
	oninit: function () {
		this.on('clickHandler', function (event) {
			this.deselectAllSiblings();
			this.set('selected', this.get('value'));
			if (this.get('validity') !== 0) {
				this.set('validity', '');
			}
			this.fire(this.get('onclick'), event, this);
			return false;
		});
	},
	deselectAllSiblings: function () {
		var name = this.get('name');
		if (name !== 'defaultName') {
			var allSiblingRadioButtons = this.parent.findAllComponents('ux-radio-button');
			var value = this.get('value');
			_.each(allSiblingRadioButtons, function (radioButtonComponent) {
				if (name === radioButtonComponent.get('name')) {
					radioButtonComponent.set('selected', value);
				}
			});
		}
	},
	onconfig: function () {
		this.on('blurHandler', function () {
			var fireEvent = this.get('onblurEvent');
			if (fireEvent) {
				this.fire(fireEvent, this);
				return false;
			}
		});

		this.on('changeHandler', function () {
			var fireEvent = this.get('onChangeEvent');
			if (fireEvent) {
				this.fire(fireEvent, this);
				return false;
			}
		});
	}
});

Ractive.components["ux-rating"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rating'],
	data: function () {
		return {
			feedBackComment: '',
			selectedStarValue: 'selectedStarValue',
			currentPageUrl: '',
			formName: 'Rating_Form_Singtel'
		};
	},
	oninit: function () {
		var self = this,
		selectedStarValue = self.get('selectedStarValue');
		self.on('ratingSelection', function (event) {
			var selectStar =  self.event.node.value;
			self.set(selectedStarValue, selectStar);
			self.set('modal.displayState', true);
			self.set('modal.padding', 50);
			self.set('modal.top', 50);
			self.set('modal.widthPercentage', 50);
			self.set('modal.class', 'light-theme');
			return true;
		});
	},
	resetForm: function () {
		_.each(this.findAllComponents('input'), function (formData) {
			formData.set({
			
				value: ''
			});
		});
	},
	onrender: function () {
		var self = this,
			ajaxcall,
			postValue = {};
		self.on('*.starSelection', function (event) {
			postValue.formName = self.get('formName');
			postValue.webform_starSelectedValue = self.get('selectedStarValue');
			postValue.webform_feedBackComment = self.get('feedBackComment');
			postValue.webform_currentPageUrl = window.location.href;
			console.log(postValue);
			ajaxcall = $.ajax({
				url: self.get('callToAction'),
				data: postValue,
				type: 'post'
			});
			ajaxcall.done(function (response) {
				if (response.response === 'success' && postValue.starSelectedValue !== '') {
					self.set('formSubmissionMsg', self.get('feedBackSuccessMsg'));
					self.set('validityClass', 'success');
					self.set('displayFeedbackText', 'none');
					self.set('displayTextarea', 'none');
					self.set('displayButton', 'none');
					self.resetForm();
				} else {
					self.set('formSubmissionMsg', self.get('errorMessage'));
					self.set('validityClass', 'error');
					self.set('displayFeedbackText', 'block');
					self.set('displayTextarea', 'block');
					self.set('displayButton', 'block');
				}
			});
			ajaxcall.fail(function () {
				self.set('formSubmissionMsg', self.get('errorMessage'));
				self.set('validityClass', 'error');
				self.set('displayFeedbackText', 'none');
				self.set('displayTextarea', 'none');
				self.set('displayButton', 'none');
			});
			return true;
		});
	}
});

Ractive.components["ux-recaptcha-form"] = Ractive.extend({
	template: LUXComponentTemplates['ux-recaptcha-form'],
	data: function () {
		return {
			captchaId: null,
			recaptchaUrl: null,
			captchaCorrectEvent: 'correctCaptcha',
			captchaExpireEvent: 'expiredCaptcha',
			captchaAction: null,
			captchaToken: null,
			recaptchaReady: false
		};
	},

	oninit: function () {
		if (typeof this.get('guid') === 'undefined') {
			this.set('guid', this._guid);
		}
		if (!this.get('captchaId')) {
			this.set('captchaId', this.get('guid'));
		}
	},

	onrender: function () {
		var self = this;
		var functionName =
			'onloadCallback_' + this.get('captchaId').replace('-', '_');

		window[functionName] = function () {
			self.set('recaptchaReady', true);
			self.executeInvisibleCaptcha();
		};

		var recaptchaUrl = '//www.google.com/recaptcha/api.js?onload=' + functionName +
			'&render=' + this.get('siteKey');
		this.set('recaptchaUrl', recaptchaUrl);
	},

	executeInvisibleCaptcha: function (action) {
		var self = this;
		action = action || this.get('captchaAction') || 'captchaAction';

		if (!window.grecaptcha || !this.get('recaptchaReady')) {
			console.warn('reCAPTCHA not ready yet');
			return;
		}

		grecaptcha.ready(function () {
			grecaptcha
				.execute(self.get('siteKey'), { action: action })
				.then(function (token) {
					self.set('captchaToken', token);
					self.fire(self.get('captchaCorrectEvent'), {
						token: token,
						action: action
					});
				})
				.catch(function (error) {
					console.error('reCAPTCHA execution failed:', error);
					self.fire(self.get('captchaExpireEvent'), error);
				});
		});
	},

	resetCaptcha: function () {
		this.set('captchaToken', null);
		this.executeInvisibleCaptcha();
	}
});

Ractive.components["ux-recommended-accessories"] = Ractive.extend({
	template: LUXComponentTemplates['ux-recommended-accessories'],

	onrender: function () {
		var self = this;
		self.on('ux-accordionitem.changeAccordion', function (component) {
			var className = component.el.querySelector('.accordion-navigation.active');
			if (className) {
				self.set('alignment', '');
			} else {
				self.set('alignment', 'v-normal-bottom');
			}
		});
		self.observe('initData.recommendedAccList', function (recommendedAccList) {
			if (recommendedAccList && recommendedAccList.length > 0) {
				var accessoryCatalogComponent = self.findComponent('ux-premium-addons');
				if (accessoryCatalogComponent) {
					self.set('addons', recommendedAccList);
					accessoryCatalogComponent.showAccessories();
				}
			}
		});
	}
});

Ractive.components["ux-recontract-number"] = Ractive.extend({
	template: LUXComponentTemplates['ux-recontract-number'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},
	oninit: function () {
		var self = this;

		this.on('selectReContract', function (event, index) {
			if (event.context.isChildPlan === false || event.context.isChildPlan === 'false') {
				self.fire('selectedPlanReContract', event, index);
			}
		});
	}
});

Ractive.components["ux-red-member-sub"] = Ractive.extend({
	template: LUXComponentTemplates['ux-red-member-sub'],
	onrender: function () {
		var self = this;
		self.observe('viewPersonInfo.viewUpdateCustomerProfileVmStatus', function (vmStatus) {
			if (vmStatus && vmStatus === 'redProductDataLoaded') {
				var self = this,
					redProductInfo = self.get('viewPersonInfo.redProductInfo');
				if (redProductInfo && redProductInfo.serviceId) {
					self.set({
						productName: 'Red Membership (Annual)',
						startDate: moment(redProductInfo.startDate).format('DD MMM YYYY'),
						endDate: moment(redProductInfo.endDate).format('DD MMM YYYY'),
						nextBillingCycleDate: moment(redProductInfo.nextBillingCycleDate).format('DD MMM YYYY'),
						serviceId: redProductInfo.serviceId
					});
				}
			}
		});
	}
});

Ractive.components["ux-red-service-details"] = Ractive.extend({
	template: LUXComponentTemplates['ux-red-service-details']
});

Ractive.components["ux-redemption-details"] = Ractive.extend({
	template: LUXComponentTemplates['ux-redemption-details'],
	data: function () {
		return {
			ConfigStrings: ConfigStrings
		};
	},
	oninit: function () {
		var self = this;
		this.set('redemptionList', self.getRedemptionMethodList());
	},
	onrender: function () {
		var self = this;
		var accordions = self.findAllComponents('ux-accordionitem');
		if (accordions) {
			_.each(accordions, function (item) {
				item.set('active', true);
			});
		}
		if (self.get('deviceIdAndPlanId.isExpressRequired') && self.get('deviceIdAndPlanId.reContractFlag')) {
			self.set('hideBackButton', true);
		} else {
			self.set('hideBackButton', false);
		}
		self.on('*.gotoPreviousStep', function () {
			Ractive.defaults.fire('ux-singtel-breadcrumbs.goto-prev-step');
		});
		self.on('*.onNextClick', function () {
			self.saveSelectedRedemotionOption();
		});
		self.on('*.selectBroadBandOption', function (selectedOption) {
			if (selectedOption.node) {
				self.handleBroadBand(selectedOption.node.id);
			}
		});
		self.on('*.selectPremiumOption', function (selectedOption) {
			if (selectedOption.node) {
				self.handlePremium(selectedOption.node.id);
			}
		});
	},
	oncomplete: function () {
		var self = this;
		var redemptionList = self.get('redemptionList');
		var redemptionModeList = [];
		_.each(redemptionList, function (redemptionObject) {
			var deviceId = redemptionObject.deviceId;
			var redemptionMethodList = redemptionObject.redemptionMethodList;
			if (deviceId && redemptionMethodList && redemptionMethodList.length > 0) {
				redemptionModeList.push(deviceId + '_' + redemptionMethodList[0].redemptionModeId);
			}
		});
		if (redemptionModeList && redemptionModeList.length > 0) {
			_.each(redemptionModeList, function (inputRadioID) {
				var inputRadioEle = document.getElementById(inputRadioID);
				var eleData = inputRadioEle ? inputRadioEle.id : '';
				var deviceType = inputRadioEle ? inputRadioEle.name : '';
				if (eleData && deviceType) {
					window.document.getElementById(eleData).checked = true;
					if (deviceType === 'Broadband') {
						self.handleBroadBand(eleData);
					} else if (deviceType === 'premium') {
						self.handlePremium(eleData);
					}
				}
			});
		}
	},
	handleBroadBand: function (data) {
		var self = this;
		var inputData = data;
		this.set('broadBandOption', inputData);
		this.set('isBroadBandMethodSelected', true);
		self.enableNextButton();
	},
	handlePremium: function (data) {
		var self = this;
		var inputData = data;
		this.set('premiumOption', inputData);
		this.set('isPremiumMethodSelected', true);
		self.enableNextButton();
	},
	getRedemptionMethodList : function () {
		var self = this;
		var redemptionMethodProductBasedList =  [];
		var premiumAddonDetails = self.get('premiumAddonDetails');
		var selectedPlanId = this.get('deviceIdAndPlanId.planId');
		var broadbandPlanList = this.get('initData.broadbandPlans');
		var wifiMeshList = this.get('initData.wifiMeshList');
		var lifestyleProductList = this.get('initData.lifestyleProductList');
		var hideBundleMesh = this.get('isInstallationOrDeliveryRequired');
		var premiumAndLifestyleProductList = [];
		if (wifiMeshList && wifiMeshList.length > 0 && lifestyleProductList && lifestyleProductList.length > 0) {
			premiumAndLifestyleProductList =
			this.get('initData.wifiMeshList').concat(this.get('initData.lifestyleProductList'));
		}
		var broadBandData = null;
		var oneClickData = this.get('deviceIdAndPlanId.oneClickData');
		if (broadbandPlanList) {
			broadBandData = _.find(broadbandPlanList, function (item) {
				return item.planId === selectedPlanId;
			});
		}
		if (premiumAddonDetails && premiumAddonDetails.length > 0) {
			premiumAddonDetails = _.uniq(premiumAddonDetails, function (item) {
				return item.spsid;
			});
			_.each(premiumAddonDetails, function (addon) {
				if (addon.isPremiumProduct === false) {
					if (broadBandData && !hideBundleMesh) {
						var deviceRedemptionModeIs =
							broadBandData.redemptionMode ? broadBandData.redemptionMode.split(',') :
							(oneClickData && oneClickData.redemptionMode ? oneClickData.redemptionMode.split(',') : []);
						var deviceRedemptionList = [];
						_.each(deviceRedemptionModeIs, function (modeId) {
							var modeData = self.getRedemptionData(modeId, selectedPlanId);
							if (modeData) {
								deviceRedemptionList.push(modeData);
							}
						});
						redemptionMethodProductBasedList.push(
							{
								'deviceSkuName' : addon.name,
								'redemptionMethodList' : deviceRedemptionList,
								'deviceType': 'Broadband',
								'deviceId': addon.spsid
							}
						);
					}
				}
				if (addon.isPremiumProduct) {
					var premiumProductData = _.find(premiumAndLifestyleProductList, function (item) {
						if (item.variants) {
							return _.find(item.variants, function (variant) {
								return variant.identifier === addon.spsid;
							});
						}
						return item.identifier === addon.spsid;
					});
					if (premiumProductData) {
						var deviceRedemptionModeIs =
						premiumProductData.redemptionMode ? premiumProductData.redemptionMode.split(',') : '';
						var deviceRedemptionList = [];
						_.each(deviceRedemptionModeIs, function (modeId) {
							var modeData = self.getRedemptionData(modeId, addon.spsid);
							if (modeData) {
								deviceRedemptionList.push(modeData);
							}
						});
						redemptionMethodProductBasedList.push(
							{
								'deviceSkuName' : addon.name,
								'redemptionMethodList' : deviceRedemptionList,
								'deviceType': 'premium',
								'deviceId': addon.spsid
							}
						);
					}
				}
			});
		}
		return redemptionMethodProductBasedList;
	},
	getRedemptionData: function (redemptioMode) {
		var redemptionDataList = this.get('initData.redemptionModeOptions');
		var redemptionData = _.find(redemptionDataList, function (redemption) {
			return redemptioMode === redemption.redemptionModeId;
		});
		return redemptionData;
	},
	enableNextButton: function () {
		if (this.get('isBroadBandMethodSelected') || this.get('isPremiumMethodSelected')) {
			this.set('isRedemptionMethodSelected', true);
		}
	},

	getPremiumAccesoryList: function () {
		var self = this;
		var selectedPremiumProductId = this.get('deviceIdAndPlanId.selectedPremiumProductId');
		var url = '/bin/services/singtel/ProductSearchServiceServlet?type=premiumProduct&id=' + selectedPremiumProductId;
		RactiveHelpers.doAjaxJSONCall('GET', url, function (response) {
			if (response && response.length > 0) {
				self.ractive.set('premiumAccssoryList', response);
			}
		},
		function (error) {
			console.log(error);
		});
	},

	redirectToOrderSummaryOrNextStep: function () {
		var self = this;
		if (self.isNextStepPrsent() && !(self.get('deviceIdAndPlanId.isExpressRequired') &&
		self.get('deviceIdAndPlanId.reContractFlag'))) {
			Ractive.defaults.fire('ux-singtel-breadcrumbs.goto-next-step');
		} else if (self.get('deviceIdAndPlanId.isExpressRequired') && self.get('deviceIdAndPlanId.reContractFlag')) {
			window.location.href = self.get('initData.proceedToOrderSummaryUrl') ||
				RactiveHelpers.modifyConfigUrl(ConfigStrings.pageUrls.orderSummaryUrl);
		} else {
			this.fire('continueWithSummary');
		}
	},

	saveSelectedRedemotionOption: function () {
		var self = this;
		var broadBandData = this.get('broadBandOption');
		var premiumData = this.get('premiumOption');
		var selectdRedemptionData = [];
		var redemptionOptions = [];
		if (broadBandData) {
			selectdRedemptionData.push(broadBandData);
		}
		if (premiumData) {
			selectdRedemptionData.push(premiumData);
		}
		_.each(selectdRedemptionData, function (item) {
			var deviceId = item ? item.split('_')[0] : '';
			var redemptionMethod = item ? item.split('_')[1] : '';
			var selecteddata = {
				'deviceId' : deviceId,
				'redemptionMethod' : redemptionMethod,
				'deviceName' : self.getDeviceName(deviceId)
			};
			redemptionOptions.push(selecteddata);
		});
		this.set('redemptionOptions', redemptionOptions);
		this.fire('selectedRedemptionOptions', redemptionOptions);
		this.redirectToOrderSummaryOrNextStep();
	},

	isNextStepPrsent: function () {
		var flag = false;
		var topic =
		'businesswidget/repository_l9_common/common/viewmodel/contextTopics/ImplBreadcrumbTopicViewModel';
		var sessionData = topic ? JSON.parse(sessionStorage.getItem(topic)) : [];
		var redemptionIndex = 0;
		if (sessionData.bcConfig) {
			_.each(sessionData.bcConfig, function (data, index) {
				if (data.target === 'redemption') {
					redemptionIndex = index;
				}
			});
			if (redemptionIndex > 0 && redemptionIndex + 2 === sessionData.bcConfig.length) {
				flag = false;
			} else {
				flag = true;
			}
		}
		return flag;
	},
	getDeviceName: function (deviceId) {
		var self = this;
		var devicenName = '';
		var premiumAddonDetails = self.get('premiumAddonDetails');
		_.each(premiumAddonDetails, function (addon) {
			if (addon.spsid === deviceId) {
				devicenName = addon.name;
			}
		});
		return devicenName;
	}
});

Ractive.components["ux-redirect-selection"] = Ractive.extend({
	template: LUXComponentTemplates['ux-redirect-selection'],

	oninit: function () {
		var self = this;
		var redirectSelection = self.get('customerTypeOptions');
		self.set('redirectSelection', redirectSelection);
	},
	onrender: function () {
		var self = this;
		self.on('handleClick', function (event, val) {
			event.original.preventDefault();
			self.setLink(val);
		});
	},
	setLink: function (val) {
		var self = this;
		self.set('selectedOption', val);
		self.redirect();
	},
	redirect: function () {
		var self = this;
		window.location.href = self.get('selectedOption');
	}
});

Ractive.components["ux-replace-text"] = Ractive.extend({
	template: LUXComponentTemplates['ux-replace-text'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			originalText: null,
			isObservableKey: false
		};
	},
	oncomplete: function () {
		this.set('originalText', this.get('text'));
		this.renderTemplate();
		if (this.get('isObservableKey')) {
			var data = this.get();
			var keys = _.keys(data);
			_.each(keys, function (key) {
				if (key.indexOf('KEY_') === 0) {
					this.observe(key, this.renderTemplate, {
						context: this,
						init: true
					});
				}
			}.bind(this));
		}
	},
	renderTemplate: function () {
		var data = this.get();
		var text = this.get('originalText');
		var keys = _.keys(data);
		_.each(keys, function (key) {
			console.log(key, data[key]);
			if (key.indexOf('KEY_') === 0) {
				var replaceKey = '{' + key.replace('KEY_', '') + '}';
				text = text.replace(replaceKey, data[key]);
			}
		}.bind(this));
		this.set('text', text);
		console.log(text);
		console.log(data);
	}
});

Ractive.components["ux-rewards-catalog-filter"] = 
Ractive.extend({
	template: LUXComponentTemplates['ux-rewards-catalog-filter'],
	onrender: function () {
		var self = this;
		self.filterRewards('All');
		self.on('ux-rewards-filter-facets.categoryChanged', function (keypath, newValue) {
			self.filterRewards(newValue);
		});

		self.on('*.rewardSelected', function (event) {
			window.location.href = event.component.instance.get('productUrl');
		});
	},

	filterRewards: function (newValue) {
		var self = this;
		var rewardCatalog = JSON.parse(JSON.stringify(self.get('rewardList')));
	
		var rewardListFiltered = {};

		if (newValue === 'All') {
			rewardListFiltered = rewardCatalog;
		} else {
			var filterRewards = {};
			filterRewards = _.filter(rewardCatalog, function (reward) {
				var match = true;
				if (reward.category !== newValue) {
					match = false;
				}
				return match;
			});
			rewardListFiltered = filterRewards;
		}
		self.set('rewardsFiltered', rewardListFiltered);

		var rewardsCatalogComponent = self.findComponent('ux-rewards-catalogue');
		if (rewardsCatalogComponent) {
			rewardsCatalogComponent.showRewards();
		}
	}
});

Ractive.components["ux-rewards-catalogue-block"] = 
Ractive.extend({
	template: LUXComponentTemplates['ux-rewards-catalogue-block'],

	initVariables: function () {
		var self = this;
		var buttonType = self.get('buttonType');
		if (typeof buttonType !== 'undefined' && buttonType !== null && buttonType === 'Redeem Now') {
			var isRedeemedUrl = ConfigStrings.isFullyRedeemedUrl;

			if (isRedeemedUrl !== '') {
				var itemCode = self.get('itemCode');
				var systemId = self.get('systemId');
				isRedeemedUrl = isRedeemedUrl + itemCode + '/' + systemId;
				RactiveHelpers.doAjaxJSONCall('GET', isRedeemedUrl, function (response) {
					if (typeof response.result !== 'undefined' && response.result !== '' &&
						response.result.success) {
						var available = response.available;
					

						if (typeof available !== 'undefined' && available !== '') {
							self.set('fullyRedeemed', !available);
						}
					}
				}, function (error) {
					self.set('fullyRedeemed', self.get('fullyRedeemed'));
				
				});
			}
		}
	},

	onrender: function () {
		var self = this;

		self.initVariables();

		self.on('*.rewardSelected', function (event) {
			window.location.href = event.component.instance.get('productUrl');
		});

	}

});

Ractive.components["ux-rewards-catalogue"] = 
Ractive.extend({
	template: LUXComponentTemplates['ux-rewards-catalogue'],
	showRewards: function (num, rewardsShown) {

		var rewardList = this.get('rewardsFiltered');

		if (num === undefined) {
			num = 1;
		}
		if (rewardsShown === undefined) {
			rewardsShown = this.showIndex * this.rewardsShown;
		}

		if (rewardList && rewardList.length > 0) {

			for (var i = 0; i < rewardList.length; i++) {
				if (Math.ceil((1 + i) / rewardsShown) === num) {
					rewardList[i].display = true;
				} else if (Math.ceil((1 + i) / rewardsShown) > num) {
					rewardList[i].display = false;
				}
			}
			this.set('rewardsFiltered', rewardList);

			if (num === Math.ceil(rewardList.length / rewardsShown)) {
				this.set('showButton', false);
			} else {
				this.set('showButton', true);
			}
		} else {
			this.set('showButton', false);
		}

	},
	oninit: function () {

		this.showIndex = 1;
		this.rewardsShown = 9;

	

		this.on('ux-button.viewMore', function () {
			this.showIndex++;
			this.showRewards(this.showIndex, this.rewardsShown);
		}.bind(this));

	}
});

Ractive.components["ux-rewards-filter-facets"] = 
Ractive.extend({
	template: LUXComponentTemplates['ux-rewards-filter-facets'],
	onrender: function () {

		this.set('category', this.get('categories')[0].value);

		this.observe('category', function (newValue, oldValue, keypath) {
			if (newValue !== oldValue && newValue !== 'undefined' && newValue !== null) {
				this.fire('categoryChanged', keypath, newValue);
			}
		}.bind(this));
	}
});

Ractive.components["ux-rewards-list-desc"] = 
Ractive.extend({
	template: LUXComponentTemplates['ux-rewards-list-desc'],

	onrender: function (argument) {
		var self = this;
		self.on('ux-anchor.toggleTnc', function (evt, modalId) {
			RactiveHelpers.toggleModal(self, modalId, true);
		});
	}
});

Ractive.components["ux-rewards-list-header"] = 
Ractive.extend({
	template: LUXComponentTemplates['ux-rewards-list-header'],

	onrender: function () {
		$('div.iparys_inherited').addClass('smallTop');
	}
});

Ractive.components["ux-rewards-list-redemption"] = 
Ractive.extend({
	template: LUXComponentTemplates['ux-rewards-list-redemption'],

	initVariables: function () {
		var self = this;
	
		self.set('transaction', false);
		self.set('disableRedeemButton', true);
		self.set('disableLuckyDrawButton', true);
		self.set('isTncAgreed', false);
		self.set('isTncAgreedPhysical', false);
		self.set('isConsentAgreed', false);
		self.set('isConsentAgreedPhysical', false);
		self.set('errorMessage', null);
		self.set('errorMessageModal', null);
		self.set('luckyDrawConfirm', '');
		self.set('chooseFromAddressList', null);
		self.set('luckyDrawTitle', '');
		self.set('errorTitle', ConfigStrings.errors.genericErrorHeading);

		var luckyDrawInd = self.get('luckyDraw');

		if (luckyDrawInd !== 'undefined' && luckyDrawInd !== '') {
			var drawDt = self.get('drawDate');
			var formattedDt = self.getFormattedEventDate(drawDt);

			if (formattedDt !== 'undefined' && formattedDt !== '') {
				self.set('drawDate', formattedDt);
			}
		}

		var buttonType = self.get('buttonType');

		if (typeof buttonType !== 'undefined' && buttonType !== null && buttonType === 'Redeem Now') {
			var isRedeemedUrl = ConfigStrings.isFullyRedeemedUrl;

			if (isRedeemedUrl !== '') {
				var itemCode = self.get('itemCode');
				var systemId = self.get('systemId');
				isRedeemedUrl = isRedeemedUrl + itemCode + '/' + systemId;

				RactiveHelpers.doAjaxJSONCall('GET', isRedeemedUrl, function (response) {
					if (typeof response.result !== 'undefined' && response.result !== '' &&
						response.result.success) {
						var available = response.available;
						if (typeof available !== 'undefined' && available !== '') {
							self.set('fullyRedeemed', !available);
						}
					}
				}, function (error) {
					self.set('fullyRedeemed', self.get('fullyRedeemed'));
				});
			}
		}
	},

	onrender: function () {
		this.set('onInitRetrieveAddressDisabled', true);
		var self = this;
		var observersOptions = {
			init: false,
			context: self
		};

		self.initVariables();

		

		self.on('ux-anchor.toggleTnc', function (evt, modalId) {
			self.handleModal(true, modalId);
		});

		var loginStatus = RactiveHelpers.getParameterByName('loginstatus');
		if (loginStatus !== 'fail') {
			self.showPreloader();
			self.observe('loginStatusTopic.loginVmStatus',
				self.onLoginVmStatusChange, observersOptions);
			var action = sessionStorage.getItem('action');
			if (action === 'redeemByEmail' || action === 'redeemVoucherPhysical') {
				sessionStorage.removeItem('action');
				self.setCustProfile(action);
				self.removePreloader();
			} else {
				self.removePreloader();
			}
		} else {
			self.set('startDisplay', true);
			var loginUrl = self.get('loginUrl');
			var originUrl;
			if (loginUrl) {
				originUrl = window.location.href;
				originUrl = RactiveHelpers.removeParam(originUrl, 'loginstatus');
				self.set('referenceUrl', originUrl);
			}
			self.removePreloader();
			self.updateModalState('loginForm', true, 'login', originUrl);
		}

		self.on('*.doCloseModal', function (event) {
			sessionStorage.removeItem('action');
		});

		self.on('*.doLuckyDraw', function (event) {
		
			self.showPreloader();

			var rewardTitle = self.get('rewardTitle');
		

			self.set('luckyDrawTitle', rewardTitle);

		
			self.set('onInitRetrieveAddressDisabled', false);
			self.set('errorMessage', null);
		
			RactiveHelpers.checkLoginStatus(self.ractive).then(function () {
				if (self.ractive.get('isLoggedIn')) {
				
					self.setCustProfile('redeemByEmail');
				} else {
				
					var loginUrl = self.get('loginUrl');
					self.set('referenceUrl', '');
					var originUrl;
					if (loginUrl) {
						originUrl = window.location.href;
						originUrl = RactiveHelpers.removeParam(originUrl, 'loginstatus');
						self.set('referenceUrl', encodeURIComponent(originUrl));
					}
					sessionStorage.setItem('loginClicked', true);
				
					self.removePreloader();
					self.handleModal(true, 'loginForm', 'redeemByEmail', originUrl);
				}
			}.bind(self), function (error) {
			
				self.removePreloader();
			
				self.set('errorMessage', ConfigStrings.errors.encounteredError);
			}.bind(self));
		});

		self.on('*.doBirthdayTreat', function (event) {
		
			self.showPreloader();
			self.set('onInitRetrieveAddressDisabled', false);
			self.set('errorMessage', null);

		
			RactiveHelpers.checkLoginStatus(self.ractive).then(function () {
				if (self.ractive.get('isLoggedIn')) {
				
					self.setCustProfile('redeemByEmail');
				} else {
				
					var loginUrl = self.get('loginUrl');
					self.set('referenceUrl', '');
					var originUrl;
					if (loginUrl) {
						originUrl = window.location.href;
						originUrl = RactiveHelpers.removeParam(originUrl, 'loginstatus');
						self.set('referenceUrl', encodeURIComponent(originUrl));
					}
					sessionStorage.setItem('loginClicked', true);
				
					self.removePreloader();
					self.handleModal(true, 'loginForm', 'redeemByEmail', originUrl);
				}
			}.bind(self), function (error) {
			
				self.removePreloader();
			
				self.set('errorMessage', ConfigStrings.errors.encounteredError);
			}.bind(self));
		});

		self.on('*.doRedeemNow', function (event) {
		
			self.showPreloader();
			self.set('errorMessage', null);
			var retrievalMode = self.get('retrievalMode');
			self.set('onInitRetrieveAddressDisabled', false);
			var nextModal = '';
			if (retrievalMode === 'SendPhysicalVoucher') {
				nextModal = 'redeemVoucherPhysical';
			} else {
				nextModal = 'redeemByEmail';
			}
		
			RactiveHelpers.checkLoginStatus(self.ractive).then(function () {
				if (self.ractive.get('isLoggedIn')) {
				
					self.setCustProfile(nextModal);

				} else {
				
					var loginUrl = self.get('loginUrl');
					self.set('referenceUrl', '');
					var originUrl;
					if (loginUrl) {
						originUrl = window.location.href;
						originUrl = RactiveHelpers.removeParam(originUrl, 'loginstatus');
						self.set('referenceUrl', encodeURIComponent(originUrl));
					}
					sessionStorage.setItem('loginClicked', true);
				
					self.removePreloader();
					self.handleModal(true, 'loginForm', nextModal, originUrl);
				}
			}.bind(this), function (error) {
			
				self.removePreloader();
			
				self.set('errorMessage', ConfigStrings.errors.encounteredError);
			}.bind(this));
		});

		self.on('*.changeBillingAddress', function (event) {
			var account = self.get('account');
			var addresses = this.get('account.addressList');
			_.each(addresses, function (address) {
				if (address.accountId === account.selectedAccountId) {
					address.getExistingNumberState = 'selected';
				}
			});
			self.set('account.addressList', addresses);
			self.handleModal(true, 'changeBillingAddressModal');
		});

		self.on('*.doSelectAddress', function (event, type) {
			self.set('account.addressList.*.getExistingNumberState', '');

			var addresses = this.get('account.addressList');
			_.each(addresses, function (address) {
				if (address.accountId === event.context.accountId) {
					address.getExistingNumberState = 'selected';
				}
			});

			self.set('account.addressList', addresses);

			self.set('account.physicalAddress', event.context.address);
			self.set('account.selectedAccountId', event.context.accountId);

			self.handleModal(false, 'changeBillingAddressModal');
		
			self.handleModal(true, 'redeemVoucherPhysical');
		});

		self.on('*.doRedeemModal', function (event) {
			self.showPreloader();
		
			self.set('errorMessageModal', null);
			self.set('errorTitle', ConfigStrings.errors.genericErrorHeading);
			var retrievalMode = self.get('retrievalMode');
			var buttonType = self.get('buttonType');
			var rewardTitle = self.get('rewardTitle');
			var prestigeInd = self.get('prestige');

			if (rewardTitle.endsWith('!') || rewardTitle.endsWith('.')) {
				rewardTitle = rewardTitle.substring(0, rewardTitle.length - 1);
			}

			if (rewardTitle.toLowerCase().startsWith('redeem ')) {
				rewardTitle = rewardTitle.substring(6);
			}
			self.set('rewardTitle', rewardTitle);

			if (retrievalMode === 'SendPhysicalVoucher') {
				var defaultAccountId = self.get('account.defaultAccountId');
				if (typeof defaultAccountId !== 'undefined' && defaultAccountId !== null && defaultAccountId !== '') {
					var selectedAccountId = self.get('account.selectedAccountId');

					if (selectedAccountId !== defaultAccountId) {
						self.set('account.changeAddressInd', true);
					} else {
						self.set('account.changeAddressInd', false);
					}
				}
				var submitRewardsPhysicalUrl = '';

				if (typeof prestigeInd !== 'undefined' && prestigeInd === true) {
					submitRewardsPhysicalUrl = ConfigStrings.submitPrestigePhysicalUrl;
				} else {
					submitRewardsPhysicalUrl = ConfigStrings.submitRewardsPhysicalUrl;
				}
				if (submitRewardsPhysicalUrl !== '' && submitRewardsPhysicalUrl !== undefined) {
					var memberNo = self.get('account.memberId');
					var itemCode = self.get('itemCode');
					var systemId = self.get('systemId');
					var mobileNo = '99999999';
					var addressId = self.get('account.selectedAccountId');
					var isConsentAgreedPhysical = self.get('isConsentAgreedPhysical');

					submitRewardsPhysicalUrl = submitRewardsPhysicalUrl + memberNo + '/' + itemCode + '/' +
						systemId + '/' + mobileNo + '/' + addressId;

					if (typeof isConsentAgreedPhysical !== 'undefined' && isConsentAgreedPhysical === true) {
						submitRewardsPhysicalUrl = submitRewardsPhysicalUrl + '/Y';
					} else {
						submitRewardsPhysicalUrl = submitRewardsPhysicalUrl + '/N';
					}
					RactiveHelpers.doAjaxJSONCall('GET', submitRewardsPhysicalUrl, function (response) {

						if (typeof response.redemption !== 'undefined' && response.redemption === '') {
							self.set('urlInvalid', true);
							self.handleModal(false, 'redeemVoucherPhysical');
							self.set('errorMessageModal', ConfigStrings.errors.genericError);
							self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
							self.removePreloader();
							self.handleModal(true, 'genericError');
						} else if (response.redemption.result.success) {
						
							self.handleModal(false, 'redeemVoucherPhysical');
							self.set('disableRedeemButton', false);
							self.removePreloader();
							self.handleModal(true, 'confirmationModal');
						} else {
							self.set('urlInvalid', true);
							if (typeof prestigeInd !== 'undefined' && prestigeInd === true) {
								self.set('errorMessageModal', response.redemption.result.message);
							} else {
								var dm = self.getFormattedString(response.redemption.displayMessage);
								self.set('errorMessageModal', dm);
							}
							self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
							self.handleModal(false, 'redeemVoucherPhysical');
							self.removePreloader();
							self.handleModal(true, 'genericError');
						}
					}, function (error) {
						self.set('urlInvalid', true);
						self.set('errorMessageModal', ConfigStrings.errors.genericError);
						self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
						self.handleModal(false, 'redeemVoucherPhysical');
						self.removePreloader();
						self.handleModal(true, 'genericError');
					});
				} else {
					self.set('urlInvalid', true);
					self.set('errorMessageModal', ConfigStrings.errors.encounteredError);
					self.handleModal(false, 'redeemVoucherPhysical');
					self.removePreloader();
					self.handleModal(true, 'genericError');
				}
			} else if (retrievalMode === 'Email' || buttonType === 'NA') {
				var submitRewardsEmailUrl = '';

				if (typeof prestigeInd !== 'undefined' && prestigeInd === true) {
					submitRewardsEmailUrl = ConfigStrings.submitPrestigeEmailUrl;
				} else {
					submitRewardsEmailUrl = ConfigStrings.submitRewardsEmailUrl;
				}
				if (submitRewardsEmailUrl !== '' && submitRewardsEmailUrl !== undefined) {
					var memberNo = self.get('account.memberId');
					var itemCode = self.get('itemCode');
					var systemId = self.get('systemId');
					var email = self.get('emailAddr');
					var mobileNo = self.get('mobileNumber');
					var isConsentAgreed = self.get('isConsentAgreed');

					submitRewardsEmailUrl = submitRewardsEmailUrl + memberNo + '/' + itemCode + '/' +
						systemId + '/' + email + '/' + mobileNo;

					if (typeof isConsentAgreed !== 'undefined' && isConsentAgreed === true) {
						submitRewardsEmailUrl = submitRewardsEmailUrl + '/Y';
					} else {
						submitRewardsEmailUrl = submitRewardsEmailUrl + '/N';
					}

					RactiveHelpers.doAjaxJSONCall('GET', submitRewardsEmailUrl, function (response) {
						if (response.redemption.result.success) {
						
							self.handleModal(false, 'redeemByEmail');
							self.removePreloader();
							self.handleModal(true, 'confirmationModal');
						} else {
							self.set('urlInvalid', true);
							if (typeof prestigeInd !== 'undefined' && prestigeInd === true) {
								self.set('errorMessageModal', response.redemption.result.message);
							} else {
								var dm = self.getFormattedString(response.redemption.displayMessage);
								self.set('errorMessageModal', dm);
							}
							self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
							self.handleModal(false, 'redeemByEmail');
							self.removePreloader();
							self.handleModal(true, 'genericError');
						}
					}, function (error) {
						self.set('urlInvalid', true);
						self.set('errorMessageModal', ConfigStrings.errors.genericError);
						self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
						self.handleModal(false, 'redeemByEmail');
						self.removePreloader();
						self.handleModal(true, 'genericError');
					});
				} else {
					self.set('urlInvalid', true);
					self.set('errorMessageModal', ConfigStrings.errors.encounteredError);
					self.handleModal(false, 'redeemByEmail');
					self.removePreloader();
					self.handleModal(true, 'genericError');
				}
			} else {
				self.set('errorMessageModal', ConfigStrings.errors.genericError);
				self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
				self.handleModal(false, 'redeemByEmail');
				self.removePreloader();
				self.handleModal(true, 'genericError');
			}
		});

		self.on('*.doLuckyDrawModal', function (event) {
			self.showPreloader();
		
			self.set('errorMessageModal', null);
			self.set('errorTitle', ConfigStrings.errors.genericErrorHeading);
			var submitRewardsLuckyDrawUrl = '';
			var prestigeInd = self.get('prestige');
			if (typeof prestigeInd !== 'undefined' && prestigeInd === true) {
				submitRewardsLuckyDrawUrl = ConfigStrings.submitPrestigeLuckyDrawUrl;
			} else {
				submitRewardsLuckyDrawUrl = ConfigStrings.submitRewardsLuckyDrawUrl;
			}
			if (submitRewardsLuckyDrawUrl !== '') {
				var memberNo = self.get('account.memberId');
				var itemCode = self.get('itemCode');
				var systemId = self.get('systemId');
				var email = self.get('emailAddr');
				var mobileNo = self.get('mobileNumber');
				var isConsentAgreed = self.get('isConsentAgreed');

				submitRewardsLuckyDrawUrl = submitRewardsLuckyDrawUrl + memberNo + '/' + itemCode + '/' +
					systemId + '/' + email + '/' + mobileNo;

				if (typeof isConsentAgreed !== 'undefined' && isConsentAgreed === true) {
					submitRewardsLuckyDrawUrl = submitRewardsLuckyDrawUrl + '/Y';
				} else {
					submitRewardsLuckyDrawUrl = submitRewardsLuckyDrawUrl + '/N';
				}

				RactiveHelpers.doAjaxJSONCall('GET', submitRewardsLuckyDrawUrl, function (response) {
					if (response.redemption.result.success) {
					
						self.handleModal(false, 'redeemByEmail');
						self.set('disableLuckyDrawButton', false);
						var dm = self.getFormattedString(response.redemption.displayMessage);
						self.set('luckyDrawConfirm', dm);
						self.removePreloader();
						self.handleModal(true, 'confirmationModal');
					} else {
						self.set('urlInvalid', true);
						if (typeof prestigeInd !== 'undefined' && prestigeInd === true) {
							self.set('errorMessageModal', response.redemption.result.message);
						} else {
							var dm = self.getFormattedString(response.redemption.displayMessage);
							self.set('errorMessageModal', dm);
						}
						self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
						self.handleModal(false, 'redeemByEmail');
						self.removePreloader();
						self.handleModal(true, 'genericError');
					}
				}, function (error) {
					self.set('urlInvalid', true);
					self.set('errorMessageModal', ConfigStrings.errors.genericError);
					self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
					self.handleModal(false, 'redeemByEmail');
					self.removePreloader();
					self.handleModal(true, 'genericError');
				});
			} else {
				self.set('urlInvalid', true);
				self.set('errorMessageModal', ConfigStrings.errors.encounteredError);
				self.handleModal(false, 'redeemByEmail');
				self.removePreloader();
				self.handleModal(true, 'genericError');
			}
		});

		self.on('*.doBirthdayTreatModal', function (event) {
			self.showPreloader();
		
			self.set('errorMessageModal', null);
			self.set('errorTitle', ConfigStrings.errors.genericErrorHeading);
			var prestigeInd = self.get('prestige');

			var submitRewardsBirthdayUrl = ConfigStrings.submitRewardsBirthdayUrl;
			if (submitRewardsBirthdayUrl !== '' && submitRewardsBirthdayUrl !== undefined) {
				var memberNo = self.get('account.memberId');
				var itemCode = self.get('itemCode');
				var systemId = self.get('systemId');
				var email = self.get('emailAddr');
				var mobileNo = self.get('mobileNumber');
				var memberPrestige = self.get('account.memberPrestige');

				if (typeof prestigeInd !== 'undefined' && prestigeInd === true &&
					typeof memberPrestige !== 'undefined' && memberPrestige === false) {
					self.set('urlInvalid', true);
					self.set('errorMessageModal', ConfigStrings.errors.nonPrestigeError);
					self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
					self.handleModal(false, 'redeemByEmail');
					self.removePreloader();
					self.handleModal(true, 'genericError');
				} else {
					submitRewardsBirthdayUrl = submitRewardsBirthdayUrl + memberNo + '/' + itemCode + '/' +
						systemId + '/' + email + '/' + mobileNo;
					RactiveHelpers.doAjaxJSONCall('GET', submitRewardsBirthdayUrl, function (response) {
						if (response.redemption.result.success) {
						
							self.handleModal(false, 'redeemByEmail');
							self.removePreloader();
							self.handleModal(true, 'confirmationModal');
						} else {
							self.set('urlInvalid', true);
							self.set('errorMessageModal', response.redemption.result.message);
							self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
							self.handleModal(false, 'redeemByEmail');
							self.removePreloader();
							self.handleModal(true, 'genericError');
						}
					}, function (error) {
						self.set('urlInvalid', true);
						self.set('errorMessageModal', ConfigStrings.errors.genericError);
						self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
						self.handleModal(false, 'redeemByEmail');
						self.removePreloader();
						self.handleModal(true, 'genericError');
					});
				}
			} else {
				self.set('urlInvalid', true);
				self.set('errorMessageModal', ConfigStrings.errors.encounteredError);
				self.handleModal(false, 'redeemByEmail');
				self.removePreloader();
				self.handleModal(true, 'genericError');
			}
		});

		self.on('*.checkPhoneValidation', function (event) {
			var mobileNumber = self.get('mobileNumber');
			self.checkPhone(mobileNumber);
		});

		self.on('*.checkEmailValidation', function (event) {
			var emailAddr = self.get('emailAddr');
			self.checkEmail(emailAddr);
		});

		self.on('*.validateEmail', function () {
			var emailAddr = self.get('emailAddr');
			self.checkEmail(emailAddr);
		});

		self.on('ux-button.checkNumber', self.portNumber, {context: self});

		self.on('ux-input-box.enablePhoneButton', function (event) {
			self.enableAddrButton('mobileNumber');
		}.bind(self));

		self.on('ux-input-box.enableEmailButton', function (event) {
			self.enableAddrButton('emailAddr');
		}.bind(self));
	},

	setCustProfile: function (nextModal) {
		var self = this;
		var url = ConfigStrings.getRewardsCustomerUrl;
		self.set('errorTitle', ConfigStrings.errors.genericErrorHeading);

		if (url !== '' && url !== undefined) {
			RactiveHelpers.doAjaxJSONCall('GET', url, function (response) {
				if (response.customer.result.success) {

					var memberNo = response.customer.memberId;
					if (memberNo === '0' || memberNo === '' || memberNo === null || memberNo === 0) {
						self.removePreloader();
						self.set('errorMessageModal', ConfigStrings.errors.genericError);
						self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
						self.handleModal(true, 'genericError');
					} else {
						self.set('account.customerName', response.customer.name);
						self.set('account.addressList', response.customer.accountList);
						self.set('account.defaultAccountId', response.customer.designatedAccountId);
						self.set('account.physicalAddress', response.customer.designatedAccountAddress);
						self.set('account.memberId', response.customer.memberId);
						self.set('account.selectedAccountId', response.customer.designatedAccountId);
						self.set('emailAddr', response.customer.email);
						self.set('account.memberPrestige', response.customer.prestige);

						if (response.customer.accountList !== null && response.customer.accountList !== '' &&
							response.customer.accountList.length > 1) {
							if (response.customer.designatedAccountAddress !== null &&
								response.customer.designatedAccountAddress.trim() !== '') {
								self.set('chooseFromAddressList', true);
							} else {
								self.set('account.physicalAddress', '');
								self.set('chooseFromAddressList', false);
							}
						} else {
							self.set('chooseFromAddressList', false);
						}
						var rewardTitle = self.get('rewardTitle');
					
						self.set('luckyDrawTitle', rewardTitle);

						var birthdayTreat = self.get('birthdayTreat');

						if (typeof birthdayTreat !== 'undefined' && birthdayTreat === true) {
							var prestigeInd = self.get('prestige');
							var memberPrestige = response.customer.prestige;

							if (typeof prestigeInd !== 'undefined' && prestigeInd === true &&
								typeof memberPrestige !== 'undefined' && memberPrestige === false) {
								self.set('urlInvalid', true);
								self.set('errorMessageModal', ConfigStrings.errors.nonPrestigeError);
								self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
								self.removePreloader();
								self.handleModal(true, 'genericError');
							} else {
								self.removePreloader();
								self.handleModal(true, nextModal);
							}
						} else {
						
							self.removePreloader();
							self.handleModal(true, nextModal);
						}
					}
				} else {
					self.set('urlInvalid', true);
					self.removePreloader();
					self.set('errorMessage', ConfigStrings.errors.apiRetrieveError);
				}
			}, function (error) {
			
				self.removePreloader();
				self.set('errorMessageModal', ConfigStrings.errors.genericError);
				self.set('errorTitle', ConfigStrings.errors.genericParticipateHeading);
				self.handleModal(true, 'genericError');
			
			});
		} else {
			self.set('urlInvalid', true);
			self.removePreloader();
			self.set('errorMessage', ConfigStrings.errors.encounteredError);
		}
	},

	enableAddrButton: function (name) {
		var value = this.get(name);
		if (name === 'mobileNumber') {
			if (value.length === 8) {
				this.checkPhone(value);
			} else {
				this.set('onInitRetrieveAddressDisabled', true);
			}
		} else if (name === 'emailAddr') {
			this.checkEmail(value);
		}
		return false;
	},

	validateEmail: function () {
		var self = this;
		var emailAddr = self.get('emailAddr');
		self.set('emailAddrErrorMsg.message', null);
		self.fire('checkEmail', emailAddr);
		return false;
	},

	portNumber : function () {
		var self = this;
		var mobileNumber = self.get('mobileNumber');
		this.set('phoneVal.phoneValErrorMsg.message', null);
		self.fire('checkPhone', mobileNumber);
		return false;
	},

	checkEmail: function (emailAddr) {
		this.set('emailAddrErrorMsg.message', null);
		this.set('onInitRetrieveAddressDisabled', false);
		var validationRule = {
			'emailAddr': {
				required: 'Please fill in the email field.',
				emailId: 'Please enter a valid email.'
			}
		};
		this.validation = new RactiveValidate(this, validationRule);
		this.validation.patterns.emailFormat = RactiveHelpers.emailValidator;
		this.validation.cwd = '';
		return this.validation.validate(this.validation);
	},

	checkPhone: function (mobileNumber) {
		this.set('onInitRetrieveAddressDisabled', false);
		this.set('phoneVal.phoneValErrorMsg.message', null);
		var validationRule = {
			phoneVal: {
				phoneNoFormat: 'Please enter a valid Contact Number.',
				minlength: {
					param: 8,
					message: 'Please enter a minimum of 8 digits.'
				},
				maxlength: {
					param: 8,
					message: 'Please enter a maximum of 8 digits.'
				},
				digits : 'Please enter a valid Contact Number.'
			}
		};
		this.validation = new RactiveValidate(this, validationRule);
		this.validation.patterns.phoneNoFormat = RactiveHelpers.mobileValidator;
		this.validation.cwd = 'phoneVal';
		this.set('phoneVal.phoneVal', mobileNumber);
		return this.validation.validate(this.validation);
	},

	getFormattedString: function (displayMessage) {
		console.log(displayMessage);
		if (displayMessage !== undefined && displayMessage !== null) {
			var dm = displayMessage.toString().replace('.,', '. ');
			return dm;
		} else {
			return '';
		}
	},

	handleModal: function (visibility, modalId, action, originUrl) {
		if (visibility) {
			this.set('hideModal', true);
		}
		var modals = this.parent.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];
		if (action && modalId === 'loginForm') {
			sessionStorage.setItem('action', action);
			if (originUrl) {
				modal.set('referenceUrl', originUrl);
			}
		}
		modal.set('displayState', visibility);
	},
	onLoginVmStatusChange: function (loginVmStatus) {
			var self = this;
			if (loginVmStatus === 'initialized') {
				var loginClicked = sessionStorage.getItem('loginClicked');
				if (loginClicked && loginClicked !== 'false') {
					self.set('loginClicked', loginClicked);
					var eventName = 'loginStatusTopic.setOnePassFields';
					self.fire(eventName, {
						name: eventName
					});
				}else {
				
					self.handleLoginError();
				}
			} else if (loginVmStatus === 'anonymous') {
			
				self.handleLoginError();
			}
		},
	handleLoginError: function () {
		var loginStatus = RactiveHelpers.getParameterByName('loginstatus');
		if (loginStatus === 'fail') {
			var modals = this.findAllChildComponents('ux-modal');

			var modal = modals.filter(function (component) {
				return 'loginForm' === component.get('modalId');
			})[0];
			if (modal) {
				var loginUrl = this.get('loginUrl');
				var originUrl;
				if (loginUrl) {
					originUrl = window.location.href;
					originUrl = RactiveHelpers.removeParam(originUrl, 'loginstatus');
					this.set('referenceUrl', encodeURIComponent(originUrl));
					modal.set('referenceUrl', originUrl);
				}
				modal.set('displayState', true);
			}
		}
	},
	updateModalState: function (modalId, state, message, originUrl) {
		
		var modals = this.findAllChildComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];
		if (message) {
			modal.set('errorMessageModal', message);
		}
		if (originUrl && modalId === 'loginForm') {
			modal.set('referenceUrl', originUrl);
		}
		modal.set('displayState', state);
	},
	showPreloader : function () {
	
		this.set('transaction', false);
	},
	removePreloader : function () {
	
		this.set('transaction', true);
	},
	getFormattedEventDate: function (eventDate) {
		if (eventDate !== undefined && eventDate !== null) {
			var dt = moment(eventDate, 'YYYYMMDD').toDate();
			return moment(dt).format('DD/MM/YYYY');
		} else {
			return '';
		}
	}
});

Ractive.components["ux-rewards-stuob"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rewards-stuob'],

	onrender: function () {
		var self = this;
		self.set('stuobbin', '');

		self.on('*.onBinNumberChange', function (event) {
			if (!self.isValidBin()) {
				self.set('binNumberValid', false);
			} else {
				self.set('binNumberValid', true);
			}
		});

		self.on('*.requestMobileShare', function (event) {

			var self = this;
			var uobbin = self.get('stuobbin');
			console.log(uobbin);

			var arr = self.get('binList');

			var result =  arr.includes(uobbin);

			if (result) {
				window.location.href = self.get('url');
				self.set('genericErrorMessage', '');
			} else {
				self.set('genericErrorMessage', 'true');
			}
		});
	},

	isValidBin: function () {
		var self = this;
		var uobbin = self.get('stuobbin');
		console.log(uobbin);
		self.set('genericErrorMessage', '');

		if (uobbin === '') {
			return false;
		} else {
			return true;
		}
	}
});


Ractive.components["ux-rewards-summary-list"] = 
Ractive.extend({
	template: LUXComponentTemplates['ux-rewards-summary-list'],
	data: function () {
		return {
			'RactiveHelpers': RactiveHelpers,
			'moment': moment
		};
	},
	oninit: function () {
	
		var self = this;
		self.set('transaction', false);
		self.set('urlInvalid', false);
	
		var url = ConfigStrings.getRewardsHistoryUrl;
		if (typeof url !== 'undefined' && url !== '') {
			RactiveHelpers.doAjaxJSONCall('GET', url, function (response) {
				if (response.result.success) {
					self.set('transaction', true);
					self.set('transactions', response.transactions);
				}else {
					self.set('urlInvalid', true);
				}
			}, function (error) {
				self.set('urlInvalid', true);
			});
		}else {
			self.set('urlInvalid', true);
		}
	},
	onrender: function () {
		var self = this;

		self.on('*.openDetailsPage', function (event, itemCode) {
			var rewardPagesPathUrl = self.get('rewardPagesPath');
			if (typeof rewardPagesPathUrl !== 'undefined' && rewardPagesPathUrl !== '') {

				var items = self.get('items');

				if (typeof items !== 'undefined' && items !== null && items !== '') {
					_.each(items, function (item) {
						var pageItemCode = item.itemCode;

						if (typeof pageItemCode !== 'undefined' && pageItemCode === itemCode) {
							var pageUrl = item.rewardUrl;
							window.open(pageUrl, '_blank');
							return false;
						}
					});
				}
			}
		});
	}
});

Ractive.components["ux-rewards-table-category"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rewards-table-category']
});

Ractive.components["ux-rewards-table-rebate"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rewards-table-rebate']
});

Ractive.components["ux-ribbon-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-ribbon-singtel']
});

Ractive.components["ux-roaming-countrylist"] = Ractive.extend({
	template: LUXComponentTemplates['ux-roaming-countrylist'],
	onconfig: function (argument) {
		this.set('osgBasePath', window.patternLibraryBaseUrl);
	},
	data: function () {
		return {
			ConfigStrings: ConfigStrings
		};
	},
	countryListSearch: function (searchValue) {
		var self = this;
		var countriesList = [];
		var countriesListResult = [];
		var zones = this.get('zones');
		for (var i = 0; i < zones.length; i++) {
			var countries = zones[i].countries;
			for (var j = 0; j < countries.length; j++) {
				var country = {};
				var countryCode = countries[j].countryCode;
				var countryName = countries[j].countryName;
				var countryOperator = countries[j].countryOperator;
				var countryImage = countries[j].countryImage;
				country.countryCode = countryCode;
				country.countryName = countryName;
				country.countryOperator = countryOperator;
				country.countryImage = countryImage;
				countriesList.push(country);
			}
		}
		for (var k = 0; k < countriesList.length; k++) {
			var countryResult = {};
			if (countriesList[k].countryName.toLowerCase().startsWith(searchValue.toLowerCase())) {
				countryResult.title = countriesList[k].countryName;
				countryResult.countryOperator = countriesList[k].countryOperator;
				countryResult.countryImage = countriesList[k].countryImage;
				countryResult.countryCode = countriesList[k].countryCode;
				countriesListResult.push(countryResult);
			}
		}
		var countriesListResultUnique = _.uniq(countriesListResult, function (res) {
			return res.title;
		});
		if (countriesListResultUnique.length > 0) {
			self.set('countriesListResult', countriesListResultUnique);
			self.set('countryListViewAll', true);
			self.set('viewMore', true);
		} else {
			self.set('countryListViewAll', false);
		}
	},

	oninit: function () {
		var self = this;
		self.observe('countrySearchValue', _.throttle(function (newValue, oldValue) {
			if (newValue && oldValue) {
				if (newValue.length > 1) {
					self.countryListSearch(newValue);
				} else {
					self.set('countryListViewAll', false);
					self.set('countriesListResult', '');
				}
			}
		}));
		this.on('ux-addon-singtel.addCountryAddonClicked', function () {
			window.location.href = RactiveHelpers.modifyConfigUrl(ConfigStrings.pageUrls.manageAddOns) +
			'?defaultaddon=roaming';
		});
	},
	filterCountries: function (countryCode) {
		var roamingAddons = this.get('roamingAddons');
		if (roamingAddons) {
			var roamingAddonsFiltered = roamingAddons.filter(function (item) {
				var cqTags = item.cqTags;
				var isIncluded = false;
				cqTags.forEach(function (cqTag) {
					if (cqTag === countryCode) {
						isIncluded = true;
					}
				});
				return isIncluded;
			});
			this.set('roamingAddonsFiltered', roamingAddonsFiltered);
		} else {
			this.set('roamingAddonsFiltered', []);
		}
	},
	onrender: function () {
		var self = this;
	
		function displayModal (modal_id) {
		
			var modals = self.findAllComponents('ux-modal');
			var modal = _.find(modals, function (modal) {
				return modal.get('modal_id') === modal_id;
			});
			modal.set('displayState', true);
		}

		this.on('*.doCloseModal', function (event) {

		});

		this.on('*.onCountryClicked', function (event) {
			var countryName = event.get('countryData').countryName;
			var countryOperator = event.get('countryData').countryOperator;
			var countryImage = event.get('countryData').countryImage;
			var countryCode = event.get('countryData').countryCode;

			self.set('countryName', countryName);
			self.set('countryOperator', countryOperator);
			self.filterCountries(countryCode);
			displayModal('roamingPlansModal');
			self.set('imgsrc', countryImage);
		});

		this.on('selectCountry', function (event, countryCode) {
			console.log(countryCode);
			var zones = self.get('zones');

			zones.forEach(function (zone) {
				zone.countries.forEach(function (country) {
					if (country.countryCode === countryCode) {
						country.selected = !country.selected;
						var countryData = self.get(event.keypath);
						var countryName = countryData.countryName;
						var countryOperator = countryData.countryOperator;
						var countryImage = countryData.countryImage;
						self.set('countryName', countryName);
						self.set('countryOperator', countryOperator);
						self.set('imgsrc', countryImage);
						self.filterCountries(countryCode);
						displayModal('roamingPlansModal');
					} else {
						country.selected = false;
					}
				});
			});
			self.set('zones', zones);
		});
	}
});

Ractive.components["ux-roaming-rates"] = Ractive.extend({
	template: LUXComponentTemplates['ux-roaming-rates'],
	data: function () {
		return {
			ConfigStrings: ConfigStrings
		};
	},

	oninit: function () {
	
		var self = this;
		function getCountryInfoURL() {
			var url;
			url = self.get('getCountryListUrl');
			if (url !== null) {
				return url + '.json';
			}
			return null;
		}
	
		var urlParams = getCountryInfoURL();
		if (urlParams !== null) {
			RactiveHelpers.doAjaxJSONCall('GET', urlParams,
				function (response) {
					var countryLists = [];
					if (response.code === '200') {
						for (var i = 0; i < response.roamingCountries.length; i++) {
							countryLists.push({value: response.roamingCountries[i].countryCode,
								title: response.roamingCountries[i].countryName});
						}
						self.set('roamingCountries', countryLists);
					} else {
						console.log(ConfigStrings.roamingRates.countryListFetchError);
					}
				}.bind(this),
				function (error) {
				
					console.log(ConfigStrings.roamingRates.countryListFetchError);
				}.bind(this)
			);
		} else {
		
			console.log(ConfigStrings.roamingRates.countryListFetchError);
		}
	},
	onrender: function () {
	
		var self = this;
		this.set('buttonDisabled', true);
	
		function displayModal (modal_id) {
		
			var modals = self.findAllComponents('ux-modal');
			var modal = _.find(modals, function (modal) {
				return modal.get('modal_id') === modal_id;
			});
			modal.set('displayState', true);
		}

		this.on('*.doCloseModal', function (event) {

		});

		this.on('*.onCountryChange', function () {
			var selectedCountryValue = this.event.component.get('selected_value');
			var selectedCountryName = this.event.component.get('selectedTitle');
			if (selectedCountryValue !== null || selectedCountryValue !== ' ') {
				this.set('buttonDisabled', false);
				this.set('selectedCountryValue', selectedCountryValue);
				this.set('selectedCountryName', selectedCountryName);
			} else {
				this.set('buttonDisabled', true);
			}
		});

		function getCountryInfoURL(countryCode) {
			var url;
			url = self.get('getCountryInfoUrl');
			if (url !== null) {
				return url + '.' + countryCode + '.json';
			}
			return null;
		}

	
		this.on('*.findRatesButtonClick', function () {
		
		
			var self = this;
			var countryCode = this.get('selectedCountryValue');
			var countryName = this.get('selectedCountryName');
			this.set('countryName', countryName);
		
			var urlParams = getCountryInfoURL(countryCode);
			if (urlParams !== null) {
				RactiveHelpers.doAjaxJSONCall('GET', urlParams, function (response) {
					if (response.code === '200') {
						self.set('countryInfo', response);
						displayModal('roamingRatesModal');
					} else {
						displayModal('errorModal');
					}
				},
			
				function (error) {
				
					displayModal('errorModal');
				});
			}else {
				displayModal('errorModal');
			}
		});
	}
});

Ractive.components["ux-roaming-recommender"] = Ractive.extend({
	template: LUXComponentTemplates['ux-roaming-recommender'],

	onconfig: function (argument) {
		this.set('step', 1);
		this.buildCountryMap();
		this.buildDurationMap();
		this.prepareAddonData();
		this.set('printSelectedCountries', this.printSelectedCountries);
		this.set('printSelectedDurations', this.printSelectedDurations);
		this.set('getAddons', this.getAddons);
		this.set('isNotBlank', this.isNotBlank);
		this.set('osgBasePath', window.patternLibraryBaseUrl);
	},

	getAddons: function () {
		var allAddons = this.get('roamingAddons'),
			selectedCountries = this.get('selectedCountries'),
			selectedDurations = this.get('selectedDurations'),
			recommendedAddons = [];

		allAddons.forEach(function (addon) {
			var tags = addon.cqTags,
				countryMatched = false,
				durationMatched = false;
			tags.forEach(function (tag) {
				selectedCountries.forEach(function (countryId) {
					if (tag.indexOf(countryId) !== -1) {
						countryMatched = true;
					}
				});
				selectedDurations.forEach(function (durationId) {
					if (tag.indexOf(durationId) !== -1) {
						durationMatched = true;
					}
				});
			});
			if (countryMatched && durationMatched) {
				recommendedAddons.push(addon);
			}
		});

		if (recommendedAddons.length <= 0) {
			this.set('noMatchFound', true);
		} else {
			this.set('noMatchFound', false);
		}

		return recommendedAddons;
	},

	prepareAddonData: function () {
		var addons = this.get('roamingAddons');
		addons.forEach(function (addon) {
			addon.totalOneTimeCalculatedPrice = {};
			if (addon.oneTimePrice) {
				addon.totalOneTimeCalculatedPrice.originalAmount = addon.oneTimePrice;
				addon.totalOneTimeCalculatedPrice.finalAmount = addon.oneTimePrice;
			} else {
				addon.totalOneTimeCalculatedPrice.originalAmount = 0;
				addon.totalOneTimeCalculatedPrice.finalAmount = 0;
			}
			if (addon.price) {
				addon.totalRecurringCalculatedPrice = {};
				addon.totalRecurringCalculatedPrice.originalAmount = addon.price;
				addon.totalRecurringCalculatedPrice.finalAmount = addon.price;
			}
		});
	},

	buildCountryMap: function () {
		var zones = this.get('zones'),
			map = {};
		zones.forEach(function (zone) {
			zone.countries.forEach(function (country) {
				map[country.countryCode] = country.countryName;
			});
		});
		this.set('countryMap', map);
	},

	buildDurationMap: function () {
		var durations = this.get('durations'),
			map = {};
		durations.forEach(function (duration) {
			map[duration.durationId] = duration.durationName;
		});
		this.set('durationMap', map);
	},

	toggleModal: function (modalId, displayState) {
		var modalList = this.findAllComponents('ux-modal');
		var targetModal = modalList.filter(function (modal) {
			return modal.get('modalId') === modalId;
		})[0];

		targetModal.set('displayState', displayState);
	},
	oninit: function () {
		var self = this;
		if (self.get('usePmodal')) {
			Ractive.defaults.on('uxModalDataModalUpdated', function (e) {
				self.fire('ux-anchor.openRoamingRecommender');
			});
		}
	},
	onrender: function () {
		this.on('ux-anchor.openRoamingRecommender', function (event) {
			this.toggleModal('roamingRecommenderModal', true);
		});
		this.on('*.selectCountry', function (event, countryId) {
			var zones = this.get('zones'),
				selectedCountries = this.get('selectedCountries'),
				index;

			zones.forEach(function (zone) {
				zone.countries.forEach(function (country) {
					if (country.countryCode === countryId) {
						country.selected = !country.selected;
					}
				});
			});
			this.set('zones', zones);

			if (!selectedCountries) {
				selectedCountries = [];
			}

			index = selectedCountries.indexOf(countryId);
			if (index >= 0) {
				selectedCountries.splice(index, 1);
			} else {
				selectedCountries.push(countryId);
			}

			this.set('selectedCountries', selectedCountries);
		});
		this.on('*.selectDuration', function (event, durationId) {
			var durations = this.get('durations'),
				selectedDurations = this.get('selectedDurations'),
				index;

			durations.forEach(function (duration) {
				if (duration.durationId === durationId) {
					duration.selected = !duration.selected;
				}
			});
			this.set('durations', durations);

			if (!selectedDurations) {
				selectedDurations = [];
			}
			index = selectedDurations.indexOf(durationId);
			if (index >= 0) {
				selectedDurations.splice(index, 1);
			} else {
				selectedDurations.push(durationId);
			}

			this.set('selectedDurations', selectedDurations);
		});
		this.on('*.goToStep', function (event, stepNumber) {
			stepNumber = Number(stepNumber);
			var step = 1;
			if (stepNumber === 2) {
				step = 2;
			} else if (stepNumber > 2) {
				step = 3;
			}
			this.set('step', step);
		});
		this.on('ux-anchor.addAddonClicked', function (event) {
			window.location.href = RactiveHelpers.modifyConfigUrl(ConfigStrings.pageUrls.manageAddOns);
		});
	},

	printSelectedCountries: function () {
		var map = this.get('countryMap'),
			selectedCountries = this.get('selectedCountries'),
			countries = [];
		if (selectedCountries && selectedCountries.length > 0) {
			selectedCountries.forEach(function (countryCode) {
				countries.push(map[countryCode]);
			});
			countries.sort();
		}

		return countries.join(', ');
	},

	printSelectedDurations: function () {
		var map = this.get('durationMap'),
			selectedDurations = this.get('selectedDurations'),
			durations = [];
		if (selectedDurations && selectedDurations.length > 0) {
			selectedDurations.forEach(function (durationId) {
				durations.push(map[durationId]);
			});
			durations.sort();
		}

		return durations.join(', ');
	},

	isNotBlank: function (string) {
		return string && string.trim() !== '';
	}
});

Ractive.components["ux-roaming-table"] = Ractive.extend({
	template: LUXComponentTemplates['ux-roaming-table']
});

Ractive.components["ux-rrp-accessories-catalog"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-accessories-catalog'],
	data: function () {
		return {
			rrpCropTextConfig: ConfigStrings.rrpCropTextConfig,
			RactiveHelpers: RactiveHelpers,
			isIppEligible: true
		};
	},
	showAccessories: function (num, itemsShown) {
		var eligibilityCheckObj = JSON.parse(window.
			sessionStorage.getItem('businesswidget/repository_l9_common/' +
				'common/viewmodel/rrp/RRPOrderContextTopic'));
		if (eligibilityCheckObj && eligibilityCheckObj.products) {
			var notEligible = eligibilityCheckObj.products.every(function eligibleCheck(product) {
				return product.accessoryIPPEligibilityDetails.isIPPEligible ===  false;
			});
			if (notEligible) {
				this.set('isIppEligible', false);
			}
		}
		this.set('startAccessoriesDisplay', false);
		var initialList = this.get('initData.accessories');
		_.each(initialList, function (accessory) {
			var variants = accessory.variants;
			var colorVariants = [];
			_.each(variants, function (variant) {
				colorVariants.push({
					hexCode: variant.hexCode
				});
			});
			accessory.colorVariants = _.uniq(colorVariants, function (i) {
				return i.hexCode;
			});
			if (accessory.minOnetimePrice) {
				var decimalPrice = accessory.minOnetimePrice.toString();
				if (_.indexOf(decimalPrice.split(''), '.') !== -1) {
					accessory.minOnetimePrice = parseFloat(accessory.minOnetimePrice).toFixed(2);
				} else {
					accessory.minOnetimePrice = decimalPrice + '.00';
				}
			}
			if (accessory.usualPrice && accessory.minOnetimePrice) {
				var usualPrice = accessory.usualPrice.toString();
				if (_.indexOf(usualPrice.split(''), '.') !== -1) {
					accessory.usualPrice = parseFloat(accessory.usualPrice).toFixed(2);
				} else {
					accessory.usualPrice = usualPrice + '.00';
				}
				if (Number(accessory.usualPrice) > Number(accessory.minOnetimePrice)) {
					accessory.isDisplayUP = true;
				}
			}
		});
		var accessoriesList = _.filter(initialList, function (accessories) {
			return !accessories.hideForDisplay;
		});
		if (num === undefined) {
			num = 1;
		}
		if (itemsShown === undefined) {
			itemsShown = this.showIndex * this.itemsShown;
		}

		if (accessoriesList && accessoriesList.length > 0) {

			for (var i = 0; i < accessoriesList.length; i++) {
				if (Math.ceil((1 + i) / itemsShown) === num) {
					accessoriesList[i].display = true;
				} else if (Math.ceil((1 + i) / itemsShown) > num) {
					accessoriesList[i].display = false;
				}
			}
			if (num === Math.ceil(accessoriesList.length / itemsShown)) {
				this.set('initData.showButton', false);
			} else {
				this.set('initData.showButton', true);
			}
		} else {
			this.set('initData.showButton', false);
		}
		this.set('initData.filteredAccessoriesList', accessoriesList);
		this.set('startAccessoriesDisplay', true);
	},
	toggleModel: function (modal_id, state) {
		var self = this;
		var modalList = self.findAllComponents('ux-modal');
		var modal = _.find(modalList, function (modal) {
			return modal.get('modalId') === modal_id;
		});
		modal.set('displayState', state);
	},
	oninit: function () {

		this.showIndex = 1;
		this.itemsShown = 12;

	

		this.on('ux-button.viewMore', function () {
			this.showIndex++;
			this.showAccessories(this.showIndex, this.itemsShown);
		}.bind(this));

	},
	oncomplete : function () {
		this.on('doSelectAccessory', function (event,index) {
			var idx = index;
			var accessoryObj = this.get('initData.filteredAccessoriesList')[idx];
			var redirectPageUrl = accessoryObj.productUrl;
			if (redirectPageUrl) {
				window.location.href = RactiveHelpers.modifyConfigUrl(redirectPageUrl);
			}
		}.bind(this));
	}
});

Ractive.components["ux-rrp-delivery-details"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-delivery-details'],
	isolated: true,
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			ConfigStrings: ConfigStrings
		};
	},
	onrender: function () {
	}
});

Ractive.components["ux-rrp-delivery-information"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-delivery-information'],
	isolated: true,
	data: function () {
		return {
			hideTitle: false,
			hideChangeLink: false,
			RactiveHelpers: RactiveHelpers,
			getDeliveryDate: function () {
				var slotStartDateEpoch = this.get('isIpp') ?
					this.get('orderDeliveryDetails.deliveryDate') : this.get('orderDeliveryDetails.slotStartDateEpoch');
				var formattedDate = '';
				if (slotStartDateEpoch) {
					formattedDate = RactiveHelpers.convertMilisTimestampToDateSGP
					(slotStartDateEpoch, 'DD MMM YYYY');
				}
				return formattedDate;
			},
			getDeliveryAddress: function () {
				var self = this,
					isIpp = self.get('isIpp'),
					orderDeliveryDetails = self.get('orderDeliveryDetails');
				if (isIpp && orderDeliveryDetails) {
					var isConfirmation = self.get('isConfirmation'),
						deliveryAddress;
					if (isConfirmation) {
						deliveryAddress = orderDeliveryDetails.deliveryAddress;
					} else {
						deliveryAddress = orderDeliveryDetails;
					}
					var matchedRes = deliveryAddress.addressLine2 &&
						deliveryAddress.addressLine2.match(/\d+\* /);
					var houseNumber = '';
					if (matchedRes && matchedRes.length > 0) {
						houseNumber = matchedRes[0];
					}
					var streetName = deliveryAddress.addressLine2 &&
						deliveryAddress.addressLine2.substring(houseNumber.length),
						splitLine4 = deliveryAddress.addressLine4 &&
							deliveryAddress.addressLine4.split(' '),
						city = '',
						postcode = '';
					if (splitLine4 && splitLine4.length > 0) {
						for (var x = 0; x < splitLine4.length - 1; x++) {
							city += (splitLine4[x] + ' ');
						}
						postcode = splitLine4[splitLine4.length - 1];
					}
					var reworkedDeliveryAddress = {
						buildingName: deliveryAddress.addressLine1,
						houseNumber: houseNumber,
						streetName: streetName,
						unitNumber: deliveryAddress.addressLine3,
						postcode: postcode,
						city: city
					};
					self.set('orderDeliveryDetails.deliveryAddress', reworkedDeliveryAddress);
					return reworkedDeliveryAddress;
				}
			}
		};
	},
	oninit: function () {
		var self = this,
			isIpp = self.get('isIpp'),
			orderDeliveryDetails = self.get('orderDeliveryDetails');
		if (isIpp && orderDeliveryDetails) {
			var isConfirmation = self.get('isConfirmation'),
				deliveryAddress;
			if (isConfirmation) {
				deliveryAddress = orderDeliveryDetails.deliveryAddress;
			} else {
				deliveryAddress = orderDeliveryDetails;
			}
			var matchedRes = deliveryAddress.addressLine2 &&
				deliveryAddress.addressLine2.match(/\d+\* /);
			var houseNumber = '';
			if (matchedRes && matchedRes.length > 0) {
				houseNumber = matchedRes[0];
			}
			var streetName = deliveryAddress.addressLine2 &&
				deliveryAddress.addressLine2.substring(houseNumber.length),
				splitLine4 = deliveryAddress.addressLine4 &&
					deliveryAddress.addressLine4.split(' '),
				city = '',
				postcode = '';
			if (splitLine4 && splitLine4.length > 0) {
				for (var x = 0; x < splitLine4.length - 1; x++) {
					city += (splitLine4[x] + ' ');
				}
				postcode = splitLine4[splitLine4.length - 1];
			}
			var reworkedDeliveryAddress = {
				buildingName: deliveryAddress.addressLine1,
				houseNumber: houseNumber,
				streetName: streetName,
				unitNumber: deliveryAddress.addressLine3,
				postcode: postcode,
				city: city
			};
			self.set('orderDeliveryDetails.deliveryAddress', reworkedDeliveryAddress);
		}
	}
















































});

Ractive.components["ux-rrp-discount-item"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-discount-item'],
	isolated: true,
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			isOrderSummary: false,
			promotion: null
		};
	}
});

Ractive.components["ux-rrp-group-item"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-group-item'],
	isolated: true,
	onrender: function () {
		this.on('selectGroupItem', function () {
			if (this.get('isEnabled') && this.get('isAvailable')) {
				this.fire('onSelectGroupItem', this.get('groupIndex'), this.get('variant'));
			}
		});
	}
});

Ractive.components["ux-rrp-image-gallery"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-image-gallery'],
	isolated: true,
	data: function () {
		return {
			images: null,
			selectedImage: null
		};
	},
	oninit: function () {
		this.observe('images', this.onImagesChange.bind(this));
	},
	onImagesChange: function (images) {
		if (images && images.length) {
			this.showImage(images[0]);
		}
	},
	onrender: function () {
	
		switch (this.get('topSpacing')) {
			case 'small':
				this.set('topSpacing', 'small');
				break;
			case 'medium':
				this.set('topSpacing', 'medium');
				break;
			case 'large':
				this.set('topSpacing', 'large');
				break;
			default:
				this.set('topSpacing', 'normal');
		}

		this.on('doShowSelectedImage', function (event, imagePath) {
			this.showImage(imagePath);
		}.bind(this));
	},

	showImage: function (imagePath) {
		this.set('selectedImage', imagePath);
	}
});

Ractive.components["ux-rrp-order-item"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-order-item'],
	isolated: true,
	data: function () {
		return {
			isChangeble: false,
			orderItem: null,
			maxAllowedQty: 10,
			minAllowedQty: 1,
			isOrderSummary: false,
			readOnlyCounter: false,
			RactiveHelpers: RactiveHelpers,
			ConfigStrings: ConfigStrings
		};
	},
	onrender: function () {
		this.on('*.quantityChange', function (quantity, eventType) {
			var orderItem = this.get('orderItem');
			if (eventType === 'increment') {
				quantity = quantity - orderItem.originalQuantity;
				this.fire('addNewOrderItems', quantity, orderItem.variant, orderItem);
			} else if (eventType === 'decrement') {
				quantity = orderItem.originalQuantity - quantity;
				this.fire('removeExistingOrderItems', quantity, orderItem.variant, orderItem);
			}
		}.bind(this));

		this.on('*.removeAllSkus', function () {
			var orderItem = this.get('orderItem');
			this.fire('removeExistingOrderItems', orderItem.orderItemDetails.length, orderItem.variant, orderItem);
		}.bind(this));
		this.on('*.removeAllSkusIPP', function () {
			var orderItem = this.get('orderItem');
			this.fire('removeExistingIppOrderItems', orderItem.orderItemDetails.length, orderItem.variant, orderItem);
		});
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	}
});

Ractive.components["ux-rrp-order-summary"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-order-summary'],
	data: function () {
		return {
			ConfigStrings: ConfigStrings
		};
	},
	decorators: {
		tooltip: ractiveTooltip
	},
	onrender: function () {
		var self = this;

		self.on('showTooltip', function (event) {

			if (event.original.currentTarget.nextElementSibling.style.display !== 'block') {
				_.each(document.getElementsByClassName('tooltip'), function (v) {
					v.style.display = 'none';
				});
				event.original.currentTarget.nextElementSibling.style.display = 'block';
			} else {
				event.original.currentTarget.nextElementSibling.style.display = 'none';
			}

			return false;
		});
	}
});

Ractive.components["ux-rrp-ordersummary-row"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-ordersummary-row'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			ConfigStrings: ConfigStrings
		};
	},

	oninit: function () {
		var self = this;
		var type = self.get('type');

		self.map = {

			'preGST' : 'Total (Before GST)',
			'GST': 'GST (7%)',
			'postGST' : 'Total (Inclusive of GST)'
		};

		self.setRowData(type);
	},
	onrender: function () {
		var self = this;

		self.on('showTooltip', function (event) {
			if (event.original.currentTarget.nextElementSibling.style.display !== 'block') {
				_.each(document.getElementsByClassName('tooltip'), function (v) {
					v.style.display = 'none';
				});
				event.original.currentTarget.nextElementSibling.style.display = 'block';
			} else {
				event.original.currentTarget.nextElementSibling.style.display = 'none';
			}
			return false;
		});
	},
	setRowData: function (type) {
		var self = this;
		var rowdata = '';
		var checkoutPWT = '';
		if (type === 'preGST') {
			var detailedData = self.get('');
			rowdata = self.map[type];
			if (typeof detailedData.checkoutPrice !== 'undefined') {
				checkoutPWT = detailedData.checkoutPrice.finalAmount;
			}
		} else if (type === 'GST') {
			var detailedData = self.get('');
			rowdata = self.map[type];
			if (typeof detailedData.checkoutPrice !== 'undefined') {
				checkoutPWT = detailedData.checkoutPrice.finalTaxAmount;
			}
		} else if (type === 'postGST') {
			var detailedData = self.get('');
			rowdata = self.map[type];
			var checkoutPrice = detailedData.checkoutPrice;
			if (typeof checkoutPrice !== 'undefined') {
				checkoutPWT = checkoutPrice.finalAmountIncludingTax;
			}
		}
		self.set('rowData', rowdata);
		self.set('checkoutPrice', checkoutPWT);
	}
});

Ractive.components["ux-rrp-payment-term-item"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-payment-term-item'],
	oninit: function () {
		this.set('startDisplay', false);
		var ippContractTerms = this.get('ippContractTerms');
		this.observe('groupBy', function (groupBy) {
			if (groupBy && groupBy.length > 0) {
				var enablePaymentTerm = true;
				_.each(groupBy, function (option) {
					if (option.isEnabled && !option.selectedValue) {
						enablePaymentTerm = false;
						return true;
					}
				});
				this.set('enablePaymentTerm', enablePaymentTerm);
			}
		});
		if (ippContractTerms && this.get('ippEnabled')) {
			_.each(ippContractTerms, function (term) {
				if (term === '12') {
					this.set('is12MonthEnabled', true);
				} else if (term === '24') {
					this.set('is24MonthEnabled', true);
				} else if (term === '36') {
					this.set('is36MonthEnabled', true);
				}
			}.bind(this));
		}
		var filteredIppContractTerms = ippContractTerms.filter(function (contractTerm) {
			if (contractTerm) {
				return contractTerm;
			}
		});
		this.set('filteredIppContractTerms', filteredIppContractTerms);
	}
});

Ractive.components["ux-rrp-personal-information"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-personal-information'],
	isolated: true,
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	}
});

Ractive.components["ux-rrp-price-item"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-price-item'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	}
});

Ractive.components["ux-rrp-promo-code"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-promo-code'],
	isolated: true,
	data: function () {
		return {
			promotions: null,
			couponPromo: null,
			initData: null,
			promoCode: null,
			promoCodeErrorMsg: null,
			RactiveHelpers: RactiveHelpers,
			rrpOrderTopic: null
		};
	},
	oninit: function () {
		this.observe('promotions', this.onPromotionsChange, this);
		this.observe('rrpOrderTopic.rrpOrderCouponVmStatus',
			this.rrpOrderCouponVmStatusChange.bind(this));
		this.on('*.applyPromoBtnClick', function () {
			this.setPromoCodeErrorMsg(null);
			var promoCode = this.get('promoCode');
			if (promoCode) {
				this.fire('onApplyPromo', promoCode.toUpperCase());
			}
		}.bind(this));
		this.on('*.removePromoLinkClick', function () {
			this.setPromoCodeErrorMsg(null);
			var couponPromo = this.get('couponPromo');
			if (couponPromo) {
				var promoCode = this.get('promoCode');
				this.fire('onRemovePromo', promoCode);
			}
		}.bind(this));
	},
	onPromotionsChange: function (promotions) {
		if (promotions && promotions.length) {
		
			var couponPromo = _.find(promotions, function (promo) {
				return promo.promoSubType === 'COUPON';
			});
			if (couponPromo) {
				this.set('couponPromo', couponPromo);
				this.set('promoCode', couponPromo.couponCode);
			}
		}
	},
	rrpOrderCouponVmStatusChange: function (rrpOrderCouponVmStatus) {
		switch (rrpOrderCouponVmStatus) {
			case 'ApplyCouponAlreadyApplied':
				this.setPromoCodeErrorMsg({
					'message': ConfigStrings.RRP.error.couponAlreadyApplied,
					'status': 'error'
				});
				break;
			case 'ApplyCouponInvalidCoupon':
				this.setPromoCodeErrorMsg({
					'message': ConfigStrings.RRP.error.invalidCodeMessage,
					'status': 'error'
				});
				break;
			case 'ApplyCouponFailed':
				this.setPromoCodeErrorMsg({
					'message': ConfigStrings.RRP.error.couponError,
					'status': 'error'
				});
				break;
			case 'RemoveCouponNotApplied':
				this.setPromoCodeErrorMsg({
					'message': ConfigStrings.RRP.error.couponError,
					'status': 'error'
				});
				break;
			case 'RemoveCouponFailed':
				this.setPromoCodeErrorMsg({
					'message': ConfigStrings.RRP.error.couponError,
					'status': 'error'
				});
				break;
		}
	},
	setPromoCodeErrorMsg: function (error) {
		this.set('promoCodeErrorMsg', error);
	}
});

Ractive.components["ux-rrp-summary-accordion"] = Ractive.extend({
	isolated: true,
	template: LUXComponentTemplates['ux-rrp-summary-accordion'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			configStrings: ConfigStrings,
			initData: null,
			isOrderSummary: false,
			readOnlyCounter: false,
			showPromoSection: false,
			rrpOrderTopic: null,
			isChangeble: false,
			showPromoCodeDiscount: false
		};
	},
	onrender: function (argument) {
	}
});

Ractive.components["ux-rrp-summarydata-row"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-summarydata-row'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},
	oninit: function () {
		var self = this;
		var type = self.get('type');

		self.map = {

			'deviceDetails': 'Device',
			'accessories': 'Accessories',
			'deliveryDetails': self.get('deliveryDetails.deliveryType')
		};

		self.rowdata = '';
		self.checkoutPWT = '';
		self.removeLinkTemplate = '<a href="#" class="left change-link">Remove</a>';
		self.set('changeState', 'hide');
		self.set('addMoreState', 'hide');
		self.set('removeState', 'hide');
		self.set('itemRemoveState', 'hide');

		self.setRowData(type);
		self.setRowTitle(type);

	},

	onrender: function (argument) {
		var self = this;
		self.update();
		self.on('*.changeCartItem', function () {
			var mapType = self.get('type');
			if (typeof mapType !== 'undefined' && mapType !== 'serviceDetails') {
				self.fire('onChangeCartItem', self.get('type'), self.get());
			} else {
				var name = self.get('serviceName');
				if (name === 'Land Line') {
					self.fire('onChangeCartItem', 'landlineNumber', self.get());
				} else {
					self.fire('onChangeCartItem', 'broadBandPlanDetails', self.get());
				}
			}
		});
		self.on('*.addCartItem', function () {
			self.fire('onChangeCartItem', self.get('type'), self.get());
		});
		self.on('*.removeCartItem', function (event) {
			self.fire('onRemoveCartItem', self.get('type'), self.get(), event.get('index'));
		});
	},

	setRowTitle: function (type) {
		var self = this;
		if (self.map[type] && self.map[type] !== '') {
			self.set('rowTitle', self.map[type]);
		}
	},

	setRowData: function (type) {
		var self = this;
		var showChange = self.get('showChange');
		if (type === 'deviceDetails') {
			self.detailedData = self.get('deviceDetails');
			self.setDeviceRowDataMultiple();
			if (showChange === true) {
				self.set('changeState', 'show');
			}
		} else if (type === 'accessories') {
			self.detailedData = self.get('accessories');
			self.setRowDataMultiple();
			if (showChange === true) {
				self.set('addMoreState', 'show');
				self.set('removeState', 'show');
			}
		}
		if (self.detailedData && typeof self.detailedData.length === 'undefined') {
			self.set('rowDetails', [self.detailedData]);
		} else {
			self.set('rowDetails', self.detailedData);
		}
		self.set('rowData', self.rowdata);
	},
	setDeviceRowDataMultiple: function () {
		var self = this;
		for (var i = 0; i < self.detailedData.length; i++) {
			self.detailedData[i].rowData = self.detailedData[i].deviceName + '<br>' +
				self.detailedData[i].deviceSize + ', ' + self.detailedData[i].colour;
			if (self.detailedData[i].ippFlag) {
				self.detailedData[i].rowData =  self.detailedData[i].rowData + '<br>' +
					'(24 Installments, ' +
					RactiveHelpers.convertUnits(
						(self.detailedData[i].oneTimePrice.finalAmountIncludingTax / 24),
					'$') + ' per Month)';
			}
		}
	}

});

Ractive.components["ux-rrp-summarytitle-row"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-summarytitle-row'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	}
});

Ractive.components["ux-rrp-top-bar"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-top-bar'],
	decorators: {
		tooltip: ractiveTooltip
	},

	onrender: function () {
		var self = this;
		self.set('show_tooltip', false);
		var topbar = document.querySelector('.ux-top-bar-singtel');
		var stickyStartPos = topbar.getBoundingClientRect().top;
		$(window).scroll(function () {
			if (document.querySelector('.ux-summary-accordion') && ($(this).scrollTop() > stickyStartPos)) {
				var testAccordion = document.querySelector('.ux-summary-accordion');
				if (testAccordion.getBoundingClientRect().top < 0) {
					self.set('isSticky', true);
					var el = document.querySelector('.bottom-summary-panel');
					if (el) {
						var rect = el.getBoundingClientRect();
						if (rect.top < document.querySelector('.ux-top-bar-singtel').getBoundingClientRect().height +
							document.querySelector('.ux-top-bar-singtel').getBoundingClientRect().top) {
							self.set('isSticky', false);
						}
					}
				}
			}
			if (document.querySelector('.ux-summary-accordion').getBoundingClientRect().top >
				document.querySelector('.ux-top-bar-singtel').getBoundingClientRect().top - 70) {
				self.set('isSticky', false);
				self.set('offsetTop', false);
			}


			if (this.pageScroll > window.pageYOffset || window.pageYOffset < 120) {
				if (!self.get('offsetTop') && self.get('isSticky')) {
					self.set('offsetTop', true);
				}
			} else {
				if (self.get('offsetTop')) {
					self.set('offsetTop', false);
				}
			}
			this.pageScroll = window.pageYOffset;

		});

		this.on('showTooltip', function (event) {

			if (event.original.currentTarget.nextElementSibling.style.display !== 'block') {
				_.each(document.getElementsByClassName('tooltip'), function (v) {
					v.style.display = 'none';
				});
				event.original.currentTarget.nextElementSibling.style.display = 'block';
			} else {
				event.original.currentTarget.nextElementSibling.style.display = 'none';
			}

			return false;
		});
	}
});

Ractive.components["ux-rrp-variant-selector"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-variant-selector'],

	onrender: function () {
		var self = this;
		self.disableCapacity();
	
		self.set('noOpenModelInd', true);
		setTimeout(function () {
			self.fire('getPriceDetails');
		}.bind(this), 0);
		self.set('price', '$' + self.get('minOnetimePrice'));
	
		var spacings = ['small', 'medium', 'large'];
		self.fire('setButtonToggleState', 'disabled');
		var topSpacing = self.get('topSpacing');
		topSpacing = _.indexOf(spacings, topSpacing) !== -1 ?
		self.set('topSpacing', topSpacing) : self.set('topSpacing', 'normal');

		var bottomSpacing = self.get('bottomSpacing');
		bottomSpacing = _.indexOf(spacings, bottomSpacing) !== -1 ?
		self.set('bottomSpacing', bottomSpacing) : self.set('bottomSpacing', 'normal');

		self.on('ux-productvariant-container.doOpenModalContent', function () {
			self.set('noOpenModelInd', false);
			self.fire('getPriceDetails');
		});

		self.parent.on('openModel', function (newValue) {
			if (newValue === 'failure') {
				self.set('errorMessage', true);
			} else {
				self.set('errorMessage', false);
			
			}
			self.handleModal();
		});

		self.on('ux-color-variant.doSelectColor', function (imgColor) {
			self.set('selectedColor', imgColor);
			self.set('selectedCapacity', '');
			self.setSelectedState('selectedColorState', self.get('selectedColor'));
			self.fire('setButtonToggleState', 'disabled');
			var selectedVariant = _.find(self.get('gadgetColors'), function (v) {
					if (v.color === imgColor) {
						return v;
					}
				});
			self.set('price', '$' + selectedVariant.price);
			self.fire('colorChange', imgColor);
			self.fire('selectedVariant', selectedVariant);

		});

		self.on('ux-capacity-variant.doSelectCapacity', function (imgCapacity) {
			var capacityState = self.get('selectedCapacityState');
			if (capacityState === 'disabled') {
				return;
			}
			self.set('selectedCapacity', imgCapacity);
			self.setSelectedState('selectedCapacityState', self.get('selectedCapacity'));
			var numOfInstallments = 12;
			if (numOfInstallments !== 0) {
				self.fire('setPaymentModeState', 'enabled', imgCapacity);
			} else {
				self.fire('setButtonToggleState', 'enabled');
			}
		});

	},

	disableCapacity: function () {
		this.fire('setButtonToggleState', 'disabled');
		this.fire('setPaymentModeState', 'disabled');
		this.set('selectedCapacityState', 'disabled');
		this.set('showSize', false);
		this.update();
	},

	handleModal: function () {
		var modal = this.parent.findComponent('ux-modal');
		var noOpenModelInd = this.get('noOpenModelInd');

		var availableStocks = this.get('productAvailability.availableStocks');
		if (availableStocks) {
			var gadgetStock = [];
			var variants = this.get('initData.accessoryDetails.variants');
			var uniqueVariants = _.uniq(variants, 'sku');
			_.each(uniqueVariants, function (variant) {
				var gadget = {};
				_.each(availableStocks, function (stock) {
					if (stock.itemCode === variant.sku) {
						gadget = {
							color: variant.name,
							hexCode: variant.hexCode,
							availableQty: stock.availableQty,
							minQuantity: Math.min(stock.availableQty, variant.itemLowerLimit),
							maxQuantity: Math.min(stock.availableQty, variant.itemUpperLimit),
							status: stock.status ===  'Not available' ? true : false,
							sku: stock.itemCode,
							price: variant.price
						};
						this.set('isDisabled', gadget.status);
						if (variant.size) {
							gadget.stockInfo[variant.size] = {
								capacity: variant.size
							};
						
						}
					}
				}.bind(this));
				gadgetStock.push(gadget);
			}.bind(this));
			this.set('gadgetColors', gadgetStock);
			this.set('data.gadgetStock', gadgetStock);
		}
		if (!noOpenModelInd) {
			modal.set('displayState', true);
		}
	},

	setSelectedState: function (state, property) {
		var selectedStateStr = state + '.' + property.toString().toLowerCase();
		var selectedStateObj = this.get(state);
		if (selectedStateObj !== undefined && selectedStateObj !== '') {
			_.each(selectedStateObj, function (element, key) {
				if (key !== property.toString().toLowerCase()) {
					selectedStateObj[key] = '';
				}
			});
		}
		this.set(selectedStateStr, 'selected');
		this.update();
	}
});

Ractive.components["ux-rrp-variant"] = Ractive.extend({
	template: LUXComponentTemplates['ux-rrp-variant'],
	isolated: true,
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			selectedColor: null,
			getVariantsByField: function (field, groupIndex) {
				var variants = this.get('variants');
				var variantsByField = _.groupBy(variants, field);
				var variantsWithQuantity = [];
				_.each(variantsByField, function (variantsList) {
					var variantWithQuantity = _.reduce(variantsList, function (result, variant) {
						if (!result) {
							result = _.clone(variant);
						} else {
							result.availableQty += variant.availableQty;
						}
						return result;
					}, null);
					variantsWithQuantity.push(variantWithQuantity);
				});
				if (field && field  === 'size') {
					var filteredVariantsIntegers = _.filter(variantsWithQuantity, function (variant) {
						return (variant.size && !isNaN(parseInt(variant.size)));
					});
					var filteredVariantsNonIntegers = _.filter(variantsWithQuantity, function (variant) {
						return (variant.size && isNaN(parseInt(variant.size)));
					});
					if (filteredVariantsIntegers.length > 0) {
						filteredVariantsIntegers = _.sortBy(filteredVariantsIntegers, function (variant) {
							return parseInt(variant.size, 10);
						});
					}
					if (filteredVariantsNonIntegers.length > 0) {
						filteredVariantsNonIntegers = _.sortBy(filteredVariantsNonIntegers, function (variant) {
							return variant.size.toLowerCase();
						});
					}
					variantsWithQuantity = filteredVariantsIntegers.concat(filteredVariantsNonIntegers);
				}
				return variantsWithQuantity;
			},
			isItemSelected: function (group, variant) {
				if (group && group.selectedValue === variant[group.field]) {
					return true;
				}
				return false;
			},
			isItemEnabled: function (currentGroupIndex) {
				return this.isParentGroupSelected(currentGroupIndex);
			},
			isItemAvailable: function (variant, currentGroupIndex) {
				var group = this.get('groupBy.' + currentGroupIndex);
			
				var availableQty = 10000;
			
			
				if (this.isParentGroupSelected(currentGroupIndex)) {
					availableQty = 0;
					var variants = this.getFilteredVariantsByParentGroup(this.get('variants'), 0, currentGroupIndex);
					if (variants && variants.length) {
						var variantsByField = this.accumulateVariantsByGroup(variants, currentGroupIndex);
						var fieldValue = variant[group.field];
						var accumulateVariant = variantsByField[fieldValue];
						if (accumulateVariant) {
							availableQty = accumulateVariant.availableQty ? accumulateVariant.availableQty : 0 ;
						}
					}
				}
				return availableQty;
			}
		};
	},

	onrender: function () {
		this.on('onColorSelect', function (event, colorName, identifier, skuId) {
			this.showSelectedColor(colorName);
			this.parent.set('identifier', identifier);
			this.parent.set('skuId', skuId);
		}.bind(this));
	},

	showSelectedColor: function (colorName) {
		this.set('selectedColor', colorName);
	},

	isParentGroupSelected: function (currentGroupIndex) {
		if (currentGroupIndex === 0) {
		
			return true;
		} else {
			return this.get('groupBy.' + (currentGroupIndex - 1) + '.selectedValue') ? true : false;
		}
	},

	getFilteredVariantsByParentGroup: function (variants, currentGroupIndex, childGroupIndex) {
		if (currentGroupIndex < childGroupIndex) {
			var group = this.get('groupBy.' + currentGroupIndex);
			var filteredVariants = _.filter(variants, function (variant) {
				return variant[group.field] === group.selectedValue;
			});
			return this.getFilteredVariantsByParentGroup(filteredVariants, ++currentGroupIndex, childGroupIndex);
		}
		return variants;
	},

	accumulateVariantsByGroup: function (variants, currentGroupIndex) {
		var group = this.get('groupBy.' + currentGroupIndex);
		var variantsByField = _.groupBy(variants, group.field);

		_.each(variantsByField, function (variantsList, key) {
			var variantWithQuantity = _.reduce(variantsList, function (result, variant) {
				if (!result) {
					result = _.clone(variant);
				} else {
					result.availableQty += variant.availableQty;
				}
				return result;
			}, null);
			variantsByField[key] = variantWithQuantity;
		});
		return variantsByField;
	}
});

Ractive.components["ux-search-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-search-singtel'],
	isolated: true,

	transitions: {
		fly: ractiveTransitionsFly
	},

	data: function () {
		return {
			showSearchBox: false,
			searchValue: ''
		};
	},

	onconfig: function () {
		var cropTextConfig = ConfigStrings.cropTextConfig;
		this.setMaxCharacters('maxCharactersTitleMobile', cropTextConfig.mobileChars);
		this.setMaxCharacters('maxCharactersTitleTablet', cropTextConfig.tabletChars);
		this.setMaxCharacters('maxCharactersTitleDesktop', cropTextConfig.desktopChars);
		this.setMaxCharacters('maxCharactersDescMobile', cropTextConfig.mobileChars);
		this.setMaxCharacters('maxCharactersDescTablet', cropTextConfig.tabletChars);
		this.setMaxCharacters('maxCharactersDescDesktop', cropTextConfig.desktopChars);
	},
	setMaxCharacters: function (property, defaultValue) {
		this.set(property, (this.get(property) ? this.get(property) : defaultValue));
	},

	oninit: function () {
		this.on('ux-icon.showSearchBox', function () {
			const myEvent = new CustomEvent('singtel-elastic-search', {
				detail: { type: 'toggle-search-bar' },
				bubbles: true,
				cancelable: true,
				composed: false
			});
			window.dispatchEvent(myEvent);
		}.bind(this));

		this.on('hideSearchBox', function () {
			var self = this;
			setTimeout(function () {
				self.set('viewAll', false);
			}, 150);
		}.bind(this));
	}
});

Ractive.components["ux-select-account"] = Ractive.extend({
	template: LUXComponentTemplates['ux-select-account'],
	isolated: true,
	data: function () {
		return {
			selectedAccount: null,
			ConfigStrings: ConfigStrings,
			RactiveHelpers: RactiveHelpers,
			showServices: false
		};
	},
	oninit : function () {
		this.on('selectAccount', function (event, index) {
			this.fire('onSelectAccount', this.get('accounts.' + index));
		}.bind(this));

		this.on('*.selectAccountMobile', function (component) {
			this.fire('onSelectAccount', this.get('accounts.' + component.get('index')));
		}.bind(this));

		this.on('*.onHideServices', function () {
			this.set('showServices', false);
		}.bind(this));
		this.on('*.onViewServices', function () {
			this.set('showServices', true);
		}.bind(this));
	}
});

Ractive.components["ux-select-pickup-location"] = Ractive.extend({
	template: LUXComponentTemplates['ux-select-pickup-location'],
	computed: {
		guid: function () {
			return this._guid;
		}
	},
	data: function () {
		return {
			distanceLimited: false,
			isFulfillment: false
		};
	},
	onrender: function () {
		var src = '//maps.googleapis.com/maps/api/js?sensor=false';
		var singtelGoogleMapKey = window.singtelGoogleMapKey;
		var def = $.Deferred();
		this.set('throughCheckField', false);
		if (singtelGoogleMapKey) {
			src = src + '&key=' + singtelGoogleMapKey;
		}
		if (this.checkGoogleApiPresent()) {
			this.initializeData(true, src);
			def.resolve();
		} else {
			require([
				src
			], function () {
				this.initializeData(false, src);
				def.resolve();
			}.bind(this));
		}
		if (!(this.get('isCollectNow') || this.get('isEAppointment')) && this.get('isFulfillment')) {
			var components = document.getElementsByClassName('ux-select-pickup-location');
			if (components && components[0]) {
				components[0].classList.add('hide');
				this.parent.set('inProcess', true);
			}
			$.when(def).done(function () {
				if (this.mapstraction === null) {
					this.postalCodeSubmitted(ConfigStrings.singtelPopStation.zipCode);
				}
			}.bind(this));
		}
	},

	checkGoogleApiPresent: function () {
		var scripts = document.getElementsByTagName('script');
		var googleAPI = _.find(scripts, function (script) {
			return (script.src.indexOf('maps.googleapis.com/maps/api/js') !== -1);
		});

		if (typeof googleAPI === 'undefined') {
			return false;
		} else {
			return true;
		}
	},

	initializeData: function (googleApiFlag, src) {
		this.mapstraction = null;
		this.geocoder = {};
		this.storeMarkers = [];
		this.set('selectedOption', null);
		this.set('data.customerPostalCode', '');
		this.set('data.selectedLocation', '');
		this.set('data.pickupLocationsFiltered', []);
		this.set('showLoadMoreButton', false);
		this.set('data.pickupLocationsHidden', true);
		this.set('selectedZone', ConfigStrings.collectNowZoneList[0].value);
		if (!googleApiFlag) {
			var scripts = document.getElementsByTagName('script');
			var googleAPI = _.find(scripts, function (script) {
				return (script.src.indexOf('maps.googleapis.com/maps/api/js') !== -1);
			});

			if (typeof googleAPI === 'undefined') {
				var googleMapsScript = document.createElement('script');
				googleMapsScript.type = 'text/javascript';
				googleMapsScript.src = src;
				var scriptContainer = this.el.getElementsByClassName('maps-scripts-container');
				scriptContainer[0].appendChild(googleMapsScript);
			}
		}
		this.on('*.searchPickupLocations', function () {
			if (!(this.get('isCollectNow') || this.get('isEAppointment')) && this.get('isFulfillment')) {
				var components = document.getElementsByClassName('pickup-location-selector');
				if (components && components[0]) {
					components[0].parentElement.classList.remove('hide');
				}
			}
			var selectedOption = this.parent.get('selectedOption');
			if (selectedOption === 'pop-station') {
				this.fire('retrievePOPStations', this.get('data.customerPostalCode') || this.get('value'));
			} else if (selectedOption === 'singtel-store') {
				this.fire('checkSingtelStoreAvailablity', this.get('pickupData.pickupLocations'));
			} else {
				this.postalCodeSubmitted(this.get('data.customerPostalCode') || this.get('value'));
			}
		}.bind(this));

		this.observe('popStationsList', function (value) {
			var selectedOption = this.parent.get('selectedOption');
			this.set('selectedOption', selectedOption);
			if (typeof value !== 'undefined' && value !== null && value.length > 0 &&
				(selectedOption === 'pop-station' || selectedOption === 'collect-now')) {
				this.postalCodeSubmitted(this.get('data.customerPostalCode') || this.get('value'));
			}
		}.bind(this));

		this.on('selectPopStationOption', function (event, newValue) {
			if (!newValue && event && event.context) {
				newValue = event.context.id || event.context.KioskId;
			}
			if (newValue) {
				var stores = this.get('data.pickupLocationsFiltered');
			
				var selectedStore = null,
					selectedOption = this.get('selectedOption');
				if (selectedOption === 'pop-station' || selectedOption === 'collect-now') {
					selectedStore = _.findWhere(stores, {KioskId: newValue});
				} else {
					selectedStore = _.findWhere(stores, {id: newValue});
				}
				this.set('data.selectedLocation', newValue);
			
				this.fire('pickupLocationSelected', selectedStore);
				this.set('selectedDeliveryAddress', selectedStore);
				this.parent.set('deviceIdAndPlanId.collectionAddress', selectedStore);
				this.parent.set('deviceIdAndPlanId.collectionAddressType', selectedOption);
				this.selectMarker(newValue);
			}
		}.bind(this));

	
		this.validation = new RactiveValidate(this, {
			'customerPostalCode': {
				required: 'The Postal Code cannot be empty',
				digits: 'Please enter a valid Postal Code (digits only)',
				maxlength: {
					param: 6,
					message: 'Please enter a maximum of 6 characters'
				},
				minlength: {
					param: 6,
					message: 'Please enter a minimum of 6 characters'
				}
			}
		});

		this.observe('data.customerPostalCode', function (newValue) {
			if (newValue !== '' && typeof newValue !== 'undefined') {
				this.set('data.onInitPostalCodeDisabled', false);
			}
		}.bind(this));
		this.observe('data.pickupLocationsFiltered', function (newValue) {
			if (newValue && newValue.length === 1) {
				var option = document.getElementsByClassName('pickup-options');
				setTimeout(function () {
					while (option && option.length === 0) {
						option = document.getElementsByClassName('pickup-options');
					}
					option[0].click();
				});
			}
		});
		if (!(this.get('isCollectNow') || this.get('isEAppointment')) && this.get('isFulfillment')) {
			this.observe('noPopStationsFound', function (newValue) {
				if (newValue) {
					var components = document.getElementsByClassName('pickup-location-selector');
					if (components && components[0]) {
						components[0].parentElement.classList.add('hide');
					}
					this.parent.set('isDeliverySelected', false);
				} else if (!this.get('throughCheckField')) {
					var components = document.getElementsByClassName('pickup-location-selector');
					if (components && components[0]) {
						components[0].parentElement.classList.remove('hide');
					}
				} else if (this.get('throughCheckField') && newValue === false) {
					this.set('throughCheckField', false);
				}
			}.bind(this));
		}
		this.set('data.onInitPostalCodeDisabled', true);

		this.on('*.validateZipCode', function () {
			this.validateZipCode();
			this.set('noPopStationsFound', false);
		}.bind(this));
		this.on('*.checkField', function () {
			this.set('noPopStationsFound', false);
			this.set('data.pickupLocationsHidden', true);
			this.set('throughCheckField', true);
		}.bind(this));

		this.on('selectSingtelStoreId', function (event, id) {
			this.fire('onSelectSingtelStoreId', id);
		});

		this.observe('singtelStoreList', function (value) {
			var selectedOption = this.parent.get('selectedOption');
			this.set('selectedOption', selectedOption);
			if (typeof value !== 'undefined' && value !== null && value.length > 0 &&
				selectedOption === 'singtel-store') {
				this.postalCodeSubmitted(this.get('data.customerPostalCode') || this.get('value'));
			}
		}.bind(this));

		this.on('*.onZoneChange', function (event, selectedZone) {
			if (this.get('isCollectNow')) {
				this.set('data.pickupLocationsHidden', true);
				this.fire('getCollectNowStores', this.get('selectedZone'));
			} else {
				this.parent.set('dateTimeShow', false);
				this.filterZoneList(selectedZone.value.toUpperCase());
			}
		});

		this.on('*.loadAll', function () {
			this.set('showLoadMoreButton', false);
			this.set('data.pickupLocationsFiltered',
				this.get('data.pickupLocationsFiltered'));
		});
	},

	validateZipCode: function () {
		this.validation.validate();
	},

	postalCodeSubmitted: function (postalCode) {
		postalCode = postalCode ? postalCode : '';
		this.set('data.selectedLocation', '');
		this.set('data.pickupLocationsFiltered', []);
		if (this.mapstraction === null) {
			this.initializeMap();
		} else {
			this.geocoder = new mxn.Geocoder('googlev3', _.bind(this.geocode_return, this));
		}
		this.geocoder.geocode({locality: 'Singapore ' + postalCode, region: 'SG'});

	},
	initializeMap: function () {
	
		this.set('data.pickupLocationsHidden', false);
		this.mapstraction = new mxn.Mapstraction('mapStractionContainer' + this._guid, 'googlev3');
		this.mapstraction.addControls({
				zoom: 'small',
				overview: true,
				scale: true,
				map_type: false,
				pan: false
			}
		);
		var latlon = new mxn.LatLonPoint(ConfigStrings.singaporeCoordinates.lat,
			ConfigStrings.singaporeCoordinates.lon);
		this.mapstraction.setMapType(mxn.Mapstraction.ROAD);
		this.mapstraction.setCenterAndZoom(latlon, 10);

		this.mapstraction.addEventListener('click', function (eName, eSource, eArgs) {
			console.log('Map clicked : ', eName, eSource, eArgs);
		});
		this.mapstraction.addLargeControls();
		this.mapstraction.setOption('enableScrollWheelZoom', true);

		this.mapstraction.applyOptions();

		this.geocoder = new mxn.Geocoder('googlev3', _.bind(this.geocode_return, this));

	},
	geocode_return: function (geocoded_location) {
	
		this.set('data.customerHomeLocation', geocoded_location);

	
		this.removeAllMarkers();

	
		this.homeMarker = new mxn.Marker(geocoded_location.point);
		this.mapstraction.addMarker(this.homeMarker);
		this.homeMarker.setIcon(this.get('pickupData.homeIconUrl'));

	
		this.displayCenterAndZoomedOnHome();
		var selectedOption = this.parent.get('selectedOption');
		if (selectedOption === 'pop-station') {
			this.filterPickUpPopLocation();
		} else if (selectedOption === 'collect-now') {
			this.filterCollectNowLocation();
		} else {
			this.filterPickUpLocation();
		}
	
		if (!(this.get('isCollectNow') || this.get('isEAppointment')) && this.get('isFulfillment')) {
			var components = document.getElementsByClassName('ux-select-pickup-location');
			var popStations = this.get('popStations');
			setTimeout(function () {
				if (components && components[0]) {
					components[0].classList.remove('hide');
					this.parent.set('inProcess', false);
					if (!(popStations && popStations.length > 0)) {
						components[0].getElementsByClassName('pickup-location-selector')[0]
							.parentNode.classList.add('hide');
					}
				}
			}.bind(this));
		}
	},
	displayCenterAndZoomedOnHome: function (maxDistanceArea) {
		if (typeof maxDistanceArea === 'undefined') {
			maxDistanceArea = this.get('pickupData.maxDistanceArea');
		}
		var mapZoom = 8;
		if (maxDistanceArea <= 3) {
			mapZoom = 14;
		} else if (maxDistanceArea <= 5) {
			mapZoom = 13;
		} else if (maxDistanceArea <= 8) {
			mapZoom = 12;
		} else if (maxDistanceArea <= 13) {
			mapZoom = 11;
		} else if (maxDistanceArea <= 21) {
			mapZoom = 10;
		} else if (maxDistanceArea <= 34) {
			mapZoom = 9;
		}

		this.mapstraction.setCenterAndZoom(this.homeMarker.location, mapZoom);
	},
	addMarker: function (lat, lon, text, id) {
		var marker = new mxn.Marker(new mxn.LatLonPoint(lat, lon));

		this.storeMarkers.push(marker);
		marker.setInfoBubble(text);
		marker.setAttribute('locationId', id);

		this.mapstraction.addMarker(marker);
		marker.click.addHandler(function (eName, eSource, eArgs) {
			console.log('marker clicked : ', eName, eSource, eArgs);
			eSource.setAttribute('class', eSource.getAttribute('class') + 'selected');
			this.markerClicked(eSource.getAttribute('locationId'));
		}, this);
	},
	addPopStationMarker: function (address) {
		this.geocoder = new mxn.Geocoder('googlev3', _.bind(this.locateMarker, this, address));
		this.geocoder.geocode({locality: 'Singapore ' + address.ZipCode, region: 'SG'});
			},
	locateMarker: function (address, result) {
		var marker = new mxn.Marker(result.point),
		selectedOption = this.get('selectedOption'),
		list;
		if (selectedOption === 'pop-station') {
			list = this.get('popStations');
		} else if (selectedOption === 'collect-now') {
			list = this.get('selfCollectNowStoresList');
		}
		var temp = _.findWhere(list, {'PostCode': address.ZipCode});
		if (!temp) {
			temp = _.findWhere(list, {'PostCode': address.PostCode});
		}
		var name = temp.POPStationName;
		this.storeMarkers.push(marker);
		marker.setInfoBubble(name);
		marker.setAttribute('locationId', temp.KioskId);

		this.mapstraction.addMarker(marker);
		marker.click.addHandler(function (eName, eSource, eArgs) {
			console.log('marker clicked : ', eName, eSource, eArgs);
			eSource.setAttribute('class', eSource.getAttribute('class') + 'selected');
			this.markerClicked(eSource.getAttribute('locationId'));
		}, this);
	},
	removeAllMarkers: function () {

		this.mapstraction.removeAllMarkers();
		this.homeMarker = null;
		this.storeMarkers = [];

	},
	markerClicked: function (locationId) {
		this.set('data.selectedLocation', locationId);

	
		var selectedOption = document.querySelector('.location-list input[type="radio"]:checked');
		selectedOption.parentElement.scrollTop = selectedOption.nextElementSibling.offsetTop;

	},
	selectMarker: function (locationId) {
	
		_.forEach(this.storeMarkers, function (marker) {
			if (marker.getAttribute('locationId') === locationId) {
				marker.setIcon(this.get('pickupData.pickupLocationSelectedIconUrl'));
				marker.openBubble();
			} else {
				marker.setIcon(this.get('pickupData.pickupLocationIconUrl'));
				marker.closeBubble();
			}
		}.bind(this));

	},

	filterPickUpLocation: function (maxDistanceArea) {

		var customerHome = this.get('data.customerHomeLocation');
		var selectedOption = this.parent.get('selectedOption');
		var availablePickupLocations =
		(selectedOption === 'singtel-store') ? this.get('singtelStoreList') : this.get('pickupData.pickupLocations');
		if (typeof maxDistanceArea === 'undefined') {
			maxDistanceArea = this.get('pickupData.maxDistanceArea');
		}
		var showLoadMore = (availablePickupLocations.length > 5 ? true : false);
		this.set('showLoadMoreButton', showLoadMore);
		var locationFiltered = [];
		for (var i = 0; i < availablePickupLocations.length; i++) {

			var d = RactiveHelpers.latLongDist(customerHome.point, availablePickupLocations[i]);
			availablePickupLocations[i].distance = Math.floor(d * 1000) / 1000;
			if (d < maxDistanceArea) {
				locationFiltered.push((availablePickupLocations[i]));
				this.addMarker(availablePickupLocations[i].lat,
					availablePickupLocations[i].lon,
					availablePickupLocations[i].name,
					availablePickupLocations[i].id
				);
			}
		}
		locationFiltered = _.sortBy(locationFiltered, 'distance');
		this.set('data.pickupLocationsFiltered', locationFiltered);
		this.set('pickupLocationsFiltered', locationFiltered);
		if (locationFiltered.length === 0) {
			this.set('data.pickupLocationsHidden', true);
			this.filterPickUpLocation(2 * maxDistanceArea);
		} else {
			this.set('data.pickupLocationsHidden', false);
			this.displayCenterAndZoomedOnHome(maxDistanceArea);
		}

		this.selectMarker(this.get('data.selectedLocation'));

	},
	addComcenterPopStation: function (locationFiltered) {
		if (this.get('data.customerPostalCode') &&
			this.get('data.customerPostalCode')[0] === '2' && !(locationFiltered[0] &&
				locationFiltered[0].ZipCode === ConfigStrings.singtelPopStation.zipCode)) {
			var idx;
			var popAtCom = _.find(locationFiltered, function (popStation, i) {
				if (popStation.ZipCode === ConfigStrings.singtelPopStation.zipCode) {
					idx = i;
					return true;
				} else {
					return false;
				}
			});
			if (popAtCom) {
				popAtCom.Distance = undefined;
				locationFiltered.splice(idx, 1);
			} else {
				popAtCom = {
					BuildingName: ConfigStrings.singtelPopStation.buildingName,
					HouseBlockNumber: ConfigStrings.singtelPopStation.blockOrHouseNum,
					KioskId: ConfigStrings.singtelPopStation.KioskId,
					POPStationName: ConfigStrings.singtelPopStation.name,
					PostCode: ConfigStrings.singtelPopStation.postcode,
					StreetName: ConfigStrings.singtelPopStation.streetName,
					UnitNumber: ConfigStrings.singtelPopStation.unitNumber,
					ZipCode: ConfigStrings.singtelPopStation.zipCode
				};
			}
			locationFiltered.unshift(popAtCom);
		}
	},
	filterPickUpPopLocation: function (maxDistanceArea) {
		var self = this,
			selectedOption = self.get('selectedOption'),
			availablePickupLocations;
	
		if (selectedOption === 'pop-station') {
			availablePickupLocations = this.get('popStations');
		} else if (selectedOption === 'singtel-store' || selectedOption === 'collect-now') {
			var availablePickupLocations =
				(selectedOption === 'singtel-store') ? this.get('singtelStores') : this.get('selfCollectNowStoresList');
			var showLoadMore = (availablePickupLocations.length > 5 ? true : false);
			this.set('showLoadMoreButton', showLoadMore);
		}
		if (typeof maxDistanceArea === 'undefined') {
			maxDistanceArea = this.get('pickupData.maxDistanceArea');
		}

		var locationFiltered = [];
		_.each(availablePickupLocations, function (value) {
			var d = Math.floor(value.Distance * 1000) / 1000;
			if (d < maxDistanceArea) {
				locationFiltered.push(value);
				self.addPopStationMarker(value);
			}
		});
		locationFiltered = _.sortBy(locationFiltered, 'Distance');
		this.addComcenterPopStation(locationFiltered);
		this.set('data.pickupLocationsFiltered', locationFiltered);

		if (locationFiltered.length === 0 && (this.get('distanceLimited') &&
			maxDistanceArea < ConfigStrings.distanceLimit || !this.get('distanceLimited'))) {
			this.set('data.pickupLocationsHidden', true);
			this.filterPickUpPopLocation(2 * maxDistanceArea);
		} else {
			this.set('data.pickupLocationsHidden', false);
			this.displayCenterAndZoomedOnHome(maxDistanceArea);
		}

		this.selectMarker(this.get('data.selectedLocation'));

	},
	filterCollectNowLocation: function () {
		var self = this,
			availablePickupLocations = this.get('selfCollectNowStoresList'),
			hasDistance = _.find(availablePickupLocations, function (item) {
				return item.Distance;
			});
		if (hasDistance) {
			self.filterPickUpPopLocation();
		} else {
			_.each(availablePickupLocations, function (value) {
				self.addPopStationMarker(value);
			});
			var showLoadMore = (availablePickupLocations.length > 5 ? true : false);
			this.set('showLoadMoreButton', showLoadMore);
			this.set('data.pickupLocationsFiltered', availablePickupLocations);
			var options = this.findAll('.pickup-options');
			if (availablePickupLocations && availablePickupLocations.length === 1) {
				_.each(options, function (item) {
					item.click();
				});
			}
			this.set('data.pickupLocationsHidden', false);
			this.displayCenterAndZoomedOnHome(self.get('pickupData.maxDistanceArea'));
			this.selectMarker(self.get('data.selectedLocation'));
		}
	},
	filterZoneList: function (selectedZone) {
		var allStoresList = _.clone(this.get('pickupLocationsFiltered'));
		allStoresList = _.filter(allStoresList, function (obj) {
			return obj.zone.toUpperCase() === selectedZone;
		});
		this.set('data.pickupLocationsFiltered', allStoresList);
		if (allStoresList.length === 0) {
			this.fire('onZoneNotAvailable');
		}
	}
});

Ractive.components["ux-select"] = Ractive.extend({
	template: LUXComponentTemplates['ux-select'],
	isolated: true,
	onrender: function () {

		this.set('selectedTitle', '');
		this.set('selectedClass', '');
		this.observe('selected_value', function (newValue) {

			if (typeof newValue !== 'undefined' && this.get('options')) {
				var selectedOption = _.find(this.get('options'), function (option) {
					return (typeof option !== 'undefined') ? option.value === newValue : false;
				});
			
				if (newValue === '') {
					this.set('selectedClass', 'placeholder');
				} else {
					this.set('selectedClass', '');
				}
				if (selectedOption && selectedOption.title) {
					this.set('selectedTitle', selectedOption.title);
				} else if (selectedOption && selectedOption.text) {
					this.set('selectedTitle', selectedOption.text);
				} else {
					this.set('selectedTitle', newValue);
				}
			} else {
			
				var optionsEl = this.findAll('option');
				var selectedOptionEl = _.find(optionsEl, function (el) {
					return el.value === newValue;
				});
				if (selectedOptionEl) {
					this.set('selectedTitle', selectedOptionEl.innerHTML);
				} else {
					this.set('selectedTitle', newValue || '');
				}
			}

		}.bind(this));
		this.on('showTooltip', function (event) {
			if (event.original.currentTarget.nextElementSibling.style.display !== 'block') {
				_.each(document.getElementsByClassName('tooltip'), function (v) {
					v.style.display = 'none';
				});
				event.original.currentTarget.nextElementSibling.style.display = 'block';
			} else {
				event.original.currentTarget.nextElementSibling.style.display = 'none';
			}
			return false;
		});
	},
	onconfig: function () {
		this.on('blurHandler', function () {
			var fireEvent = this.get('onblurEvent');
			if (fireEvent) {
				this.fire(fireEvent, this);
				this.toggle('focusStatus');
				return false;
			}
		});
		this.on('onOptionClick', function (event) {
			debugger;
			console.log('Option clickd');
		});
		this.on('onChange', function (event) {
			var fireEvent = this.get('onChangeEvent');
			if (fireEvent) {
				var selectedIndex = event.original.target.selectedIndex;
				var selectedOptionData = {};
				if (this.get('defaultOption')) {
					selectedIndex = selectedIndex - 1;
					if (selectedIndex > -1) {
						selectedOptionData = this.get('options.' + selectedIndex);
					}
				} else {
					selectedOptionData = this.get('options.' + selectedIndex);
				}
				var flag = this.get('onChangeEventContext');
				var name = this.get('name');
				if (flag) {
					name = this;
				}
				if (!name) {
					name = this.get('selected_value');
				}
				this.fire(fireEvent, name, selectedOptionData, selectedIndex);
				return false;
			}
		});
		this.on('focusHandler', function () {
			this.toggle('focusStatus');
		});
	}
});

Ractive.components["ux-separator"] = Ractive.extend({
	template: LUXComponentTemplates['ux-separator']
});

Ractive.components["ux-service-list"] = Ractive.extend({
	template: LUXComponentTemplates['ux-service-list'],
	data : {
		'RactiveHelpers' : RactiveHelpers,
		'ConfigStrings': ConfigStrings
	},
	isolated: true,
	oninit : function () {
		var self = this;
		self.on('onCommonPlanClick', function (event, groupType, idx, isApplicableForTablet) {
			self.onPlanClick(event, groupType, idx, isApplicableForTablet);
		});
		self.set('getSelectedState', function (idx) {
			return self.get('selectedPlanState.' + idx);
		});
		self.on('ux-radio-button.ippDurationSelected', function () {
			self.onIppDurationChange();
		});
		self.on('*.selectService', function (event) {
			self.parent.fire('selectService', {
				name: 'selectService',
				id: event.component.instance.get('index')
			});
			return false;
		});
	},
	onPlanClick : function (event, groupType, idx, isApplicableForTablet) {
		var eventName = 'onSelectPlan' + '.' + 'planSelected';
	
		if (groupType === 'mobileBroadbandPlan') {
			this.fire('selectedGroupType', groupType, isApplicableForTablet, this.get('mode'));
		} else {
			this.fire('selectedGroupType', groupType, isApplicableForTablet);
		}
		this.fire(eventName, event.context);
		this.set('planSelected', 'selected');
		this.setSelectedState('selectedPlanState', idx);
	},
	setSelectedState: function (state, property) {
		var selectedStateStr = state + '.' + property;
		var selectedStateObj = this.get(state);
		if (typeof selectedStateObj !== undefined) {
			_.each(selectedStateObj, function (element, key) {
				selectedStateObj[key] = '';
			});
		}
		this.set(selectedStateStr, 'selected');
		this.update();
	}

});

Ractive.components["ux-session-out-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-session-out-singtel']
});

Ractive.components["ux-shopping-cart-singtel-information"] = Ractive.extend({
	template: LUXComponentTemplates['ux-shopping-cart-singtel-information'],
	isolated : true,
	data : function () {
		return {
			ConfigStrings : ConfigStrings
		};
	},
	onrender: function () {
		this.on('ux-anchor.getMissingItem', function (event, selected) {
			var actualData = event.get('actualData');
			this.fire('findMissingItem', actualData);
		});
		this.on('ux-anchor.getOutOfStockItem', function (event, selected) {
			var actualData = event.get('actualData');
			this.fire('buyOutOfStockItem', actualData);
		});
	}
});

Ractive.components["ux-sim-only-plan"] = Ractive.extend({
	template: LUXComponentTemplates['ux-sim-only-plan'],
	data: function () {
		return {
			'RactiveHelpers': RactiveHelpers
		};
	},
	isolated: true,
	oninit : function () {
		var self = this;
		self.on('onCommonPlanClick', function (event, groupType, idx) {
			self.onPlanClick(event, groupType, idx);
		});
		self.set('getSelectedState', function (idx) {
			return self.get('selectedPlanState.' + idx);
		});
		self.resetAllPlans();
		self.on('selectDataAddon', function (e, planIndex) {
			var selectedPlan = planIndex;
			var selectedPlanIndex = self.get('selectedPlanIndex');
			var dataAddon = self.get('addons.data.addonDetails');
			if (selectedPlan !== selectedPlanIndex) {
				self.resetAllPlans();
			}
			_.each(dataAddon, function (v) {
				if (v.addonId === e.context.addonId) {
					if (v.selected === true) {
						v.selected = false;
						self.resetAllDetails('selectedDataObject');
					} else {
						v.selected = true;
						self.set('selectedDataObject', e.context);
					}
				} else {
					v.selected = false;
				}
			});
			self.set('addons.data.addonDetails', dataAddon);
			self.set('selectedPlanIndex', selectedPlan);
			self.updateTotalCharge(planIndex);
			self.updateTotalData(planIndex);
		});

		self.on('selectTalktimeAddon', function (e, planIndex) {
			var selectedPlan = planIndex;
			var selectedPlanIndex = self.get('selectedPlanIndex');
			var talktimeAddon = self.get('addons.talktime.addonDetails');
			if (selectedPlan !== selectedPlanIndex) {
				self.resetAllPlans();
			}
			_.each(talktimeAddon, function (v) {
				if (v.addonId === e.context.addonId) {
					if (v.selected === true) {
						v.selected = false;
						self.resetAllDetails('selectedTalktimeObject');
					} else {
						v.selected = true;
						self.set('selectedTalktimeObject', e.context);
					}
				} else {
					v.selected = false;
				}
			});
			self.set('addons.talktime.addonDetails', talktimeAddon);
			self.set('selectedPlanIndex', selectedPlan);
			self.updateTotalCharge(planIndex);
		});

		self.on('selectSmsAddon', function (e, planIndex) {
			var selectedPlan = planIndex;
			var selectedPlanIndex = self.get('selectedPlanIndex');
			var smsAddon = self.get('addons.sms.addonDetails');
			if (selectedPlan !== selectedPlanIndex) {
				self.resetAllPlans();
			}
			_.each(smsAddon, function (v) {
				if (v.addonId === e.context.addonId) {
					if (v.selected === true) {
						v.selected = false;
						self.resetAllDetails('selectedSmsObject');
					} else {
						v.selected = true;
						self.set('selectedSmsObject', e.context);
					}
				} else {
					v.selected = false;
				}
			});
			self.set('addons.sms.addonDetails', smsAddon);
			self.set('selectedPlanIndex', selectedPlan);
			self.updateTotalCharge(planIndex);
		});

		self.on('ux-button.selectSimOnlyPlan', function (e, planIndex) {
			var planIndex = e.get('index');
			var eventName = 'onSelectPlan' + '.' + 'planSelected';
			var selectedTalktime = self.get('selectedTalktimeObject');
			var selectedSms = self.get('selectedSmsObject');
			var selectedData = self.get('selectedDataObject');
			var addonsIds = [],
			isApplicableForTablet = e.get('isApplicableForTablet');
			if (selectedData && selectedData.addonId && selectedData.addonId !== '') {
				addonsIds.push(selectedData.addonId);
			}
			if (selectedSms && selectedSms.addonId && selectedSms.addonId !== '') {
				addonsIds.push(selectedSms.addonId);
			}
			if (selectedTalktime && selectedTalktime.addonId && selectedTalktime.addonId !== '') {
				addonsIds.push(selectedTalktime.addonId);
			}

			var plan = self.get('plans')[planIndex];
			var totalMonthlyCharges = self.get('totalMonthlyCharges');
			if (typeof (totalMonthlyCharges) === 'undefined') {
				totalMonthlyCharges = plan.monthlyCharges;
			}
			var simOnlyPlan = {
				planName: self.get('groupName'),
				totalPrice:  totalMonthlyCharges,
				talktime: selectedTalktime,
				sms: selectedSms,
				data: selectedData,
				addonsIds: addonsIds,
				planId: plan.planId,
				planRelId: plan.planRelId,
				monthlyCharges: plan.monthlyCharges,
				basePriceSchemaId: plan.basePriceSchemaId,
				cisDiscountOffers: plan.cisDiscountOffers,
				staffDiscountOffers: plan.staffDiscountOffers,
				publicDiscountOffers: plan.publicDiscountOffers

			};
			this.fire('selectedGroupType', this.get('groupType'), isApplicableForTablet);
		
			this.fire(eventName, simOnlyPlan);
		});

		self.on('ux-anchor.resetSelectSimOnlyPlan', function (e) {
			self.resetAllPlans();

		});

		self.on('ux-anchor.showConfiguration', function (e, planIndex, isApplicableForTablet) {
			var planIndex = planIndex;
			var plans =  this.get('plans');
			if (plans[planIndex].showConfigurePanel === true) {
				plans[planIndex].showConfigurePanel = false;
			} else {
				plans[planIndex].showConfigurePanel = true;
			}
			this.set('plans', plans);
		});

	},

	getAddonsDetails: function (value, addons) {
		var addon = _.where(addons, {addonId: value});
		return addon;
	},
	resetAllDetails: function (object) {
		this.set(object, {
			'price': '',
			'quantity': '',
			'unit': '',
			'addonsId': ''
		});
	},
	updateTotalCharge: function (index) {
		var self = this;
		if (typeof (index) !== 'undefined') {
			var plan = self.get('plans')[index];
			var totalCharge = parseFloat((plan.monthlyCharges)) +
				(parseFloat(self.get('selectedDataObject.price')) || 0) +
				(parseFloat(self.get('selectedSmsObject.price')) || 0) +
				(parseFloat(self.get('selectedTalktimeObject.price')) || 0);
			self.set('totalMonthlyCharges', totalCharge);
		}
	},

	updateTotalData: function (index) {
		var self = this;
		var totalData;
		if (typeof (index) !== 'undefined') {
			var plans = self.get('plans')[index];
			if (self.get('selectedDataObject.quantity').toLowerCase() === 'unlimited') {
				totalData = 'Unlimited';
			} else {
				totalData = (parseInt(plans.data.quantity) + parseInt(self.get('selectedDataObject.quantity'))) +
					plans.data.unit;
			}
			self.set('totalData', totalData);
		}

	},
	resetAllPlans: function () {
		var self = this;
		var dataAddon = this.get('addons.data.addonDetails');
		_.each(dataAddon, function (v) {
			if (v.selected === true) {
				v.selected = false;
				self.resetAllDetails('selectedDataObject');
			}
		});

		var talktimeAddon = this.get('addons.talktime.addonDetails');
		_.each(talktimeAddon, function (v) {
			if (v.selected === true) {
				v.selected = false;
				self.resetAllDetails('selectedTalktimeObject');
			}
		});

		var smsAddon = self.get('addons.sms.addonDetails');
		_.each(smsAddon, function (v) {
			if (v.selected === true) {
				v.selected = false;
				self.resetAllDetails('selectedSmsObject');
			}
		});
		self.set('addons.data.addonDetails', dataAddon);
		self.set('addons.talktime.addonDetails', talktimeAddon);
		self.set('addons.sms.addonDetails', smsAddon);
		this.set('selectedTalktimeObject', {
			'price': '',
			'quantity': '',
			'unit': '',
			'addonId': ''
		});
		this.set('selectedDataObject', {
			'price': '',
			'quantity': '',
			'unit': '',
			'addonId': ''
		});
		this.set('selectedSmsObject', {
			'price': '',
			'quantity': '',
			'unit': '',
			'addonId': ''
		});
		self.updateTotalData();
		self.updateTotalCharge();
	}
});

Ractive.components["ux-single-video"] = Ractive.extend({
	template: LUXComponentTemplates['ux-single-video'],
	onrender: function () {

		this.set('videoURL',
			ConfigStrings.videoProviderHost[this.get('video.host')] +
			this.get('video.videoRef') +
			'?autoplay=1');

		this.on('displayVideo', function () {
			this.toggleModal('singleFullScreenVideo', true);
		}.bind(this));
	},
	toggleModal: function (modalId, state) {
		var modals = this.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];
		modal.set('displayState', state);
	}
});

Ractive.components["ux-singpost-tracker"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singpost-tracker'],
	isolated: true,
	data: function () {
		return {
			moment: moment,
			RactiveHelpers: RactiveHelpers
		};
	},

	oninit: function () {
		var self = this;
		self.set('searching', true);
		self.set('result', false);
		self.set('inProgress', false);
		self.set('trackingNumber', '');
		self.set('trackingNumberValid', false);
		self.set('genericErrorMessage', false);
		self.set('errorMsg', '');
	},

	onrender: function () {
		var self = this;

		var sid = RactiveHelpers.getParameterByName('trackingNumber');
		if (sid !== null) {
			self.set('trackingNumber', sid);
			if (!self.isValidTrackingNum()) {
				self.set('trackingNumberValid', false);
			} else {
				self.set('trackingNumberValid', true);
			}
		}

		self.on('*.onTrackingNumberChange', function (event) {
			if (!self.isValidTrackingNum()) {
				self.set('trackingNumberValid', false);
			} else {
				self.set('trackingNumberValid', true);
			}
		});

		self.on('*.requestTracking', function (event) {
			var trackingNumber = self.get('trackingNumber');
			var requestOrderTrackingURL = '';
			self.set('inProgress', true);

			if (trackingNumber.toUpperCase().endsWith('N')) {
				self.set('errorMsg', self.get('ninjaErrorMsg'));
				self.set('genericErrorMessage', true);
				self.set('inProgress', false);
			} else if (trackingNumber.toUpperCase().endsWith('D')) {
				self.set('errorMsg', self.get('deltaErrorMsg'));
				self.set('genericErrorMessage', true);
				self.set('inProgress', false);
			} else {

				requestOrderTrackingURL = ConfigStrings.requestOrderTrackingURL +
				'?trackingNumber=' + trackingNumber;


				RactiveHelpers.doAjaxJSONCall('GET', requestOrderTrackingURL, function (response) {

					if (response && response.trackingNumberFound) {
						var rows = self.getOrderTrackingDetails(response.deliveryStatus);

						var trackingData = {
							rows: rows
						};

						console.log('trackingData = ' + JSON.stringify(trackingData));
						self.set('trackingData', trackingData);

						self.set('searching', false);
						self.set('result', true);
						self.set('genericErrorMessage', false);
						self.set('inProgress', false);
					} else {
						self.set('errorMsg', self.get('invalidErrorMsg'));
						self.set('genericErrorMessage', true);
						self.set('searching', true);
						self.set('result', false);
						self.set('inProgress', false);
					}

				}.bind(self));
			}
		});

		self.on('*.requestAnotherTracking', function (event) {
			self.set('searching', true);
			self.set('result', false);
			self.set('trackingNumber', '');
			self.set('trackingNumberValid', false);
			self.set('inProgress', false);
		});
	},

	isValidTrackingNum: function () {
		var self = this;
		var trackingNumber = self.get('trackingNumber');
		console.log(trackingNumber);
		self.set('genericErrorMessage', '');

		if (trackingNumber === '' || trackingNumber === 'eg. FS/12/34/56789') {
			return false;
		} else {
			return true;
		}
	},

	getOrderTrackingDetails: function (deliveryStatus) {
		var col1;
		var col2;
		var col3;
		var row;
		var rows = [];

		for (var i = 0; i < deliveryStatus.length; i++) {

			var date = deliveryStatus[i].date.substring(0, 10);
			date = date.replace(/-/g, '/');
			var time = deliveryStatus[i].date.substring(11);

			col1 = {
				type: 'text',
				value: date
			};

			col2 = {
				type: 'text',
				value: time
			};

			col3 = {
				type: 'text',
				value: deliveryStatus[i].description
			};

			row = {
				col1: col1,
				col2: col2,
				col3: col3
			};

			rows.push(row);
		}
		return rows;
	}
});

Ractive.components["ux-singtel-address"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-address'],
	isolated: true,
	data: function () {
		return {
			useOriginalCase: false,
			isMaskingReqd: false,
			ConfigStrings: ConfigStrings,
			getBlockOrHouseNo: function (value, addressType) {
				var newValue = value;
				if (this.get('isMaskingReqd') && value) {
					switch (addressType) {
						case 'crmUpdatedAddressFormat':
							newValue = RactiveHelpers.maskBlockHouseNo(value);
							break;
					}
				}
				return newValue;
			},
			getPostalCode: function (value, addressType) {
				var newValue = value;
				if (this.get('isMaskingReqd') && value) {
					switch (addressType) {
						case 'crmUpdatedAddressFormat':
							newValue = RactiveHelpers.maskPostalCode(value);
							break;
					}
				}
				return newValue;
			}
		};
	}
});

Ractive.components["ux-singtel-breadcrumb-step"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-breadcrumb-step'],
	data: function () {
		return {
			visible: false
		};
	},
	oninit: function () {
		Ractive.defaults.on('ux-singtel-breadcrumb-step.stepchange', this.onStepChange.bind(this));
	},
	oncomplete: function () {
		Ractive.defaults.fire('process-explicit-hash');
	},
	onStepChange: function (uxBreadcrumbSingtelComp, stepConfig, routerConfig) {
		var idArray = this.get('id').split('||');
		_.find(idArray, function (id) {
			if (stepConfig.target === id) {
				this.set('visible', true);
				return true;
			} else {
				this.set('visible', false);
				return false;
			}
		}.bind(this));
	}
});

Ractive.components["ux-singtel-breadcrumbs"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-breadcrumbs'],
	isolated: true,
	data: function () {
		return {
			defaultRoute: null,
			currentStepData: null,
			currentStepNo: 0,
			maxSteps: 0,
			skipPrevStepCheck: false
		};
	},
	oninit: function () {
		this.observe('bcConfig.length defaultRoute', function () {
			var bcConfig = this.get('bcConfig');
			if (bcConfig && bcConfig.length) {
				this.set('maxSteps', bcConfig.length);
				_.each(bcConfig, function (bcStep) {
					if (!router.api.exists(bcStep.hash)) {
						router.api.add(bcStep.hash, this.onRouteChange.bind(this, bcStep));
					}
				}.bind(this));

				var hash = window.location.hash;
				if (!hash && this.get('defaultRoute')) {
					router.updateHash({
						target: this.get('defaultRoute')
					});
				}
				Ractive.defaults.fire('process-explicit-hash');
			}
		}.bind(this));
	},
	oncomplete: function () {
		Ractive.defaults.on('ux-singtel-breadcrumbs.goto-next-step', this.gotoNextStep.bind(this));
		Ractive.defaults.on('ux-singtel-breadcrumbs.goto-prev-step', this.gotoPreviousStep.bind(this));
		Ractive.defaults.on('ux-singtel-breadcrumbs.goto-specific-step', this.gotoStep.bind(this));
		Ractive.defaults.on('ux-singtel-breadcrumbs.goto-specific-step-byid', this.gotoStepById.bind(this));
		this.on('next', this.gotoNextStep.bind(this));
		this.on('prev', this.gotoPreviousStep.bind(this));
		Ractive.defaults.fire('process-explicit-hash');
		this.gotoStep(0);
	},
	gotoPreviousStep: function () {
		return this.gotoStep(this.get('currentStepNo') - 1);
	},
	gotoNextStep: function () {
		return this.gotoStep(this.get('currentStepNo') + 1);
	},
	gotoStep: function (stepNumber) {
		var stepData = this.get('bcConfig.' + stepNumber);
		if (stepData) {
			router.updateHash({
				target: stepData.hash
			});
		} else {
			throw('Step does not exists');
		}
	},
	gotoStepById: function (stepId) {
		var stepNo = 0;
		var bcConfig = this.get('bcConfig');
		var step = _.find(bcConfig, function (config, index) {
			if (config.target === stepId) {
				stepNo = index;
				return config;
			}
		}.bind(this));
		console.log(step);
		return this.gotoStep(stepNo);
	},
	onRouteChange: function (bcStep, routerConfig) {
		this.set('currentStep', bcStep);
		var bcConfig = this.get('bcConfig');
		var currentStepNo = this.get('currentStepNo');
		_.each(bcConfig, function (config, index) {
			if (config.target === bcStep.target) {
				config.status = 'active';
				config.visited = true;
				this.set('currentStepNo', index);
				currentStepNo = index;
			} else {
				if (config.visited && config.rank <= bcStep.rank) {
					config.status = 'completed';
				} else {
					config.status = 'pending';
				}
			}
		}.bind(this));
		this.set('bcConfig', bcConfig);
		Ractive.defaults.fire('ux-singtel-breadcrumb-step.stepchange', this, bcStep, routerConfig);
		this.fire('stepchange', this, bcStep, routerConfig);
		if (!this.get('skipPrevStepCheck')) {
			this._checkPreviousStep();
		}
	},
	_checkPreviousStep: function () {
		var currentStepNo = this.get('currentStepNo');
		var prevStep = this.get('bcConfig.' + (currentStepNo - 1));
		if (prevStep && prevStep.status === 'pending') {
			this.gotoPreviousStep();
		}
	}
});

Ractive.components["ux-singtel-circle-bundle-price"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-circle-bundle-price'],
	onconfig: function () {
		this.set('RactiveHelpers', RactiveHelpers);
	}
});

Ractive.components["ux-singtel-circle-select-services"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-circle-select-services'],
	data: function () {
		return {
			selectedTvPlan: '',
			selectedHomeLinePlan: '',
			selectedFiberPlan: '',
			isDisabled: false
		};
	},
	onrender: function () {
		var self = this;
		self.observe('singtelCircle.validationFailed', function (value) {
			if (value && value.errorCode) {
				var allErrorCodes = self.get('widgetConfig.validationErrorCodes');
				var errorMessage = allErrorCodes[value.errorCode];
				if (errorMessage) {
					value.errorMessage = errorMessage;
				}
				if (value.serviceId && value.serviceId.indexOf(',') !== -1) {
					value.serviceId = value.serviceId.split(',');
				}
				self.checkMobileTextFields(value);
				self.set('validationError', value);
				setTimeout(function () {
					self.scrollToFirstInlineError();
				}.bind(self));
			}
		});
		self.on('*.onChangeRadio', function () {
			self.makeButtonEnable();
		});
		self.on('*.changeMobileSelect', function (value) {
			if (this.get('primaryKeyNominationNotSelected')) {
				this.set('primaryKeyNominationNotSelected', false);
			}
			if (value !== self.get('widgetConfig.addEditCircle.mobileSection.defaultSelectedOption')) {
				self.set('showKeylineInfoMsg', true);
			} else {
				self.set('showKeylineInfoMsg', false);
			}
			self.makeButtonEnable();
		});
		self.on('ux-anchor.gotoEligibilityCriteria', function () {
			var url = self.get('widgetConfig.links.eligibilityCriteriaUrl');
			if (url) {
				window.open(url);
			}
		});
		self.on('ux-anchor.addMobileLines', function () {
			self.set('showInputBoxes', true);
			var textFields = self.get('showTextFields');
			var editMode = self.get('isEditMode');
			if (editMode && textFields && textFields.length > 0) {
				self.set('showTextFields', (self.getTextFields()));
			} else if ((editMode && textFields && textFields.length === 0) || !editMode) {
				self.set('showTextFields', self.getTextFields());
			}
			if (self.get('showTextFields').length ===  self.get('widgetConfig.addEditCircle.showTextFields')) {
				self.set('showAddMoreLines', false);
			}
		});
		self.on('ux-input-box.validateMobile', function (event) {
			var textValue = event.get('textFieldObj.simNumber'),
				isValid = self.checkPhone(textValue);
			self.onValidMobileNumber(event, isValid.valid, this.get('phoneVal.phoneValErrorMsg'));
		});
		self.on('*.clearNumberField clearNumberField', function (event) {
			var nonKeyLineNumbers = this.get('showTextFields');
			if (event.context.id) {
				_.each(nonKeyLineNumbers, function (obj) {
					if (obj.id === event.context.id) {
						self.makeButtonEnable();
						obj.simNumber = '';
						obj.validationSuccess = false;
						obj.validationFailed = false;
						obj.msgValidity = { valid: null, status: 'notValid' };
					}
				});
				self.set('showTextFields', nonKeyLineNumbers);
			}
		});
		self.on('*.proceedNomination', function () {
			self.parent.set('inProcess', true);
			var flag = self.validateToProceedNominations();
			if (flag) {
				var payloadData = self.createPayloadSelectedServices();
				self.fire('getValidatedCircleNominations', payloadData);
			} else {
				self.parent.set('inProcess', false);
				setTimeout(function () {
					self.scrollToFirstInlineError();
				}.bind(self));
			}
		});
		self.on('*.cancelNomination', function () {
			self.fire('cancelCreateEditCircle');
		});
		self.on('*.startSettingValues', function () {
			self.startSettingValuesForAddEditFlow();
			self.scrollToTop();
		});
	},
	startSettingValuesForAddEditFlow: function () {
		var self = this,
			singtelCircle = self.get('singtelCircle');
		if (singtelCircle && singtelCircle.availableServices && singtelCircle.availableServices.length > 0 &&
			singtelCircle.valuesSet) {
			self.set({
				showAddMoreLines: true,
				validationError: {},
				showTextFields: [],
				isDisabled: false
			});
			if (self.get('isEditMode')) {
				self.setPreSelectedRadioValuesEditCircle();
				self.set({
					showInputBoxes: true,
					showAddMoreLines: true
				});
			} else {
				self.setPreSelectedRadioValuesAddCircle();
			}
			self.set('singtelCircle.valuesSet', false);
		}
	},
	createPayloadSelectedServices: function () {
		var self = this,
			allSelectedNominations = self.parent.get('selectedCircleServices'),
			selectedServices = [],
			data = {};
		selectedServices.push(allSelectedNominations.fiber);
		selectedServices.push(allSelectedNominations.tv);
		selectedServices.push(allSelectedNominations.homeLine);
		selectedServices.push(allSelectedNominations.primaryKeyLine);
		selectedServices = selectedServices.concat(allSelectedNominations.nonKeyLines);
		data.implServiceDetails = selectedServices;
		if (self.get('singtelCircle.groupId')) {
			data.groupId = self.get('singtelCircle.groupId');
		}
		if (self.get('isEditMode') && !self.get('singtelCircle.isCircleOne')) {
			data.flowName = 'EDIT';
		} else {
			data.flowName = 'CREATE';
		}
		data.mode = 'VCN';
		if (data.flowName === 'EDIT') {
			data.changedServiceDetails = self.getUpdatedServiceDetails();
		}
		return data;
	},
	getTextFields: function (length) {
		var self = this,
			numberOfTextFields = self.get('showTextFields'),
			numberTexts = self.get('widgetConfig.addEditCircle.showTextFields');
		if (!length) {
			length = 0;
		}
		if ((numberOfTextFields.length < 7) && (length < 8)) {
			numberTexts = 7;
		}
		if (numberTexts) {
			for (var i = numberOfTextFields.length; i < (parseInt(numberTexts) - length); i++) {
				var numberId = length ? 'mobile_' + (i + length) : 'mobile_' + i;
				numberOfTextFields.push({
					id: numberId,
					simNumber: '',
					validationFailed: false,
					validationSuccess: false
				});
			}
		}
		return numberOfTextFields;
	},
	checkMobileTextFields: function (errorDetails) {
		var self = this,
			allTextFields = self.get('showTextFields');
		if (errorDetails.serviceId) {
			_.each(allTextFields, function (textField) {
				if (textField.simNumber && (errorDetails.serviceId).includes(String(textField.simNumber))) {
					textField.validationFailed = true;
					textField.msgValidity = {
						message: errorDetails.errorMessage,
						passed: false
					};
				}
			});
		}
		self.set('showTextFields', allTextFields);
	},
	setPreSelectedRadioValuesAddCircle: function () {
		var self = this,
			presentMobiles = [],
			singtelCircle = self.get('singtelCircle');
		var fiberPlan = self.findFirstLobService(singtelCircle.availableServices, 'BB', 'FBB'),
			homeLine = self.findFirstLobService(singtelCircle.availableServices, 'FV'),
			tvPlan = self.findFirstLobService(singtelCircle.availableServices, 'TV');
		if (fiberPlan && homeLine && tvPlan) {
			self.set({
				selectedFiberPlan: fiberPlan.serviceId,
				selectedTvPlan: tvPlan.serviceId,
				selectedHomeLinePlan: homeLine.serviceId
			});
		}
		if (singtelCircle && singtelCircle.availableKeylineServices) {
			_.each(singtelCircle.availableKeylineServices, function (service) {
				presentMobiles.push({
					title: 'Mobile ' + service.serviceId,
					value: service.serviceId
				});
			});
		}
		self.set('presentMobiles', presentMobiles);
		if (presentMobiles && presentMobiles.length === 1) {
			self.set('selected_value', presentMobiles[0].value);
		}
	},
	setPreSelectedRadioValuesEditCircle: function () {
		var self = this,
			singtelCircle = self.get('singtelCircle'),
			presentMobiles = [],
			fiberPlan = self.findFirstLobService(singtelCircle.circleServices, 'BB', 'FBB'),
			homeLine = self.findFirstLobService(singtelCircle.circleServices, 'FV'),
			tvPlan = self.findFirstLobService(singtelCircle.circleServices, 'TV'),
			primaryKeyLineService = _.find(singtelCircle.circleServices, function (service) {
				return (service.lob === 'MOB' || service.lob === 'WS') && service.keyline;
			});
		if (!fiberPlan) {
			fiberPlan = self.findFirstLobService(singtelCircle.availableServices, 'BB', 'FBB');
		}
		if (!tvPlan) {
			tvPlan = self.findFirstLobService(singtelCircle.availableServices, 'TV');
		}
		if (!homeLine) {
			homeLine = self.findFirstLobService(singtelCircle.availableServices, 'FV');
		}
		if (!singtelCircle.isCircleOne) {
			self.set({
				'selectedPrimaryMobileKeyLine': primaryKeyLineService,
				isDisabled: true
			});
		} else {
			presentMobiles.push({
				title: 'Mobile ' + primaryKeyLineService.serviceId,
				value: primaryKeyLineService.serviceId
			});
			self.set('selected_value', primaryKeyLineService.serviceId);
			if (singtelCircle && singtelCircle.availableKeylineServices) {
				_.each(singtelCircle.availableKeylineServices, function (service) {
					presentMobiles.push({
						title: 'Mobile ' + service.serviceId,
						value: service.serviceId
					});
				});
			}
		}
		self.set({
			selectedFiberPlan: fiberPlan.serviceId,
			selectedTvPlan: tvPlan.serviceId,
			selectedHomeLinePlan: homeLine.serviceId,
			presentMobiles: presentMobiles
		});
		self.populateKeyLineServices();
		if (self.get('showTextFields').length ===  self.get('widgetConfig.addEditCircle.showTextFields')) {
			self.set('showAddMoreLines', false);
		}
	},
	populateKeyLineServices: function () {
		var self = this,
			circleServices = self.get('singtelCircle.circleServices'),
			numberOfTextFields = [],
			preSelectedKeyLineServices = _.filter(circleServices, function (service) {
				return !service.keyline && (service.lob === 'WS' || service.lob === 'MOB');
			});
		_.each(preSelectedKeyLineServices, function (service, index) {
			self.checkPhone(service.serviceId);
			numberOfTextFields.push({
				id: 'mobile_' + index,
				simNumber: service.serviceId,
				validationFailed: false,
				validationSuccess: true,
				msgValidity: self.get('phoneVal.phoneValErrorMsg'),
				doubleEnteredNumberError: false
			});
		});
		if (numberOfTextFields.length > 0) {
			self.set('showTextFields', numberOfTextFields.concat(self.getTextFields(numberOfTextFields.length)));
		}
	},
	getSelectedPrimaryMobileKeyLine: function (services) {
		if (services && services.length > 0) {
			return _.find(services, function (service) {
				return service.keyline && service.lob === 'WS';
			});
		}
	},
	findFirstLobService: function (services, lob, nlob) {
		return _.find(services, function (service) {
			if (nlob) {
				return service.lob === lob || service.lob === nlob;
			} else {
				return service.lob === lob;
			}
		});
	},
	onValidMobileNumber: function (textBox, isValid, validityObj) {
		var self = this,
			allMobileNumbers = self.get('showTextFields'),
			textFieldObj = textBox.get('textFieldObj');
		var sameMultiNumber = _.filter(allMobileNumbers, function (mobile) {
			return textFieldObj.id !== mobile.id &&
				textFieldObj.simNumber === (mobile.simNumber);
		});
		if (sameMultiNumber && sameMultiNumber.length === 0) {
			var selectedPrimaryKeyLine = self.get('selectedPrimaryMobileKeyLine');
			if (!selectedPrimaryKeyLine) {
				selectedPrimaryKeyLine = self.get('selected_value');
			} else {
				selectedPrimaryKeyLine = selectedPrimaryKeyLine.serviceId;
			}
			if (selectedPrimaryKeyLine) {
				sameMultiNumber = _.filter(allMobileNumbers, function (mobile) {
					return textFieldObj.simNumber === (selectedPrimaryKeyLine);
				});
			}
		}
		if (!(!isValid || (sameMultiNumber && sameMultiNumber.length > 0))) {
			var validationError = self.get('validationError');
			if (textFieldObj.simNumber && validationError.serviceId && validationError.errorMessage &&
				validationError.serviceId.includes(String(textFieldObj.simNumber))) {
				isValid = false;
				validityObj = {
					message: validationError.errorMessage,
					passed: false
				};
			}
		}
		_.each(allMobileNumbers, function (obj) {
			if (obj.id === textFieldObj.id && textFieldObj.simNumber) {
				self.makeButtonEnable();
				obj.msgValidity = validityObj;
				obj.validationSuccess = isValid;
				obj.doubleEnteredNumberError = (sameMultiNumber && sameMultiNumber.length > 0);
				obj.validationFailed = (!isValid || (sameMultiNumber && sameMultiNumber.length > 0));
			} else if (obj.id === textFieldObj.id && textFieldObj.simNumber.length === 0) {
				obj.msgValidity = {};
				obj.validationSuccess = false;
				obj.msgValidity = { valid: null };
				obj.validationFailed = false;
			}
		});
		self.set('showTextFields', allMobileNumbers);
	},
	validateToProceedNominations: function () {
		var self = this,
			selectedFiber = self.get('selectedFiberPlan'),
			selectedTV = self.get('selectedTvPlan'),
			selectedHomeLine = self.get('selectedHomeLinePlan'),
			selectedPrimaryKeyLine = self.get('selectedPrimaryMobileKeyLine'),
			showTextFields = self.get('showTextFields'),
			validationError = self.get('validationError'),
			selectedNonKeyLines = [],
			defaultSelectedOption = self.get('widgetConfig.addEditCircle.mobileSection.defaultSelectedOption'),
			nonKeyLineFlag = true;
		if (!selectedPrimaryKeyLine) {
			selectedPrimaryKeyLine = self.get('selected_value');
		} else {
			selectedPrimaryKeyLine = selectedPrimaryKeyLine.serviceId;
		}
		if (validationError && validationError.errorCode && validationError.serviceId &&
			(validationError.serviceId.includes(selectedFiber) || validationError.serviceId.includes(selectedTV) ||
				validationError.serviceId.includes(selectedHomeLine) ||
				validationError.serviceId.includes(selectedPrimaryKeyLine))) {
			return false;
		}
		_.each(showTextFields, function (number) {
			if (number.simNumber) {
				if (number.validationSuccess && !number.validationFailed &&
					number.doubleEnteredNumberError === false && nonKeyLineFlag) {
					selectedNonKeyLines.push({
						serviceID: String(number.simNumber),
						serviceType: 'MOB',
						keyline: false
					});
				} else {
					nonKeyLineFlag = false;
				}
			}
		});
		if (!nonKeyLineFlag) {
			return false;
		}
		if (defaultSelectedOption === selectedPrimaryKeyLine || !selectedPrimaryKeyLine) {
			this.set({
				'primaryKeyNominationNotSelected': true,
				'validationError.serviceId': this.get('selected_value')
			});
			return false;
		} else {
			var selectedCircleServices = {
				fiber: { serviceID: selectedFiber, serviceType: 'FBB' },
				tv: { serviceID: selectedTV, serviceType: 'TV' },
				homeLine: { serviceID: selectedHomeLine, serviceType: 'FV' },
				primaryKeyLine: { serviceID: selectedPrimaryKeyLine, serviceType: 'MOB', keyline: true },
				nonKeyLines: selectedNonKeyLines
			};
			var selectedCircleServicesArr = [
				selectedCircleServices.fiber,
				selectedCircleServices.tv,
				selectedCircleServices.homeLine,
				selectedCircleServices.primaryKeyLine
			];
			selectedCircleServicesArr = selectedCircleServicesArr.concat(selectedCircleServices.nonKeyLines);
			self.parent.set('selectedCircleServices', selectedCircleServices);
			self.parent.set('selectedCircleServicesArr', selectedCircleServicesArr);
		}
		return true;
	},
	oncomplete: function () {
		window.scrollTo({ top: 0, left: 100 });
	},
	scrollToFirstInlineError: function () {
		var errorElements = document.getElementsByClassName('validation-inline-error');
		if (errorElements.length > 0) {
			var domNode = errorElements[0];
			domNode.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
		}
	},
	getUpdatedServiceDetails: function () {
		var self = this,
			allSelectedNominations = self.parent.get('selectedCircleServicesArr'),
			circleServices = self.get('singtelCircle.circleServices'),
			updatedCircleServices = self.updateServicesToPayload(circleServices),
			addedServiceMap = self.checkServiceIsPresent(allSelectedNominations, updatedCircleServices),
			removedServiceMap = self.checkServiceIsPresent(updatedCircleServices, allSelectedNominations);
		return {
			addedServiceMap: addedServiceMap,
			removedServiceMap: removedServiceMap
		};
	},
	scrollToTop: function () {
		window.scrollTo({ top: 0, left: 100 });
	},
	checkServiceIsPresent: function (selectedServices, changedServices) {
		var services = _.filter(selectedServices, function (service) {
			return !_.find(changedServices, function (cService) {
				return service.serviceID === cService.serviceID;
			});
		});
		var serviceDetails = {};
		_.each(services, function (service) {
			serviceDetails[service.serviceID] = service.serviceType;
		});
		return serviceDetails;
	},
	updateServicesToPayload: function (circleServices) {
		var updatedServices = [];
		_.each(circleServices, function (service) {
			updatedServices.push({
				serviceID: service.serviceId,
				serviceType: service.lob,
				keyline: service.keyline
			});
		});
		return updatedServices;
	},
	makeButtonEnable: function () {
		var self = this;
		if (self.get('isEditMode') && self.get('isDisabled')) {
			self.set('isDisabled', false);
		}
	},
	checkPhone: function (value) {
		var self = this,
			errorMessages = self.get('widgetConfig.addEditCircle.nonKeyLineSection.errorMessages');
		self.phoneValidationRule = new RactiveValidate(this, {
			phoneVal: {
				phoneNoFormat: errorMessages.phoneNoFormat,
				minlength: {
					param: 8,
					message: errorMessages.minLength
				},
				maxlength: {
					param: 8,
					message: errorMessages.maxLength
				},
				digits: errorMessages.phoneNoFormat
			}
		});
		self.phoneValidationRule.patterns.phoneNoFormat = RactiveHelpers.mobileValidator;
		self.phoneValidationRule.cwd = 'phoneVal';
		self.set('phoneVal.phoneVal', value);
		return self.phoneValidationRule.validate(self.phoneValidationRule);
	}
});

Ractive.components["ux-singtel-circle"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-circle'],
	isolated: true,
	initVariables: function () {
	
		this.set('onInitEligibleButtonDisabled', true);

	},
	handleModal: function (visibility, cardId) {
		var modals = this.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return cardId === component.get('modalId');
		})[0];
		modal.set('displayState', visibility);
	},
	enableEligibilityButton: function () {
		var mobile = this.get('selectedMobileOption');
		var broadband = this.get('selectedBroadbandOption');
		var tv = this.get('selectedTvOption');

		if (mobile && broadband && tv) {
			this.set('onInitEligibleButtonDisabled', false);
		}
	},
	onrender: function () {
		var self = this;
	
	
		self.initVariables();

	
		self.on('selectProduct', function (event, id, option) {
			if (id === 'mobile') {
				self.set('selectedMobileOption', option);
			} else if (id === 'broadband') {
				self.set('selectedBroadbandOption', option);
			} else {
				self.set('selectedTvOption', option);
			}

			self.enableEligibilityButton();
		});

		self.on('*.checkEligibility', function (event) {
			var desc = '';
			var button = '';
			var url = '#';

			var mobile = this.get('selectedMobileOption');
			var broadband = this.get('selectedBroadbandOption');
			var tv = this.get('selectedTvOption');

			var noOption = this.get('preferences.noButtonText');

			if (mobile === noOption) {
				desc = this.get('productCircleList.0.failMessageDescription');
				button = this.get('productCircleList.0.failMessageButtonText');
				url = this.get('productCircleList.0.failMessageButtonLink');
			} else if (broadband === noOption) {
				desc = this.get('productCircleList.1.failMessageDescription');
				button = this.get('productCircleList.1.failMessageButtonText');
				url = this.get('productCircleList.1.failMessageButtonLink');
			} else if (tv === noOption) {
				desc = this.get('productCircleList.2.failMessageDescription');
				button = this.get('productCircleList.2.failMessageButtonText');
				url = this.get('productCircleList.2.failMessageButtonLink');
			} else {
				desc = this.get('preferences.eligibilityDescription');
				button = this.get('preferences.eligibilityButtonText');
				url = this.get('preferences.eligibilityButtonUrl');
			}

			this.set('modalDescription', desc);
			this.set('modalLinkText', button);
			this.set('modalLinkUrl', url);

			this.handleModal(true, 'eligibilityModal');

		});

	}
});

Ractive.components["ux-singtel-form-field"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-form-field'],

	validate: function (childComponent) {
		var self = this;

		var validateObj = new RactiveValidate(self, {
			value: self.get('validation')
		});

		validateObj.keypath = function (keypath) {
			return keypath;
		};

		return validateObj.validate().valid;
	},

	onrender: function () {
		var self = this;
		self.on('*.formControlsValidation', function (childComponent) {
			return self.validate();
		});

		self.on('*.radioOptionUpdated', function (btn) {
			if (btn.context.disabled !== 'disabled') {
				self.set('value', self.get('radio_btns')[btn.index.i].value);
				self.set('selected', self.get('radio_btns')[btn.index.i].value);
			}
		});
	}
});

Ractive.components["ux-singtel-form"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-form'],

	retrieveformPost: function () {
		var self = this;
		var postValue = {};
		var formFields = self.findAllComponents('ux-singtel-form-field');

		_.each(formFields, function (formElement) {
			postValue[formElement.get('name')] = formElement.get('value');
		});

		postValue.formName = this.get('formname');
		postValue.currentPageForm = this.get('currentPage');
		postValue.isMailSend = this.get('isMailSend');
		postValue.webform_userEmail = this.get('fromEmailId');
		postValue.webform_textareaValue = this.get('msgPassToUser');
		postValue.webform_emailSubject = this.get('emailSubject');
		postValue['required-info'] = this.find('.not-required-validation').value;

		return postValue;
	},

	formIsValid: function (childComponent) {
		var formFields = this.findAllComponents('ux-singtel-form-field');
		var invalidFormFields = _.filter(formFields, function (formField) {
			return !formField.validate();

		}).length;

		return invalidFormFields === 0;
	},

	resetForm: function () {
		_.each(this.findAllComponents('ux-singtel-form-field'), function (formField) {
			formField.set({
			
				value: '',
			
				selected_value: formField.get('options.0.value'),
			
				checked: formField.get('initialValue'),
			
				selected: '',
			
				valueErrorMsg: ''
			});
		});
	},

	onrender: function () {
		var self = this;
		var ajaxcall;
		self.on('*.addSubmitForm', function (event) {
			self.set('formSubmissionMsg', '');
			if (!self.formIsValid()) {
				var termsAndConditionsUnchecked;
				var formFields = self.findAllComponents('ux-singtel-form-field');
				_.filter(formFields, function (formField) {
					if (!formField.validate()) {
						if (formField.find('input#webform_term_condition') !== null) {
							termsAndConditionsUnchecked = true;
						}
					}
					return !formField.validate();
				});
				if (termsAndConditionsUnchecked) {
					self.set('formValidationMsg', self.get('checkTermsandConds'));
					return false;
				} else {
					self.set('formValidationMsg', self.get('failedValidation'));
					return false;
				}
			}

			var postValue = self.retrieveformPost();

			if (ajaxcall) {
				ajaxcall.abort();
			}

			ajaxcall = $.ajax({
				url: self.get('submissionurl'),
				data: postValue,
				type: 'post'
			});

			ajaxcall.done(function (response) {
				if (response.response !== 'success' && response.error !== '') {
					self.set('formSubmissionMsg', self.get('failedMsg'));
				} else {
										self.resetForm();
					if (self.get('successMsg') && self.get('postSubmissionPage') === '') {
						self.set('formSubmissionMsg', self.get('successMsg'));
					} else if (self.get('postSubmissionPage')) {
						window.location.replace(self.get('postSubmissionPage'));
					}
				}
			});

			ajaxcall.fail(function () {
				self.set('formSubmissionMsg', self.get('failedMsg'));
			});

			return false;
		});
	}
});

Ractive.components["ux-singtel-guest-profile"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-guest-profile'],
	data: function () {
		return {
			defaultOptions: {
				salutationOptions : [
					{ value : 'MR', text : 'Mr'},{ value : 'MRS', text : 'Mrs'},{ value : 'MS', text : 'Miss'},
					{ value : 'DR', text : 'Dr'}
				],
				genderOptions : [
					{ value : 'M', text : 'Male'},{ value : 'F', text : 'Female'}
				]
			},
			day: '',
			month: '',
			year: '',
			registeredName: '',
			singpassFlag: false,
			counter: false,
			hideSingpassButton: false,
			nric: '',
			dateOfBirth: '',
			isManuallyUpload: true,
			RactiveValidate: RactiveValidate,
			ConfigStrings: ConfigStrings,
			genderError: false,
			salutationError: false,
			worryFreeFlow: false,
			guestEmail: null,
			editableNric: false,
			showAddress: true
		};
	},

	oninit : function () {
		this.set('guestIdTypeOptions', ConfigStrings.guestIdTypeOptions);
		this.set('guestIDPrefixOptions', ConfigStrings.guestIDPrefixOptions);
		this.set('isConsentAgreed', false);
		var disablePopulatedField = this.get('disablePopulatedField');
		if (!disablePopulatedField) {
			this.set('guestType', 'Select');
			this.set('selectedGuestId', 'Select');
		}
		var d = new Date();
		var currentYear = d.getFullYear();
		var yearOptions = [];

		yearOptions.push({
			value : 'Year',
			text: 'Year'
		});
		for (var i = 0; i < 100; i++) {
			yearOptions.push({
				value : (currentYear - i),
				text: (currentYear - i)
			});
		}
		var worryFreeContext = this.get('worryFreeContext');
		if (worryFreeContext) {
			this.set('selectedGuestId', worryFreeContext.otpData.acceptorIndentValue.substring(0, 1));
			this.set('guestIdNumber', worryFreeContext.otpData.acceptorIndentValue.substring(1));
			this.set('guestType', worryFreeContext.otpData.acceptorIndentType);
		}
		this.set('defaultOptions.yearOptions', yearOptions);
		this.set('year', 'Year');
		this.set('defaultOptions.monthOptions', ConfigStrings.date.months2);
		this.set('month', 'Month');

		var dayOptions = [];
		dayOptions.push({
			value : 'Day',
			text : 'Day'
		});
		for (var i = 0; i < 31; i++) {
			dayOptions.push({
				value : (((i + 1) < 10) ? ('0' + (i + 1)) : (i + 1)),
				text : (i + 1)
			});
		}
		this.set('defaultOptions.dayOptions', dayOptions);
		this.set('day', 'Day');

		this.set('salutation', 'Select');
		this.set('gender', 'Select');

		this.on('ux-button.doContinue', function (event) {
			var customerMinimalInformation = {};
			var personalInfo = {};
			var data = this.get();
			var day = data.day;
			var month = String(data.month).padStart(2, '0');
			var year = data.year;
			var birthDate = day + '/' + month + '/' + year;
			var nameMsg = this.validateContactName();
			var isNumberValid = this.validateContactNum().valid;
			if (nameMsg.valid) {
				nameMsg.valid = this.validateUserName();
			}
			var isValidEmail = true;
			if (this.get('worryFreeFlow')) {
				isValidEmail = this.validateEmailAddress();
			}
			var address = data.address;
			var errorFlag = false;
			var isValid = true;
			var  myInfoData = this.get('myInfoData');
			if (!(this.get('cisInfoFlag') && myInfoData && myInfoData.selectedAddress &&
				myInfoData.selectedAddress.postal) && this.findComponent('ux-address-form')) {
				this.findComponent('ux-address-form').set('errorMessage', false);
				isValid = this.findComponent('ux-address-form').validateFloorAndUnitNumber();
				if (!address.postCode || (address.postCodeErrorMsg && address.postCodeErrorMsg.status === 'error')) {
					errorFlag = true;
				}
			}
			var isNricValid = !this.get('editableNric') || this.onNricBlur();
			var genderSalutationError = false;
			this.set('genderError', false);
			this.set('salutationError', false);
			if (data.gender === 'Select') {
				genderSalutationError = true;
				this.set('genderError', true);
			}
			if (data.salutation === 'Select') {
				genderSalutationError = true;
				this.set('salutationError', true);
			}

			var isConsentAgreed = this.get('isConsentAgreed');

			if (typeof isConsentAgreed !== 'undefined' && isConsentAgreed === true) {
				this.set('consentError', false);
			} else {
				this.set('consentError', true);
			}

			if (day === 'Day' || month === 'Month' || year === 'Year') {
				this.set('dateError', ConfigStrings.errors.invalidDate);
				this.set('doyError', null);
			} else if (nameMsg.valid && !errorFlag && isValid && !genderSalutationError && isNumberValid &&
				isConsentAgreed === true && isValidEmail && isNricValid) {
				var nric = this.get('editableNric') && this.get('nric') ||
					(!this.get('editableNric') && (data.selectedGuestId + data.guestIdNumber));
				var isValidDateOfBirth = this.validateDateOfBirth(birthDate).valid;
				if (!isValidDateOfBirth) {
					this.set('dateError', ConfigStrings.errors.invalidDate);
					this.set('doyError', null);
				} else if (!this.isAdult(birthDate).valid) {
					this.set('dateError', 'Customer\'s age must be greater than 18.');
					this.set('doyError', null);
				} else if (!this.get('singpassFlag') && !this.validateDobNric(birthDate, nric).valid) {
					this.set('doyError', 'Please select valid year.');
				} else {
					if (data.showIdentificationDetails || this.get('isGomoPrepaid')) {
						personalInfo.guestIdNumberPrefix = data.selectedGuestId;
						personalInfo.guestIdNumber = data.selectedGuestId + data.guestIdNumber;
						personalInfo.guestIdTypeSelected = data.guestType;
					}
					if (this.get('worryFreeFlow')) {
						personalInfo.email = data.guestEmail;
						this.parent.set('guestCheckout.guestData.email', data.guestEmail);
					}
					personalInfo.registeredName = data.registeredName;
					personalInfo.gender = data.gender;
					personalInfo.salutation = data.salutation;
					personalInfo.birthDate = birthDate;
					personalInfo.singpassFlag = true;
					personalInfo.counter = false;
					personalInfo.hideSingpassButton = data.hideSingpassButton;
					personalInfo.nric = nric;
					personalInfo.phone = data.contactNumber || data.value;
					customerMinimalInformation.personalInfo = personalInfo;
					customerMinimalInformation.address = address;
					customerMinimalInformation.address.country = ConfigStrings.physicalAddressValues.country;
					customerMinimalInformation.address.state = ConfigStrings.physicalAddressValues.state;
					customerMinimalInformation.address.city = ConfigStrings.physicalAddressValues.city;
					customerMinimalInformation.address.countryCode1 = ConfigStrings.physicalAddressValues.countryCode1;
					console.log('customerMinimalInformation', customerMinimalInformation);
					this.set('dateError', '');
					this.fire('createCustomer', customerMinimalInformation);
				}
			}
		});

		this.on('*.onSalutationChange', function () {
			this.set('genderError', false);
			this.set('salutationError', false);
			var selectedValue = this.event.component.get('selected_value');
			if (selectedValue === 'MR') {
				this.set('gender', 'M');
				this.set('disableGender', true);
			} else if (selectedValue === 'MRS' || selectedValue === 'MS') {
				this.set('gender', 'F');
				this.set('disableGender', true);
			} else if (selectedValue === 'Select' && !(this.get('singpassFlag') &&
				(this.get('gender') === 'M' || this.get('gender') === 'F'))) {
				this.set('gender', 'Select');
				this.set('disableGender', false);
			} else {
				this.set('disableGender', false);
			}
		});

		this.on('*.onGuestIdChange', function () {
			var selectedValue = this.event.component.get('selected_value');
			var guestIdTypeOptions = _.filter(ConfigStrings.guestIdTypeOptions, function (guest) {
				return guest.ID === selectedValue;
			});
			this.set('guestIdTypeOptions', guestIdTypeOptions);
			this.set('selectedGuestId', selectedValue);
		});

		this.on('*.onGenderChange', function () {
			this.set('genderError', false);
			this.set('salutationError', false);
		}.bind(this));
		var eKycFootnotes = this.get('initData.eKycFootnotes');
		var guestCheckoutFillFormManually = _.find(eKycFootnotes, function (note) {
			return (note && note.scenario === 'guestCheckoutFillFormManually');
		});
		this.set('guestCheckoutFillFormManually', guestCheckoutFillFormManually);
		var guestCheckoutSingpass = _.find(eKycFootnotes, function (note) {
			return (note && note.scenario === 'guestCheckoutSingpass');
		});
		this.set('guestCheckoutSingpass', guestCheckoutSingpass);
	},
	onrender: function () {
		this.on('ux-input-box.validateContactNumber', function (event) {
			this.validateContactNum();
		}.bind(this));
		this.on('ux-input-box.onNricBlur', function () {
			this.onNricBlur();
		}.bind(this));

		this.on('ux-input-box.validateName', function () {
			var flag = this.validateContactName();
			if (flag.valid) {
				this.validateUserName();
			}
		});

		this.on('ux-input-box.updateIdNumber', function () {
			this.set('guestIdNumberErrorMsg.message', '');
		}.bind(this));
		this.on('ux-input-box.updateNric', function () {
			this.set('nricErrorMsg.message', '');
		}.bind(this));

		this.on('ux-input-box.updateName', function () {
			this.set('registeredNameErrorMsg.message', '');
		}.bind(this));

		this.on('ux-input-box.validateCusId', function () {
			this.validateCustomerId();
		}.bind(this));

		this.on('ux-input-box.updateNum', function (event) {
			this.set('contactVal.contactValErrorMsg.message', '');
		}.bind(this));

		this.observe('day', function (value) {
			if (value !== 'Day') {
				this.set('dateError', false);
			}
		}.bind(this));

		this.observe('month', function (value) {
			if (value !== 'Month') {
				this.set('dateError', false);
			}
		}.bind(this));

		this.observe('year', function (value) {
			if (value !== 'Year') {
				this.set('dateError', false);
			}
		}.bind(this));
		this.on('*.onEmailChange', function (value) {
			this.validateEmailAddress();
		}.bind(this));
		this.observe('myInfoData', function (myInfoData) {
			var self = this;
			if (myInfoData && myInfoData.custId) {
				self.set('selectedGuestId', myInfoData.custId.substring(0, 1));
				self.set('guestIdNumber', myInfoData.custId.substring(1));
				self.set('guestType', myInfoData.idType);
				if (myInfoData.selectedGender === 'Male') {
					self.set('defaultOptions.salutationOptions', [
						{ value : 'MR', text : 'Mr'},
						{ value : 'DR', text : 'Dr'}
					]);
					self.set('salutation', 'MR');
					self.set('gender', 'M');
				} else {
					self.set('defaultOptions.salutationOptions', [
						{ value : 'MRS', text : 'Mrs'},{ value : 'MS', text : 'Miss'},
						{ value : 'DR', text : 'Dr'}
					]);
					self.set('salutation', 'MS');
					self.set('gender', 'F');
				}
				self.set('day', myInfoData.selectedDay);
				self.set('month', myInfoData.selectedMonth);
				self.set('year', myInfoData.selectedYear);
				self.set('contactNumber', myInfoData.selectedNumber);
				self.set('guestEmail', myInfoData.selectedEmail);
				self.set('registeredName', myInfoData.selectedName);
				var selectedAddress = myInfoData.selectedAddress;
				var selectedUnitNo = (selectedAddress.floor ? '#' +
						selectedAddress.floor + '-' + selectedAddress.unit : null);
				self.set('address', {
					apartment: selectedUnitNo,
					blockOrHouseNum: selectedAddress.block,
					streetName: selectedAddress.street,
					floor: selectedUnitNo,
					unitNumber: selectedUnitNo,
					buildingName: selectedAddress.building,
					postCode: selectedAddress.postal
				});
				self.set('cisInfoFlag', true);
			}
		}.bind(this));
	},
	onNricBlur: function () {
		this.set('nric', this.get('nric').toUpperCase());
		var nricValidator = new RactiveValidate(this, {
			'nric': {
				nricFormat: ConfigStrings.errors.relocateServices.nricFormat
			}
		});
		nricValidator.cwd = '';
		nricValidator.patterns.nricFormat = RactiveHelpers.validateNRIC;
		var isValid = nricValidator.validate().valid;
		return isValid;
	},
	validateContactNum: function () {
		var error = ConfigStrings.guestCheckoutValidationError.mobileNumber;
		this.contactValidation = new RactiveValidate(this,{
			contactVal: {
				validPhoneNumber: error.inValidMobile,
				minlength: {
					param: 8,
					message: error.minLengthError
				},
				maxlength: {
					param: 8,
					message: error.maxLengthError
				},
				digits: error.mobileDigitOnly,
				required: error.mobileRequired
			}
		});
		this.contactValidation.cwd = 'contactVal';
		this.set('contactVal.contactVal', this.get('value') || this.get('contactNumber'));
		return this.contactValidation.validate(this.contactValidation);
	},
	validateDateOfBirth: function (dateOfBirth) {
		var error = ConfigStrings.guestCheckoutValidationError.dateOfBirth;
		this.dateOfBirthValidation = new RactiveValidate(this,{
			dateOfBirthVal: {
				isValidDate: error.isValidDate,
				isPastDate: error.isPastDate
			}
		});
		this.dateOfBirthValidation.cwd = 'dateOfBirth';
		this.set('dateOfBirth.dateOfBirthVal', dateOfBirth);
		return this.dateOfBirthValidation.validate(this.dateOfBirthValidation);
	},
	isAdult: function (dateOfBirth) {
		this.ageValidation = new RactiveValidate(this,{
			ageVal: {
				isAdult: 'Customer\'s age must be greater than 18.'
			}
		});
		this.ageValidation.cwd = 'dateOfBirth';
		this.set('dateOfBirth.ageVal', dateOfBirth);
		return this.ageValidation.validate(this.ageValidation);
	},
	validateDobNric: function (dateOfYear, nric) {
		this.dobNricVal = new RactiveValidate(this,{
			validateDobNric : {
				isDobNricVal: 'Please select valid year.'
			}
		});
		var value = {
			nric: nric,
			dob: dateOfYear
		};
		this.dobNricVal.cwd = 'dateOfYear';
		this.set('dateOfYear.validateDobNric', value);
		return this.dobNricVal.validate(this.dobNricVal);
	},
	validateContactName: function () {
		var error = ConfigStrings.guestCheckoutValidationError.customerName;
		this.nameValidation = new RactiveValidate(this,{
			'registeredName': {
				maxlength: {
					param: 50,
					message: error.maxLengthError
				},
				validUserName: error.inValidName,
				required: error.nameRequired
			}
		});
		this.nameValidation.cwd = '';
		return this.nameValidation.validate(this.nameValidation);
	},
	validateUserName: function () {
		var name = this.get('registeredName');
		var flag = true;
		if (name.indexOf('/') !== -1) {
			var regexString = '(?!\/)(s|S|d|D)\/(o|O+)';
			if (name.match(regexString)) {
				flag = true;
			} else {
				flag = false;
				this.set('registeredNameErrorMsg', {
					message: ConfigStrings.guestCheckoutValidationError.customerName.inValidName,
					status: 'error'
				});
			}
		}
		return flag;
	},
	validateCustomerId: function () {
		var error = ConfigStrings.guestCheckoutValidationError.idNumber;
		this.guestIdNumberValidation = new RactiveValidate(this, {
			'guestIdNumber': {
				minlength: {
					param: 8,
					message: error.minLengthError
				},
				maxlength: {
					param: 8,
					message: error.maxLengthError
				},
				alphaAndNumeric: error.inValidError,
				required: error.idRequired
			}
		});
		this.guestIdNumberValidation.cwd = '';
		return this.guestIdNumberValidation.validate(this.guestIdNumberValidation);
	},
	validateEmailAddress: function () {
		var error = ConfigStrings.guestCheckoutValidationError.emailAddress;
		var validationRule = {
			guestEmail: {
				required: error.nameRequired,
				email: error.inValidEmail
			}
		};
		var validation = new RactiveValidate(this, validationRule);
		validation.cwd = '';
		return validation.validate(this.validation).valid;
	}
});

Ractive.components["ux-singtel-heading-text"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-heading-text']
});

Ractive.components["ux-singtel-login-header"] = Ractive.extend({
		template: LUXComponentTemplates['ux-singtel-login-header'],
	oncomplete: function () {
		var self = this;

		var tempJQuery = $;
		if ($) {
			tempJQuery = $;
		} else if (jQuery) {
			tempJQuery = jQuery;
		}
		
		self.on('doLogin', function () {
			self.toggle('showMenu');
			return false;
		});
		
		self.on('do_Logout', function () {
			self.fire('doLogout');
		});

		this.set('inProgress', true);
	}
});
Ractive.components["ux-singtel-login"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-login'],
	data : {
		ConfigStrings: ConfigStrings
	},
	oninit : function () {
		var self = this;
		self.set('loginURL', self.get('loginUrl'));
	},
	onconfig : function (argument) {
	
		var referenceUrl = this.get('referenceUrl') || window.location.href;

		var target = this.getQueryStringValue('referenceUrl', window.location.href);
		if (target) {
			referenceUrl = target;
		}
		var loginUrl = this.get('loginUrl');
		var status = RactiveHelpers.getParameterByName('status');
		if (status === 'already_registered') {
			loginUrl = loginUrl + '&status=already_registered';
		}
		var isShopFlow = this.get('isShopFlow');
		if (isShopFlow) {
			loginUrl = loginUrl + '&view=shop';
		}
		this.set('loginUrl', loginUrl);
		var agentId = RactiveHelpers.getCookie('visitor-agent-id');
		if (!agentId) {
			var deviceIdPromise = RactiveHelpers.getDeviceID();
			deviceIdPromise.then(function (result) {
				RactiveHelpers.redirectUiamLoginPage(loginUrl, referenceUrl, this);
			});
		} else {
			RactiveHelpers.redirectUiamLoginPage(loginUrl, referenceUrl, this);
		}
	},
	getQueryStringValue : function (field, url) {
		var href = url ? url : window.location.href;
		var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
		var string = reg.exec(href);
		return string ? string[1] : null;
	}
});

Ractive.components["ux-singtel-onepass-change-password"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-onepass-change-password'],
	oninit : function () {
		var url = this.updateQueryStringParameter(window.location.href, 'state', 'changesuccess');
		url = this.updateQueryStringParameter(url, 'ERROR_MSG', '');
		this.set('changepassword.callbackURL', url);

		var warningMessage = false;
		if (this.getParameterByName('ERROR_MSG', window.location.href)) {
			this.set('warningMessageDisplay', this.getParameterByName('ERROR_MSG', window.location.href));
			warningMessage = true;
		}
		if (this.getParameterByName('state', window.location.href) === 'changesuccess' &&
				!warningMessage) {
			this.set('successMessage', 'You have successfully changed your password');
		}
	},
	getParameterByName : function (name, url) {
		if (!url) {
			url = window.location.href;
		}
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
		if (!results) {
			return null;
		}
		if (!results[2]) {
			return '';
		}
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	},
	updateQueryStringParameter : function (uri, key, value) {
		var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
		var separator = uri.indexOf('?') !== -1 ? '&' : '?';
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + '=' + value + '$2');
		} else {
			return uri + separator + key + '=' + value;
		}
	},
	cancelAction : function () {
		if (this.get('callbackURL')) {
			window.location.href = this.get('callbackURL');
		}
		return true;
	},
	validNewPasswordRulesFail : function (newPassword, repeatPassword) {
		if (newPassword === repeatPassword) {
			return false;
		}
		return true;
	},
	validNewPasswordFail : function (newPassword, repeatPassword) {
		if (newPassword !== '') {
			return false;
		}
		return true;
	},
	validCurrentPasswordFail : function (password) {
		return false;
	},
	validForm : function (ractive) {

		var newPasswordClass = '';
		var currentPasswordClass = '';

		var warningMessageDisplay = '';
		if (ractive.validCurrentPasswordFail(ractive.get('currentPassword'))) {
			currentPasswordClass = 'warningInput';
			warningMessageDisplay = 'Current password not correct.';
		} else if (ractive.validNewPasswordFail(ractive.get('newPassword'), ractive.get('newRepeatPassword'))) {
			newPasswordClass = 'warningInput';
			warningMessageDisplay = 'New password does not match.';
		} else if (ractive.validNewPasswordRulesFail(ractive.get('newPassword'), ractive.get('newRepeatPassword'))) {
			newPasswordClass = 'warningInput';
			warningMessageDisplay = 'New password does not match rules.';
		}
		ractive.set('newPasswordClass', newPasswordClass);
		ractive.set('currentPasswordClass', currentPasswordClass);

		ractive.set('warningMessageDisplay', warningMessageDisplay);

		if (warningMessageDisplay) {
			return false;
		} else {
			return true;
		}
	},
	doSubmitAction: function (event) {
		event.original.preventDefault();

		var self = this;

		if (self.validForm(self)) {
		
			self = this;

		} else {
			console.log('Validation failed');
			return ;
		}

		event.node.submit();
	}

});

Ractive.components["ux-singtel-onepass-login"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-onepass-login'],
	oninit : function () {
		var self = this;

		var origin = RactiveHelpers.getParameterByName('origin');
		this.set('origin', origin);

		var view = RactiveHelpers.getParameterByName('view');
		this.set('view', view);

		var panelRequired = true;

		var onepassTitle = this.get('onepassTitle');
		var onepassDescription = this.get('onepassDescription');

		if (!onepassTitle) {
			if (this.get('loginType') === 'ajax') {
				panelRequired = false;
			} else {
				onepassTitle = 'Welcome to <br /> My Account';
				onepassDescription = '<h6>Login to access all your services</h6>';
			}

			if (view === 'onepass') {
				onepassTitle = 'Welcome to <br /> OnePass';
				onepassDescription = '<h6>Login to access all your services</h6>';
			} else if (view === 'shop') {
				onepassTitle = 'Login with your OnePass Account';
				onepassDescription = '';
				panelRequired = false;
			}
		}

		this.set('onepassDescription', onepassDescription);
		this.set('panelRequired', panelRequired);

		this.set('onepassTitle', onepassTitle);


		var showActionButtons = this.get('showActionButtons');

		if (showActionButtons === 'false' || showActionButtons === false) {
			this.set('showActionButtons', false);
		} else {
			this.set('showActionButtons', true);
		}

		var countryList = this.get('countryList');
		for (var i = 0; i < countryList.length; i++) {
			countryList[i].fullDisplay = countryList[i].country + ' (+' + countryList[i].countryCode + ')';
			countryList[i].countryDisplay = '+' + countryList[i].countryCode;
		}
		this.set('countryList', countryList);

		this.on('selectedCC', function (event) {
			var countryList = this.get('countryList');
			for (var i = 0; i < countryList.length; i++) {
				countryList[i].fullDisplay = countryList[i].country + ' (+' + countryList[i].countryCode + ')';
				countryList[i].countryDisplay = '+' + countryList[i].countryCode;
			}
			this.set('countryList', countryList);
			event.node.blur();
		});

		this.on('focusHandler', function () {
			var fireEvent = this.get('onFocusEvent');
			if (fireEvent) {
				this.fire(fireEvent, this);
				return false;
			}
		});

		this.observe('countryCode', function (newValue, oldValue) {
			self.onblurCC();
		});

		if (this.get('loginType') === 'ajax') {
			if (window) {
				var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
				var eventer = window[eventMethod];
				var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
				eventer(messageEvent, function (event) {
					var key = event.message ? 'message' : 'data';
					var data = event[key];
					var child = document.getElementById('onepassdynamiciframe');
					if (child) {
						child.parentElement.removeChild(child);

						if (data === 'result:success') {
							console.log('data: ' + data);
							self.fire('onepassloginresult', 'success');
						} else {
							self.fire('onepassloginresult', 'failed');
						}
					}
				}, false);
			}
		}
	},
	onblurCC: function () {
		var self = this;
		var countryList = self.get('countryList');
		for (var i = 0; i < countryList.length; i++) {
			countryList[i].fullDisplay = countryList[i].country + ' (+' + countryList[i].countryCode + ')';
			countryList[i].countryDisplay = '+' + countryList[i].countryCode;
		}
		var ccNode = self.nodes.country_code;
		if (ccNode) {
			ccNode.blur();
		}

		self.set('countryList', countryList);
	},
	oncomplete: function () {
		var self = this;

		var loginfailed = self.getQueryStringValue('loginstatus');
		if (loginfailed === 'fail') {
			self.set('warningMessageDisplay', 'You have entered invalid User ID and/or password. Please re-try.');
		}

		var status = self.get('status');
		if (status === 'already_registered') {
			self.set('warningMessageDisplay', 'Your OnePass Id already exists. Please login.');
		}

		var targetURL = self.get('targetURL');
		if (this.get('loginType') === 'ajax') {
			targetURL = self.get('serverTargetURL');
		}

		var params = {
			'portalTy': self.get('portalType'),
			'success_callback_url': self.get('succesCallBackURL'),
			'failure_callback_url': self.get('failureCallBackURL')
		};

		self.set('targetURL', targetURL + '?' + $.param(params));

		self.observe('loginid', function (newInput, oldInput, obj) {
			if (!isNaN(parseFloat(newInput)) && isFinite(newInput)) {
				this.set('displayCountryCode', true);
				this.set('usernameSpacing', 'large-8 small-8 medium-8');
			} else {
				this.set('displayCountryCode', false);
				this.set('usernameSpacing', '');
			}
		});
		self.on('forgetPasswordURLClicked', function (event) {
			window.top.location.href = self.get('forgetPasswordURL') +
				'?portalTy=' + self.get('portalType') +
				'&success_callback_url=' + self.get('origin');
		});
		self.on('registrationURLClicked', function (event) {
			window.top.location.href = self.get('registrationURL') +
				'?portalTy=' + self.get('portalType') +
				'&success_callback_url=' + self.get('origin');
		});
	},
	getQueryStringValue : function (field, url) {
		var href;
		if (window.location && window.location.href) {
			href = url ? url : window.location.href;
		} else {
			href = url;
		}
		var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
		var string = reg.exec(href);
		return string ? string[1] : null;
	},
	onfocusCC : function () {
		var countryList = this.get('countryList');
		for (var i = 0; i < countryList.length; i++) {
			countryList[i].countryDisplay = countryList[i].fullDisplay;
		}
		this.set('countryList', countryList);
	},
	validUsernamePassword : function (ractive) {
		var loginidClass = '';
		var passClass = '';

		var warningMessageDisplay = '';
		if (ractive.get('loginid') === '') {
			loginidClass = 'warningInput';
			warningMessageDisplay = 'Please enter your Login ID.';
		} else if (ractive.get('pass') === '') {
			passClass = 'warningInput';
			warningMessageDisplay = 'Please enter your password.';
		}
		ractive.set('warningMessageDisplay', warningMessageDisplay);
		ractive.set('loginidClass', loginidClass);
		ractive.set('passClass', passClass);

		if (warningMessageDisplay) {
			return false;
		} else {
			return true;
		}
	},
	doLoginAction: function (event) {
		event.original.preventDefault();

		var self = this;

		if (self.validUsernamePassword(self)) {
			self.set('password1', self.get('pass'));
			self.set('password2', self.get('pass'));
			var countryCode = (self.get('displayCountryCode')) ? self.get('countryCode') : '';
			self.set('ssoLoginUserid', countryCode + self.get('loginid'));
			self.set('username', countryCode + self.get('loginid'));
			self.set('tempCcode', ((self.get('displayCountryCode')) ? '+' : '') + countryCode);
			self.set('loginUserid', self.get('loginid'));
		} else {
			console.log('Validation failed');
			return ;
		}
		self.createCookie('userLoginId', self.get('ssoLoginUserid'), 20);

		if (self.get('loginType') === 'ajax') {

			var iframe   = document.createElement('iframe');

			iframe.id  = 'onepassdynamiciframe';
			iframe.width = '1px';
			iframe.height = '1px';
			iframe.frameBorder = '0';
			document.getElementById('onepassdynamiciframediv').appendChild(iframe);

		
			var content = '<form id="form" action="' + self.get('loginURL') + '" method="post">' +
			'<input name="loginid" type="hidden" value="' + self.get('loginid') + '">' +
			'<input name="pass" id="pass" type="hidden" value="' + self.get('pass') + '">' +
			'<input name="password" type="hidden" value="' + self.get('pass') + '">' +
			'<input name="ssoLoginUserid" type="hidden" value="' + self.get('ssoLoginUserid') + '">' +
			'<input name="loginUserid" type="hidden" value="' + self.get('loginUserid') + '">' +
			'<input name="PASSWORD" type="hidden" value="' + self.get('pass') + '">' +
			'<input type="hidden" name="temp_ccode" id="temp_ccode" value="' + self.get('tempCcode') + '">' +
			'<input name="USER" type="hidden" value="' + self.get('username') + '">' +
			'<input type="hidden" name="target" value="' + self.get('targetURL') + '">' +
			'<input name="portalTy" type="hidden" value="' + self.get('portalType')  + '">' +
			'<input type="hidden" name="success_callback_url" value="' + self.get('succesCallBackURL')  + '">' +
			'<input id="failure_callback_url" type="hidden" name="failure_callback_url" value="' +
			self.get('failureCallBackURL')  + '">' +
			'</form>';
			var doc;
			if (iframe.contentDocument) {
				doc = iframe.contentDocument;
			} else if (iframe.contentWindow) {
				doc = iframe.contentWindow.document;
			}
			doc.open();
			doc.writeln(content);
			doc.close();
			iframe.sandbox = 'allow-forms allow-scripts';
			doc.getElementById('form').submit();
		} else {
			event.node.submit();
		}
	},
	createCookie: function (name, value, days) {
		var expires;

		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = '; expires=' + date.toGMTString();
		} else {
			expires = '';
		}
		var host = window.location.host;

		var domain;
		var domainParts = host.split('.');
		domainParts.shift();
		domain = '.' + domainParts.join('.');


		var finalCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
		finalCookie = finalCookie + expires + ';domain=' + domain + '; path=/';
		console.log(finalCookie);
		document.cookie = finalCookie;
	}


});

Ractive.components["ux-singtel-onepass-profile"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-onepass-profile'],
	data: function () {
		return {
			defaultOptions: {
				salutationOptions : [
					{ value : 'Mr', gender : ['1']},
					{ value : 'Mrs', gender : ['0']},
					{ value : 'Mdm', gender : ['0']},
					{ value : 'Ms', gender : ['0']},
					{ value : 'Dr', gender : ['1','0']},
					{ value : 'Prof', gender : ['1','0']}
				],
				nricTyOptions : [
					{ value : 'ep', name : 'Employment Pass'},
					{ value : 'wp', name : 'Work Pass'},
					{ value : 'svp', name : 'Social Visit Pass'}
				],
				monthOptions : [
					{ value : '1', name : 'Jan'},{ value : '2', name : 'Feb'},{ value : '3', name : 'Mar'},
					{ value : '4', name : 'Apr'},{ value : '5', name : 'May'},{ value : '6', name : 'Jun'},
					{ value : '7', name : 'Jul'},{ value : '8', name : 'Aug'},{ value : '9', name : 'Sep'},
					{ value : '10', name : 'Oct'},{ value : '11', name : 'Nov'},{ value : '12',name : 'Dec'}
				],
				genderOptions : [
					{ value : '0', name : 'Female'},{ value : '1', name : 'Male'}
				]
			}
		};
	},
	oninit : function () {


		var preferredMobile = this.get('user.preferredMobile');
		var preferredMobileCountryCode = '';

		if (preferredMobile) {
			var preferredMobileSplit = preferredMobile.split('-');
			preferredMobileCountryCode = preferredMobileSplit[0] + '-';
			preferredMobile = preferredMobileSplit[1];
		} else {
			preferredMobile = '';
		}

		this.set('user.preferredMobileCountryCode', preferredMobileCountryCode);
		this.set('user.preferredMobile', preferredMobile);

		this.set('user.initPreferredMobile', preferredMobile);

		var homeNo = this.get('user.homeNo');
		if (homeNo === 'null') {
			homeNo = '';
			this.set('user.homeNo', homeNo);
		}

		this.set('user.homeNoOriginal', homeNo);

		var homeNoCountryCode = '';

		if (homeNo) {
			var homeNoSplit = homeNo.split('-');
			homeNoCountryCode = homeNoSplit[0] + '-';
			homeNo = homeNoSplit[1];
		}

		this.set('user.homeNoCountryCode', homeNoCountryCode);
		this.set('user.homeNo', homeNo);

		var ccList = this.get('options.countryList');
		for (var i = 0; i < ccList.length; i++) {
			if (ccList[i].countryCode === homeNoCountryCode) {
				ccList[i].homeNoSelected = true;
			}
			if (ccList[i].countryCode === preferredMobileCountryCode) {
				ccList[i].preferredMobileSelected = true;
			}
		}



		var salOpt = this.get('defaultOptions.salutationOptions');
		var sal = this.get('user.salutation');
		for (var i = 0; i < salOpt.length; i++) {
			if (salOpt[i].value === sal) {
				salOpt[i].selected = true;
			}
		}
		this.set('defaultOptions.salutationOptions', salOpt);


		var nricTyOptions = this.get('defaultOptions.nricTyOptions');
		var nricTy = this.get('user.nricTy');
		for (var i = 0; i < nricTyOptions.length; i++) {
			if (nricTyOptions[i].value === nricTy) {
				nricTyOptions[i].selected = true;
			}
		}
		this.set('defaultOptions.nricTyOptions', nricTyOptions);
		var d = new Date();
		var currentYear = d.getFullYear();
		var yearOptions = [];

		for (var i = 0; i < 105; i++) {
			var selected = ((currentYear - i) === parseInt(this.get('user.dateOfBirth.year')));
			yearOptions.push({
				value : (currentYear - i),
				selected : selected
			});
		}
		this.set('defaultOptions.yearOptions', yearOptions);

		var monthOptions = this.get('defaultOptions.monthOptions');
		var month = this.get('user.dateOfBirth.year');
		for (var i = 0; i < monthOptions.length; i++) {
			if (monthOptions[i].value === month) {
				monthOptions[i].selected = true;
			}
		}
		this.set('defaultOptions.monthOptions', monthOptions);

		var dayOptions = [];

		for (var i = 0; i < 31; i++) {
			var selected = ((i + 1) === parseInt(this.get('user.dateOfBirth.day')));
			dayOptions.push({
				value : (i + 1),
				selected : selected
			});
		}
		this.set('defaultOptions.dayOptions', dayOptions);

		var genderOptions = this.get('defaultOptions.genderOptions');
		var gender = this.get('user.gender');
		for (var i = 0; i < genderOptions.length; i++) {
			if (genderOptions[i].value === gender) {
				genderOptions[i].selected = true;
			}
		}
		this.set('defaultOptions.genderOptions', genderOptions);

		var warningMessageDisplay = '';
		if (!(this.get('callbackURL'))) {
			warningMessageDisplay = warningMessageDisplay + ' Missing callbackURL.';
		}
		if (!(this.get('portalTy'))) {
			warningMessageDisplay = warningMessageDisplay + ' Missing portalTy.';
		}

		this.set('warningMessageDisplay', warningMessageDisplay);
	},
	cancelAction : function () {
		if (this.get('callbackURL')) {
			window.location.href = this.get('callbackURL');
		}
		return true;
	},
	validGenderAndSalutationFail : function (ractive) {
		var salutationOptions = ractive.get('defaultOptions.salutationOptions');
		for (var i = 0; i < salutationOptions.length; i++) {
			if (salutationOptions[i].value === ractive.get('user.salutation')) {
				if (salutationOptions[i].gender.indexOf(ractive.get('user.gender')) > -1) {
					return false;
				} else {
					return true;
				}
			}
		}
	},
	validFormBirthdayFail : function (ractive) {
		var day = parseInt(ractive.get('user.dateOfBirth.day'));
		var month = parseInt(ractive.get('user.dateOfBirth.month'));
		var year = parseInt(ractive.get('user.dateOfBirth.year'));
		var date = new Date(year, month - 1, day);
		if (date.getFullYear() === year && date.getMonth() + 1 === month && date.getDate() === day) {
			return false;
		} else {
			return true;
		}
	},
	validNumberFail : function (number) {
		if (!isNaN(parseFloat(number)) && isFinite(number)) {
			return false;
		}
		return true;
	},
	validNickName : function (value) {
		var reg = /^[a-zA-Z\s]+$/;
		if (!reg.test(value)) {
			return false;
		} else {
			return true;
		}
	},
	validForm : function (ractive) {
		var lastNameClass = '';
		var givenNameClass = '';
		var genderAndSalutationClass = '';
		var birthdayClass = '';
		var emailClass = '';
		var mobileClass = '';
		var homeNoClass = '';

		var warningMessageDisplay = '';
		var displayNickNameOnly = ractive.get('displayNickNameOnly');


		if (ractive.validGenderAndSalutationFail(ractive)) {
			genderAndSalutationClass = 'warningInput';
			warningMessageDisplay = 'Please ensure salutation and gender are matching.';
		} else if (ractive.get('user.givenName') === '') {
			givenNameClass = 'warningInput';
			warningMessageDisplay = 'Please enter your Nick Name.';
		} else if (!ractive.validNickName(ractive.get('user.givenName'))) {
			givenNameClass = 'warningInput';
			warningMessageDisplay = 'Invalid characters.';
		} else if (ractive.get('user.lastName') === '') {
			lastNameClass = 'warningInput';
			warningMessageDisplay = 'Please enter your Last Name.';
		} else if (ractive.get('user.lastName') === '') {
			lastNameClass = 'warningInput';
			warningMessageDisplay = 'Please enter your Last Name.';
		} else if (ractive.get('user.lastName') === '') {
			lastNameClass = 'warningInput';
			warningMessageDisplay = 'Please enter your Last Name.';
		} else if (ractive.validFormBirthdayFail(ractive)) {
			birthdayClass = 'warningInput';
			warningMessageDisplay = 'Birthday is not correct.';
		} else if (ractive.get('user.initPreferredMobile') !== '' &&
					ractive.validNumberFail(ractive.get('user.preferredMobile'))) {
			mobileClass = 'warningInput';
			warningMessageDisplay = 'Mobile is Invalid';
		} else if (ractive.get('user.homeNoOriginal') !== '' &&
					ractive.get('user.homeNoOriginal') !== null &&
					ractive.validNumberFail(ractive.get('user.homeNo'))) {
			homeNoClass = 'warningInput';
			warningMessageDisplay = 'Home Phone is Invalid';
		}

		ractive.set('birthdayClass', birthdayClass);
		ractive.set('warningMessageDisplay', warningMessageDisplay);
		ractive.set('lastNameClass', lastNameClass);
		ractive.set('givenNameClass', givenNameClass);
		ractive.set('emailClass', emailClass);
		ractive.set('mobileClass', mobileClass);
		ractive.set('homeNoClass', homeNoClass);

		console.log('warningMessageDisplay ' + warningMessageDisplay);
		if (warningMessageDisplay) {
			if (givenNameClass === '' && displayNickNameOnly) {
				ractive.set('displayNickNameOnly', false);
			}
			return false;
		} else {
			return true;
		}
	},
	doSubmitAction: function (event) {
		event.original.preventDefault();

		var self = this;

		if (self.validForm(self)) {
		
			self = this;

			var preferredMobileCountryCode = self.get('user.preferredMobileCountryCode');
			var preferredMobile = self.get('user.preferredMobile');
			var preferredMobileSubmit = preferredMobileCountryCode + preferredMobile;
			self.set('user.preferredMobileSubmit', preferredMobileSubmit);

			var homeNoCountryCode = self.get('user.homeNoCountryCode');
			var homeNo = self.get('user.homeNo');
			var homeNoSubmit = homeNoCountryCode + homeNo;
			self.set('user.homeNoSubmit', homeNoSubmit);

			var day = self.get('user.dateOfBirth.day');
			var month = self.get('user.dateOfBirth.month');
			var year = self.get('user.dateOfBirth.year');
			day = ('0' + day).slice(-2);
			month = ('0' + month).slice(-2);
			self.set('user.dateOfBirth.birthday', day + '-' + month + '-' + year);

		} else {
			console.log('Validation failed');
			return ;
		}

		event.node.submit();
	}

});

Ractive.components["ux-singtel-product-channels"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-product-channels'],
	oninit: function () {
		this.channelList = this.get('channelList');
		this.channelLimit = this.get('channelLimit');
		this.totalChannels = this.channelList.length;

		this.set('totalChannels', this.totalChannels);
		this.set('summaryChannelList', this.channelList.slice(0, this.channelLimit));
	},
	onrender: function () {
		var self = this;
		self.on('selectChannel', function (event, idx) {
		
		
			this.toggle(event.keypath + '.flipState');
		});
		self.on('*.doOpenModal', function (event, modalId) {
			self.updateModalState(modalId, true);
		});
	},
	updateModalState: function (modalId, state) {
		var modals = this.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];
		modal.set('displayState', state);
		modal.off('selectChannel');
		modal.on('selectChannel', function (event, idx) {
		
		
			this.toggle(event.keypath + '.flipState');
		});
	}

});


Ractive.components["ux-singtel-product-info"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-product-info'],
	onrender: function () {
		var onepayId = RactiveHelpers.getParameterByName('id');
		var gatewayReference = RactiveHelpers.getParameterByName('gateway_reference');
		var paymentProvider = RactiveHelpers.getParameterByName('payment_provider_id');
		var amount = RactiveHelpers.getParameterByName('amount');

		var failureReason = RactiveHelpers.getParameterByName('failure_reason');
		var failureMessage = RactiveHelpers.getParameterByName('failure_message');

		if (failureReason !== '' && failureMessage !== '') {
			this.set('showErrorTransaction', true);
			this.set('failureMessage', failureMessage);

		} else if (onepayId !== '' && gatewayReference !== '' &&
					paymentProvider !== '' && amount !== '') {
			this.set('showSuccessfulTransaction', true);
		}

		this.observe('selectedQty', function () {
		

			var price = this.get('price');
			var qty = this.get('selectedQty');
			var totalPrice = price * qty;

			var pmodal = {
				width: '700',
				class: 'no-padding',
				height: '920',
				heightPercentage: '90',
				hideTitle: 'true',
				containerClass: 'modal-signup',
				qty: this.get('selectedQty'),
				price: totalPrice
			};
			this.set('pmodalData', pmodal);
		});
	},
	oninit: function () {
		var qty = this.get('qtyLimit');

		if (qty) {
			this.set('quantityOptions', this.getMaxQuantity(qty));
			this.set('selectedQty', 1);
		}
	},
	getMaxQuantity: function (qty) {
		var options = [];
		for (var i = 1; i <= qty; i++) {
			var o = {};
			o.title = i;
			o.value = i;
			options.push(o);
		}
		return options;
	},
	ajaxCallApi: function (apiEndpoint, method, userInput, customHeaders) {
		var methodType = method === '' ? 'GET' : method,
			def = $.Deferred(),
			userInput = userInput ? userInput : {},
			customHeaders = customHeaders ? customHeaders : {};

		if (methodType === 'POST') {
			customHeaders['Content-Type'] = 'application/x-www-form-urlencoded';
		} else if (methodType === 'POST-JSON') {
			methodType = 'POST';
			customHeaders['Content-Type'] = 'application/json';
		} else if (methodType === 'PUT') {
			methodType = 'PUT';
			customHeaders['Content-Type'] = 'application/json';
		}

		return $.ajax({
			type: methodType,
			cache: false,
			url: apiEndpoint,
			crossDomain: true,
		
			data: userInput,
			headers: customHeaders,
			success: function (response, textStatus, xhr) {
				def.resolve(response, textStatus, xhr);
			},
			error: function (xhr, status, errorThrownx) {
				console.log('Unable to process request. Please try again.');
			}
		});
	}
});

Ractive.components["ux-singtel-product-list"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-product-list'],
	onrender: function () {
	}
});

Ractive.components["ux-singtel-product"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-product'],
	onconfig : function () {
		this.set('RactiveHelpers', RactiveHelpers);
	},
	onrender : function () {
	}
});

Ractive.components["ux-singtel-store-appointment"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-store-appointment'],

	onrender: function () {
		this.showQNomyCalendar();
	},
	getCustomerIdType : function (customerIdType) {
		var customerType = '1';
		switch (customerIdType) {
			case 'National Registration ID Card (NRIC)':
				customerType = '1';
				break;
			case 'Foreign Identification Number':
				customerType = '6';
				break;
			case 'Foreigner Dependent Pass':
				customerType = '5';
				break;
			case 'Foreigner Employment Pass':
				customerType = '15';
				break;
			case 'Foreigner S Pass':
				customerType = '7';
				break;
			case 'Foreigner Student Pass':
				customerType = '9';
				break;
			case 'Passport Number':
				customerType = '3';
				break;
			case 'Foreigner Social Visit Pass':
				customerType = '8';
				break;
			case 'Foreigner Work Permit':
				customerType = '10';
				break;
		}
		return customerType;
	},

	showQNomyCalendar: function () {
		var qNomyIframe = document.getElementById('quonomyFrame');
		var againDisplay;
		var self = this;
		if (typeof qNomyIframe === 'undefined' || qNomyIframe === null) {
			var qNomyIframe = document.createElement('iframe');
			qNomyIframe.setAttribute('id', 'quonomyFrame');
			againDisplay = 0;
		}
		var appointmentTypeIdMap = this.get('initData.qnomyServicesMap');
		var appointmentTypeIdMap = this.get('initData.qnomyServicesMap');
		var appointmentType = this.get('initData.appointmentType');
		var appointmentTypeId = this.get('initData.appointmentTypeId') || appointmentTypeIdMap.newMobilePostpaid;
		var regionId = this.get('initData.regionId');
	
		var storeId = this.get('initData.storeId');
		var isCareFlow = this.get('initData.careFlowFlag');
		var serviceId = this.get('initData.serviceId') || 3;
		var serviceTypeId = this.get('initData.serviceTypeId');
		var currentAppointmentId = this.get('initData.currentAppointmentId');
		var authorComments = this.get('initData.authorComments');

		var url = this.get('initData.qnomyIframeUrl') +
			'StoreId=' + storeId +
			'&ServiceId=' + serviceId + '&serviceTypeId=' + serviceTypeId +
			'&AppointmentTypeId=' + appointmentTypeId;
		var userInfo = this.get('userContext.userInfo');
		var onepassInfo = this.get('onepassInfo');
		var customerIdType = onepassInfo.customerIdType || 1;
		var customerType = self.getCustomerIdType(customerIdType);
		var emailId = this.get('initData.customerEmailId') || onepassInfo.email;
	
		var qNomyParameters = {
			serviceTypeId: serviceTypeId,
			serviceId: serviceId,
			appointmentTypeId: appointmentTypeId,
			singtelQnomyFullUrl: this.get('initData.singtelQnomyFullUrl'),
			regionId: regionId,
			storeId: storeId
		};
		if (isCareFlow) {
			qNomyParameters.isCareFlow = isCareFlow;
			qNomyParameters.currentAppointmentId = currentAppointmentId;
			qNomyParameters.customerIdType = customerType;
			qNomyParameters.customerId = onepassInfo.nric;
			qNomyParameters.firstName = userInfo.contactDetails.firstName;
			qNomyParameters.lastName = userInfo.contactDetails.lastName;
			qNomyParameters.fullName = userInfo.contactDetails.firstName + ' ' +
				userInfo.contactDetails.lastName;
			qNomyParameters.phoneNumber = userInfo.contactDetails.phone;
			qNomyParameters.email = emailId;
		}

		qNomyIframe.src = url;
		qNomyIframe.style.borderWidth = 0;
		qNomyIframe.style.overflow = 'hidden';
		qNomyIframe.style.width = '100%';
		qNomyIframe.style.height = '100%';
		qNomyIframe.style['min-height'] = '650px';
		qNomyIframe.scrolling = 'yes';

		qNomyIframe.addEventListener('load', function (e) {

			var injectedScript = document.createElement('script');
			injectedScript.type = 'text/javascript';
			injectedScript.innerHTML = 'try{$("body").delegate(".selTime", "click",function(){' +
				'window.parent.window.postMessage("selectedDate:="+$(this).data("fulldate"),"*");});}' +
				'catch(e){console.log("Something went wrong : ", e);}' +
				' try{var cancelBtn = document.getElementsByClassName("col-md-2  col-xs-8");' +
				' if(cancelBtn && cancelBtn.length > 0 ){ cancelBtn[0].style.display = "none";}}' +
				'catch(e){console.log("Something went wrong : ", e);} ' +
				RactiveHelpers.getQNomyScriptToInject(userInfo, onepassInfo,
						customerType, appointmentType, emailId, isCareFlow, authorComments) +
				' var appointmentCheck = function() { ' +
				' var appointmentBooked = false; ' +
				' $("label").each(function() { ' +
				' if ($(this).text() === "Reservation Number") { ' +
				' appointmentBooked = true; ' +
				' } ' +
				' }); ' +
				' if (appointmentBooked) { ' +
				' var myarray = $("span"); ' +
				' if (myarray.length > 3) { ' +
				' window.parent.window.postMessage("selectedAppointment:="+$(myarray[3]).text(),"*"); ' +
				' } ' +
				' } ' +
				' }; appointmentCheck ();';

		
			qNomyIframe.contentDocument.body.appendChild(injectedScript);

			var injectedStyle = document.createElement('style');
			injectedStyle.type = 'text/css';
			injectedStyle.innerHTML = 'section.content-wrapper.main-content > div:first-child{display: none;}' +
				'.row.margin-top-10.hidden-xs{display: none;}' +
				'#current-selection-container{display: none !important;}' +
				'body,table{background-color: #ffffff;}' +
				'.wizard-border2{border:none;}';
			if (againDisplay === 0) {
				injectedStyle.innerHTML = injectedStyle.innerHTML + 'form > div:first-child{display: none;}';
				againDisplay = 1;
			}
		
			qNomyIframe.contentDocument.head.appendChild(injectedStyle);
		}, false);

		document.getElementsByClassName('qNomyIframeContainer')[0].appendChild(qNomyIframe);

		window.addEventListener('message', function (e) {
			var data = e.data.split(':=');
			if (data[0] === 'selectedDate') {
				var fullDate = data[1];
				this.set('initData.singtelStoreAppointment', fullDate);
			} else if (data[0] === 'selectedAppointment') {
				var selectedAppointment = data[1];
				this.set('initData.selectedAppointment', selectedAppointment);
				var appointmentBooked = {
					appointmentDate: this.get('initData.singtelStoreAppointment'),
					appointmentID: selectedAppointment
				};
				this.fire('singtelAppointmentSelected', appointmentBooked);
			}
		}.bind(this), false);
	}
});

Ractive.components["ux-singtel-support-share"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-support-share'],
	isolated: false,
	data: function () {
		return {
			textareaValue: '',
			currentPageUrl: '',
			formName: 'emailUs',
			multipleTitle: 'please use comma for multiple email',
			formSubmissionMsg: '',
			multipleEmail: '',
			userEmail: '',
			display: '',
			disable: 'disable',
			placeholderresEmailCaption: 'eg: admin@singtel.com,user@gmail.com',
			placeholdersenderEmailCaption: 'please enter your email@email.com',
			placeholdertextarea: 'Comments/Questions',
			callToAction: '/bin/services/webformsubmission'
		};
	},
	oninit: function () {
		var self = this;
		self.on('mailTofunction', function () {
			self.set('modal.padding', 50);
			self.set('modal.widthPercentage', 50);
			self.set('modal.top', 50);
			self.set('modal.class', 'light-theme');
			self.set('modal.displayState', true);
		});
	},
	onrender: function () {
		var self = this;
		var ajaxcall;
		var postValue = {};
		self.on('*.shareUsEmail', function (event) {
			var multifieldEmailValue = self.get('multipleEmail');
			var userEmailValue = self.get('userEmail');
			var textareaValue = self.get('textareaValue');
			var currentPageUrl = window.location.href;
			postValue.formName = this.get('formName');
			postValue.webform_multipleEmail = multifieldEmailValue;
			postValue.webform_userEmail = userEmailValue;
			postValue.webform_textareaValue = textareaValue;
			postValue.webform_currentPageUrl = currentPageUrl;

			ajaxcall = $.ajax({
				url: self.get('callToAction'),
				data: postValue,
				type: 'post'
			});
			if (postValue.webform_multipleEmail && postValue.webform_userEmail !== '') {
				ajaxcall.done(function (response) {
					if (response.response !== 'success' && response.error !== '') {
						self.set('formSubmissionMsg', self.get('failedMsg'));
						self.set('validationClass', 'error');
						self.set('display', 'none');
					} else {
						self.set('formSubmissionMsg', self.get('successMsg'));
						self.set('validationClass', 'success');
						self.set('display', 'none');
						window.location.replace(currentPageUrl);
					}
				});

				ajaxcall.fail(function () {
					self.set('formSubmissionMsg', self.get('failedMsg'));
					self.set('display', 'none');
					self.set('validationClass', '');
				});
			} else {
				self.set('validationClass', 'error');
				self.set('disable', 'disabled');
				self.set('display', 'block');
				return false;
			}
		});
		self.on('facebookLink', function () {
			var currentPage_url = window.location.href;
			self.set('currentPage_url', currentPage_url);
		});
		self.on('twitterShare', function () {
			var shareUrl = window.location.href;
			self.set ('sharingUrl', shareUrl);
		});
		self.on('linkedInshare', function () {
			var linkedInshare = window.location.href;
			self.set ('linkedInUrl', linkedInshare);
		});
		self.on('googleShare', function () {
			var googleShare = window.location.href;
			var encodeUrlgoole = encodeURIComponent(googleShare);
			self.set ('googleUrl', encodeUrlgoole);
		});
		self.on('*.inputHandler', function () {
			self.set('disable', '');
		});
		self.on('*.doCloseModal doCloseModal', function () {
			self.resetForm();
		});
	},
	resetForm: function () {
		var self = this;
		self.set('multipleEmail', '');
		self.set('userEmail', '');
		self.set('textareaValue', '');
	}
});

Ractive.components["ux-singtel-tv-go"] = Ractive.extend({
	template: LUXComponentTemplates['ux-singtel-tv-go'],
	onconfig : function () {
		this.set('RactiveHelpers', RactiveHelpers);
	},
	onrender : function () {

		var self = this;

		self.on('*.selectplan', function (event) {
			window.location.href = RactiveHelpers.modifyConfigUrl(ConfigStrings.pageUrls.manageAddOns);
		});
	}
});

Ractive.components["ux-snackbar"] = Ractive.extend({
	template: LUXComponentTemplates['ux-snackbar'],
	isolated: false,

	data: function () {
		return {
			showSnackbar: false,
			message: 'Item removed from cart',
			animationTime: 5000
		};
	},
	oninit: function () {
		var self = this;
		self.on('doOpenSnackbar', function (event,content) {
			this.displaySnackbar();
		});
		self.on('closeSnackbar', function (event,content) {
			this.hideSnackbar();
		});
	},
	displaySnackbar: function () {
		var self = this;
		this.set('showSnackbar', true);
		var snackBar = document.getElementById('snackBar');
		snackBar.classList.add('show-snackbar');
		setTimeout(function () {
			self.hideSnackbar();
		}, self.get('animationTime'));
	},
	hideSnackbar: function () {
		var self = this;
		var snackBar = document.getElementById('snackBar');
		if (snackBar) {
			snackBar.classList.remove('show-snackbar');
			snackBar.classList.add('hide-snackbar');
		}
		setTimeout(function () {
			self.set('showSnackbar', false);
		}, 1400);
		this.fire('onSnackbarClose');
	}
});

Ractive.components["ux-social-share"] = Ractive.extend({
	template: LUXComponentTemplates['ux-social-share']
});

Ractive.components["ux-spinner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-spinner'],
	isolated: true,
	data: function () {
		return {
			size: 41
		};
	}
});

Ractive.components["ux-spring-nav"] = Ractive.extend({
	template: LUXComponentTemplates['ux-spring-nav'],
	oncomplete: function () {

		this.on('*.showdiv', function (event, elemId) {

			event.original.preventDefault();
			console.log('elemId', elemId);
			console.log(this);

			this.findAllComponents('ux-nav-item').map(function (cmp) {

				var showItem = (elemId === cmp.get('navid'));
				console.log('showItem', showItem);
				cmp.set('showItem', showItem);

			});

		
			var currentNavClass = event.node.offsetParent.getAttribute('class');
			currentNavClass = currentNavClass + ' isActive';
			event.node.offsetParent.setAttribute('class', currentNavClass);

			return false;
		});

	}

});

Ractive.components["ux-stepper-panel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-stepper-panel']
});

Ractive.components["ux-stock-availability"] = Ractive.extend({
	template: LUXComponentTemplates['ux-stock-availability'],

	data: function () {
		return {
			startDisplay: false,
			ConfigStrings: ConfigStrings
		};
	},

	onrender: function () {
		var self = this;
		var mobileGroups = self.get('mobileGroups');
		var modelList = [];
		_.each(mobileGroups, function (item) {
			modelList.push({
				value: item,
				text: item
			});
		});
		self.set('modelsList', modelList);
		self.set('selectedModel', modelList[0].value);
		this.fetchModelStock(modelList[0].value);

		self.on('ux-anchor.toggleThresholdModal', function (event, sku) {
			self.set('modalDate', this.get('displayDate'));
			var item = event.get('stockInfo');
			self.set('stockDetails', item);
			self.setModalDisplayState('thresholdModal', true, item);
		});

		this.on('*.onModelChange', function (event) {
			this.fetchModelStock(event);
		});

		this.on('*.onCapacityChange', function (event) {
			var selectedModel = this.get('selectedModel');
			if (selectedModel) {
				this.filterDataObj(selectedModel, event);
			}
		});

	},

	fetchModelStock: function (mobileGroups) {
		var self = this;
		self.set('startDisplay', false);
		self.set('genericMessageDisplay', null);
		self.set('inProcess', true);
		var initMobileGroups = self.get('mobileGroups');
		var url = '/bin/services/singtel/getStockData.:groupId=' + initMobileGroups.join('_') + '.json';
		RactiveHelpers.doAjaxJSONCall('GET', url, function (response) {
			if (response) {
				self.set('inProcess', false);
				var selectedModel = self.get('selectedModel');
				var filteredModelObj = _.find(response, function (item) {
					return item.groupId === selectedModel;
				});
				self.set('filteredModelObj', filteredModelObj);
				self.filterDataObj(selectedModel);
				self.set('startDisplay', true);
			}
		},
		function (error) {
		
		
			console.log(error);
			self.set('inProcess', false);
			self.set('genericMessageDisplay', ConfigStrings.genericError.stockAvailabilityRestError);
		});
	},

	setModalDisplayState: function (modalId, state, item) {
		var modals = this.findAllComponents('ux-modal');
		var modal = _.find(modals, function (component) {
			return modalId === component.get('modalId');
		});
		if (modal) {
			modal.set('displayState', state);
		}
	},

	filterDataObj: function (selectedModel, capacity) {
		var filteredModelObj = this.get('filteredModelObj');
		var displayDate;
		var displayDateValue;
		var phoneStockHeaders = [];
		var sizeHeaders = [];
		var singtelShop = this.get('singtelShop');
		var businessShop = this.get('businessShop');
		_.each(filteredModelObj.items, function (item) {
			if (item.description) {
				var phone = {
					color: item.description.color,
					hexCode: item.description.hexCode,
					capacity: item.description.size,
					description: item.description.title,
					sku: item.skuId,
					size: Number(item.description.size.replace(/GB|TB/, '')),
					unit: item.description.size.match(/GB|TB/)[0]
				};
				var isDuplicate = _.some(sizeHeaders, function (item) {
					return _.isEqual(item, {size: phone.size, unit: phone.unit});
				});
				if (!isDuplicate) {
					sizeHeaders.push({size: phone.size, unit: phone.unit});
				}
				if (item.data && item.data.length > 0) {
					var stockInfo = [];
					var sersStockInfo = [];
					var singtelShopDetail;
					var businessShopDetail;
					var finalStockInfo = [];
					_.each(item.data, function (stock) {
						if (displayDate) {
							var d2 = new Date(stock.extraction_date);
							if (d2 > displayDate) {
								displayDate = d2;
								displayDateValue = stock.extraction_date;
							}
						} else {
							displayDate = new Date(stock.extraction_date);
							displayDateValue = stock.extraction_date;
						}
						if (stock.stock_status !== 'Not Available') {
							if (singtelShop && stock.shop && singtelShop.storeId === stock.shop.mtposId) {
								stock.eshop = singtelShop;
								singtelShopDetail = stock;
							} else if (businessShop && stock.shop && businessShop.storeId === stock.shop.mtposId) {
								stock.eshop = businessShop;
								businessShopDetail = stock;
							} else if (stock.shop && stock.shop.shopType === 'SERS') {
								sersStockInfo.push(stock);
							} else if (stock.shop && stock.shop.shopType === 'SHOP') {
								if (stock.dealer === 'EASIPOS') {
									stockInfo.push(stock);
								}
							}
						}
					});
					if (singtelShopDetail) {
						finalStockInfo.push(singtelShopDetail);
					}
					if (businessShopDetail) {
						finalStockInfo.push(businessShopDetail);
					}
					stockInfo = _.sortBy(stockInfo, function (stock) {
						return (stock.shop ? stock.shop.name : '');
					});
					sersStockInfo = _.sortBy(sersStockInfo, function (stock) {
						return (stock.shop ? stock.shop.name : '');
					});
					finalStockInfo = finalStockInfo.concat(stockInfo).concat(sersStockInfo);
					phone.stockInfo = finalStockInfo;
				}
				phoneStockHeaders.push(phone);
			}
		});
		displayDate = moment(displayDateValue).format('dddd, Do MMMM YYYY, h:mm:ss a');
		this.set('displayDate', displayDate);
		phoneStockHeaders =  _.sortBy(phoneStockHeaders, function (phoneStockHeader) {
			return phoneStockHeader.size;
		});
		var phoneStockHeadersGroup = _.groupBy(phoneStockHeaders, function (phoneStockHeader) {
			return [phoneStockHeader.color, phoneStockHeader.hexCode].join('_');
		});
		var finalStockHeaders = [];
		sizeHeaders =  _.sortBy(sizeHeaders, function (sizeheader) {
			return sizeheader.size;
		});
		_.map(phoneStockHeadersGroup, function (skuDetails, key) {
			var colorHexCodeDetails = key.split('_');
			var finalSkuDetails = [];
			if (sizeHeaders.length !== skuDetails.length) {
				_.each(sizeHeaders, function (sizeHeader) {
					var flag = _.find(skuDetails, function (skuDetail) {
						return skuDetail.size === sizeHeader.size;
					});
					if (flag) {
						finalSkuDetails.push(flag);
					} else {
						finalSkuDetails.push({});
					}
				});
			}  else {
				finalSkuDetails = skuDetails;
			}
			finalStockHeaders.push({
				color: colorHexCodeDetails[0],
				hexCode: colorHexCodeDetails[1],
				phoneStockHeaders: finalSkuDetails
			});
		});
		this.set('finalStockHeaders', finalStockHeaders);
		var capacityList = [];
		_.each(sizeHeaders, function (sizeHeader) {
			capacityList.push({
				title: sizeHeader.size + ' ' + sizeHeader.unit,
				value: sizeHeader.size
			});
		});
		this.set('capacityList', capacityList);
		if (typeof capacity === 'undefined' || capacity === null) {
			capacity = capacityList[0].value;
		}
		phoneStockHeaders = _.filter(phoneStockHeaders, function (phoneStockHeader) {
			return phoneStockHeader.size === capacity;
		});
		this.set('selectedCapacty', capacity);
		this.set('mobilePhoneStockHeaders', phoneStockHeaders);
	}
});

Ractive.components["ux-sub-addon"] = Ractive.extend({
	template: LUXComponentTemplates['ux-sub-addon'],
	isolated: true,

	data : function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	}
});

Ractive.components["ux-summary-accordion"] = Ractive.extend({
	template: LUXComponentTemplates['ux-summary-accordion'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			ConfigStrings: ConfigStrings
		};
	},
	onrender: function (argument) {
		this.on('ux-anchor.showTradeinModal', function (event, index) {
			var order = this.get('order');
			this.parent.set('tradeInOrderItemId', order.mobile[index].productOrderItemID);
			this.handleModal('tradeInModal', true);
			return false;
		});
		this.on('ux-anchor.removeTradein', function (event, index) {
			var order = this.get('order');

			this.fire('doRemoveTradein', order.mobile[index].tradeIn);
		});

		this.on('ux-anchor.removeMultiCartItem', function (event, index) {
			var order = event.get('item.data');
			this.fire('doRemoveMultiCart', order, this);
			return false;
		});
		this.observe('tradeInOrderItemId', function (value) {
			if (value) {
				this.parent.set('tradeInOrderItemId', value);
			}
		});
	},
	handleModal: function (modalId, visibility) {
		var modals = this.findAllComponents('ux-modal');
		var modalDetails = modals.filter(function (component) {
			return modalId === component.get('modalId');
		});
		_.each(modalDetails, function (modalDetail) {
			modalDetail.set('displayState', visibility);
		});
	}
});

Ractive.components["ux-summary-mobile-view"] = Ractive.extend({
	template: LUXComponentTemplates['ux-summary-mobile-view'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			ConfigStrings: ConfigStrings
		};
	},
	onrender: function () {
		var self = this;

		self.on('*.showSummaryRowDetails', function (event, modalId) {
			self.handleModal(modalId);
		});

		self.on('ux-anchor.showTradeinModal', function (event, index) {
			var order = this.get('order');
			this.parent.set('tradeInOrderItemId', order.mobile[index].productOrderItemID);
			self.handleModal('tradeInModal', true);
			return false;
		});
		self.on('ux-anchor.removeTradein', function (event, index) {
			var order = this.get('order');

			self.fire('doRemoveTradein', order.mobile[index].tradeIn);
		});

		self.on('ux-anchor.removeMultiCartItem', function (event, index) {
			var order = event.get('item.data');
			self.fire('doRemoveMultiCart', order);
		});

		self.on('showTooltip', function (event) {

			if (event.original.currentTarget.nextElementSibling.style.display !== 'block') {
				_.each(document.getElementsByClassName('tooltip'), function (v) {
					v.style.display = 'none';
				});
				event.original.currentTarget.nextElementSibling.style.display = 'block';
			} else {
				event.original.currentTarget.nextElementSibling.style.display = 'none';
			}

			return false;
		});
	},

	handleModal: function (modalId) {
		this.setModalDisplayState(modalId, true);
	},

	setModalDisplayState: function (modalId, state) {
		var modals = this.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];
		modal.set('hideVouchersModal', false);
		modal.set('displayState', state);
	}
});

Ractive.components["ux-summarydata-row"] = Ractive.extend({
	template: LUXComponentTemplates['ux-summarydata-row'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},

	oninit: function () {
		var self = this;
		var type = self.get('type');

		self.map = {

			'deviceDetails': 'Device',
			'planDetails': 'Plan',
			'mainLineDetails': 'Mainline',
			'simDetails': 'SIM Card',
			'simRegisteration': 'SIM Card Registration',
			'number': 'Number',
			'landlineNumber': 'Digital/Analog Homeline',
			'addons': 'Add-ons',
			'accessories': 'Accessories',
			'deliveryDetails': self.get('deliveryDetails.deliveryType'),
			'broadBandPlanDetails': 'Fibre Broadband Plan',
			'premiumAddons': 'Premium Addons',
			'netlinkInstallationCharges': 'Netlink Installation Charges',
			'fibreInstallationCharges': 'Singtel Installation Charges',
			'discountInstallationCharges': 'Installation Charge (Weekday/Weekend)',
			'topup': 'Top-up',
			'installationCharges': 'Installation Charges',
			'promotions': 'Promotions',
			'freeGifts': 'Free Gifts',
		
			'staffDiscount': 'Staff Discount',
			'penalityFees': 'Plan Downgrade Penalty',
			'cisDiscount': 'CIS Discount',
			'specialDiscounts': 'Special Discounts',
			'repaymentChanges': 'Early Device Upgrade Fee',
			'serviceContractPenalty': 'Service Contract Penalty',
			'mobileContents': 'Mobile Contents',
			'appleCare': 'Apple Care',
			'tvContentPackDetails': 'Singtel TV',
			'tvPenalityFees': 'Penalty',
			'ippCharges': 'Device Instalment Plan',
			'ippChargesPenalty': 'Early Device Upgrade Fee',
			'mbb_number': 'SIM Card Number',
			'fhb_premiumAddons': self.get('premiumHeader') || 'Product Instalment Plan (0% interest, 24-month)',
			'silverDiscount': 'Silver Discount',
			'subscription': 'Plan'
		
		};

		self.rowdata = '';
		self.oneTimePWT = '';
		self.recurringPWT = '';
		self.checkoutPWT = '';
		self.removeLinkTemplate = '<a href="#" class="left change-link">Remove</a>';
		self.set('changeState', 'hide');
		self.set('addMoreState', 'hide');
		self.set('removeState', 'hide');
		self.set('itemRemoveState', 'hide');

		self.setRowData(type);
		self.setRowTitle(type);
		self.setRowLabel(type);

	},

	onrender: function (argument) {
		var self = this;
		self.update();
		self.on('*.changeCartItem', function () {
			var mapType = self.get('type');
			if (typeof mapType !== 'undefined' && mapType !== 'serviceDetails') {
				self.fire('onChangeCartItem', self.get('type'), self.get());
			} else {
				var name = self.get('serviceName');
				if (name === 'Land Line') {
					self.fire('onChangeCartItem', 'landlineNumber', self.get());
				} else {
					self.fire('onChangeCartItem', 'broadBandPlanDetails', self.get());
				}
			}
		});
		self.on('*.addCartItem', function () {
			self.fire('onChangeCartItem', self.get('type'), self.get());
		});
		self.on('*.removeCartItem', function (event) {
			self.fire('onRemoveCartItem', self.get('type'), self.get(), event.get('index'));
		});
	},

	setRowTitle: function (type) {
		var self = this,
			isAddonPresent = _.find(self.detailedData, function (addon) {
			return !addon.hideDisplay;
		});
		if (self.get('isRedMembership') && type === 'addons') {
			self.set('rowTitle', self.map.subscription);
		} else {
			if ((type === 'addons' && self.detailedData.length > 0 && isAddonPresent || type !== 'addons') &&
				self.map[type] && self.map[type] !== '') {
				self.set('rowTitle', self.map[type]);
			}
			if (type === 'number' && self.get('isFreeMBB')) {
				self.set('rowTitle', self.map.mbb_number);
			}
			if (type === 'premiumAddons' && self.get('isBundle')) {
				self.set('rowTitle', self.map.fhb_premiumAddons);
			}
		}
	},

	setRowData: function (type) {
		var self = this;
		var showChange = self.get('showChange');
		if (type === 'deviceDetails') {

			self.detailedData = self.get('deviceDetails');
			self.setDeviceRowDataMultiple();
			var isRoiDevice = self.get('isRoiDevice');
			if (isRoiDevice) {
				_.each(self.detailedData, function (item) {
					item.hideRemoveLink = true;
				});
			}
			if (showChange === true && !isRoiDevice) {
				self.set('changeState', 'show');
			}
		} else if (type === 'planDetails') {
			self.detailedData = self.get('planDetails');
			self.setRowDataMultiple();
			var isRoiDevice = self.get('isRoiDevice');
			if ((typeof self.detailedData !== 'undefined' &&
				self.detailedData.length > 0 &&
				typeof self.detailedData[0].noChange === 'undefined') &&
				showChange === true && !isRoiDevice
				) {
				self.set('changeState', 'show');
			}
		} else if (type === 'mainLineDetails') {
			self.detailedData = self.get('mainLineDetails');
			self.rowdata = 'Singtel Mobile: ' + self.detailedData.singtelMobile + '<br>' + self.detailedData.planName;
			if (self.detailedData.staffPlan) {
				self.rowdata = self.rowdata + ' (Staff Plan)';
			}
			if (typeof self.detailedData.noChange === 'undefined' && showChange === true) {
				self.set('changeState', 'show');
			}
		} else if (type === 'simDetails') {
			self.detailedData = self.get('simDetails');
			self.rowdata = self.detailedData.simType;
		} else if (type === 'simRegisteration') {
			self.detailedData = self.get('simRegisteration');
			self.rowdata = self.detailedData.discountDetails;
		} else if (type === 'penalityFees') {
			self.detailedData = self.get('penalityFees');
			self.rowdata = self.detailedData.name;
		} else if (type === 'promotions') {
			self.detailedData = self.get('promotions');
			self.setRowDataMultiple();
			self.rowdata = self.detailedData.promotionName;
		} else if (type === 'ippCharges') {
			var contractFilter = self.get('contractFilter');
			self.detailedData = self.get('ippCharges');
			self.rowdata = self.detailedData.title;
			if (!self.get('hideContractFilter') && self.detailedData.numberOfInstallment &&
				self.detailedData.numberOfInstallment !== '' &&
				contractFilter && contractFilter.length > 0) {
				self.rowdata = self.detailedData.numberOfInstallment;
			}
		} else if (type === 'ippChargesPenalty') {
			self.detailedData = self.get('ippChargesPenalty');
			self.rowdata = self.detailedData.title;
		} else if (type === 'freeGifts') {
			self.detailedData = self.get('freeGifts');
			self.setRowDataMultiple();
			self.rowdata = self.detailedData.promotionName;
		} else if (type === 'premiumAddons') {
			self.detailedData = self.get('premiumAddons');
			self.setRowDataMultiple();
			self.rowdata = self.detailedData.premiumAddonsName;
			if (self.detailedData && self.detailedData.length > 0) {
				var singleWifiMesh = _.find(self.detailedData,
					function (item) {
					return item.name &&
						item.name.toUpperCase().indexOf('SINGLE') > -1;
				});
				if (singleWifiMesh) {
					_.each(self.detailedData, function (item) {
						if (item.name &&
							item.name.toUpperCase().indexOf('TWIN') > -1) {
							item.hideRemoveLink = true;
						} else {
							item.hideRemoveLink = false;
						}
					});
				}
			}
			if (showChange === true) {
			
				self.set('removeState', 'show');
				self.set('addMoreState', 'show');
			}
		} else if (type === 'staffDiscount') {
			self.detailedData = self.get('staffDiscount');
			self.setRowDataMultiple();
			self.rowdata = self.detailedData.name;
		} else if (type === 'silverDiscount') {
			self.detailedData = self.get('silverDiscount');
			self.setRowDataMultiple();
			self.rowdata = self.detailedData.name;
		} else if (type === 'repaymentChanges') {
			self.detailedData = self.get('repaymentChanges');
			self.setRowDataMultiple();
			self.rowdata = self.detailedData.name;
		} else if (type === 'cisDiscount') {
			self.detailedData = self.get('cisDiscount');
			self.setRowDataMultiple();
			self.rowdata = self.detailedData.name;
		} else if (type === 'specialDiscounts') {
			self.detailedData = self.get('specialDiscounts');
			self.setRowDataMultiple();
			self.rowdata = self.detailedData.name;
		} else if (type === 'serviceContractPenalty') {
			self.detailedData = self.get('serviceContractPenalty');
			self.setRowDataMultiple();
			self.rowdata = self.detailedData.name;
		} else if (type === 'number') {
			self.detailedData = self.get('number');
			self.rowdata = self.detailedData.details;
			if (typeof self.detailedData.noChange === 'undefined' &&
				showChange === true) {
				self.set('changeState', 'show');
			}
		} else if (type === 'landlineNumber') {
			self.detailedData = self.get('landlineNumber');
			self.rowdata = self.detailedData.details;
			if (typeof self.detailedData.noChange === 'undefined' &&
				showChange === true) {
				self.set('changeState', 'show');
			}
		} else if (type === 'addons') {
			self.detailedData = self.get('addons');
			self.setRowDataMultiple(showChange);
			if (showChange === true) {
				self.set('addMoreState', 'show');
			}
		} else if (type === 'mobileContents') {
			self.detailedData = self.get('mobileContents');
			var atomicsVasSpsIds = this.get('spsIds');
			self.setRowDataMultiple(showChange);
			if (showChange === true) {
				self.set('addMoreState', 'show');
			}
			if (atomicsVasSpsIds && atomicsVasSpsIds.length) {
				_.each(self.detailedData, function (item) {
					if (_.contains(atomicsVasSpsIds, item.simpleProductSpecID)) {
						item.hideRemoveLink = true;
					}
				});
			}
		} else if (type === 'accessories') {
			self.detailedData = self.get('accessories');
			self.setRowDataMultiple();
			if (showChange === true) {
				self.set('addMoreState', 'show');
				self.set('removeState', 'show');
			}
		} else if (type === 'topup') {
			self.detailedData = self.get('topup');
			self.setRowDataMultiple();
			if (self.detailedData && self.detailedData.length > 0) {
				_.each(self.detailedData, function (item) {
					if (item.name.indexOf('Set Top Box') > -1) {
						item.id = 'stb';
					}
				});
				if (showChange === true) {
					self.set('removeState', 'show');
				}
			}
		} else if (type === 'broadBandPlanDetails') {
			self.detailedData = self.get('broadBandPlanDetails');
			self.set('rowTitle', self.detailedData.serviceName);
			self.rowdata = self.detailedData.serviceType;
			if (showChange === true) {
				self.set('changeState', 'show');
			}
		} else if (type === 'fvPlanDetails') {
			self.detailedData = self.get('');
			self.set('rowTitle', self.detailedData.serviceName);
			self.rowdata = self.detailedData.serviceType;
			if (showChange === true) {
				self.set('changeState', 'show');
			}
		} else if (type === 'tvPlanDetails') {
			self.detailedData = self.get('tvPlanDetails');
			self.set('rowTitle', self.detailedData.serviceName);
			self.rowdata = self.detailedData.serviceType;
			if (showChange === true) {
				self.set('changeState', 'show');
			}
		} else if (type === 'serviceDetails') {
			self.detailedData = self.get('');
			var serviceName = self.detailedData.serviceName;
			if (serviceName !== 'Land Line') {
				self.set('rowTitle', self.detailedData.serviceName);
				self.rowdata = self.detailedData.serviceType;
				if (typeof self.detailedData.noChange === 'undefined' &&
					showChange === true) {
					self.set('changeState', 'show');
				}
			}
		} else if (type === 'deliveryDetails') {
			self.detailedData = self.get('deliveryDetails');
			self.rowdata = self.detailedData.discountDetails;
		} else if (type === 'netlinkInstallationCharges') {
			self.detailedData = self.get('netlinkInstallationCharges');
			self.rowdata = self.detailedData.discountDetails;
		} else if (type === 'fibreInstallationCharges') {
			self.detailedData = self.get('fibreInstallationCharges');
			self.rowdata = self.detailedData.discountDetails;
		} else if (type === 'installationCharges') {
			self.detailedData = self.get('installationCharges');
			self.rowdata = self.detailedData.deliveryType;
		} else if (type === 'appleCare') {
			self.detailedData = self.get('appleCare');
			self.setRowDataMultiple();
			self.set('removeState', 'show');
		} else if (type === 'discountInstallationCharges') {
			self.detailedData = self.get('discountInstallationCharges');
			self.rowdata = self.detailedData.discountDetails;
		}
		if (self.detailedData && typeof self.detailedData.length === 'undefined') {
			self.set('rowDetails', [self.detailedData]);
		} else {
			self.set('rowDetails', self.detailedData);
		}
		self.set('rowData', self.rowdata);
	},

	setRowLabel: function (type) {
		var self = this;
		var isBackOrder = self.get('isBackOrder');
		if (type === 'deviceDetails' && isBackOrder) {
			self.set('rowLabel', ConfigStrings.preOrderLabel);
		}
	},

	setRowDataMultiple: function (showChange) {
		var self = this;
		for (var i = 0; i < self.detailedData.length; i++) {
			self.detailedData[i].rowData = self.detailedData[i].name || self.detailedData[i].planName;
			if (showChange && !self.disableRemoveButton(self.detailedData[i]) &&
				(self.detailedData[i].oneTimePrice.finalAmountIncludingTax > 0 ||
				self.detailedData[i].recurringPrice.finalAmountIncludingTax > 0)) {
				self.detailedData[i].removeState = 'show';
			}
			if (self.detailedData[i].ippFlag &&
				self.detailedData[i].oneTimePrice.finalAmountIncludingTax) {
				self.detailedData[i].rowData =  self.detailedData[i].rowData + '<br>' +
					'(24 Installments, ' +
					RactiveHelpers.convertUnits(
						(self.detailedData[i].oneTimePrice.finalAmountIncludingTax / 24),
					'$') + ' per Month)';
			}
		}
	},

	disableRemoveButton: function (addon) {
		var aspireBillingOfferIds = this.get('aspireBillingOfferIds');
		var disableRemoveButton = false;
		if (aspireBillingOfferIds && aspireBillingOfferIds.length > 0 && addon.offerID) {
			disableRemoveButton = _.contains(aspireBillingOfferIds, addon.offerID);
		}
		return disableRemoveButton;
	},

	setDeviceRowDataMultiple: function () {
		var self = this;
		for (var i = 0; i < self.detailedData.length; i++) {
			self.detailedData[i].rowData = self.detailedData[i].deviceName + '<br>' +
				self.detailedData[i].deviceSize + ', ' + self.detailedData[i].colour;
			if (self.detailedData[i].ippFlag) {
				self.detailedData[i].rowData =  self.detailedData[i].rowData + '<br>' +
					'(24 Installments, ' +
					RactiveHelpers.convertUnits(
						(self.detailedData[i].oneTimePrice.finalAmountIncludingTax / 24),
					'$') + ' per Month)';
			}
		}
	}
});

Ractive.components["ux-summarytitle-row"] = Ractive.extend({
	template: LUXComponentTemplates['ux-summarytitle-row'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			ConfigStrings: ConfigStrings
		};
	},

	onrender: function (argument) {
		var tradeinData = this.get('tradeindata');
		if (tradeinData) {
			this.set('tradeindata.displayTradeinValue', false);
		}
	}
});

Ractive.components["ux-support-decision-tree"] = Ractive.extend({
	template: LUXComponentTemplates['ux-support-decision-tree'],
	oninit: function () {
		var moreOptions = {};
		var options = this.get('options');
		for (var i = 0; i < options.length; i++) {
			moreOptions[options[i].title] = [];
		}
		this.set('moreOptions', moreOptions);
	},
	getItemLocation: function (moreOptions, src, index) {
		var result;
		for (var i in moreOptions) {
			if (moreOptions[i] && typeof (moreOptions[i]) === 'object' && i === 'options') {
				if (moreOptions[i][index].src === src) {
					return moreOptions;
				} else {
					result = this.getItemLocation(moreOptions.moreElement, src, index);
					if (result) {
						return result;
					}
				}
			}
		}
		return result;
	},
	onrender: function () {

		this.on('ux-button.nextStep', function (event) {
			this.set('indexItem', event.get('itemIndex'));
						var url = RactiveHelpers.addBaseContentUrl(event.event.context.nextActionSrc);
			var urlToCall = ConfigStrings.productSupportServletUrl + url + '.json';
			console.log('nextStep clicked ; call ', urlToCall);
			RactiveHelpers.doAjaxJSONCall('GET', urlToCall,
				function (response) {
					var moreOptions = this.get('moreOptions');
					var indexItem = this.get('indexItem');
										moreOptions[indexItem] = {
						answer: response.answer,
						options: response.options
					};
					this.set('moreOptions', moreOptions);
				}.bind(this),
				function (error) {
				}.bind(this)
			);
		}.bind(this));
		this.on('ux-button.nextStepChild', function (event) {
						var url = RactiveHelpers.addBaseContentUrl(event.event.context.nextActionSrc);
			var urlToCall = ConfigStrings.productSupportServletUrl + url + '.json';
			console.log('nextStep clicked ; call ', urlToCall);
			RactiveHelpers.doAjaxJSONCall('GET', urlToCall,
				function (response) {
					var moreOptions = this.get('moreOptions');
					var keyToFind = event.get('nextActionSrc');
					var indexItem = this.get('indexItem');
					var index = event.get('index');
					var element = this.getItemLocation(moreOptions[indexItem], keyToFind, index);
					element.moreElement = {};
										element.moreElement = {
						answer: response.answer,
						options: response.options
					};
					this.set('moreOptions', moreOptions);
				}.bind(this),
				function (error) {
				}.bind(this)
			);
		}.bind(this));
	}
});

Ractive.components["ux-support-navigation"] = Ractive.extend({
	template: LUXComponentTemplates['ux-support-navigation'],

	oninit: function () {


		var navigationList = this.get('navigationList');
		var runMode = this.get('runMode');

		var itemsShown = 'author' === runMode ? navigationList.length : this.get('itemsShown');
		var defaultList = navigationList.slice(0, itemsShown);

		this.set('visibleList', defaultList);
		this.set('buttonDisable', itemsShown < navigationList.length);

		this.on('*.showAll', function (event) {
			this.set('visibleList', navigationList);
			this.set('buttonDisable', false);
		});
	}
});

Ractive.components["ux-support-videos"] = Ractive.extend({
	template: LUXComponentTemplates['ux-support-videos'],
	isolated: false,
	toggleModal: function (modalId, state) {

		var modals = this.findAllComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];

		modal.set('displayState', state);
	},

	oninit: function () {
		var videoList = this.get('videoList');
		var finalVideoList = [];
		_.each(videoList, function (video) {
			if (video.youtubeVideoId) {
				finalVideoList.push({
					img: {
						src:  'http://img.youtube.com/vi/' +
								video.youtubeVideoId +
								'/maxresdefault.jpg',
						alt: video.alt
					},
					youtubeVideoId: video.youtubeVideoId
				});
			}
		});
		this.set('videoList', finalVideoList);
		var videoListDisplayed = finalVideoList.slice(0, 3);
		this.set('videoListDisplayed', videoListDisplayed);
		this.set('hideButton', true);
		if (finalVideoList.length <= 3) {
			this.set('hideButton', false);
		}
	},

	onrender: function () {
		var self = this;

		self.on('*.openModal', function (event, modalId) {
			this.toggleModal(modalId, true);
		});

		self.on('*.viewMore', function (event) {
			this.set('videoListDisplayed', this.get('videoList'));
			this.set('hideButton', false);
		});


	}
});

Ractive.components["ux-table-head-cell"] = Ractive.extend({
	template: LUXComponentTemplates['ux-table-head-cell'],
	isolated: true,
	data: function () {
		var data = {
			config : {
				sortConfig : {
					direction: 'ASC',
					ascClass : 'sorted-asc',
					descClass : 'sorted-desc',
					sortableClass : 'sortable',
					sort : false,
					sorted : false,
					sortEventPostfix : ''
				}
			}
		};
		return data;
	},
	oninit : function () {
		var sortConfig = this.get('columnConfig.sortConfig');
		if (sortConfig && sortConfig.sort) {
			sortConfig = $.extend(this.get('config.sortConfig'), sortConfig);
			sortConfig.id = this._guid;
			this.set('columnConfig.sortConfig', sortConfig);
		}
		this.on('cellClick', this.onCellClick);
	},
	oncomplete : function () {
	
		var sortConfig = this.get('columnConfig.sortConfig');
		if (sortConfig && !sortConfig.sorted) {
			this.onCellClick();
		}
	},

	onCellClick : function () {
		var sortConfig = this.get('columnConfig.sortConfig');
		if (sortConfig && sortConfig.sort) {
			sortConfig.direction = sortConfig.direction === 'ASC' ? 'DESC' : 'ASC';
			this.set('columnConfig.sortConfig', sortConfig);
			this.fire('sortColumn_' + sortConfig.field + sortConfig.sortEventPostfix, this, sortConfig);
		}
	}
});

Ractive.components["ux-techspec-accordion"] = Ractive.extend({
	template: LUXComponentTemplates['ux-techspec-accordion'],
	data : function () {
		return {
			RactiveHelpers : RactiveHelpers
		};
	},

	onrender: function () {
		var self = this;

	
		var spacings = ['small', 'medium', 'large'];
		var topSpacing = self.get('topSpacing');
		topSpacing = _.indexOf(spacings, topSpacing) !== -1 ?
		self.set('topSpacing', topSpacing) : self.set('topSpacing', 'normal');
		var bottomSpacing = self.get('bottomSpacing');
		bottomSpacing = _.indexOf(spacings, bottomSpacing) !== -1 ?
		self.set('bottomSpacing', bottomSpacing) : self.set('bottomSpacing', 'normal');

	

		self.parent.on('setFreeGiftsState', function (deviceId, planId, priceSchemaId) {
			var groupId = self.get('initData.groupId');
			if (!(self.freegifts && self.freegifts.length)) {
				var url = '/bin/services/singtel/ProductComponentModelServlet?groupId=' + groupId;
				RactiveHelpers.doAjaxJSONCall('POST', url, function (response) {
					if (response.length > 0) {
						self.freegifts = response[0].freegifts || [];
						self.showFreeGifts (self.freegifts, deviceId, planId, priceSchemaId);
					}
				},
				function (error) {
				
				
					console.log(error);
				});
			} else {
				self.showFreeGifts (self.freegifts, deviceId, planId, priceSchemaId);
			}
		});
	},

	generateFreeGiftList: function (freeGifts) {
		var self = this;
		var accessories = [];
		if (freeGifts.length > 0) {
			_.forEach(freeGifts, function (obj) {
				if (obj.phoneAccessories.length > 0) {
					accessories = _.union(accessories, obj.phoneAccessories);
				}
			});
		}
		self.set('freeGiftsList', '');
		if (accessories.length > 0) {
			accessories = _.clone(accessories);
			var freeGiftsList = _.uniq(accessories, 'freeGiftId');
			self.set('freeGiftsList', freeGiftsList);
		}
	},

	showFreeGifts: function (freeGifts, deviceId, planId, priceSchemaId) {
		var self = this;
		if (typeof deviceId !== 'undefined' && deviceId !== '' && deviceId !== null) {
			freeGifts = _.filter(freeGifts, function (freeGift) {
				return freeGift.deviceId === deviceId;
			});

			if (freeGifts && freeGifts.length > 0) {
				if (planId && priceSchemaId) {
					_.each(freeGifts, function (freeGift) {
						var phoneAccessories = [];
						_.each(freeGift.phoneAccessories, function (phoneAccessorie) {

							var plans = _.filter(phoneAccessorie.plans, function (plan) {
								return plan.planId === planId &&
									plan.basePriceSchemaId === priceSchemaId;
							});
							if (plans && plans.length > 0) {
								phoneAccessories.push(phoneAccessorie);
							}
						});
						freeGift.phoneAccessories = phoneAccessories;
					});
				}
			}

			if (freeGifts && freeGifts.length > 0) {
				self.generateFreeGiftList(freeGifts);
			} else {
				self.set('freeGiftsList', '');
			}
		}
	}
});

Ractive.components["ux-textarea"] = Ractive.extend({
	template: LUXComponentTemplates['ux-textarea'],
	onconfig: function () {
		this.on('blurHandler', function (event) {
			var fireEvent = this.get('onblurEvent');
			if (fireEvent) {
				this.fire(fireEvent, this);
				return false;
			}
		});
	}
});

Ractive.components["ux-threetext-image"] = Ractive.extend({
	template: LUXComponentTemplates['ux-threetext-image']
});

Ractive.components["ux-timeline"] = Ractive.extend({
	template: LUXComponentTemplates['ux-timeline'],
	data: function () {
		return {
			'RactiveHelpers': RactiveHelpers,
			'moment': moment,
			'ConfigStrings': ConfigStrings,
			'slotDateFormat': 'YYYYMMDD',
			'dateTimeSlotsProp': 'dateTimeSlots',
			'isChangeFsPopAddress': false,
			'isChangeFsPopDate': false,
			'selectedOption': 'pop-station',
			'calStr': null,
			'changePopStation': {
				'address': null,
				'collectionDate': null,
				'isTnCAccepted': false
			},
			'eAppointmentCareCrOn': ConfigStrings.eAppointmentCareCrOn ||
				RactiveHelpers.getParameterByName('eAppointmentCareCrOn', false),
			getDeliveryDate: function () {
				var events = this.get('currentActivity.events');
				return _.find(events, function (event) {
					if (event.installation.deliveryDate) {
						return true;
					}
				});
			},
			getInstallationDate: function () {
				var events = this.get('currentActivity.events');
				return _.find(events, function (event) {
					if (event.installation.netLinkDate || event.installation.wfmAppointmentDate) {
						return true;
					}
				});
			},
			showAddToCalendar: function (event) {
				if (event.type === 'Installation' ||
					event.type === 'Maintenance' ||
					event.type === 'Shop') {
					return true;
				}
				return false;
			}
		};
	},

	oninit: function () {
		var self = this;
		self.set('isTncAgreed', false);
		var map = {
			'Installation': 'changeInstallationAppointment',
			'Maintenance': 'changeInstallationAppointment',
			'Shop': 'changeShopAppointment',
			'support-ticket': 'showTicketInfo',
			'purchase': 'showOrderDetails',
			'order': 'showOrderDetails',
			'transaction': 'showTransactionInfo',
			'service-agreement': 'showAgreementInfo'
		};
		var qnomyServicesMap = {
			'New - Fibre': 'newFibre',
			'New - Home Telephone': 'newHomePhone',
			'New - Mobile Broadband': 'newMobileBroadband',
			'New - Mobile PostPaid': 'newMobilePostpaid',
			'New - Singtel TV': 'newTV',
			'Recontract - Fibre': 'recontractFibre',
			'Recontract - Mobile Broadband': 'recontractMobileBroadband',
			'Recontract - Mobile PostPaid': 'recontractMobilePostpaid',
			'Recontract - Singtel TV': 'recontractSingtelTv'
		};


		self.on('ux-anchor.onLinkClick', function (evtObj, type) {
			var activity = evtObj.get('activity');
			var link = evtObj.get('link');

			this.set('currentActivity', activity);
			this.set('currentEvent', activity.events[0]);
			type = link.type;
			switch (type) {
				case 'order':
					self.showOrderDetails();
					break;
			}
		});
		self.on('*.doCloseModal', self.onCloseModal.bind(self));
		self.on('*.cancelActivity', function (event) {
			self.parent.set('timeLineData.appointment', event.get('activity'));
			self.set('currentAppointment', event.get('activity'));
			self.set('isTncAgreed', false);
			self.setModalDisplayState('cancelAppointment', true);
		});
		self.on('ux-anchor.saveAppointmentDetails', function (eventObj,type) {
			var appointmentId = eventObj.get('activity').events[0].isLinkedApptIdExist;
			self.parent.set('appointmentInContext.appointmentId', appointmentId);
			self.parent.set('appointmentInContext.flowType', 'timeLineFlow');
			window.location.href = self.get('initData.appointmentDetailsView');
		});
		self.on('*.onChangeInstallationAppointment', function (event) {
			self.setModalDisplayState('changeInstallationAppointment', false);
			self.set('isTncAgreed', false);
			self.setModalDisplayState('confirmInstallationAppointment', true);
		});

		self.on('*.onChangeFsDelAppointment', function (event) {
			self.setModalDisplayState('changeFsDelAppointment', false);
			self.set('isTncAgreed', false);
			self.setModalDisplayState('confirmFsDelAppointment', true);
		});

		self.on('*.onSubmitFsDelAppointment', function (event) {
			self.parent.setLoaderAndModalProperty('confirmFsDelAppointment', 'inProcess', true);
			var fsAppointment = self.get('currentEvent.fsAppointment');
			var selectedSlotObj = self.get('selectedSlotObj');

			var eventName = 'fsAppointmentSlotTopic.changeFsDelAppointment';
			if (fsAppointment.isRedeliveryAllowed) {
				eventName = 'fsAppointmentSlotTopic.changeFsRedelAppointment';
			}
			self.parent.fire(eventName, {
				name: eventName,
				data: {
					'dealerCode': fsAppointment.dealerCode,
					'orderActionId': fsAppointment.orderActionId,
					'newFsDelSelectedSlot': selectedSlotObj
				}
			});
		});

		self.on('*.onSubmitInstallationAppointment', function (event) {
		
			self.parent.setLoaderAndModalProperty('confirmInstallationAppointment', 'inProcess', true);
					
			var selectedSlot = self.get('selectedSlot');
			var eventName = 'timeLineData.setDWFMTimeSlot';
			self.parent.fire(eventName, {
				name: eventName,
				data: {
					'selectedSlot': selectedSlot
				}
			});
		});

		self.on('*.dateSelected', function (date) {
			if (typeof date !== 'undefined') {
				var appointmentSlots = self.get('appointmentSlots');
				if (typeof appointmentSlots !== 'undefined') {
					self.set('selectedDate', date);
					var slotDate = moment(date, 'YYYY-MM-DD', true).format(self.get('slotDateFormat'));
					if (slotDate === 'Invalid date') {
						slotDate = moment(date).format('YYYYMMDD');
					}
					var component = self.findComponent('ux-date-time-picker');
					if (component) {
						component.set('timeSlotsOptions', appointmentSlots[slotDate]);
					}
					self.set('timeSlotsOptions', appointmentSlots[slotDate]);
					self.set('selectedTime', self.get('selectedTime') ? self.get('selectedTime') :
						self.get('timeSlotsOptions')[0].title);
					self.parent.set('timeLineData.selectedSlot', appointmentSlots[slotDate][0].value);
				}
				self.set('isInstalltionDateSlotSelected', true);
				self.set('isInstalltionTimeSlotSelected', false);
			}
		});
		self.on('*.timeSelected', function (time) {
			var selectedTime = _.find(self.get('timeSlotsOptions'), function (slot) {
				return slot.value === time;
			});
			self.set('selectedTime', selectedTime ? selectedTime.title : self.get('timeSlotsOptions')[0].title);
			self.set('selectedSlot', time);
			self.set('selectedSlotObj', selectedTime);
			self.set('isInstalltionTimeSlotSelected', true);
		});
		self.on('*.cancelConfimation', function (event) {
		
			self.parent.setLoaderAndModalProperty('cancelAppointment', 'inProcess', true);
			if (this.get('currentAppointment').type === 'Shop') {
				var eventName = 'timeLineData.cancelPreviousShopAppointment';
				self.parent.fire(eventName, {
					name: eventName
				});
			} else if (this.get('currentAppointment').type === 'Maintenance' ||
				this.get('currentAppointment').type === 'Installation') {
				var eventName = 'timeLineData.cancelPreviousAppointment';
				self.parent.fire(eventName, {
					name: eventName
				});
			}
		});
		self.on('ux-anchor.downloadFsAppointmentDetails', function (evtObj) {
			self.parent.set('inProcess', false);
			var eventObj = evtObj.get('eventObj');
			var fsAppointment = eventObj.fsAppointment;
			var orderActionId = fsAppointment.orderActionId;
			var eventName = 'fsAppointmentSlotTopic.getDoImage';
			self.parent.fire(eventName, {
				name: eventName,
				data: {
					'orderActionId': orderActionId
				}
			});
		});

		self.on('*.onChangeFsPopAddress', function (event) {
			self.set('isChangeFsPopAddress', true);
			self.set('isChangeFsPopDate', false);
			self.set('changePopStation.address', null);
			self.set('changePopStation.collectionDate', null);
			self.set('changePopStation.isTnCAccepted', false);
		});

		self.on('*.retrievePOPStations', function (postalCode) {
			var ractiveWidget = this.parent;
			ractiveWidget.setModalProperty('changeFsPopStationAppointment', 'inProcess', true);
			var eventName = 'timeLineData.getPOPStations';
			ractiveWidget.set('timeLineData.popStationPostalCode', postalCode);
			ractiveWidget.fire(eventName, {
				name: eventName
			});
		}.bind(this));

		self.on('*.pickupLocationSelected', function (pickupLocationSelected) {
			self.set('changePopStation.flow', 'changeAddress');
			self.set('changePopStation.address', pickupLocationSelected);
		});

		self.on('*.onNewPopStationSelected', function () {
			var ractiveWidget = self.parent;
			self.set('isChangeFsPopAddress', false);
			self.set('isChangeFsPopDate', true);
			self.set('changePopStation.collectionDate', null);
			self.set('changePopStation.isTnCAccepted', false);
			ractiveWidget.setModalProperty('changeFsPopStationAppointment', 'inProcess', true);
			self.retrievePopStationTimeslots(self.get('changePopStation.address.KioskId'));
		});

		self.on('*.onChangeFsPopStationDate', function (event) {
			var ractiveWidget = self.parent;
			self.set('changePopStation.flow', 'changeDate');
			self.set('isChangeFsPopDate', true);
			self.set('changePopStation.collectionDate', null);
			self.set('changePopStation.isTnCAccepted', false);
			ractiveWidget.setModalProperty('changeFsPopStationAppointment', 'inProcess', true);
			self.retrievePopStationTimeslots(self.get('currentEvent.fsAppointment.deliveryOutletCode'));
		});

		self.on('*.onChangePopStationAppointment', function (event) {
			self.setModalDisplayState('changeFsPopStationAppointment', false);
			self.set('changePopStation.isTncAgreed', false);
			self.setModalDisplayState('confirmFsPopStationAppointment', true);
		});

		self.on('*.onSubmitPopStationAppointment', function (event) {
			var ractiveWidget = self.parent;
			ractiveWidget.setLoaderAndModalProperty('confirmFsPopStationAppointment', 'inProcess', true);
			var fsAppointment = self.get('currentEvent.fsAppointment');
			var selectedSlotObj = self.get('selectedSlotObj');
			var newPopStationAddress = self.get('changePopStation.address');

			var eventName = 'fsAppointmentSlotTopic.changeFsPopStationAppointment';
			self.parent.fire(eventName, {
				name: eventName,
				data: {
					'dealerCode': fsAppointment.dealerCode,
					'orderActionId': fsAppointment.orderActionId,
					'newFsDelSelectedSlot': selectedSlotObj,
					'newPopStationAddress': newPopStationAddress
				}
			});
		});

		self.on('ux-anchor.doOpenModal', function (evtObj, type) {
			var activity = evtObj.get('activity');
			var eventObj = evtObj.get('eventObj');
			var furtherProcess = true;
			this.parent.set('timeLineData.appointment', evtObj.get('activity'));
			this.set('initData.currentAppointmentId', eventObj.installation.appointmentId);
			if (activity.type === 'Shop') {
				if (this.get('eAppointmentCareCrOn')) {
					var apptId = eventObj.installation.appointmentId;
					if (apptId && typeof apptId !== 'undefined') {
						furtherProcess = false;
						var changeApptUrl = this.get('changeAppointmentUrl') ||
							RactiveHelpers.modifyConfigUrl(ConfigStrings.pageUrls.changeAppointmentUrl);
						window.location.href = changeApptUrl + '?apptId=' + apptId;
					}
				} else {
					var service = qnomyServicesMap[eventObj.installation.service];
					var appointmentTypeId = self.get('initData.qnomyServicesMap')[service];
					this.set('initData.appointmentTypeId', appointmentTypeId);
				}
			}
			if (furtherProcess) {
				this.set('currentActivity', activity);
				this.set('currentEvent', eventObj);
				type = activity.type;
				self.set('slotDateFormat', 'YYYYMMDD');
				self.set('dateTimeSlotsProp', 'dateTimeSlots');
				switch (type) {
					case 'order':
						self.showOrderDetails();
						break;
					case 'Maintenance':
					case 'Installation':
						self.set('isInstalltionDateSlotSelected', false);
						self.set('isInstalltionTimeSlotSelected', false);
						var eventName = 'timeLineData.getDWFMTimeSlots';
						self.parent.fire(eventName, {
							name: eventName
						});
						self.updateModalValues(activity, eventObj);
						self.handleModal(map[activity.type], true);
						self.parent.setLoaderAndModalProperty(map[activity.type], 'inProcess', true);
						break;
					case 'Shop':
						this.set('initData.customerEmailId', this.parent.get('viewPersonInfo.contactInfo.emailId'));
						self.updateModalValues(activity, eventObj);
						self.handleModal(map[activity.type], true);
						break;
					case 'purchase':
						var fsAppointment = eventObj.fsAppointment;
						self.set('displayCalendar', false);
						if (fsAppointment) {
							self.set('slotDateFormat', 'YYYY-MM-DD');
							self.set('dateTimeSlotsProp', 'dateTimeSlotsObj');
						
						
						
							switch (fsAppointment.slotType) {
								case ConfigStrings.FS_APPOINTMENT.HOME_DELIVERY_MOBILE:
								case ConfigStrings.FS_APPOINTMENT.SNAIL_MAIL_MOBILE:
								case ConfigStrings.FS_APPOINTMENT.HOME_DELIVERY_HOMEPRODUCT:
									self.updateModalValues(activity, eventObj);
									self.handleModal('changeFsDelAppointment', true);
									self.parent.setLoaderAndModalProperty('changeFsDelAppointment', 'inProcess', true);
									var paymentMode = ConfigStrings.FS_APPOINTMENT.PAYMENT_MODE;
									if (fsAppointment.implFsOrderFulfillmentTenderModeList &&
										fsAppointment.implFsOrderFulfillmentTenderModeList.length) {
										var tenderMode = fsAppointment.implFsOrderFulfillmentTenderModeList[0];
										paymentMode = tenderMode.method;
									}
									var delDate = moment(new Date(fsAppointment.deliveryDateMilli));
									var courierDetails = {
										'orderActionId': fsAppointment.orderActionId,
										'slotType': fsAppointment.slotType,
										'paymentMode': paymentMode,
										'dealerCode': fsAppointment.dealerCode,
										'leadDays': Math.ceil(moment.duration(delDate.diff(moment())).asDays()),
										'documentRequired': false
									};
									var eventName = 'dispatchAppointmentSlot.onRetrieveAppointmentsSlots';
									if (fsAppointment.isRedeliveryAllowed) {
										courierDetails.leadDays = moment(moment().date() + '/' +
										(moment().month() + 1) + '/' +
										moment().year(), 'DD/MM/YYYY')
										.add(0, 'days').valueOf();
										eventName = 'dispatchAppointmentSlot.onRetrieveRedeliveryAppointmentsSlots';
									}
									self.parent.fire(eventName, {
										name: eventName,
										data: {
											'courierDetails': courierDetails
										}
									});
									break;
								case ConfigStrings.FS_APPOINTMENT.POP_STATION_MOBILE:
								case ConfigStrings.FS_APPOINTMENT.POP_STATION_HOMEPRODUCT:
									self.updateModalValues(activity, eventObj);
									self.set('isChangeFsPopAddress', false);
									self.set('isChangeFsPopDate', false);
									self.handleModal('changeFsPopStationAppointment', true);
									break;
							}
						}
						break;
				}
			}
		});

		self.on('ux-anchor.addNewAppointmentToCalendar', function (evtObj) {
			var event = _.clone(evtObj.get('event'));
			switch (event.type) {
				case 'Installation':
				case 'Maintenance':
					event.installation.installationDate = this.get('selectedDate').getTime();
					event.installation.installationTime = this.get('selectedTime');
					break;
				case 'Shop':
					event.installation.shopApointmentDate = this.get('selectedDate').getTime();
					event.installation.shopApointmentTime = this.get('selectedTime');
					break;
			}
			self.setCalendarData(event);
		}.bind(self));

		self.on('ux-anchor.addAppointmentToCalendar', function (evtObj) {
			var event = evtObj.get('event');
			self.setCalendarData(event);
		});

		self.observe('datamodel.implTimelineVmStatus',
			self.onImplTimelineVmStatusChange, {context: self});
		self.observe('dispatchAppointmentSlot.appointmentSlotsVmStatus',
			self.onAppointmentSlotsVmStatus, {context: self});
		self.observe('fsAppointmentSlotTopic.fsAppointmentVmStatus',
			self.onFsAppointmentVmStatus, {context: self});
		self.observe('selfCollectionTimeSlot.collectionTimeSlotVmStatus',
			self.onCollectionTimeSlotVmStatus, {context: self});
	},
	setCalendarData: function (event) {
		var cal = ICS();
		var date, startTime, endTime, subject, description, location, subject = null;
		var timeArray, startDateTime, endDateTime = null;
		var appt = event.installation;
		switch (event.type) {
			case 'Installation':
			case 'Maintenance':
				date = RactiveHelpers.convertMilisTimestampToDate(appt.installationDate, 'DD/MM/YYYY');
				timeArray = appt.installationTime.split('-');
				startDateTime = date + ' ' + timeArray[0].replace(/\s/g, '');
				endDateTime = date + ' ' + timeArray[1].replace(/\s/g, '');
				startTime = moment(startDateTime, 'DD/MM/YYYY hh:mma').unix() * 1000;
				endTime = moment(endDateTime, 'DD/MM/YYYY hh:mma').unix() * 1000;
				location = RactiveHelpers.addressToString(event.address, event.address.addressType);
				break;
			case 'Shop':
				date = RactiveHelpers.convertMilisTimestampToDate(appt.shopApointmentDate, 'DD/MM/YYYY');
				timeArray = appt.shopApointmentTime.split('-');
				startDateTime = date + ' ' + timeArray[0].replace(/\s/g, '');
				endDateTime = date + ' ' + timeArray[1].replace(/\s/g, '');
				startTime = moment(startDateTime, 'DD/MM/YYYY hh:mma').unix() * 1000;
				endTime = moment(endDateTime, 'DD/MM/YYYY hh:mma').unix() * 1000;
				location = RactiveHelpers.addressToString(event.address, event.address.addressType);
				break;
		}
		switch (event.type) {
			case 'Installation':
				description = this.get('initData.installationDescription') || event.title;
			
			
			
			
				subject = this.get('initData.installationSubject') || event.title;
				break;
			case 'Maintenance':
				description = this.get('initData.maintenanceDescription') || event.title;
				subject = this.get('initData.maintenanceSubject') || event.title;
				break;
			case 'Shop':
				description = this.get('initData.shopDescription')  || event.title;
				subject = this.get('initData.shopSubject')  || event.title;
				break;
		}
		if (date && startTime && endTime) {
			var calEvent = cal.addEvent(subject, description, location, startTime, endTime);
			if (calEvent) {
				var calStr = cal.calendar();
				console.log(calStr);
				this.set('calStr', cal.calendar());
				$('#ics-file-download-form').submit();
			}
		}
	},
	retrievePopStationTimeslots: function (popStationOutletCode, selectedStore) {
		var ractiveWidget = this.parent;
		this.set('displayCalendar', false);
		var fsAppointment = this.get('currentEvent.fsAppointment');
		var selfCollection = {
			dealer : fsAppointment.dealerCode,
			outlet : popStationOutletCode,
			documentRequired: false,
			selectedStore: selectedStore,
			orderActionId: fsAppointment.orderActionId,
			leadDays: moment(moment().date() + '/' + (moment().month() + 1) + '/' +
				moment().year(), 'DD/MM/YYYY').add(ConfigStrings.FS_APPOINTMENT.LEAD_DAYS, 'days').valueOf()
		};
		ractiveWidget.set('selfCollectionTimeSlot.selfCollection', selfCollection);
		var eventName = 'selfCollectionTimeSlot.retrieveTimeSlots';
		ractiveWidget.fire(eventName, {
			name: eventName
		});
	},
	onCloseModal: function (event) {
		var modalId = event.component.get('modalId');
		if (modalId === 'changeFsDelAppointmentSuccessModal' ||
			modalId === 'changeFsPopStationAppointmentSuccessModal') {
			window.location.reload();
		}
	},
	deleteActivity: function (activity) {
		var activities = this.get('activities');
		if (activities && activities.length) {
			var activityIndex = activities.indexOf(activity);
			if (activityIndex > -1) {
				activities.splice(activityIndex, 1);
				this.set('activities', activities);
			}
		}
	},
	onAppointmentSlotsVmStatus: function (status) {
		var ractiveWidget = this.parent;
		switch (status) {
			case 'slotsRetrieved':
			case 'GetRedeliveryTimeslotsSuccess':
				this.parent.setModalProperty('changeFsDelAppointment', 'inProcess', false);
				var appointmentSlots = this.get('dispatchAppointmentSlot.appointmentSlots');
				if (appointmentSlots.enabledDays && appointmentSlots.enabledDays.length) {
					this.retrievedAppointments(appointmentSlots, 'YYYY-MM-DD');
				} else {
					this.parent.setLoaderAndModalProperty('changeFsDelAppointment', 'inProcess', false);
					this.setModalDisplayState('errorModal', true);
				}
			
				break;
			case 'failure':
			case 'GetRedeliveryTimeslotsFailure':
				this.parent.setLoaderAndModalProperty('changeFsDelAppointment', 'inProcess', false);
				ractiveWidget.set('apiGenericError', ConfigStrings.apiGenericError);
				this.setModalDisplayState('errorModal', true, ConfigStrings.errors.genericError2, true);
			
			
				break;
		}
	},
	onCollectionTimeSlotVmStatus: function (status) {
		var ractiveWidget = this.parent;
		switch (status) {
			case 'slotsRetrieved':
				this.parent.setModalProperty('changeFsPopStationAppointment', 'inProcess', false);
				var appointmentSlots = this.get('selfCollectionTimeSlot.appointmentSlots');
				if (appointmentSlots.enabledDays && appointmentSlots.enabledDays.length) {
					this.retrievedAppointments(appointmentSlots, 'YYYY-MM-DD');
				} else {
					this.parent.setLoaderAndModalProperty('changeFsDelAppointment', 'inProcess', false);
					this.setModalDisplayState('errorModal', true);
				}
			
				break;
			case 'failed':
				this.parent.setLoaderAndModalProperty('changeFsPopStationAppointment', 'inProcess', false);
				ractiveWidget.set('apiGenericError', ConfigStrings.apiGenericError);
				this.setModalDisplayState('errorModal', true, ConfigStrings.errors.genericError2, true);
			
			
				break;
		}
	},
	onFsAppointmentVmStatus: function (fsAppointmentVmStatus) {
		var ractiveWidget = this.parent;
		switch (fsAppointmentVmStatus) {
			case 'changeFsDelAppointmentSuccess':
			case 'changeFsRedelAppointmentSuccess':
				this.parent.setLoaderAndModalProperty('confirmFsDelAppointment', 'inProcess', false);
				this.setModalDisplayState('changeFsDelAppointmentSuccessModal', true);
				break;
			case 'changeFsDelAppointmentFailure':
			case 'changeFsRedelAppointmentFailure':
				this.parent.setLoaderAndModalProperty('confirmFsDelAppointment', 'inProcess', false);
				this.setModalDisplayState('errorModal', true);
				break;
			case 'changeFsDelAppointmentRestFailed':
			case 'changeFsRedelAppointmentRestFailed':
				this.parent.setLoaderAndModalProperty('confirmFsDelAppointment', 'inProcess', false);
				ractiveWidget.set('apiGenericError', ConfigStrings.apiGenericError);
				this.setModalDisplayState('errorModal', true);
			
			
				break;
			case 'changeFsPopStationAppointmentSuccess':
				this.parent.setLoaderAndModalProperty('confirmFsPopStationAppointment', 'inProcess', false);
				this.setModalDisplayState('changeFsPopStationAppointmentSuccessModal', true);
				break;
			case 'changeFsPopStationAppointmentFailure':
			case 'changeFsPopStationAppointmentRestFailure':
				this.parent.setLoaderAndModalProperty('confirmFsPopStationAppointment', 'inProcess', false);
				ractiveWidget.set('apiGenericError', ConfigStrings.apiGenericError);
				this.setModalDisplayState('errorModal', true);
			
			
				break;
			case 'fsGetDoImageFailure':
				this.parent.set('inProcess', false);
				this.setModalDisplayState('errorModal', true);
				break;
			case 'GetRedeliveryTimeslotsFailure':
				this.parent.set('inProcess', false);
				this.setModalDisplayState('errorModal', true);
				break;
		}
	},
	onImplTimelineVmStatusChange: function (implTimelineVmStatus) {
	
		switch (implTimelineVmStatus) {
			case 'OrderDetailsReceived':
				this.setModalDisplayState('showOrderDetails', true);
				break;
			case 'appointmentCancelled':
				this.parent.setLoaderAndModalProperty('cancelAppointment', 'inProcess', false);
				this.setModalDisplayState('cancelConfimationModal', true);
				this.deleteActivity(this.get('currentAppointment'));
				break;
			case 'getDWFMTimeSlotsSuccess':
				this.parent.setModalProperty('changeInstallationAppointment', 'inProcess', false);
				this.retrievedAppointments(this.parent.get('timeLineData.availableTimeSlots'), 'YYYYMMDD');
				break;
			case 'setDWFMTimeSlotSuccess':
				this.parent.setLoaderAndModalProperty('confirmInstallationAppointment', 'inProcess', false);
				this.setModalDisplayState('appointmentSuccessModal', true);
				break;
			case 'CancelFailure':
				this.parent.setLoaderAndModalProperty('cancelAppointment', 'inProcess', false);
				this.setModalDisplayState('errorModal', true);
				break;
			case 'OrderDetailsFailed':
				break;
			case 'interactionDataError':
			case 'interactionConvertedToActivities':
				this.parent.set('inProcess', false);
				break;
			case 'getDWFMTimeSlotsFailure':
				this.parent.setLoaderAndModalProperty('changeInstallationAppointment', 'inProcess', false);
				this.setModalDisplayState('errorModal', true);
				break;
			case 'setDWFMTimeSlotError':
				this.parent.setLoaderAndModalProperty('confirmInstallationAppointment', 'inProcess', false);
				this.setModalDisplayState('errorModal', true);
				break;
			case 'vmInitialized':
				var eventName = 'timeLineData.setAppointmentData';
				var exisitingAppointmentInput = {
					cusIdType: ConfigStrings.shopEApt.care.cusIdType,
					customerIdType: ConfigStrings.shopEApt.care.cusIdType,
					source: ConfigStrings.shopEApt.care.source,
					eAppointmentCareCrOn: this.get('eAppointmentCareCrOn')
				};
				this.parent.set('timeLineData.exisitingAppointmentInput', exisitingAppointmentInput);
				this.parent.fire(eventName, {
					name: eventName,
					data: {
						'exisitingAppointmentInput': exisitingAppointmentInput
					}
				});
				break;
			case 'popStationsFound':
				this.parent.setModalProperty('changeFsPopStationAppointment', 'inProcess', false);
				break;
			case 'popStationsFailure':
				this.parent.setLoaderAndModalProperty('changeFsPopStationAppointment', 'inProcess', false);
				this.setModalDisplayState('errorModal', true);
				break;
		}
	},
	retrievedAppointments: function (appointmentSlots, format) {
		var self = this;
		var dateTimeSlotsProp = self.get('dateTimeSlotsProp');
		var enabledDays = appointmentSlots.enabledDays || [];
		var formattedDays = [];
		_.each(enabledDays, function (enabledDay) {
			formattedDays.push(moment(enabledDay, format, true).format('YYYY-MM-DD'));
		});

		self.set('enabledDays', formattedDays) ;
		if (enabledDays.length > 0) {
			var timeslots = appointmentSlots[dateTimeSlotsProp][enabledDays[0]];
			self.set('timeSlotsOptions', timeslots);
			self.set('defaultDay', formattedDays[0]);
		}
		self.set('appointmentSlots', appointmentSlots[dateTimeSlotsProp]) ;
		self.set('displayCalendar', true);
	},

	showOrderDetails: function () {
		var activity = this.get('currentActivity');
		this.set('datamodel.orderId', activity.orderId);
		this.set('datamodel.customerId', activity.customerId);
		this.fire('retrieveOrderDetails');
		console.log(activity);
	},
	setModalDisplayState: function (modalId, state) {

		var modals = this.findAllComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];

		modal.set('displayState', state);
	},

	handleModal: function (modalId) {
		this.setModalDisplayState(modalId, true);
	},

	updateModalValues: function (appObj, eventObj) {
		var type = appObj.type;
		this.set('appointmentDate', eventObj.installation.installationDate);
		this.set('appointmentTime', eventObj.installation.installationTime);
		this.set('appointmentAddress', eventObj.address);
		this.set('appointmentService', eventObj.installation.service);
		this.set('appointmentServiceNum', eventObj.installation.serviceNumber);
		if (type === 'Shop') {
			this.allShops = this.get('initData').shopListInfo;
			this.set('shopList', this.allShops);
			return;
		} else if (type === 'support-ticket') {
			this.set('ticketNumber', appObj.ticket.number);
			this.set('ticketType', appObj.ticket.type);
			this.set('ticketArea', appObj.ticket.area);
			this.set('ticketComments', appObj.ticket.comments);
			this.set('ticketAttachments', appObj.ticket.attachments);
			return;
		} else if (type === 'Installation') {
			this.set('appointmentType', 'Installation');
		} else if (type === 'Maintenance') {
			this.set('appointmentType', 'Maintenance');
		}  else if (type === 'purchase') {
			var fsAppointment = eventObj.fsAppointment;
			if (fsAppointment) {
			
			
			
				switch (fsAppointment.slotType) {
					case ConfigStrings.FS_APPOINTMENT.HOME_DELIVERY_MOBILE:
					case ConfigStrings.FS_APPOINTMENT.SNAIL_MAIL_MOBILE:
					case ConfigStrings.FS_APPOINTMENT.HOME_DELIVERY_HOMEPRODUCT:
						this.set('appointmentType', 'FSDelivery');
						break;
					case ConfigStrings.FS_APPOINTMENT.POP_STATION_MOBILE:
					case ConfigStrings.FS_APPOINTMENT.POP_STATION_HOMEPRODUCT:
					
						this.set('appointmentType', 'FSPopStation');
						break;
				}
			}
		}
	}
});

Ractive.components["ux-timer-popup"] = Ractive.extend({
	template: LUXComponentTemplates['ux-timer-popup'],
	isolated: true,
	oncomplete: function () {
		var self = this;
		self.set('selected', true);
		self.parent.on('openTimerModal', function () {
			self.set('selected', true);
			self.set('timerDuration', false);
			clearInterval(self.timer);
			self.getTimer(0, self.get('timerModalData.timer'));
			var timerDurationDesc = self.get('timerModalData.timerDurationDesc') || '';
			timerDurationDesc = timerDurationDesc.replace(
				'timer_in_secs', ((self.get('timerModalData.timer') + ' seconds')));
			self.set('timerDurationDesc', timerDurationDesc);
			self.handleModal(true, 'timerModalPopup');
		});
		self.parent.on('closeTimerModal', function () {
			self.set('selected', true);
			clearInterval(self.timer);
			self.handleModal(false, 'timerModalPopup');
		});
		self.getTimer.bind(self);
	},
	getTimer: function (min, sec) {
		var duration = moment.duration({
			'minutes': min,
			'seconds': sec
		});
		var timestamp = new Date(0, 0, 0, 2, 10, 30);
		var interval = 1;
		this.timer = setInterval(function () {
			timestamp = new Date(timestamp.getTime() + interval * 1000);
			duration = moment.duration(duration.asSeconds() - interval, 'seconds');
			this.sec = duration.asSeconds() - interval;
			if (this.sec === 0) {
				clearInterval(this.timer);
				this.set('timerDurationDesc', null);
				this.set('timerDuration', true);
				this.set('selected', false);
			} else {
				var timerDurationDesc = this.get('timerModalData.timerDurationDesc');
				timerDurationDesc = timerDurationDesc.replace(
					'timer_in_secs', (this.sec + ' seconds'));
				this.set('timerDurationDesc', timerDurationDesc);
				this.set('timerDuration', false);
				this.set('selected', true);
			}
		}.bind(this), 1000);
	},
	handleModal: function (visibility, cardId) {
		var modals = this.findAllChildComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return cardId === component.get('modalId');
		})[0];
		modal.set('displayState', visibility);
	}
});

Ractive.components["ux-togglestate-button"] = Ractive.extend({
	template: LUXComponentTemplates['ux-togglestate-button'],

	onrender: function () {
	
		var self = this;
		var spacings = ['small', 'medium', 'large'];
		var topSpacing = self.get('topSpacing');
		topSpacing = _.indexOf(spacings, topSpacing) !== -1 ?
		self.set('topSpacing', topSpacing) : self.set('topSpacing', 'normal');
		var bottomSpacing = self.get('bottomSpacing');
		bottomSpacing = _.indexOf(spacings, bottomSpacing) !== -1 ?
		self.set('bottomSpacing', bottomSpacing) : self.set('bottomSpacing', 'normal');
		self.on('*.doNavigateView', function (event) {
			var eventName = 'updateDeviceDetailInOrder';
			self.fire(eventName, {
				name: eventName
			});
		});

	},

	oninit: function () {

		this.parent.on('*.setButtonToggleState', function (toggleState) {
			this.toggleButtonState(toggleState);
		}.bind(this));

		this.parent.on('setButtonToggleState', function (toggleState) {
			this.toggleButtonState(toggleState);
		}.bind(this));

		Ractive.defaults.on('setButtonToggleState', function (toggleState) {
			this.toggleButtonState(toggleState);
		}.bind(this));

		this.set('nextButtonState', true);

	},

	toggleButtonState: function (toggleState) {

		if (toggleState === 'disabled') {
			this.set('nextButtonCSSState', 'disabled');
			this.set('nextButtonState', true);
		} else {
			this.set('nextButtonCSSState', '');
			this.set('nextButtonState', false);
		}
		this.update();
	}
});

Ractive.components["ux-top-bar-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-top-bar-singtel'],
	decorators: {
		tooltip: ractiveTooltip
	},

	onrender: function () {
		var self = this;
		self.set('show_tooltip', false);
		var topbar = document.querySelector('.ux-top-bar-singtel');
		var stickyStartPos = topbar.getBoundingClientRect().top;
		$(window).scroll(function () {
			if (document.querySelector('.ux-summary-accordion') && ($(this).scrollTop() > stickyStartPos)) {
				var testAccordion = document.querySelector('.ux-summary-accordion');
				if (testAccordion.getBoundingClientRect().top < 0) {
					self.set('isSticky', true);
					var el = document.querySelector('.bottom-summary-panel');
					if (el) {
						var rect = el.getBoundingClientRect();
						if (rect.top < document.querySelector('.ux-top-bar-singtel').getBoundingClientRect().height +
							document.querySelector('.ux-top-bar-singtel').getBoundingClientRect().top) {
							self.set('isSticky', false);
						}
					}
				}
			}
			if (document.querySelector('.ux-summary-accordion').getBoundingClientRect().top >
				document.querySelector('.ux-top-bar-singtel').getBoundingClientRect().top - 70) {
				self.set('isSticky', false);
				self.set('offsetTop', false);
			}


			if (this.pageScroll > window.pageYOffset || window.pageYOffset < 120) {
				if (!self.get('offsetTop') && self.get('isSticky')) {
					self.set('offsetTop', true);
				}
			} else {
				if (self.get('offsetTop')) {
					self.set('offsetTop', false);
				}
			}
			this.pageScroll = window.pageYOffset;

		});

		this.on('showTooltip', function (event) {

			if (event.original.currentTarget.nextElementSibling.style.display !== 'block') {
				_.each(document.getElementsByClassName('tooltip'), function (v) {
					v.style.display = 'none';
				});
				event.original.currentTarget.nextElementSibling.style.display = 'block';
			} else {
				event.original.currentTarget.nextElementSibling.style.display = 'none';
			}

			return false;
		});
	}
});

Ractive.components["ux-tout-singtel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-tout-singtel'],
	onrender: function () {
	
		switch (this.get('topSpacing')) {
			case 'small':
				this.set('topSpacing', 'small');
				break;
			case 'medium':
				this.set('topSpacing', 'medium');
				break;
			case 'large':
				this.set('topSpacing', 'large');
				break;
			default:
				this.set('topSpacing', 'normal');
		}

	
		switch (this.get('bottomSpacing')) {
			case 'small':
				this.set('bottomSpacing', 'small');
				break;
			case 'medium':
				this.set('bottomSpacing', 'medium');
				break;
			case 'large':
				this.set('bottomSpacing', 'large');
				break;
			default:
				this.set('bottomSpacing', 'normal');
		}

	
		switch (this.get('leftSpacing')) {
			case 'small':
				this.set('leftSpacing', 'small');
				break;
			case 'medium':
				this.set('leftSpacing', 'medium');
				break;
			case 'large':
				this.set('leftSpacing', 'large');
				break;
			default:
				this.set('leftSpacing', 'normal');
		}

	
		switch (this.get('rightSpacing')) {
			case 'small':
				this.set('rightSpacing', 'small');
				break;
			case 'medium':
				this.set('rightSpacing', 'medium');
				break;
			case 'large':
				this.set('rightSpacing', 'large');
				break;
			default:
				this.set('rightSpacing', 'normal');
		}
	}
});

Ractive.components["ux-tradein-modal"] = Ractive.extend({
	template: LUXComponentTemplates['ux-tradein-modal'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	},
	onconfig: function () {
		this.set('modelDropdownStatus', true);
		this.set('sizeDropdownStatus', true);
		this.set('displayTradeinValue', false);
		this.tradeInData = this.get('brands');

		this.on('*.onBrandsChange', function () {
			var selectedTitle = this.event.component.get('selectedTitle');
			this.enableModelDropdown(selectedTitle);
		});

		this.on('*.onModelsChange', function () {
			var selectedTitle = this.event.component.get('selectedTitle');
			this.displayTradeinPrice(selectedTitle);
		});

		this.on('*.onSubmitModal', function () {
			var updatedObj = {
				'tradeinPhoneModel': this.selectedSize,
				'tradeinPhoneValue': this.get('tradeinValue'),
				'brand': this.get('brand'),
				'displayTradeinValue': true
			};
			this.fire('updateTradeinObj', updatedObj);
		});
	},
	enableModelDropdown: function (title) {
		var selectedBrandObj = this.tradeInData.filter(function (arrObj) {
			return title === arrObj.title;
		})[0];
		this.selectedBrandModels = selectedBrandObj.models;
		this.set('models', this.selectedBrandModels);
		this.set('brand', title);
		this.set('modelDropdownStatus', '');
	},
	displayTradeinPrice: function (title) {
		this.selectedSize = title;
		var selectedSizeObj = this.get('models').filter(function (arrObj) {
			return title === arrObj.title;
		})[0];
		this.set('tradeinValue', selectedSizeObj.tradePrice);
	}
});

Ractive.components["ux-tv-carousel"] = Ractive.extend({
	template: LUXComponentTemplates['ux-tv-carousel'],
	selectItem: function (index) {
		var videoId = this.get('tvCarouselModelList.' + index + '.videoId');

		if (videoId !== '') {
			var host = 'https://www.youtube.com/embed/';
			this.set('currentItem.videoURL',
				host + videoId + '?autoplay=1');
			this.set('currentItem.type', 'video');
		}
		this.set('currentItem.displayState', true);
	},
	showImage: function (index) {
		var mImagePath = this.get('tvCarouselModelList.' + index + '.mImagePath');
		var imagePath = this.get('tvCarouselModelList.' + index + '.imagePath');
		var imageAltText = this.get('tvCarouselModelList.' + index + '.mImageAltText');
		var description = this.get('tvCarouselModelList.' + index + '.description');
		this.set('currentItem.mImagePath', mImagePath);
		this.set('currentItem.imagePath', imagePath);
		this.set('currentItem.imageAltText', imageAltText);
		this.set('currentItem.description', description);
		this.set('currentItem.type', 'image');
		this.displayModal('imageTypeModal');
	},
	displayModal: function (modal_id) {
	
		var modals = this.findAllComponents('ux-modal');
		var modal = _.find(modals, function (modal) {
			return modal.get('modal_id') === modal_id;
		});
		modal.set('displayState', true);
	},
	onrender: function () {
		var self = this;
		self.swiper = new Swiper(self.find('.swiper-container'), {
			direction: 'horizontal',
			nextButton: this.find('.swiper-button-next'),
			prevButton: this.find('.swiper-button-prev'),
			slidesPerView: 6,
			loop: false,
			spaceBetween: 0,
			breakpoints: {
				640: {
					slidesPerView: 3,
					spaceBetween: 10
				},
				960: {
					slidesPerView: 4,
					spaceBetween: 10
				},
				1200: {
					slidesPerView: 5,
					spaceBetween: 10
				}
			}
		});

		self.on('selectItem', function (event, index) {
			this.selectItem(index, false);
		});

		self.on('selectImage', function (event, index) {
			this.showImage(index, false);
		});

	}
});

Ractive.components["ux-tv-channel-epg"] = Ractive.extend({
	template: LUXComponentTemplates['ux-tv-channel-epg'],
	mapOptions: function (arr) {
		return arr.map(function (arrItem) {
			return {
				'value': arrItem,
				'text': arrItem
			};
		});
	},
	oninit: function () {
		this.showIndex = 1;
		this.channelListsShown = 20;
		var tvlist = this.get('tvChannelLists');
		var filterList = _.filter(tvlist, function (allList) {
			return allList.epgChannelId;
		});
		if (filterList && filterList.length) {
			this.set('tvChannelLists', filterList);
		}
		this.set('searchFilter', '');
		var catchUpCount = this.getCatchUpCount();
		var chListCount = this.get('tvChannelLists').length;

		this.set('catchUpCount', catchUpCount);
		this.set('broadcastCount', chListCount - catchUpCount);
		this.initEpgDetails();
	},
	getCatchUpCount: function () {
		var channelList = this.get('tvChannelLists');
		if (channelList) {
			var catchUpCh = channelList.filter(function (item) {
				return item.catchUp;
			});
			return catchUpCh.length;
		}
		return 0;
	},
	initEpgDetails: function () {
		this.scope = {
			hourStart: 0,
			hourEnd: 24
		};

		var daysToShow = Array.apply(null, {length: 7}).map(Number.call, Number);
		daysToShow = daysToShow.map(function (dateItem) {
			return {
				momentObj: moment().add(dateItem, 'days'),
				dayOfWeek: moment().add(dateItem, 'days').calendar(null, {
					sameDay: '[Today]',
					nextDay: 'ddd',
					nextWeek: 'ddd'
				}),
				dateStr: moment().add(dateItem, 'days').format('DD MMM'),
				completeDate: moment().add(dateItem, 'days').format('DDMMYYYY')
			};
		});
		this.set('daysToShow', daysToShow);
		this.set('daysToShow.0.selectState', true);

		var hourEnd = this.scope.hourEnd * 2;

		var timeToShow = Array.apply(null, {length: hourEnd}).map(Number.call, Number);
		timeToShow = timeToShow.map(function (timeItem) {
			return {
				momentObj: moment().startOf('day').add(timeItem * 30, 'm'),
				timeOfDay: moment().startOf('day').add(timeItem * 30, 'm').format('h:mm a')
			};
		});

		this.set('timeToShow', timeToShow);
		this.scopeDurationHours = this.getDurationHours(this.scope.hourStart, this.scope.hourEnd);

		this.visible = 7;
		this.index = 0;
		this.lastScrollLeft = 0;
		this.loadDayProgramme(moment(new Date()).format('DDMMYYYY'));//13062016
	},
	onrender: function () {
		var self =  this;
		self.set('headerTop', 0);
		this.observe('programmes', function (newValue, oldValue, keypath) {
			if (newValue !== oldValue && newValue !== 'undefined' && newValue !== null) {
				this.showIndex = 1;
				this.channelListsShown = 20;
				this.set('searchFilter', '');
				window.scrollTo(0, 0);
				this.filterChannelList();
				this.initShows();
				this.showChannelLists(this.showIndex, this.channelListsShown, null);
			
			}
		}.bind(this));
		self.on('ux-input-box.searchChannel', function ($event) {
			this.debounce(event);
		});
		this.renderEpg();
		this.isProcessList = false;
		Ractive.defaults.on('showTvHeader', function (hideBanner) {
			var headerHeight = $('.ux-header-singtel').outerHeight(true) || 0;
			if (hideBanner && self.get('sticky')) {
				self.set('headerTop', 0);
			} else {
				self.set('headerTop', headerHeight);
			}
		});
		var lazyLoadList = _.debounce(function () {
			var windowInnerHeight = window.innerHeight;
			var threshold = windowInnerHeight;
			var listBottom = $('.show-for-medium-up .channelList')[0].getBoundingClientRect().bottom || 0;
			if (listBottom === 0) {
				listBottom = $('.show-for-small-only .channelList')[0].getBoundingClientRect().bottom;
			}
			if ((listBottom - windowInnerHeight < (threshold / 2)) && !self.isProcessList) {
			
				self.showIndex++;
				self.isProcessList = true;
			
				setTimeout(function () {
				
					self.showChannelLists(self.showIndex, self.channelListsShown, null);
				}.bind(self), 0);
			}
		}, 300);
	
		window.addEventListener('scroll', lazyLoadList);
		window.addEventListener('scroll', function () {
			var extraPadding = 0;
			var header = document.getElementById('header-section');
			var sticky = header.getBoundingClientRect();
			var parent = document.getElementsByClassName('timetable');
			var contentList = $('.show-for-medium-up .channelList')[0].getBoundingClientRect();
			var headerOftset = self.get('headerTop') || 50;
			if ($('.epg_time')[0].getBoundingClientRect().left > 0) {
				contentList = $('.show-for-small-only .channelList')[0].getBoundingClientRect();
			}
			if ((window.pageYOffset > sticky.bottom) && ((contentList.bottom - headerOftset) > window.innerHeight)) {
				if (parent.length > 0) {
					_.forEach(parent, function (ch) {
						if (ch.offsetWidth > 0) {
							var topValue = sticky.height + extraPadding;
							self.set('stickyWidth', ch.offsetWidth);
							self.set('stickTop', topValue);
							self.set('sticky', true);
						
						
						
						
						
						
						}
					});
					$('#epg-time').scrollLeft(self.lastScrollLeft);
				}
			} else if ((window.pageYOffset < (sticky.bottom / 2)) && (header.classList.contains('stick'))) {
				self.set('sticky', false);
				self.set('stickyWidth', 0);
				self.set('stickTop', 0);
			
			
			
			
			}
		});
	
	
	
		window.onload = function () {
			self.scrollToEpgMarker();
		};
	},
	renderEpg: function () {
		var self =  this;
	
	
	
	
	
		$('.section').on('scroll', function (event) {
			var documentScrollLeft = $(this).scrollLeft();
			if (self.lastScrollLeft !== documentScrollLeft) {
				self.lastScrollLeft = documentScrollLeft;
				$('#epg-time').scrollLeft(documentScrollLeft);
				if ($('.epg_time')) {
					$('.epg_time').animate({scrollLeft: documentScrollLeft}, 0);
				}
			}
		});

		self.on('selectDay', function (event, dateStr) {
			var selectStr = event.keypath + '.selectState';
			self.set('daysToShow.*.selectState', false);
			self.toggle(selectStr);
		
		
		
			self.loadDayProgramme(dateStr);
		});

		self.on('onPrev', function (event) {
			this.slideRight();
		});
		self.on('onPrevDay', function () {
			var parentWidth = $('#mob-day-selector')[0].getBoundingClientRect();
			var lastDayScroll = $('#mob-day-container').scrollLeft();
			$('.day-selector').animate({scrollLeft: parentWidth.width + lastDayScroll}, 200);
		});
		self.on('onNextDay', function () {
			var parentWidth = $('#mob-day-selector')[0].getBoundingClientRect();
			var lastDayScroll = $('#mob-day-container').scrollLeft();
			$('.day-selector').animate({scrollLeft: lastDayScroll - parentWidth.width }, 200);
		});
		self.on('onNext', function (event) {
			this.slideLeft();
		});

		self.on('*.navigateShow', function (achorComponent) {
			this.showDetails(achorComponent.get('channelid'),
				achorComponent.get('programid'), achorComponent.get('starttime'), achorComponent.get('channelId'));
		});
		self.on('*.doCloseModal', function (event) {
			this.resetScroll();
		});
		self.on('selectShow', function (event, channel, programId, startTime, channelId) {
			this.showDetails(channel, programId, startTime, channelId);
			this.set('lastYScroll', window.scrollY);
			this.handleModal(true, 'programmeModal');
		});

		self.set('epgMarker', this.computeEventBlockOffset(new Date()) + '%');
		setInterval(function () {
			self.set('epgMarker', self.computeEventBlockOffset(new Date()) + '%');
		}, 60000);
	},
	scrollToEpgMarker: function () {
		var boundIndex;
		var containerIndex;
		var offset;
		if ($('#epg-marker')[0].getBoundingClientRect().left > 0) {
			boundIndex = $('#epg-marker')[0].getBoundingClientRect();
			containerIndex = $('#section_des')[0].getBoundingClientRect();
			offset = containerIndex.left + 100;
		} else {
			boundIndex = $('.epg_marker')[0].getBoundingClientRect();
			containerIndex = $('#section_mob')[0].getBoundingClientRect();
			offset = containerIndex.left + (containerIndex.width / 2);
		}
		if (boundIndex && containerIndex) {
			$('.section').animate({scrollLeft: boundIndex.left - offset}, 200);
		}
	},
	loadDayProgramme: function (param) {
		var urlCall = this.get('epgEndPoint') + '/' + param + '.json';
		this.set('inProcess', true);
		this.set('selectedDate', param.slice(0, 2));
		RactiveHelpers.doAjaxJSONCall('GET', urlCall,
		function (response) {
			this.set('programmes', response);
		}.bind(this),
		function (error) {
			console.log('Error loading programme.');
			this.set('programmes', []);
			this.set('selectedDate', '');
			this.set('inProcess', false);
		}.bind(this)
		);
	},
	showDetails: function (channel, programId, startTime, channelId) {

		var programme = this.getChannelProgramme(channel);

		if (programme && programme.length > 0) {

			for (var j = 0; j < programme.length; j++) {

				var progItem = programme[j];

				if (programId === progItem.program.id &&
					moment(startTime).format('ddd Do MMM, h:mm a') ===
					moment(progItem.startDateTime).format('ddd Do MMM, h:mm a')) {

					var duration = parseInt(progItem.duration) / 60;
					var startDate = new Date(moment(progItem.startDateTime));
					var endDate = new Date(startDate);
					endDate.setMinutes(startDate.getMinutes() + duration);
					var progValues = progItem.program.programValues;
					var programFlags =  progItem.program.programflags;
					var names =  progItem.program.names;
					var episode = null;
					var pg = null;
					var ptype = null;
					var actors = '';
					var directors = '';


					if (progValues && progValues.length > 0) {
						for (var i = 0; i < progValues.length; i++) {
							if (progValues[i].name === 'MDA') {
								pg = progValues[i].description;
							}
							if (progValues[i].name === 'MSEPG_Syndicated_Episode_Number') {
								episode = progValues[i].description;
							}
						}
					}

					if (programFlags && programFlags.length > 0) {
						ptype = programFlags[0].description;
					}

					if (names && names.length > 0) {
						for (var k = 0; k < names.length; k++) {
							var firstName = names[k].firstName;
							var lastName = names[k].lastName;

							if (names[k].role === 'Actor') {
								if (actors.length > 0) {
									actors += ', ';
								}
								actors += firstName + ' ' + lastName;
							}
							if (names[k].role === 'Director') {
								if (directors.length > 0) {
									directors += ', ';
								}
								directors += firstName + ' ' + lastName;
							}
						}

					}

					var prevProgramme = programme[j - 1];
					var nextProgramme = programme[j + 1];
					this.set('prevP', prevProgramme);
					this.set('nextP', nextProgramme);

					if (prevProgramme) {
						this.set('prevP.prevEpisode', this.getEpisode(prevProgramme.program.programValues));
						this.set('prevP.prevTime', moment(prevProgramme.startDateTime).format('h:mm a'));
						this.set('prevP.startDateTime', prevProgramme.startDateTime);
						this.set('prevP.channelId', channelId);
					}

					if (nextProgramme) {
						this.set('nextP.nextEpisode', this.getEpisode(nextProgramme.program.programValues));
						this.set('nextP.nextTime', moment(nextProgramme.startDateTime).format('h:mm a'));
						this.set('nextP.startDateTime', nextProgramme.startDateTime);
						this.set('nextP.channelId', channelId);
					}

					var modalDetails = [{
						progTitle: progItem.program.title,
						progDescription: progItem.program.description,
						channel: progItem.channelid,
						duration: duration,
						pg: pg,
						episode: episode,
						actors: actors,
						directors: directors,
						schedule: moment(startDate).format('ddd Do MMM, h:mm a') +
							' - ' + moment(endDate).format('ddd Do MMM, h:mm a'),
						channelId: channelId
					}];
					this.set('progDetails', modalDetails);
				}

			}
		}
	},
	getEpisode: function (progValues) {
		if (progValues && progValues.length > 0) {
			for (var i = 0; i < progValues.length; i++) {
				if (progValues[i].name === 'MSEPG_Syndicated_Episode_Number') {
					return progValues[i].description;
				}
			}
		}
	},
	slideLeft: function () {
		$('.section').animate({scrollLeft: this.lastScrollLeft - 600}, 300);
	},
	slideRight: function () {
		$('.section').animate({scrollLeft: this.lastScrollLeft + 600}, 300);
	},
	getChannelList: function () {
		var channels = this.get('filteredChannelList');
		var chList = [];

		channels.forEach(function (ch) {
			if (ch.display === true) {
				chList.push({
					channelId: ch.channelId,
					img: ch.image,
					alt: ch.title,
					display: ch.display
				});
			}
		});
		return chList;
	},
	isValidHourRange : function (start, end) {
		return this.isValidHour(start) && this.isValidHour(end);
	},
	isValidHour : function (number) {
		return this.isInt(number) && this.isInHourRange(number);
	},
	isInt : function (number) {
		return number === parseInt(number, 10);
	},
	isInHourRange : function (number) {
		return number >= 0 && number < 24;
	},
	channelExists : function (channel, channelList) {
		var channelArr = channelList.map(function (channelItem) {
			return channelItem.channelId;
		});

		return channelArr.indexOf(channel) !== -1;
	},
	isValidTimeRange : function (start, end) {
		var correctTypes = start instanceof Date && end instanceof Date;
		var correctOrder = start < end;
		return correctTypes && correctOrder;
	},
	getDurationHours : function (startHour, endHour) {
		return endHour >= startHour ? endHour - startHour : 24 + endHour - startHour;
	},
	addChannels : function (channels) {
		function hasProperFormat() {
			return channels instanceof Array;
		}

		var existingChannels = [];

		if (hasProperFormat()) {
			channels.forEach(function (ch) {
				existingChannels.push(ch);
			}.bind(this));
		} else {
			throw new Error('Tried to add channel in wrong format');
		}
		this.set('existingChannels', existingChannels);
		return this;
	},
	prettyFormatHour : function (hour) {
		var prefix = hour < 10 ? '0' : '';
		return prefix + hour + ':00';
	},
	emptyNode : function (node) {
		while (node.firstChild) {
			node.removeChild(node.firstChild);
		}
	},
	getChannelProgramme: function (channelId) {
		var programme = this.get('programmes');
		if (programme && channelId && programme[channelId]) {
			return programme[channelId];
		} else {
			return false;
		}
	},
	initShows : function () {
		var selectedChannels = this.get('filteredChannelList');

		for (var i = 0; i < selectedChannels.length; i++) {
			var tvProgramme = [];
			var chId = selectedChannels[i].epgChannelId;
			var chIdToDisplay = selectedChannels[i].channelId;
			var programme = this.getChannelProgramme(chId);
			if (programme && programme.length > 0) {
				for (var j = 0; j < programme.length; j++) {
					var startDate = new Date(moment(programme[j].startDateTime));
					var endDate = new Date(startDate);
					endDate.setMinutes(startDate.getMinutes() + (parseInt(programme[j].duration) / 60));
					var selectedDate = this.get('selectedDate');
					var channel = programme[j].channelid;
					var width = this.computeEventBlockWidth(startDate, endDate);
					var left = 0;
					if (Number(selectedDate) === startDate.getDate()) {
						left = this.computeEventBlockOffset(startDate);
					}
					var title = programme[j].program.title;
					var description = programme[j].program.description;
					var programId = programme[j].program.id;
					var episode = this.getEpisode(programme[j].program.programValues);
				

					if (width < 1) {
						title = '...';
						episode = null;
					}

				
				
				
				
				
				
				
				
				
				
				
				
				
				
				
					tvProgramme.push({
						programId: programId,
						name: title,
						description: description,
						channel: channel,
						startDate: startDate,
						endDate: endDate,
						left: left + '%',
						width: width + '%',
						episode: episode,
						chIdToDisplay: chIdToDisplay
					});
				}
			}
			selectedChannels[i].tvProgramme = tvProgramme;
		}
		$('#loader').removeClass('active');
		this.set('inProcess', false);
	},
	showFilters: function () {
		var category = this.get('category');

		if (category === 'Genre') {
			this.set('filterBy', this.mapOptions(this.get('genreList')));
			this.set('filter', this.get('genreList')[0]);
		} else if (category === 'Pack') {
			var tvPackNames = this.get('packList').map(function (tvPackItem) {
				return tvPackItem.packName;
			});
			this.set('filterBy', this.mapOptions(tvPackNames));
			this.set('filter', this.get('packList')[0].packName);
		} else if (category === 'Language') {
			this.set('filterBy', this.mapOptions(this.get('languageList')));
			this.set('filter', this.get('languageList')[0]);
		} else {
			this.set('filterBy', [{}]);
		}
	},
	showChannelLists: function (num, channelListShown, filterList) {

		var channelList = filterList || this.get('filteredChannelList');

		if (num === undefined) {
			num = 1;
		}
		if (channelListShown === undefined) {
			channelListShown = this.showIndex * this.channelListShown;
		}

		if (channelList && channelList.length > 0) {
			_.each(channelList, function (ch, index) {
				if (Math.ceil((1 + index) / channelListShown) === num) {
					ch.display = true;
				} else if (Math.ceil((1 + index) / channelListShown) > num) {
					ch.display = false;
				}
			});
			this.set('filteredChannelList', channelList);
		}
		this.isProcessList = false;
		this.set('inProcess', false);
	},
	debounce: function (event)  {
		var inDebounce;
		var self = this;
		clearTimeout(inDebounce);
		inDebounce = setTimeout(function () {
			self.set('inProcess', true);
			self.filterChannelList();
		}, 1000);
	},
	filterChannelList: function () {
		var channelList = this.get('tvChannelLists');
		var searchFilter = this.get('searchFilter');
		var channelListFiltered = [];
		this.showIndex = 1;
		this.channelListsShown = 20;
		if (searchFilter && searchFilter.length > 2) {
			channelListFiltered = channelList.filter(function (item) {
				if (item.title.toUpperCase().indexOf(searchFilter.toUpperCase()) !== -1) {
					return true;
				} else {
					return false;
				}
			});
		} else {
			channelListFiltered = channelList;
		}
		if (channelListFiltered.length > 0) {
			channelListFiltered.sort(function (a, b) {
				return a.channelId - b.channelId;
			});
			this.showChannelLists(this.showIndex, this.channelListsShown, channelListFiltered);
		} else {
			this.set('filteredChannelList', []);
			this.set('inProcess', false);
		}
	},
	computeDurationInHours: function (start, end) {
		return (end.getTime() - start.getTime()) / 1000 / 60 / 60;
	},
	computeEventBlockWidth: function (startDate, endDate) {
		var selectedDate = this.get('selectedDate');
		var durationHours = this.computeDurationInHours(startDate, endDate);
		if (Number(selectedDate) !== startDate.getDate()) {
			durationHours = endDate.getHours() + (endDate.getMinutes() / 60);
		}
		if (Number(selectedDate) !== endDate.getDate()) {
			var startHours = startDate.getHours() + (startDate.getMinutes() / 60) + durationHours;
			if (startHours > this.scopeDurationHours) {
				durationHours = durationHours - (startHours - this.scopeDurationHours);
			}
		}
		return durationHours / this.scopeDurationHours * 100;
	},
	computeEventBlockOffset: function (startDate) {
		var scopeStartHours = this.scope.hourStart;
		var eventStartHours = startDate.getHours() + (startDate.getMinutes() / 60);
		var hoursBeforeEvent =  this.getDurationHours(scopeStartHours, eventStartHours);
		return hoursBeforeEvent / this.scopeDurationHours * 100;
	},
	handleModal: function (visibility, cardId) {
		var modals = this.parent.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return cardId === component.get('modalId');
		})[0];
		modal.set('displayState', visibility);
	},
	resetScroll: function () {
		var lastYScroll = this.get('lastYScroll');
		if (lastYScroll > 0 && (window.scrollY !== lastYScroll)) {
			window.scrollTo(0, lastYScroll);
		}
	}
});

Ractive.components["ux-tv-channel-listing"] = Ractive.extend({
	template: LUXComponentTemplates['ux-tv-channel-listing'],
	mapOptions: function (arr) {
		return arr.map(function (arrItem) {
			return {
				'value': arrItem.value,
				'text': arrItem.name
			};
		});
	},
	data: function () {
		return {
			cropTextConfig: ConfigStrings.tvCropTextConfig
		};
	},
	oninit: function () {
		this.showIndex = 0;
		var packList = this.mapOptions(this.get('packList'));
		if (packList && packList.length > 0) {
			packList.unshift({'text': 'All', 'value': 'All'});
			this.set('packList', packList);
		}
		this.set('categories', this.mapOptions(this.get('languageList')));
		this.set('category', 'All');
		this.set('genreList', this.mapOptions(this.get('genreList')));
		this.set('genre', 'All');
	
		this.set('pack', 'All');
		this.set('tvTypeFilters', this.get('singtelTvType'));
		this.set('tvType', 'singtel_tv');
		this.set('tvTypeFilters.0.selectState', true);
		this.on('ux-multi-select.selectCategory', function (selectedlang) {
			console.log(selectedlang);
			if (selectedlang) {
				this.set('category', selectedlang);
				if (selectedlang.length === 0) {
					this.showIndex = 0;
					this.filterChannelList();
				}
			}
		});
		this.on('ux-multi-select.selectedGenre', function (selectedGenre) {
			console.log(selectedGenre);
			if (selectedGenre) {
				this.set('genre', selectedGenre);
				if (selectedGenre.length === 0) {
					this.showIndex = 0;
					this.filterChannelList();
				}
			}
		});
	},
	getCatchUpCount: function () {
		var channelList = this.get('genreChannels');
		if (channelList) {
			var catchUpCount = 0;
			var chListCount = 0;
			_.each(channelList, function (list) {
				chListCount = chListCount + list.channels.length;
				var catchUpItem = _.filter(list.channels, function (item) {
					return item.catchUp;
				});
				if (catchUpItem) {
					catchUpCount = catchUpCount + catchUpItem.length;
				}
			});
			this.set('catchUpCount', catchUpCount);
			this.set('broadcastCount', chListCount - catchUpCount);
		}
		return 0;
	},
	onrender: function () {
		var self = this;
		this.observe('pack category genre tvType', function (newValue, oldValue, keypath) {
			if (newValue !== oldValue && newValue !== 'undefined' && newValue !== null &&
			(typeof newValue.length === 'undefined' || newValue.length === null || newValue.length > 0)) {
				if (keypath !== 'pack' && keypath !== 'tvType') {
					this.showIndex = -1;
				}
				this.filterChannelList();
			}
		}.bind(this));

		self.on('selectChannel', function (event, x, y) {
			var flipSelectStr = 'genreChannels.' + x + '.channels.' + y + '.flipState';
			this.toggle(flipSelectStr);
		});

		self.on('selectTvType', function (event, type) {
			var selectStr = event.keypath + '.selectState';
			this.set('tvTypeFilters.*.selectState', false);
			this.toggle(selectStr);
			this.set('tvType', type);
		});
		$(window).on('scroll', function (event) {
			var header = document.getElementById('header-section');
			var sticky = header.getBoundingClientRect();
			var parent = $('.channelList')[0].getBoundingClientRect();
			var extraPadding = 0;
			if ($(window).scrollTop() + $(window).height() >= parent.height) {
				if (self.showIndex >= 0) {
					self.showAllChannels();
				}
			}
			if (window.innerWidth >= ConfigStrings.mediaBreakpoints.small) {
				if (window.pageYOffset > sticky.bottom) {
					if (parent && parent.width > 0 && (parent.bottom > window.innerHeight)) {
						header.classList.add('stick');
						$('#header-section').width(parent.width - 20).css('top', extraPadding);
					}
				} else if ((window.pageYOffset < (sticky.bottom / 2)) && header.classList.contains('stick')) {
					header.classList.remove('stick');
					$('#header-section').width('').css('top', 0);
				}
			}
		});
	},
	filterChannelList: function () {
		this.set('inProcess', true);
		setTimeout(function () {
			var genreList = this.get('genreChannels');
			var genre = this.get('genre');
			var allGenreValues = [];
			var category = this.get('category');
			var tvType = this.get('tvType');
			var pack = this.get('pack');
			var catchUpCount = 0;
			var chListCount = 0;
			if (typeof genre === 'object' && genre.length) {
				_.each(genre, function (el) {
					allGenreValues.push(el.value);
				});
			}
			var hasGenres = false;
			var count = 0;
			_.each(genreList, function (genres) {
				if (allGenreValues.length > 0) {
					if (_.contains(allGenreValues, genres.value)) {
						genres.displayGenre = true;
					} else {
						genres.displayGenre = false;
						genres.hideGenre = true;
					}
				} else {
					genres.displayGenre = true;
				}
				if (genres.displayGenre) {
					var hasChannels = false;
					var hideGenre = true;
					_.each(genres.channels, function (channel) {
						if (_.contains(channel.type, tvType)) {
							channel.displayChannel = true;
						} else {
							channel.displayChannel = false;
						}
						if (channel.displayChannel && typeof category === 'object') {
							var languageList = channel.language;
							if (!languageList) {
								channel.displayChannel = false;
							} else {
								_.find(category, function (obj) {
									if (languageList && languageList.length && !(_.contains(languageList, obj.value))) {
										channel.displayChannel = false;
									} else {
										channel.displayChannel = true;
										return true;
									}
								});
							}
						}
						if (channel.displayChannel && pack !== 'All') {
							var packList = channel.packList;
							if (packList && packList.length && !(_.contains(packList, pack))) {
								channel.displayChannel = false;
							}
							if (!packList) {
								channel.displayChannel = false;
							}
						}
						if (channel.displayChannel && !hasChannels) {
							hasChannels = true;
						}
						if (channel.displayChannel) {
							if (channel.catchUp) {
								catchUpCount = ++catchUpCount;
							} else {
								chListCount = ++chListCount;
							}
						}
						if (channel.displayChannel && count <= ConfigStrings.channelsToShow &&
							this.showIndex >= 0) {
							channel.showChannel = true;
							hideGenre = false;
							count++;
						} else if (this.showIndex < 0) {
							channel.showChannel = true;
						} else {
							channel.showChannel = false;
						}
					}.bind(this));
					if (!hasChannels) {
						genres.displayGenre = false;
					} else {
						hasGenres = true;
					}
					if (this.showIndex < 0) {
						genres.hideGenre = false;
					} else {
						genres.hideGenre = hideGenre;
						this.showIndex = 0;
					}
				}
			}.bind(this));
			this.set('hasGenres', hasGenres);
			this.set('genreChannels', genreList);
			if (catchUpCount === 0 && chListCount === 0) {
				this.set('displayCatchUp', false);
			} else {
				this.set('catchUpCount', catchUpCount);
				this.set('broadcastCount', chListCount);
				this.set('displayCatchUp', true);
			}
			this.set('inProcess', false);
		}.bind(this), 0);
	},
	showAllChannels: function () {
		if (!this.isProcessing) {
			var genreChannels = this.get('genreChannels');
			this.isProcessing = true;
			_.forEach(genreChannels, function (genre, index) {
				if (this.showIndex === index) {
					_.map(genre.channels, function (channel) {
						channel.showChannel = true;
						genre.hideGenre = false;
						return channel;
					});
				}
			}.bind(this));
			this.set('genreChannels', genreChannels);
			this.showIndex++;
			this.isProcessing = false;
		}
	}
});

Ractive.components["ux-tv-pack-catalogue"] = Ractive.extend({
	template: LUXComponentTemplates['ux-tv-pack-catalogue'],

	onconfig: function () {
		var buttonText = this.get('buttonText');
		var buttonLink = this.get('buttonLink');
		var planText = this.get('planText');

		this.set('tvPackList.*.buttonText', buttonText);
		this.set('tvPackList.*.buttonLink', buttonLink);
		this.set('tvPackList.*.planText', planText);

	}
});

Ractive.components["ux-tv-pack-landing"] = Ractive.extend({
	template: LUXComponentTemplates['ux-tv-pack-landing']
});

Ractive.components["ux-tv-pack-listing"] = Ractive.extend({
	template: LUXComponentTemplates['ux-tv-pack-listing'],
	mapOptions: function (arr) {
		return arr.map(function (arrItem) {
			return {
				'value': arrItem.value,
				'text': arrItem.name
			};
		});
	},
	data: function () {
		return {
			'inProcess': false,
			cropTextConfig: ConfigStrings.tvCropTextConfig
		};
	},
	oninit: function () {
		var tvPackGenreList;
		var queryParam = decodeURIComponent(RactiveHelpers.getParameterByName('packName', true));
		if (queryParam) {
			var filterTvPack = _.find(this.get('tvPackGenereLists'), function (allPackList) {
				return allPackList.packName === queryParam;
			});
			tvPackGenreList = filterTvPack;
			if (typeof tvPackGenreList === 'undefined' ||
					tvPackGenreList === null || tvPackGenreList.length === 0) {
				this.set('nochannelsFlag', true);
			}
		}
		if (tvPackGenreList) {
			this.set('genreChannels', tvPackGenreList.genreChannels);
			this.set('packTitle', tvPackGenreList.packName);
			this.set('languagesList', this.mapOptions(tvPackGenreList.languageList));
			this.set('language', 'All');
			this.set('genreList', this.mapOptions(tvPackGenreList.genreList));
			this.set('genre', 'All');
			if (tvPackGenreList.childPackNames && tvPackGenreList.childPackNames.length > 0) {
				var packList = tvPackGenreList.childPackNames.map(function (item) {
					return {
						'value': item,
						'text': item
					};
				});
				packList.unshift({'text': 'All', 'value': 'All'});
				this.set('packList', packList);
				this.set('pack', 'All');
				this.set('isDisplayPack', true);
			} else {
				this.set('isDisplayPack', false);
			}
		}
		this.set('tvTypeFilters', this.get('singtelTvType'));
		this.set('tvType', 'singtel_tv');
		this.set('tvTypeFilters.0.selectState', true);
		this.on('ux-multi-select.selectLanguage', function (selectedlang) {
			console.log(selectedlang);
			if (selectedlang) {
				this.set('language', selectedlang);
				if (selectedlang.length === 0) {
					this.filterChannelList();
				}
			}
		});
		this.on('ux-multi-select.selectedGenre', function (selectedGenre) {
			console.log(selectedGenre);
			if (selectedGenre) {
				this.set('genre', selectedGenre);
				if (selectedGenre.length === 0) {
					this.filterChannelList();
				}
			}
		});
	},
	getCatchUpCount: function () {
		var channelList = this.get('genreChannels');
		if (channelList) {
			var chListCount = 0;
			_.each(channelList, function (list) {
				chListCount = chListCount + list.channels.length;
			});
			this.set('broadcastCount', chListCount);
		}
		return 0;
	},
	onrender: function () {
		var self = this;
		this.sortAllChannels();
		this.observe('pack language genre tvType', function (newValue, oldValue, keypath) {
			if (newValue !== oldValue && newValue !== 'undefined' && newValue !== null &&
			(typeof newValue.length === 'undefined' || newValue.length === null || newValue.length > 0)) {
				this.filterChannelList();
				this.showIndex = 1;
			}
		}.bind(this));

		self.on('selectChannel', function (event, x, y) {
			var flipSelectStr = 'genreChannels.' + x + '.channels.' + y + '.flipState';
			this.toggle(flipSelectStr);
		});

		self.on('selectTvType', function (event, type) {
			var selectStr = event.keypath + '.selectState';
			this.set('tvTypeFilters.*.selectState', false);
			this.toggle(selectStr);
			this.set('tvType', type);
		});
		$(document).on('click touchstart', function (event) {
			if ($('.ux-header-singtel.fixed-show').length > 0) {
				var extraTop = $('.ux-header-singtel').outerHeight(true);
				$('#header-section').css('top', extraTop);
			} else {
				$('#header-section').css('top', '');
			}
		});
		$(window).on('scroll', function (event) {
			var header = document.getElementById('header-section');
			var sticky = header.getBoundingClientRect().bottom;
			var parent = $('.channelList')[0].getBoundingClientRect();
			var extraPadding = 0;
			if (window.innerWidth >= ConfigStrings.mediaBreakpoints.small) {
				if (window.pageYOffset > sticky) {
					if (parent && parent.width > 0 && (parent.bottom > window.innerHeight)) {
						header.classList.add('stick');
						$('#header-section').width(parent.width - 20).css('top', extraPadding);
					}
				} else if ((window.pageYOffset < (sticky / 2)) && header.classList.contains('stick')) {
					header.classList.remove('stick');
					$('#header-section').width('').css('top', '');
				}
			}
		});
	},
	filterChannelList: function () {
		this.set('inProcess', true);
		setTimeout(function () {
			var genreList = this.get('genreChannels');
			var genre = this.get('genre');
			var allGenreValues = [];
			var category = this.get('language');
			var tvType = this.get('tvType');
			var pack = this.get('pack');
			var broadcastCount = 0;
			var isDisplayPack = this.get('isDisplayPack');
			if (typeof genre === 'object' && genre.length) {
				_.each(genre, function (el) {
					allGenreValues.push(el.value);
				});
			}
			var hasGenres = false;
			_.each(genreList, function (genres) {
				if (allGenreValues.length > 0) {
					if (_.contains(allGenreValues, genres.value)) {
						genres.displayGenre = true;
					} else {
						genres.displayGenre = false;
					}
				} else {
					genres.displayGenre = true;
				}
				if (genres.displayGenre) {
					var hasChannels = false;
					_.each(genres.channels, function (channel) {
						if (_.contains(channel.type, tvType)) {
							channel.displayChannel = true;
						} else {
							channel.displayChannel = false;
						}
						if (channel.displayChannel && typeof category === 'object') {
							var languageList = channel.language;
							if (!languageList) {
								channel.displayChannel = false;
							} else {
								_.find(category, function (obj) {
									if (languageList && languageList.length && !(_.contains(languageList, obj.value))) {
										channel.displayChannel = false;
									} else {
										channel.displayChannel = true;
										return true;
									}
								});
							}
						}
						if (channel.displayChannel && isDisplayPack && pack !== 'All') {
							var packList = channel.packList;
							if (packList && packList.length && !(_.contains(packList, pack))) {
								channel.displayChannel = false;
							}
							if (!packList) {
								channel.displayChannel = false;
							}
						}
						if (channel.displayChannel && !hasChannels) {
							hasChannels = true;
						}
						if (channel.displayChannel) {
							++broadcastCount;
						}
					});
					if (!hasChannels) {
						genres.displayGenre = false;
					} else {
						hasGenres = true;
					}
				}
			});
			this.set('hasGenres', hasGenres);
			this.set('genreChannels', genreList);
			if (broadcastCount === 0) {
				this.set('displayCatchUp', false);
			} else {
				this.set('broadcastCount', broadcastCount);
				this.set('displayCatchUp', true);
			}
			this.set('inProcess', false);
		}.bind(this), 0);
	},
	sortAllChannels: function () {
		var channelList = this.get('genreChannels');
		_.each(channelList, function (list) {
			for (var i = 0; i < list.channels.length - 1; i++) {
				if (list.channels[i].catchUp && list.channels[i].channelId === list.channels[i + 1].channelId) {
					var temp = list.channels[i];
					list.channels[i] = list.channels[i + 1];
					list.channels[i + 1] = temp;
				}
			}
		});
		this.set('genreChannels', channelList);
	}
});

Ractive.components["ux-tv-pack"] = Ractive.extend({
	template: LUXComponentTemplates['ux-tv-pack'],
	isolated: true,

	onconfig : function () {
		this.set('RactiveHelpers', RactiveHelpers);
	},
	toggleModal: function (modalId, displayState) {
		var modalList = this.findAllComponents('ux-modal');
		var targetModal = modalList.filter(function (modal) {
			return modal.get('modalId') === modalId;
		})[0];

		targetModal.set('displayState', displayState);
	},
	onrender : function () {

		var self = this;

		self.on('ux-button.selectplan', function (event) {
			self.fire('planselected', self);
		});

		var tvPacks = this.get('tvPacks');

		if (tvPacks) {
			tvPacks.map(function (packItem) {
				var channelList = packItem.channelList;
				if (channelList) {
					packItem.packChannelNum = packItem.channelList.length;
				}
			});
		} else {
			var channelList = this.get('channelList');
			if (channelList) {
				this.set('packChannelNum', channelList.length);
			}
		}

		self.on('showChannelModal', function (e) {
			if (e.keypath) {
				this.set('channelListInfo', this.get(e.keypath));
			} else {
				this.set('channelListInfo', this.get('channelList'));
			}
			this.toggleModal('channelList', true);
		});

	}
});

Ractive.components["ux-tv-recommender"] = Ractive.extend({
	template: LUXComponentTemplates['ux-tv-recommender'],

	onconfig: function () {
		this.set('RactiveHelpers', RactiveHelpers);
		this.set('displaySelectedResult', this.displaySelectedResult);
		this.set('tvPackHeaderTemp', this.get('tvPackHeader'));
		this.prepareLanguagesList();
	},

	prepareLanguagesList: function () {
				var languagesForIDHiding = ConfigStrings.tvRecommender.languagesforIDHiding;
		var languageList = this.get('languageList');

		if (languageList && languageList.length > 0) {
			for (var i = 0; i < languageList.length; i++) {
				if (languagesForIDHiding.indexOf(languageList[i].name) !== -1) {
					languageList[i].hideID = true;
				}
			}
			this.set('languageList', languageList);
		}
	},

	toggleModal: function (modalId, displayState) {
		var modalList = this.findAllComponents('ux-modal');
		var targetModal = modalList.filter(function (modal) {
			return modal.get('modalId') === modalId;
		})[0];

		targetModal.set('displayState', displayState);
	},

	displaySelectedResult: function (arr) {
		return arr.reduce(function (previousValue, currentValue, currentIndex) {
			if (currentIndex === 0) {
				return currentValue;
			} else {
				return previousValue + ', ' + currentValue;
			}
		}, '');
	},

	filterList: function (list) {
		var listFiltered = list.map(function (item) {
			if (item.chosen) {
				if (item.id) {
					return item.id;
				} else {
					return item.name;
				}
			}
		}).filter(function (item) {
			return item !== undefined;
		});

		return listFiltered;
	},

	setPackAlignment: function (defaultPlanAlign, firstPlanAlign, secondPlanAlign,
	position, packDetail, packListShown) {
		var defaultReasonText = packDetail.defaultRecommendedPlanText;
		var firstReasonText = packDetail.firstRecommendedPlanText;
		var secondReasonText = packDetail.secondRecommendedPlanText;

		var defaultPanelText = this.get('defaultAnswPanelText');
		var firstPanelText = this.get('firstRecommendedPanelText');
		var secondPanelText = this.get('secondRecommendedPanelText');

		this.addToPlanList(defaultPlanAlign, position, packDetail,
		packListShown, defaultReasonText, defaultReasonText, defaultPanelText);
		if (packDetail.firstRecommendedPack) {
			this.addToPlanList(firstPlanAlign, position,
			packDetail.firstRecommendedPack, packListShown, firstReasonText, defaultReasonText, firstPanelText);
		}
		if (packDetail.secondRecommendedPack) {
			this.addToPlanList(secondPlanAlign, position,
			packDetail.secondRecommendedPack, packListShown, secondReasonText, defaultReasonText, secondPanelText);
		}
	},

	addToPlanList : function (planAlignment, position, planValue, packListShown,
	reasonText, defaultReasonText, panelText) {
		if (planAlignment === position) {
			planValue.recommendedPlanText = reasonText !== null ? reasonText : defaultReasonText;
			planValue.panelText = panelText;
			packListShown.push(planValue);
		}
	},

	filterTVPacks: function () {
		var languageListFiltered = this.get('languageListFiltered');
		var genreListFiltered = this.get('genreListFiltered');
		var packList = this.get('packList');
		var defaultPlanAlign = this.get('defaultAnswerAlign');
		var firstPlanAlign = this.get('firstRecommendedPlanAlign');
		var secondPlanAlign = this.get('secondRecommendedPlanAlign');

		var packListSorted = packList.filter(function (item) {
			var languagesIncluded = item.languagesIncluded;
			var genresIncluded = item.genresIncluded;
			var upperCaseGenreListFiltered;
			if (genreListFiltered) {
				upperCaseGenreListFiltered = genreListFiltered.map(function (value) {
					return value.toUpperCase();
				});
			}
			var upperCaseGenresIncluded;
			if (genresIncluded) {
				upperCaseGenresIncluded = genresIncluded.map(function (value) {
					return value.toUpperCase();
				});
			}
			var langDifference;
			if (languageListFiltered && languagesIncluded) {
				langDifference = languageListFiltered.filter(function (value) {
					return languagesIncluded.indexOf(value) === -1;
				});
			}
			var genreDifference;
			if (genreListFiltered && genresIncluded) {
				genreDifference = upperCaseGenreListFiltered.filter(function (value) {
					return upperCaseGenresIncluded.indexOf(value) === -1;
				});
			}
			if (langDifference && genreDifference && (langDifference.length > 0 || genreDifference.length > 0)) {
				return;
			} else {
				return item;
			}
		}).sort(function (a, b) {
			return a.salesRanking - b.salesRanking;
		});

		console.log('packListSorted', packListSorted);
		var packListShown = [];
		if (packListSorted.length > 0) {
			this.setPackAlignment(
				defaultPlanAlign, firstPlanAlign, secondPlanAlign, 'first', packListSorted[0], packListShown);

			this.setPackAlignment(
				defaultPlanAlign, firstPlanAlign, secondPlanAlign, 'second', packListSorted[0], packListShown);

			this.setPackAlignment(
				defaultPlanAlign, firstPlanAlign, secondPlanAlign, 'third', packListSorted[0], packListShown);
		}

		if (packListShown.length === 0) {
			packListShown = null;
			this.set('tvPackHeader', this.get('tvPackNotFoundText'));
		} else {
			this.set('tvPackHeader', this.get('tvPackHeaderTemp'));
		}
		this.set('packListShown', packListShown);
	},

	onrender: function () {
		var packList = this.get('packList');

		packList.map(function (packItem) {
			packItem.packNum = packItem.tvPacks.length;
			packItem.channelNum = packItem.tvPacks.reduce(function (total, starterPack) {
				if (null !== starterPack.channelList) {
					return total + starterPack.channelList.length;
				}
			}, 0);

			packItem.tvPacks.map(function (starterPack) {
				starterPack.packChannelNum = starterPack.channelList ? starterPack.channelList.length : 0;
			});
		});

		this.on('*.openRecommenderModal', function (event) {
			this.toggleModal('selectModal', true);
		});

		this.on('*.showPackList', function (event) {
			this.set(event.keypath + '.listView', true);
		});

		this.on('*.choose', function (event) {
			var isChosen = this.get(event.keypath + '.chosen');
			var listType = event.keypath.split('.')[0];
			var list = this.get(event.keypath.split('.')[0]);

			if (isChosen) {
				this.set(event.keypath + '.chosen', false);
				var listFiltered = this.filterList(list);
				this.set(listType + 'Filtered', listFiltered);
			} else {
				this.set(event.keypath + '.chosen', true);
				var listFiltered = this.filterList(list);
				this.set(listType + 'Filtered', listFiltered);
			}
		});

		this.on('*.showChannelModal', function (e) {
			this.set('channelListInfo', this.get(e.keypath));
			this.toggleModal('channelList', true);

		});

		this.on('*.languageNext', function (event) {
			this.set('languageResults', true);
			if (!this.get('genreResults')) {
				this.set('genrePanel', true);
			}
			this.set('languagePanel', false);
			this.filterTVPacks();
		});

		this.on('*.languageChange', function (event) {
			this.set('languageResults', false);
			this.set('genrePanel', false);
			this.set('genreResults', false);
			this.set('packResults', false);
			this.set('languagePanel', true);
		});

		this.on('*.genreNext', function (event) {
			this.set('genreResults', true);
			this.set('genrePanel', false);
			this.set('packResults', true);
			this.filterTVPacks();
		});
		this.on('ux-anchor.getTvPack', function (event, idx) {
			var planId = this.get('planId');
			var relationId = this.get('planRelId');
			var packType = this.get('packListShown')[idx].packType;
			var planName = this.get('packListShown')[idx].title;
			var price = this.get('packListShown')[idx].price;
			var DeviceIdAndPlanIdInContextTopicObj = {};
			DeviceIdAndPlanIdInContextTopicObj.customerType = 'normal';
			DeviceIdAndPlanIdInContextTopicObj.planId = planId;
			DeviceIdAndPlanIdInContextTopicObj.relationId = relationId;
			DeviceIdAndPlanIdInContextTopicObj.numberType = 'LANDLINE';
			DeviceIdAndPlanIdInContextTopicObj.packType = packType;
			DeviceIdAndPlanIdInContextTopicObj.flowType = 'TV';
			var MiniCartInContextTopicObj = {};
			var flowData = {};
			flowData.planName = planName;
			MiniCartInContextTopicObj.flowData = flowData;
			MiniCartInContextTopicObj.monthlyCharges = price;
			MiniCartInContextTopicObj.id = 'TV';
			MiniCartInContextTopicObj.currentStepNumber = 2;
			var deviceAndPlanTopicContext = 'businesswidget/repository_l9_common/' +
			'common/viewmodel/contextTopics/DeviceIdAndPlanIdInContextTopic';
			var miniCartContext = 'businesswidget/repository_l9_common/' +
			'common/viewmodel/contextTopics/MiniCartInContextTopic';
			sessionStorage.setItem(deviceAndPlanTopicContext, JSON.stringify(DeviceIdAndPlanIdInContextTopicObj));
			sessionStorage.setItem(miniCartContext, JSON.stringify(MiniCartInContextTopicObj));
			window.location.href = this.get('buttonLink');
		});
		this.on('*.genreChange', function (event) {
			this.set('genreResults', false);
			this.set('genrePanel', true);
		});

	}
});

Ractive.components["ux-tv-sub"] = Ractive.extend({
	template: LUXComponentTemplates['ux-tv-sub'],
	data : function () {
		return {
			ConfigStrings : ConfigStrings,
			moment : moment
		};
	},
	onrender : function () {
		var self = this;
		self.on('*.showContractDetails', function () {
			var productFacade = self.get('productFacade');
			RactiveHelpers.toggleModal(self, 'recontractDetailsModal', true);
			console.log(productFacade.recontractData.deviceContractEndDate.format('DD/MM/YYYY'));
		});
	}
});

Ractive.components["ux-tweakplan"] = Ractive.extend({
	template: LUXComponentTemplates['ux-tweakplan'],
	easyMobileSlider: jslider,
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			tweakSuspensionErrorMsg: ConfigStrings.tweakSuspensionErrorMsg,
			ipaMsg: ConfigStrings.permission.ipaMsg,
			blacklistMsg: ConfigStrings.permission.blacklistMsg
		};
	},
	oninit: function () {
	
	},
	onrender: function () {
		var self = this;
		this.set('initActiveTalktimeUnits', this.get('subscription').productDetails.units.voiceUnits);
		this.set('initActiveSMSUnits', this.get('subscription').productDetails.units.smsUnits);
		this.set('initActiveDataUnits', this.get('subscription').productDetails.units.dataUnits);
		this.set('initTalktimeValue', this.get('subscription').productDetails.units.voiceUnits *
			this.get('initData').units.talk);
		this.set('initSmsValue', this.get('subscription').productDetails.units.smsUnits *
			this.get('initData').units.sms);
		this.set('initDataValue', this.get('subscription').productDetails.units.dataUnits *
			this.get('initData').units.data);

		var selectedPlan = {
			talktime: {
				quantity: self.get('initActiveTalktimeUnits'),
				unit: self.get('initTalktimeValue')
			},
			sms: {
				quantity: self.get('initActiveSMSUnits'),
				unit: self.get('initSmsValue')
			},
			data: {
				quantity: self.get('initActiveDataUnits'),
				unit: self.get('initDataValue')
			}
		};
		self.showSelectedPlanUnits(selectedPlan);

		this.on('ux-button.resetEasyMobilePlan', function (event) {
			self.showSelectedPlanUnits(selectedPlan);
		});
		this.on('*.updateScroll', function (event) {
			var selectedPlan = {
				talktime: {
					quantity: self.get('activeTalktimeUnits'),
					unit: self.get('activeMinutes') * this.get('initData').units.talk
				},
				sms: {
					quantity: self.get('activeSMSUnits'),
					unit: self.get('activeSMS') * this.get('initData').units.sms
				},
				data: {
					quantity: self.get('activeDataUnits'),
					unit: self.get('activeData') * this.get('initData').units.data
				}
			};
			if (self.get('activeTalktimeUnits') <= 0) {
				self.set('unitError', self.get('initData').errorMessages.talktime);
				selectedPlan.talktime.quantity = 1;
			}
			if (self.get('activeSMSUnits') <= 0) {
				self.set('unitError', self.get('initData').errorMessages.smsmms);
				selectedPlan.sms.quantity = 1;
			}
			if (self.get('activeDataUnits') <= 0) {
				self.set('unitError', self.get('initData').errorMessages.data);
				selectedPlan.data.quantity = 1;
			}
			self.showSelectedPlanUnits(selectedPlan);
			_.delay(function () {
				self.set('unitError', '');
			}, 5000);
		});

		this.on('ux-button.tweakEasyMobilePlan', function (event) {
			var tweakData = this.get();
			var easyMobilePlan = {
				talktime: {
					quantity: tweakData.activeMinutes,
					unit: tweakData.activeTalktimeUnits
				},
				sms: {
					quantity: tweakData.activeSMS,
					unit: tweakData.activeSMSUnits
				},
				data: {
					quantity: tweakData.activeData,
					unit: tweakData.activeDataUnits
				}
			};
			this.set('tweakData', easyMobilePlan);
			this.fire('onTweakPlan', easyMobilePlan);
		});

	},
	showSelectedPlanUnits: function (selectedPlan) {
		var talktime = selectedPlan.talktime.quantity;
		var smsmms = selectedPlan.sms.quantity;
		var unitdata = selectedPlan.data.quantity;
		var totalUnits = Number(talktime) + Number(smsmms) + Number(unitdata);
		this.set('totalUnits', totalUnits);
		this.updateUnits(selectedPlan.talktime.quantity, selectedPlan.sms.quantity, selectedPlan.data.quantity);
		var sliderStart = Number(selectedPlan.talktime.quantity);
		var sliderEnd = Number(selectedPlan.talktime.quantity) + Number(selectedPlan.sms.quantity);
		this.initSlider(totalUnits, sliderStart, sliderEnd);
		this.set('talktimeValue', selectedPlan.talktime.unit);
		this.set('smsValue', selectedPlan.sms.unit);
		this.set('dataValue', selectedPlan.data.unit);
		this.update();
	},

	initSlider: function (maxUnit, start, end) {
		var self = this;
		if (this.slider) {
			this.slider.noUiSlider.destroy();
		}
		this.slider = $('.range-slider')[0];
		this.easyMobileSlider.create(this.slider, {
			start: [start, end],
			step: 1,
			connect: true,
			direction: 'ltr',
			behaviour: 'tap-drag',
			range: {
				'min': 0,
				'max': maxUnit
			}
		});

		this.slider.noUiSlider.on('update', function (values, handle) {
			var talktimeUnits = Math.round(values[0]);
			var smsUnits = Math.round(values[1]) - talktimeUnits;
			var dataUnits = Math.round(maxUnit) - Math.round(values[1]);
			self.updateUnits(talktimeUnits, smsUnits, dataUnits);
		});

		this.slider.noUiSlider.on('change', function (values, handle) {
			var talktimeUnits = Math.round(values[0]);
			var smsUnits = Math.round(values[1]) - talktimeUnits;
			var dataUnits = Math.round(maxUnit) - Math.round(values[1]);
			if (talktimeUnits === 0) {
				talktimeUnits = 1;
				smsUnits = smsUnits - 1;
				self.set('unitError', self.get('initData').errorMessages.talktime);
				self.slider.noUiSlider.set([talktimeUnits, (talktimeUnits + smsUnits)]);
			} else if (smsUnits === 0) {
				smsUnits = 1;
				if (handle === 0) {
					talktimeUnits = talktimeUnits - 1;
				} else if (handle === 1) {
					dataUnits = dataUnits - 1;
				}
				self.set('unitError', self.get('initData').errorMessages.smsmms);
				self.slider.noUiSlider.set([talktimeUnits, (talktimeUnits + smsUnits)]);
			} else if (dataUnits === 0) {
				dataUnits = 1;
				smsUnits = smsUnits - 1;
				self.set('unitError', self.get('initData').errorMessages.data);
				self.slider.noUiSlider.set([talktimeUnits, (talktimeUnits + smsUnits)]);
			}
			self.updateUnits(talktimeUnits, smsUnits, dataUnits);

			_.delay(function () {
				self.set('unitError', '');
			}, 5000);
		});
	},

	updateUnits: function (talktimeUnits, smsUnits, dataUnits) {
		var self = this;
		self.set('activeTalktimeUnits', talktimeUnits);
		self.set('activeSMSUnits', smsUnits);
		self.set('activeDataUnits', dataUnits);
		self.unitToValueConversion(talktimeUnits, smsUnits, dataUnits);
		self.update();
	},

	unitToValueConversion: function (minutes, sms, data) {
		var self = this;
		var activeMinutes = Number(minutes) * self.get('initData').units.talk;
		var activeSMS = Number(sms) * self.get('initData').units.sms;
		var activeData = Number(data) * self.get('initData').units.data;
		self.set('activeMinutes', activeMinutes);
		self.set('activeSMS', activeSMS);
		self.set('activeData', activeData);
	}
});

Ractive.components["ux-two-image-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-two-image-banner'],
	isolated: true
});

Ractive.components["ux-unbilled-usage"] = Ractive.extend({
	template: LUXComponentTemplates['ux-unbilled-usage'],
	isolated : true,
	data : function () {
		return {
			RactiveHelpers : RactiveHelpers,
			ConfigStrings: ConfigStrings,
			moment: moment
		};
	}
});

Ractive.components["ux-upcoming-events"] = Ractive.extend({
	template: LUXComponentTemplates['ux-upcoming-events'],
	isolated: true,
	oninit : function () {
		var eventsList = this.get('eventsList');

		var eventListFiltered = eventsList.filter(function (item) {
			var eventDate = item.eventDate.split('/');
			var year = eventDate[2];
			var month = eventDate[1] - 1;
			var day = eventDate[0];

			var todayDate = moment(new Date()).format('YYYY-MM-DD');
			var formatEventDate = moment(new Date(year,month,day)).format('YYYY-MM-DD');
			if (formatEventDate >= todayDate) {
				return true;
			}
		});

		this.set('eventsList', eventListFiltered.sort(function (a, b) {
				var aParts = a.eventDate.split('/');
				var bParts = b.eventDate.split('/');
				return new Date(aParts[2],aParts[1],aParts[0]) < new Date(bParts[2],bParts[1],bParts[0]) ? -1 : 1;
			}));
	}
});

Ractive.components["ux-usage-details"] = Ractive.extend({
	template: LUXComponentTemplates['ux-usage-details'],
	isolated: true,

	data : function () {
		return {
			RactiveHelpers: RactiveHelpers,
			moment: moment,
			ConfigStrings: ConfigStrings,
			easyMobFeedback: ConfigStrings.easyMobFeedback,
			isParentLine: false
		};
	},
	oninit: function () {
		this.set('subscription.tweakData', null);
		this.set('selectedTab', 'local');
		this.on('*.onTweakPlan', function (event) {
			this.set('subscription.tweakData', event);
			this.fire('createOrder', event);
		});
		this.on('*.onMobileShareSetting', function (event) {
			this.fire('getMobileShareSetting', event);
		});
		this.on('*.onLocalDataSetting', function (event) {
			this.fire('setLocalDataSetting', event);
		});
		this.on('*.onRoamingDataSetting', function (event) {
			this.fire('setRoamingDataSetting', event);
		});
		this.on('*.onAlertHistory', function (event) {
			this.fire('getAlertHistoryDetails', event);
		});
		this.on('*.onShowDataModal', function (event) {
			var serviceId = this.get('subscription').serviceId;
			var displaySettingModel = {
				displaySettingModel : event.get('ariaLabel'),
				link : (event.get('ariaLabel') === 'dataSettingsModal') ?
				'dataSettings' : 'mobileShareSettings',
				serviceId : serviceId
			};
			this.fire('retrieveDqmsToken', displaySettingModel);
		});

		this.on('*.onShowUnbilledData', function (event, usage, summaryType) {
			this.set('pageIndex', 1);
			usage = (usage === 'false') ? event.get('combinedLocalUsage') : usage;
			this.showUnbilledUsageEvents(event, usage, summaryType);
		});
		this.on('*.onShowDetailedUnbilledUsage', function (event, usage, summaryType) {
			this.setModalDisplayState('localUsageDistributionModal', true);
		
		});
		this.on('*.onLoadMoreClick', function () {
			var unbilledUsageEventContext = this.get('unbilledUsageEventContext');
			unbilledUsageEventContext.pageIndex = this.get('pageIndex') + 1;
			this.set('pageIndex', this.get('pageIndex') + 1);
			this.fire('populateUnbilledEvents', unbilledUsageEventContext);
		});

		this.on('*.tweakPlan', function () {
			this.setModalDisplayState('tweakPlanModal', true);
		});
		this.on('*.changeTab', function (event, tab) {
			this.set('selectedTab', event[0].context.id);
		});
		this.observe('initData.mainLineSuplementaryLineMap', function (mainLineSuplementaryLineMap) {
			if (mainLineSuplementaryLineMap && mainLineSuplementaryLineMap.length > 0) {
				var serviceId = this.get('subscription').serviceId;
				var supplementaryLineIds = _.find(mainLineSuplementaryLineMap, function (argument, key) {
					return argument[serviceId];
				});
				this.set('isParentLine', supplementaryLineIds ? true : false);
			}
		});
		this.on('*.onShowDetailedSponsoredUnbilledUsage', function (event, usage, summaryType) {
			this.setModalDisplayState('sponsoredUsageDistributionModal', true);
		
		});
		var account = this.get('account');
		if (account.isEasyMobile) {
			this.observe('subscription.productDetails.units subscription.usageSummary.easyMobileTcUnits',
			function (units) {
				var currentUnits = this.get('subscription.productDetails.units');
				var easyMobileTcUnits = this.get('subscription.usageSummary.easyMobileTcUnits');
				if (currentUnits && easyMobileTcUnits) {
					var dataDiff = currentUnits.dataUnits - easyMobileTcUnits.dataUnits;
					var smsDiff = currentUnits.smsUnits - easyMobileTcUnits.smsUnits;
					var voiceDiff = currentUnits.voiceUnits - easyMobileTcUnits.voiceUnits;
					if (dataDiff || smsDiff || voiceDiff) {
					
						var easyMobilePlan = {
							talktime: {
								unit: currentUnits.voiceUnits,
								quantity: currentUnits.voiceUnits * this.get('initData').units.talk
							},
							sms: {
								unit: currentUnits.smsUnits,
								quantity: currentUnits.smsUnits * this.get('initData').units.sms
							},
							data: {
								unit: currentUnits.dataUnits,
								quantity: currentUnits.dataUnits * this.get('initData').units.data
							}
						};
						this.set('subscription.tweakData', easyMobilePlan);
					}
				}
			}.bind(this));
		}
	},
	showUnbilledUsageEvents: function (event, usage, summaryType) {
		if (usage.utilizedQuotaPercentage > 100) {
			var unbilledUsageEventContext = {
				summaryType: summaryType,
				usageType : usage.usageType,
				subscriptionId: this.get('subscription.subscriptionId'),
				serviceId: this.get('subscription.serviceId'),
				customerId : this.get('account.customerId'),
				faid: this.get('account.faid'),
				pageIndex: 1
			};
			this.set('unbilledUsageEventContext', unbilledUsageEventContext);
			this.fire('populateUnbilledEvents', unbilledUsageEventContext);
			this.setModalDisplayState('localUsageDistributionModal', false);
			this.setModalDisplayState('unbilledEventsModal', true);
		}
	},

	setModalDisplayState: function (modalId, state) {
		var modals = this.findAllComponents('ux-modal');
		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];
		modal.set('displayState', state);
	}
});

Ractive.components["ux-use-existing-number"] = Ractive.extend({
	template: LUXComponentTemplates['ux-use-existing-number'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers,
			ConfigStrings: ConfigStrings
		};
	},

	oninit: function (argument) {
		var self = this;
		self.on('setSelectedLine', function (event, type) {
			if (event.context.fibreEligibility) {
				self.fire('doExistingLineSelect', event);
				self.set('existingNumbers.*.getExistingNumberState', '');

				var numbersToShows = this.parent.get('numbersToShow');
				_.each(numbersToShows, function (numbersToShow) {
					numbersToShow.active = false;
				});
				self.parent.set('numbersToShow', numbersToShows);

				event.context.getExistingNumberState  = 'selected';

				var existingNumbers = this.get('existingNumbers');
				_.each(existingNumbers, function (existingNumber) {
					if (existingNumber.serviceID === event.context.serviceID) {
						existingNumber.getExistingNumberState = 'selected';
					}
				});

				self.set('existingNumbers', existingNumbers);
			}
		});
	}
});

Ractive.components["ux-vertical-plan"] = Ractive.extend({
	template: LUXComponentTemplates['ux-vertical-plan'],

	data : {
		'RactiveHelpers' : RactiveHelpers
	},

	oninit: function () {
		this.set('slidesPerView', 'auto');
	},

	onrender: function (argument) {
		var self = this;
		var spaceBetween = 0,
			slidesPerView = this.get('slidesPerView'),
			loop = false;
		var swiperContainer = this.find('.swiper-container');
		var mySwiper = null;
	
		var centeredSlides = true;
		var swiperConfig = {
		
			direction: 'horizontal',
		
			nextButton: this.find('.swiper-button-next'),
			prevButton: this.find('.swiper-button-prev'),
			slidesPerView: slidesPerView,
			loop: loop,
			spaceBetween: spaceBetween,
			centeredSlides: centeredSlides,
		
			onInit: function () {
				self.update();
				setTimeout(function () {
					this.get('swiper').update();
				}.bind(this), 500);
			}.bind(this)
		};

		try {
			mySwiper = new Swiper(swiperContainer, swiperConfig);
		} catch (e) {
			console.warn('could not initialize swiper for', swiperContainer);
			console.error(e);
			return;
		}

		self.set('moduleType', 'normal');
		self.set('swiper', mySwiper);

		if (typeof mySwiper === 'undefined') {
			console.error('SWIPER.js and SWIPER.css need to be included in the HEAD');
			return false;
		}

		self.on('selectItem', function (event, index) {
			this.selectItem(index, false);
		});

		self.on('selectImage', function (event, index) {
			this.showImage(index, false);
		});

		self.on('ux-anchor.toggleDetails', function (event, modalId) {
			var selectedPlan = event.get('selectedPlan');

			self.set('planDetailsTitleSelected', selectedPlan.planDetailsTitle);
			self.set('planDetailsSelected', selectedPlan.planDetails);

			RactiveHelpers.toggleModal(self, modalId, true);
		});

		self.on('ux-button.navigateToPath', function (event) {
			var linkURL = event.get('linkto');
			window.open(linkURL, '_self');
		});

		self.updateHeight();

		window.addEventListener('resize', _.debounce(function (e) {
			self.updateHeight();
		}, 300));
	},
	updateHeight: function () {
		setTimeout(function () {
			var isSmallDevice = window.innerWidth < 770;
			var selector = isSmallDevice ? $('.mbenefit-panel') : $('.benefit-panel');
			var maxHeight = selector.height();

			_.each(selector, function (element) {
				const height = element.scrollHeight;
				if (height > maxHeight) {
					maxHeight = height;
				}
			});

			selector.css({ height: maxHeight + 'px' });
		}, 200);
	}
});

Ractive.components["ux-vertical-tout-fill"] = Ractive.extend({
	template: LUXComponentTemplates['ux-vertical-tout-fill'],
	isolated: true
});

Ractive.components["ux-vertical-tout"] = Ractive.extend({
	template: LUXComponentTemplates['ux-vertical-tout'],
	isolated: true
});

Ractive.components["ux-virtual-agent"] = Ractive.extend({


	template: LUXComponentTemplates['ux-virtual-agent'],

	oninit: function () {

	
		this.storage = localStorage;

		this.on('*.doChatOpen doChatOpen *.doChatMinimize doChatMinimize', function () {
			if (!this.chat.classList.contains('move-handled')) {
				this.chat.classList.add('move-handled');
				this.handleChatMoveAndResize('move');
				this.handleChatMoveAndResize('resize');
			}
			this.set('virtualAgentChat.enable', true);
		});

		this.on('*.doChatClose doChatClose', function () {
			this.storage.vaLastAction = 'doChatClose';
			this.set('virtualAgentChat.enable', false);
			this.suggestSurvey();
		});

		this.on('*.doChatMinimize doChatMinimize', function () {
			if (this.chat.classList.contains('minimized')) {
				this.storage.vaLastAction = 'doChatOpen';
				this.chat.classList.remove('minimized');
				this.preventOutsideExpanding();
			} else {
				this.storage.vaLastAction = 'doChatMinimize';
				this.chat.classList.add('minimized');
			}
		});

		this.on('*.doSurveyAccess', function () {
			this.toggleModal('surveyModal', false);
		}.bind(this));

		this.on('*.doSurveyDismiss', function () {
			this.storage.vaLastSurveyDismiss = (new Date()).getTime();
			this.toggleModal('surveyModal', false);
		}.bind(this));

	},

	suggestSurvey: function () {

		if (!this.storage.vaLastSurveyDismiss) {
			this.toggleModal('surveyModal', true);
		} else {

			var secondsSince = Math.round(((new Date()).getTime() - this.storage.vaLastSurveyDismiss) / 1000);
			var daysSince = Math.round(secondsSince / 60 / 60 / 24);
			if (daysSince > 30) {
				this.toggleModal('surveyModal', true);
			}
		}
	},

	oncomplete: function () {

		this.chat = this.el.querySelector('.ux-virtual-agent');

		var action = this.storage.vaLastAction;

		if (action && action.length && action !== 'doChatClose') {

			this.fire(action);

			if (this.storage.vaPosX && this.storage.vaPosX.length) {
				this.chat.style.right = this.storage.vaPosX + 'px';
			}

			if (this.storage.vaPosY && this.storage.vaPosY.length) {
				this.chat.style.bottom = this.storage.vaPosY + 'px';
			}

			this.preventOutsideExpanding();

		} else if (this.get('virtualAgentChat.enable')) {
			this.fire('doChatOpen');
		}

	},

		preventOutsideExpanding: function () {
		setTimeout(function () {
			var yMax = document.body.getBoundingClientRect().height - this.chat.getBoundingClientRect().height;
			if (parseInt(this.chat.style.bottom) > yMax) {
				this.chat.style.bottom = yMax + 'px';
			}
		}.bind(this), 100);
	},

	toggleModal: function (modalId, state) {

		var modals = this.findAllComponents('ux-modal');

		var modal = modals.filter(function (component) {
			return modalId === component.get('modalId');
		})[0];

		modal.set('displayState', state);
		if (modalId === 'surveyModal' &&
			typeof this.event !== 'undefined' && this.event.component) {
			var href = this.event.component.get('href');
			if (href && href !== null && href !== '#') {
				window.open(
					href,
					'_blank'
				);
			}
		}
	},

	handleChatMoveAndResize: function (type) {

		var icon = this.el.querySelector('.pan' + '.' + type);
		icon.classList.remove('disabled');

	
		var container = document.body;
		var containerBounding = container.getBoundingClientRect(), chatBounding, iconBounding;

	
		var xIconOrigin, yIconOrigin, xOrigin, yOrigin;

	
		this.xMin = 0;
		this.yMin = 0;
		this.widthMin = this.get('virtualAgentChat.minimum.width');
		this.heightMin = this.get('virtualAgentChat.minimum.height');

		var mc = new Hammer(icon);
		mc.get('pan').set({
			direction: Hammer.DIRECTION_ALL
		});

		mc.on('panstart', function (event) {
			this.chat.classList.add('user-action');
			container.classList.add('no-select');
		
			chatBounding = this.chat.getBoundingClientRect();
			iconBounding = icon.getBoundingClientRect();
		
			xIconOrigin = Math.round(chatBounding.right - iconBounding.right) + 5;
			yIconOrigin = Math.round(chatBounding.bottom - iconBounding.bottom) + iconBounding.height - 15;
			xOrigin = containerBounding.width - event.pointers[0].clientX - xIconOrigin;
			yOrigin = containerBounding.height - event.pointers[0].clientY - yIconOrigin;
		
			this.xMax = containerBounding.width - chatBounding.width;
			this.yMax = containerBounding.height - chatBounding.height;
		}.bind(this));

		mc.on('panmove', function (event) {

			var newX = xOrigin - event.deltaX;
			var newY = yOrigin - event.deltaY;
			var moveX = false;
			var moveY = false;

			if (type === 'move') {
				moveX = (newX > this.xMin && newX < this.xMax);
				moveY = (newY > this.yMin && newY < this.yMax);
			} else if (type === 'resize') {
				var newHeight = (chatBounding.height + event.deltaY);
				var newWidth = (chatBounding.width + event.deltaX);
				if (newWidth > this.widthMin && newX > 0) {
					this.chat.style.width = newWidth + 'px';
					moveX = true;
				}
				if (newHeight > this.heightMin && newY > 0) {
					this.chat.style.height = newHeight + 'px';
					moveY = true;
				}
			} else {
				console.error('type not handled : ', type);
			}

			if (moveX) {
				this.storage.vaPosX = newX;
				this.chat.style.right = newX + 'px';
			}

			if (moveY) {
				this.storage.vaPosY = newY;
				this.chat.style.bottom = newY + 'px';
			}

		}.bind(this));

		mc.on('panend', function () {
			this.chat.classList.remove('user-action');
			container.classList.remove('no-select');
		}.bind(this));
	}

});

Ractive.components["ux-widget-inclusion"] = Ractive.extend({
	template: LUXComponentTemplates['ux-widget-inclusion']
});

Ractive.components["ux-wifi-adsense"] = Ractive.extend({
	template: LUXComponentTemplates['ux-wifi-adsense'],
	isolated: true,

	transitions: {
		fly: ractiveTransitionsFly
	},

	onrender: function () {
	
		var stopSingtelRedirectURL = this.get('stopSingtelRedirectURL');
		var sid = RactiveHelpers.getParameterByName('sid');

		if (this.isNullOrEmpty(stopSingtelRedirectURL) || stopSingtelRedirectURL === '1' || this.isNullOrEmpty(sid)) {
			return;
		}

		stopSingtelRedirectURL = stopSingtelRedirectURL + '?sid=' + sid;

	
		RactiveHelpers.doAjaxJSONCall('GET', stopSingtelRedirectURL, function (response) {
		

			if (response.status.code !== 200) {
			
				return true;
			}
		}, function (error) {
			return false;
		});
	},
	isNullOrEmpty: function (val) {
		return !val || val === '';
	}
});

Ractive.components["ux-wifi-agreement"] = Ractive.extend({
	template: LUXComponentTemplates['ux-wifi-agreement'],
	onrender: function () {
	
	
	
		var checkboxes = this.findAllComponents('ux-checkbox');

	
		var cbIAgreeID = 'CBIAgree';

	
		var macAddressModalTriggerID = '#macaddress';

	
		var self = this;

	
		var stopSingtelRedirectURL = this.get('stopSingtelRedirectURL');
		var updateCustomerConsentURL = this.get('updateCustomerConsentURL');
	
	






	
	
	
	
		function isStringUndefinedOrNullOrEmptyOrWhiteSpace (input) {
			return (!_.isString(input) || _.isUndefined(input) || _.isNull(input) ||
				_.isEmpty(input) || _.trim(input).length === 0) ? true : false;
		}

	
	
	
		function getURL (urlInput) {
			if (isStringUndefinedOrNullOrEmptyOrWhiteSpace(urlInput)) {
				return [window.location.protocol, '//', window.location.host, window.location.pathname].join('');
			} else {
				return urlInput.split('?')[0];
			}
		}

	
		function getCheckBoxByID (checkbox_id)	{
			var checkbox = _.find(checkboxes, function (checkbox) {
				return checkbox.get('checkboxid') === checkbox_id;
			});
			return checkbox;
		}

	
	
		function setCheckBoxCheckedValueByID (checkbox_id, checked) {
			return getCheckBoxByID(checkbox_id).set('checked', checked);
		}

	
		function isCheckBoxCheck (checkbox_id) {
			return getCheckBoxByID(checkbox_id).get('checked') === true ? 'y' : 'n';
		}

	
	
		function getURLParams (urlInput) {
			var params = {};
			var parts;

			if (isStringUndefinedOrNullOrEmptyOrWhiteSpace(urlInput)) {
				parts = window.location.search.substr(1).split('\x26');
			} else {
				parts = urlInput.split('\x26');
				parts.splice(0, 1);
			}

		
			for (var i = 0; i < parts.length; i++) {
				var keyValuePair = parts[i].split('=');

			
			
				if (keyValuePair.length === 2) {

				
				
				
					var key = decodeURIComponent(keyValuePair[0]);
					var value = keyValuePair[1].replace(/\+/g, ' ');

				
				
					if (isStringUndefinedOrNullOrEmptyOrWhiteSpace(key) === false &&
						isStringUndefinedOrNullOrEmptyOrWhiteSpace(value) === false) {
						params[key] = value;
					}
				}
			}
			return params;
		}

	
		function displayModal (modal_id) {
		
			var modals = self.findAllComponents('ux-modal');
			var modal = _.find(modals, function (modal) {
				return modal.get('modal_id') === modal_id;
			});
			modal.set('displayState', true);
		}

	
	
		function queryStringBuilder (params) {
			if (typeof params === 'undefined' || typeof params !== 'object') {
				params = {};
				return params;
			}
			var query = '?';
			var index = 0;

			for (var i in params) {
				if (params.hasOwnProperty(i)) {
					index++;
					var param = i;
					var value = params[i];
					if (index === 1) {
						query += param + '=' + value;
					} else {
						query += '&' + param + '=' + value;
					}
				}
			}
			return query;
		}
	
	






	
	
	
	
	
		this.on('*.doCloseModal', function (event) {
			var urlParams = getURLParams();
			if (event.context.modal_id === 'errorModal' &&
				isStringUndefinedOrNullOrEmptyOrWhiteSpace(urlParams.rurl) === false) {
				window.location.replace(decodeURIComponent(urlParams.rurl));
			}
		});

	
		this.on('divOnTap', function (e) {
		
			var sender = e.original.target;

		
			if (sender.href && sender.href.indexOf(macAddressModalTriggerID) !== -1) {
				displayModal('macAddressModal');
				return false;
			}
		});


	
		this.on('*.proceedButtonClick', function () {
		
		
		
		
		
		
			var urlParams = getURLParams();
			var url = getURL(updateCustomerConsentURL) +
				queryStringBuilder(_.merge(getURLParams(updateCustomerConsentURL),
					{'consentind' : isCheckBoxCheck(cbIAgreeID), 'value' : urlParams.value}));

			RactiveHelpers.doAjaxJSONCall('POST', url, function (response) {
			
			

			
				if (response.status.code === 200) {

				
				
					if (isCheckBoxCheck(cbIAgreeID) === 'y') {
					
						window.location.replace(response.body.merchanturl +
							queryStringBuilder({ 'rurl' : urlParams.rurl, 'value' : response.body.value }));
					} else {
					
						window.location.replace(decodeURIComponent(urlParams.rurl));
					}

				} else {

				
				
				
					displayModal('errorModal');
				}
			},

		
			function (error) {
			
			
				displayModal('errorModal');
			});
		});
	
	






	
	
	
	
		var urlParams = getURLParams();

	
		if (isStringUndefinedOrNullOrEmptyOrWhiteSpace(urlParams.sid) ||
			isStringUndefinedOrNullOrEmptyOrWhiteSpace(urlParams.rurl)) {
			return;
		}

		if (isStringUndefinedOrNullOrEmptyOrWhiteSpace(urlParams.value) ||
			isStringUndefinedOrNullOrEmptyOrWhiteSpace(urlParams.isconsentgiven)) {

		
		
		
			var rootElement = window.document.documentElement;
			rootElement.classList.add('hide');

		
		
		
		
		
			var url = getURL(stopSingtelRedirectURL) +
				queryStringBuilder(_.merge(getURLParams(stopSingtelRedirectURL), {'sid' : urlParams.sid }));

			RactiveHelpers.doAjaxJSONCall('GET', url, function (response) {
			

			
				if (response.status.code === 200) {

				
					urlParams.value = response.body.value;
					urlParams.isconsentgiven = response.body.isconsentgiven;

				
					window.location.replace(getURL() + queryStringBuilder(urlParams));
				} else {
				
				
				
					window.location.replace(decodeURIComponent(urlParams.rurl));
				}
			},
		
			function (error) {
			
				window.location.replace(decodeURIComponent(urlParams.rurl));
			});
		} else {
		
			setCheckBoxCheckedValueByID(cbIAgreeID, urlParams.isconsentgiven === 'y' ? true : false);
		}
	
	
	}
});

Ractive.components["ux-wifi-banner"] = Ractive.extend({
	template: LUXComponentTemplates['ux-wifi-banner']
});

Ractive.components["ux-wifi-footer"] = Ractive.extend({
	template: LUXComponentTemplates['ux-wifi-footer']
});

Ractive.components["ux-wifi-header"] = Ractive.extend({
	template: LUXComponentTemplates['ux-wifi-header'],
	isolated: true,

	oninit: function () {
		var self = this;
		self.set('show', false);
	},

	onrender: function () {

		var self = this;

		var skipURL = RactiveHelpers.getParameterByName('rurl');

		if (skipURL === null || skipURL === '') {
			skipURL = this.get('defaultSkipURL');
		}

		self.set('skipURL', skipURL);
	},


	oncomplete: function () {
		var self = this;

		var delay = self.get('delay');
		setTimeout(function () {
			self.set('show', true);
		}, delay);
	}
});

Ractive.components["ux-wifi-imagetext"] = Ractive.extend({
	template: LUXComponentTemplates['ux-wifi-imagetext'],
	isolated: true,

	transitions: {
		fly: ractiveTransitionsFly
	},

	onrender: function () {

		var self = this;
		var mid = RactiveHelpers.getParameterByName('merchantId');
		self.set('merchantId', mid);

		var wifiMerchantModelList = self.get('wifiMerchantModelList');

		if (wifiMerchantModelList && wifiMerchantModelList.length > 0) {

			for (var i = 0; i < wifiMerchantModelList.length; i++) {
				if (wifiMerchantModelList[i].merchantId.toUpperCase() === self.get('merchantId').toUpperCase()) {
					self.set('locationName', wifiMerchantModelList[i].merchantName);
					break;
				}
			}
		}
	}
});

Ractive.components["ux-wireline-sub"] = Ractive.extend({
	template: LUXComponentTemplates['ux-wireline-sub']
});

Ractive.components["ux-worry-free"] = Ractive.extend({
	template: LUXComponentTemplates['ux-worry-free'],
	isolated: true,
	data: function () {
		return {
			'guestPrefixIdTypeOptions': ConfigStrings.guestIDPrefixOptions,
			'idPrefixType': ConfigStrings.guestIDPrefixOptions[2].value,
			'guestIdTypeOptions': [],
			'guestIdType': ConfigStrings.guestIdTypeOptions[6].value,
			'idNumber': null,
			'contactNumber': null,
			'otpNumber': '',
			'accountNumber': '',
			'otpTimer': 0,
			'inProcess': false,
			'isReconFlow': false,
			'RactiveHelpers': RactiveHelpers,
			'isReloadRequired': true,
			'bcConfig': [{
				'hash': 'worryfree/enter-mobile-no',
				'target': 'enter-mobile-no',
				'title': 'Enter Mobile No',
				'icon': 'billing_details',
				'rank': 1
			}, {
				'hash': 'worryfree/verify-account',
				'target': 'verify-account',
				'title': 'Verify Account',
				'icon': 'order_summary',
				'rank': 30
			}, {
				'hash': 'worryfree/verify-otp',
				'target': 'verify-otp',
				'title': 'Verify Otp',
				'icon': 'contact_information',
				'rank': 50
			},
			{
				'hash': 'worryfree/verify-mobile-number',
				'target': 'verify-mobile-number',
				'title': 'Verify Acceptor Mobile Number',
				'icon': 'contact_information',
				'rank': 60
			},
			{
				'hash': 'worryfree/verify-account-prepaid',
				'target': 'verify-account-prepaid',
				'title': 'Verify Service',
				'icon': 'contact_information',
				'rank': 70
			},
			{
				'hash': 'worryfree/verify-otp-prepaid',
				'target': 'verify-otp-prepaid',
				'title': 'Verify Otp',
				'icon': 'contact_information',
				'rank': 80
			}]
		};
	},
	validateMobileNumber: function () {
		var error = ConfigStrings.guestCheckoutValidationError.mobileNumber;
		var validationRule = {
			'contactNumber': {
				required: error.mobileRequired,
				minlength: {
					param: 8,
					message: error.minLengthError
				},
				maxlength: {
					param: 8,
					message: error.maxLengthError
				},
				validMobileNumber: error.inValidMobileNumber
			}
		};
		var contactNumberValidation = new RactiveValidate(this, validationRule);
		contactNumberValidation.cwd = '';
		var isValid = contactNumberValidation.validate().valid;
		return isValid;
	},
	validateServiceNumber: function () {
		var error = ConfigStrings.guestCheckoutValidationError.mobileNumber;
		var validationRule = {
			'serviceNumber': {
				required: error.mobileRequired,
				minlength: {
					param: 8,
					message: error.minLengthError
				},
				maxlength: {
					param: 8,
					message: error.maxLengthError
				},
				validMobileNumber: error.inValidMobileNumber
			}
		};
		var serviceNumberValidation = new RactiveValidate(this, validationRule);
		serviceNumberValidation.cwd = '';
		var isValid = serviceNumberValidation.validate().valid;
		return isValid;
	},
	validatePassportId: function (type) {
		switch (type) {
			case 'passport':
				var passportIdNumber = this.get('passportIdNumber');
				if (passportIdNumber) {
					passportIdNumber = passportIdNumber.trim().toUpperCase();
				}
				var passportIdValidator = new RactiveValidate(this, {
					'passportIdNumber': {
						required: ConfigStrings.passportNumberErrorMessage.required,
						minlength: {
							param: 1,
							message: ConfigStrings.passportNumberErrorMessage.required
						}
					}
				});
				passportIdValidator.cwd = '';
				var isValid = passportIdValidator.validate().valid;
				this.set('passportIdNumber', passportIdNumber);
				return isValid;
			case 'nric':
				var originalNric = this.get('passportIdNumber');
				if (originalNric) {
					originalNric = originalNric.trim().toUpperCase();
				}

				var passportIdValidator = new RactiveValidate(this, {
					'passportIdNumber': {
						required: this.get('initData.requiredField'),
						nricFormat: ConfigStrings.passportNumberErrorMessage.invalidPassportId,
						nricType: ConfigStrings.passportNumberErrorMessage.invalidPassportId
					}
				});
				passportIdValidator.cwd = '';
				passportIdValidator.patterns.nricFormat = RactiveHelpers.validateNRIC;
				passportIdValidator.patterns.nricType = function (originalNric) {
					if (originalNric) {
						var idType = this.get('passportIdType');
						var options = ConfigStrings.guestIdTypeOptions;
						var filterOptions = _.filter(options, function (options) {
							return options.ID === originalNric.substring(0, 1) && options.value === idType;
						});
						return filterOptions.length > 0 ? true : false;
					}
				}.bind(this);
				this.set('passportIdNumber', originalNric);
				var isValid = passportIdValidator.validate().valid;
				return isValid;
		}
	},
	validateId: function () {
		var originalNric = this.get('idNumber');
		if (originalNric) {
			originalNric = originalNric.toUpperCase();
			this.set('idNumber', originalNric);
		}
		var nricValidator = new RactiveValidate(this, {
			'idNumber': {
				required: this.get('initData.requiredField'),
				nricFormat: ConfigStrings.errors.relocateServices.nricFormat
			}
		});
		nricValidator.cwd = '';
		nricValidator.patterns.nricFormat = RactiveHelpers.validateNRIC;
		this.set('idNumber', this.get('idPrefixType') + originalNric);
		var isValid = nricValidator.validate().valid;
		this.set('idNumber', originalNric);
		return isValid;
	},
	validateIdType: function () {
		var nricTypeValidator = new RactiveValidate(this, {
			'guestIdType': {
				idTypeFormat: this.get('initData.requiredField')
			}
		});
		nricTypeValidator.cwd = '';
		nricTypeValidator.patterns.idTypeFormat = function (value) {
			return !(value === 'Select' || value === '');
		};
		var isValid = nricTypeValidator.validate().valid;
		return isValid;
	},
	validatePrepaidOtp: function () {
		var validationRule = {
			'prepaidOtpNumber': {
				required: this.get('initData.requiredField'),
				minlength: {
					param: 6,
					message: ConfigStrings.errors.addonValidationRule.otp.minLength
				},
				digits: ConfigStrings.errors.addonValidationRule.otp.digits
			}
		};
		var otpValidation = new RactiveValidate(this, validationRule);
		otpValidation.cwd = '';
		var isValid = otpValidation.validate().valid;
		return isValid;
	},
	validateOtp: function () {
		var validationRule = {
			'otpNumber': {
				required: this.get('initData.requiredField'),
				minlength: {
					param: 6,
					message: ConfigStrings.errors.addonValidationRule.otp.minLength
				},
				digits: ConfigStrings.errors.addonValidationRule.otp.digits
			}
		};
		var otpValidation = new RactiveValidate(this, validationRule);
		otpValidation.cwd = '';
		var isValid = otpValidation.validate().valid;
		return isValid;
	},
	validatePrepaidAccount: function () {
		var validationRule = {
			'prepaidAccountNumber': {
				required: this.get('initData.requiredField'),
				digits: ConfigStrings.errors.addonValidationRule.otp.accountNo
			}
		};
		var accountValidation = new RactiveValidate(this, validationRule);
		accountValidation.cwd = '';
		var isValid = accountValidation.validate().valid;
		return isValid;
	},
	validateAccount: function () {
		var validationRule = {
			'accountNumber': {
				required: this.get('initData.requiredField'),
				digits: ConfigStrings.errors.addonValidationRule.otp.accountNo
			}
		};
		var accountValidation = new RactiveValidate(this, validationRule);
		accountValidation.cwd = '';
		var isValid = accountValidation.validate().valid;
		return isValid;
	},
	validatePostalcode: function () {
		var errorMessages = ConfigStrings.errors.updateAddress.postCode;
		var validationRule = {
			'postalcode': {
				digits: errorMessages.digits,
				minlength: {
					param: 6,
					message: errorMessages.minlength
				}
			}
		};
		var postalcodeValidation = new RactiveValidate(this, validationRule);
		postalcodeValidation.cwd = '';
		var isValid = postalcodeValidation.validate().valid;
		return isValid;
	},
	onrender: function () {
		var self = this;
		var parentRactiveWidget = this.get('parentRactiveWidget');
		if (self.get('isPrepaidFlow')) {
			var passportTypeOption = _.extend(ConfigStrings.guestIdTypeOptions, ConfigStrings.deltaGuesIdTypeOptions);
			passportTypeOption = _.uniq(passportTypeOption, function (option) {
				return option.title;
			});
			self.set('passportTypeOption', passportTypeOption);
			self.set('passportIdType', passportTypeOption[4].value);
		}
		self.set('reconOTPVerifyModalError', null);
		self.set('acceptorWorryFreeErrorMsg', null);
		self.set('reconOTPSendModalError', null);
		self.set('acceptorAttemptOTPVerifyModalError', null);
		self.set('acceptorOTPSendModalError', null);
		self.set('reconWorryFreeMsg', null);
		self.set('acceptorOTPFailed', null);
		self.set('otpAcceptorVerificationFailed', null);
		parentRactiveWidget.set('worryFreeTopic.worryFreeVMStatus', null);
		self.set('initData', this.get('initData') || ConfigStrings.worryFree);
		self.set('otpTimer', (self.get('initData.timer') * 60) + ' seconds');
		self.on('*.onBlurContact', function (event) {
			this.validateMobileNumber();
		}.bind(self));
		self.on('*.onBlurService', function (event) {
			this.validateServiceNumber();
		}.bind(self));
		self.on('*.onIdNumberBlur', function (event) {
			this.set('reconWorryFreeMsg', null);
			self.set('reconOTPSendModalError', null);
			this.validateId();
		}.bind(self));
		self.on('*.onPassportIdNumberBlur', function (event) {
			self.set('reconOTPSendModalError', null);
			if (this.get('passportIdType') === 'Passport Number') {
				this.validatePassportId('passport');
			} else {
				this.validatePassportId('nric');
			}
		});
		self.on('*.onBlurOtp', function (event) {
			this.validateOtp();
		}.bind(self));
		self.on('*.onChangePassportType', function (event) {
			self.set('reconOTPSendModalError', null);
			this.set('idPrefixType', ConfigStrings.guestIDPrefixOptions[2].value);
			this.set('guestIdType', ConfigStrings.guestIdTypeOptions[6].value);
			this.set('idNumber', '');
			this.set('idNumberErrorMsg', '');
			this.set('passportIdNumber', '');
		});
		self.on('*.onBlurPrepaidAccountNumber', function () {
			this.set('reconFAVerifyModalError', null);
			this.validatePrepaidAccount();
		});
		self.on('*.onBlurAccountNumber', function (event) {
			this.set('reconFAVerifyModalError', null);
			this.validateAccount();
		}.bind(self));
		self.on('*.onBlurPrepaidAccountNumber', function (event) {
			this.validatePrepaidAccount();
		});
		self.on('*.onBlurPostalcode', function (event) {
			this.set('reconWorryFreeMsg', null);
			this.validatePostalcode();
		}.bind(self));
		self.getTimer.bind(self);
		self.on('*.changedGuestId', function (newValue) {
			self.set('reconOTPSendModalError', null);
			self.filterIDTypeOptions(newValue);
		}.bind(self));
		self.on('*.onChangeGuestType', function (newValue) {
			self.set('reconOTPSendModalError', null);
		}.bind(self));
		self.on('*.onFAVerifyClick', function () {
			if (self.validateAccount()) {
				var parentRactiveWidget = this.get('parentRactiveWidget');
				parentRactiveWidget.set('worryFreeTopic.otpInput.billingAccountNumber',
					this.get('accountNumber'));
				this.set('reconFAVerifyModalError', null);
				this.set('otpNumber', null);
				self.set('inProcess', true);
				var eventname = 'worryFreeTopic.verifyBillingActWorryFreeOtp';
				parentRactiveWidget.fire(eventname, {
					name: eventname
				});
			}
		});
		self.on('*.onOtpVerifyClick', function () {
			if (self.validateOtp()) {
				var parentRactiveWidget = this.get('parentRactiveWidget');
				parentRactiveWidget.set('worryFreeTopic.otpInput.otp', this.get('otpNumber'));
			
				if (this.get('isReconFlow') && parentRactiveWidget.getLob() !== 'MOB') {
					parentRactiveWidget.set('worryFreeTopic.otpInput.faCheckMandatory', true);
				} else {
					parentRactiveWidget.set('worryFreeTopic.otpInput.faCheckMandatory', false);
				}
				this.set('reconOTPVerifyModalError', null);
				this.set('acceptorWorryFreeErrorMsg', null);
				self.set('inProcess', true);
				var eventname = 'worryFreeTopic.verifyWorryFreeOtp';
				parentRactiveWidget.fire(eventname, {
					name: eventname
				});
			}
		});
		self.on('*.onePassSigninClick', function () {
			this.fire('onePassHandling', {
				name: 'onePassHandling'
			});
		});
		self.on('*.onBlurPrepaidOtp', function (event) {
			this.validatePrepaidOtp();
		});
		Ractive.defaults.on('ux-singtel-breadcrumb-step.stepchange', this.onBreadcrumbStepChange.bind(this));
				self.on('*.onServiceVerifyClick', function () {
			if (self.validateServiceNumber()) {
				var parentRactiveWidget = self.get('parentRactiveWidget');
				self.set('acceptorWorryFreeErrorMsg', null);
				self.set('acceptorOTPFailed', null);
				self.set('reconOTPVerifyModalError', null);
				self.set('prepaidOtpNumber', null);
				parentRactiveWidget.set('worryFreeTopic.worryFreeVMStatus', 'AcceptorOTPSend');
				var otpInput = parentRactiveWidget.get('worryFreeTopic.otpInput');
				otpInput.acceptorMobileNumber = self.get('serviceNumber');
			
				parentRactiveWidget.set('worryFreeTopic.otpInput', otpInput);
				self.set('inProcess', true);
				var eventname = 'worryFreeTopic.sendAcceptorWorryFreeOtp';
				parentRactiveWidget.fire(eventname, {
					name: eventname
				});
				this.set('reconResendOTPMsg', null);
			}
		});

				self.on('*.onServiceOtpVerifyClick', function () {
			if (self.validatePrepaidOtp()) {
				var parentRactiveWidget = self.get('parentRactiveWidget');
				parentRactiveWidget.set('worryFreeTopic.otpInput.prepaidOtpNumber',
					this.get('prepaidOtpNumber'));
			
				parentRactiveWidget.set('worryFreeTopic.otpInput.faCheckMandatory', false);
				self.set('acceptorWorryFreeErrorMsg', null);
				self.set('acceptorOTPFailed', null);
				self.set('inProcess', true);
				var eventname = 'worryFreeTopic.verifyAcceptorWorryFreeOtp';
				parentRactiveWidget.fire(eventname, {
					name: eventname
				});
			}
		});

				self.on ('*.onPrepaidFAVerifyClick', function () {
			if (self.validatePrepaidAccount()) {
				var parentRactiveWidget = self.get('parentRactiveWidget');
				parentRactiveWidget.set('worryFreeTopic.otpInput.acceptorAccountNumber',
					this.get('prepaidAccountNumber'));
			
				parentRactiveWidget.set('worryFreeTopic.otpInput.faCheckMandatory', false);
				this.set('otpAcceptorVerificationFailed', null);
				self.set('inProcess', true);
				var eventname = 'worryFreeTopic.verifyAcceptorWorryFreeOtp';
				parentRactiveWidget.fire(eventname, {
					name: eventname
				});
			}
		});
		self.on('*.onOtpSendClick', function () {
			var isValidId = this.validateId(),
				isValidType = this.validateIdType();
			var parentRactiveWidget = this.get('parentRactiveWidget');
			this.set('reconWorryFreeMsg', null);
			if (this.get('isReconFlow') && this.get('isFtthCrEnabled')) {
				if (this.validatePostalcode() && isValidId && isValidType) {
					this.set('inProcess', true);
					var ftthLoginInput = {
						'postalcode': self.get('postalcode'),
						'indentType': self.get('guestIdType'),
						'indentValue': self.get('idPrefixType') + self.get('idNumber'),
						'lob': parentRactiveWidget.getLob(),
						'isAcceptorFlow': self.get('isAcceptorFlow')
					};
					parentRactiveWidget.set('worryFreeTopic.otpInput', ftthLoginInput);
					var eventname = 'worryFreeTopic.sendWorryFreePostcode';
					parentRactiveWidget.fire(eventname, {
						name: eventname
					});
				}
			} else {
				if (this.checkValidity(this.get('isReconFlow'), this.get('isGomoFlow'), this.get('isPrepaidFlow'))) {
					parentRactiveWidget.set('worryFreeTopic.worryFreeVMStatus', 'SendOTP');
					var otpInput = {
						'mobileNumber': self.get('contactNumber'),
						'indentType': self.get('guestIdType'),
						'indentValue': self.get('idPrefixType') + self.get('idNumber'),
						'lob': parentRactiveWidget.getLob(),
						'isAcceptorFlow': self.get('isAcceptorFlow')
					};
				
					if (this.get('isReconFlow') && parentRactiveWidget.getLob() !== 'MOB') {
						otpInput.faCheckMandatory = true;
					} else {
						otpInput.faCheckMandatory = false;
					}
					if (this.get('isGomoFlow')) {
						otpInput.type = 'GOMO';
						otpInput.acceptorIndentValue = otpInput.indentValue;
						otpInput.acceptorIndentType = otpInput.indentType;
					} else if (this.get('isPrepaidFlow')) {
						otpInput.type = 'PREPAID';
						if (this.get('passportIdType') === 'Passport Number') {
							otpInput.acceptorIndentValue = otpInput.indentValue;
							otpInput.indentValue = self.get('passportIdNumber');
							otpInput.acceptorIndentType = otpInput.indentType;
							otpInput.indentType = self.get('passportIdType');
						} else {
							otpInput.indentValue = self.get('passportIdNumber');
							otpInput.indentType = self.get('passportIdType');
							otpInput.acceptorIndentValue = self.get('passportIdNumber');
							otpInput.acceptorIndentType = self.get('passportIdType');
						}
					}
					parentRactiveWidget.set('worryFreeTopic.otpInput', otpInput);
					this.set('reconOTPSendModalError', null);
					this.set('reconOTPVerifyModalError', null);
					this.set('acceptorWorryFreeErrorMsg', null);
					this.set('acceptorOTPFailed', null);
					this.set('otpNumber', null);
					this.set('inProcess', true);
					var eventname = 'worryFreeTopic.sendWorryFreeOtp';
					this.handleGOMOPrepaid(this.get('isGomoFlow'), this.get('isPrepaidFlow'));
					parentRactiveWidget.fire(eventname, {
						name: eventname
					});
					this.set('reconResendOTPMsg', null);
				}
			}
		});
		Ractive.defaults.on('deleteOtpContext', function (param) {
			var parentRactiveWidget = this.get('parentRactiveWidget');
			var eventname = 'worryFreeTopic.deleteWorryFree';
			parentRactiveWidget.fire(eventname, {
				name: eventname
			});
		}.bind(self));
		self.on('*.onOtpReSendClick', function () {
			var parentRactiveWidget = this.get('parentRactiveWidget');
			parentRactiveWidget.set('worryFreeTopic.worryFreeVMStatus', 'ReSendOTP');
			parentRactiveWidget.set('worryFreeTopic.isOTPResend', true);
			this.set('reconOTPVerifyModalError', null);
			this.set('inProcess', true);
			var eventname = 'worryFreeTopic.sendWorryFreeOtp';
			parentRactiveWidget.fire(eventname, {
				name: eventname
			});
		});
		self.on('*.onAcceptorOtpReSendClick', function () {
			var parentRactiveWidget = this.get('parentRactiveWidget');
			parentRactiveWidget.set('worryFreeTopic.worryFreeVMStatus', 'ReSendOTP');
			parentRactiveWidget.set('worryFreeTopic.isOTPResend', true);
			this.set('acceptorWorryFreeErrorMsg', null);
			this.set('acceptorOTPFailed', null);
			this.set('inProcess', true);
			var eventname = 'worryFreeTopic.sendAcceptorWorryFreeOtp';
			parentRactiveWidget.fire(eventname, {
				name: eventname
			});
		});
		self.get('parentRactiveWidget').observe('worryFreeTopic.worryFreeVMStatus', self.onVmStatusChange.bind(self));
		self.observe('reconResendOTPMsg reconOTPVerifyModalError', self.setErrorField.bind(self, 'otpNumberErrorMsg'));
		self.observe('reconFAVerifyModalError', self.setErrorField.bind(self, 'accountNumberErrorMsg'));
				self.observe('acceptorOTPFailed', self.setErrorField.bind(self, 'serviceNumberErrorMsg'));
		self.observe('acceptorWorryFreeErrorMsg', self.setErrorField.bind(self, 'prepaidOtpNumberErrorMsg'));
		self.observe('otpAcceptorVerificationFailed', self.setErrorField.bind(self, 'prepaidAccountNumberErrorMsg'));
		self.observe('myInfoData', function (myInfoData) {
			if (myInfoData && myInfoData.custId && myInfoData.idType && myInfoData.custId.length > 0) {
				var nric =  myInfoData.custId;
				self.set('idPrefixType', nric.substring(0, 1));
				self.set('idNumber', nric.substring(1));
				self.filterIDTypeOptions(nric.substring(0, 1));
				setTimeout(function () {
					self.set('guestIdType', myInfoData.idType);
				}, 0);
				self.set('contactNumber', myInfoData.selectedNumber);
			}
		});
	},
	onBreadcrumbStepChange: function () {
		this.set('reconOTPVerifyModalError', null);
		this.set('acceptorWorryFreeErrorMsg', null);
		this.set('reconOTPSendModalError', null);
		this.set('acceptorAttemptOTPVerifyModalError', null);
		this.set('acceptorOTPSendModalError', null);
		this.set('reconWorryFreeMsg', null);
		this.set('acceptorOTPFailed', null);
		this.set('otpAcceptorVerificationFailed', null);
		clearInterval(this.timer);
		var hash = window.location.hash;
		if (hash && hash === '#worryfree/verify-otp') {
			this.getTimer(this.get('initData.timer'), 0, false);
		} else if (hash && hash === '#worryfree/verify-otp-prepaid') {
			this.getTimer(this.get('initData.timer'), 0, true);
		}
	},
	checkValidity: function (isRecon,isGomo,isPrepaid) {
		var isValidId = this.validateId(),
		isValidType = this.validateIdType();
		var isValid = false;
		if (isRecon || isGomo && this.validateMobileNumber() && isValidId && isValidType) {
			isValid = true;
		} else if (isPrepaid) {
			if (this.get('passportIdType') === 'Passport Number') {
				if (this.validateMobileNumber() && isValidId && isValidType && this.validatePassportId('passport')) {
					isValid = true;
				}
			} else {
				if (this.validatePassportId('nric') && this.validateMobileNumber()) {
					isValid = true;
				}
			}
		} else if (!isRecon && !isGomo && !isPrepaid &&
			this.validateMobileNumber() && isValidId && isValidType) {
			isValid = true;
		}
		return isValid;
	},
	handleGOMOPrepaid: function (isGomoFlow,isPrepaidFlow) {
		var parentRactiveWidget = this.get('parentRactiveWidget');
		if (isGomoFlow) {
			sessionStorage.setItem('optionType', 'gomo');
			parentRactiveWidget.set('loginClicked', true);
			sessionStorage.setItem('loginClicked', true);
		}
		if (isPrepaidFlow) {
			sessionStorage.setItem('optionType', 'prepaid');
			parentRactiveWidget.set('loginClicked', true);
			sessionStorage.setItem('loginClicked', true);
		}
	},
	setErrorField: function (errorField, newValue, oldValue, keypath) {
		var errorMsg = {
			'status': 'error',
			'message': null,
			'rule': null,
			'passed': false
		};
		if (newValue) {
			errorMsg.message = newValue;
			this.set(errorField, errorMsg);
		} else {
			errorMsg.status = 'valid';
			errorMsg.passed = true;
			this.set(errorField, errorMsg);
		}
	},
	oncomplete: function () {
		Ractive.defaults.fire('ux-singtel-breadcrumbs.goto-specific-step', 0);
	},
	gotoNext: function () {
		Ractive.defaults.fire('ux-singtel-breadcrumbs.goto-next-step');
	},
	gotoPrev: function () {
		Ractive.defaults.fire('ux-singtel-breadcrumbs.goto-prev-step');
	},
	gotoSpecificNextStep: function (number) {
		Ractive.defaults.fire('ux-singtel-breadcrumbs.goto-specific-step', number);
	},
	gotoSpecificNextStepById: function (id) {
		Ractive.defaults.fire('ux-singtel-breadcrumbs.goto-specific-step-byid', id);
	},
	filterIDTypeOptions: function (value) {
		var self = this;
		var allOptions = ConfigStrings.guestIdTypeOptions;
		var filteredOptions = _.filter(allOptions, function (item) {
			return item.ID === value;
		});
		var newFilteredOptions = [];
		if (value !== 'S' && value !== 'T') {
			newFilteredOptions.push({
				title: 'Select',
				value: 'Select'
			});
		}
		newFilteredOptions = newFilteredOptions.concat(filteredOptions);
		setTimeout(function () {
			self.set('guestIdType', newFilteredOptions[0].value);
			self.set('guestIdTypeOptions', newFilteredOptions);
		}.bind(self), 0);
	},
	getTimer: function (min, sec, isAcceptorFlow) {
		var duration = moment.duration({
			'minutes': min,
			'seconds': sec
		});
		var timestamp = new Date(0, 0, 0, 2, 10, 30);
		var interval = 1;
		this.set('reconOTPVerifyModalError', null);
		this.set('acceptorWorryFreeErrorMsg', null);
		if (!isAcceptorFlow) {
			this.set('resendOtp', true);
		} else {
			this.set('acceptorResendOtp', true);
		}
		this.timer = setInterval(function () {
			timestamp = new Date(timestamp.getTime() + interval * 1000);
			duration = moment.duration(duration.asSeconds() - interval, 'seconds');
			this.sec = duration.asSeconds() - interval;
			this.set('otpTimer', this.sec + ' seconds');
			if (this.sec === 0) {
				clearInterval(this.timer);
				this.set('otpTimer', this.sec + ' seconds');
				if (!isAcceptorFlow) {
					this.set('resendOtp', false);
					this.set('reconOTPVerifyModalError', this.get('initData.worryFreeOtpExpired'));
				} else {
					this.set('acceptorResendOtp', false);
					this.set('acceptorWorryFreeErrorMsg', this.get('initData.worryFreeOtpExpired'));
				}
			}
		}.bind(this), 1000);
	},
	getNavigationUrl: function () {
		var self = this;
		var redirectUrl = self.get('redirectUrl') ||
			RactiveHelpers.removeParam(window.location.href, 'loginstatus');
		return redirectUrl;
	},
	onVmStatusChange: function (status) {
		var self = this;
		var parentRactiveWidget = self.get('parentRactiveWidget');
		var otpInput = parentRactiveWidget.get('worryFreeTopic.otpInput');
		switch (status) {
			case 'WorryFreeNewCustomer':
				self.set('inProcess', false);
				self.set('reconOTPSendModalError', self.get('initData.worryFreeNewCustomer'));
				this.fire('WorryFreeNewCustomerDetected');
				break;
			case 'WorryFreeExistingCustomer':
				clearInterval(self.timer);
				self.gotoSpecificNextStep(2);
				self.getTimer(self.get('initData.timer'), 0, false);
				self.set('inProcess', false);
				break;
			case 'WorryFreeOtpSendFACheckReequired':
				self.set('inProcess', false);
				var parentRactiveWidget = this.get('parentRactiveWidget');
				if ((self.get('isReconFlow') || self.get('isGomoFlow') || self.get('isPrepaidFlow')) &&
					parentRactiveWidget.getLob() === 'MOB') {
					self.set('reconOTPSendModalError', self.get('initData.worryFreeOtpReconNotVerified'));
				} else {
					self.gotoNext();
				}
				break;
			case 'WorryFreeOtpSendError':
				self.set('inProcess', false);
				self.set('reconOTPSendModalError', self.get('initData.worryFreeOtpSendError'));
				break;
			case 'WorryFreeOtpSendFailed':
				self.set('inProcess', false);
				self.set('reconOTPSendModalError', self.get('initData.worryFreeOtpSendFailed'));
				break;
			case 'WorryFreeOtpNotVerified':
				self.set('inProcess', false);
				self.set('reconOTPVerifyModalError', self.get('initData.worryFreeOtpNotVerified'));
				break;
			case 'WorryFreeOtpVerified':
				self.set('inProcess', false);
				var originUrl = self.getNavigationUrl();
				if (originUrl === window.location.href) {
					window.location.reload();
				} else {
					window.location.href = originUrl;
				}
				break;
			case 'WorryFreeOtpVerifyError':
				self.set('inProcess', false);
				self.set('reconOTPVerifyModalError', self.get('initData.worryFreeOtpVerifyError'));
				break;
			case 'WorryFreeOtpVerifyFailed':
				self.set('inProcess', false);
				self.set('reconOTPVerifyModalError', self.get('initData.worryFreeOtpVerifyFailed'));
				break;
			case 'WorryFreeOtpBillingActVerifySuccess':
				self.set('inProcess', false);
				var originUrl = self.getNavigationUrl();
				if (originUrl === window.location.href) {
					window.location.reload();
				} else {
					window.location.href = originUrl;
				}
				break;
			case 'WorryFreeOtpBillingActVerifyFailed':
				self.set('inProcess', false);
				self.set('reconFAVerifyModalError', self.get('initData.worryFreeOtpBillingActVerifyFailed'));
				break;
			case 'WorryFreeOtpBillingActVerifyError':
				self.set('inProcess', false);
				self.set('reconFAVerifyModalError', self.get('initData.worryFreeOtpBillingActVerifyError'));
				break;
			case 'deleteWorryFreeSuccess':
				break;
			case 'deleteWorryFreeError':
				break;
			case 'WorryFreeExistingCustomerReSendOTP':
				clearInterval(self.timer);
				self.set('reconResendOTPMsg', self.get('initData.worryFreeExistingCustomerReSendOTP'));
				self.getTimer(self.get('initData.timer'), 0, false);
				self.set('inProcess', false);
				break;
			case 'WorryFreeOtpSendErrorReSendOTP':
				self.set('inProcess', false);
				self.set('reconResendOTPMsg', self.get('initData.worryFreeOtpSendErrorReSendOTP'));
				break;
			case 'WorryFreeOtpSendFailedReSendOTP':
				self.set('inProcess', false);
				self.set('reconResendOTPMsg', self.get('initData.worryFreeOtpSendFailedReSendOTP'));
				break;
			case 'WorryFreeFASavedAndOTPSent':
				clearInterval(self.timer);
				self.set('inProcess', false);
				self.gotoSpecificNextStep(2);
				self.getTimer(self.get('initData.timer'), 0, false);
				break;
			case 'WorryFreeFASavedAndOTPSentFailed':
				self.set('inProcess', false);
			
				self.set('reconFAVerifyModalError', self.get('initData.worryFreeOtpSendError'));
				break;
			case 'WorryFreeFASavedAndOTPSentError':
				self.set('inProcess', false);
			
				self.set('reconFAVerifyModalError', 'Please Try After sometime');
				break;
		
			case 'WorryFreeLoginSuccess':
				self.set('inProcess', false);
				if (self.get('isAcceptorFlow')) {
					self.fire('worryFreeAcceptorIdentified', self.get());
				} else {
					var originUrl = self.getNavigationUrl();
					if (originUrl === window.location.href) {
						window.location.reload();
					} else {
						window.location.href = originUrl;
					}
				}
				break;
			case 'WorryFreeFAVerificationFailed':
				self.set('inProcess', false);
			
				self.gotoSpecificNextStep(1);
				self.set('reconFAVerifyModalError', self.get('initData.worryFreeOtpBillingActVerifyFailed'));
				break;
			case 'WorryFreeOTPVerificationFailed':
				self.set('inProcess', false);
				clearInterval(self.timer);
				self.getTimer(self.get('initData.timer'), 0, false);
				self.set('reconOTPVerifyModalError', self.get('initData.worryFreeOtpVerifyFailed'));
				break;
			case 'WorryFreeVerificationFailed':
				self.set('inProcess', false);
				if (self.timer) {
					clearInterval(self.timer);
				}
			
				self.set('reconResendOTPMsg', 'Please Try After sometime !!');
				break;
			case 'WorryFreeVerificationError':
			
				self.set('inProcess', false);
				self.set('reconResendOTPMsg', 'Please Try After sometime !!');
				break;
			case 'WorryFreeOTPAttemptExceed':
				self.set('inProcess', false);
				self.set('reconOTPVerifyModalError', 'You have exceeded the number of OTP attempts.' +
					' Please try again after 30 minutes.');
				break;
			case 'WorryFreeFASavedAndOTPAttemptExceed':
				self.set('inProcess', false);
				self.set('reconFAVerifyModalError', 'You have exceeded the number of attempts.' +
					' Please try again after 30 minutes');
				break;
			case 'WorryFreePostCodeNotFound':
				self.set('inProcess', false);
				self.set('reconWorryFreeMsg', self.get('initData.postCodeNotFound'));
				break;
			case 'WorryFreePostcodeAttemptExceed':
				self.set('inProcess', false);
				self.set('reconWorryFreeMsg', self.get('initData.ftthLoginAttemptExceed'));
				break;
			case 'WorryFreeFtthLoginFailed':
				self.set('inProcess', false);
				self.set('reconWorryFreeMsg', self.get('initData.worryFreeFtthLoginFailed'));
				break;
			case 'WorryFreeFtthNricNotFound':
				self.set('inProcess', false);
				self.set('reconWorryFreeMsg', self.get('initData.ftthNricNotFound'));
				break;
			case 'AcceptorNewCustomer':
			case 'AcceptorMobileExists':
			case 'AcceptorSubExists':
				setTimeout(function () {
					var acceptorData = {
						prepaidNumber: self.get('contactNumber'),
						optionType: 'prepaid'
					};
					self.fire('checkAcceptorNumber', acceptorData);
					self.set('acceptorWorryFreeErrorMsg', null);
				}.bind(self), 0);
				if (self.timer) {
					clearInterval(self.timer);
				}
				break;
			case 'WorryFreeAcceptorOTPSuccess':
				if (self.timer) {
					clearInterval(self.timer);
				}
				self.gotoSpecificNextStep(5);
				self.getTimer(self.get('initData.timer'), 0, true);
				self.set('inProcess', false);
				break;
			case 'WorryFreeAcceptorOTPFailed':
				self.set('inProcess', false);
				self.set('acceptorOTPFailed', self.get('initData.worryFreeOtpReconNotVerified'));
				break;
			case 'WorryFreeAcceptorOTPAttemptExceed':
				self.set('inProcess', false);
				self.set('acceptorWorryFreeErrorMsg', 'You have exceeded the number of OTP attempts.' +
					' Please try again after 30 minutes.');
				break;
			case 'WorryFreeAcceptorOtpSendFailed':
				self.set('inProcess', false);
				self.set('acceptorWorryFreeErrorMsg', self.get('initData.worryFreeOtpSendFailed'));
				break;
			case 'WorryFreeOTPAcceptorVerificationFailed':
				self.set('inProcess', false);
				clearInterval(self.timer);
				self.getTimer(self.get('initData.timer'), 0, true);
				if (otpInput && otpInput.acceptorAccountNumber) {
					self.set('otpAcceptorVerificationFailed', self.get('initData.worryFreeOtpVerifyFailed'));
				} else {
					self.set('acceptorWorryFreeErrorMsg', self.get('initData.worryFreeOtpVerifyFailed'));
				}
				break;
			case 'WorryFreeAcceptorReSendOTPSuccess':
				clearInterval(self.timer);
				self.set('acceptorWorryFreeErrorMsg', self.get('initData.worryFreeExistingCustomerReSendOTP'));
				self.getTimer(self.get('initData.timer'), 0, false);
				self.set('inProcess', false);
				break;
			case 'WorryFreeAcceptorVerificationError':
			case 'WorryFreeAcceptorVerificationFailed':
				self.set('inProcess', false);
			
				if (otpInput && otpInput.acceptorAccountNumber) {
					self.set('otpAcceptorVerificationFailed', self.get('Please Try After sometime !!'));
				} else {
					self.set('acceptorWorryFreeErrorMsg', self.get('Please Try After sometime !!'));
				}
				break;
			case 'WorryFreeAcceptorFAVerificationFailed':
				self.set('inProcess', false);
			
				self.gotoSpecificNextStep(1);
				if (otpInput && otpInput.acceptorAccountNumber) {
					self.set('otpAcceptorVerificationFailed', self.get('initData.worryFreeOtpBillingActVerifyFailed'));
				} else {
					self.set('acceptorWorryFreeErrorMsg', self.get('initData.worryFreeOtpBillingActVerifyFailed'));
				}
				break;
			case 'WorryFreeAcceptorLoginSuccess':
				setTimeout(function () {
					sessionStorage.setItem('loginClicked', true);
					var eventName = 'loginStatusTopic.setOnePassFields';
					sessionStorage.setItem('optionType', 'prepaid');
					self.get('parentRactiveWidget').set('isPrepaidFlow', true);
					self.get('parentRactiveWidget').fire(eventName, {
						name: eventName
					});
				}.bind(self), 0);
				clearInterval(self.timer);
				break;
		}
	}
});

Ractive.components["ux-youth-plans"] = Ractive.extend({
	template: LUXComponentTemplates['ux-youth-plans'],
	data: function () {
		return {
			RactiveHelpers: RactiveHelpers
		};
	}
});

return Ractive.components;

});

define('RedmarineTransition',['jquery'], function ($) {

	/**
	 * Reference for writing Transition Plugins in ractivejs
	 * http://docs.ractivejs.org/latest/writing-transition-plugins
	 * Overview of this plugin file.
	 * https://wiki.express.optus.com.au/x/sQ8wB
	 */

	return {
		/**
		 * slideToggle transition helper. Replaces the need for custom jQuery.
		 * e.g. <span intro-outro="slideToggle:{duration:'fast'}" />
		 * @param transition
		 * @param params
		 */
		slideToggle: function (transition, params) {

			var defaults = {
				duration: 400
			};

			params = transition.processParams(params, defaults);

			if (transition.isIntro) {
				$(transition.node)
					.hide()
					.slideDown(params.duration, function () {
						transition.complete();
					});
			} else {
				$(transition.node)
					.slideUp(params.duration, function () {
						transition.complete();
					});
			}

		}
	};
});

define('RedmarineDecorator',['lodash-compat'], function (_) {

	/**
	 * Reference for writing Decorator Plugins in ractivejs
	 * http://docs.ractivejs.org/latest/writing-decorator-plugins
	 */

	/**
	 * Will set the height as defined from the template
	 */
	var heightDecorator = function (node, height) {
		if (!!height) {
			node.style.height = height;
		}
		return {
			teardown: function () {}
		};
	};

	/**
	 * Reference for writing Decorator Plugins in ractivejs
	 * http://docs.ractivejs.org/latest/writing-decorator-plugins
	 */

	/**
	 * Has a dependency on the height set in the widget data
	 * Widget should have
	 *		data {
	 *			equalizerHeights: {
	 *				xxx: 'auto'
	 *			}
	 *		}
	 *
	 * Where xxx maps in the template as
	 * 	<div data-equalizer-listener="xxx" decorator="equalizer">
	 * This will only work the once as the ractive template does not identify when the heights are changed
	 */
	var equalizerDecorator = function (node) {
		if (this.data.equalizerHeights &&
			node.dataset.equalizerListener &&
			this.data.equalizerHeights[node.dataset.equalizerListener]) {
			node.style.height = this.data.equalizerHeights[node.dataset.equalizerListener];
		}
		return {
			teardown: function () {}
		};
	};


	/**
		* A decorator to equalize the heights of elements with same
		* 'data-equalizer-selector' attribute
		*
		* Template:
		* <element
		* 	decorator="responsiveEqualizer"
		* 	data-equalizer-selector="one"
		* 	data-equalizer-breakpoint="640"
		* >
		* </element>
		*/
	var responsiveEqualizerDecorator = function (node) {

		var self = this;
		var breakpoint = node.dataset.equalizerBreakpoint || self.breakpoint;
		var Equalizer = function () {

			var self = this;

			/**
				* Equalize single node
			*/
			self.equalize = function (node) {
				node.style.height = _.max(
					_.map(
						document.querySelectorAll('[data-equalizer-selector=' + node.dataset.equalizerSelector + ']'),
						'offsetHeight')
				) + 'px';
			};

			/**
				* Equalizes all the nodes
				*/
			self.equalizeAll = function (nodes) {
				// reset heights of all
				self.resetAll(nodes);

				// recalculate the height
				_.each(nodes, self.equalize);
			};

			/**
				* Resets single node
			*/
			self.reset = function (node) {
				node.style.height = 'auto';
			};

			/**
				* Resets all nodes
			*/
			self.resetAll = function (nodes) {
				_.each(nodes, self.reset);
			};

		};

		// instantiate the object for this node
		var eq = new Equalizer();

		self.eq = eq;
		self.breakpoint = breakpoint;

		// make sure to execute the equalize() only after the
		// calling Ractive instance finishes rendering - oncomplete
		(function () {
			// save the reference of the caller oncomplete
			var _oncomplete = self.oncomplete;
			self.oncomplete = function () {
				_oncomplete.call(self);
				if (!breakpoint) {
					eq.equalize(node);
				} else if (window.innerWidth > parseInt(breakpoint)) {
					eq.equalize(node);
				}
			};
		})();

		// save the nodes in the map for onResize
		if (!self.equalizerNodes) {
			self.equalizerNodes = [];
		}

		// avoid duplicate entries
		if (!_.contains(self.equalizerNodes, node.dataset.equalizerSelector)) {
			self.equalizerNodes.push(node);
		}

		// define the resize handler
		var resizeHandler = function () {
			if (!breakpoint) {
				eq.equalizeAll(self.equalizerNodes);
			} else if (window.innerWidth > parseInt(breakpoint)) {
				eq.equalizeAll(self.equalizerNodes);
			} else {
				eq.resetAll(self.equalizerNodes);
			}
		};

		// attach the resize listener
		window.addEventListener('resize', resizeHandler, false);
		if ('onorientationchange' in window) {
			window.addEventListener('orientationchange', resizeHandler, false);
		}

		// if the element contains images, then refresh after all images are loaded
		_.each(self.findAll('img'), function (image) {
			image.onload = function () {
				if (!breakpoint) {
					eq.equalizeAll(self.equalizerNodes);
				} else if (window.innerWidth > parseInt(breakpoint)) {
					eq.equalizeAll(self.equalizerNodes);
				}
			};
		});

		return {
			teardown: function () {
				_.omit(self, 'equalizerNodes');
			}
		};
	};

	/**
		* Expose equalizeAll to the components/widgets
		*
		* Note:
		* The context of 'this' should be the same as the decorator function
		*/
	responsiveEqualizerDecorator.equalize = function () {
		if (!this.breakpoint) {
			this.eq.equalizeAll(this.equalizerNodes);
		} else if (window.innerWidth > parseInt(this.breakpoint)) {
			this.eq.equalizeAll(this.equalizerNodes);
		}
	};

	return {
		equalizer: equalizerDecorator,
		height: heightDecorator,
		responsiveEqualizer: responsiveEqualizerDecorator
	};
});

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define('simulant',factory) :
	global.simulant = factory()
}(this, function () { 'use strict';

	var defaults = {
		bubbles: true,
		cancelable: true,
		view: window,
		detail: null,
		screenX: 0,
		screenY: 0,
		clientX: 0,
		clientY: 0,
		ctrlKey: false,
		altKey: false,
		shiftKey: false,
		metaKey: false,
		button: 0,
		relatedTarget: null,
		locale: '',
		oldURL: '',
		newURL: '',
		origin: '',
		lastEventId: '',
		source: null,
		ports: [],
		oldValue: null,
		newValue: null,
		url: '',
		storageArea: null,
		deltaX: 0,
		deltaY: 0,
		deltaZ: 0,
		deltaMode: 0
	};

	var eventTypesByGroup = {
		UIEvent: 'abort error resize scroll select unload',
		Event: 'afterprint beforeprint cached canplay canplaythrough change chargingchange chargingtimechange checking close dischargingtimechange DOMContentLoaded downloading durationchange emptied ended fullscreenchange fullscreenerror input invalid levelchange loadeddata loadedmetadata noupdate obsolete offline online open orientationchange pause pointerlockchange pointerlockerror play playing ratechange readystatechange reset seeked seeking stalled submit success suspend timeupdate updateready visibilitychange volumechange waiting',
		AnimationEvent: 'animationend animationiteration animationstart',
		AudioProcessingEvent: 'audioprocess',
		BeforeUnloadEvent: 'beforeunload',
		TimeEvent: 'beginEvent endEvent repeatEvent',
		FocusEvent: 'blur focus focusin focusout',
		MouseEvent: 'click contextmenu dblclick mousedown mouseenter mouseleave mousemove mouseout mouseover mouseup show',
		SensorEvent: 'compassneedscalibration userproximity',
		OfflineAudioCompletionEvent: 'complete',
		CompositionEvent: 'compositionend compositionstart compositionupdate',
		ClipboardEvent: 'copy cut paste',
		DeviceLightEvent: 'devicelight',
		DeviceMotionEvent: 'devicemotion',
		DeviceOrientationEvent: 'deviceorientation',
		DeviceProximityEvent: 'deviceproximity',
		DragEvent: 'drag dragend dragenter dragleave dragover dragstart drop',
		GamepadEvent: 'gamepadconnected gamepaddisconnected',
		HashChangeEvent: 'hashchange',
		KeyboardEvent: 'keydown keypress keyup',
		ProgressEvent: 'loadend loadstart progress timeout',
		MessageEvent: 'message',
		PageTransitionEvent: 'pagehide pageshow',
		PopStateEvent: 'popstate',
		StorageEvent: 'storage',
		SVGEvent: 'SVGAbort SVGError SVGLoad SVGResize SVGScroll SVGUnload',
		SVGZoomEvent: 'SVGZoom',
		TouchEvent: 'touchcancel touchend touchenter touchleave touchmove touchstart',
		TransitionEvent: 'transitionend',
		WheelEvent: 'wheel'
	};

	var eventGroupByType = {};

	Object.keys(eventTypesByGroup).forEach(function (group) {
		var types = eventTypesByGroup[group].split(' ');

		types.forEach(function (t) {
			eventGroupByType[t] = group;
		});
	});

	// The parameters required by event constructors and init methods, in the order the init methods need them.

	// There is no initKeyboardEvent or initKeyEvent here. Keyboard events are a goddamned mess. You can't fake them
	// well in any browser - the which and keyCode properties are readonly, for example. So we don't actually use the
	// KeyboardEvent constructor, or the initKeyboardEvent or initKeyEvent methods. Instead we use a bog standard
	// Event and add the required parameters as expando properties.

	// TODO I think in some browsers we need to use modifiersList instead of ctrlKey/shiftKey etc?
	var initialiserParams = {
		initUIEvent: 'view detail',
		initMouseEvent: 'view detail screenX screenY clientX clientY ctrlKey altKey shiftKey metaKey button relatedTarget',
		initCompositionEvent: 'view detail data locale',
		initHashChangeEvent: 'oldURL newURL',
		initMessageEvent: 'data origin lastEventId source ports',
		initStorageEvent: 'key oldValue newValue url storageArea',
		initWheelEvent: 'view detail screenX screenY clientX clientY ctrlKey altKey shiftKey metaKey button relatedTarget deltaX deltaY deltaZ deltaMode'
	};

	Object.keys(initialiserParams).forEach(function (initMethod) {
		initialiserParams[initMethod] = initialiserParams[initMethod].split(' ');
	});

	var initialisersByGroup = {
		UIEvent: [window.UIEvent, 'initUIEvent'],
		Event: [window.Event, 'initEvent'],
		FocusEvent: [window.FocusEvent, 'initUIEvent'],
		MouseEvent: [window.MouseEvent, 'initMouseEvent'],
		CompositionEvent: [window.CompositionEvent, 'initCompositionEvent'],
		HashChangeEvent: [window.HashChangeEvent, 'initHashChangeEvent'],
		KeyboardEvent: [window.Event, 'initEvent'],
		ProgressEvent: [window.ProgressEvent, 'initEvent'],
		MessageEvent: [window.MessageEvent, 'initMessageEvent'], // TODO prefixed?
		PageTransitionEvent: [window.PageTransitionEvent, 'initEvent'],
		PopStateEvent: [window.PopStateEvent, 'initEvent'],
		StorageEvent: [window.StorageEvent, 'initStorageEvent'],
		TouchEvent: [window.TouchEvent, 'initTouchEvent'],
		WheelEvent: [window.WheelEvent, 'initWheelEvent'] // TODO this differs between browsers...
	};

	var utils_extendWithKeyboardParams = extendWithKeyboardParams;
	var keyboardParams = ['which', 'keyCode', 'shiftKey', 'ctrlKey', 'altKey', 'metaKey'];
	function extendWithKeyboardParams(event, params) {
		var i = keyboardParams.length;
		while (i--) {
			event[keyboardParams[i]] = params[keyboardParams[i]];
		}
	}

	var ancient = function () {
		function makeInitialiser(methodName, paramsList) {
			return function (event, type, params) {
				event.type = type;

				var i = paramsList.length;
				while (i--) {
					var paramName = paramsList[i];
					event[paramName] = params[paramName] || defaults[paramName];
				}
			};
		}

		var initialisers = {};
		var methodName = undefined;

		for (methodName in initialiserParams) {
			if (initialiserParams.hasOwnProperty(methodName)) {
				initialisers[methodName] = makeInitialiser(methodName, initialiserParams[methodName]);
			}
		}

		initialisers.initEvent = makeInitialiser('initEvent', []);

		function simulant(type, params) {
			var group = eventGroupByType[type];
			var isKeyboardEvent = undefined;

			if (group === 'KeyboardEvent') {
				isKeyboardEvent = true;
				group = 'Event';
			}

			var initialiserName = initialisersByGroup[group][1];
			var initialise = initialisers[initialiserName];

			var event = document.createEventObject();
			initialise(event, type, params || {});

			if (isKeyboardEvent) {
				utils_extendWithKeyboardParams(event, params);
			}

			return event;
		}

		simulant.mode = 'ancient';
		return simulant;
	}

	var legacy = function () {
		function makeInitialiser(methodName, paramsList) {
			return function (event, type, params) {
				var args;

				// first three args are always `type`, `bubbles`, `cancelable`
				args = [type, true, true]; // TODO some events don't bubble?

				paramsList.forEach(function (paramName) {
					args.push(params[paramName] || defaults[paramName]);
				});

				event[methodName].apply(event, args);
			};
		}

		var initialisers = {};

		Object.keys(initialiserParams).forEach(function (methodName) {
			initialisers[methodName] = makeInitialiser(methodName, initialiserParams[methodName]);
		});

		initialisers.initEvent = makeInitialiser('initEvent', []);

		function simulant(type, params) {
			var event, group, initialiserName, initialise, isKeyboardEvent;

			group = eventGroupByType[type];

			if (group === 'KeyboardEvent') {
				isKeyboardEvent = true;
				group = 'Event';
			}

			initialiserName = initialisersByGroup[group][1];
			initialise = initialisers[initialiserName];

			event = document.createEvent(group);
			initialise(event, type, params || {});

			if (isKeyboardEvent) {
				utils_extendWithKeyboardParams(event, params);
			}

			return event;
		}

		simulant.mode = 'legacy';
		return simulant;
	}

	var modern = function () {
		function simulant(type) {
			var params = arguments[1] === undefined ? {} : arguments[1];

			var group = eventGroupByType[type];
			var isKeyboardEvent = undefined;

			if (group === 'KeyboardEvent') {
				group = 'Event'; // because you can't fake KeyboardEvents well in any browser
				isKeyboardEvent = true;
			}

			var initialiser = initialisersByGroup[group] || initialisersByGroup.Event;

			var Constructor = initialiser[0] || window.Event;
			var method = initialiser[1];

			var extendedParams = {
				bubbles: true, // TODO some events don't bubble?
				cancelable: true
			};

			var paramsList = initialiserParams[method];
			var i = paramsList ? paramsList.length : 0;

			while (i--) {
				var paramName = paramsList[i];
				extendedParams[paramName] = paramName in params ? params[paramName] : defaults[paramName];
			}

			var event = new Constructor(type, extendedParams);

			if (isKeyboardEvent) {
				utils_extendWithKeyboardParams(event, params);
			}

			return event;
		}

		simulant.mode = 'modern';
		return simulant;
	}

	var utils_polyfill = polyfill;

	function polyfill() {

		// https://gist.github.com/Rich-Harris/6010282 via https://gist.github.com/jonathantneal/2869388
		// addEventListener polyfill IE6+
		var Event, addEventListener, removeEventListener, head, style;

		Event = function (e, element) {
			var property,
			    instance = this;

			for (property in e) {
				instance[property] = e[property];
			}

			instance.currentTarget = element;
			instance.target = e.srcElement || element;
			instance.timeStamp = +new Date();

			instance.preventDefault = function () {
				e.returnValue = false;
			};

			instance.stopPropagation = function () {
				e.cancelBubble = true;
			};
		};

		addEventListener = function (type, listener) {
			var element = this,
			    listeners,
			    i;

			listeners = element.listeners || (element.listeners = []);
			i = listeners.length;

			listeners[i] = [listener, function (e) {
				listener.call(element, new Event(e, element));
			}];

			element.attachEvent('on' + type, listeners[i][1]);
		};

		removeEventListener = function (type, listener) {
			var element = this,
			    listeners,
			    i;

			if (!element.listeners) {
				return;
			}

			listeners = element.listeners;
			i = listeners.length;

			while (i--) {
				if (listeners[i][0] === listener) {
					element.detachEvent('on' + type, listeners[i][1]);
				}
			}
		};

		window.addEventListener = document.addEventListener = addEventListener;
		window.removeEventListener = document.removeEventListener = removeEventListener;

		if ('Element' in window) {
			Element.prototype.addEventListener = addEventListener;
			Element.prototype.removeEventListener = removeEventListener;
		} else {
			head = document.getElementsByTagName('head')[0];
			style = document.createElement('style');

			head.insertBefore(style, head.firstChild);

			style.styleSheet.cssText = '*{-ms-event-prototype:expression(!this.addEventListener&&(this.addEventListener=addEventListener)&&(this.removeEventListener=removeEventListener))}';
		}

		addEventListener.simulant = true;
	}

	var simulant;

	try {
		new MouseEvent('click');
		simulant = modern();
	} catch (err) {
		if (!document.createEvent) {
			if (document.createEventObject) {
				simulant = ancient();
			} else {
				throw new Error('Events cannot be created in this browser');
			}
		} else {
			simulant = legacy();
		}
	}

	if (document.dispatchEvent) {
		simulant.fire = function (node, event, params) {
			if (typeof event === 'string') {
				event = simulant(event, params);
			}

			node.dispatchEvent(event);
			return event;
		};
	} else if (document.fireEvent) {
		simulant.fire = function (node, event, params) {
			if (typeof event === 'string') {
				event = simulant(event, params);
			}

			node.fireEvent('on' + event.type, event);

			// Special case - checkbox inputs
			if (node.tagName === 'INPUT' && node.type === 'checkbox') {
				node.click();
			}
			return event;
		};
	}

	simulant.polyfill = utils_polyfill;

	var _simulant = simulant;

	return _simulant;

}));
//# sourceMappingURL=simulant.js.map
;
define('singtelTooltipDecorator',['ractive', 'hammerjs'], function (Ractive, Hammer) {
	/*
	var options = {
		observeField: 'inProcess',
		selector: 'DOM Node'
	}
	*/
	var singtelTooltip = function (node, options) {
		var leaveHandled = false;
		var toggleClass = function (ev) {
			//ev.stopPropagation();
			$(node).toggleClass('show');
			//var arrow = $(node).find('.tooltip-arrow').get(0);
		};
		var leaveHandled = false;
		var mouseClickHandler = function (ev) {
			if (!leaveHandled) {
				toggleClass(ev);
			}
			leaveHandled = false;
			if ($(node).hasClass('show')) {
				setTimeout(function () {
					document.addEventListener('click', mouseClickHandler);
				},0);
				//documentTapHandler = hammerNode.on('tap', toggleClass);
			} else {
				document.removeEventListener('click', mouseClickHandler);
			}
		};

		var mouseOverHandler = function (ev) {
			toggleClass(ev);
		};

		var mouseEnterHandler = function (ev) {
			$(node).addClass('show');
		};

		var mouseLeaveHandler = function (ev) {
			$(node).removeClass('show');
			leaveHandled = true;
		};

		var ractiveComponent = this;
		options = options || {};
		//var defaultClass = options.defaultClass || 'hide';
		var selector = options.selector || '.singtel-tooltip-action-element';
		//$(node).addClass(defaultClass)
		//var actionNode = $(node).find(selector).get(0);
		var actionNode = node;
		//var hammerNode = new Hammer(actionNode);
		var documentTapHandler = null;
		var tapHandler = null;
		var hoverHandler = null;
		if (options.onmouseover && options.onclick) {
			actionNode.addEventListener('click', mouseClickHandler);	
			actionNode.addEventListener('mouseenter', mouseEnterHandler);
			actionNode.addEventListener('mouseleave', mouseLeaveHandler);
		} else {
			if (options.onmouseover) {
				//tapHandler = hammerNode.on('tap', toggleClass);
				//var documentHammerNode = new Hammer(document);
				//$(actionNode).on('click', toggleClass);
				actionNode.addEventListener('mouseenter', mouseOverHandler);
				actionNode.addEventListener('mouseleave', mouseOverHandler);
			}
			if (options.onclick) {
				actionNode.addEventListener('click', mouseClickHandler);	
			}
		}
		
		// Return an object with a `teardown()` method that removes the
		// event handlers when we no longer need them
		return {
			teardown: function () {
				actionNode.removeEventListener('click', toggleClass);
			}
		};
	};

	Ractive.decorators.singtelTooltip = singtelTooltip;

	return singtelTooltip;
});

define('BaseWidget',[
	'jquery',
	'lodash-compat',
	'ractive',
	'RedmarinePartials',
	'LUXComponents',
	'RedmarineTransition',
	'RedmarineDecorator',
	'simulant',
	'underscoreString',
	'query',
	'ractive-events-keys',
	'RactiveF',
	'RactiveTouch',
	'loadMaskDecorator',
	'RactiveHelpers',
	'ConfigStrings',
	'singtelTooltipDecorator'
], function ($, _, Ractive, partials, LUXComponents, transitions, decorators, simulant, str, query,
             RactiveEventsKeys, RactiveF, RactiveTouch, loadMaskDecorator,
             RactiveHelpers, ConfigStrings) {

	// Define global events
	Ractive.events.space = RactiveEventsKeys.space;
	Ractive.events.enter = RactiveEventsKeys.enter;

	Ractive.defaults._subs = Ractive.defaults._subs ? Ractive.defaults._subs : [];
	//Ractive.DEBUG = false;

	/**
	 * Helper function to bind foundation and our plugins (using standard event name "jsContentLoaded").
	 */
	function bindExternalJavaScript(el) {

		// Bind foundation to new DOM.
		if (typeof $.fn.foundation !== 'undefined') {
			$(el).foundation();
		}

		// Generic trigger for our plugins etc, which use a standard event name.
		$(el).trigger('jsContentLoaded');
		// Need to trigger for dropdown update
		$(el).find('select').trigger('change', true);

	}

	// implementing components here for now, so all the widgets can share it
	// this should be moved to the separate components bundle

	var TabsArea = Ractive.extend({

		template: partials.TabsArea,

		components: {
			TabsLink: Ractive.extend({template: partials.TabsLink}),
			TabsPane: Ractive.extend({
				template: partials.TabsPane,
				oncomplete: function () {
					bindExternalJavaScript(this.el);
				},
				onchange: function () {
					_.defer(function (text) {
						bindExternalJavaScript(this.el);
					});

				}
			})
		},

		onrender: function () {

			this.on('TabsLink.clicked', function (event) {

				// Prevent '#' showing up on URLs for example.
				event.original.preventDefault();

				_(this.findAllComponents('TabsLink'))
					.map(function (pane) {
						pane.set(
							'active',
							_.isEqual(pane._guid, event.component._guid)
						);
					});

				var tabsPanePromises = [];

				_(this.findAllComponents('TabsPane'))
					.map(function (pane) {
						// @see http://docs.ractivejs.org/latest/ractive-set
						tabsPanePromises.push(pane.set(
							'active',
							_.isEqual(pane.get('id'), event.context.targetPaneId)
						));
					});

				// Wait for all tabs to finish rendering.
				$.when.apply($, tabsPanePromises).done(function () {
					bindExternalJavaScript(this.el);
				}.bind(this));

				return false;

			});

		}

	});

	var Modal = Ractive.extend({
		template: partials.Modal,

		onrender: function () {
			this.on('doCloseModal', function (event) {
				this.set('displayState', false);
			});
		}
	});

	// custom components
	_.assign(
		Ractive.components,
		LUXComponents,
		{
			TabsArea: TabsArea,
			Modal: Modal,
			rcontainer: Ractive.extend({template: partials.TabsPane}),
			rcheckbox: Ractive.extend({template: partials.rcheckbox})
		}
	);

	return Ractive.extend({

		// TODO What about calling

		// FIXME This breaks Zombie, but we need to understand exactly what's going on here.
		// @see directDebit_account_lvl_already_setup.json is what caused this initially.
		// debug: true,

		transitions: transitions,

		decorators: decorators,

		toggleContainer: function (event, targetId) {
			event.original.preventDefault();
			_(this.findAllComponents('rcontainer'))
					.filter(function (container) {
						return container.get('id') === targetId;
					})
					.pop()
					.toggle('active');
		},

		reloadPage: function (event) {
			event.original.preventDefault();
			window.location.reload();
		},


		toggleCheckbox: function (event) {
			event.original.preventDefault();
			event.component.toggle('checked');
			this.toggle(event.context.toggleKeypath);
		},

		/**
		 * Used when emulating radios using OSG html (label, span, etc).
		 *
		 * Optionally converts data-value="true|false" to boolean.
		 * These "Radios" can be "true|false" boolean strings, or else they can be any old string.
		 *
		 * @param event Ractive wrapped event.
		 * @param keypath String representing the keypath to change.
		 */
		toggleRadioButton: function (event, keypath) {

			event.original.preventDefault();

			// TODO Move to utility function?
			var newValue = event.node.dataset.value.trim();
			newValue = 'true' === newValue ? true : newValue;
			newValue = 'false' === newValue ? false : newValue;

			this.set(keypath, newValue);

		},

		setLoaderAndModalProperty: function (modalId, modalProperty, value) {
			this.setModalProperty(modalId, modalProperty, value);
			if (!value) {
				this.setModalProperty(modalId, 'displayState', value);
			}
		},

		findModal: function (modalId) {
			var modals = this.findAllComponents('ux-modal');
			var modal = modals.filter(function (component) {
				return modalId === component.get('modalId');
			});
			if (modal && modal.length > 1) {
				var visibleModal = _.find(modal, function (item) {
					return item.get('displayState');
				});
				return visibleModal ? visibleModal : modal[0];
			} else {
				return modal[0];
			}
		},

		toggleModal: function (modalId, state) {
			return this.setModalProperty(modalId, 'displayState', state);
		},
		getLob: function () {
			var worryFreeLobTopics = ConfigStrings.worryFreeLobTopics;
			var lob = null;
			_.each(worryFreeLobTopics, function (topic, key) {
				var sessionObject = sessionStorage.getItem(topic) && JSON.parse(sessionStorage.getItem(topic));
				if (sessionObject && !lob) {
					switch (key) {
						case 'DeviceIdAndPlanIdInContextTopic':
							var flowType = (sessionObject.flowType || sessionObject.planType) &&
							sessionObject.numberType ?
							(sessionObject.flowType || sessionObject.planType) + sessionObject.numberType :
							(sessionObject.flowType || sessionObject.planType) || sessionObject.numberType;
							lob = this.getLobValueForFlowType(flowType);
							break;
						case 'MiniCartInContextTopic':
							lob = this.getLobValueForFlowType(sessionObject.id);
							break;
						case 'OrderInContextTopicViewModel':
							var orderAction = _.find(sessionObject.orderActions, function (order) {
								return order.flowType;
							});
							if (orderAction) {
								orderAction = orderAction.flowType && orderAction.lob ?
								(orderAction.flowType + orderAction.lob) : orderAction.flowType || orderAction.lob;
								lob = this.getLobValueForFlowType(orderAction);
							}
							break;
					}
				}
			}.bind(this));
			return lob ? lob : 'MOB';
		},
		getLobValueForFlowType: function (flowType) {
			var lob = null;
			switch (flowType) {
				case 'FIBERFV':
					lob = 'FV';
					break;
				case 'FIBERBB':
					lob = 'BB';
					break;
				case 'FIBERLANDLINE':
				case 'FIBER':
					lob = 'FBB';
					break;
				case 'FVLANDLINE':
				case 'TV':
					lob = 'TV';
					break;
				case 'WIRELESS':
				case 'deviceFirst':
					lob = 'MOB';
					break;
				case 'MBBWIRELESS':
				case 'mBBPlanFirst':
					lob = 'MBB';
					break;
			}
			return lob;
		},

		setModalProperty: function (modalId, modalProperty, value) {
			var modal = this.findModal(modalId);
			if (modal) {
				modal.set(modalProperty, value);
			}
			return modal;
		},
		getModalProperty: function (modalId, modalProperty) {
			var modal = this.findModal(modalId);
			if (modal) {
				return modal.get(modalProperty);
			}
			return false;
		},

		redirectToErrorPage: function (errorTopic) {
			//Default redirection is Read error
			var url = RactiveHelpers.modifyConfigUrl(ConfigStrings.pageUrls.readErrorUrl);
			var params = {
				requestType: errorTopic.requestType,
				modelName: errorTopic.modelName,
				statusCode: errorTopic.errorObj.statusCode,
				errorCode: errorTopic.errorObj.errorCode,
				errorMessage: errorTopic.errorObj.errorMessage
			};
			if (errorTopic.requestType === 'update') {
				url = RactiveHelpers.modifyConfigUrl(ConfigStrings.pageUrls.updateErrorUrl);
			}
			if (url.indexOf('/') === 0) {
				url = RactiveHelpers.getFullHost() + url;
			}
			var queryString = $.param(params, true);
			url = url + '?' + queryString;
			window.location.href = url;
		},

		toggleKeypath: function (event, keypaths) {

			// FIXME foundation.forms.js needs further investigation because it's causing both radio buttons to be
			// visually marked as "checked". For now, we bypass the issue by stopping the event bubbling from reaching
			// foundation forms in the first place!

			event.original.preventDefault();

			_(keypaths.split(','))
				.map(function (keypath) {
					this.toggle(keypath);
				}, this);
		},

		scrollToWidgetTop: function (el, options) {
			// this is to make sure that it works when 2nd argument is only speed
			var speed = (typeof options === 'object' && options.speed) ? options.speed : 500;
			var scrollTop = $(el).offset().top;

			if (options && options.offset) {
				scrollTop -= options.offset;
			}

			$('html, body').animate({
				scrollTop: scrollTop
			}, speed);
		},

		onconfig: function () {

			this.on('toggleContainer', this.toggleContainer);
			this.on('*.toggleContainer', this.toggleContainer);

			this.on('reloadPage', this.reloadPage);
			this.on('*.reloadPage', this.reloadPage);

			this.on('toggleCheckbox', this.toggleCheckbox);
			this.on('*.toggleCheckbox', this.toggleCheckbox);

			this.on('doToggleKeypath', this.toggleKeypath);
			this.on('*.doToggleKeypath', this.toggleKeypath);

			this.on('doToggleRadioButton', this.toggleRadioButton);
			this.on('*.doToggleRadioButton', this.toggleRadioButton);
			this.observe('errorTopic.timestamp', function () {
				var errorTopic = this.get('errorTopic');
				if (errorTopic && errorTopic.modelName &&
					errorTopic.errorObj && errorTopic.errorObj.statusCode) {
					var errorActionHandlerMap = ConfigStrings.errorHandlerActionMap[this.get('id')];
					var isErrorPresent = _.find(errorActionHandlerMap, function (error) {
						return error === errorTopic.modelName;
					});
					var currentUrl = window.location.href;
					if (errorActionHandlerMap && isErrorPresent) {
						//turn on redirectio only in publisher mode.
						//Url contains /content/singtel/en only in author mode.
						if (currentUrl.indexOf('/content/singtel/en') === -1) {
							this.redirectToErrorPage(errorTopic);
						}
					} else if (errorTopic.errorObj.statusCode === 403) {
						if (currentUrl.indexOf('/content/singtel/en') === -1) {
							//Do this only in publisher mode.
							Ractive.defaults.fire('data_fencing_error');
						}
					} else {
						this.onErrorOccured(errorTopic);
					}
				} else if (errorTopic && errorTopic.errorObj && errorTopic.errorObj.statusCode === 0) {
					console.log('Abnormally terminated request ' + errorTopic.modelName);
					this.onAbnormalAbort(errorTopic);
					Ractive.defaults.fire('abnormal_abort_error', errorTopic);
				}
			}.bind(this));

		},
		onAbnormalAbort: function () {},
		onErrorOccured: function () {},

		oca: {

			/**
			 * Compact object by removing falsey properties. Important for filtering.
			 * @param object POJO.
			 * @return {Object} Compacted object.
			 */
			compactObject: function (object) {
				_.each(object, function (v, k) {
					if (!v) {
						delete object[k];
					}
				});
				return object;
			},

			bindExternalJavaScript: function (el) {
				bindExternalJavaScript(el);
			},

			// Hack for now to get parent. Waiting merge of change for ractive to suppport this
			// https://github.com/ractivejs/ractive/pull/1580
			keyPathGetParent: function (keypath) {
				return keypath.split('.').slice(0, -1).join('.');
			},

			sync: function (params) {

				var self = this;

				var dfr = $.Deferred();

				params.widget.set('inProgress', true);

				var fallBackType = (params.data) ? 'POST' : 'GET';

				var options = _.assign({
					data : (params.data) ? params.data : null,
					type : (params.type) ? params.type : fallBackType
				}, params);


				var handleSuccess = function (response) {

					var dfr = this.dfr,
						widget = this.widget,
						helpers = this.helpers;

					var pool = [
						widget.reset(response),
						widget.set('inProgress', false),
						widget.set('helpers', helpers)
					];

					$.when.apply($, pool).done(function () {
						dfr.resolve(response);
					}).fail(function () {
						dfr.reject(response);
					});

				};

				var handleFailure = function (res) {

					var dfr = this.dfr,
						widget = this.widget,
						helpers = this.helpers,
						parseJSON = this.parseJSON;

					var resData = res;

					if (resData.responseText) {
						resData = parseJSON(resData.responseText);
					}

					if (this.persistData) {
						resData = _.merge(this.widget.get(), resData);
					}

					if (widget && widget.validation) {
						var errors = widget.validation.findValidationErrorsInResponse(resData).value();
						if (errors) {
							dfr.reject(errors);
						}
					}

					var dataModelUpdatePromise = (resData.viewName) ?
						widget.reset(resData) : widget.set(resData);

					var pool = [
						dataModelUpdatePromise,
						widget.set('inProgress', false),
						widget.set('helpers', helpers)
					];

					$.when.apply($, pool).then(function () {
						// We reject promise here deliberately
						// as we are inside fail callback already
						// so consumers down the pipe can use fail callback
						// Better idea ?
						dfr.reject(resData);
					});

				};

				var context = {
					dfr : dfr,
					widget : params.widget,
					helpers: params.widget.get('helpers'),
					parseJSON : self.parseJSON,
					persistData: params.persistData
				};

				var boundHandleSuccess = _.bind(handleSuccess, context);
				var boundHandleFailure = _.bind(handleFailure, context);

				return this.query(params.url, options)
					.done(boundHandleSuccess)
					.fail(boundHandleFailure);

			},

			/**
			 * @deprecated Please require and use query directly from your widgets, rather than oca.query.
			 */
			query: function (url, params) {
				console.log('oca.query is deprecated, please use query module directly.');
				return query(url, params);
			},

			parseJSON: function (jsonString) {
				try {
					// http://stackoverflow.com/a/20392392
					var o = JSON.parse(jsonString);
					if (o && typeof o === 'object' && o !== null) {
						return o;
					}
				}
				catch (e) {
					console.error(e, jsonString);
					throw new Error('Failed to parse JSON');
				}
				return false;
			},

			/**
			 * Ractive re-write of the once jQuery plugin.
			 * Clicks elements on a page based on the hash passed to the page.
			 * @param widget Ractive instance
			 * @param options Plugin options
			 */
			clickByHashValue: function (widget, options) {

				var self = this;

				options = _.extend({
					selector: '[data-filter-name]',
					specValueKey: 'data-filter-target-spec-value',
					hash: window.location.hash,
					bSplitHash: true
				}, options || {});

				// Trim the initial String.
				var hash = str.trim(options.hash);

				// Don't bother with executing if no hash.
				if (hash.length === 0) {
					return;
				}

				var hashValues = options.bSplitHash ? hash.substr(1).split('-') : hash.substr(1).split();

				hashValues = _.map(hashValues, function (value) {
					return value.toLowerCase();
				});

				var elements = widget.findAll(options.selector);

				if (elements.length) {
					self.clickByAttribute(elements, options.specValueKey, hashValues);

					// Lets check if any new elements have been rendered after the first round of clicks.
					// If so reapply the hash clicks.
					_.defer(function (self, widget, elements) {
						var newElements = widget.findAll(options.selector);
						if (newElements.length > elements.length) {
							self.clickByAttribute(newElements, options.specValueKey, hashValues);
						}
					}, self, widget, elements);
				}

			},

			clickByAttribute: function (elements, attribute, attributeList) {
				if (!elements.length) {
					return;
				}

				_.each(elements, function (element) {
					var attr = element.getAttribute(attribute).toLowerCase();
					if (_.indexOf(attributeList, attr) !== -1) {
						// Wait til stack has cleared to execute event.
						// If this is called on render, this will allow ractive
						// to pick up the event
						_.defer(function (element) {
							// Fire a click event on the node.
							simulant.fire(element, 'click');
						}, element);
					}
				});
			}
		}
	});

});

define('dispatcher',['lodash-compat'],
	function (_) {


		/**
		*
		*	DISPATCHER
		*	==========
		*
		*	To dispatch an action from a widget, you can
		*	- Use javascript: widget.ractive.fire('dispatch.action', someData);
		*	- Use templating: <a on-click='dispatch.someAction:someData'></a>
		*
		*	To bind an action to a widget method,
		* 	simply add a 'dispatch table' with strings to local methods at the root level of your widget
		*	widget.actions = ['localMethod1', '...']
		*
		**/

		function Dispatcher() {

			var self = this;

			this.reset = function () {
				// Maintain a list of registered widget instances
				this.widgets = {};
				// Maintain a list of all actions..
				this.actions = {};
				// Maintain a history of dispatched actions
				this.dispatchedActions = [];
			};

			// Init using reset.
			self.reset();

			// Register widget methods against action
			this.bindWidget = function (widget) {

				var widgetInstance = widget.instance;
				// Create unique id for each widget.
				var widgetName = [widget.name, widgetInstance.ractive._guid].join('-');
				this.widgets[widgetName] = widgetInstance;

				if (widgetInstance.actions) {
					_.forEach(widgetInstance.actions, function (methods, actionName) {

						if (!this.actions[actionName]) {
							this.actions[actionName] = {};
						}
						this.actions[actionName][widgetName] = methods;

					}, this);
				}

				// Bind Ractive Event proxy
				if (widgetInstance.ractive) {
					widgetInstance.ractive.on('dispatch.*', function () {

						// Handle arguments differenctly (thanks to Ractive event firing non-consistency..)
						var data = arguments.length === 1 ? arguments[0] : arguments[1];

						// Split our event name so that we can extract its action name
						var eventNameArray = this.event.name.split('.');

						// The action follows the dispatch keyword
						var actionName = eventNameArray[eventNameArray.indexOf('dispatch') + 1];

						// Dispatch
						self.dispatch(actionName, data);

					});

					if (widgetInstance.replayDispatchedActions) {
						self.doReplayDispatchedActions (widgetInstance, widgetName);
					}

				}

			};

			// Call relevant methods on a widget instance, passing data.
			this.callWidgetMethods = function (widgetInstance, methods, data) {
				_.forEach (methods, function (method) {
					widgetInstance[method](data);
				});
			};

			// Dispatch an action to the registered widget' methods
			this.dispatch = function (actionName, data) {
				// Loop through widgets bound to this action, execute their methods.
				_.forEach (this.actions[actionName], function (methods, widgetName) {
					this.callWidgetMethods(this.widgets[widgetName], methods, data);
				}, this);

				// Push to an array used for testing and logging actions
				this.dispatchedActions.push(
					{
						'actionName': actionName,
						'data': data
					}

				);

				return this.dispatchedActions;

			};

			// replay dispatched actions for the registered widget' methods
			this.doReplayDispatchedActions = function (widgetInstance, widgetName) {
				_.forEach (this.dispatchedActions, function (action) {
					var methods = this.actions[action.actionName] ? this.actions[action.actionName][widgetName] : [];
					this.callWidgetMethods (widgetInstance, methods, action.data);
				}, this);
			};

		}

		return new Dispatcher();

	});

// vim:ts=4:sts=4:sw=4:
/*!
 *
 * Copyright 2009-2012 Kris Kowal under the terms of the MIT
 * license found at http://github.com/kriskowal/q/raw/master/LICENSE
 *
 * With parts by Tyler Close
 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
 * at http://www.opensource.org/licenses/mit-license.html
 * Forked at ref_send.js version: 2009-05-11
 *
 * With parts by Mark Miller
 * Copyright (C) 2011 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

(function (definition) {
    "use strict";

    // This file will function properly as a <script> tag, or a module
    // using CommonJS and NodeJS or RequireJS module formats.  In
    // Common/Node/RequireJS, the module exports the Q API and when
    // executed as a simple <script>, it creates a Q global instead.

    // Montage Require
    if (typeof bootstrap === "function") {
        bootstrap("promise", definition);

    // CommonJS
    } else if (typeof exports === "object" && typeof module === "object") {
        module.exports = definition();

    // RequireJS
    } else if (typeof define === "function" && define.amd) {
        define('q',definition);

    // SES (Secure EcmaScript)
    } else if (typeof ses !== "undefined") {
        if (!ses.ok()) {
            return;
        } else {
            ses.makeQ = definition;
        }

    // <script>
    } else if (typeof self !== "undefined") {
        self.Q = definition();

    } else {
        throw new Error("This environment was not anticiapted by Q. Please file a bug.");
    }

})(function () {
"use strict";

var hasStacks = false;
try {
    throw new Error();
} catch (e) {
    hasStacks = !!e.stack;
}

// All code after this point will be filtered from stack traces reported
// by Q.
var qStartingLine = captureLine();
var qFileName;

// shims

// used for fallback in "allResolved"
var noop = function () {};

// Use the fastest possible means to execute a task in a future turn
// of the event loop.
var nextTick =(function () {
    // linked list of tasks (single, with head node)
    var head = {task: void 0, next: null};
    var tail = head;
    var flushing = false;
    var requestTick = void 0;
    var isNodeJS = false;

    function flush() {
        /* jshint loopfunc: true */

        while (head.next) {
            head = head.next;
            var task = head.task;
            head.task = void 0;
            var domain = head.domain;

            if (domain) {
                head.domain = void 0;
                domain.enter();
            }

            try {
                task();

            } catch (e) {
                if (isNodeJS) {
                    // In node, uncaught exceptions are considered fatal errors.
                    // Re-throw them synchronously to interrupt flushing!

                    // Ensure continuation if the uncaught exception is suppressed
                    // listening "uncaughtException" events (as domains does).
                    // Continue in next event to avoid tick recursion.
                    if (domain) {
                        domain.exit();
                    }
                    setTimeout(flush, 0);
                    if (domain) {
                        domain.enter();
                    }

                    throw e;

                } else {
                    // In browsers, uncaught exceptions are not fatal.
                    // Re-throw them asynchronously to avoid slow-downs.
                    setTimeout(function() {
                       throw e;
                    }, 0);
                }
            }

            if (domain) {
                domain.exit();
            }
        }

        flushing = false;
    }

    nextTick = function (task) {
        tail = tail.next = {
            task: task,
            domain: isNodeJS && process.domain,
            next: null
        };

        if (!flushing) {
            flushing = true;
            requestTick();
        }
    };

    if (typeof process !== "undefined" && process.nextTick) {
        // Node.js before 0.9. Note that some fake-Node environments, like the
        // Mocha test runner, introduce a `process` global without a `nextTick`.
        isNodeJS = true;

        requestTick = function () {
            process.nextTick(flush);
        };

    } else if (typeof setImmediate === "function") {
        // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
        if (typeof window !== "undefined") {
            requestTick = setImmediate.bind(window, flush);
        } else {
            requestTick = function () {
                setImmediate(flush);
            };
        }

    } else if (typeof MessageChannel !== "undefined") {
        // modern browsers
        // http://www.nonblocking.io/2011/06/windownexttick.html
        var channel = new MessageChannel();
        // At least Safari Version 6.0.5 (8536.30.1) intermittently cannot create
        // working message ports the first time a page loads.
        channel.port1.onmessage = function () {
            requestTick = requestPortTick;
            channel.port1.onmessage = flush;
            flush();
        };
        var requestPortTick = function () {
            // Opera requires us to provide a message payload, regardless of
            // whether we use it.
            channel.port2.postMessage(0);
        };
        requestTick = function () {
            setTimeout(flush, 0);
            requestPortTick();
        };

    } else {
        // old browsers
        requestTick = function () {
            setTimeout(flush, 0);
        };
    }

    return nextTick;
})();

// Attempt to make generics safe in the face of downstream
// modifications.
// There is no situation where this is necessary.
// If you need a security guarantee, these primordials need to be
// deeply frozen anyway, and if you don’t need a security guarantee,
// this is just plain paranoid.
// However, this **might** have the nice side-effect of reducing the size of
// the minified code by reducing x.call() to merely x()
// See Mark Miller’s explanation of what this does.
// http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
var call = Function.call;
function uncurryThis(f) {
    return function () {
        return call.apply(f, arguments);
    };
}
// This is equivalent, but slower:
// uncurryThis = Function_bind.bind(Function_bind.call);
// http://jsperf.com/uncurrythis

var array_slice = uncurryThis(Array.prototype.slice);

var array_reduce = uncurryThis(
    Array.prototype.reduce || function (callback, basis) {
        var index = 0,
            length = this.length;
        // concerning the initial value, if one is not provided
        if (arguments.length === 1) {
            // seek to the first value in the array, accounting
            // for the possibility that is is a sparse array
            do {
                if (index in this) {
                    basis = this[index++];
                    break;
                }
                if (++index >= length) {
                    throw new TypeError();
                }
            } while (1);
        }
        // reduce
        for (; index < length; index++) {
            // account for the possibility that the array is sparse
            if (index in this) {
                basis = callback(basis, this[index], index);
            }
        }
        return basis;
    }
);

var array_indexOf = uncurryThis(
    Array.prototype.indexOf || function (value) {
        // not a very good shim, but good enough for our one use of it
        for (var i = 0; i < this.length; i++) {
            if (this[i] === value) {
                return i;
            }
        }
        return -1;
    }
);

var array_map = uncurryThis(
    Array.prototype.map || function (callback, thisp) {
        var self = this;
        var collect = [];
        array_reduce(self, function (undefined, value, index) {
            collect.push(callback.call(thisp, value, index, self));
        }, void 0);
        return collect;
    }
);

var object_create = Object.create || function (prototype) {
    function Type() { }
    Type.prototype = prototype;
    return new Type();
};

var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);

var object_keys = Object.keys || function (object) {
    var keys = [];
    for (var key in object) {
        if (object_hasOwnProperty(object, key)) {
            keys.push(key);
        }
    }
    return keys;
};

var object_toString = uncurryThis(Object.prototype.toString);

function isObject(value) {
    return value === Object(value);
}

// generator related shims

// FIXME: Remove this function once ES6 generators are in SpiderMonkey.
function isStopIteration(exception) {
    return (
        object_toString(exception) === "[object StopIteration]" ||
        exception instanceof QReturnValue
    );
}

// FIXME: Remove this helper and Q.return once ES6 generators are in
// SpiderMonkey.
var QReturnValue;
if (typeof ReturnValue !== "undefined") {
    QReturnValue = ReturnValue;
} else {
    QReturnValue = function (value) {
        this.value = value;
    };
}

// long stack traces

var STACK_JUMP_SEPARATOR = "From previous event:";

function makeStackTraceLong(error, promise) {
    // If possible, transform the error stack trace by removing Node and Q
    // cruft, then concatenating with the stack trace of `promise`. See #57.
    if (hasStacks &&
        promise.stack &&
        typeof error === "object" &&
        error !== null &&
        error.stack &&
        error.stack.indexOf(STACK_JUMP_SEPARATOR) === -1
    ) {
        var stacks = [];
        for (var p = promise; !!p; p = p.source) {
            if (p.stack) {
                stacks.unshift(p.stack);
            }
        }
        stacks.unshift(error.stack);

        var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
        error.stack = filterStackString(concatedStacks);
    }
}

function filterStackString(stackString) {
    var lines = stackString.split("\n");
    var desiredLines = [];
    for (var i = 0; i < lines.length; ++i) {
        var line = lines[i];

        if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
            desiredLines.push(line);
        }
    }
    return desiredLines.join("\n");
}

function isNodeFrame(stackLine) {
    return stackLine.indexOf("(module.js:") !== -1 ||
           stackLine.indexOf("(node.js:") !== -1;
}

function getFileNameAndLineNumber(stackLine) {
    // Named functions: "at functionName (filename:lineNumber:columnNumber)"
    // In IE10 function name can have spaces ("Anonymous function") O_o
    var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
    if (attempt1) {
        return [attempt1[1], Number(attempt1[2])];
    }

    // Anonymous functions: "at filename:lineNumber:columnNumber"
    var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
    if (attempt2) {
        return [attempt2[1], Number(attempt2[2])];
    }

    // Firefox style: "function@filename:lineNumber or @filename:lineNumber"
    var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
    if (attempt3) {
        return [attempt3[1], Number(attempt3[2])];
    }
}

function isInternalFrame(stackLine) {
    var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);

    if (!fileNameAndLineNumber) {
        return false;
    }

    var fileName = fileNameAndLineNumber[0];
    var lineNumber = fileNameAndLineNumber[1];

    return fileName === qFileName &&
        lineNumber >= qStartingLine &&
        lineNumber <= qEndingLine;
}

// discover own file name and line number range for filtering stack
// traces
function captureLine() {
    if (!hasStacks) {
        return;
    }

    try {
        throw new Error();
    } catch (e) {
        var lines = e.stack.split("\n");
        var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
        var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
        if (!fileNameAndLineNumber) {
            return;
        }

        qFileName = fileNameAndLineNumber[0];
        return fileNameAndLineNumber[1];
    }
}

function deprecate(callback, name, alternative) {
    return function () {
        if (typeof console !== "undefined" &&
            typeof console.warn === "function") {
            console.warn(name + " is deprecated, use " + alternative +
                         " instead.", new Error("").stack);
        }
        return callback.apply(callback, arguments);
    };
}

// end of shims
// beginning of real work

/**
 * Constructs a promise for an immediate reference, passes promises through, or
 * coerces promises from different systems.
 * @param value immediate reference or promise
 */
function Q(value) {
    // If the object is already a Promise, return it directly.  This enables
    // the resolve function to both be used to created references from objects,
    // but to tolerably coerce non-promises to promises.
    if (value instanceof Promise) {
        return value;
    }

    // assimilate thenables
    if (isPromiseAlike(value)) {
        return coerce(value);
    } else {
        return fulfill(value);
    }
}
Q.resolve = Q;

/**
 * Performs a task in a future turn of the event loop.
 * @param {Function} task
 */
Q.nextTick = nextTick;

/**
 * Controls whether or not long stack traces will be on
 */
Q.longStackSupport = false;

// enable long stacks if Q_DEBUG is set
if (typeof process === "object" && process && process.env && process.env.Q_DEBUG) {
    Q.longStackSupport = true;
}

/**
 * Constructs a {promise, resolve, reject} object.
 *
 * `resolve` is a callback to invoke with a more resolved value for the
 * promise. To fulfill the promise, invoke `resolve` with any value that is
 * not a thenable. To reject the promise, invoke `resolve` with a rejected
 * thenable, or invoke `reject` with the reason directly. To resolve the
 * promise to another thenable, thus putting it in the same state, invoke
 * `resolve` with that other thenable.
 */
Q.defer = defer;
function defer() {
    // if "messages" is an "Array", that indicates that the promise has not yet
    // been resolved.  If it is "undefined", it has been resolved.  Each
    // element of the messages array is itself an array of complete arguments to
    // forward to the resolved promise.  We coerce the resolution value to a
    // promise using the `resolve` function because it handles both fully
    // non-thenable values and other thenables gracefully.
    var messages = [], progressListeners = [], resolvedPromise;

    var deferred = object_create(defer.prototype);
    var promise = object_create(Promise.prototype);

    promise.promiseDispatch = function (resolve, op, operands) {
        var args = array_slice(arguments);
        if (messages) {
            messages.push(args);
            if (op === "when" && operands[1]) { // progress operand
                progressListeners.push(operands[1]);
            }
        } else {
            Q.nextTick(function () {
                resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
            });
        }
    };

    // XXX deprecated
    promise.valueOf = function () {
        if (messages) {
            return promise;
        }
        var nearerValue = nearer(resolvedPromise);
        if (isPromise(nearerValue)) {
            resolvedPromise = nearerValue; // shorten chain
        }
        return nearerValue;
    };

    promise.inspect = function () {
        if (!resolvedPromise) {
            return { state: "pending" };
        }
        return resolvedPromise.inspect();
    };

    if (Q.longStackSupport && hasStacks) {
        try {
            throw new Error();
        } catch (e) {
            // NOTE: don't try to use `Error.captureStackTrace` or transfer the
            // accessor around; that causes memory leaks as per GH-111. Just
            // reify the stack trace as a string ASAP.
            //
            // At the same time, cut off the first line; it's always just
            // "[object Promise]\n", as per the `toString`.
            promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
        }
    }

    // NOTE: we do the checks for `resolvedPromise` in each method, instead of
    // consolidating them into `become`, since otherwise we'd create new
    // promises with the lines `become(whatever(value))`. See e.g. GH-252.

    function become(newPromise) {
        resolvedPromise = newPromise;
        promise.source = newPromise;

        array_reduce(messages, function (undefined, message) {
            Q.nextTick(function () {
                newPromise.promiseDispatch.apply(newPromise, message);
            });
        }, void 0);

        messages = void 0;
        progressListeners = void 0;
    }

    deferred.promise = promise;
    deferred.resolve = function (value) {
        if (resolvedPromise) {
            return;
        }

        become(Q(value));
    };

    deferred.fulfill = function (value) {
        if (resolvedPromise) {
            return;
        }

        become(fulfill(value));
    };
    deferred.reject = function (reason) {
        if (resolvedPromise) {
            return;
        }

        become(reject(reason));
    };
    deferred.notify = function (progress) {
        if (resolvedPromise) {
            return;
        }

        array_reduce(progressListeners, function (undefined, progressListener) {
            Q.nextTick(function () {
                progressListener(progress);
            });
        }, void 0);
    };

    return deferred;
}

/**
 * Creates a Node-style callback that will resolve or reject the deferred
 * promise.
 * @returns a nodeback
 */
defer.prototype.makeNodeResolver = function () {
    var self = this;
    return function (error, value) {
        if (error) {
            self.reject(error);
        } else if (arguments.length > 2) {
            self.resolve(array_slice(arguments, 1));
        } else {
            self.resolve(value);
        }
    };
};

/**
 * @param resolver {Function} a function that returns nothing and accepts
 * the resolve, reject, and notify functions for a deferred.
 * @returns a promise that may be resolved with the given resolve and reject
 * functions, or rejected by a thrown exception in resolver
 */
Q.Promise = promise; // ES6
Q.promise = promise;
function promise(resolver) {
    if (typeof resolver !== "function") {
        throw new TypeError("resolver must be a function.");
    }
    var deferred = defer();
    try {
        resolver(deferred.resolve, deferred.reject, deferred.notify);
    } catch (reason) {
        deferred.reject(reason);
    }
    return deferred.promise;
}

promise.race = race; // ES6
promise.all = all; // ES6
promise.reject = reject; // ES6
promise.resolve = Q; // ES6

// XXX experimental.  This method is a way to denote that a local value is
// serializable and should be immediately dispatched to a remote upon request,
// instead of passing a reference.
Q.passByCopy = function (object) {
    //freeze(object);
    //passByCopies.set(object, true);
    return object;
};

Promise.prototype.passByCopy = function () {
    //freeze(object);
    //passByCopies.set(object, true);
    return this;
};

/**
 * If two promises eventually fulfill to the same value, promises that value,
 * but otherwise rejects.
 * @param x {Any*}
 * @param y {Any*}
 * @returns {Any*} a promise for x and y if they are the same, but a rejection
 * otherwise.
 *
 */
Q.join = function (x, y) {
    return Q(x).join(y);
};

Promise.prototype.join = function (that) {
    return Q([this, that]).spread(function (x, y) {
        if (x === y) {
            // TODO: "===" should be Object.is or equiv
            return x;
        } else {
            throw new Error("Can't join: not the same: " + x + " " + y);
        }
    });
};

/**
 * Returns a promise for the first of an array of promises to become settled.
 * @param answers {Array[Any*]} promises to race
 * @returns {Any*} the first promise to be settled
 */
Q.race = race;
function race(answerPs) {
    return promise(function(resolve, reject) {
        // Switch to this once we can assume at least ES5
        // answerPs.forEach(function(answerP) {
        //     Q(answerP).then(resolve, reject);
        // });
        // Use this in the meantime
        for (var i = 0, len = answerPs.length; i < len; i++) {
            Q(answerPs[i]).then(resolve, reject);
        }
    });
}

Promise.prototype.race = function () {
    return this.then(Q.race);
};

/**
 * Constructs a Promise with a promise descriptor object and optional fallback
 * function.  The descriptor contains methods like when(rejected), get(name),
 * set(name, value), post(name, args), and delete(name), which all
 * return either a value, a promise for a value, or a rejection.  The fallback
 * accepts the operation name, a resolver, and any further arguments that would
 * have been forwarded to the appropriate method above had a method been
 * provided with the proper name.  The API makes no guarantees about the nature
 * of the returned object, apart from that it is usable whereever promises are
 * bought and sold.
 */
Q.makePromise = Promise;
function Promise(descriptor, fallback, inspect) {
    if (fallback === void 0) {
        fallback = function (op) {
            return reject(new Error(
                "Promise does not support operation: " + op
            ));
        };
    }
    if (inspect === void 0) {
        inspect = function () {
            return {state: "unknown"};
        };
    }

    var promise = object_create(Promise.prototype);

    promise.promiseDispatch = function (resolve, op, args) {
        var result;
        try {
            if (descriptor[op]) {
                result = descriptor[op].apply(promise, args);
            } else {
                result = fallback.call(promise, op, args);
            }
        } catch (exception) {
            result = reject(exception);
        }
        if (resolve) {
            resolve(result);
        }
    };

    promise.inspect = inspect;

    // XXX deprecated `valueOf` and `exception` support
    if (inspect) {
        var inspected = inspect();
        if (inspected.state === "rejected") {
            promise.exception = inspected.reason;
        }

        promise.valueOf = function () {
            var inspected = inspect();
            if (inspected.state === "pending" ||
                inspected.state === "rejected") {
                return promise;
            }
            return inspected.value;
        };
    }

    return promise;
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.then = function (fulfilled, rejected, progressed) {
    var self = this;
    var deferred = defer();
    var done = false;   // ensure the untrusted promise makes at most a
                        // single call to one of the callbacks

    function _fulfilled(value) {
        try {
            return typeof fulfilled === "function" ? fulfilled(value) : value;
        } catch (exception) {
            return reject(exception);
        }
    }

    function _rejected(exception) {
        if (typeof rejected === "function") {
            makeStackTraceLong(exception, self);
            try {
                return rejected(exception);
            } catch (newException) {
                return reject(newException);
            }
        }
        return reject(exception);
    }

    function _progressed(value) {
        return typeof progressed === "function" ? progressed(value) : value;
    }

    Q.nextTick(function () {
        self.promiseDispatch(function (value) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_fulfilled(value));
        }, "when", [function (exception) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_rejected(exception));
        }]);
    });

    // Progress propagator need to be attached in the current tick.
    self.promiseDispatch(void 0, "when", [void 0, function (value) {
        var newValue;
        var threw = false;
        try {
            newValue = _progressed(value);
        } catch (e) {
            threw = true;
            if (Q.onerror) {
                Q.onerror(e);
            } else {
                throw e;
            }
        }

        if (!threw) {
            deferred.notify(newValue);
        }
    }]);

    return deferred.promise;
};

Q.tap = function (promise, callback) {
    return Q(promise).tap(callback);
};

/**
 * Works almost like "finally", but not called for rejections.
 * Original resolution value is passed through callback unaffected.
 * Callback may return a promise that will be awaited for.
 * @param {Function} callback
 * @returns {Q.Promise}
 * @example
 * doSomething()
 *   .then(...)
 *   .tap(console.log)
 *   .then(...);
 */
Promise.prototype.tap = function (callback) {
    callback = Q(callback);

    return this.then(function (value) {
        return callback.fcall(value).thenResolve(value);
    });
};

/**
 * Registers an observer on a promise.
 *
 * Guarantees:
 *
 * 1. that fulfilled and rejected will be called only once.
 * 2. that either the fulfilled callback or the rejected callback will be
 *    called, but not both.
 * 3. that fulfilled and rejected will not be called in this turn.
 *
 * @param value      promise or immediate reference to observe
 * @param fulfilled  function to be called with the fulfilled value
 * @param rejected   function to be called with the rejection exception
 * @param progressed function to be called on any progress notifications
 * @return promise for the return value from the invoked callback
 */
Q.when = when;
function when(value, fulfilled, rejected, progressed) {
    return Q(value).then(fulfilled, rejected, progressed);
}

Promise.prototype.thenResolve = function (value) {
    return this.then(function () { return value; });
};

Q.thenResolve = function (promise, value) {
    return Q(promise).thenResolve(value);
};

Promise.prototype.thenReject = function (reason) {
    return this.then(function () { throw reason; });
};

Q.thenReject = function (promise, reason) {
    return Q(promise).thenReject(reason);
};

/**
 * If an object is not a promise, it is as "near" as possible.
 * If a promise is rejected, it is as "near" as possible too.
 * If it’s a fulfilled promise, the fulfillment value is nearer.
 * If it’s a deferred promise and the deferred has been resolved, the
 * resolution is "nearer".
 * @param object
 * @returns most resolved (nearest) form of the object
 */

// XXX should we re-do this?
Q.nearer = nearer;
function nearer(value) {
    if (isPromise(value)) {
        var inspected = value.inspect();
        if (inspected.state === "fulfilled") {
            return inspected.value;
        }
    }
    return value;
}

/**
 * @returns whether the given object is a promise.
 * Otherwise it is a fulfilled value.
 */
Q.isPromise = isPromise;
function isPromise(object) {
    return object instanceof Promise;
}

Q.isPromiseAlike = isPromiseAlike;
function isPromiseAlike(object) {
    return isObject(object) && typeof object.then === "function";
}

/**
 * @returns whether the given object is a pending promise, meaning not
 * fulfilled or rejected.
 */
Q.isPending = isPending;
function isPending(object) {
    return isPromise(object) && object.inspect().state === "pending";
}

Promise.prototype.isPending = function () {
    return this.inspect().state === "pending";
};

/**
 * @returns whether the given object is a value or fulfilled
 * promise.
 */
Q.isFulfilled = isFulfilled;
function isFulfilled(object) {
    return !isPromise(object) || object.inspect().state === "fulfilled";
}

Promise.prototype.isFulfilled = function () {
    return this.inspect().state === "fulfilled";
};

/**
 * @returns whether the given object is a rejected promise.
 */
Q.isRejected = isRejected;
function isRejected(object) {
    return isPromise(object) && object.inspect().state === "rejected";
}

Promise.prototype.isRejected = function () {
    return this.inspect().state === "rejected";
};

//// BEGIN UNHANDLED REJECTION TRACKING

// This promise library consumes exceptions thrown in handlers so they can be
// handled by a subsequent promise.  The exceptions get added to this array when
// they are created, and removed when they are handled.  Note that in ES6 or
// shimmed environments, this would naturally be a `Set`.
var unhandledReasons = [];
var unhandledRejections = [];
var trackUnhandledRejections = true;

function resetUnhandledRejections() {
    unhandledReasons.length = 0;
    unhandledRejections.length = 0;

    if (!trackUnhandledRejections) {
        trackUnhandledRejections = true;
    }
}

function trackRejection(promise, reason) {
    if (!trackUnhandledRejections) {
        return;
    }

    unhandledRejections.push(promise);
    if (reason && typeof reason.stack !== "undefined") {
        unhandledReasons.push(reason.stack);
    } else {
        unhandledReasons.push("(no stack) " + reason);
    }
}

function untrackRejection(promise) {
    if (!trackUnhandledRejections) {
        return;
    }

    var at = array_indexOf(unhandledRejections, promise);
    if (at !== -1) {
        unhandledRejections.splice(at, 1);
        unhandledReasons.splice(at, 1);
    }
}

Q.resetUnhandledRejections = resetUnhandledRejections;

Q.getUnhandledReasons = function () {
    // Make a copy so that consumers can't interfere with our internal state.
    return unhandledReasons.slice();
};

Q.stopUnhandledRejectionTracking = function () {
    resetUnhandledRejections();
    trackUnhandledRejections = false;
};

resetUnhandledRejections();

//// END UNHANDLED REJECTION TRACKING

/**
 * Constructs a rejected promise.
 * @param reason value describing the failure
 */
Q.reject = reject;
function reject(reason) {
    var rejection = Promise({
        "when": function (rejected) {
            // note that the error has been handled
            if (rejected) {
                untrackRejection(this);
            }
            return rejected ? rejected(reason) : this;
        }
    }, function fallback() {
        return this;
    }, function inspect() {
        return { state: "rejected", reason: reason };
    });

    // Note that the reason has not been handled.
    trackRejection(rejection, reason);

    return rejection;
}

/**
 * Constructs a fulfilled promise for an immediate reference.
 * @param value immediate reference
 */
Q.fulfill = fulfill;
function fulfill(value) {
    return Promise({
        "when": function () {
            return value;
        },
        "get": function (name) {
            return value[name];
        },
        "set": function (name, rhs) {
            value[name] = rhs;
        },
        "delete": function (name) {
            delete value[name];
        },
        "post": function (name, args) {
            // Mark Miller proposes that post with no name should apply a
            // promised function.
            if (name === null || name === void 0) {
                return value.apply(void 0, args);
            } else {
                return value[name].apply(value, args);
            }
        },
        "apply": function (thisp, args) {
            return value.apply(thisp, args);
        },
        "keys": function () {
            return object_keys(value);
        }
    }, void 0, function inspect() {
        return { state: "fulfilled", value: value };
    });
}

/**
 * Converts thenables to Q promises.
 * @param promise thenable promise
 * @returns a Q promise
 */
function coerce(promise) {
    var deferred = defer();
    Q.nextTick(function () {
        try {
            promise.then(deferred.resolve, deferred.reject, deferred.notify);
        } catch (exception) {
            deferred.reject(exception);
        }
    });
    return deferred.promise;
}

/**
 * Annotates an object such that it will never be
 * transferred away from this process over any promise
 * communication channel.
 * @param object
 * @returns promise a wrapping of that object that
 * additionally responds to the "isDef" message
 * without a rejection.
 */
Q.master = master;
function master(object) {
    return Promise({
        "isDef": function () {}
    }, function fallback(op, args) {
        return dispatch(object, op, args);
    }, function () {
        return Q(object).inspect();
    });
}

/**
 * Spreads the values of a promised array of arguments into the
 * fulfillment callback.
 * @param fulfilled callback that receives variadic arguments from the
 * promised array
 * @param rejected callback that receives the exception if the promise
 * is rejected.
 * @returns a promise for the return value or thrown exception of
 * either callback.
 */
Q.spread = spread;
function spread(value, fulfilled, rejected) {
    return Q(value).spread(fulfilled, rejected);
}

Promise.prototype.spread = function (fulfilled, rejected) {
    return this.all().then(function (array) {
        return fulfilled.apply(void 0, array);
    }, rejected);
};

/**
 * The async function is a decorator for generator functions, turning
 * them into asynchronous generators.  Although generators are only part
 * of the newest ECMAScript 6 drafts, this code does not cause syntax
 * errors in older engines.  This code should continue to work and will
 * in fact improve over time as the language improves.
 *
 * ES6 generators are currently part of V8 version 3.19 with the
 * --harmony-generators runtime flag enabled.  SpiderMonkey has had them
 * for longer, but under an older Python-inspired form.  This function
 * works on both kinds of generators.
 *
 * Decorates a generator function such that:
 *  - it may yield promises
 *  - execution will continue when that promise is fulfilled
 *  - the value of the yield expression will be the fulfilled value
 *  - it returns a promise for the return value (when the generator
 *    stops iterating)
 *  - the decorated function returns a promise for the return value
 *    of the generator or the first rejected promise among those
 *    yielded.
 *  - if an error is thrown in the generator, it propagates through
 *    every following yield until it is caught, or until it escapes
 *    the generator function altogether, and is translated into a
 *    rejection for the promise returned by the decorated generator.
 */
Q.async = async;
function async(makeGenerator) {
    return function () {
        // when verb is "send", arg is a value
        // when verb is "throw", arg is an exception
        function continuer(verb, arg) {
            var result;

            // Until V8 3.19 / Chromium 29 is released, SpiderMonkey is the only
            // engine that has a deployed base of browsers that support generators.
            // However, SM's generators use the Python-inspired semantics of
            // outdated ES6 drafts.  We would like to support ES6, but we'd also
            // like to make it possible to use generators in deployed browsers, so
            // we also support Python-style generators.  At some point we can remove
            // this block.

            if (typeof StopIteration === "undefined") {
                // ES6 Generators
                try {
                    result = generator[verb](arg);
                } catch (exception) {
                    return reject(exception);
                }
                if (result.done) {
                    return Q(result.value);
                } else {
                    return when(result.value, callback, errback);
                }
            } else {
                // SpiderMonkey Generators
                // FIXME: Remove this case when SM does ES6 generators.
                try {
                    result = generator[verb](arg);
                } catch (exception) {
                    if (isStopIteration(exception)) {
                        return Q(exception.value);
                    } else {
                        return reject(exception);
                    }
                }
                return when(result, callback, errback);
            }
        }
        var generator = makeGenerator.apply(this, arguments);
        var callback = continuer.bind(continuer, "next");
        var errback = continuer.bind(continuer, "throw");
        return callback();
    };
}

/**
 * The spawn function is a small wrapper around async that immediately
 * calls the generator and also ends the promise chain, so that any
 * unhandled errors are thrown instead of forwarded to the error
 * handler. This is useful because it's extremely common to run
 * generators at the top-level to work with libraries.
 */
Q.spawn = spawn;
function spawn(makeGenerator) {
    Q.done(Q.async(makeGenerator)());
}

// FIXME: Remove this interface once ES6 generators are in SpiderMonkey.
/**
 * Throws a ReturnValue exception to stop an asynchronous generator.
 *
 * This interface is a stop-gap measure to support generator return
 * values in older Firefox/SpiderMonkey.  In browsers that support ES6
 * generators like Chromium 29, just use "return" in your generator
 * functions.
 *
 * @param value the return value for the surrounding generator
 * @throws ReturnValue exception with the value.
 * @example
 * // ES6 style
 * Q.async(function* () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      return foo + bar;
 * })
 * // Older SpiderMonkey style
 * Q.async(function () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      Q.return(foo + bar);
 * })
 */
Q["return"] = _return;
function _return(value) {
    throw new QReturnValue(value);
}

/**
 * The promised function decorator ensures that any promise arguments
 * are settled and passed as values (`this` is also settled and passed
 * as a value).  It will also ensure that the result of a function is
 * always a promise.
 *
 * @example
 * var add = Q.promised(function (a, b) {
 *     return a + b;
 * });
 * add(Q(a), Q(B));
 *
 * @param {function} callback The function to decorate
 * @returns {function} a function that has been decorated.
 */
Q.promised = promised;
function promised(callback) {
    return function () {
        return spread([this, all(arguments)], function (self, args) {
            return callback.apply(self, args);
        });
    };
}

/**
 * sends a message to a value in a future turn
 * @param object* the recipient
 * @param op the name of the message operation, e.g., "when",
 * @param args further arguments to be forwarded to the operation
 * @returns result {Promise} a promise for the result of the operation
 */
Q.dispatch = dispatch;
function dispatch(object, op, args) {
    return Q(object).dispatch(op, args);
}

Promise.prototype.dispatch = function (op, args) {
    var self = this;
    var deferred = defer();
    Q.nextTick(function () {
        self.promiseDispatch(deferred.resolve, op, args);
    });
    return deferred.promise;
};

/**
 * Gets the value of a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to get
 * @return promise for the property value
 */
Q.get = function (object, key) {
    return Q(object).dispatch("get", [key]);
};

Promise.prototype.get = function (key) {
    return this.dispatch("get", [key]);
};

/**
 * Sets the value of a property in a future turn.
 * @param object    promise or immediate reference for object object
 * @param name      name of property to set
 * @param value     new value of property
 * @return promise for the return value
 */
Q.set = function (object, key, value) {
    return Q(object).dispatch("set", [key, value]);
};

Promise.prototype.set = function (key, value) {
    return this.dispatch("set", [key, value]);
};

/**
 * Deletes a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to delete
 * @return promise for the return value
 */
Q.del = // XXX legacy
Q["delete"] = function (object, key) {
    return Q(object).dispatch("delete", [key]);
};

Promise.prototype.del = // XXX legacy
Promise.prototype["delete"] = function (key) {
    return this.dispatch("delete", [key]);
};

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param value     a value to post, typically an array of
 *                  invocation arguments for promises that
 *                  are ultimately backed with `resolve` values,
 *                  as opposed to those backed with URLs
 *                  wherein the posted value can be any
 *                  JSON serializable object.
 * @return promise for the return value
 */
// bound locally because it is used by other methods
Q.mapply = // XXX As proposed by "Redsandro"
Q.post = function (object, name, args) {
    return Q(object).dispatch("post", [name, args]);
};

Promise.prototype.mapply = // XXX As proposed by "Redsandro"
Promise.prototype.post = function (name, args) {
    return this.dispatch("post", [name, args]);
};

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param ...args   array of invocation arguments
 * @return promise for the return value
 */
Q.send = // XXX Mark Miller's proposed parlance
Q.mcall = // XXX As proposed by "Redsandro"
Q.invoke = function (object, name /*...args*/) {
    return Q(object).dispatch("post", [name, array_slice(arguments, 2)]);
};

Promise.prototype.send = // XXX Mark Miller's proposed parlance
Promise.prototype.mcall = // XXX As proposed by "Redsandro"
Promise.prototype.invoke = function (name /*...args*/) {
    return this.dispatch("post", [name, array_slice(arguments, 1)]);
};

/**
 * Applies the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param args      array of application arguments
 */
Q.fapply = function (object, args) {
    return Q(object).dispatch("apply", [void 0, args]);
};

Promise.prototype.fapply = function (args) {
    return this.dispatch("apply", [void 0, args]);
};

/**
 * Calls the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q["try"] =
Q.fcall = function (object /* ...args*/) {
    return Q(object).dispatch("apply", [void 0, array_slice(arguments, 1)]);
};

Promise.prototype.fcall = function (/*...args*/) {
    return this.dispatch("apply", [void 0, array_slice(arguments)]);
};

/**
 * Binds the promised function, transforming return values into a fulfilled
 * promise and thrown errors into a rejected one.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q.fbind = function (object /*...args*/) {
    var promise = Q(object);
    var args = array_slice(arguments, 1);
    return function fbound() {
        return promise.dispatch("apply", [
            this,
            args.concat(array_slice(arguments))
        ]);
    };
};
Promise.prototype.fbind = function (/*...args*/) {
    var promise = this;
    var args = array_slice(arguments);
    return function fbound() {
        return promise.dispatch("apply", [
            this,
            args.concat(array_slice(arguments))
        ]);
    };
};

/**
 * Requests the names of the owned properties of a promised
 * object in a future turn.
 * @param object    promise or immediate reference for target object
 * @return promise for the keys of the eventually settled object
 */
Q.keys = function (object) {
    return Q(object).dispatch("keys", []);
};

Promise.prototype.keys = function () {
    return this.dispatch("keys", []);
};

/**
 * Turns an array of promises into a promise for an array.  If any of
 * the promises gets rejected, the whole array is rejected immediately.
 * @param {Array*} an array (or promise for an array) of values (or
 * promises for values)
 * @returns a promise for an array of the corresponding values
 */
// By Mark Miller
// http://wiki.ecmascript.org/doku.php?id=strawman:concurrency&rev=1308776521#allfulfilled
Q.all = all;
function all(promises) {
    return when(promises, function (promises) {
        var countDown = 0;
        var deferred = defer();
        array_reduce(promises, function (undefined, promise, index) {
            var snapshot;
            if (
                isPromise(promise) &&
                (snapshot = promise.inspect()).state === "fulfilled"
            ) {
                promises[index] = snapshot.value;
            } else {
                ++countDown;
                when(
                    promise,
                    function (value) {
                        promises[index] = value;
                        if (--countDown === 0) {
                            deferred.resolve(promises);
                        }
                    },
                    deferred.reject,
                    function (progress) {
                        deferred.notify({ index: index, value: progress });
                    }
                );
            }
        }, void 0);
        if (countDown === 0) {
            deferred.resolve(promises);
        }
        return deferred.promise;
    });
}

Promise.prototype.all = function () {
    return all(this);
};

/**
 * Waits for all promises to be settled, either fulfilled or
 * rejected.  This is distinct from `all` since that would stop
 * waiting at the first rejection.  The promise returned by
 * `allResolved` will never be rejected.
 * @param promises a promise for an array (or an array) of promises
 * (or values)
 * @return a promise for an array of promises
 */
Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
function allResolved(promises) {
    return when(promises, function (promises) {
        promises = array_map(promises, Q);
        return when(all(array_map(promises, function (promise) {
            return when(promise, noop, noop);
        })), function () {
            return promises;
        });
    });
}

Promise.prototype.allResolved = function () {
    return allResolved(this);
};

/**
 * @see Promise#allSettled
 */
Q.allSettled = allSettled;
function allSettled(promises) {
    return Q(promises).allSettled();
}

/**
 * Turns an array of promises into a promise for an array of their states (as
 * returned by `inspect`) when they have all settled.
 * @param {Array[Any*]} values an array (or promise for an array) of values (or
 * promises for values)
 * @returns {Array[State]} an array of states for the respective values.
 */
Promise.prototype.allSettled = function () {
    return this.then(function (promises) {
        return all(array_map(promises, function (promise) {
            promise = Q(promise);
            function regardless() {
                return promise.inspect();
            }
            return promise.then(regardless, regardless);
        }));
    });
};

/**
 * Captures the failure of a promise, giving an oportunity to recover
 * with a callback.  If the given promise is fulfilled, the returned
 * promise is fulfilled.
 * @param {Any*} promise for something
 * @param {Function} callback to fulfill the returned promise if the
 * given promise is rejected
 * @returns a promise for the return value of the callback
 */
Q.fail = // XXX legacy
Q["catch"] = function (object, rejected) {
    return Q(object).then(void 0, rejected);
};

Promise.prototype.fail = // XXX legacy
Promise.prototype["catch"] = function (rejected) {
    return this.then(void 0, rejected);
};

/**
 * Attaches a listener that can respond to progress notifications from a
 * promise's originating deferred. This listener receives the exact arguments
 * passed to ``deferred.notify``.
 * @param {Any*} promise for something
 * @param {Function} callback to receive any progress notifications
 * @returns the given promise, unchanged
 */
Q.progress = progress;
function progress(object, progressed) {
    return Q(object).then(void 0, void 0, progressed);
}

Promise.prototype.progress = function (progressed) {
    return this.then(void 0, void 0, progressed);
};

/**
 * Provides an opportunity to observe the settling of a promise,
 * regardless of whether the promise is fulfilled or rejected.  Forwards
 * the resolution to the returned promise when the callback is done.
 * The callback can return a promise to defer completion.
 * @param {Any*} promise
 * @param {Function} callback to observe the resolution of the given
 * promise, takes no arguments.
 * @returns a promise for the resolution of the given promise when
 * ``fin`` is done.
 */
Q.fin = // XXX legacy
Q["finally"] = function (object, callback) {
    return Q(object)["finally"](callback);
};

Promise.prototype.fin = // XXX legacy
Promise.prototype["finally"] = function (callback) {
    callback = Q(callback);
    return this.then(function (value) {
        return callback.fcall().then(function () {
            return value;
        });
    }, function (reason) {
        // TODO attempt to recycle the rejection with "this".
        return callback.fcall().then(function () {
            throw reason;
        });
    });
};

/**
 * Terminates a chain of promises, forcing rejections to be
 * thrown as exceptions.
 * @param {Any*} promise at the end of a chain of promises
 * @returns nothing
 */
Q.done = function (object, fulfilled, rejected, progress) {
    return Q(object).done(fulfilled, rejected, progress);
};

Promise.prototype.done = function (fulfilled, rejected, progress) {
    var onUnhandledError = function (error) {
        // forward to a future turn so that ``when``
        // does not catch it and turn it into a rejection.
        Q.nextTick(function () {
            makeStackTraceLong(error, promise);
            if (Q.onerror) {
                Q.onerror(error);
            } else {
                throw error;
            }
        });
    };

    // Avoid unnecessary `nextTick`ing via an unnecessary `when`.
    var promise = fulfilled || rejected || progress ?
        this.then(fulfilled, rejected, progress) :
        this;

    if (typeof process === "object" && process && process.domain) {
        onUnhandledError = process.domain.bind(onUnhandledError);
    }

    promise.then(void 0, onUnhandledError);
};

/**
 * Causes a promise to be rejected if it does not get fulfilled before
 * some milliseconds time out.
 * @param {Any*} promise
 * @param {Number} milliseconds timeout
 * @param {Any*} custom error message or Error object (optional)
 * @returns a promise for the resolution of the given promise if it is
 * fulfilled before the timeout, otherwise rejected.
 */
Q.timeout = function (object, ms, error) {
    return Q(object).timeout(ms, error);
};

Promise.prototype.timeout = function (ms, error) {
    var deferred = defer();
    var timeoutId = setTimeout(function () {
        if (!error || "string" === typeof error) {
            error = new Error(error || "Timed out after " + ms + " ms");
            error.code = "ETIMEDOUT";
        }
        deferred.reject(error);
    }, ms);

    this.then(function (value) {
        clearTimeout(timeoutId);
        deferred.resolve(value);
    }, function (exception) {
        clearTimeout(timeoutId);
        deferred.reject(exception);
    }, deferred.notify);

    return deferred.promise;
};

/**
 * Returns a promise for the given value (or promised value), some
 * milliseconds after it resolved. Passes rejections immediately.
 * @param {Any*} promise
 * @param {Number} milliseconds
 * @returns a promise for the resolution of the given promise after milliseconds
 * time has elapsed since the resolution of the given promise.
 * If the given promise rejects, that is passed immediately.
 */
Q.delay = function (object, timeout) {
    if (timeout === void 0) {
        timeout = object;
        object = void 0;
    }
    return Q(object).delay(timeout);
};

Promise.prototype.delay = function (timeout) {
    return this.then(function (value) {
        var deferred = defer();
        setTimeout(function () {
            deferred.resolve(value);
        }, timeout);
        return deferred.promise;
    });
};

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided as an array, and returns a promise.
 *
 *      Q.nfapply(FS.readFile, [__filename])
 *      .then(function (content) {
 *      })
 *
 */
Q.nfapply = function (callback, args) {
    return Q(callback).nfapply(args);
};

Promise.prototype.nfapply = function (args) {
    var deferred = defer();
    var nodeArgs = array_slice(args);
    nodeArgs.push(deferred.makeNodeResolver());
    this.fapply(nodeArgs).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided individually, and returns a promise.
 * @example
 * Q.nfcall(FS.readFile, __filename)
 * .then(function (content) {
 * })
 *
 */
Q.nfcall = function (callback /*...args*/) {
    var args = array_slice(arguments, 1);
    return Q(callback).nfapply(args);
};

Promise.prototype.nfcall = function (/*...args*/) {
    var nodeArgs = array_slice(arguments);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.fapply(nodeArgs).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Wraps a NodeJS continuation passing function and returns an equivalent
 * version that returns a promise.
 * @example
 * Q.nfbind(FS.readFile, __filename)("utf-8")
 * .then(console.log)
 * .done()
 */
Q.nfbind =
Q.denodeify = function (callback /*...args*/) {
    var baseArgs = array_slice(arguments, 1);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        Q(callback).fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
};

Promise.prototype.nfbind =
Promise.prototype.denodeify = function (/*...args*/) {
    var args = array_slice(arguments);
    args.unshift(this);
    return Q.denodeify.apply(void 0, args);
};

Q.nbind = function (callback, thisp /*...args*/) {
    var baseArgs = array_slice(arguments, 2);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        function bound() {
            return callback.apply(thisp, arguments);
        }
        Q(bound).fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
};

Promise.prototype.nbind = function (/*thisp, ...args*/) {
    var args = array_slice(arguments, 0);
    args.unshift(this);
    return Q.nbind.apply(void 0, args);
};

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback with a given array of arguments, plus a provided callback.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param {Array} args arguments to pass to the method; the callback
 * will be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nmapply = // XXX As proposed by "Redsandro"
Q.npost = function (object, name, args) {
    return Q(object).npost(name, args);
};

Promise.prototype.nmapply = // XXX As proposed by "Redsandro"
Promise.prototype.npost = function (name, args) {
    var nodeArgs = array_slice(args || []);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback, forwarding the given variadic arguments, plus a provided
 * callback argument.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param ...args arguments to pass to the method; the callback will
 * be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nsend = // XXX Based on Mark Miller's proposed "send"
Q.nmcall = // XXX Based on "Redsandro's" proposal
Q.ninvoke = function (object, name /*...args*/) {
    var nodeArgs = array_slice(arguments, 2);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    Q(object).dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

Promise.prototype.nsend = // XXX Based on Mark Miller's proposed "send"
Promise.prototype.nmcall = // XXX Based on "Redsandro's" proposal
Promise.prototype.ninvoke = function (name /*...args*/) {
    var nodeArgs = array_slice(arguments, 1);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

/**
 * If a function would like to support both Node continuation-passing-style and
 * promise-returning-style, it can end its internal promise chain with
 * `nodeify(nodeback)`, forwarding the optional nodeback argument.  If the user
 * elects to use a nodeback, the result will be sent there.  If they do not
 * pass a nodeback, they will receive the result promise.
 * @param object a result (or a promise for a result)
 * @param {Function} nodeback a Node.js-style callback
 * @returns either the promise or nothing
 */
Q.nodeify = nodeify;
function nodeify(object, nodeback) {
    return Q(object).nodeify(nodeback);
}

Promise.prototype.nodeify = function (nodeback) {
    if (nodeback) {
        this.then(function (value) {
            Q.nextTick(function () {
                nodeback(null, value);
            });
        }, function (error) {
            Q.nextTick(function () {
                nodeback(error);
            });
        });
    } else {
        return this;
    }
};

// All code before this point will be filtered from stack traces.
var qEndingLine = captureLine();

return Q;

});

define('luxEventBinding',[
	'lodash-compat',
	'ractive'
], function (_, Ractive) {

	var eventPrefix = 'luxEvents:';

	var reservedEventNames = [
		'change', 'complete', 'reset', 'teardown', 'update',
		'construct', 'config', 'init', 'render', 'unrender',
		'detach', 'insert'
	];

	// LuxEvents uses Ractive's events and exposes it globally as window.luxEvents
	if (typeof window !== 'undefined') {
		window.luxEvents = window.luxEvents || {
				on: function (eventName, handler) {
					Ractive.defaults.on(eventPrefix + eventName, handler);
				},
				listenTo: function (eventName, handler) {
					Ractive.defaults.on(eventPrefix + eventName, handler);
				}
			};
	}

	return {
		bindWidget: function (widget) {
			var instance = widget.instance.ractive;

			var getComponentName = function (component) {
				if (component && component.findComponent()) {
					return component.findComponent().component.name;
				}
			};

			// parents of standalone components are structured differently
			// to parents of widgets
			var getParentData = function (parent) {
				if (parent && parent.findComponent()) {
					return parent.findComponent().get();
				}
				return parent && parent.get();
			};

			instance.on('* *.*', function () {
				// Do not track ractive lifecycle events
				if (!_.contains(reservedEventNames, this.event.name)) {

					var event = this.event,
						component = event.component ? event.component : this,
						parent = component.root;

					var returnResult = {
						event: event,
						el: this.el,
						eventName: event.name,
						componentName: getComponentName(component),
						componentData: component.get(),
						parentName: getComponentName(parent),
						parentData: getParentData(parent),
						widgetName: widget.name
					};

					Ractive.defaults.fire(eventPrefix + widget.name, returnResult);
				}
			});
		}
	};

});

define('luxMessage',[
	'jquery',
	'ractive'
], function (dollarSign, Ractive) {

	// Check we are in a browser and not in a test case
	// This is only required until we remove the jquery triggers existing
	// and move completely to window.postMessage
	if (typeof window === 'undefined') {
		return;
	}

	// Update an existing widget with an updated data model
	// Exampe:
	// window.sendLuxMessage.updateWidget('#widget-7e0209f1-5a39-c06d', {title: 'Peter'});
	var updateWidget = function (selector, dataModel, getParent) {
		var container = typeof selector === 'string' ? document.querySelector(selector) : selector;

		if (!container) {
			return false;
		}

		// getParent allows us to target the top widget container
		if (getParent) {
			container = container.closest('.component-container');
		}

		var ractiveNodeInfo = Ractive.getNodeInfo(container);
		if (ractiveNodeInfo) {
			ractiveNodeInfo.ractive.set(dataModel);
		}

	};

	// Init specific widgets via id.
	// E.g. document trigger('initWidget', '#widget-7e0209f1-5a39-c06d-21bb-4250be039f5c');
	// TODO Confirm the need for this to exist at all.
	// TODO Consider performance of initWidget over entire DOM every time. Measure it.
	var initWidget = function (widgetManager, selector) {
		var container = typeof selector === 'string' ? document.querySelector(selector) : selector;

		return widgetManager.initWidget({
			require: window.luxReq,
			widgetContainer: container
		}).then(function (instance) {
			widgetManager.removeClass(container, 'hide');
			dollarSign(document).trigger('widgetInitialized.lux', {
				element: container,
				ractive: instance
			});
		});
	};

	var initComponent = function (widgetManager, selector) {
		var container = typeof selector === 'string' ? document.querySelector(selector) : selector;

		var params = {
			widgetContainer: container,
			widgetData: {
				id: 'luxComponents',
				viewName: 'luxComponentsStateOneView'
			},
			template: Ractive.parse(container.innerHTML),
			require: window.luxReq
		};

		return widgetManager.initWidget(params).then(function (instance) {
			widgetManager.removeClass(container, 'hide');
			dollarSign(document).trigger('widgetInitialized.lux', {
				element: container,
				ractive: instance
			});
		});
	};

	// Init all unrendered components on the DOM
	var initWidgets = function (widgetManager) {
		return widgetManager.init({
			require: window.luxReq
		}).then(function (results) {
			dollarSign(document).trigger('allWidgetsInitialized.lux', [ results ]);
		});
	};

	var luxMessage = {
		updateWidget: function (selector, dataModel, getParent) {
			var message = {
				lux: {
					event: 'updateWidget',
					data: {
						selector: selector,
						dataModel: dataModel,
						getParent: getParent
					}
				}
			};
			window.postMessage(JSON.stringify(message), window.location);
		},
		initWidget: function (selector) {
			var message = {
				lux: {
					event: 'initWidget',
					data: {
						selector: selector
					}
				}
			};
			window.postMessage(JSON.stringify(message), window.location);
		},
		initComponent: function (selector) {
			var message = {
				lux: {
					event: 'initComponent',
					data: {
						selector: selector
					}
				}
			};
			window.postMessage(JSON.stringify(message), window.location);
		},
		initWidgets: function () {
			var message = {
				lux: {
					event: 'initWidgets',
					data: {}
				}
			};
			window.postMessage(JSON.stringify(message), window.location);
		}
	};

	var passMessage = function (luxMessage, widgetManager) {
		var luxData = luxMessage.data;

		if (luxMessage.event === 'updateWidget') {
			updateWidget(luxData.selector, luxData.dataModel, luxData.getParent);
		}

		if (luxMessage.event === 'initWidget') {
			initWidget(widgetManager, luxData.selector);
		}

		if (luxMessage.event === 'initComponent') {
			initComponent(widgetManager, luxData.selector);
		}

		if (luxMessage.event === 'initWidgets') {
			initWidgets(widgetManager);
		}
	};

	return {
		start: function (widgetManager) {

			// Already started
			if (window.sendLuxMessage) {
				return;
			}

			var sendLuxMessage = function (name, args) {
				var loadReqMsg = function () {
					var sendMessage = function () {
						if (luxMessage && luxMessage[name] &&
							typeof luxMessage[name] === 'function') {
							return luxMessage[name].apply(this, args);
						}
					};
					if (!sendMessage()) {
						dollarSign(document).on('allWidgetsInitialized.lux', sendMessage);
					}
				};

				// FIXME FIXME FIXME FIXME
				// Still investigating why calling this first time causes a requirejs mismatched
				// anonymous define() module error. Doesn't happen the second time
				// Help!
				// http://requirejs.org/docs/errors.html#mismatch
				loadReqMsg();
				loadReqMsg();
			};

			window.sendLuxMessage = window.sendLuxMessage || sendLuxMessage;

			//
			// jQuery alternatives
			// Once we have moved across to luxMessage then we can remove these.
			//

			dollarSign(window).on('updateWidget', function (event, selector, dataModel, getParent) {
				updateWidget(selector, dataModel, getParent);
			});

			dollarSign(document).on('initWidget', function (event, selector) {
				initWidget(widgetManager, selector);
			});

			//
			// Filter window messages and only grab lux related
			//

			window.addEventListener('message', function (event) {
				try {
					var dataJson = JSON.parse(event.data);
					if (dataJson.lux) {
						passMessage(dataJson.lux, widgetManager);
					}
				} catch (e) {
					// Purposely left empty because outside scripts could be posting messages
				}
			}, false);
		}
	};

});

/*global define */
define(
	'widgetManager',[
		'lodash-compat',
		'dispatcher',
		'q',
		'underscoreString',
		'ractive',
		'query',
		'parseJSON',
		'luxEventBinding',
		'luxMessage',
		'globalRactivePartials'
	],
	function (_, dispatcher, Q, str, Ractive, query, parseJSON, luxEventBinding, luxMessage) {

		return {

			paths: {
				base: ''
			},

			MAX_TRIES: 4,

			ATTEMPT_INTERVAL: 1000,

			cssClassWidgetInitialized: 'widget-initialized',

			cssClassWidgetProcessing: 'widget-processing',

			scriptElemSelector: 'script[type="text/widgetData"]',

			init: function (params) {

				var self = this;

				var initWidget = function (widgetContainer) {
					return self.initWidget({
							widgetContainer: widgetContainer,
							require: params.require
						})
						.then(function (results) {
							self.removeClass(widgetContainer, 'hide');
							return results;
						});
				};

				var initComponent = function (widgetContainer) {
					params = {
						widgetContainer: widgetContainer,
						widgetData: {
							id: 'luxComponents',
							viewName: 'luxComponentsStateOneView'
						},
						template: Ractive.parse(widgetContainer.innerHTML),
						require: params.require
					};

					return self.initWidget(params)
						.then(function (results) {

							var instanceNode = results.instance.ractive.el;
							var nestedCompContainers = instanceNode.getElementsByClassName('component-container');

							_.map(nestedCompContainers, function (el) {
								// Component containers are hidden by default to prevent garish displays to user.
								self.removeClass(el, 'hide');
								self.addClass(el, 'widget-initialized');
							});

							self.removeClass(widgetContainer, 'hide');
							return results;
						});
				};

				// where is the best place for this?
				luxMessage.start(self);

				// bypass component containers if widget container is passed.
				var promises = _.map(self.getComponentContainers(), initComponent);

				// WAIT for components to init first, THEN do widgets. Important for rendering pages correctly.
				return Q.allSettled(promises).then(function (result) {
					promises = promises.concat(
						_.map(self.getWidgetContainers(), initWidget)
					);
					return Q.allSettled(promises)
						.then(self.checkForUninitialisedComponents(result));
				});

			},

			checkForUninitialisedComponents: function (results) {

				if (!Ractive.DEBUG) {
					return results;
				}

				_(document.querySelectorAll('*'))
					.filter(function (elem) {
						return /^UX-(\w|-)+/.test(elem.nodeName);
					})
					.map(function (elem) {
						return elem.nodeName;
					})
					.uniq()
					.map(function (component) {
						console.debug('Component not yet initialised:', component);
					});

				return results;

			},

			getWidgetData: function (widgetContainer) {

				var self = this;

				var deferred = Q.defer();

				var scriptElem = widgetContainer.querySelector(self.scriptElemSelector);
				var dataUrl = widgetContainer.getAttribute('data-url');

				if (!scriptElem && widgetContainer.className.indexOf('component-container') === -1 && dataUrl) {

					var hasParams = widgetContainer.getAttribute('pass-params');
					//Append current page's query strings to data-url
					if (hasParams) {
						var operator = dataUrl.indexOf('?') !== -1 ? '&' : '?';
						dataUrl = [dataUrl, operator, window.location.search.substring(1)].join('');
					}

					query(dataUrl, null, true)
						.then(function (data) {
							if (data.responseText) {
								data = JSON.parse(data.responseText);
							}
							deferred.resolve(self.loadWidgetData(null, {
								// We must imply the same structure as page rendering.
								serviceDataList: data
							}));
						}, function () {
							deferred.reject(arguments);
						});

					return deferred.promise;
				}

				if (!scriptElem) {
					self.findScriptElement(widgetContainer).then(self.processWidgetData.bind(self, deferred));
				} else {
					self.processWidgetData(deferred, scriptElem);
				}
				return deferred.promise;

			},

			processWidgetData: function (promise, scriptElem) {

				var self = this;
				var counter = 0;

				var widgetData = self.loadWidgetData(scriptElem);

				if (widgetData) {

					promise.resolve(widgetData);

				} else {

					var interval = setInterval(function () {

						var widgetData = self.loadWidgetData(scriptElem);

						if (widgetData) {

							promise.resolve(widgetData);
							clearInterval(interval);
							return;

						} else {

							// Keep going.
							counter++;

						}

						if (counter >= self.MAX_TRIES) {
							promise.reject(widgetData);
							console.error('Failed loading JSON data from element after max tries.');
							clearInterval(interval);
						}

					}, self.ATTEMPT_INTERVAL);
				}

			},

			findScriptElement: function (widgetContainer) {

				var self = this;
				var counter = 0;
				var deferred = Q.defer();

				var interval = setInterval(function () {

					var scriptElem = widgetContainer.querySelector(self.scriptElemSelector);

					if (scriptElem) {

						deferred.resolve(scriptElem);
						clearInterval(interval);
						return;

					} else {

						// Keep going.
						counter++;

					}

					if (counter >= self.MAX_TRIES) {
						deferred.reject();
						console.error('Failed to find script elem.');
						clearInterval(interval);
					}

				}, self.ATTEMPT_INTERVAL);


				return deferred.promise;

			},

			loadWidgetData: function (scriptElem, widgetData) {

				if (!widgetData && scriptElem) {
					var widgetDataString = str.trim(scriptElem.innerHTML);
					var widgetData = parseJSON(_.unescape(widgetDataString));
				}

				try {

					if (widgetData.serviceDataList) {
						return widgetData.serviceDataList[0] || widgetData.serviceDataList;
					}

					return widgetData;

				} catch (e) {

					console.error('serviceDataList is not found in widgetData', e, widgetData);
					return null;

				}

			},

			getWidgetContainers: function (root) {
				return this.getContainers('.widget-container', root);
			},

			getComponentContainers: function (root) {
				return this.getContainers('.component-container', root);
			},

			/**
			 * Find all uninitialized containers of a given type.
			 */
			getContainers: function (selector, root) {

				var element = root || document,
					self = this;

				var exemptChildComponents = function (container) {

					var removeClasses = function (childComponentContainer) {
						self.removeClass(childComponentContainer, 'component-container');
						self.removeClass(childComponentContainer, 'hide');
					};

					var containers = container.querySelectorAll('.component-container');

					_.map(containers, removeClasses);

					return container;
				};

				var notInitialized = function (container) {
					return !_.includes(container.className, self.cssClassWidgetInitialized) &&
						!_.includes(container.className, self.cssClassWidgetProcessing);
				};

				var markInProgress = function (container) {
					return self.addClass(container, self.cssClassWidgetProcessing);
				};

				var hasComponentContainer = function (container) {
					return _.includes(container.className, 'component-container') ||
						_.includes(container.className, 'widget-container');
				};

				return _(element.querySelectorAll(selector))
				// Filter those that arent initalised yet
					.filter(notInitialized)
					// Remove all child components
					.map(exemptChildComponents)
					// Filter if is component or widget container
					.filter(hasComponentContainer)
					// Mark them as in progress
					.map(markInProgress)
					.value();

			},

			initWidgetWithDataURL: function (widgetContainer, widgetDataURL) {

				var self = this;

				// TODO replace with new xhr client. Superagent?
				$.getJSON(widgetDataURL)
					.done(function (result) {
						self.initWidget({
							widgetContainer: widgetContainer,
							widgetData: result
						});
					})
					.fail(function () {
						throw new Error('Failed to load data for widget');
					});

			},

			/**
			 * If params.widgetContainer is NOT passed, function assumes server render.
			 */
			initWidget: function (params) {

				var self = this,
					widgetContainer = params.widgetContainer,
					widgetData = params.widgetData,
					template = params.template,
					require = params.require,
					promise,
					widgetInstanceDeferred = Q.defer();



				// Either use the passed widgetData (from initWidgetWithDataURL), or call getWidgetData().
				if (_.isEmpty(widgetData)) {
					widgetContainer = self.addClass(widgetContainer, this.cssClassWidgetProcessing);
					promise = self.getWidgetData(widgetContainer);
				} else {
					// Simulate a promise to allow below code to be generic.
					var deferred = Q.defer();
					deferred.resolve(widgetData);
					promise = deferred.promise;
				}

				promise.fail(function () {
					widgetInstanceDeferred.reject('Incorrect structure for widgetData.');
				});

				// Wait for async data load, to get around IE JSON size issues and failing to parse JSON.
				promise.done(function (widgetData) {

					if (!widgetData || !widgetData.id) {
						widgetInstanceDeferred.reject('Incorrect structure for widgetData.');
						return;
					}

					if (widgetContainer) {
						// For dynamic rendering, if widget container doesn't contain a .widget-instance div
						if (!widgetContainer.querySelectorAll('.widget-instance').length) {
							widgetContainer = self.addClass(widgetContainer, widgetData.id + 'Widget');
							var instanceDiv = document.createElement('div');
							instanceDiv.className = 'widget-instance';
							widgetContainer.appendChild(instanceDiv);
						}
					}

					// Use passed require function which has context assigned.
					require([
						widgetData.id + 'Bundle',
						'RactiveF'
					], function (widgetBundle) {

						// Below require block will not cause an additional HTTP request
						// as the widgetData.id has been silently declared as part of widgetBundle
						// More info on widget bundles: https://wiki.express.optus.com.au/x/LoMjB

						require([widgetData.id], self.setupWidget.bind(
							self,
							widgetInstanceDeferred,
							widgetBundle,
							widgetContainer,
							template,
							widgetData
						), function (err) {

							// If there is a require error in this block, just throw a warning.
							// e.g. widget fails to load shouldn't throw an error.
							console.warn(err);

							var failedId = err.requireModules && err.requireModules[0];
							if (failedId === widgetData.id) {
								requirejs.undef(failedId);

								_.defer(function () {
									// Try again.
									// Note: that the above require callback with the "setupWidget"
									// will be called if this new attempt to load succeeds.
									// @ref http://requirejs.org/docs/api.html#errbacks
									require([failedId], function () {});
								});
							} else {
								console.warn(err);
							}


						});

					}, function (err) {
						// If there is a require error in this block, just throw a warning.
						// e.g. widget fails to load shouldn't throw an error.
						console.warn(err);
					});

				});

				return widgetInstanceDeferred.promise;

			},


			setupWidget: function (deferred, bundle, widgetContainer, template, widgetData, widget) {

				var self = this;

				if (typeof window === 'undefined') {
					GLOBAL.window = {};
				}


				window.RedmarineTemplates = window.RedmarineTemplates || {};
				_.extend(window.RedmarineTemplates, bundle.templates);

				// Construct our widget object
				var RactiveWidget = {
					name: bundle.name,
					id: widgetContainer && widgetContainer.id || widgetData && widgetData.id,
					instance: widget.initRactiveWidget({
						el: widgetContainer && widgetContainer.querySelectorAll('.widget-instance'),
						data: widgetData,
						template: template || function () {
							var newTemplate = window.RedmarineTemplates[this.get('viewName')];
							if (!newTemplate) {
								console.error('Data: ', this.get());
								throw new Error('Could not find the requested template.');
							}
							return newTemplate;
						}
					})
				};

				// Bind our widget to the dispatcher
				dispatcher.bindWidget(RactiveWidget);

				window.dispatcher = dispatcher;
				window.RactiveWidgets = window.RactiveWidgets || [];
				window.RactiveWidgets.push(RactiveWidget);

				luxEventBinding.bindWidget(RactiveWidget);

				if (widgetContainer) {
					widgetContainer = self.addClass(widgetContainer, self.cssClassWidgetInitialized);
					widgetContainer = self.addClass(widgetContainer, widgetData.id + 'Widget');

					// Remove processing class.
					widgetContainer = self.removeClass(widgetContainer, self.cssClassWidgetProcessing);
				}

				if (widgetContainer) {
					RactiveWidget.instance.ractive.on('complete', function () {
						deferred.resolve(RactiveWidget);
					});
				} else {
					// TODO Confirm this is for server-side rendered html?
					deferred.resolve(RactiveWidget);
				}

			},

			removeClass: function (element, className) {
				// Remove processing flag.
				var regexp = new RegExp('\\b(' + className + ')\\b', 'g');
				element.className =
					_.trim(element.className.replace(regexp, ''));
				return element;
			},

			addClass: function (element, className) {
				var regexp = new RegExp('\\b(' + className + ')\\b', 'g');

				if (!element.className) {
					element.className = className;
					return element;
				}

				if (element.className.search(regexp) === -1) {
					element.className += ' ' + className;
				}

				return element;
			}

		};
	});

define('AbandonCart',['lodash-compat', 'RactiveHelpers', 'ractive'], function (_, RactiveHelpers, Ractive) {
	var AbandonCart = function () {
		this.sessionStorageKey =
		'businesswidget/repository_l9_common/common/viewmodel/contextTopics/AbondonCartTopic';
		this.flowTypeKey = 'txn';
		this.indicatorKey = 'indicator';
		this.cartItemKey = 'cartItems';
		this.isJsonDataPrepared = false;
	};
	AbandonCart.prototype = {
		initialize : function () {
			this.abandonCartJsonObj = {
				'abandonedCart' : {
					custContactId : '',
					customerSubscriberId : '',
					custType : '',
					orderId : '',
					cartItems : [{
						lob : '',
						txn : '',
						productName : '',
						billingOfferId : '',
						device : [{
							model : '',
							brand : '',
							deviceSKU : '',
							upfrontAmount : ''
						}]
					}],
					indicator : 'Open'
				}
			};
		},

		persistData : function (jsonData) {
			return this._storeJsonToSessionStorage(jsonData, this.sessionStorageKey);
		},

		_storeJsonToSessionStorage : function (jsonData, key) {
			if (sessionStorage.getItem(key) === null) {
				sessionStorage.setItem(key, JSON.stringify(jsonData));
			} else {
				sessionStorage[key] = JSON.stringify(jsonData);
			}
		},

		removeAbandonCartJsonFromSessionStorage: function () {
			var self = this;
			if (sessionStorage.getItem(this.sessionStorageKey) !== null) {
				sessionStorage.removeItem(this.sessionStorageKey);
				self.abandonCartJsonObj = null;
				self.isJsonDataPrepared = false;
			}
		},

		getAbondonCartObjectFromSession : function () {
			return this.__getJsonFromSession();
		},

		getAbondonCartObject : function () {
			var self = this;
			return self.abandonCartJsonObj;
		},

		_getJsonFromSession : function () {
			if (sessionStorage.getItem(this.sessionStorageKey) !== null) {
				return sessionStorage.getItem()(this.sessionStorageKey);
			}
		},

		setJsonKeyValuePair : function (Key, value) {
			var self = this;
			var updatedAbandonCartJsonObj = self.abandonCartJsonObj;
			updatedAbandonCartJsonObj.abandonedCart[Key] = value;
			this.persistData(updatedAbandonCartJsonObj);
			return updatedAbandonCartJsonObj;
		},

		getParameterValueByKey : function (key) {
			var self = this;
			var abandonCartJsonObj = self.abandonCartJsonObj;
			return abandonCartJsonObj[key];
		},

		removeExistingKeyfromAbandonCartJson : function (key) {
			var self =  this;
			var updatedAbandonCartJsonObj = self.abandonCartJsonData;
			if (updatedAbandonCartJsonObj[key] !== null) {
				delete updatedAbandonCartJsonObj[key];
			}
			this.persistData(updatedAbandonCartJsonObj);
			return updatedAbandonCartJsonObj;
		},

		setDeviceItems : function (devices, fetchedDevice) {
			var deviceData = [];
			_.each(devices, function (device) {
				var deviceObj = {
					'model' : device.modelName,
					'brand' : device.brandName,
					'deviceSKU' : device.skuId,
					'upfrontAmount' :
					(device.checkoutPrice.finalAmountIncludingTax !== null ||
						device.checkoutPrice.finalAmountIncludingTax !== 'undefined') ?
					RactiveHelpers.convertUnits(device.checkoutPrice.finalAmountIncludingTax, 'dollar', true) : null
				};
				if (fetchedDevice) {
					deviceObj.deviceDisplayName = fetchedDevice.groupId;
					deviceObj.deviceCapacity = fetchedDevice.size;
					deviceObj.deviceColor = fetchedDevice.color;
					deviceObj.deviceImagePath = fetchedDevice.images[0];
				}
				deviceData = deviceData.concat(deviceObj);
			});
			return deviceData;
		},

		setFlowType : function (flowTypeVal) {
			var self = this;
			var jsonObj  =  self.abandonCartJsonObj;
			var cartItemList = jsonObj[this.cartItemKey];
			_.each(cartItemList, function (item) {
				item[this.flowTypeKey] = flowTypeVal;
			});
			jsonObj[this.cartItemKey] = cartItemList;
			this.persistData(jsonObj);
			return jsonObj;
		},

		setCartItems : function (cartData, devices, that) {
			var cartItems = [];
			var self = that;
			_.each(cartData.order.mobile, function (cartItem) {
				var deviceDetails = self.setDeviceItems(cartItem.deviceDetails, devices);
				var planList = cartItem.planDetails;
				_.each(planList, function (plan) {
					var planRecurringCharges = '';
					if (plan && plan.recurringPrice && plan.recurringPrice.finalAmountIncludingTax) {
						planRecurringCharges = plan.recurringPrice.finalAmountIncludingTax;
					}
					var cartObj = {
						'lob' : (cartItem.lob && cartItem.lob === 'mobile') ? 'Mobile' : null,
						'txn' : self.getFlowType(cartData),
						'productName' : plan.planName,
						'billingOfferId' : cartItem.productOfferingID ? cartItem.productOfferingID : '',
						'device' : deviceDetails,
						'planMonthlyCharge' : RactiveHelpers.convertUnits(planRecurringCharges, 'dollar', true)
					};
					cartItems.push(cartObj);
				});
			});
			return cartItems;
		},

		getFlowType : function (orderData) {
			var flowType = null;
			_.each(orderData.order.mobile, function (mobileItem) {
				if (mobileItem.isRecon) {
					flowType = 'RECON';
				} else if (mobileItem.isPortin) {
					flowType = 'PORTIN';
				} else if (mobileItem.productOrderItemType && mobileItem.productOrderItemType === 'Provide') {
					flowType = 'GA';
				}
			});
			return flowType;
		},

		updateIndicatorValue : function (val) {
			this.setJsonKeyValuePair(this.indicatorKey, val);
		},

		sendJsonToMarktingCloud : function (abandonCartJsonObj) {
			var abandonCartJsonData = abandonCartJsonObj;
			try {
				this.persistData(abandonCartJsonData);
				Ractive.defaults.fire('luxEvents:marketingCloudDataUpdates', abandonCartJsonData);
			} catch (e) {
				console.error(e);
			}
			//var url = 'https://dc.oracleinfinity.io/v3/abc1234567?dcsverbose=true';
			//return RactiveHelpers.doAjaxJSONCallWithSimulator('POST', url, null, null, abandonCartJsonData);
		},

		prepareAbandonCartJsonObj : function (orderData, devices) {
			var self = this;
			var topic =
			'businesswidget/repository_l9_common/common/viewmodel/contextTopics/ImplUserContextTopicViewModel';
			var sessionObject = sessionStorage.getItem(topic) && JSON.parse(sessionStorage.getItem(topic));
			var abandonCartJsonObj = {
				'abandonedCart': {
					'custContactId' : sessionObject && sessionObject.userInfo && sessionObject.userInfo.contact ?
					sessionObject.userInfo.contact.contactId : null,
					'customerSubscriberId' : this.getCustomerSubscriberId(),
					'custType' : this.getCustomerType(),
					'orderId' : orderData.order.id,
					'cartItems' : this.setCartItems(orderData, devices, this),
					'indicator' : orderData.order.status &&
					orderData.order.status === 'OPEN' ? 'Open' : null
				}
			};
			self.abandonCartJsonObj = abandonCartJsonObj;
			this.isJsonDataPrepared = true;
			return abandonCartJsonObj;
		},

		isMarketingCloudEnabled : function (orderData) {
			var self = this;
			var marketingCloudEnabledFlag =  false;
			if (orderData) {
				_.each(orderData.order.mobile, function (mobileItem) {
					if ((mobileItem.isRecon || mobileItem.productOrderItemType === 'Provide') &&
					mobileItem.lob === 'mobile' && self.isUserDataPresent()) {
						marketingCloudEnabledFlag = true;
					}
				});
			}
			return marketingCloudEnabledFlag;
		},

		isJsonDataReady :  function () {
			return this.isJsonDataPrepared;
		},

		isUserDataPresent : function () {
			var userDataPresnt = false;
			var topic =
			'businesswidget/repository_l9_common/common/viewmodel/contextTopics/ImplUserContextTopicViewModel';
			var sessionObject = sessionStorage.getItem(topic) && JSON.parse(sessionStorage.getItem(topic));
			if (sessionObject !== null) {
				userDataPresnt = true;
			}
			return userDataPresnt;
		},

		getCustomerSubscriberId : function () {
			var topic =
			'businesswidget/repository_l9_common/common/viewmodel/contextTopics/ImplUserContextTopicViewModel';
			var miniCartTopic =
			'businesswidget/repository_l9_common/common/viewmodel/contextTopics/MiniCartInContextTopic';
			var sessionObject = sessionStorage.getItem(topic) && JSON.parse(sessionStorage.getItem(topic));
			var miniCartSessionObject = sessionStorage.getItem(miniCartTopic) &&
			JSON.parse(sessionStorage.getItem(miniCartTopic));
			var customerSubscriberId;
			if (sessionObject && sessionObject.userInfo && sessionObject.userInfo.contactSubscriptionDetails &&
				sessionObject.userInfo.contactSubscriptionDetails.length > 0) {
				var subscriptionDetails = sessionObject.userInfo.contactSubscriptionDetails;
				if (miniCartSessionObject && miniCartSessionObject.flowData &&
					miniCartSessionObject.flowData.selectedNumber) {
					_.each(subscriptionDetails, function (subItem) {
						if (subItem.primaryResource === miniCartSessionObject.flowData.selectedNumber) {
							customerSubscriberId = subItem.subscriberId;
						}
					});
				}
			}
			return customerSubscriberId || null;
		},

		getCustomerType : function () {
			var topic =
			'businesswidget/repository_l9_common/common/viewmodel/contextTopics/DeviceIdAndPlanIdInContextTopic';
			var sessionObject = sessionStorage.getItem(topic) && JSON.parse(sessionStorage.getItem(topic));
			var customerType =  null;
			if (sessionObject) {
				var sessionCustomerType  =  sessionObject.customerType;
				if (sessionCustomerType && sessionCustomerType === 'cis') {
					customerType = 'CIS';
				} else if (sessionCustomerType && sessionCustomerType === 'staff') {
					customerType = 'STAFF';
				} else {
					customerType = 'RES';
				}
			}
			return customerType;
		}
	};
	return AbandonCart;
});

define('luxComponentsBundle',['luxComponentsBundle'], function () { return {
name: 'luxComponents',
templates: {
	luxComponentsStateOneView: {"v":3,"t":[]}
},
widget: define('luxComponents', [
	'BaseWidget'
], function (BaseWidget) {

	var Widget = function (options) {
		var self = this;

		self.ractive = new BaseWidget(options);

	};

	Widget.prototype = {};

	return {
		initRactiveWidget: function (options) {
			return new Widget(options);
		}
	};

})
}});
// These are the entry-point deps which will be included in the lux js bundle.
// These deps may require other files.
// See the gulpfile for their config.
define([
	'requirejs',
	'jquery',
	'ractive',
	'globalRactivePartials',
	'ConfigStrings',
	'RactiveHelpers',
	'CommonHelpers',
	'RactiveF',
	'BaseWidget',
	'widgetManager',
	'ProductFacade',
	'AbandonCart',
	'luxComponentsBundle'
]);

